import * as Er from "react";
import nc, { createContext as W3, useState as gk, useRef as Jn, useMemo as Sh, useCallback as Ki, useLayoutEffect as U3, useEffect as xm, memo as Wte, useContext as G3, createElement as Ute, useDebugValue as Gte, forwardRef as Kte, useImperativeHandle as jte } from "react";
var eVe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Yte(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var cT = { exports: {} }, uy = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qH;
function qte() {
  if (qH)
    return uy;
  qH = 1;
  var t = nc, e = Symbol.for("react.element"), i = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, n = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(u, c, p) {
    var v, _ = {}, y = null, b = null;
    p !== void 0 && (y = "" + p), c.key !== void 0 && (y = "" + c.key), c.ref !== void 0 && (b = c.ref);
    for (v in c)
      r.call(c, v) && !a.hasOwnProperty(v) && (_[v] = c[v]);
    if (u && u.defaultProps)
      for (v in c = u.defaultProps, c)
        _[v] === void 0 && (_[v] = c[v]);
    return { $$typeof: e, type: u, key: y, ref: b, props: _, _owner: n.current };
  }
  return uy.Fragment = i, uy.jsx = o, uy.jsxs = o, uy;
}
var dy = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var XH;
function Xte() {
  return XH || (XH = 1, process.env.NODE_ENV !== "production" && function() {
    "use strict";
    var t = nc, e = Symbol.for("react.element"), i = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), _ = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), I = Symbol.iterator, A = "@@iterator";
    function L(G) {
      if (G === null || typeof G != "object")
        return null;
      var ke = I && G[I] || G[A];
      return typeof ke == "function" ? ke : null;
    }
    var B = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(G) {
      {
        for (var ke = arguments.length, U = new Array(ke > 1 ? ke - 1 : 0), ye = 1; ye < ke; ye++)
          U[ye - 1] = arguments[ye];
        K("error", G, U);
      }
    }
    function K(G, ke, U) {
      {
        var ye = B.ReactDebugCurrentFrame, Fe = ye.getStackAddendum();
        Fe !== "" && (ke += "%s", U = U.concat([Fe]));
        var Ue = U.map(function(Ze) {
          return String(Ze);
        });
        Ue.unshift("Warning: " + ke), Function.prototype.apply.call(console[G], console, Ue);
      }
    }
    var te = !1, z = !1, ie = !1, pe = !1, _e = !1, be;
    be = Symbol.for("react.module.reference");
    function De(G) {
      return !!(typeof G == "string" || typeof G == "function" || G === r || G === a || _e || G === n || G === p || G === v || pe || G === b || te || z || ie || typeof G == "object" && G !== null && (G.$$typeof === y || G.$$typeof === _ || G.$$typeof === o || G.$$typeof === u || G.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      G.$$typeof === be || G.getModuleId !== void 0));
    }
    function Ce(G, ke, U) {
      var ye = G.displayName;
      if (ye)
        return ye;
      var Fe = ke.displayName || ke.name || "";
      return Fe !== "" ? U + "(" + Fe + ")" : U;
    }
    function ft(G) {
      return G.displayName || "Context";
    }
    function Ve(G) {
      if (G == null)
        return null;
      if (typeof G.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof G == "function")
        return G.displayName || G.name || null;
      if (typeof G == "string")
        return G;
      switch (G) {
        case r:
          return "Fragment";
        case i:
          return "Portal";
        case a:
          return "Profiler";
        case n:
          return "StrictMode";
        case p:
          return "Suspense";
        case v:
          return "SuspenseList";
      }
      if (typeof G == "object")
        switch (G.$$typeof) {
          case u:
            var ke = G;
            return ft(ke) + ".Consumer";
          case o:
            var U = G;
            return ft(U._context) + ".Provider";
          case c:
            return Ce(G, G.render, "ForwardRef");
          case _:
            var ye = G.displayName || null;
            return ye !== null ? ye : Ve(G.type) || "Memo";
          case y: {
            var Fe = G, Ue = Fe._payload, Ze = Fe._init;
            try {
              return Ve(Ze(Ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Ee = Object.assign, Re = 0, we, We, ne, Ae, j, ge, Me;
    function ze() {
    }
    ze.__reactDisabledLog = !0;
    function je() {
      {
        if (Re === 0) {
          we = console.log, We = console.info, ne = console.warn, Ae = console.error, j = console.group, ge = console.groupCollapsed, Me = console.groupEnd;
          var G = {
            configurable: !0,
            enumerable: !0,
            value: ze,
            writable: !0
          };
          Object.defineProperties(console, {
            info: G,
            log: G,
            warn: G,
            error: G,
            group: G,
            groupCollapsed: G,
            groupEnd: G
          });
        }
        Re++;
      }
    }
    function vt() {
      {
        if (Re--, Re === 0) {
          var G = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Ee({}, G, {
              value: we
            }),
            info: Ee({}, G, {
              value: We
            }),
            warn: Ee({}, G, {
              value: ne
            }),
            error: Ee({}, G, {
              value: Ae
            }),
            group: Ee({}, G, {
              value: j
            }),
            groupCollapsed: Ee({}, G, {
              value: ge
            }),
            groupEnd: Ee({}, G, {
              value: Me
            })
          });
        }
        Re < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Je = B.ReactCurrentDispatcher, _t;
    function at(G, ke, U) {
      {
        if (_t === void 0)
          try {
            throw Error();
          } catch (Fe) {
            var ye = Fe.stack.trim().match(/\n( *(at )?)/);
            _t = ye && ye[1] || "";
          }
        return `
` + _t + G;
      }
    }
    var yt = !1, tt;
    {
      var zt = typeof WeakMap == "function" ? WeakMap : Map;
      tt = new zt();
    }
    function Ie(G, ke) {
      if (!G || yt)
        return "";
      {
        var U = tt.get(G);
        if (U !== void 0)
          return U;
      }
      var ye;
      yt = !0;
      var Fe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ue;
      Ue = Je.current, Je.current = null, je();
      try {
        if (ke) {
          var Ze = function() {
            throw Error();
          };
          if (Object.defineProperty(Ze.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ze, []);
            } catch (hi) {
              ye = hi;
            }
            Reflect.construct(G, [], Ze);
          } else {
            try {
              Ze.call();
            } catch (hi) {
              ye = hi;
            }
            G.call(Ze.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (hi) {
            ye = hi;
          }
          G();
        }
      } catch (hi) {
        if (hi && ye && typeof hi.stack == "string") {
          for (var Xe = hi.stack.split(`
`), Nt = ye.stack.split(`
`), kt = Xe.length - 1, ci = Nt.length - 1; kt >= 1 && ci >= 0 && Xe[kt] !== Nt[ci]; )
            ci--;
          for (; kt >= 1 && ci >= 0; kt--, ci--)
            if (Xe[kt] !== Nt[ci]) {
              if (kt !== 1 || ci !== 1)
                do
                  if (kt--, ci--, ci < 0 || Xe[kt] !== Nt[ci]) {
                    var pr = `
` + Xe[kt].replace(" at new ", " at ");
                    return G.displayName && pr.includes("<anonymous>") && (pr = pr.replace("<anonymous>", G.displayName)), typeof G == "function" && tt.set(G, pr), pr;
                  }
                while (kt >= 1 && ci >= 0);
              break;
            }
        }
      } finally {
        yt = !1, Je.current = Ue, vt(), Error.prepareStackTrace = Fe;
      }
      var xa = G ? G.displayName || G.name : "", Cs = xa ? at(xa) : "";
      return typeof G == "function" && tt.set(G, Cs), Cs;
    }
    function gt(G, ke, U) {
      return Ie(G, !1);
    }
    function si(G) {
      var ke = G.prototype;
      return !!(ke && ke.isReactComponent);
    }
    function Wt(G, ke, U) {
      if (G == null)
        return "";
      if (typeof G == "function")
        return Ie(G, si(G));
      if (typeof G == "string")
        return at(G);
      switch (G) {
        case p:
          return at("Suspense");
        case v:
          return at("SuspenseList");
      }
      if (typeof G == "object")
        switch (G.$$typeof) {
          case c:
            return gt(G.render);
          case _:
            return Wt(G.type, ke, U);
          case y: {
            var ye = G, Fe = ye._payload, Ue = ye._init;
            try {
              return Wt(Ue(Fe), ke, U);
            } catch {
            }
          }
        }
      return "";
    }
    var ki = Object.prototype.hasOwnProperty, lr = {}, mi = B.ReactDebugCurrentFrame;
    function Wi(G) {
      if (G) {
        var ke = G._owner, U = Wt(G.type, G._source, ke ? ke.type : null);
        mi.setExtraStackFrame(U);
      } else
        mi.setExtraStackFrame(null);
    }
    function Rr(G, ke, U, ye, Fe) {
      {
        var Ue = Function.call.bind(ki);
        for (var Ze in G)
          if (Ue(G, Ze)) {
            var Xe = void 0;
            try {
              if (typeof G[Ze] != "function") {
                var Nt = Error((ye || "React class") + ": " + U + " type `" + Ze + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof G[Ze] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Nt.name = "Invariant Violation", Nt;
              }
              Xe = G[Ze](ke, Ze, ye, U, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (kt) {
              Xe = kt;
            }
            Xe && !(Xe instanceof Error) && (Wi(Fe), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ye || "React class", U, Ze, typeof Xe), Wi(null)), Xe instanceof Error && !(Xe.message in lr) && (lr[Xe.message] = !0, Wi(Fe), $("Failed %s type: %s", U, Xe.message), Wi(null));
          }
      }
    }
    var ia = Array.isArray;
    function ra(G) {
      return ia(G);
    }
    function zn(G) {
      {
        var ke = typeof Symbol == "function" && Symbol.toStringTag, U = ke && G[Symbol.toStringTag] || G.constructor.name || "Object";
        return U;
      }
    }
    function Yi(G) {
      try {
        return tr(G), !1;
      } catch {
        return !0;
      }
    }
    function tr(G) {
      return "" + G;
    }
    function cn(G) {
      if (Yi(G))
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", zn(G)), tr(G);
    }
    var hr = B.ReactCurrentOwner, Wr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Go, Wa, Ca;
    Ca = {};
    function nt(G) {
      if (ki.call(G, "ref")) {
        var ke = Object.getOwnPropertyDescriptor(G, "ref").get;
        if (ke && ke.isReactWarning)
          return !1;
      }
      return G.ref !== void 0;
    }
    function Rt(G) {
      if (ki.call(G, "key")) {
        var ke = Object.getOwnPropertyDescriptor(G, "key").get;
        if (ke && ke.isReactWarning)
          return !1;
      }
      return G.key !== void 0;
    }
    function ii(G, ke) {
      if (typeof G.ref == "string" && hr.current && ke && hr.current.stateNode !== ke) {
        var U = Ve(hr.current.type);
        Ca[U] || ($('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Ve(hr.current.type), G.ref), Ca[U] = !0);
      }
    }
    function Pi(G, ke) {
      {
        var U = function() {
          Go || (Go = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ke));
        };
        U.isReactWarning = !0, Object.defineProperty(G, "key", {
          get: U,
          configurable: !0
        });
      }
    }
    function Ui(G, ke) {
      {
        var U = function() {
          Wa || (Wa = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ke));
        };
        U.isReactWarning = !0, Object.defineProperty(G, "ref", {
          get: U,
          configurable: !0
        });
      }
    }
    var Br = function(G, ke, U, ye, Fe, Ue, Ze) {
      var Xe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: G,
        key: ke,
        ref: U,
        props: Ze,
        // Record the component responsible for creating this element.
        _owner: Ue
      };
      return Xe._store = {}, Object.defineProperty(Xe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Xe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ye
      }), Object.defineProperty(Xe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Fe
      }), Object.freeze && (Object.freeze(Xe.props), Object.freeze(Xe)), Xe;
    };
    function fr(G, ke, U, ye, Fe) {
      {
        var Ue, Ze = {}, Xe = null, Nt = null;
        U !== void 0 && (cn(U), Xe = "" + U), Rt(ke) && (cn(ke.key), Xe = "" + ke.key), nt(ke) && (Nt = ke.ref, ii(ke, Fe));
        for (Ue in ke)
          ki.call(ke, Ue) && !Wr.hasOwnProperty(Ue) && (Ze[Ue] = ke[Ue]);
        if (G && G.defaultProps) {
          var kt = G.defaultProps;
          for (Ue in kt)
            Ze[Ue] === void 0 && (Ze[Ue] = kt[Ue]);
        }
        if (Xe || Nt) {
          var ci = typeof G == "function" ? G.displayName || G.name || "Unknown" : G;
          Xe && Pi(Ze, ci), Nt && Ui(Ze, ci);
        }
        return Br(G, Xe, Nt, Fe, ye, hr.current, Ze);
      }
    }
    var Lr = B.ReactCurrentOwner, ur = B.ReactDebugCurrentFrame;
    function Ti(G) {
      if (G) {
        var ke = G._owner, U = Wt(G.type, G._source, ke ? ke.type : null);
        ur.setExtraStackFrame(U);
      } else
        ur.setExtraStackFrame(null);
    }
    var qi;
    qi = !1;
    function Bl(G) {
      return typeof G == "object" && G !== null && G.$$typeof === e;
    }
    function gs() {
      {
        if (Lr.current) {
          var G = Ve(Lr.current.type);
          if (G)
            return `

Check the render method of \`` + G + "`.";
        }
        return "";
      }
    }
    function Vl(G) {
      {
        if (G !== void 0) {
          var ke = G.fileName.replace(/^.*[\\\/]/, ""), U = G.lineNumber;
          return `

Check your code at ` + ke + ":" + U + ".";
        }
        return "";
      }
    }
    var $u = {};
    function uc(G) {
      {
        var ke = gs();
        if (!ke) {
          var U = typeof G == "string" ? G : G.displayName || G.name;
          U && (ke = `

Check the top-level render call using <` + U + ">.");
        }
        return ke;
      }
    }
    function ms(G, ke) {
      {
        if (!G._store || G._store.validated || G.key != null)
          return;
        G._store.validated = !0;
        var U = uc(ke);
        if ($u[U])
          return;
        $u[U] = !0;
        var ye = "";
        G && G._owner && G._owner !== Lr.current && (ye = " It was passed a child from " + Ve(G._owner.type) + "."), Ti(G), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', U, ye), Ti(null);
      }
    }
    function Xs(G, ke) {
      {
        if (typeof G != "object")
          return;
        if (ra(G))
          for (var U = 0; U < G.length; U++) {
            var ye = G[U];
            Bl(ye) && ms(ye, ke);
          }
        else if (Bl(G))
          G._store && (G._store.validated = !0);
        else if (G) {
          var Fe = L(G);
          if (typeof Fe == "function" && Fe !== G.entries)
            for (var Ue = Fe.call(G), Ze; !(Ze = Ue.next()).done; )
              Bl(Ze.value) && ms(Ze.value, ke);
        }
      }
    }
    function _s(G) {
      {
        var ke = G.type;
        if (ke == null || typeof ke == "string")
          return;
        var U;
        if (typeof ke == "function")
          U = ke.propTypes;
        else if (typeof ke == "object" && (ke.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ke.$$typeof === _))
          U = ke.propTypes;
        else
          return;
        if (U) {
          var ye = Ve(ke);
          Rr(U, G.props, "prop", ye, G);
        } else if (ke.PropTypes !== void 0 && !qi) {
          qi = !0;
          var Fe = Ve(ke);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Fe || "Unknown");
        }
        typeof ke.getDefaultProps == "function" && !ke.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Qs(G) {
      {
        for (var ke = Object.keys(G.props), U = 0; U < ke.length; U++) {
          var ye = ke[U];
          if (ye !== "children" && ye !== "key") {
            Ti(G), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ye), Ti(null);
            break;
          }
        }
        G.ref !== null && (Ti(G), $("Invalid attribute `ref` supplied to `React.Fragment`."), Ti(null));
      }
    }
    function Ua(G, ke, U, ye, Fe, Ue) {
      {
        var Ze = De(G);
        if (!Ze) {
          var Xe = "";
          (G === void 0 || typeof G == "object" && G !== null && Object.keys(G).length === 0) && (Xe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Nt = Vl(Fe);
          Nt ? Xe += Nt : Xe += gs();
          var kt;
          G === null ? kt = "null" : ra(G) ? kt = "array" : G !== void 0 && G.$$typeof === e ? (kt = "<" + (Ve(G.type) || "Unknown") + " />", Xe = " Did you accidentally export a JSX literal instead of a component?") : kt = typeof G, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", kt, Xe);
        }
        var ci = fr(G, ke, U, Fe, Ue);
        if (ci == null)
          return ci;
        if (Ze) {
          var pr = ke.children;
          if (pr !== void 0)
            if (ye)
              if (ra(pr)) {
                for (var xa = 0; xa < pr.length; xa++)
                  Xs(pr[xa], G);
                Object.freeze && Object.freeze(pr);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xs(pr, G);
        }
        return G === r ? Qs(ci) : _s(ci), ci;
      }
    }
    function Ko(G, ke, U) {
      return Ua(G, ke, U, !0);
    }
    function Wn(G, ke, U) {
      return Ua(G, ke, U, !1);
    }
    var ya = Wn, jo = Ko;
    dy.Fragment = r, dy.jsx = ya, dy.jsxs = jo;
  }()), dy;
}
var tVe = cT.exports;
process.env.NODE_ENV === "production" ? cT.exports = qte() : cT.exports = Xte();
var ni = cT.exports;
var Qte = {
  "[object Array]": "array",
  "[object Date]": "date",
  "[object Object]": "object",
  "[object String]": "string"
}, cs = function(t) {
  if (t === null)
    return "null";
  var e = Object.prototype.toString.call(t);
  return typeof t == "object" ? Qte[e] || "object" : typeof t;
}, wx = function(t) {
  return typeof t == "boolean";
}, QH = function(t) {
  return Di(t) && t.toString().indexOf("e") !== -1;
}, zo = function(t) {
  return cs(t) === "date";
}, R = function(t) {
  return t != null;
}, Le = function(t) {
  return typeof t == "function";
}, ht = function(t) {
  return typeof t == "string";
}, Di = function(t) {
  return typeof t == "number" && isFinite(t) || !isNaN(t - parseFloat(t));
}, ct = function(t) {
  return cs(t) === "object";
}, uo = function(t) {
  var e;
  for (e in t)
    return !1;
  return !0;
}, $t = function(t) {
  if (!t || cs(t) !== "object")
    return !1;
  var e = Object.getPrototypeOf(t);
  if (!e)
    return !0;
  var i = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
  return typeof i == "function" && Object.toString.call(i) === Object.toString.call(Object);
}, sx = function(t) {
  return ["object", "array", "function"].indexOf(cs(t)) === -1;
}, Or = function(t) {
  return t != null && t === t.window;
}, hs = function(t) {
  return !!t && !!(t.jquery || t.dxRenderer);
}, Vm = function(t) {
  return !!t && Le(t.then);
}, JT = function(t) {
  return !!t && Le(t.done) && Le(t.fail);
}, Zte = function(t) {
  return !!(t && t.preventDefault);
}, Jte = function(t, e, i) {
  t = t || {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      var n = e[r];
      (!(r in t) || i) && (t[r] = n);
    }
  return t;
}, P = function t(e) {
  e = e || {};
  var i = 1, r = !1;
  for (typeof e == "boolean" && (r = e, e = arguments[1] || {}, i++); i < arguments.length; i++) {
    var n = arguments[i];
    if (n != null)
      for (var a in n) {
        var o = e[a], u = n[a], c = !1, p = void 0;
        a === "__proto__" || a === "constructor" || e === u || (r && u && ($t(u) || (c = Array.isArray(u))) ? (c ? p = o && Array.isArray(o) ? o : [] : p = o && $t(o) ? o : {}, e[a] = t(r, p, u)) : u !== void 0 && (e[a] = u));
      }
  }
  return e;
}, Jr = (t, e) => {
  if (Array.isArray(t))
    return t.map(e);
  var i = [];
  for (var r in t)
    i.push(e(t[r], r));
  return i;
}, N = (t, e) => {
  if (t) {
    if ("length" in t)
      for (var i = 0; i < t.length && e.call(t[i], i, t[i]) !== !1; i++)
        ;
    else
      for (var r in t)
        if (e.call(t[r], r, t[r]) === !1)
          break;
    return t;
  }
};
var eie = function() {
}, Ab = function(t) {
  return typeof console > "u" || !Le(console[t]) ? eie : console[t].bind(console);
}, eI = {
  log: Ab("log"),
  info: Ab("info"),
  warn: Ab("warn"),
  error: Ab("error")
};
var K3 = function() {
  var t = [new RegExp("&", "g"), new RegExp('"', "g"), new RegExp("'", "g"), new RegExp("<", "g"), new RegExp(">", "g")];
  return function(e) {
    return String(e).replace(t[0], "&amp;").replace(t[1], "&quot;").replace(t[2], "&#39;").replace(t[3], "&lt;").replace(t[4], "&gt;");
  };
}(), tie = function(t) {
  switch (typeof t) {
    case "string":
      return t.split(/\s+/, 4);
    case "object":
      return [t.x || t.h || t.left, t.y || t.v || t.top, t.x || t.h || t.right, t.y || t.v || t.bottom];
    case "number":
      return [t];
    default:
      return t;
  }
}, iie = function(t) {
  var e = tie(t), i = parseInt(e && e[0], 10), r = parseInt(e && e[1], 10), n = parseInt(e && e[2], 10), a = parseInt(e && e[3], 10);
  return isFinite(i) || (i = 0), isFinite(r) || (r = i), isFinite(n) || (n = i), isFinite(a) || (a = r), {
    top: r,
    right: n,
    bottom: a,
    left: i
  };
};
function Mu(t) {
  for (var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    i[r - 1] = arguments[r];
  return Le(t) ? t(...i) : (i.forEach((n, a) => {
    ht(n) && (n = n.replace(/\$/g, "$$$$"));
    var o = new RegExp("\\{" + a + "\\}", "gm");
    t = t.replace(o, n);
  }), t);
}
var Pw = /* @__PURE__ */ function() {
  var t = /\s/g;
  return function(e) {
    return !e || !e.replace(t, "");
  };
}(), j3 = "23.2.5", rie = "https://js.devexpress.com/error/" + j3.split(".").slice(0, 2).join("_") + "/";
function rF(t, e) {
  var i = {
    ERROR_MESSAGES: P(e, t),
    Error: function() {
      return o([].slice.call(arguments));
    },
    log: function(c) {
      var p = "log";
      /^E\d+$/.test(c) ? p = "error" : /^W\d+$/.test(c) && (p = "warn"), eI[p](p === "log" ? c : r([].slice.call(arguments)));
    }
  };
  function r(c) {
    var p = c[0];
    return c = c.slice(1), a(p, n(p, c));
  }
  function n(c, p) {
    return p = [i.ERROR_MESSAGES[c]].concat(p), Mu.apply(this, p).replace(/\.*\s*?$/, "");
  }
  function a(c, p) {
    var v = c != null && c.startsWith("W") ? "warning" : "error";
    return Mu.apply(this, [`{0} - {1}.

For additional information on this {2} message, see: {3}`, c, p, v, u(c)]);
  }
  function o(c) {
    var p = c[0];
    c = c.slice(1);
    var v = n(p, c), _ = u(p), y = a(p, v);
    return P(new Error(y), {
      __id: p,
      __details: v,
      url: _
    });
  }
  function u(c) {
    return rie + c;
  }
  return i;
}
const bi = rF({
  E0001: "Method is not implemented",
  E0002: "Member name collision: {0}",
  E0003: "A class must be instantiated using the 'new' keyword",
  E0004: "The NAME property of the component is not specified",
  E0005: "Unknown device",
  E0006: "Unknown endpoint key is requested",
  E0007: "'Invalidate' method is called outside the update transaction",
  E0008: "Type of the option name is not appropriate to create an action",
  E0009: "Component '{0}' has not been initialized for an element",
  E0010: "Animation configuration with the '{0}' type requires '{1}' configuration as {2}",
  E0011: "Unknown animation type '{0}'",
  E0012: "jQuery version is too old. Please upgrade jQuery to 1.10.0 or later",
  E0013: "KnockoutJS version is too old. Please upgrade KnockoutJS to 2.3.0 or later",
  E0014: "The 'release' method shouldn't be called for an unlocked Lock object",
  E0015: "Queued task returned an unexpected result",
  E0017: "Event namespace is not defined",
  E0018: "DevExpress.ui.DevExpressPopup widget is required",
  E0020: "Template engine '{0}' is not supported",
  E0021: "Unknown theme is set: {0}",
  E0022: "LINK[rel=DevExpress-theme] tags must go before DevExpress included scripts",
  E0023: "Template name is not specified",
  E0024: "DevExtreme bundle already included",
  E0025: "Unexpected argument type",
  E0100: "Unknown validation type is detected",
  E0101: "Misconfigured range validation rule is detected",
  E0102: "Misconfigured comparison validation rule is detected",
  E0103: "validationCallback of an asynchronous rule should return a jQuery or a native promise",
  E0110: "Unknown validation group is detected",
  E0120: "Adapter for a DevExpressValidator component cannot be configured",
  E0121: "The 'customItem' parameter of the 'onCustomItemCreating' function is empty or contains invalid data. Assign a custom object or a Promise that is resolved after the item is created.",
  W0000: "'{0}' is deprecated in {1}. {2}",
  W0001: "{0} - '{1}' option is deprecated in {2}. {3}",
  W0002: "{0} - '{1}' method is deprecated in {2}. {3}",
  W0003: "{0} - '{1}' property is deprecated in {2}. {3}",
  W0004: "Timeout for theme loading is over: {0}",
  W0005: "'{0}' event is deprecated in {1}. {2}",
  W0006: "Invalid recurrence rule: '{0}'",
  W0007: "'{0}' Globalize culture is not defined",
  W0008: "Invalid view name: '{0}'",
  W0009: "Invalid time zone name: '{0}'",
  W0010: "{0} is deprecated in {1}. {2}",
  W0011: "Number parsing is invoked while the parser is not defined",
  W0012: "Date parsing is invoked while the parser is not defined",
  W0013: "'{0}' file is deprecated in {1}. {2}",
  W0014: "{0} - '{1}' type is deprecated in {2}. {3}",
  W0015: "Instead of returning a value from the '{0}' function, write it into the '{1}' field of the function's parameter.",
  W0016: 'The "{0}" option does not accept the "{1}" value since v{2}. {3}.',
  W0017: 'Setting the "{0}" property with a function is deprecated since v21.2',
  W0018: 'Setting the "position" property with a function is deprecated since v21.2',
  W0019: `DevExtreme: Unable to Locate a Valid License Key.

If you are using a 30-day trial version of DevExtreme, you must uninstall all copies of DevExtreme once your 30-day trial period expires. For terms and conditions that govern use of DevExtreme UI components/libraries, please refer to the DevExtreme End User License Agreement: https://js.devexpress.com/EULAs/DevExtremeComplete.

To use DevExtreme in a commercial project, you must purchase a license. For pricing/licensing options, please visit: https://js.devexpress.com/Buy.

If you have licensing-related questions or need help with a purchase, please email clientservices@devexpress.com.

`,
  W0020: `DevExtreme: License Key Has Expired.

A mismatch exists between the license key used and the DevExtreme version referenced in this project.

To proceed, you can:
• use a version of DevExtreme linked to your license key: https://www.devexpress.com/ClientCenter/DownloadManager
• renew your DevExpress Subscription: https://www.devexpress.com/buy/renew (once you renew your subscription, you will be entitled to product updates and support service as defined in the DevExtreme End User License Agreement)

If you have licensing-related questions or need help with a renewal, please email clientservices@devexpress.com.

`,
  W0021: `DevExtreme: License Key Verification Has Failed.

To verify your DevExtreme license, make certain to specify a correct key in the GlobalConfig. If you continue to encounter this error, please visit https://www.devexpress.com/ClientCenter/DownloadManager to obtain a valid license key.

If you have a valid license and this problem persists, please submit a support ticket via the DevExpress Support Center. We will be happy to follow-up: https://supportcenter.devexpress.com/ticket/create.

`,
  W0022: `DevExtreme: Pre-release software. Not suitable for commercial use.

Pre-release software may contain deficiencies and as such, should not be considered for use or integrated in any mission critical application.

`
});
var nie = function(t, e, i) {
  return function() {
    var r = this.callBase;
    this.callBase = t[e];
    try {
      return i.apply(this, arguments);
    } finally {
      this.callBase = r;
    }
  };
}, aie = function(t) {
  var e = function() {
  };
  return e.prototype = t.prototype, new e();
}, oie = function(t) {
  var e, i, r;
  if (!t)
    return this;
  for (i in t)
    r = t[i], e = typeof this.prototype[i] == "function" && typeof r == "function", this.prototype[i] = e ? nie(this.parent.prototype, i, r) : r;
  return this;
}, sie = function() {
  var t = this, e, i, r, n = Object.prototype.hasOwnProperty.bind(t), a = !n("_includedCtors") && !n("_includedPostCtors");
  for (a && (t._includedCtors = t._includedCtors.slice(0), t._includedPostCtors = t._includedPostCtors.slice(0)), r = 0; r < arguments.length; r++) {
    e = arguments[r], e.ctor && t._includedCtors.push(e.ctor), e.postCtor && t._includedPostCtors.push(e.postCtor);
    for (i in e)
      i === "ctor" || i === "postCtor" || i === "default" || (t.prototype[i] = e[i]);
  }
  return t;
}, lie = function(t) {
  var e = Object.prototype.hasOwnProperty.bind(this)("parent"), i = !e && this.parent;
  if (i) {
    var r = Object.getPrototypeOf(this);
    return r === t || r.subclassOf(t);
  } else
    return this.parent === t ? !0 : !this.parent || !this.parent.subclassOf ? !1 : this.parent.subclassOf(t);
}, Y3 = function() {
  throw bi.Error("E0001");
}, uie = /* @__PURE__ */ function() {
  var t = Object.prototype.hasOwnProperty;
  return function(e, i) {
    for (var r in e) {
      if (!t.call(e, r))
        return;
      i[r] = e[r];
    }
  };
}(), wi = function() {
};
wi.inherit = function(t) {
  var e = function() {
    if (!this || Or(this) || typeof this.constructor != "function")
      throw bi.Error("E0003");
    var i = this, r = i.ctor, n = i.constructor._includedCtors, a = i.constructor._includedPostCtors, o;
    for (o = 0; o < n.length; o++)
      n[o].call(i);
    for (r && r.apply(i, arguments), o = 0; o < a.length; o++)
      a[o].call(i);
  };
  return e.prototype = aie(this), uie(this, e), e.inherit = this.inherit, e.abstract = Y3, e.redefine = oie, e.include = sie, e.subclassOf = lie, e.parent = this, e._includedCtors = this._includedCtors ? this._includedCtors.slice(0) : [], e._includedPostCtors = this._includedPostCtors ? this._includedPostCtors.slice(0) : [], e.prototype.constructor = e, e.redefine(t), e;
};
wi.abstract = Y3;
function js(t) {
  var e = wi.inherit(t), i = e, r = new i(t), n = {}, a = function(o, u) {
    N(o, function(c) {
      Le(r[c]) ? (u || !t[c]) && (t[c] = function() {
        return r[c].apply(t, arguments);
      }) : (u && (n[c] = t[c]), t[c] = r[c]);
    });
  };
  return a(t, !0), t.inject = function(o) {
    i = i.inherit(o), r = new i(), a(o);
  }, t.resetInjection = function() {
    P(t, n), i = e, r = new e();
  }, t;
}
function ae() {
  return ae = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var r in i)
        Object.prototype.hasOwnProperty.call(i, r) && (t[r] = i[r]);
    }
    return t;
  }, ae.apply(this, arguments);
}
var ZH = {
  rtlEnabled: !1,
  defaultCurrency: "USD",
  defaultUseCurrencyAccountingStyle: !0,
  oDataFilterToLower: !0,
  serverDecimalSeparator: ".",
  decimalSeparator: ".",
  thousandsSeparator: ",",
  forceIsoDateParsing: !0,
  wrapActionsBeforeExecute: !0,
  useLegacyStoreResult: !1,
  useJQuery: void 0,
  editorStylingMode: void 0,
  useLegacyVisibleIndex: !1,
  floatingActionButtonConfig: {
    icon: "add",
    closeIcon: "close",
    label: "",
    position: {
      at: "right bottom",
      my: "right bottom",
      offset: {
        x: -16,
        y: -16
      }
    },
    maxSpeedDialActionCount: 5,
    shading: !1,
    direction: "auto"
  },
  optionsParser: (t) => {
    t.trim().charAt(0) !== "{" && (t = "{" + t + "}");
    try {
      return JSON.parse(t);
    } catch (e) {
      try {
        return JSON.parse(die(t));
      } catch {
        throw bi.Error("E3018", e, t);
      }
    }
  }
}, die = (t) => t.replace(/'/g, '"').replace(/,\s*([\]}])/g, "$1").replace(/([{,])\s*([^":\s]+)\s*:/g, '$1"$2":'), cie = ["decimalSeparator", "thousandsSeparator"], Oi = function() {
  if (!arguments.length)
    return ZH;
  var t = arguments.length <= 0 ? void 0 : arguments[0];
  cie.forEach((e) => {
    if (t[e]) {
      var i = "Now, the ".concat(e, " is selected based on the specified locale.");
      bi.log("W0003", "config", e, "19.2", i);
    }
  }), P(ZH, t);
};
typeof DevExpress < "u" && DevExpress.config && Oi(DevExpress.config);
var yr = wi.inherit({
  ctor: function(t) {
    t && (t = String(t)), this._value = this._normalize(t || this._generate());
  },
  _normalize: function(t) {
    for (t = t.replace(/[^a-f0-9]/gi, "").toLowerCase(); t.length < 32; )
      t += "0";
    return [t.substr(0, 8), t.substr(8, 4), t.substr(12, 4), t.substr(16, 4), t.substr(20, 12)].join("-");
  },
  _generate: function() {
    for (var t = "", e = 0; e < 32; e++)
      t += Math.round(15 * Math.random()).toString(16);
    return t;
  },
  toString: function() {
    return this._value;
  },
  valueOf: function() {
    return this._value;
  },
  toJSON: function() {
    return this._value;
  }
}), ac = function(t) {
  this._options = t || {}, this._list = [], this._queue = [], this._firing = !1, this._fired = !1, this._firingIndexes = [];
};
ac.prototype._fireCore = function(t, e) {
  var i = this._firingIndexes, r = this._list, n = this._options.stopOnFalse, a = i.length;
  for (i[a] = 0; i[a] < r.length; i[a]++) {
    var o = r[i[a]].apply(t, e);
    if (o === !1 && n)
      break;
  }
  i.pop();
};
ac.prototype.add = function(t) {
  return typeof t == "function" && (!this._options.unique || !this.has(t)) && this._list.push(t), this;
};
ac.prototype.remove = function(t) {
  var e = this._list, i = this._firingIndexes, r = e.indexOf(t);
  if (r > -1 && (e.splice(r, 1), this._firing && i.length))
    for (var n = 0; n < i.length; n++)
      r <= i[n] && i[n]--;
  return this;
};
ac.prototype.has = function(t) {
  var e = this._list;
  return t ? e.indexOf(t) > -1 : !!e.length;
};
ac.prototype.empty = function(t) {
  return this._list = [], this;
};
ac.prototype.fireWith = function(t, e) {
  var i = this._queue;
  if (e = e || [], e = e.slice ? e.slice() : e, this._options.syncStrategy)
    this._firing = !0, this._fireCore(t, e);
  else {
    if (i.push([t, e]), this._firing)
      return;
    for (this._firing = !0; i.length; ) {
      var r = i.shift();
      this._fireCore(r[0], r[1]);
    }
  }
  return this._firing = !1, this._fired = !0, this;
};
ac.prototype.fire = function() {
  this.fireWith(this, arguments);
};
ac.prototype.fired = function() {
  return this._fired;
};
var ui = function(t) {
  return new ac(t);
}, q3 = [{
  method: "resolve",
  handler: "done",
  state: "resolved"
}, {
  method: "reject",
  handler: "fail",
  state: "rejected"
}, {
  method: "notify",
  handler: "progress"
}], Im = function() {
  var t = this;
  this._state = "pending", this._promise = {}, q3.forEach((function(e) {
    var i = e.method;
    this[i + "Callbacks"] = ui(), this[i] = (function() {
      return this[i + "With"](this._promise, arguments);
    }).bind(this), this._promise[e.handler] = function(r) {
      if (!r)
        return this;
      var n = t[i + "Callbacks"];
      return n.fired() ? r.apply(t[i + "Context"], t[i + "Args"]) : n.add((function(a, o) {
        r.apply(a, o);
      }).bind(this)), this;
    };
  }).bind(this)), this._promise.always = function(e) {
    return this.done(e).fail(e);
  }, this._promise.catch = function(e) {
    return this.then(null, e);
  }, this._promise.then = function(e, i) {
    var r = new Im();
    return ["done", "fail"].forEach((function(n) {
      var a = n === "done" ? e : i;
      this[n](function() {
        if (!a) {
          r[n === "done" ? "resolve" : "reject"].apply(this, arguments);
          return;
        }
        var o = a && a.apply(this, arguments);
        JT(o) ? o.done(r.resolve).fail(r.reject) : Vm(o) ? o.then(r.resolve, r.reject) : r.resolve.apply(this, R(o) ? [o] : arguments);
      });
    }).bind(this)), r.promise();
  }, this._promise.state = function() {
    return t._state;
  }, this._promise.promise = function(e) {
    return e ? P(e, t._promise) : t._promise;
  }, this._promise.promise(this);
};
q3.forEach(function(t) {
  var e = t.method, i = t.state;
  Im.prototype[e + "With"] = function(r, n) {
    var a = this[e + "Callbacks"];
    return this.state() === "pending" && (this[e + "Args"] = n, this[e + "Context"] = r, i && (this._state = i), a.fire(r, n)), this;
  };
});
function Pn(t, e) {
  if (JT(t))
    return t;
  if (Vm(t)) {
    var i = new Im();
    return t.then(function() {
      i.resolveWith.apply(i, [e].concat([
        [].slice.call(arguments)
      ]));
    }, function() {
      i.rejectWith.apply(i, [e].concat([
        [].slice.call(arguments)
      ]));
    }), i;
  }
  return new Im().resolveWith(e, [t]);
}
var hie = function() {
  if (arguments.length === 1)
    return Pn(arguments[0]);
  for (var t = [].slice.call(arguments), e = [], i = 0, r = new Im(), n = function(o) {
    return function(u) {
      e[o] = this, t[o] = arguments.length > 1 ? [].slice.call(arguments) : u, i++, i === t.length && r.resolveWith(e, t);
    };
  }, a = 0; a < t.length; a++)
    JT(t[a]) ? t[a].promise().done(n(a)).fail(r.reject) : i++;
  return i === t.length && r.resolveWith(e, t), r.promise();
};
function q() {
  return new Im();
}
function $e() {
  return hie.apply(this, arguments);
}
const Ha = js({
  isWrapped: function() {
    return !1;
  },
  isWritableWrapped: function() {
    return !1;
  },
  wrap: function(t) {
    return t;
  },
  unwrap: function(t) {
    return t;
  },
  assign: function() {
    eI.error("Method 'assign' should not be used for not wrapped variables. Use 'isWrapped' method for ensuring.");
  }
});
var mk = function(t, e) {
  var i = [], r, n;
  for (r in t)
    Object.prototype.hasOwnProperty.call(t, r) && i.push(r);
  for (i.sort(function(a, o) {
    var u = Di(a), c = Di(o);
    return u && c ? a - o : u && !c ? -1 : !u && c ? 1 : a < o ? -1 : a > o ? 1 : 0;
  }), n = 0; n < i.length; n++)
    r = i[n], e(r, t[r]);
}, fie = function(t, e, i, r) {
  !r && Ha.isWrapped(t[e]) ? Ha.assign(t[e], i) : t[e] = i;
}, Hs = function t(e, i, r, n) {
  var a, o;
  for (var u in i)
    if (a = e[u], o = i[u], !(u === "__proto__" || u === "constructor" || e === o)) {
      if ($t(o)) {
        var c = r ? ct(a) : $t(a);
        o = t(c ? a : {}, o, r, n);
      }
      o !== void 0 && a !== o && fie(e, u, o, n);
    }
  return e;
}, pie = Ha.unwrap, X3 = Ha.isWrapped, vie = Ha.assign, gie = function(t) {
  return t.replace(/\[/g, ".").replace(/\]/g, "");
}, Vp = function(t) {
  return gie(t).split(".");
}, mie = function(t, e, i) {
  return i = i || {}, Tx(e === "this" ? t : t[e], i);
}, Q3 = function(t, e, i, r) {
  if (e === "this")
    throw new bi.Error("E4016");
  var n = t[e];
  r.unwrapObservables && X3(n) ? vie(n, i) : t[e] = i;
}, Z3 = function(t) {
  return t = t || {}, t.unwrapObservables = t.unwrapObservables !== void 0 ? t.unwrapObservables : !0, t;
};
function Tx(t, e) {
  return e.unwrapObservables ? pie(t) : t;
}
var Ii = function(t) {
  if (arguments.length > 1 && (t = [].slice.call(arguments)), !t || t === "this")
    return function(i) {
      return i;
    };
  if (typeof t == "string") {
    var e = Vp(t);
    return function(i, r) {
      r = Z3(r);
      for (var n = r.functionsAsIs, a = ("defaultValue" in r), o = Tx(i, r), u = 0; u < e.length; u++) {
        if (!o) {
          if (o == null && a)
            return r.defaultValue;
          break;
        }
        var c = e[u];
        if (a && ct(o) && !(c in o))
          return r.defaultValue;
        var p = Tx(o[c], r);
        !n && Le(p) && (p = p.call(o)), o = p;
      }
      return o;
    };
  }
  if (Array.isArray(t))
    return _ie(t);
  if (Le(t))
    return t;
};
function _ie(t) {
  for (var e = {}, i = 0, r = t.length; i < r; i++) {
    var n = t[i];
    e[n] = Ii(n);
  }
  return function(a, o) {
    var u;
    return N(e, function(c) {
      var p = this(a, o);
      if (p !== void 0) {
        for (var v = u || (u = {}), _ = c.split("."), y = _.length - 1, b = 0; b < y; b++) {
          var I = _[b];
          I in v || (v[I] = {}), v = v[I];
        }
        v[_[y]] = p;
      }
    }), u;
  };
}
var JH = function(t, e, i, r) {
  if (R(i))
    return i;
  var n = {};
  return Q3(t, e, n, r), n;
}, nF = function(t) {
  t = Vp(t || "this");
  var e = t.length - 1;
  return function(i, r, n) {
    n = Z3(n);
    var a = Tx(i, n);
    t.forEach(function(o, u) {
      var c = mie(a, o, n), p = !n.functionsAsIs && Le(c) && !X3(c);
      u === e ? n.merge && $t(r) && (!R(c) || $t(c)) ? (c = JH(a, o, c, n), Hs(c, r, !1, !0)) : p ? a[o](r) : Q3(a, o, r, n) : (c = JH(a, o, c, n), p && (c = c.call(a)), a = c);
    });
  };
}, ta = function(t, e) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (t instanceof Date)
    return t.getTime();
  if (t && t instanceof wi && t.valueOf)
    return t.valueOf();
  if (!e && typeof t == "string") {
    var r;
    if ((i == null || (r = i.collatorOptions) === null || r === void 0 ? void 0 : r.sensitivity) === "base") {
      var n = /[\u0300-\u036f]/g;
      t = t.normalize("NFD").replace(n, "");
    }
    return i != null && i.locale ? t.toLocaleLowerCase(i.locale) : t.toLowerCase();
  }
  return t;
}, cr = function(t, e) {
  return R(t) ? t : e;
}, aF = function(t, e) {
  var i = new q(), r = e || this, n = {
    promise: i.promise(),
    abort: function() {
      clearTimeout(o), i.rejectWith(r);
    }
  }, a = function() {
    var u = t.call(r);
    u && u.done && Le(u.done) ? u.done(function() {
      i.resolveWith(r);
    }) : i.resolveWith(r);
  }, o = (arguments[2] || setTimeout)(a, typeof e == "number" ? e : 0);
  return n;
}, _R = [], e$ = [], cy = [], Gg, tI = function(t, e, i) {
  if (Gg && Gg !== t)
    return _R.push(e), e$.push(t), i = i || new q(), cy.push(i), i;
  var r = Gg, n = cy.length;
  Gg = t;
  var a = e();
  return a || (cy.length > n ? a = $e.apply(this, cy.slice(n)) : i && i.resolve()), Gg = r, i && a && a.done && a.done(i.resolve).fail(i.reject), !Gg && _R.length && (e$.shift() === "render" ? dn : Na)(_R.shift(), cy.shift()), a || $e();
}, dn = function(t, e) {
  return tI("render", t, e);
}, Na = function(t, e) {
  return tI("update", t, e);
}, Sm = function(t) {
  return function() {
    var e = this;
    return tI("render", function() {
      return t.call(e);
    });
  };
}, t$ = function(t) {
  return function() {
    var e = this;
    return tI("update", function() {
      return t.call(e);
    });
  };
}, J3 = function(t, e, i) {
  var r = [], n = 0;
  return N(e, (a, o) => {
    var u = 0, c = i ? i(o) : o;
    N(t, (p, v) => {
      var _ = c[p];
      if (_ !== void 0) {
        if (Cie(_, v)) {
          u++;
          return;
        }
        return u = -1, !1;
      }
    }), !(u < n) && (u > n && (r.length = 0, n = u), r.push(o));
  }), r;
}, Cie = function(t, e) {
  if (Array.isArray(t) && Array.isArray(e)) {
    var i = !1;
    return N(t, (r, n) => {
      if (n !== e[r])
        return i = !0, !1;
    }), !i;
  }
  return t === e;
}, Nm = function(t) {
  var e, i;
  switch (cs(t)) {
    case "string":
      return t.split(/\s+/, 2);
    case "object":
      return [(e = t.x) !== null && e !== void 0 ? e : t.h, (i = t.y) !== null && i !== void 0 ? i : t.v];
    case "number":
      return [t];
    case "array":
      return t;
    default:
      return null;
  }
};
var ej = function(t, e) {
  var i = Nm(t), r = e ? parseFloat(i && i[0]) : parseInt(i && i[0], 10), n = e ? parseFloat(i && i[1]) : parseInt(i && i[1], 10);
  return isFinite(r) || (r = 0), isFinite(n) || (n = r), {
    h: r,
    v: n
  };
}, ku = function(t) {
  if (t instanceof yr)
    return t.toString();
  if (ct(t) || Array.isArray(t))
    try {
      var e = JSON.stringify(t);
      return e === "{}" ? t : e;
    } catch {
      return t;
    }
  return t;
}, Eh = function(t) {
  return t.replace(/[[\]{}\-()*+?.\\^$|\s]/g, "\\$&");
}, yie = function(t) {
  var e = Oi().serverDecimalSeparator;
  return R(t) && (t = t.toString().replace(".", e)), t;
}, ee = function() {
}, tj = function() {
  return new q().resolve().promise();
}, so = function(t, e, i) {
  for (var r = [], n, a = !i, o = 0; o < t.length; o++)
    n = !!e(t[o], o), n === a && r.push(t[o]);
  return r;
}, xie = (t, e, i, r) => t.length !== e.length ? !1 : !t.some((n, a) => !oF(n, e[a], i + 1, ae({}, r, {
  strict: !0
}))), Sie = (t, e, i, r) => {
  var n = Object.keys(t), a = Object.keys(e);
  if (n.length !== a.length)
    return !1;
  var o = new Set(a);
  return !n.some((u) => !o.has(u) || !oF(t[u], e[u], i + 1, r));
}, i$ = {
  maxDepth: 3,
  strict: !0
}, oF = (t, e, i, r) => {
  var {
    strict: n,
    maxDepth: a
  } = r, o = ta(t, !0), u = ta(e, !0), c = n ? o === u : o == u;
  switch (!0) {
    case c:
    case i >= a:
      return !0;
    case (ct(o) && ct(u)):
      return Sie(o, u, i, r);
    case (Array.isArray(o) && Array.isArray(u)):
      return xie(o, u, i, r);
    default:
      return !1;
  }
}, Mi = function(t, e) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : i$, r = ae({}, i$, i);
  return oF(t, e, 0, r);
}, CR = "dx-", Ob = null;
function r$(t) {
  try {
    return new CSSStyleSheet();
  } catch {
    var e = t.ownerDocument.createElement("style");
    return t.appendChild(e), e.sheet;
  }
}
function n$(t, e, i) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    try {
      for (var a = 0; a < n.cssRules.length; a++)
        Eie(t, n.cssRules[a], i);
    } catch {
    }
  }
}
function Eie(t, e, i) {
  var r, n, a, o, u, c, p = i || ((r = e.selectorText) === null || r === void 0 ? void 0 : r.includes(CR)) || ((n = e.cssRules) === null || n === void 0 || (a = n[0]) === null || a === void 0 || (o = a.selectorText) === null || o === void 0 ? void 0 : o.includes(CR)) || ((u = e.name) === null || u === void 0 ? void 0 : u.startsWith(CR)) || ((c = e.style) === null || c === void 0 ? void 0 : c.fontFamily) === "DXIcons";
  p && t.insertRule(e.cssText, t.cssRules.length);
}
function bie(t) {
  var e, i = t.get(0), r = (e = i.getRootNode) === null || e === void 0 ? void 0 : e.call(i);
  if (r != null && r.host) {
    Ob || (Ob = r$(r), n$(Ob, i.ownerDocument.styleSheets, !1));
    var n = r$(r);
    n$(n, r.styleSheets, !0), r.adoptedStyleSheets = [Ob, n];
  }
}
function wie(t, e, i) {
  var r = t.getBoundingClientRect();
  return r && e >= r.left && e < r.right && i >= r.top && i < r.bottom;
}
function Tie() {
  var t = 0, e = [];
  return {
    push(i) {
      return e.push(i), this;
    },
    shift() {
      return t++, e[t - 1];
    },
    get length() {
      return e.length - t;
    },
    get items() {
      return e;
    }
  };
}
function Iie(t, e, i) {
  for (var r = Tie().push(i); r.length; )
    for (var n = r.shift(), a = 0; a < n.childNodes.length; a++) {
      var o = n.childNodes[a];
      o.nodeType === Node.ELEMENT_NODE && wie(o, t, e) && getComputedStyle(o).pointerEvents !== "none" && r.push(o);
    }
  var u = r.items.reverse();
  return u.pop(), u;
}
var Die = 1, Aie = 3, Oie = 9, Rie = 11, Lie = {
  querySelectorAll: (t, e) => t.querySelectorAll(e),
  elementMatches(t, e) {
    var i = t.matches || t.matchesSelector || t.mozMatchesSelector || t.msMatchesSelector || t.oMatchesSelector || t.webkitMatchesSelector || ((r) => {
      var n = t.document || t.ownerDocument;
      if (!n)
        return !1;
      for (var a = this.querySelectorAll(n, r), o = 0; o < a.length; o++)
        if (a[o] === t)
          return !0;
    });
    return i.call(t, e);
  },
  createElement(t, e) {
    return e = e || this._document, e.createElement(t);
  },
  createElementNS(t, e, i) {
    return i = i || this._document, i.createElementNS(t, e);
  },
  createTextNode(t, e) {
    return e = e || this._document, e.createTextNode(t);
  },
  createAttribute(t, e) {
    return e = e || this._document, e.createAttribute(t);
  },
  isNode: (t) => t && typeof t == "object" && "nodeType" in t && "nodeName" in t,
  isElementNode: (t) => t && t.nodeType === Die,
  isTextNode: (t) => t && t.nodeType === Aie,
  isDocument: (t) => t && t.nodeType === Oie,
  isDocumentFragment: (t) => t && t.nodeType === Rie,
  removeElement(t) {
    var e = t && t.parentNode;
    e && e.removeChild(t);
  },
  insertElement(t, e, i) {
    t && e && t !== e && (i ? t.insertBefore(e, i) : t.appendChild(e));
  },
  getAttribute: (t, e) => t.getAttribute(e),
  setAttribute(t, e, i) {
    e === "style" ? t.style.cssText = i : t.setAttribute(e, i);
  },
  removeAttribute(t, e) {
    t.removeAttribute(e);
  },
  setProperty(t, e, i) {
    t[e] = i;
  },
  setText(t, e) {
    t && (t.textContent = e);
  },
  setClass(t, e, i) {
    t.nodeType === 1 && e && (i ? t.classList.add(e) : t.classList.remove(e));
  },
  setStyle(t, e, i) {
    t.style[e] = i || "";
  },
  _document: typeof document > "u" ? void 0 : document,
  getDocument() {
    return this._document;
  },
  getActiveElement(t) {
    var e = this.getRootNode(t);
    return e.activeElement;
  },
  getRootNode(t) {
    var e, i;
    return (e = t == null || (i = t.getRootNode) === null || i === void 0 ? void 0 : i.call(t)) !== null && e !== void 0 ? e : this._document;
  },
  getBody() {
    return this._document.body;
  },
  createDocumentFragment() {
    return this._document.createDocumentFragment();
  },
  getDocumentElement() {
    return this._document.documentElement;
  },
  getLocation() {
    return this._document.location;
  },
  getSelection() {
    return this._document.selection;
  },
  getReadyState() {
    return this._document.readyState;
  },
  getHead() {
    return this._document.head;
  },
  hasDocumentProperty(t) {
    return t in this._document;
  },
  listen(t, e, i, r) {
    return !t || !("addEventListener" in t) ? ee : (t.addEventListener(e, i, r), () => {
      t.removeEventListener(e, i);
    });
  },
  elementsFromPoint(t, e, i) {
    var r = this.getRootNode(i);
    return r.host ? Iie(t, e, r) : r.elementsFromPoint(t, e);
  }
};
const de = js(Lie);
class sF {
  constructor() {
    this.memory = [], this.callbacks = ui();
  }
  add(e) {
    N(this.memory, (i, r) => e.apply(e, r)), this.callbacks.add(e);
  }
  remove(e) {
    this.callbacks.remove(e);
  }
  fire() {
    for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++)
      i[r] = arguments[r];
    this.memory.push(i), this.callbacks.fire.apply(this.callbacks, i);
  }
}
const lF = new sF();
var Mie = typeof window < "u", wt = () => Mie, cp = wt() ? window : void 0;
cp || (cp = {}, cp.window = cp);
var Ot = () => cp;
var ij = (t) => wt() && t in cp, uF = (t) => t < 768 ? "xs" : t < 992 ? "sm" : t < 1200 ? "md" : "lg", rj = (t) => {
  var e = t || uF, i = de.getDocumentElement().clientWidth;
  return e(i);
}, Yx = () => wt() ? cp.navigator : {
  userAgent: ""
}, kie = ["pageX", "pageY", "screenX", "screenY", "clientX", "clientY"], Pie = function(t, e) {
  if (e[t] && !e.touches || !e.touches)
    return e[t];
  var i = e.touches.length ? e.touches : e.changedTouches;
  if (i.length)
    return i[0][t];
};
function Fie(t) {
  kie.forEach(function(e) {
    t(e, function(i) {
      return Pie(e, i);
    });
  }, this);
}
var oc = function(t) {
  var e, i = function() {
    return e = t.apply(this, arguments), i = function() {
      return e;
    }, e;
  };
  return function() {
    return i.apply(this, arguments);
  };
}, dF = Ot(), Rb = "dxEmptyEventType", a$ = {
  mouseenter: "mouseover",
  mouseleave: "mouseout",
  pointerenter: "pointerover",
  pointerleave: "pointerout"
}, Bie = {
  focusin: "focus",
  focusout: "blur"
}, Vie = ["blur", "focus", "load"], nj = ["touchmove", "wheel", "mousewheel", "touchstart"], Nie = ["target", "relatedTarget", "delegateTarget", "altKey", "bubbles", "cancelable", "changedTouches", "ctrlKey", "detail", "eventPhase", "metaKey", "shiftKey", "view", "char", "code", "charCode", "key", "keyCode", "button", "buttons", "offsetX", "offsetY", "pointerId", "pointerType", "targetTouches", "toElement", "touches"];
function Hie(t, e) {
  return !Or(t) && t.nodeName !== "#document" && de.elementMatches(t, e);
}
var yR = /* @__PURE__ */ new WeakMap(), aj = 0, hT, gh = function() {
  var t = {};
  return lF.add(function(e, i) {
    t[e] = i;
  }), {
    getField: function(e, i) {
      return t[e] && t[e][i];
    },
    callMethod: function(e, i, r, n) {
      return t[e] && t[e][i] && t[e][i].apply(r, n);
    }
  };
}(), k = js({
  on: hy(_k(l$(function(t, e, i, r, n) {
    var a = lm(t, e);
    a.addHandler(n, i, r);
  }))),
  one: hy(_k(function(t, e, i, r, n) {
    k.on(t, e, i, r, function a() {
      k.off(t, e, i, a), n.apply(this, arguments);
    });
  })),
  off: hy(Wie(l$(function(t, e, i, r) {
    var n = lm(t, e);
    n.removeHandler(r, i);
  }))),
  trigger: hy(s$(function(t, e, i) {
    var r = e.type, n = lm(t, e.type);
    gh.callMethod(r, "trigger", t, [e, i]), n.callHandlers(e, i);
    var a = gh.getField(r, "noBubble") || e.isPropagationStopped() || Vie.indexOf(r) !== -1;
    if (!a) {
      var o = [];
      (function p(v) {
        var _, y = (_ = v.parentNode) !== null && _ !== void 0 ? _ : ct(v.host) ? v.host : null;
        y && (o.push(y), p(y));
      })(t), o.push(dF);
      for (var u = 0; o[u] && !e.isPropagationStopped(); ) {
        var c = lm(o[u], e.type);
        c.callHandlers(P(e, {
          currentTarget: o[u]
        }), i), u++;
      }
    }
    (t.nodeType || Or(t)) && (gh.callMethod(r, "_default", t, [e, i]), Gie(r, t));
  })),
  triggerHandler: hy(s$(function(t, e, i) {
    var r = lm(t, e.type);
    r.callHandlers(e, i);
  }))
});
function cF(t, e) {
  var i = t[0];
  if (i)
    if (de.isNode(i) || Or(i))
      e.apply(k, t);
    else if (!ht(i) && "length" in i) {
      var r = Array.prototype.slice.call(t, 0);
      Array.prototype.forEach.call(i, function(n) {
        r[0] = n, cF(r, e);
      });
    } else
      throw bi.Error("E0025");
}
function hy(t) {
  return function() {
    cF(arguments, t);
  };
}
function $ie() {
  var t = !1;
  try {
    var e = Object.defineProperty({}, "passive", {
      get: function() {
        return t = !0, !0;
      }
    });
    dF.addEventListener("test", null, e);
  } catch {
  }
  return t;
}
var oj = oc($ie), sj = (t, e) => Or(t) ? sj(t.document, e) : t.contains ? t.contains(e) : !!(e.compareDocumentPosition(t) & e.DOCUMENT_POSITION_CONTAINS);
function lm(t, e) {
  var i = yR.get(t);
  e = e || "";
  var r = e.split("."), n = r.slice(1), a = !!r[0];
  e = r[0] || Rb, i || (i = {}, yR.set(t, i)), i[e] || (i[e] = {
    handleObjects: [],
    nativeHandler: null
  });
  var o = i[e];
  return {
    addHandler: function(u, c, p) {
      var v = function(A, L) {
        var B = [A], $ = A.currentTarget, K = A.relatedTarget, te, z;
        e in a$ && (te = K && $ && (K === $ || sj($, K))), L !== void 0 && B.push(L), gh.callMethod(e, "handle", t, [A, p]), te || (z = u.apply($, B)), z === !1 && (A.preventDefault(), A.stopPropagation());
      }, _ = {
        handler: u,
        wrappedHandler: function(A, L) {
          if (!(hT && A.type === hT))
            if (A.data = p, A.delegateTarget = t, c)
              for (var B = A.target; B && B !== t; )
                Hie(B, c) && (A.currentTarget = B, v(A, L)), B = B.parentNode;
            else
              A.currentTarget = A.delegateTarget || A.target, v(A, L);
        },
        selector: c,
        type: e,
        data: p,
        namespace: n.join("."),
        namespaces: n,
        guid: ++aj
      };
      o.handleObjects.push(_);
      var y = o.handleObjects.length === 1, b = y && a, I;
      b && (b = !gh.callMethod(e, "setup", t, [p, n, u])), b && (o.nativeHandler = zie(e), oj() && nj.indexOf(e) > -1 && (I = {
        passive: !1
      }), o.removeListener = de.listen(t, a$[e] || e, o.nativeHandler, I)), gh.callMethod(e, "add", t, [_]);
    },
    removeHandler: function(u, c) {
      var p = function(y) {
        var b = i[y];
        if (!b.handleObjects.length) {
          delete i[y];
          return;
        }
        var I;
        b.handleObjects = b.handleObjects.filter(function(B) {
          var $ = n.length && !o$(B.namespaces, n) || u && B.handler !== u || c && B.selector !== c;
          return $ || (I = B.handler, gh.callMethod(y, "remove", t, [B])), $;
        });
        var A = !b.handleObjects.length, L = A && y !== Rb;
        L && (gh.callMethod(y, "teardown", t, [n, I]), b.nativeHandler && b.removeListener(), delete i[y]);
      };
      if (a)
        p(e);
      else
        for (var v in i)
          p(v);
      var _ = Object.keys(i).length === 0;
      _ && yR.delete(t);
    },
    callHandlers: function(u, c) {
      var p = !1, v = function(_) {
        p || (!n.length || o$(_.namespaces, n)) && (_.wrappedHandler(u, c), p = u.isImmediatePropagationStopped());
      };
      o.handleObjects.forEach(v), n.length && i[Rb] && i[Rb].handleObjects.forEach(v);
    }
  };
}
function zie(t) {
  return function(e, i) {
    var r = lm(this, t);
    e = k.Event(e), r.callHandlers(e, i);
  };
}
function o$(t, e) {
  for (var i = 0; i < e.length; i++)
    if (t.indexOf(e[i]) < 0)
      return !1;
  return !0;
}
function _k(t) {
  return function(e, i, r, n, a) {
    a || (a = n, n = void 0), typeof r != "string" && (n = r, r = void 0), !a && typeof i == "string" && (a = n || r, r = void 0, n = void 0), t(e, i, r, n, a);
  };
}
function Wie(t) {
  return function(e, i, r, n) {
    typeof r == "function" && (n = r, r = void 0), t(e, i, r, n);
  };
}
function s$(t) {
  return function(e, i, r) {
    typeof i == "string" && (i = {
      type: i
    }), i.target || (i.target = e), i.currentTarget = e, i.delegateTarget || (i.delegateTarget = e), !i.type && i.originalEvent && (i.type = i.originalEvent.type), t(e, i instanceof k.Event ? i : k.Event(i), r);
  };
}
function Uie(t) {
  return k.Event = function(e, i) {
    if (!(this instanceof k.Event))
      return new k.Event(e, i);
    e || (e = {}), typeof e == "string" && (e = {
      type: e
    }), i || (i = {}), t.call(this, e, i);
  }, ae(k.Event.prototype, {
    _propagationStopped: !1,
    _immediatePropagationStopped: !1,
    _defaultPrevented: !1,
    isPropagationStopped: function() {
      return !!(this._propagationStopped || this.originalEvent && this.originalEvent.propagationStopped);
    },
    stopPropagation: function() {
      this._propagationStopped = !0, this.originalEvent && this.originalEvent.stopPropagation();
    },
    isImmediatePropagationStopped: function() {
      return this._immediatePropagationStopped;
    },
    stopImmediatePropagation: function() {
      this.stopPropagation(), this._immediatePropagationStopped = !0, this.originalEvent && this.originalEvent.stopImmediatePropagation();
    },
    isDefaultPrevented: function() {
      return !!(this._defaultPrevented || this.originalEvent && this.originalEvent.defaultPrevented);
    },
    preventDefault: function() {
      this._defaultPrevented = !0, this.originalEvent && this.originalEvent.preventDefault();
    }
  }), k.Event;
}
function l$(t) {
  var e = function(i, r) {
    if (r && r.indexOf(" ") > -1) {
      var n = Array.prototype.slice.call(arguments, 0);
      r.split(" ").forEach(function(a) {
        n[1] = a, t.apply(this, n);
      });
    } else
      t.apply(this, arguments);
  };
  return function(i, r) {
    if (typeof r == "object") {
      var n = Array.prototype.slice.call(arguments, 0);
      for (var a in r)
        n[1] = a, n[n.length - 1] = r[a], e.apply(this, n);
    } else
      e.apply(this, arguments);
  };
}
function Gie(t, e) {
  var i = Bie[t] || t;
  (function(r, n) {
    return r === "click" && n.localName === "a";
  })(t, e) || Le(e[i]) && (hT = t, e[i](), hT = void 0);
}
function Kie(t) {
  return function(e) {
    return e.which == null && e.type.indexOf("key") === 0;
  }(t) ? t.charCode != null ? t.charCode : t.keyCode : function(e) {
    return !e.which && e.button !== void 0 && /^(?:mouse|pointer|contextmenu|drag|drop)|click/.test(e.type);
  }(t) ? {
    1: 1,
    2: 3,
    3: 1,
    4: 2
  }[t.button] : t.which;
}
function lj(t) {
  t && (k.Event = t, k.Event.prototype = t.prototype);
}
lj(Uie(function(t, e) {
  var i, r = t instanceof k.Event || wt() && t instanceof dF.Event || ((i = t.view) === null || i === void 0 ? void 0 : i.Event) && t instanceof t.view.Event;
  r ? (this.originalEvent = t, this.type = t.type, this.currentTarget = void 0, Object.prototype.hasOwnProperty.call(t, "isTrusted") && (this.isTrusted = t.isTrusted), this.timeStamp = t.timeStamp || Date.now()) : ae(this, t), hF("which", Kie, this), t.type.indexOf("touch") === 0 && (delete e.pageX, delete e.pageY), ae(this, e), this.guid = ++aj;
}));
function hF(t, e, i) {
  Object.defineProperty(i || k.Event.prototype, t, {
    enumerable: !0,
    configurable: !0,
    get: function() {
      return this.originalEvent && e(this.originalEvent);
    },
    set: function(r) {
      Object.defineProperty(this, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
      });
    }
  });
}
Nie.forEach((t) => hF(t, (e) => e[t]));
Fie(hF);
var uj = ui(), dj = ui();
k.set = function(t) {
  uj.fire(), k.inject(t), lj(t.Event), dj.fire();
};
k.subscribeGlobal = function() {
  cF(arguments, _k(function() {
    var t = arguments;
    k.on.apply(this, t), uj.add(function() {
      var e = Array.prototype.slice.call(t, 0);
      e.splice(3, 1), k.off.apply(this, e);
    }), dj.add(function() {
      k.on.apply(this, t);
    });
  }));
};
k.forcePassiveFalseEventNames = nj;
k.passiveEventHandlersSupported = oj;
var fy = /* @__PURE__ */ new WeakMap(), mp, jie = new sF(), cj = function() {
}, Yie = function() {
}, qie = function(t) {
  jie.fire(t), mp = t;
  var e = mp.cleanData;
  mp.cleanData = function(i) {
    cj(i);
    var r = e.call(this, i);
    return Yie(i), r;
  };
};
qie({
  data: function() {
    var t = arguments[0], e = arguments[1], i = arguments[2];
    if (t) {
      var r = fy.get(t);
      return r || (r = {}, fy.set(t, r)), e === void 0 ? r : arguments.length === 2 ? r[e] : (r[e] = i, i);
    }
  },
  removeData: function(t, e) {
    if (t)
      if (e === void 0)
        fy.delete(t);
      else {
        var i = fy.get(t);
        i && delete i[e];
      }
  },
  cleanData: function(t) {
    for (var e = 0; e < t.length; e++)
      k.off(t[e]), fy.delete(t[e]);
  }
});
function dr() {
  return mp.data.apply(this, arguments);
}
function Xie(t) {
  cj = t;
}
function iI(t, e) {
  return mp.removeData.call(this, t, e);
}
function qx(t, e) {
  if (de.isElementNode(t)) {
    var i = t.getElementsByTagName("*");
    mp.cleanData(i), e && mp.cleanData([t]);
  }
}
var hj = function(t) {
  return t == null ? "" : String(t);
}, fF = function(t) {
  return hj(t).charAt(0).toUpperCase() + t.substr(1);
}, pF = function(t) {
  return hj(t).replace(/([a-z\d])([A-Z])/g, "$1 $2").split(/[\s_-]+/);
}, vF = function(t) {
  return Jr(pF(t), function(e) {
    return e.toLowerCase();
  }).join("-");
};
var Ix = function(t, e) {
  return Jr(pF(t), function(i, r) {
    return i = i.toLowerCase(), (e || r > 0) && (i = fF(i)), i;
  }).join("");
}, Qie = function(t) {
  return fF(vF(t).replace(/-/g, " "));
}, Dx = function(t) {
  return Jr(pF(t), function(e) {
    return fF(e.toLowerCase());
  }).join(" ");
}, Zie = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], bp = function(t) {
  var e = [], i, r, n = !1, a = !1;
  for (i = 0; i < t.length; i++)
    r = t.charAt(i), a = r === r.toUpperCase() && r !== "-" && r !== ")" && r !== "/" || r in Zie, r === "_" || r === "." ? (r = " ", a = !0) : i === 0 ? (r = r.toUpperCase(), a = !0) : !n && a && e.length > 0 && e.push(" "), e.push(r), n = a;
  return e.join("");
}, fT = ["", "Webkit", "Moz", "O", "Ms"], Jie = {
  "": "",
  Webkit: "-webkit-",
  Moz: "-moz-",
  O: "-o-",
  ms: "-ms-"
}, Ck = oc(function() {
  return de.createElement("dx").style;
}), ere = function(t, e) {
  t = Ix(t, !0);
  for (var i, r = 0, n = fT.length; r < n; r++) {
    var a = fT[r], o = a + t, u = Ix(o);
    if (i = e(u, a), i === void 0 && (i = e(o, a)), i !== void 0)
      break;
  }
  return i || "";
}, Np = function(t) {
  if (t in Ck())
    return t;
  var e = t;
  t = t.charAt(0).toUpperCase() + t.substr(1);
  for (var i = 1; i < fT.length; i++) {
    var r = fT[i].toLowerCase() + t;
    if (r in Ck())
      return r;
  }
  return e;
}, Fw = function(t) {
  return ere(t, function(e, i) {
    if (e in Ck())
      return Jie[i];
  });
}, tre = ["fillOpacity", "columnCount", "flexGrow", "flexShrink", "fontWeight", "lineHeight", "opacity", "zIndex", "zoom"];
var Dm = function(t, e) {
  return Di(e) && tre.indexOf(t) === -1 && (e += "px"), e;
}, fj = function(t, e, i) {
  if (t) {
    i = Di(i) ? i += "px" : i;
    for (var r = 0; r < t.length; ++r)
      t[r].style[e] = i;
  }
}, yk = function(t, e) {
  fj(t, "width", e);
}, xR = function(t, e) {
  fj(t, "height", e);
}, pj = function(t, e) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (i) {
    var r = [].slice.call(t.style);
    r.forEach((n) => {
      t.style.removeProperty(n);
    });
  }
  e.split(";").forEach((n) => {
    var a = n.split(":").map((c) => c.trim());
    if (a.length === 2) {
      var [o, u] = a;
      t.style[o] = u;
    }
  });
}, pT = Ot(), ire = ["auto", "none", "inherit", "initial"], SR = function(t, e) {
  var i = 0;
  return e.forEach(function(r) {
    i += parseFloat(t[r]) || 0;
  }), i;
}, vj = function(t, e) {
  var i = t === "width" ? "Left" : "Top", r = t === "width" ? "Right" : "Bottom";
  return {
    padding: SR(e, ["padding" + i, "padding" + r]),
    border: SR(e, ["border" + i + "Width", "border" + r + "Width"]),
    margin: SR(e, ["margin" + i, "margin" + r])
  };
}, gj = function(t) {
  var e, i = (t == null || (e = t.ownerDocument) === null || e === void 0 ? void 0 : e.defaultView) || pT;
  return i.getComputedStyle && i.getComputedStyle(t);
}, xk = function(t, e, i, r) {
  var n;
  return (e == null ? void 0 : e[i]) || ((n = t.style) === null || n === void 0 ? void 0 : n[i]) || r;
}, Kg = {
  content: 0,
  padding: 1,
  border: 2,
  margin: 3,
  "content-box": 0,
  "border-box": 2
}, u$ = {
  width: ["left", "right"],
  height: ["top", "bottom"]
};
function py(t, e, i, r) {
  var n = (o, u, c) => parseFloat(xk(o, u, c, "0")) || 0, a = i === "border" ? "-width" : "";
  return n(t, r, "".concat(i, "-").concat(u$[e][0]).concat(a)) + n(t, r, "".concat(i, "-").concat(u$[e][1]).concat(a));
}
var rre = function(t, e, i) {
  var r = e === "width" ? "offsetWidth" : "offsetHeight", n = gj(t), a = xk(t, n, e);
  (a === "" || a === "auto") && (a = t[r]), a = parseFloat(a) || 0;
  var o = xk(t, n, "boxSizing", "content-box"), u = i || o, c = Kg[u], p = Kg[o];
  if (c === void 0 || p === void 0)
    throw new Error();
  if (p === c)
    return a;
  var v = Math.sign(c - p), _ = !1, y = !1, b = !1, I = !1;
  v === 1 && (c += 1, p += 1);
  for (var A = p; A !== c; A += v)
    switch (A) {
      case Kg.content:
        break;
      case Kg.padding:
        _ = v * py(t, e, "padding", n);
        break;
      case Kg.border:
        y = v * py(t, e, "border", n);
        break;
      case Kg.margin:
        b = v * py(t, e, "margin", n);
    }
  if (_ || y) {
    var L = (_ === !1 ? v * py(t, e, "padding", n) : _) + (y === !1 ? v * py(t, e, "border", n) : y);
    I = v * Math.max(0, Math.floor(t[r] - a - v * L)) || 0;
  }
  return a + b + _ + y + I;
}, nre = function(t) {
  return Or(t) ? t.innerHeight : t.offsetHeight;
}, are = function(t, e, i) {
  return t.indexOf("px") > 0 ? t = parseInt(t.replace("px", "")) : t.indexOf("%") > 0 ? t = parseInt(t.replace("%", "")) * nre(e) / 100 : isNaN(t) ? t.indexOf("vh") > 0 ? t = pT.innerHeight / 100 * parseInt(t.replace("vh", "")) : i && t.indexOf("em") > 0 && (t = parseFloat(t.replace("em", "")) * parseFloat(pT.getComputedStyle(i).fontSize)) : t = parseInt(t), t;
}, mj = function(t, e, i) {
  if (!t)
    return null;
  if (ire.indexOf(t) > -1)
    return e ? null : t;
  if (ht(t) && (t = are(t, i)), Di(t))
    return Math.max(0, t + e);
  var r = e < 0 ? " - " : " ";
  return "calc(" + t + r + Math.abs(e) + "px)";
}, ore = function(t, e, i) {
  var r = mj(t, e, i);
  return r !== null ? r : "none";
}, sre = function(t, e, i) {
  var r = mj(t, e, i);
  return r !== null ? r : 0;
}, ER = function(t, e) {
  if (!t)
    return 0;
  var i = vj("height", pT.getComputedStyle(t));
  return i.padding + i.border + (e ? i.margin : 0);
}, d$ = function(t) {
  if (t) {
    var e = t.getBoundingClientRect();
    if (e.height)
      return e.height;
  }
  return 0;
}, Fu = {
  getWidth: function() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return ks("width", ...e);
  },
  setWidth: function() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return ks("width", ...e);
  },
  getHeight: function() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return ks("height", ...e);
  },
  setHeight: function() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return ks("height", ...e);
  },
  getOuterWidth: function() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return ks("outerWidth", ...e);
  },
  setOuterWidth: function() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return ks("outerWidth", ...e);
  },
  getOuterHeight: function() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return ks("outerHeight", ...e);
  },
  setOuterHeight: function() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return ks("outerHeight", ...e);
  },
  getInnerWidth: function() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return ks("innerWidth", ...e);
  },
  setInnerWidth: function() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return ks("innerWidth", ...e);
  },
  getInnerHeight: function() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return ks("innerHeight", ...e);
  },
  setInnerHeight: function() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return ks("innerHeight", ...e);
  }
};
function ks(t, e, i) {
  return arguments.length === 2 ? f$(e, t) : f$(e, t, i);
}
var mt = (t) => Fu.getWidth(t), gF = (t, e) => Fu.setWidth(t, e), Pt = (t) => Fu.getHeight(t), Dh = (t, e) => Fu.setHeight(t, e), oi = (t, e) => Fu.getOuterWidth(t, e || !1), c$ = (t, e) => Fu.setOuterWidth(t, e), jt = (t, e) => Fu.getOuterHeight(t, e || !1), h$ = (t, e) => Fu.setOuterHeight(t, e), Sk = (t) => Fu.getInnerWidth(t);
var vT = (t) => Fu.getInnerHeight(t);
var f$ = function t(e, i, r) {
  var n = i.toLowerCase().indexOf("width") >= 0 ? "Width" : "Height", a = n.toLowerCase(), o = i.indexOf("outer") === 0, u = i.indexOf("inner") === 0, c = arguments.length === 2 || typeof r == "boolean";
  if (hs(e)) {
    if (e.length > 1 && !c) {
      for (var p = 0; p < e.length; p++)
        t(e[p], i, r);
      return;
    }
    e = e[0];
  }
  if (e) {
    if (Or(e))
      return o ? e["inner" + n] : de.getDocumentElement()["client" + n];
    if (de.isDocument(e)) {
      var v = de.getDocumentElement(), _ = de.getBody();
      return Math.max(_["scroll" + n], _["offset" + n], v["scroll" + n], v["offset" + n], v["client" + n]);
    }
    if (c) {
      var y = "content";
      return o && (y = r ? "margin" : "border"), u && (y = "padding"), rre(e, a, y);
    }
    if (Di(r)) {
      var b = gj(e), I = vj(a, b), A = b.boxSizing === "border-box";
      r = Number(r), o ? r -= A ? 0 : I.border + I.padding : u ? r += A ? I.border : -I.padding : A && (r += I.border + I.padding);
    }
    return r += Di(r) ? "px" : "", de.setStyle(e, a, r), null;
  }
}, _j = (t) => Or(t) ? t : t.defaultView, Ek = (t) => {
  if (!t.getClientRects().length)
    return {
      top: 0,
      left: 0
    };
  var e = t.getBoundingClientRect(), i = _j(t.ownerDocument), r = t.ownerDocument.documentElement;
  return {
    top: e.top + i.pageYOffset - r.clientTop,
    left: e.left + i.pageXOffset - r.clientLeft
  };
}, Cj = /<([a-z][^/\0>\x20\t\r\n\f]+)/i, Tu = {
  default: {
    tagsCount: 0,
    startTags: "",
    endTags: ""
  },
  thead: {
    tagsCount: 1,
    startTags: "<table>",
    endTags: "</table>"
  },
  td: {
    tagsCount: 3,
    startTags: "<table><tbody><tr>",
    endTags: "</tr></tbody></table>"
  },
  col: {
    tagsCount: 2,
    startTags: "<table><colgroup>",
    endTags: "</colgroup></table>"
  },
  tr: {
    tagsCount: 2,
    startTags: "<table><tbody>",
    endTags: "</tbody></table>"
  }
};
Tu.tbody = Tu.colgroup = Tu.caption = Tu.tfoot = Tu.thead;
Tu.th = Tu.td;
var mF = function(t) {
  if (typeof t != "string")
    return null;
  var e = de.createDocumentFragment(), i = e.appendChild(de.createElement("div")), r = Cj.exec(t), n = r && r[1].toLowerCase(), a = Tu[n] || Tu.default;
  i.innerHTML = a.startTags + t + a.endTags;
  for (var o = 0; o < a.tagsCount; o++)
    i = i.lastChild;
  return [...i.childNodes];
}, lre = function(t) {
  var e = Cj.exec(t);
  return e && e[1] in Tu;
}, ure = Ot(), ai, Dt = function(t, e) {
  return t ? typeof t == "string" ? t === "body" ? (this[0] = e ? e.body : de.getBody(), this.length = 1, this) : (e = e || de.getDocument(), t[0] === "<" ? (this[0] = de.createElement(t.slice(1, -1), e), this.length = 1, this) : ([].push.apply(this, de.querySelectorAll(e, t)), this)) : de.isNode(t) || Or(t) ? (this[0] = t, this.length = 1, this) : Array.isArray(t) ? ([].push.apply(this, t), this) : ai(t.toArray ? t.toArray() : [t]) : (this.length = 0, this);
};
ai = function(t, e) {
  return new Dt(t, e);
};
ai.fn = {
  dxRenderer: !0
};
Dt.prototype = ai.fn;
var Hm = function(t, e) {
  for (var i = 0; i < this.length; i++) {
    var r = ai(this[i]);
    r[t].apply(r, e);
  }
  return this;
}, bk = function(t, e, i) {
  i != null && i !== !1 ? de.setAttribute(t, e, i) : de.removeAttribute(t, e);
};
Dt.prototype.show = function() {
  return this.toggle(!0);
};
Dt.prototype.hide = function() {
  return this.toggle(!1);
};
Dt.prototype.toggle = function(t) {
  return this[0] && this.toggleClass("dx-state-invisible", !t), this;
};
Dt.prototype.attr = function(t, e) {
  if (this.length > 1 && arguments.length > 1)
    return Hm.call(this, "attr", arguments);
  if (!this[0])
    return ct(t) || e !== void 0 ? this : void 0;
  if (!this[0].getAttribute)
    return this.prop(t, e);
  if (typeof t == "string" && arguments.length === 1) {
    var i = this[0].getAttribute(t);
    return i ?? void 0;
  } else if ($t(t))
    for (var r in t)
      this.attr(r, t[r]);
  else
    bk(this[0], t, e);
  return this;
};
Dt.prototype.removeAttr = function(t) {
  return this[0] && de.removeAttribute(this[0], t), this;
};
Dt.prototype.prop = function(t, e) {
  if (!this[0])
    return this;
  if (typeof t == "string" && arguments.length === 1)
    return this[0][t];
  if ($t(t))
    for (var i in t)
      this.prop(i, t[i]);
  else
    de.setProperty(this[0], t, e);
  return this;
};
Dt.prototype.addClass = function(t) {
  return this.toggleClass(t, !0);
};
Dt.prototype.removeClass = function(t) {
  return this.toggleClass(t, !1);
};
Dt.prototype.hasClass = function(t) {
  if (!this[0] || this[0].className === void 0)
    return !1;
  for (var e = t.split(" "), i = 0; i < e.length; i++)
    if (this[0].classList) {
      if (this[0].classList.contains(e[i]))
        return !0;
    } else {
      var r = ht(this[0].className) ? this[0].className : de.getAttribute(this[0], "class");
      if ((r || "").split(" ").indexOf(e[i]) >= 0)
        return !0;
    }
  return !1;
};
Dt.prototype.toggleClass = function(t, e) {
  if (this.length > 1)
    return Hm.call(this, "toggleClass", arguments);
  if (!this[0] || !t)
    return this;
  e = e === void 0 ? !this.hasClass(t) : e;
  for (var i = t.split(" "), r = 0; r < i.length; r++)
    de.setClass(this[0], i[r], e);
  return this;
};
Dt.prototype.html = function(t) {
  return arguments.length ? (this.empty(), typeof t == "string" && !lre(t) || typeof t == "number" ? (this[0].innerHTML = t, this) : this.append(mF(t))) : this[0].innerHTML;
};
var yj = function(t, e) {
  if (!(!this[0] || !t)) {
    typeof t == "string" ? t = mF(t) : t.nodeType ? t = [t] : Di(t) && (t = [de.createTextNode(t)]);
    for (var i = 0; i < t.length; i++) {
      var r = t[i], n = this[0], a = n.tagName === "TABLE" && r.tagName === "TR";
      a && n.tBodies && n.tBodies.length && (n = n.tBodies[0]), de.insertElement(n, r.nodeType ? r : r[0], e);
    }
  }
}, p$ = function(t, e) {
  if (!(!this[0] || !this[0].style) && !(e === null || typeof e == "number" && isNaN(e))) {
    t = Np(t);
    for (var i = 0; i < this.length; i++)
      this[i].style[t] = Dm(t, e);
  }
};
Dt.prototype.css = function(t, e) {
  if (ht(t))
    if (arguments.length === 2)
      p$.call(this, t, e);
    else {
      if (!this[0])
        return;
      t = Np(t);
      var i = ure.getComputedStyle(this[0])[t] || this[0].style[t];
      return Di(i) ? i.toString() : i;
    }
  else if ($t(t))
    for (var r in t)
      p$.call(this, r, t[r]);
  return this;
};
Dt.prototype.prepend = function(t) {
  if (arguments.length > 1) {
    for (var e = 0; e < arguments.length; e++)
      this.prepend(arguments[e]);
    return this;
  }
  return yj.apply(this, [t, this[0].firstChild]), this;
};
Dt.prototype.append = function(t) {
  if (arguments.length > 1) {
    for (var e = 0; e < arguments.length; e++)
      this.append(arguments[e]);
    return this;
  }
  return yj.apply(this, [t]), this;
};
Dt.prototype.prependTo = function(t) {
  if (this.length > 1) {
    for (var e = this.length - 1; e >= 0; e--)
      ai(this[e]).prependTo(t);
    return this;
  }
  return t = ai(t), t[0] && de.insertElement(t[0], this[0], t[0].firstChild), this;
};
Dt.prototype.appendTo = function(t) {
  return this.length > 1 ? Hm.call(this, "appendTo", arguments) : (de.insertElement(ai(t)[0], this[0]), this);
};
Dt.prototype.insertBefore = function(t) {
  return t && t[0] && de.insertElement(t[0].parentNode, this[0], t[0]), this;
};
Dt.prototype.insertAfter = function(t) {
  return t && t[0] && de.insertElement(t[0].parentNode, this[0], t[0].nextSibling), this;
};
Dt.prototype.before = function(t) {
  return this[0] && de.insertElement(this[0].parentNode, t[0], this[0]), this;
};
Dt.prototype.after = function(t) {
  return this[0] && de.insertElement(this[0].parentNode, t[0], this[0].nextSibling), this;
};
Dt.prototype.wrap = function(t) {
  if (this[0]) {
    var e = ai(t);
    e.insertBefore(this), e.append(this);
  }
  return this;
};
Dt.prototype.wrapInner = function(t) {
  var e = this.contents();
  return e.length ? e.wrap(t) : this.append(t), this;
};
Dt.prototype.replaceWith = function(t) {
  if (t && t[0])
    return t.is(this) ? this : (t.insertBefore(this), this.remove(), t);
};
Dt.prototype.remove = function() {
  return this.length > 1 ? Hm.call(this, "remove", arguments) : (qx(this[0], !0), de.removeElement(this[0]), this);
};
Dt.prototype.detach = function() {
  return this.length > 1 ? Hm.call(this, "detach", arguments) : (de.removeElement(this[0]), this);
};
Dt.prototype.empty = function() {
  return this.length > 1 ? Hm.call(this, "empty", arguments) : (qx(this[0]), de.setText(this[0], ""), this);
};
Dt.prototype.clone = function() {
  for (var t = [], e = 0; e < this.length; e++)
    t.push(this[e].cloneNode(!0));
  return ai(t);
};
Dt.prototype.text = function(t) {
  if (!arguments.length) {
    for (var e = "", i = 0; i < this.length; i++)
      e += this[i] && this[i].textContent || "";
    return e;
  }
  var r = Le(t) ? t() : t;
  return qx(this[0], !1), de.setText(this[0], R(r) ? r : ""), this;
};
Dt.prototype.val = function(t) {
  return arguments.length === 1 ? this.prop("value", R(t) ? t : "") : this.prop("value");
};
Dt.prototype.contents = function() {
  if (!this[0])
    return ai();
  var t = [];
  return t.push.apply(t, this[0].childNodes), ai(t);
};
Dt.prototype.find = function(t) {
  var e = ai();
  if (!t)
    return e;
  var i = [], r;
  if (typeof t == "string")
    for (t = t.trim(), r = 0; r < this.length; r++) {
      var n = this[r];
      if (de.isElementNode(n)) {
        var a = n.getAttribute("id"), o = a || "dx-query-children";
        a || bk(n, "id", o), o = "[id='" + o + "'] ";
        var u = o + t.replace(/([^\\])(,)/g, "$1, " + o);
        i.push.apply(i, de.querySelectorAll(n, u)), bk(n, "id", a);
      } else
        (de.isDocument(n) || de.isDocumentFragment(n)) && i.push.apply(i, de.querySelectorAll(n, t));
    }
  else
    for (r = 0; r < this.length; r++)
      t = de.isNode(t) ? t : t[0], this[r] !== t && this[r].contains(t) && i.push(t);
  return e.add(i);
};
var v$ = function(t, e) {
  var i;
  return e = (i = e.host) !== null && i !== void 0 ? i : e, e.nodeType ? !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length) : !0;
};
Dt.prototype.filter = function(t) {
  if (!t)
    return ai();
  if (t === ":visible")
    return this.filter(v$);
  if (t === ":hidden")
    return this.filter(function(a, o) {
      return !v$(a, o);
    });
  for (var e = [], i = 0; i < this.length; i++) {
    var r = this[i];
    if (de.isElementNode(r) && cs(t) === "string")
      de.elementMatches(r, t) && e.push(r);
    else if (de.isNode(t) || Or(t))
      t === r && e.push(r);
    else if (Le(t))
      t.call(r, i, r) && e.push(r);
    else
      for (var n = 0; n < t.length; n++)
        t[n] === r && e.push(r);
  }
  return ai(e);
};
Dt.prototype.not = function(t) {
  for (var e = [], i = this.filter(t).toArray(), r = 0; r < this.length; r++)
    i.indexOf(this[r]) === -1 && e.push(this[r]);
  return ai(e);
};
Dt.prototype.is = function(t) {
  return !!this.filter(t).length;
};
Dt.prototype.children = function(t) {
  for (var e = [], i = 0; i < this.length; i++)
    for (var r = this[i] ? this[i].childNodes : [], n = 0; n < r.length; n++)
      de.isElementNode(r[n]) && e.push(r[n]);
  return e = ai(e), t ? e.filter(t) : e;
};
Dt.prototype.siblings = function() {
  var t = this[0];
  if (!t || !t.parentNode)
    return ai();
  for (var e = [], i = t.parentNode.childNodes || [], r = 0; r < i.length; r++) {
    var n = i[r];
    de.isElementNode(n) && n !== t && e.push(n);
  }
  return ai(e);
};
Dt.prototype.each = function(t) {
  for (var e = 0; e < this.length && t.call(this[e], e, this[e]) !== !1; e++)
    ;
};
Dt.prototype.index = function(t) {
  return t ? (t = ai(t), this.toArray().indexOf(t[0])) : this.parent().children().index(this);
};
Dt.prototype.get = function(t) {
  return this[t < 0 ? this.length + t : t];
};
Dt.prototype.eq = function(t) {
  return t = t < 0 ? this.length + t : t, ai(this[t]);
};
Dt.prototype.first = function() {
  return this.eq(0);
};
Dt.prototype.last = function() {
  return this.eq(-1);
};
Dt.prototype.select = function() {
  for (var t = 0; t < this.length; t += 1)
    this[t].select && this[t].select();
  return this;
};
Dt.prototype.parent = function(t) {
  if (!this[0])
    return ai();
  var e = ai(this[0].parentNode);
  return !t || e.is(t) ? e : ai();
};
Dt.prototype.parents = function(t) {
  for (var e = [], i = this.parent(); i && i[0] && !de.isDocument(i[0]); )
    de.isElementNode(i[0]) && (!t || i.is(t)) && e.push(i.get(0)), i = i.parent();
  return ai(e);
};
Dt.prototype.closest = function(t) {
  if (this.is(t))
    return this;
  for (var e = this.parent(); e && e.length; ) {
    if (e.is(t))
      return e;
    e = e.parent();
  }
  return ai();
};
Dt.prototype.next = function(t) {
  if (!this[0])
    return ai();
  var e = ai(this[0].nextSibling);
  if (!arguments.length)
    return e;
  for (; e && e.length; ) {
    if (e.is(t))
      return e;
    e = e.next();
  }
  return ai();
};
Dt.prototype.prev = function() {
  return this[0] ? ai(this[0].previousSibling) : ai();
};
Dt.prototype.add = function(t) {
  for (var e = ai(t), i = this.toArray(), r = 0; r < e.length; r++) {
    var n = e[r];
    i.indexOf(n) === -1 && i.push(n);
  }
  return ai(i);
};
var _F = [];
Dt.prototype.splice = function() {
  return ai(_F.splice.apply(this, arguments));
};
Dt.prototype.slice = function() {
  return ai(_F.slice.apply(this, arguments));
};
Dt.prototype.toArray = function() {
  return _F.slice.call(this);
};
Dt.prototype.offset = function() {
  if (this[0])
    return Ek(this[0]);
};
Dt.prototype.offsetParent = function() {
  if (!this[0])
    return ai();
  for (var t = ai(this[0].offsetParent); t[0] && t.css("position") === "static"; )
    t = ai(t[0].offsetParent);
  return t = t[0] ? t : ai(de.getDocumentElement()), t;
};
Dt.prototype.position = function() {
  if (this[0]) {
    var t, e = parseFloat(this.css("marginTop")), i = parseFloat(this.css("marginLeft"));
    if (this.css("position") === "fixed")
      return t = this[0].getBoundingClientRect(), {
        top: t.top - e,
        left: t.left - i
      };
    t = this.offset();
    var r = this.offsetParent(), n = {
      top: 0,
      left: 0
    };
    return r[0].nodeName !== "HTML" && (n = r.offset()), n = {
      top: n.top + parseFloat(r.css("borderTopWidth")),
      left: n.left + parseFloat(r.css("borderLeftWidth"))
    }, {
      top: t.top - n.top - e,
      left: t.left - n.left - i
    };
  }
};
[{
  name: "scrollLeft",
  offsetProp: "pageXOffset",
  scrollWindow: function(t, e) {
    t.scrollTo(e, t.pageYOffset);
  }
}, {
  name: "scrollTop",
  offsetProp: "pageYOffset",
  scrollWindow: function(t, e) {
    t.scrollTo(t.pageXOffset, e);
  }
}].forEach(function(t) {
  var e = t.name;
  Dt.prototype[e] = function(i) {
    if (this[0]) {
      var r = _j(this[0]);
      return i === void 0 ? r ? r[t.offsetProp] : this[0][e] : (r ? t.scrollWindow(r, i) : this[0][e] = i, this);
    }
  };
});
Dt.prototype.data = function(t, e) {
  if (this[0])
    return arguments.length < 2 ? dr.call(ai, this[0], t) : (dr.call(ai, this[0], t, e), this);
};
Dt.prototype.removeData = function(t) {
  return this[0] && iI(this[0], t), this;
};
var xj = function() {
  return ai.apply(this, arguments);
};
Object.defineProperty(xj, "fn", {
  enumerable: !0,
  configurable: !0,
  get: function() {
    return ai.fn;
  },
  set: function(t) {
    ai.fn = t;
  }
});
const dre = {
  set: function(t) {
    ai = t;
  },
  get: function() {
    return xj;
  }
}, E = dre.get(), Sj = new sF();
var Ys = function(t, e) {
  var i = {};
  "noBubble" in e && (i.noBubble = e.noBubble), "bindType" in e && (i.bindType = e.bindType), "delegateType" in e && (i.delegateType = e.delegateType), N(["setup", "teardown", "add", "remove", "trigger", "handle", "_default", "dispose"], function(r, n) {
    e[n] && (i[n] = function() {
      var a = [].slice.call(arguments);
      return a.unshift(this), e[n].apply(e, a);
    });
  }), lF.fire(t, i);
};
Ys.callbacks = lF;
var fo = "dxremove", wk = "dxRemoveEvent";
Xie(function(t) {
  t = [].slice.call(t);
  for (var e = 0; e < t.length; e++) {
    var i = E(t[e]);
    i.prop(wk) && (i[0][wk] = null, k.triggerHandler(i, fo));
  }
});
Ys(fo, {
  noBubble: !0,
  setup: function(t) {
    E(t).prop(wk, !0);
  }
});
var bR = "dxComponents", cre = "dxPrivateComponent", Lb = /* @__PURE__ */ new WeakMap(), hre = 0, Xx = function(t, e) {
  if (R(e)) {
    Lb.set(t, e);
    return;
  }
  if (!Lb.has(t)) {
    var i = cre + hre++;
    return Lb.set(t, i), i;
  }
  return Lb.get(t);
};
function Ej(t, e, i) {
  var r = dr(t.get(0)), n = Xx(e.constructor);
  r[n] = e, i && k.one(t, fo, function() {
    i.call(e);
  }), r[bR] || (r[bR] = []), r[bR].push(n);
}
function bj(t, e) {
  var i = Xx(e);
  return dr(t.get(0), i);
}
var ti = function(t, e, i) {
  i ? e[t] = i : i = e, Xx(i, t), Sj.fire(t, i);
}, fre = function(t, e) {
  E.fn[t] = function(i) {
    var r = typeof i == "string", n;
    if (r) {
      var a = i, o = [].slice.call(arguments).slice(1);
      this.each(function() {
        var u = e.getInstance(this);
        if (!u)
          throw bi.Error("E0009", t);
        var c = u[a], p = c.apply(u, o);
        n === void 0 && (n = p);
      });
    } else
      this.each(function() {
        var u = e.getInstance(this);
        u ? u.option(i) : new e(this, i);
      }), n = this;
    return n;
  };
};
Sj.add(fre);
class Hp {
  constructor(e) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this._events = {}, this._owner = e, this._options = i;
  }
  static create(e, i) {
    return i ? Le(i) ? i(e) : i : new Hp(e);
  }
  hasEvent(e) {
    var i = this._events[e];
    return i ? i.has() : !1;
  }
  fireEvent(e, i) {
    var r = this._events[e];
    return r && r.fireWith(this._owner, i), this._owner;
  }
  on(e, i) {
    if ($t(e))
      N(e, (a, o) => {
        this.on(a, o);
      });
    else {
      var r = this._events[e];
      r || (r = ui({
        syncStrategy: this._options.syncStrategy
      }), this._events[e] = r);
      var n = r.originalAdd || r.add;
      n.call(r, i);
    }
  }
  off(e, i) {
    var r = this._events[e];
    r && (Le(i) ? r.remove(i) : r.empty());
  }
  dispose() {
    N(this._events, (e, i) => {
      i.empty();
    });
  }
}
var Am = function(t) {
  return t === 0 ? 0 : t / Math.abs(t);
}, ma = function(t, e, i) {
  var r = !e && e !== 0, n = !i && i !== 0;
  return r && (e = n ? t : Math.min(t, i)), n && (i = r ? t : Math.max(t, e)), Math.min(Math.max(t, e), i);
}, Ud = function(t, e, i) {
  return t >= e && t <= i;
};
function g$(t) {
  return Math.abs(parseInt(t.toExponential().split("e")[1]));
}
function pre(t) {
  var e = t.toExponential().split("e"), i = parseFloat(e[0]), r = parseInt(e[1]);
  return {
    exponent: r,
    mantissa: i
  };
}
function wj(t, e) {
  var i = pre(t);
  return parseFloat("".concat(i.mantissa, "e").concat(i.exponent + e));
}
function vre() {
  return 3e-4.toPrecision(3) !== "0.000300";
}
function Tj(t, e) {
  var i = gre(e || 0) + 2, r = t.toString().split("."), n = t, a = Math.abs(t), o, u = QH(t), c = a > 1 ? 10 : 0;
  return r.length === 1 ? t : (u || (QH(e) && (i = r[0].length + g$(e)), t = a, t = t - Math.floor(t) + c), i = vre() && g$(t) > 6 || i > 7 ? 15 : 7, !u && (o = parseFloat(t.toPrecision(i)).toString().split("."), o[0] === c.toString()) ? parseFloat(r[0] + "." + o[1]) : parseFloat(n.toPrecision(i)));
}
function gre(t) {
  var e = t.toString();
  if (e.indexOf(".") < 0)
    return 0;
  var i = e.split("."), r = i[1].indexOf("e");
  return r >= 0 ? r : i[1].length;
}
var mre = 10;
function _re(t) {
  var e = Am(t);
  return e * Math.round(Math.abs(t));
}
function Cre(t, e) {
  var i = Math.pow(mre, e), r = wj(t, e);
  return _re(r) / i;
}
function Ij(t, e) {
  var i = e || 0, r = i > 0 ? Cre(...arguments) : t;
  return r.toFixed(i);
}
var yre = {
  thousandsSeparator: ",",
  decimalSeparator: "."
}, m$ = "'", xre = 15, Sre = 2;
function Ere(t) {
  return t.split(",").slice(1).map(function(e) {
    var i = 0;
    return e.split("").filter(function(r, n) {
      i += r === "'";
      var a = r === "#" || r === "0", o = i % 2;
      return a && !o;
    }).length;
  });
}
function bre(t) {
  var e = t.split(";");
  return e.length === 1 && e.push("-" + e[0]), e;
}
function wR(t) {
  return t.toString().split("").reverse().join("");
}
function wre(t) {
  return t.indexOf("%") !== -1 && !t.match(/'[^']*%[^']*'/g);
}
function Dj(t) {
  return t.replace(/'.+'/g, "");
}
function _$(t) {
  if (!t)
    return 0;
  var e = Dj(t);
  return e.length - e.replace(/[#]/g, "").length;
}
function C$(t) {
  if (!t)
    return 0;
  var e = Dj(t);
  return e.length - e.replace(/[0]/g, "").length;
}
function y$(t, e, i) {
  if (!t)
    return "";
  for (t.length > i && (t = t.substr(0, i)); t.length > e && t.slice(-1) === "0"; )
    t = t.substr(0, t.length - 1);
  for (; t.length < e; )
    t += "0";
  return t;
}
function Tre(t, e, i) {
  if (!e.length)
    return t;
  for (var r = [], n = 0; t; ) {
    var a = e[n];
    if (!a)
      break;
    r.push(t.slice(0, a)), t = t.slice(a), n < e.length - 1 && n++;
  }
  return r.join(i);
}
function x$(t, e) {
  return t.split(m$).map(function(i, r) {
    var n = r % 2;
    return !i && n ? m$ : n ? i : i.replace(/[,#0]+/, e);
  }).join("");
}
function Ire(t) {
  for (var e = !1, i = 0; i < t.length; i++)
    if (t[i] === "'" && (e = !e), t[i] === "." && !e)
      return i;
  return t.length;
}
function Dre(t, e) {
  return e = e || yre, function(i) {
    if (typeof i != "number" || isNaN(i))
      return "";
    var r = bre(t), n = 1 / i === 1 / 0, a = i > 0 || n, o = r[a ? 0 : 1], u = Ire(o), c = [o.substr(0, u), o.substr(u + 1)], p = C$(c[1]), v = p + _$(c[1]);
    wre(o) && (i = wj(i, Sre)), a || (i = -i);
    var _ = C$(c[0]), y = _$(c[0]) || e.unlimitedIntegerDigits ? void 0 : _, b = Math.floor(i).toString().length, I = ma(v, 0, xre - b), A = Ere(c[0]).reverse(), L = Ij(i, I < 0 ? 0 : I).split("."), B = y$(wR(L[0]), _, y), $ = y$(L[1], p, v);
    B = Tre(B, A, e.thousandsSeparator);
    var K = wR(x$(wR(c[0]), B)), te = v ? x$(c[1], $) : "", z = K + (te.match(/\d/) ? e.decimalSeparator : "") + te;
    return z;
  };
}
function lx(t, e, i) {
  var r = (e ? 0.01 : 1) * parseFloat(t) || 0;
  return i ? -r : r;
}
function S$(t, e, i, r) {
  var n = t, a, o, u;
  do
    u && (a = o.length === u.length ? "0" : "1", t = r ? a + t : t + a), o = u || e(lx(n, i)), n = r ? "1" + n : n + "1", u = e(lx(n, i));
  while (o !== u && (r ? o.length === u.length : o.length <= u.length));
  if (r && u.length > o.length) {
    var c = e(12345).indexOf("12345") === -1;
    do
      t = "1" + t;
    while (c && lx(t, i) < 1e5);
  }
  return t;
}
function E$(t, e, i, r) {
  var n = e(lx(t, i, r)), a = t.split("."), o = a[0] + ".3" + a[1].slice(1), u = lx(o, i, r), c = e(u).indexOf("3") - 1;
  return n = n.replace(/(\d)\D(\d)/g, "$1,$2"), c >= 0 && (n = n.slice(0, c) + "." + n.slice(c + 1)), n = n.replace(/1+/, "1").replace(/1/g, "#"), i || (n = n.replace(/%/g, "'%'")), n;
}
function Are(t) {
  var e = ".", i = t(1).indexOf("100") >= 0;
  e = S$(e, t, i, !0), e = S$(e, t, i, !1);
  var r = E$(e, t, i, !1), n = E$(e, t, i, !0);
  return n === "-" + r ? r : r + ";" + n;
}
const Ore = {
  _formatNumberCore: function(t, e, i) {
    if (e === "currency") {
      i.precision = i.precision || 0;
      var r = this.format(t, P({}, i, {
        type: "fixedpoint"
      })), n = this.getCurrencySymbol().symbol.replace(/\$/g, "$$$$");
      return r = r.replace(/^(\D*)(\d.*)/, "$1" + n + "$2"), r;
    }
    return this.callBase.apply(this, arguments);
  },
  getCurrencySymbol: function() {
    return {
      symbol: "$"
    };
  },
  getOpenXmlCurrencyFormat: function() {
    return "$#,##0{0}_);\\($#,##0{0}\\)";
  }
}, Rre = {
  "en-150": "en-001",
  "en-AG": "en-001",
  "en-AI": "en-001",
  "en-AU": "en-001",
  "en-BB": "en-001",
  "en-BM": "en-001",
  "en-BS": "en-001",
  "en-BW": "en-001",
  "en-BZ": "en-001",
  "en-CC": "en-001",
  "en-CK": "en-001",
  "en-CM": "en-001",
  "en-CX": "en-001",
  "en-CY": "en-001",
  "en-DG": "en-001",
  "en-DM": "en-001",
  "en-ER": "en-001",
  "en-FJ": "en-001",
  "en-FK": "en-001",
  "en-FM": "en-001",
  "en-GB": "en-001",
  "en-GD": "en-001",
  "en-GG": "en-001",
  "en-GH": "en-001",
  "en-GI": "en-001",
  "en-GM": "en-001",
  "en-GY": "en-001",
  "en-HK": "en-001",
  "en-IE": "en-001",
  "en-IL": "en-001",
  "en-IM": "en-001",
  "en-IN": "en-001",
  "en-IO": "en-001",
  "en-JE": "en-001",
  "en-JM": "en-001",
  "en-KE": "en-001",
  "en-KI": "en-001",
  "en-KN": "en-001",
  "en-KY": "en-001",
  "en-LC": "en-001",
  "en-LR": "en-001",
  "en-LS": "en-001",
  "en-MG": "en-001",
  "en-MO": "en-001",
  "en-MS": "en-001",
  "en-MT": "en-001",
  "en-MU": "en-001",
  "en-MV": "en-001",
  "en-MW": "en-001",
  "en-MY": "en-001",
  "en-NA": "en-001",
  "en-NF": "en-001",
  "en-NG": "en-001",
  "en-NR": "en-001",
  "en-NU": "en-001",
  "en-NZ": "en-001",
  "en-PG": "en-001",
  "en-PK": "en-001",
  "en-PN": "en-001",
  "en-PW": "en-001",
  "en-RW": "en-001",
  "en-SB": "en-001",
  "en-SC": "en-001",
  "en-SD": "en-001",
  "en-SG": "en-001",
  "en-SH": "en-001",
  "en-SL": "en-001",
  "en-SS": "en-001",
  "en-SX": "en-001",
  "en-SZ": "en-001",
  "en-TC": "en-001",
  "en-TK": "en-001",
  "en-TO": "en-001",
  "en-TT": "en-001",
  "en-TV": "en-001",
  "en-TZ": "en-001",
  "en-UG": "en-001",
  "en-VC": "en-001",
  "en-VG": "en-001",
  "en-VU": "en-001",
  "en-WS": "en-001",
  "en-ZA": "en-001",
  "en-ZM": "en-001",
  "en-ZW": "en-001",
  "en-AT": "en-150",
  "en-BE": "en-150",
  "en-CH": "en-150",
  "en-DE": "en-150",
  "en-DK": "en-150",
  "en-FI": "en-150",
  "en-NL": "en-150",
  "en-SE": "en-150",
  "en-SI": "en-150",
  "hi-Latn": "en-IN",
  "es-AR": "es-419",
  "es-BO": "es-419",
  "es-BR": "es-419",
  "es-BZ": "es-419",
  "es-CL": "es-419",
  "es-CO": "es-419",
  "es-CR": "es-419",
  "es-CU": "es-419",
  "es-DO": "es-419",
  "es-EC": "es-419",
  "es-GT": "es-419",
  "es-HN": "es-419",
  "es-MX": "es-419",
  "es-NI": "es-419",
  "es-PA": "es-419",
  "es-PE": "es-419",
  "es-PR": "es-419",
  "es-PY": "es-419",
  "es-SV": "es-419",
  "es-US": "es-419",
  "es-UY": "es-419",
  "es-VE": "es-419",
  nb: "no",
  nn: "no",
  "pt-AO": "pt-PT",
  "pt-CH": "pt-PT",
  "pt-CV": "pt-PT",
  "pt-FR": "pt-PT",
  "pt-GQ": "pt-PT",
  "pt-GW": "pt-PT",
  "pt-LU": "pt-PT",
  "pt-MO": "pt-PT",
  "pt-MZ": "pt-PT",
  "pt-ST": "pt-PT",
  "pt-TL": "pt-PT",
  "az-Arab": "und",
  "az-Cyrl": "und",
  "bal-Latn": "und",
  "blt-Latn": "und",
  "bm-Nkoo": "und",
  "bs-Cyrl": "und",
  "byn-Latn": "und",
  "cu-Glag": "und",
  "dje-Arab": "und",
  "dyo-Arab": "und",
  "en-Dsrt": "und",
  "en-Shaw": "und",
  "ff-Adlm": "und",
  "ff-Arab": "und",
  "ha-Arab": "und",
  "iu-Latn": "und",
  "kk-Arab": "und",
  "ks-Deva": "und",
  "ku-Arab": "und",
  "ky-Arab": "und",
  "ky-Latn": "und",
  "ml-Arab": "und",
  "mn-Mong": "und",
  "mni-Mtei": "und",
  "ms-Arab": "und",
  "pa-Arab": "und",
  "sat-Deva": "und",
  "sd-Deva": "und",
  "sd-Khoj": "und",
  "sd-Sind": "und",
  "shi-Latn": "und",
  "so-Arab": "und",
  "sr-Latn": "und",
  "sw-Arab": "und",
  "tg-Arab": "und",
  "ug-Cyrl": "und",
  "uz-Arab": "und",
  "uz-Cyrl": "und",
  "vai-Latn": "und",
  "wo-Arab": "und",
  "yo-Arab": "und",
  "yue-Hans": "und",
  "zh-Hant": "und",
  "zh-Hant-MO": "zh-Hant-HK"
};
var Lre = "-";
const Mre = (t, e) => {
  var i = t[e];
  return i ? i !== "root" && i : e.substr(0, e.lastIndexOf(Lre));
};
var TR = "en";
const Wo = js({
  locale: /* @__PURE__ */ (() => {
    var t = TR;
    return (e) => {
      if (!e)
        return t;
      t = e;
    };
  })(),
  getValueByClosestLocale: function(t) {
    for (var e = this.locale(), i = t(e), r; !i && !r; )
      e = Mre(Rre, e), e ? i = t(e) : r = !0;
    return i === void 0 && e !== TR ? t(TR) : i;
  }
}), kre = (t, e) => {
  if (e) {
    var i = t;
    if (typeof t == "string") {
      i = "";
      for (var r = 0; r < t.length; r++)
        t[r] !== "$" && (i += "\\"), i += t[r];
    }
    for (var n = {
      ".00": "{0}",
      "'": "\\'",
      "\\(": "\\(",
      "\\)": "\\)",
      " ": "\\ ",
      '"': "&quot;",
      "\\¤": i
    }, a = e.split(";"), o = 0; o < a.length; o++)
      for (var u in n)
        Object.prototype.hasOwnProperty.call(n, u) && (a[o] = a[o].replace(new RegExp(u, "g"), n[u]));
    return a.length === 2 ? a[0] + "_);" + a[1] : a[0];
  }
}, Pre = {
  af: "¤#,##0.00;(¤#,##0.00)",
  "af-NA": "¤#,##0.00;(¤#,##0.00)",
  agq: "#,##0.00¤",
  ak: "¤#,##0.00",
  am: "¤#,##0.00;(¤#,##0.00)",
  ar: "¤#,##0.00;(¤#,##0.00)",
  "ar-AE": "¤#,##0.00;(¤#,##0.00)",
  "ar-BH": "¤#,##0.00;(¤#,##0.00)",
  "ar-DJ": "¤#,##0.00;(¤#,##0.00)",
  "ar-DZ": "¤#,##0.00;(¤#,##0.00)",
  "ar-EG": "¤#,##0.00;(¤#,##0.00)",
  "ar-EH": "¤#,##0.00;(¤#,##0.00)",
  "ar-ER": "¤#,##0.00;(¤#,##0.00)",
  "ar-IL": "¤#,##0.00;(¤#,##0.00)",
  "ar-IQ": "¤#,##0.00;(¤#,##0.00)",
  "ar-JO": "¤#,##0.00;(¤#,##0.00)",
  "ar-KM": "¤#,##0.00;(¤#,##0.00)",
  "ar-KW": "¤#,##0.00;(¤#,##0.00)",
  "ar-LB": "¤#,##0.00;(¤#,##0.00)",
  "ar-LY": "¤#,##0.00;(¤#,##0.00)",
  "ar-MA": "¤#,##0.00;(¤#,##0.00)",
  "ar-MR": "¤#,##0.00;(¤#,##0.00)",
  "ar-OM": "¤#,##0.00;(¤#,##0.00)",
  "ar-PS": "¤#,##0.00;(¤#,##0.00)",
  "ar-QA": "¤#,##0.00;(¤#,##0.00)",
  "ar-SA": "¤#,##0.00;(¤#,##0.00)",
  "ar-SD": "¤#,##0.00;(¤#,##0.00)",
  "ar-SO": "¤#,##0.00;(¤#,##0.00)",
  "ar-SS": "¤#,##0.00;(¤#,##0.00)",
  "ar-SY": "¤#,##0.00;(¤#,##0.00)",
  "ar-TD": "¤#,##0.00;(¤#,##0.00)",
  "ar-TN": "¤#,##0.00;(¤#,##0.00)",
  "ar-YE": "¤#,##0.00;(¤#,##0.00)",
  as: "¤ #,##,##0.00",
  asa: "#,##0.00 ¤",
  ast: "#,##0.00 ¤",
  az: "#,##0.00 ¤",
  "az-Cyrl": "#,##0.00 ¤",
  "az-Latn": "#,##0.00 ¤",
  bas: "#,##0.00 ¤",
  be: "#,##0.00 ¤",
  "be-tarask": "#,##0.00 ¤",
  bem: "¤#,##0.00;(¤#,##0.00)",
  bez: "#,##0.00¤",
  bg: "0.00 ¤;(0.00 ¤)",
  bm: "¤#,##0.00;(¤#,##0.00)",
  bn: "#,##,##0.00¤;(#,##,##0.00¤)",
  "bn-IN": "#,##,##0.00¤;(#,##,##0.00¤)",
  bo: "¤ #,##0.00",
  "bo-IN": "¤ #,##0.00",
  br: "#,##0.00 ¤",
  brx: "¤ #,##,##0.00",
  bs: "#,##0.00 ¤",
  "bs-Cyrl": "#,##0.00 ¤",
  "bs-Latn": "#,##0.00 ¤",
  ca: "#,##0.00 ¤;(#,##0.00 ¤)",
  "ca-AD": "#,##0.00 ¤;(#,##0.00 ¤)",
  "ca-ES-valencia": "#,##0.00 ¤;(#,##0.00 ¤)",
  "ca-FR": "#,##0.00 ¤;(#,##0.00 ¤)",
  "ca-IT": "#,##0.00 ¤;(#,##0.00 ¤)",
  ccp: "#,##,##0.00¤;(#,##,##0.00¤)",
  "ccp-IN": "#,##,##0.00¤;(#,##,##0.00¤)",
  ce: "#,##0.00 ¤",
  ceb: "¤#,##0.00;(¤#,##0.00)",
  cgg: "¤#,##0.00",
  chr: "¤#,##0.00;(¤#,##0.00)",
  ckb: "¤ #,##0.00",
  "ckb-IR": "¤ #,##0.00",
  cs: "#,##0.00 ¤",
  cy: "¤#,##0.00;(¤#,##0.00)",
  da: "#,##0.00 ¤",
  "da-GL": "#,##0.00 ¤",
  dav: "¤#,##0.00;(¤#,##0.00)",
  de: "#,##0.00 ¤",
  "de-AT": "#,##0.00 ¤",
  "de-BE": "#,##0.00 ¤",
  "de-CH": "#,##0.00 ¤",
  "de-IT": "#,##0.00 ¤",
  "de-LI": "#,##0.00 ¤",
  "de-LU": "#,##0.00 ¤",
  dje: "#,##0.00¤",
  doi: "¤#,##0.00",
  dsb: "#,##0.00 ¤",
  dua: "#,##0.00 ¤",
  dyo: "#,##0.00 ¤",
  dz: "¤#,##,##0.00",
  ebu: "¤#,##0.00;(¤#,##0.00)",
  ee: "¤#,##0.00;(¤#,##0.00)",
  "ee-TG": "¤#,##0.00;(¤#,##0.00)",
  el: "#,##0.00 ¤",
  "el-CY": "#,##0.00 ¤",
  en: "¤#,##0.00;(¤#,##0.00)",
  "en-001": "¤#,##0.00;(¤#,##0.00)",
  "en-150": "#,##0.00 ¤",
  "en-AE": "¤#,##0.00;(¤#,##0.00)",
  "en-AG": "¤#,##0.00;(¤#,##0.00)",
  "en-AI": "¤#,##0.00;(¤#,##0.00)",
  "en-AS": "¤#,##0.00;(¤#,##0.00)",
  "en-AT": "¤ #,##0.00",
  "en-AU": "¤#,##0.00;(¤#,##0.00)",
  "en-BB": "¤#,##0.00;(¤#,##0.00)",
  "en-BE": "#,##0.00 ¤",
  "en-BI": "¤#,##0.00;(¤#,##0.00)",
  "en-BM": "¤#,##0.00;(¤#,##0.00)",
  "en-BS": "¤#,##0.00;(¤#,##0.00)",
  "en-BW": "¤#,##0.00;(¤#,##0.00)",
  "en-BZ": "¤#,##0.00;(¤#,##0.00)",
  "en-CA": "¤#,##0.00;(¤#,##0.00)",
  "en-CC": "¤#,##0.00;(¤#,##0.00)",
  "en-CH": "¤ #,##0.00;¤-#,##0.00",
  "en-CK": "¤#,##0.00;(¤#,##0.00)",
  "en-CM": "¤#,##0.00;(¤#,##0.00)",
  "en-CX": "¤#,##0.00;(¤#,##0.00)",
  "en-CY": "¤#,##0.00;(¤#,##0.00)",
  "en-DE": "#,##0.00 ¤",
  "en-DG": "¤#,##0.00;(¤#,##0.00)",
  "en-DK": "#,##0.00 ¤",
  "en-DM": "¤#,##0.00;(¤#,##0.00)",
  "en-ER": "¤#,##0.00;(¤#,##0.00)",
  "en-FI": "#,##0.00 ¤",
  "en-FJ": "¤#,##0.00;(¤#,##0.00)",
  "en-FK": "¤#,##0.00;(¤#,##0.00)",
  "en-FM": "¤#,##0.00;(¤#,##0.00)",
  "en-GB": "¤#,##0.00;(¤#,##0.00)",
  "en-GD": "¤#,##0.00;(¤#,##0.00)",
  "en-GG": "¤#,##0.00;(¤#,##0.00)",
  "en-GH": "¤#,##0.00;(¤#,##0.00)",
  "en-GI": "¤#,##0.00;(¤#,##0.00)",
  "en-GM": "¤#,##0.00;(¤#,##0.00)",
  "en-GU": "¤#,##0.00;(¤#,##0.00)",
  "en-GY": "¤#,##0.00;(¤#,##0.00)",
  "en-HK": "¤#,##0.00;(¤#,##0.00)",
  "en-IE": "¤#,##0.00;(¤#,##0.00)",
  "en-IL": "¤#,##0.00;(¤#,##0.00)",
  "en-IM": "¤#,##0.00;(¤#,##0.00)",
  "en-IN": "¤#,##0.00;(¤#,##0.00)",
  "en-IO": "¤#,##0.00;(¤#,##0.00)",
  "en-JE": "¤#,##0.00;(¤#,##0.00)",
  "en-JM": "¤#,##0.00;(¤#,##0.00)",
  "en-KE": "¤#,##0.00;(¤#,##0.00)",
  "en-KI": "¤#,##0.00;(¤#,##0.00)",
  "en-KN": "¤#,##0.00;(¤#,##0.00)",
  "en-KY": "¤#,##0.00;(¤#,##0.00)",
  "en-LC": "¤#,##0.00;(¤#,##0.00)",
  "en-LR": "¤#,##0.00;(¤#,##0.00)",
  "en-LS": "¤#,##0.00;(¤#,##0.00)",
  "en-MG": "¤#,##0.00;(¤#,##0.00)",
  "en-MH": "¤#,##0.00;(¤#,##0.00)",
  "en-MO": "¤#,##0.00;(¤#,##0.00)",
  "en-MP": "¤#,##0.00;(¤#,##0.00)",
  "en-MS": "¤#,##0.00;(¤#,##0.00)",
  "en-MT": "¤#,##0.00;(¤#,##0.00)",
  "en-MU": "¤#,##0.00;(¤#,##0.00)",
  "en-MV": "¤ #,##0.00",
  "en-MW": "¤#,##0.00;(¤#,##0.00)",
  "en-MY": "¤#,##0.00;(¤#,##0.00)",
  "en-NA": "¤#,##0.00;(¤#,##0.00)",
  "en-NF": "¤#,##0.00;(¤#,##0.00)",
  "en-NG": "¤#,##0.00;(¤#,##0.00)",
  "en-NL": "¤ #,##0.00;(¤ #,##0.00)",
  "en-NR": "¤#,##0.00;(¤#,##0.00)",
  "en-NU": "¤#,##0.00;(¤#,##0.00)",
  "en-NZ": "¤#,##0.00;(¤#,##0.00)",
  "en-PG": "¤#,##0.00;(¤#,##0.00)",
  "en-PH": "¤#,##0.00;(¤#,##0.00)",
  "en-PK": "¤#,##0.00;(¤#,##0.00)",
  "en-PN": "¤#,##0.00;(¤#,##0.00)",
  "en-PR": "¤#,##0.00;(¤#,##0.00)",
  "en-PW": "¤#,##0.00;(¤#,##0.00)",
  "en-RW": "¤#,##0.00;(¤#,##0.00)",
  "en-SB": "¤#,##0.00;(¤#,##0.00)",
  "en-SC": "¤#,##0.00;(¤#,##0.00)",
  "en-SD": "¤#,##0.00;(¤#,##0.00)",
  "en-SE": "#,##0.00 ¤",
  "en-SG": "¤#,##0.00;(¤#,##0.00)",
  "en-SH": "¤#,##0.00;(¤#,##0.00)",
  "en-SI": "#,##0.00 ¤;(#,##0.00 ¤)",
  "en-SL": "¤#,##0.00;(¤#,##0.00)",
  "en-SS": "¤#,##0.00;(¤#,##0.00)",
  "en-SX": "¤#,##0.00;(¤#,##0.00)",
  "en-SZ": "¤#,##0.00;(¤#,##0.00)",
  "en-TC": "¤#,##0.00;(¤#,##0.00)",
  "en-TK": "¤#,##0.00;(¤#,##0.00)",
  "en-TO": "¤#,##0.00;(¤#,##0.00)",
  "en-TT": "¤#,##0.00;(¤#,##0.00)",
  "en-TV": "¤#,##0.00;(¤#,##0.00)",
  "en-TZ": "¤#,##0.00;(¤#,##0.00)",
  "en-UG": "¤#,##0.00;(¤#,##0.00)",
  "en-UM": "¤#,##0.00;(¤#,##0.00)",
  "en-VC": "¤#,##0.00;(¤#,##0.00)",
  "en-VG": "¤#,##0.00;(¤#,##0.00)",
  "en-VI": "¤#,##0.00;(¤#,##0.00)",
  "en-VU": "¤#,##0.00;(¤#,##0.00)",
  "en-WS": "¤#,##0.00;(¤#,##0.00)",
  "en-ZA": "¤#,##0.00;(¤#,##0.00)",
  "en-ZM": "¤#,##0.00;(¤#,##0.00)",
  "en-ZW": "¤#,##0.00;(¤#,##0.00)",
  eo: "¤ #,##0.00",
  es: "#,##0.00 ¤",
  "es-419": "¤#,##0.00",
  "es-AR": "¤ #,##0.00;(¤ #,##0.00)",
  "es-BO": "¤#,##0.00",
  "es-BR": "¤#,##0.00",
  "es-BZ": "¤#,##0.00",
  "es-CL": "¤#,##0.00",
  "es-CO": "¤#,##0.00",
  "es-CR": "¤#,##0.00",
  "es-CU": "¤#,##0.00",
  "es-DO": "¤#,##0.00;(¤#,##0.00)",
  "es-EA": "#,##0.00 ¤",
  "es-EC": "¤#,##0.00",
  "es-GQ": "#,##0.00 ¤",
  "es-GT": "¤#,##0.00",
  "es-HN": "¤#,##0.00",
  "es-IC": "#,##0.00 ¤",
  "es-MX": "¤#,##0.00",
  "es-NI": "¤#,##0.00",
  "es-PA": "¤#,##0.00",
  "es-PE": "¤#,##0.00",
  "es-PH": "#,##0.00 ¤",
  "es-PR": "¤#,##0.00",
  "es-PY": "¤#,##0.00",
  "es-SV": "¤#,##0.00",
  "es-US": "¤#,##0.00",
  "es-UY": "¤ #,##0.00;(¤ #,##0.00)",
  "es-VE": "¤#,##0.00",
  et: "#,##0.00 ¤;(#,##0.00 ¤)",
  eu: "#,##0.00 ¤;(#,##0.00 ¤)",
  ewo: "#,##0.00 ¤",
  fa: "‎¤ #,##0.00;‎(¤ #,##0.00)",
  "fa-AF": "¤ #,##0.00;‎(¤ #,##0.00)",
  ff: "#,##0.00 ¤",
  "ff-Adlm": "¤ #,##0.00",
  "ff-Adlm-BF": "¤ #,##0.00",
  "ff-Adlm-CM": "¤ #,##0.00",
  "ff-Adlm-GH": "¤ #,##0.00",
  "ff-Adlm-GM": "¤ #,##0.00",
  "ff-Adlm-GW": "¤ #,##0.00",
  "ff-Adlm-LR": "¤ #,##0.00",
  "ff-Adlm-MR": "¤ #,##0.00",
  "ff-Adlm-NE": "¤ #,##0.00",
  "ff-Adlm-NG": "¤ #,##0.00",
  "ff-Adlm-SL": "¤ #,##0.00",
  "ff-Adlm-SN": "¤ #,##0.00",
  "ff-Latn": "#,##0.00 ¤",
  "ff-Latn-BF": "#,##0.00 ¤",
  "ff-Latn-CM": "#,##0.00 ¤",
  "ff-Latn-GH": "#,##0.00 ¤",
  "ff-Latn-GM": "#,##0.00 ¤",
  "ff-Latn-GN": "#,##0.00 ¤",
  "ff-Latn-GW": "#,##0.00 ¤",
  "ff-Latn-LR": "#,##0.00 ¤",
  "ff-Latn-MR": "#,##0.00 ¤",
  "ff-Latn-NE": "#,##0.00 ¤",
  "ff-Latn-NG": "#,##0.00 ¤",
  "ff-Latn-SL": "#,##0.00 ¤",
  fi: "#,##0.00 ¤",
  fil: "¤#,##0.00;(¤#,##0.00)",
  fo: "#,##0.00 ¤;(#,##0.00 ¤)",
  "fo-DK": "#,##0.00 ¤;(#,##0.00 ¤)",
  fr: "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-BE": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-BF": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-BI": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-BJ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-BL": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CA": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CD": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CF": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CG": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CH": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CI": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CM": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-DJ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-DZ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-GA": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-GF": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-GN": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-GP": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-GQ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-HT": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-KM": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-LU": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MA": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MC": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MF": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MG": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-ML": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MQ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MR": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MU": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-NC": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-NE": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-PF": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-PM": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-RE": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-RW": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-SC": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-SN": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-SY": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-TD": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-TG": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-TN": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-VU": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-WF": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-YT": "#,##0.00 ¤;(#,##0.00 ¤)",
  fur: "¤ #,##0.00",
  fy: "¤ #,##0.00;(¤ #,##0.00)",
  ga: "¤#,##0.00;(¤#,##0.00)",
  "ga-GB": "¤#,##0.00;(¤#,##0.00)",
  gd: "¤#,##0.00;(¤#,##0.00)",
  gl: "#,##0.00 ¤",
  gsw: "#,##0.00 ¤",
  "gsw-FR": "#,##0.00 ¤",
  "gsw-LI": "#,##0.00 ¤",
  gu: "¤#,##,##0.00;(¤#,##,##0.00)",
  guz: "¤#,##0.00;(¤#,##0.00)",
  gv: "¤#,##0.00",
  ha: "¤ #,##0.00",
  "ha-GH": "¤ #,##0.00",
  "ha-NE": "¤ #,##0.00",
  haw: "¤#,##0.00;(¤#,##0.00)",
  he: "#,##0.00 ¤",
  hi: "¤#,##,##0.00",
  "hi-Latn": "¤#,##,##0.00",
  hr: "#,##0.00 ¤",
  "hr-BA": "#,##0.00 ¤",
  hsb: "#,##0.00 ¤",
  hu: "#,##0.00 ¤",
  hy: "#,##0.00 ¤",
  ia: "¤ #,##0.00;(¤ #,##0.00)",
  id: "¤#,##0.00",
  ig: "¤#,##0.00;(¤#,##0.00)",
  ii: "¤ #,##0.00",
  is: "#,##0.00 ¤",
  it: "#,##0.00 ¤",
  "it-CH": "#,##0.00 ¤",
  "it-SM": "#,##0.00 ¤",
  "it-VA": "#,##0.00 ¤",
  ja: "¤#,##0.00;(¤#,##0.00)",
  jgo: "¤ #,##0.00",
  jmc: "¤#,##0.00",
  jv: "¤ #,##0.00",
  ka: "#,##0.00 ¤",
  kab: "#,##0.00¤",
  kam: "¤#,##0.00;(¤#,##0.00)",
  kde: "¤#,##0.00;(¤#,##0.00)",
  kea: "#,##0.00 ¤;(#,##0.00 ¤)",
  kgp: "¤ #,##0.00",
  khq: "#,##0.00¤",
  ki: "¤#,##0.00;(¤#,##0.00)",
  kk: "#,##0.00 ¤",
  kkj: "¤ #,##0.00",
  kl: "¤#,##0.00;¤-#,##0.00",
  kln: "¤#,##0.00;(¤#,##0.00)",
  km: "#,##0.00¤;(#,##0.00¤)",
  kn: "¤#,##0.00;(¤#,##0.00)",
  ko: "¤#,##0.00;(¤#,##0.00)",
  "ko-KP": "¤#,##0.00;(¤#,##0.00)",
  kok: "¤#,##0.00;(¤#,##0.00)",
  ks: "¤#,##0.00",
  "ks-Arab": "¤#,##0.00",
  "ks-Deva": "¤ #,##0.00",
  ksb: "#,##0.00¤",
  ksf: "#,##0.00 ¤",
  ksh: "#,##0.00 ¤",
  ku: "#,##0.00 ¤;(#,##0.00 ¤)",
  kw: "¤#,##0.00",
  ky: "#,##0.00 ¤",
  lag: "¤ #,##0.00",
  lb: "#,##0.00 ¤",
  lg: "#,##0.00¤",
  lkt: "¤ #,##0.00",
  ln: "#,##0.00 ¤",
  "ln-AO": "#,##0.00 ¤",
  "ln-CF": "#,##0.00 ¤",
  "ln-CG": "#,##0.00 ¤",
  lo: "¤#,##0.00;¤-#,##0.00",
  lrc: "¤ #,##0.00",
  "lrc-IQ": "¤ #,##0.00",
  lt: "#,##0.00 ¤",
  lu: "#,##0.00¤",
  luo: "#,##0.00¤",
  luy: "¤#,##0.00;¤- #,##0.00",
  lv: "#,##0.00 ¤",
  mai: "¤ #,##0.00",
  mas: "¤#,##0.00;(¤#,##0.00)",
  "mas-TZ": "¤#,##0.00;(¤#,##0.00)",
  mer: "¤#,##0.00;(¤#,##0.00)",
  mfe: "¤ #,##0.00",
  mg: "¤#,##0.00",
  mgh: "¤ #,##0.00",
  mgo: "¤ #,##0.00",
  mi: "¤ #,##0.00",
  mk: "#,##0.00 ¤",
  ml: "¤#,##0.00;(¤#,##0.00)",
  mn: "¤ #,##0.00",
  mni: "¤ #,##0.00",
  "mni-Beng": "¤ #,##0.00",
  mr: "¤#,##0.00;(¤#,##0.00)",
  ms: "¤#,##0.00;(¤#,##0.00)",
  "ms-BN": "¤#,##0.00;(¤#,##0.00)",
  "ms-ID": "¤#,##0.00",
  "ms-SG": "¤#,##0.00;(¤#,##0.00)",
  mt: "¤#,##0.00",
  mua: "¤#,##0.00;(¤#,##0.00)",
  my: "¤ #,##0.00",
  mzn: "¤ #,##0.00",
  naq: "¤#,##0.00",
  nb: "¤ #,##0.00;(¤ #,##0.00)",
  "nb-SJ": "¤ #,##0.00;(¤ #,##0.00)",
  nd: "¤#,##0.00;(¤#,##0.00)",
  nds: "¤ #,##0.00",
  "nds-NL": "¤ #,##0.00",
  ne: "¤ #,##,##0.00",
  "ne-IN": "¤ #,##,##0.00",
  nl: "¤ #,##0.00;(¤ #,##0.00)",
  "nl-AW": "¤ #,##0.00;(¤ #,##0.00)",
  "nl-BE": "¤ #,##0.00;(¤ #,##0.00)",
  "nl-BQ": "¤ #,##0.00;(¤ #,##0.00)",
  "nl-CW": "¤ #,##0.00;(¤ #,##0.00)",
  "nl-SR": "¤ #,##0.00;(¤ #,##0.00)",
  "nl-SX": "¤ #,##0.00;(¤ #,##0.00)",
  nmg: "#,##0.00 ¤",
  nn: "#,##0.00 ¤",
  nnh: "¤ #,##0.00",
  no: "¤ #,##0.00;(¤ #,##0.00)",
  nus: "¤#,##0.00;(¤#,##0.00)",
  nyn: "¤#,##0.00",
  om: "¤#,##0.00",
  "om-KE": "¤#,##0.00",
  or: "¤#,##0.00;(¤#,##0.00)",
  os: "¤ #,##0.00",
  "os-RU": "¤ #,##0.00",
  pa: "¤ #,##0.00",
  "pa-Arab": "¤ #,##0.00",
  "pa-Guru": "¤ #,##0.00",
  pcm: "¤#,##0.00",
  pl: "#,##0.00 ¤;(#,##0.00 ¤)",
  ps: "¤#,##0.00;(¤#,##0.00)",
  "ps-PK": "¤#,##0.00;(¤#,##0.00)",
  pt: "¤ #,##0.00",
  "pt-AO": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-CH": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-CV": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-GQ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-GW": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-LU": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-MO": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-MZ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-PT": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-ST": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-TL": "#,##0.00 ¤;(#,##0.00 ¤)",
  qu: "¤ #,##0.00",
  "qu-BO": "¤ #,##0.00",
  "qu-EC": "¤ #,##0.00",
  rm: "#,##0.00 ¤",
  rn: "#,##0.00¤",
  ro: "#,##0.00 ¤;(#,##0.00 ¤)",
  "ro-MD": "#,##0.00 ¤;(#,##0.00 ¤)",
  rof: "¤#,##0.00",
  ru: "#,##0.00 ¤",
  "ru-BY": "#,##0.00 ¤",
  "ru-KG": "#,##0.00 ¤",
  "ru-KZ": "#,##0.00 ¤",
  "ru-MD": "#,##0.00 ¤",
  "ru-UA": "#,##0.00 ¤",
  rw: "¤ #,##0.00",
  rwk: "#,##0.00¤",
  sa: "¤ #,##0.00",
  sah: "#,##0.00 ¤",
  saq: "¤#,##0.00;(¤#,##0.00)",
  sat: "¤ #,##0.00",
  "sat-Olck": "¤ #,##0.00",
  sbp: "#,##0.00¤",
  sc: "#,##0.00 ¤",
  sd: "¤ #,##0.00",
  "sd-Arab": "¤ #,##0.00",
  "sd-Deva": "¤ #,##0.00",
  se: "#,##0.00 ¤",
  "se-FI": "#,##0.00 ¤",
  "se-SE": "#,##0.00 ¤",
  seh: "#,##0.00¤",
  ses: "#,##0.00¤",
  sg: "¤#,##0.00;¤-#,##0.00",
  shi: "#,##0.00¤",
  "shi-Latn": "#,##0.00¤",
  "shi-Tfng": "#,##0.00¤",
  si: "¤#,##0.00;(¤#,##0.00)",
  sk: "#,##0.00 ¤;(#,##0.00 ¤)",
  sl: "#,##0.00 ¤;(#,##0.00 ¤)",
  smn: "#,##0.00 ¤",
  sn: "¤#,##0.00;(¤#,##0.00)",
  so: "¤#,##0.00;(¤#,##0.00)",
  "so-DJ": "¤#,##0.00;(¤#,##0.00)",
  "so-ET": "¤#,##0.00;(¤#,##0.00)",
  "so-KE": "¤#,##0.00;(¤#,##0.00)",
  sq: "#,##0.00 ¤;(#,##0.00 ¤)",
  "sq-MK": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sq-XK": "#,##0.00 ¤;(#,##0.00 ¤)",
  sr: "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Cyrl": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Cyrl-BA": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Cyrl-ME": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Cyrl-XK": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Latn": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Latn-BA": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Latn-ME": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Latn-XK": "#,##0.00 ¤;(#,##0.00 ¤)",
  su: "¤#,##0.00",
  "su-Latn": "¤#,##0.00",
  sv: "#,##0.00 ¤",
  "sv-AX": "#,##0.00 ¤",
  "sv-FI": "#,##0.00 ¤",
  sw: "¤ #,##0.00",
  "sw-CD": "¤ #,##0.00",
  "sw-KE": "¤ #,##0.00",
  "sw-UG": "¤ #,##0.00",
  ta: "¤#,##0.00;(¤#,##0.00)",
  "ta-LK": "¤#,##0.00;(¤#,##0.00)",
  "ta-MY": "¤#,##0.00;(¤#,##0.00)",
  "ta-SG": "¤#,##0.00;(¤#,##0.00)",
  te: "¤#,##0.00;(¤#,##0.00)",
  teo: "¤#,##0.00;(¤#,##0.00)",
  "teo-KE": "¤#,##0.00;(¤#,##0.00)",
  tg: "#,##0.00 ¤",
  th: "¤#,##0.00;(¤#,##0.00)",
  ti: "¤#,##0.00",
  "ti-ER": "¤#,##0.00",
  tk: "#,##0.00 ¤",
  to: "¤ #,##0.00",
  tr: "¤#,##0.00;(¤#,##0.00)",
  "tr-CY": "¤#,##0.00;(¤#,##0.00)",
  tt: "#,##0.00 ¤",
  twq: "#,##0.00¤",
  tzm: "#,##0.00 ¤",
  ug: "¤#,##0.00;(¤#,##0.00)",
  uk: "#,##0.00 ¤",
  und: "¤ #,##0.00",
  ur: "¤#,##0.00;(¤#,##0.00)",
  "ur-IN": "¤#,##0.00;(¤#,##0.00)",
  uz: "#,##0.00 ¤",
  "uz-Arab": "¤ #,##0.00",
  "uz-Cyrl": "#,##0.00 ¤",
  "uz-Latn": "#,##0.00 ¤",
  vai: "¤#,##0.00;(¤#,##0.00)",
  "vai-Latn": "¤#,##0.00;(¤#,##0.00)",
  "vai-Vaii": "¤#,##0.00;(¤#,##0.00)",
  vi: "#,##0.00 ¤",
  vun: "¤#,##0.00",
  wae: "¤ #,##0.00",
  wo: "¤ #,##0.00",
  xh: "¤#,##0.00",
  xog: "#,##0.00 ¤",
  yav: "#,##0.00 ¤;(#,##0.00 ¤)",
  yi: "¤ #,##0.00",
  yo: "¤#,##0.00;(¤#,##0.00)",
  "yo-BJ": "¤#,##0.00;(¤#,##0.00)",
  yrl: "¤ #,##0.00",
  "yrl-CO": "¤ #,##0.00",
  "yrl-VE": "¤ #,##0.00",
  yue: "¤#,##0.00;(¤#,##0.00)",
  "yue-Hans": "¤#,##0.00;(¤#,##0.00)",
  "yue-Hant": "¤#,##0.00;(¤#,##0.00)",
  zgh: "#,##0.00¤",
  zh: "¤#,##0.00;(¤#,##0.00)",
  "zh-Hans": "¤#,##0.00;(¤#,##0.00)",
  "zh-Hans-HK": "¤#,##0.00;(¤#,##0.00)",
  "zh-Hans-MO": "¤#,##0.00;(¤#,##0.00)",
  "zh-Hans-SG": "¤#,##0.00;(¤#,##0.00)",
  "zh-Hant": "¤#,##0.00;(¤#,##0.00)",
  "zh-Hant-HK": "¤#,##0.00;(¤#,##0.00)",
  "zh-Hant-MO": "¤#,##0.00;(¤#,##0.00)",
  zu: "¤#,##0.00;(¤#,##0.00)"
};
var Fre = ["standard", "accounting"], Bre = 20, Vre = /([^\s0]+)?(\s*)0*[.,]*0*(\s*)([^\s0]+)?/, IR = {}, b$ = (t) => {
  var e = Wo.locale() + "/" + JSON.stringify(t);
  return IR[e] || (IR[e] = new Intl.NumberFormat(Wo.locale(), t).format), IR[e];
}, Nre = (t) => new Intl.NumberFormat(Wo.locale(), {
  style: "currency",
  currency: t
});
const Hre = {
  engine: function() {
    return "intl";
  },
  _formatNumberCore: function(t, e, i) {
    return e === "exponential" ? this.callBase.apply(this, arguments) : b$(this._normalizeFormatConfig(e, i, t))(t);
  },
  _normalizeFormatConfig: function(t, e, i) {
    var r;
    if (t === "decimal") {
      var n = String(i).split(".")[1];
      r = {
        minimumIntegerDigits: e.precision || void 0,
        useGrouping: !1,
        maximumFractionDigits: n && n.length,
        round: i < 0 ? "ceil" : "floor"
      };
    } else
      r = this._getPrecisionConfig(e.precision);
    if (t === "percent")
      r.style = "percent";
    else if (t === "currency") {
      var a, o = (a = e.useCurrencyAccountingStyle) !== null && a !== void 0 ? a : Oi().defaultUseCurrencyAccountingStyle;
      r.style = "currency", r.currency = e.currency || Oi().defaultCurrency, r.currencySign = Fre[+o];
    }
    return r;
  },
  _getPrecisionConfig: function(t) {
    var e;
    return t === null ? e = {
      minimumFractionDigits: 0,
      maximumFractionDigits: Bre
    } : e = {
      minimumFractionDigits: t || 0,
      maximumFractionDigits: t || 0
    }, e;
  },
  format: function(t, e) {
    return typeof t != "number" ? t : (e = this._normalizeFormat(e), e.currency === "default" && (e.currency = Oi().defaultCurrency), !e || typeof e != "function" && !e.type && !e.formatter ? b$(e)(t) : this.callBase.apply(this, arguments));
  },
  _getCurrencySymbolInfo: function(t) {
    var e = Nre(t);
    return this._extractCurrencySymbolInfo(e.format(0));
  },
  _extractCurrencySymbolInfo: function(t) {
    var e = Vre.exec(t) || [], i = e[1] ? "before" : "after", r = e[1] || e[4] || "", n = e[2] || e[3] || "";
    return {
      position: i,
      symbol: r,
      delimiter: n
    };
  },
  getCurrencySymbol: function(t) {
    t || (t = Oi().defaultCurrency);
    var e = this._getCurrencySymbolInfo(t);
    return {
      symbol: e.symbol
    };
  },
  getOpenXmlCurrencyFormat: function(t) {
    var e = t || Oi().defaultCurrency, i = this._getCurrencySymbolInfo(e).symbol, r = Wo.getValueByClosestLocale((n) => Pre[n]);
    return kre(i, r);
  }
};
var $re = typeof Intl < "u", zre = 4, Mb = 10, w$ = ["currency", "fixedpoint", "exponential", "percent", "decimal"], DR = {
  1: "K",
  2: "M",
  3: "B",
  4: "T"
}, T$ = {
  largenumber: "auto",
  thousands: 1,
  millions: 2,
  billions: 3,
  trillions: 4
}, _i = js({
  engine: function() {
    return "base";
  },
  numericFormats: w$,
  defaultLargeNumberFormatPostfixes: DR,
  _parseNumberFormatString: function(t) {
    var e = {};
    if (!(!t || typeof t != "string")) {
      var i = t.toLowerCase().split(" ");
      if (N(i, (r, n) => {
        w$.includes(n) ? e.formatType = n : n in T$ && (e.power = T$[n]);
      }), e.power && !e.formatType && (e.formatType = "fixedpoint"), e.formatType)
        return e;
    }
  },
  _calculateNumberPower: function(t, e, i, r) {
    var n = Math.abs(t), a = 0;
    if (n > 1)
      for (; n && n >= e && (r === void 0 || a < r); )
        a++, n /= e;
    else if (n > 0 && n < 1)
      for (; n < 1 && (i === void 0 || a > i); )
        a--, n *= e;
    return a;
  },
  _getNumberByPower: function(t, e, i) {
    for (var r = t; e > 0; )
      r /= i, e--;
    for (; e < 0; )
      r *= i, e++;
    return r;
  },
  _formatNumber: function(t, e, i) {
    e.power === "auto" && (e.power = this._calculateNumberPower(t, 1e3, 0, zre)), e.power && (t = this._getNumberByPower(t, e.power, 1e3));
    var r = this.defaultLargeNumberFormatPostfixes[e.power] || "", n = this._formatNumberCore(t, e.formatType, i);
    return n = n.replace(/(\d|.$)(\D*)$/, "$1" + r + "$2"), n;
  },
  _formatNumberExponential: function(t, e) {
    var i = this._calculateNumberPower(t, Mb), r = this._getNumberByPower(t, i, Mb);
    e.precision === void 0 && (e.precision = 1), r.toFixed(e.precision || 0) >= Mb && (i++, r /= Mb);
    var n = (i >= 0 ? "+" : "") + i.toString();
    return this._formatNumberCore(r, "fixedpoint", e) + "E" + n;
  },
  _addZeroes: function(t, e) {
    var i = Math.pow(10, e), r = t < 0 ? "-" : "";
    t = (Math.abs(t) * i >>> 0) / i;
    for (var n = t.toString(); n.length < e; )
      n = "0" + n;
    return r + n;
  },
  _addGroupSeparators: function(t) {
    var e = t.toString().split(".");
    return e[0].replace(/\B(?=(\d{3})+(?!\d))/g, Oi().thousandsSeparator) + (e[1] ? Oi().decimalSeparator + e[1] : "");
  },
  _formatNumberCore: function(t, e, i) {
    return e === "exponential" ? this._formatNumberExponential(t, i) : (e !== "decimal" && i.precision !== null && (i.precision = i.precision || 0), e === "percent" && (t *= 100), i.precision !== void 0 && (e === "decimal" ? t = this._addZeroes(t, i.precision) : t = i.precision === null ? t.toPrecision() : Ij(t, i.precision)), e !== "decimal" ? t = this._addGroupSeparators(t) : t = t.toString().replace(".", Oi().decimalSeparator), e === "percent" && (t += "%"), t);
  },
  _normalizeFormat: function(t) {
    return t ? (typeof t == "function" || $t(t) || (t = {
      type: t
    }), t) : {};
  },
  _getSeparators: function() {
    return {
      decimalSeparator: this.getDecimalSeparator(),
      thousandsSeparator: this.getThousandsSeparator()
    };
  },
  getThousandsSeparator: function() {
    return this.format(1e4, "fixedPoint")[2];
  },
  getDecimalSeparator: function() {
    return this.format(1.2, {
      type: "fixedPoint",
      precision: 1
    })[1];
  },
  convertDigits: function(t, e) {
    var i = this.format(90, "decimal");
    if (typeof t != "string" || i[1] === "0")
      return t;
    var r = e ? i[1] : "0", n = e ? "0" : i[1], a = e ? i[0] : "9", o = new RegExp("[" + r + "-" + a + "]", "g");
    return t.replace(o, (u) => String.fromCharCode(u.charCodeAt(0) + (n.charCodeAt(0) - r.charCodeAt(0))));
  },
  getNegativeEtalonRegExp: function(t) {
    var e = this._getSeparators(), i = new RegExp("[0-9" + Eh(e.decimalSeparator + e.thousandsSeparator) + "]+", "g"), r = this.format(-1, t).replace(i, "1");
    return ["\\", "(", ")", "[", "]", "*", "+", "$", "^", "?", "|", "{", "}"].forEach((n) => {
      r = r.replace(new RegExp("\\".concat(n), "g"), "\\".concat(n));
    }), r = r.replace(/ /g, "\\s"), r = r.replace(/1/g, ".*"), new RegExp(r, "g");
  },
  getSign: function(t, e) {
    if (!e)
      return t.replace(/[^0-9-]/g, "").charAt(0) === "-" ? -1 : 1;
    var i = this.getNegativeEtalonRegExp(e);
    return t.match(i) ? -1 : 1;
  },
  format: function(t, e) {
    if (typeof t != "number" || typeof e == "number")
      return t;
    if (e = e && e.formatter || e, typeof e == "function")
      return e(t);
    e = this._normalizeFormat(e), e.type || (e.type = "decimal");
    var i = this._parseNumberFormatString(e.type);
    if (!i) {
      var r = this._getSeparators();
      return r.unlimitedIntegerDigits = e.unlimitedIntegerDigits, this.convertDigits(Dre(e.type, r)(t));
    }
    return this._formatNumber(t, i, e);
  },
  parse: function(t, e) {
    if (t) {
      if (e && e.parser)
        return e.parser(t);
      t = this.convertDigits(t, !0), e && typeof e != "string" && bi.log("W0011");
      var i = this.getDecimalSeparator(), r = new RegExp("[^0-9" + Eh(i) + "]", "g"), n = t.replace(r, "").replace(i, ".").replace(/\.$/g, "");
      if (n === "." || n === "")
        return null;
      if (this._calcSignificantDigits(n) > 15)
        return NaN;
      var a = +n * this.getSign(t, e);
      e = this._normalizeFormat(e);
      var o = this._parseNumberFormatString(e.type), u = o == null ? void 0 : o.power;
      if (u) {
        if (u === "auto") {
          var c = t.match(/\d(K|M|B|T)/);
          c && (u = Object.keys(DR).find((p) => DR[p] === c[1]));
        }
        a *= Math.pow(10, 3 * u);
      }
      return (o == null ? void 0 : o.formatType) === "percent" && (a /= 100), a;
    }
  },
  _calcSignificantDigits: function(t) {
    var [e, i] = t.split("."), r = (a) => {
      for (var o = -1, u = 0; u < a.length; u++)
        if (a[u] !== "0") {
          o = u;
          break;
        }
      return o > -1 ? a.length - o : 0;
    }, n = 0;
    return e && (n += r(e.split(""))), i && (n += r(i.split("").reverse())), n;
  }
});
_i.inject(Ore);
$re && _i.inject(Hre);
var Wre = {
  en: {
    Yes: "Yes",
    No: "No",
    Cancel: "Cancel",
    Close: "Close",
    Clear: "Clear",
    Done: "Done",
    Loading: "Loading...",
    Select: "Select...",
    Search: "Search",
    Back: "Back",
    OK: "OK",
    "dxCollectionWidget-noDataText": "No data to display",
    "dxDropDownEditor-selectLabel": "Select",
    "validation-required": "Required",
    "validation-required-formatted": "{0} is required",
    "validation-numeric": "Value must be a number",
    "validation-numeric-formatted": "{0} must be a number",
    "validation-range": "Value is out of range",
    "validation-range-formatted": "{0} is out of range",
    "validation-stringLength": "The length of the value is not correct",
    "validation-stringLength-formatted": "The length of {0} is not correct",
    "validation-custom": "Value is invalid",
    "validation-custom-formatted": "{0} is invalid",
    "validation-async": "Value is invalid",
    "validation-async-formatted": "{0} is invalid",
    "validation-compare": "Values do not match",
    "validation-compare-formatted": "{0} does not match",
    "validation-pattern": "Value does not match pattern",
    "validation-pattern-formatted": "{0} does not match pattern",
    "validation-email": "Email is invalid",
    "validation-email-formatted": "{0} is invalid",
    "validation-mask": "Value is invalid",
    "dxLookup-searchPlaceholder": "Minimum character number: {0}",
    "dxList-pullingDownText": "Pull down to refresh...",
    "dxList-pulledDownText": "Release to refresh...",
    "dxList-refreshingText": "Refreshing...",
    "dxList-pageLoadingText": "Loading...",
    "dxList-nextButtonText": "More",
    "dxList-selectAll": "Select All",
    "dxListEditDecorator-delete": "Delete",
    "dxListEditDecorator-more": "More",
    "dxScrollView-pullingDownText": "Pull down to refresh...",
    "dxScrollView-pulledDownText": "Release to refresh...",
    "dxScrollView-refreshingText": "Refreshing...",
    "dxScrollView-reachBottomText": "Loading...",
    "dxDateBox-simulatedDataPickerTitleTime": "Select time",
    "dxDateBox-simulatedDataPickerTitleDate": "Select date",
    "dxDateBox-simulatedDataPickerTitleDateTime": "Select date and time",
    "dxDateBox-validation-datetime": "Value must be a date or time",
    "dxDateRangeBox-invalidStartDateMessage": "Start value must be a date",
    "dxDateRangeBox-invalidEndDateMessage": "End value must be a date",
    "dxDateRangeBox-startDateOutOfRangeMessage": "Start date is out of range",
    "dxDateRangeBox-endDateOutOfRangeMessage": "End date is out of range",
    "dxDateRangeBox-startDateLabel": "Start Date",
    "dxDateRangeBox-endDateLabel": "End Date",
    "dxFileUploader-selectFile": "Select a file",
    "dxFileUploader-dropFile": "or Drop a file here",
    "dxFileUploader-bytes": "bytes",
    "dxFileUploader-kb": "KB",
    "dxFileUploader-Mb": "MB",
    "dxFileUploader-Gb": "GB",
    "dxFileUploader-upload": "Upload",
    "dxFileUploader-uploaded": "Uploaded",
    "dxFileUploader-readyToUpload": "Ready to upload",
    "dxFileUploader-uploadAbortedMessage": "Upload cancelled",
    "dxFileUploader-uploadFailedMessage": "Upload failed",
    "dxFileUploader-invalidFileExtension": "File type is not allowed",
    "dxFileUploader-invalidMaxFileSize": "File is too large",
    "dxFileUploader-invalidMinFileSize": "File is too small",
    "dxRangeSlider-ariaFrom": "From",
    "dxRangeSlider-ariaTill": "Till",
    "dxSwitch-switchedOnText": "ON",
    "dxSwitch-switchedOffText": "OFF",
    "dxForm-optionalMark": "optional",
    "dxForm-requiredMessage": "{0} is required",
    "dxNumberBox-invalidValueMessage": "Value must be a number",
    "dxNumberBox-noDataText": "No data",
    "dxDataGrid-emptyHeaderWithColumnChooserText": "Use {0} to display columns",
    "dxDataGrid-emptyHeaderWithGroupPanelText": "Drag a column from the group panel here",
    "dxDataGrid-emptyHeaderWithColumnChooserAndGroupPanelText": "Use {0} or drag a column from the group panel",
    "dxDataGrid-emptyHeaderColumnChooserText": "column chooser",
    "dxDataGrid-columnChooserTitle": "Column Chooser",
    "dxDataGrid-columnChooserEmptyText": "Drag a column here to hide it",
    "dxDataGrid-groupContinuesMessage": "Continues on the next page",
    "dxDataGrid-groupContinuedMessage": "Continued from the previous page",
    "dxDataGrid-groupHeaderText": "Group by This Column",
    "dxDataGrid-ungroupHeaderText": "Ungroup",
    "dxDataGrid-ungroupAllText": "Ungroup All",
    "dxDataGrid-editingEditRow": "Edit",
    "dxDataGrid-editingSaveRowChanges": "Save",
    "dxDataGrid-editingCancelRowChanges": "Cancel",
    "dxDataGrid-editingDeleteRow": "Delete",
    "dxDataGrid-editingUndeleteRow": "Undelete",
    "dxDataGrid-editingConfirmDeleteMessage": "Are you sure you want to delete this record?",
    "dxDataGrid-validationCancelChanges": "Cancel changes",
    "dxDataGrid-groupPanelEmptyText": "Drag a column header here to group by that column",
    "dxDataGrid-noDataText": "No data",
    "dxDataGrid-searchPanelPlaceholder": "Search...",
    "dxDataGrid-filterRowShowAllText": "(All)",
    "dxDataGrid-filterRowResetOperationText": "Reset",
    "dxDataGrid-filterRowOperationEquals": "Equals",
    "dxDataGrid-filterRowOperationNotEquals": "Does not equal",
    "dxDataGrid-filterRowOperationLess": "Less than",
    "dxDataGrid-filterRowOperationLessOrEquals": "Less than or equal to",
    "dxDataGrid-filterRowOperationGreater": "Greater than",
    "dxDataGrid-filterRowOperationGreaterOrEquals": "Greater than or equal to",
    "dxDataGrid-filterRowOperationStartsWith": "Starts with",
    "dxDataGrid-filterRowOperationContains": "Contains",
    "dxDataGrid-filterRowOperationNotContains": "Does not contain",
    "dxDataGrid-filterRowOperationEndsWith": "Ends with",
    "dxDataGrid-filterRowOperationBetween": "Between",
    "dxDataGrid-filterRowOperationBetweenStartText": "Start",
    "dxDataGrid-filterRowOperationBetweenEndText": "End",
    "dxDataGrid-ariaSearchBox": "Search box",
    "dxDataGrid-applyFilterText": "Apply filter",
    "dxDataGrid-trueText": "true",
    "dxDataGrid-falseText": "false",
    "dxDataGrid-sortingAscendingText": "Sort Ascending",
    "dxDataGrid-sortingDescendingText": "Sort Descending",
    "dxDataGrid-sortingClearText": "Clear Sorting",
    "dxDataGrid-ariaNotSortedColumn": "Not sorted column",
    "dxDataGrid-ariaSortedAscendingColumn": "Column sorted in ascending order",
    "dxDataGrid-ariaSortedDescendingColumn": "Column sorted in descending order",
    "dxDataGrid-ariaSortIndex": "Sort index {0}",
    "dxDataGrid-editingSaveAllChanges": "Save changes",
    "dxDataGrid-editingCancelAllChanges": "Discard changes",
    "dxDataGrid-editingAddRow": "Add a row",
    "dxDataGrid-summaryMin": "Min: {0}",
    "dxDataGrid-summaryMinOtherColumn": "Min of {1} is {0}",
    "dxDataGrid-summaryMax": "Max: {0}",
    "dxDataGrid-summaryMaxOtherColumn": "Max of {1} is {0}",
    "dxDataGrid-summaryAvg": "Avg: {0}",
    "dxDataGrid-summaryAvgOtherColumn": "Avg of {1} is {0}",
    "dxDataGrid-summarySum": "Sum: {0}",
    "dxDataGrid-summarySumOtherColumn": "Sum of {1} is {0}",
    "dxDataGrid-summaryCount": "Count: {0}",
    "dxDataGrid-columnFixingFix": "Fix",
    "dxDataGrid-columnFixingUnfix": "Unfix",
    "dxDataGrid-columnFixingLeftPosition": "To the left",
    "dxDataGrid-columnFixingRightPosition": "To the right",
    "dxDataGrid-exportTo": "Export",
    "dxDataGrid-exportToExcel": "Export to Excel file",
    "dxDataGrid-exporting": "Exporting...",
    "dxDataGrid-excelFormat": "Excel file",
    "dxDataGrid-selectedRows": "Selected rows",
    "dxDataGrid-exportSelectedRows": "Export selected rows to {0}",
    "dxDataGrid-exportAll": "Export all data to {0}",
    "dxDataGrid-headerFilterLabel": "Filter options",
    "dxDataGrid-headerFilterIndicatorLabel": "Show filter options for column '{0}'",
    "dxDataGrid-headerFilterEmptyValue": "(Blanks)",
    "dxDataGrid-headerFilterOK": "OK",
    "dxDataGrid-headerFilterCancel": "Cancel",
    "dxDataGrid-ariaAdaptiveCollapse": "Hide additional data",
    "dxDataGrid-ariaAdaptiveExpand": "Display additional data",
    "dxDataGrid-ariaColumn": "Column",
    "dxDataGrid-ariaColumnHeader": "Column header",
    "dxDataGrid-ariaValue": "Value",
    "dxDataGrid-ariaError": "Error",
    "dxDataGrid-ariaRevertButton": "Press Escape to discard the changes",
    "dxDataGrid-ariaFilterCell": "Filter cell",
    "dxDataGrid-ariaCollapse": "Collapse",
    "dxDataGrid-ariaModifiedCell": "Modified",
    "dxDataGrid-ariaDeletedCell": "Deleted",
    "dxDataGrid-ariaEditableCell": "Editable",
    "dxDataGrid-ariaExpand": "Expand",
    "dxDataGrid-ariaCollapsedRow": "Collapsed row",
    "dxDataGrid-ariaExpandedRow": "Expanded row",
    "dxDataGrid-ariaDataGrid": "Data grid with {0} rows and {1} columns",
    "dxDataGrid-ariaSearchInGrid": "Search in the data grid",
    "dxDataGrid-ariaSelectAll": "Select all",
    "dxDataGrid-ariaSelectRow": "Select row",
    "dxDataGrid-ariaToolbar": "Data grid toolbar",
    "dxDataGrid-ariaEditForm": "Edit form",
    "dxDataGrid-filterBuilderPopupTitle": "Filter Builder",
    "dxDataGrid-filterPanelCreateFilter": "Create Filter",
    "dxDataGrid-filterPanelClearFilter": "Clear",
    "dxDataGrid-filterPanelFilterEnabledHint": "Enable the filter",
    "dxTreeList-ariaTreeList": "Tree list with {0} rows and {1} columns",
    "dxTreeList-ariaSearchInGrid": "Search in the tree list",
    "dxTreeList-ariaToolbar": "Tree list toolbar",
    "dxTreeList-editingAddRowToNode": "Add",
    "dxPager-infoText": "Page {0} of {1} ({2} items)",
    "dxPager-pagesCountText": "of",
    "dxPager-pageSize": "Items per page: {0}",
    "dxPager-pageSizesAllText": "All",
    "dxPager-page": "Page {0}",
    "dxPager-prevPage": "Previous Page",
    "dxPager-nextPage": "Next Page",
    "dxPager-ariaLabel": "Page Navigation",
    "dxPager-ariaPageSize": "Page size",
    "dxPager-ariaPageNumber": "Page number",
    "dxPivotGrid-grandTotal": "Grand Total",
    "dxPivotGrid-total": "{0} Total",
    "dxPivotGrid-fieldChooserTitle": "Field Chooser",
    "dxPivotGrid-showFieldChooser": "Show Field Chooser",
    "dxPivotGrid-expandAll": "Expand All",
    "dxPivotGrid-collapseAll": "Collapse All",
    "dxPivotGrid-sortColumnBySummary": 'Sort "{0}" by This Column',
    "dxPivotGrid-sortRowBySummary": 'Sort "{0}" by This Row',
    "dxPivotGrid-removeAllSorting": "Remove All Sorting",
    "dxPivotGrid-dataNotAvailable": "N/A",
    "dxPivotGrid-rowFields": "Row Fields",
    "dxPivotGrid-columnFields": "Column Fields",
    "dxPivotGrid-dataFields": "Data Fields",
    "dxPivotGrid-filterFields": "Filter Fields",
    "dxPivotGrid-allFields": "All Fields",
    "dxPivotGrid-columnFieldArea": "Drop Column Fields Here",
    "dxPivotGrid-dataFieldArea": "Drop Data Fields Here",
    "dxPivotGrid-rowFieldArea": "Drop Row Fields Here",
    "dxPivotGrid-filterFieldArea": "Drop Filter Fields Here",
    "dxScheduler-editorLabelTitle": "Subject",
    "dxScheduler-editorLabelStartDate": "Start Date",
    "dxScheduler-editorLabelEndDate": "End Date",
    "dxScheduler-editorLabelDescription": "Description",
    "dxScheduler-editorLabelRecurrence": "Repeat",
    "dxScheduler-openAppointment": "Open appointment",
    "dxScheduler-recurrenceNever": "Never",
    "dxScheduler-recurrenceMinutely": "Every minute",
    "dxScheduler-recurrenceHourly": "Hourly",
    "dxScheduler-recurrenceDaily": "Daily",
    "dxScheduler-recurrenceWeekly": "Weekly",
    "dxScheduler-recurrenceMonthly": "Monthly",
    "dxScheduler-recurrenceYearly": "Yearly",
    "dxScheduler-recurrenceRepeatEvery": "Repeat Every",
    "dxScheduler-recurrenceRepeatOn": "Repeat On",
    "dxScheduler-recurrenceEnd": "End repeat",
    "dxScheduler-recurrenceAfter": "After",
    "dxScheduler-recurrenceOn": "On",
    "dxScheduler-recurrenceRepeatMinutely": "minute(s)",
    "dxScheduler-recurrenceRepeatHourly": "hour(s)",
    "dxScheduler-recurrenceRepeatDaily": "day(s)",
    "dxScheduler-recurrenceRepeatWeekly": "week(s)",
    "dxScheduler-recurrenceRepeatMonthly": "month(s)",
    "dxScheduler-recurrenceRepeatYearly": "year(s)",
    "dxScheduler-switcherDay": "Day",
    "dxScheduler-switcherWeek": "Week",
    "dxScheduler-switcherWorkWeek": "Work Week",
    "dxScheduler-switcherMonth": "Month",
    "dxScheduler-switcherAgenda": "Agenda",
    "dxScheduler-switcherTimelineDay": "Timeline Day",
    "dxScheduler-switcherTimelineWeek": "Timeline Week",
    "dxScheduler-switcherTimelineWorkWeek": "Timeline Work Week",
    "dxScheduler-switcherTimelineMonth": "Timeline Month",
    "dxScheduler-recurrenceRepeatOnDate": "on date",
    "dxScheduler-recurrenceRepeatCount": "occurrence(s)",
    "dxScheduler-allDay": "All day",
    "dxScheduler-confirmRecurrenceEditTitle": "Edit Recurring Appointment",
    "dxScheduler-confirmRecurrenceDeleteTitle": "Delete Recurring Appointment",
    "dxScheduler-confirmRecurrenceEditMessage": "Do you want to edit only this appointment or the whole series?",
    "dxScheduler-confirmRecurrenceDeleteMessage": "Do you want to delete only this appointment or the whole series?",
    "dxScheduler-confirmRecurrenceEditSeries": "Edit series",
    "dxScheduler-confirmRecurrenceDeleteSeries": "Delete series",
    "dxScheduler-confirmRecurrenceEditOccurrence": "Edit appointment",
    "dxScheduler-confirmRecurrenceDeleteOccurrence": "Delete appointment",
    "dxScheduler-noTimezoneTitle": "No timezone",
    "dxScheduler-moreAppointments": "{0} more",
    "dxCalendar-todayButtonText": "Today",
    "dxCalendar-ariaWidgetName": "Calendar",
    "dxCalendar-previousMonthButtonLabel": "Previous month",
    "dxCalendar-previousYearButtonLabel": "Previous year",
    "dxCalendar-previousDecadeButtonLabel": "Previous decade",
    "dxCalendar-previousCenturyButtonLabel": "Previous century",
    "dxCalendar-nextMonthButtonLabel": "Next month",
    "dxCalendar-nextYearButtonLabel": "Next year",
    "dxCalendar-nextDecadeButtonLabel": "Next decade",
    "dxCalendar-nextCenturyButtonLabel": "Next century",
    "dxCalendar-captionMonthLabel": "Month selection",
    "dxCalendar-captionYearLabel": "Year selection",
    "dxCalendar-captionDecadeLabel": "Decade selection",
    "dxCalendar-captionCenturyLabel": "Century selection",
    "dxColorView-ariaRed": "Red",
    "dxColorView-ariaGreen": "Green",
    "dxColorView-ariaBlue": "Blue",
    "dxColorView-ariaAlpha": "Transparency",
    "dxColorView-ariaHex": "Color code",
    "dxTagBox-selected": "{0} selected",
    "dxTagBox-allSelected": "All selected ({0})",
    "dxTagBox-moreSelected": "{0} more",
    "vizExport-printingButtonText": "Print",
    "vizExport-titleMenuText": "Exporting/Printing",
    "vizExport-exportButtonText": "{0} file",
    "dxFilterBuilder-and": "And",
    "dxFilterBuilder-or": "Or",
    "dxFilterBuilder-notAnd": "Not And",
    "dxFilterBuilder-notOr": "Not Or",
    "dxFilterBuilder-addCondition": "Add Condition",
    "dxFilterBuilder-addGroup": "Add Group",
    "dxFilterBuilder-enterValueText": "<enter a value>",
    "dxFilterBuilder-filterOperationEquals": "Equals",
    "dxFilterBuilder-filterOperationNotEquals": "Does not equal",
    "dxFilterBuilder-filterOperationLess": "Is less than",
    "dxFilterBuilder-filterOperationLessOrEquals": "Is less than or equal to",
    "dxFilterBuilder-filterOperationGreater": "Is greater than",
    "dxFilterBuilder-filterOperationGreaterOrEquals": "Is greater than or equal to",
    "dxFilterBuilder-filterOperationStartsWith": "Starts with",
    "dxFilterBuilder-filterOperationContains": "Contains",
    "dxFilterBuilder-filterOperationNotContains": "Does not contain",
    "dxFilterBuilder-filterOperationEndsWith": "Ends with",
    "dxFilterBuilder-filterOperationIsBlank": "Is blank",
    "dxFilterBuilder-filterOperationIsNotBlank": "Is not blank",
    "dxFilterBuilder-filterOperationBetween": "Is between",
    "dxFilterBuilder-filterOperationAnyOf": "Is any of",
    "dxFilterBuilder-filterOperationNoneOf": "Is none of",
    "dxHtmlEditor-dialogColorCaption": "Change Font Color",
    "dxHtmlEditor-dialogBackgroundCaption": "Change Background Color",
    "dxHtmlEditor-dialogLinkCaption": "Add Link",
    "dxHtmlEditor-dialogLinkUrlField": "URL",
    "dxHtmlEditor-dialogLinkTextField": "Text",
    "dxHtmlEditor-dialogLinkTargetField": "Open link in new window",
    "dxHtmlEditor-dialogImageCaption": "Add Image",
    "dxHtmlEditor-dialogImageUrlField": "URL",
    "dxHtmlEditor-dialogImageAltField": "Alternate text",
    "dxHtmlEditor-dialogImageWidthField": "Width (px)",
    "dxHtmlEditor-dialogImageHeightField": "Height (px)",
    "dxHtmlEditor-dialogInsertTableRowsField": "Rows",
    "dxHtmlEditor-dialogInsertTableColumnsField": "Columns",
    "dxHtmlEditor-dialogInsertTableCaption": "Insert Table",
    "dxHtmlEditor-dialogUpdateImageCaption": "Update Image",
    "dxHtmlEditor-dialogImageUpdateButton": "Update",
    "dxHtmlEditor-dialogImageAddButton": "Add",
    "dxHtmlEditor-dialogImageSpecifyUrl": "From the Web",
    "dxHtmlEditor-dialogImageSelectFile": "From This Device",
    "dxHtmlEditor-dialogImageKeepAspectRatio": "Keep Aspect Ratio",
    "dxHtmlEditor-dialogImageEncodeToBase64": "Encode to Base64",
    "dxHtmlEditor-heading": "Heading",
    "dxHtmlEditor-normalText": "Normal text",
    "dxHtmlEditor-background": "Background Color",
    "dxHtmlEditor-bold": "Bold",
    "dxHtmlEditor-color": "Font Color",
    "dxHtmlEditor-font": "Font",
    "dxHtmlEditor-italic": "Italic",
    "dxHtmlEditor-link": "Add Link",
    "dxHtmlEditor-image": "Add Image",
    "dxHtmlEditor-size": "Size",
    "dxHtmlEditor-strike": "Strikethrough",
    "dxHtmlEditor-subscript": "Subscript",
    "dxHtmlEditor-superscript": "Superscript",
    "dxHtmlEditor-underline": "Underline",
    "dxHtmlEditor-blockquote": "Blockquote",
    "dxHtmlEditor-header": "Header",
    "dxHtmlEditor-increaseIndent": "Increase Indent",
    "dxHtmlEditor-decreaseIndent": "Decrease Indent",
    "dxHtmlEditor-orderedList": "Ordered List",
    "dxHtmlEditor-bulletList": "Bullet List",
    "dxHtmlEditor-alignLeft": "Align Left",
    "dxHtmlEditor-alignCenter": "Align Center",
    "dxHtmlEditor-alignRight": "Align Right",
    "dxHtmlEditor-alignJustify": "Align Justify",
    "dxHtmlEditor-codeBlock": "Code Block",
    "dxHtmlEditor-variable": "Add Variable",
    "dxHtmlEditor-undo": "Undo",
    "dxHtmlEditor-redo": "Redo",
    "dxHtmlEditor-clear": "Clear Formatting",
    "dxHtmlEditor-insertTable": "Insert Table",
    "dxHtmlEditor-insertHeaderRow": "Insert Header Row",
    "dxHtmlEditor-insertRowAbove": "Insert Row Above",
    "dxHtmlEditor-insertRowBelow": "Insert Row Below",
    "dxHtmlEditor-insertColumnLeft": "Insert Column Left",
    "dxHtmlEditor-insertColumnRight": "Insert Column Right",
    "dxHtmlEditor-deleteColumn": "Delete Column",
    "dxHtmlEditor-deleteRow": "Delete Row",
    "dxHtmlEditor-deleteTable": "Delete Table",
    "dxHtmlEditor-cellProperties": "Cell Properties",
    "dxHtmlEditor-tableProperties": "Table Properties",
    "dxHtmlEditor-insert": "Insert",
    "dxHtmlEditor-delete": "Delete",
    "dxHtmlEditor-border": "Border",
    "dxHtmlEditor-style": "Style",
    "dxHtmlEditor-width": "Width",
    "dxHtmlEditor-height": "Height",
    "dxHtmlEditor-borderColor": "Color",
    "dxHtmlEditor-tableBackground": "Background",
    "dxHtmlEditor-dimensions": "Dimensions",
    "dxHtmlEditor-alignment": "Alignment",
    "dxHtmlEditor-horizontal": "Horizontal",
    "dxHtmlEditor-vertical": "Vertical",
    "dxHtmlEditor-paddingVertical": "Vertical Padding",
    "dxHtmlEditor-paddingHorizontal": "Horizontal Padding",
    "dxHtmlEditor-pixels": "Pixels",
    "dxHtmlEditor-list": "List",
    "dxHtmlEditor-ordered": "Ordered",
    "dxHtmlEditor-bullet": "Bullet",
    "dxHtmlEditor-align": "Align",
    "dxHtmlEditor-center": "Center",
    "dxHtmlEditor-left": "Left",
    "dxHtmlEditor-right": "Right",
    "dxHtmlEditor-indent": "Indent",
    "dxHtmlEditor-justify": "Justify",
    "dxHtmlEditor-borderStyleNone": "none",
    "dxHtmlEditor-borderStyleHidden": "hidden",
    "dxHtmlEditor-borderStyleDotted": "dotted",
    "dxHtmlEditor-borderStyleDashed": "dashed",
    "dxHtmlEditor-borderStyleSolid": "solid",
    "dxHtmlEditor-borderStyleDouble": "double",
    "dxHtmlEditor-borderStyleGroove": "groove",
    "dxHtmlEditor-borderStyleRidge": "ridge",
    "dxHtmlEditor-borderStyleInset": "inset",
    "dxHtmlEditor-borderStyleOutset": "outset",
    "dxFileManager-newDirectoryName": "Untitled directory",
    "dxFileManager-rootDirectoryName": "Files",
    "dxFileManager-errorNoAccess": "Access Denied. Operation could not be completed.",
    "dxFileManager-errorDirectoryExistsFormat": "Directory '{0}' already exists.",
    "dxFileManager-errorFileExistsFormat": "File '{0}' already exists.",
    "dxFileManager-errorFileNotFoundFormat": "File '{0}' not found.",
    "dxFileManager-errorDirectoryNotFoundFormat": "Directory '{0}' not found.",
    "dxFileManager-errorWrongFileExtension": "File extension is not allowed.",
    "dxFileManager-errorMaxFileSizeExceeded": "File size exceeds the maximum allowed size.",
    "dxFileManager-errorInvalidSymbols": "This name contains invalid characters.",
    "dxFileManager-errorDefault": "Unspecified error.",
    "dxFileManager-errorDirectoryOpenFailed": "The directory cannot be opened",
    "dxFileManager-commandCreate": "New directory",
    "dxFileManager-commandRename": "Rename",
    "dxFileManager-commandMove": "Move to",
    "dxFileManager-commandCopy": "Copy to",
    "dxFileManager-commandDelete": "Delete",
    "dxFileManager-commandDownload": "Download",
    "dxFileManager-commandUpload": "Upload files",
    "dxFileManager-commandRefresh": "Refresh",
    "dxFileManager-commandThumbnails": "Thumbnails View",
    "dxFileManager-commandDetails": "Details View",
    "dxFileManager-commandClearSelection": "Clear selection",
    "dxFileManager-commandShowNavPane": "Toggle navigation pane",
    "dxFileManager-dialogDirectoryChooserMoveTitle": "Move to",
    "dxFileManager-dialogDirectoryChooserMoveButtonText": "Move",
    "dxFileManager-dialogDirectoryChooserCopyTitle": "Copy to",
    "dxFileManager-dialogDirectoryChooserCopyButtonText": "Copy",
    "dxFileManager-dialogRenameItemTitle": "Rename",
    "dxFileManager-dialogRenameItemButtonText": "Save",
    "dxFileManager-dialogCreateDirectoryTitle": "New directory",
    "dxFileManager-dialogCreateDirectoryButtonText": "Create",
    "dxFileManager-dialogDeleteItemTitle": "Delete",
    "dxFileManager-dialogDeleteItemButtonText": "Delete",
    "dxFileManager-dialogDeleteItemSingleItemConfirmation": "Are you sure you want to delete {0}?",
    "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "Are you sure you want to delete {0} items?",
    "dxFileManager-dialogButtonCancel": "Cancel",
    "dxFileManager-editingCreateSingleItemProcessingMessage": "Creating a directory inside {0}",
    "dxFileManager-editingCreateSingleItemSuccessMessage": "Created a directory inside {0}",
    "dxFileManager-editingCreateSingleItemErrorMessage": "Directory was not created",
    "dxFileManager-editingCreateCommonErrorMessage": "Directory was not created",
    "dxFileManager-editingRenameSingleItemProcessingMessage": "Renaming an item inside {0}",
    "dxFileManager-editingRenameSingleItemSuccessMessage": "Renamed an item inside {0}",
    "dxFileManager-editingRenameSingleItemErrorMessage": "Item was not renamed",
    "dxFileManager-editingRenameCommonErrorMessage": "Item was not renamed",
    "dxFileManager-editingDeleteSingleItemProcessingMessage": "Deleting an item from {0}",
    "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "Deleting {0} items from {1}",
    "dxFileManager-editingDeleteSingleItemSuccessMessage": "Deleted an item from {0}",
    "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "Deleted {0} items from {1}",
    "dxFileManager-editingDeleteSingleItemErrorMessage": "Item was not deleted",
    "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} items were not deleted",
    "dxFileManager-editingDeleteCommonErrorMessage": "Some items were not deleted",
    "dxFileManager-editingMoveSingleItemProcessingMessage": "Moving an item to {0}",
    "dxFileManager-editingMoveMultipleItemsProcessingMessage": "Moving {0} items to {1}",
    "dxFileManager-editingMoveSingleItemSuccessMessage": "Moved an item to {0}",
    "dxFileManager-editingMoveMultipleItemsSuccessMessage": "Moved {0} items to {1}",
    "dxFileManager-editingMoveSingleItemErrorMessage": "Item was not moved",
    "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} items were not moved",
    "dxFileManager-editingMoveCommonErrorMessage": "Some items were not moved",
    "dxFileManager-editingCopySingleItemProcessingMessage": "Copying an item to {0}",
    "dxFileManager-editingCopyMultipleItemsProcessingMessage": "Copying {0} items to {1}",
    "dxFileManager-editingCopySingleItemSuccessMessage": "Copied an item to {0}",
    "dxFileManager-editingCopyMultipleItemsSuccessMessage": "Copied {0} items to {1}",
    "dxFileManager-editingCopySingleItemErrorMessage": "Item was not copied",
    "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} items were not copied",
    "dxFileManager-editingCopyCommonErrorMessage": "Some items were not copied",
    "dxFileManager-editingUploadSingleItemProcessingMessage": "Uploading an item to {0}",
    "dxFileManager-editingUploadMultipleItemsProcessingMessage": "Uploading {0} items to {1}",
    "dxFileManager-editingUploadSingleItemSuccessMessage": "Uploaded an item to {0}",
    "dxFileManager-editingUploadMultipleItemsSuccessMessage": "Uploaded {0} items to {1}",
    "dxFileManager-editingUploadSingleItemErrorMessage": "Item was not uploaded",
    "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} items were not uploaded",
    "dxFileManager-editingUploadCanceledMessage": "Canceled",
    "dxFileManager-editingDownloadSingleItemErrorMessage": "Item was not downloaded",
    "dxFileManager-editingDownloadMultipleItemsErrorMessage": "{0} items were not downloaded",
    "dxFileManager-listDetailsColumnCaptionName": "Name",
    "dxFileManager-listDetailsColumnCaptionDateModified": "Date Modified",
    "dxFileManager-listDetailsColumnCaptionFileSize": "File Size",
    "dxFileManager-listThumbnailsTooltipTextSize": "Size",
    "dxFileManager-listThumbnailsTooltipTextDateModified": "Date Modified",
    "dxFileManager-notificationProgressPanelTitle": "Progress",
    "dxFileManager-notificationProgressPanelEmptyListText": "No operations",
    "dxFileManager-notificationProgressPanelOperationCanceled": "Canceled",
    "dxDiagram-categoryGeneral": "General",
    "dxDiagram-categoryFlowchart": "Flowchart",
    "dxDiagram-categoryOrgChart": "Org Chart",
    "dxDiagram-categoryContainers": "Containers",
    "dxDiagram-categoryCustom": "Custom",
    "dxDiagram-commandExportToSvg": "Export to SVG",
    "dxDiagram-commandExportToPng": "Export to PNG",
    "dxDiagram-commandExportToJpg": "Export to JPEG",
    "dxDiagram-commandUndo": "Undo",
    "dxDiagram-commandRedo": "Redo",
    "dxDiagram-commandFontName": "Font Name",
    "dxDiagram-commandFontSize": "Font Size",
    "dxDiagram-commandBold": "Bold",
    "dxDiagram-commandItalic": "Italic",
    "dxDiagram-commandUnderline": "Underline",
    "dxDiagram-commandTextColor": "Font Color",
    "dxDiagram-commandLineColor": "Line Color",
    "dxDiagram-commandLineWidth": "Line Width",
    "dxDiagram-commandLineStyle": "Line Style",
    "dxDiagram-commandLineStyleSolid": "Solid",
    "dxDiagram-commandLineStyleDotted": "Dotted",
    "dxDiagram-commandLineStyleDashed": "Dashed",
    "dxDiagram-commandFillColor": "Fill Color",
    "dxDiagram-commandAlignLeft": "Align Left",
    "dxDiagram-commandAlignCenter": "Align Center",
    "dxDiagram-commandAlignRight": "Align Right",
    "dxDiagram-commandConnectorLineType": "Connector Line Type",
    "dxDiagram-commandConnectorLineStraight": "Straight",
    "dxDiagram-commandConnectorLineOrthogonal": "Orthogonal",
    "dxDiagram-commandConnectorLineStart": "Connector Line Start",
    "dxDiagram-commandConnectorLineEnd": "Connector Line End",
    "dxDiagram-commandConnectorLineNone": "None",
    "dxDiagram-commandConnectorLineArrow": "Arrow",
    "dxDiagram-commandFullscreen": "Full Screen",
    "dxDiagram-commandUnits": "Units",
    "dxDiagram-commandPageSize": "Page Size",
    "dxDiagram-commandPageOrientation": "Page Orientation",
    "dxDiagram-commandPageOrientationLandscape": "Landscape",
    "dxDiagram-commandPageOrientationPortrait": "Portrait",
    "dxDiagram-commandPageColor": "Page Color",
    "dxDiagram-commandShowGrid": "Show Grid",
    "dxDiagram-commandSnapToGrid": "Snap to Grid",
    "dxDiagram-commandGridSize": "Grid Size",
    "dxDiagram-commandZoomLevel": "Zoom Level",
    "dxDiagram-commandAutoZoom": "Auto Zoom",
    "dxDiagram-commandFitToContent": "Fit to Content",
    "dxDiagram-commandFitToWidth": "Fit to Width",
    "dxDiagram-commandAutoZoomByContent": "Auto Zoom by Content",
    "dxDiagram-commandAutoZoomByWidth": "Auto Zoom by Width",
    "dxDiagram-commandSimpleView": "Simple View",
    "dxDiagram-commandCut": "Cut",
    "dxDiagram-commandCopy": "Copy",
    "dxDiagram-commandPaste": "Paste",
    "dxDiagram-commandSelectAll": "Select All",
    "dxDiagram-commandDelete": "Delete",
    "dxDiagram-commandBringToFront": "Bring to Front",
    "dxDiagram-commandSendToBack": "Send to Back",
    "dxDiagram-commandLock": "Lock",
    "dxDiagram-commandUnlock": "Unlock",
    "dxDiagram-commandInsertShapeImage": "Insert Image...",
    "dxDiagram-commandEditShapeImage": "Change Image...",
    "dxDiagram-commandDeleteShapeImage": "Delete Image",
    "dxDiagram-commandLayoutLeftToRight": "Left-to-right",
    "dxDiagram-commandLayoutRightToLeft": "Right-to-left",
    "dxDiagram-commandLayoutTopToBottom": "Top-to-bottom",
    "dxDiagram-commandLayoutBottomToTop": "Bottom-to-top",
    "dxDiagram-unitIn": "in",
    "dxDiagram-unitCm": "cm",
    "dxDiagram-unitPx": "px",
    "dxDiagram-dialogButtonOK": "OK",
    "dxDiagram-dialogButtonCancel": "Cancel",
    "dxDiagram-dialogInsertShapeImageTitle": "Insert Image",
    "dxDiagram-dialogEditShapeImageTitle": "Change Image",
    "dxDiagram-dialogEditShapeImageSelectButton": "Select image",
    "dxDiagram-dialogEditShapeImageLabelText": "or drop a file here",
    "dxDiagram-uiExport": "Export",
    "dxDiagram-uiProperties": "Properties",
    "dxDiagram-uiSettings": "Settings",
    "dxDiagram-uiShowToolbox": "Show Toolbox",
    "dxDiagram-uiSearch": "Search",
    "dxDiagram-uiStyle": "Style",
    "dxDiagram-uiLayout": "Layout",
    "dxDiagram-uiLayoutTree": "Tree",
    "dxDiagram-uiLayoutLayered": "Layered",
    "dxDiagram-uiDiagram": "Diagram",
    "dxDiagram-uiText": "Text",
    "dxDiagram-uiObject": "Object",
    "dxDiagram-uiConnector": "Connector",
    "dxDiagram-uiPage": "Page",
    "dxDiagram-shapeText": "Text",
    "dxDiagram-shapeRectangle": "Rectangle",
    "dxDiagram-shapeEllipse": "Ellipse",
    "dxDiagram-shapeCross": "Cross",
    "dxDiagram-shapeTriangle": "Triangle",
    "dxDiagram-shapeDiamond": "Diamond",
    "dxDiagram-shapeHeart": "Heart",
    "dxDiagram-shapePentagon": "Pentagon",
    "dxDiagram-shapeHexagon": "Hexagon",
    "dxDiagram-shapeOctagon": "Octagon",
    "dxDiagram-shapeStar": "Star",
    "dxDiagram-shapeArrowLeft": "Left Arrow",
    "dxDiagram-shapeArrowUp": "Up Arrow",
    "dxDiagram-shapeArrowRight": "Right Arrow",
    "dxDiagram-shapeArrowDown": "Down Arrow",
    "dxDiagram-shapeArrowUpDown": "Up Down Arrow",
    "dxDiagram-shapeArrowLeftRight": "Left Right Arrow",
    "dxDiagram-shapeProcess": "Process",
    "dxDiagram-shapeDecision": "Decision",
    "dxDiagram-shapeTerminator": "Terminator",
    "dxDiagram-shapePredefinedProcess": "Predefined Process",
    "dxDiagram-shapeDocument": "Document",
    "dxDiagram-shapeMultipleDocuments": "Multiple Documents",
    "dxDiagram-shapeManualInput": "Manual Input",
    "dxDiagram-shapePreparation": "Preparation",
    "dxDiagram-shapeData": "Data",
    "dxDiagram-shapeDatabase": "Database",
    "dxDiagram-shapeHardDisk": "Hard Disk",
    "dxDiagram-shapeInternalStorage": "Internal Storage",
    "dxDiagram-shapePaperTape": "Paper Tape",
    "dxDiagram-shapeManualOperation": "Manual Operation",
    "dxDiagram-shapeDelay": "Delay",
    "dxDiagram-shapeStoredData": "Stored Data",
    "dxDiagram-shapeDisplay": "Display",
    "dxDiagram-shapeMerge": "Merge",
    "dxDiagram-shapeConnector": "Connector",
    "dxDiagram-shapeOr": "Or",
    "dxDiagram-shapeSummingJunction": "Summing Junction",
    "dxDiagram-shapeContainerDefaultText": "Container",
    "dxDiagram-shapeVerticalContainer": "Vertical Container",
    "dxDiagram-shapeHorizontalContainer": "Horizontal Container",
    "dxDiagram-shapeCardDefaultText": "Person's Name",
    "dxDiagram-shapeCardWithImageOnLeft": "Card with Image on the Left",
    "dxDiagram-shapeCardWithImageOnTop": "Card with Image on the Top",
    "dxDiagram-shapeCardWithImageOnRight": "Card with Image on the Right",
    "dxGantt-dialogTitle": "Title",
    "dxGantt-dialogStartTitle": "Start",
    "dxGantt-dialogEndTitle": "End",
    "dxGantt-dialogProgressTitle": "Progress",
    "dxGantt-dialogResourcesTitle": "Resources",
    "dxGantt-dialogResourceManagerTitle": "Resource Manager",
    "dxGantt-dialogTaskDetailsTitle": "Task Details",
    "dxGantt-dialogEditResourceListHint": "Edit Resource List",
    "dxGantt-dialogEditNoResources": "No resources",
    "dxGantt-dialogButtonAdd": "Add",
    "dxGantt-contextMenuNewTask": "New Task",
    "dxGantt-contextMenuNewSubtask": "New Subtask",
    "dxGantt-contextMenuDeleteTask": "Delete Task",
    "dxGantt-contextMenuDeleteDependency": "Delete Dependency",
    "dxGantt-dialogTaskDeleteConfirmation": "Deleting a task also deletes all its dependencies and subtasks. Are you sure you want to delete this task?",
    "dxGantt-dialogDependencyDeleteConfirmation": "Are you sure you want to delete the dependency from the task?",
    "dxGantt-dialogResourcesDeleteConfirmation": "Deleting a resource also deletes it from tasks to which this resource is assigned. Are you sure you want to delete these resources? Resources: {0}",
    "dxGantt-dialogConstraintCriticalViolationMessage": "The task you are attempting to move is linked to a second task by a dependency relation. This change would conflict with dependency rules. How would you like to proceed?",
    "dxGantt-dialogConstraintViolationMessage": "The task you are attempting to move is linked to a second task by a dependency relation. How would you like to proceed?",
    "dxGantt-dialogCancelOperationMessage": "Cancel the operation",
    "dxGantt-dialogDeleteDependencyMessage": "Delete the dependency",
    "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "Move the task and keep the dependency",
    "dxGantt-dialogConstraintCriticalViolationSeveralTasksMessage": "The task you are attempting to move is linked to another tasks by dependency relations. This change would conflict with dependency rules. How would you like to proceed?",
    "dxGantt-dialogConstraintViolationSeveralTasksMessage": "The task you are attempting to move is linked to another tasks by dependency relations. How would you like to proceed?",
    "dxGantt-dialogDeleteDependenciesMessage": "Delete the dependency relations",
    "dxGantt-dialogMoveTaskAndKeepDependenciesMessage": "Move the task and keep the dependencies",
    "dxGantt-undo": "Undo",
    "dxGantt-redo": "Redo",
    "dxGantt-expandAll": "Expand All",
    "dxGantt-collapseAll": "Collapse All",
    "dxGantt-addNewTask": "Add New Task",
    "dxGantt-deleteSelectedTask": "Delete Selected Task",
    "dxGantt-zoomIn": "Zoom In",
    "dxGantt-zoomOut": "Zoom Out",
    "dxGantt-fullScreen": "Full Screen",
    "dxGantt-quarter": "Q{0}",
    "dxGantt-sortingAscendingText": "Sort Ascending",
    "dxGantt-sortingDescendingText": "Sort Descending",
    "dxGantt-sortingClearText": "Clear Sorting",
    "dxGantt-showResources": "Show Resources",
    "dxGantt-showDependencies": "Show Dependencies",
    "dxGantt-dialogStartDateValidation": "Start date must be after {0}",
    "dxGantt-dialogEndDateValidation": "End date must be after {0}",
    "dxGallery-itemName": "Gallery item",
    "dxMultiView-elementAriaRoleDescription": "MultiView",
    "dxMultiView-elementAriaLabel": "Use the arrow keys or swipe to navigate between views",
    "dxMultiView-itemAriaRoleDescription": "View",
    "dxMultiView-itemAriaLabel": "{0} of {1}"
  }
}, Ure = P(!0, {}, Wre), Gre = (t, e) => {
  var i;
  return t[e] || (e == null ? void 0 : e.toLowerCase) && ((i = Object.entries(t).find((r) => {
    var [n] = r;
    return n.toLowerCase() === e.toLowerCase();
  })) === null || i === void 0 ? void 0 : i[1]) || {};
}, AR = {}, X = js({
  engine: function() {
    return "base";
  },
  _dictionary: Ure,
  load: function(t) {
    P(!0, this._dictionary, t);
  },
  _localizablePrefix: "@",
  setup: function(t) {
    this._localizablePrefix = t;
  },
  localizeString: function(t) {
    var e = this, i = new RegExp("(^|[^a-zA-Z_0-9" + e._localizablePrefix + "-]+)(" + e._localizablePrefix + "{1,2})([a-zA-Z_0-9-]+)", "g"), r = e._localizablePrefix + e._localizablePrefix;
    return t.replace(i, (n, a, o, u) => {
      var c = e._localizablePrefix + u, p;
      return o !== r && (p = e.format(u)), p || (AR[u] = Qie(u)), a + (p || c);
    });
  },
  getMessagesByLocales: function() {
    return this._dictionary;
  },
  getDictionary: function(t) {
    return t ? AR : P({}, AR, this.getMessagesByLocales()[Wo.locale()]);
  },
  getFormatter: function(t) {
    return this._getFormatterBase(t) || this._getFormatterBase(t, "en");
  },
  _getFormatterBase: function(t, e) {
    var i = Wo.getValueByClosestLocale((r) => Gre(this._dictionary, r)[t]);
    if (i)
      return function() {
        var r = arguments.length === 1 && Array.isArray(arguments[0]) ? arguments[0].slice(0) : Array.prototype.slice.call(arguments, 0);
        return r.unshift(i), Mu.apply(this, r);
      };
  },
  format: function(t) {
    var e = this.getFormatter(t), i = Array.prototype.slice.call(arguments, 1);
    return e && e.apply(this, i) || "";
  }
}), Kre = /^[\d\w.+_-]+@[\d\w._-]+\.[\w]+$/i, Xr = {
  valid: "valid",
  invalid: "invalid",
  pending: "pending"
};
class Ph {
  constructor() {
    this.NAME = "base";
  }
  defaultMessage(e) {
    return X.getFormatter("validation-".concat(this.NAME))(e);
  }
  defaultFormattedMessage(e) {
    return X.getFormatter("validation-".concat(this.NAME, "-formatted"))(e);
  }
  _isValueEmpty(e) {
    return !Qx.required.validate(e, {});
  }
  validate(e, i) {
    var r = Array.isArray(e) ? e : [e], n = !0;
    return r.length ? r.every((a) => (n = this._validate(a, i), n)) : n = this._validate(null, i), n;
  }
}
class jre extends Ph {
  constructor() {
    super(), this.NAME = "required";
  }
  _validate(e, i) {
    return !R(e) || e === !1 ? !1 : (e = String(e), (i.trim || !R(i.trim)) && (e = e.trim()), e !== "");
  }
}
class Yre extends Ph {
  constructor() {
    super(), this.NAME = "numeric";
  }
  _validate(e, i) {
    return i.ignoreEmptyValue !== !1 && this._isValueEmpty(e) ? !0 : i.useCultureSettings && ht(e) ? !isNaN(_i.parse(e)) : Di(e);
  }
}
class qre extends Ph {
  constructor() {
    super(), this.NAME = "range";
  }
  _validate(e, i) {
    if (i.ignoreEmptyValue !== !1 && this._isValueEmpty(e))
      return !0;
    var r = Qx.numeric.validate(e, i), n = R(e) && e !== "", a = r ? parseFloat(e) : n && e.valueOf(), o = i.min, u = i.max;
    if (!(r || zo(e)) && !n)
      return !1;
    if (R(o))
      return R(u) ? a >= o && a <= u : a >= o;
    if (R(u))
      return a <= u;
    throw bi.Error("E0101");
  }
}
class Xre extends Ph {
  constructor() {
    super(), this.NAME = "stringLength";
  }
  _validate(e, i) {
    var r;
    return e = String((r = e) !== null && r !== void 0 ? r : ""), (i.trim || !R(i.trim)) && (e = e.trim()), i.ignoreEmptyValue && this._isValueEmpty(e) ? !0 : Qx.range.validate(e.length, P({}, i));
  }
}
class Aj extends Ph {
  constructor() {
    super(), this.NAME = "custom";
  }
  validate(e, i) {
    if (i.ignoreEmptyValue && this._isValueEmpty(e))
      return !0;
    var r = i.validator, n = r && Le(r.option) && r.option("dataGetter"), a = Le(n) && n(), o = {
      value: e,
      validator: r,
      rule: i
    };
    return a && P(o, a), i.validationCallback(o);
  }
}
class Qre extends Aj {
  constructor() {
    super(), this.NAME = "async";
  }
  validate(e, i) {
    if (R(i.reevaluate) || P(i, {
      reevaluate: !0
    }), i.ignoreEmptyValue && this._isValueEmpty(e))
      return !0;
    var r = i.validator, n = r && Le(r.option) && r.option("dataGetter"), a = Le(n) && n(), o = {
      value: e,
      validator: r,
      rule: i
    };
    a && P(o, a);
    var u = i.validationCallback(o);
    if (!Vm(u))
      throw bi.Error("E0103");
    return this._getWrappedPromise(Pn(u).promise());
  }
  _getWrappedPromise(e) {
    var i = new q();
    return e.then(function(r) {
      i.resolve(r);
    }, function(r) {
      var n = {
        isValid: !1
      };
      R(r) && (ht(r) ? n.message = r : ct(r) && R(r.message) && ht(r.message) && (n.message = r.message)), i.resolve(n);
    }), i.promise();
  }
}
class Zre extends Ph {
  constructor() {
    super(), this.NAME = "compare";
  }
  _validate(e, i) {
    if (!i.comparisonTarget)
      throw bi.Error("E0102");
    if (i.ignoreEmptyValue && this._isValueEmpty(e))
      return !0;
    P(i, {
      reevaluate: !0
    });
    var r = i.comparisonTarget(), n = i.comparisonType || "==";
    switch (n) {
      case "==":
        return e == r;
      case "!=":
        return e != r;
      case "===":
        return e === r;
      case "!==":
        return e !== r;
      case ">":
        return e > r;
      case ">=":
        return e >= r;
      case "<":
        return e < r;
      case "<=":
        return e <= r;
    }
  }
}
class Jre extends Ph {
  constructor() {
    super(), this.NAME = "pattern";
  }
  _validate(e, i) {
    if (i.ignoreEmptyValue !== !1 && this._isValueEmpty(e))
      return !0;
    var r = i.pattern;
    return ht(r) && (r = new RegExp(r)), r.test(e);
  }
}
class ene extends Ph {
  constructor() {
    super(), this.NAME = "email";
  }
  _validate(e, i) {
    return i.ignoreEmptyValue !== !1 && this._isValueEmpty(e) ? !0 : Qx.pattern.validate(e, P({}, i, {
      pattern: Kre
    }));
  }
}
var Qx = {
  required: new jre(),
  numeric: new Yre(),
  range: new qre(),
  stringLength: new Xre(),
  custom: new Aj(),
  async: new Qre(),
  compare: new Zre(),
  pattern: new Jre(),
  email: new ene()
}, tne = wi.inherit({
  ctor(t) {
    this.group = t, this.validators = [], this._pendingValidators = [], this._onValidatorStatusChanged = this._onValidatorStatusChanged.bind(this), this._resetValidationInfo(), this._eventsStrategy = new Hp(this);
  },
  validate() {
    var t = {
      isValid: !0,
      brokenRules: [],
      validators: [],
      status: Xr.valid,
      complete: null
    };
    return this._unsubscribeFromAllChangeEvents(), this._pendingValidators = [], this._resetValidationInfo(), N(this.validators, (e, i) => {
      var r = i.validate();
      t.isValid = t.isValid && r.isValid, r.brokenRules && (t.brokenRules = t.brokenRules.concat(r.brokenRules)), t.validators.push(i), r.status === Xr.pending && this._addPendingValidator(i), this._subscribeToChangeEvents(i);
    }), this._pendingValidators.length ? t.status = Xr.pending : (t.status = t.isValid ? Xr.valid : Xr.invalid, this._unsubscribeFromAllChangeEvents(), this._raiseValidatedEvent(t)), this._updateValidationInfo(t), P({}, this._validationInfo.result);
  },
  _subscribeToChangeEvents(t) {
    t.on("validating", this._onValidatorStatusChanged), t.on("validated", this._onValidatorStatusChanged);
  },
  _unsubscribeFromChangeEvents(t) {
    t.off("validating", this._onValidatorStatusChanged), t.off("validated", this._onValidatorStatusChanged);
  },
  _unsubscribeFromAllChangeEvents() {
    N(this.validators, (t, e) => {
      this._unsubscribeFromChangeEvents(e);
    });
  },
  _updateValidationInfo(t) {
    this._validationInfo.result = t, t.status === Xr.pending && (this._validationInfo.deferred || (this._validationInfo.deferred = new q(), this._validationInfo.result.complete = this._validationInfo.deferred.promise()));
  },
  _addPendingValidator(t) {
    var e = so(this._pendingValidators, function(i) {
      return i === t;
    })[0];
    e || this._pendingValidators.push(t);
  },
  _removePendingValidator(t) {
    var e = this._pendingValidators.indexOf(t);
    e >= 0 && this._pendingValidators.splice(e, 1);
  },
  _orderBrokenRules(t) {
    var e = [];
    return N(this.validators, function(i, r) {
      var n = so(t, function(a) {
        return a.validator === r;
      });
      n.length && (e = e.concat(n));
    }), e;
  },
  _updateBrokenRules(t) {
    if (this._validationInfo.result) {
      var e = this._validationInfo.result.brokenRules, i = so(e, function(r) {
        return r.validator !== t.validator;
      });
      t.brokenRules && (e = i.concat(t.brokenRules)), this._validationInfo.result.brokenRules = this._orderBrokenRules(e);
    }
  },
  _onValidatorStatusChanged(t) {
    if (t.status === Xr.pending) {
      this._addPendingValidator(t.validator);
      return;
    }
    this._resolveIfComplete(t);
  },
  _resolveIfComplete(t) {
    if (this._removePendingValidator(t.validator), this._updateBrokenRules(t), !this._pendingValidators.length) {
      if (this._unsubscribeFromAllChangeEvents(), !this._validationInfo.result)
        return;
      this._validationInfo.result.status = this._validationInfo.result.brokenRules.length === 0 ? Xr.valid : Xr.invalid, this._validationInfo.result.isValid = this._validationInfo.result.status === Xr.valid;
      var e = P({}, this._validationInfo.result, {
        complete: null
      }), i = this._validationInfo.deferred;
      this._validationInfo.deferred = null, this._raiseValidatedEvent(e), i && setTimeout(() => {
        i.resolve(e);
      });
    }
  },
  _raiseValidatedEvent(t) {
    this._eventsStrategy.fireEvent("validated", [t]);
  },
  _resetValidationInfo() {
    this._validationInfo = {
      result: null,
      deferred: null
    };
  },
  _synchronizeValidationInfo() {
    this._validationInfo.result && (this._validationInfo.result.validators = this.validators);
  },
  removeRegisteredValidator(t) {
    var e = this.validators.indexOf(t);
    e > -1 && (this.validators.splice(e, 1), this._synchronizeValidationInfo(), this._resolveIfComplete({
      validator: t
    }));
  },
  registerValidator(t) {
    this.validators.includes(t) || (this.validators.push(t), this._synchronizeValidationInfo());
  },
  reset() {
    N(this.validators, function(t, e) {
      e.reset();
    }), this._pendingValidators = [], this._resetValidationInfo();
  },
  on(t, e) {
    return this._eventsStrategy.on(t, e), this;
  },
  off(t, e) {
    return this._eventsStrategy.off(t, e), this;
  }
}), Si = {
  groups: [],
  getGroupConfig(t) {
    var e = so(this.groups, function(i) {
      return i.group === t;
    });
    if (e.length)
      return e[0];
  },
  findGroup(t, e) {
    var i, r, n = (i = t.data()) === null || i === void 0 || (r = i.dxComponents) === null || r === void 0 ? void 0 : r.includes("dxValidationGroup"), a = n && t.dxValidationGroup("instance");
    if (a)
      return a;
    var o = t.parents(".dx-validationgroup").first();
    return o.length ? o.dxValidationGroup("instance") : e;
  },
  initGroups() {
    this.groups = [], this.addGroup();
  },
  addGroup(t) {
    var e = this.getGroupConfig(t);
    return e || (e = new tne(t), this.groups.push(e)), e;
  },
  removeGroup(t) {
    var e = this.getGroupConfig(t), i = this.groups.indexOf(e);
    return i > -1 && this.groups.splice(i, 1), e;
  },
  _setDefaultMessage(t) {
    var {
      rule: e,
      validator: i,
      name: r
    } = t;
    R(e.message) || (i.defaultFormattedMessage && R(r) ? e.message = i.defaultFormattedMessage(r) : e.message = i.defaultMessage());
  },
  _addBrokenRule(t) {
    var {
      result: e,
      rule: i
    } = t;
    e.brokenRule || (e.brokenRule = i), e.brokenRules || (e.brokenRules = []), e.brokenRules.push(i);
  },
  validate(t, e, i) {
    var r, n = {
      name: i,
      value: t,
      brokenRule: null,
      brokenRules: null,
      isValid: !0,
      validationRules: e,
      pendingRules: null,
      status: Xr.valid,
      complete: null
    }, a = e == null || (r = e[0]) === null || r === void 0 ? void 0 : r.validator, o = [];
    return N(e || [], (u, c) => {
      var p = Qx[c.type], v;
      if (p) {
        if (R(c.isValid) && c.value === t && !c.reevaluate)
          return c.isValid ? !0 : (n.isValid = !1, this._addBrokenRule({
            result: n,
            rule: c
          }), !1);
        if (c.value = t, c.type === "async")
          return o.push({
            rule: c,
            ruleValidator: p
          }), !0;
        if (v = p.validate(t, c), c.isValid = v, v || (n.isValid = !1, this._setDefaultMessage({
          rule: c,
          validator: p,
          name: i
        }), this._addBrokenRule({
          result: n,
          rule: c
        })), !c.isValid)
          return !1;
      } else
        throw bi.Error("E0100");
    }), n.isValid && !n.brokenRules && o.length && (n = this._validateAsyncRules({
      value: t,
      items: o,
      result: n,
      name: i
    })), this._synchronizeGroupValidationInfo(a, n), n.status = n.pendingRules ? Xr.pending : n.isValid ? Xr.valid : Xr.invalid, n;
  },
  _synchronizeGroupValidationInfo(t, e) {
    var i;
    if (t) {
      var r = Si.getGroupConfig(t._validationGroup);
      r._updateBrokenRules.call(r, {
        validator: t,
        brokenRules: (i = e.brokenRules) !== null && i !== void 0 ? i : []
      });
    }
  },
  _validateAsyncRules(t) {
    var {
      result: e,
      value: i,
      items: r,
      name: n
    } = t, a = [];
    return N(r, (o, u) => {
      var c = u.ruleValidator.validate(i, u.rule);
      if (!Vm(c))
        this._updateRuleConfig({
          rule: u.rule,
          ruleResult: this._getPatchedRuleResult(c),
          validator: u.ruleValidator,
          name: n
        });
      else {
        e.pendingRules || (e.pendingRules = []), e.pendingRules.push(u.rule);
        var p = c.then((v) => {
          var _ = this._getPatchedRuleResult(v);
          return this._updateRuleConfig({
            rule: u.rule,
            ruleResult: _,
            validator: u.ruleValidator,
            name: n
          }), _;
        });
        a.push(p);
      }
    }), a.length && (e.complete = Promise.all(a).then((o) => this._getAsyncRulesResult({
      result: e,
      values: o
    }))), e;
  },
  _updateRuleConfig(t) {
    var {
      rule: e,
      ruleResult: i,
      validator: r,
      name: n
    } = t;
    e.isValid = i.isValid, i.isValid || (R(i.message) && ht(i.message) && i.message.length ? e.message = i.message : this._setDefaultMessage({
      rule: e,
      validator: r,
      name: n
    }));
  },
  _getPatchedRuleResult(t) {
    var e;
    return ct(t) ? (e = P({}, t), R(e.isValid) || (e.isValid = !0)) : e = {
      isValid: wx(t) ? t : !0
    }, e;
  },
  _getAsyncRulesResult(t) {
    var {
      values: e,
      result: i
    } = t;
    return N(e, (r, n) => {
      if (n.isValid === !1) {
        i.isValid = n.isValid;
        var a = i.pendingRules[r];
        this._addBrokenRule({
          result: i,
          rule: a
        });
      }
    }), i.pendingRules = null, i.complete = null, i.status = i.isValid ? Xr.valid : Xr.invalid, i;
  },
  registerValidatorInGroup(t, e) {
    var i = Si.addGroup(t);
    i.registerValidator.call(i, e);
  },
  _shouldRemoveGroup(t, e) {
    var i = t === void 0, r = t && t.NAME === "dxValidationGroup";
    return !i && !r && !e.length;
  },
  removeRegisteredValidator(t, e) {
    var i = Si.getGroupConfig(t);
    if (i) {
      i.removeRegisteredValidator.call(i, e);
      var r = i.validators;
      this._shouldRemoveGroup(t, r) && this.removeGroup(t);
    }
  },
  initValidationOptions(t) {
    var e = {};
    return t && ["isValid", "validationStatus", "validationError", "validationErrors"].forEach((i) => {
      i in t && P(e, this.synchronizeValidationOptions({
        name: i,
        value: t[i]
      }, t));
    }), e;
  },
  synchronizeValidationOptions(t, e) {
    var {
      name: i,
      value: r
    } = t;
    switch (i) {
      case "validationStatus":
        var n = r === Xr.valid || r === Xr.pending;
        return e.isValid !== n ? {
          isValid: n
        } : {};
      case "isValid":
        var {
          validationStatus: a
        } = e, o = a;
        return r && a === Xr.invalid ? o = Xr.valid : !r && a !== Xr.invalid && (o = Xr.invalid), o !== a ? {
          validationStatus: o
        } : {};
      case "validationErrors":
        var u = !r || !r.length ? null : r[0];
        return e.validationError !== u ? {
          validationError: u
        } : {};
      case "validationError":
        var {
          validationErrors: c
        } = e;
        if (!r && c)
          return {
            validationErrors: null
          };
        if (r && !c)
          return {
            validationErrors: [r]
          };
        if (r && c && r !== c[0])
          return c[0] = r, {
            validationErrors: c.slice()
          };
    }
    return {};
  },
  validateGroup(t) {
    var e = Si.getGroupConfig(t);
    if (!e)
      throw bi.Error("E0110");
    return e.validate();
  },
  resetGroup(t) {
    var e = Si.getGroupConfig(t);
    if (!e)
      throw bi.Error("E0110");
    return e.reset();
  }
};
Si.initGroups();
var Ax = Array.isArray;
function gT(t) {
  var e = typeof t;
  return e === "string" || e === "number";
}
function Ei(t) {
  return t == null;
}
function Ox(t) {
  return t === null || t === !1 || t === !0 || t === void 0;
}
function wr(t) {
  return typeof t == "function";
}
function Rx(t) {
  return typeof t == "string";
}
function ine(t) {
  return typeof t == "number";
}
function co(t) {
  return t === null;
}
function rne(t) {
  return t === void 0;
}
function Fh(t, e) {
  var i = {};
  if (t)
    for (var r in t)
      i[r] = t[r];
  if (e)
    for (var n in e)
      i[n] = e[n];
  return i;
}
function CF(t) {
  return !co(t) && typeof t == "object";
}
var Fn = {}, nne = "$F";
function yF(t) {
  return t.substr(2).toLowerCase();
}
function Oj(t, e) {
  t.appendChild(e);
}
function xF(t, e, i) {
  co(i) ? Oj(t, e) : t.insertBefore(e, i);
}
function ane(t, e) {
  return e ? document.createElementNS("http://www.w3.org/2000/svg", t) : document.createElement(t);
}
function one(t, e, i) {
  t.replaceChild(e, i);
}
function Rj(t, e) {
  t.removeChild(e);
}
function Lj(t) {
  for (var e = 0; e < t.length; e++)
    t[e]();
}
function sne(t, e, i) {
  var r = t.children;
  return i & 4 ? r.$LI : i & 8192 ? t.childFlags === 2 ? r : r[e ? 0 : r.length - 1] : r;
}
function Ws(t, e) {
  for (var i; t; ) {
    if (i = t.flags, i & 2033)
      return t.dom;
    t = sne(t, e, i);
  }
  return null;
}
function Zx(t, e) {
  do {
    var i = t.flags;
    if (i & 2033) {
      Rj(e, t.dom);
      return;
    }
    var r = t.children;
    if (i & 4 && (t = r.$LI), i & 8 && (t = r), i & 8192)
      if (t.childFlags === 2)
        t = r;
      else {
        for (var n = 0, a = r.length; n < a; ++n)
          Zx(r[n], e);
        return;
      }
  } while (t);
}
function Mj(t, e, i) {
  do {
    var r = t.flags;
    if (r & 2033) {
      xF(e, t.dom, i);
      return;
    }
    var n = t.children;
    if (r & 4 && (t = n.$LI), r & 8 && (t = n), r & 8192)
      if (t.childFlags === 2)
        t = n;
      else {
        for (var a = 0, o = n.length; a < o; ++a)
          Mj(n[a], e, i);
        return;
      }
  } while (t);
}
function kj(t, e, i) {
  return t.constructor.getDerivedStateFromProps ? Fh(i, t.constructor.getDerivedStateFromProps(e, i)) : i;
}
var Lx = {
  v: !1
}, Om = {
  componentComparator: null,
  createVNode: null,
  renderComplete: null
};
function ux(t, e) {
  t.textContent = e;
}
function Pj(t, e) {
  return CF(t) && t.event === e.event && t.data === e.data;
}
function Fj(t, e) {
  for (var i in e)
    rne(t[i]) && (t[i] = e[i]);
  return t;
}
function SF(t, e) {
  return !!wr(t) && (t(e), !0);
}
var dx = "$";
function rI(t, e, i, r, n, a, o, u) {
  this.childFlags = t, this.children = e, this.className = i, this.dom = null, this.flags = r, this.key = n === void 0 ? null : n, this.props = a === void 0 ? null : a, this.ref = o === void 0 ? null : o, this.type = u;
}
function Fr(t, e, i, r, n, a, o, u) {
  var c = n === void 0 ? 1 : n, p = new rI(c, r, i, t, o, a, u, e);
  return Om.createVNode && Om.createVNode(p), c === 0 && Vj(p, p.children), p;
}
function lne(t, e, i) {
  if (t & 4)
    return i;
  var r = (t & 32768 ? e.render : e).defaultHooks;
  return Ei(r) ? i : Ei(i) ? r : Fj(i, r);
}
function une(t, e, i) {
  var r = (t & 32768 ? e.render : e).defaultProps;
  return Ei(r) ? i : Ei(i) ? Fh(r, null) : Fj(i, r);
}
function dne(t, e) {
  return t & 12 ? t : e.prototype && e.prototype.render ? 4 : e.render ? 32776 : 8;
}
function zi(t, e, i, r, n) {
  t = dne(t, e);
  var a = new rI(1, null, null, t, r, une(t, e, i), lne(t, e, n), e);
  return Om.createVNode && Om.createVNode(a), a;
}
function Jx(t, e) {
  return new rI(1, Ei(t) || t === !0 || t === !1 ? "" : t, null, 16, e, null, null, null);
}
function sc(t, e, i) {
  var r = Fr(8192, 8192, null, t, e, null, i, null);
  switch (r.childFlags) {
    case 1:
      r.children = nI(), r.childFlags = 2;
      break;
    case 16:
      r.children = [Jx(t)], r.childFlags = 4;
      break;
  }
  return r;
}
function Uo(t) {
  var e = t.props;
  if (e) {
    var i = t.flags;
    i & 481 && (e.children !== void 0 && Ei(t.children) && Vj(t, e.children), e.className !== void 0 && (Ei(t.className) && (t.className = e.className || null), e.className = void 0)), e.key !== void 0 && (t.key = e.key, e.key = void 0), e.ref !== void 0 && (i & 8 ? t.ref = Fh(t.ref, e.ref) : t.ref = e.ref, e.ref = void 0);
  }
  return t;
}
function cne(t) {
  var e = t.children, i = t.childFlags;
  return sc(i === 2 ? Bn(e) : e.map(Bn), i, t.key);
}
function Bn(t) {
  var e = t.flags & -16385, i = t.props;
  if (e & 14 && !co(i)) {
    var r = i;
    i = {};
    for (var n in r)
      i[n] = r[n];
  }
  return e & 8192 ? cne(t) : new rI(t.childFlags, t.children, t.className, e, t.key, i, t.ref, t.type);
}
function nI() {
  return Jx("", null);
}
function Bj(t, e, i, r) {
  for (var n = t.length; i < n; i++) {
    var a = t[i];
    if (!Ox(a)) {
      var o = r + dx + i;
      if (Ax(a))
        Bj(a, e, 0, o);
      else {
        if (gT(a))
          a = Jx(a, o);
        else {
          var u = a.key, c = Rx(u) && u[0] === dx;
          (a.flags & 81920 || c) && (a = Bn(a)), a.flags |= 65536, c ? u.substring(0, r.length) !== r && (a.key = r + u) : co(u) ? a.key = o : a.key = r + u;
        }
        e.push(a);
      }
    }
  }
}
function hne(t) {
  switch (t) {
    case "svg":
      return 32;
    case "input":
      return 64;
    case "select":
      return 256;
    case "textarea":
      return 128;
    case nne:
      return 8192;
    default:
      return 1;
  }
}
function Vj(t, e) {
  var i, r = 1;
  if (Ox(e))
    i = e;
  else if (gT(e))
    r = 16, i = e;
  else if (Ax(e)) {
    for (var n = e.length, a = 0; a < n; ++a) {
      var o = e[a];
      if (Ox(o) || Ax(o)) {
        i = i || e.slice(0, a), Bj(e, i, a, "");
        break;
      } else if (gT(o))
        i = i || e.slice(0, a), i.push(Jx(o, dx + a));
      else {
        var u = o.key, c = (o.flags & 81920) > 0, p = co(u), v = Rx(u) && u[0] === dx;
        c || p || v ? (i = i || e.slice(0, a), (c || v) && (o = Bn(o)), (p || v) && (o.key = dx + a), i.push(o)) : i && i.push(o), o.flags |= 65536;
      }
    }
    i = i || e, i.length === 0 ? r = 1 : r = 8;
  } else
    i = e, i.flags |= 65536, e.flags & 81920 && (i = Bn(e)), r = 2;
  return t.children = i, t.childFlags = r, t;
}
function aI(t) {
  return Ox(t) || gT(t) ? Jx(t, null) : Ax(t) ? sc(t, 0, null) : t.flags & 16384 ? Bn(t) : t;
}
var Qf = "http://www.w3.org/1999/xlink", OR = "http://www.w3.org/XML/1998/namespace", I$ = {
  "xlink:actuate": Qf,
  "xlink:arcrole": Qf,
  "xlink:href": Qf,
  "xlink:role": Qf,
  "xlink:show": Qf,
  "xlink:title": Qf,
  "xlink:type": Qf,
  "xml:base": OR,
  "xml:lang": OR,
  "xml:space": OR
};
function oI(t) {
  return {
    onClick: t,
    onDblClick: t,
    onFocusIn: t,
    onFocusOut: t,
    onKeyDown: t,
    onKeyPress: t,
    onKeyUp: t,
    onMouseDown: t,
    onMouseMove: t,
    onMouseUp: t,
    onTouchEnd: t,
    onTouchMove: t,
    onTouchStart: t
  };
}
var Nj = oI(0), Tk = oI(null), Hj = oI(!0);
function D$(t, e) {
  var i = e.$EV;
  return i || (i = e.$EV = oI(null)), i[t] || ++Nj[t] === 1 && (Tk[t] = yne(t)), i;
}
function $j(t, e) {
  var i = e.$EV;
  i && i[t] && (--Nj[t] === 0 && (document.removeEventListener(yF(t), Tk[t]), Tk[t] = null), i[t] = null);
}
function fne(t, e, i, r) {
  if (wr(i))
    D$(t, r)[t] = i;
  else if (CF(i)) {
    if (Pj(e, i))
      return;
    D$(t, r)[t] = i;
  } else
    $j(t, r);
}
function pne(t) {
  return wr(t.composedPath) ? t.composedPath()[0] : t.target;
}
function zj(t, e, i, r) {
  var n = pne(t);
  do {
    if (e && n.disabled)
      return;
    var a = n.$EV;
    if (a) {
      var o = a[i];
      if (o && (r.dom = n, o.event ? o.event(o.data, t) : o(t), t.cancelBubble))
        return;
    }
    n = n.parentNode;
  } while (!co(n));
}
function vne() {
  this.cancelBubble = !0, this.immediatePropagationStopped || this.stopImmediatePropagation();
}
function gne() {
  return this.defaultPrevented;
}
function mne() {
  return this.cancelBubble;
}
function Wj(t) {
  var e = {
    dom: document
  };
  return t.isDefaultPrevented = gne, t.isPropagationStopped = mne, t.stopPropagation = vne, Object.defineProperty(t, "currentTarget", {
    configurable: !0,
    get: function() {
      return e.dom;
    }
  }), e;
}
function _ne(t) {
  return function(e) {
    if (e.button !== 0) {
      e.stopPropagation();
      return;
    }
    zj(e, !0, t, Wj(e));
  };
}
function Cne(t) {
  return function(e) {
    zj(e, !1, t, Wj(e));
  };
}
function yne(t) {
  var e = t === "onClick" || t === "onDblClick" ? _ne(t) : Cne(t);
  return document.addEventListener(yF(t), e), e;
}
function xne(t, e) {
  var i = document.createElement("i");
  return i.innerHTML = e, i.innerHTML === t.innerHTML;
}
function A$(t, e, i) {
  if (t[e]) {
    var r = t[e];
    r.event ? r.event(r.data, i) : r(i);
  } else {
    var n = e.toLowerCase();
    t[n] && t[n](i);
  }
}
function eS(t, e) {
  var i = function(r) {
    var n = this.$V;
    if (n) {
      var a = n.props || Fn, o = n.dom;
      if (Rx(t))
        A$(a, t, r);
      else
        for (var u = 0; u < t.length; ++u)
          A$(a, t[u], r);
      if (wr(e)) {
        var c = this.$V, p = c.props || Fn;
        e(p, o, !1, c);
      }
    }
  };
  return Object.defineProperty(i, "wrapped", {
    configurable: !1,
    enumerable: !1,
    value: !0,
    writable: !1
  }), i;
}
function _p(t, e, i) {
  var r = "$" + e, n = t[r];
  if (n) {
    if (n[1].wrapped)
      return;
    t.removeEventListener(n[0], n[1]), t[r] = null;
  }
  wr(i) && (t.addEventListener(e, i), t[r] = [e, i]);
}
function EF(t) {
  return t === "checkbox" || t === "radio";
}
var Sne = eS("onInput", bF), Ene = eS(["onClick", "onChange"], bF);
function Uj(t) {
  t.stopPropagation();
}
Uj.wrapped = !0;
function bne(t, e) {
  EF(e.type) ? (_p(t, "change", Ene), _p(t, "click", Uj)) : _p(t, "input", Sne);
}
function bF(t, e) {
  var i = t.type, r = t.value, n = t.checked, a = t.multiple, o = t.defaultValue, u = !Ei(r);
  i && i !== e.type && e.setAttribute("type", i), !Ei(a) && a !== e.multiple && (e.multiple = a), !Ei(o) && !u && (e.defaultValue = o + ""), EF(i) ? (u && (e.value = r), Ei(n) || (e.checked = n)) : u && e.value !== r ? (e.defaultValue = r, e.value = r) : Ei(n) || (e.checked = n);
}
function Xy(t, e) {
  if (t.type === "option")
    wne(t, e);
  else {
    var i = t.children, r = t.flags;
    if (r & 4)
      Xy(i.$LI, e);
    else if (r & 8)
      Xy(i, e);
    else if (t.childFlags === 2)
      Xy(i, e);
    else if (t.childFlags & 12)
      for (var n = 0, a = i.length; n < a; ++n)
        Xy(i[n], e);
  }
}
function wne(t, e) {
  var i = t.props || Fn, r = t.dom;
  r.value = i.value, i.value === e || Ax(e) && e.indexOf(i.value) !== -1 ? r.selected = !0 : (!Ei(e) || !Ei(i.selected)) && (r.selected = i.selected || !1);
}
var Tne = eS("onChange", Gj);
function Ine(t) {
  _p(t, "change", Tne);
}
function Gj(t, e, i, r) {
  var n = !!t.multiple;
  !Ei(t.multiple) && n !== e.multiple && (e.multiple = n);
  var a = t.selectedIndex;
  a === -1 && (e.selectedIndex = -1);
  var o = r.childFlags;
  if (o !== 1) {
    var u = t.value;
    ine(a) && a > -1 && e.options[a] && (u = e.options[a].value), i && Ei(u) && (u = t.defaultValue), Xy(r, u);
  }
}
var Dne = eS("onInput", Kj), Ane = eS("onChange");
function One(t, e) {
  _p(t, "input", Dne), e.onChange && _p(t, "change", Ane);
}
function Kj(t, e, i) {
  var r = t.value, n = e.value;
  if (Ei(r)) {
    if (i) {
      var a = t.defaultValue;
      !Ei(a) && a !== n && (e.defaultValue = a, e.value = a);
    }
  } else
    n !== r && (e.defaultValue = r, e.value = r);
}
function jj(t, e, i, r, n, a) {
  t & 64 ? bF(r, i) : t & 256 ? Gj(r, i, n, e) : t & 128 && Kj(r, i, n), a && (i.$V = e);
}
function Rne(t, e, i) {
  t & 64 ? bne(e, i) : t & 256 ? Ine(e) : t & 128 && One(e, i);
}
function Yj(t) {
  return t.type && EF(t.type) ? !Ei(t.checked) : !Ei(t.value);
}
function Vn() {
  return {
    current: null
  };
}
function mT(t) {
  t && !SF(t, null) && t.current && (t.current = null);
}
function tS(t, e, i) {
  t && (wr(t) || t.current !== void 0) && i.push(function() {
    !SF(t, e) && t.current !== void 0 && (t.current = e);
  });
}
function Ll(t, e) {
  Gd(t), Zx(t, e);
}
function Gd(t) {
  var e = t.flags, i = t.children, r;
  if (e & 481) {
    r = t.ref;
    var n = t.props;
    mT(r);
    var a = t.childFlags;
    if (!co(n))
      for (var o = Object.keys(n), u = 0, c = o.length; u < c; u++) {
        var p = o[u];
        Hj[p] && $j(p, t.dom);
      }
    a & 12 ? Mx(i) : a === 2 && Gd(i);
  } else
    i && (e & 4 ? (wr(i.componentWillUnmount) && i.componentWillUnmount(), mT(t.ref), i.$UN = !0, Gd(i.$LI)) : e & 8 ? (r = t.ref, !Ei(r) && wr(r.onComponentWillUnmount) && r.onComponentWillUnmount(Ws(t, !0), t.props || Fn), Gd(i)) : e & 1024 ? Ll(i, t.ref) : e & 8192 && t.childFlags & 12 && Mx(i));
}
function Mx(t) {
  for (var e = 0, i = t.length; e < i; ++e)
    Gd(t[e]);
}
function Bw(t) {
  t.textContent = "";
}
function Vw(t, e, i) {
  Mx(i), e.flags & 8192 ? Zx(e, t) : Bw(t);
}
function Lne(t) {
  var e = t.event;
  return function(i) {
    e(t.data, i);
  };
}
function Mne(t, e, i, r) {
  if (CF(i)) {
    if (Pj(e, i))
      return;
    i = Lne(i);
  }
  _p(r, yF(t), i);
}
function kne(t, e, i) {
  if (Ei(e)) {
    i.removeAttribute("style");
    return;
  }
  var r = i.style, n, a;
  if (Rx(e)) {
    r.cssText = e;
    return;
  }
  if (!Ei(t) && !Rx(t)) {
    for (n in e)
      a = e[n], a !== t[n] && r.setProperty(n, a);
    for (n in t)
      Ei(e[n]) && r.removeProperty(n);
  } else
    for (n in e)
      a = e[n], r.setProperty(n, a);
}
function Pne(t, e, i, r) {
  var n = t && t.__html || "", a = e && e.__html || "";
  n !== a && !Ei(a) && !xne(r, a) && (co(i) || (i.childFlags & 12 ? Mx(i.children) : i.childFlags === 2 && Gd(i.children), i.children = null, i.childFlags = 1), r.innerHTML = a);
}
function Ik(t, e, i, r, n, a, o) {
  switch (t) {
    case "children":
    case "childrenType":
    case "className":
    case "defaultValue":
    case "key":
    case "multiple":
    case "ref":
    case "selectedIndex":
      break;
    case "autoFocus":
      r.autofocus = !!i;
      break;
    case "allowfullscreen":
    case "autoplay":
    case "capture":
    case "checked":
    case "controls":
    case "default":
    case "disabled":
    case "hidden":
    case "indeterminate":
    case "loop":
    case "muted":
    case "novalidate":
    case "open":
    case "readOnly":
    case "required":
    case "reversed":
    case "scoped":
    case "seamless":
    case "selected":
      r[t] = !!i;
      break;
    case "defaultChecked":
    case "value":
    case "volume":
      if (a && t === "value")
        break;
      var u = Ei(i) ? "" : i;
      r[t] !== u && (r[t] = u);
      break;
    case "style":
      kne(e, i, r);
      break;
    case "dangerouslySetInnerHTML":
      Pne(e, i, o, r);
      break;
    default:
      Hj[t] ? fne(t, e, i, r) : t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 ? Mne(t, e, i, r) : Ei(i) ? r.removeAttribute(t) : n && I$[t] ? r.setAttributeNS(I$[t], t, i) : r.setAttribute(t, i);
      break;
  }
}
function qj(t, e, i, r, n) {
  var a = !1, o = (e & 448) > 0;
  o && (a = Yj(i), a && Rne(e, r, i));
  for (var u in i)
    Ik(u, null, i[u], r, n, a, null);
  o && jj(e, t, r, i, !0, a);
}
function Xj(t, e, i) {
  var r = aI(t.render(e, t.state, i)), n = i;
  return wr(t.getChildContext) && (n = Fh(i, t.getChildContext())), t.$CX = n, r;
}
function Qj(t, e, i, r, n, a) {
  var o = new e(i, r), u = o.$N = !!(e.getDerivedStateFromProps || o.getSnapshotBeforeUpdate);
  if (o.$SVG = n, o.$L = a, t.children = o, o.$BS = !1, o.context = r, o.props === Fn && (o.props = i), u)
    o.state = kj(o, i, o.state);
  else if (wr(o.componentWillMount)) {
    o.$BR = !0, o.componentWillMount();
    var c = o.$PS;
    if (!co(c)) {
      var p = o.state;
      if (co(p))
        o.state = c;
      else
        for (var v in c)
          p[v] = c[v];
      o.$PS = null;
    }
    o.$BR = !1;
  }
  return o.$LI = Xj(o, i, r), o;
}
function wF(t, e) {
  var i = t.props || Fn;
  return t.flags & 32768 ? t.type.render(i, t.ref, e) : t.type(i, e);
}
function Hn(t, e, i, r, n, a) {
  var o = t.flags |= 16384;
  o & 481 ? Jj(t, e, i, r, n, a) : o & 4 ? Vne(t, e, i, r, n, a) : o & 8 ? (Nne(t, e, i, r, n, a), tY(t, a)) : o & 512 || o & 16 ? Zj(t, e, n) : o & 8192 ? Bne(t, i, e, r, n, a) : o & 1024 && Fne(t, i, e, n, a);
}
function Fne(t, e, i, r, n) {
  Hn(t.children, t.ref, e, !1, null, n);
  var a = nI();
  Zj(a, i, r), t.dom = a.dom;
}
function Bne(t, e, i, r, n, a) {
  var o = t.children, u = t.childFlags;
  u & 12 && o.length === 0 && (u = t.childFlags = 2, o = t.children = nI()), u === 2 ? Hn(o, i, e, r, n, a) : Cp(o, i, e, r, n, a);
}
function Zj(t, e, i) {
  var r = t.dom = document.createTextNode(t.children);
  co(e) || xF(e, r, i);
}
function Jj(t, e, i, r, n, a) {
  var o = t.flags, u = t.props, c = t.className, p = t.childFlags, v = t.dom = ane(t.type, r = r || (o & 32) > 0), _ = t.children;
  if (!Ei(c) && c !== "" && (r ? v.setAttribute("class", c) : v.className = c), p === 16)
    ux(v, _);
  else if (p !== 1) {
    var y = r && t.type !== "foreignObject";
    p === 2 ? (_.flags & 16384 && (t.children = _ = Bn(_)), Hn(_, v, i, y, null, a)) : (p === 8 || p === 4) && Cp(_, v, i, y, null, a);
  }
  co(e) || xF(e, v, n), co(u) || qj(t, o, u, v, r), tS(t.ref, v, a);
}
function Cp(t, e, i, r, n, a) {
  for (var o = 0; o < t.length; ++o) {
    var u = t[o];
    u.flags & 16384 && (t[o] = u = Bn(u)), Hn(u, e, i, r, n, a);
  }
}
function Vne(t, e, i, r, n, a) {
  var o = Qj(t, t.type, t.props || Fn, i, r, a);
  Hn(o.$LI, e, o.$CX, r, n, a), eY(t.ref, o, a);
}
function Nne(t, e, i, r, n, a) {
  Hn(t.children = aI(wF(t, i)), e, i, r, n, a);
}
function Hne(t) {
  return function() {
    t.componentDidMount();
  };
}
function eY(t, e, i) {
  tS(t, e, i), wr(e.componentDidMount) && i.push(Hne(e));
}
function $ne(t, e) {
  return function() {
    t.onComponentDidMount(Ws(e, !0), e.props || Fn);
  };
}
function tY(t, e) {
  var i = t.ref;
  Ei(i) || (SF(i.onComponentWillMount, t.props || Fn), wr(i.onComponentDidMount) && e.push($ne(i, t)));
}
function zne(t, e, i, r, n, a) {
  Gd(t), e.flags & t.flags & 2033 ? (Hn(e, null, r, n, null, a), one(i, e.dom, t.dom)) : (Hn(e, i, r, n, Ws(t, !0), a), Zx(t, i));
}
function Jd(t, e, i, r, n, a, o) {
  var u = e.flags |= 16384;
  t.flags !== u || t.type !== e.type || t.key !== e.key || u & 2048 ? t.flags & 16384 ? zne(t, e, i, r, n, o) : Hn(e, i, r, n, a, o) : u & 481 ? jne(t, e, r, n, u, o) : u & 4 ? Xne(t, e, i, r, n, a, o) : u & 8 ? Qne(t, e, i, r, n, a, o) : u & 16 ? Zne(t, e) : u & 512 ? e.dom = t.dom : u & 8192 ? Gne(t, e, i, r, n, o) : Kne(t, e, r, o);
}
function Wne(t, e, i) {
  t !== e && (t !== "" ? i.firstChild.nodeValue = e : ux(i, e));
}
function Une(t, e) {
  t.textContent !== e && (t.textContent = e);
}
function Gne(t, e, i, r, n, a) {
  var o = t.children, u = e.children, c = t.childFlags, p = e.childFlags, v = null;
  p & 12 && u.length === 0 && (p = e.childFlags = 2, u = e.children = nI());
  var _ = (p & 2) !== 0;
  if (c & 12) {
    var y = o.length;
    // It uses keyed algorithm
    (c & 8 && p & 8 || // It transforms from many to single
    _ || // It will append more nodes
    !_ && u.length > y) && (v = Ws(o[y - 1], !1).nextSibling);
  }
  TF(c, p, o, u, i, r, n, v, t, a);
}
function Kne(t, e, i, r) {
  var n = t.ref, a = e.ref, o = e.children;
  if (TF(t.childFlags, e.childFlags, t.children, o, n, i, !1, null, t, r), e.dom = t.dom, n !== a && !Ox(o)) {
    var u = o.dom;
    Rj(n, u), Oj(a, u);
  }
}
function jne(t, e, i, r, n, a) {
  var o = e.dom = t.dom, u = t.props, c = e.props, p = !1, v = !1, _;
  if (r = r || (n & 32) > 0, u !== c) {
    var y = u || Fn;
    if (_ = c || Fn, _ !== Fn) {
      p = (n & 448) > 0, p && (v = Yj(_));
      for (var b in _) {
        var I = y[b], A = _[b];
        I !== A && Ik(b, I, A, o, r, v, t);
      }
    }
    if (y !== Fn)
      for (var L in y)
        Ei(_[L]) && !Ei(y[L]) && Ik(L, y[L], null, o, r, v, t);
  }
  var B = e.children, $ = e.className;
  t.className !== $ && (Ei($) ? o.removeAttribute("class") : r ? o.setAttribute("class", $) : o.className = $), n & 4096 ? Une(o, B) : TF(t.childFlags, e.childFlags, t.children, B, o, i, r && e.type !== "foreignObject", null, t, a), p && jj(n, e, o, _, !1, v);
  var K = e.ref, te = t.ref;
  te !== K && (mT(te), tS(K, o, a));
}
function Yne(t, e, i, r, n, a) {
  Gd(t), Cp(e, i, r, n, Ws(t, !0), a), Zx(t, i);
}
function TF(t, e, i, r, n, a, o, u, c, p) {
  switch (t) {
    case 2:
      switch (e) {
        case 2:
          Jd(i, r, n, a, o, u, p);
          break;
        case 1:
          Ll(i, n);
          break;
        case 16:
          Gd(i), ux(n, r);
          break;
        default:
          Yne(i, r, n, a, o, p);
          break;
      }
      break;
    case 1:
      switch (e) {
        case 2:
          Hn(r, n, a, o, u, p);
          break;
        case 1:
          break;
        case 16:
          ux(n, r);
          break;
        default:
          Cp(r, n, a, o, u, p);
          break;
      }
      break;
    case 16:
      switch (e) {
        case 16:
          Wne(i, r, n);
          break;
        case 2:
          Bw(n), Hn(r, n, a, o, u, p);
          break;
        case 1:
          Bw(n);
          break;
        default:
          Bw(n), Cp(r, n, a, o, u, p);
          break;
      }
      break;
    default:
      switch (e) {
        case 16:
          Mx(i), ux(n, r);
          break;
        case 2:
          Vw(n, c, i), Hn(r, n, a, o, u, p);
          break;
        case 1:
          Vw(n, c, i);
          break;
        default:
          var v = i.length | 0, _ = r.length | 0;
          v === 0 ? _ > 0 && Cp(r, n, a, o, u, p) : _ === 0 ? Vw(n, c, i) : e === 8 && t === 8 ? eae(i, r, n, a, o, v, _, u, c, p) : Jne(i, r, n, a, o, v, _, u, p);
          break;
      }
      break;
  }
}
function qne(t, e, i, r, n) {
  n.push(function() {
    t.componentDidUpdate(e, i, r);
  });
}
function iY(t, e, i, r, n, a, o, u, c) {
  var p = t.state, v = t.props, _ = !!t.$N, y = wr(t.shouldComponentUpdate);
  if (_ && (e = kj(t, i, e !== p ? Fh(p, e) : e)), o || !y || y && t.shouldComponentUpdate(i, e, n)) {
    !_ && wr(t.componentWillUpdate) && t.componentWillUpdate(i, e, n), t.props = i, t.state = e, t.context = n;
    var b = null, I = Xj(t, i, n);
    _ && wr(t.getSnapshotBeforeUpdate) && (b = t.getSnapshotBeforeUpdate(v, p)), Jd(t.$LI, I, r, t.$CX, a, u, c), t.$LI = I, wr(t.componentDidUpdate) && qne(t, v, p, b, c);
  } else
    t.props = i, t.state = e, t.context = n;
}
function Xne(t, e, i, r, n, a, o) {
  var u = e.children = t.children;
  if (!co(u)) {
    u.$L = o;
    var c = e.props || Fn, p = e.ref, v = t.ref, _ = u.state;
    if (!u.$N) {
      if (wr(u.componentWillReceiveProps)) {
        if (u.$BR = !0, u.componentWillReceiveProps(c, r), u.$UN)
          return;
        u.$BR = !1;
      }
      co(u.$PS) || (_ = Fh(_, u.$PS), u.$PS = null);
    }
    iY(u, _, c, i, r, n, !1, a, o), v !== p && (mT(v), tS(p, u, o));
  }
}
function Qne(t, e, i, r, n, a, o) {
  var u = !0, c = e.props || Fn, p = e.ref, v = t.props, _ = !Ei(p), y = t.children;
  if (_ && wr(p.onComponentShouldUpdate) && (u = p.onComponentShouldUpdate(v, c)), u !== !1) {
    _ && wr(p.onComponentWillUpdate) && p.onComponentWillUpdate(v, c);
    var b = aI(wF(e, r));
    Jd(y, b, i, r, n, a, o), e.children = b, _ && wr(p.onComponentDidUpdate) && p.onComponentDidUpdate(v, c);
  } else
    e.children = y;
}
function Zne(t, e) {
  var i = e.children, r = e.dom = t.dom;
  i !== t.children && (r.nodeValue = i);
}
function Jne(t, e, i, r, n, a, o, u, c) {
  for (var p = a > o ? o : a, v = 0, _, y; v < p; ++v)
    _ = e[v], y = t[v], _.flags & 16384 && (_ = e[v] = Bn(_)), Jd(y, _, i, r, n, u, c), t[v] = _;
  if (a < o)
    for (v = p; v < o; ++v)
      _ = e[v], _.flags & 16384 && (_ = e[v] = Bn(_)), Hn(_, i, r, n, u, c);
  else if (a > o)
    for (v = p; v < a; ++v)
      Ll(t[v], i);
}
function eae(t, e, i, r, n, a, o, u, c, p) {
  var v = a - 1, _ = o - 1, y = 0, b = t[y], I = e[y], A, L;
  e: {
    for (; b.key === I.key; ) {
      if (I.flags & 16384 && (e[y] = I = Bn(I)), Jd(b, I, i, r, n, u, p), t[y] = I, ++y, y > v || y > _)
        break e;
      b = t[y], I = e[y];
    }
    for (b = t[v], I = e[_]; b.key === I.key; ) {
      if (I.flags & 16384 && (e[_] = I = Bn(I)), Jd(b, I, i, r, n, u, p), t[v] = I, v--, _--, y > v || y > _)
        break e;
      b = t[v], I = e[_];
    }
  }
  if (y > v) {
    if (y <= _)
      for (A = _ + 1, L = A < o ? Ws(e[A], !0) : u; y <= _; )
        I = e[y], I.flags & 16384 && (e[y] = I = Bn(I)), ++y, Hn(I, i, r, n, L, p);
  } else if (y > _)
    for (; y <= v; )
      Ll(t[y++], i);
  else
    tae(t, e, r, a, o, v, _, y, i, n, u, c, p);
}
function tae(t, e, i, r, n, a, o, u, c, p, v, _, y) {
  var b, I, A, L = 0, B = u, $ = u, K = a - u + 1, te = o - u + 1, z = new Int32Array(te + 1), ie = K === r, pe = !1, _e = 0, be = 0;
  if (n < 4 || (K | te) < 32)
    for (L = B; L <= a; ++L)
      if (b = t[L], be < te) {
        for (u = $; u <= o; u++)
          if (I = e[u], b.key === I.key) {
            if (z[u - $] = L + 1, ie)
              for (ie = !1; B < L; )
                Ll(t[B++], c);
            _e > u ? pe = !0 : _e = u, I.flags & 16384 && (e[u] = I = Bn(I)), Jd(b, I, c, i, p, v, y), ++be;
            break;
          }
        !ie && u > o && Ll(b, c);
      } else
        ie || Ll(b, c);
  else {
    var De = {};
    for (L = $; L <= o; ++L)
      De[e[L].key] = L;
    for (L = B; L <= a; ++L)
      if (b = t[L], be < te)
        if (u = De[b.key], u !== void 0) {
          if (ie)
            for (ie = !1; L > B; )
              Ll(t[B++], c);
          z[u - $] = L + 1, _e > u ? pe = !0 : _e = u, I = e[u], I.flags & 16384 && (e[u] = I = Bn(I)), Jd(b, I, c, i, p, v, y), ++be;
        } else
          ie || Ll(b, c);
      else
        ie || Ll(b, c);
  }
  if (ie)
    Vw(c, _, t), Cp(e, c, i, p, v, y);
  else if (pe) {
    var Ce = iae(z);
    for (u = Ce.length - 1, L = te - 1; L >= 0; L--)
      z[L] === 0 ? (_e = L + $, I = e[_e], I.flags & 16384 && (e[_e] = I = Bn(I)), A = _e + 1, Hn(I, c, i, p, A < n ? Ws(e[A], !0) : v, y)) : u < 0 || L !== Ce[u] ? (_e = L + $, I = e[_e], A = _e + 1, Mj(I, c, A < n ? Ws(e[A], !0) : v)) : u--;
  } else if (be !== te)
    for (L = te - 1; L >= 0; L--)
      z[L] === 0 && (_e = L + $, I = e[_e], I.flags & 16384 && (e[_e] = I = Bn(I)), A = _e + 1, Hn(I, c, i, p, A < n ? Ws(e[A], !0) : v, y));
}
var Rd, kb, O$ = 0;
function iae(t) {
  var e = 0, i = 0, r = 0, n = 0, a = 0, o = 0, u = 0, c = t.length;
  for (c > O$ && (O$ = c, Rd = new Int32Array(c), kb = new Int32Array(c)); i < c; ++i)
    if (e = t[i], e !== 0) {
      if (r = Rd[n], t[r] < e) {
        kb[i] = r, Rd[++n] = i;
        continue;
      }
      for (a = 0, o = n; a < o; )
        u = a + o >> 1, t[Rd[u]] < e ? a = u + 1 : o = u;
      e < t[Rd[a]] && (a > 0 && (kb[i] = Rd[a - 1]), Rd[a] = i);
    }
  a = n + 1;
  var p = new Int32Array(a);
  for (o = Rd[a - 1]; a-- > 0; )
    p[a] = o, o = kb[o], Rd[a] = 0;
  return p;
}
var rae = typeof document < "u";
rae && window.Node && (Node.prototype.$EV = null, Node.prototype.$V = null);
function nae(t, e, i, r) {
  var n = [], a = e.$V;
  Lx.v = !0, Ei(a) ? Ei(t) || (t.flags & 16384 && (t = Bn(t)), Hn(t, e, r, !1, null, n), e.$V = t, a = t) : Ei(t) ? (Ll(a, e), e.$V = null) : (t.flags & 16384 && (t = Bn(t)), Jd(a, t, e, r, !1, null, n), a = e.$V = t), Lj(n), Lx.v = !1, wr(i) && i(), wr(Om.renderComplete) && Om.renderComplete(a, e);
}
function sI(t, e, i, r) {
  i === void 0 && (i = null), r === void 0 && (r = Fn), nae(t, e, i, r);
}
var Nw = [], aae = typeof Promise < "u" ? Promise.resolve().then.bind(Promise.resolve()) : function(t) {
  window.setTimeout(t, 0);
}, Dk = !1;
function rY(t, e, i, r) {
  var n = t.$PS;
  if (wr(e) && (e = e(n ? Fh(t.state, n) : t.state, t.props, t.context)), Ei(n))
    t.$PS = e;
  else
    for (var a in e)
      n[a] = e[a];
  if (t.$BR)
    wr(i) && t.$L.push(i.bind(t));
  else {
    if (!Lx.v && Nw.length === 0) {
      aY(t, r), wr(i) && i.call(t);
      return;
    }
    if (Nw.indexOf(t) === -1 && Nw.push(t), r && (t.$F = !0), Dk || (Dk = !0, aae(nY)), wr(i)) {
      var o = t.$QU;
      o || (o = t.$QU = []), o.push(i);
    }
  }
}
function oae(t) {
  for (var e = t.$QU, i = 0; i < e.length; ++i)
    e[i].call(t);
  t.$QU = null;
}
function nY() {
  var t;
  for (Dk = !1; t = Nw.shift(); )
    if (!t.$UN) {
      var e = t.$F;
      t.$F = !1, aY(t, e), t.$QU && oae(t);
    }
}
function aY(t, e) {
  if (e || !t.$BR) {
    var i = t.$PS;
    t.$PS = null;
    var r = [];
    Lx.v = !0, iY(t, Fh(t.state, i), t.props, Ws(t.$LI, !0).parentNode, t.context, t.$SVG, e, null, r), Lj(r), Lx.v = !1;
  } else
    t.state = t.$PS, t.$PS = null;
}
var iS = function(e, i) {
  this.state = null, this.$BR = !1, this.$BS = !0, this.$PS = null, this.$LI = null, this.$UN = !1, this.$CX = null, this.$QU = null, this.$N = !1, this.$L = null, this.$SVG = !1, this.$F = !1, this.props = e || Fn, this.context = i || Fn;
};
iS.prototype.forceUpdate = function(e) {
  this.$UN || rY(this, {}, e, !0);
};
iS.prototype.setState = function(e, i) {
  this.$UN || this.$BS || rY(this, e, i, !1);
};
iS.prototype.render = function(e, i, r) {
  return null;
};
var Ak = (t, e) => {
  if (!e)
    throw bi.Error("E0017");
  return Array.isArray(t) ? t.map((i) => Ak(i, e)).join(" ") : t.indexOf(" ") !== -1 ? Ak(t.split(/\s+/g), e) : "".concat(t, ".").concat(e);
}, oY = function(t, e) {
  if (!sae(t))
    return !1;
  var i = t.nodeName.toLowerCase(), r = !isNaN(e), n = t.disabled, a = /^(input|select|textarea|button|object|iframe)$/.test(i), o = i === "a", u, c = t.isContentEditable;
  return a || c ? u = !n : o ? u = t.href || r : u = r, u;
};
function sae(t) {
  var e = E(t);
  return e.is(":visible") && e.css("visibility") !== "hidden" && e.parents().css("visibility") !== "hidden";
}
var Ok = function(t, e) {
  return oY(e, E(e).attr("tabIndex"));
}, R$ = function(t, e) {
  var i = E(e).attr("tabIndex");
  return (isNaN(i) || i >= 0) && oY(e, i);
}, Ah = function(t) {
  var e = E(t).get(0);
  return de.getActiveElement(e) === e;
}, lae = {
  backspace: "backspace",
  tab: "tab",
  enter: "enter",
  escape: "escape",
  pageup: "pageUp",
  pagedown: "pageDown",
  end: "end",
  home: "home",
  arrowleft: "leftArrow",
  arrowup: "upArrow",
  arrowright: "rightArrow",
  arrowdown: "downArrow",
  delete: "del",
  " ": "space",
  f: "F",
  a: "A",
  "*": "asterisk",
  "-": "minus",
  alt: "alt",
  control: "control",
  shift: "shift"
}, uae = {
  8: "backspace",
  9: "tab",
  13: "enter",
  27: "escape",
  33: "pageUp",
  34: "pageDown",
  35: "end",
  36: "home",
  37: "leftArrow",
  38: "upArrow",
  39: "rightArrow",
  40: "downArrow",
  46: "del",
  32: "space",
  70: "F",
  65: "A",
  106: "asterisk",
  109: "minus",
  189: "minus",
  173: "minus",
  16: "shift",
  17: "control",
  18: "alt"
}, dae = {
  dx: /^dx/i,
  mouse: /(mouse|wheel)/i,
  touch: /^touch/i,
  keyboard: /^key/i,
  pointer: /^(ms)?pointer/i
}, cae = (t) => t, hae = (t) => cae(k.Event(t, t), t), IF = (t) => rS(t) === "dx", fae = (t) => rS(t) === "mouse", sY = (t) => rS(t) === "touch", rS = (t) => {
  var {
    type: e
  } = t, i = "other";
  return N(dae, function(r) {
    if (this.test(e))
      return i = r, !1;
  }), i;
}, lY = (t) => rS(t) === "pointer", wp = (t) => fae(t) || (lY(t) || IF(t)) && t.pointerType === "mouse", oo = (t) => t && t.type === "dxmousewheel", nS = (t) => sY(t) || (lY(t) || IF(t)) && t.pointerType === "touch";
var br = (t) => {
  var {
    pageX: e,
    pageY: i,
    timeStamp: r
  } = t;
  return {
    x: e,
    y: i,
    time: r
  };
}, hp = (t, e) => ({
  x: e.x - t.x,
  y: e.y - t.y,
  time: e.time - t.time || 1
}), pae = (t) => {
  var {
    originalEvent: e,
    pointers: i
  } = t;
  return sY(t) ? (e.touches || []).length : IF(t) ? (i || []).length : 0;
}, vae = !1;
var uY = (t) => {
  if (vae)
    return !0;
  var {
    target: e
  } = t, i = E(e), r = (e == null ? void 0 : e.isContentEditable) || (e == null ? void 0 : e.hasAttribute("contenteditable")), n = i.is("input, textarea, select") || r;
  if (oo(t)) {
    var a = i.is("textarea") && i.hasClass("dx-texteditor-input");
    if (a || r)
      return !1;
    var o = i.is("input[type='number'], textarea, select") && i.is(":focus");
    return o;
  }
  if (wp(t))
    return n || t.which > 1;
  if (nS(t))
    return n && Ah(i);
};
var Ch = (t, e) => {
  var i = hae(t);
  return e && P(i, e), i;
}, Bh = (t) => {
  var {
    originalEvent: e,
    delegateTarget: i
  } = t, r = Ch(e, t);
  return k.trigger(i || r.target, r), r;
}, or = (t) => {
  var {
    key: e,
    which: i
  } = t, r = lae[e == null ? void 0 : e.toLowerCase()] || e, n = uae[i];
  return n && r === e ? n : !r && i ? String.fromCharCode(i) : r;
}, Rk = (t) => {
  var {
    key: e,
    which: i
  } = t;
  return e || String.fromCharCode(i);
}, ve = Ak, Cn = (t) => {
  var {
    ctrlKey: e,
    metaKey: i
  } = t;
  return e || i;
}, L$ = "compositionstart", gae = "compositionend", mae = "keydown", RR = "KeyboardProcessor", dY = (t) => ({
  keyName: or(t),
  key: t.key,
  code: t.code,
  ctrl: t.ctrlKey,
  location: t.location,
  metaKey: t.metaKey,
  shift: t.shiftKey,
  alt: t.altKey,
  which: t.which,
  originalEvent: t
}), DF = wi.inherit({
  _keydown: ve(mae, RR),
  _compositionStart: ve(L$, RR),
  _compositionEnd: ve(gae, RR),
  ctor: function(t) {
    t = t || {}, t.element && (this._element = E(t.element)), t.focusTarget && (this._focusTarget = t.focusTarget), this._handler = t.handler, this._element && (this._processFunction = (e) => {
      var i = E(this._focusTarget).toArray(), r = this._focusTarget && this._focusTarget !== e.target && !i.includes(e.target), n = this._isComposingJustFinished && e.which === 229 || this._isComposing || r;
      this._isComposingJustFinished = !1, n || this.process(e);
    }, this._toggleProcessingWithContext = this.toggleProcessing.bind(this), k.on(this._element, this._keydown, this._processFunction), k.on(this._element, this._compositionStart, this._toggleProcessingWithContext), k.on(this._element, this._compositionEnd, this._toggleProcessingWithContext));
  },
  dispose: function() {
    this._element && (k.off(this._element, this._keydown, this._processFunction), k.off(this._element, this._compositionStart, this._toggleProcessingWithContext), k.off(this._element, this._compositionEnd, this._toggleProcessingWithContext)), this._element = void 0, this._handler = void 0;
  },
  process: function(t) {
    this._handler(dY(t));
  },
  toggleProcessing: function(t) {
    var {
      type: e
    } = t;
    this._isComposing = e === L$, this._isComposingJustFinished = !this._isComposing;
  }
});
DF.createKeyDownOptions = dY;
const ph = {
  lockCount: 0,
  lock() {
    this.lockCount++;
  },
  callbacks: [],
  callEffects() {
    if (this.lockCount--, this.lockCount < 0)
      throw new Error("Unexpected Effect Call");
    if (this.lockCount === 0) {
      const t = this.callbacks;
      this.callbacks = [], t.forEach((e) => e());
    }
  }
}, LR = (t, e) => {
  if (!(t instanceof Object && e instanceof Object))
    return t === e;
  const r = Object.keys(t), n = Object.keys(e);
  return r.length !== n.length ? !1 : !r.some((o) => t[o] !== e[o]);
};
class qs extends iS {
  constructor() {
    super(...arguments), this._pendingContext = this.context;
  }
  componentWillReceiveProps(e, i) {
    this._pendingContext = i ?? {};
  }
  shouldComponentUpdate(e, i) {
    return !LR(this.props, e) || !LR(this.state, i) || !LR(this.context, this._pendingContext);
  }
}
class Bu extends qs {
  constructor() {
    super(...arguments), this._effects = [];
  }
  createEffects() {
    return [];
  }
  updateEffects() {
  }
  componentWillMount() {
    ph.lock();
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentWillUpdate(e, i, r) {
    ph.lock();
  }
  componentDidMount() {
    ph.callbacks.push(() => {
      this._effects = this.createEffects();
    }), ph.callEffects();
  }
  componentDidUpdate() {
    ph.callbacks.push(() => this.updateEffects()), ph.callEffects();
  }
  destroyEffects() {
    this._effects.forEach((e) => e.dispose());
  }
  componentWillUnmount() {
    this.destroyEffects();
  }
}
class aS extends Bu {
  constructor() {
    super(...arguments), this.vDomElement = null;
  }
  vDomUpdateClasses() {
    const e = this.vDomElement, i = e.className.length ? e.className.split(" ") : [], r = i.filter((a) => e.dxClasses.previous.indexOf(a) < 0), n = e.dxClasses.previous.filter((a) => i.indexOf(a) < 0);
    r.forEach((a) => {
      const o = e.dxClasses.removed.indexOf(a);
      o > -1 ? e.dxClasses.removed.splice(o, 1) : e.dxClasses.added.push(a);
    }), n.forEach((a) => {
      const o = e.dxClasses.added.indexOf(a);
      o > -1 ? e.dxClasses.added.splice(o, 1) : e.dxClasses.removed.push(a);
    });
  }
  componentDidMount() {
    const e = Ws(this.$LI, !0);
    this.vDomElement = e, super.componentDidMount(), e.dxClasses = e.dxClasses || {
      removed: [],
      added: [],
      previous: []
    }, e.dxClasses.previous = e != null && e.className.length ? e.className.split(" ") : [];
  }
  componentDidUpdate() {
    super.componentDidUpdate();
    const e = this.vDomElement;
    e !== null && (e.dxClasses.added.forEach((i) => e.classList.add(i)), e.dxClasses.removed.forEach((i) => e.classList.remove(i)), e.dxClasses.previous = e.className.length ? e.className.split(" ") : []);
  }
  shouldComponentUpdate(e, i) {
    const r = super.shouldComponentUpdate(e, i);
    return r && this.vDomUpdateClasses(), r;
  }
}
let _ae = 0;
const cY = function(t) {
  const e = _ae++;
  return {
    id: e,
    defaultValue: t,
    Provider: class extends iS {
      getChildContext() {
        return Object.assign(Object.assign({}, this.context), { [e]: this.props.value || t });
      }
      render() {
        return this.props.children;
      }
    }
  };
};
class ar {
  constructor(e, i) {
    this.dependency = i, this.effect = e, this.destroy = e();
  }
  update(e) {
    const i = this.dependency;
    e && (this.dependency = e), (!e || e.some((r, n) => i[n] !== r)) && (this.dispose(), this.destroy = this.effect());
  }
  dispose() {
    this.destroy && this.destroy();
  }
}
const oS = () => new ar(() => {
  nY();
}, []), Cae = "a runtime error occured! Use Inferno in development environment to find the error.";
function yae(t) {
  return t == null;
}
function xae(t) {
  return t === null || t === !1 || t === !0 || t === void 0;
}
function Sae(t) {
  return typeof t == "function";
}
function gm(t) {
  return t === null;
}
function Eae(t) {
  throw t || (t = Cae), new Error(`Inferno Error: ${t}`);
}
function bae(t, e) {
  const i = document.createElement("i");
  return i.innerHTML = e, i.innerHTML === t.innerHTML;
}
function wae(t) {
  let e, i;
  for (; t; ) {
    if (e = t.flags, e & 2033)
      return t.dom;
    i = t.children, e & 8192 ? t = t.childFlags === 2 ? i : i[i.length - 1] : e & 4 ? t = i.$LI : t = i;
  }
  return null;
}
function Tae(t, e) {
  return !!(e && e.dangerouslySetInnerHTML && e.dangerouslySetInnerHTML.__html && bae(t, e.dangerouslySetInnerHTML.__html));
}
function Iae(t, e, i, r, n, a, o) {
  const u = t.type, c = t.ref, p = t.props || Fn;
  let v;
  if (a) {
    const _ = Qj(t, u, p, r, n, o), y = _.$LI;
    v = kx(y, e, i, _.$CX, n, o), eY(c, _, o);
  } else {
    const _ = aI(wF(t, r));
    v = kx(_, e, i, r, n, o), t.children = _, tY(t, o);
  }
  return v;
}
function hY(t, e, i, r, n, a) {
  const o = t.childFlags, u = t.children, c = t.props, p = t.flags;
  if (o !== 1) {
    if (o === 2)
      gm(i) ? Hn(u, e, r, n, null, a) : (i = kx(u, e, i, r, n, a), i = i ? i.nextSibling : null);
    else if (o === 16)
      gm(i) ? e.appendChild(document.createTextNode(u)) : e.childNodes.length !== 1 || i.nodeType !== 3 ? e.textContent = u : i.nodeValue !== u && (i.nodeValue = u), i = null;
    else if (o & 12) {
      let v = !1;
      for (let _ = 0, y = u.length; _ < y; ++_) {
        const b = u[_];
        gm(i) || v && (b.flags & 16) > 0 ? Hn(b, e, r, n, i, a) : (i = kx(b, e, i, r, n, a), i = i ? i.nextSibling : null), v = (b.flags & 16) > 0;
      }
    }
    if (!(p & 8192)) {
      let v = null;
      for (; i; )
        v = i.nextSibling, e.removeChild(i), i = v;
    }
  } else
    !gm(e.firstChild) && !Tae(e, c) && (e.textContent = "", p & 448 && (e.defaultValue = ""));
}
function Dae(t, e, i, r, n, a) {
  const o = t.props, u = t.className, c = t.flags, p = t.ref;
  return n = n || (c & 32) > 0, i.nodeType !== 1 ? (Jj(t, null, r, n, null, a), e.replaceChild(t.dom, i)) : (t.dom = i, hY(t, i, i.firstChild, r, n, a), gm(o) || qj(t, c, o, i, n), yae(u) ? i.className !== "" && i.removeAttribute("class") : n ? i.setAttribute("class", u) : i.className = u, tS(p, i, a)), t.dom;
}
function fY(t, e, i) {
  if (i.nodeType !== 3)
    e.replaceChild(t.dom = document.createTextNode(t.children), i);
  else {
    const r = t.children;
    i.nodeValue !== r && (i.nodeValue = r), t.dom = i;
  }
  return t.dom;
}
function Aae(t, e, i, r, n, a) {
  const o = t.children;
  return t.childFlags === 2 ? (fY(o, e, i), o.dom) : (hY(t, e, i, r, n, a), wae(o[o.length - 1]));
}
function kx(t, e, i, r, n, a) {
  const o = t.flags |= 16384;
  return o & 14 ? Iae(t, e, i, r, n, (o & 4) > 0, a) : o & 481 ? Dae(t, e, i, r, n, a) : o & 16 ? fY(t, e, i) : o & 512 ? t.dom = i : o & 8192 ? Aae(t, e, i, r, n, a) : (Eae(), null);
}
function Oae(t, e, i) {
  let r = e.firstChild;
  if (gm(r))
    sI(t, e, i);
  else {
    const n = [];
    for (xae(t) || (r = kx(t, e, r, {}, !1, n)); r && (r = r.nextSibling); )
      e.removeChild(r);
    if (n.length > 0) {
      let a;
      for (; (a = n.shift()) !== void 0; )
        a();
    }
  }
  e.$V = t, Sae(i) && i();
}
function M$(t) {
  return t == null;
}
function Rae(t) {
  return typeof t == "string";
}
function k$(t) {
  return t === void 0;
}
var Lae = {
  onComponentDidMount: 1,
  onComponentDidUpdate: 1,
  onComponentShouldUpdate: 1,
  onComponentWillMount: 1,
  onComponentWillUnmount: 1,
  onComponentWillUpdate: 1
};
function Hw(t, e, i) {
  var r = arguments, n, a = null, o = null, u = null, c = 0, p, v = arguments.length - 2;
  if (v === 1)
    n = i;
  else if (v > 1)
    for (n = []; v-- > 0; )
      n[v] = r[v + 2];
  if (Rae(t)) {
    if (c = hne(t), !M$(e)) {
      p = {};
      for (var _ in e)
        _ === "className" || _ === "class" ? u = e[_] : _ === "key" ? o = e.key : _ === "children" && k$(n) ? n = e.children : _ === "ref" ? a = e.ref : (_ === "contenteditable" && (c |= 4096), p[_] = e[_]);
    }
  } else {
    if (c = 2, k$(n) || (e || (e = {}), e.children = n), !M$(e)) {
      p = {};
      for (var y in e)
        y === "key" ? o = e.key : y === "ref" ? a = e.ref : Lae[y] === 1 ? (a || (a = {}), a[y] = e[y]) : p[y] = e[y];
    }
    return zi(c, t, p, o, a);
  }
  return c & 8192 ? sc(v === 1 ? [n] : n, 0, o) : Fr(c, t, u, n, 0, p, o, a);
}
const Mae = (t) => {
  var e, i;
  return ((e = t.container) === null || e === void 0 ? void 0 : e.get(0)) || ((i = t.item) === null || i === void 0 ? void 0 : i.get(0));
};
function kae(t, e, i) {
  setTimeout(() => {
    sI(Hw(t, e), Mae(e));
  }, 0);
}
const Pae = (t, e, i) => {
  const r = e[t];
  return !!r && typeof r != "string";
}, Fae = /* @__PURE__ */ new Set([
  "animationIterationCount",
  "borderImageOutset",
  "borderImageSlice",
  "border-imageWidth",
  "boxFlex",
  "boxFlexGroup",
  "boxOrdinalGroup",
  "columnCount",
  "fillOpacity",
  "flex",
  "flexGrow",
  "flexNegative",
  "flexOrder",
  "flexPositive",
  "flexShrink",
  "floodOpacity",
  "fontWeight",
  "gridColumn",
  "gridRow",
  "lineClamp",
  "lineHeight",
  "opacity",
  "order",
  "orphans",
  "stopOpacity",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "tabSize",
  "widows",
  "zIndex",
  "zoom"
]), Bae = (t) => typeof t == "number" ? !0 : !Number.isNaN(Number(t)), Vae = (t, e) => Fae.has(t) ? e : `${e}px`, Nae = /[A-Z]/g, Hae = (t) => t.replace(Nae, "-$&").toLowerCase();
function AF(t) {
  if (t instanceof Object)
    return Object.entries(t).reduce((e, [i, r]) => (e[Hae(i)] = Bae(r) ? Vae(i, r) : r, e), {});
}
var P$ = (t) => {
  var {
    parentNode: e
  } = t;
  if (e) {
    var i = t.nextSibling;
    qx(t), e.$V = t.$V, sI(null, e), e.insertBefore(t, i), t.innerHTML = "", delete e.$V;
  }
  delete t.$V;
};
const jg = js({
  createElement: (t, e) => Hw(t, e),
  remove: P$,
  onAfterRender: () => {
    ph.callEffects();
  },
  onPreRender: () => {
    ph.lock();
  },
  render: (t, e, i, r) => {
    if (r)
      sI(Hw(t, e), i);
    else {
      var {
        parentNode: n
      } = i, a = i == null ? void 0 : i.nextSibling, o = de.createElement("div");
      o.appendChild(i);
      var u = de.createDocumentFragment().appendChild(o), c = !!i.$V;
      c && P$(i), Oae(Hw(t, e), u), i.$V = u.$V, n && n.insertBefore(i, a);
    }
  }
});
var MR = [], $ae = oc(() => {
  var t = de.listen(de.getDocument(), "DOMContentLoaded", () => {
    pY.fire(), t();
  });
}), pY = {
  add: (t) => {
    var e = wt();
    e && de.getReadyState() !== "loading" ? t() : (MR.push(t), e && $ae());
  },
  fire: () => {
    MR.forEach((t) => t()), MR = [];
  }
};
const Vu = js(pY);
var Tp = function() {
  var t, e = ui(), i = e.add, r = e.remove;
  if (!wt())
    return e;
  var n = function() {
    var c = Ot();
    return {
      width: c.innerWidth,
      height: c.innerHeight
    };
  }, a = function() {
    var c = n();
    if (!(c.width === t.width && c.height === t.height)) {
      var p;
      c.width === t.width && (p = "height"), c.height === t.height && (p = "width"), t = c, e.fire(p);
    }
  }, o = oc(function() {
    t = n();
  }), u;
  return e.add = function() {
    var c = i.apply(e, arguments);
    return o(), Vu.add(function() {
      !u && e.has() && (u = de.listen(Ot(), "resize", a));
    }), c;
  }, e.remove = function() {
    var c = r.apply(e, arguments);
    return !e.has() && u && (u(), u = void 0), c;
  }, e;
}(), zae = function(t, e) {
  return 1 / t === 1 / e;
}, Wae = function(t, e) {
  if (t = ta(t, !0), e = ta(e, !0), t && e && hs(t) && hs(e))
    return e.is(t);
  var i = t !== t, r = e !== e;
  return i && r ? !0 : t === 0 && e === 0 ? zae(t, e) : t === null || typeof t != "object" || de.isElementNode(t) ? t === e : !1;
}, Uae = Ot(), vY = function() {
  var t;
  try {
    t = Uae.sessionStorage;
  } catch {
  }
  return t;
}, Gae = Vu.add, lI = ui(), gY = E(), Oh = /* @__PURE__ */ function() {
  var t;
  return function(e) {
    if (!arguments.length)
      return t;
    var i = E(e);
    gY = i;
    var r = !!i.length, n = Oh();
    t = r ? i : E("body"), lI.fire(r ? Oh() : E(), n);
  };
}();
Gae(function() {
  Oh(".dx-viewport");
});
function mY() {
  return gY;
}
var _Y = Ot(), Kae = {
  iPhone: "iPhone",
  iPhone5: "iPhone",
  iPhone6: "iPhone",
  iPhone6plus: "iPhone",
  iPad: "iPad",
  iPadMini: "iPad Mini",
  androidPhone: "Android Mobile",
  androidTablet: "Android",
  msSurface: "Windows ARM Tablet PC",
  desktop: "desktop"
}, F$ = {
  deviceType: "desktop",
  platform: "generic",
  version: [],
  phone: !1,
  tablet: !1,
  android: !1,
  ios: !1,
  generic: !0,
  grade: "A",
  mac: !1
}, kR = {
  generic(t) {
    var e = /windows phone/i.test(t) || t.match(/WPDesktop/), i = !e && /Windows(.*)arm(.*)Tablet PC/i.test(t), r = !e && !i && /msapphost/i.test(t), n = /((intel|ppc) mac os x)/.test(t.toLowerCase());
    return e || i || r || n ? {
      deviceType: e ? "phone" : i ? "tablet" : "desktop",
      platform: "generic",
      version: [],
      grade: "A",
      mac: n
    } : null;
  },
  appleTouchDevice(t) {
    var e = Yx(), i = /Macintosh/i.test(t) && (e == null ? void 0 : e.maxTouchPoints) > 2, r = /ip(hone|od|ad)/i.test(t);
    if (!r && !i)
      return null;
    var n = /ip(hone|od)/i.test(t), a = t.match(/os\s{0,}X? (\d+)_(\d+)_?(\d+)?/i), o = a ? [parseInt(a[1], 10), parseInt(a[2], 10), parseInt(a[3] || 0, 10)] : [], u = _Y.screen.height === 480, c = u ? "B" : "A";
    return {
      deviceType: n ? "phone" : "tablet",
      platform: "ios",
      version: o,
      grade: c
    };
  },
  android(t) {
    var e = /android|htc_|silk/i.test(t), i = /windows phone/i.test(t);
    if (!e || i)
      return null;
    var r = /mobile/i.test(t), n = t.match(/android (\d+)\.?(\d+)?\.?(\d+)?/i), a = n ? [parseInt(n[1], 10), parseInt(n[2] || 0, 10), parseInt(n[3] || 0, 10)] : [], o = a.length > 1 && (a[0] < 4 || a[0] === 4 && a[1] < 4), u = o ? "B" : "A";
    return {
      deviceType: r ? "phone" : "tablet",
      platform: "android",
      version: a,
      grade: u
    };
  }
}, B$ = [kR.appleTouchDevice, kR.android, kR.generic];
class jae {
  constructor(e) {
    this._window = (e == null ? void 0 : e.window) || _Y, this._realDevice = this._getDevice(), this._currentDevice = void 0, this._currentOrientation = void 0, this._eventsStrategy = new Hp(this), this.changed = ui(), wt() && (Vu.add(this._recalculateOrientation.bind(this)), Tp.add(this._recalculateOrientation.bind(this)));
  }
  current(e) {
    if (e) {
      this._currentDevice = this._getDevice(e), this._forced = !0, this.changed.fire();
      return;
    }
    if (!this._currentDevice) {
      e = void 0;
      try {
        e = this._getDeviceOrNameFromWindowScope();
      } catch {
        e = this._getDeviceNameFromSessionStorage();
      } finally {
        e || (e = this._getDeviceNameFromSessionStorage()), e && (this._forced = !0);
      }
      this._currentDevice = this._getDevice(e);
    }
    return this._currentDevice;
  }
  real(e) {
    return P({}, this._realDevice);
  }
  orientation() {
    return this._currentOrientation;
  }
  isForced() {
    return this._forced;
  }
  isRippleEmulator() {
    return !!this._window.tinyHippos;
  }
  _getCssClasses(e) {
    var i = [], r = this._realDevice;
    return e = e || this.current(), e.deviceType && (i.push("dx-device-".concat(e.deviceType)), e.deviceType !== "desktop" && i.push("dx-device-mobile")), i.push("dx-device-".concat(r.platform)), r.version && r.version.length && i.push("dx-device-".concat(r.platform, "-").concat(r.version[0])), this.isSimulator() && i.push("dx-simulator"), Oi().rtlEnabled && i.push("dx-rtl"), i;
  }
  attachCssClasses(e, i) {
    this._deviceClasses = this._getCssClasses(i).join(" "), E(e).addClass(this._deviceClasses);
  }
  detachCssClasses(e) {
    E(e).removeClass(this._deviceClasses);
  }
  isSimulator() {
    try {
      return this._isSimulator || wt() && this._window.top !== this._window.self && this._window.top["dx-force-device"] || this.isRippleEmulator();
    } catch {
      return !1;
    }
  }
  forceSimulator() {
    this._isSimulator = !0;
  }
  _getDevice(e) {
    if (e === "genericPhone" && (e = {
      deviceType: "phone",
      platform: "generic",
      generic: !0
    }), $t(e))
      return this._fromConfig(e);
    var i;
    if (e) {
      if (i = Kae[e], !i)
        throw bi.Error("E0005");
    } else {
      var r = Yx();
      i = r.userAgent;
    }
    return this._fromUA(i);
  }
  _getDeviceOrNameFromWindowScope() {
    var e;
    return wt() && (this._window.top["dx-force-device-object"] || this._window.top["dx-force-device"]) && (e = this._window.top["dx-force-device-object"] || this._window.top["dx-force-device"]), e;
  }
  _getDeviceNameFromSessionStorage() {
    var e = vY();
    if (e) {
      var i = e.getItem("dx-force-device");
      try {
        return JSON.parse(i);
      } catch {
        return i;
      }
    }
  }
  _fromConfig(e) {
    var i = P({}, F$, this._currentDevice, e), r = {
      phone: i.deviceType === "phone",
      tablet: i.deviceType === "tablet",
      android: i.platform === "android",
      ios: i.platform === "ios",
      generic: i.platform === "generic"
    };
    return P(i, r);
  }
  _fromUA(e) {
    for (var i = 0; i < B$.length; i += 1) {
      var r = B$[i], n = r(e);
      if (n)
        return this._fromConfig(n);
    }
    return F$;
  }
  _changeOrientation() {
    var e = E(this._window), i = Pt(e) > mt(e) ? "portrait" : "landscape";
    this._currentOrientation !== i && (this._currentOrientation = i, this._eventsStrategy.fireEvent("orientationChanged", [{
      orientation: i
    }]));
  }
  _recalculateOrientation() {
    var e = mt(this._window);
    this._currentWidth !== e && (this._currentWidth = e, this._changeOrientation());
  }
  on(e, i) {
    return this._eventsStrategy.on(e, i), this;
  }
  off(e, i) {
    return this._eventsStrategy.off(e, i), this;
  }
}
var Ye = new jae(), V$ = Oh();
V$ && Ye.attachCssClasses(V$);
lI.add((t, e) => {
  Ye.detachCssClasses(e), Ye.attachCssClasses(t);
});
var PR = {}, Rm = (t) => {
  var e = Ye.current();
  return t.reduce((i, r) => {
    var {
      device: n,
      options: a
    } = r, o = n || {}, u = Le(o) ? o(e) : qae(e, o);
    return u && P(!0, i, a), i;
  }, {});
}, Yae = (t, e) => typeof t != "string" ? t : {
  [t]: e
}, qae = (t, e) => uo(e) || J3(t, [e]).length > 0, N$ = (t) => t.substr(t.lastIndexOf(".") + 1), H$ = (t) => t.substr(0, t.lastIndexOf(".")), Xae = function(t, e) {
  return PR[e] = PR[e] || Ii(e), PR[e](t, {
    functionsAsIs: !0
  });
}, Qae = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return t;
}, FR = {}, BR = {};
class Zae {
  constructor(e, i) {
    this._options = e, this._optionsByReference = i, this._changingCallback, this._changedCallback, this._namePreparedCallbacks;
  }
  _setByReference(e, i) {
    P(!0, e, i);
    for (var r in this._optionsByReference)
      Object.prototype.hasOwnProperty.call(i, r) && (e[r] = i[r]);
  }
  _setPreparedValue(e, i, r, n) {
    var a = this.get(this._options, e, !1);
    if (!Wae(a, i)) {
      var o = Vp(e);
      !n && this._changingCallback(e, a, i), BR[e] = BR[e] || nF(e), BR[e](this._options, i, {
        functionsAsIs: !0,
        merge: R(r) ? r : !this._optionsByReference[e],
        unwrapObservables: o.length > 1 && !!this._optionsByReference[o[0]]
      }), !n && this._changedCallback(e, i, a);
    }
  }
  _prepareRelevantNames(e, i, r, n) {
    if ($t(r))
      for (var a in r)
        this._prepareRelevantNames(e, "".concat(i, ".").concat(a), r[a]);
    this._namePreparedCallbacks(e, i, r, n);
  }
  get() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._options, i = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 ? arguments[2] : void 0;
    return FR[i] = FR[i] || Ii(i), FR[i](e, {
      functionsAsIs: !0,
      unwrapObservables: r
    });
  }
  set(e, i, r, n) {
    e = Yae(e, i);
    for (var a in e)
      this._prepareRelevantNames(e, a, e[a], n);
    for (var o in e)
      this._setPreparedValue(o, e[o], r, n);
  }
  onRelevantNamesPrepared(e) {
    this._namePreparedCallbacks = e;
  }
  onChanging(e) {
    this._changingCallback = e;
  }
  onChanged(e) {
    this._changedCallback = e;
  }
  dispose() {
    this._changingCallback = ee, this._changedCallback = ee;
  }
}
class Jae {
  constructor(e, i, r, n) {
    this._deprecatedCallback, this._startChangeCallback, this._endChangeCallback, this._default = i, this._deprecated = n, this._deprecatedNames = [], this._initDeprecatedNames(), this._optionManager = new Zae(e, r), this._optionManager.onRelevantNamesPrepared((a, o, u, c) => this._setRelevantNames(a, o, u, c)), this._cachedOptions = {}, this._rules = [];
  }
  set _initial(e) {
    this._initialOptions = e;
  }
  get _initial() {
    if (!this._initialOptions) {
      var e = this._getByRules(this.silent("defaultOptionsRules"));
      this._initialOptions = this._default, this._optionManager._setByReference(this._initialOptions, e);
    }
    return this._initialOptions;
  }
  _initDeprecatedNames() {
    for (var e in this._deprecated)
      this._deprecatedNames.push(e);
  }
  _getByRules(e) {
    return e = Array.isArray(e) ? this._rules.concat(e) : this._rules, Rm(e);
  }
  _notifyDeprecated(e) {
    var i = this._deprecated[e];
    i && this._deprecatedCallback(e, i);
  }
  _setRelevantNames(e, i, r, n) {
    if (i) {
      var a = this._normalizeName(i, n);
      a && a !== i && (this._setField(e, a, r), this._clearField(e, i));
    }
  }
  _setField(e, i, r) {
    var n = "", a = null;
    do
      n = n ? ".".concat(n) : "", n = N$(i) + n, i = H$(i), a = i ? this._optionManager.get(e, i, !1) : e;
    while (!a);
    a[n] = r;
  }
  _clearField(e, i) {
    delete e[i];
    var r = H$(i), n = r ? this._optionManager.get(e, r, !1) : e;
    n && delete n[N$(i)];
  }
  _normalizeName(e, i) {
    if (this._deprecatedNames.length && e) {
      for (var r = 0; r < this._deprecatedNames.length; r++)
        if (this._deprecatedNames[r] === e) {
          var n = this._deprecated[e];
          if (n)
            return !i && this._notifyDeprecated(e), n.alias || e;
        }
    }
    return e;
  }
  addRules(e) {
    this._rules = e.concat(this._rules);
  }
  applyRules(e) {
    var i = this._getByRules(e);
    this.silent(i);
  }
  dispose() {
    this._deprecatedCallback = ee, this._startChangeCallback = ee, this._endChangeCallback = ee, this._optionManager.dispose();
  }
  onChanging(e) {
    this._optionManager.onChanging(e);
  }
  onChanged(e) {
    this._optionManager.onChanged(e);
  }
  onDeprecated(e) {
    this._deprecatedCallback = e;
  }
  onStartChange(e) {
    this._startChangeCallback = e;
  }
  onEndChange(e) {
    this._endChangeCallback = e;
  }
  isInitial(e) {
    var i = this.silent(e), r = this.initial(e), n = Le(i) && Le(r);
    return n ? i.toString() === r.toString() : Mi(i, r);
  }
  initial(e) {
    return Xae(this._initial, e);
  }
  option(e, i) {
    var r = arguments.length < 2 && cs(e) !== "object";
    if (r)
      return this._optionManager.get(void 0, this._normalizeName(e));
    this._startChangeCallback();
    try {
      this._optionManager.set(e, i);
    } finally {
      this._endChangeCallback();
    }
  }
  silent(e, i) {
    var r = arguments.length < 2 && cs(e) !== "object";
    if (r)
      return this._optionManager.get(void 0, e, void 0, !0);
    this._optionManager.set(e, i, void 0, !0);
  }
  reset(e) {
    if (e) {
      var i = Vp(e), r = i.reduce((a, o) => a ? a[o] : this.initial(o), null), n = ct(r) ? ae({}, r) : r;
      this._optionManager.set(e, n, !1);
    }
  }
  getAliasesByName(e) {
    return Object.keys(this._deprecated).filter((i) => e === this._deprecated[i].alias);
  }
  isDeprecated(e) {
    return Object.prototype.hasOwnProperty.call(this._deprecated, e);
  }
  cache(e, i) {
    var r = arguments.length < 2;
    if (r)
      return this._cachedOptions[e];
    this._cachedOptions[e] = P(this._cachedOptions[e], i);
  }
}
class $o {
  constructor(e, i) {
    i = i || {}, this._action = e, this._context = i.context || Ot(), this._beforeExecute = i.beforeExecute, this._afterExecute = i.afterExecute, this._component = i.component, this._validatingTargetName = i.validatingTargetName;
    var r = this._excludeValidators = {};
    if (i.excludeValidators)
      for (var n = 0; n < i.excludeValidators.length; n++)
        r[i.excludeValidators[n]] = !0;
  }
  execute() {
    var e = {
      action: this._action,
      args: Array.prototype.slice.call(arguments),
      context: this._context,
      component: this._component,
      validatingTargetName: this._validatingTargetName,
      cancel: !1,
      handled: !1
    }, i = this._beforeExecute, r = this._afterExecute, n = e.args[0] || {};
    if (this._validateAction(e) && (i == null || i.call(this._context, e), !e.cancel)) {
      var a = this._executeAction(e);
      if (!n.cancel)
        return r == null || r.call(this._context, e), a;
    }
  }
  _validateAction(e) {
    var i = this._excludeValidators, {
      executors: r
    } = $o;
    for (var n in r)
      if (!i[n]) {
        var a, o = r[n];
        if ((a = o.validate) === null || a === void 0 || a.call(o, e), e.cancel)
          return !1;
      }
    return !0;
  }
  _executeAction(e) {
    var i, {
      executors: r
    } = $o;
    for (var n in r) {
      var a, o = r[n];
      if ((a = o.execute) === null || a === void 0 || a.call(o, e), e.handled) {
        i = e.result;
        break;
      }
    }
    return i;
  }
  static registerExecutor(e, i) {
    if ($t(e)) {
      N(e, $o.registerExecutor);
      return;
    }
    $o.executors[e] = i;
  }
  static unregisterExecutor() {
    for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++)
      i[r] = arguments[r];
    N(i, function() {
      delete $o.executors[this];
    });
  }
}
$o.executors = {};
var $$ = (t) => (e) => {
  if (e.args.length) {
    var i = e.args[0], r = i[e.validatingTargetName] || i.element;
    r && t(E(r)) && (e.cancel = !0);
  }
};
$o.registerExecutor({
  disabled: {
    validate: $$((t) => t.is(".dx-state-disabled, .dx-state-disabled *"))
  },
  readOnly: {
    validate: $$((t) => t.is(".dx-state-readonly, .dx-state-readonly *:not(.dx-state-independent)"))
  },
  undefined: {
    execute: (t) => {
      t.action || (t.result = void 0, t.handled = !0);
    }
  },
  func: {
    execute: (t) => {
      Le(t.action) && (t.result = t.action.call(t.context, t.args[0]), t.handled = !0);
    }
  }
});
class eoe {
  constructor() {
    this._postponedOperations = {};
  }
  add(e, i, r) {
    if (e in this._postponedOperations)
      r && this._postponedOperations[e].promises.push(r);
    else {
      var n = new q();
      this._postponedOperations[e] = {
        fn: i,
        completePromise: n,
        promises: r ? [r] : []
      };
    }
    return this._postponedOperations[e].completePromise.promise();
  }
  callPostponedOperations() {
    for (var e in this._postponedOperations) {
      var i = this._postponedOperations[e];
      R(i) && (i.promises && i.promises.length ? $e(...i.promises).done(i.fn).then(i.completePromise.resolve) : i.fn().done(i.completePromise.resolve));
    }
    this._postponedOperations = {};
  }
}
var z$ = (t) => t.charAt(2).toLowerCase() + t.substr(3), toe = (t) => t.indexOf("_", 0) === 0, CY = wi.inherit({
  _setDeprecatedOptions() {
    this._deprecatedOptions = {};
  },
  _getDeprecatedOptions() {
    return this._deprecatedOptions;
  },
  _getDefaultOptions: () => ({
    onInitialized: null,
    onOptionChanged: null,
    onDisposing: null,
    defaultOptionsRules: null
  }),
  _defaultOptionsRules: () => [],
  _setOptionsByDevice(t) {
    this._options.applyRules(t);
  },
  _convertRulesToOptions: (t) => Rm(t),
  _isInitialOptionValue(t) {
    return this._options.isInitial(t);
  },
  _setOptionsByReference() {
    this._optionsByReference = {};
  },
  _getOptionsByReference() {
    return this._optionsByReference;
  },
  ctor() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, {
      _optionChangedCallbacks: e,
      _disposingCallbacks: i
    } = t;
    this.NAME = Xx(this.constructor), this._eventsStrategy = Hp.create(this, t.eventsStrategy), this._updateLockCount = 0, this._optionChangedCallbacks = e || ui(), this._disposingCallbacks = i || ui(), this.postponedOperations = new eoe(), this._createOptions(t);
  },
  _createOptions(t) {
    this.beginUpdate();
    try {
      this._setOptionsByReference(), this._setDeprecatedOptions(), this._options = new Jae(this._getDefaultOptions(), this._getDefaultOptions(), this._getOptionsByReference(), this._getDeprecatedOptions()), this._options.onChanging((e, i, r) => this._initialized && this._optionChanging(e, i, r)), this._options.onDeprecated((e, i) => this._logDeprecatedOptionWarning(e, i)), this._options.onChanged((e, i, r) => this._notifyOptionChanged(e, i, r)), this._options.onStartChange(() => this.beginUpdate()), this._options.onEndChange(() => this.endUpdate()), this._options.addRules(this._defaultOptionsRules()), t && t.onInitializing && t.onInitializing.apply(this, [t]), this._setOptionsByDevice(t.defaultOptionsRules), this._initOptions(t);
    } finally {
      this.endUpdate();
    }
  },
  _initOptions(t) {
    this.option(t);
  },
  _init() {
    this._createOptionChangedAction(), this.on("disposing", (t) => {
      this._disposingCallbacks.fireWith(this, [t]);
    });
  },
  _logDeprecatedOptionWarning(t, e) {
    var i = e.message || "Use the '".concat(e.alias, "' option instead");
    bi.log("W0001", this.NAME, t, e.since, i);
  },
  _logDeprecatedComponentWarning(t, e) {
    bi.log("W0000", this.NAME, t, "Use the '".concat(e, "' widget instead"));
  },
  _createOptionChangedAction() {
    this._optionChangedAction = this._createActionByOption("onOptionChanged", {
      excludeValidators: ["disabled", "readOnly"]
    });
  },
  _createDisposingAction() {
    this._disposingAction = this._createActionByOption("onDisposing", {
      excludeValidators: ["disabled", "readOnly"]
    });
  },
  _optionChanged(t) {
    switch (t.name) {
      case "onDisposing":
      case "onInitialized":
        break;
      case "onOptionChanged":
        this._createOptionChangedAction();
    }
  },
  _dispose() {
    this._optionChangedCallbacks.empty(), this._createDisposingAction(), this._disposingAction(), this._eventsStrategy.dispose(), this._options.dispose(), this._disposed = !0;
  },
  _lockUpdate() {
    this._updateLockCount++;
  },
  _unlockUpdate() {
    this._updateLockCount = Math.max(this._updateLockCount - 1, 0);
  },
  _isUpdateAllowed() {
    return this._updateLockCount === 0;
  },
  _isInitializingRequired() {
    return !this._initializing && !this._initialized;
  },
  isInitialized() {
    return this._initialized;
  },
  _commitUpdate() {
    this.postponedOperations.callPostponedOperations(), this._isInitializingRequired() && this._initializeComponent();
  },
  _initializeComponent() {
    this._initializing = !0;
    try {
      this._init();
    } finally {
      this._initializing = !1, this._lockUpdate(), this._createActionByOption("onInitialized", {
        excludeValidators: ["disabled", "readOnly"]
      })(), this._unlockUpdate(), this._initialized = !0;
    }
  },
  instance() {
    return this;
  },
  beginUpdate: function() {
    this._lockUpdate();
  },
  endUpdate: function() {
    this._unlockUpdate(), this._isUpdateAllowed() && this._commitUpdate();
  },
  _optionChanging: ee,
  _notifyOptionChanged(t, e, i) {
    if (this._initialized)
      for (var r = [t].concat(this._options.getAliasesByName(t)), n = 0; n < r.length; n++) {
        var a = r[n], o = {
          name: Vp(a)[0],
          fullName: a,
          value: e,
          previousValue: i
        };
        toe(a) || (this._optionChangedCallbacks.fireWith(this, [P(this._defaultActionArgs(), o)]), this._optionChangedAction(P({}, o))), !this._disposed && this._cancelOptionChange !== a && this._optionChanged(o);
      }
  },
  initialOption(t) {
    return this._options.initial(t);
  },
  _defaultActionConfig() {
    return {
      context: this,
      component: this
    };
  },
  _defaultActionArgs() {
    return {
      component: this
    };
  },
  _createAction(t, e) {
    var i;
    return (r) => (R(r) || (r = {}), $t(r) || (r = {
      actionValue: r
    }), i = i || new $o(t, P({}, e, this._defaultActionConfig())), i.execute.call(i, P(r, this._defaultActionArgs())));
  },
  _createActionByOption(t, e) {
    var i = this, r, n, a;
    e = P({}, e);
    var o = function() {
      if (!n) {
        if (e = e || {}, typeof t != "string")
          throw bi.Error("E0008");
        t.indexOf("on") === 0 && (n = z$(t)), a = i.option(t);
      }
      if (!(!r && !a && !e.beforeExecute && !e.afterExecute && !i._eventsStrategy.hasEvent(n))) {
        if (!r) {
          var c = e.beforeExecute;
          e.beforeExecute = function() {
            for (var I = arguments.length, A = new Array(I), L = 0; L < I; L++)
              A[L] = arguments[L];
            c && c.apply(i, A), i._eventsStrategy.fireEvent(n, A[0].args);
          }, r = i._createAction(a, e);
        }
        for (var p = arguments.length, v = new Array(p), _ = 0; _ < p; _++)
          v[_] = arguments[_];
        if (Oi().wrapActionsBeforeExecute) {
          var y = i.option("beforeActionExecute") || ee, b = y(i, r, e) || r;
          return b.apply(i, v);
        }
        return r.apply(i, v);
      }
    };
    if (Oi().wrapActionsBeforeExecute)
      return o;
    var u = this.option("onActionCreated") || ee;
    return u(this, o, e) || o;
  },
  on(t, e) {
    return this._eventsStrategy.on(t, e), this;
  },
  off(t, e) {
    return this._eventsStrategy.off(t, e), this;
  },
  hasActionSubscription: function(t) {
    return !!this._options.silent(t) || this._eventsStrategy.hasEvent(z$(t));
  },
  isOptionDeprecated(t) {
    return this._options.isDeprecated(t);
  },
  _setOptionWithoutOptionChange(t, e) {
    this._cancelOptionChange = t, this.option(t, e), this._cancelOptionChange = !1;
  },
  _getOptionValue(t, e) {
    var i = this.option(t);
    return Le(i) ? i.bind(e)() : i;
  },
  option() {
    return this._options.option(...arguments);
  },
  resetOption(t) {
    this.beginUpdate(), this._options.reset(t), this.endUpdate();
  }
}), OF = Ot(), ioe = (t) => {
  if (t.getRootNode) {
    var e = t.getRootNode().host;
    if (!ht(e))
      return e;
  }
}, $m = () => {
  var t = de.getActiveElement();
  if (t && t !== de.getBody()) {
    var e;
    (e = t.blur) === null || e === void 0 || e.call(t);
  }
}, roe = () => {
  var t = OF.getSelection();
  if (t && t.type !== "Caret") {
    if (t.empty)
      t.empty();
    else if (t.removeAllRanges)
      try {
        t.removeAllRanges();
      } catch {
      }
  }
}, noe = (t, e) => {
  var i = E(t), r = E(e);
  if (i[0] === r[0])
    return i[0];
  for (var n = i.parents(), a = r.parents(), o = Math.min(n.length, a.length), u = -o; u < 0; u++)
    if (n.get(u) === a.get(u))
      return n.get(u);
};
var uI = (t) => {
  var e = R(t) && (t.nodeType || hs(t)) ? E(t) : E("<div>").html(t).contents();
  return e.length === 1 && (e.is("script") ? e = uI(e.html().trim()) : e.is("table") && (e = e.children("tbody").contents())), e;
}, Lk = (t, e) => {
  var i = t.originalEvent && t.originalEvent.clipboardData || OF.clipboardData;
  if (!e)
    return i && i.getData("Text");
  i && i.setData("Text", e);
}, Kd = (t, e) => e ? Or(t) ? Kd(t.document, e) : t.contains(e) || Kd(t, ioe(e)) : !1, aoe = (t, e, i) => {
  var r = OF.getComputedStyle(E(t).get(0)), n = i && i.includePaddings;
  return E("<div>").text(e).css({
    fontStyle: r.fontStyle,
    fontVariant: r.fontVariant,
    fontWeight: r.fontWeight,
    fontSize: r.fontSize,
    fontFamily: r.fontFamily,
    letterSpacing: r.letterSpacing,
    border: r.border,
    paddingTop: n ? r.paddingTop : "",
    paddingRight: n ? r.paddingRight : "",
    paddingBottom: n ? r.paddingBottom : "",
    paddingLeft: n ? r.paddingLeft : "",
    visibility: "hidden",
    whiteSpace: "pre",
    position: "absolute",
    float: "left"
  });
}, ooe = (t, e) => (e && de.insertElement(t.parentNode, e, t), t), soe = (t, e) => {
  if (e && e[0])
    return e.is(t) ? t : (N(e, (i, r) => {
      ooe(t[0], r);
    }), t.remove(), e);
}, dI = (t) => {
  var e = t == null ? void 0 : t.get(0), i = e == null ? void 0 : e.getRootNode().host;
  return !!E(i || e).closest(Ot().document).length;
}, RF = function(t) {
  return function(e) {
    for (var i = E(e || "body"), r = i.filter(".dx-visibility-change-handler").add(i.find(".dx-visibility-change-handler")), n = 0; n < r.length; n++)
      k.triggerHandler(r[n], t);
  };
}, LF = RF("dxshown"), loe = RF("dxhiding"), Iu = RF("dxresize"), uoe = ui({
  syncStrategy: !0
});
class $p {
  render(e) {
    e = e || {};
    var i = e.onRendered;
    delete e.onRendered;
    var r;
    return e.renovated && e.transclude && this._element ? r = E("<div>").append(this._element).contents() : r = this._renderCore(e), this._ensureResultInContainer(r, e.container), uoe.fire(r, e.container), i && i(), r;
  }
  _ensureResultInContainer(e, i) {
    if (i) {
      var r = E(i), n = Kd(r.get(0), e.get(0));
      if (r.append(e), !n) {
        var a = de.getBody().contains(r.get(0));
        a && LF(e);
      }
    }
  }
  _renderCore() {
    throw bi.Error("E0001");
  }
}
class Lm extends $p {
  constructor(e) {
    super(), this._render = e;
  }
  _renderCore(e) {
    return uI(this._render(e));
  }
}
class yp extends $p {
  _renderCore() {
    return E();
  }
}
var doe = function(t) {
  return t && t.get(0);
};
function ot(t) {
  return doe(t);
}
class MF extends $p {
  constructor(e) {
    super(), this.name = e;
  }
}
var yY = {}, $w;
function coe(t, e) {
  yY[t] = e;
}
function hoe(t) {
  if (ht(t)) {
    if ($w = yY[t], !$w)
      throw bi.Error("E0020", t);
  } else
    $w = t;
}
function W$() {
  return $w;
}
coe("default", {
  compile: (t) => uI(t),
  render: (t, e, i) => t.clone()
});
hoe("default");
let foe = class extends $p {
  constructor(e) {
    super(), this._element = e;
  }
  _renderCore(e) {
    var i = e.transclude;
    return !i && !this._compiledTemplate && (this._compiledTemplate = W$().compile(this._element)), E("<div>").append(i ? this._element : W$().render(this._compiledTemplate, e.model, e.index)).contents();
  }
  source() {
    return E(this._element).clone();
  }
};
function poe(t) {
  return t.reduce((e, i) => {
    var r, n = ((r = e.get(i)) !== null && r !== void 0 ? r : 0) + 1;
    return e.set(i, n), e;
  }, /* @__PURE__ */ new Map());
}
var voe = function(t) {
  return Array.isArray(t) ? t : [t];
}, goe = function(t) {
  return [...new Set(t)];
};
var U$ = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = poe(e);
  return t.filter((r) => {
    var n = i.get(r);
    return n && i.set(r, n - 1), !n;
  });
}, Px = function(t, e, i, r) {
  var n = {}, {
    useLegacyVisibleIndex: a
  } = Oi(), o = 0, u = (c) => !R(c[e]) && (!r || r(c));
  t.forEach((c) => {
    var p = c[e];
    p >= 0 ? (n[p] = n[p] || [], c === i ? n[p].unshift(c) : n[p].push(c)) : c[e] = void 0;
  }), a || t.forEach((c) => {
    if (u(c)) {
      for (; n[o]; )
        o++;
      n[o] = [c], o++;
    }
  }), o = 0, mk(n, function(c, p) {
    p.forEach((v) => {
      c >= 0 && (v[e] = o++);
    });
  }), a && t.forEach((c) => {
    u(c) && (c[e] = o++);
  });
}, moe = (t, e) => t.reduce((i, r) => {
  var n, a = e(r);
  return i[a] = (n = i[a]) !== null && n !== void 0 ? n : [], i[a].push(r), i;
}, {}), xY = (t, e) => {
  var i = E(t).contents().filter("[".concat("data-options", '*="').concat(e, '"]'));
  return [].slice.call(i).map((r) => {
    var n = E(r).attr("data-options") || "";
    return {
      element: r,
      options: Oi().optionsParser(n)[e]
    };
  }).filter((r) => !!r.options);
}, _oe = (t) => {
  var e = moe(t, (r) => r.options.name);
  if (e[void 0])
    throw bi.Error("E0023");
  var i = {};
  return Object.keys(e).forEach((r) => {
    var n, a = (n = J3(Ye.current(), e[r], (o) => o.options)[0]) === null || n === void 0 ? void 0 : n.element;
    a && (i[r] = a);
  }), i;
}, SY = (t) => {
  var e = t.render.bind(t);
  return P({}, t, {
    render(i) {
      var r = e(i);
      return i && i.onRendered && i.onRendered(), r;
    }
  });
}, Coe = (t) => {
  var e = t.render.bind(t);
  return P({}, t, {
    render(i) {
      var r = E(i.container);
      return e(ae({}, i, {
        container: ot(r)
      }));
    }
  });
}, yoe = (t) => {
  var e = [];
  return "model" in t && e.push(t.model), "index" in t && e.push(t.index), e.push(t.container), e;
}, xoe = (t) => typeof t == "string" ? uI(t) : t, G$ = (t) => hs(t) && t[0] || t, Soe = (t) => new foe(t), Eoe = (t, e, i, r) => {
  var n = null;
  return (!r || r.indexOf(t) === -1) && (n = e[t], n && !(n instanceof $p) && (Le(n.render) && (n = Coe(n)), i || (n = SY(n)))), n;
}, K$ = (t, e, i, r, n, a) => t == null ? new yp() : t instanceof MF ? a[t.name] : t instanceof $p ? t : Le(t.render) && !hs(t) ? r ? t : SY(t) : t.nodeType || hs(t) ? e(E(t)) : Eoe(t, i, r, n) || a[t] || e(t), boe = 3, woe = "template", Toe = "dxTemplate", Ioe = "dx-template-wrapper", Doe = new Lm((t) => {
  var {
    model: e,
    parent: i
  } = t, r = e.widget;
  if (!r)
    return E();
  var n = E("<div>"), a = e.options || {};
  return i ? i._createComponent(n, r, a) : n[r](a), n;
});
let j$ = class {
  constructor(e, i) {
    this._tempTemplates = [], this._defaultTemplates = {}, this._anonymousTemplateName = i || woe, this._createElement = e || Soe, this._createTemplateIfNeeded = this._createTemplateIfNeeded.bind(this);
  }
  static createDefaultOptions() {
    return {
      integrationOptions: {
        watchMethod: function(e, i) {
          var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return r.skipImmediate || i(e()), ee;
        },
        templates: {
          "dx-polymorph-widget": Doe
        },
        useDeferUpdateForTemplates: !0
      }
    };
  }
  get anonymousTemplateName() {
    return this._anonymousTemplateName;
  }
  addDefaultTemplates(e) {
    this._defaultTemplates = P({}, this._defaultTemplates, e);
  }
  dispose() {
    this._tempTemplates.forEach((e) => {
      e.template.dispose && e.template.dispose();
    }), this._tempTemplates = [];
  }
  extractTemplates(e) {
    var i = this._extractTemplates(e), r = this._extractAnonymousTemplate(e);
    return {
      templates: i,
      anonymousTemplateMeta: r
    };
  }
  _extractTemplates(e) {
    var i = xY(e, Toe), r = _oe(i);
    return i.forEach((n) => {
      var {
        element: a,
        options: {
          name: o
        }
      } = n;
      a === r[o] ? E(a).addClass(Ioe).detach() : E(a).remove();
    }), Object.keys(r).map((n) => ({
      name: n,
      template: this._createTemplate(r[n])
    }));
  }
  _extractAnonymousTemplate(e) {
    var i = e.contents().detach(), r = i.filter((n, a) => {
      var o = a.nodeType === boe, u = E(a).text().trim().length < 1;
      return !(o && u);
    });
    return r.length > 0 ? {
      template: this._createTemplate(i),
      name: this._anonymousTemplateName
    } : {};
  }
  _createTemplateIfNeeded(e) {
    var i = this._tempTemplates.filter((n) => n.source === G$(e))[0];
    if (i)
      return i.template;
    var r = this._createTemplate(e);
    return this._tempTemplates.push({
      template: r,
      source: G$(e)
    }), r;
  }
  _createTemplate(e) {
    return this._createElement(xoe(e));
  }
  getTemplate(e, i, r, n) {
    var {
      isAsyncTemplate: a,
      skipTemplates: o
    } = r;
    return Le(e) ? new Lm((u) => {
      var c = e.apply(n, yoe(u));
      if (!R(c))
        return new yp();
      var p = !1, v = K$(c, (y) => y.nodeType || hs(y) && !E(y).is("script") ? new Lm(() => y) : (p = !0, this._createTemplate(y)), i, a, o, this._defaultTemplates), _ = v.render(u);
      return p && v.dispose && v.dispose(), _;
    }) : K$(e, this._createTemplateIfNeeded, i, a, o, this._defaultTemplates);
  }
};
function Qr(t, e) {
  return e ? ve(t, e) : t;
}
function Mk(t, e) {
  return typeof t == "function" ? t(e) : t.execute(e);
}
var Y$ = {
  on: (t, e, i, r) => {
    var {
      selector: n,
      showTimeout: a,
      hideTimeout: o,
      namespace: u
    } = r;
    k.on(t, Qr("dxactive", u), n, {
      timeout: a
    }, (c) => Mk(e, {
      event: c,
      element: c.currentTarget
    })), k.on(t, Qr("dxinactive", u), n, {
      timeout: o
    }, (c) => Mk(i, {
      event: c,
      element: c.currentTarget
    }));
  },
  off: (t, e) => {
    var {
      namespace: i,
      selector: r
    } = e;
    k.off(t, Qr("dxactive", i), r), k.off(t, Qr("dxinactive", i), r);
  }
}, _T = {
  on: function(t, e) {
    var {
      namespace: i
    } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    k.on(t, Qr("dxresize", i), e);
  },
  off: function(t) {
    var {
      namespace: e
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    k.off(t, Qr("dxresize", e));
  }
}, q$ = {
  on: (t, e, i, r) => {
    var {
      selector: n,
      namespace: a
    } = r;
    k.on(t, Qr("dxhoverend", a), n, (o) => i(o)), k.on(t, Qr("dxhoverstart", a), n, (o) => Mk(e, {
      element: o.target,
      event: o
    }));
  },
  off: (t, e) => {
    var {
      selector: i,
      namespace: r
    } = e;
    k.off(t, Qr("dxhoverstart", r), i), k.off(t, Qr("dxhoverend", r), i);
  }
}, CT = {
  on: (t, e, i, r) => {
    var {
      namespace: n
    } = r;
    k.on(t, Qr("dxhiding", n), i), k.on(t, Qr("dxshown", n), e);
  },
  off: (t, e) => {
    var {
      namespace: i
    } = e;
    k.off(t, Qr("dxhiding", i)), k.off(t, Qr("dxshown", i));
  }
}, zw = {
  on: (t, e, i, r) => {
    var {
      namespace: n
    } = r;
    k.on(t, Qr("focusin", n), e), k.on(t, Qr("focusout", n), i);
  },
  off: (t, e) => {
    var {
      namespace: i
    } = e;
    k.off(t, Qr("focusin", i)), k.off(t, Qr("focusout", i));
  },
  trigger: (t) => k.trigger(t, "focus")
}, X$ = {
  on: function(t, e) {
    var {
      namespace: i
    } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    k.on(t, Qr("dxclick", i), e);
  },
  off: function(t) {
    var {
      namespace: e
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    k.off(t, Qr("dxclick", e));
  }
}, Q$ = {
  on: function(t, e) {
    var {
      namespace: i
    } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    k.on(t, Qr("click", i), e);
  },
  off: function(t) {
    var {
      namespace: e
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    k.off(t, Qr("click", e));
  }
}, Aoe = 0, vy = {}, Ooe = () => "keyboardProcessorId".concat(Aoe++), bh = {
  on: (t, e, i) => {
    var r = Ooe();
    return vy[r] = new DF({
      element: t,
      focusTarget: e,
      handler: i
    }), r;
  },
  off: (t) => {
    t && vy[t] && (vy[t].dispose(), delete vy[t]);
  },
  _getProcessor: (t) => vy[t]
};
function Roe(t) {
  return new Uint8Array(atob(t).split("").map((e) => e.charCodeAt(0)));
}
function Loe(t) {
  var e, i;
  return new Uint8Array((i = (e = t.match(/.{1,2}/g)) === null || e === void 0 ? void 0 : e.map((r) => parseInt(r, 16))) !== null && i !== void 0 ? i : []);
}
function Moe(t) {
  for (var e = new Uint8Array(t.length), i = 0; i < t.length; i += 1)
    e[i] = 255 & t.charCodeAt(i);
  return e;
}
function koe(t) {
  for (var e = new Uint8Array(4 * t.length), i = 0; i < e.length; i += 1)
    e[i] = t[i >> 2] >>> 8 * (3 - i % 4);
  return e;
}
function Poe(t) {
  for (var e = new Uint32Array(1 + (t.length - 1 >> 2)), i = 0; i < t.length; i += 1)
    e[i >> 2] |= t[i] << 8 * (3 - i % 4);
  return e;
}
function Z$(t, e) {
  return (t << e | t >>> 32 - e) >>> 0;
}
function J$(t, e) {
  var i = new Uint8Array(t.length + e.length);
  return i.set(t, 0), i.set(e, t.length), i;
}
var EY = {
  e: 65537,
  n: new Uint8Array([200, 219, 153, 203, 140, 7, 228, 253, 193, 243, 62, 137, 139, 60, 68, 242, 48, 142, 113, 88, 185, 235, 253, 105, 80, 74, 32, 170, 96, 74, 111, 250, 7, 205, 154, 3, 146, 115, 153, 53, 45, 132, 123, 56, 61, 208, 184, 201, 63, 24, 109, 223, 0, 179, 169, 102, 139, 224, 73, 233, 45, 173, 138, 66, 98, 88, 69, 76, 177, 111, 113, 218, 192, 33, 101, 152, 25, 134, 34, 173, 32, 82, 230, 44, 247, 200, 253, 170, 192, 246, 30, 12, 96, 205, 100, 249, 181, 93, 0, 231])
}, Foe = "5rAVv9FUI0-DvPTlA2YOQA", Boe = "3021300906052b0e03021a05000414";
function Voe(t) {
  var e = (8 * EY.n.length + 6) / 8, i = J$(Loe(Boe), t);
  if (i.length + 10 > e)
    throw Error("Key is too short for SHA1 signing algorithm");
  var r = new Uint8Array(e - i.length);
  return r.fill(255, 0, r.length - 1), r[0] = 0, r[1] = 1, r[r.length - 1] = 0, J$(r, i);
}
function Noe(t) {
  try {
    var e = BigInt(0), i = BigInt(1), r = BigInt(8), n = (v) => v.reduce((_, y) => (_ << r) + BigInt(y), e), a = n(t.actual), o = n(t.signature), u = BigInt(t.key.e), c = n(t.key.n), p = ((v, _, y) => {
      for (var b = i, I = v, A = _; A; )
        A & i && (b = b * I % y), I = I * I % y, A >>= i;
      return b;
    })(o, u, c);
    return p === a;
  } catch {
    return !0;
  }
}
function Hoe(t) {
  var e = new Uint8Array(t.length + 1);
  e.set(Moe(t)), e[e.length - 1] = 128;
  var i = Poe(new Uint8Array(e)), r = new Uint32Array(16 * Math.ceil((i.length + 2) / 16));
  return r.set(i, 0), r[r.length - 1] = 8 * (e.length - 1), r;
}
function $oe(t) {
  for (var e = Hoe(t), i = new Uint32Array([1732584193, 4023233417, 2562383102, 271733878, 3285377520]), r = 0; r < e.length; r += 16) {
    for (var n = new Uint32Array(80), a = 0; a < 16; a += 1)
      n[a] = e[r + a];
    for (var o = 16; o < 80; o += 1) {
      var u = n[o - 3] ^ n[o - 8] ^ n[o - 14] ^ n[o - 16];
      n[o] = u << 1 | u >>> 31;
    }
    for (var c = i[0], p = i[1], v = i[2], _ = i[3], y = i[4], b = 0; b < 80; b += 1) {
      var [I, A] = b < 20 ? [p & v | ~p & _, 1518500249] : b < 40 ? [p ^ v ^ _, 1859775393] : b < 60 ? [p & v | p & _ | v & _, 2400959708] : [p ^ v ^ _, 3395469782], L = Z$(c, 5) + I + y + A + n[b];
      y = _, _ = v, v = Z$(p, 30), p = c, c = L;
    }
    i[0] += c, i[1] += p, i[2] += v, i[3] += _, i[4] += y;
  }
  return koe(i);
}
var Gs;
(function(t) {
  t.corrupted = "corrupted", t.verified = "verified", t.internal = "internal";
})(Gs || (Gs = {}));
var zoe = function(t, e) {
  var i = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (i[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") {
    var n = 0;
    for (r = Object.getOwnPropertySymbols(t); n < r.length; n++)
      e.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[n]) && (i[r[n]] = t[r[n]]);
  }
  return i;
}, Woe = ".", Uoe = 1, Goe = 3, ez = {
  kind: Gs.corrupted,
  error: "general"
}, Koe = {
  kind: Gs.corrupted,
  error: "verification"
}, joe = {
  kind: Gs.corrupted,
  error: "decoding"
}, Yoe = {
  kind: Gs.corrupted,
  error: "deserialization"
}, qoe = {
  kind: Gs.corrupted,
  error: "payload"
}, Xoe = {
  kind: Gs.corrupted,
  error: "version"
}, kk = !1;
function Qoe(t) {
  var {
    text: e,
    signature: i
  } = t;
  return Noe({
    key: EY,
    signature: Roe(i),
    actual: Voe($oe(e))
  });
}
function Zoe(t) {
  if (t === void 0)
    return ez;
  var e = t.split(Woe);
  if (e.length !== 2 || e[0].length === 0 || e[1].length === 0)
    return ez;
  if (!Qoe({
    text: e[0],
    signature: e[1]
  }))
    return Koe;
  var i = "";
  try {
    i = atob(e[0]);
  } catch {
    return joe;
  }
  var r = {};
  try {
    r = JSON.parse(i);
  } catch {
    return Yoe;
  }
  var {
    customerId: n,
    maxVersionAllowed: a,
    format: o,
    internalUsageId: u
  } = r, c = zoe(r, ["customerId", "maxVersionAllowed", "format", "internalUsageId"]);
  return u !== void 0 ? {
    kind: Gs.internal,
    internalUsageId: u
  } : n === void 0 || a === void 0 || o === void 0 ? qoe : o !== Uoe ? Xoe : {
    kind: Gs.verified,
    payload: ae({
      customerId: n,
      maxVersionAllowed: a
    }, c)
  };
}
function Joe(t) {
  var {
    licenseKey: e,
    version: i
  } = t, r = !1;
  try {
    var [n, a, o] = i.split(".").map(Number);
    if (r = isNaN(o) || o < Goe, !e)
      return {
        preview: r,
        error: "W0019"
      };
    var u = Zoe(e);
    return u.kind === Gs.corrupted ? {
      preview: r,
      error: "W0021"
    } : u.kind === Gs.internal ? {
      preview: r,
      internal: !0,
      error: u.internalUsageId === Foe ? void 0 : "W0020"
    } : n && a ? 10 * n + a > u.payload.maxVersionAllowed ? {
      preview: r,
      error: "W0020"
    } : {
      preview: r,
      error: void 0
    } : {
      preview: r,
      error: "W0021"
    };
  } catch {
    return {
      preview: r,
      error: "W0021"
    };
  }
}
function ese(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : j3;
  if (!kk) {
    kk = !0;
    var {
      preview: i,
      internal: r,
      error: n
    } = Joe({
      licenseKey: t,
      version: e
    });
    if (n) {
      bi.log(i ? "W0022" : n);
      return;
    }
    i && !r && bi.log("W0022");
  }
}
function tz() {
  return kk;
}
const tse = {
  validateLicense: ese
};
var {
  abstract: Pb
} = CY, Nu = CY.inherit({
  _getDefaultOptions() {
    return P(this.callBase(), {
      width: void 0,
      height: void 0,
      rtlEnabled: Oi().rtlEnabled,
      elementAttr: {},
      disabled: !1,
      integrationOptions: {}
    }, this._useTemplates() ? j$.createDefaultOptions() : {});
  },
  ctor(t, e) {
    this._customClass = null, this._createElement(t), Ej(this._$element, this, this._dispose), this.callBase(e);
    var i = tz();
    tse.validateLicense(Oi().licenseKey), !i && tz() && Oi({
      licenseKey: ""
    });
  },
  _createElement(t) {
    this._$element = E(t);
  },
  _getSynchronizableOptionsForCreateComponent: () => ["rtlEnabled", "disabled", "templatesRenderAsynchronously"],
  _checkFunctionValueDeprecation: function(t) {
    this.option("_ignoreFunctionValueDeprecation") || t.forEach((e) => {
      Le(this.option(e)) && bi.log("W0017", e);
    });
  },
  _visibilityChanged: Pb,
  _dimensionChanged: Pb,
  _init() {
    this.callBase(), this._checkFunctionValueDeprecation(["width", "height", "maxHeight", "maxWidth", "minHeight", "minWidth", "popupHeight", "popupWidth"]), this._attachWindowResizeCallback(), this._initTemplateManager();
  },
  _setOptionsByDevice(t) {
    this.callBase([].concat(this.constructor._classCustomRules || [], t || []));
  },
  _isInitialOptionValue(t) {
    var e = this.constructor._classCustomRules && Object.prototype.hasOwnProperty.call(this._convertRulesToOptions(this.constructor._classCustomRules), t);
    return !e && this.callBase(t);
  },
  _attachWindowResizeCallback() {
    if (this._isDimensionChangeSupported()) {
      var t = this._windowResizeCallBack = this._dimensionChanged.bind(this);
      Tp.add(t);
    }
  },
  _isDimensionChangeSupported() {
    return this._dimensionChanged !== Pb;
  },
  _renderComponent() {
    this._initMarkup(), wt() && this._render();
  },
  _initMarkup() {
    var {
      rtlEnabled: t
    } = this.option() || {};
    this._renderElementAttributes(), this._toggleRTLDirection(t), this._renderVisibilityChange(), this._renderDimensions();
  },
  _render() {
    this._attachVisibilityChangeHandlers(), bie(this.$element());
  },
  _renderElementAttributes() {
    var {
      elementAttr: t
    } = this.option() || {}, e = P({}, t), i = e.class;
    delete e.class, this.$element().attr(e).removeClass(this._customClass).addClass(i), this._customClass = i;
  },
  _renderVisibilityChange() {
    if (this._isDimensionChangeSupported() && this._attachDimensionChangeHandlers(), this._isVisibilityChangeSupported()) {
      var t = this.$element();
      t.addClass("dx-visibility-change-handler");
    }
  },
  _renderDimensions() {
    var t = this.$element(), e = t.get(0), i = this._getOptionValue("width", e), r = this._getOptionValue("height", e);
    this._isCssUpdateRequired(e, r, i) && t.css({
      width: i === null ? "" : i,
      height: r === null ? "" : r
    });
  },
  _isCssUpdateRequired: (t, e, i) => !!(R(i) || R(e) || t.style.width || t.style.height),
  _attachDimensionChangeHandlers() {
    var t = this.$element(), e = "".concat(this.NAME, "VisibilityChange");
    _T.off(t, {
      namespace: e
    }), _T.on(t, () => this._dimensionChanged(), {
      namespace: e
    });
  },
  _attachVisibilityChangeHandlers() {
    if (this._isVisibilityChangeSupported()) {
      var t = this.$element(), e = "".concat(this.NAME, "VisibilityChange");
      this._isHidden = !this._isVisible(), CT.off(t, {
        namespace: e
      }), CT.on(t, () => this._checkVisibilityChanged("shown"), () => this._checkVisibilityChanged("hiding"), {
        namespace: e
      });
    }
  },
  _isVisible() {
    var t = this.$element();
    return t.is(":visible");
  },
  _checkVisibilityChanged(t) {
    var e = this._isVisible();
    e && (t === "hiding" && !this._isHidden ? (this._visibilityChanged(!1), this._isHidden = !0) : t === "shown" && this._isHidden && (this._isHidden = !1, this._visibilityChanged(!0)));
  },
  _isVisibilityChangeSupported() {
    return this._visibilityChanged !== Pb && wt();
  },
  _clean: ee,
  _modelByElement() {
    var {
      modelByElement: t
    } = this.option(), e = this.$element();
    return t ? t(e) : void 0;
  },
  _invalidate() {
    if (this._isUpdateAllowed())
      throw bi.Error("E0007");
    this._requireRefresh = !0;
  },
  _refresh() {
    this._clean(), this._renderComponent();
  },
  _dispose() {
    this._templateManager && this._templateManager.dispose(), this.callBase(), this._clean(), this._detachWindowResizeCallback();
  },
  _detachWindowResizeCallback() {
    this._isDimensionChangeSupported() && Tp.remove(this._windowResizeCallBack);
  },
  _toggleRTLDirection(t) {
    var e = this.$element();
    e.toggleClass("dx-rtl", t);
  },
  _createComponent(t, e) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = so(this._getSynchronizableOptionsForCreateComponent(), (v) => !(v in i)), {
      integrationOptions: n
    } = this.option(), {
      nestedComponentOptions: a
    } = this.option();
    a = a || ee;
    var o = P({
      integrationOptions: n
    }, a(this));
    r.forEach((v) => o[v] = this.option(v)), this._extendConfig(i, o);
    var u = void 0;
    if (ht(e)) {
      var c = E(t)[e](i);
      u = c[e]("instance");
    } else
      t && (u = e.getInstance(t), u ? u.option(i) : u = new e(t, i));
    if (u) {
      var p = (v) => {
        var {
          name: _,
          value: y
        } = v;
        r.includes(_) && u.option(_, y);
      };
      this.on("optionChanged", p), u.on("disposing", () => this.off("optionChanged", p));
    }
    return u;
  },
  _extendConfig(t, e) {
    N(e, (i, r) => {
      !Object.prototype.hasOwnProperty.call(t, i) && (t[i] = r);
    });
  },
  _defaultActionConfig() {
    var t = this.$element(), e = this._modelByElement(t);
    return P(this.callBase(), {
      context: e
    });
  },
  _defaultActionArgs() {
    var t = this.$element(), e = this._modelByElement(t), i = this.element();
    return P(this.callBase(), {
      element: i,
      model: e
    });
  },
  _optionChanged(t) {
    switch (t.name) {
      case "width":
      case "height":
        this._renderDimensions();
        break;
      case "rtlEnabled":
        this._invalidate();
        break;
      case "elementAttr":
        this._renderElementAttributes();
        break;
      case "disabled":
      case "integrationOptions":
        break;
      default:
        this.callBase(t);
    }
  },
  _removeAttributes(t) {
    for (var e = t.attributes, i = e.length - 1; i >= 0; i--) {
      var r = e[i];
      if (r) {
        var {
          name: n
        } = r;
        (!n.indexOf("aria-") || n.indexOf("dx-") !== -1 || n === "role" || n === "style" || n === "tabindex") && t.removeAttribute(n);
      }
    }
  },
  _removeClasses(t) {
    t.className = t.className.split(" ").filter((e) => e.lastIndexOf("dx-", 0) !== 0).join(" ");
  },
  _updateDOMComponent(t) {
    t ? this._renderComponent() : this._requireRefresh && (this._requireRefresh = !1, this._refresh());
  },
  endUpdate() {
    var t = this._isInitializingRequired();
    this.callBase(), this._isUpdateAllowed() && this._updateDOMComponent(t);
  },
  $element() {
    return this._$element;
  },
  element() {
    var t = this.$element();
    return ot(t);
  },
  dispose() {
    var t = this.$element().get(0);
    qx(t, !0), t.textContent = "", this._removeAttributes(t), this._removeClasses(t);
  },
  resetOption(t) {
    if (this.callBase(t), t === "width" || t === "height") {
      var e = this.initialOption(t);
      !R(e) && this.$element().css(t, "");
    }
  },
  _getAnonymousTemplateName() {
  },
  _initTemplateManager() {
    if (!(this._templateManager || !this._useTemplates())) {
      var {
        integrationOptions: t = {}
      } = this.option(), {
        createTemplate: e
      } = t;
      this._templateManager = new j$(e, this._getAnonymousTemplateName()), this._initTemplates();
    }
  },
  _initTemplates() {
    var {
      templates: t,
      anonymousTemplateMeta: e
    } = this._templateManager.extractTemplates(this.$element()), i = this.option("integrationOptions.templates.".concat(e.name));
    t.forEach((r) => {
      var {
        name: n,
        template: a
      } = r;
      this._options.silent("integrationOptions.templates.".concat(n), a);
    }), e.name && !i && (this._options.silent("integrationOptions.templates.".concat(e.name), e.template), this._options.silent("_hasAnonymousTemplateContent", !0));
  },
  _getTemplateByOption(t) {
    return this._getTemplate(this.option(t));
  },
  _getTemplate(t) {
    var e = this.option("integrationOptions.templates"), i = this.option("templatesRenderAsynchronously"), r = this.option("integrationOptions.skipTemplates");
    return this._templateManager.getTemplate(t, e, {
      isAsyncTemplate: i,
      skipTemplates: r
    }, this);
  },
  _saveTemplate(t, e) {
    this._setOptionWithoutOptionChange("integrationOptions.templates." + t, this._templateManager._createTemplate(e));
  },
  _useTemplates: () => !0
});
Nu.getInstance = function(t) {
  return bj(E(t), this);
};
Nu.defaultOptions = function(t) {
  this._classCustomRules = this._classCustomRules || [], this._classCustomRules.push(t);
};
function sr(t, e) {
  if (t == null)
    return {};
  var i = {}, r = Object.keys(t), n, a;
  for (a = 0; a < r.length; a++)
    n = r[a], !(e.indexOf(n) >= 0) && (i[n] = t[n]);
  return i;
}
var ise = (t, e) => Object.keys(t).length !== Object.keys(e).length ? !1 : Object.keys(t).every((i) => t[i] === e[i]), rse = ["isEqual"];
function nse(t) {
  return !!t.toArray;
}
function ase(t, e) {
  var i, r = {
    template: e,
    model: ae({}, t)
  }, n = (i = t.data) !== null && i !== void 0 ? i : {}, {
    isEqual: a
  } = n, o = sr(n, rse);
  return a && (r.model.data = o, r.isEqual = a), r;
}
function ose(t, e) {
  var i, {
    data: r,
    index: n
  } = (i = t.model) !== null && i !== void 0 ? i : {
    data: {}
  };
  r && Object.keys(r).forEach((o) => {
    r[o] && de.isNode(r[o]) && (r[o] = ot(E(r[o])));
  });
  var a = t.template.render(ae({
    container: e,
    transclude: t.transclude
  }, {
    renovated: t.renovated
  }, t.transclude ? {} : {
    model: r
  }, !t.transclude && Number.isFinite(n) ? {
    index: n
  } : {}));
  return a === void 0 ? [] : nse(a) ? a.toArray() : [E(a).get(0)];
}
function sse(t, e) {
  e.forEach((i) => {
    var r = !!t.find((n) => i === n);
    !r && i.parentNode && E(i).remove();
  });
}
let iz = class extends Bu {
  constructor(e) {
    super(e), this.renderTemplate = this.renderTemplate.bind(this);
  }
  renderTemplate() {
    var e = Ws(this.$LI, !0);
    if (!(e != null && e.parentNode))
      return () => {
      };
    var i = e.parentNode, r = E(i), n = r.contents().toArray(), a = ose(this.props, ot(r));
    return soe(E(e), E(a)), () => {
      var o = E(i).contents().toArray();
      sse(n, o), i.appendChild(e);
    };
  }
  shouldComponentUpdate(e) {
    var {
      model: i,
      template: r
    } = this.props, {
      isEqual: n,
      model: a,
      template: o
    } = e, u = n ?? ise;
    if (r !== o)
      return !0;
    if (!R(i) || !R(a))
      return i !== a;
    var {
      data: c,
      index: p
    } = i, {
      data: v,
      index: _
    } = a;
    return p !== _ ? !0 : !u(c, v);
  }
  createEffects() {
    return [new ar(this.renderTemplate, [this.props.template, this.props.model])];
  }
  updateEffects() {
    this._effects[0].update([this.props.template, this.props.model]);
  }
  componentWillUnmount() {
  }
  render() {
    return null;
  }
};
function VR(t) {
  return Array.isArray(t) ? [...t] : ae({}, t);
}
function bY(t, e, i) {
  var r = i.length > 0 && e && t !== e ? VR(e) : VR(t), n = i[0];
  return i.length > 1 ? r[n] = bY(t[n], e == null ? void 0 : e[n], i.slice(1)) : n && ($t(t[n]) ? r[n] = VR(t[n]) : r[n] = t[n]), r;
}
function lse(t, e, i, r) {
  var n = e[i], a = t[i], o = t;
  $t(n) || i !== r && Array.isArray(n) ? o[i] = bY(n, a, Vp(r).slice(1)) : o[i] = n;
}
var Ns = wt() ? Ot() : {}, use = 1e3 / 60, wY = function(t) {
  return setTimeout(t, use);
}, TY = function(t) {
  clearTimeout(t);
}, IY = oc(function() {
  var t = Ns.requestAnimationFrame || Ns.webkitRequestAnimationFrame || Ns.mozRequestAnimationFrame || Ns.oRequestAnimationFrame || Ns.msRequestAnimationFrame, e = Ns.cancelAnimationFrame || Ns.webkitCancelAnimationFrame || Ns.mozCancelAnimationFrame || Ns.oCancelAnimationFrame || Ns.msCancelAnimationFrame;
  t && e && (wY = t, TY = e);
});
function Fx() {
  return IY(), wY.apply(Ns, arguments);
}
function Nd() {
  IY(), TY.apply(Ns, arguments);
}
function DY(t) {
  return t && [t.target, t.delegateTarget, t.relatedTarget, t.currentTarget].filter((e) => !!e);
}
var dse = (t, e) => {
  k.one(DY(t), fo, e);
}, cse = (t, e) => {
  k.off(DY(t), fo, e);
}, {
  maxTouchPoints: AY
} = Yx(), hse = {
  webkitTransition: "webkitTransitionEnd",
  MozTransition: "transitionend",
  OTransition: "oTransitionEnd",
  transition: "transitionend"
}, kF = function(t) {
  return !!Np(t);
}, fse = function() {
  var {
    platform: t,
    mac: e
  } = Ye.real(), i = t === "ios" || t === "android" || e;
  return i;
}, cI = function(t) {
  if (t === "text")
    return !0;
  var e = de.createElement("input");
  try {
    return e.setAttribute("type", t), e.value = "wrongValue", !e.value;
  } catch {
    return !1;
  }
}, pse = function(t, e) {
  return (t("ontouchstart") || !!e) && !t("callPhantom");
}, vse = function(t) {
  return t("PointerEvent");
}, OY = pse(ij, AY), RY = vse(ij), gse = !!AY, Ip = OY || RY && gse, Pk = oc(function() {
  return kF("transition");
}), LY = oc(function() {
  return hse[Np("transition")];
}), Fk = oc(function() {
  return kF("animation");
}), Dp = fse();
const mse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  animation: Fk,
  inputType: cI,
  nativeScrolling: Dp,
  pointerEvents: RY,
  styleProp: Np,
  stylePropPrefix: Fw,
  supportProp: kF,
  touch: Ip,
  touchEvents: OY,
  transition: Pk,
  transitionEndEventName: LY
}, Symbol.toStringTag, { value: "Module" }));
var _se = Yx(), Cse = /(webkit)[ /]([\w.]+)/, yse = /(mozilla)(?:.*? rv:([\w.]+))/, rz = (t) => {
  t = t.toLowerCase();
  var e = {}, i = Cse.exec(t) || t.indexOf("compatible") < 0 && yse.exec(t) || [], r = i[1], n = i[2];
  return r === "webkit" && (e.webkit = !0, t.indexOf("chrome") >= 0 || t.indexOf("crios") >= 0 ? (r = "chrome", n = /(?:chrome|crios)\/(\d+\.\d+)/.exec(t), n = n && n[1]) : t.indexOf("fxios") >= 0 ? (r = "mozilla", n = /fxios\/(\d+\.\d+)/.exec(t), n = n && n[1]) : t.indexOf("safari") >= 0 && /version|phantomjs/.test(t) ? (r = "safari", n = /(?:version|phantomjs)\/([0-9.]+)/.exec(t), n = n && n[1]) : (r = "unknown", n = /applewebkit\/([0-9.]+)/.exec(t), n = n && n[1])), r && (e[r] = !0, e.version = n), e;
};
const $i = P({
  _fromUA: rz
}, rz(_se.userAgent));
var nz = "dxPointerEvents", PF = wi.inherit({
  ctor: function(t, e) {
    this._eventName = t, this._originalEvents = ve(e, nz), this._handlerCount = 0, this.noBubble = this._isNoBubble();
  },
  _isNoBubble: function() {
    var t = this._eventName;
    return t === "dxpointerenter" || t === "dxpointerleave";
  },
  _handler: function(t) {
    var e, i = this._getDelegateTarget(t), r = {
      type: this._eventName,
      pointerType: t.pointerType || rS(t),
      originalEvent: t,
      delegateTarget: i,
      timeStamp: $i.mozilla ? (/* @__PURE__ */ new Date()).getTime() : t.timeStamp
    }, n = t.originalEvent;
    if (n != null && (e = n.target) !== null && e !== void 0 && e.shadowRoot) {
      var a, o, u = (a = n.path) !== null && a !== void 0 ? a : (o = n.composedPath) === null || o === void 0 ? void 0 : o.call(n);
      r.target = u[0];
    }
    return this._fireEvent(r);
  },
  _getDelegateTarget: function(t) {
    var e;
    return this.noBubble && (e = t.delegateTarget), e;
  },
  _fireEvent: function(t) {
    return Bh(t);
  },
  _setSelector: function(t) {
    this._selector = this.noBubble && t ? t.selector : null;
  },
  _getSelector: function() {
    return this._selector;
  },
  setup: function() {
    return !0;
  },
  add: function(t, e) {
    if (this._handlerCount <= 0 || this.noBubble) {
      t = this.noBubble ? t : de.getDocument(), this._setSelector(e);
      var i = this;
      k.on(t, this._originalEvents, this._getSelector(), function(r) {
        i._handler(r);
      });
    }
    this.noBubble || this._handlerCount++;
  },
  remove: function(t) {
    this._setSelector(t), this.noBubble || this._handlerCount--;
  },
  teardown: function(t) {
    this._handlerCount && !this.noBubble || (t = this.noBubble ? t : de.getDocument(), this._originalEvents !== "." + nz && k.off(t, this._originalEvents, this._getSelector()));
  },
  dispose: function(t) {
    t = this.noBubble ? t : de.getDocument(), k.off(t, this._originalEvents);
  }
}), xse = {
  dxpointerdown: "touchstart",
  dxpointermove: "touchmove",
  dxpointerup: "touchend",
  dxpointercancel: "touchcancel",
  dxpointerover: "",
  dxpointerout: "",
  dxpointerenter: "",
  dxpointerleave: ""
}, MY = function(t) {
  var e = [];
  return N(t.touches, function(i, r) {
    e.push(P({
      pointerId: r.identifier
    }, r));
  }), {
    pointers: e,
    pointerId: t.changedTouches[0].identifier
  };
}, Sse = function(t) {
  return Ye.real().platform === "ios" && (t === "dxpointerdown" || t === "dxpointerup");
}, sS = PF.inherit({
  ctor: function() {
    this.callBase.apply(this, arguments), this._pointerId = 0;
  },
  _handler: function(t) {
    if (Sse(this._eventName)) {
      var e = t.changedTouches[0];
      if (this._pointerId === e.identifier && this._pointerId !== 0)
        return;
      this._pointerId = e.identifier;
    }
    return this.callBase.apply(this, arguments);
  },
  _fireEvent: function(t) {
    return this.callBase(P(MY(t.originalEvent), t));
  }
});
sS.map = xse;
sS.normalize = MY;
var Fb = function(t, e) {
  Vu.add(function() {
    t.split(" ").forEach(function(i) {
      de.listen(de.getDocument(), i, e, !0);
    });
  });
}, Ese = function(t, e, i) {
  i = i || function() {
  };
  var r = [], n = function(o) {
    var u = -1;
    return N(r, function(c, p) {
      return e(o, p) ? (u = c, !1) : !0;
    }), u;
  }, a = function(o) {
    var u = n(o);
    u > -1 && r.splice(u, 1);
  };
  Fb(t.dxpointerdown, function(o) {
    n(o) === -1 && (i(o), r.push(o));
  }), Fb(t.dxpointermove, function(o) {
    r[n(o)] = o;
  }), Fb(t.dxpointerup, a), Fb(t.dxpointercancel, a), this.pointers = function() {
    return r;
  }, this.reset = function() {
    r = [];
  };
}, kY = {
  dxpointerdown: "mousedown",
  dxpointermove: "mousemove",
  dxpointerup: "mouseup",
  dxpointercancel: "",
  dxpointerover: "mouseover",
  dxpointerout: "mouseout",
  dxpointerenter: "mouseenter",
  dxpointerleave: "mouseleave"
}, PY = function(t) {
  return t.pointerId = 1, {
    pointers: FF.pointers(),
    pointerId: 1
  };
}, FF, az = !1, FY = function() {
  az || (FF = new Ese(kY, function() {
    return !0;
  }), az = !0);
}, lc = PF.inherit({
  ctor: function() {
    this.callBase.apply(this, arguments), FY();
  },
  _fireEvent: function(t) {
    return this.callBase(P(PY(t.originalEvent), t));
  }
});
lc.map = kY;
lc.normalize = PY;
lc.activate = FY;
lc.resetObserver = function() {
  FF.reset();
};
var bse = {
  dxpointerdown: "touchstart mousedown",
  dxpointermove: "touchmove mousemove",
  dxpointerup: "touchend mouseup",
  dxpointercancel: "touchcancel",
  dxpointerover: "mouseover",
  dxpointerout: "mouseout",
  dxpointerenter: "mouseenter",
  dxpointerleave: "mouseleave"
}, oz = !1, wse = function() {
  oz || (lc.activate(), oz = !0);
}, hI = PF.inherit({
  EVENT_LOCK_TIMEOUT: 100,
  ctor: function() {
    this.callBase.apply(this, arguments), wse();
  },
  _handler: function(t) {
    var e = wp(t);
    if (e || (this._skipNextEvents = !0), !(e && this._mouseLocked)) {
      if (e && this._skipNextEvents) {
        this._skipNextEvents = !1, this._mouseLocked = !0, clearTimeout(this._unlockMouseTimer);
        var i = this;
        this._unlockMouseTimer = setTimeout(function() {
          i._mouseLocked = !1;
        }, this.EVENT_LOCK_TIMEOUT);
        return;
      }
      return this.callBase(t);
    }
  },
  _fireEvent: function(t) {
    var e = wp(t.originalEvent) ? lc.normalize : sS.normalize;
    return this.callBase(P(e(t.originalEvent), t));
  },
  dispose: function() {
    this.callBase(), this._skipNextEvents = !1, this._mouseLocked = !1, clearTimeout(this._unlockMouseTimer);
  }
});
hI.map = bse;
hI.resetObserver = lc.resetObserver;
var Tse = (t, e) => {
  var {
    tablet: i,
    phone: r
  } = e, n = Ise();
  return n || (t.touch && !(i || r) ? hI : t.touch ? sS : lc);
}, sz = Tse(mse, Ye.real());
N(sz.map, (t, e) => {
  Ys(t, new sz(t, e));
});
var Xt = {
  down: "dxpointerdown",
  up: "dxpointerup",
  move: "dxpointermove",
  cancel: "dxpointercancel",
  enter: "dxpointerenter",
  leave: "dxpointerleave",
  over: "dxpointerover",
  out: "dxpointerout"
};
function Ise() {
  var t = Oi().pointerEventStrategy;
  return {
    "mouse-and-touch": hI,
    touch: sS,
    mouse: lc
  }[t];
}
var fI = wi.inherit({
  ctor: function(t) {
    this._$element = E(t), this._cancelCallback = ui(), this._acceptCallback = ui();
  },
  getElement: function() {
    return this._$element;
  },
  validate: function(t) {
    return !oo(t);
  },
  validatePointers: function(t) {
    return pae(t) === 1;
  },
  allowInterruptionByMouseWheel: function() {
    return !0;
  },
  configure: function(t) {
    P(this, t);
  },
  addCancelCallback: function(t) {
    this._cancelCallback.add(t);
  },
  removeCancelCallback: function() {
    this._cancelCallback.empty();
  },
  _cancel: function(t) {
    this._cancelCallback.fire(this, t);
  },
  addAcceptCallback: function(t) {
    this._acceptCallback.add(t);
  },
  removeAcceptCallback: function() {
    this._acceptCallback.empty();
  },
  _accept: function(t) {
    this._acceptCallback.fire(this, t);
  },
  _requestAccept: function(t) {
    this._acceptRequestEvent = t;
  },
  _forgetAccept: function() {
    this._accept(this._acceptRequestEvent), this._acceptRequestEvent = null;
  },
  start: ee,
  move: ee,
  end: ee,
  cancel: ee,
  reset: function() {
    this._acceptRequestEvent && this._accept(this._acceptRequestEvent);
  },
  _fireEvent: function(t, e, i) {
    var r = P({
      type: t,
      originalEvent: e,
      target: this._getEmitterTarget(e),
      delegateTarget: this.getElement().get(0)
    }, i);
    return e = Bh(r), e.cancel && this._cancel(e), e;
  },
  _getEmitterTarget: function(t) {
    return (this.delegateSelector ? E(t.target).closest(this.delegateSelector) : this.getElement()).get(0);
  },
  dispose: ee
}), lS = "dxmousewheel", lz = "dxWheel", Dse = "wheel", uz = 0, Ase = 30, Bk = {
  setup: function(t) {
    var e = E(t);
    k.on(e, ve(Dse, lz), Bk._wheelHandler.bind(Bk));
  },
  teardown: function(t) {
    k.off(t, ".".concat(lz));
  },
  _wheelHandler: function(t) {
    var {
      deltaMode: e,
      deltaY: i,
      deltaX: r,
      deltaZ: n
    } = t.originalEvent;
    Bh({
      type: lS,
      originalEvent: t,
      delta: this._normalizeDelta(i, e),
      deltaX: r,
      deltaY: i,
      deltaZ: n,
      deltaMode: e,
      pointerType: "mouse"
    }), t.stopPropagation();
  },
  _normalizeDelta(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : uz;
    return e === uz ? -t : -Ase * t;
  }
};
Ys(lS, Bk);
var Bb = "dxEventManager", Qy = "dxEmitter", Ose = wi.inherit({
  ctor: function() {
    this._attachHandlers(), this.reset(), this._proxiedCancelHandler = this._cancelHandler.bind(this), this._proxiedAcceptHandler = this._acceptHandler.bind(this);
  },
  _attachHandlers: function() {
    Vu.add((function() {
      var t = de.getDocument();
      k.subscribeGlobal(t, ve(Xt.down, Bb), this._pointerDownHandler.bind(this)), k.subscribeGlobal(t, ve(Xt.move, Bb), this._pointerMoveHandler.bind(this)), k.subscribeGlobal(t, ve([Xt.up, Xt.cancel].join(" "), Bb), this._pointerUpHandler.bind(this)), k.subscribeGlobal(t, ve(lS, Bb), this._mouseWheelHandler.bind(this));
    }).bind(this));
  },
  _eachEmitter: function(t) {
    for (var e = this._activeEmitters || [], i = 0; e.length > i; ) {
      var r = e[i];
      if (t(r) === !1)
        break;
      e[i] === r && i++;
    }
  },
  _applyToEmitters: function(t, e) {
    this._eachEmitter(function(i) {
      i[t].call(i, e);
    });
  },
  reset: function() {
    this._eachEmitter(this._proxiedCancelHandler), this._activeEmitters = [];
  },
  resetEmitter: function(t) {
    this._proxiedCancelHandler(t);
  },
  _pointerDownHandler: function(t) {
    wp(t) && t.which > 1 || this._updateEmitters(t);
  },
  _updateEmitters: function(t) {
    this._isSetChanged(t) && (this._cleanEmitters(t), this._fetchEmitters(t));
  },
  _isSetChanged: function(t) {
    var e = this._closestEmitter(t), i = this._emittersSet || [], r = e.length !== i.length;
    return N(e, function(n, a) {
      return r = r || i[n] !== a, !r;
    }), this._emittersSet = e, r;
  },
  _closestEmitter: function(t) {
    var e = this, i = [], r = E(t.target);
    function n(o, u) {
      u && u.validatePointers(t) && u.validate(t) && (u.addCancelCallback(e._proxiedCancelHandler), u.addAcceptCallback(e._proxiedAcceptHandler), i.push(u));
    }
    for (; r.length; ) {
      var a = dr(r.get(0), Qy) || [];
      N(a, n), r = r.parent();
    }
    return i;
  },
  _acceptHandler: function(t, e) {
    var i = this;
    this._eachEmitter(function(r) {
      r !== t && i._cancelEmitter(r, e);
    });
  },
  _cancelHandler: function(t, e) {
    this._cancelEmitter(t, e);
  },
  _cancelEmitter: function(t, e) {
    var i = this._activeEmitters;
    e ? t.cancel(e) : t.reset(), t.removeCancelCallback(), t.removeAcceptCallback();
    var r = i.indexOf(t);
    r > -1 && i.splice(r, 1);
  },
  _cleanEmitters: function(t) {
    this._applyToEmitters("end", t), this.reset(t);
  },
  _fetchEmitters: function(t) {
    this._activeEmitters = this._emittersSet.slice(), this._applyToEmitters("start", t);
  },
  _pointerMoveHandler: function(t) {
    this._applyToEmitters("move", t);
  },
  _pointerUpHandler: function(t) {
    this._updateEmitters(t);
  },
  _mouseWheelHandler: function(t) {
    this._allowInterruptionByMouseWheel() && (t.pointers = [null], this._pointerDownHandler(t), this._adjustWheelEvent(t), this._pointerMoveHandler(t), t.pointers = [], this._pointerUpHandler(t));
  },
  _allowInterruptionByMouseWheel: function() {
    var t = !0;
    return this._eachEmitter(function(e) {
      return t = e.allowInterruptionByMouseWheel() && t, t;
    }), t;
  },
  _adjustWheelEvent: function(t) {
    var e = null;
    if (this._eachEmitter(function(a) {
      if (a.gesture) {
        var o = a.getDirection(t);
        if (o !== "horizontal" && !t.shiftKey || o !== "vertical" && t.shiftKey)
          return e = a, !1;
      }
    }), !!e) {
      var i = e.getDirection(t), r = i === "both" && !t.shiftKey || i === "vertical", n = r ? "pageY" : "pageX";
      t[n] += t.delta;
    }
  },
  isActive: function(t) {
    var e = !1;
    return this._eachEmitter(function(i) {
      e = e || i.getElement().is(t);
    }), e;
  }
}), dz = new Ose(), NR = "dxEmitterSubscription", zm = function(t) {
  var e = t.emitter, i = t.events[0], r = t.events;
  N(r, function(n, a) {
    Ys(a, {
      noBubble: !t.bubble,
      setup: function(o) {
        var u = dr(o, NR) || {}, c = dr(o, Qy) || {}, p = c[i] || new e(o);
        u[a] = !0, c[i] = p, dr(o, Qy, c), dr(o, NR, u);
      },
      add: function(o, u) {
        var c = dr(o, Qy), p = c[i];
        p.configure(P({
          delegateSelector: u.selector
        }, u.data), u.type);
      },
      teardown: function(o) {
        var u = dr(o, NR), c = dr(o, Qy), p = c[i];
        delete u[a];
        var v = !0;
        N(r, function(_, y) {
          return v = v && !u[y], v;
        }), v && (dz.isActive(o) && dz.resetEmitter(p), p && p.dispose(), delete c[i]);
      }
    });
  });
}, di = "dxclick";
var Vk = null, Zy = null, cz = () => {
  Zy = null;
}, hz = function(t) {
  var e = t.originalEvent, i = Zy === e || e && e.DXCLICK_FIRED, r = !t.which || t.which === 1;
  r && !Vk && !i && (e && (e.DXCLICK_FIRED = !0), cse(Zy, cz), Zy = e, dse(Zy, cz), Bh({
    type: di,
    originalEvent: t
  }));
}, Rse = fI.inherit({
  ctor: function(t) {
    this.callBase(t), k.on(this.getElement(), "click", hz);
  },
  start: function(t) {
    Vk = null;
  },
  cancel: function() {
    Vk = !0;
  },
  dispose: function() {
    k.off(this.getElement(), "click", hz);
  }
});
(function() {
  var t = Ye.real().generic;
  if (!t) {
    var e = null, i = !1, r = de.getDocument();
    k.subscribeGlobal(r, ve(Xt.down, "NATIVE_CLICK_FIXER"), function(n) {
      e = n.target, i = n.isDefaultPrevented();
    }), k.subscribeGlobal(r, ve("click", "NATIVE_CLICK_FIXER"), function(n) {
      var a = E(n.target);
      !i && e && !a.is(e) && !E(e).is("label") && (o = a, E(o).is("input, textarea, select, button ,:focus, :focus *")) && $m();
      var o;
      e = null, i = !1;
    });
  }
})();
zm({
  emitter: Rse,
  bubble: !0,
  events: [di]
});
var yT = "dxactive", Nk = "dxinactive", Lse = 30, Mse = 400, Vb = wi.inherit({
  ctor: function(t, e) {
    this._timeout = t, this._fire = e;
  },
  start: function() {
    var t = this;
    this._schedule(function() {
      t.force();
    });
  },
  _schedule: function(t) {
    this.stop(), this._timer = setTimeout(t, this._timeout);
  },
  stop: function() {
    clearTimeout(this._timer);
  },
  force: function() {
    this._fired || (this.stop(), this._fire(), this._fired = !0);
  },
  fired: function() {
    return this._fired;
  }
}), Ol, BF = fI.inherit({
  ctor: function() {
    this.callBase.apply(this, arguments), this._active = new Vb(0, ee), this._inactive = new Vb(0, ee);
  },
  configure: function(t, e) {
    switch (e) {
      case yT:
        t.activeTimeout = t.timeout;
        break;
      case Nk:
        t.inactiveTimeout = t.timeout;
    }
    this.callBase(t);
  },
  start: function(t) {
    if (Ol) {
      var e = Kd(this.getElement().get(0), Ol.getElement().get(0)), i = !Ol._active.fired();
      if (e && i) {
        this._cancel();
        return;
      }
      Ol._inactive.force();
    }
    Ol = this, this._initEvents(t), this._active.start();
  },
  _initEvents: function(t) {
    var e = this, i = this._getEmitterTarget(t), r = wp(t), n = Ye.isSimulator(), a = n || !r, o = cr(this.activeTimeout, Lse), u = cr(this.inactiveTimeout, Mse);
    this._active = new Vb(a ? o : 0, function() {
      e._fireEvent(yT, t, {
        target: i
      });
    }), this._inactive = new Vb(a ? u : 0, function() {
      e._fireEvent(Nk, t, {
        target: i
      }), Ol = null;
    });
  },
  cancel: function(t) {
    this.end(t);
  },
  end: function(t) {
    var e = t.type !== Xt.up;
    e ? this._active.stop() : this._active.force(), this._inactive.start(), e && this._inactive.force();
  },
  dispose: function() {
    this._active.stop(), this._inactive.stop(), Ol === this && (Ol = null), this.callBase();
  },
  lockInactive: function() {
    return this._active.force(), this._inactive.stop(), Ol = null, this._cancel(), this._inactive.force.bind(this._inactive);
  }
});
BF.lock = function(t) {
  var e = Ol ? Ol.lockInactive() : ee;
  t.done(e);
};
zm({
  emitter: BF,
  events: [yT, Nk]
});
var kse = BF.lock, BY = "dxHoverStart", uS = "dxhoverstart", Pse = ve(Xt.enter, BY), VY = "dxHoverEnd", dS = "dxhoverend", Fse = ve(Xt.leave, VY), NY = wi.inherit({
  noBubble: !0,
  ctor: function() {
    this._handlerArrayKeyPath = this._eventNamespace + "_HandlerStore";
  },
  setup: function(t) {
    dr(t, this._handlerArrayKeyPath, {});
  },
  add: function(t, e) {
    var i = this, r = function(n) {
      i._handler(n);
    };
    k.on(t, this._originalEventName, e.selector, r), dr(t, this._handlerArrayKeyPath)[e.guid] = r;
  },
  _handler: function(t) {
    nS(t) || Ye.isSimulator() || Bh({
      type: this._eventName,
      originalEvent: t,
      delegateTarget: t.delegateTarget
    });
  },
  remove: function(t, e) {
    var i = dr(t, this._handlerArrayKeyPath)[e.guid];
    k.off(t, this._originalEventName, e.selector, i);
  },
  teardown: function(t) {
    iI(t, this._handlerArrayKeyPath);
  }
}), Bse = NY.inherit({
  ctor: function() {
    this._eventNamespace = BY, this._eventName = uS, this._originalEventName = Pse, this.callBase();
  },
  _handler: function(t) {
    var e = t.pointers || [];
    e.length || this.callBase(t);
  }
}), Vse = NY.inherit({
  ctor: function() {
    this._eventNamespace = VY, this._eventName = dS, this._originalEventName = Fse, this.callBase();
  }
});
Ys(uS, new Bse());
Ys(dS, new Vse());
var HR = (t, e) => (i) => {
  Object.prototype.hasOwnProperty.call(t, i) && t[i] === void 0 && (t[i] = e(i));
};
class cS extends Nu {
  constructor(e, i) {
    super(e, i), this._shouldRaiseContentReady = !1, this.validateKeyDownHandler();
  }
  get _propsInfo() {
    return {
      allowNull: [],
      twoWay: [],
      elements: [],
      templates: [],
      props: []
    };
  }
  validateKeyDownHandler() {
    var e = this.getSupportedKeyNames(), i = e.length > 0, r = typeof this._viewComponent.prototype.keyDown == "function";
    if (i && !r)
      throw Error("Component's declaration must have 'keyDown' method.");
  }
  get viewRef() {
    var e;
    return (e = this._viewRef) === null || e === void 0 ? void 0 : e.current;
  }
  _checkContentReadyOption(e) {
    var i = this._getContentReadyOptions().reduce((r, n) => (r[n] = !0, r), {});
    return this._checkContentReadyOption = (r) => !!i[r], this._checkContentReadyOption(e);
  }
  _getContentReadyOptions() {
    return ["rtlEnabled"];
  }
  _fireContentReady() {
    this._actionsMap.onContentReady({});
  }
  _getDefaultOptions() {
    var e = this._getViewComponentDefaultProps();
    return P(!0, super._getDefaultOptions(), e, this._propsInfo.twoWay.reduce((i, r) => {
      var [n, a, o] = r;
      return ae({}, i, {
        [n]: e[a],
        [o]: (u) => this.option(n, u)
      });
    }, {}), this._propsInfo.templates.reduce((i, r) => ae({}, i, {
      [r]: null
    }), {}));
  }
  _getUnwrappedOption() {
    var e = {};
    return Object.keys(this.option()).forEach((i) => {
      e[i] = this.option(i);
    }), e;
  }
  _initializeComponent() {
    var e;
    super._initializeComponent(), (e = this._templateManager) === null || e === void 0 || e.addDefaultTemplates(this.getDefaultTemplates());
    var i = this._getUnwrappedOption();
    this._props = this._optionsWithDefaultTemplates(i), this._propsInfo.templates.forEach((r) => {
      this._componentTemplates[r] = this._createTemplateComponent(this._props[r]);
    }), Object.keys(this._getActionConfigsFull()).forEach((r) => this._addAction(r)), this._viewRef = Vn(), this.defaultKeyHandlers = this._createDefaultKeyHandlers();
  }
  _initMarkup() {
    var e = this.getProps();
    this._renderWrapper(e);
  }
  _renderWrapper(e) {
    var i = this.$element()[0];
    this._isNodeReplaced || jg.onPreRender(), jg.render(this._viewComponent, e, i, this._isNodeReplaced), this._isNodeReplaced || (this._isNodeReplaced = !0, jg.onAfterRender(), this._shouldRaiseContentReady = !0), this._shouldRaiseContentReady && (this._fireContentReady(), this._shouldRaiseContentReady = !1);
  }
  _silent(e, i) {
    this._options.silent(e, i);
  }
  _render() {
  }
  _removeWidget() {
    jg.remove(this.$element()[0]);
  }
  _dispose() {
    this._removeWidget(), super._dispose();
  }
  get elementAttr() {
    var e = this.$element()[0];
    if (!this._elementAttr) {
      var {
        attributes: i
      } = e, r = Array.from(i).filter((u) => {
        var c;
        return !this._propsInfo.templates.includes(u.name) && ((c = i[u.name]) === null || c === void 0 ? void 0 : c.specified);
      }).reduce((u, c) => {
        var {
          name: p,
          value: v
        } = c, _ = u, y = p in e;
        return _[p] = v === "" && y ? e[p] : v, _;
      }, {});
      this._elementAttr = r, this._storedClasses = e.getAttribute("class") || "";
    }
    for (var n = e.style, a = {}, o = 0; o < n.length; o += 1)
      a[n[o]] = n.getPropertyValue(n[o]);
    return this._elementAttr.style = a, this._elementAttr.class = this._storedClasses, this._elementAttr;
  }
  _getAdditionalActionConfigs() {
    return {
      onContentReady: {
        excludeValidators: ["disabled", "readOnly"]
      }
    };
  }
  _getAdditionalProps() {
    return [];
  }
  _patchOptionValues(e) {
    var {
      allowNull: i,
      elements: r,
      props: n,
      twoWay: a
    } = this._propsInfo, o = this._getViewComponentDefaultProps(), u = Object.keys(o), c = this._getDefaultOptions(), {
      children: p,
      onKeyboardHandled: v,
      ref: _
    } = e, y = v ? (I, A) => {
      v(A);
    } : void 0, b = {
      ref: _,
      children: p,
      onKeyDown: y
    };
    return [...n, ...this._getAdditionalProps()].forEach((I) => {
      Object.prototype.hasOwnProperty.call(e, I) && (b[I] = e[I]);
    }), i.forEach(HR(b, () => null)), u.forEach(HR(b, (I) => c[I])), a.forEach((I) => {
      var [A, L] = I;
      HR(b, () => c[L])(A);
    }), r.forEach((I) => {
      if (I in b) {
        var A = b[I];
        hs(A) && (b[I] = this._patchElementParam(A));
      }
    }), b;
  }
  getSupportedKeyNames() {
    return [];
  }
  prepareStyleProp(e) {
    return typeof e.style == "string" ? ae({}, e, {
      style: {},
      cssText: e.style
    }) : e;
  }
  getProps() {
    var e, i, {
      elementAttr: r
    } = this.option(), n = this._patchOptionValues(ae({}, this._props, {
      ref: this._viewRef,
      children: this._extractDefaultSlot(),
      aria: this._aria
    }));
    return this._propsInfo.templates.forEach((a) => {
      n[a] = this._componentTemplates[a];
    }), this.prepareStyleProp(ae({}, n, this.elementAttr, r, {
      className: [...((e = this.elementAttr.class) !== null && e !== void 0 ? e : "").split(" "), ...((i = r == null ? void 0 : r.class) !== null && i !== void 0 ? i : "").split(" ")].filter((a, o, u) => a && u.indexOf(a) === o).join(" ").trim(),
      class: ""
    }, this._actionsMap));
  }
  _getActionConfigs() {
    return {};
  }
  _getActionConfigsFull() {
    return ae({}, this._getActionConfigs(), this._getAdditionalActionConfigs());
  }
  getDefaultTemplates() {
    var e = Object.values(this._templatesInfo), i = {};
    return e.forEach((r) => {
      i[r] = "dx-renovation-template-mock";
    }), i;
  }
  get _templatesInfo() {
    return {};
  }
  _optionsWithDefaultTemplates(e) {
    var i = Object.entries(this._templatesInfo).reduce((r, n) => {
      var a, [o, u] = n;
      return ae({}, r, {
        [o]: (a = e[o]) !== null && a !== void 0 ? a : u
      });
    }, {});
    return ae({}, e, i);
  }
  _init() {
    super._init(), this.customKeyHandlers = {}, this._actionsMap = {}, this._aria = {}, this._componentTemplates = {};
  }
  _createDefaultKeyHandlers() {
    var e = {}, i = this.getSupportedKeyNames();
    return i.forEach((r) => {
      e[r] = (n) => this.viewRef.keyDown(DF.createKeyDownOptions(n));
    }), e;
  }
  _addAction(e, i) {
    var r = i;
    if (!r) {
      var n = this._createActionByOption(e, this._getActionConfigsFull()[e]);
      r = (a) => (Object.keys(a).forEach((o) => {
        R(a[o]) && de.isNode(a[o]) && (a[o] = ot(E(a[o])));
      }), n(a));
    }
    this._actionsMap[e] = r;
  }
  _optionChanged(e) {
    var {
      fullName: i,
      name: r,
      previousValue: n,
      value: a
    } = e;
    lse(this._props, this.option(), r, i), this._propsInfo.templates.includes(r) && a !== n && (this._componentTemplates[r] = this._createTemplateComponent(a)), r && this._getActionConfigsFull()[r] && this._addAction(r), this._shouldRaiseContentReady = this._shouldRaiseContentReady || this._checkContentReadyOption(i), super._optionChanged(e), this._invalidate();
  }
  _extractDefaultSlot() {
    return this.option("_hasAnonymousTemplateContent") ? jg.createElement(iz, {
      template: this._getTemplate(this._templateManager.anonymousTemplateName),
      transclude: !0,
      renovated: !0
    }) : null;
  }
  _createTemplateComponent(e) {
    if (e) {
      var i = this._getTemplate(e);
      if (!(ht(i) && i === "dx-renovation-template-mock"))
        return (r) => jg.createElement(iz, ase(r, i));
    }
  }
  _wrapKeyDownHandler(e) {
    return (i) => {
      var {
        keyName: r,
        originalEvent: n,
        which: a
      } = i, o = this.customKeyHandlers, u = o[r] || o[a];
      if (u !== void 0) {
        var c = u.bind(this), p = c(n, i);
        if (!p)
          return n.cancel = !0, n;
      }
      return e == null ? void 0 : e(n, i);
    };
  }
  _toPublicElement(e) {
    return ot(E(e));
  }
  _patchElementParam(e) {
    try {
      var i = E(e), r = i == null ? void 0 : i.get(0);
      return r != null && r.nodeType ? r : e;
    } catch {
      return e;
    }
  }
  repaint() {
    this._isNodeReplaced = !1, this._shouldRaiseContentReady = !0, this._removeWidget(), this._refresh();
  }
  _supportedKeys() {
    return ae({}, this.defaultKeyHandlers, this.customKeyHandlers);
  }
  registerKeyHandler(e, i) {
    this.customKeyHandlers[e] = i;
  }
  setAria(e, i) {
    this._aria[e] = i, this._initMarkup();
  }
  _getViewComponentDefaultProps() {
    return this._viewComponent.defaultProps || {};
  }
}
cS.IS_RENOVATED_WIDGET = !1;
cS.IS_RENOVATED_WIDGET = !0;
var gy = "dx-icon", Nse = "dx-svg-icon", hS = (t) => !t || typeof t != "string" ? !1 : /^\s*<svg[^>]*>(.|\r?\n)*?<\/svg>\s*$/i.test(t) ? "svg" : /data:.*base64|\.|[^<\s]\/{1,1}/.test(t) ? "image" : /^[\w-_]+$/.test(t) ? "dxIcon" : /^\s?([\w-_:]\s?)+$/.test(t) ? "fontIcon" : !1, ec = (t) => {
  switch (hS(t)) {
    case "image":
      return E("<img>").attr("src", t).addClass(gy);
    case "fontIcon":
      return E("<i>").addClass("".concat(gy, " ").concat(t));
    case "dxIcon":
      return E("<i>").addClass("".concat(gy, " ").concat(gy, "-").concat(t));
    case "svg":
      return E("<i>").addClass("".concat(gy, " ").concat(Nse)).append(t);
    default:
      return null;
  }
};
class Hse extends cS {
  get _validationGroupConfig() {
    return Si.getGroupConfig(this._findGroup());
  }
  getDefaultTemplateNames() {
    return ["content"];
  }
  getSupportedKeyNames() {
    return ["space", "enter"];
  }
  getProps() {
    var e = super.getProps();
    e.onClick = (r) => {
      var {
        event: n
      } = r;
      this._clickAction({
        event: n,
        validationGroup: this._validationGroupConfig
      });
    };
    var i = hS(e.icon);
    return i === "svg" && (e.iconTemplate = this._createTemplateComponent(() => e.icon)), e;
  }
  get _templatesInfo() {
    return {
      template: "content"
    };
  }
  _toggleActiveState(e, i) {
    var r = this.viewRef;
    i ? r.activate() : r.deactivate();
  }
  _getSubmitAction() {
    var e = !0, i = "valid";
    return this._createAction((r) => {
      var {
        event: n,
        submitInput: a
      } = r;
      if (e) {
        var o = this._validationGroupConfig;
        if (o !== void 0 && o !== "") {
          var u = o.validate();
          i = u.status, u.status === "pending" && (e = !1, this.option("disabled", !0), u.complete.then((c) => {
            var {
              status: p
            } = c;
            this.option("disabled", !1), i = p, i === "valid" && a.click(), e = !0;
          }));
        }
      }
      i !== "valid" && n.preventDefault(), n.stopPropagation();
    });
  }
  _initializeComponent() {
    super._initializeComponent(), this._addAction("onSubmit", this._getSubmitAction()), this._clickAction = this._createClickAction();
  }
  _initMarkup() {
    super._initMarkup();
    var e = this.$element().find(".dx-button-content"), i = e.children().filter(".dx-template-wrapper"), r = e.children().filter(".dx-button-submit-input");
    i.length && (i.addClass("dx-button-content"), i.append(r), e.replaceWith(i));
  }
  _patchOptionValues(e) {
    return super._patchOptionValues(ae({}, e, {
      templateData: e._templateData
    }));
  }
  _findGroup() {
    var e = this.$element(), i = this.option("validationGroup");
    return i !== void 0 && i !== "" ? i : Si.findGroup(e, this._modelByElement(e));
  }
  _createClickAction() {
    return this._createActionByOption("onClick", {
      excludeValidators: ["readOnly"]
    });
  }
  _optionChanged(e) {
    switch (e.name) {
      case "onClick":
        this._clickAction = this._createClickAction();
    }
    super._optionChanged(e);
  }
}
var mm = ui();
const Yt = rF(bi.ERROR_MESSAGES, {
  E1001: "Module '{0}'. Controller '{1}' is already registered",
  E1002: "Module '{0}'. Controller '{1}' does not inherit from DevExpress.ui.dxDataGrid.Controller",
  E1003: "Module '{0}'. View '{1}' is already registered",
  E1004: "Module '{0}'. View '{1}' does not inherit from DevExpress.ui.dxDataGrid.View",
  E1005: "Public method '{0}' is already registered",
  E1006: "Public method '{0}.{1}' does not exist",
  E1007: "State storing cannot be provided due to the restrictions of the browser",
  E1010: "The template does not contain the TextBox widget",
  E1011: 'Items cannot be deleted from the List. Implement the "remove" function in the data store',
  E1012: "Editing type '{0}' with the name '{1}' is unsupported",
  E1016: "Unexpected type of data source is provided for a lookup column",
  E1018: "The 'collapseAll' method cannot be called if you use a remote data source",
  E1019: "Search mode '{0}' is unavailable",
  E1020: "The type cannot be changed after initialization",
  E1021: "{0} '{1}' you are trying to remove does not exist",
  E1022: 'The "markers" option is given an invalid value. Assign an array instead',
  E1023: 'The "routes" option is given an invalid value. Assign an array instead',
  E1025: "This layout is too complex to render",
  E1026: 'The "calculateCustomSummary" function is missing from a field whose "summaryType" option is set to "custom"',
  E1031: "Unknown subscription in the Scheduler widget: '{0}'",
  E1032: "Unknown start date in an appointment: '{0}'",
  E1033: "Unknown step in the date navigator: '{0}'",
  E1034: "The browser does not implement an API for saving files",
  E1035: "The editor cannot be created: {0}",
  E1037: "Invalid structure of grouped data",
  E1038: "The browser does not support local storages for local web pages",
  E1039: "A cell's position cannot be calculated",
  E1040: "The '{0}' key value is not unique within the data array",
  E1041: "The '{0}' script is referenced after the DevExtreme scripts or not referenced at all",
  E1042: "{0} requires the key field to be specified",
  E1043: "Changes cannot be processed due to the incorrectly set key",
  E1044: "The key field specified by the keyExpr option does not match the key field specified in the data store",
  E1045: "Editing requires the key field to be specified in the data store",
  E1046: "The '{0}' key field is not found in data objects",
  E1047: 'The "{0}" field is not found in the fields array',
  E1048: 'The "{0}" operation is not found in the filterOperations array',
  E1049: "Column '{0}': filtering is allowed but the 'dataField' or 'name' option is not specified",
  E1050: "The validationRules option does not apply to third-party editors defined in the editCellTemplate",
  E1051: `HtmlEditor's valueType is "{0}", but the {0} converter was not imported.`,
  E1052: '{0} should have the "dataSource" option specified',
  E1053: 'The "buttons" option accepts an array that contains only objects or string values',
  E1054: "All text editor buttons must have names",
  E1055: 'One or several text editor buttons have invalid or non-unique "name" values',
  E1056: 'The {0} widget does not support buttons of the "{1}" type',
  E1058: 'The "startDayHour" and "endDayHour" options must be integers in the [0, 24] range, with "endDayHour" being greater than "startDayHour".',
  E1059: "The following column names are not unique: {0}",
  E1060: "All editable columns must have names",
  E1061: 'The "offset" option must be an integer in the [-1440, 1440] range, divisible by 5 without a remainder.',
  E1062: 'The "cellDuration" must be a positive integer, evenly dividing the ("endDayHour" - "startDayHour") interval into minutes.',
  W1001: 'The "key" option cannot be modified after initialization',
  W1002: "An item with the key '{0}' does not exist",
  W1003: "A group with the key '{0}' in which you are trying to select items does not exist",
  W1004: "The item '{0}' you are trying to select in the group '{1}' does not exist",
  W1005: "Due to column data types being unspecified, data has been loaded twice in order to apply initial filter settings. To resolve this issue, specify data types for all grid columns.",
  W1006: "The map service returned the following error: '{0}'",
  W1007: "No item with key {0} was found in the data source, but this key was used as the parent key for item {1}",
  W1008: "Cannot scroll to the '{0}' date because it does not exist on the current view",
  W1009: "Searching works only if data is specified using the dataSource option",
  W1010: "The capability to select all items works with source data of plain structure only",
  W1011: 'The "keyExpr" option is not applied when dataSource is not an array',
  W1012: "The '{0}' key field is not found in data objects",
  W1013: 'The "message" field in the dialog component was renamed to "messageHtml". Change your code correspondingly. In addition, if you used HTML code in the message, make sure that it is secure',
  W1014: "The Floating Action Button exceeds the recommended speed dial action count. If you need to display more speed dial actions, increase the maxSpeedDialActionCount option value in the global config.",
  W1016: "The '{0}' field in the HTML Editor toolbar item configuration was renamed to '{1}'. Please make a corresponding change in your code.",
  W1017: "The 'key' property is not specified for a lookup data source. Please specify it to prevent requests for the entire dataset when users filter data.",
  W1018: "Infinite scrolling may not work properly with multiple selection. To use these features together, set 'selection.deferred' to true or set 'selection.selectAllMode' to 'page'.",
  W1019: "Filter query string exceeds maximum length limit of {0} characters.",
  W1020: "hideEvent is ignored when the shading property is true",
  W1021: `The '{0}' is not rendered because none of the DOM elements match the value of the "container" property.`,
  W1022: "{0} JSON parsing error: '{1}'",
  W1023: "Appointments require unique keys. Otherwise, the agenda view may not work correctly.",
  W1024: "The client-side export is enabled. Implement the 'onExporting' function.",
  W1025: "'scrolling.mode' is set to 'virtual' or 'infinite'. Specify the height of the component."
});
var HY = Ot(), $se = Vu.add, zse = Oh, Wse = lI, Bx = new q(), $Y = "link[rel=dx-theme]", Use = "data-theme", Gse = "data-active", fz = "dx-hairlines", zY = "any", jd, Hk, Yd, as, mh, pz = 15e3, $R = "dx.";
function VF() {
  if (!wt())
    return null;
  var t = E("<div>", jd).addClass("dx-theme-marker").appendTo(jd.documentElement), e;
  try {
    return e = HY.getComputedStyle(t.get(0)).fontFamily, !e || (e = e.replace(/["']/g, ""), e.substr(0, $R.length) !== $R) ? null : e.substr($R.length);
  } finally {
    t.remove();
  }
}
function vz(t) {
  var e, i, r = !0;
  mh = t;
  function n() {
    mh = null, clearInterval(i), r = !0, mm.fire(), mm.empty(), Bx.resolve();
  }
  if (gz() || !pz)
    n();
  else {
    if (!r) {
      mh && (mh = t);
      return;
    }
    e = Date.now(), r = !1, i = setInterval(function() {
      var a = gz(), o = !a && Date.now() - e > pz;
      o && Yt.log("W0004", mh), (a || o) && n();
    }, 10);
  }
}
function gz() {
  if (!mh)
    return !0;
  var t = mh === zY;
  if (Bx.state() === "resolved" && t)
    return !0;
  var e = VF();
  return e && t ? !0 : e === mh;
}
function Kse() {
  var t = E($Y, jd);
  t.length && (Yd = {}, Hk = E(mF("<link rel=stylesheet>"), jd), t.each(function() {
    var e = E(this, jd), i = e.attr(Use), r = e.attr("href"), n = e.attr(Gse) === "true";
    Yd[i] = {
      url: r,
      isActive: n
    };
  }), t.last().after(Hk), t.remove());
}
function jse(t) {
  var e = t ? t.split(".") : [], i = null;
  if (Yd) {
    if (t in Yd)
      return t;
    N(Yd, function(r, n) {
      var a = r.split(".");
      if (!(e[0] && a[0] !== e[0]) && !(e[1] && e[1] !== a[1]) && !(e[2] && e[2] !== a[2]) && ((!i || n.isActive) && (i = r), n.isActive))
        return !1;
    });
  }
  return i;
}
function Yse(t) {
  try {
    t !== jd && (Yd = null);
  } catch {
    Yd = null;
  }
  jd = t;
}
function WY(t) {
  t = t || {}, Yse(t.context || de.getDocument()), jd && (Kse(), as = void 0, ho(t));
}
function ho(t) {
  if (!arguments.length)
    return as = as || VF(), as;
  GY(zse()), t = t || {}, typeof t == "string" && (t = {
    theme: t
  });
  var e = t._autoInit, i = t.loadCallback, r;
  if (as = jse(t.theme || as), as && (r = Yd[as]), i && mm.add(i), r)
    Hk.attr("href", Yd[as].url), (mm.has() || Bx.state() !== "resolved" || t._forceTimeout) && vz(as);
  else if (e)
    wt() && vz(zY), mm.fire(), mm.empty();
  else
    throw Yt.Error("E0021", as);
  Bx.done(() => UY(mY(), as));
}
function qse(t) {
  t = t || ho();
  var e = [], i = t && t.split(".");
  return i && (e.push("dx-theme-" + i[0], "dx-theme-" + i[0] + "-typography"), i.length > 1 && e.push("dx-color-scheme-" + i[1] + (fs(t) ? "-" + i[2] : ""))), e;
}
var Ww;
function UY(t, e) {
  Ww = qse(e).join(" "), E(t).addClass(Ww), function() {
    var i = wt() && HY.devicePixelRatio;
    if (!(!i || i < 2)) {
      var r = E("<div>");
      r.css("border", ".5px solid transparent"), E("body").append(r), jt(r) === 1 && (E(t).addClass(fz), Ww += " " + fz), r.remove();
    }
  }();
}
function GY(t) {
  E(t).removeClass(Ww);
}
function pI(t, e) {
  return e || (e = as || VF()), new RegExp(t).test(e);
}
function fs(t) {
  return _a(t) || za(t);
}
function _a(t) {
  return pI("material", t);
}
function za(t) {
  return pI("fluent", t);
}
function KY(t) {
  return pI("generic", t);
}
function Xse(t) {
  return pI("compact", t);
}
function Qse(t, e) {
  var i = de.getDocument(), r = i.createElement("span");
  r.style.position = "absolute", r.style.top = "-9999px", r.style.left = "-9999px", r.style.visibility = "hidden", r.style.fontFamily = "Arial", r.style.fontSize = "250px", r.style.fontWeight = e, r.innerHTML = t, i.body.appendChild(r);
  var n = r.offsetWidth;
  r.style.fontFamily = "Roboto, RobotoFallback, Arial";
  var a = r.offsetWidth;
  return r.parentNode.removeChild(r), n !== a;
}
function Zse(t, e) {
  return new Promise((i) => {
    var r = () => {
      clearInterval(n), clearTimeout(a), i();
    }, n = setInterval(() => {
      Qse(t, e) && r();
    }, 15), a = setTimeout(r, 2e3);
  });
}
function mz() {
  if (WY({
    _autoInit: !0,
    _forceTimeout: !0
  }), E($Y, jd).length)
    throw Yt.Error("E0022");
}
wt() ? mz() : $se(mz);
Wse.add(function(t, e) {
  Bx.done(function() {
    GY(e), UY(t);
  });
});
Ye.changed.add(function() {
  WY({
    _autoInit: !0
  });
});
function $s(t) {
  return Object.keys(t).filter((e) => t[e]).join(" ");
}
var Jse = ["iconTemplate", "position", "source"], ele = (t) => {
  var {
    iconClassName: e,
    props: {
      iconTemplate: i,
      source: r
    },
    sourceType: n
  } = t;
  return sc([n === "dxIcon" && Fr(1, "i", e), n === "fontIcon" && Fr(1, "i", e), n === "image" && Fr(1, "img", e, null, 1, {
    alt: "",
    src: r
  }), i && Fr(1, "i", e, i({}), 0)], 0);
}, tle = {
  position: "left",
  source: ""
}, ile = (t) => t && (t.defaultProps ? (e) => Uo(zi(2, t, ae({}, e))) : t);
class jY extends qs {
  constructor(e) {
    super(e), this.state = {};
  }
  get sourceType() {
    return hS(this.props.source);
  }
  get cssClass() {
    return this.props.position !== "left" ? "dx-icon-right" : "";
  }
  get iconClassName() {
    var e = {
      "dx-icon": !0,
      [this.cssClass]: !!this.cssClass
    }, {
      source: i
    } = this.props;
    return this.sourceType === "dxIcon" ? $s(ae({}, e, {
      ["dx-icon-".concat(i)]: !0
    })) : this.sourceType === "fontIcon" ? $s(ae({}, e, {
      [String(i)]: !!i
    })) : this.sourceType === "image" ? $s(e) : this.sourceType === "svg" ? $s(ae({}, e, {
      "dx-svg-icon": !0
    })) : "";
  }
  get restAttributes() {
    var e = this.props, i = sr(e, Jse);
    return i;
  }
  render() {
    var e = this.props;
    return ele({
      props: ae({}, e, {
        iconTemplate: ile(e.iconTemplate)
      }),
      sourceType: this.sourceType,
      cssClass: this.cssClass,
      iconClassName: this.iconClassName,
      restAttributes: this.restAttributes
    });
  }
}
jY.defaultProps = tle;
var _z = "dx-inkripple", Cz = "dx-inkripple-wave", YY = "dx-inkripple-showing", qY = "dx-inkripple-hiding", rle = 2, nle = 4e3, zR = 300, ale = 1e3, XY = 0, QY = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, {
    useHoldAnimation: e,
    waveSizeCoefficient: i,
    isCentered: r,
    wavesNumber: n
  } = t;
  return {
    waveSizeCoefficient: i || rle,
    isCentered: r || !1,
    wavesNumber: n || 1,
    durations: ule(e ?? !0)
  };
}, NF = function(t) {
  var e = QY(t);
  return {
    showWave: JY.bind(this, e),
    hideWave: tq.bind(this, e)
  };
}, ole = function(t) {
  var e = t.children("." + _z);
  return e.length === 0 && (e = E("<div>").addClass(_z).appendTo(t)), e;
}, ZY = function(t, e) {
  for (var i = ole(E(t)), r = i.children("." + Cz).toArray(), n = r.length; n < e; n++) {
    var a = E("<div>").appendTo(i).addClass(Cz);
    r.push(a[0]);
  }
  return E(r);
}, sle = function(t, e) {
  var i = E(e.element), r = oi(i), n = jt(i), a = parseInt(Math.sqrt(r * r + n * n)), o = Math.min(nle, parseInt(a * t.waveSizeCoefficient)), u, c;
  if (t.isCentered)
    u = (r - o) / 2, c = (n - o) / 2;
  else {
    var p = e.event, v = i.offset(), _ = p.pageX - v.left, y = p.pageY - v.top;
    u = _ - o / 2, c = y - o / 2;
  }
  return {
    left: u,
    top: c,
    height: o,
    width: o
  };
};
function JY(t, e) {
  var i = ZY(e.element, t.wavesNumber).eq(e.wave || XY);
  t.hidingTimeout && clearTimeout(t.hidingTimeout), eq(i), i.css(sle(t, e)), t.showingTimeout = setTimeout(lle.bind(this, t, i), 0);
}
function lle(t, e) {
  var i = t.durations.showingScale + "ms";
  e.addClass(YY).css("transitionDuration", i);
}
function ule(t) {
  return {
    showingScale: t ? ale : zR,
    hidingScale: zR,
    hidingOpacity: zR
  };
}
function eq(t) {
  t.removeClass(qY).css("transitionDuration", "");
}
function tq(t, e) {
  t.showingTimeout && clearTimeout(t.showingTimeout);
  var i = ZY(e.element, e.wavesNumber).eq(e.wave || XY), r = t.durations, n = r.hidingScale + "ms, " + r.hidingOpacity + "ms";
  i.addClass(qY).removeClass(YY).css("transitionDuration", n);
  var a = Math.max(r.hidingScale, r.hidingOpacity);
  t.hidingTimeout = setTimeout(eq.bind(this, i), a);
}
var dle = ["config"], cle = (t) => Uo(Fr(1, "div", "dx-inkripple", null, 1, ae({}, t.restAttributes))), hle = {
  config: Object.freeze({})
};
class iq extends qs {
  constructor(e) {
    super(e), this.state = {}, this.__getterCache = {}, this.hideWave = this.hideWave.bind(this), this.showWave = this.showWave.bind(this);
  }
  get getConfig() {
    return this.__getterCache.getConfig !== void 0 ? this.__getterCache.getConfig : this.__getterCache.getConfig = (() => {
      var {
        config: e
      } = this.props;
      return QY(e);
    })();
  }
  get restAttributes() {
    var e = this.props, i = sr(e, dle);
    return i;
  }
  hideWave(e) {
    tq(this.getConfig, e);
  }
  showWave(e) {
    JY(this.getConfig, e);
  }
  componentWillUpdate(e, i, r) {
    this.props.config !== e.config && (this.__getterCache.getConfig = void 0);
  }
  render() {
    var e = this.props;
    return cle({
      props: ae({}, e),
      getConfig: this.getConfig,
      restAttributes: this.restAttributes
    });
  }
}
iq.defaultProps = hle;
var fle = Vu.add, yz = Math.abs, WR = 0, UR = 1, my = 2, xT = 10, ple = 0, vle = 180, gle = function() {
  return Np("pointer-events");
}, mle = oc(function() {
  var t = Ye.real().deviceType === "desktop";
  if (!gle() || !t)
    return ee;
  var e = E("<div>").addClass("dx-gesture-cover").css("pointerEvents", "none");
  return k.subscribeGlobal(e, "dxmousewheel", function(i) {
    i.preventDefault();
  }), fle(function() {
    e.appendTo("body");
  }), function(i, r) {
    e.css("pointerEvents", i ? "all" : "none"), i && e.css("cursor", r);
  };
}), _le = function(t, e) {
  var i = mle();
  i(t, e);
}, fS = fI.inherit({
  gesture: !0,
  configure: function(t) {
    this.getElement().css("msTouchAction", t.immediate ? "pinch-zoom" : ""), this.callBase(t);
  },
  allowInterruptionByMouseWheel: function() {
    return this._stage !== my;
  },
  getDirection: function() {
    return this.direction;
  },
  _cancel: function() {
    this.callBase.apply(this, arguments), this._toggleGestureCover(!1), this._stage = WR;
  },
  start: function(t) {
    if (t._needSkipEvent || uY(t)) {
      this._cancel(t);
      return;
    }
    this._startEvent = Ch(t), this._startEventData = br(t), this._stage = UR, this._init(t), this._setupImmediateTimer();
  },
  _setupImmediateTimer: function() {
    var t;
    if (clearTimeout(this._immediateTimer), this._immediateAccepted = !1, !!this.immediate) {
      if (this.immediateTimeout === 0) {
        this._immediateAccepted = !0;
        return;
      }
      this._immediateTimer = setTimeout((function() {
        this._immediateAccepted = !0;
      }).bind(this), (t = this.immediateTimeout) !== null && t !== void 0 ? t : vle);
    }
  },
  move: function(t) {
    if (this._stage === UR && this._directionConfirmed(t)) {
      if (this._stage = my, this._resetActiveElement(), this._toggleGestureCover(!0), this._clearSelection(t), this._adjustStartEvent(t), this._start(this._startEvent), this._stage === WR)
        return;
      this._requestAccept(t), this._move(t), this._forgetAccept();
    } else
      this._stage === my && (this._clearSelection(t), this._move(t));
  },
  _directionConfirmed: function(t) {
    var e = this._getTouchBoundary(t), i = hp(this._startEventData, br(t)), r = yz(i.x), n = yz(i.y), a = this._validateMove(e, r, n), o = this._validateMove(e, n, r), u = this.getDirection(t), c = u === "both" && (a || o), p = u === "horizontal" && a, v = u === "vertical" && o;
    return c || p || v || this._immediateAccepted;
  },
  _validateMove: function(t, e, i) {
    return e && e >= t && (this.immediate ? e >= i : !0);
  },
  _getTouchBoundary: function(t) {
    return this.immediate || oo(t) ? ple : xT;
  },
  _adjustStartEvent: function(t) {
    var e = this._getTouchBoundary(t), i = hp(this._startEventData, br(t));
    this._startEvent.pageX += Am(i.x) * e, this._startEvent.pageY += Am(i.y) * e;
  },
  _resetActiveElement: function() {
    Ye.real().platform === "ios" && this.getElement().find(":focus").length && $m();
  },
  _toggleGestureCover: function(t) {
    this._toggleGestureCoverImpl(t);
  },
  _toggleGestureCoverImpl: function(t) {
    var e = this._stage === my;
    e && _le(t, this.getElement().css("cursor"));
  },
  _clearSelection: function(t) {
    oo(t) || nS(t) || roe();
  },
  end: function(t) {
    this._toggleGestureCover(!1), this._stage === my ? this._end(t) : this._stage === UR && this._stop(t), this._stage = WR;
  },
  dispose: function() {
    clearTimeout(this._immediateTimer), this.callBase.apply(this, arguments), this._toggleGestureCover(!1);
  },
  _init: ee,
  _start: ee,
  _move: ee,
  _stop: ee,
  _end: ee
});
fS.initialTouchBoundary = xT;
fS.touchBoundary = function(t) {
  if (R(t)) {
    xT = t;
    return;
  }
  return xT;
};
var Cle = wi.abstract, yle = Ye.real(), rq = "scroll", HF = "dxscrollinit", $F = "dxscrollstart", zF = "dxscroll", WF = "dxscrollend", UF = "dxscrollstop", GF = "dxscrollcancel", nq = wi.inherit(function() {
  var t = ve(rq, "dxScrollEmitter");
  return {
    ctor: function(e) {
      this._element = e, this._locked = !1, this._proxiedScroll = (i) => {
        this._disposed || this._scroll(i);
      }, k.on(this._element, t, this._proxiedScroll);
    },
    _scroll: Cle,
    check: function(e, i) {
      this._locked && i();
    },
    dispose: function() {
      this._disposed = !0, k.off(this._element, t, this._proxiedScroll);
    }
  };
}()), aq = nq.inherit({
  ctor: function(t, e) {
    this.callBase(t), this._timeout = e;
  },
  _scroll: function() {
    this._prepare(), this._forget();
  },
  _prepare: function() {
    this._timer && this._clearTimer(), this._locked = !0;
  },
  _clearTimer: function() {
    clearTimeout(this._timer), this._locked = !1, this._timer = null;
  },
  _forget: function() {
    var t = this;
    this._timer = setTimeout(function() {
      t._clearTimer();
    }, this._timeout);
  },
  dispose: function() {
    this.callBase(), this._clearTimer();
  }
}), xz = aq.inherit({
  ctor: function(t) {
    this.callBase(t, 400), this._lastWheelDirection = null;
  },
  check: function(t, e) {
    this._checkDirectionChanged(t), this.callBase(t, e);
  },
  _checkDirectionChanged: function(t) {
    if (!oo(t)) {
      this._lastWheelDirection = null;
      return;
    }
    var e = t.shiftKey || !1, i = this._lastWheelDirection !== null && e !== this._lastWheelDirection;
    this._lastWheelDirection = e, this._locked = this._locked && !i;
  }
}), $k = aq.inherit({
  ctor: function(t) {
    this.callBase(t, 400);
  }
});
(function() {
  var {
    ios: t,
    android: e
  } = yle;
  (t || e) && ($k = nq.inherit({
    _scroll: function() {
      this._locked = !0;
      var i = this;
      Nd(this._scrollFrame), this._scrollFrame = Fx(function() {
        i._locked = !1;
      });
    },
    check: function(i, r) {
      Nd(this._scrollFrame), Nd(this._checkFrame);
      var n = this, a = this.callBase;
      this._checkFrame = Fx(function() {
        a.call(n, i, r), n._locked = !1;
      });
    },
    dispose: function() {
      this.callBase(), Nd(this._scrollFrame), Nd(this._checkFrame);
    }
  }));
})();
var xle = fS.inherit(function() {
  var t = Math.round(16.666666666666668);
  return {
    ctor: function(e) {
      this.callBase.apply(this, arguments), this.direction = "both", this._pointerLocker = new $k(e), this._wheelLocker = new xz(e);
    },
    validate: function() {
      return !0;
    },
    configure: function(e) {
      e.scrollTarget && (this._pointerLocker.dispose(), this._wheelLocker.dispose(), this._pointerLocker = new $k(e.scrollTarget), this._wheelLocker = new xz(e.scrollTarget)), this.callBase(e);
    },
    _init: function(e) {
      this._wheelLocker.check(e, (function() {
        oo(e) && this._accept(e);
      }).bind(this)), this._pointerLocker.check(e, (function() {
        var i = this.isNative && wp(e);
        !oo(e) && !i && this._accept(e);
      }).bind(this)), this._fireEvent(HF, e), this._prevEventData = br(e);
    },
    move: function(e) {
      this.callBase.apply(this, arguments), e.isScrollingEvent = this.isNative || e.isScrollingEvent;
    },
    _start: function(e) {
      this._savedEventData = br(e), this._fireEvent($F, e), this._prevEventData = br(e);
    },
    _move: function(e) {
      var i = br(e);
      this._fireEvent(zF, e, {
        delta: hp(this._prevEventData, i)
      });
      var r = hp(this._savedEventData, i);
      r.time > 200 && (this._savedEventData = this._prevEventData), this._prevEventData = br(e);
    },
    _end: function(e) {
      var i = hp(this._prevEventData, br(e)), r = {
        x: 0,
        y: 0
      };
      if (!oo(e) && i.time < 100) {
        var n = hp(this._savedEventData, this._prevEventData), a = t / n.time;
        r = {
          x: n.x * a,
          y: n.y * a
        };
      }
      this._fireEvent(WF, e, {
        velocity: r
      });
    },
    _stop: function(e) {
      this._fireEvent(UF, e);
    },
    cancel: function(e) {
      this.callBase.apply(this, arguments), this._fireEvent(GF, e);
    },
    dispose: function() {
      this.callBase.apply(this, arguments), this._pointerLocker.dispose(), this._wheelLocker.dispose();
    },
    _clearSelection: function() {
      if (!this.isNative)
        return this.callBase.apply(this, arguments);
    },
    _toggleGestureCover: function() {
      if (!this.isNative)
        return this.callBase.apply(this, arguments);
    }
  };
}());
zm({
  emitter: xle,
  events: [HF, $F, zF, WF, UF, GF]
});
const ss = {
  init: HF,
  start: $F,
  move: zF,
  end: WF,
  stop: UF,
  cancel: GF,
  scroll: rq
};
function Sn(t) {
  return (e, i, r, n) => {
    var a = n ? ve(t, n) : t;
    if (i)
      return k.on(e, a, r, i), () => {
        k.off(e, a, i);
      };
  };
}
var Sle = Sn(di), aVe = Sn(ss.scroll), oVe = Sn(ss.init), sVe = Sn(ss.start), lVe = Sn(ss.move), uVe = Sn(ss.end), dVe = Sn(ss.stop), cVe = Sn(ss.cancel), hVe = Sn(Xt.down), fVe = Sn(Xt.up), pVe = Sn(Xt.move), vVe = Sn("mouseenter"), gVe = Sn("mouseleave"), mVe = Sn("keydown"), Ele = Sn("dxactive"), ble = Sn("dxinactive"), wle = Sn("dxhoverstart"), Tle = Sn("dxhoverend"), Ile = Sn("focusin"), Dle = Sn("focusout"), vI = {
  className: "",
  activeStateEnabled: !1,
  disabled: !1,
  focusStateEnabled: !1,
  hoverStateEnabled: !1,
  tabIndex: 0,
  visible: !0
}, ea = cY(void 0), Ale = ["children", "rtlEnabled"], Ole = (t) => t.props.children, Rle = {};
class oq extends qs {
  constructor(e) {
    super(e), this.state = {}, this.__getterCache = {};
  }
  getChildContext() {
    return ae({}, this.context, {
      [ea.id]: this.config || ea.defaultValue
    });
  }
  get config() {
    return this.__getterCache.config !== void 0 ? this.__getterCache.config : this.__getterCache.config = {
      rtlEnabled: this.props.rtlEnabled
    };
  }
  get restAttributes() {
    var e = this.props, i = sr(e, Ale);
    return i;
  }
  componentWillUpdate(e, i, r) {
    this.props.rtlEnabled !== e.rtlEnabled && (this.__getterCache.config = void 0);
  }
  render() {
    var e = this.props;
    return Ole({
      props: ae({}, e),
      config: this.config,
      restAttributes: this.restAttributes
    });
  }
}
oq.defaultProps = Rle;
function Lle(t, e) {
  return t !== void 0 ? t : (e == null ? void 0 : e.rtlEnabled) !== void 0 ? e.rtlEnabled : Oi().rtlEnabled;
}
function Mle(t, e) {
  var i = R(t), r = R(Oi().rtlEnabled) && !i && !R(e == null ? void 0 : e.rtlEnabled);
  return i && t !== (e == null ? void 0 : e.rtlEnabled) || r;
}
var kle = ["_feedbackHideTimeout", "_feedbackShowTimeout", "accessKey", "activeStateEnabled", "activeStateUnit", "addWidgetClass", "aria", "children", "className", "classes", "cssText", "disabled", "focusStateEnabled", "height", "hint", "hoverStateEnabled", "name", "onActive", "onClick", "onDimensionChanged", "onFocusIn", "onFocusOut", "onHoverEnd", "onHoverStart", "onInactive", "onKeyDown", "onRootElementRendered", "onVisibilityChange", "rootElementRef", "rtlEnabled", "tabIndex", "visible", "width"], Ple = 400, Fle = 30, Ble = (t) => Object.keys(t).reduce((e, i) => t[i] ? ae({}, e, {
  [i === "role" || i === "id" ? i : "aria-".concat(i)]: String(t[i])
}) : e, {}), Vle = (t) => {
  var e = Uo(Fr(1, "div", t.cssClasses, t.props.children, 0, ae({}, t.attributes, {
    tabIndex: t.tabIndex,
    title: t.props.hint,
    style: AF(t.styles)
  }), null, t.widgetElementRef));
  return t.shouldRenderConfigProvider ? zi(2, oq, {
    rtlEnabled: t.rtlEnabled,
    children: e
  }) : e;
}, ST = Object.create(Object.prototype, ae(Object.getOwnPropertyDescriptors(vI), Object.getOwnPropertyDescriptors({
  _feedbackHideTimeout: Ple,
  _feedbackShowTimeout: Fle,
  cssText: "",
  aria: Object.freeze({}),
  classes: "",
  name: "",
  addWidgetClass: !0
})));
let gI = class extends aS {
  constructor(e) {
    super(e), this.widgetElementRef = Vn(), this.state = {
      active: !1,
      focused: !1,
      hovered: !1
    }, this.setRootElementRef = this.setRootElementRef.bind(this), this.activeEffect = this.activeEffect.bind(this), this.inactiveEffect = this.inactiveEffect.bind(this), this.clickEffect = this.clickEffect.bind(this), this.focus = this.focus.bind(this), this.blur = this.blur.bind(this), this.activate = this.activate.bind(this), this.deactivate = this.deactivate.bind(this), this.focusInEffect = this.focusInEffect.bind(this), this.focusOutEffect = this.focusOutEffect.bind(this), this.hoverStartEffect = this.hoverStartEffect.bind(this), this.hoverEndEffect = this.hoverEndEffect.bind(this), this.keyboardEffect = this.keyboardEffect.bind(this), this.resizeEffect = this.resizeEffect.bind(this), this.windowResizeEffect = this.windowResizeEffect.bind(this), this.visibilityEffect = this.visibilityEffect.bind(this), this.checkDeprecation = this.checkDeprecation.bind(this), this.applyCssTextEffect = this.applyCssTextEffect.bind(this);
  }
  get config() {
    return this.context[ea.id] ? this.context[ea.id] : ea.defaultValue;
  }
  createEffects() {
    return [new ar(this.setRootElementRef, []), new ar(this.activeEffect, [this.props._feedbackShowTimeout, this.props.activeStateEnabled, this.props.activeStateUnit, this.props.disabled, this.props.onActive]), new ar(this.inactiveEffect, [this.props._feedbackHideTimeout, this.props.activeStateEnabled, this.props.activeStateUnit, this.props.onInactive, this.state.active]), new ar(this.clickEffect, [this.props.disabled, this.props.name, this.props.onClick]), new ar(this.focusInEffect, [this.props.disabled, this.props.focusStateEnabled, this.props.name, this.props.onFocusIn]), new ar(this.focusOutEffect, [this.props.focusStateEnabled, this.props.name, this.props.onFocusOut, this.state.focused]), new ar(this.hoverStartEffect, [this.props.activeStateUnit, this.props.disabled, this.props.hoverStateEnabled, this.props.onHoverStart, this.state.active]), new ar(this.hoverEndEffect, [this.props.activeStateUnit, this.props.hoverStateEnabled, this.props.onHoverEnd, this.state.hovered]), new ar(this.keyboardEffect, [this.props.focusStateEnabled, this.props.onKeyDown]), new ar(this.resizeEffect, [this.props.name, this.props.onDimensionChanged]), new ar(this.windowResizeEffect, [this.props.onDimensionChanged]), new ar(this.visibilityEffect, [this.props.name, this.props.onVisibilityChange]), new ar(this.checkDeprecation, [this.props.height, this.props.width]), new ar(this.applyCssTextEffect, [this.props.cssText]), oS()];
  }
  updateEffects() {
    var e, i, r, n, a, o, u, c, p, v, _, y, b;
    (e = this._effects[1]) === null || e === void 0 || e.update([this.props._feedbackShowTimeout, this.props.activeStateEnabled, this.props.activeStateUnit, this.props.disabled, this.props.onActive]), (i = this._effects[2]) === null || i === void 0 || i.update([this.props._feedbackHideTimeout, this.props.activeStateEnabled, this.props.activeStateUnit, this.props.onInactive, this.state.active]), (r = this._effects[3]) === null || r === void 0 || r.update([this.props.disabled, this.props.name, this.props.onClick]), (n = this._effects[4]) === null || n === void 0 || n.update([this.props.disabled, this.props.focusStateEnabled, this.props.name, this.props.onFocusIn]), (a = this._effects[5]) === null || a === void 0 || a.update([this.props.focusStateEnabled, this.props.name, this.props.onFocusOut, this.state.focused]), (o = this._effects[6]) === null || o === void 0 || o.update([this.props.activeStateUnit, this.props.disabled, this.props.hoverStateEnabled, this.props.onHoverStart, this.state.active]), (u = this._effects[7]) === null || u === void 0 || u.update([this.props.activeStateUnit, this.props.hoverStateEnabled, this.props.onHoverEnd, this.state.hovered]), (c = this._effects[8]) === null || c === void 0 || c.update([this.props.focusStateEnabled, this.props.onKeyDown]), (p = this._effects[9]) === null || p === void 0 || p.update([this.props.name, this.props.onDimensionChanged]), (v = this._effects[10]) === null || v === void 0 || v.update([this.props.onDimensionChanged]), (_ = this._effects[11]) === null || _ === void 0 || _.update([this.props.name, this.props.onVisibilityChange]), (y = this._effects[12]) === null || y === void 0 || y.update([this.props.height, this.props.width]), (b = this._effects[13]) === null || b === void 0 || b.update([this.props.cssText]);
  }
  setRootElementRef() {
    var {
      onRootElementRendered: e,
      rootElementRef: i
    } = this.props;
    i && (i.current = this.widgetElementRef.current), e == null || e(this.widgetElementRef.current);
  }
  activeEffect() {
    var {
      _feedbackShowTimeout: e,
      activeStateEnabled: i,
      activeStateUnit: r,
      disabled: n,
      onActive: a
    } = this.props, o = r;
    if (i && !n)
      return Ele(this.widgetElementRef.current, (u) => {
        this.setState((c) => ({
          active: !0
        })), a == null || a(u);
      }, {
        timeout: e,
        selector: o
      }, "UIFeedback");
  }
  inactiveEffect() {
    var {
      _feedbackHideTimeout: e,
      activeStateEnabled: i,
      activeStateUnit: r,
      onInactive: n
    } = this.props, a = r;
    if (i)
      return ble(this.widgetElementRef.current, (o) => {
        this.state.active && (this.setState((u) => ({
          active: !1
        })), n == null || n(o));
      }, {
        timeout: e,
        selector: a
      }, "UIFeedback");
  }
  clickEffect() {
    var {
      disabled: e,
      name: i,
      onClick: r
    } = this.props, n = i;
    if (r && !e)
      return X$.on(this.widgetElementRef.current, r, {
        namespace: n
      }), () => X$.off(this.widgetElementRef.current, {
        namespace: n
      });
  }
  focusInEffect() {
    var {
      disabled: e,
      focusStateEnabled: i,
      name: r,
      onFocusIn: n
    } = this.props, a = "".concat(r, "Focus");
    if (i && !e)
      return Ile(this.widgetElementRef.current, (o) => {
        o.isDefaultPrevented() || (this.setState((u) => ({
          focused: !0
        })), n == null || n(o));
      }, null, a);
  }
  focusOutEffect() {
    var {
      focusStateEnabled: e,
      name: i,
      onFocusOut: r
    } = this.props, n = "".concat(i, "Focus");
    if (e)
      return Dle(this.widgetElementRef.current, (a) => {
        !a.isDefaultPrevented() && this.state.focused && (this.setState((o) => ({
          focused: !1
        })), r == null || r(a));
      }, null, n);
  }
  hoverStartEffect() {
    var {
      activeStateUnit: e,
      disabled: i,
      hoverStateEnabled: r,
      onHoverStart: n
    } = this.props, a = e;
    if (r && !i)
      return wle(this.widgetElementRef.current, (o) => {
        !this.state.active && this.setState((u) => ({
          hovered: !0
        })), n == null || n(o);
      }, {
        selector: a
      }, "UIFeedback");
  }
  hoverEndEffect() {
    var {
      activeStateUnit: e,
      hoverStateEnabled: i,
      onHoverEnd: r
    } = this.props, n = e;
    if (i)
      return Tle(this.widgetElementRef.current, (a) => {
        this.state.hovered && (this.setState((o) => ({
          hovered: !1
        })), r == null || r(a));
      }, {
        selector: n
      }, "UIFeedback");
  }
  keyboardEffect() {
    var {
      focusStateEnabled: e,
      onKeyDown: i
    } = this.props;
    if (e && i) {
      var r = bh.on(this.widgetElementRef.current, this.widgetElementRef.current, (n) => i(n));
      return () => bh.off(r);
    }
  }
  resizeEffect() {
    var e = "".concat(this.props.name, "VisibilityChange"), {
      onDimensionChanged: i
    } = this.props;
    if (i)
      return _T.on(this.widgetElementRef.current, i, {
        namespace: e
      }), () => _T.off(this.widgetElementRef.current, {
        namespace: e
      });
  }
  windowResizeEffect() {
    var {
      onDimensionChanged: e
    } = this.props;
    if (e)
      return Tp.add(e), () => {
        Tp.remove(e);
      };
  }
  visibilityEffect() {
    var {
      name: e,
      onVisibilityChange: i
    } = this.props, r = "".concat(e, "VisibilityChange");
    if (i)
      return CT.on(this.widgetElementRef.current, () => i(!0), () => i(!1), {
        namespace: r
      }), () => CT.off(this.widgetElementRef.current, {
        namespace: r
      });
  }
  checkDeprecation() {
    var {
      height: e,
      width: i
    } = this.props;
    Le(i) && bi.log("W0017", "width"), Le(e) && bi.log("W0017", "height");
  }
  applyCssTextEffect() {
    var {
      cssText: e
    } = this.props;
    e !== "" && (this.widgetElementRef.current.style.cssText = e);
  }
  get shouldRenderConfigProvider() {
    var {
      rtlEnabled: e
    } = this.props;
    return Mle(e, this.config);
  }
  get rtlEnabled() {
    var {
      rtlEnabled: e
    } = this.props;
    return Lle(e, this.config);
  }
  get attributes() {
    var {
      aria: e,
      disabled: i,
      focusStateEnabled: r,
      visible: n
    } = this.props, a = r && !i && this.props.accessKey;
    return ae({}, P({}, a && {
      accessKey: a
    }), Ble(ae({}, e, {
      disabled: i,
      hidden: !n
    })), P({}, this.restAttributes));
  }
  get styles() {
    var {
      height: e,
      width: i
    } = this.props, r = this.restAttributes.style || {}, n = Dm("width", Le(i) ? i() : i), a = Dm("height", Le(e) ? e() : e);
    return ae({}, r, {
      height: a ?? r.height,
      width: n ?? r.width
    });
  }
  get cssClasses() {
    var {
      activeStateEnabled: e,
      addWidgetClass: i,
      className: r,
      classes: n,
      disabled: a,
      focusStateEnabled: o,
      hoverStateEnabled: u,
      onVisibilityChange: c,
      visible: p
    } = this.props, v = !!o && !a, _ = !!u && !a, y = !!e && !a, b = {
      "dx-widget": !!i,
      [String(n)]: !!n,
      [String(r)]: !!r,
      "dx-state-disabled": !!a,
      "dx-state-invisible": !p,
      "dx-state-focused": !!this.state.focused && v,
      "dx-state-active": !!this.state.active && y,
      "dx-state-hover": !!this.state.hovered && _ && !this.state.active,
      "dx-rtl": !!this.rtlEnabled,
      "dx-visibility-change-handler": !!c
    };
    return $s(b);
  }
  get tabIndex() {
    var {
      disabled: e,
      focusStateEnabled: i,
      tabIndex: r
    } = this.props, n = i && !e;
    return n ? r : void 0;
  }
  get restAttributes() {
    var e = this.props, i = sr(e, kle);
    return i;
  }
  focus() {
    zw.trigger(this.widgetElementRef.current);
  }
  blur() {
    var e = de.getActiveElement(this.widgetElementRef.current);
    this.widgetElementRef.current === e && e.blur();
  }
  activate() {
    this.setState((e) => ({
      active: !0
    }));
  }
  deactivate() {
    this.setState((e) => ({
      active: !1
    }));
  }
  render() {
    var e = this.props;
    return Vle({
      props: ae({}, e),
      active: this.state.active,
      focused: this.state.focused,
      hovered: this.state.hovered,
      widgetElementRef: this.widgetElementRef,
      config: this.config,
      shouldRenderConfigProvider: this.shouldRenderConfigProvider,
      rtlEnabled: this.rtlEnabled,
      attributes: this.attributes,
      styles: this.styles,
      cssClasses: this.cssClasses,
      tabIndex: this.tabIndex,
      restAttributes: this.restAttributes
    });
  }
};
gI.defaultProps = ST;
var Nle = ["accessKey", "activeStateEnabled", "children", "className", "disabled", "focusStateEnabled", "height", "hint", "hoverStateEnabled", "icon", "iconPosition", "iconTemplate", "onClick", "onKeyDown", "onSubmit", "pressed", "rtlEnabled", "stylingMode", "tabIndex", "template", "templateData", "text", "type", "useInkRipple", "useSubmitBehavior", "visible", "width"], Hle = ["outlined", "text", "contained"], $le = (t) => {
  var {
    icon: e,
    iconPosition: i,
    stylingMode: r,
    text: n,
    type: a
  } = t, o = r && Hle.includes(r), u = {
    "dx-button": !0,
    ["dx-button-mode-".concat(o ? r : "contained")]: !0,
    ["dx-button-".concat(a ?? "normal")]: !0,
    "dx-button-has-text": !!n,
    "dx-button-has-icon": !!e,
    "dx-button-icon-right": i !== "left"
  };
  return $s(u);
}, zle = (t) => {
  var {
    children: e,
    iconPosition: i,
    iconTemplate: r,
    template: n,
    text: a
  } = t.props, o = !t.props.template && !e && a !== "", u = i === "left", c = !t.props.template && !e && (t.iconSource || t.props.iconTemplate) && zi(2, jY, {
    source: t.iconSource,
    position: i,
    iconTemplate: r
  });
  return Uo(zi(2, gI, ae({
    accessKey: t.props.accessKey,
    activeStateEnabled: t.props.activeStateEnabled,
    aria: t.aria,
    className: t.props.className,
    classes: t.cssClasses,
    disabled: t.props.disabled,
    focusStateEnabled: t.props.focusStateEnabled,
    height: t.props.height,
    hint: t.props.hint,
    hoverStateEnabled: t.props.hoverStateEnabled,
    onActive: t.onActive,
    onClick: t.onWidgetClick,
    onInactive: t.onInactive,
    onKeyDown: t.keyDown,
    rtlEnabled: t.props.rtlEnabled,
    tabIndex: t.props.tabIndex,
    visible: t.props.visible,
    width: t.props.width
  }, t.restAttributes, {
    children: Fr(1, "div", "dx-button-content", [t.props.template && n({
      data: t.buttonTemplateData
    }), !t.props.template && e, u && c, o && Fr(1, "span", "dx-button-text", a, 0), !u && c, t.props.useSubmitBehavior && Fr(64, "input", "dx-button-submit-input", null, 1, {
      type: "submit",
      tabIndex: -1
    }, null, t.submitInputRef), t.props.useInkRipple && zi(2, iq, {
      config: t.inkRippleConfig
    }, null, t.inkRippleRef)], 0, null, null, t.contentRef)
  }), null, t.widgetRef));
}, Wle = Object.create(Object.prototype, ae(Object.getOwnPropertyDescriptors(vI), Object.getOwnPropertyDescriptors({
  activeStateEnabled: !0,
  hoverStateEnabled: !0,
  icon: "",
  iconPosition: "left",
  stylingMode: "contained",
  text: "",
  type: "normal",
  useInkRipple: !1,
  useSubmitBehavior: !1,
  templateData: Object.freeze({})
}))), sq = Qae([{
  device: () => Ye.real().deviceType === "desktop" && !Ye.isSimulator(),
  options: {
    focusStateEnabled: !0
  }
}, {
  device: () => _a(ho()),
  options: {
    useInkRipple: !0
  }
}]), Sz = (t) => t && (t.defaultProps ? (e) => Uo(zi(2, t, ae({}, e))) : t);
let ET = class extends aS {
  constructor(e) {
    super(e), this.state = {}, this.contentRef = Vn(), this.inkRippleRef = Vn(), this.submitInputRef = Vn(), this.widgetRef = Vn(), this.__getterCache = {}, this.focus = this.focus.bind(this), this.activate = this.activate.bind(this), this.deactivate = this.deactivate.bind(this), this.submitEffect = this.submitEffect.bind(this), this.onActive = this.onActive.bind(this), this.onInactive = this.onInactive.bind(this), this.onWidgetClick = this.onWidgetClick.bind(this), this.keyDown = this.keyDown.bind(this), this.emitClickEvent = this.emitClickEvent.bind(this);
  }
  createEffects() {
    return [new ar(this.submitEffect, [this.props.onSubmit, this.props.useSubmitBehavior]), oS()];
  }
  updateEffects() {
    var e;
    (e = this._effects[0]) === null || e === void 0 || e.update([this.props.onSubmit, this.props.useSubmitBehavior]);
  }
  submitEffect() {
    var {
      onSubmit: e,
      useSubmitBehavior: i
    } = this.props;
    if (i && e)
      return Q$.on(this.submitInputRef.current, (r) => e({
        event: r,
        submitInput: this.submitInputRef.current
      }), {
        namespace: "UIFeedback"
      }), () => Q$.off(this.submitInputRef.current, {
        namespace: "UIFeedback"
      });
  }
  onActive(e) {
    var {
      useInkRipple: i
    } = this.props;
    i && this.inkRippleRef.current.showWave({
      element: this.contentRef.current,
      event: e
    });
  }
  onInactive(e) {
    var {
      useInkRipple: i
    } = this.props;
    i && this.inkRippleRef.current.hideWave({
      element: this.contentRef.current,
      event: e
    });
  }
  onWidgetClick(e) {
    var {
      onClick: i,
      useSubmitBehavior: r
    } = this.props;
    i == null || i({
      event: e
    }), r && this.submitInputRef.current.click();
  }
  keyDown(e) {
    var {
      onKeyDown: i
    } = this.props, {
      keyName: r,
      originalEvent: n,
      which: a
    } = e, o = i == null ? void 0 : i(e);
    if (o != null && o.cancel)
      return o;
    (r === "space" || a === "space" || r === "enter" || a === "enter") && (n.preventDefault(), this.emitClickEvent());
  }
  emitClickEvent() {
    this.contentRef.current.click();
  }
  get aria() {
    var {
      icon: e,
      text: i
    } = this.props, r = i ?? "";
    if (!i && e) {
      var n = hS(e);
      switch (n) {
        case "image":
          var a = !e.includes("base64") && /^(?!(?:https?:\/\/)|(?:ftp:\/\/)|(?:www\.))[^\s]+$/.test(e);
          r = a ? e.replace(/.+\/([^.]+)\..+$/, "$1") : "";
          break;
        case "dxIcon":
          r = X.format(Ix(e, !0)) || e;
          break;
        case "fontIcon":
          r = e;
          break;
        case "svg":
          var o, u, c = (o = (u = /<title>(.*?)<\/title>/.exec(e)) === null || u === void 0 ? void 0 : u[1]) !== null && o !== void 0 ? o : "";
          r = c;
      }
    }
    return ae({
      role: "button"
    }, r ? {
      label: r
    } : {});
  }
  get cssClasses() {
    return $le(this.props);
  }
  get iconSource() {
    var {
      icon: e
    } = this.props;
    return e ?? "";
  }
  get inkRippleConfig() {
    return this.__getterCache.inkRippleConfig !== void 0 ? this.__getterCache.inkRippleConfig : this.__getterCache.inkRippleConfig = (() => {
      var {
        icon: e,
        text: i
      } = this.props;
      return !i && e ? {
        isCentered: !0,
        useHoldAnimation: !1,
        waveSizeCoefficient: 1
      } : {};
    })();
  }
  get buttonTemplateData() {
    var {
      icon: e,
      templateData: i,
      text: r
    } = this.props;
    return ae({
      icon: e,
      text: r
    }, i);
  }
  get restAttributes() {
    var e = this.props, i = sr(e, Nle);
    return i;
  }
  focus() {
    this.widgetRef.current.focus();
  }
  activate() {
    this.widgetRef.current.activate();
  }
  deactivate() {
    this.widgetRef.current.deactivate();
  }
  componentWillUpdate(e, i, r) {
    super.componentWillUpdate(), (this.props.icon !== e.icon || this.props.text !== e.text) && (this.__getterCache.inkRippleConfig = void 0);
  }
  render() {
    var e = this.props;
    return zle({
      props: ae({}, e, {
        template: Sz(e.template),
        iconTemplate: Sz(e.iconTemplate)
      }),
      contentRef: this.contentRef,
      submitInputRef: this.submitInputRef,
      inkRippleRef: this.inkRippleRef,
      widgetRef: this.widgetRef,
      onActive: this.onActive,
      onInactive: this.onInactive,
      onWidgetClick: this.onWidgetClick,
      keyDown: this.keyDown,
      emitClickEvent: this.emitClickEvent,
      aria: this.aria,
      cssClasses: this.cssClasses,
      iconSource: this.iconSource,
      inkRippleConfig: this.inkRippleConfig,
      buttonTemplateData: this.buttonTemplateData,
      restAttributes: this.restAttributes
    });
  }
};
ET.defaultProps = Object.create(Object.prototype, ae(Object.getOwnPropertyDescriptors(Wle), Object.getOwnPropertyDescriptors(ae({}, Rm(sq)))));
var Ez = [];
function Ule(t) {
  Ez.push(t), ET.defaultProps = Object.create(Object.prototype, ae(Object.getOwnPropertyDescriptors(ET.defaultProps), Object.getOwnPropertyDescriptors(Rm(sq)), Object.getOwnPropertyDescriptors(Rm(Ez))));
}
let yn = class extends Hse {
  getProps() {
    var e = super.getProps();
    return e.onKeyDown = this._wrapKeyDownHandler(e.onKeyDown), e;
  }
  focus() {
    var e;
    return (e = this.viewRef) === null || e === void 0 ? void 0 : e.focus(...arguments);
  }
  activate() {
    var e;
    return (e = this.viewRef) === null || e === void 0 ? void 0 : e.activate(...arguments);
  }
  deactivate() {
    var e;
    return (e = this.viewRef) === null || e === void 0 ? void 0 : e.deactivate(...arguments);
  }
  _getActionConfigs() {
    return {
      onClick: {
        excludeValidators: ["readOnly"]
      },
      onSubmit: {}
    };
  }
  get _propsInfo() {
    return {
      twoWay: [],
      allowNull: [],
      elements: ["onSubmit"],
      templates: ["template", "iconTemplate"],
      props: ["activeStateEnabled", "hoverStateEnabled", "icon", "iconPosition", "onClick", "onSubmit", "pressed", "stylingMode", "template", "iconTemplate", "text", "type", "useInkRipple", "useSubmitBehavior", "templateData", "className", "accessKey", "disabled", "focusStateEnabled", "height", "hint", "onKeyDown", "rtlEnabled", "tabIndex", "visible", "width"]
    };
  }
  get _viewComponent() {
    return ET;
  }
};
ti("dxButton", yn);
yn.defaultOptions = Ule;
var bT = { exports: {} }, Jy = { exports: {} }, Ji = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bz;
function Gle() {
  if (bz)
    return Ji;
  bz = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, i = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, n = t ? Symbol.for("react.strict_mode") : 60108, a = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, u = t ? Symbol.for("react.context") : 60110, c = t ? Symbol.for("react.async_mode") : 60111, p = t ? Symbol.for("react.concurrent_mode") : 60111, v = t ? Symbol.for("react.forward_ref") : 60112, _ = t ? Symbol.for("react.suspense") : 60113, y = t ? Symbol.for("react.suspense_list") : 60120, b = t ? Symbol.for("react.memo") : 60115, I = t ? Symbol.for("react.lazy") : 60116, A = t ? Symbol.for("react.block") : 60121, L = t ? Symbol.for("react.fundamental") : 60117, B = t ? Symbol.for("react.responder") : 60118, $ = t ? Symbol.for("react.scope") : 60119;
  function K(z) {
    if (typeof z == "object" && z !== null) {
      var ie = z.$$typeof;
      switch (ie) {
        case e:
          switch (z = z.type, z) {
            case c:
            case p:
            case r:
            case a:
            case n:
            case _:
              return z;
            default:
              switch (z = z && z.$$typeof, z) {
                case u:
                case v:
                case I:
                case b:
                case o:
                  return z;
                default:
                  return ie;
              }
          }
        case i:
          return ie;
      }
    }
  }
  function te(z) {
    return K(z) === p;
  }
  return Ji.AsyncMode = c, Ji.ConcurrentMode = p, Ji.ContextConsumer = u, Ji.ContextProvider = o, Ji.Element = e, Ji.ForwardRef = v, Ji.Fragment = r, Ji.Lazy = I, Ji.Memo = b, Ji.Portal = i, Ji.Profiler = a, Ji.StrictMode = n, Ji.Suspense = _, Ji.isAsyncMode = function(z) {
    return te(z) || K(z) === c;
  }, Ji.isConcurrentMode = te, Ji.isContextConsumer = function(z) {
    return K(z) === u;
  }, Ji.isContextProvider = function(z) {
    return K(z) === o;
  }, Ji.isElement = function(z) {
    return typeof z == "object" && z !== null && z.$$typeof === e;
  }, Ji.isForwardRef = function(z) {
    return K(z) === v;
  }, Ji.isFragment = function(z) {
    return K(z) === r;
  }, Ji.isLazy = function(z) {
    return K(z) === I;
  }, Ji.isMemo = function(z) {
    return K(z) === b;
  }, Ji.isPortal = function(z) {
    return K(z) === i;
  }, Ji.isProfiler = function(z) {
    return K(z) === a;
  }, Ji.isStrictMode = function(z) {
    return K(z) === n;
  }, Ji.isSuspense = function(z) {
    return K(z) === _;
  }, Ji.isValidElementType = function(z) {
    return typeof z == "string" || typeof z == "function" || z === r || z === p || z === a || z === n || z === _ || z === y || typeof z == "object" && z !== null && (z.$$typeof === I || z.$$typeof === b || z.$$typeof === o || z.$$typeof === u || z.$$typeof === v || z.$$typeof === L || z.$$typeof === B || z.$$typeof === $ || z.$$typeof === A);
  }, Ji.typeOf = K, Ji;
}
var er = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wz;
function Kle() {
  return wz || (wz = 1, process.env.NODE_ENV !== "production" && function() {
    "use strict";
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, i = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, n = t ? Symbol.for("react.strict_mode") : 60108, a = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, u = t ? Symbol.for("react.context") : 60110, c = t ? Symbol.for("react.async_mode") : 60111, p = t ? Symbol.for("react.concurrent_mode") : 60111, v = t ? Symbol.for("react.forward_ref") : 60112, _ = t ? Symbol.for("react.suspense") : 60113, y = t ? Symbol.for("react.suspense_list") : 60120, b = t ? Symbol.for("react.memo") : 60115, I = t ? Symbol.for("react.lazy") : 60116, A = t ? Symbol.for("react.block") : 60121, L = t ? Symbol.for("react.fundamental") : 60117, B = t ? Symbol.for("react.responder") : 60118, $ = t ? Symbol.for("react.scope") : 60119;
    function K(Ie) {
      return typeof Ie == "string" || typeof Ie == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Ie === r || Ie === p || Ie === a || Ie === n || Ie === _ || Ie === y || typeof Ie == "object" && Ie !== null && (Ie.$$typeof === I || Ie.$$typeof === b || Ie.$$typeof === o || Ie.$$typeof === u || Ie.$$typeof === v || Ie.$$typeof === L || Ie.$$typeof === B || Ie.$$typeof === $ || Ie.$$typeof === A);
    }
    function te(Ie) {
      if (typeof Ie == "object" && Ie !== null) {
        var gt = Ie.$$typeof;
        switch (gt) {
          case e:
            var si = Ie.type;
            switch (si) {
              case c:
              case p:
              case r:
              case a:
              case n:
              case _:
                return si;
              default:
                var Wt = si && si.$$typeof;
                switch (Wt) {
                  case u:
                  case v:
                  case I:
                  case b:
                  case o:
                    return Wt;
                  default:
                    return gt;
                }
            }
          case i:
            return gt;
        }
      }
    }
    var z = c, ie = p, pe = u, _e = o, be = e, De = v, Ce = r, ft = I, Ve = b, Ee = i, Re = a, we = n, We = _, ne = !1;
    function Ae(Ie) {
      return ne || (ne = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), j(Ie) || te(Ie) === c;
    }
    function j(Ie) {
      return te(Ie) === p;
    }
    function ge(Ie) {
      return te(Ie) === u;
    }
    function Me(Ie) {
      return te(Ie) === o;
    }
    function ze(Ie) {
      return typeof Ie == "object" && Ie !== null && Ie.$$typeof === e;
    }
    function je(Ie) {
      return te(Ie) === v;
    }
    function vt(Ie) {
      return te(Ie) === r;
    }
    function Je(Ie) {
      return te(Ie) === I;
    }
    function _t(Ie) {
      return te(Ie) === b;
    }
    function at(Ie) {
      return te(Ie) === i;
    }
    function yt(Ie) {
      return te(Ie) === a;
    }
    function tt(Ie) {
      return te(Ie) === n;
    }
    function zt(Ie) {
      return te(Ie) === _;
    }
    er.AsyncMode = z, er.ConcurrentMode = ie, er.ContextConsumer = pe, er.ContextProvider = _e, er.Element = be, er.ForwardRef = De, er.Fragment = Ce, er.Lazy = ft, er.Memo = Ve, er.Portal = Ee, er.Profiler = Re, er.StrictMode = we, er.Suspense = We, er.isAsyncMode = Ae, er.isConcurrentMode = j, er.isContextConsumer = ge, er.isContextProvider = Me, er.isElement = ze, er.isForwardRef = je, er.isFragment = vt, er.isLazy = Je, er.isMemo = _t, er.isPortal = at, er.isProfiler = yt, er.isStrictMode = tt, er.isSuspense = zt, er.isValidElementType = K, er.typeOf = te;
  }()), er;
}
var xVe = Jy.exports, Tz;
function lq() {
  return Tz || (Tz = 1, process.env.NODE_ENV === "production" ? Jy.exports = Gle() : Jy.exports = Kle()), Jy.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var GR, Iz;
function jle() {
  if (Iz)
    return GR;
  Iz = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, u = 0; u < 10; u++)
        o["_" + String.fromCharCode(u)] = u;
      var c = Object.getOwnPropertyNames(o).map(function(v) {
        return o[v];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(v) {
        p[v] = v;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return GR = n() ? Object.assign : function(a, o) {
    for (var u, c = r(a), p, v = 1; v < arguments.length; v++) {
      u = Object(arguments[v]);
      for (var _ in u)
        e.call(u, _) && (c[_] = u[_]);
      if (t) {
        p = t(u);
        for (var y = 0; y < p.length; y++)
          i.call(u, p[y]) && (c[p[y]] = u[p[y]]);
      }
    }
    return c;
  }, GR;
}
var KR, Dz;
function KF() {
  if (Dz)
    return KR;
  Dz = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return KR = t, KR;
}
var jR, Az;
function uq() {
  return Az || (Az = 1, jR = Function.call.bind(Object.prototype.hasOwnProperty)), jR;
}
var YR, Oz;
function Yle() {
  if (Oz)
    return YR;
  Oz = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = KF(), i = {}, r = uq();
    t = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function n(a, o, u, c, p) {
    if (process.env.NODE_ENV !== "production") {
      for (var v in a)
        if (r(a, v)) {
          var _;
          try {
            if (typeof a[v] != "function") {
              var y = Error(
                (c || "React class") + ": " + u + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw y.name = "Invariant Violation", y;
            }
            _ = a[v](o, v, c, u, null, e);
          } catch (I) {
            _ = I;
          }
          if (_ && !(_ instanceof Error) && t(
            (c || "React class") + ": type specification of " + u + " `" + v + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof _ + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), _ instanceof Error && !(_.message in i)) {
            i[_.message] = !0;
            var b = p ? p() : "";
            t(
              "Failed " + u + " type: " + _.message + (b ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (i = {});
  }, YR = n, YR;
}
var qR, Rz;
function qle() {
  if (Rz)
    return qR;
  Rz = 1;
  var t = lq(), e = jle(), i = KF(), r = uq(), n = Yle(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(u) {
    var c = "Warning: " + u;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return qR = function(u, c) {
    var p = typeof Symbol == "function" && Symbol.iterator, v = "@@iterator";
    function _(j) {
      var ge = j && (p && j[p] || j[v]);
      if (typeof ge == "function")
        return ge;
    }
    var y = "<<anonymous>>", b = {
      array: B("array"),
      bigint: B("bigint"),
      bool: B("boolean"),
      func: B("function"),
      number: B("number"),
      object: B("object"),
      string: B("string"),
      symbol: B("symbol"),
      any: $(),
      arrayOf: K,
      element: te(),
      elementType: z(),
      instanceOf: ie,
      node: De(),
      objectOf: _e,
      oneOf: pe,
      oneOfType: be,
      shape: ft,
      exact: Ve
    };
    function I(j, ge) {
      return j === ge ? j !== 0 || 1 / j === 1 / ge : j !== j && ge !== ge;
    }
    function A(j, ge) {
      this.message = j, this.data = ge && typeof ge == "object" ? ge : {}, this.stack = "";
    }
    A.prototype = Error.prototype;
    function L(j) {
      if (process.env.NODE_ENV !== "production")
        var ge = {}, Me = 0;
      function ze(vt, Je, _t, at, yt, tt, zt) {
        if (at = at || y, tt = tt || _t, zt !== i) {
          if (c) {
            var Ie = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Ie.name = "Invariant Violation", Ie;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var gt = at + ":" + _t;
            !ge[gt] && // Avoid spamming the console because they are often not actionable except for lib authors
            Me < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + tt + "` prop on `" + at + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), ge[gt] = !0, Me++);
          }
        }
        return Je[_t] == null ? vt ? Je[_t] === null ? new A("The " + yt + " `" + tt + "` is marked as required " + ("in `" + at + "`, but its value is `null`.")) : new A("The " + yt + " `" + tt + "` is marked as required in " + ("`" + at + "`, but its value is `undefined`.")) : null : j(Je, _t, at, yt, tt);
      }
      var je = ze.bind(null, !1);
      return je.isRequired = ze.bind(null, !0), je;
    }
    function B(j) {
      function ge(Me, ze, je, vt, Je, _t) {
        var at = Me[ze], yt = we(at);
        if (yt !== j) {
          var tt = We(at);
          return new A(
            "Invalid " + vt + " `" + Je + "` of type " + ("`" + tt + "` supplied to `" + je + "`, expected ") + ("`" + j + "`."),
            { expectedType: j }
          );
        }
        return null;
      }
      return L(ge);
    }
    function $() {
      return L(o);
    }
    function K(j) {
      function ge(Me, ze, je, vt, Je) {
        if (typeof j != "function")
          return new A("Property `" + Je + "` of component `" + je + "` has invalid PropType notation inside arrayOf.");
        var _t = Me[ze];
        if (!Array.isArray(_t)) {
          var at = we(_t);
          return new A("Invalid " + vt + " `" + Je + "` of type " + ("`" + at + "` supplied to `" + je + "`, expected an array."));
        }
        for (var yt = 0; yt < _t.length; yt++) {
          var tt = j(_t, yt, je, vt, Je + "[" + yt + "]", i);
          if (tt instanceof Error)
            return tt;
        }
        return null;
      }
      return L(ge);
    }
    function te() {
      function j(ge, Me, ze, je, vt) {
        var Je = ge[Me];
        if (!u(Je)) {
          var _t = we(Je);
          return new A("Invalid " + je + " `" + vt + "` of type " + ("`" + _t + "` supplied to `" + ze + "`, expected a single ReactElement."));
        }
        return null;
      }
      return L(j);
    }
    function z() {
      function j(ge, Me, ze, je, vt) {
        var Je = ge[Me];
        if (!t.isValidElementType(Je)) {
          var _t = we(Je);
          return new A("Invalid " + je + " `" + vt + "` of type " + ("`" + _t + "` supplied to `" + ze + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return L(j);
    }
    function ie(j) {
      function ge(Me, ze, je, vt, Je) {
        if (!(Me[ze] instanceof j)) {
          var _t = j.name || y, at = Ae(Me[ze]);
          return new A("Invalid " + vt + " `" + Je + "` of type " + ("`" + at + "` supplied to `" + je + "`, expected ") + ("instance of `" + _t + "`."));
        }
        return null;
      }
      return L(ge);
    }
    function pe(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function ge(Me, ze, je, vt, Je) {
        for (var _t = Me[ze], at = 0; at < j.length; at++)
          if (I(_t, j[at]))
            return null;
        var yt = JSON.stringify(j, function(zt, Ie) {
          var gt = We(Ie);
          return gt === "symbol" ? String(Ie) : Ie;
        });
        return new A("Invalid " + vt + " `" + Je + "` of value `" + String(_t) + "` " + ("supplied to `" + je + "`, expected one of " + yt + "."));
      }
      return L(ge);
    }
    function _e(j) {
      function ge(Me, ze, je, vt, Je) {
        if (typeof j != "function")
          return new A("Property `" + Je + "` of component `" + je + "` has invalid PropType notation inside objectOf.");
        var _t = Me[ze], at = we(_t);
        if (at !== "object")
          return new A("Invalid " + vt + " `" + Je + "` of type " + ("`" + at + "` supplied to `" + je + "`, expected an object."));
        for (var yt in _t)
          if (r(_t, yt)) {
            var tt = j(_t, yt, je, vt, Je + "." + yt, i);
            if (tt instanceof Error)
              return tt;
          }
        return null;
      }
      return L(ge);
    }
    function be(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var ge = 0; ge < j.length; ge++) {
        var Me = j[ge];
        if (typeof Me != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ne(Me) + " at index " + ge + "."
          ), o;
      }
      function ze(je, vt, Je, _t, at) {
        for (var yt = [], tt = 0; tt < j.length; tt++) {
          var zt = j[tt], Ie = zt(je, vt, Je, _t, at, i);
          if (Ie == null)
            return null;
          Ie.data && r(Ie.data, "expectedType") && yt.push(Ie.data.expectedType);
        }
        var gt = yt.length > 0 ? ", expected one of type [" + yt.join(", ") + "]" : "";
        return new A("Invalid " + _t + " `" + at + "` supplied to " + ("`" + Je + "`" + gt + "."));
      }
      return L(ze);
    }
    function De() {
      function j(ge, Me, ze, je, vt) {
        return Ee(ge[Me]) ? null : new A("Invalid " + je + " `" + vt + "` supplied to " + ("`" + ze + "`, expected a ReactNode."));
      }
      return L(j);
    }
    function Ce(j, ge, Me, ze, je) {
      return new A(
        (j || "React class") + ": " + ge + " type `" + Me + "." + ze + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + je + "`."
      );
    }
    function ft(j) {
      function ge(Me, ze, je, vt, Je) {
        var _t = Me[ze], at = we(_t);
        if (at !== "object")
          return new A("Invalid " + vt + " `" + Je + "` of type `" + at + "` " + ("supplied to `" + je + "`, expected `object`."));
        for (var yt in j) {
          var tt = j[yt];
          if (typeof tt != "function")
            return Ce(je, vt, Je, yt, We(tt));
          var zt = tt(_t, yt, je, vt, Je + "." + yt, i);
          if (zt)
            return zt;
        }
        return null;
      }
      return L(ge);
    }
    function Ve(j) {
      function ge(Me, ze, je, vt, Je) {
        var _t = Me[ze], at = we(_t);
        if (at !== "object")
          return new A("Invalid " + vt + " `" + Je + "` of type `" + at + "` " + ("supplied to `" + je + "`, expected `object`."));
        var yt = e({}, Me[ze], j);
        for (var tt in yt) {
          var zt = j[tt];
          if (r(j, tt) && typeof zt != "function")
            return Ce(je, vt, Je, tt, We(zt));
          if (!zt)
            return new A(
              "Invalid " + vt + " `" + Je + "` key `" + tt + "` supplied to `" + je + "`.\nBad object: " + JSON.stringify(Me[ze], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(j), null, "  ")
            );
          var Ie = zt(_t, tt, je, vt, Je + "." + tt, i);
          if (Ie)
            return Ie;
        }
        return null;
      }
      return L(ge);
    }
    function Ee(j) {
      switch (typeof j) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !j;
        case "object":
          if (Array.isArray(j))
            return j.every(Ee);
          if (j === null || u(j))
            return !0;
          var ge = _(j);
          if (ge) {
            var Me = ge.call(j), ze;
            if (ge !== j.entries) {
              for (; !(ze = Me.next()).done; )
                if (!Ee(ze.value))
                  return !1;
            } else
              for (; !(ze = Me.next()).done; ) {
                var je = ze.value;
                if (je && !Ee(je[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Re(j, ge) {
      return j === "symbol" ? !0 : ge ? ge["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ge instanceof Symbol : !1;
    }
    function we(j) {
      var ge = typeof j;
      return Array.isArray(j) ? "array" : j instanceof RegExp ? "object" : Re(ge, j) ? "symbol" : ge;
    }
    function We(j) {
      if (typeof j > "u" || j === null)
        return "" + j;
      var ge = we(j);
      if (ge === "object") {
        if (j instanceof Date)
          return "date";
        if (j instanceof RegExp)
          return "regexp";
      }
      return ge;
    }
    function ne(j) {
      var ge = We(j);
      switch (ge) {
        case "array":
        case "object":
          return "an " + ge;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ge;
        default:
          return ge;
      }
    }
    function Ae(j) {
      return !j.constructor || !j.constructor.name ? y : j.constructor.name;
    }
    return b.checkPropTypes = n, b.resetWarningCache = n.resetWarningCache, b.PropTypes = b, b;
  }, qR;
}
var XR, Lz;
function Xle() {
  if (Lz)
    return XR;
  Lz = 1;
  var t = KF();
  function e() {
  }
  function i() {
  }
  return i.resetWarningCache = e, XR = function() {
    function r(o, u, c, p, v, _) {
      if (_ !== t) {
        var y = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw y.name = "Invariant Violation", y;
      }
    }
    r.isRequired = r;
    function n() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: n,
      element: r,
      elementType: r,
      instanceOf: n,
      node: r,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: i,
      resetWarningCache: e
    };
    return a.PropTypes = a, a;
  }, XR;
}
var SVe = bT.exports;
if (process.env.NODE_ENV !== "production") {
  var Qle = lq(), Zle = !0;
  bT.exports = qle()(Qle.isElement, Zle);
} else
  bT.exports = Xle()();
var re = bT.exports;
var zk = k.on, EVe = k.one, um = k.off, bVe = k.trigger, Jle = k.triggerHandler, wVe = k.Event, wT = { exports: {} }, ko = {}, ex = { exports: {} }, QR = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mz;
function eue() {
  return Mz || (Mz = 1, function(t) {
    "use strict";
    function e(ne, Ae) {
      var j = ne.length;
      ne.push(Ae);
      e:
        for (; 0 < j; ) {
          var ge = j - 1 >>> 1, Me = ne[ge];
          if (0 < n(Me, Ae))
            ne[ge] = Ae, ne[j] = Me, j = ge;
          else
            break e;
        }
    }
    function i(ne) {
      return ne.length === 0 ? null : ne[0];
    }
    function r(ne) {
      if (ne.length === 0)
        return null;
      var Ae = ne[0], j = ne.pop();
      if (j !== Ae) {
        ne[0] = j;
        e:
          for (var ge = 0, Me = ne.length, ze = Me >>> 1; ge < ze; ) {
            var je = 2 * (ge + 1) - 1, vt = ne[je], Je = je + 1, _t = ne[Je];
            if (0 > n(vt, j))
              Je < Me && 0 > n(_t, vt) ? (ne[ge] = _t, ne[Je] = j, ge = Je) : (ne[ge] = vt, ne[je] = j, ge = je);
            else if (Je < Me && 0 > n(_t, j))
              ne[ge] = _t, ne[Je] = j, ge = Je;
            else
              break e;
          }
      }
      return Ae;
    }
    function n(ne, Ae) {
      var j = ne.sortIndex - Ae.sortIndex;
      return j !== 0 ? j : ne.id - Ae.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var a = performance;
      t.unstable_now = function() {
        return a.now();
      };
    } else {
      var o = Date, u = o.now();
      t.unstable_now = function() {
        return o.now() - u;
      };
    }
    var c = [], p = [], v = 1, _ = null, y = 3, b = !1, I = !1, A = !1, L = typeof setTimeout == "function" ? setTimeout : null, B = typeof clearTimeout == "function" ? clearTimeout : null, $ = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function K(ne) {
      for (var Ae = i(p); Ae !== null; ) {
        if (Ae.callback === null)
          r(p);
        else if (Ae.startTime <= ne)
          r(p), Ae.sortIndex = Ae.expirationTime, e(c, Ae);
        else
          break;
        Ae = i(p);
      }
    }
    function te(ne) {
      if (A = !1, K(ne), !I)
        if (i(c) !== null)
          I = !0, we(z);
        else {
          var Ae = i(p);
          Ae !== null && We(te, Ae.startTime - ne);
        }
    }
    function z(ne, Ae) {
      I = !1, A && (A = !1, B(_e), _e = -1), b = !0;
      var j = y;
      try {
        for (K(Ae), _ = i(c); _ !== null && (!(_.expirationTime > Ae) || ne && !Ce()); ) {
          var ge = _.callback;
          if (typeof ge == "function") {
            _.callback = null, y = _.priorityLevel;
            var Me = ge(_.expirationTime <= Ae);
            Ae = t.unstable_now(), typeof Me == "function" ? _.callback = Me : _ === i(c) && r(c), K(Ae);
          } else
            r(c);
          _ = i(c);
        }
        if (_ !== null)
          var ze = !0;
        else {
          var je = i(p);
          je !== null && We(te, je.startTime - Ae), ze = !1;
        }
        return ze;
      } finally {
        _ = null, y = j, b = !1;
      }
    }
    var ie = !1, pe = null, _e = -1, be = 5, De = -1;
    function Ce() {
      return !(t.unstable_now() - De < be);
    }
    function ft() {
      if (pe !== null) {
        var ne = t.unstable_now();
        De = ne;
        var Ae = !0;
        try {
          Ae = pe(!0, ne);
        } finally {
          Ae ? Ve() : (ie = !1, pe = null);
        }
      } else
        ie = !1;
    }
    var Ve;
    if (typeof $ == "function")
      Ve = function() {
        $(ft);
      };
    else if (typeof MessageChannel < "u") {
      var Ee = new MessageChannel(), Re = Ee.port2;
      Ee.port1.onmessage = ft, Ve = function() {
        Re.postMessage(null);
      };
    } else
      Ve = function() {
        L(ft, 0);
      };
    function we(ne) {
      pe = ne, ie || (ie = !0, Ve());
    }
    function We(ne, Ae) {
      _e = L(function() {
        ne(t.unstable_now());
      }, Ae);
    }
    t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(ne) {
      ne.callback = null;
    }, t.unstable_continueExecution = function() {
      I || b || (I = !0, we(z));
    }, t.unstable_forceFrameRate = function(ne) {
      0 > ne || 125 < ne ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : be = 0 < ne ? Math.floor(1e3 / ne) : 5;
    }, t.unstable_getCurrentPriorityLevel = function() {
      return y;
    }, t.unstable_getFirstCallbackNode = function() {
      return i(c);
    }, t.unstable_next = function(ne) {
      switch (y) {
        case 1:
        case 2:
        case 3:
          var Ae = 3;
          break;
        default:
          Ae = y;
      }
      var j = y;
      y = Ae;
      try {
        return ne();
      } finally {
        y = j;
      }
    }, t.unstable_pauseExecution = function() {
    }, t.unstable_requestPaint = function() {
    }, t.unstable_runWithPriority = function(ne, Ae) {
      switch (ne) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          ne = 3;
      }
      var j = y;
      y = ne;
      try {
        return Ae();
      } finally {
        y = j;
      }
    }, t.unstable_scheduleCallback = function(ne, Ae, j) {
      var ge = t.unstable_now();
      switch (typeof j == "object" && j !== null ? (j = j.delay, j = typeof j == "number" && 0 < j ? ge + j : ge) : j = ge, ne) {
        case 1:
          var Me = -1;
          break;
        case 2:
          Me = 250;
          break;
        case 5:
          Me = 1073741823;
          break;
        case 4:
          Me = 1e4;
          break;
        default:
          Me = 5e3;
      }
      return Me = j + Me, ne = { id: v++, callback: Ae, priorityLevel: ne, startTime: j, expirationTime: Me, sortIndex: -1 }, j > ge ? (ne.sortIndex = j, e(p, ne), i(c) === null && ne === i(p) && (A ? (B(_e), _e = -1) : A = !0, We(te, j - ge))) : (ne.sortIndex = Me, e(c, ne), I || b || (I = !0, we(z))), ne;
    }, t.unstable_shouldYield = Ce, t.unstable_wrapCallback = function(ne) {
      var Ae = y;
      return function() {
        var j = y;
        y = Ae;
        try {
          return ne.apply(this, arguments);
        } finally {
          y = j;
        }
      };
    };
  }(QR)), QR;
}
var ZR = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kz;
function tue() {
  return kz || (kz = 1, function(t) {
    "use strict";
    process.env.NODE_ENV !== "production" && function() {
      "use strict";
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var e = !1, i = !1, r = 5;
      function n(nt, Rt) {
        var ii = nt.length;
        nt.push(Rt), u(nt, Rt, ii);
      }
      function a(nt) {
        return nt.length === 0 ? null : nt[0];
      }
      function o(nt) {
        if (nt.length === 0)
          return null;
        var Rt = nt[0], ii = nt.pop();
        return ii !== Rt && (nt[0] = ii, c(nt, ii, 0)), Rt;
      }
      function u(nt, Rt, ii) {
        for (var Pi = ii; Pi > 0; ) {
          var Ui = Pi - 1 >>> 1, Br = nt[Ui];
          if (p(Br, Rt) > 0)
            nt[Ui] = Rt, nt[Pi] = Br, Pi = Ui;
          else
            return;
        }
      }
      function c(nt, Rt, ii) {
        for (var Pi = ii, Ui = nt.length, Br = Ui >>> 1; Pi < Br; ) {
          var fr = (Pi + 1) * 2 - 1, Lr = nt[fr], ur = fr + 1, Ti = nt[ur];
          if (p(Lr, Rt) < 0)
            ur < Ui && p(Ti, Lr) < 0 ? (nt[Pi] = Ti, nt[ur] = Rt, Pi = ur) : (nt[Pi] = Lr, nt[fr] = Rt, Pi = fr);
          else if (ur < Ui && p(Ti, Rt) < 0)
            nt[Pi] = Ti, nt[ur] = Rt, Pi = ur;
          else
            return;
        }
      }
      function p(nt, Rt) {
        var ii = nt.sortIndex - Rt.sortIndex;
        return ii !== 0 ? ii : nt.id - Rt.id;
      }
      var v = 1, _ = 2, y = 3, b = 4, I = 5;
      function A(nt, Rt) {
      }
      var L = typeof performance == "object" && typeof performance.now == "function";
      if (L) {
        var B = performance;
        t.unstable_now = function() {
          return B.now();
        };
      } else {
        var $ = Date, K = $.now();
        t.unstable_now = function() {
          return $.now() - K;
        };
      }
      var te = 1073741823, z = -1, ie = 250, pe = 5e3, _e = 1e4, be = te, De = [], Ce = [], ft = 1, Ve = null, Ee = y, Re = !1, we = !1, We = !1, ne = typeof setTimeout == "function" ? setTimeout : null, Ae = typeof clearTimeout == "function" ? clearTimeout : null, j = typeof setImmediate < "u" ? setImmediate : null, ge = typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
      function Me(nt) {
        for (var Rt = a(Ce); Rt !== null; ) {
          if (Rt.callback === null)
            o(Ce);
          else if (Rt.startTime <= nt)
            o(Ce), Rt.sortIndex = Rt.expirationTime, n(De, Rt);
          else
            return;
          Rt = a(Ce);
        }
      }
      function ze(nt) {
        if (We = !1, Me(nt), !we)
          if (a(De) !== null)
            we = !0, hr(je);
          else {
            var Rt = a(Ce);
            Rt !== null && Wr(ze, Rt.startTime - nt);
          }
      }
      function je(nt, Rt) {
        we = !1, We && (We = !1, Go()), Re = !0;
        var ii = Ee;
        try {
          if (i)
            try {
              return vt(nt, Rt);
            } catch (Ui) {
              if (Ve !== null) {
                var Pi = t.unstable_now();
                Ve.isQueued = !1;
              }
              throw Ui;
            }
          else
            return vt(nt, Rt);
        } finally {
          Ve = null, Ee = ii, Re = !1;
        }
      }
      function vt(nt, Rt) {
        var ii = Rt;
        for (Me(ii), Ve = a(De); Ve !== null && !e && !(Ve.expirationTime > ii && (!nt || Rr())); ) {
          var Pi = Ve.callback;
          if (typeof Pi == "function") {
            Ve.callback = null, Ee = Ve.priorityLevel;
            var Ui = Ve.expirationTime <= ii, Br = Pi(Ui);
            ii = t.unstable_now(), typeof Br == "function" ? Ve.callback = Br : Ve === a(De) && o(De), Me(ii);
          } else
            o(De);
          Ve = a(De);
        }
        if (Ve !== null)
          return !0;
        var fr = a(Ce);
        return fr !== null && Wr(ze, fr.startTime - ii), !1;
      }
      function Je(nt, Rt) {
        switch (nt) {
          case v:
          case _:
          case y:
          case b:
          case I:
            break;
          default:
            nt = y;
        }
        var ii = Ee;
        Ee = nt;
        try {
          return Rt();
        } finally {
          Ee = ii;
        }
      }
      function _t(nt) {
        var Rt;
        switch (Ee) {
          case v:
          case _:
          case y:
            Rt = y;
            break;
          default:
            Rt = Ee;
            break;
        }
        var ii = Ee;
        Ee = Rt;
        try {
          return nt();
        } finally {
          Ee = ii;
        }
      }
      function at(nt) {
        var Rt = Ee;
        return function() {
          var ii = Ee;
          Ee = Rt;
          try {
            return nt.apply(this, arguments);
          } finally {
            Ee = ii;
          }
        };
      }
      function yt(nt, Rt, ii) {
        var Pi = t.unstable_now(), Ui;
        if (typeof ii == "object" && ii !== null) {
          var Br = ii.delay;
          typeof Br == "number" && Br > 0 ? Ui = Pi + Br : Ui = Pi;
        } else
          Ui = Pi;
        var fr;
        switch (nt) {
          case v:
            fr = z;
            break;
          case _:
            fr = ie;
            break;
          case I:
            fr = be;
            break;
          case b:
            fr = _e;
            break;
          case y:
          default:
            fr = pe;
            break;
        }
        var Lr = Ui + fr, ur = {
          id: ft++,
          callback: Rt,
          priorityLevel: nt,
          startTime: Ui,
          expirationTime: Lr,
          sortIndex: -1
        };
        return Ui > Pi ? (ur.sortIndex = Ui, n(Ce, ur), a(De) === null && ur === a(Ce) && (We ? Go() : We = !0, Wr(ze, Ui - Pi))) : (ur.sortIndex = Lr, n(De, ur), !we && !Re && (we = !0, hr(je))), ur;
      }
      function tt() {
      }
      function zt() {
        !we && !Re && (we = !0, hr(je));
      }
      function Ie() {
        return a(De);
      }
      function gt(nt) {
        nt.callback = null;
      }
      function si() {
        return Ee;
      }
      var Wt = !1, ki = null, lr = -1, mi = r, Wi = -1;
      function Rr() {
        var nt = t.unstable_now() - Wi;
        return !(nt < mi);
      }
      function ia() {
      }
      function ra(nt) {
        if (nt < 0 || nt > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        nt > 0 ? mi = Math.floor(1e3 / nt) : mi = r;
      }
      var zn = function() {
        if (ki !== null) {
          var nt = t.unstable_now();
          Wi = nt;
          var Rt = !0, ii = !0;
          try {
            ii = ki(Rt, nt);
          } finally {
            ii ? Yi() : (Wt = !1, ki = null);
          }
        } else
          Wt = !1;
      }, Yi;
      if (typeof j == "function")
        Yi = function() {
          j(zn);
        };
      else if (typeof MessageChannel < "u") {
        var tr = new MessageChannel(), cn = tr.port2;
        tr.port1.onmessage = zn, Yi = function() {
          cn.postMessage(null);
        };
      } else
        Yi = function() {
          ne(zn, 0);
        };
      function hr(nt) {
        ki = nt, Wt || (Wt = !0, Yi());
      }
      function Wr(nt, Rt) {
        lr = ne(function() {
          nt(t.unstable_now());
        }, Rt);
      }
      function Go() {
        Ae(lr), lr = -1;
      }
      var Wa = ia, Ca = null;
      t.unstable_IdlePriority = I, t.unstable_ImmediatePriority = v, t.unstable_LowPriority = b, t.unstable_NormalPriority = y, t.unstable_Profiling = Ca, t.unstable_UserBlockingPriority = _, t.unstable_cancelCallback = gt, t.unstable_continueExecution = zt, t.unstable_forceFrameRate = ra, t.unstable_getCurrentPriorityLevel = si, t.unstable_getFirstCallbackNode = Ie, t.unstable_next = _t, t.unstable_pauseExecution = tt, t.unstable_requestPaint = Wa, t.unstable_runWithPriority = Je, t.unstable_scheduleCallback = yt, t.unstable_shouldYield = Rr, t.unstable_wrapCallback = at, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(ZR)), ZR;
}
var TVe = ex.exports, Pz;
function dq() {
  return Pz || (Pz = 1, process.env.NODE_ENV === "production" ? ex.exports = eue() : ex.exports = tue()), ex.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fz;
function iue() {
  if (Fz)
    return ko;
  Fz = 1;
  var t = nc, e = dq();
  function i(d) {
    for (var h = "https://reactjs.org/docs/error-decoder.html?invariant=" + d, m = 1; m < arguments.length; m++)
      h += "&args[]=" + encodeURIComponent(arguments[m]);
    return "Minified React error #" + d + "; visit " + h + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var r = /* @__PURE__ */ new Set(), n = {};
  function a(d, h) {
    o(d, h), o(d + "Capture", h);
  }
  function o(d, h) {
    for (n[d] = h, d = 0; d < h.length; d++)
      r.add(h[d]);
  }
  var u = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), c = Object.prototype.hasOwnProperty, p = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, v = {}, _ = {};
  function y(d) {
    return c.call(_, d) ? !0 : c.call(v, d) ? !1 : p.test(d) ? _[d] = !0 : (v[d] = !0, !1);
  }
  function b(d, h, m, x) {
    if (m !== null && m.type === 0)
      return !1;
    switch (typeof h) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return x ? !1 : m !== null ? !m.acceptsBooleans : (d = d.toLowerCase().slice(0, 5), d !== "data-" && d !== "aria-");
      default:
        return !1;
    }
  }
  function I(d, h, m, x) {
    if (h === null || typeof h > "u" || b(d, h, m, x))
      return !0;
    if (x)
      return !1;
    if (m !== null)
      switch (m.type) {
        case 3:
          return !h;
        case 4:
          return h === !1;
        case 5:
          return isNaN(h);
        case 6:
          return isNaN(h) || 1 > h;
      }
    return !1;
  }
  function A(d, h, m, x, w, D, F) {
    this.acceptsBooleans = h === 2 || h === 3 || h === 4, this.attributeName = x, this.attributeNamespace = w, this.mustUseProperty = m, this.propertyName = d, this.type = h, this.sanitizeURL = D, this.removeEmptyString = F;
  }
  var L = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(d) {
    L[d] = new A(d, 0, !1, d, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(d) {
    var h = d[0];
    L[h] = new A(h, 1, !1, d[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(d) {
    L[d] = new A(d, 2, !1, d.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(d) {
    L[d] = new A(d, 2, !1, d, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(d) {
    L[d] = new A(d, 3, !1, d.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(d) {
    L[d] = new A(d, 3, !0, d, null, !1, !1);
  }), ["capture", "download"].forEach(function(d) {
    L[d] = new A(d, 4, !1, d, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(d) {
    L[d] = new A(d, 6, !1, d, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(d) {
    L[d] = new A(d, 5, !1, d.toLowerCase(), null, !1, !1);
  });
  var B = /[\-:]([a-z])/g;
  function $(d) {
    return d[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(d) {
    var h = d.replace(
      B,
      $
    );
    L[h] = new A(h, 1, !1, d, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(d) {
    var h = d.replace(B, $);
    L[h] = new A(h, 1, !1, d, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(d) {
    var h = d.replace(B, $);
    L[h] = new A(h, 1, !1, d, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(d) {
    L[d] = new A(d, 1, !1, d.toLowerCase(), null, !1, !1);
  }), L.xlinkHref = new A("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(d) {
    L[d] = new A(d, 1, !1, d.toLowerCase(), null, !0, !0);
  });
  function K(d, h, m, x) {
    var w = L.hasOwnProperty(h) ? L[h] : null;
    (w !== null ? w.type !== 0 : x || !(2 < h.length) || h[0] !== "o" && h[0] !== "O" || h[1] !== "n" && h[1] !== "N") && (I(h, m, w, x) && (m = null), x || w === null ? y(h) && (m === null ? d.removeAttribute(h) : d.setAttribute(h, "" + m)) : w.mustUseProperty ? d[w.propertyName] = m === null ? w.type === 3 ? !1 : "" : m : (h = w.attributeName, x = w.attributeNamespace, m === null ? d.removeAttribute(h) : (w = w.type, m = w === 3 || w === 4 && m === !0 ? "" : "" + m, x ? d.setAttributeNS(x, h, m) : d.setAttribute(h, m))));
  }
  var te = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, z = Symbol.for("react.element"), ie = Symbol.for("react.portal"), pe = Symbol.for("react.fragment"), _e = Symbol.for("react.strict_mode"), be = Symbol.for("react.profiler"), De = Symbol.for("react.provider"), Ce = Symbol.for("react.context"), ft = Symbol.for("react.forward_ref"), Ve = Symbol.for("react.suspense"), Ee = Symbol.for("react.suspense_list"), Re = Symbol.for("react.memo"), we = Symbol.for("react.lazy");
  Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode");
  var We = Symbol.for("react.offscreen");
  Symbol.for("react.legacy_hidden"), Symbol.for("react.cache"), Symbol.for("react.tracing_marker");
  var ne = Symbol.iterator;
  function Ae(d) {
    return d === null || typeof d != "object" ? null : (d = ne && d[ne] || d["@@iterator"], typeof d == "function" ? d : null);
  }
  var j = Object.assign, ge;
  function Me(d) {
    if (ge === void 0)
      try {
        throw Error();
      } catch (m) {
        var h = m.stack.trim().match(/\n( *(at )?)/);
        ge = h && h[1] || "";
      }
    return `
` + ge + d;
  }
  var ze = !1;
  function je(d, h) {
    if (!d || ze)
      return "";
    ze = !0;
    var m = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (h)
        if (h = function() {
          throw Error();
        }, Object.defineProperty(h.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(h, []);
          } catch (he) {
            var x = he;
          }
          Reflect.construct(d, [], h);
        } else {
          try {
            h.call();
          } catch (he) {
            x = he;
          }
          d.call(h.prototype);
        }
      else {
        try {
          throw Error();
        } catch (he) {
          x = he;
        }
        d();
      }
    } catch (he) {
      if (he && x && typeof he.stack == "string") {
        for (var w = he.stack.split(`
`), D = x.stack.split(`
`), F = w.length - 1, W = D.length - 1; 1 <= F && 0 <= W && w[F] !== D[W]; )
          W--;
        for (; 1 <= F && 0 <= W; F--, W--)
          if (w[F] !== D[W]) {
            if (F !== 1 || W !== 1)
              do
                if (F--, W--, 0 > W || w[F] !== D[W]) {
                  var Y = `
` + w[F].replace(" at new ", " at ");
                  return d.displayName && Y.includes("<anonymous>") && (Y = Y.replace("<anonymous>", d.displayName)), Y;
                }
              while (1 <= F && 0 <= W);
            break;
          }
      }
    } finally {
      ze = !1, Error.prepareStackTrace = m;
    }
    return (d = d ? d.displayName || d.name : "") ? Me(d) : "";
  }
  function vt(d) {
    switch (d.tag) {
      case 5:
        return Me(d.type);
      case 16:
        return Me("Lazy");
      case 13:
        return Me("Suspense");
      case 19:
        return Me("SuspenseList");
      case 0:
      case 2:
      case 15:
        return d = je(d.type, !1), d;
      case 11:
        return d = je(d.type.render, !1), d;
      case 1:
        return d = je(d.type, !0), d;
      default:
        return "";
    }
  }
  function Je(d) {
    if (d == null)
      return null;
    if (typeof d == "function")
      return d.displayName || d.name || null;
    if (typeof d == "string")
      return d;
    switch (d) {
      case pe:
        return "Fragment";
      case ie:
        return "Portal";
      case be:
        return "Profiler";
      case _e:
        return "StrictMode";
      case Ve:
        return "Suspense";
      case Ee:
        return "SuspenseList";
    }
    if (typeof d == "object")
      switch (d.$$typeof) {
        case Ce:
          return (d.displayName || "Context") + ".Consumer";
        case De:
          return (d._context.displayName || "Context") + ".Provider";
        case ft:
          var h = d.render;
          return d = d.displayName, d || (d = h.displayName || h.name || "", d = d !== "" ? "ForwardRef(" + d + ")" : "ForwardRef"), d;
        case Re:
          return h = d.displayName || null, h !== null ? h : Je(d.type) || "Memo";
        case we:
          h = d._payload, d = d._init;
          try {
            return Je(d(h));
          } catch {
          }
      }
    return null;
  }
  function _t(d) {
    var h = d.type;
    switch (d.tag) {
      case 24:
        return "Cache";
      case 9:
        return (h.displayName || "Context") + ".Consumer";
      case 10:
        return (h._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return d = h.render, d = d.displayName || d.name || "", h.displayName || (d !== "" ? "ForwardRef(" + d + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return h;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Je(h);
      case 8:
        return h === _e ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof h == "function")
          return h.displayName || h.name || null;
        if (typeof h == "string")
          return h;
    }
    return null;
  }
  function at(d) {
    switch (typeof d) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return d;
      case "object":
        return d;
      default:
        return "";
    }
  }
  function yt(d) {
    var h = d.type;
    return (d = d.nodeName) && d.toLowerCase() === "input" && (h === "checkbox" || h === "radio");
  }
  function tt(d) {
    var h = yt(d) ? "checked" : "value", m = Object.getOwnPropertyDescriptor(d.constructor.prototype, h), x = "" + d[h];
    if (!d.hasOwnProperty(h) && typeof m < "u" && typeof m.get == "function" && typeof m.set == "function") {
      var w = m.get, D = m.set;
      return Object.defineProperty(d, h, { configurable: !0, get: function() {
        return w.call(this);
      }, set: function(F) {
        x = "" + F, D.call(this, F);
      } }), Object.defineProperty(d, h, { enumerable: m.enumerable }), { getValue: function() {
        return x;
      }, setValue: function(F) {
        x = "" + F;
      }, stopTracking: function() {
        d._valueTracker = null, delete d[h];
      } };
    }
  }
  function zt(d) {
    d._valueTracker || (d._valueTracker = tt(d));
  }
  function Ie(d) {
    if (!d)
      return !1;
    var h = d._valueTracker;
    if (!h)
      return !0;
    var m = h.getValue(), x = "";
    return d && (x = yt(d) ? d.checked ? "true" : "false" : d.value), d = x, d !== m ? (h.setValue(d), !0) : !1;
  }
  function gt(d) {
    if (d = d || (typeof document < "u" ? document : void 0), typeof d > "u")
      return null;
    try {
      return d.activeElement || d.body;
    } catch {
      return d.body;
    }
  }
  function si(d, h) {
    var m = h.checked;
    return j({}, h, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: m ?? d._wrapperState.initialChecked });
  }
  function Wt(d, h) {
    var m = h.defaultValue == null ? "" : h.defaultValue, x = h.checked != null ? h.checked : h.defaultChecked;
    m = at(h.value != null ? h.value : m), d._wrapperState = { initialChecked: x, initialValue: m, controlled: h.type === "checkbox" || h.type === "radio" ? h.checked != null : h.value != null };
  }
  function ki(d, h) {
    h = h.checked, h != null && K(d, "checked", h, !1);
  }
  function lr(d, h) {
    ki(d, h);
    var m = at(h.value), x = h.type;
    if (m != null)
      x === "number" ? (m === 0 && d.value === "" || d.value != m) && (d.value = "" + m) : d.value !== "" + m && (d.value = "" + m);
    else if (x === "submit" || x === "reset") {
      d.removeAttribute("value");
      return;
    }
    h.hasOwnProperty("value") ? Wi(d, h.type, m) : h.hasOwnProperty("defaultValue") && Wi(d, h.type, at(h.defaultValue)), h.checked == null && h.defaultChecked != null && (d.defaultChecked = !!h.defaultChecked);
  }
  function mi(d, h, m) {
    if (h.hasOwnProperty("value") || h.hasOwnProperty("defaultValue")) {
      var x = h.type;
      if (!(x !== "submit" && x !== "reset" || h.value !== void 0 && h.value !== null))
        return;
      h = "" + d._wrapperState.initialValue, m || h === d.value || (d.value = h), d.defaultValue = h;
    }
    m = d.name, m !== "" && (d.name = ""), d.defaultChecked = !!d._wrapperState.initialChecked, m !== "" && (d.name = m);
  }
  function Wi(d, h, m) {
    (h !== "number" || gt(d.ownerDocument) !== d) && (m == null ? d.defaultValue = "" + d._wrapperState.initialValue : d.defaultValue !== "" + m && (d.defaultValue = "" + m));
  }
  var Rr = Array.isArray;
  function ia(d, h, m, x) {
    if (d = d.options, h) {
      h = {};
      for (var w = 0; w < m.length; w++)
        h["$" + m[w]] = !0;
      for (m = 0; m < d.length; m++)
        w = h.hasOwnProperty("$" + d[m].value), d[m].selected !== w && (d[m].selected = w), w && x && (d[m].defaultSelected = !0);
    } else {
      for (m = "" + at(m), h = null, w = 0; w < d.length; w++) {
        if (d[w].value === m) {
          d[w].selected = !0, x && (d[w].defaultSelected = !0);
          return;
        }
        h !== null || d[w].disabled || (h = d[w]);
      }
      h !== null && (h.selected = !0);
    }
  }
  function ra(d, h) {
    if (h.dangerouslySetInnerHTML != null)
      throw Error(i(91));
    return j({}, h, { value: void 0, defaultValue: void 0, children: "" + d._wrapperState.initialValue });
  }
  function zn(d, h) {
    var m = h.value;
    if (m == null) {
      if (m = h.children, h = h.defaultValue, m != null) {
        if (h != null)
          throw Error(i(92));
        if (Rr(m)) {
          if (1 < m.length)
            throw Error(i(93));
          m = m[0];
        }
        h = m;
      }
      h == null && (h = ""), m = h;
    }
    d._wrapperState = { initialValue: at(m) };
  }
  function Yi(d, h) {
    var m = at(h.value), x = at(h.defaultValue);
    m != null && (m = "" + m, m !== d.value && (d.value = m), h.defaultValue == null && d.defaultValue !== m && (d.defaultValue = m)), x != null && (d.defaultValue = "" + x);
  }
  function tr(d) {
    var h = d.textContent;
    h === d._wrapperState.initialValue && h !== "" && h !== null && (d.value = h);
  }
  function cn(d) {
    switch (d) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function hr(d, h) {
    return d == null || d === "http://www.w3.org/1999/xhtml" ? cn(h) : d === "http://www.w3.org/2000/svg" && h === "foreignObject" ? "http://www.w3.org/1999/xhtml" : d;
  }
  var Wr, Go = function(d) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(h, m, x, w) {
      MSApp.execUnsafeLocalFunction(function() {
        return d(h, m, x, w);
      });
    } : d;
  }(function(d, h) {
    if (d.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in d)
      d.innerHTML = h;
    else {
      for (Wr = Wr || document.createElement("div"), Wr.innerHTML = "<svg>" + h.valueOf().toString() + "</svg>", h = Wr.firstChild; d.firstChild; )
        d.removeChild(d.firstChild);
      for (; h.firstChild; )
        d.appendChild(h.firstChild);
    }
  });
  function Wa(d, h) {
    if (h) {
      var m = d.firstChild;
      if (m && m === d.lastChild && m.nodeType === 3) {
        m.nodeValue = h;
        return;
      }
    }
    d.textContent = h;
  }
  var Ca = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, nt = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Ca).forEach(function(d) {
    nt.forEach(function(h) {
      h = h + d.charAt(0).toUpperCase() + d.substring(1), Ca[h] = Ca[d];
    });
  });
  function Rt(d, h, m) {
    return h == null || typeof h == "boolean" || h === "" ? "" : m || typeof h != "number" || h === 0 || Ca.hasOwnProperty(d) && Ca[d] ? ("" + h).trim() : h + "px";
  }
  function ii(d, h) {
    d = d.style;
    for (var m in h)
      if (h.hasOwnProperty(m)) {
        var x = m.indexOf("--") === 0, w = Rt(m, h[m], x);
        m === "float" && (m = "cssFloat"), x ? d.setProperty(m, w) : d[m] = w;
      }
  }
  var Pi = j({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Ui(d, h) {
    if (h) {
      if (Pi[d] && (h.children != null || h.dangerouslySetInnerHTML != null))
        throw Error(i(137, d));
      if (h.dangerouslySetInnerHTML != null) {
        if (h.children != null)
          throw Error(i(60));
        if (typeof h.dangerouslySetInnerHTML != "object" || !("__html" in h.dangerouslySetInnerHTML))
          throw Error(i(61));
      }
      if (h.style != null && typeof h.style != "object")
        throw Error(i(62));
    }
  }
  function Br(d, h) {
    if (d.indexOf("-") === -1)
      return typeof h.is == "string";
    switch (d) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var fr = null;
  function Lr(d) {
    return d = d.target || d.srcElement || window, d.correspondingUseElement && (d = d.correspondingUseElement), d.nodeType === 3 ? d.parentNode : d;
  }
  var ur = null, Ti = null, qi = null;
  function Bl(d) {
    if (d = df(d)) {
      if (typeof ur != "function")
        throw Error(i(280));
      var h = d.stateNode;
      h && (h = Lt(h), ur(d.stateNode, d.type, h));
    }
  }
  function gs(d) {
    Ti ? qi ? qi.push(d) : qi = [d] : Ti = d;
  }
  function Vl() {
    if (Ti) {
      var d = Ti, h = qi;
      if (qi = Ti = null, Bl(d), h)
        for (d = 0; d < h.length; d++)
          Bl(h[d]);
    }
  }
  function $u(d, h) {
    return d(h);
  }
  function uc() {
  }
  var ms = !1;
  function Xs(d, h, m) {
    if (ms)
      return d(h, m);
    ms = !0;
    try {
      return $u(d, h, m);
    } finally {
      ms = !1, (Ti !== null || qi !== null) && (uc(), Vl());
    }
  }
  function _s(d, h) {
    var m = d.stateNode;
    if (m === null)
      return null;
    var x = Lt(m);
    if (x === null)
      return null;
    m = x[h];
    e:
      switch (h) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (x = !x.disabled) || (d = d.type, x = !(d === "button" || d === "input" || d === "select" || d === "textarea")), d = !x;
          break e;
        default:
          d = !1;
      }
    if (d)
      return null;
    if (m && typeof m != "function")
      throw Error(i(231, h, typeof m));
    return m;
  }
  var Qs = !1;
  if (u)
    try {
      var Ua = {};
      Object.defineProperty(Ua, "passive", { get: function() {
        Qs = !0;
      } }), window.addEventListener("test", Ua, Ua), window.removeEventListener("test", Ua, Ua);
    } catch {
      Qs = !1;
    }
  function Ko(d, h, m, x, w, D, F, W, Y) {
    var he = Array.prototype.slice.call(arguments, 3);
    try {
      h.apply(m, he);
    } catch (Be) {
      this.onError(Be);
    }
  }
  var Wn = !1, ya = null, jo = !1, G = null, ke = { onError: function(d) {
    Wn = !0, ya = d;
  } };
  function U(d, h, m, x, w, D, F, W, Y) {
    Wn = !1, ya = null, Ko.apply(ke, arguments);
  }
  function ye(d, h, m, x, w, D, F, W, Y) {
    if (U.apply(this, arguments), Wn) {
      if (Wn) {
        var he = ya;
        Wn = !1, ya = null;
      } else
        throw Error(i(198));
      jo || (jo = !0, G = he);
    }
  }
  function Fe(d) {
    var h = d, m = d;
    if (d.alternate)
      for (; h.return; )
        h = h.return;
    else {
      d = h;
      do
        h = d, h.flags & 4098 && (m = h.return), d = h.return;
      while (d);
    }
    return h.tag === 3 ? m : null;
  }
  function Ue(d) {
    if (d.tag === 13) {
      var h = d.memoizedState;
      if (h === null && (d = d.alternate, d !== null && (h = d.memoizedState)), h !== null)
        return h.dehydrated;
    }
    return null;
  }
  function Ze(d) {
    if (Fe(d) !== d)
      throw Error(i(188));
  }
  function Xe(d) {
    var h = d.alternate;
    if (!h) {
      if (h = Fe(d), h === null)
        throw Error(i(188));
      return h !== d ? null : d;
    }
    for (var m = d, x = h; ; ) {
      var w = m.return;
      if (w === null)
        break;
      var D = w.alternate;
      if (D === null) {
        if (x = w.return, x !== null) {
          m = x;
          continue;
        }
        break;
      }
      if (w.child === D.child) {
        for (D = w.child; D; ) {
          if (D === m)
            return Ze(w), d;
          if (D === x)
            return Ze(w), h;
          D = D.sibling;
        }
        throw Error(i(188));
      }
      if (m.return !== x.return)
        m = w, x = D;
      else {
        for (var F = !1, W = w.child; W; ) {
          if (W === m) {
            F = !0, m = w, x = D;
            break;
          }
          if (W === x) {
            F = !0, x = w, m = D;
            break;
          }
          W = W.sibling;
        }
        if (!F) {
          for (W = D.child; W; ) {
            if (W === m) {
              F = !0, m = D, x = w;
              break;
            }
            if (W === x) {
              F = !0, x = D, m = w;
              break;
            }
            W = W.sibling;
          }
          if (!F)
            throw Error(i(189));
        }
      }
      if (m.alternate !== x)
        throw Error(i(190));
    }
    if (m.tag !== 3)
      throw Error(i(188));
    return m.stateNode.current === m ? d : h;
  }
  function Nt(d) {
    return d = Xe(d), d !== null ? kt(d) : null;
  }
  function kt(d) {
    if (d.tag === 5 || d.tag === 6)
      return d;
    for (d = d.child; d !== null; ) {
      var h = kt(d);
      if (h !== null)
        return h;
      d = d.sibling;
    }
    return null;
  }
  var ci = e.unstable_scheduleCallback, pr = e.unstable_cancelCallback, xa = e.unstable_shouldYield, Cs = e.unstable_requestPaint, hi = e.unstable_now, HI = e.unstable_getCurrentPriorityLevel, Zs = e.unstable_ImmediatePriority, fi = e.unstable_UserBlockingPriority, Nl = e.unstable_NormalPriority, OS = e.unstable_LowPriority, jm = e.unstable_IdlePriority, zh = null, Yo = null;
  function RS(d) {
    if (Yo && typeof Yo.onCommitFiberRoot == "function")
      try {
        Yo.onCommitFiberRoot(zh, d, void 0, (d.current.flags & 128) === 128);
      } catch {
      }
  }
  var po = Math.clz32 ? Math.clz32 : $I, LS = Math.log, MS = Math.LN2;
  function $I(d) {
    return d >>>= 0, d === 0 ? 32 : 31 - (LS(d) / MS | 0) | 0;
  }
  var Jp = 64, dc = 4194304;
  function zu(d) {
    switch (d & -d) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return d & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return d & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return d;
    }
  }
  function qo(d, h) {
    var m = d.pendingLanes;
    if (m === 0)
      return 0;
    var x = 0, w = d.suspendedLanes, D = d.pingedLanes, F = m & 268435455;
    if (F !== 0) {
      var W = F & ~w;
      W !== 0 ? x = zu(W) : (D &= F, D !== 0 && (x = zu(D)));
    } else
      F = m & ~w, F !== 0 ? x = zu(F) : D !== 0 && (x = zu(D));
    if (x === 0)
      return 0;
    if (h !== 0 && h !== x && !(h & w) && (w = x & -x, D = h & -h, w >= D || w === 16 && (D & 4194240) !== 0))
      return h;
    if (x & 4 && (x |= m & 16), h = d.entangledLanes, h !== 0)
      for (d = d.entanglements, h &= x; 0 < h; )
        m = 31 - po(h), w = 1 << m, x |= d[m], h &= ~w;
    return x;
  }
  function Ym(d, h) {
    switch (d) {
      case 1:
      case 2:
      case 4:
        return h + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return h + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function ev(d, h) {
    for (var m = d.suspendedLanes, x = d.pingedLanes, w = d.expirationTimes, D = d.pendingLanes; 0 < D; ) {
      var F = 31 - po(D), W = 1 << F, Y = w[F];
      Y === -1 ? (!(W & m) || W & x) && (w[F] = Ym(W, h)) : Y <= h && (d.expiredLanes |= W), D &= ~W;
    }
  }
  function qm(d) {
    return d = d.pendingLanes & -1073741825, d !== 0 ? d : d & 1073741824 ? 1073741824 : 0;
  }
  function tv() {
    var d = Jp;
    return Jp <<= 1, !(Jp & 4194240) && (Jp = 64), d;
  }
  function Xm(d) {
    for (var h = [], m = 0; 31 > m; m++)
      h.push(d);
    return h;
  }
  function Wu(d, h, m) {
    d.pendingLanes |= h, h !== 536870912 && (d.suspendedLanes = 0, d.pingedLanes = 0), d = d.eventTimes, h = 31 - po(h), d[h] = m;
  }
  function zI(d, h) {
    var m = d.pendingLanes & ~h;
    d.pendingLanes = h, d.suspendedLanes = 0, d.pingedLanes = 0, d.expiredLanes &= h, d.mutableReadLanes &= h, d.entangledLanes &= h, h = d.entanglements;
    var x = d.eventTimes;
    for (d = d.expirationTimes; 0 < m; ) {
      var w = 31 - po(m), D = 1 << w;
      h[w] = 0, x[w] = -1, d[w] = -1, m &= ~D;
    }
  }
  function Wh(d, h) {
    var m = d.entangledLanes |= h;
    for (d = d.entanglements; m; ) {
      var x = 31 - po(m), w = 1 << x;
      w & h | d[x] & h && (d[x] |= h), m &= ~w;
    }
  }
  var Gi = 0;
  function Qm(d) {
    return d &= -d, 1 < d ? 4 < d ? d & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var kS, iv, ir, PS, Zm, Jt = !1, Uh = [], Ur = null, vo = null, go = null, Gh = /* @__PURE__ */ new Map(), en = /* @__PURE__ */ new Map(), Xi = [], WI = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Xo(d, h) {
    switch (d) {
      case "focusin":
      case "focusout":
        Ur = null;
        break;
      case "dragenter":
      case "dragleave":
        vo = null;
        break;
      case "mouseover":
      case "mouseout":
        go = null;
        break;
      case "pointerover":
      case "pointerout":
        Gh.delete(h.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        en.delete(h.pointerId);
    }
  }
  function Un(d, h, m, x, w, D) {
    return d === null || d.nativeEvent !== D ? (d = { blockedOn: h, domEventName: m, eventSystemFlags: x, nativeEvent: D, targetContainers: [w] }, h !== null && (h = df(h), h !== null && iv(h)), d) : (d.eventSystemFlags |= x, h = d.targetContainers, w !== null && h.indexOf(w) === -1 && h.push(w), d);
  }
  function Hl(d, h, m, x, w) {
    switch (h) {
      case "focusin":
        return Ur = Un(Ur, d, h, m, x, w), !0;
      case "dragenter":
        return vo = Un(vo, d, h, m, x, w), !0;
      case "mouseover":
        return go = Un(go, d, h, m, x, w), !0;
      case "pointerover":
        var D = w.pointerId;
        return Gh.set(D, Un(Gh.get(D) || null, d, h, m, x, w)), !0;
      case "gotpointercapture":
        return D = w.pointerId, en.set(D, Un(en.get(D) || null, d, h, m, x, w)), !0;
    }
    return !1;
  }
  function FS(d) {
    var h = _o(d.target);
    if (h !== null) {
      var m = Fe(h);
      if (m !== null) {
        if (h = m.tag, h === 13) {
          if (h = Ue(m), h !== null) {
            d.blockedOn = h, Zm(d.priority, function() {
              ir(m);
            });
            return;
          }
        } else if (h === 3 && m.stateNode.current.memoizedState.isDehydrated) {
          d.blockedOn = m.tag === 3 ? m.stateNode.containerInfo : null;
          return;
        }
      }
    }
    d.blockedOn = null;
  }
  function cc(d) {
    if (d.blockedOn !== null)
      return !1;
    for (var h = d.targetContainers; 0 < h.length; ) {
      var m = av(d.domEventName, d.eventSystemFlags, h[0], d.nativeEvent);
      if (m === null) {
        m = d.nativeEvent;
        var x = new m.constructor(m.type, m);
        fr = x, m.target.dispatchEvent(x), fr = null;
      } else
        return h = df(m), h !== null && iv(h), d.blockedOn = m, !1;
      h.shift();
    }
    return !0;
  }
  function Jm(d, h, m) {
    cc(d) && m.delete(h);
  }
  function BS() {
    Jt = !1, Ur !== null && cc(Ur) && (Ur = null), vo !== null && cc(vo) && (vo = null), go !== null && cc(go) && (go = null), Gh.forEach(Jm), en.forEach(Jm);
  }
  function Kh(d, h) {
    d.blockedOn === h && (d.blockedOn = null, Jt || (Jt = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, BS)));
  }
  function jh(d) {
    function h(w) {
      return Kh(w, d);
    }
    if (0 < Uh.length) {
      Kh(Uh[0], d);
      for (var m = 1; m < Uh.length; m++) {
        var x = Uh[m];
        x.blockedOn === d && (x.blockedOn = null);
      }
    }
    for (Ur !== null && Kh(Ur, d), vo !== null && Kh(vo, d), go !== null && Kh(go, d), Gh.forEach(h), en.forEach(h), m = 0; m < Xi.length; m++)
      x = Xi[m], x.blockedOn === d && (x.blockedOn = null);
    for (; 0 < Xi.length && (m = Xi[0], m.blockedOn === null); )
      FS(m), m.blockedOn === null && Xi.shift();
  }
  var hc = te.ReactCurrentBatchConfig, Uu = !0;
  function VS(d, h, m, x) {
    var w = Gi, D = hc.transition;
    hc.transition = null;
    try {
      Gi = 1, nv(d, h, m, x);
    } finally {
      Gi = w, hc.transition = D;
    }
  }
  function rv(d, h, m, x) {
    var w = Gi, D = hc.transition;
    hc.transition = null;
    try {
      Gi = 4, nv(d, h, m, x);
    } finally {
      Gi = w, hc.transition = D;
    }
  }
  function nv(d, h, m, x) {
    if (Uu) {
      var w = av(d, h, m, x);
      if (w === null)
        mv(d, h, x, Yh, m), Xo(d, x);
      else if (Hl(w, d, h, m, x))
        x.stopPropagation();
      else if (Xo(d, x), h & 4 && -1 < WI.indexOf(d)) {
        for (; w !== null; ) {
          var D = df(w);
          if (D !== null && kS(D), D = av(d, h, m, x), D === null && mv(d, h, x, Yh, m), D === w)
            break;
          w = D;
        }
        w !== null && x.stopPropagation();
      } else
        mv(d, h, x, null, m);
    }
  }
  var Yh = null;
  function av(d, h, m, x) {
    if (Yh = null, d = Lr(x), d = _o(d), d !== null)
      if (h = Fe(d), h === null)
        d = null;
      else if (m = h.tag, m === 13) {
        if (d = Ue(h), d !== null)
          return d;
        d = null;
      } else if (m === 3) {
        if (h.stateNode.current.memoizedState.isDehydrated)
          return h.tag === 3 ? h.stateNode.containerInfo : null;
        d = null;
      } else
        h !== d && (d = null);
    return Yh = d, null;
  }
  function e_(d) {
    switch (d) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (HI()) {
          case Zs:
            return 1;
          case fi:
            return 4;
          case Nl:
          case OS:
            return 16;
          case jm:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Js = null, qh = null, Xh = null;
  function t_() {
    if (Xh)
      return Xh;
    var d, h = qh, m = h.length, x, w = "value" in Js ? Js.value : Js.textContent, D = w.length;
    for (d = 0; d < m && h[d] === w[d]; d++)
      ;
    var F = m - d;
    for (x = 1; x <= F && h[m - x] === w[D - x]; x++)
      ;
    return Xh = w.slice(d, 1 < x ? 1 - x : void 0);
  }
  function fc(d) {
    var h = d.keyCode;
    return "charCode" in d ? (d = d.charCode, d === 0 && h === 13 && (d = 13)) : d = h, d === 10 && (d = 13), 32 <= d || d === 13 ? d : 0;
  }
  function Qh() {
    return !0;
  }
  function NS() {
    return !1;
  }
  function Ga(d) {
    function h(m, x, w, D, F) {
      this._reactName = m, this._targetInst = w, this.type = x, this.nativeEvent = D, this.target = F, this.currentTarget = null;
      for (var W in d)
        d.hasOwnProperty(W) && (m = d[W], this[W] = m ? m(D) : D[W]);
      return this.isDefaultPrevented = (D.defaultPrevented != null ? D.defaultPrevented : D.returnValue === !1) ? Qh : NS, this.isPropagationStopped = NS, this;
    }
    return j(h.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var m = this.nativeEvent;
      m && (m.preventDefault ? m.preventDefault() : typeof m.returnValue != "unknown" && (m.returnValue = !1), this.isDefaultPrevented = Qh);
    }, stopPropagation: function() {
      var m = this.nativeEvent;
      m && (m.stopPropagation ? m.stopPropagation() : typeof m.cancelBubble != "unknown" && (m.cancelBubble = !0), this.isPropagationStopped = Qh);
    }, persist: function() {
    }, isPersistent: Qh }), h;
  }
  var $l = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(d) {
    return d.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, ov = Ga($l), pc = j({}, $l, { view: 0, detail: 0 }), HS = Ga(pc), sv, i_, Zh, hn = j({}, pc, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: o_, button: 0, buttons: 0, relatedTarget: function(d) {
    return d.relatedTarget === void 0 ? d.fromElement === d.srcElement ? d.toElement : d.fromElement : d.relatedTarget;
  }, movementX: function(d) {
    return "movementX" in d ? d.movementX : (d !== Zh && (Zh && d.type === "mousemove" ? (sv = d.screenX - Zh.screenX, i_ = d.screenY - Zh.screenY) : i_ = sv = 0, Zh = d), sv);
  }, movementY: function(d) {
    return "movementY" in d ? d.movementY : i_;
  } }), lv = Ga(hn), $S = j({}, hn, { dataTransfer: 0 }), zS = Ga($S), UI = j({}, pc, { relatedTarget: 0 }), zl = Ga(UI), r_ = j({}, $l, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), WS = Ga(r_), GI = j({}, $l, { clipboardData: function(d) {
    return "clipboardData" in d ? d.clipboardData : window.clipboardData;
  } }), KI = Ga(GI), jI = j({}, $l, { data: 0 }), n_ = Ga(jI), a_ = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, US = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, GS = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function KS(d) {
    var h = this.nativeEvent;
    return h.getModifierState ? h.getModifierState(d) : (d = GS[d]) ? !!h[d] : !1;
  }
  function o_() {
    return KS;
  }
  var el = j({}, pc, { key: function(d) {
    if (d.key) {
      var h = a_[d.key] || d.key;
      if (h !== "Unidentified")
        return h;
    }
    return d.type === "keypress" ? (d = fc(d), d === 13 ? "Enter" : String.fromCharCode(d)) : d.type === "keydown" || d.type === "keyup" ? US[d.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: o_, charCode: function(d) {
    return d.type === "keypress" ? fc(d) : 0;
  }, keyCode: function(d) {
    return d.type === "keydown" || d.type === "keyup" ? d.keyCode : 0;
  }, which: function(d) {
    return d.type === "keypress" ? fc(d) : d.type === "keydown" || d.type === "keyup" ? d.keyCode : 0;
  } }), YI = Ga(el), s_ = j({}, hn, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), uv = Ga(s_), l_ = j({}, pc, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: o_ }), qI = Ga(l_), dv = j({}, $l, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), jS = Ga(dv), Sa = j({}, hn, {
    deltaX: function(d) {
      return "deltaX" in d ? d.deltaX : "wheelDeltaX" in d ? -d.wheelDeltaX : 0;
    },
    deltaY: function(d) {
      return "deltaY" in d ? d.deltaY : "wheelDeltaY" in d ? -d.wheelDeltaY : "wheelDelta" in d ? -d.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), tl = Ga(Sa), Gr = [9, 13, 27, 32], Qo = u && "CompositionEvent" in window, Gu = null;
  u && "documentMode" in document && (Gu = document.documentMode);
  var cv = u && "TextEvent" in window && !Gu, YS = u && (!Qo || Gu && 8 < Gu && 11 >= Gu), vc = " ", qS = !1;
  function XS(d, h) {
    switch (d) {
      case "keyup":
        return Gr.indexOf(h.keyCode) !== -1;
      case "keydown":
        return h.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function hv(d) {
    return d = d.detail, typeof d == "object" && "data" in d ? d.data : null;
  }
  var gc = !1;
  function XI(d, h) {
    switch (d) {
      case "compositionend":
        return hv(h);
      case "keypress":
        return h.which !== 32 ? null : (qS = !0, vc);
      case "textInput":
        return d = h.data, d === vc && qS ? null : d;
      default:
        return null;
    }
  }
  function QI(d, h) {
    if (gc)
      return d === "compositionend" || !Qo && XS(d, h) ? (d = t_(), Xh = qh = Js = null, gc = !1, d) : null;
    switch (d) {
      case "paste":
        return null;
      case "keypress":
        if (!(h.ctrlKey || h.altKey || h.metaKey) || h.ctrlKey && h.altKey) {
          if (h.char && 1 < h.char.length)
            return h.char;
          if (h.which)
            return String.fromCharCode(h.which);
        }
        return null;
      case "compositionend":
        return YS && h.locale !== "ko" ? null : h.data;
      default:
        return null;
    }
  }
  var QS = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function ZS(d) {
    var h = d && d.nodeName && d.nodeName.toLowerCase();
    return h === "input" ? !!QS[d.type] : h === "textarea";
  }
  function JS(d, h, m, x) {
    gs(x), h = sf(h, "onChange"), 0 < h.length && (m = new ov("onChange", "change", null, m, x), d.push({ event: m, listeners: h }));
  }
  var Jh = null, mc = null;
  function _c(d) {
    gv(d, 0);
  }
  function Cc(d) {
    var h = xc(d);
    if (Ie(h))
      return d;
  }
  function e0(d, h) {
    if (d === "change")
      return h;
  }
  var u_ = !1;
  if (u) {
    var d_;
    if (u) {
      var c_ = "oninput" in document;
      if (!c_) {
        var t0 = document.createElement("div");
        t0.setAttribute("oninput", "return;"), c_ = typeof t0.oninput == "function";
      }
      d_ = c_;
    } else
      d_ = !1;
    u_ = d_ && (!document.documentMode || 9 < document.documentMode);
  }
  function i0() {
    Jh && (Jh.detachEvent("onpropertychange", r0), mc = Jh = null);
  }
  function r0(d) {
    if (d.propertyName === "value" && Cc(mc)) {
      var h = [];
      JS(h, mc, d, Lr(d)), Xs(_c, h);
    }
  }
  function ZI(d, h, m) {
    d === "focusin" ? (i0(), Jh = h, mc = m, Jh.attachEvent("onpropertychange", r0)) : d === "focusout" && i0();
  }
  function JI(d) {
    if (d === "selectionchange" || d === "keyup" || d === "keydown")
      return Cc(mc);
  }
  function eD(d, h) {
    if (d === "click")
      return Cc(h);
  }
  function n0(d, h) {
    if (d === "input" || d === "change")
      return Cc(h);
  }
  function tD(d, h) {
    return d === h && (d !== 0 || 1 / d === 1 / h) || d !== d && h !== h;
  }
  var mo = typeof Object.is == "function" ? Object.is : tD;
  function ef(d, h) {
    if (mo(d, h))
      return !0;
    if (typeof d != "object" || d === null || typeof h != "object" || h === null)
      return !1;
    var m = Object.keys(d), x = Object.keys(h);
    if (m.length !== x.length)
      return !1;
    for (x = 0; x < m.length; x++) {
      var w = m[x];
      if (!c.call(h, w) || !mo(d[w], h[w]))
        return !1;
    }
    return !0;
  }
  function a0(d) {
    for (; d && d.firstChild; )
      d = d.firstChild;
    return d;
  }
  function o0(d, h) {
    var m = a0(d);
    d = 0;
    for (var x; m; ) {
      if (m.nodeType === 3) {
        if (x = d + m.textContent.length, d <= h && x >= h)
          return { node: m, offset: h - d };
        d = x;
      }
      e: {
        for (; m; ) {
          if (m.nextSibling) {
            m = m.nextSibling;
            break e;
          }
          m = m.parentNode;
        }
        m = void 0;
      }
      m = a0(m);
    }
  }
  function s0(d, h) {
    return d && h ? d === h ? !0 : d && d.nodeType === 3 ? !1 : h && h.nodeType === 3 ? s0(d, h.parentNode) : "contains" in d ? d.contains(h) : d.compareDocumentPosition ? !!(d.compareDocumentPosition(h) & 16) : !1 : !1;
  }
  function fv() {
    for (var d = window, h = gt(); h instanceof d.HTMLIFrameElement; ) {
      try {
        var m = typeof h.contentWindow.location.href == "string";
      } catch {
        m = !1;
      }
      if (m)
        d = h.contentWindow;
      else
        break;
      h = gt(d.document);
    }
    return h;
  }
  function il(d) {
    var h = d && d.nodeName && d.nodeName.toLowerCase();
    return h && (h === "input" && (d.type === "text" || d.type === "search" || d.type === "tel" || d.type === "url" || d.type === "password") || h === "textarea" || d.contentEditable === "true");
  }
  function pv(d) {
    var h = fv(), m = d.focusedElem, x = d.selectionRange;
    if (h !== m && m && m.ownerDocument && s0(m.ownerDocument.documentElement, m)) {
      if (x !== null && il(m)) {
        if (h = x.start, d = x.end, d === void 0 && (d = h), "selectionStart" in m)
          m.selectionStart = h, m.selectionEnd = Math.min(d, m.value.length);
        else if (d = (h = m.ownerDocument || document) && h.defaultView || window, d.getSelection) {
          d = d.getSelection();
          var w = m.textContent.length, D = Math.min(x.start, w);
          x = x.end === void 0 ? D : Math.min(x.end, w), !d.extend && D > x && (w = x, x = D, D = w), w = o0(m, D);
          var F = o0(
            m,
            x
          );
          w && F && (d.rangeCount !== 1 || d.anchorNode !== w.node || d.anchorOffset !== w.offset || d.focusNode !== F.node || d.focusOffset !== F.offset) && (h = h.createRange(), h.setStart(w.node, w.offset), d.removeAllRanges(), D > x ? (d.addRange(h), d.extend(F.node, F.offset)) : (h.setEnd(F.node, F.offset), d.addRange(h)));
        }
      }
      for (h = [], d = m; d = d.parentNode; )
        d.nodeType === 1 && h.push({ element: d, left: d.scrollLeft, top: d.scrollTop });
      for (typeof m.focus == "function" && m.focus(), m = 0; m < h.length; m++)
        d = h[m], d.element.scrollLeft = d.left, d.element.scrollTop = d.top;
    }
  }
  var l0 = u && "documentMode" in document && 11 >= document.documentMode, Zo = null, h_ = null, tf = null, f_ = !1;
  function u0(d, h, m) {
    var x = m.window === m ? m.document : m.nodeType === 9 ? m : m.ownerDocument;
    f_ || Zo == null || Zo !== gt(x) || (x = Zo, "selectionStart" in x && il(x) ? x = { start: x.selectionStart, end: x.selectionEnd } : (x = (x.ownerDocument && x.ownerDocument.defaultView || window).getSelection(), x = { anchorNode: x.anchorNode, anchorOffset: x.anchorOffset, focusNode: x.focusNode, focusOffset: x.focusOffset }), tf && ef(tf, x) || (tf = x, x = sf(h_, "onSelect"), 0 < x.length && (h = new ov("onSelect", "select", null, h, m), d.push({ event: h, listeners: x }), h.target = Zo)));
  }
  function vv(d, h) {
    var m = {};
    return m[d.toLowerCase()] = h.toLowerCase(), m["Webkit" + d] = "webkit" + h, m["Moz" + d] = "moz" + h, m;
  }
  var Ku = { animationend: vv("Animation", "AnimationEnd"), animationiteration: vv("Animation", "AnimationIteration"), animationstart: vv("Animation", "AnimationStart"), transitionend: vv("Transition", "TransitionEnd") }, p_ = {}, v_ = {};
  u && (v_ = document.createElement("div").style, "AnimationEvent" in window || (delete Ku.animationend.animation, delete Ku.animationiteration.animation, delete Ku.animationstart.animation), "TransitionEvent" in window || delete Ku.transitionend.transition);
  function fn(d) {
    if (p_[d])
      return p_[d];
    if (!Ku[d])
      return d;
    var h = Ku[d], m;
    for (m in h)
      if (h.hasOwnProperty(m) && m in v_)
        return p_[d] = h[m];
    return d;
  }
  var g_ = fn("animationend"), d0 = fn("animationiteration"), c0 = fn("animationstart"), h0 = fn("transitionend"), f0 = /* @__PURE__ */ new Map(), p0 = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function rl(d, h) {
    f0.set(d, h), a(h, [d]);
  }
  for (var rf = 0; rf < p0.length; rf++) {
    var ju = p0[rf], iD = ju.toLowerCase(), nf = ju[0].toUpperCase() + ju.slice(1);
    rl(iD, "on" + nf);
  }
  rl(g_, "onAnimationEnd"), rl(d0, "onAnimationIteration"), rl(c0, "onAnimationStart"), rl("dblclick", "onDoubleClick"), rl("focusin", "onFocus"), rl("focusout", "onBlur"), rl(h0, "onTransitionEnd"), o("onMouseEnter", ["mouseout", "mouseover"]), o("onMouseLeave", ["mouseout", "mouseover"]), o("onPointerEnter", ["pointerout", "pointerover"]), o("onPointerLeave", ["pointerout", "pointerover"]), a("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), a("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), a("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), a("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), a("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), a("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var af = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), rD = new Set("cancel close invalid load scroll toggle".split(" ").concat(af));
  function v0(d, h, m) {
    var x = d.type || "unknown-event";
    d.currentTarget = m, ye(x, h, void 0, d), d.currentTarget = null;
  }
  function gv(d, h) {
    h = (h & 4) !== 0;
    for (var m = 0; m < d.length; m++) {
      var x = d[m], w = x.event;
      x = x.listeners;
      e: {
        var D = void 0;
        if (h)
          for (var F = x.length - 1; 0 <= F; F--) {
            var W = x[F], Y = W.instance, he = W.currentTarget;
            if (W = W.listener, Y !== D && w.isPropagationStopped())
              break e;
            v0(w, W, he), D = Y;
          }
        else
          for (F = 0; F < x.length; F++) {
            if (W = x[F], Y = W.instance, he = W.currentTarget, W = W.listener, Y !== D && w.isPropagationStopped())
              break e;
            v0(w, W, he), D = Y;
          }
      }
    }
    if (jo)
      throw d = G, jo = !1, G = null, d;
  }
  function rr(d, h) {
    var m = h[E_];
    m === void 0 && (m = h[E_] = /* @__PURE__ */ new Set());
    var x = d + "__bubble";
    m.has(x) || (g0(h, d, 2, !1), m.add(x));
  }
  function Wl(d, h, m) {
    var x = 0;
    h && (x |= 4), g0(m, d, x, h);
  }
  var nl = "_reactListening" + Math.random().toString(36).slice(2);
  function yc(d) {
    if (!d[nl]) {
      d[nl] = !0, r.forEach(function(m) {
        m !== "selectionchange" && (rD.has(m) || Wl(m, !1, d), Wl(m, !0, d));
      });
      var h = d.nodeType === 9 ? d : d.ownerDocument;
      h === null || h[nl] || (h[nl] = !0, Wl("selectionchange", !1, h));
    }
  }
  function g0(d, h, m, x) {
    switch (e_(h)) {
      case 1:
        var w = VS;
        break;
      case 4:
        w = rv;
        break;
      default:
        w = nv;
    }
    m = w.bind(null, h, m, d), w = void 0, !Qs || h !== "touchstart" && h !== "touchmove" && h !== "wheel" || (w = !0), x ? w !== void 0 ? d.addEventListener(h, m, { capture: !0, passive: w }) : d.addEventListener(h, m, !0) : w !== void 0 ? d.addEventListener(h, m, { passive: w }) : d.addEventListener(h, m, !1);
  }
  function mv(d, h, m, x, w) {
    var D = x;
    if (!(h & 1) && !(h & 2) && x !== null)
      e:
        for (; ; ) {
          if (x === null)
            return;
          var F = x.tag;
          if (F === 3 || F === 4) {
            var W = x.stateNode.containerInfo;
            if (W === w || W.nodeType === 8 && W.parentNode === w)
              break;
            if (F === 4)
              for (F = x.return; F !== null; ) {
                var Y = F.tag;
                if ((Y === 3 || Y === 4) && (Y = F.stateNode.containerInfo, Y === w || Y.nodeType === 8 && Y.parentNode === w))
                  return;
                F = F.return;
              }
            for (; W !== null; ) {
              if (F = _o(W), F === null)
                return;
              if (Y = F.tag, Y === 5 || Y === 6) {
                x = D = F;
                continue e;
              }
              W = W.parentNode;
            }
          }
          x = x.return;
        }
    Xs(function() {
      var he = D, Be = Lr(m), Ne = [];
      e: {
        var Pe = f0.get(d);
        if (Pe !== void 0) {
          var ut = ov, xt = d;
          switch (d) {
            case "keypress":
              if (fc(m) === 0)
                break e;
            case "keydown":
            case "keyup":
              ut = YI;
              break;
            case "focusin":
              xt = "focus", ut = zl;
              break;
            case "focusout":
              xt = "blur", ut = zl;
              break;
            case "beforeblur":
            case "afterblur":
              ut = zl;
              break;
            case "click":
              if (m.button === 2)
                break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              ut = lv;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              ut = zS;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              ut = qI;
              break;
            case g_:
            case d0:
            case c0:
              ut = WS;
              break;
            case h0:
              ut = jS;
              break;
            case "scroll":
              ut = HS;
              break;
            case "wheel":
              ut = tl;
              break;
            case "copy":
            case "cut":
            case "paste":
              ut = KI;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              ut = uv;
          }
          var bt = (h & 4) !== 0, Nr = !bt && d === "scroll", oe = bt ? Pe !== null ? Pe + "Capture" : null : Pe;
          bt = [];
          for (var Z = he, ue; Z !== null; ) {
            ue = Z;
            var Ge = ue.stateNode;
            if (ue.tag === 5 && Ge !== null && (ue = Ge, oe !== null && (Ge = _s(Z, oe), Ge != null && bt.push(of(Z, Ge, ue)))), Nr)
              break;
            Z = Z.return;
          }
          0 < bt.length && (Pe = new ut(Pe, xt, null, m, Be), Ne.push({ event: Pe, listeners: bt }));
        }
      }
      if (!(h & 7)) {
        e: {
          if (Pe = d === "mouseover" || d === "pointerover", ut = d === "mouseout" || d === "pointerout", Pe && m !== fr && (xt = m.relatedTarget || m.fromElement) && (_o(xt) || xt[al]))
            break e;
          if ((ut || Pe) && (Pe = Be.window === Be ? Be : (Pe = Be.ownerDocument) ? Pe.defaultView || Pe.parentWindow : window, ut ? (xt = m.relatedTarget || m.toElement, ut = he, xt = xt ? _o(xt) : null, xt !== null && (Nr = Fe(xt), xt !== Nr || xt.tag !== 5 && xt.tag !== 6) && (xt = null)) : (ut = null, xt = he), ut !== xt)) {
            if (bt = lv, Ge = "onMouseLeave", oe = "onMouseEnter", Z = "mouse", (d === "pointerout" || d === "pointerover") && (bt = uv, Ge = "onPointerLeave", oe = "onPointerEnter", Z = "pointer"), Nr = ut == null ? Pe : xc(ut), ue = xt == null ? Pe : xc(xt), Pe = new bt(Ge, Z + "leave", ut, m, Be), Pe.target = Nr, Pe.relatedTarget = ue, Ge = null, _o(Be) === he && (bt = new bt(oe, Z + "enter", xt, m, Be), bt.target = ue, bt.relatedTarget = Nr, Ge = bt), Nr = Ge, ut && xt)
              t: {
                for (bt = ut, oe = xt, Z = 0, ue = bt; ue; ue = Yu(ue))
                  Z++;
                for (ue = 0, Ge = oe; Ge; Ge = Yu(Ge))
                  ue++;
                for (; 0 < Z - ue; )
                  bt = Yu(bt), Z--;
                for (; 0 < ue - Z; )
                  oe = Yu(oe), ue--;
                for (; Z--; ) {
                  if (bt === oe || oe !== null && bt === oe.alternate)
                    break t;
                  bt = Yu(bt), oe = Yu(oe);
                }
                bt = null;
              }
            else
              bt = null;
            ut !== null && m_(Ne, Pe, ut, bt, !1), xt !== null && Nr !== null && m_(Ne, Nr, xt, bt, !0);
          }
        }
        e: {
          if (Pe = he ? xc(he) : window, ut = Pe.nodeName && Pe.nodeName.toLowerCase(), ut === "select" || ut === "input" && Pe.type === "file")
            var It = e0;
          else if (ZS(Pe))
            if (u_)
              It = n0;
            else {
              It = JI;
              var St = ZI;
            }
          else
            (ut = Pe.nodeName) && ut.toLowerCase() === "input" && (Pe.type === "checkbox" || Pe.type === "radio") && (It = eD);
          if (It && (It = It(d, he))) {
            JS(Ne, It, m, Be);
            break e;
          }
          St && St(d, Pe, he), d === "focusout" && (St = Pe._wrapperState) && St.controlled && Pe.type === "number" && Wi(Pe, "number", Pe.value);
        }
        switch (St = he ? xc(he) : window, d) {
          case "focusin":
            (ZS(St) || St.contentEditable === "true") && (Zo = St, h_ = he, tf = null);
            break;
          case "focusout":
            tf = h_ = Zo = null;
            break;
          case "mousedown":
            f_ = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            f_ = !1, u0(Ne, m, Be);
            break;
          case "selectionchange":
            if (l0)
              break;
          case "keydown":
          case "keyup":
            u0(Ne, m, Be);
        }
        var At;
        if (Qo)
          e: {
            switch (d) {
              case "compositionstart":
                var Kt = "onCompositionStart";
                break e;
              case "compositionend":
                Kt = "onCompositionEnd";
                break e;
              case "compositionupdate":
                Kt = "onCompositionUpdate";
                break e;
            }
            Kt = void 0;
          }
        else
          gc ? XS(d, m) && (Kt = "onCompositionEnd") : d === "keydown" && m.keyCode === 229 && (Kt = "onCompositionStart");
        Kt && (YS && m.locale !== "ko" && (gc || Kt !== "onCompositionStart" ? Kt === "onCompositionEnd" && gc && (At = t_()) : (Js = Be, qh = "value" in Js ? Js.value : Js.textContent, gc = !0)), St = sf(he, Kt), 0 < St.length && (Kt = new n_(Kt, d, null, m, Be), Ne.push({ event: Kt, listeners: St }), At ? Kt.data = At : (At = hv(m), At !== null && (Kt.data = At)))), (At = cv ? XI(d, m) : QI(d, m)) && (he = sf(he, "onBeforeInput"), 0 < he.length && (Be = new n_("onBeforeInput", "beforeinput", null, m, Be), Ne.push({ event: Be, listeners: he }), Be.data = At));
      }
      gv(Ne, h);
    });
  }
  function of(d, h, m) {
    return { instance: d, listener: h, currentTarget: m };
  }
  function sf(d, h) {
    for (var m = h + "Capture", x = []; d !== null; ) {
      var w = d, D = w.stateNode;
      w.tag === 5 && D !== null && (w = D, D = _s(d, m), D != null && x.unshift(of(d, D, w)), D = _s(d, h), D != null && x.push(of(d, D, w))), d = d.return;
    }
    return x;
  }
  function Yu(d) {
    if (d === null)
      return null;
    do
      d = d.return;
    while (d && d.tag !== 5);
    return d || null;
  }
  function m_(d, h, m, x, w) {
    for (var D = h._reactName, F = []; m !== null && m !== x; ) {
      var W = m, Y = W.alternate, he = W.stateNode;
      if (Y !== null && Y === x)
        break;
      W.tag === 5 && he !== null && (W = he, w ? (Y = _s(m, D), Y != null && F.unshift(of(m, Y, W))) : w || (Y = _s(m, D), Y != null && F.push(of(m, Y, W)))), m = m.return;
    }
    F.length !== 0 && d.push({ event: h, listeners: F });
  }
  var __ = /\r\n?/g, nD = /\u0000|\uFFFD/g;
  function C_(d) {
    return (typeof d == "string" ? d : "" + d).replace(__, `
`).replace(nD, "");
  }
  function _v(d, h, m) {
    if (h = C_(h), C_(d) !== h && m)
      throw Error(i(425));
  }
  function Cv() {
  }
  var y_ = null, qu = null;
  function lf(d, h) {
    return d === "textarea" || d === "noscript" || typeof h.children == "string" || typeof h.children == "number" || typeof h.dangerouslySetInnerHTML == "object" && h.dangerouslySetInnerHTML !== null && h.dangerouslySetInnerHTML.__html != null;
  }
  var Xu = typeof setTimeout == "function" ? setTimeout : void 0, m0 = typeof clearTimeout == "function" ? clearTimeout : void 0, x_ = typeof Promise == "function" ? Promise : void 0, S_ = typeof queueMicrotask == "function" ? queueMicrotask : typeof x_ < "u" ? function(d) {
    return x_.resolve(null).then(d).catch(aD);
  } : Xu;
  function aD(d) {
    setTimeout(function() {
      throw d;
    });
  }
  function Ul(d, h) {
    var m = h, x = 0;
    do {
      var w = m.nextSibling;
      if (d.removeChild(m), w && w.nodeType === 8)
        if (m = w.data, m === "/$") {
          if (x === 0) {
            d.removeChild(w), jh(h);
            return;
          }
          x--;
        } else
          m !== "$" && m !== "$?" && m !== "$!" || x++;
      m = w;
    } while (m);
    jh(h);
  }
  function Jo(d) {
    for (; d != null; d = d.nextSibling) {
      var h = d.nodeType;
      if (h === 1 || h === 3)
        break;
      if (h === 8) {
        if (h = d.data, h === "$" || h === "$!" || h === "$?")
          break;
        if (h === "/$")
          return null;
      }
    }
    return d;
  }
  function uf(d) {
    d = d.previousSibling;
    for (var h = 0; d; ) {
      if (d.nodeType === 8) {
        var m = d.data;
        if (m === "$" || m === "$!" || m === "$?") {
          if (h === 0)
            return d;
          h--;
        } else
          m === "/$" && h++;
      }
      d = d.previousSibling;
    }
    return null;
  }
  var Gl = Math.random().toString(36).slice(2), ys = "__reactFiber$" + Gl, Qu = "__reactProps$" + Gl, al = "__reactContainer$" + Gl, E_ = "__reactEvents$" + Gl, oD = "__reactListeners$" + Gl, b_ = "__reactHandles$" + Gl;
  function _o(d) {
    var h = d[ys];
    if (h)
      return h;
    for (var m = d.parentNode; m; ) {
      if (h = m[al] || m[ys]) {
        if (m = h.alternate, h.child !== null || m !== null && m.child !== null)
          for (d = uf(d); d !== null; ) {
            if (m = d[ys])
              return m;
            d = uf(d);
          }
        return h;
      }
      d = m, m = d.parentNode;
    }
    return null;
  }
  function df(d) {
    return d = d[ys] || d[al], !d || d.tag !== 5 && d.tag !== 6 && d.tag !== 13 && d.tag !== 3 ? null : d;
  }
  function xc(d) {
    if (d.tag === 5 || d.tag === 6)
      return d.stateNode;
    throw Error(i(33));
  }
  function Lt(d) {
    return d[Qu] || null;
  }
  var Kl = [], vr = -1;
  function ri(d) {
    return { current: d };
  }
  function Fi(d) {
    0 > vr || (d.current = Kl[vr], Kl[vr] = null, vr--);
  }
  function Vi(d, h) {
    vr++, Kl[vr] = d.current, d.current = h;
  }
  var xs = {}, Gt = ri(xs), Mr = ri(!1), Ea = xs;
  function Co(d, h) {
    var m = d.type.contextTypes;
    if (!m)
      return xs;
    var x = d.stateNode;
    if (x && x.__reactInternalMemoizedUnmaskedChildContext === h)
      return x.__reactInternalMemoizedMaskedChildContext;
    var w = {}, D;
    for (D in m)
      w[D] = h[D];
    return x && (d = d.stateNode, d.__reactInternalMemoizedUnmaskedChildContext = h, d.__reactInternalMemoizedMaskedChildContext = w), w;
  }
  function xr(d) {
    return d = d.childContextTypes, d != null;
  }
  function yo() {
    Fi(Mr), Fi(Gt);
  }
  function jl(d, h, m) {
    if (Gt.current !== xs)
      throw Error(i(168));
    Vi(Gt, h), Vi(Mr, m);
  }
  function cf(d, h, m) {
    var x = d.stateNode;
    if (h = h.childContextTypes, typeof x.getChildContext != "function")
      return m;
    x = x.getChildContext();
    for (var w in x)
      if (!(w in h))
        throw Error(i(108, _t(d) || "Unknown", w));
    return j({}, m, x);
  }
  function yv(d) {
    return d = (d = d.stateNode) && d.__reactInternalMemoizedMergedChildContext || xs, Ea = Gt.current, Vi(Gt, d), Vi(Mr, Mr.current), !0;
  }
  function _0(d, h, m) {
    var x = d.stateNode;
    if (!x)
      throw Error(i(169));
    m ? (d = cf(d, h, Ea), x.__reactInternalMemoizedMergedChildContext = d, Fi(Mr), Fi(Gt), Vi(Gt, d)) : Fi(Mr), Vi(Mr, m);
  }
  var Ka = null, pn = !1, hf = !1;
  function w_(d) {
    Ka === null ? Ka = [d] : Ka.push(d);
  }
  function T_(d) {
    pn = !0, w_(d);
  }
  function ba() {
    if (!hf && Ka !== null) {
      hf = !0;
      var d = 0, h = Gi;
      try {
        var m = Ka;
        for (Gi = 1; d < m.length; d++) {
          var x = m[d];
          do
            x = x(!0);
          while (x !== null);
        }
        Ka = null, pn = !1;
      } catch (w) {
        throw Ka !== null && (Ka = Ka.slice(d + 1)), ci(Zs, ba), w;
      } finally {
        Gi = h, hf = !1;
      }
    }
    return null;
  }
  var Yl = [], wa = 0, Zu = null, Sc = 0, Ta = [], Gn = 0, xo = null, En = 1, ol = "";
  function ja(d, h) {
    Yl[wa++] = Sc, Yl[wa++] = Zu, Zu = d, Sc = h;
  }
  function I_(d, h, m) {
    Ta[Gn++] = En, Ta[Gn++] = ol, Ta[Gn++] = xo, xo = d;
    var x = En;
    d = ol;
    var w = 32 - po(x) - 1;
    x &= ~(1 << w), m += 1;
    var D = 32 - po(h) + w;
    if (30 < D) {
      var F = w - w % 5;
      D = (x & (1 << F) - 1).toString(32), x >>= F, w -= F, En = 1 << 32 - po(h) + w | m << w | x, ol = D + d;
    } else
      En = 1 << D | m << w | x, ol = d;
  }
  function xv(d) {
    d.return !== null && (ja(d, 1), I_(d, 1, 0));
  }
  function D_(d) {
    for (; d === Zu; )
      Zu = Yl[--wa], Yl[wa] = null, Sc = Yl[--wa], Yl[wa] = null;
    for (; d === xo; )
      xo = Ta[--Gn], Ta[Gn] = null, ol = Ta[--Gn], Ta[Gn] = null, En = Ta[--Gn], Ta[Gn] = null;
  }
  var Ya = null, Ia = null, gr = !1, So = null;
  function A_(d, h) {
    var m = Do(5, null, null, 0);
    m.elementType = "DELETED", m.stateNode = h, m.return = d, h = d.deletions, h === null ? (d.deletions = [m], d.flags |= 16) : h.push(m);
  }
  function C0(d, h) {
    switch (d.tag) {
      case 5:
        var m = d.type;
        return h = h.nodeType !== 1 || m.toLowerCase() !== h.nodeName.toLowerCase() ? null : h, h !== null ? (d.stateNode = h, Ya = d, Ia = Jo(h.firstChild), !0) : !1;
      case 6:
        return h = d.pendingProps === "" || h.nodeType !== 3 ? null : h, h !== null ? (d.stateNode = h, Ya = d, Ia = null, !0) : !1;
      case 13:
        return h = h.nodeType !== 8 ? null : h, h !== null ? (m = xo !== null ? { id: En, overflow: ol } : null, d.memoizedState = { dehydrated: h, treeContext: m, retryLane: 1073741824 }, m = Do(18, null, null, 0), m.stateNode = h, m.return = d, d.child = m, Ya = d, Ia = null, !0) : !1;
      default:
        return !1;
    }
  }
  function Sv(d) {
    return (d.mode & 1) !== 0 && (d.flags & 128) === 0;
  }
  function Ev(d) {
    if (gr) {
      var h = Ia;
      if (h) {
        var m = h;
        if (!C0(d, h)) {
          if (Sv(d))
            throw Error(i(418));
          h = Jo(m.nextSibling);
          var x = Ya;
          h && C0(d, h) ? A_(x, m) : (d.flags = d.flags & -4097 | 2, gr = !1, Ya = d);
        }
      } else {
        if (Sv(d))
          throw Error(i(418));
        d.flags = d.flags & -4097 | 2, gr = !1, Ya = d;
      }
    }
  }
  function y0(d) {
    for (d = d.return; d !== null && d.tag !== 5 && d.tag !== 3 && d.tag !== 13; )
      d = d.return;
    Ya = d;
  }
  function bv(d) {
    if (d !== Ya)
      return !1;
    if (!gr)
      return y0(d), gr = !0, !1;
    var h;
    if ((h = d.tag !== 3) && !(h = d.tag !== 5) && (h = d.type, h = h !== "head" && h !== "body" && !lf(d.type, d.memoizedProps)), h && (h = Ia)) {
      if (Sv(d))
        throw x0(), Error(i(418));
      for (; h; )
        A_(d, h), h = Jo(h.nextSibling);
    }
    if (y0(d), d.tag === 13) {
      if (d = d.memoizedState, d = d !== null ? d.dehydrated : null, !d)
        throw Error(i(317));
      e: {
        for (d = d.nextSibling, h = 0; d; ) {
          if (d.nodeType === 8) {
            var m = d.data;
            if (m === "/$") {
              if (h === 0) {
                Ia = Jo(d.nextSibling);
                break e;
              }
              h--;
            } else
              m !== "$" && m !== "$!" && m !== "$?" || h++;
          }
          d = d.nextSibling;
        }
        Ia = null;
      }
    } else
      Ia = Ya ? Jo(d.stateNode.nextSibling) : null;
    return !0;
  }
  function x0() {
    for (var d = Ia; d; )
      d = Jo(d.nextSibling);
  }
  function Tr() {
    Ia = Ya = null, gr = !1;
  }
  function O_(d) {
    So === null ? So = [d] : So.push(d);
  }
  var wv = te.ReactCurrentBatchConfig;
  function qa(d, h) {
    if (d && d.defaultProps) {
      h = j({}, h), d = d.defaultProps;
      for (var m in d)
        h[m] === void 0 && (h[m] = d[m]);
      return h;
    }
    return h;
  }
  var Ss = ri(null), Tv = null, ql = null, R_ = null;
  function L_() {
    R_ = ql = Tv = null;
  }
  function sl(d) {
    var h = Ss.current;
    Fi(Ss), d._currentValue = h;
  }
  function tn(d, h, m) {
    for (; d !== null; ) {
      var x = d.alternate;
      if ((d.childLanes & h) !== h ? (d.childLanes |= h, x !== null && (x.childLanes |= h)) : x !== null && (x.childLanes & h) !== h && (x.childLanes |= h), d === m)
        break;
      d = d.return;
    }
  }
  function it(d, h) {
    Tv = d, R_ = ql = null, d = d.dependencies, d !== null && d.firstContext !== null && (d.lanes & h && (Kr = !0), d.firstContext = null);
  }
  function Vr(d) {
    var h = d._currentValue;
    if (R_ !== d)
      if (d = { context: d, memoizedValue: h, next: null }, ql === null) {
        if (Tv === null)
          throw Error(i(308));
        ql = d, Tv.dependencies = { lanes: 0, firstContext: d };
      } else
        ql = ql.next = d;
    return h;
  }
  var bn = null;
  function M_(d) {
    bn === null ? bn = [d] : bn.push(d);
  }
  function S0(d, h, m, x) {
    var w = h.interleaved;
    return w === null ? (m.next = m, M_(h)) : (m.next = w.next, w.next = m), h.interleaved = m, ll(d, x);
  }
  function ll(d, h) {
    d.lanes |= h;
    var m = d.alternate;
    for (m !== null && (m.lanes |= h), m = d, d = d.return; d !== null; )
      d.childLanes |= h, m = d.alternate, m !== null && (m.childLanes |= h), m = d, d = d.return;
    return m.tag === 3 ? m.stateNode : null;
  }
  var Xl = !1;
  function k_(d) {
    d.updateQueue = { baseState: d.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function rn(d, h) {
    d = d.updateQueue, h.updateQueue === d && (h.updateQueue = { baseState: d.baseState, firstBaseUpdate: d.firstBaseUpdate, lastBaseUpdate: d.lastBaseUpdate, shared: d.shared, effects: d.effects });
  }
  function ul(d, h) {
    return { eventTime: d, lane: h, tag: 0, payload: null, callback: null, next: null };
  }
  function Ql(d, h, m) {
    var x = d.updateQueue;
    if (x === null)
      return null;
    if (x = x.shared, pi & 2) {
      var w = x.pending;
      return w === null ? h.next = h : (h.next = w.next, w.next = h), x.pending = h, ll(d, m);
    }
    return w = x.interleaved, w === null ? (h.next = h, M_(x)) : (h.next = w.next, w.next = h), x.interleaved = h, ll(d, m);
  }
  function Iv(d, h, m) {
    if (h = h.updateQueue, h !== null && (h = h.shared, (m & 4194240) !== 0)) {
      var x = h.lanes;
      x &= d.pendingLanes, m |= x, h.lanes = m, Wh(d, m);
    }
  }
  function P_(d, h) {
    var m = d.updateQueue, x = d.alternate;
    if (x !== null && (x = x.updateQueue, m === x)) {
      var w = null, D = null;
      if (m = m.firstBaseUpdate, m !== null) {
        do {
          var F = { eventTime: m.eventTime, lane: m.lane, tag: m.tag, payload: m.payload, callback: m.callback, next: null };
          D === null ? w = D = F : D = D.next = F, m = m.next;
        } while (m !== null);
        D === null ? w = D = h : D = D.next = h;
      } else
        w = D = h;
      m = { baseState: x.baseState, firstBaseUpdate: w, lastBaseUpdate: D, shared: x.shared, effects: x.effects }, d.updateQueue = m;
      return;
    }
    d = m.lastBaseUpdate, d === null ? m.firstBaseUpdate = h : d.next = h, m.lastBaseUpdate = h;
  }
  function Zl(d, h, m, x) {
    var w = d.updateQueue;
    Xl = !1;
    var D = w.firstBaseUpdate, F = w.lastBaseUpdate, W = w.shared.pending;
    if (W !== null) {
      w.shared.pending = null;
      var Y = W, he = Y.next;
      Y.next = null, F === null ? D = he : F.next = he, F = Y;
      var Be = d.alternate;
      Be !== null && (Be = Be.updateQueue, W = Be.lastBaseUpdate, W !== F && (W === null ? Be.firstBaseUpdate = he : W.next = he, Be.lastBaseUpdate = Y));
    }
    if (D !== null) {
      var Ne = w.baseState;
      F = 0, Be = he = Y = null, W = D;
      do {
        var Pe = W.lane, ut = W.eventTime;
        if ((x & Pe) === Pe) {
          Be !== null && (Be = Be.next = {
            eventTime: ut,
            lane: 0,
            tag: W.tag,
            payload: W.payload,
            callback: W.callback,
            next: null
          });
          e: {
            var xt = d, bt = W;
            switch (Pe = h, ut = m, bt.tag) {
              case 1:
                if (xt = bt.payload, typeof xt == "function") {
                  Ne = xt.call(ut, Ne, Pe);
                  break e;
                }
                Ne = xt;
                break e;
              case 3:
                xt.flags = xt.flags & -65537 | 128;
              case 0:
                if (xt = bt.payload, Pe = typeof xt == "function" ? xt.call(ut, Ne, Pe) : xt, Pe == null)
                  break e;
                Ne = j({}, Ne, Pe);
                break e;
              case 2:
                Xl = !0;
            }
          }
          W.callback !== null && W.lane !== 0 && (d.flags |= 64, Pe = w.effects, Pe === null ? w.effects = [W] : Pe.push(W));
        } else
          ut = { eventTime: ut, lane: Pe, tag: W.tag, payload: W.payload, callback: W.callback, next: null }, Be === null ? (he = Be = ut, Y = Ne) : Be = Be.next = ut, F |= Pe;
        if (W = W.next, W === null) {
          if (W = w.shared.pending, W === null)
            break;
          Pe = W, W = Pe.next, Pe.next = null, w.lastBaseUpdate = Pe, w.shared.pending = null;
        }
      } while (!0);
      if (Be === null && (Y = Ne), w.baseState = Y, w.firstBaseUpdate = he, w.lastBaseUpdate = Be, h = w.shared.interleaved, h !== null) {
        w = h;
        do
          F |= w.lane, w = w.next;
        while (w !== h);
      } else
        D === null && (w.shared.lanes = 0);
      fl |= F, d.lanes = F, d.memoizedState = Ne;
    }
  }
  function Ju(d, h, m) {
    if (d = h.effects, h.effects = null, d !== null)
      for (h = 0; h < d.length; h++) {
        var x = d[h], w = x.callback;
        if (w !== null) {
          if (x.callback = null, x = m, typeof w != "function")
            throw Error(i(191, w));
          w.call(x);
        }
      }
  }
  var E0 = new t.Component().refs;
  function F_(d, h, m, x) {
    h = d.memoizedState, m = m(x, h), m = m == null ? h : j({}, h, m), d.memoizedState = m, d.lanes === 0 && (d.updateQueue.baseState = m);
  }
  var Dv = { isMounted: function(d) {
    return (d = d._reactInternals) ? Fe(d) === d : !1;
  }, enqueueSetState: function(d, h, m) {
    d = d._reactInternals;
    var x = qn(), w = jr(d), D = ul(x, w);
    D.payload = h, m != null && (D.callback = m), h = Ql(d, D, w), h !== null && (Xn(h, d, w, x), Iv(h, d, w));
  }, enqueueReplaceState: function(d, h, m) {
    d = d._reactInternals;
    var x = qn(), w = jr(d), D = ul(x, w);
    D.tag = 1, D.payload = h, m != null && (D.callback = m), h = Ql(d, D, w), h !== null && (Xn(h, d, w, x), Iv(h, d, w));
  }, enqueueForceUpdate: function(d, h) {
    d = d._reactInternals;
    var m = qn(), x = jr(d), w = ul(m, x);
    w.tag = 2, h != null && (w.callback = h), h = Ql(d, w, x), h !== null && (Xn(h, d, x, m), Iv(h, d, x));
  } };
  function b0(d, h, m, x, w, D, F) {
    return d = d.stateNode, typeof d.shouldComponentUpdate == "function" ? d.shouldComponentUpdate(x, D, F) : h.prototype && h.prototype.isPureReactComponent ? !ef(m, x) || !ef(w, D) : !0;
  }
  function w0(d, h, m) {
    var x = !1, w = xs, D = h.contextType;
    return typeof D == "object" && D !== null ? D = Vr(D) : (w = xr(h) ? Ea : Gt.current, x = h.contextTypes, D = (x = x != null) ? Co(d, w) : xs), h = new h(m, D), d.memoizedState = h.state !== null && h.state !== void 0 ? h.state : null, h.updater = Dv, d.stateNode = h, h._reactInternals = d, x && (d = d.stateNode, d.__reactInternalMemoizedUnmaskedChildContext = w, d.__reactInternalMemoizedMaskedChildContext = D), h;
  }
  function T0(d, h, m, x) {
    d = h.state, typeof h.componentWillReceiveProps == "function" && h.componentWillReceiveProps(m, x), typeof h.UNSAFE_componentWillReceiveProps == "function" && h.UNSAFE_componentWillReceiveProps(m, x), h.state !== d && Dv.enqueueReplaceState(h, h.state, null);
  }
  function Av(d, h, m, x) {
    var w = d.stateNode;
    w.props = m, w.state = d.memoizedState, w.refs = E0, k_(d);
    var D = h.contextType;
    typeof D == "object" && D !== null ? w.context = Vr(D) : (D = xr(h) ? Ea : Gt.current, w.context = Co(d, D)), w.state = d.memoizedState, D = h.getDerivedStateFromProps, typeof D == "function" && (F_(d, h, D, m), w.state = d.memoizedState), typeof h.getDerivedStateFromProps == "function" || typeof w.getSnapshotBeforeUpdate == "function" || typeof w.UNSAFE_componentWillMount != "function" && typeof w.componentWillMount != "function" || (h = w.state, typeof w.componentWillMount == "function" && w.componentWillMount(), typeof w.UNSAFE_componentWillMount == "function" && w.UNSAFE_componentWillMount(), h !== w.state && Dv.enqueueReplaceState(w, w.state, null), Zl(d, m, w, x), w.state = d.memoizedState), typeof w.componentDidMount == "function" && (d.flags |= 4194308);
  }
  function Ec(d, h, m) {
    if (d = m.ref, d !== null && typeof d != "function" && typeof d != "object") {
      if (m._owner) {
        if (m = m._owner, m) {
          if (m.tag !== 1)
            throw Error(i(309));
          var x = m.stateNode;
        }
        if (!x)
          throw Error(i(147, d));
        var w = x, D = "" + d;
        return h !== null && h.ref !== null && typeof h.ref == "function" && h.ref._stringRef === D ? h.ref : (h = function(F) {
          var W = w.refs;
          W === E0 && (W = w.refs = {}), F === null ? delete W[D] : W[D] = F;
        }, h._stringRef = D, h);
      }
      if (typeof d != "string")
        throw Error(i(284));
      if (!m._owner)
        throw Error(i(290, d));
    }
    return d;
  }
  function Ov(d, h) {
    throw d = Object.prototype.toString.call(h), Error(i(31, d === "[object Object]" ? "object with keys {" + Object.keys(h).join(", ") + "}" : d));
  }
  function I0(d) {
    var h = d._init;
    return h(d._payload);
  }
  function D0(d) {
    function h(oe, Z) {
      if (d) {
        var ue = oe.deletions;
        ue === null ? (oe.deletions = [Z], oe.flags |= 16) : ue.push(Z);
      }
    }
    function m(oe, Z) {
      if (!d)
        return null;
      for (; Z !== null; )
        h(oe, Z), Z = Z.sibling;
      return null;
    }
    function x(oe, Z) {
      for (oe = /* @__PURE__ */ new Map(); Z !== null; )
        Z.key !== null ? oe.set(Z.key, Z) : oe.set(Z.index, Z), Z = Z.sibling;
      return oe;
    }
    function w(oe, Z) {
      return oe = ou(oe, Z), oe.index = 0, oe.sibling = null, oe;
    }
    function D(oe, Z, ue) {
      return oe.index = ue, d ? (ue = oe.alternate, ue !== null ? (ue = ue.index, ue < Z ? (oe.flags |= 2, Z) : ue) : (oe.flags |= 2, Z)) : (oe.flags |= 1048576, Z);
    }
    function F(oe) {
      return d && oe.alternate === null && (oe.flags |= 2), oe;
    }
    function W(oe, Z, ue, Ge) {
      return Z === null || Z.tag !== 6 ? (Z = Rf(ue, oe.mode, Ge), Z.return = oe, Z) : (Z = w(Z, ue), Z.return = oe, Z);
    }
    function Y(oe, Z, ue, Ge) {
      var It = ue.type;
      return It === pe ? Be(oe, Z, ue.props.children, Ge, ue.key) : Z !== null && (Z.elementType === It || typeof It == "object" && It !== null && It.$$typeof === we && I0(It) === Z.type) ? (Ge = w(Z, ue.props), Ge.ref = Ec(oe, Z, ue), Ge.return = oe, Ge) : (Ge = lg(ue.type, ue.key, ue.props, null, oe.mode, Ge), Ge.ref = Ec(oe, Z, ue), Ge.return = oe, Ge);
    }
    function he(oe, Z, ue, Ge) {
      return Z === null || Z.tag !== 4 || Z.stateNode.containerInfo !== ue.containerInfo || Z.stateNode.implementation !== ue.implementation ? (Z = _d(ue, oe.mode, Ge), Z.return = oe, Z) : (Z = w(Z, ue.children || []), Z.return = oe, Z);
    }
    function Be(oe, Z, ue, Ge, It) {
      return Z === null || Z.tag !== 7 ? (Z = md(ue, oe.mode, Ge, It), Z.return = oe, Z) : (Z = w(Z, ue), Z.return = oe, Z);
    }
    function Ne(oe, Z, ue) {
      if (typeof Z == "string" && Z !== "" || typeof Z == "number")
        return Z = Rf("" + Z, oe.mode, ue), Z.return = oe, Z;
      if (typeof Z == "object" && Z !== null) {
        switch (Z.$$typeof) {
          case z:
            return ue = lg(Z.type, Z.key, Z.props, null, oe.mode, ue), ue.ref = Ec(oe, null, Z), ue.return = oe, ue;
          case ie:
            return Z = _d(Z, oe.mode, ue), Z.return = oe, Z;
          case we:
            var Ge = Z._init;
            return Ne(oe, Ge(Z._payload), ue);
        }
        if (Rr(Z) || Ae(Z))
          return Z = md(Z, oe.mode, ue, null), Z.return = oe, Z;
        Ov(oe, Z);
      }
      return null;
    }
    function Pe(oe, Z, ue, Ge) {
      var It = Z !== null ? Z.key : null;
      if (typeof ue == "string" && ue !== "" || typeof ue == "number")
        return It !== null ? null : W(oe, Z, "" + ue, Ge);
      if (typeof ue == "object" && ue !== null) {
        switch (ue.$$typeof) {
          case z:
            return ue.key === It ? Y(oe, Z, ue, Ge) : null;
          case ie:
            return ue.key === It ? he(oe, Z, ue, Ge) : null;
          case we:
            return It = ue._init, Pe(
              oe,
              Z,
              It(ue._payload),
              Ge
            );
        }
        if (Rr(ue) || Ae(ue))
          return It !== null ? null : Be(oe, Z, ue, Ge, null);
        Ov(oe, ue);
      }
      return null;
    }
    function ut(oe, Z, ue, Ge, It) {
      if (typeof Ge == "string" && Ge !== "" || typeof Ge == "number")
        return oe = oe.get(ue) || null, W(Z, oe, "" + Ge, It);
      if (typeof Ge == "object" && Ge !== null) {
        switch (Ge.$$typeof) {
          case z:
            return oe = oe.get(Ge.key === null ? ue : Ge.key) || null, Y(Z, oe, Ge, It);
          case ie:
            return oe = oe.get(Ge.key === null ? ue : Ge.key) || null, he(Z, oe, Ge, It);
          case we:
            var St = Ge._init;
            return ut(oe, Z, ue, St(Ge._payload), It);
        }
        if (Rr(Ge) || Ae(Ge))
          return oe = oe.get(ue) || null, Be(Z, oe, Ge, It, null);
        Ov(Z, Ge);
      }
      return null;
    }
    function xt(oe, Z, ue, Ge) {
      for (var It = null, St = null, At = Z, Kt = Z = 0, mn = null; At !== null && Kt < ue.length; Kt++) {
        At.index > Kt ? (mn = At, At = null) : mn = At.sibling;
        var Ai = Pe(oe, At, ue[Kt], Ge);
        if (Ai === null) {
          At === null && (At = mn);
          break;
        }
        d && At && Ai.alternate === null && h(oe, At), Z = D(Ai, Z, Kt), St === null ? It = Ai : St.sibling = Ai, St = Ai, At = mn;
      }
      if (Kt === ue.length)
        return m(oe, At), gr && ja(oe, Kt), It;
      if (At === null) {
        for (; Kt < ue.length; Kt++)
          At = Ne(oe, ue[Kt], Ge), At !== null && (Z = D(At, Z, Kt), St === null ? It = At : St.sibling = At, St = At);
        return gr && ja(oe, Kt), It;
      }
      for (At = x(oe, At); Kt < ue.length; Kt++)
        mn = ut(At, oe, Kt, ue[Kt], Ge), mn !== null && (d && mn.alternate !== null && At.delete(mn.key === null ? Kt : mn.key), Z = D(mn, Z, Kt), St === null ? It = mn : St.sibling = mn, St = mn);
      return d && At.forEach(function(su) {
        return h(oe, su);
      }), gr && ja(oe, Kt), It;
    }
    function bt(oe, Z, ue, Ge) {
      var It = Ae(ue);
      if (typeof It != "function")
        throw Error(i(150));
      if (ue = It.call(ue), ue == null)
        throw Error(i(151));
      for (var St = It = null, At = Z, Kt = Z = 0, mn = null, Ai = ue.next(); At !== null && !Ai.done; Kt++, Ai = ue.next()) {
        At.index > Kt ? (mn = At, At = null) : mn = At.sibling;
        var su = Pe(oe, At, Ai.value, Ge);
        if (su === null) {
          At === null && (At = mn);
          break;
        }
        d && At && su.alternate === null && h(oe, At), Z = D(su, Z, Kt), St === null ? It = su : St.sibling = su, St = su, At = mn;
      }
      if (Ai.done)
        return m(
          oe,
          At
        ), gr && ja(oe, Kt), It;
      if (At === null) {
        for (; !Ai.done; Kt++, Ai = ue.next())
          Ai = Ne(oe, Ai.value, Ge), Ai !== null && (Z = D(Ai, Z, Kt), St === null ? It = Ai : St.sibling = Ai, St = Ai);
        return gr && ja(oe, Kt), It;
      }
      for (At = x(oe, At); !Ai.done; Kt++, Ai = ue.next())
        Ai = ut(At, oe, Kt, Ai.value, Ge), Ai !== null && (d && Ai.alternate !== null && At.delete(Ai.key === null ? Kt : Ai.key), Z = D(Ai, Z, Kt), St === null ? It = Ai : St.sibling = Ai, St = Ai);
      return d && At.forEach(function(TD) {
        return h(oe, TD);
      }), gr && ja(oe, Kt), It;
    }
    function Nr(oe, Z, ue, Ge) {
      if (typeof ue == "object" && ue !== null && ue.type === pe && ue.key === null && (ue = ue.props.children), typeof ue == "object" && ue !== null) {
        switch (ue.$$typeof) {
          case z:
            e: {
              for (var It = ue.key, St = Z; St !== null; ) {
                if (St.key === It) {
                  if (It = ue.type, It === pe) {
                    if (St.tag === 7) {
                      m(oe, St.sibling), Z = w(St, ue.props.children), Z.return = oe, oe = Z;
                      break e;
                    }
                  } else if (St.elementType === It || typeof It == "object" && It !== null && It.$$typeof === we && I0(It) === St.type) {
                    m(oe, St.sibling), Z = w(St, ue.props), Z.ref = Ec(oe, St, ue), Z.return = oe, oe = Z;
                    break e;
                  }
                  m(oe, St);
                  break;
                } else
                  h(oe, St);
                St = St.sibling;
              }
              ue.type === pe ? (Z = md(ue.props.children, oe.mode, Ge, ue.key), Z.return = oe, oe = Z) : (Ge = lg(ue.type, ue.key, ue.props, null, oe.mode, Ge), Ge.ref = Ec(oe, Z, ue), Ge.return = oe, oe = Ge);
            }
            return F(oe);
          case ie:
            e: {
              for (St = ue.key; Z !== null; ) {
                if (Z.key === St)
                  if (Z.tag === 4 && Z.stateNode.containerInfo === ue.containerInfo && Z.stateNode.implementation === ue.implementation) {
                    m(oe, Z.sibling), Z = w(Z, ue.children || []), Z.return = oe, oe = Z;
                    break e;
                  } else {
                    m(oe, Z);
                    break;
                  }
                else
                  h(oe, Z);
                Z = Z.sibling;
              }
              Z = _d(ue, oe.mode, Ge), Z.return = oe, oe = Z;
            }
            return F(oe);
          case we:
            return St = ue._init, Nr(oe, Z, St(ue._payload), Ge);
        }
        if (Rr(ue))
          return xt(oe, Z, ue, Ge);
        if (Ae(ue))
          return bt(oe, Z, ue, Ge);
        Ov(oe, ue);
      }
      return typeof ue == "string" && ue !== "" || typeof ue == "number" ? (ue = "" + ue, Z !== null && Z.tag === 6 ? (m(oe, Z.sibling), Z = w(Z, ue), Z.return = oe, oe = Z) : (m(oe, Z), Z = Rf(ue, oe.mode, Ge), Z.return = oe, oe = Z), F(oe)) : m(oe, Z);
    }
    return Nr;
  }
  var bc = D0(!0), A0 = D0(!1), ff = {}, es = ri(ff), pf = ri(ff), wc = ri(ff);
  function ed(d) {
    if (d === ff)
      throw Error(i(174));
    return d;
  }
  function B_(d, h) {
    switch (Vi(wc, h), Vi(pf, d), Vi(es, ff), d = h.nodeType, d) {
      case 9:
      case 11:
        h = (h = h.documentElement) ? h.namespaceURI : hr(null, "");
        break;
      default:
        d = d === 8 ? h.parentNode : h, h = d.namespaceURI || null, d = d.tagName, h = hr(h, d);
    }
    Fi(es), Vi(es, h);
  }
  function Jl() {
    Fi(es), Fi(pf), Fi(wc);
  }
  function Ft(d) {
    ed(wc.current);
    var h = ed(es.current), m = hr(h, d.type);
    h !== m && (Vi(pf, d), Vi(es, m));
  }
  function li(d) {
    pf.current === d && (Fi(es), Fi(pf));
  }
  var Vt = ri(0);
  function Ir(d) {
    for (var h = d; h !== null; ) {
      if (h.tag === 13) {
        var m = h.memoizedState;
        if (m !== null && (m = m.dehydrated, m === null || m.data === "$?" || m.data === "$!"))
          return h;
      } else if (h.tag === 19 && h.memoizedProps.revealOrder !== void 0) {
        if (h.flags & 128)
          return h;
      } else if (h.child !== null) {
        h.child.return = h, h = h.child;
        continue;
      }
      if (h === d)
        break;
      for (; h.sibling === null; ) {
        if (h.return === null || h.return === d)
          return null;
        h = h.return;
      }
      h.sibling.return = h.return, h = h.sibling;
    }
    return null;
  }
  var Eo = [];
  function Rv() {
    for (var d = 0; d < Eo.length; d++)
      Eo[d]._workInProgressVersionPrimary = null;
    Eo.length = 0;
  }
  var Lv = te.ReactCurrentDispatcher, V_ = te.ReactCurrentBatchConfig, td = 0, mr = null, Te = null, yi = null, Ht = !1, Es = !1, Xa = 0, id = 0;
  function _r() {
    throw Error(i(321));
  }
  function rd(d, h) {
    if (h === null)
      return !1;
    for (var m = 0; m < h.length && m < d.length; m++)
      if (!mo(d[m], h[m]))
        return !1;
    return !0;
  }
  function eu(d, h, m, x, w, D) {
    if (td = D, mr = h, h.memoizedState = null, h.updateQueue = null, h.lanes = 0, Lv.current = d === null || d.memoizedState === null ? lD : uD, d = m(x, w), Es) {
      D = 0;
      do {
        if (Es = !1, Xa = 0, 25 <= D)
          throw Error(i(301));
        D += 1, yi = Te = null, h.updateQueue = null, Lv.current = H_, d = m(x, w);
      } while (Es);
    }
    if (Lv.current = Yv, h = Te !== null && Te.next !== null, td = 0, yi = Te = mr = null, Ht = !1, h)
      throw Error(i(300));
    return d;
  }
  function nd() {
    var d = Xa !== 0;
    return Xa = 0, d;
  }
  function bo() {
    var d = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return yi === null ? mr.memoizedState = yi = d : yi = yi.next = d, yi;
  }
  function Da() {
    if (Te === null) {
      var d = mr.alternate;
      d = d !== null ? d.memoizedState : null;
    } else
      d = Te.next;
    var h = yi === null ? mr.memoizedState : yi.next;
    if (h !== null)
      yi = h, Te = d;
    else {
      if (d === null)
        throw Error(i(310));
      Te = d, d = { memoizedState: Te.memoizedState, baseState: Te.baseState, baseQueue: Te.baseQueue, queue: Te.queue, next: null }, yi === null ? mr.memoizedState = yi = d : yi = yi.next = d;
    }
    return yi;
  }
  function ad(d, h) {
    return typeof h == "function" ? h(d) : h;
  }
  function vf(d) {
    var h = Da(), m = h.queue;
    if (m === null)
      throw Error(i(311));
    m.lastRenderedReducer = d;
    var x = Te, w = x.baseQueue, D = m.pending;
    if (D !== null) {
      if (w !== null) {
        var F = w.next;
        w.next = D.next, D.next = F;
      }
      x.baseQueue = w = D, m.pending = null;
    }
    if (w !== null) {
      D = w.next, x = x.baseState;
      var W = F = null, Y = null, he = D;
      do {
        var Be = he.lane;
        if ((td & Be) === Be)
          Y !== null && (Y = Y.next = { lane: 0, action: he.action, hasEagerState: he.hasEagerState, eagerState: he.eagerState, next: null }), x = he.hasEagerState ? he.eagerState : d(x, he.action);
        else {
          var Ne = {
            lane: Be,
            action: he.action,
            hasEagerState: he.hasEagerState,
            eagerState: he.eagerState,
            next: null
          };
          Y === null ? (W = Y = Ne, F = x) : Y = Y.next = Ne, mr.lanes |= Be, fl |= Be;
        }
        he = he.next;
      } while (he !== null && he !== D);
      Y === null ? F = x : Y.next = W, mo(x, h.memoizedState) || (Kr = !0), h.memoizedState = x, h.baseState = F, h.baseQueue = Y, m.lastRenderedState = x;
    }
    if (d = m.interleaved, d !== null) {
      w = d;
      do
        D = w.lane, mr.lanes |= D, fl |= D, w = w.next;
      while (w !== d);
    } else
      w === null && (m.lanes = 0);
    return [h.memoizedState, m.dispatch];
  }
  function gf(d) {
    var h = Da(), m = h.queue;
    if (m === null)
      throw Error(i(311));
    m.lastRenderedReducer = d;
    var x = m.dispatch, w = m.pending, D = h.memoizedState;
    if (w !== null) {
      m.pending = null;
      var F = w = w.next;
      do
        D = d(D, F.action), F = F.next;
      while (F !== w);
      mo(D, h.memoizedState) || (Kr = !0), h.memoizedState = D, h.baseQueue === null && (h.baseState = D), m.lastRenderedState = D;
    }
    return [D, x];
  }
  function Mv() {
  }
  function kv(d, h) {
    var m = mr, x = Da(), w = h(), D = !mo(x.memoizedState, w);
    if (D && (x.memoizedState = w, Kr = !0), x = x.queue, mf(Bv.bind(null, m, x, d), [d]), x.getSnapshot !== h || D || yi !== null && yi.memoizedState.tag & 1) {
      if (m.flags |= 2048, od(9, Fv.bind(null, m, x, w, h), void 0, null), Dr === null)
        throw Error(i(349));
      td & 30 || Pv(m, h, w);
    }
    return w;
  }
  function Pv(d, h, m) {
    d.flags |= 16384, d = { getSnapshot: h, value: m }, h = mr.updateQueue, h === null ? (h = { lastEffect: null, stores: null }, mr.updateQueue = h, h.stores = [d]) : (m = h.stores, m === null ? h.stores = [d] : m.push(d));
  }
  function Fv(d, h, m, x) {
    h.value = m, h.getSnapshot = x, Vv(h) && Nv(d);
  }
  function Bv(d, h, m) {
    return m(function() {
      Vv(h) && Nv(d);
    });
  }
  function Vv(d) {
    var h = d.getSnapshot;
    d = d.value;
    try {
      var m = h();
      return !mo(d, m);
    } catch {
      return !0;
    }
  }
  function Nv(d) {
    var h = ll(d, 1);
    h !== null && Xn(h, d, 1, -1);
  }
  function Hv(d) {
    var h = bo();
    return typeof d == "function" && (d = d()), h.memoizedState = h.baseState = d, d = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: ad, lastRenderedState: d }, h.queue = d, d = d.dispatch = jv.bind(null, mr, d), [h.memoizedState, d];
  }
  function od(d, h, m, x) {
    return d = { tag: d, create: h, destroy: m, deps: x, next: null }, h = mr.updateQueue, h === null ? (h = { lastEffect: null, stores: null }, mr.updateQueue = h, h.lastEffect = d.next = d) : (m = h.lastEffect, m === null ? h.lastEffect = d.next = d : (x = m.next, m.next = d, d.next = x, h.lastEffect = d)), d;
  }
  function $v() {
    return Da().memoizedState;
  }
  function sd(d, h, m, x) {
    var w = bo();
    mr.flags |= d, w.memoizedState = od(1 | h, m, void 0, x === void 0 ? null : x);
  }
  function dl(d, h, m, x) {
    var w = Da();
    x = x === void 0 ? null : x;
    var D = void 0;
    if (Te !== null) {
      var F = Te.memoizedState;
      if (D = F.destroy, x !== null && rd(x, F.deps)) {
        w.memoizedState = od(h, m, D, x);
        return;
      }
    }
    mr.flags |= d, w.memoizedState = od(1 | h, m, D, x);
  }
  function zv(d, h) {
    return sd(8390656, 8, d, h);
  }
  function mf(d, h) {
    return dl(2048, 8, d, h);
  }
  function Wv(d, h) {
    return dl(4, 2, d, h);
  }
  function Uv(d, h) {
    return dl(4, 4, d, h);
  }
  function N_(d, h) {
    if (typeof h == "function")
      return d = d(), h(d), function() {
        h(null);
      };
    if (h != null)
      return d = d(), h.current = d, function() {
        h.current = null;
      };
  }
  function Tc(d, h, m) {
    return m = m != null ? m.concat([d]) : null, dl(4, 4, N_.bind(null, h, d), m);
  }
  function Gv() {
  }
  function Ic(d, h) {
    var m = Da();
    h = h === void 0 ? null : h;
    var x = m.memoizedState;
    return x !== null && h !== null && rd(h, x[1]) ? x[0] : (m.memoizedState = [d, h], d);
  }
  function tu(d, h) {
    var m = Da();
    h = h === void 0 ? null : h;
    var x = m.memoizedState;
    return x !== null && h !== null && rd(h, x[1]) ? x[0] : (d = d(), m.memoizedState = [d, h], d);
  }
  function Aa(d, h, m) {
    return td & 21 ? (mo(m, h) || (m = tv(), mr.lanes |= m, fl |= m, d.baseState = !0), h) : (d.baseState && (d.baseState = !1, Kr = !0), d.memoizedState = m);
  }
  function sD(d, h) {
    var m = Gi;
    Gi = m !== 0 && 4 > m ? m : 4, d(!0);
    var x = V_.transition;
    V_.transition = {};
    try {
      d(!1), h();
    } finally {
      Gi = m, V_.transition = x;
    }
  }
  function nr() {
    return Da().memoizedState;
  }
  function Kv(d, h, m) {
    var x = jr(d);
    if (m = { lane: x, action: m, hasEagerState: !1, eagerState: null, next: null }, Dc(d))
      _f(h, m);
    else if (m = S0(d, h, m, x), m !== null) {
      var w = qn();
      Xn(m, d, x, w), O0(m, h, x);
    }
  }
  function jv(d, h, m) {
    var x = jr(d), w = { lane: x, action: m, hasEagerState: !1, eagerState: null, next: null };
    if (Dc(d))
      _f(h, w);
    else {
      var D = d.alternate;
      if (d.lanes === 0 && (D === null || D.lanes === 0) && (D = h.lastRenderedReducer, D !== null))
        try {
          var F = h.lastRenderedState, W = D(F, m);
          if (w.hasEagerState = !0, w.eagerState = W, mo(W, F)) {
            var Y = h.interleaved;
            Y === null ? (w.next = w, M_(h)) : (w.next = Y.next, Y.next = w), h.interleaved = w;
            return;
          }
        } catch {
        } finally {
        }
      m = S0(d, h, w, x), m !== null && (w = qn(), Xn(m, d, x, w), O0(m, h, x));
    }
  }
  function Dc(d) {
    var h = d.alternate;
    return d === mr || h !== null && h === mr;
  }
  function _f(d, h) {
    Es = Ht = !0;
    var m = d.pending;
    m === null ? h.next = h : (h.next = m.next, m.next = h), d.pending = h;
  }
  function O0(d, h, m) {
    if (m & 4194240) {
      var x = h.lanes;
      x &= d.pendingLanes, m |= x, h.lanes = m, Wh(d, m);
    }
  }
  var Yv = { readContext: Vr, useCallback: _r, useContext: _r, useEffect: _r, useImperativeHandle: _r, useInsertionEffect: _r, useLayoutEffect: _r, useMemo: _r, useReducer: _r, useRef: _r, useState: _r, useDebugValue: _r, useDeferredValue: _r, useTransition: _r, useMutableSource: _r, useSyncExternalStore: _r, useId: _r, unstable_isNewReconciler: !1 }, lD = { readContext: Vr, useCallback: function(d, h) {
    return bo().memoizedState = [d, h === void 0 ? null : h], d;
  }, useContext: Vr, useEffect: zv, useImperativeHandle: function(d, h, m) {
    return m = m != null ? m.concat([d]) : null, sd(
      4194308,
      4,
      N_.bind(null, h, d),
      m
    );
  }, useLayoutEffect: function(d, h) {
    return sd(4194308, 4, d, h);
  }, useInsertionEffect: function(d, h) {
    return sd(4, 2, d, h);
  }, useMemo: function(d, h) {
    var m = bo();
    return h = h === void 0 ? null : h, d = d(), m.memoizedState = [d, h], d;
  }, useReducer: function(d, h, m) {
    var x = bo();
    return h = m !== void 0 ? m(h) : h, x.memoizedState = x.baseState = h, d = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: d, lastRenderedState: h }, x.queue = d, d = d.dispatch = Kv.bind(null, mr, d), [x.memoizedState, d];
  }, useRef: function(d) {
    var h = bo();
    return d = { current: d }, h.memoizedState = d;
  }, useState: Hv, useDebugValue: Gv, useDeferredValue: function(d) {
    return bo().memoizedState = d;
  }, useTransition: function() {
    var d = Hv(!1), h = d[0];
    return d = sD.bind(null, d[1]), bo().memoizedState = d, [h, d];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(d, h, m) {
    var x = mr, w = bo();
    if (gr) {
      if (m === void 0)
        throw Error(i(407));
      m = m();
    } else {
      if (m = h(), Dr === null)
        throw Error(i(349));
      td & 30 || Pv(x, h, m);
    }
    w.memoizedState = m;
    var D = { value: m, getSnapshot: h };
    return w.queue = D, zv(Bv.bind(
      null,
      x,
      D,
      d
    ), [d]), x.flags |= 2048, od(9, Fv.bind(null, x, D, m, h), void 0, null), m;
  }, useId: function() {
    var d = bo(), h = Dr.identifierPrefix;
    if (gr) {
      var m = ol, x = En;
      m = (x & ~(1 << 32 - po(x) - 1)).toString(32) + m, h = ":" + h + "R" + m, m = Xa++, 0 < m && (h += "H" + m.toString(32)), h += ":";
    } else
      m = id++, h = ":" + h + "r" + m.toString(32) + ":";
    return d.memoizedState = h;
  }, unstable_isNewReconciler: !1 }, uD = {
    readContext: Vr,
    useCallback: Ic,
    useContext: Vr,
    useEffect: mf,
    useImperativeHandle: Tc,
    useInsertionEffect: Wv,
    useLayoutEffect: Uv,
    useMemo: tu,
    useReducer: vf,
    useRef: $v,
    useState: function() {
      return vf(ad);
    },
    useDebugValue: Gv,
    useDeferredValue: function(d) {
      var h = Da();
      return Aa(h, Te.memoizedState, d);
    },
    useTransition: function() {
      var d = vf(ad)[0], h = Da().memoizedState;
      return [d, h];
    },
    useMutableSource: Mv,
    useSyncExternalStore: kv,
    useId: nr,
    unstable_isNewReconciler: !1
  }, H_ = { readContext: Vr, useCallback: Ic, useContext: Vr, useEffect: mf, useImperativeHandle: Tc, useInsertionEffect: Wv, useLayoutEffect: Uv, useMemo: tu, useReducer: gf, useRef: $v, useState: function() {
    return gf(ad);
  }, useDebugValue: Gv, useDeferredValue: function(d) {
    var h = Da();
    return Te === null ? h.memoizedState = d : Aa(h, Te.memoizedState, d);
  }, useTransition: function() {
    var d = gf(ad)[0], h = Da().memoizedState;
    return [d, h];
  }, useMutableSource: Mv, useSyncExternalStore: kv, useId: nr, unstable_isNewReconciler: !1 };
  function Ac(d, h) {
    try {
      var m = "", x = h;
      do
        m += vt(x), x = x.return;
      while (x);
      var w = m;
    } catch (D) {
      w = `
Error generating stack: ` + D.message + `
` + D.stack;
    }
    return { value: d, source: h, stack: w, digest: null };
  }
  function Cf(d, h, m) {
    return { value: d, source: null, stack: m ?? null, digest: h ?? null };
  }
  function qv(d, h) {
    try {
      console.error(h.value);
    } catch (m) {
      setTimeout(function() {
        throw m;
      });
    }
  }
  var dD = typeof WeakMap == "function" ? WeakMap : Map;
  function R0(d, h, m) {
    m = ul(-1, m), m.tag = 3, m.payload = { element: null };
    var x = h.value;
    return m.callback = function() {
      ig || (ig = !0, hd = x), qv(d, h);
    }, m;
  }
  function yf(d, h, m) {
    m = ul(-1, m), m.tag = 3;
    var x = d.type.getDerivedStateFromError;
    if (typeof x == "function") {
      var w = h.value;
      m.payload = function() {
        return x(w);
      }, m.callback = function() {
        qv(d, h);
      };
    }
    var D = d.stateNode;
    return D !== null && typeof D.componentDidCatch == "function" && (m.callback = function() {
      qv(d, h), typeof x != "function" && (Ts === null ? Ts = /* @__PURE__ */ new Set([this]) : Ts.add(this));
      var F = h.stack;
      this.componentDidCatch(h.value, { componentStack: F !== null ? F : "" });
    }), m;
  }
  function L0(d, h, m) {
    var x = d.pingCache;
    if (x === null) {
      x = d.pingCache = new dD();
      var w = /* @__PURE__ */ new Set();
      x.set(h, w);
    } else
      w = x.get(h), w === void 0 && (w = /* @__PURE__ */ new Set(), x.set(h, w));
    w.has(m) || (w.add(m), d = mD.bind(null, d, h, m), h.then(d, d));
  }
  function $_(d) {
    do {
      var h;
      if ((h = d.tag === 13) && (h = d.memoizedState, h = h !== null ? h.dehydrated !== null : !0), h)
        return d;
      d = d.return;
    } while (d !== null);
    return null;
  }
  function z_(d, h, m, x, w) {
    return d.mode & 1 ? (d.flags |= 65536, d.lanes = w, d) : (d === h ? d.flags |= 65536 : (d.flags |= 128, m.flags |= 131072, m.flags &= -52805, m.tag === 1 && (m.alternate === null ? m.tag = 17 : (h = ul(-1, 1), h.tag = 2, Ql(m, h, 1))), m.lanes |= 1), d);
  }
  var cD = te.ReactCurrentOwner, Kr = !1;
  function nn(d, h, m, x) {
    h.child = d === null ? A0(h, null, m, x) : bc(h, d.child, m, x);
  }
  function iu(d, h, m, x, w) {
    m = m.render;
    var D = h.ref;
    return it(h, w), x = eu(d, h, m, x, D, w), m = nd(), d !== null && !Kr ? (h.updateQueue = d.updateQueue, h.flags &= -2053, d.lanes &= ~w, wn(d, h, w)) : (gr && m && xv(h), h.flags |= 1, nn(d, h, x, w), h.child);
  }
  function Xv(d, h, m, x, w) {
    if (d === null) {
      var D = m.type;
      return typeof D == "function" && !sC(D) && D.defaultProps === void 0 && m.compare === null && m.defaultProps === void 0 ? (h.tag = 15, h.type = D, Oa(d, h, D, x, w)) : (d = lg(m.type, null, x, h, h.mode, w), d.ref = h.ref, d.return = h, h.child = d);
    }
    if (D = d.child, !(d.lanes & w)) {
      var F = D.memoizedProps;
      if (m = m.compare, m = m !== null ? m : ef, m(F, x) && d.ref === h.ref)
        return wn(d, h, w);
    }
    return h.flags |= 1, d = ou(D, x), d.ref = h.ref, d.return = h, h.child = d;
  }
  function Oa(d, h, m, x, w) {
    if (d !== null) {
      var D = d.memoizedProps;
      if (ef(D, x) && d.ref === h.ref)
        if (Kr = !1, h.pendingProps = x = D, (d.lanes & w) !== 0)
          d.flags & 131072 && (Kr = !0);
        else
          return h.lanes = d.lanes, wn(d, h, w);
    }
    return Oc(d, h, m, x, w);
  }
  function ld(d, h, m) {
    var x = h.pendingProps, w = x.children, D = d !== null ? d.memoizedState : null;
    if (x.mode === "hidden")
      if (!(h.mode & 1))
        h.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Vi(Fc, Qa), Qa |= m;
      else {
        if (!(m & 1073741824))
          return d = D !== null ? D.baseLanes | m : m, h.lanes = h.childLanes = 1073741824, h.memoizedState = { baseLanes: d, cachePool: null, transitions: null }, h.updateQueue = null, Vi(Fc, Qa), Qa |= d, null;
        h.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, x = D !== null ? D.baseLanes : m, Vi(Fc, Qa), Qa |= x;
      }
    else
      D !== null ? (x = D.baseLanes | m, h.memoizedState = null) : x = m, Vi(Fc, Qa), Qa |= x;
    return nn(d, h, w, m), h.child;
  }
  function ei(d, h) {
    var m = h.ref;
    (d === null && m !== null || d !== null && d.ref !== m) && (h.flags |= 512, h.flags |= 2097152);
  }
  function Oc(d, h, m, x, w) {
    var D = xr(m) ? Ea : Gt.current;
    return D = Co(h, D), it(h, w), m = eu(d, h, m, x, D, w), x = nd(), d !== null && !Kr ? (h.updateQueue = d.updateQueue, h.flags &= -2053, d.lanes &= ~w, wn(d, h, w)) : (gr && x && xv(h), h.flags |= 1, nn(d, h, m, w), h.child);
  }
  function W_(d, h, m, x, w) {
    if (xr(m)) {
      var D = !0;
      yv(h);
    } else
      D = !1;
    if (it(h, w), h.stateNode === null)
      Kn(d, h), w0(h, m, x), Av(h, m, x, w), x = !0;
    else if (d === null) {
      var F = h.stateNode, W = h.memoizedProps;
      F.props = W;
      var Y = F.context, he = m.contextType;
      typeof he == "object" && he !== null ? he = Vr(he) : (he = xr(m) ? Ea : Gt.current, he = Co(h, he));
      var Be = m.getDerivedStateFromProps, Ne = typeof Be == "function" || typeof F.getSnapshotBeforeUpdate == "function";
      Ne || typeof F.UNSAFE_componentWillReceiveProps != "function" && typeof F.componentWillReceiveProps != "function" || (W !== x || Y !== he) && T0(h, F, x, he), Xl = !1;
      var Pe = h.memoizedState;
      F.state = Pe, Zl(h, x, F, w), Y = h.memoizedState, W !== x || Pe !== Y || Mr.current || Xl ? (typeof Be == "function" && (F_(h, m, Be, x), Y = h.memoizedState), (W = Xl || b0(h, m, W, x, Pe, Y, he)) ? (Ne || typeof F.UNSAFE_componentWillMount != "function" && typeof F.componentWillMount != "function" || (typeof F.componentWillMount == "function" && F.componentWillMount(), typeof F.UNSAFE_componentWillMount == "function" && F.UNSAFE_componentWillMount()), typeof F.componentDidMount == "function" && (h.flags |= 4194308)) : (typeof F.componentDidMount == "function" && (h.flags |= 4194308), h.memoizedProps = x, h.memoizedState = Y), F.props = x, F.state = Y, F.context = he, x = W) : (typeof F.componentDidMount == "function" && (h.flags |= 4194308), x = !1);
    } else {
      F = h.stateNode, rn(d, h), W = h.memoizedProps, he = h.type === h.elementType ? W : qa(h.type, W), F.props = he, Ne = h.pendingProps, Pe = F.context, Y = m.contextType, typeof Y == "object" && Y !== null ? Y = Vr(Y) : (Y = xr(m) ? Ea : Gt.current, Y = Co(h, Y));
      var ut = m.getDerivedStateFromProps;
      (Be = typeof ut == "function" || typeof F.getSnapshotBeforeUpdate == "function") || typeof F.UNSAFE_componentWillReceiveProps != "function" && typeof F.componentWillReceiveProps != "function" || (W !== Ne || Pe !== Y) && T0(h, F, x, Y), Xl = !1, Pe = h.memoizedState, F.state = Pe, Zl(h, x, F, w);
      var xt = h.memoizedState;
      W !== Ne || Pe !== xt || Mr.current || Xl ? (typeof ut == "function" && (F_(h, m, ut, x), xt = h.memoizedState), (he = Xl || b0(h, m, he, x, Pe, xt, Y) || !1) ? (Be || typeof F.UNSAFE_componentWillUpdate != "function" && typeof F.componentWillUpdate != "function" || (typeof F.componentWillUpdate == "function" && F.componentWillUpdate(x, xt, Y), typeof F.UNSAFE_componentWillUpdate == "function" && F.UNSAFE_componentWillUpdate(x, xt, Y)), typeof F.componentDidUpdate == "function" && (h.flags |= 4), typeof F.getSnapshotBeforeUpdate == "function" && (h.flags |= 1024)) : (typeof F.componentDidUpdate != "function" || W === d.memoizedProps && Pe === d.memoizedState || (h.flags |= 4), typeof F.getSnapshotBeforeUpdate != "function" || W === d.memoizedProps && Pe === d.memoizedState || (h.flags |= 1024), h.memoizedProps = x, h.memoizedState = xt), F.props = x, F.state = xt, F.context = Y, x = he) : (typeof F.componentDidUpdate != "function" || W === d.memoizedProps && Pe === d.memoizedState || (h.flags |= 4), typeof F.getSnapshotBeforeUpdate != "function" || W === d.memoizedProps && Pe === d.memoizedState || (h.flags |= 1024), x = !1);
    }
    return M0(d, h, m, x, D, w);
  }
  function M0(d, h, m, x, w, D) {
    ei(d, h);
    var F = (h.flags & 128) !== 0;
    if (!x && !F)
      return w && _0(h, m, !1), wn(d, h, D);
    x = h.stateNode, cD.current = h;
    var W = F && typeof m.getDerivedStateFromError != "function" ? null : x.render();
    return h.flags |= 1, d !== null && F ? (h.child = bc(h, d.child, null, D), h.child = bc(h, null, W, D)) : nn(d, h, W, D), h.memoizedState = x.state, w && _0(h, m, !0), h.child;
  }
  function k0(d) {
    var h = d.stateNode;
    h.pendingContext ? jl(d, h.pendingContext, h.pendingContext !== h.context) : h.context && jl(d, h.context, !1), B_(d, h.containerInfo);
  }
  function Qv(d, h, m, x, w) {
    return Tr(), O_(w), h.flags |= 256, nn(d, h, m, x), h.child;
  }
  var ud = { dehydrated: null, treeContext: null, retryLane: 0 };
  function U_(d) {
    return { baseLanes: d, cachePool: null, transitions: null };
  }
  function G_(d, h, m) {
    var x = h.pendingProps, w = Vt.current, D = !1, F = (h.flags & 128) !== 0, W;
    if ((W = F) || (W = d !== null && d.memoizedState === null ? !1 : (w & 2) !== 0), W ? (D = !0, h.flags &= -129) : (d === null || d.memoizedState !== null) && (w |= 1), Vi(Vt, w & 1), d === null)
      return Ev(h), d = h.memoizedState, d !== null && (d = d.dehydrated, d !== null) ? (h.mode & 1 ? d.data === "$!" ? h.lanes = 8 : h.lanes = 1073741824 : h.lanes = 1, null) : (F = x.children, d = x.fallback, D ? (x = h.mode, D = h.child, F = { mode: "hidden", children: F }, !(x & 1) && D !== null ? (D.childLanes = 0, D.pendingProps = F) : D = Of(F, x, 0, null), d = md(d, x, m, null), D.return = h, d.return = h, D.sibling = d, h.child = D, h.child.memoizedState = U_(m), h.memoizedState = ud, d) : K_(h, F));
    if (w = d.memoizedState, w !== null && (W = w.dehydrated, W !== null))
      return hD(d, h, F, x, W, w, m);
    if (D) {
      D = x.fallback, F = h.mode, w = d.child, W = w.sibling;
      var Y = { mode: "hidden", children: x.children };
      return !(F & 1) && h.child !== w ? (x = h.child, x.childLanes = 0, x.pendingProps = Y, h.deletions = null) : (x = ou(w, Y), x.subtreeFlags = w.subtreeFlags & 14680064), W !== null ? D = ou(W, D) : (D = md(D, F, m, null), D.flags |= 2), D.return = h, x.return = h, x.sibling = D, h.child = x, x = D, D = h.child, F = d.child.memoizedState, F = F === null ? U_(m) : { baseLanes: F.baseLanes | m, cachePool: null, transitions: F.transitions }, D.memoizedState = F, D.childLanes = d.childLanes & ~m, h.memoizedState = ud, x;
    }
    return D = d.child, d = D.sibling, x = ou(D, { mode: "visible", children: x.children }), !(h.mode & 1) && (x.lanes = m), x.return = h, x.sibling = null, d !== null && (m = h.deletions, m === null ? (h.deletions = [d], h.flags |= 16) : m.push(d)), h.child = x, h.memoizedState = null, x;
  }
  function K_(d, h) {
    return h = Of({ mode: "visible", children: h }, d.mode, 0, null), h.return = d, d.child = h;
  }
  function Rc(d, h, m, x) {
    return x !== null && O_(x), bc(h, d.child, null, m), d = K_(h, h.pendingProps.children), d.flags |= 2, h.memoizedState = null, d;
  }
  function hD(d, h, m, x, w, D, F) {
    if (m)
      return h.flags & 256 ? (h.flags &= -257, x = Cf(Error(i(422))), Rc(d, h, F, x)) : h.memoizedState !== null ? (h.child = d.child, h.flags |= 128, null) : (D = x.fallback, w = h.mode, x = Of({ mode: "visible", children: x.children }, w, 0, null), D = md(D, w, F, null), D.flags |= 2, x.return = h, D.return = h, x.sibling = D, h.child = x, h.mode & 1 && bc(h, d.child, null, F), h.child.memoizedState = U_(F), h.memoizedState = ud, D);
    if (!(h.mode & 1))
      return Rc(d, h, F, null);
    if (w.data === "$!") {
      if (x = w.nextSibling && w.nextSibling.dataset, x)
        var W = x.dgst;
      return x = W, D = Error(i(419)), x = Cf(D, x, void 0), Rc(d, h, F, x);
    }
    if (W = (F & d.childLanes) !== 0, Kr || W) {
      if (x = Dr, x !== null) {
        switch (F & -F) {
          case 4:
            w = 2;
            break;
          case 16:
            w = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            w = 32;
            break;
          case 536870912:
            w = 268435456;
            break;
          default:
            w = 0;
        }
        w = w & (x.suspendedLanes | F) ? 0 : w, w !== 0 && w !== D.retryLane && (D.retryLane = w, ll(d, w), Xn(x, d, w, -1));
      }
      return nC(), x = Cf(Error(i(421))), Rc(d, h, F, x);
    }
    return w.data === "$?" ? (h.flags |= 128, h.child = d.child, h = _D.bind(null, d), w._reactRetry = h, null) : (d = D.treeContext, Ia = Jo(w.nextSibling), Ya = h, gr = !0, So = null, d !== null && (Ta[Gn++] = En, Ta[Gn++] = ol, Ta[Gn++] = xo, En = d.id, ol = d.overflow, xo = h), h = K_(h, x.children), h.flags |= 4096, h);
  }
  function j_(d, h, m) {
    d.lanes |= h;
    var x = d.alternate;
    x !== null && (x.lanes |= h), tn(d.return, h, m);
  }
  function Zv(d, h, m, x, w) {
    var D = d.memoizedState;
    D === null ? d.memoizedState = { isBackwards: h, rendering: null, renderingStartTime: 0, last: x, tail: m, tailMode: w } : (D.isBackwards = h, D.rendering = null, D.renderingStartTime = 0, D.last = x, D.tail = m, D.tailMode = w);
  }
  function Y_(d, h, m) {
    var x = h.pendingProps, w = x.revealOrder, D = x.tail;
    if (nn(d, h, x.children, m), x = Vt.current, x & 2)
      x = x & 1 | 2, h.flags |= 128;
    else {
      if (d !== null && d.flags & 128)
        e:
          for (d = h.child; d !== null; ) {
            if (d.tag === 13)
              d.memoizedState !== null && j_(d, m, h);
            else if (d.tag === 19)
              j_(d, m, h);
            else if (d.child !== null) {
              d.child.return = d, d = d.child;
              continue;
            }
            if (d === h)
              break e;
            for (; d.sibling === null; ) {
              if (d.return === null || d.return === h)
                break e;
              d = d.return;
            }
            d.sibling.return = d.return, d = d.sibling;
          }
      x &= 1;
    }
    if (Vi(Vt, x), !(h.mode & 1))
      h.memoizedState = null;
    else
      switch (w) {
        case "forwards":
          for (m = h.child, w = null; m !== null; )
            d = m.alternate, d !== null && Ir(d) === null && (w = m), m = m.sibling;
          m = w, m === null ? (w = h.child, h.child = null) : (w = m.sibling, m.sibling = null), Zv(h, !1, w, m, D);
          break;
        case "backwards":
          for (m = null, w = h.child, h.child = null; w !== null; ) {
            if (d = w.alternate, d !== null && Ir(d) === null) {
              h.child = w;
              break;
            }
            d = w.sibling, w.sibling = m, m = w, w = d;
          }
          Zv(h, !0, m, null, D);
          break;
        case "together":
          Zv(h, !1, null, null, void 0);
          break;
        default:
          h.memoizedState = null;
      }
    return h.child;
  }
  function Kn(d, h) {
    !(h.mode & 1) && d !== null && (d.alternate = null, h.alternate = null, h.flags |= 2);
  }
  function wn(d, h, m) {
    if (d !== null && (h.dependencies = d.dependencies), fl |= h.lanes, !(m & h.childLanes))
      return null;
    if (d !== null && h.child !== d.child)
      throw Error(i(153));
    if (h.child !== null) {
      for (d = h.child, m = ou(d, d.pendingProps), h.child = m, m.return = h; d.sibling !== null; )
        d = d.sibling, m = m.sibling = ou(d, d.pendingProps), m.return = h;
      m.sibling = null;
    }
    return h.child;
  }
  function cl(d, h, m) {
    switch (h.tag) {
      case 3:
        k0(h), Tr();
        break;
      case 5:
        Ft(h);
        break;
      case 1:
        xr(h.type) && yv(h);
        break;
      case 4:
        B_(h, h.stateNode.containerInfo);
        break;
      case 10:
        var x = h.type._context, w = h.memoizedProps.value;
        Vi(Ss, x._currentValue), x._currentValue = w;
        break;
      case 13:
        if (x = h.memoizedState, x !== null)
          return x.dehydrated !== null ? (Vi(Vt, Vt.current & 1), h.flags |= 128, null) : m & h.child.childLanes ? G_(d, h, m) : (Vi(Vt, Vt.current & 1), d = wn(d, h, m), d !== null ? d.sibling : null);
        Vi(Vt, Vt.current & 1);
        break;
      case 19:
        if (x = (m & h.childLanes) !== 0, d.flags & 128) {
          if (x)
            return Y_(d, h, m);
          h.flags |= 128;
        }
        if (w = h.memoizedState, w !== null && (w.rendering = null, w.tail = null, w.lastEffect = null), Vi(Vt, Vt.current), x)
          break;
        return null;
      case 22:
      case 23:
        return h.lanes = 0, ld(d, h, m);
    }
    return wn(d, h, m);
  }
  var xf, dd, wo, an;
  xf = function(d, h) {
    for (var m = h.child; m !== null; ) {
      if (m.tag === 5 || m.tag === 6)
        d.appendChild(m.stateNode);
      else if (m.tag !== 4 && m.child !== null) {
        m.child.return = m, m = m.child;
        continue;
      }
      if (m === h)
        break;
      for (; m.sibling === null; ) {
        if (m.return === null || m.return === h)
          return;
        m = m.return;
      }
      m.sibling.return = m.return, m = m.sibling;
    }
  }, dd = function() {
  }, wo = function(d, h, m, x) {
    var w = d.memoizedProps;
    if (w !== x) {
      d = h.stateNode, ed(es.current);
      var D = null;
      switch (m) {
        case "input":
          w = si(d, w), x = si(d, x), D = [];
          break;
        case "select":
          w = j({}, w, { value: void 0 }), x = j({}, x, { value: void 0 }), D = [];
          break;
        case "textarea":
          w = ra(d, w), x = ra(d, x), D = [];
          break;
        default:
          typeof w.onClick != "function" && typeof x.onClick == "function" && (d.onclick = Cv);
      }
      Ui(m, x);
      var F;
      m = null;
      for (he in w)
        if (!x.hasOwnProperty(he) && w.hasOwnProperty(he) && w[he] != null)
          if (he === "style") {
            var W = w[he];
            for (F in W)
              W.hasOwnProperty(F) && (m || (m = {}), m[F] = "");
          } else
            he !== "dangerouslySetInnerHTML" && he !== "children" && he !== "suppressContentEditableWarning" && he !== "suppressHydrationWarning" && he !== "autoFocus" && (n.hasOwnProperty(he) ? D || (D = []) : (D = D || []).push(he, null));
      for (he in x) {
        var Y = x[he];
        if (W = w != null ? w[he] : void 0, x.hasOwnProperty(he) && Y !== W && (Y != null || W != null))
          if (he === "style")
            if (W) {
              for (F in W)
                !W.hasOwnProperty(F) || Y && Y.hasOwnProperty(F) || (m || (m = {}), m[F] = "");
              for (F in Y)
                Y.hasOwnProperty(F) && W[F] !== Y[F] && (m || (m = {}), m[F] = Y[F]);
            } else
              m || (D || (D = []), D.push(
                he,
                m
              )), m = Y;
          else
            he === "dangerouslySetInnerHTML" ? (Y = Y ? Y.__html : void 0, W = W ? W.__html : void 0, Y != null && W !== Y && (D = D || []).push(he, Y)) : he === "children" ? typeof Y != "string" && typeof Y != "number" || (D = D || []).push(he, "" + Y) : he !== "suppressContentEditableWarning" && he !== "suppressHydrationWarning" && (n.hasOwnProperty(he) ? (Y != null && he === "onScroll" && rr("scroll", d), D || W === Y || (D = [])) : (D = D || []).push(he, Y));
      }
      m && (D = D || []).push("style", m);
      var he = D;
      (h.updateQueue = he) && (h.flags |= 4);
    }
  }, an = function(d, h, m, x) {
    m !== x && (h.flags |= 4);
  };
  function Sf(d, h) {
    if (!gr)
      switch (d.tailMode) {
        case "hidden":
          h = d.tail;
          for (var m = null; h !== null; )
            h.alternate !== null && (m = h), h = h.sibling;
          m === null ? d.tail = null : m.sibling = null;
          break;
        case "collapsed":
          m = d.tail;
          for (var x = null; m !== null; )
            m.alternate !== null && (x = m), m = m.sibling;
          x === null ? h || d.tail === null ? d.tail = null : d.tail.sibling = null : x.sibling = null;
      }
  }
  function jn(d) {
    var h = d.alternate !== null && d.alternate.child === d.child, m = 0, x = 0;
    if (h)
      for (var w = d.child; w !== null; )
        m |= w.lanes | w.childLanes, x |= w.subtreeFlags & 14680064, x |= w.flags & 14680064, w.return = d, w = w.sibling;
    else
      for (w = d.child; w !== null; )
        m |= w.lanes | w.childLanes, x |= w.subtreeFlags, x |= w.flags, w.return = d, w = w.sibling;
    return d.subtreeFlags |= x, d.childLanes = m, h;
  }
  function fD(d, h, m) {
    var x = h.pendingProps;
    switch (D_(h), h.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return jn(h), null;
      case 1:
        return xr(h.type) && yo(), jn(h), null;
      case 3:
        return x = h.stateNode, Jl(), Fi(Mr), Fi(Gt), Rv(), x.pendingContext && (x.context = x.pendingContext, x.pendingContext = null), (d === null || d.child === null) && (bv(h) ? h.flags |= 4 : d === null || d.memoizedState.isDehydrated && !(h.flags & 256) || (h.flags |= 1024, So !== null && (Af(So), So = null))), dd(d, h), jn(h), null;
      case 5:
        li(h);
        var w = ed(wc.current);
        if (m = h.type, d !== null && h.stateNode != null)
          wo(d, h, m, x, w), d.ref !== h.ref && (h.flags |= 512, h.flags |= 2097152);
        else {
          if (!x) {
            if (h.stateNode === null)
              throw Error(i(166));
            return jn(h), null;
          }
          if (d = ed(es.current), bv(h)) {
            x = h.stateNode, m = h.type;
            var D = h.memoizedProps;
            switch (x[ys] = h, x[Qu] = D, d = (h.mode & 1) !== 0, m) {
              case "dialog":
                rr("cancel", x), rr("close", x);
                break;
              case "iframe":
              case "object":
              case "embed":
                rr("load", x);
                break;
              case "video":
              case "audio":
                for (w = 0; w < af.length; w++)
                  rr(af[w], x);
                break;
              case "source":
                rr("error", x);
                break;
              case "img":
              case "image":
              case "link":
                rr(
                  "error",
                  x
                ), rr("load", x);
                break;
              case "details":
                rr("toggle", x);
                break;
              case "input":
                Wt(x, D), rr("invalid", x);
                break;
              case "select":
                x._wrapperState = { wasMultiple: !!D.multiple }, rr("invalid", x);
                break;
              case "textarea":
                zn(x, D), rr("invalid", x);
            }
            Ui(m, D), w = null;
            for (var F in D)
              if (D.hasOwnProperty(F)) {
                var W = D[F];
                F === "children" ? typeof W == "string" ? x.textContent !== W && (D.suppressHydrationWarning !== !0 && _v(x.textContent, W, d), w = ["children", W]) : typeof W == "number" && x.textContent !== "" + W && (D.suppressHydrationWarning !== !0 && _v(
                  x.textContent,
                  W,
                  d
                ), w = ["children", "" + W]) : n.hasOwnProperty(F) && W != null && F === "onScroll" && rr("scroll", x);
              }
            switch (m) {
              case "input":
                zt(x), mi(x, D, !0);
                break;
              case "textarea":
                zt(x), tr(x);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof D.onClick == "function" && (x.onclick = Cv);
            }
            x = w, h.updateQueue = x, x !== null && (h.flags |= 4);
          } else {
            F = w.nodeType === 9 ? w : w.ownerDocument, d === "http://www.w3.org/1999/xhtml" && (d = cn(m)), d === "http://www.w3.org/1999/xhtml" ? m === "script" ? (d = F.createElement("div"), d.innerHTML = "<script><\/script>", d = d.removeChild(d.firstChild)) : typeof x.is == "string" ? d = F.createElement(m, { is: x.is }) : (d = F.createElement(m), m === "select" && (F = d, x.multiple ? F.multiple = !0 : x.size && (F.size = x.size))) : d = F.createElementNS(d, m), d[ys] = h, d[Qu] = x, xf(d, h, !1, !1), h.stateNode = d;
            e: {
              switch (F = Br(m, x), m) {
                case "dialog":
                  rr("cancel", d), rr("close", d), w = x;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  rr("load", d), w = x;
                  break;
                case "video":
                case "audio":
                  for (w = 0; w < af.length; w++)
                    rr(af[w], d);
                  w = x;
                  break;
                case "source":
                  rr("error", d), w = x;
                  break;
                case "img":
                case "image":
                case "link":
                  rr(
                    "error",
                    d
                  ), rr("load", d), w = x;
                  break;
                case "details":
                  rr("toggle", d), w = x;
                  break;
                case "input":
                  Wt(d, x), w = si(d, x), rr("invalid", d);
                  break;
                case "option":
                  w = x;
                  break;
                case "select":
                  d._wrapperState = { wasMultiple: !!x.multiple }, w = j({}, x, { value: void 0 }), rr("invalid", d);
                  break;
                case "textarea":
                  zn(d, x), w = ra(d, x), rr("invalid", d);
                  break;
                default:
                  w = x;
              }
              Ui(m, w), W = w;
              for (D in W)
                if (W.hasOwnProperty(D)) {
                  var Y = W[D];
                  D === "style" ? ii(d, Y) : D === "dangerouslySetInnerHTML" ? (Y = Y ? Y.__html : void 0, Y != null && Go(d, Y)) : D === "children" ? typeof Y == "string" ? (m !== "textarea" || Y !== "") && Wa(d, Y) : typeof Y == "number" && Wa(d, "" + Y) : D !== "suppressContentEditableWarning" && D !== "suppressHydrationWarning" && D !== "autoFocus" && (n.hasOwnProperty(D) ? Y != null && D === "onScroll" && rr("scroll", d) : Y != null && K(d, D, Y, F));
                }
              switch (m) {
                case "input":
                  zt(d), mi(d, x, !1);
                  break;
                case "textarea":
                  zt(d), tr(d);
                  break;
                case "option":
                  x.value != null && d.setAttribute("value", "" + at(x.value));
                  break;
                case "select":
                  d.multiple = !!x.multiple, D = x.value, D != null ? ia(d, !!x.multiple, D, !1) : x.defaultValue != null && ia(
                    d,
                    !!x.multiple,
                    x.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof w.onClick == "function" && (d.onclick = Cv);
              }
              switch (m) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  x = !!x.autoFocus;
                  break e;
                case "img":
                  x = !0;
                  break e;
                default:
                  x = !1;
              }
            }
            x && (h.flags |= 4);
          }
          h.ref !== null && (h.flags |= 512, h.flags |= 2097152);
        }
        return jn(h), null;
      case 6:
        if (d && h.stateNode != null)
          an(d, h, d.memoizedProps, x);
        else {
          if (typeof x != "string" && h.stateNode === null)
            throw Error(i(166));
          if (m = ed(wc.current), ed(es.current), bv(h)) {
            if (x = h.stateNode, m = h.memoizedProps, x[ys] = h, (D = x.nodeValue !== m) && (d = Ya, d !== null))
              switch (d.tag) {
                case 3:
                  _v(x.nodeValue, m, (d.mode & 1) !== 0);
                  break;
                case 5:
                  d.memoizedProps.suppressHydrationWarning !== !0 && _v(x.nodeValue, m, (d.mode & 1) !== 0);
              }
            D && (h.flags |= 4);
          } else
            x = (m.nodeType === 9 ? m : m.ownerDocument).createTextNode(x), x[ys] = h, h.stateNode = x;
        }
        return jn(h), null;
      case 13:
        if (Fi(Vt), x = h.memoizedState, d === null || d.memoizedState !== null && d.memoizedState.dehydrated !== null) {
          if (gr && Ia !== null && h.mode & 1 && !(h.flags & 128))
            x0(), Tr(), h.flags |= 98560, D = !1;
          else if (D = bv(h), x !== null && x.dehydrated !== null) {
            if (d === null) {
              if (!D)
                throw Error(i(318));
              if (D = h.memoizedState, D = D !== null ? D.dehydrated : null, !D)
                throw Error(i(317));
              D[ys] = h;
            } else
              Tr(), !(h.flags & 128) && (h.memoizedState = null), h.flags |= 4;
            jn(h), D = !1;
          } else
            So !== null && (Af(So), So = null), D = !0;
          if (!D)
            return h.flags & 65536 ? h : null;
        }
        return h.flags & 128 ? (h.lanes = m, h) : (x = x !== null, x !== (d !== null && d.memoizedState !== null) && x && (h.child.flags |= 8192, h.mode & 1 && (d === null || Vt.current & 1 ? sn === 0 && (sn = 3) : nC())), h.updateQueue !== null && (h.flags |= 4), jn(h), null);
      case 4:
        return Jl(), dd(d, h), d === null && yc(h.stateNode.containerInfo), jn(h), null;
      case 10:
        return sl(h.type._context), jn(h), null;
      case 17:
        return xr(h.type) && yo(), jn(h), null;
      case 19:
        if (Fi(Vt), D = h.memoizedState, D === null)
          return jn(h), null;
        if (x = (h.flags & 128) !== 0, F = D.rendering, F === null)
          if (x)
            Sf(D, !1);
          else {
            if (sn !== 0 || d !== null && d.flags & 128)
              for (d = h.child; d !== null; ) {
                if (F = Ir(d), F !== null) {
                  for (h.flags |= 128, Sf(D, !1), x = F.updateQueue, x !== null && (h.updateQueue = x, h.flags |= 4), h.subtreeFlags = 0, x = m, m = h.child; m !== null; )
                    D = m, d = x, D.flags &= 14680066, F = D.alternate, F === null ? (D.childLanes = 0, D.lanes = d, D.child = null, D.subtreeFlags = 0, D.memoizedProps = null, D.memoizedState = null, D.updateQueue = null, D.dependencies = null, D.stateNode = null) : (D.childLanes = F.childLanes, D.lanes = F.lanes, D.child = F.child, D.subtreeFlags = 0, D.deletions = null, D.memoizedProps = F.memoizedProps, D.memoizedState = F.memoizedState, D.updateQueue = F.updateQueue, D.type = F.type, d = F.dependencies, D.dependencies = d === null ? null : { lanes: d.lanes, firstContext: d.firstContext }), m = m.sibling;
                  return Vi(Vt, Vt.current & 1 | 2), h.child;
                }
                d = d.sibling;
              }
            D.tail !== null && hi() > Vc && (h.flags |= 128, x = !0, Sf(D, !1), h.lanes = 4194304);
          }
        else {
          if (!x)
            if (d = Ir(F), d !== null) {
              if (h.flags |= 128, x = !0, m = d.updateQueue, m !== null && (h.updateQueue = m, h.flags |= 4), Sf(D, !0), D.tail === null && D.tailMode === "hidden" && !F.alternate && !gr)
                return jn(h), null;
            } else
              2 * hi() - D.renderingStartTime > Vc && m !== 1073741824 && (h.flags |= 128, x = !0, Sf(D, !1), h.lanes = 4194304);
          D.isBackwards ? (F.sibling = h.child, h.child = F) : (m = D.last, m !== null ? m.sibling = F : h.child = F, D.last = F);
        }
        return D.tail !== null ? (h = D.tail, D.rendering = h, D.tail = h.sibling, D.renderingStartTime = hi(), h.sibling = null, m = Vt.current, Vi(Vt, x ? m & 1 | 2 : m & 1), h) : (jn(h), null);
      case 22:
      case 23:
        return rC(), x = h.memoizedState !== null, d !== null && d.memoizedState !== null !== x && (h.flags |= 8192), x && h.mode & 1 ? Qa & 1073741824 && (jn(h), h.subtreeFlags & 6 && (h.flags |= 8192)) : jn(h), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(i(156, h.tag));
  }
  function q_(d, h) {
    switch (D_(h), h.tag) {
      case 1:
        return xr(h.type) && yo(), d = h.flags, d & 65536 ? (h.flags = d & -65537 | 128, h) : null;
      case 3:
        return Jl(), Fi(Mr), Fi(Gt), Rv(), d = h.flags, d & 65536 && !(d & 128) ? (h.flags = d & -65537 | 128, h) : null;
      case 5:
        return li(h), null;
      case 13:
        if (Fi(Vt), d = h.memoizedState, d !== null && d.dehydrated !== null) {
          if (h.alternate === null)
            throw Error(i(340));
          Tr();
        }
        return d = h.flags, d & 65536 ? (h.flags = d & -65537 | 128, h) : null;
      case 19:
        return Fi(Vt), null;
      case 4:
        return Jl(), null;
      case 10:
        return sl(h.type._context), null;
      case 22:
      case 23:
        return rC(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Ef = !1, on = !1, P0 = typeof WeakSet == "function" ? WeakSet : Set, Ct = null;
  function Lc(d, h) {
    var m = d.ref;
    if (m !== null)
      if (typeof m == "function")
        try {
          m(null);
        } catch (x) {
          Pr(d, h, x);
        }
      else
        m.current = null;
  }
  function bf(d, h, m) {
    try {
      m();
    } catch (x) {
      Pr(d, h, x);
    }
  }
  var F0 = !1;
  function B0(d, h) {
    if (y_ = Uu, d = fv(), il(d)) {
      if ("selectionStart" in d)
        var m = { start: d.selectionStart, end: d.selectionEnd };
      else
        e: {
          m = (m = d.ownerDocument) && m.defaultView || window;
          var x = m.getSelection && m.getSelection();
          if (x && x.rangeCount !== 0) {
            m = x.anchorNode;
            var w = x.anchorOffset, D = x.focusNode;
            x = x.focusOffset;
            try {
              m.nodeType, D.nodeType;
            } catch {
              m = null;
              break e;
            }
            var F = 0, W = -1, Y = -1, he = 0, Be = 0, Ne = d, Pe = null;
            t:
              for (; ; ) {
                for (var ut; Ne !== m || w !== 0 && Ne.nodeType !== 3 || (W = F + w), Ne !== D || x !== 0 && Ne.nodeType !== 3 || (Y = F + x), Ne.nodeType === 3 && (F += Ne.nodeValue.length), (ut = Ne.firstChild) !== null; )
                  Pe = Ne, Ne = ut;
                for (; ; ) {
                  if (Ne === d)
                    break t;
                  if (Pe === m && ++he === w && (W = F), Pe === D && ++Be === x && (Y = F), (ut = Ne.nextSibling) !== null)
                    break;
                  Ne = Pe, Pe = Ne.parentNode;
                }
                Ne = ut;
              }
            m = W === -1 || Y === -1 ? null : { start: W, end: Y };
          } else
            m = null;
        }
      m = m || { start: 0, end: 0 };
    } else
      m = null;
    for (qu = { focusedElem: d, selectionRange: m }, Uu = !1, Ct = h; Ct !== null; )
      if (h = Ct, d = h.child, (h.subtreeFlags & 1028) !== 0 && d !== null)
        d.return = h, Ct = d;
      else
        for (; Ct !== null; ) {
          h = Ct;
          try {
            var xt = h.alternate;
            if (h.flags & 1024)
              switch (h.tag) {
                case 0:
                case 11:
                case 15:
                  break;
                case 1:
                  if (xt !== null) {
                    var bt = xt.memoizedProps, Nr = xt.memoizedState, oe = h.stateNode, Z = oe.getSnapshotBeforeUpdate(h.elementType === h.type ? bt : qa(h.type, bt), Nr);
                    oe.__reactInternalSnapshotBeforeUpdate = Z;
                  }
                  break;
                case 3:
                  var ue = h.stateNode.containerInfo;
                  ue.nodeType === 1 ? ue.textContent = "" : ue.nodeType === 9 && ue.documentElement && ue.removeChild(ue.documentElement);
                  break;
                case 5:
                case 6:
                case 4:
                case 17:
                  break;
                default:
                  throw Error(i(163));
              }
          } catch (Ge) {
            Pr(h, h.return, Ge);
          }
          if (d = h.sibling, d !== null) {
            d.return = h.return, Ct = d;
            break;
          }
          Ct = h.return;
        }
    return xt = F0, F0 = !1, xt;
  }
  function wf(d, h, m) {
    var x = h.updateQueue;
    if (x = x !== null ? x.lastEffect : null, x !== null) {
      var w = x = x.next;
      do {
        if ((w.tag & d) === d) {
          var D = w.destroy;
          w.destroy = void 0, D !== void 0 && bf(h, m, D);
        }
        w = w.next;
      } while (w !== x);
    }
  }
  function Tf(d, h) {
    if (h = h.updateQueue, h = h !== null ? h.lastEffect : null, h !== null) {
      var m = h = h.next;
      do {
        if ((m.tag & d) === d) {
          var x = m.create;
          m.destroy = x();
        }
        m = m.next;
      } while (m !== h);
    }
  }
  function X_(d) {
    var h = d.ref;
    if (h !== null) {
      var m = d.stateNode;
      switch (d.tag) {
        case 5:
          d = m;
          break;
        default:
          d = m;
      }
      typeof h == "function" ? h(d) : h.current = d;
    }
  }
  function Q_(d) {
    var h = d.alternate;
    h !== null && (d.alternate = null, Q_(h)), d.child = null, d.deletions = null, d.sibling = null, d.tag === 5 && (h = d.stateNode, h !== null && (delete h[ys], delete h[Qu], delete h[E_], delete h[oD], delete h[b_])), d.stateNode = null, d.return = null, d.dependencies = null, d.memoizedProps = null, d.memoizedState = null, d.pendingProps = null, d.stateNode = null, d.updateQueue = null;
  }
  function V0(d) {
    return d.tag === 5 || d.tag === 3 || d.tag === 4;
  }
  function Jv(d) {
    e:
      for (; ; ) {
        for (; d.sibling === null; ) {
          if (d.return === null || V0(d.return))
            return null;
          d = d.return;
        }
        for (d.sibling.return = d.return, d = d.sibling; d.tag !== 5 && d.tag !== 6 && d.tag !== 18; ) {
          if (d.flags & 2 || d.child === null || d.tag === 4)
            continue e;
          d.child.return = d, d = d.child;
        }
        if (!(d.flags & 2))
          return d.stateNode;
      }
  }
  function Mc(d, h, m) {
    var x = d.tag;
    if (x === 5 || x === 6)
      d = d.stateNode, h ? m.nodeType === 8 ? m.parentNode.insertBefore(d, h) : m.insertBefore(d, h) : (m.nodeType === 8 ? (h = m.parentNode, h.insertBefore(d, m)) : (h = m, h.appendChild(d)), m = m._reactRootContainer, m != null || h.onclick !== null || (h.onclick = Cv));
    else if (x !== 4 && (d = d.child, d !== null))
      for (Mc(d, h, m), d = d.sibling; d !== null; )
        Mc(d, h, m), d = d.sibling;
  }
  function bs(d, h, m) {
    var x = d.tag;
    if (x === 5 || x === 6)
      d = d.stateNode, h ? m.insertBefore(d, h) : m.appendChild(d);
    else if (x !== 4 && (d = d.child, d !== null))
      for (bs(d, h, m), d = d.sibling; d !== null; )
        bs(d, h, m), d = d.sibling;
  }
  var Sr = null, vn = !1;
  function To(d, h, m) {
    for (m = m.child; m !== null; )
      kc(d, h, m), m = m.sibling;
  }
  function kc(d, h, m) {
    if (Yo && typeof Yo.onCommitFiberUnmount == "function")
      try {
        Yo.onCommitFiberUnmount(zh, m);
      } catch {
      }
    switch (m.tag) {
      case 5:
        on || Lc(m, h);
      case 6:
        var x = Sr, w = vn;
        Sr = null, To(d, h, m), Sr = x, vn = w, Sr !== null && (vn ? (d = Sr, m = m.stateNode, d.nodeType === 8 ? d.parentNode.removeChild(m) : d.removeChild(m)) : Sr.removeChild(m.stateNode));
        break;
      case 18:
        Sr !== null && (vn ? (d = Sr, m = m.stateNode, d.nodeType === 8 ? Ul(d.parentNode, m) : d.nodeType === 1 && Ul(d, m), jh(d)) : Ul(Sr, m.stateNode));
        break;
      case 4:
        x = Sr, w = vn, Sr = m.stateNode.containerInfo, vn = !0, To(d, h, m), Sr = x, vn = w;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!on && (x = m.updateQueue, x !== null && (x = x.lastEffect, x !== null))) {
          w = x = x.next;
          do {
            var D = w, F = D.destroy;
            D = D.tag, F !== void 0 && (D & 2 || D & 4) && bf(m, h, F), w = w.next;
          } while (w !== x);
        }
        To(d, h, m);
        break;
      case 1:
        if (!on && (Lc(m, h), x = m.stateNode, typeof x.componentWillUnmount == "function"))
          try {
            x.props = m.memoizedProps, x.state = m.memoizedState, x.componentWillUnmount();
          } catch (W) {
            Pr(m, h, W);
          }
        To(d, h, m);
        break;
      case 21:
        To(d, h, m);
        break;
      case 22:
        m.mode & 1 ? (on = (x = on) || m.memoizedState !== null, To(d, h, m), on = x) : To(d, h, m);
        break;
      default:
        To(d, h, m);
    }
  }
  function hl(d) {
    var h = d.updateQueue;
    if (h !== null) {
      d.updateQueue = null;
      var m = d.stateNode;
      m === null && (m = d.stateNode = new P0()), h.forEach(function(x) {
        var w = CD.bind(null, d, x);
        m.has(x) || (m.add(x), x.then(w, w));
      });
    }
  }
  function ts(d, h) {
    var m = h.deletions;
    if (m !== null)
      for (var x = 0; x < m.length; x++) {
        var w = m[x];
        try {
          var D = d, F = h, W = F;
          e:
            for (; W !== null; ) {
              switch (W.tag) {
                case 5:
                  Sr = W.stateNode, vn = !1;
                  break e;
                case 3:
                  Sr = W.stateNode.containerInfo, vn = !0;
                  break e;
                case 4:
                  Sr = W.stateNode.containerInfo, vn = !0;
                  break e;
              }
              W = W.return;
            }
          if (Sr === null)
            throw Error(i(160));
          kc(D, F, w), Sr = null, vn = !1;
          var Y = w.alternate;
          Y !== null && (Y.return = null), w.return = null;
        } catch (he) {
          Pr(w, h, he);
        }
      }
    if (h.subtreeFlags & 12854)
      for (h = h.child; h !== null; )
        N0(h, d), h = h.sibling;
  }
  function N0(d, h) {
    var m = d.alternate, x = d.flags;
    switch (d.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (ts(h, d), ws(d), x & 4) {
          try {
            wf(3, d, d.return), Tf(3, d);
          } catch (bt) {
            Pr(d, d.return, bt);
          }
          try {
            wf(5, d, d.return);
          } catch (bt) {
            Pr(d, d.return, bt);
          }
        }
        break;
      case 1:
        ts(h, d), ws(d), x & 512 && m !== null && Lc(m, m.return);
        break;
      case 5:
        if (ts(h, d), ws(d), x & 512 && m !== null && Lc(m, m.return), d.flags & 32) {
          var w = d.stateNode;
          try {
            Wa(w, "");
          } catch (bt) {
            Pr(d, d.return, bt);
          }
        }
        if (x & 4 && (w = d.stateNode, w != null)) {
          var D = d.memoizedProps, F = m !== null ? m.memoizedProps : D, W = d.type, Y = d.updateQueue;
          if (d.updateQueue = null, Y !== null)
            try {
              W === "input" && D.type === "radio" && D.name != null && ki(w, D), Br(W, F);
              var he = Br(W, D);
              for (F = 0; F < Y.length; F += 2) {
                var Be = Y[F], Ne = Y[F + 1];
                Be === "style" ? ii(w, Ne) : Be === "dangerouslySetInnerHTML" ? Go(w, Ne) : Be === "children" ? Wa(w, Ne) : K(w, Be, Ne, he);
              }
              switch (W) {
                case "input":
                  lr(w, D);
                  break;
                case "textarea":
                  Yi(w, D);
                  break;
                case "select":
                  var Pe = w._wrapperState.wasMultiple;
                  w._wrapperState.wasMultiple = !!D.multiple;
                  var ut = D.value;
                  ut != null ? ia(w, !!D.multiple, ut, !1) : Pe !== !!D.multiple && (D.defaultValue != null ? ia(
                    w,
                    !!D.multiple,
                    D.defaultValue,
                    !0
                  ) : ia(w, !!D.multiple, D.multiple ? [] : "", !1));
              }
              w[Qu] = D;
            } catch (bt) {
              Pr(d, d.return, bt);
            }
        }
        break;
      case 6:
        if (ts(h, d), ws(d), x & 4) {
          if (d.stateNode === null)
            throw Error(i(162));
          w = d.stateNode, D = d.memoizedProps;
          try {
            w.nodeValue = D;
          } catch (bt) {
            Pr(d, d.return, bt);
          }
        }
        break;
      case 3:
        if (ts(h, d), ws(d), x & 4 && m !== null && m.memoizedState.isDehydrated)
          try {
            jh(h.containerInfo);
          } catch (bt) {
            Pr(d, d.return, bt);
          }
        break;
      case 4:
        ts(h, d), ws(d);
        break;
      case 13:
        ts(h, d), ws(d), w = d.child, w.flags & 8192 && (D = w.memoizedState !== null, w.stateNode.isHidden = D, !D || w.alternate !== null && w.alternate.memoizedState !== null || (eC = hi())), x & 4 && hl(d);
        break;
      case 22:
        if (Be = m !== null && m.memoizedState !== null, d.mode & 1 ? (on = (he = on) || Be, ts(h, d), on = he) : ts(h, d), ws(d), x & 8192) {
          if (he = d.memoizedState !== null, (d.stateNode.isHidden = he) && !Be && d.mode & 1)
            for (Ct = d, Be = d.child; Be !== null; ) {
              for (Ne = Ct = Be; Ct !== null; ) {
                switch (Pe = Ct, ut = Pe.child, Pe.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    wf(4, Pe, Pe.return);
                    break;
                  case 1:
                    Lc(Pe, Pe.return);
                    var xt = Pe.stateNode;
                    if (typeof xt.componentWillUnmount == "function") {
                      x = Pe, m = Pe.return;
                      try {
                        h = x, xt.props = h.memoizedProps, xt.state = h.memoizedState, xt.componentWillUnmount();
                      } catch (bt) {
                        Pr(x, m, bt);
                      }
                    }
                    break;
                  case 5:
                    Lc(Pe, Pe.return);
                    break;
                  case 22:
                    if (Pe.memoizedState !== null) {
                      Z_(Ne);
                      continue;
                    }
                }
                ut !== null ? (ut.return = Pe, Ct = ut) : Z_(Ne);
              }
              Be = Be.sibling;
            }
          e:
            for (Be = null, Ne = d; ; ) {
              if (Ne.tag === 5) {
                if (Be === null) {
                  Be = Ne;
                  try {
                    w = Ne.stateNode, he ? (D = w.style, typeof D.setProperty == "function" ? D.setProperty("display", "none", "important") : D.display = "none") : (W = Ne.stateNode, Y = Ne.memoizedProps.style, F = Y != null && Y.hasOwnProperty("display") ? Y.display : null, W.style.display = Rt("display", F));
                  } catch (bt) {
                    Pr(d, d.return, bt);
                  }
                }
              } else if (Ne.tag === 6) {
                if (Be === null)
                  try {
                    Ne.stateNode.nodeValue = he ? "" : Ne.memoizedProps;
                  } catch (bt) {
                    Pr(d, d.return, bt);
                  }
              } else if ((Ne.tag !== 22 && Ne.tag !== 23 || Ne.memoizedState === null || Ne === d) && Ne.child !== null) {
                Ne.child.return = Ne, Ne = Ne.child;
                continue;
              }
              if (Ne === d)
                break e;
              for (; Ne.sibling === null; ) {
                if (Ne.return === null || Ne.return === d)
                  break e;
                Be === Ne && (Be = null), Ne = Ne.return;
              }
              Be === Ne && (Be = null), Ne.sibling.return = Ne.return, Ne = Ne.sibling;
            }
        }
        break;
      case 19:
        ts(h, d), ws(d), x & 4 && hl(d);
        break;
      case 21:
        break;
      default:
        ts(
          h,
          d
        ), ws(d);
    }
  }
  function ws(d) {
    var h = d.flags;
    if (h & 2) {
      try {
        e: {
          for (var m = d.return; m !== null; ) {
            if (V0(m)) {
              var x = m;
              break e;
            }
            m = m.return;
          }
          throw Error(i(160));
        }
        switch (x.tag) {
          case 5:
            var w = x.stateNode;
            x.flags & 32 && (Wa(w, ""), x.flags &= -33);
            var D = Jv(d);
            bs(d, D, w);
            break;
          case 3:
          case 4:
            var F = x.stateNode.containerInfo, W = Jv(d);
            Mc(d, W, F);
            break;
          default:
            throw Error(i(161));
        }
      } catch (Y) {
        Pr(d, d.return, Y);
      }
      d.flags &= -3;
    }
    h & 4096 && (d.flags &= -4097);
  }
  function H0(d, h, m) {
    Ct = d, Pc(d, h, m);
  }
  function Pc(d, h, m) {
    for (var x = (d.mode & 1) !== 0; Ct !== null; ) {
      var w = Ct, D = w.child;
      if (w.tag === 22 && x) {
        var F = w.memoizedState !== null || Ef;
        if (!F) {
          var W = w.alternate, Y = W !== null && W.memoizedState !== null || on;
          W = Ef;
          var he = on;
          if (Ef = F, (on = Y) && !he)
            for (Ct = w; Ct !== null; )
              F = Ct, Y = F.child, F.tag === 22 && F.memoizedState !== null ? z0(w) : Y !== null ? (Y.return = F, Ct = Y) : z0(w);
          for (; D !== null; )
            Ct = D, Pc(D, h, m), D = D.sibling;
          Ct = w, Ef = W, on = he;
        }
        $0(d, h, m);
      } else
        w.subtreeFlags & 8772 && D !== null ? (D.return = w, Ct = D) : $0(d, h, m);
    }
  }
  function $0(d) {
    for (; Ct !== null; ) {
      var h = Ct;
      if (h.flags & 8772) {
        var m = h.alternate;
        try {
          if (h.flags & 8772)
            switch (h.tag) {
              case 0:
              case 11:
              case 15:
                on || Tf(5, h);
                break;
              case 1:
                var x = h.stateNode;
                if (h.flags & 4 && !on)
                  if (m === null)
                    x.componentDidMount();
                  else {
                    var w = h.elementType === h.type ? m.memoizedProps : qa(h.type, m.memoizedProps);
                    x.componentDidUpdate(w, m.memoizedState, x.__reactInternalSnapshotBeforeUpdate);
                  }
                var D = h.updateQueue;
                D !== null && Ju(h, D, x);
                break;
              case 3:
                var F = h.updateQueue;
                if (F !== null) {
                  if (m = null, h.child !== null)
                    switch (h.child.tag) {
                      case 5:
                        m = h.child.stateNode;
                        break;
                      case 1:
                        m = h.child.stateNode;
                    }
                  Ju(h, F, m);
                }
                break;
              case 5:
                var W = h.stateNode;
                if (m === null && h.flags & 4) {
                  m = W;
                  var Y = h.memoizedProps;
                  switch (h.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      Y.autoFocus && m.focus();
                      break;
                    case "img":
                      Y.src && (m.src = Y.src);
                  }
                }
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (h.memoizedState === null) {
                  var he = h.alternate;
                  if (he !== null) {
                    var Be = he.memoizedState;
                    if (Be !== null) {
                      var Ne = Be.dehydrated;
                      Ne !== null && jh(Ne);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(i(163));
            }
          on || h.flags & 512 && X_(h);
        } catch (Pe) {
          Pr(h, h.return, Pe);
        }
      }
      if (h === d) {
        Ct = null;
        break;
      }
      if (m = h.sibling, m !== null) {
        m.return = h.return, Ct = m;
        break;
      }
      Ct = h.return;
    }
  }
  function Z_(d) {
    for (; Ct !== null; ) {
      var h = Ct;
      if (h === d) {
        Ct = null;
        break;
      }
      var m = h.sibling;
      if (m !== null) {
        m.return = h.return, Ct = m;
        break;
      }
      Ct = h.return;
    }
  }
  function z0(d) {
    for (; Ct !== null; ) {
      var h = Ct;
      try {
        switch (h.tag) {
          case 0:
          case 11:
          case 15:
            var m = h.return;
            try {
              Tf(4, h);
            } catch (Y) {
              Pr(h, m, Y);
            }
            break;
          case 1:
            var x = h.stateNode;
            if (typeof x.componentDidMount == "function") {
              var w = h.return;
              try {
                x.componentDidMount();
              } catch (Y) {
                Pr(h, w, Y);
              }
            }
            var D = h.return;
            try {
              X_(h);
            } catch (Y) {
              Pr(h, D, Y);
            }
            break;
          case 5:
            var F = h.return;
            try {
              X_(h);
            } catch (Y) {
              Pr(h, F, Y);
            }
        }
      } catch (Y) {
        Pr(h, h.return, Y);
      }
      if (h === d) {
        Ct = null;
        break;
      }
      var W = h.sibling;
      if (W !== null) {
        W.return = h.return, Ct = W;
        break;
      }
      Ct = h.return;
    }
  }
  var eg = Math.ceil, If = te.ReactCurrentDispatcher, J_ = te.ReactCurrentOwner, Yn = te.ReactCurrentBatchConfig, pi = 0, Dr = null, kr = null, gn = 0, Qa = 0, Fc = ri(0), sn = 0, Df = null, fl = 0, tg = 0, Bc = 0, cd = null, na = null, eC = 0, Vc = 1 / 0, pl = null, ig = !1, hd = null, Ts = null, ru = !1, nu = null, rg = 0, Nc = 0, ng = null, fd = -1, pd = 0;
  function qn() {
    return pi & 6 ? hi() : fd !== -1 ? fd : fd = hi();
  }
  function jr(d) {
    return d.mode & 1 ? pi & 2 && gn !== 0 ? gn & -gn : wv.transition !== null ? (pd === 0 && (pd = tv()), pd) : (d = Gi, d !== 0 || (d = window.event, d = d === void 0 ? 16 : e_(d.type)), d) : 1;
  }
  function Xn(d, h, m, x) {
    if (50 < Nc)
      throw Nc = 0, ng = null, Error(i(185));
    Wu(d, m, x), (!(pi & 2) || d !== Dr) && (d === Dr && (!(pi & 2) && (tg |= m), sn === 4 && Io(d, gn)), Qn(d, x), m === 1 && pi === 0 && !(h.mode & 1) && (Vc = hi() + 500, pn && ba()));
  }
  function Qn(d, h) {
    var m = d.callbackNode;
    ev(d, h);
    var x = qo(d, d === Dr ? gn : 0);
    if (x === 0)
      m !== null && pr(m), d.callbackNode = null, d.callbackPriority = 0;
    else if (h = x & -x, d.callbackPriority !== h) {
      if (m != null && pr(m), h === 1)
        d.tag === 0 ? T_(W0.bind(null, d)) : w_(W0.bind(null, d)), S_(function() {
          !(pi & 6) && ba();
        }), m = null;
      else {
        switch (Qm(x)) {
          case 1:
            m = Zs;
            break;
          case 4:
            m = fi;
            break;
          case 16:
            m = Nl;
            break;
          case 536870912:
            m = jm;
            break;
          default:
            m = Nl;
        }
        m = oC(m, Hc.bind(null, d));
      }
      d.callbackPriority = h, d.callbackNode = m;
    }
  }
  function Hc(d, h) {
    if (fd = -1, pd = 0, pi & 6)
      throw Error(i(327));
    var m = d.callbackNode;
    if (zc() && d.callbackNode !== m)
      return null;
    var x = qo(d, d === Dr ? gn : 0);
    if (x === 0)
      return null;
    if (x & 30 || x & d.expiredLanes || h)
      h = og(d, x);
    else {
      h = x;
      var w = pi;
      pi |= 2;
      var D = ag();
      (Dr !== d || gn !== h) && (pl = null, Vc = hi() + 500, vd(d, h));
      do
        try {
          vD();
          break;
        } catch (W) {
          U0(d, W);
        }
      while (!0);
      L_(), If.current = D, pi = w, kr !== null ? h = 0 : (Dr = null, gn = 0, h = sn);
    }
    if (h !== 0) {
      if (h === 2 && (w = qm(d), w !== 0 && (x = w, h = tC(d, w))), h === 1)
        throw m = Df, vd(d, 0), Io(d, x), Qn(d, hi()), m;
      if (h === 6)
        Io(d, x);
      else {
        if (w = d.current.alternate, !(x & 30) && !iC(w) && (h = og(d, x), h === 2 && (D = qm(d), D !== 0 && (x = D, h = tC(d, D))), h === 1))
          throw m = Df, vd(d, 0), Io(d, x), Qn(d, hi()), m;
        switch (d.finishedWork = w, d.finishedLanes = x, h) {
          case 0:
          case 1:
            throw Error(i(345));
          case 2:
            gd(d, na, pl);
            break;
          case 3:
            if (Io(d, x), (x & 130023424) === x && (h = eC + 500 - hi(), 10 < h)) {
              if (qo(d, 0) !== 0)
                break;
              if (w = d.suspendedLanes, (w & x) !== x) {
                qn(), d.pingedLanes |= d.suspendedLanes & w;
                break;
              }
              d.timeoutHandle = Xu(gd.bind(null, d, na, pl), h);
              break;
            }
            gd(d, na, pl);
            break;
          case 4:
            if (Io(d, x), (x & 4194240) === x)
              break;
            for (h = d.eventTimes, w = -1; 0 < x; ) {
              var F = 31 - po(x);
              D = 1 << F, F = h[F], F > w && (w = F), x &= ~D;
            }
            if (x = w, x = hi() - x, x = (120 > x ? 120 : 480 > x ? 480 : 1080 > x ? 1080 : 1920 > x ? 1920 : 3e3 > x ? 3e3 : 4320 > x ? 4320 : 1960 * eg(x / 1960)) - x, 10 < x) {
              d.timeoutHandle = Xu(gd.bind(null, d, na, pl), x);
              break;
            }
            gd(d, na, pl);
            break;
          case 5:
            gd(d, na, pl);
            break;
          default:
            throw Error(i(329));
        }
      }
    }
    return Qn(d, hi()), d.callbackNode === m ? Hc.bind(null, d) : null;
  }
  function tC(d, h) {
    var m = cd;
    return d.current.memoizedState.isDehydrated && (vd(d, h).flags |= 256), d = og(d, h), d !== 2 && (h = na, na = m, h !== null && Af(h)), d;
  }
  function Af(d) {
    na === null ? na = d : na.push.apply(na, d);
  }
  function iC(d) {
    for (var h = d; ; ) {
      if (h.flags & 16384) {
        var m = h.updateQueue;
        if (m !== null && (m = m.stores, m !== null))
          for (var x = 0; x < m.length; x++) {
            var w = m[x], D = w.getSnapshot;
            w = w.value;
            try {
              if (!mo(D(), w))
                return !1;
            } catch {
              return !1;
            }
          }
      }
      if (m = h.child, h.subtreeFlags & 16384 && m !== null)
        m.return = h, h = m;
      else {
        if (h === d)
          break;
        for (; h.sibling === null; ) {
          if (h.return === null || h.return === d)
            return !0;
          h = h.return;
        }
        h.sibling.return = h.return, h = h.sibling;
      }
    }
    return !0;
  }
  function Io(d, h) {
    for (h &= ~Bc, h &= ~tg, d.suspendedLanes |= h, d.pingedLanes &= ~h, d = d.expirationTimes; 0 < h; ) {
      var m = 31 - po(h), x = 1 << m;
      d[m] = -1, h &= ~x;
    }
  }
  function W0(d) {
    if (pi & 6)
      throw Error(i(327));
    zc();
    var h = qo(d, 0);
    if (!(h & 1))
      return Qn(d, hi()), null;
    var m = og(d, h);
    if (d.tag !== 0 && m === 2) {
      var x = qm(d);
      x !== 0 && (h = x, m = tC(d, x));
    }
    if (m === 1)
      throw m = Df, vd(d, 0), Io(d, h), Qn(d, hi()), m;
    if (m === 6)
      throw Error(i(345));
    return d.finishedWork = d.current.alternate, d.finishedLanes = h, gd(d, na, pl), Qn(d, hi()), null;
  }
  function $c(d, h) {
    var m = pi;
    pi |= 1;
    try {
      return d(h);
    } finally {
      pi = m, pi === 0 && (Vc = hi() + 500, pn && ba());
    }
  }
  function au(d) {
    nu !== null && nu.tag === 0 && !(pi & 6) && zc();
    var h = pi;
    pi |= 1;
    var m = Yn.transition, x = Gi;
    try {
      if (Yn.transition = null, Gi = 1, d)
        return d();
    } finally {
      Gi = x, Yn.transition = m, pi = h, !(pi & 6) && ba();
    }
  }
  function rC() {
    Qa = Fc.current, Fi(Fc);
  }
  function vd(d, h) {
    d.finishedWork = null, d.finishedLanes = 0;
    var m = d.timeoutHandle;
    if (m !== -1 && (d.timeoutHandle = -1, m0(m)), kr !== null)
      for (m = kr.return; m !== null; ) {
        var x = m;
        switch (D_(x), x.tag) {
          case 1:
            x = x.type.childContextTypes, x != null && yo();
            break;
          case 3:
            Jl(), Fi(Mr), Fi(Gt), Rv();
            break;
          case 5:
            li(x);
            break;
          case 4:
            Jl();
            break;
          case 13:
            Fi(Vt);
            break;
          case 19:
            Fi(Vt);
            break;
          case 10:
            sl(x.type._context);
            break;
          case 22:
          case 23:
            rC();
        }
        m = m.return;
      }
    if (Dr = d, kr = d = ou(d.current, null), gn = Qa = h, sn = 0, Df = null, Bc = tg = fl = 0, na = cd = null, bn !== null) {
      for (h = 0; h < bn.length; h++)
        if (m = bn[h], x = m.interleaved, x !== null) {
          m.interleaved = null;
          var w = x.next, D = m.pending;
          if (D !== null) {
            var F = D.next;
            D.next = w, x.next = F;
          }
          m.pending = x;
        }
      bn = null;
    }
    return d;
  }
  function U0(d, h) {
    do {
      var m = kr;
      try {
        if (L_(), Lv.current = Yv, Ht) {
          for (var x = mr.memoizedState; x !== null; ) {
            var w = x.queue;
            w !== null && (w.pending = null), x = x.next;
          }
          Ht = !1;
        }
        if (td = 0, yi = Te = mr = null, Es = !1, Xa = 0, J_.current = null, m === null || m.return === null) {
          sn = 1, Df = h, kr = null;
          break;
        }
        e: {
          var D = d, F = m.return, W = m, Y = h;
          if (h = gn, W.flags |= 32768, Y !== null && typeof Y == "object" && typeof Y.then == "function") {
            var he = Y, Be = W, Ne = Be.tag;
            if (!(Be.mode & 1) && (Ne === 0 || Ne === 11 || Ne === 15)) {
              var Pe = Be.alternate;
              Pe ? (Be.updateQueue = Pe.updateQueue, Be.memoizedState = Pe.memoizedState, Be.lanes = Pe.lanes) : (Be.updateQueue = null, Be.memoizedState = null);
            }
            var ut = $_(F);
            if (ut !== null) {
              ut.flags &= -257, z_(ut, F, W, D, h), ut.mode & 1 && L0(D, he, h), h = ut, Y = he;
              var xt = h.updateQueue;
              if (xt === null) {
                var bt = /* @__PURE__ */ new Set();
                bt.add(Y), h.updateQueue = bt;
              } else
                xt.add(Y);
              break e;
            } else {
              if (!(h & 1)) {
                L0(D, he, h), nC();
                break e;
              }
              Y = Error(i(426));
            }
          } else if (gr && W.mode & 1) {
            var Nr = $_(F);
            if (Nr !== null) {
              !(Nr.flags & 65536) && (Nr.flags |= 256), z_(Nr, F, W, D, h), O_(Ac(Y, W));
              break e;
            }
          }
          D = Y = Ac(Y, W), sn !== 4 && (sn = 2), cd === null ? cd = [D] : cd.push(D), D = F;
          do {
            switch (D.tag) {
              case 3:
                D.flags |= 65536, h &= -h, D.lanes |= h;
                var oe = R0(D, Y, h);
                P_(D, oe);
                break e;
              case 1:
                W = Y;
                var Z = D.type, ue = D.stateNode;
                if (!(D.flags & 128) && (typeof Z.getDerivedStateFromError == "function" || ue !== null && typeof ue.componentDidCatch == "function" && (Ts === null || !Ts.has(ue)))) {
                  D.flags |= 65536, h &= -h, D.lanes |= h;
                  var Ge = yf(D, W, h);
                  P_(D, Ge);
                  break e;
                }
            }
            D = D.return;
          } while (D !== null);
        }
        aC(m);
      } catch (It) {
        h = It, kr === m && m !== null && (kr = m = m.return);
        continue;
      }
      break;
    } while (!0);
  }
  function ag() {
    var d = If.current;
    return If.current = Yv, d === null ? Yv : d;
  }
  function nC() {
    (sn === 0 || sn === 3 || sn === 2) && (sn = 4), Dr === null || !(fl & 268435455) && !(tg & 268435455) || Io(Dr, gn);
  }
  function og(d, h) {
    var m = pi;
    pi |= 2;
    var x = ag();
    (Dr !== d || gn !== h) && (pl = null, vd(d, h));
    do
      try {
        pD();
        break;
      } catch (w) {
        U0(d, w);
      }
    while (!0);
    if (L_(), pi = m, If.current = x, kr !== null)
      throw Error(i(261));
    return Dr = null, gn = 0, sn;
  }
  function pD() {
    for (; kr !== null; )
      G0(kr);
  }
  function vD() {
    for (; kr !== null && !xa(); )
      G0(kr);
  }
  function G0(d) {
    var h = j0(d.alternate, d, Qa);
    d.memoizedProps = d.pendingProps, h === null ? aC(d) : kr = h, J_.current = null;
  }
  function aC(d) {
    var h = d;
    do {
      var m = h.alternate;
      if (d = h.return, h.flags & 32768) {
        if (m = q_(m, h), m !== null) {
          m.flags &= 32767, kr = m;
          return;
        }
        if (d !== null)
          d.flags |= 32768, d.subtreeFlags = 0, d.deletions = null;
        else {
          sn = 6, kr = null;
          return;
        }
      } else if (m = fD(m, h, Qa), m !== null) {
        kr = m;
        return;
      }
      if (h = h.sibling, h !== null) {
        kr = h;
        return;
      }
      kr = h = d;
    } while (h !== null);
    sn === 0 && (sn = 5);
  }
  function gd(d, h, m) {
    var x = Gi, w = Yn.transition;
    try {
      Yn.transition = null, Gi = 1, gD(d, h, m, x);
    } finally {
      Yn.transition = w, Gi = x;
    }
    return null;
  }
  function gD(d, h, m, x) {
    do
      zc();
    while (nu !== null);
    if (pi & 6)
      throw Error(i(327));
    m = d.finishedWork;
    var w = d.finishedLanes;
    if (m === null)
      return null;
    if (d.finishedWork = null, d.finishedLanes = 0, m === d.current)
      throw Error(i(177));
    d.callbackNode = null, d.callbackPriority = 0;
    var D = m.lanes | m.childLanes;
    if (zI(d, D), d === Dr && (kr = Dr = null, gn = 0), !(m.subtreeFlags & 2064) && !(m.flags & 2064) || ru || (ru = !0, oC(Nl, function() {
      return zc(), null;
    })), D = (m.flags & 15990) !== 0, m.subtreeFlags & 15990 || D) {
      D = Yn.transition, Yn.transition = null;
      var F = Gi;
      Gi = 1;
      var W = pi;
      pi |= 4, J_.current = null, B0(d, m), N0(m, d), pv(qu), Uu = !!y_, qu = y_ = null, d.current = m, H0(m, d, w), Cs(), pi = W, Gi = F, Yn.transition = D;
    } else
      d.current = m;
    if (ru && (ru = !1, nu = d, rg = w), D = d.pendingLanes, D === 0 && (Ts = null), RS(m.stateNode, x), Qn(d, hi()), h !== null)
      for (x = d.onRecoverableError, m = 0; m < h.length; m++)
        w = h[m], x(w.value, { componentStack: w.stack, digest: w.digest });
    if (ig)
      throw ig = !1, d = hd, hd = null, d;
    return rg & 1 && d.tag !== 0 && zc(), D = d.pendingLanes, D & 1 ? d === ng ? Nc++ : (Nc = 0, ng = d) : Nc = 0, ba(), null;
  }
  function zc() {
    if (nu !== null) {
      var d = Qm(rg), h = Yn.transition, m = Gi;
      try {
        if (Yn.transition = null, Gi = 16 > d ? 16 : d, nu === null)
          var x = !1;
        else {
          if (d = nu, nu = null, rg = 0, pi & 6)
            throw Error(i(331));
          var w = pi;
          for (pi |= 4, Ct = d.current; Ct !== null; ) {
            var D = Ct, F = D.child;
            if (Ct.flags & 16) {
              var W = D.deletions;
              if (W !== null) {
                for (var Y = 0; Y < W.length; Y++) {
                  var he = W[Y];
                  for (Ct = he; Ct !== null; ) {
                    var Be = Ct;
                    switch (Be.tag) {
                      case 0:
                      case 11:
                      case 15:
                        wf(8, Be, D);
                    }
                    var Ne = Be.child;
                    if (Ne !== null)
                      Ne.return = Be, Ct = Ne;
                    else
                      for (; Ct !== null; ) {
                        Be = Ct;
                        var Pe = Be.sibling, ut = Be.return;
                        if (Q_(Be), Be === he) {
                          Ct = null;
                          break;
                        }
                        if (Pe !== null) {
                          Pe.return = ut, Ct = Pe;
                          break;
                        }
                        Ct = ut;
                      }
                  }
                }
                var xt = D.alternate;
                if (xt !== null) {
                  var bt = xt.child;
                  if (bt !== null) {
                    xt.child = null;
                    do {
                      var Nr = bt.sibling;
                      bt.sibling = null, bt = Nr;
                    } while (bt !== null);
                  }
                }
                Ct = D;
              }
            }
            if (D.subtreeFlags & 2064 && F !== null)
              F.return = D, Ct = F;
            else
              e:
                for (; Ct !== null; ) {
                  if (D = Ct, D.flags & 2048)
                    switch (D.tag) {
                      case 0:
                      case 11:
                      case 15:
                        wf(9, D, D.return);
                    }
                  var oe = D.sibling;
                  if (oe !== null) {
                    oe.return = D.return, Ct = oe;
                    break e;
                  }
                  Ct = D.return;
                }
          }
          var Z = d.current;
          for (Ct = Z; Ct !== null; ) {
            F = Ct;
            var ue = F.child;
            if (F.subtreeFlags & 2064 && ue !== null)
              ue.return = F, Ct = ue;
            else
              e:
                for (F = Z; Ct !== null; ) {
                  if (W = Ct, W.flags & 2048)
                    try {
                      switch (W.tag) {
                        case 0:
                        case 11:
                        case 15:
                          Tf(9, W);
                      }
                    } catch (It) {
                      Pr(W, W.return, It);
                    }
                  if (W === F) {
                    Ct = null;
                    break e;
                  }
                  var Ge = W.sibling;
                  if (Ge !== null) {
                    Ge.return = W.return, Ct = Ge;
                    break e;
                  }
                  Ct = W.return;
                }
          }
          if (pi = w, ba(), Yo && typeof Yo.onPostCommitFiberRoot == "function")
            try {
              Yo.onPostCommitFiberRoot(zh, d);
            } catch {
            }
          x = !0;
        }
        return x;
      } finally {
        Gi = m, Yn.transition = h;
      }
    }
    return !1;
  }
  function K0(d, h, m) {
    h = Ac(m, h), h = R0(d, h, 1), d = Ql(d, h, 1), h = qn(), d !== null && (Wu(d, 1, h), Qn(d, h));
  }
  function Pr(d, h, m) {
    if (d.tag === 3)
      K0(d, d, m);
    else
      for (; h !== null; ) {
        if (h.tag === 3) {
          K0(h, d, m);
          break;
        } else if (h.tag === 1) {
          var x = h.stateNode;
          if (typeof h.type.getDerivedStateFromError == "function" || typeof x.componentDidCatch == "function" && (Ts === null || !Ts.has(x))) {
            d = Ac(m, d), d = yf(h, d, 1), h = Ql(h, d, 1), d = qn(), h !== null && (Wu(h, 1, d), Qn(h, d));
            break;
          }
        }
        h = h.return;
      }
  }
  function mD(d, h, m) {
    var x = d.pingCache;
    x !== null && x.delete(h), h = qn(), d.pingedLanes |= d.suspendedLanes & m, Dr === d && (gn & m) === m && (sn === 4 || sn === 3 && (gn & 130023424) === gn && 500 > hi() - eC ? vd(d, 0) : Bc |= m), Qn(d, h);
  }
  function sg(d, h) {
    h === 0 && (d.mode & 1 ? (h = dc, dc <<= 1, !(dc & 130023424) && (dc = 4194304)) : h = 1);
    var m = qn();
    d = ll(d, h), d !== null && (Wu(d, h, m), Qn(d, m));
  }
  function _D(d) {
    var h = d.memoizedState, m = 0;
    h !== null && (m = h.retryLane), sg(d, m);
  }
  function CD(d, h) {
    var m = 0;
    switch (d.tag) {
      case 13:
        var x = d.stateNode, w = d.memoizedState;
        w !== null && (m = w.retryLane);
        break;
      case 19:
        x = d.stateNode;
        break;
      default:
        throw Error(i(314));
    }
    x !== null && x.delete(h), sg(d, m);
  }
  var j0;
  j0 = function(d, h, m) {
    if (d !== null)
      if (d.memoizedProps !== h.pendingProps || Mr.current)
        Kr = !0;
      else {
        if (!(d.lanes & m) && !(h.flags & 128))
          return Kr = !1, cl(d, h, m);
        Kr = !!(d.flags & 131072);
      }
    else
      Kr = !1, gr && h.flags & 1048576 && I_(h, Sc, h.index);
    switch (h.lanes = 0, h.tag) {
      case 2:
        var x = h.type;
        Kn(d, h), d = h.pendingProps;
        var w = Co(h, Gt.current);
        it(h, m), w = eu(null, h, x, d, w, m);
        var D = nd();
        return h.flags |= 1, typeof w == "object" && w !== null && typeof w.render == "function" && w.$$typeof === void 0 ? (h.tag = 1, h.memoizedState = null, h.updateQueue = null, xr(x) ? (D = !0, yv(h)) : D = !1, h.memoizedState = w.state !== null && w.state !== void 0 ? w.state : null, k_(h), w.updater = Dv, h.stateNode = w, w._reactInternals = h, Av(h, x, d, m), h = M0(null, h, x, !0, D, m)) : (h.tag = 0, gr && D && xv(h), nn(null, h, w, m), h = h.child), h;
      case 16:
        x = h.elementType;
        e: {
          switch (Kn(d, h), d = h.pendingProps, w = x._init, x = w(x._payload), h.type = x, w = h.tag = xD(x), d = qa(x, d), w) {
            case 0:
              h = Oc(null, h, x, d, m);
              break e;
            case 1:
              h = W_(null, h, x, d, m);
              break e;
            case 11:
              h = iu(null, h, x, d, m);
              break e;
            case 14:
              h = Xv(null, h, x, qa(x.type, d), m);
              break e;
          }
          throw Error(i(
            306,
            x,
            ""
          ));
        }
        return h;
      case 0:
        return x = h.type, w = h.pendingProps, w = h.elementType === x ? w : qa(x, w), Oc(d, h, x, w, m);
      case 1:
        return x = h.type, w = h.pendingProps, w = h.elementType === x ? w : qa(x, w), W_(d, h, x, w, m);
      case 3:
        e: {
          if (k0(h), d === null)
            throw Error(i(387));
          x = h.pendingProps, D = h.memoizedState, w = D.element, rn(d, h), Zl(h, x, null, m);
          var F = h.memoizedState;
          if (x = F.element, D.isDehydrated)
            if (D = { element: x, isDehydrated: !1, cache: F.cache, pendingSuspenseBoundaries: F.pendingSuspenseBoundaries, transitions: F.transitions }, h.updateQueue.baseState = D, h.memoizedState = D, h.flags & 256) {
              w = Ac(Error(i(423)), h), h = Qv(d, h, x, m, w);
              break e;
            } else if (x !== w) {
              w = Ac(Error(i(424)), h), h = Qv(d, h, x, m, w);
              break e;
            } else
              for (Ia = Jo(h.stateNode.containerInfo.firstChild), Ya = h, gr = !0, So = null, m = A0(h, null, x, m), h.child = m; m; )
                m.flags = m.flags & -3 | 4096, m = m.sibling;
          else {
            if (Tr(), x === w) {
              h = wn(d, h, m);
              break e;
            }
            nn(d, h, x, m);
          }
          h = h.child;
        }
        return h;
      case 5:
        return Ft(h), d === null && Ev(h), x = h.type, w = h.pendingProps, D = d !== null ? d.memoizedProps : null, F = w.children, lf(x, w) ? F = null : D !== null && lf(x, D) && (h.flags |= 32), ei(d, h), nn(d, h, F, m), h.child;
      case 6:
        return d === null && Ev(h), null;
      case 13:
        return G_(d, h, m);
      case 4:
        return B_(h, h.stateNode.containerInfo), x = h.pendingProps, d === null ? h.child = bc(h, null, x, m) : nn(d, h, x, m), h.child;
      case 11:
        return x = h.type, w = h.pendingProps, w = h.elementType === x ? w : qa(x, w), iu(d, h, x, w, m);
      case 7:
        return nn(d, h, h.pendingProps, m), h.child;
      case 8:
        return nn(d, h, h.pendingProps.children, m), h.child;
      case 12:
        return nn(d, h, h.pendingProps.children, m), h.child;
      case 10:
        e: {
          if (x = h.type._context, w = h.pendingProps, D = h.memoizedProps, F = w.value, Vi(Ss, x._currentValue), x._currentValue = F, D !== null)
            if (mo(D.value, F)) {
              if (D.children === w.children && !Mr.current) {
                h = wn(d, h, m);
                break e;
              }
            } else
              for (D = h.child, D !== null && (D.return = h); D !== null; ) {
                var W = D.dependencies;
                if (W !== null) {
                  F = D.child;
                  for (var Y = W.firstContext; Y !== null; ) {
                    if (Y.context === x) {
                      if (D.tag === 1) {
                        Y = ul(-1, m & -m), Y.tag = 2;
                        var he = D.updateQueue;
                        if (he !== null) {
                          he = he.shared;
                          var Be = he.pending;
                          Be === null ? Y.next = Y : (Y.next = Be.next, Be.next = Y), he.pending = Y;
                        }
                      }
                      D.lanes |= m, Y = D.alternate, Y !== null && (Y.lanes |= m), tn(
                        D.return,
                        m,
                        h
                      ), W.lanes |= m;
                      break;
                    }
                    Y = Y.next;
                  }
                } else if (D.tag === 10)
                  F = D.type === h.type ? null : D.child;
                else if (D.tag === 18) {
                  if (F = D.return, F === null)
                    throw Error(i(341));
                  F.lanes |= m, W = F.alternate, W !== null && (W.lanes |= m), tn(F, m, h), F = D.sibling;
                } else
                  F = D.child;
                if (F !== null)
                  F.return = D;
                else
                  for (F = D; F !== null; ) {
                    if (F === h) {
                      F = null;
                      break;
                    }
                    if (D = F.sibling, D !== null) {
                      D.return = F.return, F = D;
                      break;
                    }
                    F = F.return;
                  }
                D = F;
              }
          nn(d, h, w.children, m), h = h.child;
        }
        return h;
      case 9:
        return w = h.type, x = h.pendingProps.children, it(h, m), w = Vr(w), x = x(w), h.flags |= 1, nn(d, h, x, m), h.child;
      case 14:
        return x = h.type, w = qa(x, h.pendingProps), w = qa(x.type, w), Xv(d, h, x, w, m);
      case 15:
        return Oa(d, h, h.type, h.pendingProps, m);
      case 17:
        return x = h.type, w = h.pendingProps, w = h.elementType === x ? w : qa(x, w), Kn(d, h), h.tag = 1, xr(x) ? (d = !0, yv(h)) : d = !1, it(h, m), w0(h, x, w), Av(h, x, w, m), M0(null, h, x, !0, d, m);
      case 19:
        return Y_(d, h, m);
      case 22:
        return ld(d, h, m);
    }
    throw Error(i(156, h.tag));
  };
  function oC(d, h) {
    return ci(d, h);
  }
  function yD(d, h, m, x) {
    this.tag = d, this.key = m, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = h, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = x, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Do(d, h, m, x) {
    return new yD(d, h, m, x);
  }
  function sC(d) {
    return d = d.prototype, !(!d || !d.isReactComponent);
  }
  function xD(d) {
    if (typeof d == "function")
      return sC(d) ? 1 : 0;
    if (d != null) {
      if (d = d.$$typeof, d === ft)
        return 11;
      if (d === Re)
        return 14;
    }
    return 2;
  }
  function ou(d, h) {
    var m = d.alternate;
    return m === null ? (m = Do(d.tag, h, d.key, d.mode), m.elementType = d.elementType, m.type = d.type, m.stateNode = d.stateNode, m.alternate = d, d.alternate = m) : (m.pendingProps = h, m.type = d.type, m.flags = 0, m.subtreeFlags = 0, m.deletions = null), m.flags = d.flags & 14680064, m.childLanes = d.childLanes, m.lanes = d.lanes, m.child = d.child, m.memoizedProps = d.memoizedProps, m.memoizedState = d.memoizedState, m.updateQueue = d.updateQueue, h = d.dependencies, m.dependencies = h === null ? null : { lanes: h.lanes, firstContext: h.firstContext }, m.sibling = d.sibling, m.index = d.index, m.ref = d.ref, m;
  }
  function lg(d, h, m, x, w, D) {
    var F = 2;
    if (x = d, typeof d == "function")
      sC(d) && (F = 1);
    else if (typeof d == "string")
      F = 5;
    else
      e:
        switch (d) {
          case pe:
            return md(m.children, w, D, h);
          case _e:
            F = 8, w |= 8;
            break;
          case be:
            return d = Do(12, m, h, w | 2), d.elementType = be, d.lanes = D, d;
          case Ve:
            return d = Do(13, m, h, w), d.elementType = Ve, d.lanes = D, d;
          case Ee:
            return d = Do(19, m, h, w), d.elementType = Ee, d.lanes = D, d;
          case We:
            return Of(m, w, D, h);
          default:
            if (typeof d == "object" && d !== null)
              switch (d.$$typeof) {
                case De:
                  F = 10;
                  break e;
                case Ce:
                  F = 9;
                  break e;
                case ft:
                  F = 11;
                  break e;
                case Re:
                  F = 14;
                  break e;
                case we:
                  F = 16, x = null;
                  break e;
              }
            throw Error(i(130, d == null ? d : typeof d, ""));
        }
    return h = Do(F, m, h, w), h.elementType = d, h.type = x, h.lanes = D, h;
  }
  function md(d, h, m, x) {
    return d = Do(7, d, x, h), d.lanes = m, d;
  }
  function Of(d, h, m, x) {
    return d = Do(22, d, x, h), d.elementType = We, d.lanes = m, d.stateNode = { isHidden: !1 }, d;
  }
  function Rf(d, h, m) {
    return d = Do(6, d, null, h), d.lanes = m, d;
  }
  function _d(d, h, m) {
    return h = Do(4, d.children !== null ? d.children : [], d.key, h), h.lanes = m, h.stateNode = { containerInfo: d.containerInfo, pendingChildren: null, implementation: d.implementation }, h;
  }
  function SD(d, h, m, x, w) {
    this.tag = h, this.containerInfo = d, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Xm(0), this.expirationTimes = Xm(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Xm(0), this.identifierPrefix = x, this.onRecoverableError = w, this.mutableSourceEagerHydrationData = null;
  }
  function ug(d, h, m, x, w, D, F, W, Y) {
    return d = new SD(d, h, m, W, Y), h === 1 ? (h = 1, D === !0 && (h |= 8)) : h = 0, D = Do(3, null, null, h), d.current = D, D.stateNode = d, D.memoizedState = { element: x, isDehydrated: m, cache: null, transitions: null, pendingSuspenseBoundaries: null }, k_(D), d;
  }
  function Y0(d, h, m) {
    var x = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: ie, key: x == null ? null : "" + x, children: d, containerInfo: h, implementation: m };
  }
  function lC(d) {
    if (!d)
      return xs;
    d = d._reactInternals;
    e: {
      if (Fe(d) !== d || d.tag !== 1)
        throw Error(i(170));
      var h = d;
      do {
        switch (h.tag) {
          case 3:
            h = h.stateNode.context;
            break e;
          case 1:
            if (xr(h.type)) {
              h = h.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        h = h.return;
      } while (h !== null);
      throw Error(i(171));
    }
    if (d.tag === 1) {
      var m = d.type;
      if (xr(m))
        return cf(d, m, h);
    }
    return h;
  }
  function q0(d, h, m, x, w, D, F, W, Y) {
    return d = ug(m, x, !0, d, w, D, F, W, Y), d.context = lC(null), m = d.current, x = qn(), w = jr(m), D = ul(x, w), D.callback = h ?? null, Ql(m, D, w), d.current.lanes = w, Wu(d, w, x), Qn(d, x), d;
  }
  function Lf(d, h, m, x) {
    var w = h.current, D = qn(), F = jr(w);
    return m = lC(m), h.context === null ? h.context = m : h.pendingContext = m, h = ul(D, F), h.payload = { element: d }, x = x === void 0 ? null : x, x !== null && (h.callback = x), d = Ql(w, h, F), d !== null && (Xn(d, w, F, D), Iv(d, w, F)), F;
  }
  function dg(d) {
    if (d = d.current, !d.child)
      return null;
    switch (d.child.tag) {
      case 5:
        return d.child.stateNode;
      default:
        return d.child.stateNode;
    }
  }
  function X0(d, h) {
    if (d = d.memoizedState, d !== null && d.dehydrated !== null) {
      var m = d.retryLane;
      d.retryLane = m !== 0 && m < h ? m : h;
    }
  }
  function uC(d, h) {
    X0(d, h), (d = d.alternate) && X0(d, h);
  }
  function Q0() {
    return null;
  }
  var dC = typeof reportError == "function" ? reportError : function(d) {
    console.error(d);
  };
  function cg(d) {
    this._internalRoot = d;
  }
  vl.prototype.render = cg.prototype.render = function(d) {
    var h = this._internalRoot;
    if (h === null)
      throw Error(i(409));
    Lf(d, h, null, null);
  }, vl.prototype.unmount = cg.prototype.unmount = function() {
    var d = this._internalRoot;
    if (d !== null) {
      this._internalRoot = null;
      var h = d.containerInfo;
      au(function() {
        Lf(null, d, null, null);
      }), h[al] = null;
    }
  };
  function vl(d) {
    this._internalRoot = d;
  }
  vl.prototype.unstable_scheduleHydration = function(d) {
    if (d) {
      var h = PS();
      d = { blockedOn: null, target: d, priority: h };
      for (var m = 0; m < Xi.length && h !== 0 && h < Xi[m].priority; m++)
        ;
      Xi.splice(m, 0, d), m === 0 && FS(d);
    }
  };
  function cC(d) {
    return !(!d || d.nodeType !== 1 && d.nodeType !== 9 && d.nodeType !== 11);
  }
  function hg(d) {
    return !(!d || d.nodeType !== 1 && d.nodeType !== 9 && d.nodeType !== 11 && (d.nodeType !== 8 || d.nodeValue !== " react-mount-point-unstable "));
  }
  function Z0() {
  }
  function ED(d, h, m, x, w) {
    if (w) {
      if (typeof x == "function") {
        var D = x;
        x = function() {
          var he = dg(F);
          D.call(he);
        };
      }
      var F = q0(h, x, d, 0, null, !1, !1, "", Z0);
      return d._reactRootContainer = F, d[al] = F.current, yc(d.nodeType === 8 ? d.parentNode : d), au(), F;
    }
    for (; w = d.lastChild; )
      d.removeChild(w);
    if (typeof x == "function") {
      var W = x;
      x = function() {
        var he = dg(Y);
        W.call(he);
      };
    }
    var Y = ug(d, 0, !1, null, null, !1, !1, "", Z0);
    return d._reactRootContainer = Y, d[al] = Y.current, yc(d.nodeType === 8 ? d.parentNode : d), au(function() {
      Lf(h, Y, m, x);
    }), Y;
  }
  function fg(d, h, m, x, w) {
    var D = m._reactRootContainer;
    if (D) {
      var F = D;
      if (typeof w == "function") {
        var W = w;
        w = function() {
          var Y = dg(F);
          W.call(Y);
        };
      }
      Lf(h, F, d, w);
    } else
      F = ED(m, h, d, w, x);
    return dg(F);
  }
  kS = function(d) {
    switch (d.tag) {
      case 3:
        var h = d.stateNode;
        if (h.current.memoizedState.isDehydrated) {
          var m = zu(h.pendingLanes);
          m !== 0 && (Wh(h, m | 1), Qn(h, hi()), !(pi & 6) && (Vc = hi() + 500, ba()));
        }
        break;
      case 13:
        au(function() {
          var x = ll(d, 1);
          if (x !== null) {
            var w = qn();
            Xn(x, d, 1, w);
          }
        }), uC(d, 1);
    }
  }, iv = function(d) {
    if (d.tag === 13) {
      var h = ll(d, 134217728);
      if (h !== null) {
        var m = qn();
        Xn(h, d, 134217728, m);
      }
      uC(d, 134217728);
    }
  }, ir = function(d) {
    if (d.tag === 13) {
      var h = jr(d), m = ll(d, h);
      if (m !== null) {
        var x = qn();
        Xn(m, d, h, x);
      }
      uC(d, h);
    }
  }, PS = function() {
    return Gi;
  }, Zm = function(d, h) {
    var m = Gi;
    try {
      return Gi = d, h();
    } finally {
      Gi = m;
    }
  }, ur = function(d, h, m) {
    switch (h) {
      case "input":
        if (lr(d, m), h = m.name, m.type === "radio" && h != null) {
          for (m = d; m.parentNode; )
            m = m.parentNode;
          for (m = m.querySelectorAll("input[name=" + JSON.stringify("" + h) + '][type="radio"]'), h = 0; h < m.length; h++) {
            var x = m[h];
            if (x !== d && x.form === d.form) {
              var w = Lt(x);
              if (!w)
                throw Error(i(90));
              Ie(x), lr(x, w);
            }
          }
        }
        break;
      case "textarea":
        Yi(d, m);
        break;
      case "select":
        h = m.value, h != null && ia(d, !!m.multiple, h, !1);
    }
  }, $u = $c, uc = au;
  var bD = { usingClientEntryPoint: !1, Events: [df, xc, Lt, gs, Vl, $c] }, Wc = { findFiberByHostInstance: _o, bundleType: 0, version: "18.2.0", rendererPackageName: "react-dom" }, wD = { bundleType: Wc.bundleType, version: Wc.version, rendererPackageName: Wc.rendererPackageName, rendererConfig: Wc.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: te.ReactCurrentDispatcher, findHostInstanceByFiber: function(d) {
    return d = Nt(d), d === null ? null : d.stateNode;
  }, findFiberByHostInstance: Wc.findFiberByHostInstance || Q0, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.2.0-next-9e3b772b8-20220608" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var pg = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!pg.isDisabled && pg.supportsFiber)
      try {
        zh = pg.inject(wD), Yo = pg;
      } catch {
      }
  }
  return ko.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = bD, ko.createPortal = function(d, h) {
    var m = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!cC(h))
      throw Error(i(200));
    return Y0(d, h, null, m);
  }, ko.createRoot = function(d, h) {
    if (!cC(d))
      throw Error(i(299));
    var m = !1, x = "", w = dC;
    return h != null && (h.unstable_strictMode === !0 && (m = !0), h.identifierPrefix !== void 0 && (x = h.identifierPrefix), h.onRecoverableError !== void 0 && (w = h.onRecoverableError)), h = ug(d, 1, !1, null, null, m, !1, x, w), d[al] = h.current, yc(d.nodeType === 8 ? d.parentNode : d), new cg(h);
  }, ko.findDOMNode = function(d) {
    if (d == null)
      return null;
    if (d.nodeType === 1)
      return d;
    var h = d._reactInternals;
    if (h === void 0)
      throw typeof d.render == "function" ? Error(i(188)) : (d = Object.keys(d).join(","), Error(i(268, d)));
    return d = Nt(h), d = d === null ? null : d.stateNode, d;
  }, ko.flushSync = function(d) {
    return au(d);
  }, ko.hydrate = function(d, h, m) {
    if (!hg(h))
      throw Error(i(200));
    return fg(null, d, h, !0, m);
  }, ko.hydrateRoot = function(d, h, m) {
    if (!cC(d))
      throw Error(i(405));
    var x = m != null && m.hydratedSources || null, w = !1, D = "", F = dC;
    if (m != null && (m.unstable_strictMode === !0 && (w = !0), m.identifierPrefix !== void 0 && (D = m.identifierPrefix), m.onRecoverableError !== void 0 && (F = m.onRecoverableError)), h = q0(h, null, d, 1, m ?? null, w, !1, D, F), d[al] = h.current, yc(d), x)
      for (d = 0; d < x.length; d++)
        m = x[d], w = m._getVersion, w = w(m._source), h.mutableSourceEagerHydrationData == null ? h.mutableSourceEagerHydrationData = [m, w] : h.mutableSourceEagerHydrationData.push(
          m,
          w
        );
    return new vl(h);
  }, ko.render = function(d, h, m) {
    if (!hg(h))
      throw Error(i(200));
    return fg(null, d, h, !1, m);
  }, ko.unmountComponentAtNode = function(d) {
    if (!hg(d))
      throw Error(i(40));
    return d._reactRootContainer ? (au(function() {
      fg(null, null, d, !1, function() {
        d._reactRootContainer = null, d[al] = null;
      });
    }), !0) : !1;
  }, ko.unstable_batchedUpdates = $c, ko.unstable_renderSubtreeIntoContainer = function(d, h, m, x) {
    if (!hg(m))
      throw Error(i(200));
    if (d == null || d._reactInternals === void 0)
      throw Error(i(38));
    return fg(d, h, m, !1, x);
  }, ko.version = "18.2.0-next-9e3b772b8-20220608", ko;
}
var Po = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bz;
function rue() {
  return Bz || (Bz = 1, process.env.NODE_ENV !== "production" && function() {
    "use strict";
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = nc, e = dq(), i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, r = !1;
    function n(s) {
      r = s;
    }
    function a(s) {
      if (!r) {
        for (var l = arguments.length, f = new Array(l > 1 ? l - 1 : 0), g = 1; g < l; g++)
          f[g - 1] = arguments[g];
        u("warn", s, f);
      }
    }
    function o(s) {
      if (!r) {
        for (var l = arguments.length, f = new Array(l > 1 ? l - 1 : 0), g = 1; g < l; g++)
          f[g - 1] = arguments[g];
        u("error", s, f);
      }
    }
    function u(s, l, f) {
      {
        var g = i.ReactDebugCurrentFrame, C = g.getStackAddendum();
        C !== "" && (l += "%s", f = f.concat([C]));
        var S = f.map(function(T) {
          return String(T);
        });
        S.unshift("Warning: " + l), Function.prototype.apply.call(console[s], console, S);
      }
    }
    var c = 0, p = 1, v = 2, _ = 3, y = 4, b = 5, I = 6, A = 7, L = 8, B = 9, $ = 10, K = 11, te = 12, z = 13, ie = 14, pe = 15, _e = 16, be = 17, De = 18, Ce = 19, ft = 21, Ve = 22, Ee = 23, Re = 24, we = 25, We = !0, ne = !1, Ae = !1, j = !1, ge = !1, Me = !0, ze = !1, je = !1, vt = !0, Je = !0, _t = !0, at = /* @__PURE__ */ new Set(), yt = {}, tt = {};
    function zt(s, l) {
      Ie(s, l), Ie(s + "Capture", l);
    }
    function Ie(s, l) {
      yt[s] && o("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", s), yt[s] = l;
      {
        var f = s.toLowerCase();
        tt[f] = s, s === "onDoubleClick" && (tt.ondblclick = s);
      }
      for (var g = 0; g < l.length; g++)
        at.add(l[g]);
    }
    var gt = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", si = Object.prototype.hasOwnProperty;
    function Wt(s) {
      {
        var l = typeof Symbol == "function" && Symbol.toStringTag, f = l && s[Symbol.toStringTag] || s.constructor.name || "Object";
        return f;
      }
    }
    function ki(s) {
      try {
        return lr(s), !1;
      } catch {
        return !0;
      }
    }
    function lr(s) {
      return "" + s;
    }
    function mi(s, l) {
      if (ki(s))
        return o("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", l, Wt(s)), lr(s);
    }
    function Wi(s) {
      if (ki(s))
        return o("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Wt(s)), lr(s);
    }
    function Rr(s, l) {
      if (ki(s))
        return o("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", l, Wt(s)), lr(s);
    }
    function ia(s, l) {
      if (ki(s))
        return o("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", l, Wt(s)), lr(s);
    }
    function ra(s) {
      if (ki(s))
        return o("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Wt(s)), lr(s);
    }
    function zn(s) {
      if (ki(s))
        return o("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Wt(s)), lr(s);
    }
    var Yi = 0, tr = 1, cn = 2, hr = 3, Wr = 4, Go = 5, Wa = 6, Ca = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", nt = Ca + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Rt = new RegExp("^[" + Ca + "][" + nt + "]*$"), ii = {}, Pi = {};
    function Ui(s) {
      return si.call(Pi, s) ? !0 : si.call(ii, s) ? !1 : Rt.test(s) ? (Pi[s] = !0, !0) : (ii[s] = !0, o("Invalid attribute name: `%s`", s), !1);
    }
    function Br(s, l, f) {
      return l !== null ? l.type === Yi : f ? !1 : s.length > 2 && (s[0] === "o" || s[0] === "O") && (s[1] === "n" || s[1] === "N");
    }
    function fr(s, l, f, g) {
      if (f !== null && f.type === Yi)
        return !1;
      switch (typeof l) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (g)
            return !1;
          if (f !== null)
            return !f.acceptsBooleans;
          var C = s.toLowerCase().slice(0, 5);
          return C !== "data-" && C !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Lr(s, l, f, g) {
      if (l === null || typeof l > "u" || fr(s, l, f, g))
        return !0;
      if (g)
        return !1;
      if (f !== null)
        switch (f.type) {
          case hr:
            return !l;
          case Wr:
            return l === !1;
          case Go:
            return isNaN(l);
          case Wa:
            return isNaN(l) || l < 1;
        }
      return !1;
    }
    function ur(s) {
      return qi.hasOwnProperty(s) ? qi[s] : null;
    }
    function Ti(s, l, f, g, C, S, T) {
      this.acceptsBooleans = l === cn || l === hr || l === Wr, this.attributeName = g, this.attributeNamespace = C, this.mustUseProperty = f, this.propertyName = s, this.type = l, this.sanitizeURL = S, this.removeEmptyString = T;
    }
    var qi = {}, Bl = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    Bl.forEach(function(s) {
      qi[s] = new Ti(
        s,
        Yi,
        !1,
        // mustUseProperty
        s,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(s) {
      var l = s[0], f = s[1];
      qi[l] = new Ti(
        l,
        tr,
        !1,
        // mustUseProperty
        f,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(s) {
      qi[s] = new Ti(
        s,
        cn,
        !1,
        // mustUseProperty
        s.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(s) {
      qi[s] = new Ti(
        s,
        cn,
        !1,
        // mustUseProperty
        s,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(s) {
      qi[s] = new Ti(
        s,
        hr,
        !1,
        // mustUseProperty
        s.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(s) {
      qi[s] = new Ti(
        s,
        hr,
        !0,
        // mustUseProperty
        s,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(s) {
      qi[s] = new Ti(
        s,
        Wr,
        !1,
        // mustUseProperty
        s,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(s) {
      qi[s] = new Ti(
        s,
        Wa,
        !1,
        // mustUseProperty
        s,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(s) {
      qi[s] = new Ti(
        s,
        Go,
        !1,
        // mustUseProperty
        s.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var gs = /[\-\:]([a-z])/g, Vl = function(s) {
      return s[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(s) {
      var l = s.replace(gs, Vl);
      qi[l] = new Ti(
        l,
        tr,
        !1,
        // mustUseProperty
        s,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(s) {
      var l = s.replace(gs, Vl);
      qi[l] = new Ti(
        l,
        tr,
        !1,
        // mustUseProperty
        s,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(s) {
      var l = s.replace(gs, Vl);
      qi[l] = new Ti(
        l,
        tr,
        !1,
        // mustUseProperty
        s,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(s) {
      qi[s] = new Ti(
        s,
        tr,
        !1,
        // mustUseProperty
        s.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var $u = "xlinkHref";
    qi[$u] = new Ti(
      "xlinkHref",
      tr,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(s) {
      qi[s] = new Ti(
        s,
        tr,
        !1,
        // mustUseProperty
        s.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var uc = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, ms = !1;
    function Xs(s) {
      !ms && uc.test(s) && (ms = !0, o("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(s)));
    }
    function _s(s, l, f, g) {
      if (g.mustUseProperty) {
        var C = g.propertyName;
        return s[C];
      } else {
        mi(f, l), g.sanitizeURL && Xs("" + f);
        var S = g.attributeName, T = null;
        if (g.type === Wr) {
          if (s.hasAttribute(S)) {
            var O = s.getAttribute(S);
            return O === "" ? !0 : Lr(l, f, g, !1) ? O : O === "" + f ? f : O;
          }
        } else if (s.hasAttribute(S)) {
          if (Lr(l, f, g, !1))
            return s.getAttribute(S);
          if (g.type === hr)
            return f;
          T = s.getAttribute(S);
        }
        return Lr(l, f, g, !1) ? T === null ? f : T : T === "" + f ? f : T;
      }
    }
    function Qs(s, l, f, g) {
      {
        if (!Ui(l))
          return;
        if (!s.hasAttribute(l))
          return f === void 0 ? void 0 : null;
        var C = s.getAttribute(l);
        return mi(f, l), C === "" + f ? f : C;
      }
    }
    function Ua(s, l, f, g) {
      var C = ur(l);
      if (!Br(l, C, g)) {
        if (Lr(l, f, C, g) && (f = null), g || C === null) {
          if (Ui(l)) {
            var S = l;
            f === null ? s.removeAttribute(S) : (mi(f, l), s.setAttribute(S, "" + f));
          }
          return;
        }
        var T = C.mustUseProperty;
        if (T) {
          var O = C.propertyName;
          if (f === null) {
            var M = C.type;
            s[O] = M === hr ? !1 : "";
          } else
            s[O] = f;
          return;
        }
        var V = C.attributeName, H = C.attributeNamespace;
        if (f === null)
          s.removeAttribute(V);
        else {
          var J = C.type, Q;
          J === hr || J === Wr && f === !0 ? Q = "" : (mi(f, V), Q = "" + f, C.sanitizeURL && Xs(Q.toString())), H ? s.setAttributeNS(H, V, Q) : s.setAttribute(V, Q);
        }
      }
    }
    var Ko = Symbol.for("react.element"), Wn = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), jo = Symbol.for("react.strict_mode"), G = Symbol.for("react.profiler"), ke = Symbol.for("react.provider"), U = Symbol.for("react.context"), ye = Symbol.for("react.forward_ref"), Fe = Symbol.for("react.suspense"), Ue = Symbol.for("react.suspense_list"), Ze = Symbol.for("react.memo"), Xe = Symbol.for("react.lazy"), Nt = Symbol.for("react.scope"), kt = Symbol.for("react.debug_trace_mode"), ci = Symbol.for("react.offscreen"), pr = Symbol.for("react.legacy_hidden"), xa = Symbol.for("react.cache"), Cs = Symbol.for("react.tracing_marker"), hi = Symbol.iterator, HI = "@@iterator";
    function Zs(s) {
      if (s === null || typeof s != "object")
        return null;
      var l = hi && s[hi] || s[HI];
      return typeof l == "function" ? l : null;
    }
    var fi = Object.assign, Nl = 0, OS, jm, zh, Yo, RS, po, LS;
    function MS() {
    }
    MS.__reactDisabledLog = !0;
    function $I() {
      {
        if (Nl === 0) {
          OS = console.log, jm = console.info, zh = console.warn, Yo = console.error, RS = console.group, po = console.groupCollapsed, LS = console.groupEnd;
          var s = {
            configurable: !0,
            enumerable: !0,
            value: MS,
            writable: !0
          };
          Object.defineProperties(console, {
            info: s,
            log: s,
            warn: s,
            error: s,
            group: s,
            groupCollapsed: s,
            groupEnd: s
          });
        }
        Nl++;
      }
    }
    function Jp() {
      {
        if (Nl--, Nl === 0) {
          var s = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: fi({}, s, {
              value: OS
            }),
            info: fi({}, s, {
              value: jm
            }),
            warn: fi({}, s, {
              value: zh
            }),
            error: fi({}, s, {
              value: Yo
            }),
            group: fi({}, s, {
              value: RS
            }),
            groupCollapsed: fi({}, s, {
              value: po
            }),
            groupEnd: fi({}, s, {
              value: LS
            })
          });
        }
        Nl < 0 && o("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var dc = i.ReactCurrentDispatcher, zu;
    function qo(s, l, f) {
      {
        if (zu === void 0)
          try {
            throw Error();
          } catch (C) {
            var g = C.stack.trim().match(/\n( *(at )?)/);
            zu = g && g[1] || "";
          }
        return `
` + zu + s;
      }
    }
    var Ym = !1, ev;
    {
      var qm = typeof WeakMap == "function" ? WeakMap : Map;
      ev = new qm();
    }
    function tv(s, l) {
      if (!s || Ym)
        return "";
      {
        var f = ev.get(s);
        if (f !== void 0)
          return f;
      }
      var g;
      Ym = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var S;
      S = dc.current, dc.current = null, $I();
      try {
        if (l) {
          var T = function() {
            throw Error();
          };
          if (Object.defineProperty(T.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(T, []);
            } catch (ce) {
              g = ce;
            }
            Reflect.construct(s, [], T);
          } else {
            try {
              T.call();
            } catch (ce) {
              g = ce;
            }
            s.call(T.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ce) {
            g = ce;
          }
          s();
        }
      } catch (ce) {
        if (ce && g && typeof ce.stack == "string") {
          for (var O = ce.stack.split(`
`), M = g.stack.split(`
`), V = O.length - 1, H = M.length - 1; V >= 1 && H >= 0 && O[V] !== M[H]; )
            H--;
          for (; V >= 1 && H >= 0; V--, H--)
            if (O[V] !== M[H]) {
              if (V !== 1 || H !== 1)
                do
                  if (V--, H--, H < 0 || O[V] !== M[H]) {
                    var J = `
` + O[V].replace(" at new ", " at ");
                    return s.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", s.displayName)), typeof s == "function" && ev.set(s, J), J;
                  }
                while (V >= 1 && H >= 0);
              break;
            }
        }
      } finally {
        Ym = !1, dc.current = S, Jp(), Error.prepareStackTrace = C;
      }
      var Q = s ? s.displayName || s.name : "", fe = Q ? qo(Q) : "";
      return typeof s == "function" && ev.set(s, fe), fe;
    }
    function Xm(s, l, f) {
      return tv(s, !0);
    }
    function Wu(s, l, f) {
      return tv(s, !1);
    }
    function zI(s) {
      var l = s.prototype;
      return !!(l && l.isReactComponent);
    }
    function Wh(s, l, f) {
      if (s == null)
        return "";
      if (typeof s == "function")
        return tv(s, zI(s));
      if (typeof s == "string")
        return qo(s);
      switch (s) {
        case Fe:
          return qo("Suspense");
        case Ue:
          return qo("SuspenseList");
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case ye:
            return Wu(s.render);
          case Ze:
            return Wh(s.type, l, f);
          case Xe: {
            var g = s, C = g._payload, S = g._init;
            try {
              return Wh(S(C), l, f);
            } catch {
            }
          }
        }
      return "";
    }
    function Gi(s) {
      var l = s._debugOwner ? s._debugOwner.type : null, f = s._debugSource;
      switch (s.tag) {
        case b:
          return qo(s.type);
        case _e:
          return qo("Lazy");
        case z:
          return qo("Suspense");
        case Ce:
          return qo("SuspenseList");
        case c:
        case v:
        case pe:
          return Wu(s.type);
        case K:
          return Wu(s.type.render);
        case p:
          return Xm(s.type);
        default:
          return "";
      }
    }
    function Qm(s) {
      try {
        var l = "", f = s;
        do
          l += Gi(f), f = f.return;
        while (f);
        return l;
      } catch (g) {
        return `
Error generating stack: ` + g.message + `
` + g.stack;
      }
    }
    function kS(s, l, f) {
      var g = s.displayName;
      if (g)
        return g;
      var C = l.displayName || l.name || "";
      return C !== "" ? f + "(" + C + ")" : f;
    }
    function iv(s) {
      return s.displayName || "Context";
    }
    function ir(s) {
      if (s == null)
        return null;
      if (typeof s.tag == "number" && o("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof s == "function")
        return s.displayName || s.name || null;
      if (typeof s == "string")
        return s;
      switch (s) {
        case ya:
          return "Fragment";
        case Wn:
          return "Portal";
        case G:
          return "Profiler";
        case jo:
          return "StrictMode";
        case Fe:
          return "Suspense";
        case Ue:
          return "SuspenseList";
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case U:
            var l = s;
            return iv(l) + ".Consumer";
          case ke:
            var f = s;
            return iv(f._context) + ".Provider";
          case ye:
            return kS(s, s.render, "ForwardRef");
          case Ze:
            var g = s.displayName || null;
            return g !== null ? g : ir(s.type) || "Memo";
          case Xe: {
            var C = s, S = C._payload, T = C._init;
            try {
              return ir(T(S));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function PS(s, l, f) {
      var g = l.displayName || l.name || "";
      return s.displayName || (g !== "" ? f + "(" + g + ")" : f);
    }
    function Zm(s) {
      return s.displayName || "Context";
    }
    function Jt(s) {
      var l = s.tag, f = s.type;
      switch (l) {
        case Re:
          return "Cache";
        case B:
          var g = f;
          return Zm(g) + ".Consumer";
        case $:
          var C = f;
          return Zm(C._context) + ".Provider";
        case De:
          return "DehydratedFragment";
        case K:
          return PS(f, f.render, "ForwardRef");
        case A:
          return "Fragment";
        case b:
          return f;
        case y:
          return "Portal";
        case _:
          return "Root";
        case I:
          return "Text";
        case _e:
          return ir(f);
        case L:
          return f === jo ? "StrictMode" : "Mode";
        case Ve:
          return "Offscreen";
        case te:
          return "Profiler";
        case ft:
          return "Scope";
        case z:
          return "Suspense";
        case Ce:
          return "SuspenseList";
        case we:
          return "TracingMarker";
        case p:
        case c:
        case be:
        case v:
        case ie:
        case pe:
          if (typeof f == "function")
            return f.displayName || f.name || null;
          if (typeof f == "string")
            return f;
          break;
      }
      return null;
    }
    var Uh = i.ReactDebugCurrentFrame, Ur = null, vo = !1;
    function go() {
      {
        if (Ur === null)
          return null;
        var s = Ur._debugOwner;
        if (s !== null && typeof s < "u")
          return Jt(s);
      }
      return null;
    }
    function Gh() {
      return Ur === null ? "" : Qm(Ur);
    }
    function en() {
      Uh.getCurrentStack = null, Ur = null, vo = !1;
    }
    function Xi(s) {
      Uh.getCurrentStack = s === null ? null : Gh, Ur = s, vo = !1;
    }
    function WI() {
      return Ur;
    }
    function Xo(s) {
      vo = s;
    }
    function Un(s) {
      return "" + s;
    }
    function Hl(s) {
      switch (typeof s) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return s;
        case "object":
          return zn(s), s;
        default:
          return "";
      }
    }
    var FS = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function cc(s, l) {
      FS[l.type] || l.onChange || l.onInput || l.readOnly || l.disabled || l.value == null || o("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), l.onChange || l.readOnly || l.disabled || l.checked == null || o("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Jm(s) {
      var l = s.type, f = s.nodeName;
      return f && f.toLowerCase() === "input" && (l === "checkbox" || l === "radio");
    }
    function BS(s) {
      return s._valueTracker;
    }
    function Kh(s) {
      s._valueTracker = null;
    }
    function jh(s) {
      var l = "";
      return s && (Jm(s) ? l = s.checked ? "true" : "false" : l = s.value), l;
    }
    function hc(s) {
      var l = Jm(s) ? "checked" : "value", f = Object.getOwnPropertyDescriptor(s.constructor.prototype, l);
      zn(s[l]);
      var g = "" + s[l];
      if (!(s.hasOwnProperty(l) || typeof f > "u" || typeof f.get != "function" || typeof f.set != "function")) {
        var C = f.get, S = f.set;
        Object.defineProperty(s, l, {
          configurable: !0,
          get: function() {
            return C.call(this);
          },
          set: function(O) {
            zn(O), g = "" + O, S.call(this, O);
          }
        }), Object.defineProperty(s, l, {
          enumerable: f.enumerable
        });
        var T = {
          getValue: function() {
            return g;
          },
          setValue: function(O) {
            zn(O), g = "" + O;
          },
          stopTracking: function() {
            Kh(s), delete s[l];
          }
        };
        return T;
      }
    }
    function Uu(s) {
      BS(s) || (s._valueTracker = hc(s));
    }
    function VS(s) {
      if (!s)
        return !1;
      var l = BS(s);
      if (!l)
        return !0;
      var f = l.getValue(), g = jh(s);
      return g !== f ? (l.setValue(g), !0) : !1;
    }
    function rv(s) {
      if (s = s || (typeof document < "u" ? document : void 0), typeof s > "u")
        return null;
      try {
        return s.activeElement || s.body;
      } catch {
        return s.body;
      }
    }
    var nv = !1, Yh = !1, av = !1, e_ = !1;
    function Js(s) {
      var l = s.type === "checkbox" || s.type === "radio";
      return l ? s.checked != null : s.value != null;
    }
    function qh(s, l) {
      var f = s, g = l.checked, C = fi({}, l, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: g ?? f._wrapperState.initialChecked
      });
      return C;
    }
    function Xh(s, l) {
      cc("input", l), l.checked !== void 0 && l.defaultChecked !== void 0 && !Yh && (o("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", go() || "A component", l.type), Yh = !0), l.value !== void 0 && l.defaultValue !== void 0 && !nv && (o("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", go() || "A component", l.type), nv = !0);
      var f = s, g = l.defaultValue == null ? "" : l.defaultValue;
      f._wrapperState = {
        initialChecked: l.checked != null ? l.checked : l.defaultChecked,
        initialValue: Hl(l.value != null ? l.value : g),
        controlled: Js(l)
      };
    }
    function t_(s, l) {
      var f = s, g = l.checked;
      g != null && Ua(f, "checked", g, !1);
    }
    function fc(s, l) {
      var f = s;
      {
        var g = Js(l);
        !f._wrapperState.controlled && g && !e_ && (o("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), e_ = !0), f._wrapperState.controlled && !g && !av && (o("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), av = !0);
      }
      t_(s, l);
      var C = Hl(l.value), S = l.type;
      if (C != null)
        S === "number" ? (C === 0 && f.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        f.value != C) && (f.value = Un(C)) : f.value !== Un(C) && (f.value = Un(C));
      else if (S === "submit" || S === "reset") {
        f.removeAttribute("value");
        return;
      }
      l.hasOwnProperty("value") ? $l(f, l.type, C) : l.hasOwnProperty("defaultValue") && $l(f, l.type, Hl(l.defaultValue)), l.checked == null && l.defaultChecked != null && (f.defaultChecked = !!l.defaultChecked);
    }
    function Qh(s, l, f) {
      var g = s;
      if (l.hasOwnProperty("value") || l.hasOwnProperty("defaultValue")) {
        var C = l.type, S = C === "submit" || C === "reset";
        if (S && (l.value === void 0 || l.value === null))
          return;
        var T = Un(g._wrapperState.initialValue);
        f || T !== g.value && (g.value = T), g.defaultValue = T;
      }
      var O = g.name;
      O !== "" && (g.name = ""), g.defaultChecked = !g.defaultChecked, g.defaultChecked = !!g._wrapperState.initialChecked, O !== "" && (g.name = O);
    }
    function NS(s, l) {
      var f = s;
      fc(f, l), Ga(f, l);
    }
    function Ga(s, l) {
      var f = l.name;
      if (l.type === "radio" && f != null) {
        for (var g = s; g.parentNode; )
          g = g.parentNode;
        mi(f, "name");
        for (var C = g.querySelectorAll("input[name=" + JSON.stringify("" + f) + '][type="radio"]'), S = 0; S < C.length; S++) {
          var T = C[S];
          if (!(T === s || T.form !== s.form)) {
            var O = vE(T);
            if (!O)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            VS(T), fc(T, O);
          }
        }
      }
    }
    function $l(s, l, f) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (l !== "number" || rv(s.ownerDocument) !== s) && (f == null ? s.defaultValue = Un(s._wrapperState.initialValue) : s.defaultValue !== Un(f) && (s.defaultValue = Un(f)));
    }
    var ov = !1, pc = !1, HS = !1;
    function sv(s, l) {
      l.value == null && (typeof l.children == "object" && l.children !== null ? t.Children.forEach(l.children, function(f) {
        f != null && (typeof f == "string" || typeof f == "number" || pc || (pc = !0, o("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : l.dangerouslySetInnerHTML != null && (HS || (HS = !0, o("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), l.selected != null && !ov && (o("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), ov = !0);
    }
    function i_(s, l) {
      l.value != null && s.setAttribute("value", Un(Hl(l.value)));
    }
    var Zh = Array.isArray;
    function hn(s) {
      return Zh(s);
    }
    var lv;
    lv = !1;
    function $S() {
      var s = go();
      return s ? `

Check the render method of \`` + s + "`." : "";
    }
    var zS = ["value", "defaultValue"];
    function UI(s) {
      {
        cc("select", s);
        for (var l = 0; l < zS.length; l++) {
          var f = zS[l];
          if (s[f] != null) {
            var g = hn(s[f]);
            s.multiple && !g ? o("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", f, $S()) : !s.multiple && g && o("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", f, $S());
          }
        }
      }
    }
    function zl(s, l, f, g) {
      var C = s.options;
      if (l) {
        for (var S = f, T = {}, O = 0; O < S.length; O++)
          T["$" + S[O]] = !0;
        for (var M = 0; M < C.length; M++) {
          var V = T.hasOwnProperty("$" + C[M].value);
          C[M].selected !== V && (C[M].selected = V), V && g && (C[M].defaultSelected = !0);
        }
      } else {
        for (var H = Un(Hl(f)), J = null, Q = 0; Q < C.length; Q++) {
          if (C[Q].value === H) {
            C[Q].selected = !0, g && (C[Q].defaultSelected = !0);
            return;
          }
          J === null && !C[Q].disabled && (J = C[Q]);
        }
        J !== null && (J.selected = !0);
      }
    }
    function r_(s, l) {
      return fi({}, l, {
        value: void 0
      });
    }
    function WS(s, l) {
      var f = s;
      UI(l), f._wrapperState = {
        wasMultiple: !!l.multiple
      }, l.value !== void 0 && l.defaultValue !== void 0 && !lv && (o("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), lv = !0);
    }
    function GI(s, l) {
      var f = s;
      f.multiple = !!l.multiple;
      var g = l.value;
      g != null ? zl(f, !!l.multiple, g, !1) : l.defaultValue != null && zl(f, !!l.multiple, l.defaultValue, !0);
    }
    function KI(s, l) {
      var f = s, g = f._wrapperState.wasMultiple;
      f._wrapperState.wasMultiple = !!l.multiple;
      var C = l.value;
      C != null ? zl(f, !!l.multiple, C, !1) : g !== !!l.multiple && (l.defaultValue != null ? zl(f, !!l.multiple, l.defaultValue, !0) : zl(f, !!l.multiple, l.multiple ? [] : "", !1));
    }
    function jI(s, l) {
      var f = s, g = l.value;
      g != null && zl(f, !!l.multiple, g, !1);
    }
    var n_ = !1;
    function a_(s, l) {
      var f = s;
      if (l.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var g = fi({}, l, {
        value: void 0,
        defaultValue: void 0,
        children: Un(f._wrapperState.initialValue)
      });
      return g;
    }
    function US(s, l) {
      var f = s;
      cc("textarea", l), l.value !== void 0 && l.defaultValue !== void 0 && !n_ && (o("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", go() || "A component"), n_ = !0);
      var g = l.value;
      if (g == null) {
        var C = l.children, S = l.defaultValue;
        if (C != null) {
          o("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (S != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (hn(C)) {
              if (C.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              C = C[0];
            }
            S = C;
          }
        }
        S == null && (S = ""), g = S;
      }
      f._wrapperState = {
        initialValue: Hl(g)
      };
    }
    function GS(s, l) {
      var f = s, g = Hl(l.value), C = Hl(l.defaultValue);
      if (g != null) {
        var S = Un(g);
        S !== f.value && (f.value = S), l.defaultValue == null && f.defaultValue !== S && (f.defaultValue = S);
      }
      C != null && (f.defaultValue = Un(C));
    }
    function KS(s, l) {
      var f = s, g = f.textContent;
      g === f._wrapperState.initialValue && g !== "" && g !== null && (f.value = g);
    }
    function o_(s, l) {
      GS(s, l);
    }
    var el = "http://www.w3.org/1999/xhtml", YI = "http://www.w3.org/1998/Math/MathML", s_ = "http://www.w3.org/2000/svg";
    function uv(s) {
      switch (s) {
        case "svg":
          return s_;
        case "math":
          return YI;
        default:
          return el;
      }
    }
    function l_(s, l) {
      return s == null || s === el ? uv(l) : s === s_ && l === "foreignObject" ? el : s;
    }
    var qI = function(s) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(l, f, g, C) {
        MSApp.execUnsafeLocalFunction(function() {
          return s(l, f, g, C);
        });
      } : s;
    }, dv, jS = qI(function(s, l) {
      if (s.namespaceURI === s_ && !("innerHTML" in s)) {
        dv = dv || document.createElement("div"), dv.innerHTML = "<svg>" + l.valueOf().toString() + "</svg>";
        for (var f = dv.firstChild; s.firstChild; )
          s.removeChild(s.firstChild);
        for (; f.firstChild; )
          s.appendChild(f.firstChild);
        return;
      }
      s.innerHTML = l;
    }), Sa = 1, tl = 3, Gr = 8, Qo = 9, Gu = 11, cv = function(s, l) {
      if (l) {
        var f = s.firstChild;
        if (f && f === s.lastChild && f.nodeType === tl) {
          f.nodeValue = l;
          return;
        }
      }
      s.textContent = l;
    }, YS = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, vc = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function qS(s, l) {
      return s + l.charAt(0).toUpperCase() + l.substring(1);
    }
    var XS = ["Webkit", "ms", "Moz", "O"];
    Object.keys(vc).forEach(function(s) {
      XS.forEach(function(l) {
        vc[qS(l, s)] = vc[s];
      });
    });
    function hv(s, l, f) {
      var g = l == null || typeof l == "boolean" || l === "";
      return g ? "" : !f && typeof l == "number" && l !== 0 && !(vc.hasOwnProperty(s) && vc[s]) ? l + "px" : (ia(l, s), ("" + l).trim());
    }
    var gc = /([A-Z])/g, XI = /^ms-/;
    function QI(s) {
      return s.replace(gc, "-$1").toLowerCase().replace(XI, "-ms-");
    }
    var QS = function() {
    };
    {
      var ZS = /^(?:webkit|moz|o)[A-Z]/, JS = /^-ms-/, Jh = /-(.)/g, mc = /;\s*$/, _c = {}, Cc = {}, e0 = !1, u_ = !1, d_ = function(s) {
        return s.replace(Jh, function(l, f) {
          return f.toUpperCase();
        });
      }, c_ = function(s) {
        _c.hasOwnProperty(s) && _c[s] || (_c[s] = !0, o(
          "Unsupported style property %s. Did you mean %s?",
          s,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          d_(s.replace(JS, "ms-"))
        ));
      }, t0 = function(s) {
        _c.hasOwnProperty(s) && _c[s] || (_c[s] = !0, o("Unsupported vendor-prefixed style property %s. Did you mean %s?", s, s.charAt(0).toUpperCase() + s.slice(1)));
      }, i0 = function(s, l) {
        Cc.hasOwnProperty(l) && Cc[l] || (Cc[l] = !0, o(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, s, l.replace(mc, "")));
      }, r0 = function(s, l) {
        e0 || (e0 = !0, o("`NaN` is an invalid value for the `%s` css style property.", s));
      }, ZI = function(s, l) {
        u_ || (u_ = !0, o("`Infinity` is an invalid value for the `%s` css style property.", s));
      };
      QS = function(s, l) {
        s.indexOf("-") > -1 ? c_(s) : ZS.test(s) ? t0(s) : mc.test(l) && i0(s, l), typeof l == "number" && (isNaN(l) ? r0(s, l) : isFinite(l) || ZI(s, l));
      };
    }
    var JI = QS;
    function eD(s) {
      {
        var l = "", f = "";
        for (var g in s)
          if (s.hasOwnProperty(g)) {
            var C = s[g];
            if (C != null) {
              var S = g.indexOf("--") === 0;
              l += f + (S ? g : QI(g)) + ":", l += hv(g, C, S), f = ";";
            }
          }
        return l || null;
      }
    }
    function n0(s, l) {
      var f = s.style;
      for (var g in l)
        if (l.hasOwnProperty(g)) {
          var C = g.indexOf("--") === 0;
          C || JI(g, l[g]);
          var S = hv(g, l[g], C);
          g === "float" && (g = "cssFloat"), C ? f.setProperty(g, S) : f[g] = S;
        }
    }
    function tD(s) {
      return s == null || typeof s == "boolean" || s === "";
    }
    function mo(s) {
      var l = {};
      for (var f in s)
        for (var g = YS[f] || [f], C = 0; C < g.length; C++)
          l[g[C]] = f;
      return l;
    }
    function ef(s, l) {
      {
        if (!l)
          return;
        var f = mo(s), g = mo(l), C = {};
        for (var S in f) {
          var T = f[S], O = g[S];
          if (O && T !== O) {
            var M = T + "," + O;
            if (C[M])
              continue;
            C[M] = !0, o("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", tD(s[T]) ? "Removing" : "Updating", T, O);
          }
        }
      }
    }
    var a0 = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, o0 = fi({
      menuitem: !0
    }, a0), s0 = "__html";
    function fv(s, l) {
      if (l) {
        if (o0[s] && (l.children != null || l.dangerouslySetInnerHTML != null))
          throw new Error(s + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (l.dangerouslySetInnerHTML != null) {
          if (l.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof l.dangerouslySetInnerHTML != "object" || !(s0 in l.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!l.suppressContentEditableWarning && l.contentEditable && l.children != null && o("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), l.style != null && typeof l.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function il(s, l) {
      if (s.indexOf("-") === -1)
        return typeof l.is == "string";
      switch (s) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var pv = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, l0 = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Zo = {}, h_ = new RegExp("^(aria)-[" + nt + "]*$"), tf = new RegExp("^(aria)[A-Z][" + nt + "]*$");
    function f_(s, l) {
      {
        if (si.call(Zo, l) && Zo[l])
          return !0;
        if (tf.test(l)) {
          var f = "aria-" + l.slice(4).toLowerCase(), g = l0.hasOwnProperty(f) ? f : null;
          if (g == null)
            return o("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", l), Zo[l] = !0, !0;
          if (l !== g)
            return o("Invalid ARIA attribute `%s`. Did you mean `%s`?", l, g), Zo[l] = !0, !0;
        }
        if (h_.test(l)) {
          var C = l.toLowerCase(), S = l0.hasOwnProperty(C) ? C : null;
          if (S == null)
            return Zo[l] = !0, !1;
          if (l !== S)
            return o("Unknown ARIA attribute `%s`. Did you mean `%s`?", l, S), Zo[l] = !0, !0;
        }
      }
      return !0;
    }
    function u0(s, l) {
      {
        var f = [];
        for (var g in l) {
          var C = f_(s, g);
          C || f.push(g);
        }
        var S = f.map(function(T) {
          return "`" + T + "`";
        }).join(", ");
        f.length === 1 ? o("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", S, s) : f.length > 1 && o("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", S, s);
      }
    }
    function vv(s, l) {
      il(s, l) || u0(s, l);
    }
    var Ku = !1;
    function p_(s, l) {
      {
        if (s !== "input" && s !== "textarea" && s !== "select")
          return;
        l != null && l.value === null && !Ku && (Ku = !0, s === "select" && l.multiple ? o("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", s) : o("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", s));
      }
    }
    var v_ = function() {
    };
    {
      var fn = {}, g_ = /^on./, d0 = /^on[^A-Z]/, c0 = new RegExp("^(aria)-[" + nt + "]*$"), h0 = new RegExp("^(aria)[A-Z][" + nt + "]*$");
      v_ = function(s, l, f, g) {
        if (si.call(fn, l) && fn[l])
          return !0;
        var C = l.toLowerCase();
        if (C === "onfocusin" || C === "onfocusout")
          return o("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), fn[l] = !0, !0;
        if (g != null) {
          var S = g.registrationNameDependencies, T = g.possibleRegistrationNames;
          if (S.hasOwnProperty(l))
            return !0;
          var O = T.hasOwnProperty(C) ? T[C] : null;
          if (O != null)
            return o("Invalid event handler property `%s`. Did you mean `%s`?", l, O), fn[l] = !0, !0;
          if (g_.test(l))
            return o("Unknown event handler property `%s`. It will be ignored.", l), fn[l] = !0, !0;
        } else if (g_.test(l))
          return d0.test(l) && o("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", l), fn[l] = !0, !0;
        if (c0.test(l) || h0.test(l))
          return !0;
        if (C === "innerhtml")
          return o("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), fn[l] = !0, !0;
        if (C === "aria")
          return o("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), fn[l] = !0, !0;
        if (C === "is" && f !== null && f !== void 0 && typeof f != "string")
          return o("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof f), fn[l] = !0, !0;
        if (typeof f == "number" && isNaN(f))
          return o("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", l), fn[l] = !0, !0;
        var M = ur(l), V = M !== null && M.type === Yi;
        if (pv.hasOwnProperty(C)) {
          var H = pv[C];
          if (H !== l)
            return o("Invalid DOM property `%s`. Did you mean `%s`?", l, H), fn[l] = !0, !0;
        } else if (!V && l !== C)
          return o("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", l, C), fn[l] = !0, !0;
        return typeof f == "boolean" && fr(l, f, M, !1) ? (f ? o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', f, l, l, f, l) : o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', f, l, l, f, l, l, l), fn[l] = !0, !0) : V ? !0 : fr(l, f, M, !1) ? (fn[l] = !0, !1) : ((f === "false" || f === "true") && M !== null && M.type === hr && (o("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", f, l, f === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', l, f), fn[l] = !0), !0);
      };
    }
    var f0 = function(s, l, f) {
      {
        var g = [];
        for (var C in l) {
          var S = v_(s, C, l[C], f);
          S || g.push(C);
        }
        var T = g.map(function(O) {
          return "`" + O + "`";
        }).join(", ");
        g.length === 1 ? o("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", T, s) : g.length > 1 && o("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", T, s);
      }
    };
    function p0(s, l, f) {
      il(s, l) || f0(s, l, f);
    }
    var rl = 1, rf = 2, ju = 4, iD = rl | rf | ju, nf = null;
    function af(s) {
      nf !== null && o("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), nf = s;
    }
    function rD() {
      nf === null && o("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), nf = null;
    }
    function v0(s) {
      return s === nf;
    }
    function gv(s) {
      var l = s.target || s.srcElement || window;
      return l.correspondingUseElement && (l = l.correspondingUseElement), l.nodeType === tl ? l.parentNode : l;
    }
    var rr = null, Wl = null, nl = null;
    function yc(s) {
      var l = Kc(s);
      if (l) {
        if (typeof rr != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var f = l.stateNode;
        if (f) {
          var g = vE(f);
          rr(l.stateNode, l.type, g);
        }
      }
    }
    function g0(s) {
      rr = s;
    }
    function mv(s) {
      Wl ? nl ? nl.push(s) : nl = [s] : Wl = s;
    }
    function of() {
      return Wl !== null || nl !== null;
    }
    function sf() {
      if (Wl) {
        var s = Wl, l = nl;
        if (Wl = null, nl = null, yc(s), l)
          for (var f = 0; f < l.length; f++)
            yc(l[f]);
      }
    }
    var Yu = function(s, l) {
      return s(l);
    }, m_ = function() {
    }, __ = !1;
    function nD() {
      var s = of();
      s && (m_(), sf());
    }
    function C_(s, l, f) {
      if (__)
        return s(l, f);
      __ = !0;
      try {
        return Yu(s, l, f);
      } finally {
        __ = !1, nD();
      }
    }
    function _v(s, l, f) {
      Yu = s, m_ = f;
    }
    function Cv(s) {
      return s === "button" || s === "input" || s === "select" || s === "textarea";
    }
    function y_(s, l, f) {
      switch (s) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(f.disabled && Cv(l));
        default:
          return !1;
      }
    }
    function qu(s, l) {
      var f = s.stateNode;
      if (f === null)
        return null;
      var g = vE(f);
      if (g === null)
        return null;
      var C = g[l];
      if (y_(l, s.type, g))
        return null;
      if (C && typeof C != "function")
        throw new Error("Expected `" + l + "` listener to be a function, instead got a value of `" + typeof C + "` type.");
      return C;
    }
    var lf = !1;
    if (gt)
      try {
        var Xu = {};
        Object.defineProperty(Xu, "passive", {
          get: function() {
            lf = !0;
          }
        }), window.addEventListener("test", Xu, Xu), window.removeEventListener("test", Xu, Xu);
      } catch {
        lf = !1;
      }
    function m0(s, l, f, g, C, S, T, O, M) {
      var V = Array.prototype.slice.call(arguments, 3);
      try {
        l.apply(f, V);
      } catch (H) {
        this.onError(H);
      }
    }
    var x_ = m0;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var S_ = document.createElement("react");
      x_ = function(l, f, g, C, S, T, O, M, V) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var H = document.createEvent("Event"), J = !1, Q = !0, fe = window.event, ce = Object.getOwnPropertyDescriptor(window, "event");
        function me() {
          S_.removeEventListener(Se, Mt, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = fe);
        }
        var lt = Array.prototype.slice.call(arguments, 3);
        function Mt() {
          J = !0, me(), f.apply(g, lt), Q = !1;
        }
        var Tt, vi = !1, gi = !1;
        function se(le) {
          if (Tt = le.error, vi = !0, Tt === null && le.colno === 0 && le.lineno === 0 && (gi = !0), le.defaultPrevented && Tt != null && typeof Tt == "object")
            try {
              Tt._suppressLogging = !0;
            } catch {
            }
        }
        var Se = "react-" + (l || "invokeguardedcallback");
        if (window.addEventListener("error", se), S_.addEventListener(Se, Mt, !1), H.initEvent(Se, !1, !1), S_.dispatchEvent(H), ce && Object.defineProperty(window, "event", ce), J && Q && (vi ? gi && (Tt = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Tt = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Tt)), window.removeEventListener("error", se), !J)
          return me(), m0.apply(this, arguments);
      };
    }
    var aD = x_, Ul = !1, Jo = null, uf = !1, Gl = null, ys = {
      onError: function(s) {
        Ul = !0, Jo = s;
      }
    };
    function Qu(s, l, f, g, C, S, T, O, M) {
      Ul = !1, Jo = null, aD.apply(ys, arguments);
    }
    function al(s, l, f, g, C, S, T, O, M) {
      if (Qu.apply(this, arguments), Ul) {
        var V = b_();
        uf || (uf = !0, Gl = V);
      }
    }
    function E_() {
      if (uf) {
        var s = Gl;
        throw uf = !1, Gl = null, s;
      }
    }
    function oD() {
      return Ul;
    }
    function b_() {
      if (Ul) {
        var s = Jo;
        return Ul = !1, Jo = null, s;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function _o(s) {
      return s._reactInternals;
    }
    function df(s) {
      return s._reactInternals !== void 0;
    }
    function xc(s, l) {
      s._reactInternals = l;
    }
    var Lt = (
      /*                      */
      0
    ), Kl = (
      /*                */
      1
    ), vr = (
      /*                    */
      2
    ), ri = (
      /*                       */
      4
    ), Fi = (
      /*                */
      16
    ), Vi = (
      /*                 */
      32
    ), xs = (
      /*                     */
      64
    ), Gt = (
      /*                   */
      128
    ), Mr = (
      /*            */
      256
    ), Ea = (
      /*                          */
      512
    ), Co = (
      /*                     */
      1024
    ), xr = (
      /*                      */
      2048
    ), yo = (
      /*                    */
      4096
    ), jl = (
      /*                   */
      8192
    ), cf = (
      /*             */
      16384
    ), yv = xr | ri | xs | Ea | Co | cf, _0 = (
      /*               */
      32767
    ), Ka = (
      /*                   */
      32768
    ), pn = (
      /*                */
      65536
    ), hf = (
      /* */
      131072
    ), w_ = (
      /*                       */
      1048576
    ), T_ = (
      /*                    */
      2097152
    ), ba = (
      /*                 */
      4194304
    ), Yl = (
      /*                */
      8388608
    ), wa = (
      /*               */
      16777216
    ), Zu = (
      /*              */
      33554432
    ), Sc = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      ri | Co | 0
    ), Ta = vr | ri | Fi | Vi | Ea | yo | jl, Gn = ri | xs | Ea | jl, xo = xr | Fi, En = ba | Yl | T_, ol = i.ReactCurrentOwner;
    function ja(s) {
      var l = s, f = s;
      if (s.alternate)
        for (; l.return; )
          l = l.return;
      else {
        var g = l;
        do
          l = g, (l.flags & (vr | yo)) !== Lt && (f = l.return), g = l.return;
        while (g);
      }
      return l.tag === _ ? f : null;
    }
    function I_(s) {
      if (s.tag === z) {
        var l = s.memoizedState;
        if (l === null) {
          var f = s.alternate;
          f !== null && (l = f.memoizedState);
        }
        if (l !== null)
          return l.dehydrated;
      }
      return null;
    }
    function xv(s) {
      return s.tag === _ ? s.stateNode.containerInfo : null;
    }
    function D_(s) {
      return ja(s) === s;
    }
    function Ya(s) {
      {
        var l = ol.current;
        if (l !== null && l.tag === p) {
          var f = l, g = f.stateNode;
          g._warnedAboutRefsInRender || o("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Jt(f) || "A component"), g._warnedAboutRefsInRender = !0;
        }
      }
      var C = _o(s);
      return C ? ja(C) === C : !1;
    }
    function Ia(s) {
      if (ja(s) !== s)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function gr(s) {
      var l = s.alternate;
      if (!l) {
        var f = ja(s);
        if (f === null)
          throw new Error("Unable to find node on an unmounted component.");
        return f !== s ? null : s;
      }
      for (var g = s, C = l; ; ) {
        var S = g.return;
        if (S === null)
          break;
        var T = S.alternate;
        if (T === null) {
          var O = S.return;
          if (O !== null) {
            g = C = O;
            continue;
          }
          break;
        }
        if (S.child === T.child) {
          for (var M = S.child; M; ) {
            if (M === g)
              return Ia(S), s;
            if (M === C)
              return Ia(S), l;
            M = M.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (g.return !== C.return)
          g = S, C = T;
        else {
          for (var V = !1, H = S.child; H; ) {
            if (H === g) {
              V = !0, g = S, C = T;
              break;
            }
            if (H === C) {
              V = !0, C = S, g = T;
              break;
            }
            H = H.sibling;
          }
          if (!V) {
            for (H = T.child; H; ) {
              if (H === g) {
                V = !0, g = T, C = S;
                break;
              }
              if (H === C) {
                V = !0, C = T, g = S;
                break;
              }
              H = H.sibling;
            }
            if (!V)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (g.alternate !== C)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (g.tag !== _)
        throw new Error("Unable to find node on an unmounted component.");
      return g.stateNode.current === g ? s : l;
    }
    function So(s) {
      var l = gr(s);
      return l !== null ? A_(l) : null;
    }
    function A_(s) {
      if (s.tag === b || s.tag === I)
        return s;
      for (var l = s.child; l !== null; ) {
        var f = A_(l);
        if (f !== null)
          return f;
        l = l.sibling;
      }
      return null;
    }
    function C0(s) {
      var l = gr(s);
      return l !== null ? Sv(l) : null;
    }
    function Sv(s) {
      if (s.tag === b || s.tag === I)
        return s;
      for (var l = s.child; l !== null; ) {
        if (l.tag !== y) {
          var f = Sv(l);
          if (f !== null)
            return f;
        }
        l = l.sibling;
      }
      return null;
    }
    var Ev = e.unstable_scheduleCallback, y0 = e.unstable_cancelCallback, bv = e.unstable_shouldYield, x0 = e.unstable_requestPaint, Tr = e.unstable_now, O_ = e.unstable_getCurrentPriorityLevel, wv = e.unstable_ImmediatePriority, qa = e.unstable_UserBlockingPriority, Ss = e.unstable_NormalPriority, Tv = e.unstable_LowPriority, ql = e.unstable_IdlePriority, R_ = e.unstable_yieldValue, L_ = e.unstable_setDisableYieldValue, sl = null, tn = null, it = null, Vr = !1, bn = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function M_(s) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var l = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (l.isDisabled)
        return !0;
      if (!l.supportsFiber)
        return o("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        vt && (s = fi({}, s, {
          getLaneLabelMap: Ql,
          injectProfilingHooks: ul
        })), sl = l.inject(s), tn = l;
      } catch (f) {
        o("React instrumentation encountered an error: %s.", f);
      }
      return !!l.checkDCE;
    }
    function S0(s, l) {
      if (tn && typeof tn.onScheduleFiberRoot == "function")
        try {
          tn.onScheduleFiberRoot(sl, s, l);
        } catch (f) {
          Vr || (Vr = !0, o("React instrumentation encountered an error: %s", f));
        }
    }
    function ll(s, l) {
      if (tn && typeof tn.onCommitFiberRoot == "function")
        try {
          var f = (s.current.flags & Gt) === Gt;
          if (Je) {
            var g;
            switch (l) {
              case Kn:
                g = wv;
                break;
              case wn:
                g = qa;
                break;
              case cl:
                g = Ss;
                break;
              case xf:
                g = ql;
                break;
              default:
                g = Ss;
                break;
            }
            tn.onCommitFiberRoot(sl, s, g, f);
          } else
            tn.onCommitFiberRoot(sl, s, void 0, f);
        } catch (C) {
          Vr || (Vr = !0, o("React instrumentation encountered an error: %s", C));
        }
    }
    function Xl(s) {
      if (tn && typeof tn.onPostCommitFiberRoot == "function")
        try {
          tn.onPostCommitFiberRoot(sl, s);
        } catch (l) {
          Vr || (Vr = !0, o("React instrumentation encountered an error: %s", l));
        }
    }
    function k_(s) {
      if (tn && typeof tn.onCommitFiberUnmount == "function")
        try {
          tn.onCommitFiberUnmount(sl, s);
        } catch (l) {
          Vr || (Vr = !0, o("React instrumentation encountered an error: %s", l));
        }
    }
    function rn(s) {
      if (typeof R_ == "function" && (L_(s), n(s)), tn && typeof tn.setStrictMode == "function")
        try {
          tn.setStrictMode(sl, s);
        } catch (l) {
          Vr || (Vr = !0, o("React instrumentation encountered an error: %s", l));
        }
    }
    function ul(s) {
      it = s;
    }
    function Ql() {
      {
        for (var s = /* @__PURE__ */ new Map(), l = 1, f = 0; f < mr; f++) {
          var g = sD(l);
          s.set(l, g), l *= 2;
        }
        return s;
      }
    }
    function Iv(s) {
      it !== null && typeof it.markCommitStarted == "function" && it.markCommitStarted(s);
    }
    function P_() {
      it !== null && typeof it.markCommitStopped == "function" && it.markCommitStopped();
    }
    function Zl(s) {
      it !== null && typeof it.markComponentRenderStarted == "function" && it.markComponentRenderStarted(s);
    }
    function Ju() {
      it !== null && typeof it.markComponentRenderStopped == "function" && it.markComponentRenderStopped();
    }
    function E0(s) {
      it !== null && typeof it.markComponentPassiveEffectMountStarted == "function" && it.markComponentPassiveEffectMountStarted(s);
    }
    function F_() {
      it !== null && typeof it.markComponentPassiveEffectMountStopped == "function" && it.markComponentPassiveEffectMountStopped();
    }
    function Dv(s) {
      it !== null && typeof it.markComponentPassiveEffectUnmountStarted == "function" && it.markComponentPassiveEffectUnmountStarted(s);
    }
    function b0() {
      it !== null && typeof it.markComponentPassiveEffectUnmountStopped == "function" && it.markComponentPassiveEffectUnmountStopped();
    }
    function w0(s) {
      it !== null && typeof it.markComponentLayoutEffectMountStarted == "function" && it.markComponentLayoutEffectMountStarted(s);
    }
    function T0() {
      it !== null && typeof it.markComponentLayoutEffectMountStopped == "function" && it.markComponentLayoutEffectMountStopped();
    }
    function Av(s) {
      it !== null && typeof it.markComponentLayoutEffectUnmountStarted == "function" && it.markComponentLayoutEffectUnmountStarted(s);
    }
    function Ec() {
      it !== null && typeof it.markComponentLayoutEffectUnmountStopped == "function" && it.markComponentLayoutEffectUnmountStopped();
    }
    function Ov(s, l, f) {
      it !== null && typeof it.markComponentErrored == "function" && it.markComponentErrored(s, l, f);
    }
    function I0(s, l, f) {
      it !== null && typeof it.markComponentSuspended == "function" && it.markComponentSuspended(s, l, f);
    }
    function D0(s) {
      it !== null && typeof it.markLayoutEffectsStarted == "function" && it.markLayoutEffectsStarted(s);
    }
    function bc() {
      it !== null && typeof it.markLayoutEffectsStopped == "function" && it.markLayoutEffectsStopped();
    }
    function A0(s) {
      it !== null && typeof it.markPassiveEffectsStarted == "function" && it.markPassiveEffectsStarted(s);
    }
    function ff() {
      it !== null && typeof it.markPassiveEffectsStopped == "function" && it.markPassiveEffectsStopped();
    }
    function es(s) {
      it !== null && typeof it.markRenderStarted == "function" && it.markRenderStarted(s);
    }
    function pf() {
      it !== null && typeof it.markRenderYielded == "function" && it.markRenderYielded();
    }
    function wc() {
      it !== null && typeof it.markRenderStopped == "function" && it.markRenderStopped();
    }
    function ed(s) {
      it !== null && typeof it.markRenderScheduled == "function" && it.markRenderScheduled(s);
    }
    function B_(s, l) {
      it !== null && typeof it.markForceUpdateScheduled == "function" && it.markForceUpdateScheduled(s, l);
    }
    function Jl(s, l) {
      it !== null && typeof it.markStateUpdateScheduled == "function" && it.markStateUpdateScheduled(s, l);
    }
    var Ft = (
      /*                         */
      0
    ), li = (
      /*                 */
      1
    ), Vt = (
      /*                    */
      2
    ), Ir = (
      /*               */
      8
    ), Eo = (
      /*              */
      16
    ), Rv = Math.clz32 ? Math.clz32 : td, Lv = Math.log, V_ = Math.LN2;
    function td(s) {
      var l = s >>> 0;
      return l === 0 ? 32 : 31 - (Lv(l) / V_ | 0) | 0;
    }
    var mr = 31, Te = (
      /*                        */
      0
    ), yi = (
      /*                          */
      0
    ), Ht = (
      /*                        */
      1
    ), Es = (
      /*    */
      2
    ), Xa = (
      /*             */
      4
    ), id = (
      /*            */
      8
    ), _r = (
      /*                     */
      16
    ), rd = (
      /*                */
      32
    ), eu = (
      /*                       */
      4194240
    ), nd = (
      /*                        */
      64
    ), bo = (
      /*                        */
      128
    ), Da = (
      /*                        */
      256
    ), ad = (
      /*                        */
      512
    ), vf = (
      /*                        */
      1024
    ), gf = (
      /*                        */
      2048
    ), Mv = (
      /*                        */
      4096
    ), kv = (
      /*                        */
      8192
    ), Pv = (
      /*                        */
      16384
    ), Fv = (
      /*                       */
      32768
    ), Bv = (
      /*                       */
      65536
    ), Vv = (
      /*                       */
      131072
    ), Nv = (
      /*                       */
      262144
    ), Hv = (
      /*                       */
      524288
    ), od = (
      /*                       */
      1048576
    ), $v = (
      /*                       */
      2097152
    ), sd = (
      /*                            */
      130023424
    ), dl = (
      /*                             */
      4194304
    ), zv = (
      /*                             */
      8388608
    ), mf = (
      /*                             */
      16777216
    ), Wv = (
      /*                             */
      33554432
    ), Uv = (
      /*                             */
      67108864
    ), N_ = dl, Tc = (
      /*          */
      134217728
    ), Gv = (
      /*                          */
      268435455
    ), Ic = (
      /*               */
      268435456
    ), tu = (
      /*                        */
      536870912
    ), Aa = (
      /*                   */
      1073741824
    );
    function sD(s) {
      {
        if (s & Ht)
          return "Sync";
        if (s & Es)
          return "InputContinuousHydration";
        if (s & Xa)
          return "InputContinuous";
        if (s & id)
          return "DefaultHydration";
        if (s & _r)
          return "Default";
        if (s & rd)
          return "TransitionHydration";
        if (s & eu)
          return "Transition";
        if (s & sd)
          return "Retry";
        if (s & Tc)
          return "SelectiveHydration";
        if (s & Ic)
          return "IdleHydration";
        if (s & tu)
          return "Idle";
        if (s & Aa)
          return "Offscreen";
      }
    }
    var nr = -1, Kv = nd, jv = dl;
    function Dc(s) {
      switch (Kr(s)) {
        case Ht:
          return Ht;
        case Es:
          return Es;
        case Xa:
          return Xa;
        case id:
          return id;
        case _r:
          return _r;
        case rd:
          return rd;
        case nd:
        case bo:
        case Da:
        case ad:
        case vf:
        case gf:
        case Mv:
        case kv:
        case Pv:
        case Fv:
        case Bv:
        case Vv:
        case Nv:
        case Hv:
        case od:
        case $v:
          return s & eu;
        case dl:
        case zv:
        case mf:
        case Wv:
        case Uv:
          return s & sd;
        case Tc:
          return Tc;
        case Ic:
          return Ic;
        case tu:
          return tu;
        case Aa:
          return Aa;
        default:
          return o("Should have found matching lanes. This is a bug in React."), s;
      }
    }
    function _f(s, l) {
      var f = s.pendingLanes;
      if (f === Te)
        return Te;
      var g = Te, C = s.suspendedLanes, S = s.pingedLanes, T = f & Gv;
      if (T !== Te) {
        var O = T & ~C;
        if (O !== Te)
          g = Dc(O);
        else {
          var M = T & S;
          M !== Te && (g = Dc(M));
        }
      } else {
        var V = f & ~C;
        V !== Te ? g = Dc(V) : S !== Te && (g = Dc(S));
      }
      if (g === Te)
        return Te;
      if (l !== Te && l !== g && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (l & C) === Te) {
        var H = Kr(g), J = Kr(l);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          H >= J || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          H === _r && (J & eu) !== Te
        )
          return l;
      }
      (g & Xa) !== Te && (g |= f & _r);
      var Q = s.entangledLanes;
      if (Q !== Te)
        for (var fe = s.entanglements, ce = g & Q; ce > 0; ) {
          var me = iu(ce), lt = 1 << me;
          g |= fe[me], ce &= ~lt;
        }
      return g;
    }
    function O0(s, l) {
      for (var f = s.eventTimes, g = nr; l > 0; ) {
        var C = iu(l), S = 1 << C, T = f[C];
        T > g && (g = T), l &= ~S;
      }
      return g;
    }
    function Yv(s, l) {
      switch (s) {
        case Ht:
        case Es:
        case Xa:
          return l + 250;
        case id:
        case _r:
        case rd:
        case nd:
        case bo:
        case Da:
        case ad:
        case vf:
        case gf:
        case Mv:
        case kv:
        case Pv:
        case Fv:
        case Bv:
        case Vv:
        case Nv:
        case Hv:
        case od:
        case $v:
          return l + 5e3;
        case dl:
        case zv:
        case mf:
        case Wv:
        case Uv:
          return nr;
        case Tc:
        case Ic:
        case tu:
        case Aa:
          return nr;
        default:
          return o("Should have found matching lanes. This is a bug in React."), nr;
      }
    }
    function lD(s, l) {
      for (var f = s.pendingLanes, g = s.suspendedLanes, C = s.pingedLanes, S = s.expirationTimes, T = f; T > 0; ) {
        var O = iu(T), M = 1 << O, V = S[O];
        V === nr ? ((M & g) === Te || (M & C) !== Te) && (S[O] = Yv(M, l)) : V <= l && (s.expiredLanes |= M), T &= ~M;
      }
    }
    function uD(s) {
      return Dc(s.pendingLanes);
    }
    function H_(s) {
      var l = s.pendingLanes & ~Aa;
      return l !== Te ? l : l & Aa ? Aa : Te;
    }
    function Ac(s) {
      return (s & Ht) !== Te;
    }
    function Cf(s) {
      return (s & Gv) !== Te;
    }
    function qv(s) {
      return (s & sd) === s;
    }
    function dD(s) {
      var l = Ht | Xa | _r;
      return (s & l) === Te;
    }
    function R0(s) {
      return (s & eu) === s;
    }
    function yf(s, l) {
      var f = Es | Xa | id | _r;
      return (l & f) !== Te;
    }
    function L0(s, l) {
      return (l & s.expiredLanes) !== Te;
    }
    function $_(s) {
      return (s & eu) !== Te;
    }
    function z_() {
      var s = Kv;
      return Kv <<= 1, (Kv & eu) === Te && (Kv = nd), s;
    }
    function cD() {
      var s = jv;
      return jv <<= 1, (jv & sd) === Te && (jv = dl), s;
    }
    function Kr(s) {
      return s & -s;
    }
    function nn(s) {
      return Kr(s);
    }
    function iu(s) {
      return 31 - Rv(s);
    }
    function Xv(s) {
      return iu(s);
    }
    function Oa(s, l) {
      return (s & l) !== Te;
    }
    function ld(s, l) {
      return (s & l) === l;
    }
    function ei(s, l) {
      return s | l;
    }
    function Oc(s, l) {
      return s & ~l;
    }
    function W_(s, l) {
      return s & l;
    }
    function M0(s) {
      return s;
    }
    function k0(s, l) {
      return s !== yi && s < l ? s : l;
    }
    function Qv(s) {
      for (var l = [], f = 0; f < mr; f++)
        l.push(s);
      return l;
    }
    function ud(s, l, f) {
      s.pendingLanes |= l, l !== tu && (s.suspendedLanes = Te, s.pingedLanes = Te);
      var g = s.eventTimes, C = Xv(l);
      g[C] = f;
    }
    function U_(s, l) {
      s.suspendedLanes |= l, s.pingedLanes &= ~l;
      for (var f = s.expirationTimes, g = l; g > 0; ) {
        var C = iu(g), S = 1 << C;
        f[C] = nr, g &= ~S;
      }
    }
    function G_(s, l, f) {
      s.pingedLanes |= s.suspendedLanes & l;
    }
    function K_(s, l) {
      var f = s.pendingLanes & ~l;
      s.pendingLanes = l, s.suspendedLanes = Te, s.pingedLanes = Te, s.expiredLanes &= l, s.mutableReadLanes &= l, s.entangledLanes &= l;
      for (var g = s.entanglements, C = s.eventTimes, S = s.expirationTimes, T = f; T > 0; ) {
        var O = iu(T), M = 1 << O;
        g[O] = Te, C[O] = nr, S[O] = nr, T &= ~M;
      }
    }
    function Rc(s, l) {
      for (var f = s.entangledLanes |= l, g = s.entanglements, C = f; C; ) {
        var S = iu(C), T = 1 << S;
        // Is this one of the newly entangled lanes?
        T & l | // Is this lane transitively entangled with the newly entangled lanes?
        g[S] & l && (g[S] |= l), C &= ~T;
      }
    }
    function hD(s, l) {
      var f = Kr(l), g;
      switch (f) {
        case Xa:
          g = Es;
          break;
        case _r:
          g = id;
          break;
        case nd:
        case bo:
        case Da:
        case ad:
        case vf:
        case gf:
        case Mv:
        case kv:
        case Pv:
        case Fv:
        case Bv:
        case Vv:
        case Nv:
        case Hv:
        case od:
        case $v:
        case dl:
        case zv:
        case mf:
        case Wv:
        case Uv:
          g = rd;
          break;
        case tu:
          g = Ic;
          break;
        default:
          g = yi;
          break;
      }
      return (g & (s.suspendedLanes | l)) !== yi ? yi : g;
    }
    function j_(s, l, f) {
      if (bn)
        for (var g = s.pendingUpdatersLaneMap; f > 0; ) {
          var C = Xv(f), S = 1 << C, T = g[C];
          T.add(l), f &= ~S;
        }
    }
    function Zv(s, l) {
      if (bn)
        for (var f = s.pendingUpdatersLaneMap, g = s.memoizedUpdaters; l > 0; ) {
          var C = Xv(l), S = 1 << C, T = f[C];
          T.size > 0 && (T.forEach(function(O) {
            var M = O.alternate;
            (M === null || !g.has(M)) && g.add(O);
          }), T.clear()), l &= ~S;
        }
    }
    function Y_(s, l) {
      return null;
    }
    var Kn = Ht, wn = Xa, cl = _r, xf = tu, dd = yi;
    function wo() {
      return dd;
    }
    function an(s) {
      dd = s;
    }
    function Sf(s, l) {
      var f = dd;
      try {
        return dd = s, l();
      } finally {
        dd = f;
      }
    }
    function jn(s, l) {
      return s !== 0 && s < l ? s : l;
    }
    function fD(s, l) {
      return s === 0 || s > l ? s : l;
    }
    function q_(s, l) {
      return s !== 0 && s < l;
    }
    function Ef(s) {
      var l = Kr(s);
      return q_(Kn, l) ? q_(wn, l) ? Cf(l) ? cl : xf : wn : Kn;
    }
    function on(s) {
      var l = s.current.memoizedState;
      return l.isDehydrated;
    }
    var P0;
    function Ct(s) {
      P0 = s;
    }
    function Lc(s) {
      P0(s);
    }
    var bf;
    function F0(s) {
      bf = s;
    }
    var B0;
    function wf(s) {
      B0 = s;
    }
    var Tf;
    function X_(s) {
      Tf = s;
    }
    var Q_;
    function V0(s) {
      Q_ = s;
    }
    var Jv = !1, Mc = [], bs = null, Sr = null, vn = null, To = /* @__PURE__ */ new Map(), kc = /* @__PURE__ */ new Map(), hl = [], ts = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function N0(s) {
      return ts.indexOf(s) > -1;
    }
    function ws(s, l, f, g, C) {
      return {
        blockedOn: s,
        domEventName: l,
        eventSystemFlags: f,
        nativeEvent: C,
        targetContainers: [g]
      };
    }
    function H0(s, l) {
      switch (s) {
        case "focusin":
        case "focusout":
          bs = null;
          break;
        case "dragenter":
        case "dragleave":
          Sr = null;
          break;
        case "mouseover":
        case "mouseout":
          vn = null;
          break;
        case "pointerover":
        case "pointerout": {
          var f = l.pointerId;
          To.delete(f);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var g = l.pointerId;
          kc.delete(g);
          break;
        }
      }
    }
    function Pc(s, l, f, g, C, S) {
      if (s === null || s.nativeEvent !== S) {
        var T = ws(l, f, g, C, S);
        if (l !== null) {
          var O = Kc(l);
          O !== null && bf(O);
        }
        return T;
      }
      s.eventSystemFlags |= g;
      var M = s.targetContainers;
      return C !== null && M.indexOf(C) === -1 && M.push(C), s;
    }
    function $0(s, l, f, g, C) {
      switch (l) {
        case "focusin": {
          var S = C;
          return bs = Pc(bs, s, l, f, g, S), !0;
        }
        case "dragenter": {
          var T = C;
          return Sr = Pc(Sr, s, l, f, g, T), !0;
        }
        case "mouseover": {
          var O = C;
          return vn = Pc(vn, s, l, f, g, O), !0;
        }
        case "pointerover": {
          var M = C, V = M.pointerId;
          return To.set(V, Pc(To.get(V) || null, s, l, f, g, M)), !0;
        }
        case "gotpointercapture": {
          var H = C, J = H.pointerId;
          return kc.set(J, Pc(kc.get(J) || null, s, l, f, g, H)), !0;
        }
      }
      return !1;
    }
    function Z_(s) {
      var l = Pf(s.target);
      if (l !== null) {
        var f = ja(l);
        if (f !== null) {
          var g = f.tag;
          if (g === z) {
            var C = I_(f);
            if (C !== null) {
              s.blockedOn = C, Q_(s.priority, function() {
                B0(f);
              });
              return;
            }
          } else if (g === _) {
            var S = f.stateNode;
            if (on(S)) {
              s.blockedOn = xv(f);
              return;
            }
          }
        }
      }
      s.blockedOn = null;
    }
    function z0(s) {
      for (var l = Tf(), f = {
        blockedOn: null,
        target: s,
        priority: l
      }, g = 0; g < hl.length && q_(l, hl[g].priority); g++)
        ;
      hl.splice(g, 0, f), g === 0 && Z_(f);
    }
    function eg(s) {
      if (s.blockedOn !== null)
        return !1;
      for (var l = s.targetContainers; l.length > 0; ) {
        var f = l[0], g = cd(s.domEventName, s.eventSystemFlags, f, s.nativeEvent);
        if (g === null) {
          var C = s.nativeEvent, S = new C.constructor(C.type, C);
          af(S), C.target.dispatchEvent(S), rD();
        } else {
          var T = Kc(g);
          return T !== null && bf(T), s.blockedOn = g, !1;
        }
        l.shift();
      }
      return !0;
    }
    function If(s, l, f) {
      eg(s) && f.delete(l);
    }
    function J_() {
      Jv = !1, bs !== null && eg(bs) && (bs = null), Sr !== null && eg(Sr) && (Sr = null), vn !== null && eg(vn) && (vn = null), To.forEach(If), kc.forEach(If);
    }
    function Yn(s, l) {
      s.blockedOn === l && (s.blockedOn = null, Jv || (Jv = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, J_)));
    }
    function pi(s) {
      if (Mc.length > 0) {
        Yn(Mc[0], s);
        for (var l = 1; l < Mc.length; l++) {
          var f = Mc[l];
          f.blockedOn === s && (f.blockedOn = null);
        }
      }
      bs !== null && Yn(bs, s), Sr !== null && Yn(Sr, s), vn !== null && Yn(vn, s);
      var g = function(O) {
        return Yn(O, s);
      };
      To.forEach(g), kc.forEach(g);
      for (var C = 0; C < hl.length; C++) {
        var S = hl[C];
        S.blockedOn === s && (S.blockedOn = null);
      }
      for (; hl.length > 0; ) {
        var T = hl[0];
        if (T.blockedOn !== null)
          break;
        Z_(T), T.blockedOn === null && hl.shift();
      }
    }
    var Dr = i.ReactCurrentBatchConfig, kr = !0;
    function gn(s) {
      kr = !!s;
    }
    function Qa() {
      return kr;
    }
    function Fc(s, l, f) {
      var g = na(l), C;
      switch (g) {
        case Kn:
          C = sn;
          break;
        case wn:
          C = Df;
          break;
        case cl:
        default:
          C = fl;
          break;
      }
      return C.bind(null, l, f, s);
    }
    function sn(s, l, f, g) {
      var C = wo(), S = Dr.transition;
      Dr.transition = null;
      try {
        an(Kn), fl(s, l, f, g);
      } finally {
        an(C), Dr.transition = S;
      }
    }
    function Df(s, l, f, g) {
      var C = wo(), S = Dr.transition;
      Dr.transition = null;
      try {
        an(wn), fl(s, l, f, g);
      } finally {
        an(C), Dr.transition = S;
      }
    }
    function fl(s, l, f, g) {
      kr && tg(s, l, f, g);
    }
    function tg(s, l, f, g) {
      var C = cd(s, l, f, g);
      if (C === null) {
        MD(s, l, g, Bc, f), H0(s, g);
        return;
      }
      if ($0(C, s, l, f, g)) {
        g.stopPropagation();
        return;
      }
      if (H0(s, g), l & ju && N0(s)) {
        for (; C !== null; ) {
          var S = Kc(C);
          S !== null && Lc(S);
          var T = cd(s, l, f, g);
          if (T === null && MD(s, l, g, Bc, f), T === C)
            break;
          C = T;
        }
        C !== null && g.stopPropagation();
        return;
      }
      MD(s, l, g, null, f);
    }
    var Bc = null;
    function cd(s, l, f, g) {
      Bc = null;
      var C = gv(g), S = Pf(C);
      if (S !== null) {
        var T = ja(S);
        if (T === null)
          S = null;
        else {
          var O = T.tag;
          if (O === z) {
            var M = I_(T);
            if (M !== null)
              return M;
            S = null;
          } else if (O === _) {
            var V = T.stateNode;
            if (on(V))
              return xv(T);
            S = null;
          } else
            T !== S && (S = null);
        }
      }
      return Bc = S, null;
    }
    function na(s) {
      switch (s) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Kn;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return wn;
        case "message": {
          var l = O_();
          switch (l) {
            case wv:
              return Kn;
            case qa:
              return wn;
            case Ss:
            case Tv:
              return cl;
            case ql:
              return xf;
            default:
              return cl;
          }
        }
        default:
          return cl;
      }
    }
    function eC(s, l, f) {
      return s.addEventListener(l, f, !1), f;
    }
    function Vc(s, l, f) {
      return s.addEventListener(l, f, !0), f;
    }
    function pl(s, l, f, g) {
      return s.addEventListener(l, f, {
        capture: !0,
        passive: g
      }), f;
    }
    function ig(s, l, f, g) {
      return s.addEventListener(l, f, {
        passive: g
      }), f;
    }
    var hd = null, Ts = null, ru = null;
    function nu(s) {
      return hd = s, Ts = ng(), !0;
    }
    function rg() {
      hd = null, Ts = null, ru = null;
    }
    function Nc() {
      if (ru)
        return ru;
      var s, l = Ts, f = l.length, g, C = ng(), S = C.length;
      for (s = 0; s < f && l[s] === C[s]; s++)
        ;
      var T = f - s;
      for (g = 1; g <= T && l[f - g] === C[S - g]; g++)
        ;
      var O = g > 1 ? 1 - g : void 0;
      return ru = C.slice(s, O), ru;
    }
    function ng() {
      return "value" in hd ? hd.value : hd.textContent;
    }
    function fd(s) {
      var l, f = s.keyCode;
      return "charCode" in s ? (l = s.charCode, l === 0 && f === 13 && (l = 13)) : l = f, l === 10 && (l = 13), l >= 32 || l === 13 ? l : 0;
    }
    function pd() {
      return !0;
    }
    function qn() {
      return !1;
    }
    function jr(s) {
      function l(f, g, C, S, T) {
        this._reactName = f, this._targetInst = C, this.type = g, this.nativeEvent = S, this.target = T, this.currentTarget = null;
        for (var O in s)
          if (s.hasOwnProperty(O)) {
            var M = s[O];
            M ? this[O] = M(S) : this[O] = S[O];
          }
        var V = S.defaultPrevented != null ? S.defaultPrevented : S.returnValue === !1;
        return V ? this.isDefaultPrevented = pd : this.isDefaultPrevented = qn, this.isPropagationStopped = qn, this;
      }
      return fi(l.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var f = this.nativeEvent;
          f && (f.preventDefault ? f.preventDefault() : typeof f.returnValue != "unknown" && (f.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
          var f = this.nativeEvent;
          f && (f.stopPropagation ? f.stopPropagation() : typeof f.cancelBubble != "unknown" && (f.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: pd
      }), l;
    }
    var Xn = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(s) {
        return s.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Qn = jr(Xn), Hc = fi({}, Xn, {
      view: 0,
      detail: 0
    }), tC = jr(Hc), Af, iC, Io;
    function W0(s) {
      s !== Io && (Io && s.type === "mousemove" ? (Af = s.screenX - Io.screenX, iC = s.screenY - Io.screenY) : (Af = 0, iC = 0), Io = s);
    }
    var $c = fi({}, Hc, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: sg,
      button: 0,
      buttons: 0,
      relatedTarget: function(s) {
        return s.relatedTarget === void 0 ? s.fromElement === s.srcElement ? s.toElement : s.fromElement : s.relatedTarget;
      },
      movementX: function(s) {
        return "movementX" in s ? s.movementX : (W0(s), Af);
      },
      movementY: function(s) {
        return "movementY" in s ? s.movementY : iC;
      }
    }), au = jr($c), rC = fi({}, $c, {
      dataTransfer: 0
    }), vd = jr(rC), U0 = fi({}, Hc, {
      relatedTarget: 0
    }), ag = jr(U0), nC = fi({}, Xn, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), og = jr(nC), pD = fi({}, Xn, {
      clipboardData: function(s) {
        return "clipboardData" in s ? s.clipboardData : window.clipboardData;
      }
    }), vD = jr(pD), G0 = fi({}, Xn, {
      data: 0
    }), aC = jr(G0), gd = aC, gD = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, zc = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function K0(s) {
      if (s.key) {
        var l = gD[s.key] || s.key;
        if (l !== "Unidentified")
          return l;
      }
      if (s.type === "keypress") {
        var f = fd(s);
        return f === 13 ? "Enter" : String.fromCharCode(f);
      }
      return s.type === "keydown" || s.type === "keyup" ? zc[s.keyCode] || "Unidentified" : "";
    }
    var Pr = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function mD(s) {
      var l = this, f = l.nativeEvent;
      if (f.getModifierState)
        return f.getModifierState(s);
      var g = Pr[s];
      return g ? !!f[g] : !1;
    }
    function sg(s) {
      return mD;
    }
    var _D = fi({}, Hc, {
      key: K0,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: sg,
      // Legacy Interface
      charCode: function(s) {
        return s.type === "keypress" ? fd(s) : 0;
      },
      keyCode: function(s) {
        return s.type === "keydown" || s.type === "keyup" ? s.keyCode : 0;
      },
      which: function(s) {
        return s.type === "keypress" ? fd(s) : s.type === "keydown" || s.type === "keyup" ? s.keyCode : 0;
      }
    }), CD = jr(_D), j0 = fi({}, $c, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), oC = jr(j0), yD = fi({}, Hc, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: sg
    }), Do = jr(yD), sC = fi({}, Xn, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), xD = jr(sC), ou = fi({}, $c, {
      deltaX: function(s) {
        return "deltaX" in s ? s.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in s ? -s.wheelDeltaX : 0
        );
      },
      deltaY: function(s) {
        return "deltaY" in s ? s.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in s ? -s.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in s ? -s.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), lg = jr(ou), md = [9, 13, 27, 32], Of = 229, Rf = gt && "CompositionEvent" in window, _d = null;
    gt && "documentMode" in document && (_d = document.documentMode);
    var SD = gt && "TextEvent" in window && !_d, ug = gt && (!Rf || _d && _d > 8 && _d <= 11), Y0 = 32, lC = String.fromCharCode(Y0);
    function q0() {
      zt("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), zt("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), zt("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), zt("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Lf = !1;
    function dg(s) {
      return (s.ctrlKey || s.altKey || s.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(s.ctrlKey && s.altKey);
    }
    function X0(s) {
      switch (s) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function uC(s, l) {
      return s === "keydown" && l.keyCode === Of;
    }
    function Q0(s, l) {
      switch (s) {
        case "keyup":
          return md.indexOf(l.keyCode) !== -1;
        case "keydown":
          return l.keyCode !== Of;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function dC(s) {
      var l = s.detail;
      return typeof l == "object" && "data" in l ? l.data : null;
    }
    function cg(s) {
      return s.locale === "ko";
    }
    var vl = !1;
    function cC(s, l, f, g, C) {
      var S, T;
      if (Rf ? S = X0(l) : vl ? Q0(l, g) && (S = "onCompositionEnd") : uC(l, g) && (S = "onCompositionStart"), !S)
        return null;
      ug && !cg(g) && (!vl && S === "onCompositionStart" ? vl = nu(C) : S === "onCompositionEnd" && vl && (T = Nc()));
      var O = iE(f, S);
      if (O.length > 0) {
        var M = new aC(S, l, null, g, C);
        if (s.push({
          event: M,
          listeners: O
        }), T)
          M.data = T;
        else {
          var V = dC(g);
          V !== null && (M.data = V);
        }
      }
    }
    function hg(s, l) {
      switch (s) {
        case "compositionend":
          return dC(l);
        case "keypress":
          var f = l.which;
          return f !== Y0 ? null : (Lf = !0, lC);
        case "textInput":
          var g = l.data;
          return g === lC && Lf ? null : g;
        default:
          return null;
      }
    }
    function Z0(s, l) {
      if (vl) {
        if (s === "compositionend" || !Rf && Q0(s, l)) {
          var f = Nc();
          return rg(), vl = !1, f;
        }
        return null;
      }
      switch (s) {
        case "paste":
          return null;
        case "keypress":
          if (!dg(l)) {
            if (l.char && l.char.length > 1)
              return l.char;
            if (l.which)
              return String.fromCharCode(l.which);
          }
          return null;
        case "compositionend":
          return ug && !cg(l) ? null : l.data;
        default:
          return null;
      }
    }
    function ED(s, l, f, g, C) {
      var S;
      if (SD ? S = hg(l, g) : S = Z0(l, g), !S)
        return null;
      var T = iE(f, "onBeforeInput");
      if (T.length > 0) {
        var O = new gd("onBeforeInput", "beforeinput", null, g, C);
        s.push({
          event: O,
          listeners: T
        }), O.data = S;
      }
    }
    function fg(s, l, f, g, C, S, T) {
      cC(s, l, f, g, C), ED(s, l, f, g, C);
    }
    var bD = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function Wc(s) {
      var l = s && s.nodeName && s.nodeName.toLowerCase();
      return l === "input" ? !!bD[s.type] : l === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function wD(s) {
      if (!gt)
        return !1;
      var l = "on" + s, f = l in document;
      if (!f) {
        var g = document.createElement("div");
        g.setAttribute(l, "return;"), f = typeof g[l] == "function";
      }
      return f;
    }
    function pg() {
      zt("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function d(s, l, f, g) {
      mv(g);
      var C = iE(l, "onChange");
      if (C.length > 0) {
        var S = new Qn("onChange", "change", null, f, g);
        s.push({
          event: S,
          listeners: C
        });
      }
    }
    var h = null, m = null;
    function x(s) {
      var l = s.nodeName && s.nodeName.toLowerCase();
      return l === "select" || l === "input" && s.type === "file";
    }
    function w(s) {
      var l = [];
      d(l, m, s, gv(s)), C_(D, l);
    }
    function D(s) {
      TV(s, 0);
    }
    function F(s) {
      var l = yg(s);
      if (VS(l))
        return s;
    }
    function W(s, l) {
      if (s === "change")
        return l;
    }
    var Y = !1;
    gt && (Y = wD("input") && (!document.documentMode || document.documentMode > 9));
    function he(s, l) {
      h = s, m = l, h.attachEvent("onpropertychange", Ne);
    }
    function Be() {
      h && (h.detachEvent("onpropertychange", Ne), h = null, m = null);
    }
    function Ne(s) {
      s.propertyName === "value" && F(m) && w(s);
    }
    function Pe(s, l, f) {
      s === "focusin" ? (Be(), he(l, f)) : s === "focusout" && Be();
    }
    function ut(s, l) {
      if (s === "selectionchange" || s === "keyup" || s === "keydown")
        return F(m);
    }
    function xt(s) {
      var l = s.nodeName;
      return l && l.toLowerCase() === "input" && (s.type === "checkbox" || s.type === "radio");
    }
    function bt(s, l) {
      if (s === "click")
        return F(l);
    }
    function Nr(s, l) {
      if (s === "input" || s === "change")
        return F(l);
    }
    function oe(s) {
      var l = s._wrapperState;
      !l || !l.controlled || s.type !== "number" || $l(s, "number", s.value);
    }
    function Z(s, l, f, g, C, S, T) {
      var O = f ? yg(f) : window, M, V;
      if (x(O) ? M = W : Wc(O) ? Y ? M = Nr : (M = ut, V = Pe) : xt(O) && (M = bt), M) {
        var H = M(l, f);
        if (H) {
          d(s, H, g, C);
          return;
        }
      }
      V && V(l, O, f), l === "focusout" && oe(O);
    }
    function ue() {
      Ie("onMouseEnter", ["mouseout", "mouseover"]), Ie("onMouseLeave", ["mouseout", "mouseover"]), Ie("onPointerEnter", ["pointerout", "pointerover"]), Ie("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function Ge(s, l, f, g, C, S, T) {
      var O = l === "mouseover" || l === "pointerover", M = l === "mouseout" || l === "pointerout";
      if (O && !v0(g)) {
        var V = g.relatedTarget || g.fromElement;
        if (V && (Pf(V) || wC(V)))
          return;
      }
      if (!(!M && !O)) {
        var H;
        if (C.window === C)
          H = C;
        else {
          var J = C.ownerDocument;
          J ? H = J.defaultView || J.parentWindow : H = window;
        }
        var Q, fe;
        if (M) {
          var ce = g.relatedTarget || g.toElement;
          if (Q = f, fe = ce ? Pf(ce) : null, fe !== null) {
            var me = ja(fe);
            (fe !== me || fe.tag !== b && fe.tag !== I) && (fe = null);
          }
        } else
          Q = null, fe = f;
        if (Q !== fe) {
          var lt = au, Mt = "onMouseLeave", Tt = "onMouseEnter", vi = "mouse";
          (l === "pointerout" || l === "pointerover") && (lt = oC, Mt = "onPointerLeave", Tt = "onPointerEnter", vi = "pointer");
          var gi = Q == null ? H : yg(Q), se = fe == null ? H : yg(fe), Se = new lt(Mt, vi + "leave", Q, g, C);
          Se.target = gi, Se.relatedTarget = se;
          var le = null, He = Pf(C);
          if (He === f) {
            var pt = new lt(Tt, vi + "enter", fe, g, C);
            pt.target = se, pt.relatedTarget = gi, le = pt;
          }
          m7(s, Se, le, Q, fe);
        }
      }
    }
    function It(s, l) {
      return s === l && (s !== 0 || 1 / s === 1 / l) || s !== s && l !== l;
    }
    var St = typeof Object.is == "function" ? Object.is : It;
    function At(s, l) {
      if (St(s, l))
        return !0;
      if (typeof s != "object" || s === null || typeof l != "object" || l === null)
        return !1;
      var f = Object.keys(s), g = Object.keys(l);
      if (f.length !== g.length)
        return !1;
      for (var C = 0; C < f.length; C++) {
        var S = f[C];
        if (!si.call(l, S) || !St(s[S], l[S]))
          return !1;
      }
      return !0;
    }
    function Kt(s) {
      for (; s && s.firstChild; )
        s = s.firstChild;
      return s;
    }
    function mn(s) {
      for (; s; ) {
        if (s.nextSibling)
          return s.nextSibling;
        s = s.parentNode;
      }
    }
    function Ai(s, l) {
      for (var f = Kt(s), g = 0, C = 0; f; ) {
        if (f.nodeType === tl) {
          if (C = g + f.textContent.length, g <= l && C >= l)
            return {
              node: f,
              offset: l - g
            };
          g = C;
        }
        f = Kt(mn(f));
      }
    }
    function su(s) {
      var l = s.ownerDocument, f = l && l.defaultView || window, g = f.getSelection && f.getSelection();
      if (!g || g.rangeCount === 0)
        return null;
      var C = g.anchorNode, S = g.anchorOffset, T = g.focusNode, O = g.focusOffset;
      try {
        C.nodeType, T.nodeType;
      } catch {
        return null;
      }
      return TD(s, C, S, T, O);
    }
    function TD(s, l, f, g, C) {
      var S = 0, T = -1, O = -1, M = 0, V = 0, H = s, J = null;
      e:
        for (; ; ) {
          for (var Q = null; H === l && (f === 0 || H.nodeType === tl) && (T = S + f), H === g && (C === 0 || H.nodeType === tl) && (O = S + C), H.nodeType === tl && (S += H.nodeValue.length), (Q = H.firstChild) !== null; )
            J = H, H = Q;
          for (; ; ) {
            if (H === s)
              break e;
            if (J === l && ++M === f && (T = S), J === g && ++V === C && (O = S), (Q = H.nextSibling) !== null)
              break;
            H = J, J = H.parentNode;
          }
          H = Q;
        }
      return T === -1 || O === -1 ? null : {
        start: T,
        end: O
      };
    }
    function Z9(s, l) {
      var f = s.ownerDocument || document, g = f && f.defaultView || window;
      if (g.getSelection) {
        var C = g.getSelection(), S = s.textContent.length, T = Math.min(l.start, S), O = l.end === void 0 ? T : Math.min(l.end, S);
        if (!C.extend && T > O) {
          var M = O;
          O = T, T = M;
        }
        var V = Ai(s, T), H = Ai(s, O);
        if (V && H) {
          if (C.rangeCount === 1 && C.anchorNode === V.node && C.anchorOffset === V.offset && C.focusNode === H.node && C.focusOffset === H.offset)
            return;
          var J = f.createRange();
          J.setStart(V.node, V.offset), C.removeAllRanges(), T > O ? (C.addRange(J), C.extend(H.node, H.offset)) : (J.setEnd(H.node, H.offset), C.addRange(J));
        }
      }
    }
    function pV(s) {
      return s && s.nodeType === tl;
    }
    function vV(s, l) {
      return !s || !l ? !1 : s === l ? !0 : pV(s) ? !1 : pV(l) ? vV(s, l.parentNode) : "contains" in s ? s.contains(l) : s.compareDocumentPosition ? !!(s.compareDocumentPosition(l) & 16) : !1;
    }
    function J9(s) {
      return s && s.ownerDocument && vV(s.ownerDocument.documentElement, s);
    }
    function e7(s) {
      try {
        return typeof s.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function gV() {
      for (var s = window, l = rv(); l instanceof s.HTMLIFrameElement; ) {
        if (e7(l))
          s = l.contentWindow;
        else
          return l;
        l = rv(s.document);
      }
      return l;
    }
    function ID(s) {
      var l = s && s.nodeName && s.nodeName.toLowerCase();
      return l && (l === "input" && (s.type === "text" || s.type === "search" || s.type === "tel" || s.type === "url" || s.type === "password") || l === "textarea" || s.contentEditable === "true");
    }
    function t7() {
      var s = gV();
      return {
        focusedElem: s,
        selectionRange: ID(s) ? r7(s) : null
      };
    }
    function i7(s) {
      var l = gV(), f = s.focusedElem, g = s.selectionRange;
      if (l !== f && J9(f)) {
        g !== null && ID(f) && n7(f, g);
        for (var C = [], S = f; S = S.parentNode; )
          S.nodeType === Sa && C.push({
            element: S,
            left: S.scrollLeft,
            top: S.scrollTop
          });
        typeof f.focus == "function" && f.focus();
        for (var T = 0; T < C.length; T++) {
          var O = C[T];
          O.element.scrollLeft = O.left, O.element.scrollTop = O.top;
        }
      }
    }
    function r7(s) {
      var l;
      return "selectionStart" in s ? l = {
        start: s.selectionStart,
        end: s.selectionEnd
      } : l = su(s), l || {
        start: 0,
        end: 0
      };
    }
    function n7(s, l) {
      var f = l.start, g = l.end;
      g === void 0 && (g = f), "selectionStart" in s ? (s.selectionStart = f, s.selectionEnd = Math.min(g, s.value.length)) : Z9(s, l);
    }
    var a7 = gt && "documentMode" in document && document.documentMode <= 11;
    function o7() {
      zt("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var vg = null, DD = null, hC = null, AD = !1;
    function s7(s) {
      if ("selectionStart" in s && ID(s))
        return {
          start: s.selectionStart,
          end: s.selectionEnd
        };
      var l = s.ownerDocument && s.ownerDocument.defaultView || window, f = l.getSelection();
      return {
        anchorNode: f.anchorNode,
        anchorOffset: f.anchorOffset,
        focusNode: f.focusNode,
        focusOffset: f.focusOffset
      };
    }
    function l7(s) {
      return s.window === s ? s.document : s.nodeType === Qo ? s : s.ownerDocument;
    }
    function mV(s, l, f) {
      var g = l7(f);
      if (!(AD || vg == null || vg !== rv(g))) {
        var C = s7(vg);
        if (!hC || !At(hC, C)) {
          hC = C;
          var S = iE(DD, "onSelect");
          if (S.length > 0) {
            var T = new Qn("onSelect", "select", null, l, f);
            s.push({
              event: T,
              listeners: S
            }), T.target = vg;
          }
        }
      }
    }
    function u7(s, l, f, g, C, S, T) {
      var O = f ? yg(f) : window;
      switch (l) {
        case "focusin":
          (Wc(O) || O.contentEditable === "true") && (vg = O, DD = f, hC = null);
          break;
        case "focusout":
          vg = null, DD = null, hC = null;
          break;
        case "mousedown":
          AD = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          AD = !1, mV(s, g, C);
          break;
        case "selectionchange":
          if (a7)
            break;
        case "keydown":
        case "keyup":
          mV(s, g, C);
      }
    }
    function J0(s, l) {
      var f = {};
      return f[s.toLowerCase()] = l.toLowerCase(), f["Webkit" + s] = "webkit" + l, f["Moz" + s] = "moz" + l, f;
    }
    var gg = {
      animationend: J0("Animation", "AnimationEnd"),
      animationiteration: J0("Animation", "AnimationIteration"),
      animationstart: J0("Animation", "AnimationStart"),
      transitionend: J0("Transition", "TransitionEnd")
    }, OD = {}, _V = {};
    gt && (_V = document.createElement("div").style, "AnimationEvent" in window || (delete gg.animationend.animation, delete gg.animationiteration.animation, delete gg.animationstart.animation), "TransitionEvent" in window || delete gg.transitionend.transition);
    function eE(s) {
      if (OD[s])
        return OD[s];
      if (!gg[s])
        return s;
      var l = gg[s];
      for (var f in l)
        if (l.hasOwnProperty(f) && f in _V)
          return OD[s] = l[f];
      return s;
    }
    var CV = eE("animationend"), yV = eE("animationiteration"), xV = eE("animationstart"), SV = eE("transitionend"), EV = /* @__PURE__ */ new Map(), bV = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function Uc(s, l) {
      EV.set(s, l), zt(l, [s]);
    }
    function d7() {
      for (var s = 0; s < bV.length; s++) {
        var l = bV[s], f = l.toLowerCase(), g = l[0].toUpperCase() + l.slice(1);
        Uc(f, "on" + g);
      }
      Uc(CV, "onAnimationEnd"), Uc(yV, "onAnimationIteration"), Uc(xV, "onAnimationStart"), Uc("dblclick", "onDoubleClick"), Uc("focusin", "onFocus"), Uc("focusout", "onBlur"), Uc(SV, "onTransitionEnd");
    }
    function c7(s, l, f, g, C, S, T) {
      var O = EV.get(l);
      if (O !== void 0) {
        var M = Qn, V = l;
        switch (l) {
          case "keypress":
            if (fd(g) === 0)
              return;
          case "keydown":
          case "keyup":
            M = CD;
            break;
          case "focusin":
            V = "focus", M = ag;
            break;
          case "focusout":
            V = "blur", M = ag;
            break;
          case "beforeblur":
          case "afterblur":
            M = ag;
            break;
          case "click":
            if (g.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            M = au;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            M = vd;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            M = Do;
            break;
          case CV:
          case yV:
          case xV:
            M = og;
            break;
          case SV:
            M = xD;
            break;
          case "scroll":
            M = tC;
            break;
          case "wheel":
            M = lg;
            break;
          case "copy":
          case "cut":
          case "paste":
            M = vD;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            M = oC;
            break;
        }
        var H = (S & ju) !== 0;
        {
          var J = !H && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          l === "scroll", Q = v7(f, O, g.type, H, J);
          if (Q.length > 0) {
            var fe = new M(O, V, null, g, C);
            s.push({
              event: fe,
              listeners: Q
            });
          }
        }
      }
    }
    d7(), ue(), pg(), o7(), q0();
    function h7(s, l, f, g, C, S, T) {
      c7(s, l, f, g, C, S);
      var O = (S & iD) === 0;
      O && (Ge(s, l, f, g, C), Z(s, l, f, g, C), u7(s, l, f, g, C), fg(s, l, f, g, C));
    }
    var fC = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], RD = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(fC));
    function wV(s, l, f) {
      var g = s.type || "unknown-event";
      s.currentTarget = f, al(g, l, void 0, s), s.currentTarget = null;
    }
    function f7(s, l, f) {
      var g;
      if (f)
        for (var C = l.length - 1; C >= 0; C--) {
          var S = l[C], T = S.instance, O = S.currentTarget, M = S.listener;
          if (T !== g && s.isPropagationStopped())
            return;
          wV(s, M, O), g = T;
        }
      else
        for (var V = 0; V < l.length; V++) {
          var H = l[V], J = H.instance, Q = H.currentTarget, fe = H.listener;
          if (J !== g && s.isPropagationStopped())
            return;
          wV(s, fe, Q), g = J;
        }
    }
    function TV(s, l) {
      for (var f = (l & ju) !== 0, g = 0; g < s.length; g++) {
        var C = s[g], S = C.event, T = C.listeners;
        f7(S, T, f);
      }
      E_();
    }
    function p7(s, l, f, g, C) {
      var S = gv(f), T = [];
      h7(T, s, g, f, S, l), TV(T, l);
    }
    function Ar(s, l) {
      RD.has(s) || o('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', s);
      var f = !1, g = UQ(l), C = _7(s, f);
      g.has(C) || (IV(l, s, rf, f), g.add(C));
    }
    function LD(s, l, f) {
      RD.has(s) && !l && o('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', s);
      var g = 0;
      l && (g |= ju), IV(f, s, g, l);
    }
    var tE = "_reactListening" + Math.random().toString(36).slice(2);
    function pC(s) {
      if (!s[tE]) {
        s[tE] = !0, at.forEach(function(f) {
          f !== "selectionchange" && (RD.has(f) || LD(f, !1, s), LD(f, !0, s));
        });
        var l = s.nodeType === Qo ? s : s.ownerDocument;
        l !== null && (l[tE] || (l[tE] = !0, LD("selectionchange", !1, l)));
      }
    }
    function IV(s, l, f, g, C) {
      var S = Fc(s, l, f), T = void 0;
      lf && (l === "touchstart" || l === "touchmove" || l === "wheel") && (T = !0), s = s;
      var O;
      g ? T !== void 0 ? O = pl(s, l, S, T) : O = Vc(s, l, S) : T !== void 0 ? O = ig(s, l, S, T) : O = eC(s, l, S);
    }
    function DV(s, l) {
      return s === l || s.nodeType === Gr && s.parentNode === l;
    }
    function MD(s, l, f, g, C) {
      var S = g;
      if (!(l & rl) && !(l & rf)) {
        var T = C;
        if (g !== null) {
          var O = g;
          e:
            for (; ; ) {
              if (O === null)
                return;
              var M = O.tag;
              if (M === _ || M === y) {
                var V = O.stateNode.containerInfo;
                if (DV(V, T))
                  break;
                if (M === y)
                  for (var H = O.return; H !== null; ) {
                    var J = H.tag;
                    if (J === _ || J === y) {
                      var Q = H.stateNode.containerInfo;
                      if (DV(Q, T))
                        return;
                    }
                    H = H.return;
                  }
                for (; V !== null; ) {
                  var fe = Pf(V);
                  if (fe === null)
                    return;
                  var ce = fe.tag;
                  if (ce === b || ce === I) {
                    O = S = fe;
                    continue e;
                  }
                  V = V.parentNode;
                }
              }
              O = O.return;
            }
        }
      }
      C_(function() {
        return p7(s, l, f, S);
      });
    }
    function vC(s, l, f) {
      return {
        instance: s,
        listener: l,
        currentTarget: f
      };
    }
    function v7(s, l, f, g, C, S) {
      for (var T = l !== null ? l + "Capture" : null, O = g ? T : l, M = [], V = s, H = null; V !== null; ) {
        var J = V, Q = J.stateNode, fe = J.tag;
        if (fe === b && Q !== null && (H = Q, O !== null)) {
          var ce = qu(V, O);
          ce != null && M.push(vC(V, ce, H));
        }
        if (C)
          break;
        V = V.return;
      }
      return M;
    }
    function iE(s, l) {
      for (var f = l + "Capture", g = [], C = s; C !== null; ) {
        var S = C, T = S.stateNode, O = S.tag;
        if (O === b && T !== null) {
          var M = T, V = qu(C, f);
          V != null && g.unshift(vC(C, V, M));
          var H = qu(C, l);
          H != null && g.push(vC(C, H, M));
        }
        C = C.return;
      }
      return g;
    }
    function mg(s) {
      if (s === null)
        return null;
      do
        s = s.return;
      while (s && s.tag !== b);
      return s || null;
    }
    function g7(s, l) {
      for (var f = s, g = l, C = 0, S = f; S; S = mg(S))
        C++;
      for (var T = 0, O = g; O; O = mg(O))
        T++;
      for (; C - T > 0; )
        f = mg(f), C--;
      for (; T - C > 0; )
        g = mg(g), T--;
      for (var M = C; M--; ) {
        if (f === g || g !== null && f === g.alternate)
          return f;
        f = mg(f), g = mg(g);
      }
      return null;
    }
    function AV(s, l, f, g, C) {
      for (var S = l._reactName, T = [], O = f; O !== null && O !== g; ) {
        var M = O, V = M.alternate, H = M.stateNode, J = M.tag;
        if (V !== null && V === g)
          break;
        if (J === b && H !== null) {
          var Q = H;
          if (C) {
            var fe = qu(O, S);
            fe != null && T.unshift(vC(O, fe, Q));
          } else if (!C) {
            var ce = qu(O, S);
            ce != null && T.push(vC(O, ce, Q));
          }
        }
        O = O.return;
      }
      T.length !== 0 && s.push({
        event: l,
        listeners: T
      });
    }
    function m7(s, l, f, g, C) {
      var S = g && C ? g7(g, C) : null;
      g !== null && AV(s, l, g, S, !1), C !== null && f !== null && AV(s, f, C, S, !0);
    }
    function _7(s, l) {
      return s + "__" + (l ? "capture" : "bubble");
    }
    var Ao = !1, gC = "dangerouslySetInnerHTML", rE = "suppressContentEditableWarning", Gc = "suppressHydrationWarning", OV = "autoFocus", Mf = "children", kf = "style", nE = "__html", kD, aE, mC, RV, oE, LV, MV;
    kD = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, aE = function(s, l) {
      vv(s, l), p_(s, l), p0(s, l, {
        registrationNameDependencies: yt,
        possibleRegistrationNames: tt
      });
    }, LV = gt && !document.documentMode, mC = function(s, l, f) {
      if (!Ao) {
        var g = sE(f), C = sE(l);
        C !== g && (Ao = !0, o("Prop `%s` did not match. Server: %s Client: %s", s, JSON.stringify(C), JSON.stringify(g)));
      }
    }, RV = function(s) {
      if (!Ao) {
        Ao = !0;
        var l = [];
        s.forEach(function(f) {
          l.push(f);
        }), o("Extra attributes from the server: %s", l);
      }
    }, oE = function(s, l) {
      l === !1 ? o("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", s, s, s) : o("Expected `%s` listener to be a function, instead got a value of `%s` type.", s, typeof l);
    }, MV = function(s, l) {
      var f = s.namespaceURI === el ? s.ownerDocument.createElement(s.tagName) : s.ownerDocument.createElementNS(s.namespaceURI, s.tagName);
      return f.innerHTML = l, f.innerHTML;
    };
    var C7 = /\r\n?/g, y7 = /\u0000|\uFFFD/g;
    function sE(s) {
      ra(s);
      var l = typeof s == "string" ? s : "" + s;
      return l.replace(C7, `
`).replace(y7, "");
    }
    function lE(s, l, f, g) {
      var C = sE(l), S = sE(s);
      if (S !== C && (g && (Ao || (Ao = !0, o('Text content did not match. Server: "%s" Client: "%s"', S, C))), f && We))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function kV(s) {
      return s.nodeType === Qo ? s : s.ownerDocument;
    }
    function x7() {
    }
    function uE(s) {
      s.onclick = x7;
    }
    function S7(s, l, f, g, C) {
      for (var S in g)
        if (g.hasOwnProperty(S)) {
          var T = g[S];
          if (S === kf)
            T && Object.freeze(T), n0(l, T);
          else if (S === gC) {
            var O = T ? T[nE] : void 0;
            O != null && jS(l, O);
          } else if (S === Mf)
            if (typeof T == "string") {
              var M = s !== "textarea" || T !== "";
              M && cv(l, T);
            } else
              typeof T == "number" && cv(l, "" + T);
          else
            S === rE || S === Gc || S === OV || (yt.hasOwnProperty(S) ? T != null && (typeof T != "function" && oE(S, T), S === "onScroll" && Ar("scroll", l)) : T != null && Ua(l, S, T, C));
        }
    }
    function E7(s, l, f, g) {
      for (var C = 0; C < l.length; C += 2) {
        var S = l[C], T = l[C + 1];
        S === kf ? n0(s, T) : S === gC ? jS(s, T) : S === Mf ? cv(s, T) : Ua(s, S, T, g);
      }
    }
    function b7(s, l, f, g) {
      var C, S = kV(f), T, O = g;
      if (O === el && (O = uv(s)), O === el) {
        if (C = il(s, l), !C && s !== s.toLowerCase() && o("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", s), s === "script") {
          var M = S.createElement("div");
          M.innerHTML = "<script><\/script>";
          var V = M.firstChild;
          T = M.removeChild(V);
        } else if (typeof l.is == "string")
          T = S.createElement(s, {
            is: l.is
          });
        else if (T = S.createElement(s), s === "select") {
          var H = T;
          l.multiple ? H.multiple = !0 : l.size && (H.size = l.size);
        }
      } else
        T = S.createElementNS(O, s);
      return O === el && !C && Object.prototype.toString.call(T) === "[object HTMLUnknownElement]" && !si.call(kD, s) && (kD[s] = !0, o("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", s)), T;
    }
    function w7(s, l) {
      return kV(l).createTextNode(s);
    }
    function T7(s, l, f, g) {
      var C = il(l, f);
      aE(l, f);
      var S;
      switch (l) {
        case "dialog":
          Ar("cancel", s), Ar("close", s), S = f;
          break;
        case "iframe":
        case "object":
        case "embed":
          Ar("load", s), S = f;
          break;
        case "video":
        case "audio":
          for (var T = 0; T < fC.length; T++)
            Ar(fC[T], s);
          S = f;
          break;
        case "source":
          Ar("error", s), S = f;
          break;
        case "img":
        case "image":
        case "link":
          Ar("error", s), Ar("load", s), S = f;
          break;
        case "details":
          Ar("toggle", s), S = f;
          break;
        case "input":
          Xh(s, f), S = qh(s, f), Ar("invalid", s);
          break;
        case "option":
          sv(s, f), S = f;
          break;
        case "select":
          WS(s, f), S = r_(s, f), Ar("invalid", s);
          break;
        case "textarea":
          US(s, f), S = a_(s, f), Ar("invalid", s);
          break;
        default:
          S = f;
      }
      switch (fv(l, S), S7(l, s, g, S, C), l) {
        case "input":
          Uu(s), Qh(s, f, !1);
          break;
        case "textarea":
          Uu(s), KS(s);
          break;
        case "option":
          i_(s, f);
          break;
        case "select":
          GI(s, f);
          break;
        default:
          typeof S.onClick == "function" && uE(s);
          break;
      }
    }
    function I7(s, l, f, g, C) {
      aE(l, g);
      var S = null, T, O;
      switch (l) {
        case "input":
          T = qh(s, f), O = qh(s, g), S = [];
          break;
        case "select":
          T = r_(s, f), O = r_(s, g), S = [];
          break;
        case "textarea":
          T = a_(s, f), O = a_(s, g), S = [];
          break;
        default:
          T = f, O = g, typeof T.onClick != "function" && typeof O.onClick == "function" && uE(s);
          break;
      }
      fv(l, O);
      var M, V, H = null;
      for (M in T)
        if (!(O.hasOwnProperty(M) || !T.hasOwnProperty(M) || T[M] == null))
          if (M === kf) {
            var J = T[M];
            for (V in J)
              J.hasOwnProperty(V) && (H || (H = {}), H[V] = "");
          } else
            M === gC || M === Mf || M === rE || M === Gc || M === OV || (yt.hasOwnProperty(M) ? S || (S = []) : (S = S || []).push(M, null));
      for (M in O) {
        var Q = O[M], fe = T != null ? T[M] : void 0;
        if (!(!O.hasOwnProperty(M) || Q === fe || Q == null && fe == null))
          if (M === kf)
            if (Q && Object.freeze(Q), fe) {
              for (V in fe)
                fe.hasOwnProperty(V) && (!Q || !Q.hasOwnProperty(V)) && (H || (H = {}), H[V] = "");
              for (V in Q)
                Q.hasOwnProperty(V) && fe[V] !== Q[V] && (H || (H = {}), H[V] = Q[V]);
            } else
              H || (S || (S = []), S.push(M, H)), H = Q;
          else if (M === gC) {
            var ce = Q ? Q[nE] : void 0, me = fe ? fe[nE] : void 0;
            ce != null && me !== ce && (S = S || []).push(M, ce);
          } else
            M === Mf ? (typeof Q == "string" || typeof Q == "number") && (S = S || []).push(M, "" + Q) : M === rE || M === Gc || (yt.hasOwnProperty(M) ? (Q != null && (typeof Q != "function" && oE(M, Q), M === "onScroll" && Ar("scroll", s)), !S && fe !== Q && (S = [])) : (S = S || []).push(M, Q));
      }
      return H && (ef(H, O[kf]), (S = S || []).push(kf, H)), S;
    }
    function D7(s, l, f, g, C) {
      f === "input" && C.type === "radio" && C.name != null && t_(s, C);
      var S = il(f, g), T = il(f, C);
      switch (E7(s, l, S, T), f) {
        case "input":
          fc(s, C);
          break;
        case "textarea":
          GS(s, C);
          break;
        case "select":
          KI(s, C);
          break;
      }
    }
    function A7(s) {
      {
        var l = s.toLowerCase();
        return pv.hasOwnProperty(l) && pv[l] || null;
      }
    }
    function O7(s, l, f, g, C, S, T) {
      var O, M;
      switch (O = il(l, f), aE(l, f), l) {
        case "dialog":
          Ar("cancel", s), Ar("close", s);
          break;
        case "iframe":
        case "object":
        case "embed":
          Ar("load", s);
          break;
        case "video":
        case "audio":
          for (var V = 0; V < fC.length; V++)
            Ar(fC[V], s);
          break;
        case "source":
          Ar("error", s);
          break;
        case "img":
        case "image":
        case "link":
          Ar("error", s), Ar("load", s);
          break;
        case "details":
          Ar("toggle", s);
          break;
        case "input":
          Xh(s, f), Ar("invalid", s);
          break;
        case "option":
          sv(s, f);
          break;
        case "select":
          WS(s, f), Ar("invalid", s);
          break;
        case "textarea":
          US(s, f), Ar("invalid", s);
          break;
      }
      fv(l, f);
      {
        M = /* @__PURE__ */ new Set();
        for (var H = s.attributes, J = 0; J < H.length; J++) {
          var Q = H[J].name.toLowerCase();
          switch (Q) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              M.add(H[J].name);
          }
        }
      }
      var fe = null;
      for (var ce in f)
        if (f.hasOwnProperty(ce)) {
          var me = f[ce];
          if (ce === Mf)
            typeof me == "string" ? s.textContent !== me && (f[Gc] !== !0 && lE(s.textContent, me, S, T), fe = [Mf, me]) : typeof me == "number" && s.textContent !== "" + me && (f[Gc] !== !0 && lE(s.textContent, me, S, T), fe = [Mf, "" + me]);
          else if (yt.hasOwnProperty(ce))
            me != null && (typeof me != "function" && oE(ce, me), ce === "onScroll" && Ar("scroll", s));
          else if (T && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof O == "boolean") {
            var lt = void 0, Mt = O && ze ? null : ur(ce);
            if (f[Gc] !== !0) {
              if (!(ce === rE || ce === Gc || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              ce === "value" || ce === "checked" || ce === "selected")) {
                if (ce === gC) {
                  var Tt = s.innerHTML, vi = me ? me[nE] : void 0;
                  if (vi != null) {
                    var gi = MV(s, vi);
                    gi !== Tt && mC(ce, Tt, gi);
                  }
                } else if (ce === kf) {
                  if (M.delete(ce), LV) {
                    var se = eD(me);
                    lt = s.getAttribute("style"), se !== lt && mC(ce, lt, se);
                  }
                } else if (O && !ze)
                  M.delete(ce.toLowerCase()), lt = Qs(s, ce, me), me !== lt && mC(ce, lt, me);
                else if (!Br(ce, Mt, O) && !Lr(ce, me, Mt, O)) {
                  var Se = !1;
                  if (Mt !== null)
                    M.delete(Mt.attributeName), lt = _s(s, ce, me, Mt);
                  else {
                    var le = g;
                    if (le === el && (le = uv(l)), le === el)
                      M.delete(ce.toLowerCase());
                    else {
                      var He = A7(ce);
                      He !== null && He !== ce && (Se = !0, M.delete(He)), M.delete(ce);
                    }
                    lt = Qs(s, ce, me);
                  }
                  var pt = ze;
                  !pt && me !== lt && !Se && mC(ce, lt, me);
                }
              }
            }
          }
        }
      switch (T && // $FlowFixMe - Should be inferred as not undefined.
      M.size > 0 && f[Gc] !== !0 && RV(M), l) {
        case "input":
          Uu(s), Qh(s, f, !0);
          break;
        case "textarea":
          Uu(s), KS(s);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof f.onClick == "function" && uE(s);
          break;
      }
      return fe;
    }
    function R7(s, l, f) {
      var g = s.nodeValue !== l;
      return g;
    }
    function PD(s, l) {
      {
        if (Ao)
          return;
        Ao = !0, o("Did not expect server HTML to contain a <%s> in <%s>.", l.nodeName.toLowerCase(), s.nodeName.toLowerCase());
      }
    }
    function FD(s, l) {
      {
        if (Ao)
          return;
        Ao = !0, o('Did not expect server HTML to contain the text node "%s" in <%s>.', l.nodeValue, s.nodeName.toLowerCase());
      }
    }
    function BD(s, l, f) {
      {
        if (Ao)
          return;
        Ao = !0, o("Expected server HTML to contain a matching <%s> in <%s>.", l, s.nodeName.toLowerCase());
      }
    }
    function VD(s, l) {
      {
        if (l === "" || Ao)
          return;
        Ao = !0, o('Expected server HTML to contain a matching text node for "%s" in <%s>.', l, s.nodeName.toLowerCase());
      }
    }
    function L7(s, l, f) {
      switch (l) {
        case "input":
          NS(s, f);
          return;
        case "textarea":
          o_(s, f);
          return;
        case "select":
          jI(s, f);
          return;
      }
    }
    var _C = function() {
    }, CC = function() {
    };
    {
      var M7 = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], PV = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], k7 = PV.concat(["button"]), P7 = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], FV = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      CC = function(s, l) {
        var f = fi({}, s || FV), g = {
          tag: l
        };
        return PV.indexOf(l) !== -1 && (f.aTagInScope = null, f.buttonTagInScope = null, f.nobrTagInScope = null), k7.indexOf(l) !== -1 && (f.pTagInButtonScope = null), M7.indexOf(l) !== -1 && l !== "address" && l !== "div" && l !== "p" && (f.listItemTagAutoclosing = null, f.dlItemTagAutoclosing = null), f.current = g, l === "form" && (f.formTag = g), l === "a" && (f.aTagInScope = g), l === "button" && (f.buttonTagInScope = g), l === "nobr" && (f.nobrTagInScope = g), l === "p" && (f.pTagInButtonScope = g), l === "li" && (f.listItemTagAutoclosing = g), (l === "dd" || l === "dt") && (f.dlItemTagAutoclosing = g), f;
      };
      var F7 = function(s, l) {
        switch (l) {
          case "select":
            return s === "option" || s === "optgroup" || s === "#text";
          case "optgroup":
            return s === "option" || s === "#text";
          case "option":
            return s === "#text";
          case "tr":
            return s === "th" || s === "td" || s === "style" || s === "script" || s === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return s === "tr" || s === "style" || s === "script" || s === "template";
          case "colgroup":
            return s === "col" || s === "template";
          case "table":
            return s === "caption" || s === "colgroup" || s === "tbody" || s === "tfoot" || s === "thead" || s === "style" || s === "script" || s === "template";
          case "head":
            return s === "base" || s === "basefont" || s === "bgsound" || s === "link" || s === "meta" || s === "title" || s === "noscript" || s === "noframes" || s === "style" || s === "script" || s === "template";
          case "html":
            return s === "head" || s === "body" || s === "frameset";
          case "frameset":
            return s === "frame";
          case "#document":
            return s === "html";
        }
        switch (s) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return l !== "h1" && l !== "h2" && l !== "h3" && l !== "h4" && l !== "h5" && l !== "h6";
          case "rp":
          case "rt":
            return P7.indexOf(l) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return l == null;
        }
        return !0;
      }, B7 = function(s, l) {
        switch (s) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return l.pTagInButtonScope;
          case "form":
            return l.formTag || l.pTagInButtonScope;
          case "li":
            return l.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return l.dlItemTagAutoclosing;
          case "button":
            return l.buttonTagInScope;
          case "a":
            return l.aTagInScope;
          case "nobr":
            return l.nobrTagInScope;
        }
        return null;
      }, BV = {};
      _C = function(s, l, f) {
        f = f || FV;
        var g = f.current, C = g && g.tag;
        l != null && (s != null && o("validateDOMNesting: when childText is passed, childTag should be null"), s = "#text");
        var S = F7(s, C) ? null : g, T = S ? null : B7(s, f), O = S || T;
        if (O) {
          var M = O.tag, V = !!S + "|" + s + "|" + M;
          if (!BV[V]) {
            BV[V] = !0;
            var H = s, J = "";
            if (s === "#text" ? /\S/.test(l) ? H = "Text nodes" : (H = "Whitespace text nodes", J = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : H = "<" + s + ">", S) {
              var Q = "";
              M === "table" && s === "tr" && (Q += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), o("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", H, M, J, Q);
            } else
              o("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", H, M);
          }
        }
      };
    }
    var dE = "suppressHydrationWarning", cE = "$", hE = "/$", yC = "$?", xC = "$!", V7 = "style", ND = null, HD = null;
    function N7(s) {
      var l, f, g = s.nodeType;
      switch (g) {
        case Qo:
        case Gu: {
          l = g === Qo ? "#document" : "#fragment";
          var C = s.documentElement;
          f = C ? C.namespaceURI : l_(null, "");
          break;
        }
        default: {
          var S = g === Gr ? s.parentNode : s, T = S.namespaceURI || null;
          l = S.tagName, f = l_(T, l);
          break;
        }
      }
      {
        var O = l.toLowerCase(), M = CC(null, O);
        return {
          namespace: f,
          ancestorInfo: M
        };
      }
    }
    function H7(s, l, f) {
      {
        var g = s, C = l_(g.namespace, l), S = CC(g.ancestorInfo, l);
        return {
          namespace: C,
          ancestorInfo: S
        };
      }
    }
    function XBe(s) {
      return s;
    }
    function $7(s) {
      ND = Qa(), HD = t7();
      var l = null;
      return gn(!1), l;
    }
    function z7(s) {
      i7(HD), gn(ND), ND = null, HD = null;
    }
    function W7(s, l, f, g, C) {
      var S;
      {
        var T = g;
        if (_C(s, null, T.ancestorInfo), typeof l.children == "string" || typeof l.children == "number") {
          var O = "" + l.children, M = CC(T.ancestorInfo, s);
          _C(null, O, M);
        }
        S = T.namespace;
      }
      var V = b7(s, l, f, S);
      return bC(C, V), YD(V, l), V;
    }
    function U7(s, l) {
      s.appendChild(l);
    }
    function G7(s, l, f, g, C) {
      switch (T7(s, l, f, g), l) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!f.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function K7(s, l, f, g, C, S) {
      {
        var T = S;
        if (typeof g.children != typeof f.children && (typeof g.children == "string" || typeof g.children == "number")) {
          var O = "" + g.children, M = CC(T.ancestorInfo, l);
          _C(null, O, M);
        }
      }
      return I7(s, l, f, g);
    }
    function $D(s, l) {
      return s === "textarea" || s === "noscript" || typeof l.children == "string" || typeof l.children == "number" || typeof l.dangerouslySetInnerHTML == "object" && l.dangerouslySetInnerHTML !== null && l.dangerouslySetInnerHTML.__html != null;
    }
    function j7(s, l, f, g) {
      {
        var C = f;
        _C(null, s, C.ancestorInfo);
      }
      var S = w7(s, l);
      return bC(g, S), S;
    }
    function Y7() {
      var s = window.event;
      return s === void 0 ? cl : na(s.type);
    }
    var zD = typeof setTimeout == "function" ? setTimeout : void 0, q7 = typeof clearTimeout == "function" ? clearTimeout : void 0, WD = -1, VV = typeof Promise == "function" ? Promise : void 0, X7 = typeof queueMicrotask == "function" ? queueMicrotask : typeof VV < "u" ? function(s) {
      return VV.resolve(null).then(s).catch(Q7);
    } : zD;
    function Q7(s) {
      setTimeout(function() {
        throw s;
      });
    }
    function Z7(s, l, f, g) {
      switch (l) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          f.autoFocus && s.focus();
          return;
        case "img": {
          f.src && (s.src = f.src);
          return;
        }
      }
    }
    function J7(s, l, f, g, C, S) {
      D7(s, l, f, g, C), YD(s, C);
    }
    function NV(s) {
      cv(s, "");
    }
    function eQ(s, l, f) {
      s.nodeValue = f;
    }
    function tQ(s, l) {
      s.appendChild(l);
    }
    function iQ(s, l) {
      var f;
      s.nodeType === Gr ? (f = s.parentNode, f.insertBefore(l, s)) : (f = s, f.appendChild(l));
      var g = s._reactRootContainer;
      g == null && f.onclick === null && uE(f);
    }
    function rQ(s, l, f) {
      s.insertBefore(l, f);
    }
    function nQ(s, l, f) {
      s.nodeType === Gr ? s.parentNode.insertBefore(l, f) : s.insertBefore(l, f);
    }
    function aQ(s, l) {
      s.removeChild(l);
    }
    function oQ(s, l) {
      s.nodeType === Gr ? s.parentNode.removeChild(l) : s.removeChild(l);
    }
    function UD(s, l) {
      var f = l, g = 0;
      do {
        var C = f.nextSibling;
        if (s.removeChild(f), C && C.nodeType === Gr) {
          var S = C.data;
          if (S === hE)
            if (g === 0) {
              s.removeChild(C), pi(l);
              return;
            } else
              g--;
          else
            (S === cE || S === yC || S === xC) && g++;
        }
        f = C;
      } while (f);
      pi(l);
    }
    function sQ(s, l) {
      s.nodeType === Gr ? UD(s.parentNode, l) : s.nodeType === Sa && UD(s, l), pi(s);
    }
    function lQ(s) {
      s = s;
      var l = s.style;
      typeof l.setProperty == "function" ? l.setProperty("display", "none", "important") : l.display = "none";
    }
    function uQ(s) {
      s.nodeValue = "";
    }
    function dQ(s, l) {
      s = s;
      var f = l[V7], g = f != null && f.hasOwnProperty("display") ? f.display : null;
      s.style.display = hv("display", g);
    }
    function cQ(s, l) {
      s.nodeValue = l;
    }
    function hQ(s) {
      s.nodeType === Sa ? s.textContent = "" : s.nodeType === Qo && s.documentElement && s.removeChild(s.documentElement);
    }
    function fQ(s, l, f) {
      return s.nodeType !== Sa || l.toLowerCase() !== s.nodeName.toLowerCase() ? null : s;
    }
    function pQ(s, l) {
      return l === "" || s.nodeType !== tl ? null : s;
    }
    function vQ(s) {
      return s.nodeType !== Gr ? null : s;
    }
    function HV(s) {
      return s.data === yC;
    }
    function GD(s) {
      return s.data === xC;
    }
    function gQ(s) {
      var l = s.nextSibling && s.nextSibling.dataset, f, g, C;
      return l && (f = l.dgst, g = l.msg, C = l.stck), {
        message: g,
        digest: f,
        stack: C
      };
    }
    function mQ(s, l) {
      s._reactRetry = l;
    }
    function fE(s) {
      for (; s != null; s = s.nextSibling) {
        var l = s.nodeType;
        if (l === Sa || l === tl)
          break;
        if (l === Gr) {
          var f = s.data;
          if (f === cE || f === xC || f === yC)
            break;
          if (f === hE)
            return null;
        }
      }
      return s;
    }
    function SC(s) {
      return fE(s.nextSibling);
    }
    function _Q(s) {
      return fE(s.firstChild);
    }
    function CQ(s) {
      return fE(s.firstChild);
    }
    function yQ(s) {
      return fE(s.nextSibling);
    }
    function xQ(s, l, f, g, C, S, T) {
      bC(S, s), YD(s, f);
      var O;
      {
        var M = C;
        O = M.namespace;
      }
      var V = (S.mode & li) !== Ft;
      return O7(s, l, f, O, g, V, T);
    }
    function SQ(s, l, f, g) {
      bC(f, s);
      var C = (f.mode & li) !== Ft;
      return R7(s, l);
    }
    function EQ(s, l) {
      bC(l, s);
    }
    function bQ(s) {
      for (var l = s.nextSibling, f = 0; l; ) {
        if (l.nodeType === Gr) {
          var g = l.data;
          if (g === hE) {
            if (f === 0)
              return SC(l);
            f--;
          } else
            (g === cE || g === xC || g === yC) && f++;
        }
        l = l.nextSibling;
      }
      return null;
    }
    function $V(s) {
      for (var l = s.previousSibling, f = 0; l; ) {
        if (l.nodeType === Gr) {
          var g = l.data;
          if (g === cE || g === xC || g === yC) {
            if (f === 0)
              return l;
            f--;
          } else
            g === hE && f++;
        }
        l = l.previousSibling;
      }
      return null;
    }
    function wQ(s) {
      pi(s);
    }
    function TQ(s) {
      pi(s);
    }
    function IQ(s) {
      return s !== "head" && s !== "body";
    }
    function DQ(s, l, f, g) {
      var C = !0;
      lE(l.nodeValue, f, g, C);
    }
    function AQ(s, l, f, g, C, S) {
      if (l[dE] !== !0) {
        var T = !0;
        lE(g.nodeValue, C, S, T);
      }
    }
    function OQ(s, l) {
      l.nodeType === Sa ? PD(s, l) : l.nodeType === Gr || FD(s, l);
    }
    function RQ(s, l) {
      {
        var f = s.parentNode;
        f !== null && (l.nodeType === Sa ? PD(f, l) : l.nodeType === Gr || FD(f, l));
      }
    }
    function LQ(s, l, f, g, C) {
      (C || l[dE] !== !0) && (g.nodeType === Sa ? PD(f, g) : g.nodeType === Gr || FD(f, g));
    }
    function MQ(s, l, f) {
      BD(s, l);
    }
    function kQ(s, l) {
      VD(s, l);
    }
    function PQ(s, l, f) {
      {
        var g = s.parentNode;
        g !== null && BD(g, l);
      }
    }
    function FQ(s, l) {
      {
        var f = s.parentNode;
        f !== null && VD(f, l);
      }
    }
    function BQ(s, l, f, g, C, S) {
      (S || l[dE] !== !0) && BD(f, g);
    }
    function VQ(s, l, f, g, C) {
      (C || l[dE] !== !0) && VD(f, g);
    }
    function NQ(s) {
      o("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", s.nodeName.toLowerCase());
    }
    function HQ(s) {
      pC(s);
    }
    var _g = Math.random().toString(36).slice(2), Cg = "__reactFiber$" + _g, KD = "__reactProps$" + _g, EC = "__reactContainer$" + _g, jD = "__reactEvents$" + _g, $Q = "__reactListeners$" + _g, zQ = "__reactHandles$" + _g;
    function WQ(s) {
      delete s[Cg], delete s[KD], delete s[jD], delete s[$Q], delete s[zQ];
    }
    function bC(s, l) {
      l[Cg] = s;
    }
    function pE(s, l) {
      l[EC] = s;
    }
    function zV(s) {
      s[EC] = null;
    }
    function wC(s) {
      return !!s[EC];
    }
    function Pf(s) {
      var l = s[Cg];
      if (l)
        return l;
      for (var f = s.parentNode; f; ) {
        if (l = f[EC] || f[Cg], l) {
          var g = l.alternate;
          if (l.child !== null || g !== null && g.child !== null)
            for (var C = $V(s); C !== null; ) {
              var S = C[Cg];
              if (S)
                return S;
              C = $V(C);
            }
          return l;
        }
        s = f, f = s.parentNode;
      }
      return null;
    }
    function Kc(s) {
      var l = s[Cg] || s[EC];
      return l && (l.tag === b || l.tag === I || l.tag === z || l.tag === _) ? l : null;
    }
    function yg(s) {
      if (s.tag === b || s.tag === I)
        return s.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function vE(s) {
      return s[KD] || null;
    }
    function YD(s, l) {
      s[KD] = l;
    }
    function UQ(s) {
      var l = s[jD];
      return l === void 0 && (l = s[jD] = /* @__PURE__ */ new Set()), l;
    }
    var WV = {}, UV = i.ReactDebugCurrentFrame;
    function gE(s) {
      if (s) {
        var l = s._owner, f = Wh(s.type, s._source, l ? l.type : null);
        UV.setExtraStackFrame(f);
      } else
        UV.setExtraStackFrame(null);
    }
    function gl(s, l, f, g, C) {
      {
        var S = Function.call.bind(si);
        for (var T in s)
          if (S(s, T)) {
            var O = void 0;
            try {
              if (typeof s[T] != "function") {
                var M = Error((g || "React class") + ": " + f + " type `" + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[T] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw M.name = "Invariant Violation", M;
              }
              O = s[T](l, T, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              O = V;
            }
            O && !(O instanceof Error) && (gE(C), o("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, T, typeof O), gE(null)), O instanceof Error && !(O.message in WV) && (WV[O.message] = !0, gE(C), o("Failed %s type: %s", f, O.message), gE(null));
          }
      }
    }
    var qD = [], mE;
    mE = [];
    var Cd = -1;
    function jc(s) {
      return {
        current: s
      };
    }
    function Ra(s, l) {
      if (Cd < 0) {
        o("Unexpected pop.");
        return;
      }
      l !== mE[Cd] && o("Unexpected Fiber popped."), s.current = qD[Cd], qD[Cd] = null, mE[Cd] = null, Cd--;
    }
    function La(s, l, f) {
      Cd++, qD[Cd] = s.current, mE[Cd] = f, s.current = l;
    }
    var XD;
    XD = {};
    var is = {};
    Object.freeze(is);
    var yd = jc(is), lu = jc(!1), QD = is;
    function xg(s, l, f) {
      return f && uu(l) ? QD : yd.current;
    }
    function GV(s, l, f) {
      {
        var g = s.stateNode;
        g.__reactInternalMemoizedUnmaskedChildContext = l, g.__reactInternalMemoizedMaskedChildContext = f;
      }
    }
    function Sg(s, l) {
      {
        var f = s.type, g = f.contextTypes;
        if (!g)
          return is;
        var C = s.stateNode;
        if (C && C.__reactInternalMemoizedUnmaskedChildContext === l)
          return C.__reactInternalMemoizedMaskedChildContext;
        var S = {};
        for (var T in g)
          S[T] = l[T];
        {
          var O = Jt(s) || "Unknown";
          gl(g, S, "context", O);
        }
        return C && GV(s, l, S), S;
      }
    }
    function _E() {
      return lu.current;
    }
    function uu(s) {
      {
        var l = s.childContextTypes;
        return l != null;
      }
    }
    function CE(s) {
      Ra(lu, s), Ra(yd, s);
    }
    function ZD(s) {
      Ra(lu, s), Ra(yd, s);
    }
    function KV(s, l, f) {
      {
        if (yd.current !== is)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        La(yd, l, s), La(lu, f, s);
      }
    }
    function jV(s, l, f) {
      {
        var g = s.stateNode, C = l.childContextTypes;
        if (typeof g.getChildContext != "function") {
          {
            var S = Jt(s) || "Unknown";
            XD[S] || (XD[S] = !0, o("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", S, S));
          }
          return f;
        }
        var T = g.getChildContext();
        for (var O in T)
          if (!(O in C))
            throw new Error((Jt(s) || "Unknown") + '.getChildContext(): key "' + O + '" is not defined in childContextTypes.');
        {
          var M = Jt(s) || "Unknown";
          gl(C, T, "child context", M);
        }
        return fi({}, f, T);
      }
    }
    function yE(s) {
      {
        var l = s.stateNode, f = l && l.__reactInternalMemoizedMergedChildContext || is;
        return QD = yd.current, La(yd, f, s), La(lu, lu.current, s), !0;
      }
    }
    function YV(s, l, f) {
      {
        var g = s.stateNode;
        if (!g)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (f) {
          var C = jV(s, l, QD);
          g.__reactInternalMemoizedMergedChildContext = C, Ra(lu, s), Ra(yd, s), La(yd, C, s), La(lu, f, s);
        } else
          Ra(lu, s), La(lu, f, s);
      }
    }
    function GQ(s) {
      {
        if (!D_(s) || s.tag !== p)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var l = s;
        do {
          switch (l.tag) {
            case _:
              return l.stateNode.context;
            case p: {
              var f = l.type;
              if (uu(f))
                return l.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          l = l.return;
        } while (l !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Yc = 0, xE = 1, xd = null, JD = !1, eA = !1;
    function qV(s) {
      xd === null ? xd = [s] : xd.push(s);
    }
    function KQ(s) {
      JD = !0, qV(s);
    }
    function XV() {
      JD && qc();
    }
    function qc() {
      if (!eA && xd !== null) {
        eA = !0;
        var s = 0, l = wo();
        try {
          var f = !0, g = xd;
          for (an(Kn); s < g.length; s++) {
            var C = g[s];
            do
              C = C(f);
            while (C !== null);
          }
          xd = null, JD = !1;
        } catch (S) {
          throw xd !== null && (xd = xd.slice(s + 1)), Ev(wv, qc), S;
        } finally {
          an(l), eA = !1;
        }
      }
      return null;
    }
    var Eg = [], bg = 0, SE = null, EE = 0, Is = [], Ds = 0, Ff = null, Sd = 1, Ed = "";
    function jQ(s) {
      return Vf(), (s.flags & w_) !== Lt;
    }
    function YQ(s) {
      return Vf(), EE;
    }
    function qQ() {
      var s = Ed, l = Sd, f = l & ~XQ(l);
      return f.toString(32) + s;
    }
    function Bf(s, l) {
      Vf(), Eg[bg++] = EE, Eg[bg++] = SE, SE = s, EE = l;
    }
    function QV(s, l, f) {
      Vf(), Is[Ds++] = Sd, Is[Ds++] = Ed, Is[Ds++] = Ff, Ff = s;
      var g = Sd, C = Ed, S = bE(g) - 1, T = g & ~(1 << S), O = f + 1, M = bE(l) + S;
      if (M > 30) {
        var V = S - S % 5, H = (1 << V) - 1, J = (T & H).toString(32), Q = T >> V, fe = S - V, ce = bE(l) + fe, me = O << fe, lt = me | Q, Mt = J + C;
        Sd = 1 << ce | lt, Ed = Mt;
      } else {
        var Tt = O << S, vi = Tt | T, gi = C;
        Sd = 1 << M | vi, Ed = gi;
      }
    }
    function tA(s) {
      Vf();
      var l = s.return;
      if (l !== null) {
        var f = 1, g = 0;
        Bf(s, f), QV(s, f, g);
      }
    }
    function bE(s) {
      return 32 - Rv(s);
    }
    function XQ(s) {
      return 1 << bE(s) - 1;
    }
    function iA(s) {
      for (; s === SE; )
        SE = Eg[--bg], Eg[bg] = null, EE = Eg[--bg], Eg[bg] = null;
      for (; s === Ff; )
        Ff = Is[--Ds], Is[Ds] = null, Ed = Is[--Ds], Is[Ds] = null, Sd = Is[--Ds], Is[Ds] = null;
    }
    function QQ() {
      return Vf(), Ff !== null ? {
        id: Sd,
        overflow: Ed
      } : null;
    }
    function ZQ(s, l) {
      Vf(), Is[Ds++] = Sd, Is[Ds++] = Ed, Is[Ds++] = Ff, Sd = l.id, Ed = l.overflow, Ff = s;
    }
    function Vf() {
      oa() || o("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var aa = null, As = null, ml = !1, Nf = !1, Xc = null;
    function JQ() {
      ml && o("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function ZV() {
      Nf = !0;
    }
    function eZ() {
      return Nf;
    }
    function tZ(s) {
      var l = s.stateNode.containerInfo;
      return As = CQ(l), aa = s, ml = !0, Xc = null, Nf = !1, !0;
    }
    function iZ(s, l, f) {
      return As = yQ(l), aa = s, ml = !0, Xc = null, Nf = !1, f !== null && ZQ(s, f), !0;
    }
    function JV(s, l) {
      switch (s.tag) {
        case _: {
          OQ(s.stateNode.containerInfo, l);
          break;
        }
        case b: {
          var f = (s.mode & li) !== Ft;
          LQ(
            s.type,
            s.memoizedProps,
            s.stateNode,
            l,
            // TODO: Delete this argument when we remove the legacy root API.
            f
          );
          break;
        }
        case z: {
          var g = s.memoizedState;
          g.dehydrated !== null && RQ(g.dehydrated, l);
          break;
        }
      }
    }
    function e1(s, l) {
      JV(s, l);
      var f = dte();
      f.stateNode = l, f.return = s;
      var g = s.deletions;
      g === null ? (s.deletions = [f], s.flags |= Fi) : g.push(f);
    }
    function rA(s, l) {
      {
        if (Nf)
          return;
        switch (s.tag) {
          case _: {
            var f = s.stateNode.containerInfo;
            switch (l.tag) {
              case b:
                var g = l.type, C = l.pendingProps;
                MQ(f, g);
                break;
              case I:
                var S = l.pendingProps;
                kQ(f, S);
                break;
            }
            break;
          }
          case b: {
            var T = s.type, O = s.memoizedProps, M = s.stateNode;
            switch (l.tag) {
              case b: {
                var V = l.type, H = l.pendingProps, J = (s.mode & li) !== Ft;
                BQ(
                  T,
                  O,
                  M,
                  V,
                  H,
                  // TODO: Delete this argument when we remove the legacy root API.
                  J
                );
                break;
              }
              case I: {
                var Q = l.pendingProps, fe = (s.mode & li) !== Ft;
                VQ(
                  T,
                  O,
                  M,
                  Q,
                  // TODO: Delete this argument when we remove the legacy root API.
                  fe
                );
                break;
              }
            }
            break;
          }
          case z: {
            var ce = s.memoizedState, me = ce.dehydrated;
            if (me !== null)
              switch (l.tag) {
                case b:
                  var lt = l.type, Mt = l.pendingProps;
                  PQ(me, lt);
                  break;
                case I:
                  var Tt = l.pendingProps;
                  FQ(me, Tt);
                  break;
              }
            break;
          }
          default:
            return;
        }
      }
    }
    function t1(s, l) {
      l.flags = l.flags & ~yo | vr, rA(s, l);
    }
    function i1(s, l) {
      switch (s.tag) {
        case b: {
          var f = s.type, g = s.pendingProps, C = fQ(l, f);
          return C !== null ? (s.stateNode = C, aa = s, As = _Q(C), !0) : !1;
        }
        case I: {
          var S = s.pendingProps, T = pQ(l, S);
          return T !== null ? (s.stateNode = T, aa = s, As = null, !0) : !1;
        }
        case z: {
          var O = vQ(l);
          if (O !== null) {
            var M = {
              dehydrated: O,
              treeContext: QQ(),
              retryLane: Aa
            };
            s.memoizedState = M;
            var V = cte(O);
            return V.return = s, s.child = V, aa = s, As = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function nA(s) {
      return (s.mode & li) !== Ft && (s.flags & Gt) === Lt;
    }
    function aA(s) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function oA(s) {
      if (ml) {
        var l = As;
        if (!l) {
          nA(s) && (rA(aa, s), aA()), t1(aa, s), ml = !1, aa = s;
          return;
        }
        var f = l;
        if (!i1(s, l)) {
          nA(s) && (rA(aa, s), aA()), l = SC(f);
          var g = aa;
          if (!l || !i1(s, l)) {
            t1(aa, s), ml = !1, aa = s;
            return;
          }
          e1(g, f);
        }
      }
    }
    function rZ(s, l, f) {
      var g = s.stateNode, C = !Nf, S = xQ(g, s.type, s.memoizedProps, l, f, s, C);
      return s.updateQueue = S, S !== null;
    }
    function nZ(s) {
      var l = s.stateNode, f = s.memoizedProps, g = SQ(l, f, s);
      if (g) {
        var C = aa;
        if (C !== null)
          switch (C.tag) {
            case _: {
              var S = C.stateNode.containerInfo, T = (C.mode & li) !== Ft;
              DQ(
                S,
                l,
                f,
                // TODO: Delete this argument when we remove the legacy root API.
                T
              );
              break;
            }
            case b: {
              var O = C.type, M = C.memoizedProps, V = C.stateNode, H = (C.mode & li) !== Ft;
              AQ(
                O,
                M,
                V,
                l,
                f,
                // TODO: Delete this argument when we remove the legacy root API.
                H
              );
              break;
            }
          }
      }
      return g;
    }
    function aZ(s) {
      var l = s.memoizedState, f = l !== null ? l.dehydrated : null;
      if (!f)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      EQ(f, s);
    }
    function oZ(s) {
      var l = s.memoizedState, f = l !== null ? l.dehydrated : null;
      if (!f)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return bQ(f);
    }
    function r1(s) {
      for (var l = s.return; l !== null && l.tag !== b && l.tag !== _ && l.tag !== z; )
        l = l.return;
      aa = l;
    }
    function wE(s) {
      if (s !== aa)
        return !1;
      if (!ml)
        return r1(s), ml = !0, !1;
      if (s.tag !== _ && (s.tag !== b || IQ(s.type) && !$D(s.type, s.memoizedProps))) {
        var l = As;
        if (l)
          if (nA(s))
            n1(s), aA();
          else
            for (; l; )
              e1(s, l), l = SC(l);
      }
      return r1(s), s.tag === z ? As = oZ(s) : As = aa ? SC(s.stateNode) : null, !0;
    }
    function sZ() {
      return ml && As !== null;
    }
    function n1(s) {
      for (var l = As; l; )
        JV(s, l), l = SC(l);
    }
    function wg() {
      aa = null, As = null, ml = !1, Nf = !1;
    }
    function a1() {
      Xc !== null && (eH(Xc), Xc = null);
    }
    function oa() {
      return ml;
    }
    function sA(s) {
      Xc === null ? Xc = [s] : Xc.push(s);
    }
    var lZ = i.ReactCurrentBatchConfig, uZ = null;
    function dZ() {
      return lZ.transition;
    }
    var _l = {
      recordUnsafeLifecycleWarnings: function(s, l) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(s, l) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var cZ = function(s) {
        for (var l = null, f = s; f !== null; )
          f.mode & Ir && (l = f), f = f.return;
        return l;
      }, Hf = function(s) {
        var l = [];
        return s.forEach(function(f) {
          l.push(f);
        }), l.sort().join(", ");
      }, TC = [], IC = [], DC = [], AC = [], OC = [], RC = [], $f = /* @__PURE__ */ new Set();
      _l.recordUnsafeLifecycleWarnings = function(s, l) {
        $f.has(s.type) || (typeof l.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        l.componentWillMount.__suppressDeprecationWarning !== !0 && TC.push(s), s.mode & Ir && typeof l.UNSAFE_componentWillMount == "function" && IC.push(s), typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && DC.push(s), s.mode & Ir && typeof l.UNSAFE_componentWillReceiveProps == "function" && AC.push(s), typeof l.componentWillUpdate == "function" && l.componentWillUpdate.__suppressDeprecationWarning !== !0 && OC.push(s), s.mode & Ir && typeof l.UNSAFE_componentWillUpdate == "function" && RC.push(s));
      }, _l.flushPendingUnsafeLifecycleWarnings = function() {
        var s = /* @__PURE__ */ new Set();
        TC.length > 0 && (TC.forEach(function(Q) {
          s.add(Jt(Q) || "Component"), $f.add(Q.type);
        }), TC = []);
        var l = /* @__PURE__ */ new Set();
        IC.length > 0 && (IC.forEach(function(Q) {
          l.add(Jt(Q) || "Component"), $f.add(Q.type);
        }), IC = []);
        var f = /* @__PURE__ */ new Set();
        DC.length > 0 && (DC.forEach(function(Q) {
          f.add(Jt(Q) || "Component"), $f.add(Q.type);
        }), DC = []);
        var g = /* @__PURE__ */ new Set();
        AC.length > 0 && (AC.forEach(function(Q) {
          g.add(Jt(Q) || "Component"), $f.add(Q.type);
        }), AC = []);
        var C = /* @__PURE__ */ new Set();
        OC.length > 0 && (OC.forEach(function(Q) {
          C.add(Jt(Q) || "Component"), $f.add(Q.type);
        }), OC = []);
        var S = /* @__PURE__ */ new Set();
        if (RC.length > 0 && (RC.forEach(function(Q) {
          S.add(Jt(Q) || "Component"), $f.add(Q.type);
        }), RC = []), l.size > 0) {
          var T = Hf(l);
          o(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, T);
        }
        if (g.size > 0) {
          var O = Hf(g);
          o(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, O);
        }
        if (S.size > 0) {
          var M = Hf(S);
          o(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, M);
        }
        if (s.size > 0) {
          var V = Hf(s);
          a(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, V);
        }
        if (f.size > 0) {
          var H = Hf(f);
          a(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, H);
        }
        if (C.size > 0) {
          var J = Hf(C);
          a(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, J);
        }
      };
      var TE = /* @__PURE__ */ new Map(), o1 = /* @__PURE__ */ new Set();
      _l.recordLegacyContextWarning = function(s, l) {
        var f = cZ(s);
        if (f === null) {
          o("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!o1.has(s.type)) {
          var g = TE.get(f);
          (s.type.contextTypes != null || s.type.childContextTypes != null || l !== null && typeof l.getChildContext == "function") && (g === void 0 && (g = [], TE.set(f, g)), g.push(s));
        }
      }, _l.flushLegacyContextWarning = function() {
        TE.forEach(function(s, l) {
          if (s.length !== 0) {
            var f = s[0], g = /* @__PURE__ */ new Set();
            s.forEach(function(S) {
              g.add(Jt(S) || "Component"), o1.add(S.type);
            });
            var C = Hf(g);
            try {
              Xi(f), o(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, C);
            } finally {
              en();
            }
          }
        });
      }, _l.discardPendingWarnings = function() {
        TC = [], IC = [], DC = [], AC = [], OC = [], RC = [], TE = /* @__PURE__ */ new Map();
      };
    }
    function Cl(s, l) {
      if (s && s.defaultProps) {
        var f = fi({}, l), g = s.defaultProps;
        for (var C in g)
          f[C] === void 0 && (f[C] = g[C]);
        return f;
      }
      return l;
    }
    var lA = jc(null), uA;
    uA = {};
    var IE = null, Tg = null, dA = null, DE = !1;
    function AE() {
      IE = null, Tg = null, dA = null, DE = !1;
    }
    function s1() {
      DE = !0;
    }
    function l1() {
      DE = !1;
    }
    function u1(s, l, f) {
      La(lA, l._currentValue, s), l._currentValue = f, l._currentRenderer !== void 0 && l._currentRenderer !== null && l._currentRenderer !== uA && o("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), l._currentRenderer = uA;
    }
    function cA(s, l) {
      var f = lA.current;
      Ra(lA, l), s._currentValue = f;
    }
    function hA(s, l, f) {
      for (var g = s; g !== null; ) {
        var C = g.alternate;
        if (ld(g.childLanes, l) ? C !== null && !ld(C.childLanes, l) && (C.childLanes = ei(C.childLanes, l)) : (g.childLanes = ei(g.childLanes, l), C !== null && (C.childLanes = ei(C.childLanes, l))), g === f)
          break;
        g = g.return;
      }
      g !== f && o("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function hZ(s, l, f) {
      fZ(s, l, f);
    }
    function fZ(s, l, f) {
      var g = s.child;
      for (g !== null && (g.return = s); g !== null; ) {
        var C = void 0, S = g.dependencies;
        if (S !== null) {
          C = g.child;
          for (var T = S.firstContext; T !== null; ) {
            if (T.context === l) {
              if (g.tag === p) {
                var O = nn(f), M = bd(nr, O);
                M.tag = RE;
                var V = g.updateQueue;
                if (V !== null) {
                  var H = V.shared, J = H.pending;
                  J === null ? M.next = M : (M.next = J.next, J.next = M), H.pending = M;
                }
              }
              g.lanes = ei(g.lanes, f);
              var Q = g.alternate;
              Q !== null && (Q.lanes = ei(Q.lanes, f)), hA(g.return, f, s), S.lanes = ei(S.lanes, f);
              break;
            }
            T = T.next;
          }
        } else if (g.tag === $)
          C = g.type === s.type ? null : g.child;
        else if (g.tag === De) {
          var fe = g.return;
          if (fe === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          fe.lanes = ei(fe.lanes, f);
          var ce = fe.alternate;
          ce !== null && (ce.lanes = ei(ce.lanes, f)), hA(fe, f, s), C = g.sibling;
        } else
          C = g.child;
        if (C !== null)
          C.return = g;
        else
          for (C = g; C !== null; ) {
            if (C === s) {
              C = null;
              break;
            }
            var me = C.sibling;
            if (me !== null) {
              me.return = C.return, C = me;
              break;
            }
            C = C.return;
          }
        g = C;
      }
    }
    function Ig(s, l) {
      IE = s, Tg = null, dA = null;
      var f = s.dependencies;
      if (f !== null) {
        var g = f.firstContext;
        g !== null && (Oa(f.lanes, l) && GC(), f.firstContext = null);
      }
    }
    function _n(s) {
      DE && o("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var l = s._currentValue;
      if (dA !== s) {
        var f = {
          context: s,
          memoizedValue: l,
          next: null
        };
        if (Tg === null) {
          if (IE === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Tg = f, IE.dependencies = {
            lanes: Te,
            firstContext: f
          };
        } else
          Tg = Tg.next = f;
      }
      return l;
    }
    var zf = null;
    function fA(s) {
      zf === null ? zf = [s] : zf.push(s);
    }
    function pZ() {
      if (zf !== null) {
        for (var s = 0; s < zf.length; s++) {
          var l = zf[s], f = l.interleaved;
          if (f !== null) {
            l.interleaved = null;
            var g = f.next, C = l.pending;
            if (C !== null) {
              var S = C.next;
              C.next = g, f.next = S;
            }
            l.pending = f;
          }
        }
        zf = null;
      }
    }
    function d1(s, l, f, g) {
      var C = l.interleaved;
      return C === null ? (f.next = f, fA(l)) : (f.next = C.next, C.next = f), l.interleaved = f, OE(s, g);
    }
    function vZ(s, l, f, g) {
      var C = l.interleaved;
      C === null ? (f.next = f, fA(l)) : (f.next = C.next, C.next = f), l.interleaved = f;
    }
    function gZ(s, l, f, g) {
      var C = l.interleaved;
      return C === null ? (f.next = f, fA(l)) : (f.next = C.next, C.next = f), l.interleaved = f, OE(s, g);
    }
    function Oo(s, l) {
      return OE(s, l);
    }
    var mZ = OE;
    function OE(s, l) {
      s.lanes = ei(s.lanes, l);
      var f = s.alternate;
      f !== null && (f.lanes = ei(f.lanes, l)), f === null && (s.flags & (vr | yo)) !== Lt && hH(s);
      for (var g = s, C = s.return; C !== null; )
        C.childLanes = ei(C.childLanes, l), f = C.alternate, f !== null ? f.childLanes = ei(f.childLanes, l) : (C.flags & (vr | yo)) !== Lt && hH(s), g = C, C = C.return;
      if (g.tag === _) {
        var S = g.stateNode;
        return S;
      } else
        return null;
    }
    var c1 = 0, h1 = 1, RE = 2, pA = 3, LE = !1, vA, ME;
    vA = !1, ME = null;
    function gA(s) {
      var l = {
        baseState: s.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: Te
        },
        effects: null
      };
      s.updateQueue = l;
    }
    function f1(s, l) {
      var f = l.updateQueue, g = s.updateQueue;
      if (f === g) {
        var C = {
          baseState: g.baseState,
          firstBaseUpdate: g.firstBaseUpdate,
          lastBaseUpdate: g.lastBaseUpdate,
          shared: g.shared,
          effects: g.effects
        };
        l.updateQueue = C;
      }
    }
    function bd(s, l) {
      var f = {
        eventTime: s,
        lane: l,
        tag: c1,
        payload: null,
        callback: null,
        next: null
      };
      return f;
    }
    function Qc(s, l, f) {
      var g = s.updateQueue;
      if (g === null)
        return null;
      var C = g.shared;
      if (ME === C && !vA && (o("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), vA = !0), See()) {
        var S = C.pending;
        return S === null ? l.next = l : (l.next = S.next, S.next = l), C.pending = l, mZ(s, f);
      } else
        return gZ(s, C, l, f);
    }
    function kE(s, l, f) {
      var g = l.updateQueue;
      if (g !== null) {
        var C = g.shared;
        if ($_(f)) {
          var S = C.lanes;
          S = W_(S, s.pendingLanes);
          var T = ei(S, f);
          C.lanes = T, Rc(s, T);
        }
      }
    }
    function mA(s, l) {
      var f = s.updateQueue, g = s.alternate;
      if (g !== null) {
        var C = g.updateQueue;
        if (f === C) {
          var S = null, T = null, O = f.firstBaseUpdate;
          if (O !== null) {
            var M = O;
            do {
              var V = {
                eventTime: M.eventTime,
                lane: M.lane,
                tag: M.tag,
                payload: M.payload,
                callback: M.callback,
                next: null
              };
              T === null ? S = T = V : (T.next = V, T = V), M = M.next;
            } while (M !== null);
            T === null ? S = T = l : (T.next = l, T = l);
          } else
            S = T = l;
          f = {
            baseState: C.baseState,
            firstBaseUpdate: S,
            lastBaseUpdate: T,
            shared: C.shared,
            effects: C.effects
          }, s.updateQueue = f;
          return;
        }
      }
      var H = f.lastBaseUpdate;
      H === null ? f.firstBaseUpdate = l : H.next = l, f.lastBaseUpdate = l;
    }
    function _Z(s, l, f, g, C, S) {
      switch (f.tag) {
        case h1: {
          var T = f.payload;
          if (typeof T == "function") {
            s1();
            var O = T.call(S, g, C);
            {
              if (s.mode & Ir) {
                rn(!0);
                try {
                  T.call(S, g, C);
                } finally {
                  rn(!1);
                }
              }
              l1();
            }
            return O;
          }
          return T;
        }
        case pA:
          s.flags = s.flags & ~pn | Gt;
        case c1: {
          var M = f.payload, V;
          if (typeof M == "function") {
            s1(), V = M.call(S, g, C);
            {
              if (s.mode & Ir) {
                rn(!0);
                try {
                  M.call(S, g, C);
                } finally {
                  rn(!1);
                }
              }
              l1();
            }
          } else
            V = M;
          return V == null ? g : fi({}, g, V);
        }
        case RE:
          return LE = !0, g;
      }
      return g;
    }
    function PE(s, l, f, g) {
      var C = s.updateQueue;
      LE = !1, ME = C.shared;
      var S = C.firstBaseUpdate, T = C.lastBaseUpdate, O = C.shared.pending;
      if (O !== null) {
        C.shared.pending = null;
        var M = O, V = M.next;
        M.next = null, T === null ? S = V : T.next = V, T = M;
        var H = s.alternate;
        if (H !== null) {
          var J = H.updateQueue, Q = J.lastBaseUpdate;
          Q !== T && (Q === null ? J.firstBaseUpdate = V : Q.next = V, J.lastBaseUpdate = M);
        }
      }
      if (S !== null) {
        var fe = C.baseState, ce = Te, me = null, lt = null, Mt = null, Tt = S;
        do {
          var vi = Tt.lane, gi = Tt.eventTime;
          if (ld(g, vi)) {
            if (Mt !== null) {
              var Se = {
                eventTime: gi,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: yi,
                tag: Tt.tag,
                payload: Tt.payload,
                callback: Tt.callback,
                next: null
              };
              Mt = Mt.next = Se;
            }
            fe = _Z(s, C, Tt, fe, l, f);
            var le = Tt.callback;
            if (le !== null && // If the update was already committed, we should not queue its
            // callback again.
            Tt.lane !== yi) {
              s.flags |= xs;
              var He = C.effects;
              He === null ? C.effects = [Tt] : He.push(Tt);
            }
          } else {
            var se = {
              eventTime: gi,
              lane: vi,
              tag: Tt.tag,
              payload: Tt.payload,
              callback: Tt.callback,
              next: null
            };
            Mt === null ? (lt = Mt = se, me = fe) : Mt = Mt.next = se, ce = ei(ce, vi);
          }
          if (Tt = Tt.next, Tt === null) {
            if (O = C.shared.pending, O === null)
              break;
            var pt = O, st = pt.next;
            pt.next = null, Tt = st, C.lastBaseUpdate = pt, C.shared.pending = null;
          }
        } while (!0);
        Mt === null && (me = fe), C.baseState = me, C.firstBaseUpdate = lt, C.lastBaseUpdate = Mt;
        var Ut = C.shared.interleaved;
        if (Ut !== null) {
          var Qt = Ut;
          do
            ce = ei(ce, Qt.lane), Qt = Qt.next;
          while (Qt !== Ut);
        } else
          S === null && (C.shared.lanes = Te);
        ry(ce), s.lanes = ce, s.memoizedState = fe;
      }
      ME = null;
    }
    function CZ(s, l) {
      if (typeof s != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + s));
      s.call(l);
    }
    function p1() {
      LE = !1;
    }
    function FE() {
      return LE;
    }
    function v1(s, l, f) {
      var g = l.effects;
      if (l.effects = null, g !== null)
        for (var C = 0; C < g.length; C++) {
          var S = g[C], T = S.callback;
          T !== null && (S.callback = null, CZ(T, f));
        }
    }
    var _A = {}, g1 = new t.Component().refs, CA, yA, xA, SA, EA, m1, BE, bA, wA, TA;
    {
      CA = /* @__PURE__ */ new Set(), yA = /* @__PURE__ */ new Set(), xA = /* @__PURE__ */ new Set(), SA = /* @__PURE__ */ new Set(), bA = /* @__PURE__ */ new Set(), EA = /* @__PURE__ */ new Set(), wA = /* @__PURE__ */ new Set(), TA = /* @__PURE__ */ new Set();
      var _1 = /* @__PURE__ */ new Set();
      BE = function(s, l) {
        if (!(s === null || typeof s == "function")) {
          var f = l + "_" + s;
          _1.has(f) || (_1.add(f), o("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", l, s));
        }
      }, m1 = function(s, l) {
        if (l === void 0) {
          var f = ir(s) || "Component";
          EA.has(f) || (EA.add(f), o("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", f));
        }
      }, Object.defineProperty(_A, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(_A);
    }
    function IA(s, l, f, g) {
      var C = s.memoizedState, S = f(g, C);
      {
        if (s.mode & Ir) {
          rn(!0);
          try {
            S = f(g, C);
          } finally {
            rn(!1);
          }
        }
        m1(l, S);
      }
      var T = S == null ? C : fi({}, C, S);
      if (s.memoizedState = T, s.lanes === Te) {
        var O = s.updateQueue;
        O.baseState = T;
      }
    }
    var DA = {
      isMounted: Ya,
      enqueueSetState: function(s, l, f) {
        var g = _o(s), C = eo(), S = ah(g), T = bd(C, S);
        T.payload = l, f != null && (BE(f, "setState"), T.callback = f);
        var O = Qc(g, T, S);
        O !== null && (Mn(O, g, S, C), kE(O, g, S)), Jl(g, S);
      },
      enqueueReplaceState: function(s, l, f) {
        var g = _o(s), C = eo(), S = ah(g), T = bd(C, S);
        T.tag = h1, T.payload = l, f != null && (BE(f, "replaceState"), T.callback = f);
        var O = Qc(g, T, S);
        O !== null && (Mn(O, g, S, C), kE(O, g, S)), Jl(g, S);
      },
      enqueueForceUpdate: function(s, l) {
        var f = _o(s), g = eo(), C = ah(f), S = bd(g, C);
        S.tag = RE, l != null && (BE(l, "forceUpdate"), S.callback = l);
        var T = Qc(f, S, C);
        T !== null && (Mn(T, f, C, g), kE(T, f, C)), B_(f, C);
      }
    };
    function C1(s, l, f, g, C, S, T) {
      var O = s.stateNode;
      if (typeof O.shouldComponentUpdate == "function") {
        var M = O.shouldComponentUpdate(g, S, T);
        {
          if (s.mode & Ir) {
            rn(!0);
            try {
              M = O.shouldComponentUpdate(g, S, T);
            } finally {
              rn(!1);
            }
          }
          M === void 0 && o("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", ir(l) || "Component");
        }
        return M;
      }
      return l.prototype && l.prototype.isPureReactComponent ? !At(f, g) || !At(C, S) : !0;
    }
    function yZ(s, l, f) {
      var g = s.stateNode;
      {
        var C = ir(l) || "Component", S = g.render;
        S || (l.prototype && typeof l.prototype.render == "function" ? o("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", C) : o("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", C)), g.getInitialState && !g.getInitialState.isReactClassApproved && !g.state && o("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", C), g.getDefaultProps && !g.getDefaultProps.isReactClassApproved && o("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", C), g.propTypes && o("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", C), g.contextType && o("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", C), g.contextTypes && o("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", C), l.contextType && l.contextTypes && !wA.has(l) && (wA.add(l), o("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", C)), typeof g.componentShouldUpdate == "function" && o("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", C), l.prototype && l.prototype.isPureReactComponent && typeof g.shouldComponentUpdate < "u" && o("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", ir(l) || "A pure component"), typeof g.componentDidUnmount == "function" && o("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", C), typeof g.componentDidReceiveProps == "function" && o("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", C), typeof g.componentWillRecieveProps == "function" && o("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", C), typeof g.UNSAFE_componentWillRecieveProps == "function" && o("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", C);
        var T = g.props !== f;
        g.props !== void 0 && T && o("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", C, C), g.defaultProps && o("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", C, C), typeof g.getSnapshotBeforeUpdate == "function" && typeof g.componentDidUpdate != "function" && !xA.has(l) && (xA.add(l), o("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", ir(l))), typeof g.getDerivedStateFromProps == "function" && o("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", C), typeof g.getDerivedStateFromError == "function" && o("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", C), typeof l.getSnapshotBeforeUpdate == "function" && o("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", C);
        var O = g.state;
        O && (typeof O != "object" || hn(O)) && o("%s.state: must be set to an object or null", C), typeof g.getChildContext == "function" && typeof l.childContextTypes != "object" && o("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", C);
      }
    }
    function y1(s, l) {
      l.updater = DA, s.stateNode = l, xc(l, s), l._reactInternalInstance = _A;
    }
    function x1(s, l, f) {
      var g = !1, C = is, S = is, T = l.contextType;
      if ("contextType" in l) {
        var O = (
          // Allow null for conditional declaration
          T === null || T !== void 0 && T.$$typeof === U && T._context === void 0
        );
        if (!O && !TA.has(l)) {
          TA.add(l);
          var M = "";
          T === void 0 ? M = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof T != "object" ? M = " However, it is set to a " + typeof T + "." : T.$$typeof === ke ? M = " Did you accidentally pass the Context.Provider instead?" : T._context !== void 0 ? M = " Did you accidentally pass the Context.Consumer instead?" : M = " However, it is set to an object with keys {" + Object.keys(T).join(", ") + "}.", o("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", ir(l) || "Component", M);
        }
      }
      if (typeof T == "object" && T !== null)
        S = _n(T);
      else {
        C = xg(s, l, !0);
        var V = l.contextTypes;
        g = V != null, S = g ? Sg(s, C) : is;
      }
      var H = new l(f, S);
      if (s.mode & Ir) {
        rn(!0);
        try {
          H = new l(f, S);
        } finally {
          rn(!1);
        }
      }
      var J = s.memoizedState = H.state !== null && H.state !== void 0 ? H.state : null;
      y1(s, H);
      {
        if (typeof l.getDerivedStateFromProps == "function" && J === null) {
          var Q = ir(l) || "Component";
          yA.has(Q) || (yA.add(Q), o("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Q, H.state === null ? "null" : "undefined", Q));
        }
        if (typeof l.getDerivedStateFromProps == "function" || typeof H.getSnapshotBeforeUpdate == "function") {
          var fe = null, ce = null, me = null;
          if (typeof H.componentWillMount == "function" && H.componentWillMount.__suppressDeprecationWarning !== !0 ? fe = "componentWillMount" : typeof H.UNSAFE_componentWillMount == "function" && (fe = "UNSAFE_componentWillMount"), typeof H.componentWillReceiveProps == "function" && H.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? ce = "componentWillReceiveProps" : typeof H.UNSAFE_componentWillReceiveProps == "function" && (ce = "UNSAFE_componentWillReceiveProps"), typeof H.componentWillUpdate == "function" && H.componentWillUpdate.__suppressDeprecationWarning !== !0 ? me = "componentWillUpdate" : typeof H.UNSAFE_componentWillUpdate == "function" && (me = "UNSAFE_componentWillUpdate"), fe !== null || ce !== null || me !== null) {
            var lt = ir(l) || "Component", Mt = typeof l.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            SA.has(lt) || (SA.add(lt), o(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, lt, Mt, fe !== null ? `
  ` + fe : "", ce !== null ? `
  ` + ce : "", me !== null ? `
  ` + me : ""));
          }
        }
      }
      return g && GV(s, C, S), H;
    }
    function xZ(s, l) {
      var f = l.state;
      typeof l.componentWillMount == "function" && l.componentWillMount(), typeof l.UNSAFE_componentWillMount == "function" && l.UNSAFE_componentWillMount(), f !== l.state && (o("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Jt(s) || "Component"), DA.enqueueReplaceState(l, l.state, null));
    }
    function S1(s, l, f, g) {
      var C = l.state;
      if (typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps(f, g), typeof l.UNSAFE_componentWillReceiveProps == "function" && l.UNSAFE_componentWillReceiveProps(f, g), l.state !== C) {
        {
          var S = Jt(s) || "Component";
          CA.has(S) || (CA.add(S), o("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", S));
        }
        DA.enqueueReplaceState(l, l.state, null);
      }
    }
    function AA(s, l, f, g) {
      yZ(s, l, f);
      var C = s.stateNode;
      C.props = f, C.state = s.memoizedState, C.refs = g1, gA(s);
      var S = l.contextType;
      if (typeof S == "object" && S !== null)
        C.context = _n(S);
      else {
        var T = xg(s, l, !0);
        C.context = Sg(s, T);
      }
      {
        if (C.state === f) {
          var O = ir(l) || "Component";
          bA.has(O) || (bA.add(O), o("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", O));
        }
        s.mode & Ir && _l.recordLegacyContextWarning(s, C), _l.recordUnsafeLifecycleWarnings(s, C);
      }
      C.state = s.memoizedState;
      var M = l.getDerivedStateFromProps;
      if (typeof M == "function" && (IA(s, l, M, f), C.state = s.memoizedState), typeof l.getDerivedStateFromProps != "function" && typeof C.getSnapshotBeforeUpdate != "function" && (typeof C.UNSAFE_componentWillMount == "function" || typeof C.componentWillMount == "function") && (xZ(s, C), PE(s, f, C, g), C.state = s.memoizedState), typeof C.componentDidMount == "function") {
        var V = ri;
        V |= ba, (s.mode & Eo) !== Ft && (V |= wa), s.flags |= V;
      }
    }
    function SZ(s, l, f, g) {
      var C = s.stateNode, S = s.memoizedProps;
      C.props = S;
      var T = C.context, O = l.contextType, M = is;
      if (typeof O == "object" && O !== null)
        M = _n(O);
      else {
        var V = xg(s, l, !0);
        M = Sg(s, V);
      }
      var H = l.getDerivedStateFromProps, J = typeof H == "function" || typeof C.getSnapshotBeforeUpdate == "function";
      !J && (typeof C.UNSAFE_componentWillReceiveProps == "function" || typeof C.componentWillReceiveProps == "function") && (S !== f || T !== M) && S1(s, C, f, M), p1();
      var Q = s.memoizedState, fe = C.state = Q;
      if (PE(s, f, C, g), fe = s.memoizedState, S === f && Q === fe && !_E() && !FE()) {
        if (typeof C.componentDidMount == "function") {
          var ce = ri;
          ce |= ba, (s.mode & Eo) !== Ft && (ce |= wa), s.flags |= ce;
        }
        return !1;
      }
      typeof H == "function" && (IA(s, l, H, f), fe = s.memoizedState);
      var me = FE() || C1(s, l, S, f, Q, fe, M);
      if (me) {
        if (!J && (typeof C.UNSAFE_componentWillMount == "function" || typeof C.componentWillMount == "function") && (typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount()), typeof C.componentDidMount == "function") {
          var lt = ri;
          lt |= ba, (s.mode & Eo) !== Ft && (lt |= wa), s.flags |= lt;
        }
      } else {
        if (typeof C.componentDidMount == "function") {
          var Mt = ri;
          Mt |= ba, (s.mode & Eo) !== Ft && (Mt |= wa), s.flags |= Mt;
        }
        s.memoizedProps = f, s.memoizedState = fe;
      }
      return C.props = f, C.state = fe, C.context = M, me;
    }
    function EZ(s, l, f, g, C) {
      var S = l.stateNode;
      f1(s, l);
      var T = l.memoizedProps, O = l.type === l.elementType ? T : Cl(l.type, T);
      S.props = O;
      var M = l.pendingProps, V = S.context, H = f.contextType, J = is;
      if (typeof H == "object" && H !== null)
        J = _n(H);
      else {
        var Q = xg(l, f, !0);
        J = Sg(l, Q);
      }
      var fe = f.getDerivedStateFromProps, ce = typeof fe == "function" || typeof S.getSnapshotBeforeUpdate == "function";
      !ce && (typeof S.UNSAFE_componentWillReceiveProps == "function" || typeof S.componentWillReceiveProps == "function") && (T !== M || V !== J) && S1(l, S, g, J), p1();
      var me = l.memoizedState, lt = S.state = me;
      if (PE(l, g, S, C), lt = l.memoizedState, T === M && me === lt && !_E() && !FE() && !Ae)
        return typeof S.componentDidUpdate == "function" && (T !== s.memoizedProps || me !== s.memoizedState) && (l.flags |= ri), typeof S.getSnapshotBeforeUpdate == "function" && (T !== s.memoizedProps || me !== s.memoizedState) && (l.flags |= Co), !1;
      typeof fe == "function" && (IA(l, f, fe, g), lt = l.memoizedState);
      var Mt = FE() || C1(l, f, O, g, me, lt, J) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      Ae;
      return Mt ? (!ce && (typeof S.UNSAFE_componentWillUpdate == "function" || typeof S.componentWillUpdate == "function") && (typeof S.componentWillUpdate == "function" && S.componentWillUpdate(g, lt, J), typeof S.UNSAFE_componentWillUpdate == "function" && S.UNSAFE_componentWillUpdate(g, lt, J)), typeof S.componentDidUpdate == "function" && (l.flags |= ri), typeof S.getSnapshotBeforeUpdate == "function" && (l.flags |= Co)) : (typeof S.componentDidUpdate == "function" && (T !== s.memoizedProps || me !== s.memoizedState) && (l.flags |= ri), typeof S.getSnapshotBeforeUpdate == "function" && (T !== s.memoizedProps || me !== s.memoizedState) && (l.flags |= Co), l.memoizedProps = g, l.memoizedState = lt), S.props = g, S.state = lt, S.context = J, Mt;
    }
    var OA, RA, LA, MA, kA, E1 = function(s, l) {
    };
    OA = !1, RA = !1, LA = {}, MA = {}, kA = {}, E1 = function(s, l) {
      if (!(s === null || typeof s != "object") && !(!s._store || s._store.validated || s.key != null)) {
        if (typeof s._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        s._store.validated = !0;
        var f = Jt(l) || "Component";
        MA[f] || (MA[f] = !0, o('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function LC(s, l, f) {
      var g = f.ref;
      if (g !== null && typeof g != "function" && typeof g != "object") {
        if ((s.mode & Ir || je) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(f._owner && f._self && f._owner.stateNode !== f._self)) {
          var C = Jt(s) || "Component";
          LA[C] || (o('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', g), LA[C] = !0);
        }
        if (f._owner) {
          var S = f._owner, T;
          if (S) {
            var O = S;
            if (O.tag !== p)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            T = O.stateNode;
          }
          if (!T)
            throw new Error("Missing owner for string ref " + g + ". This error is likely caused by a bug in React. Please file an issue.");
          var M = T;
          Rr(g, "ref");
          var V = "" + g;
          if (l !== null && l.ref !== null && typeof l.ref == "function" && l.ref._stringRef === V)
            return l.ref;
          var H = function(J) {
            var Q = M.refs;
            Q === g1 && (Q = M.refs = {}), J === null ? delete Q[V] : Q[V] = J;
          };
          return H._stringRef = V, H;
        } else {
          if (typeof g != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!f._owner)
            throw new Error("Element ref was specified as a string (" + g + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return g;
    }
    function VE(s, l) {
      var f = Object.prototype.toString.call(l);
      throw new Error("Objects are not valid as a React child (found: " + (f === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : f) + "). If you meant to render a collection of children, use an array instead.");
    }
    function NE(s) {
      {
        var l = Jt(s) || "Component";
        if (kA[l])
          return;
        kA[l] = !0, o("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function b1(s) {
      var l = s._payload, f = s._init;
      return f(l);
    }
    function w1(s) {
      function l(se, Se) {
        if (s) {
          var le = se.deletions;
          le === null ? (se.deletions = [Se], se.flags |= Fi) : le.push(Se);
        }
      }
      function f(se, Se) {
        if (!s)
          return null;
        for (var le = Se; le !== null; )
          l(se, le), le = le.sibling;
        return null;
      }
      function g(se, Se) {
        for (var le = /* @__PURE__ */ new Map(), He = Se; He !== null; )
          He.key !== null ? le.set(He.key, He) : le.set(He.index, He), He = He.sibling;
        return le;
      }
      function C(se, Se) {
        var le = Xf(se, Se);
        return le.index = 0, le.sibling = null, le;
      }
      function S(se, Se, le) {
        if (se.index = le, !s)
          return se.flags |= w_, Se;
        var He = se.alternate;
        if (He !== null) {
          var pt = He.index;
          return pt < Se ? (se.flags |= vr, Se) : pt;
        } else
          return se.flags |= vr, Se;
      }
      function T(se) {
        return s && se.alternate === null && (se.flags |= vr), se;
      }
      function O(se, Se, le, He) {
        if (Se === null || Se.tag !== I) {
          var pt = lR(le, se.mode, He);
          return pt.return = se, pt;
        } else {
          var st = C(Se, le);
          return st.return = se, st;
        }
      }
      function M(se, Se, le, He) {
        var pt = le.type;
        if (pt === ya)
          return H(se, Se, le.props.children, He, le.key);
        if (Se !== null && (Se.elementType === pt || // Keep this check inline so it only runs on the false path:
        gH(Se, le) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof pt == "object" && pt !== null && pt.$$typeof === Xe && b1(pt) === Se.type)) {
          var st = C(Se, le.props);
          return st.ref = LC(se, Se, le), st.return = se, st._debugSource = le._source, st._debugOwner = le._owner, st;
        }
        var Ut = sR(le, se.mode, He);
        return Ut.ref = LC(se, Se, le), Ut.return = se, Ut;
      }
      function V(se, Se, le, He) {
        if (Se === null || Se.tag !== y || Se.stateNode.containerInfo !== le.containerInfo || Se.stateNode.implementation !== le.implementation) {
          var pt = uR(le, se.mode, He);
          return pt.return = se, pt;
        } else {
          var st = C(Se, le.children || []);
          return st.return = se, st;
        }
      }
      function H(se, Se, le, He, pt) {
        if (Se === null || Se.tag !== A) {
          var st = sh(le, se.mode, He, pt);
          return st.return = se, st;
        } else {
          var Ut = C(Se, le);
          return Ut.return = se, Ut;
        }
      }
      function J(se, Se, le) {
        if (typeof Se == "string" && Se !== "" || typeof Se == "number") {
          var He = lR("" + Se, se.mode, le);
          return He.return = se, He;
        }
        if (typeof Se == "object" && Se !== null) {
          switch (Se.$$typeof) {
            case Ko: {
              var pt = sR(Se, se.mode, le);
              return pt.ref = LC(se, null, Se), pt.return = se, pt;
            }
            case Wn: {
              var st = uR(Se, se.mode, le);
              return st.return = se, st;
            }
            case Xe: {
              var Ut = Se._payload, Qt = Se._init;
              return J(se, Qt(Ut), le);
            }
          }
          if (hn(Se) || Zs(Se)) {
            var Zi = sh(Se, se.mode, le, null);
            return Zi.return = se, Zi;
          }
          VE(se, Se);
        }
        return typeof Se == "function" && NE(se), null;
      }
      function Q(se, Se, le, He) {
        var pt = Se !== null ? Se.key : null;
        if (typeof le == "string" && le !== "" || typeof le == "number")
          return pt !== null ? null : O(se, Se, "" + le, He);
        if (typeof le == "object" && le !== null) {
          switch (le.$$typeof) {
            case Ko:
              return le.key === pt ? M(se, Se, le, He) : null;
            case Wn:
              return le.key === pt ? V(se, Se, le, He) : null;
            case Xe: {
              var st = le._payload, Ut = le._init;
              return Q(se, Se, Ut(st), He);
            }
          }
          if (hn(le) || Zs(le))
            return pt !== null ? null : H(se, Se, le, He, null);
          VE(se, le);
        }
        return typeof le == "function" && NE(se), null;
      }
      function fe(se, Se, le, He, pt) {
        if (typeof He == "string" && He !== "" || typeof He == "number") {
          var st = se.get(le) || null;
          return O(Se, st, "" + He, pt);
        }
        if (typeof He == "object" && He !== null) {
          switch (He.$$typeof) {
            case Ko: {
              var Ut = se.get(He.key === null ? le : He.key) || null;
              return M(Se, Ut, He, pt);
            }
            case Wn: {
              var Qt = se.get(He.key === null ? le : He.key) || null;
              return V(Se, Qt, He, pt);
            }
            case Xe:
              var Zi = He._payload, Ri = He._init;
              return fe(se, Se, le, Ri(Zi), pt);
          }
          if (hn(He) || Zs(He)) {
            var ln = se.get(le) || null;
            return H(Se, ln, He, pt, null);
          }
          VE(Se, He);
        }
        return typeof He == "function" && NE(Se), null;
      }
      function ce(se, Se, le) {
        {
          if (typeof se != "object" || se === null)
            return Se;
          switch (se.$$typeof) {
            case Ko:
            case Wn:
              E1(se, le);
              var He = se.key;
              if (typeof He != "string")
                break;
              if (Se === null) {
                Se = /* @__PURE__ */ new Set(), Se.add(He);
                break;
              }
              if (!Se.has(He)) {
                Se.add(He);
                break;
              }
              o("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", He);
              break;
            case Xe:
              var pt = se._payload, st = se._init;
              ce(st(pt), Se, le);
              break;
          }
        }
        return Se;
      }
      function me(se, Se, le, He) {
        for (var pt = null, st = 0; st < le.length; st++) {
          var Ut = le[st];
          pt = ce(Ut, pt, se);
        }
        for (var Qt = null, Zi = null, Ri = Se, ln = 0, Li = 0, Yr = null; Ri !== null && Li < le.length; Li++) {
          Ri.index > Li ? (Yr = Ri, Ri = null) : Yr = Ri.sibling;
          var ka = Q(se, Ri, le[Li], He);
          if (ka === null) {
            Ri === null && (Ri = Yr);
            break;
          }
          s && Ri && ka.alternate === null && l(se, Ri), ln = S(ka, ln, Li), Zi === null ? Qt = ka : Zi.sibling = ka, Zi = ka, Ri = Yr;
        }
        if (Li === le.length) {
          if (f(se, Ri), oa()) {
            var fa = Li;
            Bf(se, fa);
          }
          return Qt;
        }
        if (Ri === null) {
          for (; Li < le.length; Li++) {
            var ns = J(se, le[Li], He);
            ns !== null && (ln = S(ns, ln, Li), Zi === null ? Qt = ns : Zi.sibling = ns, Zi = ns);
          }
          if (oa()) {
            var to = Li;
            Bf(se, to);
          }
          return Qt;
        }
        for (var io = g(se, Ri); Li < le.length; Li++) {
          var Pa = fe(io, se, Li, le[Li], He);
          Pa !== null && (s && Pa.alternate !== null && io.delete(Pa.key === null ? Li : Pa.key), ln = S(Pa, ln, Li), Zi === null ? Qt = Pa : Zi.sibling = Pa, Zi = Pa);
        }
        if (s && io.forEach(function(Ug) {
          return l(se, Ug);
        }), oa()) {
          var Od = Li;
          Bf(se, Od);
        }
        return Qt;
      }
      function lt(se, Se, le, He) {
        var pt = Zs(le);
        if (typeof pt != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          le[Symbol.toStringTag] === "Generator" && (RA || o("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), RA = !0), le.entries === pt && (OA || o("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), OA = !0);
          var st = pt.call(le);
          if (st)
            for (var Ut = null, Qt = st.next(); !Qt.done; Qt = st.next()) {
              var Zi = Qt.value;
              Ut = ce(Zi, Ut, se);
            }
        }
        var Ri = pt.call(le);
        if (Ri == null)
          throw new Error("An iterable object provided no iterator.");
        for (var ln = null, Li = null, Yr = Se, ka = 0, fa = 0, ns = null, to = Ri.next(); Yr !== null && !to.done; fa++, to = Ri.next()) {
          Yr.index > fa ? (ns = Yr, Yr = null) : ns = Yr.sibling;
          var io = Q(se, Yr, to.value, He);
          if (io === null) {
            Yr === null && (Yr = ns);
            break;
          }
          s && Yr && io.alternate === null && l(se, Yr), ka = S(io, ka, fa), Li === null ? ln = io : Li.sibling = io, Li = io, Yr = ns;
        }
        if (to.done) {
          if (f(se, Yr), oa()) {
            var Pa = fa;
            Bf(se, Pa);
          }
          return ln;
        }
        if (Yr === null) {
          for (; !to.done; fa++, to = Ri.next()) {
            var Od = J(se, to.value, He);
            Od !== null && (ka = S(Od, ka, fa), Li === null ? ln = Od : Li.sibling = Od, Li = Od);
          }
          if (oa()) {
            var Ug = fa;
            Bf(se, Ug);
          }
          return ln;
        }
        for (var ly = g(se, Yr); !to.done; fa++, to = Ri.next()) {
          var mu = fe(ly, se, fa, to.value, He);
          mu !== null && (s && mu.alternate !== null && ly.delete(mu.key === null ? fa : mu.key), ka = S(mu, ka, fa), Li === null ? ln = mu : Li.sibling = mu, Li = mu);
        }
        if (s && ly.forEach(function(zte) {
          return l(se, zte);
        }), oa()) {
          var $te = fa;
          Bf(se, $te);
        }
        return ln;
      }
      function Mt(se, Se, le, He) {
        if (Se !== null && Se.tag === I) {
          f(se, Se.sibling);
          var pt = C(Se, le);
          return pt.return = se, pt;
        }
        f(se, Se);
        var st = lR(le, se.mode, He);
        return st.return = se, st;
      }
      function Tt(se, Se, le, He) {
        for (var pt = le.key, st = Se; st !== null; ) {
          if (st.key === pt) {
            var Ut = le.type;
            if (Ut === ya) {
              if (st.tag === A) {
                f(se, st.sibling);
                var Qt = C(st, le.props.children);
                return Qt.return = se, Qt._debugSource = le._source, Qt._debugOwner = le._owner, Qt;
              }
            } else if (st.elementType === Ut || // Keep this check inline so it only runs on the false path:
            gH(st, le) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Ut == "object" && Ut !== null && Ut.$$typeof === Xe && b1(Ut) === st.type) {
              f(se, st.sibling);
              var Zi = C(st, le.props);
              return Zi.ref = LC(se, st, le), Zi.return = se, Zi._debugSource = le._source, Zi._debugOwner = le._owner, Zi;
            }
            f(se, st);
            break;
          } else
            l(se, st);
          st = st.sibling;
        }
        if (le.type === ya) {
          var Ri = sh(le.props.children, se.mode, He, le.key);
          return Ri.return = se, Ri;
        } else {
          var ln = sR(le, se.mode, He);
          return ln.ref = LC(se, Se, le), ln.return = se, ln;
        }
      }
      function vi(se, Se, le, He) {
        for (var pt = le.key, st = Se; st !== null; ) {
          if (st.key === pt)
            if (st.tag === y && st.stateNode.containerInfo === le.containerInfo && st.stateNode.implementation === le.implementation) {
              f(se, st.sibling);
              var Ut = C(st, le.children || []);
              return Ut.return = se, Ut;
            } else {
              f(se, st);
              break;
            }
          else
            l(se, st);
          st = st.sibling;
        }
        var Qt = uR(le, se.mode, He);
        return Qt.return = se, Qt;
      }
      function gi(se, Se, le, He) {
        var pt = typeof le == "object" && le !== null && le.type === ya && le.key === null;
        if (pt && (le = le.props.children), typeof le == "object" && le !== null) {
          switch (le.$$typeof) {
            case Ko:
              return T(Tt(se, Se, le, He));
            case Wn:
              return T(vi(se, Se, le, He));
            case Xe:
              var st = le._payload, Ut = le._init;
              return gi(se, Se, Ut(st), He);
          }
          if (hn(le))
            return me(se, Se, le, He);
          if (Zs(le))
            return lt(se, Se, le, He);
          VE(se, le);
        }
        return typeof le == "string" && le !== "" || typeof le == "number" ? T(Mt(se, Se, "" + le, He)) : (typeof le == "function" && NE(se), f(se, Se));
      }
      return gi;
    }
    var Dg = w1(!0), T1 = w1(!1);
    function bZ(s, l) {
      if (s !== null && l.child !== s.child)
        throw new Error("Resuming work not yet implemented.");
      if (l.child !== null) {
        var f = l.child, g = Xf(f, f.pendingProps);
        for (l.child = g, g.return = l; f.sibling !== null; )
          f = f.sibling, g = g.sibling = Xf(f, f.pendingProps), g.return = l;
        g.sibling = null;
      }
    }
    function wZ(s, l) {
      for (var f = s.child; f !== null; )
        ate(f, l), f = f.sibling;
    }
    var MC = {}, Zc = jc(MC), kC = jc(MC), HE = jc(MC);
    function $E(s) {
      if (s === MC)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return s;
    }
    function I1() {
      var s = $E(HE.current);
      return s;
    }
    function PA(s, l) {
      La(HE, l, s), La(kC, s, s), La(Zc, MC, s);
      var f = N7(l);
      Ra(Zc, s), La(Zc, f, s);
    }
    function Ag(s) {
      Ra(Zc, s), Ra(kC, s), Ra(HE, s);
    }
    function FA() {
      var s = $E(Zc.current);
      return s;
    }
    function D1(s) {
      var l = $E(HE.current), f = $E(Zc.current), g = H7(f, s.type);
      f !== g && (La(kC, s, s), La(Zc, g, s));
    }
    function BA(s) {
      kC.current === s && (Ra(Zc, s), Ra(kC, s));
    }
    var TZ = 0, A1 = 1, O1 = 1, PC = 2, yl = jc(TZ);
    function VA(s, l) {
      return (s & l) !== 0;
    }
    function Og(s) {
      return s & A1;
    }
    function NA(s, l) {
      return s & A1 | l;
    }
    function IZ(s, l) {
      return s | l;
    }
    function Jc(s, l) {
      La(yl, l, s);
    }
    function Rg(s) {
      Ra(yl, s);
    }
    function DZ(s, l) {
      var f = s.memoizedState;
      if (f !== null)
        return f.dehydrated !== null;
      var g = s.memoizedProps;
      return !0;
    }
    function zE(s) {
      for (var l = s; l !== null; ) {
        if (l.tag === z) {
          var f = l.memoizedState;
          if (f !== null) {
            var g = f.dehydrated;
            if (g === null || HV(g) || GD(g))
              return l;
          }
        } else if (l.tag === Ce && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        l.memoizedProps.revealOrder !== void 0) {
          var C = (l.flags & Gt) !== Lt;
          if (C)
            return l;
        } else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === s)
          return null;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === s)
            return null;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
      return null;
    }
    var Ro = (
      /*   */
      0
    ), Tn = (
      /* */
      1
    ), du = (
      /*  */
      2
    ), In = (
      /*    */
      4
    ), sa = (
      /*   */
      8
    ), HA = [];
    function $A() {
      for (var s = 0; s < HA.length; s++) {
        var l = HA[s];
        l._workInProgressVersionPrimary = null;
      }
      HA.length = 0;
    }
    function AZ(s, l) {
      var f = l._getVersion, g = f(l._source);
      s.mutableSourceEagerHydrationData == null ? s.mutableSourceEagerHydrationData = [l, g] : s.mutableSourceEagerHydrationData.push(l, g);
    }
    var dt = i.ReactCurrentDispatcher, FC = i.ReactCurrentBatchConfig, zA, Lg;
    zA = /* @__PURE__ */ new Set();
    var Wf = Te, Qi = null, Dn = null, An = null, WE = !1, BC = !1, VC = 0, OZ = 0, RZ = 25, Oe = null, Os = null, eh = -1, WA = !1;
    function Ni() {
      {
        var s = Oe;
        Os === null ? Os = [s] : Os.push(s);
      }
    }
    function rt() {
      {
        var s = Oe;
        Os !== null && (eh++, Os[eh] !== s && LZ(s));
      }
    }
    function Mg(s) {
      s != null && !hn(s) && o("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", Oe, typeof s);
    }
    function LZ(s) {
      {
        var l = Jt(Qi);
        if (!zA.has(l) && (zA.add(l), Os !== null)) {
          for (var f = "", g = 30, C = 0; C <= eh; C++) {
            for (var S = Os[C], T = C === eh ? s : S, O = C + 1 + ". " + S; O.length < g; )
              O += " ";
            O += T + `
`, f += O;
          }
          o(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, l, f);
        }
      }
    }
    function Ma() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function UA(s, l) {
      if (WA)
        return !1;
      if (l === null)
        return o("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Oe), !1;
      s.length !== l.length && o(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Oe, "[" + l.join(", ") + "]", "[" + s.join(", ") + "]");
      for (var f = 0; f < l.length && f < s.length; f++)
        if (!St(s[f], l[f]))
          return !1;
      return !0;
    }
    function kg(s, l, f, g, C, S) {
      Wf = S, Qi = l, Os = s !== null ? s._debugHookTypes : null, eh = -1, WA = s !== null && s.type !== l.type, l.memoizedState = null, l.updateQueue = null, l.lanes = Te, s !== null && s.memoizedState !== null ? dt.current = Z1 : Os !== null ? dt.current = Q1 : dt.current = X1;
      var T = f(g, C);
      if (BC) {
        var O = 0;
        do {
          if (BC = !1, VC = 0, O >= RZ)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          O += 1, WA = !1, Dn = null, An = null, l.updateQueue = null, eh = -1, dt.current = J1, T = f(g, C);
        } while (BC);
      }
      dt.current = ib, l._debugHookTypes = Os;
      var M = Dn !== null && Dn.next !== null;
      if (Wf = Te, Qi = null, Dn = null, An = null, Oe = null, Os = null, eh = -1, s !== null && (s.flags & En) !== (l.flags & En) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (s.mode & li) !== Ft && o("Internal React error: Expected static flag was missing. Please notify the React team."), WE = !1, M)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return T;
    }
    function Pg() {
      var s = VC !== 0;
      return VC = 0, s;
    }
    function R1(s, l, f) {
      l.updateQueue = s.updateQueue, (l.mode & Eo) !== Ft ? l.flags &= ~(Zu | wa | xr | ri) : l.flags &= ~(xr | ri), s.lanes = Oc(s.lanes, f);
    }
    function L1() {
      if (dt.current = ib, WE) {
        for (var s = Qi.memoizedState; s !== null; ) {
          var l = s.queue;
          l !== null && (l.pending = null), s = s.next;
        }
        WE = !1;
      }
      Wf = Te, Qi = null, Dn = null, An = null, Os = null, eh = -1, Oe = null, G1 = !1, BC = !1, VC = 0;
    }
    function cu() {
      var s = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return An === null ? Qi.memoizedState = An = s : An = An.next = s, An;
    }
    function Rs() {
      var s;
      if (Dn === null) {
        var l = Qi.alternate;
        l !== null ? s = l.memoizedState : s = null;
      } else
        s = Dn.next;
      var f;
      if (An === null ? f = Qi.memoizedState : f = An.next, f !== null)
        An = f, f = An.next, Dn = s;
      else {
        if (s === null)
          throw new Error("Rendered more hooks than during the previous render.");
        Dn = s;
        var g = {
          memoizedState: Dn.memoizedState,
          baseState: Dn.baseState,
          baseQueue: Dn.baseQueue,
          queue: Dn.queue,
          next: null
        };
        An === null ? Qi.memoizedState = An = g : An = An.next = g;
      }
      return An;
    }
    function M1() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function GA(s, l) {
      return typeof l == "function" ? l(s) : l;
    }
    function KA(s, l, f) {
      var g = cu(), C;
      f !== void 0 ? C = f(l) : C = l, g.memoizedState = g.baseState = C;
      var S = {
        pending: null,
        interleaved: null,
        lanes: Te,
        dispatch: null,
        lastRenderedReducer: s,
        lastRenderedState: C
      };
      g.queue = S;
      var T = S.dispatch = FZ.bind(null, Qi, S);
      return [g.memoizedState, T];
    }
    function jA(s, l, f) {
      var g = Rs(), C = g.queue;
      if (C === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      C.lastRenderedReducer = s;
      var S = Dn, T = S.baseQueue, O = C.pending;
      if (O !== null) {
        if (T !== null) {
          var M = T.next, V = O.next;
          T.next = V, O.next = M;
        }
        S.baseQueue !== T && o("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), S.baseQueue = T = O, C.pending = null;
      }
      if (T !== null) {
        var H = T.next, J = S.baseState, Q = null, fe = null, ce = null, me = H;
        do {
          var lt = me.lane;
          if (ld(Wf, lt)) {
            if (ce !== null) {
              var Tt = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: yi,
                action: me.action,
                hasEagerState: me.hasEagerState,
                eagerState: me.eagerState,
                next: null
              };
              ce = ce.next = Tt;
            }
            if (me.hasEagerState)
              J = me.eagerState;
            else {
              var vi = me.action;
              J = s(J, vi);
            }
          } else {
            var Mt = {
              lane: lt,
              action: me.action,
              hasEagerState: me.hasEagerState,
              eagerState: me.eagerState,
              next: null
            };
            ce === null ? (fe = ce = Mt, Q = J) : ce = ce.next = Mt, Qi.lanes = ei(Qi.lanes, lt), ry(lt);
          }
          me = me.next;
        } while (me !== null && me !== H);
        ce === null ? Q = J : ce.next = fe, St(J, g.memoizedState) || GC(), g.memoizedState = J, g.baseState = Q, g.baseQueue = ce, C.lastRenderedState = J;
      }
      var gi = C.interleaved;
      if (gi !== null) {
        var se = gi;
        do {
          var Se = se.lane;
          Qi.lanes = ei(Qi.lanes, Se), ry(Se), se = se.next;
        } while (se !== gi);
      } else
        T === null && (C.lanes = Te);
      var le = C.dispatch;
      return [g.memoizedState, le];
    }
    function YA(s, l, f) {
      var g = Rs(), C = g.queue;
      if (C === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      C.lastRenderedReducer = s;
      var S = C.dispatch, T = C.pending, O = g.memoizedState;
      if (T !== null) {
        C.pending = null;
        var M = T.next, V = M;
        do {
          var H = V.action;
          O = s(O, H), V = V.next;
        } while (V !== M);
        St(O, g.memoizedState) || GC(), g.memoizedState = O, g.baseQueue === null && (g.baseState = O), C.lastRenderedState = O;
      }
      return [O, S];
    }
    function QBe(s, l, f) {
    }
    function ZBe(s, l, f) {
    }
    function qA(s, l, f) {
      var g = Qi, C = cu(), S, T = oa();
      if (T) {
        if (f === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        S = f(), Lg || S !== f() && (o("The result of getServerSnapshot should be cached to avoid an infinite loop"), Lg = !0);
      } else {
        if (S = l(), !Lg) {
          var O = l();
          St(S, O) || (o("The result of getSnapshot should be cached to avoid an infinite loop"), Lg = !0);
        }
        var M = yb();
        if (M === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        yf(M, Wf) || k1(g, l, S);
      }
      C.memoizedState = S;
      var V = {
        value: S,
        getSnapshot: l
      };
      return C.queue = V, YE(F1.bind(null, g, V, s), [s]), g.flags |= xr, NC(Tn | sa, P1.bind(null, g, V, S, l), void 0, null), S;
    }
    function UE(s, l, f) {
      var g = Qi, C = Rs(), S = l();
      if (!Lg) {
        var T = l();
        St(S, T) || (o("The result of getSnapshot should be cached to avoid an infinite loop"), Lg = !0);
      }
      var O = C.memoizedState, M = !St(O, S);
      M && (C.memoizedState = S, GC());
      var V = C.queue;
      if ($C(F1.bind(null, g, V, s), [s]), V.getSnapshot !== l || M || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      An !== null && An.memoizedState.tag & Tn) {
        g.flags |= xr, NC(Tn | sa, P1.bind(null, g, V, S, l), void 0, null);
        var H = yb();
        if (H === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        yf(H, Wf) || k1(g, l, S);
      }
      return S;
    }
    function k1(s, l, f) {
      s.flags |= cf;
      var g = {
        getSnapshot: l,
        value: f
      }, C = Qi.updateQueue;
      if (C === null)
        C = M1(), Qi.updateQueue = C, C.stores = [g];
      else {
        var S = C.stores;
        S === null ? C.stores = [g] : S.push(g);
      }
    }
    function P1(s, l, f, g) {
      l.value = f, l.getSnapshot = g, B1(l) && V1(s);
    }
    function F1(s, l, f) {
      var g = function() {
        B1(l) && V1(s);
      };
      return f(g);
    }
    function B1(s) {
      var l = s.getSnapshot, f = s.value;
      try {
        var g = l();
        return !St(f, g);
      } catch {
        return !0;
      }
    }
    function V1(s) {
      var l = Oo(s, Ht);
      l !== null && Mn(l, s, Ht, nr);
    }
    function GE(s) {
      var l = cu();
      typeof s == "function" && (s = s()), l.memoizedState = l.baseState = s;
      var f = {
        pending: null,
        interleaved: null,
        lanes: Te,
        dispatch: null,
        lastRenderedReducer: GA,
        lastRenderedState: s
      };
      l.queue = f;
      var g = f.dispatch = BZ.bind(null, Qi, f);
      return [l.memoizedState, g];
    }
    function XA(s) {
      return jA(GA);
    }
    function QA(s) {
      return YA(GA);
    }
    function NC(s, l, f, g) {
      var C = {
        tag: s,
        create: l,
        destroy: f,
        deps: g,
        // Circular
        next: null
      }, S = Qi.updateQueue;
      if (S === null)
        S = M1(), Qi.updateQueue = S, S.lastEffect = C.next = C;
      else {
        var T = S.lastEffect;
        if (T === null)
          S.lastEffect = C.next = C;
        else {
          var O = T.next;
          T.next = C, C.next = O, S.lastEffect = C;
        }
      }
      return C;
    }
    function ZA(s) {
      var l = cu();
      {
        var f = {
          current: s
        };
        return l.memoizedState = f, f;
      }
    }
    function KE(s) {
      var l = Rs();
      return l.memoizedState;
    }
    function HC(s, l, f, g) {
      var C = cu(), S = g === void 0 ? null : g;
      Qi.flags |= s, C.memoizedState = NC(Tn | l, f, void 0, S);
    }
    function jE(s, l, f, g) {
      var C = Rs(), S = g === void 0 ? null : g, T = void 0;
      if (Dn !== null) {
        var O = Dn.memoizedState;
        if (T = O.destroy, S !== null) {
          var M = O.deps;
          if (UA(S, M)) {
            C.memoizedState = NC(l, f, T, S);
            return;
          }
        }
      }
      Qi.flags |= s, C.memoizedState = NC(Tn | l, f, T, S);
    }
    function YE(s, l) {
      return (Qi.mode & Eo) !== Ft ? HC(Zu | xr | Yl, sa, s, l) : HC(xr | Yl, sa, s, l);
    }
    function $C(s, l) {
      return jE(xr, sa, s, l);
    }
    function JA(s, l) {
      return HC(ri, du, s, l);
    }
    function qE(s, l) {
      return jE(ri, du, s, l);
    }
    function eO(s, l) {
      var f = ri;
      return f |= ba, (Qi.mode & Eo) !== Ft && (f |= wa), HC(f, In, s, l);
    }
    function XE(s, l) {
      return jE(ri, In, s, l);
    }
    function N1(s, l) {
      if (typeof l == "function") {
        var f = l, g = s();
        return f(g), function() {
          f(null);
        };
      } else if (l != null) {
        var C = l;
        C.hasOwnProperty("current") || o("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(C).join(", ") + "}");
        var S = s();
        return C.current = S, function() {
          C.current = null;
        };
      }
    }
    function tO(s, l, f) {
      typeof l != "function" && o("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", l !== null ? typeof l : "null");
      var g = f != null ? f.concat([s]) : null, C = ri;
      return C |= ba, (Qi.mode & Eo) !== Ft && (C |= wa), HC(C, In, N1.bind(null, l, s), g);
    }
    function QE(s, l, f) {
      typeof l != "function" && o("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", l !== null ? typeof l : "null");
      var g = f != null ? f.concat([s]) : null;
      return jE(ri, In, N1.bind(null, l, s), g);
    }
    function MZ(s, l) {
    }
    var ZE = MZ;
    function iO(s, l) {
      var f = cu(), g = l === void 0 ? null : l;
      return f.memoizedState = [s, g], s;
    }
    function JE(s, l) {
      var f = Rs(), g = l === void 0 ? null : l, C = f.memoizedState;
      if (C !== null && g !== null) {
        var S = C[1];
        if (UA(g, S))
          return C[0];
      }
      return f.memoizedState = [s, g], s;
    }
    function rO(s, l) {
      var f = cu(), g = l === void 0 ? null : l, C = s();
      return f.memoizedState = [C, g], C;
    }
    function eb(s, l) {
      var f = Rs(), g = l === void 0 ? null : l, C = f.memoizedState;
      if (C !== null && g !== null) {
        var S = C[1];
        if (UA(g, S))
          return C[0];
      }
      var T = s();
      return f.memoizedState = [T, g], T;
    }
    function nO(s) {
      var l = cu();
      return l.memoizedState = s, s;
    }
    function H1(s) {
      var l = Rs(), f = Dn, g = f.memoizedState;
      return z1(l, g, s);
    }
    function $1(s) {
      var l = Rs();
      if (Dn === null)
        return l.memoizedState = s, s;
      var f = Dn.memoizedState;
      return z1(l, f, s);
    }
    function z1(s, l, f) {
      var g = !dD(Wf);
      if (g) {
        if (!St(f, l)) {
          var C = z_();
          Qi.lanes = ei(Qi.lanes, C), ry(C), s.baseState = !0;
        }
        return l;
      } else
        return s.baseState && (s.baseState = !1, GC()), s.memoizedState = f, f;
    }
    function kZ(s, l, f) {
      var g = wo();
      an(jn(g, wn)), s(!0);
      var C = FC.transition;
      FC.transition = {};
      var S = FC.transition;
      FC.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        s(!1), l();
      } finally {
        if (an(g), FC.transition = C, C === null && S._updatedFibers) {
          var T = S._updatedFibers.size;
          T > 10 && a("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), S._updatedFibers.clear();
        }
      }
    }
    function aO() {
      var s = GE(!1), l = s[0], f = s[1], g = kZ.bind(null, f), C = cu();
      return C.memoizedState = g, [l, g];
    }
    function W1() {
      var s = XA(), l = s[0], f = Rs(), g = f.memoizedState;
      return [l, g];
    }
    function U1() {
      var s = QA(), l = s[0], f = Rs(), g = f.memoizedState;
      return [l, g];
    }
    var G1 = !1;
    function PZ() {
      return G1;
    }
    function oO() {
      var s = cu(), l = yb(), f = l.identifierPrefix, g;
      if (oa()) {
        var C = qQ();
        g = ":" + f + "R" + C;
        var S = VC++;
        S > 0 && (g += "H" + S.toString(32)), g += ":";
      } else {
        var T = OZ++;
        g = ":" + f + "r" + T.toString(32) + ":";
      }
      return s.memoizedState = g, g;
    }
    function tb() {
      var s = Rs(), l = s.memoizedState;
      return l;
    }
    function FZ(s, l, f) {
      typeof arguments[3] == "function" && o("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var g = ah(s), C = {
        lane: g,
        action: f,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (K1(s))
        j1(l, C);
      else {
        var S = d1(s, l, C, g);
        if (S !== null) {
          var T = eo();
          Mn(S, s, g, T), Y1(S, l, g);
        }
      }
      q1(s, g);
    }
    function BZ(s, l, f) {
      typeof arguments[3] == "function" && o("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var g = ah(s), C = {
        lane: g,
        action: f,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (K1(s))
        j1(l, C);
      else {
        var S = s.alternate;
        if (s.lanes === Te && (S === null || S.lanes === Te)) {
          var T = l.lastRenderedReducer;
          if (T !== null) {
            var O;
            O = dt.current, dt.current = xl;
            try {
              var M = l.lastRenderedState, V = T(M, f);
              if (C.hasEagerState = !0, C.eagerState = V, St(V, M)) {
                vZ(s, l, C, g);
                return;
              }
            } catch {
            } finally {
              dt.current = O;
            }
          }
        }
        var H = d1(s, l, C, g);
        if (H !== null) {
          var J = eo();
          Mn(H, s, g, J), Y1(H, l, g);
        }
      }
      q1(s, g);
    }
    function K1(s) {
      var l = s.alternate;
      return s === Qi || l !== null && l === Qi;
    }
    function j1(s, l) {
      BC = WE = !0;
      var f = s.pending;
      f === null ? l.next = l : (l.next = f.next, f.next = l), s.pending = l;
    }
    function Y1(s, l, f) {
      if ($_(f)) {
        var g = l.lanes;
        g = W_(g, s.pendingLanes);
        var C = ei(g, f);
        l.lanes = C, Rc(s, C);
      }
    }
    function q1(s, l, f) {
      Jl(s, l);
    }
    var ib = {
      readContext: _n,
      useCallback: Ma,
      useContext: Ma,
      useEffect: Ma,
      useImperativeHandle: Ma,
      useInsertionEffect: Ma,
      useLayoutEffect: Ma,
      useMemo: Ma,
      useReducer: Ma,
      useRef: Ma,
      useState: Ma,
      useDebugValue: Ma,
      useDeferredValue: Ma,
      useTransition: Ma,
      useMutableSource: Ma,
      useSyncExternalStore: Ma,
      useId: Ma,
      unstable_isNewReconciler: ne
    }, X1 = null, Q1 = null, Z1 = null, J1 = null, hu = null, xl = null, rb = null;
    {
      var sO = function() {
        o("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, qt = function() {
        o("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      X1 = {
        readContext: function(s) {
          return _n(s);
        },
        useCallback: function(s, l) {
          return Oe = "useCallback", Ni(), Mg(l), iO(s, l);
        },
        useContext: function(s) {
          return Oe = "useContext", Ni(), _n(s);
        },
        useEffect: function(s, l) {
          return Oe = "useEffect", Ni(), Mg(l), YE(s, l);
        },
        useImperativeHandle: function(s, l, f) {
          return Oe = "useImperativeHandle", Ni(), Mg(f), tO(s, l, f);
        },
        useInsertionEffect: function(s, l) {
          return Oe = "useInsertionEffect", Ni(), Mg(l), JA(s, l);
        },
        useLayoutEffect: function(s, l) {
          return Oe = "useLayoutEffect", Ni(), Mg(l), eO(s, l);
        },
        useMemo: function(s, l) {
          Oe = "useMemo", Ni(), Mg(l);
          var f = dt.current;
          dt.current = hu;
          try {
            return rO(s, l);
          } finally {
            dt.current = f;
          }
        },
        useReducer: function(s, l, f) {
          Oe = "useReducer", Ni();
          var g = dt.current;
          dt.current = hu;
          try {
            return KA(s, l, f);
          } finally {
            dt.current = g;
          }
        },
        useRef: function(s) {
          return Oe = "useRef", Ni(), ZA(s);
        },
        useState: function(s) {
          Oe = "useState", Ni();
          var l = dt.current;
          dt.current = hu;
          try {
            return GE(s);
          } finally {
            dt.current = l;
          }
        },
        useDebugValue: function(s, l) {
          return Oe = "useDebugValue", Ni(), void 0;
        },
        useDeferredValue: function(s) {
          return Oe = "useDeferredValue", Ni(), nO(s);
        },
        useTransition: function() {
          return Oe = "useTransition", Ni(), aO();
        },
        useMutableSource: function(s, l, f) {
          return Oe = "useMutableSource", Ni(), void 0;
        },
        useSyncExternalStore: function(s, l, f) {
          return Oe = "useSyncExternalStore", Ni(), qA(s, l, f);
        },
        useId: function() {
          return Oe = "useId", Ni(), oO();
        },
        unstable_isNewReconciler: ne
      }, Q1 = {
        readContext: function(s) {
          return _n(s);
        },
        useCallback: function(s, l) {
          return Oe = "useCallback", rt(), iO(s, l);
        },
        useContext: function(s) {
          return Oe = "useContext", rt(), _n(s);
        },
        useEffect: function(s, l) {
          return Oe = "useEffect", rt(), YE(s, l);
        },
        useImperativeHandle: function(s, l, f) {
          return Oe = "useImperativeHandle", rt(), tO(s, l, f);
        },
        useInsertionEffect: function(s, l) {
          return Oe = "useInsertionEffect", rt(), JA(s, l);
        },
        useLayoutEffect: function(s, l) {
          return Oe = "useLayoutEffect", rt(), eO(s, l);
        },
        useMemo: function(s, l) {
          Oe = "useMemo", rt();
          var f = dt.current;
          dt.current = hu;
          try {
            return rO(s, l);
          } finally {
            dt.current = f;
          }
        },
        useReducer: function(s, l, f) {
          Oe = "useReducer", rt();
          var g = dt.current;
          dt.current = hu;
          try {
            return KA(s, l, f);
          } finally {
            dt.current = g;
          }
        },
        useRef: function(s) {
          return Oe = "useRef", rt(), ZA(s);
        },
        useState: function(s) {
          Oe = "useState", rt();
          var l = dt.current;
          dt.current = hu;
          try {
            return GE(s);
          } finally {
            dt.current = l;
          }
        },
        useDebugValue: function(s, l) {
          return Oe = "useDebugValue", rt(), void 0;
        },
        useDeferredValue: function(s) {
          return Oe = "useDeferredValue", rt(), nO(s);
        },
        useTransition: function() {
          return Oe = "useTransition", rt(), aO();
        },
        useMutableSource: function(s, l, f) {
          return Oe = "useMutableSource", rt(), void 0;
        },
        useSyncExternalStore: function(s, l, f) {
          return Oe = "useSyncExternalStore", rt(), qA(s, l, f);
        },
        useId: function() {
          return Oe = "useId", rt(), oO();
        },
        unstable_isNewReconciler: ne
      }, Z1 = {
        readContext: function(s) {
          return _n(s);
        },
        useCallback: function(s, l) {
          return Oe = "useCallback", rt(), JE(s, l);
        },
        useContext: function(s) {
          return Oe = "useContext", rt(), _n(s);
        },
        useEffect: function(s, l) {
          return Oe = "useEffect", rt(), $C(s, l);
        },
        useImperativeHandle: function(s, l, f) {
          return Oe = "useImperativeHandle", rt(), QE(s, l, f);
        },
        useInsertionEffect: function(s, l) {
          return Oe = "useInsertionEffect", rt(), qE(s, l);
        },
        useLayoutEffect: function(s, l) {
          return Oe = "useLayoutEffect", rt(), XE(s, l);
        },
        useMemo: function(s, l) {
          Oe = "useMemo", rt();
          var f = dt.current;
          dt.current = xl;
          try {
            return eb(s, l);
          } finally {
            dt.current = f;
          }
        },
        useReducer: function(s, l, f) {
          Oe = "useReducer", rt();
          var g = dt.current;
          dt.current = xl;
          try {
            return jA(s, l, f);
          } finally {
            dt.current = g;
          }
        },
        useRef: function(s) {
          return Oe = "useRef", rt(), KE();
        },
        useState: function(s) {
          Oe = "useState", rt();
          var l = dt.current;
          dt.current = xl;
          try {
            return XA(s);
          } finally {
            dt.current = l;
          }
        },
        useDebugValue: function(s, l) {
          return Oe = "useDebugValue", rt(), ZE();
        },
        useDeferredValue: function(s) {
          return Oe = "useDeferredValue", rt(), H1(s);
        },
        useTransition: function() {
          return Oe = "useTransition", rt(), W1();
        },
        useMutableSource: function(s, l, f) {
          return Oe = "useMutableSource", rt(), void 0;
        },
        useSyncExternalStore: function(s, l, f) {
          return Oe = "useSyncExternalStore", rt(), UE(s, l);
        },
        useId: function() {
          return Oe = "useId", rt(), tb();
        },
        unstable_isNewReconciler: ne
      }, J1 = {
        readContext: function(s) {
          return _n(s);
        },
        useCallback: function(s, l) {
          return Oe = "useCallback", rt(), JE(s, l);
        },
        useContext: function(s) {
          return Oe = "useContext", rt(), _n(s);
        },
        useEffect: function(s, l) {
          return Oe = "useEffect", rt(), $C(s, l);
        },
        useImperativeHandle: function(s, l, f) {
          return Oe = "useImperativeHandle", rt(), QE(s, l, f);
        },
        useInsertionEffect: function(s, l) {
          return Oe = "useInsertionEffect", rt(), qE(s, l);
        },
        useLayoutEffect: function(s, l) {
          return Oe = "useLayoutEffect", rt(), XE(s, l);
        },
        useMemo: function(s, l) {
          Oe = "useMemo", rt();
          var f = dt.current;
          dt.current = rb;
          try {
            return eb(s, l);
          } finally {
            dt.current = f;
          }
        },
        useReducer: function(s, l, f) {
          Oe = "useReducer", rt();
          var g = dt.current;
          dt.current = rb;
          try {
            return YA(s, l, f);
          } finally {
            dt.current = g;
          }
        },
        useRef: function(s) {
          return Oe = "useRef", rt(), KE();
        },
        useState: function(s) {
          Oe = "useState", rt();
          var l = dt.current;
          dt.current = rb;
          try {
            return QA(s);
          } finally {
            dt.current = l;
          }
        },
        useDebugValue: function(s, l) {
          return Oe = "useDebugValue", rt(), ZE();
        },
        useDeferredValue: function(s) {
          return Oe = "useDeferredValue", rt(), $1(s);
        },
        useTransition: function() {
          return Oe = "useTransition", rt(), U1();
        },
        useMutableSource: function(s, l, f) {
          return Oe = "useMutableSource", rt(), void 0;
        },
        useSyncExternalStore: function(s, l, f) {
          return Oe = "useSyncExternalStore", rt(), UE(s, l);
        },
        useId: function() {
          return Oe = "useId", rt(), tb();
        },
        unstable_isNewReconciler: ne
      }, hu = {
        readContext: function(s) {
          return sO(), _n(s);
        },
        useCallback: function(s, l) {
          return Oe = "useCallback", qt(), Ni(), iO(s, l);
        },
        useContext: function(s) {
          return Oe = "useContext", qt(), Ni(), _n(s);
        },
        useEffect: function(s, l) {
          return Oe = "useEffect", qt(), Ni(), YE(s, l);
        },
        useImperativeHandle: function(s, l, f) {
          return Oe = "useImperativeHandle", qt(), Ni(), tO(s, l, f);
        },
        useInsertionEffect: function(s, l) {
          return Oe = "useInsertionEffect", qt(), Ni(), JA(s, l);
        },
        useLayoutEffect: function(s, l) {
          return Oe = "useLayoutEffect", qt(), Ni(), eO(s, l);
        },
        useMemo: function(s, l) {
          Oe = "useMemo", qt(), Ni();
          var f = dt.current;
          dt.current = hu;
          try {
            return rO(s, l);
          } finally {
            dt.current = f;
          }
        },
        useReducer: function(s, l, f) {
          Oe = "useReducer", qt(), Ni();
          var g = dt.current;
          dt.current = hu;
          try {
            return KA(s, l, f);
          } finally {
            dt.current = g;
          }
        },
        useRef: function(s) {
          return Oe = "useRef", qt(), Ni(), ZA(s);
        },
        useState: function(s) {
          Oe = "useState", qt(), Ni();
          var l = dt.current;
          dt.current = hu;
          try {
            return GE(s);
          } finally {
            dt.current = l;
          }
        },
        useDebugValue: function(s, l) {
          return Oe = "useDebugValue", qt(), Ni(), void 0;
        },
        useDeferredValue: function(s) {
          return Oe = "useDeferredValue", qt(), Ni(), nO(s);
        },
        useTransition: function() {
          return Oe = "useTransition", qt(), Ni(), aO();
        },
        useMutableSource: function(s, l, f) {
          return Oe = "useMutableSource", qt(), Ni(), void 0;
        },
        useSyncExternalStore: function(s, l, f) {
          return Oe = "useSyncExternalStore", qt(), Ni(), qA(s, l, f);
        },
        useId: function() {
          return Oe = "useId", qt(), Ni(), oO();
        },
        unstable_isNewReconciler: ne
      }, xl = {
        readContext: function(s) {
          return sO(), _n(s);
        },
        useCallback: function(s, l) {
          return Oe = "useCallback", qt(), rt(), JE(s, l);
        },
        useContext: function(s) {
          return Oe = "useContext", qt(), rt(), _n(s);
        },
        useEffect: function(s, l) {
          return Oe = "useEffect", qt(), rt(), $C(s, l);
        },
        useImperativeHandle: function(s, l, f) {
          return Oe = "useImperativeHandle", qt(), rt(), QE(s, l, f);
        },
        useInsertionEffect: function(s, l) {
          return Oe = "useInsertionEffect", qt(), rt(), qE(s, l);
        },
        useLayoutEffect: function(s, l) {
          return Oe = "useLayoutEffect", qt(), rt(), XE(s, l);
        },
        useMemo: function(s, l) {
          Oe = "useMemo", qt(), rt();
          var f = dt.current;
          dt.current = xl;
          try {
            return eb(s, l);
          } finally {
            dt.current = f;
          }
        },
        useReducer: function(s, l, f) {
          Oe = "useReducer", qt(), rt();
          var g = dt.current;
          dt.current = xl;
          try {
            return jA(s, l, f);
          } finally {
            dt.current = g;
          }
        },
        useRef: function(s) {
          return Oe = "useRef", qt(), rt(), KE();
        },
        useState: function(s) {
          Oe = "useState", qt(), rt();
          var l = dt.current;
          dt.current = xl;
          try {
            return XA(s);
          } finally {
            dt.current = l;
          }
        },
        useDebugValue: function(s, l) {
          return Oe = "useDebugValue", qt(), rt(), ZE();
        },
        useDeferredValue: function(s) {
          return Oe = "useDeferredValue", qt(), rt(), H1(s);
        },
        useTransition: function() {
          return Oe = "useTransition", qt(), rt(), W1();
        },
        useMutableSource: function(s, l, f) {
          return Oe = "useMutableSource", qt(), rt(), void 0;
        },
        useSyncExternalStore: function(s, l, f) {
          return Oe = "useSyncExternalStore", qt(), rt(), UE(s, l);
        },
        useId: function() {
          return Oe = "useId", qt(), rt(), tb();
        },
        unstable_isNewReconciler: ne
      }, rb = {
        readContext: function(s) {
          return sO(), _n(s);
        },
        useCallback: function(s, l) {
          return Oe = "useCallback", qt(), rt(), JE(s, l);
        },
        useContext: function(s) {
          return Oe = "useContext", qt(), rt(), _n(s);
        },
        useEffect: function(s, l) {
          return Oe = "useEffect", qt(), rt(), $C(s, l);
        },
        useImperativeHandle: function(s, l, f) {
          return Oe = "useImperativeHandle", qt(), rt(), QE(s, l, f);
        },
        useInsertionEffect: function(s, l) {
          return Oe = "useInsertionEffect", qt(), rt(), qE(s, l);
        },
        useLayoutEffect: function(s, l) {
          return Oe = "useLayoutEffect", qt(), rt(), XE(s, l);
        },
        useMemo: function(s, l) {
          Oe = "useMemo", qt(), rt();
          var f = dt.current;
          dt.current = xl;
          try {
            return eb(s, l);
          } finally {
            dt.current = f;
          }
        },
        useReducer: function(s, l, f) {
          Oe = "useReducer", qt(), rt();
          var g = dt.current;
          dt.current = xl;
          try {
            return YA(s, l, f);
          } finally {
            dt.current = g;
          }
        },
        useRef: function(s) {
          return Oe = "useRef", qt(), rt(), KE();
        },
        useState: function(s) {
          Oe = "useState", qt(), rt();
          var l = dt.current;
          dt.current = xl;
          try {
            return QA(s);
          } finally {
            dt.current = l;
          }
        },
        useDebugValue: function(s, l) {
          return Oe = "useDebugValue", qt(), rt(), ZE();
        },
        useDeferredValue: function(s) {
          return Oe = "useDeferredValue", qt(), rt(), $1(s);
        },
        useTransition: function() {
          return Oe = "useTransition", qt(), rt(), U1();
        },
        useMutableSource: function(s, l, f) {
          return Oe = "useMutableSource", qt(), rt(), void 0;
        },
        useSyncExternalStore: function(s, l, f) {
          return Oe = "useSyncExternalStore", qt(), rt(), UE(s, l);
        },
        useId: function() {
          return Oe = "useId", qt(), rt(), tb();
        },
        unstable_isNewReconciler: ne
      };
    }
    var th = e.unstable_now, eN = 0, nb = -1, zC = -1, ab = -1, lO = !1, ob = !1;
    function tN() {
      return lO;
    }
    function VZ() {
      ob = !0;
    }
    function NZ() {
      lO = !1, ob = !1;
    }
    function HZ() {
      lO = ob, ob = !1;
    }
    function iN() {
      return eN;
    }
    function rN() {
      eN = th();
    }
    function uO(s) {
      zC = th(), s.actualStartTime < 0 && (s.actualStartTime = th());
    }
    function nN(s) {
      zC = -1;
    }
    function sb(s, l) {
      if (zC >= 0) {
        var f = th() - zC;
        s.actualDuration += f, l && (s.selfBaseDuration = f), zC = -1;
      }
    }
    function fu(s) {
      if (nb >= 0) {
        var l = th() - nb;
        nb = -1;
        for (var f = s.return; f !== null; ) {
          switch (f.tag) {
            case _:
              var g = f.stateNode;
              g.effectDuration += l;
              return;
            case te:
              var C = f.stateNode;
              C.effectDuration += l;
              return;
          }
          f = f.return;
        }
      }
    }
    function dO(s) {
      if (ab >= 0) {
        var l = th() - ab;
        ab = -1;
        for (var f = s.return; f !== null; ) {
          switch (f.tag) {
            case _:
              var g = f.stateNode;
              g !== null && (g.passiveEffectDuration += l);
              return;
            case te:
              var C = f.stateNode;
              C !== null && (C.passiveEffectDuration += l);
              return;
          }
          f = f.return;
        }
      }
    }
    function pu() {
      nb = th();
    }
    function cO() {
      ab = th();
    }
    function hO(s) {
      for (var l = s.child; l; )
        s.actualDuration += l.actualDuration, l = l.sibling;
    }
    function Uf(s, l) {
      return {
        value: s,
        source: l,
        stack: Qm(l),
        digest: null
      };
    }
    function fO(s, l, f) {
      return {
        value: s,
        source: null,
        stack: f ?? null,
        digest: l ?? null
      };
    }
    function $Z(s, l) {
      return !0;
    }
    function pO(s, l) {
      try {
        var f = $Z(s, l);
        if (f === !1)
          return;
        var g = l.value, C = l.source, S = l.stack, T = S !== null ? S : "";
        if (g != null && g._suppressLogging) {
          if (s.tag === p)
            return;
          console.error(g);
        }
        var O = C ? Jt(C) : null, M = O ? "The above error occurred in the <" + O + "> component:" : "The above error occurred in one of your React components:", V;
        if (s.tag === _)
          V = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var H = Jt(s) || "Anonymous";
          V = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + H + ".");
        }
        var J = M + `
` + T + `

` + ("" + V);
        console.error(J);
      } catch (Q) {
        setTimeout(function() {
          throw Q;
        });
      }
    }
    var zZ = typeof WeakMap == "function" ? WeakMap : Map;
    function aN(s, l, f) {
      var g = bd(nr, f);
      g.tag = pA, g.payload = {
        element: null
      };
      var C = l.value;
      return g.callback = function() {
        Nee(C), pO(s, l);
      }, g;
    }
    function vO(s, l, f) {
      var g = bd(nr, f);
      g.tag = pA;
      var C = s.type.getDerivedStateFromError;
      if (typeof C == "function") {
        var S = l.value;
        g.payload = function() {
          return C(S);
        }, g.callback = function() {
          mH(s), pO(s, l);
        };
      }
      var T = s.stateNode;
      return T !== null && typeof T.componentDidCatch == "function" && (g.callback = function() {
        mH(s), pO(s, l), typeof C != "function" && Bee(this);
        var M = l.value, V = l.stack;
        this.componentDidCatch(M, {
          componentStack: V !== null ? V : ""
        }), typeof C != "function" && (Oa(s.lanes, Ht) || o("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", Jt(s) || "Unknown"));
      }), g;
    }
    function oN(s, l, f) {
      var g = s.pingCache, C;
      if (g === null ? (g = s.pingCache = new zZ(), C = /* @__PURE__ */ new Set(), g.set(l, C)) : (C = g.get(l), C === void 0 && (C = /* @__PURE__ */ new Set(), g.set(l, C))), !C.has(f)) {
        C.add(f);
        var S = Hee.bind(null, s, l, f);
        bn && ny(s, f), l.then(S, S);
      }
    }
    function WZ(s, l, f, g) {
      var C = s.updateQueue;
      if (C === null) {
        var S = /* @__PURE__ */ new Set();
        S.add(f), s.updateQueue = S;
      } else
        C.add(f);
    }
    function UZ(s, l) {
      var f = s.tag;
      if ((s.mode & li) === Ft && (f === c || f === K || f === pe)) {
        var g = s.alternate;
        g ? (s.updateQueue = g.updateQueue, s.memoizedState = g.memoizedState, s.lanes = g.lanes) : (s.updateQueue = null, s.memoizedState = null);
      }
    }
    function sN(s) {
      var l = s;
      do {
        if (l.tag === z && DZ(l))
          return l;
        l = l.return;
      } while (l !== null);
      return null;
    }
    function lN(s, l, f, g, C) {
      if ((s.mode & li) === Ft) {
        if (s === l)
          s.flags |= pn;
        else {
          if (s.flags |= Gt, f.flags |= hf, f.flags &= ~(yv | Ka), f.tag === p) {
            var S = f.alternate;
            if (S === null)
              f.tag = be;
            else {
              var T = bd(nr, Ht);
              T.tag = RE, Qc(f, T, Ht);
            }
          }
          f.lanes = ei(f.lanes, Ht);
        }
        return s;
      }
      return s.flags |= pn, s.lanes = C, s;
    }
    function GZ(s, l, f, g, C) {
      if (f.flags |= Ka, bn && ny(s, C), g !== null && typeof g == "object" && typeof g.then == "function") {
        var S = g;
        UZ(f), oa() && f.mode & li && ZV();
        var T = sN(l);
        if (T !== null) {
          T.flags &= ~Mr, lN(T, l, f, s, C), T.mode & li && oN(s, S, C), WZ(T, s, S);
          return;
        } else {
          if (!Ac(C)) {
            oN(s, S, C), qO();
            return;
          }
          var O = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          g = O;
        }
      } else if (oa() && f.mode & li) {
        ZV();
        var M = sN(l);
        if (M !== null) {
          (M.flags & pn) === Lt && (M.flags |= Mr), lN(M, l, f, s, C), sA(Uf(g, f));
          return;
        }
      }
      g = Uf(g, f), Aee(g);
      var V = l;
      do {
        switch (V.tag) {
          case _: {
            var H = g;
            V.flags |= pn;
            var J = nn(C);
            V.lanes = ei(V.lanes, J);
            var Q = aN(V, H, J);
            mA(V, Q);
            return;
          }
          case p:
            var fe = g, ce = V.type, me = V.stateNode;
            if ((V.flags & Gt) === Lt && (typeof ce.getDerivedStateFromError == "function" || me !== null && typeof me.componentDidCatch == "function" && !lH(me))) {
              V.flags |= pn;
              var lt = nn(C);
              V.lanes = ei(V.lanes, lt);
              var Mt = vO(V, fe, lt);
              mA(V, Mt);
              return;
            }
            break;
        }
        V = V.return;
      } while (V !== null);
    }
    function KZ() {
      return null;
    }
    var WC = i.ReactCurrentOwner, Sl = !1, gO, UC, mO, _O, CO, Gf, yO, lb;
    gO = {}, UC = {}, mO = {}, _O = {}, CO = {}, Gf = !1, yO = {}, lb = {};
    function Za(s, l, f, g) {
      s === null ? l.child = T1(l, null, f, g) : l.child = Dg(l, s.child, f, g);
    }
    function jZ(s, l, f, g) {
      l.child = Dg(l, s.child, null, g), l.child = Dg(l, null, f, g);
    }
    function uN(s, l, f, g, C) {
      if (l.type !== l.elementType) {
        var S = f.propTypes;
        S && gl(
          S,
          g,
          // Resolved props
          "prop",
          ir(f)
        );
      }
      var T = f.render, O = l.ref, M, V;
      Ig(l, C), Zl(l);
      {
        if (WC.current = l, Xo(!0), M = kg(s, l, T, g, O, C), V = Pg(), l.mode & Ir) {
          rn(!0);
          try {
            M = kg(s, l, T, g, O, C), V = Pg();
          } finally {
            rn(!1);
          }
        }
        Xo(!1);
      }
      return Ju(), s !== null && !Sl ? (R1(s, l, C), wd(s, l, C)) : (oa() && V && tA(l), l.flags |= Kl, Za(s, l, M, C), l.child);
    }
    function dN(s, l, f, g, C) {
      if (s === null) {
        var S = f.type;
        if (rte(S) && f.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        f.defaultProps === void 0) {
          var T = S;
          return T = Wg(S), l.tag = pe, l.type = T, EO(l, S), cN(s, l, T, g, C);
        }
        {
          var O = S.propTypes;
          O && gl(
            O,
            g,
            // Resolved props
            "prop",
            ir(S)
          );
        }
        var M = oR(f.type, null, g, l, l.mode, C);
        return M.ref = l.ref, M.return = l, l.child = M, M;
      }
      {
        var V = f.type, H = V.propTypes;
        H && gl(
          H,
          g,
          // Resolved props
          "prop",
          ir(V)
        );
      }
      var J = s.child, Q = AO(s, C);
      if (!Q) {
        var fe = J.memoizedProps, ce = f.compare;
        if (ce = ce !== null ? ce : At, ce(fe, g) && s.ref === l.ref)
          return wd(s, l, C);
      }
      l.flags |= Kl;
      var me = Xf(J, g);
      return me.ref = l.ref, me.return = l, l.child = me, me;
    }
    function cN(s, l, f, g, C) {
      if (l.type !== l.elementType) {
        var S = l.elementType;
        if (S.$$typeof === Xe) {
          var T = S, O = T._payload, M = T._init;
          try {
            S = M(O);
          } catch {
            S = null;
          }
          var V = S && S.propTypes;
          V && gl(
            V,
            g,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            ir(S)
          );
        }
      }
      if (s !== null) {
        var H = s.memoizedProps;
        if (At(H, g) && s.ref === l.ref && // Prevent bailout if the implementation changed due to hot reload.
        l.type === s.type)
          if (Sl = !1, l.pendingProps = g = H, AO(s, C))
            (s.flags & hf) !== Lt && (Sl = !0);
          else
            return l.lanes = s.lanes, wd(s, l, C);
      }
      return xO(s, l, f, g, C);
    }
    function hN(s, l, f) {
      var g = l.pendingProps, C = g.children, S = s !== null ? s.memoizedState : null;
      if (g.mode === "hidden" || j)
        if ((l.mode & li) === Ft) {
          var T = {
            baseLanes: Te,
            cachePool: null,
            transitions: null
          };
          l.memoizedState = T, xb(l, f);
        } else if (Oa(f, Aa)) {
          var J = {
            baseLanes: Te,
            cachePool: null,
            transitions: null
          };
          l.memoizedState = J;
          var Q = S !== null ? S.baseLanes : f;
          xb(l, Q);
        } else {
          var O = null, M;
          if (S !== null) {
            var V = S.baseLanes;
            M = ei(V, f);
          } else
            M = f;
          l.lanes = l.childLanes = Aa;
          var H = {
            baseLanes: M,
            cachePool: O,
            transitions: null
          };
          return l.memoizedState = H, l.updateQueue = null, xb(l, M), null;
        }
      else {
        var fe;
        S !== null ? (fe = ei(S.baseLanes, f), l.memoizedState = null) : fe = f, xb(l, fe);
      }
      return Za(s, l, C, f), l.child;
    }
    function YZ(s, l, f) {
      var g = l.pendingProps;
      return Za(s, l, g, f), l.child;
    }
    function qZ(s, l, f) {
      var g = l.pendingProps.children;
      return Za(s, l, g, f), l.child;
    }
    function XZ(s, l, f) {
      {
        l.flags |= ri;
        {
          var g = l.stateNode;
          g.effectDuration = 0, g.passiveEffectDuration = 0;
        }
      }
      var C = l.pendingProps, S = C.children;
      return Za(s, l, S, f), l.child;
    }
    function fN(s, l) {
      var f = l.ref;
      (s === null && f !== null || s !== null && s.ref !== f) && (l.flags |= Ea, l.flags |= T_);
    }
    function xO(s, l, f, g, C) {
      if (l.type !== l.elementType) {
        var S = f.propTypes;
        S && gl(
          S,
          g,
          // Resolved props
          "prop",
          ir(f)
        );
      }
      var T;
      {
        var O = xg(l, f, !0);
        T = Sg(l, O);
      }
      var M, V;
      Ig(l, C), Zl(l);
      {
        if (WC.current = l, Xo(!0), M = kg(s, l, f, g, T, C), V = Pg(), l.mode & Ir) {
          rn(!0);
          try {
            M = kg(s, l, f, g, T, C), V = Pg();
          } finally {
            rn(!1);
          }
        }
        Xo(!1);
      }
      return Ju(), s !== null && !Sl ? (R1(s, l, C), wd(s, l, C)) : (oa() && V && tA(l), l.flags |= Kl, Za(s, l, M, C), l.child);
    }
    function pN(s, l, f, g, C) {
      {
        switch (_te(l)) {
          case !1: {
            var S = l.stateNode, T = l.type, O = new T(l.memoizedProps, S.context), M = O.state;
            S.updater.enqueueSetState(S, M, null);
            break;
          }
          case !0: {
            l.flags |= Gt, l.flags |= pn;
            var V = new Error("Simulated error coming from DevTools"), H = nn(C);
            l.lanes = ei(l.lanes, H);
            var J = vO(l, Uf(V, l), H);
            mA(l, J);
            break;
          }
        }
        if (l.type !== l.elementType) {
          var Q = f.propTypes;
          Q && gl(
            Q,
            g,
            // Resolved props
            "prop",
            ir(f)
          );
        }
      }
      var fe;
      uu(f) ? (fe = !0, yE(l)) : fe = !1, Ig(l, C);
      var ce = l.stateNode, me;
      ce === null ? (db(s, l), x1(l, f, g), AA(l, f, g, C), me = !0) : s === null ? me = SZ(l, f, g, C) : me = EZ(s, l, f, g, C);
      var lt = SO(s, l, f, me, fe, C);
      {
        var Mt = l.stateNode;
        me && Mt.props !== g && (Gf || o("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Jt(l) || "a component"), Gf = !0);
      }
      return lt;
    }
    function SO(s, l, f, g, C, S) {
      fN(s, l);
      var T = (l.flags & Gt) !== Lt;
      if (!g && !T)
        return C && YV(l, f, !1), wd(s, l, S);
      var O = l.stateNode;
      WC.current = l;
      var M;
      if (T && typeof f.getDerivedStateFromError != "function")
        M = null, nN();
      else {
        Zl(l);
        {
          if (Xo(!0), M = O.render(), l.mode & Ir) {
            rn(!0);
            try {
              O.render();
            } finally {
              rn(!1);
            }
          }
          Xo(!1);
        }
        Ju();
      }
      return l.flags |= Kl, s !== null && T ? jZ(s, l, M, S) : Za(s, l, M, S), l.memoizedState = O.state, C && YV(l, f, !0), l.child;
    }
    function vN(s) {
      var l = s.stateNode;
      l.pendingContext ? KV(s, l.pendingContext, l.pendingContext !== l.context) : l.context && KV(s, l.context, !1), PA(s, l.containerInfo);
    }
    function QZ(s, l, f) {
      if (vN(l), s === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var g = l.pendingProps, C = l.memoizedState, S = C.element;
      f1(s, l), PE(l, g, null, f);
      var T = l.memoizedState, O = l.stateNode, M = T.element;
      if (C.isDehydrated) {
        var V = {
          element: M,
          isDehydrated: !1,
          cache: T.cache,
          pendingSuspenseBoundaries: T.pendingSuspenseBoundaries,
          transitions: T.transitions
        }, H = l.updateQueue;
        if (H.baseState = V, l.memoizedState = V, l.flags & Mr) {
          var J = Uf(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), l);
          return gN(s, l, M, f, J);
        } else if (M !== S) {
          var Q = Uf(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), l);
          return gN(s, l, M, f, Q);
        } else {
          tZ(l);
          var fe = T1(l, null, M, f);
          l.child = fe;
          for (var ce = fe; ce; )
            ce.flags = ce.flags & ~vr | yo, ce = ce.sibling;
        }
      } else {
        if (wg(), M === S)
          return wd(s, l, f);
        Za(s, l, M, f);
      }
      return l.child;
    }
    function gN(s, l, f, g, C) {
      return wg(), sA(C), l.flags |= Mr, Za(s, l, f, g), l.child;
    }
    function ZZ(s, l, f) {
      D1(l), s === null && oA(l);
      var g = l.type, C = l.pendingProps, S = s !== null ? s.memoizedProps : null, T = C.children, O = $D(g, C);
      return O ? T = null : S !== null && $D(g, S) && (l.flags |= Vi), fN(s, l), Za(s, l, T, f), l.child;
    }
    function JZ(s, l) {
      return s === null && oA(l), null;
    }
    function eJ(s, l, f, g) {
      db(s, l);
      var C = l.pendingProps, S = f, T = S._payload, O = S._init, M = O(T);
      l.type = M;
      var V = l.tag = nte(M), H = Cl(M, C), J;
      switch (V) {
        case c:
          return EO(l, M), l.type = M = Wg(M), J = xO(null, l, M, H, g), J;
        case p:
          return l.type = M = eR(M), J = pN(null, l, M, H, g), J;
        case K:
          return l.type = M = tR(M), J = uN(null, l, M, H, g), J;
        case ie: {
          if (l.type !== l.elementType) {
            var Q = M.propTypes;
            Q && gl(
              Q,
              H,
              // Resolved for outer only
              "prop",
              ir(M)
            );
          }
          return J = dN(
            null,
            l,
            M,
            Cl(M.type, H),
            // The inner type can have defaults too
            g
          ), J;
        }
      }
      var fe = "";
      throw M !== null && typeof M == "object" && M.$$typeof === Xe && (fe = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + M + ". " + ("Lazy element type must resolve to a class or function." + fe));
    }
    function tJ(s, l, f, g, C) {
      db(s, l), l.tag = p;
      var S;
      return uu(f) ? (S = !0, yE(l)) : S = !1, Ig(l, C), x1(l, f, g), AA(l, f, g, C), SO(null, l, f, !0, S, C);
    }
    function iJ(s, l, f, g) {
      db(s, l);
      var C = l.pendingProps, S;
      {
        var T = xg(l, f, !1);
        S = Sg(l, T);
      }
      Ig(l, g);
      var O, M;
      Zl(l);
      {
        if (f.prototype && typeof f.prototype.render == "function") {
          var V = ir(f) || "Unknown";
          gO[V] || (o("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", V, V), gO[V] = !0);
        }
        l.mode & Ir && _l.recordLegacyContextWarning(l, null), Xo(!0), WC.current = l, O = kg(null, l, f, C, S, g), M = Pg(), Xo(!1);
      }
      if (Ju(), l.flags |= Kl, typeof O == "object" && O !== null && typeof O.render == "function" && O.$$typeof === void 0) {
        var H = ir(f) || "Unknown";
        UC[H] || (o("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", H, H, H), UC[H] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof O == "object" && O !== null && typeof O.render == "function" && O.$$typeof === void 0
      ) {
        {
          var J = ir(f) || "Unknown";
          UC[J] || (o("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", J, J, J), UC[J] = !0);
        }
        l.tag = p, l.memoizedState = null, l.updateQueue = null;
        var Q = !1;
        return uu(f) ? (Q = !0, yE(l)) : Q = !1, l.memoizedState = O.state !== null && O.state !== void 0 ? O.state : null, gA(l), y1(l, O), AA(l, f, C, g), SO(null, l, f, !0, Q, g);
      } else {
        if (l.tag = c, l.mode & Ir) {
          rn(!0);
          try {
            O = kg(null, l, f, C, S, g), M = Pg();
          } finally {
            rn(!1);
          }
        }
        return oa() && M && tA(l), Za(null, l, O, g), EO(l, f), l.child;
      }
    }
    function EO(s, l) {
      {
        if (l && l.childContextTypes && o("%s(...): childContextTypes cannot be defined on a function component.", l.displayName || l.name || "Component"), s.ref !== null) {
          var f = "", g = go();
          g && (f += `

Check the render method of \`` + g + "`.");
          var C = g || "", S = s._debugSource;
          S && (C = S.fileName + ":" + S.lineNumber), CO[C] || (CO[C] = !0, o("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", f));
        }
        if (typeof l.getDerivedStateFromProps == "function") {
          var T = ir(l) || "Unknown";
          _O[T] || (o("%s: Function components do not support getDerivedStateFromProps.", T), _O[T] = !0);
        }
        if (typeof l.contextType == "object" && l.contextType !== null) {
          var O = ir(l) || "Unknown";
          mO[O] || (o("%s: Function components do not support contextType.", O), mO[O] = !0);
        }
      }
    }
    var bO = {
      dehydrated: null,
      treeContext: null,
      retryLane: yi
    };
    function wO(s) {
      return {
        baseLanes: s,
        cachePool: KZ(),
        transitions: null
      };
    }
    function rJ(s, l) {
      var f = null;
      return {
        baseLanes: ei(s.baseLanes, l),
        cachePool: f,
        transitions: s.transitions
      };
    }
    function nJ(s, l, f, g) {
      if (l !== null) {
        var C = l.memoizedState;
        if (C === null)
          return !1;
      }
      return VA(s, PC);
    }
    function aJ(s, l) {
      return Oc(s.childLanes, l);
    }
    function mN(s, l, f) {
      var g = l.pendingProps;
      Cte(l) && (l.flags |= Gt);
      var C = yl.current, S = !1, T = (l.flags & Gt) !== Lt;
      if (T || nJ(C, s) ? (S = !0, l.flags &= ~Gt) : (s === null || s.memoizedState !== null) && (C = IZ(C, O1)), C = Og(C), Jc(l, C), s === null) {
        oA(l);
        var O = l.memoizedState;
        if (O !== null) {
          var M = O.dehydrated;
          if (M !== null)
            return dJ(l, M);
        }
        var V = g.children, H = g.fallback;
        if (S) {
          var J = oJ(l, V, H, f), Q = l.child;
          return Q.memoizedState = wO(f), l.memoizedState = bO, J;
        } else
          return TO(l, V);
      } else {
        var fe = s.memoizedState;
        if (fe !== null) {
          var ce = fe.dehydrated;
          if (ce !== null)
            return cJ(s, l, T, g, ce, fe, f);
        }
        if (S) {
          var me = g.fallback, lt = g.children, Mt = lJ(s, l, lt, me, f), Tt = l.child, vi = s.child.memoizedState;
          return Tt.memoizedState = vi === null ? wO(f) : rJ(vi, f), Tt.childLanes = aJ(s, f), l.memoizedState = bO, Mt;
        } else {
          var gi = g.children, se = sJ(s, l, gi, f);
          return l.memoizedState = null, se;
        }
      }
    }
    function TO(s, l, f) {
      var g = s.mode, C = {
        mode: "visible",
        children: l
      }, S = IO(C, g);
      return S.return = s, s.child = S, S;
    }
    function oJ(s, l, f, g) {
      var C = s.mode, S = s.child, T = {
        mode: "hidden",
        children: l
      }, O, M;
      return (C & li) === Ft && S !== null ? (O = S, O.childLanes = Te, O.pendingProps = T, s.mode & Vt && (O.actualDuration = 0, O.actualStartTime = -1, O.selfBaseDuration = 0, O.treeBaseDuration = 0), M = sh(f, C, g, null)) : (O = IO(T, C), M = sh(f, C, g, null)), O.return = s, M.return = s, O.sibling = M, s.child = O, M;
    }
    function IO(s, l, f) {
      return CH(s, l, Te, null);
    }
    function _N(s, l) {
      return Xf(s, l);
    }
    function sJ(s, l, f, g) {
      var C = s.child, S = C.sibling, T = _N(C, {
        mode: "visible",
        children: f
      });
      if ((l.mode & li) === Ft && (T.lanes = g), T.return = l, T.sibling = null, S !== null) {
        var O = l.deletions;
        O === null ? (l.deletions = [S], l.flags |= Fi) : O.push(S);
      }
      return l.child = T, T;
    }
    function lJ(s, l, f, g, C) {
      var S = l.mode, T = s.child, O = T.sibling, M = {
        mode: "hidden",
        children: f
      }, V;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (S & li) === Ft && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        l.child !== T
      ) {
        var H = l.child;
        V = H, V.childLanes = Te, V.pendingProps = M, l.mode & Vt && (V.actualDuration = 0, V.actualStartTime = -1, V.selfBaseDuration = T.selfBaseDuration, V.treeBaseDuration = T.treeBaseDuration), l.deletions = null;
      } else
        V = _N(T, M), V.subtreeFlags = T.subtreeFlags & En;
      var J;
      return O !== null ? J = Xf(O, g) : (J = sh(g, S, C, null), J.flags |= vr), J.return = l, V.return = l, V.sibling = J, l.child = V, J;
    }
    function ub(s, l, f, g) {
      g !== null && sA(g), Dg(l, s.child, null, f);
      var C = l.pendingProps, S = C.children, T = TO(l, S);
      return T.flags |= vr, l.memoizedState = null, T;
    }
    function uJ(s, l, f, g, C) {
      var S = l.mode, T = {
        mode: "visible",
        children: f
      }, O = IO(T, S), M = sh(g, S, C, null);
      return M.flags |= vr, O.return = l, M.return = l, O.sibling = M, l.child = O, (l.mode & li) !== Ft && Dg(l, s.child, null, C), M;
    }
    function dJ(s, l, f) {
      return (s.mode & li) === Ft ? (o("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), s.lanes = Ht) : GD(l) ? s.lanes = id : s.lanes = Aa, null;
    }
    function cJ(s, l, f, g, C, S, T) {
      if (f)
        if (l.flags & Mr) {
          l.flags &= ~Mr;
          var se = fO(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return ub(s, l, T, se);
        } else {
          if (l.memoizedState !== null)
            return l.child = s.child, l.flags |= Gt, null;
          var Se = g.children, le = g.fallback, He = uJ(s, l, Se, le, T), pt = l.child;
          return pt.memoizedState = wO(T), l.memoizedState = bO, He;
        }
      else {
        if (JQ(), (l.mode & li) === Ft)
          return ub(
            s,
            l,
            T,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (GD(C)) {
          var O, M, V;
          {
            var H = gQ(C);
            O = H.digest, M = H.message, V = H.stack;
          }
          var J;
          M ? J = new Error(M) : J = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var Q = fO(J, O, V);
          return ub(s, l, T, Q);
        }
        var fe = Oa(T, s.childLanes);
        if (Sl || fe) {
          var ce = yb();
          if (ce !== null) {
            var me = hD(ce, T);
            if (me !== yi && me !== S.retryLane) {
              S.retryLane = me;
              var lt = nr;
              Oo(s, me), Mn(ce, s, me, lt);
            }
          }
          qO();
          var Mt = fO(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return ub(s, l, T, Mt);
        } else if (HV(C)) {
          l.flags |= Gt, l.child = s.child;
          var Tt = $ee.bind(null, s);
          return mQ(C, Tt), null;
        } else {
          iZ(l, C, S.treeContext);
          var vi = g.children, gi = TO(l, vi);
          return gi.flags |= yo, gi;
        }
      }
    }
    function CN(s, l, f) {
      s.lanes = ei(s.lanes, l);
      var g = s.alternate;
      g !== null && (g.lanes = ei(g.lanes, l)), hA(s.return, l, f);
    }
    function hJ(s, l, f) {
      for (var g = l; g !== null; ) {
        if (g.tag === z) {
          var C = g.memoizedState;
          C !== null && CN(g, f, s);
        } else if (g.tag === Ce)
          CN(g, f, s);
        else if (g.child !== null) {
          g.child.return = g, g = g.child;
          continue;
        }
        if (g === s)
          return;
        for (; g.sibling === null; ) {
          if (g.return === null || g.return === s)
            return;
          g = g.return;
        }
        g.sibling.return = g.return, g = g.sibling;
      }
    }
    function fJ(s) {
      for (var l = s, f = null; l !== null; ) {
        var g = l.alternate;
        g !== null && zE(g) === null && (f = l), l = l.sibling;
      }
      return f;
    }
    function pJ(s) {
      if (s !== void 0 && s !== "forwards" && s !== "backwards" && s !== "together" && !yO[s])
        if (yO[s] = !0, typeof s == "string")
          switch (s.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              o('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', s, s.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              o('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', s, s.toLowerCase());
              break;
            }
            default:
              o('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', s);
              break;
          }
        else
          o('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', s);
    }
    function vJ(s, l) {
      s !== void 0 && !lb[s] && (s !== "collapsed" && s !== "hidden" ? (lb[s] = !0, o('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', s)) : l !== "forwards" && l !== "backwards" && (lb[s] = !0, o('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', s)));
    }
    function yN(s, l) {
      {
        var f = hn(s), g = !f && typeof Zs(s) == "function";
        if (f || g) {
          var C = f ? "array" : "iterable";
          return o("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", C, l, C), !1;
        }
      }
      return !0;
    }
    function gJ(s, l) {
      if ((l === "forwards" || l === "backwards") && s !== void 0 && s !== null && s !== !1)
        if (hn(s)) {
          for (var f = 0; f < s.length; f++)
            if (!yN(s[f], f))
              return;
        } else {
          var g = Zs(s);
          if (typeof g == "function") {
            var C = g.call(s);
            if (C)
              for (var S = C.next(), T = 0; !S.done; S = C.next()) {
                if (!yN(S.value, T))
                  return;
                T++;
              }
          } else
            o('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', l);
        }
    }
    function DO(s, l, f, g, C) {
      var S = s.memoizedState;
      S === null ? s.memoizedState = {
        isBackwards: l,
        rendering: null,
        renderingStartTime: 0,
        last: g,
        tail: f,
        tailMode: C
      } : (S.isBackwards = l, S.rendering = null, S.renderingStartTime = 0, S.last = g, S.tail = f, S.tailMode = C);
    }
    function xN(s, l, f) {
      var g = l.pendingProps, C = g.revealOrder, S = g.tail, T = g.children;
      pJ(C), vJ(S, C), gJ(T, C), Za(s, l, T, f);
      var O = yl.current, M = VA(O, PC);
      if (M)
        O = NA(O, PC), l.flags |= Gt;
      else {
        var V = s !== null && (s.flags & Gt) !== Lt;
        V && hJ(l, l.child, f), O = Og(O);
      }
      if (Jc(l, O), (l.mode & li) === Ft)
        l.memoizedState = null;
      else
        switch (C) {
          case "forwards": {
            var H = fJ(l.child), J;
            H === null ? (J = l.child, l.child = null) : (J = H.sibling, H.sibling = null), DO(
              l,
              !1,
              // isBackwards
              J,
              H,
              S
            );
            break;
          }
          case "backwards": {
            var Q = null, fe = l.child;
            for (l.child = null; fe !== null; ) {
              var ce = fe.alternate;
              if (ce !== null && zE(ce) === null) {
                l.child = fe;
                break;
              }
              var me = fe.sibling;
              fe.sibling = Q, Q = fe, fe = me;
            }
            DO(
              l,
              !0,
              // isBackwards
              Q,
              null,
              // last
              S
            );
            break;
          }
          case "together": {
            DO(
              l,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            l.memoizedState = null;
        }
      return l.child;
    }
    function mJ(s, l, f) {
      PA(l, l.stateNode.containerInfo);
      var g = l.pendingProps;
      return s === null ? l.child = Dg(l, null, g, f) : Za(s, l, g, f), l.child;
    }
    var SN = !1;
    function _J(s, l, f) {
      var g = l.type, C = g._context, S = l.pendingProps, T = l.memoizedProps, O = S.value;
      {
        "value" in S || SN || (SN = !0, o("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var M = l.type.propTypes;
        M && gl(M, S, "prop", "Context.Provider");
      }
      if (u1(l, C, O), T !== null) {
        var V = T.value;
        if (St(V, O)) {
          if (T.children === S.children && !_E())
            return wd(s, l, f);
        } else
          hZ(l, C, f);
      }
      var H = S.children;
      return Za(s, l, H, f), l.child;
    }
    var EN = !1;
    function CJ(s, l, f) {
      var g = l.type;
      g._context === void 0 ? g !== g.Consumer && (EN || (EN = !0, o("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : g = g._context;
      var C = l.pendingProps, S = C.children;
      typeof S != "function" && o("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Ig(l, f);
      var T = _n(g);
      Zl(l);
      var O;
      return WC.current = l, Xo(!0), O = S(T), Xo(!1), Ju(), l.flags |= Kl, Za(s, l, O, f), l.child;
    }
    function GC() {
      Sl = !0;
    }
    function db(s, l) {
      (l.mode & li) === Ft && s !== null && (s.alternate = null, l.alternate = null, l.flags |= vr);
    }
    function wd(s, l, f) {
      return s !== null && (l.dependencies = s.dependencies), nN(), ry(l.lanes), Oa(f, l.childLanes) ? (bZ(s, l), l.child) : null;
    }
    function yJ(s, l, f) {
      {
        var g = l.return;
        if (g === null)
          throw new Error("Cannot swap the root fiber.");
        if (s.alternate = null, l.alternate = null, f.index = l.index, f.sibling = l.sibling, f.return = l.return, f.ref = l.ref, l === g.child)
          g.child = f;
        else {
          var C = g.child;
          if (C === null)
            throw new Error("Expected parent to have a child.");
          for (; C.sibling !== l; )
            if (C = C.sibling, C === null)
              throw new Error("Expected to find the previous sibling.");
          C.sibling = f;
        }
        var S = g.deletions;
        return S === null ? (g.deletions = [s], g.flags |= Fi) : S.push(s), f.flags |= vr, f;
      }
    }
    function AO(s, l) {
      var f = s.lanes;
      return !!Oa(f, l);
    }
    function xJ(s, l, f) {
      switch (l.tag) {
        case _:
          vN(l);
          var g = l.stateNode;
          wg();
          break;
        case b:
          D1(l);
          break;
        case p: {
          var C = l.type;
          uu(C) && yE(l);
          break;
        }
        case y:
          PA(l, l.stateNode.containerInfo);
          break;
        case $: {
          var S = l.memoizedProps.value, T = l.type._context;
          u1(l, T, S);
          break;
        }
        case te:
          {
            var O = Oa(f, l.childLanes);
            O && (l.flags |= ri);
            {
              var M = l.stateNode;
              M.effectDuration = 0, M.passiveEffectDuration = 0;
            }
          }
          break;
        case z: {
          var V = l.memoizedState;
          if (V !== null) {
            if (V.dehydrated !== null)
              return Jc(l, Og(yl.current)), l.flags |= Gt, null;
            var H = l.child, J = H.childLanes;
            if (Oa(f, J))
              return mN(s, l, f);
            Jc(l, Og(yl.current));
            var Q = wd(s, l, f);
            return Q !== null ? Q.sibling : null;
          } else
            Jc(l, Og(yl.current));
          break;
        }
        case Ce: {
          var fe = (s.flags & Gt) !== Lt, ce = Oa(f, l.childLanes);
          if (fe) {
            if (ce)
              return xN(s, l, f);
            l.flags |= Gt;
          }
          var me = l.memoizedState;
          if (me !== null && (me.rendering = null, me.tail = null, me.lastEffect = null), Jc(l, yl.current), ce)
            break;
          return null;
        }
        case Ve:
        case Ee:
          return l.lanes = Te, hN(s, l, f);
      }
      return wd(s, l, f);
    }
    function bN(s, l, f) {
      if (l._debugNeedsRemount && s !== null)
        return yJ(s, l, oR(l.type, l.key, l.pendingProps, l._debugOwner || null, l.mode, l.lanes));
      if (s !== null) {
        var g = s.memoizedProps, C = l.pendingProps;
        if (g !== C || _E() || // Force a re-render if the implementation changed due to hot reload:
        l.type !== s.type)
          Sl = !0;
        else {
          var S = AO(s, f);
          if (!S && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (l.flags & Gt) === Lt)
            return Sl = !1, xJ(s, l, f);
          (s.flags & hf) !== Lt ? Sl = !0 : Sl = !1;
        }
      } else if (Sl = !1, oa() && jQ(l)) {
        var T = l.index, O = YQ();
        QV(l, O, T);
      }
      switch (l.lanes = Te, l.tag) {
        case v:
          return iJ(s, l, l.type, f);
        case _e: {
          var M = l.elementType;
          return eJ(s, l, M, f);
        }
        case c: {
          var V = l.type, H = l.pendingProps, J = l.elementType === V ? H : Cl(V, H);
          return xO(s, l, V, J, f);
        }
        case p: {
          var Q = l.type, fe = l.pendingProps, ce = l.elementType === Q ? fe : Cl(Q, fe);
          return pN(s, l, Q, ce, f);
        }
        case _:
          return QZ(s, l, f);
        case b:
          return ZZ(s, l, f);
        case I:
          return JZ(s, l);
        case z:
          return mN(s, l, f);
        case y:
          return mJ(s, l, f);
        case K: {
          var me = l.type, lt = l.pendingProps, Mt = l.elementType === me ? lt : Cl(me, lt);
          return uN(s, l, me, Mt, f);
        }
        case A:
          return YZ(s, l, f);
        case L:
          return qZ(s, l, f);
        case te:
          return XZ(s, l, f);
        case $:
          return _J(s, l, f);
        case B:
          return CJ(s, l, f);
        case ie: {
          var Tt = l.type, vi = l.pendingProps, gi = Cl(Tt, vi);
          if (l.type !== l.elementType) {
            var se = Tt.propTypes;
            se && gl(
              se,
              gi,
              // Resolved for outer only
              "prop",
              ir(Tt)
            );
          }
          return gi = Cl(Tt.type, gi), dN(s, l, Tt, gi, f);
        }
        case pe:
          return cN(s, l, l.type, l.pendingProps, f);
        case be: {
          var Se = l.type, le = l.pendingProps, He = l.elementType === Se ? le : Cl(Se, le);
          return tJ(s, l, Se, He, f);
        }
        case Ce:
          return xN(s, l, f);
        case ft:
          break;
        case Ve:
          return hN(s, l, f);
      }
      throw new Error("Unknown unit of work tag (" + l.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Fg(s) {
      s.flags |= ri;
    }
    function wN(s) {
      s.flags |= Ea, s.flags |= T_;
    }
    var TN, OO, IN, DN;
    TN = function(s, l, f, g) {
      for (var C = l.child; C !== null; ) {
        if (C.tag === b || C.tag === I)
          U7(s, C.stateNode);
        else if (C.tag !== y) {
          if (C.child !== null) {
            C.child.return = C, C = C.child;
            continue;
          }
        }
        if (C === l)
          return;
        for (; C.sibling === null; ) {
          if (C.return === null || C.return === l)
            return;
          C = C.return;
        }
        C.sibling.return = C.return, C = C.sibling;
      }
    }, OO = function(s, l) {
    }, IN = function(s, l, f, g, C) {
      var S = s.memoizedProps;
      if (S !== g) {
        var T = l.stateNode, O = FA(), M = K7(T, f, S, g, C, O);
        l.updateQueue = M, M && Fg(l);
      }
    }, DN = function(s, l, f, g) {
      f !== g && Fg(l);
    };
    function KC(s, l) {
      if (!oa())
        switch (s.tailMode) {
          case "hidden": {
            for (var f = s.tail, g = null; f !== null; )
              f.alternate !== null && (g = f), f = f.sibling;
            g === null ? s.tail = null : g.sibling = null;
            break;
          }
          case "collapsed": {
            for (var C = s.tail, S = null; C !== null; )
              C.alternate !== null && (S = C), C = C.sibling;
            S === null ? !l && s.tail !== null ? s.tail.sibling = null : s.tail = null : S.sibling = null;
            break;
          }
        }
    }
    function la(s) {
      var l = s.alternate !== null && s.alternate.child === s.child, f = Te, g = Lt;
      if (l) {
        if ((s.mode & Vt) !== Ft) {
          for (var M = s.selfBaseDuration, V = s.child; V !== null; )
            f = ei(f, ei(V.lanes, V.childLanes)), g |= V.subtreeFlags & En, g |= V.flags & En, M += V.treeBaseDuration, V = V.sibling;
          s.treeBaseDuration = M;
        } else
          for (var H = s.child; H !== null; )
            f = ei(f, ei(H.lanes, H.childLanes)), g |= H.subtreeFlags & En, g |= H.flags & En, H.return = s, H = H.sibling;
        s.subtreeFlags |= g;
      } else {
        if ((s.mode & Vt) !== Ft) {
          for (var C = s.actualDuration, S = s.selfBaseDuration, T = s.child; T !== null; )
            f = ei(f, ei(T.lanes, T.childLanes)), g |= T.subtreeFlags, g |= T.flags, C += T.actualDuration, S += T.treeBaseDuration, T = T.sibling;
          s.actualDuration = C, s.treeBaseDuration = S;
        } else
          for (var O = s.child; O !== null; )
            f = ei(f, ei(O.lanes, O.childLanes)), g |= O.subtreeFlags, g |= O.flags, O.return = s, O = O.sibling;
        s.subtreeFlags |= g;
      }
      return s.childLanes = f, l;
    }
    function SJ(s, l, f) {
      if (sZ() && (l.mode & li) !== Ft && (l.flags & Gt) === Lt)
        return n1(l), wg(), l.flags |= Mr | Ka | pn, !1;
      var g = wE(l);
      if (f !== null && f.dehydrated !== null)
        if (s === null) {
          if (!g)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (aZ(l), la(l), (l.mode & Vt) !== Ft) {
            var C = f !== null;
            if (C) {
              var S = l.child;
              S !== null && (l.treeBaseDuration -= S.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (wg(), (l.flags & Gt) === Lt && (l.memoizedState = null), l.flags |= ri, la(l), (l.mode & Vt) !== Ft) {
            var T = f !== null;
            if (T) {
              var O = l.child;
              O !== null && (l.treeBaseDuration -= O.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return a1(), !0;
    }
    function AN(s, l, f) {
      var g = l.pendingProps;
      switch (iA(l), l.tag) {
        case v:
        case _e:
        case pe:
        case c:
        case K:
        case A:
        case L:
        case te:
        case B:
        case ie:
          return la(l), null;
        case p: {
          var C = l.type;
          return uu(C) && CE(l), la(l), null;
        }
        case _: {
          var S = l.stateNode;
          if (Ag(l), ZD(l), $A(), S.pendingContext && (S.context = S.pendingContext, S.pendingContext = null), s === null || s.child === null) {
            var T = wE(l);
            if (T)
              Fg(l);
            else if (s !== null) {
              var O = s.memoizedState;
              // Check if this is a client root
              (!O.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (l.flags & Mr) !== Lt) && (l.flags |= Co, a1());
            }
          }
          return OO(s, l), la(l), null;
        }
        case b: {
          BA(l);
          var M = I1(), V = l.type;
          if (s !== null && l.stateNode != null)
            IN(s, l, V, g, M), s.ref !== l.ref && wN(l);
          else {
            if (!g) {
              if (l.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return la(l), null;
            }
            var H = FA(), J = wE(l);
            if (J)
              rZ(l, M, H) && Fg(l);
            else {
              var Q = W7(V, g, M, H, l);
              TN(Q, l, !1, !1), l.stateNode = Q, G7(Q, V, g, M) && Fg(l);
            }
            l.ref !== null && wN(l);
          }
          return la(l), null;
        }
        case I: {
          var fe = g;
          if (s && l.stateNode != null) {
            var ce = s.memoizedProps;
            DN(s, l, ce, fe);
          } else {
            if (typeof fe != "string" && l.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var me = I1(), lt = FA(), Mt = wE(l);
            Mt ? nZ(l) && Fg(l) : l.stateNode = j7(fe, me, lt, l);
          }
          return la(l), null;
        }
        case z: {
          Rg(l);
          var Tt = l.memoizedState;
          if (s === null || s.memoizedState !== null && s.memoizedState.dehydrated !== null) {
            var vi = SJ(s, l, Tt);
            if (!vi)
              return l.flags & pn ? l : null;
          }
          if ((l.flags & Gt) !== Lt)
            return l.lanes = f, (l.mode & Vt) !== Ft && hO(l), l;
          var gi = Tt !== null, se = s !== null && s.memoizedState !== null;
          if (gi !== se && gi) {
            var Se = l.child;
            if (Se.flags |= jl, (l.mode & li) !== Ft) {
              var le = s === null && (l.memoizedProps.unstable_avoidThisFallback !== !0 || !ge);
              le || VA(yl.current, O1) ? Dee() : qO();
            }
          }
          var He = l.updateQueue;
          if (He !== null && (l.flags |= ri), la(l), (l.mode & Vt) !== Ft && gi) {
            var pt = l.child;
            pt !== null && (l.treeBaseDuration -= pt.treeBaseDuration);
          }
          return null;
        }
        case y:
          return Ag(l), OO(s, l), s === null && HQ(l.stateNode.containerInfo), la(l), null;
        case $:
          var st = l.type._context;
          return cA(st, l), la(l), null;
        case be: {
          var Ut = l.type;
          return uu(Ut) && CE(l), la(l), null;
        }
        case Ce: {
          Rg(l);
          var Qt = l.memoizedState;
          if (Qt === null)
            return la(l), null;
          var Zi = (l.flags & Gt) !== Lt, Ri = Qt.rendering;
          if (Ri === null)
            if (Zi)
              KC(Qt, !1);
            else {
              var ln = Oee() && (s === null || (s.flags & Gt) === Lt);
              if (!ln)
                for (var Li = l.child; Li !== null; ) {
                  var Yr = zE(Li);
                  if (Yr !== null) {
                    Zi = !0, l.flags |= Gt, KC(Qt, !1);
                    var ka = Yr.updateQueue;
                    return ka !== null && (l.updateQueue = ka, l.flags |= ri), l.subtreeFlags = Lt, wZ(l, f), Jc(l, NA(yl.current, PC)), l.child;
                  }
                  Li = Li.sibling;
                }
              Qt.tail !== null && Tr() > QN() && (l.flags |= Gt, Zi = !0, KC(Qt, !1), l.lanes = N_);
            }
          else {
            if (!Zi) {
              var fa = zE(Ri);
              if (fa !== null) {
                l.flags |= Gt, Zi = !0;
                var ns = fa.updateQueue;
                if (ns !== null && (l.updateQueue = ns, l.flags |= ri), KC(Qt, !0), Qt.tail === null && Qt.tailMode === "hidden" && !Ri.alternate && !oa())
                  return la(l), null;
              } else
                // The time it took to render last row is greater than the remaining
                // time we have to render. So rendering one more row would likely
                // exceed it.
                Tr() * 2 - Qt.renderingStartTime > QN() && f !== Aa && (l.flags |= Gt, Zi = !0, KC(Qt, !1), l.lanes = N_);
            }
            if (Qt.isBackwards)
              Ri.sibling = l.child, l.child = Ri;
            else {
              var to = Qt.last;
              to !== null ? to.sibling = Ri : l.child = Ri, Qt.last = Ri;
            }
          }
          if (Qt.tail !== null) {
            var io = Qt.tail;
            Qt.rendering = io, Qt.tail = io.sibling, Qt.renderingStartTime = Tr(), io.sibling = null;
            var Pa = yl.current;
            return Zi ? Pa = NA(Pa, PC) : Pa = Og(Pa), Jc(l, Pa), io;
          }
          return la(l), null;
        }
        case ft:
          break;
        case Ve:
        case Ee: {
          YO(l);
          var Od = l.memoizedState, Ug = Od !== null;
          if (s !== null) {
            var ly = s.memoizedState, mu = ly !== null;
            mu !== Ug && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !j && (l.flags |= jl);
          }
          return !Ug || (l.mode & li) === Ft ? la(l) : Oa(gu, Aa) && (la(l), l.subtreeFlags & (vr | ri) && (l.flags |= jl)), null;
        }
        case Re:
          return null;
        case we:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + l.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function EJ(s, l, f) {
      switch (iA(l), l.tag) {
        case p: {
          var g = l.type;
          uu(g) && CE(l);
          var C = l.flags;
          return C & pn ? (l.flags = C & ~pn | Gt, (l.mode & Vt) !== Ft && hO(l), l) : null;
        }
        case _: {
          var S = l.stateNode;
          Ag(l), ZD(l), $A();
          var T = l.flags;
          return (T & pn) !== Lt && (T & Gt) === Lt ? (l.flags = T & ~pn | Gt, l) : null;
        }
        case b:
          return BA(l), null;
        case z: {
          Rg(l);
          var O = l.memoizedState;
          if (O !== null && O.dehydrated !== null) {
            if (l.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            wg();
          }
          var M = l.flags;
          return M & pn ? (l.flags = M & ~pn | Gt, (l.mode & Vt) !== Ft && hO(l), l) : null;
        }
        case Ce:
          return Rg(l), null;
        case y:
          return Ag(l), null;
        case $:
          var V = l.type._context;
          return cA(V, l), null;
        case Ve:
        case Ee:
          return YO(l), null;
        case Re:
          return null;
        default:
          return null;
      }
    }
    function ON(s, l, f) {
      switch (iA(l), l.tag) {
        case p: {
          var g = l.type.childContextTypes;
          g != null && CE(l);
          break;
        }
        case _: {
          var C = l.stateNode;
          Ag(l), ZD(l), $A();
          break;
        }
        case b: {
          BA(l);
          break;
        }
        case y:
          Ag(l);
          break;
        case z:
          Rg(l);
          break;
        case Ce:
          Rg(l);
          break;
        case $:
          var S = l.type._context;
          cA(S, l);
          break;
        case Ve:
        case Ee:
          YO(l);
          break;
      }
    }
    var RN = null;
    RN = /* @__PURE__ */ new Set();
    var cb = !1, ua = !1, bJ = typeof WeakSet == "function" ? WeakSet : Set, Et = null, Bg = null, Vg = null;
    function wJ(s) {
      Qu(null, function() {
        throw s;
      }), b_();
    }
    var TJ = function(s, l) {
      if (l.props = s.memoizedProps, l.state = s.memoizedState, s.mode & Vt)
        try {
          pu(), l.componentWillUnmount();
        } finally {
          fu(s);
        }
      else
        l.componentWillUnmount();
    };
    function LN(s, l) {
      try {
        ih(In, s);
      } catch (f) {
        Cr(s, l, f);
      }
    }
    function RO(s, l, f) {
      try {
        TJ(s, f);
      } catch (g) {
        Cr(s, l, g);
      }
    }
    function IJ(s, l, f) {
      try {
        f.componentDidMount();
      } catch (g) {
        Cr(s, l, g);
      }
    }
    function MN(s, l) {
      try {
        FN(s);
      } catch (f) {
        Cr(s, l, f);
      }
    }
    function Ng(s, l) {
      var f = s.ref;
      if (f !== null)
        if (typeof f == "function") {
          var g;
          try {
            if (Je && _t && s.mode & Vt)
              try {
                pu(), g = f(null);
              } finally {
                fu(s);
              }
            else
              g = f(null);
          } catch (C) {
            Cr(s, l, C);
          }
          typeof g == "function" && o("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Jt(s));
        } else
          f.current = null;
    }
    function hb(s, l, f) {
      try {
        f();
      } catch (g) {
        Cr(s, l, g);
      }
    }
    var kN = null, PN = !1;
    function DJ(s, l) {
      kN = $7(s.containerInfo), Et = l, AJ();
      var f = PN;
      return PN = !1, kN = null, f;
    }
    function AJ() {
      for (; Et !== null; ) {
        var s = Et, l = s.child;
        (s.subtreeFlags & Sc) !== Lt && l !== null ? (l.return = s, Et = l) : OJ();
      }
    }
    function OJ() {
      for (; Et !== null; ) {
        var s = Et;
        Xi(s);
        try {
          RJ(s);
        } catch (f) {
          Cr(s, s.return, f);
        }
        en();
        var l = s.sibling;
        if (l !== null) {
          l.return = s.return, Et = l;
          return;
        }
        Et = s.return;
      }
    }
    function RJ(s) {
      var l = s.alternate, f = s.flags;
      if ((f & Co) !== Lt) {
        switch (Xi(s), s.tag) {
          case c:
          case K:
          case pe:
            break;
          case p: {
            if (l !== null) {
              var g = l.memoizedProps, C = l.memoizedState, S = s.stateNode;
              s.type === s.elementType && !Gf && (S.props !== s.memoizedProps && o("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Jt(s) || "instance"), S.state !== s.memoizedState && o("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Jt(s) || "instance"));
              var T = S.getSnapshotBeforeUpdate(s.elementType === s.type ? g : Cl(s.type, g), C);
              {
                var O = RN;
                T === void 0 && !O.has(s.type) && (O.add(s.type), o("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", Jt(s)));
              }
              S.__reactInternalSnapshotBeforeUpdate = T;
            }
            break;
          }
          case _: {
            {
              var M = s.stateNode;
              hQ(M.containerInfo);
            }
            break;
          }
          case b:
          case I:
          case y:
          case be:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        en();
      }
    }
    function El(s, l, f) {
      var g = l.updateQueue, C = g !== null ? g.lastEffect : null;
      if (C !== null) {
        var S = C.next, T = S;
        do {
          if ((T.tag & s) === s) {
            var O = T.destroy;
            T.destroy = void 0, O !== void 0 && ((s & sa) !== Ro ? Dv(l) : (s & In) !== Ro && Av(l), (s & du) !== Ro && ay(!0), hb(l, f, O), (s & du) !== Ro && ay(!1), (s & sa) !== Ro ? b0() : (s & In) !== Ro && Ec());
          }
          T = T.next;
        } while (T !== S);
      }
    }
    function ih(s, l) {
      var f = l.updateQueue, g = f !== null ? f.lastEffect : null;
      if (g !== null) {
        var C = g.next, S = C;
        do {
          if ((S.tag & s) === s) {
            (s & sa) !== Ro ? E0(l) : (s & In) !== Ro && w0(l);
            var T = S.create;
            (s & du) !== Ro && ay(!0), S.destroy = T(), (s & du) !== Ro && ay(!1), (s & sa) !== Ro ? F_() : (s & In) !== Ro && T0();
            {
              var O = S.destroy;
              if (O !== void 0 && typeof O != "function") {
                var M = void 0;
                (S.tag & In) !== Lt ? M = "useLayoutEffect" : (S.tag & du) !== Lt ? M = "useInsertionEffect" : M = "useEffect";
                var V = void 0;
                O === null ? V = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof O.then == "function" ? V = `

It looks like you wrote ` + M + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + M + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : V = " You returned: " + O, o("%s must not return anything besides a function, which is used for clean-up.%s", M, V);
              }
            }
          }
          S = S.next;
        } while (S !== C);
      }
    }
    function LJ(s, l) {
      if ((l.flags & ri) !== Lt)
        switch (l.tag) {
          case te: {
            var f = l.stateNode.passiveEffectDuration, g = l.memoizedProps, C = g.id, S = g.onPostCommit, T = iN(), O = l.alternate === null ? "mount" : "update";
            tN() && (O = "nested-update"), typeof S == "function" && S(C, O, f, T);
            var M = l.return;
            e:
              for (; M !== null; ) {
                switch (M.tag) {
                  case _:
                    var V = M.stateNode;
                    V.passiveEffectDuration += f;
                    break e;
                  case te:
                    var H = M.stateNode;
                    H.passiveEffectDuration += f;
                    break e;
                }
                M = M.return;
              }
            break;
          }
        }
    }
    function MJ(s, l, f, g) {
      if ((f.flags & Gn) !== Lt)
        switch (f.tag) {
          case c:
          case K:
          case pe: {
            if (!ua)
              if (f.mode & Vt)
                try {
                  pu(), ih(In | Tn, f);
                } finally {
                  fu(f);
                }
              else
                ih(In | Tn, f);
            break;
          }
          case p: {
            var C = f.stateNode;
            if (f.flags & ri && !ua)
              if (l === null)
                if (f.type === f.elementType && !Gf && (C.props !== f.memoizedProps && o("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Jt(f) || "instance"), C.state !== f.memoizedState && o("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Jt(f) || "instance")), f.mode & Vt)
                  try {
                    pu(), C.componentDidMount();
                  } finally {
                    fu(f);
                  }
                else
                  C.componentDidMount();
              else {
                var S = f.elementType === f.type ? l.memoizedProps : Cl(f.type, l.memoizedProps), T = l.memoizedState;
                if (f.type === f.elementType && !Gf && (C.props !== f.memoizedProps && o("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Jt(f) || "instance"), C.state !== f.memoizedState && o("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Jt(f) || "instance")), f.mode & Vt)
                  try {
                    pu(), C.componentDidUpdate(S, T, C.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    fu(f);
                  }
                else
                  C.componentDidUpdate(S, T, C.__reactInternalSnapshotBeforeUpdate);
              }
            var O = f.updateQueue;
            O !== null && (f.type === f.elementType && !Gf && (C.props !== f.memoizedProps && o("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Jt(f) || "instance"), C.state !== f.memoizedState && o("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Jt(f) || "instance")), v1(f, O, C));
            break;
          }
          case _: {
            var M = f.updateQueue;
            if (M !== null) {
              var V = null;
              if (f.child !== null)
                switch (f.child.tag) {
                  case b:
                    V = f.child.stateNode;
                    break;
                  case p:
                    V = f.child.stateNode;
                    break;
                }
              v1(f, M, V);
            }
            break;
          }
          case b: {
            var H = f.stateNode;
            if (l === null && f.flags & ri) {
              var J = f.type, Q = f.memoizedProps;
              Z7(H, J, Q);
            }
            break;
          }
          case I:
            break;
          case y:
            break;
          case te: {
            {
              var fe = f.memoizedProps, ce = fe.onCommit, me = fe.onRender, lt = f.stateNode.effectDuration, Mt = iN(), Tt = l === null ? "mount" : "update";
              tN() && (Tt = "nested-update"), typeof me == "function" && me(f.memoizedProps.id, Tt, f.actualDuration, f.treeBaseDuration, f.actualStartTime, Mt);
              {
                typeof ce == "function" && ce(f.memoizedProps.id, Tt, lt, Mt), Pee(f);
                var vi = f.return;
                e:
                  for (; vi !== null; ) {
                    switch (vi.tag) {
                      case _:
                        var gi = vi.stateNode;
                        gi.effectDuration += lt;
                        break e;
                      case te:
                        var se = vi.stateNode;
                        se.effectDuration += lt;
                        break e;
                    }
                    vi = vi.return;
                  }
              }
            }
            break;
          }
          case z: {
            $J(s, f);
            break;
          }
          case Ce:
          case be:
          case ft:
          case Ve:
          case Ee:
          case we:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      ua || f.flags & Ea && FN(f);
    }
    function kJ(s) {
      switch (s.tag) {
        case c:
        case K:
        case pe: {
          if (s.mode & Vt)
            try {
              pu(), LN(s, s.return);
            } finally {
              fu(s);
            }
          else
            LN(s, s.return);
          break;
        }
        case p: {
          var l = s.stateNode;
          typeof l.componentDidMount == "function" && IJ(s, s.return, l), MN(s, s.return);
          break;
        }
        case b: {
          MN(s, s.return);
          break;
        }
      }
    }
    function PJ(s, l) {
      for (var f = null, g = s; ; ) {
        if (g.tag === b) {
          if (f === null) {
            f = g;
            try {
              var C = g.stateNode;
              l ? lQ(C) : dQ(g.stateNode, g.memoizedProps);
            } catch (T) {
              Cr(s, s.return, T);
            }
          }
        } else if (g.tag === I) {
          if (f === null)
            try {
              var S = g.stateNode;
              l ? uQ(S) : cQ(S, g.memoizedProps);
            } catch (T) {
              Cr(s, s.return, T);
            }
        } else if (!((g.tag === Ve || g.tag === Ee) && g.memoizedState !== null && g !== s)) {
          if (g.child !== null) {
            g.child.return = g, g = g.child;
            continue;
          }
        }
        if (g === s)
          return;
        for (; g.sibling === null; ) {
          if (g.return === null || g.return === s)
            return;
          f === g && (f = null), g = g.return;
        }
        f === g && (f = null), g.sibling.return = g.return, g = g.sibling;
      }
    }
    function FN(s) {
      var l = s.ref;
      if (l !== null) {
        var f = s.stateNode, g;
        switch (s.tag) {
          case b:
            g = f;
            break;
          default:
            g = f;
        }
        if (typeof l == "function") {
          var C;
          if (s.mode & Vt)
            try {
              pu(), C = l(g);
            } finally {
              fu(s);
            }
          else
            C = l(g);
          typeof C == "function" && o("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Jt(s));
        } else
          l.hasOwnProperty("current") || o("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", Jt(s)), l.current = g;
      }
    }
    function FJ(s) {
      var l = s.alternate;
      l !== null && (l.return = null), s.return = null;
    }
    function BN(s) {
      var l = s.alternate;
      l !== null && (s.alternate = null, BN(l));
      {
        if (s.child = null, s.deletions = null, s.sibling = null, s.tag === b) {
          var f = s.stateNode;
          f !== null && WQ(f);
        }
        s.stateNode = null, s._debugOwner = null, s.return = null, s.dependencies = null, s.memoizedProps = null, s.memoizedState = null, s.pendingProps = null, s.stateNode = null, s.updateQueue = null;
      }
    }
    function BJ(s) {
      for (var l = s.return; l !== null; ) {
        if (VN(l))
          return l;
        l = l.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function VN(s) {
      return s.tag === b || s.tag === _ || s.tag === y;
    }
    function NN(s) {
      var l = s;
      e:
        for (; ; ) {
          for (; l.sibling === null; ) {
            if (l.return === null || VN(l.return))
              return null;
            l = l.return;
          }
          for (l.sibling.return = l.return, l = l.sibling; l.tag !== b && l.tag !== I && l.tag !== De; ) {
            if (l.flags & vr || l.child === null || l.tag === y)
              continue e;
            l.child.return = l, l = l.child;
          }
          if (!(l.flags & vr))
            return l.stateNode;
        }
    }
    function VJ(s) {
      var l = BJ(s);
      switch (l.tag) {
        case b: {
          var f = l.stateNode;
          l.flags & Vi && (NV(f), l.flags &= ~Vi);
          var g = NN(s);
          MO(s, g, f);
          break;
        }
        case _:
        case y: {
          var C = l.stateNode.containerInfo, S = NN(s);
          LO(s, S, C);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function LO(s, l, f) {
      var g = s.tag, C = g === b || g === I;
      if (C) {
        var S = s.stateNode;
        l ? nQ(f, S, l) : iQ(f, S);
      } else if (g !== y) {
        var T = s.child;
        if (T !== null) {
          LO(T, l, f);
          for (var O = T.sibling; O !== null; )
            LO(O, l, f), O = O.sibling;
        }
      }
    }
    function MO(s, l, f) {
      var g = s.tag, C = g === b || g === I;
      if (C) {
        var S = s.stateNode;
        l ? rQ(f, S, l) : tQ(f, S);
      } else if (g !== y) {
        var T = s.child;
        if (T !== null) {
          MO(T, l, f);
          for (var O = T.sibling; O !== null; )
            MO(O, l, f), O = O.sibling;
        }
      }
    }
    var da = null, bl = !1;
    function NJ(s, l, f) {
      {
        var g = l;
        e:
          for (; g !== null; ) {
            switch (g.tag) {
              case b: {
                da = g.stateNode, bl = !1;
                break e;
              }
              case _: {
                da = g.stateNode.containerInfo, bl = !0;
                break e;
              }
              case y: {
                da = g.stateNode.containerInfo, bl = !0;
                break e;
              }
            }
            g = g.return;
          }
        if (da === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        HN(s, l, f), da = null, bl = !1;
      }
      FJ(f);
    }
    function rh(s, l, f) {
      for (var g = f.child; g !== null; )
        HN(s, l, g), g = g.sibling;
    }
    function HN(s, l, f) {
      switch (k_(f), f.tag) {
        case b:
          ua || Ng(f, l);
        case I: {
          {
            var g = da, C = bl;
            da = null, rh(s, l, f), da = g, bl = C, da !== null && (bl ? oQ(da, f.stateNode) : aQ(da, f.stateNode));
          }
          return;
        }
        case De: {
          da !== null && (bl ? sQ(da, f.stateNode) : UD(da, f.stateNode));
          return;
        }
        case y: {
          {
            var S = da, T = bl;
            da = f.stateNode.containerInfo, bl = !0, rh(s, l, f), da = S, bl = T;
          }
          return;
        }
        case c:
        case K:
        case ie:
        case pe: {
          if (!ua) {
            var O = f.updateQueue;
            if (O !== null) {
              var M = O.lastEffect;
              if (M !== null) {
                var V = M.next, H = V;
                do {
                  var J = H, Q = J.destroy, fe = J.tag;
                  Q !== void 0 && ((fe & du) !== Ro ? hb(f, l, Q) : (fe & In) !== Ro && (Av(f), f.mode & Vt ? (pu(), hb(f, l, Q), fu(f)) : hb(f, l, Q), Ec())), H = H.next;
                } while (H !== V);
              }
            }
          }
          rh(s, l, f);
          return;
        }
        case p: {
          if (!ua) {
            Ng(f, l);
            var ce = f.stateNode;
            typeof ce.componentWillUnmount == "function" && RO(f, l, ce);
          }
          rh(s, l, f);
          return;
        }
        case ft: {
          rh(s, l, f);
          return;
        }
        case Ve: {
          if (
            // TODO: Remove this dead flag
            f.mode & li
          ) {
            var me = ua;
            ua = me || f.memoizedState !== null, rh(s, l, f), ua = me;
          } else
            rh(s, l, f);
          break;
        }
        default: {
          rh(s, l, f);
          return;
        }
      }
    }
    function HJ(s) {
      var l = s.memoizedState;
    }
    function $J(s, l) {
      var f = l.memoizedState;
      if (f === null) {
        var g = l.alternate;
        if (g !== null) {
          var C = g.memoizedState;
          if (C !== null) {
            var S = C.dehydrated;
            S !== null && TQ(S);
          }
        }
      }
    }
    function $N(s) {
      var l = s.updateQueue;
      if (l !== null) {
        s.updateQueue = null;
        var f = s.stateNode;
        f === null && (f = s.stateNode = new bJ()), l.forEach(function(g) {
          var C = zee.bind(null, s, g);
          if (!f.has(g)) {
            if (f.add(g), bn)
              if (Bg !== null && Vg !== null)
                ny(Vg, Bg);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            g.then(C, C);
          }
        });
      }
    }
    function zJ(s, l, f) {
      Bg = f, Vg = s, Xi(l), zN(l, s), Xi(l), Bg = null, Vg = null;
    }
    function wl(s, l, f) {
      var g = l.deletions;
      if (g !== null)
        for (var C = 0; C < g.length; C++) {
          var S = g[C];
          try {
            NJ(s, l, S);
          } catch (M) {
            Cr(S, l, M);
          }
        }
      var T = WI();
      if (l.subtreeFlags & Ta)
        for (var O = l.child; O !== null; )
          Xi(O), zN(O, s), O = O.sibling;
      Xi(T);
    }
    function zN(s, l, f) {
      var g = s.alternate, C = s.flags;
      switch (s.tag) {
        case c:
        case K:
        case ie:
        case pe: {
          if (wl(l, s), vu(s), C & ri) {
            try {
              El(du | Tn, s, s.return), ih(du | Tn, s);
            } catch (Ut) {
              Cr(s, s.return, Ut);
            }
            if (s.mode & Vt) {
              try {
                pu(), El(In | Tn, s, s.return);
              } catch (Ut) {
                Cr(s, s.return, Ut);
              }
              fu(s);
            } else
              try {
                El(In | Tn, s, s.return);
              } catch (Ut) {
                Cr(s, s.return, Ut);
              }
          }
          return;
        }
        case p: {
          wl(l, s), vu(s), C & Ea && g !== null && Ng(g, g.return);
          return;
        }
        case b: {
          wl(l, s), vu(s), C & Ea && g !== null && Ng(g, g.return);
          {
            if (s.flags & Vi) {
              var S = s.stateNode;
              try {
                NV(S);
              } catch (Ut) {
                Cr(s, s.return, Ut);
              }
            }
            if (C & ri) {
              var T = s.stateNode;
              if (T != null) {
                var O = s.memoizedProps, M = g !== null ? g.memoizedProps : O, V = s.type, H = s.updateQueue;
                if (s.updateQueue = null, H !== null)
                  try {
                    J7(T, H, V, M, O, s);
                  } catch (Ut) {
                    Cr(s, s.return, Ut);
                  }
              }
            }
          }
          return;
        }
        case I: {
          if (wl(l, s), vu(s), C & ri) {
            if (s.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var J = s.stateNode, Q = s.memoizedProps, fe = g !== null ? g.memoizedProps : Q;
            try {
              eQ(J, fe, Q);
            } catch (Ut) {
              Cr(s, s.return, Ut);
            }
          }
          return;
        }
        case _: {
          if (wl(l, s), vu(s), C & ri && g !== null) {
            var ce = g.memoizedState;
            if (ce.isDehydrated)
              try {
                wQ(l.containerInfo);
              } catch (Ut) {
                Cr(s, s.return, Ut);
              }
          }
          return;
        }
        case y: {
          wl(l, s), vu(s);
          return;
        }
        case z: {
          wl(l, s), vu(s);
          var me = s.child;
          if (me.flags & jl) {
            var lt = me.stateNode, Mt = me.memoizedState, Tt = Mt !== null;
            if (lt.isHidden = Tt, Tt) {
              var vi = me.alternate !== null && me.alternate.memoizedState !== null;
              vi || Iee();
            }
          }
          if (C & ri) {
            try {
              HJ(s);
            } catch (Ut) {
              Cr(s, s.return, Ut);
            }
            $N(s);
          }
          return;
        }
        case Ve: {
          var gi = g !== null && g.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            s.mode & li
          ) {
            var se = ua;
            ua = se || gi, wl(l, s), ua = se;
          } else
            wl(l, s);
          if (vu(s), C & jl) {
            var Se = s.stateNode, le = s.memoizedState, He = le !== null, pt = s;
            if (Se.isHidden = He, He && !gi && (pt.mode & li) !== Ft) {
              Et = pt;
              for (var st = pt.child; st !== null; )
                Et = st, UJ(st), st = st.sibling;
            }
            PJ(pt, He);
          }
          return;
        }
        case Ce: {
          wl(l, s), vu(s), C & ri && $N(s);
          return;
        }
        case ft:
          return;
        default: {
          wl(l, s), vu(s);
          return;
        }
      }
    }
    function vu(s) {
      var l = s.flags;
      if (l & vr) {
        try {
          VJ(s);
        } catch (f) {
          Cr(s, s.return, f);
        }
        s.flags &= ~vr;
      }
      l & yo && (s.flags &= ~yo);
    }
    function WJ(s, l, f) {
      Bg = f, Vg = l, Et = s, WN(s, l, f), Bg = null, Vg = null;
    }
    function WN(s, l, f) {
      for (var g = (s.mode & li) !== Ft; Et !== null; ) {
        var C = Et, S = C.child;
        if (C.tag === Ve && g) {
          var T = C.memoizedState !== null, O = T || cb;
          if (O) {
            kO(s, l, f);
            continue;
          } else {
            var M = C.alternate, V = M !== null && M.memoizedState !== null, H = V || ua, J = cb, Q = ua;
            cb = O, ua = H, ua && !Q && (Et = C, GJ(C));
            for (var fe = S; fe !== null; )
              Et = fe, WN(
                fe,
                // New root; bubble back up to here and stop.
                l,
                f
              ), fe = fe.sibling;
            Et = C, cb = J, ua = Q, kO(s, l, f);
            continue;
          }
        }
        (C.subtreeFlags & Gn) !== Lt && S !== null ? (S.return = C, Et = S) : kO(s, l, f);
      }
    }
    function kO(s, l, f) {
      for (; Et !== null; ) {
        var g = Et;
        if ((g.flags & Gn) !== Lt) {
          var C = g.alternate;
          Xi(g);
          try {
            MJ(l, C, g, f);
          } catch (T) {
            Cr(g, g.return, T);
          }
          en();
        }
        if (g === s) {
          Et = null;
          return;
        }
        var S = g.sibling;
        if (S !== null) {
          S.return = g.return, Et = S;
          return;
        }
        Et = g.return;
      }
    }
    function UJ(s) {
      for (; Et !== null; ) {
        var l = Et, f = l.child;
        switch (l.tag) {
          case c:
          case K:
          case ie:
          case pe: {
            if (l.mode & Vt)
              try {
                pu(), El(In, l, l.return);
              } finally {
                fu(l);
              }
            else
              El(In, l, l.return);
            break;
          }
          case p: {
            Ng(l, l.return);
            var g = l.stateNode;
            typeof g.componentWillUnmount == "function" && RO(l, l.return, g);
            break;
          }
          case b: {
            Ng(l, l.return);
            break;
          }
          case Ve: {
            var C = l.memoizedState !== null;
            if (C) {
              UN(s);
              continue;
            }
            break;
          }
        }
        f !== null ? (f.return = l, Et = f) : UN(s);
      }
    }
    function UN(s) {
      for (; Et !== null; ) {
        var l = Et;
        if (l === s) {
          Et = null;
          return;
        }
        var f = l.sibling;
        if (f !== null) {
          f.return = l.return, Et = f;
          return;
        }
        Et = l.return;
      }
    }
    function GJ(s) {
      for (; Et !== null; ) {
        var l = Et, f = l.child;
        if (l.tag === Ve) {
          var g = l.memoizedState !== null;
          if (g) {
            GN(s);
            continue;
          }
        }
        f !== null ? (f.return = l, Et = f) : GN(s);
      }
    }
    function GN(s) {
      for (; Et !== null; ) {
        var l = Et;
        Xi(l);
        try {
          kJ(l);
        } catch (g) {
          Cr(l, l.return, g);
        }
        if (en(), l === s) {
          Et = null;
          return;
        }
        var f = l.sibling;
        if (f !== null) {
          f.return = l.return, Et = f;
          return;
        }
        Et = l.return;
      }
    }
    function KJ(s, l, f, g) {
      Et = l, jJ(l, s, f, g);
    }
    function jJ(s, l, f, g) {
      for (; Et !== null; ) {
        var C = Et, S = C.child;
        (C.subtreeFlags & xo) !== Lt && S !== null ? (S.return = C, Et = S) : YJ(s, l, f, g);
      }
    }
    function YJ(s, l, f, g) {
      for (; Et !== null; ) {
        var C = Et;
        if ((C.flags & xr) !== Lt) {
          Xi(C);
          try {
            qJ(l, C, f, g);
          } catch (T) {
            Cr(C, C.return, T);
          }
          en();
        }
        if (C === s) {
          Et = null;
          return;
        }
        var S = C.sibling;
        if (S !== null) {
          S.return = C.return, Et = S;
          return;
        }
        Et = C.return;
      }
    }
    function qJ(s, l, f, g) {
      switch (l.tag) {
        case c:
        case K:
        case pe: {
          if (l.mode & Vt) {
            cO();
            try {
              ih(sa | Tn, l);
            } finally {
              dO(l);
            }
          } else
            ih(sa | Tn, l);
          break;
        }
      }
    }
    function XJ(s) {
      Et = s, QJ();
    }
    function QJ() {
      for (; Et !== null; ) {
        var s = Et, l = s.child;
        if ((Et.flags & Fi) !== Lt) {
          var f = s.deletions;
          if (f !== null) {
            for (var g = 0; g < f.length; g++) {
              var C = f[g];
              Et = C, eee(C, s);
            }
            {
              var S = s.alternate;
              if (S !== null) {
                var T = S.child;
                if (T !== null) {
                  S.child = null;
                  do {
                    var O = T.sibling;
                    T.sibling = null, T = O;
                  } while (T !== null);
                }
              }
            }
            Et = s;
          }
        }
        (s.subtreeFlags & xo) !== Lt && l !== null ? (l.return = s, Et = l) : ZJ();
      }
    }
    function ZJ() {
      for (; Et !== null; ) {
        var s = Et;
        (s.flags & xr) !== Lt && (Xi(s), JJ(s), en());
        var l = s.sibling;
        if (l !== null) {
          l.return = s.return, Et = l;
          return;
        }
        Et = s.return;
      }
    }
    function JJ(s) {
      switch (s.tag) {
        case c:
        case K:
        case pe: {
          s.mode & Vt ? (cO(), El(sa | Tn, s, s.return), dO(s)) : El(sa | Tn, s, s.return);
          break;
        }
      }
    }
    function eee(s, l) {
      for (; Et !== null; ) {
        var f = Et;
        Xi(f), iee(f, l), en();
        var g = f.child;
        g !== null ? (g.return = f, Et = g) : tee(s);
      }
    }
    function tee(s) {
      for (; Et !== null; ) {
        var l = Et, f = l.sibling, g = l.return;
        if (BN(l), l === s) {
          Et = null;
          return;
        }
        if (f !== null) {
          f.return = g, Et = f;
          return;
        }
        Et = g;
      }
    }
    function iee(s, l) {
      switch (s.tag) {
        case c:
        case K:
        case pe: {
          s.mode & Vt ? (cO(), El(sa, s, l), dO(s)) : El(sa, s, l);
          break;
        }
      }
    }
    function ree(s) {
      switch (s.tag) {
        case c:
        case K:
        case pe: {
          try {
            ih(In | Tn, s);
          } catch (f) {
            Cr(s, s.return, f);
          }
          break;
        }
        case p: {
          var l = s.stateNode;
          try {
            l.componentDidMount();
          } catch (f) {
            Cr(s, s.return, f);
          }
          break;
        }
      }
    }
    function nee(s) {
      switch (s.tag) {
        case c:
        case K:
        case pe: {
          try {
            ih(sa | Tn, s);
          } catch (l) {
            Cr(s, s.return, l);
          }
          break;
        }
      }
    }
    function aee(s) {
      switch (s.tag) {
        case c:
        case K:
        case pe: {
          try {
            El(In | Tn, s, s.return);
          } catch (f) {
            Cr(s, s.return, f);
          }
          break;
        }
        case p: {
          var l = s.stateNode;
          typeof l.componentWillUnmount == "function" && RO(s, s.return, l);
          break;
        }
      }
    }
    function oee(s) {
      switch (s.tag) {
        case c:
        case K:
        case pe:
          try {
            El(sa | Tn, s, s.return);
          } catch (l) {
            Cr(s, s.return, l);
          }
      }
    }
    var see = 0, lee = 1, uee = 2, dee = 3, cee = 4;
    if (typeof Symbol == "function" && Symbol.for) {
      var jC = Symbol.for;
      see = jC("selector.component"), lee = jC("selector.has_pseudo_class"), uee = jC("selector.role"), dee = jC("selector.test_id"), cee = jC("selector.text");
    }
    var hee = [];
    function fee() {
      hee.forEach(function(s) {
        return s();
      });
    }
    var pee = i.ReactCurrentActQueue;
    function vee(s) {
      {
        var l = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), f = typeof jest < "u";
        return f && l !== !1;
      }
    }
    function KN() {
      {
        var s = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !s && pee.current !== null && o("The current testing environment is not configured to support act(...)"), s;
      }
    }
    var gee = Math.ceil, PO = i.ReactCurrentDispatcher, FO = i.ReactCurrentOwner, ca = i.ReactCurrentBatchConfig, Tl = i.ReactCurrentActQueue, On = (
      /*             */
      0
    ), jN = (
      /*               */
      1
    ), ha = (
      /*                */
      2
    ), Ls = (
      /*                */
      4
    ), Td = 0, YC = 1, Kf = 2, fb = 3, qC = 4, YN = 5, BO = 6, xi = On, Ja = null, Hr = null, Rn = Te, gu = Te, VO = jc(Te), Ln = Td, XC = null, NO = Te, pb = Te, QC = Te, vb = Te, ZC = null, Lo = null, HO = 0, qN = 500, XN = 1 / 0, mee = 500, Id = null;
    function JC() {
      XN = Tr() + mee;
    }
    function QN() {
      return XN;
    }
    var gb = !1, $O = null, Hg = null, jf = !1, nh = null, ey = Te, zO = [], WO = null, _ee = 50, ty = 0, UO = null, GO = !1, mb = !1, Cee = 50, $g = 0, _b = null, iy = nr, Cb = Te, ZN = !1;
    function yb() {
      return Ja;
    }
    function eo() {
      return (xi & (ha | Ls)) !== On ? Tr() : (iy !== nr || (iy = Tr()), iy);
    }
    function ah(s) {
      var l = s.mode;
      if ((l & li) === Ft)
        return Ht;
      if ((xi & ha) !== On && Rn !== Te)
        return nn(Rn);
      var f = dZ() !== uZ;
      if (f) {
        if (ca.transition !== null) {
          var g = ca.transition;
          g._updatedFibers || (g._updatedFibers = /* @__PURE__ */ new Set()), g._updatedFibers.add(s);
        }
        return Cb === yi && (Cb = z_()), Cb;
      }
      var C = wo();
      if (C !== yi)
        return C;
      var S = Y7();
      return S;
    }
    function yee(s) {
      var l = s.mode;
      return (l & li) === Ft ? Ht : cD();
    }
    function Mn(s, l, f, g) {
      Uee(), ZN && o("useInsertionEffect must not schedule updates."), GO && (mb = !0), ud(s, f, g), (xi & ha) !== Te && s === Ja ? jee(l) : (bn && j_(s, l, f), Yee(l), s === Ja && ((xi & ha) === On && (QC = ei(QC, f)), Ln === qC && oh(s, Rn)), Mo(s, g), f === Ht && xi === On && (l.mode & li) === Ft && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Tl.isBatchingLegacy && (JC(), XV()));
    }
    function xee(s, l, f) {
      var g = s.current;
      g.lanes = l, ud(s, l, f), Mo(s, f);
    }
    function See(s) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (xi & ha) !== On
      );
    }
    function Mo(s, l) {
      var f = s.callbackNode;
      lD(s, l);
      var g = _f(s, s === Ja ? Rn : Te);
      if (g === Te) {
        f !== null && pH(f), s.callbackNode = null, s.callbackPriority = yi;
        return;
      }
      var C = Kr(g), S = s.callbackPriority;
      if (S === C && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Tl.current !== null && f !== ZO)) {
        f == null && S !== Ht && o("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      f != null && pH(f);
      var T;
      if (C === Ht)
        s.tag === Yc ? (Tl.isBatchingLegacy !== null && (Tl.didScheduleLegacyUpdate = !0), KQ(tH.bind(null, s))) : qV(tH.bind(null, s)), Tl.current !== null ? Tl.current.push(qc) : X7(function() {
          (xi & (ha | Ls)) === On && qc();
        }), T = null;
      else {
        var O;
        switch (Ef(g)) {
          case Kn:
            O = wv;
            break;
          case wn:
            O = qa;
            break;
          case cl:
            O = Ss;
            break;
          case xf:
            O = ql;
            break;
          default:
            O = Ss;
            break;
        }
        T = JO(O, JN.bind(null, s));
      }
      s.callbackPriority = C, s.callbackNode = T;
    }
    function JN(s, l) {
      if (NZ(), iy = nr, Cb = Te, (xi & (ha | Ls)) !== On)
        throw new Error("Should not already be working.");
      var f = s.callbackNode, g = Ad();
      if (g && s.callbackNode !== f)
        return null;
      var C = _f(s, s === Ja ? Rn : Te);
      if (C === Te)
        return null;
      var S = !yf(s, C) && !L0(s, C) && !l, T = S ? Lee(s, C) : Sb(s, C);
      if (T !== Td) {
        if (T === Kf) {
          var O = H_(s);
          O !== Te && (C = O, T = KO(s, O));
        }
        if (T === YC) {
          var M = XC;
          throw Yf(s, Te), oh(s, C), Mo(s, Tr()), M;
        }
        if (T === BO)
          oh(s, C);
        else {
          var V = !yf(s, C), H = s.current.alternate;
          if (V && !bee(H)) {
            if (T = Sb(s, C), T === Kf) {
              var J = H_(s);
              J !== Te && (C = J, T = KO(s, J));
            }
            if (T === YC) {
              var Q = XC;
              throw Yf(s, Te), oh(s, C), Mo(s, Tr()), Q;
            }
          }
          s.finishedWork = H, s.finishedLanes = C, Eee(s, T, C);
        }
      }
      return Mo(s, Tr()), s.callbackNode === f ? JN.bind(null, s) : null;
    }
    function KO(s, l) {
      var f = ZC;
      if (on(s)) {
        var g = Yf(s, l);
        g.flags |= Mr, NQ(s.containerInfo);
      }
      var C = Sb(s, l);
      if (C !== Kf) {
        var S = Lo;
        Lo = f, S !== null && eH(S);
      }
      return C;
    }
    function eH(s) {
      Lo === null ? Lo = s : Lo.push.apply(Lo, s);
    }
    function Eee(s, l, f) {
      switch (l) {
        case Td:
        case YC:
          throw new Error("Root did not complete. This is a bug in React.");
        case Kf: {
          qf(s, Lo, Id);
          break;
        }
        case fb: {
          if (oh(s, f), qv(f) && // do not delay if we're inside an act() scope
          !vH()) {
            var g = HO + qN - Tr();
            if (g > 10) {
              var C = _f(s, Te);
              if (C !== Te)
                break;
              var S = s.suspendedLanes;
              if (!ld(S, f)) {
                var T = eo();
                G_(s, S);
                break;
              }
              s.timeoutHandle = zD(qf.bind(null, s, Lo, Id), g);
              break;
            }
          }
          qf(s, Lo, Id);
          break;
        }
        case qC: {
          if (oh(s, f), R0(f))
            break;
          if (!vH()) {
            var O = O0(s, f), M = O, V = Tr() - M, H = Wee(V) - V;
            if (H > 10) {
              s.timeoutHandle = zD(qf.bind(null, s, Lo, Id), H);
              break;
            }
          }
          qf(s, Lo, Id);
          break;
        }
        case YN: {
          qf(s, Lo, Id);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function bee(s) {
      for (var l = s; ; ) {
        if (l.flags & cf) {
          var f = l.updateQueue;
          if (f !== null) {
            var g = f.stores;
            if (g !== null)
              for (var C = 0; C < g.length; C++) {
                var S = g[C], T = S.getSnapshot, O = S.value;
                try {
                  if (!St(T(), O))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var M = l.child;
        if (l.subtreeFlags & cf && M !== null) {
          M.return = l, l = M;
          continue;
        }
        if (l === s)
          return !0;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === s)
            return !0;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
      return !0;
    }
    function oh(s, l) {
      l = Oc(l, vb), l = Oc(l, QC), U_(s, l);
    }
    function tH(s) {
      if (HZ(), (xi & (ha | Ls)) !== On)
        throw new Error("Should not already be working.");
      Ad();
      var l = _f(s, Te);
      if (!Oa(l, Ht))
        return Mo(s, Tr()), null;
      var f = Sb(s, l);
      if (s.tag !== Yc && f === Kf) {
        var g = H_(s);
        g !== Te && (l = g, f = KO(s, g));
      }
      if (f === YC) {
        var C = XC;
        throw Yf(s, Te), oh(s, l), Mo(s, Tr()), C;
      }
      if (f === BO)
        throw new Error("Root did not complete. This is a bug in React.");
      var S = s.current.alternate;
      return s.finishedWork = S, s.finishedLanes = l, qf(s, Lo, Id), Mo(s, Tr()), null;
    }
    function wee(s, l) {
      l !== Te && (Rc(s, ei(l, Ht)), Mo(s, Tr()), (xi & (ha | Ls)) === On && (JC(), qc()));
    }
    function jO(s, l) {
      var f = xi;
      xi |= jN;
      try {
        return s(l);
      } finally {
        xi = f, xi === On && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Tl.isBatchingLegacy && (JC(), XV());
      }
    }
    function Tee(s, l, f, g, C) {
      var S = wo(), T = ca.transition;
      try {
        return ca.transition = null, an(Kn), s(l, f, g, C);
      } finally {
        an(S), ca.transition = T, xi === On && JC();
      }
    }
    function Dd(s) {
      nh !== null && nh.tag === Yc && (xi & (ha | Ls)) === On && Ad();
      var l = xi;
      xi |= jN;
      var f = ca.transition, g = wo();
      try {
        return ca.transition = null, an(Kn), s ? s() : void 0;
      } finally {
        an(g), ca.transition = f, xi = l, (xi & (ha | Ls)) === On && qc();
      }
    }
    function iH() {
      return (xi & (ha | Ls)) !== On;
    }
    function xb(s, l) {
      La(VO, gu, s), gu = ei(gu, l), NO = ei(NO, l);
    }
    function YO(s) {
      gu = VO.current, Ra(VO, s);
    }
    function Yf(s, l) {
      s.finishedWork = null, s.finishedLanes = Te;
      var f = s.timeoutHandle;
      if (f !== WD && (s.timeoutHandle = WD, q7(f)), Hr !== null)
        for (var g = Hr.return; g !== null; ) {
          var C = g.alternate;
          ON(C, g), g = g.return;
        }
      Ja = s;
      var S = Xf(s.current, null);
      return Hr = S, Rn = gu = NO = l, Ln = Td, XC = null, pb = Te, QC = Te, vb = Te, ZC = null, Lo = null, pZ(), _l.discardPendingWarnings(), S;
    }
    function rH(s, l) {
      do {
        var f = Hr;
        try {
          if (AE(), L1(), en(), FO.current = null, f === null || f.return === null) {
            Ln = YC, XC = l, Hr = null;
            return;
          }
          if (Je && f.mode & Vt && sb(f, !0), vt)
            if (Ju(), l !== null && typeof l == "object" && typeof l.then == "function") {
              var g = l;
              I0(f, g, Rn);
            } else
              Ov(f, l, Rn);
          GZ(s, f.return, f, l, Rn), sH(f);
        } catch (C) {
          l = C, Hr === f && f !== null ? (f = f.return, Hr = f) : f = Hr;
          continue;
        }
        return;
      } while (!0);
    }
    function nH() {
      var s = PO.current;
      return PO.current = ib, s === null ? ib : s;
    }
    function aH(s) {
      PO.current = s;
    }
    function Iee() {
      HO = Tr();
    }
    function ry(s) {
      pb = ei(s, pb);
    }
    function Dee() {
      Ln === Td && (Ln = fb);
    }
    function qO() {
      (Ln === Td || Ln === fb || Ln === Kf) && (Ln = qC), Ja !== null && (Cf(pb) || Cf(QC)) && oh(Ja, Rn);
    }
    function Aee(s) {
      Ln !== qC && (Ln = Kf), ZC === null ? ZC = [s] : ZC.push(s);
    }
    function Oee() {
      return Ln === Td;
    }
    function Sb(s, l) {
      var f = xi;
      xi |= ha;
      var g = nH();
      if (Ja !== s || Rn !== l) {
        if (bn) {
          var C = s.memoizedUpdaters;
          C.size > 0 && (ny(s, Rn), C.clear()), Zv(s, l);
        }
        Id = Y_(), Yf(s, l);
      }
      es(l);
      do
        try {
          Ree();
          break;
        } catch (S) {
          rH(s, S);
        }
      while (!0);
      if (AE(), xi = f, aH(g), Hr !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return wc(), Ja = null, Rn = Te, Ln;
    }
    function Ree() {
      for (; Hr !== null; )
        oH(Hr);
    }
    function Lee(s, l) {
      var f = xi;
      xi |= ha;
      var g = nH();
      if (Ja !== s || Rn !== l) {
        if (bn) {
          var C = s.memoizedUpdaters;
          C.size > 0 && (ny(s, Rn), C.clear()), Zv(s, l);
        }
        Id = Y_(), JC(), Yf(s, l);
      }
      es(l);
      do
        try {
          Mee();
          break;
        } catch (S) {
          rH(s, S);
        }
      while (!0);
      return AE(), aH(g), xi = f, Hr !== null ? (pf(), Td) : (wc(), Ja = null, Rn = Te, Ln);
    }
    function Mee() {
      for (; Hr !== null && !bv(); )
        oH(Hr);
    }
    function oH(s) {
      var l = s.alternate;
      Xi(s);
      var f;
      (s.mode & Vt) !== Ft ? (uO(s), f = XO(l, s, gu), sb(s, !0)) : f = XO(l, s, gu), en(), s.memoizedProps = s.pendingProps, f === null ? sH(s) : Hr = f, FO.current = null;
    }
    function sH(s) {
      var l = s;
      do {
        var f = l.alternate, g = l.return;
        if ((l.flags & Ka) === Lt) {
          Xi(l);
          var C = void 0;
          if ((l.mode & Vt) === Ft ? C = AN(f, l, gu) : (uO(l), C = AN(f, l, gu), sb(l, !1)), en(), C !== null) {
            Hr = C;
            return;
          }
        } else {
          var S = EJ(f, l);
          if (S !== null) {
            S.flags &= _0, Hr = S;
            return;
          }
          if ((l.mode & Vt) !== Ft) {
            sb(l, !1);
            for (var T = l.actualDuration, O = l.child; O !== null; )
              T += O.actualDuration, O = O.sibling;
            l.actualDuration = T;
          }
          if (g !== null)
            g.flags |= Ka, g.subtreeFlags = Lt, g.deletions = null;
          else {
            Ln = BO, Hr = null;
            return;
          }
        }
        var M = l.sibling;
        if (M !== null) {
          Hr = M;
          return;
        }
        l = g, Hr = l;
      } while (l !== null);
      Ln === Td && (Ln = YN);
    }
    function qf(s, l, f) {
      var g = wo(), C = ca.transition;
      try {
        ca.transition = null, an(Kn), kee(s, l, f, g);
      } finally {
        ca.transition = C, an(g);
      }
      return null;
    }
    function kee(s, l, f, g) {
      do
        Ad();
      while (nh !== null);
      if (Gee(), (xi & (ha | Ls)) !== On)
        throw new Error("Should not already be working.");
      var C = s.finishedWork, S = s.finishedLanes;
      if (Iv(S), C === null)
        return P_(), null;
      if (S === Te && o("root.finishedLanes should not be empty during a commit. This is a bug in React."), s.finishedWork = null, s.finishedLanes = Te, C === s.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      s.callbackNode = null, s.callbackPriority = yi;
      var T = ei(C.lanes, C.childLanes);
      K_(s, T), s === Ja && (Ja = null, Hr = null, Rn = Te), ((C.subtreeFlags & xo) !== Lt || (C.flags & xo) !== Lt) && (jf || (jf = !0, WO = f, JO(Ss, function() {
        return Ad(), null;
      })));
      var O = (C.subtreeFlags & (Sc | Ta | Gn | xo)) !== Lt, M = (C.flags & (Sc | Ta | Gn | xo)) !== Lt;
      if (O || M) {
        var V = ca.transition;
        ca.transition = null;
        var H = wo();
        an(Kn);
        var J = xi;
        xi |= Ls, FO.current = null;
        var Q = DJ(s, C);
        rN(), zJ(s, C, S), z7(s.containerInfo), s.current = C, D0(S), WJ(C, s, S), bc(), x0(), xi = J, an(H), ca.transition = V;
      } else
        s.current = C, rN();
      var fe = jf;
      if (jf ? (jf = !1, nh = s, ey = S) : ($g = 0, _b = null), T = s.pendingLanes, T === Te && (Hg = null), fe || cH(s.current, !1), ll(C.stateNode, g), bn && s.memoizedUpdaters.clear(), fee(), Mo(s, Tr()), l !== null)
        for (var ce = s.onRecoverableError, me = 0; me < l.length; me++) {
          var lt = l[me], Mt = lt.stack, Tt = lt.digest;
          ce(lt.value, {
            componentStack: Mt,
            digest: Tt
          });
        }
      if (gb) {
        gb = !1;
        var vi = $O;
        throw $O = null, vi;
      }
      return Oa(ey, Ht) && s.tag !== Yc && Ad(), T = s.pendingLanes, Oa(T, Ht) ? (VZ(), s === UO ? ty++ : (ty = 0, UO = s)) : ty = 0, qc(), P_(), null;
    }
    function Ad() {
      if (nh !== null) {
        var s = Ef(ey), l = fD(cl, s), f = ca.transition, g = wo();
        try {
          return ca.transition = null, an(l), Fee();
        } finally {
          an(g), ca.transition = f;
        }
      }
      return !1;
    }
    function Pee(s) {
      zO.push(s), jf || (jf = !0, JO(Ss, function() {
        return Ad(), null;
      }));
    }
    function Fee() {
      if (nh === null)
        return !1;
      var s = WO;
      WO = null;
      var l = nh, f = ey;
      if (nh = null, ey = Te, (xi & (ha | Ls)) !== On)
        throw new Error("Cannot flush passive effects while already rendering.");
      GO = !0, mb = !1, A0(f);
      var g = xi;
      xi |= Ls, XJ(l.current), KJ(l, l.current, f, s);
      {
        var C = zO;
        zO = [];
        for (var S = 0; S < C.length; S++) {
          var T = C[S];
          LJ(l, T);
        }
      }
      ff(), cH(l.current, !0), xi = g, qc(), mb ? l === _b ? $g++ : ($g = 0, _b = l) : $g = 0, GO = !1, mb = !1, Xl(l);
      {
        var O = l.current.stateNode;
        O.effectDuration = 0, O.passiveEffectDuration = 0;
      }
      return !0;
    }
    function lH(s) {
      return Hg !== null && Hg.has(s);
    }
    function Bee(s) {
      Hg === null ? Hg = /* @__PURE__ */ new Set([s]) : Hg.add(s);
    }
    function Vee(s) {
      gb || (gb = !0, $O = s);
    }
    var Nee = Vee;
    function uH(s, l, f) {
      var g = Uf(f, l), C = aN(s, g, Ht), S = Qc(s, C, Ht), T = eo();
      S !== null && (ud(S, Ht, T), Mo(S, T));
    }
    function Cr(s, l, f) {
      if (wJ(f), ay(!1), s.tag === _) {
        uH(s, s, f);
        return;
      }
      var g = null;
      for (g = l; g !== null; ) {
        if (g.tag === _) {
          uH(g, s, f);
          return;
        } else if (g.tag === p) {
          var C = g.type, S = g.stateNode;
          if (typeof C.getDerivedStateFromError == "function" || typeof S.componentDidCatch == "function" && !lH(S)) {
            var T = Uf(f, s), O = vO(g, T, Ht), M = Qc(g, O, Ht), V = eo();
            M !== null && (ud(M, Ht, V), Mo(M, V));
            return;
          }
        }
        g = g.return;
      }
      o(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, f);
    }
    function Hee(s, l, f) {
      var g = s.pingCache;
      g !== null && g.delete(l);
      var C = eo();
      G_(s, f), qee(s), Ja === s && ld(Rn, f) && (Ln === qC || Ln === fb && qv(Rn) && Tr() - HO < qN ? Yf(s, Te) : vb = ei(vb, f)), Mo(s, C);
    }
    function dH(s, l) {
      l === yi && (l = yee(s));
      var f = eo(), g = Oo(s, l);
      g !== null && (ud(g, l, f), Mo(g, f));
    }
    function $ee(s) {
      var l = s.memoizedState, f = yi;
      l !== null && (f = l.retryLane), dH(s, f);
    }
    function zee(s, l) {
      var f = yi, g;
      switch (s.tag) {
        case z:
          g = s.stateNode;
          var C = s.memoizedState;
          C !== null && (f = C.retryLane);
          break;
        case Ce:
          g = s.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      g !== null && g.delete(l), dH(s, f);
    }
    function Wee(s) {
      return s < 120 ? 120 : s < 480 ? 480 : s < 1080 ? 1080 : s < 1920 ? 1920 : s < 3e3 ? 3e3 : s < 4320 ? 4320 : gee(s / 1960) * 1960;
    }
    function Uee() {
      if (ty > _ee)
        throw ty = 0, UO = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      $g > Cee && ($g = 0, _b = null, o("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function Gee() {
      _l.flushLegacyContextWarning(), _l.flushPendingUnsafeLifecycleWarnings();
    }
    function cH(s, l) {
      Xi(s), Eb(s, wa, aee), l && Eb(s, Zu, oee), Eb(s, wa, ree), l && Eb(s, Zu, nee), en();
    }
    function Eb(s, l, f) {
      for (var g = s, C = null; g !== null; ) {
        var S = g.subtreeFlags & l;
        g !== C && g.child !== null && S !== Lt ? g = g.child : ((g.flags & l) !== Lt && f(g), g.sibling !== null ? g = g.sibling : g = C = g.return);
      }
    }
    var bb = null;
    function hH(s) {
      {
        if ((xi & ha) !== On || !(s.mode & li))
          return;
        var l = s.tag;
        if (l !== v && l !== _ && l !== p && l !== c && l !== K && l !== ie && l !== pe)
          return;
        var f = Jt(s) || "ReactComponent";
        if (bb !== null) {
          if (bb.has(f))
            return;
          bb.add(f);
        } else
          bb = /* @__PURE__ */ new Set([f]);
        var g = Ur;
        try {
          Xi(s), o("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          g ? Xi(s) : en();
        }
      }
    }
    var XO;
    {
      var Kee = null;
      XO = function(s, l, f) {
        var g = yH(Kee, l);
        try {
          return bN(s, l, f);
        } catch (S) {
          if (eZ() || S !== null && typeof S == "object" && typeof S.then == "function")
            throw S;
          if (AE(), L1(), ON(s, l), yH(l, g), l.mode & Vt && uO(l), Qu(null, bN, null, s, l, f), oD()) {
            var C = b_();
            typeof C == "object" && C !== null && C._suppressLogging && typeof S == "object" && S !== null && !S._suppressLogging && (S._suppressLogging = !0);
          }
          throw S;
        }
      };
    }
    var fH = !1, QO;
    QO = /* @__PURE__ */ new Set();
    function jee(s) {
      if (vo && !PZ())
        switch (s.tag) {
          case c:
          case K:
          case pe: {
            var l = Hr && Jt(Hr) || "Unknown", f = l;
            if (!QO.has(f)) {
              QO.add(f);
              var g = Jt(s) || "Unknown";
              o("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", g, l, l);
            }
            break;
          }
          case p: {
            fH || (o("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), fH = !0);
            break;
          }
        }
    }
    function ny(s, l) {
      if (bn) {
        var f = s.memoizedUpdaters;
        f.forEach(function(g) {
          j_(s, g, l);
        });
      }
    }
    var ZO = {};
    function JO(s, l) {
      {
        var f = Tl.current;
        return f !== null ? (f.push(l), ZO) : Ev(s, l);
      }
    }
    function pH(s) {
      if (s !== ZO)
        return y0(s);
    }
    function vH() {
      return Tl.current !== null;
    }
    function Yee(s) {
      {
        if (s.mode & li) {
          if (!KN())
            return;
        } else if (!vee() || xi !== On || s.tag !== c && s.tag !== K && s.tag !== pe)
          return;
        if (Tl.current === null) {
          var l = Ur;
          try {
            Xi(s), o(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, Jt(s));
          } finally {
            l ? Xi(s) : en();
          }
        }
      }
    }
    function qee(s) {
      s.tag !== Yc && KN() && Tl.current === null && o(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function ay(s) {
      ZN = s;
    }
    var Ms = null, zg = null, Xee = function(s) {
      Ms = s;
    };
    function Wg(s) {
      {
        if (Ms === null)
          return s;
        var l = Ms(s);
        return l === void 0 ? s : l.current;
      }
    }
    function eR(s) {
      return Wg(s);
    }
    function tR(s) {
      {
        if (Ms === null)
          return s;
        var l = Ms(s);
        if (l === void 0) {
          if (s != null && typeof s.render == "function") {
            var f = Wg(s.render);
            if (s.render !== f) {
              var g = {
                $$typeof: ye,
                render: f
              };
              return s.displayName !== void 0 && (g.displayName = s.displayName), g;
            }
          }
          return s;
        }
        return l.current;
      }
    }
    function gH(s, l) {
      {
        if (Ms === null)
          return !1;
        var f = s.elementType, g = l.type, C = !1, S = typeof g == "object" && g !== null ? g.$$typeof : null;
        switch (s.tag) {
          case p: {
            typeof g == "function" && (C = !0);
            break;
          }
          case c: {
            (typeof g == "function" || S === Xe) && (C = !0);
            break;
          }
          case K: {
            (S === ye || S === Xe) && (C = !0);
            break;
          }
          case ie:
          case pe: {
            (S === Ze || S === Xe) && (C = !0);
            break;
          }
          default:
            return !1;
        }
        if (C) {
          var T = Ms(f);
          if (T !== void 0 && T === Ms(g))
            return !0;
        }
        return !1;
      }
    }
    function mH(s) {
      {
        if (Ms === null || typeof WeakSet != "function")
          return;
        zg === null && (zg = /* @__PURE__ */ new WeakSet()), zg.add(s);
      }
    }
    var Qee = function(s, l) {
      {
        if (Ms === null)
          return;
        var f = l.staleFamilies, g = l.updatedFamilies;
        Ad(), Dd(function() {
          iR(s.current, g, f);
        });
      }
    }, Zee = function(s, l) {
      {
        if (s.context !== is)
          return;
        Ad(), Dd(function() {
          oy(l, s, null, null);
        });
      }
    };
    function iR(s, l, f) {
      {
        var g = s.alternate, C = s.child, S = s.sibling, T = s.tag, O = s.type, M = null;
        switch (T) {
          case c:
          case pe:
          case p:
            M = O;
            break;
          case K:
            M = O.render;
            break;
        }
        if (Ms === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var V = !1, H = !1;
        if (M !== null) {
          var J = Ms(M);
          J !== void 0 && (f.has(J) ? H = !0 : l.has(J) && (T === p ? H = !0 : V = !0));
        }
        if (zg !== null && (zg.has(s) || g !== null && zg.has(g)) && (H = !0), H && (s._debugNeedsRemount = !0), H || V) {
          var Q = Oo(s, Ht);
          Q !== null && Mn(Q, s, Ht, nr);
        }
        C !== null && !H && iR(C, l, f), S !== null && iR(S, l, f);
      }
    }
    var Jee = function(s, l) {
      {
        var f = /* @__PURE__ */ new Set(), g = new Set(l.map(function(C) {
          return C.current;
        }));
        return rR(s.current, g, f), f;
      }
    };
    function rR(s, l, f) {
      {
        var g = s.child, C = s.sibling, S = s.tag, T = s.type, O = null;
        switch (S) {
          case c:
          case pe:
          case p:
            O = T;
            break;
          case K:
            O = T.render;
            break;
        }
        var M = !1;
        O !== null && l.has(O) && (M = !0), M ? ete(s, f) : g !== null && rR(g, l, f), C !== null && rR(C, l, f);
      }
    }
    function ete(s, l) {
      {
        var f = tte(s, l);
        if (f)
          return;
        for (var g = s; ; ) {
          switch (g.tag) {
            case b:
              l.add(g.stateNode);
              return;
            case y:
              l.add(g.stateNode.containerInfo);
              return;
            case _:
              l.add(g.stateNode.containerInfo);
              return;
          }
          if (g.return === null)
            throw new Error("Expected to reach root first.");
          g = g.return;
        }
      }
    }
    function tte(s, l) {
      for (var f = s, g = !1; ; ) {
        if (f.tag === b)
          g = !0, l.add(f.stateNode);
        else if (f.child !== null) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === s)
          return g;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === s)
            return g;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
      return !1;
    }
    var nR;
    {
      nR = !1;
      try {
        var _H = Object.preventExtensions({});
      } catch {
        nR = !0;
      }
    }
    function ite(s, l, f, g) {
      this.tag = s, this.key = f, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = l, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = g, this.flags = Lt, this.subtreeFlags = Lt, this.deletions = null, this.lanes = Te, this.childLanes = Te, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !nR && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var rs = function(s, l, f, g) {
      return new ite(s, l, f, g);
    };
    function aR(s) {
      var l = s.prototype;
      return !!(l && l.isReactComponent);
    }
    function rte(s) {
      return typeof s == "function" && !aR(s) && s.defaultProps === void 0;
    }
    function nte(s) {
      if (typeof s == "function")
        return aR(s) ? p : c;
      if (s != null) {
        var l = s.$$typeof;
        if (l === ye)
          return K;
        if (l === Ze)
          return ie;
      }
      return v;
    }
    function Xf(s, l) {
      var f = s.alternate;
      f === null ? (f = rs(s.tag, l, s.key, s.mode), f.elementType = s.elementType, f.type = s.type, f.stateNode = s.stateNode, f._debugSource = s._debugSource, f._debugOwner = s._debugOwner, f._debugHookTypes = s._debugHookTypes, f.alternate = s, s.alternate = f) : (f.pendingProps = l, f.type = s.type, f.flags = Lt, f.subtreeFlags = Lt, f.deletions = null, f.actualDuration = 0, f.actualStartTime = -1), f.flags = s.flags & En, f.childLanes = s.childLanes, f.lanes = s.lanes, f.child = s.child, f.memoizedProps = s.memoizedProps, f.memoizedState = s.memoizedState, f.updateQueue = s.updateQueue;
      var g = s.dependencies;
      switch (f.dependencies = g === null ? null : {
        lanes: g.lanes,
        firstContext: g.firstContext
      }, f.sibling = s.sibling, f.index = s.index, f.ref = s.ref, f.selfBaseDuration = s.selfBaseDuration, f.treeBaseDuration = s.treeBaseDuration, f._debugNeedsRemount = s._debugNeedsRemount, f.tag) {
        case v:
        case c:
        case pe:
          f.type = Wg(s.type);
          break;
        case p:
          f.type = eR(s.type);
          break;
        case K:
          f.type = tR(s.type);
          break;
      }
      return f;
    }
    function ate(s, l) {
      s.flags &= En | vr;
      var f = s.alternate;
      if (f === null)
        s.childLanes = Te, s.lanes = l, s.child = null, s.subtreeFlags = Lt, s.memoizedProps = null, s.memoizedState = null, s.updateQueue = null, s.dependencies = null, s.stateNode = null, s.selfBaseDuration = 0, s.treeBaseDuration = 0;
      else {
        s.childLanes = f.childLanes, s.lanes = f.lanes, s.child = f.child, s.subtreeFlags = Lt, s.deletions = null, s.memoizedProps = f.memoizedProps, s.memoizedState = f.memoizedState, s.updateQueue = f.updateQueue, s.type = f.type;
        var g = f.dependencies;
        s.dependencies = g === null ? null : {
          lanes: g.lanes,
          firstContext: g.firstContext
        }, s.selfBaseDuration = f.selfBaseDuration, s.treeBaseDuration = f.treeBaseDuration;
      }
      return s;
    }
    function ote(s, l, f) {
      var g;
      return s === xE ? (g = li, l === !0 && (g |= Ir, g |= Eo)) : g = Ft, bn && (g |= Vt), rs(_, null, null, g);
    }
    function oR(s, l, f, g, C, S) {
      var T = v, O = s;
      if (typeof s == "function")
        aR(s) ? (T = p, O = eR(O)) : O = Wg(O);
      else if (typeof s == "string")
        T = b;
      else
        e:
          switch (s) {
            case ya:
              return sh(f.children, C, S, l);
            case jo:
              T = L, C |= Ir, (C & li) !== Ft && (C |= Eo);
              break;
            case G:
              return ste(f, C, S, l);
            case Fe:
              return lte(f, C, S, l);
            case Ue:
              return ute(f, C, S, l);
            case ci:
              return CH(f, C, S, l);
            case pr:
            case Nt:
            case xa:
            case Cs:
            case kt:
            default: {
              if (typeof s == "object" && s !== null)
                switch (s.$$typeof) {
                  case ke:
                    T = $;
                    break e;
                  case U:
                    T = B;
                    break e;
                  case ye:
                    T = K, O = tR(O);
                    break e;
                  case Ze:
                    T = ie;
                    break e;
                  case Xe:
                    T = _e, O = null;
                    break e;
                }
              var M = "";
              {
                (s === void 0 || typeof s == "object" && s !== null && Object.keys(s).length === 0) && (M += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var V = g ? Jt(g) : null;
                V && (M += `

Check the render method of \`` + V + "`.");
              }
              throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (s == null ? s : typeof s) + "." + M));
            }
          }
      var H = rs(T, f, l, C);
      return H.elementType = s, H.type = O, H.lanes = S, H._debugOwner = g, H;
    }
    function sR(s, l, f) {
      var g = null;
      g = s._owner;
      var C = s.type, S = s.key, T = s.props, O = oR(C, S, T, g, l, f);
      return O._debugSource = s._source, O._debugOwner = s._owner, O;
    }
    function sh(s, l, f, g) {
      var C = rs(A, s, g, l);
      return C.lanes = f, C;
    }
    function ste(s, l, f, g) {
      typeof s.id != "string" && o('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof s.id);
      var C = rs(te, s, g, l | Vt);
      return C.elementType = G, C.lanes = f, C.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, C;
    }
    function lte(s, l, f, g) {
      var C = rs(z, s, g, l);
      return C.elementType = Fe, C.lanes = f, C;
    }
    function ute(s, l, f, g) {
      var C = rs(Ce, s, g, l);
      return C.elementType = Ue, C.lanes = f, C;
    }
    function CH(s, l, f, g) {
      var C = rs(Ve, s, g, l);
      C.elementType = ci, C.lanes = f;
      var S = {
        isHidden: !1
      };
      return C.stateNode = S, C;
    }
    function lR(s, l, f) {
      var g = rs(I, s, null, l);
      return g.lanes = f, g;
    }
    function dte() {
      var s = rs(b, null, null, Ft);
      return s.elementType = "DELETED", s;
    }
    function cte(s) {
      var l = rs(De, null, null, Ft);
      return l.stateNode = s, l;
    }
    function uR(s, l, f) {
      var g = s.children !== null ? s.children : [], C = rs(y, g, s.key, l);
      return C.lanes = f, C.stateNode = {
        containerInfo: s.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: s.implementation
      }, C;
    }
    function yH(s, l) {
      return s === null && (s = rs(v, null, null, Ft)), s.tag = l.tag, s.key = l.key, s.elementType = l.elementType, s.type = l.type, s.stateNode = l.stateNode, s.return = l.return, s.child = l.child, s.sibling = l.sibling, s.index = l.index, s.ref = l.ref, s.pendingProps = l.pendingProps, s.memoizedProps = l.memoizedProps, s.updateQueue = l.updateQueue, s.memoizedState = l.memoizedState, s.dependencies = l.dependencies, s.mode = l.mode, s.flags = l.flags, s.subtreeFlags = l.subtreeFlags, s.deletions = l.deletions, s.lanes = l.lanes, s.childLanes = l.childLanes, s.alternate = l.alternate, s.actualDuration = l.actualDuration, s.actualStartTime = l.actualStartTime, s.selfBaseDuration = l.selfBaseDuration, s.treeBaseDuration = l.treeBaseDuration, s._debugSource = l._debugSource, s._debugOwner = l._debugOwner, s._debugNeedsRemount = l._debugNeedsRemount, s._debugHookTypes = l._debugHookTypes, s;
    }
    function hte(s, l, f, g, C) {
      this.tag = l, this.containerInfo = s, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = WD, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = yi, this.eventTimes = Qv(Te), this.expirationTimes = Qv(nr), this.pendingLanes = Te, this.suspendedLanes = Te, this.pingedLanes = Te, this.expiredLanes = Te, this.mutableReadLanes = Te, this.finishedLanes = Te, this.entangledLanes = Te, this.entanglements = Qv(Te), this.identifierPrefix = g, this.onRecoverableError = C, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var S = this.pendingUpdatersLaneMap = [], T = 0; T < mr; T++)
          S.push(/* @__PURE__ */ new Set());
      }
      switch (l) {
        case xE:
          this._debugRootType = f ? "hydrateRoot()" : "createRoot()";
          break;
        case Yc:
          this._debugRootType = f ? "hydrate()" : "render()";
          break;
      }
    }
    function xH(s, l, f, g, C, S, T, O, M, V) {
      var H = new hte(s, l, f, O, M), J = ote(l, S);
      H.current = J, J.stateNode = H;
      {
        var Q = {
          element: g,
          isDehydrated: f,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        J.memoizedState = Q;
      }
      return gA(J), H;
    }
    var dR = "18.2.0";
    function fte(s, l, f) {
      var g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return Wi(g), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: Wn,
        key: g == null ? null : "" + g,
        children: s,
        containerInfo: l,
        implementation: f
      };
    }
    var cR, hR;
    cR = !1, hR = {};
    function SH(s) {
      if (!s)
        return is;
      var l = _o(s), f = GQ(l);
      if (l.tag === p) {
        var g = l.type;
        if (uu(g))
          return jV(l, g, f);
      }
      return f;
    }
    function pte(s, l) {
      {
        var f = _o(s);
        if (f === void 0) {
          if (typeof s.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var g = Object.keys(s).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + g);
        }
        var C = So(f);
        if (C === null)
          return null;
        if (C.mode & Ir) {
          var S = Jt(f) || "Component";
          if (!hR[S]) {
            hR[S] = !0;
            var T = Ur;
            try {
              Xi(C), f.mode & Ir ? o("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", l, l, S) : o("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", l, l, S);
            } finally {
              T ? Xi(T) : en();
            }
          }
        }
        return C.stateNode;
      }
    }
    function EH(s, l, f, g, C, S, T, O) {
      var M = !1, V = null;
      return xH(s, l, M, V, f, g, C, S, T);
    }
    function bH(s, l, f, g, C, S, T, O, M, V) {
      var H = !0, J = xH(f, g, H, s, C, S, T, O, M);
      J.context = SH(null);
      var Q = J.current, fe = eo(), ce = ah(Q), me = bd(fe, ce);
      return me.callback = l ?? null, Qc(Q, me, ce), xee(J, ce, fe), J;
    }
    function oy(s, l, f, g) {
      S0(l, s);
      var C = l.current, S = eo(), T = ah(C);
      ed(T);
      var O = SH(f);
      l.context === null ? l.context = O : l.pendingContext = O, vo && Ur !== null && !cR && (cR = !0, o(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, Jt(Ur) || "Unknown"));
      var M = bd(S, T);
      M.payload = {
        element: s
      }, g = g === void 0 ? null : g, g !== null && (typeof g != "function" && o("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", g), M.callback = g);
      var V = Qc(C, M, T);
      return V !== null && (Mn(V, C, T, S), kE(V, C, T)), T;
    }
    function wb(s) {
      var l = s.current;
      if (!l.child)
        return null;
      switch (l.child.tag) {
        case b:
          return l.child.stateNode;
        default:
          return l.child.stateNode;
      }
    }
    function vte(s) {
      switch (s.tag) {
        case _: {
          var l = s.stateNode;
          if (on(l)) {
            var f = uD(l);
            wee(l, f);
          }
          break;
        }
        case z: {
          Dd(function() {
            var C = Oo(s, Ht);
            if (C !== null) {
              var S = eo();
              Mn(C, s, Ht, S);
            }
          });
          var g = Ht;
          fR(s, g);
          break;
        }
      }
    }
    function wH(s, l) {
      var f = s.memoizedState;
      f !== null && f.dehydrated !== null && (f.retryLane = k0(f.retryLane, l));
    }
    function fR(s, l) {
      wH(s, l);
      var f = s.alternate;
      f && wH(f, l);
    }
    function gte(s) {
      if (s.tag === z) {
        var l = Tc, f = Oo(s, l);
        if (f !== null) {
          var g = eo();
          Mn(f, s, l, g);
        }
        fR(s, l);
      }
    }
    function mte(s) {
      if (s.tag === z) {
        var l = ah(s), f = Oo(s, l);
        if (f !== null) {
          var g = eo();
          Mn(f, s, l, g);
        }
        fR(s, l);
      }
    }
    function TH(s) {
      var l = C0(s);
      return l === null ? null : l.stateNode;
    }
    var IH = function(s) {
      return null;
    };
    function _te(s) {
      return IH(s);
    }
    var DH = function(s) {
      return !1;
    };
    function Cte(s) {
      return DH(s);
    }
    var AH = null, OH = null, RH = null, LH = null, MH = null, kH = null, PH = null, FH = null, BH = null;
    {
      var VH = function(s, l, f) {
        var g = l[f], C = hn(s) ? s.slice() : fi({}, s);
        return f + 1 === l.length ? (hn(C) ? C.splice(g, 1) : delete C[g], C) : (C[g] = VH(s[g], l, f + 1), C);
      }, NH = function(s, l) {
        return VH(s, l, 0);
      }, HH = function(s, l, f, g) {
        var C = l[g], S = hn(s) ? s.slice() : fi({}, s);
        if (g + 1 === l.length) {
          var T = f[g];
          S[T] = S[C], hn(S) ? S.splice(C, 1) : delete S[C];
        } else
          S[C] = HH(
            // $FlowFixMe number or string is fine here
            s[C],
            l,
            f,
            g + 1
          );
        return S;
      }, $H = function(s, l, f) {
        if (l.length !== f.length) {
          a("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var g = 0; g < f.length - 1; g++)
            if (l[g] !== f[g]) {
              a("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return HH(s, l, f, 0);
      }, zH = function(s, l, f, g) {
        if (f >= l.length)
          return g;
        var C = l[f], S = hn(s) ? s.slice() : fi({}, s);
        return S[C] = zH(s[C], l, f + 1, g), S;
      }, WH = function(s, l, f) {
        return zH(s, l, 0, f);
      }, pR = function(s, l) {
        for (var f = s.memoizedState; f !== null && l > 0; )
          f = f.next, l--;
        return f;
      };
      AH = function(s, l, f, g) {
        var C = pR(s, l);
        if (C !== null) {
          var S = WH(C.memoizedState, f, g);
          C.memoizedState = S, C.baseState = S, s.memoizedProps = fi({}, s.memoizedProps);
          var T = Oo(s, Ht);
          T !== null && Mn(T, s, Ht, nr);
        }
      }, OH = function(s, l, f) {
        var g = pR(s, l);
        if (g !== null) {
          var C = NH(g.memoizedState, f);
          g.memoizedState = C, g.baseState = C, s.memoizedProps = fi({}, s.memoizedProps);
          var S = Oo(s, Ht);
          S !== null && Mn(S, s, Ht, nr);
        }
      }, RH = function(s, l, f, g) {
        var C = pR(s, l);
        if (C !== null) {
          var S = $H(C.memoizedState, f, g);
          C.memoizedState = S, C.baseState = S, s.memoizedProps = fi({}, s.memoizedProps);
          var T = Oo(s, Ht);
          T !== null && Mn(T, s, Ht, nr);
        }
      }, LH = function(s, l, f) {
        s.pendingProps = WH(s.memoizedProps, l, f), s.alternate && (s.alternate.pendingProps = s.pendingProps);
        var g = Oo(s, Ht);
        g !== null && Mn(g, s, Ht, nr);
      }, MH = function(s, l) {
        s.pendingProps = NH(s.memoizedProps, l), s.alternate && (s.alternate.pendingProps = s.pendingProps);
        var f = Oo(s, Ht);
        f !== null && Mn(f, s, Ht, nr);
      }, kH = function(s, l, f) {
        s.pendingProps = $H(s.memoizedProps, l, f), s.alternate && (s.alternate.pendingProps = s.pendingProps);
        var g = Oo(s, Ht);
        g !== null && Mn(g, s, Ht, nr);
      }, PH = function(s) {
        var l = Oo(s, Ht);
        l !== null && Mn(l, s, Ht, nr);
      }, FH = function(s) {
        IH = s;
      }, BH = function(s) {
        DH = s;
      };
    }
    function yte(s) {
      var l = So(s);
      return l === null ? null : l.stateNode;
    }
    function xte(s) {
      return null;
    }
    function Ste() {
      return Ur;
    }
    function Ete(s) {
      var l = s.findFiberByHostInstance, f = i.ReactCurrentDispatcher;
      return M_({
        bundleType: s.bundleType,
        version: s.version,
        rendererPackageName: s.rendererPackageName,
        rendererConfig: s.rendererConfig,
        overrideHookState: AH,
        overrideHookStateDeletePath: OH,
        overrideHookStateRenamePath: RH,
        overrideProps: LH,
        overridePropsDeletePath: MH,
        overridePropsRenamePath: kH,
        setErrorHandler: FH,
        setSuspenseHandler: BH,
        scheduleUpdate: PH,
        currentDispatcherRef: f,
        findHostInstanceByFiber: yte,
        findFiberByHostInstance: l || xte,
        // React Refresh
        findHostInstancesForRefresh: Jee,
        scheduleRefresh: Qee,
        scheduleRoot: Zee,
        setRefreshHandler: Xee,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: Ste,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: dR
      });
    }
    var UH = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(s) {
      console.error(s);
    };
    function vR(s) {
      this._internalRoot = s;
    }
    Tb.prototype.render = vR.prototype.render = function(s) {
      var l = this._internalRoot;
      if (l === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? o("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : Ib(arguments[1]) ? o("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && o("You passed a second argument to root.render(...) but it only accepts one argument.");
        var f = l.containerInfo;
        if (f.nodeType !== Gr) {
          var g = TH(l.current);
          g && g.parentNode !== f && o("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      oy(s, l, null, null);
    }, Tb.prototype.unmount = vR.prototype.unmount = function() {
      typeof arguments[0] == "function" && o("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var s = this._internalRoot;
      if (s !== null) {
        this._internalRoot = null;
        var l = s.containerInfo;
        iH() && o("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Dd(function() {
          oy(null, s, null, null);
        }), zV(l);
      }
    };
    function bte(s, l) {
      if (!Ib(s))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      GH(s);
      var f = !1, g = !1, C = "", S = UH, T = null;
      l != null && (l.hydrate ? a("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof l == "object" && l !== null && l.$$typeof === Ko && o(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), l.unstable_strictMode === !0 && (f = !0), l.identifierPrefix !== void 0 && (C = l.identifierPrefix), l.onRecoverableError !== void 0 && (S = l.onRecoverableError), l.transitionCallbacks !== void 0 && (T = l.transitionCallbacks));
      var O = EH(s, xE, null, f, g, C, S);
      pE(O.current, s);
      var M = s.nodeType === Gr ? s.parentNode : s;
      return pC(M), new vR(O);
    }
    function Tb(s) {
      this._internalRoot = s;
    }
    function wte(s) {
      s && z0(s);
    }
    Tb.prototype.unstable_scheduleHydration = wte;
    function Tte(s, l, f) {
      if (!Ib(s))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      GH(s), l === void 0 && o("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var g = f ?? null, C = f != null && f.hydratedSources || null, S = !1, T = !1, O = "", M = UH;
      f != null && (f.unstable_strictMode === !0 && (S = !0), f.identifierPrefix !== void 0 && (O = f.identifierPrefix), f.onRecoverableError !== void 0 && (M = f.onRecoverableError));
      var V = bH(l, null, s, xE, g, S, T, O, M);
      if (pE(V.current, s), pC(s), C)
        for (var H = 0; H < C.length; H++) {
          var J = C[H];
          AZ(V, J);
        }
      return new Tb(V);
    }
    function Ib(s) {
      return !!(s && (s.nodeType === Sa || s.nodeType === Qo || s.nodeType === Gu || !Me));
    }
    function sy(s) {
      return !!(s && (s.nodeType === Sa || s.nodeType === Qo || s.nodeType === Gu || s.nodeType === Gr && s.nodeValue === " react-mount-point-unstable "));
    }
    function GH(s) {
      s.nodeType === Sa && s.tagName && s.tagName.toUpperCase() === "BODY" && o("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), wC(s) && (s._reactRootContainer ? o("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : o("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var Ite = i.ReactCurrentOwner, KH;
    KH = function(s) {
      if (s._reactRootContainer && s.nodeType !== Gr) {
        var l = TH(s._reactRootContainer.current);
        l && l.parentNode !== s && o("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var f = !!s._reactRootContainer, g = gR(s), C = !!(g && Kc(g));
      C && !f && o("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), s.nodeType === Sa && s.tagName && s.tagName.toUpperCase() === "BODY" && o("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function gR(s) {
      return s ? s.nodeType === Qo ? s.documentElement : s.firstChild : null;
    }
    function jH() {
    }
    function Dte(s, l, f, g, C) {
      if (C) {
        if (typeof g == "function") {
          var S = g;
          g = function() {
            var Q = wb(T);
            S.call(Q);
          };
        }
        var T = bH(
          l,
          g,
          s,
          Yc,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          jH
        );
        s._reactRootContainer = T, pE(T.current, s);
        var O = s.nodeType === Gr ? s.parentNode : s;
        return pC(O), Dd(), T;
      } else {
        for (var M; M = s.lastChild; )
          s.removeChild(M);
        if (typeof g == "function") {
          var V = g;
          g = function() {
            var Q = wb(H);
            V.call(Q);
          };
        }
        var H = EH(
          s,
          Yc,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          jH
        );
        s._reactRootContainer = H, pE(H.current, s);
        var J = s.nodeType === Gr ? s.parentNode : s;
        return pC(J), Dd(function() {
          oy(l, H, f, g);
        }), H;
      }
    }
    function Ate(s, l) {
      s !== null && typeof s != "function" && o("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", l, s);
    }
    function Db(s, l, f, g, C) {
      KH(f), Ate(C === void 0 ? null : C, "render");
      var S = f._reactRootContainer, T;
      if (!S)
        T = Dte(f, l, s, C, g);
      else {
        if (T = S, typeof C == "function") {
          var O = C;
          C = function() {
            var M = wb(T);
            O.call(M);
          };
        }
        oy(l, T, s, C);
      }
      return wb(T);
    }
    function Ote(s) {
      {
        var l = Ite.current;
        if (l !== null && l.stateNode !== null) {
          var f = l.stateNode._warnedAboutRefsInRender;
          f || o("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", ir(l.type) || "A component"), l.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return s == null ? null : s.nodeType === Sa ? s : pte(s, "findDOMNode");
    }
    function Rte(s, l, f) {
      if (o("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !sy(l))
        throw new Error("Target container is not a DOM element.");
      {
        var g = wC(l) && l._reactRootContainer === void 0;
        g && o("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return Db(null, s, l, !0, f);
    }
    function Lte(s, l, f) {
      if (o("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !sy(l))
        throw new Error("Target container is not a DOM element.");
      {
        var g = wC(l) && l._reactRootContainer === void 0;
        g && o("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return Db(null, s, l, !1, f);
    }
    function Mte(s, l, f, g) {
      if (o("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !sy(f))
        throw new Error("Target container is not a DOM element.");
      if (s == null || !df(s))
        throw new Error("parentComponent must be a valid React Component");
      return Db(s, l, f, !1, g);
    }
    function kte(s) {
      if (!sy(s))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var l = wC(s) && s._reactRootContainer === void 0;
        l && o("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (s._reactRootContainer) {
        {
          var f = gR(s), g = f && !Kc(f);
          g && o("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return Dd(function() {
          Db(null, null, s, !1, function() {
            s._reactRootContainer = null, zV(s);
          });
        }), !0;
      } else {
        {
          var C = gR(s), S = !!(C && Kc(C)), T = s.nodeType === Sa && sy(s.parentNode) && !!s.parentNode._reactRootContainer;
          S && o("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", T ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Ct(vte), F0(gte), wf(mte), X_(wo), V0(Sf), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && o("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), g0(L7), _v(jO, Tee, Dd);
    function Pte(s, l) {
      var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!Ib(l))
        throw new Error("Target container is not a DOM element.");
      return fte(s, l, null, f);
    }
    function Fte(s, l, f, g) {
      return Mte(s, l, f, g);
    }
    var mR = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Kc, yg, vE, mv, sf, jO]
    };
    function Bte(s, l) {
      return mR.usingClientEntryPoint || o('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), bte(s, l);
    }
    function Vte(s, l, f) {
      return mR.usingClientEntryPoint || o('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), Tte(s, l, f);
    }
    function Nte(s) {
      return iH() && o("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), Dd(s);
    }
    var Hte = Ete({
      findFiberByHostInstance: Pf,
      bundleType: 1,
      version: dR,
      rendererPackageName: "react-dom"
    });
    if (!Hte && gt && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var YH = window.location.protocol;
      /^(https?|file):$/.test(YH) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (YH === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Po.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = mR, Po.createPortal = Pte, Po.createRoot = Bte, Po.findDOMNode = Ote, Po.flushSync = Nte, Po.hydrate = Rte, Po.hydrateRoot = Vte, Po.render = Lte, Po.unmountComponentAtNode = kte, Po.unstable_batchedUpdates = jO, Po.unstable_renderSubtreeIntoContainer = Fte, Po.version = dR, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Po;
}
var IVe = wT.exports;
function cq() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(cq);
    } catch (t) {
      console.error(t);
    }
  }
}
process.env.NODE_ENV === "production" ? (cq(), wT.exports = iue()) : wT.exports = rue();
var hq = wT.exports;
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var nue = /* @__PURE__ */ function() {
  var t = function(e, i) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
    }, t(e, i);
  };
  return function(e, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    t(e, i);
    function r() {
      this.constructor = e;
    }
    e.prototype = i === null ? Object.create(i) : (r.prototype = i.prototype, new r());
  };
}(), aue = function(t, e) {
  var i = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, n, a, o;
  return o = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function u(p) {
    return function(v) {
      return c([p, v]);
    };
  }
  function c(p) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; i; )
      try {
        if (r = 1, n && (a = p[0] & 2 ? n.return : p[0] ? n.throw || ((a = n.return) && a.call(n), 0) : n.next) && !(a = a.call(n, p[1])).done)
          return a;
        switch (n = 0, a && (p = [p[0] & 2, a.value]), p[0]) {
          case 0:
          case 1:
            a = p;
            break;
          case 4:
            return i.label++, { value: p[1], done: !1 };
          case 5:
            i.label++, n = p[1], p = [0];
            continue;
          case 7:
            p = i.ops.pop(), i.trys.pop();
            continue;
          default:
            if (a = i.trys, !(a = a.length > 0 && a[a.length - 1]) && (p[0] === 6 || p[0] === 2)) {
              i = 0;
              continue;
            }
            if (p[0] === 3 && (!a || p[1] > a[0] && p[1] < a[3])) {
              i.label = p[1];
              break;
            }
            if (p[0] === 6 && i.label < a[1]) {
              i.label = a[1], a = p;
              break;
            }
            if (a && i.label < a[2]) {
              i.label = a[2], i.ops.push(p);
              break;
            }
            a[2] && i.ops.pop(), i.trys.pop();
            continue;
        }
        p = e.call(t, i);
      } catch (v) {
        p = [6, v], n = 0;
      } finally {
        r = a = 0;
      }
    if (p[0] & 5)
      throw p[1];
    return { value: p[0] ? p[1] : void 0, done: !0 };
  }
}, Vz = function(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, i = e && t[e], r = 0;
  if (i)
    return i.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Nz = function(t, e) {
  var i = typeof Symbol == "function" && t[Symbol.iterator];
  if (!i)
    return t;
  var r = i.call(t), n, a = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(n = r.next()).done; )
      a.push(n.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      n && !n.done && (i = r.return) && i.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return a;
}, fq = W3({
  lock: function() {
  },
  unlock: function() {
  }
});
function JR() {
  return Math.random().toString(36).substring(2);
}
var oue = (
  /** @class */
  function() {
    function t() {
      this._map = /* @__PURE__ */ new Map();
    }
    return t.prototype.set = function(e, i) {
      var r = e.key1, n = e.key2, a = this._map.get(r);
      a || (a = /* @__PURE__ */ new Map(), this._map.set(r, a)), a.set(n, i);
    }, t.prototype.get = function(e) {
      var i = e.key1, r = e.key2, n = this._map.get(i);
      return n ? n.get(r) : void 0;
    }, t.prototype.delete = function(e) {
      var i = e.key1, r = e.key2, n = this._map.get(i);
      n && (n.delete(r), n.size === 0 && this._map.delete(i));
    }, Object.defineProperty(t.prototype, "empty", {
      get: function() {
        return this._map.size === 0;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.shallowCopy = function() {
      var e = new t();
      return e._map = this._map, e;
    }, t.prototype[Symbol.iterator] = function() {
      var e, i, r, n, a, o, u, c, p, v, _, y, b, I, A, L;
      return aue(this, function(B) {
        switch (B.label) {
          case 0:
            B.trys.push([0, 11, 12, 13]), e = Vz(this._map), i = e.next(), B.label = 1;
          case 1:
            if (i.done)
              return [3, 10];
            r = Nz(i.value, 2), n = r[0], a = r[1], B.label = 2;
          case 2:
            B.trys.push([2, 7, 8, 9]), o = (A = void 0, Vz(a)), u = o.next(), B.label = 3;
          case 3:
            return u.done ? [3, 6] : (c = Nz(u.value, 2), p = c[0], v = c[1], [4, [{ key1: n, key2: p }, v]]);
          case 4:
            B.sent(), B.label = 5;
          case 5:
            return u = o.next(), [3, 3];
          case 6:
            return [3, 9];
          case 7:
            return _ = B.sent(), A = { error: _ }, [3, 9];
          case 8:
            try {
              u && !u.done && (L = o.return) && L.call(o);
            } finally {
              if (A)
                throw A.error;
            }
            return [
              7
              /*endfinally*/
            ];
          case 9:
            return i = e.next(), [3, 1];
          case 10:
            return [3, 13];
          case 11:
            return y = B.sent(), b = { error: y }, [3, 13];
          case 12:
            try {
              i && !i.done && (I = e.return) && I.call(e);
            } finally {
              if (b)
                throw b.error;
            }
            return [
              7
              /*endfinally*/
            ];
          case 13:
            return [
              2
              /*return*/
            ];
        }
      });
    }, t;
  }()
), Hz = (
  /** @class */
  function(t) {
    nue(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(oue)
);
function sue(t) {
  return t.length ? "" + t[0].toUpperCase() + t.substr(1) : "";
}
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var lue = function(t, e) {
  var i = typeof Symbol == "function" && t[Symbol.iterator];
  if (!i)
    return t;
  var r = i.call(t), n, a = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(n = r.next()).done; )
      a.push(n.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      n && !n.done && (i = r.return) && i.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return a;
}, $z = function(t, e, i) {
  var r = { display: "none" };
  switch (t) {
    case "TABLE":
      return Er.createElement("tbody", { style: r, ref: e });
    case "TBODY":
      return Er.createElement("tr", { style: r, ref: e });
    default:
      return Er.createElement(i, { style: r, ref: e });
  }
}, uue = function(t) {
  var e = t.templateFactory, i = t.data, r = t.index, n = t.container, a = t.onRemoved, o = t.onRendered, u = lue(gk(!1), 2), c = u[0], p = u[1], v = Jn(!1), _ = Sh(function() {
    return {
      lock: function() {
        v.current = !0;
      },
      unlock: function() {
        v.current = !1;
      }
    };
  }, []), y = Jn(), b = Jn(), I = Jn(), A = Ki(function($, K) {
    K != null && K.isUnmounting || v.current || (y.current && um(y.current, bu, A), I.current && um(I.current, bu, A), a());
  }, [a]);
  U3(function() {
    var $ = y.current;
    return $ && $.nodeType === Node.ELEMENT_NODE ? (um($, bu, A), zk($, bu, A)) : c ? I.current && (um(I.current, bu, A), zk(I.current, bu, A)) : p(!0), function() {
      y.current && n.appendChild(y.current), b.current && n.appendChild(b.current), I.current && n.appendChild(I.current), $ && um($, bu, A);
    };
  }, [A, c, n]), xm(function() {
    o();
  }, [o]);
  var L = $z(n == null ? void 0 : n.nodeName, function($) {
    b.current = $, y.current = $ == null ? void 0 : $.previousSibling;
  }, "div"), B = c ? $z(n == null ? void 0 : n.nodeName, function($) {
    I.current = $;
  }, "span") : void 0;
  return hq.createPortal(Er.createElement(
    Er.Fragment,
    null,
    Er.createElement(
      fq.Provider,
      { value: _ },
      e({ data: i, index: r, onRendered: o }),
      L,
      B
    )
  ), n);
}, due = Wte(uue);
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var cue = {
  useLegacyTemplateEngine: !1
};
function hue(t) {
  return cue[t];
}
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var TT = function() {
  return TT = Object.assign || function(t) {
    for (var e, i = 1, r = arguments.length; i < r; i++) {
      e = arguments[i];
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t;
  }, TT.apply(this, arguments);
}, Nb = function(t, e) {
  var i = typeof Symbol == "function" && t[Symbol.iterator];
  if (!i)
    return t;
  var r = i.call(t), n, a = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(n = r.next()).done; )
      a.push(n.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      n && !n.done && (i = r.return) && i.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return a;
};
function zz(t) {
  if (hue("useLegacyTemplateEngine")) {
    var e = t.data;
    return e && Object.prototype.hasOwnProperty.call(e, "key") && (e.dxkey = e.key), e;
  }
  return t;
}
var fue = function(t) {
  var e = t.init, i = Nb(gk(new Hz()), 2), r = i[0], n = i[1], a = Nb(gk(), 2), o = a[0], u = a[1], c = Jn(""), p = Jn({}), v = Ki(function(L, B) {
    L.nodeType === Node.ELEMENT_NODE && zk(L, bu, B);
  }, []), _ = Ki(function(L, B) {
    L.nodeType === Node.ELEMENT_NODE && um(L, bu, B);
  }, []), y = Ki(function(L) {
    return L.get ? L.get(0) : L;
  }, []), b = Ki(function(L, B) {
    return { key1: L, key2: B };
  }, []), I = Ki(function() {
    return "" + JR() + JR() + JR();
  }, []), A = Ki(function(L) {
    return function(B) {
      var $ = B.model, K = B.index, te = B.container, z = B.onRendered, ie = y(te), pe = b($, ie), _e = function() {
        n(function(De) {
          var Ce = De.get(pe);
          return Ce ? (De.delete(pe), De.shallowCopy()) : De;
        });
      }, be = c.current;
      return n(function(De) {
        return De.set(pe, {
          templateKey: L,
          index: K,
          componentKey: I(),
          onRendered: function() {
            _(ie, _e), be === c.current && (z == null || z());
          },
          onRemoved: _e
        }), De.shallowCopy();
      }), ie;
    };
  }, [_, b]);
  return Sh(function() {
    function L(te) {
      switch (te.type) {
        case "children":
          return function() {
            return te.content;
          };
        case "render":
          return function(z) {
            return zz(z), te.content(z.data, z.index);
          };
        case "component":
          return function(z) {
            return z = zz(z), Er.createElement.bind(null, te.content)(z);
          };
        default:
          return function() {
            return Er.createElement(Er.Fragment);
          };
      }
    }
    function B(te) {
      var z = Object.entries(te).reduce(function(pe, _e) {
        var be, De = Nb(_e, 2), Ce = De[0], ft = De[1];
        return TT(TT({}, pe), (be = {}, be[Ce] = L(ft), be));
      }, {});
      p.current = z;
      var ie = Object.keys(z).reduce(function(pe, _e) {
        return pe[_e] = { render: A(_e) }, pe;
      }, {});
      return ie;
    }
    function $() {
      c.current = I(), n(new Hz());
    }
    function K(te) {
      u({ onUpdated: te });
    }
    e({ createDXTemplates: B, clearInstantiationModels: $, updateTemplates: K });
  }, [e, A]), xm(function() {
    o && o.onUpdated();
  }, [o]), r.empty ? null : Er.createElement(Er.Fragment, null, Array.from(r).map(function(L) {
    var B = Nb(L, 2), $ = B[0], K = $.key1, te = $.key2, z = B[1], ie = z.index, pe = z.templateKey, _e = z.componentKey, be = z.onRendered, De = z.onRemoved;
    v(te, De);
    var Ce = p.current[pe];
    return Ce ? Er.createElement(due, { key: _e, templateFactory: Ce, data: K, index: ie, container: te, onRemoved: De, onRendered: be }) : null;
  }));
};
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
function Vh() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return t.filter(function(i) {
    return i;
  }).join(".");
}
function pue(t) {
  var e = t.split("[");
  return e.length === 1 ? {
    isCollectionItem: !1,
    name: t
  } : {
    isCollectionItem: !0,
    name: e[0],
    index: Number(e[1].slice(0, -1))
  };
}
var vue = function() {
  var t, e, i = (e = (t = window == null ? void 0 : window.navigator) === null || t === void 0 ? void 0 : t.userAgent) !== null && e !== void 0 ? e : "", r = i.indexOf("MSIE"), n = i.indexOf("Trident/");
  return r > 0 || n > 0;
}, gue = function(t, e) {
  return Object.keys(t).length !== Object.keys(e).length ? !1 : Object.keys(t).every(function(i) {
    return t[i] === e[i];
  });
};
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
function Wk(t, e, i) {
  t.templates.forEach(function(r) {
    if (r.isAnonymous) {
      var n = Vh(t.fullName, r.optionName);
      e[r.optionName] = n, i[n] = r;
    } else
      i[r.optionName] = r;
  });
}
function Mm(t, e, i) {
  var r = {};
  return Object.keys(t.predefinedOptions).forEach(function(n) {
    r[n] = t.predefinedOptions[n];
  }), Object.keys(t.configs).forEach(function(n) {
    r[n] = Mm(t.configs[n], e, i);
  }), Object.keys(t.configCollections).forEach(function(n) {
    r[n] = t.configCollections[n].map(function(a) {
      return Mm(a, e, i);
    });
  }), i || Object.keys(t.initialOptions).forEach(function(n) {
    r[n] = t.initialOptions[n];
  }), Object.keys(t.options).forEach(function(n) {
    r[n] = t.options[n];
  }), Wk(t, r, e), r;
}
function Uk(t, e) {
  var i = {}, r = Mm(t, i, e);
  return {
    templates: i,
    options: r
  };
}
var Ap;
(function(t) {
  t[t.Simple = 0] = "Simple", t[t.Complex = 1] = "Complex", t[t.Array = 2] = "Array";
})(Ap || (Ap = {}));
function pq(t, e) {
  var i = e.shift();
  if (!i)
    return {
      value: t,
      type: Ap.Simple
    };
  if (t instanceof Object && Object.keys(t).includes(i))
    return pq(t[i], e);
}
function cx(t, e) {
  var i = e.shift();
  if (!i)
    return {
      value: Uk(t, !0).options,
      type: Ap.Complex
    };
  var r = pue(i);
  if (r.name in t.options) {
    var n = r.isCollectionItem ? t.options[r.name][r.index] : t.options[r.name];
    return pq(n, e);
  }
  if (r.isCollectionItem) {
    var a = t.configCollections[r.name];
    if (!a)
      return;
    var o = a[r.index];
    return o ? cx(o, e) : void 0;
  }
  var u = t.configs[r.name];
  if (u)
    return cx(u, e);
  var c = t.configCollections[r.name];
  if (c)
    return e.length !== 0 ? void 0 : {
      value: c.map(function(p) {
        return Mm(p, {}, !0);
      }),
      type: Ap.Array
    };
}
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
function mue(t, e, i) {
  var r = {}, n = {}, a = {}, o = {};
  Wk(t, r, n), Wk(e, a, o), i.addRemovedValues(r, a, t.fullName), Object.keys(r).forEach(function(u) {
    r[u] !== a[u] && (i.options[Vh(t.fullName, u)] = r[u]);
  }), Object.keys(n).forEach(function(u) {
    var c = n[u], p = o[u];
    p && c.content === p.content || (i.templates[u] = c);
  });
}
function jF(t, e, i) {
  if (!e) {
    i.options[t.fullName] = Mm(t, i.templates, !0);
    return;
  }
  i.addRemovedValues(t.options, e.options, t.fullName), i.addRemovedValues(t.configCollections, e.configCollections, t.fullName), i.addRemovedValues(t.configs, e.configs, t.fullName), yue(t, e, i), Object.keys(t.configs).forEach(function(r) {
    jF(t.configs[r], e.configs[r], i);
  }), Object.keys(t.options).forEach(function(r) {
    t.options[r] !== e.options[r] && (i.options[Vh(t.fullName, r)] = t.options[r]);
  }), mue(t, e, i);
}
function _ue(t, e, i, r) {
  var n = Object.keys(e).filter(function(a) {
    return !Object.keys(t).includes(a);
  });
  n.forEach(function(a) {
    r.push(Vh(i, a));
  });
}
function Cue(t, e) {
  var i = {
    options: {},
    removedOptions: [],
    templates: {},
    addRemovedValues: function(r, n, a) {
      _ue(r, n, a, this.removedOptions);
    }
  };
  return jF(t, e, i), i;
}
function yue(t, e, i) {
  Object.keys(t.configCollections).forEach(function(r) {
    var n = t.configCollections[r], a = e.configCollections[r] || [];
    if (!n || n.length !== a.length) {
      var o = [];
      n.forEach(function(c) {
        var p = Mm(c, i.templates, !0);
        o.push(p);
      }), i.options[Vh(t.fullName, r)] = o;
      return;
    }
    for (var u = 0; u < n.length; u += 1)
      jF(n[u], a[u], i);
  });
}
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Wz = function(t, e) {
  var i = typeof Symbol == "function" && t[Symbol.iterator];
  if (!i)
    return t;
  var r = i.call(t), n, a = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(n = r.next()).done; )
      a.push(n.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      n && !n.done && (i = r.return) && i.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return a;
}, xue = function(t, e) {
  for (var i = 0, r = e.length, n = t.length; i < r; i++, n++)
    t[n] = e[i];
  return t;
}, Gk = /* @__PURE__ */ new Set(), vq = -1, gq = -1;
function mq() {
  clearTimeout(vq), clearTimeout(gq);
}
function _q() {
  mq(), vq = window.setTimeout(function() {
    gq = window.setTimeout(function() {
      Gk.forEach(function(t) {
        return t.execGuards();
      });
    });
  });
}
var Sue = (
  /** @class */
  function() {
    function t() {
      this.guards = {}, this.isUpdating = !1, Gk.add(this), this.onOptionChanged = this.onOptionChanged.bind(this), this.wrapOptionValue = this.wrapOptionValue.bind(this);
    }
    return t.prototype.setInstance = function(e, i, r, n) {
      this.instance = e, this.currentConfig = i, this.subscribableOptions = new Set(r), this.independentEvents = new Set(n);
    }, t.prototype.getInitialOptions = function(e) {
      var i = this, r = Uk(e, !1), n = {};
      return Object.keys(r.options).forEach(function(a) {
        n[a] = i.wrapOptionValue(a, r.options[a]);
      }), n;
    }, t.prototype.getTemplateOptions = function(e) {
      var i = Uk(e, !1);
      return i.templates;
    }, t.prototype.update = function(e, i) {
      var r = this, n = [], a = function(u) {
        var c = u.value, p = u.fullName;
        n.push([p, c]);
      };
      this.instance.on("optionChanged", a);
      var o = Cue(e, this.currentConfig);
      !o.options && !o.templates && !o.removedOptions.length || (this.instance.beginUpdate(), this.isUpdating = !0, o.removedOptions.forEach(function(u) {
        r.resetOption(u);
      }), Object.keys(i).length > 0 && this.setValue("integrationOptions", {
        templates: i
      }), Object.keys(o.options).forEach(function(u) {
        r.setValue(u, o.options[u]);
      }), this.isUpdating = !1, this.instance.off("optionChanged", a), this.currentConfig = e, n.forEach(function(u) {
        var c = Wz(u, 2), p = c[0], v = c[1], _ = e.options[p];
        Object.prototype.hasOwnProperty.call(e.options, p) && _ !== v && r.setValue(p, _);
      }), this.instance.endUpdate());
    }, t.prototype.onOptionChanged = function(e) {
      var i = this, r;
      if (!this.isUpdating) {
        var n = cx(this.currentConfig, e.fullName.split("."));
        if ((!n || n.value !== e.value) && this.callOptionChangeHandler(e.fullName, e.value), n = cx(this.currentConfig, e.fullName.split(".")), !!n) {
          var a = n.value, o = n.type;
          if (a instanceof Array && o === Ap.Array) {
            for (var u = 0; u < a.length; u += 1)
              if (a[u] !== ((r = e.value) === null || r === void 0 ? void 0 : r[u])) {
                this.addGuard(e.fullName, a);
                return;
              }
          } else if (o === Ap.Complex && a instanceof Object)
            Object.keys(a).forEach(function(v) {
              var _;
              a[v] !== ((_ = e.value) === null || _ === void 0 ? void 0 : _[v]) && i.addGuard(Vh(e.fullName, v), a[v]);
            });
          else {
            var c = a === e.value, p = !c && a instanceof Object && e.value instanceof Object && gue(a, e.value);
            if (c || p || this.instance.skipOptionsRollBack)
              return;
            this.addGuard(e.fullName, a);
          }
        }
      }
    }, t.prototype.dispose = function() {
      var e = this;
      Gk.delete(this), Object.keys(this.guards).forEach(function(i) {
        delete e.guards[i];
      });
    }, t.prototype.isOptionSubscribable = function(e) {
      return this.subscribableOptions.has(e);
    }, t.prototype.isIndependentEvent = function(e) {
      return this.independentEvents.has(e);
    }, t.prototype.callOptionChangeHandler = function(e, i) {
      if (this.isOptionSubscribable(e)) {
        var r = e.split("."), n = r[r.length - 1];
        if (!n.startsWith("on")) {
          var a = "on" + sue(n) + "Change";
          r[r.length - 1] = a;
          var o = cx(this.currentConfig, r);
          if (o) {
            if (typeof o.value != "function")
              throw new Error("Invalid value for the " + a + ` property.
                ` + a + " must be a function.");
            o.value(i);
          }
        }
      }
    }, t.prototype.wrapOptionValue = function(e, i) {
      var r = this;
      return e.substr(0, 2) === "on" && typeof i == "function" ? function() {
        for (var n = [], a = 0; a < arguments.length; a++)
          n[a] = arguments[a];
        (!r.isUpdating || r.isIndependentEvent(e)) && i.apply(void 0, xue([], Wz(n)));
      } : i;
    }, t.prototype.addGuard = function(e, i) {
      var r = this;
      if (this.guards[e] === void 0) {
        var n = function() {
          r.setValue(e, i), delete r.guards[e];
        };
        this.guards[e] = n, _q();
      }
    }, t.prototype.execGuards = function() {
      Object.values(this.guards).forEach(function(e) {
        return e();
      });
    }, t.prototype.resetOption = function(e) {
      this.instance.resetOption(e);
    }, t.prototype.setValue = function(e, i) {
      this.guards[e] && delete this.guards[e], this.instance.option(e, this.wrapOptionValue(e, i));
    }, t;
  }()
);
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Cq = ["style", "id"], yq = "className", Eue = ["dropZone", "dialogTrigger"];
function bue(t) {
  return t === "children" || t === yq || Cq.includes(t);
}
function wue(t, e, i) {
  i = i || [];
  var r = {}, n = {}, a = {}, o = {};
  return i.forEach(function(u) {
    o[u.component] = !0, o[u.render] = !0;
  }), Object.keys(t).forEach(function(u) {
    var c = e ? e[u] : null, p = t[u];
    if (!bue(u)) {
      if (c) {
        r[c] = p;
        return;
      }
      if (o[u]) {
        a[u] = p;
        return;
      }
      if (Eue.includes(u)) {
        n[u] = p && p.current ? p.current : p;
        return;
      }
      n[u] = t[u];
    }
  }), { options: n, defaults: r, templates: a };
}
function Uz(t) {
  return t[yq];
}
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Tue = /* @__PURE__ */ function() {
  var t = function(e, i) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
    }, t(e, i);
  };
  return function(e, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    t(e, i);
    function r() {
      this.constructor = e;
    }
    e.prototype = i === null ? Object.create(i) : (r.prototype = i.prototype, new r());
  };
}(), xq = (
  /** @class */
  function(t) {
    Tue(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.render = function() {
      return null;
    }, e;
  }(Er.PureComponent)
), eL = function(t) {
  return !t.component && !t.render && !t.children ? new Error("The Template component requires 'component' or 'render' property") : null;
};
xq.propTypes = {
  name: re.string.isRequired,
  component: eL,
  render: eL,
  children: eL
};
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Au;
(function(t) {
  t[t.Option = 0] = "Option", t[t.Template = 1] = "Template", t[t.Unknown = 2] = "Unknown";
})(Au || (Au = {}));
function Sq(t, e) {
  var i = t;
  if (!i || !i.type)
    return {
      type: Au.Unknown
    };
  if (i.type === xq)
    return {
      type: Au.Template,
      props: i.props
    };
  var r = i.type;
  if (r.OptionName) {
    var n = r.OptionName, a = r.IsCollectionItem, o = e && e[n];
    return o && (a = o.isCollectionItem, o.optionName && (n = o.optionName)), {
      type: Au.Option,
      descriptor: {
        name: n,
        isCollection: a,
        templates: r.TemplateProps || [],
        initialValuesProps: r.DefaultsProps || {},
        predefinedValuesProps: r.PredefinedProps || {},
        expectedChildren: r.ExpectedChildren || {}
      },
      props: i.props
    };
  }
  return {
    type: Au.Unknown
  };
}
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
function Iue(t, e, i) {
  return e.tmplOption === "template" && i ? {
    optionName: e.tmplOption,
    isAnonymous: !0,
    type: "children",
    content: t.children,
    keyFn: t[e.keyFn]
  } : t[e.render] ? {
    optionName: e.tmplOption,
    isAnonymous: !0,
    type: "render",
    content: t[e.render],
    keyFn: t[e.keyFn]
  } : t[e.component] ? {
    optionName: e.tmplOption,
    isAnonymous: !0,
    type: "component",
    content: t[e.component],
    keyFn: t[e.keyFn]
  } : null;
}
function Due(t) {
  return t.name ? t.component ? {
    optionName: t.name,
    isAnonymous: !1,
    type: "component",
    content: t.component,
    keyFn: t.keyFn
  } : t.render ? {
    optionName: t.name,
    isAnonymous: !1,
    type: "render",
    content: t.render,
    keyFn: t.keyFn
  } : {
    optionName: t.name,
    isAnonymous: !1,
    type: "children",
    content: t.children,
    keyFn: t.keyFn
  } : null;
}
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Kk = function() {
  return Kk = Object.assign || function(t) {
    for (var e, i = 1, r = arguments.length; i < r; i++) {
      e = arguments[i];
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t;
  }, Kk.apply(this, arguments);
};
function Aue(t, e) {
  var i = [], r = {}, n = {}, a = !1;
  return Er.Children.map(t.props.children, function(o) {
    var u = Sq(o, t.descriptor.expectedChildren);
    if (u.type === Au.Unknown) {
      o != null && o !== !1 && (a = !0);
      return;
    }
    if (u.type === Au.Template) {
      var c = Due(u.props);
      c && i.push(c);
      return;
    }
    if (u.descriptor.isCollection) {
      var p = r[u.descriptor.name];
      p || (p = [], r[u.descriptor.name] = p);
      var v = jk(u, Vh(e, u.descriptor.name) + "[" + p.length + "]");
      p.push(v);
      return;
    }
    var _ = jk(u, e);
    n[u.descriptor.name] = _;
  }), {
    configs: n,
    configCollections: r,
    templates: i,
    hasTranscludedContent: a
  };
}
function jk(t, e) {
  var i = t.descriptor.isCollection ? e : Vh(e, t.descriptor.name), r = wue(t.props, t.descriptor.initialValuesProps, t.descriptor.templates), n = Aue(t, i);
  return t.descriptor.templates.forEach(function(a) {
    var o = Iue(t.props, a, e.length > 0 ? n.hasTranscludedContent : !1);
    o && n.templates.push(o);
  }), {
    fullName: i,
    predefinedOptions: t.descriptor.predefinedValuesProps,
    initialOptions: r.defaults,
    options: r.options,
    templates: n.templates,
    configCollections: n.configCollections,
    configs: n.configs
  };
}
function Oue(t, e) {
  return jk({
    type: Au.Option,
    descriptor: Kk({ name: "", isCollection: !1 }, t),
    props: e
  }, "");
}
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Rue = /* @__PURE__ */ function() {
  var t = function(e, i) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
    }, t(e, i);
  };
  return function(e, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    t(e, i);
    function r() {
      this.constructor = e;
    }
    e.prototype = i === null ? Object.create(i) : (r.prototype = i.prototype, new r());
  };
}(), hx = function() {
  return hx = Object.assign || function(t) {
    for (var e, i = 1, r = arguments.length; i < r; i++) {
      e = arguments[i];
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t;
  }, hx.apply(this, arguments);
}, Hb = function(t, e) {
  var i = typeof Symbol == "function" && t[Symbol.iterator];
  if (!i)
    return t;
  var r = i.call(t), n, a = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(n = r.next()).done; )
      a.push(n.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      n && !n.done && (i = r.return) && i.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return a;
}, tL = function(t, e) {
  for (var i = 0, r = e.length, n = t.length; i < r; i++, n++)
    t[n] = e[i];
  return t;
}, bu = "dxremove", Eq = (
  /** @class */
  function(t) {
    Rue(e, t);
    function e(i) {
      var r = t.call(this, i) || this;
      return r.isPortalComponent = !1, r._templateProps = [], r._childNodes = [], r.useRequestAnimationFrameFlag = !1, r.useDeferUpdateForTemplates = !1, r.guardsUpdateScheduled = !1, r._createWidget = r._createWidget.bind(r), r._setTemplateManagerHooks = r._setTemplateManagerHooks.bind(r), r._optionsManager = new Sue(), r;
    }
    return e.displayContentsStyle = function() {
      return vue() ? {
        width: "100%",
        height: "100%",
        padding: 0,
        margin: 0
      } : { display: "contents" };
    }, e.prototype.componentDidMount = function() {
      var i, r, n = this.props.style;
      !((r = this._childNodes) === null || r === void 0) && r.length ? (i = this._element).append.apply(i, tL([], Hb(this._childNodes))) : this._element.childNodes.length && (this._childNodes = Array.from(this._element.childNodes)), this._updateCssClasses(null, this.props), n && this._setInlineStyles(n);
    }, e.prototype.componentDidUpdate = function(i) {
      var r;
      this._updateCssClasses(i, this.props);
      var n = this._getConfig(), a = this._optionsManager.getTemplateOptions(n), o = ((r = this._createDXTemplates) === null || r === void 0 ? void 0 : r.call(this, a)) || {};
      this._optionsManager.update(n, o), this._scheduleTemplatesUpdate();
    }, e.prototype.componentWillUnmount = function() {
      var i;
      if (this._lockParentOnRemoved(), this._instance) {
        var r = { isUnmounting: !0 };
        (i = this._childNodes) === null || i === void 0 || i.forEach(function(n) {
          var a;
          return (a = n.parentNode) === null || a === void 0 ? void 0 : a.removeChild(n);
        }), Jle(this._element, bu, r), this._instance.dispose();
      }
      this._optionsManager.dispose(), this._unlockParentOnRemoved();
    }, e.prototype._createWidget = function(i) {
      var r, n;
      i = i || this._element;
      var a = this._getConfig(), o = hx({ templatesRenderAsynchronously: !0 }, this._optionsManager.getInitialOptions(a)), u = this._optionsManager.getTemplateOptions(a), c = (r = this._createDXTemplates) === null || r === void 0 ? void 0 : r.call(this, u);
      c && Object.keys(c).length && (o = hx(hx({}, o), { integrationOptions: {
        templates: c
      } })), (n = this._clearInstantiationModels) === null || n === void 0 || n.call(this), this._instance = new this._WidgetClass(i, o), this.useRequestAnimationFrameFlag || (this.useDeferUpdateForTemplates = this._instance.option("integrationOptions.useDeferUpdateForTemplates")), this._optionsManager.setInstance(this._instance, a, this.subscribableOptions, this.independentEvents), this._instance.on("optionChanged", this._optionsManager.onOptionChanged);
    }, e.prototype._scheduleTemplatesUpdate = function() {
      var i = this;
      if (!this.guardsUpdateScheduled) {
        this.guardsUpdateScheduled = !0;
        var r = this.useDeferUpdateForTemplates ? Na : Fx;
        r(function() {
          var n;
          i.guardsUpdateScheduled = !1, (n = i._updateTemplates) === null || n === void 0 || n.call(i, function() {
            return _q();
          });
        }), mq();
      }
    }, e.prototype._getConfig = function() {
      return Oue({
        templates: this._templateProps,
        initialValuesProps: this._defaults,
        predefinedValuesProps: {},
        expectedChildren: this._expectedChildren
      }, this.props);
    }, e.prototype._getElementProps = function() {
      var i = this, r = {
        ref: function(n) {
          i._element = n;
        }
      };
      return Cq.forEach(function(n) {
        var a = i.props;
        n in a && (r[n] = a[n]);
      }), r;
    }, e.prototype._setInlineStyles = function(i) {
      var r = this;
      Object.entries(i).forEach(function(n) {
        var a = Hb(n, 2), o = a[0], u = a[1];
        r._element.style[o] = u;
      });
    }, e.prototype._updateCssClasses = function(i, r) {
      var n, a, o = i ? Uz(i) : void 0, u = Uz(r);
      if (o !== u) {
        if (o) {
          var c = o.split(" ").filter(function(p) {
            return p;
          });
          c.length && (n = this._element.classList).remove.apply(n, tL([], Hb(c)));
        }
        if (u) {
          var c = u.split(" ").filter(function(v) {
            return v;
          });
          c.length && (a = this._element.classList).add.apply(a, tL([], Hb(c)));
        }
      }
    }, e.prototype._lockParentOnRemoved = function() {
      var i;
      (i = this.context) === null || i === void 0 || i.lock();
    }, e.prototype._unlockParentOnRemoved = function() {
      var i;
      (i = this.context) === null || i === void 0 || i.unlock();
    }, e.prototype._setTemplateManagerHooks = function(i) {
      var r = i.createDXTemplates, n = i.clearInstantiationModels, a = i.updateTemplates;
      this._createDXTemplates = r, this._clearInstantiationModels = n, this._updateTemplates = a;
    }, e.prototype.renderChildren = function() {
      var i = this.props.children;
      return i;
    }, e.prototype.renderContent = function() {
      var i = this, r = this.props.children;
      return this.isPortalComponent && r ? Er.createElement("div", {
        ref: function(n) {
          n && i.portalContainer !== n && (i.portalContainer = n, i.forceUpdate());
        },
        style: e.displayContentsStyle()
      }) : this.renderChildren();
    }, e.prototype.renderPortal = function() {
      return this.portalContainer && hq.createPortal(this.renderChildren(), this.portalContainer);
    }, e.prototype.render = function() {
      return Er.createElement(Er.Fragment, {}, Er.createElement("div", this._getElementProps(), this.renderContent(), Er.createElement(fue, {
        init: this._setTemplateManagerHooks
      })), this.isPortalComponent && this.renderPortal());
    }, e.contextType = fq, e;
  }(Er.PureComponent)
);
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Lue = /* @__PURE__ */ function() {
  var t = function(e, i) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
    }, t(e, i);
  };
  return function(e, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    t(e, i);
    function r() {
      this.constructor = e;
    }
    e.prototype = i === null ? Object.create(i) : (r.prototype = i.prototype, new r());
  };
}(), Mue = (
  /** @class */
  function(t) {
    Lue(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.componentDidMount = function() {
      var i = this.props.onMounted;
      i ? i(this._createWidget) : this._createWidget();
    }, e;
  }(Eq)
);
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var kue = /* @__PURE__ */ function() {
  var t = function(e, i) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
    }, t(e, i);
  };
  return function(e, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    t(e, i);
    function r() {
      this.constructor = e;
    }
    e.prototype = i === null ? Object.create(i) : (r.prototype = i.prototype, new r());
  };
}(), bq = (
  /** @class */
  function(t) {
    kue(e, t);
    function e(i) {
      var r = t.call(this, i) || this;
      return r._extensionCreators = [], r._registerExtension = r._registerExtension.bind(r), r;
    }
    return e.prototype.componentDidMount = function() {
      t.prototype.componentDidMount.call(this), this._createWidget(), this._createExtensions();
    }, e.prototype.componentWillUnmount = function() {
      t.prototype.componentWillUnmount.call(this), this.clearExtensions();
    }, e.prototype.clearExtensions = function() {
      this._extensionCreators = [];
    }, e.prototype.renderChildren = function() {
      var i = this;
      return Er.Children.map(
        // @ts-expect-error TS2339
        this.props.children,
        function(r) {
          return r && Object.prototype.isPrototypeOf.call(Mue, r.type) ? Er.cloneElement(r, { onMounted: i._registerExtension }) : r;
        }
      );
    }, e.prototype._registerExtension = function(i) {
      this._extensionCreators.push(i);
    }, e.prototype._createExtensions = function() {
      var i = this;
      this._extensionCreators.forEach(function(r) {
        return r(i._element);
      });
    }, e;
  }(Eq)
);
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Pue = /* @__PURE__ */ function() {
  var t = function(e, i) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
    }, t(e, i);
  };
  return function(e, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    t(e, i);
    function r() {
      this.constructor = e;
    }
    e.prototype = i === null ? Object.create(i) : (r.prototype = i.prototype, new r());
  };
}(), wq = (
  /** @class */
  function(t) {
    Pue(e, t);
    function e() {
      var i = t !== null && t.apply(this, arguments) || this;
      return i._WidgetClass = yn, i.independentEvents = ["onClick", "onContentReady", "onDisposing", "onInitialized"], i._templateProps = [{
        tmplOption: "template",
        render: "render",
        component: "component",
        keyFn: "keyFn"
      }], i;
    }
    return Object.defineProperty(e.prototype, "instance", {
      get: function() {
        return this._instance;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(bq)
);
wq.propTypes = {
  accessKey: re.string,
  activeStateEnabled: re.bool,
  disabled: re.bool,
  elementAttr: re.object,
  focusStateEnabled: re.bool,
  height: re.oneOfType([
    re.func,
    re.number,
    re.string
  ]),
  hint: re.string,
  hoverStateEnabled: re.bool,
  icon: re.string,
  onClick: re.func,
  onContentReady: re.func,
  onDisposing: re.func,
  onInitialized: re.func,
  onOptionChanged: re.func,
  rtlEnabled: re.bool,
  stylingMode: re.oneOfType([
    re.string,
    re.oneOf([
      "text",
      "outlined",
      "contained"
    ])
  ]),
  tabIndex: re.number,
  text: re.string,
  type: re.oneOfType([
    re.string,
    re.oneOf([
      "danger",
      "default",
      "normal",
      "success"
    ])
  ]),
  useSubmitBehavior: re.bool,
  validationGroup: re.string,
  visible: re.bool,
  width: re.oneOfType([
    re.func,
    re.number,
    re.string
  ])
};
var IT = { exports: {} }, iL, Gz;
function Fue() {
  if (Gz)
    return iL;
  Gz = 1;
  var t = 1e3, e = t * 60, i = e * 60, r = i * 24, n = r * 7, a = r * 365.25;
  iL = function(v, _) {
    _ = _ || {};
    var y = typeof v;
    if (y === "string" && v.length > 0)
      return o(v);
    if (y === "number" && isFinite(v))
      return _.long ? c(v) : u(v);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(v)
    );
  };
  function o(v) {
    if (v = String(v), !(v.length > 100)) {
      var _ = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        v
      );
      if (_) {
        var y = parseFloat(_[1]), b = (_[2] || "ms").toLowerCase();
        switch (b) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return y * a;
          case "weeks":
          case "week":
          case "w":
            return y * n;
          case "days":
          case "day":
          case "d":
            return y * r;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return y * i;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return y * e;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return y * t;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return y;
          default:
            return;
        }
      }
    }
  }
  function u(v) {
    var _ = Math.abs(v);
    return _ >= r ? Math.round(v / r) + "d" : _ >= i ? Math.round(v / i) + "h" : _ >= e ? Math.round(v / e) + "m" : _ >= t ? Math.round(v / t) + "s" : v + "ms";
  }
  function c(v) {
    var _ = Math.abs(v);
    return _ >= r ? p(v, _, r, "day") : _ >= i ? p(v, _, i, "hour") : _ >= e ? p(v, _, e, "minute") : _ >= t ? p(v, _, t, "second") : v + " ms";
  }
  function p(v, _, y, b) {
    var I = _ >= y * 1.5;
    return Math.round(v / y) + " " + b + (I ? "s" : "");
  }
  return iL;
}
function Bue(t) {
  i.debug = i, i.default = i, i.coerce = c, i.disable = a, i.enable = n, i.enabled = o, i.humanize = Fue(), i.destroy = p, Object.keys(t).forEach((v) => {
    i[v] = t[v];
  }), i.names = [], i.skips = [], i.formatters = {};
  function e(v) {
    let _ = 0;
    for (let y = 0; y < v.length; y++)
      _ = (_ << 5) - _ + v.charCodeAt(y), _ |= 0;
    return i.colors[Math.abs(_) % i.colors.length];
  }
  i.selectColor = e;
  function i(v) {
    let _, y = null, b, I;
    function A(...L) {
      if (!A.enabled)
        return;
      const B = A, $ = Number(/* @__PURE__ */ new Date()), K = $ - (_ || $);
      B.diff = K, B.prev = _, B.curr = $, _ = $, L[0] = i.coerce(L[0]), typeof L[0] != "string" && L.unshift("%O");
      let te = 0;
      L[0] = L[0].replace(/%([a-zA-Z%])/g, (ie, pe) => {
        if (ie === "%%")
          return "%";
        te++;
        const _e = i.formatters[pe];
        if (typeof _e == "function") {
          const be = L[te];
          ie = _e.call(B, be), L.splice(te, 1), te--;
        }
        return ie;
      }), i.formatArgs.call(B, L), (B.log || i.log).apply(B, L);
    }
    return A.namespace = v, A.useColors = i.useColors(), A.color = i.selectColor(v), A.extend = r, A.destroy = i.destroy, Object.defineProperty(A, "enabled", {
      enumerable: !0,
      configurable: !1,
      get: () => y !== null ? y : (b !== i.namespaces && (b = i.namespaces, I = i.enabled(v)), I),
      set: (L) => {
        y = L;
      }
    }), typeof i.init == "function" && i.init(A), A;
  }
  function r(v, _) {
    const y = i(this.namespace + (typeof _ > "u" ? ":" : _) + v);
    return y.log = this.log, y;
  }
  function n(v) {
    i.save(v), i.namespaces = v, i.names = [], i.skips = [];
    let _;
    const y = (typeof v == "string" ? v : "").split(/[\s,]+/), b = y.length;
    for (_ = 0; _ < b; _++)
      y[_] && (v = y[_].replace(/\*/g, ".*?"), v[0] === "-" ? i.skips.push(new RegExp("^" + v.slice(1) + "$")) : i.names.push(new RegExp("^" + v + "$")));
  }
  function a() {
    const v = [
      ...i.names.map(u),
      ...i.skips.map(u).map((_) => "-" + _)
    ].join(",");
    return i.enable(""), v;
  }
  function o(v) {
    if (v[v.length - 1] === "*")
      return !0;
    let _, y;
    for (_ = 0, y = i.skips.length; _ < y; _++)
      if (i.skips[_].test(v))
        return !1;
    for (_ = 0, y = i.names.length; _ < y; _++)
      if (i.names[_].test(v))
        return !0;
    return !1;
  }
  function u(v) {
    return v.toString().substring(2, v.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  function c(v) {
    return v instanceof Error ? v.stack || v.message : v;
  }
  function p() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }
  return i.enable(i.load()), i;
}
var Vue = Bue;
var DVe = IT.exports;
(function(t, e) {
  e.formatArgs = r, e.save = n, e.load = a, e.useColors = i, e.storage = o(), e.destroy = /* @__PURE__ */ (() => {
    let c = !1;
    return () => {
      c || (c = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  })(), e.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
  ];
  function i() {
    if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs))
      return !0;
    if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/))
      return !1;
    let c;
    return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator < "u" && navigator.userAgent && (c = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(c[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  function r(c) {
    if (c[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + c[0] + (this.useColors ? "%c " : " ") + "+" + t.exports.humanize(this.diff), !this.useColors)
      return;
    const p = "color: " + this.color;
    c.splice(1, 0, p, "color: inherit");
    let v = 0, _ = 0;
    c[0].replace(/%[a-zA-Z%]/g, (y) => {
      y !== "%%" && (v++, y === "%c" && (_ = v));
    }), c.splice(_, 0, p);
  }
  e.log = console.debug || console.log || (() => {
  });
  function n(c) {
    try {
      c ? e.storage.setItem("debug", c) : e.storage.removeItem("debug");
    } catch {
    }
  }
  function a() {
    let c;
    try {
      c = e.storage.getItem("debug");
    } catch {
    }
    return !c && typeof process < "u" && "env" in process && (c = process.env.DEBUG), c;
  }
  function o() {
    try {
      return localStorage;
    } catch {
    }
  }
  t.exports = Vue(e);
  const { formatters: u } = t.exports;
  u.j = function(c) {
    try {
      return JSON.stringify(c);
    } catch (p) {
      return "[UnexpectedJSONParseError]: " + p.message;
    }
  };
})(IT, IT.exports);
var Nue = IT.exports;
const YF = /* @__PURE__ */ Yte(Nue), Yk = (t, e) => ({
  ...t,
  ...e
}), Hue = (t) => (t == null ? void 0 : t.constructor) === Object, Wm = async (t, e) => {
  const {
    result: i = "json"
  } = e, r = new URL(t);
  if (e != null && e.parameter) {
    const u = e.parameter;
    r.search = new URLSearchParams(
      Object.keys(u).filter(
        (c) => u[c] !== void 0 && u[c] !== "undefined"
      ).reduce((c, p) => ({
        ...c,
        [p]: u[p]
      }), {})
    ).toString();
  }
  let n = Yk({
    Accept: "application/json"
  }, e.headers);
  e.body && (Array.isArray(e.body) || Hue(e.body)) && (n = Yk({
    "Content-Type": "application/json"
  }, n), e.body = JSON.stringify(e.body));
  const a = await window.fetch(r, {
    body: e == null ? void 0 : e.body,
    cache: e == null ? void 0 : e.cache,
    headers: n,
    method: e == null ? void 0 : e.method,
    signal: e == null ? void 0 : e.signal
  }), o = await $ue(i, a);
  if (!a.ok)
    throw o;
  return o;
};
async function $ue(t, e) {
  return t === "text" ? await e.text() : t === "blob" ? await e.blob() : await e.json();
}
function zue(t, e) {
  let i = {};
  return e.method === "GET" && e.body && (i = e.body, e.body = void 0), Wm(t, {
    body: e.body,
    headers: e.headers,
    method: e.method,
    parameter: i,
    result: e.result,
    signal: e.signal
  });
}
function Wue(t, e) {
  var i, r;
  const n = new FormData();
  n.append("entity", e.body.entity), n.append("namespace", e.body.namespace), Array.isArray(e.body.files) && e.body.files.forEach((o) => {
    n.append("files[]", o);
  }), Array.isArray(e.body.categories) && e.body.categories.forEach((o) => {
    n.append("categories[]", JSON.stringify(o));
  });
  const a = Yk({
    MantumKey: (i = e == null ? void 0 : e.security) == null ? void 0 : i.key,
    MantumSecret: (r = e == null ? void 0 : e.security) == null ? void 0 : r.secret
  }, e.headers);
  return Wm(t, {
    body: n,
    headers: a,
    method: e.method,
    result: e == null ? void 0 : e.result
  });
}
function Tq(t, e) {
  return Wm(t, {
    cache: e == null ? void 0 : e.cache,
    headers: e == null ? void 0 : e.headers,
    method: "GET",
    parameter: e == null ? void 0 : e.parameter,
    result: e == null ? void 0 : e.result,
    signal: e == null ? void 0 : e.signal
  });
}
let Uue = (t = 21) => crypto.getRandomValues(new Uint8Array(t)).reduce((e, i) => (i &= 63, i < 36 ? e += i.toString(36) : i < 62 ? e += (i - 26).toString(36).toUpperCase() : i > 62 ? e += "-" : e += "_", e), "");
const Kz = () => Uue();
function Gue(t) {
  const e = Kz(), i = new AbortController(), r = i.signal, n = {}, a = {}, o = () => {
    e in n && delete n[e];
  }, u = (p) => {
    i.abort(), p in a && delete a[p];
  }, c = (p) => {
    for (const [, v] of Object.entries(a))
      v(p);
  };
  return {
    subscribe: (p) => {
      const v = Kz();
      return a[v] = p, () => u(v);
    },
    call: (p) => {
      Object.keys(a).length !== 0 && (() => {
        const v = Tq(t, {
          parameter: p,
          signal: r
        });
        v.then((_) => {
          c(_), o();
        }), v.catch((_) => {
          c(_), o();
        });
      })();
    }
  };
}
function Kue(t, e) {
  return Wm(t, {
    body: e == null ? void 0 : e.body,
    headers: e == null ? void 0 : e.headers,
    method: "POST",
    result: e == null ? void 0 : e.result
  });
}
function jue(t, e) {
  return Wm(t, {
    body: e == null ? void 0 : e.body,
    headers: e == null ? void 0 : e.headers,
    method: "PUT",
    result: e == null ? void 0 : e.result
  });
}
function Yue(t, e) {
  return Wm(t, {
    headers: e == null ? void 0 : e.headers,
    method: "DELETE",
    result: e == null ? void 0 : e.result
  });
}
const qk = {
  delete: Yue,
  fetch: zue,
  file: Wue,
  get: Tq,
  observable: Gue,
  post: Kue,
  put: jue
};
var Iq = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Dq(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Aq = { exports: {} };
(function(t, e) {
  (function(i, r) {
    t.exports = r();
  })(Iq, function() {
    var i = 1e3, r = 6e4, n = 36e5, a = "millisecond", o = "second", u = "minute", c = "hour", p = "day", v = "week", _ = "month", y = "quarter", b = "year", I = "date", A = "Invalid Date", L = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, B = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, $ = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(Ee) {
      var Re = ["th", "st", "nd", "rd"], we = Ee % 100;
      return "[" + Ee + (Re[(we - 20) % 10] || Re[we] || Re[0]) + "]";
    } }, K = function(Ee, Re, we) {
      var We = String(Ee);
      return !We || We.length >= Re ? Ee : "" + Array(Re + 1 - We.length).join(we) + Ee;
    }, te = { s: K, z: function(Ee) {
      var Re = -Ee.utcOffset(), we = Math.abs(Re), We = Math.floor(we / 60), ne = we % 60;
      return (Re <= 0 ? "+" : "-") + K(We, 2, "0") + ":" + K(ne, 2, "0");
    }, m: function Ee(Re, we) {
      if (Re.date() < we.date())
        return -Ee(we, Re);
      var We = 12 * (we.year() - Re.year()) + (we.month() - Re.month()), ne = Re.clone().add(We, _), Ae = we - ne < 0, j = Re.clone().add(We + (Ae ? -1 : 1), _);
      return +(-(We + (we - ne) / (Ae ? ne - j : j - ne)) || 0);
    }, a: function(Ee) {
      return Ee < 0 ? Math.ceil(Ee) || 0 : Math.floor(Ee);
    }, p: function(Ee) {
      return { M: _, y: b, w: v, d: p, D: I, h: c, m: u, s: o, ms: a, Q: y }[Ee] || String(Ee || "").toLowerCase().replace(/s$/, "");
    }, u: function(Ee) {
      return Ee === void 0;
    } }, z = "en", ie = {};
    ie[z] = $;
    var pe = "$isDayjsObject", _e = function(Ee) {
      return Ee instanceof ft || !(!Ee || !Ee[pe]);
    }, be = function Ee(Re, we, We) {
      var ne;
      if (!Re)
        return z;
      if (typeof Re == "string") {
        var Ae = Re.toLowerCase();
        ie[Ae] && (ne = Ae), we && (ie[Ae] = we, ne = Ae);
        var j = Re.split("-");
        if (!ne && j.length > 1)
          return Ee(j[0]);
      } else {
        var ge = Re.name;
        ie[ge] = Re, ne = ge;
      }
      return !We && ne && (z = ne), ne || !We && z;
    }, De = function(Ee, Re) {
      if (_e(Ee))
        return Ee.clone();
      var we = typeof Re == "object" ? Re : {};
      return we.date = Ee, we.args = arguments, new ft(we);
    }, Ce = te;
    Ce.l = be, Ce.i = _e, Ce.w = function(Ee, Re) {
      return De(Ee, { locale: Re.$L, utc: Re.$u, x: Re.$x, $offset: Re.$offset });
    };
    var ft = function() {
      function Ee(we) {
        this.$L = be(we.locale, null, !0), this.parse(we), this.$x = this.$x || we.x || {}, this[pe] = !0;
      }
      var Re = Ee.prototype;
      return Re.parse = function(we) {
        this.$d = function(We) {
          var ne = We.date, Ae = We.utc;
          if (ne === null)
            return /* @__PURE__ */ new Date(NaN);
          if (Ce.u(ne))
            return /* @__PURE__ */ new Date();
          if (ne instanceof Date)
            return new Date(ne);
          if (typeof ne == "string" && !/Z$/i.test(ne)) {
            var j = ne.match(L);
            if (j) {
              var ge = j[2] - 1 || 0, Me = (j[7] || "0").substring(0, 3);
              return Ae ? new Date(Date.UTC(j[1], ge, j[3] || 1, j[4] || 0, j[5] || 0, j[6] || 0, Me)) : new Date(j[1], ge, j[3] || 1, j[4] || 0, j[5] || 0, j[6] || 0, Me);
            }
          }
          return new Date(ne);
        }(we), this.init();
      }, Re.init = function() {
        var we = this.$d;
        this.$y = we.getFullYear(), this.$M = we.getMonth(), this.$D = we.getDate(), this.$W = we.getDay(), this.$H = we.getHours(), this.$m = we.getMinutes(), this.$s = we.getSeconds(), this.$ms = we.getMilliseconds();
      }, Re.$utils = function() {
        return Ce;
      }, Re.isValid = function() {
        return this.$d.toString() !== A;
      }, Re.isSame = function(we, We) {
        var ne = De(we);
        return this.startOf(We) <= ne && ne <= this.endOf(We);
      }, Re.isAfter = function(we, We) {
        return De(we) < this.startOf(We);
      }, Re.isBefore = function(we, We) {
        return this.endOf(We) < De(we);
      }, Re.$g = function(we, We, ne) {
        return Ce.u(we) ? this[We] : this.set(ne, we);
      }, Re.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, Re.valueOf = function() {
        return this.$d.getTime();
      }, Re.startOf = function(we, We) {
        var ne = this, Ae = !!Ce.u(We) || We, j = Ce.p(we), ge = function(yt, tt) {
          var zt = Ce.w(ne.$u ? Date.UTC(ne.$y, tt, yt) : new Date(ne.$y, tt, yt), ne);
          return Ae ? zt : zt.endOf(p);
        }, Me = function(yt, tt) {
          return Ce.w(ne.toDate()[yt].apply(ne.toDate("s"), (Ae ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(tt)), ne);
        }, ze = this.$W, je = this.$M, vt = this.$D, Je = "set" + (this.$u ? "UTC" : "");
        switch (j) {
          case b:
            return Ae ? ge(1, 0) : ge(31, 11);
          case _:
            return Ae ? ge(1, je) : ge(0, je + 1);
          case v:
            var _t = this.$locale().weekStart || 0, at = (ze < _t ? ze + 7 : ze) - _t;
            return ge(Ae ? vt - at : vt + (6 - at), je);
          case p:
          case I:
            return Me(Je + "Hours", 0);
          case c:
            return Me(Je + "Minutes", 1);
          case u:
            return Me(Je + "Seconds", 2);
          case o:
            return Me(Je + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, Re.endOf = function(we) {
        return this.startOf(we, !1);
      }, Re.$set = function(we, We) {
        var ne, Ae = Ce.p(we), j = "set" + (this.$u ? "UTC" : ""), ge = (ne = {}, ne[p] = j + "Date", ne[I] = j + "Date", ne[_] = j + "Month", ne[b] = j + "FullYear", ne[c] = j + "Hours", ne[u] = j + "Minutes", ne[o] = j + "Seconds", ne[a] = j + "Milliseconds", ne)[Ae], Me = Ae === p ? this.$D + (We - this.$W) : We;
        if (Ae === _ || Ae === b) {
          var ze = this.clone().set(I, 1);
          ze.$d[ge](Me), ze.init(), this.$d = ze.set(I, Math.min(this.$D, ze.daysInMonth())).$d;
        } else
          ge && this.$d[ge](Me);
        return this.init(), this;
      }, Re.set = function(we, We) {
        return this.clone().$set(we, We);
      }, Re.get = function(we) {
        return this[Ce.p(we)]();
      }, Re.add = function(we, We) {
        var ne, Ae = this;
        we = Number(we);
        var j = Ce.p(We), ge = function(je) {
          var vt = De(Ae);
          return Ce.w(vt.date(vt.date() + Math.round(je * we)), Ae);
        };
        if (j === _)
          return this.set(_, this.$M + we);
        if (j === b)
          return this.set(b, this.$y + we);
        if (j === p)
          return ge(1);
        if (j === v)
          return ge(7);
        var Me = (ne = {}, ne[u] = r, ne[c] = n, ne[o] = i, ne)[j] || 1, ze = this.$d.getTime() + we * Me;
        return Ce.w(ze, this);
      }, Re.subtract = function(we, We) {
        return this.add(-1 * we, We);
      }, Re.format = function(we) {
        var We = this, ne = this.$locale();
        if (!this.isValid())
          return ne.invalidDate || A;
        var Ae = we || "YYYY-MM-DDTHH:mm:ssZ", j = Ce.z(this), ge = this.$H, Me = this.$m, ze = this.$M, je = ne.weekdays, vt = ne.months, Je = ne.meridiem, _t = function(tt, zt, Ie, gt) {
          return tt && (tt[zt] || tt(We, Ae)) || Ie[zt].slice(0, gt);
        }, at = function(tt) {
          return Ce.s(ge % 12 || 12, tt, "0");
        }, yt = Je || function(tt, zt, Ie) {
          var gt = tt < 12 ? "AM" : "PM";
          return Ie ? gt.toLowerCase() : gt;
        };
        return Ae.replace(B, function(tt, zt) {
          return zt || function(Ie) {
            switch (Ie) {
              case "YY":
                return String(We.$y).slice(-2);
              case "YYYY":
                return Ce.s(We.$y, 4, "0");
              case "M":
                return ze + 1;
              case "MM":
                return Ce.s(ze + 1, 2, "0");
              case "MMM":
                return _t(ne.monthsShort, ze, vt, 3);
              case "MMMM":
                return _t(vt, ze);
              case "D":
                return We.$D;
              case "DD":
                return Ce.s(We.$D, 2, "0");
              case "d":
                return String(We.$W);
              case "dd":
                return _t(ne.weekdaysMin, We.$W, je, 2);
              case "ddd":
                return _t(ne.weekdaysShort, We.$W, je, 3);
              case "dddd":
                return je[We.$W];
              case "H":
                return String(ge);
              case "HH":
                return Ce.s(ge, 2, "0");
              case "h":
                return at(1);
              case "hh":
                return at(2);
              case "a":
                return yt(ge, Me, !0);
              case "A":
                return yt(ge, Me, !1);
              case "m":
                return String(Me);
              case "mm":
                return Ce.s(Me, 2, "0");
              case "s":
                return String(We.$s);
              case "ss":
                return Ce.s(We.$s, 2, "0");
              case "SSS":
                return Ce.s(We.$ms, 3, "0");
              case "Z":
                return j;
            }
            return null;
          }(tt) || j.replace(":", "");
        });
      }, Re.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, Re.diff = function(we, We, ne) {
        var Ae, j = this, ge = Ce.p(We), Me = De(we), ze = (Me.utcOffset() - this.utcOffset()) * r, je = this - Me, vt = function() {
          return Ce.m(j, Me);
        };
        switch (ge) {
          case b:
            Ae = vt() / 12;
            break;
          case _:
            Ae = vt();
            break;
          case y:
            Ae = vt() / 3;
            break;
          case v:
            Ae = (je - ze) / 6048e5;
            break;
          case p:
            Ae = (je - ze) / 864e5;
            break;
          case c:
            Ae = je / n;
            break;
          case u:
            Ae = je / r;
            break;
          case o:
            Ae = je / i;
            break;
          default:
            Ae = je;
        }
        return ne ? Ae : Ce.a(Ae);
      }, Re.daysInMonth = function() {
        return this.endOf(_).$D;
      }, Re.$locale = function() {
        return ie[this.$L];
      }, Re.locale = function(we, We) {
        if (!we)
          return this.$L;
        var ne = this.clone(), Ae = be(we, We, !0);
        return Ae && (ne.$L = Ae), ne;
      }, Re.clone = function() {
        return Ce.w(this.$d, this);
      }, Re.toDate = function() {
        return new Date(this.valueOf());
      }, Re.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, Re.toISOString = function() {
        return this.$d.toISOString();
      }, Re.toString = function() {
        return this.$d.toUTCString();
      }, Ee;
    }(), Ve = ft.prototype;
    return De.prototype = Ve, [["$ms", a], ["$s", o], ["$m", u], ["$H", c], ["$W", p], ["$M", _], ["$y", b], ["$D", I]].forEach(function(Ee) {
      Ve[Ee[1]] = function(Re) {
        return this.$g(Re, Ee[0], Ee[1]);
      };
    }), De.extend = function(Ee, Re) {
      return Ee.$i || (Ee(Re, ft, De), Ee.$i = !0), De;
    }, De.locale = be, De.isDayjs = _e, De.unix = function(Ee) {
      return De(1e3 * Ee);
    }, De.en = ie[z], De.Ls = ie, De.p = {}, De;
  });
})(Aq);
var que = Aq.exports;
const Oq = /* @__PURE__ */ Dq(que);
var Rq = { exports: {} };
(function(t, e) {
  (function(i, r) {
    t.exports = r();
  })(Iq, function() {
    var i = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, a = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, u = {}, c = function(A) {
      return (A = +A) + (A > 68 ? 1900 : 2e3);
    }, p = function(A) {
      return function(L) {
        this[A] = +L;
      };
    }, v = [/[+-]\d\d:?(\d\d)?|Z/, function(A) {
      (this.zone || (this.zone = {})).offset = function(L) {
        if (!L || L === "Z")
          return 0;
        var B = L.match(/([+-]|\d\d)/g), $ = 60 * B[1] + (+B[2] || 0);
        return $ === 0 ? 0 : B[0] === "+" ? -$ : $;
      }(A);
    }], _ = function(A) {
      var L = u[A];
      return L && (L.indexOf ? L : L.s.concat(L.f));
    }, y = function(A, L) {
      var B, $ = u.meridiem;
      if ($) {
        for (var K = 1; K <= 24; K += 1)
          if (A.indexOf($(K, 0, L)) > -1) {
            B = K > 12;
            break;
          }
      } else
        B = A === (L ? "pm" : "PM");
      return B;
    }, b = { A: [o, function(A) {
      this.afternoon = y(A, !1);
    }], a: [o, function(A) {
      this.afternoon = y(A, !0);
    }], S: [/\d/, function(A) {
      this.milliseconds = 100 * +A;
    }], SS: [n, function(A) {
      this.milliseconds = 10 * +A;
    }], SSS: [/\d{3}/, function(A) {
      this.milliseconds = +A;
    }], s: [a, p("seconds")], ss: [a, p("seconds")], m: [a, p("minutes")], mm: [a, p("minutes")], H: [a, p("hours")], h: [a, p("hours")], HH: [a, p("hours")], hh: [a, p("hours")], D: [a, p("day")], DD: [n, p("day")], Do: [o, function(A) {
      var L = u.ordinal, B = A.match(/\d+/);
      if (this.day = B[0], L)
        for (var $ = 1; $ <= 31; $ += 1)
          L($).replace(/\[|\]/g, "") === A && (this.day = $);
    }], M: [a, p("month")], MM: [n, p("month")], MMM: [o, function(A) {
      var L = _("months"), B = (_("monthsShort") || L.map(function($) {
        return $.slice(0, 3);
      })).indexOf(A) + 1;
      if (B < 1)
        throw new Error();
      this.month = B % 12 || B;
    }], MMMM: [o, function(A) {
      var L = _("months").indexOf(A) + 1;
      if (L < 1)
        throw new Error();
      this.month = L % 12 || L;
    }], Y: [/[+-]?\d+/, p("year")], YY: [n, function(A) {
      this.year = c(A);
    }], YYYY: [/\d{4}/, p("year")], Z: v, ZZ: v };
    function I(A) {
      var L, B;
      L = A, B = u && u.formats;
      for (var $ = (A = L.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(be, De, Ce) {
        var ft = Ce && Ce.toUpperCase();
        return De || B[Ce] || i[Ce] || B[ft].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(Ve, Ee, Re) {
          return Ee || Re.slice(1);
        });
      })).match(r), K = $.length, te = 0; te < K; te += 1) {
        var z = $[te], ie = b[z], pe = ie && ie[0], _e = ie && ie[1];
        $[te] = _e ? { regex: pe, parser: _e } : z.replace(/^\[|\]$/g, "");
      }
      return function(be) {
        for (var De = {}, Ce = 0, ft = 0; Ce < K; Ce += 1) {
          var Ve = $[Ce];
          if (typeof Ve == "string")
            ft += Ve.length;
          else {
            var Ee = Ve.regex, Re = Ve.parser, we = be.slice(ft), We = Ee.exec(we)[0];
            Re.call(De, We), be = be.replace(We, "");
          }
        }
        return function(ne) {
          var Ae = ne.afternoon;
          if (Ae !== void 0) {
            var j = ne.hours;
            Ae ? j < 12 && (ne.hours += 12) : j === 12 && (ne.hours = 0), delete ne.afternoon;
          }
        }(De), De;
      };
    }
    return function(A, L, B) {
      B.p.customParseFormat = !0, A && A.parseTwoDigitYear && (c = A.parseTwoDigitYear);
      var $ = L.prototype, K = $.parse;
      $.parse = function(te) {
        var z = te.date, ie = te.utc, pe = te.args;
        this.$u = ie;
        var _e = pe[1];
        if (typeof _e == "string") {
          var be = pe[2] === !0, De = pe[3] === !0, Ce = be || De, ft = pe[2];
          De && (ft = pe[2]), u = this.$locale(), !be && ft && (u = B.Ls[ft]), this.$d = function(we, We, ne) {
            try {
              if (["x", "X"].indexOf(We) > -1)
                return new Date((We === "X" ? 1e3 : 1) * we);
              var Ae = I(We)(we), j = Ae.year, ge = Ae.month, Me = Ae.day, ze = Ae.hours, je = Ae.minutes, vt = Ae.seconds, Je = Ae.milliseconds, _t = Ae.zone, at = /* @__PURE__ */ new Date(), yt = Me || (j || ge ? 1 : at.getDate()), tt = j || at.getFullYear(), zt = 0;
              j && !ge || (zt = ge > 0 ? ge - 1 : at.getMonth());
              var Ie = ze || 0, gt = je || 0, si = vt || 0, Wt = Je || 0;
              return _t ? new Date(Date.UTC(tt, zt, yt, Ie, gt, si, Wt + 60 * _t.offset * 1e3)) : ne ? new Date(Date.UTC(tt, zt, yt, Ie, gt, si, Wt)) : new Date(tt, zt, yt, Ie, gt, si, Wt);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(z, _e, ie), this.init(), ft && ft !== !0 && (this.$L = this.locale(ft).$L), Ce && z != this.format(_e) && (this.$d = /* @__PURE__ */ new Date("")), u = {};
        } else if (_e instanceof Array)
          for (var Ve = _e.length, Ee = 1; Ee <= Ve; Ee += 1) {
            pe[1] = _e[Ee - 1];
            var Re = B.apply(this, pe);
            if (Re.isValid()) {
              this.$d = Re.$d, this.$L = Re.$L, this.init();
              break;
            }
            Ee === Ve && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          K.call(this, te);
      };
    };
  });
})(Rq);
var Xue = Rq.exports;
const Que = /* @__PURE__ */ Dq(Xue);
Oq.extend(Que);
const Zue = /undefined/i, Jue = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/, ede = (t) => !t || t === "" || t.trim().length === 0, tde = (t) => t === !0 || t === void 0, ide = (t) => t === void 0 || typeof t == "string" && Zue.test(t), rde = (t) => t === null, mI = (t) => Object.prototype.toString.call(t) === "[object Object]", nde = (t, e, i) => Oq(t, e, i, !0).isValid(), ade = (t) => !(!t || t.split("@").length != 2 || !Jue.test(t)), ode = (t) => {
  if (Array.isArray(t)) {
    if (t.length === 0)
      return !0;
    const e = t[0];
    if (mI(e) && "sections" in e)
      return !0;
  }
  return !1;
}, sde = (t) => !!(t && mI(t) && typeof t == "object" && "label" in t && "value" in t), lde = (t) => !!(t && mI(t) && typeof t == "object" && "url" in t), ude = (t, e) => t < e, dde = (t, e) => t <= e, cde = (t, e) => t > e, hde = (t, e) => t >= e, qF = {
  isDataSource: lde,
  isDate: nde,
  isEmail: ade,
  isEmpty: ede,
  isGreaterThan: cde,
  isGreaterThanOrEqualTo: hde,
  isLessThan: ude,
  isLessThanThanOrEqualTo: dde,
  isNull: rde,
  isObject: mI,
  isSelect: sde,
  isTab: ode,
  isUndefined: ide,
  isVisible: tde
};
const fde = (t, e) => {
  if (!e || !t)
    return "";
  t = t.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const i = new RegExp("[\\?&]" + t + "=([^&#]*)").exec(e);
  return i === null ? "" : decodeURIComponent(i[1].replace(/\+/g, " "));
}, pde = {
  query: fde
};
const vde = (t, e) => (t.order || 0) - (e.order || 0), jz = {
  asc: vde
}, gde = (t, e) => {
  if (!Lq(t, e) || !e.parameter)
    return e;
  const i = {
    ...t
  };
  i.parameter = i.parameter || {};
  for (const [r, n] of Object.entries(e.parameter))
    if (!(r in i.parameter))
      i.parameter = {
        ...i.parameter,
        [r]: n
      };
    else if (i.parameter) {
      const a = i.parameter[r];
      if (a && typeof a == "string") {
        const o = a.split(",");
        o.push(`${n}`), i.parameter[r] = o.join(",");
      }
    }
  return i;
}, Lq = (t, e) => !t || !e || t.url !== e.url || t.method !== e.method || t.namespace !== e.namespace || JSON.stringify(t.parameter) !== JSON.stringify(e.parameter), mde = (t, e) => {
  var i, r;
  return qF.isObject(t) && ((r = (i = e == null ? void 0 : e.split(".")) == null ? void 0 : i.filter((n) => n !== "")) == null || r.forEach((n) => {
    t && (t = t[n]);
  })), t;
}, np = {
  diff: Lq,
  extract: mde,
  merge: gde
};
const rL = YF("kanela:request");
function Mq(t) {
  return new Promise((e, i) => {
    rL("fetch %s", t.url);
    const r = qk.fetch(t.url, {
      method: t.args.method,
      body: t.args.body,
      headers: t.args.headers
    });
    r.then((n) => {
      rL("response request %o", n), e(np.extract(n, t.args.namespace));
    }), r.catch((n) => {
      rL("error request %o", n), i(n);
    });
  });
}
var DT = { exports: {} }, nL = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yz;
function _de() {
  if (Yz)
    return nL;
  Yz = 1;
  var t = nc;
  function e(_, y) {
    return _ === y && (_ !== 0 || 1 / _ === 1 / y) || _ !== _ && y !== y;
  }
  var i = typeof Object.is == "function" ? Object.is : e, r = t.useState, n = t.useEffect, a = t.useLayoutEffect, o = t.useDebugValue;
  function u(_, y) {
    var b = y(), I = r({ inst: { value: b, getSnapshot: y } }), A = I[0].inst, L = I[1];
    return a(function() {
      A.value = b, A.getSnapshot = y, c(A) && L({ inst: A });
    }, [_, b, y]), n(function() {
      return c(A) && L({ inst: A }), _(function() {
        c(A) && L({ inst: A });
      });
    }, [_]), o(b), b;
  }
  function c(_) {
    var y = _.getSnapshot;
    _ = _.value;
    try {
      var b = y();
      return !i(_, b);
    } catch {
      return !0;
    }
  }
  function p(_, y) {
    return y();
  }
  var v = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? p : u;
  return nL.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : v, nL;
}
var aL = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qz;
function Cde() {
  return qz || (qz = 1, process.env.NODE_ENV !== "production" && function() {
    "use strict";
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = nc, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function i(K) {
      {
        for (var te = arguments.length, z = new Array(te > 1 ? te - 1 : 0), ie = 1; ie < te; ie++)
          z[ie - 1] = arguments[ie];
        r("error", K, z);
      }
    }
    function r(K, te, z) {
      {
        var ie = e.ReactDebugCurrentFrame, pe = ie.getStackAddendum();
        pe !== "" && (te += "%s", z = z.concat([pe]));
        var _e = z.map(function(be) {
          return String(be);
        });
        _e.unshift("Warning: " + te), Function.prototype.apply.call(console[K], console, _e);
      }
    }
    function n(K, te) {
      return K === te && (K !== 0 || 1 / K === 1 / te) || K !== K && te !== te;
    }
    var a = typeof Object.is == "function" ? Object.is : n, o = t.useState, u = t.useEffect, c = t.useLayoutEffect, p = t.useDebugValue, v = !1, _ = !1;
    function y(K, te, z) {
      v || t.startTransition !== void 0 && (v = !0, i("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var ie = te();
      if (!_) {
        var pe = te();
        a(ie, pe) || (i("The result of getSnapshot should be cached to avoid an infinite loop"), _ = !0);
      }
      var _e = o({
        inst: {
          value: ie,
          getSnapshot: te
        }
      }), be = _e[0].inst, De = _e[1];
      return c(function() {
        be.value = ie, be.getSnapshot = te, b(be) && De({
          inst: be
        });
      }, [K, ie, te]), u(function() {
        b(be) && De({
          inst: be
        });
        var Ce = function() {
          b(be) && De({
            inst: be
          });
        };
        return K(Ce);
      }, [K]), p(ie), ie;
    }
    function b(K) {
      var te = K.getSnapshot, z = K.value;
      try {
        var ie = te();
        return !a(z, ie);
      } catch {
        return !0;
      }
    }
    function I(K, te, z) {
      return te();
    }
    var A = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", L = !A, B = L ? I : y, $ = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : B;
    aL.useSyncExternalStore = $, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), aL;
}
var AVe = DT.exports;
process.env.NODE_ENV === "production" ? DT.exports = _de() : DT.exports = Cde();
var yde = DT.exports;
const yh = () => {
}, ao = (
  /*#__NOINLINE__*/
  yh()
), Uw = Object, Hi = (t) => t === ao, Ml = (t) => typeof t == "function", tc = (t, e) => ({
  ...t,
  ...e
}), xde = (t) => Ml(t.then), $b = /* @__PURE__ */ new WeakMap();
let Sde = 0;
const Vx = (t) => {
  const e = typeof t, i = t && t.constructor, r = i == Date;
  let n, a;
  if (Uw(t) === t && !r && i != RegExp) {
    if (n = $b.get(t), n)
      return n;
    if (n = ++Sde + "~", $b.set(t, n), i == Array) {
      for (n = "@", a = 0; a < t.length; a++)
        n += Vx(t[a]) + ",";
      $b.set(t, n);
    }
    if (i == Uw) {
      n = "#";
      const o = Uw.keys(t).sort();
      for (; !Hi(a = o.pop()); )
        Hi(t[a]) || (n += a + ":" + Vx(t[a]) + ",");
      $b.set(t, n);
    }
  } else
    n = r ? t.toJSON() : e == "symbol" ? t.toString() : e == "string" ? JSON.stringify(t) : "" + t;
  return n;
}, Hd = /* @__PURE__ */ new WeakMap(), oL = {}, zb = {}, XF = "undefined", _I = typeof window != XF, Xk = typeof document != XF, Ede = () => _I && typeof window.requestAnimationFrame != XF, kq = (t, e) => {
  const i = Hd.get(t);
  return [
    // Getter
    () => !Hi(e) && t.get(e) || oL,
    // Setter
    (r) => {
      if (!Hi(e)) {
        const n = t.get(e);
        e in zb || (zb[e] = n), i[5](e, tc(n, r), n || oL);
      }
    },
    // Subscriber
    i[6],
    // Get server cache snapshot
    () => !Hi(e) && e in zb ? zb[e] : !Hi(e) && t.get(e) || oL
  ];
};
let Qk = !0;
const bde = () => Qk, [Zk, Jk] = _I && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  yh,
  yh
], wde = () => {
  const t = Xk && document.visibilityState;
  return Hi(t) || t !== "hidden";
}, Tde = (t) => (Xk && document.addEventListener("visibilitychange", t), Zk("focus", t), () => {
  Xk && document.removeEventListener("visibilitychange", t), Jk("focus", t);
}), Ide = (t) => {
  const e = () => {
    Qk = !0, t();
  }, i = () => {
    Qk = !1;
  };
  return Zk("online", e), Zk("offline", i), () => {
    Jk("online", e), Jk("offline", i);
  };
}, Dde = {
  isOnline: bde,
  isVisible: wde
}, Ade = {
  initFocus: Tde,
  initReconnect: Ide
}, Xz = !nc.useId, Nx = !_I || "Deno" in window, Ode = (t) => Ede() ? window.requestAnimationFrame(t) : setTimeout(t, 1), Gw = Nx ? xm : U3, sL = typeof navigator < "u" && navigator.connection, Qz = !Nx && sL && ([
  "slow-2g",
  "2g"
].includes(sL.effectiveType) || sL.saveData), QF = (t) => {
  if (Ml(t))
    try {
      t = t();
    } catch {
      t = "";
    }
  const e = t;
  return t = typeof t == "string" ? t : (Array.isArray(t) ? t.length : t) ? Vx(t) : "", [
    t,
    e
  ];
};
let Rde = 0;
const eP = () => ++Rde, Pq = 0, Fq = 1, Bq = 2, Lde = 3;
var _y = {
  __proto__: null,
  ERROR_REVALIDATE_EVENT: Lde,
  FOCUS_EVENT: Pq,
  MUTATE_EVENT: Bq,
  RECONNECT_EVENT: Fq
};
async function Vq(...t) {
  const [e, i, r, n] = t, a = tc({
    populateCache: !0,
    throwOnError: !0
  }, typeof n == "boolean" ? {
    revalidate: n
  } : n || {});
  let o = a.populateCache;
  const u = a.rollbackOnError;
  let c = a.optimisticData;
  const p = (y) => typeof u == "function" ? u(y) : u !== !1, v = a.throwOnError;
  if (Ml(i)) {
    const y = i, b = [], I = e.keys();
    for (const A of I)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(A) && y(e.get(A)._k) && b.push(A);
    return Promise.all(b.map(_));
  }
  return _(i);
  async function _(y) {
    const [b] = QF(y);
    if (!b)
      return;
    const [I, A] = kq(e, b), [L, B, $, K] = Hd.get(e), te = () => {
      const Ve = L[b];
      return (Ml(a.revalidate) ? a.revalidate(I().data, y) : a.revalidate !== !1) && (delete $[b], delete K[b], Ve && Ve[0]) ? Ve[0](Bq).then(() => I().data) : I().data;
    };
    if (t.length < 3)
      return te();
    let z = r, ie;
    const pe = eP();
    B[b] = [
      pe,
      0
    ];
    const _e = !Hi(c), be = I(), De = be.data, Ce = be._c, ft = Hi(Ce) ? De : Ce;
    if (_e && (c = Ml(c) ? c(ft, De) : c, A({
      data: c,
      _c: ft
    })), Ml(z))
      try {
        z = z(ft);
      } catch (Ve) {
        ie = Ve;
      }
    if (z && xde(z))
      if (z = await z.catch((Ve) => {
        ie = Ve;
      }), pe !== B[b][0]) {
        if (ie)
          throw ie;
        return z;
      } else
        ie && _e && p(ie) && (o = !0, A({
          data: ft,
          _c: ao
        }));
    if (o && !ie)
      if (Ml(o)) {
        const Ve = o(z, ft);
        A({
          data: Ve,
          error: ao,
          _c: ao
        });
      } else
        A({
          data: z,
          error: ao,
          _c: ao
        });
    if (B[b][1] = eP(), Promise.resolve(te()).then(() => {
      A({
        _c: ao
      });
    }), ie) {
      if (v)
        throw ie;
      return;
    }
    return z;
  }
}
const Zz = (t, e) => {
  for (const i in t)
    t[i][0] && t[i][0](e);
}, Nq = (t, e) => {
  if (!Hd.has(t)) {
    const i = tc(Ade, e), r = {}, n = Vq.bind(ao, t);
    let a = yh;
    const o = {}, u = (v, _) => {
      const y = o[v] || [];
      return o[v] = y, y.push(_), () => y.splice(y.indexOf(_), 1);
    }, c = (v, _, y) => {
      t.set(v, _);
      const b = o[v];
      if (b)
        for (const I of b)
          I(_, y);
    }, p = () => {
      if (!Hd.has(t) && (Hd.set(t, [
        r,
        {},
        {},
        {},
        n,
        c,
        u
      ]), !Nx)) {
        const v = i.initFocus(setTimeout.bind(ao, Zz.bind(ao, r, Pq))), _ = i.initReconnect(setTimeout.bind(ao, Zz.bind(ao, r, Fq)));
        a = () => {
          v && v(), _ && _(), Hd.delete(t);
        };
      }
    };
    return p(), [
      t,
      n,
      p,
      a
    ];
  }
  return [
    t,
    Hd.get(t)[4]
  ];
}, Mde = (t, e, i, r, n) => {
  const a = i.errorRetryCount, o = n.retryCount, u = ~~((Math.random() + 0.5) * (1 << (o < 8 ? o : 8))) * i.errorRetryInterval;
  !Hi(a) && o > a || setTimeout(r, u, n);
}, kde = (t, e) => Vx(t) == Vx(e), [ZF, Pde] = Nq(/* @__PURE__ */ new Map()), Hq = tc(
  {
    // events
    onLoadingSlow: yh,
    onSuccess: yh,
    onError: yh,
    onErrorRetry: Mde,
    onDiscarded: yh,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: Qz ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: Qz ? 5e3 : 3e3,
    // providers
    compare: kde,
    isPaused: () => !1,
    cache: ZF,
    mutate: Pde,
    fallback: {}
  },
  // use web preset by default
  Dde
), $q = (t, e) => {
  const i = tc(t, e);
  if (e) {
    const { use: r, fallback: n } = t, { use: a, fallback: o } = e;
    r && a && (i.use = r.concat(a)), n && o && (i.fallback = tc(n, o));
  }
  return i;
}, tP = W3({}), Fde = (t) => {
  const { value: e } = t, i = G3(tP), r = Ml(e), n = Sh(() => r ? e(i) : e, [
    r,
    i,
    e
  ]), a = Sh(() => r ? n : $q(i, n), [
    r,
    i,
    n
  ]), o = n && n.provider, u = Jn(ao);
  o && !u.current && (u.current = Nq(o(a.cache || ZF), n));
  const c = u.current;
  return c && (a.cache = c[0], a.mutate = c[1]), Gw(() => {
    if (c)
      return c[2] && c[2](), c[3];
  }, []), Ute(tP.Provider, tc(t, {
    value: a
  }));
}, Bde = "$inf$", zq = _I && window.__SWR_DEVTOOLS_USE__, Vde = zq ? window.__SWR_DEVTOOLS_USE__ : [], Nde = () => {
  zq && (window.__SWR_DEVTOOLS_REACT__ = nc);
}, Hde = (t) => Ml(t[1]) ? [
  t[0],
  t[1],
  t[2] || {}
] : [
  t[0],
  null,
  (t[1] === null ? t[2] : t[1]) || {}
], $de = () => tc(Hq, G3(tP));
const zde = (t) => (e, i, r) => t(e, i && ((...a) => {
  const [o] = QF(e), [, , , u] = Hd.get(ZF);
  if (o.startsWith(Bde))
    return i(...a);
  const c = u[o];
  return Hi(c) ? i(...a) : (delete u[o], c);
}), r), Wde = Vde.concat(zde), Ude = (t) => function(...i) {
  const r = $de(), [n, a, o] = Hde(i), u = $q(r, o);
  let c = t;
  const { use: p } = u, v = (p || []).concat(Wde);
  for (let _ = v.length; _--; )
    c = v[_](c);
  return c(n, a || u.fetcher || null, u);
}, Gde = (t, e, i) => {
  const r = e[t] || (e[t] = []);
  return r.push(i), () => {
    const n = r.indexOf(i);
    n >= 0 && (r[n] = r[r.length - 1], r.pop());
  };
};
Nde();
const Jz = nc.use || ((t) => {
  if (t.status === "pending")
    throw t;
  if (t.status === "fulfilled")
    return t.value;
  throw t.status === "rejected" ? t.reason : (t.status = "pending", t.then((e) => {
    t.status = "fulfilled", t.value = e;
  }, (e) => {
    t.status = "rejected", t.reason = e;
  }), t);
}), lL = {
  dedupe: !0
}, Kde = (t, e, i) => {
  const { cache: r, compare: n, suspense: a, fallbackData: o, revalidateOnMount: u, revalidateIfStale: c, refreshInterval: p, refreshWhenHidden: v, refreshWhenOffline: _, keepPreviousData: y } = i, [b, I, A, L] = Hd.get(r), [B, $] = QF(t), K = Jn(!1), te = Jn(!1), z = Jn(B), ie = Jn(e), pe = Jn(i), _e = () => pe.current, be = () => _e().isVisible() && _e().isOnline(), [De, Ce, ft, Ve] = kq(r, B), Ee = Jn({}).current, Re = Hi(o) ? i.fallback[B] : o, we = (Ie, gt) => {
    for (const si in Ee) {
      const Wt = si;
      if (Wt === "data") {
        if (!n(Ie[Wt], gt[Wt]) && (!Hi(Ie[Wt]) || !n(vt, gt[Wt])))
          return !1;
      } else if (gt[Wt] !== Ie[Wt])
        return !1;
    }
    return !0;
  }, We = Sh(() => {
    const Ie = !B || !e ? !1 : Hi(u) ? _e().isPaused() || a ? !1 : Hi(c) ? !0 : c : u, gt = (Wi) => {
      const Rr = tc(Wi);
      return delete Rr._k, Ie ? {
        isValidating: !0,
        isLoading: !0,
        ...Rr
      } : Rr;
    }, si = De(), Wt = Ve(), ki = gt(si), lr = si === Wt ? ki : gt(Wt);
    let mi = ki;
    return [
      () => {
        const Wi = gt(De());
        return we(Wi, mi) ? (mi.data = Wi.data, mi.isLoading = Wi.isLoading, mi.isValidating = Wi.isValidating, mi.error = Wi.error, mi) : (mi = Wi, Wi);
      },
      () => lr
    ];
  }, [
    r,
    B
  ]), ne = yde.useSyncExternalStore(Ki(
    (Ie) => ft(B, (gt, si) => {
      we(si, gt) || Ie();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      B
    ]
  ), We[0], We[1]), Ae = !K.current, j = b[B] && b[B].length > 0, ge = ne.data, Me = Hi(ge) ? Re : ge, ze = ne.error, je = Jn(Me), vt = y ? Hi(ge) ? je.current : ge : Me, Je = j && !Hi(ze) ? !1 : Ae && !Hi(u) ? u : _e().isPaused() ? !1 : a ? Hi(Me) ? !1 : c : Hi(Me) || c, _t = !!(B && e && Ae && Je), at = Hi(ne.isValidating) ? _t : ne.isValidating, yt = Hi(ne.isLoading) ? _t : ne.isLoading, tt = Ki(
    async (Ie) => {
      const gt = ie.current;
      if (!B || !gt || te.current || _e().isPaused())
        return !1;
      let si, Wt, ki = !0;
      const lr = Ie || {}, mi = !A[B] || !lr.dedupe, Wi = () => Xz ? !te.current && B === z.current && K.current : B === z.current, Rr = {
        isValidating: !1,
        isLoading: !1
      }, ia = () => {
        Ce(Rr);
      }, ra = () => {
        const Yi = A[B];
        Yi && Yi[1] === Wt && delete A[B];
      }, zn = {
        isValidating: !0
      };
      Hi(De().data) && (zn.isLoading = !0);
      try {
        if (mi && (Ce(zn), i.loadingTimeout && Hi(De().data) && setTimeout(() => {
          ki && Wi() && _e().onLoadingSlow(B, i);
        }, i.loadingTimeout), A[B] = [
          gt($),
          eP()
        ]), [si, Wt] = A[B], si = await si, mi && setTimeout(ra, i.dedupingInterval), !A[B] || A[B][1] !== Wt)
          return mi && Wi() && _e().onDiscarded(B), !1;
        Rr.error = ao;
        const Yi = I[B];
        if (!Hi(Yi) && // case 1
        (Wt <= Yi[0] || // case 2
        Wt <= Yi[1] || // case 3
        Yi[1] === 0))
          return ia(), mi && Wi() && _e().onDiscarded(B), !1;
        const tr = De().data;
        Rr.data = n(tr, si) ? tr : si, mi && Wi() && _e().onSuccess(si, B, i);
      } catch (Yi) {
        ra();
        const tr = _e(), { shouldRetryOnError: cn } = tr;
        tr.isPaused() || (Rr.error = Yi, mi && Wi() && (tr.onError(Yi, B, tr), (cn === !0 || Ml(cn) && cn(Yi)) && (!_e().revalidateOnFocus || !_e().revalidateOnReconnect || be()) && tr.onErrorRetry(Yi, B, tr, (hr) => {
          const Wr = b[B];
          Wr && Wr[0] && Wr[0](_y.ERROR_REVALIDATE_EVENT, hr);
        }, {
          retryCount: (lr.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return ki = !1, ia(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      B,
      r
    ]
  ), zt = Ki(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...Ie) => Vq(r, z.current, ...Ie),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (Gw(() => {
    ie.current = e, pe.current = i, Hi(ge) || (je.current = ge);
  }), Gw(() => {
    if (!B)
      return;
    const Ie = tt.bind(ao, lL);
    let gt = 0;
    const Wt = Gde(B, b, (ki, lr = {}) => {
      if (ki == _y.FOCUS_EVENT) {
        const mi = Date.now();
        _e().revalidateOnFocus && mi > gt && be() && (gt = mi + _e().focusThrottleInterval, Ie());
      } else if (ki == _y.RECONNECT_EVENT)
        _e().revalidateOnReconnect && be() && Ie();
      else {
        if (ki == _y.MUTATE_EVENT)
          return tt();
        if (ki == _y.ERROR_REVALIDATE_EVENT)
          return tt(lr);
      }
    });
    return te.current = !1, z.current = B, K.current = !0, Ce({
      _k: $
    }), Je && (Hi(Me) || Nx ? Ie() : Ode(Ie)), () => {
      te.current = !0, Wt();
    };
  }, [
    B
  ]), Gw(() => {
    let Ie;
    function gt() {
      const Wt = Ml(p) ? p(De().data) : p;
      Wt && Ie !== -1 && (Ie = setTimeout(si, Wt));
    }
    function si() {
      !De().error && (v || _e().isVisible()) && (_ || _e().isOnline()) ? tt(lL).then(gt) : gt();
    }
    return gt(), () => {
      Ie && (clearTimeout(Ie), Ie = -1);
    };
  }, [
    p,
    v,
    _,
    B
  ]), Gte(vt), a && Hi(Me) && B) {
    if (!Xz && Nx)
      throw new Error("Fallback data is required when using suspense in SSR.");
    ie.current = e, pe.current = i, te.current = !1;
    const Ie = L[B];
    if (!Hi(Ie)) {
      const gt = zt(Ie);
      Jz(gt);
    }
    if (Hi(ze)) {
      const gt = tt(lL);
      Hi(vt) || (gt.status = "fulfilled", gt.value = !0), Jz(gt);
    } else
      throw ze;
  }
  return {
    mutate: zt,
    get data() {
      return Ee.data = !0, vt;
    },
    get error() {
      return Ee.error = !0, ze;
    },
    get isValidating() {
      return Ee.isValidating = !0, at;
    },
    get isLoading() {
      return Ee.isLoading = !0, yt;
    }
  };
}, OVe = Uw.defineProperty(Fde, "defaultValue", {
  value: Hq
}), Wq = Ude(Kde);
var iP = "dx-state-focused", jde = "dx-cell-focus-disabled", Yde = ".dx-row-focused", Uq = ".dx-datagrid-rowsview .dx-row", eW = "".concat(Uq, " > td"), Gq = ".dx-treelist-rowsview .dx-row", tW = "".concat(Gq, " > td"), iW = {
  groupPanel: [".dx-datagrid-group-panel .dx-group-panel-item[tabindex]"],
  columnHeaders: [".dx-datagrid-headers .dx-header-row > td.dx-datagrid-action", ".dx-treelist-headers .dx-header-row > td.dx-treelist-action"],
  filterRow: [".dx-datagrid-headers .dx-datagrid-filter-row .dx-editor-cell .dx-texteditor-input", ".dx-treelist-headers .dx-treelist-filter-row .dx-editor-cell .dx-texteditor-input"],
  rowsView: ["".concat(Yde), "".concat(Uq, "[tabindex]"), "".concat(eW, "[tabindex]"), "".concat(eW), "".concat(Gq, "[tabindex]"), "".concat(tW, "[tabindex]"), "".concat(tW)],
  footer: [".dx-datagrid-total-footer .dx-datagrid-summary-item", ".dx-treelist-total-footer .dx-treelist-summary-item"],
  filterPanel: [".dx-datagrid-filter-panel .dx-icon-filter", ".dx-treelist-filter-panel .dx-icon-filter"],
  pager: [".dx-datagrid-pager [tabindex]", ".dx-treelist-pager [tabindex]"]
}, uL = !1, AT = !1, dm = null;
function qde(t, e, i, r, n, a) {
  var o = Qde(e, i.originalEvent, a);
  if (!o) {
    var u = or(i);
    u === "enter" || u === "space" ? (Kq(i.target, e), r && r({
      event: i
    })) : u === "tab" ? n.addClass(iP) : eB(t, e, i);
  }
}
function Kq(t, e) {
  var i = E(t), r = i.attr("aria-label"), n = jq(r, e.element()), a = n.index(i);
  dm = P({}, {
    ariaLabel: r,
    index: a
  }, {
    viewInstance: e
  });
}
function jq(t, e) {
  var i = E(e), r;
  return t ? r = i.find('[aria-label="'.concat(t, '"][tabindex]')) : r = i.find("[tabindex]"), r;
}
function Xde(t, e) {
  var i = (e == null ? void 0 : e.getRootNode()) || de.getDocument();
  for (var r in t) {
    var n = t[r], a = E(i).find(n).first();
    if (a.length)
      return a;
  }
}
function Qde(t, e, i) {
  var r = {
    event: e,
    handled: !1
  };
  return i ? i(r) : t._createActionByOption("onKeyDown")(r), r.handled;
}
function Yq() {
  AT = de.getDocument().visibilityState === "visible";
}
function Zde() {
  k.on(de.getDocument(), "visibilitychange", Yq);
}
function rW() {
  k.off(de.getDocument(), "visibilitychange", Yq);
}
function Jde(t, e) {
  AT = !0, t.focus({
    preventScroll: e
  }), AT = !1;
}
function qq(t, e, i, r, n, a) {
  if (e.option("useLegacyKeyboardNavigation"))
    return ee;
  var o = () => E(e.element()), u = (v) => qde(t, e, v, n, o(), a), c = () => {
    uL = !0, o().removeClass(iP);
  }, p = () => {
    var v = !uL && !AT;
    v && o().addClass(iP), uL = !1;
  };
  return k.on(i, "keydown", r, u), k.on(i, "mousedown", r, c), k.on(i, "focusin", r, p), () => {
    k.off(i, "keydown", r, u), k.off(i, "mousedown", r, c), k.off(i, "focusin", r, p);
  };
}
function JF(t) {
  if (!t.option("useLegacyKeyboardNavigation") && dm) {
    var e = dm.viewInstance;
    if (e) {
      var i = jq(dm.ariaLabel, e.element()), r = i.eq(dm.index);
      dm = null, k.trigger(r, "focus");
    }
  }
}
function eB(t, e, i) {
  var r = or(i);
  if (i.ctrlKey && (r === "upArrow" || r === "downArrow"))
    for (var n = Object.keys(iW), a = n.indexOf(t); a >= 0 && a < n.length; ) {
      a = r === "upArrow" ? --a : ++a;
      var o = n[a], u = iW[o], c = Xde(u, i.target);
      if (c && c.length) {
        c.attr("tabindex", e.option("tabindex") || 0), k.trigger(c, "focus"), c.removeClass(jde);
        break;
      }
    }
}
function ece(t, e) {
  t.option("useLegacyKeyboardnavigation") || e.attr("tabindex", t.option("tabindex") || 0);
}
var fx = function(t, e, i, r, n) {
  var a = e.getController("keyboardNavigation");
  e.option("useLegacyKeyboardNavigation") || a && !a.isKeyboardEnabled() || (e.createAction("onKeyDown"), qq(t, e, i, r, n, (o) => {
    e.executeAction("onKeyDown", o);
  }));
}, Nh = (t) => {
  var e = t ?? Oi().rtlEnabled;
  return e ? "right" : "left";
}, zr = (t) => Or(t) ? {
  width: t.outerWidth,
  height: t.outerHeight
} : t.getBoundingClientRect(), Um = "dxdblclick", tce = "dxDblClick", nW = ve(di, tce), aW = 300, ice = wi.inherit({
  ctor() {
    this._handlerCount = 0, this._forgetLastClick();
  },
  _forgetLastClick() {
    this._firstClickTarget = null, this._lastClickTimeStamp = -aW;
  },
  add() {
    this._handlerCount <= 0 && k.on(de.getDocument(), nW, this._clickHandler.bind(this)), this._handlerCount += 1;
  },
  _clickHandler(t) {
    var e = t.timeStamp || Date.now(), i = e - this._lastClickTimeStamp, r = i < 0, n = !r && i < aW;
    n ? (Bh({
      type: Um,
      target: noe(this._firstClickTarget, t.target),
      originalEvent: t
    }), this._forgetLastClick()) : (this._firstClickTarget = t.target, this._lastClickTimeStamp = e);
  },
  remove() {
    this._handlerCount -= 1, this._handlerCount <= 0 && (this._forgetLastClick(), k.off(de.getDocument(), nW, void 0), this._handlerCount = 0);
  }
}), rce = new ice();
Ys(Um, rce);
var oW = "dx-column-indicators", nce = "dx-group-panel-item", ace = (t) => class extends t {
  _applyColumnState(e) {
    var i, r = this.option("rtlEnabled"), n = this._getColumnAlignment(e.column.alignment, r), a = P(!0, {
      columnAlignment: n
    }, e), o = a.rootElement.hasClass(nce), u = this._createIndicatorContainer(a, o), c = E("<span>").addClass(this._getIndicatorClassName(e.name)), p = (i = this.component) === null || i === void 0 ? void 0 : i.getController("columns"), v = (p == null ? void 0 : p.getHeaderContentAlignment(n)) || n;
    return a.container = u, a.indicator = c, this._renderIndicator(a), u[(o || !e.showColumnLines) && v === "left" ? "appendTo" : "prependTo"](e.rootElement), c;
  }
  _getIndicatorClassName(e) {
  }
  _getColumnAlignment(e, i) {
    return i = i || this.option("rtlEnabled"), e && e !== "center" ? e : Nh(i);
  }
  _createIndicatorContainer(e, i) {
    var r = this._getIndicatorContainer(e.rootElement), n = e.columnAlignment === "left" ? "right" : "left";
    return r.length || (r = E("<div>").addClass(oW)), this.setAria("role", "presentation", r), r.css("float", e.showColumnLines && !i ? n : null);
  }
  _getIndicatorContainer(e) {
    return e && e.find(".".concat(oW));
  }
  _getIndicatorElements(e) {
    var i = this._getIndicatorContainer(e);
    return i && i.children();
  }
  _renderIndicator(e) {
    var i = e.container, r = e.indicator;
    i && r && i.append(r);
  }
  _updateIndicators(e) {
    var i = this.getColumns(), r = this.getColumnElements(), n;
    if (!(!r || i.length !== r.length))
      for (var a = 0; a < i.length; a++) {
        n = r.eq(a), this._updateIndicator(n, i[a], e);
        var o = n.parent().data("options");
        o && o.cells && (o.cells[n.index()].column = i[a]);
      }
  }
  _updateIndicator(e, i, r) {
    if (!i.command)
      return this._applyColumnState({
        name: r,
        rootElement: e,
        column: i,
        showColumnLines: this.option("showColumnLines")
      });
  }
}, oce = function(t, e) {
  var i = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (i[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") {
    var n = 0;
    for (r = Object.getOwnPropertySymbols(t); n < r.length; n++)
      e.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[n]) && (i[r[n]] = t[r[n]]);
  }
  return i;
}, lh = {
  borderedTop: "dx-bordered-top-view",
  borderedBottom: "dx-bordered-bottom-view"
}, sce = (t) => {
  var {
    columnHeadersView: e,
    rowsView: i
  } = t;
  return e != null && e.isVisible() ? e.element() : i.element();
}, lce = (t) => {
  var {
    filterPanelView: e,
    footerView: i,
    rowsView: r
  } = t;
  return e != null && e.isVisible() ? e.element() : i != null && i.isVisible() ? i.element() : r.element();
}, sW = (t, e) => {
  var i, r = Object.values(t).find((n) => {
    var a;
    return (a = n == null ? void 0 : n.element()) === null || a === void 0 ? void 0 : a.hasClass(e);
  });
  return (i = r == null ? void 0 : r.element()) !== null && i !== void 0 ? i : null;
}, uce = (t, e) => {
  var i;
  if (!Object.keys(e).includes(t))
    return !1;
  var {
    rowsView: r
  } = e, n = oce(e, ["rowsView"]);
  return R((i = r == null ? void 0 : r.element) === null || i === void 0 ? void 0 : i.call(r)) ? Object.values(n).filter((a) => {
    var o;
    return (o = a == null ? void 0 : a.isVisible) === null || o === void 0 ? void 0 : o.call(a);
  }).every((a) => R(a == null ? void 0 : a.element())) : !1;
}, dce = (t, e) => {
  if (uce(t, e)) {
    var i = sW(e, lh.borderedTop), r = sW(e, lh.borderedBottom), n = sce(e), a = lce(e);
    i && !i.is(n) && i.removeClass(lh.borderedTop), r && !r.is(a) && r.removeClass(lh.borderedBottom), n.hasClass(lh.borderedTop) || n.addClass(lh.borderedTop), a.hasClass(lh.borderedBottom) || a.addClass(lh.borderedBottom);
  }
}, cce = "dxDataGrid";
class Xq {
  constructor(e) {
    var i = this;
    i._updateLockCount = 0, i.component = e, i._actions = {}, i._actionConfigs = {}, N(this.callbackNames() || [], function(r, n) {
      var a = i.callbackFlags(n) || {};
      a.unique = !0, a.syncStrategy = !0, i[this] = ui(a);
    });
  }
  _endUpdateCore() {
  }
  init() {
  }
  callbackNames() {
  }
  callbackFlags(e) {
  }
  publicMethods() {
    return [];
  }
  beginUpdate() {
    this._updateLockCount++;
  }
  endUpdate() {
    this._updateLockCount > 0 && (this._updateLockCount--, this._updateLockCount || this._endUpdateCore());
  }
  option(e) {
    var {
      component: i
    } = this, r = i._optionCache;
    return arguments.length === 1 && r ? (e in r || (r[e] = i.option(e)), r[e]) : i.option.apply(i, arguments);
  }
  _silentOption(e, i) {
    var {
      component: r
    } = this, n = r._optionCache;
    return n && (n[e] = i), r._setOptionWithoutOptionChange(e, i);
  }
  localize(e) {
    var i = this.component._optionCache;
    return i ? (e in i || (i[e] = X.format(e)), i[e]) : X.format(e);
  }
  on(e, i) {
    return this.component.on.apply(this.component, arguments);
  }
  off() {
    return this.component.off.apply(this.component, arguments);
  }
  optionChanged(e) {
    e.name in this._actions && (this.createAction(e.name, this._actionConfigs[e.name]), e.handled = !0);
  }
  getAction(e) {
    return this._actions[e];
  }
  setAria(e, i, r) {
    var n = r.get(0), a = e !== "role" && e !== "id" ? "aria-" : "";
    n.setAttribute ? n.setAttribute(a + e, i) : r.attr(a + e, i);
  }
  _createComponent(e, i, r) {
    return this.component._createComponent(e, i, r);
  }
  getController(e) {
    return this.component._controllers[e];
  }
  createAction(e, i) {
    if (Le(e)) {
      var r = this.component._createAction(e.bind(this), i);
      return function(n) {
        r({
          event: n
        });
      };
    }
    this._actions[e] = this.component._createActionByOption(e, i), this._actionConfigs[e] = i;
  }
  executeAction(e, i) {
    var r = this._actions[e];
    return r && r(i);
  }
  dispose() {
    var e = this;
    N(e.callbackNames() || [], function() {
      e[this].empty();
    });
  }
  addWidgetPrefix(e) {
    var i = this.component.NAME;
    return "dx-".concat(i.slice(2).toLowerCase()).concat(e ? "-".concat(e) : "");
  }
  getWidgetContainerClass() {
    var e = this.component.NAME === cce ? null : "container";
    return this.addWidgetPrefix(e);
  }
  elementIsInsideGrid(e) {
    var i = e.closest(".".concat(this.getWidgetContainerClass())).parent();
    return i.is(this.component.$element());
  }
}
class tB extends Xq {
}
class hce extends tB {
  getView(e) {
    return this.component._views[e];
  }
  getViews() {
    return this.component._views;
  }
}
class Qq extends Xq {
  constructor(e) {
    super(e), this.renderCompleted = ui(), this.resizeCompleted = ui();
  }
  _isReady() {
    return this.component.isReady();
  }
  _endUpdateCore() {
    super._endUpdateCore(), !this._isReady() && this._requireReady && (this._requireRender = !1, this.component._requireResize = !1), this._requireRender && (this._requireRender = !1, this.render(this._$parent));
  }
  _invalidate(e, i) {
    this._requireRender = !0, this.component._requireResize = wt() && (this.component._requireResize || e), this._requireReady = this._requireReady || i;
  }
  _renderCore(e) {
  }
  _resizeCore() {
  }
  _parentElement() {
    return this._$parent;
  }
  element() {
    return this._$element;
  }
  getElementHeight() {
    var e = this.element();
    if (!e)
      return 0;
    var i = parseFloat(e.css("marginTop")) || 0, r = parseFloat(e.css("marginBottom")) || 0, {
      offsetHeight: n
    } = e.get(0);
    return n + i + r;
  }
  isVisible() {
    return !0;
  }
  getTemplate(e) {
    return this.component._getTemplate(e);
  }
  getView(e) {
    return this.component._views[e];
  }
  _getBorderedViews() {
    return {
      columnHeadersView: this.component._views.columnHeadersView,
      rowsView: this.component._views.rowsView,
      filterPanelView: this.component._views.filterPanelView,
      footerView: this.component._views.footerView
    };
  }
  render(e, i) {
    var r = this._$element, n = this.isVisible();
    if (!(!r && !e) && (this._requireReady = !1, r || (r = this._$element = E("<div>").appendTo(e), this._$parent = e), r.toggleClass("dx-hidden", !n), this.component._views && dce(this.name, this._getBorderedViews()), n)) {
      this.component._optionCache = {};
      var a = this._renderCore(i);
      this.component._optionCache = void 0, a ? a.done(() => {
        this.renderCompleted.fire(i);
      }) : this.renderCompleted.fire(i);
    }
  }
  resize() {
    this.isResizing = !0, this._resizeCore(), this.resizeCompleted.fire(), this.isResizing = !1;
  }
  focus(e) {
    this.element().get(0).focus({
      preventScroll: e
    });
  }
}
var lW = 1e6;
function uW(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = {};
  return Object.entries(e).forEach((r) => {
    var [n, a] = r, o = t[n];
    if (o)
      if (Le(a))
        i[n] = a(o);
      else {
        var u = o;
        i[n] = u.inherit(a);
      }
  }), i;
}
function fce(t, e, i) {
  var r = i.publicMethods();
  r && N(r, (n, a) => {
    if (i[a])
      if (!t[a])
        t[a] = function() {
          return i[a](...arguments);
        };
      else
        throw Yt.Error("E1005", a);
    else
      throw Yt.Error("E1006", e, a);
  });
}
function pce(t, e) {
  var {
    modules: i
  } = e, {
    modulesOrder: r
  } = e;
  function n(v) {
    var _ = {};
    return N(v, (y, b) => {
      var I = new b(t);
      I.name = y, fce(t, y, I), _[y] = I;
    }), _;
  }
  r && i.sort((v, _) => {
    var y = r.indexOf(v.name), b = r.indexOf(_.name);
    return y < 0 && (y = lW), b < 0 && (b = lW), y - b;
  });
  var a = {}, o = {};
  i.forEach((v) => {
    var {
      name: _,
      controllers: y = {},
      views: b = {}
    } = v;
    Object.entries(y).forEach((I) => {
      var [A, L] = I;
      if (a[A])
        throw Yt.Error("E1001", _, A);
      if (!((L == null ? void 0 : L.prototype) instanceof tB))
        throw Yt.Error("E1002", _, A);
      a[A] = L;
    }), Object.entries(b).forEach((I) => {
      var [A, L] = I;
      if (o[A])
        throw Yt.Error("E1003", _, A);
      if (!((L == null ? void 0 : L.prototype) instanceof Qq))
        throw Yt.Error("E1004", _, A);
      o[A] = L;
    });
  });
  var u = i.filter((v) => {
    var {
      extenders: _
    } = v;
    return !!_;
  }), c = u.reduce((v, _) => {
    var {
      extenders: y
    } = _;
    return ae(ae({}, v), uW(v, y == null ? void 0 : y.controllers));
  }, a), p = u.reduce((v, _) => {
    var {
      extenders: y
    } = _;
    return ae(ae({}, v), uW(v, y == null ? void 0 : y.views));
  }, o);
  t._controllers = n(c), t._views = n(p);
}
var vce = function(t, e, i) {
  i = i || [], t._controllers && N(t._controllers, function() {
    this[e] && this[e].apply(this, i);
  }), t._views && N(t._views, function() {
    this[e] && this[e].apply(this, i);
  });
};
const Bi = {
  modules: [],
  View: Qq,
  ViewController: hce,
  Controller: tB,
  registerModule(t, e) {
    for (var {
      modules: i
    } = this, r = 0; r < i.length; r++)
      if (i[r].name === t)
        return;
    e.name = t, i.push(e);
  },
  registerModulesOrder(t) {
    this.modulesOrder = t;
  },
  unregisterModule(t) {
    this.modules = so(this.modules, (e) => e.name !== t);
  },
  processModules: pce,
  callModuleItemsMethod: vce
};
var gce = Vu.add, Zq = "DEVEXTREME_XHR_ERROR_UNLOAD", mce = function(t) {
  return [t[0], t.length < 3 ? "=" : String(t[1]).toLowerCase(), t.length < 2 ? !0 : t[t.length - 1]];
}, ic = function(t) {
  return Array.isArray(t) || (t = [t]), Jr(t, function(e) {
    var i = {
      selector: Le(e) || typeof e == "string" ? e : e.getter || e.field || e.selector,
      desc: !!(e.desc || String(e.dir).charAt(0).toLowerCase() === "d")
    };
    return e.compare && (i.compare = e.compare), i;
  });
}, _ce = function() {
  var t = {
    timeout: "Network connection timeout",
    error: "Unspecified network error",
    parsererror: "Unexpected server response"
  }, e;
  return gce(function() {
    var i = Ot();
    de.listen(i, "beforeunload", function() {
      e = !0;
    });
  }), function(i, r) {
    return e ? Zq : i.status < 400 ? function(n) {
      var a = t[n];
      return a || n;
    }(r) : i.statusText;
  };
}(), iB = {
  count: {
    seed: 0,
    step: function(t) {
      return 1 + t;
    }
  },
  sum: {
    seed: 0,
    step: function(t, e) {
      return t + e;
    }
  },
  min: {
    step: function(t, e) {
      return e < t ? e : t;
    }
  },
  max: {
    step: function(t, e) {
      return e > t ? e : t;
    }
  },
  avg: {
    seed: [0, 0],
    step: function(t, e) {
      return [t[0] + e, t[1] + 1];
    },
    finalize: function(t) {
      return t[1] ? t[0] / t[1] : NaN;
    }
  }
}, Cce = /* @__PURE__ */ function() {
  var t = 0, e;
  return {
    obtain: function() {
      t === 0 && (e = new q()), t++;
    },
    release: function() {
      t--, t < 1 && e.resolve();
    },
    promise: function() {
      var i = t === 0 ? new q().resolve() : e;
      return i.promise();
    },
    reset: function() {
      t = 0, e && e.resolve();
    }
  };
}();
function yce(t) {
  return /^(and|&&|&)$/i.test(t);
}
var pS = function(t, e, i) {
  if (Array.isArray(t)) {
    for (var r = Jr(e, function(o, u) {
      return u;
    }), n, a = 0; a < r.length; a++)
      if (n = r[a], !Mi(e[n], i[n], {
        strict: !1
      }))
        return !1;
    return !0;
  }
  return Mi(e, i, {
    strict: !1
  });
};
var xce = function(t) {
  return t[0] === "!" && Array.isArray(t[1]);
}, Sce = function(t) {
  return t === "and" || t === "or";
}, Ece = function(t) {
  var e = t[0], i = t[1];
  return !!(Array.isArray(e) || Le(e) && (Array.isArray(i) || Le(i) || Sce(i)));
}, Em = function() {
  var t = new q();
  return t.resolve.apply(t, arguments).promise();
}, Jq = function() {
  var t = new q();
  return t.reject.apply(t, arguments).promise();
};
function bce(t, e) {
  var i;
  return function() {
    return i || (i = setTimeout(() => {
      i = void 0, t.call(this);
    }, Le(e) ? e() : e)), i;
  };
}
function wce(t, e) {
  var i = [], r = bce(function() {
    t.call(this, i), i = [];
  }, e);
  return function(n) {
    return Array.isArray(n) && i.push(...n), r.call(this, i);
  };
}
var Zr = rF(bi.ERROR_MESSAGES, {
  E4000: "[DevExpress.data]: {0}",
  E4001: "Unknown aggregating function is detected: '{0}'",
  E4002: "Unsupported OData protocol version is used",
  E4003: "Unknown filter operation is used: {0}",
  E4004: "The thenby() method is called before the sortby() method",
  E4005: "Store requires a key expression for this operation",
  E4006: "ArrayStore 'data' option must be an array",
  E4007: "Compound keys cannot be auto-generated",
  E4008: "Attempt to insert an item with a duplicated key",
  E4009: "Data item cannot be found",
  E4010: "CustomStore does not support creating queries",
  E4011: "Custom Store method is not implemented or is not a function: {0}",
  E4012: "Custom Store method returns an invalid value: {0}",
  E4013: "Local Store requires the 'name' configuration option is specified",
  E4014: "Unknown data type is specified for ODataStore: {0}",
  E4015: "Unknown entity name or alias is used: {0}",
  E4016: "The compileSetter(expr) method is called with 'self' passed as a parameter",
  E4017: "Keys cannot be modified",
  E4018: "The server has returned a non-numeric value in a response to an item count request",
  E4019: "Mixing of group operators inside a single group of filter expression is not allowed",
  E4020: "Unknown store type is detected: {0}",
  E4021: "The server response does not provide the totalCount value",
  E4022: "The server response does not provide the groupCount value",
  E4023: "Could not parse the following XML: {0}",
  E4024: "String function {0} cannot be used with the data field {1} of type {2}.",
  W4000: "Data returned from the server has an incorrect structure",
  W4001: 'The {0} field is listed in both "keyType" and "fieldTypes". The value of "fieldTypes" is used.',
  W4002: "Data loading has failed for some cells due to the following error: {0}"
}), Tce = null, rB = function(t) {
  var e;
  (e = Tce) === null || e === void 0 || e(t);
};
function Ice(t, e) {
  for (var i, r = typeof e == "string" ? e.split() : e.slice(); r.length; )
    if (i = r.shift(), i in t)
      return !0;
  return !1;
}
function e6(t, e, i, r) {
  var n, a;
  if (r) {
    for (var o = 0; o < e.length; o++)
      if (n = e[o].items || e[o].collapsedItems || [], a = e6(t, n || [], i, r - 1), a)
        return a;
  } else if (Op(t, e, i) >= 0)
    return e;
}
function Dce(t, e, i, r) {
  return r ? e6(t, e, i, r) || [] : e;
}
function Ace(t, e) {
  if (t.key() && (!e._dataByKeyMap || e._dataByKeyMapLength !== e.length)) {
    for (var i = {}, r = e.length, n = 0; n < r; n++)
      i[JSON.stringify(t.keyOf(e[n]))] = e[n];
    e._dataByKeyMap = i, e._dataByKeyMapLength = r;
  }
}
function Oce(t, e) {
  if (t._dataByKeyMap)
    return t._dataByKeyMap[JSON.stringify(e)];
}
function Rce(t, e) {
  return t._dataByKeyMap ? t._dataByKeyMap[JSON.stringify(e)] : !0;
}
function t6(t, e, i) {
  t._dataByKeyMap && (t._dataByKeyMap[JSON.stringify(e)] = i, t._dataByKeyMapLength += i ? 1 : -1);
}
function i6(t, e, i) {
  i = i || /* @__PURE__ */ new WeakMap();
  var r = t ? Object.create(Object.getPrototypeOf(t)) : {};
  t && i.set(t, r);
  var n = ae({}, t);
  Hs(r, n, !0, !0);
  for (var a in n) {
    var o = n[a], u = e == null ? void 0 : e[a];
    ct(o) && !$t(o) && ct(u) && !i.has(o) && (r[a] = i6(o, u, i));
  }
  for (var c in r) {
    var p = r[c];
    ct(p) && i.has(p) && (r[c] = i.get(p));
  }
  return r;
}
function xh(t, e) {
  var i = i6(t, e);
  return Hs(i, e, !0, !0);
}
function xp(t) {
  var {
    keyInfo: e,
    data: i,
    changes: r,
    groupCount: n,
    useInsertIndex: a,
    immutable: o,
    disableCache: u,
    logError: c,
    skipCopying: p
  } = t, v = o === !0 ? [...i] : i;
  return r.forEach((_) => {
    var y = _.type === "insert" ? v : Dce(e, v, _.key, n);
    switch (!u && Ace(e, y), _.type) {
      case "update":
        nB(e, y, _.key, _.data, !0, o, c);
        break;
      case "insert":
        aB(e, y, _.data, a && R(_.index) ? _.index : -1, !0, c, p);
        break;
      case "remove":
        r6(e, y, _.key, !0, c);
    }
  }), v;
}
function OT(t, e, i) {
  return t ? e && Zr.log(i) : Jq(Zr.Error(i));
}
function nB(t, e, i, r, n, a, o) {
  var u, c = t.key();
  if (c) {
    if (Ice(r, c) && !pS(c, i, t.keyOf(r)))
      return OT(n, o, "E4017");
    if (u = Oce(e, i), !u) {
      var p = Op(t, e, i);
      if (p < 0)
        return OT(n, o, "E4009");
      if (u = e[p], a === !0 && R(u)) {
        var v = xh(u, r);
        return e[p] = v, !n && Em(v, i);
      }
    }
  } else
    u = i;
  if (Hs(u, r, !0), !n)
    return Oi().useLegacyStoreResult ? Em(i, r) : Em(u, i);
}
function aB(t, e, i, r, n, a, o) {
  var u, c = t.key(), p = $t(i) && !o ? P({}, i) : i;
  if (c) {
    if (u = t.keyOf(p), u === void 0 || typeof u == "object" && uo(u)) {
      if (Array.isArray(c))
        throw Zr.Error("E4007");
      u = p[c] = String(new yr());
    } else if (e[Op(t, e, u)] !== void 0)
      return OT(n, a, "E4008");
  } else
    u = p;
  if (r >= 0 ? e.splice(r, 0, p) : e.push(p), t6(e, u, p), !n)
    return Em(Oi().useLegacyStoreResult ? i : p, u);
}
function r6(t, e, i, r, n) {
  var a = Op(t, e, i);
  if (a > -1 && (e.splice(a, 1), t6(e, i, null)), r) {
    if (a < 0)
      return OT(r, n, "E4009");
  } else
    return Em(i);
}
function Op(t, e, i) {
  var r = t.key();
  if (!Rce(e, i))
    return -1;
  for (var n = 0, a = e.length; n < a; n++)
    if (pS(r, t.keyOf(e[n]), i))
      return n;
  return -1;
}
var vS = wi.inherit({
  toArray: function() {
    var t = [];
    for (this.reset(); this.next(); )
      t.push(this.current());
    return t;
  },
  countable: function() {
    return !1;
  }
}), oB = vS.inherit({
  ctor: function(t) {
    this.array = t, this.index = -1;
  },
  next: function() {
    return this.index + 1 < this.array.length ? (this.index++, !0) : !1;
  },
  current: function() {
    return this.array[this.index];
  },
  reset: function() {
    this.index = -1;
  },
  toArray: function() {
    return this.array.slice(0);
  },
  countable: function() {
    return !0;
  },
  count: function() {
    return this.array.length;
  }
}), CI = vS.inherit({
  ctor: function(t) {
    this.iter = t;
  },
  next: function() {
    return this.iter.next();
  },
  current: function() {
    return this.iter.current();
  },
  reset: function() {
    return this.iter.reset();
  }
}), dL = CI.inherit({
  ctor: function(t, e) {
    this.callBase(t), this.index = -1, this.mapper = e;
  },
  current: function() {
    return this.mapper(this.callBase(), this.index);
  },
  next: function() {
    var t = this.callBase();
    return t && this.index++, t;
  }
}), Lce = function(t, e, i) {
  return ht(t) && ht(e) && (i != null && i.locale || i != null && i.collatorOptions) ? new Intl.Collator((i == null ? void 0 : i.locale) || void 0, (i == null ? void 0 : i.collatorOptions) || void 0).compare(t, e) : (t = ta(t, !1, i), e = ta(e, !1, i), t === null && e !== null ? -1 : t !== null && e === null || t === void 0 && e !== void 0 ? 1 : t !== void 0 && e === void 0 || t < e ? -1 : t > e ? 1 : 0);
}, rP = vS.inherit({
  ctor: function(t, e, i, r) {
    this.langParams = t.langParams, t instanceof dL || (t = new dL(t, this._wrap), t.langParams = this.langParams), this.iter = t, this.rules = [{
      getter: e,
      desc: i,
      compare: r,
      langParams: this.langParams
    }];
  },
  thenBy: function(t, e, i) {
    var r = new rP(this.sortedIter || this.iter, t, e, i);
    return this.sortedIter || (r.rules = this.rules.concat(r.rules)), r;
  },
  next: function() {
    return this._ensureSorted(), this.sortedIter.next();
  },
  current: function() {
    return this._ensureSorted(), this.sortedIter.current();
  },
  reset: function() {
    delete this.sortedIter;
  },
  countable: function() {
    return this.sortedIter || this.iter.countable();
  },
  count: function() {
    return this.sortedIter ? this.sortedIter.count() : this.iter.count();
  },
  _ensureSorted: function() {
    var t = this;
    t.sortedIter || (N(t.rules, function() {
      this.getter = Ii(this.getter);
    }), t.sortedIter = new dL(new oB(this.iter.toArray().sort(function(e, i) {
      return t._compare(e, i);
    })), t._unwrap));
  },
  _wrap: function(t, e) {
    return {
      index: e,
      value: t
    };
  },
  _unwrap: function(t) {
    return t.value;
  },
  _getDefaultCompare: (t) => (e, i) => Lce(e, i, t),
  _compare: function(t, e) {
    var i = t.index, r = e.index;
    if (t = t.value, e = e.value, t === e)
      return i - r;
    for (var n = 0, a = this.rules.length; n < a; n++) {
      var o = this.rules[n], u = o.getter(t), c = o.getter(e), p = o.compare || this._getDefaultCompare(o.langParams), v = p(u, c);
      if (v)
        return o.desc ? -v : v;
    }
    return i - r;
  }
}), nP = /* @__PURE__ */ function() {
  var t = {}, e = (n) => ta(n, !1, t), i = function(n) {
    var a;
    return R(n) ? (a = t) !== null && a !== void 0 && a.locale ? n.toLocaleString(t.locale) : n.toString() : "";
  };
  function r(n, a, o) {
    return function(u) {
      u = e(n(u));
      var c = /* @__PURE__ */ function(p) {
        return p === "" || p === 0 || p === !1;
      }(a) ? u === a : u == a;
      return o && (c = !c), c;
    };
  }
  return function(n, a) {
    return t = a || {}, Le(n) ? n : Ece(n) ? function(o) {
      var u = [], c = !1, p = !1;
      return N(o, function() {
        if (Array.isArray(this) || Le(this)) {
          if (u.length > 1 && c !== p)
            throw new Zr.Error("E4019");
          u.push(nP(this, t)), c = p, p = !0;
        } else
          p = yce(this);
      }), function(v) {
        for (var _ = c, y = 0; y < u.length; y++)
          if (u[y](v) !== c) {
            _ = !c;
            break;
          }
        return _;
      };
    }(n) : xce(n) ? function(o) {
      var u = o[0], c = nP(o[1], t);
      if (u === "!")
        return function(p) {
          return !c(p);
        };
      throw Zr.Error("E4003", u);
    }(n) : function(o) {
      o = mce(o);
      var u = Ii(o[0]), c = o[1], p = o[2];
      p = e(p);
      var v = (_, y) => (_ = e(u(_)), (p == null || _ == null) && p !== _ ? !1 : y(_, p));
      switch (c.toLowerCase()) {
        case "=":
          return r(u, p);
        case "<>":
          return r(u, p, !0);
        case ">":
          return (_) => v(_, (y, b) => y > b);
        case "<":
          return (_) => v(_, (y, b) => y < b);
        case ">=":
          return (_) => v(_, (y, b) => y >= b);
        case "<=":
          return (_) => v(_, (y, b) => y <= b);
        case "startswith":
          return function(_) {
            return e(i(u(_))).indexOf(p) === 0;
          };
        case "endswith":
          return function(_) {
            var y = e(i(u(_))), b = i(p);
            if (y.length < b.length)
              return !1;
            var I = y.lastIndexOf(p);
            return I !== -1 && I === y.length - p.length;
          };
        case "contains":
          return function(_) {
            return e(i(u(_))).indexOf(p) > -1;
          };
        case "notcontains":
          return function(_) {
            return e(i(u(_))).indexOf(p) === -1;
          };
      }
      throw Zr.Error("E4003", c);
    }(n);
  };
}(), Mce = CI.inherit({
  ctor: function(t, e) {
    this.callBase(t), this.langParams = t.langParams, this.criteria = nP(e, this.langParams);
  },
  next: function() {
    for (; this.iter.next(); )
      if (this.criteria(this.current()))
        return !0;
    return !1;
  }
}), kce = vS.inherit({
  ctor: function(t, e) {
    this.iter = t, this.getter = e;
  },
  next: function() {
    return this._ensureGrouped(), this.groupedIter.next();
  },
  current: function() {
    return this._ensureGrouped(), this.groupedIter.current();
  },
  reset: function() {
    delete this.groupedIter;
  },
  countable: function() {
    return !!this.groupedIter;
  },
  count: function() {
    return this.groupedIter.count();
  },
  _ensureGrouped: function() {
    if (!this.groupedIter) {
      var t = {}, e = [], i = this.iter, r = Ii(this.getter);
      for (i.reset(); i.next(); ) {
        var n = i.current(), a = r(n);
        a in t ? t[a].push(n) : (t[a] = [n], e.push(a));
      }
      this.groupedIter = new oB(Jr(e, function(o) {
        return {
          key: o,
          items: t[o]
        };
      }));
    }
  }
}), Pce = CI.inherit({
  ctor: function(t, e) {
    this.callBase(t), this.getter = Ii(e);
  },
  current: function() {
    return this.getter(this.callBase());
  },
  countable: function() {
    return this.iter.countable();
  },
  count: function() {
    return this.iter.count();
  }
}), Fce = CI.inherit({
  ctor: function(t, e, i) {
    this.callBase(t), this.skip = Math.max(0, e), this.take = Math.max(0, i), this.pos = 0;
  },
  next: function() {
    if (this.pos >= this.skip + this.take)
      return !1;
    for (; this.pos < this.skip && this.iter.next(); )
      this.pos++;
    return this.pos++, this.iter.next();
  },
  reset: function() {
    this.callBase(), this.pos = 0;
  },
  countable: function() {
    return this.iter.countable();
  },
  count: function() {
    return Math.min(this.iter.count() - this.skip, this.take);
  }
}), yI = function t(e, i) {
  i = i || {}, e instanceof vS || (e = new oB(e)), i.langParams && (e.langParams = i.langParams);
  var r = function(p) {
    var v = i.errorHandler;
    v && v(p), rB(p);
  }, n = function(p) {
    var v = new q().fail(r), _, y = p.step, b = p.finalize;
    try {
      e.reset(), "seed" in p ? _ = p.seed : _ = e.next() ? e.current() : NaN;
      for (var I = _; e.next(); )
        I = y(I, e.current());
      v.resolve(b ? b(I) : I);
    } catch (A) {
      v.reject(A);
    }
    return v.promise();
  }, a = function(p) {
    return n(iB[p]);
  }, o = function(p) {
    return !Le(p) && !Array.isArray(p) && (p = [].slice.call(arguments)), c(new Pce(e, p));
  }, u = function(p) {
    return o(Ii(p));
  };
  function c(p) {
    return t(p, i);
  }
  return {
    toArray: function() {
      return e.toArray();
    },
    enumerate: function() {
      var p = new q().fail(r);
      try {
        p.resolve(e.toArray());
      } catch (v) {
        p.reject(v);
      }
      return p.promise();
    },
    setLangParams(p) {
      e.langParams = p;
    },
    sortBy: function(p, v, _) {
      return c(new rP(e, p, v, _));
    },
    thenBy: function(p, v, _) {
      if (e instanceof rP)
        return c(e.thenBy(p, v, _));
      throw Zr.Error("E4004");
    },
    filter: function(p) {
      return Array.isArray(p) || (p = [].slice.call(arguments)), c(new Mce(e, p));
    },
    slice: function(p, v) {
      return v === void 0 && (v = Number.MAX_VALUE), c(new Fce(e, p, v));
    },
    select: o,
    groupBy: function(p) {
      return c(new kce(e, p));
    },
    aggregate: function(p, v, _) {
      return arguments.length < 2 ? n({
        step: arguments[0]
      }) : n({
        seed: p,
        step: v,
        finalize: _
      });
    },
    count: function() {
      if (e.countable()) {
        var p = new q().fail(r);
        try {
          p.resolve(e.count());
        } catch (v) {
          p.reject(v);
        }
        return p.promise();
      }
      return a("count");
    },
    sum: function(p) {
      return p ? u(p).sum() : a("sum");
    },
    min: function(p) {
      return p ? u(p).min() : a("min");
    },
    max: function(p) {
      return p ? u(p).max() : a("max");
    },
    avg: function(p) {
      return p ? u(p).avg() : a("avg");
    }
  };
};
function sB(t, e) {
  return t = t.groupBy(e[0].selector), e.length > 1 && (t = t.select(function(i) {
    return P({}, i, {
      items: sB(yI(i.items), e.slice(1)).toArray()
    });
  })), t;
}
function n6(t, e) {
  var i = [];
  return N(t, function(r, n) {
    var a = so(e, function(o) {
      return n.selector === o.selector;
    });
    a.length < 1 && i.push(n);
  }), i.concat(e);
}
function Bce(t, e, i) {
  var r;
  e = e || {};
  var n = e.filter;
  if ((r = e) !== null && r !== void 0 && r.langParams) {
    var a, o;
    (a = (o = t).setLangParams) === null || a === void 0 || a.call(o, e.langParams);
  }
  if (n && (t = t.filter(n)), i)
    return t;
  var u = e.sort, c = e.select, p = e.group, v = e.skip, _ = e.take;
  return p && (p = ic(p), p.keepInitialKeyOrder = !!e.group.keepInitialKeyOrder), (u || p) && (u = ic(u || []), p && !p.keepInitialKeyOrder && (u = n6(p, u)), N(u, function(y) {
    t = t[y ? "thenBy" : "sortBy"](this.selector, this.desc, this.compare);
  })), c && (t = t.select(c)), p && (t = sB(t, p)), (_ || v) && (t = t.slice(v || 0, _)), t;
}
const rc = {
  multiLevelGroup: sB,
  arrangeSortingInfo: n6,
  queryByOptions: Bce
};
var Cy = wi.abstract, dW = rc.queryByOptions, aP = {}, Ou = wi.inherit({
  _langParams: {},
  ctor: function(t) {
    var e = this;
    t = t || {}, this._eventsStrategy = new Hp(this), N(["onLoaded", "onLoading", "onInserted", "onInserting", "onUpdated", "onUpdating", "onPush", "onRemoved", "onRemoving", "onModified", "onModifying"], function(i, r) {
      r in t && e.on(r.slice(2).toLowerCase(), t[r]);
    }), this._key = t.key, this._errorHandler = t.errorHandler, this._useDefaultSearch = !0;
  },
  _clearCache: ee,
  _customLoadOptions: function() {
    return null;
  },
  key: function() {
    return this._key;
  },
  keyOf: function(t) {
    return this._keyGetter || (this._keyGetter = Ii(this.key())), this._keyGetter(t);
  },
  _requireKey: function() {
    if (!this.key())
      throw Zr.Error("E4005");
  },
  load: function(t) {
    var e = this;
    return t = t || {}, this._eventsStrategy.fireEvent("loading", [t]), this._withLock(this._loadImpl(t)).done(function(i) {
      e._eventsStrategy.fireEvent("loaded", [i, t]);
    });
  },
  _loadImpl: function(t) {
    return uo(this._langParams) || (t = t || {}, t._langParams = ae({}, this._langParams, t._langParams)), dW(this.createQuery(t), t).enumerate();
  },
  _withLock: function(t) {
    var e = new q();
    return t.done(function() {
      var i = this, r = arguments;
      Cce.promise().done(function() {
        e.resolveWith(i, r);
      });
    }).fail(function() {
      e.rejectWith(this, arguments);
    }), e;
  },
  createQuery: Cy,
  totalCount: function(t) {
    return this._totalCountImpl(t);
  },
  _totalCountImpl: function(t) {
    return dW(this.createQuery(t), t, !0).count();
  },
  byKey: function(t, e) {
    return this._addFailHandlers(this._withLock(this._byKeyImpl(t, e)));
  },
  _byKeyImpl: Cy,
  insert: function(t) {
    var e = this;
    return e._eventsStrategy.fireEvent("modifying"), e._eventsStrategy.fireEvent("inserting", [t]), e._addFailHandlers(e._insertImpl(t).done(function(i, r) {
      e._eventsStrategy.fireEvent("inserted", [i, r]), e._eventsStrategy.fireEvent("modified");
    }));
  },
  _insertImpl: Cy,
  update: function(t, e) {
    var i = this;
    return i._eventsStrategy.fireEvent("modifying"), i._eventsStrategy.fireEvent("updating", [t, e]), i._addFailHandlers(i._updateImpl(t, e).done(function() {
      i._eventsStrategy.fireEvent("updated", [t, e]), i._eventsStrategy.fireEvent("modified");
    }));
  },
  _updateImpl: Cy,
  push: function(t) {
    var e = {
      changes: t,
      waitFor: []
    };
    this._eventsStrategy.fireEvent("beforePushAggregation", [e]), $e(...e.waitFor).done(() => {
      this._pushImpl(t), this._eventsStrategy.fireEvent("beforePush", [{
        changes: t
      }]), this._eventsStrategy.fireEvent("push", [t]);
    });
  },
  _pushImpl: ee,
  remove: function(t) {
    var e = this;
    return e._eventsStrategy.fireEvent("modifying"), e._eventsStrategy.fireEvent("removing", [t]), e._addFailHandlers(e._removeImpl(t).done(function(i) {
      e._eventsStrategy.fireEvent("removed", [i]), e._eventsStrategy.fireEvent("modified");
    }));
  },
  _removeImpl: Cy,
  _addFailHandlers: function(t) {
    return t.fail(this._errorHandler).fail(rB);
  },
  on(t, e) {
    return this._eventsStrategy.on(t, e), this;
  },
  off(t, e) {
    return this._eventsStrategy.off(t, e), this;
  }
});
Ou.create = function(t, e) {
  if (!(t in aP))
    throw Zr.Error("E4020", t);
  return new aP[t](e);
};
Ou.registerClass = function(t, e) {
  return e && (aP[e] = t), t;
};
Ou.inherit = /* @__PURE__ */ function(t) {
  return function(e, i) {
    var r = t.apply(this, [e]);
    return Ou.registerClass(r, i), r;
  };
}(Ou.inherit);
var a6 = "totalCount", oP = "load", o6 = "byKey", cW = "insert", hW = "update", fW = "remove";
function bm(t) {
  return t && Le(t.then);
}
function Sp(t) {
  return new q().resolve(t).promise();
}
function px(t, e) {
  if (!Le(e))
    throw Zr.Error("E4011", t);
}
function s6(t) {
  throw Zr.Error("E4012", t);
}
function ap(t) {
  function e(i) {
    var r = i[0], n = i[1];
    return !r || !r.getResponseHeader ? null : _ce(r, n);
  }
  return function(i) {
    var r;
    i instanceof Error ? r = i : r = new Error(e(arguments) || i && String(i) || "Unknown error"), r.message !== Zq && t.reject(r);
  };
}
function l6(t, e) {
  var i = t._loadFunc, r;
  return px(oP, i), r = i.apply(t, [e]), Array.isArray(r) ? r = Sp(r) : r == null ? r = Sp([]) : bm(r) || s6(oP), Pn(r);
}
function Vce(t, e) {
  var i = t._totalCountFunc, r;
  if (!Le(i))
    throw Zr.Error("E4021");
  return r = i.apply(t, [e]), bm(r) || (r = Number(r), isFinite(r) || s6(a6), r = Sp(r)), Pn(r);
}
function Nce(t, e, i) {
  var r = t._byKeyFunc, n;
  return px(o6, r), n = r.apply(t, [e, i]), bm(n) || (n = Sp(n)), Pn(n);
}
function u6(t, e, i, r) {
  if (e.__rawData)
    r(e.__rawData);
  else {
    var n = e.__rawDataPromise || l6(e, i);
    e._cacheRawData && (e.__rawDataPromise = n), n.always(function() {
      delete e.__rawDataPromise;
    }).done(function(a) {
      e._cacheRawData && (e.__rawData = a), r(a);
    }).fail(ap(t));
  }
}
function pW(t, e, i, r) {
  i = i || {};
  var n = {};
  "userData" in i && (n.userData = i.userData), u6(t, e, n, function(a) {
    var o = yI(a, {
      errorHandler: e._errorHandler
    }), u, c, p = [], v, _;
    r || (u = rc.queryByOptions(o, i), u === o ? v = a.slice(0) : p.push(u.enumerate().done(function(y) {
      v = y;
    }))), (i.requireTotalCount || r) && (c = rc.queryByOptions(o, i, !0), c === o ? _ = a.length : p.push(c.count().done(function(y) {
      _ = y;
    }))), $e.apply(E, p).done(function() {
      r ? t.resolve(_) : i.requireTotalCount ? t.resolve(v, {
        totalCount: _
      }) : t.resolve(v);
    }).fail(function(y) {
      t.reject(y);
    });
  });
}
function Hce(t, e, i) {
  u6(t, e, {}, function(r) {
    for (var n = e.key(), a, o = 0, u = r.length; o < u; o++)
      if (a = r[o], pS(n, e.keyOf(r[o]), i)) {
        t.resolve(a);
        return;
      }
    t.reject(Zr.Error("E4009"));
  });
}
var gS = Ou.inherit({
  ctor: function(t) {
    t = t || {}, this.callBase(t), this._useDefaultSearch = !!t.useDefaultSearch || t.loadMode === "raw", this._loadMode = t.loadMode, this._cacheRawData = t.cacheRawData !== !1, this._loadFunc = t[oP], this._totalCountFunc = t[a6], this._byKeyFunc = t[o6], this._insertFunc = t[cW], this._updateFunc = t[hW], this._removeFunc = t[fW];
  },
  _clearCache() {
    delete this.__rawData;
  },
  createQuery: function() {
    throw Zr.Error("E4010");
  },
  clearRawDataCache: function() {
    this._clearCache();
  },
  _totalCountImpl: function(t) {
    var e = new q();
    return this._loadMode === "raw" && !this._totalCountFunc ? pW(e, this, t, !0) : (Vce(this, t).done(function(i) {
      e.resolve(Number(i));
    }).fail(ap(e)), e = this._addFailHandlers(e)), e.promise();
  },
  _pushImpl: function(t) {
    this.__rawData && xp({
      keyInfo: this,
      data: this.__rawData,
      changes: t
    });
  },
  _loadImpl: function(t) {
    var e = new q();
    return this._loadMode === "raw" ? pW(e, this, t, !1) : (l6(this, t).done(function(i, r) {
      e.resolve(i, r);
    }).fail(ap(e)), e = this._addFailHandlers(e)), e.promise();
  },
  _byKeyImpl: function(t, e) {
    var i = new q();
    return this._byKeyViaLoad() ? (this._requireKey(), Hce(i, this, t)) : Nce(this, t, e).done(function(r) {
      i.resolve(r);
    }).fail(ap(i)), i.promise();
  },
  _byKeyViaLoad: function() {
    return this._loadMode === "raw" && !this._byKeyFunc;
  },
  _insertImpl: function(t) {
    var e = this, i = e._insertFunc, r, n = new q();
    return px(cW, i), r = i.apply(e, [t]), bm(r) || (r = Sp(r)), Pn(r).done(function(a) {
      Oi().useLegacyStoreResult ? n.resolve(t, a) : n.resolve(a || t, e.keyOf(a));
    }).fail(ap(n)), n.promise();
  },
  _updateImpl: function(t, e) {
    var i = this._updateFunc, r, n = new q();
    return px(hW, i), r = i.apply(this, [t, e]), bm(r) || (r = Sp(r)), Pn(r).done(function(a) {
      Oi().useLegacyStoreResult ? n.resolve(t, e) : n.resolve(a || e, t);
    }).fail(ap(n)), n.promise();
  },
  _removeImpl: function(t) {
    var e = this._removeFunc, i, r = new q();
    return px(fW, e), i = e.apply(this, [t]), bm(i) || (i = Sp()), Pn(i).done(function() {
      r.resolve(t);
    }).fail(ap(r)), r.promise();
  }
});
function d6(t) {
  var e = [], i = !1;
  function r() {
    for (; e.length; ) {
      i = !0;
      var n = e.shift(), a = n();
      if (a !== void 0) {
        if (a.then) {
          $e(a).always(r);
          return;
        }
        throw bi.Error("E0015");
      }
    }
    i = !1;
  }
  return {
    add: function(n, a) {
      t ? (e[0] && a && a(e[0]), e = [n]) : e.push(n), i || r();
    },
    busy: function() {
      return i;
    }
  };
}
var RVe = d6().add, $ce = Ot(), zce = {
  getXhr: function() {
    return new $ce.XMLHttpRequest();
  }
};
const Wce = js(zce);
var lB = Ot(), vx = "success", cL = "error", Uce = "timeout", Gce = "nocontent", Kce = "parsererror", jce = function(t) {
  return 200 <= t && t < 300;
}, Yce = function(t) {
  return t !== 204;
}, qce = function(t) {
  var e = [];
  for (var i in t) {
    var r = t[i];
    r !== void 0 && (r === null && (r = ""), typeof r == "function" && (r = r()), e.push(encodeURIComponent(i) + "=" + encodeURIComponent(r)));
  }
  return e.join("&");
}, c6 = function(t) {
  var e = de.createElement("script");
  for (var i in t)
    e[i] = t[i];
  return e;
}, h6 = function(t) {
  t.parentNode.removeChild(t);
}, f6 = function(t) {
  return de.getHead().appendChild(t);
}, vW = function(t) {
  var e = c6({
    text: t
  });
  f6(e), h6(e);
}, Xce = function(t) {
  var e = c6({
    src: t
  });
  return new Promise(function(i, r) {
    var n = {
      load: i,
      error: r
    }, a = function(u) {
      n[u.type](), h6(e);
    };
    for (var o in n)
      de.listen(e, o, a);
    f6(e);
  });
}, Qce = function(t) {
  var e = t.dataType || "*", i = "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript", r = {
    "*": "*/*",
    text: "text/plain",
    html: "text/html",
    xml: "application/xml, text/xml",
    json: "application/json, text/javascript",
    jsonp: i,
    script: i
  };
  return Jte(r, t.accepts, !0), r[e] ? r[e] + (e !== "*" ? ", */*; q=0.01" : "") : r["*"];
}, Zce = function(t) {
  var e;
  return t.data && !t.upload && uB(t) !== "GET" && (e = "application/x-www-form-urlencoded;charset=utf-8"), t.contentType || e;
}, Jce = function(t) {
  return t.responseType && t.responseType !== "text" || typeof t.responseText != "string" ? t.response : t.responseText;
}, ehe = function(t, e, i) {
  var r = Jce(e);
  switch (i) {
    case "jsonp":
      vW(r);
      break;
    case "script":
      vW(r), t.resolve(r, vx, e);
      break;
    case "json":
      try {
        t.resolve(JSON.parse(r), vx, e);
      } catch (n) {
        t.reject(e, Kce, n);
      }
      break;
    default:
      t.resolve(r, vx, e);
  }
}, the = function(t) {
  if (!wt())
    return !0;
  var e = !1, i = de.createElement("a"), r = de.createElement("a");
  i.href = lB.location.href;
  try {
    r.href = t, r.href = r.href, e = i.protocol + "//" + i.host != r.protocol + "//" + r.host;
  } catch {
    e = !0;
  }
  return e;
}, ihe = function(t, e) {
  return t && setTimeout(function() {
    e.customStatus = Uce, e.abort();
  }, t);
}, rhe = function(t) {
  if (t.dataType === "jsonp") {
    var e = Math.random().toString().replace(/\D/g, ""), i = t.jsonpCallback || "dxCallback" + Date.now() + "_" + e, r = t.jsonp || "callback";
    return t.data = t.data || {}, t.data[r] = i, i;
  }
}, nhe = function(t, e) {
  var i = t.data, r = typeof i == "string", n = t.url || lB.location.href;
  return !r && !t.cache && (i = i || {}, i._ = Date.now()), i && !t.upload && (r || (i = qce(i)), uB(t) === "GET" ? (i !== "" && (n += (n.indexOf("?") > -1 ? "&" : "?") + i), i = null) : e["Content-Type"] && e["Content-Type"].indexOf("application/x-www-form-urlencoded") > -1 && (i = i.replace(/%20/g, "+"))), {
    url: n,
    parameters: i
  };
};
function uB(t) {
  return (t.method || "GET").toUpperCase();
}
var ahe = function(t) {
  var e = t.headers || {};
  return e["Content-Type"] = e["Content-Type"] || Zce(t), e.Accept = e.Accept || Qce(t), !t.crossDomain && !e["X-Requested-With"] && (e["X-Requested-With"] = "XMLHttpRequest"), e;
}, ohe = function(t) {
  var e = Wce.getXhr(), i = new q(), r = i.promise(), n = R(t.async) ? t.async : !0, a = t.dataType, o = t.timeout || 0, u;
  t.crossDomain = the(t.url);
  var c = a === "jsonp" || a === "script";
  t.cache === void 0 && (t.cache = !c);
  var p = rhe(t), v = ahe(t), _ = nhe(t, v), y = _.url, b = _.parameters;
  if (p && (lB[p] = function(L) {
    i.resolve(L, vx, e);
  }), t.crossDomain && c)
    return Xce(y).then(function() {
      a !== "jsonp" && i.resolve(null, vx, e);
    }, function() {
      i.reject(e, cL);
    }), r;
  if (t.crossDomain && !("withCredentials" in e))
    return i.reject(e, cL), r;
  if (e.open(uB(t), y, n, t.username, t.password), n && (e.timeout = o, u = ihe(o, e)), e.onreadystatechange = function(L) {
    e.readyState === 4 && (clearTimeout(u), jce(e.status) ? Yce(e.status) ? ehe(i, e, a) : i.resolve(null, Gce, e) : i.reject(e, e.customStatus || cL));
  }, t.upload && (e.upload.onprogress = t.upload.onprogress, e.upload.onloadstart = t.upload.onloadstart, e.upload.onabort = t.upload.onabort), t.xhrFields)
    for (var I in t.xhrFields)
      e[I] = t.xhrFields[I];
  t.responseType === "arraybuffer" && (e.responseType = t.responseType);
  for (var A in v)
    Object.prototype.hasOwnProperty.call(v, A) && R(v[A]) && e.setRequestHeader(A, v[A]);
  return t.beforeSend && t.beforeSend(e), e.send(b), r.abort = function() {
    e.abort();
  }, r;
};
const she = js({
  sendRequest: ohe
}), lhe = {};
var uhe = function t(e, i, r) {
  r = r || [], i = i || {};
  var n = function(u, c) {
    return {
      name: u,
      args: c
    };
  }, a = function(u) {
    var c = new q(), p, v, _, y, b, I = function(B) {
      var $ = i.errorHandler;
      $ && $(B), rB(B), c.reject(B);
    };
    function A(B) {
      switch (B.name) {
        case "sortBy":
          return b = [B.args], !0;
        case "thenBy":
          if (!b)
            throw Zr.Error("E4004");
          return b.push(B.args), !0;
      }
      return !1;
    }
    try {
      p = i.adapter, Le(p) || (p = lhe[p]), v = p(i), _ = [].concat(r).concat(u);
      var L = v.optimize;
      for (L && L(_); _.length; ) {
        if (y = _[0], !A(y)) {
          if (b) {
            _.unshift(n("multiSort", [b])), b = null;
            continue;
          }
          if (String(y.name) !== "enumerate" && (!v[y.name] || v[y.name].apply(v, y.args) === !1))
            break;
        }
        _.shift();
      }
      (function() {
        var B = _[0], $ = [];
        B && B.name === "multiSort" && (_.shift(), N(B.args[0], function() {
          $.push(n($.length ? "thenBy" : "sortBy", this));
        })), _ = $.concat(_);
      })(), v.exec(e).done(function(B, $) {
        if (!_.length)
          c.resolve(B, $);
        else {
          var K = yI(B, {
            errorHandler: i.errorHandler
          });
          N(_, function() {
            K = K[this.name].apply(K, this.args);
          }), K.done(c.resolve).fail(c.reject);
        }
      }).fail(I);
    } catch (B) {
      I(B);
    }
    return c.promise();
  }, o = {};
  return N(["sortBy", "thenBy", "filter", "slice", "select", "groupBy"], function() {
    var u = String(this);
    o[u] = function() {
      return t(e, i, r.concat(n(u, arguments)));
    };
  }), N(["count", "min", "max", "sum", "avg", "aggregate", "enumerate"], function() {
    var u = String(this);
    o[u] = function() {
      return a.call(this, n(u, arguments));
    };
  }), o;
}, dhe = {
  array: yI,
  remote: uhe
}, lo = function() {
  var t = Array.isArray(arguments[0]) ? "array" : "remote";
  return dhe[t].apply(this, arguments);
}, mS = Ou.inherit({
  ctor: function(t) {
    Array.isArray(t) ? t = {
      data: t
    } : t = t || {}, this.callBase(t);
    var e = t.data;
    if (e && !Array.isArray(e))
      throw Zr.Error("E4006");
    this._array = e || [];
  },
  createQuery: function() {
    return lo(this._array, {
      errorHandler: this._errorHandler
    });
  },
  _byKeyImpl: function(t) {
    var e = Op(this, this._array, t);
    return e === -1 ? Jq(Zr.Error("E4009")) : Em(this._array[e]);
  },
  _insertImpl: function(t) {
    return aB(this, this._array, t);
  },
  _pushImpl: function(t) {
    xp({
      keyInfo: this,
      data: this._array,
      changes: t
    });
  },
  _updateImpl: function(t, e) {
    return nB(this, this._array, t, e);
  },
  _removeImpl: function(t) {
    return r6(this, this._array, t);
  },
  clear: function() {
    this._eventsStrategy.fireEvent("modifying"), this._array = [], this._eventsStrategy.fireEvent("modified");
  }
}, "array"), che = ["items"], p6 = "canceled", gW = (t) => t.state() === "pending", mW = (t) => {
  switch (t.length) {
    case 0:
      return;
    case 1:
      return t[0];
  }
  return [].slice.call(t);
}, hhe = (t, e, i) => Jr(t, (r) => {
  var n = sr(r, che);
  return ae({}, n, {
    items: v6(r.items, e - 1, i)
  });
}), v6 = (t, e, i) => Array.isArray(t) ? e ? hhe(t, e, i) : Jr(t, i) : t, fhe = (t, e, i) => {
  var r = i ? ic(i).length : 0;
  return v6(t, r, e);
}, g6 = (t, e) => {
  var i;
  return (i = t) !== null && i !== void 0 && i.data && (e = t, t = t.data), Array.isArray(t) || (t = [t]), {
    data: t,
    extra: e
  };
}, phe = (t) => {
  var e = {};
  return N(["useDefaultSearch", "key", "load", "loadMode", "cacheRawData", "byKey", "lookup", "totalCount", "insert", "update", "remove"], function() {
    e[this] = t[this], delete t[this];
  }), new gS(e);
}, vhe = (t) => {
  var e = t.type;
  return delete t.type, Ou.create(e, t);
}, ghe = (t, e) => new gS({
  load: () => she.sendRequest({
    url: t,
    dataType: "json"
  }),
  loadMode: e == null ? void 0 : e.fromUrlLoadMode
}), zp = (t, e) => {
  var i;
  return typeof t == "string" && (t = {
    paginate: !1,
    store: ghe(t, e)
  }), t === void 0 && (t = []), Array.isArray(t) || t instanceof Ou ? t = {
    store: t
  } : t = P({}, t), t.store === void 0 && (t.store = []), i = t.store, "load" in t ? i = phe(t) : Array.isArray(i) ? i = new mS(i) : $t(i) && (i = vhe(P({}, i))), t.store = i, t;
};
class mhe {
  constructor() {
    this._counter = -1, this._deferreds = {};
  }
  add(e) {
    return this._counter++, this._deferreds[this._counter] = e, this._counter;
  }
  remove(e) {
    return delete this._deferreds[e];
  }
  cancel(e) {
    return e in this._deferreds ? (this._deferreds[e].reject(p6), !0) : !1;
  }
  cancelAll() {
    for (; this._counter > -1; )
      this.cancel(this._counter), this._counter--;
  }
}
var Ks = wi.inherit({
  ctor(t) {
    var e;
    t = zp(t), this._eventsStrategy = new Hp(this, {
      syncStrategy: !0
    }), this._store = t.store, this._changedTime = 0;
    var i = t.pushAggregationTimeout !== 0;
    if (i) {
      var r = t.pushAggregationTimeout === void 0 ? () => 5 * this._changedTime : t.pushAggregationTimeout, n, a, o = wce((u) => {
        n.resolve();
        var c = $e(...a);
        c.done(() => this._onPush(u)), a = void 0, n = void 0;
      }, r);
      this._onPushHandler = (u) => {
        this._aggregationTimeoutId = o(u.changes), n || (n = new q()), a = u.waitFor, u.waitFor.push(n.promise());
      }, this._store.on("beforePushAggregation", this._onPushHandler);
    } else
      this._onPushHandler = (u) => this._onPush(u), this._store.on("push", this._onPushHandler);
    this._storeLoadOptions = this._extractLoadOptions(t), this._mapFunc = t.map, this._postProcessFunc = t.postProcess, this._pageIndex = t.pageIndex !== void 0 ? t.pageIndex : 0, this._pageSize = t.pageSize !== void 0 ? t.pageSize : 20, this._loadingCount = 0, this._loadQueue = this._createLoadQueue(), this._searchValue = "searchValue" in t ? t.searchValue : null, this._searchOperation = t.searchOperation || "contains", this._searchExpr = t.searchExpr, this._paginate = t.paginate, this._reshapeOnPush = (e = t.reshapeOnPush) !== null && e !== void 0 ? e : !1, N(["onChanged", "onLoadError", "onLoadingChanged", "onCustomizeLoadResult", "onCustomizeStoreLoadOptions"], (u, c) => {
      c in t && this.on(c.substr(2, 1).toLowerCase() + c.substr(3), t[c]);
    }), this._operationManager = new mhe(), this._init();
  },
  _init() {
    this._items = [], this._userData = {}, this._totalCount = -1, this._isLoaded = !1, R(this._paginate) || (this._paginate = !this.group()), this._isLastPage = !this._paginate;
  },
  dispose() {
    var t;
    this._store.off("beforePushAggregation", this._onPushHandler), this._store.off("push", this._onPushHandler), this._eventsStrategy.dispose(), clearTimeout(this._aggregationTimeoutId), (t = this._delayedLoadTask) === null || t === void 0 || t.abort(), this._operationManager.cancelAll(), delete this._store, delete this._items, delete this._delayedLoadTask, this._disposed = !0;
  },
  _extractLoadOptions(t) {
    var e = {}, i = ["sort", "filter", "langParams", "select", "group", "requireTotalCount"], r = this._store._customLoadOptions();
    return r && (i = i.concat(r)), N(i, function() {
      e[this] = t[this];
    }), e;
  },
  loadOptions() {
    return this._storeLoadOptions;
  },
  items() {
    return this._items;
  },
  pageIndex(t) {
    if (!Di(t))
      return this._pageIndex;
    this._pageIndex = t, this._isLastPage = !this._paginate;
  },
  paginate(t) {
    if (!wx(t))
      return this._paginate;
    this._paginate !== t && (this._paginate = t, this.pageIndex(0));
  },
  pageSize(t) {
    if (!Di(t))
      return this._pageSize;
    this._pageSize = t;
  },
  isLastPage() {
    return this._isLastPage;
  },
  generateStoreLoadOptionAccessor(t) {
    return (e) => {
      var i = mW(e);
      if (i === void 0)
        return this._storeLoadOptions[t];
      this._storeLoadOptions[t] = i;
    };
  },
  sort() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return this.generateStoreLoadOptionAccessor("sort")(e);
  },
  filter() {
    var t = mW(arguments);
    if (t === void 0)
      return this._storeLoadOptions.filter;
    this._storeLoadOptions.filter = t, this.pageIndex(0);
  },
  group() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return this.generateStoreLoadOptionAccessor("group")(e);
  },
  select() {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i];
    return this.generateStoreLoadOptionAccessor("select")(e);
  },
  requireTotalCount(t) {
    if (!wx(t))
      return this._storeLoadOptions.requireTotalCount;
    this._storeLoadOptions.requireTotalCount = t;
  },
  searchValue(t) {
    if (arguments.length < 1)
      return this._searchValue;
    this._searchValue = t, this.pageIndex(0);
  },
  searchOperation(t) {
    if (!ht(t))
      return this._searchOperation;
    this._searchOperation = t, this.pageIndex(0);
  },
  searchExpr(t) {
    var e = arguments.length;
    if (e === 0)
      return this._searchExpr;
    e > 1 && (t = [].slice.call(arguments)), this._searchExpr = t, this.pageIndex(0);
  },
  store() {
    return this._store;
  },
  key() {
    var t;
    return (t = this._store) === null || t === void 0 ? void 0 : t.key();
  },
  totalCount() {
    return this._totalCount;
  },
  isLoaded() {
    return this._isLoaded;
  },
  isLoading() {
    return this._loadingCount > 0;
  },
  beginLoading() {
    this._changeLoadingCount(1);
  },
  endLoading() {
    this._changeLoadingCount(-1);
  },
  _createLoadQueue: () => d6(),
  _changeLoadingCount(t) {
    var e = this.isLoading();
    this._loadingCount += t;
    var i = this.isLoading();
    e ^ i && this._eventsStrategy.fireEvent("loadingChanged", [i]);
  },
  _scheduleLoadCallbacks(t) {
    this.beginLoading(), t.always(() => {
      this.endLoading();
    });
  },
  _scheduleFailCallbacks(t) {
    var e = this;
    t.fail(function() {
      for (var i = arguments.length, r = new Array(i), n = 0; n < i; n++)
        r[n] = arguments[n];
      r[0] !== p6 && e._eventsStrategy.fireEvent("loadError", r);
    });
  },
  _fireChanged(t) {
    var e = /* @__PURE__ */ new Date();
    this._eventsStrategy.fireEvent("changed", t), this._changedTime = /* @__PURE__ */ new Date() - e;
  },
  _scheduleChangedCallbacks(t) {
    t.done(() => this._fireChanged());
  },
  loadSingle(t, e) {
    var i = new q(), r = this.key(), n = this._store, a = this._createStoreLoadOptions();
    return this._scheduleFailCallbacks(i), arguments.length < 2 && (e = t, t = r), delete a.skip, delete a.group, delete a.refresh, delete a.pageIndex, delete a.searchString, (t === r || n instanceof gS && !n._byKeyViaLoad() ? n.byKey(e, a) : (a.take = 1, a.filter = a.filter ? [a.filter, [t, e]] : [t, e], n.load(a))).fail(i.reject).done((o) => {
      var u = Array.isArray(o) && !o.length;
      !R(o) || u ? i.reject(new Zr.Error("E4009")) : (Array.isArray(o) || (o = [o]), i.resolve(this._applyMapFunction(o)[0]));
    }), i.promise();
  },
  load() {
    var t = new q(), e = () => {
      if (!this._disposed && gW(t))
        return this._loadFromStore(i, t);
    };
    this._scheduleLoadCallbacks(t), this._scheduleFailCallbacks(t), this._scheduleChangedCallbacks(t);
    var i = this._createLoadOperation(t);
    return this._eventsStrategy.fireEvent("customizeStoreLoadOptions", [i]), this._loadQueue.add(() => (typeof i.delay == "number" ? this._delayedLoadTask = aF(e, i.delay) : e(), t.promise())), t.promise({
      operationId: i.operationId
    });
  },
  _onPush(t) {
    if (this._reshapeOnPush)
      this.load();
    else {
      var e = {
        changes: t
      };
      this._eventsStrategy.fireEvent("changing", [e]);
      var i = this.group(), r = this.items(), n = 0, a = this.paginate() || i ? t.filter((o) => o.type === "update") : t;
      i && (n = Array.isArray(i) ? i.length : 1), this._mapFunc && a.forEach((o) => {
        o.type === "insert" && (o.data = this._mapFunc(o.data));
      }), e.postProcessChanges && (a = e.postProcessChanges(a)), xp({
        keyInfo: this.store(),
        data: r,
        changes: a,
        groupCount: n,
        useInsertIndex: !0
      }), this._fireChanged([{
        changes: t
      }]);
    }
  },
  _createLoadOperation(t) {
    var e = this._operationManager.add(t), i = this._createStoreLoadOptions();
    return this._store && !uo(i == null ? void 0 : i.langParams) && (this._store._langParams = ae({}, this._store._langParams, i.langParams)), t.always(() => this._operationManager.remove(e)), {
      operationId: e,
      storeLoadOptions: i
    };
  },
  reload() {
    var t = this.store();
    return t._clearCache(), this._init(), this.load();
  },
  cancel(t) {
    return this._operationManager.cancel(t);
  },
  cancelAll() {
    return this._operationManager.cancelAll();
  },
  _addSearchOptions(t) {
    this._disposed || (this.store()._useDefaultSearch ? this._addSearchFilter(t) : (t.searchOperation = this._searchOperation, t.searchValue = this._searchValue, t.searchExpr = this._searchExpr));
  },
  _createStoreLoadOptions() {
    var t = P({}, this._storeLoadOptions);
    return this._addSearchOptions(t), this._paginate && this._pageSize && (t.skip = this._pageIndex * this._pageSize, t.take = this._pageSize), t.userData = this._userData, t;
  },
  _addSearchFilter(t) {
    var e = this._searchValue, i = this._searchOperation, r = this._searchExpr, n = [];
    e && (r || (r = "this"), Array.isArray(r) || (r = [r]), N(r, function(a, o) {
      n.length && n.push("or"), n.push([o, i, e]);
    }), t.filter ? t.filter = [n, t.filter] : t.filter = n);
  },
  _loadFromStore(t, e) {
    var i = (r, n) => {
      if (!this._disposed && gW(e)) {
        var a = P(g6(r, n), t);
        this._eventsStrategy.fireEvent("customizeLoadResult", [a]), $e(a.data).done((o) => {
          a.data = o, this._processStoreLoadResult(a, e);
        }).fail(e.reject);
      }
    };
    return t.data ? new q().resolve(t.data).done(i) : this.store().load(t.storeLoadOptions).done(i).fail(e.reject);
  },
  _processStoreLoadResult(t, e) {
    var i = t.data, r = t.extra, n = t.storeLoadOptions, a = () => (this._isLoaded = !0, this._totalCount = isFinite(r.totalCount) ? r.totalCount : -1, e.resolve(i, r));
    this._disposed || (i = this._applyPostProcessFunction(this._applyMapFunction(i)), ct(r) || (r = {}), this._items = i, (!i.length || !this._paginate || this._pageSize && i.length < this._pageSize) && (this._isLastPage = !0), n.requireTotalCount && !isFinite(r.totalCount) ? this.store().totalCount(n).done(function(o) {
      r.totalCount = o, a();
    }).fail(e.reject) : a());
  },
  _applyMapFunction(t) {
    return this._mapFunc ? fhe(t, this._mapFunc, this.group()) : t;
  },
  _applyPostProcessFunction(t) {
    return this._postProcessFunc ? this._postProcessFunc(t) : t;
  },
  on(t, e) {
    return this._eventsStrategy.on(t, e), this;
  },
  off(t, e) {
    return this._eventsStrategy.off(t, e), this;
  }
}), _he = {
  millisecond: 1,
  second: 1e3,
  minute: 6e4,
  hour: 36e5,
  day: 864e5,
  week: 6048e5,
  month: 2592e6,
  quarter: 7776e6,
  year: 31536e6
};
function xI(t) {
  return _he[t];
}
var Hx = 7, _W = 4, CW = 7, yW = 52, tx = ["millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year"], Che = function(t, e, i) {
  var r = e.getTime() - t.getTime(), n = xI(i) || 1;
  return Math.floor(r / n);
}, yhe = function(t, e) {
  var i = SI(t);
  switch (i) {
    case "millisecond":
      return "second";
    case "second":
      return "minute";
    case "minute":
      return "hour";
    case "hour":
      return "day";
    case "day":
      return e ? "week" : "month";
    case "week":
      return "month";
    case "month":
      return "quarter";
    case "quarter":
    case "year":
      return "year";
    default:
      return 0;
  }
}, m6 = function(t) {
  var e, i, r, n = ["millisecond", "second", "minute", "hour", "day", "month", "year"], a = {};
  for (e = n.length - 1; e >= 0; e--)
    r = n[e], i = Math.floor(t / xI(r)), i > 0 && (a[r + "s"] = i, t -= RT(r, i));
  return a;
}, xhe = function(t) {
  var e = 0;
  return ct(t) && N(t, function(i, r) {
    e += RT(i.substr(0, i.length - 1), r);
  }), ht(t) && (e = RT(t, 1)), e;
};
function RT(t, e) {
  return xI(t) * e;
}
function SI(t) {
  var e = -1, i;
  return ht(t) ? t : ct(t) ? (N(t, function(r, n) {
    for (i = 0; i < tx.length; i++)
      n && (r === tx[i] + "s" || r === tx[i]) && e < i && (e = i);
  }), tx[e]) : "";
}
var She = {
  millisecond: "millisecond",
  second: "longtime",
  minute: "shorttime",
  hour: "shorttime",
  day: "day",
  week: "day",
  month: "month",
  quarter: "quarter",
  year: "year"
};
function Ehe(t) {
  return She[SI(t)] || "";
}
var _6 = function(t) {
  return Math.floor(t / 3);
}, C6 = function(t) {
  return 3 * _6(t);
};
function y6(t, e, i, r) {
  t = new Date(t.getTime());
  var n = new Date(t.getTime()), a, o, u = SI(e);
  switch (u) {
    case "second":
      t = new Date(1e3 * Math.floor(n.getTime() / 1e3));
      break;
    case "minute":
      t = new Date(6e4 * Math.floor(n.getTime() / 6e4));
      break;
    case "hour":
      t = new Date(36e5 * Math.floor(n.getTime() / 36e5));
      break;
    case "year":
      t.setMonth(0);
    case "month":
      t.setDate(1);
    case "day":
      t.setHours(0, 0, 0, 0);
      break;
    case "week":
      t = T6(t, r || 0), t.setHours(0, 0, 0, 0);
      break;
    case "quarter":
      a = C6(t.getMonth()), o = t.getMonth(), t.setDate(1), t.setHours(0, 0, 0, 0), o !== a && t.setMonth(a);
  }
  return i && u !== "hour" && u !== "minute" && u !== "second" && A6(n, t), t;
}
function x6(t) {
  return y6(t, "day");
}
var bhe = function(t) {
  var e = x6(t);
  return e.setDate(e.getDate() + 1), new Date(e.getTime() - 1);
}, whe = function(t, e) {
  var i = 0, r = {
    year: t.getFullYear() !== e.getFullYear(),
    month: t.getMonth() !== e.getMonth(),
    day: t.getDate() !== e.getDate(),
    hour: t.getHours() !== e.getHours(),
    minute: t.getMinutes() !== e.getMinutes(),
    second: t.getSeconds() !== e.getSeconds(),
    millisecond: t.getMilliseconds() !== e.getMilliseconds()
  };
  return N(r, function(n, a) {
    a && i++;
  }), i === 0 && O6(t, e) !== 0 && (r.hour = !0, i++), r.count = i, r;
};
function S6(t, e, i) {
  var r = new Date(t.getTime()), n = ht(e) ? b6(e.toLowerCase()) : Di(e) ? m6(e) : e;
  return n.years && r.setFullYear(r.getFullYear() + n.years * i), n.quarters && r.setMonth(r.getMonth() + 3 * n.quarters * i), n.months && r.setMonth(r.getMonth() + n.months * i), n.weeks && r.setDate(r.getDate() + 7 * n.weeks * i), n.days && r.setDate(r.getDate() + n.days * i), n.hours && r.setTime(r.getTime() + 36e5 * n.hours * i), n.minutes && r.setTime(r.getTime() + 6e4 * n.minutes * i), n.seconds && r.setTime(r.getTime() + 1e3 * n.seconds * i), n.milliseconds && r.setTime(r.getTime() + n.milliseconds * i), r;
}
var E6 = function(t, e, i) {
  var r = i ? -1 : 1;
  return zo(t) ? S6(t, e, r) : Tj(t + e * r, e);
}, The = function(t, e, i) {
  var r = [], n;
  for (r.push(zo(t) ? new Date(t.getTime()) : t), n = t; n < e; )
    n = E6(n, i), r.push(n);
  return r;
}, Ihe = function(t, e) {
  if (t === "month")
    return ls(e.getFullYear(), e.getMonth(), 1);
  if (t === "year")
    return ls(e.getFullYear(), 0, e.getDate());
  if (t === "decade")
    return ls(CS(e), e.getMonth(), e.getDate());
  if (t === "century")
    return ls(_S(e), e.getMonth(), e.getDate());
}, Dhe = function(t, e) {
  if (t === "month")
    return ls(e.getFullYear(), e.getMonth(), LT(e));
  if (t === "year")
    return ls(e.getFullYear(), 11, e.getDate());
  if (t === "decade")
    return ls(CS(e) + 9, e.getMonth(), e.getDate());
  if (t === "century")
    return ls(_S(e) + 90, e.getMonth(), e.getDate());
}, Ahe = function(t, e) {
  var i = ls(e.getFullYear(), e.getMonth(), 1);
  return t === "month" || (i.setMonth(0), t === "year") || (t === "decade" && i.setFullYear(CS(e)), t === "century" && i.setFullYear(_S(e))), i;
}, Ohe = function(t, e) {
  var i = new Date(e);
  return i.setDate(LT(e)), t === "month" || (i.setMonth(11), i.setDate(LT(i)), t === "year") || (t === "decade" && i.setFullYear(CS(e) + 9), t === "century" && i.setFullYear(_S(e) + 99)), i;
};
function LT(t) {
  var e = ls(t.getFullYear(), t.getMonth() + 1, 0);
  return e.getDate();
}
var Rhe = function(t) {
  switch (t) {
    case "month":
      return "year";
    case "year":
      return "decade";
    case "decade":
      return "century";
  }
}, Lhe = function(t) {
  switch (t) {
    case "century":
      return "decade";
    case "decade":
      return "year";
    case "year":
      return "month";
  }
}, Mhe = function(t) {
  var e = 1;
  return t === "year" && (e = 12), t === "decade" && (e = 120), t === "century" && (e = 1200), e;
}, khe = function(t) {
  var e = 1;
  return t === "decade" && (e = 12), t === "century" && (e = 120), e;
};
function b6(t) {
  var e = {};
  switch (t) {
    case "year":
      e.years = 1;
      break;
    case "month":
      e.months = 1;
      break;
    case "quarter":
      e.months = 3;
      break;
    case "week":
      e.weeks = 1;
      break;
    case "day":
      e.days = 1;
      break;
    case "hour":
      e.hours = 1;
      break;
    case "minute":
      e.minutes = 1;
      break;
    case "second":
      e.seconds = 1;
      break;
    case "millisecond":
      e.milliseconds = 1;
  }
  return e;
}
function Phe(t, e) {
  return sP(t, e) && t.getDate() === e.getDate();
}
function sP(t, e) {
  return w6(t, e) && t.getMonth() === e.getMonth();
}
function w6(t, e) {
  return t && e && t.getFullYear() === e.getFullYear();
}
function Fhe(t, e) {
  return t && e && t.getHours() === e.getHours() && t.getMinutes() === e.getMinutes();
}
var Bhe = function(t, e) {
  if (!(!R(t) || !R(e))) {
    var i = t.getFullYear() - t.getFullYear() % 10, r = e.getFullYear() - e.getFullYear() % 10;
    return t && e && i === r;
  }
}, Vhe = function(t, e) {
  if (!(!R(t) || !R(e))) {
    var i = t.getFullYear() - t.getFullYear() % 100, r = e.getFullYear() - e.getFullYear() % 100;
    return t && e && i === r;
  }
};
function _S(t) {
  return t && t.getFullYear() - t.getFullYear() % 100;
}
function CS(t) {
  return t && t.getFullYear() - t.getFullYear() % 10;
}
var Nhe = function() {
  return "yyyy/MM/dd";
}, Hhe = function(t) {
  if (R(t))
    return ls(t.getFullYear(), t.getMonth(), 1);
}, $he = function(t) {
  if (R(t))
    return ls(t.getFullYear(), t.getMonth() + 1, 0);
};
function T6(t, e) {
  var i = (t.getDay() - e + Hx) % Hx, r = new Date(t);
  return r.setDate(t.getDate() - i), r;
}
function xW(t) {
  return Date.UTC(t.getFullYear(), t.getMonth(), t.getDate());
}
function zhe(t) {
  var e = xW(t) - xW(I6(t.getFullYear()));
  return 1 + Math.floor(e / xI("day"));
}
function I6(t) {
  return new Date(t, 0, 1);
}
function hL(t) {
  return new Date(t, 11, 31);
}
function SW(t, e) {
  var i = t.getDay() - e + 1;
  return i <= 0 && (i += Hx), i;
}
function lP(t, e, i) {
  var r = SW(I6(t.getFullYear()), e), n = SW(hL(t.getFullYear()), e), a = Hx - r + 1, o = Math.ceil((zhe(t) - a) / 7);
  switch (i) {
    case "fullWeek":
      if (a === Hx && o++, o === 0) {
        var u = hL(t.getFullYear() - 1);
        return lP(u, e, i);
      }
      return o;
    case "firstDay":
      a > 0 && o++;
      var c = r === CW || n === CW;
      return (o > yW && !c || o === 54) && (o = 1), o;
    case "firstFourDays":
      a > 3 && o++;
      var p = r === _W || n === _W;
      if (o > yW && !p && (o = 1), o === 0) {
        var v = hL(t.getFullYear() - 1);
        return lP(v, e, i);
      }
      return o;
  }
}
var Whe = function(t, e) {
  var i = Ke.getDatesInterval(t, e, "day"), r = new Date(t);
  return i >= 6 && (r = new Date(r.setDate(r.getDate() + 7))), r;
}, Uhe = function(t, e, i, r) {
  return r === "date" && (e = e && Ke.correctDateWithUnitBeginning(e, "day"), i = i && Ke.correctDateWithUnitBeginning(i, "day"), t = t && Ke.correctDateWithUnitBeginning(t, "day")), D6(t, e, i) === t;
}, Ghe = function(t) {
  var {
    firstMin: e,
    firstMax: i,
    secondMin: r,
    secondMax: n
  } = t;
  return e <= r && r <= i || e > r && e < n || e < n && i > n;
}, Khe = function(t) {
  var e = Math.floor(t), i = t % 1 * 60;
  return {
    hours: e,
    minutes: i
  };
}, jhe = function(t, e) {
  var i = this.dateTimeFromDecimal(e), r = new Date(t);
  return (t.getHours() === i.hours && t.getMinutes() < i.minutes || t.getHours() < i.hours) && r.setHours(i.hours, i.minutes, 0, 0), r;
};
function D6(t, e, i) {
  var r = t;
  return R(t) ? (R(e) && t < e && (r = e), R(i) && t > i && (r = i), r) : t;
}
function A6(t, e) {
  if (R(t)) {
    var i = e.getHours() - t.getHours();
    if (i !== 0) {
      var r = i === 1 || i === -23 ? -1 : 1, n = new Date(e.getTime() + 36e5 * r);
      (r > 0 || n.getDate() === e.getDate()) && e.setTime(n.getTime());
    }
  }
}
var Yhe = function(t) {
  var e = new Date(t.getTime());
  return e.setHours(e.getHours() + 1), e.setMinutes(0), e;
};
function O6(t, e) {
  return 60 * (e.getTimezoneOffset() - t.getTimezoneOffset()) * 1e3;
}
var qhe = function(t) {
  return new Date(t);
}, Xhe = function(t, e, i) {
  for (var r = [], n = new Date(t.getTime()); n < e; )
    r.push(new Date(n.getTime())), n = this.addInterval(n, i);
  return r;
}, ls = function(t) {
  var e = new Date(...arguments);
  return e.setFullYear(t), e;
}, Qhe = () => {
  var t = typeof Intl < "u";
  return t ? Intl.DateTimeFormat().resolvedOptions().timeZone : null;
}, Ke = {
  dateUnitIntervals: tx,
  convertMillisecondsToDateUnits: m6,
  dateToMilliseconds: xhe,
  getNextDateUnit: yhe,
  convertDateUnitToMilliseconds: RT,
  getDateUnitInterval: SI,
  getDateFormatByTickInterval: Ehe,
  getDatesDifferences: whe,
  correctDateWithUnitBeginning: y6,
  trimTime: x6,
  setToDayEnd: bhe,
  roundDateByStartDayHour: jhe,
  dateTimeFromDecimal: Khe,
  addDateInterval: S6,
  addInterval: E6,
  getSequenceByInterval: The,
  getDateIntervalByString: b6,
  sameHoursAndMinutes: Fhe,
  sameDate: Phe,
  sameMonthAndYear: sP,
  sameMonth: sP,
  sameYear: w6,
  sameDecade: Bhe,
  sameCentury: Vhe,
  getDifferenceInMonth: Mhe,
  getDifferenceInMonthForCells: khe,
  getFirstYearInDecade: CS,
  getFirstDecadeInCentury: _S,
  getShortDateFormat: Nhe,
  getViewFirstCellDate: Ihe,
  getViewLastCellDate: Dhe,
  getViewDown: Lhe,
  getViewUp: Rhe,
  getLastMonthDay: LT,
  getLastMonthDate: $he,
  getFirstMonthDate: Hhe,
  getFirstWeekDate: T6,
  getWeekNumber: lP,
  normalizeDateByWeek: Whe,
  getQuarter: _6,
  getFirstQuarterMonth: C6,
  dateInRange: Uhe,
  intervalsOverlap: Ghe,
  roundToHour: Yhe,
  normalizeDate: D6,
  getViewMinBoundaryDate: Ahe,
  getViewMaxBoundaryDate: Ohe,
  fixTimezoneGap: A6,
  getTimezonesDifference: O6,
  makeDate: qhe,
  getDatesInterval: Che,
  getDatesOfInterval: Xhe,
  createDateWithFullYear: ls,
  getMachineTimezoneName: Qhe
};
Ke.sameView = function(t, e, i) {
  return Ke[Ix("same " + t)](e, i);
};
function Ps(t, e) {
  for (; t.length < e; )
    t = "0" + t;
  return t;
}
var yy = {
  3: "abbreviated",
  4: "wide",
  5: "narrow"
}, uP = {
  y: function(t, e, i) {
    var r = t[i ? "getUTCFullYear" : "getFullYear"]();
    return e === 2 && (r %= 100), Ps(r.toString(), e);
  },
  M: function(t, e, i, r) {
    var n = t[i ? "getUTCMonth" : "getMonth"](), a = yy[e];
    return a ? r.getMonthNames(a, "format")[n] : Ps((n + 1).toString(), Math.min(e, 2));
  },
  L: function(t, e, i, r) {
    var n = t[i ? "getUTCMonth" : "getMonth"](), a = yy[e];
    return a ? r.getMonthNames(a, "standalone")[n] : Ps((n + 1).toString(), Math.min(e, 2));
  },
  Q: function(t, e, i, r) {
    var n = t[i ? "getUTCMonth" : "getMonth"](), a = Math.floor(n / 3), o = yy[e];
    return o ? r.getQuarterNames(o)[a] : Ps((a + 1).toString(), Math.min(e, 2));
  },
  E: function(t, e, i, r) {
    var n = t[i ? "getUTCDay" : "getDay"](), a = yy[e < 3 ? 3 : e];
    return r.getDayNames(a)[n];
  },
  a: function(t, e, i, r) {
    var n = t[i ? "getUTCHours" : "getHours"](), a = n < 12 ? 0 : 1, o = yy[e];
    return r.getPeriodNames(o)[a];
  },
  d: function(t, e, i) {
    return Ps(t[i ? "getUTCDate" : "getDate"]().toString(), Math.min(e, 2));
  },
  H: function(t, e, i) {
    return Ps(t[i ? "getUTCHours" : "getHours"]().toString(), Math.min(e, 2));
  },
  h: function(t, e, i) {
    var r = t[i ? "getUTCHours" : "getHours"]();
    return Ps((r % 12 || 12).toString(), Math.min(e, 2));
  },
  m: function(t, e, i) {
    return Ps(t[i ? "getUTCMinutes" : "getMinutes"]().toString(), Math.min(e, 2));
  },
  s: function(t, e, i) {
    return Ps(t[i ? "getUTCSeconds" : "getSeconds"]().toString(), Math.min(e, 2));
  },
  S: function(t, e, i) {
    return Ps(t[i ? "getUTCMilliseconds" : "getMilliseconds"]().toString(), 3).substr(0, e);
  },
  x: function(t, e, i) {
    var r = i ? 0 : t.getTimezoneOffset(), n = r > 0 ? "-" : "+", a = Math.abs(r), o = Math.floor(a / 60), u = a % 60, c = Ps(o.toString(), 2), p = Ps(u.toString(), 2);
    return n + c + (e >= 3 ? ":" : "") + (e > 1 || u ? p : "");
  },
  X: function(t, e, i) {
    return i || !t.getTimezoneOffset() ? "Z" : uP.x(t, e, i);
  },
  Z: function(t, e, i) {
    return uP.X(t, e >= 5 ? 3 : 2, i);
  }
}, R6 = function(t, e) {
  return function(i) {
    var r, n, a, o = 0, u = !1, c, p = "";
    if (!i)
      return null;
    if (!t)
      return i;
    var v = t[t.length - 1] === "Z" || t.slice(-3) === "'Z'";
    for (r = 0; r < t.length; r++)
      a = t[r], n = uP[a], c = a === t[r + 1], o++, c || (n && !u && (p += n(i, o, v, e)), o = 0), a === "'" && !c ? u = !u : (u || !n) && (p += a), a === "'" && c && r++;
    return p;
  };
}, Zhe = "،", L6 = " .,:;/\\<>()-[]" + Zhe, Jhe = ". m.", wh = function(t) {
  var e = t && _i.convertDigits(t, !1).charCodeAt(0), i = _i.convertDigits("0", !1).charCodeAt(0);
  return i <= e && e < i + 10;
}, efe = function(t, e, i, r) {
  var n = t[i], a = t[i + 1];
  if (!r && (n === "." || n === " " && t.slice(i - 1, i + 3) === Jhe || n === "-" && !wh(a)))
    return !0;
  var o = r && e.some((u) => t[i] !== u[i]);
  return L6.indexOf(n) < 0 && r === wh(n) && (!r || o);
}, tfe = function(t, e) {
  if (!wh(t[e]))
    for (; e > 0 && !wh(t[e - 1]) && (t[e - 1] === "." || L6.indexOf(t[e - 1]) < 0); )
      e--;
  return e;
}, ife = function(t, e, i, r) {
  var n = 0, a = [], o = function(u) {
    return t[n] !== u[n] && (r === void 0 || wh(t[n]) === r);
  };
  for (Array.isArray(e) || (e = [e]), n = 0; n < t.length; n++)
    if (i.indexOf(n) < 0 && e.filter(o).length) {
      n = tfe(t, n);
      do {
        if (r = wh(t[n]), !a.length && !r && wh(e[0][n]))
          break;
        a.push(n), i.unshift(n), n++;
      } while (t[n] && efe(t, e, n, r));
      break;
    }
  return a.length === 1 && (t[i[0] - 1] === "0" || t[i[0] - 1] === "٠") && i.unshift(i[0] - 1), a;
}, rfe = function(t, e, i, r) {
  var n = e[0], a = n < r.length ? r[n] : n;
  return e.forEach(function(o, u) {
    t = t.substr(0, a + u) + (i.length > 1 ? i[u] : i) + t.substr(a + u + 1);
  }), e.length === 1 && (t = t.replace("0" + i, i + i), t = t.replace("٠" + i, i + i)), t;
}, nfe = function(t, e, i, r) {
  var n, a, o;
  if (!wh(t[e[0]] || "0")) {
    for (var u = Math.max(e.length <= 3 ? 3 : 4, i.length); e.length > u; ) {
      for (a = e.pop(), o = r[a], r[a] = -1, n = a + 1; n < r.length; n++)
        r[n]--;
      t = t.substr(0, o) + t.substr(o + 1);
    }
    for (a = e[e.length - 1] + 1, o = a < r.length ? r[a] : a; e.length < u; ) {
      for (e.push(e[e.length - 1] + 1), n = a; n < r.length; n++)
        r[n]++;
      t = t.substr(0, o) + " " + t.substr(o);
    }
  }
  return t = rfe(t, e, i, r), t;
}, EW = function(t, e) {
  return Array.isArray(t) ? t.map(function(i) {
    return (e(i) || "").toString();
  }) : (e(t) || "").toString();
}, afe = /[a-zA-Z]/g, ofe = function(t, e, i, r) {
  var n = e.split("").map(function(a, o) {
    return i.indexOf(o) < 0 && (a.match(afe) || a === "'") ? r[o] : -1;
  });
  return t = t.split("").map(function(a, o) {
    var u = a, c = n.indexOf(o) >= 0, p = o > 0 && n.indexOf(o - 1) >= 0, v = n.indexOf(o + 1) >= 0;
    return c && (p || (u = "'" + u), v || (u += "'")), u;
  }).join(""), t;
}, M6 = function(t) {
  var e = [], i = EW(new Date(2009, 8, 8, 6, 5, 4), t), r = i.split("").map(function(u, c) {
    return c;
  }), n = i, a = {}, o = [{
    date: new Date(2009, 8, 8, 6, 5, 4, 111),
    pattern: "S"
  }, {
    date: new Date(2009, 8, 8, 6, 5, 2),
    pattern: "s"
  }, {
    date: new Date(2009, 8, 8, 6, 2, 4),
    pattern: "m"
  }, {
    date: new Date(2009, 8, 8, 18, 5, 4),
    pattern: "H",
    isDigit: !0
  }, {
    date: new Date(2009, 8, 8, 2, 5, 4),
    pattern: "h",
    isDigit: !0
  }, {
    date: new Date(2009, 8, 8, 18, 5, 4),
    pattern: "a",
    isDigit: !1
  }, {
    date: new Date(2009, 8, 1, 6, 5, 4),
    pattern: "d"
  }, {
    date: [new Date(2009, 8, 2, 6, 5, 4), new Date(2009, 8, 3, 6, 5, 4), new Date(2009, 8, 4, 6, 5, 4)],
    pattern: "E"
  }, {
    date: new Date(2009, 9, 6, 6, 5, 4),
    pattern: "M"
  }, {
    date: new Date(1998, 8, 8, 6, 5, 4),
    pattern: "y"
  }];
  if (n && (o.forEach(function(u) {
    var c = ife(i, EW(u.date, t), e, u.isDigit), p = u.pattern === "M" && !a.d ? "L" : u.pattern;
    n = nfe(n, c, p, r), a[p] = c.length;
  }), n = ofe(n, i, e, r), e.length))
    return n;
}, qd = {
  3: "abbreviated",
  4: "wide",
  5: "narrow"
}, bW = function(t, e) {
  return t > 2 ? Object.keys(qd).map(function(i) {
    return ["format", "standalone"].map(function(r) {
      return e.getMonthNames(qd[i], r).join("|");
    }).join("|");
  }).join("|") : t === 2 ? "1[012]|0?[1-9]" : "0??[1-9]|1[012]";
}, sfe = {
  ":": function(t, e) {
    var i = t > 1 ? "{".concat(t, "}") : "", r = Eh(e.getTimeSeparator());
    return r !== ":" && (r = "".concat(r, "|:")), "".concat(r).concat(i);
  },
  y: function(t) {
    return t === 2 ? "[0-9]{".concat(t, "}") : "[0-9]+?";
  },
  M: bW,
  L: bW,
  Q: function(t, e) {
    return t > 2 ? e.getQuarterNames(qd[t], "format").join("|") : "0?[1-4]";
  },
  E: function(t, e) {
    return "\\D*";
  },
  a: function(t, e) {
    return e.getPeriodNames(qd[t < 3 ? 3 : t], "format").join("|");
  },
  d: function(t) {
    return t === 2 ? "3[01]|[12][0-9]|0?[1-9]" : "0??[1-9]|[12][0-9]|3[01]";
  },
  H: function(t) {
    return t === 2 ? "2[0-3]|1[0-9]|0?[0-9]" : "0??[0-9]|1[0-9]|2[0-3]";
  },
  h: function(t) {
    return t === 2 ? "1[012]|0?[1-9]" : "0??[1-9]|1[012]";
  },
  m: function(t) {
    return t === 2 ? "[1-5][0-9]|0?[0-9]" : "0??[0-9]|[1-5][0-9]";
  },
  s: function(t) {
    return t === 2 ? "[1-5][0-9]|0?[0-9]" : "0??[0-9]|[1-5][0-9]";
  },
  S: function(t) {
    return "[0-9]{1,".concat(t, "}");
  },
  w: function(t) {
    return t === 2 ? "[1-5][0-9]|0?[0-9]" : "0??[0-9]|[1-5][0-9]";
  }
}, Fd = Number, dP = function(t, e) {
  return t.map((i) => i.toLowerCase()).indexOf(e.toLowerCase());
}, wW = function(t, e, i) {
  return e > 2 ? ["format", "standalone"].map(function(r) {
    return Object.keys(qd).map(function(n) {
      var a = i.getMonthNames(qd[n], r);
      return dP(a, t);
    });
  }).reduce(function(r, n) {
    return r.concat(n);
  }).filter(function(r) {
    return r >= 0;
  })[0] : Fd(t) - 1;
}, lfe = {
  y: function(t, e) {
    var i = Fd(t);
    return e === 2 ? i < 30 ? 2e3 + i : 1900 + i : i;
  },
  M: wW,
  L: wW,
  Q: function(t, e, i) {
    return e > 2 ? i.getQuarterNames(qd[e], "format").indexOf(t) : Fd(t) - 1;
  },
  E: function(t, e, i) {
    var r = i.getDayNames(qd[e < 3 ? 3 : e], "format");
    return dP(r, t);
  },
  a: function(t, e, i) {
    var r = i.getPeriodNames(qd[e < 3 ? 3 : e], "format");
    return dP(r, t);
  },
  d: Fd,
  H: Fd,
  h: Fd,
  m: Fd,
  s: Fd,
  S: function(t, e) {
    for (e = Math.max(e, 3), t = t.slice(0, 3); e < 3; )
      t += "0", e++;
    return Fd(t);
  }
}, MT = ["y", "M", "d", "h", "m", "s", "S"], dB = {
  y: "setFullYear",
  M: "setMonth",
  L: "setMonth",
  a: function(t, e, i) {
    var r = t.getHours(), n = i.h;
    n !== void 0 && n !== r && r--, !e && r === 12 ? r = 0 : e && r !== 12 && (r += 12), t.setHours(r);
  },
  d: "setDate",
  H: "setHours",
  h: "setHours",
  m: "setMinutes",
  s: "setSeconds",
  S: "setMilliseconds"
}, ufe = function(t, e) {
  var i = t[e];
  if (!i)
    return 0;
  var r = 0;
  do
    e++, r++;
  while (t[e] === i);
  return r;
}, dfe = function(t, e) {
  for (var i = "", r = 0; r < e; r++)
    i += t;
  return i;
}, k6 = function(t, e) {
  for (var i = "", r = "", n, a = [], o = function() {
    r && (a.push("'".concat(r, "'")), i += "".concat(Eh(r), ")"), r = "");
  }, u = 0; u < t.length; u++) {
    var c = t[u], p = c === "'", v = sfe[c];
    if (!(p && (n = !n, t[u - 1] !== "'")))
      if (v && !n) {
        var _ = ufe(t, u), y = dfe(c, _);
        o(), a.push(y), i += "(".concat(v(_, e), ")"), u += _ - 1;
      } else
        r || (i += "("), r += c;
  }
  return o(), hfe(a) || eI.warn("The following format may be parsed incorrectly: ".concat(t, ".")), {
    patterns: a,
    regexp: new RegExp("^".concat(i, "$"), "i")
  };
}, cfe = ["d", "H", "h", "m", "s", "w", "M", "L", "Q"], hfe = function(t) {
  var e = (n) => {
    if (!n)
      return !1;
    var a = n[0];
    return ["y", "S"].includes(a) || cfe.includes(a) && n.length < 3;
  }, i = !0, r = 0;
  return t.every((n, a, o) => (e(n) && (((u) => u[0] !== "S" && u.length !== 2)(n) && (i = ++r < 2), e(o[a + 1]) || (r = 0)), i));
}, ffe = function() {
  return dB;
}, pfe = function(t, e, i, r, n) {
  var a = e[0], o = dB[a], u = lfe[a];
  if (o && u) {
    var c = u(i, e.length, r);
    n[e] = c, t[o] ? t[o](c) : o(t, c, n);
  }
}, vfe = function(t, e, i) {
  var r = dB[e], n = "g" + r.substr(1), a = i[n]();
  t[r](a);
}, gfe = function(t) {
  return t.map(function(e) {
    return e[0] === "'" ? "" : e[0] === "H" ? "h" : e[0];
  });
}, mfe = function(t) {
  var e = t.map(function(i) {
    return MT.indexOf(i);
  });
  return Math.max.apply(Math, e);
}, _fe = function(t) {
  var e = t.filter(function(i) {
    return MT.indexOf(i) < 0;
  });
  return MT.concat(e);
}, Cfe = function(t, e) {
  var i = k6(t, e);
  return function(r) {
    var n = i.regexp.exec(r);
    if (n) {
      var a = /* @__PURE__ */ new Date(), o = new Date(a.getFullYear(), 0, 1), u = gfe(i.patterns), c = mfe(u), p = _fe(u), v = {};
      return p.forEach(function(_, y) {
        if (!(!_ || y < MT.length && y > c)) {
          var b = u.indexOf(_);
          if (b >= 0) {
            var I = i.patterns[b], A = n[b + 1];
            pfe(o, I, A, e, v);
          } else
            vfe(o, _, a);
        }
      }), o;
    }
    return null;
  };
}, yfe = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], xfe = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], Sfe = ["AM", "PM"], Efe = ["Q1", "Q2", "Q3", "Q4"], TW = (t, e) => {
  var i = {
    abbreviated: 3,
    short: 2,
    narrow: 1
  };
  return Jr(t, (r) => r.substr(0, i[e]));
};
const _m = {
  getMonthNames: function(t) {
    return TW(yfe, t);
  },
  getDayNames: function(t) {
    return TW(xfe, t);
  },
  getQuarterNames: function(t) {
    return Efe;
  },
  getPeriodNames: function(t) {
    return Sfe;
  }
}, bfe = {
  "af-NA": 1,
  agq: 1,
  ak: 1,
  ar: 6,
  "ar-EH": 1,
  "ar-ER": 1,
  "ar-KM": 1,
  "ar-LB": 1,
  "ar-MA": 1,
  "ar-MR": 1,
  "ar-PS": 1,
  "ar-SO": 1,
  "ar-SS": 1,
  "ar-TD": 1,
  "ar-TN": 1,
  asa: 1,
  ast: 1,
  az: 1,
  "az-Cyrl": 1,
  bas: 1,
  be: 1,
  bem: 1,
  bez: 1,
  bg: 1,
  bm: 1,
  br: 1,
  bs: 1,
  "bs-Cyrl": 1,
  ca: 1,
  ce: 1,
  cgg: 1,
  ckb: 6,
  cs: 1,
  cy: 1,
  da: 1,
  de: 1,
  dje: 1,
  dsb: 1,
  dua: 1,
  dyo: 1,
  ee: 1,
  el: 1,
  "en-001": 1,
  "en-AE": 6,
  "en-BI": 1,
  "en-MP": 1,
  "en-MV": 5,
  "en-SD": 6,
  eo: 1,
  es: 1,
  et: 1,
  eu: 1,
  ewo: 1,
  fa: 6,
  ff: 1,
  "ff-Adlm": 1,
  fi: 1,
  fo: 1,
  fr: 1,
  "fr-DJ": 6,
  "fr-DZ": 6,
  "fr-SY": 6,
  fur: 1,
  fy: 1,
  ga: 1,
  gd: 1,
  gl: 1,
  gsw: 1,
  gv: 1,
  ha: 1,
  hr: 1,
  hsb: 1,
  hu: 1,
  hy: 1,
  ia: 1,
  ig: 1,
  is: 1,
  it: 1,
  jgo: 1,
  jmc: 1,
  ka: 1,
  kab: 6,
  kde: 1,
  kea: 1,
  khq: 1,
  kk: 1,
  kkj: 1,
  kl: 1,
  "ko-KP": 1,
  ksb: 1,
  ksf: 1,
  ksh: 1,
  ku: 1,
  kw: 1,
  ky: 1,
  lag: 1,
  lb: 1,
  lg: 1,
  ln: 1,
  lrc: 6,
  lt: 1,
  lu: 1,
  lv: 1,
  "mas-TZ": 1,
  mfe: 1,
  mg: 1,
  mgo: 1,
  mi: 1,
  mk: 1,
  mn: 1,
  ms: 1,
  mua: 1,
  mzn: 6,
  naq: 1,
  nds: 1,
  nl: 1,
  nmg: 1,
  nnh: 1,
  no: 1,
  nus: 1,
  nyn: 1,
  os: 1,
  pcm: 1,
  pl: 1,
  ps: 6,
  "pt-AO": 1,
  "pt-CH": 1,
  "pt-CV": 1,
  "pt-GQ": 1,
  "pt-GW": 1,
  "pt-LU": 1,
  "pt-ST": 1,
  "pt-TL": 1,
  "qu-BO": 1,
  "qu-EC": 1,
  rm: 1,
  rn: 1,
  ro: 1,
  rof: 1,
  ru: 1,
  rw: 1,
  rwk: 1,
  sah: 1,
  sbp: 1,
  sc: 1,
  se: 1,
  ses: 1,
  sg: 1,
  shi: 1,
  "shi-Latn": 1,
  si: 1,
  sk: 1,
  sl: 1,
  smn: 1,
  so: 1,
  "so-DJ": 6,
  sq: 1,
  sr: 1,
  "sr-Latn": 1,
  sv: 1,
  sw: 1,
  "ta-LK": 1,
  "ta-MY": 1,
  teo: 1,
  tg: 1,
  "ti-ER": 1,
  tk: 1,
  to: 1,
  tr: 1,
  tt: 1,
  twq: 1,
  tzm: 1,
  uk: 1,
  uz: 1,
  "uz-Arab": 6,
  "uz-Cyrl": 1,
  vai: 1,
  "vai-Latn": 1,
  vi: 1,
  vun: 1,
  wae: 1,
  wo: 1,
  xog: 1,
  yav: 1,
  yi: 1,
  yo: 1,
  zgh: 1
};
var wfe = /[\u200E\u200F]/g, Tfe = /[\u202F]/g, sp = (t) => (e) => {
  if (!t.timeZoneName) {
    var i = e.getFullYear(), r = String(i).length < 3, n = r ? i + 400 : i, a = new Date(Date.UTC(n, e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
    r && a.setFullYear(i);
    var o = P({
      timeZone: "UTC"
    }, t);
    return cP(a, o);
  }
  return cP(e, t);
}, fL = {}, Ife = (t) => {
  var e = Wo.locale() + "/" + JSON.stringify(t);
  return fL[e] || (fL[e] = new Intl.DateTimeFormat(Wo.locale(), t).format), fL[e];
};
function cP(t, e) {
  return Ife(e)(t).replace(wfe, "").replace(Tfe, " ");
}
var hP = (t) => new Intl.NumberFormat(Wo.locale()).format(t), Dfe = /* @__PURE__ */ (() => {
  var t = {};
  return (e) => {
    if (!(e in t)) {
      if (hP(0) === "0")
        return t[e] = !1, !1;
      t[e] = {};
      for (var i = 0; i < 10; ++i)
        t[e][hP(i)] = i;
    }
    return t[e];
  };
})(), Wb = (t) => {
  var e = Dfe(Wo.locale());
  return e ? t.split("").map((i) => i in e ? String(e[i]) : i).join("") : t;
}, IW = (t) => t.replace(/(\D)0+(\d)/g, "$1$2"), Afe = (t, e) => IW(t) === IW(e), fP = (t) => t.replace("d’", "de "), cB = {
  day: {
    day: "numeric"
  },
  dayofweek: {
    weekday: "long"
  },
  longdate: {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  },
  longdatelongtime: {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  longtime: {
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  month: {
    month: "long"
  },
  monthandday: {
    month: "long",
    day: "numeric"
  },
  monthandyear: {
    year: "numeric",
    month: "long"
  },
  shortdate: {},
  shorttime: {
    hour: "numeric",
    minute: "numeric"
  },
  shortyear: {
    year: "2-digit"
  },
  year: {
    year: "numeric"
  }
};
Object.defineProperty(cB, "shortdateshorttime", {
  get: function() {
    var t = Intl.DateTimeFormat(Wo.locale()).resolvedOptions();
    return {
      year: t.year,
      month: t.month,
      day: t.day,
      hour: "numeric",
      minute: "numeric"
    };
  }
});
var Ofe = (t) => typeof t == "string" && cB[t.toLowerCase()], P6 = {
  standalone: function(t, e) {
    var i = new Date(1999, t, 13, 1), r = sp({
      month: e
    })(i);
    return r;
  },
  format: function(t, e) {
    var i = new Date(0, t, 13, 1), r = fP(sp({
      day: "numeric",
      month: e
    })(i)), n = r.split(" ").filter((a) => a.indexOf("13") < 0);
    return n.length === 1 ? n[0] : n.length === 2 ? n[0].length > n[1].length ? n[0] : n[1] : P6.standalone(t, e);
  }
};
const Rfe = {
  engine: function() {
    return "intl";
  },
  getMonthNames: function(t, e) {
    var i = {
      wide: "long",
      abbreviated: "short",
      narrow: "narrow"
    }[t || "wide"];
    return e = e === "format" ? e : "standalone", Array.apply(null, new Array(12)).map((r, n) => P6[e](n, i));
  },
  getDayNames: function(t) {
    var e = ((i) => Array.apply(null, new Array(7)).map((r, n) => sp({
      weekday: i
    })(new Date(0, 0, n))))({
      wide: "long",
      abbreviated: "short",
      short: "narrow",
      narrow: "narrow"
    }[t || "wide"]);
    return e;
  },
  getPeriodNames: function() {
    var t = sp({
      hour: "numeric",
      hour12: !0
    });
    return [1, 13].map((e) => {
      var i = hP(1), r = t(new Date(0, 0, 1, e)).split(i);
      if (r.length !== 2)
        return "";
      var n = r[0].length > r[1].length ? r[0] : r[1];
      return n.trim();
    });
  },
  format: function(t, e) {
    if (t) {
      if (!e)
        return t;
      typeof e != "function" && !e.formatter && (e = e.type || e);
      var i = Ofe(e);
      if (i)
        return sp(i)(t);
      var r = typeof e;
      return e.formatter || r === "function" || r === "string" ? this.callBase.apply(this, arguments) : sp(e)(t);
    }
  },
  parse: function(t, e) {
    var i;
    return e && !e.parser && typeof t == "string" && (t = fP(t), i = (r) => fP(this.format(r, e))), this.callBase(t, i || e);
  },
  _parseDateBySimpleFormat: function(t, e) {
    t = Wb(t);
    var i = this.getFormatParts(e), r = t.split(/\D+/).filter((o) => o.length > 0);
    if (i.length === r.length) {
      var n = this._generateDateArgs(i, r), a = (o) => {
        var u = ((c, p) => {
          var v = p ? 12 : 0;
          return new Date(c.year, c.month, c.day, (c.hours + v) % 24, c.minutes, c.seconds);
        })(n, o);
        if (Afe(Wb(this.format(u, e)), t))
          return u;
      };
      return a(!1) || a(!0);
    }
  },
  _generateDateArgs: function(t, e) {
    var i = /* @__PURE__ */ new Date(), r = {
      year: i.getFullYear(),
      month: i.getMonth(),
      day: i.getDate(),
      hours: 0,
      minutes: 0,
      seconds: 0
    };
    return t.forEach((n, a) => {
      var o = e[a], u = parseInt(o, 10);
      n === "month" && (u -= 1), r[n] = u;
    }), r;
  },
  formatUsesMonthName: function(t) {
    return typeof t == "object" && !(t.type || t.format) ? t.month === "long" : this.callBase.apply(this, arguments);
  },
  formatUsesDayName: function(t) {
    return typeof t == "object" && !(t.type || t.format) ? t.weekday === "long" : this.callBase.apply(this, arguments);
  },
  getTimeSeparator: function() {
    return Wb(cP(new Date(2001, 1, 1, 11, 11), {
      hour: "numeric",
      minute: "numeric",
      hour12: !1
    })).replace(/\d/g, "");
  },
  getFormatParts: function(t) {
    if (typeof t == "string")
      return this.callBase(t);
    var e = P({}, cB[t.toLowerCase()]), i = new Date(2001, 2, 4, 5, 6, 7), r = sp(e)(i);
    return r = Wb(r), [{
      name: "year",
      value: 1
    }, {
      name: "month",
      value: 3
    }, {
      name: "day",
      value: 4
    }, {
      name: "hours",
      value: 5
    }, {
      name: "minutes",
      value: 6
    }, {
      name: "seconds",
      value: 7
    }].map((n) => ({
      name: n.name,
      index: r.indexOf(n.value)
    })).filter((n) => n.index > -1).sort((n, a) => n.index - a.index).map((n) => n.name);
  }
};
var Lfe = 0, Mfe = typeof Intl < "u", pL = {
  shortdate: "M/d/y",
  shorttime: "h:mm a",
  longdate: "EEEE, MMMM d, y",
  longtime: "h:mm:ss a",
  monthandday: "MMMM d",
  monthandyear: "MMMM y",
  quarterandyear: "QQQ y",
  day: "d",
  year: "y",
  shortdateshorttime: "M/d/y, h:mm a",
  longdatelongtime: "EEEE, MMMM d, y, h:mm:ss a",
  month: "LLLL",
  shortyear: "yy",
  dayofweek: "EEEE",
  quarter: "QQQ",
  hour: "HH",
  minute: "mm",
  second: "ss",
  millisecond: "SSS",
  "datetime-local": "yyyy-MM-ddTHH':'mm':'ss"
}, kfe = {
  year: ["y", "yy", "yyyy"],
  day: ["d", "dd"],
  month: ["M", "MM", "MMM", "MMMM"],
  hours: ["H", "HH", "h", "hh", "ah"],
  minutes: ["m", "mm"],
  seconds: ["s", "ss"],
  milliseconds: ["S", "SS", "SSS"]
}, Bt = js({
  engine: function() {
    return "base";
  },
  _getPatternByFormat: function(t) {
    return pL[t.toLowerCase()];
  },
  _expandPattern: function(t) {
    return this._getPatternByFormat(t) || t;
  },
  formatUsesMonthName: function(t) {
    return this._expandPattern(t).indexOf("MMMM") !== -1;
  },
  formatUsesDayName: function(t) {
    return this._expandPattern(t).indexOf("EEEE") !== -1;
  },
  getFormatParts: function(t) {
    var e = this._getPatternByFormat(t) || t, i = [];
    return N(e.split(/\W+/), (r, n) => {
      N(kfe, (a, o) => {
        o.includes(n) && i.push(a);
      });
    }), i;
  },
  getMonthNames: function(t) {
    return _m.getMonthNames(t);
  },
  getDayNames: function(t) {
    return _m.getDayNames(t);
  },
  getQuarterNames: function(t) {
    return _m.getQuarterNames(t);
  },
  getPeriodNames: function(t) {
    return _m.getPeriodNames(t);
  },
  getTimeSeparator: function() {
    return ":";
  },
  is24HourFormat: function(t) {
    for (var e = new Date(2017, 0, 20, 11, 0, 0, 0), i = new Date(2017, 0, 20, 23, 0, 0, 0), r = this.format(e, t), n = this.format(i, t), a = 0; a < r.length; a++)
      if (r[a] !== n[a])
        return !isNaN(parseInt(r[a]));
  },
  format: function(t, e) {
    if (t) {
      if (!e)
        return t;
      var i;
      if (typeof e == "function")
        i = e;
      else if (e.formatter)
        i = e.formatter;
      else if (e = e.type || e, ht(e))
        return e = pL[e.toLowerCase()] || e, _i.convertDigits(R6(e, this)(t));
      if (i)
        return i(t);
    }
  },
  parse: function(t, e) {
    var i = this, r, n;
    if (t) {
      if (!e)
        return this.parse(t, "shortdate");
      if (e.parser)
        return e.parser(t);
      if (typeof e == "string" && !pL[e.toLowerCase()])
        r = e;
      else {
        n = (o) => {
          var u = i.format(o, e);
          return _i.convertDigits(u, !0);
        };
        try {
          r = M6(n);
        } catch {
        }
      }
      if (r)
        return t = _i.convertDigits(t, !0), Cfe(r, this)(t);
      bi.log("W0012");
      var a = new Date(t);
      if (!(!a || isNaN(a.getTime())))
        return a;
    }
  },
  firstDayOfWeekIndex: function() {
    var t = Wo.getValueByClosestLocale((e) => bfe[e]);
    return t === void 0 ? Lfe : t;
  }
});
Mfe && Bt.inject(Rfe);
const F6 = js({
  format: function(t, e) {
    var i = ht(e) && e !== "" || $t(e) || Le(e), r = Di(t) || zo(t);
    if (!i || !r)
      return R(t) ? t.toString() : "";
    if (Le(e))
      return e(t);
    if (ht(e) && (e = {
      type: e
    }), Di(t))
      return _i.format(t, e);
    if (zo(t))
      return Bt.format(t, e);
  },
  getTimeFormat: function(t) {
    return t ? "longtime" : "shorttime";
  },
  _normalizeFormat: function(t) {
    return Array.isArray(t) ? t.length === 1 ? t[0] : function(e) {
      return t.map(function(i) {
        return Bt.format(e, i);
      }).join(" ");
    } : t;
  },
  getDateFormatByDifferences: function(t, e) {
    var i = [], r = e && t.millisecond && !(t.year || t.month || t.day);
    return r ? i.push(function(n) {
      return n.getSeconds() + n.getMilliseconds() / 1e3 + "s";
    }) : t.millisecond && i.push("millisecond"), (t.hour || t.minute || !r && t.second) && i.unshift(this.getTimeFormat(t.second)), t.year && t.month && t.day ? e && e === "month" ? "monthandyear" : (i.unshift("shortdate"), this._normalizeFormat(i)) : t.year && t.month ? "monthandyear" : t.year && t.quarter ? "quarterandyear" : t.year ? "year" : t.quarter ? "quarter" : t.month && t.day ? (e ? i.unshift(function(n) {
      return Bt.getMonthNames("abbreviated")[n.getMonth()] + " " + Bt.format(n, "day");
    }) : i.unshift("monthandday"), this._normalizeFormat(i)) : t.month ? "month" : t.day ? (e ? i.unshift("day") : i.unshift(function(n) {
      return Bt.format(n, "dayofweek") + ", " + Bt.format(n, "day");
    }), this._normalizeFormat(i)) : this._normalizeFormat(i);
  },
  getDateFormatByTicks: function(t) {
    var e, i, r;
    if (t.length > 1)
      for (e = Ke.getDatesDifferences(t[0], t[1]), r = 1; r < t.length - 1; r++)
        i = Ke.getDatesDifferences(t[r], t[r + 1]), e.count < i.count && (e = i);
    else
      e = {
        year: !0,
        month: !0,
        day: !0,
        hour: t[0].getHours() > 0,
        minute: t[0].getMinutes() > 0,
        second: t[0].getSeconds() > 0,
        millisecond: t[0].getMilliseconds() > 0
      };
    var n = this.getDateFormatByDifferences(e);
    return n;
  },
  getDateFormatByTickInterval: function(t, e, i) {
    var r, n = function(u, c, p) {
      switch (c) {
        case "year":
        case "quarter":
          u.month = p;
        case "month":
          u.day = p;
        case "week":
        case "day":
          u.hour = p;
        case "hour":
          u.minute = p;
        case "minute":
          u.second = p;
        case "second":
          u.millisecond = p;
      }
    };
    i = ht(i) ? i.toLowerCase() : i;
    var a = Ke.getDatesDifferences(t, e);
    t !== e && function(u, c, p) {
      !p.getMilliseconds() && p.getSeconds() ? p.getSeconds() - c.getSeconds() === 1 && (u.millisecond = !0, u.second = !1) : !p.getSeconds() && p.getMinutes() ? p.getMinutes() - c.getMinutes() === 1 && (u.second = !0, u.minute = !1) : !p.getMinutes() && p.getHours() ? p.getHours() - c.getHours() === 1 && (u.minute = !0, u.hour = !1) : !p.getHours() && p.getDate() > 1 ? p.getDate() - c.getDate() === 1 && (u.hour = !0, u.day = !1) : p.getDate() === 1 && p.getMonth() ? p.getMonth() - c.getMonth() === 1 && (u.day = !0, u.month = !1) : !p.getMonth() && p.getFullYear() && p.getFullYear() - c.getFullYear() === 1 && (u.month = !0, u.year = !1);
    }(a, t > e ? e : t, t > e ? t : e), r = Ke.getDateUnitInterval(a), n(a, r, !0), r = Ke.getDateUnitInterval(i || "second"), n(a, r, !1), a[{
      week: "day"
    }[r] || r] = !0;
    var o = this.getDateFormatByDifferences(a);
    return o;
  }
});
function B6(t, e, i) {
  function r(c) {
    return typeof c == "string" ? c.split(".") : typeof c == "number" ? [c] : c;
  }
  t = r(t), e = r(e);
  var n = Math.max(t.length, e.length);
  isFinite(i) && (n = Math.min(n, i));
  for (var a = 0; a < n; a++) {
    var o = parseInt(t[a] || 0, 10), u = parseInt(e[a] || 0, 10);
    if (o < u)
      return -1;
    if (o > u)
      return 1;
  }
  return 0;
}
function DW(t, e, i) {
  t = t === "role" || t === "id" ? t : "aria-".concat(t), e = R(e) ? e.toString() : null, i.attr(t, e);
}
var xn = Nu.inherit({
  _feedbackHideTimeout: 400,
  _feedbackShowTimeout: 30,
  _supportedKeys: () => ({}),
  _getDefaultOptions() {
    return P(this.callBase(), {
      hoveredElement: null,
      isActive: !1,
      disabled: !1,
      visible: !0,
      hint: void 0,
      activeStateEnabled: !1,
      onContentReady: null,
      hoverStateEnabled: !1,
      focusStateEnabled: !1,
      tabIndex: 0,
      accessKey: void 0,
      onFocusIn: null,
      onFocusOut: null,
      onKeyboardHandled: null,
      ignoreParentReadOnly: !1,
      useResizeObserver: !0
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: function() {
        var t = Ye.real(), e = t.platform, i = t.version;
        return e === "ios" && B6(i, "13.3") <= 0;
      },
      options: {
        useResizeObserver: !1
      }
    }]);
  },
  _init() {
    this.callBase(), this._initContentReadyAction();
  },
  _innerWidgetOptionChanged: function(t, e) {
    var i = xn.getOptionsFromContainer(e);
    t && t.option(i), this._options.cache(e.name, i);
  },
  _bindInnerWidgetOptions(t, e) {
    var i = () => this._options.silent(e, P({}, t.option()));
    i(), t.on("optionChanged", i);
  },
  _getAriaTarget() {
    return this._focusTarget();
  },
  _initContentReadyAction() {
    this._contentReadyAction = this._createActionByOption("onContentReady", {
      excludeValidators: ["disabled", "readOnly"]
    });
  },
  _initMarkup() {
    var {
      disabled: t,
      visible: e
    } = this.option();
    this.$element().addClass("dx-widget"), this._toggleDisabledState(t), this._toggleVisibility(e), this._renderHint(), this._isFocusable() && this._renderFocusTarget(), this.callBase();
  },
  _render() {
    this.callBase(), this._renderContent(), this._renderFocusState(), this._attachFeedbackEvents(), this._attachHoverEvents(), this._toggleIndependentState();
  },
  _renderHint() {
    var {
      hint: t
    } = this.option();
    this.$element().attr("title", t || null);
  },
  _renderContent() {
    dn(() => this._disposed ? void 0 : this._renderContentImpl()).done(() => this._disposed ? void 0 : this._fireContentReadyAction());
  },
  _renderContentImpl: ee,
  _fireContentReadyAction: Sm(function() {
    return this._contentReadyAction();
  }),
  _dispose() {
    this._contentReadyAction = null, this._detachKeyboardEvents(), this.callBase();
  },
  _resetActiveState() {
    this._toggleActiveState(this._eventBindingTarget(), !1);
  },
  _clean() {
    this._cleanFocusState(), this._resetActiveState(), this.callBase(), this.$element().empty();
  },
  _toggleVisibility(t) {
    this.$element().toggleClass("dx-state-invisible", !t);
  },
  _renderFocusState() {
    this._attachKeyboardEvents(), this._isFocusable() && (this._renderFocusTarget(), this._attachFocusEvents(), this._renderAccessKey());
  },
  _renderAccessKey() {
    var t = this._focusTarget(), {
      accessKey: e
    } = this.option();
    t.attr("accesskey", e);
  },
  _isFocusable() {
    var {
      focusStateEnabled: t,
      disabled: e
    } = this.option();
    return t && !e;
  },
  _eventBindingTarget() {
    return this.$element();
  },
  _focusTarget() {
    return this._getActiveElement();
  },
  _isFocusTarget: function(t) {
    var e = E(this._focusTarget()).toArray();
    return e.includes(t);
  },
  _findActiveTarget(t) {
    return t.find(this._activeStateUnit).not(".dx-state-disabled");
  },
  _getActiveElement() {
    var t = this._eventBindingTarget();
    return this._activeStateUnit ? this._findActiveTarget(t) : t;
  },
  _renderFocusTarget() {
    var {
      tabIndex: t
    } = this.option();
    this._focusTarget().attr("tabIndex", t);
  },
  _keyboardEventBindingTarget() {
    return this._eventBindingTarget();
  },
  _refreshFocusEvent() {
    this._detachFocusEvents(), this._attachFocusEvents();
  },
  _focusEventTarget() {
    return this._focusTarget();
  },
  _focusInHandler(t) {
    t.isDefaultPrevented() || this._createActionByOption("onFocusIn", {
      beforeExecute: () => this._updateFocusState(t, !0),
      excludeValidators: ["readOnly"]
    })({
      event: t
    });
  },
  _focusOutHandler(t) {
    t.isDefaultPrevented() || this._createActionByOption("onFocusOut", {
      beforeExecute: () => this._updateFocusState(t, !1),
      excludeValidators: ["readOnly", "disabled"]
    })({
      event: t
    });
  },
  _updateFocusState(t, e) {
    var {
      target: i
    } = t;
    this._isFocusTarget(i) && this._toggleFocusClass(e, E(i));
  },
  _toggleFocusClass(t, e) {
    var i = e && e.length ? e : this._focusTarget();
    i.toggleClass("dx-state-focused", t);
  },
  _hasFocusClass(t) {
    var e = E(t || this._focusTarget());
    return e.hasClass("dx-state-focused");
  },
  _isFocused() {
    return this._hasFocusClass();
  },
  _getKeyboardListeners: () => [],
  _attachKeyboardEvents() {
    this._detachKeyboardEvents();
    var {
      focusStateEnabled: t,
      onKeyboardHandled: e
    } = this.option(), i = this._getKeyboardListeners().length, r = !!e, n = t || i || r;
    n && (this._keyboardListenerId = bh.on(this._keyboardEventBindingTarget(), this._focusTarget(), (a) => this._keyboardHandler(a)));
  },
  _keyboardHandler(t, e) {
    if (!e) {
      var {
        originalEvent: i,
        keyName: r,
        which: n
      } = t, a = this._supportedKeys(i), o = a[r] || a[n];
      if (o !== void 0) {
        var u = o.bind(this), c = u(i, t);
        if (!c)
          return !1;
      }
    }
    var p = this._getKeyboardListeners(), {
      onKeyboardHandled: v
    } = this.option();
    return p.forEach((_) => _ && _._keyboardHandler(t)), v && v(t), !0;
  },
  _refreshFocusState() {
    this._cleanFocusState(), this._renderFocusState();
  },
  _cleanFocusState() {
    var t = this._focusTarget();
    t.removeAttr("tabIndex"), this._toggleFocusClass(!1), this._detachFocusEvents(), this._detachKeyboardEvents();
  },
  _detachKeyboardEvents() {
    bh.off(this._keyboardListenerId), this._keyboardListenerId = null;
  },
  _attachHoverEvents() {
    var {
      hoverStateEnabled: t
    } = this.option(), e = this._activeStateUnit, i = this._eventBindingTarget();
    q$.off(i, {
      selector: e,
      namespace: "UIFeedback"
    }), t && q$.on(i, new $o((r) => {
      var {
        event: n,
        element: a
      } = r;
      this._hoverStartHandler(n), this.option("hoveredElement", E(a));
    }, {
      excludeValidators: ["readOnly"]
    }), (r) => {
      this.option("hoveredElement", null), this._hoverEndHandler(r);
    }, {
      selector: e,
      namespace: "UIFeedback"
    });
  },
  _attachFeedbackEvents() {
    var {
      activeStateEnabled: t
    } = this.option(), e = this._activeStateUnit, i = this._eventBindingTarget();
    Y$.off(i, {
      namespace: "UIFeedback",
      selector: e
    }), t && Y$.on(i, new $o((r) => {
      var {
        event: n,
        element: a
      } = r;
      return this._toggleActiveState(E(a), !0, n);
    }), new $o((r) => {
      var {
        event: n,
        element: a
      } = r;
      return this._toggleActiveState(E(a), !1, n);
    }, {
      excludeValidators: ["disabled", "readOnly"]
    }), {
      showTimeout: this._feedbackShowTimeout,
      hideTimeout: this._feedbackHideTimeout,
      selector: e,
      namespace: "UIFeedback"
    });
  },
  _detachFocusEvents() {
    var t = this._focusEventTarget();
    zw.off(t, {
      namespace: "".concat(this.NAME, "Focus")
    });
  },
  _attachFocusEvents() {
    var t = this._focusEventTarget();
    zw.on(t, (e) => this._focusInHandler(e), (e) => this._focusOutHandler(e), {
      namespace: "".concat(this.NAME, "Focus"),
      isFocusable: (e, i) => E(i).is(Ok)
    });
  },
  _hoverStartHandler: ee,
  _hoverEndHandler: ee,
  _toggleActiveState(t, e) {
    this.option("isActive", e), t.toggleClass("dx-state-active", e);
  },
  _updatedHover() {
    var t = this._options.silent("hoveredElement");
    this._hover(t, t);
  },
  _findHoverTarget(t) {
    return t && t.closest(this._activeStateUnit || this._eventBindingTarget());
  },
  _hover(t, e) {
    var {
      hoverStateEnabled: i,
      disabled: r,
      isActive: n
    } = this.option();
    if (e = this._findHoverTarget(e), e && e.toggleClass("dx-state-hover", !1), t && i && !r && !n) {
      var a = this._findHoverTarget(t);
      a && a.toggleClass("dx-state-hover", !0);
    }
  },
  _toggleDisabledState(t) {
    this.$element().toggleClass("dx-state-disabled", !!t), this.setAria("disabled", t || void 0);
  },
  _toggleIndependentState() {
    this.$element().toggleClass("dx-state-independent", this.option("ignoreParentReadOnly"));
  },
  _setWidgetOption(t, e) {
    if (this[t]) {
      if ($t(e[0])) {
        N(e[0], (a, o) => this._setWidgetOption(t, [a, o]));
        return;
      }
      var i = e[0], r = e[1];
      e.length === 1 && (r = this.option(i));
      var n = this["".concat(t, "OptionMap")];
      this[t].option(n ? n(i) : i, r);
    }
  },
  _optionChanged(t) {
    var {
      name: e,
      value: i,
      previousValue: r
    } = t;
    switch (e) {
      case "disabled":
        this._toggleDisabledState(i), this._updatedHover(), this._refreshFocusState();
        break;
      case "hint":
        this._renderHint();
        break;
      case "ignoreParentReadOnly":
        this._toggleIndependentState();
        break;
      case "activeStateEnabled":
        this._attachFeedbackEvents();
        break;
      case "hoverStateEnabled":
        this._attachHoverEvents(), this._updatedHover();
        break;
      case "tabIndex":
      case "focusStateEnabled":
        this._refreshFocusState();
        break;
      case "onFocusIn":
      case "onFocusOut":
      case "useResizeObserver":
        break;
      case "accessKey":
        this._renderAccessKey();
        break;
      case "hoveredElement":
        this._hover(i, r);
        break;
      case "isActive":
        this._updatedHover();
        break;
      case "visible":
        this._toggleVisibility(i), this._isVisibilityChangeSupported() && this._checkVisibilityChanged(i ? "shown" : "hiding");
        break;
      case "onKeyboardHandled":
        this._attachKeyboardEvents();
        break;
      case "onContentReady":
        this._initContentReadyAction();
        break;
      default:
        this.callBase(t);
    }
  },
  _isVisible() {
    var {
      visible: t
    } = this.option();
    return this.callBase() && t;
  },
  beginUpdate() {
    this._ready(!1), this.callBase();
  },
  endUpdate() {
    this.callBase(), this._initialized && this._ready(!0);
  },
  _ready(t) {
    if (arguments.length === 0)
      return this._isReady;
    this._isReady = t;
  },
  setAria() {
    if (!$t(arguments.length <= 0 ? void 0 : arguments[0]))
      DW(arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1], (arguments.length <= 2 ? void 0 : arguments[2]) || this._getAriaTarget());
    else {
      var t = (arguments.length <= 1 ? void 0 : arguments[1]) || this._getAriaTarget();
      N(arguments.length <= 0 ? void 0 : arguments[0], (e, i) => DW(e, i, t));
    }
  },
  isReady() {
    return this._ready();
  },
  repaint() {
    this._refresh();
  },
  focus() {
    zw.trigger(this._focusTarget());
  },
  registerKeyHandler(t, e) {
    var i = this._supportedKeys();
    this._supportedKeys = () => P(i, {
      [t]: e
    });
  }
});
xn.getOptionsFromContainer = (t) => {
  var {
    name: e,
    fullName: i,
    value: r
  } = t, n = {};
  if (e === i)
    n = r;
  else {
    var a = i.split(".").pop();
    n[a] = r;
  }
  return n;
};
var Pfe = Yx(), Ffe = "dx-loadindicator", Bfe = "dx-loadindicator-wrapper", Vfe = "dx-loadindicator-content", Nfe = "dx-loadindicator-icon", AW = "dx-loadindicator-segment", Hfe = "dx-loadindicator-segment-inner", $fe = "dx-loadindicator-image", us = xn.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      indicatorSrc: "",
      activeStateEnabled: !1,
      hoverStateEnabled: !1,
      _animatingSegmentCount: 1,
      _animatingSegmentInner: !1
    });
  },
  _defaultOptionsRules: function() {
    var t = ho();
    return this.callBase().concat([{
      device: function() {
        var e = Ye.real(), i = e.platform === "android" && !/chrome/i.test(Pfe.userAgent);
        return i;
      },
      options: {
        viaImage: !0
      }
    }, {
      device: function() {
        return fs(t);
      },
      options: {
        _animatingSegmentCount: 2,
        _animatingSegmentInner: !0
      }
    }, {
      device: function() {
        return KY(t);
      },
      options: {
        _animatingSegmentCount: 7
      }
    }]);
  },
  _useTemplates: function() {
    return !1;
  },
  _init: function() {
    this.callBase(), this.$element().addClass(Ffe);
  },
  _initMarkup: function() {
    this.callBase(), this._renderWrapper(), this._renderIndicatorContent(), this._renderMarkup();
  },
  _renderWrapper: function() {
    this._$wrapper = E("<div>").addClass(Bfe), this.$element().append(this._$wrapper);
  },
  _renderIndicatorContent: function() {
    this._$content = E("<div>").addClass(Vfe), this._$wrapper.append(this._$content);
  },
  _renderMarkup: function() {
    var {
      viaImage: t,
      indicatorSrc: e
    } = this.option();
    Fk() && !t && !e ? this._renderMarkupForAnimation() : this._renderMarkupForImage();
  },
  _renderMarkupForAnimation: function() {
    var t = this.option("_animatingSegmentInner");
    this._$indicator = E("<div>").addClass(Nfe), this._$content.append(this._$indicator);
    for (var e = this.option("_animatingSegmentCount"); e >= 0; --e) {
      var i = E("<div>").addClass(AW).addClass(AW + e);
      t && i.append(E("<div>").addClass(Hfe)), this._$indicator.append(i);
    }
  },
  _renderMarkupForImage: function() {
    var {
      indicatorSrc: t
    } = this.option();
    t ? (this._$wrapper.addClass($fe), this._$wrapper.css("backgroundImage", "url(" + t + ")")) : Fk() && this._renderMarkupForAnimation();
  },
  _renderDimensions: function() {
    this.callBase(), this._updateContentSizeForAnimation();
  },
  _updateContentSizeForAnimation: function() {
    if (this._$indicator) {
      var t = this.option("width"), e = this.option("height");
      if (t || e) {
        t = mt(this.$element()), e = Pt(this.$element());
        var i = Math.min(e, t);
        this._$wrapper.css({
          height: i,
          width: i,
          fontSize: i
        });
      }
    }
  },
  _clean: function() {
    this.callBase(), this._removeMarkupForAnimation(), this._removeMarkupForImage();
  },
  _removeMarkupForAnimation: function() {
    this._$indicator && (this._$indicator.remove(), delete this._$indicator);
  },
  _removeMarkupForImage: function() {
    this._$wrapper.css("backgroundImage", "none");
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "_animatingSegmentCount":
      case "_animatingSegmentInner":
      case "indicatorSrc":
        this._invalidate();
        break;
      default:
        this.callBase(t);
    }
  }
});
ti("dxLoadIndicator", us);
var hB = "dxTranslator", zfe = /matrix(3d)?\((.+?)\)/, Wfe = /translate(?:3d)?\((.+?)\)/, zs = function(t) {
  t = E(t);
  var e = PT(t);
  return {
    left: e.x,
    top: e.y
  };
};
function kT(t) {
  return cs(t) === "string" && t[t.length - 1] === "%";
}
function V6(t, e) {
  t.length && dr(t.get(0), hB, e);
}
var fB = function(t) {
  t.length && iI(t.get(0), hB);
}, yS = function(t) {
  t.x = t.x || 0, t.y = t.y || 0;
  var e = kT(t.x) ? t.x : t.x + "px", i = kT(t.y) ? t.y : t.y + "px";
  return "translate(" + e + ", " + i + ")";
}, PT = function(t) {
  var e = t.length ? dr(t.get(0), hB) : null;
  if (!e) {
    var i = t.css("transform") || yS({
      x: 0,
      y: 0
    }), r = i.match(zfe), n = r && r[1];
    r ? (r = r[2].split(","), n === "3d" ? r = r.slice(12, 15) : (r.push(0), r = r.slice(4, 7))) : r = [0, 0, 0], e = {
      x: parseFloat(r[0]),
      y: parseFloat(r[1]),
      z: parseFloat(r[2])
    }, V6(t, e);
  }
  return e;
}, Nn = function(t, e) {
  t = E(t);
  var i = e.left, r = e.top, n;
  i === void 0 ? (n = PT(t), n.y = r || 0) : r === void 0 ? (n = PT(t), n.x = i || 0) : (n = {
    x: i || 0,
    y: r || 0,
    z: 0
  }, V6(t, n)), t.css({
    transform: yS(n)
  }), (kT(i) || kT(r)) && fB(t);
}, xS = function(t, e) {
  t = E(t);
  var i, r = {
    left: 0,
    top: 0,
    transform: "none"
  };
  e && (i = t.css("transition"), r.transition = "none"), t.css(r), fB(t), e && (t.get(0).offsetHeight, t.css("transition", i));
}, Ufe = function(t) {
  var e = t.match(Wfe);
  if (!(!e || !e[1]))
    return e = e[1].split(","), e = {
      x: parseFloat(e[0]),
      y: parseFloat(e[1]),
      z: parseFloat(e[2])
    }, e;
}, OW = /cubic-bezier\((\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\)/, RW = {
  linear: "cubic-bezier(0, 0, 1, 1)",
  swing: "cubic-bezier(0.445, 0.05, 0.55, 0.95)",
  ease: "cubic-bezier(0.25, 0.1, 0.25, 1)",
  "ease-in": "cubic-bezier(0.42, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.58, 1)",
  "ease-in-out": "cubic-bezier(0.42, 0, 0.58, 1)"
}, Gfe = function(t, e, i, r) {
  var n = 3 * t, a = 3 * (i - t) - n, o = 1 - n - a, u = 3 * e, c = 3 * (r - e) - u, p = 1 - u - c, v = function(y) {
    return y * (n + y * (a + y * o));
  }, _ = function(y) {
    return n + y * (2 * a + 3 * y * o);
  };
  return function(y) {
    return function(b) {
      return b * (u + b * (c + b * p));
    }(function(b) {
      for (var I = b, A = 0, L; A < 14 && (L = v(I) - b, !(Math.abs(L) < 1e-3)); )
        I -= L / _(I), A++;
      return I;
    }(y));
  };
}, pP = {}, Kfe = function(t) {
  t = RW[t] || t;
  var e = t.match(OW), i;
  e || (i = "linear", e = RW[i].match(OW)), e = e.slice(1, 5);
  for (var r = 0; r < e.length; r++)
    e[r] = parseFloat(e[r]);
  var n = i || "cubicbezier_" + e.join("_").replace(/\./g, "p");
  return Le(pP[n]) || (pP[n] = function(a, o, u, c, p) {
    return c * Gfe(e[0], e[1], e[2], e[3])(o / p) + u;
  }), n;
};
function jfe(t) {
  return pP[t];
}
var LW = Ot(), Yfe = /left|right/, qfe = /top|bottom/, MW = /fit|flip|none/, Xfe = /scale\(.+?\)/, Qfe = $i.safari, vP = function(t) {
  var e = {
    h: "center",
    v: "center"
  }, i = Nm(t);
  return i && N(i, function() {
    var r = String(this).toLowerCase();
    Yfe.test(r) ? e.h = r : qfe.test(r) && (e.v = r);
  }), e;
}, kW = function(t, e) {
  return ej(t, e);
}, Zfe = function(t) {
  var e = Nm(t), i = String(e && e[0]).toLowerCase(), r = String(e && e[1]).toLowerCase();
  return MW.test(i) || (i = "none"), MW.test(r) || (r = i), {
    h: i,
    v: r
  };
}, PW = function(t) {
  switch (t) {
    case "center":
      return 0.5;
    case "right":
    case "bottom":
      return 1;
    default:
      return 0;
  }
}, gP = function(t) {
  switch (t) {
    case "left":
      return "right";
    case "right":
      return "left";
    case "top":
      return "bottom";
    case "bottom":
      return "top";
    default:
      return t;
  }
}, mP = function(t, e) {
  var i = 0;
  return t.myLocation < e.min && (i += e.min - t.myLocation), t.myLocation > e.max && (i += t.myLocation - e.max), i;
}, FW = function(t, e, i) {
  return e.myLocation < i.min ? t === "h" ? "left" : "top" : e.myLocation > i.max ? t === "h" ? "right" : "bottom" : "none";
}, _P = function(t) {
  t.myLocation = t.atLocation + PW(t.atAlign) * t.atSize - PW(t.myAlign) * t.mySize + t.offset;
}, Ub = {
  fit: function(t, e) {
    var i = !1;
    t.myLocation > e.max && (t.myLocation = e.max, i = !0), t.myLocation < e.min && (t.myLocation = e.min, i = !0), t.fit = i;
  },
  flip: function(t, e) {
    if (t.flip = !1, !(t.myAlign === "center" && t.atAlign === "center") && (t.myLocation < e.min || t.myLocation > e.max)) {
      var i = P({}, t, {
        myAlign: gP(t.myAlign),
        atAlign: gP(t.atAlign),
        offset: -t.offset
      });
      _P(i), i.oversize = mP(i, e), (i.myLocation >= e.min && i.myLocation <= e.max || t.oversize > i.oversize) && (t.myLocation = i.myLocation, t.oversize = i.oversize, t.flip = !0);
    }
  },
  flipfit: function(t, e) {
    this.flip(t, e), this.fit(t, e);
  },
  none: function(t) {
    t.oversize = 0;
  }
}, N6, H6 = function() {
  var t = E("<div>").css({
    width: 100,
    height: 100,
    overflow: "scroll",
    position: "absolute",
    top: -9999
  }).appendTo(E("body")), e = t.get(0).offsetWidth - t.get(0).clientWidth;
  t.remove(), N6 = e;
}, Jfe = {
  h: {
    location: 0,
    flip: !1,
    fit: !1,
    oversize: 0
  },
  v: {
    location: 0,
    flip: !1,
    fit: !1,
    oversize: 0
  }
}, $6 = function(t, e) {
  var i = E(t), r = i.offset(), n = P(!0, {}, Jfe, {
    h: {
      location: r.left
    },
    v: {
      location: r.top
    }
  });
  if (!e)
    return n;
  var a = vP(e.my), o = vP(e.at), u = E(e.of).length && e.of || LW, c = kW(e.offset, e.precise), p = Zfe(e.collision), v = e.boundary, _ = kW(e.boundaryOffset, e.precise), y = {
    mySize: oi(i),
    myAlign: a.h,
    atAlign: o.h,
    offset: c.h,
    collision: p.h,
    boundaryOffset: _.h
  }, b = {
    mySize: jt(i),
    myAlign: a.v,
    atAlign: o.v,
    offset: c.v,
    collision: p.v,
    boundaryOffset: _.v
  };
  if (u.preventDefault)
    y.atLocation = u.pageX, b.atLocation = u.pageY, y.atSize = 0, b.atSize = 0;
  else if (u = E(u), Or(u[0]))
    y.atLocation = u.scrollLeft(), b.atLocation = u.scrollTop(), Ye.real().deviceType === "phone" && u[0].visualViewport ? (y.atLocation = Math.max(y.atLocation, u[0].visualViewport.offsetLeft), b.atLocation = Math.max(b.atLocation, u[0].visualViewport.offsetTop), y.atSize = u[0].visualViewport.width, b.atSize = u[0].visualViewport.height) : (y.atSize = u[0].innerWidth > u[0].outerWidth ? u[0].innerWidth : mt(u), b.atSize = u[0].innerHeight > u[0].outerHeight || Qfe ? u[0].innerHeight : Pt(u));
  else if (u[0].nodeType === 9)
    y.atLocation = 0, b.atLocation = 0, y.atSize = mt(u), b.atSize = Pt(u);
  else {
    var I = zr(u.get(0)), A = z6(u);
    y.atLocation = A.left, b.atLocation = A.top, y.atSize = Math.max(I.width, oi(u)), b.atSize = Math.max(I.height, jt(u));
  }
  _P(y), _P(b);
  var L = function() {
    var $ = E(LW), K = mt($), te = Pt($), z = $.scrollLeft(), ie = $.scrollTop(), pe = de.getDocumentElement(), _e = Ip ? pe.clientWidth / K : 1, be = Ip ? pe.clientHeight / te : 1;
    N6 === void 0 && H6();
    var De = K, Ce = te;
    if (v && !Or(v)) {
      var ft = E(v), Ve = ft.offset();
      z = Ve.left, ie = Ve.top, De = mt(ft), Ce = Pt(ft);
    }
    return {
      h: {
        min: z + y.boundaryOffset,
        max: z + De / _e - y.mySize - y.boundaryOffset
      },
      v: {
        min: ie + b.boundaryOffset,
        max: ie + Ce / be - b.mySize - b.boundaryOffset
      }
    };
  }();
  y.oversize = mP(y, L.h), b.oversize = mP(b, L.v), y.collisionSide = FW("h", y, L.h), b.collisionSide = FW("v", b, L.v), Ub[y.collision] && Ub[y.collision](y, L.h), Ub[b.collision] && Ub[b.collision](b, L.v);
  var B = function($) {
    return e.precise ? $ : Math.round($);
  };
  return P(!0, n, {
    h: {
      location: B(y.myLocation),
      oversize: B(y.oversize),
      fit: y.fit,
      flip: y.flip,
      collisionSide: y.collisionSide
    },
    v: {
      location: B(b.myLocation),
      oversize: B(b.oversize),
      fit: b.fit,
      flip: b.flip,
      collisionSide: b.collisionSide
    },
    precise: e.precise
  }), n;
}, BW = function(t, e, i, r) {
  var n = R(t.style) && !de.isNode(t.style), a = r ? i.replace(e, "") : i;
  if (n)
    pj(t, a, !1);
  else {
    var o = de.createAttribute("style");
    o.value = a, t.setAttributeNode(o);
  }
}, z6 = function t(e) {
  var i, r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, a = n.get(0);
  if (!a)
    return e.offset();
  var o = ((i = a.getAttribute) === null || i === void 0 ? void 0 : i.call(a, "style")) || "", u = (r = o.match(Xfe)) === null || r === void 0 ? void 0 : r[0], c;
  return u ? (BW(a, u, o, !0), c = t(e, n.parent()), BW(a, u, o, !1)) : c = t(e, n.parent()), c;
}, $x = function(t, e) {
  var i = E(t);
  if (!e)
    return i.offset();
  xS(i, !0);
  var r = z6(i), n = e.h && e.v ? e : $6(i, e), a = function(o) {
    return e.precise ? o : Math.round(o);
  };
  return Nn(i, {
    left: n.h.location - a(r.left),
    top: n.v.location - a(r.top)
  }), n;
}, epe = function(t) {
  return t = E(t).get(0), Or(t) ? null : t && "pageY" in t && "pageX" in t ? {
    top: t.pageY,
    left: t.pageX
  } : E(t).offset();
};
$x.inverseAlign || ($x.inverseAlign = gP);
$x.normalizeAlign || ($x.normalizeAlign = vP);
const kl = {
  calculateScrollbarWidth: H6,
  calculate: $6,
  setup: $x,
  offset: epe
};
var W6 = Ot(), gx = ve(fo, "dxFX"), tpe = /^([+-])=(.*)/i, zx = "dxAnimData", pB = "dxAnimQueue", Rl = "transform", ipe = {
  initAnimation: function(t, e) {
    t.css({
      transitionProperty: "none"
    }), typeof e.from == "string" ? t.addClass(e.from) : yP(t, e.from);
    var i = this, r = new q(), n = e.cleanupWhen;
    e.transitionAnimation = {
      deferred: r,
      finish: function() {
        i._finishTransition(t), n ? $e(r, n).always(function() {
          i._cleanup(t, e);
        }) : i._cleanup(t, e), r.resolveWith(t, [e, t]);
      }
    }, this._completeAnimationCallback(t, e).done(function() {
      e.transitionAnimation.finish();
    }).fail(function() {
      r.rejectWith(t, [e, t]);
    }), e.duration || e.transitionAnimation.finish(), t.css("transform");
  },
  animate: function(t, e) {
    return this._startAnimation(t, e), e.transitionAnimation.deferred.promise();
  },
  _completeAnimationCallback: function(t, e) {
    var i = this, r = Date.now() + e.delay, n = new q(), a = new q(), o = new q(), u, c = LY() + ".dxFX";
    e.transitionAnimation.cleanup = function() {
      clearTimeout(u), clearTimeout(p), k.off(t, c), k.off(t, gx);
    }, k.one(t, c, function() {
      Date.now() - r >= e.duration && a.reject();
    }), k.off(t, gx), k.on(t, gx, function() {
      i.stop(t, e), n.reject();
    });
    var p = setTimeout(function() {
      u = setTimeout(function() {
        o.reject();
      }, e.duration + e.delay + ji._simulatedTransitionEndDelay), $e(a, o).fail((function() {
        n.resolve();
      }).bind(this));
    });
    return n.promise();
  },
  _startAnimation: function(t, e) {
    t.css({
      transitionProperty: "all",
      transitionDelay: e.delay + "ms",
      transitionDuration: e.duration + "ms",
      transitionTimingFunction: e.easing
    }), typeof e.to == "string" ? t[0].className += " " + e.to : e.to && yP(t, e.to);
  },
  _finishTransition: function(t) {
    t.css("transition", "none");
  },
  _cleanup: function(t, e) {
    e.transitionAnimation.cleanup(), typeof e.from == "string" && (t.removeClass(e.from), t.removeClass(e.to));
  },
  stop: function(t, e, i) {
    e && (i ? e.transitionAnimation.finish() : ($t(e.to) && N(e.to, function(r) {
      t.css(r, t.css(r));
    }), this._finishTransition(t), this._cleanup(t, e)));
  }
}, VW = {
  initAnimation: function(t, e) {
    yP(t, e.from);
  },
  animate: function(t, e) {
    var i = new q(), r = this;
    return e ? (N(e.to, function(n) {
      e.from[n] === void 0 && (e.from[n] = r._normalizeValue(t.css(n)));
    }), e.to[Rl] && (e.from[Rl] = r._parseTransform(e.from[Rl]), e.to[Rl] = r._parseTransform(e.to[Rl])), e.frameAnimation = {
      to: e.to,
      from: e.from,
      currentValue: e.from,
      easing: Kfe(e.easing),
      duration: e.duration,
      startTime: (/* @__PURE__ */ new Date()).valueOf(),
      finish: function() {
        this.currentValue = this.to, this.draw(), Nd(e.frameAnimation.animationFrameId), i.resolve();
      },
      draw: function() {
        if (e.draw) {
          e.draw(this.currentValue);
          return;
        }
        var n = P({}, this.currentValue);
        n[Rl] && (n[Rl] = Jr(n[Rl], function(a, o) {
          if (o === "translate")
            return yS(a);
          if (o === "scale")
            return "scale(" + a + ")";
          if (o.substr(0, o.length - 1) === "rotate")
            return o + "(" + a + "deg)";
        }).join(" ")), t.css(n);
      }
    }, e.delay ? (e.frameAnimation.startTime += e.delay, e.frameAnimation.delayTimeout = setTimeout(function() {
      r._startAnimation(t, e);
    }, e.delay)) : r._startAnimation(t, e), i.promise()) : i.reject().promise();
  },
  _startAnimation: function(t, e) {
    k.off(t, gx), k.on(t, gx, function() {
      e.frameAnimation && Nd(e.frameAnimation.animationFrameId);
    }), this._animationStep(t, e);
  },
  _parseTransform: function(t) {
    var e = {};
    return N(t.match(/\w+\d*\w*\([^)]*\)\s*/g), function(i, r) {
      var n = Ufe(r), a = r.match(/scale\((.+?)\)/), o = r.match(/(rotate.)\((.+)deg\)/);
      n && (e.translate = n), a && a[1] && (e.scale = parseFloat(a[1])), o && o[1] && (e[o[1]] = parseFloat(o[2]));
    }), e;
  },
  stop: function(t, e, i) {
    var r = e && e.frameAnimation;
    r && (Nd(r.animationFrameId), clearTimeout(r.delayTimeout), i && r.finish(), delete e.frameAnimation);
  },
  _animationStep: function(t, e) {
    var i = e && e.frameAnimation;
    if (i) {
      var r = (/* @__PURE__ */ new Date()).valueOf();
      if (r >= i.startTime + i.duration) {
        i.finish();
        return;
      }
      i.currentValue = this._calcStepValue(i, r - i.startTime), i.draw();
      var n = this;
      i.animationFrameId = Fx(function() {
        n._animationStep(t, e);
      });
    }
  },
  _calcStepValue: function(t, e) {
    return function i(r, n) {
      var a = Array.isArray(n) ? [] : {};
      return N(n, function(o, u) {
        if (typeof u == "string" && parseFloat(u) === !1)
          return !0;
        a[o] = typeof u == "object" ? i(r[o], u) : function(c) {
          var p = e / t.duration, v = e, _ = 1 * r[c], y = n[c] - r[c], b = t.duration;
          return jfe(t.easing)(p, v, _, y, b);
        }(o);
      }), a;
    }(t.from, t.to);
  },
  _normalizeValue: function(t) {
    var e = parseFloat(t);
    return e === !1 ? t : e;
  }
}, rpe = {
  initAnimation: function() {
  },
  animate: function() {
    return new q().resolve().promise();
  },
  stop: ee,
  isSynchronous: !0
}, npe = function(t) {
  t = t || {};
  var e = {
    transition: Pk() ? ipe : VW,
    frame: VW,
    noAnimation: rpe
  }, i = t.strategy || "transition";
  return t.type === "css" && !Pk() && (i = "noAnimation"), e[i];
}, U6 = function(t, e, i, r) {
  N(["from", "to"], function() {
    if (!i(t[this]))
      throw bi.Error("E0010", e, this, r);
  });
}, G6 = function(t, e) {
  return U6(t, e, function(i) {
    return $t(i);
  }, "a plain object");
}, ape = function(t, e) {
  return U6(t, e, function(i) {
    return typeof i == "string";
  }, "a string");
}, ope = {
  setup: function() {
  }
}, spe = {
  validateConfig: function(t) {
    ape(t, "css");
  },
  setup: function() {
  }
}, lpe = {
  top: {
    my: "bottom center",
    at: "top center"
  },
  bottom: {
    my: "top center",
    at: "bottom center"
  },
  right: {
    my: "left center",
    at: "right center"
  },
  left: {
    my: "right center",
    at: "left center"
  }
}, vL = {
  validateConfig: function(t) {
    G6(t, "slide");
  },
  setup: function(t, e) {
    var i = zs(t);
    if (e.type !== "slide") {
      var r = e.type === "slideIn" ? e.from : e.to;
      r.position = P({
        of: W6
      }, lpe[e.direction]), CP(t, r);
    }
    this._setUpConfig(i, e.from), this._setUpConfig(i, e.to), fB(t);
  },
  _setUpConfig: function(t, e) {
    e.left = "left" in e ? e.left : "+=0", e.top = "top" in e ? e.top : "+=0", this._initNewPosition(t, e);
  },
  _initNewPosition: function(t, e) {
    var i = {
      left: e.left,
      top: e.top
    };
    delete e.left, delete e.top;
    var r = this._getRelativeValue(i.left);
    r !== void 0 ? i.left = r + t.left : e.left = 0, r = this._getRelativeValue(i.top), r !== void 0 ? i.top = r + t.top : e.top = 0, e[Rl] = yS({
      x: i.left,
      y: i.top
    });
  },
  _getRelativeValue: function(t) {
    var e;
    if (typeof t == "string" && (e = tpe.exec(t)))
      return parseInt(e[1] + "1") * e[2];
  }
}, gL = {
  setup: function(t, e) {
    var i, r, n = e.from, a = e.to, o = e.type === "fadeOut" ? 1 : 0, u = e.type === "fadeOut" ? 0 : 1, c = $t(n) ? String((i = n.opacity) !== null && i !== void 0 ? i : o) : String(n), p = $t(a) ? String((r = a.opacity) !== null && r !== void 0 ? r : u) : String(a);
    switch (e.skipElementInitialStyles || (c = t.css("opacity")), e.type) {
      case "fadeIn":
        p = 1;
        break;
      case "fadeOut":
        p = 0;
    }
    e.from = {
      visibility: "visible",
      opacity: c
    }, e.to = {
      opacity: p
    };
  }
}, upe = {
  validateConfig: function(t) {
    G6(t, "pop");
  },
  setup: function(t, e) {
    var i = e.from, r = e.to, n = "opacity" in i ? i.opacity : t.css("opacity"), a = "opacity" in r ? r.opacity : 1, o = "scale" in i ? i.scale : 0, u = "scale" in r ? r.scale : 1;
    e.from = {
      opacity: n
    };
    var c = PT(t);
    e.from[Rl] = this._getCssTransform(c, o), e.to = {
      opacity: a
    }, e.to[Rl] = this._getCssTransform(c, u);
  },
  _getCssTransform: function(t, e) {
    return yS(t) + "scale(" + e + ")";
  }
}, K6 = {
  custom: ope,
  slide: vL,
  slideIn: vL,
  slideOut: vL,
  fade: gL,
  fadeIn: gL,
  fadeOut: gL,
  pop: upe,
  css: spe
}, dpe = function(t) {
  var e = K6[t.type];
  if (!e)
    throw bi.Error("E0011", t.type);
  return e;
}, cpe = {
  type: "custom",
  from: {},
  to: {},
  duration: 400,
  start: ee,
  complete: ee,
  easing: "ease",
  delay: 0
}, hpe = {
  duration: 400,
  easing: "ease",
  delay: 0
};
function fpe() {
  var t = this.element, e = this.config;
  if (CP(t, e.from), CP(t, e.to), this.configurator.setup(t, e), t.data(zx, this), ji.off && (e.duration = 0, e.delay = 0), this.strategy.initAnimation(t, e), e.start) {
    var i = ot(t);
    e.start.apply(this, [i, e]);
  }
}
var ppe = function(t) {
  var e = t.element, i = t.config;
  if (e.removeData(zx), i.complete) {
    var r = ot(e);
    i.complete.apply(this, [r, i]);
  }
  t.deferred.resolveWith(this, [e, i]);
}, vpe = function() {
  var t = this, e = t.element, i = t.config;
  return t.isStarted = !0, t.strategy.animate(e, i).done(function() {
    ppe(t);
  }).fail(function() {
    t.deferred.rejectWith(this, [e, i]);
  });
}, gpe = function(t) {
  var e = this.element, i = this.config;
  clearTimeout(this.startTimeout), this.isStarted || this.start(), this.strategy.stop(e, i, t);
}, mL = ve(fo, "dxFXStartAnimation"), mpe = function(t) {
  k.off(t.element, mL), k.on(t.element, mL, function() {
    ji.stop(t.element);
  }), t.deferred.always(function() {
    k.off(t.element, mL);
  });
}, j6 = function(t, e) {
  var i = e.type === "css" ? hpe : cpe, r = P(!0, {}, i, e), n = dpe(r), a = npe(r), o = {
    element: E(t),
    config: r,
    configurator: n,
    strategy: a,
    isSynchronous: a.isSynchronous,
    setup: fpe,
    start: vpe,
    stop: gpe,
    deferred: new q()
  };
  return Le(n.validateConfig) && n.validateConfig(r), mpe(o), o;
}, _pe = function(t, e) {
  var i = E(t);
  if (!i.length)
    return new q().resolve().promise();
  var r = j6(i, e);
  return Cpe(i, r), r.deferred.promise();
};
function Cpe(t, e) {
  var i = vB(t);
  ype(t, i), i.push(e), EI(t) || gB(t, i);
}
function vB(t) {
  return t.data(pB) || [];
}
function ype(t, e) {
  t.data(pB, e);
}
var Y6 = function(t) {
  t.removeData(pB);
};
function EI(t) {
  return !!t.data(zx);
}
function gB(t, e) {
  if (e = vB(t), !!e.length) {
    var i = e.shift();
    e.length === 0 && Y6(t), xpe(i).done(function() {
      EI(t) || gB(t);
    });
  }
}
function xpe(t) {
  return t.setup(), ji.off || t.isSynchronous ? t.start() : t.startTimeout = setTimeout(function() {
    t.start();
  }), t.deferred.promise();
}
function CP(t, e) {
  if (!(!e || !e.position)) {
    var i = E(W6), r = 0, n = 0, a = kl.calculate(t, e.position), o = t.offset(), u = t.position();
    u.top > o.top && (n = i.scrollTop()), u.left > o.left && (r = i.scrollLeft()), P(e, {
      left: a.h.location - o.left + u.left - r,
      top: a.v.location - o.top + u.top - n
    }), delete e.position;
  }
}
function yP(t, e) {
  N(e, function(i, r) {
    try {
      t.css(i, Le(r) ? r() : r);
    } catch {
    }
  });
}
var Spe = function(t, e) {
  var i = E(t), r = vB(i);
  N(r, function(a, o) {
    o.config.delay = 0, o.config.duration = 0, o.isSynchronous = !0;
  }), EI(i) || gB(i, r);
  var n = i.data(zx);
  n && n.stop(e), i.removeData(zx), Y6(i);
}, ji = {
  off: !1,
  animationTypes: K6,
  animate: _pe,
  createAnimation: j6,
  isAnimating: EI,
  stop: Spe,
  _simulatedTransitionEndDelay: 100
}, Rp = "dxdragstart", Rh = "dxdrag", Lp = "dxdragend", bI = "dxdragenter", wI = "dxdragleave", mB = "dxdrop", Gb = "dxDragEventsCount", $d = [], Cm = [], xP = [], _B = {
  setup: function(t, e) {
    var i = $d.includes(t);
    i || ($d.push(t), Cm.push([]), xP.push(e || {}));
  },
  add: function(t, e) {
    var i = $d.indexOf(t);
    this.updateEventsCounter(t, e.type, 1);
    var r = e.selector;
    Cm[i].includes(r) || Cm[i].push(r);
  },
  updateEventsCounter: function(t, e, i) {
    if ([bI, wI, mB].indexOf(e) > -1) {
      var r = dr(t, Gb) || 0;
      dr(t, Gb, Math.max(0, r + i));
    }
  },
  remove: function(t, e) {
    this.updateEventsCounter(t, e.type, -1);
  },
  teardown: function(t) {
    var e = dr(t, Gb);
    if (!e) {
      var i = $d.indexOf(t);
      $d.splice(i, 1), Cm.splice(i, 1), xP.splice(i, 1), iI(t, Gb);
    }
  }
};
Ys(bI, _B);
Ys(wI, _B);
Ys(mB, _B);
var Epe = function(t) {
  var e = $d.indexOf(t.get(0)), i = Cm[e].filter((n) => n), r = t.find(i.join(", "));
  return Cm[e].includes(void 0) && (r = r.add(t)), r;
}, bpe = function(t) {
  var e = $d.indexOf(t.get(0));
  return xP[e];
}, wpe = function(t, e) {
  return t.itemPositionFunc ? t.itemPositionFunc(e) : e.offset();
}, Tpe = function(t, e) {
  return t.itemSizeFunc ? t.itemSizeFunc(e) : {
    width: e.get(0).getBoundingClientRect().width,
    height: e.get(0).getBoundingClientRect().height
  };
}, Ipe = fS.inherit({
  ctor: function(t) {
    this.callBase(t), this.direction = "both";
  },
  _init: function(t) {
    this._initEvent = t;
  },
  _start: function(t) {
    if (t = this._fireEvent(Rp, this._initEvent), this._maxLeftOffset = t.maxLeftOffset, this._maxRightOffset = t.maxRightOffset, this._maxTopOffset = t.maxTopOffset, this._maxBottomOffset = t.maxBottomOffset, t.targetElements || t.targetElements === null) {
      var e = voe(t.targetElements || []);
      this._dropTargets = Jr(e, function(i) {
        return E(i).get(0);
      });
    } else
      this._dropTargets = $d;
  },
  _move: function(t) {
    var e = br(t), i = this._calculateOffset(e);
    t = this._fireEvent(Rh, t, {
      offset: i
    }), this._processDropTargets(t), t._cancelPreventDefault || t.preventDefault();
  },
  _calculateOffset: function(t) {
    return {
      x: this._calculateXOffset(t),
      y: this._calculateYOffset(t)
    };
  },
  _calculateXOffset: function(t) {
    if (this.direction !== "vertical") {
      var e = t.x - this._startEventData.x;
      return this._fitOffset(e, this._maxLeftOffset, this._maxRightOffset);
    }
    return 0;
  },
  _calculateYOffset: function(t) {
    if (this.direction !== "horizontal") {
      var e = t.y - this._startEventData.y;
      return this._fitOffset(e, this._maxTopOffset, this._maxBottomOffset);
    }
    return 0;
  },
  _fitOffset: function(t, e, i) {
    return e != null && (t = Math.max(t, -e)), i != null && (t = Math.min(t, i)), t;
  },
  _processDropTargets: function(t) {
    var e = this._findDropTarget(t), i = e === this._currentDropTarget;
    i || (this._fireDropTargetEvent(t, wI), this._currentDropTarget = e, this._fireDropTargetEvent(t, bI));
  },
  _fireDropTargetEvent: function(t, e) {
    if (this._currentDropTarget) {
      var i = {
        type: e,
        originalEvent: t,
        draggingElement: this._$element.get(0),
        target: this._currentDropTarget
      };
      Bh(i);
    }
  },
  _findDropTarget: function(t) {
    var e = this, i;
    return N($d, function(r, n) {
      if (e._checkDropTargetActive(n)) {
        var a = E(n);
        N(Epe(a), function(o, u) {
          var c = E(u);
          e._checkDropTarget(bpe(a), c, E(i), t) && (i = u);
        });
      }
    }), i;
  },
  _checkDropTargetActive: function(t) {
    var e = !1;
    return N(this._dropTargets, function(i, r) {
      return e = e || r === t || Kd(r, t), !e;
    }), e;
  },
  _checkDropTarget: function(t, e, i, r) {
    var n = e.get(0) === E(r.target).get(0);
    if (n)
      return !1;
    var a = wpe(t, e);
    if (r.pageX < a.left || r.pageY < a.top)
      return !1;
    var o = Tpe(t, e);
    return r.pageX > a.left + o.width || r.pageY > a.top + o.height || i.length && i.closest(e).length || t.checkDropTarget && !t.checkDropTarget(e, r) ? !1 : e;
  },
  _end: function(t) {
    var e = br(t);
    this._fireEvent(Lp, t, {
      offset: this._calculateOffset(e)
    }), this._fireDropTargetEvent(t, mB), delete this._currentDropTarget;
  }
});
zm({
  emitter: Ipe,
  events: [Rp, Rh, Lp]
});
var NW = /* @__PURE__ */ function() {
  var t = [];
  return {
    add: function(e) {
      t.includes(e) || t.push(e);
    },
    remove: function(e) {
      var i = t.indexOf(e);
      i !== -1 && t.splice(i, 1);
    },
    fire: function() {
      var e = t.pop(), i = !!e;
      return i && e(), i;
    },
    hasCallback: function() {
      return t.length > 0;
    }
  };
}(), Kw = 1500, Th = [], Dpe = (t) => (Kw = cr(t, Kw), Kw), q6 = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Kw, e = Th.length, i = (e ? Th[e - 1] : t) + 1;
  return Th.push(i), i;
}, SP = (t) => {
  var e = Th.indexOf(t);
  e >= 0 && Th.splice(e, 1);
}, Ape = (t) => Th.length && Th[Th.length - 1] === t;
var _L = "dx-swatch-", Ope = (t) => {
  var e = E(t), i = e.closest('[class^="'.concat(_L, '"], [class*=" ').concat(_L, '"]')), r = Oh();
  if (!i.length)
    return r;
  var n = new RegExp("(\\s|^)(".concat(_L, ".*?)(\\s|$)")), a = i[0].className.match(n)[2], o = r.children("." + a);
  return o.length || (o = E("<div>").addClass(a).appendTo(r)), o;
};
const X6 = {
  getSwatchContainer: Ope
};
var Rpe = Ot(), Q6 = {
  top: {
    my: "top center",
    at: "top center"
  },
  bottom: {
    my: "bottom center",
    at: "bottom center"
  },
  right: {
    my: "right center",
    at: "right center"
  },
  left: {
    my: "left center",
    at: "left center"
  },
  center: {
    my: "center",
    at: "center"
  },
  "right bottom": {
    my: "right bottom",
    at: "right bottom"
  },
  "right top": {
    my: "right top",
    at: "right top"
  },
  "left bottom": {
    my: "left bottom",
    at: "left bottom"
  },
  "left top": {
    my: "left top",
    at: "left top"
  }
}, HW = {
  h: 0,
  v: 0
};
class Z6 {
  constructor(e) {
    var {
      position: i,
      container: r,
      visualContainer: n,
      $root: a,
      $content: o,
      $wrapper: u,
      onPositioned: c,
      onVisualPositionChanged: p,
      restorePosition: v,
      _fixWrapperPosition: _,
      _skipContentPositioning: y
    } = e;
    this._props = {
      position: i,
      container: r,
      visualContainer: n,
      restorePosition: v,
      onPositioned: c,
      onVisualPositionChanged: p,
      _fixWrapperPosition: _,
      _skipContentPositioning: y
    }, this._$root = a, this._$content = o, this._$wrapper = u, this._$markupContainer = void 0, this._$visualContainer = void 0, this._shouldRenderContentInitialPosition = !0, this._visualPosition = void 0, this._initialPosition = void 0, this._previousVisualPosition = void 0, this.updateContainer(r), this.updatePosition(i), this.updateVisualContainer(n);
  }
  get $container() {
    return this.updateContainer(), this._$markupContainer;
  }
  get $visualContainer() {
    return this._$visualContainer;
  }
  get position() {
    return this._position;
  }
  set fixWrapperPosition(e) {
    this._props._fixWrapperPosition = e, this.styleWrapperPosition();
  }
  set restorePosition(e) {
    this._props.restorePosition = e;
  }
  restorePositionOnNextRender(e) {
    this._shouldRenderContentInitialPosition = e || !this._visualPosition;
  }
  openingHandled() {
    var e = this._props.restorePosition;
    this.restorePositionOnNextRender(e);
  }
  updatePosition(e) {
    this._props.position = e, this._position = this._normalizePosition(e), this.updateVisualContainer();
  }
  updateContainer() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._props.container;
    this._props.container = e, this._$markupContainer = e ? E(e) : X6.getSwatchContainer(this._$root), this.updateVisualContainer(this._props.visualContainer);
  }
  updateVisualContainer() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._props.visualContainer;
    this._props.visualContainer = e, this._$visualContainer = this._getVisualContainer();
  }
  detectVisualPositionChange(e) {
    this._updateVisualPositionValue(), this._raisePositionedEvents(e);
  }
  positionContent() {
    this._shouldRenderContentInitialPosition ? this._renderContentInitialPosition() : (Nn(this._$content, this._visualPosition), this.detectVisualPositionChange());
  }
  positionWrapper() {
    this._$visualContainer && kl.setup(this._$wrapper, {
      my: "top left",
      at: "top left",
      of: this._$visualContainer
    });
  }
  styleWrapperPosition() {
    var e = Or(this.$visualContainer.get(0)) || this._props._fixWrapperPosition, i = e ? "fixed" : "absolute";
    this._$wrapper.css("position", i);
  }
  _updateVisualPositionValue() {
    this._previousVisualPosition = this._visualPosition, this._visualPosition = zs(this._$content);
  }
  _renderContentInitialPosition() {
    this._renderBoundaryOffset(), xS(this._$content);
    var e = this._$wrapper.css("overflow");
    if (this._$wrapper.css("overflow", "hidden"), !this._props._skipContentPositioning) {
      var i = kl.setup(this._$content, this._position);
      this._initialPosition = i;
    }
    this._$wrapper.css("overflow", e), this.detectVisualPositionChange();
  }
  _raisePositionedEvents(e) {
    var i = this._previousVisualPosition, r = this._visualPosition, n = (i == null ? void 0 : i.top) !== r.top || (i == null ? void 0 : i.left) !== r.left;
    n && this._props.onVisualPositionChanged({
      previousPosition: i,
      position: r,
      event: e
    }), this._props.onPositioned({
      position: this._initialPosition
    });
  }
  _renderBoundaryOffset() {
    var e, i = (e = this._position) !== null && e !== void 0 ? e : {
      boundaryOffset: HW
    };
    this._$content.css("margin", "".concat(i.v, "px ").concat(i.h, "px"));
  }
  _getVisualContainer() {
    var e, i, r = this._props.container, n = this._props.visualContainer, a = Zte((e = this._props.position) === null || e === void 0 ? void 0 : e.of) ? this._props.position.of.target : (i = this._props.position) === null || i === void 0 ? void 0 : i.of;
    return E(n || r || a || Rpe);
  }
  _normalizePosition(e) {
    var i = {
      boundaryOffset: HW
    };
    return R(e) ? P(!0, {}, i, this._positionToObject(e)) : i;
  }
  _positionToObject(e) {
    return ht(e) ? P({}, Q6[e]) : e;
  }
}
var Lpe = Vu.add, Yg = Ot(), $W = lI, Mpe = "dx-overlay", kpe = "dx-overlay-wrapper", Ppe = "dx-overlay-content", Fpe = "dx-overlay-shader", zW = "dx-inner-overlay", CL = "dx-state-invisible", Bpe = "content", Vpe = "dx-rtl", EP = [], yL = "dx-prevent-safari-scrolling", Npe = "tab";
Lpe(() => {
  k.subscribeGlobal(de.getDocument(), Xt.down, (t) => {
    for (var e = EP.length - 1; e >= 0; e--)
      if (!EP[e]._proxiedDocumentDownHandler(t))
        return;
  });
});
var Pl = xn.inherit({
  _supportedKeys: function() {
    return P(this.callBase(), {
      escape: function() {
        this.hide();
      }
    });
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      activeStateEnabled: !1,
      visible: !1,
      deferRendering: !0,
      shading: !0,
      shadingColor: "",
      wrapperAttr: {},
      position: P({}, Q6.center),
      width: "80vw",
      minWidth: null,
      maxWidth: null,
      height: "80vh",
      minHeight: null,
      maxHeight: null,
      animation: {
        show: {
          type: "pop",
          duration: 300,
          from: {
            scale: 0.55
          }
        },
        hide: {
          type: "pop",
          duration: 300,
          from: {
            opacity: 1,
            scale: 1
          },
          to: {
            opacity: 0,
            scale: 0.55
          }
        }
      },
      closeOnOutsideClick: !1,
      hideOnOutsideClick: !1,
      copyRootClassesToWrapper: !1,
      _ignoreCopyRootClassesToWrapperDeprecation: !1,
      _ignoreElementAttrDeprecation: !1,
      _ignorePreventScrollEventsDeprecation: !1,
      onShowing: null,
      onShown: null,
      onHiding: null,
      onHidden: null,
      contentTemplate: "content",
      innerOverlay: !1,
      restorePosition: !0,
      container: void 0,
      visualContainer: void 0,
      hideTopOverlayHandler: () => {
        this.hide();
      },
      hideOnParentScroll: !1,
      preventScrollEvents: !0,
      onPositioned: null,
      propagateOutsideClick: !1,
      ignoreChildEvents: !0,
      _checkParentVisibility: !0,
      _hideOnParentScrollTarget: void 0,
      _fixWrapperPosition: !1
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: function() {
        return !wt();
      },
      options: {
        width: null,
        height: null,
        animation: null,
        _checkParentVisibility: !1
      }
    }]);
  },
  _setOptionsByReference: function() {
    this.callBase(), P(this._optionsByReference, {
      animation: !0
    });
  },
  $wrapper: function() {
    return this._$wrapper;
  },
  _eventBindingTarget: function() {
    return this._$content;
  },
  _setDeprecatedOptions() {
    this.callBase(), P(this._deprecatedOptions, {
      closeOnOutsideClick: {
        since: "22.1",
        alias: "hideOnOutsideClick"
      }
    });
  },
  ctor: function(t, e) {
    this.callBase(t, e), e && (e.copyRootClassesToWrapper && !e._ignoreCopyRootClassesToWrapperDeprecation && this._logDeprecatedOptionWarning("copyRootClassesToWrapper", {
      since: "21.2",
      message: 'Use the "wrapperAttr" option instead'
    }), e.elementAttr && !e._ignoreElementAttrDeprecation && this._logDeprecatedOptionWarning("elementAttr", {
      since: "21.2",
      message: 'Use the "wrapperAttr" option instead'
    }), "preventScrollEvents" in e && !e._ignorePreventScrollEventsDeprecation && this._logDeprecatedPreventScrollEventsInfo());
  },
  _logDeprecatedPreventScrollEventsInfo() {
    this._logDeprecatedOptionWarning("preventScrollEvents", {
      since: "23.1",
      message: "If you enable this option, end-users may experience scrolling issues."
    });
  },
  _init: function() {
    this.callBase(), this._initActions(), this._initHideOnOutsideClickHandler(), this._initTabTerminatorHandler(), this._customWrapperClass = null, this._$wrapper = E("<div>").addClass(kpe), this._$content = E("<div>").addClass(Ppe), this._initInnerOverlayClass();
    var t = this.$element();
    this.option("copyRootClassesToWrapper") && this._$wrapper.addClass(t.attr("class")), t.addClass(Mpe), this._$wrapper.attr("data-bind", "dxControlsDescendantBindings: true"), this._toggleViewPortSubscription(!0), this._initHideTopOverlayHandler(this.option("hideTopOverlayHandler")), this._parentsScrollSubscriptionInfo = {
      handler: (e) => {
        this._hideOnParentsScrollHandler(e);
      }
    }, this.warnPositionAsFunction();
  },
  warnPositionAsFunction() {
    Le(this.option("position")) && bi.log("W0018");
  },
  _initInnerOverlayClass: function() {
    this._$content.toggleClass(zW, this.option("innerOverlay"));
  },
  _initHideTopOverlayHandler: function(t) {
    this._hideTopOverlayHandler = t;
  },
  _getActionsList: function() {
    return ["onShowing", "onShown", "onHiding", "onHidden", "onPositioned", "onVisualPositionChanged"];
  },
  _initActions: function() {
    this._actions = {};
    var t = this._getActionsList();
    N(t, (e, i) => {
      this._actions[i] = this._createActionByOption(i, {
        excludeValidators: ["disabled", "readOnly"]
      }) || ee;
    });
  },
  _initHideOnOutsideClickHandler: function() {
    var t = this;
    this._proxiedDocumentDownHandler = function() {
      return t._documentDownHandler(...arguments);
    };
  },
  _initMarkup() {
    this.callBase(), this._renderWrapperAttributes(), this._initPositionController();
  },
  _documentDownHandler: function(t) {
    this._showAnimationProcessing && this._stopAnimation();
    var e = E(Yg.document).is(t.target) || Kd(Yg.document, t.target), i = E(t.target).closest(".".concat(zW)).length, r = e && !i && !(this._$content.is(t.target) || Kd(this._$content.get(0), t.target));
    return r && this._shouldHideOnOutsideClick(t) && this._outsideClickHandler(t), this.option("propagateOutsideClick");
  },
  _shouldHideOnOutsideClick: function(t) {
    var {
      hideOnOutsideClick: e
    } = this.option();
    return Le(e) ? e(t) : e;
  },
  _outsideClickHandler(t) {
    this.option("shading") && t.preventDefault(), this.hide();
  },
  _getAnonymousTemplateName: function() {
    return Bpe;
  },
  _initTemplates: function() {
    this._templateManager.addDefaultTemplates({
      content: new yp()
    }), this.callBase();
  },
  _isTopOverlay: function() {
    for (var t = this._overlayStack(), e = t.length - 1; e >= 0; e--) {
      var i = t[e]._findTabbableBounds();
      if (i.first || i.last)
        return t[e] === this;
    }
    return !1;
  },
  _overlayStack: function() {
    return EP;
  },
  _zIndexInitValue: function() {
    return Pl.baseZIndex();
  },
  _toggleViewPortSubscription: function(t) {
    var e = this;
    $W.remove(this._viewPortChangeHandle), t && (this._viewPortChangeHandle = function() {
      e._viewPortChangeHandler(...arguments);
    }, $W.add(this._viewPortChangeHandle));
  },
  _viewPortChangeHandler: function() {
    this._positionController.updateContainer(this.option("container")), this._refresh();
  },
  _renderWrapperAttributes() {
    var {
      wrapperAttr: t
    } = this.option(), e = P({}, t), i = e.class;
    delete e.class, this.$wrapper().attr(e).removeClass(this._customWrapperClass).addClass(i), this._customWrapperClass = i;
  },
  _renderVisibilityAnimate: function(t) {
    return this._stopAnimation(), t ? this._show() : this._hide();
  },
  _getAnimationConfig: function() {
    return this._getOptionValue("animation", this);
  },
  _toggleBodyScroll: ee,
  _animateShowing: function() {
    var t, e, i, r = this, n = (t = this._getAnimationConfig()) !== null && t !== void 0 ? t : {}, a = this._normalizeAnimation(n.show, "to"), o = (e = a == null ? void 0 : a.start) !== null && e !== void 0 ? e : ee, u = (i = a == null ? void 0 : a.complete) !== null && i !== void 0 ? i : ee;
    this._animate(a, function() {
      if (!r._isAnimationPaused) {
        r.option("focusStateEnabled") && k.trigger(r._focusTarget(), "focus");
        for (var c = arguments.length, p = new Array(c), v = 0; v < c; v++)
          p[v] = arguments[v];
        u.call(r, ...p), r._showAnimationProcessing = !1, r._isHidden = !1, r._actions.onShown(), r._toggleSafariScrolling(), r._showingDeferred.resolve();
      }
    }, function() {
      if (!r._isAnimationPaused) {
        for (var c = arguments.length, p = new Array(c), v = 0; v < c; v++)
          p[v] = arguments[v];
        o.call(r, ...p), r._showAnimationProcessing = !0;
      }
    });
  },
  _processShowingHidingCancel: function(t, e, i) {
    Vm(t) ? t.then((r) => {
      r ? i() : e();
    }).catch(() => e()) : t ? i() : e();
  },
  _show: function() {
    if (this._showingDeferred = new q(), this._parentHidden = this._isParentHidden(), this._showingDeferred.done(() => {
      delete this._parentHidden;
    }), this._parentHidden)
      return this._isHidden = !0, this._showingDeferred.resolve();
    if (this._currentVisible)
      return new q().resolve().promise();
    if (this._currentVisible = !0, this._isHidingActionCanceled)
      delete this._isHidingActionCanceled, this._showingDeferred.reject();
    else {
      var t = () => {
        this._stopAnimation(), this._toggleBodyScroll(this.option("enableBodyScroll")), this._toggleVisibility(!0), this._$content.css("visibility", "hidden"), this._$content.toggleClass(CL, !1), this._updateZIndexStackPosition(!0), this._positionController.openingHandled(), this._renderContent();
        var e = {
          cancel: !1
        };
        this._actions.onShowing(e), this._processShowingHidingCancel(e.cancel, () => {
          this._$content.css("visibility", ""), this._renderVisibility(!0), this._animateShowing();
        }, () => {
          this._toggleVisibility(!1), this._$content.css("visibility", ""), this._$content.toggleClass(CL, !0), this._isShowingActionCanceled = !0, this._moveFromContainer(), this._toggleBodyScroll(!0), this.option("visible", !1), this._showingDeferred.resolve();
        });
      };
      this.option("templatesRenderAsynchronously") ? (this._stopShowTimer(), this._asyncShowTimeout = setTimeout(t)) : t();
    }
    return this._showingDeferred.promise();
  },
  _normalizeAnimation: function(t, e) {
    return t && (t = P({
      type: "slide",
      skipElementInitialStyles: !0
    }, t), ct(t[e]) && P(t[e], {
      position: this._positionController.position
    })), t;
  },
  _animateHiding: function() {
    var t, e, i, r = this, n = (t = this._getAnimationConfig()) !== null && t !== void 0 ? t : {}, a = this._normalizeAnimation(n.hide, "from"), o = (e = a == null ? void 0 : a.start) !== null && e !== void 0 ? e : ee, u = (i = a == null ? void 0 : a.complete) !== null && i !== void 0 ? i : ee;
    this._animate(a, function() {
      var c;
      r._$content.css("pointerEvents", ""), r._renderVisibility(!1);
      for (var p = arguments.length, v = new Array(p), _ = 0; _ < p; _++)
        v[_] = arguments[_];
      u.call(r, ...v), r._hideAnimationProcessing = !1, (c = r._actions) === null || c === void 0 || c.onHidden(), r._hidingDeferred.resolve();
    }, function() {
      r._$content.css("pointerEvents", "none");
      for (var c = arguments.length, p = new Array(c), v = 0; v < c; v++)
        p[v] = arguments[v];
      o.call(r, ...p), r._hideAnimationProcessing = !0;
    });
  },
  _hide: function() {
    if (!this._currentVisible)
      return new q().resolve().promise();
    this._currentVisible = !1, this._hidingDeferred = new q();
    var t = {
      cancel: !1
    };
    return this._isShowingActionCanceled ? (delete this._isShowingActionCanceled, this._hidingDeferred.reject()) : (this._actions.onHiding(t), this._toggleSafariScrolling(), this._toggleBodyScroll(!0), this._processShowingHidingCancel(t.cancel, () => {
      this._forceFocusLost(), this._toggleShading(!1), this._toggleSubscriptions(!1), this._stopShowTimer(), this._animateHiding();
    }, () => {
      this._isHidingActionCanceled = !0, this._toggleBodyScroll(this.option("enableBodyScroll")), this.option("visible", !0), this._hidingDeferred.resolve();
    })), this._hidingDeferred.promise();
  },
  _forceFocusLost: function() {
    var t = de.getActiveElement(), e = !!this._$content.find(t).length;
    e && $m();
  },
  _animate: function(t, e, i) {
    t ? (i = i || t.start || ee, ji.animate(this._$content, P({}, t, {
      start: i,
      complete: e
    }))) : e();
  },
  _stopAnimation: function() {
    ji.stop(this._$content, !0);
  },
  _renderVisibility: function(t) {
    t && this._isParentHidden() || (this._currentVisible = t, this._stopAnimation(), t || loe(this._$content), t ? (this._checkContainerExists(), this._moveToContainer(), this._renderGeometry(), LF(this._$content), Iu(this._$content)) : (this._toggleVisibility(t), this._$content.toggleClass(CL, !t), this._updateZIndexStackPosition(t), this._moveFromContainer()), this._toggleShading(t), this._toggleSubscriptions(t));
  },
  _updateZIndexStackPosition: function(t) {
    var e = this._overlayStack(), i = e.indexOf(this);
    t ? (i === -1 && (this._zIndex = q6(this._zIndexInitValue()), e.push(this)), this._$wrapper.css("zIndex", this._zIndex), this._$content.css("zIndex", this._zIndex)) : i !== -1 && (e.splice(i, 1), SP(this._zIndex));
  },
  _toggleShading: function(t) {
    this._$wrapper.toggleClass(Fpe, t && this.option("shading")), this._$wrapper.css("backgroundColor", this.option("shading") ? this.option("shadingColor") : ""), this._toggleTabTerminator(t && this.option("shading"));
  },
  _initTabTerminatorHandler: function() {
    var t = this;
    this._proxiedTabTerminatorHandler = function() {
      t._tabKeyHandler(...arguments);
    };
  },
  _toggleTabTerminator: function(t) {
    var e = ve("keydown", this.NAME);
    t ? k.on(de.getDocument(), e, this._proxiedTabTerminatorHandler) : k.off(de.getDocument(), e, this._proxiedTabTerminatorHandler);
  },
  _findTabbableBounds: function() {
    for (var t = this._$wrapper.find("*"), e = t.length - 1, i = {
      first: null,
      last: null
    }, r = 0; r <= e && (!i.first && t.eq(r).is(R$) && (i.first = t.eq(r)), !i.last && t.eq(e - r).is(R$) && (i.last = t.eq(e - r)), !(i.first && i.last)); r++)
      ;
    return i;
  },
  _tabKeyHandler: function(t) {
    if (!(or(t) !== Npe || !this._isTopOverlay())) {
      var e = this._findTabbableBounds(), i = e.first, r = e.last, n = !t.shiftKey && t.target === r.get(0), a = t.shiftKey && t.target === i.get(0), o = e.length === 0, u = !Kd(this._$wrapper.get(0), t.target);
      if (n || a || o || u) {
        t.preventDefault();
        var c = t.shiftKey ? r : i;
        k.trigger(c, "focusin"), k.trigger(c, "focus");
      }
    }
  },
  _toggleSubscriptions: function(t) {
    wt() && (this._toggleHideTopOverlayCallback(t), this._toggleHideOnParentsScrollSubscription(t));
  },
  _toggleHideTopOverlayCallback: function(t) {
    this._hideTopOverlayHandler && (t ? NW.add(this._hideTopOverlayHandler) : NW.remove(this._hideTopOverlayHandler));
  },
  _toggleHideOnParentsScrollSubscription: function(t) {
    var e, i = ve("scroll", this.NAME), {
      prevTargets: r,
      handler: n
    } = (e = this._parentsScrollSubscriptionInfo) !== null && e !== void 0 ? e : {};
    k.off(r, i, n);
    var a = this.option("hideOnParentScroll");
    if (t && a) {
      var o = this._getHideOnParentScrollTarget().parents();
      Ye.real().deviceType === "desktop" && (o = o.add(Yg)), k.on(o, i, n), this._parentsScrollSubscriptionInfo.prevTargets = o;
    }
  },
  _hideOnParentsScrollHandler: function(t) {
    var e = !1, i = this.option("hideOnParentScroll");
    Le(i) && (e = i(t)), !e && !this._showAnimationProcessing && this.hide();
  },
  _getHideOnParentScrollTarget: function() {
    var t = E(this.option("_hideOnParentScrollTarget"));
    return t.length ? t : this._$wrapper;
  },
  _render: function() {
    this.callBase(), this._appendContentToElement(), this._renderVisibilityAnimate(this.option("visible"));
  },
  _appendContentToElement: function() {
    this._$content.parent().is(this.$element()) || this._$content.appendTo(this.$element());
  },
  _renderContent: function() {
    var t = !this._currentVisible && this.option("deferRendering"), e = this.option("visible") && this._isParentHidden();
    if (e) {
      this._isHidden = !0;
      return;
    }
    this._contentAlreadyRendered || t || (this._contentAlreadyRendered = !0, this._appendContentToElement(), this.callBase());
  },
  _isParentHidden: function() {
    if (!this.option("_checkParentVisibility"))
      return !1;
    if (this._parentHidden !== void 0)
      return this._parentHidden;
    var t = this.$element().parent();
    if (t.is(":visible"))
      return !1;
    var e = !1;
    return t.add(t.parents()).each(function() {
      var i = E(this);
      if (i.css("display") === "none")
        return e = !0, !1;
    }), e || !de.getBody().contains(t.get(0));
  },
  _renderContentImpl: function() {
    var t = new q(), e = this.option("contentTemplate"), i = this._getTemplate(e), r = this._templateManager.anonymousTemplateName === e;
    return i && i.render({
      container: ot(this.$content()),
      noModel: !0,
      transclude: r,
      onRendered: () => {
        t.resolve(), this.option("templatesRenderAsynchronously") && this._dimensionChanged();
      }
    }), this._toggleWrapperScrollEventsSubscription(this.option("preventScrollEvents")), t.done(() => {
      this.option("visible") && this._moveToContainer();
    }), t.promise();
  },
  _getPositionControllerConfig() {
    var {
      container: t,
      visualContainer: e,
      _fixWrapperPosition: i,
      restorePosition: r,
      _skipContentPositioning: n
    } = this.option();
    return {
      container: t,
      visualContainer: e,
      $root: this.$element(),
      $content: this._$content,
      $wrapper: this._$wrapper,
      onPositioned: this._actions.onPositioned,
      onVisualPositionChanged: this._actions.onVisualPositionChanged,
      restorePosition: r,
      _fixWrapperPosition: i,
      _skipContentPositioning: n
    };
  },
  _initPositionController() {
    this._positionController = new Z6(this._getPositionControllerConfig());
  },
  _toggleWrapperScrollEventsSubscription: function(t) {
    var e = ve(Rh, this.NAME);
    k.off(this._$wrapper, e), t && k.on(this._$wrapper, e, {
      validate: function() {
        return !0;
      },
      getDirection: function() {
        return "both";
      },
      _toggleGestureCover: function(i) {
        i || this._toggleGestureCoverImpl(i);
      },
      _clearSelection: ee,
      isNative: !0
    }, (i) => {
      var r = i.originalEvent.originalEvent, {
        type: n
      } = r || {}, a = n === "wheel", o = n === "mousemove", u = a && !Cn(i);
      i._cancelPreventDefault = !0, r && i.cancelable !== !1 && (!o && !a || u) && i.preventDefault();
    });
  },
  _moveFromContainer: function() {
    this._$content.appendTo(this.$element()), this._$wrapper.detach();
  },
  _checkContainerExists() {
    var t = this._positionController.$container;
    if (t !== void 0) {
      var e = t.length > 0;
      e || Yt.log("W1021", this.NAME);
    }
  },
  _moveToContainer: function() {
    var t = this._positionController.$container;
    this._$wrapper.appendTo(t), this._$content.appendTo(this._$wrapper);
  },
  _renderGeometry: function(t) {
    var {
      visible: e
    } = this.option();
    e && wt() && (this._stopAnimation(), this._renderGeometryImpl());
  },
  _renderGeometryImpl: function() {
    this._positionController.updatePosition(this._getOptionValue("position")), this._renderWrapper(), this._renderDimensions(), this._renderPosition();
  },
  _renderPosition() {
    this._positionController.positionContent();
  },
  _isAllWindowCovered: function() {
    return Or(this._positionController.$visualContainer.get(0)) && this.option("shading");
  },
  _toggleSafariScrolling: function() {
    var t = this.option("visible"), e = E(de.getBody()), i = Ye.real().platform === "ios" && $i.safari, r = this._isAllWindowCovered(), n = e.hasClass(yL), a = !n && t && r, o = n && (!t || !r || this._disposed);
    i && (o ? (e.removeClass(yL), Yg.scrollTo(0, this._cachedBodyScrollTop), this._cachedBodyScrollTop = void 0) : a && (this._cachedBodyScrollTop = Yg.pageYOffset, e.addClass(yL)));
  },
  _renderWrapper: function() {
    this._positionController.styleWrapperPosition(), this._renderWrapperDimensions(), this._positionController.positionWrapper();
  },
  _renderWrapperDimensions: function() {
    var t = this._positionController.$visualContainer, e = de.getDocumentElement(), i = Or(t.get(0)), r = i ? e.clientWidth : oi(t), n = i ? Yg.innerHeight : jt(t);
    this._$wrapper.css({
      width: r,
      height: n
    });
  },
  _renderDimensions: function() {
    var t = this._$content.get(0);
    this._$content.css({
      minWidth: this._getOptionValue("minWidth", t),
      maxWidth: this._getOptionValue("maxWidth", t),
      minHeight: this._getOptionValue("minHeight", t),
      maxHeight: this._getOptionValue("maxHeight", t),
      width: this._getOptionValue("width", t),
      height: this._getOptionValue("height", t)
    });
  },
  _focusTarget: function() {
    return this._$content;
  },
  _attachKeyboardEvents: function() {
    this._keyboardListenerId = bh.on(this._$content, null, (t) => this._keyboardHandler(t));
  },
  _keyboardHandler: function(t) {
    var e = t.originalEvent, i = E(e.target);
    (i.is(this._$content) || !this.option("ignoreChildEvents")) && this.callBase(...arguments);
  },
  _isVisible: function() {
    return this.option("visible");
  },
  _visibilityChanged: function(t) {
    t ? this.option("visible") && this._renderVisibilityAnimate(t) : this._renderVisibilityAnimate(t);
  },
  _dimensionChanged: function() {
    this._renderGeometry();
  },
  _clean: function() {
    var t = this.option();
    !this._contentAlreadyRendered && !t.isRenovated && this.$content().empty(), this._renderVisibility(!1), this._stopShowTimer(), this._cleanFocusState();
  },
  _stopShowTimer() {
    this._asyncShowTimeout && clearTimeout(this._asyncShowTimeout), this._asyncShowTimeout = null;
  },
  _dispose: function() {
    ji.stop(this._$content, !1), clearTimeout(this._deferShowTimer), this._toggleViewPortSubscription(!1), this._toggleSubscriptions(!1), this._updateZIndexStackPosition(!1), this._toggleTabTerminator(!1), this._actions = null, this._parentsScrollSubscriptionInfo = null, this.callBase(), this._toggleSafariScrolling(), this.option("visible") && SP(this._zIndex), this._$wrapper.remove(), this._$content.remove();
  },
  _toggleRTLDirection: function(t) {
    this._$content.toggleClass(Vpe, t);
  },
  _optionChanged: function(t) {
    var {
      value: e,
      name: i
    } = t;
    if (this._getActionsList().includes(i)) {
      this._initActions();
      return;
    }
    switch (i) {
      case "animation":
        break;
      case "shading":
        this._toggleShading(this.option("visible")), this._toggleSafariScrolling();
        break;
      case "shadingColor":
        this._toggleShading(this.option("visible"));
        break;
      case "width":
      case "height":
        this._renderGeometry();
        break;
      case "minWidth":
      case "maxWidth":
      case "minHeight":
      case "maxHeight":
        this._renderGeometry();
        break;
      case "position":
        this._positionController.updatePosition(this.option("position")), this._positionController.restorePositionOnNextRender(!0), this._renderGeometry(), this._toggleSafariScrolling();
        break;
      case "visible":
        this._renderVisibilityAnimate(e).done(() => {
          var r;
          return (r = this._animateDeferred) === null || r === void 0 ? void 0 : r.resolveWith(this);
        }).fail(() => {
          var r;
          return (r = this._animateDeferred) === null || r === void 0 ? void 0 : r.reject();
        });
        break;
      case "container":
        this._positionController.updateContainer(e), this._invalidate(), this._toggleSafariScrolling();
        break;
      case "visualContainer":
        this._positionController.updateVisualContainer(e), this._renderWrapper(), this._toggleSafariScrolling();
        break;
      case "innerOverlay":
        this._initInnerOverlayClass();
        break;
      case "deferRendering":
      case "contentTemplate":
        this._contentAlreadyRendered = !1, this._clean(), this._invalidate();
        break;
      case "hideTopOverlayHandler":
        this._toggleHideTopOverlayCallback(!1), this._initHideTopOverlayHandler(e), this._toggleHideTopOverlayCallback(this.option("visible"));
        break;
      case "hideOnParentScroll":
      case "_hideOnParentScrollTarget":
        this._toggleHideOnParentsScrollSubscription(this.option("visible"));
        break;
      case "closeOnOutsideClick":
      case "hideOnOutsideClick":
      case "propagateOutsideClick":
        break;
      case "rtlEnabled":
        this._contentAlreadyRendered = !1, this.callBase(t);
        break;
      case "_fixWrapperPosition":
        this._positionController.fixWrapperPosition = e;
        break;
      case "wrapperAttr":
        this._renderWrapperAttributes();
        break;
      case "restorePosition":
        this._positionController.restorePosition = e;
        break;
      case "preventScrollEvents":
        this._logDeprecatedPreventScrollEventsInfo(), this._toggleWrapperScrollEventsSubscription(e);
        break;
      default:
        this.callBase(t);
    }
  },
  toggle: function(t) {
    t = t === void 0 ? !this.option("visible") : t;
    var e = new q();
    if (t === this.option("visible"))
      return e.resolveWith(this, [t]).promise();
    var i = new q();
    return this._animateDeferred = i, this.option("visible", t), i.promise().done(() => {
      delete this._animateDeferred, e.resolveWith(this, [this.option("visible")]);
    }).fail(() => {
      delete this._animateDeferred, e.reject();
    }), e.promise();
  },
  $content: function() {
    return this._$content;
  },
  show: function() {
    return this.toggle(!0);
  },
  hide: function() {
    return this.toggle(!1);
  },
  content: function() {
    return ot(this._$content);
  },
  repaint: function() {
    this._contentAlreadyRendered ? (this._positionController.restorePositionOnNextRender(!0), this._renderGeometry({
      forceStopAnimation: !0
    }), Iu(this._$content)) : this.callBase();
  }
});
Pl.baseZIndex = (t) => Dpe(t);
ti("dxOverlay", Pl);
var Hpe = "dx-loadpanel", $pe = "dx-loadpanel-wrapper", WW = "dx-loadpanel-indicator", UW = "dx-loadpanel-message", zpe = "dx-loadpanel-content", Wpe = "dx-loadpanel-content-wrapper", Upe = "dx-loadpanel-pane-hidden", CB = Pl.inherit({
  _supportedKeys: function() {
    return P(this.callBase(), {
      escape: ee
    });
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      message: X.format("Loading"),
      width: 222,
      height: 90,
      animation: null,
      showIndicator: !0,
      indicatorSrc: "",
      showPane: !0,
      delay: 0,
      templatesRenderAsynchronously: !1,
      hideTopOverlayHandler: null,
      focusStateEnabled: !1,
      propagateOutsideClick: !0,
      preventScrollEvents: !1
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: {
        platform: "generic"
      },
      options: {
        shadingColor: "transparent"
      }
    }, {
      device: function() {
        return _a();
      },
      options: {
        message: "",
        width: 60,
        height: 60,
        maxHeight: 60,
        maxWidth: 60
      }
    }, {
      device: function() {
        return za();
      },
      options: {
        width: "auto",
        height: "auto"
      }
    }]);
  },
  _init: function() {
    this.callBase.apply(this, arguments);
  },
  _render: function() {
    this.callBase(), this.$element().addClass(Hpe), this.$wrapper().addClass($pe), this._setWrapperAria();
  },
  _setWrapperAria() {
    var {
      message: t
    } = this.option(), e = fs() ? t : null, i = t ? e : X.format("Loading"), r = {
      role: "alert",
      label: i
    };
    this.setAria(r, this.$wrapper());
  },
  _renderContentImpl: function() {
    this.callBase(), this.$content().addClass(zpe), this._$loadPanelContentWrapper = E("<div>").addClass(Wpe), this._$loadPanelContentWrapper.appendTo(this.$content()), this._togglePaneVisible(), this._cleanPreviousContent(), this._renderLoadIndicator(), this._renderMessage();
  },
  _show: function() {
    var t = this.option("delay");
    if (!t)
      return this.callBase();
    var e = new q(), i = this.callBase.bind(this);
    return this._clearShowTimeout(), this._showTimeout = setTimeout(function() {
      i().done(function() {
        e.resolve();
      });
    }, t), e.promise();
  },
  _hide: function() {
    return this._clearShowTimeout(), this.callBase();
  },
  _clearShowTimeout: function() {
    clearTimeout(this._showTimeout);
  },
  _renderMessage: function() {
    if (this._$loadPanelContentWrapper) {
      var t = this.option("message");
      if (t) {
        var e = E("<div>").addClass(UW).text(t);
        this._$loadPanelContentWrapper.append(e);
      }
    }
  },
  _renderLoadIndicator: function() {
    !this._$loadPanelContentWrapper || !this.option("showIndicator") || (this._$indicator || (this._$indicator = E("<div>").addClass(WW).appendTo(this._$loadPanelContentWrapper)), this._createComponent(this._$indicator, us, {
      indicatorSrc: this.option("indicatorSrc")
    }));
  },
  _cleanPreviousContent: function() {
    this.$content().find("." + UW).remove(), this.$content().find("." + WW).remove(), delete this._$indicator;
  },
  _togglePaneVisible: function() {
    this.$content().toggleClass(Upe, !this.option("showPane"));
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "delay":
        break;
      case "message":
      case "showIndicator":
        this._cleanPreviousContent(), this._renderLoadIndicator(), this._renderMessage(), this._setWrapperAria();
        break;
      case "showPane":
        this._togglePaneVisible();
        break;
      case "indicatorSrc":
        this._renderLoadIndicator();
        break;
      default:
        this.callBase(t);
    }
  },
  _dispose: function() {
    this._clearShowTimeout(), this.callBase();
  }
});
ti("dxLoadPanel", CB);
var Gpe = ["year", "month", "day"], Kpe = ["year", "month", "day", "hour", "minute"], bP = function(t) {
  return t === "date" || t === "datetime";
}, xL = function(t) {
  var e, i = [], r = ["year", "month", "day", "hour", "minute", "second"], n = t.headerFilter && t.headerFilter.groupInterval, a = n === "quarter" ? "month" : n;
  if (bP(t.dataType) && n !== null)
    return i = t.dataType === "datetime" ? Kpe : Gpe, e = r.indexOf(a), e >= 0 && (i = r.slice(0, e), i.push(n)), i;
  if (R(n))
    return Array.isArray(n) ? n : [n];
};
const Wp = /* @__PURE__ */ function() {
  var t = function(n, a) {
    var o = n.dataField || n.selector;
    return a === "search" && (o = n.displayField || n.calculateDisplayValue || o), o;
  }, e = function(n, a) {
    var o, u, c, p = t(this, a);
    if (Array.isArray(n) && R(n[0]) && R(n[1]))
      return u = [p, ">=", n[0]], c = [p, "<=", n[1]], bP(this.dataType) && (v = n[1], v.getHours() + v.getMinutes() + v.getSeconds() + v.getMilliseconds() < 1) && (o = new Date(n[1].getTime()), this.dataType === "date" && o.setDate(n[1].getDate() + 1), c = [p, "<", o]), [u, "and", c];
    var v;
  }, i = function(n, a, o) {
    var u, c, p, v = function(y) {
      return zo(y) ? [y.getFullYear(), y.getMonth(), y.getDate(), y.getHours(), y.getMinutes(), y.getSeconds()] : Jr(("" + y).split("/"), function(b, I) {
        return I === 1 ? Number(b) - 1 : Number(b);
      });
    }(n), _ = t(this, o);
    switch (o === "headerFilter" ? p = xL(this)[v.length - 1] : this.dataType === "datetime" && (p = "minute"), p) {
      case "year":
        u = new Date(v[0], 0, 1), c = new Date(v[0] + 1, 0, 1);
        break;
      case "month":
        u = new Date(v[0], v[1], 1), c = new Date(v[0], v[1] + 1, 1);
        break;
      case "quarter":
        u = new Date(v[0], 3 * v[1], 1), c = new Date(v[0], 3 * v[1] + 3, 1);
        break;
      case "hour":
        u = new Date(v[0], v[1], v[2], v[3]), c = new Date(v[0], v[1], v[2], v[3] + 1);
        break;
      case "minute":
        u = new Date(v[0], v[1], v[2], v[3], v[4]), c = new Date(v[0], v[1], v[2], v[3], v[4] + 1);
        break;
      case "second":
        u = new Date(v[0], v[1], v[2], v[3], v[4], v[5]), c = new Date(v[0], v[1], v[2], v[3], v[4], v[5] + 1);
        break;
      default:
        u = new Date(v[0], v[1], v[2]), c = new Date(v[0], v[1], v[2] + 1);
    }
    switch (a) {
      case "<":
        return [_, "<", u];
      case "<=":
        return [_, "<", c];
      case ">":
        return [_, ">=", c];
      case ">=":
        return [_, ">=", u];
      case "<>":
        return [
          [_, "<", u],
          "or",
          [_, ">=", c]
        ];
      default:
        return [
          [_, ">=", u],
          "and",
          [_, "<", c]
        ];
    }
  }, r = function(n, a, o) {
    var u = t(this, o), c = xL(this);
    if (o === "headerFilter" && c && R(n)) {
      var p = ("" + n).split("/"), v = Number(p[p.length - 1]), _ = c[p.length - 1], y = [u, ">=", v], b = [u, "<", v + _], I = [y, "and", b];
      return I;
    }
    return [u, a || "=", n];
  };
  return {
    defaultCalculateFilterExpression: function(n, a, o) {
      var u = this, c = t(u, o), p = u.calculateDisplayValue && o === "search", v = p && u.lookup && u.lookup.dataType || u.dataType, _ = null;
      if ((o === "headerFilter" || o === "filterBuilder") && n === null)
        _ = [c, a || "=", null], v === "string" && (_ = [_, a === "=" ? "or" : "and", [c, a || "=", ""]]);
      else if (v === "string" && (!u.lookup || p))
        _ = [c, a || "contains", n];
      else {
        if (a === "between")
          return e.apply(u, [n, o]);
        if (bP(v) && R(n))
          return i.apply(u, arguments);
        if (v === "number")
          return r.apply(u, arguments);
        _ = [c, a || "=", n];
      }
      return _;
    },
    getGroupInterval: xL
  };
}();
var jpe = "dx-selection-disabled", Ype = "dx-datagrid-group-opened", qpe = "dx-datagrid-group-closed", Xpe = "dx-datagrid-expand", Qpe = "nodata", Zpe = "infinite", GW = "virtual", Jpe = "scrolling.legacyMode", KW = "scrolling.mode", eve = "scrolling.rowRenderingMode", tve = {
  year: (t) => t && t.getFullYear(),
  month: (t) => t && t.getMonth() + 1,
  day: (t) => t && t.getDate(),
  quarter: (t) => t && Math.floor(t.getMonth() / 3) + 1,
  hour: (t) => t && t.getHours(),
  minute: (t) => t && t.getMinutes(),
  second: (t) => t && t.getSeconds()
}, ive = function() {
  var t = arguments[1], e = this.calculateCellValue(t);
  if (!R(e))
    return null;
  if (J6(this.dataType)) {
    var i = arguments[0];
    return tve[i](e);
  }
  if (this.dataType === "number") {
    var r = arguments[0];
    return Math.floor(Number(e) / r) * r;
  }
}, rve = function(t, e) {
  return Le(t) && Le(e) && t.originalCallback && e.originalCallback ? t.originalCallback === e.originalCallback && t.columnIndex === e.columnIndex : t === e;
};
function J6(t) {
  return t === "date" || t === "datetime";
}
var jW = function(t) {
  t.get(0).textContent = " ";
}, SL = function(t) {
  t = t || [];
  for (var e = ic(t), i = 0; i < t.length; i++)
    t && t[i] && t[i].isExpanded !== void 0 && (e[i].isExpanded = t[i].isExpanded), t && t[i] && t[i].groupInterval !== void 0 && (e[i].groupInterval = t[i].groupInterval);
  return e;
}, e5 = function(t, e) {
  var i = F6.format(t, e.format) || t && t.toString() || "", r = {
    value: t,
    valueText: e.getDisplayFormat ? e.getDisplayFormat(i) : i,
    target: e.target || "row",
    groupInterval: e.groupInterval
  };
  return e.customizeText ? e.customizeText.call(e, r) : r.valueText;
}, YW = function(t, e) {
  var i = t.displayFormat || t.columnCaption && e["".concat(t.summaryType, "OtherColumn")] || e[t.summaryType];
  return e5(t.value, {
    format: t.valueFormat,
    getDisplayFormat: (r) => i ? Mu(i, r, t.columnCaption) : r,
    customizeText: t.customizeText
  });
}, qW = function(t) {
  var e = t.data && t.data(), i = e && e.dxComponents, r = i && i[0];
  return r && e[r];
}, nve = function t(e, i) {
  if (Array.isArray(e) && Array.isArray(i)) {
    if (e.length !== i.length)
      return !1;
    for (var r = 0; r < e.length; r++)
      if (!t(e[r], i[r]))
        return !1;
    return !0;
  }
  return Le(e) && e.columnIndex >= 0 && Le(i) && i.columnIndex >= 0 ? e.columnIndex === i.columnIndex && ta(e.filterValue) === ta(i.filterValue) && ta(e.selectedFilterOperation) === ta(i.selectedFilterOperation) : ta(e) == ta(i);
};
function ave(t) {
  return Array.isArray(t) || (t = [t]), t.map((e, i) => ht(e) ? {
    selector: e,
    isExpanded: i < t.length - 1
  } : e);
}
const xe = {
  renderNoDataText(t) {
    if (t = t || this.element(), !!t) {
      var e = this.addWidgetPrefix(Qpe), i = t.find(".".concat(e)).last(), r = this._dataController.isEmpty(), n = this._dataController.isLoading();
      i.length || (i = E("<span>").addClass(e)), i.parent().is(t) || i.appendTo(t), r && !n ? i.removeClass("dx-hidden").text(this._getNoDataText()) : i.addClass("dx-hidden");
    }
  },
  renderLoadPanel(t, e, i) {
    var r;
    this._loadPanel && this._loadPanel.$element().remove(), r = this.option("loadPanel"), r && (r.enabled === "auto" ? !i : r.enabled) ? (r = P({
      shading: !1,
      message: r.text,
      container: e
    }, r), this._loadPanel = this._createComponent(E("<div>").appendTo(e), CB, r)) : this._loadPanel = null;
  },
  calculateLoadPanelPosition(t) {
    var e = E(Ot());
    return Pt(t) > Pt(e) ? {
      of: e,
      boundary: t,
      collision: "fit"
    } : {
      of: t
    };
  },
  getIndexByKey(t, e, i) {
    var r = -1;
    if (t !== void 0 && Array.isArray(e)) {
      i = arguments.length <= 2 ? "key" : i;
      for (var n = 0; n < e.length; n++) {
        var a = R(i) ? e[n][i] : e[n];
        if (Mi(t, a)) {
          r = n;
          break;
        }
      }
    }
    return r;
  },
  combineFilters(t, e) {
    var i, r = [];
    e = e || "and";
    for (var n = 0; n < t.length; n++)
      if (t[n]) {
        if (((i = t[n]) === null || i === void 0 ? void 0 : i.length) === 1 && t[n][0] === "!") {
          if (e === "and")
            return ["!"];
          if (e === "or")
            continue;
        }
        r.length && r.push(e), r.push(t[n]);
      }
    if (r.length === 1 && (r = r[0]), r.length)
      return r;
  },
  checkChanges(t, e) {
    for (var i = 0, r = 0; r < e.length; r++)
      t[e[r]] && i++;
    return t.length && t.length === i;
  },
  equalFilterParameters: nve,
  proxyMethod(t, e, i) {
    t[e] || (t[e] = function() {
      var r = this._dataSource;
      return r ? r[e].apply(r, arguments) : i;
    });
  },
  formatValue: e5,
  getFormatOptionsByColumn: (t, e) => ({
    format: t.format,
    getDisplayFormat: t.getDisplayFormat,
    customizeText: t.customizeText,
    target: e,
    trueText: t.trueText,
    falseText: t.falseText
  }),
  getDisplayValue(t, e, i, r) {
    return t.displayValueMap && t.displayValueMap[e] !== void 0 ? t.displayValueMap[e] : t.calculateDisplayValue && i && r !== "group" ? t.calculateDisplayValue(i) : t.lookup && !(r === "group" && (t.calculateGroupValue || t.calculateDisplayValue)) ? t.lookup.calculateCellValue(e) : e;
  },
  getGroupRowSummaryText(t, e) {
    for (var i = "(", r = 0; r < t.length; r++) {
      var n = t[r];
      i += (r > 0 ? ", " : "") + YW(n, e);
    }
    return i + ")";
  },
  getSummaryText: YW,
  normalizeSortingInfo: SL,
  getFormatByDataType(t) {
    switch (t) {
      case "date":
        return "shortDate";
      case "datetime":
        return "shortDateShortTime";
      default:
        return;
    }
  },
  getHeaderFilterGroupParameters(t, e) {
    var i = [], r = t.dataField || t.name, n = Wp.getGroupInterval(t);
    return n ? (N(n, (a, o) => {
      i.push(e ? {
        selector: r,
        groupInterval: o,
        isExpanded: a < n.length - 1
      } : ive.bind(t, o));
    }), i) : (e ? i = [{
      selector: r,
      isExpanded: !1
    }] : (i = function(a) {
      var o = t.calculateCellValue(a);
      return (o === void 0 || o === "") && (o = null), o;
    }, t.sortingMethod && (i = [{
      selector: i,
      compare: t.sortingMethod.bind(t)
    }])), i);
  },
  equalSortParameters(t, e, i) {
    if (t = SL(t), e = SL(e), Array.isArray(t) && Array.isArray(e)) {
      if (t.length !== e.length)
        return !1;
      for (var r = 0; r < t.length; r++)
        if (!rve(t[r].selector, e[r].selector) || t[r].desc !== e[r].desc || t[r].groupInterval !== e[r].groupInterval || !i && !!t[r].isExpanded != !!e[r].isExpanded)
          return !1;
      return !0;
    }
    return (!t || !t.length) == (!e || !e.length);
  },
  getPointsByColumns(t, e, i, r) {
    for (var n = t.length, a = !1, o, u, c = r || 0, p = [], v, _ = 0; _ <= n; _++) {
      _ < n && (o = t.eq(_), u = o.offset(), v = o.css("direction") === "rtl");
      var y = {
        index: c,
        x: u ? u.left + (!i && v ^ _ === n ? zr(o[0]).width : 0) : 0,
        y: u ? u.top + (i && _ === n ? zr(o[0]).height : 0) : 0,
        columnIndex: c
      };
      if (!i && _ > 0) {
        var b = t.eq(_ - 1).offset();
        b.top < y.y && (y.y = b.top);
      }
      e && (a = e(y)), a || p.push(y), c++;
    }
    return p;
  },
  getExpandCellTemplate: () => ({
    allowRenderToDetachedContainer: !0,
    render(t, e) {
      var i = E(t);
      if (R(e.value) && !(e.data && e.data.isContinuation) && !e.row.isNewRow) {
        var r = e.component.getView("rowsView");
        i.addClass(Xpe).addClass(jpe), E("<div>").addClass(e.value ? Ype : qpe).appendTo(i), r.setAria("label", e.value ? r.localize("dxDataGrid-ariaCollapse") : r.localize("dxDataGrid-ariaExpand"), i);
      } else
        jW(i);
    }
  }),
  setEmptyText: jW,
  isDateType: J6,
  getSelectionRange(t) {
    try {
      if (t)
        return {
          selectionStart: t.selectionStart,
          selectionEnd: t.selectionEnd
        };
    } catch {
    }
    return {};
  },
  setSelectionRange(t, e) {
    try {
      t && t.setSelectionRange && t.setSelectionRange(e.selectionStart, e.selectionEnd);
    } catch {
    }
  },
  focusAndSelectElement(t, e) {
    var i = e.is(":focus");
    k.trigger(e, "focus");
    var r = t.option("editing.selectTextOnEditStart"), n = e.get(0);
    if (!i && r && e.is(".dx-texteditor-input") && !e.is("[readonly]")) {
      var a = qW(e.closest(".dx-texteditor"));
      $e(a && a._loadItemDeferred).done(() => {
        n.select();
      });
    }
  },
  getWidgetInstance: qW,
  getLastResizableColumnIndex(t, e) {
    var i = t.some((u) => u && !u.command && !u.fixed && u.allowResizing !== !1), r;
    for (r = t.length - 1; t[r]; r--) {
      var n = t[r], a = e && e[r], o = !i || n.allowResizing !== !1;
      if (!n.command && !n.fixed && a !== "adaptiveHidden" && o)
        break;
    }
    return r;
  },
  isElementInCurrentGrid(t, e) {
    if (e && e.length) {
      var i = e.closest(".".concat(t.getWidgetContainerClass())).parent();
      return i.is(t.component.$element());
    }
    return !1;
  },
  isVirtualRowRendering(t) {
    var e = t.option(eve), i = t.option(KW) === GW, r = t.option(KW) === Zpe;
    return t.option(Jpe) === !1 && (i || r) ? !0 : e === GW;
  },
  getPixelRatio: (t) => t.devicePixelRatio || 1,
  getContentHeightLimit(t) {
    return t.mozilla ? 8e6 : 15e6 / this.getPixelRatio(Ot());
  },
  normalizeLookupDataSource(t) {
    var e;
    return t.items ? e = t.items : (e = t.dataSource, Le(e) && !Ha.isWrapped(e) && (e = e({}))), zp(e);
  },
  getWrappedLookupDataSource(t, e, i) {
    if (!e)
      return [];
    var r = this.normalizeLookupDataSource(t.lookup);
    if (t.calculateCellValue !== t.defaultCalculateCellValue)
      return r;
    var n = e.remoteOperations().groupPaging, a = t.displayField && ht(t.displayField), o, u, c, p = (_, y) => {
      var b, I = (b = y.skip) !== null && b !== void 0 ? b : 0, A = y.take ? I + y.take : _.length;
      return _.slice(I, A);
    }, v = ae(ae({}, r), {
      __dataGridSourceFilter: i,
      load: (_) => {
        var y = new q();
        return ((b) => {
          var I = ave(a ? [t.dataField, t.displayField] : t.dataField), A = new q(), L = o && (!n || b.skip === c && b.take === u);
          return L ? A.resolve(p(o, b)) : (c = b.skip, u = b.take, e.load({
            filter: i,
            group: I,
            take: n ? b.take : void 0,
            skip: n ? b.skip : void 0
          }).done((B) => {
            o = B, A.resolve(n ? B : p(B, b));
          }).fail(A.fail)), A;
        })(_).done((b) => {
          if (b.length === 0) {
            y.resolve([]);
            return;
          }
          var I = this.combineFilters(b.flatMap((L) => L.key).map((L) => [t.lookup.valueExpr, L]), "or"), A = new Ks(ae(ae(ae({}, r), _), {
            filter: this.combineFilters([I, _.filter], "and"),
            paginate: !1
          }));
          A.load().done(y.resolve).fail(y.fail);
        }).fail(y.fail), y;
      },
      key: t.lookup.valueExpr,
      byKey(_) {
        var y = q();
        return this.load({
          filter: [t.lookup.valueExpr, "=", _]
        }).done((b) => {
          y.resolve(b[0]);
        }), y.promise();
      }
    });
    return v;
  },
  logHeaderFilterDeprecatedWarningIfNeed(t) {
    var e = t._logDeprecatedOptionWarning.bind(t);
    R(t.option("headerFilter.allowSearch")) && e("headerFilter.allowSearch", {
      since: "23.1",
      alias: "headerFilter.search.enabled"
    }), R(t.option("headerFilter.searchTimeout")) && e("headerFilter.searchTimeout", {
      since: "23.1",
      alias: "headerFilter.search.timeout"
    });
    var i = t.NAME === "dxPivotGrid" ? "dataSource.fields" : "columns", r = t.option(i);
    if (Array.isArray(r)) {
      var n = (a) => {
        a.forEach((o) => {
          var u, c = o.headerFilter || {};
          R(c.allowSearch) && e("".concat(i, "[].headerFilter.allowSearch"), {
            since: "23.1",
            alias: "".concat(i, "[].headerFilter.search.enabled")
          }), R(c.searchMode) && e("".concat(i, "[].headerFilter.searchMode"), {
            since: "23.1",
            alias: "".concat(i, "[].headerFilter.search.mode")
          }), !((u = o.columns) === null || u === void 0) && u.length && n(o.columns);
        });
      };
      n(r);
    }
  }
};
var XW = "scroll-container", ove = "scrollable-simulated", sve = "group-space", lve = "content", uve = "table", dve = "table-fixed", cve = "content-fixed", xy = "dx-row", EL = "dx-group-row", hve = "dx-group-cell", bL = "dx-master-detail-row", fve = "filter-row", pve = "dx-error-row", vve = "cell-updated-animation", t5 = "0.0001px", wL = "dxCellHintVisible", gve = "dx-field-item-content", mve = {
  render(t) {
    t.container.append(t.content);
  }
}, _ve = function(t, e) {
  var i, r, n;
  function a(o) {
    return setTimeout(() => {
      i = r = null;
    }, o);
  }
  k.on(e, "touchstart touchend", ".dx-row", (o) => {
    clearTimeout(n), o.type === "touchstart" ? (i = o.target, r = o.currentTarget, n = a(1e3)) : n = a();
  }), k.on(e, [di, Um, Xt.down].join(" "), ".dx-row", t.createAction((o) => {
    var {
      event: u
    } = o;
    i && (u.target = i, u.currentTarget = r), E(u.target).closest("a").length || (o.rowIndex = t.getRowIndex(u.currentTarget), o.rowIndex >= 0 && (o.rowElement = ot(E(u.currentTarget)), o.columns = t.getColumns(), u.type === Xt.down ? t._rowPointerDown(o) : u.type === di ? t._rowClick(o) : t._rowDblClick(o)));
  }));
}, Kb = function(t) {
  return t === "auto" ? "" : Di(t) ? "".concat(t, "px") : t;
}, QW = function(t, e, i) {
  t.style.width = t.style.maxWidth = e.width === "auto" ? "" : i;
}, Cve = function(t, e) {
  if (!(!t || !e)) {
    var i = t.attributes, r = e.attributes, n;
    for (n = 0; n < i.length; n++) {
      var a = i[n].nodeName;
      e.hasAttribute(a) || t.removeAttribute(a);
    }
    for (n = 0; n < r.length; n++)
      t.setAttribute(r[n].nodeName, r[n].nodeValue);
  }
}, yve = function(t) {
  t.resolve();
}, i5 = (t) => typeof t == "number" ? "".concat(t.toFixed(3), "px") : t === "adaptiveHidden" ? t5 : t;
class SS extends ace(Bi.View) {
  init() {
    this._scrollLeft = -1, this._columnsController = this.getController("columns"), this._dataController = this.getController("data"), this._adaptiveColumnsController = this.getController("adaptiveColumns"), this._columnChooserController = this.getController("columnChooser"), this._editorFactoryController = this.getController("editorFactory"), this._selectionController = this.getController("selection"), this._columnChooserView = this.getView("columnChooserView"), this._delayedTemplates = [], this._templateDeferreds = /* @__PURE__ */ new Set(), this._templatesCache = {}, this._templateTimeouts = /* @__PURE__ */ new Set(), this.createAction("onCellClick"), this.createAction("onRowClick"), this.createAction("onCellDblClick"), this.createAction("onRowDblClick"), this.createAction("onCellHoverChanged", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onCellPrepared", {
      excludeValidators: ["disabled", "readOnly"],
      category: "rendering"
    }), this.createAction("onRowPrepared", {
      excludeValidators: ["disabled", "readOnly"],
      category: "rendering",
      afterExecute: (e) => {
        this._afterRowPrepared(e);
      }
    }), this._columnsController.columnsChanged.add(this._columnOptionChanged.bind(this)), this._dataController && this._dataController.changed.add(this._handleDataChanged.bind(this));
  }
  dispose() {
    var e, i;
    if (wt()) {
      var r = Ot();
      (e = this._templateTimeouts) === null || e === void 0 || e.forEach((n) => r.clearTimeout(n)), (i = this._templateTimeouts) === null || i === void 0 || i.clear();
    }
  }
  optionChanged(e) {
    switch (super.optionChanged(e), e.name) {
      case "cellHintEnabled":
      case "onCellPrepared":
      case "onRowPrepared":
      case "onCellHoverChanged":
        this._invalidate(!0, !0), e.handled = !0;
        break;
      case "keyboardNavigation":
        e.fullName === "keyboardNavigation.enabled" && this._invalidate(!0, !0), e.handled = !0;
    }
  }
  _createScrollableOptions() {
    var e = this.option("scrolling"), i = this.option("scrolling.useNative"), r = P({}, e, {
      direction: "both",
      bounceEnabled: !1,
      useKeyboard: !1
    });
    return i === void 0 && (i = !0), i === "auto" ? (delete r.useNative, delete r.useSimulatedScrollbar) : (r.useNative = !!i, r.useSimulatedScrollbar = !i), r;
  }
  _updateCell(e, i) {
    i.rowType && this._cellPrepared(e, i);
  }
  _createCell(e) {
    var {
      column: i
    } = e, r = i.alignment || Nh(this.option("rtlEnabled")), n = de.createElement("td");
    n.style.textAlign = r;
    var a = E(n);
    return e.rowType === "data" && i.headerId && !i.type && this.component.option("showColumnHeaders") && this.setAria("describedby", i.headerId, a), i.cssClass && a.addClass(i.cssClass), Array.isArray(i.elementAttr) && i.elementAttr.forEach((o) => {
      var {
        name: u,
        value: c
      } = o;
      a.attr(u, c);
    }), i.command === "expand" && (a.addClass(i.cssClass), a.addClass(this.addWidgetPrefix(sve))), i.colspan > 1 ? a.attr("colSpan", i.colspan) : !i.isBand && i.visibleWidth !== "auto" && this.option("columnAutoWidth") && ((i.width || i.minWidth) && (n.style.minWidth = Kb(i.minWidth || i.width)), i.width && QW(n, i, Kb(i.width))), a;
  }
  _createRow(e, i) {
    i = i || "tr";
    var r = E("<".concat(i, ">")).addClass(xy);
    return i === "tr" && this.setAria("role", "row", r), r;
  }
  _isAltRow(e) {
    return e && e.dataIndex % 2 === 1;
  }
  _createTable(e, i) {
    var r = E("<table>").addClass(this.addWidgetPrefix(uve)).addClass(this.addWidgetPrefix(dve));
    if (e && !i ? (r.attr("id", "dx-".concat(new yr())).append(this._createColGroup(e)), $i.safari && r.append(E("<thead>").append("<tr>")), this.setAria("role", "presentation", r)) : this.setAria("hidden", !0, r), this.setAria("role", "presentation", E("<tbody>").appendTo(r)), i)
      return r;
    $i.mozilla && k.on(r, "mousedown", "td", (a) => {
      a.ctrlKey && a.preventDefault();
    }), this.option("cellHintEnabled") && k.on(r, "mousemove", ".dx-row > td", this.createAction((a) => {
      var o = a.event, u = E(o.target), c = E(o.currentTarget), p = c.parent(), v = this._columnsController.getVisibleColumns(), _ = p.data("options"), y = c.index(), b = _ && _.cells && _.cells[y], I = b ? b.column : v[y], A = p.hasClass("dx-header-row"), L = p.hasClass("dx-data-row"), B = p.hasClass(bL), $ = p.hasClass(EL), K = p.hasClass(this.addWidgetPrefix(fve)), te = L && (!I || I.cellTemplate), z = L && b && (_.isEditing || b.isEditing || (I == null ? void 0 : I.showEditorAlways)), ie = A && (!I || I.headerCellTemplate), pe = $ && (!I || I.groupIndex && I.groupCellTemplate), _e = !B && !K && !z && !te && !ie && !pe;
      if (_e) {
        u.data(wL) && (u.removeAttr("title"), u.data(wL, !1));
        var be = u[0].scrollWidth - u[0].clientWidth;
        be > 0 && !R(u.attr("title")) && (u.attr("title", u.text()), u.data(wL, !0));
      }
    }));
    var n = (a) => {
      var o = E(a.currentTarget), u = E(a.target).closest(".".concat(gve)), c = o.parent(), p = c.data("options"), v = p && p.cells && p.cells[o.index()];
      if (o.closest("table").is(a.delegateTarget)) {
        var _ = P({}, v, {
          cellElement: ot(o),
          event: a,
          eventType: a.type
        });
        if (_.rowIndex = this.getRowIndex(c), u.length) {
          var y = u.data("dx-form-item");
          y.column && (_.column = y.column, _.columnIndex = this._columnsController.getVisibleIndex(_.column.index));
        }
        return _;
      }
    };
    return k.on(r, "mouseover", ".dx-row > td", (a) => {
      var o = n(a);
      o && this.executeAction("onCellHoverChanged", o);
    }), k.on(r, "mouseout", ".dx-row > td", (a) => {
      var o = n(a);
      o && this.executeAction("onCellHoverChanged", o);
    }), k.on(r, di, ".dx-row > td", (a) => {
      var o = n(a);
      o && this.executeAction("onCellClick", o);
    }), k.on(r, Um, ".dx-row > td", (a) => {
      var o = n(a);
      o && this.executeAction("onCellDblClick", o);
    }), _ve(this, r), r;
  }
  _rowPointerDown(e) {
  }
  _rowClick() {
  }
  _rowDblClick() {
  }
  _createColGroup(e) {
    for (var i = E("<colgroup>"), r = 0; r < e.length; r++)
      for (var n = e[r].colspan || 1, a = 0; a < n; a++)
        i.append(this._createCol(e[r]));
    return i;
  }
  _createCol(e) {
    var i = e.visibleWidth || e.width;
    i === "adaptiveHidden" && (i = t5);
    var r = E("<col>");
    return yk(r, i), r;
  }
  renderDelayedTemplates(e) {
    var i = this._delayedTemplates, r = i.filter((a) => !a.async), n = i.filter((a) => a.async);
    this._delayedTemplates = [], this._renderDelayedTemplatesCore(r, !1, e), this._renderDelayedTemplatesCoreAsync(n);
  }
  _renderDelayedTemplatesCoreAsync(e) {
    if (e.length) {
      var i = Ot().setTimeout(() => {
        this._templateTimeouts.delete(i), this._renderDelayedTemplatesCore(e, !0);
      });
      this._templateTimeouts.add(i);
    }
  }
  _renderDelayedTemplatesCore(e, i, r) {
    for (var n = /* @__PURE__ */ new Date(); e.length; ) {
      var a = e.shift(), {
        options: o
      } = a, u = de.getRootNode(E(o.container).get(0)), c = this.needWaitAsyncTemplates();
      if ((!i || E(o.container).closest(u).length || c) && (r && (o.change = r), a.template.render(o)), i && /* @__PURE__ */ new Date() - n > 30) {
        this._renderDelayedTemplatesCoreAsync(e);
        break;
      }
    }
    !e.length && this._delayedTemplates.length && this.renderDelayedTemplates();
  }
  _processTemplate(e, i) {
    var r;
    if (e && e.render && !hs(e))
      r = {
        allowRenderToDetachedContainer: e.allowRenderToDetachedContainer,
        render(a) {
          e.render(a.container, a.model, a.change), a.deferred && a.deferred.resolve();
        }
      };
    else if (Le(e))
      r = {
        render(a) {
          var o = e(ot(a.container), a.model, a.change);
          o && (o.nodeType || hs(o)) && a.container.append(o), a.deferred && a.deferred.resolve();
        }
      };
    else {
      var n = ht(e) ? e : E(e).attr("id");
      n ? (this._templatesCache[n] || (this._templatesCache[n] = this.getTemplate(e)), r = this._templatesCache[n]) : r = this.getTemplate(e);
    }
    return r;
  }
  renderTemplate(e, i, r, n, a) {
    var o, u = this._processTemplate(i, r), {
      column: c
    } = r, p = r.rowType === "data", v = new q(), _ = {
      container: e,
      model: r,
      deferred: v,
      onRendered: () => {
        this.isDisposed() ? v.reject() : v.resolve();
      }
    };
    if (u) {
      r.component = this.component;
      var y = c && (c.renderAsync && p || this.option("renderAsync") && (c.renderAsync !== !1 && (c.command || c.showEditorAlways) && p || r.rowType === "filter")), b = (o = r.renderAsync) !== null && o !== void 0 ? o : y;
      (u.allowRenderToDetachedContainer || n) && !b ? u.render(_) : this._delayedTemplates.push({
        template: u,
        options: _,
        async: b
      }), this._templateDeferreds.add(v), k.on(e, fo, yve.bind(null, v));
    } else
      v.reject();
    return v.promise().always(() => {
      this._templateDeferreds.delete(v);
    });
  }
  _getBodies(e) {
    return E(e).children("tbody").not(".dx-header").not(".dx-footer");
  }
  _needWrapRow(e) {
    var i, r = !!this.option().rowTemplate;
    return r && !!(!((i = this._getBodies(e)) === null || i === void 0) && i.filter(".".concat(xy)).length);
  }
  _wrapRowIfNeed(e, i, r) {
    var n = r ? e || this._tableElement : this._tableElement || e, a = this._needWrapRow(n);
    if (a) {
      var o = E("<tbody>").addClass(i.attr("class"));
      return this.setAria("role", "presentation", o), o.append(i);
    }
    return i;
  }
  _appendRow(e, i, r) {
    r = r || mve, r.render({
      content: i,
      container: e
    });
  }
  _resizeCore() {
    var e = this._scrollLeft;
    e >= 0 && (this._scrollLeft = 0, this.scrollTo({
      left: e
    }));
  }
  _renderCore(e) {
    var i = this.element().parent();
    (!i || i.parent().length) && this.renderDelayedTemplates(e);
  }
  _renderTable(e) {
    e = e || {}, e.columns = this._columnsController.getVisibleColumns();
    var i = e.change && e.change.changeType, r = this._createTable(e.columns, i === "append" || i === "prepend" || i === "update");
    return this._renderRows(r, e), r;
  }
  _renderRows(e, i) {
    for (var r = this._getRows(i.change), n = i.change && i.change.columnIndices || [], a = i.change && i.change.changeTypes || [], o = 0; o < r.length; o++)
      this._renderRow(e, P({
        row: r[o],
        columnIndices: n[o],
        changeType: a[o]
      }, i));
  }
  _renderRow(e, i) {
    i.columnIndices || (i.row.cells = []);
    var r = this._createRow(i.row), n = this._wrapRowIfNeed(e, r);
    i.changeType !== "remove" && this._renderCells(r, i), this._appendRow(e, n);
    var a = P({
      columns: i.columns
    }, i.row);
    this._addWatchMethod(a, i.row), this._rowPrepared(n, a, i.row);
  }
  _needRenderCell(e, i) {
    return !i || i.indexOf(e) >= 0;
  }
  _renderCells(e, i) {
    for (var r = 0, {
      row: n
    } = i, {
      columns: a
    } = i, o = 0; o < a.length; o++)
      this._needRenderCell(o, i.columnIndices) && this._renderCell(e, P({
        column: a[o],
        columnIndex: r,
        value: n.values && n.values[r],
        oldValue: n.oldValues && n.oldValues[r]
      }, i)), a[o].colspan > 1 ? r += a[o].colspan : r++;
  }
  _updateCells(e, i, r) {
    var n = e.children(), a = i.children(), o = this.option("highlightChanges"), u = this.addWidgetPrefix(vve);
    r.forEach((c, p) => {
      var v = n.eq(c), _ = a.eq(p);
      v.replaceWith(_), o && !_.hasClass("dx-command-expand") && _.addClass(u);
    }), Cve(e.get(0), i.get(0));
  }
  _setCellAriaAttributes(e, i) {
    if (i.rowType !== "freeSpace") {
      this.setAria("role", "gridcell", e);
      var r = this._columnsController.getColumnIndexOffset(), n = i.columnIndex + r + 1;
      this.setAria("colindex", n, e);
    }
  }
  _renderCell(e, i) {
    var r = this._getCellOptions(i);
    if (i.columnIndices) {
      if (i.row.cells) {
        var n = i.row.cells.findIndex((o) => o.columnIndex === r.columnIndex);
        i.row.cells[n] = r;
      }
    } else
      i.row.cells.push(r);
    var a = this._createCell(r);
    return this._setCellAriaAttributes(a, r), this._renderCellContent(a, r, i), e.get(0).appendChild(a.get(0)), a;
  }
  _renderCellContent(e, i, r) {
    var n = this._getCellTemplate(i);
    $e(!n || this.renderTemplate(e, n, i, void 0, r.change)).done(() => {
      this._updateCell(e, i);
    });
  }
  _getCellTemplate(e) {
  }
  _getRows(e) {
    return [];
  }
  _getCellOptions(e) {
    var i = {
      column: e.column,
      columnIndex: e.columnIndex,
      rowType: e.row.rowType,
      isAltRow: this._isAltRow(e.row)
    };
    return this._addWatchMethod(i), i;
  }
  _addWatchMethod(e, i) {
    if (this.option("repaintChangesOnly")) {
      var r = [];
      return i = i || e, i.watch = i.watch || function(n, a, o) {
        var u = n(i.data), c = function(p) {
          p && o && o(p);
          var v = n(i.data);
          JSON.stringify(u) !== JSON.stringify(v) && (p && a(v), u = v);
        };
        return r.push(c), function() {
          var p = r.indexOf(c);
          p >= 0 && r.splice(p, 1);
        };
      }, i.update = i.update || function(n, a) {
        n && (this.data = e.data = n.data, this.rowIndex = e.rowIndex = n.rowIndex, this.dataIndex = e.dataIndex = n.dataIndex, this.isExpanded = e.isExpanded = n.isExpanded, e.row && !a && (e.row = n)), r.forEach((o) => {
          o(n);
        });
      }, i !== e && (e.watch = i.watch.bind(i)), e;
    }
  }
  _cellPrepared(e, i) {
    i.cellElement = ot(E(e)), this.executeAction("onCellPrepared", i);
  }
  _rowPrepared(e, i, r) {
    dr(e.get(0), "options", i), i.rowElement = ot(e), this.executeAction("onRowPrepared", i);
  }
  _columnOptionChanged(e) {
    var {
      optionNames: i
    } = e;
    if (xe.checkChanges(i, ["width", "visibleWidth"])) {
      var r = this._columnsController.getVisibleColumns(), n = r.map((a) => a.visibleWidth || a.width);
      this.setColumnWidths({
        widths: n,
        optionNames: i
      });
      return;
    }
    this._requireReady || this.render();
  }
  getCellIndex(e, i) {
    var r = e.length ? e[0].cellIndex : -1;
    return r;
  }
  getTableElements() {
    return this._tableElement || E();
  }
  getTableElement(e) {
    return this._tableElement;
  }
  setTableElement(e, i) {
    this._tableElement = e;
  }
  _afterRowPrepared(e) {
  }
  _handleDataChanged(e) {
  }
  callbackNames() {
    return ["scrollChanged"];
  }
  _updateScrollLeftPosition() {
    var e = this._scrollLeft;
    e >= 0 && (this._scrollLeft = 0, this.scrollTo({
      left: e
    }));
  }
  scrollTo(e) {
    var i = this.element(), r = i && i.children(".".concat(this.addWidgetPrefix(XW))).not(".".concat(this.addWidgetPrefix(cve)));
    R(e) && R(e.left) && this._scrollLeft !== e.left && (this._scrollLeft = e.left, r && r.scrollLeft(e.left));
  }
  _getContent(e) {
    var i;
    return (i = this._tableElement) === null || i === void 0 ? void 0 : i.parent();
  }
  _removeContent(e) {
    var i = this._getContent(e);
    i != null && i.length && i.remove();
  }
  _wrapTableInScrollContainer(e, i) {
    var r = E("<div>"), n = this.option("scrolling.useNative");
    return (n === !1 || n === "auto" && !Dp) && r.addClass(this.addWidgetPrefix(ove)), k.on(r, "scroll", () => {
      var a = r.scrollLeft();
      a !== this._scrollLeft && this.scrollChanged.fire({
        left: a
      }, this.name);
    }), r.addClass(this.addWidgetPrefix(lve)).addClass(this.addWidgetPrefix(XW)).append(e).appendTo(this.element()), this.setAria("role", "presentation", r), r;
  }
  needWaitAsyncTemplates() {
    return this.option("templatesRenderAsynchronously") && this.option("renderAsync") === !1;
  }
  waitAsyncTemplates() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, i = new q(), r = e || this.needWaitAsyncTemplates();
    if (!r)
      return i.resolve();
    var n = () => $e.apply(this, Array.from(this._templateDeferreds)).done(() => {
      this.isDisposed() ? i.reject() : this._templateDeferreds.size > 0 ? n() : i.resolve();
    }).fail(i.reject);
    return n(), i.promise();
  }
  _updateContent(e, i, r) {
    return this.waitAsyncTemplates().done(() => {
      this._removeContent(r), this.setTableElement(e, r), this._wrapTableInScrollContainer(e, r);
    });
  }
  _findContentElement(e) {
  }
  _getWidths(e) {
    if (!e)
      return [];
    var i = [], r = e.toArray();
    return r.forEach((n) => {
      var a = n.offsetWidth;
      if (n.getBoundingClientRect) {
        var o = zr(n);
        o.width > n.offsetWidth - 1 && (a = o.width);
      }
      i.push(a);
    }), i;
  }
  getColumnWidths(e) {
    if ((this.option("forceApplyBindings") || ee)(), e = e ?? this.getTableElement(), e)
      for (var i = e.children("tbody:not(.dx-header)").children(), r = 0; r < i.length; r++) {
        var n = i.eq(r), a = n.hasClass(EL), o = n.hasClass(bL), u = n.hasClass(pve), c = n.get(0).style.display !== "none" && !n.hasClass("dx-state-invisible"), p = !a && !o && !u;
        if (c && p) {
          var v = n.children("td"), _ = this._getWidths(v);
          return _;
        }
      }
    return [];
  }
  getVisibleColumnIndex(e, i) {
    return e;
  }
  setColumnWidths(e) {
    var {
      widths: i,
      optionNames: r
    } = e, n = this.getTableElement();
    if (!(!(n != null && n.length) || !i)) {
      var a = this.getColumns(), o = this.option("columnAutoWidth"), u = n.children("colgroup").children("col");
      u.toArray().forEach((c) => c.removeAttribute("style")), a.forEach((c, p) => {
        if (o && c.width && !c.command)
          for (var v = Kb(c.visibleWidth || c.width), _ = Kb(c.minWidth || v), y = n.children().children(".dx-row").not(".".concat(bL)), b = 0; b < y.length; b++) {
            var I = this.getVisibleColumnIndex(p, b);
            if (I >= 0) {
              var A = y.eq(b), L = A.hasClass(EL) ? A.find("td[aria-colindex='".concat(I + 1, "']:not(.").concat(hve, ")")) : A.find("td").eq(I);
              if (L.length) {
                var B = L.get(0);
                QW(B, c, v), B.style.minWidth = _;
              }
            }
          }
        var $ = i5(i[p]);
        R($) && yk(u.eq(p), $);
      });
    }
  }
  getCellElements(e) {
    return this._getCellElementsCore(e);
  }
  _getCellElementsCore(e) {
    if (!(e < 0)) {
      var i = this._getRowElements().eq(e);
      return i.children();
    }
  }
  _getCellElement(e, i) {
    var r = this.getCellElements(e), n = this._getVisibleColumnIndex(r, e, i);
    if (!(!(r != null && r.length) || n < 0)) {
      var a = r.eq(n);
      return a.length > 0 ? a : void 0;
    }
  }
  _getRowElement(e) {
    var i = this, r = E(), n = i.getTableElements();
    if (N(n, (a, o) => {
      r = r.add(i._getRowElements(E(o)).eq(e));
    }), r.length)
      return r;
  }
  getCellElement(e, i) {
    var r = this._getCellElement(e, i);
    if (r)
      return ot(r);
  }
  getRowElement(e) {
    var i = this._getRowElement(e), r = [];
    if (i && !ot(i).get)
      for (var n = 0; n < i.length; n++)
        r.push(i[n]);
    else
      r = i;
    return r;
  }
  _getVisibleColumnIndex(e, i, r) {
    if (ht(r)) {
      var n = this._columnsController.columnOption(r, "index");
      return this._columnsController.getVisibleIndex(n);
    }
    return r;
  }
  getColumnElements() {
  }
  getColumns(e, i) {
    return this._columnsController.getVisibleColumns(e);
  }
  getCell(e, i, r) {
    var n = i || this._getRowElements(), a;
    if (n.length > 0 && e.rowIndex >= 0 && (this.option("scrolling.mode") !== "virtual" && this.option("scrolling.rowRenderingMode") !== "virtual" && (e.rowIndex = e.rowIndex < n.length ? e.rowIndex : n.length - 1), a = r || this.getCellElements(e.rowIndex), (a == null ? void 0 : a.length) > 0))
      return a.eq(a.length > e.columnIndex ? e.columnIndex : a.length - 1);
  }
  getRowsCount() {
    var e = this.getTableElement();
    return e && e.length === 1 ? e[0].rows.length : 0;
  }
  _getRowElementsCore(e) {
    if (e = e || this.getTableElement(), e) {
      var i = this.option().rowTemplate || this.option("dataRowTemplate"), r = i && e.find("> tbody.".concat(xy));
      return r && r.length ? r : e.find("> tbody > " + ".".concat(xy, ", > .").concat(xy));
    }
    return E();
  }
  _getRowElements(e) {
    return this._getRowElementsCore(e);
  }
  getRowIndex(e) {
    return this._getRowElements().index(e);
  }
  getBoundingRect() {
  }
  getName() {
  }
  setScrollerSpacing(e) {
    var i = this.element(), r = this.option("rtlEnabled");
    i && i.css({
      paddingLeft: r ? e : "",
      paddingRight: r ? "" : e
    });
  }
  isScrollbarVisible(e) {
    var i = this.element(), r = this._tableElement;
    return i && r ? e ? oi(r) - mt(i) > 0 : jt(r) - Pt(i) > 0 : !1;
  }
  isDisposed() {
    var e;
    return (e = this.component) === null || e === void 0 ? void 0 : e._disposed;
  }
}
var yB = "text-content", xve = "headers", Sve = "nowrap", Eve = ".dx-row", ZW = "dx-header-row", bve = "dx-column-lines", wve = "context-menu-sort-asc", Tve = "context-menu-sort-desc", Ive = "context-menu-sort-none", Dve = "dx-cell-focus-disabled", TL = "dx-visibility-hidden", JW = "dx-text-content-alignment-", Ave = "dx-sort-indicator", Ove = "dx-sort-index-indicator", Rve = ".dx-header-filter", Lve = "dx-header-filter-indicator", Mve = "dx-header-multi-row", kve = "dx-link", IL = function(t, e, i) {
  var r = E("<div>").addClass(t.addWidgetPrefix(yB));
  t.setAria("role", "presentation", r), r5(t, e, i.column, r);
  var n = t.option("showColumnLines"), a = t.getController("columns").getHeaderContentAlignment(i.column.alignment);
  return r[n || a === "right" ? "appendTo" : "prependTo"](e);
};
function r5(t, e, i, r) {
  var n = t._getIndicatorElements(e, !0), a = t._getIndicatorElements(e), o = n && n.length, u = t._getColumnAlignment(i.alignment), c = ".".concat(t._getIndicatorClassName("sort")), p = ".".concat(t._getIndicatorClassName("sortIndex")), v = a.filter(c), _ = a.children().filter(p);
  r = r || e.children(".".concat(t.addWidgetPrefix(yB))), r.toggleClass(JW + u, o > 0).toggleClass(JW + (u === "left" ? "right" : "left"), o > 0 && i.alignment === "center").toggleClass(Ave, !!v.length).toggleClass(Ove, !!_.length).toggleClass(Lve, !!a.filter(".".concat(t._getIndicatorClassName("headerFilter"))).length);
}
let Pve = class extends SS {
  init() {
    super.init(), this._headerPanelView = this.getView("headerPanel"), this._headerFilterController = this.getController("headerFilter"), this._dataController = this.getController("data");
  }
  _createTable() {
    var e = super._createTable.apply(this, arguments);
    return k.on(e, "mousedown selectstart", this.createAction((i) => {
      var {
        event: r
      } = i;
      r.shiftKey && r.preventDefault();
    })), e;
  }
  _isLegacyKeyboardNavigation() {
    return this.option("useLegacyKeyboardNavigation");
  }
  _getDefaultTemplate(e) {
    var i = this;
    return function(r, n) {
      var {
        caption: a
      } = e, o = !e.command || a && e.command !== "expand";
      if (e.command === "empty")
        i._renderEmptyMessage(r, n);
      else if (o) {
        var u = IL(i, r, n);
        u.text(a);
      } else
        e.command && r.html("&nbsp;");
    };
  }
  _renderEmptyMessage(e, i) {
    var r = this._getEmptyHeaderText();
    if (!r) {
      e.html("&nbsp;");
      return;
    }
    var n = IL(this, e, i), a = r.includes("{0}");
    if (a) {
      var [o, u] = r.split("{0}"), c = X.format("dxDataGrid-emptyHeaderColumnChooserText"), p = this._columnChooserView, v = E("<a>").text(c).addClass(kve);
      k.on(v, "click", this.createAction(() => p.showColumnChooser())), n.append(de.createTextNode(o)).append(v).append(de.createTextNode(u));
    } else
      n.text(r);
  }
  _getEmptyHeaderText() {
    var e = !!this._columnChooserView.hasHiddenColumns(), i = !!this._headerPanelView.hasGroupedColumns();
    switch (!0) {
      case (e && i):
        return X.format("dxDataGrid-emptyHeaderWithColumnChooserAndGroupPanelText");
      case i:
        return X.format("dxDataGrid-emptyHeaderWithGroupPanelText");
      case e:
        return X.format("dxDataGrid-emptyHeaderWithColumnChooserText");
      default:
        return "";
    }
  }
  _getHeaderTemplate(e) {
    return e.headerCellTemplate || {
      allowRenderToDetachedContainer: !0,
      render: this._getDefaultTemplate(e)
    };
  }
  _processTemplate(e, i) {
    var r = this, n, {
      column: a
    } = i, o = super._processTemplate(e);
    return i.rowType === "header" && o && a.headerCellTemplate && !a.command ? n = {
      render(u) {
        var c = IL(r, u.container, u.model);
        o.render(P({}, u, {
          container: c
        }));
      }
    } : n = o, n;
  }
  _handleDataChanged(e) {
    e.changeType === "refresh" && (this._isGroupingChanged || this._requireReady) && (this._isGroupingChanged = !1, this.render());
  }
  _renderCell(e, i) {
    var r = super._renderCell(e, i);
    return i.row.rowType === "header" && (r.addClass(Dve), this._isLegacyKeyboardNavigation() || i.column && !i.column.type && r.attr("tabindex", this.option("tabindex") || 0)), r;
  }
  _setCellAriaAttributes(e, i) {
    super._setCellAriaAttributes(e, i), i.rowType === "header" && (i.column.type || this.setAria("role", "columnheader", e), i.column && !i.column.command && !i.column.isBand && (e.attr("id", i.column.headerId), this.setAria("label", "".concat(X.format("dxDataGrid-ariaColumn"), " ").concat(i.column.caption), e)));
  }
  _createRow(e) {
    var i = super._createRow.apply(this, arguments);
    return i.toggleClass(bve, this.option("showColumnLines")), e.rowType === "header" && (i.addClass(ZW), this._isLegacyKeyboardNavigation() || fx("columnHeaders", this, i, "td", this._handleActionKeyDown.bind(this))), i;
  }
  _processHeaderAction(e, i) {
  }
  _handleActionKeyDown(e) {
    var {
      event: i
    } = e, r = E(i.target);
    if (this._lastActionElement = i.target, r.is(Rve)) {
      var n = this._headerFilterController, a = r.closest("td"), o = this.getColumnIndexByElement(a);
      o >= 0 && n.showHeaderFilterMenu(o, !1);
    } else {
      var u = r.closest(Eve);
      this._processHeaderAction(i, u);
    }
    i.preventDefault();
  }
  _renderCore() {
    var e = this.element(), i = {};
    if (!(this._tableElement && !this._dataController.isLoaded() && !this._hasRowElements)) {
      e.addClass(this.addWidgetPrefix(xve)).toggleClass(this.addWidgetPrefix(Sve), !this.option("wordWrapEnabled")).empty(), this.setAria("role", "presentation", e);
      var r = this._updateContent(this._renderTable({
        change: i
      }), i);
      return this.getRowCount() > 1 && e.addClass(Mve), super._renderCore.apply(this, arguments), r;
    }
  }
  _renderRows() {
    (this._dataController.isLoaded() || this._hasRowElements) && (super._renderRows.apply(this, arguments), this._hasRowElements = !0);
  }
  _renderRow(e, i) {
    var r = this.getRowCount() === 1 ? null : i.row.rowIndex;
    i.columns = this.getColumns(r), super._renderRow(e, i);
  }
  _createCell(e) {
    var {
      column: i
    } = e, r = super._createCell.apply(this, arguments);
    return i.rowspan > 1 && e.rowType === "header" && r.attr("rowSpan", i.rowspan), r;
  }
  _getRows() {
    var e = [], i = this.getRowCount();
    if (this.option("showColumnHeaders"))
      for (var r = 0; r < i; r++)
        e.push({
          rowType: "header",
          rowIndex: r
        });
    return e;
  }
  _getCellTemplate(e) {
    if (e.rowType === "header")
      return this._getHeaderTemplate(e.column);
  }
  _columnOptionChanged(e) {
    var {
      changeTypes: i
    } = e, {
      optionNames: r
    } = e;
    if (i.grouping || i.groupExpanding) {
      i.grouping && (this._isGroupingChanged = !0);
      return;
    }
    super._columnOptionChanged(e), (r.width || r.visible) && this.resizeCompleted.fire();
  }
  _isElementVisible(e) {
    return e && e.visible;
  }
  _alignCaptionByCenter(e) {
    var i = this._getIndicatorContainer(e, !0);
    i && i.length && (i.filter(".".concat(TL)).remove(), i = this._getIndicatorContainer(e), i.clone().addClass(TL).css("float", "").insertBefore(e.children(".".concat(this.addWidgetPrefix(yB)))));
  }
  _updateCell(e, i) {
    i.rowType === "header" && i.column.alignment === "center" && this._alignCaptionByCenter(e), super._updateCell.apply(this, arguments);
  }
  _updateIndicator(e, i, r) {
    var n = super._updateIndicator.apply(this, arguments);
    return i.alignment === "center" && this._alignCaptionByCenter(e), r5(this, e, i), n;
  }
  _getIndicatorContainer(e, i) {
    var r = super._getIndicatorContainer(e);
    return i ? r : r.filter(":not(.".concat(TL, ")"));
  }
  _isSortableElement(e) {
    return !0;
  }
  getHeadersRowHeight() {
    var e = this.getTableElement(), i = e && e.find(".".concat(ZW));
    return i && i.toArray().reduce((r, n) => r + Pt(n), 0) || 0;
  }
  getHeaderElement(e) {
    var i = this.getColumnElements();
    return i && i.eq(e);
  }
  getColumnElements(e, i) {
    var r = this, n, a = r._columnsController, o = r.getRowCount();
    if (r.option("showColumnHeaders")) {
      if (o > 1 && (!R(e) || R(i))) {
        var u = [], c = R(i) ? a.getChildrenByBandColumn(i, !0) : a.getVisibleColumns();
        return N(c, (p, v) => {
          var _ = R(e) ? e : a.getRowIndex(v.index);
          n = r._getCellElement(_, a.getVisibleIndex(v.index, _)), n && u.push(n.get(0));
        }), E(u);
      }
      if (!e || e < o)
        return r.getCellElements(e || 0);
    }
  }
  getColumnIndexByElement(e) {
    var i = this.getCellIndex(e), r = e.closest(".dx-row"), {
      rowIndex: n
    } = r[0], a = this.getColumns(n)[i];
    return a ? a.index : -1;
  }
  getVisibleColumnIndex(e, i) {
    var r = this.getColumns()[e];
    return r ? this._columnsController.getVisibleIndex(r.index, i) : -1;
  }
  getColumnWidths() {
    var e = this.getColumnElements();
    return e && e.length ? this._getWidths(e) : super.getColumnWidths.apply(this, arguments);
  }
  allowDragging(e) {
    var i, r = e && this._columnsController.getRowIndex(e.index), n = this.getColumns(r), a = (i = this.option("allowColumnReordering")) !== null && i !== void 0 ? i : this._columnsController.isColumnOptionUsed("allowReordering");
    return a && e.allowReordering && n.length > 1;
  }
  getBoundingRect() {
    var e = this.getColumnElements();
    if (e && e.length) {
      var i = this.getTableElement().offset();
      return {
        top: i.top
      };
    }
    return null;
  }
  getName() {
    return "headers";
  }
  getColumnCount() {
    var e = this.getColumnElements();
    return e ? e.length : 0;
  }
  isVisible() {
    return this.option("showColumnHeaders");
  }
  optionChanged(e) {
    switch (e.name) {
      case "showColumnHeaders":
      case "wordWrapEnabled":
      case "showColumnLines":
        this._invalidate(!0, !0), e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
  getHeight() {
    return this.getElementHeight();
  }
  getContextMenuItems(e) {
    var i = this, {
      column: r
    } = e;
    if (e.row && (e.row.rowType === "header" || e.row.rowType === "detailAdaptive")) {
      var n = i.option("sorting");
      if (n && n.mode !== "none" && r && r.allowSorting) {
        var a = function(o) {
          setTimeout(() => {
            i._columnsController.changeSortOrder(r.index, o.itemData.value);
          });
        };
        return [{
          text: n.ascendingText,
          value: "asc",
          disabled: r.sortOrder === "asc",
          icon: wve,
          onItemClick: a
        }, {
          text: n.descendingText,
          value: "desc",
          disabled: r.sortOrder === "desc",
          icon: Tve,
          onItemClick: a
        }, {
          text: n.clearText,
          value: "none",
          disabled: !r.sortOrder,
          icon: Ive,
          onItemClick: a
        }];
      }
    }
  }
  getRowCount() {
    return this._columnsController && this._columnsController.getRowCount();
  }
  setRowsOpacity(e, i, r) {
    var n, a, o = this.getRowCount(), u = this._columnsController.getColumns(), c = u && u[e], p = c && c.isBand && c.index, v = (y, b) => {
      y.ownerBand === p && (a.eq(b).css({
        opacity: i
      }), y.isBand && this.setRowsOpacity(y.index, i, n + 1));
    };
    if (R(p)) {
      for (r = r || 0, n = r; n < o; n++)
        if (a = this.getCellElements(n), a) {
          var _ = this.getColumns(n);
          _.forEach(v);
        }
    }
  }
};
var n5 = {
  defaultOptions: () => ({
    showColumnHeaders: !0,
    cellHintEnabled: !0
  }),
  views: {
    columnHeadersView: Pve
  }
};
const et = ae(ae(ae({}, Bi), xe), {
  modules: []
});
var MVe = n5.views.columnHeadersView;
et.registerModule("columnHeaders", n5);
var a5 = ["filterValues", "filterType", "fixed", "fixedPosition"], FT = ["visibleIndex", "dataField", "name", "dataType", "width", "visible", "sortOrder", "lastSortOrder", "sortIndex", "groupIndex", "filterValue", "bufferedFilterValue", "selectedFilterOperation", "bufferedSelectedFilterOperation", "added"].concat(a5), Fve = {
  visibleWidth: !0,
  bestFitWidth: !0,
  bufferedFilterValue: !0
}, Bve = "dx-command-expand", eU = Number.MAX_SAFE_INTEGER || 9007199254740991, Ih = "groupExpand", Vve = "detailExpand", DL = /columns\[(\d+)\]\.?/gi, Nve = {
  visible: !0,
  showInColumnChooser: !0
}, Hve = {
  number: ["=", "<>", "<", ">", "<=", ">=", "between"],
  string: ["contains", "notcontains", "startswith", "endswith", "=", "<>"],
  date: ["=", "<>", "<", ">", "<=", ">=", "between"],
  datetime: ["=", "<>", "<", ">", "<=", ">=", "between"]
}, $ve = {
  visibleIndex: !0,
  groupIndex: !0,
  grouped: !0,
  sortIndex: !0,
  sortOrder: !0
}, cm = "group", hm = "columnChooser", o5 = "number", s5 = "yyyy/MM/dd", zve = "yyyy/MM/dd HH:mm:ss", l5 = /^(\d{4,})(-)?(\d{2})(-)?(\d{2})(?:T(\d{2})(:)?(\d{2})?(:)?(\d{2}(?:\.(\d{1,3})\d*)?)?)?(Z|([+-])(\d{2})(:)?(\d{2})?)?$/, u5 = /^(\d{2}):(\d{2})(:(\d{2}))?$/, tU = ["", "yyyy", "", "MM", "", "dd", "THH", "", "mm", "", "ss", ".SSS"], Wve = /^(\d{4})\/(\d{2})\/(\d{2})$/, Uve = 3, d5 = function(t, e) {
  var i;
  return ht(t) && !e && (i = Kve(t)), i || Gve(t);
};
function Va(t) {
  return +t || 0;
}
function Gve(t) {
  var e = c5(t) === s5, i = !zo(t) && Date.parse(t);
  if (!i && e) {
    var r = t.match(Wve);
    if (r) {
      var n = new Date(Va(r[1]), Va(r[2]), Va(r[3]));
      return n.setFullYear(Va(r[1])), n.setMonth(Va(r[2]) - 1), n.setDate(Va(r[3])), n;
    }
  }
  return Di(i) ? new Date(i) : t;
}
function Kve(t) {
  var e = t.match(l5);
  if (!e)
    return e = t.match(u5), e ? new Date(0, 0, 0, Va(e[1]), Va(e[2]), Va(e[4])) : void 0;
  var i = Va(e[1]), r = --e[3], n = e[5], a = 0, o = 0, u = (y) => (i < 100 && y.setFullYear(i), y);
  a = Va(e[14]), o = Va(e[16]), e[13] === "-" && (a = -a, o = -o);
  var c = Va(e[6]) - a, p = Va(e[8]) - o, v = Va(e[10]), _ = function(y) {
    return y = y || "", Va(y) * Math.pow(10, Uve - y.length);
  }(e[11]);
  return e[12] ? u(new Date(Date.UTC(i, r, n, c, p, v, _))) : u(new Date(i, r, n, c, p, v, _));
}
var jve = function(t, e) {
  var i = t.match(l5), r = "";
  if (!i)
    return i = t.match(u5), i ? i[3] ? "HH:mm:ss" : "HH:mm" : void 0;
  for (var n = 1; n < tU.length; n++)
    i[n] && (r += tU[n] || i[n]);
  return i[12] === "Z" && (r += "'Z'"), i[14] && (i[15] ? r += "xxx" : i[16] ? r += "xx" : r += "x"), r;
}, Yve = function(t) {
  return typeof t == "number" ? new Date(t) : d5(t, !Oi().forceIsoDateParsing);
}, qve = function(t, e) {
  return e ? zo(t) ? e === o5 ? t && t.valueOf ? t.valueOf() : null : R6(e, _m)(t) : null : t;
}, c5 = function(t) {
  if (typeof t == "number")
    return o5;
  if (ht(t)) {
    var e;
    return Oi().forceIsoDateParsing && (e = jve(t)), e || (t.indexOf(":") >= 0 ? zve : s5);
  } else if (t)
    return null;
};
const $r = {
  dateParser: d5,
  deserializeDate: Yve,
  serializeDate: qve,
  getDateSerializationFormat: c5
};
var h5 = function(t) {
  t.filterOperations = t.defaultFilterOperations;
}, Xve = 1, TI = function(t, e, i, r) {
  var n = {};
  if (e) {
    ht(e) && (e = {
      dataField: e
    }), t.setName(e);
    var a = {};
    if (e.command)
      a = Hs(n, e);
    else {
      n = t.getCommonSettings(e), i && i.name && i.dataField && (e = P({}, e, {
        dataField: i.dataField
      }));
      var o = t._createCalculatedColumnOptions(e, r);
      e.type || (a = {
        headerId: "dx-col-".concat(Xve++)
      }), a = Hs(a, Nve), Hs(a, n), Hs(a, o), Hs(a, e), Hs(a, {
        selector: null
      });
    }
    return e.filterOperations === e.defaultFilterOperations && h5(a), a;
  }
}, fm = function t(e, i, r, n) {
  var a = [];
  return i && N(i, (o, u) => {
    var c = (n ?? 0) + a.length, p = e._columnsUserState && xB(u, e._columnsUserState[c]) && e._columnsUserState[c], v = TI(e, u, p, r);
    v && (r && (v.ownerBand = r), a.push(v), v.columns && (a = a.concat(t(e, v.columns, v, a.length)), delete v.columns, v.hasColumns = !0));
  }), a;
}, fp = function(t, e) {
  for (var i = [], r = e[t]; r; )
    i.unshift(r), t = r.index, r = e[t];
  return i;
}, Qve = function t(e, i, r) {
  var n = [], a = i[e];
  if (a)
    for (var o = 0; o < a.length; o++) {
      var u = a[o];
      (!R(u.groupIndex) || u.showWhenGrouped) && (n.push(u), r && u.isBand && (n = n.concat(t(u.index, i, r))));
    }
  return n;
}, Zve = function(t, e) {
  var i, r, n = t.getBandColumnsCache(), a = function(u) {
    var c = i ? i.index : void 0;
    return u.ownerBand === c;
  };
  if (n.isPlain)
    i = t._columns[e[0]];
  else {
    r = t._columns.filter(a);
    for (var o = 0; o < e.length; o++)
      i = r[e[o]], i && (r = t._columns.filter(a));
  }
  return i;
}, Jve = function(t, e) {
  var i = [], r, n = t.getBandColumnsCache(), a = function(u) {
    return u.ownerBand === e.ownerBand;
  };
  if (n.isPlain) {
    var o = t._columns.indexOf(e);
    o >= 0 && (i = ["columns[".concat(o, "]")]);
  } else
    for (r = t._columns.filter(a); r.length && r.indexOf(e) !== -1; )
      i.unshift("columns[".concat(r.indexOf(e), "]")), e = n.columnParentByIndex[e.index], r = e ? t._columns.filter(a) : [];
  return i.join(".");
}, ege = function t(e, i) {
  var r = 0, n = e.getChildrenByBandColumn(i, !0);
  return N(n, (a, o) => {
    o.isBand ? (o.colspan = o.colspan || t(e, o.index), r += o.colspan || 1) : r += 1;
  }), r;
}, tge = function(t, e, i) {
  for (var r, n = 0; n < e.length; n++) {
    var a = e[n];
    (a.visible || a.command) && (a.isBand && (a.colspan = a.colspan || ege(t, a.index)), (!a.isBand || !a.colspan) && (r = t.getRowCount(), !a.command && (!R(a.groupIndex) || a.showWhenGrouped) && (r -= fp(a.index, i.columnParentByIndex).length), r > 1 && (a.rowspan = r)));
  }
}, AL = function(t) {
  var e = cs(t);
  return e !== "string" && e !== "boolean" && e !== "number" && e !== "date" && e !== "object" && (e = void 0), e;
}, iU = function(t, e) {
  switch (t) {
    case "date":
    case "datetime":
      return $r.getDateSerializationFormat(e);
    case "number":
      if (ht(e))
        return "string";
      if (Di(e))
        return null;
  }
}, rU = function(t, e) {
  t.deserializeValue || (xe.isDateType(e) && (t.deserializeValue = function(i) {
    return $r.deserializeDate(i);
  }, t.serializeValue = function(i) {
    return ht(i) ? i : $r.serializeDate(i, this.serializationFormat);
  }), e === "number" && (t.deserializeValue = function(i) {
    var r = parseFloat(i);
    return isNaN(r) ? i : r;
  }, t.serializeValue = function(i, r) {
    return r === "filter" ? i : R(i) && this.serializationFormat === "string" ? i.toString() : i;
  }));
}, ige = function(t, e) {
  switch (t) {
    case "number":
      return "right";
    case "boolean":
      return "center";
    default:
      return Nh(e);
  }
}, rge = function(t) {
  return t.value === !0 ? this.trueText || "true" : t.value === !1 ? this.falseText || "false" : t.valueText || "";
}, nU = function(t) {
  if (t === "boolean")
    return rge;
}, nge = function(t, e) {
  for (var i = t._getFirstItems(e), r, n = {}, a = [], o = 0; o < i.length; o++)
    if (i[o])
      for (r in i[o])
        (!Le(i[o][r]) || Ha.isWrapped(i[o][r])) && (n[r] = !0);
  for (r in n)
    if (r.indexOf("__") !== 0) {
      var u = TI(t, r);
      a.push(u);
    }
  return a;
}, f5 = function(t) {
  N(t._columns, (e, i) => {
    i.index = e;
  }), N(t._columns, (e, i) => {
    ct(i.ownerBand) && (i.ownerBand = i.ownerBand.index);
  }), N(t._commandColumns, (e, i) => {
    i.index = -(e + 1);
  });
}, p5 = function(t, e) {
  Px(t._columns, "groupIndex", e, (i) => {
    var {
      grouped: r
    } = i;
    return delete i.grouped, r;
  });
}, age = function(t, e) {
  N(t._columns, (i, r) => {
    R(r.sortIndex) && !BT(r.sortOrder) && delete r.sortIndex;
  }), Px(t._columns, "sortIndex", e, (i) => !R(i.groupIndex) && BT(i.sortOrder));
}, oge = function(t, e) {
  for (var i, r = [], n = t.getBandColumnsCache(), a = [], o = t._columns.filter((p) => !p.command), u = 0; u < o.length; u++) {
    i = o[u];
    var c = fp(u, n.columnParentByIndex);
    c.length ? a.push(i) : r.push(i);
  }
  Px(a, "visibleIndex", e), Px(r, "visibleIndex", e);
}, OL = function(t, e, i) {
  var r = ct(e) ? e.rowIndex : null, n = i === cm ? t.getGroupColumns() : i === hm ? t.getChooserColumns() : t.getVisibleColumns(r), a;
  return e = ct(e) ? e.columnIndex : e, a = n[e], a && a.type === Ih && (a = t._columns.filter((o) => a.type === o.type)[0] || a), a && R(a.index) ? a.index : -1;
}, sge = function(t, e, i) {
  var r = t.getGroupColumns(), n;
  if (i >= 0)
    for (n = 0; n < r.length; n++)
      r[n].groupIndex >= i && r[n].groupIndex++;
  else
    for (i = 0, n = 0; n < r.length; n++)
      i = Math.max(i, r[n].groupIndex + 1);
  return i;
};
function xB(t, e) {
  return t && e && e.name === (t.name || t.dataField) && (e.dataField === t.dataField || t.name);
}
var aU = function(t) {
  var e = t._columnsUserState, i = t._ignoreColumnOptionNames || [], r = t._columns, n = {}, a = [], o = !0, u = [], c, p, v;
  function _(A, L) {
    if (L)
      for (var B = 0; B < FT.length; B++) {
        var $ = FT[B];
        i.includes($) || ($ === "dataType" ? A[$] = A[$] || L[$] : a5.includes($) ? $ in L && (A[$] = L[$]) : ($ === "selectedFilterOperation" && L[$] && (A.defaultSelectedFilterOperation = A[$] || null), A[$] = L[$]));
      }
  }
  function y(A, L) {
    for (var B = L.name || L.dataField, $ = n[B] || 0, K = 0; K < A.length; K++)
      if (xB(L, A[K]))
        if ($)
          $--;
        else
          return n[B] = n[B] || 0, n[B]++, K;
    return -1;
  }
  if (e) {
    for (v = 0; v < r.length; v++)
      p = y(e, r[v]), o = o && p >= 0, u.push(p);
    for (v = 0; v < r.length; v++)
      c = r[v], p = u[v], (t._hasUserState || o) && _(c, e[p]), p >= 0 && R(e[p].initialIndex) ? a[p] = c : a.push(c);
    var b = !1;
    for (v = 0; v < e.length; v++) {
      var I = e[v];
      I.added && y(r, I) < 0 && (c = TI(t, I.added), _(c, I), a.push(c), I.added.columns && (b = !0));
    }
    b && (f5(t), a = fm(t, a)), pm(t, a);
  }
}, op = function(t, e) {
  f5(t), p5(t, e), age(t, e), v5(t), oge(t, e);
}, II = function(t) {
  t.resetColumnsCache();
};
function pm(t, e) {
  t._previousColumns = t._columns, t._columns = e, II(t), t.updateColumnDataTypes();
}
var xu = function(t, e, i, r) {
  var n, a = t._columnChanges || {
    optionNames: {
      length: 0
    },
    changeTypes: {
      length: 0
    },
    columnIndex: r
  };
  i = i || "all", i = i.split(".")[0];
  var {
    changeTypes: o
  } = a;
  e && !o[e] && (o[e] = !0, o.length++);
  var {
    optionNames: u
  } = a;
  i && !u[i] && (u[i] = !0, u.length++), (r === void 0 || r !== a.columnIndex) && (R(r) && ((n = a.columnIndices) !== null && n !== void 0 || (a.columnIndices = []), R(a.columnIndex) && a.columnIndices.push(a.columnIndex), a.columnIndices.push(r)), delete a.columnIndex), t._columnChanges = a, II(t);
}, Sy = function(t) {
  var e = t.option("onColumnsChanging"), i = t._columnChanges, r = ["dataField", "lookup", "dataType", "columns"];
  t.isInitialized() && !t._updateLockCount && i && (e && (t._updateLockCount++, e(P({
    component: t.component
  }, i)), t._updateLockCount--), t._columnChanges = void 0, n = i.optionNames, n && r.some((a) => n[a]) ? (t._reinitAfterLookupChanges = i == null ? void 0 : i.optionNames.lookup, t.reinit(), t._reinitAfterLookupChanges = void 0) : t.columnsChanged.fire(i));
  var n;
}, lge = function(t, e, i, r) {
  var n = r >= 0;
  if (i >= 0)
    n || (e.lastSortOrder = e.sortOrder);
  else {
    var a = t.option("sorting.mode"), o = e.lastSortOrder;
    if (a === "single") {
      var u = t._columns.some((c) => c !== e && R(c.sortIndex));
      u && (o = void 0);
    }
    e.sortOrder = o;
  }
}, uge = function(t, e) {
  var {
    value: i
  } = e, {
    optionName: r
  } = e, {
    prevValue: n
  } = e, {
    fullOptionName: a
  } = e, o = "".concat(a, ".").concat(r);
  !Fve[r] && t._skipProcessingColumnsChange !== o && (t._skipProcessingColumnsChange = o, t.component._notifyOptionChanged(o, i, n), t._skipProcessingColumnsChange = !1);
}, RL = function(t, e, i, r, n) {
  var a = Ii(i), o = e.index, u, c, p;
  if (arguments.length === 3)
    return a(e, {
      functionsAsIs: !0
    });
  var v = a(e, {
    functionsAsIs: !0
  });
  if (!Mi(v, r, {
    maxDepth: 5
  })) {
    i === "groupIndex" || i === "calculateGroupValue" ? (c = "grouping", lge(t, e, r, v)) : i === "sortIndex" || i === "sortOrder" || i === "calculateSortValue" ? c = "sorting" : c = "columns";
    var _ = nF(i);
    _(e, r, {
      functionsAsIs: !0
    });
    var y = Jve(t, e);
    $ve[i] && (op(t, e), r = a(e)), (i === "name" || i === "allowEditing") && t._checkColumns(), !R(v) && !R(r) && i.indexOf("buffer") !== 0 && (n = !0), n ? II(t) : (!FT.includes(i) && i !== "visibleWidth" && (u = t.option("columns"), p = t.getColumnByPath(y, u), ht(p) && (p = u[o] = {
      dataField: p
    }), p && xB(p, e) && _(p, r, {
      functionsAsIs: !0
    })), xu(t, c, i, o)), y && uge(t, {
      fullOptionName: y,
      optionName: i,
      value: r,
      prevValue: v
    });
  }
};
function BT(t) {
  return t === "asc" || t === "desc";
}
var dge = function(t) {
  var e = t._getExpandColumnOptions();
  t.addCommandColumn(e);
}, cge = function(t, e) {
  if (this.dataField) {
    var i = this.dataField.split("."), r = i.length - 1;
    this.serializeValue && (e = this.serializeValue(e));
    for (var n = 0; n < r; n++) {
      var a = i[n];
      t = t[a] = t[a] || {};
    }
    t[i[r]] = e;
  }
}, hge = function t(e, i, r) {
  var n = [];
  return i = i || 0, e[i] && N(e[i], (a, o) => {
    (o.ownerBand === r || o.type === Ih) && (!o.isBand || !o.colspan ? (!o.command || i < 1) && n.push(o) : n.push.apply(n, t(e, i + 1, o.index)));
  }), n;
}, fge = function(t) {
  var e = 1, i = t.getBandColumnsCache(), {
    columnParentByIndex: r
  } = i;
  return t._columns.forEach((n) => {
    var a = fp(n.index, r), o = a.filter((u) => !u.visible);
    n.visible && !o.length && (e = Math.max(e, a.length + 1));
  }), e;
}, wP = (t, e) => {
  var i = t._columns.filter((r) => r.type === e.type);
  return !!i.length;
}, oU = function(t, e) {
  var i = t.option("rtlEnabled");
  return e.command && !wP(t, e) || !e.fixedPosition ? i ? "right" : "left" : e.fixedPosition;
}, sU = function(t, e, i, r) {
  var n, a = this.getRowCount(), o = t[r] && t[r].rowspan, u = e.filter((c) => c.type === i);
  return t.forEach((c, p) => {
    c.type === i && (n = p, o = t[p + 1] ? t[p + 1].rowspan : a);
  }), o > 1 && (u = Jr(u, (c) => P({}, c, {
    rowspan: o
  }))), u.unshift.apply(u, R(n) ? [n, 1] : [r, 0]), t.splice.apply(t, u), o || 1;
}, pge = function(t) {
  var e;
  for (e = 0; t > 1; e++)
    t /= 10;
  return e;
}, lU = function(t, e) {
  for (var i = t ? t.toString() : "0"; i.length < e; )
    i = "0".concat(i);
  return i;
}, uU = (t, e, i, r) => {
  for (var n, a, o = e.slice().map((b) => P({}, b)), u = t._isColumnFixing(), c = i.slice().map((b) => P({
    fixed: u
  }, b)), p = (b) => i.reduce((I, A, L) => {
    var B = r && b.type === Ih ? "expand" : b.type;
    return A.type === B || A.command === b.command ? L : I;
  }, -1), v = (b) => b.command !== i[a].command, _ = 0; _ < e.length; _++)
    if (n = e[_], a = n && (n.type || n.command) ? p(n) : -1, a >= 0)
      if (r)
        o[_] = P({
          fixed: u
        }, i[a], n), n.type !== Ih && (c = c.filter(v));
      else {
        var y = {
          visibleIndex: n.visibleIndex,
          index: n.index,
          headerId: n.headerId,
          allowFixing: n.groupIndex === 0,
          allowReordering: n.groupIndex === 0,
          groupIndex: n.groupIndex
        };
        o[_] = P({}, n, i[a], n.type === Ih && y);
      }
  return e.length && r && c.length && (o = o.concat(c)), o;
}, dU = (t, e) => R(e.fixed) || !e.type ? e.fixed : t._isColumnFixing(), vge = (t) => {
  t.forEach((e) => {
    R(e.ownerBand) && (e.ownerBand = t[e.ownerBand]);
  });
}, v5 = (t) => {
  t._bandColumnsCache = void 0;
}, cU = (t, e) => {
  var i = ht(e) && e.substr(0, e.indexOf(":")), r;
  if (e !== void 0)
    return i && (e = e.substr(i.length + 1)), i ? r = t.filter((n) => "".concat(n[i]) === e)[0] : ["index", "name", "dataField", "caption"].some((n) => (r = t.filter((a) => a[n] === e)[0], !!r)), r;
}, gge = (t, e) => {
  if (e !== "asc" && e !== "desc")
    return t;
  var i = e === "asc" ? 1 : -1;
  return t.sort((r, n) => {
    var a = r.caption || "", o = n.caption || "";
    return i * a.localeCompare(o);
  }), t;
}, mge = function(t, e) {
  var i = _i.parse(t);
  if (Di(i)) {
    var r = _i.format(i, e), n = _i.format(i, "decimal");
    if (r === t || n === t)
      return i;
  }
};
class _ge extends Bi.Controller {
  init(e) {
    this._dataController = this.getController("data"), this._focusController = this.getController("focus"), this._stateStoringController = this.getController("stateStoring");
    var i = this.option("columns");
    this._commandColumns = this._commandColumns || [], this._columns = this._columns || [], this._isColumnsFromOptions = !!i, this._isColumnsFromOptions ? (pm(this, i ? fm(this, i) : []), aU(this)) : pm(this, this._columnsUserState ? fm(this, this._columnsUserState) : this._columns), dge(this), this._dataSourceApplied ? this.applyDataSource(this._dataSource, !0, e) : op(this), this._checkColumns();
  }
  _getExpandColumnOptions() {
    return {
      type: "expand",
      command: "expand",
      width: "auto",
      cssClass: Bve,
      allowEditing: !1,
      allowGrouping: !1,
      allowSorting: !1,
      allowResizing: !1,
      allowReordering: !1,
      allowHiding: !1
    };
  }
  _getFirstItems(e) {
    var i, r = [];
    return e && e.items().length > 0 && (i = xe.normalizeSortingInfo(e.group()).length, r = function n(a, o) {
      if (!a || !o)
        return a;
      for (var u = 0; u < a.length; u++) {
        var c = n(a[u].items || a[u].collapsedItems, o - 1);
        if (c && c.length)
          return c;
      }
    }(e.items(), i) || []), r;
  }
  _endUpdateCore() {
    !this._skipProcessingColumnsChange && Sy(this);
  }
  callbackNames() {
    return ["columnsChanged"];
  }
  getColumnByPath(e, i) {
    var r, n = [];
    return e.replace(DL, (a, o) => (n.push(parseInt(o)), "")), n.length && (i ? r = n.reduce((a, o) => a && a.columns && a.columns[o], {
      columns: i
    }) : r = Zve(this, n)), r;
  }
  optionChanged(e) {
    var i;
    switch (e.name) {
      case "adaptColumnWidthByRatio":
        e.handled = !0;
        break;
      case "dataSource":
        e.value !== e.previousValue && !this.option("columns") && (!Array.isArray(e.value) || !Array.isArray(e.previousValue)) && (this._columns = []);
        break;
      case "columns":
        i = this._skipProcessingColumnsChange, e.handled = !0, this._skipProcessingColumnsChange || (e.name === e.fullName ? (this._columnsUserState = null, this._ignoreColumnOptionNames = null, this.init()) : (this._columnOptionChanged(e), i = !0)), i && this._updateRequireResize(e);
        break;
      case "commonColumnSettings":
      case "columnAutoWidth":
      case "allowColumnResizing":
      case "allowColumnReordering":
      case "columnFixing":
      case "grouping":
      case "groupPanel":
      case "regenerateColumnsByVisibleItems":
      case "customizeColumns":
      case "columnHidingEnabled":
      case "dateSerializationFormat":
      case "columnResizingMode":
      case "columnMinWidth":
      case "columnWidth":
        e.handled = !0;
        var r = e.fullName === "columnWidth" && ["width"];
        this.reinit(r);
        break;
      case "rtlEnabled":
        this.reinit();
        break;
      default:
        super.optionChanged(e);
    }
  }
  _columnOptionChanged(e) {
    var i = {}, r = this.getColumnByPath(e.fullName), n = e.fullName.replace(DL, "");
    r && (n ? i[n] = e.value : i = e.value, this._skipProcessingColumnsChange = e.fullName, this.columnOption(r.index, i), this._skipProcessingColumnsChange = !1);
  }
  _updateRequireResize(e) {
    var {
      component: i
    } = this;
    e.fullName.replace(DL, "") === "width" && i._updateLockCount && (i._requireResize = !0);
  }
  publicMethods() {
    return ["addColumn", "deleteColumn", "columnOption", "columnCount", "clearSorting", "clearGrouping", "getVisibleColumns", "getVisibleColumnIndex"];
  }
  applyDataSource(e, i, r) {
    var n = e && e.isLoaded();
    if (this._dataSource = e, !this._dataSourceApplied || this._dataSourceColumnsCount === 0 || i || this.option("regenerateColumnsByVisibleItems")) {
      if (n) {
        if (!this._isColumnsFromOptions) {
          var a = nge(this, e);
          a.length && (pm(this, a), this._dataSourceColumnsCount = this._columns.length, aU(this));
        }
        return this.updateColumns(e, i, r);
      }
      this._dataSourceApplied = !1, op(this);
    } else if (n && !this.isAllDataTypesDefined(!0) && this.updateColumnDataTypes(e))
      return xu(this, "columns"), Sy(this), new q().reject().promise();
  }
  reset() {
    this._dataSource = null, this._dataSourceApplied = !1, this._dataSourceColumnsCount = void 0, this.reinit();
  }
  resetColumnsCache() {
    this._visibleColumns = void 0, this._fixedColumns = void 0, this._rowCount = void 0, v5(this);
  }
  reinit(e) {
    this._columnsUserState = this.getUserState(), this._ignoreColumnOptionNames = e || null, this.init(), e && (this._ignoreColumnOptionNames = null);
  }
  isInitialized() {
    return !!this._columns.length || !!this.option("columns");
  }
  isDataSourceApplied() {
    return this._dataSourceApplied;
  }
  getCommonSettings(e) {
    var i, r, n = (!e || !e.type) && this.option("commonColumnSettings") || {}, a = (i = this.option("grouping")) !== null && i !== void 0 ? i : {}, o = (r = this.option("groupPanel")) !== null && r !== void 0 ? r : {};
    return P({
      allowFixing: this.option("columnFixing.enabled"),
      allowResizing: this.option("allowColumnResizing") || void 0,
      allowReordering: this.option("allowColumnReordering"),
      minWidth: this.option("columnMinWidth"),
      width: this.option("columnWidth"),
      autoExpandGroup: a.autoExpandAll,
      allowCollapsing: a.allowCollapsing,
      allowGrouping: o.allowColumnDragging && o.visible || a.contextMenuEnabled
    }, n);
  }
  isColumnOptionUsed(e) {
    for (var i = 0; i < this._columns.length; i++)
      if (this._columns[i][e])
        return !0;
  }
  isAllDataTypesDefined(e) {
    var i = this._columns;
    if (!i.length)
      return !1;
    for (var r = 0; r < i.length; r++)
      if (!(!i[r].dataField && i[r].calculateCellValue === i[r].defaultCalculateCellValue) && (!i[r].dataType || e && i[r].deserializeValue && i[r].serializationFormat === void 0))
        return !1;
    return !0;
  }
  getColumns() {
    return this._columns;
  }
  isBandColumnsUsed() {
    return this.getColumns().some((e) => e.isBand);
  }
  getGroupColumns() {
    var e = [];
    return N(this._columns, function() {
      R(this.groupIndex) && (e[this.groupIndex] = this);
    }), e;
  }
  _shouldReturnVisibleColumns() {
    return !0;
  }
  _compileVisibleColumns(e) {
    return this._visibleColumns = this._visibleColumns || this._compileVisibleColumnsCore(), e = R(e) ? e : this._visibleColumns.length - 1, this._visibleColumns[e] || [];
  }
  getVisibleColumns(e, i) {
    return this._shouldReturnVisibleColumns() ? this._compileVisibleColumns.apply(this, arguments) : [];
  }
  getFixedColumns(e) {
    return this._fixedColumns = this._fixedColumns || this._getFixedColumnsCore(), e = R(e) ? e : this._fixedColumns.length - 1, this._fixedColumns[e] || [];
  }
  getFilteringColumns() {
    return this.getColumns().filter((e) => (e.dataField || e.name) && (e.allowFiltering || e.allowHeaderFiltering)).map((e) => {
      var i = P(!0, {}, e);
      return R(i.dataField) || (i.dataField = i.name), i.filterOperations = e.filterOperations !== e.defaultFilterOperations ? i.filterOperations : null, i;
    });
  }
  getColumnIndexOffset() {
    return 0;
  }
  _getFixedColumnsCore() {
    var e = [], i = this.getRowCount(), r = this._isColumnFixing(), n = {
      command: "transparent"
    }, a = 0, o, u, c;
    if (r)
      for (var p = 0; p <= i; p++) {
        o = 0, c = null, u = null;
        for (var v = this.getVisibleColumns(p, !0), _ = 0; _ < v.length; _++) {
          var y = v[_ - 1], b = v[_];
          b.fixed ? y && y.fixed && oU(this, y) !== oU(this, b) ? R(u) || (u = _) : c = b.fixedPosition : (p === 0 && (b.isBand && b.colspan ? a += b.colspan : a++), o++, R(u) || (u = _));
        }
        if (p === 0 && (o === 0 || o >= v.length))
          return [];
        R(u) || (u = c === "right" ? 0 : v.length), e[p] = v.slice(0), n.colspan || (n.colspan = a), e[p].splice(u, o, n);
      }
    return e.map((I) => I.map((A) => {
      var L = ae({}, A);
      return L.headerId && (L.headerId += "-fixed"), L;
    }));
  }
  _isColumnFixing() {
    var e = this.option("columnFixing.enabled");
    return !e && N(this._columns, (i, r) => {
      if (r.fixed)
        return e = !0, !1;
    }), e;
  }
  _getExpandColumnsCore() {
    return this.getGroupColumns();
  }
  getExpandColumns() {
    var e = this._getExpandColumnsCore(), i, r = e.filter((u) => u.groupIndex === 0)[0], n = r && r.fixed, a = this._isColumnFixing(), o = this.option("rtlEnabled");
    return e.length && (i = this.columnOption("command:expand")), e = Jr(e, (u) => P({}, u, {
      visibleWidth: null,
      minWidth: null,
      cellTemplate: R(u.groupIndex) ? null : u.cellTemplate,
      headerCellTemplate: null,
      fixed: !R(u.groupIndex) || !n ? a : !0,
      fixedPosition: o ? "right" : "left"
    }, i, {
      index: u.index,
      type: u.type || Ih
    })), e;
  }
  getBandColumnsCache() {
    if (!this._bandColumnsCache) {
      var e = this._columns, i = {}, r = {}, n = !0;
      e.forEach((a) => {
        var {
          ownerBand: o
        } = a, u = ct(o) ? o.index : o, c = e[u];
        a.hasColumns && (n = !1), a.colspan && (a.colspan = void 0), a.rowspan && (a.rowspan = void 0), c ? r[a.index] = c : u = -1, i[u] = i[u] || [], i[u].push(a);
      }), this._bandColumnsCache = {
        isPlain: n,
        columnChildrenByIndex: i,
        columnParentByIndex: r
      };
    }
    return this._bandColumnsCache;
  }
  _isColumnVisible(e) {
    return e.visible && this.isParentColumnVisible(e.index);
  }
  _isColumnInGroupPanel(e) {
    return R(e.groupIndex) && !e.showWhenGrouped;
  }
  hasVisibleDataColumns() {
    var e = this._columns;
    return e.some((i) => {
      var r = this._isColumnVisible(i), n = this._isColumnInGroupPanel(i), a = !!i.command;
      return r && !n && !a;
    });
  }
  _compileVisibleColumnsCore() {
    var e = this.getBandColumnsCache(), i = uU(this, this._columns, this._commandColumns, !0);
    tge(this, i, e);
    var r = this._getIndexedColumns(i), n = this._getVisibleColumnsFromIndexed(r), a = !this.hasVisibleDataColumns();
    return a && this._columns.length && n[n.length - 1].push({
      command: "empty"
    }), n;
  }
  _getIndexedColumns(e) {
    for (var i = this.option("rtlEnabled"), r = this.getRowCount(), n = pge(e.length), a = this.getBandColumnsCache(), o = [], u = [], c = 0; c < r; c += 1)
      u[c] = [{}], o[c] = [{}, {}, {}];
    return e.forEach((p) => {
      var v, _, y, b, {
        visibleIndex: I
      } = p, A, L = fp(p.index, a.columnParentByIndex), B = this._isColumnVisible(p), $ = this._isColumnInGroupPanel(p);
      if (B && !$) {
        var K = L.length;
        if (I < 0)
          I = -I, A = u[K];
        else if (p.fixed = (_ = (v = L[0]) === null || v === void 0 ? void 0 : v.fixed) !== null && _ !== void 0 ? _ : p.fixed, p.fixedPosition = (b = (y = L[0]) === null || y === void 0 ? void 0 : y.fixedPosition) !== null && b !== void 0 ? b : p.fixedPosition, p.fixed) {
          var te = !!p.command && !wP(this, p), z = p.fixedPosition === "right";
          i && !te && (z = !z), A = z ? o[K][2] : o[K][0];
        } else
          A = o[K][1];
        if (L.length) {
          I = lU(I, n);
          for (var ie = L.length - 1; ie >= 0; ie -= 1)
            I = lU(L[ie].visibleIndex, n) + I;
        }
        A[I] = A[I] || [], A[I].push(p);
      }
    }), {
      positiveIndexedColumns: o,
      negativeIndexedColumns: u
    };
  }
  _getVisibleColumnsFromIndexed(e) {
    for (var i = this, {
      positiveIndexedColumns: r,
      negativeIndexedColumns: n
    } = e, a = [], o = this.getRowCount(), u = uU(this, this.getExpandColumns(), this._columns), c = 0, p = 0, v = function(y) {
      a.push([]), mk(n[y], (A, L) => {
        a[y].unshift.apply(a[y], L);
      });
      var b = a[y].length, I = r[y];
      I.forEach((A) => {
        mk(A, (L, B) => {
          a[y].push.apply(a[y], B);
        });
      }), p <= y && (p += sU.call(i, a[y], u, Vve, b)), c <= y && (c += sU.call(i, a[y], u, Ih, b));
    }, _ = 0; _ < o; _ += 1)
      v(_);
    return a.push(hge(a)), a;
  }
  getInvisibleColumns(e, i) {
    var r = this, n = [], a;
    return e = e || r._columns, N(e, (o, u) => {
      if (u.ownerBand === i) {
        if (u.isBand) {
          u.visible ? a = r.getInvisibleColumns(r.getChildrenByBandColumn(u.index), u.index) : a = r.getChildrenByBandColumn(u.index), a.length && (n.push(u), n = n.concat(a));
          return;
        }
        u.visible || n.push(u);
      }
    }), n;
  }
  getChooserColumns(e) {
    var i = e ? this.getColumns() : this.getInvisibleColumns(), r = i.filter((a) => a.showInColumnChooser), n = this.option("columnChooser.sortOrder");
    return gge(r, n);
  }
  allowMoveColumn(e, i, r, n) {
    var a = OL(this, e, r), o = this._columns[a];
    return o && (o.allowReordering || o.allowGrouping || o.allowHiding) ? r === n ? r === hm ? !1 : (e = ct(e) ? e.columnIndex : e, i = ct(i) ? i.columnIndex : i, e !== i && e + 1 !== i) : r === cm && n !== hm || n === cm ? o && o.allowGrouping : r === hm || n === hm ? o && o.allowHiding : !0 : !1;
  }
  moveColumn(e, i, r, n) {
    var a = {}, o, u = OL(this, e, r), c = OL(this, i, n), p;
    if (u >= 0) {
      var v = this._columns[u];
      if (i = ct(i) ? i.columnIndex : i, p = c >= 0 ? this._columns[c].groupIndex : -1, R(v.groupIndex) && r === cm && (p > v.groupIndex && p--, n !== cm ? a.groupIndex = void 0 : (o = v.groupIndex, delete v.groupIndex, p5(this))), n === cm)
        a.groupIndex = sge(this, v, p), v.groupIndex = o;
      else if (i >= 0) {
        var _ = this._columns[c];
        !_ || v.ownerBand !== _.ownerBand || dU(this, v) ^ dU(this, _) ? a.visibleIndex = eU : a.visibleIndex = _.visibleIndex;
      }
      var y = n !== hm;
      v.visible !== y && (a.visible = y), this.columnOption(v.index, a);
    }
  }
  changeSortOrder(e, i) {
    var r = {}, n = this.option("sorting"), a = n && n.mode, o = a === "single" || !i, u = a === "single" || a === "multiple", c = this._columns[e];
    u && c && c.allowSorting && (o && !R(c.groupIndex) && N(this._columns, function(p) {
      p !== e && this.sortOrder && (R(this.groupIndex) || delete this.sortOrder, delete this.sortIndex);
    }), BT(i) ? c.sortOrder !== i && (r.sortOrder = i) : i === "none" ? c.sortOrder && (r.sortIndex = void 0, r.sortOrder = void 0) : function(p) {
      if (i === "ctrl") {
        if (!("sortOrder" in p && "sortIndex" in p))
          return !1;
        r.sortOrder = void 0, r.sortIndex = void 0;
      } else
        R(p.groupIndex) || R(p.sortIndex) ? r.sortOrder = p.sortOrder === "desc" ? "asc" : "desc" : r.sortOrder = "asc";
      return !0;
    }(c)), this.columnOption(c.index, r);
  }
  getSortDataSourceParameters(e) {
    var i = [], r = [];
    return N(this._columns, function() {
      (this.dataField || this.selector || this.calculateCellValue) && R(this.sortIndex) && !R(this.groupIndex) && (i[this.sortIndex] = this);
    }), N(i, function() {
      var n = this && this.sortOrder;
      if (BT(n)) {
        var a = {
          selector: this.calculateSortValue || this.displayField || this.calculateDisplayValue || e && this.selector || this.dataField || this.calculateCellValue,
          desc: this.sortOrder === "desc"
        };
        this.sortingMethod && (a.compare = this.sortingMethod.bind(this)), r.push(a);
      }
    }), r.length > 0 ? r : null;
  }
  getGroupDataSourceParameters(e) {
    var i = [];
    return N(this.getGroupColumns(), function() {
      var r = this.calculateGroupValue || this.displayField || this.calculateDisplayValue || e && this.selector || this.dataField || this.calculateCellValue;
      if (r) {
        var n = {
          selector: r,
          desc: this.sortOrder === "desc",
          isExpanded: !!this.autoExpandGroup
        };
        this.sortingMethod && (n.compare = this.sortingMethod.bind(this)), i.push(n);
      }
    }), i.length > 0 ? i : null;
  }
  refresh(e) {
    var i = [];
    return N(this._columns, function() {
      var {
        lookup: r
      } = this;
      if (r && !this.calculateDisplayValue) {
        if (e && r.valueMap)
          return;
        r.update && i.push(r.update());
      }
    }), $e.apply(E, i).done(II.bind(null, this));
  }
  _updateColumnOptions(e, i) {
    var r, n, a, o, u = this._reinitAfterLookupChanges && ((r = this._previousColumns) === null || r === void 0 ? void 0 : r[i]);
    e.selector = (n = e.selector) !== null && n !== void 0 ? n : (v) => e.calculateCellValue(v), e.selector.columnIndex = i, e.selector.originalCallback = u && (o = (a = this._previousColumns[i].selector) === null || a === void 0 ? void 0 : a.originalCallback) !== null && o !== void 0 ? o : e.selector, N(["calculateSortValue", "calculateGroupValue", "calculateDisplayValue"], (v, _) => {
      var y = e[_];
      if (Le(y))
        if (y.originalCallback)
          e[_].context.column = e;
        else {
          var b = {
            column: e
          };
          e[_] = function(I) {
            return y.call(b.column, I);
          }, e[_].originalCallback = y, e[_].columnIndex = i, e[_].context = b;
        }
    }), ht(e.calculateDisplayValue) && (e.displayField = e.calculateDisplayValue, e.calculateDisplayValue = Ii(e.displayField)), e.calculateDisplayValue && (e.displayValueMap = e.displayValueMap || {}), rU(e, e.dataType);
    var {
      lookup: c
    } = e;
    c && rU(c, c.dataType);
    var p = c ? c.dataType : e.dataType;
    p && (e.alignment = e.alignment || ige(p, this.option("rtlEnabled")), e.format = e.format || xe.getFormatByDataType(p), e.customizeText = e.customizeText || nU(p), e.defaultFilterOperations = e.defaultFilterOperations || !c && Hve[p] || [], R(e.filterOperations) || h5(e), e.defaultFilterOperation = e.filterOperations && e.filterOperations[0] || "=", e.showEditorAlways = R(e.showEditorAlways) ? e.showEditorAlways : p === "boolean" && !e.cellTemplate && !e.lookup);
  }
  updateColumnDataTypes(e) {
    var i = this, r = i.option("dateSerializationFormat"), n = i._getFirstItems(e), a = !1;
    return N(i._columns, (o, u) => {
      var c, p, v, _, y, {
        lookup: b
      } = u;
      if (xe.isDateType(u.dataType) && u.serializationFormat === void 0 && (u.serializationFormat = r), b && xe.isDateType(b.dataType) && u.serializationFormat === void 0 && (b.serializationFormat = r), u.calculateCellValue && n.length) {
        if (!u.dataType || b && !b.dataType) {
          for (c = 0; c < n.length; c++)
            p = u.calculateCellValue(n[c]), u.dataType || (y = AL(p), v = v || y, v && y && v !== y && (v = "string")), b && !b.dataType && (y = AL(xe.getDisplayValue(u, p, n[c])), _ = _ || y, _ && y && _ !== y && (_ = "string"));
          (v || _) && (v && (u.dataType = v), b && _ && (b.dataType = _), a = !0);
        }
        if (u.serializationFormat === void 0 || b && b.serializationFormat === void 0)
          for (c = 0; c < n.length; c++)
            p = u.calculateCellValue(n[c], !0), u.serializationFormat === void 0 && (u.serializationFormat = iU(u.dataType, p)), b && b.serializationFormat === void 0 && (b.serializationFormat = iU(b.dataType, b.calculateCellValue(p, !0)));
      }
      i._updateColumnOptions(u, o);
    }), a;
  }
  _customizeColumns(e) {
    var i = this.option("customizeColumns");
    if (i) {
      var r = e.some((n) => ct(n.ownerBand));
      r && op(this), i(e), pm(this, fm(this, e));
    }
  }
  updateColumns(e, i, r) {
    if (i || this.updateSortingGrouping(e), !e || e.isLoaded()) {
      var n = e ? e.sort() || [] : this.getSortDataSourceParameters(), a = e ? e.group() || [] : this.getGroupDataSourceParameters(), o = e == null ? void 0 : e.lastLoadOptions().filter;
      r || this._customizeColumns(this._columns), op(this);
      var u = this._columns;
      return $e(this.refresh(!0)).always(() => {
        this._columns === u && (this._updateChanges(e, {
          sorting: n,
          grouping: a,
          filtering: o
        }), Sy(this));
      });
    }
  }
  _updateChanges(e, i) {
    e && (this.updateColumnDataTypes(e), this._dataSourceApplied = !0), xe.equalSortParameters(i.sorting, this.getSortDataSourceParameters()) || xu(this, "sorting"), xe.equalSortParameters(i.grouping, this.getGroupDataSourceParameters()) || xu(this, "grouping"), this._dataController && !xe.equalFilterParameters(i.filtering, this._dataController.getCombinedFilter()) && xu(this, "filtering"), xu(this, "columns");
  }
  updateSortingGrouping(e, i) {
    var r = this, n, a, o = function(y, b, I) {
      N(y, (A, L) => {
        if (delete L[I], b)
          for (var B = 0; B < b.length; B++) {
            var {
              selector: $
            } = b[B], {
              isExpanded: K
            } = b[B];
            if ($ === L.dataField || $ === L.name || $ === L.selector || $ === L.calculateCellValue || $ === L.calculateGroupValue || $ === L.calculateDisplayValue) {
              i ? L.sortOrder = "sortOrder" in L ? L.sortOrder : b[B].desc ? "desc" : "asc" : L.sortOrder = L.sortOrder || (b[B].desc ? "desc" : "asc"), K !== void 0 && (L.autoExpandGroup = K), L[I] = B;
              break;
            }
          }
      });
    };
    if (e) {
      n = xe.normalizeSortingInfo(e.sort());
      var u = xe.normalizeSortingInfo(e.group()), c = r.getGroupDataSourceParameters(), p = r.getSortDataSourceParameters(), v = !xe.equalSortParameters(u, c, !0), _ = !v && !xe.equalSortParameters(u, c);
      r._columns.length || (N(u, (y, b) => {
        r._columns.push(b.selector);
      }), N(n, (y, b) => {
        Le(b.selector) || r._columns.push(b.selector);
      }), pm(r, fm(r, r._columns))), (i || !c && !r._hasUserState) && (v || _) && (o(r._columns, u, "groupIndex"), i && (v && xu(r, "grouping"), _ && xu(r, "groupExpanding"), a = !0)), (i || !p && !r._hasUserState) && !xe.equalSortParameters(n, p) && (o(r._columns, n, "sortIndex"), i && (xu(r, "sorting"), a = !0)), a && Sy(r);
    }
  }
  updateFilter(e, i, r, n) {
    if (!Array.isArray(e))
      return e;
    if (e = P([], e), r = e.columnIndex !== void 0 ? e.columnIndex : r, n = e.filterValue !== void 0 ? e.filterValue : n, ht(e[0]) && e[0] !== "!") {
      var a = this.columnOption(e[0]);
      i ? Oi().forceIsoDateParsing && a && a.serializeValue && e.length > 1 && (e[e.length - 1] = a.serializeValue(e[e.length - 1], "filter")) : a && a.selector && (e[0] = a.selector, e[0].columnIndex = a.index);
    } else
      Le(e[0]) && (e[0].columnIndex = r, e[0].filterValue = n, e[0].selectedFilterOperation = e.selectedFilterOperation);
    for (var o = 0; o < e.length; o++)
      e[o] = this.updateFilter(e[o], i, r, n);
    return e;
  }
  columnCount() {
    return this._columns ? this._columns.length : 0;
  }
  columnOption(e, i, r, n) {
    var a = this, o = a._columns.concat(a._commandColumns), u = cU(o, e);
    if (u) {
      if (arguments.length === 1)
        return P({}, u);
      if (ht(i)) {
        if (arguments.length === 2)
          return RL(a, u, i);
        RL(a, u, i, r, n);
      } else
        ct(i) && N(i, (c, p) => {
          RL(a, u, c, p, n);
        });
      Sy(a);
    }
  }
  clearSorting() {
    var e = this.columnCount();
    this.beginUpdate();
    for (var i = 0; i < e; i++)
      this.columnOption(i, "sortOrder", void 0), delete cU(this._columns, i).sortOrder;
    this.endUpdate();
  }
  clearGrouping() {
    var e = this.columnCount();
    this.beginUpdate();
    for (var i = 0; i < e; i++)
      this.columnOption(i, "groupIndex", void 0);
    this.endUpdate();
  }
  getVisibleIndex(e, i) {
    for (var r = this.getVisibleColumns(i), n = r.length - 1; n >= 0; n--)
      if (r[n].index === e)
        return n;
    return -1;
  }
  getVisibleIndexByColumn(e, i) {
    var r = this.getVisibleColumns(i), n = r.filter((a) => a.index === e.index && a.command === e.command)[0];
    return r.indexOf(n);
  }
  getVisibleColumnIndex(e, i) {
    var r = this.columnOption(e, "index");
    return this.getVisibleIndex(r, i);
  }
  addColumn(e) {
    var i = TI(this, e), r = this._columns.length;
    this._columns.push(i), i.isBand && (this._columns = fm(this, this._columns), i = this._columns[r]), i.added = e, op(this, i), this.updateColumns(this._dataSource), this._checkColumns();
  }
  deleteColumn(e) {
    var i = this.columnOption(e);
    if (i && i.index >= 0) {
      if (vge(this._columns), this._columns.splice(i.index, 1), i.isBand) {
        var r = this.getChildrenByBandColumn(i.index).map((n) => n.index);
        this._columns = this._columns.filter((n) => r.indexOf(n.index) < 0);
      }
      op(this), this.updateColumns(this._dataSource);
    }
  }
  addCommandColumn(e) {
    var i = this._commandColumns.filter((r) => r.command === e.command)[0];
    i || (i = e, this._commandColumns.push(i));
  }
  getUserState() {
    var e = this._columns, i = [], r;
    function n(a, o) {
      e[r][o] !== void 0 && (i[r][o] = e[r][o]);
    }
    for (r = 0; r < e.length; r++)
      i[r] = {}, N(FT, n);
    return i;
  }
  setName(e) {
    e.name = e.name || e.dataField || e.type;
  }
  setUserState(e) {
    var i = this._dataSource, r = this.option("stateStoring.ignoreColumnOptionNames");
    if (e == null || e.forEach(this.setName), !r) {
      r = [];
      var n = this.getCommonSettings();
      this.option("columnChooser.enabled") || r.push("visible"), this.option("sorting.mode") === "none" && r.push("sortIndex", "sortOrder"), n.allowGrouping || r.push("groupIndex"), n.allowFixing || r.push("fixed", "fixedPosition"), n.allowResizing || r.push("width", "visibleWidth");
      var a = !this.option("filterPanel.visible");
      !this.option("filterRow.visible") && a && r.push("filterValue", "selectedFilterOperation"), !this.option("headerFilter.visible") && a && r.push("filterValues", "filterType");
    }
    this._columnsUserState = e, this._ignoreColumnOptionNames = r, this._hasUserState = !!e, xu(this, "filtering"), this.init(!0), i && (i.sort(this.getSortDataSourceParameters()), i.group(this.getGroupDataSourceParameters()));
  }
  _checkColumns() {
    var e = {}, i = !1, r = [];
    this._columns.forEach((n) => {
      var a, {
        name: o
      } = n, u = (a = n.columns) === null || a === void 0 ? void 0 : a.length, c = n.allowEditing && (n.dataField || n.setCellValue) && !u;
      o ? (e[o] && r.push('"'.concat(o, '"')), e[o] = !0) : c && (i = !0);
    }), r.length && Yt.log("E1059", r.join(", ")), i && Yt.log("E1060");
  }
  _createCalculatedColumnOptions(e, i) {
    var r = {}, {
      dataField: n
    } = e;
    if ((Array.isArray(e.columns) && e.columns.length || e.isBand) && (r.isBand = !0, n = null), n) {
      if (ht(n)) {
        var a = Ii(n);
        r = {
          caption: bp(n),
          calculateCellValue(o, u) {
            var c = a(o);
            return this.deserializeValue && !u ? this.deserializeValue(c) : c;
          },
          setCellValue: cge,
          parseValue(o) {
            var u, c;
            return this.dataType === "number" ? ht(o) && this.format ? u = mge(o.trim(), this.format) : R(o) && Di(o) && (u = Number(o)) : this.dataType === "boolean" ? o === this.trueText ? u = !0 : o === this.falseText && (u = !1) : xe.isDateType(this.dataType) ? (c = Bt.parse(o, this.format), c && (u = c)) : u = o, u;
          }
        };
      }
      r.allowFiltering = !0;
    } else
      r.allowFiltering = !!e.calculateFilterExpression;
    return r.calculateFilterExpression = function() {
      return Wp.defaultCalculateFilterExpression.apply(this, arguments);
    }, r.defaultFilterOperation = "=", r.createFilterExpression = function(o, u) {
      var c;
      return this.calculateFilterExpression && (c = this.calculateFilterExpression.apply(this, arguments)), Le(c) && (c = [c, "=", !0]), c && (c.columnIndex = this.index, c.filterValue = o, c.selectedFilterOperation = u), c;
    }, (!n || !ht(n)) && P(!0, r, {
      allowSorting: !1,
      allowGrouping: !1,
      calculateCellValue: () => null
    }), i && (r.allowFixing = !1), e.dataType && (r.userDataType = e.dataType), e.selectedFilterOperation && !("defaultSelectedFilterOperation" in r) && (r.defaultSelectedFilterOperation = e.selectedFilterOperation), e.lookup && (r.lookup = {
      calculateCellValue(o, u) {
        return this.valueExpr && (o = this.valueMap && this.valueMap[o]), this.deserializeValue && !u ? this.deserializeValue(o) : o;
      },
      updateValueMap() {
        if (this.valueMap = {}, this.items)
          for (var o = Ii(this.valueExpr), u = Ii(this.displayExpr), c = 0; c < this.items.length; c++) {
            var p = this.items[c], v = u(p);
            this.valueMap[o(p)] = v, this.dataType = this.dataType || AL(v);
          }
      },
      update() {
        var o = this, {
          dataSource: u
        } = o;
        if (u)
          if (Le(u) && !Ha.isWrapped(u) && (u = u({})), $t(u) || u instanceof Ou || Array.isArray(u)) {
            if (o.valueExpr) {
              var c = zp(u);
              return c.paginate = !1, u = new Ks(c), u.load().done((p) => {
                o.items = p, o.updateValueMap && o.updateValueMap();
              });
            }
          } else
            Yt.log("E1016");
        else
          o.updateValueMap && o.updateValueMap();
      }
    }), r.resizedCallbacks = ui(), e.resized && r.resizedCallbacks.add(e.resized.bind(e)), N(r, (o) => {
      if (Le(r[o]) && o.indexOf("default") !== 0) {
        var u = "default".concat(o.charAt(0).toUpperCase()).concat(o.substr(1));
        r[u] = r[o];
      }
    }), r;
  }
  getRowCount() {
    return this._rowCount = this._rowCount || fge(this), this._rowCount;
  }
  getRowIndex(e, i) {
    var r = this._columns[e], n = this.getBandColumnsCache();
    return r && (i || r.visible && !(r.command || R(r.groupIndex))) ? fp(e, n.columnParentByIndex).length : 0;
  }
  getChildrenByBandColumn(e, i) {
    var r = this.getBandColumnsCache(), n = Qve(e, r.columnChildrenByIndex, !i);
    return i ? n.filter((a) => a.visible && !a.command).sort((a, o) => a.visibleIndex - o.visibleIndex) : n;
  }
  isParentBandColumn(e, i) {
    var r = !1, n = this._columns[e], a = this.getBandColumnsCache(), o = n && fp(e, a.columnParentByIndex);
    return o && N(o, (u, c) => {
      if (c.index === i)
        return r = !0, !1;
    }), r;
  }
  isParentColumnVisible(e) {
    var i = !0, r = this.getBandColumnsCache(), n = e >= 0 && fp(e, r.columnParentByIndex);
    return n && N(n, (a, o) => (i = i && o.visible, i)), i;
  }
  getColumnId(e) {
    return e.command && e.type === Ih ? wP(this, e) ? "type:".concat(e.type) : "command:".concat(e.command) : e.index;
  }
  getCustomizeTextByDataType(e) {
    return nU(e);
  }
  getHeaderContentAlignment(e) {
    var i = this.option("rtlEnabled");
    return i ? e === "left" ? "right" : "left" : e;
  }
}
var hU = {
  defaultOptions: () => ({
    commonColumnSettings: {
      allowFiltering: !0,
      allowHiding: !0,
      allowSorting: !0,
      allowEditing: !0,
      encodeHtml: !0,
      trueText: X.format("dxDataGrid-trueText"),
      falseText: X.format("dxDataGrid-falseText")
    },
    allowColumnReordering: !1,
    allowColumnResizing: !1,
    columnResizingMode: "nextColumn",
    columnMinWidth: void 0,
    columnWidth: void 0,
    adaptColumnWidthByRatio: !0,
    columns: void 0,
    regenerateColumnsByVisibleItems: !1,
    customizeColumns: null,
    dateSerializationFormat: void 0
  }),
  controllers: {
    columns: _ge
  }
};
et.registerModule("columns", {
  defaultOptions: () => P(!0, {}, hU.defaultOptions(), {
    commonColumnSettings: {
      allowExporting: !0
    }
  }),
  controllers: hU.controllers
});
var jw = function(t, e) {
  var i = e(t);
  if (ct(i))
    try {
      return JSON.stringify(i);
    } catch {
      return i;
    }
  return i;
}, Cge = function(t, e, i, r) {
  var n = jw(t, r);
  return e[i[n]];
}, yge = function(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var i = 0; i < e.length; i++)
    if (t[i] !== e[i])
      return !1;
  return !0;
}, g5 = function(t, e, i, r) {
  var n = {}, a = {}, o = 0, u = 0, c = [];
  t.forEach(function($, K) {
    var te = jw($, i);
    n[te] = K;
  }), e.forEach(function($, K) {
    var te = jw($, i);
    a[te] = K;
  });
  for (var p = Math.max(t.length, e.length), v = 0; v < p + o; v++) {
    var _ = e[v], y = v - o + u, b = t[y], I = !_ || b && !Cge(b, e, a, i);
    if (I)
      b && (c.push({
        type: "remove",
        key: i(b),
        index: v,
        oldItem: b
      }), u++, v--);
    else {
      var A = jw(_, i), L = n[A], B = t[L];
      if (!B)
        o++, c.push({
          type: "insert",
          data: _,
          index: v
        });
      else if (L === y)
        r(B, _) || c.push({
          type: "update",
          data: _,
          key: i(_),
          index: v,
          oldItem: B
        });
      else
        return;
    }
  }
  return c;
}, xge = {
  load: () => q().reject(),
  loadSingle: () => q().reject(),
  loadFromStore: () => q().reject(),
  loadNextPage: () => q().reject(),
  loadOptions: ee,
  userData: ee,
  cancel: ee,
  cancelAll: ee,
  filter: ee,
  addSearchFilter: ee,
  group: ee,
  paginate: ee,
  pageSize: ee,
  pageIndex: ee,
  resetDataSourcePageIndex: ee,
  totalCount: ee,
  isLastPage: ee,
  isLoading: ee,
  isLoaded: ee,
  searchValue: ee,
  searchOperation: ee,
  searchExpr: ee,
  select: ee,
  key: ee,
  keyOf: ee,
  store: ee,
  items: ee,
  applyMapFunction: ee,
  getDataSource: ee,
  reload: ee,
  on: ee,
  off: ee
};
let m5 = class {
  constructor(e) {
    if (!e)
      return xge;
    this._dataSource = e;
  }
  load() {
    return this._dataSource.load();
  }
  loadSingle(e, i) {
    return arguments.length < 2 && (i = e, e = this.key()), this._dataSource.loadSingle(e, i);
  }
  loadFromStore(e) {
    return this.store().load(e);
  }
  loadNextPage() {
    return this.pageIndex(1 + this.pageIndex()), this.load();
  }
  loadOptions() {
    return this._dataSource.loadOptions();
  }
  userData() {
    return this._dataSource._userData;
  }
  cancel(e) {
    this._dataSource.cancel(e);
  }
  cancelAll() {
    this._dataSource.cancelAll();
  }
  filter(e) {
    return this._dataSource.filter(e);
  }
  addSearchFilter(e) {
    this._dataSource._addSearchFilter(e);
  }
  group(e) {
    return this._dataSource.group(e);
  }
  paginate() {
    return this._dataSource.paginate();
  }
  pageSize() {
    return this._dataSource._pageSize;
  }
  pageIndex(e) {
    return this._dataSource.pageIndex(e);
  }
  resetDataSourcePageIndex() {
    this.pageIndex() && (this.pageIndex(0), this.load());
  }
  totalCount() {
    return this._dataSource.totalCount();
  }
  isLastPage() {
    return this._dataSource.isLastPage() || !this._dataSource._pageSize;
  }
  isLoading() {
    return this._dataSource.isLoading();
  }
  isLoaded() {
    return this._dataSource.isLoaded();
  }
  searchValue(e) {
    return arguments.length ? this._dataSource.searchValue(e) : this._dataSource.searchValue();
  }
  searchOperation(e) {
    return this._dataSource.searchOperation(e);
  }
  searchExpr(e) {
    return arguments.length ? this._dataSource.searchExpr(e) : this._dataSource.searchExpr();
  }
  select() {
    return this._dataSource.select(...arguments);
  }
  key() {
    return this._dataSource.key();
  }
  keyOf(e) {
    return this.store().keyOf(e);
  }
  store() {
    return this._dataSource.store();
  }
  items() {
    return this._dataSource.items();
  }
  applyMapFunction(e) {
    return this._dataSource._applyMapFunction(e);
  }
  getDataSource() {
    return this._dataSource || null;
  }
  reload() {
    return this._dataSource.reload();
  }
  on(e, i) {
    this._dataSource.on(e, i);
  }
  off(e, i) {
    this._dataSource.off(e, i);
  }
};
var fU = "_dataSourceOptions", pU = "_dataSourceChangedHandler", vU = "_dataSourceLoadErrorHandler", gU = "_dataSourceLoadingChangedHandler", mU = "_dataSourceFromUrlLoadMode", _U = "_getSpecificDataSourceOption", CU = "_normalizeDataSource", Sge = (t) => class extends t {
  postCtor() {
    this.on("disposing", () => {
      this._disposeDataSource();
    });
  }
  _refreshDataSource() {
    this._initDataSource(), this._loadDataSource();
  }
  _initDataSource() {
    var e = _U in this ? this[_U]() : this.option("dataSource"), i, r;
    this._disposeDataSource(), e && (e instanceof Ks ? (this._isSharedDataSource = !0, this._dataSource = e) : (i = fU in this ? this[fU]() : {}, r = this._dataSourceType ? this._dataSourceType() : Ks, e = zp(e, {
      fromUrlLoadMode: mU in this && this[mU]()
    }), this._dataSource = new r(P(!0, {}, i, e))), CU in this && (this._dataSource = this[CU](this._dataSource)), this._addDataSourceHandlers(), this._initDataController());
  }
  _initDataController() {
    var e, i = (e = this.option) === null || e === void 0 ? void 0 : e.call(this, "_dataController"), r = this._dataSource;
    i ? this._dataController = i : this._dataController = new m5(r);
  }
  _addDataSourceHandlers() {
    pU in this && this._addDataSourceChangeHandler(), vU in this && this._addDataSourceLoadErrorHandler(), gU in this && this._addDataSourceLoadingChangedHandler(), this._addReadyWatcher();
  }
  _addReadyWatcher() {
    this.readyWatcher = (function(e) {
      this._ready && this._ready(!e);
    }).bind(this), this._dataSource.on("loadingChanged", this.readyWatcher);
  }
  _addDataSourceChangeHandler() {
    var e = this._dataSource;
    this._proxiedDataSourceChangedHandler = (function(i) {
      this[pU](e.items(), i);
    }).bind(this), e.on("changed", this._proxiedDataSourceChangedHandler);
  }
  _addDataSourceLoadErrorHandler() {
    this._proxiedDataSourceLoadErrorHandler = this[vU].bind(this), this._dataSource.on("loadError", this._proxiedDataSourceLoadErrorHandler);
  }
  _addDataSourceLoadingChangedHandler() {
    this._proxiedDataSourceLoadingChangedHandler = this[gU].bind(this), this._dataSource.on("loadingChanged", this._proxiedDataSourceLoadingChangedHandler);
  }
  _loadDataSource() {
    var e = this._dataSource;
    e && (e.isLoaded() ? this._proxiedDataSourceChangedHandler && this._proxiedDataSourceChangedHandler() : e.load());
  }
  _loadSingle(e, i) {
    return e = e === "this" ? this._dataSource.key() || "this" : e, this._dataSource.loadSingle(e, i);
  }
  _isLastPage() {
    return !this._dataSource || this._dataSource.isLastPage() || !this._dataSource._pageSize;
  }
  _isDataSourceLoading() {
    return this._dataSource && this._dataSource.isLoading();
  }
  _disposeDataSource() {
    this._dataSource && (this._isSharedDataSource ? (delete this._isSharedDataSource, this._proxiedDataSourceChangedHandler && this._dataSource.off("changed", this._proxiedDataSourceChangedHandler), this._proxiedDataSourceLoadErrorHandler && this._dataSource.off("loadError", this._proxiedDataSourceLoadErrorHandler), this._proxiedDataSourceLoadingChangedHandler && this._dataSource.off("loadingChanged", this._proxiedDataSourceLoadingChangedHandler), this._dataSource._eventsStrategy && this._dataSource._eventsStrategy.off("loadingChanged", this.readyWatcher)) : this._dataSource.dispose(), delete this._dataSource, delete this._proxiedDataSourceChangedHandler, delete this._proxiedDataSourceLoadErrorHandler, delete this._proxiedDataSourceLoadingChangedHandler);
  }
  getDataSource() {
    return this._dataSource || null;
  }
}, yU = function(t, e, i) {
  var r = t._dataSource;
  if (r) {
    if (i !== void 0) {
      var n = t._getPagingOptionValue(e);
      if (n !== i) {
        e === "pageSize" && r.pageIndex(0), r[e](i), t._skipProcessingPagingChange = !0, t.option("paging.".concat(e), i), t._skipProcessingPagingChange = !1;
        var a = r.pageIndex();
        return t._isPaging = e === "pageIndex", r[e === "pageIndex" ? "load" : "reload"]().done(() => {
          t._isPaging = !1, t.pageChanged.fire(a);
        });
      }
      return q().resolve().promise();
    }
    return r[e]();
  }
  return 0;
};
class _5 extends Sge(Bi.Controller) {
  init() {
    this._items = [], this._cachedProcessedItems = null, this._columnsController = this.getController("columns"), this._adaptiveColumnsController = this.getController("adaptiveColumns"), this._editingController = this.getController("editing"), this._editorFactoryController = this.getController("editorFactory"), this._errorHandlingController = this.getController("errorHandling"), this._filterSyncController = this.getController("filterSync"), this._applyFilterController = this.getController("applyFilter"), this._keyboardNavigationController = this.getController("keyboardNavigation"), this._focusController = this.getController("focus"), this._headerFilterController = this.getController("headerFilter"), this._selectionController = this.getController("selection"), this._stateStoringController = this.getController("stateStoring"), this._validatingController = this.getController("validating"), this._adaptiveExpandedKey = void 0, this._isPaging = !1, this._currentOperationTypes = null, this._dataChangedHandler = (e) => {
      this._currentOperationTypes = this._dataSource.operationTypes(), this._handleDataChanged(e), this._currentOperationTypes = null;
    }, this._columnsChangedHandler = this._handleColumnsChanged.bind(this), this._loadingChangedHandler = this._handleLoadingChanged.bind(this), this._loadErrorHandler = this._handleLoadError.bind(this), this._customizeStoreLoadOptionsHandler = this._handleCustomizeStoreLoadOptions.bind(this), this._changingHandler = this._handleChanging.bind(this), this._dataPushedHandler = this._handleDataPushed.bind(this), this._columnsController.columnsChanged.add(this._columnsChangedHandler), this._isLoading = !1, this._isCustomLoading = !1, this._repaintChangesOnly = void 0, this._changes = [], this.createAction("onDataErrorOccurred"), this.dataErrorOccurred.add((e) => this.executeAction("onDataErrorOccurred", {
      error: e
    })), this._refreshDataSource(), this.postCtor();
  }
  _getPagingOptionValue(e) {
    return this._dataSource[e]();
  }
  callbackNames() {
    return ["changed", "loadingChanged", "dataErrorOccurred", "pageChanged", "dataSourceChanged", "pushed"];
  }
  callbackFlags(e) {
    if (e === "dataErrorOccurred")
      return {
        stopOnFalse: !0
      };
  }
  publicMethods() {
    return ["_disposeDataSource", "beginCustomLoading", "byKey", "clearFilter", "endCustomLoading", "filter", "getCombinedFilter", "getDataByKeys", "getDataSource", "getKeyByRowIndex", "getRowIndexByKey", "getVisibleRows", "keyOf", "pageCount", "pageIndex", "pageSize", "refresh", "repaintRows", "totalCount"];
  }
  reset() {
    this._columnsController.reset(), this._items = [], this._refreshDataSource();
  }
  _handleDataSourceChange(e) {
    if (e.value === e.previousValue || this.option("columns") && Array.isArray(e.value) && Array.isArray(e.previousValue)) {
      var i = e.value !== e.previousValue;
      if (i) {
        var r = this.store();
        r && (r._array = e.value);
      }
      return this.needToRefreshOnDataSourceChange(e) && this.refresh(this.option("repaintChangesOnly")), !0;
    }
    return !1;
  }
  needToRefreshOnDataSourceChange(e) {
    return !0;
  }
  optionChanged(e) {
    var i = this, r, n;
    function a() {
      e.handled = !0;
    }
    if (e.name === "dataSource" && e.name === e.fullName && this._handleDataSourceChange(e)) {
      a();
      return;
    }
    switch (e.name) {
      case "cacheEnabled":
      case "repaintChangesOnly":
      case "highlightChanges":
      case "loadingTimeout":
        a();
        break;
      case "remoteOperations":
      case "keyExpr":
      case "dataSource":
      case "scrolling":
        a(), i.reset();
        break;
      case "paging":
        if (r = i.dataSource(), r && (n = i._setPagingOptions(r), n)) {
          var o = r.pageIndex();
          this._isPaging = n.isPageIndexChanged, r.load().done(() => {
            this._isPaging = !1, i.pageChanged.fire(o);
          });
        }
        a();
        break;
      case "rtlEnabled":
        i.reset();
        break;
      case "columns":
        r = i.dataSource(), r && r.isLoading() && e.name === e.fullName && (this._useSortingGroupingFromColumns = !0, r.load());
        break;
      default:
        super.optionChanged(e);
    }
  }
  isReady() {
    return !this._isLoading;
  }
  getDataSource() {
    return this._dataSource && this._dataSource._dataSource;
  }
  getCombinedFilter(e) {
    return this.combinedFilter(void 0, e);
  }
  combinedFilter(e, i) {
    if (!this._dataSource)
      return e;
    var r = e ?? this._dataSource.filter(), n = this._columnsController.isDataSourceApplied() || this._columnsController.isAllDataTypesDefined();
    if (n) {
      var a = this._calculateAdditionalFilter();
      r = a ? xe.combineFilters([a, r]) : r;
    }
    var o = this._dataSource.remoteOperations().filtering || i;
    return r = this._columnsController.updateFilter(r, o), r;
  }
  waitReady() {
    return this._updateLockCount ? (this._readyDeferred = new q(), this._readyDeferred) : $e();
  }
  _endUpdateCore() {
    var e = this._changes;
    if (e.length) {
      this._changes = [];
      var i = e.every((r) => r.repaintChangesOnly);
      this.updateItems(e.length === 1 ? e[0] : {
        repaintChangesOnly: i
      });
    }
    this._readyDeferred && (this._readyDeferred.resolve(), this._readyDeferred = null);
  }
  _handleCustomizeStoreLoadOptions(e) {
    var i, r = this._columnsController, n = this._dataSource, {
      storeLoadOptions: a
    } = e;
    e.isCustomLoading && !a.isLoadingAll || (a.filter = this.combinedFilter(a.filter), ((i = a.filter) === null || i === void 0 ? void 0 : i.length) === 1 && a.filter[0] === "!" && (e.data = [], e.extra = e.extra || {}, e.extra.totalCount = 0), r.isDataSourceApplied() || r.updateColumnDataTypes(n), this._columnsUpdating = !0, r.updateSortingGrouping(n, !this._useSortingGroupingFromColumns), this._columnsUpdating = !1, a.sort = r.getSortDataSourceParameters(), a.group = r.getGroupDataSourceParameters(), n.sort(a.sort), n.group(a.group), a.sort = r.getSortDataSourceParameters(!n.remoteOperations().sorting), e.group = r.getGroupDataSourceParameters(!n.remoteOperations().grouping));
  }
  _handleColumnsChanged(e) {
    var i = this, {
      changeTypes: r
    } = e, {
      optionNames: n
    } = e, a, o, u;
    if (r.sorting || r.grouping)
      i._dataSource && !i._columnsUpdating && (i._dataSource.group(i._columnsController.getGroupDataSourceParameters()), i._dataSource.sort(i._columnsController.getSortDataSourceParameters()), i.reload());
    else if (r.columns && (o = i._columnsController.columnOption(e.columnIndex, "filterValues"), (n.filterValues || n.filterType && Array.isArray(o) || n.filterValue || n.selectedFilterOperation || n.allowFiltering) && (a = i._columnsController.columnOption(e.columnIndex, "filterValue"), (Array.isArray(o) || e.columnIndex === void 0 || R(a) || !n.selectedFilterOperation || n.filterValue) && (i._applyFilter(), u = !0)), !i._needApplyFilter && !xe.checkChanges(n, ["width", "visibleWidth", "filterValue", "bufferedFilterValue", "selectedFilterOperation", "filterValues", "filterType"]) && i._columnsController.columnsChanged.add(function p(v) {
      var _;
      i._columnsController.columnsChanged.remove(p), i.updateItems({
        repaintChangesOnly: !1,
        virtualColumnsScrolling: (_ = v == null ? void 0 : v.changeTypes) === null || _ === void 0 ? void 0 : _.virtualColumnsScrolling
      });
    }), R(n.visible))) {
      var c = i._columnsController.columnOption(e.columnIndex);
      c && (R(c.filterValue) || R(c.filterValues)) && (i._applyFilter(), u = !0);
    }
    !u && r.filtering && !this._needApplyFilter && i.reload();
  }
  _handleDataChanged(e) {
    var i = this, r = i._dataSource, n = i._columnsController, a = !1;
    this._useSortingGroupingFromColumns = !1, r && !i._isDataSourceApplying && (i._isDataSourceApplying = !0, $e(i._columnsController.applyDataSource(r)).done(() => {
      i._isLoading && i._handleLoadingChanged(!1), a && e && e.isDelayed && (e.isDelayed = !1), i._isDataSourceApplying = !1;
      var o = i._needApplyFilter;
      i._needApplyFilter = !1, o && !i._isAllDataTypesDefined && (u = i._calculateAdditionalFilter(), u && u.length) ? (Yt.log("W1005", i.component.NAME), i._applyFilter()) : i.updateItems(e, !0);
      var u;
    }).fail(() => {
      i._isDataSourceApplying = !1;
    }), i._isDataSourceApplying && (a = !0, i._handleLoadingChanged(!0)), i._needApplyFilter = !i._columnsController.isDataSourceApplied(), i._isAllDataTypesDefined = n.isAllDataTypesDefined());
  }
  _handleLoadingChanged(e) {
    this._isLoading = e, this._fireLoadingChanged();
  }
  _handleLoadError(e) {
    this.dataErrorOccurred.fire(e);
  }
  _handleDataPushed(e) {
    this.pushed.fire(e);
  }
  fireError() {
    for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++)
      i[r] = arguments[r];
    this.dataErrorOccurred.fire(Yt.Error.apply(Yt, i));
  }
  _setPagingOptions(e) {
    var i = this.option("paging.pageIndex"), r = this.option("paging.pageSize"), n = this.option("paging.enabled"), a = this.option("scrolling.mode"), o = a === "infinite", u = a === "virtual", c = n || u || o, p = !1, v = !1, _ = !1;
    return e.requireTotalCount(!o), n !== void 0 && e.paginate() !== c && (e.paginate(c), p = !0), r !== void 0 && e.pageSize() !== r && (e.pageSize(r), v = !0), i !== void 0 && e.pageIndex() !== i && (e.pageIndex(i), _ = !0), p || v || _ ? {
      isPaginateChanged: p,
      isPageSizeChanged: v,
      isPageIndexChanged: _
    } : !1;
  }
  _getSpecificDataSourceOption() {
    var e = this.option("dataSource");
    return Array.isArray(e) ? {
      store: {
        type: "array",
        data: e,
        key: this.option("keyExpr")
      }
    } : e;
  }
  _initDataSource() {
    var e = this._dataSource;
    super._initDataSource();
    var i = this._dataSource;
    if (this._useSortingGroupingFromColumns = !0, this._cachedProcessedItems = null, i) {
      var r = this._setPagingOptions(i);
      this._isPaging = r == null ? void 0 : r.isPageIndexChanged, this.setDataSource(i);
    } else
      e && this.updateItems();
  }
  _loadDataSource() {
    var e = this, i = e._dataSource, r = new q();
    return $e(this._columnsController.refresh(!0)).always(() => {
      i ? i.load().done(function() {
        e._isPaging = !1, r.resolve.apply(r, arguments);
      }).fail(r.reject) : r.resolve();
    }), r.promise();
  }
  _beforeProcessItems(e) {
    return e.slice(0);
  }
  getRowIndexDelta() {
    return 0;
  }
  getDataIndex(e) {
    var i = this._items, r = e.changeType === "append" && i.length > 0 ? i[i.length - 1] : null;
    return R(r == null ? void 0 : r.dataIndex) ? r.dataIndex + 1 : 0;
  }
  _processItems(e, i) {
    var r = this, n = r.getRowIndexDelta(), {
      changeType: a
    } = i, o = r._columnsController.getVisibleColumns(null, a === "loadingAll"), u = this.getDataIndex(i), c = {
      visibleColumns: o,
      dataIndex: u
    }, p = [];
    return N(e, (v, _) => {
      R(_) && (c.rowIndex = v - n, _ = r._processItem(_, c), p.push(_));
    }), p;
  }
  _processItem(e, i) {
    return e = this._generateDataItem(e, i), e = this._processDataItem(e, i), e.dataIndex = i.dataIndex++, e;
  }
  _generateDataItem(e, i) {
    return {
      rowType: "data",
      data: e,
      key: this.keyOf(e)
    };
  }
  _processDataItem(e, i) {
    return e.values = this.generateDataValues(e.data, i.visibleColumns), e;
  }
  generateDataValues(e, i, r) {
    for (var n = [], a, o = 0; o < i.length; o++) {
      var u = i[o];
      a = r ? void 0 : null, u.command || (u.calculateCellValue ? a = u.calculateCellValue(e) : u.dataField && (a = e[u.dataField])), n.push(a);
    }
    return n;
  }
  _applyChange(e) {
    e.changeType === "update" ? this._applyChangeUpdate(e) : this.items().length && e.repaintChangesOnly && e.changeType === "refresh" ? this._applyChangesOnly(e) : e.changeType === "refresh" && this._applyChangeFull(e);
  }
  _applyChangeFull(e) {
    this._items = e.items.slice(0);
  }
  _getRowIndices(e) {
    var i = e.rowIndices.slice(0), r = this.getRowIndexDelta();
    i.sort((o, u) => o - u);
    for (var n = 0; n < i.length; n++) {
      var a = i[n];
      e.allowInvisibleRowIndices && (a += r), a < 0 && (i.splice(n, 1), n--);
    }
    return i;
  }
  _applyChangeUpdate(e) {
    var i = this, {
      items: r
    } = e, n = i._getRowIndices(e), a = i.getRowIndexDelta(), o = i.option("repaintChangesOnly"), u = -1, c = 0, p;
    e.items = [], e.rowIndices = [], e.columnIndices = [], e.changeTypes = [];
    var v = function(_, y, b) {
      var I = _ && y && Mi(_.key, y.key);
      return I && b && (I = _.rowType === y.rowType && (y.rowType !== "detail" || _.isEditing === y.isEditing)), I;
    };
    N(n, (_, y) => {
      var b;
      if (y += c + a, u !== y) {
        u = y;
        var I = i._items[y], A = i._items[y + 1], L = r[y], B = r[y + 1], $ = v(I, A) || v(L, B);
        if (L && (L.rowIndex = y, e.items.push(L)), I && L && v(I, L, $))
          p = "update", i._items[y] = L, I.visible !== L.visible ? e.items.splice(-1, 1, {
            visible: L.visible
          }) : o && !e.isFullUpdate && (b = i._partialUpdateRow(I, L, y - a));
        else if (L && !I || B && v(I, B, $))
          p = "insert", i._items.splice(y, 0, L), c++;
        else if (I && !L || A && v(L, A, $))
          p = "remove", i._items.splice(y, 1), c--, u = -1;
        else if (L)
          p = "update", i._items[y] = L;
        else
          return;
        e.rowIndices.push(y - a), e.changeTypes.push(p), e.columnIndices.push(b);
      }
    });
  }
  _isCellChanged(e, i, r, n, a) {
    if (JSON.stringify(e.values[n]) !== JSON.stringify(i.values[n]))
      return !0;
    function o(u, c) {
      return u.modifiedValues ? u.modifiedValues[c] !== void 0 : !1;
    }
    return o(e, n) !== o(i, n);
  }
  _getChangedColumnIndices(e, i, r, n) {
    var a;
    if (e.rowType === i.rowType) {
      if (i.rowType !== "group" && i.rowType !== "groupFooter" && (a = [], i.rowType !== "detail"))
        for (var o = 0; o < e.values.length; o++)
          this._isCellChanged(e, i, r, o, n) && a.push(o);
      if (i.rowType === "group" && e.cells) {
        var u = i.isExpanded === e.isExpanded && i.data.isContinuation === e.data.isContinuation && i.data.isContinuationOnNextPage === e.data.isContinuationOnNextPage;
        u && (a = e.cells.map((c, p) => {
          var v;
          return ((v = c.column) === null || v === void 0 ? void 0 : v.type) !== "groupExpand" ? p : -1;
        }).filter((c) => c >= 0));
      }
    }
    return a;
  }
  _partialUpdateRow(e, i, r, n) {
    var a = this._getChangedColumnIndices(e, i, r, n);
    return a != null && a.length && this.option("dataRowTemplate") && (a = void 0), a && (e.cells && e.cells.forEach((o, u) => {
      var c = a.indexOf(u) >= 0;
      !c && o && o.update && o.update(i);
    }), i.update = e.update, i.watch = e.watch, i.cells = e.cells, n && (i.oldValues = e.values), e.update && e.update(i)), a;
  }
  _isItemEquals(e, i) {
    var r, n, a, o;
    if (JSON.stringify(e.values) !== JSON.stringify(i.values) || ["modified", "isNewRow", "removed", "isEditing"].some((v) => e[v] !== i[v]))
      return !1;
    if (e.rowType === "group" || e.rowType === "groupFooter") {
      var u = e.isExpanded === i.isExpanded, c = JSON.stringify(e.summaryCells) === JSON.stringify(i.summaryCells), p = ((r = e.data) === null || r === void 0 ? void 0 : r.isContinuation) === ((n = i.data) === null || n === void 0 ? void 0 : n.isContinuation) && ((a = e.data) === null || a === void 0 ? void 0 : a.isContinuationOnNextPage) === ((o = i.data) === null || o === void 0 ? void 0 : o.isContinuationOnNextPage);
      if (!u || !c || !p)
        return !1;
    }
    return !0;
  }
  _applyChangesOnly(e) {
    var i, r = [], n = [], a = [], o = [], u = {}, c = (i = e == null ? void 0 : e.isLiveUpdate) !== null && i !== void 0 ? i : !0;
    function p(b) {
      if (b)
        return "".concat(b.rowType, ",").concat(JSON.stringify(b.key));
    }
    var v = this._items, _ = v.slice();
    e.items.forEach((b, I) => {
      var A = p(b);
      u[A] = I, b.rowIndex = I;
    });
    var y = g5(_, e.items, p, (b, I) => this._isItemEquals(b, I) ? (b.cells && (b.update && b.update(I), b.cells.forEach((A) => {
      A && A.update && A.update(I, !0);
    })), !0) : !1);
    if (!y) {
      this._applyChangeFull(e);
      return;
    }
    y.forEach((b) => {
      switch (b.type) {
        case "update":
          var {
            index: I
          } = b, A = b.data, {
            oldItem: L
          } = b, B = this._partialUpdateRow(L, A, I, c);
          r.push(I), a.push("update"), o.push(A), v[I] = A, n.push(B);
          break;
        case "insert":
          r.push(b.index), a.push("insert"), o.push(b.data), n.push(void 0), v.splice(b.index, 0, b.data);
          break;
        case "remove":
          r.push(b.index), a.push("remove"), v.splice(b.index, 1), o.push(b.oldItem), n.push(void 0);
      }
    }), e.repaintChangesOnly = !0, e.changeType = "update", e.rowIndices = r, e.columnIndices = n, e.changeTypes = a, e.items = o, _.length && (e.isLiveUpdate = !0), this._correctRowIndices((b) => {
      var I = this._rowIndexOffset || 0, A = this.getRowIndexOffset(), L = _[b - I], B = p(L), $ = u[B];
      return $ >= 0 ? $ + A - b : 0;
    });
  }
  _correctRowIndices(e) {
  }
  _afterProcessItems(e, i) {
    return e;
  }
  _updateItemsCore(e) {
    var i, r = this._dataSource, n = e.changeType || "refresh";
    if (e.changeType = n, r) {
      var a = this._cachedProcessedItems;
      e.useProcessedItemsCache && a ? i = a : (i = e.items || r.items(), i = this._beforeProcessItems(i), i = this._processItems(i, e), this._cachedProcessedItems = i), i = this._afterProcessItems(i, e), e.items = i;
      var o = this._items.length === i.length && this._items;
      this._applyChange(e);
      var u = this.getRowIndexDelta();
      N(this._items, (c, p) => {
        var v;
        p.rowIndex = c - u, o && (p.cells = (v = o[c].cells) !== null && v !== void 0 ? v : []);
        var _ = i[c];
        _ && (p.loadIndex = _.loadIndex);
      }), this._rowIndexOffset = this.getRowIndexOffset();
    } else
      this._items = [];
  }
  _handleChanging(e) {
    var i = this.getVisibleRows(), r = this.dataSource();
    r && e.changes.forEach((n) => {
      if (n.type === "insert" && n.index >= 0) {
        for (var a = 0, o = 0; o < n.index; o++) {
          var u = i[o];
          u && (u.rowType === "data" || u.rowType === "group") && a++;
        }
        n.index = a;
      }
    });
  }
  updateItems(e, i) {
    var r;
    if (e = e || {}, this._repaintChangesOnly !== void 0)
      e.repaintChangesOnly = (r = e.repaintChangesOnly) !== null && r !== void 0 ? r : this._repaintChangesOnly, e.needUpdateDimensions = e.needUpdateDimensions || this._needUpdateDimensions;
    else if (e.changes)
      e.repaintChangesOnly = this.option("repaintChangesOnly");
    else if (i) {
      var n = this.dataSource().operationTypes();
      e.repaintChangesOnly = n && !n.grouping && !n.filtering && this.option("repaintChangesOnly"), e.isDataChanged = !0, n && (n.reload || n.paging || n.groupExpanding) && (e.needUpdateDimensions = !0);
    }
    if (this._updateLockCount && !e.cancel) {
      this._changes.push(e);
      return;
    }
    this._updateItemsCore(e), !e.cancel && this._fireChanged(e);
  }
  loadingOperationTypes() {
    var e = this.dataSource();
    return e && e.loadingOperationTypes() || {};
  }
  _fireChanged(e) {
    this._currentOperationTypes && (e.operationTypes = this._currentOperationTypes, this._currentOperationTypes = null), dn(() => {
      this.changed.fire(e);
    });
  }
  isLoading() {
    return this._isLoading || this._isCustomLoading;
  }
  _fireLoadingChanged() {
    this.loadingChanged.fire(this.isLoading(), this._loadingText);
  }
  _calculateAdditionalFilter() {
    return null;
  }
  _applyFilter() {
    var e = this._dataSource;
    return e ? (e.pageIndex(0), this._isFilterApplying = !0, this.reload().done(() => {
      this._isFilterApplying && this.pageChanged.fire();
    })) : new q().resolve();
  }
  resetFilterApplying() {
    this._isFilterApplying = !1;
  }
  filter(e) {
    var i = this._dataSource, r = i && i.filter();
    if (arguments.length === 0)
      return r;
    e = arguments.length > 1 ? Array.prototype.slice.call(arguments, 0) : e, !xe.equalFilterParameters(r, e) && (i && i.filter(e), this._applyFilter());
  }
  clearFilter(e) {
    var i = this._columnsController, r = function(n) {
      for (var a = i.columnCount(), o = 0; o < a; o++)
        i.columnOption(o, n, void 0);
    };
    if (this.component.beginUpdate(), arguments.length > 0)
      switch (e) {
        case "dataSource":
          this.filter(null);
          break;
        case "search":
          this.searchByText("");
          break;
        case "header":
          r("filterValues");
          break;
        case "row":
          r("filterValue");
      }
    else
      this.filter(null), this.searchByText(""), r("filterValue"), r("bufferedFilterValue"), r("filterValues");
    this.component.endUpdate();
  }
  _fireDataSourceChanged() {
    var e = this;
    e.changed.add(function i() {
      e.changed.remove(i), e.dataSourceChanged.fire();
    });
  }
  _getDataSourceAdapter() {
  }
  _createDataSourceAdapterCore(e, i) {
    var r = this._getDataSourceAdapter(), n = r.create(this.component);
    return n.init(e, i), n;
  }
  isLocalStore() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.store();
    return e instanceof mS;
  }
  isCustomStore(e) {
    return e = e || this.store(), e instanceof gS;
  }
  _createDataSourceAdapter(e) {
    var i = this.option("remoteOperations"), r = e.store(), n = {
      filtering: !0,
      sorting: !0,
      paging: !0,
      grouping: !0,
      summary: !0
    };
    return ct(i) && i.groupPaging && (i = P({}, n, i)), i === "auto" && (i = this.isLocalStore(r) || this.isCustomStore(r) ? {} : {
      filtering: !0,
      sorting: !0,
      paging: !0
    }), i === !0 && (i = n), this._createDataSourceAdapterCore(e, i);
  }
  setDataSource(e) {
    var i = this._dataSource;
    !e && i && (i.cancelAll(), i.changed.remove(this._dataChangedHandler), i.loadingChanged.remove(this._loadingChangedHandler), i.loadError.remove(this._loadErrorHandler), i.customizeStoreLoadOptions.remove(this._customizeStoreLoadOptionsHandler), i.changing.remove(this._changingHandler), i.pushed.remove(this._dataPushedHandler), i.dispose(this._isSharedDataSource)), e && (e = this._createDataSourceAdapter(e)), this._dataSource = e, e && (this._fireDataSourceChanged(), this._isLoading = !e.isLoaded(), this._needApplyFilter = !0, this._isAllDataTypesDefined = this._columnsController.isAllDataTypesDefined(), e.changed.add(this._dataChangedHandler), e.loadingChanged.add(this._loadingChangedHandler), e.loadError.add(this._loadErrorHandler), e.customizeStoreLoadOptions.add(this._customizeStoreLoadOptionsHandler), e.changing.add(this._changingHandler), e.pushed.add(this._dataPushedHandler));
  }
  items(e) {
    return this._items;
  }
  isEmpty() {
    return !this.items().length;
  }
  pageCount() {
    return this._dataSource ? this._dataSource.pageCount() : 1;
  }
  dataSource() {
    return this._dataSource;
  }
  store() {
    var e = this._dataSource;
    return e && e.store();
  }
  loadAll(e) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = this, n = new q(), a = r._dataSource;
    if (a)
      if (e) {
        var o = {
          data: e,
          isCustomLoading: !0,
          storeLoadOptions: {
            isLoadingAll: !0
          },
          loadOptions: {
            filter: i ? null : r.getCombinedFilter(),
            group: a.group(),
            sort: a.sort()
          }
        };
        a._handleDataLoaded(o), $e(o.data).done((c) => {
          var p;
          c = r._beforeProcessItems(c), n.resolve(r._processItems(c, {
            changeType: "loadingAll"
          }), (p = o.extra) === null || p === void 0 ? void 0 : p.summary);
        }).fail(n.reject);
      } else if (a.isLoading())
        n.reject();
      else {
        var u = P({}, a.loadOptions(), {
          isLoadingAll: !0,
          requireTotalCount: !1
        });
        a.load(u).done((c, p) => {
          c = r._beforeProcessItems(c), c = r._processItems(c, {
            changeType: "loadingAll"
          }), n.resolve(c, p && p.summary);
        }).fail(n.reject);
      }
    else
      n.resolve([]);
    return n;
  }
  getKeyByRowIndex(e, i) {
    var r = this.items(i)[e];
    if (r)
      return r.key;
  }
  getRowIndexByKey(e, i) {
    return xe.getIndexByKey(e, this.items(i));
  }
  keyOf(e) {
    var i = this.store();
    if (i)
      return i.keyOf(e);
  }
  byKey(e) {
    var i = this.store(), r = this.getRowIndexByKey(e), n;
    if (i)
      return r >= 0 && (n = new q().resolve(this.items()[r].data)), n || i.byKey(e);
  }
  key() {
    var e = this.store();
    if (e)
      return e.key();
  }
  getRowIndexOffset(e) {
    return 0;
  }
  getDataByKeys(e) {
    var i = this, r = new q(), n = [], a = [];
    return N(e, (o, u) => {
      n.push(i.byKey(u).done((c) => {
        a[o] = c;
      }));
    }), $e.apply(E, n).always(() => {
      r.resolve(a);
    }), r;
  }
  pageIndex(e) {
    return yU(this, "pageIndex", e);
  }
  pageSize(e) {
    return yU(this, "pageSize", e);
  }
  beginCustomLoading(e) {
    this._isCustomLoading = !0, this._loadingText = e || "", this._fireLoadingChanged();
  }
  endCustomLoading() {
    this._isCustomLoading = !1, this._loadingText = void 0, this._fireLoadingChanged();
  }
  refresh(e) {
    e === !0 ? e = {
      reload: !0,
      changesOnly: !0
    } : e || (e = {
      lookup: !0,
      selection: !0,
      reload: !0
    });
    var i = this, r = i.getDataSource(), {
      changesOnly: n
    } = e, a = new q(), o = function() {
      i._repaintChangesOnly = !!n;
    };
    return $e(!e.lookup || i._columnsController.refresh()).always(() => {
      e.load || e.reload ? (r && r.on("customizeLoadResult", o), $e(i.reload(e.reload, n)).always(() => {
        r && r.off("customizeLoadResult", o), i._repaintChangesOnly = void 0;
      }).done(a.resolve).fail(a.reject)) : (i.updateItems({
        repaintChangesOnly: e.changesOnly
      }), a.resolve());
    }), a.promise();
  }
  getVisibleRows() {
    return this.items();
  }
  _disposeDataSource() {
    this._dataSource && this._dataSource._eventsStrategy && this._dataSource._eventsStrategy.off("loadingChanged", this.readyWatcher), this.setDataSource(null);
  }
  dispose() {
    this._disposeDataSource(), super.dispose();
  }
  repaintRows(e, i) {
    e = Array.isArray(e) ? e : [e], (e.length > 1 || R(e[0])) && this.updateItems({
      changeType: "update",
      rowIndices: e,
      isFullUpdate: !i
    });
  }
  skipProcessingPagingChange(e) {
    return this._skipProcessingPagingChange && (e === "paging.pageIndex" || e === "paging.pageSize");
  }
  getUserState() {
    return {
      searchText: this.option("searchPanel.text"),
      pageIndex: this.pageIndex(),
      pageSize: this.pageSize()
    };
  }
  getCachedStoreData() {
    return this._dataSource && this._dataSource.getCachedStoreData();
  }
  isLastPageLoaded() {
    var e = this.pageIndex(), i = this.pageCount();
    return e === i - 1;
  }
  load() {
    var e;
    return (e = this._dataSource) === null || e === void 0 ? void 0 : e.load();
  }
  reload(e, i) {
    var r;
    return (r = this._dataSource) === null || r === void 0 ? void 0 : r.reload(e, i);
  }
  push() {
    var e;
    return (e = this._dataSource) === null || e === void 0 ? void 0 : e.push(...arguments);
  }
  itemsCount() {
    var e;
    return this._dataSource ? (e = this._dataSource) === null || e === void 0 ? void 0 : e.itemsCount() : 0;
  }
  totalItemsCount() {
    var e;
    return this._dataSource ? (e = this._dataSource) === null || e === void 0 ? void 0 : e.totalItemsCount() : 0;
  }
  hasKnownLastPage() {
    var e;
    return this._dataSource ? (e = this._dataSource) === null || e === void 0 ? void 0 : e.hasKnownLastPage() : !0;
  }
  isLoaded() {
    var e;
    return this._dataSource ? (e = this._dataSource) === null || e === void 0 ? void 0 : e.isLoaded() : !0;
  }
  totalCount() {
    var e;
    return this._dataSource ? (e = this._dataSource) === null || e === void 0 ? void 0 : e.totalCount() : 0;
  }
  hasLoadOperation() {
    var e, i, r = (i = (e = this._dataSource) === null || e === void 0 ? void 0 : e.operationTypes()) !== null && i !== void 0 ? i : {};
    return Object.keys(r).some((n) => r[n]);
  }
}
var Ege = {
  defaultOptions: () => ({
    loadingTimeout: 0,
    dataSource: null,
    cacheEnabled: !0,
    repaintChangesOnly: !1,
    highlightChanges: !1,
    onDataErrorOccurred: null,
    remoteOperations: "auto",
    paging: {
      enabled: !0,
      pageSize: void 0,
      pageIndex: void 0
    }
  }),
  controllers: {
    data: _5
  }
}, LL = function t(e, i) {
  if (e && (e = e.slice(0), i))
    for (var r = 0; r < e.length; r++)
      e[r] = P({
        key: e[r].key
      }, e[r]), e[r].items = t(e[r].items, i - 1);
  return e;
}, xU = function(t, e, i) {
  var r = {
    reload: !0,
    fullReload: !0
  };
  return e && (r = {
    sorting: !xe.equalSortParameters(t.sort, e.sort),
    grouping: !xe.equalSortParameters(t.group, e.group, !0),
    groupExpanding: !xe.equalSortParameters(t.group, e.group) || e.groupExpand,
    filtering: !xe.equalFilterParameters(t.filter, e.filter),
    pageIndex: t.pageIndex !== e.pageIndex,
    skip: t.skip !== e.skip,
    take: t.take !== e.take,
    pageSize: t.pageSize !== e.pageSize,
    fullReload: i,
    reload: !1,
    paging: !1
  }, r.reload = i || r.sorting || r.grouping || r.filtering, r.paging = r.pageIndex || r.pageSize || r.take), r;
}, bge = function(t, e) {
  R(e) ? aF(t, e) : t();
}, Ey = function() {
  return {
    items: {}
  };
}, SU = function(t, e) {
  var i = xe.normalizeSortingInfo(t.group || t.storeLoadOptions.group || t.loadOptions.group).length, r = [];
  if (C5(r, t, i))
    return r;
  e && Ige(r, t, i);
}, C5 = function(t, e, i, r) {
  var n, a, o, u, c, {
    storeLoadOptions: p
  } = e, v = (a = (n = e.take) !== null && n !== void 0 ? n : p.take) !== null && a !== void 0 ? a : 0, _ = (o = e.cachedData) === null || o === void 0 ? void 0 : o.items;
  if (v && _) {
    for (var y = (c = (u = e.skip) !== null && u !== void 0 ? u : p.skip) !== null && c !== void 0 ? c : 0, b = 0; b < v; b += 1) {
      var I = r ? v - 1 - b : b, A = I + y, L = _[A];
      if (L === void 0 && A in _)
        return !0;
      var B = wge(e, L, i, I, v);
      if (B)
        t.push(B);
      else
        return !1;
    }
    return !0;
  }
  return !1;
}, wge = function(t, e, i, r, n) {
  if (i && e) {
    var a = r === 0 && t.skips || [], o = r === n - 1 && t.takes || [];
    return Tge(e, i, a, o);
  }
  return e;
}, Tge = function t(e, i, r, n) {
  if (i && e) {
    var a = ae({}, e), o = r[0] || 0, u = n[0], {
      items: c
    } = e;
    if (c) {
      if (u === void 0 && !c[o])
        return;
      a.items = [], r.length && (a.isContinuation = !0), u && (a.isContinuationOnNextPage = e.count > u);
      for (var p = 0; u === void 0 ? c[p + o] : p < u; p += 1) {
        var v = c[p + o], _ = p + 1 === u, y = t(v, i - 1, p === 0 ? r.slice(1) : [], _ ? n.slice(1) : []);
        if (y !== void 0)
          a.items.push(y);
        else
          return;
      }
    }
    return a;
  }
  return e;
}, Ige = function(t, e, i) {
  var r, n, a = t.length, {
    storeLoadOptions: o
  } = e;
  if (o.skip !== void 0 && o.take && !i) {
    var u = [];
    C5(u, e, i, !0);
    var c = u.length;
    (a || c) && (e.skip = (r = e.skip) !== null && r !== void 0 ? r : o.skip, e.take = (n = e.take) !== null && n !== void 0 ? n : o.take), a && (o.skip += a, o.take -= a, e.cachedDataPartBegin = t), c && (o.take -= c, e.cachedDataPartEnd = u.reverse());
  }
}, Dge = function(t, e, i) {
  for (var r, n, a, o, {
    storeLoadOptions: u
  } = t, c = (n = (r = t.skip) !== null && r !== void 0 ? r : u.skip) !== null && n !== void 0 ? n : 0, p = (o = (a = t.take) !== null && a !== void 0 ? a : u.take) !== null && o !== void 0 ? o : 0, v = 0; v < p; v += 1) {
    var _ = v + c, y = t.cachedData.items, b = v === 0 && t.skips || [];
    y[_] = Age(y[_], e[v], i, b);
  }
}, Age = function t(e, i, r, n) {
  if (r && i) {
    var a = ae({}, i);
    delete a.isContinuation, delete a.isContinuationOnNextPage;
    var o = n[0] || 0;
    return i.items && (a.items = (e == null ? void 0 : e.items) || {}, i.items.forEach((u, c) => {
      var p = c + o, v = c === 0 ? n.slice(1) : [];
      a.items[p] = t(a.items[p], u, r - 1, v);
    })), a;
  }
  return i;
};
class Oge extends Bi.Controller {
  init(e, i) {
    var r = this;
    r._dataSource = e, r._remoteOperations = i || {}, r._isLastPage = !e.isLastPage(), r._hasLastPage = !1, r._currentTotalCount = 0, r._cachedData = Ey(), r._lastOperationTypes = {}, r._eventsStrategy = e._eventsStrategy, r._totalCountCorrection = 0, r._isLoadingAll = !1, r.changed = ui(), r.loadingChanged = ui(), r.loadError = ui(), r.customizeStoreLoadOptions = ui(), r.changing = ui(), r.pushed = ui(), r._dataChangedHandler = r._handleDataChanged.bind(r), r._customizeStoreLoadOptionsHandler = r._handleCustomizeStoreLoadOptions.bind(r), r._dataLoadedHandler = r._handleDataLoaded.bind(r), r._loadingChangedHandler = r._handleLoadingChanged.bind(r), r._loadErrorHandler = r._handleLoadError.bind(r), r._pushHandler = r._handlePush.bind(r), r._changingHandler = r._handleChanging.bind(r), e.on("changed", r._dataChangedHandler), e.on("customizeStoreLoadOptions", r._customizeStoreLoadOptionsHandler), e.on("customizeLoadResult", r._dataLoadedHandler), e.on("loadingChanged", r._loadingChangedHandler), e.on("loadError", r._loadErrorHandler), e.on("changing", r._changingHandler), e.store().on("beforePush", r._pushHandler), N(e, (n, a) => {
      !r[n] && Le(a) && (r[n] = function() {
        return this._dataSource[n].apply(this._dataSource, arguments);
      });
    });
  }
  dispose(e) {
    var i = this._dataSource, r = i.store();
    i.off("changed", this._dataChangedHandler), i.off("customizeStoreLoadOptions", this._customizeStoreLoadOptionsHandler), i.off("customizeLoadResult", this._dataLoadedHandler), i.off("loadingChanged", this._loadingChangedHandler), i.off("loadError", this._loadErrorHandler), i.off("changing", this._changingHandler), r && r.off("beforePush", this._pushHandler), e || i.dispose();
  }
  remoteOperations() {
    return this._remoteOperations;
  }
  refresh(e, i) {
    var r = this._dataSource;
    i.reload && (this.resetCurrentTotalCount(), this._isLastPage = !r.paginate(), this._hasLastPage = this._isLastPage);
  }
  resetCurrentTotalCount() {
    this._currentTotalCount = 0, this._totalCountCorrection = 0;
  }
  resetCache() {
    this._cachedStoreData = void 0, this._cachedPagingData = void 0;
  }
  resetPagesCache(e) {
    this._cachedData = Ey();
  }
  _needClearStoreDataCache() {
    var e = this.remoteOperations(), i = xU(this._lastLoadOptions || {}, {}), r = Object.keys(e).every((n) => !i[n] || !e[n]);
    return !r;
  }
  push(e, i) {
    var r = this.store();
    this._needClearStoreDataCache() && (this._cachedStoreData = void 0), this._cachedPagingData = void 0, this.resetPagesCache(!0), this._cachedStoreData && xp({
      keyInfo: r,
      data: this._cachedStoreData,
      changes: e
    }), i || this._applyBatch(e), this.pushed.fire(e);
  }
  getDataIndexGetter() {
    if (!this._dataIndexGetter) {
      var e, i, r = this.store();
      this._dataIndexGetter = (n) => {
        var a = i && i !== this._cachedStoreData;
        if (!e || a) {
          i = this._cachedStoreData || [], e = {};
          for (var o = 0; o < i.length; o++)
            e[ku(r.keyOf(i[o]))] = o;
        }
        return e[ku(r.keyOf(n))];
      };
    }
    return this._dataIndexGetter;
  }
  _getKeyInfo() {
    return this.store();
  }
  _needToCopyDataObject() {
    return !0;
  }
  _applyBatch(e, i) {
    var r = this._getKeyInfo(), n = this._dataSource, a = xe.normalizeSortingInfo(this.group()).length, o = this.option("editing.refreshMode") === "reshape", u = this.option("scrolling.mode") === "virtual";
    e = e.filter((_) => !n.paginate() || _.type !== "insert" || _.index !== void 0);
    var c = () => a ? this.itemsCount() : this.items().length, p = c();
    xp({
      keyInfo: r,
      data: this._items,
      changes: e,
      groupCount: a,
      useInsertIndex: !0,
      skipCopying: !this._needToCopyDataObject()
    }), xp({
      keyInfo: r,
      data: n.items(),
      changes: e,
      groupCount: a,
      useInsertIndex: !0,
      skipCopying: !this._needToCopyDataObject()
    });
    var v = this._currentTotalCount > 0 || (i || !o) && u;
    v && (this._totalCountCorrection += c() - p), e.splice(0, e.length);
  }
  _handlePush(e) {
    var {
      changes: i
    } = e;
    this.push(i, !0);
  }
  _handleChanging(e) {
    this.changing.fire(e), this._applyBatch(e.changes, !0);
  }
  _needCleanCacheByOperation(e, i) {
    var r = ["filtering", "sorting", "paging"], n = r.indexOf(e), a = n >= 0 ? r.slice(n) : [e];
    return a.some((o) => i[o]);
  }
  _customizeRemoteOperations(e, i) {
    var r = this._cachedStoreData, n = this._cachedPagingData, a = this._cachedData;
    (e.storeLoadOptions.filter && !e.remoteOperations.filtering || e.storeLoadOptions.sort && !e.remoteOperations.sorting) && (e.remoteOperations = {
      filtering: e.remoteOperations.filtering,
      summary: e.remoteOperations.summary
    }), i.fullReload ? (r = void 0, n = void 0, a = Ey()) : (i.reload ? (n = void 0, a = Ey()) : i.groupExpanding && (a = Ey()), N(i, (o, u) => {
      u && this._needCleanCacheByOperation(o, e.remoteOperations) && (r = void 0, n = void 0);
    })), n && (e.remoteOperations.paging = !1), e.cachedStoreData = r, e.cachedPagingData = n, e.cachedData = a, e.isCustomLoading || (this._cachedStoreData = r, this._cachedPagingData = n, this._cachedData = a);
  }
  _handleCustomizeStoreLoadOptions(e) {
    var i;
    this._handleDataLoading(e), ((i = e.data) === null || i === void 0 ? void 0 : i.length) !== 0 && (e.data = SU(e, !0) || e.cachedStoreData);
  }
  _handleDataLoading(e) {
    var i = this._dataSource, r = this._lastLoadOptions;
    this.customizeStoreLoadOptions.fire(e), e.delay = this.option("loadingTimeout"), e.originalStoreLoadOptions = e.storeLoadOptions, e.remoteOperations = P({}, this.remoteOperations());
    var n = !this.isLoaded() && !this._isRefreshing;
    this.option("integrationOptions.renderedOnServer") && !this.isLoaded() && (e.delay = void 0);
    var a = P({
      pageIndex: this.pageIndex(),
      pageSize: this.pageSize()
    }, e.storeLoadOptions), o = xU(a, r, n);
    if (this._customizeRemoteOperations(e, o), !e.isCustomLoading) {
      var u = this._isRefreshing;
      e.pageIndex = i.pageIndex(), e.lastLoadOptions = a, e.operationTypes = o, this._loadingOperationTypes = o, this._isRefreshing = !0, $e(u || this._isRefreshed || this.refresh(e, o)).done(() => {
        this._lastOperationId === e.operationId && (this._isRefreshed = !0, this.load().always(() => {
          this._isRefreshed = !1;
        }));
      }).fail(() => {
        i.cancel(e.operationId);
      }).always(() => {
        this._isRefreshing = !1;
      }), i.cancel(this._lastOperationId), this._lastOperationId = e.operationId, this._isRefreshing && i.cancel(this._lastOperationId);
    }
    this._handleDataLoadingCore(e);
  }
  _handleDataLoadingCore(e) {
    var {
      remoteOperations: i
    } = e;
    e.loadOptions = {};
    var r = e.cachedData.extra, n = {
      filter: !i.filtering,
      sort: !i.sorting,
      group: !i.grouping,
      summary: !i.summary,
      skip: !i.paging,
      take: !i.paging,
      requireTotalCount: r && "totalCount" in r || !i.paging,
      langParams: !i.filtering || !i.sorting
    };
    N(e.storeLoadOptions, (a, o) => {
      n[a] && (e.loadOptions[a] = o, delete e.storeLoadOptions[a]);
    }), r && (e.extra = r);
  }
  _handleDataLoaded(e) {
    var i, r, {
      loadOptions: n
    } = e, a = e.remoteOperations && !e.remoteOperations.paging, {
      cachedData: o
    } = e, {
      storeLoadOptions: u
    } = e, c = this.option("cacheEnabled") !== !1 && u, p = c && !e.isCustomLoading && o && (!a || u.group), v = c && a, _ = v && !e.isCustomLoading;
    if (!n) {
      this._dataSource.cancel(e.operationId);
      return;
    }
    a && (e.skip = n.skip, e.take = n.take, delete n.skip, delete n.take), n.group && (n.group = e.group || n.group);
    var y = xe.normalizeSortingInfo(e.group || u.group || n.group).length;
    e.cachedDataPartBegin && (e.data = e.cachedDataPartBegin.concat(e.data)), e.cachedDataPartEnd && (e.data = e.data.concat(e.cachedDataPartEnd)), (!p || !SU(e)) && (v && e.cachedPagingData ? e.data = LL(e.cachedPagingData, y) : (_ && (this._cachedStoreData ? e.mergeStoreLoadData && (e.data = this._cachedStoreData = this._cachedStoreData.concat(e.data)) : this._cachedStoreData = LL(e.data, xe.normalizeSortingInfo(u.group).length)), new mS(e.data).load(n).done((b) => {
      e.data = b, _ && (this._cachedPagingData = LL(e.data, y));
    }).fail((b) => {
      e.data = new q().reject(b);
    })), n.requireTotalCount && a && (e.extra = $t(e.extra) ? e.extra : {}, e.extra.totalCount = e.data.length), e.extra && e.extra.totalCount >= 0 && (u.requireTotalCount === !1 || n.requireTotalCount === !1) && (e.extra.totalCount = -1), !n.data && (u.requireTotalCount || ((r = (i = e.extra) === null || i === void 0 ? void 0 : i.totalCount) !== null && r !== void 0 ? r : -1) >= 0) && (this._totalCountCorrection = 0), this._handleDataLoadedCore(e), p && (o.extra = o.extra || P({}, e.extra), $e(e.data).done((b) => {
      Dge(e, b, y);
    }))), $e(e.data).done(() => {
      e.lastLoadOptions && (this._lastLoadOptions = e.lastLoadOptions, Object.keys(e.operationTypes).forEach((b) => {
        this._lastOperationTypes[b] = this._lastOperationTypes[b] || e.operationTypes[b];
      }));
    }), e.storeLoadOptions = e.originalStoreLoadOptions;
  }
  _handleDataLoadedCore(e) {
    e.remoteOperations && !e.remoteOperations.paging && Array.isArray(e.data) && (e.skip !== void 0 && (e.data = e.data.slice(e.skip)), e.take !== void 0 && (e.data = e.data.slice(0, e.take)));
  }
  _handleLoadingChanged(e) {
    this.loadingChanged.fire(e);
  }
  _handleLoadError(e) {
    this.loadError.fire(e), this.changed.fire({
      changeType: "loadError",
      error: e
    });
  }
  _loadPageSize() {
    return this.pageSize();
  }
  _handleDataChanged(e) {
    var i, r = this._dataSource, n = !1, a = !e || R(e.changeType), o = this.itemsCount();
    a && (this._isLastPage = !o || !this._loadPageSize() || o < this._loadPageSize(), this._isLastPage && (this._hasLastPage = !0)), r.totalCount() >= 0 ? r.pageIndex() >= this.pageCount() && (r.pageIndex(this.pageCount() - 1), this.pageIndex(r.pageIndex()), this.resetPagesCache(), r.load(), n = !0) : a && (i = r.pageIndex() * this.pageSize() + o, i > this._currentTotalCount && (this._currentTotalCount = i, (r.pageIndex() === 0 || !this.option("scrolling.legacyMode")) && (this._totalCountCorrection = 0)), o === 0 && r.pageIndex() >= this.pageCount() && (r.pageIndex(this.pageCount() - 1), this.option("scrolling.mode") !== "infinite" && (r.load(), n = !0))), n || (this._operationTypes = this._lastOperationTypes, this._lastOperationTypes = {}, this.component._optionCache = {}, this.changed.fire(e), this.component._optionCache = void 0);
  }
  _scheduleCustomLoadCallbacks(e) {
    var i = this;
    i._isCustomLoading = !0, e.always(() => {
      i._isCustomLoading = !1;
    });
  }
  loadingOperationTypes() {
    return this._loadingOperationTypes;
  }
  operationTypes() {
    return this._operationTypes;
  }
  lastLoadOptions() {
    return this._lastLoadOptions || {};
  }
  isLastPage() {
    return this._isLastPage;
  }
  _dataSourceTotalCount() {
    return this._dataSource.totalCount();
  }
  _changeRowExpandCore(e) {
  }
  changeRowExpand(e) {
  }
  totalCount() {
    return parseInt((this._currentTotalCount || this._dataSourceTotalCount()) + this._totalCountCorrection);
  }
  totalCountCorrection() {
    return this._totalCountCorrection;
  }
  items() {
  }
  itemsCount() {
    return this._dataSource.items().length;
  }
  totalItemsCount() {
    return this.totalCount();
  }
  pageSize() {
    var e = this._dataSource;
    return !arguments.length && !e.paginate() ? 0 : e.pageSize.apply(e, arguments);
  }
  pageCount() {
    var e = this.totalItemsCount() - this._totalCountCorrection, i = this.pageSize();
    return i && e > 0 ? Math.max(1, Math.ceil(e / i)) : 1;
  }
  hasKnownLastPage() {
    return this._hasLastPage || this._dataSource.totalCount() >= 0;
  }
  loadFromStore(e, i) {
    var r = this._dataSource, n = new q();
    if (r)
      return i = i || r.store(), i.load(e).done((a, o) => {
        a && !Array.isArray(a) && Array.isArray(a.data) && (o = a, a = a.data), n.resolve(a, o);
      }).fail(n.reject), n;
  }
  isCustomLoading() {
    return !!this._isCustomLoading;
  }
  load(e) {
    var i = this, r = i._dataSource, n = new q();
    if (e) {
      var a = r.store(), o = r.loadOptions(), u = {
        storeLoadOptions: P({}, e, {
          langParams: o == null ? void 0 : o.langParams
        }),
        isCustomLoading: !0
      };
      return N(a._customLoadOptions() || [], (c, p) => {
        p in u.storeLoadOptions || (u.storeLoadOptions[p] = o[p]);
      }), this._isLoadingAll = e.isLoadingAll, i._scheduleCustomLoadCallbacks(n), r._scheduleLoadCallbacks(n), i._handleCustomizeStoreLoadOptions(u), bge(() => {
        if (!r.store())
          return n.reject("canceled");
        $e(u.data || i.loadFromStore(u.storeLoadOptions)).done((c, p) => {
          u.data = c, u.extra = p || {}, i._handleDataLoaded(u), e.requireTotalCount && u.extra.totalCount === void 0 && (u.extra.totalCount = a.totalCount(u.storeLoadOptions)), $e(u.data, u.extra.totalCount).done((v, _) => {
            u.extra.totalCount = _, n.resolve(v, u.extra);
          }).fail(n.reject);
        }).fail(n.reject);
      }, i.option("loadingTimeout")), n.fail(function() {
        i._eventsStrategy.fireEvent("loadError", arguments);
      }).always(() => {
        this._isLoadingAll = !1;
      }).promise();
    }
    return r.load();
  }
  reload(e) {
    return e ? this._dataSource.reload() : this._dataSource.load();
  }
  getCachedStoreData() {
    return this._cachedStoreData;
  }
  isLoaded() {
  }
  pageIndex(e) {
  }
}
var ML = Oge;
const DI = {
  extend(t) {
    ML = t(ML);
  },
  create: (t) => new ML(t)
};
class Rge extends _5 {
  _getDataSourceAdapter() {
    return DI;
  }
  _getSpecificDataSourceOption() {
    var e = this.option("dataSource");
    return e && !Array.isArray(e) && this.option("keyExpr") && Yt.log("W1011"), super._getSpecificDataSourceOption();
  }
}
et.registerModule("data", {
  defaultOptions: Ege.defaultOptions,
  controllers: {
    data: Rge
  }
});
var EU = "dx-sort", bU = "dx-sort-none", Lge = "dx-sort-up", Mge = "dx-sort-down", kge = "dx-sort-index", wU = "dx-sort-index-icon", Pge = "action", y5 = (t) => class extends t {
  _applyColumnState(e) {
    var i, r, n = this.option("sorting.mode"), {
      rootElement: a
    } = e, {
      column: o
    } = e, u = this._getIndicatorContainer(a);
    if (e.name === "sort") {
      a.find(".".concat(EU)).remove(), !u.children().length && u.remove();
      var c = n !== "none" && o.allowSorting, p = this.getController && !!this.getController("columns").columnOption("sortIndex:1");
      return !R(o.groupIndex) && (c || R(o.sortOrder)) && (i = o.sortOrder === "asc" ? "ascending" : "descending", r = super._applyColumnState(e).toggleClass(Lge, o.sortOrder === "asc").toggleClass(Mge, o.sortOrder === "desc"), p && this.option("sorting.showSortIndexes") && o.sortIndex >= 0 && (E("<span>").addClass(wU).text(o.sortIndex + 1).appendTo(r), r.addClass(kge)), c && e.rootElement.addClass(this.addWidgetPrefix(Pge))), this._setAriaSortAttribute(o, i, a, p), r;
    }
    return super._applyColumnState(e);
  }
  _setAriaSortAttribute(e, i, r, n) {
    if (r.removeAttr("aria-roledescription"), e.isGrouped) {
      var a = this.localize("dxDataGrid-ariaNotSortedColumn");
      R(e.sortOrder) && (a = e.sortOrder === "asc" ? this.localize("dxDataGrid-ariaSortedAscendingColumn") : this.localize("dxDataGrid-ariaSortedDescendingColumn")), this.setAria("roledescription", a, r);
    } else if (!R(e.sortOrder))
      this.setAria("sort", "none", r);
    else if (this.setAria("sort", i, r), n && e.sortIndex >= 0) {
      var o = X.format("dxDataGrid-ariaColumnHeader"), u = X.format("dxDataGrid-ariaSortIndex", e.sortIndex + 1), c = "".concat(o, ", ").concat(u);
      this.setAria("roledescription", c, r);
    }
  }
  _getIndicatorClassName(e) {
    return e === "sort" ? EU : e === "sortIndex" ? wU : super._getIndicatorClassName(e);
  }
  _renderIndicator(e) {
    var {
      column: i
    } = e, r = e.container, n = e.indicator;
    if (e.name === "sort") {
      var a = this.option("rtlEnabled");
      if (R(i.sortOrder) || n && n.addClass(bU), r.children().length && (!a && e.columnAlignment === "left" || a && e.columnAlignment === "right")) {
        r.prepend(n);
        return;
      }
    }
    super._renderIndicator(e);
  }
  _updateIndicator(e, i, r) {
    if (!(r === "sort" && R(i.groupIndex)))
      return super._updateIndicator.apply(this, arguments);
  }
  _getIndicatorElements(e, i) {
    var r = super._getIndicatorElements(e);
    return i ? r : r && r.not(".".concat(bU));
  }
}, Fge = "dxDataGridColumnHeadersView", Bge = (t) => class extends y5(t) {
  optionChanged(e) {
    switch (e.name) {
      case "sorting":
        this._invalidate(), e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
  _createRow(e) {
    var i = super._createRow(e);
    return e.rowType === "header" && k.on(i, ve(di, Fge), "td", this.createAction((r) => {
      this._processHeaderAction(r.event, i);
    })), i;
  }
  _processHeaderAction(e, i) {
    if (E(e.currentTarget).parent().get(0) === i.get(0)) {
      var r = this, n = null, a = E(e.currentTarget), o = a.parent().index(), u = -1;
      [].slice.call(r.getCellElements(o)).some((b, I) => {
        if (b === a.get(0))
          return u = I, !0;
      });
      var c = r._columnsController.getVisibleColumns(o), p = c[u], v = r.getController("editing"), _ = r.option("editing.mode"), y = v && v.isEditing() && (_ === "batch" || _ === "cell");
      y || !r._isSortableElement(E(e.target)) || p && !R(p.groupIndex) && !p.command && (e.shiftKey ? n = "shift" : Cn(e) && (n = "ctrl"), setTimeout(() => {
        r._columnsController.changeSortOrder(p.index, n);
      }));
    }
  }
  _renderCellContent(e, i) {
    var {
      column: r
    } = i;
    !r.command && i.rowType === "header" && this._applyColumnState({
      name: "sort",
      rootElement: e,
      column: r,
      showColumnLines: this.option("showColumnLines")
    }), super._renderCellContent.apply(this, arguments);
  }
  _columnOptionChanged(e) {
    var {
      changeTypes: i
    } = e;
    if (i.length === 1 && i.sorting) {
      this._updateIndicators("sort");
      return;
    }
    super._columnOptionChanged(e);
  }
}, Vge = (t) => class extends y5(t) {
  optionChanged(e) {
    switch (e.name) {
      case "sorting":
        this._invalidate(), e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
  _createGroupPanelItem(e, i) {
    var r = this, n = super._createGroupPanelItem(...arguments);
    return k.on(n, ve(di, "dxDataGridHeaderPanel"), r.createAction(() => {
      r._processGroupItemAction(i.index);
    })), r._applyColumnState({
      name: "sort",
      rootElement: n,
      column: {
        alignment: r.option("rtlEnabled") ? "right" : "left",
        allowSorting: i.allowSorting,
        sortOrder: i.sortOrder === "desc" ? "desc" : "asc",
        isGrouped: !0
      },
      showColumnLines: !0
    }), n;
  }
  _processGroupItemAction(e) {
    setTimeout(() => this.getController("columns").changeSortOrder(e));
  }
}, Nge = {
  defaultOptions: () => ({
    sorting: {
      mode: "single",
      ascendingText: X.format("dxDataGrid-sortingAscendingText"),
      descendingText: X.format("dxDataGrid-sortingDescendingText"),
      clearText: X.format("dxDataGrid-sortingClearText"),
      showSortIndexes: !0
    }
  }),
  extenders: {
    views: {
      columnHeadersView: Bge,
      headerPanel: Vge
    }
  }
};
et.registerModule("sorting", Nge);
var Hge = wi.abstract, x5 = wi.inherit({
  ctor: function() {
    this._finished = !0, this._stopped = !1, this._proxiedStepCore = this._stepCore.bind(this);
  },
  start: function() {
    this._stopped = !1, this._finished = !1, this._stepCore();
  },
  stop: function() {
    this._stopped = !0, Nd(this._stepAnimationFrame);
  },
  _stepCore: function() {
    if (this._isStopped()) {
      this._stop();
      return;
    }
    if (this._isFinished()) {
      this._finished = !0, this._complete();
      return;
    }
    this._step(), this._stepAnimationFrame = Fx(this._proxiedStepCore);
  },
  _step: Hge,
  _isFinished: ee,
  _stop: ee,
  _complete: ee,
  _isStopped: function() {
    return this._stopped;
  },
  inProgress: function() {
    return !(this._stopped || this._finished);
  }
}), TP = "dxScrollbar", S5 = "dx-scrollable-scrollbar", TU = "".concat(S5, "-active"), $ge = "dx-scrollable-scroll", zge = "dx-scrollable-scroll-content", Wge = "dx-scrollbar-hoverable", IU = "horizontal", Uge = 15, Ld = {
  onScroll: "onScroll",
  onHover: "onHover",
  always: "always",
  never: "never"
}, ym = null, E5 = xn.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      direction: null,
      visible: !1,
      activeStateEnabled: !1,
      visibilityMode: Ld.onScroll,
      containerSize: 0,
      contentSize: 0,
      expandable: !0,
      scaleRatio: 1
    });
  },
  _init: function() {
    this.callBase(), this._isHovered = !1;
  },
  _initMarkup: function() {
    this._renderThumb(), this.callBase();
  },
  _render: function() {
    this.callBase(), this._renderDirection(), this._update(), this._attachPointerDownHandler(), this.option("hoverStateEnabled", this._isHoverMode()), this.$element().toggleClass(Wge, this.option("hoverStateEnabled"));
  },
  _renderThumb: function() {
    this._$thumb = E("<div>").addClass($ge), E("<div>").addClass(zge).appendTo(this._$thumb), this.$element().addClass(S5).append(this._$thumb);
  },
  isThumb: function(t) {
    return !!this.$element().find(t).length;
  },
  _isHoverMode: function() {
    var t = this.option("visibilityMode");
    return (t === Ld.onHover || t === Ld.always) && this.option("expandable");
  },
  _renderDirection: function() {
    var t = this.option("direction");
    this.$element().addClass("dx-scrollbar-" + t), this._dimension = t === IU ? "width" : "height", this._prop = t === IU ? "left" : "top";
  },
  _attachPointerDownHandler: function() {
    k.on(this._$thumb, ve(Xt.down, TP), this.feedbackOn.bind(this));
  },
  feedbackOn: function() {
    this.$element().addClass(TU), ym = this;
  },
  feedbackOff: function() {
    this.$element().removeClass(TU), ym = null;
  },
  cursorEnter: function() {
    this._isHovered = !0, this._needScrollbar() && this.option("visible", !0);
  },
  cursorLeave: function() {
    this._isHovered = !1, this.option("visible", !1);
  },
  _renderDimensions: function() {
    this._$thumb.css({
      width: this.option("width"),
      height: this.option("height")
    });
  },
  _toggleVisibility: function(t) {
    this.option("visibilityMode") === Ld.onScroll && this._$thumb.css("opacity"), t = this._adjustVisibility(t), this.option().visible = t, this._$thumb.toggleClass("dx-state-invisible", !t);
  },
  _adjustVisibility: function(t) {
    if (this._baseContainerToContentRatio && !this._needScrollbar())
      return !1;
    switch (this.option("visibilityMode")) {
      case Ld.onScroll:
        break;
      case Ld.onHover:
        t = t || !!this._isHovered;
        break;
      case Ld.never:
        t = !1;
        break;
      case Ld.always:
        t = !0;
    }
    return t;
  },
  moveTo: function(t) {
    if (!this._isHidden()) {
      $t(t) && (t = t[this._prop] || 0);
      var e = {};
      e[this._prop] = this._calculateScrollBarPosition(t), Nn(this._$thumb, e);
    }
  },
  _calculateScrollBarPosition: function(t) {
    return -t * this._thumbRatio;
  },
  _update: function() {
    var t = Math.round(this.option("containerSize")), e = Math.round(this.option("contentSize")), i = Math.round(this.option("baseContainerSize")), r = Math.round(this.option("baseContentSize"));
    isNaN(i) && (i = t, r = e), this._baseContainerToContentRatio = r ? i / r : i, this._realContainerToContentRatio = e ? t / e : t;
    var n = Math.round(Math.max(Math.round(t * this._realContainerToContentRatio), Uge));
    this._thumbRatio = (t - n) / (this.option("scaleRatio") * (e - t)), this.option(this._dimension, n / this.option("scaleRatio")), this.$element().css("display", this._needScrollbar() ? "" : "none");
  },
  _isHidden: function() {
    return this.option("visibilityMode") === Ld.never;
  },
  _needScrollbar: function() {
    return !this._isHidden() && this._baseContainerToContentRatio < 1;
  },
  containerToContentRatio: function() {
    return this._realContainerToContentRatio;
  },
  _normalizeSize: function(t) {
    return $t(t) ? t[this._dimension] || 0 : t;
  },
  _clean: function() {
    this.callBase(), this === ym && (ym = null), k.off(this._$thumb, "." + TP);
  },
  _optionChanged: function(t) {
    if (!this._isHidden())
      switch (t.name) {
        case "containerSize":
        case "contentSize":
          this.option()[t.name] = this._normalizeSize(t.value), this._update();
          break;
        case "baseContentSize":
        case "baseContainerSize":
          this._update();
          break;
        case "visibilityMode":
        case "direction":
          this._invalidate();
          break;
        case "scaleRatio":
          this._update();
          break;
        default:
          this.callBase.apply(this, arguments);
      }
  },
  update: Sm(function() {
    this._adjustVisibility() && this.option("visible", !0);
  })
});
Vu.add(function() {
  k.subscribeGlobal(de.getDocument(), ve(Xt.up, TP), function() {
    ym && ym.feedbackOff();
  });
});
var b5 = "dxSimulatedScrollable", Gge = "dxScrollableStrategy", jb = b5 + "Cursor", kL = b5 + "Keyboard", PL = "dx-scrollable-simulated", Kge = "dx-scrollable-scrollbars-alwaysvisible", jge = "dx-scrollable-scrollbar", _u = "vertical", va = "horizontal", VT = 0.92, w5 = 0.5, T5 = 1, Yge = Math.round(1e3 / 60), qge = 40, Xge = 500, Qge = T5 / 5, Zge = 400, Jge = Zge / Yge, eme = (1 - Math.pow(VT, Jge)) / (1 - VT), Md = {
  PAGE_UP: "pageUp",
  PAGE_DOWN: "pageDown",
  END: "end",
  HOME: "home",
  LEFT: "leftArrow",
  UP: "upArrow",
  RIGHT: "rightArrow",
  DOWN: "downArrow",
  TAB: "tab"
}, I5 = x5.inherit({
  ctor: function(t) {
    this.callBase(), this.scroller = t;
  },
  VELOCITY_LIMIT: T5,
  _isFinished: function() {
    return Math.abs(this.scroller._velocity) <= this.VELOCITY_LIMIT;
  },
  _step: function() {
    this.scroller._scrollStep(this.scroller._velocity), this.scroller._velocity *= this._acceleration();
  },
  _acceleration: function() {
    return this.scroller._inBounds() ? VT : w5;
  },
  _complete: function() {
    this.scroller._scrollComplete();
  }
}), tme = I5.inherit({
  VELOCITY_LIMIT: Qge,
  _isFinished: function() {
    return this.scroller._crossBoundOnNextStep() || this.callBase();
  },
  _acceleration: function() {
    return VT;
  },
  _complete: function() {
    this.scroller._move(this.scroller._bounceLocation), this.callBase();
  }
}), D5 = wi.inherit({
  ctor: function(t) {
    this._initOptions(t), this._initAnimators(), this._initScrollbar();
  },
  _initOptions: function(t) {
    this._location = 0, this._topReached = !1, this._bottomReached = !1, this._axis = t.direction === va ? "x" : "y", this._prop = t.direction === va ? "left" : "top", this._dimension = t.direction === va ? "width" : "height", this._scrollProp = t.direction === va ? "scrollLeft" : "scrollTop", N(t, (e, i) => {
      this["_" + e] = i;
    });
  },
  _initAnimators: function() {
    this._inertiaAnimator = new I5(this), this._bounceAnimator = new tme(this);
  },
  _initScrollbar: function() {
    this._scrollbar = new E5(E("<div>").appendTo(this._$container), {
      direction: this._direction,
      visible: this._scrollByThumb,
      visibilityMode: this._visibilityModeNormalize(this._scrollbarVisible),
      expandable: this._scrollByThumb
    }), this._$scrollbar = this._scrollbar.$element();
  },
  _visibilityModeNormalize: function(t) {
    return t === !0 ? "onScroll" : t === !1 ? "never" : t;
  },
  _scrollStep: function(t) {
    var e = this._location;
    this._location += t, this._suppressBounce(), this._move(), !(Math.abs(e - this._location) < 1) && k.triggerHandler(this._$container, {
      type: "scroll"
    });
  },
  _suppressBounce: function() {
    this._bounceEnabled || this._inBounds(this._location) || (this._velocity = 0, this._location = this._boundLocation());
  },
  _boundLocation: function(t) {
    return t = t !== void 0 ? t : this._location, Math.max(Math.min(t, this._maxOffset), this._minOffset);
  },
  _move: function(t) {
    this._location = t !== void 0 ? t * this._getScaleRatio() : this._location, this._moveContent(), this._moveScrollbar();
  },
  _moveContent: function() {
    var t = this._location;
    this._$container[this._scrollProp](-t / this._getScaleRatio()), this._moveContentByTranslator(t);
  },
  _getScaleRatio: function() {
    if (wt() && !this._scaleRatio) {
      var t = this._$element.get(0), e = this._getRealDimension(t, this._dimension), i = this._getBaseDimension(t, this._dimension);
      this._scaleRatio = Math.round(e / i * 100) / 100;
    }
    return this._scaleRatio || 1;
  },
  _getRealDimension: function(t, e) {
    return Math.round(zr(t)[e]);
  },
  _getBaseDimension: function(t, e) {
    var i = "offset" + Dx(e);
    return t[i];
  },
  _moveContentByTranslator: function(t) {
    var e, i = -this._maxScrollPropValue;
    if (t > 0 ? e = t : t <= i ? e = t - i : e = t % 1, this._translateOffset !== e) {
      var r = {};
      if (r[this._prop] = e, this._translateOffset = e, e === 0) {
        xS(this._$content);
        return;
      }
      Nn(this._$content, r);
    }
  },
  _moveScrollbar: function() {
    this._scrollbar.moveTo(this._location);
  },
  _scrollComplete: function() {
    this._inBounds() && (this._hideScrollbar(), this._completeDeferred && this._completeDeferred.resolve()), this._scrollToBounds();
  },
  _scrollToBounds: function() {
    this._inBounds() || (this._bounceAction(), this._setupBounce(), this._bounceAnimator.start());
  },
  _setupBounce: function() {
    var t = this._bounceLocation = this._boundLocation(), e = t - this._location;
    this._velocity = e / eme;
  },
  _inBounds: function(t) {
    return t = t !== void 0 ? t : this._location, this._boundLocation(t) === t;
  },
  _crossBoundOnNextStep: function() {
    var t = this._location, e = t + this._velocity;
    return t < this._minOffset && e >= this._minOffset || t > this._maxOffset && e <= this._maxOffset;
  },
  _initHandler: function(t) {
    this._stopScrolling(), this._prepareThumbScrolling(t);
  },
  _stopScrolling: Sm(function() {
    this._hideScrollbar(), this._inertiaAnimator.stop(), this._bounceAnimator.stop();
  }),
  _prepareThumbScrolling: function(t) {
    if (!oo(t.originalEvent)) {
      var e = E(t.originalEvent.target), i = this._isScrollbar(e);
      i && this._moveToMouseLocation(t), this._thumbScrolling = i || this._isThumb(e), this._crossThumbScrolling = !this._thumbScrolling && this._isAnyThumbScrolling(e), this._thumbScrolling && this._scrollbar.feedbackOn();
    }
  },
  _isThumbScrollingHandler: function(t) {
    return this._isThumb(t);
  },
  _moveToMouseLocation: function(t) {
    var e = t["page" + this._axis.toUpperCase()] - this._$element.offset()[this._prop], i = this._location + e / this._containerToContentRatio() - Pt(this._$container) / 2;
    this._scrollStep(-Math.round(i));
  },
  _startHandler: function() {
    this._showScrollbar();
  },
  _moveHandler: function(t) {
    this._crossThumbScrolling || (this._thumbScrolling && (t[this._axis] = -Math.round(t[this._axis] / this._containerToContentRatio())), this._scrollBy(t));
  },
  _scrollBy: function(t) {
    t = t[this._axis], this._inBounds() || (t *= w5), this._scrollStep(t);
  },
  _scrollByHandler: function(t) {
    this._scrollBy(t), this._scrollComplete();
  },
  _containerToContentRatio: function() {
    return this._scrollbar.containerToContentRatio();
  },
  _endHandler: function(t) {
    return this._completeDeferred = new q(), this._velocity = t[this._axis], this._inertiaHandler(), this._resetThumbScrolling(), this._completeDeferred.promise();
  },
  _inertiaHandler: function() {
    this._suppressInertia(), this._inertiaAnimator.start();
  },
  _suppressInertia: function() {
    (!this._inertiaEnabled || this._thumbScrolling) && (this._velocity = 0);
  },
  _resetThumbScrolling: function() {
    this._thumbScrolling = !1, this._crossThumbScrolling = !1;
  },
  _stopHandler: function() {
    this._thumbScrolling && this._scrollComplete(), this._resetThumbScrolling(), this._scrollToBounds();
  },
  _disposeHandler: function() {
    this._stopScrolling(), this._$scrollbar.remove();
  },
  _updateHandler: function() {
    this._update(), this._moveToBounds();
  },
  _update: function() {
    return this._stopScrolling(), Na(() => {
      this._resetScaleRatio(), this._updateLocation(), this._updateBounds(), this._updateScrollbar(), dn(() => {
        this._moveScrollbar(), this._scrollbar.update();
      });
    });
  },
  _resetScaleRatio: function() {
    this._scaleRatio = null;
  },
  _updateLocation: function() {
    this._location = (zs(this._$content)[this._prop] - this._$container[this._scrollProp]()) * this._getScaleRatio();
  },
  _updateBounds: function() {
    this._maxOffset = this._getMaxOffset(), this._minOffset = this._getMinOffset();
  },
  _getMaxOffset: function() {
    return 0;
  },
  _getMinOffset: function() {
    return this._maxScrollPropValue = Math.max(this._contentSize() - this._containerSize(), 0), -this._maxScrollPropValue;
  },
  _updateScrollbar: t$(function() {
    var t = this._containerSize(), e = this._contentSize(), i = this._getBaseDimension(this._$container.get(0), this._dimension), r = this._getBaseDimension(this._$content.get(0), this._dimension);
    dn(() => {
      this._scrollbar.option({
        containerSize: t,
        contentSize: e,
        baseContainerSize: i,
        baseContentSize: r,
        scaleRatio: this._getScaleRatio()
      });
    });
  }),
  _moveToBounds: Sm(t$(Sm(function() {
    var t = this._boundLocation(), e = t !== this._location;
    this._location = t, this._move(), e && this._scrollAction();
  }))),
  _createActionsHandler: function(t) {
    this._scrollAction = t.scroll, this._bounceAction = t.bounce;
  },
  _showScrollbar: function() {
    this._scrollbar.option("visible", !0);
  },
  _hideScrollbar: function() {
    this._scrollbar.option("visible", !1);
  },
  _containerSize: function() {
    return this._getRealDimension(this._$container.get(0), this._dimension);
  },
  _contentSize: function() {
    var t = this._$content.css("overflow" + this._axis.toUpperCase()) === "hidden", e = this._getRealDimension(this._$content.get(0), this._dimension);
    if (!t) {
      var i = this._$content[0]["scroll" + Dx(this._dimension)] * this._getScaleRatio();
      e = Math.max(i, e);
    }
    return e;
  },
  _validateEvent: function(t) {
    var e = E(t.originalEvent.target);
    return this._isThumb(e) || this._isScrollbar(e);
  },
  _isThumb: function(t) {
    return this._scrollByThumb && this._scrollbar.isThumb(t);
  },
  _isScrollbar: function(t) {
    return this._scrollByThumb && t && t.is(this._$scrollbar);
  },
  _reachedMin: function() {
    return Math.round(this._location - this._minOffset) <= 0;
  },
  _reachedMax: function() {
    return Math.round(this._location - this._maxOffset) >= 0;
  },
  _cursorEnterHandler: function() {
    this._resetScaleRatio(), this._updateScrollbar(), this._scrollbar.cursorEnter();
  },
  _cursorLeaveHandler: function() {
    this._scrollbar.cursorLeave();
  },
  dispose: ee
}), Il, qg, A5 = wi.inherit({
  ctor: function(t) {
    this._init(t);
  },
  _init: function(t) {
    this._component = t, this._$element = t.$element(), this._$container = E(t.container()), this._$wrapper = t._$wrapper, this._$content = t.$content(), this.option = t.option.bind(t), this._createActionByOption = t._createActionByOption.bind(t), this._isLocked = t._isLocked.bind(t), this._isDirection = t._isDirection.bind(t), this._allowedDirection = t._allowedDirection.bind(t), this._getMaxOffset = t._getMaxOffset.bind(t);
  },
  render: function() {
    this._$element.addClass(PL), this._createScrollers(), this.option("useKeyboard") && this._$container.prop("tabIndex", 0), this._attachKeyboardHandler(), this._attachCursorHandlers();
  },
  _createScrollers: function() {
    this._scrollers = {}, this._isDirection(va) && this._createScroller(va), this._isDirection(_u) && this._createScroller(_u), this._$element.toggleClass(Kge, this.option("showScrollbar") === "always");
  },
  _createScroller: function(t) {
    this._scrollers[t] = new D5(this._scrollerOptions(t));
  },
  _scrollerOptions: function(t) {
    return {
      direction: t,
      $content: this._$content,
      $container: this._$container,
      $wrapper: this._$wrapper,
      $element: this._$element,
      scrollByThumb: this.option("scrollByThumb"),
      scrollbarVisible: this.option("showScrollbar"),
      bounceEnabled: this.option("bounceEnabled"),
      inertiaEnabled: this.option("inertiaEnabled"),
      isAnyThumbScrolling: this._isAnyThumbScrolling.bind(this)
    };
  },
  _applyScaleRatio: function(t) {
    for (var e in this._scrollers) {
      var i = this._getPropByDirection(e);
      if (R(t[i])) {
        var r = this._scrollers[e];
        t[i] *= r._getScaleRatio();
      }
    }
    return t;
  },
  _isAnyThumbScrolling: function(t) {
    var e = !1;
    return this._eventHandler("isThumbScrolling", t).done(function(i, r) {
      e = i || r;
    }), e;
  },
  handleInit: function(t) {
    this._suppressDirections(t), this._eventForUserAction = t, this._eventHandler("init", t);
  },
  _suppressDirections: function(t) {
    if (oo(t.originalEvent)) {
      this._prepareDirections(!0);
      return;
    }
    this._prepareDirections(), this._eachScroller(function(e, i) {
      var r = E(t.originalEvent.target), n = e._validateEvent(t) || this.option("scrollByContent") && this._isContent(r);
      this._validDirections[i] = n;
    });
  },
  _isContent: function(t) {
    return !!t.closest(this._$element).length;
  },
  _prepareDirections: function(t) {
    t = t || !1, this._validDirections = {}, this._validDirections[va] = t, this._validDirections[_u] = t;
  },
  _eachScroller: function(t) {
    t = t.bind(this), N(this._scrollers, function(e, i) {
      t(i, e);
    });
  },
  handleStart: function(t) {
    this._eventForUserAction = t, this._eventHandler("start").done(this._startAction);
  },
  _saveActive: function() {
    qg = this;
  },
  _resetActive: function() {
    qg === this && (qg = null);
  },
  handleMove: function(t) {
    if (this._isLocked()) {
      t.cancel = !0, this._resetActive();
      return;
    }
    this._saveActive(), t.preventDefault && t.preventDefault(), this._adjustDistance(t, t.delta), this._eventForUserAction = t, this._eventHandler("move", t.delta);
  },
  _adjustDistance: function(t, e) {
    e.x *= this._validDirections[va], e.y *= this._validDirections[_u];
    var i = this._tryGetDevicePixelRatio();
    i && oo(t.originalEvent) && (e.x = Math.round(e.x / i * 100) / 100, e.y = Math.round(e.y / i * 100) / 100);
  },
  _tryGetDevicePixelRatio: function() {
    if (wt())
      return Ot().devicePixelRatio;
  },
  handleEnd: function(t) {
    return this._resetActive(), this._refreshCursorState(t.originalEvent && t.originalEvent.target), this._adjustDistance(t, t.velocity), this._eventForUserAction = t, this._eventHandler("end", t.velocity).done(this._endAction);
  },
  handleCancel: function(t) {
    return this._resetActive(), this._eventForUserAction = t, this._eventHandler("end", {
      x: 0,
      y: 0
    });
  },
  handleStop: function() {
    this._resetActive(), this._eventHandler("stop");
  },
  handleScroll: function() {
    this._updateRtlConfig(), this._scrollAction();
  },
  _attachKeyboardHandler: function() {
    k.off(this._$element, ".".concat(kL)), !this.option("disabled") && this.option("useKeyboard") && k.on(this._$element, ve("keydown", kL), this._keyDownHandler.bind(this));
  },
  _keyDownHandler: function(t) {
    if (clearTimeout(this._updateHandlerTimeout), this._updateHandlerTimeout = setTimeout(() => {
      or(t) === Md.TAB && this._eachScroller((i) => {
        i._updateHandler();
      });
    }), !!this._$container.is(de.getActiveElement(this._$container.get(0)))) {
      var e = !0;
      switch (or(t)) {
        case Md.DOWN:
          this._scrollByLine({
            y: 1
          });
          break;
        case Md.UP:
          this._scrollByLine({
            y: -1
          });
          break;
        case Md.RIGHT:
          this._scrollByLine({
            x: 1
          });
          break;
        case Md.LEFT:
          this._scrollByLine({
            x: -1
          });
          break;
        case Md.PAGE_DOWN:
          this._scrollByPage(1);
          break;
        case Md.PAGE_UP:
          this._scrollByPage(-1);
          break;
        case Md.HOME:
          this._scrollToHome();
          break;
        case Md.END:
          this._scrollToEnd();
          break;
        default:
          e = !1;
      }
      e && (t.stopPropagation(), t.preventDefault());
    }
  },
  _scrollByLine: function(t) {
    var e = this._tryGetDevicePixelRatio(), i = qge;
    e && (i = Math.abs(i / e * 100) / 100), this.scrollBy({
      top: (t.y || 0) * -i,
      left: (t.x || 0) * -i
    });
  },
  _scrollByPage: function(t) {
    var e = this._wheelProp(), i = this._dimensionByProp(e), r = {}, n = i === "width" ? mt : Pt;
    r[e] = t * -n(this._$container), this.scrollBy(r);
  },
  _dimensionByProp: function(t) {
    return t === "left" ? "width" : "height";
  },
  _getPropByDirection: function(t) {
    return t === va ? "left" : "top";
  },
  _scrollToHome: function() {
    var t = this._wheelProp(), e = {};
    e[t] = 0, this._component.scrollTo(e);
  },
  _scrollToEnd: function() {
    var t = this._wheelProp(), e = this._dimensionByProp(t), i = {}, r = e === "width" ? mt : Pt;
    i[t] = r(this._$content) - r(this._$container), this._component.scrollTo(i);
  },
  createActions: function() {
    this._startAction = this._createActionHandler("onStart"), this._endAction = this._createActionHandler("onEnd"), this._updateAction = this._createActionHandler("onUpdated"), this._createScrollerActions();
  },
  _createScrollerActions: function() {
    this._scrollAction = this._createActionHandler("onScroll"), this._bounceAction = this._createActionHandler("onBounce"), this._eventHandler("createActions", {
      scroll: this._scrollAction,
      bounce: this._bounceAction
    });
  },
  _createActionHandler: function(t) {
    var e = this._createActionByOption(t);
    return () => {
      e(P(this._createActionArgs(), arguments));
    };
  },
  _createActionArgs: function() {
    var {
      horizontal: t,
      vertical: e
    } = this._scrollers, i = this._getScrollOffset();
    return this._scrollOffset = {
      top: e && i.top,
      left: t && i.left
    }, {
      event: this._eventForUserAction,
      scrollOffset: this._scrollOffset,
      reachedLeft: t && t._reachedMax(),
      reachedRight: t && t._reachedMin(),
      reachedTop: e && e._reachedMax(),
      reachedBottom: e && e._reachedMin()
    };
  },
  _getScrollOffset() {
    return {
      top: -this.location().top,
      left: -this.location().left
    };
  },
  _eventHandler: function(t) {
    var e = [].slice.call(arguments).slice(1), i = Jr(this._scrollers, (r) => r["_" + t + "Handler"].apply(r, e));
    return $e.apply(E, i).promise();
  },
  location: function() {
    var t = zs(this._$content);
    return t.top -= this._$container.scrollTop(), t.left -= this._$container.scrollLeft(), t;
  },
  disabledChanged: function() {
    this._attachCursorHandlers();
  },
  _attachCursorHandlers: function() {
    k.off(this._$element, ".".concat(jb)), !this.option("disabled") && this._isHoverMode() && (k.on(this._$element, ve("mouseenter", jb), this._cursorEnterHandler.bind(this)), k.on(this._$element, ve("mouseleave", jb), this._cursorLeaveHandler.bind(this)));
  },
  _isHoverMode: function() {
    return this.option("showScrollbar") === "onHover";
  },
  _cursorEnterHandler: function(t) {
    t = t || {}, t.originalEvent = t.originalEvent || {}, !(qg || t.originalEvent._hoverHandled) && (Il && Il._cursorLeaveHandler(), Il = this, this._eventHandler("cursorEnter"), t.originalEvent._hoverHandled = !0);
  },
  _cursorLeaveHandler: function(t) {
    Il !== this || qg === Il || (this._eventHandler("cursorLeave"), Il = null, this._refreshCursorState(t && t.relatedTarget));
  },
  _refreshCursorState: function(t) {
    if (!(!this._isHoverMode() && (!t || qg))) {
      var e = E(t), i = e.closest(".".concat(PL, ":not(.dx-state-disabled)")), r = i.length && i.data(Gge);
      Il && Il !== r && Il._cursorLeaveHandler(), r && r._cursorEnterHandler();
    }
  },
  update: function() {
    var t = this._eventHandler("update").done(this._updateAction);
    return $e(t, Na(() => {
      var e = this._allowedDirections();
      return dn(() => {
        var i = e.vertical ? "pan-x" : "";
        i = e.horizontal ? "pan-y" : i, i = e.vertical && e.horizontal ? "none" : i, this._$container.css("touchAction", i);
      }), $e().promise();
    }));
  },
  _allowedDirections: function() {
    var t = this.option("bounceEnabled"), e = this._scrollers[_u], i = this._scrollers[va];
    return {
      vertical: e && (e._minOffset < 0 || t),
      horizontal: i && (i._minOffset < 0 || t)
    };
  },
  _updateBounds: function() {
    this._scrollers[va] && this._scrollers[va]._updateBounds();
  },
  _isHorizontalAndRtlEnabled: function() {
    return this.option("rtlEnabled") && this.option("direction") !== _u;
  },
  updateRtlPosition: function(t) {
    if (t && (this._rtlConfig = {
      scrollRight: 0,
      clientWidth: this._$container.get(0).clientWidth,
      windowPixelRatio: this._getWindowDevicePixelRatio()
    }), this._updateBounds(), this._isHorizontalAndRtlEnabled()) {
      var e = this._getMaxOffset().left - this._rtlConfig.scrollRight;
      e <= 0 && (e = 0, this._rtlConfig.scrollRight = this._getMaxOffset().left), this._getScrollOffset().left !== e && (this._rtlConfig.skipUpdating = !0, this._component.scrollTo({
        left: e
      }), this._rtlConfig.skipUpdating = !1);
    }
  },
  _updateRtlConfig: function() {
    if (this._isHorizontalAndRtlEnabled() && !this._rtlConfig.skipUpdating) {
      var {
        clientWidth: t,
        scrollLeft: e
      } = this._$container.get(0), i = this._getWindowDevicePixelRatio();
      this._rtlConfig.windowPixelRatio === i && this._rtlConfig.clientWidth === t && (this._rtlConfig.scrollRight = this._getMaxOffset().left - e), this._rtlConfig.clientWidth = t, this._rtlConfig.windowPixelRatio = i;
    }
  },
  _getWindowDevicePixelRatio: function() {
    return wt() ? Ot().devicePixelRatio : 1;
  },
  scrollBy: function(t) {
    var e = this._scrollers[_u], i = this._scrollers[va];
    e && (t.top = e._boundLocation(t.top + e._location) - e._location), i && (t.left = i._boundLocation(t.left + i._location) - i._location), this._prepareDirections(!0), this._startAction(), this._eventHandler("scrollBy", {
      x: t.left,
      y: t.top
    }), this._endAction(), this._updateRtlConfig();
  },
  validate: function(t) {
    return oo(t) && Cn(t) || this.option("disabled") ? !1 : this.option("bounceEnabled") ? !0 : oo(t) ? this._validateWheel(t) : this._validateMove(t);
  },
  _validateWheel: function(t) {
    var e = this._scrollers[this._wheelDirection(t)], i = e._reachedMin(), r = e._reachedMax(), n = !i || !r, a = !i && !r, o = i && t.delta > 0, u = r && t.delta < 0, c = n && (a || o || u);
    return c = c || this._validateWheelTimer !== void 0, c && (clearTimeout(this._validateWheelTimer), this._validateWheelTimer = setTimeout(() => {
      this._validateWheelTimer = void 0;
    }, Xge)), c;
  },
  _validateMove: function(t) {
    return !this.option("scrollByContent") && !E(t.target).closest(".".concat(jge)).length ? !1 : this._allowedDirection();
  },
  getDirection: function(t) {
    return oo(t) ? this._wheelDirection(t) : this._allowedDirection();
  },
  _wheelProp: function() {
    return this._wheelDirection() === va ? "left" : "top";
  },
  _wheelDirection: function(t) {
    switch (this.option("direction")) {
      case va:
        return va;
      case _u:
        return _u;
      default:
        return t && t.shiftKey ? va : _u;
    }
  },
  dispose: function() {
    this._resetActive(), Il === this && (Il = null), this._eventHandler("dispose"), this._detachEventHandlers(), this._$element.removeClass(PL), this._eventForUserAction = null, clearTimeout(this._validateWheelTimer), clearTimeout(this._updateHandlerTimeout);
  },
  _detachEventHandlers: function() {
    k.off(this._$element, ".".concat(jb)), k.off(this._$container, ".".concat(kL));
  }
}), DU = "dxNativeScrollable", FL = "dx-scrollable-native", ime = "dx-scrollable-scrollbar-simulated", rme = "dx-scrollable-scrollbars-hidden", by = "vertical", Yb = "horizontal", nme = 500, SB = wi.inherit({
  ctor: function(t) {
    this._init(t);
  },
  _init: function(t) {
    this._component = t, this._$element = t.$element(), this._$container = E(t.container()), this._$content = t.$content(), this._direction = t.option("direction"), this._useSimulatedScrollbar = t.option("useSimulatedScrollbar"), this.option = t.option.bind(t), this._createActionByOption = t._createActionByOption.bind(t), this._isLocked = t._isLocked.bind(t), this._isDirection = t._isDirection.bind(t), this._allowedDirection = t._allowedDirection.bind(t), this._getMaxOffset = t._getMaxOffset.bind(t), this._isRtlNativeStrategy = t._isRtlNativeStrategy.bind(t);
  },
  render: function() {
    var t = Ye.real(), e = t.platform;
    this._$element.addClass(FL).addClass(FL + "-" + e).toggleClass(rme, !this._isScrollbarVisible()), this._isScrollbarVisible() && this._useSimulatedScrollbar && this._renderScrollbars();
  },
  updateRtlPosition: function(t) {
    t && this.option("rtlEnabled") && this._isScrollbarVisible() && this._useSimulatedScrollbar && this._moveScrollbars();
  },
  _renderScrollbars: function() {
    this._scrollbars = {}, this._hideScrollbarTimeout = 0, this._$element.addClass(ime), this._renderScrollbar(by), this._renderScrollbar(Yb);
  },
  _renderScrollbar: function(t) {
    this._isDirection(t) && (this._scrollbars[t] = new E5(E("<div>").appendTo(this._$element), {
      direction: t,
      expandable: this._component.option("scrollByThumb")
    }));
  },
  handleInit: ee,
  handleStart: ee,
  handleMove: function(t) {
    if (this._isLocked()) {
      t.cancel = !0;
      return;
    }
    this._allowedDirection() && (t.originalEvent.isScrollingEvent = !0);
  },
  handleEnd: ee,
  handleCancel: ee,
  handleStop: ee,
  _eachScrollbar: function(t) {
    t = t.bind(this), N(this._scrollbars || {}, function(e, i) {
      t(i, e);
    });
  },
  createActions: function() {
    this._scrollAction = this._createActionByOption("onScroll"), this._updateAction = this._createActionByOption("onUpdated");
  },
  _createActionArgs: function() {
    var {
      left: t,
      top: e
    } = this.location();
    return {
      event: this._eventForUserAction,
      scrollOffset: this._getScrollOffset(),
      reachedLeft: this._isRtlNativeStrategy() ? this._isReachedRight(-t) : this._isReachedLeft(t),
      reachedRight: this._isRtlNativeStrategy() ? this._isReachedLeft(-Math.abs(t)) : this._isReachedRight(t),
      reachedTop: this._isDirection(by) ? Math.round(e) >= 0 : void 0,
      reachedBottom: this._isDirection(by) ? Math.round(Math.abs(e) - this._getMaxOffset().top) >= 0 : void 0
    };
  },
  _getScrollOffset: function() {
    var {
      top: t,
      left: e
    } = this.location();
    return {
      top: -t,
      left: this._normalizeOffsetLeft(-e)
    };
  },
  _normalizeOffsetLeft(t) {
    return this._isRtlNativeStrategy() ? this._getMaxOffset().left + t : t;
  },
  _isReachedLeft: function(t) {
    return this._isDirection(Yb) ? Math.round(t) >= 0 : void 0;
  },
  _isReachedRight: function(t) {
    return this._isDirection(Yb) ? Math.round(Math.abs(t) - this._getMaxOffset().left) >= 0 : void 0;
  },
  _isScrollbarVisible: function() {
    var {
      showScrollbar: t
    } = this.option();
    return t !== "never" && t !== !1;
  },
  handleScroll: function(t) {
    this._eventForUserAction = t, this._moveScrollbars(), this._scrollAction(this._createActionArgs());
  },
  _moveScrollbars: function() {
    var {
      top: t,
      left: e
    } = this._getScrollOffset();
    this._eachScrollbar(function(i) {
      i.moveTo({
        top: -t,
        left: -e
      }), i.option("visible", !0);
    }), this._hideScrollbars();
  },
  _hideScrollbars: function() {
    clearTimeout(this._hideScrollbarTimeout), this._hideScrollbarTimeout = setTimeout((function() {
      this._eachScrollbar(function(t) {
        t.option("visible", !1);
      });
    }).bind(this), nme);
  },
  location: function() {
    return {
      left: -this._$container.scrollLeft(),
      top: -this._$container.scrollTop()
    };
  },
  disabledChanged: ee,
  update: function() {
    this._update(), this._updateAction(this._createActionArgs());
  },
  _update: function() {
    this._updateDimensions(), this._updateScrollbars();
  },
  _updateDimensions: function() {
    this._containerSize = {
      height: Pt(this._$container),
      width: mt(this._$container)
    }, this._componentContentSize = {
      height: Pt(this._component.$content()),
      width: mt(this._component.$content())
    }, this._contentSize = {
      height: Pt(this._$content),
      width: mt(this._$content)
    };
  },
  _updateScrollbars: function() {
    this._eachScrollbar(function(t, e) {
      var i = e === by ? "height" : "width";
      t.option({
        containerSize: this._containerSize[i],
        contentSize: this._componentContentSize[i]
      }), t.update();
    });
  },
  _allowedDirections: function() {
    return {
      vertical: this._isDirection(by) && this._contentSize.height > this._containerSize.height,
      horizontal: this._isDirection(Yb) && this._contentSize.width > this._containerSize.width
    };
  },
  dispose: function() {
    var t = this._$element.get(0).className, e = new RegExp(FL + "\\S*", "g");
    e.test(t) && this._$element.removeClass(t.match(e).join(" ")), k.off(this._$element, "." + DU), k.off(this._$container, "." + DU), this._removeScrollbars(), clearTimeout(this._hideScrollbarTimeout);
  },
  _removeScrollbars: function() {
    this._eachScrollbar(function(t) {
      t.$element().remove();
    });
  },
  scrollBy: function(t) {
    var e = this.location();
    this._$container.scrollTop(Math.round(-e.top - t.top)), this._$container.scrollLeft(Math.round(-e.left - t.left));
  },
  validate: function(t) {
    return this.option("disabled") || oo(t) && this._isScrolledInMaxDirection(t) ? !1 : !!this._allowedDirection();
  },
  _isScrolledInMaxDirection(t) {
    var e = this._$container.get(0), i;
    return t.delta > 0 ? i = t.shiftKey ? !e.scrollLeft : !e.scrollTop : t.shiftKey ? i = e.scrollLeft >= this._getMaxOffset().left : i = e.scrollTop >= this._getMaxOffset().top, i;
  },
  getDirection: function() {
    return this._allowedDirection();
  }
}), O5 = function() {
  return [{
    device: function() {
      return !Dp;
    },
    options: {
      useNative: !1
    }
  }, {
    device: function(t) {
      return !Ye.isSimulator() && Ye.real().deviceType === "desktop" && t.platform === "generic";
    },
    options: {
      bounceEnabled: !1,
      scrollByThumb: !0,
      scrollByContent: Ip,
      showScrollbar: "onHover"
    }
  }];
};
function R5(t, e) {
  for (var i = {
    left: 0,
    top: 0
  }, r = e; (n = r) !== null && n !== void 0 && n.offsetParent && !r.classList.contains(t); ) {
    var n, a = r.offsetParent, o = r.getBoundingClientRect(), u = a.getBoundingClientRect();
    i.left += o.left - u.left, i.top += o.top - u.top, r = r.offsetParent;
  }
  return i;
}
var NT = "vertical", L5 = "horizontal", BL = "both";
var M5 = "dx-scrollable-content";
function ame(t, e, i, r, n) {
  var a = ae({
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }, n), o = e === NT, u = o ? "top" : "left", c = o ? "bottom" : "right", p = o ? "height" : "width", v = i["offset".concat(Dx(p))], _ = i["client".concat(Dx(p))], y = i.getBoundingClientRect()[p], b = t.getBoundingClientRect()[p], I = 1;
  Math.abs(y - v) > 1 && (I = y / v);
  var A = R5(M5, t)[u] / I, L = r[u], B = L - A + a[u], $ = L - A - b / I + _ - a[c];
  return B <= 0 && $ >= 0 ? L : L - (Math.abs(B) > Math.abs($) ? $ : B);
}
var Su = "dxScrollable", ome = "dxScrollableStrategy", AU = "dx-scrollable", sme = "dx-scrollable-disabled", lme = "dx-scrollable-container", ume = "dx-scrollable-wrapper", OU = "dx-scrollable-content", Cu = "vertical", kd = "horizontal", VL = "both", ds = Nu.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      disabled: !1,
      onScroll: null,
      direction: Cu,
      showScrollbar: "onScroll",
      useNative: !0,
      bounceEnabled: !0,
      scrollByContent: !0,
      scrollByThumb: !1,
      onUpdated: null,
      onStart: null,
      onEnd: null,
      onBounce: null,
      useSimulatedScrollbar: !1,
      useKeyboard: !0,
      inertiaEnabled: !0,
      updateManually: !1
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat(O5(), [{
      device: function() {
        return Dp && Ye.real().platform === "android" && !$i.mozilla;
      },
      options: {
        useSimulatedScrollbar: !0
      }
    }]);
  },
  _initOptions: function(t) {
    this.callBase(t), "useSimulatedScrollbar" in t || this._setUseSimulatedScrollbar();
  },
  _setUseSimulatedScrollbar: function() {
    this.initialOption("useSimulatedScrollbar") || this.option("useSimulatedScrollbar", !this.option("useNative"));
  },
  _init: function() {
    this.callBase(), this._initScrollableMarkup(), this._locked = !1;
  },
  _visibilityChanged: function(t) {
    t ? (this.update(), this._updateRtlPosition(), this._savedScrollOffset && this.scrollTo(this._savedScrollOffset), delete this._savedScrollOffset) : this._savedScrollOffset = this.scrollOffset();
  },
  _initScrollableMarkup: function() {
    var t = this.$element().addClass(AU), e = this._$container = E("<div>").addClass(lme), i = this._$wrapper = E("<div>").addClass(ume), r = this._$content = E("<div>").addClass(OU);
    r.append(t.contents()).appendTo(e), e.appendTo(i), i.appendTo(t);
  },
  _dimensionChanged: function() {
    this.update(), this._updateRtlPosition();
  },
  _initMarkup: function() {
    this.callBase(), this._renderDirection();
  },
  _render: function() {
    this._renderStrategy(), this._attachEventHandlers(), this._renderDisabledState(), this._createActions(), this.update(), this.callBase(), this._updateRtlPosition(!0);
  },
  _updateRtlPosition: function(t) {
    this._strategy.updateRtlPosition(t);
  },
  _getMaxOffset: function() {
    var {
      scrollWidth: t,
      clientWidth: e,
      scrollHeight: i,
      clientHeight: r
    } = E(this.container()).get(0);
    return {
      left: t - e,
      top: i - r
    };
  },
  _attachEventHandlers: function() {
    var t = this._strategy, e = {
      getDirection: t.getDirection.bind(t),
      validate: this._validate.bind(this),
      isNative: this.option("useNative"),
      scrollTarget: this._$container
    };
    k.off(this._$wrapper, "." + Su), k.on(this._$wrapper, ve(ss.init, Su), e, this._initHandler.bind(this)), k.on(this._$wrapper, ve(ss.start, Su), t.handleStart.bind(t)), k.on(this._$wrapper, ve(ss.move, Su), t.handleMove.bind(t)), k.on(this._$wrapper, ve(ss.end, Su), t.handleEnd.bind(t)), k.on(this._$wrapper, ve(ss.cancel, Su), t.handleCancel.bind(t)), k.on(this._$wrapper, ve(ss.stop, Su), t.handleStop.bind(t)), k.off(this._$container, "." + Su), k.on(this._$container, ve("scroll", Su), t.handleScroll.bind(t));
  },
  _validate: function(t) {
    return this._isLocked() ? !1 : (this._updateIfNeed(), this._moveIsAllowed(t));
  },
  _moveIsAllowed(t) {
    return this._strategy.validate(t);
  },
  handleMove(t) {
    this._strategy.handleMove(t);
  },
  _prepareDirections(t) {
    this._strategy._prepareDirections(t);
  },
  _initHandler: function() {
    var t = this._strategy;
    t.handleInit.apply(t, arguments);
  },
  _renderDisabledState: function() {
    this.$element().toggleClass(sme, this.option("disabled")), this.option("disabled") ? this._lock() : this._unlock();
  },
  _renderDirection: function() {
    this.$element().removeClass("dx-scrollable-" + kd).removeClass("dx-scrollable-" + Cu).removeClass("dx-scrollable-" + VL).addClass("dx-scrollable-" + this.option("direction"));
  },
  _renderStrategy: function() {
    this._createStrategy(), this._strategy.render(), this.$element().data(ome, this._strategy);
  },
  _createStrategy: function() {
    this._strategy = this.option("useNative") ? new SB(this) : new A5(this);
  },
  _createActions: function() {
    this._strategy && this._strategy.createActions();
  },
  _clean: function() {
    this._strategy && this._strategy.dispose();
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "onStart":
      case "onEnd":
      case "onUpdated":
      case "onScroll":
      case "onBounce":
        this._createActions();
        break;
      case "direction":
        this._resetInactiveDirection(), this._invalidate();
        break;
      case "useNative":
        this._setUseSimulatedScrollbar(), this._invalidate();
        break;
      case "inertiaEnabled":
      case "scrollByThumb":
      case "bounceEnabled":
      case "useKeyboard":
      case "showScrollbar":
      case "useSimulatedScrollbar":
        this._invalidate();
        break;
      case "disabled":
        this._renderDisabledState(), this._strategy && this._strategy.disabledChanged();
        break;
      case "updateManually":
      case "scrollByContent":
        break;
      case "width":
        this.callBase(t), this._updateRtlPosition();
        break;
      default:
        this.callBase(t);
    }
  },
  _resetInactiveDirection: function() {
    var t = this._getInactiveProp();
    if (!(!t || !wt())) {
      var e = this.scrollOffset();
      e[t] = 0, this.scrollTo(e);
    }
  },
  _getInactiveProp: function() {
    var t = this.option("direction");
    if (t === Cu)
      return "left";
    if (t === kd)
      return "top";
  },
  _location: function() {
    return this._strategy.location();
  },
  _normalizeLocation: function(t) {
    if ($t(t)) {
      var e = cr(t.left, t.x), i = cr(t.top, t.y);
      return {
        left: R(e) ? -e : void 0,
        top: R(i) ? -i : void 0
      };
    } else {
      var r = this.option("direction");
      return {
        left: r !== Cu ? -t : void 0,
        top: r !== kd ? -t : void 0
      };
    }
  },
  _isLocked: function() {
    return this._locked;
  },
  _lock: function() {
    this._locked = !0;
  },
  _unlock: function() {
    this.option("disabled") || (this._locked = !1);
  },
  _isDirection: function(t) {
    var e = this.option("direction");
    return t === Cu ? e !== kd : t === kd ? e !== Cu : e === t;
  },
  _updateAllowedDirection: function() {
    var t = this._strategy._allowedDirections();
    this._isDirection(VL) && t.vertical && t.horizontal ? this._allowedDirectionValue = VL : this._isDirection(kd) && t.horizontal ? this._allowedDirectionValue = kd : this._isDirection(Cu) && t.vertical ? this._allowedDirectionValue = Cu : this._allowedDirectionValue = null;
  },
  _allowedDirection: function() {
    return this._allowedDirectionValue;
  },
  $content: function() {
    return this._$content;
  },
  content: function() {
    return ot(this._$content);
  },
  container: function() {
    return ot(this._$container);
  },
  scrollOffset: function() {
    return this._strategy._getScrollOffset();
  },
  _isRtlNativeStrategy: function() {
    var {
      useNative: t,
      rtlEnabled: e
    } = this.option();
    return t && e;
  },
  scrollTop: function() {
    return this.scrollOffset().top;
  },
  scrollLeft: function() {
    return this.scrollOffset().left;
  },
  clientHeight: function() {
    return Pt(this._$container);
  },
  scrollHeight: function() {
    return jt(this.$content());
  },
  clientWidth: function() {
    return mt(this._$container);
  },
  scrollWidth: function() {
    return oi(this.$content());
  },
  update: function() {
    if (this._strategy)
      return $e(this._strategy.update()).done((function() {
        this._updateAllowedDirection();
      }).bind(this));
  },
  scrollBy: function(t) {
    t = this._normalizeLocation(t), !(!t.top && !t.left) && (this._updateIfNeed(), this._strategy.scrollBy(t));
  },
  scrollTo: function(t) {
    t = this._normalizeLocation(t), this._updateIfNeed();
    var e = this._location();
    this.option("useNative") || (t = this._strategy._applyScaleRatio(t), e = this._strategy._applyScaleRatio(e)), this._isRtlNativeStrategy() && (e.left = e.left - this._getMaxOffset().left);
    var i = this._normalizeLocation({
      left: e.left - cr(t.left, e.left),
      top: e.top - cr(t.top, e.top)
    });
    !i.top && !i.left || this._strategy.scrollBy(i);
  },
  scrollToElement: function(t, e) {
    var i = E(t), r = this.$content().find(t).length, n = i.parents("." + AU).length - i.parents("." + OU).length === 0;
    if (!(!r || !n)) {
      var a = {
        top: 0,
        left: 0
      }, o = this.option("direction");
      o !== Cu && (a.left = this.getScrollElementPosition(i, kd, e)), o !== kd && (a.top = this.getScrollElementPosition(i, Cu, e)), this.scrollTo(a);
    }
  },
  getScrollElementPosition: function(t, e, i) {
    var r = this.scrollOffset();
    return ame(t.get(0), e, E(this.container()).get(0), r, i);
  },
  _updateIfNeed: function() {
    this.option("updateManually") || this.update();
  },
  _useTemplates: function() {
    return !1;
  },
  isRenovated: function() {
    return !!ds.IS_RENOVATED_WIDGET;
  }
});
ti(Su, ds);
var dme = "rowsview", cme = "content", hme = "nowrap", NL = "dx-group-row", RU = "dx-group-cell", fme = "dx-data-row", qb = "dx-freespace-row", pme = "dx-row-lines", LU = "dx-column-lines", MU = "dx-row-alt", kU = "dx-last-row-border", vme = "dx-empty", gme = "row-inserted-animation", mme = 200;
function PU(t) {
  return t ? Math.round(t.scrollWidth() - t.clientWidth()) : 0;
}
function FU(t) {
  var {
    rowType: e,
    column: i
  } = t;
  return e === "group" && R(i.groupIndex) && !i.showWhenGrouped && !i.command;
}
function BU(t) {
  var {
    element: e,
    watch: i,
    getter: r,
    callBack: n
  } = t;
  if (i) {
    var a = i(r, n);
    k.on(e, fo, a);
  }
}
var _me = function(t, e) {
  var i = Pw(e.text) && e.rowType === "data", {
    text: r
  } = e, n = t.get(0);
  i ? xe.setEmptyText(t) : e.column.encodeHtml ? n.textContent = r : n.innerHTML = r;
}, Cme = function(t) {
  var e = t.getScrollable();
  return e ? Math.ceil(parseFloat(E(e.content()).css("paddingBottom"))) : 0;
};
let yme = class extends SS {
  init() {
    super.init(), this._editingController = this.getController("editing"), this._resizingController = this.getController("resizing"), this._columnsResizerController = this.getController("columnsResizer"), this._focusController = this.getController("focus"), this._keyboardNavigationController = this.getController("keyboardNavigation"), this._validatingController = this.getController("validating"), this._errorHandlingController = this.getController("errorHandling"), this._columnHeadersView = this.getView("columnHeadersView"), this._rowHeight = 0, this._scrollTop = 0, this._scrollLeft = -1, this._scrollRight = 0, this._hasHeight = void 0, this._contentChanges = [], this._dataController.loadingChanged.add((e, i) => {
      this.setLoading(e, i);
    }), this._dataController.dataSourceChanged.add(() => {
      this._scrollLeft >= 0 && !this._dataController.isLoading() && this._handleScroll({
        component: this.getScrollable(),
        forceUpdateScrollPosition: !0,
        scrollOffset: {
          top: this._scrollTop,
          left: this._scrollLeft
        }
      });
    });
  }
  _getDefaultTemplate(e) {
    switch (e.command) {
      case "empty":
        return function(i) {
          i.html("&nbsp;");
        };
      default:
        return _me;
    }
  }
  _getDefaultGroupTemplate(e) {
    var i = this.option("summary.texts");
    return function(r, n) {
      var {
        data: a
      } = n, o = "".concat(n.column.caption, ": ").concat(n.text), u = r.get(0);
      n.summaryItems && n.summaryItems.length && (o += " ".concat(xe.getGroupRowSummaryText(n.summaryItems, i))), a && (n.groupContinuedMessage && n.groupContinuesMessage ? o += " (".concat(n.groupContinuedMessage, ". ").concat(n.groupContinuesMessage, ")") : n.groupContinuesMessage ? o += " (".concat(n.groupContinuesMessage, ")") : n.groupContinuedMessage && (o += " (".concat(n.groupContinuedMessage, ")"))), e.encodeHtml ? u.textContent = o : u.innerHTML = o;
    };
  }
  _update(e) {
  }
  _updateCell(e, i) {
    FU(i) && e.addClass(RU), super._updateCell.apply(this, arguments);
  }
  _getCellTemplate(e) {
    var {
      column: i
    } = e, r;
    return FU(e) ? r = i.groupCellTemplate || {
      allowRenderToDetachedContainer: !0,
      render: this._getDefaultGroupTemplate(i)
    } : (e.rowType === "data" || i.command) && i.cellTemplate ? r = i.cellTemplate : r = {
      allowRenderToDetachedContainer: !0,
      render: this._getDefaultTemplate(i)
    }, r;
  }
  _createRow(e, i) {
    var r = super._createRow.apply(this, arguments);
    if (e) {
      var n = e.rowType === "group", a = e.rowType === "data";
      a && r.addClass(fme), a && this.option("showRowLines") && r.addClass(pme), this.option("showColumnLines") && r.addClass(LU), e.visible === !1 && r.hide(), n && (r.addClass(NL), this.setAriaExpandedAttribute(r, e));
    }
    return r;
  }
  _rowPrepared(e, i, r) {
    i.rowType === "data" && (this.option("rowAlternationEnabled") && (this._isAltRow(r) && e.addClass(MU), BU({
      element: e.get(0),
      watch: i.watch,
      getter: () => this._isAltRow(r),
      callBack: (n) => {
        e.toggleClass(MU, n);
      }
    })), this._setAriaRowIndex(i, e), BU({
      element: e.get(0),
      watch: i.watch,
      getter: () => i.rowIndex,
      callBack: () => this._setAriaRowIndex(i, e)
    })), super._rowPrepared.apply(this, arguments);
  }
  _setAriaRowIndex(e, i) {
    if (i.is("tr")) {
      var {
        component: r
      } = this, n = r.option("scrolling.mode") === "standard" && !xe.isVirtualRowRendering(r), a = e.rowIndex + 1;
      n ? a = r.pageIndex() * r.pageSize() + a : a += this._dataController.getRowIndexOffset(), this.setAria("rowindex", a, i);
    }
  }
  setAriaExpandedAttribute(e, i) {
    var r = i.isExpanded ? this.localize("dxDataGrid-ariaExpandedRow") : this.localize("dxDataGrid-ariaCollapsedRow");
    this.setAria("roledescription", r, e);
  }
  _afterRowPrepared(e) {
    var i = e.args[0], r = this._dataController, n = r.getVisibleRows()[i.rowIndex], a = this.option("integrationOptions.watchMethod");
    if (!(!i.data || i.rowType !== "data" || i.isNewRow || !this.option("twoWayBindingEnabled") || !a || !n)) {
      var o = a(() => r.generateDataValues(i.data, i.columns), () => {
        r.repaintRows([n.rowIndex], this.option("repaintChangesOnly"));
      }, {
        deep: !0,
        skipImmediate: !0
      });
      k.on(i.rowElement, fo, o);
    }
  }
  _renderScrollable(e) {
    var i = this.element();
    if (i.children().length || i.append("<div>"), (e || !this._loadPanel) && this._renderLoadPanel(i, i.parent(), this._dataController.isLocalStore()), (e || !this.getScrollable()) && this._dataController.isLoaded()) {
      for (var r = this.getColumns(), n = !0, a = 0; a < r.length; a++)
        if (!r[a].width && !r[a].minWidth) {
          n = !1;
          break;
        }
      (this.option("columnAutoWidth") || this._hasHeight || n || this._columnsController._isColumnFixing()) && this._renderScrollableCore(i);
    }
  }
  _handleScroll(e) {
    var i = this.option("rtlEnabled"), r = e.component.option("useNative");
    this._scrollTop = e.scrollOffset.top, this._scrollLeft = e.scrollOffset.left;
    var n = e.scrollOffset.left;
    i && (this._scrollRight = PU(e.component) - this._scrollLeft, r && (n = -this._scrollRight), this.isScrollbarVisible(!0) || (this._scrollLeft = -1)), this.scrollChanged.fire(ae(ae({}, e.scrollOffset), {
      left: n
    }), this.name);
  }
  _renderScrollableCore(e) {
    var i = this._createScrollableOptions(), r = this._handleScroll.bind(this);
    i.onScroll = r, this._scrollable = this._createComponent(e, ds, i), this._scrollableContainer = this._scrollable && E(this._scrollable.container());
  }
  _renderLoadPanel() {
    for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++)
      i[r] = arguments[r];
    return xe.renderLoadPanel.apply(this, arguments);
  }
  _renderContent(e, i, r) {
    return e.empty().append(i), this._findContentElement();
  }
  _updateContent(e, i, r) {
    return this._contentChanges.push({
      newTableElement: e,
      change: i,
      isFixedTableRendering: r
    }), this.waitAsyncTemplates().done(() => {
      var n = this._contentChanges;
      this._contentChanges = [], n.forEach((a) => {
        var {
          newTableElement: o,
          change: u,
          isFixedTableRendering: c
        } = a, p = this.getTableElement(c), v = this._findContentElement(c), _ = u == null ? void 0 : u.changeType, y = [], b = this.option("highlightChanges"), I = this.addWidgetPrefix(gme);
        switch (_) {
          case "update":
            N(u.rowIndices, (A, L) => {
              var B, $ = this._getRowElements(o).eq(A), K = (B = u.changeTypes) === null || B === void 0 ? void 0 : B[A], te = u.items && u.items[A];
              y.push(() => {
                var z, ie = this._getRowElements(p), pe = ie.eq(L);
                switch (K) {
                  case "update":
                    if (te) {
                      var _e = (z = u.columnIndices) === null || z === void 0 ? void 0 : z[A];
                      R(te.visible) && te.visible !== pe.is(":visible") ? pe.toggle(te.visible) : _e ? this._updateCells(pe, $, _e) : pe.replaceWith($);
                    }
                    break;
                  case "insert":
                    if (ie.length)
                      pe.length ? $.insertBefore(pe) : $.insertAfter(ie.last());
                    else if (p) {
                      var be = $.is("tbody") ? p : p.children("tbody");
                      $.prependTo(be);
                    }
                    b && u.isLiveUpdate && $.addClass(I);
                    break;
                  case "remove":
                    pe.remove();
                }
              });
            }), N(y, function() {
              this();
            }), o.remove();
            break;
          default:
            this.setTableElement(o, c), v.addClass(this.addWidgetPrefix(cme)), this._setGridRole(v), this._renderContent(v, o, c);
        }
      });
    }).fail(() => {
      this._contentChanges = [];
    });
  }
  _getGridRoleName() {
    return "grid";
  }
  _setGridRole(e) {
    var i, r = !(!((i = this._dataController) === null || i === void 0) && i.isEmpty()), n = this._getGridRoleName();
    e != null && e.length && r && this.setAria("role", n, e);
  }
  _createEmptyRow(e, i, r) {
    var n, a = this._createRow(), o = i ? this.getFixedColumns() : this.getColumns();
    a.addClass(e).toggleClass(LU, this.option("showColumnLines"));
    for (var u = 0; u < o.length; u++)
      n = this._createCell({
        column: o[u],
        rowType: "freeSpace",
        columnIndex: u,
        columns: o
      }), Di(r) && n.css("height", r), a.append(n);
    return this.setAria("role", "presentation", a), a;
  }
  getFixedColumns() {
    throw new Error("Method not implemented.");
  }
  _appendEmptyRow(e, i, r) {
    var n = this._getBodies(e), a = !n.length || i.is("tbody"), o = a ? e : n;
    if (r === "top") {
      if (o.first().prepend(i), a) {
        var u = o.children("colgroup");
        o.prepend(u);
      }
    } else
      o.last().append(i);
  }
  _renderFreeSpaceRow(e, i) {
    var r = this._createEmptyRow(qb);
    r = this._wrapRowIfNeed(e, r, (i == null ? void 0 : i.changeType) === "refresh"), this._appendEmptyRow(e, r);
  }
  _checkRowKeys(e) {
    var i = this, r = i._getRows(e), n = i._dataController.store() && i._dataController.store().key();
    n && r.some((a) => {
      if (a.rowType === "data" && a.key === void 0)
        return i._dataController.fireError("E1046", n), !0;
    });
  }
  _needUpdateRowHeight(e) {
    return e > 0 && !this._rowHeight;
  }
  _getRowsHeight(e) {
    e = e || this._tableElement;
    var i = e.children("tbody").children().not(".dx-virtual-row").not(".".concat(qb));
    return i.toArray().reduce((r, n) => r + zr(n).height, 0);
  }
  _updateRowHeight() {
    var e = this.getTableElement(), i = this._dataController.items().length;
    if (e && this._needUpdateRowHeight(i)) {
      var r = this._getRowsHeight(e);
      this._rowHeight = r / i;
    }
  }
  _findContentElement(e) {
    var i = this.element(), r = this.getScrollable();
    if (i)
      return r && (i = E(r.content())), i.children().first();
  }
  _getRowElements(e) {
    var i = super._getRowElements(e);
    return i && i.not(".".concat(qb));
  }
  _getFreeSpaceRowElements(e) {
    var i = e || this.getTableElements();
    return i && i.children("tbody").children(".".concat(qb));
  }
  _getNoDataText() {
    return this.option("noDataText");
  }
  _rowClick(e) {
    var i = this._dataController.items()[e.rowIndex] || {};
    this.executeAction("onRowClick", P({
      evaluate(r) {
        var n = Ii(r);
        return n(i.data);
      }
    }, e, i));
  }
  _rowDblClick(e) {
    var i = this._dataController.items()[e.rowIndex] || {};
    this.executeAction("onRowDblClick", P({}, e, i));
  }
  _getColumnsCountBeforeGroups(e) {
    for (var i = 0; i < e.length; i++)
      if (e[i].type === "groupExpand")
        return i;
    return 0;
  }
  _getGroupCellOptions(e) {
    var i = this._getColumnsCountBeforeGroups(e.columns), r = (e.row.groupIndex || 0) + i;
    return {
      columnIndex: r,
      colspan: e.columns.length - r - 1
    };
  }
  _needWrapRow() {
    return super._needWrapRow.apply(this, arguments) || !!this.option("dataRowTemplate");
  }
  _renderCells(e, i) {
    i.row.rowType === "group" ? this._renderGroupedCells(e, i) : i.row.values && super._renderCells(e, i);
  }
  _renderGroupedCells(e, i) {
    for (var {
      row: r
    } = i, n, {
      columns: a
    } = i, {
      rowIndex: o
    } = r, u, c = this._getGroupCellOptions(i), p = 0; p <= c.columnIndex; p++)
      p === c.columnIndex && a[p].allowCollapsing && i.scrollingMode !== "infinite" ? (u = !!r.isExpanded, n = a[p]) : (u = null, n = {
        command: "expand",
        cssClass: a[p].cssClass
      }), this._needRenderCell(p, i.columnIndices) && this._renderCell(e, {
        value: u,
        row: r,
        rowIndex: o,
        column: n,
        columnIndex: p,
        columnIndices: i.columnIndices,
        change: i.change
      });
    var v = Nh(this.option("rtlEnabled")), _ = P({}, a[c.columnIndex], {
      command: null,
      type: null,
      cssClass: null,
      width: null,
      showWhenGrouped: !1,
      alignment: v
    });
    c.colspan > 1 && (_.colspan = c.colspan), this._needRenderCell(c.columnIndex + 1, i.columnIndices) && this._renderCell(e, {
      value: r.values[r.groupIndex],
      row: r,
      rowIndex: o,
      column: _,
      columnIndex: c.columnIndex + 1,
      columnIndices: i.columnIndices,
      change: i.change
    });
  }
  _renderRows(e, i) {
    var r = this.option("scrolling.mode");
    super._renderRows(e, P({
      scrollingMode: r
    }, i)), this._checkRowKeys(i.change), this._renderFreeSpaceRow(e, i.change), this._hasHeight || this.updateFreeSpaceRowHeight(e);
  }
  _renderDataRowByTemplate(e, i, r) {
    var {
      row: n
    } = i, a = P({
      columns: i.columns
    }, n), o = this._createRow(n, "tbody");
    o.appendTo(e), this.renderTemplate(o, r, a, !0, i.change), this._rowPrepared(o, a, i.row);
  }
  _renderRow(e, i) {
    var {
      row: r
    } = i, {
      rowTemplate: n
    } = this.option(), a = this.option("dataRowTemplate");
    r.rowType === "data" && a ? this._renderDataRowByTemplate(e, i, a) : (r.rowType === "data" || r.rowType === "group") && !R(r.groupIndex) && n ? this.renderTemplate(e, n, P({
      columns: i.columns
    }, r), !0) : super._renderRow(e, i);
  }
  _renderTable(e) {
    var i = this, r = super._renderTable(e);
    return R(i.getTableElement()) ? i._renderScrollable() : (i.setTableElement(r), i._renderScrollable(!0), i.resizeCompleted.add(function n() {
      var a = i.getScrollable();
      a && i.element().closest(Ot().document).length && (i.resizeCompleted.remove(n), a._visibilityChanged(!0));
    })), r;
  }
  _createTable() {
    var e = super._createTable.apply(this, arguments);
    return (this.option().rowTemplate || this.option().dataRowTemplate) && e.appendTo(this.component.$element()), e;
  }
  _renderCore(e) {
    var i = this.element();
    i.addClass(this.addWidgetPrefix(dme)).toggleClass(this.addWidgetPrefix(hme), !this.option("wordWrapEnabled")), i.toggleClass(vme, this._dataController.isEmpty()), this.setAria("role", "presentation", i);
    var r = this._renderTable({
      change: e
    }), n = this._updateContent(r, e);
    return super._renderCore(e), this._lastColumnWidths = null, n;
  }
  _getRows(e) {
    return e && e.items || this._dataController.items();
  }
  _getCellOptions(e) {
    var {
      column: i
    } = e, {
      row: r
    } = e, {
      data: n
    } = r, a = r && r.summaryCells, {
      value: o
    } = e, u = xe.getDisplayValue(i, o, n, r.rowType), c = super._getCellOptions(e);
    if (c.value = o, c.oldValue = e.oldValue, c.displayValue = u, c.row = r, c.key = r.key, c.data = n, c.rowType = r.rowType, c.values = r.values, c.text = i.command ? "" : xe.formatValue(u, i), c.rowIndex = r.rowIndex, c.summaryItems = a && a[e.columnIndex], c.resized = i.resizedCallbacks, R(i.groupIndex) && !i.command) {
      var p = this.option("grouping.texts"), v = this.option("scrolling.mode");
      v !== "virtual" && v !== "infinite" && (c.groupContinuesMessage = n && n.isContinuationOnNextPage && p && p.groupContinuesMessage, c.groupContinuedMessage = n && n.isContinuation && p && p.groupContinuedMessage);
    }
    return c;
  }
  _setRowsOpacityCore(e, i, r, n) {
    var a = this._columnsController, o = a.getColumns(), u = o && o[r], c = u && u.isBand && u.index;
    N(e, (p, v) => {
      if (!E(v).hasClass(NL))
        for (var _ = 0; _ < i.length && !((Di(c) && a.isParentBandColumn(i[_].index, c) || i[_].index === r) && (e.eq(p).children().eq(_).css({
          opacity: n
        }), !Di(c))); _++)
          ;
    });
  }
  _getDevicePixelRatio() {
    return Ot().devicePixelRatio;
  }
  renderNoDataText() {
    return xe.renderNoDataText.apply(this, arguments);
  }
  getCellOptions(e, i) {
    var r = this._dataController.items()[e], n, a;
    return r && (ht(i) ? a = this._columnsController.columnOption(i) : a = this._columnsController.getVisibleColumns()[i], a && (n = this._getCellOptions({
      value: a.calculateCellValue(r.data),
      rowIndex: r.rowIndex,
      row: r,
      column: a
    }))), n;
  }
  getRow(e) {
    if (e >= 0) {
      var i = this._getRowElements();
      if (i.length > e)
        return E(i[e]);
    }
  }
  updateFreeSpaceRowHeight(e) {
    var i = this._dataController, r = i.items(!0).length, n = this._findContentElement(), a = this._getFreeSpaceRowElements(e);
    if (a && n && i.totalCount() >= 0) {
      var o = !1;
      if (r > 0)
        if (this._hasHeight)
          a.hide(), Na(() => {
            var p = this.getScrollbarWidth(!0), v = Pt(this.element()) - p, _ = jt(n), y = v - _ > 0, b = this._getRowsHeight(n.children().first()), I = e || this.getTableElements(), A = Math.ceil(parseFloat(I.css("borderTopWidth"))), L = this._getHeightCorrection(), B = v - b - A - L;
            y && dn(() => {
              a.css("height", B), o = !0, a.show();
            }), dn(() => this._updateLastRowBorder(o));
          });
        else {
          var u = i.pageSize() - r, c = this.option("scrolling.mode");
          u > 0 && i.pageCount() > 1 && c !== "virtual" && c !== "infinite" && (xR(a, u * this._rowHeight), o = !0), !o && e ? xR(a, 0) : a.toggle(o), this._updateLastRowBorder(o);
        }
      else
        a.css("height", 0), a.show(), this._updateLastRowBorder(!0);
    }
  }
  _getHeightCorrection() {
    var e = $i.webkit && this._getDevicePixelRatio() >= 2, i = $i.chrome && $i.version >= 91, r = $i.mozilla && $i.version >= 70 && !this.option("showRowLines");
    return e || r || i ? 1 : 0;
  }
  _columnOptionChanged(e) {
    var {
      optionNames: i
    } = e;
    e.changeTypes.grouping || (i.width || i.visibleWidth) && (super._columnOptionChanged(e), this._fireColumnResizedCallbacks());
  }
  getScrollable() {
    return this._scrollable;
  }
  _handleDataChanged(e) {
    switch (e.changeType) {
      case "refresh":
      case "prepend":
      case "append":
      case "update":
        this.render(null, e);
        break;
      default:
        this._update(e);
    }
  }
  publicMethods() {
    return ["isScrollbarVisible", "getTopVisibleRowData", "getScrollbarWidth", "getCellElement", "getRowElement", "getScrollable"];
  }
  contentWidth() {
    return mt(this.element()) - this.getScrollbarWidth();
  }
  getScrollbarWidth(e) {
    var i = this._scrollableContainer && this._scrollableContainer.get(0), r = 0;
    return i && (e ? (r = i.clientHeight ? i.offsetHeight - i.clientHeight : 0, r += Cme(this)) : r = i.clientWidth ? i.offsetWidth - i.clientWidth : 0), r > 0 ? r : 0;
  }
  _fireColumnResizedCallbacks() {
    for (var e = this._lastColumnWidths || [], i = [], r = this.getColumns(), n = 0; n < r.length; n++)
      i[n] = r[n].visibleWidth, r[n].resizedCallbacks && !R(r[n].groupIndex) && e[n] !== i[n] && r[n].resizedCallbacks.fire(i[n]);
    this._lastColumnWidths = i;
  }
  _updateLastRowBorder(e) {
    this.option("showBorders") && !e ? this.element().addClass(kU) : this.element().removeClass(kU);
  }
  _updateScrollable() {
    var e = ds.getInstance(this.element());
    e && (e.update(), (e.option("useNative") || !(e != null && e.isRenovated())) && this._updateHorizontalScrollPosition());
  }
  _updateHorizontalScrollPosition() {
    var e = this.getScrollable(), i = e && e.scrollOffset().left, r = this.option("rtlEnabled");
    if (r) {
      var n = PU(e), a = n - i;
      a !== this._scrollRight && (this._scrollLeft = n - this._scrollRight);
    }
    this._scrollLeft >= 0 && i !== this._scrollLeft && e.scrollTo({
      x: this._scrollLeft
    });
  }
  _resizeCore() {
    var e = this;
    e._fireColumnResizedCallbacks(), e._updateRowHeight(), dn(() => {
      e._renderScrollable(), e.renderNoDataText(), e.updateFreeSpaceRowHeight(), Na(() => {
        e._updateScrollable();
      });
    });
  }
  scrollTo(e) {
    var i = this.element(), r = i && ds.getInstance(i);
    r && r.scrollTo(e);
  }
  height(e) {
    var i = this.element();
    if (arguments.length === 0)
      return i ? jt(i, !0) : 0;
    R(e) && i && (this.hasHeight(e !== "auto"), xR(i, e));
  }
  hasHeight(e) {
    if (arguments.length === 0)
      return !!this._hasHeight;
    this._hasHeight = e;
  }
  setLoading(e, i) {
    var r = this._loadPanel, n = this._dataController, a = this.option("loadPanel") || {}, o = n.isLoaded() ? a.animation : null, u = this.element();
    if (wt() && (!r && i !== void 0 && n.isLocalStore() && a.enabled === "auto" && u && (this._renderLoadPanel(u, u.parent()), r = this._loadPanel), r)) {
      var c = {
        message: i || a.text,
        animation: o,
        visible: e
      };
      e && (c.position = xe.calculateLoadPanelPosition(u)), clearTimeout(this._hideLoadingTimeoutID), r.option("visible") && !e ? this._hideLoadingTimeoutID = setTimeout(() => {
        r.option(c);
      }, mme) : r.option(c);
    }
  }
  setRowsOpacity(e, i) {
    var r = this._getRowElements().not(".".concat(NL)) || [];
    this._setRowsOpacityCore(r, this.getColumns(), e, i);
  }
  _getCellElementsCore(e) {
    var i = super._getCellElementsCore.apply(this, arguments);
    if (i) {
      var r = i.filter(".".concat(RU)).index();
      if (r >= 0 && i.length > r + 1)
        return i.slice(0, r + 1);
    }
    return i;
  }
  _getBoundaryVisibleItemIndex(e, i) {
    var r = 0, n = 0, a = 0, o = this._scrollTop, u = this._findContentElement(), c = u && u.offset().top, p = this._dataController.items(), v = this.getTableElement();
    if (p.length && v) {
      var _ = this._getRowElements(v).filter(":visible");
      if (!e) {
        var y = jt(this._hasHeight ? this.element() : Ot());
        o += y;
      }
      for (r = 0; r < p.length; r++) {
        n = a;
        var b = E(_).eq(r);
        if (b.length && (a = b.offset(), a = (e ? a.top : a.top + jt(b)) - c, a > o)) {
          r && (i || 2 * o < Math.round(a + n)) && r--;
          break;
        }
      }
      r && r === p.length && r--;
    }
    return r;
  }
  getTopVisibleItemIndex(e) {
    return this._getBoundaryVisibleItemIndex(!0, e);
  }
  getBottomVisibleItemIndex(e) {
    return this._getBoundaryVisibleItemIndex(!1, e);
  }
  getTopVisibleRowData() {
    var e = this.getTopVisibleItemIndex(), i = this._dataController.items();
    if (i[e])
      return i[e].data;
  }
  _scrollToElement(e, i) {
    var r = this.getScrollable();
    r && r.scrollToElement(e, i);
  }
  optionChanged(e) {
    switch (super.optionChanged(e), e.name) {
      case "wordWrapEnabled":
      case "showColumnLines":
      case "showRowLines":
      case "rowAlternationEnabled":
      case "rowTemplate":
      case "dataRowTemplate":
      case "twoWayBindingEnabled":
        this._invalidate(!0, !0), e.handled = !0;
        break;
      case "scrolling":
        this._rowHeight = null, this._tableElement = null, e.handled = !0;
        break;
      case "rtlEnabled":
        this._rowHeight = null, this._tableElement = null;
        break;
      case "loadPanel":
        this._tableElement = null, this._invalidate(!0, e.fullName !== "loadPanel.enabled"), e.handled = !0;
        break;
      case "noDataText":
        this.renderNoDataText(), e.handled = !0;
    }
  }
  setAriaOwns(e, i, r) {
    var n, a = this._findContentElement(), o = this.getTableElement();
    o != null && o.length && this.setAria("owns", "".concat(e ?? "", " ").concat((n = o.attr("id")) !== null && n !== void 0 ? n : "", " ").concat(i ?? "").trim(), a);
  }
  dispose() {
    super.dispose(), clearTimeout(this._hideLoadingTimeoutID), this._scrollable && this._scrollable.dispose();
  }
  setScrollerSpacing(e, i) {
  }
  _restoreErrorRow(e) {
  }
};
var k5 = {
  defaultOptions: () => ({
    hoverStateEnabled: !1,
    scrolling: {
      useNative: "auto"
    },
    loadPanel: {
      enabled: "auto",
      text: X.format("Loading"),
      width: 200,
      height: 90,
      showIndicator: !0,
      indicatorSrc: "",
      showPane: !0
    },
    dataRowTemplate: null,
    columnAutoWidth: !1,
    noDataText: X.format("dxDataGrid-noDataText"),
    wordWrapEnabled: !1,
    showColumnLines: !0,
    showRowLines: !1,
    rowAlternationEnabled: !1,
    activeStateEnabled: !1,
    twoWayBindingEnabled: !0
  }),
  views: {
    rowsView: yme
  }
}, FVe = k5.views.rowsView;
et.registerModule("rows", k5);
function xme(t) {
  return class {
    constructor() {
      throw new Error("Module '".concat(t, "' not found"));
    }
    static getInstance() {
    }
  };
}
var VU = xme("TextBox");
const Mp = {
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      searchMode: "",
      searchExpr: null,
      searchValue: "",
      searchEnabled: !1,
      searchEditorOptions: {}
    });
  },
  _initMarkup: function() {
    this._renderSearch(), this.callBase();
  },
  _renderSearch: function() {
    var t = this.$element(), e = this.option("searchEnabled"), i = this._addWidgetPrefix("search"), r = this._addWidgetPrefix("with-search");
    if (!e) {
      t.removeClass(r), this._removeSearchBox();
      return;
    }
    var n = this._getSearchEditorOptions();
    this._searchEditor ? this._searchEditor.option(n) : (t.addClass(r), this._$searchEditorElement = E("<div>").addClass(i).prependTo(t), this._searchEditor = this._createComponent(this._$searchEditorElement, VU, n));
  },
  _removeSearchBox: function() {
    this._$searchEditorElement && this._$searchEditorElement.remove(), delete this._$searchEditorElement, delete this._searchEditor;
  },
  _getSearchEditorOptions: function() {
    var t = this, e = t.option("searchEditorOptions"), i = X.format("Search");
    return P({
      mode: "search",
      placeholder: i,
      tabIndex: t.option("tabIndex"),
      value: t.option("searchValue"),
      valueChangeEvent: "input",
      inputAttr: {
        "aria-label": i
      },
      onValueChanged: function(r) {
        var n = t.option("searchTimeout");
        t._valueChangeDeferred = new q(), clearTimeout(t._valueChangeTimeout), t._valueChangeDeferred.done((function() {
          this.option("searchValue", r.value);
        }).bind(t)), r.event && r.event.type === "input" && n ? t._valueChangeTimeout = setTimeout(function() {
          t._valueChangeDeferred.resolve();
        }, n) : t._valueChangeDeferred.resolve();
      }
    }, e);
  },
  _getAriaTarget: function() {
    return this.option("searchEnabled") ? this._itemContainer(!0) : this.callBase();
  },
  _focusTarget: function() {
    return this.option("searchEnabled") ? this._itemContainer(!0) : this.callBase();
  },
  _updateFocusState: function(t, e) {
    this.option("searchEnabled") && this._toggleFocusClass(e, this.$element()), this.callBase(t, e);
  },
  getOperationBySearchMode: function(t) {
    return t === "equals" ? "=" : t;
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "searchEnabled":
      case "searchEditorOptions":
        this._invalidate();
        break;
      case "searchExpr":
      case "searchMode":
      case "searchValue":
        if (!this._dataSource) {
          Yt.log("W1009");
          return;
        }
        t.name === "searchMode" ? this._dataSource.searchOperation(this.getOperationBySearchMode(t.value)) : this._dataSource[t.name](t.value), this._dataSource.load();
        break;
      case "searchTimeout":
        break;
      default:
        this.callBase(t);
    }
  },
  focus: function() {
    if (!this.option("focusedElement") && this.option("searchEnabled")) {
      this._searchEditor && this._searchEditor.focus();
      return;
    }
    this.callBase();
  },
  _cleanAria: function() {
    var t = this.$element();
    this.setAria({
      role: null,
      activedescendant: null
    }, t), t.attr("tabIndex", null);
  },
  _clean() {
    this.callBase(), this._cleanAria();
  },
  _refresh: function() {
    this._valueChangeDeferred && this._valueChangeDeferred.resolve(), this.callBase();
  },
  setEditorClass: function(t) {
    VU = t;
  }
};
var {
  ios: Sme,
  mac: Eme
} = Ye.real(), bme = Sme || Eme, wme = function(t) {
  var e;
  try {
    e = {
      start: t.selectionStart,
      end: t.selectionEnd
    };
  } catch {
    e = {
      start: 0,
      end: 0
    };
  }
  return e;
}, Tme = function(t, e) {
  var i = de.getBody();
  if (!(!i.contains(t) && !i.contains(t.getRootNode().host)))
    try {
      t.selectionStart = e.start, t.selectionEnd = e.end;
    } catch {
    }
}, Ime = function(t, e) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (t = E(t).get(0), !R(e))
    return wme(t);
  !i && bme && de.getActiveElement(t) !== t || Tme(t, e);
}, vm = " ";
class P5 {
  constructor(e) {
    this._value = vm, P(this, e);
  }
  next(e) {
    if (!arguments.length)
      return this._next;
    this._next = e;
  }
  _prepareHandlingArgs(e, i) {
    var r, n, a;
    i = i || {};
    var o = Object.prototype.hasOwnProperty.call(e, "value") ? "value" : "text";
    return e[o] = (r = i.str) !== null && r !== void 0 ? r : e[o], e.start = (n = i.start) !== null && n !== void 0 ? n : e.start, e.length = (a = i.length) !== null && a !== void 0 ? a : e.length, e.index = e.index + 1, e;
  }
  first(e) {
    return e = e || 0, this.next().first(e + 1);
  }
  isAccepted() {
    return !1;
  }
  adjustedCaret(e, i, r) {
    return i ? this._adjustedForward(e, 0, r) : this._adjustedBackward(e, 0, r);
  }
  _adjustedForward() {
  }
  _adjustedBackward() {
  }
  isValid() {
  }
  reset() {
  }
  clear() {
  }
  text() {
  }
  value() {
  }
  rawValue() {
  }
  handle() {
  }
}
class Dme extends P5 {
  next() {
  }
  handle() {
    return 0;
  }
  text() {
    return "";
  }
  value() {
    return "";
  }
  first() {
    return 0;
  }
  rawValue() {
    return "";
  }
  adjustedCaret() {
    return 0;
  }
  isValid() {
    return !0;
  }
}
class F5 extends P5 {
  text() {
    return (this._value !== vm ? this._value : this.maskChar) + this.next().text();
  }
  value() {
    return this._value + this.next().value();
  }
  rawValue() {
    return this._value + this.next().rawValue();
  }
  handle(e) {
    var i = Object.prototype.hasOwnProperty.call(e, "value") ? e.value : e.text;
    if (!i || !i.length || !e.length)
      return 0;
    if (e.start)
      return this.next().handle(this._prepareHandlingArgs(e, {
        start: e.start - 1
      }));
    var r = i[0], n = i.substring(1);
    return this._tryAcceptChar(r, e), this._accepted() ? this.next().handle(this._prepareHandlingArgs(e, {
      str: n,
      length: e.length - 1
    })) + 1 : this.handle(this._prepareHandlingArgs(e, {
      str: n,
      length: e.length - 1
    }));
  }
  clear(e) {
    this._tryAcceptChar(vm, e), this.next().clear(this._prepareHandlingArgs(e));
  }
  reset() {
    this._accepted(!1), this.next().reset();
  }
  _tryAcceptChar(e, i) {
    if (this._accepted(!1), !!this._isAllowed(e, i)) {
      var r = e === vm ? this.maskChar : e;
      i.fullText = i.fullText.substring(0, i.index) + r + i.fullText.substring(i.index + 1), this._accepted(!0), this._value = e;
    }
  }
  _accepted(e) {
    if (!arguments.length)
      return !!this._isAccepted;
    this._isAccepted = !!e;
  }
  first(e) {
    return this._value === vm ? e || 0 : super.first(e);
  }
  _isAllowed(e, i) {
    return e === vm ? !0 : this._isValid(e, i);
  }
  _isValid(e, i) {
    var r = this.allowedChars;
    return r instanceof RegExp ? r.test(e) : Le(r) ? r(e, i.index, i.fullText) : Array.isArray(r) ? r.includes(e) : r === e;
  }
  isAccepted(e) {
    return e === 0 ? this._accepted() : this.next().isAccepted(e - 1);
  }
  _adjustedForward(e, i, r) {
    return i >= e ? i : this.next()._adjustedForward(e, i + 1, r) || i + 1;
  }
  _adjustedBackward(e, i) {
    return i >= e - 1 ? e : this.next()._adjustedBackward(e, i + 1) || i + 1;
  }
  isValid(e) {
    return this._isValid(this._value, e) && this.next().isValid(this._prepareHandlingArgs(e));
  }
}
class NU extends F5 {
  value() {
    return this.next().value();
  }
  handle(e) {
    var i = Object.prototype.hasOwnProperty.call(e, "value"), r = i ? e.value : e.text;
    if (!r.length || !e.length)
      return 0;
    if (e.start || i)
      return this.next().handle(this._prepareHandlingArgs(e, {
        start: e.start && e.start - 1
      }));
    var n = r[0], a = r.substring(1);
    this._tryAcceptChar(n);
    var o = this._isAllowed(n) ? this._prepareHandlingArgs(e, {
      str: a,
      length: e.length - 1
    }) : e;
    return this.next().handle(o) + 1;
  }
  clear(e) {
    this._accepted(!1), this.next().clear(this._prepareHandlingArgs(e));
  }
  _tryAcceptChar(e) {
    this._accepted(this._isValid(e));
  }
  _isValid(e) {
    return e === this.maskChar;
  }
  first(e) {
    return e = e || 0, this.next().first(e + 1);
  }
  _adjustedForward(e, i, r) {
    return i >= e && r === this.maskChar ? i : e === i + 1 && this._accepted() ? e : this.next()._adjustedForward(e, i + 1, r);
  }
  _adjustedBackward(e, i) {
    return i >= e - 1 ? 0 : this.next()._adjustedBackward(e, i + 1);
  }
  isValid(e) {
    return this.next().isValid(this._prepareHandlingArgs(e));
  }
}
var Xb = "dx-invalid-message", Ame = "dx-invalid-message-auto", Ome = "dx-invalid-message-always", Rme = "dx-invalid-message-content", Lme = 100, EB = Pl.inherit({
  _getDefaultOptions() {
    return P(this.callBase(), {
      integrationOptions: {},
      templatesRenderAsynchronously: !1,
      shading: !1,
      width: "auto",
      height: "auto",
      hideOnOutsideClick: !1,
      animation: null,
      visible: !0,
      propagateOutsideClick: !0,
      _checkParentVisibility: !1,
      rtlEnabled: !1,
      contentTemplate: this._renderInnerHtml,
      maxWidth: "100%",
      container: this.$element(),
      target: void 0,
      mode: "auto",
      validationErrors: void 0,
      preventScrollEvents: !1,
      positionSide: "top",
      boundary: void 0,
      offset: {
        h: 0,
        v: 0
      },
      contentId: void 0
    });
  },
  _init() {
    this.callBase(), this.updateMaxWidth(), this._updatePosition();
  },
  _initMarkup() {
    this.callBase(), this._ensureMessageNotEmpty(), this._updatePositionByTarget(), this._toggleModeClass(), this._updateContentId();
  },
  _updatePositionByTarget: function() {
    var {
      target: t
    } = this.option();
    this.option("position.of", t);
  },
  _ensureMessageNotEmpty: function() {
    this._textMarkup = this._getTextMarkup();
    var t = this.option("visible") && this._textMarkup;
    this._toggleVisibilityClasses(t);
  },
  _toggleVisibilityClasses: function(t) {
    t ? (this.$element().addClass(Xb), this.$wrapper().addClass(Xb)) : (this.$element().removeClass(Xb), this.$wrapper().removeClass(Xb));
  },
  _updateContentId() {
    var {
      container: t,
      contentId: e
    } = this.option(), i = e ?? E(t).attr("aria-describedby");
    this.$content().addClass(Rme).attr("id", i);
  },
  _renderInnerHtml(t) {
    var e = t && E(t);
    e == null || e.html(this._textMarkup);
  },
  _getTextMarkup() {
    var t, e = (t = this.option("validationErrors")) !== null && t !== void 0 ? t : [], i = "";
    return e.forEach((r) => {
      var n, a = i ? "<br />" : "";
      i += a + K3((n = r == null ? void 0 : r.message) !== null && n !== void 0 ? n : "");
    }), i;
  },
  _toggleModeClass() {
    var t = this.option("mode");
    this.$wrapper().toggleClass(Ame, t === "auto").toggleClass(Ome, t === "always");
  },
  updateMaxWidth() {
    var t = this.option("target"), e = oi(t), i = "100%";
    e && (i = Math.max(e, Lme)), this.option({
      maxWidth: i
    });
  },
  _getPositionsArray: function(t, e) {
    switch (t) {
      case "top":
        return ["".concat(e, " bottom"), "".concat(e, " top")];
      case "left":
        return ["right", "left"];
      case "right":
        return ["left", "right"];
      default:
        return ["".concat(e, " top"), "".concat(e, " bottom")];
    }
  },
  _updatePosition: function() {
    var {
      positionSide: t,
      rtlEnabled: e,
      offset: i,
      boundary: r
    } = this.option(), n = Nh(e), a = this._getPositionsArray(t, n), o = ae({}, i);
    this.$element().addClass("dx-invalid-message-".concat(t)), e && t !== "left" && t !== "right" && (o.h = -o.h), t === "top" && (o.v = -o.v), t === "left" && (o.h = -o.h), this.option("position", {
      offset: o,
      boundary: r,
      my: a[0],
      at: a[1],
      collision: "none flip"
    });
  },
  _optionChanged(t) {
    var {
      name: e,
      value: i,
      previousValue: r
    } = t;
    switch (e) {
      case "target":
        this._updatePositionByTarget(), this.updateMaxWidth(), this.callBase(t);
        break;
      case "boundary":
        this.option("position.boundary", i);
        break;
      case "mode":
        this._toggleModeClass(i);
        break;
      case "rtlEnabled":
      case "offset":
      case "positionSide":
        this.$element().removeClass("dx-invalid-message-".concat(r)), this._updatePosition();
        break;
      case "container":
        this._updateContentId(), this.callBase(t);
        break;
      case "contentId":
        this._updateContentId();
        break;
      case "validationErrors":
        this._ensureMessageNotEmpty(), this._renderInnerHtml(this.$content());
        break;
      default:
        this.callBase(t);
    }
  }
});
ti("dxValidationMessage", EB);
var HU = "dx-invalid-message-auto", Mme = "dx-state-readonly", kme = "dx-invalid", Pme = "dx-show-invalid-badge", $U = "dx-validation-target", Fme = "valid", zU = "invalid", Bme = "editorReadOnly", Vme = ["outlined", "filled", "underlined"], WU = {
  validationMessageMode: "mode",
  validationMessagePosition: "positionSide",
  validationMessageOffset: "offset",
  validationBoundary: "boundary"
}, Fl = xn.inherit({
  ctor: function() {
    this.showValidationMessageTimeout = null, this.validationRequest = ui(), this.callBase.apply(this, arguments);
  },
  _createElement: function(t) {
    this.callBase(t);
    var e = this.$element();
    e && dr(e[0], $U, this);
  },
  _initOptions: function(t) {
    this.callBase.apply(this, arguments), this.option(Si.initValidationOptions(t));
  },
  _init: function() {
    this._initialValue = this.option("value"), this.callBase(), this._options.cache("validationTooltipOptions", this.option("validationTooltipOptions"));
    var t = this.$element();
    t.addClass(Pme);
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      value: null,
      name: "",
      onValueChanged: null,
      readOnly: !1,
      isValid: !0,
      validationError: null,
      validationErrors: null,
      validationStatus: Fme,
      validationMessageMode: "auto",
      validationMessagePosition: "bottom",
      validationBoundary: void 0,
      validationMessageOffset: {
        h: 0,
        v: 0
      },
      validationTooltipOptions: {},
      _showValidationMessage: !0,
      isDirty: !1
    });
  },
  _attachKeyboardEvents: function() {
    this.option("readOnly") || this.callBase();
  },
  _setOptionsByReference: function() {
    this.callBase(), P(this._optionsByReference, {
      validationError: !0
    });
  },
  _createValueChangeAction: function() {
    this._valueChangeAction = this._createActionByOption("onValueChanged", {
      excludeValidators: ["disabled", "readOnly"]
    });
  },
  _suppressValueChangeAction: function() {
    this._valueChangeActionSuppressed = !0;
  },
  _resumeValueChangeAction: function() {
    this._valueChangeActionSuppressed = !1;
  },
  _initMarkup: function() {
    var t;
    this._toggleReadOnlyState(), this._setSubmitElementName(this.option("name")), this.callBase(), this._renderValidationState(), (t = this.option("_onMarkupRendered")) === null || t === void 0 || t();
  },
  _raiseValueChangeAction: function(t, e) {
    this._valueChangeAction || this._createValueChangeAction(), this._valueChangeAction(this._valueChangeArgs(t, e));
  },
  _valueChangeArgs: function(t, e) {
    return {
      value: t,
      previousValue: e,
      event: this._valueChangeEventInstance
    };
  },
  _saveValueChangeEvent: function(t) {
    this._valueChangeEventInstance = t;
  },
  _focusInHandler: function(t) {
    var e = this.option("validationMessageMode") === "auto";
    if (this._canValueBeChangedByClick() && e) {
      var i, r = (i = this._validationMessage) === null || i === void 0 ? void 0 : i.$wrapper();
      r == null || r.removeClass(HU), clearTimeout(this.showValidationMessageTimeout), this.showValidationMessageTimeout = setTimeout(() => r == null ? void 0 : r.addClass(HU), 150);
    }
    return this.callBase(t);
  },
  _canValueBeChangedByClick: function() {
    return !1;
  },
  _getStylingModePrefix: function() {
    return "dx-editor-";
  },
  _renderStylingMode: function() {
    var t = this.option("stylingMode"), e = this._getStylingModePrefix(), i = Vme.map((o) => e + o);
    i.forEach((o) => this.$element().removeClass(o));
    var r = e + t;
    if (i.indexOf(r) === -1) {
      var n = this._getDefaultOptions().stylingMode, a = this._convertRulesToOptions(this._defaultOptionsRules()).stylingMode;
      r = e + (a || n);
    }
    this.$element().addClass(r);
  },
  _getValidationErrors: function() {
    var t = this.option("validationErrors");
    return !t && this.option("validationError") && (t = [this.option("validationError")]), t;
  },
  _disposeValidationMessage: function() {
    this._$validationMessage && (this._$validationMessage.remove(), this.setAria("describedby", null), this._$validationMessage = void 0, this._validationMessage = void 0);
  },
  _toggleValidationClasses: function(t) {
    this.$element().toggleClass(kme, t), this.setAria(zU, t || void 0);
  },
  _renderValidationState: function() {
    var t = this.option("isValid") && this.option("validationStatus") !== zU, e = this._getValidationErrors(), i = this.$element();
    if (this._toggleValidationClasses(!t), !(!wt() || this.option("_showValidationMessage") === !1) && (this._disposeValidationMessage(), !t && e)) {
      var {
        validationMessageMode: r,
        validationMessageOffset: n,
        validationBoundary: a,
        rtlEnabled: o
      } = this.option();
      this._$validationMessage = E("<div>").appendTo(i);
      var u = "dx-".concat(new yr());
      this.setAria("describedby", u), this._validationMessage = new EB(this._$validationMessage, P({
        validationErrors: e,
        rtlEnabled: o,
        target: this._getValidationMessageTarget(),
        visualContainer: i,
        mode: r,
        positionSide: this._getValidationMessagePosition(),
        offset: n,
        boundary: a,
        contentId: u
      }, this._options.cache("validationTooltipOptions"))), this._bindInnerWidgetOptions(this._validationMessage, "validationTooltipOptions");
    }
  },
  _getValidationMessagePosition: function() {
    return this.option("validationMessagePosition");
  },
  _getValidationMessageTarget: function() {
    return this.$element();
  },
  _toggleReadOnlyState: function() {
    var t = this.option("readOnly");
    this._toggleBackspaceHandler(t), this.$element().toggleClass(Mme, !!t), this.setAria("readonly", t || void 0);
  },
  _toggleBackspaceHandler: function(t) {
    var e = this._keyboardEventBindingTarget(), i = ve("keydown", Bme);
    k.off(e, i), t && k.on(e, i, (r) => {
      or(r) === "backspace" && r.preventDefault();
    });
  },
  _dispose: function() {
    var t = this.$element()[0];
    dr(t, $U, null), clearTimeout(this.showValidationMessageTimeout), this._disposeValidationMessage(), this.callBase();
  },
  _setSubmitElementName: function(t) {
    var e = this._getSubmitElement();
    e && (t.length > 0 ? e.attr("name", t) : e.removeAttr("name"));
  },
  _getSubmitElement: function() {
    return null;
  },
  _setValidationMessageOption: function(t) {
    var e, {
      name: i,
      value: r
    } = t, n = WU[i] ? WU[i] : i;
    (e = this._validationMessage) === null || e === void 0 || e.option(n, r);
  },
  _hasActiveElement: ee,
  _optionChanged: function(t) {
    var e;
    switch (t.name) {
      case "onValueChanged":
        this._createValueChangeAction();
        break;
      case "readOnly":
        this._toggleReadOnlyState(), this._refreshFocusState();
        break;
      case "value":
        t.value != t.previousValue && (this.option("isDirty", this._initialValue !== t.value), this.validationRequest.fire({
          value: t.value,
          editor: this
        })), this._valueChangeActionSuppressed || (this._raiseValueChangeAction(t.value, t.previousValue), this._saveValueChangeEvent(void 0));
        break;
      case "width":
        this.callBase(t), (e = this._validationMessage) === null || e === void 0 || e.updateMaxWidth();
        break;
      case "name":
        this._setSubmitElementName(t.value);
        break;
      case "isValid":
      case "validationError":
      case "validationErrors":
      case "validationStatus":
        this.option(Si.synchronizeValidationOptions(t, this.option())), this._renderValidationState();
        break;
      case "validationBoundary":
      case "validationMessageMode":
      case "validationMessagePosition":
      case "validationMessageOffset":
        this._setValidationMessageOption(t);
        break;
      case "rtlEnabled":
        this._setValidationMessageOption(t), this.callBase(t);
        break;
      case "validationTooltipOptions":
        this._innerWidgetOptionChanged(this._validationMessage, t);
        break;
      case "_showValidationMessage":
      case "isDirty":
        break;
      default:
        this.callBase(t);
    }
  },
  _resetToInitialValue: function() {
    this.option("value", this._initialValue);
  },
  blur: function() {
    this._hasActiveElement() && $m();
  },
  clear: function() {
    var t = this._getDefaultOptions();
    this.option("value", t.value);
  },
  reset: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
    arguments.length && (this._initialValue = t), this._resetToInitialValue(), this.option("isDirty", !1), this.option("isValid", !0);
  }
});
Fl.isEditor = (t) => t instanceof Fl;
class AI {
  constructor(e, i, r) {
    this.instance = null, this.$container = null, this.$placeMarker = null, this.editor = i, this.name = e, this.options = r || {};
  }
  _addPlaceMarker(e) {
    this.$placeMarker = E("<div>").appendTo(e);
  }
  _addToContainer(e) {
    var {
      $placeMarker: i,
      $container: r
    } = this;
    i ? i.replaceWith(e) : e.appendTo(r);
  }
  _attachEvents() {
    throw "Not implemented";
  }
  _create() {
    throw "Not implemented";
  }
  _isRendered() {
    return !!this.instance;
  }
  _isVisible() {
    var {
      editor: e,
      options: i
    } = this;
    return i.visible || !e.option("readOnly");
  }
  _isDisabled() {
    throw "Not implemented";
  }
  _shouldRender() {
    return this._isVisible() && !this._isRendered();
  }
  dispose() {
    var {
      instance: e,
      $placeMarker: i
    } = this;
    e && (e.dispose ? e.dispose() : e.remove(), this.instance = null), i && i.remove();
  }
  render() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.$container;
    if (this.$container = e, this._isVisible()) {
      var {
        instance: i,
        $element: r
      } = this._create();
      this.instance = i, this._attachEvents(i, r);
    } else
      this._addPlaceMarker(e);
  }
  update() {
    return this._shouldRender() && this.render(), !!this.instance;
  }
}
var Nme = Xt.down, Hme = "dx-state-invisible", $me = "dx-clear-button-area", zme = "dx-icon-clear", Wme = "dx-icon", Ume = "dx-show-clear-button";
class Gme extends AI {
  _create() {
    var e = E("<span>").addClass($me).append(E("<span>").addClass(Wme).addClass(zme));
    return this._addToContainer(e), this.update(!0), {
      instance: e,
      $element: e
    };
  }
  _isVisible() {
    var {
      editor: e
    } = this;
    return e._isClearButtonVisible();
  }
  _attachEvents(e, i) {
    var {
      editor: r
    } = this, n = r.NAME;
    k.on(i, ve(Nme, n), (a) => {
      a.preventDefault(), a.pointerType !== "mouse" && r._clearValueHandler(a);
    }), k.on(i, ve(di, n), (a) => r._clearValueHandler(a));
  }
  _legacyRender(e, i) {
    e.toggleClass(Ume, i);
  }
  update() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    !e && super.update();
    var {
      editor: i,
      instance: r
    } = this, n = i.$element(), a = this._isVisible();
    r && r.toggleClass(Hme, !a), this._legacyRender(n, a);
  }
}
var UU = "dx-custom-button-hovered";
class Kme extends AI {
  _attachEvents(e, i) {
    var {
      editor: r
    } = this;
    k.on(i, uS, () => {
      r.$element().addClass(UU);
    }), k.on(i, dS, () => {
      r.$element().removeClass(UU);
    }), k.on(i, di, (n) => {
      n.stopPropagation();
    });
  }
  _create() {
    var {
      editor: e
    } = this, i = E("<div>");
    this._addToContainer(i);
    var r = e._createComponent(i, yn, P({}, this.options, {
      ignoreParentReadOnly: !0,
      disabled: this._isDisabled(),
      integrationOptions: this._prepareIntegrationOptions(e)
    }));
    return {
      $element: i,
      instance: r
    };
  }
  _prepareIntegrationOptions(e) {
    return P({}, e.option("integrationOptions"), {
      skipTemplates: ["content"]
    });
  }
  update() {
    var e = super.update();
    return this.instance && this.instance.option("disabled", this._isDisabled()), e;
  }
  _isVisible() {
    var {
      editor: e
    } = this;
    return e.option("visible");
  }
  _isDisabled() {
    var e = this.options.disabled !== void 0;
    return e ? this.instance ? this.instance.option("disabled") : this.options.disabled : this.editor.option("readOnly");
  }
}
var jme = "dx-texteditor-buttons-container";
function Yme(t) {
  (() => {
    if (!t || typeof t != "object" || Array.isArray(t))
      throw Yt.Error("E1053");
  })(), (() => {
    if (!("name" in t))
      throw Yt.Error("E1054");
  })(), (() => {
    var {
      name: e
    } = t;
    if (typeof e != "string")
      throw Yt.Error("E1055");
  })(), (() => {
    var {
      location: e
    } = t;
    "location" in t && e !== "after" && e !== "before" && (t.location = "after");
  })();
}
function GU(t, e) {
  if (t.indexOf(e) !== -1)
    throw Yt.Error("E1055", e);
  t.push(e);
}
function qme(t, e) {
  return !!e.find((i) => i.name === t);
}
class Xme {
  constructor(e, i) {
    this.buttons = [], this.defaultButtonsInfo = i, this.editor = e;
  }
  _compileButtonInfo(e) {
    var i = [];
    return e.map((r) => {
      var n = typeof r == "string";
      n || Yme(r);
      var a = n || qme(r.name, this.defaultButtonsInfo);
      if (a) {
        var o = this.defaultButtonsInfo.find((c) => {
          var {
            name: p
          } = c;
          return p === r || p === r.name;
        });
        if (!o)
          throw Yt.Error("E1056", this.editor.NAME, r);
        return GU(i, r), o;
      } else {
        var {
          name: u
        } = r;
        return GU(i, u), P(r, {
          Ctor: Kme
        });
      }
    });
  }
  _createButton(e) {
    var {
      Ctor: i,
      options: r,
      name: n
    } = e, a = new i(n, this.editor, r);
    return this.buttons.push(a), a;
  }
  _renderButtons(e, i, r) {
    var n = null, a = e ? this._compileButtonInfo(e) : this.defaultButtonsInfo;
    return a.forEach((o) => {
      var {
        location: u = "after"
      } = o;
      u === r && this._createButton(o).render((n = n || E("<div>").addClass(jme), r === "before" ? i.prepend(n) : i.append(n), n));
    }), n;
  }
  clean() {
    this.buttons.forEach((e) => e.dispose()), this.buttons = [];
  }
  getButton(e) {
    var i = this.buttons.find((r) => {
      var {
        name: n
      } = r;
      return n === e;
    });
    return i && i.instance;
  }
  renderAfterButtons(e, i) {
    return this._renderButtons(e, i, "after");
  }
  renderBeforeButtons(e, i) {
    return this._renderButtons(e, i, "before");
  }
  updateButtons(e) {
    this.buttons.forEach((i) => {
      (!e || e.indexOf(i.name) !== -1) && i.update();
    });
  }
}
var KU = "dx-texteditor-label", jU = "dx-texteditor-with-label", YU = "dx-texteditor-label-outside", qU = "dx-texteditor-with-floating-label", XU = "dx-texteditor-with-before-buttons", Qme = "dx-label-before", Zme = "dx-label", Jme = "dx-label-after";
class e_e {
  constructor(e) {
    this.NAME = "dxLabel", this._props = e, this._id = "".concat(KU, "-").concat(new yr()), this._render(), this._toggleMarkupVisibility();
  }
  _isVisible() {
    return !!this._props.text && this._props.mode !== "hidden";
  }
  _render() {
    this._$before = E("<div>").addClass(Qme), this._$labelSpan = E("<span>"), this._$label = E("<div>").addClass(Zme).append(this._$labelSpan), this._$after = E("<div>").addClass(Jme), this._$root = E("<div>").addClass(KU).attr("id", this._id).append(this._$before).append(this._$label).append(this._$after), this._updateMark(), this._updateText(), this._updateBeforeWidth(), this._updateMaxWidth();
  }
  _toggleMarkupVisibility() {
    var e = this._isVisible();
    this._updateEditorBeforeButtonsClass(e), this._updateEditorLabelClass(e), e ? this._$root.appendTo(this._props.$editor) : this._$root.detach(), this._attachEvents();
  }
  _attachEvents() {
    var e = ve(di, this.NAME), i = ve(uS, this.NAME), r = ve(yT, this.NAME);
    k.off(this._$labelSpan, e), k.off(this._$labelSpan, i), k.off(this._$labelSpan, r), this._isVisible() && this._isOutsideMode() && (k.on(this._$labelSpan, e, (n) => {
      var a = Ot().getSelection().toString();
      a === "" && (this._props.onClickHandler(), n.preventDefault());
    }), k.on(this._$labelSpan, i, (n) => {
      this._props.onHoverHandler(n);
    }), k.on(this._$labelSpan, r, (n) => {
      this._props.onActiveHandler(n);
    }));
  }
  _updateEditorLabelClass(e) {
    if (this._props.$editor.removeClass(qU).removeClass(YU).removeClass(jU), e) {
      var i = this._props.mode === "floating" ? qU : jU;
      this._props.$editor.addClass(i), this._isOutsideMode() && this._props.$editor.addClass(YU);
    }
  }
  _isOutsideMode() {
    return this._props.mode === "outside";
  }
  _updateEditorBeforeButtonsClass() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._isVisible();
    if (this._props.$editor.removeClass(XU), e) {
      var i = this._props.containsButtonsBefore ? XU : "";
      this._props.$editor.addClass(i);
    }
  }
  _updateMark() {
    this._$labelSpan.attr("data-mark", this._props.mark);
  }
  _updateText() {
    this._$labelSpan.text(this._props.text);
  }
  _updateBeforeWidth() {
    if (this._isVisible()) {
      var e, i = (e = this._props.beforeWidth) !== null && e !== void 0 ? e : this._props.getBeforeWidth();
      this._$before.css({
        width: i
      }), this._updateLabelTransform();
    }
  }
  _updateLabelTransform() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    if (this._$labelSpan.css("transform", ""), this._isVisible() && this._isOutsideMode()) {
      var i = this._props.rtlEnabled ? 1 : -1, r = i * (mt(this._$before) + e);
      this._$labelSpan.css("transform", "translateX(".concat(r, "px)"));
    }
  }
  _updateMaxWidth() {
    if (this._isVisible() && !this._isOutsideMode()) {
      var e, i = (e = this._props.containerWidth) !== null && e !== void 0 ? e : this._props.getContainerWidth();
      this._$label.css({
        maxWidth: i
      });
    }
  }
  $element() {
    return this._$root;
  }
  isVisible() {
    return this._isVisible();
  }
  getId() {
    if (this._isVisible())
      return this._id;
  }
  updateMode(e) {
    this._props.mode = e, this._toggleMarkupVisibility(), this._updateBeforeWidth(), this._updateMaxWidth();
  }
  updateText(e) {
    this._props.text = e, this._updateText(), this._toggleMarkupVisibility(), this._updateBeforeWidth(), this._updateMaxWidth();
  }
  updateMark(e) {
    this._props.mark = e, this._updateMark();
  }
  updateContainsButtonsBefore(e) {
    this._props.containsButtonsBefore = e, this._updateEditorBeforeButtonsClass();
  }
  updateBeforeWidth(e) {
    this._props.beforeWidth = e, this._updateBeforeWidth();
  }
  updateMaxWidth(e) {
    this._props.containerWidth = e, this._updateMaxWidth();
  }
}
var QU = Ot(), t_e = {
  observe: ee,
  unobserve: ee,
  disconnect: ee
};
class i_e {
  constructor() {
    if (!wt() || !QU.ResizeObserver)
      return t_e;
    this._callbacksMap = /* @__PURE__ */ new Map(), this._observer = new QU.ResizeObserver((e) => {
      e.forEach((i) => {
        var r;
        (r = this._callbacksMap.get(i.target)) === null || r === void 0 || r(i);
      });
    });
  }
  observe(e, i) {
    this._callbacksMap.set(e, i), this._observer.observe(e);
  }
  unobserve(e) {
    this._callbacksMap.delete(e), this._observer.unobserve(e);
  }
  disconnect() {
    this._callbacksMap.clear(), this._observer.disconnect();
  }
}
var Ep = new i_e(), r_e = "dx-texteditor", n_e = "dx-texteditor-input-container", B5 = "dx-texteditor-input", a_e = "." + B5, o_e = "dx-texteditor-container", s_e = "dx-texteditor-buttons-container", ZU = "dx-placeholder", l_e = "dx-texteditor-empty", u_e = "dx-state-invisible", d_e = "dx-pending-indicator", JU = "dx-validation-pending", c_e = "dx-valid", Qb = ["KeyDown", "KeyPress", "KeyUp", "Change", "Cut", "Copy", "Paste", "Input"], h_e = ["tab", "enter", "shift", "control", "alt", "escape", "pageUp", "pageDown", "end", "home", "leftArrow", "upArrow", "rightArrow", "downArrow"], f_e = e_e;
function eG(t) {
  if (R(t) && !Array.isArray(t))
    throw Yt.Error("E1053");
}
var p_e = Fl.inherit({
  ctor: function(t, e) {
    e && eG(e.buttons), this._buttonCollection = new Xme(this, this._getDefaultButtons()), this._$beforeButtonsContainer = null, this._$afterButtonsContainer = null, this._labelContainerElement = null, this.callBase.apply(this, arguments);
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      buttons: void 0,
      value: "",
      spellcheck: !1,
      showClearButton: !1,
      valueChangeEvent: "change",
      placeholder: "",
      inputAttr: {},
      onFocusIn: null,
      onFocusOut: null,
      onKeyDown: null,
      onKeyUp: null,
      onChange: null,
      onInput: null,
      onCut: null,
      onCopy: null,
      onPaste: null,
      onEnterKey: null,
      mode: "text",
      hoverStateEnabled: !0,
      focusStateEnabled: !0,
      text: void 0,
      displayValueFormatter: function(t) {
        return R(t) && t !== !1 ? t : "";
      },
      stylingMode: Oi().editorStylingMode || "outlined",
      showValidationMark: !0,
      label: "",
      labelMode: "static",
      labelMark: ""
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: function() {
        var t = ho();
        return _a(t);
      },
      options: {
        labelMode: "floating",
        stylingMode: Oi().editorStylingMode || "filled"
      }
    }, {
      device: function() {
        var t = ho();
        return za(t);
      },
      options: {
        labelMode: "outside"
      }
    }]);
  },
  _getDefaultButtons: function() {
    return [{
      name: "clear",
      Ctor: Gme
    }];
  },
  _isClearButtonVisible: function() {
    return this.option("showClearButton") && !this.option("readOnly");
  },
  _input: function() {
    return this.$element().find(a_e).first();
  },
  _isFocused: function() {
    return Ah(this._input()) || this.callBase();
  },
  _inputWrapper: function() {
    return this.$element();
  },
  _buttonsContainer: function() {
    return this._inputWrapper().find("." + s_e).eq(0);
  },
  _isControlKey: function(t) {
    return h_e.indexOf(t) !== -1;
  },
  _renderStylingMode: function() {
    this.callBase(), this._updateButtonsStyling(this.option("stylingMode"));
  },
  _initMarkup: function() {
    this.$element().addClass(r_e), this._renderInput(), this._renderStylingMode(), this._renderInputType(), this._renderPlaceholder(), this._renderProps(), this.callBase(), this._renderValue(), this._renderLabel();
  },
  _render: function() {
    this.callBase(), this._refreshValueChangeEvent(), this._renderEvents(), this._renderEnterKeyAction(), this._renderEmptinessEvent();
  },
  _renderInput: function() {
    this._$buttonsContainer = this._$textEditorContainer = E("<div>").addClass(o_e).appendTo(this.$element()), this._$textEditorInputContainer = E("<div>").addClass(n_e).appendTo(this._$textEditorContainer), this._$textEditorInputContainer.append(this._createInput()), this._renderButtonContainers();
  },
  _getInputContainer() {
    return this._$textEditorInputContainer;
  },
  _renderPendingIndicator: function() {
    this.$element().addClass(JU);
    var t = this._getInputContainer(), e = E("<div>").addClass(d_e).appendTo(t);
    this._pendingIndicator = this._createComponent(e, us);
  },
  _disposePendingIndicator: function() {
    this._pendingIndicator && (this._pendingIndicator.dispose(), this._pendingIndicator.$element().remove(), this._pendingIndicator = null, this.$element().removeClass(JU));
  },
  _renderValidationState: function() {
    this.callBase();
    var t = this.option("validationStatus") === "pending";
    t ? (!this._pendingIndicator && this._renderPendingIndicator(), this._showValidMark = !1) : (this.option("validationStatus") === "invalid" && (this._showValidMark = !1), !this._showValidMark && this.option("showValidationMark") === !0 && (this._showValidMark = this.option("validationStatus") === "valid" && !!this._pendingIndicator), this._disposePendingIndicator()), this._toggleValidMark();
  },
  _renderButtonContainers: function() {
    var t = this.option("buttons");
    this._$beforeButtonsContainer = this._buttonCollection.renderBeforeButtons(t, this._$buttonsContainer), this._$afterButtonsContainer = this._buttonCollection.renderAfterButtons(t, this._$buttonsContainer);
  },
  _cleanButtonContainers: function() {
    var t, e;
    (t = this._$beforeButtonsContainer) === null || t === void 0 || t.remove(), (e = this._$afterButtonsContainer) === null || e === void 0 || e.remove(), this._buttonCollection.clean();
  },
  _clean() {
    this._buttonCollection.clean(), this._disposePendingIndicator(), this._unobserveLabelContainerResize(), this._$beforeButtonsContainer = null, this._$afterButtonsContainer = null, this._$textEditorContainer = null, this._$buttonsContainer = null, this.callBase();
  },
  _createInput: function() {
    var t = E("<input>");
    return this._applyInputAttributes(t, this.option("inputAttr")), t;
  },
  _setSubmitElementName: function(t) {
    var e = this.option("inputAttr.name");
    return this.callBase(t || e || "");
  },
  _applyInputAttributes: function(t, e) {
    var i = P(this._getDefaultAttributes(), e);
    t.attr(i).addClass(B5), this._setInputMinHeight(t);
  },
  _setInputMinHeight: function(t) {
    t.css("minHeight", this.option("height") ? "0" : "");
  },
  _getPlaceholderAttr() {
    var {
      ios: t,
      mac: e
    } = Ye.real(), {
      placeholder: i
    } = this.option(), r = i || (t || e ? " " : null);
    return r;
  },
  _getDefaultAttributes() {
    var t = {
      autocomplete: "off",
      placeholder: this._getPlaceholderAttr()
    };
    return t;
  },
  _updateButtons: function(t) {
    this._buttonCollection.updateButtons(t);
  },
  _updateButtonsStyling: function(t) {
    N(this.option("buttons"), (e, i) => {
      var {
        options: r,
        name: n
      } = i;
      if (r && !r.stylingMode && this.option("visible")) {
        var a = this.getButton(n);
        a.option && a.option("stylingMode", t === "underlined" ? "text" : "contained");
      }
    });
  },
  _renderValue: function() {
    var t = this._renderInputValue();
    return t.promise();
  },
  _renderInputValue: function(t) {
    var e;
    t = (e = t) !== null && e !== void 0 ? e : this.option("value");
    var i = this.option("text"), r = this.option("displayValue"), n = this.option("displayValueFormatter");
    return r !== void 0 && t !== null ? i = n(r) : R(i) || (i = n(t)), this.option("text", i), this._input().val() !== (R(i) ? i : "") ? this._renderDisplayText(i) : this._toggleEmptinessEventHandler(), new q().resolve();
  },
  _renderDisplayText: function(t) {
    this._input().val(t), this._toggleEmptinessEventHandler();
  },
  _isValueValid: function() {
    if (this._input().length) {
      var t = this._input().get(0).validity;
      if (t)
        return t.valid;
    }
    return !0;
  },
  _toggleEmptiness: function(t) {
    this.$element().toggleClass(l_e, t), this._togglePlaceholder(t);
  },
  _togglePlaceholder: function(t) {
    this.$element().find(".".concat(ZU)).eq(0).toggleClass(u_e, !t);
  },
  _renderProps: function() {
    this._toggleReadOnlyState(), this._toggleSpellcheckState(), this._toggleTabIndex();
  },
  _toggleDisabledState: function(t) {
    this.callBase.apply(this, arguments);
    var e = this._input();
    e.prop("disabled", t);
  },
  _toggleTabIndex: function() {
    var t = this._input(), e = this.option("disabled"), i = this.option("focusStateEnabled");
    e || !i ? t.attr("tabIndex", -1) : t.removeAttr("tabIndex");
  },
  _toggleReadOnlyState: function() {
    this._input().prop("readOnly", this._readOnlyPropValue()), this.callBase();
  },
  _readOnlyPropValue: function() {
    return this.option("readOnly");
  },
  _toggleSpellcheckState: function() {
    this._input().prop("spellcheck", this.option("spellcheck"));
  },
  _unobserveLabelContainerResize: function() {
    this._labelContainerElement && (Ep.unobserve(this._labelContainerElement), this._labelContainerElement = null);
  },
  _getLabelContainer: function() {
    return this._input();
  },
  _getLabelContainerWidth: function() {
    return mt(this._getLabelContainer());
  },
  _getLabelBeforeWidth: function() {
    var t = this._$beforeButtonsContainer && mt(this._$beforeButtonsContainer);
    return t ?? 0;
  },
  _updateLabelWidth: function() {
    this._label.updateBeforeWidth(this._getLabelBeforeWidth()), this._label.updateMaxWidth(this._getLabelContainerWidth());
  },
  _getFieldElement() {
    return this._getLabelContainer();
  },
  _setFieldAria(t) {
    var {
      "aria-label": e
    } = this.option("inputAttr"), i = this._label.getId(), r = e ? void 0 : i;
    if (r || t) {
      var n = {
        labelledby: r,
        label: e
      };
      this.setAria(n, this._getFieldElement());
    }
  },
  _renderLabel: function() {
    this._unobserveLabelContainerResize(), this._labelContainerElement = E(this._getLabelContainer()).get(0);
    var {
      label: t,
      labelMode: e,
      labelMark: i,
      rtlEnabled: r
    } = this.option(), n = {
      onClickHandler: () => {
        this.focus();
      },
      onHoverHandler: (a) => {
        a.stopPropagation();
      },
      onActiveHandler: (a) => {
        a.stopPropagation();
      },
      $editor: this.$element(),
      text: t,
      mark: i,
      mode: e,
      rtlEnabled: r,
      containsButtonsBefore: !!this._$beforeButtonsContainer,
      getContainerWidth: () => this._getLabelContainerWidth(),
      getBeforeWidth: () => this._getLabelBeforeWidth()
    };
    this._label = new f_e(n), this._setFieldAria(), this._labelContainerElement && Ep.observe(this._labelContainerElement, this._updateLabelWidth.bind(this));
  },
  _renderPlaceholder: function() {
    this._renderPlaceholderMarkup(), this._attachPlaceholderEvents();
  },
  _renderPlaceholderMarkup: function() {
    this._$placeholder && (this._$placeholder.remove(), this._$placeholder = null);
    var t = this._input(), e = this.option("placeholder"), i = {
      id: e ? "dx-".concat(new yr()) : void 0,
      "data-dx_placeholder": e
    }, r = this._$placeholder = E("<div>").attr(i);
    r.insertAfter(t), r.addClass(ZU);
  },
  _attachPlaceholderEvents: function() {
    var t = ve(Xt.up, this.NAME);
    k.on(this._$placeholder, t, () => {
      k.trigger(this._input(), "focus");
    }), this._toggleEmptinessEventHandler();
  },
  _placeholder: function() {
    return this._$placeholder || E();
  },
  _clearValueHandler: function(t) {
    var e = this._input();
    t.stopPropagation(), this._saveValueChangeEvent(t), this._clearValue(), !this._isFocused() && k.trigger(e, "focus"), k.trigger(e, "input");
  },
  _clearValue: function() {
    this.clear();
  },
  _renderEvents: function() {
    var t = this._input();
    N(Qb, (e, i) => {
      if (this.hasActionSubscription("on" + i)) {
        var r = this._createActionByOption("on" + i, {
          excludeValidators: ["readOnly"]
        });
        k.on(t, ve(i.toLowerCase(), this.NAME), (n) => {
          this._disposed || r({
            event: n
          });
        });
      }
    });
  },
  _refreshEvents: function() {
    var t = this._input();
    N(Qb, (e, i) => {
      k.off(t, ve(i.toLowerCase(), this.NAME));
    }), this._renderEvents();
  },
  _keyPressHandler: function() {
    this.option("text", this._input().val());
  },
  _keyDownHandler: function(t) {
    var e = this._input(), i = t.ctrlKey && or(t) === "enter", r = e.val() !== this.option("value");
    i && r && k.trigger(e, "change");
  },
  _getValueChangeEventOptionName: function() {
    return "valueChangeEvent";
  },
  _renderValueChangeEvent: function() {
    var t = ve(this._renderValueEventName(), "".concat(this.NAME, "TextChange")), e = ve(this.option(this._getValueChangeEventOptionName()), "".concat(this.NAME, "ValueChange")), i = ve("keydown", "".concat(this.NAME, "TextChange")), r = this._input();
    k.on(r, t, this._keyPressHandler.bind(this)), k.on(r, e, this._valueChangeEventHandler.bind(this)), k.on(r, i, this._keyDownHandler.bind(this));
  },
  _cleanValueChangeEvent: function() {
    var t = ".".concat(this.NAME, "ValueChange"), e = ".".concat(this.NAME, "TextChange");
    k.off(this._input(), t), k.off(this._input(), e);
  },
  _refreshValueChangeEvent: function() {
    this._cleanValueChangeEvent(), this._renderValueChangeEvent();
  },
  _renderValueEventName: function() {
    return "input change keypress";
  },
  _focusTarget: function() {
    return this._input();
  },
  _focusEventTarget: function() {
    return this.element();
  },
  _isInput: function(t) {
    return t === this._input().get(0);
  },
  _preventNestedFocusEvent: function(t) {
    if (t.isDefaultPrevented())
      return !0;
    var e = this._isNestedTarget(t.relatedTarget);
    return t.type === "focusin" ? e = e && this._isNestedTarget(t.target) && !this._isInput(t.target) : e || this._toggleFocusClass(!1, this.$element()), e && t.preventDefault(), e;
  },
  _isNestedTarget: function(t) {
    return !!this.$element().find(t).length;
  },
  _focusClassTarget: function() {
    return this.$element();
  },
  _focusInHandler: function(t) {
    this._preventNestedFocusEvent(t), this.callBase.apply(this, arguments);
  },
  _focusOutHandler: function(t) {
    this._preventNestedFocusEvent(t), this.callBase.apply(this, arguments);
  },
  _toggleFocusClass: function(t, e) {
    this.callBase(t, this._focusClassTarget(e));
  },
  _hasFocusClass: function(t) {
    return this.callBase(E(t || this.$element()));
  },
  _renderEmptinessEvent: function() {
    var t = this._input();
    k.on(t, "input blur", this._toggleEmptinessEventHandler.bind(this));
  },
  _toggleEmptinessEventHandler: function() {
    var t = this._input().val(), e = (t === "" || t === null) && this._isValueValid();
    this._toggleEmptiness(e);
  },
  _valueChangeEventHandler: function(t, e) {
    this.option("readOnly") || (this._saveValueChangeEvent(t), this.option("value", arguments.length > 1 ? e : this._input().val()), this._saveValueChangeEvent(void 0));
  },
  _renderEnterKeyAction: function() {
    this._enterKeyAction = this._createActionByOption("onEnterKey", {
      excludeValidators: ["readOnly"]
    }), k.off(this._input(), "keyup.onEnterKey.dxTextEditor"), k.on(this._input(), "keyup.onEnterKey.dxTextEditor", this._enterKeyHandlerUp.bind(this));
  },
  _enterKeyHandlerUp: function(t) {
    this._disposed || or(t) === "enter" && this._enterKeyAction({
      event: t
    });
  },
  _updateValue: function() {
    this._options.silent("text", null), this._renderValue();
  },
  _dispose: function() {
    this._enterKeyAction = void 0, this.callBase();
  },
  _getSubmitElement: function() {
    return this._input();
  },
  _hasActiveElement: function() {
    return this._input().is(de.getActiveElement(this._input()[0]));
  },
  _optionChanged: function(t) {
    var {
      name: e,
      fullName: i,
      value: r
    } = t, n = e.replace("on", "");
    if (Qb.includes(n)) {
      this._refreshEvents();
      return;
    }
    switch (e) {
      case "valueChangeEvent":
        this._refreshValueChangeEvent(), this._refreshFocusEvent(), this._refreshEvents();
        break;
      case "onValueChanged":
        this._createValueChangeAction();
        break;
      case "focusStateEnabled":
        this.callBase(t), this._toggleTabIndex();
        break;
      case "spellcheck":
        this._toggleSpellcheckState();
        break;
      case "mode":
        this._renderInputType();
        break;
      case "onEnterKey":
        this._renderEnterKeyAction();
        break;
      case "placeholder":
        this._renderPlaceholder(), this._setFieldAria(!0), this._input().attr({
          placeholder: this._getPlaceholderAttr()
        });
        break;
      case "label":
        this._label.updateText(r), this._setFieldAria(!0);
        break;
      case "labelMark":
        this._label.updateMark(r);
        break;
      case "labelMode":
        this._label.updateMode(r), this._setFieldAria();
        break;
      case "width":
        this.callBase(t), this._label.updateMaxWidth(this._getLabelContainerWidth());
        break;
      case "readOnly":
      case "disabled":
        this._updateButtons(), this.callBase(t);
        break;
      case "showClearButton":
        this._updateButtons(["clear"]);
        break;
      case "text":
        break;
      case "value":
        this._updateValue(), this.callBase(t);
        break;
      case "inputAttr":
        this._applyInputAttributes(this._input(), this.option(e));
        break;
      case "stylingMode":
        this._renderStylingMode(), this._updateLabelWidth();
        break;
      case "buttons":
        i === e && eG(r), this._cleanButtonContainers(), this._renderButtonContainers(), this._updateButtonsStyling(this.option("stylingMode")), this._updateLabelWidth(), this._label.updateContainsButtonsBefore(!!this._$beforeButtonsContainer);
        break;
      case "visible":
        this.callBase(t), r && this.option("buttons") && (this._cleanButtonContainers(), this._renderButtonContainers(), this._updateButtonsStyling(this.option("stylingMode")));
        break;
      case "displayValueFormatter":
        this._invalidate();
        break;
      case "showValidationMark":
        break;
      default:
        this.callBase(t);
    }
  },
  _renderInputType: function() {
    this._setInputType(this.option("mode"));
  },
  _setInputType: function(t) {
    var e = this._input();
    t === "search" && (t = "text");
    try {
      e.prop("type", t);
    } catch {
      e.prop("type", "text");
    }
  },
  getButton(t) {
    return this._buttonCollection.getButton(t);
  },
  focus: function() {
    k.trigger(this._input(), "focus");
  },
  clear: function() {
    this._showValidMark && (this._showValidMark = !1, this._renderValidationState());
    var t = this._getDefaultOptions();
    this.option("value") === t.value ? (this._options.silent("text", ""), this._renderValue()) : this.option("value", t.value);
  },
  _resetToInitialValue() {
    this.option("value") === this._initialValue ? (this._options.silent("text", this._initialValue), this._renderValue()) : this.callBase(), this._disposePendingIndicator(), this._showValidMark = !1, this._toggleValidMark();
  },
  _toggleValidMark() {
    this.$element().toggleClass(c_e, !!this._showValidMark);
  },
  reset: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
    arguments.length ? this.callBase(t) : this.callBase();
  },
  on: function(t, e) {
    var i = this.callBase(t, e), r = t.charAt(0).toUpperCase() + t.substr(1);
    return Qb.indexOf(r) >= 0 && this._refreshEvents(), i;
  }
}), HL = "dxMask", v_e = "blur beforedeactivate", V5 = " ", g_e = ["deleteContentBackward", "deleteSoftLineBackward", "deleteContent", "deleteHardLineBackward"], m_e = ["historyUndo", "historyRedo"], __e = ["focusIn", "focusOut", "input", "paste", "cut", "drop", "beforeInput"];
function C_e(t) {
  return V5.repeat(t);
}
class y_e {
  constructor(e) {
    this.editor = e;
  }
  _editorOption() {
    return this.editor.option(...arguments);
  }
  _editorInput() {
    return this.editor._input();
  }
  _editorCaret(e) {
    if (!e)
      return this.editor._caret();
    this.editor._caret(e);
  }
  _attachChangeEventHandler() {
    if (this._editorOption("valueChangeEvent").split(" ").includes("change")) {
      var e = this._editorInput(), i = ve(v_e, HL);
      k.on(e, i, (r) => {
        this.editor._changeHandler(r);
      });
    }
  }
  _beforeInputHandler() {
    this._previousText = this._editorOption("text"), this._prevCaret = this._editorCaret();
  }
  _inputHandler(e) {
    var {
      originalEvent: i
    } = e;
    if (i) {
      var {
        inputType: r
      } = i;
      if (m_e.includes(r))
        this._handleHistoryInputEvent();
      else if (g_e.includes(r))
        this._handleBackwardDeleteInputEvent();
      else {
        var n = this._editorCaret();
        if (!n.end)
          return;
        this._clearSelectedText(), this._autoFillHandler(i), this._editorCaret(n), this._handleInsertTextInputEvent(i.data);
      }
      this._editorOption("text") === this._previousText && e.stopImmediatePropagation();
    }
  }
  _handleHistoryInputEvent() {
    var e = this._editorCaret();
    this._updateEditorMask({
      start: e.start,
      length: e.end - e.start,
      text: ""
    }), this._editorCaret(this._prevCaret);
  }
  _handleBackwardDeleteInputEvent() {
    this._clearSelectedText();
    var e = this._editorCaret();
    this.editor.setForwardDirection(), this.editor._adjustCaret();
    var i = this._editorCaret();
    i.start !== e.start && (this.editor.setBackwardDirection(), this.editor._adjustCaret());
  }
  _clearSelectedText() {
    var e, i, r = ((e = this._prevCaret) === null || e === void 0 ? void 0 : e.end) - ((i = this._prevCaret) === null || i === void 0 ? void 0 : i.start) || 1, n = this._editorCaret();
    this._isAutoFill() || (this.editor.setBackwardDirection(), this._updateEditorMask({
      start: n.start,
      length: r,
      text: C_e(r)
    }));
  }
  _handleInsertTextInputEvent(e) {
    var i, r, n = e ?? "";
    this.editor.setForwardDirection();
    var a = this._updateEditorMask({
      start: (i = (r = this._prevCaret) === null || r === void 0 ? void 0 : r.start) !== null && i !== void 0 ? i : 0,
      length: n.length || 1,
      text: n
    });
    a || this._editorCaret(this._prevCaret);
  }
  _updateEditorMask(e) {
    var i = e.text.length, r = this.editor._handleChain(e);
    if (this.editor._displayMask(), this.editor.isForwardDirection()) {
      var {
        start: n,
        end: a
      } = this._editorCaret(), o = r - i, u = r > 1;
      u && i === 1 && this._editorCaret({
        start: n + o,
        end: a + o
      }), this.editor._adjustCaret();
    }
    return !!r;
  }
  _focusInHandler() {
    if (this.editor._showMaskPlaceholder(), this.editor.setForwardDirection(), !this.editor._isValueEmpty() && this._editorOption("isValid"))
      this.editor._adjustCaret();
    else {
      var e = this.editor._maskRulesChain.first();
      this._caretTimeout = setTimeout(() => {
        this._editorCaret({
          start: e,
          end: e
        });
      }, 0);
    }
  }
  _focusOutHandler(e) {
    this.editor._changeHandler(e), this._editorOption("showMaskMode") === "onFocus" && this.editor._isValueEmpty() && (this._editorOption("text", ""), this.editor._renderDisplayText(""));
  }
  _delHandler(e) {
    var {
      editor: i
    } = this;
    i._maskKeyHandler(e, () => {
      i._hasSelection() || i._handleKey(V5);
    });
  }
  _cutHandler(e) {
    var i = this._editorCaret(), r = this._editorInput().val().substring(i.start, i.end);
    this.editor._maskKeyHandler(e, () => Lk(e, r));
  }
  _dropHandler() {
    this._clearDragTimer(), this._dragTimer = setTimeout(() => {
      var e = this.editor._convertToValue(this._editorInput().val());
      this._editorOption("value", e);
    });
  }
  _pasteHandler(e) {
    var {
      editor: i
    } = this;
    if (!this._editorOption("disabled")) {
      var r = this._editorCaret();
      i._maskKeyHandler(e, () => {
        var n = Lk(e), a = i._maskRulesChain.text().substring(r.end), o = i._handleChain({
          text: n,
          start: r.start,
          length: n.length
        }), u = r.start + o;
        i._handleChain({
          text: a,
          start: u,
          length: a.length
        }), i._caret({
          start: u,
          end: u
        });
      });
    }
  }
  _autoFillHandler(e) {
    var {
      editor: i
    } = this, r = this._editorInput().val();
    this._inputHandlerTimer = setTimeout(() => {
      this._isAutoFill() && (i._maskKeyHandler(e, () => {
        i._handleChain({
          text: r,
          start: 0,
          length: r.length
        });
      }), i._validateMask());
    });
  }
  _isAutoFill() {
    var e = this._editorInput();
    if ($i.webkit) {
      var i, r = e.get(0);
      return (i = r == null ? void 0 : r.matches(":-webkit-autofill")) !== null && i !== void 0 ? i : !1;
    }
    return !1;
  }
  _clearDragTimer() {
    clearTimeout(this._dragTimer);
  }
  _clearTimers() {
    this._clearDragTimer(), clearTimeout(this._caretTimeout), clearTimeout(this._inputHandlerTimer);
  }
  getHandler(e) {
    return (i) => {
      var r;
      (r = this["_".concat(e, "Handler")]) === null || r === void 0 || r.call(this, i);
    };
  }
  attachEvents() {
    var e = this._editorInput();
    __e.forEach((i) => {
      var r = ve(i.toLowerCase(), HL);
      k.on(e, r, this.getHandler(i));
    }), this._attachChangeEventHandler();
  }
  detachEvents() {
    this._clearTimers(), k.off(this._editorInput(), ".".concat(HL));
  }
  clean() {
    this._clearTimers();
  }
}
var tG = Ime, iG = " ", x_e = "\\", rG = "dx-texteditor-masked", $L = "forward", S_e = "backward", E_e = "drop", b_e = {
  0: /[0-9]/,
  9: /[0-9\s]/,
  "#": /[-+0-9\s]/,
  L: function(t) {
    return Zb(t);
  },
  l: function(t) {
    return Zb(t) || aG(t);
  },
  C: /\S/,
  c: /./,
  A: function(t) {
    return Zb(t) || nG(t);
  },
  a: function(t) {
    return Zb(t) || nG(t) || aG(t);
  }
};
function nG(t) {
  return /[0-9]/.test(t);
}
function Zb(t) {
  var e = t.charCodeAt();
  return 64 < e && e < 91 || 96 < e && e < 123 || e > 127;
}
function aG(t) {
  return t === " ";
}
var bB = p_e.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      mask: "",
      maskChar: "_",
      maskRules: {},
      maskInvalidMessage: X.format("validation-mask"),
      useMaskedValue: !1,
      showMaskMode: "always"
    });
  },
  _supportedKeys: function() {
    var t = this, e = {
      del: t._maskStrategy.getHandler("del"),
      enter: t._changeHandler
    }, i = t.callBase();
    return N(e, function(r, n) {
      var a = i[r];
      i[r] = function(o) {
        t.option("mask") && n.call(t, o), a && a(o);
      };
    }), i;
  },
  _getSubmitElement: function() {
    return this.option("mask") ? this._$hiddenElement : this.callBase();
  },
  _init: function() {
    this.callBase(), this._initMaskStrategy();
  },
  _initMaskStrategy: function() {
    this._maskStrategy = new y_e(this);
  },
  _initMarkup: function() {
    this._renderHiddenElement(), this.callBase();
  },
  _attachMouseWheelEventHandlers: function() {
    var t = this._onMouseWheel !== ee;
    if (t) {
      var e = this._input(), i = ve(lS, this.NAME), r = this._createAction((function(n) {
        var {
          event: a
        } = n;
        Ah(e) && !Cn(a) && (this._onMouseWheel(a), a.preventDefault(), a.stopPropagation());
      }).bind(this));
      k.off(e, i), k.on(e, i, function(n) {
        r({
          event: n
        });
      });
    }
  },
  _onMouseWheel: ee,
  _useMaskBehavior() {
    return !!this.option("mask");
  },
  _attachDropEventHandler() {
    var t = this._useMaskBehavior();
    if (t) {
      var e = ve(E_e, this.NAME), i = this._input();
      k.off(i, e), k.on(i, e, (r) => r.preventDefault());
    }
  },
  _render() {
    this._renderMask(), this.callBase(), this._attachDropEventHandler(), this._attachMouseWheelEventHandlers();
  },
  _renderHiddenElement: function() {
    this.option("mask") && (this._$hiddenElement = E("<input>").attr("type", "hidden").appendTo(this._inputWrapper()));
  },
  _removeHiddenElement: function() {
    this._$hiddenElement && this._$hiddenElement.remove();
  },
  _renderMask: function() {
    this.$element().removeClass(rG), this._maskRulesChain = null, this._maskStrategy.detachEvents(), this.option("mask") && (this.$element().addClass(rG), this._maskStrategy.attachEvents(), this._parseMask(), this._renderMaskedValue());
  },
  _changeHandler: function(t) {
    var e = this._input(), i = e.val();
    if (i !== this._changedValue) {
      this._changedValue = i;
      var r = Ch(t, {
        type: "change"
      });
      k.trigger(e, r);
    }
  },
  _parseMask: function() {
    this._maskRules = P({}, b_e, this.option("maskRules")), this._maskRulesChain = this._parseMaskRule(0);
  },
  _parseMaskRule: function(t) {
    var e = this.option("mask");
    if (t >= e.length)
      return new Dme();
    var i = e[t], r = i === x_e, n = r ? new NU({
      maskChar: e[t + 1]
    }) : this._getMaskRule(i);
    return n.next(this._parseMaskRule(t + 1 + r)), n;
  },
  _getMaskRule: function(t) {
    var e;
    return N(this._maskRules, function(i, r) {
      if (i === t)
        return e = {
          pattern: i,
          allowedChars: r
        }, !1;
    }), R(e) ? new F5(P({
      maskChar: this.option("maskChar") || " "
    }, e)) : new NU({
      maskChar: t
    });
  },
  _renderMaskedValue: function() {
    if (this._maskRulesChain) {
      var t = this.option("value") || "";
      this._maskRulesChain.clear(this._normalizeChainArguments());
      var e = {
        length: t.length
      };
      e[this._isMaskedValueMode() ? "text" : "value"] = t, this._handleChain(e), this._displayMask();
    }
  },
  _replaceSelectedText: function(t, e, i) {
    if (i === void 0)
      return t;
    var r = t.slice(0, e.start), n = t.slice(e.end), a = r + i + n;
    return a;
  },
  _isMaskedValueMode: function() {
    return this.option("useMaskedValue");
  },
  _displayMask: function(t) {
    t = t || this._caret(), this._renderValue(), this._caret(t);
  },
  _isValueEmpty: function() {
    return Pw(this._value);
  },
  _shouldShowMask: function() {
    var t = this.option("showMaskMode");
    return t === "onFocus" ? Ah(this._input()) || !this._isValueEmpty() : !0;
  },
  _showMaskPlaceholder: function() {
    if (this._shouldShowMask()) {
      var t = this._maskRulesChain.text();
      this.option("text", t), this.option("showMaskMode") === "onFocus" && this._renderDisplayText(t);
    }
  },
  _renderValue: function() {
    if (this._maskRulesChain && (this._showMaskPlaceholder(), this._$hiddenElement)) {
      var t = this._maskRulesChain.value(), e = Pw(t) ? "" : this._getPreparedValue();
      this._$hiddenElement.val(e);
    }
    return this.callBase();
  },
  _getPreparedValue: function() {
    return this._convertToValue().replace(/\s+$/, "");
  },
  _valueChangeEventHandler: function(t) {
    if (!this._maskRulesChain) {
      this.callBase.apply(this, arguments);
      return;
    }
    this._saveValueChangeEvent(t), this.option("value", this._getPreparedValue());
  },
  _isControlKeyFired: function(t) {
    return this._isControlKey(or(t)) || Cn(t);
  },
  _handleChain: function(t) {
    var e = this._maskRulesChain.handle(this._normalizeChainArguments(t));
    return this._updateMaskInfo(), e;
  },
  _normalizeChainArguments: function(t) {
    return t = t || {}, t.index = 0, t.fullText = this._maskRulesChain.text(), t;
  },
  _convertToValue: function(t) {
    return this._isMaskedValueMode() ? t = this._replaceMaskCharWithEmpty(t || this._textValue || "") : t = t || this._value || "", t;
  },
  _replaceMaskCharWithEmpty: function(t) {
    return t.replace(new RegExp(this.option("maskChar"), "g"), iG);
  },
  _maskKeyHandler: function(t, e) {
    if (!this.option("readOnly")) {
      this.setForwardDirection(), t.preventDefault(), this._handleSelection();
      var i = this._input().val(), r = () => {
        i !== this._input().val() && k.trigger(this._input(), "input");
      }, n = e();
      n ? n.then(r) : (this.setForwardDirection(), this._adjustCaret(), this._displayMask(), this._maskRulesChain.reset(), r());
    }
  },
  _handleKey: function(t, e) {
    this._direction(e || $L), this._adjustCaret(t), this._handleKeyChain(t), this._moveCaret();
  },
  _handleSelection: function() {
    if (this._hasSelection()) {
      var t = this._caret(), e = new Array(t.end - t.start + 1).join(iG);
      this._handleKeyChain(e);
    }
  },
  _handleKeyChain: function(t) {
    var e = this._caret(), i = this.isForwardDirection() ? e.start : e.start - 1, r = this.isForwardDirection() ? e.end : e.end - 1, n = i === r ? 1 : r - i;
    this._handleChain({
      text: t,
      start: i,
      length: n
    });
  },
  _tryMoveCaretBackward: function() {
    this.setBackwardDirection();
    var t = this._caret().start;
    return this._adjustCaret(), !t || t !== this._caret().start;
  },
  _adjustCaret: function(t) {
    var e = this._caret().start, i = this.isForwardDirection(), r = this._maskRulesChain.adjustedCaret(e, i, t);
    this._caret({
      start: r,
      end: r
    });
  },
  _moveCaret: function() {
    var t = this._caret().start, e = t + (this.isForwardDirection() ? 0 : -1), i = this._maskRulesChain.isAccepted(e) ? t + (this.isForwardDirection() ? 1 : -1) : t;
    this._caret({
      start: i,
      end: i
    });
  },
  _caret: function(t, e) {
    var i = this._input();
    if (i.length) {
      if (!arguments.length)
        return tG(i);
      tG(i, t, e);
    }
  },
  _hasSelection: function() {
    var t = this._caret();
    return t.start !== t.end;
  },
  _direction: function(t) {
    if (!arguments.length)
      return this._typingDirection;
    this._typingDirection = t;
  },
  setForwardDirection: function() {
    this._direction($L);
  },
  setBackwardDirection: function() {
    this._direction(S_e);
  },
  isForwardDirection: function() {
    return this._direction() === $L;
  },
  _updateMaskInfo() {
    this._textValue = this._maskRulesChain.text(), this._value = this._maskRulesChain.value();
  },
  _clean: function() {
    this._maskStrategy && this._maskStrategy.clean(), this.callBase();
  },
  _validateMask: function() {
    if (this._maskRulesChain) {
      var t = Pw(this.option("value")) || this._maskRulesChain.isValid(this._normalizeChainArguments());
      this.option({
        isValid: t,
        validationError: t ? null : {
          editorSpecific: !0,
          message: this.option("maskInvalidMessage")
        }
      });
    }
  },
  _updateHiddenElement: function() {
    this._removeHiddenElement(), this.option("mask") && (this._input().removeAttr("name"), this._renderHiddenElement()), this._setSubmitElementName(this.option("name"));
  },
  _updateMaskOption: function() {
    this._updateHiddenElement(), this._renderMask(), this._validateMask(), this._refreshValueChangeEvent();
  },
  _processEmptyMask: function(t) {
    if (!t) {
      var e = this.option("value");
      this.option({
        text: e,
        isValid: !0,
        validationError: null
      }), this.validationRequest.fire({
        value: e,
        editor: this
      }), this._renderValue();
    }
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "mask":
        this._updateMaskOption(), this._processEmptyMask(t.value);
        break;
      case "maskChar":
      case "maskRules":
      case "useMaskedValue":
        this._updateMaskOption();
        break;
      case "value":
        this._renderMaskedValue(), this._validateMask(), this.callBase(t), this._changedValue = this._input().val();
        break;
      case "maskInvalidMessage":
        break;
      case "showMaskMode":
        this.option("text", ""), this._renderValue();
        break;
      default:
        this.callBase(t);
    }
  },
  clear: function() {
    var {
      value: t
    } = this._getDefaultOptions();
    this.option("value") === t && this._renderMaskedValue(), this.callBase();
  }
});
ti("dxTextEditor", bB);
var w_e = Ot(), T_e = ["backspace", "tab", "enter", "pageUp", "pageDown", "end", "home", "leftArrow", "rightArrow", "downArrow", "upArrow", "del"], I_e = "dx-textbox", oG = "dx-searchbox", D_e = "dx-icon", A_e = "dx-icon-search", ES = bB.inherit({
  ctor: function(t, e) {
    e && (this._showClearButton = e.showClearButton), this.callBase.apply(this, arguments);
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      value: "",
      mode: "text",
      maxLength: null
    });
  },
  _initMarkup: function() {
    this.$element().addClass(I_e), this.callBase(), this.setAria("role", "textbox");
  },
  _renderInputType: function() {
    this.callBase(), this._renderSearchMode();
  },
  _useTemplates: function() {
    return !1;
  },
  _renderProps: function() {
    this.callBase(), this._toggleMaxLengthProp();
  },
  _toggleMaxLengthProp: function() {
    var t = this._getMaxLength();
    t && t > 0 ? this._input().attr("maxLength", t) : this._input().removeAttr("maxLength");
  },
  _renderSearchMode: function() {
    var t = this._$element;
    this.option("mode") === "search" ? (t.addClass(oG), this._renderSearchIcon(), this._showClearButton === void 0 && (this._showClearButton = this.option("showClearButton"), this.option("showClearButton", !0))) : (t.removeClass(oG), this._$searchIcon && this._$searchIcon.remove(), this.option("showClearButton", this._showClearButton === void 0 ? this.option("showClearButton") : this._showClearButton), delete this._showClearButton);
  },
  _renderSearchIcon: function() {
    var t = E("<div>").addClass(D_e).addClass(A_e);
    t.prependTo(this._input().parent()), this._$searchIcon = t;
  },
  _getLabelContainerWidth: function() {
    if (this._$searchIcon) {
      var t = this._input().parent();
      return mt(t) - this._getLabelBeforeWidth();
    }
    return this.callBase();
  },
  _getLabelBeforeWidth: function() {
    var t = this.callBase();
    return this._$searchIcon && (t += oi(this._$searchIcon)), t;
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "maxLength":
        this._toggleMaxLengthProp();
        break;
      case "mode":
        this.callBase(t), this._updateLabelWidth();
        break;
      case "mask":
        this.callBase(t), this._toggleMaxLengthProp();
        break;
      default:
        this.callBase(t);
    }
  },
  _onKeyDownCutOffHandler: function(t) {
    var e = this._getMaxLength();
    if (e && !t.ctrlKey && !this._hasSelection()) {
      var i = E(t.target), r = or(t);
      return this._cutOffExtraChar(i), i.val().length < e || T_e.includes(r) || w_e.getSelection().toString() !== "";
    } else
      return !0;
  },
  _onChangeCutOffHandler: function(t) {
    var e = E(t.target);
    this.option("maxLength") && this._cutOffExtraChar(e);
  },
  _cutOffExtraChar: function(t) {
    var e = this._getMaxLength(), i = t.val();
    e && i.length > e && t.val(i.substr(0, e));
  },
  _getMaxLength: function() {
    var t = !!this.option("mask");
    return t ? null : this.option("maxLength");
  }
});
ti("dxTextBox", ES);
var O_e = wi.inherit({
  ctor: function() {
    this._dataStructure = [], this._itemsCount = 0, this._visibleItemsCount = 0;
  },
  _indexByKey: {},
  _convertItemsToNodes: function(t, e) {
    var i = this;
    N(t, function(r, n) {
      var a = R(e) ? e : i._getParentId(n), o = i._convertItemToNode(n, a);
      i._dataStructure.push(o), i._checkForDuplicateId(o.internalFields.key), i._indexByKey[o.internalFields.key] = i._dataStructure.length - 1, i._itemHasChildren(n) && i._convertItemsToNodes(i._dataAccessors.getters.items(n), o.internalFields.key);
    });
  },
  _checkForDuplicateId: function(t) {
    if (R(this._indexByKey[t]))
      throw Yt.Error("E1040", t);
  },
  _getParentId: function(t) {
    return this._dataType === "plain" ? this._dataAccessors.getters.parentKey(t) : void 0;
  },
  _itemHasChildren: function(t) {
    if (this._dataType !== "plain") {
      var e = this._dataAccessors.getters.items(t);
      return e && e.length;
    }
  },
  _getUniqueKey: function(t) {
    var e = this._dataAccessors.getters.key, i = e(t), r = e && (i || i === 0) && sx(i);
    return r ? i : this.getItemsCount();
  },
  _convertItemToNode: function(t, e) {
    this._itemsCount++, t.visible !== !1 && this._visibleItemsCount++;
    var i = {
      internalFields: {
        disabled: this._dataAccessors.getters.disabled(t, {
          defaultValue: !1
        }),
        expanded: this._dataAccessors.getters.expanded(t, {
          defaultValue: !1
        }),
        selected: this._dataAccessors.getters.selected(t, {
          defaultValue: !1
        }),
        key: this._getUniqueKey(t),
        parentKey: R(e) ? e : this._rootValue,
        item: this._makeObjectFromPrimitive(t),
        childrenKeys: []
      }
    };
    return P(i, t), delete i.items, i;
  },
  setChildrenKeys: function() {
    var t = this;
    N(this._dataStructure, function(e, i) {
      if (i.internalFields.parentKey !== t._rootValue) {
        var r = t.getParentNode(i);
        r && r.internalFields.childrenKeys.push(i.internalFields.key);
      }
    });
  },
  _makeObjectFromPrimitive: function(t) {
    if (sx(t)) {
      var e = t;
      t = {}, this._dataAccessors.setters.key(t, e);
    }
    return t;
  },
  _convertToPublicNode: function(t, e) {
    if (!t)
      return null;
    var i = {
      text: this._dataAccessors.getters.display(t),
      key: t.internalFields.key,
      selected: t.internalFields.selected,
      expanded: t.internalFields.expanded,
      disabled: t.internalFields.disabled,
      parent: e || null,
      itemData: t.internalFields.item,
      children: [],
      items: []
    };
    return i.parent && (i.parent.children.push(i), i.parent.items.push(i)), i;
  },
  convertToPublicNodes: function(t, e) {
    if (!t.length)
      return [];
    var i = this, r = [];
    return N(t, function(n, a) {
      a = sx(a) ? i._getByKey(a) : a;
      var o = i._convertToPublicNode(a, e);
      o.children = i.convertToPublicNodes(a.internalFields.childrenKeys, o), r.push(o), a.internalFields.publicNode = o;
    }), r;
  },
  setDataAccessors: function(t) {
    this._dataAccessors = t;
  },
  _getByKey: function(t) {
    return this._dataStructure[this.getIndexByKey(t)] || null;
  },
  getParentNode: function(t) {
    return this._getByKey(t.internalFields.parentKey);
  },
  getByKey: function(t, e) {
    if (e == null)
      return null;
    var i = null, r = this, n = function(a, o) {
      return N(a, function(u, c) {
        var p = c.internalFields && c.internalFields.key || r._dataAccessors.getters.key(c);
        if (p.toString() === o.toString())
          return i = c, !1;
      }), i;
    };
    return n(t, e);
  },
  getItemsCount: function() {
    return this._itemsCount;
  },
  getVisibleItemsCount: function() {
    return this._visibleItemsCount;
  },
  updateIndexByKey: function() {
    var t = this;
    this._indexByKey = {}, N(this._dataStructure, function(e, i) {
      t._checkForDuplicateId(i.internalFields.key), t._indexByKey[i.internalFields.key] = e;
    });
  },
  updateChildrenKeys: function() {
    this._indexByKey = {}, this.removeChildrenKeys(), this.updateIndexByKey(), this.setChildrenKeys();
  },
  removeChildrenKeys: function() {
    this._indexByKey = {}, N(this._dataStructure, function(t, e) {
      e.internalFields.childrenKeys = [];
    });
  },
  getIndexByKey: function(t) {
    return this._indexByKey[t];
  },
  createPlainStructure: function(t, e, i) {
    return this._itemsCount = 0, this._visibleItemsCount = 0, this._rootValue = e, this._dataType = i, this._indexByKey = {}, this._convertItemsToNodes(t), this.setChildrenKeys(), this._dataStructure;
  }
}), Xg = "expanded", Zf = "selected", R_e = "disabled";
Mp.setEditorClass(ES);
var L_e = wi.inherit({
  ctor: function(t) {
    this.options = {}, P(this.options, this._defaultOptions(), t), this.options.dataConverter.setDataAccessors(this.options.dataAccessors), this._selectedNodesKeys = [], this._expandedNodesKeys = [], this._dataStructure = [], this._createInternalDataStructure(), this.getTreeNodes();
  },
  setOption: function(t, e) {
    this.options[t] = e, t === "recursiveSelection" && this._updateSelection();
  },
  _defaultOptions: function() {
    return {
      dataAccessors: void 0,
      items: [],
      multipleSelection: !0,
      recursiveSelection: !1,
      recursiveExpansion: !1,
      rootValue: 0,
      searchValue: "",
      dataType: "tree",
      searchMode: "contains",
      dataConverter: new O_e(),
      onNodeChanged: ee,
      sort: null
    };
  },
  _createInternalDataStructure: function() {
    this._initialDataStructure = this.options.dataConverter.createPlainStructure(this.options.items, this.options.rootValue, this.options.dataType), this._dataStructure = this.options.searchValue.length ? this.search(this.options.searchValue) : this._initialDataStructure, this.options.dataConverter._dataStructure = this._dataStructure, this._updateSelection(), this._updateExpansion();
  },
  _updateSelection: function() {
    this.options.recursiveSelection && (this._setChildrenSelection(), this._setParentSelection()), this._selectedNodesKeys = this._updateNodesKeysArray(Zf);
  },
  _updateExpansion: function(t) {
    this.options.recursiveExpansion && (t ? this._updateOneBranch(t) : this._setParentExpansion()), this._expandedNodesKeys = this._updateNodesKeysArray(Xg);
  },
  _updateNodesKeysArray: function(t) {
    var e = this, i = [];
    return N(e._getDataBySelectionMode(), function(r, n) {
      e._isNodeVisible(n) && n.internalFields[t] && (t === Xg || e.options.multipleSelection ? i.push(n.internalFields.key) : (i.length && e.toggleSelection(i[0], !1, !0), i = [n.internalFields.key]));
    }), i;
  },
  _getDataBySelectionMode: function() {
    return this.options.multipleSelection ? this.getData() : this.getFullData();
  },
  _isNodeVisible: function(t) {
    return t.internalFields.item.visible !== !1;
  },
  _getByKey: function(t, e) {
    return t === this._dataStructure ? this.options.dataConverter._getByKey(e) : this.options.dataConverter.getByKey(t, e);
  },
  _setChildrenSelection: function() {
    var t = this;
    N(this._dataStructure, function(e, i) {
      if (i.internalFields.childrenKeys.length) {
        var r = i.internalFields.selected;
        r === !0 && t._toggleChildrenSelection(i, r);
      }
    });
  },
  _setParentSelection: function() {
    var t = this;
    N(this._dataStructure, function(e, i) {
      var r = t.options.dataConverter.getParentNode(i);
      r && i.internalFields.parentKey !== t.options.rootValue && t._iterateParents(i, function(n) {
        var a = t._calculateSelectedState(n);
        t._setFieldState(n, Zf, a);
      });
    });
  },
  _setParentExpansion: function() {
    var t = this;
    N(this._dataStructure, function(e, i) {
      i.internalFields.expanded && t._updateOneBranch(i.internalFields.key);
    });
  },
  _updateOneBranch: function(t) {
    var e = this, i = this.getNodeByKey(t);
    e._iterateParents(i, function(r) {
      e._setFieldState(r, Xg, !0);
    });
  },
  _iterateChildren: function(t, e, i, r) {
    if (Le(i)) {
      var n = this, a = t.internalFields.key;
      r = r || [], r.indexOf(a) === -1 && (r.push(a), N(t.internalFields.childrenKeys, function(o, u) {
        var c = n.getNodeByKey(u);
        i(c), c.internalFields.childrenKeys.length && e && n._iterateChildren(c, e, i, r);
      }));
    }
  },
  _iterateParents: function(t, e, i) {
    if (!(t.internalFields.parentKey === this.options.rootValue || !Le(e))) {
      i = i || [];
      var r = t.internalFields.key;
      if (i.indexOf(r) === -1) {
        i.push(r);
        var n = this.options.dataConverter.getParentNode(t);
        n && (e(n), n.internalFields.parentKey !== this.options.rootValue && this._iterateParents(n, e, i));
      }
    }
  },
  _calculateSelectedState: function(t) {
    for (var e = t.internalFields.childrenKeys.length, i = 0, r = 0, n = !1, a = 0; a <= e - 1; a++) {
      var o = this.getNodeByKey(t.internalFields.childrenKeys[a]), u = o.internalFields.item.visible === !1, c = o.internalFields.selected;
      if (u) {
        r++;
        continue;
      }
      c ? i++ : c === void 0 && (i += 0.5);
    }
    return i && (n = i === e - r ? !0 : void 0), n;
  },
  _toggleChildrenSelection: function(t, e) {
    var i = this;
    this._iterateChildren(t, !0, function(r) {
      i._isNodeVisible(r) && i._setFieldState(r, Zf, e);
    });
  },
  _setFieldState: function(t, e, i) {
    t.internalFields[e] !== i && (t.internalFields[e] = i, t.internalFields.publicNode && (t.internalFields.publicNode[e] = i), this.options.dataAccessors.setters[e](t.internalFields.item, i), this.options.onNodeChanged(t));
  },
  _markChildren: function(t) {
    var e = this;
    N(t, function(i, r) {
      var n = e.getIndexByKey(r), a = e.getNodeByKey(r);
      e._dataStructure[n] = 0, a.internalFields.childrenKeys.length && e._markChildren(a.internalFields.childrenKeys);
    });
  },
  _removeNode: function(t) {
    var e = this.getNodeByKey(t);
    this._dataStructure[this.getIndexByKey(t)] = 0, this._markChildren(e.internalFields.childrenKeys);
    var i = this, r = 0, n = P([], this._dataStructure);
    N(n, function(a, o) {
      o || (i._dataStructure.splice(a - r, 1), r++);
    });
  },
  _addNode: function(t) {
    var e = this.options.dataConverter, i = e._convertItemToNode(t, this.options.dataAccessors.getters.parentKey(t));
    this._dataStructure = this._dataStructure.concat(i), this._initialDataStructure = this._initialDataStructure.concat(i), e._dataStructure = e._dataStructure.concat(i);
  },
  _updateFields: function() {
    this.options.dataConverter.updateChildrenKeys(), this._updateSelection(), this._updateExpansion();
  },
  getSelectedNodesKeys: function() {
    return this._selectedNodesKeys;
  },
  getExpandedNodesKeys: function() {
    return this._expandedNodesKeys;
  },
  getData: function() {
    return this._dataStructure;
  },
  getFullData: function() {
    return this._initialDataStructure;
  },
  getNodeByItem: function(t) {
    var e = null;
    return N(this._dataStructure, function(i, r) {
      if (r.internalFields.item === t)
        return e = r, !1;
    }), e;
  },
  getNodesByItems: function(t) {
    var e = this, i = [];
    return N(t, function(r, n) {
      var a = e.getNodeByItem(n);
      a && i.push(a);
    }), i;
  },
  getNodeByKey: function(t, e) {
    return this._getByKey(e || this._getDataBySelectionMode(), t);
  },
  getTreeNodes: function() {
    return this.options.dataConverter.convertToPublicNodes(this.getRootNodes());
  },
  getItemsCount: function() {
    return this.options.dataConverter.getItemsCount();
  },
  getVisibleItemsCount: function() {
    return this.options.dataConverter.getVisibleItemsCount();
  },
  getPublicNode: function(t) {
    return t.internalFields.publicNode;
  },
  getRootNodes: function() {
    return this.getChildrenNodes(this.options.rootValue);
  },
  getChildrenNodes: function(t) {
    return lo(this._dataStructure, {
      langParams: this.options.langParams
    }).filter(["internalFields.parentKey", t]).toArray();
  },
  getIndexByKey: function(t) {
    return this.options.dataConverter.getIndexByKey(t);
  },
  addItem: function(t) {
    this._addNode(t), this._updateFields();
  },
  removeItem: function(t) {
    this._removeNode(t), this._updateFields();
  },
  toggleSelection: function(t, e, i) {
    var r = this._isSingleModeUnselect(e), n = this._getByKey(i || r ? this._initialDataStructure : this._dataStructure, t);
    this._setFieldState(n, Zf, e), this.options.recursiveSelection && !i && (e ? this._setChildrenSelection() : this._toggleChildrenSelection(n, e), this._setParentSelection()), this._selectedNodesKeys = this._updateNodesKeysArray(Zf);
  },
  _isSingleModeUnselect: function(t) {
    return !this.options.multipleSelection && !t;
  },
  toggleNodeDisabledState: function(t, e) {
    var i = this.getNodeByKey(t);
    this._setFieldState(i, R_e, e);
  },
  toggleSelectAll: function(t) {
    if (R(t)) {
      var e = this, i = e._selectedNodesKeys[e._selectedNodesKeys.length - 1], r = e._isSingleModeUnselect(t) ? this._initialDataStructure : this._dataStructure;
      N(r, function(n, a) {
        e._isNodeVisible(a) && e._setFieldState(a, Zf, t);
      }), e._selectedNodesKeys = e._updateNodesKeysArray(Zf), !t && e.options.selectionRequired && e.toggleSelection(i, !0);
    }
  },
  isAllSelected: function() {
    return this.getSelectedNodesKeys().length ? this.getSelectedNodesKeys().length === this.getVisibleItemsCount() ? !0 : void 0 : !1;
  },
  toggleExpansion: function(t, e) {
    var i = this.getNodeByKey(t);
    this._setFieldState(i, Xg, e), e && this._updateExpansion(t), this._expandedNodesKeys = this._updateNodesKeysArray(Xg);
  },
  isFiltered: function(t) {
    return !this.options.searchValue.length || !!this._filterDataStructure(this.options.searchValue, [t]).length;
  },
  _createCriteria: function(t, e, i) {
    var r = [];
    return Array.isArray(t) ? (N(t, function(n, a) {
      r.push([a, i, e], "or");
    }), r.pop(), r) : [t, i, e];
  },
  _filterDataStructure: function(t, e) {
    var i = this.options.searchExpr || this.options.dataAccessors.getters.display, r = Mp.getOperationBySearchMode(this.options.searchMode), n = this._createCriteria(i, t, r);
    return e = e || this._initialDataStructure, lo(e, {
      langParams: this.options.langParams
    }).filter(n).toArray();
  },
  search: function(t) {
    var e = this, i = this._filterDataStructure(t), r = this.options.dataConverter;
    return function n(a, o) {
      for (var u = a.length; o < u; ) {
        var c = a[o];
        if (c.internalFields.parentKey === e.options.rootValue) {
          o++;
          continue;
        }
        var p = r.getParentNode(c);
        if (!p) {
          Yt.log("W1007", c.internalFields.parentKey, c.internalFields.key), o++;
          continue;
        }
        if (p.internalFields.expanded || e._setFieldState(p, Xg, !0), a.includes(p)) {
          o++;
          continue;
        }
        a.splice(o, 0, p), n(a, o);
      }
    }(i, 0), this.options.sort && (i = rc.queryByOptions(lo(i), {
      sort: this.options.sort,
      langParams: this.options.langParams
    }).toArray()), r._indexByKey = {}, N(i, function(n, a) {
      a.internalFields.childrenKeys = [], r._indexByKey[a.internalFields.key] = n;
    }), r._dataStructure = i, r.setChildrenKeys(), r._dataStructure;
  }
}), sG = "_dataSourceOptions", lG = "_dataSourceChangedHandler", uG = "_dataSourceLoadErrorHandler", dG = "_dataSourceLoadingChangedHandler", cG = "_dataSourceFromUrlLoadMode", hG = "_getSpecificDataSourceOption", fG = "_normalizeDataSource", wB = {
  postCtor: function() {
    this.on("disposing", (function() {
      this._disposeDataSource();
    }).bind(this));
  },
  _refreshDataSource: function() {
    this._initDataSource(), this._loadDataSource();
  },
  _initDataSource: function() {
    var t = hG in this ? this[hG]() : this.option("dataSource"), e, i;
    this._disposeDataSource(), t && (t instanceof Ks ? (this._isSharedDataSource = !0, this._dataSource = t) : (e = sG in this ? this[sG]() : {}, i = this._dataSourceType ? this._dataSourceType() : Ks, t = zp(t, {
      fromUrlLoadMode: cG in this && this[cG]()
    }), this._dataSource = new i(P(!0, {}, e, t))), fG in this && (this._dataSource = this[fG](this._dataSource)), this._addDataSourceHandlers(), this._initDataController());
  },
  _initDataController: function() {
    var t, e = (t = this.option) === null || t === void 0 ? void 0 : t.call(this, "_dataController"), i = this._dataSource;
    e ? this._dataController = e : this._dataController = new m5(i);
  },
  _addDataSourceHandlers: function() {
    lG in this && this._addDataSourceChangeHandler(), uG in this && this._addDataSourceLoadErrorHandler(), dG in this && this._addDataSourceLoadingChangedHandler(), this._addReadyWatcher();
  },
  _addReadyWatcher: function() {
    this.readyWatcher = (function(t) {
      this._ready && this._ready(!t);
    }).bind(this), this._dataSource.on("loadingChanged", this.readyWatcher);
  },
  _addDataSourceChangeHandler: function() {
    var t = this._dataSource;
    this._proxiedDataSourceChangedHandler = (function(e) {
      this[lG](t.items(), e);
    }).bind(this), t.on("changed", this._proxiedDataSourceChangedHandler);
  },
  _addDataSourceLoadErrorHandler: function() {
    this._proxiedDataSourceLoadErrorHandler = this[uG].bind(this), this._dataSource.on("loadError", this._proxiedDataSourceLoadErrorHandler);
  },
  _addDataSourceLoadingChangedHandler: function() {
    this._proxiedDataSourceLoadingChangedHandler = this[dG].bind(this), this._dataSource.on("loadingChanged", this._proxiedDataSourceLoadingChangedHandler);
  },
  _loadDataSource: function() {
    var t = this._dataSource;
    t && (t.isLoaded() ? this._proxiedDataSourceChangedHandler && this._proxiedDataSourceChangedHandler() : t.load());
  },
  _loadSingle: function(t, e) {
    return t = t === "this" ? this._dataSource.key() || "this" : t, this._dataSource.loadSingle(t, e);
  },
  _isLastPage: function() {
    return !this._dataSource || this._dataSource.isLastPage() || !this._dataSource._pageSize;
  },
  _isDataSourceLoading: function() {
    return this._dataSource && this._dataSource.isLoading();
  },
  _disposeDataSource: function() {
    this._dataSource && (this._isSharedDataSource ? (delete this._isSharedDataSource, this._proxiedDataSourceChangedHandler && this._dataSource.off("changed", this._proxiedDataSourceChangedHandler), this._proxiedDataSourceLoadErrorHandler && this._dataSource.off("loadError", this._proxiedDataSourceLoadErrorHandler), this._proxiedDataSourceLoadingChangedHandler && this._dataSource.off("loadingChanged", this._proxiedDataSourceLoadingChangedHandler), this._dataSource._eventsStrategy && this._dataSource._eventsStrategy.off("loadingChanged", this.readyWatcher)) : this._dataSource.dispose(), delete this._dataSource, delete this._proxiedDataSourceChangedHandler, delete this._proxiedDataSourceLoadErrorHandler, delete this._proxiedDataSourceLoadingChangedHandler);
  },
  getDataSource: function() {
    return this._dataSource || null;
  }
}, M_e = "dx-state-invisible", k_e = "dx-state-disabled", P_e = "dx-item-content-placeholder", F_e = function(t, e, i) {
  var r = function(a) {
    n !== a && (i(a, n), n = a);
  }, n;
  return {
    dispose: t(e, r),
    force: function() {
      r(e());
    }
  };
}, Up = wi.inherit({
  ctor: function(t, e, i) {
    this._$element = t, this._options = e, this._rawData = i, Ej(t, this, this._dispose), this._render();
  },
  _render: function() {
    var t = E("<div>").addClass(P_e);
    this._$element.append(t), this._watchers = [], this._renderWatchers();
  },
  _renderWatchers: function() {
    this._startWatcher("disabled", this._renderDisabled.bind(this)), this._startWatcher("visible", this._renderVisible.bind(this));
  },
  _startWatcher: function(t, e) {
    var i = this._rawData, r = this._options.fieldGetter(t), n = F_e(this._options.watchMethod(), function() {
      return r(i);
    }, (function(a, o) {
      this._dirty = !0, e(a, o);
    }).bind(this));
    this._watchers.push(n);
  },
  setDataField: function() {
    if (this._dirty = !1, N(this._watchers, function(t, e) {
      e.force();
    }), this._dirty)
      return !0;
  },
  _renderDisabled: function(t, e) {
    this._$element.toggleClass(k_e, !!t), this._$element.attr("aria-disabled", !!t), this._updateOwnerFocus(t);
  },
  _updateOwnerFocus: function(t) {
    var e = this._options.owner;
    e && t && e._resetItemFocus(this._$element);
  },
  _renderVisible: function(t, e) {
    this._$element.toggleClass(M_e, t !== void 0 && !t);
  },
  _dispose: function() {
    N(this._watchers, function(t, e) {
      e.dispose();
    });
  }
});
Up.getInstance = function(t) {
  return bj(t, this);
};
var pG = Math.abs, TB = "dxhold", B_e = 750, vG = 5, V_e = fI.inherit({
  start: function(t) {
    this._startEventData = br(t), this._startTimer(t);
  },
  _startTimer: function(t) {
    var e = "timeout" in this ? this.timeout : B_e;
    this._holdTimer = setTimeout((function() {
      this._requestAccept(t), this._fireEvent(TB, t, {
        target: t.target
      }), this._forgetAccept();
    }).bind(this), e);
  },
  move: function(t) {
    this._touchWasMoved(t) && this._cancel(t);
  },
  _touchWasMoved: function(t) {
    var e = hp(this._startEventData, br(t));
    return pG(e.x) > vG || pG(e.y) > vG;
  },
  end: function() {
    this._stopTimer();
  },
  _stopTimer: function() {
    clearTimeout(this._holdTimer);
  },
  cancel: function() {
    this._stopTimer();
  },
  dispose: function() {
    this._stopTimer();
  }
});
zm({
  emitter: V_e,
  bubble: !0,
  events: [TB]
});
const Lh = {
  name: TB
};
var IB = "dxContexMenu", N_e = ve("contextmenu", IB), H_e = ve(Lh.name, IB), DB = "dxcontextmenu", $_e = wi.inherit({
  setup: function(t) {
    var e = E(t);
    k.on(e, N_e, this._contextMenuHandler.bind(this)), (Ip || Ye.isSimulator()) && k.on(e, H_e, this._holdHandler.bind(this));
  },
  _holdHandler: function(t) {
    wp(t) && !Ye.isSimulator() || this._fireContextMenu(t);
  },
  _contextMenuHandler: function(t) {
    this._fireContextMenu(t);
  },
  _fireContextMenu: function(t) {
    return Bh({
      type: DB,
      originalEvent: t
    });
  },
  teardown: function(t) {
    k.off(t, "." + IB);
  }
});
Ys(DB, new $_e());
var N5 = DB, z_e = function(t, e, i, r, n) {
  var a, o = ((u, c, p) => c(() => u, p))(t, e, function(u) {
    if (a && a(), sx(u)) {
      n(u);
      return;
    }
    a = function(c, p, v, _, y) {
      var b = {}, I = v.slice(), A = v.map(function(L) {
        var B = _[L];
        return p(B ? () => B(c) : () => c[L], function($) {
          if (b[L] = $, I.length) {
            var K = I.indexOf(L);
            K >= 0 && I.splice(K, 1);
          }
          I.length || y(b);
        });
      });
      return function() {
        A.forEach((L) => L());
      };
    }(u, e, i, r, n);
  });
  return function() {
    a && a(), o && o();
  };
};
class Gp extends $p {
  constructor(e, i, r, n) {
    super(), this._render = e, this._fields = i, this._fieldsMap = n || {}, this._watchMethod = r;
  }
  _renderCore(e) {
    var i = E(e.container), r = z_e(e.model, this._watchMethod, this._fields, this._fieldsMap, (n) => {
      i.empty(), this._render(i, n, e.model);
    });
    return k.on(i, fo, r), i.contents();
  }
}
var W_e = "dx-collection", Jb = "dx-item", gG = "-content", mG = "dx-item-content-placeholder", U_e = "dxItemData", G_e = "dxItemIndex", K_e = "tmpl-", j_e = "dxItem", Y_e = "dx-item-selected", q_e = "dx-item-response-wait", X_e = "dx-empty-collection", _G = "dx-template-wrapper", Q_e = /^([^.]+\[\d+\]\.)+([\w.]+)$/, Z_e = "item", zL = "up", WL = "down", CG = "left", yG = "right", J_e = "pageup", eCe = "pagedown", xG = "last", SG = "first", H5 = xn.inherit({
  _activeStateUnit: "." + Jb,
  _supportedKeys: function() {
    var t = function(e, i) {
      Cn(i) || (i.preventDefault(), i.stopPropagation(), this._moveFocus(e, i));
    };
    return P(this.callBase(), {
      space: function(e) {
        e.preventDefault(), this._enterKeyHandler(e);
      },
      enter: this._enterKeyHandler,
      leftArrow: t.bind(this, CG),
      rightArrow: t.bind(this, yG),
      upArrow: t.bind(this, zL),
      downArrow: t.bind(this, WL),
      pageUp: t.bind(this, zL),
      pageDown: t.bind(this, WL),
      home: t.bind(this, SG),
      end: t.bind(this, xG)
    });
  },
  _enterKeyHandler: function(t) {
    var e = E(this.option("focusedElement"));
    if (e.length) {
      var i = this._getItemData(e);
      i != null && i.onClick && this._itemEventHandlerByHandler(e, i.onClick, {
        event: t
      }), this._itemClickHandler(P({}, t, {
        target: e.get(0),
        currentTarget: e.get(0)
      }));
    }
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      selectOnFocus: !1,
      loopItemFocus: !0,
      items: [],
      itemTemplate: "item",
      onItemRendered: null,
      onItemClick: null,
      onItemHold: null,
      itemHoldTimeout: 750,
      onItemContextMenu: null,
      onFocusedItemChanged: null,
      noDataText: X.format("dxCollectionWidget-noDataText"),
      encodeNoDataText: !1,
      dataSource: null,
      _dataController: null,
      _itemAttributes: {},
      itemTemplateProperty: "template",
      focusOnSelectedItem: !0,
      focusedElement: null,
      displayExpr: void 0,
      disabledExpr: function(t) {
        return t ? t.disabled : void 0;
      },
      visibleExpr: function(t) {
        return t ? t.visible : void 0;
      }
    });
  },
  _init: function() {
    this._compileDisplayGetter(), this._initDataController(), this.callBase(), this._cleanRenderedItems(), this._refreshDataSource();
  },
  _compileDisplayGetter: function() {
    var t = this.option("displayExpr");
    this._displayGetter = t ? Ii(this.option("displayExpr")) : void 0;
  },
  _initTemplates: function() {
    this._initItemsFromMarkup(), this._initDefaultItemTemplate(), this.callBase();
  },
  _getAnonymousTemplateName: function() {
    return Z_e;
  },
  _initDefaultItemTemplate: function() {
    var t = this._getFieldsMap();
    this._templateManager.addDefaultTemplates({
      item: new Gp((function(e, i) {
        $t(i) ? this._prepareDefaultItemTemplate(i, e) : (t && Le(t.text) && (i = t.text(i)), e.text(String(cr(i, ""))));
      }).bind(this), this._getBindableFields(), this.option("integrationOptions.watchMethod"), t)
    });
  },
  _getBindableFields: function() {
    return ["text", "html"];
  },
  _getFieldsMap: function() {
    if (this._displayGetter)
      return {
        text: this._displayGetter
      };
  },
  _prepareDefaultItemTemplate: function(t, e) {
    R(t.text) && e.text(t.text), R(t.html) && e.html(t.html);
  },
  _initItemsFromMarkup: function() {
    var t = xY(this.$element(), j_e);
    if (!(!t.length || this.option("items").length)) {
      var e = t.map((i) => {
        var {
          element: r,
          options: n
        } = i, a = /\S/.test(r.innerHTML) && !n.template;
        return a ? n.template = this._prepareItemTemplate(r) : E(r).remove(), n;
      });
      this.option("items", e);
    }
  },
  _prepareItemTemplate: function(t) {
    var e = K_e + new yr(), i = E(t).detach().clone().removeAttr("data-options").addClass(_G);
    return this._saveTemplate(e, i), e;
  },
  _dataSourceOptions: function() {
    return {
      paginate: !1
    };
  },
  _cleanRenderedItems: function() {
    this._renderedItemsCount = 0;
  },
  _focusTarget: function() {
    return this.$element();
  },
  _focusInHandler: function(t) {
    if (this.callBase.apply(this, arguments), !!this._isFocusTarget(t.target)) {
      var e = E(this.option("focusedElement"));
      if (e.length)
        this._setFocusedItem(e);
      else {
        var i = this._getActiveItem();
        i.length && this.option("focusedElement", ot(i));
      }
    }
  },
  _focusOutHandler: function() {
    this.callBase.apply(this, arguments);
    var t = E(this.option("focusedElement"));
    this._updateFocusedItemState(t, !1);
  },
  _findActiveTarget(t) {
    return t.find(this._activeStateUnit);
  },
  _getActiveItem: function(t) {
    var e = E(this.option("focusedElement"));
    if (e.length)
      return e;
    var i = this.option("focusOnSelectedItem") ? this.option("selectedIndex") : 0, r = this._getActiveElement(), n = r.length - 1;
    return i < 0 && (i = t ? n : 0), r.eq(i);
  },
  _moveFocus: function(t) {
    var e = this._getAvailableItems(), i;
    switch (t) {
      case J_e:
      case zL:
        i = this._prevItem(e);
        break;
      case eCe:
      case WL:
        i = this._nextItem(e);
        break;
      case yG:
        i = this.option("rtlEnabled") ? this._prevItem(e) : this._nextItem(e);
        break;
      case CG:
        i = this.option("rtlEnabled") ? this._nextItem(e) : this._prevItem(e);
        break;
      case SG:
        i = e.first();
        break;
      case xG:
        i = e.last();
        break;
      default:
        return !1;
    }
    i.length !== 0 && this.option("focusedElement", ot(i));
  },
  _getVisibleItems: function(t) {
    return t = t || this._itemElements(), t.filter(":visible");
  },
  _getAvailableItems: function(t) {
    return this._getVisibleItems(t);
  },
  _prevItem: function(t) {
    var e = this._getActiveItem(), i = t.index(e), r = t.last(), n = E(t[i - 1]), a = this.option("loopItemFocus");
    return n.length === 0 && a && (n = r), n;
  },
  _nextItem: function(t) {
    var e = this._getActiveItem(!0), i = t.index(e), r = t.first(), n = E(t[i + 1]), a = this.option("loopItemFocus");
    return n.length === 0 && a && (n = r), n;
  },
  _selectFocusedItem: function(t) {
    this.selectItem(t);
  },
  _updateFocusedItemState: function(t, e, i) {
    var r = E(t);
    r.length && (this._refreshActiveDescendant(), this._refreshItemId(r, i), this._toggleFocusClass(e, r)), this._updateParentActiveDescendant();
  },
  _refreshActiveDescendant: function(t) {
    this.setAria("activedescendant", R(this.option("focusedElement")) ? this.getFocusedItemId() : null, t);
  },
  _refreshItemId: function(t, e) {
    !e && this.option("focusedElement") ? this.setAria("id", this.getFocusedItemId(), t) : this.setAria("id", null, t);
  },
  _isDisabled: (t) => t && E(t).attr("aria-disabled") === "true",
  _setFocusedItem: function(t) {
    if (!(!t || !t.length)) {
      this._updateFocusedItemState(t, !0), this.onFocusedItemChanged(this.getFocusedItemId());
      var {
        selectOnFocus: e
      } = this.option(), i = this._isDisabled(t);
      e && !i && this._selectFocusedItem(t);
    }
  },
  _findItemElementByItem: function(t) {
    var e = E(), i = this;
    return this.itemElements().each(function() {
      var r = E(this);
      if (r.data(i._itemDataKey()) === t)
        return e = r, !1;
    }), e;
  },
  _getIndexByItem: function(t) {
    return this.option("items").indexOf(t);
  },
  _itemOptionChanged: function(t, e, i, r) {
    var n = this._findItemElementByItem(t);
    if (n.length) {
      this.constructor.ItemClass.getInstance(n).setDataField(e, i) || this._refreshItem(n, t);
      var a = e === "disabled" && i;
      a && this._resetItemFocus(n);
    }
  },
  _resetItemFocus(t) {
    t.is(this.option("focusedElement")) && this.option("focusedElement", null);
  },
  _refreshItem: function(t) {
    var e = this._getItemData(t), i = t.data(this._itemIndexKey());
    this._renderItem(this._renderedItemsCount + i, e, null, t);
  },
  _updateParentActiveDescendant: ee,
  _optionChanged: function(t) {
    if (t.name === "items") {
      var e = t.fullName.match(Q_e);
      if (e && e.length) {
        var i = e[e.length - 1], r = t.fullName.replace("." + i, ""), n = this.option(r);
        this._itemOptionChanged(n, i, t.value, t.previousValue);
        return;
      }
    }
    switch (t.name) {
      case "items":
      case "_itemAttributes":
      case "itemTemplateProperty":
      case "useItemTextAsTitle":
        this._cleanRenderedItems(), this._invalidate();
        break;
      case "dataSource":
        this._refreshDataSource(), this._renderEmptyMessage();
        break;
      case "noDataText":
      case "encodeNoDataText":
        this._renderEmptyMessage();
        break;
      case "itemTemplate":
        this._invalidate();
        break;
      case "onItemRendered":
        this._createItemRenderAction();
        break;
      case "onItemClick":
        break;
      case "onItemHold":
      case "itemHoldTimeout":
        this._attachHoldEvent();
        break;
      case "onItemContextMenu":
        this._attachContextMenuEvent();
        break;
      case "onFocusedItemChanged":
        this.onFocusedItemChanged = this._createActionByOption("onFocusedItemChanged");
        break;
      case "selectOnFocus":
      case "loopItemFocus":
      case "focusOnSelectedItem":
        break;
      case "focusedElement":
        this._updateFocusedItemState(t.previousValue, !1, !0), this._setFocusedItem(E(t.value));
        break;
      case "displayExpr":
        this._compileDisplayGetter(), this._initDefaultItemTemplate(), this._invalidate();
        break;
      case "visibleExpr":
      case "disabledExpr":
        this._invalidate();
        break;
      default:
        this.callBase(t);
    }
  },
  _invalidate: function() {
    return this.option("focusedElement", null), this.callBase.apply(this, arguments);
  },
  _loadNextPage: function() {
    return this._expectNextPageLoading(), this._dataController.loadNextPage();
  },
  _expectNextPageLoading: function() {
    this._startIndexForAppendedItems = 0;
  },
  _expectLastItemLoading: function() {
    this._startIndexForAppendedItems = -1;
  },
  _forgetNextPageLoading: function() {
    this._startIndexForAppendedItems = null;
  },
  _dataSourceChangedHandler: function(t) {
    var e = this.option("items");
    this._initialized && e && this._shouldAppendItems() ? (this._renderedItemsCount = e.length, (!this._isLastPage() || this._startIndexForAppendedItems !== -1) && (this.option().items = e.concat(t.slice(this._startIndexForAppendedItems))), this._forgetNextPageLoading(), this._refreshContent()) : this.option("items", t.slice());
  },
  _refreshContent: function() {
    this._prepareContent(), this._renderContent();
  },
  _dataSourceLoadErrorHandler: function() {
    this._forgetNextPageLoading(), this.option("items", this.option("items"));
  },
  _shouldAppendItems: function() {
    return this._startIndexForAppendedItems != null && this._allowDynamicItemsAppend();
  },
  _allowDynamicItemsAppend: function() {
    return !1;
  },
  _clean: function() {
    this._cleanFocusState(), this._cleanItemContainer(), this._inkRipple && delete this._inkRipple, this._resetActiveState();
  },
  _cleanItemContainer: function() {
    E(this._itemContainer()).empty();
  },
  _dispose: function() {
    this.callBase(), clearTimeout(this._itemFocusTimeout);
  },
  _refresh: function() {
    this._cleanRenderedItems(), this.callBase.apply(this, arguments);
  },
  _itemContainer: function() {
    return this.$element();
  },
  _itemClass: function() {
    return Jb;
  },
  _itemContentClass: function() {
    return this._itemClass() + gG;
  },
  _selectedItemClass: function() {
    return Y_e;
  },
  _itemResponseWaitClass: function() {
    return q_e;
  },
  _itemSelector: function() {
    return "." + this._itemClass();
  },
  _itemDataKey: function() {
    return U_e;
  },
  _itemIndexKey: function() {
    return G_e;
  },
  _itemElements: function() {
    return this._itemContainer().find(this._itemSelector());
  },
  _initMarkup: function() {
    this.callBase(), this.onFocusedItemChanged = this._createActionByOption("onFocusedItemChanged"), this.$element().addClass(W_e), this._prepareContent();
  },
  _prepareContent: Sm(function() {
    this._renderContentImpl();
  }),
  _renderContent: function() {
    this._fireContentReadyAction();
  },
  _render: function() {
    this.callBase(), this._attachClickEvent(), this._attachHoldEvent(), this._attachContextMenuEvent();
  },
  _getPointerEvent: () => Xt.down,
  _attachClickEvent() {
    var t = this._itemSelector(), e = this._getPointerEvent(), i = ve(di, this.NAME), r = ve(e, this.NAME), n = new $o((a) => {
      var {
        event: o
      } = a;
      this._itemPointerDownHandler(o);
    });
    k.off(this._itemContainer(), i, t), k.off(this._itemContainer(), r, t), k.on(this._itemContainer(), i, t, (a) => this._itemClickHandler(a)), k.on(this._itemContainer(), r, t, (a) => {
      n.execute({
        element: E(a.target),
        event: a
      });
    });
  },
  _itemClickHandler: function(t, e, i) {
    this._itemDXEventHandler(t, "onItemClick", e, i);
  },
  _itemPointerDownHandler: function(t) {
    this.option("focusStateEnabled") && (this._itemFocusHandler = (function() {
      if (clearTimeout(this._itemFocusTimeout), this._itemFocusHandler = null, !t.isDefaultPrevented()) {
        var e = E(t.target), i = e.closest(this._itemElements()), r = this._closestFocusable(e);
        i.length && this._isFocusTarget(r == null ? void 0 : r.get(0)) && this.option("focusedElement", ot(i));
      }
    }).bind(this), this._itemFocusTimeout = setTimeout(this._forcePointerDownFocus.bind(this)));
  },
  _closestFocusable: function(t) {
    if (t.is(Ok))
      return t;
    for (t = t.parent(); t.length && !de.isDocument(t.get(0)) && !de.isDocumentFragment(t.get(0)); ) {
      if (t.is(Ok))
        return t;
      t = t.parent();
    }
  },
  _forcePointerDownFocus: function() {
    this._itemFocusHandler && this._itemFocusHandler();
  },
  _updateFocusState: function() {
    this.callBase.apply(this, arguments), this._forcePointerDownFocus();
  },
  _attachHoldEvent: function() {
    var t = this._itemContainer(), e = this._itemSelector(), i = ve(Lh.name, this.NAME);
    k.off(t, i, e), k.on(t, i, e, {
      timeout: this._getHoldTimeout()
    }, this._itemHoldHandler.bind(this));
  },
  _getHoldTimeout: function() {
    return this.option("itemHoldTimeout");
  },
  _shouldFireHoldEvent: function() {
    return this.hasActionSubscription("onItemHold");
  },
  _itemHoldHandler: function(t) {
    this._shouldFireHoldEvent() ? this._itemDXEventHandler(t, "onItemHold") : t.cancel = !0;
  },
  _attachContextMenuEvent: function() {
    var t = this._itemContainer(), e = this._itemSelector(), i = ve(N5, this.NAME);
    k.off(t, i, e), k.on(t, i, e, this._itemContextMenuHandler.bind(this));
  },
  _shouldFireContextMenuEvent: function() {
    return this.hasActionSubscription("onItemContextMenu");
  },
  _itemContextMenuHandler: function(t) {
    this._shouldFireContextMenuEvent() ? this._itemDXEventHandler(t, "onItemContextMenu") : t.cancel = !0;
  },
  _renderContentImpl: function() {
    var t = this.option("items") || [];
    this._renderedItemsCount ? this._renderItems(t.slice(this._renderedItemsCount)) : this._renderItems(t);
  },
  _renderItems: function(t) {
    t.length && N(t, (function(e, i) {
      this._renderItem(this._renderedItemsCount + e, i);
    }).bind(this)), this._renderEmptyMessage();
  },
  _getItemsContainer: function() {
    return this._itemContainer();
  },
  _setAttributes(t) {
    var e = ae({}, this.option("_itemAttributes")), {
      class: i
    } = e;
    if (i) {
      var r = t.get(0).className;
      e.class = [r, i].join(" ");
    }
    t.attr(e);
  },
  _renderItem: function(t, e, i, r) {
    var n, a = (n = t == null ? void 0 : t.item) !== null && n !== void 0 ? n : t;
    i = i || this._getItemsContainer();
    var o = this._renderItemFrame(a, e, i, r);
    this._setElementData(o, e, a), this._setAttributes(o), this._attachItemClickEvent(e, o);
    var u = this._getItemContent(o), c = this._renderItemContent({
      index: a,
      itemData: e,
      container: ot(u),
      contentClass: this._itemContentClass(),
      defaultTemplateName: this.option("itemTemplate")
    }), p = this;
    return $e(c).done(function(v) {
      p._postprocessRenderItem({
        itemElement: o,
        itemContent: v,
        itemData: e,
        itemIndex: a
      }), p._executeItemRenderAction(t, e, ot(o));
    }), o;
  },
  _getItemContent: function(t) {
    var e = t.find("." + mG);
    return e.removeClass(mG), e;
  },
  _attachItemClickEvent: function(t, e) {
    !t || !t.onClick || k.on(e, di, (function(i) {
      this._itemEventHandlerByHandler(e, t.onClick, {
        event: i
      });
    }).bind(this));
  },
  _renderItemContent: function(t) {
    var e = this._getItemTemplateName(t), i = this._getTemplate(e);
    this._addItemContentClasses(t);
    var r = E(this._createItemByTemplate(i, t));
    return r.hasClass(_G) ? this._renderItemContentByNode(t, r) : t.container;
  },
  _renderItemContentByNode: function(t, e) {
    return E(t.container).replaceWith(e), t.container = ot(e), this._addItemContentClasses(t), e;
  },
  _addItemContentClasses: function(t) {
    var e = [Jb + gG, t.contentClass];
    E(t.container).addClass(e.join(" "));
  },
  _appendItemToContainer: function(t, e, i) {
    e.appendTo(t);
  },
  _renderItemFrame: function(t, e, i, r) {
    var n = E("<div>");
    if (new this.constructor.ItemClass(n, this._itemOptions(), e || {}), r && r.length ? r.replaceWith(n) : this._appendItemToContainer.call(this, i, n, t), this.option("useItemTextAsTitle")) {
      var a = this._displayGetter ? this._displayGetter(e) : e;
      n.attr("title", a);
    }
    return n;
  },
  _itemOptions: function() {
    var t = this;
    return {
      watchMethod: function() {
        return t.option("integrationOptions.watchMethod");
      },
      owner: t,
      fieldGetter: function(e) {
        var i = t.option(e + "Expr"), r = Ii(i);
        return r;
      }
    };
  },
  _postprocessRenderItem: ee,
  _executeItemRenderAction: function(t, e, i) {
    this._getItemRenderAction()({
      itemElement: i,
      itemIndex: t,
      itemData: e
    });
  },
  _setElementData: function(t, e, i) {
    t.addClass([Jb, this._itemClass()].join(" ")).data(this._itemDataKey(), e).data(this._itemIndexKey(), i);
  },
  _createItemRenderAction: function() {
    return this._itemRenderAction = this._createActionByOption("onItemRendered", {
      element: this.element(),
      excludeValidators: ["disabled", "readOnly"],
      category: "rendering"
    });
  },
  _getItemRenderAction: function() {
    return this._itemRenderAction || this._createItemRenderAction();
  },
  _getItemTemplateName: function(t) {
    var e = t.itemData, i = t.templateProperty || this.option("itemTemplateProperty"), r = e && e[i];
    return r || t.defaultTemplateName;
  },
  _createItemByTemplate: function(t, e) {
    return t.render({
      model: e.itemData,
      container: e.container,
      index: e.index,
      onRendered: this._onItemTemplateRendered(t, e)
    });
  },
  _onItemTemplateRendered: function() {
    return ee;
  },
  _emptyMessageContainer: function() {
    return this._itemContainer();
  },
  _renderEmptyMessage: function(t) {
    t = t || this.option("items");
    var e = this.option("noDataText"), i = !e || t && t.length || this._dataController.isLoading();
    i && this._$noData && (this._$noData.remove(), this._$noData = null, this.setAria("label", void 0)), i || (this._$noData = this._$noData || E("<div>").addClass("dx-empty-message"), this._$noData.appendTo(this._emptyMessageContainer()), this.option("encodeNoDataText") ? this._$noData.text(e) : this._$noData.html(e)), this.$element().toggleClass(X_e, !i);
  },
  _itemDXEventHandler: function(t, e, i, r) {
    this._itemEventHandler(t.target, e, P(i, {
      event: t
    }), r);
  },
  _itemEventHandler: function(t, e, i, r) {
    var n = this._createActionByOption(e, P({
      validatingTargetName: "itemElement"
    }, r));
    return this._itemEventHandlerImpl(t, n, i);
  },
  _itemEventHandlerByHandler: function(t, e, i, r) {
    var n = this._createAction(e, P({
      validatingTargetName: "itemElement"
    }, r));
    return this._itemEventHandlerImpl(t, n, i);
  },
  _itemEventHandlerImpl: function(t, e, i) {
    var r = this._closestItemElement(E(t)), n = P({}, i);
    return e(P(i, this._extendActionArgs(r), n));
  },
  _extendActionArgs: function(t) {
    return {
      itemElement: ot(t),
      itemIndex: this._itemElements().index(t),
      itemData: this._getItemData(t)
    };
  },
  _closestItemElement: function(t) {
    return E(t).closest(this._itemSelector());
  },
  _getItemData: function(t) {
    return E(t).data(this._itemDataKey());
  },
  _getSummaryItemsSize(t, e, i) {
    var r = 0;
    return e && N(e, function(n, a) {
      t === "width" ? r += oi(a, i || !1) : t === "height" && (r += jt(a, i || !1));
    }), r;
  },
  getFocusedItemId: function() {
    return this._focusedItemId || (this._focusedItemId = "dx-" + new yr()), this._focusedItemId;
  },
  itemElements: function() {
    return this._itemElements();
  },
  itemsContainer: function() {
    return this._itemContainer();
  }
}).include(wB);
H5.ItemClass = Up;
var Fo = wi.abstract, tCe = wi.inherit({
  ctor: function(t) {
    this._collectionWidget = t;
  },
  getIndexByItemData: Fo,
  getItemDataByIndex: Fo,
  getKeysByItems: Fo,
  getItemsByKeys: Fo,
  itemsGetter: Fo,
  getKeyByIndex: function(t) {
    var e = this._denormalizeItemIndex(t);
    return this.getKeysByItems([this.getItemDataByIndex(e)])[0];
  },
  _equalKeys: function(t, e) {
    return this._collectionWidget._isKeySpecified() ? Mi(t, e) : t === e;
  },
  beginCache: function() {
    this._cache = {};
  },
  endCache: function() {
    this._cache = null;
  },
  getIndexByKey: Fo,
  getNormalizedIndex: function(t) {
    return this._isNormalizedItemIndex(t) ? t : this._isItemIndex(t) ? this._normalizeItemIndex(t) : this._isNode(t) ? this._getNormalizedItemIndex(t) : this._normalizeItemIndex(this.getIndexByItemData(t));
  },
  getIndex: function(t) {
    return this._isNormalizedItemIndex(t) ? this._denormalizeItemIndex(t) : this._isItemIndex(t) ? t : this._isNode(t) ? this._denormalizeItemIndex(this._getNormalizedItemIndex(t)) : this.getIndexByItemData(t);
  },
  getItemElement: function(t) {
    if (this._isNormalizedItemIndex(t))
      return this._getItemByNormalizedIndex(t);
    if (this._isItemIndex(t))
      return this._getItemByNormalizedIndex(this._normalizeItemIndex(t));
    if (this._isNode(t))
      return E(t);
    var e = this._normalizeItemIndex(this.getIndexByItemData(t));
    return this._getItemByNormalizedIndex(e);
  },
  _isNode: (t) => de.isNode(t && hs(t) ? t.get(0) : t),
  deleteItemAtIndex: Fo,
  itemPlacementFunc: function(t, e) {
    return this._itemsFromSameParent(t, e) && t < e ? "after" : "before";
  },
  moveItemAtIndexToIndex: Fo,
  _isNormalizedItemIndex: function(t) {
    return typeof t == "number" && Math.round(t) === t;
  },
  _isItemIndex: Fo,
  _getNormalizedItemIndex: Fo,
  _normalizeItemIndex: Fo,
  _denormalizeItemIndex: Fo,
  _getItemByNormalizedIndex: Fo,
  _itemsFromSameParent: Fo
}), AB = tCe.inherit({
  _getPlainItems: function() {
    return this._collectionWidget.option("items") || [];
  },
  getIndexByItemData: function(t) {
    var e = this._collectionWidget.keyOf.bind(this._collectionWidget);
    return e ? this.getIndexByKey(e(t)) : this._getPlainItems().indexOf(t);
  },
  getItemDataByIndex: function(t) {
    return this._getPlainItems()[t];
  },
  deleteItemAtIndex: function(t) {
    this._getPlainItems().splice(t, 1);
  },
  itemsGetter: function() {
    return this._getPlainItems();
  },
  getKeysByItems: function(t) {
    var e = this._collectionWidget.keyOf.bind(this._collectionWidget), i = t;
    if (e) {
      i = [];
      for (var r = 0; r < t.length; r++)
        i.push(e(t[r]));
    }
    return i;
  },
  getIndexByKey: function(t) {
    var e = this._cache, i = e && e.keys || this.getKeysByItems(this._getPlainItems());
    if (e && !e.keys && (e.keys = i), typeof t == "object") {
      for (var r = 0, n = i.length; r < n; r++)
        if (this._equalKeys(t, i[r]))
          return r;
    } else
      return i.indexOf(t);
    return -1;
  },
  getItemsByKeys: function(t, e) {
    return (e || t).slice();
  },
  moveItemAtIndexToIndex: function(t, e) {
    var i = this._getPlainItems(), r = i[t];
    i.splice(t, 1), i.splice(e, 0, r);
  },
  _isItemIndex: function(t) {
    return typeof t == "number" && Math.round(t) === t;
  },
  _getNormalizedItemIndex: function(t) {
    return this._collectionWidget._itemElements().index(t);
  },
  _normalizeItemIndex: function(t) {
    return t;
  },
  _denormalizeItemIndex: function(t) {
    return t;
  },
  _getItemByNormalizedIndex: function(t) {
    return t > -1 ? this._collectionWidget._itemElements().eq(t) : null;
  },
  _itemsFromSameParent: function() {
    return !0;
  }
});
class $5 {
  constructor(e) {
    this.options = e, this._setOption("disabledItemKeys", []), this._clearItemKeys();
  }
  _clearItemKeys() {
    this._setOption("addedItemKeys", []), this._setOption("removedItemKeys", []), this._setOption("removedItems", []), this._setOption("addedItems", []);
  }
  validate() {
  }
  _setOption(e, i) {
    this.options[e] = i;
  }
  onSelectionChanged() {
    var e = this.options.addedItemKeys, i = this.options.removedItemKeys, r = this.options.addedItems, n = this.options.removedItems, a = this.options.selectedItems, o = this.options.selectedItemKeys, u = this.options.onSelectionChanged || ee;
    this._clearItemKeys(), u({
      selectedItems: a,
      selectedItemKeys: o,
      addedItemKeys: e,
      removedItemKeys: i,
      addedItems: r,
      removedItems: n
    });
  }
  equalKeys(e, i) {
    return this.options.equalByReference && ct(e) && ct(i) ? e === i : Mi(e, i);
  }
  getSelectableItems(e) {
    return e.filter(function(i) {
      return !(i != null && i.disabled);
    });
  }
  _clearSelection(e, i, r, n) {
    return e = e || [], e = Array.isArray(e) ? e : [e], this.validate(), this.selectedItemKeys(e, i, r, n);
  }
  _removeTemplateProperty(e) {
    return Array.isArray(e) ? e.map((i) => this._removeTemplateProperty(i)) : (ct(e) && delete e.template, e);
  }
  _loadFilteredData(e, i, r, n) {
    var a = encodeURI(JSON.stringify(this._removeTemplateProperty(e))).length, o = this.options.maxFilterLengthInRequest && a > this.options.maxFilterLengthInRequest, u = new q(), c = {
      filter: o ? void 0 : e,
      select: o ? this.options.dataFields() : r || this.options.dataFields()
    };
    return e && e.length === 0 ? u.resolve([]) : this.options.load(c).done(function(p) {
      var v = $t(p) ? p.data : p;
      i && !n ? v = v.filter(i) : o && (v = lo(v).filter(e).toArray()), u.resolve(v);
    }).fail(u.reject.bind(u)), u;
  }
  updateSelectedItemKeyHash(e) {
    for (var i = 0; i < e.length; i++) {
      var r = ku(e[i]);
      if (!ct(r)) {
        this.options.keyHashIndices[r] = this.options.keyHashIndices[r] || [];
        var n = this.options.keyHashIndices[r];
        n.push(i);
      }
    }
  }
  _isAnyItemSelected(e) {
    for (var i = 0; i < e.length; i++)
      if (this.options.isItemSelected(e[i]))
        return;
    return !1;
  }
  _getFullSelectAllState() {
    var e = this.options.plainItems(), i = this.options.filter(), r = this.options.ignoreDisabledItems ? this.options.selectedItems : this.options.selectedItems.filter((o) => !(o != null && o.disabled));
    i && (r = lo(r).filter(i).toArray());
    var n = r.length, a = e.length - this.getSelectableItems(e).length;
    if (!n)
      return this._isAnyItemSelected(e);
    if (n >= this.options.totalCount() - a)
      return !0;
  }
  _getVisibleSelectAllState() {
    for (var e = this.getSelectableItems(this.options.plainItems()), i = !1, r = !1, n = 0; n < e.length; n++) {
      var a = e[n], o = this.options.getItemData(a), u = this.options.keyOf(o);
      this.options.isSelectableItem(a) && (this.isItemKeySelected(u) ? i = !0 : r = !0);
    }
    return i ? r ? void 0 : !0 : !1;
  }
}
class iCe extends $5 {
  getSelectedItems() {
    return this._loadFilteredData(this.options.selectionFilter);
  }
  getSelectedItemKeys() {
    var e = new q(), i = this, r = this.options.key(), n = ht(r) ? [r] : r;
    return this._loadFilteredData(this.options.selectionFilter, null, n).done(function(a) {
      var o = a.map(function(u) {
        return i.options.keyOf(u);
      });
      e.resolve(o);
    }).fail(e.reject), e.promise();
  }
  selectedItemKeys(e, i, r, n) {
    if (n) {
      var a = this.options.filter(), o = !a || JSON.stringify(a) === JSON.stringify(this.options.selectionFilter) && r;
      o ? this._setOption("selectionFilter", r ? [] : null) : this._addSelectionFilter(r, a, n);
    } else {
      i || this._setOption("selectionFilter", []);
      for (var u = 0; u < e.length; u++)
        r ? this.removeSelectedItem(e[u]) : this.addSelectedItem(e[u], n, !i);
    }
    return this.onSelectionChanged(), new q().resolve();
  }
  setSelectedItems(e) {
    this._setOption("selectionFilter", null);
    for (var i = 0; i < e.length; i++)
      this.addSelectedItem(e[i]);
  }
  isItemDataSelected(e) {
    return this.isItemKeySelected(e);
  }
  isItemKeySelected(e) {
    var i = this.options.selectionFilter;
    return i ? !!lo([e]).filter(i).toArray().length : !0;
  }
  _getKeyExpr() {
    var e = this.options.key();
    return Array.isArray(e) && e.length === 1 ? e[0] : e;
  }
  _normalizeKey(e) {
    var i = this.options.key();
    return Array.isArray(i) && i.length === 1 ? e[i[0]] : e;
  }
  _getFilterByKey(e) {
    var i = this._getKeyExpr(), r = [i, "=", this._normalizeKey(e)];
    if (Array.isArray(i)) {
      r = [];
      for (var n = 0; n < i.length; n++)
        r.push([i[n], "=", e[i[n]]]), n !== i.length - 1 && r.push("and");
    }
    return r;
  }
  addSelectedItem(e, i, r) {
    var n = this._getFilterByKey(e);
    this._addSelectionFilter(!1, n, i, r);
  }
  removeSelectedItem(e) {
    var i = this._getFilterByKey(e);
    this._addSelectionFilter(!0, i);
  }
  validate() {
    var e = this.options.key;
    if (e && e() === void 0)
      throw Yt.Error("E1042", "Deferred selection");
  }
  _findSubFilter(e, i) {
    if (!e)
      return -1;
    for (var r = JSON.stringify(i), n = 0; n < e.length; n++) {
      var a = e[n];
      if (a && JSON.stringify(a) === r)
        return n;
    }
    return -1;
  }
  _isLastSubFilter(e, i) {
    return e && i ? this._findSubFilter(e, i) === e.length - 1 || this._findSubFilter([e], i) === 0 : !1;
  }
  _addFilterOperator(e, i) {
    return e.length > 1 && ht(e[1]) && e[1] !== i && (e = [e]), e.length && e.push(i), e;
  }
  _denormalizeFilter(e) {
    return e && ht(e[0]) && (e = [e]), e;
  }
  _isOnlyNegativeFiltersLeft(e) {
    return e.every((i, r) => r % 2 === 0 ? Array.isArray(i) && i[0] === "!" : i === "and");
  }
  _addSelectionFilter(e, i, r, n) {
    var a, o = e ? ["!", i] : i, u = e ? "and" : "or", c = !0, p = this.options.selectionFilter || [];
    if (p = this._denormalizeFilter(p), (a = p) !== null && a !== void 0 && a.length && !n) {
      var v = this._removeSameFilter(p, i, e, r), _ = this._removeSameFilter(p, i, !e), y = e && (v !== -1 || _ !== -1) && this._isOnlyNegativeFiltersLeft(p);
      y && (p = []);
      var b = this._isKeyFilter(i) && this._hasKeyFiltersOnlyStartingFromIndex(p, _);
      c = i.length && !b;
    }
    c && (p = this._addFilterOperator(p, u), p.push(o)), p = this._normalizeFilter(p), this._setOption("selectionFilter", !e && !p.length ? null : p);
  }
  _normalizeFilter(e) {
    return e && e.length === 1 && (e = e[0]), e;
  }
  _removeFilterByIndex(e, i, r) {
    var n = e[1];
    i > 0 ? e.splice(i - 1, 2) : e.splice(i, 2), r && n === "and" && e.splice(0, e.length);
  }
  _isSimpleKeyFilter(e, i) {
    return e.length === 3 && e[0] === i && e[1] === "=";
  }
  _isKeyFilter(e) {
    if (e.length === 2 && e[0] === "!")
      return this._isKeyFilter(e[1]);
    var i = this._getKeyExpr();
    if (Array.isArray(i)) {
      if (e.length !== 2 * i.length - 1)
        return !1;
      for (var r = 0; r < i.length; r++)
        if (r > 0 && e[2 * r - 1] !== "and" || !this._isSimpleKeyFilter(e[2 * r], i[r]))
          return !1;
      return !0;
    }
    return this._isSimpleKeyFilter(e, i);
  }
  _hasKeyFiltersOnlyStartingFromIndex(e, i) {
    if (i >= 0) {
      for (var r = i; r < e.length; r++)
        if (typeof e[r] != "string" && !this._isKeyFilter(e[r]))
          return !1;
      return !0;
    }
    return !1;
  }
  _removeSameFilter(e, i, r, n) {
    if (i = r ? ["!", i] : i, JSON.stringify(i) === JSON.stringify(e))
      return e.splice(0, e.length), 0;
    var a = this._findSubFilter(e, i);
    if (a >= 0)
      return this._removeFilterByIndex(e, a, n), a;
    for (var o = 0; o < e.length; o++)
      if (Array.isArray(e[o]) && e[o].length > 2) {
        var u = this._removeSameFilter(e[o], i, !1, n);
        if (u >= 0)
          return e[o].length ? e[o].length === 1 && (e[o] = e[o][0]) : this._removeFilterByIndex(e, o, n), u;
      }
    return -1;
  }
  getSelectAllState() {
    var e = this.options.filter(), i = this.options.selectionFilter;
    if (!i)
      return !0;
    if (!i.length)
      return !1;
    if (!(!e || !e.length)) {
      if (i = this._denormalizeFilter(i), this._isLastSubFilter(i, e))
        return !0;
      if (this._isLastSubFilter(i, ["!", e]))
        return !1;
    }
  }
  loadSelectedItemsWithFilter() {
    var e = this.options.filter(), i = this.options.selectionFilter, r = e ? [e, "and", i] : i;
    return this._loadFilteredData(r);
  }
}
var EG = function(t, e) {
  this.getLocalFilter = function(o, u, c, p) {
    return u = u === void 0 ? Mi : u, n.bind(this, u, o, c, p);
  }, this.getExpr = function(o) {
    if (o) {
      var u;
      return t.forEach(function(c, p) {
        u = u || [];
        var v;
        p > 0 && u.push(e ? "and" : "or"), ht(o) ? v = a(o, c) : v = function(_, y) {
          for (var b = [], I = 0, A = _.length; I < A; I++) {
            var L = _[I], B = Ii(L), $ = y && B(y), K = a(L, $);
            if (!K)
              break;
            I > 0 && b.push(e ? "or" : "and"), b.push(K);
          }
          return b;
        }(o, c), u.push(v);
      }), u && u.length === 1 && (u = u[0]), u;
    }
  }, this.getCombinedFilter = function(o, u) {
    var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, p = this.getExpr(o), v = p;
    return (c || e) && u && (p ? (v = [], v.push(p), v.push(u)) : v = u), v;
  };
  var i, r = function(o, u, c) {
    return Array.isArray(c) ? o.map((p) => u(p)) : o;
  };
  function n(o, u, c, p, v) {
    var _ = u(v), y, b;
    if (!c && (y = ku(_), !ct(y))) {
      var I = function(A, L) {
        if (!i) {
          i = {};
          for (var B = r(t, A, L), $ = 0; $ < B.length; $++)
            i[ku(B[$])] = !0;
        }
        return i;
      }(u, p);
      return I[y] ? !e : !!e;
    }
    for (b = 0; b < t.length; b++)
      if (o(t[b], _))
        return !e;
    return !!e;
  }
  function a(o, u) {
    if (u !== void 0)
      return [o, e ? "<>" : "=", u];
  }
};
class rCe extends $5 {
  constructor(e) {
    super(e), this._initSelectedItemKeyHash();
  }
  _initSelectedItemKeyHash() {
    this._setOption("keyHashIndices", this.options.equalByReference ? null : {});
  }
  getSelectedItemKeys() {
    return this.options.selectedItemKeys.slice(0);
  }
  getSelectedItems() {
    return this.options.selectedItems.slice(0);
  }
  _preserveSelectionUpdate(e, i) {
    var r = this.options.keyOf, n, a, o;
    if (r) {
      var u = i && e.length > 1 && !this.options.equalByReference;
      for (u && (n = {}), o = 0; o < e.length; o++) {
        var c = e[o], p = r(c);
        i ? (a = this.removeSelectedItem(p, n, c == null ? void 0 : c.disabled), n && a >= 0 && (n[a] = !0)) : this.addSelectedItem(p, c);
      }
      u && this._batchRemoveSelectedItems(n);
    }
  }
  _batchRemoveSelectedItems(e) {
    var i = this.options.selectedItemKeys.slice(0), r = this.options.selectedItems.slice(0);
    this.options.selectedItemKeys.length = 0, this.options.selectedItems.length = 0;
    for (var n = 0; n < i.length; n++)
      e[n] || (this.options.selectedItemKeys.push(i[n]), this.options.selectedItems.push(r[n]));
    this._initSelectedItemKeyHash(), this.updateSelectedItemKeyHash(this.options.selectedItemKeys);
  }
  _loadSelectedItemsCore(e, i, r, n) {
    var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, o = new q(), u = this.options.key();
    if (!e.length && !r)
      return o.resolve([]), o;
    if (r && i && !n)
      return o.resolve(this.getSelectedItems()), o;
    var c = new EG(e, r), p = c.getCombinedFilter(u, n, a), v = [];
    if (i) {
      var _ = this.options.selectedItems;
      v = p && e.length !== _.length ? lo(_).filter(p).toArray() : _.slice(0);
    }
    var y = v.length ? v : this.options.plainItems(!0).filter(this.options.isSelectableItem).map(this.options.getItemData), b = c.getLocalFilter(this.options.keyOf, this.equalKeys.bind(this), this.options.equalByReference, u);
    return y = y.filter(b), v.length || !r && y.length === e.length ? o.resolve(y) : o = this._loadFilteredData(p, b, null, r), o;
  }
  _replaceSelectionUpdate(e) {
    var i = [], r = this.options.keyOf;
    if (r) {
      for (var n = 0; n < e.length; n++) {
        var a = e[n], o = r(a);
        i.push(o);
      }
      this.setSelectedItems(i, e);
    }
  }
  _warnOnIncorrectKeys(e) {
    for (var i = this.options.allowNullValue, r = 0; r < e.length; r++) {
      var n = e[r];
      (!i || n !== null) && !this.isItemKeySelected(n) && Yt.log("W1002", n);
    }
  }
  _isMultiSelectEnabled() {
    var e = this.options.mode;
    return e === "all" || e === "multiple";
  }
  _requestInProgress() {
    var e;
    return ((e = this._lastLoadDeferred) === null || e === void 0 ? void 0 : e.state()) === "pending";
  }
  _concatRequestsItems(e, i, r, n) {
    var a, o = i ? e : [];
    return n ? a = n : a = U$(e, this.options.selectedItemKeys), {
      addedItems: r.added.concat(a),
      removedItems: r.removed.concat(o),
      keys: e
    };
  }
  _collectLastRequestData(e, i, r, n) {
    var a = i && r, o = {
      added: [],
      removed: []
    }, u = this._isMultiSelectEnabled(), c = u ? this._lastRequestData : {};
    return u && (this._shouldMergeWithLastRequest && (a ? (this._lastLoadDeferred.reject(), c = {}) : yge(e, this.options.selectedItemKeys) || (o.added = c.addedItems, o.removed = c.removedItems, i || this._lastLoadDeferred.reject())), c = this._concatRequestsItems(e, i, o, this._shouldMergeWithLastRequest ? void 0 : n)), c;
  }
  _updateKeysByLastRequestData(e, i, r) {
    var n = e;
    if (this._isMultiSelectEnabled() && this._shouldMergeWithLastRequest && !i && !r) {
      var a, o;
      n = U$(e.concat((a = this._lastRequestData) === null || a === void 0 ? void 0 : a.addedItems), (o = this._lastRequestData) === null || o === void 0 ? void 0 : o.removedItems), n = goe(n);
    }
    return n;
  }
  _loadSelectedItems(e, i, r, n) {
    var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, o = this, u = new q(), c = o.options.filter();
    return this._shouldMergeWithLastRequest = this._requestInProgress(), this._lastRequestData = this._collectLastRequestData(e, i, r, n), $e(o._lastLoadDeferred).always(function() {
      var p = o._updateKeysByLastRequestData(e, i, r);
      o._shouldMergeWithLastRequest = !1, o._loadSelectedItemsCore(p, i, r, c, a).done(u.resolve).fail(u.reject);
    }), o._lastLoadDeferred = u, u;
  }
  selectedItemKeys(e, i, r, n, a) {
    var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, u = this, c = u._loadSelectedItems(e, r, n, a, o);
    return c.done(function(p) {
      i ? u._preserveSelectionUpdate(p, r) : u._replaceSelectionUpdate(p), u.onSelectionChanged();
    }), c;
  }
  addSelectedItem(e, i) {
    if (R(i) && !this.options.ignoreDisabledItems && i.disabled) {
      this.options.disabledItemKeys.indexOf(e) === -1 && this.options.disabledItemKeys.push(e);
      return;
    }
    var r = this._getKeyHash(e);
    this._indexOfSelectedItemKey(r) === -1 && (!ct(r) && this.options.keyHashIndices && (this.options.keyHashIndices[r] = [this.options.selectedItemKeys.length]), this.options.selectedItemKeys.push(e), this.options.addedItemKeys.push(e), this.options.addedItems.push(i), this.options.selectedItems.push(i));
  }
  _getSelectedIndexByKey(e, i) {
    for (var r = this.options.selectedItemKeys, n = 0; n < r.length; n++)
      if ((!i || !i[n]) && this.equalKeys(r[n], e))
        return n;
    return -1;
  }
  _getSelectedIndexByHash(e, i) {
    var r = this.options.keyHashIndices[e];
    return r && r.length > 1 && i && (r = r.filter(function(n) {
      return !i[n];
    })), r && r[0] >= 0 ? r[0] : -1;
  }
  _indexOfSelectedItemKey(e, i) {
    var r;
    return this.options.equalByReference ? r = this.options.selectedItemKeys.indexOf(e) : ct(e) ? r = this._getSelectedIndexByKey(e, i) : r = this._getSelectedIndexByHash(e, i), r;
  }
  _shiftSelectedKeyIndices(e) {
    for (var i = e; i < this.options.selectedItemKeys.length; i++) {
      var r = this.options.selectedItemKeys[i], n = ku(r), a = this.options.keyHashIndices[n];
      if (a)
        for (var o = 0; o < a.length; o++)
          a[o] > e && a[o]--;
    }
  }
  removeSelectedItem(e, i, r) {
    if (!(!this.options.ignoreDisabledItems && r)) {
      var n = this._getKeyHash(e), a = !!i, o = this._indexOfSelectedItemKey(n, i);
      if (o < 0 || (this.options.removedItemKeys.push(e), this.options.removedItems.push(this.options.selectedItems[o]), a) || (this.options.selectedItemKeys.splice(o, 1), this.options.selectedItems.splice(o, 1), ct(n) || !this.options.keyHashIndices))
        return o;
      var u = this.options.keyHashIndices[n];
      return u && (u.shift(), u.length || delete this.options.keyHashIndices[n], this._shiftSelectedKeyIndices(o)), o;
    }
  }
  _updateAddedItemKeys(e, i) {
    for (var r = 0; r < e.length; r++)
      this.isItemKeySelected(e[r]) || (this.options.addedItemKeys.push(e[r]), this.options.addedItems.push(i[r]));
  }
  _updateRemovedItemKeys(e, i, r) {
    for (var n = 0; n < i.length; n++)
      this.isItemKeySelected(i[n]) || (this.options.removedItemKeys.push(i[n]), this.options.removedItems.push(r[n]));
  }
  _isItemSelectionInProgress(e, i) {
    var r = i && this._lastRequestData && this._requestInProgress();
    if (r) {
      var n, a = (n = this._lastRequestData.addedItems) !== null && n !== void 0 ? n : [];
      return a.includes(e);
    } else
      return !1;
  }
  _getKeyHash(e) {
    return this.options.equalByReference ? e : ku(e);
  }
  setSelectedItems(e, i) {
    this._updateAddedItemKeys(e, i);
    var r = this.options.selectedItemKeys, n = this.options.selectedItems;
    this.options.equalByReference || (this._initSelectedItemKeyHash(), this.updateSelectedItemKeyHash(e)), this._setOption("selectedItemKeys", e), this._setOption("selectedItems", i), this._updateRemovedItemKeys(e, r, n);
  }
  isItemDataSelected(e) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = this.options.keyOf(e);
    return this.isItemKeySelected(r, i);
  }
  isItemKeySelected(e) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = this._isItemSelectionInProgress(e, i.checkPending);
    if (!r) {
      var n = this._getKeyHash(e), a = this._indexOfSelectedItemKey(n);
      r = a !== -1;
    }
    return r;
  }
  getSelectAllState(e) {
    return e ? this._getVisibleSelectAllState() : this._getFullSelectAllState();
  }
  loadSelectedItemsWithFilter() {
    var e = this.options.key(), i = this.getSelectedItemKeys(), r = this.options.filter();
    if (!i.length)
      return q().resolve([]);
    var n = new EG(i), a = n.getCombinedFilter(e, r, !0);
    return this._loadFilteredData(a);
  }
}
let z5 = class {
  constructor(e) {
    this.options = P(this._getDefaultOptions(), e, {
      selectedItemKeys: e.selectedKeys || []
    }), this._selectionStrategy = this.options.deferred ? new iCe(this.options) : new rCe(this.options), this._focusedItemIndex = -1, this.options.equalByReference || this._selectionStrategy.updateSelectedItemKeyHash(this.options.selectedItemKeys);
  }
  _getDefaultOptions() {
    return {
      allowNullValue: !1,
      deferred: !1,
      equalByReference: !1,
      mode: "multiple",
      selectedItems: [],
      selectionFilter: [],
      maxFilterLengthInRequest: 0,
      onSelectionChanged: ee,
      key: ee,
      keyOf: function(e) {
        return e;
      },
      load: function() {
        return new q().resolve([]);
      },
      totalCount: function() {
        return -1;
      },
      isSelectableItem: function() {
        return !0;
      },
      isItemSelected: function() {
        return !1;
      },
      getItemData: function(e) {
        return e;
      },
      dataFields: ee,
      filter: ee
    };
  }
  validate() {
    this._selectionStrategy.validate();
  }
  getSelectedItemKeys() {
    return this._selectionStrategy.getSelectedItemKeys();
  }
  getSelectedItems() {
    return this._selectionStrategy.getSelectedItems();
  }
  selectionFilter(e) {
    if (e === void 0)
      return this.options.selectionFilter;
    var i = this.options.selectionFilter !== e && JSON.stringify(this.options.selectionFilter) !== JSON.stringify(e);
    this.options.selectionFilter = e, i && this.onSelectionChanged();
  }
  setSelection(e, i) {
    return this.selectedItemKeys(e, !1, !1, !1, i);
  }
  select(e) {
    return this.selectedItemKeys(e, !0);
  }
  deselect(e) {
    return this.selectedItemKeys(e, !0, !0);
  }
  selectedItemKeys(e, i, r, n, a) {
    var o;
    return e = (o = e) !== null && o !== void 0 ? o : [], e = Array.isArray(e) ? e : [e], this.validate(), this._selectionStrategy.selectedItemKeys(e, i, r, n, a);
  }
  clearSelection() {
    return this.selectedItemKeys([]);
  }
  _addSelectedItem(e, i) {
    this._selectionStrategy.addSelectedItem(i, e);
  }
  _removeSelectedItem(e) {
    this._selectionStrategy.removeSelectedItem(e);
  }
  _setSelectedItems(e, i) {
    this._selectionStrategy.setSelectedItems(e, i);
  }
  onSelectionChanged() {
    this._selectionStrategy.onSelectionChanged();
  }
  changeItemSelection(e, i, r) {
    var n, a, o, u = this.options.plainItems(), c = u[e], p, v = this.options.isVirtualPaging, _ = (n = (a = this.options).allowLoadByRange) === null || n === void 0 ? void 0 : n.call(a), y = this.options.alwaysSelectByShift, b, I = !1, A = !1, L = (ie) => ie >= 0 && !u.filter((pe) => pe.loadIndex === ie).length;
    if (v && R(c) && (_ && (b = c.loadIndex - e, e = c.loadIndex), I = L(this._focusedItemIndex), R(this._shiftFocusedItemIndex) && (A = L(this._shiftFocusedItemIndex))), !this.isSelectable() || !this.isDataItem(c))
      return !1;
    var B = this.options.getItemData(c), $ = this.options.keyOf(B);
    i = i || {};
    var K = i.shift;
    if (y === !1 && K && (K = _ !== !1 || !I && !A), K && this.options.mode === "multiple" && this._focusedItemIndex >= 0)
      _ && (I || A) ? (o = e !== this._shiftFocusedItemIndex || this._focusedItemIndex !== this._shiftFocusedItemIndex, o && (p = this.changeItemSelectionWhenShiftKeyInVirtualPaging(e))) : o = this.changeItemSelectionWhenShiftKeyPressed(e, u, b);
    else if (i.control) {
      if (this._resetItemSelectionWhenShiftKeyPressed(), !r) {
        var te = this._selectionStrategy.isItemDataSelected(B);
        this.options.mode === "single" && this.clearSelectedItems(), te ? this._removeSelectedItem($) : this._addSelectedItem(B, $);
      }
      o = !0;
    } else {
      this._resetItemSelectionWhenShiftKeyPressed();
      var z = this._selectionStrategy.equalKeys(this.options.selectedItemKeys[0], $);
      (this.options.selectedItemKeys.length !== 1 || !z) && (this._setSelectedItems([$], [B]), o = !0);
    }
    if (o)
      return $e(p).done(() => {
        this._focusedItemIndex = e, !r && this.onSelectionChanged();
      }), !0;
  }
  isDataItem(e) {
    return this.options.isSelectableItem(e);
  }
  isSelectable() {
    return this.options.mode === "single" || this.options.mode === "multiple";
  }
  isItemDataSelected(e) {
    return this._selectionStrategy.isItemDataSelected(e, {
      checkPending: !0
    });
  }
  isItemSelected(e, i) {
    return this._selectionStrategy.isItemKeySelected(e, i);
  }
  _resetItemSelectionWhenShiftKeyPressed() {
    delete this._shiftFocusedItemIndex;
  }
  _resetFocusedItemIndex() {
    this._focusedItemIndex = -1;
  }
  changeItemSelectionWhenShiftKeyInVirtualPaging(e) {
    var i = this.options.getLoadOptions(e, this._focusedItemIndex, this._shiftFocusedItemIndex), r = new q(), n = i.skip;
    return this.options.load(i).done((a) => {
      this.changeItemSelectionWhenShiftKeyPressed(e, a, n), r.resolve();
    }), r.promise();
  }
  changeItemSelectionWhenShiftKeyPressed(e, i, r) {
    var n = !1, a, o = R(r), u = o ? this._focusedItemIndex - r : this._focusedItemIndex, c = this.options.keyOf, p = i[u], v = this.options.getItemData(p), _ = c(v), y = p && this.isItemDataSelected(v);
    R(this._shiftFocusedItemIndex) || (this._shiftFocusedItemIndex = this._focusedItemIndex);
    var b, I, A, L;
    if (this._shiftFocusedItemIndex !== this._focusedItemIndex)
      for (a = this._focusedItemIndex < this._shiftFocusedItemIndex ? 1 : -1, A = o ? this._focusedItemIndex - r : this._focusedItemIndex, L = o ? this._shiftFocusedItemIndex - r : this._shiftFocusedItemIndex, u = A; u !== L; u += a)
        (o || this.isDataItem(i[u])) && (I = c(this.options.getItemData(i[u])), this._removeSelectedItem(I), n = !0);
    if (e !== this._shiftFocusedItemIndex)
      for (a = e < this._shiftFocusedItemIndex ? 1 : -1, A = o ? e - r : e, L = o ? this._shiftFocusedItemIndex - r : this._shiftFocusedItemIndex, u = A; u !== L; u += a)
        (o || this.isDataItem(i[u])) && (b = this.options.getItemData(i[u]), I = c(b), this._addSelectedItem(b, I), n = !0);
    return (o || this.isDataItem(p)) && !y && (this._addSelectedItem(v, _), n = !0), n;
  }
  clearSelectedItems() {
    this._setSelectedItems([], []);
  }
  selectAll(e) {
    return this._resetFocusedItemIndex(), e ? this._onePageSelectAll(!1) : this.selectedItemKeys([], !0, !1, !0);
  }
  deselectAll(e) {
    return this._resetFocusedItemIndex(), e ? this._onePageSelectAll(!0) : this.selectedItemKeys([], !0, !0, !0);
  }
  _onePageSelectAll(e) {
    for (var i = this._selectionStrategy.getSelectableItems(this.options.plainItems()), r = 0; r < i.length; r++) {
      var n = i[r];
      if (this.isDataItem(n)) {
        var a = this.options.getItemData(n), o = this.options.keyOf(a), u = this.isItemSelected(o);
        !u && !e && this._addSelectedItem(a, o), u && e && this._removeSelectedItem(o);
      }
    }
    return this.onSelectionChanged(), new q().resolve();
  }
  getSelectAllState(e) {
    return this._selectionStrategy.getSelectAllState(e);
  }
  loadSelectedItemsWithFilter() {
    return this._selectionStrategy.loadSelectedItemsWithFilter();
  }
};
var UL = "dxItemDeleting", Yw = -1, Dl = function(t) {
  return t !== Yw;
}, Kp = H5.inherit({
  _setOptionsByReference: function() {
    this.callBase(), P(this._optionsByReference, {
      selectedItem: !0
    });
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      selectionMode: "none",
      selectionRequired: !1,
      selectByClick: !0,
      selectedItems: [],
      selectedItemKeys: [],
      maxFilterLengthInRequest: 1500,
      keyExpr: null,
      selectedIndex: Yw,
      selectedItem: null,
      onSelectionChanged: null,
      onItemReordered: null,
      onItemDeleting: null,
      onItemDeleted: null
    });
  },
  ctor: function(t, e) {
    this._userOptions = e || {}, this.callBase(t, e);
  },
  _init: function() {
    this._initEditStrategy(), this.callBase(), this._initKeyGetter(), this._initSelectionModule();
  },
  _initKeyGetter: function() {
    this._keyGetter = Ii(this.option("keyExpr"));
  },
  _getKeysByItems: function(t) {
    return this._editStrategy.getKeysByItems(t);
  },
  _getItemsByKeys: function(t, e) {
    return this._editStrategy.getItemsByKeys(t, e);
  },
  _getKeyByIndex: function(t) {
    return this._editStrategy.getKeyByIndex(t);
  },
  _getIndexByKey: function(t) {
    return this._editStrategy.getIndexByKey(t);
  },
  _getIndexByItemData: function(t) {
    return this._editStrategy.getIndexByItemData(t);
  },
  _isKeySpecified: function() {
    return !!this._dataController.key();
  },
  _getCombinedFilter: function() {
    return this._dataController.filter();
  },
  key: function() {
    return this.option("keyExpr") ? this.option("keyExpr") : this._dataController.key();
  },
  keyOf: function(t) {
    var e = t;
    return this.option("keyExpr") ? e = this._keyGetter(t) : this._dataController.store() && (e = this._dataController.keyOf(t)), e;
  },
  _nullValueSelectionSupported: function() {
    return !1;
  },
  _initSelectionModule: function() {
    var t = this, e = t._editStrategy.itemsGetter;
    this._selection = new z5({
      allowNullValue: this._nullValueSelectionSupported(),
      mode: this.option("selectionMode"),
      maxFilterLengthInRequest: this.option("maxFilterLengthInRequest"),
      equalByReference: !this._isKeySpecified(),
      onSelectionChanged: function(i) {
        (i.addedItemKeys.length || i.removedItemKeys.length) && (t.option("selectedItems", t._getItemsByKeys(i.selectedItemKeys, i.selectedItems)), t._updateSelectedItems(i));
      },
      filter: t._getCombinedFilter.bind(t),
      totalCount: function() {
        var i = t.option("items"), r = t._dataController.totalCount();
        return r >= 0 ? r : t._getItemsCount(i);
      },
      key: t.key.bind(t),
      keyOf: t.keyOf.bind(t),
      load: function(i) {
        var r, n = t._dataController;
        return i.customQueryParams = (r = n.loadOptions()) === null || r === void 0 ? void 0 : r.customQueryParams, i.userData = n.userData(), n.store() ? n.loadFromStore(i).done(function(a) {
          if (!t._disposed) {
            var o = g6(a).data;
            n.applyMapFunction(o);
          }
        }) : new q().resolve(this.plainItems());
      },
      dataFields: function() {
        return t._dataController.select();
      },
      plainItems: e.bind(t._editStrategy)
    });
  },
  _getItemsCount: function(t) {
    return t.reduce((e, i) => e + (i.items ? this._getItemsCount(i.items) : 1), 0);
  },
  _initEditStrategy: function() {
    var t = AB;
    this._editStrategy = new t(this);
  },
  _getSelectedItemIndices: function(t) {
    var e = this, i = [];
    return t = t || this._selection.getSelectedItemKeys(), e._editStrategy.beginCache(), N(t, function(r, n) {
      var a = e._getIndexByKey(n);
      Dl(a) && i.push(a);
    }), e._editStrategy.endCache(), i;
  },
  _initMarkup: function() {
    this._rendering = !0, this._dataController.isLoading() || this._syncSelectionOptions().done(() => this._normalizeSelectedItems()), this.callBase();
  },
  _render: function() {
    this.callBase(), this._rendering = !1;
  },
  _fireContentReadyAction: function() {
    this._rendering = !1, this._rendered = !0, this.callBase.apply(this, arguments);
  },
  _syncSelectionOptions: function(t) {
    t = t || this._chooseSelectOption();
    var e, i, r, n;
    switch (t) {
      case "selectedIndex":
        e = this._editStrategy.getItemDataByIndex(this.option("selectedIndex")), R(e) ? (this._setOptionWithoutOptionChange("selectedItems", [e]), this._setOptionWithoutOptionChange("selectedItem", e), this._setOptionWithoutOptionChange("selectedItemKeys", this._editStrategy.getKeysByItems([e]))) : (this._setOptionWithoutOptionChange("selectedItems", []), this._setOptionWithoutOptionChange("selectedItemKeys", []), this._setOptionWithoutOptionChange("selectedItem", null));
        break;
      case "selectedItems":
        if (n = this.option("selectedItems") || [], i = n.length ? this._editStrategy.getIndexByItemData(n[0]) : Yw, this.option("selectionRequired") && !Dl(i))
          return this._syncSelectionOptions("selectedIndex");
        this._setOptionWithoutOptionChange("selectedItem", n[0]), this._setOptionWithoutOptionChange("selectedIndex", i), this._setOptionWithoutOptionChange("selectedItemKeys", this._editStrategy.getKeysByItems(n));
        break;
      case "selectedItem":
        if (e = this.option("selectedItem"), i = this._editStrategy.getIndexByItemData(e), this.option("selectionRequired") && !Dl(i))
          return this._syncSelectionOptions("selectedIndex");
        R(e) ? (this._setOptionWithoutOptionChange("selectedItems", [e]), this._setOptionWithoutOptionChange("selectedIndex", i), this._setOptionWithoutOptionChange("selectedItemKeys", this._editStrategy.getKeysByItems([e]))) : (this._setOptionWithoutOptionChange("selectedItems", []), this._setOptionWithoutOptionChange("selectedItemKeys", []), this._setOptionWithoutOptionChange("selectedIndex", Yw));
        break;
      case "selectedItemKeys":
        if (r = this.option("selectedItemKeys"), this.option("selectionRequired")) {
          var a = this._getIndexByKey(r[0]);
          if (!Dl(a))
            return this._syncSelectionOptions("selectedIndex");
        }
        return this._selection.setSelection(r);
    }
    return new q().resolve().promise();
  },
  _chooseSelectOption: function() {
    var t = "selectedIndex", e = (function(i) {
      var r = this.option(i), n = R(r) && r.length;
      return n || i in this._userOptions;
    }).bind(this);
    return e("selectedItems") ? t = "selectedItems" : e("selectedItem") ? t = "selectedItem" : e("selectedItemKeys") && (t = "selectedItemKeys"), t;
  },
  _compareKeys: function(t, e) {
    if (t.length !== e.length)
      return !1;
    for (var i = 0; i < e.length; i++)
      if (t[i] !== e[i])
        return !1;
    return !0;
  },
  _normalizeSelectedItems: function() {
    if (this.option("selectionMode") === "none")
      this._setOptionWithoutOptionChange("selectedItems", []), this._syncSelectionOptions("selectedItems");
    else if (this.option("selectionMode") === "single") {
      var t = this.option("selectedItems");
      if (t.length > 1 || !t.length && this.option("selectionRequired") && this.option("items") && this.option("items").length) {
        var e = this._selection.getSelectedItems(), i = t[0] === void 0 ? e[0] : t[0];
        return i === void 0 && (i = this._editStrategy.itemsGetter()[0]), this.option("grouped") && i && i.items && (i.items = [i.items[0]]), this._selection.setSelection(this._getKeysByItems([i])), this._setOptionWithoutOptionChange("selectedItems", [i]), this._syncSelectionOptions("selectedItems");
      } else
        this._selection.setSelection(this._getKeysByItems(t));
    } else {
      var r = this._getKeysByItems(this.option("selectedItems")), n = this._selection.getSelectedItemKeys();
      this._compareKeys(n, r) || this._selection.setSelection(r);
    }
    return new q().resolve().promise();
  },
  _itemClickHandler: function(t) {
    var e = new q().resolve(), i = this.callBase;
    this._createAction((function(r) {
      var n;
      e = (n = this._itemSelectHandler(r.event)) !== null && n !== void 0 ? n : e;
    }).bind(this), {
      validatingTargetName: "itemElement"
    })({
      itemElement: E(t.currentTarget),
      event: t
    }), e.always(() => {
      i.apply(this, arguments);
    });
  },
  _itemSelectHandler: function(t) {
    var e, i;
    if (this.option("selectByClick")) {
      var r = t.currentTarget;
      return this.isItemSelected(r) ? this.unselectItem(t.currentTarget) : i = this.selectItem(t.currentTarget), (e = i) === null || e === void 0 ? void 0 : e.promise();
    }
  },
  _selectedItemElement: function(t) {
    return this._itemElements().eq(t);
  },
  _postprocessRenderItem: function(t) {
    if (this.option("selectionMode") !== "none") {
      var e = E(t.itemElement), i = this._editStrategy.getNormalizedIndex(e), r = this._isItemSelected(i);
      this._processSelectableItem(e, r);
    }
  },
  _processSelectableItem: function(t, e) {
    t.toggleClass(this._selectedItemClass(), e), this._setAriaSelectionAttribute(t, String(e));
  },
  _updateSelectedItems: function(t) {
    var e = this, i = t.addedItemKeys, r = t.removedItemKeys;
    if (e._rendered && (i.length || r.length)) {
      var n = e._selectionChangePromise;
      if (!e._rendering) {
        var a = [], o, u = [];
        e._editStrategy.beginCache();
        for (var c = 0; c < i.length; c++)
          o = e._getIndexByKey(i[c]), a.push(o), e._addSelection(o);
        for (var p = 0; p < r.length; p++)
          o = e._getIndexByKey(r[p]), u.push(o), e._removeSelection(o);
        e._editStrategy.endCache(), e._updateSelection(a, u);
      }
      $e(n).done(function() {
        e._fireSelectionChangeEvent(t.addedItems, t.removedItems);
      });
    }
  },
  _fireSelectionChangeEvent: function(t, e) {
    this._createActionByOption("onSelectionChanged", {
      excludeValidators: ["disabled", "readOnly"]
    })({
      addedItems: t,
      removedItems: e
    });
  },
  _updateSelection: ee,
  _setAriaSelectionAttribute: function(t, e) {
    this.setAria("selected", e, t);
  },
  _removeSelection: function(t) {
    var e = this._editStrategy.getItemElement(t);
    Dl(t) && (this._processSelectableItem(e, !1), k.triggerHandler(e, "stateChanged", !1));
  },
  _addSelection: function(t) {
    var e = this._editStrategy.getItemElement(t);
    Dl(t) && (this._processSelectableItem(e, !0), k.triggerHandler(e, "stateChanged", !0));
  },
  _isItemSelected: function(t) {
    var e = this._getKeyByIndex(t);
    return this._selection.isItemSelected(e, {
      checkPending: !0
    });
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "selectionMode":
        this._invalidate();
        break;
      case "dataSource":
        (!t.value || Array.isArray(t.value) && !t.value.length) && this.option("selectedItemKeys", []), this.callBase(t);
        break;
      case "selectedIndex":
      case "selectedItem":
      case "selectedItems":
      case "selectedItemKeys":
        this._syncSelectionOptions(t.name).done(() => this._normalizeSelectedItems());
        break;
      case "keyExpr":
        this._initKeyGetter();
        break;
      case "selectionRequired":
        this._normalizeSelectedItems();
        break;
      case "selectByClick":
      case "onSelectionChanged":
      case "onItemDeleting":
      case "onItemDeleted":
      case "onItemReordered":
      case "maxFilterLengthInRequest":
        break;
      default:
        this.callBase(t);
    }
  },
  _clearSelectedItems: function() {
    this._setOptionWithoutOptionChange("selectedItems", []), this._syncSelectionOptions("selectedItems");
  },
  _waitDeletingPrepare: function(t) {
    if (t.data(UL))
      return new q().resolve().promise();
    t.data(UL, !0);
    var e = new q(), i = {
      cancel: !1
    }, r = this._itemEventHandler(t, "onItemDeleting", i, {
      excludeValidators: ["disabled", "readOnly"]
    });
    return $e(r).always((function(n) {
      var a = !r, o = !a && r.state() === "resolved", u = !!arguments.length, c = a || o && !u || o && n;
      $e(Pn(i.cancel)).always(function() {
        t.data(UL, !1);
      }).done(function(p) {
        c && !p ? e.resolve() : e.reject();
      }).fail(e.reject);
    }).bind(this)), e.promise();
  },
  _deleteItemFromDS: function(t) {
    var e = this._dataController, i = new q(), r = this.option("disabled"), n = e.store();
    if (!n)
      return new q().resolve().promise();
    if (!n.remove)
      throw Yt.Error("E1011");
    return this.option("disabled", !0), n.remove(e.keyOf(this._getItemData(t))).done(function(a) {
      a !== void 0 ? i.resolve() : i.reject();
    }).fail(function() {
      i.reject();
    }), i.always((function() {
      this.option("disabled", r);
    }).bind(this)), i;
  },
  _tryRefreshLastPage: function() {
    var t = new q();
    return this._isLastPage() || this.option("grouped") ? t.resolve() : this._refreshLastPage().done(function() {
      t.resolve();
    }), t.promise();
  },
  _refreshLastPage: function() {
    return this._expectLastItemLoading(), this._dataController.load();
  },
  _updateSelectionAfterDelete: function(t) {
    var e = this._getKeyByIndex(t);
    this._selection.deselect([e]);
  },
  _updateIndicesAfterIndex: function(t) {
    for (var e = this._itemElements(), i = t + 1; i < e.length; i++)
      E(e[i]).data(this._itemIndexKey(), i - 1);
  },
  _simulateOptionChange: function(t) {
    var e = this.option(t);
    e instanceof Ks || this._optionChangedAction({
      name: t,
      fullName: t,
      value: e
    });
  },
  isItemSelected: function(t) {
    return this._isItemSelected(this._editStrategy.getNormalizedIndex(t));
  },
  selectItem: function(t) {
    if (this.option("selectionMode") !== "none") {
      var e = this._editStrategy.getNormalizedIndex(t);
      if (Dl(e)) {
        var i = this._getKeyByIndex(e);
        if (!this._selection.isItemSelected(i)) {
          if (this.option("selectionMode") === "single")
            return this._selection.setSelection([i]);
          var r = this.option("selectedItemKeys") || [];
          return this._selection.setSelection([...r, i], [i]);
        }
      }
    }
  },
  unselectItem: function(t) {
    var e = this._editStrategy.getNormalizedIndex(t);
    if (Dl(e)) {
      var i = this._selection.getSelectedItemKeys();
      if (!(this.option("selectionRequired") && i.length <= 1)) {
        var r = this._getKeyByIndex(e);
        this._selection.isItemSelected(r, {
          checkPending: !0
        }) && this._selection.deselect([r]);
      }
    }
  },
  _deleteItemElementByIndex: function(t) {
    this._updateSelectionAfterDelete(t), this._updateIndicesAfterIndex(t), this._editStrategy.deleteItemAtIndex(t);
  },
  _afterItemElementDeleted: function(t, e) {
    var i = this._dataController.getDataSource() ? "dataSource" : "items";
    this._simulateOptionChange(i), this._itemEventHandler(t, "onItemDeleted", e, {
      beforeExecute: function() {
        t.remove();
      },
      excludeValidators: ["disabled", "readOnly"]
    }), this._renderEmptyMessage();
  },
  deleteItem: function(t) {
    var e = this, i = new q(), r = this._editStrategy.getItemElement(t), n = this._editStrategy.getNormalizedIndex(t), a = this._itemResponseWaitClass();
    return Dl(n) ? this._waitDeletingPrepare(r).done(function() {
      r.addClass(a);
      var o = e._extendActionArgs(r);
      e._deleteItemFromDS(r).done(function() {
        e._deleteItemElementByIndex(n), e._afterItemElementDeleted(r, o), e._tryRefreshLastPage().done(function() {
          i.resolveWith(e);
        });
      }).fail(function() {
        r.removeClass(a), i.rejectWith(e);
      });
    }).fail(function() {
      i.rejectWith(e);
    }) : i.rejectWith(e), i.promise();
  },
  reorderItem: function(t, e) {
    var i = new q(), r = this, n = this._editStrategy, a = n.getItemElement(t), o = n.getItemElement(e), u = n.getNormalizedIndex(t), c = n.getNormalizedIndex(e), p = this._dataController.getDataSource() ? "dataSource" : "items", v = Dl(u) && Dl(c) && u !== c;
    return v ? i.resolveWith(this) : i.rejectWith(this), i.promise().done(function() {
      o[n.itemPlacementFunc(u, c)](a), n.moveItemAtIndexToIndex(u, c), this._updateIndicesAfterIndex(u), r.option("selectedItems", r._getItemsByKeys(r._selection.getSelectedItemKeys(), r._selection.getSelectedItems())), p === "items" && r._simulateOptionChange(p), r._itemEventHandler(a, "onItemReordered", {
        fromIndex: n.getIndex(u),
        toIndex: n.getIndex(c)
      }, {
        excludeValidators: ["disabled", "readOnly"]
      });
    });
  }
}), nCe = "dx-state-disabled", aCe = "dx-item-url", W5 = Kp.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      keyExpr: "id",
      displayExpr: "text",
      selectedExpr: "selected",
      disabledExpr: "disabled",
      itemsExpr: "items",
      hoverStateEnabled: !0,
      parentIdExpr: "parentId",
      expandedExpr: "expanded"
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: function() {
        return Ye.real().deviceType === "desktop" && !Ye.isSimulator();
      },
      options: {
        focusStateEnabled: !0
      }
    }]);
  },
  _init: function() {
    this.callBase(), this._initAccessors(), this._initDataAdapter(), this._initDynamicTemplates();
  },
  _initDataSource: function() {
    this.callBase(), this._dataSource && this._dataSource.paginate(!1);
  },
  _initDataAdapter: function() {
    var t = this._createDataAdapterAccessors();
    this._dataAdapter = new L_e(P({
      dataAccessors: {
        getters: t.getters,
        setters: t.setters
      },
      items: this.option("items")
    }, this._getDataAdapterOptions()));
  },
  _getDataAdapterOptions: ee,
  _getItemExtraPropNames: ee,
  _initDynamicTemplates: function() {
    var t = ["text", "html", "items", "icon"].concat(this._getItemExtraPropNames());
    this._templateManager.addDefaultTemplates({
      item: new Gp(this._addContent.bind(this), t, this.option("integrationOptions.watchMethod"), {
        text: this._displayGetter,
        items: this._itemsGetter
      })
    });
  },
  _addContent: function(t, e) {
    t.html(e.html).append(this._getIconContainer(e)).append(this._getTextContainer(e));
  },
  _getLinkContainer: function(t, e, i) {
    var {
      linkAttr: r,
      url: n
    } = i, a = ct(r) ? r : {};
    return E("<a>").addClass(aCe).attr(ae({}, a, {
      href: n
    })).append(t).append(e);
  },
  _getIconContainer: function(t) {
    if (t.icon) {
      var e = ec(t.icon);
      return e.is("img") && e.attr("alt", "".concat(this.NAME, " item icon")), e;
    }
  },
  _getTextContainer: function(t) {
    return E("<span>").text(t.text);
  },
  _initAccessors: function() {
    var t = this;
    N(this._getAccessors(), function(e, i) {
      t._compileAccessor(i);
    }), this._compileDisplayGetter();
  },
  _getAccessors: function() {
    return ["key", "selected", "items", "disabled", "parentId", "expanded"];
  },
  _getChildNodes: function(t) {
    var e = this, i = [];
    return N(t.internalFields.childrenKeys, function(r, n) {
      var a = e._dataAdapter.getNodeByKey(n);
      i.push(a);
    }), i;
  },
  _hasChildren: function(t) {
    return t && t.internalFields.childrenKeys.length;
  },
  _compileAccessor: function(t) {
    var e = "_" + t + "Getter", i = "_" + t + "Setter", r = this.option(t + "Expr");
    if (r) {
      if (Le(r)) {
        this[i] = function(n, a) {
          n[r()] = a;
        }, this[e] = function(n) {
          return n[r()];
        };
        return;
      }
    } else {
      this[e] = ee, this[i] = ee;
      return;
    }
    this[e] = Ii(r), this[i] = nF(r);
  },
  _createDataAdapterAccessors: function() {
    var t = this, e = {
      getters: {},
      setters: {}
    };
    return N(this._getAccessors(), function(i, r) {
      var n = "_" + r + "Getter", a = "_" + r + "Setter", o = r === "parentId" ? "parentKey" : r;
      e.getters[o] = t[n], e.setters[o] = t[a];
    }), e.getters.display = this._displayGetter ? this._displayGetter : (i) => i.text, e;
  },
  _initMarkup: function() {
    this.callBase(), this._addWidgetClass();
  },
  _addWidgetClass: function() {
    this._focusTarget().addClass(this._widgetClass());
  },
  _widgetClass: ee,
  _renderItemFrame: function(t, e) {
    var i = this.callBase.apply(this, arguments);
    return i.toggleClass(nCe, !!this._disabledGetter(e)), i;
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "displayExpr":
      case "keyExpr":
        this._initAccessors(), this._initDynamicTemplates(), this.repaint();
        break;
      case "itemsExpr":
      case "selectedExpr":
      case "disabledExpr":
      case "expandedExpr":
      case "parentIdExpr":
        this._initAccessors(), this._initDataAdapter(), this.repaint();
        break;
      case "items":
        this._initDataAdapter(), this.callBase(t);
        break;
      default:
        this.callBase(t);
    }
  }
});
class oCe extends AB {
  _getPlainItems() {
    return Jr(this._collectionWidget.option("items"), function e(i) {
      return i.items ? [i].concat(Jr(i.items, e)) : i;
    });
  }
  _stringifyItem(e) {
    return JSON.stringify(e, (i, r) => i === "template" ? this._getTemplateString(r) : r);
  }
  _getTemplateString(e) {
    var i;
    return typeof e == "object" ? i = E(e).text() : i = e.toString(), i;
  }
}
var bS = "dx-menu", sCe = bS + "-no-icons", lCe = "dx-menu-base", Us = bS + "-item", uCe = Us + "-content", GL = Us + "-selected", bG = Us + "-wrapper", dCe = bS + "-items-container", cCe = Us + "-expanded", hCe = bS + "-separator", fCe = bS + "-last-group-item", pCe = Us + "-has-text", vCe = Us + "-has-icon", gCe = Us + "-has-submenu", U5 = Us + "-popout", mCe = U5 + "-container", G5 = Us + "-text", _Ce = "single", CCe = {
  show: 50,
  hide: 300
}, yCe = "".concat(G5, "-with-url"), xCe = "dx-icon-with-url", SCe = "dx-item-url";
class OB extends W5 {
  _getDefaultOptions() {
    return P(super._getDefaultOptions(), {
      items: [],
      cssClass: "",
      activeStateEnabled: !0,
      showSubmenuMode: {
        name: "onHover",
        delay: {
          show: 50,
          hide: 300
        }
      },
      animation: {
        show: {
          type: "fade",
          from: 0,
          to: 1,
          duration: 100
        },
        hide: {
          type: "fade",
          from: 1,
          to: 0,
          duration: 100
        }
      },
      selectByClick: !1,
      focusOnSelectedItem: !1,
      keyExpr: null,
      _itemAttributes: {
        role: "menuitem"
      },
      useInkRipple: !1
    });
  }
  _itemDataKey() {
    return "dxMenuItemDataKey";
  }
  _itemClass() {
    return Us;
  }
  _setAriaSelectionAttribute() {
  }
  _selectedItemClass() {
    return GL;
  }
  _widgetClass() {
    return lCe;
  }
  _focusTarget() {
    return this._itemContainer();
  }
  _clean() {
    this.option("focusedElement", null), super._clean();
  }
  _supportedKeys() {
    return P(super._supportedKeys(), {
      space: () => {
        var e = E(this.option("focusedElement"));
        !e.length || !this._isSelectionEnabled() || this.selectItem(e[0]);
      },
      pageUp: ee,
      pageDown: ee
    });
  }
  _isSelectionEnabled() {
    return this.option("selectionMode") === _Ce;
  }
  _init() {
    this._activeStateUnit = ".".concat(Us), super._init(), this._renderSelectedItem(), this._initActions();
  }
  _getLinkContainer(e, i, r) {
    var {
      linkAttr: n,
      url: a
    } = r;
    return e == null || e.addClass(xCe), i == null || i.addClass(yCe), super._getLinkContainer(e, i, {
      linkAttr: n,
      url: a
    });
  }
  _addContent(e, i) {
    var {
      html: r,
      url: n
    } = i;
    if (n) {
      e.html(r);
      var a = this._getLinkContainer(this._getIconContainer(i), this._getTextContainer(i), i);
      e.append(a);
    } else
      super._addContent(e, i);
    e.append(this._getPopoutContainer(i)), this._addContentClasses(i, e.parent());
  }
  _getTextContainer(e) {
    var {
      text: i
    } = e;
    if (i) {
      var r = E("<span>").addClass(G5), n = $t(e) ? i : String(e);
      return r.text(n);
    }
  }
  _getItemExtraPropNames() {
    return ["url", "linkAttr"];
  }
  _getPopoutContainer(e) {
    var i = e.items, r;
    if (i && i.length) {
      var n = E("<div>").addClass(U5);
      r = E("<span>").addClass(mCe).append(n);
    }
    return r;
  }
  _getDataAdapterOptions() {
    return {
      rootValue: 0,
      multipleSelection: !1,
      recursiveSelection: !1,
      recursiveExpansion: !1,
      searchValue: ""
    };
  }
  _selectByItem(e) {
    if (e) {
      var i = this._dataAdapter.getNodeByItem(e);
      this._dataAdapter.toggleSelection(i.internalFields.key, !0);
    }
  }
  _renderSelectedItem() {
    var e = this._dataAdapter.getSelectedNodesKeys(), i = e.length && e[0], r = this.option("selectedItem");
    if (!i) {
      this._selectByItem(r);
      return;
    }
    var n = this._dataAdapter.getNodeByKey(i);
    if (n.selectable !== !1) {
      if (!r) {
        this.option("selectedItem", n.internalFields.item);
        return;
      }
      r !== n.internalFields.item && (this._dataAdapter.toggleSelection(i, !1), this._selectByItem(r));
    }
  }
  _initActions() {
  }
  _initMarkup() {
    super._initMarkup(), this.option("useInkRipple") && this._renderInkRipple();
  }
  _renderInkRipple() {
    this._inkRipple = NF();
  }
  _toggleActiveState(e, i, r) {
    if (super._toggleActiveState.apply(this, arguments), !!this._inkRipple) {
      var n = {
        element: e,
        event: r
      };
      i ? this._inkRipple.showWave(n) : this._inkRipple.hideWave(n);
    }
  }
  _getShowSubmenuMode() {
    var e = this.option("showSubmenuMode");
    return e = ct(e) ? e.name : e, this._isDesktopDevice() ? e : "onClick";
  }
  _initSelectedItems() {
  }
  _isDesktopDevice() {
    return Ye.real().deviceType === "desktop";
  }
  _initEditStrategy() {
    var e = oCe;
    this._editStrategy = new e(this);
  }
  _addCustomCssClass(e) {
    e.addClass(this.option("cssClass"));
  }
  _itemWrapperSelector() {
    return ".".concat(bG);
  }
  _hoverStartHandler(e) {
    var i = this._getItemElementByEventArgs(e);
    !i || this._isItemDisabled(i) || (e.stopPropagation(), this._getShowSubmenuMode() === "onHover" && (clearTimeout(this._showSubmenusTimeout), this._showSubmenusTimeout = setTimeout(this._showSubmenu.bind(this, i), this._getSubmenuDelay("show"))));
  }
  _getAvailableItems(e) {
    return super._getAvailableItems(e).filter(function() {
      return E(this).css("visibility") !== "hidden";
    });
  }
  _isItemDisabled(e) {
    return this._disabledGetter(e.data(this._itemDataKey()));
  }
  _showSubmenu(e) {
    this._addExpandedClass(e);
  }
  _addExpandedClass(e) {
    E(e).addClass(cCe);
  }
  _getSubmenuDelay(e) {
    var {
      delay: i
    } = this.option("showSubmenuMode");
    return R(i) ? ct(i) ? i[e] : i : CCe[e];
  }
  _getItemElementByEventArgs(e) {
    var i = E(e.target);
    if (i.hasClass(this._itemClass()) || i.get(0) === e.currentTarget)
      return i;
    for (; !i.hasClass(this._itemClass()); )
      if (i = i.parent(), i.hasClass("dx-submenu"))
        return null;
    return i;
  }
  _hoverEndHandler() {
    clearTimeout(this._showSubmenusTimeout);
  }
  _hasSubmenu(e) {
    return e && e.internalFields.childrenKeys.length;
  }
  _renderContentImpl() {
    this._renderItems(this._dataAdapter.getRootNodes());
  }
  _renderItems(e, i) {
    if (e.length) {
      this.hasIcons = !1;
      var r = this._renderContainer(this.$element(), i), n = -1, a = -1;
      N(e, (o, u) => {
        var c = u.visible !== !1;
        c && n < 0 && (n = o);
        var p = n < o && (u.beginGroup || o === a);
        p && (a = c ? o : o + 1), o === a && n < o && this._renderSeparator(r), this._renderItem(o, u, r);
      }), this.hasIcons || r.addClass(sCe);
    }
  }
  _renderContainer(e) {
    var i = E("<ul>");
    return this.setAria("role", "none", i), i.appendTo(e).addClass(dCe);
  }
  _createDOMElement(e) {
    var i = E("<li>");
    return this.setAria("role", "none", i), i.appendTo(e).addClass(bG);
  }
  _renderItem(e, i, r, n) {
    var a = this.option("items"), o = n || this._createDOMElement(r);
    a[e + 1] && a[e + 1].beginGroup && o.addClass(fCe);
    var u = super._renderItem(e, i.internalFields.item, o);
    i.internalFields.item === this.option("selectedItem") && u.addClass(GL), u.attr("tabIndex", -1), this._hasSubmenu(i) && this.setAria("haspopup", "true", u);
  }
  _renderItemFrame(e, i, r) {
    var n = r.children(".".concat(Us));
    return n.length ? n : super._renderItemFrame.apply(this, arguments);
  }
  _refreshItem(e, i) {
    var r = this._dataAdapter.getNodeByItem(i), n = e.data(this._itemIndexKey()), a = e.closest("ul"), o = e.closest("li");
    this._renderItem(n, r, a, o);
  }
  _addContentClasses(e, i) {
    var r = e.text ? !!e.text.length : !1, n = !!e.icon, a = e.items ? !!e.items.length : !1;
    i.toggleClass(pCe, r), i.toggleClass(vCe, n), this.hasIcons || (this.hasIcons = n), i.toggleClass(gCe, a);
  }
  _getItemContent(e) {
    var i = super._getItemContent(e);
    return i.length || (i = e.children(".".concat(uCe))), i;
  }
  _postprocessRenderItem(e) {
    var i = E(e.itemElement), r = this._dataAdapter.getSelectedNodesKeys();
    if (!r.length || !this._selectedGetter(e.itemData) || !this._isItemSelectable(e.itemData)) {
      this._setAriaSelectionAttribute(i, "false");
      return;
    }
    var n = this._dataAdapter.getNodeByItem(e.itemData);
    n.internalFields.key === r[0] ? (i.addClass(this._selectedItemClass()), this._setAriaSelectionAttribute(i, "true")) : this._setAriaSelectionAttribute(i, "false");
  }
  _isItemSelectable(e) {
    return e.selectable !== !1;
  }
  _renderSeparator(e) {
    E("<li>").appendTo(e).addClass(hCe);
  }
  _itemClickHandler(e) {
    if (!e._skipHandling) {
      var i = this._createAction(this._updateSubmenuVisibilityOnClick.bind(this));
      this._itemDXEventHandler(e, "onItemClick", {}, {
        beforeExecute: this._itemClick,
        afterExecute: i.bind(this)
      }), e._skipHandling = !0;
    }
  }
  _itemClick(e) {
    var {
      event: i,
      itemData: r
    } = e.args[0], n = this._getItemElementByEventArgs(i), a = n && n.find(".".concat(SCe)).get(0);
    r.url && a && a.click();
  }
  _updateSubmenuVisibilityOnClick(e) {
    this._updateSelectedItemOnClick(e), this._getShowSubmenuMode() === "onClick" && this._addExpandedClass(e.args[0].itemElement);
  }
  _updateSelectedItemOnClick(e) {
    var i = e.args ? e.args[0] : e;
    if (this._isItemSelectAllowed(i.itemData)) {
      var r = this._dataAdapter.getSelectedNodesKeys(), n = r.length && this._dataAdapter.getNodeByKey(r[0]);
      n && this._toggleItemSelection(n, !1), !n || n.internalFields.item !== i.itemData ? this.selectItem(i.itemData) : (this._fireSelectionChangeEvent(null, this.option("selectedItem")), this._setOptionWithoutOptionChange("selectedItem", null));
    }
  }
  _isItemSelectAllowed(e) {
    var i = this._isSelectionEnabled() && this.option("selectByClick");
    return !this._isContainerEmpty() && i && this._isItemSelectable(e) && !this._itemsGetter(e);
  }
  _isContainerEmpty() {
    return this._itemContainer().is(":empty");
  }
  _syncSelectionOptions() {
    return tj();
  }
  _optionChanged(e) {
    switch (e.name) {
      case "showSubmenuMode":
        break;
      case "selectedItem":
        var i = this._dataAdapter.getNodeByItem(e.value), r = this._dataAdapter.getSelectedNodesKeys()[0];
        if (i && i.internalFields.key !== r) {
          if (i.selectable === !1)
            break;
          r && this._toggleItemSelection(this._dataAdapter.getNodeByKey(r), !1), this._toggleItemSelection(i, !0), this._updateSelectedItems();
        }
        break;
      case "cssClass":
      case "position":
      case "selectByClick":
      case "animation":
      case "useInkRipple":
        this._invalidate();
        break;
      default:
        super._optionChanged(e);
    }
  }
  _toggleItemSelection(e, i) {
    var r = this._getElementByItem(e.internalFields.item);
    r && E(r).toggleClass(GL), this._dataAdapter.toggleSelection(e.internalFields.key, i);
  }
  _getElementByItem(e) {
    var i;
    return N(this._itemElements(), (r, n) => E(n).data(this._itemDataKey()) !== e ? !0 : (i = n, !1)), i;
  }
  _updateSelectedItems(e, i) {
    (e || i) && this._fireSelectionChangeEvent(i, e);
  }
  _fireSelectionChangeEvent(e, i) {
    this._createActionByOption("onSelectionChanged", {
      excludeValidators: ["disabled", "readOnly"]
    })({
      addedItems: [e],
      removedItems: [i]
    });
  }
  selectItem(e) {
    var i = e.nodeType ? this._getItemData(e) : e, r = this._dataAdapter.getSelectedNodesKeys()[0], n = this.option("selectedItem"), a = this._dataAdapter.getNodeByItem(i);
    a.internalFields.key !== r && (r && this._toggleItemSelection(this._dataAdapter.getNodeByKey(r), !1), this._toggleItemSelection(a, !0), this._updateSelectedItems(n, i), this._setOptionWithoutOptionChange("selectedItem", i));
  }
  unselectItem(e) {
    var i = e.nodeType ? this._getItemData(e) : e, r = this._dataAdapter.getNodeByItem(i), n = this.option("selectedItem");
    r.internalFields.selected && (this._toggleItemSelection(r, !1), this._updateSelectedItems(n, null), this._setOptionWithoutOptionChange("selectedItem", null));
  }
}
OB.ItemClass = Up;
var K5 = "dx-menu", mx = K5 + "-item", Qg = mx + "-expanded", ECe = "dx-menu-phone-overlay", ew = K5 + "-items-container", wG = mx + "-wrapper", Bo = "dx-submenu", bCe = "dx-context-menu", wCe = "dx-has-context-menu", TCe = "dx-state-disabled", ICe = "dx-state-focused", TG = "dx-state-hover", DCe = "dx-overlay-content", j5 = "up", Y5 = "down", ACe = "left", OCe = "right", q5 = "first", X5 = "last", IG = ["onShowing", "onShown", "onSubmenuCreated", "onHiding", "onHidden", "onPositioning", "onLeftFirstItem", "onLeftLastItem", "onCloseRootSubmenu", "onExpandLastSubmenu"], RCe = [j5, Y5, q5, X5], DG = "dxcontextmenu", LCe = Ot();
class RB extends OB {
  getShowEvent(e) {
    var i = null;
    return ct(e) ? e.name !== null && (i = e.name || DG) : i = e, i;
  }
  getShowDelay(e) {
    return ct(e) && e.delay;
  }
  _getDefaultOptions() {
    return P(super._getDefaultOptions(), {
      showEvent: DG,
      hideOnOutsideClick: !0,
      position: {
        at: "top left",
        my: "top left"
      },
      onShowing: null,
      onShown: null,
      onSubmenuCreated: null,
      onHiding: null,
      onHidden: null,
      onPositioning: null,
      submenuDirection: "auto",
      visible: !1,
      target: void 0,
      onLeftFirstItem: null,
      onLeftLastItem: null,
      onCloseRootSubmenu: null,
      onExpandLastSubmenu: null
    });
  }
  _defaultOptionsRules() {
    return super._defaultOptionsRules().concat([{
      device: () => !wt(),
      options: {
        animation: null
      }
    }]);
  }
  _setDeprecatedOptions() {
    super._setDeprecatedOptions(), P(this._deprecatedOptions, {
      closeOnOutsideClick: {
        since: "22.2",
        alias: "hideOnOutsideClick"
      }
    });
  }
  _initActions() {
    this._actions = {}, N(IG, (e, i) => {
      this._actions[i] = this._createActionByOption(i) || ee;
    });
  }
  _setOptionsByReference() {
    super._setOptionsByReference(), P(this._optionsByReference, {
      animation: !0,
      selectedItem: !0
    });
  }
  _focusInHandler() {
  }
  _itemContainer() {
    return this._overlay ? this._overlay.$content() : E();
  }
  _eventBindingTarget() {
    return this._itemContainer();
  }
  itemsContainer() {
    return this._overlay ? this._overlay.$content() : void 0;
  }
  _supportedKeys() {
    return P(super._supportedKeys(), {
      space: () => {
        var e = E(this.option("focusedElement"));
        this.hide(), !(!e.length || !this._isSelectionEnabled()) && this.selectItem(e[0]);
      },
      escape: this.hide
    });
  }
  _getActiveItem() {
    var e = this._getAvailableItems(), i = e.filter(".".concat(ICe)), r = e.filter(".".concat(TG)), n = r.closest(".".concat(ew));
    return n.find(".".concat(mx)).index(i) >= 0 ? i : r.length ? r : super._getActiveItem();
  }
  _moveFocus(e) {
    var i = this._getItemsByLocation(e), r = this._getActiveItem(!0), n = this.itemsContainer().find(".".concat(TG)), a = E(this.option("focusedElement")), o = !!(a.length || n.length), u;
    switch (e) {
      case j5:
        u = o ? this._prevItem(i) : r, this._setFocusedElement(u), r.is(i.first()) && this._actions.onLeftFirstItem(r);
        break;
      case Y5:
        u = o ? this._nextItem(i) : r, this._setFocusedElement(u), r.is(i.last()) && this._actions.onLeftLastItem(r);
        break;
      case OCe:
        u = this.option("rtlEnabled") ? this._hideSubmenuHandler() : this._expandSubmenuHandler(i, e), this._setFocusedElement(u);
        break;
      case ACe:
        u = this.option("rtlEnabled") ? this._expandSubmenuHandler(i, e) : this._hideSubmenuHandler(), this._setFocusedElement(u);
        break;
      case q5:
        u = i.first(), this._setFocusedElement(u);
        break;
      case X5:
        u = i.last(), this._setFocusedElement(u);
        break;
      default:
        return super._moveFocus(e);
    }
  }
  _setFocusedElement(e) {
    e && e.length !== 0 && this.option("focusedElement", ot(e));
  }
  _getItemsByLocation(e) {
    var i = this._getActiveItem(!0), r;
    return RCe.includes(e) && (r = i.closest(".".concat(ew)).children().children()), r = this._getAvailableItems(r), r;
  }
  _getAriaTarget() {
    return this.$element();
  }
  _refreshActiveDescendant() {
    if (R(this._overlay)) {
      var e = this._overlay.$content();
      super._refreshActiveDescendant(e);
    }
  }
  _hideSubmenuHandler() {
    var e = this._getActiveItem(!0), i = e.parents(".".concat(Qg)).first();
    return i.length ? (this._hideSubmenusOnSameLevel(i), this._hideSubmenu(e.closest(".".concat(Bo))), i) : (this._actions.onCloseRootSubmenu(e), e);
  }
  _expandSubmenuHandler(e, i) {
    var r = this._getActiveItem(!0), n = this._getItemData(r), a = this._dataAdapter.getNodeByItem(n), o = this._hasSubmenu(a), u = r.children(".".concat(Bo));
    if (o && !r.hasClass(TCe))
      return (!u.length || u.css("visibility") === "hidden") && this._showSubmenu(r), this._nextItem(this._getItemsByLocation(i));
    this._actions.onExpandLastSubmenu(r);
  }
  _clean() {
    this._overlay && (this._overlay.$element().remove(), this._overlay = null), this._detachShowContextMenuEvents(this._getTarget()), super._clean();
  }
  _initMarkup() {
    this.$element().addClass(wCe), super._initMarkup();
  }
  _render() {
    super._render(), this._renderVisibility(this.option("visible")), this._addWidgetClass();
  }
  _renderContentImpl() {
    this._detachShowContextMenuEvents(this._getTarget()), this._attachShowContextMenuEvents();
  }
  _attachKeyboardEvents() {
    !this._keyboardListenerId && this._focusTarget().length && super._attachKeyboardEvents();
  }
  _renderContextMenuOverlay() {
    if (!this._overlay) {
      var e = this._getOverlayOptions();
      this._overlay = this._createComponent(E("<div>").appendTo(this._$element), Pl, e);
      var i = this._overlay.$content();
      i.addClass(bCe), this._addCustomCssClass(i), this._addPlatformDependentClass(i), this._attachContextMenuEvent();
    }
  }
  preventShowingDefaultContextMenuAboveOverlay() {
    var e = this._itemContainer(), i = ve(N5, this.NAME);
    k.off(e, i, ".".concat(Bo)), k.on(e, i, ".".concat(Bo), ((r) => {
      r.stopPropagation(), r.preventDefault(), k.off(e, i, ".".concat(Bo));
    }).bind(this));
  }
  _itemContextMenuHandler(e) {
    super._itemContextMenuHandler(e), e.stopPropagation();
  }
  _addPlatformDependentClass(e) {
    Ye.current().phone && e.addClass(ECe);
  }
  _detachShowContextMenuEvents(e) {
    var i = this.getShowEvent(this.option("showEvent"));
    if (i) {
      var r = ve(i, this.NAME);
      this._showContextMenuEventHandler ? k.off(de.getDocument(), r, e, this._showContextMenuEventHandler) : k.off(E(e), r);
    }
  }
  _attachShowContextMenuEvents() {
    var e = this._getTarget(), i = this.getShowEvent(this.option("showEvent"));
    if (i) {
      var r = ve(i, this.NAME), n = this._createAction((o) => {
        var u = this.getShowDelay(this.option("showEvent"));
        u ? setTimeout(() => this._show(o.event), u) : this._show(o.event);
      }, {
        validatingTargetName: "target"
      }), a = (o) => n({
        event: o,
        target: E(o.currentTarget)
      });
      n = this._createAction(n), hs(e) || e.nodeType || Or(e) ? (this._showContextMenuEventHandler = void 0, k.on(e, r, a)) : (this._showContextMenuEventHandler = a, k.on(de.getDocument(), r, e, this._showContextMenuEventHandler));
    }
  }
  _hoverEndHandler(e) {
    super._hoverEndHandler(e), e.stopPropagation();
  }
  _renderDimensions() {
  }
  _renderContainer(e, i) {
    var r = i || this._itemContainer();
    e = E("<div>"), e.appendTo(r).addClass(Bo).css("visibility", i ? "hidden" : "visible"), e.parent().hasClass(DCe) || this._addCustomCssClass(e);
    var n = super._renderContainer(e);
    return i ? n : this.option("width") ? n.css("minWidth", this.option("width")) : this.option("height") ? n.css("minHeight", this.option("height")) : n;
  }
  _renderSubmenuItems(e, i) {
    this._renderItems(this._getChildNodes(e), i), this._actions.onSubmenuCreated({
      itemElement: ot(i),
      itemData: e.internalFields.item,
      submenuElement: ot(i.children(".".concat(Bo)))
    });
  }
  _getOverlayOptions() {
    var e = this.option("position"), i = {
      focusStateEnabled: this.option("focusStateEnabled"),
      animation: this.option("animation"),
      innerOverlay: !0,
      hideOnOutsideClick: (r) => this._hideOnOutsideClickHandler(r),
      propagateOutsideClick: !0,
      hideOnParentScroll: !0,
      deferRendering: !1,
      position: {
        at: e.at,
        my: e.my,
        of: this._getTarget(),
        collision: "flipfit"
      },
      shading: !1,
      showTitle: !1,
      height: "auto",
      width: "auto",
      onShown: this._overlayShownActionHandler.bind(this),
      onHiding: this._overlayHidingActionHandler.bind(this),
      onHidden: this._overlayHiddenActionHandler.bind(this),
      visualContainer: LCe
    };
    return i;
  }
  _overlayShownActionHandler(e) {
    this._actions.onShown(e);
  }
  _overlayHidingActionHandler(e) {
    this._actions.onHiding(e), e.cancel || (this._hideAllShownSubmenus(), this._setOptionWithoutOptionChange("visible", !1));
  }
  _overlayHiddenActionHandler(e) {
    this._actions.onHidden(e);
  }
  _shouldHideOnOutsideClick(e) {
    var {
      closeOnOutsideClick: i,
      hideOnOutsideClick: r
    } = this.option();
    return Le(r) ? r(e) : Le(i) ? i(e) : r || i;
  }
  _hideOnOutsideClickHandler(e) {
    if (!this._shouldHideOnOutsideClick(e))
      return !1;
    if (de.isDocument(e.target))
      return !0;
    var i = this._getActiveItemsContainer(e.target), r = this._getItemsContainers(), n = this._searchActiveItem(e.target), a = this.$element().parents(".".concat(mx)), o = n[0] === a[0] && n.length && a.length, u = this._isIncludeOverlay(i, r) && n.length;
    return u || o ? (this._getShowSubmenuMode() === "onClick" && this._hideAllShownChildSubmenus(n), !1) : !0;
  }
  _getActiveItemsContainer(e) {
    return E(e).closest(".".concat(ew));
  }
  _getItemsContainers() {
    return this._overlay.$content().find(".".concat(ew));
  }
  _searchActiveItem(e) {
    return E(e).closest(".".concat(mx)).eq(0);
  }
  _isIncludeOverlay(e, i) {
    var r = !1;
    return N(i, (n, a) => {
      e.is(a) && !r && (r = !0);
    }), r;
  }
  _hideAllShownChildSubmenus(e) {
    var i = e.find(".".concat(Bo)), r = P([], this._shownSubmenus);
    i.length > 0 && N(r, (n, a) => {
      var o = this._searchActiveItem(a.context).parent();
      o.parent().is(e.parent().parent()) && !o.is(e.parent()) && this._hideSubmenu(a);
    });
  }
  _showSubmenu(e) {
    var i = this._dataAdapter.getNodeByItem(this._getItemData(e));
    if (this._hideSubmenusOnSameLevel(e), !!this._hasSubmenu(i)) {
      var r = e.children(".".concat(Bo)), n = r.length;
      super._showSubmenu(e), n || this._renderSubmenuItems(i, e), this._isSubmenuVisible(r) || this._drawSubmenu(e);
    }
  }
  _hideSubmenusOnSameLevel(e) {
    var i = e.parent(".".concat(wG)).siblings().find(".".concat(Qg));
    i.length && (i.removeClass(Qg), this._hideSubmenu(i.find(".".concat(Bo))));
  }
  _hideSubmenuGroup(e) {
    this._isSubmenuVisible(e) && this._hideSubmenuCore(e);
  }
  _isSubmenuVisible(e) {
    return e.css("visibility") === "visible";
  }
  _drawSubmenu(e) {
    var i = this.option("animation") ? this.option("animation").show : {}, r = e.children(".".concat(Bo)), n = this._getSubmenuPosition(e);
    this._overlay && this._overlay.option("visible") && (R(this._shownSubmenus) || (this._shownSubmenus = []), this._shownSubmenus.includes(r) || this._shownSubmenus.push(r), i && ji.stop(r), kl.setup(r, n), i && ($t(i.to) && (i.to.position = n), this._animate(r, i)), r.css("visibility", "visible"));
  }
  _animate(e, i) {
    ji.animate(e, i);
  }
  _getSubmenuPosition(e) {
    var i = this.option("submenuDirection").toLowerCase(), r = e.parent(".".concat(wG)), n = {
      collision: "flip",
      of: r,
      offset: {
        h: 0,
        v: -1
      }
    };
    switch (i) {
      case "left":
        n.at = "left top", n.my = "right top";
        break;
      case "right":
        n.at = "right top", n.my = "left top";
        break;
      default:
        this.option("rtlEnabled") ? (n.at = "left top", n.my = "right top") : (n.at = "right top", n.my = "left top");
    }
    return n;
  }
  _updateSubmenuVisibilityOnClick(e) {
    if (e.args.length) {
      var i = e.args[0].itemData, r = this._dataAdapter.getNodeByItem(i);
      if (r) {
        var n = E(e.args[0].itemElement), a = n.find(".".concat(Bo)), o = this._hasSubmenu(r) && !a.length;
        if (o && (this._renderSubmenuItems(r, n), a = n.find(".".concat(Bo))), !(n.context === a.context && a.css("visibility") === "visible")) {
          this._updateSelectedItemOnClick(e);
          var u = i && i.closeMenuOnClick === !1;
          if (!(!i || i.disabled || u))
            if (a.length === 0) {
              var c = E(n.parents(".".concat(Bo))[0]);
              this._hideSubmenu(c), !e.canceled && this._overlay && this._overlay.option("visible") && this.option("visible", !1);
            } else
              this._shownSubmenus && this._shownSubmenus.length > 0 && this._shownSubmenus[0].is(a) && this._hideSubmenu(a), this._showSubmenu(n);
        }
      }
    }
  }
  _hideSubmenu(e) {
    var i = P([], this._shownSubmenus);
    N(i, (r, n) => {
      (e.is(n) || Kd(e[0], n[0])) && (n.parent().removeClass(Qg), this._hideSubmenuCore(n));
    });
  }
  _hideSubmenuCore(e) {
    var i = this._shownSubmenus.indexOf(e), r = this.option("animation") ? this.option("animation").hide : null;
    i >= 0 && this._shownSubmenus.splice(i, 1), this._stopAnimate(e), r && this._animate(e, r), e.css("visibility", "hidden");
  }
  _stopAnimate(e) {
    ji.stop(e, !0);
  }
  _hideAllShownSubmenus() {
    var e = P([], this._shownSubmenus), i = this._overlay.$content().find(".".concat(Qg));
    i.removeClass(Qg), N(e, (r, n) => {
      this._hideSubmenu(n);
    });
  }
  _visibilityChanged(e) {
    e && this._renderContentImpl();
  }
  _optionChanged(e) {
    if (IG.includes(e.name)) {
      this._initActions();
      return;
    }
    switch (e.name) {
      case "visible":
        this._renderVisibility(e.value);
        break;
      case "showEvent":
      case "position":
      case "submenuDirection":
        this._invalidate();
        break;
      case "target":
        e.previousValue && this._detachShowContextMenuEvents(e.previousValue), this._invalidate();
        break;
      case "closeOnOutsideClick":
      case "hideOnOutsideClick":
        break;
      default:
        super._optionChanged(e);
    }
  }
  _renderVisibility(e) {
    return e ? this._show() : this._hide();
  }
  _toggleVisibility() {
  }
  _show(e) {
    var i = {
      jQEvent: e
    }, r = new q().reject().promise();
    if (this._actions.onShowing(i), i.cancel)
      return r;
    var n = this._positionContextMenu(e);
    if (n) {
      var a;
      this._overlay || (this._renderContextMenuOverlay(), this._overlay.$content().addClass(this._widgetClass()), this._renderFocusState(), this._attachHoverEvents(), this._attachClickEvent(), this._renderItems(this._dataAdapter.getRootNodes())), this._setOptionWithoutOptionChange("visible", !0), this._overlay.option("position", n), r = this._overlay.show(), e && e.stopPropagation(), this._setAriaAttributes(), (e == null || (a = e.originalEvent) === null || a === void 0 ? void 0 : a.type) === Lh.name && this.preventShowingDefaultContextMenuAboveOverlay();
    }
    return r;
  }
  _setAriaAttributes() {
    this._overlayContentId = "dx-".concat(new yr()), this.setAria("owns", this._overlayContentId), this.setAria({
      id: this._overlayContentId,
      role: "menu"
    }, this._overlay.$content());
  }
  _cleanAriaAttributes() {
    this._overlay && this.setAria("id", null, this._overlay.$content()), this.setAria("owns", void 0);
  }
  _getTarget() {
    return this.option("target") || this.option("position").of || E(de.getDocument());
  }
  _getContextMenuPosition() {
    return P({}, this.option("position"), {
      of: this._getTarget()
    });
  }
  _positionContextMenu(e) {
    var i = this._getContextMenuPosition(), r = this._isInitialOptionValue("position"), n = this._createActionByOption("onPositioning");
    e && e.preventDefault && r && (i.of = e);
    var a = {
      position: i,
      event: e
    };
    return n(a), a.cancel ? i = null : a.event && (a.event.cancel = !0, e.preventDefault()), i;
  }
  _refresh() {
    if (!wt())
      super._refresh();
    else if (this._overlay) {
      var e = this._overlay.option("position");
      super._refresh(), this._overlay && this._overlay.option("position", e);
    } else
      super._refresh();
  }
  _hide() {
    var e;
    return this._overlay && (e = this._overlay.hide(), this._setOptionWithoutOptionChange("visible", !1)), this._cleanAriaAttributes(), this.option("focusedElement", null), e || new q().reject().promise();
  }
  toggle(e) {
    var i = this.option("visible");
    return e = e === void 0 ? !i : e, this._renderVisibility(e);
  }
  show() {
    return this.toggle(!0);
  }
  hide() {
    return this.toggle(!1);
  }
}
ti("dxContextMenu", RB);
var MCe = "dx-context-menu", kCe = {
  columnHeadersView: "header",
  rowsView: "content",
  footerView: "footer",
  headerPanel: "headerPanel"
}, PCe = ["columnHeadersView", "rowsView", "footerView", "headerPanel"];
class FCe extends Bi.ViewController {
  init() {
    this.createAction("onContextMenuPreparing");
  }
  getContextMenuItems(e) {
    if (!e)
      return !1;
    var i = this, r = E(e.target), n, a, o, u;
    return N(PCe, function() {
      var c, p, v = i.getView(this);
      if (n = v && v.element(), n && (n.is(r) || n.find(r).length)) {
        o = r.closest(".dx-row > td, .dx-row > tr"), a = o.parent();
        var _ = v.getRowIndex(a), y = o[0] && o[0].cellIndex, b = a.data("options"), I = {
          event: e,
          targetElement: ot(r),
          target: kCe[this],
          rowIndex: _,
          row: v._getRows()[_],
          columnIndex: y,
          column: (p = (c = b == null ? void 0 : b.cells) === null || c === void 0 ? void 0 : c[y]) === null || p === void 0 ? void 0 : p.column
        };
        if (I.items = v.getContextMenuItems && v.getContextMenuItems(I), i.executeAction("onContextMenuPreparing", I), i._contextMenuPrepared(I), u = I.items, u)
          return !1;
      }
    }), u;
  }
  _contextMenuPrepared(e) {
  }
}
class BCe extends Bi.View {
  init() {
    super.init(), this._contextMenuController = this.getController("contextMenu");
  }
  _renderCore() {
    var e = this.element().addClass(MCe);
    this.setAria("role", "presentation", e), this._createComponent(e, RB, {
      onPositioning: (i) => {
        var {
          event: r
        } = i, n = i.component, a = this._contextMenuController.getContextMenuItems(r);
        a ? (n.option("items", a), r.stopPropagation()) : i.cancel = !0;
      },
      onItemClick(i) {
        var r, n;
        (n = (r = i.itemData) === null || r === void 0 ? void 0 : r.onItemClick) === null || n === void 0 || n.call(r, i);
      },
      cssClass: this.getWidgetContainerClass(),
      target: this.component.$element()
    });
  }
}
var VCe = {
  defaultOptions: () => ({
    onContextMenuPreparing: null
  }),
  controllers: {
    contextMenu: FCe
  },
  views: {
    contextMenuView: BCe
  }
};
et.registerModule("contextMenu", VCe);
var wy = "dx-error-row", AG = "dx-error-message", NCe = "dx-closebutton", HCe = "action";
class $Ce extends Bi.ViewController {
  init() {
    this._resizingController = this.getController("resizing"), this._columnsController = this.getController("columns"), this._columnHeadersView = this.getView("columnHeadersView"), this._rowsView = this.getView("rowsView");
  }
  _createErrorRow(e, i) {
    var r, n, a = this._renderErrorMessage(e);
    return i ? (r = E("<tr>").attr("role", "row").addClass(wy), n = E("<div>").addClass(NCe).addClass(this.addWidgetPrefix(HCe)), k.on(n, di, this.createAction((o) => {
      var u, c, p = o.event, v, _ = E(p.currentTarget).closest(".".concat(wy)).index();
      p.stopPropagation(), N(i, (y, b) => {
        v = E(b).children("tbody").children("tr").eq(_), this.removeErrorRow(v);
      }), (c = (u = this._resizingController) === null || u === void 0 ? void 0 : u.fireContentReadyAction) === null || c === void 0 || c.call(u);
    })), E("<td>").attr({
      colSpan: this._columnsController.getVisibleColumns().length,
      role: "gridcell"
    }).prepend(n).append(a).appendTo(r), r) : a;
  }
  _renderErrorMessage(e) {
    var i = e.url ? e.message.replace(e.url, "") : e.message || e, r = E("<div>").attr("role", "alert").attr("aria-roledescription", X.format("dxDataGrid-ariaError")).addClass(AG).text(i);
    return e.url && E("<a>").attr("href", e.url).text(e.url).appendTo(r), r;
  }
  renderErrorRow(e, i, r) {
    var n, a, o = this, u, c;
    if (r)
      return r.find(".".concat(AG)).remove(), u = o._createErrorRow(e), r.prepend(u), u;
    var p = i >= 0 || !o._columnHeadersView.isVisible() ? o._rowsView : o._columnHeadersView, v = p.getTableElements();
    return N(v, (_, y) => {
      if (u = o._createErrorRow(e, v), c = c || u, i >= 0) {
        var b = p._getRowElements(E(y)).eq(i);
        o.removeErrorRow(b.next()), u.insertAfter(b);
      } else {
        var I = E(y).children("tbody"), A = I.children("tr");
        o._columnHeadersView.isVisible() ? (o.removeErrorRow(A.last()), E(y).append(u)) : (o.removeErrorRow(A.first()), I.first().prepend(u));
      }
    }), (a = (n = this._resizingController) === null || n === void 0 ? void 0 : n.fireContentReadyAction) === null || a === void 0 || a.call(n), c;
  }
  removeErrorRow(e) {
    if (!e) {
      var i = this._columnHeadersView && this._columnHeadersView.element();
      if (e = i && i.find(".".concat(wy)), !e || !e.length) {
        var r = this._rowsView.element();
        e = r && r.find(".".concat(wy));
      }
    }
    e && e.hasClass(wy) && e.remove();
  }
  optionChanged(e) {
    switch (e.name) {
      case "errorRowEnabled":
        e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
}
var zCe = (t) => class extends t {
  init() {
    super.init(), this.dataErrorOccurred.add((e, i) => {
      this.option("errorRowEnabled") && this._errorHandlingController.renderErrorRow(e, void 0, i);
    }), this.changed.add((e) => {
      var i, r;
      e && e.changeType === "loadError" || this._editingController && !this._editingController.hasChanges() && ((r = (i = this._errorHandlingController) === null || i === void 0 ? void 0 : i.removeErrorRow) === null || r === void 0 || r.call(i));
    });
  }
}, WCe = {
  defaultOptions: () => ({
    errorRowEnabled: !0
  }),
  controllers: {
    errorHandling: $Ce
  },
  extenders: {
    controllers: {
      data: zCe
    }
  }
};
et.registerModule("errorHandling", WCe);
var OG = "borders", UCe = "table-fixed", GCe = "important-margin", Q5 = "dx-gridbase-container", KCe = "tr.dx-group-row", tw = "adaptiveHidden", LB = ["columnsSeparatorView", "blockSeparatorView", "trackerView", "headerPanel", "columnHeadersView", "rowsView", "footerView", "columnChooserView", "filterPanelView", "pagerView", "draggingHeaderView", "contextMenuView", "errorView", "headerFilterView", "filterBuilderView"], Ty = function(t) {
  return ht(t) && t.endsWith("%");
}, jCe = function(t) {
  return ht(t) && t.endsWith("px");
}, Z5 = function(t, e) {
  var i = t._rowsView.contentWidth(), r = t._getTotalWidth(e, i);
  return i - r;
}, YCe = function(t, e, i, r) {
  return Z5(t, r.map((n, a) => a === e ? i : n));
}, qCe = function(t, e) {
  Jde(t, !0), xe.setSelectionRange(t, e);
};
class XCe extends Bi.ViewController {
  init() {
    this._prevContentMinHeight = null, this._dataController = this.getController("data"), this._columnsController = this.getController("columns"), this._columnHeadersView = this.getView("columnHeadersView"), this._adaptiveColumnsController = this.getController("adaptiveColumns"), this._editorFactoryController = this.getController("editorFactory"), this._footerView = this.getView("footerView"), this._rowsView = this.getView("rowsView");
  }
  _initPostRenderHandlers() {
    this._refreshSizesHandler || (this._refreshSizesHandler = (e) => {
      var i = new q().resolve(null), r = e == null ? void 0 : e.changeType, n = e == null ? void 0 : e.isDelayed, a = r && r !== "updateSelection" && r !== "updateFocusedRow" && r !== "pageIndex" && !n;
      this._dataController.changed.remove(this._refreshSizesHandler), this._checkSize() && (i = this._refreshSizes(e)), a && $e(i).done(() => {
        this._setAriaLabel(), this.fireContentReadyAction();
      });
    }, this._dataController.changed.add(() => {
      this._dataController.changed.add(this._refreshSizesHandler);
    }));
  }
  _refreshSizes(e) {
    var i, r = new q().resolve(null), n = e == null ? void 0 : e.changeType, a = e == null ? void 0 : e.isDelayed, o = this._dataController.items();
    if (!e || n === "refresh" || n === "prepend" || n === "append")
      a || (r = this.resize());
    else if (n === "update") {
      if (((i = e.changeTypes) === null || i === void 0 ? void 0 : i.length) === 0)
        return r;
      (o.length > 1 || e.changeTypes[0] !== "insert") && !(o.length === 0 && e.changeTypes[0] === "remove") && !e.needUpdateDimensions ? (r = new q(), this._waitAsyncTemplates().done(() => {
        Na(() => dn(() => Na(() => {
          this._setScrollerSpacing(), this._rowsView.resize(), r.resolve();
        })));
      }).fail(r.reject)) : r = this.resize();
    }
    return r;
  }
  fireContentReadyAction() {
    this.component._fireContentReadyAction();
  }
  _getWidgetAriaLabel() {
    return "dxDataGrid-ariaDataGrid";
  }
  _setAriaLabel() {
    var e = Math.max(0, this._dataController.totalItemsCount());
    this.component.setAria("label", X.format(this._getWidgetAriaLabel(), e, this.component.columnCount()), this.component.$element().children(".".concat(Q5)));
  }
  _getBestFitWidths() {
    var e, i = this._rowsView, r = this._columnHeadersView, n = i.getColumnWidths();
    if (!(n != null && n.length)) {
      var a = r.getTableElement();
      r.setTableElement((e = i.getTableElement()) === null || e === void 0 ? void 0 : e.children(".dx-header")), n = r.getColumnWidths(), r.setTableElement(a);
    }
    return n;
  }
  _setVisibleWidths(e, i) {
    var r = this._columnsController;
    r.beginUpdate(), N(e, (n, a) => {
      var o = r.getColumnId(a);
      r.columnOption(o, "visibleWidth", i[n]);
    }), r.endUpdate();
  }
  _toggleBestFitModeForView(e, i, r) {
    if (!(!e || !e.isVisible())) {
      var n = this._rowsView.getTableElements(), a = e.getTableElements();
      N(n, (o, u) => {
        var c, p = E(u), v = a.eq(o);
        v && v.length && (r ? c = v.children("tbody").appendTo(p) : c = p.children(".".concat(i)).appendTo(v), c.toggleClass(i, r), c.toggleClass(this.addWidgetPrefix("best-fit"), r));
      });
    }
  }
  _toggleBestFitMode(e) {
    var i = this._rowsView.getTableElement(), r = this._rowsView.getTableElements().eq(1);
    i && (i.css("tableLayout", e ? "auto" : "fixed"), i.children("colgroup").css("display", e ? "none" : ""), N(r.find(KCe), (n, a) => {
      E(a).css("display", e ? "none" : "");
    }), r.toggleClass(this.addWidgetPrefix(UCe), !e), this._toggleBestFitModeForView(this._columnHeadersView, "dx-header", e), this._toggleBestFitModeForView(this._footerView, "dx-footer", e), this._needStretch() && (i.get(0).style.width = e ? "auto" : ""));
  }
  _toggleContentMinHeight(e) {
    var i = this._rowsView.getScrollable(), r = this._rowsView._findContentElement();
    (i == null ? void 0 : i.option("useNative")) === !1 && (e === !0 && (this._prevContentMinHeight = r.get(0).style.minHeight), R(this._prevContentMinHeight) && r.css({
      minHeight: e ? xe.getContentHeightLimit($i) : this._prevContentMinHeight
    }));
  }
  _synchronizeColumns() {
    var e = this._columnsController, i = e.getVisibleColumns(), r = this.option("columnAutoWidth"), n = this.option("wordWrapEnabled"), a = i.some((I) => !R(I.width)), o = this._needBestFit(), u = !1, c, p = !1, v = [], _, y;
    !o && N(i, (I, A) => {
      if (A.width === "auto")
        return o = !0, !1;
    }), N(i, (I, A) => {
      if (A.minWidth)
        return u = !0, !1;
    }), this._setVisibleWidths(i, []);
    var b = this.component.$element();
    o && (_ = de.getActiveElement(b.get(0)), y = xe.getSelectionRange(_), this._toggleBestFitMode(!0), c = !0), this._toggleContentMinHeight(n), b && b.get(0) && this._maxWidth && (delete this._maxWidth, b[0].style.maxWidth = ""), Na(() => {
      if (o ? (v = this._getBestFitWidths(), N(i, (A, L) => {
        var B = e.getColumnId(L);
        e.columnOption(B, "bestFitWidth", v[A], !0);
      })) : u && (v = this._getBestFitWidths()), N(i, function(A) {
        var {
          width: L
        } = this;
        L !== "auto" && (R(L) ? v[A] = Di(L) || jCe(L) ? parseFloat(L) : L : r || (v[A] = void 0));
      }), c && (this._toggleBestFitMode(!1), c = !1, _ && _ !== de.getActiveElement())) {
        var I = zr(_).bottom < 0;
        I || qCe(_, y);
      }
      p = this._correctColumnWidths(v, i), r && (function() {
        var A;
        N(i, (L, B) => {
          B.type === "groupExpand" && (A = v[L]);
        }), N(i, (L, B) => {
          B.type === "groupExpand" && A && (v[L] = A);
        });
      }(), this._needStretch() && this._processStretch(v, i)), dn(() => {
        (o || p || a) && this._setVisibleWidths(i, v), n && this._toggleContentMinHeight(!1);
      });
    });
  }
  _needBestFit() {
    return this.option("columnAutoWidth");
  }
  _needStretch() {
    return this._columnsController.getVisibleColumns().some((e) => e.width === "auto" && !e.command);
  }
  _getAverageColumnsWidth(e) {
    var i = Z5(this, e), r = e.filter((n) => n === void 0).length;
    return i / r;
  }
  _correctColumnWidths(e, i) {
    var r = this, n, a = !1, o = !1, u = !1, c = r.component.$element(), p = r._hasWidth, v = function() {
      var B = n, $ = i[B], K = e[B] === tw, te = e[B], {
        minWidth: z
      } = $;
      if (z) {
        if (te === void 0) {
          var ie = r._getAverageColumnsWidth(e);
          te = ie;
        } else if (Ty(te)) {
          var pe = YCe(r, B, z, e);
          pe < 0 && (te = -1);
        }
      }
      var _e = r._getRealColumnWidth(B, e.map((be, De) => B === De ? te : be));
      z && !K && _e < z && (e[B] = z, u = !0, n = -1), R($.width) || (o = !0), Ty($.width) && (a = !0);
    };
    for (n = 0; n < i.length; n++)
      v();
    if (!o && e.length) {
      var _ = r._rowsView.element(), y = r._rowsView.contentWidth(), b = r._rowsView.getScrollbarWidth(), I = r._getTotalWidth(e, y);
      if (I < y) {
        var A = xe.getLastResizableColumnIndex(i, e);
        if (A >= 0 && (e[A] = "auto", u = !0, p === !1 && !a)) {
          var L = r.option("showBorders") ? Math.ceil(oi(_) - Sk(_)) : 0;
          r._maxWidth = I + b + L, c.css("maxWidth", r._maxWidth);
        }
      }
    }
    return u;
  }
  _processStretch(e, i) {
    var r = this._rowsView.contentWidth(), n = this._getTotalWidth(e, r), a = {
      length: 0
    };
    if (e.length) {
      N(i, function(v) {
        (this.width || e[v] === tw) && (a[v] = !0, a.length++);
      });
      var o = r - n, u = Math.floor(o / (e.length - a.length)), c = o - u * (e.length - a.length);
      if (o >= 0)
        for (var p = 0; p < e.length; p++)
          a[p] || (e[p] += u, c > 0 && (c < 1 ? (e[p] += c, c = 0) : (e[p]++, c--)));
    }
  }
  _getRealColumnWidth(e, i, r) {
    var n = 1, a = i[e];
    if (!Ty(a))
      return parseFloat(a);
    var o = i.reduce((v, _, y) => Ty(_) ? v + parseFloat(_) : v, 0), u = i.reduce((v, _) => !_ || _ === tw || Ty(_) ? v : v + parseFloat(_), 0);
    r = r || this._rowsView.contentWidth();
    var c = r - u, p = o * r / 100;
    return u > 0 && p + u >= r && (n = p > c ? c / p : 1), parseFloat(a) * r * n / 100;
  }
  _getTotalWidth(e, i) {
    for (var r = 0, n = 0; n < e.length; n++) {
      var a = e[n];
      a && a !== tw && (r += this._getRealColumnWidth(n, e, i));
    }
    return Math.ceil(r);
  }
  _getGroupElement() {
    return this.component.$element().children().get(0);
  }
  updateSize(e) {
    var i = E(e), r = this.addWidgetPrefix(GCe);
    if (this._hasHeight === void 0 && i && i.is(":visible") && mt(i)) {
      var n = i.children(".".concat(this.getWidgetContainerClass()));
      n.length && n.detach(), this._hasHeight = !!Pt(i);
      var a = mt(i);
      i.addClass(r), this._hasWidth = mt(i) === a, i.removeClass(r), n.length && n.appendTo(i);
    }
  }
  publicMethods() {
    return ["resize", "updateDimensions"];
  }
  _waitAsyncTemplates() {
    var e, i, r;
    return $e((e = this._columnHeadersView) === null || e === void 0 ? void 0 : e.waitAsyncTemplates(!0), (i = this._rowsView) === null || i === void 0 ? void 0 : i.waitAsyncTemplates(!0), (r = this._footerView) === null || r === void 0 ? void 0 : r.waitAsyncTemplates(!0));
  }
  resize() {
    if (!this.component._requireResize) {
      var e = new q();
      return this._waitAsyncTemplates().done(() => {
        $e(this.updateDimensions()).done(e.resolve).fail(e.reject);
      }).fail(e.reject), e.promise();
    }
  }
  updateDimensions(e) {
    var i = this;
    if (i._initPostRenderHandlers(), !!i._checkSize(e)) {
      var r = i._resizeDeferred, n = i._resizeDeferred = new q();
      return $e(r).always(() => {
        dn(() => {
          i._dataController.isLoaded() && i._synchronizeColumns(), i._resetGroupElementHeight(), Na(() => {
            dn(() => {
              Na(() => {
                i._updateDimensionsCore();
              });
            });
          });
        }).done(n.resolve).fail(n.reject);
      }), n.promise();
    }
  }
  _resetGroupElementHeight() {
    var e = this._getGroupElement(), i = this._rowsView.getScrollable();
    e && e.style.height && (!i || !i.scrollTop()) && (e.style.height = "");
  }
  _checkSize(e) {
    var i = this.component.$element(), r = i.is(":visible"), n = this._lastWidth !== mt(i) || this._lastHeight !== Pt(i) || this._devicePixelRatio !== Ot().devicePixelRatio;
    return r && (!e || n);
  }
  _setScrollerSpacingCore() {
    var e = this, i = e._rowsView.getScrollbarWidth(), r = e._rowsView.getScrollbarWidth(!0);
    dn(() => {
      e._columnHeadersView && e._columnHeadersView.setScrollerSpacing(i), e._footerView && e._footerView.setScrollerSpacing(i), e._rowsView.setScrollerSpacing(i, r);
    });
  }
  _setScrollerSpacing() {
    var e = this._rowsView.getScrollable(), i = this.option("scrolling.useNative") === !0;
    !e || i ? dn(() => {
      Na(() => {
        this._setScrollerSpacingCore();
      });
    }) : this._setScrollerSpacingCore();
  }
  _setAriaOwns() {
    var e, i, r, n = (e = this._columnHeadersView) === null || e === void 0 ? void 0 : e.getTableElement(), a = (i = this._footerView) === null || i === void 0 ? void 0 : i.getTableElement();
    (r = this._rowsView) === null || r === void 0 || r.setAriaOwns(n == null ? void 0 : n.attr("id"), a == null ? void 0 : a.attr("id"));
  }
  _updateDimensionsCore() {
    var e, i = this, r = i._dataController, n = i._rowsView, a = i.component.$element(), o = this._getGroupElement(), u = Pt(a), c = (e = i.option("height")) !== null && e !== void 0 ? e : a.get(0).style.height, p = !!c && c !== "auto", v = parseInt(a.css("maxHeight")), _ = v && u >= v, y = o && o.scrollHeight === o.offsetHeight;
    i.updateSize(a), dn(() => {
      var b = i._hasHeight || !!v || p;
      if (n.hasHeight(b), this._setAriaOwns(), _ && !y && E(o).css("height", v), !r.isLoaded()) {
        n.setLoading(r.isLoading());
        return;
      }
      Na(() => {
        i._updateLastSizes(a), i._setScrollerSpacing(), N(LB, (I, A) => {
          var L = i.getView(A);
          L && L.resize();
        }), this._editorFactoryController && this._editorFactoryController.resize();
      });
    });
  }
  _updateLastSizes(e) {
    this._lastWidth = mt(e), this._lastHeight = Pt(e), this._devicePixelRatio = Ot().devicePixelRatio;
  }
  optionChanged(e) {
    switch (e.name) {
      case "width":
      case "height":
        this.component._renderDimensions(), this.resize();
      case "renderAsync":
        e.handled = !0;
        return;
      default:
        super.optionChanged(e);
    }
  }
}
class QCe extends Bi.ViewController {
  _scrollChangedHandler(e, i, r) {
    for (var n = 0; n < e.length; n++)
      e[n] && e[n].name !== r && e[n].scrollTo({
        left: i.left,
        top: i.top
      });
  }
  init() {
    for (var e = [this.getView("columnHeadersView"), this.getView("footerView"), this.getView("rowsView")], i = 0; i < e.length; i++) {
      var r = e[i];
      r && r.scrollChanged.add(this._scrollChangedHandler.bind(this, e));
    }
  }
}
class ZCe extends Bi.View {
  _endUpdateCore() {
    this.component._requireResize && (this.component._requireResize = !1, this._resizingController.resize());
  }
  init() {
    this._resizingController = this.getController("resizing"), this._dataController = this.getController("data");
  }
  getView(e) {
    return this.component._views[e];
  }
  element() {
    return this._groupElement;
  }
  optionChanged(e) {
    R(this._groupElement) && e.name === "showBorders" ? (this._groupElement.toggleClass(this.addWidgetPrefix(OG), !!e.value), e.handled = !0) : super.optionChanged(e);
  }
  _renderViews(e) {
    var i = this;
    N(LB, (r, n) => {
      var a = i.getView(n);
      a && a.render(e);
    });
  }
  _getTableRoleName() {
    return "group";
  }
  render(e) {
    var i = !this._groupElement, r = this._groupElement || E("<div>").addClass(this.getWidgetContainerClass());
    r.addClass(Q5), r.toggleClass(this.addWidgetPrefix(OG), !!this.option("showBorders")), this.setAria("role", "presentation", e), this.component.setAria("role", this._getTableRoleName(), r), this._rootElement = e || this._rootElement, i && (this._groupElement = r, wt() && this._resizingController.updateSize(e), r.appendTo(e)), this._renderViews(r);
  }
  update() {
    var e = this._rootElement, i = this._groupElement;
    e && i && (this._resizingController.resize(), this._dataController.isLoaded() && this._resizingController.fireContentReadyAction());
  }
}
var JCe = {
  defaultOptions: () => ({
    showBorders: !1,
    renderAsync: !1
  }),
  controllers: {
    resizing: XCe,
    synchronizeScrolling: QCe
  },
  views: {
    gridView: ZCe
  },
  VIEW_NAMES: LB
};
et.registerModule("gridView", JCe);
var eye = Kp.inherit({
  _initMarkup() {
    this._deferredItems = [], this.callBase();
  },
  _renderItemContent(t) {
    var e = new q(), i = new q();
    this._deferredItems[t.index] = i;
    var r = this.callBase.call(this, t);
    return i.done(() => {
      e.resolve(r);
    }), e.promise();
  },
  _onItemTemplateRendered: function(t, e) {
    return () => {
      this._deferredItems[e.index].resolve();
    };
  },
  _postProcessRenderItems: ee,
  _renderItemsAsync() {
    var t = new q();
    return $e.apply(this, this._deferredItems).done(() => {
      this._postProcessRenderItems(), t.resolve();
    }), t.promise();
  },
  _clean() {
    this.callBase(), this._deferredItems = [];
  }
}), J5 = "dx-toolbar", KL = "dx-toolbar-before", tye = "dx-toolbar-center", RG = "dx-toolbar-after", iye = "dx-toolbar-mini", rye = "dx-toolbar-item", Iy = "dx-toolbar-label", nye = "dx-toolbar-button", aye = "dx-toolbar-items-container", oye = "dx-toolbar-group", LG = "dx-toolbar-compact", MG = "text", sye = "default", lye = "contained", uye = "dxToolbarItemDataKey", dye = 15;
class eX extends eye {
  _getSynchronizableOptionsForCreateComponent() {
    return super._getSynchronizableOptionsForCreateComponent().filter((e) => e !== "disabled");
  }
  _initTemplates() {
    super._initTemplates();
    var e = new Gp((function(i, r, n) {
      if ($t(r)) {
        var {
          text: a,
          html: o,
          widget: u
        } = r;
        if (a && i.text(a).wrapInner("<div>"), o && i.html(o), u === "dxDropDownButton") {
          var c;
          r.options = (c = r.options) !== null && c !== void 0 ? c : {}, R(r.options.stylingMode) || (r.options.stylingMode = this.option("useFlatButtons") ? MG : lye);
        }
        if (u === "dxButton") {
          if (this.option("useFlatButtons")) {
            var p, v;
            r.options = (p = r.options) !== null && p !== void 0 ? p : {}, r.options.stylingMode = (v = r.options.stylingMode) !== null && v !== void 0 ? v : MG;
          }
          if (this.option("useDefaultButtons")) {
            var _, y;
            r.options = (_ = r.options) !== null && _ !== void 0 ? _ : {}, r.options.type = (y = r.options.type) !== null && y !== void 0 ? y : sye;
          }
        }
      } else
        i.text(String(r));
      this._getTemplate("dx-polymorph-widget").render({
        container: i,
        model: n,
        parent: this
      });
    }).bind(this), ["text", "html", "widget", "options"], this.option("integrationOptions.watchMethod"));
    this._templateManager.addDefaultTemplates({
      item: e,
      menuItem: e
    });
  }
  _getDefaultOptions() {
    return P(super._getDefaultOptions(), {
      renderAs: "topToolbar",
      grouped: !1,
      useFlatButtons: !1,
      useDefaultButtons: !1
    });
  }
  _defaultOptionsRules() {
    return super._defaultOptionsRules().concat([{
      device: function() {
        return fs();
      },
      options: {
        useFlatButtons: !0
      }
    }]);
  }
  _itemContainer() {
    return this._$toolbarItemsContainer.find([".".concat(KL), ".".concat(tye), ".".concat(RG)].join(","));
  }
  _itemClass() {
    return rye;
  }
  _itemDataKey() {
    return uye;
  }
  _dimensionChanged() {
    this._disposed || (this._arrangeItems(), this._applyCompactMode());
  }
  _initMarkup() {
    this._renderToolbar(), this._renderSections(), super._initMarkup();
  }
  _render() {
    super._render(), this._renderItemsAsync(), this._updateDimensionsInMaterial();
  }
  _postProcessRenderItems() {
    this._arrangeItems();
  }
  _renderToolbar() {
    this.$element().addClass(J5), this._$toolbarItemsContainer = E("<div>").addClass(aye).appendTo(this.$element()), this.setAria("role", "toolbar");
  }
  _renderSections() {
    var e = this._$toolbarItemsContainer;
    N(["before", "center", "after"], (i, r) => {
      var n = "dx-toolbar-".concat(r), a = e.find(".".concat(n));
      a.length || (this["_$".concat(r, "Section")] = E("<div>").addClass(n).attr("role", "presentation").appendTo(e));
    });
  }
  _arrangeItems(e) {
    var i;
    e = (i = e) !== null && i !== void 0 ? i : mt(this.$element()), this._$centerSection.css({
      margin: "0 auto",
      float: "none"
    });
    var r = zr(this._$beforeSection.get(0)), n = zr(this._$afterSection.get(0));
    this._alignCenterSection(r, n, e);
    var a = this._$toolbarItemsContainer.find(".".concat(Iy)).eq(0), o = a.parent();
    if (a.length) {
      var u = r.width ? r.width : a.position().left, c = o.hasClass(KL) ? 0 : u, p = o.hasClass(RG) ? 0 : n.width, v = 0;
      o.children().not(".".concat(Iy)).each(function() {
        v += oi(this);
      });
      var _ = e - v, y = Math.max(_ - c - p, 0);
      if (o.hasClass(KL))
        this._alignSection(this._$beforeSection, y);
      else {
        var b = oi(a) - mt(a);
        a.css("maxWidth", y - b);
      }
    }
  }
  _alignCenterSection(e, i, r) {
    this._alignSection(this._$centerSection, r - e.width - i.width);
    var n = this.option("rtlEnabled"), a = n ? i : e, o = n ? e : i, u = zr(this._$centerSection.get(0));
    (a.right > u.left || u.right > o.left) && this._$centerSection.css({
      marginLeft: a.width,
      marginRight: o.width,
      float: a.width > o.width ? "none" : "right"
    });
  }
  _alignSection(e, i) {
    var r = e.find(".".concat(Iy)), n = r.toArray();
    i -= this._getCurrentLabelsPaddings(n);
    var a = this._getCurrentLabelsWidth(n), o = Math.abs(a - i);
    i < a ? (n = n.reverse(), this._alignSectionLabels(n, o, !1)) : this._alignSectionLabels(n, o, !0);
  }
  _alignSectionLabels(e, i, r) {
    for (var n = function(v) {
      return zr(v).width;
    }, a = 0; a < e.length; a++) {
      var o = E(e[a]), u = Math.ceil(n(e[a])), c = void 0;
      r && o.css("maxWidth", "inherit");
      var p = Math.ceil(r ? n(e[a]) : u);
      if (p < i)
        c = r ? p : 0, i -= p;
      else {
        c = r ? u + i : u - i, o.css("maxWidth", c);
        break;
      }
      o.css("maxWidth", c);
    }
  }
  _applyCompactMode() {
    var e = this.$element();
    e.removeClass(LG), this.option("compactMode") && this._getSummaryItemsSize("width", this.itemElements(), !0) > mt(e) && e.addClass(LG);
  }
  _getCurrentLabelsWidth(e) {
    var i = 0;
    return e.forEach(function(r, n) {
      i += oi(r);
    }), i;
  }
  _getCurrentLabelsPaddings(e) {
    var i = 0;
    return e.forEach(function(r, n) {
      i += oi(r) - mt(r);
    }), i;
  }
  _renderItem(e, i, r, n) {
    var a, o, u = (a = i.location) !== null && a !== void 0 ? a : "center", c = r ?? this["_$".concat(u, "Section")], p = !!((o = i.text) !== null && o !== void 0 ? o : i.html), v = super._renderItem(e, i, c, n);
    return v.toggleClass(nye, !p).toggleClass(Iy, p).addClass(i.cssClass), v;
  }
  _renderGroupedItems() {
    N(this.option("items"), (e, i) => {
      var r, n = i.items, a = E("<div>").addClass(oye), o = (r = i.location) !== null && r !== void 0 ? r : "center";
      !n || !n.length || (N(n, (u, c) => {
        this._renderItem(u, c, a, null);
      }), this._$toolbarItemsContainer.find(".dx-toolbar-".concat(o)).append(a));
    });
  }
  _renderItems(e) {
    var i = this.option("grouped") && e.length && e[0].items;
    i ? this._renderGroupedItems() : super._renderItems(e);
  }
  _getToolbarItems() {
    var e;
    return (e = this.option("items")) !== null && e !== void 0 ? e : [];
  }
  _renderContentImpl() {
    var e = this._getToolbarItems();
    this.$element().toggleClass(iye, e.length === 0), this._renderedItemsCount ? this._renderItems(e.slice(this._renderedItemsCount)) : this._renderItems(e), this._applyCompactMode();
  }
  _renderEmptyMessage() {
  }
  _clean() {
    this._$toolbarItemsContainer.children().empty(), this.$element().empty(), delete this._$beforeSection, delete this._$centerSection, delete this._$afterSection;
  }
  _visibilityChanged(e) {
    e && this._arrangeItems();
  }
  _isVisible() {
    return mt(this.$element()) > 0 && Pt(this.$element()) > 0;
  }
  _getIndexByItem(e) {
    return this._getToolbarItems().indexOf(e);
  }
  _itemOptionChanged(e, i, r) {
    super._itemOptionChanged.apply(this, [e, i, r]), this._arrangeItems();
  }
  _optionChanged(e) {
    var {
      name: i,
      value: r
    } = e;
    switch (i) {
      case "width":
        super._optionChanged.apply(this, arguments), this._dimensionChanged();
        break;
      case "renderAs":
      case "useFlatButtons":
      case "useDefaultButtons":
        this._invalidate();
        break;
      case "compactMode":
        this._applyCompactMode();
        break;
      case "grouped":
        break;
      default:
        super._optionChanged.apply(this, arguments);
    }
  }
  _dispose() {
    super._dispose(), clearTimeout(this._waitParentAnimationTimeout);
  }
  _updateDimensionsInMaterial() {
    _a() && Promise.all([new Promise((e) => {
      var i = () => {
        var n = !0;
        return this.$element().parents().each((a, o) => {
          if (ji.isAnimating(E(o)))
            return n = !1, !1;
        }), n && e(), n;
      }, r = () => {
        clearTimeout(this._waitParentAnimationTimeout), this._waitParentAnimationTimeout = setTimeout(() => i() || r(), dye);
      };
      r();
    }), (() => {
      var e = this.$element().find(".".concat(Iy)), i = [];
      return e.each((r, n) => {
        var a = E(n).text(), o = E(n).css("fontWeight");
        i.push(Zse(a, o));
      }), Promise.all(i);
    })()]).then(() => {
      this._dimensionChanged();
    });
  }
}
ti("dxToolbarBase", eX);
var cye = "dx-buttongroup", hye = ["dxAutocomplete", "dxButton", "dxCheckBox", "dxDateBox", "dxMenu", "dxSelectBox", "dxTabs", "dxTextBox", "dxButtonGroup", "dxDropDownButton"], fye = function(t) {
  var e = t.data && t.data(), i = e && e.dxComponents, r = i && i[0];
  return r && e[r];
};
function HT(t, e) {
  var i;
  if (t) {
    var r = t._findItemElementByItem(e);
    if (r.length) {
      var n = t._getItemData(r), a = !!((i = n.options) !== null && i !== void 0 && i.disabled || n.disabled || t.option("disabled")), {
        widget: o
      } = n;
      if (o && hye.indexOf(o) !== -1) {
        var u = r.find(o.toLowerCase().replace("dx", ".dx-"));
        if (u.length) {
          var c, p, v = fye(u);
          if (!v)
            return;
          var _ = (c = v._focusTarget) === null || c === void 0 ? void 0 : c.call(v);
          if (o === "dxDropDownButton")
            _ = _ && _.find(".".concat(cye));
          else {
            var y;
            _ = (y = _) !== null && y !== void 0 ? y : E(v.element());
          }
          var b = (p = n.options) === null || p === void 0 ? void 0 : p.tabIndex;
          a ? _.attr("tabIndex", -1) : _.attr("tabIndex", b ?? 0);
        }
      }
    }
  }
}
var pye = "dx-toolbar-label";
class vye {
  constructor(e) {
    this._toolbar = e;
  }
  _initMarkup() {
  }
  _updateMenuVisibility() {
  }
  _renderMenuItems() {
  }
  _renderItem() {
  }
  _getMenuItems() {
  }
  _getToolbarItems() {
    var e;
    return (e = this._toolbar.option("items")) !== null && e !== void 0 ? e : [];
  }
  _getItemsWidth() {
    return this._toolbar._getSummaryItemsSize("width", this._toolbar.itemElements(), !0);
  }
  _arrangeItems() {
    var e = this._toolbar._$toolbarItemsContainer.find(".".concat(pye)).eq(0);
    if (e.length) {
      var i = mt(this._toolbar.$element()), r = oi(e) - mt(e);
      e.css("maxWidth", i - r);
    }
  }
  _hideOverflowItems() {
  }
  _dimensionChanged() {
  }
  _itemOptionChanged() {
  }
  _optionChanged() {
  }
}
var OI = "dxswipestart", RI = "dxswipe", wS = "dxswipeend", gye = {
  defaultItemSizeFunc: function() {
    return mt(this.getElement());
  },
  getBounds: function() {
    return [this._maxLeftOffset, this._maxRightOffset];
  },
  calcOffsetRatio: function(t) {
    var e = br(t);
    return (e.x - (this._savedEventData && this._savedEventData.x || 0)) / this._itemSizeFunc().call(this, t);
  },
  isFastSwipe: function(t) {
    var e = br(t);
    return this.FAST_SWIPE_SPEED_LIMIT * Math.abs(e.x - this._tickData.x) >= e.time - this._tickData.time;
  }
}, mye = {
  defaultItemSizeFunc: function() {
    return Pt(this.getElement());
  },
  getBounds: function() {
    return [this._maxTopOffset, this._maxBottomOffset];
  },
  calcOffsetRatio: function(t) {
    var e = br(t);
    return (e.y - (this._savedEventData && this._savedEventData.y || 0)) / this._itemSizeFunc().call(this, t);
  },
  isFastSwipe: function(t) {
    var e = br(t);
    return this.FAST_SWIPE_SPEED_LIMIT * Math.abs(e.y - this._tickData.y) >= e.time - this._tickData.time;
  }
}, _ye = {
  horizontal: gye,
  vertical: mye
}, Cye = fS.inherit({
  TICK_INTERVAL: 300,
  FAST_SWIPE_SPEED_LIMIT: 10,
  ctor: function(t) {
    this.callBase(t), this.direction = "horizontal", this.elastic = !0;
  },
  _getStrategy: function() {
    return _ye[this.direction];
  },
  _defaultItemSizeFunc: function() {
    return this._getStrategy().defaultItemSizeFunc.call(this);
  },
  _itemSizeFunc: function() {
    return this.itemSizeFunc || this._defaultItemSizeFunc;
  },
  _init: function(t) {
    this._tickData = br(t);
  },
  _start: function(t) {
    this._savedEventData = br(t), t = this._fireEvent(OI, t), t.cancel || (this._maxLeftOffset = t.maxLeftOffset, this._maxRightOffset = t.maxRightOffset, this._maxTopOffset = t.maxTopOffset, this._maxBottomOffset = t.maxBottomOffset);
  },
  _move: function(t) {
    var e = this._getStrategy(), i = br(t), r = e.calcOffsetRatio.call(this, t);
    r = this._fitOffset(r, this.elastic), i.time - this._tickData.time > this.TICK_INTERVAL && (this._tickData = i), this._fireEvent(RI, t, {
      offset: r
    }), t.cancelable !== !1 && t.preventDefault();
  },
  _end: function(t) {
    var e = this._getStrategy(), i = e.calcOffsetRatio.call(this, t), r = e.isFastSwipe.call(this, t), n = i, a = this._calcTargetOffset(i, r);
    n = this._fitOffset(n, this.elastic), a = this._fitOffset(a, !1), this._fireEvent(wS, t, {
      offset: n,
      targetOffset: a
    });
  },
  _fitOffset: function(t, e) {
    var i = this._getStrategy(), r = i.getBounds.call(this);
    return t < -r[0] ? e ? (-2 * r[0] + t) / 3 : -r[0] : t > r[1] ? e ? (2 * r[1] + t) / 3 : r[1] : t;
  },
  _calcTargetOffset: function(t, e) {
    var i;
    return e ? (i = Math.ceil(Math.abs(t)), t < 0 && (i = -i)) : i = Math.round(t), i;
  }
});
zm({
  emitter: Cye,
  events: [OI, RI, wS]
});
var kG = "dx-list-item-badge-container", yye = "dx-list-item-badge", xye = "dx-badge", jL = "dx-list-item-chevron-container", Sye = "dx-list-item-chevron", Eye = Up.inherit({
  _renderWatchers: function() {
    this.callBase(), this._startWatcher("badge", this._renderBadge.bind(this)), this._startWatcher("showChevron", this._renderShowChevron.bind(this));
  },
  _renderBadge: function(t) {
    if (this._$element.children("." + kG).remove(), !!t) {
      var e = E("<div>").addClass(kG).append(E("<div>").addClass(yye).addClass(xye).text(t)), i = this._$element.children("." + jL).first();
      i.length > 0 ? e.insertBefore(i) : e.appendTo(this._$element);
    }
  },
  _renderShowChevron: function(t) {
    if (this._$element.children("." + jL).remove(), !!t) {
      var e = E("<div>").addClass(jL), i = E("<div>").addClass(Sye);
      e.append(i).appendTo(this._$element);
    }
  }
}), PG = "dx-scrollview-pull-down-loading", YL = "dx-scrollview-pull-down-ready", bye = "dx-scrollview-pull-down-image", wye = "dx-scrollview-pull-down-indicator", Tye = "dx-scrollview-pull-down-text", Iye = "dx-scrollview-pull-down-text-visible", iw = 0, Dy = 1, rw = 2, qL = 3, Dye = 400, Aye = SB.inherit({
  _init: function(t) {
    this.callBase(t), this._$topPocket = t._$topPocket, this._$pullDown = t._$pullDown, this._$refreshingText = t._$refreshingText, this._$scrollViewContent = E(t.content()), this._$container = E(t.container()), this._initCallbacks();
  },
  _initCallbacks: function() {
    this.pullDownCallbacks = ui(), this.releaseCallbacks = ui(), this.reachBottomCallbacks = ui();
  },
  render: function() {
    this.callBase(), this._renderPullDown(), this._releaseState();
  },
  _renderPullDown: function() {
    var t = E("<div>").addClass(bye), e = E("<div>").addClass(wye), i = new us(E("<div>")).$element(), r = this._$pullDownText = E("<div>").addClass(Tye);
    this._$pullingDownText = E("<div>").text(this.option("pullingDownText")).appendTo(r), this._$pulledDownText = E("<div>").text(this.option("pulledDownText")).appendTo(r), this._$refreshingText = E("<div>").text(this.option("refreshingText")).appendTo(r), this._$pullDown.empty().append(t).append(e.append(i)).append(r);
  },
  _releaseState: function() {
    this._state = iw, this._refreshPullDownText();
  },
  _refreshPullDownText: function() {
    var t = this, e = [{
      element: this._$pullingDownText,
      visibleState: iw
    }, {
      element: this._$pulledDownText,
      visibleState: Dy
    }, {
      element: this._$refreshingText,
      visibleState: rw
    }];
    N(e, function(i, r) {
      var n = t._state === r.visibleState ? "addClass" : "removeClass";
      r.element[n](Iye);
    });
  },
  update: function() {
    this.callBase(), this._setTopPocketOffset();
  },
  _updateDimensions: function() {
    this.callBase(), this._topPocketSize = this._$topPocket.get(0).clientHeight;
    var t = this._$scrollViewContent.get(0), e = this._$container.get(0);
    this._bottomBoundary = Math.max(t.clientHeight - e.clientHeight, 0);
  },
  _allowedDirections: function() {
    var t = this.callBase();
    return t.vertical = t.vertical || this._pullDownEnabled, t;
  },
  _setTopPocketOffset: function() {
    this._$topPocket.css({
      top: -this._topPocketSize
    });
  },
  handleEnd: function() {
    this.callBase(), this._complete();
  },
  handleStop: function() {
    this.callBase(), this._complete();
  },
  _complete: function() {
    this._state === Dy && (this._setPullDownOffset(this._topPocketSize), clearTimeout(this._pullDownRefreshTimeout), this._pullDownRefreshTimeout = setTimeout((function() {
      this._pullDownRefreshing();
    }).bind(this), 400));
  },
  _setPullDownOffset: function(t) {
    Nn(this._$topPocket, {
      top: t
    }), Nn(this._$scrollViewContent, {
      top: t
    });
  },
  handleScroll: function(t) {
    if (this.callBase(t), this._state !== rw) {
      var e = this.location().top, i = (this._location || 0) - e;
      this._location = e, this._isPullDown() ? this._pullDownReady() : i > 0 && this._isReachBottom() ? this._reachBottom() : this._stateReleased();
    }
  },
  _isPullDown: function() {
    return this._pullDownEnabled && this._location >= this._topPocketSize;
  },
  _isReachBottom: function() {
    return this._reachBottomEnabled && Math.round(this._bottomBoundary + Math.floor(this._location)) <= 1;
  },
  _reachBottom: function() {
    this._state !== qL && (this._state = qL, this.reachBottomCallbacks.fire());
  },
  _pullDownReady: function() {
    this._state !== Dy && (this._state = Dy, this._$pullDown.addClass(YL), this._refreshPullDownText());
  },
  _stateReleased: function() {
    this._state !== iw && (this._$pullDown.removeClass(PG).removeClass(YL), this._releaseState());
  },
  _pullDownRefreshing: function() {
    this._state !== rw && (this._state = rw, this._$pullDown.addClass(PG).removeClass(YL), this._refreshPullDownText(), this.pullDownCallbacks.fire());
  },
  pullDownEnable: function(t) {
    t && (this._updateDimensions(), this._setTopPocketOffset()), this._pullDownEnabled = t;
  },
  reachBottomEnable: function(t) {
    this._reachBottomEnabled = t;
  },
  pendingRelease: function() {
    this._state = Dy;
  },
  release: function() {
    var t = new q();
    return this._updateDimensions(), clearTimeout(this._releaseTimeout), this._state === qL && (this._state = iw), this._releaseTimeout = setTimeout((function() {
      this._setPullDownOffset(0), this._stateReleased(), this.releaseCallbacks.fire(), this._updateAction(), t.resolve();
    }).bind(this), Dye), t.promise();
  },
  dispose: function() {
    clearTimeout(this._pullDownRefreshTimeout), clearTimeout(this._releaseTimeout), this.callBase();
  }
}), FG = "dx-scrollview-pull-down-loading", Oye = "dx-scrollview-pull-down-indicator", Rye = "dx-scrollview-pull-down-refreshing", Lye = "dx-icon-pulldown", XL = 0, Mye = 1, BG = 2, QL = 4, nw = 5, kye = SB.inherit({
  _init: function(t) {
    this.callBase(t), this._$topPocket = t._$topPocket, this._$pullDown = t._$pullDown, this._$scrollViewContent = E(t.content()), this._$container = E(t.container()), this._initCallbacks(), this._location = 0;
  },
  _initCallbacks: function() {
    this.pullDownCallbacks = ui(), this.releaseCallbacks = ui(), this.reachBottomCallbacks = ui();
  },
  render: function() {
    this.callBase(), this._renderPullDown(), this._releaseState();
  },
  _renderPullDown: function() {
    var t = E("<div>").addClass(Oye), e = new us(E("<div>")).$element();
    this._$icon = E("<div>").addClass(Lye), this._$pullDown.empty().append(this._$icon).append(t.append(e));
  },
  _releaseState: function() {
    this._state = XL, this._releasePullDown(), this._updateDimensions();
  },
  _releasePullDown: function() {
    this._$pullDown.css({
      opacity: 0
    });
  },
  _updateDimensions: function() {
    this.callBase(), this._topPocketSize = this._$topPocket.get(0).clientHeight;
    var t = this._$scrollViewContent.get(0), e = this._$container.get(0);
    this._bottomBoundary = Math.max(t.clientHeight - e.clientHeight, 0);
  },
  _allowedDirections: function() {
    var t = this.callBase();
    return t.vertical = t.vertical || this._pullDownEnabled, t;
  },
  handleInit: function(t) {
    this.callBase(t), this._state === XL && this._location === 0 && (this._startClientY = br(t.originalEvent).y, this._state = QL);
  },
  handleMove: function(t) {
    this.callBase(t), this._deltaY = br(t.originalEvent).y - this._startClientY, this._state === QL && (this._pullDownEnabled && this._deltaY > 0 ? this._state = nw : this._complete()), this._state === nw && (t.preventDefault(), this._movePullDown());
  },
  _movePullDown: function() {
    var t = this._getPullDownHeight(), e = Math.min(3 * t, this._deltaY + this._getPullDownStartPosition()), i = 180 * e / t / 3;
    this._$pullDown.css({
      opacity: 1
    }).toggleClass(Rye, e < t), Nn(this._$pullDown, {
      top: e
    }), this._$icon.css({
      transform: "rotate(" + i + "deg)"
    });
  },
  _isPullDown: function() {
    return this._pullDownEnabled && this._state === nw && this._deltaY >= this._getPullDownHeight() - this._getPullDownStartPosition();
  },
  _getPullDownHeight: function() {
    return Math.round(0.05 * jt(this._$element));
  },
  _getPullDownStartPosition: function() {
    return -Math.round(1.5 * jt(this._$pullDown));
  },
  handleEnd: function() {
    this._isPullDown() && this._pullDownRefreshing(), this._complete();
  },
  handleStop: function() {
    this._complete();
  },
  _complete: function() {
    (this._state === QL || this._state === nw) && this._releaseState();
  },
  handleScroll: function(t) {
    if (this.callBase(t), this._state !== BG) {
      var e = this.location().top, i = this._location - e;
      this._location = e, i > 0 && this._isReachBottom() ? this._reachBottom() : this._stateReleased();
    }
  },
  _isReachBottom: function() {
    return this._reachBottomEnabled && Math.round(this._bottomBoundary + Math.floor(this._location)) <= 1;
  },
  _reachBottom: function() {
    this.reachBottomCallbacks.fire();
  },
  _stateReleased: function() {
    this._state !== XL && (this._$pullDown.removeClass(FG), this._releaseState());
  },
  _pullDownRefreshing: function() {
    this._state = BG, this._pullDownRefreshHandler();
  },
  _pullDownRefreshHandler: function() {
    this._refreshPullDown(), this.pullDownCallbacks.fire();
  },
  _refreshPullDown: function() {
    this._$pullDown.addClass(FG), Nn(this._$pullDown, {
      top: this._getPullDownHeight()
    });
  },
  pullDownEnable: function(t) {
    this._$topPocket.toggle(t), this._pullDownEnabled = t;
  },
  reachBottomEnable: function(t) {
    this._reachBottomEnabled = t;
  },
  pendingRelease: function() {
    this._state = Mye;
  },
  release: function() {
    var t = new q();
    return this._updateDimensions(), clearTimeout(this._releaseTimeout), this._releaseTimeout = setTimeout((function() {
      this._stateReleased(), this.releaseCallbacks.fire(), this._updateAction(), t.resolve();
    }).bind(this), 800), t.promise();
  },
  dispose: function() {
    clearTimeout(this._pullDownRefreshTimeout), clearTimeout(this._releaseTimeout), this.callBase();
  }
}), Pye = Math, VG = "dx-scrollview-pull-down-loading", ZL = "dx-scrollview-pull-down-ready", Fye = "dx-scrollview-pull-down-image", Bye = "dx-scrollview-pull-down-indicator", Vye = "dx-scrollview-pull-down-text", Nye = "dx-scrollview-pull-down-text-visible", Ay = 0, Oy = 1, JL = 2, eM = 3, Hye = D5.inherit({
  ctor: function() {
    this._topPocketSize = 0, this._bottomPocketSize = 0, this.callBase.apply(this, arguments), this._initCallbacks(), this._releaseState();
  },
  _releaseState: function() {
    this._state = Ay, this._refreshPullDownText();
  },
  _refreshPullDownText: function() {
    var t = this, e = [{
      element: this._$pullingDownText,
      visibleState: Ay
    }, {
      element: this._$pulledDownText,
      visibleState: Oy
    }, {
      element: this._$refreshingText,
      visibleState: JL
    }];
    N(e, function(i, r) {
      var n = t._state === r.visibleState ? "addClass" : "removeClass";
      r.element[n](Nye);
    });
  },
  _initCallbacks: function() {
    this.pullDownCallbacks = ui(), this.releaseCallbacks = ui(), this.reachBottomCallbacks = ui();
  },
  _updateBounds: function() {
    var t = this._direction !== "horizontal";
    if (t) {
      this._topPocketSize = this._$topPocket.get(0).clientHeight, this._bottomPocketSize = this._$bottomPocket.get(0).clientHeight;
      var e = this._$container.get(0), i = this._$content.get(0);
      this._bottomBoundary = Math.max(i.clientHeight - this._bottomPocketSize - e.clientHeight, 0);
    }
    this.callBase();
  },
  _updateScrollbar: function() {
    this._scrollbar.option({
      containerSize: this._containerSize(),
      contentSize: this._contentSize() - this._topPocketSize - this._bottomPocketSize,
      scaleRatio: this._getScaleRatio()
    });
  },
  _moveContent: function() {
    this.callBase(), this._isPullDown() ? this._pullDownReady() : this._isReachBottom() ? this._reachBottomReady() : this._state !== Ay && this._stateReleased();
  },
  _moveScrollbar: function() {
    this._scrollbar.moveTo(this._topPocketSize + this._location);
  },
  _isPullDown: function() {
    return this._pullDownEnabled && this._location >= 0;
  },
  _isReachBottom: function() {
    var t = this._$container.get(0);
    return this._reachBottomEnabled && Math.round(this._bottomBoundary - Math.ceil(t.scrollTop)) <= 1;
  },
  _scrollComplete: function() {
    this._inBounds() && this._state === Oy ? this._pullDownRefreshing() : this._inBounds() && this._state === eM ? this._reachBottomLoading() : this.callBase();
  },
  _reachBottomReady: function() {
    this._state !== eM && (this._state = eM, this._minOffset = this._getMinOffset());
  },
  _getMaxOffset: function() {
    return -this._topPocketSize;
  },
  _getMinOffset: function() {
    return Pye.min(this.callBase(), -this._topPocketSize);
  },
  _reachBottomLoading: function() {
    this.reachBottomCallbacks.fire();
  },
  _pullDownReady: function() {
    this._state !== Oy && (this._state = Oy, this._maxOffset = 0, this._$pullDown.addClass(ZL), this._refreshPullDownText());
  },
  _stateReleased: function() {
    this._state !== Ay && (this._releaseState(), this._updateBounds(), this._$pullDown.removeClass(VG).removeClass(ZL), this.releaseCallbacks.fire());
  },
  _pullDownRefreshing: function() {
    this._state !== JL && (this._state = JL, this._$pullDown.addClass(VG).removeClass(ZL), this._refreshPullDownText(), this.pullDownCallbacks.fire());
  },
  _releaseHandler: function() {
    return this._state === Ay && this._moveToBounds(), this._update(), this._releaseTask && this._releaseTask.abort(), this._releaseTask = aF(this._release.bind(this)), this._releaseTask.promise;
  },
  _release: function() {
    this._stateReleased(), this._scrollComplete();
  },
  _reachBottomEnablingHandler: function(t) {
    this._reachBottomEnabled !== t && (this._reachBottomEnabled = t, this._updateBounds());
  },
  _pullDownEnablingHandler: function(t) {
    this._pullDownEnabled !== t && (this._pullDownEnabled = t, this._considerTopPocketChange(), this._updateHandler());
  },
  _considerTopPocketChange: function() {
    this._location -= Pt(this._$topPocket) || -this._topPocketSize, this._maxOffset = 0, this._move();
  },
  _pendingReleaseHandler: function() {
    this._state = Oy;
  },
  dispose: function() {
    this._releaseTask && this._releaseTask.abort(), this.callBase();
  }
}), $ye = A5.inherit({
  _init: function(t) {
    this.callBase(t), this._$pullDown = t._$pullDown, this._$topPocket = t._$topPocket, this._$bottomPocket = t._$bottomPocket, this._initCallbacks();
  },
  _initCallbacks: function() {
    this.pullDownCallbacks = ui(), this.releaseCallbacks = ui(), this.reachBottomCallbacks = ui();
  },
  render: function() {
    this._renderPullDown(), this.callBase();
  },
  _renderPullDown: function() {
    var t = E("<div>").addClass(Fye), e = E("<div>").addClass(Bye), i = new us(E("<div>")).$element(), r = this._$pullDownText = E("<div>").addClass(Vye);
    this._$pullingDownText = E("<div>").text(this.option("pullingDownText")).appendTo(r), this._$pulledDownText = E("<div>").text(this.option("pulledDownText")).appendTo(r), this._$refreshingText = E("<div>").text(this.option("refreshingText")).appendTo(r), this._$pullDown.empty().append(t).append(e.append(i)).append(r);
  },
  pullDownEnable: function(t) {
    this._eventHandler("pullDownEnabling", t);
  },
  reachBottomEnable: function(t) {
    this._eventHandler("reachBottomEnabling", t);
  },
  _createScroller: function(t) {
    var e = this, i = e._scrollers[t] = new Hye(e._scrollerOptions(t));
    i.pullDownCallbacks.add(function() {
      e.pullDownCallbacks.fire();
    }), i.releaseCallbacks.add(function() {
      e.releaseCallbacks.fire();
    }), i.reachBottomCallbacks.add(function() {
      e.reachBottomCallbacks.fire();
    });
  },
  _scrollerOptions: function(t) {
    return P(this.callBase(t), {
      $topPocket: this._$topPocket,
      $bottomPocket: this._$bottomPocket,
      $pullDown: this._$pullDown,
      $pullDownText: this._$pullDownText,
      $pullingDownText: this._$pullingDownText,
      $pulledDownText: this._$pulledDownText,
      $refreshingText: this._$refreshingText
    });
  },
  pendingRelease: function() {
    this._eventHandler("pendingRelease");
  },
  release: function() {
    return this._eventHandler("release").done(this._updateAction);
  },
  location: function() {
    var t = this.callBase();
    return t.top += Pt(this._$topPocket), t;
  },
  dispose: function() {
    N(this._scrollers, function() {
      this.dispose();
    }), this.callBase();
  }
}), jp = "dx-scrollview", zye = jp + "-content", Wye = jp + "-top-pocket", Uye = jp + "-bottom-pocket", Gye = jp + "-pull-down", MB = jp + "-scrollbottom", Kye = MB + "-indicator", jye = MB + "-text", Yye = jp + "-loadpanel", qye = {
  pullDown: Aye,
  swipeDown: kye,
  simulated: $ye
}, Xye = !wt(), Qye = {
  finishLoading: ee,
  release: ee,
  refresh: ee,
  scrollOffset: () => ({
    top: 0,
    left: 0
  }),
  _optionChanged: function(t) {
    if (t.name !== "onUpdated")
      return this.callBase.apply(this, arguments);
  }
}, kB = ds.inherit(Xye ? Qye : {
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      pullingDownText: X.format("dxScrollView-pullingDownText"),
      pulledDownText: X.format("dxScrollView-pulledDownText"),
      refreshingText: X.format("dxScrollView-refreshingText"),
      reachBottomText: X.format("dxScrollView-reachBottomText"),
      onPullDown: null,
      onReachBottom: null,
      refreshStrategy: "pullDown"
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: function() {
        var t = Ye.real();
        return t.platform === "android";
      },
      options: {
        refreshStrategy: "swipeDown"
      }
    }, {
      device: function() {
        return fs();
      },
      options: {
        pullingDownText: "",
        pulledDownText: "",
        refreshingText: "",
        reachBottomText: ""
      }
    }]);
  },
  _init: function() {
    this.callBase(), this._loadingIndicatorEnabled = !0;
  },
  _initScrollableMarkup: function() {
    this.callBase(), this.$element().addClass(jp), this._initContent(), this._initTopPocket(), this._initBottomPocket(), this._initLoadPanel();
  },
  _initContent: function() {
    var t = E("<div>").addClass(zye);
    this._$content.wrapInner(t);
  },
  _initTopPocket: function() {
    var t = this._$topPocket = E("<div>").addClass(Wye), e = this._$pullDown = E("<div>").addClass(Gye);
    t.append(e), this._$content.prepend(t);
  },
  _initBottomPocket: function() {
    var t = this._$bottomPocket = E("<div>").addClass(Uye), e = this._$reachBottom = E("<div>").addClass(MB), i = E("<div>").addClass(Kye), r = new us(E("<div>")).$element(), n = this._$reachBottomText = E("<div>").addClass(jye);
    this._updateReachBottomText(), e.append(i.append(r)).append(n), t.append(e), this._$content.append(t);
  },
  _initLoadPanel: function() {
    var t = E("<div>").addClass(Yye).appendTo(this.$element()), e = {
      shading: !1,
      delay: 400,
      message: this.option("refreshingText"),
      position: {
        of: this.$element()
      }
    };
    this._loadPanel = this._createComponent(t, CB, e);
  },
  _updateReachBottomText: function() {
    this._$reachBottomText.text(this.option("reachBottomText"));
  },
  _createStrategy: function() {
    var t = this.option("useNative") ? this.option("refreshStrategy") : "simulated", e = qye[t];
    this._strategy = new e(this), this._strategy.pullDownCallbacks.add(this._pullDownHandler.bind(this)), this._strategy.releaseCallbacks.add(this._releaseHandler.bind(this)), this._strategy.reachBottomCallbacks.add(this._reachBottomHandler.bind(this));
  },
  _createActions: function() {
    this.callBase(), this._pullDownAction = this._createActionByOption("onPullDown"), this._reachBottomAction = this._createActionByOption("onReachBottom"), this._tryRefreshPocketState();
  },
  _tryRefreshPocketState: function() {
    this._pullDownEnable(this.hasActionSubscription("onPullDown")), this._reachBottomEnable(this.hasActionSubscription("onReachBottom"));
  },
  on: function(t) {
    var e = this.callBase.apply(this, arguments);
    return (t === "pullDown" || t === "reachBottom") && this._tryRefreshPocketState(), e;
  },
  _pullDownEnable: function(t) {
    if (arguments.length === 0)
      return this._pullDownEnabled;
    this._$pullDown && this._strategy && (this._$pullDown.toggle(t), this._strategy.pullDownEnable(t), this._pullDownEnabled = t);
  },
  _reachBottomEnable: function(t) {
    if (arguments.length === 0)
      return this._reachBottomEnabled;
    this._$reachBottom && this._strategy && (this._$reachBottom.toggle(t), this._strategy.reachBottomEnable(t), this._reachBottomEnabled = t);
  },
  _pullDownHandler: function() {
    this._loadingIndicator(!1), this._pullDownLoading();
  },
  _loadingIndicator: function(t) {
    if (arguments.length < 1)
      return this._loadingIndicatorEnabled;
    this._loadingIndicatorEnabled = t;
  },
  _pullDownLoading: function() {
    this.startLoading(), this._pullDownAction();
  },
  _reachBottomHandler: function() {
    this._loadingIndicator(!1), this._reachBottomLoading();
  },
  _reachBottomLoading: function() {
    this.startLoading(), this._reachBottomAction();
  },
  _releaseHandler: function() {
    this.finishLoading(), this._loadingIndicator(!0);
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "onPullDown":
      case "onReachBottom":
        this._createActions();
        break;
      case "pullingDownText":
      case "pulledDownText":
      case "refreshingText":
      case "refreshStrategy":
        this._invalidate();
        break;
      case "reachBottomText":
        this._updateReachBottomText();
        break;
      default:
        this.callBase(t);
    }
  },
  content: function() {
    return ot(this._$content.children().eq(1));
  },
  release: function(t) {
    return t !== void 0 && this.toggleLoading(!t), this._strategy.release();
  },
  toggleLoading: function(t) {
    this._reachBottomEnable(t);
  },
  refresh: function() {
    this.hasActionSubscription("onPullDown") && (this._strategy.pendingRelease(), this._pullDownLoading());
  },
  startLoading: function() {
    this._loadingIndicator() && this.$element().is(":visible") && this._loadPanel.show(), this._lock();
  },
  finishLoading: function() {
    this._loadPanel.hide(), this._unlock();
  },
  _dispose: function() {
    this._strategy.dispose(), this.callBase(), this._loadPanel && this._loadPanel.$element().remove();
  }
});
ti("dxScrollView", kB);
var aw = "__dx_key__";
const PB = Kp.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      repaintChangesOnly: !1
    });
  },
  ctor: function() {
    var t;
    this.callBase.apply(this, arguments), this._customizeStoreLoadOptions = (e) => {
      var i = this._dataController;
      i.getDataSource() && !this._dataController.isLoaded() && (this._correctionIndex = 0), this._correctionIndex && e.storeLoadOptions && (e.storeLoadOptions.skip += this._correctionIndex);
    }, (t = this._dataController) === null || t === void 0 || t.on("customizeStoreLoadOptions", this._customizeStoreLoadOptions);
  },
  reload: function() {
    this._correctionIndex = 0;
  },
  _init: function() {
    this.callBase(), this._refreshItemsCache(), this._correctionIndex = 0;
  },
  _findItemElementByKey: function(t) {
    var e = E(), i = this.key();
    return this.itemElements().each((r, n) => {
      var a = E(n), o = this._getItemData(a);
      if (i ? pS(i, this.keyOf(o), t) : this._isItemEquals(o, t))
        return e = a, !1;
    }), e;
  },
  _dataSourceChangedHandler: function(t, e) {
    e != null && e.changes ? this._modifyByChanges(e.changes) : (this.callBase(t, e), this._refreshItemsCache());
  },
  _isItemEquals: function(t, e) {
    t && t[aw] && (t = t.data);
    try {
      return JSON.stringify(t) === JSON.stringify(e);
    } catch {
      return t === e;
    }
  },
  _isItemStrictEquals: function(t, e) {
    return this._isItemEquals(t, e);
  },
  _shouldAddNewGroup: function(t, e) {
    var i = !1;
    return this.option("grouped") && (t.length || (i = !0), N(t, (r, n) => {
      n.type === "insert" && (i = !0, N(e, (a, o) => {
        if (n.data.key !== void 0 && n.data.key === o.key)
          return i = !1, !1;
      }));
    })), i;
  },
  _partialRefresh: function() {
    if (this.option("repaintChangesOnly")) {
      var t = g5(this._itemsCache, this._editStrategy.itemsGetter(), (e) => e && e[aw] !== void 0 ? e[aw] : this.keyOf(e), this._isItemStrictEquals.bind(this));
      if (t && this._itemsCache.length && !this._shouldAddNewGroup(t, this._itemsCache))
        return this._modifyByChanges(t, !0), this._renderEmptyMessage(), !0;
      this._refreshItemsCache();
    }
    return !1;
  },
  _refreshItemsCache: function() {
    if (this.option("repaintChangesOnly")) {
      var t = this._editStrategy.itemsGetter();
      try {
        this._itemsCache = P(!0, [], t), this.key() || (this._itemsCache = this._itemsCache.map((e, i) => ({
          [aw]: t[i],
          data: e
        })));
      } catch {
        this._itemsCache = P([], t);
      }
    }
  },
  _dispose: function() {
    this._dataController.off("customizeStoreLoadOptions", this._customizeStoreLoadOptions), this.callBase();
  },
  _updateByChange: function(t, e, i, r) {
    if (r)
      this._renderItem(i.index, i.data, null, this._findItemElementByKey(i.key));
    else {
      var n = e[Op(t, e, i.key)];
      n && nB(t, e, i.key, i.data).done(() => {
        this._renderItem(e.indexOf(n), n, null, this._findItemElementByKey(i.key));
      });
    }
  },
  _insertByChange: function(t, e, i, r) {
    $e(r || aB(t, e, i.data, i.index)).done(() => {
      var n;
      this._beforeItemElementInserted(i), this._renderItem((n = i.index) !== null && n !== void 0 ? n : e.length, i.data), this._afterItemElementInserted(), this._correctionIndex++;
    });
  },
  _updateSelectionAfterRemoveByChange: function(t) {
    var e = this.option("selectedIndex");
    e > t ? this.option("selectedIndex", e - 1) : e === t && this.option("selectedItems").length === 1 ? this.option("selectedItems", []) : this._normalizeSelectedItems();
  },
  _beforeItemElementInserted: function(t) {
    var e = this.option("selectedIndex");
    t.index <= e && this.option("selectedIndex", e + 1);
  },
  _afterItemElementInserted: ee,
  _removeByChange: function(t, e, i, r) {
    var n = r ? i.index : Op(t, e, i.key), a = r ? i.oldItem : e[n];
    if (a) {
      var o = this._findItemElementByKey(i.key), u = this._extendActionArgs(o);
      this._waitDeletingPrepare(o).done(() => {
        r ? (this._updateIndicesAfterIndex(n - 1), this._afterItemElementDeleted(o, u), this._updateSelectionAfterRemoveByChange(n)) : (this._deleteItemElementByIndex(n), this._afterItemElementDeleted(o, u));
      }), this._correctionIndex--;
    }
  },
  _modifyByChanges: function(t, e) {
    var i = this._editStrategy.itemsGetter(), r = {
      key: this.key.bind(this),
      keyOf: this.keyOf.bind(this)
    }, n = this._dataController, a = n.paginate(), o = n.group();
    (a || o) && (t = t.filter((u) => u.type !== "insert" || u.index !== void 0)), t.forEach((u) => this["_".concat(u.type, "ByChange")](r, i, u, e)), this._renderedItemsCount = i.length, this._refreshItemsCache(), this._fireContentReadyAction();
  },
  _appendItemToContainer: function(t, e, i) {
    var r = t.children(this._itemSelector()).get(i);
    de.insertElement(t.get(0), e.get(0), r);
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "items":
        var e = this._partialRefresh(t.value);
        e || this.callBase(t);
        break;
      case "dataSource":
        (!this.option("repaintChangesOnly") || !t.value) && this.option("items", []), this.callBase(t);
        break;
      case "repaintChangesOnly":
        break;
      default:
        this.callBase(t);
    }
  }
});
var Zye = (t) => Array.isArray(t) && t.every((e) => {
  var i = Object.keys(e).length === 2, r = "key" in e && "items" in e;
  return i && r && Array.isArray(e.items);
});
const tX = {
  _getSpecificDataSourceOption: function() {
    var t = this.option("dataSource"), e = !1, i = {};
    return this._getGroupedOption() && Zye(t) && (i = t.reduce((r, n) => {
      var a = n.items.map((o) => (ct(o) || (o = {
        text: o
      }, e = !0), "key" in o || (o.key = n.key), o));
      return r.concat(a);
    }, []), t = {
      store: {
        type: "array",
        data: i
      },
      group: {
        selector: "key",
        keepInitialKeyOrder: !0
      }
    }, e && (t.searchExpr = "text")), t;
  }
};
function iX(t) {
  return t ? Number(t.replace("px", "")) : 0;
}
function Jye(t) {
  var e, i;
  return t && wt() ? (e = (i = Ot()).getComputedStyle) === null || e === void 0 ? void 0 : e.call(i, t) : null;
}
function exe(t, e) {
  var i = Jye(t);
  return i ? iX(i["margin".concat(Dx(e))]) : 0;
}
var txe = "dx-list", ixe = "dx-list-items", qw = "dx-list-item", rxe = "." + qw, nxe = "dx-list-item-icon-container", axe = "dx-list-item-icon", Zg = "dx-list-group", tM = "dx-list-group-header", ow = "dx-list-group-body", oxe = "dx-list-collapsible-groups", NG = "dx-list-group-collapsed", sxe = "dx-list-group-header-indicator", lxe = "dx-has-next", uxe = "dx-list-next-button", dxe = "dx-wrap-item-text", cxe = ".dx-list-select-all", hxe = "dxListItemData", HG = 70, fxe = Ii("items"), pxe, FB = PB.inherit({
  _activeStateUnit: [rxe, cxe].join(","),
  _supportedKeys: function() {
    var t = this, e = function(r) {
      var n = i(r), a = n.is(t.option("focusedElement"));
      a && (function(o, u) {
        var c = o.position().top;
        u === "prev" && (c = o.position().top - Pt(t.$element()) + jt(o)), t.scrollTo(c);
      }(n, r), n = i(r)), t.option("focusedElement", ot(n)), t.scrollToItem(n);
    };
    function i(r) {
      var n = t.scrollTop(), a = Pt(t.$element()), o = E(t.option("focusedElement")), u = !0;
      if (!o.length)
        return E();
      for (; u; ) {
        var c = o[r]();
        if (!c.length)
          break;
        var p = c.position().top + jt(c) / 2;
        u = p < a + n && p > n, u && (o = c);
      }
      return o;
    }
    return P(this.callBase(), {
      leftArrow: ee,
      rightArrow: ee,
      pageUp: function() {
        return e("prev"), !1;
      },
      pageDown: function() {
        return e("next"), !1;
      }
    });
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      hoverStateEnabled: !0,
      pullRefreshEnabled: !1,
      scrollingEnabled: !0,
      selectByClick: !0,
      showScrollbar: "onScroll",
      useNativeScrolling: !0,
      bounceEnabled: !0,
      scrollByContent: !0,
      scrollByThumb: !1,
      pullingDownText: X.format("dxList-pullingDownText"),
      pulledDownText: X.format("dxList-pulledDownText"),
      refreshingText: X.format("dxList-refreshingText"),
      pageLoadingText: X.format("dxList-pageLoadingText"),
      onScroll: null,
      onPullRefresh: null,
      onPageLoading: null,
      pageLoadMode: "scrollBottom",
      nextButtonText: X.format("dxList-nextButtonText"),
      onItemSwipe: null,
      grouped: !1,
      onGroupRendered: null,
      collapsibleGroups: !1,
      groupTemplate: "group",
      indicateLoading: !0,
      activeStateEnabled: !0,
      _itemAttributes: {
        role: "option"
      },
      useInkRipple: !1,
      wrapItemText: !1,
      _swipeEnabled: !0,
      showChevronExpr: function(t) {
        return t ? t.showChevron : void 0;
      },
      badgeExpr: function(t) {
        return t ? t.badge : void 0;
      }
    });
  },
  _defaultOptionsRules: function() {
    var t = ho();
    return this.callBase().concat(O5(), [{
      device: function() {
        return !Dp;
      },
      options: {
        useNativeScrolling: !1
      }
    }, {
      device: function(e) {
        return !Dp && !Ye.isSimulator() && Ye.real().deviceType === "desktop" && e.platform === "generic";
      },
      options: {
        showScrollbar: "onHover",
        pageLoadMode: "nextButton"
      }
    }, {
      device: function() {
        return Ye.real().deviceType === "desktop" && !Ye.isSimulator();
      },
      options: {
        focusStateEnabled: !0
      }
    }, {
      device: function() {
        return _a(t);
      },
      options: {
        useInkRipple: !0
      }
    }, {
      device: function() {
        return fs(t);
      },
      options: {
        pullingDownText: "",
        pulledDownText: "",
        refreshingText: "",
        pageLoadingText: ""
      }
    }]);
  },
  _visibilityChanged: function(t) {
    t && this._updateLoadingState(!0);
  },
  _itemClass: function() {
    return qw;
  },
  _itemDataKey: function() {
    return hxe;
  },
  _itemContainer: function() {
    return this._$container;
  },
  _getItemsContainer: function() {
    return this._$listContainer;
  },
  _cleanItemContainer: function() {
    this.callBase();
    var t = this._getItemsContainer();
    E(t).empty(), t.appendTo(this._$container);
  },
  _saveSelectionChangeEvent: function(t) {
    this._selectionChangeEventInstance = t;
  },
  _getSelectionChangeEvent: function() {
    return this._selectionChangeEventInstance;
  },
  _refreshItemElements: function() {
    this.option("grouped") ? this._itemElementsCache = this._getItemsContainer().children("." + Zg).children("." + ow).children(this._itemSelector()) : this._itemElementsCache = this._getItemsContainer().children(this._itemSelector());
  },
  _modifyByChanges: function() {
    this.callBase.apply(this, arguments), this._refreshItemElements(), this._updateLoadingState(!0);
  },
  reorderItem: function(t, e) {
    var i = this.callBase(t, e);
    return i.done(function() {
      this._refreshItemElements();
    });
  },
  deleteItem: function(t) {
    var e = this.callBase(t);
    return e.done(function() {
      this._refreshItemElements();
    });
  },
  _itemElements: function() {
    return this._itemElementsCache;
  },
  _itemSelectHandler: function(t) {
    if (!(this.option("selectionMode") === "single" && this.isItemSelected(t.currentTarget)))
      return this.callBase(t);
  },
  _allowDynamicItemsAppend: function() {
    return !0;
  },
  _init: function() {
    this.callBase(), this._dataController.resetDataSourcePageIndex(), this._$container = this.$element(), this._$listContainer = E("<div>").addClass(ixe), this._initScrollView(), this._feedbackShowTimeout = HG, this._createGroupRenderAction();
  },
  _scrollBottomMode: function() {
    return this.option("pageLoadMode") === "scrollBottom";
  },
  _nextButtonMode: function() {
    return this.option("pageLoadMode") === "nextButton";
  },
  _dataSourceOptions: function() {
    var t = this._scrollBottomMode(), e = this._nextButtonMode();
    return P(this.callBase(), {
      paginate: cr(t || e, !0)
    });
  },
  _getGroupedOption: function() {
    return this.option("grouped");
  },
  _getGroupContainerByIndex: function(t) {
    return this._getItemsContainer().find(".".concat(Zg)).eq(t).find(".".concat(ow));
  },
  _dataSourceFromUrlLoadMode: function() {
    return "raw";
  },
  _initScrollView: function() {
    var t = this.option("scrollingEnabled"), e = t && this.option("pullRefreshEnabled"), i = t && this._scrollBottomMode() && !!this._dataController.getDataSource();
    this._scrollView = this._createComponent(this.$element(), vxe(), {
      height: this.option("height"),
      width: this.option("width"),
      disabled: this.option("disabled") || !t,
      onScroll: this._scrollHandler.bind(this),
      onPullDown: e ? this._pullDownHandler.bind(this) : null,
      onReachBottom: i ? this._scrollBottomHandler.bind(this) : null,
      showScrollbar: this.option("showScrollbar"),
      useNative: this.option("useNativeScrolling"),
      bounceEnabled: this.option("bounceEnabled"),
      scrollByContent: this.option("scrollByContent"),
      scrollByThumb: this.option("scrollByThumb"),
      pullingDownText: this.option("pullingDownText"),
      pulledDownText: this.option("pulledDownText"),
      refreshingText: this.option("refreshingText"),
      reachBottomText: this.option("pageLoadingText"),
      useKeyboard: !1
    }), this._$container = E(this._scrollView.content()), this._$listContainer.appendTo(this._$container), this._toggleWrapItemText(this.option("wrapItemText")), this._createScrollViewActions();
  },
  _toggleWrapItemText: function(t) {
    this._$listContainer.toggleClass(dxe, t);
  },
  _createScrollViewActions: function() {
    this._scrollAction = this._createActionByOption("onScroll"), this._pullRefreshAction = this._createActionByOption("onPullRefresh"), this._pageLoadingAction = this._createActionByOption("onPageLoading");
  },
  _scrollHandler: function(t) {
    this._scrollAction && this._scrollAction(t);
  },
  _initTemplates: function() {
    this._templateManager.addDefaultTemplates({
      group: new Gp(function(t, e) {
        $t(e) ? e.key && t.text(e.key) : t.text(String(e));
      }, ["key"], this.option("integrationOptions.watchMethod"))
    }), this.callBase();
  },
  _prepareDefaultItemTemplate: function(t, e) {
    if (this.callBase(t, e), t.icon) {
      var i = ec(t.icon).addClass(axe), r = E("<div>").addClass(nxe);
      r.append(i), e.prepend(r);
    }
  },
  _getBindableFields: function() {
    return ["text", "html", "icon"];
  },
  _updateLoadingState: function(t) {
    var e = this._dataController, i = this._scrollBottomMode() && t && !e.isLoading() && !this._isLastPage();
    this._shouldContinueLoading(i) ? this._infiniteDataLoading() : (this._scrollView.release(!i && !e.isLoading()), this._toggleNextButton(this._shouldRenderNextButton() && !this._isLastPage()), this._loadIndicationSuppressed(!1));
  },
  _shouldRenderNextButton: function() {
    return this._nextButtonMode() && this._dataController.isLoaded();
  },
  _isDataSourceFirstLoadCompleted: function(t) {
    return R(t) && (this._isFirstLoadCompleted = t), this._isFirstLoadCompleted;
  },
  _dataSourceLoadingChangedHandler: function(t) {
    this._loadIndicationSuppressed() || (t && this.option("indicateLoading") ? this._showLoadingIndicatorTimer = setTimeout((function() {
      var e = !this._itemElements().length, i = !e || this._isDataSourceFirstLoadCompleted();
      if (i) {
        var r;
        (r = this._scrollView) === null || r === void 0 || r.startLoading();
      }
    }).bind(this)) : (clearTimeout(this._showLoadingIndicatorTimer), this._scrollView && this._scrollView.finishLoading()), t || this._isDataSourceFirstLoadCompleted(!1));
  },
  _dataSourceChangedHandler: function() {
    !this._shouldAppendItems() && wt() && this._scrollView && this._scrollView.scrollTo(0), this.callBase.apply(this, arguments), this._isDataSourceFirstLoadCompleted(!0);
  },
  _refreshContent: function() {
    this._prepareContent(), this._fireContentReadyAction();
  },
  _hideLoadingIfLoadIndicationOff: function() {
    this.option("indicateLoading") || this._dataSourceLoadingChangedHandler(!1);
  },
  _loadIndicationSuppressed: function(t) {
    if (!arguments.length)
      return this._isLoadIndicationSuppressed;
    this._isLoadIndicationSuppressed = t;
  },
  _scrollViewIsFull: function() {
    var t = this._scrollView;
    return !t || Pt(t.content()) > Pt(t.container());
  },
  _pullDownHandler: function(t) {
    this._pullRefreshAction(t);
    var e = this._dataController;
    e.getDataSource() && !e.isLoading() ? (this._clearSelectedItems(), e.pageIndex(0), e.reload()) : this._updateLoadingState();
  },
  _shouldContinueLoading: function(t) {
    var e, i, r = Pt(this._scrollView.content()) - Pt(this._scrollView.container()) < ((e = (i = this._scrollView.scrollOffset()) === null || i === void 0 ? void 0 : i.top) !== null && e !== void 0 ? e : 0);
    return t && (!this._scrollViewIsFull() || r);
  },
  _infiniteDataLoading: function() {
    var t = this.$element().is(":visible");
    t && (clearTimeout(this._loadNextPageTimer), this._loadNextPageTimer = setTimeout(() => {
      this._loadNextPage();
    }));
  },
  _scrollBottomHandler: function(t) {
    this._pageLoadingAction(t);
    var e = this._dataController;
    !e.isLoading() && !this._isLastPage() ? this._loadNextPage() : this._updateLoadingState();
  },
  _renderItems: function(t) {
    this.option("grouped") ? (N(t, this._renderGroup.bind(this)), this._attachGroupCollapseEvent(), this._renderEmptyMessage(), _a() && this.attachGroupHeaderInkRippleEvents()) : this.callBase.apply(this, arguments), this._refreshItemElements(), this._updateLoadingState(!0);
  },
  _attachGroupCollapseEvent: function() {
    var t = ve(di, this.NAME), e = "." + tM, i = this.$element(), r = this.option("collapsibleGroups");
    i.toggleClass(oxe, r), k.off(i, t, e), r && k.on(i, t, e, (function(n) {
      this._createAction((function(a) {
        var o = E(a.event.currentTarget).parent();
        this._collapseGroupHandler(o), this.option("focusStateEnabled") && this.option("focusedElement", ot(o.find("." + qw).eq(0)));
      }).bind(this), {
        validatingTargetName: "element"
      })({
        event: n
      });
    }).bind(this));
  },
  _collapseGroupHandler: function(t, e) {
    var i = new q();
    if (t.hasClass(NG) === e)
      return i.resolve();
    var r = t.children("." + ow), n = jt(r), a = 0;
    return n === 0 && (Dh(r, "auto"), a = jt(r)), t.toggleClass(NG, e), ji.animate(r, {
      type: "custom",
      from: {
        height: n
      },
      to: {
        height: a
      },
      duration: 200,
      complete: (function() {
        this.updateDimensions(), this._updateLoadingState(!0), i.resolve();
      }).bind(this)
    }), i.promise();
  },
  _dataSourceLoadErrorHandler: function() {
    this._forgetNextPageLoading(), this._initialized && (this._renderEmptyMessage(), this._updateLoadingState());
  },
  _initMarkup: function() {
    this._itemElementsCache = E(), this.$element().addClass(txe), this.callBase(), this.option("useInkRipple") && this._renderInkRipple(), this.setAria({
      role: "group",
      roledescription: "list"
    }, this.$element()), this.setAria({
      role: "group"
    }, this._focusTarget()), this._setListAria();
  },
  _setListAria() {
    var {
      items: t
    } = this.option(), e = t != null && t.length ? {
      role: "listbox",
      label: "Items"
    } : {
      role: void 0,
      label: void 0
    };
    this.setAria(e, this._$listContainer);
  },
  _focusTarget: function() {
    return this._itemContainer();
  },
  _renderInkRipple: function() {
    this._inkRipple = NF();
  },
  _toggleActiveState: function(t, e, i) {
    this.callBase.apply(this, arguments);
    var r = this;
    if (this._inkRipple) {
      var n = {
        element: t,
        event: i
      };
      e ? _a() ? this._inkRippleTimer = setTimeout(function() {
        r._inkRipple.showWave(n);
      }, HG / 2) : r._inkRipple.showWave(n) : (clearTimeout(this._inkRippleTimer), this._inkRipple.hideWave(n));
    }
  },
  _postprocessRenderItem: function(t) {
    this._refreshItemElements(), this.callBase.apply(this, arguments), this.option("_swipeEnabled") && this._attachSwipeEvent(E(t.itemElement));
  },
  _attachSwipeEvent: function(t) {
    var e = ve(wS, this.NAME);
    k.on(t, e, this._itemSwipeEndHandler.bind(this));
  },
  _itemSwipeEndHandler: function(t) {
    this._itemDXEventHandler(t, "onItemSwipe", {
      direction: t.offset < 0 ? "left" : "right"
    });
  },
  _nextButtonHandler: function(t) {
    this._pageLoadingAction(t);
    var e = this._dataController;
    e.getDataSource() && !e.isLoading() && (this._scrollView.toggleLoading(!0), this._$nextButton.detach(), this._loadIndicationSuppressed(!0), this._loadNextPage());
  },
  _renderGroup: function(t, e) {
    var i = E("<div>").addClass(Zg).appendTo(this._getItemsContainer()), r = "dx-".concat(new yr().toString()), n = {
      role: "group",
      labelledby: r
    };
    this.setAria(n, i);
    var a = E("<div>").addClass(tM).attr("id", r).appendTo(i), o = this.option("groupTemplate"), u = this._getTemplate(e.template || o, e, t, a), c = {
      index: t,
      itemData: e,
      container: ot(a)
    };
    this._createItemByTemplate(u, c), E("<div>").addClass(sxe).prependTo(a), this._renderingGroupIndex = t;
    var p = E("<div>").addClass(ow).appendTo(i);
    N(fxe(e) || [], (function(v, _) {
      this._renderItem({
        group: t,
        item: v
      }, _, p);
    }).bind(this)), this._groupRenderAction({
      groupElement: ot(i),
      groupIndex: t,
      groupData: e
    });
  },
  downInkRippleHandler: function(t) {
    this._toggleActiveState(E(t.currentTarget), !0, t);
  },
  upInkRippleHandler: function(t) {
    this._toggleActiveState(E(t.currentTarget), !1);
  },
  attachGroupHeaderInkRippleEvents: function() {
    var t = "." + tM, e = this.$element();
    this._downInkRippleHandler = this._downInkRippleHandler || this.downInkRippleHandler.bind(this), this._upInkRippleHandler = this._upInkRippleHandler || this.upInkRippleHandler.bind(this);
    var i = [e, "dxpointerdown", t, this._downInkRippleHandler], r = [e, "dxpointerup dxpointerout", t, this._upInkRippleHandler];
    k.off(...i), k.on(...i), k.off(...r), k.on(...r);
  },
  _createGroupRenderAction: function() {
    this._groupRenderAction = this._createActionByOption("onGroupRendered");
  },
  _clean: function() {
    clearTimeout(this._inkRippleTimer), this._$nextButton && (this._$nextButton.remove(), this._$nextButton = null), this.callBase.apply(this, arguments);
  },
  _dispose: function() {
    this._isDataSourceFirstLoadCompleted(!1), clearTimeout(this._holdTimer), clearTimeout(this._loadNextPageTimer), clearTimeout(this._showLoadingIndicatorTimer), this.callBase();
  },
  _toggleDisabledState: function(t) {
    this.callBase(t), this._scrollView.option("disabled", t || !this.option("scrollingEnabled"));
  },
  _toggleNextButton: function(t) {
    var e = this._dataController, i = this._getNextButton();
    this.$element().toggleClass(lxe, t), t && e.isLoaded() && i.appendTo(this._itemContainer()), t || i.detach();
  },
  _getNextButton: function() {
    return this._$nextButton || (this._$nextButton = this._createNextButton()), this._$nextButton;
  },
  _createNextButton: function() {
    var t = E("<div>").addClass(uxe), e = E("<div>").appendTo(t);
    return this._createComponent(e, yn, {
      text: this.option("nextButtonText"),
      onClick: this._nextButtonHandler.bind(this),
      type: fs() ? "default" : void 0,
      integrationOptions: {}
    }), t;
  },
  _moveFocus: function() {
    this.callBase.apply(this, arguments), this.scrollToItem(this.option("focusedElement"));
  },
  _refresh: function() {
    if (!wt())
      this.callBase();
    else {
      var t = this._scrollView.scrollTop();
      this.callBase(), t && this._scrollView.scrollTo(t);
    }
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "pageLoadMode":
        this._toggleNextButton(t.value), this._initScrollView();
        break;
      case "dataSource":
        this.callBase(t), this._initScrollView(), this._isDataSourceFirstLoadCompleted(!1);
        break;
      case "items":
        this.callBase(t), this._isDataSourceFirstLoadCompleted(!1);
        break;
      case "pullingDownText":
      case "pulledDownText":
      case "refreshingText":
      case "pageLoadingText":
      case "showScrollbar":
      case "bounceEnabled":
      case "scrollByContent":
      case "scrollByThumb":
      case "useNativeScrolling":
      case "scrollingEnabled":
      case "pullRefreshEnabled":
        this._initScrollView(), this._updateLoadingState(!0);
        break;
      case "nextButtonText":
      case "onItemSwipe":
      case "useInkRipple":
        this._invalidate();
        break;
      case "onScroll":
      case "onPullRefresh":
      case "onPageLoading":
        this._createScrollViewActions();
        break;
      case "grouped":
      case "collapsibleGroups":
      case "groupTemplate":
        this._invalidate();
        break;
      case "wrapItemText":
        this._toggleWrapItemText(t.value);
        break;
      case "onGroupRendered":
        this._createGroupRenderAction();
        break;
      case "width":
      case "height":
        this.callBase(t), this._scrollView.option(t.name, t.value), this._scrollView.update();
        break;
      case "indicateLoading":
        this._hideLoadingIfLoadIndicationOff();
        break;
      case "visible":
        this.callBase(t), this._scrollView.update();
        break;
      case "rtlEnabled":
        this._initScrollView(), this.callBase(t);
        break;
      case "showChevronExpr":
      case "badgeExpr":
        this._invalidate();
        break;
      case "_swipeEnabled":
      case "selectByClick":
        break;
      default:
        this.callBase(t);
    }
  },
  _extendActionArgs: function(t) {
    if (!this.option("grouped"))
      return this.callBase(t);
    var e = t.closest("." + Zg), i = e.find("." + qw);
    return P(this.callBase(t), {
      itemIndex: {
        group: e.index(),
        item: i.index(t)
      }
    });
  },
  expandGroup: function(t) {
    var e = new q(), i = this._getItemsContainer().find(".".concat(Zg)).eq(t);
    return this._collapseGroupHandler(i, !1).done((function() {
      e.resolveWith(this);
    }).bind(this)), e.promise();
  },
  collapseGroup: function(t) {
    var e = new q(), i = this._getItemsContainer().find(".".concat(Zg)).eq(t);
    return this._collapseGroupHandler(i, !0).done((function() {
      e.resolveWith(this);
    }).bind(this)), e;
  },
  updateDimensions: function() {
    var t = this, e = new q();
    return t._scrollView ? t._scrollView.update().done(function() {
      !t._scrollViewIsFull() && t._updateLoadingState(!0), e.resolveWith(t);
    }) : e.resolveWith(t), e.promise();
  },
  reload: function() {
    this.callBase(), this.scrollTo(0), this._pullDownHandler();
  },
  repaint: function() {
    this.scrollTo(0), this.callBase();
  },
  scrollTop: function() {
    return this._scrollView.scrollOffset().top;
  },
  clientHeight: function() {
    return this._scrollView.clientHeight();
  },
  scrollHeight: function() {
    return this._scrollView.scrollHeight();
  },
  scrollBy: function(t) {
    this._scrollView.scrollBy(t);
  },
  scrollTo: function(t) {
    this._scrollView.scrollTo(t);
  },
  scrollToItem: function(t) {
    var e = this._editStrategy.getItemElement(t), i = e == null ? void 0 : e.get(0);
    this._scrollView.scrollToElement(i, {
      bottom: exe(i, "bottom")
    });
  },
  _dimensionChanged: function() {
    this.updateDimensions();
  }
}).include(tX);
FB.ItemClass = Eye;
function vxe() {
  return pxe || kB;
}
var iM = "dx-toolbar-menu-action", gxe = "dx-toolbar-hidden-button", $G = "dx-toolbar-hidden-button-group", zG = "dx-toolbar-menu-section", mxe = "dx-toolbar-menu-custom", WG = "dx-toolbar-menu-last-section", _xe = "dx-scrollview-content";
class Cxe extends FB {
  _init() {
    super._init(), this._activeStateUnit = ".".concat(iM, ":not(.").concat($G, ")");
  }
  _initMarkup() {
    this._renderSections(), super._initMarkup(), this._setMenuRole();
  }
  _getSections() {
    return this._itemContainer().children();
  }
  _itemElements() {
    return this._getSections().children(this._itemSelector());
  }
  _renderSections() {
    var e = this._itemContainer();
    N(["before", "center", "after", "menu"], (i, r) => {
      var n = "_$".concat(r, "Section");
      this[n] || (this[n] = E("<div>").addClass(zG)), this[n].appendTo(e);
    });
  }
  _renderItems() {
    super._renderItems.apply(this, arguments), this._updateSections();
  }
  _setMenuRole() {
    var e = this.$element().find(".".concat(_xe));
    e.attr("role", "menu");
  }
  _updateSections() {
    var e = this.$element().find(".".concat(zG));
    e.removeClass(WG), e.not(":empty").eq(-1).addClass(WG);
  }
  _renderItem(e, i, r, n) {
    var a, o = (a = i.location) !== null && a !== void 0 ? a : "menu", u = this["_$".concat(o, "Section")], c = super._renderItem(e, i, u, n);
    return this._getItemTemplateName({
      itemData: i
    }) && c.addClass(mxe), (o === "menu" || i.widget === "dxButton" || i.widget === "dxButtonGroup" || i.isAction) && c.addClass(iM), i.widget === "dxButton" && c.addClass(gxe), i.widget === "dxButtonGroup" && c.addClass($G), c.addClass(i.cssClass), c;
  }
  _getItemTemplateName(e) {
    var i = super._getItemTemplateName(e), r = e.itemData, n = r && r.menuItemTemplate;
    return n || i;
  }
  _dataSourceOptions() {
    return {
      paginate: !1
    };
  }
  _itemClickHandler(e, i, r) {
    E(e.target).closest(".".concat(iM)).length && super._itemClickHandler(e, i, r);
  }
  _clean() {
    this._getSections().empty(), super._clean();
  }
}
var sw = 5;
class yxe {
  constructor(e) {
    this.init(e);
  }
  init(e) {
    var {
      dragEnabled: i,
      handle: r,
      draggableElement: n,
      positionController: a
    } = e;
    this._positionController = a, this._draggableElement = n, this._handle = r, this._dragEnabled = i, this.unsubscribe(), i && this.subscribe();
  }
  moveDown(e) {
    this._moveTo(sw, 0, e);
  }
  moveUp(e) {
    this._moveTo(-sw, 0, e);
  }
  moveLeft(e) {
    this._moveTo(0, -sw, e);
  }
  moveRight(e) {
    this._moveTo(0, sw, e);
  }
  subscribe() {
    var e = this._getEventNames();
    k.on(this._handle, e.startEventName, (i) => {
      this._dragStartHandler(i);
    }), k.on(this._handle, e.updateEventName, (i) => {
      this._dragUpdateHandler(i);
    }), k.on(this._handle, e.endEventName, (i) => {
      this._dragEndHandler(i);
    });
  }
  unsubscribe() {
    var e = this._getEventNames();
    k.off(this._handle, e.startEventName), k.off(this._handle, e.updateEventName), k.off(this._handle, e.endEventName);
  }
  _getEventNames() {
    var e = ve(Rp, "overlayDrag"), i = ve(Rh, "overlayDrag"), r = ve(Lp, "overlayDrag");
    return {
      startEventName: e,
      updateEventName: i,
      endEventName: r
    };
  }
  _dragStartHandler(e) {
    var i = this._getAllowedOffsets();
    this._prevOffset = {
      x: 0,
      y: 0
    }, e.targetElements = [], e.maxTopOffset = i.top, e.maxBottomOffset = i.bottom, e.maxLeftOffset = i.left, e.maxRightOffset = i.right;
  }
  _dragUpdateHandler(e) {
    var i = {
      top: e.offset.y - this._prevOffset.y,
      left: e.offset.x - this._prevOffset.x
    };
    this._moveByOffset(i), this._prevOffset = e.offset;
  }
  _dragEndHandler(e) {
    this._positionController.dragHandled(), this._positionController.detectVisualPositionChange(e);
  }
  _moveTo(e, i, r) {
    if (this._dragEnabled) {
      r.preventDefault(), r.stopPropagation();
      var n = this._fitOffsetIntoAllowedRange(e, i);
      this._moveByOffset(n), this._dragEndHandler(r);
    }
  }
  _fitOffsetIntoAllowedRange(e, i) {
    var r = this._getAllowedOffsets();
    return {
      top: ma(e, -r.top, r.bottom),
      left: ma(i, -r.left, r.right)
    };
  }
  _getContainerDimensions() {
    var e = de.getDocument(), i = this._positionController.$dragResizeContainer.get(0), r = oi(i), n = jt(i);
    return Or(i) && (n = Math.max(e.body.clientHeight, n), r = Math.max(e.body.clientWidth, r)), {
      width: r,
      height: n
    };
  }
  _getContainerPosition() {
    var e = this._positionController.$dragResizeContainer.get(0);
    return Or(e) ? {
      top: 0,
      left: 0
    } : Ek(e);
  }
  _getElementPosition() {
    return Ek(this._draggableElement);
  }
  _getInnerDelta() {
    var e = this._getContainerDimensions(), i = this._getElementDimensions();
    return {
      x: e.width - i.width,
      y: e.height - i.height
    };
  }
  _getOuterDelta() {
    var {
      width: e,
      height: i
    } = this._getElementDimensions(), r = this._positionController.outsideDragFactor;
    return {
      x: e * r,
      y: i * r
    };
  }
  _getFullDelta() {
    var e = this._getInnerDelta(), i = this._getOuterDelta();
    return {
      x: e.x + i.x,
      y: e.y + i.y
    };
  }
  _getElementDimensions() {
    return {
      width: this._draggableElement.offsetWidth,
      height: this._draggableElement.offsetHeight
    };
  }
  _getAllowedOffsets() {
    var e = this._getFullDelta(), i = e.y >= 0 && e.x >= 0;
    if (!i)
      return {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      };
    var r = this._getElementPosition(), n = this._getContainerPosition(), a = this._getOuterDelta();
    return {
      top: r.top - n.top + a.y,
      bottom: -r.top + n.top + e.y,
      left: r.left - n.left + a.x,
      right: -r.left + n.left + e.x
    };
  }
  _moveByOffset(e) {
    var i = zs(this._draggableElement), r = {
      left: i.left + e.left,
      top: i.top + e.top
    };
    Nn(this._draggableElement, r);
  }
}
var LI = "dxResizable", xxe = "dx-resizable", Sxe = "dx-resizable-resizing", lw = "dx-resizable-handle", Exe = "dx-resizable-handle-top", bxe = "dx-resizable-handle-bottom", wxe = "dx-resizable-handle-left", Txe = "dx-resizable-handle-right", uw = "dx-resizable-handle-corner", Ixe = ve(Rp, LI), Dxe = ve(Rh, LI), Axe = ve(Lp, LI), Oxe = {
  left: "borderLeftWidth",
  top: "borderTopWidth",
  right: "borderRightWidth",
  bottom: "borderBottomWidth"
}, rX = Nu.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      handles: "all",
      step: "1",
      stepPrecision: "simple",
      area: void 0,
      minWidth: 30,
      maxWidth: 1 / 0,
      minHeight: 30,
      maxHeight: 1 / 0,
      onResizeStart: null,
      onResize: null,
      onResizeEnd: null,
      roundStepValue: !0,
      keepAspectRatio: !0
    });
  },
  _init: function() {
    this.callBase(), this.$element().addClass(xxe);
  },
  _initMarkup: function() {
    this.callBase(), this._renderHandles();
  },
  _render: function() {
    this.callBase(), this._renderActions();
  },
  _renderActions: function() {
    this._resizeStartAction = this._createActionByOption("onResizeStart"), this._resizeEndAction = this._createActionByOption("onResizeEnd"), this._resizeAction = this._createActionByOption("onResize");
  },
  _renderHandles: function() {
    this._handles = [];
    var t = this.option("handles");
    if (!(t === "none" || !t)) {
      var e = t === "all" ? ["top", "bottom", "left", "right"] : t.split(" "), i = {};
      N(e, (r, n) => {
        i[n] = !0, this._renderHandle(n);
      }), i.bottom && i.right && this._renderHandle("corner-bottom-right"), i.bottom && i.left && this._renderHandle("corner-bottom-left"), i.top && i.right && this._renderHandle("corner-top-right"), i.top && i.left && this._renderHandle("corner-top-left"), this._attachEventHandlers();
    }
  },
  _renderHandle: function(t) {
    var e = E("<div>").addClass(lw).addClass(lw + "-" + t).appendTo(this.$element());
    this._handles.push(e);
  },
  _attachEventHandlers: function() {
    if (!this.option("disabled")) {
      var t = {};
      t[Ixe] = this._dragStartHandler.bind(this), t[Dxe] = this._dragHandler.bind(this), t[Axe] = this._dragEndHandler.bind(this), this._handles.forEach((e) => {
        k.on(e, t, {
          direction: "both",
          immediate: !0
        });
      });
    }
  },
  _detachEventHandlers: function() {
    this._handles.forEach((t) => {
      k.off(t);
    });
  },
  _toggleEventHandlers: function(t) {
    t ? this._attachEventHandlers() : this._detachEventHandlers();
  },
  _getElementSize: function() {
    var t = this.$element();
    return t.css("boxSizing") === "border-box" ? {
      width: oi(t),
      height: jt(t)
    } : {
      width: mt(t),
      height: Pt(t)
    };
  },
  _dragStartHandler: function(t) {
    var e = this.$element();
    if (e.is(".dx-state-disabled, .dx-state-disabled *")) {
      t.cancel = !0;
      return;
    }
    this._toggleResizingClass(!0), this._movingSides = this._getMovingSides(t), this._elementLocation = zs(e), this._elementSize = this._getElementSize(), this._renderDragOffsets(t), this._resizeStartAction({
      event: t,
      width: this._elementSize.width,
      height: this._elementSize.height,
      handles: this._movingSides
    }), t.targetElements = null;
  },
  _toggleResizingClass: function(t) {
    this.$element().toggleClass(Sxe, t);
  },
  _renderDragOffsets: function(t) {
    var e = this._getArea();
    if (e) {
      var i = E(t.target).closest("." + lw), r = oi(i), n = jt(i), a = i.offset(), o = e.offset, u = this._getAreaScrollOffset();
      t.maxLeftOffset = this._leftMaxOffset = a.left - o.left - u.scrollX, t.maxRightOffset = this._rightMaxOffset = o.left + e.width - a.left - r + u.scrollX, t.maxTopOffset = this._topMaxOffset = a.top - o.top - u.scrollY, t.maxBottomOffset = this._bottomMaxOffset = o.top + e.height - a.top - n + u.scrollY;
    }
  },
  _getBorderWidth: function(t, e) {
    if (Or(t.get(0)))
      return 0;
    var i = t.css(Oxe[e]);
    return parseInt(i) || 0;
  },
  _proportionate: function(t, e) {
    var i = this._elementSize, r = t === "x" ? i.width / i.height : i.height / i.width;
    return e * r;
  },
  _getProportionalDelta: function(t) {
    var {
      x: e,
      y: i
    } = t, r = this._proportionate("y", e);
    if (r >= i)
      return {
        x: e,
        y: r
      };
    var n = this._proportionate("x", i);
    return n >= e ? {
      x: n,
      y: i
    } : {
      x: 0,
      y: 0
    };
  },
  _getDirectionName: function(t) {
    var e = this._movingSides;
    return t === "x" ? e.left ? "left" : "right" : e.top ? "top" : "bottom";
  },
  _fitIntoArea: function(t, e) {
    var i, r = this._getDirectionName(t);
    return Math.min(e, (i = this["_".concat(r, "MaxOffset")]) !== null && i !== void 0 ? i : 1 / 0);
  },
  _fitDeltaProportionally: function(t) {
    var e = ae({}, t), i = this._elementSize, {
      minWidth: r,
      minHeight: n,
      maxWidth: a,
      maxHeight: o
    } = this.option(), u = () => i.width + e.x, c = () => i.height + e.y, p = (I) => e[I] === this._fitIntoArea(I, e[I]), v = () => Ud(u(), r, a) && p("x"), _ = () => Ud(c(), n, o) && p("y");
    if (!v()) {
      var y = this._fitIntoArea("x", ma(u(), r, a) - i.width);
      e = {
        x: y,
        y: this._proportionate("y", y)
      };
    }
    if (!_()) {
      var b = this._fitIntoArea("y", ma(c(), n, o) - i.height);
      e = {
        x: this._proportionate("x", b),
        y: b
      };
    }
    return v() && _() ? e : {
      x: 0,
      y: 0
    };
  },
  _fitDelta: function(t) {
    var {
      x: e,
      y: i
    } = t, r = this._elementSize, {
      minWidth: n,
      minHeight: a,
      maxWidth: o,
      maxHeight: u
    } = this.option();
    return {
      x: ma(r.width + e, n, o) - r.width,
      y: ma(r.height + i, a, u) - r.height
    };
  },
  _getDeltaByOffset: function(t) {
    var e = this._movingSides, i = this._isCornerHandler(e) && this.option("keepAspectRatio"), r = {
      x: t.x * (e.left ? -1 : 1),
      y: t.y * (e.top ? -1 : 1)
    };
    if (i) {
      var n = this._getProportionalDelta(r), a = this._fitDeltaProportionally(n);
      r = a;
    } else {
      var o = this._fitDelta(r), u = this._roundByStep(o);
      r = u;
    }
    return r;
  },
  _updatePosition: function(t, e) {
    var {
      width: i,
      height: r
    } = e, n = this._elementLocation, a = this._movingSides, o = this.$element(), u = this._getElementSize(), c = t.y * (a.top ? -1 : 1) - ((u.height || r) - r), p = t.x * (a.left ? -1 : 1) - ((u.width || i) - i);
    Nn(o, {
      top: n.top + (a.top ? c : 0),
      left: n.left + (a.left ? p : 0)
    });
  },
  _dragHandler: function(t) {
    var e = this._getOffset(t), i = this._getDeltaByOffset(e), r = this._updateDimensions(i);
    this._updatePosition(i, r), this._triggerResizeAction(t, r);
  },
  _updateDimensions: function(t) {
    var e = (p) => p.substring(p.length - 2) === "px", i = this.option("stepPrecision") === "strict", r = this._elementSize, n = r.width + t.x, a = r.height + t.y, o = this.$element().get(0).style, u = t.x || i || e(o.width), c = t.y || i || e(o.height);
    return u && this.option({
      width: n
    }), c && this.option({
      height: a
    }), {
      width: u ? n : r.width,
      height: c ? a : r.height
    };
  },
  _triggerResizeAction: function(t, e) {
    var {
      width: i,
      height: r
    } = e;
    this._resizeAction({
      event: t,
      width: this.option("width") || i,
      height: this.option("height") || r,
      handles: this._movingSides
    }), Iu(this.$element());
  },
  _isCornerHandler: (t) => Object.values(t).reduce((e, i) => e ^ i, 0) === 0,
  _getOffset: function(t) {
    var e = t.offset, i = this._movingSides;
    return !i.left && !i.right && (e.x = 0), !i.top && !i.bottom && (e.y = 0), e;
  },
  _roundByStep: function(t) {
    return this.option("stepPrecision") === "strict" ? this._roundStrict(t) : this._roundNotStrict(t);
  },
  _getSteps: function() {
    return ej(this.option("step"), !this.option("roundStepValue"));
  },
  _roundNotStrict: function(t) {
    var e = this._getSteps();
    return {
      x: t.x - t.x % e.h,
      y: t.y - t.y % e.v
    };
  },
  _roundStrict: function(t) {
    var e = this._movingSides, i = {
      x: t.x * (e.left ? -1 : 1),
      y: t.y * (e.top ? -1 : 1)
    }, r = this._getSteps(), n = this._elementLocation, a = this._elementSize, o = e.left ? n.left : n.left + a.width, u = e.top ? n.top : n.top + a.height, c = (o + i.x) % r.h, p = (u + i.y) % r.v, v = Math.sign || ((B) => (B = +B, B === 0 || isNaN(B) ? B : B > 0 ? 1 : -1)), _ = (B, $) => (1 + 0.2 * v($)) % 1 * B, y = (B, $) => Math.abs(B) < 0.2 * $, b = i.x - c, I = i.y - p;
    c > _(r.h, i.x) && (b += r.h), p > _(r.v, i.y) && (I += r.v);
    var A = (e.left || e.right) && !y(i.x, r.h) ? b : 0, L = (e.top || e.bottom) && !y(i.y, r.v) ? I : 0;
    return {
      x: A * (e.left ? -1 : 1),
      y: L * (e.top ? -1 : 1)
    };
  },
  _getMovingSides: function(t) {
    var e = E(t.target), i = e.hasClass(uw + "-top-left"), r = e.hasClass(uw + "-top-right"), n = e.hasClass(uw + "-bottom-left"), a = e.hasClass(uw + "-bottom-right");
    return {
      top: e.hasClass(Exe) || i || r,
      left: e.hasClass(wxe) || i || n,
      bottom: e.hasClass(bxe) || n || a,
      right: e.hasClass(Txe) || r || a
    };
  },
  _getArea: function() {
    var t = this.option("area");
    return Le(t) && (t = t.call(this)), $t(t) ? this._getAreaFromObject(t) : this._getAreaFromElement(t);
  },
  _getAreaScrollOffset: function() {
    var t = this.option("area"), e = !Le(t) && !$t(t), i = {
      scrollY: 0,
      scrollX: 0
    };
    if (e) {
      var r = E(t)[0];
      Or(r) && (i.scrollX = r.pageXOffset, i.scrollY = r.pageYOffset);
    }
    return i;
  },
  _getAreaFromObject: function(t) {
    var e = {
      width: t.right - t.left,
      height: t.bottom - t.top,
      offset: {
        left: t.left,
        top: t.top
      }
    };
    return this._correctAreaGeometry(e), e;
  },
  _getAreaFromElement: function(t) {
    var e = E(t), i;
    return e.length && (i = {
      width: Sk(e),
      height: vT(e),
      offset: P({
        top: 0,
        left: 0
      }, Or(e[0]) ? {} : e.offset())
    }, this._correctAreaGeometry(i, e)), i;
  },
  _correctAreaGeometry: function(t, e) {
    var i = e ? this._getBorderWidth(e, "left") : 0, r = e ? this._getBorderWidth(e, "top") : 0;
    t.offset.left += i + this._getBorderWidth(this.$element(), "left"), t.offset.top += r + this._getBorderWidth(this.$element(), "top"), t.width -= oi(this.$element()) - Sk(this.$element()), t.height -= jt(this.$element()) - vT(this.$element());
  },
  _dragEndHandler: function(t) {
    var e = this.$element();
    this._resizeEndAction({
      event: t,
      width: oi(e),
      height: jt(e),
      handles: this._movingSides
    }), this._toggleResizingClass(!1);
  },
  _renderWidth: function(t) {
    this.option("width", ma(t, this.option("minWidth"), this.option("maxWidth")));
  },
  _renderHeight: function(t) {
    this.option("height", ma(t, this.option("minHeight"), this.option("maxHeight")));
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "disabled":
        this._toggleEventHandlers(!t.value), this.callBase(t);
        break;
      case "handles":
        this._invalidate();
        break;
      case "minWidth":
      case "maxWidth":
        wt() && this._renderWidth(oi(this.$element()));
        break;
      case "minHeight":
      case "maxHeight":
        wt() && this._renderHeight(jt(this.$element()));
        break;
      case "onResize":
      case "onResizeStart":
      case "onResizeEnd":
        this._renderActions();
        break;
      case "area":
      case "stepPrecision":
      case "step":
      case "roundStepValue":
      case "keepAspectRatio":
        break;
      default:
        this.callBase(t);
    }
  },
  _clean: function() {
    this.$element().find("." + lw).remove();
  },
  _useTemplates: function() {
    return !1;
  }
});
ti(LI, rX);
var Rxe = ["fullScreen", "forceApplyBindings", "dragOutsideBoundary", "dragAndResizeArea", "outsideDragFactor"], rM = Ot();
class Lxe extends Z6 {
  constructor(e) {
    var {
      fullScreen: i,
      forceApplyBindings: r,
      dragOutsideBoundary: n,
      dragAndResizeArea: a,
      outsideDragFactor: o
    } = e, u = sr(e, Rxe);
    super(u), this._props = ae({}, this._props, {
      fullScreen: i,
      forceApplyBindings: r,
      dragOutsideBoundary: n,
      dragAndResizeArea: a,
      outsideDragFactor: o
    }), this._$dragResizeContainer = void 0, this._updateDragResizeContainer();
  }
  set fullScreen(e) {
    this._props.fullScreen = e, e ? this._fullScreenEnabled() : this._fullScreenDisabled();
  }
  get $dragResizeContainer() {
    return this._$dragResizeContainer;
  }
  get outsideDragFactor() {
    return this._props.dragOutsideBoundary ? 1 : this._props.outsideDragFactor;
  }
  set dragAndResizeArea(e) {
    this._props.dragAndResizeArea = e, this._updateDragResizeContainer();
  }
  set dragOutsideBoundary(e) {
    this._props.dragOutsideBoundary = e, this._updateDragResizeContainer();
  }
  set outsideDragFactor(e) {
    this._props.outsideDragFactor = e;
  }
  updateContainer(e) {
    super.updateContainer(e), this._updateDragResizeContainer();
  }
  dragHandled() {
    this.restorePositionOnNextRender(!1);
  }
  resizeHandled() {
    this.restorePositionOnNextRender(!1);
  }
  positionContent() {
    if (this._props.fullScreen)
      Nn(this._$content, {
        top: 0,
        left: 0
      }), this.detectVisualPositionChange();
    else {
      var e, i;
      (e = (i = this._props).forceApplyBindings) === null || e === void 0 || e.call(i), super.positionContent();
    }
  }
  _updateDragResizeContainer() {
    this._$dragResizeContainer = this._getDragResizeContainer();
  }
  _getDragResizeContainer() {
    if (this._props.dragOutsideBoundary)
      return E(rM);
    if (this._props.dragAndResizeArea)
      return E(this._props.dragAndResizeArea);
    var e = mY().get(0) || this._props.container;
    return e ? this._$markupContainer : E(rM);
  }
  _getVisualContainer() {
    return this._props.fullScreen ? E(rM) : super._getVisualContainer();
  }
  _fullScreenEnabled() {
    this.restorePositionOnNextRender(!1);
  }
  _fullScreenDisabled() {
    this.restorePositionOnNextRender(!0);
  }
}
var Mxe = {
  setOverflow: ee,
  restoreOverflow: ee
}, kxe = () => {
  if (!wt())
    return Mxe;
  var t = Ot(), e = de.getDocument().documentElement, i = de.getBody(), r = Ye.real().platform === "ios", n = {
    overflow: null,
    overflowX: null,
    overflowY: null,
    paddingRight: null,
    position: null,
    top: null,
    left: null
  }, a = () => {
    var u = t.innerWidth - e.clientWidth;
    if (!(n.paddingRight || u <= 0)) {
      var c = t.getComputedStyle(i).getPropertyValue("padding-right"), p = parseInt(c, 10);
      n.paddingRight = p, i.style.setProperty("padding-right", "".concat(p + u, "px"));
    }
  }, o = () => {
    R(n.paddingRight) && (n.paddingRight ? i.style.setProperty("padding-right", "".concat(n.paddingRight, "px")) : i.style.removeProperty("padding-right"), n.paddingRight = null);
  };
  return {
    setOverflow: r ? () => {
      if (!(R(n.position) || i.style.position === "fixed")) {
        var {
          scrollY: u,
          scrollX: c
        } = t;
        n.position = i.style.position, n.top = i.style.top, n.left = i.style.left, i.style.setProperty("position", "fixed"), i.style.setProperty("top", "".concat(-u, "px")), i.style.setProperty("left", "".concat(-c, "px"));
      }
    } : () => {
      a(), !(n.overflow || i.style.overflow === "hidden") && (n.overflow = i.style.overflow, n.overflowX = i.style.overflowX, n.overflowY = i.style.overflowY, i.style.setProperty("overflow", "hidden"));
    },
    restoreOverflow: r ? () => {
      if (R(n.position)) {
        var u = -parseInt(i.style.top, 10), c = -parseInt(i.style.left, 10);
        ["position", "top", "left"].forEach((p) => {
          n[p] ? i.style.setProperty(p, n[p]) : i.style.removeProperty(p);
        }), t.scrollTo(c, u), n.position = null;
      }
    } : () => {
      o(), ["overflow", "overflowX", "overflowY"].forEach((u) => {
        if (R(n[u])) {
          var c = u.replace(/(X)|(Y)/, (p) => "-".concat(p.toLowerCase()));
          n[u] ? i.style.setProperty(c, n[u]) : i.style.removeProperty(c), n[u] = null;
        }
      });
    }
  };
}, Pxe = Ot(), nM = "dx-popup", UG = "dx-popup-wrapper", Fxe = "dx-popup-fullscreen", Bxe = "dx-popup-fullscreen-width", Vxe = "dx-popup-normal", Nxe = "dx-popup-content", Hxe = "dx-popup-content-scrollable", $xe = "dx-state-disabled", zxe = "dx-popup-draggable", GG = "dx-popup-title", Wxe = "dx-closebutton", KG = "dx-popup-bottom", Uxe = "dx-has-close-button", Gxe = "dx-template-wrapper", Kxe = "dx-popup-flex-height", jxe = "dx-popup-inherit-height", Yxe = "dx-toolbar-label", jG = ["cancel", "clear", "done"], qxe = "default", Xxe = "normal", Qxe = "text", YG = "contained", Zxe = "outlined", Jxe = $i.safari && B6($i.version, [11]) < 0, uh = {
  static: "",
  inherit: jxe,
  flex: Kxe
}, eSe = (t) => {
  var e = Ye.current(), i = e.platform, r = "bottom", n = "before";
  if (i === "ios")
    switch (t) {
      case "cancel":
        r = "top";
        break;
      case "clear":
        r = "top", n = "after";
        break;
      case "done":
        n = "after";
    }
  else if (i === "android")
    switch (t) {
      case "cancel":
      case "done":
        n = "after";
    }
  return {
    toolbar: r,
    location: n
  };
}, Hu = Pl.inherit({
  _supportedKeys: function() {
    return P(this.callBase(), {
      upArrow: (t) => {
        var e;
        (e = this._drag) === null || e === void 0 || e.moveUp(t);
      },
      downArrow: (t) => {
        var e;
        (e = this._drag) === null || e === void 0 || e.moveDown(t);
      },
      leftArrow: (t) => {
        var e;
        (e = this._drag) === null || e === void 0 || e.moveLeft(t);
      },
      rightArrow: (t) => {
        var e;
        (e = this._drag) === null || e === void 0 || e.moveRight(t);
      }
    });
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      fullScreen: !1,
      title: "",
      showTitle: !0,
      titleTemplate: "title",
      onTitleRendered: null,
      dragOutsideBoundary: !1,
      dragEnabled: !1,
      dragAndResizeArea: void 0,
      enableBodyScroll: !0,
      outsideDragFactor: 0,
      onResizeStart: null,
      onResize: null,
      onResizeEnd: null,
      resizeEnabled: !1,
      toolbarItems: [],
      showCloseButton: !1,
      bottomTemplate: "bottom",
      useDefaultToolbarButtons: !1,
      useFlatToolbarButtons: !1,
      autoResizeEnabled: !0
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: {
        platform: "ios"
      },
      options: {
        animation: this._iosAnimation
      }
    }, {
      device: {
        platform: "android"
      },
      options: {
        animation: this._androidAnimation
      }
    }, {
      device: {
        platform: "generic"
      },
      options: {
        showCloseButton: !0
      }
    }, {
      device: function(t) {
        return Ye.real().deviceType === "desktop" && t.platform === "generic";
      },
      options: {
        dragEnabled: !0
      }
    }, {
      device: function() {
        return Ye.real().deviceType === "desktop" && !Ye.isSimulator();
      },
      options: {
        focusStateEnabled: !0
      }
    }, {
      device: function() {
        return fs();
      },
      options: {
        useFlatToolbarButtons: !0
      }
    }, {
      device: function() {
        return _a();
      },
      options: {
        useDefaultToolbarButtons: !0,
        showCloseButton: !1
      }
    }]);
  },
  _iosAnimation: {
    show: {
      type: "slide",
      duration: 400,
      from: {
        position: {
          my: "top",
          at: "bottom"
        }
      },
      to: {
        position: {
          my: "center",
          at: "center"
        }
      }
    },
    hide: {
      type: "slide",
      duration: 400,
      from: {
        opacity: 1,
        position: {
          my: "center",
          at: "center"
        }
      },
      to: {
        opacity: 1,
        position: {
          my: "top",
          at: "bottom"
        }
      }
    }
  },
  _androidAnimation: function() {
    return this.option("fullScreen") ? {
      show: {
        type: "slide",
        duration: 300,
        from: {
          top: "30%",
          opacity: 0
        },
        to: {
          top: 0,
          opacity: 1
        }
      },
      hide: {
        type: "slide",
        duration: 300,
        from: {
          top: 0,
          opacity: 1
        },
        to: {
          top: "30%",
          opacity: 0
        }
      }
    } : {
      show: {
        type: "fade",
        duration: 400,
        from: 0,
        to: 1
      },
      hide: {
        type: "fade",
        duration: 400,
        from: 1,
        to: 0
      }
    };
  },
  _init: function() {
    var t = this.option("_wrapperClassExternal"), e = t ? "".concat(UG, " ").concat(t) : UG;
    this.callBase(), this._createBodyOverflowManager(), this._updateResizeCallbackSkipCondition(), this.$element().addClass(nM), this.$wrapper().addClass(e), this._$popupContent = this._$content.wrapInner(E("<div>").addClass(Nxe)).children().eq(0), this._toggleContentScrollClass(), this.$overlayContent().attr("role", "dialog");
  },
  _render: function() {
    var t = this.option("fullScreen");
    this._toggleFullScreenClass(t), this.callBase();
  },
  _createBodyOverflowManager: function() {
    this._bodyOverflowManager = kxe();
  },
  _toggleFullScreenClass: function(t) {
    this.$overlayContent().toggleClass(Fxe, t).toggleClass(Vxe, !t);
  },
  _initTemplates: function() {
    this.callBase(), this._templateManager.addDefaultTemplates({
      title: new yp(),
      bottom: new yp()
    });
  },
  _getActionsList: function() {
    return this.callBase().concat(["onResizeStart", "onResize", "onResizeEnd"]);
  },
  _contentResizeHandler: function(t) {
    this._shouldSkipContentResize(t) || this._renderGeometry({
      shouldOnlyReposition: !0
    });
  },
  _doesShowAnimationChangeDimensions: function() {
    var t = this.option("animation");
    return ["to", "from"].some((e) => {
      var i, r = t == null || (i = t.show) === null || i === void 0 ? void 0 : i[e];
      return ct(r) && ("width" in r || "height" in r);
    });
  },
  _updateResizeCallbackSkipCondition() {
    var t = this._doesShowAnimationChangeDimensions();
    this._shouldSkipContentResize = (e) => t && this._showAnimationProcessing || this._areContentDimensionsRendered(e);
  },
  _observeContentResize: function(t) {
    if (this.option("useResizeObserver")) {
      var e = this._$content.get(0);
      t ? Ep.observe(e, (i) => {
        this._contentResizeHandler(i);
      }) : Ep.unobserve(e);
    }
  },
  _areContentDimensionsRendered: function(t) {
    var e, i, r, n = (e = t.contentBoxSize) === null || e === void 0 ? void 0 : e[0];
    if (n) {
      var a, o;
      return parseInt(n.inlineSize, 10) === ((a = this._renderedDimensions) === null || a === void 0 ? void 0 : a.width) && parseInt(n.blockSize, 10) === ((o = this._renderedDimensions) === null || o === void 0 ? void 0 : o.height);
    }
    var u = t.contentRect;
    return parseInt(u.width, 10) === ((i = this._renderedDimensions) === null || i === void 0 ? void 0 : i.width) && parseInt(u.height, 10) === ((r = this._renderedDimensions) === null || r === void 0 ? void 0 : r.height);
  },
  _renderContent() {
    this.callBase(), this._observeContentResize(!0);
  },
  _renderContentImpl: function() {
    this._renderTitle(), this.callBase(), this._renderResize(), this._renderBottom();
  },
  _renderTitle: function() {
    var t = this._getToolbarItems("top"), {
      title: e,
      showTitle: i
    } = this.option();
    if (i && e && t.unshift({
      location: Ye.current().ios ? "center" : "before",
      text: e
    }), i || t.length > 0) {
      this._$title && this._$title.remove();
      var r = E("<div>").addClass(GG).insertBefore(this.$content());
      this._$title = this._renderTemplateByType("titleTemplate", t, r).addClass(GG), this._renderDrag(), this._executeTitleRenderAction(this._$title), this._$title.toggleClass(Uxe, this._hasCloseButton());
    } else
      this._$title && this._$title.detach();
    this._toggleAriaLabel();
  },
  _toggleAriaLabel() {
    var t, {
      title: e,
      showTitle: i
    } = this.option(), r = i && !!e, n = r ? new yr() : null;
    (t = this._$title) === null || t === void 0 || t.find(".".concat(Yxe)).eq(0).attr("id", n), this.$overlayContent().attr("aria-labelledby", n);
  },
  _renderTemplateByType: function(t, e, i, r) {
    var {
      rtlEnabled: n,
      useDefaultToolbarButtons: a,
      useFlatToolbarButtons: o,
      disabled: u
    } = this.option(), c = this._getTemplateByOption(t), p = c instanceof yp;
    if (p) {
      var v = P({}, this.option("integrationOptions"), {
        skipTemplates: ["content", "title"]
      }), _ = P(r, {
        items: e,
        rtlEnabled: n,
        useDefaultButtons: a,
        useFlatButtons: o,
        disabled: u,
        integrationOptions: v
      });
      this._getTemplate("dx-polymorph-widget").render({
        container: i,
        model: {
          widget: this._getToolbarName(),
          options: _
        }
      });
      var y = i.children("div");
      return i.replaceWith(y), y;
    } else {
      var b = E(c.render({
        container: ot(i)
      }));
      return b.hasClass(Gxe) && (i.replaceWith(b), i = b), i;
    }
  },
  _getToolbarName: function() {
    return "dxToolbarBase";
  },
  _renderVisibilityAnimate: function(t) {
    return this.callBase(t);
  },
  _hide() {
    return this._observeContentResize(!1), this.callBase();
  },
  _executeTitleRenderAction: function(t) {
    this._getTitleRenderAction()({
      titleElement: ot(t)
    });
  },
  _getTitleRenderAction: function() {
    return this._titleRenderAction || this._createTitleRenderAction();
  },
  _createTitleRenderAction: function() {
    return this._titleRenderAction = this._createActionByOption("onTitleRendered", {
      element: this.element(),
      excludeValidators: ["disabled", "readOnly"]
    });
  },
  _getCloseButton: function() {
    return {
      toolbar: "top",
      location: "after",
      template: this._getCloseButtonRenderer()
    };
  },
  _getCloseButtonRenderer: function() {
    return (t, e, i) => {
      var r = E("<div>").addClass(Wxe);
      this._createComponent(r, yn, {
        icon: "close",
        onClick: this._createToolbarItemAction(void 0),
        stylingMode: "text",
        integrationOptions: {}
      }), E(i).append(r);
    };
  },
  _getToolbarItems: function(t) {
    var e = this.option("toolbarItems"), i = [];
    this._toolbarItemClasses = [];
    var r = Ye.current().platform, n = 0;
    return N(e, (a, o) => {
      var u = R(o.shortcut), c = u ? eSe(o.shortcut) : o;
      if (u && r === "ios" && n < 2 && (c.toolbar = "top", n++), c.toolbar = o.toolbar || c.toolbar || "top", c && c.toolbar === t) {
        u && P(c, {
          location: o.location
        }, this._getToolbarItemByAlias(o));
        var p = r === "generic";
        o.shortcut === "done" && p || o.shortcut === "cancel" && !p ? i.unshift(c) : i.push(c);
      }
    }), t === "top" && this._hasCloseButton() && i.push(this._getCloseButton()), i;
  },
  _hasCloseButton() {
    return this.option("showCloseButton") && this.option("showTitle");
  },
  _getLocalizationKey: (t) => t.toLowerCase() === "done" ? "OK" : Ix(t, !0),
  _getToolbarButtonStylingMode: function(t) {
    return za() ? t === "done" ? YG : Zxe : this.option("useFlatToolbarButtons") ? Qxe : YG;
  },
  _getToolbarButtonType: function(t) {
    return za() && t === "done" || this.option("useDefaultToolbarButtons") ? qxe : Xxe;
  },
  _getToolbarItemByAlias: function(t) {
    var e = this, i = t.shortcut;
    if (!jG.includes(i))
      return !1;
    var r = P({
      text: X.format(this._getLocalizationKey(i)),
      onClick: this._createToolbarItemAction(t.onClick),
      integrationOptions: {},
      type: this._getToolbarButtonType(i),
      stylingMode: this._getToolbarButtonStylingMode(i)
    }, t.options || {}), n = nM + "-" + i;
    return this._toolbarItemClasses.push(n), {
      template: function(a, o, u) {
        var c = E("<div>").addClass(n).appendTo(u);
        e._createComponent(c, yn, r);
      }
    };
  },
  _createToolbarItemAction: function(t) {
    return this._createAction(t, {
      afterExecute: function(e) {
        e.component.hide();
      }
    });
  },
  _renderBottom: function() {
    var t = this._getToolbarItems("bottom");
    if (t.length) {
      this._$bottom && this._$bottom.remove();
      var e = E("<div>").addClass(KG).insertAfter(this.$content());
      this._$bottom = this._renderTemplateByType("bottomTemplate", t, e, {
        compactMode: !0
      }).addClass(KG), this._toggleClasses();
    } else
      this._$bottom && this._$bottom.detach();
  },
  _toggleDisabledState: function(t) {
    this.callBase(...arguments), this.$content().toggleClass($xe, !!t);
  },
  _toggleClasses: function() {
    var t = jG;
    N(t, (e, i) => {
      var r = nM + "-" + i;
      this._toolbarItemClasses.includes(r) ? (this.$wrapper().addClass(r + "-visible"), this._$bottom.addClass(r)) : (this.$wrapper().removeClass(r + "-visible"), this._$bottom.removeClass(r));
    });
  },
  _toggleFocusClass(t, e) {
    if (this.callBase(t, e), t && !Ape(this._zIndex)) {
      var i = q6(this._zIndexInitValue());
      SP(this._zIndex), this._zIndex = i, this._$wrapper.css("zIndex", i), this._$content.css("zIndex", i);
    }
  },
  _toggleContentScrollClass() {
    var t = !this.option("preventScrollEvents");
    this.$content().toggleClass(Hxe, t);
  },
  _getPositionControllerConfig() {
    var {
      fullScreen: t,
      forceApplyBindings: e,
      dragOutsideBoundary: i,
      dragAndResizeArea: r,
      outsideDragFactor: n
    } = this.option();
    return P({}, this.callBase(), {
      fullScreen: t,
      forceApplyBindings: e,
      dragOutsideBoundary: i,
      dragAndResizeArea: r,
      outsideDragFactor: n
    });
  },
  _initPositionController() {
    this._positionController = new Lxe(this._getPositionControllerConfig());
  },
  _getDragTarget: function() {
    return this.topToolbar();
  },
  _renderGeometry: function(t) {
    var {
      visible: e,
      useResizeObserver: i
    } = this.option();
    if (e && wt()) {
      var r = this._showAnimationProcessing, n = r && !(t != null && t.forceStopAnimation) && i;
      this._isAnimationPaused = n || void 0, this._stopAnimation(), t != null && t.shouldOnlyReposition ? this._renderPosition(!1) : this._renderGeometryImpl(t == null ? void 0 : t.isDimensionChange), n && (this._animateShowing(), this._isAnimationPaused = void 0);
    }
  },
  _cacheDimensions: function() {
    this.option("useResizeObserver") && (this._renderedDimensions = {
      width: parseInt(mt(this._$content), 10),
      height: parseInt(Pt(this._$content), 10)
    });
  },
  _renderGeometryImpl: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    t || this._resetContentHeight(), this.callBase(), this._cacheDimensions(), this._setContentHeight();
  },
  _resetContentHeight: function() {
    var t = this._getOptionValue("height");
    t === "auto" && this.$content().css({
      height: "auto",
      maxHeight: "none"
    });
  },
  _renderDrag: function() {
    var t = this._getDragTarget(), e = this.option("dragEnabled");
    if (t) {
      var i = {
        dragEnabled: e,
        handle: t.get(0),
        draggableElement: this._$content.get(0),
        positionController: this._positionController
      };
      this._drag ? this._drag.init(i) : this._drag = new yxe(i), this.$overlayContent().toggleClass(zxe, e);
    }
  },
  _renderResize: function() {
    this._resizable = this._createComponent(this._$content, rX, {
      handles: this.option("resizeEnabled") ? "all" : "none",
      onResizeEnd: (t) => {
        this._resizeEndHandler(t), this._observeContentResize(!0);
      },
      onResize: (t) => {
        this._setContentHeight(), this._actions.onResize(t);
      },
      onResizeStart: (t) => {
        this._observeContentResize(!1), this._actions.onResizeStart(t);
      },
      minHeight: 100,
      minWidth: 100,
      area: this._positionController.$dragResizeContainer,
      keepAspectRatio: !1
    });
  },
  _resizeEndHandler: function(t) {
    var e = this._resizable.option("width"), i = this._resizable.option("height");
    e && this._setOptionWithoutOptionChange("width", e), i && this._setOptionWithoutOptionChange("height", i), this._cacheDimensions(), this._positionController.resizeHandled(), this._positionController.detectVisualPositionChange(t.event), this._actions.onResizeEnd(t);
  },
  _setContentHeight: function() {
    (this.option("forceApplyBindings") || ee)();
    var t = this.$overlayContent().get(0), e = this._chooseHeightStrategy(t);
    this.$content().css(this._getHeightCssStyles(e, t)), this._setHeightClasses(this.$overlayContent(), e);
  },
  _heightStrategyChangeOffset: function(t, e) {
    return t === uh.flex ? -e : 0;
  },
  _chooseHeightStrategy: function(t) {
    var e = t.style.width === "auto" || t.style.width === "", i = uh.static;
    return this._isAutoHeight() && this.option("autoResizeEnabled") && (e || Jxe ? i = uh.inherit : i = uh.flex), i;
  },
  _getHeightCssStyles: function(t, e) {
    var i = {}, r = this._getOptionValue("maxHeight", e), n = this._getOptionValue("minHeight", e), a = this._splitPopupHeight(), o = a.header + a.footer + a.contentVerticalOffsets + a.popupVerticalOffsets + this._heightStrategyChangeOffset(t, a.popupVerticalPaddings);
    if (t === uh.static) {
      if (!this._isAutoHeight() || r || n) {
        var u = this.option("fullScreen") ? Math.min(zr(e).height, Ot().innerHeight) : zr(e).height, c = u - o;
        i = {
          height: Math.max(0, c),
          minHeight: "auto",
          maxHeight: "auto"
        };
      }
    } else {
      var p = E(this._positionController.$visualContainer).get(0), v = ore(r, -o, p), _ = sre(n, -o, p);
      i = {
        height: "auto",
        minHeight: _,
        maxHeight: v
      };
    }
    return i;
  },
  _setHeightClasses: function(t, e) {
    var i = "";
    for (var r in uh)
      uh[r] !== e && (i += " " + uh[r]);
    t.removeClass(i).addClass(e);
  },
  _isAutoHeight: function() {
    return this.$overlayContent().get(0).style.height === "auto";
  },
  _splitPopupHeight: function() {
    var t = this.topToolbar(), e = this.bottomToolbar();
    return {
      header: d$(t && t.get(0)),
      footer: d$(e && e.get(0)),
      contentVerticalOffsets: ER(this.$overlayContent().get(0), !0),
      popupVerticalOffsets: ER(this.$content().get(0), !0),
      popupVerticalPaddings: ER(this.$content().get(0), !1)
    };
  },
  _isAllWindowCovered: function() {
    return this.callBase() || this.option("fullScreen");
  },
  _renderDimensions: function() {
    this.option("fullScreen") ? this.$overlayContent().css({
      width: "100%",
      height: "100%",
      minWidth: "",
      maxWidth: "",
      minHeight: "",
      maxHeight: ""
    }) : this.callBase(), wt() && this._renderFullscreenWidthClass();
  },
  _dimensionChanged: function() {
    this._renderGeometry({
      isDimensionChange: !0
    });
  },
  _clean: function() {
    this.callBase(), this._observeContentResize(!1);
  },
  _dispose: function() {
    this.callBase(), this._toggleBodyScroll(!0);
  },
  _renderFullscreenWidthClass: function() {
    this.$overlayContent().toggleClass(Bxe, oi(this.$overlayContent()) === mt(Pxe));
  },
  _toggleSafariScrolling() {
    this.option("enableBodyScroll") && this.callBase();
  },
  _toggleBodyScroll: function(t) {
    if (this._bodyOverflowManager) {
      var {
        setOverflow: e,
        restoreOverflow: i
      } = this._bodyOverflowManager;
      t ? i() : e();
    }
  },
  refreshPosition: function() {
    this._renderPosition();
  },
  _optionChanged: function(t) {
    var e, {
      value: i,
      name: r
    } = t;
    switch (r) {
      case "disabled":
        this.callBase(t), this._renderTitle(), this._renderBottom();
        break;
      case "animation":
        this._updateResizeCallbackSkipCondition();
        break;
      case "enableBodyScroll":
        this.option("visible") && this._toggleBodyScroll(i);
        break;
      case "showTitle":
      case "title":
      case "titleTemplate":
        this._renderTitle(), this._renderGeometry(), Iu(this.$overlayContent());
        break;
      case "bottomTemplate":
        this._renderBottom(), this._renderGeometry(), Iu(this.$overlayContent());
        break;
      case "container":
        if (this.callBase(t), this.option("resizeEnabled")) {
          var n;
          (n = this._resizable) === null || n === void 0 || n.option("area", this._positionController.$dragResizeContainer);
        }
        break;
      case "width":
      case "height":
        this.callBase(t), (e = this._resizable) === null || e === void 0 || e.option(r, i);
        break;
      case "onTitleRendered":
        this._createTitleRenderAction(i);
        break;
      case "toolbarItems":
      case "useDefaultToolbarButtons":
      case "useFlatToolbarButtons":
        var a = !t.fullName.match(/^toolbarItems((\[\d+\])(\.(options|visible).*)?)?$/);
        this._renderTitle(), this._renderBottom(), a && (this._renderGeometry(), Iu(this.$overlayContent()));
        break;
      case "dragEnabled":
        this._renderDrag();
        break;
      case "dragAndResizeArea":
        this._positionController.dragAndResizeArea = i, this.option("resizeEnabled") && this._resizable.option("area", this._positionController.$dragResizeContainer), this._positionController.positionContent();
        break;
      case "dragOutsideBoundary":
        this._positionController.dragOutsideBoundary = i, this.option("resizeEnabled") && this._resizable.option("area", this._positionController.$dragResizeContainer);
        break;
      case "outsideDragFactor":
        this._positionController.outsideDragFactor = i;
        break;
      case "resizeEnabled":
        this._renderResize(), this._renderGeometry();
        break;
      case "autoResizeEnabled":
        this._renderGeometry(), Iu(this.$overlayContent());
        break;
      case "fullScreen":
        this._positionController.fullScreen = i, this._toggleFullScreenClass(i), this._toggleSafariScrolling(), this._renderGeometry(), Iu(this.$overlayContent());
        break;
      case "showCloseButton":
        this._renderTitle();
        break;
      case "preventScrollEvents":
        this.callBase(t), this._toggleContentScrollClass();
        break;
      default:
        this.callBase(t);
    }
  },
  bottomToolbar: function() {
    return this._$bottom;
  },
  topToolbar: function() {
    return this._$title;
  },
  $content: function() {
    return this._$popupContent;
  },
  content: function() {
    return ot(this.$content());
  },
  $overlayContent: function() {
    return this._$content;
  },
  getFocusableElements: function() {
    return this.$wrapper().find("[tabindex]").filter((t, e) => e.getAttribute("tabindex") >= 0);
  }
});
ti("dxPopup", Hu);
class BB extends Hu {
  _getDefaultOptions() {
    return P(super._getDefaultOptions(), {
      preventScrollEvents: !1
    });
  }
  _getToolbarName() {
    return "dxToolbar";
  }
}
BB.defaultOptions = function(t) {
  Hu.defaultOptions(t);
};
ti("dxPopup", BB);
var tSe = "dx-dropdownmenu", iSe = "dx-dropdownmenu-popup", rSe = "dx-dropdownmenu-popup-wrapper", nSe = "dx-dropdownmenu-list", aSe = "dx-dropdownmenu-button", oSe = 10, qG = 3;
class sSe extends xn {
  _supportedKeys() {
    var e = {};
    return (!this.option("opened") || !this._list.option("focusedElement")) && (e = this._button._supportedKeys()), P(super._supportedKeys(), e, {
      tab: function() {
        this._popup && this._popup.hide();
      }
    });
  }
  _getDefaultOptions() {
    return P(super._getDefaultOptions(), {
      items: [],
      onItemClick: null,
      dataSource: null,
      itemTemplate: "item",
      onButtonClick: null,
      activeStateEnabled: !0,
      hoverStateEnabled: !0,
      opened: !1,
      onItemRendered: null,
      closeOnClick: !0,
      useInkRipple: !1,
      container: void 0,
      animation: {
        show: {
          type: "fade",
          from: 0,
          to: 1
        },
        hide: {
          type: "fade",
          to: 0
        }
      }
    });
  }
  _defaultOptionsRules() {
    return super._defaultOptionsRules().concat([{
      device: function() {
        return Ye.real().deviceType === "desktop" && !Ye.isSimulator();
      },
      options: {
        focusStateEnabled: !0
      }
    }, {
      device: function() {
        return fs();
      },
      options: {
        useInkRipple: !0,
        animation: {
          show: {
            type: "pop",
            duration: 200,
            from: {
              scale: 0
            },
            to: {
              scale: 1
            }
          },
          hide: {
            type: "pop",
            duration: 200,
            from: {
              scale: 1
            },
            to: {
              scale: 0
            }
          }
        }
      }
    }]);
  }
  _init() {
    super._init(), this.$element().addClass(tSe), this._initItemClickAction(), this._initButtonClickAction();
  }
  _initItemClickAction() {
    this._itemClickAction = this._createActionByOption("onItemClick");
  }
  _initButtonClickAction() {
    this._buttonClickAction = this._createActionByOption("onButtonClick");
  }
  _initTemplates() {
    this._templateManager.addDefaultTemplates({
      content: new MF("content")
    }), super._initTemplates();
  }
  _initMarkup() {
    this._renderButton(), super._initMarkup();
  }
  _render() {
    super._render(), this.setAria({
      haspopup: !0,
      expanded: this.option("opened")
    });
  }
  _renderContentImpl() {
    this.option("opened") && this._renderPopup();
  }
  _clean() {
    this._cleanFocusState(), this._list && this._list.$element().remove(), this._popup && this._popup.$element().remove(), delete this._list, delete this._popup;
  }
  _renderButton() {
    var e = this.$element().addClass(aSe);
    this._button = this._createComponent(e, yn, {
      icon: "overflow",
      template: "content",
      stylingMode: za() ? "text" : "contained",
      useInkRipple: this.option("useInkRipple"),
      hoverStateEnabled: !1,
      focusStateEnabled: !1,
      onClick: (i) => {
        this.option("opened", !this.option("opened")), this._buttonClickAction(i);
      }
    });
  }
  _toggleActiveState(e, i, r) {
    this._button._toggleActiveState(e, i, r);
  }
  _toggleMenuVisibility(e) {
    var i = e ?? !this._popup.option("visible");
    e && this._renderPopup(), this._popup.toggle(i), this.setAria("expanded", i);
  }
  _renderPopup() {
    if (!this._$popup) {
      this._$popup = E("<div>").appendTo(this.$element());
      var {
        rtlEnabled: e,
        container: i,
        animation: r
      } = this.option();
      this._popup = this._createComponent(this._$popup, "dxPopup", {
        onInitialized(n) {
          var {
            component: a
          } = n;
          a.$wrapper().addClass(rSe).addClass(iSe);
        },
        deferRendering: !1,
        contentTemplate: (n) => this._renderList(n),
        _ignoreFunctionValueDeprecation: !0,
        maxHeight: () => this._getMaxHeight(),
        position: {
          my: "top ".concat(e ? "left" : "right"),
          at: "bottom ".concat(e ? "left" : "right"),
          collision: "fit flip",
          offset: {
            v: qG
          },
          of: this.$element()
        },
        animation: r,
        onOptionChanged: (n) => {
          var {
            name: a,
            value: o
          } = n;
          a === "visible" && this.option("opened", o);
        },
        container: i,
        autoResizeEnabled: !1,
        height: "auto",
        width: "auto",
        hideOnOutsideClick: (n) => this._closeOutsideDropDownHandler(n),
        hideOnParentScroll: !0,
        shading: !1,
        dragEnabled: !1,
        showTitle: !1,
        fullScreen: !1,
        _fixWrapperPosition: !0
      });
    }
  }
  _getMaxHeight() {
    var e = this.$element(), i = e.offset().top, r = jt(Ot()), n = Math.max(i, r - i - jt(e));
    return Math.min(r, n - qG - oSe);
  }
  _closeOutsideDropDownHandler(e) {
    var i = !E(e.target).closest(this.$element()).length;
    return i;
  }
  _renderList(e) {
    var i = E(e);
    i.addClass(nSe), this._list = this._createComponent(i, Cxe, {
      dataSource: this._getListDataSource(),
      pageLoadMode: "scrollBottom",
      indicateLoading: !1,
      noDataText: "",
      itemTemplate: this.option("itemTemplate"),
      onItemClick: (r) => {
        this.option("closeOnClick") && this.option("opened", !1), this._itemClickAction(r);
      },
      tabIndex: -1,
      focusStateEnabled: !1,
      activeStateEnabled: !0,
      onItemRendered: this.option("onItemRendered"),
      _itemAttributes: {
        role: "menuitem"
      }
    });
  }
  _itemOptionChanged(e, i, r) {
    var n;
    (n = this._list) === null || n === void 0 || n._itemOptionChanged(e, i, r), HT(this._list, e);
  }
  _getListDataSource() {
    var e;
    return (e = this.option("dataSource")) !== null && e !== void 0 ? e : this.option("items");
  }
  _setListDataSource() {
    var e;
    (e = this._list) === null || e === void 0 || e.option("dataSource", this._getListDataSource()), delete this._deferRendering;
  }
  _getKeyboardListeners() {
    return super._getKeyboardListeners().concat([this._list]);
  }
  _toggleVisibility(e) {
    super._toggleVisibility(e), this._button.option("visible", e);
  }
  _optionChanged(e) {
    var i, r, n, {
      name: a,
      value: o
    } = e;
    switch (a) {
      case "items":
      case "dataSource":
        this.option("opened") ? this._setListDataSource() : this._deferRendering = !0;
        break;
      case "itemTemplate":
        (i = this._list) === null || i === void 0 || i.option(a, this._getTemplate(o));
        break;
      case "onItemClick":
        this._initItemClickAction();
        break;
      case "onButtonClick":
        this._buttonClickAction();
        break;
      case "useInkRipple":
        this._invalidate();
        break;
      case "focusStateEnabled":
        (r = this._list) === null || r === void 0 || r.option(a, o), super._optionChanged(e);
        break;
      case "onItemRendered":
        (n = this._list) === null || n === void 0 || n.option(a, o);
        break;
      case "opened":
        this._deferRendering && this._setListDataSource(), this._toggleMenuVisibility(o), this._updateFocusableItemsTabIndex();
        break;
      case "closeOnClick":
        break;
      case "container":
        this._popup && this._popup.option(a, o);
        break;
      case "disabled":
        this._list && this._updateFocusableItemsTabIndex();
        break;
      default:
        super._optionChanged(e);
    }
  }
  _updateFocusableItemsTabIndex() {
    this.option("items").forEach((e) => HT(this._list, e));
  }
}
var XG = "dx-state-invisible", lSe = "dx-toolbar-menu-container", uSe = "dx-toolbar-button", dw = "dx-toolbar-item-auto-hide", aM = "dx-toolbar-item-invisible";
class dSe {
  constructor(e) {
    this._toolbar = e;
  }
  _initMarkup() {
    dn(() => {
      this._renderOverflowMenu(), this._renderMenuItems();
    });
  }
  _renderOverflowMenu() {
    if (this._hasVisibleMenuItems()) {
      this._renderMenuButtonContainer();
      var e = E("<div>").appendTo(this._overflowMenuContainer()), i = this._toolbar._createActionByOption("onItemClick"), r = this._toolbar._getTemplateByOption("menuItemTemplate");
      this._menu = this._toolbar._createComponent(e, sSe, {
        disabled: this._toolbar.option("disabled"),
        itemTemplate: () => r,
        onItemClick: (n) => {
          i(n);
        },
        container: this._toolbar.option("menuContainer"),
        onOptionChanged: (n) => {
          var {
            name: a,
            value: o
          } = n;
          a === "opened" && this._toolbar.option("overflowMenuVisible", o), a === "items" && this._updateMenuVisibility(o);
        }
      });
    }
  }
  renderMenuItems() {
    this._menu || this._renderOverflowMenu(), this._menu && this._menu.option("items", this._getMenuItems()), this._menu && !this._menu.option("items").length && this._menu.option("opened", !1);
  }
  _renderMenuButtonContainer() {
    this._$overflowMenuContainer = E("<div>").appendTo(this._toolbar._$afterSection).addClass(uSe).addClass(lSe);
  }
  _overflowMenuContainer() {
    return this._$overflowMenuContainer;
  }
  _updateMenuVisibility(e) {
    var i = e ?? this._getMenuItems(), r = i.length && this._hasVisibleMenuItems(i);
    this._toggleMenuVisibility(r);
  }
  _toggleMenuVisibility(e) {
    this._overflowMenuContainer() && this._overflowMenuContainer().toggleClass(XG, !e);
  }
  _renderMenuItems() {
    dn(() => {
      this.renderMenuItems();
    });
  }
  _dimensionChanged() {
    this.renderMenuItems();
  }
  _getToolbarItems() {
    var e;
    return so((e = this._toolbar.option("items")) !== null && e !== void 0 ? e : [], (i) => !this._toolbar._isMenuItem(i));
  }
  _getHiddenItems() {
    return this._toolbar._itemContainer().children(".".concat(dw, ".").concat(aM)).not(".".concat(XG));
  }
  _getMenuItems() {
    var e, i, r = so((e = this._toolbar.option("items")) !== null && e !== void 0 ? e : [], (o) => this._toolbar._isMenuItem(o)), n = this._getHiddenItems();
    this._restoreItems = (i = this._restoreItems) !== null && i !== void 0 ? i : [];
    var a = [].slice.call(n).map((o) => {
      var u = this._toolbar._getItemData(o), c = E(o), p = c.children();
      return P({
        menuItemTemplate: () => {
          this._restoreItems.push({
            container: c,
            item: p
          });
          var v = E("<div>").addClass(dw);
          return v.append(p);
        }
      }, u);
    });
    return [...a, ...r];
  }
  _hasVisibleMenuItems(e) {
    var i = e ?? this._toolbar.option("items"), r = !1, n = Ii("visible"), a = Ii("locateInMenu");
    return N(i, function(o, u) {
      var c = n(u, {
        functionsAsIs: !0
      }), p = a(u, {
        functionsAsIs: !0
      });
      (c !== !1 && (p === "auto" || p === "always") || u.location === "menu") && (r = !0);
    }), r;
  }
  _arrangeItems() {
    var e;
    this._toolbar._$centerSection.css({
      margin: "0 auto",
      float: "none"
    }), N((e = this._restoreItems) !== null && e !== void 0 ? e : [], function(r, n) {
      E(n.container).append(n.item);
    }), this._restoreItems = [];
    var i = mt(this._toolbar.$element());
    return this._hideOverflowItems(i), i;
  }
  _hideOverflowItems(e) {
    var i, r = this._toolbar.$element().find(".".concat(dw));
    if (r.length) {
      e = (i = e) !== null && i !== void 0 ? i : mt(this._toolbar.$element()), E(r).removeClass(aM);
      for (var n = this._getItemsWidth(); r.length && e < n; ) {
        var a = r.eq(-1);
        a.addClass(aM), n = this._getItemsWidth(), r.splice(-1, 1);
      }
    }
  }
  _getItemsWidth() {
    return this._toolbar._getSummaryItemsSize("width", [this._toolbar._$beforeSection, this._toolbar._$centerSection, this._toolbar._$afterSection]);
  }
  _itemOptionChanged(e, i, r) {
    if ((i === "disabled" || i === "options.disabled") && this._toolbar._isMenuItem(e)) {
      var n;
      (n = this._menu) === null || n === void 0 || n._itemOptionChanged(e, i, r);
      return;
    }
    this.renderMenuItems();
  }
  _renderItem(e, i) {
    e.locateInMenu === "auto" && i.addClass(dw);
  }
  _optionChanged(e, i) {
    var r, n, a, o, u;
    switch (e) {
      case "disabled":
        (r = this._menu) === null || r === void 0 || r.option(e, i);
        break;
      case "overflowMenuVisible":
        (n = this._menu) === null || n === void 0 || n.option("opened", i);
        break;
      case "onItemClick":
        (a = this._menu) === null || a === void 0 || a.option(e, i);
        break;
      case "menuContainer":
        (o = this._menu) === null || o === void 0 || o.option("container", i);
        break;
      case "menuItemTemplate":
        (u = this._menu) === null || u === void 0 || u.option("itemTemplate", i);
    }
  }
}
var cSe = "dx-toolbar-multiline", hSe = "dx-toolbar-text-auto-hide";
let nX = class extends eX {
  _getDefaultOptions() {
    return P(super._getDefaultOptions(), {
      menuItemTemplate: "menuItem",
      menuContainer: void 0,
      overflowMenuVisible: !1,
      multiline: !1
    });
  }
  _isMultiline() {
    return this.option("multiline");
  }
  _dimensionChanged(e) {
    e !== "height" && (super._dimensionChanged(), this._layoutStrategy._dimensionChanged());
  }
  _initMarkup() {
    super._initMarkup(), this._updateFocusableItemsTabIndex(), this._layoutStrategy._initMarkup();
  }
  _renderToolbar() {
    super._renderToolbar(), this._renderLayoutStrategy();
  }
  _itemContainer() {
    return this._isMultiline() ? this._$toolbarItemsContainer : super._itemContainer();
  }
  _renderLayoutStrategy() {
    this.$element().toggleClass(cSe, this._isMultiline()), this._layoutStrategy = this._isMultiline() ? new vye(this) : new dSe(this);
  }
  _renderSections() {
    if (!this._isMultiline())
      return super._renderSections();
  }
  _postProcessRenderItems() {
    this._layoutStrategy._hideOverflowItems(), this._layoutStrategy._updateMenuVisibility(), super._postProcessRenderItems(), this._layoutStrategy._renderMenuItems();
  }
  _renderItem(e, i, r, n) {
    var a = super._renderItem(e, i, r, n);
    this._layoutStrategy._renderItem(i, a);
    var {
      widget: o,
      showText: u
    } = i;
    return o === "dxButton" && u === "inMenu" && a.toggleClass(hSe), a;
  }
  _getItemsWidth() {
    return this._layoutStrategy._getItemsWidth();
  }
  _getMenuItems() {
    return this._layoutStrategy._getMenuItems();
  }
  _getToolbarItems() {
    return this._layoutStrategy._getToolbarItems();
  }
  _arrangeItems() {
    if (!this.$element().is(":hidden")) {
      var e = this._layoutStrategy._arrangeItems();
      this._isMultiline() || super._arrangeItems(e);
    }
  }
  _itemOptionChanged(e, i, r) {
    this._isMenuItem(e) || super._itemOptionChanged(e, i, r), this._layoutStrategy._itemOptionChanged(e, i, r), (i === "disabled" || i === "options.disabled") && HT(this, e), i === "location" && this.repaint();
  }
  _updateFocusableItemsTabIndex() {
    this._getToolbarItems().forEach((e) => HT(this, e));
  }
  _isMenuItem(e) {
    return e.location === "menu" || e.locateInMenu === "always";
  }
  _isToolbarItem(e) {
    return e.location === void 0 || e.locateInMenu === "never";
  }
  _optionChanged(e) {
    var {
      name: i,
      value: r
    } = e;
    switch (this._layoutStrategy._optionChanged(i, r), i) {
      case "menuContainer":
      case "menuItemTemplate":
      case "overflowMenuVisible":
        break;
      case "multiline":
        this._invalidate();
        break;
      case "disabled":
        super._optionChanged.apply(this, arguments), this._updateFocusableItemsTabIndex();
        break;
      default:
        super._optionChanged.apply(this, arguments);
    }
  }
  updateDimensions() {
    this._dimensionChanged();
  }
};
ti("dxToolbar", nX);
var fSe = "header-panel", QG = "toolbar-button", pSe = "-ariaToolbar", ZG = ["addRowButton", "applyFilterButton", "columnChooserButton", "exportButton", "groupPanel", "revertButton", "saveButton", "searchPanel"];
let vSe = class extends SS {
  init() {
    super.init(), this._editingController = this.getController("editing"), this._headerFilterController = this.getController("headerFilter"), this.createAction("onToolbarPreparing", {
      excludeValidators: ["disabled", "readOnly"]
    });
  }
  _getToolbarItems() {
    return [];
  }
  _getButtonContainer() {
    return E("<div>").addClass(this.addWidgetPrefix(QG));
  }
  _getToolbarButtonClass(e) {
    var i = e ? " ".concat(e) : "";
    return this.addWidgetPrefix(QG) + i;
  }
  _getToolbarOptions() {
    var e = this.option("toolbar"), i = {
      toolbarOptions: {
        items: this._getToolbarItems(),
        visible: e == null ? void 0 : e.visible,
        disabled: e == null ? void 0 : e.disabled,
        onItemRendered(a) {
          var o = a.itemData.onItemRendered;
          o && o(a);
        }
      }
    }, r = e == null ? void 0 : e.items;
    if (i.toolbarOptions.items = this._normalizeToolbarItems(i.toolbarOptions.items, r), this.executeAction("onToolbarPreparing", i), i.toolbarOptions && !R(i.toolbarOptions.visible)) {
      var n = i.toolbarOptions.items;
      i.toolbarOptions.visible = !!(n != null && n.length);
    }
    return i.toolbarOptions;
  }
  _normalizeToolbarItems(e, i) {
    e.forEach((u) => {
      if (!ZG.includes(u.name))
        throw new Error("Default toolbar item '".concat(u.name, "' is not added to DEFAULT_TOOLBAR_ITEM_NAMES"));
    });
    var r = {
      location: "after"
    }, n = Array.isArray(i);
    if (!R(i))
      return e;
    n || (i = [i]);
    var a = {};
    e.forEach((u) => {
      a[u.name] = u;
    });
    var o = i.map((u) => (ht(u) && (u = {
      name: u
    }), R(u.name) && (R(a[u.name]) ? u = P(!0, {}, a[u.name], u) : ZG.includes(u.name) && (u = ae(ae({}, u), {
      visible: !1
    }))), P(!0, {}, r, u)));
    return n ? o : o[0];
  }
  _renderCore() {
    if (this._toolbar)
      this._toolbar.option(this._toolbarOptions);
    else {
      var e = this.element();
      e.addClass(this.addWidgetPrefix(fSe));
      var i = X.format(this.component.NAME + pSe), r = E("<div>").attr("aria-label", i).appendTo(e);
      this._toolbar = this._createComponent(r, nX, this._toolbarOptions);
    }
  }
  _columnOptionChanged() {
  }
  _handleDataChanged() {
    this._requireReady && this.render();
  }
  _isDisabledDefinedByUser(e) {
    var i, r = (i = this.option("toolbar")) === null || i === void 0 ? void 0 : i.items, n = r == null ? void 0 : r.find((a) => (a == null ? void 0 : a.name) === e);
    return R(n == null ? void 0 : n.disabled);
  }
  render() {
    this._toolbarOptions = this._getToolbarOptions(), super.render.apply(this, arguments);
  }
  setToolbarItemDisabled(e, i) {
    var r, n = this._toolbar, a = this._isDisabledDefinedByUser(e);
    if (!(!n || a)) {
      var o = (r = n.option("items")) !== null && r !== void 0 ? r : [], u = o.findIndex((p) => p.name === e);
      if (!(u < 0)) {
        var c = n.option("items[".concat(u, "]"));
        n.option("items[".concat(u, "].disabled"), i), c.options && n.option("items[".concat(u, "].options.disabled"), i);
      }
    }
  }
  updateToolbarDimensions() {
    var e;
    (e = this._toolbar) === null || e === void 0 || e.updateDimensions();
  }
  getHeaderPanel() {
    return this.element();
  }
  getHeight() {
    return this.getElementHeight();
  }
  optionChanged(e) {
    if (e.name === "onToolbarPreparing" && (this._invalidate(), e.handled = !0), e.name === "toolbar" && (e.handled = !0, this._toolbar)) {
      var i = Vp(e.fullName), r = e.fullName.replace(/^toolbar\./, "");
      if (i.length === 1) {
        var n = this._getToolbarOptions();
        this._toolbar.option(n);
      } else if (i[1] === "items")
        if (i.length === 2) {
          var a = this._getToolbarOptions();
          this._toolbar.option("items", a.items);
        } else if (i.length === 3) {
          var o = this._normalizeToolbarItems(this._getToolbarItems(), e.value);
          this._toolbar.option(r, o);
        } else
          i.length >= 4 && this._toolbar.option(r, e.value);
      else
        this._toolbar.option(r, e.value);
    }
    super.optionChanged(e);
  }
  isVisible() {
    return !!(this._toolbarOptions && this._toolbarOptions.visible);
  }
  allowDragging() {
  }
  hasGroupedColumns() {
  }
};
var gSe = (t) => class extends t {
  _updateDimensionsCore() {
    super._updateDimensionsCore.apply(this, arguments), this.getView("headerPanel").updateToolbarDimensions();
  }
}, aX = {
  defaultOptions: () => ({}),
  views: {
    headerPanel: vSe
  },
  extenders: {
    controllers: {
      resizing: gSe
    }
  }
}, HVe = aX.views.headerPanel;
et.registerModule("headerPanel", aX);
var mSe = ".dx-row", _Se = "Specifying grid templates with the jQuery selector name is now deprecated. Use the DOM Node or the jQuery object that references this selector instead.";
et.registerModulesOrder(["stateStoring", "columns", "selection", "editorFactory", "columnChooser", "grouping", "editing", "editingRowBased", "editingFormBased", "editingCellBased", "masterDetail", "validating", "adaptivity", "data", "virtualScrolling", "columnHeaders", "filterRow", "headerPanel", "headerFilter", "sorting", "search", "rows", "pager", "columnsResizingReordering", "contextMenu", "keyboardNavigation", "errorHandling", "summary", "columnFixing", "export", "gridView"]);
var VB = xn.inherit({
  _activeStateUnit: mSe,
  _getDefaultOptions() {
    var t = this.callBase();
    return N(et.modules, function() {
      Le(this.defaultOptions) && P(!0, t, this.defaultOptions());
    }), t;
  },
  _setDeprecatedOptions() {
    this.callBase(), P(this._deprecatedOptions, {
      useKeyboard: {
        since: "19.2",
        alias: "keyboardNavigation.enabled"
      },
      rowTemplate: {
        since: "21.2",
        message: 'Use the "dataRowTemplate" option instead'
      },
      "columnChooser.allowSearch": {
        since: "23.1",
        message: 'Use the "columnChooser.search.enabled" option instead'
      },
      "columnChooser.searchTimeout": {
        since: "23.1",
        message: 'Use the "columnChooser.search.timeout" option instead'
      }
    });
  },
  _defaultOptionsRules() {
    return this.callBase().concat([{
      device: {
        platform: "ios"
      },
      options: {
        showRowLines: !0
      }
    }, {
      device: () => fs(),
      options: {
        showRowLines: !0,
        showColumnLines: !1,
        headerFilter: {
          height: 315
        },
        editing: {
          useIcons: !0
        },
        selection: {
          showCheckBoxesMode: "always"
        }
      }
    }, {
      device: () => $i.webkit,
      options: {
        loadingTimeout: 30,
        loadPanel: {
          animation: {
            show: {
              easing: "cubic-bezier(1, 0, 1, 0)",
              duration: 500,
              from: {
                opacity: 0
              },
              to: {
                opacity: 1
              }
            }
          }
        }
      }
    }, {
      device: (t) => t.deviceType !== "desktop",
      options: {
        grouping: {
          expandMode: "rowClick"
        }
      }
    }]);
  },
  _init() {
    this.callBase(), xe.logHeaderFilterDeprecatedWarningIfNeed(this), et.processModules(this, et), et.callModuleItemsMethod(this, "init");
  },
  _clean: ee,
  _optionChanged(t) {
    et.callModuleItemsMethod(this, "optionChanged", [t]), t.handled || this.callBase(t);
  },
  _dimensionChanged() {
    this.updateDimensions(!0);
  },
  _visibilityChanged(t) {
    t && this.updateDimensions();
  },
  _initMarkup() {
    this.callBase.apply(this, arguments), this.getView("gridView").render(this.$element());
  },
  _renderContentImpl() {
    this.getView("gridView").update();
  },
  _renderContent() {
    var t = this;
    dn(() => {
      t._renderContentImpl();
    });
  },
  _getTemplate(t) {
    var e = t;
    return ht(e) && e.startsWith("#") && (e = E(t), eI.warn(_Se)), this.callBase(e);
  },
  _dispose() {
    this.callBase(), et.callModuleItemsMethod(this, "dispose");
  },
  isReady() {
    return this.getController("data").isReady();
  },
  beginUpdate() {
    this.callBase(), et.callModuleItemsMethod(this, "beginUpdate");
  },
  endUpdate() {
    et.callModuleItemsMethod(this, "endUpdate"), this.callBase();
  },
  getController(t) {
    return this._controllers[t];
  },
  getView(t) {
    return this._views[t];
  },
  focus(t) {
    this.getController("keyboardNavigation").focus(t);
  }
});
VB.registerModule = et.registerModule.bind(et);
ti("dxDataGrid", VB);
var CSe = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/, ySe = function t(e) {
  e && N(e, (i, r) => {
    if ($t(r) || Array.isArray(r))
      t(r);
    else if (typeof r == "string") {
      var n = CSe.exec(r);
      n && (e[i] = new Date(Date.UTC(+n[1], +n[2] - 1, +n[3], +n[4], +n[5], +n[6])));
    }
  });
}, JG = function(t) {
  var e = t.type === "sessionStorage" ? vY() : Ot().localStorage;
  if (!e)
    throw new Error("E1007");
  return e;
}, e4 = function(t) {
  return R(t.storageKey) ? t.storageKey : "storage";
};
class xSe extends Bi.ViewController {
  get _dataController() {
    return this.getController("data");
  }
  get _exportController() {
    return this.getController("export");
  }
  get _columnsController() {
    return this.getController("columns");
  }
  init() {
    return this._state = {}, this._isLoaded = !1, this._isLoading = !1, this._windowUnloadHandler = () => {
      this._savingTimeoutID !== void 0 && this._saveState(this.state());
    }, k.on(Ot(), "unload", this._windowUnloadHandler), this;
  }
  optionChanged(e) {
    switch (e.name) {
      case "stateStoring":
        this.isEnabled() && !this.isLoading() && this.load(), e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
  dispose() {
    clearTimeout(this._savingTimeoutID), k.off(Ot(), "unload", this._windowUnloadHandler);
  }
  _loadState() {
    var e = this.option("stateStoring");
    if (e.type === "custom")
      return e.customLoad && e.customLoad();
    try {
      return JSON.parse(JG(e).getItem(e4(e)));
    } catch (i) {
      Yt.log("W1022", "State storing", i.message);
    }
  }
  _saveState(e) {
    var i = this.option("stateStoring");
    if (i.type === "custom") {
      i.customSave && i.customSave(e);
      return;
    }
    try {
      JG(i).setItem(e4(i), JSON.stringify(e));
    } catch (r) {
      Yt.log(r.message);
    }
  }
  publicMethods() {
    return ["state"];
  }
  isEnabled() {
    return this.option("stateStoring.enabled");
  }
  isLoaded() {
    return this._isLoaded;
  }
  isLoading() {
    return this._isLoading;
  }
  load() {
    this._isLoading = !0;
    var e = Pn(this._loadState());
    return e.always(() => {
      this._isLoaded = !0, this._isLoading = !1;
    }).done((i) => {
      i !== null && !uo(i) && this.state(i);
    }), e;
  }
  state(e) {
    if (!arguments.length)
      return P(!0, {}, this._state);
    this._state = P({}, e), ySe(this._state);
  }
  save() {
    var e = this;
    clearTimeout(e._savingTimeoutID), e._savingTimeoutID = setTimeout(() => {
      e._saveState(e.state()), e._savingTimeoutID = void 0;
    }, e.option("stateStoring.savingTimeout"));
  }
}
var SSe = (t) => {
  var e = t.getView("pagerView"), i = t.getController("data"), r = {
    allowedPageSizes: e ? e.getPageSizes() : void 0,
    filterPanel: {
      filterEnabled: t.option("filterPanel.filterEnabled")
    },
    filterValue: t.option("filterValue"),
    focusedRowKey: t.option("focusedRowEnabled") ? t.option("focusedRowKey") : void 0
  };
  return P(r, i.getUserState());
}, ESe = (t) => {
  var e = t.getController("columns"), i = t.getController("selection"), r = t.getController("export"), n = t.getController("data");
  e && e.columnsChanged.add(() => {
    t.updateState({
      columns: e.getUserState()
    });
  }), i && i.selectionChanged.add((a) => {
    t.updateState({
      selectedRowKeys: a.selectedRowKeys,
      selectionFilter: a.selectionFilter
    });
  }), n && (t._initialPageSize = t.option("paging.pageSize"), t._initialFilterValue = t.option("filterValue"), n.changed.add(() => {
    var a = SSe(t);
    t.updateState(a);
  })), r && r.selectionOnlyChanged.add(() => {
    t.updateState({
      exportSelectionOnly: r.selectionOnly()
    });
  });
}, bSe = null, wSe = (t, e) => {
  var i = t.getController("filterSync"), r = t.getController("columns"), n = e.columns || e.filterValue !== void 0;
  return i ? n ? e.filterValue || i.getFilterValueFromColumns(e.columns) : t._initialFilterValue || i.getFilterValueFromColumns(r.getColumns()) : bSe;
}, TSe = (t) => class extends t {
  init() {
    super.init(), this._dataController.stateLoaded.add(() => {
      if (this._dataController.isLoaded() && !this._dataController.getDataSource()) {
        this.setLoading(!1), this.renderNoDataText();
        var e = this.component.getView("columnHeadersView");
        e && e.render(), this.component._fireContentReadyAction();
      }
    });
  }
}, ISe = (t) => class extends t {
  init() {
    return super.init.apply(this, arguments), ESe(this), this;
  }
  isLoading() {
    return super.isLoading() || this._dataController.isStateLoading();
  }
  state(e) {
    var i = super.state.apply(this, arguments);
    return e !== void 0 && this.applyState(P(!0, {}, e)), i;
  }
  updateState(e) {
    if (this.isEnabled()) {
      var i = this.state(), r = P({}, i, e), n = ku(i), a = ku(r);
      Mi(n, a) || (e = P(!0, {}, e), P(this._state, e), this.save());
    } else
      P(this._state, e);
  }
  applyState(e) {
    var i, {
      allowedPageSizes: r
    } = e, {
      searchText: n
    } = e, {
      selectedRowKeys: a
    } = e, {
      selectionFilter: o
    } = e, u = this.option("scrolling.mode"), c = u === "virtual" || u === "infinite", p = this.option("pager.visible") === !0 && this.option("pager.showPageSizeSelector"), v = (i = this.getView("rowsView")) === null || i === void 0 ? void 0 : i.hasHeight();
    this.component.beginUpdate(), this._columnsController && this._columnsController.setUserState(e.columns), this._exportController && this._exportController.selectionOnly(e.exportSelectionOnly), this.option("selection.deferred") || this.option("selectedRowKeys", a || []), this.option("selectionFilter", o), r && this.option("pager.allowedPageSizes") === "auto" && (this.option("pager").allowedPageSizes = r), this.option("focusedRowEnabled") && (this.option("focusedRowIndex", -1), this.option("focusedRowKey", e.focusedRowKey || null)), this.component.endUpdate(), this.option("searchPanel.text", n || ""), this.option("filterValue", wSe(this, e)), this.option("filterPanel.filterEnabled", e.filterPanel ? e.filterPanel.filterEnabled : !0), this.option("paging.pageIndex", (!c || v) && e.pageIndex || 0), this.option("paging.pageSize", (!c || p) && R(e.pageSize) ? e.pageSize : this._initialPageSize), this._dataController && this._dataController.reset();
  }
}, DSe = (t) => class extends t {
  _shouldReturnVisibleColumns() {
    var e = super._shouldReturnVisibleColumns.apply(this, arguments);
    return e && (!this._stateStoringController.isEnabled() || this._stateStoringController.isLoaded());
  }
}, ASe = (t) => class extends t {
  dispose() {
    clearTimeout(this._restoreStateTimeoutID), super.dispose();
  }
  callbackNames() {
    return super.callbackNames().concat(["stateLoaded"]);
  }
  _refreshDataSource() {
    if (this._stateStoringController.isEnabled() && !this._stateStoringController.isLoaded()) {
      clearTimeout(this._restoreStateTimeoutID);
      var e = new q();
      return this._restoreStateTimeoutID = setTimeout(() => {
        this._stateStoringController.load().always(() => {
          this._restoreStateTimeoutID = null;
        }).done(() => {
          super._refreshDataSource(), this.stateLoaded.fire(), e.resolve();
        }).fail((i) => {
          this.stateLoaded.fire(), this._handleLoadError(i || "Unknown error"), e.reject();
        });
      }), e.promise();
    }
    this.isStateLoading() || super._refreshDataSource();
  }
  isLoading() {
    return super.isLoading() || this._stateStoringController.isLoading();
  }
  isStateLoading() {
    return R(this._restoreStateTimeoutID);
  }
  isLoaded() {
    return super.isLoaded() && !this.isStateLoading();
  }
}, OSe = (t) => class extends t {
  _fireSelectionChanged(e) {
    var i = this.option("selection.deferred");
    this._stateStoringController.isLoading() && i || super._fireSelectionChanged.apply(this, arguments);
  }
}, RSe = {
  defaultOptions: () => ({
    stateStoring: {
      enabled: !1,
      storageKey: null,
      type: "localStorage",
      customLoad: null,
      customSave: null,
      savingTimeout: 2e3
    }
  }),
  controllers: {
    stateStoring: xSe
  },
  extenders: {
    views: {
      rowsView: TSe
    },
    controllers: {
      stateStoring: ISe,
      columns: DSe,
      data: ASe,
      selection: OSe
    }
  }
};
et.registerModule("stateStoring", RSe);
var oX = "dx-editor-cell", LSe = "dx-row", t4 = "dx-selection", pp = "dx-select-checkbox", MSe = "dx-select-checkboxes-hidden", sX = "dx-command-select", kSe = "dx-selection-disabled", lX = "dx-data-row", Du = "selection.showCheckBoxesMode", _x = "selection.mode", uX = function(t, e) {
  var i = t.getView("rowsView"), r = t.getController("selection"), n = E(e.target).closest(".".concat(lX)), a = i.getRowIndex(n);
  a < 0 || (t.option(Du) === "onLongTap" ? r.isSelectionWithCheckboxes() ? r.stopSelectionWithCheckboxes() : r.startSelectionWithCheckboxes() : (t.option(Du) === "onClick" && r.startSelectionWithCheckboxes(), t.option(Du) !== "always" && r.changeItemSelection(a, {
    control: !0
  })));
}, PSe = function(t, e) {
  var i = 0, r = t._dataController.store(), n = r && r.key(), a = Array.isArray(n);
  if (!e.length)
    return !1;
  if (a && Array.isArray(e[0]) && e[1] === "and") {
    for (var o = 0; o < e.length; o++)
      if (Array.isArray(e[o])) {
        if (e[o][0] !== n[i] || e[o][1] !== "=")
          return !0;
        i++;
      }
    return !1;
  }
  return n !== e[0];
}, FSe = (t, e) => {
  var {
    component: i
  } = e, r = i.getView("rowsView");
  i.option("renderAsync") && !i.option("selection.deferred") && (e.value = i.isRowSelected(e.row.key)), r.renderSelectCheckBoxContainer(E(t), e);
}, BSe = (t, e) => {
  var {
    column: i
  } = e, r = E(t), n = e.component.getView("columnHeadersView");
  r.addClass(oX), n._renderSelectAllCheckBox(r, i), n._attachSelectAllCheckBoxClickEvent(r);
};
class VSe extends Bi.Controller {
  init() {
    var e, {
      deferred: i,
      selectAllMode: r,
      mode: n
    } = (e = this.option("selection")) !== null && e !== void 0 ? e : {};
    this.option("scrolling.mode") === "infinite" && !i && n === "multiple" && r === "allPages" && Yt.log("W1018"), this._dataController = this.getController("data"), this._columnsController = this.getController("columns"), this._stateStoringController = this.getController("stateStoring"), this._selectionMode = n, this._isSelectionWithCheckboxes = !1, this._selection = this._createSelection(), this._updateSelectColumn(), this.createAction("onSelectionChanged", {
      excludeValidators: ["disabled", "readOnly"]
    }), this._dataPushedHandler || (this._dataPushedHandler = this._handleDataPushed.bind(this), this._dataController.pushed.add(this._dataPushedHandler));
  }
  _handleDataPushed(e) {
    this._deselectRemovedOnPush(e), this._updateSelectedOnPush(e);
  }
  _deselectRemovedOnPush(e) {
    var i = this.option("selection.deferred"), r = e.filter((a) => a.type === "remove").map((a) => a.key);
    if (i) {
      var n = this._dataController.items().filter((a) => a.isSelected).map((a) => a.key);
      r = r.filter((a) => n.find((o) => Mi(o, a)));
    }
    r.length && this.deselectRows(r);
  }
  _updateSelectedOnPush(e) {
    var i = this.option("selection.deferred");
    if (!i) {
      var r = e.filter((a) => a.type === "update"), n = this.getSelectedRowsData();
      xp({
        keyInfo: this._selection.options,
        data: n,
        changes: r
      });
    }
  }
  _getSelectionConfig() {
    var e, i = this._dataController, r = this._columnsController, n = (e = this.option("selection")) !== null && e !== void 0 ? e : {}, {
      deferred: a
    } = n, o = this.option("scrolling.mode"), u = o === "virtual" || o === "infinite", c = this.option("selection.allowSelectAll"), p = this.option("scrolling.legacyMode");
    return {
      selectedKeys: this.option("selectedRowKeys"),
      mode: this._selectionMode,
      deferred: a,
      alwaysSelectByShift: n.alwaysSelectByShift,
      maxFilterLengthInRequest: n.maxFilterLengthInRequest,
      selectionFilter: this.option("selectionFilter"),
      ignoreDisabledItems: !0,
      isVirtualPaging: u,
      allowLoadByRange() {
        var v = r.getGroupColumns().length > 0;
        return u && !p && !v && c && !a;
      },
      key: () => i == null ? void 0 : i.key(),
      keyOf: (v) => i == null ? void 0 : i.keyOf(v),
      dataFields() {
        var v;
        return (v = i.dataSource()) === null || v === void 0 ? void 0 : v.select();
      },
      load(v) {
        var _;
        return ((_ = i.dataSource()) === null || _ === void 0 ? void 0 : _.load(v)) || new q().resolve([]);
      },
      plainItems: (v) => i.items(!0),
      isItemSelected: (v) => v.selected,
      isSelectableItem: (v) => (v == null ? void 0 : v.rowType) === "data" && !v.isNewRow,
      getItemData: (v) => R(v == null ? void 0 : v.rowType) ? (v == null ? void 0 : v.oldData) || (v == null ? void 0 : v.data) : v,
      filter: () => i.getCombinedFilter(a),
      totalCount: () => i.totalCount(),
      getLoadOptions(v, _, y) {
        var b, I, {
          sort: A,
          filter: L
        } = (I = (b = i.dataSource()) === null || b === void 0 ? void 0 : b.lastLoadOptions()) !== null && I !== void 0 ? I : {}, B = Math.min(v, _), $ = Math.max(v, _);
        R(y) && (B = Math.min(y, B), $ = Math.max(y, $));
        var K = $ - B + 1;
        return {
          skip: B,
          take: K,
          filter: L,
          sort: A
        };
      },
      onSelectionChanged: this._updateSelectedItems.bind(this)
    };
  }
  _updateSelectColumn() {
    var e = this._columnsController, i = this.isSelectColumnVisible();
    e.addCommandColumn({
      type: "selection",
      command: "select",
      visible: i,
      visibleIndex: -1,
      dataType: "boolean",
      alignment: "center",
      cssClass: sX,
      width: "auto",
      cellTemplate: FSe,
      headerCellTemplate: BSe
    }), e.columnOption("command:select", "visible", i);
  }
  _createSelection() {
    var e = this._getSelectionConfig();
    return new z5(e);
  }
  _fireSelectionChanged(e) {
    var i = this.option("selection.deferred") ? {
      selectionFilter: this.option("selectionFilter")
    } : {
      selectedRowKeys: this.option("selectedRowKeys")
    };
    this.selectionChanged.fire(i), e && this.executeAction("onSelectionChanged", e);
  }
  _updateCheckboxesState(e) {
    var {
      isDeferredMode: i
    } = e, {
      selectionFilter: r
    } = e, {
      selectedItemKeys: n
    } = e, {
      removedItemKeys: a
    } = e;
    this.option(Du) === "onClick" && ((i ? r && PSe(this, r) : n.length > 1) ? this.startSelectionWithCheckboxes() : (i ? r && !r.length : n.length === 0 && a.length) && this.stopSelectionWithCheckboxes());
  }
  _updateSelectedItems(e) {
    var i, r = this.option("selection.deferred"), n = this._selection.selectionFilter(), a = this._dataController, o = a.items(!0), u = a.items();
    if (o) {
      var c = this.isSelectionWithCheckboxes(), p = this.getChangedItemIndexes(o), v = this.getChangedItemIndexes(u);
      this._updateCheckboxesState({
        selectedItemKeys: e.selectedItemKeys,
        removedItemKeys: e.removedItemKeys,
        selectionFilter: n,
        isDeferredMode: r
      }), (p.length || c !== this.isSelectionWithCheckboxes()) && a.updateItems({
        changeType: "updateSelection",
        itemIndexes: v
      }), r ? (this.option("selectionFilter", n), i = {}) : (e.addedItemKeys.length || e.removedItemKeys.length) && (this._selectedItemsInternalChange = !0, this.option("selectedRowKeys", e.selectedItemKeys.slice(0)), this._selectedItemsInternalChange = !1, i = {
        selectedRowsData: e.selectedItems.slice(0),
        selectedRowKeys: e.selectedItemKeys.slice(0),
        currentSelectedRowKeys: e.addedItemKeys.slice(0),
        currentDeselectedRowKeys: e.removedItemKeys.slice(0)
      }), this._fireSelectionChanged(i);
    }
  }
  getChangedItemIndexes(e) {
    for (var i = [], r = this.option("selection.deferred"), n = 0, {
      length: a
    } = e; n < a; n++) {
      var o = e[n], u = this.isRowSelected(r ? o.data : o.key);
      this._selection.isDataItem(o) && o.isSelected !== u && i.push(n);
    }
    return i;
  }
  callbackNames() {
    return ["selectionChanged"];
  }
  optionChanged(e) {
    switch (super.optionChanged(e), e.name) {
      case "selection":
        var i = this._selectionMode;
        if (this.init(), e.fullName !== "selection.showCheckBoxesMode") {
          var r = this._selectionMode, n = this.option("selectedRowKeys");
          i !== r && (r === "single" ? n.length > 1 && (n = [n[0]]) : r !== "multiple" && (n = [])), this.selectRows(n).always(() => {
            this._fireSelectionChanged();
          });
        }
        this._columnsController.updateColumns(), e.handled = !0;
        break;
      case "selectionFilter":
        this._selection.selectionFilter(e.value), e.handled = !0;
        break;
      case "selectedRowKeys":
        var a = e.value || [];
        Array.isArray(a) && !this._selectedItemsInternalChange && (this.component.getDataSource() || !a.length) && this.selectRows(a), e.handled = !0;
    }
  }
  publicMethods() {
    return ["selectRows", "deselectRows", "selectRowsByIndexes", "getSelectedRowKeys", "getSelectedRowsData", "clearSelection", "selectAll", "deselectAll", "startSelectionWithCheckboxes", "stopSelectionWithCheckboxes", "isRowSelected"];
  }
  isRowSelected(e) {
    return this._selection.isItemSelected(e);
  }
  isSelectColumnVisible() {
    return this.option(_x) === "multiple" && (this.option(Du) === "always" || this.option(Du) === "onClick" || this._isSelectionWithCheckboxes);
  }
  _isOnePageSelectAll() {
    return this.option("selection.selectAllMode") === "page";
  }
  isSelectAll() {
    return this._selection.getSelectAllState(this._isOnePageSelectAll());
  }
  selectAll() {
    return this.option(Du) === "onClick" && this.startSelectionWithCheckboxes(), this._selection.selectAll(this._isOnePageSelectAll());
  }
  deselectAll() {
    return this._selection.deselectAll(this._isOnePageSelectAll());
  }
  clearSelection() {
    return this.selectedItemKeys([]);
  }
  refresh() {
    var e, i = (e = this.option("selectedRowKeys")) !== null && e !== void 0 ? e : [];
    return !this.option("selection.deferred") && i.length ? this.selectedItemKeys(i) : new q().resolve().promise();
  }
  selectedItemKeys(e, i, r, n) {
    return this._selection.selectedItemKeys(e, i, r, n);
  }
  getSelectedRowKeys(e) {
    return this._selection.getSelectedItemKeys();
  }
  selectRows(e, i) {
    return this.selectedItemKeys(e, i);
  }
  deselectRows(e) {
    return this.selectedItemKeys(e, !0, !0);
  }
  selectRowsByIndexes(e) {
    var i = this._dataController.items(), r = [];
    return Array.isArray(e) || (e = Array.prototype.slice.call(arguments, 0)), N(e, function() {
      var n = i[this];
      n && n.rowType === "data" && r.push(n.key);
    }), this.selectRows(r);
  }
  getSelectedRowsData(e) {
    return this._selection.getSelectedItems();
  }
  loadSelectedItemsWithFilter() {
    return this._selection.loadSelectedItemsWithFilter();
  }
  changeItemSelection(e, i, r) {
    i = i || {}, this.isSelectionWithCheckboxes() && (i.control = !0);
    var n = e + this._dataController.getRowIndexOffset() - this._dataController.getRowIndexOffset(!0);
    return this._selection.changeItemSelection(n, i, r);
  }
  focusedItemIndex(e) {
    if (R(e))
      this._selection._focusedItemIndex = e;
    else
      return this._selection._focusedItemIndex;
  }
  isSelectionWithCheckboxes() {
    return this.option(_x) === "multiple" && (this.option(Du) === "always" || this._isSelectionWithCheckboxes);
  }
  startSelectionWithCheckboxes() {
    return this.option(_x) === "multiple" && !this.isSelectionWithCheckboxes() ? (this._isSelectionWithCheckboxes = !0, this._updateSelectColumn(), !0) : !1;
  }
  stopSelectionWithCheckboxes() {
    return this._isSelectionWithCheckboxes ? (this._isSelectionWithCheckboxes = !1, this._updateSelectColumn(), !0) : !1;
  }
}
var NSe = (t) => class extends t {
  init() {
    var e = this.option("selection.deferred");
    super.init.apply(this, arguments), e && this._selectionController._updateCheckboxesState({
      isDeferredMode: !0,
      selectionFilter: this.option("selectionFilter")
    });
  }
  _loadDataSource() {
    var e = this;
    return super._loadDataSource().always(() => {
      e._selectionController.refresh();
    });
  }
  _processDataItem(e, i) {
    var r = this._selectionController.isSelectColumnVisible(), n = i.isDeferredSelection = i.isDeferredSelection === void 0 ? this.option("selection.deferred") : i.isDeferredSelection, a = super._processDataItem.apply(this, arguments);
    if (a.isSelected = this._selectionController.isRowSelected(n ? a.data : a.key), r && a.values) {
      for (var o = 0; o < i.visibleColumns.length; o++)
        if (i.visibleColumns[o].command === "select") {
          a.values[o] = a.isSelected;
          break;
        }
    }
    return a;
  }
  refresh(e) {
    var i = this, r = new q();
    return super.refresh.apply(this, arguments).done(() => {
      !e || e.selection ? i._selectionController.refresh().done(r.resolve).fail(r.reject) : r.resolve();
    }).fail(r.reject), r.promise();
  }
  _handleDataChanged(e) {
    var i = this.hasLoadOperation();
    super._handleDataChanged.apply(this, arguments), i && !this._repaintChangesOnly && this._selectionController.focusedItemIndex(-1);
  }
  _applyChange(e) {
    if (e && e.changeType === "updateSelection") {
      e.items.forEach((i, r) => {
        var n = this._items[r];
        n && (n.isSelected = i.isSelected, n.values = i.values);
      });
      return;
    }
    return super._applyChange.apply(this, arguments);
  }
  _endUpdateCore() {
    var e = this._changes, i = e.length > 1 && e.every((n) => n.changeType === "updateSelection");
    if (i) {
      var r = e.map((n) => n.itemIndexes || []).reduce((n, a) => n.concat(a));
      this._changes = [{
        changeType: "updateSelection",
        itemIndexes: r
      }];
    }
    super._endUpdateCore.apply(this, arguments);
  }
}, HSe = (t) => class extends t {
  _contextMenuPrepared(e) {
    var i = e.event;
    i.originalEvent && i.originalEvent.type !== "dxhold" || e.items && e.items.length > 0 || uX(this, i);
  }
}, $Se = (t) => class extends t {
  init() {
    super.init(), this._selectionController.selectionChanged.add(this._updateSelectAllValue.bind(this));
  }
  _updateSelectAllValue() {
    var e = this.element(), i = e && e.find(".".concat(pp));
    if (e && i.length && this.option("selection.mode") === "multiple") {
      var r = this._selectionController.isSelectAll(), n = r !== !1, a = this.option("selection.allowSelectAll") ? !this._dataController.isEmpty() : n;
      i.dxCheckBox("instance").option({
        visible: a,
        value: r
      });
    }
  }
  _handleDataChanged(e) {
    super._handleDataChanged(e), (!e || e.changeType === "refresh" || e.repaintChangesOnly && e.changeType === "update") && this.waitAsyncTemplates().done(() => {
      this._updateSelectAllValue();
    });
  }
  _renderSelectAllCheckBox(e, i) {
    var r = this, n = r._dataController.isEmpty(), a = E("<div>").appendTo(e).addClass(pp);
    return r.setAria("label", X.format("dxDataGrid-ariaSelectAll"), a), r._editorFactoryController.createEditor(a, P({}, i, {
      parentType: "headerRow",
      dataType: "boolean",
      value: this._selectionController.isSelectAll(),
      editorOptions: {
        visible: !n && (r.option("selection.allowSelectAll") || this._selectionController.isSelectAll() !== !1)
      },
      tabIndex: r.option("useLegacyKeyboardNavigation") ? -1 : r.option("tabIndex") || 0,
      setValue: (o, u) => {
        var c = r.option("selection.allowSelectAll");
        u.component.option("visible", c || u.component.option("value") !== !1), !(!u.event || this._selectionController.isSelectAll() === o) && (u.value && !c ? u.component.option("value", !1) : u.value ? this._selectionController.selectAll() : this._selectionController.deselectAll(), u.event.preventDefault());
      }
    })), a;
  }
  _attachSelectAllCheckBoxClickEvent(e) {
    k.on(e, di, this.createAction((i) => {
      var {
        event: r
      } = i;
      E(r.target).closest(".".concat(pp)).length || k.trigger(E(r.currentTarget).children(".".concat(pp)), di), r.preventDefault();
    }));
  }
}, zSe = (t) => class extends t {
  renderSelectCheckBoxContainer(e, i) {
    i.rowType === "data" && !i.row.isNewRow ? (e.addClass(oX), this._attachCheckBoxClickEvent(e), this._renderSelectCheckBox(e, i)) : xe.setEmptyText(e);
  }
  _renderSelectCheckBox(e, i) {
    var r = E("<div>").addClass(pp).appendTo(e);
    return this.setAria("label", X.format("dxDataGrid-ariaSelectRow"), r), this._editorFactoryController.createEditor(r, P({}, i.column, {
      parentType: "dataRow",
      dataType: "boolean",
      lookup: null,
      value: i.value,
      setValue(n, a) {
        var o;
        ((o = a == null ? void 0 : a.event) === null || o === void 0 ? void 0 : o.type) === "keydown" && k.trigger(a.element, di, a);
      },
      row: i.row
    })), r;
  }
  _attachCheckBoxClickEvent(e) {
    k.on(e, di, this.createAction(function(i) {
      var {
        event: r
      } = i, n = this.getRowIndex(E(r.currentTarget).closest(".".concat(LSe)));
      n >= 0 && (this._selectionController.startSelectionWithCheckboxes(), this._selectionController.changeItemSelection(n, {
        shift: r.shiftKey
      }), E(r.target).closest(".".concat(pp)).length && this._dataController.updateItems({
        changeType: "updateSelection",
        itemIndexes: [n]
      }));
    }));
  }
  _update(e) {
    var i = this, r = i.getTableElements();
    e.changeType === "updateSelection" ? r.length > 0 && (N(r, (n, a) => {
      N(e.itemIndexes || [], (o, u) => {
        var c;
        if (e.items[u] && (c = i._getRowElements(E(a)).eq(u), c.length)) {
          var {
            isSelected: p
          } = e.items[u];
          c.toggleClass(t4, p === void 0 ? !1 : p).find(".".concat(pp)).dxCheckBox("option", "value", p), i.setAria("selected", p, c);
        }
      });
    }), i._updateCheckboxesClass()) : super._update(e);
  }
  _createTable() {
    var e = this, i = e.option("selection.mode"), r = super._createTable.apply(e, arguments);
    return i !== "none" && ((e.option(Du) === "onLongTap" || !Ip) && k.on(r, ve(Lh.name, "dxDataGridRowsView"), ".".concat(lX), e.createAction((n) => {
      uX(e.component, n.event), n.event.stopPropagation();
    })), k.on(r, "mousedown selectstart", e.createAction((n) => {
      var {
        event: a
      } = n;
      a.shiftKey && a.preventDefault();
    }))), r;
  }
  _createRow(e) {
    var i = super._createRow.apply(this, arguments);
    if (e) {
      var {
        isSelected: r
      } = e;
      r && i.addClass(t4);
      var n = this.option(_x);
      n !== "none" && this.setAria("selected", r, i);
    }
    return i;
  }
  _rowClickForTreeList(e) {
    super._rowClick(e);
  }
  _rowClick(e) {
    var i = e.event, r = E(i.target).closest(".".concat(kSe)).length;
    this.isClickableElement(E(i.target)) || (!r && (this.option(_x) !== "multiple" || this.option(Du) !== "always") && this._selectionController.changeItemSelection(e.rowIndex, {
      control: Cn(i),
      shift: i.shiftKey
    }) && (i.preventDefault(), e.handled = !0), super._rowClick(e));
  }
  isClickableElement(e) {
    var i = e.closest(".".concat(sX)).length;
    return !!i;
  }
  _renderCore(e) {
    var i = super._renderCore(e);
    return this._updateCheckboxesClass(), i;
  }
  _updateCheckboxesClass() {
    var e = this.getTableElements(), i = this._selectionController.isSelectColumnVisible() && !this._selectionController.isSelectionWithCheckboxes();
    N(e, (r, n) => {
      E(n).toggleClass(MSe, i);
    });
  }
}, WSe = {
  defaultOptions: () => ({
    selection: {
      mode: "none",
      showCheckBoxesMode: "onClick",
      allowSelectAll: !0,
      selectAllMode: "allPages",
      deferred: !1,
      maxFilterLengthInRequest: 1500,
      alwaysSelectByShift: !1
    },
    selectionFilter: [],
    selectedRowKeys: []
  }),
  controllers: {
    selection: VSe
  },
  extenders: {
    controllers: {
      data: NSe,
      contextMenu: HSe
    },
    views: {
      columnHeadersView: $Se,
      rowsView: zSe
    }
  }
};
et.registerModule("selection", WSe);
function USe(t, e) {
  var i, r, n = (i = (r = t.getRootNode) === null || r === void 0 ? void 0 : r.call(t)) !== null && i !== void 0 ? i : document;
  return n.querySelector(e);
}
var i4 = "dx-invalid-message-auto", r4 = "dx-validation-target";
let NB = class extends cS {
  getProps() {
    var e = super.getProps();
    return e.onFocusIn = () => {
      var i = this.option("validationMessageMode") === "auto";
      if (i) {
        var r = E(USe(this.element(), ".dx-invalid-message.dx-overlay-wrapper"));
        r == null || r.removeClass(i4), this.showValidationMessageTimeout && clearTimeout(this.showValidationMessageTimeout), this.showValidationMessageTimeout = setTimeout(() => {
          r == null || r.addClass(i4);
        }, 150);
      }
    }, e.saveValueChangeEvent = (i) => {
      this._valueChangeEventInstance = i;
    }, e;
  }
  _createElement(e) {
    super._createElement(e), this.showValidationMessageTimeout = void 0, this.validationRequest = ui(), dr(this.$element()[0], r4, this);
  }
  _render() {
    var e;
    (e = this.option("_onMarkupRendered")) === null || e === void 0 || e();
  }
  _init() {
    super._init(), this._initialValue = this.option("value");
  }
  _initializeComponent() {
    super._initializeComponent(), this._valueChangeAction = this._createActionByOption("onValueChanged", {
      excludeValidators: ["disabled", "readOnly"]
    });
  }
  _initOptions(e) {
    super._initOptions(e), this.option(Si.initValidationOptions(e));
  }
  _getDefaultOptions() {
    return P(super._getDefaultOptions(), {
      validationMessageOffset: {
        h: 0,
        v: 0
      },
      validationTooltipOptions: {}
    });
  }
  _bindInnerWidgetOptions(e, i) {
    var r = P({}, e.option()), n = () => this._silent(i, r);
    n(), e.on("optionChanged", n);
  }
  _raiseValidation(e, i) {
    var r = !R(e) && !R(i);
    e !== i && !r && this.validationRequest.fire({
      value: e,
      editor: this
    });
  }
  _raiseValueChangeAction(e, i) {
    var r;
    (r = this._valueChangeAction) === null || r === void 0 || r.call(this, {
      element: this.$element(),
      previousValue: i,
      value: e,
      event: this._valueChangeEventInstance
    }), this._valueChangeEventInstance = void 0;
  }
  _optionChanged(e) {
    var {
      name: i,
      previousValue: r,
      value: n
    } = e;
    switch (i && this._getActionConfigs()[i] !== void 0 && this._addAction(i), i) {
      case "value":
        this._raiseValidation(n, r), this.option("isDirty", this._initialValue !== n), this._raiseValueChangeAction(n, r);
        break;
      case "onValueChanged":
        this._valueChangeAction = this._createActionByOption("onValueChanged", {
          excludeValidators: ["disabled", "readOnly"]
        });
        break;
      case "isValid":
      case "validationError":
      case "validationErrors":
      case "validationStatus":
        this.option(Si.synchronizeValidationOptions(e, this.option()));
    }
    super._optionChanged(e);
  }
  clear() {
    var {
      value: e
    } = this._getDefaultOptions();
    this.option({
      value: e
    });
  }
  reset() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
    arguments.length && (this._initialValue = e), this.option("value", this._initialValue), this.option("isDirty", !1), this.option("isValid", !0);
  }
  _dispose() {
    super._dispose(), dr(this.element(), r4, null), this.showValidationMessageTimeout && clearTimeout(this.showValidationMessageTimeout);
  }
};
var GSe = Fl.isEditor, dX = (t) => GSe(t) || t instanceof NB;
NB.isEditor = dX;
Fl.isEditor = dX;
let KSe = class extends NB {
  _useTemplates() {
    return !1;
  }
  _isFocused() {
    var e = this.$element()[0];
    return e.classList.contains("dx-state-focused");
  }
  getSupportedKeyNames() {
    return ["space"];
  }
  getProps() {
    var e = super.getProps();
    return e.value !== null && (e.value = !!e.value), e;
  }
};
var jSe = ["dataSource", "selectedRowKeys"], YSe = {
  integrationOptions: !0
};
function Ry(t, e, i) {
  return {
    path: t,
    value: e,
    previousValue: i
  };
}
function n4(t, e, i, r, n, a) {
  if (!YSe[r]) {
    var o = cs(e), u = cs(i);
    if (e !== i)
      if (o !== u)
        t.push(Ry(r, i, e));
      else if (o === "object")
        if (!$t(i))
          t.push(Ry(r, i, e));
        else {
          var c = a4(e, i, n, a);
          t.push(...c.map((_) => ae({}, _, {
            path: "".concat(r, ".").concat(_.path)
          })));
        }
      else if (o === "array") {
        var p = a.some((_) => n.includes(_));
        if (p && e !== i)
          t.push(Ry(r, i, e));
        else if (e.length !== i.length)
          t.push(Ry(r, i, e));
        else {
          var v = a4(e, i, n, a);
          [].push.apply(t, v.map((_) => ae({}, _, {
            path: "".concat(r).concat(_.path)
          })));
        }
      } else
        t.push(Ry(r, i, e));
  }
}
var cX = (t) => (e, i, r, n) => {
  var a = [], o = Array.isArray(e) ? (u) => {
    n4(a, e[u], i[u], "[".concat(u, "]"), "".concat(r, ".").concat(u), n);
  } : (u) => {
    n4(a, e[u], i[u], u, "".concat(r, ".").concat(u), n);
  };
  return t(e).forEach(o), Object.keys(i).filter((u) => !Object.prototype.hasOwnProperty.call(e, u) && e[u] !== i[u]).forEach((u) => {
    a.push({
      path: u,
      value: i[u],
      previousValue: e[u]
    });
  }), a;
}, a4 = cX((t) => Object.keys(t)), qSe = {
  key: !0,
  ref: !0,
  children: !0,
  style: !0
}, XSe = cX((t) => Object.keys(t).filter((e) => !qSe[e]));
function QSe(t, e) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : jSe;
  return XSe(t, e, "", i);
}
var ZSe = ["valueChange"], JSe = ["componentProps", "componentType", "templateNames"], hX = (t) => Object.keys(t).reduce((e, i) => (t[i] !== void 0 && (e[i] = t[i]), e), {}), e0e = (t) => {
  var {
    props: {
      componentProps: {
        className: e
      }
    },
    restAttributes: i,
    widgetRef: r
  } = t;
  return hX(Fr(1, "div", e, null, 1, ae({}, i), null, r));
}, t0e = {};
class MI extends Bu {
  constructor(e) {
    super(e), this.state = {}, this.widgetRef = Vn(), this.getInstance = this.getInstance.bind(this), this.setupWidget = this.setupWidget.bind(this), this.updateWidget = this.updateWidget.bind(this);
  }
  get config() {
    return this.context[ea.id] ? this.context[ea.id] : ea.defaultValue;
  }
  createEffects() {
    return [new ar(this.setupWidget, []), new ar(this.updateWidget, [this.props.componentProps, this.config, this.props.templateNames])];
  }
  updateEffects() {
    var e;
    (e = this._effects[1]) === null || e === void 0 || e.update([this.props.componentProps, this.config, this.props.templateNames]);
  }
  setupWidget() {
    var e = new this.props.componentType(this.widgetRef.current, this.properties);
    return this.instance = e, () => {
      e.dispose(), this.instance = null;
    };
  }
  updateWidget() {
    var e = this.getInstance();
    if (e) {
      var i = QSe(this.prevProps || {}, this.properties);
      i.length && (e.beginUpdate(), i.forEach((r) => {
        var {
          path: n,
          value: a
        } = r;
        e.option(n, a);
      }), e.endUpdate()), this.prevProps = this.properties;
    }
  }
  get properties() {
    var e, i = hX(this.props.componentProps), {
      valueChange: r
    } = i, n = sr(i, ZSe), a = ae({
      rtlEnabled: !!((e = this.config) !== null && e !== void 0 && e.rtlEnabled),
      isRenovated: !0
    }, n);
    r && (a.onValueChanged = (u) => {
      var {
        value: c
      } = u;
      return r(c);
    });
    var o = this.props.templateNames;
    return o.forEach((u) => {
      Pae(u, a, this) && (a[u] = (c, p, v) => {
        kae(this.props.componentProps[u], {
          item: c,
          index: p,
          container: v
        }, this);
      });
    }), a;
  }
  get restAttributes() {
    var e = this.props, i = sr(e, JSe);
    return i;
  }
  getInstance() {
    return this.instance;
  }
  render() {
    var e = this.props;
    return e0e({
      props: ae({}, e),
      widgetRef: this.widgetRef,
      config: this.config,
      properties: this.properties,
      restAttributes: this.restAttributes
    });
  }
}
MI.defaultProps = t0e;
var i0e = ["accessKey", "activeStateEnabled", "boundary", "className", "contentId", "disabled", "focusStateEnabled", "height", "hint", "hoverStateEnabled", "mode", "offset", "onClick", "onKeyDown", "positionSide", "rtlEnabled", "tabIndex", "target", "validationErrors", "visible", "visualContainer", "width"], r0e = (t) => {
  var {
    componentProps: e,
    restAttributes: i
  } = t;
  return Uo(zi(2, MI, ae({
    componentType: EB,
    componentProps: e,
    templateNames: []
  }, i)));
}, n0e = Object.create(Object.prototype, ae(Object.getOwnPropertyDescriptors(vI), Object.getOwnPropertyDescriptors({
  mode: "auto",
  positionSide: "top",
  offset: Object.freeze({
    h: 0,
    v: 0
  }),
  isReactComponentWrapper: !0
})));
class fX extends qs {
  constructor(e) {
    super(e), this.state = {};
  }
  get componentProps() {
    return this.props;
  }
  get restAttributes() {
    var e = this.props, i = sr(e, i0e);
    return i;
  }
  render() {
    var e = this.props;
    return r0e({
      props: ae({}, e),
      componentProps: this.componentProps,
      restAttributes: this.restAttributes
    });
  }
}
fX.defaultProps = n0e;
var a0e = ["accessKey", "activeStateEnabled", "aria", "children", "className", "classes", "defaultValue", "disabled", "focusStateEnabled", "height", "hint", "hoverStateEnabled", "inputAttr", "isDirty", "isValid", "name", "onClick", "onFocusIn", "onKeyDown", "readOnly", "rtlEnabled", "tabIndex", "validationError", "validationErrors", "validationMessageMode", "validationMessagePosition", "validationStatus", "value", "valueChange", "visible", "width"], o0e = (t) => {
  var {
    classes: e,
    isValid: i,
    readOnly: r
  } = t, n = {
    "dx-state-readonly": !!r,
    "dx-invalid": !i,
    ["".concat(e)]: !!e
  };
  return $s(n);
}, s0e = (t) => {
  var {
    aria: e,
    cssClasses: i,
    isValidationMessageVisible: r,
    onFocusIn: n,
    props: {
      accessKey: a,
      activeStateEnabled: o,
      children: u,
      className: c,
      disabled: p,
      focusStateEnabled: v,
      height: _,
      hint: y,
      hoverStateEnabled: b,
      onClick: I,
      onKeyDown: A,
      rtlEnabled: L,
      tabIndex: B,
      validationMessageMode: $,
      validationMessagePosition: K,
      visible: te,
      width: z
    },
    restAttributes: ie,
    rootElementRef: pe,
    validationErrors: _e,
    validationMessageGuid: be,
    validationMessageTarget: De,
    widgetRef: Ce
  } = t;
  return Uo(zi(2, gI, ae({
    rootElementRef: pe,
    aria: e,
    classes: i,
    activeStateEnabled: o,
    focusStateEnabled: v,
    hoverStateEnabled: b,
    accessKey: a,
    className: c,
    rtlEnabled: L,
    hint: y,
    disabled: p,
    height: _,
    width: z,
    onFocusIn: n,
    onClick: I,
    onKeyDown: A,
    tabIndex: B,
    visible: te
  }, ie, {
    children: sc([u, r && zi(2, fX, {
      validationErrors: _e,
      mode: $,
      positionSide: K,
      rtlEnabled: L,
      target: De,
      boundary: De,
      visualContainer: De,
      contentId: be
    })], 0)
  }), null, Ce));
}, qr = Object.create(Object.prototype, ae(Object.getOwnPropertyDescriptors(vI), Object.getOwnPropertyDescriptors({
  readOnly: !1,
  name: "",
  validationError: null,
  validationErrors: null,
  validationMessageMode: "auto",
  validationMessagePosition: "bottom",
  validationStatus: "valid",
  isValid: !0,
  isDirty: !1,
  inputAttr: Object.freeze({}),
  defaultValue: null,
  valueChange: () => {
  }
}))), l0e = {
  get readOnly() {
    return qr.readOnly;
  },
  get name() {
    return qr.name;
  },
  get validationError() {
    return qr.validationError;
  },
  get validationErrors() {
    return qr.validationErrors;
  },
  get validationMessageMode() {
    return qr.validationMessageMode;
  },
  get validationMessagePosition() {
    return qr.validationMessagePosition;
  },
  get validationStatus() {
    return qr.validationStatus;
  },
  get isValid() {
    return qr.isValid;
  },
  get isDirty() {
    return qr.isDirty;
  },
  get inputAttr() {
    return qr.inputAttr;
  },
  get defaultValue() {
    return qr.defaultValue;
  },
  get valueChange() {
    return qr.valueChange;
  },
  get className() {
    return qr.className;
  },
  get activeStateEnabled() {
    return qr.activeStateEnabled;
  },
  get disabled() {
    return qr.disabled;
  },
  get focusStateEnabled() {
    return qr.focusStateEnabled;
  },
  get hoverStateEnabled() {
    return qr.hoverStateEnabled;
  },
  get tabIndex() {
    return qr.tabIndex;
  },
  get visible() {
    return qr.visible;
  },
  get aria() {
    return ST.aria;
  },
  get classes() {
    return ST.classes;
  }
};
class pX extends aS {
  constructor(e) {
    super(e), this.widgetRef = Vn(), this.rootElementRef = Vn(), this.__getterCache = {}, this.state = {
      validationMessageGuid: "dx-".concat(new yr()),
      isValidationMessageVisible: !1,
      value: this.props.value !== void 0 ? this.props.value : this.props.defaultValue
    }, this.updateValidationMessageVisibility = this.updateValidationMessageVisibility.bind(this), this.focus = this.focus.bind(this), this.blur = this.blur.bind(this), this.onFocusIn = this.onFocusIn.bind(this);
  }
  createEffects() {
    return [new ar(this.updateValidationMessageVisibility, [this.props.isValid, this.props.validationStatus, this.props.validationError, this.props.validationErrors]), oS()];
  }
  updateEffects() {
    var e;
    (e = this._effects[0]) === null || e === void 0 || e.update([this.props.isValid, this.props.validationStatus, this.props.validationError, this.props.validationErrors]);
  }
  updateValidationMessageVisibility() {
    this.setState((e) => ({
      isValidationMessageVisible: this.shouldShowValidationMessage
    }));
  }
  onFocusIn(e) {
    var {
      onFocusIn: i
    } = this.props;
    i == null || i(e);
  }
  get cssClasses() {
    return "".concat(o0e(ae({}, this.props, {
      value: this.props.value !== void 0 ? this.props.value : this.state.value
    })));
  }
  get shouldShowValidationMessage() {
    var e, {
      isValid: i,
      validationStatus: r
    } = this.props, n = (e = this.validationErrors) !== null && e !== void 0 ? e : [], a = i && r !== "invalid";
    return !a && n.length > 0;
  }
  get aria() {
    var {
      isValid: e,
      readOnly: i
    } = this.props, r = {
      readonly: i ? "true" : "false",
      invalid: e ? "false" : "true"
    };
    return this.shouldShowValidationMessage && (r.describedBy = this.state.validationMessageGuid), ae({}, r, this.props.aria);
  }
  get validationErrors() {
    return this.__getterCache.validationErrors !== void 0 ? this.__getterCache.validationErrors : this.__getterCache.validationErrors = (() => {
      var {
        validationError: e,
        validationErrors: i
      } = this.props, r = i && [...i];
      return !r && e && (r = [ae({}, e)]), r;
    })();
  }
  get validationMessageTarget() {
    var e;
    return (e = this.rootElementRef) === null || e === void 0 ? void 0 : e.current;
  }
  get restAttributes() {
    var e = ae({}, this.props, {
      value: this.props.value !== void 0 ? this.props.value : this.state.value
    }), i = sr(e, a0e);
    return i;
  }
  focus() {
    this.widgetRef.current.focus();
  }
  blur() {
    this.widgetRef.current.blur();
  }
  componentWillUpdate(e, i, r) {
    super.componentWillUpdate(), (this.props.validationError !== e.validationError || this.props.validationErrors !== e.validationErrors) && (this.__getterCache.validationErrors = void 0);
  }
  render() {
    var e = this.props;
    return s0e({
      props: ae({}, e, {
        value: this.props.value !== void 0 ? this.props.value : this.state.value
      }),
      validationMessageGuid: this.state.validationMessageGuid,
      isValidationMessageVisible: this.state.isValidationMessageVisible,
      rootElementRef: this.rootElementRef,
      widgetRef: this.widgetRef,
      onFocusIn: this.onFocusIn,
      cssClasses: this.cssClasses,
      shouldShowValidationMessage: this.shouldShowValidationMessage,
      aria: this.aria,
      validationErrors: this.validationErrors,
      validationMessageTarget: this.validationMessageTarget,
      restAttributes: this.restAttributes
    });
  }
}
pX.defaultProps = l0e;
function vX(t) {
  var e, i = Ot();
  return t ? (e = i.getComputedStyle) === null || e === void 0 ? void 0 : e.call(i, t) : null;
}
var u0e = [
  [22, 16],
  [18, 16]
], d0e = [
  [
    [12, 8],
    [20, 18]
  ],
  [
    [16, 10],
    [16, 14]
  ]
];
function gX() {
  var t = ho();
  return {
    isMaterialTheme: _a(t),
    isCompactTheme: Xse(t)
  };
}
function c0e() {
  var {
    isCompactTheme: t,
    isMaterialTheme: e
  } = gX();
  return u0e[+e][+t];
}
function h0e(t) {
  var {
    isCompactTheme: e,
    isMaterialTheme: i
  } = gX();
  return d0e[+t][+i][+e];
}
function f0e(t, e) {
  var i = h0e(e), r = c0e(), n = i / r;
  return Math.ceil(n * t);
}
var p0e = ["isChecked", "size"], v0e = (t) => {
  var {
    cssStyles: e,
    elementRef: i
  } = t;
  return Fr(1, "span", "dx-checkbox-icon", null, 1, {
    style: AF(e)
  }, null, i);
}, g0e = {
  isChecked: !1
};
class mX extends Bu {
  constructor(e) {
    super(e), this.state = {}, this.elementRef = Vn(), this.__getterCache = {}, this.updateFontSize = this.updateFontSize.bind(this), this.setIconFontSize = this.setIconFontSize.bind(this), this.getIconSize = this.getIconSize.bind(this), this.getComputedIconSize = this.getComputedIconSize.bind(this);
  }
  createEffects() {
    return [new ar(this.updateFontSize, [this.props.isChecked, this.props.size])];
  }
  updateEffects() {
    var e;
    (e = this._effects[0]) === null || e === void 0 || e.update([this.props.isChecked, this.props.size]);
  }
  updateFontSize() {
    var {
      isChecked: e,
      size: i
    } = this.props;
    if (wt() && i) {
      var r = this.getIconSize(i), n = f0e(r, e);
      this.setIconFontSize(n);
    }
  }
  setIconFontSize(e) {
    var i = this.elementRef.current;
    i.style.fontSize = "".concat(e, "px");
  }
  getIconSize(e) {
    return Di(e) ? e : e.endsWith("px") ? parseInt(e, 10) : this.getComputedIconSize();
  }
  getComputedIconSize() {
    var e = this.elementRef.current, i = vX(e), r = parseInt(i == null ? void 0 : i.width, 10);
    return r;
  }
  get cssStyles() {
    return this.__getterCache.cssStyles !== void 0 ? this.__getterCache.cssStyles : this.__getterCache.cssStyles = (() => {
      var {
        size: e
      } = this.props, i = Dm("width", e), r = Dm("height", e);
      return {
        height: r,
        width: i
      };
    })();
  }
  get restAttributes() {
    var e = this.props, i = sr(e, p0e);
    return i;
  }
  componentWillUpdate(e, i, r) {
    super.componentWillUpdate(), this.props.size !== e.size && (this.__getterCache.cssStyles = void 0);
  }
  render() {
    var e = this.props;
    return v0e({
      props: ae({}, e),
      elementRef: this.elementRef,
      setIconFontSize: this.setIconFontSize,
      getIconSize: this.getIconSize,
      getComputedIconSize: this.getComputedIconSize,
      cssStyles: this.cssStyles,
      restAttributes: this.restAttributes
    });
  }
}
mX.defaultProps = g0e;
var m0e = ["accessKey", "activeStateEnabled", "aria", "className", "defaultValue", "disabled", "enableThreeStateBehavior", "focusStateEnabled", "height", "hint", "hoverStateEnabled", "iconSize", "inputAttr", "isDirty", "isValid", "name", "onClick", "onFocusIn", "onKeyDown", "readOnly", "rtlEnabled", "saveValueChangeEvent", "tabIndex", "text", "validationError", "validationErrors", "validationMessageMode", "validationMessagePosition", "validationStatus", "value", "valueChange", "visible", "width"], _0e = (t) => {
  var {
    text: e,
    value: i
  } = t, r = i, n = r === null, a = {
    "dx-checkbox": !0,
    "dx-checkbox-checked": r === !0,
    "dx-checkbox-has-text": !!e,
    "dx-checkbox-indeterminate": n
  };
  return $s(a);
}, C0e = (t) => {
  var {
    aria: e,
    cssClasses: i,
    editorRef: r,
    keyDown: n,
    onWidgetClick: a,
    props: {
      accessKey: o,
      activeStateEnabled: u,
      className: c,
      disabled: p,
      focusStateEnabled: v,
      height: _,
      hint: y,
      hoverStateEnabled: b,
      iconSize: I,
      isValid: A,
      name: L,
      onFocusIn: B,
      readOnly: $,
      rtlEnabled: K,
      tabIndex: te,
      text: z,
      validationError: ie,
      validationErrors: pe,
      validationMessageMode: _e,
      validationMessagePosition: be,
      validationStatus: De,
      value: Ce,
      visible: ft,
      width: Ve
    },
    restAttributes: Ee
  } = t;
  return Uo(zi(2, pX, ae({
    aria: e,
    classes: i,
    onClick: a,
    onKeyDown: n,
    accessKey: o,
    activeStateEnabled: u,
    focusStateEnabled: v,
    hoverStateEnabled: b,
    className: c,
    disabled: p,
    readOnly: $,
    hint: y,
    height: _,
    width: Ve,
    rtlEnabled: K,
    tabIndex: te,
    visible: ft,
    validationError: ie,
    validationErrors: pe,
    validationMessageMode: _e,
    validationMessagePosition: be,
    validationStatus: De,
    isValid: A,
    onFocusIn: B
  }, Ee, {
    children: sc([Uo(Fr(64, "input", null, null, 1, ae({
      type: "hidden",
      value: "".concat(Ce)
    }, L && {
      name: L
    }))), Fr(1, "div", "dx-checkbox-container", [zi(2, mX, {
      size: I,
      isChecked: Ce === !0
    }), z && Fr(1, "span", "dx-checkbox-text", z, 0)], 0)], 4)
  }), null, r));
}, un = Object.create(Object.prototype, ae(Object.getOwnPropertyDescriptors(qr), Object.getOwnPropertyDescriptors({
  text: "",
  enableThreeStateBehavior: !1,
  activeStateEnabled: !0,
  hoverStateEnabled: !0,
  get focusStateEnabled() {
    return Ye.real().deviceType === "desktop" && !Ye.isSimulator();
  },
  defaultValue: !1,
  valueChange: () => {
  }
}))), y0e = {
  get text() {
    return un.text;
  },
  get enableThreeStateBehavior() {
    return un.enableThreeStateBehavior;
  },
  get activeStateEnabled() {
    return un.activeStateEnabled;
  },
  get hoverStateEnabled() {
    return un.hoverStateEnabled;
  },
  get focusStateEnabled() {
    return un.focusStateEnabled;
  },
  get defaultValue() {
    return un.defaultValue;
  },
  get valueChange() {
    return un.valueChange;
  },
  get readOnly() {
    return un.readOnly;
  },
  get name() {
    return un.name;
  },
  get validationError() {
    return un.validationError;
  },
  get validationErrors() {
    return un.validationErrors;
  },
  get validationMessageMode() {
    return un.validationMessageMode;
  },
  get validationMessagePosition() {
    return un.validationMessagePosition;
  },
  get validationStatus() {
    return un.validationStatus;
  },
  get isValid() {
    return un.isValid;
  },
  get isDirty() {
    return un.isDirty;
  },
  get inputAttr() {
    return un.inputAttr;
  },
  get className() {
    return un.className;
  },
  get disabled() {
    return un.disabled;
  },
  get tabIndex() {
    return un.tabIndex;
  },
  get visible() {
    return un.visible;
  },
  get aria() {
    return ST.aria;
  }
};
let $T = class extends aS {
  constructor(e) {
    super(e), this.editorRef = Vn(), this.state = {
      value: this.props.value !== void 0 ? this.props.value : this.props.defaultValue
    }, this.focus = this.focus.bind(this), this.blur = this.blur.bind(this), this.onWidgetClick = this.onWidgetClick.bind(this), this.keyDown = this.keyDown.bind(this);
  }
  createEffects() {
    return [oS()];
  }
  onWidgetClick(e) {
    var {
      enableThreeStateBehavior: i,
      readOnly: r,
      saveValueChangeEvent: n
    } = this.props;
    if (!r)
      if (n == null || n(e), i) {
        var a;
        this.setState((u) => (a = (this.props.value !== void 0 ? this.props.value : u.value) === null || ((this.props.value !== void 0 ? this.props.value : u.value) ? !1 : null), {
          value: a
        })), this.props.valueChange(a);
      } else {
        var o;
        this.setState((u) => {
          var c;
          return o = !((c = this.props.value !== void 0 ? this.props.value : u.value) !== null && c !== void 0 && c), {
            value: o
          };
        }), this.props.valueChange(o);
      }
  }
  keyDown(e) {
    var {
      onKeyDown: i
    } = this.props, {
      keyName: r,
      originalEvent: n,
      which: a
    } = e, o = i == null ? void 0 : i(e);
    if (o != null && o.cancel)
      return o;
    (r === "space" || a === "space") && (n.preventDefault(), this.onWidgetClick(n));
  }
  get cssClasses() {
    return _0e(ae({}, this.props, {
      value: this.props.value !== void 0 ? this.props.value : this.state.value
    }));
  }
  get aria() {
    var e = (this.props.value !== void 0 ? this.props.value : this.state.value) === !0, i = (this.props.value !== void 0 ? this.props.value : this.state.value) === null, r = {
      role: "checkbox",
      checked: i ? "mixed" : "".concat(e)
    };
    return ae({}, r, this.props.aria);
  }
  get restAttributes() {
    var e = ae({}, this.props, {
      value: this.props.value !== void 0 ? this.props.value : this.state.value
    }), i = sr(e, m0e);
    return i;
  }
  focus() {
    this.editorRef.current.focus();
  }
  blur() {
    this.editorRef.current.blur();
  }
  render() {
    var e = this.props;
    return C0e({
      props: ae({}, e, {
        value: this.props.value !== void 0 ? this.props.value : this.state.value
      }),
      editorRef: this.editorRef,
      onWidgetClick: this.onWidgetClick,
      keyDown: this.keyDown,
      cssClasses: this.cssClasses,
      aria: this.aria,
      restAttributes: this.restAttributes
    });
  }
};
function x0e(t) {
  var e = ["value"];
  return Object.keys(t).reduce((i, r) => {
    var n = t[r], a = e.some((o) => o === r) ? "default" + r.charAt(0).toUpperCase() + r.slice(1) : r;
    return i[a] = n, i;
  }, {});
}
$T.defaultProps = y0e;
var o4 = [];
function S0e(t) {
  o4.push(t), $T.defaultProps = Object.create(Object.prototype, ae(Object.getOwnPropertyDescriptors($T.defaultProps), Object.getOwnPropertyDescriptors(x0e(Rm(o4)))));
}
class kp extends KSe {
  getProps() {
    var e = super.getProps();
    return e.onKeyDown = this._wrapKeyDownHandler(e.onKeyDown), e;
  }
  focus() {
    var e;
    return (e = this.viewRef) === null || e === void 0 ? void 0 : e.focus(...arguments);
  }
  blur() {
    var e;
    return (e = this.viewRef) === null || e === void 0 ? void 0 : e.blur(...arguments);
  }
  _getActionConfigs() {
    return {
      onFocusIn: {},
      onClick: {}
    };
  }
  get _propsInfo() {
    return {
      twoWay: [
        ["value", "defaultValue", "valueChange"]
      ],
      allowNull: ["defaultValue", "validationError", "validationErrors", "value"],
      elements: [],
      templates: [],
      props: ["text", "iconSize", "enableThreeStateBehavior", "activeStateEnabled", "hoverStateEnabled", "focusStateEnabled", "saveValueChangeEvent", "defaultValue", "valueChange", "readOnly", "name", "validationError", "validationErrors", "validationMessageMode", "validationMessagePosition", "validationStatus", "isValid", "isDirty", "inputAttr", "onFocusIn", "className", "accessKey", "disabled", "height", "hint", "onClick", "onKeyDown", "rtlEnabled", "tabIndex", "visible", "width", "aria", "value"]
    };
  }
  get _viewComponent() {
    return $T;
  }
}
ti("dxCheckBox", kp);
kp.defaultOptions = S0e;
var ps = "dx-treeview", no = "".concat(ps, "-node"), Pd = "".concat(no, "-container"), oM = "".concat(no, "-loadindicator"), dh = "".concat(no, "-container-opened"), Ly = "".concat(no, "-is-leaf"), ga = "".concat(ps, "-item"), E0e = "".concat(ga, "-with-checkbox"), b0e = "".concat(ga, "-with-custom-expander-icon"), w0e = "".concat(ps, "-custom-expander-icon-item-container"), T0e = "".concat(ga, "-without-checkbox"), I0e = "".concat(ga, "-data"), My = "".concat(ps, "-toggle-item-visibility"), sM = "".concat(ps, "-custom-collapse-icon"), lM = "".concat(ps, "-custom-expand-icon"), D0e = "".concat(ps, "-loadindicator"), A0e = "".concat(ps, "-loadindicator-wrapper"), s4 = "".concat(ps, "-toggle-item-visibility-opened"), cw = "".concat(ps, "-select-all-item"), l4 = "dx-state-invisible", ky = "dx-state-disabled", O0e = "dx-state-selected", uM = "dxTreeView_expand", hw = "data-item-id", R0e = "dx-item-url", u4 = "dx-checkbox", L0e = "dx-checkbox-icon", M0e = "".concat(ps, "-root-node"), k0e = "".concat(ps, "-expander-icon-stub"), P0e = W5.inherit({
  _supportedKeys: function(t) {
    var e = (n) => {
      var a = E(this.option("focusedElement"));
      if (a.length) {
        n.target = a, n.currentTarget = a, this._itemClickHandler(n, a.children("." + ga));
        var o = this._getEventNameByOption(this.option("expandEvent")), u = o === ve(di, uM);
        u && this._expandEventHandler(n);
      }
    }, i = (n) => {
      n.preventDefault();
      var a = E(this.option("focusedElement")), o = this._getCheckBoxInstance(a);
      if (!o.option("disabled")) {
        var u = o.option("value");
        this._updateItemSelection(!u, a.find("." + ga).get(0), !0);
      }
    }, r = function(n, a) {
      if (this.option("expandAllEnabled")) {
        a.preventDefault();
        var o = E(this.option("focusedElement"));
        if (o.length) {
          var u = this._getItemData(o.find(".".concat(ga)));
          this._toggleExpandedNestedItems([u], n);
        }
      }
    };
    return P(this.callBase(), {
      enter: this._showCheckboxes() ? i : e,
      space: this._showCheckboxes() ? i : e,
      asterisk: r.bind(this, !0),
      minus: r.bind(this, !1)
    });
  },
  _toggleExpandedNestedItems: function(t, e) {
    if (t)
      for (var i = 0, r = t.length; i < r; i++) {
        var n = t[i], a = this._dataAdapter.getNodeByItem(n);
        this._toggleExpandedState(a, e), this._toggleExpandedNestedItems(n.items, e);
      }
  },
  _getNodeElement: function(t, e) {
    var i = this._encodeString(t.internalFields.key);
    if (e)
      return e.$nodeByKey || (e.$nodeByKey = {}, this.$element().find(".".concat(no)).each(function() {
        var n = E(this), a = n.attr(hw);
        e.$nodeByKey[a] = n;
      })), e.$nodeByKey[i] || E();
    var r = this.$element().get(0).querySelector("[".concat(hw, '="').concat(i, '"]'));
    return E(r);
  },
  _activeStateUnit: "." + ga,
  _widgetClass: function() {
    return ps;
  },
  _getDefaultOptions: function() {
    var t = P(this.callBase(), {
      animationEnabled: !0,
      dataStructure: "tree",
      deferRendering: !0,
      expandAllEnabled: !1,
      hasItemsExpr: "hasItems",
      selectNodesRecursive: !0,
      expandNodesRecursive: !0,
      showCheckBoxesMode: "none",
      expandIcon: null,
      collapseIcon: null,
      selectAllText: X.format("dxList-selectAll"),
      onItemSelectionChanged: null,
      onItemExpanded: null,
      onItemCollapsed: null,
      scrollDirection: "vertical",
      useNativeScrolling: !0,
      virtualModeEnabled: !1,
      rootValue: 0,
      focusStateEnabled: !1,
      selectionMode: "multiple",
      expandEvent: "dblclick",
      selectByClick: !1,
      createChildren: null,
      onSelectAllValueChanged: null
    });
    return P(!0, t, {
      integrationOptions: {
        useDeferUpdateForTemplates: !1
      }
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: function() {
        return !Dp;
      },
      options: {
        useNativeScrolling: !1
      }
    }]);
  },
  _initSelectedItems: ee,
  _syncSelectionOptions: tj,
  _fireSelectionChanged: function() {
    var t = this._selectionChangePromise;
    $e(t).done((function() {
      this._createActionByOption("onSelectionChanged", {
        excludeValidators: ["disabled", "readOnly"]
      })();
    }).bind(this));
  },
  _createSelectAllValueChangedAction: function() {
    this._selectAllValueChangedAction = this._createActionByOption("onSelectAllValueChanged", {
      excludeValidators: ["disabled", "readOnly"]
    });
  },
  _fireSelectAllValueChanged: function(t) {
    this._selectAllValueChangedAction({
      value: t
    });
  },
  _checkBoxModeChange: function(t, e) {
    var i = this.option("searchEnabled"), r = this._selectAllEnabled(e), n = this._itemContainer(i, r);
    if (this._detachClickEvent(n), this._detachExpandEvent(n), !(e === "none" || t === "none")) {
      var a = this._$selectAllItem && this._$selectAllItem.length;
      switch (t) {
        case "selectAll":
          a || (this._createSelectAllValueChangedAction(), this._renderSelectAllItem());
          break;
        case "normal":
          a && (this._$selectAllItem.remove(), delete this._$selectAllItem);
      }
    }
  },
  _removeSelection: function() {
    var t = this;
    N(this._dataAdapter.getFullData(), function(e, i) {
      t._hasChildren(i) && t._dataAdapter.toggleSelection(i.internalFields.key, !1, !0);
    });
  },
  _optionChanged: function(t) {
    var {
      name: e,
      value: i,
      previousValue: r
    } = t;
    switch (e) {
      case "selectAllText":
        this._$selectAllItem && this._$selectAllItem.dxCheckBox("instance").option("text", i);
        break;
      case "showCheckBoxesMode":
        this._checkBoxModeChange(i, r), this._invalidate();
        break;
      case "scrollDirection":
        this.getScrollable().option("direction", i);
        break;
      case "useNativeScrolling":
        this.getScrollable().option("useNative", i);
        break;
      case "items":
        delete this._$selectAllItem, this.callBase(t);
        break;
      case "dataSource":
        this.callBase(t), this._initDataAdapter(), this._filter = {};
        break;
      case "hasItemsExpr":
        this._initAccessors(), this.repaint();
        break;
      case "expandEvent":
        this._attachExpandEvent();
        break;
      case "deferRendering":
      case "dataStructure":
      case "rootValue":
      case "createChildren":
      case "expandNodesRecursive":
      case "onItemSelectionChanged":
      case "onItemExpanded":
      case "onItemCollapsed":
      case "expandAllEnabled":
      case "animationEnabled":
      case "virtualModeEnabled":
      case "selectByClick":
        break;
      case "selectionMode":
        this._initDataAdapter(), this.callBase(t);
        break;
      case "onSelectAllValueChanged":
        this._createSelectAllValueChangedAction();
        break;
      case "selectNodesRecursive":
        this._dataAdapter.setOption("recursiveSelection", t.value), this.repaint();
        break;
      case "expandIcon":
      case "collapseIcon":
        this.repaint();
        break;
      default:
        this.callBase(t);
    }
  },
  _initDataSource: function() {
    this._useCustomChildrenLoader() ? this._loadChildrenByCustomLoader(null).done((function(t) {
      t && t.length && this.option("items", t);
    }).bind(this)) : (this.callBase(), this._isVirtualMode() && this._initVirtualMode());
  },
  _initVirtualMode: function() {
    var t = this._filter;
    t.custom || (t.custom = this._dataSource.filter()), t.internal || (t.internal = [this.option("parentIdExpr"), this.option("rootValue")]);
  },
  _useCustomChildrenLoader: function() {
    return Le(this.option("createChildren")) && this._isDataStructurePlain();
  },
  _loadChildrenByCustomLoader: function(t) {
    var e = this.option("createChildren").call(this, t);
    return Array.isArray(e) ? new q().resolve(e).promise() : e && Le(e.then) ? Pn(e) : new q().resolve([]).promise();
  },
  _combineFilter: function() {
    return !this._filter.custom || !this._filter.custom.length ? this._filter.internal : [this._filter.custom, this._filter.internal];
  },
  _dataSourceLoadErrorHandler: function() {
    this._renderEmptyMessage();
  },
  _init: function() {
    this._filter = {}, this.callBase(), this._initStoreChangeHandlers();
  },
  _dataSourceChangedHandler: function(t) {
    var e = this.option("items");
    this._initialized && this._isVirtualMode() && e.length || this.option("items", t);
  },
  _removeTreeViewLoadIndicator: function() {
    this._treeViewLoadIndicator && (this._treeViewLoadIndicator.remove(), this._treeViewLoadIndicator = null);
  },
  _createTreeViewLoadIndicator: function() {
    return this._treeViewLoadIndicator = E("<div>").addClass(D0e), this._createComponent(this._treeViewLoadIndicator, us, {}), this._treeViewLoadIndicator;
  },
  _dataSourceLoadingChangedHandler: function(t) {
    var e;
    if (this._isVirtualMode() && (e = this._combineFilter(), this._dataSource.filter(e)), t && !this._dataSource.isLoaded()) {
      this.option("items", []);
      var i = E("<div>").addClass(A0e);
      this._createTreeViewLoadIndicator().appendTo(i), this.itemsContainer().append(i), this._isVirtualMode() && this._dataSource.filter() !== e && this._dataSource.filter([]);
    } else
      this._removeTreeViewLoadIndicator();
  },
  _initStoreChangeHandlers: function() {
    this.option("dataStructure") === "plain" && this._dataSource && this._dataSource.store().on("inserted", (t) => {
      this.option().items = this.option("items").concat(t), this._dataAdapter.addItem(t), this._dataAdapter.isFiltered(t) && this._updateLevel(this._parentIdGetter(t));
    }).on("removed", (t) => {
      var e = this._dataAdapter.getNodeByKey(t);
      R(e) && (this.option("items")[this._dataAdapter.getIndexByKey(e.internalFields.key)] = 0, this._markChildrenItemsToRemove(e), this._removeItems(), this._dataAdapter.removeItem(t), this._updateLevel(this._parentIdGetter(e)));
    });
  },
  _markChildrenItemsToRemove: function(t) {
    var e = t.internalFields.childrenKeys;
    N(e, (i, r) => {
      this.option("items")[this._dataAdapter.getIndexByKey(r)] = 0, this._markChildrenItemsToRemove(this._dataAdapter.getNodeByKey(r));
    });
  },
  _removeItems: function() {
    var t = P(!0, [], this.option("items")), e = 0;
    N(t, (i, r) => {
      r || (this.option("items").splice(i - e, 1), e++);
    });
  },
  _updateLevel: function(t) {
    var e = this._getContainerByParentKey(t);
    this._renderItems(e, this._dataAdapter.getChildrenNodes(t));
  },
  _getOldContainer: function(t) {
    if (t.length)
      return t.children(".".concat(Pd));
    var e = this.getScrollable();
    return e ? E(e.content()).children() : E();
  },
  _getContainerByParentKey: function(t) {
    var e = this._dataAdapter.getNodeByKey(t), i = e ? this._getNodeElement(e) : [];
    this._getOldContainer(i).remove();
    var r = this._renderNodeContainer(i);
    if (this._isRootLevel(t)) {
      var n = this.getScrollable();
      n || this._renderScrollableContainer(), E(n.content()).append(r);
    }
    return r;
  },
  _isRootLevel: function(t) {
    return t === this.option("rootValue");
  },
  _getAccessors: function() {
    var t = this.callBase();
    return t.push("hasItems"), t;
  },
  _getDataAdapterOptions: function() {
    var t, e, i;
    return {
      rootValue: this.option("rootValue"),
      multipleSelection: !this._isSingleSelection(),
      recursiveSelection: this._isRecursiveSelection(),
      recursiveExpansion: this.option("expandNodesRecursive"),
      selectionRequired: this.option("selectionRequired"),
      dataType: this.option("dataStructure"),
      sort: this._dataSource && this._dataSource.sort(),
      langParams: (t = this._dataSource) === null || t === void 0 || (e = t.loadOptions) === null || e === void 0 || (i = e.call(t)) === null || i === void 0 ? void 0 : i.langParams
    };
  },
  _initMarkup() {
    this._renderScrollableContainer(), this._renderEmptyMessage(this._dataAdapter.getRootNodes()), this.callBase(), this._setAriaRole();
  },
  _setAriaRole() {
    var {
      items: t
    } = this.option();
    t != null && t.length && this.setAria({
      role: "tree"
    });
  },
  _renderContentImpl: function() {
    var t = this._renderNodeContainer();
    E(this.getScrollable().content()).append(t), !(!this.option("items") || !this.option("items").length) && (this._renderItems(t, this._dataAdapter.getRootNodes()), this._attachExpandEvent(), this._selectAllEnabled() && (this._createSelectAllValueChangedAction(), this._renderSelectAllItem(t)));
  },
  _isVirtualMode: function() {
    return this.option("virtualModeEnabled") && this._isDataStructurePlain() && !!this.option("dataSource");
  },
  _isDataStructurePlain: function() {
    return this.option("dataStructure") === "plain";
  },
  _fireContentReadyAction: function() {
    var t = this.getDataSource(), e = t && !t.isLoaded() || this._skipContentReadyAndItemExpanded, i = this.getScrollable();
    i && wt() && i.update(), e || this.callBase(), i && wt() && i.update();
  },
  _renderScrollableContainer: function() {
    this._scrollable = this._createComponent(E("<div>").appendTo(this.$element()), ds, {
      useNative: this.option("useNativeScrolling"),
      direction: this.option("scrollDirection"),
      useKeyboard: !1
    });
  },
  _renderNodeContainer: function(t) {
    var e = E("<ul>").addClass(Pd);
    if (this.setAria("role", "group", e), t && t.length) {
      var i = this._getItemData(t.children("." + ga));
      this._expandedGetter(i) && e.addClass(dh), e.appendTo(t);
    }
    return e;
  },
  _createDOMElement: function(t, e) {
    var i, r, n = E("<li>").addClass(no).attr(hw, this._encodeString(e.internalFields.key)).prependTo(t), a = {
      role: "treeitem",
      label: this._displayGetter(e.internalFields.item) || "",
      level: this._getLevel(t)
    }, o = !!(e != null && (i = e.internalFields) !== null && i !== void 0 && (r = i.childrenKeys) !== null && r !== void 0 && r.length);
    return o && (a.expanded = e.internalFields.expanded || !1), this.setAria(a, n), n;
  },
  _getLevel: function(t) {
    var e = t.parent();
    return e.hasClass("dx-scrollable-content") ? 1 : parseInt(e.attr("aria-level")) + 1;
  },
  _showCheckboxes: function() {
    return this.option("showCheckBoxesMode") !== "none";
  },
  _hasCustomExpanderIcons: function() {
    return this.option("expandIcon") || this.option("collapseIcon");
  },
  _selectAllEnabled: function(t) {
    var e = t ?? this.option("showCheckBoxesMode");
    return e === "selectAll" && !this._isSingleSelection();
  },
  _renderItems: function(t, e) {
    for (var i = e.length - 1, r = i; r >= 0; r--)
      this._renderItem(r, e[r], t);
    this._renderedItemsCount += e.length;
  },
  _renderItem: function(t, e, i) {
    var r = this._createDOMElement(i, e), n = e.internalFields, a = this._showCheckboxes();
    r.addClass(a ? E0e : T0e), r.toggleClass(l4, n.item.visible === !1), this._hasCustomExpanderIcons() && (r.addClass(b0e), i.addClass(w0e)), this.setAria("selected", n.selected, r), this._toggleSelectedClass(r, n.selected), n.disabled && this.setAria("disabled", n.disabled, r), this.callBase(this._renderedItemsCount + t, n.item, r);
    var o = this._getNode(e.internalFields.parentKey);
    o || r.addClass(M0e), n.item.visible !== !1 && this._renderChildren(r, e);
  },
  _setAriaSelectionAttribute: ee,
  _renderChildren: function(t, e) {
    if (!this._hasChildren(e)) {
      this._addLeafClass(t), E("<div>").addClass(k0e).appendTo(this._getItem(t));
      return;
    }
    this._hasCustomExpanderIcons() ? this._renderCustomExpanderIcons(t, e) : this._renderDefaultExpanderIcons(t, e), this._shouldRenderSublevel(e.internalFields.expanded) && this._loadSublevel(e).done((i) => {
      this._renderSublevel(t, this._getActualNode(e), i);
    });
  },
  _shouldRenderSublevel: function(t) {
    return t || !this.option("deferRendering");
  },
  _getActualNode: function(t) {
    return this._dataAdapter.getNodeByKey(t.internalFields.key);
  },
  _hasChildren: function(t) {
    return this._isVirtualMode() || this._useCustomChildrenLoader() ? this._hasItemsGetter(t.internalFields.item) !== !1 : this.callBase(t);
  },
  _loadSublevel: function(t) {
    var e = new q(), i = this._getChildNodes(t);
    return i.length ? e.resolve(i) : this._loadNestedItems(t).done((r) => {
      e.resolve(this._dataAdapter.getNodesByItems(r));
    }), e.promise();
  },
  _getItemExtraPropNames: () => ["url", "linkAttr"],
  _addContent: function(t, e) {
    var {
      html: i,
      url: r
    } = e;
    if (r) {
      t.html(i);
      var n = this._getLinkContainer(this._getIconContainer(e), this._getTextContainer(e), e);
      t.append(n);
    } else
      this.callBase(t, e);
  },
  _postprocessRenderItem(t) {
    var {
      itemData: e,
      itemElement: i
    } = t;
    this._showCheckboxes() && this._renderCheckBox(i, this._getNode(e)), this.callBase(t);
  },
  _renderSublevel: function(t, e, i) {
    var r = this._renderNodeContainer(t, e), n = i.filter((o) => e.internalFields.childrenKeys.indexOf(o.internalFields.key) !== -1);
    if (this._renderItems(r, n), n.length && !e.internalFields.selected) {
      var a = n[0];
      this._updateParentsState(a, this._getNodeElement(a));
    }
    this._normalizeIconState(t, n.length), e.internalFields.expanded && r.addClass(dh);
  },
  _executeItemRenderAction: function(t, e, i) {
    var r = this._getNode(i);
    this._getItemRenderAction()({
      itemElement: i,
      itemIndex: t,
      itemData: e,
      node: this._dataAdapter.getPublicNode(r)
    });
  },
  _addLeafClass: function(t) {
    t.addClass(Ly);
  },
  _expandEventHandler: function(t) {
    var e = E(t.currentTarget.parentNode);
    e.hasClass(Ly) || this._toggleExpandedState(t.currentTarget, void 0, t);
  },
  _attachExpandEvent: function() {
    var t = this._getEventNameByOption(this.option("expandEvent")), e = this._itemContainer();
    this._detachExpandEvent(e), k.on(e, t, this._itemSelector(), this._expandEventHandler.bind(this));
  },
  _detachExpandEvent(t) {
    k.off(t, ".".concat(uM), this._itemSelector());
  },
  _getEventNameByOption: function(t) {
    var e = t === "click" ? di : Um;
    return ve(e, uM);
  },
  _getNode: function(t) {
    if (!R(t))
      return null;
    if (t.internalFields)
      return t;
    if (sx(t))
      return this._dataAdapter.getNodeByKey(t);
    var e = E(t).get(0);
    return e ? de.isElementNode(e) ? this._getNodeByElement(e) : this._dataAdapter.getNodeByItem(e) : null;
  },
  _getNodeByElement: function(t) {
    var e = E(t).closest("." + no), i = this._decodeString(e.attr(hw));
    return this._dataAdapter.getNodeByKey(i);
  },
  _toggleExpandedState: function(t, e, i) {
    var r = this._getNode(t);
    if (!r)
      return new q().reject().promise();
    if (r.internalFields.disabled)
      return new q().reject().promise();
    var n = r.internalFields.expanded;
    if (n === e)
      return new q().resolve().promise();
    if (this._hasChildren(r)) {
      var a = this._getNodeElement(r);
      if (a.find(".".concat(oM, ":not(.").concat(l4, ")")).length)
        return new q().reject().promise();
      !n && !this._nodeHasRenderedChildren(a) && this._createLoadIndicator(a);
    }
    return R(e) || (e = !n), this._dataAdapter.toggleExpansion(r.internalFields.key, e), this._updateExpandedItemsUI(r, e, i);
  },
  _nodeHasRenderedChildren(t) {
    var e = t.children(".".concat(Pd));
    return e.not(":empty").length;
  },
  _getItem: function(t) {
    return t.children(".".concat(ga)).eq(0);
  },
  _createLoadIndicator: function(t) {
    var e = this._getItem(t);
    this._createComponent(E("<div>").addClass(oM), us, {}).$element().appendTo(e);
    var i = e.children(".".concat(My, ",.").concat(lM));
    i.hide();
  },
  _renderExpanderIcon: function(t, e, i, r) {
    i.appendTo(this._getItem(t)), i.addClass(r), e.internalFields.disabled && i.addClass(ky), this._renderToggleItemVisibilityIconClick(i, e);
  },
  _renderDefaultExpanderIcons: function(t, e) {
    var i = this._getItem(t), r = E("<div>").addClass(My).appendTo(i);
    e.internalFields.expanded && (r.addClass(s4), t.parent().addClass(dh)), e.internalFields.disabled && r.addClass(ky), this._renderToggleItemVisibilityIconClick(r, e);
  },
  _renderCustomExpanderIcons: function(t, e) {
    var {
      expandIcon: i,
      collapseIcon: r
    } = this.option(), n = ec(i ?? r), a = ec(r ?? i);
    this._renderExpanderIcon(t, e, n, lM), this._renderExpanderIcon(t, e, a, sM);
    var o = e.internalFields.expanded;
    o && t.parent().addClass(dh), this._toggleCustomExpanderIcons(n, a, o);
  },
  _renderToggleItemVisibilityIconClick: function(t, e) {
    var i = ve(di, this.NAME);
    k.off(t, i), k.on(t, i, (r) => (this._toggleExpandedState(e.internalFields.key, void 0, r), !1));
  },
  _toggleCustomExpanderIcons: function(t, e, i) {
    e.toggle(i), t.toggle(!i);
  },
  _updateExpandedItemsUI: function(t, e, i) {
    var r = this._getNodeElement(t), n = !r.length || e && r.is(":hidden");
    if (this.option("expandNodesRecursive") && n) {
      var a = this._getNode(t.internalFields.parentKey);
      a && this._updateExpandedItemsUI(a, e, i);
    }
    if (this._hasCustomExpanderIcons()) {
      if (this._nodeHasRenderedChildren(r)) {
        var u = this._getItem(r), c = u.children(".".concat(lM)), p = u.children(".".concat(sM));
        this._toggleCustomExpanderIcons(c, p, e);
      }
    } else {
      var o = this._getItem(r).children(".".concat(My));
      o.toggleClass(s4, e);
    }
    var v = r.children(".".concat(Pd)), _ = v.length > 0, y = new q();
    return !e || _ && !v.is(":empty") ? (this._animateNodeContainer(t, e, i, y), y.promise()) : t.internalFields.childrenKeys.length === 0 && (this._isVirtualMode() || this._useCustomChildrenLoader()) ? (this._loadNestedItemsWithUpdate(t, e, i, y), y.promise()) : (this._renderSublevel(r, t, this._getChildNodes(t)), this._fireContentReadyAction(), this._animateNodeContainer(t, e, i, y), y.promise());
  },
  _loadNestedItemsWithUpdate: function(t, e, i, r) {
    var n = this._getNodeElement(t);
    this._loadNestedItems(t).done((a) => {
      var o = this._getActualNode(t);
      if (this._renderSublevel(n, o, this._dataAdapter.getNodesByItems(a)), !a || !a.length) {
        r.resolve();
        return;
      }
      this._fireContentReadyAction(), this._animateNodeContainer(o, e, i, r);
    });
  },
  _loadNestedItems: function(t) {
    if (this._useCustomChildrenLoader()) {
      var e = this._dataAdapter.getPublicNode(t);
      return this._loadChildrenByCustomLoader(e).done((i) => {
        this._areNodesExists(i) || this._appendItems(i);
      });
    }
    return this._isVirtualMode() ? (this._filter.internal = [this.option("parentIdExpr"), t.internalFields.key], this._dataSource.filter(this._combineFilter()), this._dataSource.load().done((i) => {
      this._areNodesExists(i) || this._appendItems(i);
    })) : new q().resolve([]).promise();
  },
  _areNodesExists: function(t, e) {
    var i = this.keyOf(t[0]), r = this._dataAdapter.getFullData();
    return !!this._dataAdapter.getNodeByKey(i, r);
  },
  _appendItems: function(t) {
    this.option().items = this.option("items").concat(t), this._initDataAdapter();
  },
  _animateNodeContainer: function(t, e, i, r) {
    var n = this._getNodeElement(t), a = n.children(".".concat(Pd));
    t && r && a.length === 0 && r.resolve(), a.addClass(dh);
    var o = Pt(a);
    ji.stop(a, !0), ji.animate(a, {
      type: "custom",
      duration: this.option("animationEnabled") ? 400 : 0,
      from: {
        maxHeight: e ? 0 : o
      },
      to: {
        maxHeight: e ? o : 0
      },
      complete: (function() {
        a.css("maxHeight", "none"), a.toggleClass(dh, e), this.setAria("expanded", e, n), this.getScrollable().update(), this._fireExpandedStateUpdatedEvent(e, t, i), r && r.resolve();
      }).bind(this)
    });
  },
  _fireExpandedStateUpdatedEvent: function(t, e, i) {
    if (!(!this._hasChildren(e) || this._skipContentReadyAndItemExpanded)) {
      var r = t ? "onItemExpanded" : "onItemCollapsed";
      if (R(i))
        this._itemDXEventHandler(i, r, {
          node: this._dataAdapter.getPublicNode(e)
        });
      else {
        var n = this._getNodeElement(e);
        this._itemEventHandler(n, r, {
          event: i,
          node: this._dataAdapter.getPublicNode(e)
        });
      }
    }
  },
  _normalizeIconState: function(t, e) {
    var i = t.find(".".concat(oM));
    if (i.length) {
      var r;
      (r = us.getInstance(i)) === null || r === void 0 || r.option("visible", !1);
    }
    var n = this._getItem(t), a = n.children(".".concat(sM, ",.").concat(My));
    if (e) {
      a.show();
      return;
    }
    a.removeClass(My), t.addClass(Ly);
  },
  _emptyMessageContainer: function() {
    var t = this.getScrollable();
    return t ? E(t.content()) : this.callBase();
  },
  _renderContent: function() {
    var t = this.option("items");
    t && t.length && (this._contentAlreadyRendered = !0), this.callBase();
  },
  _renderSelectAllItem: function(t) {
    var {
      selectAllText: e,
      focusStateEnabled: i
    } = this.option();
    t = t || this.$element().find(".".concat(Pd)).first(), this._$selectAllItem = E("<div>").addClass(cw);
    var r = this._dataAdapter.isAllSelected();
    this._createComponent(this._$selectAllItem, kp, {
      value: r,
      elementAttr: {
        "aria-label": "Select All"
      },
      text: e,
      focusStateEnabled: i,
      onValueChanged: this._onSelectAllCheckboxValueChanged.bind(this),
      onInitialized: (n) => {
        var {
          component: a
        } = n;
        a.registerKeyHandler("enter", () => {
          a.option("value", !a.option("value"));
        });
      }
    }), this._toggleSelectedClass(this._$selectAllItem, r), t.before(this._$selectAllItem);
  },
  _onSelectAllCheckboxValueChanged: function(t) {
    this._toggleSelectAll(t), this._fireSelectAllValueChanged(t.value);
  },
  _toggleSelectAll: function(t) {
    this._dataAdapter.toggleSelectAll(t.value), this._updateItemsUI(), this._fireSelectionChanged();
  },
  _renderCheckBox: function(t, e) {
    var i = E("<div>").appendTo(t);
    this._createComponent(i, kp, {
      value: e.internalFields.selected,
      onValueChanged: this._changeCheckboxValue.bind(this),
      focusStateEnabled: !1,
      elementAttr: {
        "aria-label": "Check State"
      },
      disabled: this._disabledGetter(e)
    });
  },
  _toggleSelectedClass: function(t, e) {
    t.toggleClass(O0e, !!e);
  },
  _toggleNodeDisabledState: function(t, e) {
    var i = this._getNodeElement(t), r = i.find("." + ga).eq(0);
    if (this._dataAdapter.toggleNodeDisabledState(t.internalFields.key, e), r.toggleClass(ky, !!e), this._showCheckboxes()) {
      var n = this._getCheckBoxInstance(i);
      n.option("disabled", !!e);
    }
  },
  _itemOptionChanged: function(t, e, i) {
    var r = this._dataAdapter.getNodeByItem(t);
    e === this.option("disabledExpr") && this._toggleNodeDisabledState(r, i);
  },
  _changeCheckboxValue: function(t) {
    var e = E(t.element).closest(".".concat(no)), i = this._getItem(e), r = this._getItemData(i), n = this._getNodeByElement(i), a = t.value;
    n && n.internalFields.selected === a || this._updateItemSelection(a, r, t.event);
  },
  _isSingleSelection: function() {
    return this.option("selectionMode") === "single";
  },
  _isRecursiveSelection: function() {
    return this.option("selectNodesRecursive") && this.option("selectionMode") !== "single";
  },
  _isLastSelectedBranch: function(t, e, i) {
    var r = e.indexOf(t.key);
    return r >= 0 && e.splice(r, 1), i && N(t.children, (function(n, a) {
      this._isLastSelectedBranch(a, e, !0);
    }).bind(this)), t.parent && this._isLastSelectedBranch(t.parent, e), e.length === 0;
  },
  _isLastRequired: function(t) {
    var e = this.option("selectionRequired"), i = this._isSingleSelection(), r = this.getSelectedNodeKeys();
    if (e)
      return i ? r.length === 1 : this._isLastSelectedBranch(t.internalFields.publicNode, r.slice(), !0);
  },
  _updateItemSelection: function(t, e, i) {
    var r = this._getNode(e);
    if (!r || r.visible === !1)
      return !1;
    if (r.internalFields.selected === t)
      return !0;
    if (!t && this._isLastRequired(r)) {
      if (this._showCheckboxes()) {
        var n = this._getNodeElement(r);
        this._getCheckBoxInstance(n).option("value", !0);
      }
      return !1;
    }
    if (t && this._isSingleSelection()) {
      var a = this.getSelectedNodeKeys();
      N(a, (c, p) => {
        this._dataAdapter.toggleSelection(p, !1), this._updateItemsUI(), this._fireItemSelectionChanged(this._getNode(p));
      });
    }
    this._dataAdapter.toggleSelection(r.internalFields.key, t);
    var o = this._dataAdapter.isAllSelected(), u = this._selectAllEnabled() && this._$selectAllItem.dxCheckBox("instance").option("value") !== o;
    return this._updateItemsUI(), this._fireItemSelectionChanged(r, i), this._fireSelectionChanged(), u && this._fireSelectAllValueChanged(o), !0;
  },
  _fireItemSelectionChanged: function(t, e) {
    var i = e || this._findItemElementByItem(t.internalFields.item), r = e ? this._itemDXEventHandler : this._itemEventHandler;
    r.call(this, i, "onItemSelectionChanged", {
      node: this._dataAdapter.getPublicNode(t),
      itemData: t.internalFields.item
    });
  },
  _getCheckBoxInstance: function(t) {
    var e = this._getItem(t);
    return e.children(".".concat(u4)).dxCheckBox("instance");
  },
  _updateItemsUI: function() {
    var t = {};
    if (N(this._dataAdapter.getData(), (i, r) => {
      var n = this._getNodeElement(r, t), a = r.internalFields.selected;
      n.length && (this._toggleSelectedClass(n, a), this.setAria("selected", a, n), this._showCheckboxes() && this._getCheckBoxInstance(n).option("value", a));
    }), this._selectAllEnabled()) {
      var e = this._$selectAllItem.dxCheckBox("instance");
      e.option("onValueChanged", void 0), e.option("value", this._dataAdapter.isAllSelected()), e.option("onValueChanged", this._onSelectAllCheckboxValueChanged.bind(this));
    }
  },
  _updateParentsState: function(t, e) {
    if (e) {
      var i = this._dataAdapter.getNodeByKey(t.internalFields.parentKey), r = E(e.parents("." + no)[0]);
      if (this._showCheckboxes()) {
        var n = i.internalFields.selected;
        this._getCheckBoxInstance(r).option("value", n), this._toggleSelectedClass(r, n);
      }
      i.internalFields.parentKey !== this.option("rootValue") && this._updateParentsState(i, r);
    }
  },
  _itemEventHandlerImpl: function(t, e, i) {
    var r = E(t).closest("." + no).children("." + ga);
    return e(P(this._extendActionArgs(r), i));
  },
  _itemContextMenuHandler: function(t) {
    this._createEventHandler("onItemContextMenu", t);
  },
  _itemHoldHandler: function(t) {
    this._createEventHandler("onItemHold", t);
  },
  _createEventHandler: function(t, e) {
    var i = this._getNodeByElement(e.currentTarget);
    this._itemDXEventHandler(e, t, {
      node: this._dataAdapter.getPublicNode(i)
    });
  },
  _itemClass: function() {
    return ga;
  },
  _itemDataKey: function() {
    return I0e;
  },
  _attachClickEvent: function() {
    var t = this._itemContainer();
    this._detachClickEvent(t);
    var {
      clickEventNamespace: e,
      itemSelector: i,
      pointerDownEventNamespace: r,
      nodeSelector: n
    } = this._getItemClickEventData();
    k.on(t, e, i, (a) => {
      E(a.target).hasClass(L0e) || E(a.target).hasClass(u4) || this._itemClickHandler(a, E(a.currentTarget));
    }), k.on(t, r, n, (a) => {
      this._itemPointerDownHandler(a);
    });
  },
  _detachClickEvent: function(t) {
    var {
      clickEventNamespace: e,
      itemSelector: i,
      pointerDownEventNamespace: r,
      nodeSelector: n
    } = this._getItemClickEventData();
    k.off(t, e, i), k.off(t, r, n);
  },
  _getItemClickEventData: function() {
    var t = ".".concat(this._itemClass()), e = ".".concat(no, ", .").concat(cw), i = ve(di, this.NAME), r = ve(Xt.down, this.NAME);
    return {
      clickEventNamespace: i,
      itemSelector: t,
      pointerDownEventNamespace: r,
      nodeSelector: e
    };
  },
  _itemClick: function(t) {
    var e = t.args[0], i = e.event.target[0] || e.event.target, r = i.getElementsByClassName(R0e)[0];
    e.itemData.url && r && r.click();
  },
  _itemClickHandler: function(t, e) {
    var i = this._getItemData(e), r = this._getNodeByElement(e);
    this._itemDXEventHandler(t, "onItemClick", {
      node: this._dataAdapter.getPublicNode(r)
    }, {
      beforeExecute: this._itemClick
    }), this.option("selectByClick") && !t.isDefaultPrevented() && this._updateItemSelection(!r.internalFields.selected, i, t);
  },
  _updateSelectionToFirstItem: function(t, e) {
    for (var i = e; i >= 0; ) {
      var r = E(t[i]);
      this._updateItemSelection(!0, r.find("." + ga).get(0)), i--;
    }
  },
  _updateSelectionToLastItem: function(t, e) {
    for (var i = t.length, r = e; r < i; ) {
      var n = E(t[r]);
      this._updateItemSelection(!0, n.find("." + ga).get(0)), r++;
    }
  },
  focus: function() {
    if (this._selectAllEnabled()) {
      k.trigger(this._$selectAllItem, "focus");
      return;
    }
    this.callBase();
  },
  _focusInHandler: function(t) {
    this._updateFocusState(t, !0);
    var e = E(t.target).hasClass(cw);
    if (e || this.option("focusedElement")) {
      clearTimeout(this._setFocusedItemTimeout), this._setFocusedItemTimeout = setTimeout(() => {
        var r = e ? ot(this._$selectAllItem) : E(this.option("focusedElement"));
        this._setFocusedItem(r);
      });
      return;
    }
    var i = this._getActiveItem();
    this.option("focusedElement", ot(i.closest("." + no)));
  },
  _itemPointerDownHandler: function(t) {
    if (this.option("focusStateEnabled")) {
      var e = E(t.target).closest("." + no + ", ." + cw);
      if (e.length) {
        var i = e.hasClass(ky) ? null : e;
        this.option("focusedElement", ot(i));
      }
    }
  },
  _findNonDisabledNodes: function(t) {
    return t.not(function() {
      return E(this).children("." + ga).hasClass(ky);
    });
  },
  _moveFocus: function(t, e) {
    var i = "up", r = "down", n = "first", a = "last", o = this.option("rtlEnabled") ? "right" : "left", u = this.option("rtlEnabled") ? "left" : "right";
    this.$element().find(".".concat(Pd)).each(function() {
      ji.stop(this, !0);
    });
    var c = this._nodeElements();
    if (!(!c || !c.length))
      switch (t) {
        case i:
          var p = this._prevItem(c);
          this.option("focusedElement", ot(p));
          var v = this._getNodeItemElement(p);
          this.getScrollable().scrollToElement(v), e.shiftKey && this._showCheckboxes() && this._updateItemSelection(!0, v);
          break;
        case r:
          var _ = this._nextItem(c);
          this.option("focusedElement", ot(_));
          var y = this._getNodeItemElement(_);
          this.getScrollable().scrollToElement(y), e.shiftKey && this._showCheckboxes() && this._updateItemSelection(!0, y);
          break;
        case n:
          var b = c.first();
          e.shiftKey && this._showCheckboxes() && this._updateSelectionToFirstItem(c, c.index(this._prevItem(c))), this.option("focusedElement", ot(b)), this.getScrollable().scrollToElement(this._getNodeItemElement(b));
          break;
        case a:
          var I = c.last();
          e.shiftKey && this._showCheckboxes() && this._updateSelectionToLastItem(c, c.index(this._nextItem(c))), this.option("focusedElement", ot(I)), this.getScrollable().scrollToElement(this._getNodeItemElement(I));
          break;
        case u:
          this._expandFocusedContainer();
          break;
        case o:
          this._collapseFocusedContainer();
          break;
        default:
          this.callBase.apply(this, arguments);
          return;
      }
  },
  _getNodeItemElement: function(t) {
    return t.find("." + ga).get(0);
  },
  _nodeElements: function() {
    return this.$element().find("." + no).not(":hidden");
  },
  _expandFocusedContainer: function() {
    var t = E(this.option("focusedElement"));
    if (!(!t.length || t.hasClass(Ly))) {
      var e = t.find(".".concat(Pd)).eq(0);
      if (e.hasClass(dh)) {
        var i = this._nextItem(this._findNonDisabledNodes(this._nodeElements()));
        this.option("focusedElement", ot(i)), this.getScrollable().scrollToElement(this._getNodeItemElement(i));
        return;
      }
      var r = this._getNodeByElement(this._getItem(t));
      this._toggleExpandedState(r, !0);
    }
  },
  _getClosestNonDisabledNode: function(t) {
    do
      t = t.parent().closest("." + no);
    while (t.children(".dx-treeview-item.dx-state-disabled").length);
    return t;
  },
  _collapseFocusedContainer: function() {
    var t = E(this.option("focusedElement"));
    if (t.length) {
      var e = t.find(".".concat(Pd)).eq(0);
      if (!t.hasClass(Ly) && e.hasClass(dh)) {
        var i = this._getNodeByElement(this._getItem(t));
        this._toggleExpandedState(i, !1);
      } else {
        var r = this._getClosestNonDisabledNode(t);
        r.length && this.option("focusedElement", ot(r)), this.getScrollable().scrollToElement(this._getNodeItemElement(r));
      }
    }
  },
  _encodeString: function(t) {
    return ht(t) ? encodeURI(t) : t;
  },
  _decodeString: function(t) {
    return ht(t) ? decodeURI(t) : t;
  },
  getScrollable: function() {
    return this._scrollable;
  },
  updateDimensions: function() {
    var t = new q(), e = this.getScrollable();
    return e ? e.update().done(() => {
      t.resolveWith(this);
    }) : t.resolveWith(this), t.promise();
  },
  selectItem: function(t) {
    return this._updateItemSelection(!0, t);
  },
  unselectItem: function(t) {
    return this._updateItemSelection(!1, t);
  },
  expandItem: function(t) {
    return this._toggleExpandedState(t, !0);
  },
  collapseItem: function(t) {
    return this._toggleExpandedState(t, !1);
  },
  getNodes: function() {
    return this._dataAdapter.getTreeNodes();
  },
  getSelectedNodes: function() {
    return this.getSelectedNodeKeys().map((t) => {
      var e = this._dataAdapter.getNodeByKey(t);
      return this._dataAdapter.getPublicNode(e);
    });
  },
  getSelectedNodeKeys: function() {
    return this._dataAdapter.getSelectedNodesKeys();
  },
  selectAll: function() {
    this._selectAllEnabled() ? this._$selectAllItem.dxCheckBox("instance").option("value", !0) : this._toggleSelectAll({
      value: !0
    });
  },
  unselectAll: function() {
    this._selectAllEnabled() ? this._$selectAllItem.dxCheckBox("instance").option("value", !1) : this._toggleSelectAll({
      value: !1
    });
  },
  _allItemsExpandedHandler: function() {
    this._skipContentReadyAndItemExpanded = !1, this._fireContentReadyAction();
  },
  expandAll: function() {
    var t = this._dataAdapter.getData(), e = [];
    this._skipContentReadyAndItemExpanded = !0, t.forEach((i) => e.push(this._toggleExpandedState(i.internalFields.key, !0))), Promise.allSettled(e).then(() => {
      var i;
      return (i = this._allItemsExpandedHandler) === null || i === void 0 ? void 0 : i.call(this);
    });
  },
  collapseAll: function() {
    N(this._dataAdapter.getExpandedNodesKeys(), (function(t, e) {
      this._toggleExpandedState(e, !1);
    }).bind(this));
  },
  scrollToItem: function(t) {
    var e = this._getNode(t);
    if (!e)
      return new q().reject().promise();
    for (var i = [], r = e.internalFields.publicNode.parent; r != null; )
      r.expanded || i.push(r.key), r = r.parent;
    var n = new q();
    return this._expandNodes(i.reverse()).always(() => {
      var a = this._getNodeElement(e);
      a && a.length ? (this.scrollToElementTopLeft(a.get(0)), n.resolve()) : n.reject();
    }), n.promise();
  },
  scrollToElementTopLeft: function(t) {
    var e = this.getScrollable(), {
      scrollDirection: i,
      rtlEnabled: r
    } = this.option(), n = {
      top: 0,
      left: 0
    }, a = R5(M5, t);
    if (i !== NT) {
      var o = E(e.container()).get(0);
      n.left = r ? a.left + t.offsetWidth - o.clientWidth : a.left;
    }
    i !== L5 && (n.top = a.top), e.scrollTo(n);
  },
  _expandNodes: function(t) {
    if (!t || t.length === 0)
      return new q().resolve().promise();
    var e = new q(), i = t.map((r) => this.expandItem(r));
    return $e.apply(E, i).done(() => e.resolve()).fail(() => e.reject()), e.promise();
  },
  _dispose: function() {
    this.callBase(), clearTimeout(this._setFocusedItemTimeout), this._allItemsExpandedHandler = null;
  }
});
Mp.setEditorClass(ES);
var _X = "dx-treeview", F0e = "".concat(_X, "-node-container"), TS = P0e.inherit(Mp).inherit({
  _addWidgetPrefix: function(t) {
    return "".concat(_X, "-").concat(t);
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "searchValue":
        this._showCheckboxes() && this._isRecursiveSelection() && this._removeSelection(), this._initDataAdapter(), this._updateSearch(), this._repaintContainer(), this.option("focusedElement", null);
        break;
      case "searchExpr":
        this._initDataAdapter(), this.repaint();
        break;
      case "searchMode":
        this.option("expandNodesRecursive") ? this._updateDataAdapter() : this._initDataAdapter(), this.repaint();
        break;
      default:
        this.callBase(t);
    }
  },
  _updateDataAdapter: function() {
    this._setOptionWithoutOptionChange("expandNodesRecursive", !1), this._initDataAdapter(), this._setOptionWithoutOptionChange("expandNodesRecursive", !0);
  },
  _getDataAdapterOptions: function() {
    return P(this.callBase(), {
      searchValue: this.option("searchValue"),
      searchMode: this.option("searchMode") || "contains",
      searchExpr: this.option("searchExpr")
    });
  },
  _getNodeContainer: function() {
    return this.$element().find(".".concat(F0e)).first();
  },
  _updateSearch: function() {
    if (this._searchEditor) {
      var t = this._getSearchEditorOptions();
      this._searchEditor.option(t);
    }
  },
  _repaintContainer: function() {
    var t = this._getNodeContainer(), e;
    t.length && (t.empty(), e = this._dataAdapter.getRootNodes(), this._renderEmptyMessage(e), this._renderItems(t, e), this._fireContentReadyAction());
  },
  _focusTarget: function() {
    return this._itemContainer(this.option("searchEnabled"));
  },
  _cleanItemContainer: function() {
    this.$element().empty();
  },
  _itemContainer: function(t, e) {
    var i;
    return (i = e) !== null && i !== void 0 || (e = this._selectAllEnabled()), e ? this._getNodeContainer() : this._scrollable && t ? E(this._scrollable.content()) : this.callBase();
  },
  _addWidgetClass: function() {
    this.$element().addClass(this._widgetClass());
  },
  _clean: function() {
    this.callBase(), this._removeSearchBox();
  }
});
ti("dxTreeView", TS);
var B0e = "column-chooser", CX = "column-chooser-button", d4 = "notouch-action", V0e = "column-chooser-list", N0e = "column-chooser-plain", H0e = "column-chooser-mode-drag", $0e = "column-chooser-mode-select", yX = "column-chooser", c4 = "dx-column-chooser-item", z0e = ["showInColumnChooser", "caption", "allowHiding", "visible", "cssClass", "ownerBand"], W0e = function(t, e) {
  var i = [], r = t.isSelectMode(), n = t.option("columnChooser.selection.recursive");
  return e.length && N(e, (a, o) => {
    var u = {
      text: o.caption,
      cssClass: o.cssClass,
      allowHiding: o.allowHiding,
      expanded: !0,
      id: o.index,
      disabled: o.allowHiding === !1,
      parentId: R(o.ownerBand) ? o.ownerBand : null
    }, c = n && o.hasColumns;
    r && !c && (u.selected = o.visible), i.push(u);
  }), i;
};
let U0e = class extends Bi.ViewController {
  init() {
    super.init(), this._rowsView = this.getView("rowsView");
  }
  renderShowColumnChooserButton(e) {
    var i = this, r = i.addWidgetPrefix(CX), n = i.option("columnChooser.enabled"), a = e.find(".".concat(r)), o;
    n ? a.length ? a.show() : (o = E("<div>").addClass(r).appendTo(e), i._createComponent(o, yn, {
      icon: yX,
      onClick() {
        i.getView("columnChooserView").showColumnChooser();
      },
      hint: i.option("columnChooser.title"),
      integrationOptions: {}
    })) : a.hide();
  }
  getPosition() {
    var e = this.option("columnChooser.position");
    return R(e) ? e : {
      my: "right bottom",
      at: "right bottom",
      of: this._rowsView && this._rowsView.element(),
      collision: "fit",
      offset: "-2 -2",
      boundaryOffset: "2 2"
    };
  }
}, G0e = class extends SS {
  optionChanged(e) {
    switch (e.name) {
      case "columnChooser":
        this._initializePopupContainer(), this.render(null, "full");
        break;
      default:
        super.optionChanged(e);
    }
  }
  publicMethods() {
    return ["showColumnChooser", "hideColumnChooser"];
  }
  _resizeCore() {
  }
  _isWinDevice() {
    return !!Ye.real().win;
  }
  _initializePopupContainer() {
    var e = this, i = e.addWidgetPrefix(B0e), r = e.element().addClass(i), n = e.option("columnChooser"), a = this._columnChooserController.getPosition(), o = ho(), u = KY(o), c = _a(o), p = {
      visible: !1,
      shading: !1,
      showCloseButton: !1,
      dragEnabled: !0,
      resizeEnabled: !0,
      wrapperAttr: {
        class: i
      },
      toolbarItems: [{
        text: n.title,
        toolbar: "top",
        location: u || c ? "before" : "center"
      }],
      position: a,
      width: n.width,
      height: n.height,
      rtlEnabled: e.option("rtlEnabled"),
      onHidden() {
        e._isWinDevice() && E("body").removeClass(e.addWidgetPrefix(d4));
      },
      container: n.container
    };
    u || c ? P(p, {
      showCloseButton: !0
    }) : p.toolbarItems[p.toolbarItems.length] = {
      shortcut: "cancel"
    }, R(this._popupContainer) ? this._popupContainer.option(p) : (e._popupContainer = e._createComponent(r, Hu, p), e._popupContainer.on("optionChanged", (v) => {
      v.name === "visible" && e.renderCompleted.fire();
    })), this.setPopupAttributes();
  }
  setPopupAttributes() {
    var e = this.isSelectMode(), i = this._columnsController.isBandColumnsUsed();
    this._popupContainer.setAria({
      role: "dialog",
      label: X.format("dxDataGrid-columnChooserTitle")
    }), this._popupContainer.$wrapper().toggleClass(this.addWidgetPrefix(H0e), !e).toggleClass(this.addWidgetPrefix($0e), e), this._popupContainer.$content().addClass(this.addWidgetPrefix(V0e)), e && !i && this._popupContainer.$content().addClass(this.addWidgetPrefix(N0e));
  }
  _renderCore(e) {
    if (this._popupContainer) {
      var i = !this.isSelectMode();
      !this._columnChooserList || e === "full" ? this._renderTreeView() : i && this._updateItems();
    }
  }
  _renderTreeView() {
    var e, i, r, n = this, a = this._popupContainer.$content(), o = this.option("columnChooser"), u = this.isSelectMode(), c = R(o.allowSearch) ? o.allowSearch : (e = o.search) === null || e === void 0 ? void 0 : e.enabled, p = R(o.searchTimeout) ? o.searchTimeout : (i = o.search) === null || i === void 0 ? void 0 : i.timeout, v = {
      dataStructure: "plain",
      activeStateEnabled: !0,
      focusStateEnabled: !0,
      hoverStateEnabled: !0,
      itemTemplate: "item",
      showCheckBoxesMode: "none",
      rootValue: null,
      searchEnabled: c,
      searchTimeout: p,
      searchEditorOptions: (r = o.search) === null || r === void 0 ? void 0 : r.editorOptions
    };
    if (this._isWinDevice() && (v.useNativeScrolling = !1), P(v, u ? this._prepareSelectModeConfig() : this._prepareDragModeConfig()), this._columnChooserList)
      v.searchEnabled || (v.searchValue = ""), this._columnChooserList.option(v), this._updateItems();
    else {
      this._columnChooserList = this._createComponent(a, TS, v), this._updateItems();
      var _ = 0;
      this._columnChooserList.on("optionChanged", (y) => {
        var b = y.component.getScrollable();
        _ = b.scrollTop();
      }), this._columnChooserList.on("contentReady", (y) => {
        Na(() => {
          var b = y.component.getScrollable();
          b.scrollTo({
            y: _
          }), n.renderCompleted.fire();
        });
      });
    }
  }
  _prepareDragModeConfig() {
    var e = this.option("columnChooser");
    return {
      noDataText: e.emptyPanelText,
      activeStateEnabled: !1,
      focusStateEnabled: !1,
      hoverStateEnabled: !1,
      itemTemplate(i, r, n) {
        E(n).text(i.text).parent().addClass(i.cssClass).addClass(c4);
      }
    };
  }
  _prepareSelectModeConfig() {
    var e, i = this, r = (e = this.option("columnChooser.selection")) !== null && e !== void 0 ? e : {}, n = !1;
    return {
      selectByClick: r.selectByClick,
      selectNodesRecursive: r.recursive,
      showCheckBoxesMode: r.allowSelectAll ? "selectAll" : "normal",
      onSelectionChanged: (a) => {
        if (!n) {
          var o = ((u) => {
            var c = (p, v) => p.reduce((_, y) => (_.push(y), y.children.length && c(y.children, _), _), v);
            return c(u, []);
          })(a.component.getNodes());
          a.component.beginUpdate(), n = !0, ((u, c) => {
            c.filter((p) => p.itemData.allowHiding === !1).forEach((p) => u.component.selectItem(p.key));
          })(a, o), a.component.endUpdate(), n = !1, i.component.beginUpdate(), this._isUpdatingColumnVisibility = !0, ((u) => {
            u.forEach((c) => {
              var p = c.itemData.id, v = c.selected !== !1;
              i._columnsController.columnOption(p, "visible", v);
            });
          })(o), i.component.endUpdate(), this._isUpdatingColumnVisibility = !1;
        }
      }
    };
  }
  _updateItems() {
    var e = this.isSelectMode(), i = this._columnsController.getChooserColumns(e), r = W0e(this, i);
    this._columnChooserList.option("items", r);
  }
  _updateItemsSelection(e) {
    var i = e == null ? void 0 : e.map((r) => this._columnsController.columnOption(r));
    this._columnChooserList.beginUpdate(), i == null || i.forEach((r) => {
      var {
        visible: n,
        index: a
      } = r;
      n ? this._columnChooserList.selectItem(a) : this._columnChooserList.unselectItem(a);
    }), this._columnChooserList.endUpdate();
  }
  _columnOptionChanged(e) {
    super._columnOptionChanged(e);
    var i = this.isSelectMode();
    if (i && this._columnChooserList && !this._isUpdatingColumnVisibility) {
      var {
        optionNames: r
      } = e, n = r.visible && r.length === 1, a = R(e.columnIndex) ? [e.columnIndex] : e.columnIndices, o = z0e.some((u) => r[u]) || e.changeTypes.columns && r.all;
      o && (this._updateItemsSelection(a), n || this._updateItems());
    }
  }
  getColumnElements() {
    var e = [], i = this.isSelectMode(), r = this._columnsController.getChooserColumns(i), n = this._popupContainer && this._popupContainer.$content(), a = n && n.find(".dx-treeview-node");
    return a && r.forEach((o) => {
      var u = a.filter("[data-item-id = '".concat(o.index, "']")), c = u.length ? u.children(".".concat(c4)).get(0) : null;
      e.push(c);
    }), E(e);
  }
  getName() {
    return "columnChooser";
  }
  getColumns() {
    return this._columnsController.getChooserColumns();
  }
  allowDragging(e) {
    var i = this._columnsController.isParentColumnVisible(e.index), r = !e.visible && e.allowHiding;
    return this.isColumnChooserVisible() && i && r;
  }
  allowColumnHeaderDragging(e) {
    var i = !this.isSelectMode();
    return i && this.isColumnChooserVisible() && e.allowHiding;
  }
  getBoundingRect() {
    var e = this._popupContainer && this._popupContainer.$overlayContent();
    if (e && e.is(":visible")) {
      var i = e.offset();
      return {
        left: i.left,
        top: i.top,
        right: i.left + oi(e),
        bottom: i.top + jt(e)
      };
    }
    return null;
  }
  showColumnChooser() {
    this._popupContainer || (this._initializePopupContainer(), this.render()), this._popupContainer.show(), this._isWinDevice() && E("body").addClass(this.addWidgetPrefix(d4));
  }
  hideColumnChooser() {
    this._popupContainer && this._popupContainer.hide();
  }
  isColumnChooserVisible() {
    var e = this._popupContainer;
    return e && e.option("visible");
  }
  isSelectMode() {
    return this.option("columnChooser.mode") === "select";
  }
  hasHiddenColumns() {
    var e = this.option("columnChooser.enabled"), i = this.getColumns().filter((r) => !r.visible);
    return e && i.length;
  }
};
var K0e = (t) => class extends t {
  _getToolbarItems() {
    var e = super._getToolbarItems();
    return this._appendColumnChooserItem(e);
  }
  _appendColumnChooserItem(e) {
    var i = this, r = i.option("columnChooser.enabled");
    if (r) {
      var n = i.option("columnChooser.title"), a = {
        widget: "dxButton",
        options: {
          icon: yX,
          onClick: function() {
            i.component.getView("columnChooserView").showColumnChooser();
          },
          hint: n,
          text: n,
          onInitialized: function(o) {
            E(o.element).addClass(i._getToolbarButtonClass(i.addWidgetPrefix(CX)));
          },
          elementAttr: {
            "aria-haspopup": "dialog"
          }
        },
        showText: "inMenu",
        location: "after",
        name: "columnChooserButton",
        locateInMenu: "auto",
        sortIndex: 40
      };
      e.push(a);
    }
    return e;
  }
  optionChanged(e) {
    switch (e.name) {
      case "columnChooser":
        this._invalidate(), e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
  isVisible() {
    var e = this.option("columnChooser.enabled");
    return super.isVisible() || e;
  }
}, j0e = (t) => class extends t {
  allowMoveColumn(e, i, r, n) {
    var a = this.option("columnChooser.mode") === "select", o = a && n === "columnChooser";
    return o ? !1 : super.allowMoveColumn(e, i, r, n);
  }
}, Y0e = (t) => class extends t {
  allowDragging(e) {
    var i = !this._columnChooserView.isSelectMode(), r = this._columnChooserView.isColumnChooserVisible();
    return i && r && e.allowHiding || super.allowDragging(e);
  }
}, HB = {
  defaultOptions: () => ({
    columnChooser: {
      enabled: !1,
      search: {
        enabled: !1,
        timeout: 500,
        editorOptions: {}
      },
      selection: {
        allowSelectAll: !1,
        selectByClick: !1,
        recursive: !1
      },
      position: void 0,
      mode: "dragAndDrop",
      width: 250,
      height: 260,
      title: X.format("dxDataGrid-columnChooserTitle"),
      emptyPanelText: X.format("dxDataGrid-columnChooserEmptyText"),
      container: void 0
    }
  }),
  controllers: {
    columnChooser: U0e
  },
  views: {
    columnChooserView: G0e
  },
  extenders: {
    views: {
      headerPanel: K0e,
      columnHeadersView: Y0e
    },
    controllers: {
      columns: j0e
    }
  }
}, KVe = HB.controllers.columnChooser, jVe = HB.views.columnChooserView;
et.registerModule("columnChooser", HB);
function Pp(t, e) {
  for (var i = ic(e.group), r = [], n = 0; n < t.length; n++)
    r.push([i[n].selector, "=", t[n]]);
  return e.filter && r.push(e.filter), xe.combineFilters(r);
}
function xX(t, e, i) {
  for (var r = ic(e.group), n = [], a = i ? t.length - 1 : 0; a < t.length; a++) {
    for (var o = [], u = 0; u <= a; u++) {
      var {
        selector: c
      } = r[u];
      if (a === u && (t[u] === null || t[u] === !1 || t[u] === !0))
        t[u] === !1 ? o.push([c, "=", r[u].desc ? !0 : null]) : (t[u] ? !r[u].desc : r[u].desc) ? o.push([c, "<>", t[u]]) : (o.push([c, "<>", null]), o.push([c, "=", null]));
      else {
        var p = [c, a === u ? r[u].desc ? ">" : "<" : "=", t[u]];
        p[1] === "<" ? o.push([p, "or", [c, "=", null]]) : o.push(p);
      }
    }
    n.push(et.combineFilters(o));
  }
  return n = et.combineFilters(n, "or"), et.combineFilters([n, e.filter]);
}
var h4 = function(t, e) {
  var {
    hash: i
  } = t;
  return i && i[JSON.stringify(e)];
}, q0e = function(t, e) {
  var i = 0, r = t.length - 1;
  if (!t.length)
    return 0;
  do {
    var n = r + i >> 1;
    t[n].offset > e ? r = n : i = n;
  } while (r - i > 1);
  var a;
  for (a = i; a <= r && !(t[a].offset > e); a++)
    ;
  return a;
}, X0e = function t(e, i, r) {
  for (var n = 0; n < e.length; n++)
    i + 1 >= r ? e[n].children = [] : t(e[n].children, i + 1, r);
}, Q0e = function t(e, i, r) {
  var n = 0;
  if (i)
    if (!r)
      n = i.length;
    else
      for (var a = 0; a < i.length; a++)
        e.isGroupItemCountable(i[a]) && n++, n += t(e, i[a].items, r - 1);
  return n;
};
let SX = class {
  constructor(e) {
    this._dataSource = e, this.reset();
  }
  reset() {
    this._groupsInfo = [], this._totalCountCorrection = 0;
  }
  totalCountCorrection() {
    return this._totalCountCorrection;
  }
  updateTotalItemsCount(e) {
    this._totalCountCorrection = e || 0;
  }
  isGroupItemCountable(e) {
    return !this._isVirtualPaging() || !e.isContinuation;
  }
  _isVirtualPaging() {
    var e = this._dataSource.option("scrolling.mode");
    return e === "virtual" || e === "infinite";
  }
  itemsCount() {
    var e = this._dataSource, i = e._dataSource, r = et.normalizeSortingInfo(i.group() || []).length, n = Q0e(this, i.items(), r);
    return n;
  }
  foreachGroups(e, i, r, n, a) {
    var o = this;
    return function u(c, p, v, _) {
      var y = [];
      function b($, K, te, z) {
        var ie = K && $(K, te);
        return ie && z.push(ie), ie;
      }
      for (var I = 0; I < c.length; I++) {
        if (_.push(c[I].data), !v && b(p, c[I].data, _, y) === !1)
          return !1;
        if (!c[I].data || c[I].data.isExpanded || r) {
          var {
            children: A
          } = c[I], L = A.length && u(A, p, v, _);
          if (L && y.push(L), L === !1)
            return !1;
        }
        if (v && b(p, c[I].data, _, y) === !1)
          return !1;
        (!c[I].data || c[I].data.offset !== c[I].offset) && (n = !0), _.pop();
      }
      var B = a && _.slice(0);
      return n && $e.apply(E, y).always(() => {
        o._updateGroupInfoOffsets(c, B);
      });
    }(o._groupsInfo, e, i, []);
  }
  _updateGroupInfoOffsets(e, i) {
    i = i || [];
    for (var r = 0; r < e.length; r++) {
      var n = e[r];
      if (n.data && n.data.offset !== n.offset) {
        n.offset = n.data.offset;
        for (var a = 0; a < i.length; a++)
          i[a].offset = n.offset;
      }
    }
    e.sort((o, u) => o.offset - u.offset);
  }
  findGroupInfo(e) {
    for (var i, r = this._groupsInfo, n = 0; r && n < e.length; n++)
      i = h4(r, e[n]), r = i && i.children;
    return i && i.data;
  }
  addGroupInfo(e) {
    for (var i, {
      path: r
    } = e, n = this._groupsInfo, a = 0; a < r.length; a++) {
      if (i = h4(n, r[a]), !i) {
        i = {
          key: r[a],
          offset: e.offset,
          data: {
            offset: e.offset,
            isExpanded: !0,
            path: r.slice(0, a + 1)
          },
          children: []
        };
        var o = q0e(n, e.offset);
        n.splice(o, 0, i), n.hash = n.hash || {}, n.hash[JSON.stringify(i.key)] = i;
      }
      a === r.length - 1 && (i.data = e, i.offset !== e.offset && this._updateGroupInfoOffsets(n)), n = i.children;
    }
  }
  allowCollapseAll() {
    return !0;
  }
  refresh(e) {
    var {
      storeLoadOptions: i
    } = e, r = ic(i.group || []), n = "_group" in this ? ic(this._group || []) : r, a = Math.min(n.length, r.length);
    this._group = i.group;
    for (var o = 0; o < a; o++)
      if (n[o].selector !== r[o].selector) {
        a = o;
        break;
      }
    a ? X0e(this._groupsInfo, 0, a) : this.reset();
  }
  handleDataLoading() {
  }
  handleDataLoaded(e, i) {
    i(e);
  }
  handleDataLoadedCore(e, i) {
    i(e);
  }
};
function IP(t, e, i, r) {
  if (r = r || 0, e > 1 && i > 0) {
    var n = t - Math.floor(t / e) * e || e;
    return n += i - r - 2, n < 0 && (n += e), Math.floor(n / (e - r - 1));
  }
  return 0;
}
var Py = function(t, e, i) {
  return t.foreachGroups((r, n) => {
    if (r.isExpanded)
      return e(r, n);
  }, !0, !1, i, i);
}, EX = function t(e, i, r, n, a, o, u) {
  var c;
  if (n.items = n.items || [], n.paths = n.paths || [], n.count = n.count || 0, n.lastCount = n.lastCount || 0, !!r)
    for (var p = 0; p < i.length; p++) {
      var v = i[p];
      if (v.items !== void 0) {
        if (a.push(v.key), o)
          c = !0;
        else {
          var _ = e.findGroupInfo(a);
          c = _ && _.isExpanded;
        }
        c ? v.items ? t(e, v.items, r - 1, n, a, o, u) : r === 1 && v.count && (!o || u) && (n.items.push(v), n.paths.push(a.slice(0)), n.count += n.lastCount, n.lastCount = v.count) : (v.collapsedItems = v.items, v.items = null), a.pop();
      }
    }
}, Z0e = function(t, e, i, r, n) {
  var a = t.findGroupInfo(r), o;
  a ? (i ? a.count = e.count > 0 ? e.count : e.items && e.items.length || 0 : e.count = a.count || e.count, a.offset = n) : (i && (o = e.count > 0 ? e.count : e.items.length), t.addGroupInfo({
    isExpanded: t._isGroupExpanded(r.length - 1),
    path: r.slice(0),
    offset: n,
    count: o || 0
  }));
}, bX = function t(e, i, r, n, a, o, u) {
  var c = i.group ? i.group.length : 0, p = c === n, v = i.remoteOperations.paging, _ = 0, y = 0, b;
  if (a = a || 0, o = o || [], v && !u && (_ = a === 0 ? i.skip || 0 : i.skips[a - 1] || 0), a >= n)
    return r.length;
  for (var I = 0; I < r.length; I++) {
    var A = r[I];
    if (A) {
      if (o.push(A.key), !A.count && !A.items || A.items === void 0 || (Z0e(e, A, p, o, _ + I), b = A.items ? t(e, i, A.items, n, a + 1, o, I) : A.count || -1, b < 0))
        return -1;
      y += b, o.pop();
    }
  }
  return y;
}, dM = function(t, e) {
  return t && t.length && t[e] && !!t[e].isExpanded;
}, f4 = function(t, e, i) {
  for (var r, n = i, a = 0; a < t.length; a++)
    r = t[a].offset + 1, a > 0 && (r += t[a - 1].childrenTotalCount, e && (r += IP(n, e, r, a - 1) * a)), n += r;
  return n;
};
function wX(t, e, i, r) {
  var n = e.items[r], a = t.skips && t.skips[i], o = t.takes && t.takes[i], u = r === e.items.length - 1, c = r === 0, p = c && a || 0, v = n.count > o + p;
  c && a !== void 0 && (n.isContinuation = !0), u && o !== void 0 && v && (n.isContinuationOnNextPage = !0);
}
function J0e(t, e, i) {
  var r = i - 1, n = t.group ? t.group.length : 0;
  e.skip = t.skips && t.skips[r], t.takes && t.takes[r] !== void 0 && (n === i ? e.take = e.count ? e.count - (e.skip || 0) : 0 : e.take = 0, e.take += t.takes[r]);
}
function TX(t) {
  return !Array.isArray(t);
}
function p4(t) {
  TX(t.data) || (t.data = new q());
}
function IX(t, e, i, r, n, a) {
  e.isCustomLoading || (r = {}, EX(t, a, i, r, []), J0e(e, r, i));
  var o = e.group ? e.group.length : 0;
  r.paths.length && o - i > 0 ? (p4(e), eEe(t, e, r, i, n, a)) : r.paths.length && e.storeLoadOptions.group ? (p4(e), tEe(t, e, r, a)) : TX(e.data) && e.data.resolve(a);
}
function eEe(t, e, i, r, n, a) {
  var o = e.group || [], u = o[n + 1], c = [];
  N(i.paths, (p) => {
    var v, _ = {
      requireTotalCount: !1,
      requireGroupCount: !0,
      group: [u],
      groupSummary: e.storeLoadOptions.groupSummary,
      filter: Pp(i.paths[p], {
        filter: e.storeLoadOptions.filter,
        group: o
      }),
      select: e.storeLoadOptions.select,
      langParams: (v = e.storeLoadOptions) === null || v === void 0 ? void 0 : v.langParams
    };
    p === 0 && (_.skip = i.skip || 0), p === i.paths.length - 1 && (_.take = i.take);
    var y = _.take === 0 ? [] : t._dataSource.loadFromStore(_);
    $e(y).done((b) => {
      var I = i.items[p];
      wX(e, i, n, p), I.items = b;
    }), c.push(y);
  }), $e.apply(null, c).done(() => {
    bX(t, e, a, r + 1), IX(t, e, r + 1, i, n + 1, a);
  });
}
function tEe(t, e, i, r) {
  var n = [], a = e.group || [];
  N(i.paths, (p, v) => {
    n.push(Pp(v, {
      group: e.isCustomLoading ? e.storeLoadOptions.group : a
    }));
  });
  var {
    filter: o
  } = e.storeLoadOptions;
  e.storeLoadOptions.isLoadingAll || (o = et.combineFilters([o, et.combineFilters(n, "or")]));
  var u = P({}, e.storeLoadOptions, {
    requireTotalCount: !1,
    requireGroupCount: !1,
    group: null,
    sort: a.concat(et.normalizeSortingInfo(e.storeLoadOptions.sort || [])),
    filter: o
  }), c = t._dataSource.isLastLevelGroupItemsPagingLocal();
  c || (u.skip = i.skip, u.take = i.take), $e(i.take === 0 ? [] : t._dataSource.loadFromStore(u)).done((p) => {
    c && (p = t._dataSource.sortLastLevelGroupItems(p, a, i.paths), p = i.skip ? p.slice(i.skip) : p, p = i.take ? p.slice(0, i.take) : p), N(i.items, (v, _) => {
      var y = _.count - (v === 0 && i.skip || 0), b = p.splice(0, y);
      wX(e, i, a.length - 1, v), _.items = b;
    }), e.data.resolve(r);
  }).fail(e.data.reject);
}
var cM = function(t, e) {
  var i = new q(), r = !!(e.group && e.group.length), n = P({
    skip: 0,
    take: 1,
    requireGroupCount: r,
    requireTotalCount: !r
  }, e, {
    group: r ? e.group : null
  });
  return t.load(n).done((a, o) => {
    var u = o && (r ? o.groupCount : o.totalCount);
    if (!isFinite(u)) {
      i.reject(Zr.Error(r ? "E4022" : "E4021"));
      return;
    }
    i.resolve(u);
  }).fail(i.reject.bind(i)), i;
};
let v4 = class extends SX {
  updateTotalItemsCount(e) {
    var i = 0, r = e.extra && e.extra.totalCount || 0, n = e.extra && e.extra.groupCount || 0, a = this._dataSource.pageSize(), o = this._isVirtualPaging();
    Py(this, (u) => {
      u.childrenTotalCount = 0;
    }), Py(this, (u, c) => {
      var p = f4(c, o ? 0 : a, i), v = u.count + u.childrenTotalCount;
      o || (v += IP(p, a, v, c.length - 1)), c[c.length - 2] ? c[c.length - 2].childrenTotalCount += v : i += v;
    }), super.updateTotalItemsCount(i - r + n);
  }
  _isGroupExpanded(e) {
    var i = this._dataSource.group();
    return dM(i, e);
  }
  _updatePagingOptions(e, i) {
    var r = this._isVirtualPaging(), n = this._dataSource.pageSize(), a = [], o = [], u = 0, c = 0;
    e.take && (Py(this, (p) => {
      p.childrenTotalCount = 0, p.skipChildrenTotalCount = 0;
    }), Py(this, (p, v) => {
      var _, y = 0, b = 0, I = f4(v, r ? 0 : n, c), A = 0, L = 0, B = p.count + p.childrenTotalCount, $ = B;
      i && i(p, I);
      var K = e.skip - I;
      I <= e.skip + e.take && B && (_ = e.take, r || (A = IP(I, n, B, v.length - 1), B += A * v.length, $ += A, n && K >= 0 && (y = v.length, b = v.length - 1, L = Math.floor(K / n))), K >= 0 ? (I + B > e.skip && a.unshift(K - L * y - p.skipChildrenTotalCount), I + B >= e.skip + _ && o.unshift(_ - y - p.childrenTotalCount + p.skipChildrenTotalCount)) : I + B >= e.skip + _ && o.unshift(_ + K - p.childrenTotalCount)), I <= e.skip && (v[v.length - 2] ? v[v.length - 2].skipChildrenTotalCount += Math.min($, K + 1 - L * b) : u += Math.min($, K + 1)), I <= e.skip + _ && (B = Math.min($, K + _ - (L + 1) * b), v[v.length - 2] ? v[v.length - 2].childrenTotalCount += B : c += B);
    }), e.skip -= u, e.take -= c - u), e.skips = a, e.takes = o;
  }
  changeRowExpand(e) {
    var i = this.findGroupInfo(e), r = this._dataSource, n = r.remoteOperations().groupPaging, a = et.normalizeSortingInfo(r.group());
    return i ? (i.isExpanded = !i.isExpanded, n && i.isExpanded && e.length < a.length ? cM(r, {
      filter: Pp(e, {
        filter: r.lastLoadOptions().filter,
        group: r.group()
      }),
      group: [a[e.length]],
      select: r.select()
    }).done((o) => {
      i.count = o;
    }) : new q().resolve()) : new q().reject();
  }
  handleDataLoading(e) {
    var {
      storeLoadOptions: i
    } = e, r = et.normalizeSortingInfo(i.group || e.loadOptions.group);
    if (!(e.isCustomLoading || !r.length)) {
      if (e.remoteOperations.grouping) {
        var n = this._dataSource.remoteOperations().paging;
        i.group = et.normalizeSortingInfo(i.group), i.group.forEach((a, o) => {
          var u = o === i.group.length - 1;
          a.isExpanded = !n || !u;
        });
      }
      e.group = e.group || r, e.remoteOperations.paging ? (e.skip = i.skip, e.take = i.take, i.requireGroupCount = !0, i.group = r.slice(0, 1), this._updatePagingOptions(e), i.skip = e.skip, i.take = e.take) : (e.skip = e.loadOptions.skip, e.take = e.loadOptions.take, this._updatePagingOptions(e));
    }
  }
  handleDataLoadedCore(e, i) {
    var r = et.normalizeSortingInfo(e.storeLoadOptions.group || e.loadOptions.group).length, n = e.group ? e.group.length : 0, a, o = {};
    if (e.isCustomLoading)
      i(e), EX(this, e.data, r, o, [], e.isCustomLoading, e.storeLoadOptions.isLoadingAll);
    else {
      if (e.remoteOperations.paging || this.foreachGroups((u) => {
        u.count = 0;
      }), a = bX(this, e, e.data, r), a < 0) {
        e.data = new q().reject(Yt.Error("E1037"));
        return;
      }
      if (e.remoteOperations.paging || r && e.extra && e.loadOptions.requireTotalCount && (e.extra.totalCount = a, e.extra.groupCount = e.data.length), n && e.storeLoadOptions.requireGroupCount && !isFinite(e.extra.groupCount)) {
        e.data = new q().reject(Zr.Error("E4022"));
        return;
      }
      this.updateTotalItemsCount(e), e.remoteOperations.paging || (this._updatePagingOptions(e), e.lastLoadOptions.skips = e.skips, e.lastLoadOptions.takes = e.takes), i(e), e.remoteOperations.paging || this._processPaging(e, r);
    }
    IX(this, e, r, o, 0, e.data);
  }
  _processSkips(e, i, r) {
    if (r) {
      var n = e[0], a = i[0], o = n && n.items;
      a !== void 0 && (n.isContinuation = !0, o && (n.items = o.slice(a), this._processSkips(n.items, i.slice(1), r - 1)));
    }
  }
  _processTakes(e, i, r, n, a) {
    if (!(!n || !e)) {
      a = a || [];
      var o = e[e.length - 1], u = o && o.items, c = r[0], p = i[0];
      if (o) {
        var v = o.count - (o.isContinuation && p || 0) || u.length;
        c !== void 0 && v > c && (o.isContinuationOnNextPage = !0, a.forEach((_) => {
          _.isContinuationOnNextPage = !0;
        }), u && (u = u.slice(0, c), o.items = u)), a.push(o), this._processTakes(u, i.slice(1), r.slice(1), n - 1, a);
      }
    }
  }
  _processPaging(e, i) {
    this._processSkips(e.data, e.skips, i), this._processTakes(e.data, e.skips, e.takes, i);
  }
  isLastLevelGroupItemsPagingLocal() {
    return !1;
  }
  sortLastLevelGroupItems(e) {
    return e;
  }
  refresh(e, i) {
    var r = this, n = r._dataSource, {
      storeLoadOptions: a
    } = e, o = e.group || e.storeLoadOptions.group, u = et.normalizeSortingInfo(r._group), c, p;
    function v(_, y) {
      y.length === p + 1 && (_.isExpanded = c);
    }
    for (p = 0; p < u.length; p++)
      c = dM(o, p), dM(r._group, p) !== c && r.foreachGroups(v);
    if (super.refresh.apply(this, arguments), o && e.remoteOperations.paging && i.reload)
      return Py(r, (_) => {
        var y = cM(n, {
          filter: Pp(_.path, {
            filter: a.filter,
            group: o
          }),
          group: o.slice(_.path.length),
          select: a.select
        }), b = cM(n, {
          filter: xX(_.path, {
            filter: a.filter,
            group: o
          }, !0),
          group: o.slice(_.path.length - 1, _.path.length),
          select: a.select
        });
        return $e(b, y).done((I, A) => {
          I = parseInt(I.length ? I[0] : I), A = parseInt(A.length ? A[0] : A), _.offset = I, _.count !== A && (_.count = A, r.updateTotalItemsCount(e));
        });
      }, !0);
  }
};
var hM = function(t, e) {
  var i = new q(), r = P({
    skip: 0,
    take: 1,
    requireTotalCount: !0
  }, e);
  return t.load(r).done((n, a) => {
    i.resolve(a && a.totalCount);
  }).fail(i.reject.bind(i)), i;
}, Xw = function(t, e, i) {
  return t.foreachGroups((r) => {
    if (!r.isExpanded)
      return e(r);
  }, !1, !1, i, !0);
}, g4 = function(t, e) {
  var i = 0, r = e || 0;
  return e && (Xw(t, (n) => {
    if (n.offset - i >= e)
      return !1;
    i += n.count - 1;
  }), r += i), r;
}, iEe = function t(e, i, r, n, a, o) {
  for (var u = 0, c = !1, p = 0; p < i.length; p++) {
    var v = i[p];
    if (v.items !== void 0) {
      r.push(v.key);
      var _ = e.findGroupInfo(r);
      if (_ && !_.isExpanded)
        v.collapsedItems = v.items, v.items = null, n += _.count, o--, o < 0 && u++, a && (c = !0);
      else if (v.items) {
        var y = t(e, v.items, r, n, a, o);
        a && (y.offset - n > 1 ? v.isContinuation = !0 : c = !0), n = y.offset, o = y.take, o < 0 && (v.items.length ? v.isContinuationOnNextPage = !0 : u++);
      }
      r.pop();
    } else
      a && (c = !0), n++, o--, o < 0 && u++;
    a = !1;
  }
  return c && i.splice(0, 1), u && i.splice(-u, u), {
    offset: n,
    take: o
  };
}, rEe = function(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var i = 0; i < t.length; i++)
    if (!pS(null, t[i], e[i]))
      return !1;
  return !0;
}, m4 = function t(e, i, r, n, a) {
  if (i) {
    for (var o = 0; o < i.length; o++) {
      var u = i[o];
      if ("key" in u && u.items !== void 0) {
        r.push(u.key), a && rEe(a.path, r) && !u.isContinuation && (a.offset = n);
        var c = e.findGroupInfo(r);
        c && !u.isContinuation && (c.offset = n), c && !c.isExpanded ? n += c.count : n = t(e, u.items, r, n, a), r.pop();
      } else
        n++;
    }
    return n;
  }
}, nEe = function(t, e) {
  if (e.group) {
    var i = et.normalizeSortingInfo(e.group), r = et.normalizeSortingInfo(t.sort);
    t.sort = rc.arrangeSortingInfo(i, r), delete e.group;
  }
}, aEe = function(t, e, i) {
  for (var r = et.normalizeSortingInfo(i || e.group), n = [], a = 0; a < t.length; a++) {
    for (var o = [], u = 0; u <= a; u++)
      o.push([r[u].selector, a === u ? "<>" : "=", t[u]]);
    n.push(et.combineFilters(o));
  }
  return n = et.combineFilters(n, "or"), et.combineFilters([n, e.filter]);
}, oEe = function t(e, i) {
  var r = e.count || e.items.length;
  if (!e.count && i > 1) {
    r = 0;
    for (var n = 0; n < e.items.length; n++)
      r += t(e.items[n], i - 1);
  }
  return r;
};
class _4 extends SX {
  handleDataLoading(e) {
    var {
      storeLoadOptions: i
    } = e, r = [], n = 0, a = !1, o, {
      group: u
    } = e.loadOptions, c = 0;
    if (nEe(i, e.loadOptions), e.group = e.group || u, !e.isCustomLoading) {
      var p = P({}, i);
      p.skip = g4(this, i.skip), p.skip && p.take && u && (p.skip--, p.take++, a = !0), p.take && u && (o = p.take, p.take++), Xw(this, (v) => {
        if (v.offset >= p.skip + p.take + c)
          return !1;
        v.offset >= p.skip + c && v.count && (c += v.count - 1, r.push(v), n += v.count);
      }), N(r, function() {
        p.filter = aEe(this.path, p, u);
      }), e.storeLoadOptions = p, e.collapsedGroups = r, e.collapsedItemsCount = n, e.skip = p.skip || 0, e.skipFirstItem = a, e.take = o;
    }
  }
  handleDataLoaded(e, i) {
    var {
      collapsedGroups: r
    } = e, n = et.normalizeSortingInfo(e.group), a = n.length;
    function o(v, _, y, b, I) {
      if (!(!v || !_.length || !y.length)) {
        var A, L, B = ta(_[0], !0);
        for (L = 0; L < v.length && (A = ta(v[L].key, !0), !(I >= b.offset || B === A)); L++)
          I += oEe(v[L], y.length);
        (!v.length || B !== A) && v.splice(L, 0, {
          key: _[0],
          items: [],
          count: _.length === 1 ? b.count : void 0
        }), o(v[L].items, _.slice(1), y.slice(1), b, I);
      }
    }
    if (e.collapsedItemsCount && e.extra && e.extra.totalCount >= 0 && (e.extra._totalCountWasIncreasedByCollapsedItems || (e.extra.totalCount += e.collapsedItemsCount, e.extra._totalCountWasIncreasedByCollapsedItems = !0)), i(e), a) {
      var {
        data: u
      } = e, c = lo(u);
      if (rc.multiLevelGroup(c, n).enumerate().done((v) => {
        u = v;
      }), r)
        for (var p = 0; p < r.length; p++)
          o(u, r[p].path, n, r[p], e.skip);
      e.isCustomLoading || iEe(this, u, [], e.skip, e.skipFirstItem, e.take), e.data = u;
    }
  }
  isGroupItemCountable(e) {
    return e.items === null;
  }
  updateTotalItemsCount() {
    var e = 0;
    Xw(this, (i) => {
      i.count && (e -= i.count - 1);
    }), super.updateTotalItemsCount(e);
  }
  changeRowExpand(e) {
    var i = this, r = i._dataSource, n = r.beginPageIndex ? r.beginPageIndex() : r.pageIndex(), a = r.items(), o = g4(i, n * r.pageSize()), u = i.findGroupInfo(e), c;
    return u && !u.isExpanded ? c = new q().resolve(u.count) : c = hM(r, {
      filter: Pp(e, {
        filter: r.filter(),
        group: r.group()
      })
    }), $e(c).done((p) => {
      p = parseInt(p.length ? p[0] : p), u ? (m4(i, a, [], o), u.isExpanded = !u.isExpanded, u.count = p) : (u = {
        offset: -1,
        count: p,
        path: e,
        isExpanded: !1
      }, m4(i, a, [], o, u), u.offset >= 0 && i.addGroupInfo(u)), i.updateTotalItemsCount();
    }).fail(function() {
      r._eventsStrategy.fireEvent("loadError", arguments);
    });
  }
  allowCollapseAll() {
    return !1;
  }
  refresh(e, i) {
    var r = this, {
      storeLoadOptions: n
    } = e, a = r._dataSource;
    if (super.refresh.apply(this, arguments), i.reload)
      return Xw(r, (o) => {
        var u = hM(a, {
          filter: Pp(o.path, n)
        }), c = hM(a, {
          filter: xX(o.path, n)
        });
        return $e(c, u).done((p, v) => {
          p = parseInt(p.length ? p[0] : p), v = parseInt(v.length ? v[0] : v), o.offset = p, o.count !== v && (o.count = v, r.updateTotalItemsCount());
        });
      }, !0);
  }
}
var fM = "dx-datagrid-group-panel", sEe = "dx-group-panel-message", fw = "dx-group-panel-item", C4 = "dx-toolbar-label", lEe = "dx-toolbar-item", uEe = "dx-datagrid-expand", dEe = "dx-group-row", cEe = ".dx-header-filter", hEe = (t) => class extends t {
  init() {
    super.init.apply(this, arguments), this._initGroupingHelper();
  }
  _initGroupingHelper(e) {
    var i = this._grouping, r = this.option("grouping.autoExpandAll"), n = this.option("focusedRowEnabled"), a = e ? e.remoteOperations : this.remoteOperations(), o = a.filtering && a.sorting && a.paging;
    o && !a.grouping && (r || !n) ? (!i || i instanceof v4) && (this._grouping = new _4(this)) : (!i || i instanceof _4) && (this._grouping = new v4(this));
  }
  totalItemsCount() {
    var e = super.totalItemsCount();
    return e > 0 && this._dataSource.group() && this._dataSource.requireTotalCount() ? e + this._grouping.totalCountCorrection() : e;
  }
  itemsCount() {
    return this._dataSource.group() ? this._grouping.itemsCount() || 0 : super.itemsCount.apply(this, arguments);
  }
  allowCollapseAll() {
    return this._grouping.allowCollapseAll();
  }
  isGroupItemCountable(e) {
    return this._grouping.isGroupItemCountable(e);
  }
  isRowExpanded(e) {
    var i = this._grouping.findGroupInfo(e);
    return i ? i.isExpanded : !this._grouping.allowCollapseAll();
  }
  collapseAll(e) {
    return this._collapseExpandAll(e, !1);
  }
  expandAll(e) {
    return this._collapseExpandAll(e, !0);
  }
  _collapseExpandAll(e, i) {
    var r = this._dataSource, n = r.group(), a = et.normalizeSortingInfo(n || []);
    if (a.length) {
      for (var o = 0; o < a.length; o++)
        e === void 0 || e === o ? a[o].isExpanded = i : n && n[o] && (a[o].isExpanded = n[o].isExpanded);
      r.group(a), this._grouping.foreachGroups((u, c) => {
        (e === void 0 || e === c.length - 1) && (u.isExpanded = i);
      }, !1, !0), this.resetPagesCache();
    }
    return !0;
  }
  refresh() {
    return super.refresh.apply(this, arguments), this._grouping.refresh.apply(this._grouping, arguments);
  }
  changeRowExpand(e) {
    var i = this._dataSource;
    if (i.group())
      return i.beginLoading(), this._lastLoadOptions && (this._lastLoadOptions.groupExpand = !0), this._changeRowExpandCore(e).always(() => {
        i.endLoading();
      });
  }
  _changeRowExpandCore(e) {
    return this._grouping.changeRowExpand(e);
  }
  _hasGroupLevelsExpandState(e, i) {
    if (e && Array.isArray(e)) {
      for (var r = 0; r < e.length; r++)
        if (e[r].isExpanded === i)
          return !0;
    }
  }
  _customizeRemoteOperations(e, i) {
    var {
      remoteOperations: r
    } = e;
    e.storeLoadOptions.group ? (r.grouping && !e.isCustomLoading && (!r.groupPaging || this._hasGroupLevelsExpandState(e.storeLoadOptions.group, !0)) && (r.paging = !1), !r.grouping && (!r.sorting || !r.filtering || e.isCustomLoading || this._hasGroupLevelsExpandState(e.storeLoadOptions.group, !1)) && (r.paging = !1)) : !e.isCustomLoading && r.paging && i.grouping && this.resetCache(), super._customizeRemoteOperations.apply(this, arguments);
  }
  _handleDataLoading(e) {
    return super._handleDataLoading(e), this._initGroupingHelper(e), this._grouping.handleDataLoading(e);
  }
  _handleDataLoaded(e) {
    return this._grouping.handleDataLoaded(e, super._handleDataLoaded.bind(this));
  }
  _handleDataLoadedCore(e) {
    return this._grouping.handleDataLoadedCore(e, super._handleDataLoadedCore.bind(this));
  }
};
DI.extend(hEe);
var fEe = (t) => class extends t {
  init() {
    super.init(), this.createAction("onRowExpanding"), this.createAction("onRowExpanded"), this.createAction("onRowCollapsing"), this.createAction("onRowCollapsed");
  }
  _beforeProcessItems(e) {
    var i = this._columnsController.getGroupColumns();
    return e = super._beforeProcessItems(e), e.length && i.length && (e = this._processGroupItems(e, i.length)), e;
  }
  _processItem(e, i) {
    return R(e.groupIndex) && ht(e.rowType) && e.rowType.indexOf("group") === 0 ? (e = this._processGroupItem(e, i), i.dataIndex = 0) : e = super._processItem.apply(this, arguments), e;
  }
  _processGroupItem(e, i) {
    return e;
  }
  _processGroupItems(e, i, r) {
    var n = this._columnsController.getGroupColumns(), a = n[n.length - i];
    if (!r) {
      var o = this.option("scrolling.mode");
      r = {
        collectContinuationItems: o !== "virtual" && o !== "infinite",
        resultItems: [],
        path: [],
        values: []
      };
    }
    var {
      resultItems: u
    } = r;
    if (r.data && (r.collectContinuationItems || !r.data.isContinuation) && u.push({
      rowType: "group",
      data: r.data,
      groupIndex: r.path.length - 1,
      isExpanded: !!r.data.items,
      key: r.path.slice(0),
      values: r.values.slice(0)
    }), e)
      if (i === 0)
        u.push.apply(u, e);
      else
        for (var c = 0; c < e.length; c++) {
          var p = e[c];
          p && "items" in p ? (r.data = p, r.path.push(p.key), r.values.push(a && a.deserializeValue && !a.calculateDisplayValue ? a.deserializeValue(p.key) : p.key), this._processGroupItems(p.items, i - 1, r), r.data = void 0, r.path.pop(), r.values.pop()) : u.push(p);
        }
    return u;
  }
  publicMethods() {
    return super.publicMethods().concat(["collapseAll", "expandAll", "isRowExpanded", "expandRow", "collapseRow"]);
  }
  collapseAll(e) {
    var i = this._dataSource;
    i && i.collapseAll(e) && (i.pageIndex(0), i.reload());
  }
  expandAll(e) {
    var i = this._dataSource;
    i && i.expandAll(e) && (i.pageIndex(0), i.reload());
  }
  changeRowExpand(e) {
    var i = this, r = i.isRowExpanded(e), n = {
      key: e,
      expanded: r
    };
    return i.executeAction(r ? "onRowCollapsing" : "onRowExpanding", n), n.cancel ? new q().resolve() : $e(i._changeRowExpandCore(e)).done(() => {
      n.expanded = !r, i.executeAction(r ? "onRowCollapsed" : "onRowExpanded", n);
    });
  }
  _changeRowExpandCore(e) {
    var i = this, r = this._dataSource, n = new q();
    return r ? $e(r.changeRowExpand(e)).done(() => {
      i.load().done(n.resolve).fail(n.reject);
    }).fail(n.reject) : n.resolve(), n;
  }
  isRowExpanded(e) {
    var i = this._dataSource;
    return i && i.isRowExpanded(e);
  }
  expandRow(e) {
    return this.isRowExpanded(e) ? new q().resolve() : this.changeRowExpand(e);
  }
  collapseRow(e) {
    return this.isRowExpanded(e) ? this.changeRowExpand(e) : new q().resolve();
  }
  optionChanged(e) {
    e.name === "grouping" && (e.name = "dataSource"), super.optionChanged(e);
  }
}, $B = function(t, e) {
  var i = this._columnsController;
  switch (e.itemData.value) {
    case "group":
      var r = i._dataSource.group() || [];
      i.columnOption(t.dataField, "groupIndex", r.length);
      break;
    case "ungroup":
      i.columnOption(t.dataField, "groupIndex", -1);
      break;
    case "ungroupAll":
      this.component.clearGrouping();
  }
}, DX = (t) => {
  var e = t == null ? void 0 : t.visible;
  return e === "auto" ? Ye.current().deviceType === "desktop" : !!e;
}, AX = (t, e) => {
  var i = DX(t), r = (t == null ? void 0 : t.allowColumnDragging) && e.allowGrouping;
  return i && !!r;
}, pEe = (t) => class extends t {
  _getToolbarItems() {
    var e = super._getToolbarItems();
    return this._appendGroupingItem(e);
  }
  _appendGroupingItem(e) {
    if (this._isGroupPanelVisible()) {
      var i = !1, r = {
        template: () => {
          var n = E("<div>").addClass(fM);
          return this._updateGroupPanelContent(n), fx("groupPanel", this, n, void 0, this._handleActionKeyDown.bind(this)), n;
        },
        name: "groupPanel",
        onItemRendered: () => {
          i && this.renderCompleted.fire(), i = !0;
        },
        location: "before",
        locateInMenu: "never",
        sortIndex: 1
      };
      e.push(r), this.updateToolbarDimensions();
    }
    return e;
  }
  _handleActionKeyDown(e) {
    var {
      event: i
    } = e, r = E(i.target), n = r.closest(".".concat(fw)).index(), a = this._columnsController.getGroupColumns()[n], o = a && a.index;
    r.is(cEe) ? this.getController("headerFilter").showHeaderFilterMenu(o, !0) : this._processGroupItemAction(o), i.preventDefault();
  }
  _isGroupPanelVisible() {
    return DX(this.option("groupPanel"));
  }
  _renderGroupPanelItems(e, i) {
    var r = this;
    e.empty(), N(i, (n, a) => {
      r._createGroupPanelItem(e, a);
    }), JF(this);
  }
  _createGroupPanelItem(e, i) {
    var r = E("<div>").addClass(i.cssClass).addClass(fw).data("columnData", i).appendTo(e).text(i.caption);
    return ece(this, r), r;
  }
  _columnOptionChanged(e) {
    if (!this._requireReady && !et.checkChanges(e.optionNames, ["width", "visibleWidth"])) {
      var i = this.element(), r = i && i.find(".".concat(fM));
      r && r.length && (this._updateGroupPanelContent(r), this.updateToolbarDimensions(), this.renderCompleted.fire());
    }
    super._columnOptionChanged();
  }
  _updateGroupPanelContent(e) {
    var i = this.getController("columns").getGroupColumns(), r = this.option("groupPanel");
    this._renderGroupPanelItems(e, i), r.allowColumnDragging && !i.length && (E("<div>").addClass(sEe).text(r.emptyPanelText).appendTo(e), e.closest(".".concat(lEe)).addClass(C4), e.closest(".".concat(C4)).css("maxWidth", "none"));
  }
  allowDragging(e) {
    var i = this.option("groupPanel");
    return AX(i, e);
  }
  getColumnElements() {
    var e = this.element();
    return e && e.find(".".concat(fw));
  }
  getColumns() {
    return this.getController("columns").getGroupColumns();
  }
  getBoundingRect() {
    var e = this.element();
    if (e && e.find(".".concat(fM)).length) {
      var i = e.offset();
      return {
        top: i.top,
        bottom: i.top + Pt(e)
      };
    }
    return null;
  }
  getName() {
    return "group";
  }
  getContextMenuItems(e) {
    var i = this.option("grouping.contextMenuEnabled"), r = E(e.targetElement).closest(".".concat(fw)), n;
    if (r.length && (e.column = r.data("columnData")), i && e.column) {
      var {
        column: a
      } = e, o = R(a.allowGrouping) ? a.allowGrouping : !0;
      if (o) {
        var u = R(a.groupIndex) && a.groupIndex > -1, c = this.option("grouping.texts"), p = $B.bind(this, a);
        n = [{
          text: c.ungroup,
          value: "ungroup",
          disabled: !u,
          onItemClick: p
        }, {
          text: c.ungroupAll,
          value: "ungroupAll",
          onItemClick: p
        }];
      }
    }
    return n;
  }
  isVisible() {
    return super.isVisible() || this._isGroupPanelVisible();
  }
  hasGroupedColumns() {
    return this._isGroupPanelVisible() && !!this.getColumns().length;
  }
  optionChanged(e) {
    e.name === "groupPanel" ? (this._invalidate(), e.handled = !0) : super.optionChanged(e);
  }
}, vEe = (t) => class extends t {
  getContextMenuItems(e) {
    var i = this.option("grouping.contextMenuEnabled"), r;
    if (i && e.row && e.row.rowType === "group") {
      var n = this._columnsController, a = n.columnOption("groupIndex:".concat(e.row.groupIndex));
      if (a && a.allowGrouping) {
        var o = this.option("grouping.texts"), u = $B.bind(this, a);
        r = [], r.push({
          text: o.ungroup,
          value: "ungroup",
          onItemClick: u
        }, {
          text: o.ungroupAll,
          value: "ungroupAll",
          onItemClick: u
        });
      }
    }
    return r;
  }
  _rowClick(e) {
    var i = this.option("grouping.expandMode"), r = this.option("scrolling.mode"), n = r !== "infinite" && i === "rowClick" && E(e.event.target).closest(".".concat(dEe)).length, a = E(e.event.target).closest(".".concat(uEe)).length;
    (n || a) && this._changeGroupRowState(e), super._rowClick(e);
  }
  _changeGroupRowState(e) {
    var i = this.getController("data"), r = i.items()[e.rowIndex], n = this._columnsController.columnOption("groupIndex:".concat(r.groupIndex), "allowCollapsing");
    (r.rowType === "data" || r.rowType === "group" && n !== !1) && (i.changeRowExpand(r.key, !0), e.event.preventDefault(), e.handled = !0);
  }
}, gEe = (t) => class extends t {
  getContextMenuItems(e) {
    var i = this.option("grouping.contextMenuEnabled"), r = super.getContextMenuItems(e);
    if (i && e.row && (e.row.rowType === "header" || e.row.rowType === "detailAdaptive")) {
      var {
        column: n
      } = e;
      if (!n.command && (!R(n.allowGrouping) || n.allowGrouping)) {
        var a = this.option("grouping.texts"), o = R(n.groupIndex) && n.groupIndex > -1, u = $B.bind(this, n);
        r = r || [], r.push({
          text: a.groupByThisColumn,
          value: "group",
          beginGroup: !0,
          disabled: o,
          onItemClick: u
        }), n.showWhenGrouped && r.push({
          text: a.ungroup,
          value: "ungroup",
          disabled: !o,
          onItemClick: u
        }), r.push({
          text: a.ungroupAll,
          value: "ungroupAll",
          onItemClick: u
        });
      }
    }
    return r;
  }
  allowDragging(e) {
    var i = this.option("groupPanel");
    return AX(i, e) || super.allowDragging(e);
  }
};
et.registerModule("grouping", {
  defaultOptions: () => ({
    grouping: {
      autoExpandAll: !0,
      allowCollapsing: !0,
      contextMenuEnabled: !1,
      expandMode: "buttonClick",
      texts: {
        groupContinuesMessage: X.format("dxDataGrid-groupContinuesMessage"),
        groupContinuedMessage: X.format("dxDataGrid-groupContinuedMessage"),
        groupByThisColumn: X.format("dxDataGrid-groupHeaderText"),
        ungroup: X.format("dxDataGrid-ungroupHeaderText"),
        ungroupAll: X.format("dxDataGrid-ungroupAllText")
      }
    },
    groupPanel: {
      visible: !1,
      emptyPanelText: X.format("dxDataGrid-groupPanelEmptyText"),
      allowColumnDragging: !0
    }
  }),
  extenders: {
    controllers: {
      data: fEe,
      columns: (t) => class extends t {
        _getExpandColumnOptions() {
          var e = super._getExpandColumnOptions.apply(this, arguments);
          return e.cellTemplate = et.getExpandCellTemplate(), e;
        }
      },
      editing: (t) => class extends t {
        _isProcessedItem(e) {
          return R(e.groupIndex) && ht(e.rowType) && e.rowType.indexOf("group") === 0;
        }
      }
    },
    views: {
      headerPanel: pEe,
      rowsView: vEe,
      columnHeadersView: gEe
    }
  }
});
var mEe = "dx-master-detail-cell", OX = "dx-master-detail-row", _Ee = "dx-cell-focus-disabled", CEe = "dx-row-lines", yEe = (t) => class extends t {
  _getExpandColumnsCore() {
    var e = super._getExpandColumnsCore();
    return this.option("masterDetail.enabled") && e.push({
      type: "detailExpand",
      cellTemplate: xe.getExpandCellTemplate()
    }), e;
  }
}, pM = function(t) {
  t._expandedItems = [], t._isExpandAll = t.option("masterDetail.autoExpandAll");
}, xEe = (t) => class extends t {
  init() {
    pM(this), super.init();
  }
  expandAll(e) {
    e < 0 ? (this._isExpandAll = !0, this._expandedItems = [], this.updateItems()) : super.expandAll.apply(this, arguments);
  }
  collapseAll(e) {
    e < 0 ? (this._isExpandAll = !1, this._expandedItems = [], this.updateItems()) : super.collapseAll.apply(this, arguments);
  }
  isRowExpandedHack() {
    return super.isRowExpanded.apply(this, arguments);
  }
  isRowExpanded(e) {
    var i = xe.getIndexByKey(e, this._expandedItems);
    return Array.isArray(e) ? super.isRowExpanded.apply(this, arguments) : !!(this._isExpandAll ^ (i >= 0 && this._expandedItems[i].visible));
  }
  _getRowIndicesForExpand(e) {
    var i = this.getRowIndexByKey(e);
    return [i, i + 1];
  }
  _changeRowExpandCore(e) {
    var i;
    if (Array.isArray(e))
      i = super._changeRowExpandCore.apply(this, arguments);
    else {
      var r = xe.getIndexByKey(e, this._expandedItems);
      if (r >= 0) {
        var {
          visible: n
        } = this._expandedItems[r];
        this._expandedItems[r].visible = !n;
      } else
        this._expandedItems.push({
          key: e,
          visible: !0
        });
      this.updateItems({
        changeType: "update",
        rowIndices: this._getRowIndicesForExpand(e)
      }), i = new q().resolve();
    }
    return i;
  }
  _processDataItemHack() {
    return super._processDataItem.apply(this, arguments);
  }
  _processDataItem(e, i) {
    var r = super._processDataItem.apply(this, arguments);
    return r.isExpanded = this.isRowExpanded(r.key), i.detailColumnIndex === void 0 && (i.detailColumnIndex = -1, N(i.visibleColumns, (n, a) => {
      if (a.command === "expand" && !R(a.groupIndex))
        return i.detailColumnIndex = n, !1;
    })), i.detailColumnIndex >= 0 && (r.values[i.detailColumnIndex] = r.isExpanded), r;
  }
  _processItemsHack() {
    return super._processItems.apply(this, arguments);
  }
  _processItems(e, i) {
    var r = this, {
      changeType: n
    } = i, a = [];
    return e = super._processItems.apply(r, arguments), n === "loadingAll" ? e : (n === "refresh" && (r._expandedItems = so(r._expandedItems, (o) => o.visible)), N(e, (o, u) => {
      a.push(u);
      var c = xe.getIndexByKey(u.key, r._expandedItems);
      u.rowType === "data" && (u.isExpanded || c >= 0) && !u.isNewRow && a.push({
        visible: u.isExpanded,
        rowType: "detail",
        key: u.key,
        data: u.data,
        values: []
      });
    }), a);
  }
  optionChanged(e) {
    var i, r;
    if (e.name === "masterDetail") {
      switch (e.name = "dataSource", e.fullName) {
        case "masterDetail":
          var n = e.value || {}, a = e.previousValue || {};
          i = n.enabled !== a.enabled, r = n.autoExpandAll !== a.autoExpandAll;
          break;
        case "masterDetail.template":
          pM(this);
          break;
        case "masterDetail.enabled":
          i = !0;
          break;
        case "masterDetail.autoExpandAll":
          r = !0;
      }
      (i || r) && pM(this);
    }
    super.optionChanged(e);
  }
}, SEe = (t) => class extends t {
  fireContentReadyAction() {
    super.fireContentReadyAction.apply(this, arguments), this._updateParentDataGrids(this.component.$element());
  }
  _updateParentDataGrids(e) {
    var i = e.closest(".".concat(OX));
    i.length && $e(this._updateMasterDataGrid(i, e)).done(() => {
      this._updateParentDataGrids(i.parent());
    });
  }
  _updateMasterDataGrid(e, i) {
    var r = E(e).data("options"), n = E(e).closest(".".concat(this.getWidgetContainerClass())).parent().data("dxDataGrid");
    if (r && n)
      return this._updateMasterDataGridCore(n, r);
  }
  _updateMasterDataGridCore(e, i) {
    var r = q();
    if (e.getView("rowsView").isFixedColumns())
      this._updateFixedMasterDetailGrids(e, i.rowIndex, E(i.rowElement)).done(r.resolve);
    else {
      if (e.option("scrolling.useNative") === !0) {
        e.updateDimensions().done(() => r.resolve(!0));
        return;
      }
      var n = e.getScrollable();
      n ? n == null || n.update().done(() => r.resolve()) : r.resolve();
    }
    return r.promise();
  }
  _updateFixedMasterDetailGrids(e, i, r) {
    var n = q(), a = E(e.getRowElement(i)), o = E(e.getView("rowsView").getTableElements()), u = (a == null ? void 0 : a.length) === 2 && Pt(a.eq(0)) !== Pt(a.eq(1)), c = (o == null ? void 0 : o.length) === 2 && Pt(o.eq(0)) !== Pt(o.eq(1));
    if (u || c) {
      var p = mt(r);
      return e.updateDimensions().done(() => {
        var v = this.option("columnAutoWidth") && e.option("scrolling.useNative") === !0, _ = v && p !== mt(r);
        v && _ ? this.updateDimensions().done(() => n.resolve(!0)) : n.resolve(!0);
      }), n.promise();
    }
    return q().resolve();
  }
  _toggleBestFitMode(e) {
    if (super._toggleBestFitMode.apply(this, arguments), this.option("masterDetail.template")) {
      var i = this._rowsView.getTableElement();
      i && i.find(".dx-master-detail-cell").css("maxWidth", e ? 0 : "");
    }
  }
}, EEe = (t) => class extends t {
  _getCellTemplate(e) {
    var {
      column: i
    } = e, r = this._editingController, n = r && r.isEditRow(e.rowIndex), a;
    return i.command === "detail" && !n ? a = this.option("masterDetail.template") || {
      allowRenderToDetachedContainer: !1,
      render: this._getDefaultTemplate(i)
    } : a = super._getCellTemplate.apply(this, arguments), a;
  }
  _isDetailRow(e) {
    return e && e.rowType && e.rowType.indexOf("detail") === 0;
  }
  _createRow(e) {
    var i = super._createRow.apply(this, arguments);
    return e && this._isDetailRow(e) && (this.option("showRowLines") && i.addClass(CEe), i.addClass(OX), R(e.visible) && i.toggle(e.visible)), i;
  }
  _renderCells(e, i) {
    var {
      row: r
    } = i, n, a = this._columnsController.getVisibleColumns();
    r.rowType && this._isDetailRow(r) ? this._needRenderCell(0, i.columnIndices) && (n = this._renderCell(e, {
      value: null,
      row: r,
      rowIndex: r.rowIndex,
      column: {
        command: "detail"
      },
      columnIndex: 0,
      change: i.change
    }), n.addClass(_Ee).addClass(mEe).attr("colSpan", a.length)) : super._renderCells.apply(this, arguments);
  }
}, bEe = {
  defaultOptions: () => ({
    masterDetail: {
      enabled: !1,
      autoExpandAll: !1,
      template: null
    }
  }),
  extenders: {
    controllers: {
      columns: yEe,
      data: xEe,
      resizing: SEe
    },
    views: {
      rowsView: EEe
    }
  }
};
et.registerModule("masterDetail", bEe);
var Qw = function(t) {
  for (var e = 0, i = 0, r = 0; r < t.length; ++r)
    if (t[r] === "'" && e++, t[r] === "." && (++i, e % 2 === 0))
      return {
        occurrence: i,
        index: r
      };
  return {
    occurrence: 1,
    index: -1
  };
}, DP = function(t, e, i) {
  for (var r = -1; i-- && r++ < t.length; )
    r = t.indexOf(e, r);
  return r;
}, AP = function(t, e) {
  return e === -1 ? [t] : [t.slice(0, e), t.slice(e + 1)];
}, wEe = function(t, e) {
  return t && Tj(t / 100, e);
}, zT = function(t, e) {
  if (typeof e == "string") {
    var i = e.split(";"), r = _i.getSign(t, e);
    i[1] = i[1] || "-" + i[0], e = i[r < 0 ? 1 : 0], e = (o = e, o.replace(/'([^']*)'/g, (u) => u.split("").map(() => " ").join("").substr(2)));
    var n = /^[^#0.,]*/.exec(e)[0].length, a = /[^#0.,]*$/.exec(e)[0].length;
    return {
      start: n,
      end: t.length - a
    };
  } else
    return {
      start: 0,
      end: t.length
    };
  var o;
}, y4 = function(t, e) {
  var i = _i.getDecimalSeparator(), r = new RegExp("[^0-9" + Eh(i) + "]", "g"), n = e.slice(0, t);
  return n.replace(r, "").length;
}, x4 = function(t) {
  return t.split("").reverse().join("");
}, S4 = function(t, e) {
  if (!t)
    return -1;
  for (var i = /[0-9]/g, r = 1, n = null, a = i.exec(e); a; ) {
    if (n = a.index, r >= t)
      return n;
    r++, a = i.exec(e);
  }
  return n === null ? e.length : n;
}, TEe = function(t) {
  return t.replace(/[^0-9e]+$/, "");
}, vp = function(t, e) {
  return t.start === void 0 && (t = {
    start: t,
    end: t
  }), {
    start: t.start + e,
    end: t.end + e
  };
}, IEe = function(t, e, i, r) {
  i = vp(i, 0);
  var n = _i.getDecimalSeparator(), a = DEe(t), o = Qw(r).occurrence, u = a ? 0 : DP(t, n, o), c = DP(e, n, o), p = AP(t, u), v = AP(e, c), _ = u !== -1 && i.start > u;
  if (_) {
    var y = i.start - u - 1, b = y4(y, p[1]), I = v[1] ? c + 1 + S4(b, v[1]) + 1 : e.length;
    return _h(I, e, r);
  } else {
    var A = TEe(v[0]), L = p[0].length - i.start, B = y4(L, x4(p[0])), $ = S4(B, x4(A)), K = A.length - ($ + 1);
    return _h(K, e, r);
  }
};
function DEe(t) {
  return t.length === 1 && !!t.match(/^[,.][0-9]*$/g);
}
var AEe = function(t, e, i) {
  t = vp(t, 0);
  var r = _h(t, e, i);
  return t.start >= r.start && t.end <= r.end;
};
function _h(t, e, i) {
  t = vp(t, 0);
  var r = zT(e, i), n = {
    start: ma(t.start, r.start, r.end),
    end: ma(t.end, r.start, r.end)
  };
  return n;
}
var OEe = function(t, e, i) {
  var r = zT(t, i), n = zT(e, i);
  return n.start - r.start;
}, REe = "dx-numberbox-spin", LEe = "dx-numberbox-spin-button", MEe = 100, RX = "dxNumberBox", E4 = ve(Xt.up, RX), b4 = ve(Xt.cancel, RX), Jg = xn.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      direction: "up",
      onChange: null,
      activeStateEnabled: !0,
      hoverStateEnabled: !0
    });
  },
  _initMarkup: function() {
    this.callBase();
    var t = REe + "-" + this.option("direction");
    this.$element().addClass(LEe).addClass(t), this._spinIcon = E("<div>").addClass(t + "-icon").appendTo(this.$element());
  },
  _render: function() {
    this.callBase();
    var t = ve(Xt.down, this.NAME), e = this.$element();
    k.off(e, t), k.on(e, t, this._spinDownHandler.bind(this)), this._spinChangeHandler = this._createActionByOption("onChange");
  },
  _spinDownHandler: function(t) {
    t.preventDefault(), this._clearTimer(), k.on(this.$element(), Lh.name, (function() {
      this._feedBackDeferred = new q(), kse(this._feedBackDeferred), this._spinChangeHandler({
        event: t
      }), this._holdTimer = setInterval(this._spinChangeHandler, MEe, {
        event: t
      });
    }).bind(this));
    var e = de.getDocument();
    k.on(e, E4, this._clearTimer.bind(this)), k.on(e, b4, this._clearTimer.bind(this)), this._spinChangeHandler({
      event: t
    });
  },
  _dispose: function() {
    this._clearTimer(), this.callBase();
  },
  _clearTimer: function() {
    k.off(this.$element(), Lh.name);
    var t = de.getDocument();
    k.off(t, E4), k.off(t, b4), this._feedBackDeferred && this._feedBackDeferred.resolve(), this._holdTimer && clearInterval(this._holdTimer);
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "onChange":
      case "direction":
        this._invalidate();
        break;
      default:
        this.callBase(t);
    }
  }
}), kEe = "dx-numberbox-spin", PEe = "dx-numberbox-spin-container", FEe = "dx-numberbox-spin-touch-friendly";
class BEe extends AI {
  _attachEvents(e, i) {
    var {
      editor: r
    } = this, n = ve(Xt.down, r.NAME), a = i.children(), o = r._createAction((u) => r._spinButtonsPointerDownHandler(u));
    k.off(i, n), k.on(i, n, (u) => o({
      event: u
    })), Jg.getInstance(a.eq(0)).option("onChange", (u) => r._spinUpChangeHandler(u)), Jg.getInstance(a.eq(1)).option("onChange", (u) => r._spinDownChangeHandler(u));
  }
  _create() {
    var {
      editor: e
    } = this, i = E("<div>").addClass(PEe), r = E("<div>").appendTo(i), n = E("<div>").appendTo(i), a = this._getOptions();
    return this._addToContainer(i), e._createComponent(r, Jg, P({
      direction: "up"
    }, a)), e._createComponent(n, Jg, P({
      direction: "down"
    }, a)), this._legacyRender(e.$element(), this._isTouchFriendly(), a.visible), {
      instance: i,
      $element: i
    };
  }
  _getOptions() {
    var {
      editor: e
    } = this, i = this._isVisible(), r = e.option("disabled");
    return {
      visible: i,
      disabled: r
    };
  }
  _isVisible() {
    var {
      editor: e
    } = this;
    return super._isVisible() && e.option("showSpinButtons");
  }
  _isTouchFriendly() {
    var {
      editor: e
    } = this;
    return e.option("showSpinButtons") && e.option("useLargeSpinButtons");
  }
  _legacyRender(e, i, r) {
    e.toggleClass(FEe, i), e.toggleClass(kEe, r);
  }
  update() {
    var e = super.update();
    if (e) {
      var {
        editor: i,
        instance: r
      } = this, n = i.$element(), a = this._isVisible(), o = this._isTouchFriendly(), u = r.children(), c = Jg.getInstance(u.eq(0)), p = Jg.getInstance(u.eq(1)), v = this._getOptions();
      c.option(v), p.option(v), this._legacyRender(n, o, a);
    }
  }
}
var VEe = Math, NEe = "dx-numberbox", HEe = ["tab", "del", "backspace", "leftArrow", "rightArrow", "home", "end", "enter"], $Ee = "NumberBoxForceValueChange", zEe = bB.inherit({
  _supportedKeys: function() {
    return P(this.callBase(), {
      upArrow: function(t) {
        Cn(t) || (t.preventDefault(), t.stopPropagation(), this._spinUpChangeHandler(t));
      },
      downArrow: function(t) {
        Cn(t) || (t.preventDefault(), t.stopPropagation(), this._spinDownChangeHandler(t));
      },
      enter: function() {
      }
    });
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      value: 0,
      min: void 0,
      max: void 0,
      step: 1,
      showSpinButtons: !1,
      useLargeSpinButtons: !0,
      mode: "text",
      invalidValueMessage: X.format("dxNumberBox-invalidValueMessage"),
      buttons: void 0
    });
  },
  _useTemplates: function() {
    return !1;
  },
  _getDefaultButtons: function() {
    return this.callBase().concat([{
      name: "spins",
      Ctor: BEe
    }]);
  },
  _isSupportInputMode: function() {
    var t = parseFloat($i.version);
    return $i.chrome && t >= 66 || $i.safari && t >= 12;
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: function() {
        return Ye.real().generic && !Ye.isSimulator();
      },
      options: {
        useLargeSpinButtons: !1
      }
    }, {
      device: (function() {
        return Ye.real().deviceType !== "desktop" && !this._isSupportInputMode();
      }).bind(this),
      options: {
        mode: "number"
      }
    }]);
  },
  _initMarkup: function() {
    this._renderSubmitElement(), this.$element().addClass(NEe), this.callBase();
  },
  _getDefaultAttributes: function() {
    var t = this.callBase();
    return t.inputmode = "decimal", t;
  },
  _renderContentImpl: function() {
    this.option("isValid") && this._validateValue(this.option("value")), this.setAria("role", "spinbutton");
  },
  _renderSubmitElement: function() {
    this._$submitElement = E("<input>").attr("type", "hidden").appendTo(this.$element()), this._setSubmitValue(this.option("value"));
  },
  _setSubmitValue: function(t) {
    this._getSubmitElement().val(yie(t));
  },
  _getSubmitElement: function() {
    return this._$submitElement;
  },
  _keyPressHandler: function(t) {
    this.callBase(t);
    var e = Rk(t), i = /[\d.,eE\-+]/.test(e);
    if (!i) {
      var r = or(t);
      return Cn(t) || r && HEe.includes(r) ? void 0 : (t.preventDefault(), !1);
    }
    this._keyPressed = !0;
  },
  _onMouseWheel: function(t) {
    t.delta > 0 ? this._spinValueChange(1, t) : this._spinValueChange(-1, t);
  },
  _renderValue: function() {
    var t = this._input().val(), e = this.option("value");
    (!t.length || Number(t) !== e) && (this._forceValueRender(), this._toggleEmptinessEventHandler());
    var i = R(e) ? null : X.format("dxNumberBox-noDataText");
    return this.setAria({
      valuenow: cr(e, ""),
      valuetext: i
    }), this.option("text", this._input().val()), this._updateButtons(), new q().resolve();
  },
  _forceValueRender: function() {
    var t = this.option("value"), e = Number(t), i = isNaN(e) ? "" : this._applyDisplayValueFormatter(t);
    this._renderDisplayText(i);
  },
  _applyDisplayValueFormatter: function(t) {
    return this.option("displayValueFormatter")(t);
  },
  _renderProps: function() {
    this._input().prop({
      min: this.option("min"),
      max: this.option("max"),
      step: this.option("step")
    }), this.setAria({
      valuemin: cr(this.option("min"), ""),
      valuemax: cr(this.option("max"), "")
    });
  },
  _spinButtonsPointerDownHandler: function() {
    var t = this._input();
    !this.option("useLargeSpinButtons") && de.getActiveElement() !== t[0] && k.trigger(t, "focus");
  },
  _spinUpChangeHandler: function(t) {
    this.option("readOnly") || this._spinValueChange(1, t.event || t);
  },
  _spinDownChangeHandler: function(t) {
    this.option("readOnly") || this._spinValueChange(-1, t.event || t);
  },
  _spinValueChange: function(t, e) {
    var i = parseFloat(this.option("step"));
    if (i !== 0) {
      var r = parseFloat(this._normalizeInputValue()) || 0;
      r = this._correctRounding(r, i * t);
      var n = this.option("min"), a = this.option("max");
      R(n) && (r = Math.max(n, r)), R(a) && (r = Math.min(a, r)), this._saveValueChangeEvent(e), this.option("value", r);
    }
  },
  _correctRounding: function(t, e) {
    var i = /[,.](.*)/, r = i.test(t), n = i.test(e);
    if (r || n) {
      var a = r ? i.exec(t)[0].length : 0, o = n ? i.exec(e)[0].length : 0, u = VEe.max(a, o);
      return t = this._round(t + e, u), t;
    }
    return t + e;
  },
  _round: function(t, e) {
    e = e || 0;
    var i = Math.pow(10, e);
    return t *= i, t = Math.round(t) / i, t;
  },
  _renderValueChangeEvent: function() {
    this.callBase();
    var t = ve("focusout", $Ee);
    k.off(this.element(), t), k.on(this.element(), t, this._forceRefreshInputValue.bind(this));
  },
  _forceRefreshInputValue: function() {
    if (this.option("mode") !== "number") {
      var t = this._input(), e = this._applyDisplayValueFormatter(this.option("value"));
      t.val(null), t.val(e);
    }
  },
  _valueChangeEventHandler: function(t) {
    var e = this._input(), i = this._normalizeText(), r = this._parseValue(i), n = i !== "." && i !== "-";
    if (this._isValueValid() && !this._validateValue(r)) {
      e.val(this._applyDisplayValueFormatter(r));
      return;
    }
    n && this.callBase(t, isNaN(r) ? null : r), this._applyValueBoundaries(i, r), this.validationRequest.fire({
      value: r,
      editor: this
    });
  },
  _applyValueBoundaries: function(t, e) {
    var i = this._isValueIncomplete(t), r = this._isValueInRange(t);
    !i && !r && e !== null && Number(t) !== e && this._input().val(this._applyDisplayValueFormatter(e));
  },
  _replaceCommaWithPoint: function(t) {
    return t.replace(",", ".");
  },
  _inputIsInvalid: function() {
    var t = this.option("mode") === "number", e = this._input().get(0).validity;
    return t && e && e.badInput;
  },
  _renderDisplayText: function(t) {
    this._inputIsInvalid() || this.callBase(t);
  },
  _isValueIncomplete: function(t) {
    return /(^-$)|(^-?\d*\.$)|(\d+e-?$)/i.test(t);
  },
  _isValueInRange: function(t) {
    return Ud(t, this.option("min"), this.option("max"));
  },
  _isNumber: function(t) {
    return this._parseValue(t) !== null;
  },
  _validateValue: function(t) {
    var e = this._normalizeText(), i = this._isValueValid(), r = !0, n = this._isNumber(e);
    return isNaN(Number(t)) && (r = !1), !t && i ? r = !0 : !n && !i && (r = !1), this.option({
      isValid: r,
      validationError: r ? null : {
        editorSpecific: !0,
        message: this.option("invalidValueMessage")
      }
    }), r;
  },
  _normalizeInputValue: function() {
    return this._parseValue(this._normalizeText());
  },
  _normalizeText: function() {
    var t = this._input().val().trim();
    return this._replaceCommaWithPoint(t);
  },
  _parseValue: function(t) {
    var e = parseFloat(t);
    return isNaN(e) ? null : ma(e, this.option("min"), this.option("max"));
  },
  _clearValue: function() {
    this._inputIsInvalid() && (this._input().val(""), this._validateValue()), this.callBase();
  },
  clear: function() {
    this.option("value") === null ? (this.option("text", ""), this._input().length && this._renderValue()) : this.option("value", null);
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "value":
        this._validateValue(t.value), this._setSubmitValue(t.value), this.callBase(t), this._resumeValueChangeAction();
        break;
      case "step":
        this._renderProps();
        break;
      case "min":
      case "max":
        this._renderProps(), this.option("value", this._parseValue(this.option("value")));
        break;
      case "showSpinButtons":
      case "useLargeSpinButtons":
        this._updateButtons(["spins"]);
        break;
      case "invalidValueMessage":
        break;
      default:
        this.callBase(t);
    }
  }
}), vM = "dxNumberFormatter", pw = 1, gM = -1, w4 = "-", Fy = "minus", WEe = "input", UEe = 110, T4 = 0, WT = zEe.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      useMaskBehavior: !0,
      format: null
    });
  },
  _isDeleteKey: function(t) {
    return t === "del";
  },
  _supportedKeys: function() {
    return this._useMaskBehavior() ? P(this.callBase(), {
      minus: this._revertSign.bind(this),
      del: this._removeHandler.bind(this),
      backspace: this._removeHandler.bind(this),
      leftArrow: this._arrowHandler.bind(this, gM),
      rightArrow: this._arrowHandler.bind(this, pw),
      home: this._moveCaretToBoundaryEventHandler.bind(this, pw),
      enter: this._updateFormattedValue.bind(this),
      end: this._moveCaretToBoundaryEventHandler.bind(this, gM)
    }) : this.callBase();
  },
  _getTextSeparatorIndex: function(t) {
    var e = _i.getDecimalSeparator(), i = Qw(this.option("format")).occurrence;
    return DP(t, e, i);
  },
  _focusInHandler: function(t) {
    this._preventNestedFocusEvent(t) || (this.clearCaretTimeout(), this._caretTimeout = setTimeout((function() {
      this._caretTimeout = void 0;
      var e = this._caret();
      if (e.start === e.end && this._useMaskBehavior()) {
        var i = this._getInputVal(), r = this._getTextSeparatorIndex(i);
        r >= 0 ? this._caret({
          start: r,
          end: r
        }) : this._moveCaretToBoundaryEventHandler(gM, t);
      }
    }).bind(this), T4)), this.callBase(t);
  },
  _focusOutHandler: function(t) {
    var e = !this._preventNestedFocusEvent(t);
    e && (this._focusOutOccurs = !0, this._useMaskBehavior() && this._updateFormattedValue()), this.callBase(t), e && (this._focusOutOccurs = !1);
  },
  _hasValueBeenChanged(t) {
    var e = this._getFormatPattern(), i = this.option("value"), r = this._format(i, e) || "";
    return r !== t;
  },
  _updateFormattedValue: function() {
    var t = this._getInputVal();
    this._hasValueBeenChanged(t) && (this._updateParsedValue(), this._adjustParsedValue(), this._setTextByParsedValue(), this._parsedValue !== this.option("value") && k.trigger(this._input(), "change"));
  },
  _arrowHandler: function(t, e) {
    if (this._useMaskBehavior()) {
      var i = this._getInputVal(), r = this._getFormatPattern(), n = vp(this._caret(), t);
      AEe(n, i, r) || (n = t === pw ? n.end : n.start, e.preventDefault(), this._caret(_h(n, i, r)));
    }
  },
  _moveCaretToBoundary: function(t) {
    var e = zT(this._getInputVal(), this._getFormatPattern()), i = vp(t === pw ? e.start : e.end, 0);
    this._caret(i);
  },
  _moveCaretToBoundaryEventHandler: function(t, e) {
    !this._useMaskBehavior() || e && e.shiftKey || (this._moveCaretToBoundary(t), e && e.preventDefault());
  },
  _shouldMoveCaret: function(t, e) {
    var i = _i.getDecimalSeparator(), r = t.charAt(e.end) === i, n = (this._lastKey === i || this._lastKey === "." || this._lastKey === ",") && r;
    return n;
  },
  _getInputVal: function() {
    return _i.convertDigits(this._input().val(), !0);
  },
  _keyboardHandler: function(t) {
    if (this.clearCaretTimeout(), this._lastKey = _i.convertDigits(Rk(t), !0), this._lastKeyName = or(t), !this._shouldHandleKey(t.originalEvent))
      return this.callBase(t);
    var e = this._getInputVal(), i = this._caret(), r;
    this._lastKeyName === Fy ? r = "" : r = t.which === UEe ? _i.getDecimalSeparator() : this._lastKey;
    var n = this._tryParse(e, i, r);
    return this._shouldMoveCaret(e, i) && (this._moveCaret(1), t.originalEvent.preventDefault()), n === void 0 ? this._lastKeyName !== Fy && t.originalEvent.preventDefault() : this._parsedValue = n, this.callBase(t);
  },
  _keyPressHandler: function(t) {
    this._useMaskBehavior() || this.callBase(t);
  },
  _removeHandler: function(t) {
    var e = this._caret(), i = this._getInputVal(), r = e.start, n = e.end;
    this._lastKey = Rk(t), this._lastKeyName = or(t);
    var a = this._isDeleteKey(this._lastKeyName), o = !a;
    if (r === n) {
      var u = r, c = o && u > 0 || a && u < i.length;
      if (c)
        a && n++, o && r--;
      else {
        t.preventDefault();
        return;
      }
    }
    var p = i.slice(r, n);
    if (this._isStub(p)) {
      if (this._moveCaret(a ? 1 : -1), this._parsedValue < 0 || 1 / this._parsedValue === -1 / 0) {
        this._revertSign(t), this._setTextByParsedValue();
        var v = this.option("valueChangeEvent").split(" ").includes("input");
        v && k.trigger(this._input(), "input");
      }
      t.preventDefault();
      return;
    }
    var _ = _i.getDecimalSeparator();
    if (p === _) {
      var y = i.indexOf(_);
      this._isNonStubAfter(y + 1) && (this._moveCaret(a ? 1 : -1), t.preventDefault());
      return;
    }
    if (n - r < i.length) {
      var b = this._replaceSelectedText(i, {
        start: r,
        end: n
      }, ""), I = b.search(/[0-9]/) < 0;
      if (I && this._isValueInRange(0)) {
        this._parsedValue = this._parsedValue < 0 || 1 / this._parsedValue === -1 / 0 ? -0 : 0;
        return;
      }
    }
    var A = this._tryParse(i, {
      start: r,
      end: n
    }, "");
    A === void 0 ? t.preventDefault() : this._parsedValue = A;
  },
  _isPercentFormat: function() {
    var t = this._getFormatPattern(), e = t.replace(/'[^']+'/g, "");
    return e.indexOf("%") !== -1;
  },
  _parse: function(t, e) {
    var i = this.option("format"), r = Le(i.parser), n = r ? i.parser : _i.parse, a = 0;
    if (!r) {
      var o = Qw(e).index, u = this._getTextSeparatorIndex(t), c = o !== -1 ? o : e.length, p = u !== -1 ? u : t.length;
      p > c && e.indexOf("#") === -1 && (a = p - c);
    }
    return t = t.substr(a), n(t, e);
  },
  _format: function(t, e) {
    var i = this.option("format"), r = (i == null ? void 0 : i.formatter) || i, n = Le(r) ? r : _i.format, a = t === null ? "" : n(t, e);
    return a;
  },
  _getFormatPattern: function() {
    return this._currentFormat || this._updateFormat(), this._currentFormat;
  },
  _updateFormat: function() {
    var t = this.option("format"), e = Le(t == null ? void 0 : t.parser), i = ht(t) && (t.indexOf("0") >= 0 || t.indexOf("#") >= 0), r = t === "exponential" || (t == null ? void 0 : t.type) === "exponential", n = e || i || r;
    this._currentFormat = n ? t : Are((a) => {
      var o = this._format(a, t);
      return _i.convertDigits(o, !0);
    });
  },
  _getFormatForSign: function(t) {
    var e = this._getFormatPattern();
    if (ht(e)) {
      var i = e.split(";"), r = _i.getSign(t, e);
      return i[1] = i[1] || "-" + i[0], r < 0 ? i[1] : i[0];
    } else {
      var n = _i.getSign(t);
      return n < 0 ? "-" : "";
    }
  },
  _removeStubs: function(t, e) {
    var i = this._getFormatForSign(t), r = _i.getThousandsSeparator(), n = this._getStubs(i), a = t;
    if (n.length) {
      var o = n[0], u = new RegExp("(" + Eh(n[1] || "") + ")$", "g"), c = new RegExp("[-" + Eh(e ? "" : r) + "]", "g");
      a = a.replace(o, "").replace(u, "").replace(c, "");
    }
    return a;
  },
  _getStubs: function(t) {
    var e = /[^']([#0.,]+)/g.exec(t), i = e && e[0].trim();
    return t.split(i).map(function(r) {
      return r.replace(/'/g, "");
    });
  },
  _truncateToPrecision: function(t, e) {
    if (R(t)) {
      var i = t.toString(), r = i.indexOf(".");
      if (i && r > -1) {
        var n = parseFloat(i.substr(0, r + e + 1));
        return isNaN(n) ? t : n;
      }
    }
    return t;
  },
  _tryParse: function(t, e, i) {
    var r = e.start !== e.end, n = r && e.start === 0 && e.end === t.length, a = _i.getDecimalSeparator();
    if (n && i === a)
      return 0;
    var o = this._replaceSelectedText(t, e, i), u = this._getFormatPattern(), c = this._getParsedValue(o, u), p = !u.parser && this._getPrecisionLimits(o).max, v = c !== this._parsedValue, _ = i === a && p === 0, y = !r && !v && i !== w4 && this._isStub(i);
    if (!(_ || y) && (this._removeStubs(o) === "" && (c = Math.abs(0 * this._parsedValue)), !isNaN(c))) {
      var b = c === null ? this._parsedValue : c;
      return c = p ? this._truncateToPrecision(b, p) : c, !u.parser && this._isPercentFormat() ? wEe(c, p) : c;
    }
  },
  _getParsedValue: function(t, e) {
    var i = _i.getSign(t, (e == null ? void 0 : e.formatter) || e), r = this._removeStubs(t, !0), n = this._parse(r, e), a = n < 0 ? -1 : 1, o = Di(n) && i !== a ? i * n : n;
    return o;
  },
  _isValueIncomplete: function(t) {
    if (!this._useMaskBehavior())
      return this.callBase(t);
    var e = this._caret(), i = _i.getDecimalSeparator(), r = this._getTextSeparatorIndex(t), n = r >= 0 && r < e.start, a = this._removeStubs(t, !0).split(i);
    if (!n || a.length !== 2)
      return !1;
    var o = a[1].length, u = this._getFormatPattern(), c = !!u.parser, p = !c && this._getPrecisionLimits(this._getFormatPattern(), t), v = c ? !0 : Ud(o, p.min, p.max), _ = a[1].charAt(o - 1) === "0";
    return v && (_ || !o);
  },
  _isValueInRange: function(t) {
    var e = cr(this.option("min"), -1 / 0), i = cr(this.option("max"), 1 / 0);
    return Ud(t, e, i);
  },
  _setInputText: function(t) {
    var e = _i.convertDigits(t, !0), i = IEe(this._getInputVal(), e, this._caret(), this._getFormatPattern());
    this._input().val(t), this._toggleEmptinessEventHandler(), this._formattedValue = t, this._focusOutOccurs || this._caret(i);
  },
  _useMaskBehavior: function() {
    return !!this.option("format") && this.option("useMaskBehavior");
  },
  _renderInputType: function() {
    var t = this.option("mode") === "number", e = Ye.real().deviceType === "desktop";
    this._useMaskBehavior() && t ? this._setInputType(e || this._isSupportInputMode() ? "text" : "tel") : this.callBase();
  },
  _isChar: function(t) {
    return ht(t) && t.length === 1;
  },
  _moveCaret: function(t) {
    if (t) {
      var e = vp(this._caret(), t), i = _h(e, this._getInputVal(), this._getFormatPattern());
      this._caret(i);
    }
  },
  _shouldHandleKey: function(t) {
    var e = or(t), i = Cn(t) || t.altKey || t.shiftKey || !this._isChar(e), r = e === Fy, n = this._useMaskBehavior();
    return n && !i && !r;
  },
  _renderInput: function() {
    this.callBase(), this._renderFormatter();
  },
  _renderFormatter: function() {
    this._clearCache(), this._detachFormatterEvents(), this._useMaskBehavior() && this._attachFormatterEvents();
  },
  _detachFormatterEvents: function() {
    k.off(this._input(), "." + vM);
  },
  _isInputFromPaste: function(t) {
    var e = t.originalEvent && t.originalEvent.inputType;
    return R(e) ? e === "insertFromPaste" : this._isValuePasted;
  },
  _attachFormatterEvents: function() {
    var t = this._input();
    k.on(t, ve(WEe, vM), (function(e) {
      this._formatValue(e), this._isValuePasted = !1;
    }).bind(this)), k.on(t, ve("dxclick", vM), (function() {
      this._caretTimeout || (this._caretTimeout = setTimeout((function() {
        this._caretTimeout = void 0, this._caret(_h(this._caret(), this._getInputVal(), this._getFormatPattern()));
      }).bind(this), T4));
    }).bind(this)), k.on(t, Um, (function() {
      this.clearCaretTimeout();
    }).bind(this));
  },
  clearCaretTimeout: function() {
    clearTimeout(this._caretTimeout), this._caretTimeout = void 0;
  },
  _forceRefreshInputValue: function() {
    if (!this._useMaskBehavior())
      return this.callBase();
  },
  _isNonStubAfter: function(t) {
    var e = this._getInputVal().slice(t);
    return e && !this._isStub(e, !0);
  },
  _isStub: function(t, e) {
    var i = Eh(_i.getDecimalSeparator()), r = "^[^0-9" + i + "]+$", n = new RegExp(r, "g");
    return n.test(t) && (e || this._isChar(t));
  },
  _parseValue: function(t) {
    return this._useMaskBehavior() ? this._parsedValue : this.callBase(t);
  },
  _getPrecisionLimits: function(t) {
    var e = this._getFormatForSign(t), i = Qw(e).index, r = (AP(e, i)[1] || "").replace(/[^#0]/g, ""), n = r.replace(/^(0*)#*/, "$1").length, a = r.length;
    return {
      min: n,
      max: a
    };
  },
  _revertSign: function(t) {
    if (this._useMaskBehavior()) {
      var e = this._caret();
      if (e.start !== e.end)
        if (or(t) === Fy) {
          this._applyRevertedSign(t, e, !0);
          return;
        } else
          this._caret(_h(0, this._getInputVal(), this._getFormatPattern()));
      this._applyRevertedSign(t, e);
    }
  },
  _applyRevertedSign: function(t, e, i) {
    var r = -1 * cr(this._parsedValue, null);
    if ((this._isValueInRange(r) || r === 0) && (this._parsedValue = r, i)) {
      var n = this._getFormatPattern(), a = this._getInputVal();
      this._setTextByParsedValue(), t.preventDefault();
      var o = this._getInputVal(), u = OEe(a, o, n);
      e = vp(e, u);
      var c = _h(e, o, n);
      this._caret(c);
    }
  },
  _removeMinusFromText: function(t, e) {
    var i = this._lastKeyName === Fy && t.charAt(e.start - 1) === w4;
    return i ? this._replaceSelectedText(t, {
      start: e.start - 1,
      end: e.start
    }, "") : t;
  },
  _setTextByParsedValue: function() {
    var t = this._getFormatPattern(), e = this._parseValue(), i = this._format(e, t) || "";
    this._setInputText(i);
  },
  _formatValue: function(t) {
    var e = this._getInputVal(), i = this._caret(), r = this._removeMinusFromText(e, i), n = r !== e;
    if (e = r, !this._isInputFromPaste(t) && this._isValueIncomplete(r)) {
      this._formattedValue = e, n && this._setTextByParsedValue();
      return;
    }
    var a = _i.convertDigits(this._formattedValue, !0) !== e;
    if (a) {
      var o = this._tryParse(e, i, "");
      R(o) && (this._parsedValue = o);
    }
    this._setTextByParsedValue();
  },
  _renderDisplayText: function() {
    this._useMaskBehavior() ? this._toggleEmptinessEventHandler() : this.callBase.apply(this, arguments);
  },
  _renderValue: function() {
    return this._useMaskBehavior() && (this._parsedValue = this.option("value"), this._setTextByParsedValue()), this.callBase();
  },
  _updateParsedValue: function() {
    var t = this._getInputVal();
    this._parsedValue = this._tryParse(t, this._caret());
  },
  _adjustParsedValue: function() {
    if (this._useMaskBehavior()) {
      var t = this._removeStubs(this._getInputVal()), e = t ? this._parseValue() : null;
      if (!Di(e)) {
        this._parsedValue = e;
        return;
      }
      this._parsedValue = ma(e, this.option("min"), this.option("max"));
    }
  },
  _valueChangeEventHandler: function(t) {
    if (!this._useMaskBehavior())
      return this.callBase(t);
    var e = this._caret();
    this._saveValueChangeEvent(t), this._lastKey = null, this._lastKeyName = null, this._updateParsedValue(), this._adjustParsedValue(), this.option("value", this._parsedValue), e && this._caret(e);
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "format":
      case "useMaskBehavior":
        this._renderInputType(), this._updateFormat(), this._renderFormatter(), this._renderValue(), this._refreshValueChangeEvent(), this._refreshEvents();
        break;
      case "min":
      case "max":
        this._adjustParsedValue(), this.callBase(t);
        break;
      default:
        this.callBase(t);
    }
  },
  _clearCache: function() {
    delete this._formattedValue, delete this._lastKey, delete this._lastKeyName, delete this._parsedValue, delete this._focusOutOccurs, clearTimeout(this._caretTimeout), delete this._caretTimeout;
  },
  _clean: function() {
    this._clearCache(), this.callBase();
  }
});
ti("dxNumberBox", WT);
var GEe = "dx-radiobutton", I4 = "dx-radiobutton-icon", KEe = "dx-radiobutton-icon-dot", jEe = "dx-radiobutton-checked", YEe = "dx-radiobutton-icon-checked", LX = Fl.inherit({
  _supportedKeys: function() {
    return P(this.callBase(), {
      space: function(t) {
        t.preventDefault(), this._clickAction({
          event: t
        });
      }
    });
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      hoverStateEnabled: !0,
      activeStateEnabled: !0,
      value: !1
    });
  },
  _canValueBeChangedByClick: function() {
    return !0;
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: function() {
        return Ye.real().deviceType === "desktop" && !Ye.isSimulator();
      },
      options: {
        focusStateEnabled: !0
      }
    }]);
  },
  _init: function() {
    this.callBase(), this.$element().addClass(GEe);
  },
  _initMarkup: function() {
    this.callBase(), this._renderIcon(), this._renderCheckedState(this.option("value")), this._renderClick(), this.setAria("role", "radio");
  },
  _renderIcon: function() {
    this._$icon = E("<div>").addClass(I4), E("<div>").addClass(KEe).appendTo(this._$icon), this.$element().append(this._$icon);
  },
  _renderCheckedState: function(t) {
    this.$element().toggleClass(jEe, t).find("." + I4).toggleClass(YEe, t), this.setAria("checked", t);
  },
  _renderClick: function() {
    var t = ve(di, this.NAME);
    this._clickAction = this._createAction((function(e) {
      this._clickHandler(e.event);
    }).bind(this)), k.off(this.$element(), t), k.on(this.$element(), t, (function(e) {
      this._clickAction({
        event: e
      });
    }).bind(this));
  },
  _clickHandler: function(t) {
    this._saveValueChangeEvent(t), this.option("value", !0);
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "value":
        this._renderCheckedState(t.value), this.callBase(t);
        break;
      default:
        this.callBase(t);
    }
  }
});
ti("dxRadioButton", LX);
var MX = {};
function qEe(t, e, i) {
  var r = MX, n = {};
  n[t] = r[t] ? r[t] : {}, n[t][e] = i, P(r, n);
}
var zB = "dxListEditDecorator", XEe = ve(OI, zB), QEe = ve(RI, zB), ZEe = ve(wS, zB), JEe = wi.inherit({
  ctor: function(t) {
    this._list = t, this._init();
  },
  _init: ee,
  _shouldHandleSwipe: !1,
  _attachSwipeEvent: function(t) {
    var e = {
      itemSizeFunc: (function() {
        return this._clearSwipeCache && (this._itemWidthCache = mt(this._list.$element()), this._clearSwipeCache = !1), this._itemWidthCache;
      }).bind(this)
    };
    k.on(t.$itemElement, XEe, e, this._itemSwipeStartHandler.bind(this)), k.on(t.$itemElement, QEe, this._itemSwipeUpdateHandler.bind(this)), k.on(t.$itemElement, ZEe, this._itemSwipeEndHandler.bind(this));
  },
  _itemSwipeStartHandler: function(t) {
    var e = E(t.currentTarget);
    if (e.is(".dx-state-disabled, .dx-state-disabled *")) {
      t.cancel = !0;
      return;
    }
    clearTimeout(this._list._inkRippleTimer), this._swipeStartHandler(e, t);
  },
  _itemSwipeUpdateHandler: function(t) {
    var e = E(t.currentTarget);
    this._swipeUpdateHandler(e, t);
  },
  _itemSwipeEndHandler: function(t) {
    var e = E(t.currentTarget);
    this._swipeEndHandler(e, t), this._clearSwipeCache = !0;
  },
  beforeBag: ee,
  afterBag: ee,
  _commonOptions: function() {
    return {
      activeStateEnabled: this._list.option("activeStateEnabled"),
      hoverStateEnabled: this._list.option("hoverStateEnabled"),
      focusStateEnabled: this._list.option("focusStateEnabled")
    };
  },
  modifyElement: function(t) {
    this._shouldHandleSwipe && (this._attachSwipeEvent(t), this._clearSwipeCache = !0);
  },
  afterRender: ee,
  handleClick: ee,
  handleKeyboardEvents: ee,
  handleEnterPressing: ee,
  handleContextMenu: ee,
  _swipeStartHandler: ee,
  _swipeUpdateHandler: ee,
  _swipeEndHandler: ee,
  visibilityChange: ee,
  getExcludedSelectors: ee,
  dispose: ee
}), D4 = "dx-list-select-decorator-enabled", ebe = "dx-list-select-all", tbe = "dx-list-select-all-checkbox", ibe = "dx-list-select-all-label", rbe = "dx-list-select-checkbox-container", nbe = "dx-list-select-checkbox", abe = "dx-list-select-radiobutton-container", obe = "dx-list-select-radiobutton", sbe = "dx-state-focused", A4 = ve(di, "dxListEditDecorator");
qEe("selection", "default", JEe.inherit({
  _init: function() {
    this.callBase.apply(this, arguments);
    var t = this._list.option("selectionMode");
    this._singleStrategy = t === "single", this._containerClass = this._singleStrategy ? abe : rbe, this._controlClass = this._singleStrategy ? obe : nbe, this._controlWidget = this._singleStrategy ? LX : kp, this._list.$element().addClass(D4);
  },
  beforeBag: function(t) {
    var e = t.$itemElement, i = t.$container.addClass(this._containerClass), r = E("<div>").addClass(this._controlClass).appendTo(i);
    new this._controlWidget(r, P(this._commonOptions(), {
      value: this._isSelected(e),
      elementAttr: {
        "aria-label": "Check State"
      },
      focusStateEnabled: !1,
      hoverStateEnabled: !1,
      onValueChanged: (function(n) {
        n.event && this._list._saveSelectionChangeEvent(n.event), this._processCheckedState(e, n.value), n.event && n.event.stopPropagation();
      }).bind(this)
    }));
  },
  modifyElement: function(t) {
    this.callBase.apply(this, arguments);
    var e = t.$itemElement, i = this._controlWidget.getInstance(e.find("." + this._controlClass));
    k.on(e, "stateChanged", (function(r, n) {
      i.option("value", n);
    }).bind(this));
  },
  _updateSelectAllState: function() {
    this._$selectAll && this._selectAllCheckBox.option("value", this._list.isSelectAll());
  },
  afterRender: function() {
    this._list.option("selectionMode") === "all" && (this._$selectAll ? this._updateSelectAllState() : this._renderSelectAll());
  },
  handleKeyboardEvents: function(t, e) {
    var i = !e, r = this._list, n = this._$selectAll, a = r._getLastItemIndex(), o = e && t === 0 || i && t === a, u = !!n;
    return u && o ? (r.option("focusedElement", n), r.scrollToItem(r.option("focusedElement")), !0) : !1;
  },
  handleEnterPressing: function(t) {
    if (this._$selectAll && this._$selectAll.hasClass(sbe))
      return t.target = this._$selectAll.get(0), this._list._saveSelectionChangeEvent(t), this._selectAllCheckBox.option("value", !this._selectAllCheckBox.option("value")), !0;
  },
  _renderSelectAll: function() {
    var t = this._$selectAll = E("<div>").addClass(ebe), e = this._list, i = e._supportedKeys().downArrow.bind(e);
    this._selectAllCheckBox = e._createComponent(E("<div>").addClass(tbe).appendTo(t), kp, {
      elementAttr: {
        "aria-label": "Select All"
      },
      focusStateEnabled: !1,
      hoverStateEnabled: !1
    }), this._selectAllCheckBox.registerKeyHandler("downArrow", i), E("<div>").addClass(ibe).text(this._list.option("selectAllText")).appendTo(t), this._list.itemsContainer().prepend(t), this._updateSelectAllState(), this._attachSelectAllHandler();
  },
  _attachSelectAllHandler: function() {
    this._selectAllCheckBox.option("onValueChanged", this._selectAllHandler.bind(this)), k.off(this._$selectAll, A4), k.on(this._$selectAll, A4, this._selectAllClickHandler.bind(this));
  },
  _selectAllHandler: function(t) {
    t.event && t.event.stopPropagation();
    var e = this._selectAllCheckBox.option("value");
    t.event && this._list._saveSelectionChangeEvent(t.event), e === !0 ? this._selectAllItems() : e === !1 && this._unselectAllItems(), this._list._createActionByOption("onSelectAllValueChanged")({
      value: e
    });
  },
  _checkSelectAllCapability: function() {
    var t = this._list, e = t._dataController;
    return t.option("selectAllMode") === "allPages" && t.option("grouped") && !e.group() ? (Yt.log("W1010"), !1) : !0;
  },
  _selectAllItems: function() {
    this._checkSelectAllCapability() && this._list._selection.selectAll(this._list.option("selectAllMode") === "page");
  },
  _unselectAllItems: function() {
    this._checkSelectAllCapability() && this._list._selection.deselectAll(this._list.option("selectAllMode") === "page");
  },
  _selectAllClickHandler: function(t) {
    this._list._saveSelectionChangeEvent(t), this._selectAllCheckBox.option("value", !this._selectAllCheckBox.option("value"));
  },
  _isSelected: function(t) {
    return this._list.isItemSelected(t);
  },
  _processCheckedState: function(t, e) {
    e ? this._list.selectItem(t) : this._list.unselectItem(t);
  },
  dispose: function() {
    this._disposeSelectAll(), this._list.$element().removeClass(D4), this.callBase.apply(this, arguments);
  },
  _disposeSelectAll: function() {
    this._$selectAll && (this._$selectAll.remove(), this._$selectAll = null);
  }
}));
var lbe = "dx-dropdowneditor-button", ube = "dx-dropdowneditor-button-visible", dbe = "dxDropDownEditor-selectLabel";
let cbe = class extends AI {
  constructor(e, i, r) {
    super(e, i, r), this.currentTemplate = null;
  }
  _attachEvents(e) {
    var {
      editor: i
    } = this;
    e.option("onClick", (r) => {
      var n;
      if ((n = i._shouldCallOpenHandler) !== null && n !== void 0 && n.call(i)) {
        i._openHandler(r);
        return;
      }
      !i.option("openOnFieldClick") && i._openHandler(r);
    }), k.on(e.$element(), "mousedown", (r) => {
      i.$element().is(".dx-state-focused") && r.preventDefault();
    });
  }
  _create() {
    var {
      editor: e
    } = this, i = E("<div>"), r = this._getOptions();
    this._addToContainer(i);
    var n = e._createComponent(i, yn, P({}, r, {
      elementAttr: {
        "aria-label": X.format(dbe)
      }
    }));
    return this._legacyRender(e.$element(), i, r.visible), {
      $element: i,
      instance: n
    };
  }
  _getOptions() {
    var {
      editor: e
    } = this, i = this._isVisible(), r = e.option("readOnly"), n = {
      focusStateEnabled: !1,
      hoverStateEnabled: !1,
      activeStateEnabled: !1,
      useInkRipple: !1,
      disabled: r,
      visible: i
    };
    return this._addTemplate(n), n;
  }
  _isVisible() {
    var {
      editor: e
    } = this;
    return super._isVisible() && e.option("showDropDownButton");
  }
  _legacyRender(e, i, r) {
    e.toggleClass(ube, r), i && i.removeClass("dx-button").removeClass("dx-button-mode-contained").addClass(lbe);
  }
  _isSameTemplate() {
    return this.editor.option("dropDownButtonTemplate") === this.currentTemplate;
  }
  _addTemplate(e) {
    this._isSameTemplate() || (e.template = this.editor._getTemplateByOption("dropDownButtonTemplate"), this.currentTemplate = this.editor.option("dropDownButtonTemplate"));
  }
  update() {
    var e = super.update();
    if (e) {
      var {
        editor: i,
        instance: r
      } = this, n = i.$element(), a = this._getOptions();
      r == null || r.option(a), this._legacyRender(n, r == null ? void 0 : r.$element(), a.visible);
    }
  }
};
var UT = function(t) {
  if (wt())
    return oi(t);
}, WB = function(t) {
  return t === null && (t = void 0), typeof t == "function" && (t = t()), t;
}, hbe = "dx-dropdowneditor", O4 = "dx-dropdowneditor-input-wrapper", fbe = "dx-dropdowneditor-icon", vw = "dx-dropdowneditor-overlay", pbe = "dx-dropdowneditor-overlay-flipped", vbe = "dx-dropdowneditor-active", gbe = "dx-dropdowneditor-field-clickable", mbe = "dx-dropdowneditor-field-template-wrapper", R4 = Ye.current().platform === "ios", UB = ES.inherit({
  _supportedKeys: function() {
    return P({}, this.callBase(), {
      tab: function(t) {
        if (this.option("opened")) {
          if (!this._popup.getFocusableElements().length) {
            this.close();
            return;
          }
          var e = t.shiftKey ? this._getLastPopupElement() : this._getFirstPopupElement();
          e && (k.trigger(e, "focus"), e.select()), t.preventDefault();
        }
      },
      escape: function(t) {
        return this.option("opened") && t.preventDefault(), this.close(), !0;
      },
      upArrow: function(t) {
        return !Cn(t) && (t.preventDefault(), t.stopPropagation(), t.altKey) ? (this.close(), !1) : !0;
      },
      downArrow: function(t) {
        return !Cn(t) && (t.preventDefault(), t.stopPropagation(), t.altKey) ? (this._validatedOpening(), !1) : !0;
      },
      enter: function(t) {
        return this.option("opened") && (t.preventDefault(), this._valueChangeEventHandler(t)), !0;
      }
    });
  },
  _getDefaultButtons: function() {
    return this.callBase().concat([{
      name: "dropDown",
      Ctor: cbe
    }]);
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      value: null,
      onOpened: null,
      onClosed: null,
      opened: !1,
      acceptCustomValue: !0,
      applyValueMode: "instantly",
      deferRendering: !0,
      activeStateEnabled: !0,
      dropDownButtonTemplate: "dropDownButton",
      fieldTemplate: null,
      openOnFieldClick: !1,
      showDropDownButton: !0,
      buttons: void 0,
      dropDownOptions: {
        showTitle: !1
      },
      popupPosition: this._getDefaultPopupPosition(),
      onPopupInitialized: null,
      applyButtonText: X.format("OK"),
      cancelButtonText: X.format("Cancel"),
      buttonsLocation: "default",
      useHiddenSubmitElement: !1,
      validationMessagePosition: "auto"
    });
  },
  _useTemplates: function() {
    return !0;
  },
  _getDefaultPopupPosition: function(t) {
    var e = Nh(t);
    return {
      offset: {
        h: 0,
        v: -1
      },
      my: e + " top",
      at: e + " bottom",
      collision: "flip flip"
    };
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: function(t) {
        var e = t.platform === "generic";
        return e;
      },
      options: {
        popupPosition: {
          offset: {
            v: 0
          }
        }
      }
    }]);
  },
  _inputWrapper: function() {
    return this.$element().find("." + O4).first();
  },
  _init: function() {
    this.callBase(), this._initVisibilityActions(), this._initPopupInitializedAction(), this._updatePopupPosition(this.option("rtlEnabled")), this._options.cache("dropDownOptions", this.option("dropDownOptions"));
  },
  _updatePopupPosition: function(t) {
    var {
      my: e,
      at: i
    } = this._getDefaultPopupPosition(t), r = this.option("popupPosition");
    this.option("popupPosition", P({}, r, {
      my: e,
      at: i
    }));
  },
  _initVisibilityActions: function() {
    this._openAction = this._createActionByOption("onOpened", {
      excludeValidators: ["disabled", "readOnly"]
    }), this._closeAction = this._createActionByOption("onClosed", {
      excludeValidators: ["disabled", "readOnly"]
    });
  },
  _initPopupInitializedAction: function() {
    this._popupInitializedAction = this._createActionByOption("onPopupInitialized", {
      excludeValidators: ["disabled", "readOnly"]
    });
  },
  _initMarkup: function() {
    this._renderSubmitElement(), this.callBase(), this.$element().addClass(hbe), this.setAria("role", "combobox");
  },
  _render: function() {
    this.callBase(), this._renderOpenHandler(), this._attachFocusOutHandler(), this._renderOpenedState();
  },
  _renderContentImpl: function() {
    this.option("deferRendering") || this._createPopup();
  },
  _renderInput: function() {
    this.callBase(), this._wrapInput(), this._setDefaultAria();
  },
  _wrapInput: function() {
    this._$container = this.$element().wrapInner(E("<div>").addClass(O4)).children().eq(0);
  },
  _setDefaultAria: function() {
    this.setAria({
      haspopup: "true",
      autocomplete: "list"
    });
  },
  _readOnlyPropValue: function() {
    return !this._isEditable() || this.callBase();
  },
  _cleanFocusState: function() {
    this.callBase(), this.option("fieldTemplate") && this._detachFocusEvents();
  },
  _getFieldTemplate: function() {
    return this.option("fieldTemplate") && this._getTemplateByOption("fieldTemplate");
  },
  _renderMask: function() {
    this.option("fieldTemplate") || this.callBase();
  },
  _renderField: function() {
    var t = this._getFieldTemplate();
    t && this._renderTemplatedField(t, this._fieldRenderData());
  },
  _renderPlaceholder: function() {
    var t = !!this._getFieldTemplate();
    t || this.callBase();
  },
  _renderValue: function() {
    this.option("useHiddenSubmitElement") && this._setSubmitValue();
    var t = this.callBase();
    t.always(this._renderField.bind(this));
  },
  _renderTemplatedField: function(t, e) {
    var i = Ah(this._input()), r = this._$container;
    this._detachKeyboardEvents(), this._refreshButtonsContainer(), this._detachWrapperContent(), this._detachFocusEvents(), r.empty();
    var n = E("<div>").addClass(mbe).appendTo(r);
    t.render({
      model: e,
      container: ot(n),
      onRendered: () => {
        var a = !!this.$element().find(n).length;
        if (a) {
          var o = this._input();
          if (!o.length)
            throw Yt.Error("E1010");
          this._integrateInput(), i && k.trigger(o, "focus");
        }
      }
    }), this._attachWrapperContent(r);
  },
  _detachWrapperContent() {
    var t, e, i, r = this.option("useHiddenSubmitElement");
    r && ((t = this._$submitElement) === null || t === void 0 || t.detach());
    var n = (e = this._$beforeButtonsContainer) === null || e === void 0 ? void 0 : e[0].parentNode, a = (i = this._$afterButtonsContainer) === null || i === void 0 ? void 0 : i[0].parentNode;
    n == null || n.removeChild(this._$beforeButtonsContainer[0]), a == null || a.removeChild(this._$afterButtonsContainer[0]);
  },
  _attachWrapperContent(t) {
    var e, i = this.option("useHiddenSubmitElement");
    t.prepend(this._$beforeButtonsContainer), i && ((e = this._$submitElement) === null || e === void 0 || e.appendTo(t)), t.append(this._$afterButtonsContainer);
  },
  _refreshButtonsContainer() {
    this._$buttonsContainer = this.$element().children().eq(0);
  },
  _integrateInput: function() {
    this._renderFocusState(), this._refreshValueChangeEvent(), this._refreshEvents(), this._refreshEmptinessEvent();
  },
  _refreshEmptinessEvent: function() {
    k.off(this._input(), "input blur", this._toggleEmptinessEventHandler), this._renderEmptinessEvent();
  },
  _fieldRenderData: function() {
    return this.option("value");
  },
  _initTemplates: function() {
    this._templateManager.addDefaultTemplates({
      dropDownButton: new Lm(function(t) {
        var e = E("<div>").addClass(fbe);
        E(t.container).append(e);
      })
    }), this.callBase();
  },
  _renderOpenHandler: function() {
    var t = this._inputWrapper(), e = ve(di, this.NAME), i = this.option("openOnFieldClick");
    k.off(t, e), k.on(t, e, this._getInputClickHandler(i)), this.$element().toggleClass(gbe, i), i && (this._openOnFieldClickAction = this._createAction(this._openHandler.bind(this)));
  },
  _attachFocusOutHandler: function() {
    R4 && (this._detachFocusOutEvents(), k.on(this._inputWrapper(), ve("focusout", this.NAME), (t) => {
      var e = t.relatedTarget;
      if (e && this.option("opened")) {
        var i = this._isTargetOutOfComponent(e);
        i && this.close();
      }
    }));
  },
  _isTargetOutOfComponent: function(t) {
    var e = this.content ? E(this.content()).closest(".".concat(vw)) : this._$popup, i = E(t).closest(".".concat(vw), e).length === 0;
    return i;
  },
  _detachFocusOutEvents: function() {
    R4 && k.off(this._inputWrapper(), ve("focusout", this.NAME));
  },
  _getInputClickHandler: function(t) {
    return t ? (e) => {
      this._executeOpenAction(e);
    } : (e) => {
      this._focusInput();
    };
  },
  _openHandler: function() {
    this._toggleOpenState();
  },
  _executeOpenAction: function(t) {
    this._openOnFieldClickAction({
      event: t
    });
  },
  _keyboardEventBindingTarget: function() {
    return this._input();
  },
  _focusInput: function() {
    return this.option("disabled") ? !1 : (this.option("focusStateEnabled") && !Ah(this._input()) && (this._resetCaretPosition(), k.trigger(this._input(), "focus")), !0);
  },
  _resetCaretPosition: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, e = this._input().get(0);
    if (e) {
      var {
        value: i
      } = e, r = R(i) && (t || this._isEditable()) ? i.length : 0;
      this._caret({
        start: r,
        end: r
      }, !0);
    }
  },
  _isEditable: function() {
    return this.option("acceptCustomValue");
  },
  _toggleOpenState: function(t) {
    this._focusInput() && (this.option("readOnly") || (t = arguments.length ? t : !this.option("opened"), this.option("opened", t)));
  },
  _getControlsAria() {
    return this._popup && this._popupContentId;
  },
  _renderOpenedState: function() {
    var t = this.option("opened");
    t && this._createPopup(), this.$element().toggleClass(vbe, t), this._setPopupOption("visible", t);
    var e = {
      expanded: t,
      controls: this._getControlsAria()
    };
    this.setAria(e), this.setAria("owns", t ? this._popupContentId : void 0, this.$element());
  },
  _createPopup: function() {
    this._$popup || (this._$popup = E("<div>").addClass(vw).appendTo(this.$element()), this._renderPopup(), this._renderPopupContent());
  },
  _renderPopupContent: ee,
  _renderPopup: function() {
    var t = P(this._popupConfig(), this._options.cache("dropDownOptions"));
    delete t.closeOnOutsideClick, t.elementAttr && !Object.keys(t.elementAttr).length && delete t.elementAttr, this._popup = this._createComponent(this._$popup, Hu, t), this._popup.on({
      showing: this._popupShowingHandler.bind(this),
      shown: this._popupShownHandler.bind(this),
      hiding: this._popupHidingHandler.bind(this),
      hidden: this._popupHiddenHandler.bind(this),
      contentReady: this._contentReadyHandler.bind(this)
    }), this._attachPopupKeyHandler(), this._contentReadyHandler(), this._setPopupContentId(this._popup.$content()), this._bindInnerWidgetOptions(this._popup, "dropDownOptions");
  },
  _attachPopupKeyHandler() {
    k.on(this._popup.$overlayContent(), ve("keydown", this.NAME), (t) => this._popupKeyHandler(t));
  },
  _popupKeyHandler(t) {
    switch (or(t)) {
      case "tab":
        this._popupTabHandler(t);
        break;
      case "escape":
        this._popupEscHandler(t);
    }
  },
  _popupTabHandler(t) {
    var e = E(t.target), i = t.shiftKey && e.is(this._getFirstPopupElement()), r = !t.shiftKey && e.is(this._getLastPopupElement());
    (r || i) && (k.trigger(this.field(), "focus"), t.preventDefault());
  },
  _popupEscHandler() {
    k.trigger(this._input(), "focus"), this.close();
  },
  _setPopupContentId(t) {
    this._popupContentId = "dx-" + new yr(), this.setAria("id", this._popupContentId, t);
  },
  _contentReadyHandler: ee,
  _popupConfig: function() {
    return {
      onInitialized: this._getPopupInitializedHandler(),
      position: P(this.option("popupPosition"), {
        of: this.$element()
      }),
      showTitle: this.option("dropDownOptions.showTitle"),
      _ignoreFunctionValueDeprecation: !0,
      width: () => UT(this.$element()),
      height: "auto",
      shading: !1,
      hideOnParentScroll: !0,
      hideOnOutsideClick: (t) => this._closeOutsideDropDownHandler(t),
      animation: {
        show: {
          type: "fade",
          duration: 0,
          from: 0,
          to: 1
        },
        hide: {
          type: "fade",
          duration: 400,
          from: 1,
          to: 0
        }
      },
      deferRendering: !1,
      focusStateEnabled: !1,
      showCloseButton: !1,
      dragEnabled: !1,
      toolbarItems: this._getPopupToolbarItems(),
      onPositioned: this._popupPositionedHandler.bind(this),
      fullScreen: !1,
      contentTemplate: null,
      _hideOnParentScrollTarget: this.$element(),
      _wrapperClassExternal: vw,
      _ignorePreventScrollEventsDeprecation: !0
    };
  },
  _popupInitializedHandler: ee,
  _getPopupInitializedHandler: function() {
    var t = this.option("onPopupInitialized");
    return (e) => {
      this._popupInitializedHandler(e), t && this._popupInitializedAction({
        popup: e.component
      });
    };
  },
  _dimensionChanged: function() {
    if (wt() && !this.$element().is(":visible")) {
      this.close();
      return;
    }
    this._updatePopupWidth();
  },
  _updatePopupWidth: function() {
    var t = WB(this.option("dropDownOptions.width"));
    t === void 0 && this._setPopupOption("width", () => UT(this.$element()));
  },
  _popupPositionedHandler: function(t) {
    var e, i, {
      labelMode: r,
      stylingMode: n
    } = this.option();
    if (this._popup) {
      var a = this._popup.$overlayContent(), o = (e = t.position) === null || e === void 0 || (i = e.v) === null || i === void 0 ? void 0 : i.flip, u = r !== "hidden" && r !== "outside" && n === "outlined";
      if (t.position && a.toggleClass(pbe, o), o && u && this._label.isVisible()) {
        var c = this._label.$element();
        Nn(a, {
          top: zs(a).top - parseInt(c.css("fontSize"))
        });
      }
    }
  },
  _popupShowingHandler: ee,
  _popupHidingHandler: function() {
    this.option("opened", !1);
  },
  _popupShownHandler: function() {
    var t;
    this._openAction(), (t = this._validationMessage) === null || t === void 0 || t.option("positionSide", this._getValidationMessagePositionSide());
  },
  _popupHiddenHandler: function() {
    var t;
    this._closeAction(), (t = this._validationMessage) === null || t === void 0 || t.option("positionSide", this._getValidationMessagePositionSide());
  },
  _getValidationMessagePositionSide: function() {
    var t = this.option("validationMessagePosition");
    if (t !== "auto")
      return t;
    var e = "bottom";
    if (this._popup && this._popup.option("visible")) {
      var {
        top: i
      } = kl.setup(this.$element()), {
        top: r
      } = kl.setup(this._popup.$content());
      e = i + this.option("popupPosition").offset.v > r ? "bottom" : "top";
    }
    return e;
  },
  _closeOutsideDropDownHandler: function(t) {
    var {
      target: e
    } = t, i = E(e), r = this.getButton("dropDown"), n = r && r.$element(), a = !!i.closest(this.$element()).length, o = !!i.closest(n).length, u = !a && !o;
    return u;
  },
  _clean: function() {
    delete this._openOnFieldClickAction, this._$popup && (this._$popup.remove(), delete this._$popup, delete this._popup), this.callBase();
  },
  _setPopupOption: function(t, e) {
    this._setWidgetOption("_popup", arguments);
  },
  _validatedOpening: function() {
    this.option("readOnly") || this._toggleOpenState(!0);
  },
  _getPopupToolbarItems: function() {
    return this.option("applyValueMode") === "useButtons" ? this._popupToolbarItemsConfig() : [];
  },
  _getFirstPopupElement: function() {
    return E(this._popup.getFocusableElements()).first();
  },
  _getLastPopupElement: function() {
    return E(this._popup.getFocusableElements()).last();
  },
  _popupToolbarItemsConfig: function() {
    var t = [{
      shortcut: "done",
      options: {
        onClick: this._applyButtonHandler.bind(this),
        text: this.option("applyButtonText")
      }
    }, {
      shortcut: "cancel",
      options: {
        onClick: this._cancelButtonHandler.bind(this),
        text: this.option("cancelButtonText")
      }
    }];
    return this._applyButtonsLocation(t);
  },
  _applyButtonsLocation: function(t) {
    var e = this.option("buttonsLocation"), i = t;
    if (e !== "default") {
      var r = Nm(e);
      N(i, function(n, a) {
        P(a, {
          toolbar: r[0],
          location: r[1]
        });
      });
    }
    return i;
  },
  _applyButtonHandler: function() {
    this.close(), this.option("focusStateEnabled") && this.focus();
  },
  _cancelButtonHandler: function() {
    this.close(), this.option("focusStateEnabled") && this.focus();
  },
  _popupOptionChanged: function(t) {
    var e = xn.getOptionsFromContainer(t);
    this._setPopupOption(e);
    var i = Object.keys(e);
    (i.indexOf("width") !== -1 || i.indexOf("height") !== -1) && this._dimensionChanged();
  },
  _renderSubmitElement: function() {
    this.option("useHiddenSubmitElement") && (this._$submitElement = E("<input>").attr("type", "hidden").appendTo(this.$element()));
  },
  _setSubmitValue: function() {
    this._getSubmitElement().val(this.option("value"));
  },
  _getSubmitElement: function() {
    return this.option("useHiddenSubmitElement") ? this._$submitElement : this.callBase();
  },
  _dispose: function() {
    this._detachFocusOutEvents(), this.callBase();
  },
  _optionChanged: function(t) {
    var e;
    switch (t.name) {
      case "width":
      case "height":
        this.callBase(t), (e = this._popup) === null || e === void 0 || e.repaint();
        break;
      case "opened":
        this._renderOpenedState();
        break;
      case "onOpened":
      case "onClosed":
        this._initVisibilityActions();
        break;
      case "onPopupInitialized":
        this._initPopupInitializedAction();
        break;
      case "fieldTemplate":
        R(t.value) ? this._renderField() : this._invalidate();
        break;
      case "acceptCustomValue":
      case "openOnFieldClick":
        this._invalidate();
        break;
      case "dropDownButtonTemplate":
      case "showDropDownButton":
        this._updateButtons(["dropDown"]);
        break;
      case "dropDownOptions":
        this._popupOptionChanged(t), this._options.cache("dropDownOptions", this.option("dropDownOptions"));
        break;
      case "popupPosition":
        break;
      case "deferRendering":
        wt() && this._createPopup();
        break;
      case "applyValueMode":
      case "applyButtonText":
      case "cancelButtonText":
      case "buttonsLocation":
        this._setPopupOption("toolbarItems", this._getPopupToolbarItems());
        break;
      case "useHiddenSubmitElement":
        this._$submitElement && (this._$submitElement.remove(), this._$submitElement = void 0), this._renderSubmitElement();
        break;
      case "rtlEnabled":
        this._updatePopupPosition(t.value), this.callBase(t);
        break;
      default:
        this.callBase(t);
    }
  },
  open: function() {
    this.option("opened", !0);
  },
  close: function() {
    this.option("opened", !1);
  },
  field: function() {
    return ot(this._input());
  },
  content: function() {
    return this._popup ? this._popup.content() : null;
  }
});
ti("dxDropDownEditor", UB);
var _be = "dx-list-item", L4 = "dx-list-group", GB = 20, Cbe = (1 << GB) - 1, M4 = function(t) {
  return (t.group << GB) + t.item;
}, Jf = function(t) {
  return {
    group: t >> GB,
    item: t & Cbe
  };
}, ybe = AB.inherit({
  _groupElements: function() {
    return this._collectionWidget._itemContainer().find("." + L4);
  },
  _groupItemElements: function(t) {
    return t.find("." + _be);
  },
  getIndexByItemData: function(t) {
    var e = this._collectionWidget.option("items"), i = !1;
    return t ? (t.items && t.items.length && (t = t.items[0]), N(e, function(r, n) {
      if (!n.items || (N(n.items, function(a, o) {
        return o !== t ? !0 : (i = {
          group: r,
          item: a
        }, !1);
      }), i))
        return !1;
    }), i) : !1;
  },
  getItemDataByIndex: function(t) {
    var e = this._collectionWidget.option("items");
    return Di(t) ? this.itemsGetter()[t] : t && e[t.group] && e[t.group].items[t.item] || null;
  },
  itemsGetter: function() {
    for (var t = [], e = this._collectionWidget.option("items"), i = 0; i < e.length; i++)
      e[i] && e[i].items ? t = t.concat(e[i].items) : t.push(e[i]);
    return t;
  },
  deleteItemAtIndex: function(t) {
    var e = Jf(t), i = this._collectionWidget.option("items")[e.group].items;
    i.splice(e.item, 1);
  },
  getKeysByItems: function(t) {
    var e = [], i;
    for (i = 0; i < t.length; i++)
      t[i] && t[i].items ? e = e.concat(t[i].items) : e.push(t[i]);
    var r = [];
    for (i = 0; i < e.length; i++)
      r.push(this._collectionWidget.keyOf(e[i]));
    return r;
  },
  getIndexByKey: function(t, e) {
    var i = e || this._collectionWidget.option("items"), r = -1, n = this;
    return N(i, function(a, o) {
      if (o.items && (N(o.items, function(u, c) {
        var p = n._collectionWidget.keyOf(c);
        if (n._equalKeys(p, t))
          return r = {
            group: a,
            item: u
          }, !1;
      }), r !== -1))
        return !1;
    }), r;
  },
  _getGroups: function(t) {
    var e = this._collectionWidget._dataController, i = e.group();
    return i ? rc.queryByOptions(lo(t), {
      group: i
    }).toArray() : this._collectionWidget.option("items");
  },
  getItemsByKeys: function(t, e) {
    var i = [], r = this._getGroups(e), n = {}, a = (o) => {
      var u = this.getIndexByKey(o, r), c = u && r[u.group];
      if (c)
        return {
          groupKey: c.key,
          item: c.items[u.item]
        };
    };
    return N(t, function(o, u) {
      var c = a(u);
      if (c) {
        var p = c.groupKey, v = c.item, _ = n[p];
        _ || (_ = {
          key: p,
          items: []
        }, n[p] = _, i.push(_)), _.items.push(v);
      }
    }), i;
  },
  moveItemAtIndexToIndex: function(t, e) {
    var i = this._collectionWidget.option("items"), r = Jf(t), n = Jf(e), a = i[r.group].items, o = i[n.group].items, u = a[r.item];
    a.splice(r.item, 1), o.splice(n.item, 0, u);
  },
  _isItemIndex: function(t) {
    return t && Di(t.group) && Di(t.item);
  },
  _getNormalizedItemIndex: function(t) {
    var e = E(t), i = e.closest("." + L4);
    return i.length ? M4({
      group: this._groupElements().index(i),
      item: this._groupItemElements(i).index(e)
    }) : -1;
  },
  _normalizeItemIndex: function(t) {
    return M4(t);
  },
  _denormalizeItemIndex: function(t) {
    return Jf(t);
  },
  _getItemByNormalizedIndex: function(t) {
    var e = Jf(t), i = this._groupElements().eq(e.group);
    return this._groupItemElements(i).eq(e.item);
  },
  _itemsFromSameParent: function(t, e) {
    return Jf(t).group === Jf(e).group;
  }
}), kX = [], kI = function(t, e, i) {
  kX.push({
    enabled: t,
    decoratorType: e,
    decoratorSubType: i
  });
};
kI(function() {
  return this.option("menuItems").length;
}, function() {
  return "menu";
}, function() {
  return this.option("menuMode");
});
kI(function() {
  return !this.option("menuItems").length && this.option("allowItemDeleting");
}, function() {
  var t = this.option("itemDeleteMode");
  return t === "toggle" || t === "slideButton" || t === "swipe" || t === "static" ? "delete" : "menu";
}, function() {
  var t = this.option("itemDeleteMode");
  return t === "slideItem" && (t = "slide"), t;
});
kI(function() {
  return this.option("selectionMode") !== "none" && this.option("showSelectionControls");
}, function() {
  return "selection";
}, function() {
  return "default";
});
kI(function() {
  return this.option("itemDragging.allowReordering") || this.option("itemDragging.allowDropInsideItem") || this.option("itemDragging.group");
}, function() {
  return "reorder";
}, function() {
  return "default";
});
var xbe = "dx-list-item-before-bag", Sbe = "dx-list-item-after-bag", Ebe = "beforeBag", bbe = "afterBag", wbe = "modifyElement", Tbe = "afterRender", Ibe = "getExcludedSelectors", Dbe = wi.inherit({
  ctor: function(t) {
    this._list = t, this._fetchRequiredDecorators();
  },
  dispose: function() {
    this._decorators && this._decorators.length && N(this._decorators, function(t, e) {
      e.dispose();
    });
  },
  _fetchRequiredDecorators: function() {
    this._decorators = [], N(kX, (function(t, e) {
      var i = e.enabled.call(this._list);
      if (i) {
        var r = e.decoratorType.call(this._list), n = e.decoratorSubType.call(this._list), a = this._createDecorator(r, n);
        this._decorators.push(a);
      }
    }).bind(this));
  },
  _createDecorator: function(t, e) {
    var i = this._findDecorator(t, e);
    return new i(this._list);
  },
  _findDecorator: function(t, e) {
    var i, r = (i = MX[t]) === null || i === void 0 ? void 0 : i[e];
    if (!r)
      throw Yt.Error("E1012", t, e);
    return r;
  },
  modifyItemElement: function(t) {
    var e = E(t.itemElement), i = {
      $itemElement: e
    };
    this._prependBeforeBags(e, i), this._appendAfterBags(e, i), this._applyDecorators(wbe, i);
  },
  afterItemsRendered: function() {
    this._applyDecorators(Tbe);
  },
  _prependBeforeBags: function(t, e) {
    var i = this._collectDecoratorsMarkup(Ebe, e, xbe);
    t.prepend(i);
  },
  _appendAfterBags: function(t, e) {
    var i = this._collectDecoratorsMarkup(bbe, e, Sbe);
    t.append(i);
  },
  _collectDecoratorsMarkup: function(t, e, i) {
    var r = E("<div>");
    return N(this._decorators, function() {
      var n = E("<div>").addClass(i);
      this[t](P({
        $container: n
      }, e)), n.children().length && r.append(n);
    }), r.children();
  },
  _applyDecorators: function(t, e) {
    N(this._decorators, function() {
      this[t](e);
    });
  },
  _handlerExists: function(t) {
    if (!this._decorators)
      return !1;
    for (var e = this._decorators, i = e.length, r = 0; r < i; r++)
      if (e[r][t] !== ee)
        return !0;
    return !1;
  },
  _eventHandler: function(t, e, i) {
    if (!this._decorators)
      return !1;
    for (var r = !1, n = this._decorators, a = n.length, o = 0; o < a && (r = n[o][t](e, i), !r); o++)
      ;
    return r;
  },
  handleClick: function(t, e) {
    return this._eventHandler("handleClick", t, e);
  },
  handleKeyboardEvents: function(t, e) {
    return this._eventHandler("handleKeyboardEvents", t, e);
  },
  handleEnterPressing: function(t) {
    return this._eventHandler("handleEnterPressing", t);
  },
  contextMenuHandlerExists: function() {
    return this._handlerExists("handleContextMenu");
  },
  handleContextMenu: function(t, e) {
    return this._eventHandler("handleContextMenu", t, e);
  },
  getExcludedItemSelectors: function() {
    var t = [];
    return this._applyDecorators(Ibe, t), t.join(",");
  }
}), Abe = "dx-list-item-selected", Obe = "dx-list-item-response-wait", Rbe = FB.inherit({
  _supportedKeys() {
    var t = this, e = this.callBase(), i = (r, n) => {
      var a = this._editStrategy, o = this.option("focusedElement"), u = a.getNormalizedIndex(o), c = u === this._getLastItemIndex();
      if (!(c && this._dataController.isLoading()))
        if (r.shiftKey && t.option("itemDragging.allowReordering")) {
          var p = u + (n ? -1 : 1), v = a.getItemElement(p);
          this.reorderItem(o, v), this.scrollToItem(o), r.preventDefault();
        } else {
          var _ = this._editProvider, y = _.handleKeyboardEvents(u, n);
          y || (n ? e.upArrow(r) : e.downArrow(r));
        }
    };
    return P({}, e, {
      del: (r) => {
        t.option("allowItemDeleting") && (r.preventDefault(), t.deleteItem(t.option("focusedElement")));
      },
      upArrow: (r) => i(r, !0),
      downArrow: (r) => i(r),
      enter: function(r) {
        this._editProvider.handleEnterPressing(r) || e.enter.apply(this, arguments);
      },
      space: function(r) {
        this._editProvider.handleEnterPressing(r) || e.space.apply(this, arguments);
      }
    });
  },
  _updateSelection() {
    this._editProvider.afterItemsRendered(), this.callBase();
  },
  _getLastItemIndex() {
    return this._itemElements().length - 1;
  },
  _refreshItemElements() {
    this.callBase();
    var t = this._editProvider.getExcludedItemSelectors();
    t.length && (this._itemElementsCache = this._itemElementsCache.not(t));
  },
  _isItemStrictEquals: function(t, e) {
    var i = t && t.__dx_key__;
    return i && !this.key() && this._selection.isItemSelected(i) ? !1 : this.callBase(t, e);
  },
  _getDefaultOptions() {
    return P(this.callBase(), {
      showSelectionControls: !1,
      selectionMode: "none",
      selectAllMode: "page",
      onSelectAllValueChanged: null,
      selectAllText: X.format("dxList-selectAll"),
      menuItems: [],
      menuMode: "context",
      allowItemDeleting: !1,
      itemDeleteMode: "static",
      itemDragging: {}
    });
  },
  _defaultOptionsRules() {
    return this.callBase().concat([{
      device: (t) => t.platform === "ios",
      options: {
        menuMode: "slide",
        itemDeleteMode: "slideItem"
      }
    }, {
      device: {
        platform: "android"
      },
      options: {
        itemDeleteMode: "swipe"
      }
    }]);
  },
  _init() {
    this.callBase(), this._initEditProvider();
  },
  _initDataSource() {
    this.callBase(), this._isPageSelectAll() || this._dataSource && this._dataSource.requireTotalCount(!0);
  },
  _isPageSelectAll() {
    return this.option("selectAllMode") === "page";
  },
  _initEditProvider() {
    this._editProvider = new Dbe(this);
  },
  _disposeEditProvider() {
    this._editProvider && this._editProvider.dispose();
  },
  _refreshEditProvider() {
    this._disposeEditProvider(), this._initEditProvider();
  },
  _initEditStrategy() {
    this.option("grouped") ? this._editStrategy = new ybe(this) : this.callBase();
  },
  _initMarkup() {
    this._refreshEditProvider(), this.callBase();
  },
  _renderItems() {
    this.callBase(...arguments), this._editProvider.afterItemsRendered();
  },
  _selectedItemClass: () => Abe,
  _itemResponseWaitClass: () => Obe,
  _itemClickHandler(t) {
    var e = E(t.currentTarget);
    if (!e.is(".dx-state-disabled, .dx-state-disabled *")) {
      var i = this._editProvider.handleClick(e, t);
      i || (this._saveSelectionChangeEvent(t), this.callBase(...arguments));
    }
  },
  _shouldFireContextMenuEvent() {
    return this.callBase(...arguments) || this._editProvider.contextMenuHandlerExists();
  },
  _itemHoldHandler(t) {
    var e = E(t.currentTarget);
    if (!e.is(".dx-state-disabled, .dx-state-disabled *")) {
      var i = nS(t) && this._editProvider.handleContextMenu(e, t);
      if (i) {
        t.handledByEditProvider = !0;
        return;
      }
      this.callBase(...arguments);
    }
  },
  _getItemContainer: function(t) {
    if (this.option("grouped")) {
      var e, i = (e = this._editStrategy.getIndexByItemData(t)) === null || e === void 0 ? void 0 : e.group;
      return this._getGroupContainerByIndex(i);
    } else
      return this.callBase(t);
  },
  _itemContextMenuHandler(t) {
    var e = E(t.currentTarget);
    if (!e.is(".dx-state-disabled, .dx-state-disabled *")) {
      var i = !t.handledByEditProvider && this._editProvider.handleContextMenu(e, t);
      if (i) {
        t.preventDefault();
        return;
      }
      this.callBase(...arguments);
    }
  },
  _postprocessRenderItem(t) {
    this.callBase(...arguments), this._editProvider.modifyItemElement(t);
  },
  _clean() {
    this._disposeEditProvider(), this.callBase();
  },
  focusListItem(t) {
    var e = this._editStrategy.getItemElement(t);
    this.option("focusedElement", e), this.focus(), this.scrollToItem(this.option("focusedElement"));
  },
  _optionChanged(t) {
    switch (t.name) {
      case "selectAllMode":
        this._initDataSource(), this._dataController.pageIndex(0), this._dataController.load();
        break;
      case "grouped":
        this._clearSelectedItems(), delete this._renderingGroupIndex, this._initEditStrategy(), this.callBase(t);
        break;
      case "showSelectionControls":
      case "menuItems":
      case "menuMode":
      case "allowItemDeleting":
      case "itemDeleteMode":
      case "itemDragging":
      case "selectAllText":
        this._invalidate();
        break;
      case "onSelectAllValueChanged":
        break;
      default:
        this.callBase(t);
    }
  },
  selectAll() {
    return this._selection.selectAll(this._isPageSelectAll());
  },
  unselectAll() {
    return this._selection.deselectAll(this._isPageSelectAll());
  },
  isSelectAll() {
    return this._selection.getSelectAllState(this._isPageSelectAll());
  },
  getFlatIndexByItemElement(t) {
    return this._itemElements().index(t);
  },
  getItemElementByFlatIndex(t) {
    var e = this._itemElements();
    return t < 0 || t >= e.length ? E() : e.eq(t);
  },
  getItemByIndex(t) {
    return this._editStrategy.getItemDataByIndex(t);
  },
  deleteItem(t) {
    var e = this._editStrategy, i = e.getNormalizedIndex(t), r = this.option("focusedElement"), n = r ? e.getNormalizedIndex(r) : i, a = n === this._getLastItemIndex(), o = a || i < n ? n - 1 : n, u = this.callBase(t);
    return u.done(function() {
      return this.focusListItem(o);
    });
  }
}), Gm = Rbe.inherit(Mp).inherit({
  _addWidgetPrefix: function(t) {
    return "dx-list-" + t;
  },
  _getCombinedFilter: function() {
    var t = this._dataController, e = {
      filter: t.filter()
    };
    t.addSearchFilter(e);
    var i = e.filter;
    return i;
  },
  _initDataSource: function() {
    var t = this.option("searchValue"), e = this.option("searchExpr"), i = this.option("searchMode");
    this.callBase();
    var r = this._dataController;
    t && t.length && r.searchValue(t), i.length && r.searchOperation(Mp.getOperationBySearchMode(i)), e && r.searchExpr(e);
  }
});
ti("dxList", Gm);
var k4 = P({}, wB, {
  _dataExpressionDefaultOptions: function() {
    return {
      items: [],
      dataSource: null,
      itemTemplate: "item",
      value: null,
      valueExpr: "this",
      displayExpr: void 0
    };
  },
  _initDataExpressions: function() {
    this._compileValueGetter(), this._compileDisplayGetter(), this._initDynamicTemplates(), this._initDataSource(), this._itemsToDataSource();
  },
  _itemsToDataSource: function() {
    this.option("dataSource") || (this._dataSource = new Ks({
      store: new mS(this.option("items")),
      pageSize: 0
    }), this._initDataController());
  },
  _compileDisplayGetter: function() {
    this._displayGetter = Ii(this._displayGetterExpr());
  },
  _displayGetterExpr: function() {
    return this.option("displayExpr");
  },
  _compileValueGetter: function() {
    this._valueGetter = Ii(this._valueGetterExpr());
  },
  _valueGetterExpr: function() {
    return this.option("valueExpr") || "this";
  },
  _loadValue: function(t) {
    var e = new q();
    return t = this._unwrappedValue(t), R(t) ? (this._loadSingle(this._valueGetterExpr(), t).done((function(i) {
      this._isValueEquals(this._valueGetter(i), t) ? e.resolve(i) : e.reject();
    }).bind(this)).fail(function() {
      e.reject();
    }), this._loadValueDeferred = e, e.promise()) : e.reject().promise();
  },
  _rejectValueLoading: function() {
    var t;
    (t = this._loadValueDeferred) === null || t === void 0 || t.reject({
      shouldSkipCallback: !0
    });
  },
  _getCurrentValue: function() {
    return this.option("value");
  },
  _unwrappedValue: function(t) {
    var e;
    return t = (e = t) !== null && e !== void 0 ? e : this._getCurrentValue(), t && this._dataSource && this._valueGetterExpr() === "this" && (t = this._getItemKey(t)), Ha.unwrap(t);
  },
  _getItemKey: function(t) {
    var e = this._dataSource.key();
    if (Array.isArray(e)) {
      for (var i = {}, r = 0, n = e.length; r < n; r++)
        i[e[r]] = t[e[r]];
      return i;
    }
    return e && typeof t == "object" && (t = t[e]), t;
  },
  _isValueEquals: function(t, e) {
    var i = this._dataSource && this._dataSource.key(), r = this._compareValues(t, e);
    return !r && i && R(t) && R(e) && (Array.isArray(i) ? r = this._compareByCompositeKey(t, e, i) : r = this._compareByKey(t, e, i)), r;
  },
  _compareByCompositeKey: function(t, e, i) {
    var r = ct;
    if (!r(t) || !r(e))
      return !1;
    for (var n = 0, a = i.length; n < a; n++)
      if (t[i[n]] !== e[i[n]])
        return !1;
    return !0;
  },
  _compareByKey: function(t, e, i) {
    var r = Ha.unwrap, n = cr(r(t[i]), t), a = cr(r(e[i]), e);
    return this._compareValues(n, a);
  },
  _compareValues: function(t, e) {
    return ta(t, !0) === ta(e, !0);
  },
  _initDynamicTemplates: ee,
  _setCollectionWidgetItemTemplate: function() {
    this._initDynamicTemplates(), this._setCollectionWidgetOption("itemTemplate", this.option("itemTemplate"));
  },
  _getCollectionKeyExpr: function() {
    var t = this.option("valueExpr"), e = ht(t) && t !== "this" || Le(t);
    return e ? t : null;
  },
  _dataExpressionOptionChanged: function(t) {
    switch (t.name) {
      case "items":
        this._itemsToDataSource(), this._setCollectionWidgetOption("items");
        break;
      case "dataSource":
        this._initDataSource();
        break;
      case "itemTemplate":
        this._setCollectionWidgetItemTemplate();
        break;
      case "valueExpr":
        this._compileValueGetter();
        break;
      case "displayExpr":
        this._compileDisplayGetter(), this._initDynamicTemplates(), this._setCollectionWidgetOption("displayExpr");
    }
  }
}), P4 = Ot(), Lbe = ".dx-list-item", Mbe = "dxListItemData", kbe = "dx-dropdownlist-popup-wrapper", Pbe = "input", Fbe = ["startswith", "contains", "endwith", "notcontains"], F4 = Ye.real().platform !== "android", PX = UB.inherit({
  _supportedKeys: function() {
    var t = this.callBase();
    return P({}, t, {
      tab: function(e) {
        if (this._allowSelectItemByTab()) {
          this._saveValueChangeEvent(e);
          var i = E(this._list.option("focusedElement"));
          i.length && this._setSelectedElement(i);
        }
        t.tab.apply(this, arguments);
      },
      space: ee,
      home: ee,
      end: ee
    });
  },
  _allowSelectItemByTab: function() {
    return this.option("opened") && this.option("applyValueMode") === "instantly";
  },
  _setSelectedElement: function(t) {
    var e = this._valueGetter(this._list._getItemData(t));
    this._setValue(e);
  },
  _setValue: function(t) {
    this.option("value", t);
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), P(k4._dataExpressionDefaultOptions(), {
      displayValue: void 0,
      searchEnabled: !1,
      searchMode: "contains",
      searchTimeout: 500,
      minSearchLength: 0,
      searchExpr: null,
      valueChangeEvent: "input change keyup",
      selectedItem: null,
      noDataText: X.format("dxCollectionWidget-noDataText"),
      encodeNoDataText: !1,
      onSelectionChanged: null,
      onItemClick: ee,
      showDataBeforeSearch: !1,
      grouped: !1,
      groupTemplate: "group",
      popupPosition: {
        my: "left top",
        at: "left bottom",
        offset: {
          h: 0,
          v: 0
        },
        collision: "flip"
      },
      wrapItemText: !1,
      useItemTextAsTitle: !1
    }));
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: {
        platform: "ios"
      },
      options: {
        popupPosition: {
          offset: {
            v: -1
          }
        }
      }
    }, {
      device: {
        platform: "generic"
      },
      options: {
        buttonsLocation: "bottom center"
      }
    }]);
  },
  _setOptionsByReference: function() {
    this.callBase(), P(this._optionsByReference, {
      value: !0,
      selectedItem: !0,
      displayValue: !0
    });
  },
  _init: function() {
    this.callBase(), this._initDataExpressions(), this._initActions(), this._setListDataSource(), this._validateSearchMode(), this._clearSelectedItem(), this._initItems();
  },
  _setListFocusedElementOptionChange: function() {
    this._list._updateParentActiveDescendant = this._updateActiveDescendant.bind(this);
  },
  _initItems: function() {
    var t = this.option().items;
    t && !t.length && this._dataSource && (this.option().items = this._dataSource.items());
  },
  _initActions: function() {
    this._initContentReadyAction(), this._initSelectionChangedAction(), this._initItemClickAction();
  },
  _initContentReadyAction: function() {
    this._contentReadyAction = this._createActionByOption("onContentReady", {
      excludeValidators: ["disabled", "readOnly"]
    });
  },
  _initSelectionChangedAction: function() {
    this._selectionChangedAction = this._createActionByOption("onSelectionChanged", {
      excludeValidators: ["disabled", "readOnly"]
    });
  },
  _initItemClickAction: function() {
    this._itemClickAction = this._createActionByOption("onItemClick");
  },
  _initTemplates: function() {
    this.callBase(), this._templateManager.addDefaultTemplates({
      item: new MF("item")
    });
  },
  _isEditable: function() {
    return this.callBase() || this.option("searchEnabled");
  },
  _saveFocusOnWidget: function(t) {
    this._list && this._list.initialOption("focusStateEnabled") && this._focusInput();
  },
  _fitIntoRange: function(t, e, i) {
    return t > i ? e : t < e ? i : t;
  },
  _items: function() {
    var t = this._getPlainItems(!this._list && this._dataSource.items()), e = new lo(t).filter("disabled", "<>", !0).toArray();
    return e;
  },
  _calcNextItem: function(t) {
    var e = this._items(), i = this._fitIntoRange(this._getSelectedIndex() + t, 0, e.length - 1);
    return e[i];
  },
  _getSelectedIndex: function() {
    var t = this._items(), e = this.option("selectedItem"), i = -1;
    return N(t, (function(r, n) {
      if (this._isValueEquals(n, e))
        return i = r, !1;
    }).bind(this)), i;
  },
  _createPopup: function() {
    this.callBase(), this._updateCustomBoundaryContainer(), this._popup.$wrapper().addClass(this._popupWrapperClass());
    var t = this._popup.$content();
    k.off(t, "mouseup"), k.on(t, "mouseup", this._saveFocusOnWidget.bind(this));
  },
  _updateCustomBoundaryContainer: function() {
    var t = this.option("dropDownOptions.container"), e = t && E(t);
    if (e && e.length && !Or(e.get(0))) {
      var i = [].slice.call(e.parents());
      i.unshift(e.get(0)), N(i, (function(r, n) {
        if (n === E("body").get(0))
          return !1;
        if (P4.getComputedStyle(n).overflowY === "hidden")
          return this._$customBoundaryContainer = E(n), !1;
      }).bind(this));
    }
  },
  _popupWrapperClass: function() {
    return kbe;
  },
  _renderInputValue: function() {
    var t = this._getCurrentValue();
    return this._rejectValueLoading(), this._loadInputValue(t, this._setSelectedItem.bind(this)).always(this.callBase.bind(this, t));
  },
  _loadInputValue: function(t, e) {
    return this._loadItem(t).always(e);
  },
  _getItemFromPlain: function(t, e) {
    var i, r;
    return e && typeof t != "object" && (e.itemByValue || (e.itemByValue = {}, i = this._getPlainItems(), i.forEach(function(n) {
      e.itemByValue[this._valueGetter(n)] = n;
    }, this)), r = e.itemByValue[t]), r || (i = this._getPlainItems(), r = so(i, (function(n) {
      return this._isValueEquals(this._valueGetter(n), t);
    }).bind(this))[0]), r;
  },
  _loadItem: function(t, e) {
    var i = this._getItemFromPlain(t, e);
    return i !== void 0 ? new q().resolve(i).promise() : this._loadValue(t);
  },
  _getPlainItems: function(t) {
    var e = [];
    t = t || this.option("items") || this._dataSource.items() || [];
    for (var i = 0; i < t.length; i++)
      t[i] && t[i].items ? e = e.concat(t[i].items) : e.push(t[i]);
    return e;
  },
  _updateActiveDescendant(t) {
    var e, i = this.option("opened"), r = (e = this._list) === null || e === void 0 ? void 0 : e.getFocusedItemId(), n = E("#".concat(r)).length > 0, a = i && n && r;
    this.setAria({
      activedescendant: a || null
    }, t);
  },
  _setSelectedItem: function(t) {
    var e = this._displayValue(t);
    this.option("selectedItem", cr(t, null)), this.option("displayValue", e);
  },
  _displayValue: function(t) {
    return this._displayGetter(t);
  },
  _refreshSelected: function() {
    var t = {};
    this._listItemElements().each((function(e, i) {
      var r = E(i), n = this._valueGetter(r.data(Mbe)), a = this._isSelectedValue(n, t);
      a ? this._list.selectItem(r) : this._list.unselectItem(r);
    }).bind(this));
  },
  _popupShownHandler: function() {
    this.callBase(), this._setFocusPolicy();
  },
  _setFocusPolicy: function() {
    !this.option("focusStateEnabled") || !this._list || this._list.option("focusedElement", null);
  },
  _isSelectedValue: function(t) {
    return this._isValueEquals(t, this.option("value"));
  },
  _validateSearchMode: function() {
    var t = this.option("searchMode"), e = t.toLowerCase();
    if (!Fbe.includes(e))
      throw Yt.Error("E1019", t);
  },
  _clearSelectedItem: function() {
    this.option("selectedItem", null);
  },
  _processDataSourceChanging: function() {
    this._initDataController(), this._setListOption("_dataController", this._dataController), this._setListDataSource(), this._renderInputValue().fail((function() {
      this._isCustomValueAllowed() || this._clearSelectedItem();
    }).bind(this));
  },
  _isCustomValueAllowed: function() {
    return this.option("displayCustomValue");
  },
  clear: function() {
    this.callBase(), this._clearFilter(), this._clearSelectedItem();
  },
  _listItemElements: function() {
    return this._$list ? this._$list.find(Lbe) : E();
  },
  _popupConfig: function() {
    return P(this.callBase(), {
      templatesRenderAsynchronously: !1,
      autoResizeEnabled: !1,
      maxHeight: this._getMaxHeight.bind(this)
    });
  },
  _renderPopupContent: function() {
    this.callBase(), this._renderList();
  },
  _getKeyboardListeners() {
    var t = this._canListHaveFocus();
    return this.callBase().concat([!t && this._list]);
  },
  _renderList: function() {
    this._listId = "dx-" + new yr()._value;
    var t = E("<div>").attr("id", this._listId).appendTo(this._popup.$content());
    this._$list = t, this._list = this._createComponent(t, Gm, this._listConfig()), this._refreshList(), this._renderPreventBlurOnListClick(), this._setListFocusedElementOptionChange();
  },
  _renderPreventBlurOnListClick: function() {
    var t = ve("mousedown", "dxDropDownList");
    k.off(this._$list, t), k.on(this._$list, t, (e) => e.preventDefault());
  },
  _getControlsAria() {
    return this._list && this._listId;
  },
  _renderOpenedState: function() {
    this.callBase(), this._list && this._updateActiveDescendant(), this.setAria("owns", this._popup && this._popupContentId);
  },
  _setDefaultAria: function() {
    this.setAria({
      haspopup: "listbox",
      autocomplete: "list"
    });
  },
  _refreshList: function() {
    this._list && this._shouldRefreshDataSource() && this._setListDataSource();
  },
  _shouldRefreshDataSource: function() {
    var t = !!this._list.option("dataSource");
    return t !== this._needPassDataSourceToList();
  },
  _isDesktopDevice: function() {
    return Ye.real().deviceType === "desktop";
  },
  _listConfig: function() {
    var t = {
      selectionMode: "single",
      _templates: this.option("_templates"),
      templateProvider: this.option("templateProvider"),
      noDataText: this.option("noDataText"),
      encodeNoDataText: this.option("encodeNoDataText"),
      grouped: this.option("grouped"),
      wrapItemText: this.option("wrapItemText"),
      useItemTextAsTitle: this.option("useItemTextAsTitle"),
      onContentReady: this._listContentReadyHandler.bind(this),
      itemTemplate: this.option("itemTemplate"),
      indicateLoading: !1,
      keyExpr: this._getCollectionKeyExpr(),
      displayExpr: this._displayGetterExpr(),
      groupTemplate: this.option("groupTemplate"),
      onItemClick: this._listItemClickAction.bind(this),
      dataSource: this._getDataSource(),
      _dataController: this._dataController,
      hoverStateEnabled: this._isDesktopDevice() ? this.option("hoverStateEnabled") : !1,
      focusStateEnabled: this._isDesktopDevice() ? this.option("focusStateEnabled") : !1
    };
    return this._canListHaveFocus() || (t.tabIndex = null), t;
  },
  _canListHaveFocus: () => !1,
  _getDataSource: function() {
    return this._needPassDataSourceToList() ? this._dataSource : null;
  },
  _dataSourceOptions: function() {
    return {
      paginate: !1
    };
  },
  _getGroupedOption: function() {
    return this.option("grouped");
  },
  _dataSourceFromUrlLoadMode: function() {
    return "raw";
  },
  _listContentReadyHandler: function() {
    this._list = this._list || this._$list.dxList("instance"), this.option("deferRendering") || this._refreshSelected(), this._updatePopupWidth(), this._updateListDimensions(), this._contentReadyAction();
  },
  _setListOption: function(t, e) {
    this._setWidgetOption("_list", arguments);
  },
  _listItemClickAction: function(t) {
    this._listItemClickHandler(t), this._itemClickAction(t);
  },
  _listItemClickHandler: ee,
  _setListDataSource: function() {
    this._list && (this._setListOption("dataSource", this._getDataSource()), this._needPassDataSourceToList() || this._setListOption("items", []));
  },
  _needPassDataSourceToList: function() {
    return this.option("showDataBeforeSearch") || this._isMinSearchLengthExceeded();
  },
  _isMinSearchLengthExceeded: function() {
    return this._searchValue().toString().length >= this.option("minSearchLength");
  },
  _needClearFilter: function() {
    return this._canKeepDataSource() ? !1 : this._needPassDataSourceToList();
  },
  _canKeepDataSource: function() {
    var t = this._isMinSearchLengthExceeded();
    return this._dataController.isLoaded() && this.option("showDataBeforeSearch") && this.option("minSearchLength") && !t && !this._isLastMinSearchLengthExceeded;
  },
  _searchValue: function() {
    return this._input().val() || "";
  },
  _getSearchEvent: function() {
    return ve(Pbe, this.NAME + "Search");
  },
  _getCompositionStartEvent: function() {
    return ve("compositionstart", this.NAME + "CompositionStart");
  },
  _getCompositionEndEvent: function() {
    return ve("compositionend", this.NAME + "CompositionEnd");
  },
  _getSetFocusPolicyEvent: function() {
    return ve("input", this.NAME + "FocusPolicy");
  },
  _renderEvents: function() {
    this.callBase(), k.on(this._input(), this._getSetFocusPolicyEvent(), () => {
      this._setFocusPolicy();
    }), this._shouldRenderSearchEvent() && (k.on(this._input(), this._getSearchEvent(), (t) => {
      this._searchHandler(t);
    }), F4 && (k.on(this._input(), this._getCompositionStartEvent(), () => {
      this._isTextCompositionInProgress(!0);
    }), k.on(this._input(), this._getCompositionEndEvent(), (t) => {
      this._isTextCompositionInProgress(void 0), this._searchHandler(t, this._searchValue());
    })));
  },
  _shouldRenderSearchEvent: function() {
    return this.option("searchEnabled");
  },
  _refreshEvents: function() {
    k.off(this._input(), this._getSearchEvent()), k.off(this._input(), this._getSetFocusPolicyEvent()), F4 && (k.off(this._input(), this._getCompositionStartEvent()), k.off(this._input(), this._getCompositionEndEvent())), this.callBase();
  },
  _isTextCompositionInProgress: function(t) {
    if (arguments.length)
      this._isTextComposition = t;
    else
      return this._isTextComposition;
  },
  _searchHandler: function(t, e) {
    if (!this._isTextCompositionInProgress()) {
      if (!this._isMinSearchLengthExceeded()) {
        this._searchCanceled();
        return;
      }
      var i = this.option("searchTimeout");
      i ? (this._clearSearchTimer(), this._searchTimer = setTimeout(() => {
        this._searchDataSource(e);
      }, i)) : this._searchDataSource(e);
    }
  },
  _searchCanceled: function() {
    this._clearSearchTimer(), this._needClearFilter() && this._filterDataSource(null), this._refreshList();
  },
  _searchDataSource: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._searchValue();
    this._filterDataSource(t);
  },
  _filterDataSource: function(t) {
    this._clearSearchTimer();
    var e = this._dataController;
    e.searchExpr(this.option("searchExpr") || this._displayGetterExpr()), e.searchOperation(this.option("searchMode")), e.searchValue(t), e.load().done(this._dataSourceFiltered.bind(this, t));
  },
  _clearFilter: function() {
    var t = this._dataController;
    t.searchValue() && t.searchValue(null);
  },
  _dataSourceFiltered: function() {
    this._isLastMinSearchLengthExceeded = this._isMinSearchLengthExceeded(), this._refreshList(), this._refreshPopupVisibility();
  },
  _shouldOpenPopup: function() {
    return this._hasItemsToShow();
  },
  _refreshPopupVisibility: function() {
    if (!(this.option("readOnly") || !this._searchValue())) {
      var t = this._shouldOpenPopup();
      t && !this._isFocused() || (this.option("opened", t), t && (this._updatePopupWidth(), this._updateListDimensions()));
    }
  },
  _dataSourceChangedHandler: function(t) {
    this._dataController.pageIndex() === 0 ? this.option().items = t : this.option().items = this.option().items.concat(t);
  },
  _hasItemsToShow: function() {
    var t = this._dataController, e = t.items() || [], i = e.length, r = this._needPassDataSourceToList();
    return !!(r && i);
  },
  _clearSearchTimer: function() {
    clearTimeout(this._searchTimer), delete this._searchTimer;
  },
  _popupShowingHandler: function() {
    this._updatePopupWidth(), this._updateListDimensions();
  },
  _dimensionChanged: function() {
    this.callBase(), this._updateListDimensions();
  },
  _needPopupRepaint: function() {
    var t = this._dataController, e = t.pageIndex(), i = R(this._pageIndex) && e <= this._pageIndex || t.isLastPage() && !this._list._scrollViewIsFull();
    return this._pageIndex = e, i;
  },
  _updateListDimensions: function() {
    this._popup && (this._needPopupRepaint() && this._popup.repaint(), this._list && this._list.updateDimensions());
  },
  _getMaxHeight: function() {
    var t = this.$element(), e = this._$customBoundaryContainer, i = t.offset().top - (e ? e.offset().top : 0), r = jt(P4), n = e ? Math.min(jt(e), r) : r, a = Math.max(i, n - i - jt(t));
    return Math.min(0.5 * n, a);
  },
  _clean: function() {
    this._list && delete this._list, delete this._isLastMinSearchLengthExceeded, this.callBase();
  },
  _dispose: function() {
    this._clearSearchTimer(), this.callBase();
  },
  _setCollectionWidgetOption: function() {
    this._setListOption.apply(this, arguments);
  },
  _setSubmitValue: function() {
    var t = this.option("value"), e = this._shouldUseDisplayValue(t) ? this._displayGetter(t) : t;
    this._getSubmitElement().val(e);
  },
  _shouldUseDisplayValue: function(t) {
    return this.option("valueExpr") === "this" && ct(t);
  },
  _optionChanged: function(t) {
    switch (this._dataExpressionOptionChanged(t), t.name) {
      case "hoverStateEnabled":
      case "focusStateEnabled":
        this._isDesktopDevice() && this._setListOption(t.name, t.value), this.callBase(t);
        break;
      case "items":
        this.option("dataSource") || this._processDataSourceChanging();
        break;
      case "dataSource":
        this._processDataSourceChanging();
        break;
      case "valueExpr":
        this._renderValue(), this._setListOption("keyExpr", this._getCollectionKeyExpr());
        break;
      case "displayExpr":
        this._renderValue(), this._setListOption("displayExpr", this._displayGetterExpr());
        break;
      case "searchMode":
        this._validateSearchMode();
        break;
      case "minSearchLength":
        this._refreshList();
        break;
      case "searchEnabled":
      case "showDataBeforeSearch":
      case "searchExpr":
        this._invalidate();
        break;
      case "onContentReady":
        this._initContentReadyAction();
        break;
      case "onSelectionChanged":
        this._initSelectionChangedAction();
        break;
      case "onItemClick":
        this._initItemClickAction();
        break;
      case "grouped":
      case "groupTemplate":
      case "wrapItemText":
      case "noDataText":
      case "encodeNoDataText":
      case "useItemTextAsTitle":
        this._setListOption(t.name);
        break;
      case "displayValue":
        this.option("text", t.value);
        break;
      case "itemTemplate":
      case "searchTimeout":
        break;
      case "selectedItem":
        t.previousValue !== t.value && this._selectionChangedAction({
          selectedItem: t.value
        });
        break;
      default:
        this.callBase(t);
    }
  }
}).include(k4, tX);
ti("dxDropDownList", PX);
var Bbe = ".dx-state-disabled", Vbe = "dx-selectbox", Nbe = "dx-selectbox-popup", Hbe = "dx-selectbox-container", B4 = "dx-selectbox-popup-wrapper", KB = PX.inherit({
  _supportedKeys() {
    var t = this, e = this.callBase(), i = function(n) {
      var a = this._isEditable();
      a ? this._valueSubstituted() && (this._preventFiltering = !0) : this.option("showClearButton") && (n.preventDefault(), this.clear()), this._savedTextRemoveEvent = n, this._preventSubstitution = !0;
    }, r = function() {
      t.option("searchEnabled") && t._valueSubstituted() && t._searchHandler();
    };
    return P({}, e, {
      tab() {
        this.option("opened") && !this._popup.getFocusableElements().length && this._resetCaretPosition(!0), e.tab && e.tab.apply(this, arguments), this._cancelSearchIfNeed();
      },
      upArrow(n) {
        if (e.upArrow.apply(this, arguments))
          return this.option("opened") || this._setNextValue(n), !0;
      },
      downArrow(n) {
        if (e.downArrow.apply(this, arguments))
          return this.option("opened") || this._setNextValue(n), !0;
      },
      leftArrow() {
        var n;
        r(), (n = e.leftArrow) === null || n === void 0 || n.apply(this, arguments);
      },
      rightArrow() {
        r(), e.rightArrow && e.rightArrow.apply(this, arguments);
      },
      home() {
        r(), e.home && e.home.apply(this, arguments);
      },
      end() {
        r(), e.end && e.end.apply(this, arguments);
      },
      escape() {
        var n = e.escape && e.escape.apply(this, arguments);
        return this._cancelEditing(), n ?? !0;
      },
      enter(n) {
        var a = this.option("opened"), o = this._input().val().trim(), u = o && this._list && !this._list.option("focusedElement");
        if (!o && R(this.option("value")) && this.option("allowClearing"))
          this._saveValueChangeEvent(n), this.option({
            selectedItem: null,
            value: null
          }), this.close();
        else {
          if (this.option("acceptCustomValue"))
            return n.preventDefault(), u && (a && this._toggleOpenState(), this._valueChangeEventHandler(n)), a;
          if (e.enter && e.enter.apply(this, arguments))
            return a;
        }
      },
      space(n) {
        var a = this.option("opened"), o = this.option("searchEnabled"), u = this.option("acceptCustomValue");
        if (!(!a || o || u))
          return n.preventDefault(), this._valueChangeEventHandler(n), !0;
      },
      backspace: i,
      del: i
    });
  },
  _getDefaultOptions() {
    return P(this.callBase(), {
      placeholder: X.format("Select"),
      fieldTemplate: null,
      customItemCreateEvent: "change",
      valueChangeEvent: "change",
      acceptCustomValue: !1,
      onCustomItemCreating(t) {
        R(t.customItem) || (t.customItem = t.text);
      },
      showSelectionControls: !1,
      allowClearing: !0,
      tooltipEnabled: !1,
      openOnFieldClick: !0,
      showDropDownButton: !0,
      displayCustomValue: !1,
      useHiddenSubmitElement: !0
    });
  },
  _init() {
    this.callBase(), this._initCustomItemCreatingAction();
  },
  _initMarkup() {
    this.$element().addClass(Vbe), this._renderTooltip(), this.callBase(), this._$container.addClass(Hbe);
  },
  _createPopup() {
    this.callBase(), this._popup.$element().addClass(Nbe), this._popup.$overlayContent().attr("tabindex", -1);
  },
  _popupWrapperClass() {
    return "".concat(this.callBase(), " ").concat(B4);
  },
  _setDeprecatedOptions() {
    this.callBase(), P(this._deprecatedOptions, {
      valueChangeEvent: {
        since: "22.2",
        alias: "customItemCreateEvent"
      }
    });
  },
  _cancelEditing() {
    !this.option("searchEnabled") && this._list && (this._focusListElement(null), this._updateField(this.option("selectedItem")));
  },
  _renderOpenedState() {
    this.callBase(), this.option("opened") && (this._scrollToSelectedItem(), this._focusSelectedElement());
  },
  _focusSelectedElement() {
    var t, e = this._searchValue();
    if (!e) {
      this._focusListElement(null);
      return;
    }
    var {
      items: i,
      selectedItem: r
    } = this.option(), n = this._list._itemElements(), a = (t = i == null ? void 0 : i.indexOf(r)) !== null && t !== void 0 ? t : -1, o = a !== -1 && !this._isCustomItemSelected() ? n.eq(a) : null;
    this._focusListElement(o);
  },
  _renderFocusedElement() {
    if (this._list) {
      var t = this._searchValue();
      if (!t || this.option("acceptCustomValue")) {
        this._focusListElement(null);
        return;
      }
      var e = this._list._itemElements(), i = e.not(Bbe).eq(0);
      this._focusListElement(i);
    }
  },
  _focusListElement(t) {
    this._preventInputValueRender = !0, this._list.option("focusedElement", ot(t)), delete this._preventInputValueRender;
  },
  _scrollToSelectedItem() {
    this._list && this._list.scrollToItem(this._list.option("selectedItem"));
  },
  _listContentReadyHandler() {
    this.callBase();
    var t = this._dataController.paginate();
    t && this._needPopupRepaint() || this._scrollToSelectedItem();
  },
  _renderValue() {
    return this._renderInputValue(), this._setSubmitValue(), new q().resolve();
  },
  _renderInputValue() {
    return this.callBase().always(() => {
      this._renderInputValueAsync();
    });
  },
  _renderInputValueAsync() {
    this._renderTooltip(), this._renderInputValueImpl().always(() => {
      this._refreshSelected();
    });
  },
  _renderInputValueImpl() {
    return this._renderField(), new q().resolve();
  },
  _setNextItem(t) {
    var e = this._calcNextItem(t), i = this._valueGetter(e);
    this._setValue(i);
  },
  _setNextValue(t) {
    var e = this._dataController.isLoaded() ? new q().resolve() : this._dataController.load();
    e.done(() => {
      var i = this._getSelectedIndex(), r = this._dataController.pageSize(), n = this._dataController.isLastPage(), a = i === this._items().length - 1;
      this._saveValueChangeEvent(t);
      var o = or(t) === "downArrow" ? 1 : -1;
      r && !n && a && o > 0 ? (this._popup || this._createPopup(), this._dataController.isLoading() || this._list._loadNextPage().done(this._setNextItem.bind(this, o))) : this._setNextItem(o);
    });
  },
  _setSelectedItem(t) {
    var e = !this._isCustomValueAllowed() && t === void 0;
    this.callBase(e ? null : t), !e && (!this._isEditable() || this._isCustomItemSelected()) && this._setListOption("selectedItem", this.option("selectedItem"));
  },
  _isCustomValueAllowed() {
    return this.option("acceptCustomValue") || this.callBase();
  },
  _displayValue(t) {
    return t = !R(t) && this._isCustomValueAllowed() ? this.option("value") : t, this.callBase(t);
  },
  _listConfig() {
    var t = P(this.callBase(), {
      pageLoadMode: "scrollBottom",
      onSelectionChanged: this._getSelectionChangeHandler(),
      selectedItem: this.option("selectedItem"),
      onFocusedItemChanged: this._listFocusedItemChangeHandler.bind(this)
    });
    return this.option("showSelectionControls") && P(t, {
      showSelectionControls: !0,
      selectByClick: !0
    }), t;
  },
  _listFocusedItemChangeHandler(t) {
    if (!this._preventInputValueRender) {
      var e = t.component, i = E(e.option("focusedElement")), r = e._getItemData(i);
      this._updateField(r);
    }
  },
  _updateField(t) {
    var e = this._getTemplateByOption("fieldTemplate");
    if (!(e && this.option("fieldTemplate"))) {
      var i = this._displayGetter(t);
      this.option("text", i), this._renderDisplayText(i);
      return;
    }
    this._renderField();
  },
  _getSelectionChangeHandler() {
    return this.option("showSelectionControls") ? this._selectionChangeHandler.bind(this) : ee;
  },
  _selectionChangeHandler(t) {
    N(t.addedItems || [], (e, i) => {
      this._setValue(this._valueGetter(i));
    });
  },
  _getActualSearchValue() {
    return this._dataController.searchValue();
  },
  _toggleOpenState(t) {
    if (!this.option("disabled")) {
      if (t = arguments.length ? t : !this.option("opened"), !t && !this._shouldClearFilter() && this._restoreInputText(!0), this._wasSearch() && t) {
        this._wasSearch(!1);
        var e = this.option("showDataBeforeSearch") || this._isMinSearchLengthExceeded();
        if (e && this._dataController.getDataSource()) {
          if (this._searchTimer)
            return;
          var i = this._getActualSearchValue();
          i && this._wasSearch(!0), this._filterDataSource(i || null);
        } else
          this._setListOption("items", []);
      }
      t && this._scrollToSelectedItem(), this.callBase(t);
    }
  },
  _renderTooltip() {
    this.option("tooltipEnabled") && this.$element().attr("title", this.option("displayValue"));
  },
  _renderDimensions() {
    this.callBase(), this._updatePopupWidth(), this._updateListDimensions();
  },
  _isValueEqualInputText() {
    var t = this.option("selectedItem");
    if (t === null)
      return !1;
    var e = this._displayGetter(t), i = e ? String(e) : "", r = this._searchValue();
    return i === r;
  },
  _popupHidingHandler() {
    this._isValueEqualInputText() && this._cancelEditing(), this.callBase();
  },
  _popupHiddenHandler() {
    this.callBase(), this._shouldCancelSearch() && (this._wasSearch(!1), this._searchCanceled(), this._shouldCancelSearch(!1));
  },
  _restoreInputText(t) {
    this.option("readOnly") || this._loadItemDeferred && this._loadItemDeferred.always(() => {
      var {
        acceptCustomValue: e,
        text: i,
        selectedItem: r
      } = this.option();
      if (e) {
        !t && !this._isValueChanging && (this._updateField(r ?? this._createCustomItem(i)), this._clearFilter());
        return;
      }
      if (this.option("searchEnabled") && !this._searchValue() && this.option("allowClearing")) {
        this._clearTextValue();
        return;
      }
      this._isValueEqualInputText() || this._renderInputValue().always((n) => {
        var a = cr(n, r);
        this._setSelectedItem(a), this._updateField(a), this._clearFilter();
      });
    });
  },
  _valueChangeEventIncludesBlur() {
    var t = this.option(this._getValueChangeEventOptionName());
    return t.includes("blur");
  },
  _isPreventedFocusOutEvent(t) {
    return this._preventNestedFocusEvent(t) || this._valueChangeEventIncludesBlur();
  },
  _focusOutHandler(t) {
    if (!this._isPreventedFocusOutEvent(t)) {
      var e = this._isOverlayNestedTarget(t.relatedTarget);
      e || (this._restoreInputText(), this._clearSearchTimer()), this._cancelSearchIfNeed(t);
    }
    t.target = this._input().get(0), this.callBase(t);
  },
  _cancelSearchIfNeed(t) {
    var e, {
      searchEnabled: i
    } = this.option(), r = this._isOverlayNestedTarget(t == null ? void 0 : t.relatedTarget), n = this._wasSearch() && i && !r;
    if (n) {
      var a = (e = this._popup) === null || e === void 0 ? void 0 : e._hideAnimationProcessing;
      this._clearSearchTimer(), a ? this._shouldCancelSearch(!0) : (this._wasSearch(!1), this._searchCanceled());
    }
  },
  _shouldCancelSearch(t) {
    if (!arguments.length)
      return this._shouldCancelSearchValue;
    this._shouldCancelSearchValue = t;
  },
  _isOverlayNestedTarget: (t) => !!E(t).closest(".".concat(B4)).length,
  _clearTextValue() {
    var t = this.option("selectedItem"), e = this._displayGetter(t), i = t && e !== "";
    i && (this._savedTextRemoveEvent && this._saveValueChangeEvent(this._savedTextRemoveEvent), this.option("value", null)), delete this._savedTextRemoveEvent;
  },
  _shouldOpenPopup() {
    return this._needPassDataSourceToList() && this._wasSearch();
  },
  _isFocused() {
    var t = de.getActiveElement(this.element());
    return this.callBase() && E(t).closest(this._input()).length > 0;
  },
  _getValueChangeEventOptionName: () => "customItemCreateEvent",
  _renderValueChangeEvent() {
    this._isEditable() && this.callBase();
  },
  _fieldRenderData() {
    var t = this._list && this.option("opened") && E(this._list.option("focusedElement"));
    return t && t.length ? this._list._getItemData(t) : this.option("selectedItem");
  },
  _isSelectedValue(t) {
    return this._isValueEquals(t, this.option("value"));
  },
  _shouldCloseOnItemClick() {
    return !(this.option("showSelectionControls") && this.option("selectionMode") !== "single");
  },
  _listItemClickHandler(t) {
    var e = this._getCurrentValue();
    this._focusListElement(E(t.itemElement)), this._saveValueChangeEvent(t.event), this._completeSelection(this._valueGetter(t.itemData)), this._shouldCloseOnItemClick() && this.option("opened", !1), this.option("searchEnabled") && e === this._valueGetter(t.itemData) && this._updateField(t.itemData), this._shouldClearFilter() && this._cancelSearchIfNeed();
  },
  _shouldClearFilter() {
    return this._wasSearch();
  },
  _completeSelection(t) {
    this._setValue(t);
  },
  _loadItem(t, e) {
    var i = this, r = new q();
    return this.callBase(t, e).done((n) => {
      r.resolve(n);
    }).fail((n) => {
      if (!(n != null && n.shouldSkipCallback)) {
        var a = i.option("selectedItem");
        i.option("acceptCustomValue") && t === i._valueGetter(a) ? r.resolve(a) : r.reject();
      }
    }), r.promise();
  },
  _loadInputValue(t, e) {
    return this._loadItemDeferred = this._loadItem(t).always(e), this._loadItemDeferred;
  },
  _isCustomItemSelected() {
    var t = this.option("selectedItem"), e = this._searchValue(), i = this._displayGetter(t);
    return !i || e !== i.toString();
  },
  _valueChangeEventHandler(t) {
    this.option("acceptCustomValue") && this._isCustomItemSelected() && !this._isValueChanging && (this._isValueChanging = !0, this._customItemAddedHandler(t));
  },
  _initCustomItemCreatingAction() {
    this._customItemCreatingAction = this._createActionByOption("onCustomItemCreating");
  },
  _createCustomItem(t) {
    var e = {
      text: t
    }, i = this._customItemCreatingAction(e), r = cr(i, e.customItem);
    return R(i) && bi.log("W0015", "onCustomItemCreating", "customItem"), r;
  },
  _customItemAddedHandler(t) {
    var e = this._searchValue(), i = this._createCustomItem(e);
    if (this._saveValueChangeEvent(t), i === void 0)
      throw this._renderValue(), bi.Error("E0121");
    Vm(i) ? Pn(i).done(this._setCustomItem.bind(this)).fail(this._setCustomItem.bind(this, null)) : this._setCustomItem(i);
  },
  _setCustomItem(t) {
    this._disposed || (t = t || null, this.option("selectedItem", t), this._cancelSearchIfNeed(), this._setValue(this._valueGetter(t)), this._renderDisplayText(this._displayGetter(t)), this._isValueChanging = !1);
  },
  _clearValueHandler(t) {
    return this._preventFiltering = !0, this.callBase(t), this._searchCanceled(), !1;
  },
  _wasSearch(t) {
    if (!arguments.length)
      return !!this._wasSearchValue;
    this._wasSearchValue = t;
  },
  _searchHandler() {
    if (this._preventFiltering) {
      delete this._preventFiltering;
      return;
    }
    this._needPassDataSourceToList() && this._wasSearch(!0), this.callBase(arguments);
  },
  _dataSourceFiltered(t) {
    this.callBase(), t !== null && (this._renderInputSubstitution(), this._renderFocusedElement());
  },
  _valueSubstituted() {
    var t = this._input().get(0), e = this._searchValue().length, i = t.selectionStart === 0 && t.selectionEnd === e, r = t.selectionStart !== t.selectionEnd, n = e === t.selectionEnd;
    return this._wasSearch() && r && !i && n && this._shouldSubstitutionBeRendered();
  },
  _shouldSubstitutionBeRendered() {
    return !this._preventSubstitution && this.option("searchEnabled") && !this.option("acceptCustomValue") && this.option("searchMode") === "startswith";
  },
  _renderInputSubstitution() {
    if (!this._shouldSubstitutionBeRendered()) {
      delete this._preventSubstitution;
      return;
    }
    var t = this._list && this._getPlainItems(this._list.option("items"))[0];
    if (t) {
      var e = this._input(), i = e.val().length;
      if (i !== 0) {
        var r = e.get(0), n = this._displayGetter(t).toString();
        r.value = n, this._caret({
          start: i,
          end: n.length
        });
      }
    }
  },
  _dispose() {
    this._renderInputValueAsync = ee, delete this._loadItemDeferred, this.callBase();
  },
  _optionChanged(t) {
    switch (t.name) {
      case "customItemCreateEvent":
        this._refreshValueChangeEvent(), this._refreshFocusEvent(), this._refreshEvents();
        break;
      case "onCustomItemCreating":
        this._initCustomItemCreatingAction();
        break;
      case "tooltipEnabled":
        this._renderTooltip();
        break;
      case "displayCustomValue":
      case "acceptCustomValue":
      case "showSelectionControls":
        this._invalidate();
        break;
      case "allowClearing":
        break;
      default:
        this.callBase(t);
    }
  }
});
ti("dxSelectBox", KB);
var V4 = (t) => t.getMonth() + 1, N4 = (t, e) => {
  var i = t.getDate(), r = Wx("M", t), n = ma(parseInt(e), r.min, r.max);
  t.setMonth(n - 1, 1);
  var {
    min: a,
    max: o
  } = Wx("dM", t), u = ma(i, a, o);
  t.setDate(u);
}, $be = {
  a: (t) => t.getHours() < 12 ? 0 : 1,
  E: "getDay",
  y: "getFullYear",
  M: V4,
  L: V4,
  d: "getDate",
  H: "getHours",
  h: "getHours",
  m: "getMinutes",
  s: "getSeconds",
  S: "getMilliseconds"
}, zbe = P({}, ffe(), {
  a: (t, e) => {
    var i = t.getHours(), r = i >= 12;
    r !== !!parseInt(e) && t.setHours((i + 12) % 24);
  },
  d: (t, e) => {
    var i = Wx("dM", t).max;
    e > i && t.setMonth(t.getMonth() + 1), t.setDate(e);
  },
  h: (t, e) => {
    var i = t.getHours() >= 12;
    t.setHours(+e % 12 + (i ? 12 : 0));
  },
  M: N4,
  L: N4,
  E: (t, e) => {
    e < 0 || t.setDate(t.getDate() - t.getDay() + parseInt(e));
  },
  y: (t, e) => {
    var i = t.getFullYear(), r = String(e).length, n = String(Wx("y", t).max).length, a = parseInt(String(i).substr(0, n - r) + e);
    t.setFullYear(a);
  }
}), Wbe = (t) => $be[t] || (() => t), Ube = (t, e) => {
  for (var i = e.regexp.exec(t), r = 0, n = 0, a = [], o = function() {
    r = n, n = r + i[u].length;
    var c = e.patterns[u - 1].replace(/^'|'$/g, ""), p = Wbe(c[0]);
    a.push({
      index: u - 1,
      isStub: c === i[u],
      caret: {
        start: r,
        end: n
      },
      pattern: c,
      text: i[u],
      limits: function() {
        for (var v = arguments.length, _ = new Array(v), y = 0; y < v; y++)
          _[y] = arguments[y];
        return Wx(c[0], ..._);
      },
      setter: zbe[c[0]] || ee,
      getter: p
    });
  }, u = 1; u < i.length; u++)
    o();
  return a;
}, Wx = (t, e, i) => {
  var r = {
    y: {
      min: 0,
      max: 9999
    },
    M: {
      min: 1,
      max: 12
    },
    L: {
      min: 1,
      max: 12
    },
    d: {
      min: 1,
      max: 31
    },
    dM: {
      min: 1,
      max: new Date(e.getFullYear(), e.getMonth() + 1, 0).getDate()
    },
    E: {
      min: 0,
      max: 6
    },
    H: {
      min: 0,
      max: 23
    },
    h: {
      min: 1,
      max: 12
    },
    m: {
      min: 0,
      max: 59
    },
    s: {
      min: 0,
      max: 59
    },
    S: {
      min: 0,
      max: 999
    },
    a: {
      min: 0,
      max: 1
    }
  };
  return r[i || t] || r.getAmPm;
}, Gbe = (t, e) => {
  for (var i = 0; i < t.length; i++) {
    var r = t[i].caret.end >= e;
    if (!t[i].isStub && r)
      return i;
  }
  return null;
}, mM = ["year", "day", "month", "day"], H4 = ["hours", "minutes", "seconds", "milliseconds"], FX = 6e4, BX = 60 * FX * 24, Kbe = 365 * BX, jbe = function(t) {
  var e = typeof t;
  return e === "string" ? "format" : e === "object" && t.type !== void 0 ? t.type : null;
}, Ci = {
  SUPPORTED_FORMATS: ["date", "time", "datetime"],
  ONE_MINUTE: FX,
  ONE_DAY: BX,
  ONE_YEAR: Kbe,
  MIN_DATEVIEW_DEFAULT_DATE: new Date(1900, 0, 1),
  MAX_DATEVIEW_DEFAULT_DATE: function() {
    var t = /* @__PURE__ */ new Date();
    return new Date(t.getFullYear() + 50, t.getMonth(), t.getDate(), 23, 59, 59);
  }(),
  FORMATS_INFO: {
    date: {
      getStandardPattern: function() {
        return "yyyy-MM-dd";
      },
      components: mM
    },
    time: {
      getStandardPattern: function() {
        return "HH:mm";
      },
      components: H4
    },
    datetime: {
      getStandardPattern: function() {
        var t;
        return function() {
          var e = E("<input>").attr("type", "datetime");
          e.val("2000-01-01T01:01Z"), e.val() && (t = "yyyy-MM-ddTHH:mmZ");
        }(), t || (t = "yyyy-MM-ddTHH:mm:ssZ"), Ci.FORMATS_INFO.datetime.getStandardPattern = function() {
          return t;
        }, t;
      },
      components: [...mM, ...H4]
    },
    "datetime-local": {
      getStandardPattern: function() {
        return "yyyy-MM-ddTHH:mm:ss";
      },
      components: [...mM, "hours", "minutes", "seconds"]
    }
  },
  FORMATS_MAP: {
    date: "shortdate",
    time: "shorttime",
    datetime: "shortdateshorttime"
  },
  SUBMIT_FORMATS_MAP: {
    date: "date",
    time: "time",
    datetime: "datetime-local"
  },
  toStandardDateFormat: function(t, e) {
    var i = Ci.FORMATS_INFO[e].getStandardPattern();
    return $r.serializeDate(t, i);
  },
  fromStandardDateFormat: function(t) {
    var e = $r.dateParser(t);
    return zo(e) ? e : void 0;
  },
  getMaxMonthDay: function(t, e) {
    return new Date(t, e + 1, 0).getDate();
  },
  mergeDates: function(t, e, i) {
    if (!e)
      return e || null;
    if (!t || isNaN(t.getTime())) {
      var r = /* @__PURE__ */ new Date(null);
      t = new Date(r.getFullYear(), r.getMonth(), r.getDate());
    }
    var n = new Date(t.valueOf()), a = Ci.FORMATS_INFO[i];
    return N(a.components, function() {
      var o = Ci.DATE_COMPONENTS_INFO[this];
      n[o.setter](e[o.getter]());
    }), n;
  },
  getLongestCaptionIndex: function(t) {
    var e = 0, i = 0, r;
    for (r = 0; r < t.length; ++r)
      t[r].length > i && (e = r, i = t[r].length);
    return e;
  },
  formatUsesMonthName: function(t) {
    return Bt.formatUsesMonthName(t);
  },
  formatUsesDayName: function(t) {
    return Bt.formatUsesDayName(t);
  },
  getLongestDate: function(t, e, i) {
    var r = jbe(t), n = 9;
    (!r || Ci.formatUsesMonthName(r)) && (n = Ci.getLongestCaptionIndex(e));
    var a = new Date(1888, n, 21, 23, 59, 59, 999);
    if (!r || Ci.formatUsesDayName(r)) {
      var o = a.getDate() - a.getDay() + Ci.getLongestCaptionIndex(i);
      a.setDate(o);
    }
    return a;
  },
  normalizeTime: function(t) {
    t.setSeconds(0), t.setMilliseconds(0);
  }
};
Ci.DATE_COMPONENTS_INFO = {
  year: {
    getter: "getFullYear",
    setter: "setFullYear",
    formatter: function(t, e) {
      var i = new Date(e.getTime());
      return i.setFullYear(t), Bt.format(i, "yyyy");
    },
    startValue: void 0,
    endValue: void 0
  },
  day: {
    getter: "getDate",
    setter: "setDate",
    formatter: function(t, e) {
      var i = new Date(e.getTime());
      return i.setDate(t), Bt.format(i, "d");
    },
    startValue: 1,
    endValue: void 0
  },
  month: {
    getter: "getMonth",
    setter: "setMonth",
    formatter: function(t) {
      return Bt.getMonthNames()[t];
    },
    startValue: 0,
    endValue: 11
  },
  hours: {
    getter: "getHours",
    setter: "setHours",
    formatter: function(t) {
      return Bt.format(new Date(0, 0, 0, t), "hour");
    },
    startValue: 0,
    endValue: 23
  },
  minutes: {
    getter: "getMinutes",
    setter: "setMinutes",
    formatter: function(t) {
      return Bt.format(new Date(0, 0, 0, 0, t), "minute");
    },
    startValue: 0,
    endValue: 59
  },
  seconds: {
    getter: "getSeconds",
    setter: "setSeconds",
    formatter: function(t) {
      return Bt.format(new Date(0, 0, 0, 0, 0, t), "second");
    },
    startValue: 0,
    endValue: 59
  },
  milliseconds: {
    getter: "getMilliseconds",
    setter: "setMilliseconds",
    formatter: function(t) {
      return Bt.format(new Date(0, 0, 0, 0, 0, 0, t), "millisecond");
    },
    startValue: 0,
    endValue: 999
  }
};
var VX = "dxSwipeable", Ybe = "dx-swipeable", qbe = {
  onStart: OI,
  onUpdated: RI,
  onEnd: wS,
  onCancel: "dxswipecancel"
}, Xbe = 180, GT = Nu.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      elastic: !0,
      immediate: !1,
      immediateTimeout: Xbe,
      direction: "horizontal",
      itemSizeFunc: null,
      onStart: null,
      onUpdated: null,
      onEnd: null,
      onCancel: null
    });
  },
  _render: function() {
    this.callBase(), this.$element().addClass(Ybe), this._attachEventHandlers();
  },
  _attachEventHandlers: function() {
    if (this._detachEventHandlers(), !this.option("disabled")) {
      var t = this.NAME;
      this._createEventData(), N(qbe, (function(e, i) {
        var r = this._createActionByOption(e, {
          context: this
        });
        i = ve(i, t), k.on(this.$element(), i, this._eventData, function(n) {
          return r({
            event: n
          });
        });
      }).bind(this));
    }
  },
  _createEventData: function() {
    this._eventData = {
      elastic: this.option("elastic"),
      itemSizeFunc: this.option("itemSizeFunc"),
      direction: this.option("direction"),
      immediate: this.option("immediate"),
      immediateTimeout: this.option("immediateTimeout")
    };
  },
  _detachEventHandlers: function() {
    k.off(this.$element(), "." + VX);
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "disabled":
      case "onStart":
      case "onUpdated":
      case "onEnd":
      case "onCancel":
      case "elastic":
      case "immediate":
      case "itemSizeFunc":
      case "direction":
        this._detachEventHandlers(), this._attachEventHandlers();
        break;
      case "rtlEnabled":
        break;
      default:
        this.callBase(t);
    }
  },
  _useTemplates: function() {
    return !1;
  }
});
Xx(GT, VX);
var Qbe = "dx-calendar-navigator", Zbe = "dx-calendar-navigator-previous-month", Jbe = "dx-calendar-navigator-next-month", ewe = "dx-calendar-navigator-previous-view", twe = "dx-calendar-navigator-next-view", iwe = "dx-calendar-disabled-navigator-link", rwe = "dx-calendar-caption-button", nwe = "dx-button-text";
class awe extends xn {
  _getDefaultOptions() {
    return P(super._getDefaultOptions(), {
      onClick: null,
      onCaptionClick: null,
      type: "normal",
      stylingMode: "outlined",
      text: ""
    });
  }
  _defaultOptionsRules() {
    return super._defaultOptionsRules().concat([{
      device: function() {
        return _a();
      },
      options: {
        type: "default",
        stylingMode: "text"
      }
    }, {
      device: function() {
        return za();
      },
      options: {
        type: "normal",
        stylingMode: "text"
      }
    }]);
  }
  _init() {
    super._init(), this._initActions();
  }
  _initActions() {
    this._clickAction = this._createActionByOption("onClick"), this._captionClickAction = this._createActionByOption("onCaptionClick");
  }
  _initMarkup() {
    super._initMarkup(), this.$element().addClass(Qbe), this._renderButtons(), this._renderCaption();
  }
  _renderButtons() {
    var {
      rtlEnabled: e,
      type: i,
      stylingMode: r,
      focusStateEnabled: n
    } = this.option();
    this._prevButton = this._createComponent(E("<div>"), yn, {
      focusStateEnabled: n,
      icon: e ? "chevronright" : "chevronleft",
      onClick: (c) => {
        this._clickAction({
          direction: -1,
          event: c
        });
      },
      type: i,
      stylingMode: r,
      integrationOptions: {}
    });
    var a = this._prevButton.$element().addClass(ewe).addClass(Zbe);
    this._nextButton = this._createComponent(E("<div>"), yn, {
      focusStateEnabled: n,
      icon: e ? "chevronleft" : "chevronright",
      onClick: (c) => {
        this._clickAction({
          direction: 1,
          event: c
        });
      },
      type: i,
      stylingMode: r,
      integrationOptions: {}
    });
    var o = this._nextButton.$element().addClass(twe).addClass(Jbe);
    this._caption = this._createComponent(E("<div>").addClass(rwe), yn, {
      focusStateEnabled: n,
      onClick: (c) => {
        this._captionClickAction({
          event: c
        });
      },
      type: i,
      stylingMode: r,
      template: (c, p) => {
        var {
          text: v
        } = this.option(), _ = v.split(" - ");
        _.forEach((y) => {
          E(p).append(E("<span>").addClass(nwe).text(y));
        });
      },
      integrationOptions: {}
    });
    var u = this._caption.$element();
    this.$element().append(a, u, o);
  }
  _renderCaption() {
    this._caption.option("text", this.option("text"));
  }
  toggleButton(e, i) {
    var r = "_" + e + "Button", n = this[r];
    n && (n.option("disabled", i), n.$element().toggleClass(iwe, i));
  }
  _optionChanged(e) {
    switch (e.name) {
      case "text":
        this._renderCaption();
        break;
      default:
        super._optionChanged(e);
    }
  }
}
var {
  abstract: yu
} = xn, owe = "dx-calendar-other-view", _M = "dx-calendar-cell", swe = "dx-calendar-cell-start", lwe = "dx-calendar-cell-end", uwe = "dx-calendar-cell-start-in-row", dwe = "dx-calendar-cell-end-in-row", NX = "dx-calendar-week-number-cell", CM = "dx-calendar-empty-cell", cwe = "dx-calendar-today", $4 = "dx-calendar-selected-date", z4 = "dx-calendar-cell-in-range", yM = "dx-calendar-cell-range-hover", xM = "dx-calendar-cell-range-hover-start", SM = "dx-calendar-cell-range-hover-end", W4 = "dx-calendar-range-start-date", U4 = "dx-calendar-range-end-date", EM = "dx-calendar-contoured-date", G4 = "td:not(.".concat(NX, ")"), bM = ve(di, "dxCalendar"), K4 = ve(uS, "dxCalendar"), By = "dxDateValueKey", hwe = 864e5, gw = xn.inherit({
  _getViewName: function() {
    return "base";
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      date: /* @__PURE__ */ new Date(),
      focusStateEnabled: !1,
      cellTemplate: null,
      disabledDates: null,
      onCellClick: null,
      onCellHover: null,
      onWeekNumberClick: null,
      rowCount: 3,
      colCount: 4,
      allowValueSelection: !0,
      _todayDate: () => /* @__PURE__ */ new Date()
    });
  },
  _initMarkup: function() {
    this.callBase(), this._renderImpl();
  },
  _renderImpl: function() {
    this.$element().append(this._createTable()), this._createDisabledDatesHandler(), this._renderBody(), this._renderContouredDate(), this._renderValue(), this._renderRange(), this._renderEvents();
  },
  _createTable: function() {
    this._$table = E("<table>");
    var t = X.format("dxCalendar-ariaWidgetName");
    return this.setAria({
      label: t,
      role: "grid"
    }, this._$table), this._$table;
  },
  _renderBody: function() {
    this.$body = E("<tbody>").appendTo(this._$table);
    for (var t = {
      cellDate: this._getFirstCellData(),
      prevCellDate: null
    }, e = 0, i = this.option("rowCount"); e < i; e++) {
      t.row = this._createRow();
      for (var r = 0, n = this.option("colCount"); r < n; r++)
        this._renderCell(t, r);
      this._renderWeekNumberCell(t);
    }
  },
  _createRow: function() {
    var t = de.createElement("tr");
    return this.setAria("role", "row", E(t)), this.$body.get(0).appendChild(t), t;
  },
  _createCell: function(t, e) {
    var i = de.createElement("td"), r = E(i);
    return i.className = this._getClassNameByDate(t, e), i.setAttribute("data-value", $r.serializeDate(t, Ke.getShortDateFormat())), dr(i, By, t), this.setAria({
      role: "gridcell",
      label: this.getCellAriaLabel(t)
    }, r), {
      cell: i,
      $cell: r
    };
  },
  _renderCell: function(t, e) {
    var {
      cellDate: i,
      prevCellDate: r,
      row: n
    } = t;
    r && Ke.fixTimezoneGap(r, i), t.prevCellDate = i;
    var {
      cell: a,
      $cell: o
    } = this._createCell(i, e), u = this.option("cellTemplate");
    E(n).append(a), u ? u.render(this._prepareCellTemplateData(i, e, o)) : a.innerHTML = this._getCellText(i), t.cellDate = this._getNextCellData(i);
  },
  _getClassNameByDate: function(t, e) {
    var i = _M;
    return this._isTodayCell(t) && (i += " ".concat(cwe)), (this._isDateOutOfRange(t) || this.isDateDisabled(t)) && (i += " ".concat(CM)), this._isOtherView(t) && (i += " ".concat(owe)), this.option("selectionMode") === "range" && (e === 0 && (i += " ".concat(uwe)), e === this.option("colCount") - 1 && (i += " ".concat(dwe)), this._isStartDayOfMonth(t) && (i += " ".concat(swe)), this._isEndDayOfMonth(t) && (i += " ".concat(lwe))), i;
  },
  _prepareCellTemplateData: function(t, e, i) {
    var r = t instanceof Date, n = r ? this._getCellText(t) : t, a = r ? t : void 0, o = this._getViewName();
    return {
      model: {
        text: n,
        date: a,
        view: o
      },
      container: ot(i),
      index: e
    };
  },
  _renderEvents: function() {
    this._createCellClickAction(), k.off(this._$table, bM), k.on(this._$table, bM, G4, (e) => {
      E(e.currentTarget).hasClass(CM) || this._cellClickAction({
        event: e,
        value: E(e.currentTarget).data(By)
      });
    });
    var {
      selectionMode: t
    } = this.option();
    k.off(this._$table, K4), t === "range" && (this._createCellHoverAction(), k.on(this._$table, K4, G4, (e) => {
      E(e.currentTarget).hasClass(CM) || this._cellHoverAction({
        event: e,
        value: E(e.currentTarget).data(By)
      });
    })), t !== "single" && (this._createWeekNumberCellClickAction(), k.on(this._$table, bM, ".".concat(NX), (e) => {
      var i = E(e.currentTarget).closest("tr"), r = i.find(".".concat(_M)).first().data(By), n = i.find(".".concat(_M)).last().data(By), a = [...Ke.getDatesOfInterval(r, n, hwe), n];
      this._weekNumberCellClickAction({
        event: e,
        rowDates: a
      });
    }));
  },
  _createCellClickAction: function() {
    this._cellClickAction = this._createActionByOption("onCellClick");
  },
  _createCellHoverAction: function() {
    this._cellHoverAction = this._createActionByOption("onCellHover");
  },
  _createWeekNumberCellClickAction: function() {
    this._weekNumberCellClickAction = this._createActionByOption("onWeekNumberClick");
  },
  _createDisabledDatesHandler: function() {
    var t = this.option("disabledDates");
    this._disabledDatesHandler = Array.isArray(t) ? this._getDefaultDisabledDatesHandler(t) : t || ee;
  },
  _getDefaultDisabledDatesHandler: function(t) {
    return ee;
  },
  _isTodayCell: yu,
  _isDateOutOfRange: yu,
  isDateDisabled: function(t) {
    var e = {
      date: t,
      view: this._getViewName()
    };
    return this._disabledDatesHandler(e);
  },
  _isOtherView: yu,
  _isStartDayOfMonth: yu,
  _isEndDayOfMonth: yu,
  _getCellText: yu,
  _getFirstCellData: yu,
  _getNextCellData: yu,
  _renderContouredDate: function(t) {
    if (this.option("focusStateEnabled")) {
      t = t || this.option("contouredDate");
      var e = this._getContouredCell(), i = this._getCellByDate(t);
      e.removeClass(EM), t && i.addClass(EM);
    }
  },
  _getContouredCell: function() {
    return this._$table.find(".".concat(EM));
  },
  _renderValue: function() {
    if (this.option("allowValueSelection")) {
      var t = this.option("value");
      Array.isArray(t) || (t = [t]), this._updateSelectedClass(t);
    }
  },
  _updateSelectedClass: function(t) {
    var e;
    this._isRangeMode() && !this._isMonthView() || ((e = this._$selectedCells) === null || e === void 0 || e.forEach((i) => {
      i.removeClass($4);
    }), this._$selectedCells = t.map((i) => this._getCellByDate(i)), this._$selectedCells.forEach((i) => {
      i.addClass($4);
    }));
  },
  _renderRange: function() {
    var t, e, i, r, n, a, o, u, {
      allowValueSelection: c,
      value: p,
      range: v
    } = this.option();
    !c || !this._isRangeMode() || !this._isMonthView() || ((t = this._$rangeCells) === null || t === void 0 || t.forEach((_) => {
      _.removeClass(z4);
    }), (e = this._$hoveredRangeCells) === null || e === void 0 || e.forEach((_) => {
      _.removeClass(yM);
    }), (i = this._$rangeStartHoverCell) === null || i === void 0 || i.removeClass(xM), (r = this._$rangeEndHoverCell) === null || r === void 0 || r.removeClass(SM), (n = this._$rangeStartDateCell) === null || n === void 0 || n.removeClass(W4), (a = this._$rangeEndDateCell) === null || a === void 0 || a.removeClass(U4), this._$rangeCells = v.map((_) => this._getCellByDate(_)), this._$rangeStartDateCell = this._getCellByDate(p[0]), this._$rangeEndDateCell = this._getCellByDate(p[1]), this._$rangeCells.forEach((_) => {
      _.addClass(z4);
    }), (o = this._$rangeStartDateCell) === null || o === void 0 || o.addClass(W4), (u = this._$rangeEndDateCell) === null || u === void 0 || u.addClass(U4));
  },
  _renderHoveredRange() {
    var t, e, i, r, n, {
      allowValueSelection: a,
      hoveredRange: o
    } = this.option();
    !a || !this._isRangeMode() || !this._isMonthView() || ((t = this._$hoveredRangeCells) === null || t === void 0 || t.forEach((u) => {
      u.removeClass(yM);
    }), (e = this._$rangeStartHoverCell) === null || e === void 0 || e.removeClass(xM), (i = this._$rangeEndHoverCell) === null || i === void 0 || i.removeClass(SM), this._$hoveredRangeCells = o.map((u) => this._getCellByDate(u)), this._$rangeStartHoverCell = this._getCellByDate(o[0]), this._$rangeEndHoverCell = this._getCellByDate(o[o.length - 1]), this._$hoveredRangeCells.forEach((u) => {
      u.addClass(yM);
    }), (r = this._$rangeStartHoverCell) === null || r === void 0 || r.addClass(xM), (n = this._$rangeEndHoverCell) === null || n === void 0 || n.addClass(SM));
  },
  _isMonthView: function() {
    return this.option("zoomLevel") === "month";
  },
  _isRangeMode: function() {
    return this.option("selectionMode") === "range";
  },
  getCellAriaLabel: function(t) {
    return this._getCellText(t);
  },
  _getFirstAvailableDate: function() {
    var t = this.option("date"), e = this.option("min");
    return t = Ke.getViewFirstCellDate(this._getViewName(), t), new Date(e && t < e ? e : t);
  },
  _getCellByDate: yu,
  isBoundary: yu,
  _optionChanged: function(t) {
    var {
      name: e,
      value: i
    } = t;
    switch (e) {
      case "value":
        this._renderValue();
        break;
      case "range":
        this._renderRange();
        break;
      case "hoveredRange":
        this._renderHoveredRange();
        break;
      case "contouredDate":
        this._renderContouredDate(i);
        break;
      case "onCellClick":
        this._createCellClickAction();
        break;
      case "onCellHover":
        this._createCellHoverAction();
        break;
      case "min":
      case "max":
      case "disabledDates":
      case "cellTemplate":
      case "selectionMode":
        this._invalidate();
        break;
      case "_todayDate":
        this._renderBody();
        break;
      default:
        this.callBase(t);
    }
  }
}), fwe = "dx-calendar-other-month", pwe = "dx-calendar-other-view", vwe = "dx-calendar-week-number-cell", gwe = "dx-calendar-week-selection", mwe = {
  month: gw.inherit({
    _getViewName: function() {
      return "month";
    },
    _getDefaultOptions: function() {
      return P(this.callBase(), {
        firstDayOfWeek: 0,
        rowCount: 6,
        colCount: 7
      });
    },
    _renderImpl: function() {
      this.callBase(), this._renderHeader();
    },
    _renderBody: function() {
      this.callBase(), this._$table.find(".".concat(pwe)).addClass(fwe);
    },
    _renderFocusTarget: ee,
    getCellAriaLabel: function(t) {
      return Bt.format(t, "longdate");
    },
    _renderHeader: function() {
      var t = E("<tr>"), e = E("<thead>").append(t);
      this._$table.prepend(e);
      for (var i = 0, r = this.option("colCount"); i < r; i++)
        this._renderHeaderCell(i, t);
      this.option("showWeekNumbers") && this._renderWeekHeaderCell(t);
    },
    _renderHeaderCell: function(t, e) {
      var {
        firstDayOfWeek: i
      } = this.option(), {
        full: r,
        abbreviated: n
      } = this._getDayCaption(i + t), a = E("<th>").attr({
        scope: "col",
        abbr: r
      }).text(n);
      e.append(a);
    },
    _renderWeekHeaderCell: function(t) {
      var e = E("<th>").attr({
        scope: "col",
        abbr: "WeekNumber",
        class: "dx-week-number-header"
      });
      t.prepend(e);
    },
    _renderWeekNumberCell: function(t) {
      var {
        showWeekNumbers: e,
        cellTemplate: i,
        selectionMode: r,
        selectWeekOnClick: n
      } = this.option();
      if (e) {
        var a = this._getWeekNumber(t.prevCellDate), o = de.createElement("td"), u = E(o);
        o.className = vwe, r !== "single" && n && u.addClass(gwe), i ? i.render(this._prepareCellTemplateData(a, -1, u)) : o.innerHTML = a, t.row.prepend(o), this.setAria({
          role: "gridcell",
          label: "Week ".concat(a)
        }, u);
      }
    },
    _getWeekNumber: function(t) {
      var {
        weekNumberRule: e,
        firstDayOfWeek: i
      } = this.option();
      return e === "auto" ? Ke.getWeekNumber(t, i, i === 1 ? "firstFourDays" : "firstDay") : Ke.getWeekNumber(t, i, e);
    },
    getNavigatorCaption: function() {
      return Bt.format(this.option("date"), "monthandyear");
    },
    _isTodayCell: function(t) {
      var e = this.option("_todayDate")();
      return Ke.sameDate(t, e);
    },
    _isDateOutOfRange: function(t) {
      var e = this.option("min"), i = this.option("max");
      return !Ke.dateInRange(t, e, i, "date");
    },
    _isOtherView: function(t) {
      return t.getMonth() !== this.option("date").getMonth();
    },
    _isStartDayOfMonth: function(t) {
      return Ke.sameDate(t, Ke.getFirstMonthDate(this.option("date")));
    },
    _isEndDayOfMonth: function(t) {
      return Ke.sameDate(t, Ke.getLastMonthDate(this.option("date")));
    },
    _getCellText: function(t) {
      return Bt.format(t, "d");
    },
    _getDayCaption: function(t) {
      var e = this.option("colCount"), i = t % e;
      return {
        full: Bt.getDayNames()[i],
        abbreviated: Bt.getDayNames("abbreviated")[i]
      };
    },
    _getFirstCellData: function() {
      var {
        firstDayOfWeek: t
      } = this.option(), e = Ke.getFirstMonthDate(this.option("date")), i = t - e.getDay(), r = this.option("colCount");
      return i >= 0 && (i -= r), e.setDate(e.getDate() + i), e;
    },
    _getNextCellData: function(t) {
      return t = new Date(t), t.setDate(t.getDate() + 1), t;
    },
    _getCellByDate: function(t) {
      return this._$table.find("td[data-value='".concat($r.serializeDate(t, Ke.getShortDateFormat()), "']"));
    },
    isBoundary: function(t) {
      return Ke.sameMonthAndYear(t, this.option("min")) || Ke.sameMonthAndYear(t, this.option("max"));
    },
    _getDefaultDisabledDatesHandler: function(t) {
      return function(e) {
        var i = t.some(function(r) {
          return Ke.sameDate(r, e.date);
        });
        if (i)
          return !0;
      };
    }
  }),
  year: gw.inherit({
    _getViewName: function() {
      return "year";
    },
    _isTodayCell: function(t) {
      var e = this.option("_todayDate")();
      return Ke.sameMonthAndYear(t, e);
    },
    _isDateOutOfRange: function(t) {
      return !Ke.dateInRange(t, Ke.getFirstMonthDate(this.option("min")), Ke.getLastMonthDate(this.option("max")));
    },
    _isOtherView: function() {
      return !1;
    },
    _isStartDayOfMonth: function() {
      return !1;
    },
    _isEndDayOfMonth: function() {
      return !1;
    },
    _getCellText: function(t) {
      return Bt.getMonthNames("abbreviated")[t.getMonth()];
    },
    _getFirstCellData: function() {
      var t = this.option("date"), e = new Date(t);
      return e.setDate(1), e.setMonth(0), e;
    },
    _getNextCellData: function(t) {
      return t = new Date(t), t.setMonth(t.getMonth() + 1), t;
    },
    _getCellByDate: function(t) {
      var e = new Date(t);
      return e.setDate(1), this._$table.find("td[data-value='".concat($r.serializeDate(e, Ke.getShortDateFormat()), "']"));
    },
    getCellAriaLabel: function(t) {
      return Bt.format(t, "monthandyear");
    },
    getNavigatorCaption: function() {
      return Bt.format(this.option("date"), "yyyy");
    },
    isBoundary: function(t) {
      return Ke.sameYear(t, this.option("min")) || Ke.sameYear(t, this.option("max"));
    },
    _renderWeekNumberCell: ee
  }),
  decade: gw.inherit({
    _getViewName: function() {
      return "decade";
    },
    _isTodayCell: function(t) {
      var e = this.option("_todayDate")();
      return Ke.sameYear(t, e);
    },
    _isDateOutOfRange: function(t) {
      var e = this.option("min"), i = this.option("max");
      return !Ke.dateInRange(t.getFullYear(), e && e.getFullYear(), i && i.getFullYear());
    },
    _isOtherView: function(t) {
      var e = new Date(t);
      return e.setMonth(1), !Ke.sameDecade(e, this.option("date"));
    },
    _isStartDayOfMonth: function() {
      return !1;
    },
    _isEndDayOfMonth: function() {
      return !1;
    },
    _getCellText: function(t) {
      return Bt.format(t, "yyyy");
    },
    _getFirstCellData: function() {
      var t = Ke.getFirstYearInDecade(this.option("date")) - 1;
      return Ke.createDateWithFullYear(t, 0, 1);
    },
    _getNextCellData: function(t) {
      return t = new Date(t), t.setFullYear(t.getFullYear() + 1), t;
    },
    getNavigatorCaption: function() {
      var t = this.option("date"), e = Ke.getFirstYearInDecade(t), i = new Date(t), r = new Date(t);
      return i.setFullYear(e), r.setFullYear(e + 9), Bt.format(i, "yyyy") + "-" + Bt.format(r, "yyyy");
    },
    _isValueOnCurrentView: function(t, e) {
      return Ke.sameDecade(t, e);
    },
    _getCellByDate: function(t) {
      var e = new Date(t);
      return e.setDate(1), e.setMonth(0), this._$table.find("td[data-value='".concat($r.serializeDate(e, Ke.getShortDateFormat()), "']"));
    },
    isBoundary: function(t) {
      return Ke.sameDecade(t, this.option("min")) || Ke.sameDecade(t, this.option("max"));
    },
    _renderWeekNumberCell: ee
  }),
  century: gw.inherit({
    _getViewName: function() {
      return "century";
    },
    _isTodayCell: function(t) {
      var e = this.option("_todayDate")();
      return Ke.sameDecade(t, e);
    },
    _isDateOutOfRange: function(t) {
      var e = Ke.getFirstYearInDecade(t), i = Ke.getFirstYearInDecade(this.option("min")), r = Ke.getFirstYearInDecade(this.option("max"));
      return !Ke.dateInRange(e, i, r);
    },
    _isOtherView: function(t) {
      var e = new Date(t);
      return e.setMonth(1), !Ke.sameCentury(e, this.option("date"));
    },
    _isStartDayOfMonth: function() {
      return !1;
    },
    _isEndDayOfMonth: function() {
      return !1;
    },
    _getCellText: function(t) {
      var e = Bt.format(t, "yyyy"), i = new Date(t);
      return i.setFullYear(i.getFullYear() + 9), e + " - " + Bt.format(i, "yyyy");
    },
    _getFirstCellData: function() {
      var t = Ke.getFirstDecadeInCentury(this.option("date")) - 10;
      return Ke.createDateWithFullYear(t, 0, 1);
    },
    _getNextCellData: function(t) {
      return t = new Date(t), t.setFullYear(t.getFullYear() + 10), t;
    },
    _getCellByDate: function(t) {
      var e = new Date(t);
      return e.setDate(1), e.setMonth(0), e.setFullYear(Ke.getFirstYearInDecade(e)), this._$table.find("td[data-value='".concat($r.serializeDate(e, Ke.getShortDateFormat()), "']"));
    },
    getNavigatorCaption: function() {
      var t = this.option("date"), e = Ke.getFirstDecadeInCentury(t), i = new Date(t), r = new Date(t);
      return i.setFullYear(e), r.setFullYear(e + 99), Bt.format(i, "yyyy") + "-" + Bt.format(r, "yyyy");
    },
    isBoundary: function(t) {
      return Ke.sameCentury(t, this.option("min")) || Ke.sameCentury(t, this.option("max"));
    },
    _renderWeekNumberCell: ee
  })
};
class jB {
  constructor(e) {
    this.calendar = e;
  }
  dateOption(e) {
    return this.calendar._dateOption(e);
  }
  dateValue(e, i) {
    this.calendar._dateValue(e, i);
  }
  skipNavigate() {
    this.calendar._skipNavigate = !0;
  }
  updateAriaSelected(e, i) {
    this.calendar._updateAriaSelected(e, i), e[0] && this.calendar.option("currentDate").getTime() === e[0].getTime() && this.calendar._updateAriaId(e[0]);
  }
  processValueChanged(e, i) {
    var r, n;
    R(e) && !Array.isArray(e) && (e = [e]), R(i) && !Array.isArray(i) && (i = [i]), e = ((r = e) === null || r === void 0 ? void 0 : r.map((a) => this._convertToDate(a))) || [], i = ((n = i) === null || n === void 0 ? void 0 : n.map((a) => this._convertToDate(a))) || [], this._updateViewsValue(e), this.updateAriaSelected(e, i), this._currentDateChanged || this.calendar._initCurrentDate(), this._currentDateChanged = !1;
  }
  _isDateDisabled(e) {
    var i = this.calendar._dateOption("min"), r = this.calendar._dateOption("max"), n = R(i) && e < i && !Ke.sameDate(i, e), a = R(r) && e > r && !Ke.sameDate(r, e);
    return this.calendar._view.isDateDisabled(e) || n || a;
  }
  _getLowestDateInArray(e) {
    if (e.length)
      return new Date(Math.min(...e));
  }
  _convertToDate(e) {
    return this.calendar._convertToDate(e);
  }
  _isMaxZoomLevel() {
    return this.calendar._isMaxZoomLevel();
  }
  _updateViewsOption(e, i) {
    this.calendar._updateViewsOption(e, i);
  }
  _updateViewsValue(e) {
    this._updateViewsOption("value", e);
  }
  _updateCurrentDate(e) {
    this.calendar.option("currentDate", e ?? /* @__PURE__ */ new Date());
  }
  _shouldHandleWeekNumberClick() {
    var {
      selectionMode: e,
      selectWeekOnClick: i
    } = this.calendar.option();
    return i && e !== "single";
  }
}
class _we extends jB {
  constructor(e) {
    super(e), this.NAME = "SingleSelection";
  }
  getViewOptions() {
    return {
      value: this.dateOption("value"),
      range: [],
      selectionMode: "single"
    };
  }
  selectValue(e, i) {
    this.skipNavigate(), this.dateValue(e, i);
  }
  updateAriaSelected(e, i) {
    var r, n;
    (r = e) !== null && r !== void 0 || (e = [this.dateOption("value")]), (n = i) !== null && n !== void 0 || (i = []), super.updateAriaSelected(e, i);
  }
  getDefaultCurrentDate() {
    return this.dateOption("value");
  }
  restoreValue() {
    this.calendar.option("value", null);
  }
  _updateViewsValue(e) {
    this._updateViewsOption("value", e[0]);
  }
}
class Cwe extends jB {
  constructor(e) {
    super(e), this.NAME = "MultiSelection";
  }
  getViewOptions() {
    return {
      value: this.dateOption("value"),
      range: [],
      selectionMode: "multi",
      onWeekNumberClick: this._shouldHandleWeekNumberClick() ? this._weekNumberClickHandler.bind(this) : null
    };
  }
  selectValue(e, i) {
    var r = [...this.dateOption("value")], n = r.findIndex((a) => (a == null ? void 0 : a.toDateString()) === e.toDateString());
    n > -1 ? r.splice(n, 1) : r.push(e), this.skipNavigate(), this._updateCurrentDate(e), this._currentDateChanged = !0, this.dateValue(r, i);
  }
  updateAriaSelected(e, i) {
    var r, n;
    (r = e) !== null && r !== void 0 || (e = this.dateOption("value")), (n = i) !== null && n !== void 0 || (i = []), super.updateAriaSelected(e, i);
  }
  getDefaultCurrentDate() {
    var e = this.dateOption("value").filter((i) => i);
    return this._getLowestDateInArray(e);
  }
  restoreValue() {
    this.calendar.option("value", []);
  }
  _weekNumberClickHandler(e) {
    var {
      rowDates: i,
      event: r
    } = e, n = i.filter((a) => !this._isDateDisabled(a));
    this.dateValue(n, r);
  }
}
var ywe = 864e5;
class xwe extends jB {
  constructor(e) {
    super(e), this.NAME = "RangeSelection";
  }
  getViewOptions() {
    var e = this._getValue(), i = this._getDaysInRange(e[0], e[1]);
    return {
      value: e,
      range: i,
      selectionMode: "range",
      onCellHover: this._cellHoverHandler.bind(this),
      onWeekNumberClick: this._shouldHandleWeekNumberClick() ? this._weekNumberClickHandler.bind(this) : null
    };
  }
  selectValue(e, i) {
    var [r, n] = this._getValue();
    this.skipNavigate(), this._updateCurrentDate(e), this._currentDateChanged = !0, this.calendar.option("_allowChangeSelectionOrder") === !0 ? (this.calendar._valueSelected = !0, this.calendar.option("_currentSelection") === "startDate" ? this.calendar._convertToDate(e) > this.calendar._convertToDate(n) ? this.dateValue([e, null], i) : this.dateValue([e, n], i) : this.calendar._convertToDate(e) >= this.calendar._convertToDate(r) ? this.dateValue([r, e], i) : this.dateValue([e, null], i)) : !r || n ? this.dateValue([e, null], i) : this.dateValue(r < e ? [r, e] : [e, r], i);
  }
  updateAriaSelected(e, i) {
    var r, n;
    (r = e) !== null && r !== void 0 || (e = this._getValue()), (n = i) !== null && n !== void 0 || (i = []), super.updateAriaSelected(e, i);
  }
  processValueChanged(e, i) {
    super.processValueChanged(e, i);
    var r = this._getRange();
    this._updateViewsOption("range", r);
  }
  getDefaultCurrentDate() {
    var {
      _allowChangeSelectionOrder: e,
      _currentSelection: i
    } = this.calendar.option(), r = this.dateOption("value");
    if (e) {
      if (i === "startDate" && r[0])
        return r[0];
      if (i === "endDate" && r[1])
        return r[1];
    }
    var n = r.filter((a) => a);
    return this._getLowestDateInArray(n);
  }
  restoreValue() {
    this.calendar.option("value", [null, null]);
  }
  _getValue() {
    var e = this.dateOption("value");
    if (!e.length)
      return e;
    var [i, r] = e;
    return i && r && i > r && ([i, r] = [r, i]), [i, r];
  }
  _getRange() {
    var [e, i] = this._getValue();
    return this._getDaysInRange(e, i);
  }
  _getDaysInRange(e, i) {
    if (!e || !i)
      return [];
    var {
      currentDate: r,
      viewsCount: n
    } = this.calendar.option(), a = this.calendar._isAdditionalViewDate(r), o = Ke.getFirstMonthDate(Ke.addDateInterval(r, "month", a ? -2 : -1)), u = Ke.getLastMonthDate(Ke.addDateInterval(r, "month", a ? 1 : n)), c = new Date(Math.max(o, e)), p = new Date(Math.min(u, i));
    return [...Ke.getDatesOfInterval(c, p, ywe), p];
  }
  _cellHoverHandler(e) {
    var i = this._isMaxZoomLevel(), [r, n] = this._getValue(), {
      _allowChangeSelectionOrder: a,
      _currentSelection: o
    } = this.calendar.option();
    if (i) {
      var u = a && o === "startDate";
      if (r && !n && !u) {
        if (e.value > r) {
          this._updateViewsOption("hoveredRange", this._getDaysInRange(r, e.value));
          return;
        }
      } else if (!r && n && !(a && o === "endDate")) {
        if (e.value < n) {
          this._updateViewsOption("hoveredRange", this._getDaysInRange(e.value, n));
          return;
        }
      } else if (r && n) {
        if (o === "startDate" && e.value < r) {
          this._updateViewsOption("hoveredRange", this._getDaysInRange(e.value, r));
          return;
        } else if (o === "endDate" && e.value > n) {
          this._updateViewsOption("hoveredRange", this._getDaysInRange(n, e.value));
          return;
        }
      }
      this._updateViewsOption("hoveredRange", []);
    }
  }
  _weekNumberClickHandler(e) {
    var {
      rowDates: i,
      event: r
    } = e, n = i.filter((o) => !this._isDateDisabled(o)), a = n.length ? [n[0], n[n.length - 1]] : [null, null];
    this.dateValue(a, r);
  }
}
var wM = "dx-calendar", Swe = "dx-calendar-body", Ewe = "dx-calendar-cell", bwe = "dx-calendar-footer", wwe = "dx-calendar-today-button", Twe = "dx-calendar-with-footer", Iwe = "dx-calendar-views-wrapper", j4 = "dx-calendar-view", Dwe = "dx-calendar-multiview", Awe = "dx-calendar-range", Owe = "dx-gesture-cover", mw = 250, Y4 = 0.6, q4 = 1, Rwe = "yyyy-MM-dd", Lwe = "dxDateValueKey", X4 = ve(dS, "dxCalendar"), em = {
  month: 3,
  year: 2,
  decade: 1,
  century: 0
}, Zn = {
  MONTH: "month",
  YEAR: "year",
  DECADE: "decade",
  CENTURY: "century"
}, Mwe = {
  SingleSelection: _we,
  MultipleSelection: Cwe,
  RangeSelection: xwe
}, HX = Fl.inherit({
  _activeStateUnit: "." + Ewe,
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      hoverStateEnabled: !0,
      activeStateEnabled: !0,
      currentDate: /* @__PURE__ */ new Date(),
      value: null,
      dateSerializationFormat: void 0,
      min: new Date(1e3, 0),
      max: new Date(3e3, 0),
      firstDayOfWeek: void 0,
      viewsCount: 1,
      zoomLevel: Zn.MONTH,
      maxZoomLevel: Zn.MONTH,
      minZoomLevel: Zn.CENTURY,
      selectionMode: "single",
      selectWeekOnClick: !0,
      showTodayButton: !1,
      showWeekNumbers: !1,
      weekNumberRule: "auto",
      cellTemplate: "cell",
      disabledDates: null,
      onCellClick: null,
      onContouredChanged: null,
      skipFocusCheck: !1,
      _todayDate: () => /* @__PURE__ */ new Date()
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: function() {
        return Ye.real().deviceType === "desktop" && !Ye.isSimulator();
      },
      options: {
        focusStateEnabled: !0
      }
    }]);
  },
  _supportedKeys: function() {
    return P(this.callBase(), {
      rightArrow: function(t) {
        t.preventDefault(), Cn(t) ? this._waitRenderView(1) : this._moveCurrentDateByOffset(1 * this._getRtlCorrection());
      },
      leftArrow: function(t) {
        t.preventDefault(), Cn(t) ? this._waitRenderView(-1) : this._moveCurrentDateByOffset(-1 * this._getRtlCorrection());
      },
      upArrow: function(t) {
        if (t.preventDefault(), Cn(t))
          this._navigateUp();
        else {
          if (ji.isAnimating(this._view.$element()))
            return;
          this._moveCurrentDateByOffset(-1 * this._view.option("colCount"));
        }
      },
      downArrow: function(t) {
        if (t.preventDefault(), Cn(t))
          this._navigateDown();
        else {
          if (ji.isAnimating(this._view.$element()))
            return;
          this._moveCurrentDateByOffset(1 * this._view.option("colCount"));
        }
      },
      home: function(t) {
        t.preventDefault();
        var e = this.option("zoomLevel"), i = this.option("currentDate"), r = this._dateOption("min");
        if (!this._view.isDateDisabled(i)) {
          var n = Ke.sameView(e, i, r) ? r : Ke.getViewFirstCellDate(e, i);
          this._moveToClosestAvailableDate(n);
        }
      },
      end: function(t) {
        t.preventDefault();
        var e = this.option("zoomLevel"), i = this.option("currentDate"), r = this._dateOption("max");
        if (!this._view.isDateDisabled(i)) {
          var n = Ke.sameView(e, i, r) ? r : Ke.getViewLastCellDate(e, i);
          this._moveToClosestAvailableDate(n);
        }
      },
      pageUp: function(t) {
        t.preventDefault(), this._waitRenderView(-1 * this._getRtlCorrection());
      },
      pageDown: function(t) {
        t.preventDefault(), this._waitRenderView(1 * this._getRtlCorrection());
      },
      tab: ee,
      enter: this._enterKeyHandler
    });
  },
  _enterKeyHandler: function(t) {
    if (!this._isMaxZoomLevel())
      this._navigateDown();
    else if (!this._view.isDateDisabled(this.option("currentDate"))) {
      var e = this._updateTimeComponent(this.option("currentDate"));
      this._selectionStrategy.selectValue(e, t);
    }
  },
  _getSerializationFormat: function(t) {
    var e = this.option(t || "value");
    if (this.option("dateSerializationFormat"))
      return this.option("dateSerializationFormat");
    if (Di(e))
      return "number";
    if (ht(e))
      return $r.getDateSerializationFormat(e);
  },
  _convertToDate: function(t) {
    return $r.deserializeDate(t);
  },
  _dateValue: function(t, e) {
    if (e) {
      if (e.type === "keydown") {
        var i = this._view._getContouredCell().get(0);
        e.target = i;
      }
      this._saveValueChangeEvent(e);
    }
    this._dateOption("value", t);
  },
  _dateOption: function(t, e) {
    var i = t === "value" && !this._isSingleMode(), r = this.option("value");
    if (arguments.length === 1)
      return i ? (r ?? []).map((o) => this._convertToDate(o)) : this._convertToDate(this.option(t));
    var n = this._getSerializationFormat(t), a = i ? (e == null ? void 0 : e.map((o) => $r.serializeDate(o, n))) || [] : $r.serializeDate(e, n);
    this.option(t, a);
  },
  _isSingleMode: function() {
    return this.option("selectionMode") === "single";
  },
  _shiftDate: function(t, e, i, r) {
    switch (t) {
      case Zn.MONTH:
        e.setDate(e.getDate() + i * r);
        break;
      case Zn.YEAR:
        e.setMonth(e.getMonth() + i * r);
        break;
      case Zn.DECADE:
        e.setFullYear(e.getFullYear() + i * r);
        break;
      case Zn.CENTURY:
        e.setFullYear(e.getFullYear() + 10 * i * r);
    }
  },
  _moveCurrentDateByOffset: function(t) {
    var e = this.option("currentDate"), i = new Date(e), r = this.option("zoomLevel");
    this._shiftDate(r, i, t, 1);
    for (var n = this._getMaxDate(), a = this._getMinDate(), o = this._areDatesInNeighborView(r, i, e), u = Ud(i, a, n) && o, c = new Date(i); u; ) {
      if (!this._view.isDateDisabled(c)) {
        i = c;
        break;
      }
      this._shiftDate(r, c, t, 1), o = this._areDatesInNeighborView(r, c, e), u = Ud(c, a, n) && o;
    }
    if (this._view.isDateDisabled(e) || this._view.isDateDisabled(i)) {
      var p = t > 0 ? 1 : -1, v = p === 1 ? this._isNextViewDisabled() : this._isPrevViewDisabled();
      v ? this._moveToClosestAvailableDate(i) : this._waitRenderView(p);
    } else
      this._skipNavigate = !0, this.option("currentDate", i);
  },
  _isNextViewDisabled() {
    return this._navigator._nextButton.option("disabled");
  },
  _isPrevViewDisabled() {
    return this._navigator._prevButton.option("disabled");
  },
  _areDatesInSameView(t, e, i) {
    switch (t) {
      case Zn.MONTH:
        return e.getMonth() === i.getMonth();
      case Zn.YEAR:
        return e.getYear() === i.getYear();
      case Zn.DECADE:
        return parseInt(e.getYear() / 10) === parseInt(i.getYear() / 10);
      case Zn.CENTURY:
        return parseInt(e.getYear() / 100) === parseInt(i.getYear() / 100);
    }
  },
  _areDatesInNeighborView(t, e, i) {
    switch (t) {
      case Zn.MONTH:
        return r = e.getMonth(), n = i.getMonth(), a = Math.abs(r - n), Math.min(a, 12 - a) <= 1;
      case Zn.YEAR:
        return Math.abs(e.getYear() - i.getYear()) <= 1;
      case Zn.DECADE:
        return Math.abs(e.getYear() - i.getYear()) <= 10;
      case Zn.CENTURY:
        return Math.abs(e.getYear() - i.getYear()) <= 100;
    }
    var r, n, a;
  },
  _moveToClosestAvailableDate: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.option("currentDate"), e = new Date(t), i = this.option("zoomLevel"), r = !this._isDateNotAvailable(e), n = r, a = r, o, u, c = new Date(e), p = new Date(e);
    do {
      if (n) {
        e = c;
        break;
      }
      if (a) {
        e = p;
        break;
      }
      this._shiftDate(i, c, 1, 1), this._shiftDate(i, p, 1, -1), o = this._areDatesInSameView(i, c, t), u = this._areDatesInSameView(i, p, t), n = o && !this._isDateNotAvailable(c), a = u && !this._isDateNotAvailable(p);
    } while (o || u);
    this.option("currentDate", e);
  },
  _isDateNotAvailable: function(t) {
    var e = this._getMaxDate(), i = this._getMinDate();
    return !Ud(t, i, e) || this._view.isDateDisabled(t);
  },
  _init: function() {
    this.callBase(), this._initSelectionStrategy(), this._correctZoomLevel(), this._initCurrentDate(), this._initActions();
  },
  _initSelectionStrategy: function() {
    var t = this._getSelectionStrategyName(), e = Mwe[t];
    (!this._selectionStrategy || this._selectionStrategy.NAME !== t) && (this._selectionStrategy = new e(this));
  },
  _refreshSelectionStrategy: function() {
    this._initSelectionStrategy(), this._selectionStrategy.restoreValue(), this._refresh();
  },
  _getSelectionStrategyName: function() {
    var t = this.option("selectionMode");
    switch (t) {
      case "multiple":
        return "MultipleSelection";
      case "range":
        return "RangeSelection";
      default:
        return "SingleSelection";
    }
  },
  _correctZoomLevel: function() {
    var t = this.option("minZoomLevel"), e = this.option("maxZoomLevel"), i = this.option("zoomLevel");
    em[e] < em[t] || (em[i] > em[e] ? this.option("zoomLevel", e) : em[i] < em[t] && this.option("zoomLevel", t));
  },
  _initCurrentDate: function() {
    var t, e = (t = this._getNormalizedDate(this._selectionStrategy.getDefaultCurrentDate())) !== null && t !== void 0 ? t : this._getNormalizedDate(this.option("currentDate"));
    this.option("currentDate", e);
  },
  _getNormalizedDate: function(t) {
    return t = Ke.normalizeDate(t, this._getMinDate(), this._getMaxDate()), R(t) ? this._getDate(t) : t;
  },
  _initActions: function() {
    this._cellClickAction = this._createActionByOption("onCellClick"), this._onContouredChanged = this._createActionByOption("onContouredChanged");
  },
  _initTemplates: function() {
    this._templateManager.addDefaultTemplates({
      cell: new Lm(function(t) {
        var e = t.model;
        E(t.container).append(E("<span>").text(e && e.text || String(e)));
      })
    }), this.callBase();
  },
  _updateCurrentDate: function(t) {
    ji.isAnimating(this._$viewsWrapper) && ji.stop(this._$viewsWrapper, !0);
    var e = this._getMinDate(), i = this._getMaxDate();
    if (e > i) {
      this.option("currentDate", /* @__PURE__ */ new Date());
      return;
    }
    var r = this._getNormalizedDate(t);
    if (t.getTime() !== r.getTime()) {
      this.option("currentDate", new Date(r));
      return;
    }
    var n = this._getViewsOffset(this._view.option("date"), r);
    n !== 0 && !this._isMaxZoomLevel() && this._isOtherViewCellClicked && (n = 0), this._view && n !== 0 && !this._suppressNavigation ? this._additionalView ? n > 2 || n < -1 ? (this._refreshViews(), this._setViewContoured(r), this._updateAriaId(r), this._renderNavigator()) : n === 1 && this._skipNavigate ? (this._setViewContoured(r), this._updateAriaId(r)) : this._navigate(n, r) : this._navigate(n, r) : (this._renderNavigator(), this._setViewContoured(r), this._updateAriaId(r)), this._skipNavigate = !1;
  },
  _isAdditionalViewDate(t) {
    return this._additionalView ? t >= this._additionalView._getFirstAvailableDate() : !1;
  },
  _getActiveView: function(t) {
    return this._isAdditionalViewDate(t) ? this._additionalView : this._view;
  },
  _setViewContoured: function(t) {
    if (this.option("skipFocusCheck") || E(this._$viewsWrapper).is(":focus")) {
      var e;
      this._view.option("contouredDate", null), (e = this._additionalView) === null || e === void 0 || e.option("contouredDate", null);
      var i = this._isAdditionalViewDate(t) ? this._additionalView : this._view;
      i.option("contouredDate", t);
    }
  },
  _getMinDate: function() {
    var t = this.option("_rangeMin");
    return t || (this.min ? this.min : (this.min = this._dateOption("min") || new Date(1e3, 0), this.min));
  },
  _getMaxDate: function() {
    var t = this.option("_rangeMax");
    return t || (this.max ? this.max : (this.max = this._dateOption("max") || new Date(3e3, 0), this.max));
  },
  _getViewsOffset: function(t, e) {
    var i = this.option("zoomLevel");
    if (i === Zn.MONTH)
      return this._getMonthsOffset(t, e);
    var r;
    switch (i) {
      case Zn.CENTURY:
        r = 100;
        break;
      case Zn.DECADE:
        r = 10;
        break;
      default:
        r = 1;
    }
    return parseInt(e.getFullYear() / r) - parseInt(t.getFullYear() / r);
  },
  _getMonthsOffset: function(t, e) {
    var i = e.getFullYear() - t.getFullYear(), r = e.getMonth() - t.getMonth();
    return 12 * i + r;
  },
  _waitRenderView: function(t) {
    if (!this._alreadyViewRender) {
      this._alreadyViewRender = !0;
      var e = this._getDateByOffset(t * this._getRtlCorrection());
      this._moveToClosestAvailableDate(e), this._waitRenderViewTimeout = setTimeout(() => {
        this._alreadyViewRender = !1;
      });
    }
  },
  _getRtlCorrection: function() {
    return this.option("rtlEnabled") ? -1 : 1;
  },
  _getDateByOffset: function(t, e) {
    var i;
    e = this._getDate((i = e) !== null && i !== void 0 ? i : this.option("currentDate"));
    var r = e.getDate(), n = Ke.getDifferenceInMonth(this.option("zoomLevel")) * t;
    e.setDate(1), e.setMonth(e.getMonth() + n);
    var a = Ke.getLastMonthDate(e).getDate();
    return e.setDate(r > a ? a : r), e;
  },
  _focusTarget: function() {
    return this._$viewsWrapper;
  },
  _focusEventTarget() {
    return this.$element();
  },
  _initMarkup: function() {
    this._renderSubmitElement();
    var t = this.$element();
    t.addClass(wM), t.toggleClass(Awe, this.option("selectionMode") === "range"), this._renderBody(), t.append(this.$body), this._renderViews(), this._renderNavigator(), this.callBase(), this._renderEvents(), t.prepend(this._navigator.$element()), this._renderSwipeable(), this._renderFooter(), this._selectionStrategy.updateAriaSelected(), this._updateAriaId(), this._updateNavigatorLabels(), this.setAria("role", "application"), this._moveToClosestAvailableDate();
  },
  _render: function() {
    this.callBase(), this._setViewContoured(this.option("currentDate"));
  },
  _renderBody: function() {
    this._$viewsWrapper || (this.$body = E("<div>").addClass(Swe), this._$viewsWrapper = E("<div>").addClass(Iwe), this.$body.append(this._$viewsWrapper));
  },
  _getKeyboardListeners() {
    return this.callBase().concat([this._view]);
  },
  _renderViews: function() {
    this.$element().addClass(j4 + "-" + this.option("zoomLevel"));
    var {
      currentDate: t,
      viewsCount: e
    } = this.option();
    if (this.$element().toggleClass(Dwe, e > 1), this._view = this._renderSpecificView(t), wt()) {
      var i = this._getDateByOffset(-1, t);
      this._beforeView = this._isViewAvailable(i) ? this._renderSpecificView(i) : null;
      var r = this._getDateByOffset(e, t);
      r.setDate(1), this._afterView = this._isViewAvailable(r) ? this._renderSpecificView(r) : null;
    }
    e > 1 && (this._additionalView = this._renderSpecificView(this._getDateByOffset(1, t))), this._translateViews();
  },
  _renderSpecificView: function(t) {
    var {
      zoomLevel: e
    } = this.option(), i = mwe[e], r = E("<div>").appendTo(this._$viewsWrapper), n = this._viewConfig(t), a = this._createComponent(r, i, n);
    return a;
  },
  _viewConfig: function(t) {
    var e, i = this.option("disabledDates");
    return i = Le(i) ? this._injectComponent(i.bind(this)) : i, ae({}, this._selectionStrategy.getViewOptions(), {
      date: t,
      min: this._getMinDate(),
      max: this._getMaxDate(),
      firstDayOfWeek: (e = this.option("firstDayOfWeek")) !== null && e !== void 0 ? e : Bt.firstDayOfWeekIndex(),
      showWeekNumbers: this.option("showWeekNumbers"),
      selectWeekOnClick: this.option("selectWeekOnClick"),
      weekNumberRule: this.option("weekNumberRule"),
      zoomLevel: this.option("zoomLevel"),
      tabIndex: void 0,
      focusStateEnabled: this.option("focusStateEnabled"),
      hoverStateEnabled: this.option("hoverStateEnabled"),
      disabledDates: i,
      onCellClick: this._cellClickHandler.bind(this),
      cellTemplate: this._getTemplateByOption("cellTemplate"),
      allowValueSelection: this._isMaxZoomLevel(),
      _todayDate: this.option("_todayDate")
    });
  },
  _renderEvents() {
    k.off(this._$viewsWrapper, X4), this.option("selectionMode") === "range" && k.on(this._$viewsWrapper, X4, null, (t) => {
      this._updateViewsOption("hoveredRange", []);
    });
  },
  _injectComponent: function(t) {
    var e = this;
    return function(i) {
      return P(i, {
        component: e
      }), t(i);
    };
  },
  _isViewAvailable: function(t) {
    var e = this.option("zoomLevel"), i = Ke.getViewMinBoundaryDate(e, this._getMinDate()), r = Ke.getViewMaxBoundaryDate(e, this._getMaxDate());
    return Ke.dateInRange(t, i, r);
  },
  _translateViews: function() {
    var {
      viewsCount: t
    } = this.option();
    Nn(this._view.$element(), {
      left: 0,
      top: 0
    }), this._moveViewElement(this._beforeView, -1), this._moveViewElement(this._afterView, t), this._moveViewElement(this._additionalView, 1);
  },
  _moveViewElement(t, e) {
    t && Nn(t.$element(), {
      left: this._getViewPosition(e),
      top: 0
    });
  },
  _getViewPosition: function(t) {
    var e = this.option("rtlEnabled") ? -1 : 1;
    return 100 * t * e + "%";
  },
  _cellClickHandler: function(t) {
    var e = this.option("zoomLevel"), i = Ke.getViewDown(e), r = this._isMaxZoomLevel();
    if (i && !r)
      this._navigateDown(t.event.currentTarget);
    else {
      var n = this._updateTimeComponent(t.value);
      this._selectionStrategy.selectValue(n, t.event), this._cellClickAction(t);
    }
  },
  _updateTimeComponent: function(t) {
    var e = new Date(t), i = this._dateOption("value");
    return i && this._isSingleMode() && (e.setHours(i.getHours()), e.setMinutes(i.getMinutes()), e.setSeconds(i.getSeconds()), e.setMilliseconds(i.getMilliseconds())), e;
  },
  _isMaxZoomLevel: function() {
    return this.option("zoomLevel") === this.option("maxZoomLevel");
  },
  _navigateDown: function(t) {
    var e = this.option("zoomLevel");
    if (!this._isMaxZoomLevel()) {
      var i = Ke.getViewDown(e);
      if (i) {
        var r = this._view.option("contouredDate") || this._view.option("date");
        t && (r = E(t).data(Lwe)), this._isOtherViewCellClicked = !0, this.option("currentDate", r), this.option("zoomLevel", i), this._isOtherViewCellClicked = !1, this._renderNavigator(), this._animateShowView(), this._moveToClosestAvailableDate(), this._setViewContoured(this._getNormalizedDate(this.option("currentDate")));
      }
    }
  },
  _renderNavigator: function() {
    this._navigator || (this._navigator = new awe(E("<div>"), this._navigatorConfig())), this._navigator.option("text", this._getViewsCaption(this._view, this._additionalView)), this._updateButtonsVisibility();
  },
  _navigatorConfig: function() {
    var {
      focusStateEnabled: t,
      rtlEnabled: e
    } = this.option();
    return {
      text: this._getViewsCaption(this._view, this._additionalView),
      onClick: this._navigatorClickHandler.bind(this),
      onCaptionClick: this._navigateUp.bind(this),
      focusStateEnabled: t,
      rtlEnabled: e,
      tabIndex: void 0
    };
  },
  _navigatorClickHandler: function(t) {
    var {
      currentDate: e,
      viewsCount: i
    } = this.option(), r = t.direction;
    if (i > 1) {
      var n = this._isAdditionalViewDate(e), a = n && r < 0 || !n && r > 0;
      a && (r *= 2);
    }
    var o = this._getDateByOffset(r, e);
    this._moveToClosestAvailableDate(o);
  },
  _navigateUp: function() {
    var t = this.option("zoomLevel"), e = Ke.getViewUp(t);
    !e || this._isMinZoomLevel(t) || (this.option("zoomLevel", e), this._renderNavigator(), this._animateShowView(), this._moveToClosestAvailableDate(), this._setViewContoured(this._getNormalizedDate(this.option("currentDate"))));
  },
  _isMinZoomLevel: function(t) {
    var e = this._getMinDate(), i = this._getMaxDate();
    return Ke.sameView(t, e, i) || this.option("minZoomLevel") === t;
  },
  _updateButtonsVisibility: function() {
    this._navigator.toggleButton("next", !R(this._afterView)), this._navigator.toggleButton("prev", !R(this._beforeView));
  },
  _renderSwipeable: function() {
    this._swipeable || (this._swipeable = this._createComponent(this.$element(), GT, {
      onStart: this._swipeStartHandler.bind(this),
      onUpdated: this._swipeUpdateHandler.bind(this),
      onEnd: this._swipeEndHandler.bind(this),
      itemSizeFunc: this._viewWidth.bind(this)
    }));
  },
  _swipeStartHandler: function(t) {
    ji.stop(this._$viewsWrapper, !0);
    var {
      viewsCount: e
    } = this.option();
    this._toggleGestureCoverCursor("grabbing"), t.event.maxLeftOffset = this._getRequiredView("next") ? 1 / e : 0, t.event.maxRightOffset = this._getRequiredView("prev") ? 1 / e : 0;
  },
  _toggleGestureCoverCursor: function(t) {
    E(".".concat(Owe)).css("cursor", t);
  },
  _getRequiredView: function(t) {
    var e, i = this.option("rtlEnabled");
    return t === "next" ? e = i ? this._beforeView : this._afterView : t === "prev" && (e = i ? this._afterView : this._beforeView), e;
  },
  _swipeUpdateHandler: function(t) {
    var e = t.event.offset;
    Nn(this._$viewsWrapper, {
      left: e * this._viewWidth(),
      top: 0
    }), this._updateNavigatorCaption(e);
  },
  _swipeEndHandler: function(t) {
    this._toggleGestureCoverCursor("auto");
    var {
      currentDate: e,
      rtlEnabled: i
    } = this.option(), r = t.event.targetOffset, n = r ? r / Math.abs(r) : 0, a = this._isAdditionalViewDate(e), o = a && (i ? n === -1 : n === 1);
    if (n === 0) {
      this._animateWrapper(0, mw);
      return;
    }
    var u = -n * this._getRtlCorrection() * (o ? 2 : 1), c = this._getDateByOffset(u);
    this._isDateInInvalidRange(c) && (n >= 0 ? c = new Date(this._getMinDate()) : c = new Date(this._getMaxDate())), this.option("currentDate", c);
  },
  _viewWidth: function() {
    return this._viewWidthValue || (this._viewWidthValue = mt(this.$element()) / this.option("viewsCount")), this._viewWidthValue;
  },
  _updateNavigatorCaption: function(t) {
    t *= this._getRtlCorrection();
    var e = this.option("viewsCount") > 1, i, r;
    t > 0.5 && this._beforeView ? (i = this._beforeView, r = e && this._view) : t < -0.5 && this._afterView ? (i = e ? this._additionalView : this._afterView, r = e ? this._afterView : null) : (i = this._view, r = e ? this._additionalView : null), this._navigator.option("text", this._getViewsCaption(i, r));
  },
  _getViewsCaption: function(t, e) {
    var i = t.getNavigatorCaption(), {
      viewsCount: r
    } = this.option();
    if (r > 1 && e) {
      var n = e.getNavigatorCaption();
      i = "".concat(i, " - ").concat(n);
    }
    return i;
  },
  _isDateInInvalidRange: function(t) {
    if (!this._view.isBoundary(t)) {
      var e = this._getMinDate(), i = this._getMaxDate(), r = Ke.normalizeDate(t, e, i);
      return r === e || r === i;
    }
  },
  _renderFooter: function() {
    var t = this.option("showTodayButton");
    if (t) {
      var e = this._createComponent(E("<div>"), yn, {
        focusStateEnabled: this.option("focusStateEnabled"),
        text: X.format("dxCalendar-todayButtonText"),
        onClick: (i) => {
          this._toTodayView(i);
        },
        type: za() ? "normal" : "default",
        stylingMode: za() ? "outlined" : "text",
        integrationOptions: {}
      }).$element().addClass(wwe);
      this._$footer = E("<div>").addClass(bwe).append(e), this.$element().append(this._$footer);
    }
    this.$element().toggleClass(Twe, t);
  },
  _renderSubmitElement: function() {
    this._$submitElement = E("<input>").attr("type", "hidden").appendTo(this.$element()), this._setSubmitValue(this.option("value"));
  },
  _setSubmitValue: function(t) {
    var e = this._convertToDate(t);
    this._getSubmitElement().val($r.serializeDate(e, Rwe));
  },
  _getSubmitElement: function() {
    return this._$submitElement;
  },
  _animateShowView: function() {
    ji.stop(this._view.$element(), !0), this._popAnimationView(this._view, Y4, q4, mw), this.option("viewsCount") > 1 && (ji.stop(this._additionalView.$element(), !0), this._popAnimationView(this._additionalView, Y4, q4, mw));
  },
  _popAnimationView: function(t, e, i, r) {
    return ji.animate(t.$element(), {
      type: "pop",
      from: {
        scale: e,
        opacity: e
      },
      to: {
        scale: i,
        opacity: i
      },
      duration: r
    });
  },
  _navigate: function(t, e) {
    if (t !== 0 && Math.abs(t) !== 1 && this._isViewAvailable(e)) {
      var i = this._renderSpecificView(e);
      t > 0 ? (this._afterView && this._afterView.$element().remove(), this._afterView = i) : (this._beforeView && this._beforeView.$element().remove(), this._beforeView = i), this._translateViews();
    }
    var r = this._getRtlCorrection(), n = t > 0 ? 1 : t < 0 ? -1 : 0, a = -r * n * this._viewWidth(), o = this._$viewsWrapper.position().left;
    o !== a && (this._preventViewChangeAnimation ? this._wrapperAnimationEndHandler(t, e) : this._animateWrapper(a, mw).done(this._wrapperAnimationEndHandler.bind(this, t, e)));
  },
  _animateWrapper: function(t, e) {
    return ji.animate(this._$viewsWrapper, {
      type: "slide",
      from: {
        left: this._$viewsWrapper.position().left
      },
      to: {
        left: t
      },
      duration: e
    });
  },
  _getDate: (t) => new Date(t),
  _toTodayView: function(t) {
    var e = /* @__PURE__ */ new Date();
    if (this._isMaxZoomLevel()) {
      this._selectionStrategy.selectValue(e, t.event);
      return;
    }
    this._preventViewChangeAnimation = !0, this.option("zoomLevel", this.option("maxZoomLevel")), this._selectionStrategy.selectValue(e, t.event), this._animateShowView(), this._preventViewChangeAnimation = !1;
  },
  _wrapperAnimationEndHandler: function(t, e) {
    this._rearrangeViews(t), this._translateViews(), this._resetLocation(), this._renderNavigator(), this._setViewContoured(e), this._updateAriaId(e), this._selectionStrategy.updateAriaSelected();
  },
  _rearrangeViews: function(t) {
    var e;
    if (t !== 0) {
      var {
        viewsCount: i
      } = this.option(), r, n, a, o, u;
      if (t < 0 ? (r = 1, n = "_beforeView", a = "_afterView", o = "_view", u = i === 1 ? "_view" : "_additionalView") : (r = -1, n = "_afterView", a = "_beforeView", o = i === 1 ? "_view" : "_additionalView", u = "_view"), !!this[n]) {
        var c = this[n].option("date");
        (e = this[a]) === null || e === void 0 || e.$element().remove(), this[a] = this._renderSpecificView(this._getDateByOffset(r * i, c)), this[u].$element().remove(), i === 1 ? this[u] = this[n] : (this[u] = this[o], this[o] = this[n]);
        var p = this._getDateByOffset(-r, c);
        this[n] = this._isViewAvailable(p) ? this._renderSpecificView(p) : null;
      }
    }
  },
  _resetLocation: function() {
    Nn(this._$viewsWrapper, {
      left: 0,
      top: 0
    });
  },
  _clean: function() {
    this.callBase(), this._clearViewWidthCache(), delete this._$viewsWrapper, delete this._navigator, delete this._$footer;
  },
  _clearViewWidthCache: function() {
    delete this._viewWidthValue;
  },
  _disposeViews: function() {
    this._view.$element().remove(), this._beforeView && this._beforeView.$element().remove(), this._additionalView && this._additionalView.$element().remove(), this._afterView && this._afterView.$element().remove(), delete this._view, delete this._additionalView, delete this._beforeView, delete this._afterView, delete this._skipNavigate;
  },
  _dispose: function() {
    clearTimeout(this._waitRenderViewTimeout), this.callBase();
  },
  _refreshViews: function() {
    this._resetActiveState(), this._disposeViews(), this._renderViews();
  },
  _visibilityChanged: function() {
    this._translateViews();
  },
  _shouldSkipFocusEvent(t) {
    var {
      target: e,
      relatedTarget: i
    } = t;
    return E(e).parents(".".concat(wM)).length && E(i).parents(".".concat(wM)).length;
  },
  _focusInHandler: function(t) {
    E(t.target).is(this._$viewsWrapper) && this._setViewContoured(this.option("currentDate")), !this._shouldSkipFocusEvent(t) && (this.callBase.apply(this, arguments), this._toggleFocusClass(!0, this.$element()));
  },
  _focusOutHandler: function(t) {
    if (E(t.target).is(this._$viewsWrapper)) {
      var e;
      this._view.option("contouredDate", null), (e = this._additionalView) === null || e === void 0 || e.option("contouredDate", null);
    }
    this._shouldSkipFocusEvent(t) || (this.callBase.apply(this, arguments), this._toggleFocusClass(!1, this.$element()));
  },
  _updateViewsOption: function(t, e) {
    var i, r, n;
    this._view.option(t, e), (i = this._additionalView) === null || i === void 0 || i.option(t, e), (r = this._beforeView) === null || r === void 0 || r.option(t, e), (n = this._afterView) === null || n === void 0 || n.option(t, e);
  },
  _setViewsMinOption: function(t) {
    this._restoreViewsMinMaxOptions(), this.option("_rangeMin", this._convertToDate(t)), this._updateViewsOption("min", this._getMinDate());
  },
  _setViewsMaxOption: function(t) {
    this._restoreViewsMinMaxOptions(), this.option("_rangeMax", this._convertToDate(t)), this._updateViewsOption("max", this._getMaxDate());
  },
  _restoreViewsMinMaxOptions: function() {
    this._resetActiveState(), this.option({
      _rangeMin: null,
      _rangeMax: null
    }), this._updateViewsOption("min", this._getMinDate()), this._updateViewsOption("max", this._getMaxDate());
  },
  _updateNavigatorLabels: function() {
    var t = this.option("zoomLevel");
    t = t.charAt(0).toUpperCase() + t.slice(1);
    var e = this._navigator._caption.option("text"), i = X.format("dxCalendar-previous".concat(t, "ButtonLabel")), r = X.format("dxCalendar-caption".concat(t, "Label")), n = X.format("dxCalendar-next".concat(t, "ButtonLabel"));
    this.setAria("label", i, this._navigator._prevButton.$element()), this.setAria("label", "".concat(e, ". ").concat(r), this._navigator._caption.$element()), this.setAria("label", n, this._navigator._nextButton.$element());
  },
  _updateAriaSelected: function(t, e) {
    e.forEach((i) => {
      this.setAria("selected", void 0, this._view._getCellByDate(i));
    }), t.forEach((i) => {
      this.setAria("selected", !0, this._view._getCellByDate(i));
    }), this.option("viewsCount") > 1 && (e.forEach((i) => {
      this.setAria("selected", void 0, this._additionalView._getCellByDate(i));
    }), t.forEach((i) => {
      this.setAria("selected", !0, this._additionalView._getCellByDate(i));
    }));
  },
  _updateAriaId: function(t) {
    var e;
    t = (e = t) !== null && e !== void 0 ? e : this.option("currentDate");
    var i = "dx-" + new yr(), r = this._getActiveView(t), n = r._getCellByDate(t);
    this.setAria("id", i, n), this.setAria("activedescendant", i), this._onContouredChanged(i);
  },
  _suppressingNavigation: function(t, e) {
    this._suppressNavigation = !0, t.apply(this, e), delete this._suppressNavigation;
  },
  _optionChanged: function(t) {
    var {
      value: e,
      previousValue: i
    } = t;
    switch (t.name) {
      case "width":
        this.callBase(t), this._clearViewWidthCache();
        break;
      case "min":
      case "max":
        this.min = void 0, this.max = void 0, this._suppressingNavigation(this._updateCurrentDate, [this.option("currentDate")]), this._refreshViews(), this._renderNavigator();
        break;
      case "selectionMode":
        this._refreshSelectionStrategy(), this._initCurrentDate();
        break;
      case "selectWeekOnClick":
        this._refreshViews();
        break;
      case "firstDayOfWeek":
        this._refreshViews(), this._updateButtonsVisibility();
        break;
      case "focusStateEnabled":
        this._invalidate();
        break;
      case "currentDate":
        this.setAria("id", void 0, this._view._getCellByDate(i)), this._updateCurrentDate(e);
        break;
      case "zoomLevel":
        this.$element().removeClass(j4 + "-" + i), this._correctZoomLevel(), this._refreshViews(), this._renderNavigator(), this._updateAriaId(), this._updateNavigatorLabels();
        break;
      case "minZoomLevel":
      case "maxZoomLevel":
        this._correctZoomLevel(), this._updateButtonsVisibility();
        break;
      case "value":
        this._selectionStrategy.processValueChanged(e, i), this._setSubmitValue(e), this.callBase(t);
        break;
      case "viewsCount":
        this._refreshViews(), this._renderNavigator();
        break;
      case "onCellClick":
        this._view.option("onCellClick", e);
        break;
      case "onContouredChanged":
        this._onContouredChanged = this._createActionByOption("onContouredChanged");
        break;
      case "disabledDates":
      case "dateSerializationFormat":
      case "cellTemplate":
      case "showTodayButton":
        this._invalidate();
        break;
      case "skipFocusCheck":
        break;
      case "_todayDate":
      case "showWeekNumbers":
      case "weekNumberRule":
        this._refreshViews();
        break;
      default:
        this.callBase(t);
    }
  },
  getContouredDate: function() {
    return this._view.option("contouredDate");
  }
});
ti("dxCalendar", HX);
var _w = wi.abstract, PI = wi.inherit({
  ctor: function(t) {
    this.dateBox = t;
  },
  widgetOption: function() {
    return this._widget && this._widget.option.apply(this._widget, arguments);
  },
  _renderWidget: function(t) {
    t = t || E("<div>"), this._widget = this._createWidget(t), this._widget.$element().appendTo(this._getWidgetContainer());
  },
  _createWidget: function(t) {
    var e = this._getWidgetName(), i = this._getWidgetOptions();
    return this.dateBox._createComponent(t, e, i);
  },
  _getWidgetOptions: _w,
  _getWidgetName: _w,
  getDefaultOptions: function() {
    return {
      mode: "text"
    };
  },
  getDisplayFormat: _w,
  supportedKeys: ee,
  getKeyboardListener: ee,
  customizeButtons: ee,
  getParsedText: function(t, e) {
    var i = Bt.parse(t, e);
    return i || Bt.parse(t);
  },
  renderInputMinMax: ee,
  renderOpenedState: function() {
    this._updateValue();
  },
  popupConfig: _w,
  _dimensionChanged: function() {
    var t;
    (t = this._getPopup()) === null || t === void 0 || t.repaint();
  },
  renderPopupContent: function() {
    var t = this._getPopup();
    this._renderWidget();
    var e = t.$content().parent();
    k.off(e, "mousedown"), k.on(e, "mousedown", this._preventFocusOnPopup.bind(this));
  },
  _preventFocusOnPopup: function(t) {
    t.preventDefault();
  },
  _getWidgetContainer: function() {
    return this._getPopup().$content();
  },
  _getPopup: function() {
    return this.dateBox._popup;
  },
  popupShowingHandler: ee,
  popupHiddenHandler: ee,
  _updateValue: function() {
    this._widget && this._widget.option("value", this.dateBoxValue());
  },
  useCurrentDateByDefault: ee,
  getDefaultDate: function() {
    return /* @__PURE__ */ new Date();
  },
  textChangedHandler: ee,
  renderValue: function() {
    this.dateBox.option("opened") && this._updateValue();
  },
  getValue: function() {
    return this._widget.option("value");
  },
  isAdaptivityChanged: function() {
    return !1;
  },
  dispose: function() {
    var t = this._getPopup();
    t && t.$content().empty();
  },
  dateBoxValue: function() {
    return arguments.length ? this.dateBox.dateValue.apply(this.dateBox, arguments) : this.dateBox.dateOption.apply(this.dateBox, ["value"]);
  }
}), kwe = "dx-button-today", $X = PI.inherit({
  NAME: "Calendar",
  getDefaultOptions: function() {
    return P(this.callBase(), {
      todayButtonText: X.format("dxCalendar-todayButtonText")
    });
  },
  supportedKeys: function() {
    var t = function(e) {
      return this.option("opened") ? (e.preventDefault(), !0) : !1;
    };
    return {
      rightArrow: function() {
        if (this.option("opened"))
          return !0;
      },
      leftArrow: function() {
        if (this.option("opened"))
          return !0;
      },
      enter: (function(e) {
        if (this.dateBox.option("opened"))
          if (e.preventDefault(), this._widget.option("zoomLevel") === this._widget.option("maxZoomLevel")) {
            var i = this._getContouredValue(), r = this._lastActionElement, n = this._closeDropDownByEnter();
            return n && i && r === "calendar" && this.dateBoxValue(i, e), n && this.dateBox.close(), this.dateBox._valueChangeEventHandler(e), !n;
          } else
            return !0;
        else
          this.dateBox._valueChangeEventHandler(e);
      }).bind(this),
      home: t,
      end: t
    };
  },
  getDisplayFormat: function(t) {
    return t || "shortdate";
  },
  _closeDropDownByEnter: () => !0,
  _getWidgetName: function() {
    return HX;
  },
  _getContouredValue: function() {
    return this._widget._view.option("contouredDate");
  },
  getKeyboardListener() {
    return this._widget;
  },
  _getWidgetOptions: function() {
    var t = this.dateBox.option("disabledDates");
    return P(this.dateBox.option("calendarOptions"), {
      value: this.dateBoxValue() || null,
      selectionMode: "single",
      dateSerializationFormat: null,
      min: this.dateBox.dateOption("min"),
      max: this.dateBox.dateOption("max"),
      onValueChanged: this._valueChangedHandler.bind(this),
      onCellClick: this._cellClickHandler.bind(this),
      disabledDates: Le(t) ? this._injectComponent(t.bind(this.dateBox)) : t,
      onContouredChanged: this._refreshActiveDescendant.bind(this),
      skipFocusCheck: !0
    });
  },
  _injectComponent: function(t) {
    var e = this;
    return function(i) {
      return P(i, {
        component: e.dateBox
      }), t(i);
    };
  },
  _refreshActiveDescendant: function(t) {
    this._lastActionElement = "calendar", this.dateBox.setAria("activedescendant", t.actionValue);
  },
  _getTodayButtonConfig() {
    var t = this.dateBox.option("buttonsLocation"), e = t === "default", i = e ? ["bottom", "center"] : Nm(t), r = _a() ? "text" : "outlined";
    return {
      widget: "dxButton",
      toolbar: i[0],
      location: i[1] === "after" ? "before" : i[1],
      options: {
        onClick: (n) => {
          this._widget._toTodayView(n);
        },
        text: this.dateBox.option("todayButtonText"),
        elementAttr: {
          class: kwe
        },
        stylingMode: r
      }
    };
  },
  _isCalendarVisible: function() {
    var {
      calendarOptions: t
    } = this.dateBox.option();
    return uo(t) || t.visible !== !1;
  },
  _getPopupToolbarItems(t) {
    var e = this.dateBox.option("applyValueMode") === "useButtons", i = e && this._isCalendarVisible();
    if (i) {
      var r = this._getTodayButtonConfig();
      return [r, ...t];
    }
    return t;
  },
  popupConfig: function(t) {
    return P(!0, t, {
      position: {
        collision: "flipfit flip"
      },
      width: "auto"
    });
  },
  _valueChangedHandler: function(t) {
    var e = t.value, i = t.previousValue;
    Ke.sameDate(e, i) && Ke.sameHoursAndMinutes(e, i) || this.dateBox.option("applyValueMode") === "instantly" && this.dateBoxValue(this.getValue(), t.event);
  },
  _updateValue: function() {
    this._widget && this._widget.option("value", this.dateBoxValue());
  },
  textChangedHandler: function() {
    this._lastActionElement = "input", this.dateBox.option("opened") && this._widget && this._updateValue(!0);
  },
  _cellClickHandler: function(t) {
    var e = this.dateBox;
    e.option("applyValueMode") === "instantly" && (e.option("opened", !1), this.dateBoxValue(this.getValue(), t.event));
  }
});
class Pwe {
  constructor(e) {
    this.DIRECTION_HORIZONTAL = "horizontal", this.DIRECTION_VERTICAL = "vertical", this.DIRECTION_BOTH = "both", this.direction = e ?? NT;
  }
  get isHorizontal() {
    return this.direction === L5 || this.direction === BL;
  }
  get isVertical() {
    return this.direction === NT || this.direction === BL;
  }
  get isBoth() {
    return this.direction === BL;
  }
}
function Fwe(t, e) {
  if ($t(t)) {
    var i = cr(t.left, t.x), r = cr(t.top, t.y);
    return {
      left: R(i) ? i : void 0,
      top: R(r) ? r : void 0
    };
  }
  var {
    isHorizontal: n,
    isVertical: a
  } = new Pwe(e);
  return {
    left: n && R(t) ? t : void 0,
    top: a && R(t) ? t : void 0
  };
}
var Bwe = "dx-dateviewroller", Vwe = "dx-state-active", Nwe = "dx-dateviewroller-current", Q4 = "dx-dateview-item", Hwe = "dx-dateview-item-selected", $we = "dx-dateview-item-selected-frame", zwe = "dx-dateview-item-selected-border";
class zX extends ds {
  _getDefaultOptions() {
    return P(super._getDefaultOptions(), {
      showScrollbar: "never",
      useNative: !1,
      selectedIndex: 0,
      bounceEnabled: !1,
      items: [],
      showOnClick: !1,
      onClick: null,
      onSelectedIndexChanged: null,
      scrollByContent: !0
    });
  }
  _init() {
    super._init(), this.option("onVisibilityChange", this._visibilityChangedHandler.bind(this)), this.option("onEnd", this._endActionHandler.bind(this));
  }
  _render() {
    super._render(), this._renderSelectedItemFrame(), this.$element().addClass(Bwe), this._renderContainerClick(), this._renderItems(), this._renderSelectedValue(), this._renderItemsClick(), this._renderWheelEvent(), this._renderSelectedIndexChanged();
  }
  _renderSelectedIndexChanged() {
    this._selectedIndexChanged = this._createActionByOption("onSelectedIndexChanged");
  }
  _renderWheelEvent() {
    k.on(E(this.container()), "dxmousewheel", (e) => {
      this._isWheelScrolled = !0;
    });
  }
  _renderContainerClick() {
    if (this.option("showOnClick")) {
      var e = ve(di, this.NAME), i = this._createActionByOption("onClick");
      k.off(E(this.container()), e), k.on(E(this.container()), e, function(r) {
        i({
          event: r
        });
      });
    }
  }
  _renderItems() {
    var e = this.option("items") || [], i = E();
    E(this.content()).empty(), e.forEach(function(r) {
      i = i.add(E("<div>").addClass(Q4).append(r));
    }), E(this.content()).append(i), this._$items = i, this.update();
  }
  _renderSelectedItemFrame() {
    E("<div>").addClass($we).append(E("<div>").addClass(zwe)).appendTo(E(this.container()));
  }
  _renderSelectedValue(e) {
    var i = this._fitIndex(e ?? this.option("selectedIndex"));
    this._moveTo({
      top: this._getItemPosition(i)
    }), this._renderActiveStateItem();
  }
  _fitIndex(e) {
    var i = this.option("items") || [], r = i.length;
    return e >= r ? r - 1 : e < 0 ? 0 : e;
  }
  _getItemPosition(e) {
    return Math.round(this._itemHeight() * e);
  }
  _renderItemsClick() {
    var e = this._getItemSelector(), i = ve(di, this.NAME);
    k.off(this.$element(), i, e), k.on(this.$element(), i, e, this._itemClickHandler.bind(this));
  }
  _getItemSelector() {
    return "." + Q4;
  }
  _itemClickHandler(e) {
    this.option("selectedIndex", this._itemElementIndex(e.currentTarget));
  }
  _itemElementIndex(e) {
    return this._itemElements().index(e);
  }
  _itemElements() {
    return this.$element().find(this._getItemSelector());
  }
  _renderActiveStateItem() {
    var e = this.option("selectedIndex");
    N(this._$items, function(i) {
      E(this).toggleClass(Hwe, e === i);
    });
  }
  _shouldScrollToNeighborItem() {
    return Ye.real().deviceType === "desktop" && this._isWheelScrolled;
  }
  _moveTo(e) {
    var {
      top: i,
      left: r
    } = Fwe(e), n = this.scrollOffset(), a = {
      x: n.left - r,
      y: n.top - i
    };
    if (this._isVisible() && (a.x || a.y))
      if (this._prepareDirections(!0), this._animation && !this._shouldScrollToNeighborItem()) {
        var o = this;
        ji.stop(E(this.content())), ji.animate(E(this.content()), {
          duration: 200,
          type: "slide",
          to: {
            top: Math.floor(a.y)
          },
          complete() {
            xS(E(o.content())), o.handleMove({
              delta: a
            });
          }
        }), delete this._animation;
      } else
        this.handleMove({
          delta: a
        });
  }
  _validate(e) {
    return this._moveIsAllowed(e);
  }
  _fitSelectedIndexInRange(e) {
    var i = this.option("items").length;
    return Math.max(Math.min(e, i - 1), 0);
  }
  _isInNullNeighborhood(e) {
    return -0.1 <= e && e <= 0.1;
  }
  _getSelectedIndexAfterScroll(e) {
    var i = this.scrollOffset().top, r = e * this._itemHeight(), n = i - r;
    if (this._isInNullNeighborhood(n))
      return e;
    var a = n > 0 ? 1 : -1, o = this._fitSelectedIndexInRange(e + a);
    return o;
  }
  _getNewSelectedIndex(e) {
    if (this._shouldScrollToNeighborItem())
      return this._getSelectedIndexAfterScroll(e);
    this._animation = !0;
    var i = this.scrollOffset().top / this._itemHeight();
    return Math.round(i);
  }
  _endActionHandler() {
    var e = this.option("selectedIndex"), i = this._getNewSelectedIndex(e);
    i === e ? this._renderSelectedValue(i) : this.option("selectedIndex", i), this._isWheelScrolled = !1;
  }
  _itemHeight() {
    var e = this._$items.first();
    return Pt(e);
  }
  _toggleActive(e) {
    this.$element().toggleClass(Vwe, e);
  }
  _isVisible() {
    return E(this.container()).is(":visible");
  }
  _fireSelectedIndexChanged(e, i) {
    this._selectedIndexChanged({
      value: e,
      previousValue: i,
      event: void 0
    });
  }
  _visibilityChanged(e) {
    super._visibilityChanged(e), this._visibilityChangedHandler(e);
  }
  _visibilityChangedHandler(e) {
    e && (this._visibilityTimer = setTimeout(() => {
      this._renderSelectedValue(this.option("selectedIndex"));
    })), this.toggleActiveState(!1);
  }
  toggleActiveState(e) {
    this.$element().toggleClass(Nwe, e);
  }
  _refreshSelectedIndex() {
    var e = this.option("selectedIndex"), i = this._fitIndex(e);
    i === e ? this._renderActiveStateItem() : this.option("selectedIndex", i);
  }
  _optionChanged(e) {
    switch (e.name) {
      case "selectedIndex":
        this._fireSelectedIndexChanged(e.value, e.previousValue), this._renderSelectedValue(e.value);
        break;
      case "items":
        this._renderItems(), this._refreshSelectedIndex();
        break;
      case "onClick":
      case "showOnClick":
        this._renderContainerClick();
        break;
      case "onSelectedIndexChanged":
        this._renderSelectedIndexChanged();
        break;
      default:
        super._optionChanged(e);
    }
  }
  _dispose() {
    clearTimeout(this._visibilityTimer), super._dispose();
  }
}
ti("dxDateViewRoller", zX);
var TM = "dx-dateview", Wwe = "dx-dateview-compact", Uwe = "dx-dateview-wrapper", Gwe = "dx-dateview-rollers", Kwe = "dx-dateviewroller", Z4 = {
  date: "date",
  datetime: "datetime",
  time: "time"
}, Vo = {
  year: "year",
  month: "month",
  day: "day",
  hours: "hours"
}, WX = Fl.inherit({
  _valueOption: function() {
    var t = this.option("value"), e = new Date(t);
    return !t || isNaN(e) ? this._getDefaultDate() : e;
  },
  _getDefaultDate: function() {
    var t = /* @__PURE__ */ new Date();
    return this.option("type") === Z4.date ? new Date(t.getFullYear(), t.getMonth(), t.getDate()) : t;
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      minDate: Ci.MIN_DATEVIEW_DEFAULT_DATE,
      maxDate: Ci.MAX_DATEVIEW_DEFAULT_DATE,
      type: Z4.date,
      value: /* @__PURE__ */ new Date(),
      applyCompactClass: !1
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: function(t) {
        return t.deviceType !== "desktop";
      },
      options: {
        applyCompactClass: !0
      }
    }]);
  },
  _render: function() {
    this.callBase(), this.$element().addClass(TM), this._toggleFormatClasses(this.option("type")), this._toggleCompactClass();
  },
  _toggleFormatClasses: function(t, e) {
    this.$element().addClass(TM + "-" + t), e && this.$element().removeClass(TM + "-" + e);
  },
  _toggleCompactClass: function() {
    this.$element().toggleClass(Wwe, this.option("applyCompactClass"));
  },
  _wrapper: function() {
    return this._$wrapper;
  },
  _renderContentImpl: function() {
    this._$wrapper = E("<div>").addClass(Uwe), this._renderRollers(), this._$wrapper.appendTo(this.$element());
  },
  _renderRollers: function() {
    this._$rollersContainer || (this._$rollersContainer = E("<div>").addClass(Gwe)), this._$rollersContainer.empty(), this._createRollerConfigs(), this._rollers = {};
    var t = this;
    N(t._rollerConfigs, function(e) {
      var i = E("<div>").appendTo(t._$rollersContainer).addClass(Kwe + "-" + t._rollerConfigs[e].type);
      t._rollers[t._rollerConfigs[e].type] = t._createComponent(i, zX, {
        items: t._rollerConfigs[e].displayItems,
        selectedIndex: t._rollerConfigs[e].selectedIndex,
        showScrollbar: "never",
        scrollByContent: !0,
        onStart: function(r) {
          var n = r.component;
          n._toggleActive(!0), t._setActiveRoller(t._rollerConfigs[e], n.option("selectedIndex"));
        },
        onEnd: function(r) {
          var n = r.component;
          n._toggleActive(!1);
        },
        onClick: function(r) {
          var n = r.component;
          n._toggleActive(!0), t._setActiveRoller(t._rollerConfigs[e], n.option("selectedIndex")), t._setRollerState(t._rollerConfigs[e], n.option("selectedIndex")), n._toggleActive(!1);
        },
        onSelectedIndexChanged: function(r) {
          var n = r.component;
          t._setRollerState(t._rollerConfigs[e], n.option("selectedIndex"));
        }
      });
    }), t._$rollersContainer.appendTo(t._wrapper());
  },
  _createRollerConfigs: function(t) {
    var e = this;
    t = t || e.option("type"), e._rollerConfigs = {}, Bt.getFormatParts(Ci.FORMATS_MAP[t]).forEach(function(i) {
      e._createRollerConfig(i);
    });
  },
  _createRollerConfig: function(t) {
    for (var e = Ci.DATE_COMPONENTS_INFO[t], i = this._calculateRollerConfigValueRange(t), r = i.startValue, n = i.endValue, a = e.formatter, o = this._getCurrentDate(), u = {
      type: t,
      setValue: e.setter,
      valueItems: [],
      displayItems: [],
      getIndex: function(p) {
        return p[e.getter]() - r;
      }
    }, c = r; c <= n; c++)
      u.valueItems.push(c), u.displayItems.push(a(c, o));
    u.selectedIndex = u.getIndex(o), this._rollerConfigs[t] = u;
  },
  _setActiveRoller: function(t) {
    var e = t && this._rollers[t.type];
    N(this._rollers, function() {
      this.toggleActiveState(this === e);
    });
  },
  _updateRollersPosition: function() {
    var t = this;
    N(this._rollers, function(e) {
      var i = t._rollerConfigs[e].getIndex(t._getCurrentDate());
      this.option("selectedIndex", i);
    });
  },
  _setRollerState: function(t, e) {
    if (e !== t.selectedIndex) {
      var i = t.valueItems[e], r = t.setValue, n = new Date(this._getCurrentDate()), a = n.getDate(), o = this.option("minDate"), u = this.option("maxDate");
      t.type === Vo.month ? a = Math.min(a, Ci.getMaxMonthDay(n.getFullYear(), i)) : t.type === Vo.year && (a = Math.min(a, Ci.getMaxMonthDay(i, n.getMonth()))), n.setDate(a), n[r](i);
      var c = Ke.normalizeDate(n, o, u);
      n = Ci.mergeDates(c, n, "time"), n = Ke.normalizeDate(n, o, u), this.option("value", n), t.selectedIndex = e;
    }
    t.type === Vo.year && this._refreshRollers(), t.type === Vo.month && (this._refreshRoller(Vo.day), this._refreshRoller(Vo.hours));
  },
  _refreshRoller: function(t) {
    var e = this._rollers[t];
    if (e) {
      this._createRollerConfig(t);
      var i = this._rollerConfigs[t];
      (t === Vo.day || i.displayItems.toString() !== e.option("items").toString()) && e.option({
        items: i.displayItems,
        selectedIndex: i.selectedIndex
      });
    }
  },
  _getCurrentDate: function() {
    var t = this._valueOption(), e = this.option("minDate"), i = this.option("maxDate");
    return Ke.normalizeDate(t, e, i);
  },
  _calculateRollerConfigValueRange: function(t) {
    var e = this._getCurrentDate(), i = this.option("minDate"), r = this.option("maxDate"), n = Ke.sameYear(e, i), a = n && e.getMonth() === i.getMonth(), o = Ke.sameYear(e, r), u = o && e.getMonth() === r.getMonth(), c = a && e.getDate() === i.getDate(), p = u && e.getDate() === r.getDate(), v = Ci.DATE_COMPONENTS_INFO[t], _ = v.startValue, y = v.endValue;
    return t === Vo.year && (_ = i.getFullYear(), y = r.getFullYear()), t === Vo.month && (n && (_ = i.getMonth()), o && (y = r.getMonth())), t === Vo.day && (y = Ci.getMaxMonthDay(e.getFullYear(), e.getMonth()), n && a && (_ = i.getDate()), o && u && (y = r.getDate())), t === Vo.hours && (_ = c ? i.getHours() : _, y = p ? r.getHours() : y), {
      startValue: _,
      endValue: y
    };
  },
  _refreshRollers: function() {
    this._refreshRoller(Vo.month), this._refreshRoller(Vo.day), this._refreshRoller(Vo.hours);
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "minDate":
      case "maxDate":
      case "type":
        this._renderRollers(), this._toggleFormatClasses(t.value, t.previousValue);
        break;
      case "visible":
        this.callBase(t), t.value && this._renderRollers();
        break;
      case "value":
        this.option("value", this._valueOption()), this._refreshRollers(), this._updateRollersPosition();
        break;
      default:
        this.callBase(t);
    }
  },
  _clean: function() {
    this.callBase(), delete this._$rollersContainer;
  }
});
ti("dxDateView", WX);
var jwe = Ot(), Ywe = PI.inherit({
  NAME: "DateView",
  getDefaultOptions: function() {
    return P(this.callBase(), {
      openOnFieldClick: !0,
      applyButtonText: X.format("OK"),
      "dropDownOptions.showTitle": !0
    });
  },
  getDisplayFormat: function(t) {
    return t || Ci.FORMATS_MAP[this.dateBox.option("type")];
  },
  popupConfig: function(t) {
    return {
      toolbarItems: this.dateBox._popupToolbarItemsConfig(),
      onInitialized: t.onInitialized,
      defaultOptionsRules: [{
        device: {
          platform: "android"
        },
        options: {
          width: 333,
          height: 331
        }
      }, {
        device: function(e) {
          var i = e.platform;
          return i === "generic" || i === "ios";
        },
        options: {
          width: "auto",
          height: "auto"
        }
      }, {
        device: function(e) {
          var i = e.platform, r = e.phone;
          return i === "generic" && r;
        },
        options: {
          width: 333,
          maxWidth: "100%",
          maxHeight: "100%",
          height: "auto",
          position: {
            collision: "flipfit flip"
          }
        }
      }, {
        device: {
          platform: "ios",
          phone: !0
        },
        options: {
          width: "100%",
          position: {
            my: "bottom",
            at: "bottom",
            of: jwe
          }
        }
      }]
    };
  },
  _renderWidget: function() {
    if (cI(this.dateBox.option("mode")) && this.dateBox._isNativeType() || this.dateBox.option("readOnly")) {
      this._widget && (this._widget.$element().remove(), this._widget = null);
      return;
    }
    var t = this._getPopup();
    if (this._widget)
      this._widget.option(this._getWidgetOptions());
    else {
      var e = E("<div>").appendTo(t.$content());
      this._widget = this._createWidget(e);
    }
    this._widget.$element().appendTo(this._getWidgetContainer());
  },
  _getWidgetName: function() {
    return WX;
  },
  renderOpenedState: function() {
    this.callBase(), this._widget && this._widget.option("value", this._widget._getCurrentDate());
  },
  _getWidgetOptions: function() {
    return {
      value: this.dateBoxValue() || /* @__PURE__ */ new Date(),
      type: this.dateBox.option("type"),
      minDate: this.dateBox.dateOption("min") || new Date(1900, 0, 1),
      maxDate: this.dateBox.dateOption("max") || new Date(Date.now() + 50 * Ci.ONE_YEAR),
      onDisposing: (function() {
        this._widget = null;
      }).bind(this)
    };
  }
}), qwe = PI.inherit({
  NAME: "Native",
  popupConfig: function(t) {
    return P({}, t, {
      width: "auto"
    });
  },
  getParsedText: function(t) {
    return t ? this.dateBox.option("type") === "datetime" ? new Date(t.replace(/-/g, "/").replace("T", " ").split(".")[0]) : Ci.fromStandardDateFormat(t) : null;
  },
  renderPopupContent: ee,
  _getWidgetName: ee,
  _getWidgetOptions: ee,
  _getDateBoxType: function() {
    var t = this.dateBox.option("type");
    return Ci.SUPPORTED_FORMATS.includes(t) ? t === "datetime" && !cI(t) && (t = "datetime-local") : t = "date", t;
  },
  customizeButtons: function() {
    var t = this.dateBox.getButton("dropDown");
    Ye.real().android && t && t.on("click", (function() {
      this.dateBox._input().get(0).click();
    }).bind(this));
  },
  getDefaultOptions: function() {
    return {
      mode: this._getDateBoxType()
    };
  },
  getDisplayFormat: function(t) {
    var e = this._getDateBoxType();
    return t || Ci.FORMATS_MAP[e];
  },
  renderInputMinMax: function(t) {
    t.attr({
      min: $r.serializeDate(this.dateBox.dateOption("min"), "yyyy-MM-dd"),
      max: $r.serializeDate(this.dateBox.dateOption("max"), "yyyy-MM-dd")
    });
  }
}), Xwe = "dx-box", Qwe = "dx-box-flex", Zwe = "dx-box-item", UX = "dxBoxItemData", Jwe = 1, eTe = {
  row: "minWidth",
  col: "minHeight"
}, tTe = {
  row: "maxWidth",
  col: "maxHeight"
}, J4 = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  "space-between": "space-between",
  "space-around": "space-around"
}, eK = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  stretch: "stretch"
}, iTe = {
  row: "row",
  col: "column"
}, tm = (t, e, i) => {
  if (i = Dm(e, i), t.style[Np(e)] = i, !wt()) {
    if (i === "" || !R(i))
      return;
    var r = vF(e), n = "".concat(r, ": ").concat(i, ";");
    pj(t, n, !1);
  }
};
class rTe extends Up {
  _renderVisible(e, i) {
    super._renderVisible(e), R(i) && this._options.fireItemStateChangedAction({
      name: "visible",
      state: e,
      oldState: i
    });
  }
}
class nTe {
  constructor(e, i) {
    this._$element = e, this._option = i;
  }
  renderBox() {
    this._$element.css({
      display: "".concat(Fw("flexDirection"), "flex")
    }), tm(this._$element.get(0), "flexDirection", iTe[this._option("direction")]);
  }
  renderAlign() {
    this._$element.css({
      justifyContent: this._normalizedAlign()
    });
  }
  _normalizedAlign() {
    var e = this._option("align");
    return e in J4 ? J4[e] : e;
  }
  renderCrossAlign() {
    this._$element.css({
      alignItems: this._normalizedCrossAlign()
    });
  }
  _normalizedCrossAlign() {
    var e = this._option("crossAlign");
    return e in eK ? eK[e] : e;
  }
  renderItems(e) {
    var i = Fw("flexDirection"), r = this._option("direction");
    N(e, function() {
      var n = E(this), a = n.data(UX);
      n.css({
        display: "".concat(i, "flex")
      }).css(tTe[r], a.maxSize || "none").css(eTe[r], a.minSize || "0"), tm(n.get(0), "flexBasis", a.baseSize || 0), tm(n.get(0), "flexGrow", a.ratio), tm(n.get(0), "flexShrink", R(a.shrink) ? a.shrink : Jwe), n.children().each((o, u) => {
        E(u).css({
          width: "auto",
          height: "auto",
          display: "".concat(Fw("flexDirection"), "flex"),
          flexBasis: 0
        }), tm(u, "flexGrow", 1), tm(u, "flexDirection", E(u)[0].style.flexDirection || "column");
      });
    });
  }
}
class Mh extends Kp {
  _getDefaultOptions() {
    return P(super._getDefaultOptions(), {
      direction: "row",
      align: "start",
      crossAlign: "stretch",
      activeStateEnabled: !1,
      focusStateEnabled: !1,
      onItemStateChanged: void 0,
      _queue: void 0
    });
  }
  _itemClass() {
    return Zwe;
  }
  _itemDataKey() {
    return UX;
  }
  _itemElements() {
    return this._itemContainer().children(this._itemSelector());
  }
  _init() {
    super._init(), this.$element().addClass(Qwe), this._initLayout(), this._initBoxQueue();
  }
  _initLayout() {
    this._layout = new nTe(this.$element(), this.option.bind(this));
  }
  _initBoxQueue() {
    this._queue = this.option("_queue") || [];
  }
  _queueIsNotEmpty() {
    return this.option("_queue") ? !1 : !!this._queue.length;
  }
  _pushItemToQueue(e, i) {
    this._queue.push({
      $item: e,
      config: i
    });
  }
  _shiftItemFromQueue() {
    return this._queue.shift();
  }
  _initMarkup() {
    this.$element().addClass(Xwe), this._layout.renderBox(), super._initMarkup(), this._renderAlign(), this._renderActions();
  }
  _renderActions() {
    this._onItemStateChanged = this._createActionByOption("onItemStateChanged");
  }
  _renderAlign() {
    this._layout.renderAlign(), this._layout.renderCrossAlign();
  }
  _renderItems(e) {
    for (super._renderItems(e); this._queueIsNotEmpty(); ) {
      var i = this._shiftItemFromQueue();
      this._createComponent(i.$item, Mh, P({
        itemTemplate: this.option("itemTemplate"),
        itemHoldTimeout: this.option("itemHoldTimeout"),
        onItemHold: this.option("onItemHold"),
        onItemClick: this.option("onItemClick"),
        onItemContextMenu: this.option("onItemContextMenu"),
        onItemRendered: this.option("onItemRendered"),
        _queue: this._queue
      }, i.config));
    }
    this._layout.renderItems(this._itemElements());
  }
  _renderItemContent(e) {
    var i = e.itemData && e.itemData.node;
    return i ? this._renderItemContentByNode(e, i) : super._renderItemContent(e);
  }
  _postprocessRenderItem(e) {
    var i = e.itemData.box;
    i && this._pushItemToQueue(e.itemContent, i);
  }
  _createItemByTemplate(e, i) {
    return i.itemData.box ? e.source ? e.source() : E() : super._createItemByTemplate(e, i);
  }
  _itemOptionChanged(e, i, r, n) {
    i === "visible" && this._onItemStateChanged({
      name: i,
      state: r,
      oldState: n !== !1
    }), super._itemOptionChanged(e, i, r);
  }
  _optionChanged(e) {
    switch (e.name) {
      case "_queue":
      case "direction":
        this._invalidate();
        break;
      case "align":
        this._layout.renderAlign();
        break;
      case "crossAlign":
        this._layout.renderCrossAlign();
        break;
      default:
        super._optionChanged(e);
    }
  }
  _itemOptions() {
    var e = super._itemOptions();
    return e.fireItemStateChangedAction = (i) => {
      this._onItemStateChanged(i);
    }, e;
  }
}
Mh.ItemClass = rTe;
ti("dxBox", Mh);
var aTe = "dx-timeview", oTe = "dx-timeview-clock", sTe = "dx-timeview-field", lTe = "dx-timeview-hourarrow", uTe = "dx-timeview-time-separator", dTe = "dx-timeview-format12", IM = -1, DM = 1, cTe = "dx-timeview-minutearrow", tK = function(t, e, i) {
  hTe(t, e, i);
}, hTe = function(t, e, i) {
  t.css("transform", "rotate(" + e + "deg) translate(0," + i + "px)");
}, GX = Fl.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      value: new Date(Date.now()),
      use24HourFormat: !0,
      _showClock: !0,
      _arrowOffset: 5,
      stylingMode: void 0
    });
  },
  _getValue: function() {
    return this.option("value") || /* @__PURE__ */ new Date();
  },
  _init: function() {
    this.callBase(), this.$element().addClass(aTe);
  },
  _render: function() {
    this.callBase(), this._renderBox(), this._updateTime();
  },
  _renderBox: function() {
    var t = E("<div>").appendTo(this.$element()), e = [];
    this.option("_showClock") && e.push({
      ratio: 1,
      shrink: 0,
      baseSize: "auto",
      template: this._renderClock.bind(this)
    }), e.push({
      ratio: 0,
      shrink: 0,
      baseSize: "auto",
      template: this._renderField.bind(this)
    }), this._createComponent(t, Mh, {
      height: "100%",
      width: "100%",
      direction: "col",
      items: e
    });
  },
  _renderClock: function(t, e, i) {
    this._$hourArrow = E("<div>").addClass(lTe), this._$minuteArrow = E("<div>").addClass(cTe);
    var r = E(i);
    r.addClass(oTe).append(this._$hourArrow).append(this._$minuteArrow), this.setAria("role", "presentation", r);
  },
  _updateClock: function() {
    var t = this._getValue(), e = t.getHours() / 12 * 360 + t.getMinutes() / 60 * 30, i = t.getMinutes() / 60 * 360;
    tK(this._$hourArrow, e, this.option("_arrowOffset")), tK(this._$minuteArrow, i, this.option("_arrowOffset"));
  },
  _getBoxItems: function(t) {
    var e = [{
      ratio: 0,
      shrink: 0,
      baseSize: "auto",
      template: () => this._hourBox.$element()
    }, {
      ratio: 0,
      shrink: 0,
      baseSize: "auto",
      template: E("<div>").addClass(uTe).text(Bt.getTimeSeparator())
    }, {
      ratio: 0,
      shrink: 0,
      baseSize: "auto",
      template: () => this._minuteBox.$element()
    }];
    return t && e.push({
      ratio: 0,
      shrink: 0,
      baseSize: "auto",
      template: () => this._format12.$element()
    }), e;
  },
  _renderField: function() {
    var t = !this.option("use24HourFormat");
    return this._createHourBox(t), this._createMinuteBox(), t && this._createFormat12Box(), this._createComponent(E("<div>").addClass(sTe), Mh, {
      direction: "row",
      align: "center",
      crossAlign: "center",
      items: this._getBoxItems(t)
    }).$element();
  },
  _createHourBox: function(t) {
    var e = this._hourBox = this._createComponent(E("<div>"), WT, P({
      min: -1,
      max: t ? 13 : 24,
      value: this._getValue().getHours(),
      onValueChanged: this._onHourBoxValueChanged.bind(this),
      onKeyboardHandled: (i) => this._keyboardHandler(i)
    }, this._getNumberBoxConfig()));
    e.setAria("label", "hours");
  },
  _isPM: function() {
    return !this.option("use24HourFormat") && this._format12.option("value") === 1;
  },
  _onHourBoxValueChanged: function(t) {
    var {
      value: e,
      component: i
    } = t, r = this._getValue(), n = new Date(r), a = this._convertMaxHourToMin(e);
    i.option("value", a), this._isPM() && (a += 12), n.setHours(a), Ci.normalizeTime(n), this.option("value", n);
  },
  _convertMaxHourToMin: function(t) {
    var e = this.option("use24HourFormat") ? 24 : 12;
    return (e + t) % e;
  },
  _createMinuteBox: function() {
    var t = this._minuteBox = this._createComponent(E("<div>"), WT, P({
      min: -1,
      max: 60,
      value: this._getValue().getMinutes(),
      onKeyboardHandled: (e) => this._keyboardHandler(e),
      onValueChanged: (e) => {
        var {
          value: i,
          component: r
        } = e, n = (60 + i) % 60;
        r.option("value", n);
        var a = new Date(this._getValue());
        a.setMinutes(n), Ci.normalizeTime(a), this.option("value", a);
      }
    }, this._getNumberBoxConfig()));
    t.setAria("label", "minutes");
  },
  _createFormat12Box: function() {
    var t = Bt.getPeriodNames(), e = this._format12 = this._createComponent(E("<div>").addClass(dTe), KB, {
      items: [{
        value: IM,
        text: t[0]
      }, {
        value: DM,
        text: t[1]
      }],
      valueExpr: "value",
      displayExpr: "text",
      onKeyboardHandled: (i) => this._keyboardHandler(i),
      onValueChanged: (i) => {
        var {
          value: r
        } = i, n = this._getValue().getHours(), a = new Date(this._getValue()), o = (n + 12 * r) % 24;
        a.setHours(o), this.option("value", a);
      },
      value: this._getValue().getHours() >= 12 ? DM : IM,
      stylingMode: this.option("stylingMode")
    });
    e.setAria("label", "type");
  },
  _refreshFormat12: function() {
    if (!this.option("use24HourFormat")) {
      var t = this._getValue(), e = t.getHours(), i = e >= 12, r = i ? DM : IM;
      this._silentEditorValueUpdate(this._format12, r);
    }
  },
  _silentEditorValueUpdate: function(t, e) {
    t && (t._suppressValueChangeAction(), t.option("value", e), t._resumeValueChangeAction());
  },
  _getNumberBoxConfig: function() {
    return {
      showSpinButtons: !0,
      displayValueFormatter: function(t) {
        return (t < 10 ? "0" : "") + t;
      },
      stylingMode: this.option("stylingMode")
    };
  },
  _normalizeHours: function(t) {
    return this.option("use24HourFormat") ? t : t % 12 || 12;
  },
  _updateField: function() {
    var t = this._normalizeHours(this._getValue().getHours());
    this._silentEditorValueUpdate(this._hourBox, t), this._silentEditorValueUpdate(this._minuteBox, this._getValue().getMinutes()), this._refreshFormat12();
  },
  _updateTime: function() {
    this.option("_showClock") && this._updateClock(), this._updateField();
  },
  _visibilityChanged: function(t) {
    t && this._updateTime();
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "value":
        this._updateTime(), this.callBase(t);
        break;
      case "_arrowOffset":
        break;
      case "use24HourFormat":
      case "_showClock":
      case "stylingMode":
        this._invalidate();
        break;
      default:
        this.callBase(t);
    }
  }
});
ti("dxTimeView", GX);
var fTe = Ot(), pTe = 573, vTe = "dx-datebox-adaptivity-mode", iK = "dx-datebox-datetime-time-side", gTe = $X.inherit({
  NAME: "CalendarWithTime",
  getDefaultOptions: function() {
    return P(this.callBase(), {
      applyValueMode: "useButtons",
      buttonsLocation: "bottom after",
      "dropDownOptions.showTitle": !1
    });
  },
  _closeDropDownByEnter: function() {
    return Ke.sameDate(this._getContouredValue(), this.widgetOption("value"));
  },
  getDisplayFormat: function(t) {
    return t || "shortdateshorttime";
  },
  _is24HourFormat: function() {
    return Bt.is24HourFormat(this.getDisplayFormat(this.dateBox.option("displayFormat")));
  },
  _getContouredValue: function() {
    var t = this.callBase();
    return this._updateDateTime(t);
  },
  _renderWidget: function() {
    this.callBase(), this._timeView = this.dateBox._createComponent(E("<div>"), GX, {
      value: this.dateBoxValue(),
      _showClock: !this._isShrinkView(),
      use24HourFormat: this._is24HourFormat(),
      onValueChanged: this._valueChangedHandler.bind(this),
      stylingMode: this.dateBox.option("stylingMode")
    });
  },
  renderOpenedState: function() {
    this.callBase();
    var t = this._getPopup();
    t && t.$wrapper().toggleClass(vTe, this._isSmallScreen()), clearTimeout(this._repaintTimer), this._repaintTimer = setTimeout((function() {
      this._getPopup() && this._getPopup().repaint();
    }).bind(this), 0);
  },
  isAdaptivityChanged: function() {
    var t = this._isShrinkView(), e = this._currentAdaptiveMode;
    return t !== e ? (this._currentAdaptiveMode = t, e !== void 0) : this.callBase();
  },
  _updateValue: function(t) {
    var e = this.dateBoxValue();
    !e && !t && (e = /* @__PURE__ */ new Date(), Ci.normalizeTime(e)), this.callBase(), this._timeView && (e && this._timeView.option("value", e), this._timeView.option("use24HourFormat", this._is24HourFormat()));
  },
  _isSmallScreen: function() {
    return mt(fTe) <= pTe;
  },
  _isShrinkView: function() {
    return !this.dateBox.option("showAnalogClock") || this.dateBox.option("adaptivityEnabled") && this._isSmallScreen();
  },
  _getBoxItems: function() {
    var t = [{
      ratio: 0,
      shrink: 0,
      baseSize: "auto",
      name: "calendar"
    }];
    return this._isShrinkView() || t.push({
      ratio: 0,
      shrink: 0,
      baseSize: "auto",
      name: "time"
    }), t;
  },
  renderPopupContent: function() {
    this.callBase(), this._currentAdaptiveMode = this._isShrinkView();
    var t = this._getPopup().$content();
    this._box = this.dateBox._createComponent(E("<div>").appendTo(t), Mh, {
      direction: "row",
      crossAlign: "stretch",
      items: this._getBoxItems(),
      itemTemplate: (function(e, i, r) {
        var n = E("<div>");
        switch (e.name) {
          case "calendar":
            n.append(this._widget.$element()), this._isShrinkView() && (this._timeView.$element().addClass(iK), n.append(this._timeView.$element()));
            break;
          case "time":
            n.append(this._timeView.$element()), E(r).addClass(iK);
        }
        return n;
      }).bind(this)
    });
  },
  popupConfig: function(t) {
    var e = this.callBase(t);
    return P(e, {
      width: "auto"
    });
  },
  _preventFocusOnPopup: function(t) {
    E(t.target).hasClass("dx-texteditor-input") || (this.callBase.apply(this, arguments), this.dateBox._hasFocusClass() || this.dateBox.focus());
  },
  _updateDateTime: function(t) {
    var e = this._timeView.option("value");
    return t.setHours(e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()), t;
  },
  getValue: function() {
    var t, e = (t = this._widget.option("value")) !== null && t !== void 0 ? t : this._widget.getContouredDate();
    return e = e ? new Date(e) : /* @__PURE__ */ new Date(), this._updateDateTime(e);
  },
  dispose: function() {
    clearTimeout(this._removeMinWidthTimer), clearTimeout(this._repaintTimer), this.callBase();
  }
}), mTe = Ot(), _Te = "date", CTe = {
  min: new Date(0, 0, 0, 0, 0),
  max: new Date(0, 0, 0, 23, 59)
}, yTe = PI.inherit({
  NAME: "List",
  supportedKeys: function() {
    return {
      space: ee,
      home: ee,
      end: ee
    };
  },
  getDefaultOptions: function() {
    return P(this.callBase(), {
      applyValueMode: "instantly"
    });
  },
  getDisplayFormat: function(t) {
    return t || "shorttime";
  },
  popupConfig: function(t) {
    return t;
  },
  getValue: function() {
    var t = this._widget.option("selectedIndex");
    if (t === -1)
      return this.dateBox.option("value");
    var e = this._widgetItems[t];
    return this._getDateByItemData(e);
  },
  useCurrentDateByDefault: function() {
    return !0;
  },
  getDefaultDate: function() {
    return /* @__PURE__ */ new Date(null);
  },
  popupShowingHandler: function() {
    this.dateBox._dimensionChanged();
  },
  _renderWidget: function() {
    this.callBase(), this._refreshItems();
  },
  _getWidgetName: function() {
    return Gm;
  },
  _getWidgetOptions: function() {
    return {
      itemTemplate: this._timeListItemTemplate.bind(this),
      onItemClick: this._listItemClickHandler.bind(this),
      tabIndex: -1,
      onFocusedItemChanged: this._refreshActiveDescendant.bind(this),
      selectionMode: "single"
    };
  },
  _refreshActiveDescendant: function(t) {
    this.dateBox.setAria("activedescendant", ""), this.dateBox.setAria("activedescendant", t.actionValue);
  },
  _refreshItems: function() {
    this._widgetItems = this._getTimeListItems(), this._widget.option("items", this._widgetItems);
  },
  renderOpenedState: function() {
    this._widget && (this._widget.option("focusedElement", null), this._setSelectedItemsByValue(), this._widget.option("templatesRenderAsynchronously") ? this._asyncScrollTimeout = setTimeout(this._scrollToSelectedItem.bind(this)) : this._scrollToSelectedItem());
  },
  dispose: function() {
    this.callBase(), clearTimeout(this._asyncScrollTimeout);
  },
  _updateValue: function() {
    this._widget && (this._refreshItems(), this._setSelectedItemsByValue(), this._scrollToSelectedItem());
  },
  _setSelectedItemsByValue: function() {
    var t = this.dateBoxValue(), e = this._getDateIndex(t);
    e === -1 ? this._widget.option("selectedItems", []) : this._widget.option("selectedIndex", e);
  },
  _scrollToSelectedItem: function() {
    this._widget.scrollToItem(this._widget.option("selectedIndex"));
  },
  _getDateIndex: function(t) {
    for (var e = -1, i = 0, r = this._widgetItems.length; i < r; i++)
      if (this._areDatesEqual(t, this._widgetItems[i])) {
        e = i;
        break;
      }
    return e;
  },
  _areDatesEqual: function(t, e) {
    return zo(t) && zo(e) && t.getHours() === e.getHours() && t.getMinutes() === e.getMinutes();
  },
  _getTimeListItems: function() {
    var t = this.dateBox.dateOption("min") || this._getBoundaryDate("min"), e = this.dateBox.dateOption("max") || this._getBoundaryDate("max"), i = this.dateBox.dateOption("value") || null, r = e - t, n = t.getMinutes() % this.dateBox.option("interval");
    return r < 0 ? [] : (r > Ci.ONE_DAY && (r = Ci.ONE_DAY), i - t < Ci.ONE_DAY ? this._getRangeItems(t, new Date(t), r) : (t = this._getBoundaryDate("min"), t.setMinutes(n), i && Math.abs(i - e) < Ci.ONE_DAY && (r = (60 * e.getHours() + Math.abs(e.getMinutes() - n)) * Ci.ONE_MINUTE), this._getRangeItems(t, new Date(t), r)));
  },
  _getRangeItems: function(t, e, i) {
    for (var r = [], n = this.dateBox.option("interval"); e - t <= i; )
      r.push(new Date(e)), e.setMinutes(e.getMinutes() + n);
    return r;
  },
  _getBoundaryDate: function(t) {
    var e = CTe[t], i = new Date(cr(this.dateBox.dateOption("value"), 0));
    return new Date(i.getFullYear(), i.getMonth(), i.getDate(), e.getHours(), e.getMinutes());
  },
  _timeListItemTemplate: function(t) {
    var e = this.dateBox.option("displayFormat");
    return Bt.format(t, this.getDisplayFormat(e));
  },
  _listItemClickHandler: function(t) {
    if (this.dateBox.option("applyValueMode") !== "useButtons") {
      var e = this._getDateByItemData(t.itemData);
      this.dateBox.option("opened", !1), this.dateBoxValue(e, t.event);
    }
  },
  _getDateByItemData: function(t) {
    var e = this.dateBox.option("value"), i = t.getHours(), r = t.getMinutes(), n = t.getSeconds(), a = t.getFullYear(), o = t.getMonth(), u = t.getDate();
    return e ? (this.dateBox.option("dateSerializationFormat") ? e = $r.deserializeDate(e) : e = new Date(e), e.setHours(i), e.setMinutes(r), e.setSeconds(n), e.setFullYear(a), e.setMonth(o), e.setDate(u)) : e = new Date(a, o, u, i, r, 0, 0), e;
  },
  getKeyboardListener: function() {
    return this._widget;
  },
  _updatePopupHeight: function() {
    var t = WB(this.dateBox.option("dropDownOptions.height"));
    if (t === void 0 || t === "auto") {
      this.dateBox._setPopupOption("height", "auto");
      var e = jt(this._widget.$element()), i = 0.45 * Pt(mTe);
      this.dateBox._setPopupOption("height", Math.min(e, i));
    }
    this.dateBox._timeList && this.dateBox._timeList.updateDimensions();
  },
  getParsedText: function(t, e) {
    var i = this.callBase(t, e);
    return i && (i = Ci.mergeDates(i, /* @__PURE__ */ new Date(null), _Te)), i;
  }
}), Vy = Ot(), Ny = "dx-datebox", xTe = "dx-auto-width", STe = "dx-show-invalid-badge", ETe = "dx-clear-button-area", Cw = "dx-datebox-wrapper", bTe = "dx-dropdowneditor-overlay", Fs = {
  calendar: "calendar",
  rollers: "rollers",
  list: "list",
  native: "native"
}, Bs = {
  date: "date",
  datetime: "datetime",
  time: "time"
}, Hy = {
  calendar: "Calendar",
  dateView: "DateView",
  native: "Native",
  calendarWithTime: "CalendarWithTime",
  list: "List"
}, wTe = {
  Calendar: $X,
  DateView: Ywe,
  Native: qwe,
  CalendarWithTime: gTe,
  List: yTe
}, TTe = UB.inherit({
  _supportedKeys: function() {
    return P(this.callBase(), this._strategy.supportedKeys());
  },
  _renderButtonContainers: function() {
    this.callBase.apply(this, arguments), this._strategy.customizeButtons();
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      type: "date",
      showAnalogClock: !0,
      value: null,
      dateSerializationFormat: void 0,
      min: void 0,
      max: void 0,
      displayFormat: null,
      interval: 30,
      disabledDates: null,
      pickerType: Fs.calendar,
      invalidDateMessage: X.format("dxDateBox-validation-datetime"),
      dateOutOfRangeMessage: X.format("validation-range"),
      applyButtonText: X.format("OK"),
      adaptivityEnabled: !1,
      calendarOptions: {},
      useHiddenSubmitElement: !0,
      _showValidationIcon: !0
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: {
        platform: "ios"
      },
      options: {
        "dropDownOptions.showTitle": !0
      }
    }, {
      device: {
        platform: "android"
      },
      options: {
        buttonsLocation: "bottom after"
      }
    }, {
      device: function() {
        var t = Ye.real(), e = t.platform;
        return e === "ios" || e === "android";
      },
      options: {
        pickerType: Fs.native
      }
    }, {
      device: {
        platform: "generic",
        deviceType: "desktop"
      },
      options: {
        buttonsLocation: "bottom after"
      }
    }]);
  },
  _initOptions: function(t) {
    this._userOptions = P({}, t), this.callBase(t), this._updatePickerOptions();
  },
  _updatePickerOptions: function() {
    var t = this.option("pickerType"), e = this.option("type");
    t === Fs.list && (e === Bs.datetime || e === Bs.date) && (t = Fs.calendar), e === Bs.time && t === Fs.calendar && (t = Fs.list), this._pickerType = t, this._setShowDropDownButtonOption();
  },
  _setShowDropDownButtonOption() {
    var t = Ye.real().platform, e = t === "android" && $i.mozilla, i = this._isNativeType(), r = t !== "generic" || !i;
    i && e && (r = !1), this.option({
      showDropDownButton: r
    });
  },
  _init: function() {
    this._initStrategy(), this.option(P({}, this._strategy.getDefaultOptions(), this._userOptions)), delete this._userOptions, this.callBase();
  },
  _toLowerCaseFirstLetter: function(t) {
    return t.charAt(0).toLowerCase() + t.substr(1);
  },
  _initStrategy: function() {
    var t = this._getStrategyName(this._getFormatType()), e = wTe[t];
    this._strategy && this._strategy.NAME === t || (this._strategy = new e(this));
  },
  _getFormatType: function() {
    var t = this.option("type"), e = /h|m|s/g.test(t), i = /d|M|Y/g.test(t), r = "";
    return i && (r += Bs.date), e && (r += Bs.time), r;
  },
  _getStrategyName: function(t) {
    var e = this._pickerType;
    return e === Fs.rollers ? Hy.dateView : e === Fs.native ? Hy.native : t === Bs.date ? Hy.calendar : t === Bs.datetime ? Hy.calendarWithTime : Hy.list;
  },
  _initMarkup: function() {
    this.$element().addClass(Ny), this.callBase(), this._refreshFormatClass(), this._refreshPickerTypeClass(), this._strategy.renderInputMinMax(this._input());
  },
  _render: function() {
    this.callBase(), this._formatValidationIcon();
  },
  _renderDimensions: function() {
    this.callBase(), this.$element().toggleClass(xTe, !this.option("width")), this._updatePopupWidth(), this._updatePopupHeight();
  },
  _dimensionChanged: function() {
    this.callBase(), this._updatePopupHeight();
  },
  _updatePopupHeight: function() {
    if (this._popup) {
      var t, e;
      (t = (e = this._strategy)._updatePopupHeight) === null || t === void 0 || t.call(e);
    }
  },
  _refreshFormatClass: function() {
    var t = this.$element();
    N(Bs, function(e, i) {
      t.removeClass(Ny + "-" + i);
    }), t.addClass(Ny + "-" + this.option("type"));
  },
  _refreshPickerTypeClass: function() {
    var t = this.$element();
    N(Fs, function(e, i) {
      t.removeClass(Ny + "-" + i);
    }), t.addClass(Ny + "-" + this._pickerType);
  },
  _formatValidationIcon: function() {
    if (wt()) {
      var t = this._input().get(0), e = this.option("rtlEnabled"), i = this._getClearButtonWidth(), r = this._getLongestElementDimensions(), n = parseFloat(Vy.getComputedStyle(t).width) - i, a = r.width > n, o = t.style;
      this.$element().toggleClass(STe, !a && this.option("_showValidationIcon")), a ? (this._storedPadding === void 0 && (this._storedPadding = e ? r.leftPadding : r.rightPadding), e ? o.paddingLeft = 0 : o.paddingRight = 0) : e ? o.paddingLeft = this._storedPadding + "px" : o.paddingRight = this._storedPadding + "px";
    }
  },
  _getClearButtonWidth: function() {
    var t = 0;
    if (this._isClearButtonVisible() && this._input().val() === "") {
      var e = this.$element().find("." + ETe).get(0);
      t = parseFloat(Vy.getComputedStyle(e).width);
    }
    return t;
  },
  _getLongestElementDimensions: function() {
    var t = this._strategy.getDisplayFormat(this.option("displayFormat")), e = Bt.format(Ci.getLongestDate(t, Bt.getMonthNames(), Bt.getDayNames()), t), i = this._input(), r = i.get(0), n = aoe(i, e), a = this._storedPadding !== void 0, o = a ? this._storedPadding : 0;
    n.appendTo(this.$element());
    var u = parseFloat(Vy.getComputedStyle(n.get(0)).width), c = parseFloat(Vy.getComputedStyle(r).paddingRight), p = parseFloat(Vy.getComputedStyle(r).paddingLeft), v = u + p + c + o;
    return n.remove(), {
      width: v,
      leftPadding: p,
      rightPadding: c
    };
  },
  _getKeyboardListeners() {
    return this.callBase().concat([this._strategy && this._strategy.getKeyboardListener()]);
  },
  _renderPopup: function() {
    this.callBase(), this._popup.$wrapper().addClass(Cw), this._renderPopupWrapper();
  },
  _getPopupToolbarItems() {
    var t, e, i, r = this.callBase();
    return (t = (e = (i = this._strategy)._getPopupToolbarItems) === null || e === void 0 ? void 0 : e.call(i, r)) !== null && t !== void 0 ? t : r;
  },
  _popupConfig: function() {
    var t = this.callBase();
    return P(this._strategy.popupConfig(t), {
      title: this._getPopupTitle(),
      dragEnabled: !1
    });
  },
  _renderPopupWrapper: function() {
    if (this._popup) {
      var t = this.$element(), e = P({}, Bs, Fs);
      N(e, (function(i, r) {
        t.removeClass(Cw + "-" + r);
      }).bind(this)), this._popup.$wrapper().addClass(Cw + "-" + this.option("type")).addClass(Cw + "-" + this._pickerType).addClass(bTe);
    }
  },
  _renderPopupContent: function() {
    this.callBase(), this._strategy.renderPopupContent();
  },
  _popupShowingHandler: function() {
    this.callBase(), this._strategy.popupShowingHandler();
  },
  _popupShownHandler: function() {
    this.callBase(), this._strategy.renderOpenedState();
  },
  _popupHiddenHandler: function() {
    this.callBase(), this._strategy.renderOpenedState(), this._strategy.popupHiddenHandler();
  },
  _visibilityChanged: function(t) {
    t && this._formatValidationIcon();
  },
  _clearValueHandler: function(t) {
    this.option("text", ""), this.callBase(t);
  },
  _readOnlyPropValue: function() {
    if (this._pickerType === Fs.rollers)
      return !0;
    var t = Ye.real().platform, e = this._isNativeType() && (t === "ios" || t === "android");
    return e ? this.option("readOnly") : this.callBase();
  },
  _isClearButtonVisible: function() {
    return this.callBase() && !this._isNativeType();
  },
  _renderValue: function() {
    var t = this.dateOption("value");
    return this.option("text", this._getDisplayedText(t)), this._strategy.renderValue(), this.callBase();
  },
  _setSubmitValue: function() {
    var t = this.dateOption("value"), e = this.option("dateSerializationFormat"), i = Ci.SUBMIT_FORMATS_MAP[this.option("type")], r = e ? $r.serializeDate(t, e) : Ci.toStandardDateFormat(t, i);
    this._getSubmitElement().val(r);
  },
  _getDisplayedText: function(t) {
    var e = this.option("mode"), i;
    if (e === "text") {
      var r = this._strategy.getDisplayFormat(this.option("displayFormat"));
      i = Bt.format(t, r);
    } else {
      var n = this._getFormatByMode(e);
      n ? i = Bt.format(t, n) : i = Ci.toStandardDateFormat(t, e);
    }
    return i;
  },
  _getFormatByMode: function(t) {
    return cI(t) ? null : Ci.FORMATS_MAP[t];
  },
  _valueChangeEventHandler: function(t) {
    var {
      text: e,
      type: i,
      validationError: r
    } = this.option(), n = this.dateOption("value");
    if (e === this._getDisplayedText(n)) {
      this._recallInternalValidation(n, r);
      return;
    }
    var a = this._getParsedDate(e), o = n ?? this._getDateByDefault(), u = Ci.mergeDates(o, a, i), c = a && i === "time" ? u : a;
    if (this._applyInternalValidation(c).isValid) {
      var p = this._getDisplayedText(u);
      o && u && o.getTime() === u.getTime() && p !== e ? this._renderValue() : this.dateValue(u, t);
    }
  },
  _recallInternalValidation(t, e) {
    (!e || e.editorSpecific) && (this._applyInternalValidation(t), this._applyCustomValidation(t));
  },
  _getDateByDefault: function() {
    return this._strategy.useCurrentDateByDefault() && this._strategy.getDefaultDate();
  },
  _getParsedDate: function(t) {
    var e = this._strategy.getDisplayFormat(this.option("displayFormat")), i = this._strategy.getParsedText(t, e);
    return i ?? void 0;
  },
  _applyInternalValidation(t) {
    var e = this.option("text"), i = !!e && t !== null, r = !!t && zo(t) && !isNaN(t.getTime()), n = r && Ke.dateInRange(t, this.dateOption("min"), this.dateOption("max"), this.option("type")), a = !i && !t || n, o = "";
    return r ? n || (o = this.option("dateOutOfRangeMessage")) : o = this.option("invalidDateMessage"), this._updateInternalValidationState(a, o), {
      isValid: a,
      isDate: r
    };
  },
  _updateInternalValidationState(t, e) {
    this.option({
      isValid: t,
      validationError: t ? null : {
        editorSpecific: !0,
        message: e
      }
    });
  },
  _applyCustomValidation: function(t) {
    this.validationRequest.fire({
      editor: this,
      value: this._serializeDate(t)
    });
  },
  _isValueChanged: function(t) {
    var e = this.dateOption("value"), i = e && e.getTime(), r = t && t.getTime();
    return i !== r;
  },
  _isTextChanged: function(t) {
    var e = this.option("text"), i = t && this._getDisplayedText(t) || "";
    return e !== i;
  },
  _renderProps: function() {
    this.callBase(), this._input().attr("autocomplete", "off");
  },
  _renderOpenedState: function() {
    this._isNativeType() || this.callBase(), this._strategy.isAdaptivityChanged() && this._refreshStrategy();
  },
  _getPopupTitle: function() {
    var t = this.option("placeholder");
    if (t)
      return t;
    var e = this.option("type");
    return e === Bs.time ? X.format("dxDateBox-simulatedDataPickerTitleTime") : e === Bs.date || e === Bs.datetime ? X.format("dxDateBox-simulatedDataPickerTitleDate") : "";
  },
  _refreshStrategy: function() {
    this._strategy.dispose(), this._initStrategy(), this.option(this._strategy.getDefaultOptions()), this._refresh();
  },
  _applyButtonHandler: function(t) {
    var e = this._strategy.getValue();
    this.dateValue(e, t.event), this.callBase();
  },
  _dispose: function() {
    var t;
    this.callBase(), (t = this._strategy) === null || t === void 0 || t.dispose();
  },
  _isNativeType: function() {
    return this._pickerType === Fs.native;
  },
  _updatePopupTitle: function() {
    var t;
    (t = this._popup) === null || t === void 0 || t.option("title", this._getPopupTitle());
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "showClearButton":
      case "buttons":
        this.callBase.apply(this, arguments), this._formatValidationIcon();
        break;
      case "pickerType":
        this._updatePickerOptions({
          pickerType: t.value
        }), this._refreshStrategy(), this._refreshPickerTypeClass(), this._invalidate();
        break;
      case "type":
        this._updatePickerOptions({
          format: t.value
        }), this._refreshStrategy(), this._refreshFormatClass(), this._renderPopupWrapper(), this._formatValidationIcon(), this._updateValue();
        break;
      case "placeholder":
        this.callBase.apply(this, arguments), this._updatePopupTitle();
        break;
      case "min":
      case "max":
        var e = this.option("isValid");
        this._applyInternalValidation(this.dateOption("value")), e || this._applyCustomValidation(this.dateOption("value")), this._invalidate();
        break;
      case "dateSerializationFormat":
      case "interval":
      case "disabledDates":
      case "calendarOptions":
        this._invalidate();
        break;
      case "displayFormat":
        this.option("text", this._getDisplayedText(this.dateOption("value"))), this._renderInputValue();
        break;
      case "text":
        this._strategy.textChangedHandler(t.value), this.callBase.apply(this, arguments);
        break;
      case "isValid":
        this.callBase.apply(this, arguments), this._formatValidationIcon();
        break;
      case "showDropDownButton":
        this._formatValidationIcon(), this.callBase.apply(this, arguments);
        break;
      case "readOnly":
        this.callBase.apply(this, arguments), this._formatValidationIcon();
        break;
      case "todayButtonText":
        this._setPopupOption("toolbarItems", this._getPopupToolbarItems());
        break;
      case "invalidDateMessage":
      case "dateOutOfRangeMessage":
      case "adaptivityEnabled":
      case "showAnalogClock":
      case "_showValidationIcon":
        break;
      default:
        this.callBase.apply(this, arguments);
    }
  },
  _getSerializationFormat: function() {
    var t = this.option("value");
    if (this.option("dateSerializationFormat") && Oi().forceIsoDateParsing)
      return this.option("dateSerializationFormat");
    if (Di(t))
      return "number";
    if (ht(t))
      return $r.getDateSerializationFormat(t);
  },
  _updateValue: function(t) {
    this.callBase(), this._applyInternalValidation(t ?? this.dateOption("value"));
  },
  dateValue: function(t, e) {
    var i = this._isValueChanged(t);
    return i && e && this._saveValueChangeEvent(e), i || (this._isTextChanged(t) ? this._updateValue(t) : this.option("text") === "" && this._applyCustomValidation(t)), this.dateOption("value", t);
  },
  dateOption: function(t, e) {
    if (arguments.length === 1)
      return $r.deserializeDate(this.option(t));
    this.option(t, this._serializeDate(e));
  },
  _serializeDate: function(t) {
    var e = this._getSerializationFormat();
    return $r.serializeDate(t, e);
  },
  _clearValue: function() {
    var t = this.option("value");
    this.callBase(), t === null && this._applyCustomValidation(null);
  },
  clear: function() {
    var t = this.option("value");
    this.callBase(), t === null && this._applyInternalValidation(null);
  }
}), im = "dateBoxMask", ch = 1, rm = -1, ITe = TTe.inherit({
  _supportedKeys(t) {
    var e = this.callBase(t), i = (n) => {
      var a = e[or(n)];
      return a && a.apply(this, [n]);
    }, r = (n, a) => this._shouldUseOriginalHandler(n) ? i.apply(this, [n]) : a.apply(this, [n]);
    return P({}, e, {
      del: (n) => r(n, (a) => {
        this._revertPart(ch), this._isAllSelected() || a.preventDefault();
      }),
      backspace: (n) => r(n, (a) => {
        this._revertPart(rm), this._isAllSelected() || a.preventDefault();
      }),
      home: (n) => r(n, (a) => {
        this._selectFirstPart(), a.preventDefault();
      }),
      end: (n) => r(n, (a) => {
        this._selectLastPart(), a.preventDefault();
      }),
      escape: (n) => r(n, (a) => {
        this._revertChanges(a);
      }),
      enter: (n) => r(n, () => {
        this._enterHandler();
      }),
      leftArrow: (n) => r(n, (a) => {
        this._selectNextPart(rm), a.preventDefault();
      }),
      rightArrow: (n) => r(n, (a) => {
        this._selectNextPart(ch), a.preventDefault();
      }),
      upArrow: (n) => r(n, (a) => {
        this._upDownArrowHandler(ch), a.preventDefault();
      }),
      downArrow: (n) => r(n, (a) => {
        this._upDownArrowHandler(rm), a.preventDefault();
      })
    });
  },
  _shouldUseOriginalHandler(t) {
    var e = this.option("opened") && t && ["backspace", "del"].indexOf(or(t)) === -1;
    return !this._useMaskBehavior() || e || t && t.altKey;
  },
  _upDownArrowHandler(t) {
    this._setNewDateIfEmpty();
    var e = this._getActivePartValue(this._initialMaskValue), i = this._getActivePartValue(), r = i - e;
    this._loadMaskValue(this._initialMaskValue), this._changePartValue(r + t, !0);
  },
  _changePartValue(t, e) {
    var i = this._getActivePartProp("pattern") === "a";
    i ? this._toggleAmPm() : this._partIncrease(t, e);
  },
  _toggleAmPm() {
    var t = this._getActivePartProp("text"), e = _m.getPeriodNames().indexOf(t), i = 1 ^ e;
    this._setActivePartValue(i);
  },
  _getDefaultOptions() {
    return P(this.callBase(), {
      useMaskBehavior: !1,
      emptyDateValue: new Date(2e3, 0, 1, 0, 0, 0)
    });
  },
  _isSingleCharKey(t) {
    var {
      originalEvent: e,
      alt: i
    } = t, r = e.data || e.key;
    return typeof r == "string" && r.length === 1 && !i && !Cn(e);
  },
  _isSingleDigitKey(t) {
    var e, i = (e = t.originalEvent) === null || e === void 0 ? void 0 : e.data;
    return (i == null ? void 0 : i.length) === 1 && parseInt(i, 10);
  },
  _useBeforeInputEvent: function() {
    return Ye.real().android;
  },
  _keyInputHandler(t, e) {
    var i = this._input().val();
    this._processInputKey(e), t.preventDefault();
    var r = i !== this._input().val();
    r && k.trigger(this._input(), "input");
  },
  _keyboardHandler(t) {
    var e = t.originalEvent.key, i = this.callBase(t);
    return !this._useMaskBehavior() || this._useBeforeInputEvent() || ($i.chrome && t.key === "Process" && t.code.indexOf("Digit") === 0 ? (e = t.code.replace("Digit", ""), this._processInputKey(e), this._maskInputHandler = () => {
      this._renderSelectedPart();
    }) : this._isSingleCharKey(t) && this._keyInputHandler(t.originalEvent, e)), i;
  },
  _maskBeforeInputHandler(t) {
    this._maskInputHandler = null;
    var {
      inputType: e
    } = t.originalEvent;
    e === "insertCompositionText" && (this._maskInputHandler = () => {
      this._renderSelectedPart();
    });
    var i = e === "deleteContentBackward", r = e === "deleteContentForward";
    if (i || r) {
      var n = i ? rm : ch;
      this._maskInputHandler = () => {
        this._revertPart(), this._selectNextPart(n);
      };
    }
    if (!(!this._useMaskBehavior() || !this._isSingleCharKey(t))) {
      var a = t.originalEvent.data;
      return this._keyInputHandler(t, a), !0;
    }
  },
  _keyPressHandler(t) {
    var {
      originalEvent: e
    } = t;
    (e == null ? void 0 : e.inputType) === "insertCompositionText" && this._isSingleDigitKey(t) && (this._processInputKey(e.data), this._renderDisplayText(this._getDisplayedText(this._maskValue)), this._selectNextPart()), this.callBase(t), this._maskInputHandler && (this._maskInputHandler(), this._maskInputHandler = null);
  },
  _processInputKey(t) {
    this._isAllSelected() && (this._activePartIndex = 0), this._setNewDateIfEmpty(), isNaN(parseInt(t)) ? this._searchString(t) : this._searchNumber(t);
  },
  _isAllSelected() {
    var t = this._caret();
    return t.end - t.start === this.option("text").length;
  },
  _getFormatPattern() {
    if (this._formatPattern)
      return this._formatPattern;
    var t = this._strategy.getDisplayFormat(this.option("displayFormat")), e = ht(t) && !Bt._getPatternByFormat(t);
    return e ? this._formatPattern = t : this._formatPattern = M6(function(i) {
      return Bt.format(i, t);
    }), this._formatPattern;
  },
  _setNewDateIfEmpty() {
    if (!this._maskValue) {
      var t = this.option("type") === "time" ? /* @__PURE__ */ new Date(null) : /* @__PURE__ */ new Date();
      this._maskValue = t, this._initialMaskValue = t, this._renderDateParts();
    }
  },
  _partLimitsReached(t) {
    var e = String(t).length, i = this._getActivePartProp("pattern").length, r = i === 1, n = r ? e : Math.min(i, e), a = this._searchValue.length === n, o = parseInt(this._searchValue + "0") > t;
    return a || o;
  },
  _searchNumber(t) {
    var {
      max: e
    } = this._getActivePartLimits(), i = String(e).length;
    this._searchValue = (this._searchValue + t).substr(-i), isNaN(this._searchValue) && (this._searchValue = t), this._setActivePartValue(this._searchValue), this._partLimitsReached(e) && this._selectNextPart(ch);
  },
  _searchString(t) {
    if (isNaN(parseInt(this._getActivePartProp("text")))) {
      for (var e = this._getActivePartProp("limits")(this._maskValue), i = this._searchValue + t.toLowerCase(), r = e.max - e.min, n = 0; n <= r; n++)
        if (this._loadMaskValue(this._initialMaskValue), this._changePartValue(n + 1), this._getActivePartProp("text").toLowerCase().indexOf(i) === 0) {
          this._searchValue = i;
          return;
        }
      this._setNewDateIfEmpty(), this._searchValue && (this._clearSearchValue(), this._searchString(t));
    }
  },
  _clearSearchValue() {
    this._searchValue = "";
  },
  _revertPart: function(t) {
    if (!this._isAllSelected()) {
      var e = this._getActivePartValue(this.option("emptyDateValue"));
      this._setActivePartValue(e), this._selectNextPart(t);
    }
    this._clearSearchValue();
  },
  _useMaskBehavior() {
    return this.option("useMaskBehavior") && this.option("mode") === "text";
  },
  _prepareRegExpInfo() {
    this._regExpInfo = k6(this._getFormatPattern(), Bt);
    var t = this._regExpInfo.regexp, e = t.source, i = t.flags, r = new RegExp(/(\{[0-9]+,?[0-9]*\})/), n = e.split(r).map((a) => r.test(a) ? a : _i.convertDigits(a, !1)).join("");
    this._regExpInfo.regexp = new RegExp(n, i);
  },
  _initMaskState() {
    this._activePartIndex = 0, this._formatPattern = null, this._prepareRegExpInfo(), this._loadMaskValue();
  },
  _renderMask() {
    this.callBase(), this._detachMaskEvents(), this._clearMaskState(), this._useMaskBehavior() && (this._attachMaskEvents(), this._initMaskState(), this._renderDateParts());
  },
  _renderDateParts() {
    if (this._useMaskBehavior()) {
      var t = this.option("text") || this._getDisplayedText(this._maskValue);
      t && (this._dateParts = Ube(t, this._regExpInfo), this._input().is(":hidden") || this._selectNextPart());
    }
  },
  _detachMaskEvents() {
    k.off(this._input(), "." + im);
  },
  _attachMaskEvents() {
    k.on(this._input(), ve("dxclick", im), this._maskClickHandler.bind(this)), k.on(this._input(), ve("paste", im), this._maskPasteHandler.bind(this)), k.on(this._input(), ve("drop", im), () => {
      this._renderSelectedPart();
    }), k.on(this._input(), ve("compositionend", im), this._maskCompositionEndHandler.bind(this)), this._useBeforeInputEvent() && k.on(this._input(), ve("beforeinput", im), this._maskBeforeInputHandler.bind(this));
  },
  _renderSelectedPart() {
    this._renderDisplayText(this._getDisplayedText(this._maskValue)), this._selectNextPart();
  },
  _selectLastPart() {
    this.option("text") && (this._activePartIndex = this._dateParts.length, this._selectNextPart(rm));
  },
  _selectFirstPart() {
    this.option("text") && (this._activePartIndex = -1, this._selectNextPart(ch));
  },
  _onMouseWheel(t) {
    this._useMaskBehavior() && this._partIncrease(t.delta > 0 ? ch : rm, t);
  },
  _selectNextPart() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    if (!(!this.option("text") || this._disposed)) {
      t && (this._initialMaskValue = new Date(this._maskValue));
      var e = ma(this._activePartIndex + t, 0, this._dateParts.length - 1);
      if (this._dateParts[e].isStub) {
        var i = e === 0 && t < 0 || e === this._dateParts.length - 1 && t > 0;
        if (i)
          e = this._activePartIndex;
        else {
          this._selectNextPart(t >= 0 ? t + 1 : t - 1);
          return;
        }
      }
      this._activePartIndex !== e && this._clearSearchValue(), this._activePartIndex = e, this._caret(this._getActivePartProp("caret"));
    }
  },
  _getRealLimitsPattern() {
    if (this._getActivePartProp("pattern")[0] === "d")
      return "dM";
  },
  _getActivePartLimits(t) {
    var e = this._getActivePartProp("limits");
    return e(this._maskValue, t && this._getRealLimitsPattern());
  },
  _getActivePartValue(t) {
    t = t || this._maskValue;
    var e = this._getActivePartProp("getter");
    return Le(e) ? e(t) : t[e]();
  },
  _addLeadingZeroes(t) {
    var e = this._searchValue.match(/^0+/), i = this._getActivePartLimits(), r = String(i.max).length;
    return ((e && e[0] || "") + String(t)).substr(-r);
  },
  _setActivePartValue(t, e) {
    e = e || this._maskValue;
    var i = this._getActivePartProp("setter"), r = this._getActivePartLimits();
    t = Ud(t, r.min, r.max) ? t : t % 10, t = this._addLeadingZeroes(ma(t, r.min, r.max)), Le(i) ? i(e, t) : e[i](t), this._renderDisplayText(this._getDisplayedText(e)), this._renderDateParts();
  },
  _getActivePartProp(t) {
    if (!(!this._dateParts || !this._dateParts[this._activePartIndex]))
      return this._dateParts[this._activePartIndex][t];
  },
  _loadMaskValue() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.dateOption("value");
    this._maskValue = t && new Date(t), this._initialMaskValue = t && new Date(t);
  },
  _saveMaskValue() {
    var t = this._maskValue && new Date(this._maskValue);
    t && this.option("type") === "date" && t.setHours(0, 0, 0, 0), this._initialMaskValue = new Date(t), this.dateOption("value", t);
  },
  _revertChanges() {
    this._loadMaskValue(), this._renderDisplayText(this._getDisplayedText(this._maskValue)), this._renderDateParts();
  },
  _renderDisplayText(t) {
    this.callBase(t), this._useMaskBehavior() && this.option("text", t);
  },
  _partIncrease(t, e) {
    this._setNewDateIfEmpty();
    var {
      max: i,
      min: r
    } = this._getActivePartLimits(e), n = t + this._getActivePartValue();
    n > i ? n = this._applyLimits(n, {
      limitBase: r,
      limitClosest: i,
      max: i
    }) : n < r && (n = this._applyLimits(n, {
      limitBase: i,
      limitClosest: r,
      max: i
    })), this._setActivePartValue(n);
  },
  _applyLimits(t, e) {
    var {
      limitBase: i,
      limitClosest: r,
      max: n
    } = e, a = (t - r) % n;
    return a ? i + a - 1 * Am(a) : r;
  },
  _maskClickHandler() {
    this._loadMaskValue(this._maskValue), this.option("text") && (this._activePartIndex = Gbe(this._dateParts, this._caret().start), this._isAllSelected() || (R(this._activePartIndex) ? this._caret(this._getActivePartProp("caret")) : this._selectLastPart()));
  },
  _maskCompositionEndHandler(t) {
    this._input().val(this._getDisplayedText(this._maskValue)), this._selectNextPart(), this._maskInputHandler = () => {
      this._renderSelectedPart();
    };
  },
  _maskPasteHandler(t) {
    var e = this._replaceSelectedText(this.option("text"), this._caret(), Lk(t)), i = Bt.parse(e, this._getFormatPattern());
    i && this._isDateValid(i) && (this._maskValue = i, this._renderDisplayText(this._getDisplayedText(this._maskValue)), this._renderDateParts(), this._selectNextPart()), t.preventDefault();
  },
  _isDateValid: (t) => zo(t) && !isNaN(t),
  _isValueDirty() {
    var t = this.dateOption("value");
    return (this._maskValue && this._maskValue.getTime()) !== (t && t.getTime());
  },
  _fireChangeEvent() {
    this._clearSearchValue(), this._isValueDirty() && k.trigger(this._input(), "change");
  },
  _enterHandler() {
    this._fireChangeEvent(), this._selectNextPart(ch);
  },
  _focusOutHandler(t) {
    var e = this._useMaskBehavior() && !t.isDefaultPrevented();
    e ? (this._fireChangeEvent(), this.callBase(t), this._selectFirstPart(t)) : this.callBase(t);
  },
  _valueChangeEventHandler(t) {
    var e = this.option("text");
    this._useMaskBehavior() ? (this._saveValueChangeEvent(t), e ? this._maskValue === null && this._loadMaskValue(e) : this._maskValue = null, this._saveMaskValue()) : this.callBase(t);
  },
  _optionChanged(t) {
    switch (t.name) {
      case "useMaskBehavior":
        this._renderMask();
        break;
      case "displayFormat":
      case "mode":
        this.callBase(t), this._renderMask();
        break;
      case "value":
        this._loadMaskValue(), this.callBase(t), this._renderDateParts();
        break;
      case "emptyDateValue":
        break;
      default:
        this.callBase(t);
    }
  },
  _clearMaskState() {
    this._clearSearchValue(), delete this._dateParts, delete this._activePartIndex, delete this._maskValue;
  },
  clear() {
    this._clearMaskState(), this._activePartIndex = 0, this.callBase();
  },
  _clean() {
    this.callBase(), this._detachMaskEvents(), this._clearMaskState();
  }
});
ti("dxDateBox", ITe);
var {
  isWrapped: DTe
} = Ha, ATe = "checkbox-size", OTe = "dx-editor-inline-block", IS = function(t, e) {
  return P(t, {
    readOnly: e.readOnly,
    placeholder: e.placeholder,
    inputAttr: {
      id: e.id,
      "aria-labelledby": e["aria-labelledby"]
    },
    tabIndex: e.tabIndex
  }, e.editorOptions);
}, KX = function() {
  return $i.mozilla || Ye.real().ios;
}, jX = function(t) {
  var e = {}, i = KX(), r = t.sharedData || e;
  return IS({
    placeholder: t.placeholder,
    width: t.width,
    value: t.value,
    onValueChanged: function(n) {
      var a = t.parentType === "filterRow" || t.parentType === "searchPanel", o = n.event && (n.event.type === "input" || n.event.type === "keyup"), u = function(c, p) {
        t && t.setValue(c.value, p);
      };
      clearTimeout(e.valueChangeTimeout), o && a ? r.valueChangeTimeout = e.valueChangeTimeout = setTimeout(function() {
        u(n, e.valueChangeTimeout !== r.valueChangeTimeout);
      }, R(t.updateValueTimeout) ? t.updateValueTimeout : 0) : u(n);
    },
    onKeyDown: function(n) {
      i && or(n.event) === "enter" && k.trigger(E(n.component._input()), "change");
    },
    valueChangeEvent: "change" + (t.parentType === "filterRow" ? " keyup input" : "")
  }, t);
}, rK = function(t) {
  t.editorName = "dxDateBox", t.editorOptions = IS({
    value: t.value,
    onValueChanged: function(e) {
      t.setValue(e.value);
    },
    onKeyDown: function(e) {
      var {
        component: i,
        event: r
      } = e, n = i.option("useMaskBehavior");
      (KX() || n) && or(r) === "enter" && (i.blur(), i.focus());
    },
    displayFormat: t.format,
    type: t.dataType,
    dateSerializationFormat: null,
    width: t.parentType === "filterBuilder" ? void 0 : "auto"
  }, t);
}, nK = function(t) {
  var e = jX(t), i = t.parentType === "searchPanel";
  t.editorType && t.editorType !== "dxTextBox" ? e.value = t.value : e.value = (r = t.value, R(r) ? r.toString() : "");
  var r;
  e.valueChangeEvent += i ? " keyup input search" : "", e.mode = e.mode || (i ? "search" : "text"), t.editorName = "dxTextBox", t.editorOptions = e;
}, aK = function(t) {
  var e = jX(t);
  e.value = R(t.value) ? t.value : null, t.editorName = "dxNumberBox", t.editorOptions = e;
}, RTe = function(t) {
  t.parentType === "filterRow" || t.parentType === "filterBuilder" ? YX(P(t, {
    lookup: {
      displayExpr: function(e) {
        if (e === !0)
          return t.trueText || "true";
        if (e === !1)
          return t.falseText || "false";
      },
      dataSource: [!0, !1]
    }
  })) : qX(t);
};
function LTe(t) {
  if (t.row && t.row.watch && t.parentType === "dataRow") {
    var e = t.editorOptions || {};
    t.editorOptions = e;
    var i, r = e.onInitialized;
    e.onInitialized = function(o) {
      r && r.apply(this, arguments), i = o.component, i.on("disposing", a);
    };
    var n, a = t.row.watch(() => (n = t.lookup.dataSource(t.row), n && n.filter), () => {
      i.option("dataSource", n);
    }, (o) => {
      t.row = o;
    });
  }
}
function YX(t) {
  var e = t.lookup, i, r, n, a = t.parentType === "filterRow";
  if (e) {
    var o;
    i = Ii(e.displayExpr), r = e.dataSource, Le(r) && !DTe(r) && (r = r(t.row || {}), LTe(t)), (ct(r) || Array.isArray(r)) && (r = zp(r), a && (n = r.postProcess, r.postProcess = function(c) {
      return this.pageIndex() === 0 && (c = c.slice(0), c.unshift(null)), n ? n.call(this, c) : c;
    }));
    var u = !!(e.allowClearing && !a);
    t.editorName = (o = t.editorType) !== null && o !== void 0 ? o : "dxSelectBox", t.editorOptions = IS({
      searchEnabled: !0,
      value: t.value,
      valueExpr: t.lookup.valueExpr,
      searchExpr: t.lookup.searchExpr || t.lookup.displayExpr,
      allowClearing: u,
      showClearButton: u,
      displayExpr: function(c) {
        return c === null ? t.showAllText : i(c);
      },
      dataSource: r,
      onValueChanged: function(c) {
        var p = [c.value];
        !a && p.push(c.component.option("text")), t.setValue.apply(this, p);
      }
    }, t);
  }
}
function qX(t) {
  t.editorName = "dxCheckBox", t.editorOptions = IS({
    elementAttr: {
      id: t.id
    },
    value: R(t.value) ? t.value : void 0,
    hoverStateEnabled: !t.readOnly,
    focusStateEnabled: !t.readOnly,
    activeStateEnabled: !1,
    onValueChanged: function(e) {
      t.setValue && t.setValue(e.value, e);
    }
  }, t);
}
var MTe = function(t, e) {
  var i = E(e.editorElement);
  if (e.editorName && e.editorOptions && i[e.editorName]) {
    if ((e.editorName === "dxCheckBox" || e.editorName === "dxSwitch") && (e.isOnForm || (i.addClass(t.addWidgetPrefix(ATe)), i.parent().addClass(OTe))), t._createComponent(i, e.editorName, e.editorOptions), e.editorName === "dxDateBox") {
      var r = i.dxDateBox("instance"), n = r._supportedKeys().enter;
      r.registerKeyHandler("enter", (a) => (r.option("opened") && n(a), !0));
    }
    e.editorName === "dxTextArea" && i.dxTextArea("instance").registerKeyHandler("enter", function(a) {
      or(a) === "enter" && !a.ctrlKey && !a.shiftKey && a.stopPropagation();
    });
  }
}, kTe = (t) => {
  t.editorName = t.editorType, t.editorOptions = IS({
    value: t.value,
    onValueChanged: function(e) {
      t.setValue(e.value);
    }
  }, t);
}, PTe = (t) => {
  var e = {
    dxDateBox: rK,
    dxCheckBox: qX,
    dxNumberBox: aK,
    dxTextBox: nK
  };
  if (t.lookup)
    YX(t);
  else if (t.editorType) {
    var i;
    ((i = e[t.editorType]) !== null && i !== void 0 ? i : kTe)(t);
  } else
    switch (t.dataType) {
      case "date":
      case "datetime":
        rK(t);
        break;
      case "boolean":
        RTe(t);
        break;
      case "number":
        aK(t);
        break;
      default:
        nK(t);
    }
}, XX = (t) => class extends t {
  createEditor(e, i) {
    i.cancel = !1, i.editorElement = ot(e), R(i.tabIndex) || (i.tabIndex = this.option("tabIndex")), PTe(i), this.executeAction("onEditorPreparing", i), !i.cancel && (i.parentType === "dataRow" && !i.isOnForm && !R(i.editorOptions.showValidationMark) && (i.editorOptions.showValidationMark = !1), MTe(this, i), this.executeAction("onEditorPrepared", i));
  }
}, FTe = "dx-editor-inline-block", AM = "dx-cell-focus-disabled", BTe = "dx-cell-modified", VTe = "invalid", NTe = "dx-focused-cell-modified", HTe = "dx-focused-cell-invalid", oK = "focus-overlay", $Te = "content", OM = "dx-focused", zTe = "dx-row", QX = "dxDataGridEditorFactory", sK = ve([Xt.down, "focusin", di].join(" "), QX), RM = "dx-hidden", WTe = XX(Bi.ViewController);
let UTe = class extends WTe {
  init() {
    this.createAction("onEditorPreparing", {
      excludeValidators: ["disabled", "readOnly"],
      category: "rendering"
    }), this.createAction("onEditorPrepared", {
      excludeValidators: ["disabled", "readOnly"],
      category: "rendering"
    }), this._columnsResizerController = this.getController("columnsResizer"), this._editingController = this.getController("editing"), this._keyboardNavigationController = this.getController("keyboardNavigation"), this._columnsController = this.getController("columns"), this._validatingController = this.getController("validating"), this._rowsView = this.getView("rowsView"), this._updateFocusHandler = this._updateFocusHandler || this.createAction(this._updateFocus.bind(this)), this._subscribedContainerRoot = this._getContainerRoot(), k.on(this._subscribedContainerRoot, sK, this._updateFocusHandler), this._attachContainerEventHandlers();
  }
  dispose() {
    clearTimeout(this._focusTimeoutID), clearTimeout(this._updateFocusTimeoutID), k.off(this._subscribedContainerRoot, sK, this._updateFocusHandler);
  }
  _getFocusedElement(e) {
    var i = this.option("focusedRowEnabled") ? "tr[tabindex]:focus" : "tr[tabindex]:not(.dx-data-row):focus", r = ["td[tabindex]:focus", "".concat(i), "input:focus", "button:focus", "textarea:focus", "div[tabindex]:focus", ".dx-lookup-field:focus", ".dx-checkbox:focus", ".dx-switch:focus", ".dx-dropdownbutton", ".dx-buttongroup:focus", ".dx-adaptive-item-text:focus"].join(","), n = e.find(r);
    return this.elementIsInsideGrid(n) && n;
  }
  _getFocusCellSelector() {
    return ".dx-row > td";
  }
  _updateFocusCore() {
    var e = this.component && this.component.$element();
    if (e) {
      var i = this._getFocusedElement(e);
      if (i && i.length) {
        var r;
        if (!i.hasClass(AM) && !i.hasClass(zTe)) {
          var n = i.closest("".concat(this._getFocusCellSelector(), ", .").concat(AM));
          n.get(0) !== i.get(0) && (r = this._needHideBorder(n), i = n);
        }
        if (i.length && !i.hasClass(AM)) {
          this.focus(i, r);
          return;
        }
      }
    }
    this.loseFocus();
  }
  _needHideBorder(e) {
    var i = this._rowsView.element(), r = e.closest(i).length > 0, n = this._editingController.isEditing();
    return e.hasClass(FTe) || r && !n;
  }
  _updateFocus(e) {
    var i = this, r = e && e.event && E(e.event.target).hasClass(i.addWidgetPrefix(oK));
    i._isFocusOverlay = i._isFocusOverlay || r, clearTimeout(i._updateFocusTimeoutID), i._updateFocusTimeoutID = setTimeout(() => {
      delete i._updateFocusTimeoutID, i._isFocusOverlay || i._updateFocusCore(), i._isFocusOverlay = !1;
    });
  }
  _updateFocusOverlaySize(e, i) {
    e.hide();
    var r = kl.calculate(e, P({
      collision: "fit"
    }, i));
    r.h.oversize > 0 && c$(e, oi(e) - r.h.oversize), r.v.oversize > 0 && h$(e, jt(e) - r.v.oversize), e.show();
  }
  callbackNames() {
    return ["focused"];
  }
  focus(e, i) {
    var r = this;
    if (e === void 0)
      return r._$focusedElement;
    e && (e.is(r._$focusedElement) || r._$focusedElement && r._$focusedElement.removeClass(OM), r._$focusedElement = e, clearTimeout(r._focusTimeoutID), r._focusTimeoutID = setTimeout(() => {
      delete r._focusTimeoutID, r.renderFocusOverlay(e, i), e.addClass(OM), r.focused.fire(e);
    }));
  }
  refocus() {
    var e = this.focus();
    this.focus(e);
  }
  renderFocusOverlay(e, i) {
    if (xe.isElementInCurrentGrid(this, e)) {
      if (this._$focusOverlay || (this._$focusOverlay = E("<div>").addClass(this.addWidgetPrefix(oK))), i)
        this._$focusOverlay.addClass(RM);
      else if (e.length) {
        var r = $i.mozilla ? "right bottom" : "left top", n = e.closest(".".concat(this.addWidgetPrefix($Te))), a = zr(e.get(0)), o = e.hasClass(this.addWidgetPrefix(VTe)), u = e.hasClass(BTe) && !o;
        this._$focusOverlay.removeClass(RM).toggleClass(HTe, o).toggleClass(NTe, u).appendTo(n), h$(this._$focusOverlay, a.bottom - a.top + 1), c$(this._$focusOverlay, a.right - a.left + 1);
        var c = {
          precise: !0,
          my: r,
          at: r,
          of: e,
          boundary: n.length && n
        };
        this._updateFocusOverlaySize(this._$focusOverlay, c), kl.setup(this._$focusOverlay, c), this._$focusOverlay.css("visibility", "visible");
      }
    }
  }
  resize() {
    var e = this._$focusedElement;
    e && this.focus(e);
  }
  loseFocus(e) {
    this._$focusedElement && this._$focusedElement.removeClass(OM), this._$focusedElement = null, this._$focusOverlay && this._$focusOverlay.addClass(RM);
  }
  _getContainerRoot() {
    var e, i = (e = this.component) === null || e === void 0 ? void 0 : e.$element(), r = de.getRootNode(i == null ? void 0 : i.get(0));
    return r.nodeType === Node.DOCUMENT_FRAGMENT_NODE && !r.host ? de.getDocument() : r;
  }
  _attachContainerEventHandlers() {
    var e = this, i = e.component && e.component.$element();
    i && k.on(i, ve("keydown", QX), (r) => {
      or(r) === "tab" && e._updateFocusHandler(r);
    });
  }
};
var GTe = {
  defaultOptions: () => ({}),
  controllers: {
    editorFactory: UTe
  }
};
et.registerModule("editorFactory", GTe);
var yw = Ot(), KTe = {
  text: "OK",
  onClick: function() {
    return !0;
  }
}, Yp = "dx-dialog", jTe = "".concat(Yp, "-wrapper"), YTe = "".concat(Yp, "-root"), qTe = "".concat(Yp, "-content"), XTe = "".concat(Yp, "-message"), QTe = "".concat(Yp, "-buttons"), ZTe = "".concat(Yp, "-button"), lK = "dx-button", JTe = () => za() ? {
  stylingMode: "contained",
  type: "default"
} : {}, eIe = () => za() ? {
  stylingMode: "outlined",
  type: "default"
} : {}, tIe = function(t) {
  var e, i = new q();
  t = t || {};
  var r = E("<div>").addClass(Yp).appendTo(Oh()), n = "message" in t, a = "messageHtml" in t;
  n && Yt.log("W1013");
  var o = String(a ? t.messageHtml : t.message), u = t.title ? null : new yr(), c = E("<div>").addClass(XTe).html(o).attr("id", u), p = [], v = new Hu(r, P({
    title: (e = t.title) !== null && e !== void 0 ? e : "",
    showTitle: cr(t.showTitle, !0),
    dragEnabled: cr(t.dragEnabled, !0),
    height: "auto",
    width: t.width,
    showCloseButton: t.showCloseButton || !1,
    ignoreChildEvents: !1,
    container: r,
    visualContainer: yw,
    dragAndResizeArea: yw,
    onContentReady: function(b) {
      b.component.$content().addClass(qTe).append(c), u && b.component.$overlayContent().attr("aria-labelledby", u);
    },
    onShowing: function(b) {
      b.component.bottomToolbar().addClass(QTe).find(".".concat(lK)).addClass(ZTe), $m();
    },
    onShown: function(b) {
      var I = b.component.bottomToolbar().find(".".concat(lK)).first();
      k.trigger(I, "focus");
    },
    onHiding: function() {
      i.reject();
    },
    onHidden: function(b) {
      var {
        element: I
      } = b;
      E(I).remove();
    },
    animation: {
      show: {
        type: "pop",
        duration: 400
      },
      hide: {
        type: "pop",
        duration: 400,
        to: {
          opacity: 0,
          scale: 0
        },
        from: {
          opacity: 1,
          scale: 1
        }
      }
    },
    rtlEnabled: Oi().rtlEnabled,
    position: {
      boundaryOffset: {
        h: 10,
        v: 0
      }
    }
  }, t.popupOptions)), _ = t.buttons || [KTe];
  _.forEach((b) => {
    var I = new $o(b.onClick, {
      context: v
    });
    p.push({
      toolbar: "bottom",
      location: Ye.current().android ? "after" : "center",
      widget: "dxButton",
      options: ae({}, b, {
        onClick: function() {
          var A = I.execute(...arguments);
          y(A);
        }
      })
    });
  }), v.option("toolbarItems", p), v.$wrapper().addClass(jTe), t.position && v.option("position", t.position), v.$wrapper().addClass(YTe);
  function y(b) {
    i.resolve(b), v.hide();
  }
  return {
    show: function() {
      if (Ye.real().deviceType === "phone") {
        var b = Pt(yw) > mt(yw), I = b ? "90%" : "60%";
        v.option({
          width: I
        });
      }
      return v.show(), i.promise();
    },
    hide: y
  };
};
var iIe = function(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i = arguments.length > 2 ? arguments[2] : void 0, r = $t(t) ? t : {
    title: e,
    messageHtml: t,
    showTitle: i,
    buttons: [ae({
      text: X.format("Yes"),
      onClick: function() {
        return !0;
      }
    }, JTe()), ae({
      text: X.format("No"),
      onClick: function() {
        return !1;
      }
    }, eIe())],
    dragEnabled: i
  };
  return tIe(r).show();
}, FI = "dx-editor-cell", vh = "dx-row", rIe = "dx-cell-modified", uK = "dx-selection", KT = "edit-form", Eu = "insert", Bd = "remove", Zw = "editing.popup", LM = "editing.form", os = "editing.editRowKey", gp = "editing.editColumnName", ZX = "targetComponent", YB = "input:not([type='hidden'])", qB = "[tabindex]:not([disabled]), ".concat(YB, ":not([disabled])"), Fp = "batch", Xd = "row", km = "cell", Km = "form", XB = "popup", dK = "first", xw = "last", cK = "pageBottom", MM = "pageTop", hK = "viewportBottom", JX = "viewportTop", nIe = [Fp, Xd, km, Km, XB], aIe = [Xd, Km, XB], oIe = [Fp, km], sIe = [Fp, Xd, km], lIe = [Xd, Km], uIe = "readonly", dIe = "dx-link", cIe = "dx-link-icon", hIe = "dx-selection", fIe = "dx-edit-button", e8 = "dx-command-edit", fK = "".concat(e8, "-with-icons"), hh = "__DX_INSERT_INDEX__", pIe = "dx-row-inserted", vIe = "dx-row-modified", pK = "dx-cell-modified", gIe = "dxDataGridEditing", mIe = "dx-cell-focus-disabled", $y = "update", _Ie = "click", CIe = {
  save: "dx-link-save",
  cancel: "dx-link-cancel",
  edit: "dx-link-edit",
  undelete: "dx-link-undelete",
  delete: "dx-link-delete",
  add: "dx-link-add"
}, yIe = {
  save: "save",
  cancel: "revert",
  edit: "edit",
  undelete: "revert",
  delete: "trash",
  add: "add"
}, xIe = {
  edit: "editRow",
  delete: "deleteRow",
  undelete: "undeleteRow",
  save: "saveEditData",
  cancel: "cancelEditData",
  add: "addRowByRowIndex"
}, SIe = {
  add: "allowAdding",
  edit: "allowUpdating",
  delete: "allowDeleting"
}, EIe = ["edit", "save", "cancel", "delete", "undelete"], Vd = "editing.changes", bIe = "focus-overlay", wIe = "addrow-button", TIe = "dx-dropdowneditor-overlay", IIe = "dx-data-row", DIe = "dx-row-removed", AIe = !!ds.IS_RENOVATED_WIDGET, t8 = "edit-form-item", OIe = "edit-popup", RIe = "edit-popup-form", LIe = AIe ? "dx-scrollable" : "dx-scrollable-container", MIe = "dx-button", kIe = "form-buttons-container", vK = "dx-edit-row", OP = "_DX_KEY_", PIe = 36, zy = function(t) {
  return function(e) {
    var i = e instanceof Error ? e : new Error(e && String(e) || "Unknown error");
    t.reject(i);
  };
}, i8 = function(t, e) {
  return e.isEditing || t && e.column.allowEditing;
}, gK = function(t, e) {
  var i = !!e.column.command, r = i8(t, e), n = !i && (r || e.column.showEditorAlways);
  return e.rowType === "data" && n;
}, FIe = (t) => {
  var e = t.component.option("editing.texts") || {};
  return {
    save: e.saveRowChanges,
    cancel: e.cancelRowChanges,
    edit: e.editRow,
    undelete: e.undeleteRow,
    delete: e.deleteRow,
    add: e.addRowToNode
  };
}, BIe = () => "".concat(OP).concat(new yr()), VIe = (t) => typeof t == "string" && t.startsWith(OP) && t.length === OP.length + PIe, nm = (t, e) => {
  var i = -1;
  return t.some((r, n) => {
    if (r8(r) === e)
      return i = n, !0;
  }), i;
};
function r8(t) {
  return ct(t) ? t.name : t;
}
function NIe(t) {
  return t && (t.is("input") || t.is("textarea"));
}
var HIe = (t) => {
  var e, {
    column: i
  } = t;
  return t.isCustomEditorType ? t.editorType : (e = i.formItem) === null || e === void 0 ? void 0 : e.editorType;
}, n8 = (t, e) => {
  t.forEach((i) => {
    i.items || i.tabs ? n8(i.items || i.tabs, e) : e(i);
  });
};
class $Ie extends Bi.ViewController {
  init() {
    this._columnsController = this.getController("columns"), this._dataController = this.getController("data"), this._adaptiveColumnsController = this.getController("adaptiveColumns"), this._validatingController = this.getController("validating"), this._editorFactoryController = this.getController("editorFactory"), this._focusController = this.getController("focus"), this._keyboardNavigationController = this.getController("keyboardNavigation"), this._columnsResizerController = this.getController("columnsResizer"), this._errorHandlingController = this.getController("errorHandling"), this._rowsView = this.getView("rowsView"), this._headerPanelView = this.getView("headerPanel"), this._lastOperation = null, this._changes = [], this._deferreds && this._deferreds.forEach((e) => {
      e.reject("cancel");
    }), this._deferreds = [], this._dataChangedHandler || (this._dataChangedHandler = this._handleDataChanged.bind(this), this._dataController.changed.add(this._dataChangedHandler)), this._saveEditorHandler || (this.createAction("onInitNewRow", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onRowInserting", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onRowInserted", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onEditingStart", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onRowUpdating", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onRowUpdated", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onRowRemoving", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onRowRemoved", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onSaved", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onSaving", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onEditCanceling", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onEditCanceled", {
      excludeValidators: ["disabled", "readOnly"]
    })), this._updateEditColumn(), this._updateEditButtons(), this._internalState || (this._internalState = []), this.component._optionsByReference[os] = !0, this.component._optionsByReference[Vd] = !0;
  }
  getEditMode() {
    var e, i = (e = this.option("editing.mode")) !== null && e !== void 0 ? e : Xd;
    return nIe.includes(i) ? i : Xd;
  }
  isCellBasedEditMode() {
    var e = this.getEditMode();
    return oIe.includes(e);
  }
  _getDefaultEditorTemplate() {
    return (e, i) => {
      var r = E("<div>").appendTo(e), n = P({}, i.column, {
        value: i.value,
        setValue: i.setValue,
        row: i.row,
        parentType: "dataRow",
        width: null,
        readOnly: !i.setValue,
        isOnForm: i.isOnForm,
        id: i.id
      }), a = sIe.includes(this.getEditMode());
      a && (n["aria-labelledby"] = i.column.headerId), this._editorFactoryController.createEditor(r, n);
    };
  }
  _getNewRowPosition() {
    var e = this.option("editing.newRowPosition"), i = this.option("scrolling.mode");
    if (i === "virtual")
      switch (e) {
        case MM:
          return JX;
        case cK:
          return hK;
        default:
          return e;
      }
    return e;
  }
  getChanges() {
    return this.option(Vd);
  }
  getInsertRowCount() {
    var e = this.option(Vd);
    return e.filter((i) => i.type === "insert").length;
  }
  resetChanges() {
    var e = this.getChanges(), i = e == null ? void 0 : e.length;
    i && this._silentOption(Vd, []);
  }
  _getInternalData(e) {
    return this._internalState.filter((i) => Mi(i.key, e))[0];
  }
  _addInternalData(e) {
    var i = this._getInternalData(e.key);
    return i ? P(i, e) : (this._internalState.push(e), e);
  }
  _getOldData(e) {
    var i;
    return (i = this._getInternalData(e)) === null || i === void 0 ? void 0 : i.oldData;
  }
  getUpdatedData(e) {
    var i = this._dataController.keyOf(e), r = this.getChanges(), n = xe.getIndexByKey(i, r);
    return r[n] ? xh(e, r[n].data) : e;
  }
  getInsertedData() {
    return this.getChanges().filter((e) => e.data && e.type === Eu).map((e) => e.data);
  }
  getRemovedData() {
    return this.getChanges().filter((e) => this._getOldData(e.key) && e.type === Bd).map((e) => this._getOldData(e.key));
  }
  _fireDataErrorOccurred(e) {
    if (e !== "cancel") {
      var i = this.getPopupContent();
      this._dataController.dataErrorOccurred.fire(e, i);
    }
  }
  _needToCloseEditableCell(e) {
  }
  _closeEditItem(e) {
  }
  _handleDataChanged(e) {
  }
  _isDefaultButtonVisible(e, i) {
    var r = !0;
    switch (e.name) {
      case "delete":
        r = this.allowDeleting(i);
        break;
      case "undelete":
        r = !1;
    }
    return r;
  }
  _isButtonVisible(e, i) {
    var {
      visible: r
    } = e;
    return R(r) ? Le(r) ? r.call(e, {
      component: i.component,
      row: i.row,
      column: i.column
    }) : r : this._isDefaultButtonVisible(e, i);
  }
  _isButtonDisabled(e, i) {
    var {
      disabled: r
    } = e;
    return Le(r) ? r.call(e, {
      component: i.component,
      row: i.row,
      column: i.column
    }) : !!r;
  }
  _getButtonConfig(e, i) {
    var r = ct(e) ? e : {}, n = r8(e), a = FIe(i), o = xIe[n], u = this.option("editing"), c = SIe[n], p = c ? u[c] : !0;
    return P({
      name: n,
      text: a[n],
      cssClass: CIe[n]
    }, {
      onClick: o && ((v) => {
        var {
          event: _
        } = v;
        _.stopPropagation(), _.preventDefault(), setTimeout(() => {
          i.row && p && this[o] && this[o](i.row.rowIndex);
        });
      })
    }, r);
  }
  _getEditingButtons(e) {
    var i, r = !!e.column.buttons, n = (e.column.buttons || []).slice();
    return r ? (i = nm(n, "edit"), i >= 0 && (nm(n, "save") < 0 && n.splice(i + 1, 0, "save"), nm(n, "cancel") < 0 && n.splice(nm(n, "save") + 1, 0, "cancel")), i = nm(n, "delete"), i >= 0 && nm(n, "undelete") < 0 && n.splice(i + 1, 0, "undelete")) : n = EIe.slice(), n.map((a) => this._getButtonConfig(a, e));
  }
  _renderEditingButtons(e, i, r, n) {
    i.forEach((a) => {
      this._isButtonVisible(a, r) && this._createButton(e, a, r, n);
    });
  }
  _getEditCommandCellTemplate() {
    return (e, i, r) => {
      var n = E(e);
      if (i.rowType === "data") {
        var a = this._getEditingButtons(i);
        if (this._renderEditingButtons(n, a, i, r), i.watch) {
          var o = i.watch(() => a.map((u) => ({
            visible: this._isButtonVisible(u, i),
            disabled: this._isButtonDisabled(u, i)
          })), () => {
            n.empty(), this._renderEditingButtons(n, a, i);
          });
          k.on(n, fo, o);
        }
      } else
        xe.setEmptyText(n);
    };
  }
  isRowBasedEditMode() {
    var e = this.getEditMode();
    return aIe.includes(e);
  }
  getFirstEditableColumnIndex() {
    var e, i = this._columnsController.getVisibleColumns();
    return N(i, (r, n) => {
      if (n.allowEditing)
        return e = r, !1;
    }), e;
  }
  getFirstEditableCellInRow(e) {
    var i, r = this.getFirstEditableColumnIndex();
    return (i = this._rowsView) === null || i === void 0 ? void 0 : i._getCellElement(e || 0, r);
  }
  getFocusedCellInRow(e) {
    return this.getFirstEditableCellInRow(e);
  }
  getIndexByKey(e, i) {
    return xe.getIndexByKey(e, i);
  }
  hasChanges(e) {
    for (var i = this.getChanges(), r = !1, n = 0; n < (i == null ? void 0 : i.length); n++)
      if (i[n].type && (!R(e) || this._dataController.getRowIndexByKey(i[n].key) === e)) {
        r = !0;
        break;
      }
    return r;
  }
  dispose() {
    super.dispose(), clearTimeout(this._inputFocusTimeoutID), k.off(de.getDocument(), Xt.up, this._pointerUpEditorHandler), k.off(de.getDocument(), Xt.down, this._pointerDownEditorHandler), k.off(de.getDocument(), di, this._saveEditorHandler);
  }
  _silentOption(e, i) {
    e === "editing.changes" && (this._changes = Hs([], i)), super._silentOption(e, i);
  }
  optionChanged(e) {
    if (e.name === "editing") {
      var {
        fullName: i
      } = e;
      if (i === os)
        this._handleEditRowKeyChange(e);
      else if (i === Vd) {
        var r = Mi(e.value, this._changes, {
          maxDepth: 4
        });
        r || (this._changes = Hs([], e.value), this._handleChangesChange(e));
      } else
        e.handled || (this._columnsController.reinit(), this.init(), this.resetChanges(), this._resetEditColumnName(), this._resetEditRowKey());
      e.handled = !0;
    } else
      super.optionChanged(e);
  }
  _handleEditRowKeyChange(e) {
    var i = this._dataController.getRowIndexByKey(e.value), r = this._getEditRowIndexCorrection(), n = this._dataController.getRowIndexByKey(e.previousValue) + r;
    R(e.value) ? e.value !== e.previousValue && this._editRowFromOptionChanged(i, n) : this.cancelEditData();
  }
  _handleChangesChange(e) {
    var i = this._dataController, r = e.value;
    !e.value.length && !e.previousValue.length || (r.forEach((n) => {
      var a;
      if (n.type === "insert")
        this._addInsertInfo(n);
      else {
        var o = i.getCachedStoreData() || ((a = i.items()) === null || a === void 0 ? void 0 : a.map((c) => c.data)), u = xe.getIndexByKey(n.key, o, i.key());
        this._addInternalData({
          key: n.key,
          oldData: o[u]
        });
      }
    }), i.updateItems({
      repaintChangesOnly: !0,
      isLiveUpdate: !1,
      isOptionChanged: !0
    }));
  }
  publicMethods() {
    return ["addRow", "deleteRow", "undeleteRow", "editRow", "saveEditData", "cancelEditData", "hasEditData"];
  }
  refresh() {
    R(this._pageIndex) && this._refreshCore.apply(this, arguments);
  }
  _refreshCore(e) {
  }
  isEditing() {
    var e = R(this.option(os));
    return e;
  }
  isEditRow(e) {
    return !1;
  }
  _setEditRowKey(e, i) {
    i ? this._silentOption(os, e) : this.option(os, e), this._refocusEditCell && (this._refocusEditCell = !1, this._focusEditingCell());
  }
  _setEditRowKeyByIndex(e, i) {
    var r = this._dataController.getKeyByRowIndex(e);
    if (r === void 0) {
      this._dataController.fireError("E1043");
      return;
    }
    this._setEditRowKey(r, i);
  }
  getEditRowIndex() {
    return this._getVisibleEditRowIndex();
  }
  getEditFormRowIndex() {
    return -1;
  }
  isEditRowByIndex(e) {
    var i = this._dataController.getKeyByRowIndex(e), r = R(i) && Mi(this.option(os), i);
    return r && this._getVisibleEditRowIndex() === e;
  }
  isEditCell(e, i) {
    return this.isEditRowByIndex(e) && this._getVisibleEditColumnIndex() === i;
  }
  getPopupContent() {
  }
  _isProcessedItem(e) {
    return !1;
  }
  _getInsertRowIndex(e, i, r) {
    var n = -1, a = this._dataController, o = this._getInsertAfterOrBeforeKey(i);
    return !R(o) && e.length === 0 ? n = 0 : R(o) && e.some((u, c) => {
      var p = r || this._isProcessedItem(u);
      if (ct(u) && (p || R(u[hh]) ? Mi(u.key, o) && (n = c) : Mi(a.keyOf(u), o) && (n = c)), n >= 0) {
        var v = e[n + 1];
        return v && (v.rowType === "detail" || v.rowType === "detailAdaptive") && R(i.insertAfterKey) ? void 0 : (R(i.insertAfterKey) && (n += 1), !0);
      }
    }), n;
  }
  _generateNewItem(e) {
    var i, r = {
      key: e
    }, n = (i = this._getInternalData(e)) === null || i === void 0 ? void 0 : i.insertInfo;
    return n != null && n[hh] && (r[hh] = n[hh]), r;
  }
  _getLoadedRowIndex(e, i, r) {
    var n = this._getInsertRowIndex(e, i, r), a = this._dataController;
    if (n < 0) {
      var o = this._getNewRowPosition(), u = a.pageIndex(), c = this._getInsertAfterOrBeforeKey(i);
      o !== xw && u === 0 && !R(c) ? n = 0 : o === xw && a.isLastPageLoaded() && (n = e.length);
    }
    return n;
  }
  processItems(e, i) {
    var {
      changeType: r
    } = i;
    this.update(r);
    var n = this.getChanges();
    return n.forEach((a) => {
      var o, u = a.type === Eu;
      if (u) {
        var {
          key: c
        } = a, p = (o = this._getInternalData(c)) === null || o === void 0 ? void 0 : o.insertInfo;
        (!R(c) || !R(p)) && (p = this._addInsertInfo(a), c = p.key);
        var v = this._getLoadedRowIndex(e, a), _ = this._generateNewItem(c);
        v >= 0 && e.splice(v, 0, _);
      }
    }), e;
  }
  processDataItem(e, i, r) {
    var n = i.visibleColumns, a = e.data[hh] ? e.data.key : e.key, o = this.getChanges(), u = xe.getIndexByKey(a, o);
    e.isEditing = !1, u >= 0 && this._processDataItemCore(e, o[u], a, n, r);
  }
  _processDataItemCore(e, i, r, n, a) {
    var {
      data: o,
      type: u
    } = i;
    switch (u) {
      case Eu:
        e.isNewRow = !0, e.key = r, e.data = o;
        break;
      case $y:
        e.modified = !0, e.oldData = e.data, e.data = xh(e.data, o), e.modifiedValues = a(o, n, !0);
        break;
      case Bd:
        e.removed = !0;
    }
  }
  _initNewRow(e) {
    if (this.executeAction("onInitNewRow", e), e.promise) {
      var i = new q();
      return $e(Pn(e.promise)).done(i.resolve).fail(zy(i)).fail((r) => this._fireDataErrorOccurred(r)), i;
    }
  }
  _createInsertInfo() {
    var e = {};
    return e[hh] = this._getInsertIndex(), e;
  }
  _addInsertInfo(e, i) {
    var r;
    console.log("add insert info");
    var n;
    e.key = this.getChangeKeyValue(e);
    var {
      key: a
    } = e;
    if (n = (r = this._getInternalData(a)) === null || r === void 0 ? void 0 : r.insertInfo, !R(n)) {
      var o = this._getInsertAfterOrBeforeKey(e);
      n = this._createInsertInfo(), R(o) || this._setInsertAfterOrBeforeKey(e, i);
    }
    return this._addInternalData({
      insertInfo: n,
      key: a
    }), {
      insertInfo: n,
      key: a
    };
  }
  getChangeKeyValue(e) {
    if (R(e.key))
      return e.key;
    var i = this._dataController.key(), r;
    return e.data && i && !Array.isArray(i) && (r = e.data[i]), R(r) || (r = BIe()), r;
  }
  _setInsertAfterOrBeforeKey(e, i) {
    var r = this.getView("rowsView"), n = this._dataController, a = n.items(!0), o = this._getNewRowPosition();
    switch (o) {
      case dK:
      case xw:
        break;
      case MM:
      case cK:
        if (a.length) {
          var u = o === MM ? 0 : a.length - 1;
          e[u === 0 ? "insertBeforeKey" : "insertAfterKey"] = a[u].key;
        }
        break;
      default:
        var c = o === hK, p = c ? r == null ? void 0 : r.getBottomVisibleItemIndex() : r == null ? void 0 : r.getTopVisibleItemIndex(), v = n.getVisibleRows()[p];
        v && (!v.isEditing && v.rowType === "detail" || v.rowType === "detailAdaptive") && p++;
        var _ = n.getKeyByRowIndex(p);
        R(_) && (e.insertBeforeKey = _);
    }
  }
  _getInsertIndex() {
    var e = 0;
    return this.getChanges().forEach((i) => {
      var r, n = (r = this._getInternalData(i.key)) === null || r === void 0 ? void 0 : r.insertInfo;
      R(n) && i.type === Eu && n[hh] > e && (e = n[hh]);
    }), e + 1;
  }
  _getInsertAfterOrBeforeKey(e) {
    var i;
    return (i = e.insertAfterKey) !== null && i !== void 0 ? i : e.insertBeforeKey;
  }
  _getPageIndexToInsertRow() {
    var e = this._getNewRowPosition(), i = this._dataController, r = i.pageIndex(), n = i.pageCount() - 1;
    return e === dK && r !== 0 ? 0 : e === xw && r !== n ? n : -1;
  }
  addRow(e) {
    var i = this._dataController, r = i.store();
    return r ? this._addRow(e) : (i.fireError("E1052", this.component.NAME), new q().reject());
  }
  _addRow(e) {
    var i = this._dataController, r = i.store(), n = r && r.key(), a = {
      data: {}
    }, o = this._getVisibleEditRowIndex(), u = new q();
    return this.refresh({
      allowCancelEditing: !0
    }), this._allowRowAdding() ? (n || (a.data.__KEY__ = String(new yr())), $e(this._initNewRow(a, e)).done(() => {
      this._allowRowAdding() ? $e(this._addRowCore(a.data, e, o)).done(u.resolve).fail(u.reject) : u.reject("cancel");
    }).fail(u.reject), u.promise()) : ($e(this._navigateToNewRow(o)).done(u.resolve).fail(u.reject), u.promise());
  }
  _allowRowAdding(e) {
    var i = this._getInsertIndex();
    return !(i > 1);
  }
  _addRowCore(e, i, r) {
    var n = {
      data: e,
      type: Eu
    }, a = this._getVisibleEditRowIndex(), o = this._addInsertInfo(n, i), {
      key: u
    } = o;
    return this._setEditRowKey(u, !0), this._addChange(n), this._navigateToNewRow(r, n, a);
  }
  _navigateToNewRow(e, i, r) {
    var n = new q(), a = this._dataController;
    if (r = r ?? -1, i = i ?? this.getChanges().filter((v) => v.type === Eu)[0], !i)
      return n.reject("cancel").promise();
    var o = this._getPageIndexToInsertRow(), u = this._getLoadedRowIndex(a.items(), i, !0), c = (v) => {
      var _;
      $e((_ = this._focusController) === null || _ === void 0 ? void 0 : _.navigateToRow(v)).done(() => {
        u = a.getRowIndexByKey(i.key), n.resolve();
      });
    }, p = this._getInsertAfterOrBeforeKey(i);
    return o >= 0 ? a.pageIndex(o).done(() => {
      c(i.key);
    }).fail(n.reject) : u < 0 && R(p) ? c(p) : (a.updateItems({
      changeType: "update",
      rowIndices: [e, r, u]
    }), u = a.getRowIndexByKey(i.key), u < 0 ? c(i.key) : n.resolve()), n.done(() => {
      var v;
      (v = this._rowsView) === null || v === void 0 || v.waitAsyncTemplates(!0).done(() => {
        this._showAddedRow(u), this._afterInsertRow(i.key);
      });
    }), n.promise();
  }
  _showAddedRow(e) {
    this._focusFirstEditableCellInRow(e);
  }
  _beforeFocusElementInRow(e) {
  }
  _focusFirstEditableCellInRow(e) {
    var i, r = this._dataController, n = r.getKeyByRowIndex(e), a = this.getFirstEditableCellInRow(e);
    (i = this._keyboardNavigationController) === null || i === void 0 || i.focus(a), this.option("focusedRowKey", n), this._editCellInProgress = !0, this._delayedInputFocus(a, () => {
      e = r.getRowIndexByKey(n), this._editCellInProgress = !1, this._beforeFocusElementInRow(e);
    });
  }
  _isEditingStart(e) {
    return this.executeAction("onEditingStart", e), e.cancel;
  }
  _beforeUpdateItems(e, i) {
  }
  _getVisibleEditColumnIndex() {
    var e = this.option(gp);
    return R(e) ? this._columnsController.getVisibleColumnIndex(e) : -1;
  }
  _setEditColumnNameByIndex(e, i) {
    var r, n = this._columnsController.getVisibleColumns();
    this._setEditColumnName((r = n[e]) === null || r === void 0 ? void 0 : r.name, i);
  }
  _setEditColumnName(e, i) {
    i ? this._silentOption(gp, e) : this.option(gp, e);
  }
  _resetEditColumnName() {
    this._setEditColumnName(null, !0);
  }
  _getEditColumn() {
    var e = this.option(gp);
    return this._getColumnByName(e);
  }
  _getColumnByName(e) {
    var i = this._columnsController.getVisibleColumns(), r;
    return R(e) && i.some((n) => {
      if (n.name === e)
        return r = n, !0;
    }), r;
  }
  _getVisibleEditRowIndex(e) {
    var i = this._dataController, r = this.option(os), n = i.getRowIndexByKey(r);
    return n === -1 ? n : n + this._getEditRowIndexCorrection(e);
  }
  _getEditRowIndexCorrection(e) {
    var i = e ? this._getColumnByName(e) : this._getEditColumn(), r = (i == null ? void 0 : i.visibleWidth) === "adaptiveHidden";
    return r ? 1 : 0;
  }
  _resetEditRowKey() {
    this._refocusEditCell = !1, this._setEditRowKey(null, !0);
  }
  _resetEditIndices() {
    this._resetEditColumnName(), this._resetEditRowKey();
  }
  editRow(e) {
    var i, r = this._dataController, n = r.items(), a = n[e], o = {
      data: a && a.data,
      cancel: !1
    }, u = this._getVisibleEditRowIndex();
    if (a) {
      if (e === u)
        return !0;
      if (a.key === void 0) {
        this._dataController.fireError("E1043");
        return;
      }
      a.isNewRow || (o.key = a.key), !this._isEditingStart(o) && (this.resetChanges(), this.init(), this._resetEditColumnName(), this._pageIndex = r.pageIndex(), this._addInternalData({
        key: a.key,
        oldData: (i = a.oldData) !== null && i !== void 0 ? i : a.data
      }), this._setEditRowKey(a.key));
    }
  }
  _editRowFromOptionChanged(e, i) {
    var r = [i, e];
    this._beforeUpdateItems(r, e, i), this._editRowFromOptionChangedCore(r, e);
  }
  _editRowFromOptionChangedCore(e, i, r) {
    this._needFocusEditor = !0, this._dataController.updateItems({
      changeType: "update",
      rowIndices: e,
      cancel: r
    });
  }
  _focusEditorIfNeed() {
  }
  _showEditPopup(e, i) {
  }
  _repaintEditPopup() {
  }
  _getEditPopupHiddenHandler() {
    return (e) => {
      this.isEditing() && this.cancelEditData();
    };
  }
  _getPopupEditFormTemplate(e) {
  }
  _getSaveButtonConfig() {
    var e = {
      text: this.option("editing.texts.saveRowChanges"),
      onClick: this.saveEditData.bind(this)
    };
    return za(ho()) && (e.stylingMode = "contained", e.type = "default"), e;
  }
  _getCancelButtonConfig() {
    var e = {
      text: this.option("editing.texts.cancelRowChanges"),
      onClick: this.cancelEditData.bind(this)
    };
    return za(ho()) && (e.stylingMode = "outlined"), e;
  }
  _removeInternalData(e) {
    var i = this._getInternalData(e), r = this._internalState.indexOf(i);
    r > -1 && this._internalState.splice(r, 1);
  }
  _updateInsertAfterOrBeforeKeys(e, i) {
    var r = e[i];
    e.forEach((n) => {
      var a = this._getInsertAfterOrBeforeKey(n);
      Mi(a, r.key) && (n[R(n.insertAfterKey) ? "insertAfterKey" : "insertBeforeKey"] = this._getInsertAfterOrBeforeKey(r));
    });
  }
  _removeChange(e) {
    if (e >= 0) {
      var i = [...this.getChanges()], {
        key: r
      } = i[e];
      this._removeInternalData(r), this._updateInsertAfterOrBeforeKeys(i, e), i.splice(e, 1), this._silentOption(Vd, i), Mi(this.option(os), r) && this._resetEditIndices();
    }
  }
  executeOperation(e, i) {
    this._lastOperation && this._lastOperation.reject(), this._lastOperation = e, this.waitForDeferredOperations().done(() => {
      e.state() !== "rejected" && (i(), this._lastOperation = null);
    }).fail(() => {
      e.reject(), this._lastOperation = null;
    });
  }
  waitForDeferredOperations() {
    return $e(...this._deferreds);
  }
  _processCanceledEditingCell() {
  }
  _repaintEditCell(e, i, r) {
    !e || !e.showEditorAlways || i && !i.showEditorAlways ? (this._editCellInProgress = !0, this._needFocusEditor = !0, this._editorFactoryController.loseFocus(), this._dataController.updateItems({
      changeType: "update",
      rowIndices: [r, this._getVisibleEditRowIndex()]
    })) : e !== i && (this._needFocusEditor = !0, this._dataController.updateItems({
      changeType: "update",
      rowIndices: []
    }));
  }
  _delayedInputFocus(e, i, r) {
    var n = () => {
      if (i && i(), e) {
        var a = e.find(qB).first();
        xe.focusAndSelectElement(this, a);
      }
      this._beforeFocusCallback = null;
    };
    Ye.real().ios || Ye.real().android ? n() : (this._beforeFocusCallback && this._beforeFocusCallback(), clearTimeout(this._inputFocusTimeoutID), r && (this._beforeFocusCallback = i), this._inputFocusTimeoutID = setTimeout(n));
  }
  _focusEditingCell(e, i, r) {
    var n = this._getVisibleEditColumnIndex();
    i = i || this._rowsView && this._rowsView._getCellElement(this._getVisibleEditRowIndex(), n), i && this._delayedInputFocus(i, e, r);
  }
  deleteRow(e) {
    this._checkAndDeleteRow(e);
  }
  _checkAndDeleteRow(e) {
    var i = this.option("editing"), r = i == null ? void 0 : i.texts, n = i == null ? void 0 : i.confirmDelete, a = r == null ? void 0 : r.confirmDeleteMessage, o = this._dataController.items()[e], u = !this.isEditing() || o.isNewRow;
    if (o && u)
      if (!n || !a)
        this._deleteRowCore(e);
      else {
        var c = r && r.confirmDeleteTitle, p = R(c) && c.length > 0;
        iIe(a, c, p).done((v) => {
          v && this._deleteRowCore(e);
        });
      }
  }
  _deleteRowCore(e) {
    var i = this._dataController, r = i.items()[e], n = r && r.key, a = this._getVisibleEditRowIndex();
    this.refresh();
    var o = this.getChanges(), u = xe.getIndexByKey(n, o);
    return u >= 0 ? o[u].type === Eu ? this._removeChange(u) : this._addChange({
      key: n,
      type: Bd
    }) : this._addChange({
      key: n,
      oldData: r.data,
      type: Bd
    }), this._afterDeleteRow(e, a);
  }
  _afterDeleteRow(e, i) {
    return this.saveEditData();
  }
  undeleteRow(e) {
    var i = this._dataController, r = i.items()[e], n = this._getVisibleEditRowIndex(), a = r && r.key, o = this.getChanges();
    if (r) {
      var u = xe.getIndexByKey(a, o);
      if (u >= 0) {
        var {
          data: c
        } = o[u];
        uo(c) ? this._removeChange(u) : this._addChange({
          key: a,
          type: $y
        }), i.updateItems({
          changeType: "update",
          rowIndices: [n, e]
        });
      }
    }
  }
  _fireOnSaving() {
    var e = {
      cancel: !1,
      promise: null,
      changes: [...this.getChanges()]
    };
    this.executeAction("onSaving", e);
    var i = new q();
    return $e(Pn(e.promise)).done(() => {
      i.resolve(e);
    }).fail((r) => {
      zy(i), this._fireDataErrorOccurred(r), i.resolve({
        cancel: !0
      });
    }), i;
  }
  _executeEditingAction(e, i, r) {
    if (this.component._disposed)
      return null;
    var n = new q();
    return this.executeAction(e, i), $e(Pn(i.cancel)).done((a) => {
      a ? setTimeout(() => {
        n.resolve("cancel");
      }) : r(i).done(n.resolve).fail(zy(n));
    }).fail(zy(n)), n;
  }
  _processChanges(e, i, r, n) {
    var a = this._dataController.store();
    N(n, (o, u) => {
      var c = this._getOldData(u.key), {
        data: p,
        type: v
      } = u, _ = ae({}, u), y, b;
      if (!this._beforeSaveEditData(u, o)) {
        switch (v) {
          case Bd:
            b = {
              data: c,
              key: u.key,
              cancel: !1
            }, y = this._executeEditingAction("onRowRemoving", b, () => a.remove(u.key).done((A) => {
              r.push({
                type: "remove",
                key: A
              });
            }));
            break;
          case Eu:
            b = {
              data: p,
              cancel: !1
            }, y = this._executeEditingAction("onRowInserting", b, () => a.insert(b.data).done((A, L) => {
              R(L) && (_.key = L), A && ct(A) && A !== b.data && (_.data = A), r.push({
                type: "insert",
                data: A,
                index: 0
              });
            }));
            break;
          case $y:
            b = {
              newData: p,
              oldData: c,
              key: u.key,
              cancel: !1
            }, y = this._executeEditingAction("onRowUpdating", b, () => a.update(u.key, b.newData).done((A, L) => {
              A && ct(A) && A !== b.newData && (_.data = A), r.push({
                type: "update",
                key: L,
                data: A
              });
            }));
        }
        if (n[o] = _, y) {
          var I = new q();
          y.always((A) => {
            i.push({
              key: u.key,
              result: A
            });
          }).always(I.resolve), e.push(I.promise());
        }
      }
    });
  }
  _processRemoveIfError(e, i) {
    var r = e[i];
    return (r == null ? void 0 : r.type) === Bd && i >= 0 && e.splice(i, 1), !0;
  }
  _processRemove(e, i, r) {
    var n = e[i];
    if (!r || !n || n.type === Bd)
      return this._processRemoveCore(e, i, !r || !n);
  }
  _processRemoveCore(e, i, r) {
    return i >= 0 && e.splice(i, 1), !0;
  }
  _processSaveEditDataResult(e) {
    for (var i = !1, r = [...this.getChanges()], n = r.length, a = 0; a < e.length; a++) {
      var o = e[a].result, u = o === "cancel", c = xe.getIndexByKey(e[a].key, r), p = r[c], v = o && o instanceof Error;
      if (v) {
        if (p && this._addInternalData({
          key: p.key,
          error: o
        }), this._fireDataErrorOccurred(o), this._processRemoveIfError(r, c))
          break;
      } else
        this._processRemove(r, c, u) && (i = !u);
    }
    return r.length < n && this._silentOption(Vd, r), i;
  }
  _fireSaveEditDataEvents(e) {
    N(e, (i, r) => {
      var {
        data: n,
        key: a,
        type: o
      } = r, u = this._addInternalData({
        key: a
      }), c = {
        key: a,
        data: n
      };
      switch (u.error && (c.error = u.error), o) {
        case Bd:
          this.executeAction("onRowRemoved", P({}, c, {
            data: u.oldData
          }));
          break;
        case Eu:
          this.executeAction("onRowInserted", c);
          break;
        case $y:
          this.executeAction("onRowUpdated", c);
      }
    }), this.executeAction("onSaved", {
      changes: e
    });
  }
  saveEditData() {
    var e = new q();
    return this.waitForDeferredOperations().done(() => {
      if (this.isSaving()) {
        this._resolveAfterSave(e);
        return;
      }
      $e(this._beforeSaveEditData()).done((i) => {
        if (i) {
          this._resolveAfterSave(e, {
            cancel: i
          });
          return;
        }
        this._saving = !0, this._saveEditDataInner().always(() => {
          this._saving = !1, this._refocusEditCell && this._focusEditingCell();
        }).done(e.resolve).fail(e.reject);
      }).fail(e.reject);
    }).fail(e.reject), e.promise();
  }
  _resolveAfterSave(e) {
    var {
      cancel: i,
      error: r
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    $e(this._afterSaveEditData(i)).done(() => {
      e.resolve(r);
    }).fail(e.reject);
  }
  _saveEditDataInner() {
    var e = new q(), i = [], r = [], n = [], a = this._dataController.dataSource();
    return $e(this._fireOnSaving()).done((o) => {
      var {
        cancel: u,
        changes: c
      } = o;
      if (u)
        return e.resolve().promise();
      if (this._processChanges(r, i, n, c), r.length)
        return this._refocusEditCell = !0, a == null || a.beginLoading(), $e(...r).done(() => {
          this._processSaveEditDataResult(i) ? this._endSaving(n, c, e) : (a == null || a.endLoading(), e.resolve());
        }).fail((p) => {
          a == null || a.endLoading(), e.resolve(p);
        }), e.always(() => {
          this._refocusEditCell = !0;
        }).promise();
      this._cancelSaving(e);
    }).fail(e.reject), e.promise();
  }
  _beforeEndSaving(e) {
    this._resetEditIndices();
  }
  _endSaving(e, i, r) {
    var n = this._dataController.dataSource();
    this._beforeEndSaving(i), n == null || n.endLoading(), this._refreshDataAfterSave(e, i, r);
  }
  _cancelSaving(e) {
    this.executeAction("onSaved", {
      changes: []
    }), this._resolveAfterSave(e);
  }
  _refreshDataAfterSave(e, i, r) {
    var n = this._dataController, a = this.option("editing.refreshMode"), o = a !== "reshape" && a !== "repaint";
    o || n.push(e), $e(n.refresh({
      selection: o,
      reload: o,
      load: a === "reshape",
      changesOnly: this.option("repaintChangesOnly")
    })).always(() => {
      this._fireSaveEditDataEvents(i);
    }).done(() => {
      this._resolveAfterSave(r);
    }).fail((u) => {
      this._resolveAfterSave(r, {
        error: u
      });
    });
  }
  isSaving() {
    return this._saving;
  }
  _updateEditColumn() {
    var e = this._isEditColumnVisible(), i = this.option("editing.useIcons"), r = e8 + (i ? " ".concat(fK) : "");
    this._columnsController.addCommandColumn({
      type: "buttons",
      command: "edit",
      visible: e,
      cssClass: r,
      width: "auto",
      alignment: "center",
      cellTemplate: this._getEditCommandCellTemplate(),
      fixedPosition: "right"
    }), this._columnsController.columnOption("command:edit", {
      visible: e,
      cssClass: r
    });
  }
  _isEditColumnVisible() {
    var e = this.option("editing");
    return e.allowDeleting;
  }
  _isEditButtonDisabled() {
    var e = this.hasChanges(), i = R(this.option("editing.editRowKey"));
    return !(i || e);
  }
  _updateEditButtons() {
    var e = this._isEditButtonDisabled();
    this._headerPanelView && (this._headerPanelView.setToolbarItemDisabled("saveButton", e), this._headerPanelView.setToolbarItemDisabled("revertButton", e));
  }
  _applyModified(e, i) {
    e && e.addClass(pK);
  }
  _beforeCloseEditCellInBatchMode(e) {
  }
  cancelEditData() {
    var e = this.getChanges(), i = {
      cancel: !1,
      changes: e
    };
    this.executeAction("onEditCanceling", i), i.cancel || (this._cancelEditDataCore(), this.executeAction("onEditCanceled", {
      changes: e
    }));
  }
  _cancelEditDataCore() {
    var e = this._getVisibleEditRowIndex();
    this._beforeCancelEditData(), this.init(), this.resetChanges(), this._resetEditColumnName(), this._resetEditRowKey(), this._afterCancelEditData(e);
  }
  _afterCancelEditData(e) {
    var i = this._dataController;
    i.updateItems({
      repaintChangesOnly: this.option("repaintChangesOnly")
    });
  }
  _hideEditPopup() {
  }
  hasEditData() {
    return this.hasChanges();
  }
  update(e) {
    var i = this._dataController;
    i && this._pageIndex !== i.pageIndex() && (e === "refresh" && this.refresh({
      isPageChanged: !0
    }), this._pageIndex = i.pageIndex()), this._updateEditButtons();
  }
  _getRowIndicesForCascadeUpdating(e, i) {
    return i ? [] : [e.rowIndex];
  }
  addDeferred(e) {
    this._deferreds.includes(e) || (this._deferreds.push(e), e.always(() => {
      var i = this._deferreds.indexOf(e);
      i >= 0 && this._deferreds.splice(i, 1);
    }));
  }
  _prepareChange(e, i, r) {
    var n, a = {}, o = (n = e.row) === null || n === void 0 ? void 0 : n.data, u = e.key, c = new q();
    if (u !== void 0) {
      e.value = i;
      var p = Pn(e.column.setCellValue(a, i, P(!0, {}, o), r));
      p.done(() => {
        c.resolve({
          data: a,
          key: u,
          oldData: o,
          type: $y
        });
      }).fail(zy(c)).fail((v) => this._fireDataErrorOccurred(v)), R(r) && e.column.displayValueMap && (e.column.displayValueMap[i] = r), this._updateRowValues(e), this.addDeferred(c);
    }
    return c;
  }
  _updateRowValues(e) {
    if (e.values) {
      var i = this._dataController, r = i.getRowIndexByKey(e.key), n = i.getVisibleRows()[r];
      n && (e.row.values = n.values, e.values = n.values), e.values[e.columnIndex] = e.value;
    }
  }
  updateFieldValue(e, i, r, n) {
    var a = e.key, o = new q();
    return a === void 0 && this._dataController.fireError("E1043"), e.column.setCellValue ? this._prepareChange(e, i, r).done((u) => {
      $e(this._applyChange(e, u, n)).always(() => {
        o.resolve();
      });
    }) : o.resolve(), o.promise();
  }
  _focusPreviousEditingCellIfNeed(e) {
    if (this.hasEditData() && !this.isEditCell(e.rowIndex, e.columnIndex))
      return this._focusEditingCell(), this._updateEditRow(e.row, !0), !0;
  }
  _needUpdateRow(e) {
    var i = this._columnsController.getVisibleColumns();
    e || (e = this._getEditColumn());
    var r = e && e.setCellValue !== e.defaultSetCellValue, n = i.some((a) => a.calculateCellValue !== a.defaultCalculateCellValue);
    return r || n;
  }
  _applyChange(e, i, r) {
    var n = ae(ae({}, e), {
      forceUpdateRow: r
    });
    return this._addChange(i, n), this._updateEditButtons(), this._applyChangeCore(e, n.forceUpdateRow);
  }
  _applyChangeCore(e, i) {
    var r = e.column.setCellValue !== e.column.defaultSetCellValue, {
      row: n
    } = e;
    n && (i || r ? this._updateEditRow(n, i, r) : n.update && n.update());
  }
  _updateEditRowCore(e, i, r) {
    this._dataController.updateItems({
      changeType: "update",
      rowIndices: this._getRowIndicesForCascadeUpdating(e, i)
    });
  }
  _updateEditRow(e, i, r) {
    i ? this._updateRowImmediately(e, i, r) : this._updateRowWithDelay(e, r);
  }
  _updateRowImmediately(e, i, r) {
    this._updateEditRowCore(e, !i, r), this._validateEditFormAfterUpdate(e, r), i || this._focusEditingCell();
  }
  _updateRowWithDelay(e, i) {
    var r = new q();
    this.addDeferred(r), setTimeout(() => {
      var n, a = ((n = this._editForm) === null || n === void 0 ? void 0 : n.element()) || this.component.$element().get(0), o = E(de.getActiveElement(a)), u = this._rowsView.getCellIndex(o, e.rowIndex), c = o.get(0), p = xe.getSelectionRange(c);
      if (this._updateEditRowCore(e, !1, i), this._validateEditFormAfterUpdate(e, i), u >= 0) {
        var v = this._rowsView._getCellElement(e.rowIndex, u);
        this._delayedInputFocus(v, () => {
          setTimeout(() => {
            var _;
            c = de.getActiveElement((_ = this.component.$element()) === null || _ === void 0 ? void 0 : _.get(0)), p.selectionStart >= 0 && xe.setSelectionRange(c, p);
          });
        });
      }
      r.resolve();
    });
  }
  _validateEditFormAfterUpdate() {
  }
  _addChange(e, i) {
    var r, n = i == null ? void 0 : i.row, a = [...this.getChanges()], o = xe.getIndexByKey(e.key, a);
    o < 0 && (o = a.length, this._addInternalData({
      key: e.key,
      oldData: e.oldData
    }), delete e.oldData, a.push(e));
    var u = ae({}, a[o]);
    return u && (e.data && (u.data = xh(u.data, e.data)), (!u.type || !e.data) && e.type && (u.type = e.type), n && (n.oldData = this._getOldData(n.key), n.data = xh(n.data, e.data))), a[o] = u, this._silentOption(Vd, a), i && u !== ((r = this.getChanges()) === null || r === void 0 ? void 0 : r[o]) && (i.forceUpdateRow = !0), u;
  }
  _getFormEditItemTemplate(e, i) {
    return i.editCellTemplate || this._getDefaultEditorTemplate();
  }
  getColumnTemplate(e) {
    var {
      column: i
    } = e, r = e.row && e.row.rowIndex, n, a = this.isRowBasedEditMode(), o = this.isEditRow(r), u = this.isEditCell(r, e.columnIndex), c;
    if ((i.showEditorAlways || i.setCellValue && (o && i.allowEditing || u)) && (e.rowType === "data" || e.rowType === "detailAdaptive") && !i.command) {
      var p = this.allowUpdating(e);
      ((p || o) && i.allowEditing || u) && (o || !a) && (i.showEditorAlways && !a && (c = {
        cancel: !1,
        key: e.row.isNewRow ? void 0 : e.row.key,
        data: e.row.data,
        column: i
      }, this._isEditingStart(c)), (!c || !c.cancel) && (e.setValue = (v, _) => {
        this.updateFieldValue(e, v, _);
      })), n = i.editCellTemplate || this._getDefaultEditorTemplate();
    } else
      i.command === "detail" && e.rowType === "detail" && o && (n = this === null || this === void 0 ? void 0 : this.getEditFormTemplate(e));
    return n;
  }
  _createButton(e, i, r, n) {
    var a = yIe[i.name], o = this.option("editing.useIcons"), u = this.option("useLegacyColumnButtonTemplate"), c = E("<a>").attr("href", "#").addClass(dIe).addClass(i.cssClass);
    if (i.template && u)
      this._rowsView.renderTemplate(e, i.template, r, !0);
    else {
      if (i.template)
        c = E("<span>").addClass(i.cssClass);
      else if (o && a || i.icon) {
        a = i.icon || a;
        var p = hS(a);
        p === "image" || p === "svg" ? c = ec(a).addClass(i.cssClass) : c.addClass("dx-icon".concat(p === "dxIcon" ? "-" : " ").concat(a)).attr("title", i.text), c.addClass(cIe), e.addClass(fK);
        var v = this.getButtonLocalizationNames()[i.name];
        v && c.attr("aria-label", X.format(v));
      } else
        c.text(i.text);
      R(i.hint) && c.attr("title", i.hint), this._isButtonDisabled(i, r) ? c.addClass("dx-state-disabled") : (!i.template || i.onClick) && k.on(c, ve("click", gIe), this.createAction((_) => {
        var y;
        (y = i.onClick) === null || y === void 0 || y.call(i, P({}, _, {
          row: r.row,
          column: r.column
        })), _.event.preventDefault(), _.event.stopPropagation();
      })), e.append(c, "&nbsp;"), i.template && (r.renderAsync = !1, this._rowsView.renderTemplate(c, i.template, r, !0, n));
    }
  }
  getButtonLocalizationNames() {
    return {
      edit: "dxDataGrid-editingEditRow",
      save: "dxDataGrid-editingSaveRowChanges",
      delete: "dxDataGrid-editingDeleteRow",
      undelete: "dxDataGrid-editingUndeleteRow",
      cancel: "dxDataGrid-editingCancelRowChanges"
    };
  }
  prepareButtonItem(e, i, r, n) {
    var a, o = (a = this.option("editing.texts")) !== null && a !== void 0 ? a : {}, u = {
      revert: o.cancelAllChanges,
      save: o.saveAllChanges,
      addRow: o.addRow
    }, c = {
      revert: "cancel",
      save: "save",
      addRow: "addrow"
    }[i], p = u[i], v = (c === "save" || c === "cancel") && this._isEditButtonDisabled();
    return {
      widget: "dxButton",
      options: {
        onInitialized: (_) => {
          E(_.element).addClass(e._getToolbarButtonClass("".concat(fIe, " ").concat(this.addWidgetPrefix(c), "-button")));
        },
        icon: "edit-button-".concat(c),
        disabled: v,
        onClick: () => {
          setTimeout(() => {
            this[r]();
          });
        },
        text: p,
        hint: p
      },
      showText: "inMenu",
      name: "".concat(i, "Button"),
      location: "after",
      locateInMenu: "auto",
      sortIndex: n
    };
  }
  prepareEditButtons(e) {
    var i, r = (i = this.option("editing")) !== null && i !== void 0 ? i : {}, n = [];
    return r.allowAdding && n.push(this.prepareButtonItem(e, "addRow", "addRow", 20)), n;
  }
  highlightDataCell(e, i) {
    this.shouldHighlightCell(i) && e.addClass(pK);
  }
  _afterInsertRow(e) {
  }
  _beforeSaveEditData(e) {
    if (e && !R(e.key) && R(e.type))
      return !0;
  }
  _afterSaveEditData() {
  }
  _beforeCancelEditData() {
  }
  _allowEditAction(e, i) {
    var r = this.option("editing.".concat(e));
    return Le(r) && (r = r({
      component: this.component,
      row: i.row
    })), r;
  }
  allowUpdating(e, i) {
    var r, n = (r = this.option("editing.startEditAction")) !== null && r !== void 0 ? r : _Ie, a = arguments.length > 1 ? n === i || i === "down" : !0;
    return a && this._allowEditAction("allowUpdating", e);
  }
  allowDeleting(e) {
    return this._allowEditAction("allowDeleting", e);
  }
  isCellModified(e) {
    var i, r, n, {
      columnIndex: a
    } = e, o = (r = (i = e == null ? void 0 : e.row) === null || i === void 0 ? void 0 : i.modifiedValues) === null || r === void 0 ? void 0 : r[a];
    return !((n = e == null ? void 0 : e.row) === null || n === void 0) && n.isNewRow && (o = e.value), o !== void 0;
  }
  isNewRowInEditMode() {
    var e = this._getVisibleEditRowIndex(), i = this._dataController.items();
    return e >= 0 ? i[e].isNewRow : !1;
  }
  _isRowDeleteAllowed() {
  }
  shouldHighlightCell(e) {
    var i = this.isCellModified(e);
    return i && e.column.setCellValue && (this.getEditMode() !== Xd || !e.row.isEditing);
  }
}
var a8 = (t) => class extends t {
  reload(e, i) {
    return !i && this._editingController.refresh(), super.reload.apply(this, arguments);
  }
  repaintRows() {
    if (!this._editingController.isSaving())
      return super.repaintRows.apply(this, arguments);
  }
  _updateEditRow(e) {
    var i, r = this.option(os), n = xe.getIndexByKey(r, e), a = e[n];
    a && (a.isEditing = !0, (i = this._updateEditItem) === null || i === void 0 || i.call(this, a));
  }
  _updateItemsCore(e) {
    super._updateItemsCore(e), this._updateEditRow(this.items(!0));
  }
  _applyChangeUpdate(e) {
    this._updateEditRow(e.items), super._applyChangeUpdate(e);
  }
  _applyChangesOnly(e) {
    this._updateEditRow(e.items), super._applyChangesOnly(e);
  }
  _processItems(e, i) {
    return e = this._editingController.processItems(e, i), super._processItems(e, i);
  }
  _processDataItem(e, i) {
    return this._editingController.processDataItem(e, i, this.generateDataValues), super._processDataItem(e, i);
  }
  _processItem(e, i) {
    return e = super._processItem(e, i), e.isNewRow && (i.dataIndex--, delete e.dataIndex), e;
  }
  _getChangedColumnIndices(e, i, r, n) {
    if (!(e.isNewRow !== i.isNewRow || e.removed !== i.removed))
      return super._getChangedColumnIndices.apply(this, arguments);
  }
  _isCellChanged(e, i, r, n, a) {
    var o = e.cells && e.cells[n], u = this._editingController && this._editingController.isEditCell(r, n);
    return a && u ? !1 : o && o.column && !o.column.showEditorAlways && o.isEditing !== u ? !0 : super._isCellChanged.apply(this, arguments);
  }
  needToRefreshOnDataSourceChange(e) {
    var i = Array.isArray(e.value) && e.value === e.previousValue && this._editingController.isSaving();
    return !i;
  }
  _handleDataSourceChange(e) {
    var i = super._handleDataSourceChange(e), r = this.option("editing.changes"), n = e.value;
    if (Array.isArray(n) && r.length) {
      var a = n.map((p) => this.keyOf(p)), o = r.filter((p) => p.type === "insert" || a.some((v) => Mi(p.key, v)));
      o.length !== r.length && this.option("editing.changes", o);
      var u = this.option("editing.editRowKey"), c = o.some((p) => p.type === "insert" && Mi(u, p.key));
      !c && a.every((p) => !Mi(u, p)) && this.option("editing.editRowKey", null);
    }
    return i;
  }
}, zIe = (t) => class extends t {
  getCellIndex(e, i) {
    if (!e.is("td") && i >= 0) {
      var r = this.getCellElements(i), n = -1;
      return N(r, (a, o) => {
        E(o).find(e).length && (n = a);
      }), n;
    }
    return super.getCellIndex.apply(this, arguments);
  }
  publicMethods() {
    return super.publicMethods().concat(["cellValue"]);
  }
  _getCellTemplate(e) {
    var i = this._editingController.getColumnTemplate(e);
    return i || super._getCellTemplate(e);
  }
  _createRow(e) {
    var i = super._createRow.apply(this, arguments);
    if (e) {
      var r = !!e.removed, n = !!e.isNewRow, a = !!e.modified;
      n && i.addClass(pIe), a && i.addClass(vIe), (n || r) && i.removeClass(hIe);
    }
    return i;
  }
  _getColumnIndexByElement(e) {
    for (var i = e.closest("table"), r = this.getTableElements(); i.length && !r.filter(i).length; )
      e = i.closest("td"), i = e.closest("table");
    return this._getColumnIndexByElementCore(e);
  }
  _getColumnIndexByElementCore(e) {
    var i = e.closest(".".concat(vh, "> td:not(.dx-master-detail-cell)"));
    return this.getCellIndex(i);
  }
  _editCellByClick(e, i) {
    var r = this._editingController, n = E(e.event.target), a = this._getColumnIndexByElement(n), o = this._dataController.items()[e.rowIndex], u = r.allowUpdating({
      row: o
    }, i) || o && o.isNewRow, c = this._columnsController.getVisibleColumns()[a], p = r.isEditCell(e.rowIndex, a), v = u && c && (c.allowEditing || p), _ = this.option("editing.startEditAction") || "click", y = c && c.showEditorAlways;
    if (p)
      return !0;
    if (i === "down")
      return (Ye.real().ios || Ye.real().android) && $m(), y && v && r.editCell(e.rowIndex, a);
    if (i === "click" && _ === "dblClick" && this._pointerDownTarget === n.get(0)) {
      var b = o == null ? void 0 : o.isNewRow;
      r.closeEditCell(!1, b);
    }
    if (v && i === _)
      return r.editCell(e.rowIndex, a) || r.isEditRow(e.rowIndex);
  }
  _rowPointerDown(e) {
    this._pointerDownTarget = e.event.target, this._pointerDownTimeout = setTimeout(() => {
      this._editCellByClick(e, "down");
    });
  }
  _rowClickTreeListHack(e) {
    super._rowClick.apply(this, arguments);
  }
  _rowClick(e) {
    var i = E(e.rowElement).hasClass(this.addWidgetPrefix(KT));
    e.event[ZX] = this.component, !this._editCellByClick(e, "click") && !i && super._rowClick.apply(this, arguments);
  }
  _rowDblClickTreeListHack(e) {
    super._rowDblClick.apply(this, arguments);
  }
  _rowDblClick(e) {
    this._editCellByClick(e, "dblClick") || super._rowDblClick.apply(this, arguments);
  }
  _cellPrepared(e, i) {
    var r, n = this._editingController, a = !!i.column.command, o = i.setValue, u = n.isEditRow(i.rowIndex), c = i8(u, i);
    if (gK(u, i)) {
      var {
        alignment: p
      } = i.column;
      e.toggleClass(this.addWidgetPrefix(uIe), !o).toggleClass(mIe, !o), p && e.find(YB).first().css("textAlign", p);
    }
    c && this._editCellPrepared(e);
    var v = !!(!((r = i.column) === null || r === void 0) && r.cellTemplate);
    i.column && !a && (!v || n.shouldHighlightCell(i)) && n.highlightDataCell(e, i), super._cellPrepared.apply(this, arguments);
  }
  _getCellOptions(e) {
    var i = super._getCellOptions(e), {
      columnIndex: r,
      row: n
    } = e;
    return i.isEditing = this._editingController.isEditCell(i.rowIndex, i.columnIndex), i.removed = n.removed, n.modified && (i.modified = n.modifiedValues[r] !== void 0), i;
  }
  _setCellAriaAttributes(e, i) {
    super._setCellAriaAttributes(e, i), i.removed && this.setAria("roledescription", X.format("dxDataGrid-ariaDeletedCell"), e), i.modified && this.setAria("roledescription", X.format("dxDataGrid-ariaModifiedCell"), e);
    var r = i.column.allowEditing && !i.removed && !i.modified && i.rowType === "data" && i.column.calculateCellValue === i.column.defaultCalculateCellValue && this._editingController.isCellBasedEditMode();
    r && this.setAria("roledescription", X.format("dxDataGrid-ariaEditableCell"), e);
  }
  _createCell(e) {
    var i = super._createCell(e), r = this._editingController.isEditRow(e.rowIndex);
    return gK(r, e) && i.addClass(FI), i;
  }
  cellValue(e, i, r, n) {
    var a = this.getCellOptions(e, i);
    if (a) {
      if (r === void 0)
        return a.value;
      this._editingController.updateFieldValue(a, r, n, !0);
    }
  }
  dispose() {
    super.dispose.apply(this, arguments), clearTimeout(this._pointerDownTimeout);
  }
  _renderCore() {
    return super._renderCore.apply(this, arguments), this.waitAsyncTemplates(!0).done(() => {
      this._editingController._focusEditorIfNeed();
    });
  }
  _editCellPrepared() {
  }
  _formItemPrepared() {
  }
}, WIe = (t) => class extends t {
  optionChanged(e) {
    var {
      fullName: i
    } = e;
    switch (e.name) {
      case "editing":
        var r = [Zw, Vd, gp, os], n = i && !r.some((a) => a === i);
        n && this._invalidate(), super.optionChanged(e);
        break;
      case "useLegacyColumnButtonTemplate":
        e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
  _getToolbarItems() {
    var e = super._getToolbarItems(), i = this._editingController.prepareEditButtons(this);
    return i.concat(e);
  }
  isVisible() {
    var e = this._editingController.option("editing");
    return super.isVisible() || (e == null ? void 0 : e.allowAdding);
  }
}, kM = {
  defaultOptions: () => ({
    editing: {
      mode: "row",
      refreshMode: "full",
      newRowPosition: JX,
      allowAdding: !1,
      allowUpdating: !1,
      allowDeleting: !1,
      useIcons: !1,
      selectTextOnEditStart: !1,
      confirmDelete: !0,
      texts: {
        editRow: X.format("dxDataGrid-editingEditRow"),
        saveAllChanges: X.format("dxDataGrid-editingSaveAllChanges"),
        saveRowChanges: X.format("dxDataGrid-editingSaveRowChanges"),
        cancelAllChanges: X.format("dxDataGrid-editingCancelAllChanges"),
        cancelRowChanges: X.format("dxDataGrid-editingCancelRowChanges"),
        addRow: X.format("dxDataGrid-editingAddRow"),
        deleteRow: X.format("dxDataGrid-editingDeleteRow"),
        undeleteRow: X.format("dxDataGrid-editingUndeleteRow"),
        confirmDeleteMessage: X.format("dxDataGrid-editingConfirmDeleteMessage"),
        confirmDeleteTitle: ""
      },
      form: {
        colCount: 2
      },
      popup: {},
      startEditAction: "click",
      editRowKey: null,
      editColumnName: null,
      changes: []
    },
    useLegacyColumnButtonTemplate: !1
  }),
  controllers: {
    editing: $Ie
  },
  extenders: {
    controllers: {
      data: a8
    },
    views: {
      rowsView: zIe,
      headerPanel: WIe
    }
  }
}, UIe = (t) => class extends a8(t) {
  _changeRowExpandCore(e) {
    var i = this._editingController;
    return Array.isArray(e) && i && i.refresh(), super._changeRowExpandCore.apply(this, arguments);
  }
};
et.registerModule("editing", ae(ae({}, kM), {
  extenders: ae(ae({}, kM.extenders), {
    controllers: ae(ae({}, kM.extenders.controllers), {
      data: UIe
    })
  })
}));
var GIe = (t) => class extends t {
  isRowEditMode() {
    return this.getEditMode() === Xd;
  }
  _afterCancelEditData(e) {
    var i = this._dataController;
    this.isRowBasedEditMode() && e >= 0 ? i.updateItems({
      changeType: "update",
      rowIndices: [e, e + 1]
    }) : super._afterCancelEditData(e);
  }
  _isDefaultButtonVisible(e, i) {
    var r = this.isRowBasedEditMode(), n = i.row && Mi(i.row.key, this.option(os));
    if (r)
      switch (e.name) {
        case "edit":
          return !n && this.allowUpdating(i);
        case "delete":
          return super._isDefaultButtonVisible(e, i) && !n;
        case "save":
        case "cancel":
          return n;
        default:
          return super._isDefaultButtonVisible(e, i);
      }
    return super._isDefaultButtonVisible(e, i);
  }
  isEditRow(e) {
    return this.isRowBasedEditMode() && this.isEditRowByIndex(e);
  }
  _cancelSaving(e) {
    this.isRowBasedEditMode() && (this.hasChanges() || this._cancelEditDataCore()), super._cancelSaving(e);
  }
  _refreshCore(e) {
    var {
      allowCancelEditing: i
    } = e ?? {};
    if (this.isRowBasedEditMode()) {
      var r = this.getChanges().filter((n) => n.type === "update").length > 0;
      this.init(), i && r && this._cancelEditDataCore();
    }
    super._refreshCore(e);
  }
  _isEditColumnVisible() {
    var e = super._isEditColumnVisible(), i = this.option("editing"), r = this.isRowEditMode(), n = i.allowUpdating || i.allowAdding;
    return e || r && n;
  }
  _focusEditorIfNeed() {
    var e = this.getEditMode();
    if (this._needFocusEditor) {
      if (lIe.includes(e)) {
        var i = this.getFocusedCellInRow(this._getVisibleEditRowIndex());
        this._delayedInputFocus(i, () => {
          i && this.component.focus(i);
        });
      }
      this._needFocusEditor = !1;
    }
  }
}, KIe = (t) => class extends t {
  _getChangedColumnIndices(e, i, r, n) {
    if (!(this._editingController.isRowBasedEditMode() && e.isEditing !== i.isEditing))
      return super._getChangedColumnIndices.apply(this, arguments);
  }
}, jIe = (t) => class extends t {
  _createRow(e) {
    var i = super._createRow.apply(this, arguments);
    if (e) {
      var r = this._editingController, n = r.isEditRow(e.rowIndex);
      n && (i.addClass(vK), i.removeClass(uK), e.rowType === "detail" && i.addClass(this.addWidgetPrefix(KT)));
    }
    return i;
  }
  _update(e) {
    super._update(e), e.changeType === "updateSelection" && this.getTableElements().children("tbody").children(".".concat(vK)).removeClass(uK);
  }
}, YIe = {
  extenders: {
    controllers: {
      editing: GIe,
      data: KIe
    },
    views: {
      rowsView: jIe
    }
  }
};
et.registerModule("editingRowBased", YIe);
class o8 {
  constructor() {
    this._map = {};
  }
  _findWidgetInstance(e) {
    var i;
    return N(this._map, function(r, n) {
      var {
        widgetInstance: a,
        item: o
      } = n;
      if (e(o))
        return i = a, !1;
    }), i;
  }
  _findFieldByCondition(e, i) {
    var r;
    return N(this._map, function(n, a) {
      if (e(a))
        return r = i === "guid" ? n : a[i], !1;
    }), r;
  }
  clear() {
    this._map = {};
  }
  removeItemsByItems(e) {
    N(e.getItems(), (i) => this.removeItemByKey(i));
  }
  removeItemByKey(e) {
    delete this._map[e];
  }
  add(e) {
    var i = e.guid || new yr();
    return this._map[i] = e, i;
  }
  addItemsOrExtendFrom(e) {
    e.each((i, r) => {
      this._map[i] ? (r.widgetInstance && (this._map[i].widgetInstance = r.widgetInstance), this._map[i].$itemContainer = r.$itemContainer) : this.add({
        item: r.item,
        widgetInstance: r.widgetInstance,
        guid: i,
        $itemContainer: r.$itemContainer
      });
    });
  }
  extendRunTimeItemInfoByKey(e, i) {
    this._map[e] && (this._map[e] = P(this._map[e], i));
  }
  findWidgetInstanceByItem(e) {
    return this._findWidgetInstance((i) => i === e);
  }
  findGroupOrTabLayoutManagerByPath(e) {
    return this._findFieldByCondition((i) => {
      var {
        path: r
      } = i;
      return r === e;
    }, "layoutManager");
  }
  findKeyByPath(e) {
    return this._findFieldByCondition((i) => {
      var {
        path: r
      } = i;
      return r === e;
    }, "guid");
  }
  findWidgetInstanceByName(e) {
    return this._findWidgetInstance((i) => e === i.name);
  }
  findWidgetInstanceByDataField(e) {
    return this._findWidgetInstance((i) => e === (ht(i) ? i : i.dataField));
  }
  findItemContainerByItem(e) {
    for (var i in this._map)
      if (this._map[i].item === e)
        return this._map[i].$itemContainer;
    return null;
  }
  findItemIndexByItem(e) {
    return this._findFieldByCondition((i) => {
      var {
        item: r
      } = i;
      return r === e;
    }, "itemIndex");
  }
  findPreparedItemByItem(e) {
    return this._findFieldByCondition((i) => {
      var {
        item: r
      } = i;
      return r === e;
    }, "preparedItem");
  }
  getItems() {
    return this._map;
  }
  each(e) {
    N(this._map, function(i, r) {
      e(i, r);
    });
  }
  removeItemsByPathStartWith(e) {
    var i = Object.keys(this._map), r = i.filter((n) => this._map[n].path ? this._map[n].path.indexOf(e, 0) > -1 : !1);
    r.forEach((n) => this.removeItemByKey(n));
  }
}
var Sw = {
  move(t, e) {
    Nn(t, {
      left: e
    });
  }
}, PM = {
  moveTo(t, e, i, r) {
    ji.animate(t, {
      type: "slide",
      to: {
        left: e
      },
      duration: i,
      complete: r
    });
  },
  complete(t) {
    ji.stop(t, !0);
  }
}, qIe = "dx-multiview", XIe = "dx-multiview-wrapper", QIe = "dx-multiview-item-container", mK = "dx-multiview-item", ZIe = "dx-multiview-item-hidden", JIe = "dxMultiViewItemData", eDe = 200, _K = (t) => +t, tDe = (t) => zs(t).left, s8 = PB.inherit({
  _activeStateUnit: "." + mK,
  _supportedKeys: function() {
    return P(this.callBase(), {
      pageUp: ee,
      pageDown: ee
    });
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      selectedIndex: 0,
      swipeEnabled: !0,
      animationEnabled: !0,
      loop: !1,
      deferRendering: !0,
      loopItemFocus: !1,
      selectOnFocus: !0,
      selectionMode: "single",
      selectionRequired: !0,
      selectByClick: !1
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: function() {
        return Ye.real().deviceType === "desktop" && !Ye.isSimulator();
      },
      options: {
        focusStateEnabled: !0
      }
    }]);
  },
  _itemClass: function() {
    return mK;
  },
  _itemDataKey: function() {
    return JIe;
  },
  _itemContainer: function() {
    return this._$itemContainer;
  },
  _itemElements: function() {
    return this._itemContainer().children(this._itemSelector());
  },
  _itemWidth: function() {
    return this._itemWidthValue || (this._itemWidthValue = mt(this._$wrapper)), this._itemWidthValue;
  },
  _clearItemWidthCache: function() {
    delete this._itemWidthValue;
  },
  _itemsCount: function() {
    return this.option("items").length;
  },
  _normalizeIndex: function(t) {
    var e = this._itemsCount();
    return t < 0 && (t += e), t >= e && (t -= e), t;
  },
  _getRTLSignCorrection: function() {
    return this.option("rtlEnabled") ? -1 : 1;
  },
  _init: function() {
    this.callBase.apply(this, arguments);
    var t = this.$element();
    t.addClass(qIe), this._$wrapper = E("<div>").addClass(XIe), this._$wrapper.appendTo(t), this._$itemContainer = E("<div>").addClass(QIe), this._$itemContainer.appendTo(this._$wrapper), this.option("loopItemFocus", this.option("loop")), this._findBoundaryIndices(), this._initSwipeable();
  },
  _initMarkup: function() {
    this._deferredItems = [], this.callBase();
    var t = this._getSelectedItemIndices();
    this._updateItemsVisibility(t[0]), this._setElementAria(), this._setItemsAria();
  },
  _afterItemElementDeleted: function(t, e) {
    this.callBase(t, e), this._deferredItems && this._deferredItems.splice(e.itemIndex, 1);
  },
  _beforeItemElementInserted: function(t) {
    this.callBase.apply(this, arguments), this._deferredItems && this._deferredItems.splice(t.index, 0, null);
  },
  _executeItemRenderAction: function(t, e, i) {
    t = (this.option("items") || []).indexOf(e), this.callBase(t, e, i);
  },
  _renderItemContent: function(t) {
    var e = new q(), i = this, r = this.callBase, n = new q();
    return n.done(function() {
      var a = r.call(i, t);
      e.resolve(a);
    }), this._deferredItems[t.index] = n, this.option("deferRendering") || n.resolve(), e.promise();
  },
  _render: function() {
    this.callBase(), dn(() => {
      var t = this._getSelectedItemIndices();
      this._updateItems(t[0]);
    });
  },
  _getElementAria: () => ({
    role: "group",
    roledescription: X.format("dxMultiView-elementAriaRoleDescription"),
    label: X.format("dxMultiView-elementAriaLabel")
  }),
  _setElementAria() {
    var t = this._getElementAria();
    this.setAria(t, this.$element());
  },
  _setItemsAria() {
    var t = this._itemElements(), e = this._itemsCount();
    t.each((i, r) => {
      var n = this._getItemAria({
        itemIndex: i,
        itemsCount: e
      });
      this.setAria(n, E(r));
    });
  },
  _getItemAria(t) {
    var {
      itemIndex: e,
      itemsCount: i
    } = t, r = {
      role: "group",
      roledescription: X.format("dxMultiView-itemAriaRoleDescription"),
      label: X.format("dxMultiView-itemAriaLabel", e + 1, i)
    };
    return r;
  },
  _updateItems: function(t, e) {
    this._updateItemsPosition(t, e), this._updateItemsVisibility(t, e);
  },
  _modifyByChanges: function() {
    this.callBase.apply(this, arguments);
    var t = this._getSelectedItemIndices();
    this._updateItemsVisibility(t[0]);
  },
  _updateItemsPosition: function(t, e) {
    var i = this._itemElements(), r = R(e) ? -this._animationDirection(e, t) : void 0, n = i.eq(t);
    Sw.move(n, 0), R(e) && Sw.move(i.eq(e), 100 * r + "%");
  },
  _updateItemsVisibility(t, e) {
    var i = this._itemElements();
    i.each((r, n) => {
      var a = E(n), o = r !== t && r !== e;
      o || this._renderSpecificItem(r), a.toggleClass(ZIe, o), this.setAria("hidden", o || void 0, a);
    });
  },
  _renderSpecificItem: function(t) {
    var e = this._itemElements().eq(t), i = e.find(this._itemContentClass()).length > 0;
    R(t) && !i && (this._deferredItems[t].resolve(), Iu(e));
  },
  _refreshItem: function(t, e) {
    this.callBase(t, e), this._updateItemsVisibility(this.option("selectedIndex"));
  },
  _setAriaSelectionAttribute: ee,
  _updateSelection: function(t, e) {
    var i = t[0], r = e[0];
    PM.complete(this._$itemContainer), this._updateItems(r, i);
    var n = this._animationDirection(i, r);
    this._animateItemContainer(n * this._itemWidth(), (function() {
      Sw.move(this._$itemContainer, 0), this._updateItems(i), mt(this._$itemContainer);
    }).bind(this));
  },
  _animateItemContainer: function(t, e) {
    var i = this.option("animationEnabled") ? eDe : 0;
    PM.moveTo(this._$itemContainer, t, i, e);
  },
  _animationDirection: function(t, e) {
    var i = tDe(this._$itemContainer), r = (e - t) * this._getRTLSignCorrection() * this._getItemFocusLoopSignCorrection(), n = i !== 0, a = n ? i : r;
    return Am(a);
  },
  _getSwipeDisabledState() {
    return !this.option("swipeEnabled") || this._itemsCount() <= 1;
  },
  _initSwipeable() {
    this._createComponent(this.$element(), GT, {
      disabled: this._getSwipeDisabledState(),
      elastic: !1,
      itemSizeFunc: this._itemWidth.bind(this),
      onStart: (t) => this._swipeStartHandler(t.event),
      onUpdated: (t) => this._swipeUpdateHandler(t.event),
      onEnd: (t) => this._swipeEndHandler(t.event)
    });
  },
  _findBoundaryIndices() {
    var t, e, i = this.option("items"), r, n;
    i.forEach((a, o) => {
      var u = !!(a != null && a.disabled);
      if (!u) {
        var c;
        (c = r) !== null && c !== void 0 || (r = o), n = o;
      }
    }), this._boundaryIndices = {
      firstAvailableIndex: (t = r) !== null && t !== void 0 ? t : 0,
      lastAvailableIndex: (e = n) !== null && e !== void 0 ? e : i.length - 1,
      firstTrueIndex: 0,
      lastTrueIndex: i.length - 1
    };
  },
  _swipeStartHandler: function(t) {
    PM.complete(this._$itemContainer);
    var e = this.option("selectedIndex"), i = this.option("loop"), {
      firstAvailableIndex: r,
      lastAvailableIndex: n
    } = this._boundaryIndices, a = this.option("rtlEnabled");
    t.maxLeftOffset = _K(i || (a ? e > r : e < n)), t.maxRightOffset = _K(i || (a ? e < n : e > r)), this._swipeDirection = null;
  },
  _swipeUpdateHandler: function(t) {
    var e = t.offset, i = Am(e) * this._getRTLSignCorrection();
    if (Sw.move(this._$itemContainer, e * this._itemWidth()), i !== this._swipeDirection) {
      this._swipeDirection = i;
      var r = this.option("selectedIndex"), n = this._normalizeIndex(r - i);
      this._updateItems(r, n);
    }
  },
  _findNextAvailableIndex(t, e) {
    var {
      items: i,
      loop: r
    } = this.option(), {
      firstAvailableIndex: n,
      lastAvailableIndex: a,
      firstTrueIndex: o,
      lastTrueIndex: u
    } = this._boundaryIndices, c = [o, n].includes(t), p = [u, a].includes(t);
    if (r) {
      if (c && e < 0)
        return a;
      if (p && e > 0)
        return n;
    }
    for (var v = t + e; v >= n && v <= a; v += e) {
      var _ = !!i[v].disabled;
      if (!_)
        return v;
    }
    return t;
  },
  _swipeEndHandler: function(t) {
    var e = t.targetOffset * this._getRTLSignCorrection();
    if (e) {
      var i = this._findNextAvailableIndex(this.option("selectedIndex"), -e);
      this.option("selectedIndex", i);
      var r = this.itemElements().filter(".dx-item-selected");
      this.option("focusStateEnabled") && this.option("focusedElement", ot(r));
    } else
      this._animateItemContainer(0, ee);
  },
  _getItemFocusLoopSignCorrection: function() {
    return this._itemFocusLooped ? -1 : 1;
  },
  _moveFocus: function() {
    this.callBase.apply(this, arguments), this._itemFocusLooped = !1;
  },
  _prevItem: function(t) {
    var e = this.callBase.apply(this, arguments);
    return this._itemFocusLooped = e.is(t.last()), e;
  },
  _nextItem: function(t) {
    var e = this.callBase.apply(this, arguments);
    return this._itemFocusLooped = e.is(t.first()), e;
  },
  _dimensionChanged: function() {
    this._clearItemWidthCache();
  },
  _visibilityChanged: function(t) {
    t && this._dimensionChanged();
  },
  _updateSwipeDisabledState() {
    var t = this._getSwipeDisabledState();
    GT.getInstance(this.$element()).option("disabled", t);
  },
  _dispose: function() {
    delete this._boundaryIndices, this.callBase();
  },
  _optionChanged: function(t) {
    var e = t.value;
    switch (t.name) {
      case "loop":
        this.option("loopItemFocus", e);
        break;
      case "animationEnabled":
        break;
      case "swipeEnabled":
        this._updateSwipeDisabledState();
        break;
      case "deferRendering":
        this._invalidate();
        break;
      case "items":
        this._updateSwipeDisabledState(), this._findBoundaryIndices(), this.callBase(t);
        break;
      default:
        this.callBase(t);
    }
  }
});
ti("dxMultiView", s8);
var iDe = "dx-tabs-item-badge", CK = "dx-badge", rDe = Up.inherit({
  _renderWatchers: function() {
    this.callBase(), this._startWatcher("badge", this._renderBadge.bind(this));
  },
  _renderBadge: function(t) {
    if (this._$element.children("." + CK).remove(), !!t) {
      var e = E("<div>").addClass(iDe).addClass(CK).text(t);
      this._$element.append(e);
    }
  }
}), yK = "dx-tabs-expanded";
function l8(t) {
  return t.scrollWidth - t.clientWidth;
}
function nDe(t) {
  return t.scrollHeight - t.clientHeight;
}
function aDe(t, e) {
  return Math.round(t) <= e;
}
function oDe(t, e, i) {
  return Math.round(l8(t) - e) <= i;
}
function sDe(t, e) {
  return Math.round(t) <= e;
}
function lDe(t, e, i, r) {
  return Math.round(nDe(t) - e - i) <= r;
}
var uDe = "dx-tabs", dDe = "dx-tabs-wrapper", xK = "dx-tabs-stretched", cDe = "dx-tabs-scrollable", SK = "dx-tabs-nav-buttons", EK = "dx-overflow-hidden", bK = "dx-tab", hDe = "dx-tab-selected", fDe = "dx-tabs-scrolling-enabled", pDe = "dx-tabs-nav-button", vDe = "dx-tabs-nav-button-left", gDe = "dx-tabs-nav-button-right", mDe = "dx-tab-text", _De = "dx-tab-text-span", CDe = "dx-tab-text-span-pseudo", wK = "dx-state-disabled", TK = "dx-focused-disabled-next-tab", IK = "dx-focused-disabled-prev-tab", DK = {
  vertical: "dx-tabs-vertical",
  horizontal: "dx-tabs-horizontal"
}, AK = {
  top: "dx-tab-indicator-position-top",
  right: "dx-tab-indicator-position-right",
  bottom: "dx-tab-indicator-position-bottom",
  left: "dx-tab-indicator-position-left"
}, Wy = {
  top: "dx-tabs-icon-position-top",
  end: "dx-tabs-icon-position-end",
  bottom: "dx-tabs-icon-position-bottom",
  start: "dx-tabs-icon-position-start"
}, FM = {
  primary: "dx-tabs-styling-mode-primary",
  secondary: "dx-tabs-styling-mode-secondary"
}, yDe = "dxTabData", OK = "chevronnext", RK = "chevronprev", xDe = 100, LK = 5, SDe = 300, MK = 30, BM = {
  horizontal: "horizontal",
  vertical: "vertical"
}, Ew = {
  top: "top",
  right: "right",
  bottom: "bottom",
  left: "left"
}, kK = {
  horizontal: "horizontal",
  vertical: "vertical"
}, ep = {
  top: "top",
  end: "end",
  bottom: "bottom",
  start: "start"
}, PK = {
  primary: "primary",
  secondary: "secondary"
}, QB = PB.inherit({
  _activeStateUnit: "." + bK,
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      hoverStateEnabled: !0,
      showNavButtons: !0,
      scrollByContent: !0,
      scrollingEnabled: !0,
      selectionMode: "single",
      orientation: BM.horizontal,
      iconPosition: ep.start,
      stylingMode: PK.primary,
      activeStateEnabled: !0,
      selectionRequired: !1,
      selectOnFocus: !0,
      loopItemFocus: !1,
      useInkRipple: !1,
      badgeExpr: function(t) {
        return t ? t.badge : void 0;
      },
      _itemAttributes: {
        role: "tab"
      },
      _indicatorPosition: null
    });
  },
  _defaultOptionsRules: function() {
    var t = ho();
    return this.callBase().concat([{
      device: () => Ye.real().deviceType !== "desktop",
      options: {
        showNavButtons: !1
      }
    }, {
      device: {
        deviceType: "desktop"
      },
      options: {
        scrollByContent: !1
      }
    }, {
      device: () => Ye.real().deviceType === "desktop" && !Ye.isSimulator(),
      options: {
        focusStateEnabled: !0
      }
    }, {
      device: () => za(t),
      options: {
        iconPosition: ep.top,
        stylingMode: PK.secondary
      }
    }, {
      device: () => _a(t),
      options: {
        useInkRipple: !0,
        selectOnFocus: !1,
        iconPosition: ep.top
      }
    }]);
  },
  _init() {
    var {
      orientation: t,
      stylingMode: e,
      scrollingEnabled: i
    } = this.option(), r = this._getIndicatorPosition();
    this.callBase(), this.$element().addClass(uDe), this._toggleScrollingEnabledClass(i), this._toggleOrientationClass(t), this._toggleIndicatorPositionClass(r), this._toggleIconPositionClass(), this._toggleStylingModeClass(e), this._renderWrapper(), this._renderMultiple(), this._feedbackHideTimeout = xDe;
  },
  _prepareDefaultItemTemplate(t, e) {
    var i = $t(t) ? t == null ? void 0 : t.text : t;
    if (R(i)) {
      var r = E("<span>").addClass(_De);
      r.text(i);
      var n = E("<span>").addClass(CDe);
      n.text(i), n.appendTo(r), r.appendTo(e);
    }
    R(t.html) && e.html(t.html);
  },
  _initTemplates() {
    this.callBase(), this._templateManager.addDefaultTemplates({
      item: new Gp(((t, e) => {
        this._prepareDefaultItemTemplate(e, t);
        var i = ec(e.icon);
        i && i.prependTo(t);
        var r = E("<div>").addClass(mDe);
        t.wrapInner(r);
      }).bind(this), ["text", "html", "icon"], this.option("integrationOptions.watchMethod"))
    });
  },
  _createItemByTemplate: function(t, e) {
    var {
      itemData: i,
      container: r,
      index: n
    } = e;
    return this._deferredTemplates[n] = new q(), t.render({
      model: i,
      container: r,
      index: n,
      onRendered: () => this._deferredTemplates[n].resolve()
    });
  },
  _itemClass: function() {
    return bK;
  },
  _selectedItemClass: function() {
    return hDe;
  },
  _itemDataKey: function() {
    return yDe;
  },
  _initMarkup: function() {
    this._deferredTemplates = [], this.callBase(), this.option("useInkRipple") && this._renderInkRipple(), this.$element().addClass(EK);
  },
  _render: function() {
    this.callBase(), this._deferRenderScrolling();
  },
  _deferRenderScrolling() {
    $e.apply(this, this._deferredTemplates).done(() => this._renderScrolling());
  },
  _renderScrolling() {
    var t = [xK, yK, EK];
    if (this.$element().removeClass(t.join(" ")), this.option("scrollingEnabled") && this._isItemsSizeExceeded()) {
      this._scrollable || (this._renderScrollable(), this._renderNavButtons());
      var e = this.getScrollable();
      if (e.update(), this.option("rtlEnabled")) {
        var i = l8(E(this.getScrollable().container()).get(0));
        e.scrollTo({
          left: i
        });
      }
      this._updateNavButtonsState(), this._scrollToItem(this.option("selectedItem"));
    }
    this.option("scrollingEnabled") && this._isItemsSizeExceeded() || (this._cleanScrolling(), this._needStretchItems() && this.$element().addClass(xK), this.$element().removeClass(SK).addClass(yK));
  },
  _isVertical() {
    return this.option("orientation") === BM.vertical;
  },
  _isItemsSizeExceeded() {
    var t = this._isVertical(), e = t ? this._isItemsHeightExceeded() : this._isItemsWidthExceeded();
    return e;
  },
  _isItemsWidthExceeded() {
    var t = this._getVisibleItems(), e = this._getSummaryItemsSize("width", t, !0), i = mt(this.$element());
    if ([e, i].includes(0))
      return !1;
    var r = e > i - 1;
    return r;
  },
  _isItemsHeightExceeded() {
    var t = this._getVisibleItems(), e = this._getSummaryItemsSize("height", t, !0), i = Pt(this.$element()), r = e - 1 > i;
    return r;
  },
  _needStretchItems() {
    var t = this._getVisibleItems(), e = mt(this.$element()), i = [];
    N(t, (o, u) => {
      i.push(oi(u, !0));
    });
    var r = Math.max.apply(null, i), n = e / t.length, a = r > n + 1;
    return a;
  },
  _cleanNavButtons: function() {
    !this._leftButton || !this._rightButton || (this._leftButton.$element().remove(), this._rightButton.$element().remove(), this._leftButton = null, this._rightButton = null);
  },
  _cleanScrolling: function() {
    this._scrollable && (this._$wrapper.appendTo(this.$element()), this._scrollable.$element().remove(), this._scrollable = null, this._cleanNavButtons());
  },
  _renderInkRipple: function() {
    this._inkRipple = NF();
  },
  _getPointerEvent: () => Xt.up,
  _toggleActiveState: function(t, e, i) {
    if (this.callBase.apply(this, arguments), !!this._inkRipple) {
      var r = {
        element: t,
        event: i
      };
      e ? this._inkRipple.showWave(r) : this._inkRipple.hideWave(r);
    }
  },
  _renderMultiple: function() {
    this.option("selectionMode") === "multiple" && this.option("selectOnFocus", !1);
  },
  _renderWrapper: function() {
    this._$wrapper = E("<div>").addClass(dDe), this.setAria("role", "tablist", this._$wrapper), this.$element().append(this._$wrapper);
  },
  _itemContainer: function() {
    return this._$wrapper;
  },
  _getScrollableDirection() {
    var t = this._isVertical(), e = t ? kK.vertical : kK.horizontal;
    return e;
  },
  _updateScrollable() {
    this.getScrollable() && this._cleanScrolling(), this._renderScrolling();
  },
  _renderScrollable() {
    var t = this.$element().wrapInner(E("<div>").addClass(cDe)).children();
    this._scrollable = this._createComponent(t, ds, {
      direction: this._getScrollableDirection(),
      showScrollbar: "never",
      useKeyboard: !1,
      useNative: !1,
      scrollByContent: this.option("scrollByContent"),
      onScroll: () => {
        this._updateNavButtonsState();
      }
    }), this.$element().append(this._scrollable.$element());
  },
  _scrollToItem: function(t) {
    if (this._scrollable) {
      var e = this._editStrategy.getItemElement(t);
      this._scrollable.scrollToElement(e);
    }
  },
  _renderNavButtons: function() {
    if (this.$element().toggleClass(SK, this.option("showNavButtons")), !!this.option("showNavButtons")) {
      var t = this.option("rtlEnabled");
      this._leftButton = this._createNavButton(-MK, t ? OK : RK);
      var e = this._leftButton.$element();
      e.addClass(vDe), this.$element().prepend(e), this._rightButton = this._createNavButton(MK, t ? RK : OK);
      var i = this._rightButton.$element();
      i.addClass(gDe), this.$element().append(i);
    }
  },
  _updateNavButtonsState() {
    var t = this._isVertical(), e = this.getScrollable();
    if (t) {
      var i, r;
      (i = this._leftButton) === null || i === void 0 || i.option("disabled", sDe(e.scrollTop(), 1)), (r = this._rightButton) === null || r === void 0 || r.option("disabled", lDe(E(e.container()).get(0), e.scrollTop(), 0, 1));
    } else {
      var n, a;
      (n = this._leftButton) === null || n === void 0 || n.option("disabled", aDe(e.scrollLeft(), 1)), (a = this._rightButton) === null || a === void 0 || a.option("disabled", oDe(E(e.container()).get(0), e.scrollLeft(), 1));
    }
  },
  _updateScrollPosition: function(t, e) {
    this._scrollable.update(), this._scrollable.scrollBy(t / e);
  },
  _createNavButton: function(t, e) {
    var i = this, r = i._createAction(function() {
      i._holdInterval = setInterval(function() {
        i._updateScrollPosition(t, LK);
      }, LK);
    }), n = ve(Lh.name, "dxNavButton"), a = ve(Xt.up, "dxNavButton"), o = ve(Xt.out, "dxNavButton"), u = this._createComponent(E("<div>").addClass(pDe), yn, {
      focusStateEnabled: !1,
      icon: e,
      onClick: function() {
        i._updateScrollPosition(t, 1);
      },
      integrationOptions: {}
    }), c = u.$element();
    return k.on(c, n, {
      timeout: SDe
    }, (function(p) {
      r({
        event: p
      });
    }).bind(this)), k.on(c, a, function() {
      i._clearInterval();
    }), k.on(c, o, function() {
      i._clearInterval();
    }), u;
  },
  _clearInterval: function() {
    this._holdInterval && clearInterval(this._holdInterval);
  },
  _updateSelection: function(t) {
    this._scrollable && this._scrollable.scrollToElement(this.itemElements().eq(t[0]));
  },
  _visibilityChanged: function(t) {
    t && this._dimensionChanged();
  },
  _dimensionChanged: function() {
    this._renderScrolling();
  },
  _itemSelectHandler: function(t) {
    this.option("selectionMode") === "single" && this.isItemSelected(t.currentTarget) || this.callBase(t);
  },
  _refreshActiveDescendant: function() {
    this.callBase(this._$wrapper);
  },
  _clean: function() {
    this._deferredTemplates = [], this._cleanScrolling(), this.callBase();
  },
  _toggleTabsVerticalClass(t) {
    this.$element().toggleClass(DK.vertical, t);
  },
  _toggleTabsHorizontalClass(t) {
    this.$element().toggleClass(DK.horizontal, t);
  },
  _getIndicatorPositionClass: (t) => AK[t],
  _getIndicatorPosition() {
    var {
      _indicatorPosition: t,
      rtlEnabled: e
    } = this.option();
    if (t)
      return t;
    var i = this._isVertical();
    return e ? i ? Ew.left : Ew.bottom : i ? Ew.right : Ew.bottom;
  },
  _toggleIndicatorPositionClass(t) {
    var e = this._getIndicatorPositionClass(t);
    this._toggleElementClasses(AK, e);
  },
  _toggleScrollingEnabledClass(t) {
    this.$element().toggleClass(fDe, !!t);
  },
  _toggleOrientationClass(t) {
    var e = t === BM.vertical;
    this._toggleTabsVerticalClass(e), this._toggleTabsHorizontalClass(!e);
  },
  _getTabsIconPositionClass() {
    var t = this.option("iconPosition");
    switch (t) {
      case ep.top:
        return Wy.top;
      case ep.end:
        return Wy.end;
      case ep.bottom:
        return Wy.bottom;
      case ep.start:
      default:
        return Wy.start;
    }
  },
  _toggleIconPositionClass() {
    var t = this._getTabsIconPositionClass();
    this._toggleElementClasses(Wy, t);
  },
  _toggleStylingModeClass(t) {
    var e, i = (e = FM[t]) !== null && e !== void 0 ? e : FM.primary;
    this._toggleElementClasses(FM, i);
  },
  _toggleElementClasses(t, e) {
    for (var i in t)
      this.$element().removeClass(t[i]);
    this.$element().addClass(e);
  },
  _toggleFocusedDisabledNextClass(t, e) {
    this._itemElements().eq(t).toggleClass(TK, e);
  },
  _toggleFocusedDisabledPrevClass(t, e) {
    this._itemElements().eq(t).toggleClass(IK, e);
  },
  _toggleFocusedDisabledClasses(t) {
    var {
      selectedIndex: e
    } = this.option();
    this._itemElements().removeClass(TK).removeClass(IK);
    var i = e - 1, r = e + 1, n = E(t).index(), a = this._itemElements().eq(r).hasClass(wK), o = this._itemElements().eq(i).hasClass(wK), u = a && n === r, c = o && n === i;
    this._toggleFocusedDisabledNextClass(e, u), this._toggleFocusedDisabledPrevClass(e, c);
  },
  _updateFocusedElement() {
    var {
      focusStateEnabled: t,
      selectedIndex: e
    } = this.option(), i = this._itemElements();
    if (t && i.length) {
      var r = i.get(e);
      this.option({
        focusedElement: r
      });
    }
  },
  _optionChanged: function(t) {
    switch (t.name) {
      case "useInkRipple":
      case "scrollingEnabled":
        this._toggleScrollingEnabledClass(t.value), this._invalidate();
        break;
      case "showNavButtons":
        this._invalidate();
        break;
      case "scrollByContent":
        this._scrollable && this._scrollable.option(t.name, t.value);
        break;
      case "width":
      case "height":
        this.callBase(t), this._dimensionChanged();
        break;
      case "selectionMode":
        this._renderMultiple(), this.callBase(t);
        break;
      case "badgeExpr":
        this._invalidate();
        break;
      case "focusedElement":
        this._toggleFocusedDisabledClasses(t.value), this.callBase(t), this._scrollToItem(t.value);
        break;
      case "rtlEnabled":
        this.callBase(t);
        var e = this._getIndicatorPosition();
        this._toggleIndicatorPositionClass(e);
        break;
      case "orientation":
        this._toggleOrientationClass(t.value);
        var i = this._getIndicatorPosition();
        this._toggleIndicatorPositionClass(i), wt() && this._updateScrollable();
        break;
      case "iconPosition":
        this._toggleIconPositionClass(), wt() && this._dimensionChanged();
        break;
      case "stylingMode":
        this._toggleStylingModeClass(t.value), wt() && this._dimensionChanged();
        break;
      case "_indicatorPosition":
        this._toggleIndicatorPositionClass(t.value);
        break;
      case "selectedIndex":
      case "selectedItem":
      case "selectedItems":
        this.callBase(t), this._updateFocusedElement();
        break;
      default:
        this.callBase(t);
    }
  },
  _afterItemElementInserted() {
    this.callBase(), this._deferRenderScrolling();
  },
  _afterItemElementDeleted(t, e) {
    this.callBase(t, e), this._renderScrolling();
  },
  getScrollable() {
    return this._scrollable;
  }
});
QB.ItemClass = rDe;
ti("dxTabs", QB);
class EDe extends Up {
  _renderWatchers() {
    return this._startWatcher("badge", ee), super._renderWatchers();
  }
}
var bDe = "dx-tabpanel", wDe = "dx-tabpanel-tabs", TDe = "dx-tabpanel-tab", IDe = "dx-tabpanel-container", DDe = "dx-tab-text", ADe = "dx-disabled-focused-tab", ODe = "dx-tab-text-span", RDe = "dx-tab-text-span-pseudo", am = {
  top: "dx-tabpanel-tabs-position-top",
  right: "dx-tabpanel-tabs-position-right",
  bottom: "dx-tabpanel-tabs-position-bottom",
  left: "dx-tabpanel-tabs-position-left"
}, tp = {
  top: "top",
  right: "right",
  bottom: "bottom",
  left: "left"
}, LDe = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, FK = {
  horizontal: "horizontal",
  vertical: "vertical"
}, BK = {
  top: "top",
  end: "end",
  bottom: "bottom",
  start: "start"
}, VK = {
  primary: "primary",
  secondary: "secondary"
}, ZB = s8.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      itemTitleTemplate: "title",
      hoverStateEnabled: !0,
      showNavButtons: !1,
      scrollByContent: !0,
      scrollingEnabled: !0,
      tabsPosition: tp.top,
      iconPosition: BK.start,
      stylingMode: VK.primary,
      onTitleClick: null,
      onTitleHold: null,
      onTitleRendered: null,
      badgeExpr: function(t) {
        return t ? t.badge : void 0;
      },
      _tabsIndicatorPosition: null
    });
  },
  _defaultOptionsRules: function() {
    var t = ho();
    return this.callBase().concat([{
      device: function() {
        return Ye.real().deviceType === "desktop" && !Ye.isSimulator();
      },
      options: {
        focusStateEnabled: !0
      }
    }, {
      device: function() {
        return !Ip;
      },
      options: {
        swipeEnabled: !1
      }
    }, {
      device: {
        platform: "generic"
      },
      options: {
        animationEnabled: !1
      }
    }, {
      device: () => za(t),
      options: {
        stylingMode: VK.secondary
      }
    }, {
      device: () => fs(t),
      options: {
        iconPosition: BK.top
      }
    }]);
  },
  _init: function() {
    this.callBase(), this.$element().addClass(bDe), this._toggleTabPanelTabsPositionClass();
  },
  _getElementAria: () => ({
    role: "tabpanel"
  }),
  _getItemAria: () => ({
    role: "tabpanel"
  }),
  _initMarkup: function() {
    this.callBase(), this._createTitleActions(), this._renderLayout();
  },
  _prepareTabsItemTemplate(t, e) {
    var i = ec(t == null ? void 0 : t.icon);
    i && e.append(i);
    var r = $t(t) ? t == null ? void 0 : t.title : t;
    if (R(r) && !$t(r)) {
      var n = E("<span>").addClass(ODe);
      n.append(de.createTextNode(r));
      var a = E("<span>").addClass(RDe);
      a.append(de.createTextNode(r)), a.appendTo(n), n.appendTo(e);
    }
  },
  _initTemplates() {
    this.callBase(), this._templateManager.addDefaultTemplates({
      title: new Gp((t, e) => {
        this._prepareTabsItemTemplate(e, t);
        var i = E("<div>").addClass(DDe);
        t.wrapInner(i);
      }, ["title", "icon"], this.option("integrationOptions.watchMethod"))
    });
  },
  _createTitleActions: function() {
    this._createTitleClickAction(), this._createTitleHoldAction(), this._createTitleRenderedAction();
  },
  _createTitleClickAction: function() {
    this._titleClickAction = this._createActionByOption("onTitleClick");
  },
  _createTitleHoldAction: function() {
    this._titleHoldAction = this._createActionByOption("onTitleHold");
  },
  _createTitleRenderedAction: function() {
    this._titleRenderedAction = this._createActionByOption("onTitleRendered");
  },
  _renderLayout: function() {
    if (!this._tabs) {
      var t = this.$element();
      this._$tabContainer = E("<div>").addClass(wDe).appendTo(t);
      var e = E("<div>").appendTo(this._$tabContainer);
      this._tabs = this._createComponent(e, QB, this._tabConfig()), this._$container = E("<div>").addClass(IDe).appendTo(t), this._$container.append(this._$wrapper);
    }
  },
  _refreshActiveDescendant: function() {
    if (this._tabs) {
      var t = this._tabs, e = t.itemElements(), i = E(e[t.option("selectedIndex")]), r = this.getFocusedItemId();
      this.setAria("controls", void 0, E(e)), this.setAria("controls", r, i);
    }
  },
  _getTabsIndicatorPosition() {
    var {
      _tabsIndicatorPosition: t,
      tabsPosition: e
    } = this.option();
    return t ?? LDe[e];
  },
  _tabConfig() {
    var t = this._getTabsIndicatorPosition();
    return {
      selectOnFocus: !0,
      focusStateEnabled: this.option("focusStateEnabled"),
      hoverStateEnabled: this.option("hoverStateEnabled"),
      repaintChangesOnly: this.option("repaintChangesOnly"),
      tabIndex: this.option("tabIndex"),
      selectedIndex: this.option("selectedIndex"),
      badgeExpr: this.option("badgeExpr"),
      onItemClick: this._titleClickAction.bind(this),
      onItemHold: this._titleHoldAction.bind(this),
      itemHoldTimeout: this.option("itemHoldTimeout"),
      onSelectionChanged: (function(e) {
        this.option("selectedIndex", e.component.option("selectedIndex")), this._refreshActiveDescendant();
      }).bind(this),
      onItemRendered: this._titleRenderedAction.bind(this),
      itemTemplate: this._getTemplateByOption("itemTitleTemplate"),
      items: this.option("items"),
      noDataText: null,
      scrollingEnabled: this.option("scrollingEnabled"),
      scrollByContent: this.option("scrollByContent"),
      showNavButtons: this.option("showNavButtons"),
      itemTemplateProperty: "tabTemplate",
      loopItemFocus: this.option("loop"),
      selectionRequired: !0,
      onOptionChanged: (function(e) {
        if (e.name === "focusedElement")
          if (e.value) {
            var i = E(e.value), r = this._itemElements().eq(i.index());
            this.option("focusedElement", ot(r));
          } else
            this.option("focusedElement", e.value);
      }).bind(this),
      onFocusIn: (function(e) {
        this._focusInHandler(e.event);
      }).bind(this),
      onFocusOut: (function(e) {
        this._isFocusOutHandlerExecuting || this._focusOutHandler(e.event);
      }).bind(this),
      orientation: this._getTabsOrientation(),
      iconPosition: this.option("iconPosition"),
      stylingMode: this.option("stylingMode"),
      _itemAttributes: {
        class: TDe
      },
      _indicatorPosition: t
    };
  },
  _renderFocusTarget: function() {
    this._focusTarget().attr("tabIndex", -1);
  },
  _getTabsOrientation() {
    var {
      tabsPosition: t
    } = this.option();
    return [tp.right, tp.left].includes(t) ? FK.vertical : FK.horizontal;
  },
  _getTabPanelTabsPositionClass() {
    var t = this.option("tabsPosition");
    switch (t) {
      case tp.right:
        return am.right;
      case tp.bottom:
        return am.bottom;
      case tp.left:
        return am.left;
      case tp.top:
      default:
        return am.top;
    }
  },
  _toggleTabPanelTabsPositionClass() {
    for (var t in am)
      this.$element().removeClass(am[t]);
    var e = this._getTabPanelTabsPositionClass();
    this.$element().addClass(e);
  },
  _updateTabsOrientation() {
    var t = this._getTabsOrientation();
    this._setTabsOption("orientation", t);
  },
  _toggleWrapperFocusedClass(t) {
    this._toggleFocusClass(t, this._$wrapper);
  },
  _toggleDisabledFocusedClass(t) {
    this._focusTarget().toggleClass(ADe, t);
  },
  _updateFocusState: function(t, e) {
    this.callBase(t, e);
    var i = t.target === this._tabs._focusTarget().get(0), r = t.target === this._focusTarget().get(0);
    if (i && this._toggleFocusClass(e, this._focusTarget()), i || r) {
      var n = this._isDisabled(this.option("focusedElement"));
      this._toggleWrapperFocusedClass(e && !n), this._toggleDisabledFocusedClass(e && n);
    }
    r && this._toggleFocusClass(e, this._tabs.option("focusedElement"));
  },
  _focusOutHandler: function(t) {
    this._isFocusOutHandlerExecuting = !0, this.callBase.apply(this, arguments), this._tabs._focusOutHandler(t), this._isFocusOutHandlerExecuting = !1;
  },
  _setTabsOption(t, e) {
    this._tabs && this._tabs.option(t, e);
  },
  _visibilityChanged: function(t) {
    t && this._tabs._dimensionChanged();
  },
  registerKeyHandler: function(t, e) {
    this.callBase(t, e), this._tabs && this._tabs.registerKeyHandler(t, e);
  },
  repaint: function() {
    this.callBase(), this._tabs.repaint();
  },
  _updateTabsIndicatorPosition() {
    var t = this._getTabsIndicatorPosition();
    this._setTabsOption("_indicatorPosition", t);
  },
  _optionChanged: function(t) {
    var {
      name: e,
      value: i,
      fullName: r
    } = t;
    switch (e) {
      case "dataSource":
        this.callBase(t);
        break;
      case "items":
        this._setTabsOption(e, this.option(e)), this.option("repaintChangesOnly") || this._tabs.repaint(), this.callBase(t);
        break;
      case "width":
        this.callBase(t), this._tabs.repaint();
        break;
      case "selectedIndex":
      case "selectedItem":
        if (this._setTabsOption(r, i), this.callBase(t), this.option("focusStateEnabled") === !0) {
          var n = this.option("selectedIndex"), a = this._itemElements().eq(n);
          this.option("focusedElement", ot(a));
        }
        break;
      case "itemHoldTimeout":
      case "focusStateEnabled":
      case "hoverStateEnabled":
        this._setTabsOption(r, i), this.callBase(t);
        break;
      case "scrollingEnabled":
      case "scrollByContent":
      case "showNavButtons":
        this._setTabsOption(r, i);
        break;
      case "focusedElement":
        var o = i && E(i).index(), u = i && this._tabs._itemElements().eq(o);
        if (this._setTabsOption("focusedElement", ot(u)), i) {
          var c = this._isDisabled(i);
          this._toggleWrapperFocusedClass(!c), this._toggleDisabledFocusedClass(c);
        }
        this.callBase(t);
        break;
      case "itemTitleTemplate":
        this._setTabsOption("itemTemplate", this._getTemplateByOption("itemTitleTemplate"));
        break;
      case "onTitleClick":
        this._createTitleClickAction(), this._setTabsOption("onItemClick", this._titleClickAction.bind(this));
        break;
      case "onTitleHold":
        this._createTitleHoldAction(), this._setTabsOption("onItemHold", this._titleHoldAction.bind(this));
        break;
      case "onTitleRendered":
        this._createTitleRenderedAction(), this._setTabsOption("onItemRendered", this._titleRenderedAction.bind(this));
        break;
      case "loop":
        this._setTabsOption("loopItemFocus", i);
        break;
      case "badgeExpr":
        this._invalidate();
        break;
      case "tabsPosition":
        this._toggleTabPanelTabsPositionClass(), this._updateTabsIndicatorPosition(), this._updateTabsOrientation();
        break;
      case "iconPosition":
        this._setTabsOption("iconPosition", i);
        break;
      case "stylingMode":
        this._setTabsOption("stylingMode", i);
        break;
      case "_tabsIndicatorPosition":
        this._setTabsOption("_indicatorPosition", i);
        break;
      default:
        this.callBase(t);
    }
  }
});
ZB.ItemClass = EDe;
ti("dxTabPanel", ZB);
class qp {
  constructor(e) {
    this._options = e, this._itemsRunTimeInfo = this._options.itemsRunTimeInfo;
  }
  findInstance() {
    return this._itemsRunTimeInfo.findWidgetInstanceByItem(this._options.item);
  }
  findItemContainer() {
    return this._itemsRunTimeInfo.findItemContainerByItem(this._options.item);
  }
  findPreparedItem() {
    return this._itemsRunTimeInfo.findPreparedItemByItem(this._options.item);
  }
  tryExecute() {
    wi.abstract();
  }
}
var RP = (t, e) => "".concat(e ? "tabs" : "items", "[").concat(t, "]"), u8 = (t, e) => R(t) && R(e) ? "".concat(t, ".").concat(e) : t || e, LP = (t) => t ? t.replace(/\s/g, "") : void 0, MDe = (t, e) => t ? t.dataField === e || t.name === e || LP(t.title) === e || t.itemType === "group" && LP(t.caption) === e : !1, ix = (t, e) => "".concat(t, ".").concat(e), NK = (t) => {
  var e = t.split(".");
  return e[e.length - 1].replace(/\[\d+]/, "");
}, kDe = (t) => {
  for (var e = t.split("."), i = [...e], r = e.length - 1; r >= 0; r--) {
    if (d8(e[r]))
      return i.join(".");
    i.splice(r, 1);
  }
  return "";
}, d8 = (t) => t.indexOf("tabs") > -1, c8 = (t, e, i) => {
  var r = t.indexOf(e);
  if (r > -1)
    return RP(r, i);
  for (var n = 0; n < t.length; n++) {
    var a = t[n], o = a.tabs || a.items;
    if (o) {
      var u = c8(o, e, a.tabs);
      if (u)
        return u8(RP(n, i), u);
    }
  }
};
function PDe(t) {
  var {
    form: e,
    $formElement: i,
    formOptions: r,
    items: n,
    validationGroup: a,
    extendedLayoutManagerOptions: o,
    onFieldDataChanged: u,
    onContentReady: c,
    onDisposing: p,
    onFieldItemRendered: v
  } = t, _ = {
    form: e,
    items: n,
    $formElement: i,
    validationGroup: a,
    onFieldDataChanged: u,
    onContentReady: c,
    onDisposing: p,
    onFieldItemRendered: v,
    validationBoundary: r.scrollingEnabled ? i : void 0,
    scrollingEnabled: r.scrollingEnabled,
    showRequiredMark: r.showRequiredMark,
    showOptionalMark: r.showOptionalMark,
    requiredMark: r.requiredMark,
    optionalMark: r.optionalMark,
    requiredMessage: r.requiredMessage,
    screenByWidth: r.screenByWidth,
    layoutData: r.formData,
    labelLocation: r.labelLocation,
    customizeItem: r.customizeItem,
    minColWidth: r.minColWidth,
    showColonAfterLabel: r.showColonAfterLabel,
    onEditorEnterKey: r.onEditorEnterKey,
    labelMode: r.labelMode
  }, y = P(_, {
    isRoot: o.isRoot,
    colCount: o.colCount,
    alignItemLabels: o.alignItemLabels,
    cssItemClass: o.cssItemClass,
    colCountByScreen: o.colCountByScreen,
    onLayoutChanged: o.onLayoutChanged,
    width: o.width
  });
  return y;
}
class FDe extends qp {
  tryExecute() {
    var {
      value: e
    } = this._options, i = this.findInstance();
    return i ? (i.option(e), !0) : !1;
  }
}
class HK extends qp {
  tryExecute() {
    var e = this.findInstance();
    if (e) {
      var {
        optionName: i,
        item: r,
        value: n
      } = this._options, a = this._itemsRunTimeInfo.findItemIndexByItem(r);
      if (a >= 0)
        return e.option(ix("items[".concat(a, "]"), i), n), !0;
    }
    return !1;
  }
}
class BDe extends qp {
  tryExecute() {
    return !1;
  }
}
class VDe extends qp {
  tryExecute() {
    var e = this.findPreparedItem();
    return e != null && e._prepareGroupItemTemplate && e._renderGroupContentTemplate ? (e._prepareGroupItemTemplate(this._options.item.template), e._renderGroupContentTemplate(), !0) : !1;
  }
}
class NDe extends qp {
  tryExecute() {
    var e = this.findInstance();
    if (e) {
      var {
        value: i
      } = this._options;
      return e.option("dataSource", i), !0;
    }
    return !1;
  }
}
class HDe extends qp {
  tryExecute() {
    var {
      item: e
    } = this._options, i = this.findInstance(), r = i && dr(i.$element()[0], "dxValidator");
    if (r && e) {
      var n = (u) => u.type === "required", a = (r.option("validationRules") || []).some(n), o = (e.validationRules || []).some(n);
      if (!a && !o || a && o)
        return r.option("validationRules", e.validationRules), !0;
    }
    return !1;
  }
}
class $De extends qp {
  tryExecute() {
    var e = this.findItemContainer(), {
      previousValue: i,
      value: r
    } = this._options;
    return e ? (e.removeClass(i).addClass(r), !0) : !1;
  }
}
var zDe = (t, e) => {
  switch (t) {
    case "editorOptions":
    case "buttonOptions":
      return new FDe(e);
    case "validationRules":
      return new HDe(e);
    case "cssClass":
      return new $De(e);
    case "badge":
    case "disabled":
    case "icon":
    case "tabTemplate":
    case "title":
      return new HK(P(e, {
        optionName: t
      }));
    case "tabs":
      return new NDe(e);
    case "template":
      var i, r, n, a = (i = e == null || (r = e.item) === null || r === void 0 ? void 0 : r.itemType) !== null && i !== void 0 ? i : (n = e.itemsRunTimeInfo.findPreparedItemByItem(e == null ? void 0 : e.item)) === null || n === void 0 ? void 0 : n.itemType;
      return a === "simple" ? new BDe(e) : a === "group" ? new VDe(e) : new HK(P(e, {
        optionName: t
      }));
    default:
      return null;
  }
}, h8 = "dx-responsivebox", $K = h8 + "-screen-", WDe = "dx-box-item", zK = "dxBoxItemData", UDe = 1920, f8 = Kp.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      rows: [],
      cols: [],
      screenByWidth: null,
      singleColumnScreen: "",
      height: "100%",
      width: "100%",
      activeStateEnabled: !1,
      focusStateEnabled: !1,
      onItemStateChanged: void 0,
      onLayoutChanged: null,
      currentScreenFactor: void 0
    });
  },
  _init: function() {
    this.option("screenByWidth") || this._options.silent("screenByWidth", uF), this.callBase(), this._initLayoutChangedAction();
  },
  _initLayoutChangedAction: function() {
    this._layoutChangedAction = this._createActionByOption("onLayoutChanged", {
      excludeValidators: ["disabled", "readonly"]
    });
  },
  _itemClass: function() {
    return WDe;
  },
  _itemDataKey: function() {
    return zK;
  },
  _initMarkup: function() {
    this.callBase(), this.$element().addClass(h8);
  },
  _renderItems: function() {
    this._setScreenSize(), this._screenItems = this._itemsByScreen(), this._prepareGrid(), this._spreadItems(), this._layoutItems(), this._linkNodeToItem();
  },
  _itemOptionChanged: function(t) {
    var e = this._findItemElementByItem(t);
    e.length && (this._refreshItem(e, t), this._clearItemNodeTemplates(), this._update(!0));
  },
  _setScreenSize: function() {
    var t = this._getCurrentScreen();
    this._removeScreenSizeClass(), this.$element().addClass($K + t), this.option("currentScreenFactor", t);
  },
  _removeScreenSizeClass: function() {
    var t = this.option("currentScreenFactor");
    t && this.$element().removeClass($K + t);
  },
  _prepareGrid: function() {
    var t = this._grid = [];
    this._prepareRowsAndCols(), N(this._rows, (function() {
      var e = [];
      t.push(e), N(this._cols, (function() {
        e.push(this._createEmptyCell());
      }).bind(this));
    }).bind(this));
  },
  getSingleColumnRows: function() {
    var t = this.option("rows"), e = this._screenItems.length;
    if (t.length) {
      for (var i = this._filterByScreen(t), r = [], n = 0; n < e; n++) {
        var a = this._defaultSizeConfig();
        n < i.length && R(i[n].shrink) && (a.shrink = i[n].shrink), r.push(a);
      }
      return r;
    } else
      return this._defaultSizeConfig(e);
  },
  _prepareRowsAndCols: function() {
    this._isSingleColumnScreen() ? (this._prepareSingleColumnScreenItems(), this._rows = this.getSingleColumnRows(), this._cols = this._defaultSizeConfig(1)) : (this._rows = this._sizesByScreen(this.option("rows")), this._cols = this._sizesByScreen(this.option("cols")));
  },
  _isSingleColumnScreen: function() {
    return this._screenRegExp().test(this.option("singleColumnScreen")) || !this.option("rows").length || !this.option("cols").length;
  },
  _prepareSingleColumnScreenItems: function() {
    this._screenItems.sort(function(t, e) {
      return t.location.row - e.location.row || t.location.col - e.location.col;
    }), N(this._screenItems, function(t, e) {
      P(e.location, {
        row: t,
        col: 0,
        rowspan: 1,
        colspan: 1
      });
    });
  },
  _sizesByScreen: function(t) {
    return Jr(this._filterByScreen(t), (function(e) {
      return P(this._defaultSizeConfig(), e);
    }).bind(this));
  },
  _createDefaultSizeConfig: function() {
    return {
      ratio: 1,
      baseSize: 0,
      minSize: 0,
      maxSize: 0
    };
  },
  _defaultSizeConfig: function(t) {
    var e = this._createDefaultSizeConfig();
    if (!arguments.length)
      return e;
    for (var i = [], r = 0; r < t; r++)
      i.push(e);
    return i;
  },
  _filterByScreen: function(t) {
    var e = this._screenRegExp();
    return so(t, function(i) {
      return !i.screen || e.test(i.screen);
    });
  },
  _screenRegExp: function() {
    var t = this._getCurrentScreen();
    return new RegExp("(^|\\s)" + t + "($|\\s)", "i");
  },
  _getCurrentScreen: function() {
    var t = this._screenWidth();
    return this.option("screenByWidth")(t);
  },
  _screenWidth: function() {
    return wt() ? mt(Ot()) : UDe;
  },
  _createEmptyCell: function() {
    return {
      item: {},
      location: {
        colspan: 1,
        rowspan: 1
      }
    };
  },
  _spreadItems: function() {
    N(this._screenItems, (function(t, e) {
      var i = e.location || {}, r = i.col, n = i.row, a = this._grid[n], o = a && a[r];
      this._occupyCells(o, e);
    }).bind(this));
  },
  _itemsByScreen: function() {
    return this.option("items").reduce((t, e) => {
      var i = e.location || {};
      return i = $t(i) ? [i] : i, this._filterByScreen(i).forEach((r) => {
        t.push({
          item: e,
          location: P({
            rowspan: 1,
            colspan: 1
          }, r)
        });
      }), t;
    }, []);
  },
  _occupyCells: function(t, e) {
    !t || this._isItemCellOccupied(t, e) || (P(t, e), this._markSpanningCell(t));
  },
  _isItemCellOccupied: function(t, e) {
    if (!uo(t.item))
      return !0;
    var i = !1;
    return this._loopOverSpanning(e.location, function(r) {
      i = i || !uo(r.item);
    }), i;
  },
  _loopOverSpanning: function(t, e) {
    var i = t.row + t.rowspan - 1, r = t.col + t.colspan - 1, n = Math.min(i, this._rows.length - 1), a = Math.min(r, this._cols.length - 1);
    t.rowspan -= i - n, t.colspan -= r - a;
    for (var o = t.row; o <= n; o++)
      for (var u = t.col; u <= a; u++)
        (o !== t.row || u !== t.col) && e(this._grid[o][u]);
  },
  _markSpanningCell: function(t) {
    this._loopOverSpanning(t.location, function(e) {
      P(e, {
        item: t.item,
        spanningCell: t
      });
    });
  },
  _linkNodeToItem: function() {
    N(this._itemElements(), function(t, e) {
      var i = E(e), r = i.data(zK);
      r.box || (r.node = i.children());
    });
  },
  _layoutItems: function() {
    var t = this._grid.length, e = t && this._grid[0].length;
    if (!(!t && !e)) {
      var i = this._layoutBlock({
        direction: "col",
        row: {
          start: 0,
          end: t - 1
        },
        col: {
          start: 0,
          end: e - 1
        }
      }), r = this._prepareBoxConfig(i.box || {
        direction: "row",
        items: [P(i, {
          ratio: 1
        })]
      });
      P(r, this._rootBoxConfig(r.items)), this._$root = E("<div>").appendTo(this._itemContainer()), this._createComponent(this._$root, Mh, r);
    }
  },
  _rootBoxConfig: function(t) {
    var e = N(t, (function(i, r) {
      this._needApplyAutoBaseSize(r) && P(r, {
        baseSize: "auto"
      });
    }).bind(this));
    return {
      width: "100%",
      height: "100%",
      items: e,
      itemTemplate: this._getTemplateByOption("itemTemplate"),
      itemHoldTimeout: this.option("itemHoldTimeout"),
      onItemHold: this._createActionByOption("onItemHold"),
      onItemClick: this._createActionByOption("onItemClick"),
      onItemContextMenu: this._createActionByOption("onItemContextMenu"),
      onItemRendered: this._createActionByOption("onItemRendered")
    };
  },
  _needApplyAutoBaseSize: function(t) {
    return !t.baseSize && (!t.minSize || t.minSize === "auto") && (!t.maxSize || t.maxSize === "auto");
  },
  _prepareBoxConfig: function(t) {
    return P(t || {}, {
      crossAlign: "stretch",
      onItemStateChanged: this.option("onItemStateChanged")
    });
  },
  _layoutBlock: function(t) {
    return this._isSingleItem(t) ? this._itemByCell(t.row.start, t.col.start) : this._layoutDirection(t);
  },
  _isSingleItem: function(t) {
    var e = this._grid[t.row.start][t.col.start].location, i = t.row.end - t.row.start === e.rowspan - 1, r = t.col.end - t.col.start === e.colspan - 1;
    return i && r;
  },
  _itemByCell: function(t, e) {
    var i = this._grid[t][e];
    return i.spanningCell ? null : i.item;
  },
  _layoutDirection: function(t) {
    for (var e = [], i = t.direction, r = this._crossDirection(i), n; n = this._nextBlock(t); ) {
      if (this._isBlockIndivisible(t.prevBlockOptions, n))
        throw Yt.Error("E1025");
      var a = this._layoutBlock({
        direction: r,
        row: n.row,
        col: n.col,
        prevBlockOptions: t
      });
      a && (P(a, this._blockSize(n, r)), e.push(a)), t[r].start = n[r].end + 1;
    }
    return {
      box: this._prepareBoxConfig({
        direction: i,
        items: e
      })
    };
  },
  _isBlockIndivisible: function(t, e) {
    return t && t.col.start === e.col.start && t.col.end === e.col.end && t.row.start === e.row.start && t.row.end === e.row.end;
  },
  _crossDirection: function(t) {
    return t === "col" ? "row" : "col";
  },
  _nextBlock: function(t) {
    var e = t.direction, i = this._crossDirection(e), r = t[e].start, n = t[e].end, a = t[i].start;
    if (a > t[i].end)
      return null;
    for (var o = 1, u = a; u < a + o; u++) {
      for (var c = 1, p = r; p <= n; p++) {
        var v = this._cellByDirection(e, p, u);
        c = Math.max(c, v.location[i + "span"]);
      }
      var _ = u + c, y = a + o;
      _ > y && (o += _ - y);
    }
    var b = {};
    return b[e] = {
      start: r,
      end: n
    }, b[i] = {
      start: a,
      end: a + o - 1
    }, b;
  },
  _cellByDirection: function(t, e, i) {
    return t === "col" ? this._grid[i][e] : this._grid[e][i];
  },
  _blockSize: function(t, e) {
    for (var i = e === "row" ? "auto" : 0, r = e === "row" ? this._rows : this._cols, n = P(this._createDefaultSizeConfig(), {
      ratio: 0
    }), a = t[e].start; a <= t[e].end; a++) {
      var o = r[a];
      n.ratio += o.ratio, n.baseSize += o.baseSize, n.minSize += o.minSize, n.maxSize += o.maxSize, R(o.shrink) && (n.shrink = o.shrink);
    }
    return n.minSize = n.minSize ? n.minSize : i, n.maxSize = n.maxSize ? n.maxSize : "auto", this._isSingleColumnScreen() && (n.baseSize = "auto"), n;
  },
  _update: function(t) {
    var e = this._$root;
    this._renderItems(), e && (t ? e.remove() : (e.detach(), this._saveAssistantRoot(e))), this._layoutChangedAction();
  },
  _saveAssistantRoot: function(t) {
    this._assistantRoots = this._assistantRoots || [], this._assistantRoots.push(t);
  },
  _dispose: function() {
    this._clearItemNodeTemplates(), this._cleanUnusedRoots(), this.callBase.apply(this, arguments);
  },
  _cleanUnusedRoots: function() {
    this._assistantRoots && N(this._assistantRoots, function(t, e) {
      E(e).remove();
    });
  },
  _clearItemNodeTemplates: function() {
    N(this.option("items"), function() {
      delete this.node;
    });
  },
  _attachClickEvent: ee,
  _optionChanged: function(t) {
    switch (t.name) {
      case "rows":
      case "cols":
      case "screenByWidth":
      case "singleColumnScreen":
        this._clearItemNodeTemplates(), this._invalidate();
        break;
      case "width":
      case "height":
        this.callBase(t), this._update();
        break;
      case "onLayoutChanged":
        this._initLayoutChangedAction();
        break;
      case "itemTemplate":
        this._clearItemNodeTemplates(), this.callBase(t);
        break;
      case "currentScreenFactor":
        break;
      default:
        this.callBase(t);
    }
  },
  _dimensionChanged: function() {
    this._getCurrentScreen() !== this.option("currentScreenFactor") && this._update();
  },
  repaint: function() {
    this._update();
  }
});
ti("dxResponsiveBox", f8);
var GDe = "dx-form", VM = "dx-form-group", KDe = "dx-form-group-caption", WK = "dx-col-", p8 = "dx-field-item", UK = "dx-layout-manager-one-col", v8 = "dx-field-item-label-content", jDe = "dx-layout-manager", g8 = "dx-field-item-label", MP = "dx-field-item-content", YDe = "dx-single-column-item-content", m8 = "dx-root-simple-item", qDe = "dx-form-group-content", XDe = "dx-field-item-has-group", QDe = "dx-field-item-has-tabs", ZDe = "dx-form-group-with-caption", GK = "dx-field-item-tab", KK = "dx-group-colcount-", jK = "group-col-count", JDe = "dx-form-validation-summary", eAe = "dx-form-styling-mode-underlined", kP = "simple", tAe = wi.inherit({
  ctor(t, e) {
    this.editor = t, this.validator = e, this.validationRequestsCallbacks = [];
    var i = (r) => {
      this.validationRequestsCallbacks.forEach((n) => n(r));
    };
    t.validationRequest.add(i), t.on("disposing", function() {
      t.validationRequest.remove(i);
    });
  },
  getValue() {
    return this.editor.option("value");
  },
  getCurrentValidationError() {
    return this.editor.option("validationError");
  },
  bypass() {
    return this.editor.option("disabled");
  },
  applyValidationResults(t) {
    this.editor.option({
      validationErrors: t.brokenRules,
      validationStatus: t.status
    });
  },
  reset() {
    this.editor.clear();
  },
  focus() {
    this.editor.focus();
  }
}), iAe = "dx-validator", YK = "valid", rAe = "invalid", NM = "pending", BI = Nu.inherit({
  _initOptions: function(t) {
    this.callBase.apply(this, arguments), this.option(Si.initValidationOptions(t));
  },
  _getDefaultOptions() {
    return P(this.callBase(), {
      validationRules: []
    });
  },
  _init() {
    this.callBase(), this._initGroupRegistration(), this.focused = ui(), this._initAdapter(), this._validationInfo = {
      result: null,
      deferred: null,
      skipValidation: !1
    };
  },
  _initGroupRegistration() {
    var t = this._findGroup();
    this._groupWasInit || this.on("disposing", function(e) {
      Si.removeRegisteredValidator(e.component._validationGroup, e.component);
    }), (!this._groupWasInit || this._validationGroup !== t) && (Si.removeRegisteredValidator(this._validationGroup, this), this._groupWasInit = !0, this._validationGroup = t, Si.registerValidatorInGroup(t, this));
  },
  _setOptionsByReference() {
    this.callBase(), P(this._optionsByReference, {
      validationGroup: !0
    });
  },
  _getEditor() {
    var t = this.$element()[0];
    return dr(t, "dx-validation-target");
  },
  _initAdapter() {
    var t = this._getEditor(), e = this.option("adapter");
    if (!e) {
      if (t) {
        e = new tAe(t, this), e.validationRequestsCallbacks.push((r) => {
          this._validationInfo.skipValidation || this.validate(r);
        }), this.option("adapter", e);
        return;
      }
      throw Yt.Error("E0120");
    }
    var i = e.validationRequestsCallbacks;
    i && i.push((r) => {
      this.validate(r);
    });
  },
  _toggleRTLDirection(t) {
    var e, i, r, n = (e = (i = this.option("adapter")) === null || i === void 0 || (r = i.editor) === null || r === void 0 ? void 0 : r.option("rtlEnabled")) !== null && e !== void 0 ? e : t;
    this.callBase(n);
  },
  _initMarkup() {
    this.$element().addClass(iAe), this.callBase();
  },
  _render() {
    this.callBase(), this._toggleAccessibilityAttributes();
  },
  _toggleAccessibilityAttributes() {
    var t = this._getEditor();
    if (t) {
      var e = this.option("validationRules") || [], i = e.some((r) => {
        var {
          type: n
        } = r;
        return n === "required";
      }) || null;
      t.isInitialized() && t.setAria("required", i), t.option("_onMarkupRendered", () => {
        t.setAria("required", i);
      });
    }
  },
  _visibilityChanged(t) {
    t && this._initGroupRegistration();
  },
  _optionChanged(t) {
    switch (t.name) {
      case "validationGroup":
        this._initGroupRegistration();
        return;
      case "validationRules":
        this._resetValidationRules(), this._toggleAccessibilityAttributes(), this.option("isValid") !== void 0 && this.validate();
        return;
      case "adapter":
        this._initAdapter();
        break;
      case "isValid":
      case "validationStatus":
        this.option(Si.synchronizeValidationOptions(t, this.option()));
        break;
      default:
        this.callBase(t);
    }
  },
  _getValidationRules() {
    return this._validationRules || (this._validationRules = Jr(this.option("validationRules"), (t, e) => P({}, t, {
      validator: this,
      index: e
    }))), this._validationRules;
  },
  _findGroup() {
    var t = this.$element();
    return this.option("validationGroup") || Si.findGroup(t, this._modelByElement(t));
  },
  _resetValidationRules() {
    delete this._validationRules;
  },
  validate(t) {
    var e = this.option("adapter"), i = this.option("name"), r = e.bypass && e.bypass(), n = t && t.value !== void 0 ? t.value : e.getValue(), a = e.getCurrentValidationError && e.getCurrentValidationError(), o = this._getValidationRules(), u = this._validationInfo && this._validationInfo.result;
    if (u && u.status === NM && u.value === n)
      return P({}, u);
    var c;
    return r ? c = {
      isValid: !0,
      status: YK
    } : a && a.editorSpecific ? (a.validator = this, c = {
      isValid: !1,
      status: rAe,
      brokenRule: a,
      brokenRules: [a]
    }) : c = Si.validate(n, o, i), c.id = new yr().toString(), this._applyValidationResult(c, e), c.complete && c.complete.then((p) => {
      p.id === this._validationInfo.result.id && this._applyValidationResult(p, e);
    }), P({}, this._validationInfo.result);
  },
  reset() {
    var t = this.option("adapter"), e = {
      id: null,
      isValid: !0,
      brokenRule: null,
      brokenRules: null,
      pendingRules: null,
      status: YK,
      complete: null
    };
    this._validationInfo.skipValidation = !0, t.reset(), this._validationInfo.skipValidation = !1, this._resetValidationRules(), this._applyValidationResult(e, t);
  },
  _updateValidationResult(t) {
    if (!this._validationInfo.result || this._validationInfo.result.id !== t.id) {
      var e = this._validationInfo.deferred && this._validationInfo.result.complete;
      this._validationInfo.result = P({}, t, {
        complete: e
      });
    } else
      for (var i in t)
        i !== "id" && i !== "complete" && (this._validationInfo.result[i] = t[i]);
  },
  _applyValidationResult(t, e) {
    var i = this._createActionByOption("onValidated", {
      excludeValidators: ["readOnly"]
    });
    if (t.validator = this, this._updateValidationResult(t), e.applyValidationResults && e.applyValidationResults(this._validationInfo.result), this.option({
      validationStatus: this._validationInfo.result.status
    }), this._validationInfo.result.status === NM) {
      this._validationInfo.deferred || (this._validationInfo.deferred = new q(), this._validationInfo.result.complete = this._validationInfo.deferred.promise()), this._eventsStrategy.fireEvent("validating", [this._validationInfo.result]);
      return;
    }
    this._validationInfo.result.status !== NM && (i(t), this._validationInfo.deferred && (this._validationInfo.deferred.resolve(t), this._validationInfo.deferred = null));
  },
  focus() {
    var t = this.option("adapter");
    t && t.focus && t.focus();
  },
  _useTemplates: function() {
    return !1;
  }
});
ti("dxValidator", BI);
var nAe = ["dxTagBox", "dxRangeSlider", "dxDateRangeBox"], aAe = ["dxCalendar", "dxCheckBox", "dxHtmlEditor", "dxRadioGroup", "dxRangeSlider", "dxSlider", "dxSwitch"];
function oAe(t) {
  var {
    $parent: e,
    rootElementCssClassList: i,
    formOrLayoutManager: r,
    createComponentCallback: n,
    item: a,
    template: o,
    labelTemplate: u,
    name: c,
    formLabelLocation: p,
    requiredMessageTemplate: v,
    validationGroup: _,
    editorValue: y,
    canAssignUndefinedValueToEditor: b,
    editorValidationBoundary: I,
    editorStylingMode: A,
    showColonAfterLabel: L,
    managerLabelLocation: B,
    itemId: $,
    managerMarkOptions: K,
    labelMode: te,
    onLabelTemplateRendered: z
  } = t, ie = R(a.isRequired) ? a.isRequired : !!uAe(a.validationRules), pe = a.itemType === kP, _e = a.helpText ? "dx-" + new yr() : null, be = dAe({
    item: a,
    id: $,
    isRequired: ie,
    managerMarkOptions: K,
    showColonAfterLabel: L,
    labelLocation: B,
    formLabelMode: te,
    labelTemplate: u,
    onLabelTemplateRendered: z
  }), De = be.visible && (be.text || be.labelTemplate && pe), {
    location: Ce,
    labelID: ft
  } = be, Ve = Ce !== "top" && ["dxTextArea", "dxRadioGroup", "dxCalendar", "dxHtmlEditor"].includes(a.editorType), Ee = lAe({
    editorType: a.editorType,
    editorValue: y,
    defaultEditorName: a.dataField,
    canAssignUndefinedValueToEditor: b,
    externalEditorOptions: a.editorOptions,
    editorInputId: $,
    editorValidationBoundary: I,
    editorStylingMode: A,
    formLabelMode: te,
    labelText: be.textWithoutColon,
    labelMark: be.markOptions.showRequiredMark ? " " + be.markOptions.requiredMark : ""
  }), Re = be.markOptions.showOptionalMark && !be.visible && Ee.labelMode !== "hidden" && !R(a.helpText), we = Re ? be.markOptions.optionalMark : a.helpText;
  return {
    $parent: e,
    rootElementCssClassList: i,
    formOrLayoutManager: r,
    createComponentCallback: n,
    labelOptions: be,
    labelNeedBaselineAlign: Ve,
    labelLocation: Ce,
    needRenderLabel: De,
    item: a,
    isSimpleItem: pe,
    isRequired: ie,
    template: o,
    helpID: _e,
    labelID: ft,
    name: c,
    helpText: we,
    formLabelLocation: p,
    requiredMessageTemplate: v,
    validationGroup: _,
    editorOptions: Ee
  };
}
function sAe(t) {
  var {
    showRequiredMark: e,
    requiredMark: i,
    showOptionalMark: r,
    optionalMark: n
  } = t;
  return !e && !r ? "" : " " + (e ? i : n);
}
function _8(t, e) {
  var {
    showRequiredMark: i,
    requiredMark: r,
    showOptionalMark: n,
    optionalMark: a
  } = t;
  return {
    showRequiredMark: i && e,
    requiredMark: r,
    showOptionalMark: n && !e,
    optionalMark: a
  };
}
function lAe(t) {
  var {
    editorType: e,
    defaultEditorName: i,
    editorValue: r,
    canAssignUndefinedValueToEditor: n,
    externalEditorOptions: a,
    editorInputId: o,
    editorValidationBoundary: u,
    editorStylingMode: c,
    formLabelMode: p,
    labelText: v,
    labelMark: _
  } = t, y = {};
  (r !== void 0 || n) && (y.value = r), nAe.indexOf(e) !== -1 && (y.value = y.value || []);
  var b = a == null ? void 0 : a.labelMode;
  R(b) || (b = p === "outside" ? "hidden" : p);
  var I = (a == null ? void 0 : a.stylingMode) || c, A = P(!0, y, a, {
    inputAttr: {
      id: o
    },
    validationBoundary: u,
    stylingMode: I,
    label: v,
    labelMode: b,
    labelMark: _
  });
  return a && (A.dataSource && (A.dataSource = a.dataSource), A.items && (A.items = a.items)), i && !A.name && (A.name = i), A;
}
function uAe(t) {
  var e;
  return t && t.length && N(t, function(i, r) {
    if (r.type === "required")
      return e = !0, !1;
  }), e;
}
function dAe(t) {
  var {
    item: e,
    id: i,
    isRequired: r,
    managerMarkOptions: n,
    showColonAfterLabel: a,
    labelLocation: o,
    labelTemplate: u,
    formLabelMode: c,
    onLabelTemplateRendered: p
  } = t, v = aAe.includes(e.editorType), _ = P({
    showColon: a,
    location: o,
    id: i,
    visible: c === "outside" || v && c !== "hidden",
    isRequired: r
  }, e ? e.label : {}, {
    markOptions: _8(n, r),
    labelTemplate: u,
    onLabelTemplateRendered: p
  });
  return ["dxRadioGroup", "dxCheckBox", "dxLookup", "dxSlider", "dxRangeSlider", "dxSwitch", "dxHtmlEditor", "dxDateRangeBox"].includes(e.editorType) && (_.labelID = "dx-label-".concat(new yr())), !_.text && e.dataField && (_.text = bp(e.dataField)), _.text && (_.textWithoutColon = _.text, _.text += _.showColon ? ":" : ""), _;
}
var cAe = "dx-field-item-required-mark", C8 = "dx-field-item-label-location-", hAe = "dx-field-item-optional-mark", fAe = "dx-field-item-label-text";
function pAe(t) {
  var {
    text: e,
    id: i,
    location: r,
    alignment: n,
    labelID: a = null,
    markOptions: o = {},
    labelTemplate: u,
    labelTemplateData: c,
    onLabelTemplateRendered: p
  } = t;
  if ((!R(e) || e.length <= 0) && !R(u))
    return null;
  var v = E("<label>").addClass(g8 + " " + C8 + r).attr("for", i).attr("id", a).css("textAlign", n), _ = E("<span>").addClass(v8), y = E("<span>").addClass(fAe).text(e);
  return u && (y = E("<div>").addClass("dx-field-item-custom-label-content"), c.text = e, u.render({
    container: ot(y),
    model: c,
    onRendered() {
      p == null || p();
    }
  })), v.append(_.append(y, vAe(o)));
}
function vAe(t) {
  var e = sAe(t);
  return e === "" ? null : E("<span>").addClass(t.showRequiredMark ? cAe : hAe).text(e);
}
function gAe(t, e, i) {
  var r = "".concat(e, " > .").concat(g8, ":not(.").concat(C8, "top) > .").concat(v8), n = t.find(r), a = n.length, o, u, c = 0;
  for (u = 0; u < a; u++)
    o = mAe(n[u]), o > c && (c = o);
  for (u = 0; u < a; u++)
    n[u].style.width = c + "px";
}
function mAe(t) {
  for (var e = 0, i = t.children.length, r = 0; r < i; r++) {
    var n = t.children[r];
    e += n.offsetWidth;
  }
  return e;
}
var _Ae = "dx-flex-layout", CAe = "dx-field-item-optional", yAe = "dx-field-item-required", y8 = "dx-field-item-content-wrapper", xAe = "dx-field-item-content-location-", SAe = "dx-field-item-label-align", EAe = "dx-field-item-help-text", bAe = "dx-label-v-align", wAe = "dx-label-h-align", TAe = "dx-toggle-controls-paddings", IAe = "dx-template-wrapper", PP = "dx-validation-target", DAe = "dx-invalid";
function AAe(t) {
  var {
    $parent: e,
    rootElementCssClassList: i,
    formOrLayoutManager: r,
    createComponentCallback: n,
    labelOptions: a,
    labelNeedBaselineAlign: o,
    labelLocation: u,
    needRenderLabel: c,
    formLabelLocation: p,
    item: v,
    editorOptions: _,
    isSimpleItem: y,
    isRequired: b,
    template: I,
    helpID: A,
    labelID: L,
    name: B,
    helpText: $,
    requiredMessageTemplate: K,
    validationGroup: te
  } = t, z = E("<div>").addClass(i.join(" ")).appendTo(e);
  z.addClass(b ? yAe : CAe), y && z.addClass(_Ae), y && o && z.addClass(SAe);
  var ie = E("<div>");
  ie.data("dx-form-item", v), ie.addClass(MP).addClass(xAe + {
    right: "left",
    left: "right",
    top: "bottom"
  }[p]);
  var pe = null;
  if (c && (a.labelTemplate && (a.labelTemplateData = QK(v, _, r)), pe = pAe(a)), pe) {
    var {
      editorType: _e
    } = v;
    z.append(pe), (u === "top" || u === "left") && z.append(ie), u === "right" && z.prepend(ie), u === "top" ? z.addClass(bAe) : z.addClass(wAe), (_e === "dxCheckBox" || _e === "dxSwitch") && k.on(pe, di, function() {
      k.trigger(ie.children(), di);
    });
    var be = ["dxCheckBox", "dxSwitch", "dxRadioGroup"].includes(_e), De = a.alignment, Ce = De === "left" || !De, ft = !I, Ve = u === "top";
    ft && be && Ve && Ce && ie.addClass(TAe);
  } else
    z.append(ie);
  var Ee;
  if (I)
    I.render({
      container: ot(ie),
      model: QK(v, _, r),
      onRendered() {
        var je = qK(ie), vt = OAe(je);
        XK(vt);
      }
    });
  else {
    var Re = E("<div>").appendTo(ie);
    try {
      Ee = n(Re, v.editorType, _), Ee.setAria("describedby", A), L && Ee.setAria("labelledby", L), Ee.setAria("required", b);
    } catch (je) {
      Yt.log("E1035", je.message);
    }
  }
  var we = qK(ie), We = we && we.data(PP);
  if (We) {
    var ne = v.label && v.label.text, Ae = ne ? null : B, j = ne ? v.label.text : Ae && bp(Ae), ge;
    if (y)
      if (v.validationRules)
        ge = v.validationRules;
      else {
        var Me = Mu(K, j || "");
        ge = v.isRequired ? [{
          type: "required",
          message: Me
        }] : null;
      }
    Array.isArray(ge) && ge.length && n(we, BI, {
      validationRules: ge,
      validationGroup: te,
      dataGetter: function() {
        return {
          formItem: v
        };
      }
    }), XK(We);
  }
  if ($ && y) {
    var ze = ie.parent();
    ze.append(E("<div>").addClass(y8).append(ie).append(E("<div>").addClass(EAe).attr("id", A).text($)));
  }
  return {
    $fieldEditorContainer: ie,
    $rootElement: z,
    widgetInstance: Ee
  };
}
function qK(t) {
  var e = t.children().first();
  return e.hasClass(IAe) ? e.children().first() : e;
}
function OAe(t) {
  var e, i;
  return (t == null ? void 0 : t.data(PP)) || (t == null || (e = t.parent) === null || e === void 0 || (i = e.call(t)) === null || i === void 0 ? void 0 : i.data(PP));
}
function XK(t) {
  if (t && fs()) {
    var e = ".".concat(y8), i = (r) => {
      var {
        element: n,
        component: a
      } = r, {
        isValid: o,
        validationMessageMode: u
      } = a.option();
      E(n).parents(e).toggleClass(DAe, o === !1 && (a._isFocused() || u === "always"));
    };
    t.on("optionChanged", (r) => {
      r.name === "isValid" && i(r);
    }), t.on("focusIn", i).on("focusOut", i).on("enterKey", i);
  }
}
function QK(t, e, i) {
  return {
    dataField: t.dataField,
    editorType: t.editorType,
    editorOptions: e,
    component: i,
    name: t.name
  };
}
var RAe = "dx-field-button-item";
function LAe(t) {
  var {
    item: e,
    $parent: i,
    rootElementCssClassList: r,
    validationGroup: n,
    createComponentCallback: a
  } = t, o = E("<div>").appendTo(i).addClass(r.join(" ")).addClass(RAe).css("textAlign", MAe(e.horizontalAlignment));
  i.css("justifyContent", kAe(e.verticalAlignment));
  var u = E("<div>").appendTo(o);
  return {
    $rootElement: o,
    buttonInstance: a(u, "dxButton", P({
      validationGroup: n
    }, e.buttonOptions))
  };
}
function MAe(t) {
  return R(t) ? t : "right";
}
function kAe(t) {
  switch (t) {
    case "center":
      return "center";
    case "bottom":
      return "flex-end";
    default:
      return "flex-start";
  }
}
var PAe = "dx-field-empty-item";
function ZK(t) {
  var {
    $parent: e,
    rootElementCssClassList: i
  } = t;
  return E("<div>").addClass(PAe).html("&nbsp;").addClass(i.join(" ")).appendTo(e);
}
var FAe = "dxTextBox", BAe = "dx-first-row", VAe = "dx-last-row", NAe = "dx-first-col", HAe = "dx-last-col", $Ae = xn.inherit({
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      layoutData: {},
      readOnly: !1,
      colCount: 1,
      colCountByScreen: void 0,
      labelLocation: "left",
      onFieldDataChanged: null,
      onEditorEnterKey: null,
      customizeItem: null,
      alignItemLabels: !0,
      minColWidth: 200,
      showRequiredMark: !0,
      screenByWidth: null,
      showOptionalMark: !1,
      requiredMark: "*",
      labelMode: "outside",
      optionalMark: X.format("dxForm-optionalMark"),
      requiredMessage: X.getFormatter("dxForm-requiredMessage")
    });
  },
  _setOptionsByReference: function() {
    this.callBase(), P(this._optionsByReference, {
      layoutData: !0,
      validationGroup: !0
    });
  },
  _init: function() {
    var t = this.option("layoutData");
    this.callBase(), this._itemWatchers = [], this._itemsRunTimeInfo = new o8(), this._updateReferencedOptions(t), this._initDataAndItems(t);
  },
  _dispose: function() {
    this.callBase(), this._cleanItemWatchers();
  },
  _initDataAndItems: function(t) {
    this._syncDataWithItems(), this._updateItems(t);
  },
  _syncDataWithItems: function() {
    var t = this.option("layoutData"), e = this.option("items");
    R(e) && e.forEach((i) => {
      if (i.dataField && this._getDataByField(i.dataField) === void 0) {
        var r;
        i.editorOptions && (r = i.editorOptions.value), (R(r) || i.dataField in t) && this._updateFieldValue(i.dataField, r);
      }
    });
  },
  _getDataByField: function(t) {
    return t ? this.option("layoutData." + t) : null;
  },
  _isCheckboxUndefinedStateEnabled: function(t) {
    var {
      allowIndeterminateState: e,
      editorType: i,
      dataField: r
    } = t;
    if (e === !0 && i === "dxCheckBox") {
      var n = ["layoutData", ...r.split(".")], a = n.pop(), o = this.option(n.join("."));
      return o && a in o;
    }
    return !1;
  },
  _updateFieldValue: function(t, e) {
    var i = this.option("layoutData"), r = e;
    !Ha.isWrapped(i[t]) && R(t) ? this.option("layoutData." + t, r) : Ha.isWritableWrapped(i[t]) && (r = Le(r) ? r() : r, i[t](r)), this._triggerOnFieldDataChanged({
      dataField: t,
      value: r
    });
  },
  _triggerOnFieldDataChanged: function(t) {
    this._createActionByOption("onFieldDataChanged")(t);
  },
  _updateItems: function(t) {
    var e = this, i = this.option("items"), r = R(i), n = e.option("customizeItem"), a = r ? i : this._generateItemsByData(t);
    if (R(a)) {
      var o = [];
      N(a, function(u, c) {
        e._isAcceptableItem(c) && (c = e._processItem(c), n && n(c), ct(c) && Ha.unwrap(c.visible) !== !1 && o.push(c));
      }), (!e._itemWatchers.length || !r) && e._updateItemWatchers(a), this._setItems(o), this._sortItems();
    }
  },
  _cleanItemWatchers: function() {
    this._itemWatchers.forEach(function(t) {
      t();
    }), this._itemWatchers = [];
  },
  _updateItemWatchers: function(t) {
    var e = this, i = e._getWatch();
    t.forEach(function(r) {
      ct(r) && R(r.visible) && Le(i) && e._itemWatchers.push(i(function() {
        return Ha.unwrap(r.visible);
      }, function() {
        e._updateItems(e.option("layoutData")), e.repaint();
      }, {
        skipImmediate: !0
      }));
    });
  },
  _generateItemsByData: function(t) {
    var e = [];
    return R(t) && N(t, function(i) {
      e.push({
        dataField: i
      });
    }), e;
  },
  _isAcceptableItem: function(t) {
    var e = t.dataField || t, i = this._getDataByField(e);
    return !(Le(i) && !Ha.isWrapped(i));
  },
  _processItem: function(t) {
    if (typeof t == "string" && (t = {
      dataField: t
    }), typeof t == "object" && !t.itemType && (t.itemType = kP), !R(t.editorType) && R(t.dataField)) {
      var e = this._getDataByField(t.dataField);
      t.editorType = R(e) ? this._getEditorTypeByDataType(cs(e)) : FAe;
    }
    if (t.editorType === "dxCheckBox") {
      var i;
      t.allowIndeterminateState = (i = t.allowIndeterminateState) !== null && i !== void 0 ? i : !0;
    }
    return t;
  },
  _getEditorTypeByDataType: function(t) {
    switch (t) {
      case "number":
        return "dxNumberBox";
      case "date":
        return "dxDateBox";
      case "boolean":
        return "dxCheckBox";
      default:
        return "dxTextBox";
    }
  },
  _sortItems: function() {
    Px(this._items, "visibleIndex"), this._sortIndexes();
  },
  _sortIndexes: function() {
    this._items.sort(function(t, e) {
      var i = t.visibleIndex, r = e.visibleIndex, n;
      return i > r ? n = 1 : i < r ? n = -1 : n = 0, n;
    });
  },
  _initMarkup: function() {
    this._itemsRunTimeInfo.clear(), this.$element().addClass(jDe), this.callBase(), this._renderResponsiveBox();
  },
  _renderResponsiveBox: function() {
    var t = [];
    if (this._items && this._items.length) {
      var e = this._getColCount(), i = E("<div>").appendTo(this.$element());
      this._prepareItemsWithMerging(e);
      var r = this._generateLayoutItems();
      this._responsiveBox = this._createComponent(i, f8, this._getResponsiveBoxConfig(r, e, t)), wt() || this._renderTemplates(t);
    }
  },
  _itemStateChangedHandler: function(t) {
    this._refresh();
  },
  _renderTemplates: function(t) {
    var e = this, i = 0;
    t.forEach((r) => {
      var n, {
        item: a
      } = r;
      a != null && (n = a.label) !== null && n !== void 0 && n.template && i++;
    }), N(t, function(r, n) {
      switch (n.itemType) {
        case "empty":
          ZK(n);
          break;
        case "button":
          e._renderButtonItem(n);
          break;
        default:
          e._renderFieldItem(n, i);
      }
    });
  },
  _getResponsiveBoxConfig: function(t, e, i) {
    var r = this, n = r.option("colCountByScreen"), a = n && n.xs;
    return {
      onItemStateChanged: this._itemStateChangedHandler.bind(this),
      onLayoutChanged: function() {
        var o = r.option("onLayoutChanged"), u = r.isSingleColumnMode();
        o && (r.$element().toggleClass(UK, u), o(u));
      },
      onContentReady: function(o) {
        wt() && r._renderTemplates(i), r.option("onLayoutChanged") && r.$element().toggleClass(UK, r.isSingleColumnMode(o.component));
      },
      itemTemplate: function(o, u, c) {
        if (o.location) {
          var p = E(c), v = o.location.row * e, _ = r._items[o.location.col + v];
          if (_) {
            var y = [_.cssClass];
            p.toggleClass(YDe, r.isSingleColumnMode(this)), o.location.row === 0 && y.push(BAe), o.location.col === 0 && y.push(NAe), _.itemType === kP && r.option("isRoot") && p.addClass(m8);
            var b = o.location.col === e - 1 || o.location.col + o.location.colspan === e, I = r._getRowsCount(), A = o.location.row === I - 1;
            b && y.push(HAe), A && y.push(VAe), _.itemType !== "empty" && (y.push(p8), y.push(r.option("cssItemClass")), R(_.col) && y.push("dx-col-" + _.col)), i.push({
              itemType: _.itemType,
              item: _,
              $parent: p,
              rootElementCssClassList: y
            });
          }
        }
      },
      cols: r._generateRatio(e),
      rows: r._generateRatio(r._getRowsCount(), !0),
      dataSource: t,
      screenByWidth: r.option("screenByWidth"),
      singleColumnScreen: a ? !1 : "xs"
    };
  },
  _getColCount: function() {
    var t = this.option("colCount"), e = this.option("colCountByScreen");
    if (e) {
      var i = this.option("form").getTargetScreenFactor();
      i || (i = wt() ? rj(this.option("screenByWidth")) : "lg"), t = e[i] || t;
    }
    if (t === "auto") {
      if (this._cashedColCount)
        return this._cashedColCount;
      this._cashedColCount = t = this._getMaxColCount();
    }
    return t < 1 ? 1 : t;
  },
  _getMaxColCount: function() {
    if (!wt())
      return 1;
    var t = this.option("minColWidth"), e = mt(this.$element()), i = this._items.length, r = Math.floor(e / t) || 1;
    return i < r ? i : r;
  },
  isCachedColCountObsolete: function() {
    return this._cashedColCount && this._getMaxColCount() !== this._cashedColCount;
  },
  _prepareItemsWithMerging: function(t) {
    var e = this._items.slice(0), i, r, n = [], a, o;
    for (o = 0; o < e.length; o++)
      if (i = e[o], n.push(i), (this.option("alignItemLabels") || i.alignItemLabels || i.colSpan) && (i.col = this._getColByIndex(n.length - 1, t)), i.colSpan > 1 && i.col + i.colSpan <= t) {
        for (r = [], a = 0; a < i.colSpan - 1; a++)
          r.push({
            merged: !0
          });
        n = n.concat(r);
      } else
        delete i.colSpan;
    this._setItems(n);
  },
  _getColByIndex: function(t, e) {
    return t % e;
  },
  _setItems: function(t) {
    this._items = t, this._cashedColCount = null;
  },
  _generateLayoutItems: function() {
    var t = this._items, e = this._getColCount(), i = [], r, n;
    for (n = 0; n < t.length; n++)
      if (r = t[n], !r.merged) {
        var a = {
          location: {
            row: parseInt(n / e),
            col: this._getColByIndex(n, e)
          }
        };
        R(r.disabled) && (a.disabled = r.disabled), R(r.visible) && (a.visible = r.visible), R(r.colSpan) && (a.location.colspan = r.colSpan), R(r.rowSpan) && (a.location.rowspan = r.rowSpan), i.push(a);
      }
    return i;
  },
  _renderEmptyItem: function(t) {
    ZK({
      $container: t
    });
  },
  _renderButtonItem: function(t) {
    var {
      item: e,
      $parent: i,
      rootElementCssClassList: r
    } = t, {
      $rootElement: n,
      buttonInstance: a
    } = LAe({
      item: e,
      $parent: i,
      rootElementCssClassList: r,
      validationGroup: this.option("validationGroup"),
      createComponentCallback: this._createComponent.bind(this)
    });
    this._itemsRunTimeInfo.add({
      item: e,
      widgetInstance: a,
      guid: e.guid,
      $itemContainer: n
    });
  },
  _renderFieldItem: function(t, e) {
    var i, r, {
      item: n,
      $parent: a,
      rootElementCssClassList: o
    } = t, u = this._getDataByField(n.dataField), c = !1;
    if (u === void 0) {
      var {
        allowIndeterminateState: p,
        editorType: v,
        dataField: _
      } = n;
      c = this._isCheckboxUndefinedStateEnabled({
        allowIndeterminateState: p,
        editorType: v,
        dataField: _
      });
    }
    var y = n.dataField || n.name, b = this._getFormOrThis(), {
      $fieldEditorContainer: I,
      widgetInstance: A,
      $rootElement: L
    } = AAe(oAe({
      $parent: a,
      rootElementCssClassList: o,
      item: n,
      name: y,
      editorValue: u,
      canAssignUndefinedValueToEditor: c,
      formOrLayoutManager: this._getFormOrThis(),
      createComponentCallback: this._createComponent.bind(this),
      formLabelLocation: this.option("labelLocation"),
      requiredMessageTemplate: this.option("requiredMessage"),
      validationGroup: this.option("validationGroup"),
      editorValidationBoundary: this.option("validationBoundary"),
      editorStylingMode: this.option("form") && this.option("form").option("stylingMode"),
      showColonAfterLabel: this.option("showColonAfterLabel"),
      managerLabelLocation: this.option("labelLocation"),
      template: n.template ? this._getTemplate(n.template) : null,
      labelTemplate: (i = n.label) !== null && i !== void 0 && i.template ? this._getTemplate(n.label.template) : null,
      itemId: this.option("form") && this.option("form").getItemID(y),
      managerMarkOptions: this._getMarkOptions(),
      labelMode: this.option("labelMode"),
      onLabelTemplateRendered: () => {
        this._incTemplateRenderedCallCount(), this._shouldAlignLabelsOnTemplateRendered(b, e) && b._alignLabels(this, this.isSingleColumnMode(b));
      }
    }));
    (r = this.option("onFieldItemRendered")) === null || r === void 0 || r(), A && n.dataField && this._bindDataField(A, n.dataField, n.editorType, I), this._itemsRunTimeInfo.add({
      item: n,
      widgetInstance: A,
      guid: n.guid,
      $itemContainer: L
    });
  },
  _incTemplateRenderedCallCount() {
    var t;
    this._labelTemplateRenderedCallCount = ((t = this._labelTemplateRenderedCallCount) !== null && t !== void 0 ? t : 0) + 1;
  },
  _shouldAlignLabelsOnTemplateRendered(t, e) {
    return t.option("templatesRenderAsynchronously") && this._labelTemplateRenderedCallCount === e;
  },
  _getMarkOptions: function() {
    return {
      showRequiredMark: this.option("showRequiredMark"),
      requiredMark: this.option("requiredMark"),
      showOptionalMark: this.option("showOptionalMark"),
      optionalMark: this.option("optionalMark")
    };
  },
  _getFormOrThis: function() {
    return this.option("form") || this;
  },
  _bindDataField: function(t, e, i, r) {
    var n = this._getFormOrThis();
    t.on("enterKey", function(a) {
      n._createActionByOption("onEditorEnterKey")(P(a, {
        dataField: e
      }));
    }), this._createWatcher(t, r, e), this.linkEditorToDataField(t, e, i);
  },
  _createWatcher: function(t, e, i) {
    var r = this, n = r._getWatch();
    if (Le(n)) {
      var a = n(function() {
        return r._getDataByField(i);
      }, function() {
        var o = r._getDataByField(i);
        if (t.NAME === "dxTagBox") {
          var u = t.option("value");
          if (o !== u && function(c, p) {
            if (!Array.isArray(c) || !Array.isArray(p) || c.length !== p.length)
              return !1;
            for (var v = 0; v < c.length; v++)
              if (c[v] !== p[v])
                return !1;
            return !0;
          }(o, u))
            return;
        }
        t.option("value", o);
      }, {
        deep: !0,
        skipImmediate: !0
      });
      k.on(e, fo, a);
    }
  },
  _getWatch: function() {
    if (!R(this._watch)) {
      var t = this.option("form");
      this._watch = t && t.option("integrationOptions.watchMethod");
    }
    return this._watch;
  },
  _createComponent: function(t, e, i) {
    var r = this.option("readOnly"), n = Object.hasOwn(i, "readOnly"), a = this.callBase(t, e, ae({}, i, {
      readOnly: n ? i.readOnly : r
    })), o = !1;
    return a.on("optionChanged", (u) => {
      u.name === "readOnly" && !o && (n = !0);
    }), this.on("optionChanged", function(u) {
      u.name === "readOnly" && !n && (o = !0, a.option(u.name, u.value), o = !1);
    }), a;
  },
  _generateRatio: function(t, e) {
    var i = [], r, n;
    for (n = 0; n < t; n++)
      r = {
        ratio: 1
      }, e && (r.baseSize = "auto"), i.push(r);
    return i;
  },
  _getRowsCount: function() {
    return Math.ceil(this._items.length / this._getColCount());
  },
  _updateReferencedOptions: function(t) {
    var e = this.option("layoutData");
    ct(e) && Object.getOwnPropertyNames(e).forEach((i) => delete this._optionsByReference["layoutData." + i]), ct(t) && Object.getOwnPropertyNames(t).forEach((i) => this._optionsByReference["layoutData." + i] = !0);
  },
  _clearWidget(t) {
    this._disableEditorValueChangedHandler = !0, t.clear(), this._disableEditorValueChangedHandler = !1, t.option("isValid", !0);
  },
  _optionChanged(t) {
    if (t.fullName.search("layoutData.") !== 0)
      switch (t.name) {
        case "showRequiredMark":
        case "showOptionalMark":
        case "requiredMark":
        case "optionalMark":
          this._cashedRequiredConfig = null, this._invalidate();
          break;
        case "layoutData":
          this._updateReferencedOptions(t.value), this.option("items") ? uo(t.value) || this._itemsRunTimeInfo.each((e, i) => {
            if (R(i.item)) {
              var r = i.item.dataField;
              if (r && R(i.widgetInstance)) {
                var n = Ii(r), a = n(t.value), {
                  allowIndeterminateState: o,
                  editorType: u
                } = i.item;
                a !== void 0 || this._isCheckboxUndefinedStateEnabled({
                  allowIndeterminateState: o,
                  editorType: u,
                  dataField: r
                }) ? i.widgetInstance.option("value", a) : this._clearWidget(i.widgetInstance);
              }
            }
          }) : (this._initDataAndItems(t.value), this._invalidate());
          break;
        case "items":
          this._cleanItemWatchers(), this._initDataAndItems(t.value), this._invalidate();
          break;
        case "alignItemLabels":
        case "labelLocation":
        case "labelMode":
        case "requiredMessage":
          this._invalidate();
          break;
        case "customizeItem":
          this._updateItems(this.option("layoutData")), this._invalidate();
          break;
        case "colCount":
        case "colCountByScreen":
          this._resetColCount();
          break;
        case "minColWidth":
          this.option("colCount") === "auto" && this._resetColCount();
          break;
        case "readOnly":
          break;
        case "width":
          this.callBase(t), this.option("colCount") === "auto" && this._resetColCount();
          break;
        case "onFieldDataChanged":
          break;
        default:
          this.callBase(t);
      }
  },
  _resetColCount: function() {
    this._cashedColCount = null, this._invalidate();
  },
  linkEditorToDataField(t, e) {
    this.on("optionChanged", (i) => {
      i.fullName === "layoutData.".concat(e) && t._setOptionWithoutOptionChange("value", i.value);
    }), t.on("valueChanged", (i) => {
      var r = ct(i.value) || Array.isArray(i.value);
      !this._disableEditorValueChangedHandler && !(r && i.value === i.previousValue) && this._updateFieldValue(e, i.value);
    });
  },
  _dimensionChanged: function() {
    this.option("colCount") === "auto" && this.isCachedColCountObsolete() && this._eventsStrategy.fireEvent("autoColCountChanged");
  },
  updateData: function(t, e) {
    var i = this;
    ct(t) ? N(t, function(r, n) {
      i._updateFieldValue(r, n);
    }) : typeof t == "string" && i._updateFieldValue(t, e);
  },
  getEditor: function(t) {
    return this._itemsRunTimeInfo.findWidgetInstanceByDataField(t) || this._itemsRunTimeInfo.findWidgetInstanceByName(t);
  },
  isSingleColumnMode: function(t) {
    var e = this._responsiveBox || t;
    if (e)
      return e.option("currentScreenFactor") === e.option("singleColumnScreen");
  },
  getItemsRunTimeInfo: function() {
    return this._itemsRunTimeInfo;
  }
});
ti("dxLayoutManager", $Ae);
var JB = "dx-validationsummary", zAe = JB + "-item", WAe = JB + "-item-data", x8 = Kp.inherit({
  _getDefaultOptions() {
    return P(this.callBase(), {
      focusStateEnabled: !1,
      noDataText: null
    });
  },
  _setOptionsByReference() {
    this.callBase(), P(this._optionsByReference, {
      validationGroup: !0
    });
  },
  _init() {
    this.callBase(), this._initGroupRegistration();
  },
  _initGroupRegistration() {
    var t = this.$element(), e = this.option("validationGroup") || Si.findGroup(t, this._modelByElement(t)), i = Si.addGroup(e);
    this._unsubscribeGroup(), this._groupWasInit = !0, this._validationGroup = e, this.groupSubscription = this._groupValidationHandler.bind(this), i.on("validated", this.groupSubscription);
  },
  _unsubscribeGroup() {
    var t = Si.getGroupConfig(this._validationGroup);
    t && t.off("validated", this.groupSubscription);
  },
  _getOrderedItems(t, e) {
    var i = [];
    return N(t, function(r, n) {
      var a = so(e, function(o) {
        if (o.validator === n)
          return !0;
      });
      a.length && (i = i.concat(a));
    }), i;
  },
  _groupValidationHandler(t) {
    var e = this._getOrderedItems(t.validators, Jr(t.brokenRules, function(i) {
      return {
        text: i.message,
        validator: i.validator,
        index: i.index
      };
    }));
    this.validators = t.validators, N(this.validators, (i, r) => {
      if (r._validationSummary !== this) {
        var n = this._itemValidationHandler.bind(this);
        r.on("validated", n), r.on("disposing", function() {
          r.off("validated", n), r._validationSummary = null, n = null;
        }), r._validationSummary = this;
      }
    }), this.option("items", e);
  },
  _itemValidationHandler(t) {
    for (var {
      isValid: e,
      validator: i,
      brokenRules: r
    } = t, n = this.option("items"), a = !1, o = 0, u = function() {
      var c = n[o];
      if (c.validator === i) {
        var p = so(r || [], function(v) {
          return v.index === c.index;
        })[0];
        if (e || !p)
          return n.splice(o, 1), a = !0, 1;
        p.message !== c.text && (c.text = p.message, a = !0);
      }
      o++;
    }; o < n.length; )
      u();
    N(r, function(c, p) {
      var v = so(n, function(_) {
        return _.validator === i && _.index === p.index;
      })[0];
      v || (n.push({
        text: p.message,
        validator: i,
        index: p.index
      }), a = !0);
    }), a && (n = this._getOrderedItems(this.validators, n), this.option("items", n));
  },
  _initMarkup() {
    this.$element().addClass(JB), this.callBase();
  },
  _optionChanged(t) {
    switch (t.name) {
      case "validationGroup":
        this._initGroupRegistration();
        break;
      default:
        this.callBase(t);
    }
  },
  _itemClass: () => zAe,
  _itemDataKey: () => WAe,
  _postprocessRenderItem(t) {
    k.on(t.itemElement, "click", function() {
      t.itemData.validator && t.itemData.validator.focus && t.itemData.validator.focus();
    });
  },
  _dispose() {
    this.callBase(), this._unsubscribeGroup();
  },
  refreshValidationGroup() {
    this._initGroupRegistration();
  }
});
ti("dxValidationSummary", x8);
var JK = "dx-validationgroup", UAe = "dx-validator", GAe = "dx-validationsummary";
class KAe extends Nu {
  _getDefaultOptions() {
    return super._getDefaultOptions();
  }
  _init() {
    super._init(), Si.addGroup(this);
  }
  _initMarkup() {
    var e = this.$element();
    e.addClass(JK), e.find(".".concat(UAe)).each(function(i, r) {
      BI.getInstance(E(r))._initGroupRegistration();
    }), e.find(".".concat(GAe)).each(function(i, r) {
      x8.getInstance(E(r)).refreshValidationGroup();
    }), super._initMarkup();
  }
  validate() {
    return Si.validateGroup(this);
  }
  reset() {
    return Si.resetGroup(this);
  }
  _dispose() {
    Si.removeGroup(this), this.$element().removeClass(JK), super._dispose();
  }
  _useTemplates() {
    return !1;
  }
}
ti("dxValidationGroup", KAe);
var e2 = "dx-state-focused", jAe = ["items", "isRequired", "validationRules", "visible"], eV = xn.inherit({
  _init: function() {
    this.callBase(), this._dirtyFields = /* @__PURE__ */ new Set(), this._cachedColCountOptions = [], this._itemsRunTimeInfo = new o8(), this._groupsColCount = [], this._attachSyncSubscriptions();
  },
  _getDefaultOptions: function() {
    return P(this.callBase(), {
      formID: "dx-" + new yr(),
      formData: {},
      colCount: 1,
      screenByWidth: uF,
      colCountByScreen: void 0,
      labelLocation: "left",
      readOnly: !1,
      onFieldDataChanged: null,
      customizeItem: null,
      onEditorEnterKey: null,
      minColWidth: 200,
      alignItemLabels: !0,
      alignItemLabelsInAllGroups: !0,
      alignRootItemLabels: !0,
      showColonAfterLabel: !0,
      showRequiredMark: !0,
      showOptionalMark: !1,
      requiredMark: "*",
      optionalMark: X.format("dxForm-optionalMark"),
      requiredMessage: X.getFormatter("dxForm-requiredMessage"),
      showValidationSummary: !1,
      items: void 0,
      scrollingEnabled: !1,
      validationGroup: void 0,
      stylingMode: Oi().editorStylingMode,
      labelMode: "outside",
      isDirty: !1
    });
  },
  _defaultOptionsRules: function() {
    return this.callBase().concat([{
      device: function() {
        return fs();
      },
      options: {
        labelLocation: "top"
      }
    }, {
      device: function() {
        return _a();
      },
      options: {
        showColonAfterLabel: !1
      }
    }]);
  },
  _setOptionsByReference: function() {
    this.callBase(), P(this._optionsByReference, {
      formData: !0,
      validationGroup: !0
    });
  },
  _getGroupColCount: function(t) {
    return parseInt(t.attr(jK));
  },
  _applyLabelsWidthByCol: function(t, e) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = arguments.length > 3 ? arguments[3] : void 0, n = i.inOneColumn ? p8 : WK + e, a = i.excludeTabbed ? ":not(.".concat(GK, ")") : "";
    gAe(t, ".".concat(n).concat(a), r);
  },
  _applyLabelsWidth: function(t, e, i, r, n) {
    r = i ? 1 : r || this._getGroupColCount(t);
    var a = {
      excludeTabbed: e,
      inOneColumn: i
    }, o;
    for (o = 0; o < r; o++)
      this._applyLabelsWidthByCol(t, o, a, n);
  },
  _getGroupElementsInColumn: function(t, e, i) {
    var r = R(i) ? "." + KK + i : "", n = "." + WK + e + " > ." + MP + " > ." + VM + r;
    return t.find(n);
  },
  _applyLabelsWidthWithGroups: function(t, e, i, r) {
    if (this.option("alignRootItemLabels") === !0)
      for (var n = t.find(".".concat(m8)), a = 0; a < e; a++)
        this._applyLabelsWidthByCol(n, a, i, r);
    var o = this.option("alignItemLabelsInAllGroups");
    if (o)
      this._applyLabelsWidthWithNestedGroups(t, e, i, r);
    else {
      var u = this.$element().find("." + VM), c;
      for (c = 0; c < u.length; c++)
        this._applyLabelsWidth(u.eq(c), i, void 0, void 0, r);
    }
  },
  _applyLabelsWidthWithNestedGroups: function(t, e, i, r) {
    var n = {
      excludeTabbed: i
    }, a, o, u, c;
    for (a = 0; a < e; a++)
      for (c = this._getGroupElementsInColumn(t, a), this._applyLabelsWidthByCol(c, 0, n, r), o = 0; o < this._groupsColCount.length; o++) {
        c = this._getGroupElementsInColumn(t, a, this._groupsColCount[o]);
        var p = this._getGroupColCount(c);
        for (u = 1; u < p; u++)
          this._applyLabelsWidthByCol(c, u, n, r);
      }
  },
  _labelLocation: function() {
    return this.option("labelLocation");
  },
  _alignLabelsInColumn: function(t) {
    var {
      layoutManager: e,
      inOneColumn: i,
      $container: r,
      excludeTabbed: n,
      items: a
    } = t;
    if (!(!wt() || this._labelLocation() === "top")) {
      var o = _8(e._getMarkOptions());
      i ? this._applyLabelsWidth(r, n, !0, void 0, o) : this._checkGrouping(a) ? this._applyLabelsWidthWithGroups(r, e._getColCount(), n, o) : this._applyLabelsWidth(r, n, !1, e._getColCount(), o);
    }
  },
  _prepareFormData: function() {
    R(this.option("formData")) || this.option("formData", {});
  },
  _setStylingModeClass: function() {
    this.option("stylingMode") === "underlined" && this.$element().addClass(eAe);
  },
  _initMarkup: function() {
    Si.addGroup(this._getValidationGroup()), this._clearCachedInstances(), this._prepareFormData(), this.$element().addClass(GDe), this._setStylingModeClass(), this.callBase(), this.setAria("role", "form", this.$element()), this.option("scrollingEnabled") && this._renderScrollable(), this._renderLayout(), this._renderValidationSummary(), this._lastMarkupScreenFactor = this._targetScreenFactor || this._getCurrentScreenFactor(), this._attachResizeObserverSubscription();
  },
  _attachResizeObserverSubscription: function() {
    if (wt()) {
      var t = this.$element().get(0);
      Ep.unobserve(t), Ep.observe(t, () => {
        this._resizeHandler();
      });
    }
  },
  _resizeHandler: function() {
    this._cachedLayoutManagers.length && N(this._cachedLayoutManagers, (t, e) => {
      var i;
      (i = e.option("onLayoutChanged")) === null || i === void 0 || i(e.isSingleColumnMode());
    });
  },
  _getCurrentScreenFactor: function() {
    return wt() ? rj(this.option("screenByWidth")) : "lg";
  },
  _clearCachedInstances: function() {
    this._itemsRunTimeInfo.clear(), this._cachedLayoutManagers = [];
  },
  _alignLabels: function(t, e) {
    this._alignLabelsInColumn({
      $container: this.$element(),
      layoutManager: t,
      excludeTabbed: !0,
      items: this.option("items"),
      inOneColumn: e
    }), Iu(this.$element().find(".".concat(J5)));
  },
  _clean: function() {
    this._clearValidationSummary(), this.callBase(), this._groupsColCount = [], this._cachedColCountOptions = [], this._lastMarkupScreenFactor = void 0, Ep.unobserve(this.$element().get(0));
  },
  _renderScrollable: function() {
    var t = this.option("useNativeScrolling");
    this._scrollable = new ds(this.$element(), {
      useNative: !!t,
      useSimulatedScrollbar: !t,
      useKeyboard: !1,
      direction: "both",
      bounceEnabled: !1
    });
  },
  _getContent: function() {
    return this.option("scrollingEnabled") ? E(this._scrollable.content()) : this.$element();
  },
  _clearValidationSummary: function() {
    var t;
    (t = this._$validationSummary) === null || t === void 0 || t.remove(), this._$validationSummary = void 0, this._validationSummary = void 0;
  },
  _renderValidationSummary: function() {
    this._clearValidationSummary(), this.option("showValidationSummary") && (this._$validationSummary = E("<div>").addClass(JDe).appendTo(this._getContent()), this._validationSummary = this._$validationSummary.dxValidationSummary({
      validationGroup: this._getValidationGroup()
    }).dxValidationSummary("instance"));
  },
  _prepareItems(t, e, i, r) {
    if (t) {
      for (var n = [], a = 0; a < t.length; a++) {
        var o = t[a], u = u8(i, RP(a, r)), c = {
          item: o,
          itemIndex: a,
          path: u
        }, p = this._itemsRunTimeInfo.add(c);
        if (ht(o) && (o = {
          dataField: o
        }), ct(o)) {
          var v = ae({}, o);
          c.preparedItem = v, v.guid = p, this._tryPrepareGroupItem(v), this._tryPrepareTabbedItem(v, u), this._tryPrepareItemTemplate(v), e && (v.cssItemClass = GK), v.items && (v.items = this._prepareItems(v.items, e, u)), n.push(v);
        } else
          n.push(o);
      }
      return n;
    }
  },
  _tryPrepareGroupItem: function(t) {
    t.itemType === "group" && (t.alignItemLabels = cr(t.alignItemLabels, !0), t._prepareGroupItemTemplate = (e) => {
      t.template && (t.groupContentTemplate = this._getTemplate(e)), t.template = this._itemGroupTemplate.bind(this, t);
    }, t._prepareGroupItemTemplate(t.template));
  },
  _tryPrepareTabbedItem: function(t, e) {
    t.itemType === "tabbed" && (t.template = this._itemTabbedTemplate.bind(this, t), t.tabs = this._prepareItems(t.tabs, !0, e, !0));
  },
  _tryPrepareItemTemplate: function(t) {
    t.template && (t.template = this._getTemplate(t.template));
  },
  _checkGrouping: function(t) {
    if (t)
      for (var e = 0; e < t.length; e++) {
        var i = t[e];
        if (i.itemType === "group")
          return !0;
      }
  },
  _renderLayout: function() {
    var t = this, e = t.option("items"), i = t._getContent();
    e = t._prepareItems(e), t._rootLayoutManager = t._renderLayoutManager(i, this._createLayoutManagerOptions(e, {
      isRoot: !0,
      colCount: t.option("colCount"),
      alignItemLabels: t.option("alignItemLabels"),
      screenByWidth: this.option("screenByWidth"),
      colCountByScreen: this.option("colCountByScreen"),
      onLayoutChanged: function(r) {
        t._alignLabels.bind(t)(t._rootLayoutManager, r);
      },
      onContentReady: function(r) {
        t._alignLabels(r.component, r.component.isSingleColumnMode());
      }
    }));
  },
  _tryGetItemsForTemplate: function(t) {
    return t.items || [];
  },
  _itemTabbedTemplate: function(t, e, i) {
    var r, n = E("<div>").appendTo(i), a = P({}, t.tabPanelOptions, {
      dataSource: t.tabs,
      onItemRendered: (c) => {
        var p, v;
        (p = t.tabPanelOptions) === null || p === void 0 || (v = p.onItemRendered) === null || v === void 0 || v.call(p, c), LF(c.itemElement);
      },
      itemTemplate: (c, p, v) => {
        var _ = E(v), y = cr(c.alignItemLabels, !0), b = this._renderLayoutManager(_, this._createLayoutManagerOptions(this._tryGetItemsForTemplate(c), {
          colCount: c.colCount,
          alignItemLabels: y,
          screenByWidth: this.option("screenByWidth"),
          colCountByScreen: c.colCountByScreen,
          cssItemClass: c.cssItemClass,
          onLayoutChanged: (I) => {
            this._alignLabelsInColumn({
              $container: _,
              layoutManager: b,
              items: c.items,
              inOneColumn: I
            });
          }
        }));
        this._itemsRunTimeInfo && this._itemsRunTimeInfo.extendRunTimeItemInfoByKey(c.guid, {
          layoutManager: b
        }), y && this._alignLabelsInColumn({
          $container: _,
          layoutManager: b,
          items: c.items,
          inOneColumn: b.isSingleColumnMode()
        });
      }
    }), o = (c, p) => {
      Array.isArray(c) && c.forEach((v) => this._itemsRunTimeInfo.extendRunTimeItemInfoByKey(v.guid, {
        widgetInstance: p
      }));
    }, u = this._createComponent(n, ZB, a);
    E(i).parent().addClass(QDe), u.on("optionChanged", (c) => {
      c.fullName === "dataSource" && o(c.value, c.component);
    }), o([{
      guid: t.guid
    }, ...(r = t.tabs) !== null && r !== void 0 ? r : []], u);
  },
  _itemGroupTemplate: function(t, e, i) {
    var r = e.editorOptions.inputAttr.id, n = E("<div>").toggleClass(ZDe, R(t.caption) && t.caption.length).addClass(VM).appendTo(i), a = {
      role: "group",
      labelledby: r
    };
    this.setAria(a, n), E(i).parent().addClass(XDe), t.caption && E("<span>").addClass(KDe).text(t.caption).attr("id", r).appendTo(n);
    var o = E("<div>").addClass(qDe).appendTo(n);
    if (t.groupContentTemplate)
      t._renderGroupContentTemplate = () => {
        o.empty();
        var p = {
          formData: this.option("formData"),
          component: this
        };
        t.groupContentTemplate.render({
          model: p,
          container: ot(o)
        });
      }, t._renderGroupContentTemplate();
    else {
      var u = this._renderLayoutManager(o, this._createLayoutManagerOptions(this._tryGetItemsForTemplate(t), {
        colCount: t.colCount,
        colCountByScreen: t.colCountByScreen,
        alignItemLabels: t.alignItemLabels,
        cssItemClass: t.cssItemClass
      }));
      this._itemsRunTimeInfo && this._itemsRunTimeInfo.extendRunTimeItemInfoByKey(t.guid, {
        layoutManager: u
      });
      var c = u._getColCount();
      this._groupsColCount.includes(c) || this._groupsColCount.push(c), n.addClass(KK + c), n.attr(jK, c);
    }
  },
  _createLayoutManagerOptions: function(t, e) {
    return PDe({
      form: this,
      formOptions: this.option(),
      $formElement: this.$element(),
      items: t,
      validationGroup: this._getValidationGroup(),
      extendedLayoutManagerOptions: e,
      onFieldDataChanged: (i) => {
        this._isDataUpdating || this._triggerOnFieldDataChanged(i);
      },
      onContentReady: (i) => {
        this._itemsRunTimeInfo.addItemsOrExtendFrom(i.component._itemsRunTimeInfo), e.onContentReady && e.onContentReady(i);
      },
      onDisposing: (i) => {
        var {
          component: r
        } = i, n = r.getItemsRunTimeInfo();
        this._itemsRunTimeInfo.removeItemsByItems(n);
      },
      onFieldItemRendered: () => {
        var i;
        (i = this._validationSummary) === null || i === void 0 || i.refreshValidationGroup();
      }
    });
  },
  _renderLayoutManager: function(t, e) {
    var i = {
      lg: e.colCount,
      md: e.colCount,
      sm: e.colCount,
      xs: 1
    };
    this._cachedColCountOptions.push({
      colCountByScreen: P(i, e.colCountByScreen)
    });
    var r = E("<div>");
    r.appendTo(t);
    var n = this._createComponent(r, "dxLayoutManager", e);
    return n.on("autoColCountChanged", () => {
      this._clearAutoColCountChangedTimeout(), this.autoColCountChangedTimeoutId = setTimeout(() => !this._disposed && this._refresh(), 0);
    }), this._cachedLayoutManagers.push(n), n;
  },
  _getValidationGroup: function() {
    return this.option("validationGroup") || this;
  },
  _createComponent: function(t, e, i) {
    return i = i || {}, this._extendConfig(i, {
      readOnly: this.option("readOnly")
    }), this.callBase(t, e, i);
  },
  _attachSyncSubscriptions: function() {
    var t = this;
    t.on("optionChanged", function(e) {
      var i = e.fullName;
      i === "formData" && (R(e.value) || t._options.silent("formData", e.value = {}), t._triggerOnFieldDataChangedByDataSet(e.value)), t._cachedLayoutManagers.length && N(t._cachedLayoutManagers, function(r, n) {
        i === "formData" && (t._isDataUpdating = !0, n.option("layoutData", e.value), t._isDataUpdating = !1), (e.name === "readOnly" || e.name === "disabled") && n.option(i, e.value);
      });
    });
  },
  _optionChanged: function(t) {
    var e = t.fullName.split(".");
    e.length > 1 && e[0].search("items") !== -1 && this._itemsOptionChangedHandler(t) || e.length > 1 && e[0].search("formData") !== -1 && this._formDataOptionChangedHandler(t) || this._defaultOptionChangedHandler(t);
  },
  _defaultOptionChangedHandler: function(t) {
    switch (t.name) {
      case "formData":
        this.option("items") ? uo(t.value) && this._clear() : this._invalidate();
        break;
      case "onFieldDataChanged":
        break;
      case "items":
      case "colCount":
      case "onEditorEnterKey":
      case "labelLocation":
      case "labelMode":
      case "alignItemLabels":
      case "showColonAfterLabel":
      case "customizeItem":
      case "alignItemLabelsInAllGroups":
      case "showRequiredMark":
      case "showOptionalMark":
      case "requiredMark":
      case "optionalMark":
      case "requiredMessage":
      case "scrollingEnabled":
      case "formID":
      case "colCountByScreen":
      case "screenByWidth":
      case "stylingMode":
        this._invalidate();
        break;
      case "showValidationSummary":
        this._renderValidationSummary();
        break;
      case "minColWidth":
        this.option("colCount") === "auto" && this._invalidate();
        break;
      case "alignRootItemLabels":
      case "readOnly":
      case "isDirty":
        break;
      case "width":
        this.callBase(t), this._rootLayoutManager.option(t.name, t.value), this._alignLabels(this._rootLayoutManager, this._rootLayoutManager.isSingleColumnMode());
        break;
      case "validationGroup":
        Si.removeGroup(t.previousValue || this), this._invalidate();
        break;
      default:
        this.callBase(t);
    }
  },
  _itemsOptionChangedHandler: function(t) {
    var e = t.fullName.split("."), i = t.value, r = this._getItemPath(e), n = this.option(r), a = t.fullName.replace(r + ".", ""), o = a.split(".")[0].replace(/\[\d+]/, ""), u = this._tryCreateItemOptionAction(o, n, n[o], t.previousValue, r), c = this._tryExecuteItemOptionAction(u) || this._tryChangeLayoutManagerItemOption(t.fullName, i);
    if (!c && n) {
      this._changeItemOption(n, a, i);
      var p = this._generateItemsFromData(this.option("items"));
      this.option("items", p), c = !0;
    }
    return c;
  },
  _formDataOptionChangedHandler: function(t) {
    var e = t.fullName.split("."), i = t.value, r = e.slice(1).join("."), n = this.getEditor(r);
    return n ? n.option("value", i) : this._triggerOnFieldDataChanged({
      dataField: r,
      value: i
    }), !0;
  },
  _tryCreateItemOptionAction: function(t, e, i, r, n) {
    return t === "tabs" && (this._itemsRunTimeInfo.removeItemsByPathStartWith("".concat(n, ".tabs")), i = this._prepareItems(i, !0, n, !0)), zDe(t, {
      item: e,
      value: i,
      previousValue: r,
      itemsRunTimeInfo: this._itemsRunTimeInfo
    });
  },
  _tryExecuteItemOptionAction: function(t) {
    return t && t.tryExecute();
  },
  _updateValidationGroupAndSummaryIfNeeded: function(t) {
    var e = NK(t);
    if (jAe.indexOf(e) > -1 && (Si.addGroup(this._getValidationGroup()), this.option("showValidationSummary"))) {
      var i;
      (i = this._validationSummary) === null || i === void 0 || i.refreshValidationGroup();
    }
  },
  _setLayoutManagerItemOption(t, e, i, r) {
    if (this._updateLockCount > 0) {
      !t._updateLockCount && t.beginUpdate();
      var n = this._itemsRunTimeInfo.findKeyByPath(r);
      this.postponedOperations.add(n, () => (!t._disposed && t.endUpdate(), new q().resolve()));
    }
    var a = (o) => {
      if (o.component.off("contentReady", a), d8(r)) {
        var u = kDe(r), c = this._itemsRunTimeInfo.findGroupOrTabLayoutManagerByPath(u);
        c && this._alignLabelsInColumn({
          items: c.option("items"),
          layoutManager: c,
          $container: c.$element(),
          inOneColumn: c.isSingleColumnMode()
        });
      } else
        this._alignLabels(this._rootLayoutManager, this._rootLayoutManager.isSingleColumnMode());
    };
    t.on("contentReady", a), t.option(e, i), this._updateValidationGroupAndSummaryIfNeeded(e);
  },
  _tryChangeLayoutManagerItemOption(t, e) {
    var i = t.split("."), r = NK(t);
    if (r === "items" && i.length > 1) {
      var n = this._getItemPath(i), a = this._itemsRunTimeInfo.findGroupOrTabLayoutManagerByPath(n);
      if (a) {
        this._itemsRunTimeInfo.removeItemsByItems(a.getItemsRunTimeInfo());
        var o = this._prepareItems(e, !1, n);
        return this._setLayoutManagerItemOption(a, r, o, n), !0;
      }
    } else if (i.length > 2) {
      var u = i.length - 2, c = this._getItemPath(i.slice(0, u)), p = this._itemsRunTimeInfo.findGroupOrTabLayoutManagerByPath(c);
      if (p) {
        var v = ix(i[u], r);
        if (r === "editorType" && p.option(v) !== e)
          return !1;
        if (r === "visible") {
          var _ = this.option(ix(c, "items"));
          if (_ && _.length) {
            var y = p.option("items");
            _.forEach((b, I) => {
              var A = y[I];
              A.visibleIndex = b.visibleIndex;
            });
          }
        }
        return this._setLayoutManagerItemOption(p, v, e, c), !0;
      }
    }
    return !1;
  },
  _tryChangeLayoutManagerItemOptions(t, e) {
    var i;
    return this.beginUpdate(), N(e, (r, n) => {
      if (i = this._tryChangeLayoutManagerItemOption(ix(t, r), n), !i)
        return !1;
    }), this.endUpdate(), i;
  },
  _getItemPath: function(t) {
    var e = t[0], i;
    for (i = 1; i < t.length && t[i].search(/items\[\d+]|tabs\[\d+]/) !== -1; i++)
      e += "." + t[i];
    return e;
  },
  _triggerOnFieldDataChanged: function(t) {
    this._updateIsDirty(t.dataField), this._createActionByOption("onFieldDataChanged")(t);
  },
  _triggerOnFieldDataChangedByDataSet(t) {
    t && ct(t) && Object.keys(t).forEach((e) => {
      this._triggerOnFieldDataChanged({
        dataField: e,
        value: t[e]
      });
    });
  },
  _updateFieldValue: function(t, e) {
    if (R(this.option("formData"))) {
      var i = this.getEditor(t);
      if (this.option("formData." + t, e), i) {
        var r = i.option("value");
        r !== e && i.option("value", e);
      }
    }
  },
  _generateItemsFromData: function(t) {
    var e = this.option("formData"), i = [];
    return !t && R(e) && N(e, function(r) {
      i.push({
        dataField: r
      });
    }), t && N(t, function(r, n) {
      ct(n) ? i.push(n) : i.push({
        dataField: n
      });
    }), i;
  },
  _getItemByField: function(t, e) {
    var i = this, r = ct(t) ? t : i._getFieldParts(t), n = r.fieldName, a = r.fieldPath, o;
    return e.length && N(e, function(u, c) {
      var p = c.itemType;
      if (a.length) {
        var v = a.slice();
        c = i._getItemByFieldPath(v, n, c);
      } else if (p === "group" && !(c.caption || c.name) || p === "tabbed" && !c.name) {
        var _ = i._getSubItemField(p);
        c.items = i._generateItemsFromData(c.items), c = i._getItemByField({
          fieldName: n,
          fieldPath: a
        }, c[_]);
      }
      if (MDe(c, n))
        return o = c, !1;
    }), o;
  },
  _getFieldParts: function(t) {
    for (var e = t, i = e.indexOf("."), r = []; i !== -1; )
      r.push(e.substr(0, i)), e = e.substr(i + 1), i = e.indexOf(".");
    return {
      fieldName: e,
      fieldPath: r.reverse()
    };
  },
  _getItemByFieldPath: function(t, e, i) {
    var r = i.itemType, n = this._getSubItemField(r), a = r === "group" || r === "tabbed" || i.title, o;
    do
      if (a) {
        var u = i.name || i.caption || i.title, c = R(u), p = LP(u), v = void 0;
        if (i[n] = this._generateItemsFromData(i[n]), c && (v = t.pop()), !t.length && (o = this._getItemByField(e, i[n]), o))
          break;
        (!c || c && p === v) && t.length && (o = this._searchItemInEverySubItem(t, e, i[n]));
      } else
        break;
    while (t.length && !R(o));
    return o;
  },
  _getSubItemField: function(t) {
    return t === "tabbed" ? "tabs" : "items";
  },
  _searchItemInEverySubItem: function(t, e, i) {
    var r = this, n;
    return N(i, function(a, o) {
      if (n = r._getItemByFieldPath(t.slice(), e, o), n)
        return !1;
    }), n || (n = !1), n;
  },
  _changeItemOption: function(t, e, i) {
    ct(t) && (t[e] = i);
  },
  _dimensionChanged: function() {
    var t = this._getCurrentScreenFactor();
    this._lastMarkupScreenFactor !== t && (this._isColCountChanged(this._lastMarkupScreenFactor, t) && (this._targetScreenFactor = t, this._refresh(), this._targetScreenFactor = void 0), this._lastMarkupScreenFactor = t);
  },
  _isColCountChanged: function(t, e) {
    var i = !1;
    return N(this._cachedColCountOptions, function(r, n) {
      if (n.colCountByScreen[t] !== n.colCountByScreen[e])
        return i = !0, !1;
    }), i;
  },
  _refresh: function() {
    var t = ".".concat(e2, " > :not(.dx-dropdowneditor-input-wrapper) input,") + " .".concat(e2, " textarea");
    k.trigger(this.$element().find(t), "change"), this.callBase();
  },
  _updateIsDirty: function(t) {
    var e = this.getEditor(t);
    e && (e.option("isDirty") ? this._dirtyFields.add(t) : this._dirtyFields.delete(t), this.option("isDirty", !!this._dirtyFields.size));
  },
  updateRunTimeInfoForEachEditor: function(t) {
    this._itemsRunTimeInfo.each(function(e, i) {
      var r = i.widgetInstance;
      R(r) && Fl.isEditor(r) && t(r);
    });
  },
  _clear: function() {
    this.updateRunTimeInfoForEachEditor((t) => {
      t.clear(), t.option("isValid", !0);
    }), Si.resetGroup(this._getValidationGroup());
  },
  _updateData: function(t, e, i) {
    var r = this, n = i ? e : t;
    ct(n) ? N(n, function(a, o) {
      r._updateData(i ? t + "." + a : a, o, ct(o));
    }) : ht(t) && r._updateFieldValue(t, e);
  },
  registerKeyHandler: function(t, e) {
    this.callBase(t, e), this._itemsRunTimeInfo.each(function(i, r) {
      R(r.widgetInstance) && r.widgetInstance.registerKeyHandler(t, e);
    });
  },
  _focusTarget: function() {
    return this.$element().find("." + MP + " [tabindex]").first();
  },
  _visibilityChanged: function() {
    this._alignLabels(this._rootLayoutManager, this._rootLayoutManager.isSingleColumnMode());
  },
  _clearAutoColCountChangedTimeout: function() {
    this.autoColCountChangedTimeoutId && (clearTimeout(this.autoColCountChangedTimeoutId), this.autoColCountChangedTimeoutId = void 0);
  },
  _dispose: function() {
    this._clearAutoColCountChangedTimeout(), Si.removeGroup(this._getValidationGroup()), this.callBase();
  },
  clear: function() {
    this._clear();
  },
  resetValues: function() {
    this._clear();
  },
  reset: function(t) {
    this.updateRunTimeInfoForEachEditor((e) => {
      var i = e.option("name");
      t && i in t ? e.reset(t[i]) : e.reset();
    }), this._renderValidationSummary();
  },
  updateData: function(t, e) {
    this._updateData(t, e);
  },
  getEditor: function(t) {
    return this._itemsRunTimeInfo.findWidgetInstanceByDataField(t) || this._itemsRunTimeInfo.findWidgetInstanceByName(t);
  },
  getButton: function(t) {
    return this._itemsRunTimeInfo.findWidgetInstanceByName(t);
  },
  updateDimensions: function() {
    var t = this, e = new q();
    return t._scrollable ? t._scrollable.update().done(function() {
      e.resolveWith(t);
    }) : e.resolveWith(t), e.promise();
  },
  itemOption: function(t, e, i) {
    var r = this._generateItemsFromData(this.option("items")), n = this._getItemByField(t, r), a = c8(r, n);
    if (n)
      switch (arguments.length) {
        case 1:
          return n;
        case 3:
          var o = this._tryCreateItemOptionAction(e, n, i, n[e], a);
          this._changeItemOption(n, e, i);
          var u = ix(a, e);
          !this._tryExecuteItemOptionAction(o) && !this._tryChangeLayoutManagerItemOption(u, i) && this.option("items", r);
          break;
        default:
          if (ct(e) && !this._tryChangeLayoutManagerItemOptions(a, e)) {
            var c;
            N(e, (p, v) => {
              var _ = this._tryCreateItemOptionAction(p, n, v, n[p], a);
              this._changeItemOption(n, p, v), !c && !this._tryExecuteItemOptionAction(_) && (c = !0);
            }), c && this.option("items", r);
          }
      }
  },
  validate: function() {
    return Si.validateGroup(this._getValidationGroup());
  },
  getItemID: function(t) {
    return "dx_" + this.option("formID") + "_" + (t || new yr());
  },
  getTargetScreenFactor: function() {
    return this._targetScreenFactor;
  }
});
ti("dxForm", eV);
var YAe = (t) => class extends t {
  init() {
    this._editForm = null, this._updateEditFormDeferred = null, super.init();
  }
  isFormOrPopupEditMode() {
    return this.isPopupEditMode() || this.isFormEditMode();
  }
  isPopupEditMode() {
    var e = this.option("editing.mode");
    return e === XB;
  }
  isFormEditMode() {
    var e = this.option("editing.mode");
    return e === Km;
  }
  getFirstEditableColumnIndex() {
    var e = this._firstFormItem;
    if (this.isFormEditMode() && e) {
      var i = this.option(os), r = this._dataController.getRowIndexByKey(i), n = this._rowsView.getCellElements(r);
      return this._rowsView._getEditFormEditorVisibleIndex(n, e.column);
    }
    return super.getFirstEditableColumnIndex();
  }
  getEditFormRowIndex() {
    return this.isFormOrPopupEditMode() ? this._getVisibleEditRowIndex() : super.getEditFormRowIndex();
  }
  _isEditColumnVisible() {
    var e = super._isEditColumnVisible(), i = this.option("editing");
    return this.isFormOrPopupEditMode() && i.allowUpdating || e;
  }
  _handleDataChanged(e) {
    var i, r;
    if (this.isPopupEditMode()) {
      var n = this.option("editing.editRowKey"), a = (i = e == null ? void 0 : e.items) === null || i === void 0 ? void 0 : i.some((u) => Mi(u.key, n)), o = ((r = e.changeTypes) === null || r === void 0 ? void 0 : r.length) && e.changeTypes.every((u) => u === "insert");
      (e.changeType === "refresh" || a && e.isOptionChanged) && !o && this._repaintEditPopup();
    }
    super._handleDataChanged(e);
  }
  getPopupContent() {
    var e, i = (e = this._editPopup) === null || e === void 0 ? void 0 : e.option("visible");
    if (this.isPopupEditMode() && i)
      return this._$popupContent;
  }
  _showAddedRow(e) {
    this.isPopupEditMode() ? this._showEditPopup(e) : super._showAddedRow(e);
  }
  _cancelEditDataCore() {
    super._cancelEditDataCore(), this.isPopupEditMode() && this._hideEditPopup();
  }
  _updateEditRowCore(e, i, r) {
    var n, a = this._editForm;
    this.isPopupEditMode() ? this.option("repaintChangesOnly") ? ((n = e.update) === null || n === void 0 || n.call(e, e), this._rowsView.renderDelayedTemplates()) : a && (this._updateEditFormDeferred = new q().done(() => a.repaint()), this._updateLockCount || this._updateEditFormDeferred.resolve()) : super._updateEditRowCore(e, i, r);
  }
  _showEditPopup(e, i) {
    var r = Ye.current().deviceType !== "desktop", n = this.addWidgetPrefix(OIe), a = P({
      showTitle: !1,
      fullScreen: r,
      wrapperAttr: {
        class: n
      },
      toolbarItems: [{
        toolbar: "bottom",
        location: "after",
        widget: "dxButton",
        options: this._getSaveButtonConfig()
      }, {
        toolbar: "bottom",
        location: "after",
        widget: "dxButton",
        options: this._getCancelButtonConfig()
      }],
      contentTemplate: this._getPopupEditFormTemplate(e)
    }, this.option(Zw));
    if (!this._editPopup) {
      var o = E("<div>").appendTo(this.component.$element()).addClass(n);
      this._editPopup = this._createComponent(o, Hu), this._editPopup.on("hiding", this._getEditPopupHiddenHandler()), this._editPopup.on("shown", (u) => {
        var c;
        k.trigger(u.component.$content().find(qB).not(".".concat(LIe)).first(), "focus"), i && ((c = this._editForm) === null || c === void 0 || c.repaint());
      });
    }
    this._editPopup.option(a), this._editPopup.show(), super._showEditPopup(e, i);
  }
  _getPopupEditFormTemplate(e) {
    var i = this.component.getVisibleRows()[e], r = {
      row: i,
      values: i.values,
      rowType: i.rowType,
      key: i.key,
      rowIndex: e
    };
    return this._rowsView._addWatchMethod(r, i), (n) => {
      var a = this.getEditFormTemplate(), o = this._createComponent(E("<div>").appendTo(n), ds);
      this._$popupContent = E(o.content()), a(this._$popupContent, r, {
        isPopupForm: !0
      }), this._rowsView.renderDelayedTemplates(), E(n).parent().attr("aria-label", this.localize("dxDataGrid-ariaEditForm"));
    };
  }
  _repaintEditPopup() {
    var e, i, r = this._getVisibleEditRowIndex();
    if (r >= 0) {
      var n = (e = this._editPopup) === null || e === void 0 ? void 0 : e.option("animation");
      (i = this._editPopup) === null || i === void 0 || i.option("animation", null), this._showEditPopup(r, !0), n !== void 0 && this._editPopup.option("animation", n);
    }
  }
  _hideEditPopup() {
    var e;
    (e = this._editPopup) === null || e === void 0 || e.option("visible", !1);
  }
  optionChanged(e) {
    if (e.name === "editing" && this.isFormOrPopupEditMode()) {
      var {
        fullName: i
      } = e;
      i.indexOf(LM) === 0 ? (this._handleFormOptionChange(e), e.handled = !0) : i.indexOf(Zw) === 0 && (this._handlePopupOptionChange(e), e.handled = !0);
    }
    super.optionChanged(e);
  }
  _handleFormOptionChange(e) {
    var i;
    if (this.isFormEditMode()) {
      var r = this._getVisibleEditRowIndex();
      r >= 0 && this._dataController.updateItems({
        changeType: "update",
        rowIndices: [r]
      });
    } else
      !((i = this._editPopup) === null || i === void 0) && i.option("visible") && e.fullName.indexOf(LM) === 0 && this._repaintEditPopup();
  }
  _handlePopupOptionChange(e) {
    var i = this._editPopup;
    if (i) {
      var r = e.fullName.slice(Zw.length + 1);
      r ? i.option(r, e.value) : i.option(e.value);
    }
  }
  renderFormEditorTemplate(e, i, r, n, a) {
    var o = this, u = E(n), {
      column: c
    } = i, p = HIe(i), v = e == null ? void 0 : e.row.data, _ = r.component, {
      label: y,
      labelMark: b,
      labelMode: I
    } = r.editorOptions || {}, A = P({}, e, {
      data: v,
      cellElement: null,
      isOnForm: !0,
      item: i,
      id: _.getItemID(i.name || i.dataField),
      column: P({}, c, {
        editorType: p,
        editorOptions: P({
          label: y,
          labelMark: b,
          labelMode: I
        }, c.editorOptions, i.editorOptions)
      }),
      columnIndex: c.index,
      setValue: !a && c.allowEditing && function(B, $) {
        o.updateFieldValue(A, B, $);
      }
    });
    A.value = c.calculateCellValue(v);
    var L = this._getFormEditItemTemplate.bind(this)(A, c);
    return this._rowsView.renderTemplate(u, L, A, !!dI(u)).done(() => {
      this._rowsView._updateCell(u, A);
    }), A;
  }
  getFormEditorTemplate(e, i) {
    var r = this.component.columnOption(i.name || i.dataField);
    return (n, a) => {
      var o = E(a), {
        row: u
      } = e;
      if (u != null && u.watch) {
        var c = u.watch(() => r.selector(u.data), () => {
          var p = o.find(".dx-widget").first(), v = p.data("dxValidator"), _ = v == null ? void 0 : v.option();
          o.contents().remove(), e = this.renderFormEditorTemplate.bind(this)(e, i, n, o), p = o.find(".dx-widget").first(), v = p.data("dxValidator"), _ && !v && p.dxValidator({
            validationRules: _.validationRules,
            validationGroup: _.validationGroup,
            dataGetter: _.dataGetter
          });
        });
        k.on(o, fo, c);
      }
      e = this.renderFormEditorTemplate.bind(this)(e, i, n, o);
    };
  }
  getEditFormOptions(e) {
    var i, r = (i = this._getValidationGroupsInForm) === null || i === void 0 ? void 0 : i.call(this, e), n = this.option("editing.form.customizeItem"), a = this.addWidgetPrefix(t8), o = this.option("editing.form.items"), u = {};
    if (o)
      n8(o, (p) => {
        var v = (p == null ? void 0 : p.name) || (p == null ? void 0 : p.dataField);
        v && (u[v] = !!p.editorType);
      });
    else {
      var c = this._columnsController.getColumns();
      o = [], N(c, (p, v) => {
        !v.isBand && !v.type && o.push({
          column: v,
          name: v.name,
          dataField: v.dataField
        });
      });
    }
    return P({}, r, {
      items: o,
      formID: "dx-".concat(new yr()),
      customizeItem: (p) => {
        var v, _ = p.name || p.dataField;
        if ((p.column || _) && (v = p.column || this._columnsController.columnOption(p.name ? "name:".concat(p.name) : "dataField:".concat(p.dataField))), v) {
          if (p.label = p.label || {}, p.label.text = p.label.text || v.caption, v.dataType === "boolean" && p.label.visible === void 0) {
            var y = this.option("editing.form.labelMode");
            (y === "floating" || y === "static") && (p.label.visible = !0);
          }
          p.template = p.template || this.getFormEditorTemplate(e, p), p.column = v, p.isCustomEditorType = u[_], v.formItem && P(p, v.formItem), p.isRequired === void 0 && v.validationRules && (p.isRequired = v.validationRules.some((I) => I.type === "required"), p.validationRules = []);
          var b = R(p.visible) ? p.visible : !0;
          !this._firstFormItem && b && (this._firstFormItem = p);
        }
        n == null || n.call(this, p), p.cssClass = ht(p.cssClass) ? "".concat(p.cssClass, " ").concat(a) : a;
      }
    });
  }
  getEditFormTemplate() {
    return (e, i, r) => {
      var n = this.option(LM), a = this.getEditFormOptions(i), o = E("<div>").appendTo(e), u = r == null ? void 0 : r.isPopupForm;
      if (this._firstFormItem = void 0, u && o.addClass(this.addWidgetPrefix(RIe)), this._editForm = this._createComponent(o, eV, P({}, n, a)), !u) {
        var c = E("<div>").addClass(this.addWidgetPrefix(kIe)).appendTo(e);
        this._createComponent(E("<div>").appendTo(c), yn, this._getSaveButtonConfig()), this._createComponent(E("<div>").appendTo(c), yn, this._getCancelButtonConfig());
      }
      this._editForm.on("contentReady", () => {
        var p;
        this._rowsView.renderDelayedTemplates(), (p = this._editPopup) === null || p === void 0 || p.repaint();
      });
    };
  }
  getEditForm() {
    return this._editForm;
  }
  _endUpdateCore() {
    var e;
    (e = this._updateEditFormDeferred) === null || e === void 0 || e.resolve();
  }
  _beforeEndSaving(e) {
    var i;
    super._beforeEndSaving(e), this.isPopupEditMode() && ((i = this._editPopup) === null || i === void 0 || i.hide());
  }
  _processDataItemCore(e, i, r, n, a) {
    var {
      type: o
    } = i;
    this.isPopupEditMode() && o === Eu && (e.visible = !1), super._processDataItemCore(e, i, r, n, a);
  }
  _editRowFromOptionChangedCore(e, i) {
    var r = this.isPopupEditMode();
    super._editRowFromOptionChangedCore(e, i, r), r && this._showEditPopup(i);
  }
}, qAe = (t) => class extends t {
  _updateEditItem(e) {
    this._editingController.isFormEditMode() && (e.rowType = "detail");
  }
  _getChangedColumnIndices(e, i, r, n) {
    if (!(n === !1 && i.isEditing && this._editingController.isFormEditMode()))
      return super._getChangedColumnIndices.apply(this, arguments);
  }
}, XAe = (t) => class extends t {
  _renderCellContent(e, i) {
    i.rowType === "data" && this._editingController.isPopupEditMode() && i.row.visible === !1 || super._renderCellContent.apply(this, arguments);
  }
  getCellElements(e) {
    var i = super.getCellElements(e), r = this._editingController, n = r.getEditForm(), a = r.getEditFormRowIndex();
    return a === e && i && n ? n.$element().find(".".concat(this.addWidgetPrefix(t8), ", .").concat(MIe)) : i;
  }
  _getVisibleColumnIndex(e, i, r) {
    var n = this._editingController.getEditFormRowIndex();
    if (n === i && ht(r)) {
      var a = this._columnsController.columnOption(r);
      return this._getEditFormEditorVisibleIndex(e, a);
    }
    return super._getVisibleColumnIndex.apply(this, arguments);
  }
  _getEditFormEditorVisibleIndex(e, i) {
    var r = -1;
    return N(e, (n, a) => {
      var o = E(a).find(".dx-field-item-content").data("dx-form-item");
      if (o != null && o.column && i && o.column.index === i.index)
        return r = n, !1;
    }), r;
  }
  _isFormItem(e) {
    var i = e.rowType === "detail" || e.rowType === "detailAdaptive", r = e.rowType === "data" && this._editingController.isPopupEditMode();
    return (i || r) && e.item;
  }
  _updateCell(e, i) {
    this._isFormItem(i) ? this._formItemPrepared(i, e) : super._updateCell(e, i);
  }
  _updateContent() {
    var e = this._editingController, i = e.getEditForm(), r = i == null ? void 0 : i.option("validationGroup"), n = super._updateContent.apply(this, arguments);
    return n.done(() => {
      var a = e.getEditForm();
      r && a && a !== i && a.option("validationGroup", r);
    });
  }
}, QAe = {
  extenders: {
    controllers: {
      editing: YAe,
      data: qAe
    },
    views: {
      rowsView: XAe
    }
  }
};
et.registerModule("editingFormBased", QAe);
var ZAe = (t) => class extends t {
  init() {
    var e = !this._saveEditorHandler;
    if (super.init(), e) {
      var i, r;
      this._pointerUpEditorHandler = () => {
        var n;
        r = (n = this._columnsResizerController) === null || n === void 0 ? void 0 : n.isResizing();
      }, this._pointerDownEditorHandler = (n) => i = E(n.target), this._saveEditorHandler = this.createAction(function(n) {
        var {
          event: a
        } = n, o = E(a.target), u = a[ZX], {
          component: c
        } = this;
        if (NIe(i) && !i.is(o))
          return;
        function p(A) {
          if (!A)
            return !1;
          var L = A.closest(".".concat(TIe)), B = c.$element();
          return L.length > 0 && B.closest(L).length === 0;
        }
        if (this.isCellOrBatchEditMode() && !this._editCellInProgress) {
          var v = p(o) || p(u == null ? void 0 : u.$element()), _ = u && !u._disposed && u !== this.component, y = !!o.closest(".".concat(this.addWidgetPrefix(wIe))).length, b = o.hasClass(this.addWidgetPrefix(bIe)), I = this.isCellEditMode();
          !r && !v && !b && !(y && I && this.isEditing()) && (dI(o) || _) && this._closeEditItem.bind(this)(o);
        }
      }), k.on(de.getDocument(), Xt.up, this._pointerUpEditorHandler), k.on(de.getDocument(), Xt.down, this._pointerDownEditorHandler), k.on(de.getDocument(), di, this._saveEditorHandler);
    }
  }
  isCellEditMode() {
    return this.option("editing.mode") === km;
  }
  isBatchEditMode() {
    return this.option("editing.mode") === Fp;
  }
  isCellOrBatchEditMode() {
    return this.isCellEditMode() || this.isBatchEditMode();
  }
  _needToCloseEditableCell(e) {
    var i, r = this.component.$element(), n = this.isEditing(), a = !r || !!e.closest(r).length;
    if (a) {
      var o = e.closest(".".concat(IIe)).length;
      if (o) {
        var u = e.closest(".".concat(vh, "> td")), c = this._rowsView.getRowIndex(u.parent()), p = this._rowsView.getCellElements(c);
        if (p != null && p.length) {
          var v = p.index(u), _ = this._columnsController.getVisibleColumns(), y = (i = _[v]) === null || i === void 0 ? void 0 : i.allowEditing, b = this.isEditCell(c, v);
          n = n && !y && !b;
        }
      }
    }
    return n || super._needToCloseEditableCell(e);
  }
  _closeEditItem(e) {
    this._needToCloseEditableCell(e) && this.closeEditCell();
  }
  _focusEditorIfNeed() {
    var e;
    if (this._needFocusEditor && this.isCellOrBatchEditMode()) {
      var i = this._getVisibleEditColumnIndex(), r = (e = this._rowsView) === null || e === void 0 ? void 0 : e._getCellElement(this._getVisibleEditRowIndex(), i);
      r && !r.find(":focus").length ? this._focusEditingCell(() => {
        this._editCellInProgress = !1;
      }, r, !0) : this._editCellInProgress = !1, this._needFocusEditor = !1;
    } else
      super._focusEditorIfNeed();
  }
  isEditing() {
    if (this.isCellOrBatchEditMode()) {
      var e = R(this.option(os)), i = R(this.option(gp));
      return e && i;
    }
    return super.isEditing();
  }
  _handleEditColumnNameChange(e) {
    var i = this._getVisibleEditRowIndex(e.previousValue);
    if (this.isCellOrBatchEditMode() && i !== -1 && R(e.value) && e.value !== e.previousValue) {
      var r = this._columnsController.getVisibleColumnIndex(e.value), n = this._columnsController.getVisibleColumnIndex(e.previousValue);
      this._editCellFromOptionChanged(r, n, i);
    }
  }
  _addRow(e) {
    if (this.isCellEditMode() && this.hasChanges()) {
      var i = new q();
      return this.saveEditData().done(() => {
        this.hasChanges() ? i.reject("cancel") : this.addRow(e).done(i.resolve).fail(i.reject);
      }), i.promise();
    }
    return super._addRow(e);
  }
  editCell(e, i) {
    return this._editCell({
      rowIndex: e,
      columnIndex: i
    });
  }
  _editCell(e) {
    var i = new q(), r;
    return this.executeOperation(i, () => {
      r = this._editCellCore(e), $e(r).done(i.resolve).fail(i.reject);
    }), r !== void 0 ? r : i.promise();
  }
  _editCellCore(e) {
    var i = this._dataController, r = R(e.oldColumnIndex) || R(e.oldRowIndex), {
      columnIndex: n,
      rowIndex: a,
      column: o,
      item: u
    } = this._getNormalizedEditCellOptions(e), c = {
      data: u == null ? void 0 : u.data,
      cancel: !1,
      column: o
    };
    if (u.key === void 0) {
      this._dataController.fireError("E1043");
      return;
    }
    if (o && (u.rowType === "data" || u.rowType === "detailAdaptive") && !u.removed && this.isCellOrBatchEditMode()) {
      if (!r && this.isEditCell(a, n))
        return !0;
      var p = a + i.getRowIndexOffset();
      return $e(this._beforeEditCell(a, n, u)).done((v) => {
        v || this._prepareEditCell(c, u, n, p) || this._processCanceledEditingCell();
      });
    }
    return !1;
  }
  _beforeEditCell(e, i, r) {
    if (this.isCellEditMode() && !r.isNewRow && this.hasChanges()) {
      var n = new q();
      return this.saveEditData().always(() => {
        n.resolve(this.hasChanges());
      }), this.addDeferred(n), n;
    }
    return !1;
  }
  publicMethods() {
    var e = super.publicMethods();
    return e.concat(["editCell", "closeEditCell"]);
  }
  _getNormalizedEditCellOptions(e) {
    var {
      oldColumnIndex: i,
      oldRowIndex: r,
      columnIndex: n,
      rowIndex: a
    } = e, o = this._columnsController, u = o.getVisibleColumns(), c = this._dataController.items(), p = c[a], v;
    R(i) ? v = u[i] : v = this._getEditColumn(), R(r) || (r = this._getVisibleEditRowIndex()), ht(n) && (n = o.columnOption(n, "index"), n = o.getVisibleIndex(n));
    var _ = u[n];
    return {
      oldColumn: v,
      columnIndex: n,
      oldRowIndex: r,
      rowIndex: a,
      column: _,
      item: p
    };
  }
  _prepareEditCell(e, i, r, n) {
    var a;
    return i.isNewRow || (e.key = i.key), this._isEditingStart(e) ? !1 : (this._pageIndex = this._dataController.pageIndex(), this._setEditRowKey(i.key), this._setEditColumnNameByIndex(r), e.column.showEditorAlways || this._addInternalData({
      key: i.key,
      oldData: (a = i.oldData) !== null && a !== void 0 ? a : i.data
    }), !0);
  }
  closeEditCell(e, i) {
    var r = $e(), n = this._getVisibleEditRowIndex();
    if (this.isCellOrBatchEditMode()) {
      var a = new q();
      r = new q(), this.executeOperation(a, () => {
        this._closeEditCellCore(e, n, i).always(r.resolve);
      });
    }
    return r.promise();
  }
  _closeEditCellCore(e, i, r) {
    var n = this._dataController, a = new q(), o = a.promise();
    if (this.isCellEditMode() && this.hasChanges()) {
      if (!r)
        return this.saveEditData().done((c) => {
          if (!this.hasChanges()) {
            this.closeEditCell(!!c).always(a.resolve);
            return;
          }
          a.resolve();
        }), o;
    } else if (this._resetEditRowKey(), this._resetEditColumnName(), i >= 0) {
      var u = [i];
      this._beforeCloseEditCellInBatchMode(u), e || n.updateItems({
        changeType: "update",
        rowIndices: u
      });
    }
    return a.resolve(), o;
  }
  _resetModifiedClassCells(e) {
    if (this.isBatchEditMode()) {
      var i = this._columnsController.getVisibleColumns().length;
      e.forEach((r) => {
        for (var {
          key: n
        } = r, a = this._dataController.getRowIndexByKey(n), o = 0; o < i; o++) {
          var u = this._rowsView._getCellElement(a, o);
          u == null || u.removeClass(rIe);
        }
      });
    }
  }
  _prepareChange(e, i, r) {
    var n = E(e.cellElement);
    return this.isBatchEditMode() && e.key !== void 0 && this._applyModified(n, e), super._prepareChange(e, i, r);
  }
  _cancelSaving(e) {
    var i = this._dataController;
    this.isCellOrBatchEditMode() && (this.isBatchEditMode() && this._resetEditIndices(), i.updateItems()), super._cancelSaving(e);
  }
  optionChanged(e) {
    var {
      fullName: i
    } = e;
    e.name === "editing" && i === gp ? (this._handleEditColumnNameChange(e), e.handled = !0) : super.optionChanged(e);
  }
  _editCellFromOptionChanged(e, i, r) {
    var n = this._columnsController.getVisibleColumns();
    e > -1 && dn(() => {
      this._repaintEditCell(n[e], n[i], r);
    });
  }
  _handleEditRowKeyChange(e) {
    var i;
    if (this.isCellOrBatchEditMode()) {
      var r = this._getVisibleEditColumnIndex(), n = this._getEditRowIndexCorrection(), a = this._dataController.getRowIndexByKey(e.previousValue) + n;
      R(e.value) && e.value !== e.previousValue && ((i = this._editCellFromOptionChanged) === null || i === void 0 || i.call(this, r, r, a));
    } else
      super._handleEditRowKeyChange(e);
  }
  deleteRow(e) {
    if (this.isCellEditMode() && this.isEditing()) {
      var {
        isNewRow: i
      } = this._dataController.items()[e], r = this._dataController.getKeyByRowIndex(e);
      this.closeEditCell(null, i).always(() => {
        e = this._dataController.getRowIndexByKey(r), this._checkAndDeleteRow(e);
      });
    } else
      super.deleteRow(e);
  }
  _checkAndDeleteRow(e) {
    this.isBatchEditMode() ? this._deleteRowCore(e) : super._checkAndDeleteRow(e);
  }
  _refreshCore(e) {
    var {
      isPageChanged: i
    } = e ?? {}, r = this.isBatchEditMode() || i && this.option("scrolling.mode") !== "virtual";
    this.isCellOrBatchEditMode() ? r && (this._resetEditColumnName(), this._resetEditRowKey()) : super._refreshCore(e);
  }
  _allowRowAdding(e) {
    return this.isBatchEditMode() ? !0 : super._allowRowAdding(e);
  }
  _afterDeleteRow(e, i) {
    var r = this._dataController;
    return this.isBatchEditMode() ? (r.updateItems({
      changeType: "update",
      rowIndices: [i, e]
    }), new q().resolve()) : super._afterDeleteRow(e, i);
  }
  _updateEditRow(e, i, r) {
    this.isCellOrBatchEditMode() ? this._updateRowImmediately(e, i, r) : super._updateEditRow(e, i, r);
  }
  _isDefaultButtonVisible(e, i) {
    if (this.isCellOrBatchEditMode()) {
      var r = this.isBatchEditMode();
      switch (e.name) {
        case "save":
        case "cancel":
        case "edit":
          return !1;
        case "delete":
          return super._isDefaultButtonVisible(e, i) && (!r || !i.row.removed);
        case "undelete":
          return r && this.allowDeleting(i) && i.row.removed;
        default:
          return super._isDefaultButtonVisible(e, i);
      }
    }
    return super._isDefaultButtonVisible(e, i);
  }
  _isRowDeleteAllowed() {
    var e = super._isRowDeleteAllowed();
    return e || this.isBatchEditMode();
  }
  _beforeEndSaving(e) {
    var i;
    this.isCellEditMode() ? ((i = e[0]) === null || i === void 0 ? void 0 : i.type) !== "update" && super._beforeEndSaving(e) : (this.isBatchEditMode() && this._resetModifiedClassCells(e), super._beforeEndSaving(e));
  }
  prepareEditButtons(e) {
    var i, r = (i = this.option("editing")) !== null && i !== void 0 ? i : {}, n = super.prepareEditButtons(e), a = r.allowUpdating || r.allowAdding || r.allowDeleting;
    return a && this.isBatchEditMode() && (n.push(this.prepareButtonItem(e, "save", "saveEditData", 21)), n.push(this.prepareButtonItem(e, "revert", "cancelEditData", 22))), n;
  }
  _saveEditDataInner() {
    var e = this._dataController.getVisibleRows()[this.getEditRowIndex()], i = this._getEditColumn(), r = i == null ? void 0 : i.showEditorAlways, n = this.isCellEditMode() && !(e != null && e.isNewRow), a;
    return n && r && (a = new q(), this.addDeferred(a)), super._saveEditDataInner().always(a == null ? void 0 : a.resolve);
  }
  _applyChange(e, i, r) {
    var n = this.isCellEditMode() && e.row && !e.row.isNewRow, {
      showEditorAlways: a
    } = e.column, o = e.column.setCellValue !== e.column.defaultSetCellValue, u = a && !r && n && this.hasEditData() && !this.isEditCell(e.rowIndex, e.columnIndex);
    if (u) {
      this._focusEditingCell(), this._updateEditRow(e.row, !0, o);
      return;
    }
    return super._applyChange(e, i, r);
  }
  _applyChangeCore(e, i) {
    var {
      showEditorAlways: r
    } = e.column, n = this.isCellEditMode() && e.row && !e.row.isNewRow;
    if (r && !i) {
      if (n)
        return this._setEditRowKey(e.row.key, !0), this._setEditColumnNameByIndex(e.columnIndex, !0), this.saveEditData();
      if (this.isBatchEditMode())
        return i = this._needUpdateRow(e.column), super._applyChangeCore(e, i);
    }
    return super._applyChangeCore(e, i);
  }
  _processDataItemCore(e, i, r, n, a) {
    var {
      data: o,
      type: u
    } = i;
    this.isBatchEditMode() && u === Bd && (e.data = xh(e.data, o)), super._processDataItemCore(e, i, r, n, a);
  }
  _processRemoveCore(e, i, r) {
    if (!(this.isBatchEditMode() && !r))
      return super._processRemoveCore(e, i, r);
  }
  _processRemoveIfError(e, i) {
    if (!this.isBatchEditMode())
      return super._processRemoveIfError(e, i);
  }
  _beforeFocusElementInRow(e) {
    super._beforeFocusElementInRow(e);
    var i = e >= 0 ? e : 0, r = this.getFirstEditableColumnIndex();
    r >= 0 && this.editCell(i, r);
  }
}, JAe = (t) => class extends t {
  _createTable() {
    var e = super._createTable.apply(this, arguments), i = this._editingController;
    return i.isCellOrBatchEditMode() && this.option("editing.allowUpdating") && k.on(e, ve(Lh.name, "dxDataGridRowsView"), "td:not(.".concat(FI, ")"), this.createAction(() => {
      i.isEditing() && i.closeEditCell();
    })), e;
  }
  _createRow(e) {
    var i = super._createRow.apply(this, arguments);
    if (e) {
      var r = this._editingController, n = !!e.removed;
      r.isBatchEditMode() && n && i.addClass(DIe);
    }
    return i;
  }
}, eOe = (t) => class extends t {
  isVisible() {
    var e = this._editingController.option("editing");
    return super.isVisible() || e && (e.allowUpdating || e.allowDeleting) && e.mode === Fp;
  }
}, tOe = {
  extenders: {
    controllers: {
      editing: ZAe
    },
    views: {
      rowsView: JAe,
      headerPanel: eOe
    }
  }
};
et.registerModule("editingCellBased", tOe);
var S8 = "invalid", HM = "revert-tooltip", t2 = "dx-invalid-message", i2 = "dxInvalidMessage", FP = "invalid-message", r2 = "dx-invalid-message-always", iOe = "dx-revert-button", n2 = "dxRevertButton", E8 = "validator", $M = "dx-pending-indicator", a2 = "dx-validation-pending", o2 = "content", s2 = "__DX_INSERT_INDEX__", rOe = 2, b8 = "row", nOe = "form", Jw = "batch", wm = "cell", aOe = "popup", oOe = "dx-group-cell", w8 = [aOe, nOe], sOe = "transparent", No = {
  valid: "valid",
  invalid: "invalid",
  pending: "pending"
}, rx = "insert", lOe = "remove", nx = "cancel", ax = function(t) {
  return R(t) && t !== nx;
}, T8 = function(t, e) {
  return t !== void 0 || t === void 0 && e && !e.isNewRow;
};
class uOe extends Bi.Controller {
  constructor() {
    super(...arguments), this._isValidationInProgress = !1, this._disableApplyValidationResults = !1;
  }
  init() {
    this._editingController = this.getController("editing"), this._editorFactoryController = this.getController("editorFactory"), this._columnsController = this.getController("columns"), this.createAction("onRowValidating"), this._validationState || this.initValidationState();
  }
  initValidationState() {
    this._validationState = [], this._validationStateCache = {};
  }
  _rowIsValidated(e) {
    var i = this._getValidationData(e == null ? void 0 : e.key);
    return !!i && !!i.validated;
  }
  _getValidationData(e, i) {
    var r = ku(e), n = ct(r), a;
    return n ? a = this._validationState.filter((o) => Mi(o.key, e))[0] : a = this._validationStateCache[r], !a && i && (a = {
      key: e,
      isValid: !0
    }, this._validationState.push(a), n || (this._validationStateCache[r] = a)), a;
  }
  _getBrokenRules(e, i) {
    var r;
    return i ? r = i.brokenRules || i.brokenRule && [i.brokenRule] : r = e.brokenRules || [], r;
  }
  _rowValidating(e, i) {
    var r = new q(), n = this._editingController.getChangeByKey(e == null ? void 0 : e.key), a = this._getBrokenRules(e, i), o = i ? i.isValid : e.isValid, u = {
      brokenRules: a,
      isValid: o,
      key: n.key,
      newData: n.data,
      oldData: this._editingController._getOldData(n.key),
      promise: null,
      errorText: this.getHiddenValidatorsErrorText(a)
    };
    return this.executeAction("onRowValidating", u), $e(Pn(u.promise)).always(() => {
      e.isValid = u.isValid, e.errorText = u.errorText, r.resolve(u);
    }), r.promise();
  }
  getHiddenValidatorsErrorText(e) {
    var i = [];
    return N(e, (r, n) => {
      var {
        column: a
      } = n, o = a && a.groupIndex !== void 0 && !a.showWhenGrouped, u = a && a.visible;
      !n.validator.$element().parent().length && (!u || o) && i.push(n.message);
    }), i.join(", ");
  }
  validate(e) {
    var i = !0, r = this._editingController, n = new q(), a = [], o = r.getEditMode();
    if (e = e || o === b8, this._isValidationInProgress)
      return n.resolve(!1).promise();
    if (this._isValidationInProgress = !0, e) {
      r.addDeferred(n);
      var u = r.getChanges();
      N(u, (p, v) => {
        var {
          type: _,
          key: y
        } = v;
        if (_ !== "remove") {
          var b = this._getValidationData(y, !0), I = this.validateGroup(b);
          a.push(I), I.done((A) => {
            b.validated = !0, i = i && A.isValid;
          });
        }
      });
    } else if (this._currentCellValidator) {
      var c = this.validateGroup(this._currentCellValidator._findGroup());
      a.push(c), c.done((p) => {
        i = p.isValid;
      });
    }
    return $e(...a).done(() => {
      this._isValidationInProgress = !1, n.resolve(i);
    }), n.promise();
  }
  validateGroup(e) {
    var i = new q(), r = e && Si.getGroupConfig(e), n;
    return r != null && r.validators.length && (this.resetRowValidationResults(e), n = Si.validateGroup(e)), $e((n == null ? void 0 : n.complete) || n).done((a) => {
      $e(this._rowValidating(e, a)).done(i.resolve);
    }), i.promise();
  }
  isRowDataModified(e) {
    return !uo(e.data);
  }
  updateValidationState(e) {
    var i = this._editingController.getEditMode(), {
      key: r
    } = e, n = this._getValidationData(r, !0);
    if (w8.includes(i))
      n.isValid = !0;
    else {
      if (e.type === rx && !this.isRowDataModified(e)) {
        n.isValid = !0;
        return;
      }
      this.setDisableApplyValidationResults(!0);
      var a = Si.getGroupConfig(n);
      if (a) {
        var o = Si.validateGroup(n);
        $e(o.complete || o).done((u) => {
          n.isValid = u.isValid, n.brokenRules = u.brokenRules;
        });
      } else
        (!n.brokenRules || !n.brokenRules.length) && (n.isValid = !0);
      this.setDisableApplyValidationResults(!1);
    }
  }
  setValidator(e) {
    this._currentCellValidator = e;
  }
  renderCellPendingIndicator(e) {
    var i = e.find(".".concat($M));
    if (!i.length) {
      var r = e;
      i = E("<div>").appendTo(r).addClass($M), this._createComponent(i, us), e.addClass(a2);
    }
  }
  disposeCellPendingIndicator(e) {
    var i = e.find(".".concat($M));
    if (i.length) {
      var r = us.getInstance(i);
      r && (r.dispose(), r.$element().remove()), e.removeClass(a2);
    }
  }
  validationStatusChanged(e) {
    var {
      validator: i
    } = e, r = i.option("validationGroup"), {
      column: n
    } = i.option("dataGetter")();
    this.updateCellValidationResult({
      rowKey: r.key,
      columnIndex: n.index,
      validationResult: e
    });
  }
  validatorInitialized(e) {
    e.component.on("validating", this.validationStatusChanged.bind(this)), e.component.on("validated", this.validationStatusChanged.bind(this));
  }
  validatorDisposing(e) {
    var i = e.component, r = i.option("validationGroup"), {
      column: n
    } = i.option("dataGetter")(), a = this.getCellValidationResult({
      rowKey: r == null ? void 0 : r.key,
      columnIndex: n.index
    });
    ax(a) && a.status === No.pending && this.cancelCellValidationResult({
      change: r,
      columnIndex: n.index
    });
  }
  applyValidationResult(e, i) {
    var {
      validator: r
    } = i, n = r.option("validationGroup"), {
      column: a
    } = r.option("dataGetter")();
    if (i.brokenRules && i.brokenRules.forEach((v) => {
      v.columnIndex = a.index, v.column = a;
    }), e) {
      var o = this.getCellValidationResult({
        rowKey: n.key,
        columnIndex: a.index
      }), u = ax(o) && o.disabledPendingId === i.id;
      if (this._disableApplyValidationResults || u)
        return;
      if (i.status === No.invalid) {
        var c = e.find(":focus");
        Ah(c) || (k.trigger(c, "focus"), k.trigger(c, Xt.down));
      }
      var p = !a.editCellTemplate && this._editorFactoryController.getEditorInstance(e);
      i.status === No.pending ? p ? p.option("validationStatus", No.pending) : this.renderCellPendingIndicator(e) : p ? p.option("validationStatus", No.valid) : this.disposeCellPendingIndicator(e), e.toggleClass(this.addWidgetPrefix(S8), i.status === No.invalid);
    }
  }
  _syncInternalEditingData(e) {
    var i, r = this._editingController, n = r.getChangeByKey(e.key), a = r._getOldData(e.key), o = (i = e.row) === null || i === void 0 ? void 0 : i.oldData;
    n && o && !a && r._addInternalData({
      key: e.key,
      oldData: o
    });
  }
  createValidator(e, i) {
    var r, n, a, o = this._editingController, {
      column: u
    } = e, {
      showEditorAlways: c
    } = u;
    if (!(R(u.command) || !u.validationRules || !Array.isArray(u.validationRules) || !u.validationRules.length)) {
      var p = o.getIndexByKey(e.key, o.getChanges()), v = p > -1;
      if (!v) {
        if (!c) {
          var _ = ((r = this._columnsController) === null || r === void 0 ? void 0 : r.getVisibleColumns()) || [];
          c = _.some((z) => z.showEditorAlways);
        }
        var y = Mi(this.option("editing.editRowKey"), e.key), b = o.isCellOrBatchEditMode() && o.allowUpdating({
          row: e.row
        });
        v = y || b && c, b && c && o._addInternalData({
          key: e.key,
          oldData: (a = (n = e.row) === null || n === void 0 ? void 0 : n.oldData) !== null && a !== void 0 ? a : e.data
        });
      }
      if (v) {
        if (i && !i.length) {
          Yt.log("E1050");
          return;
        }
        this._syncInternalEditingData(e);
        var I = this._getValidationData(e.key, !0), A = () => {
          var z = o.getChangeByKey(I == null ? void 0 : I.key), ie = u.calculateCellValue((z == null ? void 0 : z.data) || {});
          return ie !== void 0 ? ie : e.value;
        }, L = i && i.hasClass("dx-widget");
        i && i.addClass(this.addWidgetPrefix(E8));
        var B = new BI(i || E("<div>"), {
          name: u.caption,
          validationRules: P(!0, [], u.validationRules),
          validationGroup: I,
          adapter: L ? null : {
            getValue: A,
            applyValidationResults: (z) => {
              this.applyValidationResult(i, z);
            }
          },
          dataGetter() {
            var z = I == null ? void 0 : I.key, ie = o.getChangeByKey(z), pe = o._getOldData(z);
            return {
              data: xh(pe, ie == null ? void 0 : ie.data),
              column: u
            };
          },
          onInitialized: this.validatorInitialized.bind(this),
          onDisposing: this.validatorDisposing.bind(this)
        });
        if (L) {
          var $ = B.option("adapter");
          if ($) {
            var K = $.bypass, te = () => e.row.isNewRow && !this._isValidationInProgress && !o.isCellModified(e);
            $.getValue = A, $.validationRequestsCallbacks = [], $.bypass = () => K.call($) || te();
          }
        }
        return B;
      }
    }
  }
  setDisableApplyValidationResults(e) {
    this._disableApplyValidationResults = e;
  }
  getDisableApplyValidationResults() {
    return this._disableApplyValidationResults;
  }
  isCurrentValidatorProcessing(e) {
    var {
      rowKey: i,
      columnIndex: r
    } = e;
    return this._currentCellValidator && Mi(this._currentCellValidator.option("validationGroup").key, i) && this._currentCellValidator.option("dataGetter")().column.index === r;
  }
  validateCell(e) {
    var i = {
      rowKey: e.option("validationGroup").key,
      columnIndex: e.option("dataGetter")().column.index,
      validationResult: null
    }, r = this.getCellValidationResult(i), n = ax(r), a = e.option("adapter");
    if (!n)
      r = e.validate();
    else {
      var o = a.getValue();
      Mi(o, r.value) || (r = e.validate());
    }
    var u = new q();
    return n && r.status === No.pending && (this.updateCellValidationResult(i), a.applyValidationResults(r)), $e(r.complete || r).done((c) => {
      n && a.applyValidationResults(c), u.resolve(c);
    }), u.promise();
  }
  updateCellValidationResult(e) {
    var {
      rowKey: i,
      columnIndex: r,
      validationResult: n
    } = e, a = this._getValidationData(i);
    if (a) {
      a.validationResults || (a.validationResults = {});
      var o;
      if (n) {
        if (o = P({}, n), a.validationResults[r] = o, n.status === No.pending && (this._editingController.getEditMode() === wm && (o.deferred = new q(), o.complete.always(() => {
          o.deferred.resolve();
        }), this._editingController.addDeferred(o.deferred)), this._disableApplyValidationResults)) {
          o.disabledPendingId = n.id;
          return;
        }
      } else
        o = a.validationResults[r];
      o && o.disabledPendingId && delete o.disabledPendingId;
    }
  }
  getCellValidationResult(e) {
    var {
      rowKey: i,
      columnIndex: r
    } = e, n, a = this._getValidationData(i, !0);
    return (n = a == null ? void 0 : a.validationResults) === null || n === void 0 ? void 0 : n[r];
  }
  removeCellValidationResult(e) {
    var {
      change: i,
      columnIndex: r
    } = e, n = this._getValidationData(i == null ? void 0 : i.key);
    n && n.validationResults && (this.cancelCellValidationResult({
      change: i,
      columnIndex: r
    }), delete n.validationResults[r]);
  }
  cancelCellValidationResult(e) {
    var {
      change: i,
      columnIndex: r
    } = e, n = this._getValidationData(i.key);
    if (i && n.validationResults) {
      var a = n.validationResults[r];
      a && (a.deferred && a.deferred.reject(nx), n.validationResults[r] = nx);
    }
  }
  resetRowValidationResults(e) {
    e && (e.validationResults && delete e.validationResults, delete e.validated);
  }
  isInvalidCell(e) {
    var {
      rowKey: i,
      columnIndex: r
    } = e, n = this.getCellValidationResult({
      rowKey: i,
      columnIndex: r
    });
    return ax(n) && n.status === No.invalid;
  }
  getCellValidator(e) {
    var {
      rowKey: i,
      columnIndex: r
    } = e, n = this._getValidationData(i), a = n && Si.getGroupConfig(n), o = a && a.validators;
    return o && o.filter((u) => {
      var {
        column: c
      } = u.option("dataGetter")();
      return c ? c.index === r : !1;
    })[0];
  }
  setCellValidationStatus(e) {
    var i = this.getCellValidationResult({
      rowKey: e.key,
      columnIndex: e.column.index
    });
    R(i) ? e.validationStatus = i !== nx ? i.status : nx : delete e.validationStatus;
  }
}
var dOe = (t) => class extends t {
  processDataItemTreeListHack(e) {
    super.processDataItem.apply(this, arguments);
  }
  processItemsTreeListHack(e, i) {
    return super.processItems.apply(this, arguments);
  }
  _addChange(e) {
    var i = super._addChange.apply(this, arguments);
    return i && e.type !== lOe && this._validatingController.updateValidationState(i), i;
  }
  _handleChangesChange(e) {
    super._handleChangesChange.apply(this, arguments), e.value.forEach((i) => {
      this._validatingController._getValidationData(i.key) === void 0 && this._validatingController.updateValidationState(i);
    });
  }
  _updateRowAndPageIndices() {
    var e = this, i = e.getView("rowsView").getTopVisibleItemIndex(), r = i;
    N(e.getChanges(), (n, a) => {
      var {
        key: o,
        type: u
      } = a, c = this._validatingController._getValidationData(o);
      c && !c.isValid && c.pageIndex !== e._pageIndex && (c.pageIndex = e._pageIndex, u === rx ? c.rowIndex = i : c.rowIndex = r, r++);
    });
  }
  _getValidationGroupsInForm(e) {
    var i = this._validatingController._getValidationData(e.key, !0);
    return {
      validationGroup: i
    };
  }
  _validateEditFormAfterUpdate(e, i) {
    i && this._editForm && this._editForm.validate(), super._validateEditFormAfterUpdate.apply(this, arguments);
  }
  _prepareEditCell(e) {
    var i = super._prepareEditCell.apply(this, arguments);
    return i && e.column.showEditorAlways && this._validatingController.updateValidationState({
      key: e.key
    }), i;
  }
  processItems(e, i) {
    var r = this.getChanges(), n = (o, u) => {
      var c = -1, p = o.type === rx, {
        key: v
      } = o;
      return N(u, (_, y) => {
        if (Mi(v, p ? y.key : this._dataController.keyOf(y)))
          return c = _, !1;
      }), c;
    };
    e = super.processItems(e, i);
    var a = e.length;
    return this.getEditMode() === Jw && i !== "prepend" && i !== "append" && r.forEach((o) => {
      var {
        key: u
      } = o, c = this._validatingController._getValidationData(u);
      c && o.type && c.pageIndex === this._pageIndex && (o == null ? void 0 : o.pageIndex) !== this._pageIndex && function(p, v) {
        var _ = {
          key: p.key
        }, y = n(p, e);
        if (!(y >= 0)) {
          v.rowIndex = v.rowIndex > a ? v.rowIndex % a : v.rowIndex;
          var {
            rowIndex: b
          } = v;
          _[s2] = 1, e.splice(b, 0, _);
        }
      }(o, c);
    }), e;
  }
  processDataItem(e) {
    var i = e.data[s2], r = i ? e.data.key : e.key, n = this.getEditMode();
    if (n === Jw && i && r) {
      var a = this.getChanges(), o = xe.getIndexByKey(r, a);
      if (o >= 0) {
        var u = a[o];
        if (u.type !== rx) {
          var c = this._getOldData(u.key);
          e.data = P(!0, {}, c, u.data), e.key = r;
        }
      }
    }
    super.processDataItem.apply(this, arguments);
  }
  _createInvisibleColumnValidators(e) {
    var i = this, r = this._columnsController.getColumns(), n = this._columnsController.getInvisibleColumns().filter((c) => !c.isBand), a = this._columnsController.getGroupColumns().filter((c) => !c.showWhenGrouped && n.indexOf(c) === -1), o = [], u = (c, p) => this._dataController.getRowIndexByKey(p) >= 0 && n.indexOf(c) < 0;
    return n.push(...a), w8.includes(this.getEditMode()) || N(r, (c, p) => {
      e.forEach((v) => {
        var _;
        if (!u(p, v.key)) {
          if (v.type === rx)
            _ = v.data;
          else if (v.type === "update") {
            var y = i._getOldData(v.key);
            if (!R(y))
              return;
            _ = xh(y, v.data);
          }
          if (_) {
            var b = this._validatingController.createValidator({
              column: p,
              key: v.key,
              value: p.calculateCellValue(_)
            });
            b && o.push(b);
          }
        }
      });
    }), function() {
      o.forEach((c) => {
        c.dispose();
      });
    };
  }
  _beforeSaveEditData(e, i) {
    var r = super._beforeSaveEditData.apply(this, arguments), n = this._validatingController._getValidationData(e == null ? void 0 : e.key);
    if (e) {
      var a = e.type === "remove" || n.isValid;
      r = r || !a;
    } else {
      var o = this._createInvisibleColumnValidators(this.getChanges());
      r = new q(), this.executeOperation(r, () => {
        this._validatingController.validate(!0).done((u) => {
          switch (o(), this._updateRowAndPageIndices(), this.getEditMode()) {
            case wm:
              u || this._focusEditingCell();
              break;
            case Jw:
              u || (this._resetEditRowKey(), this._resetEditColumnName(), this._dataController.updateItems());
          }
          r.resolve(!u);
        });
      });
    }
    return r.promise ? r.promise() : r;
  }
  _beforeEditCell(e, i, r) {
    var n = super._beforeEditCell(e, i, r);
    if (this.getEditMode() === wm) {
      var a = this._rowsView._getCellElement(e, i), o = a && a.data("dxValidator"), u = a && a.closest(".dx-row").data("options"), c = o && o.option("adapter").getValue();
      if (o && T8(c, u)) {
        var p = new q();
        return $e(this._validatingController.validateCell(o), n).done((v, _) => {
          p.resolve(v.status === No.valid && _);
        }), p.promise();
      }
      if (!o)
        return n;
    }
    return !1;
  }
  _afterSaveEditData(e) {
    var i, r = this.getEditMode() === wm;
    if (N(this.getChanges(), (p, v) => {
      var _ = this._showErrorRow(v);
      i = i || _;
    }), i) {
      var n = this._rowsView.getScrollable();
      n && (n.update(), n.scrollToElement(i));
    }
    if (e && r && this._needUpdateRow()) {
      var a = this.getEditRowIndex();
      this._dataController.updateItems({
        changeType: "update",
        rowIndices: [a]
      }), this._focusEditingCell();
    } else if (!e) {
      var o = !0;
      if (r) {
        var u = this._columnsController.getColumns(), c = u.filter((p) => {
          var v;
          return p.showEditorAlways && ((v = p.validationRules) === null || v === void 0 ? void 0 : v.length) > 0;
        }).length > 0;
        o = !c;
      }
      o && this._validatingController.initValidationState();
    }
  }
  _handleDataChanged(e) {
    var i = this._validatingController._validationState;
    this.option("scrolling.mode") === "standard" && this.resetRowAndPageIndices(), e.changeType === "prepend" && N(i, (r, n) => {
      n.rowIndex += e.items.length;
    }), super._handleDataChanged(e);
  }
  resetRowAndPageIndices() {
    var e = this._validatingController._validationState;
    N(e, (i, r) => {
      r.pageIndex !== this._pageIndex && (delete r.pageIndex, delete r.rowIndex);
    });
  }
  _beforeCancelEditData() {
    this._validatingController.initValidationState(), super._beforeCancelEditData();
  }
  _showErrorRow(e) {
    var i, r = this._dataController.items(), n = this.getIndexByKey(e.key, r), a = this._validatingController._getValidationData(e.key);
    if (!(a != null && a.isValid) && (a != null && a.errorText) && n >= 0)
      return i = this.getPopupContent(), this._errorHandlingController && this._errorHandlingController.renderErrorRow(a == null ? void 0 : a.errorText, n, i);
  }
  updateFieldValue(e) {
    var i = new q();
    return this._validatingController.removeCellValidationResult({
      change: this.getChangeByKey(e.key),
      columnIndex: e.column.index
    }), super.updateFieldValue.apply(this, arguments).done(() => {
      var r = this._validatingController.getCellValidator({
        rowKey: e.key,
        columnIndex: e.column.index
      });
      $e(r && this._validatingController.validateCell(r)).done((n) => {
        this._editorFactoryController.refocus(), i.resolve(n);
      });
    }), i.promise();
  }
  highlightDataCell(e, i) {
    super.highlightDataCell.apply(this, arguments), this._validatingController.setCellValidationStatus(i);
    var r = !!i.setValue, n = this.isCellModified(i), a = R(i.validationStatus), o = n && i.column.setCellValue || r && !n && !(i.row.isNewRow || !a);
    if (o) {
      var u = e.data("dxValidator");
      u && $e(this._validatingController.validateCell(u)).done(() => {
        this._validatingController.setCellValidationStatus(i);
      });
    }
  }
  getChangeByKey(e) {
    var i = this.getChanges();
    return i[xe.getIndexByKey(e, i)];
  }
  isCellModified(e) {
    var i = super.isCellModified(e), r = this.getChangeByKey(e.key), n = !!e.row && this._validatingController.isInvalidCell({
      rowKey: e.key,
      columnIndex: e.column.index
    });
    return i || this._validatingController._rowIsValidated(r) && n;
  }
}, cOe = function(t, e) {
  var i = E(e).closest("tr").index(), r = E(t._rowsView.getRowElement(i)).first().children().filter(":not(.dx-hidden-cell)");
  return t._rowsView._getWidths(r).reduce((n, a) => n + a, 0);
}, hOe = function(t) {
  var e, i;
  return t.some((r, n) => {
    if (r.command === sOe)
      return e = n === 0 ? -1 : n, i = n === t.length - 1 ? -1 : n + r.colspan - 1, !0;
  }), {
    startColumnIndex: e,
    endColumnIndex: i
  };
}, fOe = (t) => class extends t {
  _showRevertButton(e) {
    var i, r = (i = this._revertTooltip) === null || i === void 0 ? void 0 : i.$element();
    if (!e || !e.length) {
      r == null || r.remove(), this._revertTooltip = void 0;
      return;
    }
    if (!e.find(r).length) {
      var n = e.closest(".".concat(this.addWidgetPrefix(o2))).parent(), a = this.addWidgetPrefix(HM);
      r == null || r.remove(), r = E("<div>").addClass(a).appendTo(e);
      var o = {
        animation: null,
        visible: !0,
        width: "auto",
        height: "auto",
        shading: !1,
        container: n,
        propagateOutsideClick: !0,
        hideOnOutsideClick: !1,
        wrapperAttr: {
          class: a
        },
        contentTemplate: () => {
          var u = E("<div>").addClass(iOe), c = {
            icon: "revert",
            hint: this.option("editing.texts.validationCancelChanges"),
            elementAttr: {
              id: n2,
              "aria-label": X.format("dxDataGrid-ariaRevertButton")
            },
            onClick: () => {
              this._editingController.cancelEditData();
            }
          };
          return new yn(u, c).$element();
        },
        position: {
          my: "left top",
          at: "right top",
          offset: "1 0",
          collision: "flip",
          boundaryOffset: "0 0",
          boundary: this._rowsView.element(),
          of: e
        },
        onPositioned: this._positionedHandler.bind(this)
      };
      this._revertTooltip = new Pl(r, o);
    }
  }
  _hideFixedGroupCell(e, i) {
    var r, n, a = this._rowsView.isFixedColumns(), o = this._editingController.isFormOrPopupEditMode();
    if (a && !o) {
      var u = e.closest(".dx-row").next().data("options");
      u && u.rowType === "group" && (r = E(this._rowsView.getRowElement(u.rowIndex)).last(), n = r.find(".".concat(oOe)), n.length && n.get(0).style.visibility !== "hidden" && (n.css("visibility", "hidden"), i.onDisposing = function() {
        n.css("visibility", "");
      }));
    }
  }
  _positionedHandler(e, i) {
    if (!e.component.__skipPositionProcessing) {
      var r = E(e.element).hasClass(this.addWidgetPrefix(HM)), n = !r && this._rowsView.updateFreeSpaceRowHeight(), a = this._normalizeValidationMessagePositionAndMaxWidth(e, r, i);
      e.component.__skipPositionProcessing = !!(n || a), a ? e.component.option(a) : n && e.component.repaint();
    }
  }
  _showValidationMessage(e, i, r) {
    var n, a = e.find(".dx-dropdowneditor-overlay").data("dxPopup"), o = a && a.option("visible"), u = o ? "top right" : "top ".concat(r), c = o ? "top left" : "bottom ".concat(r), p = ((n = this._columnsController.getFixedColumns()) === null || n === void 0 ? void 0 : n.length) > 0, v = p ? this.getView("rowsView").element() : e.closest(".".concat(this.addWidgetPrefix(o2))), _ = "";
    i && i.forEach((A) => {
      _ += (_.length ? "<br/>" : "") + K3(A);
    });
    var y = this.addWidgetPrefix(FP);
    this._rowsView.element().find(".".concat(y)).remove();
    var b = E("<div>").addClass(t2).addClass(r2).addClass(y).html(_).appendTo(e), I = {
      container: v,
      shading: !1,
      width: "auto",
      height: "auto",
      visible: !0,
      animation: !1,
      propagateOutsideClick: !0,
      hideOnOutsideClick: !1,
      wrapperAttr: {
        id: i2,
        class: "".concat(t2, " ").concat(r2, " ").concat(y)
      },
      position: {
        collision: "flip",
        boundary: this._rowsView.element(),
        boundaryOffset: "0 0",
        offset: {
          x: 0,
          y: !o && $i.mozilla ? -1 : 0
        },
        my: u,
        at: c,
        of: e
      },
      onPositioned: (A) => {
        this._positionedHandler(A, o), this._shiftValidationMessageIfNeed(A.component.$content(), e);
      }
    };
    this._hideFixedGroupCell(e, I), new Pl(b, I);
  }
  _hideValidationMessage() {
    var e, i = (e = this._rowsView.element()) === null || e === void 0 ? void 0 : e.find(this._getValidationMessagesSelector());
    i == null || i.remove();
  }
  _normalizeValidationMessagePositionAndMaxWidth(e, i, r) {
    var n = this._columnsController.getFixedColumns();
    if (!(!n || !n.length)) {
      var a, o = !i && cOe(this, e.element), u = e.component.$content(), c = oi(u, !0), p = !i && c > o, v = this._rowsView.getCellIndex(E(e.element).closest("td")), _ = hOe(n);
      return !i && (v === _.startColumnIndex || p) ? a = {
        collision: "none flip",
        my: "top left",
        at: r ? "top right" : "bottom left"
      } : v === _.endColumnIndex && (a = {
        collision: "none flip",
        my: "top right",
        at: i || r ? "top left" : "bottom right"
      }, i && (a.offset = "-1 0")), a && {
        position: a,
        maxWidth: p ? o - 2 : void 0
      };
    }
  }
  _shiftValidationMessageIfNeed(e, i) {
    var r = this._revertTooltip && this._revertTooltip.$content();
    if (r) {
      var n = e.offset(), a = r.offset();
      if (n.top === a.top && n.left + mt(e) > a.left) {
        var o = mt(r) + rOe;
        e.css("left", a.left < i.offset().left ? -o : o);
      }
    }
  }
  _getRevertTooltipsSelector() {
    var e = this.addWidgetPrefix(HM);
    return ".dx-editor-cell .".concat(e);
  }
  _getValidationMessagesSelector() {
    var e = this.addWidgetPrefix(FP);
    return ".dx-editor-cell .".concat(e, ", .dx-cell-modified .").concat(e);
  }
  loseFocus(e) {
    e || this._validatingController.setValidator(null), super.loseFocus();
  }
  updateCellState(e, i, r) {
    var n, a = e == null ? void 0 : e.closest(this._getFocusCellSelector()), o = a != null && a.is("td") ? a : null, u = a == null ? void 0 : a.closest(".dx-row").data("options"), c = u ? this._editingController.getChangeByKey(u.key) : null, p = o && this._columnsController.getVisibleColumns()[o.index()], v = ((n = c == null ? void 0 : c.data) === null || n === void 0 ? void 0 : n[p == null ? void 0 : p.name]) !== void 0 && !this._editingController.isSaving(), _ = [];
    this._editingController.getEditMode() === wm && ((i == null ? void 0 : i.status) === No.invalid || v ? (this._showRevertButton(a), _.push(n2)) : this._revertTooltip && this._revertTooltip.$element().remove());
    var y = i && i.status === No.invalid;
    if (y && o && p && i && i.brokenRules) {
      var b = [];
      i.brokenRules.forEach((I) => {
        I.message && b.push(I.message);
      }), b.length && (this._showValidationMessage(a, b, p.alignment || "left"), _.push(i2));
    }
    this._updateAriaValidationAttributes(a, _), !r && this._rowsView.element() && this._rowsView.updateFreeSpaceRowHeight();
  }
  _updateAriaValidationAttributes(e, i) {
    if (i.length !== 0) {
      var r = this._editingController.getEditMode(), n = [wm, Jw, b8].includes(r);
      if (n) {
        var a = this._getCurrentFocusElement(e);
        a.attr("aria-labelledby", i.join(" ")), a.attr("aria-invalid", !0);
      }
    }
  }
  _getCurrentFocusElement(e) {
    return this._editingController.isEditing() ? e.find(YB).first() : e;
  }
  focus(e, i) {
    if (!arguments.length)
      return super.focus();
    if (this._hideValidationMessage(), e != null && e.hasClass("dx-row") || e != null && e.hasClass("dx-master-detail-cell"))
      return super.focus(e, i);
    var r = e == null ? void 0 : e.closest(this._getFocusCellSelector()), n = r && (r.data("dxValidator") || e.find(".".concat(this.addWidgetPrefix(E8))).eq(0).data("dxValidator")), a = r && r.closest(".dx-row").data("options"), o = a ? this._editingController.getChangeByKey(a.key) : null, u;
    if (n) {
      this._validatingController.setValidator(n);
      var c = n.option("adapter").getValue();
      if (T8(c, a) || this._validatingController._rowIsValidated(o))
        return this._editingController.waitForDeferredOperations().done(() => {
          var p = e.closest("tr").length === 0;
          p || $e(this._validatingController.validateCell(n)).done((v) => {
            u = v;
            var {
              column: _
            } = u.validator.option("dataGetter")();
            o && _ && !this._validatingController.isCurrentValidatorProcessing({
              rowKey: o.key,
              columnIndex: _.index
            }) || (!za(ho()) && u.status === No.invalid && (i = !0), this.updateCellState(e, u, i), super.focus.call(this, e, i));
          });
        }), super.focus(e, i);
    }
    return this.updateCellState(e, u, i), super.focus(e, i);
  }
  getEditorInstance(e) {
    var i = e.find(".dx-texteditor").eq(0);
    return xe.getWidgetInstance(i);
  }
}, pOe = (t) => class extends t {
  _getValidationStatus(e) {
    var i = ax(e) ? e.status : e;
    return i || No.valid;
  }
  _isCellChanged(e, i, r, n, a) {
    var o, u, c = (o = e.cells) === null || o === void 0 ? void 0 : o[n], p = this._getValidationStatus({
      status: c == null ? void 0 : c.validationStatus
    }), v = this._validatingController.getCellValidationResult({
      rowKey: e.key,
      columnIndex: n
    }), _ = this._validatingController._getValidationData(e.key), y = this._getValidationStatus(v), b = JSON.stringify(i.modifiedValues) !== JSON.stringify(e.modifiedValues), I = p !== y && b, A = E(c == null ? void 0 : c.cellElement).hasClass(this.addWidgetPrefix(S8)), L = (u = c == null ? void 0 : c.column.validationRules) === null || u === void 0 ? void 0 : u.length, B = e.isEditing !== i.isEditing && L, $ = I || _.isValid && A;
    return B || $ ? !0 : super._isCellChanged.apply(this, arguments);
  }
}, vOe = (t) => class extends t {
  updateFreeSpaceRowHeight(e) {
    var i, r, n, a = this.element(), o = a && a.find(".".concat(this.addWidgetPrefix(FP), " .dx-overlay-content"));
    if (super.updateFreeSpaceRowHeight(e), o && o.length && (i = this._getRowElements(), n = this._getFreeSpaceRowElements(e), r = n.first(), r && i.length === 1 && (!r.is(":visible") || jt(o) > jt(r))))
      return n.show(), Dh(n, jt(o)), !0;
  }
  _formItemPrepared(e, i) {
    super._formItemPrepared.apply(this, arguments), Na(() => {
      var r = i.find(".dx-widget").first(), n = r.length && !r.children().length;
      n || this._validatingController.createValidator(e, r);
    });
  }
  _cellPrepared(e, i) {
    this._editingController.isFormOrPopupEditMode() || this._validatingController.createValidator(i, e), super._cellPrepared.apply(this, arguments);
  }
  _restoreErrorRow(e) {
    this._editingController && this._editingController.hasChanges() && this._getRowElements(e).each((i, r) => {
      var n = E(r).data("options");
      if (n) {
        var a = this._editingController.getChangeByKey(n.key);
        a && this._editingController._showErrorRow(a);
      }
    });
  }
}, gOe = {
  defaultOptions: () => ({
    editing: {
      texts: {
        validationCancelChanges: X.format("dxDataGrid-validationCancelChanges")
      }
    }
  }),
  controllers: {
    validating: uOe
  },
  extenders: {
    controllers: {
      editing: dOe,
      editorFactory: fOe,
      data: pOe
    },
    views: {
      rowsView: vOe
    }
  }
};
et.registerModule("validating", gOe);
var zM = "scrolling.legacyMode", I8 = (t) => t.option("scrolling.loadTwoPagesOnStart") || t._controller.isVirtual() || t._controller.getViewportItemIndex() > 0, eT = (t) => t._cache.length ? t._cache[0].pageIndex : -1, BP = (t) => t._cache.length ? t._cache[t._cache.length - 1].pageIndex : -1, jT = (t, e, i) => {
  t._isChangedFiring = !0, e(i), t._isChangedFiring = !1;
}, l2 = (t, e, i) => {
  if (t._isDelayChanged)
    return t._isDelayChanged = !1, jT(t, e, i), !0;
}, mOe = (t) => {
  var e = t._dataOptions.pageSize(), i = t.option("scrolling.preventPreload");
  if (i)
    return 0;
  var r = t._controller.viewportSize();
  if (t._controller.isVirtualMode() && t.option("scrolling.removeInvisiblePages")) {
    r = 0;
    for (var n = t._controller.viewportSize() * t._controller.viewportItemSize(), a = t._controller.getContentOffset(), o = t._controller.getViewportPosition(), u = t._controller.virtualItemsCount(), c = t._dataOptions.totalItemsCount(), p = u.begin; p < c && !(a >= o + n); p++) {
      var v = t._controller.getItemSizes()[p] || t._controller.viewportItemSize();
      a += v, a >= o && r++;
    }
  }
  return e && r > 0 ? Math.ceil(r / e) : 1;
}, tT = (t, e) => {
  var i = t.option("scrolling.preloadEnabled"), r = mOe(t), n = t._controller.isAppendMode();
  return r && (e ? r = i ? 1 : 0 : (i && r++, (n || !I8(t)) && r--)), r;
}, _Oe = (t) => {
  var e = -1, i = eT(t), r = t._dataOptions;
  if (i < 0)
    e = t._pageIndex;
  else if (!t._cache[t._pageIndex - i])
    e = t._pageIndex;
  else if (i >= 0 && t._controller.viewportSize() >= 0) {
    if (i > 0) {
      var n = BP(t) + 1 === r.pageCount() && t._cache.length < tT(t) + 1, a = n || t._pageIndex === i && tT(t, !0);
      a && (e = i - 1);
    }
    if (e < 0) {
      var o = i + t._cache.length <= t._pageIndex + tT(t);
      o && (e = i + t._cache.length);
    }
  }
  return t._loadingPageIndexes[e] && (e = -1), e;
}, COe = (t, e) => {
  var i = t._dataOptions;
  if (e === t.pageIndex() || !i.isLoading() && e < i.pageCount() || !i.hasKnownLastPage() && e === i.pageCount())
    return i.pageIndex(e), t._loadingPageIndexes[e] = !0, $e(i.load()).always(() => {
      t._loadingPageIndexes[e] = !1;
    });
}, u2 = (t, e, i, r, n) => {
  var a = t._dataOptions, o = a.items().slice(), u = ct(i) ? i : void 0, c = i === "prepend", p = a.viewportItems();
  i && ht(i) && !t._isDelayChanged && (u = {
    changeType: i,
    items: o
  }, n && (u.removeCount = n.itemsCount, u.removeCount && a.correctCount && (u.removeCount = a.correctCount(p, u.removeCount, c))));
  var v = n ? n.itemsLength : 0;
  v && a.correctCount && (v = a.correctCount(p, v, c)), i === "append" ? (p.push.apply(p, o), n && p.splice(0, v)) : c ? (p.unshift.apply(p, o), n && p.splice(-v)) : t._dataOptions.viewportItems(o), a.updateLoading(), t._lastPageIndex = t.pageIndex(), t._isDelayChanged = r, r || jT(t, e, u);
};
class yOe {
  constructor(e, i) {
    this._dataOptions = i, this._controller = e, this._pageIndex = this._lastPageIndex = i.pageIndex(), this._cache = [], this._loadingPageIndexes = {};
  }
  option() {
    return this._controller.option.apply(this._controller, arguments);
  }
  viewportItemIndexChanged(e) {
    var i = this._dataOptions.pageSize(), r = this._dataOptions.pageCount(), n = this._controller.isVirtualMode(), a = this._controller.isAppendMode(), o = this._dataOptions.totalItemsCount(), u;
    if (i && (n || a) && o >= 0) {
      var c = this._controller.viewportSize();
      if (c && e + c >= o && !this._controller.isVirtual())
        if (this._dataOptions.hasKnownLastPage()) {
          u = r - 1;
          var p = o % i;
          u > 0 && p > 0 && p < c && u--;
        } else
          u = r;
      else {
        u = Math.floor(e / i);
        var v = r - 1;
        u = Math.max(u, 0), u = Math.min(u, v);
      }
      return this.pageIndex(u), this.load();
    }
  }
  pageIndex(e) {
    var i = this._controller.isVirtualMode(), r = this._controller.isAppendMode();
    return this.option(zM) !== !1 && (i || r) ? (e !== void 0 && (this._pageIndex = e), this._pageIndex) : this._dataOptions.pageIndex(e);
  }
  beginPageIndex(e) {
    var i = eT(this);
    return i < 0 && (i = e !== void 0 ? e : this.pageIndex()), i;
  }
  endPageIndex() {
    var e = BP(this);
    return e > 0 ? e : this._lastPageIndex;
  }
  pageSize() {
    return this._dataOptions.pageSize();
  }
  load() {
    var e = this._dataOptions, i, r = this._controller.isVirtualMode(), n = this._controller.isAppendMode();
    if (this.option(zM) !== !1 && (r || n)) {
      var a = _Oe(this);
      if (a >= 0) {
        var o = COe(this, a);
        o && (i = new q(), o.done(() => {
          var u = this._delayDeferred;
          u ? u.done(i.resolve).fail(i.reject) : i.resolve();
        }).fail(i.reject), e.updateLoading());
      }
    } else
      i = e.load();
    return !i && this._lastPageIndex !== this.pageIndex() && this._dataOptions.onChanged({
      changeType: "pageIndex"
    }), i || new q().resolve();
  }
  loadIfNeed() {
    var e = this._controller.isVirtualMode(), i = this._controller.isAppendMode();
    if ((e || i) && !this._dataOptions.isLoading() && (!this._isChangedFiring || this._controller.isVirtual())) {
      var r = this._controller.getViewportPosition();
      r > 0 ? this._controller._setViewportPositionCore(r) : this.load();
    }
  }
  handleDataChanged(e, i) {
    var r = this._dataOptions, n = this._cache.length, a, o, u = this._controller.isVirtualMode(), c = this._controller.isAppendMode();
    if (i && i.changes)
      jT(this, e, i);
    else if (this.option(zM) !== !1 && (u || c)) {
      var p = eT(this);
      if (p >= 0 && (u && p + this._cache.length !== r.pageIndex() && p - 1 !== r.pageIndex() && (n = 0, this._cache = []), c)) {
        if (r.pageIndex() === 0)
          this._cache = [];
        else if (r.pageIndex() < BP(this)) {
          jT(this, e, {
            changeType: "append",
            items: []
          });
          return;
        }
      }
      var v = {
        pageIndex: r.pageIndex(),
        itemsLength: r.items(!0).length,
        itemsCount: this.itemsCount(!0)
      };
      this.option("scrolling.removeInvisiblePages") && u ? o = this._cache.length > Math.max(tT(this) + (this.option("scrolling.preloadEnabled") ? 1 : 0), 2) : l2(this, e, {
        isDelayed: !0
      });
      var _;
      p === r.pageIndex() + 1 ? (o && (_ = this._cache.pop()), a = "prepend", this._cache.unshift(v)) : (o && (_ = this._cache.shift()), a = "append", this._cache.push(v));
      var y = u && n === 0 && I8(this);
      u2(this, e, this._cache.length > 1 ? a : void 0, y, _), this._delayDeferred = this.load().done(() => {
        l2(this, e) && this.load();
      });
    } else
      u2(this, e, i);
  }
  getDelayDeferred() {
    return this._delayDeferred;
  }
  itemsCount(e) {
    var i = 0, r = this._controller.isVirtualMode();
    return !e && r ? this._cache.forEach((n) => {
      i += n.itemsCount;
    }) : i = this._dataOptions.itemsCount(), i;
  }
  virtualItemsCount() {
    var e = eT(this);
    e < 0 && (e = this._dataOptions.pageIndex());
    var i = e * this._dataOptions.pageSize(), r = this._cache.length * this._dataOptions.pageSize(), n = Math.max(0, this._dataOptions.totalItemsCount() - r - i);
    return {
      begin: i,
      end: n
    };
  }
  reset() {
    this._loadingPageIndexes = {}, this._cache = [];
  }
}
var xOe = "infinite", D8 = "virtual", bw = "scrolling.legacyMode", d2 = (t) => t.option("scrolling.mode") === D8 || t._isVirtual, SOe = (t) => t.option("scrolling.mode") === xOe && !t._isVirtual;
function A8(t, e, i) {
  var r, n = [], a = [], o = [];
  i = i || t;
  function u(_) {
    var y = _.element ? _.$element() : _, b = kl.offset(y);
    return b ? _.scrollTop() - (b.top - t.offset().top) : t.offset().top;
  }
  var c = {
    on(_, y, b) {
      _.on("scroll", b);
    },
    off(_, y, b) {
      _.off("scroll", b);
    }
  };
  function p(_) {
    var y = _.get(0).nodeName === "#document", b = _.get(0).nodeType === Ot().Node.ELEMENT_NODE, I = _.data("dxScrollable"), A = c;
    if (!(!I && (I = y && E(Ot()) || b && _.css("overflowY") === "auto" && _, A = k, !I))) {
      var L = /* @__PURE__ */ function(B) {
        return function() {
          var $ = B.scrollTop() - u(B);
          $ = $ > 0 ? $ : 0, e($);
        };
      }(I);
      A.on(I, "scroll", L), a.push((B) => {
        var $ = u(I), K = I.scrollTo ? "scrollTo" : "scrollTop";
        B - $ >= 0 && I[K](B + $);
      }), n.push(I), o.push(() => {
        A.off(I, "scroll", L);
      });
    }
  }
  var v = (_) => {
    var y;
    return E((y = _.get(0).parentNode) !== null && y !== void 0 ? y : _.get(0).host);
  };
  for (r = i.parent(); r.length; r = v(r))
    p(r);
  return {
    scrollTo(_) {
      N(a, (y, b) => {
        b(_);
      });
    },
    dispose() {
      N(o, (_, y) => {
        y();
      });
    }
  };
}
class O8 {
  constructor(e, i, r) {
    this._dataOptions = i, this.component = e, this._viewportSize = e.option(bw) === !1 ? 15 : 0, this._viewportItemSize = 20, this._viewportItemIndex = 0, this._position = 0, this._isScrollingBack = !1, this._contentSize = 0, this._itemSizes = {}, this._sizeRatio = 1, this._isVirtual = r, this.positionChanged = ui(), this._dataLoader = new yOe(this, this._dataOptions);
  }
  getItemSizes() {
    return this._itemSizes;
  }
  option(e, i) {
    return this.component.option.apply(this.component, arguments);
  }
  isVirtual() {
    return this._isVirtual;
  }
  virtualItemsCount() {
    if (d2(this)) {
      var e = this._dataOptions, i = e.totalItemsCount();
      if (this.option(bw) === !1 && i !== -1) {
        var r = this.getViewportParams(), n = e.loadedOffset(), a = e.loadedItemCount(), o = Math.max(r.skip, n), u = Math.min(r.take, a), c = Math.max(i - (o + u), 0);
        return {
          begin: o,
          end: c
        };
      }
      return this._dataLoader.virtualItemsCount.apply(this._dataLoader, arguments);
    }
  }
  getScrollingTimeout() {
    var e, i = this.option("scrolling.renderAsync"), r = 0;
    return R(i) ? i && (r = (e = this.option("scrolling.timeout")) !== null && e !== void 0 ? e : 0) : (r = Math.min(this.option("scrolling.timeout") || 0, this._dataOptions.changingDuration()), r < this.option("scrolling.renderingThreshold") && (r = this.option("scrolling.minTimeout") || 0)), r;
  }
  setViewportPosition(e) {
    var i = new q(), r = this.getScrollingTimeout();
    return clearTimeout(this._scrollTimeoutID), r > 0 ? this._scrollTimeoutID = setTimeout(() => {
      this._setViewportPositionCore(e), i.resolve();
    }, r) : (this._setViewportPositionCore(e), i.resolve()), i.promise();
  }
  getViewportPosition() {
    return this._position;
  }
  getItemIndexByPosition(e, i, r) {
    e = e ?? this._position;
    for (var n = this.getItemSize(), a = 0, o = 0, u = Object.keys(this._itemSizes).concat(-1), c = 0; c < u.length && a < e; c++) {
      var p = parseInt(u[c]), v = (e - a) / n;
      if (p < 0 || o + v < p) {
        o += v, this._sizeRatio < 1 && R(i) && (o = i + r / this._viewportItemSize);
        break;
      } else
        v = p - o, a += v * n, o += v;
      var _ = this._itemSizes[p];
      a += _, o += a < e ? 1 : (e - a + _) / _;
    }
    return Math.round(50 * o) / 50;
  }
  isScrollingBack() {
    return this._isScrollingBack;
  }
  _setViewportPositionCore(e) {
    var i = this._position || 0;
    this._position = e, i !== this._position && (this._isScrollingBack = this._position < i);
    var r = this.getItemIndexByPosition(), n = this.setViewportItemIndex(r);
    return this.positionChanged.fire(), n;
  }
  setContentItemSizes(e) {
    var i = this.virtualItemsCount();
    if (this._contentSize = e.reduce((a, o) => a + o, 0), i) {
      e.forEach((a, o) => {
        this._itemSizes[i.begin + o] = a;
      });
      var r = (i.begin + i.end + this.itemsCount()) * this._viewportItemSize, n = xe.getContentHeightLimit($i);
      r > n ? this._sizeRatio = n / r : this._sizeRatio = 1;
    }
  }
  getItemSize() {
    return this._viewportItemSize * this._sizeRatio;
  }
  getItemOffset(e, i) {
    var r = this.virtualItemsCount(), n = e;
    if (!r)
      return 0;
    var a = 0, o = this._dataOptions.totalItemsCount();
    return Object.keys(this._itemSizes).forEach((u) => {
      n && (i ? u >= o - e : u < e) && (a += this._itemSizes[u], n--);
    }), Math.floor(a + n * this._viewportItemSize * this._sizeRatio);
  }
  getContentOffset(e) {
    var i = e === "end", r = this.virtualItemsCount();
    return r ? this.getItemOffset(i ? r.end : r.begin, i) : 0;
  }
  getVirtualContentSize() {
    var e = this.virtualItemsCount();
    return e ? this.getContentOffset("begin") + this.getContentOffset("end") + this._contentSize : 0;
  }
  getViewportItemIndex() {
    return this._viewportItemIndex;
  }
  setViewportItemIndex(e) {
    if (this._viewportItemIndex = e, this.option(bw) !== !1)
      return this._dataLoader.viewportItemIndexChanged.apply(this._dataLoader, arguments);
  }
  viewportItemSize(e) {
    return e !== void 0 && (this._viewportItemSize = e), this._viewportItemSize;
  }
  viewportSize(e) {
    return e !== void 0 && (this._viewportSize = e), this._viewportSize;
  }
  viewportHeight(e, i) {
    var r = i ?? this._position, n = this.getItemIndexByPosition(r), a = this.getItemIndexByPosition(r + e, n, e);
    this.viewportSize(Math.ceil(a - n)), !R(i) && this._viewportItemIndex !== n && this._setViewportPositionCore(r);
  }
  reset(e) {
    this._dataLoader.reset(), e || (this._itemSizes = {});
  }
  subscribeToWindowScrollEvents(e) {
    this._windowScroll = this._windowScroll || A8(e, (i) => {
      this.viewportItemSize() && this.setViewportPosition(i);
    });
  }
  dispose() {
    clearTimeout(this._scrollTimeoutID), this._windowScroll && this._windowScroll.dispose(), this._windowScroll = null;
  }
  scrollTo(e) {
    this._windowScroll && this._windowScroll.scrollTo(e);
  }
  isVirtualMode() {
    return d2(this);
  }
  isAppendMode() {
    return SOe(this);
  }
  getViewportParams() {
    var e, i = this.option("scrolling.mode") === D8, r = this._dataOptions.totalItemsCount(), n = this._dataOptions.hasKnownLastPage(), a = n && this._viewportItemIndex > r ? r : this._viewportItemIndex, o = this._viewportSize + a, u = this.option("scrolling.prerenderedRowChunkSize") || 1, c = this.isScrollingBack(), p = (e = this.option("scrolling.prerenderedRowCount")) !== null && e !== void 0 ? e : 1, v = c ? p : 0, _ = c ? 0 : p, y = Math.floor(Math.max(0, a - v) / u) * u, b = Math.ceil((o + _ - y) / u) * u;
    if (i) {
      var I = Math.max(0, r - y);
      b = Math.min(b, I);
    }
    return {
      skip: y,
      take: b
    };
  }
  itemsCount() {
    var e = 0;
    return this.option(bw) ? e = this._dataLoader.itemsCount.apply(this._dataLoader, arguments) : e = this._dataOptions.itemsCount(), e;
  }
  pageIndex() {
    return this._dataLoader.pageIndex(...arguments);
  }
  beginPageIndex() {
    return this._dataLoader.beginPageIndex(...arguments);
  }
  endPageIndex() {
    return this._dataLoader.endPageIndex(...arguments);
  }
  pageSize() {
    return this._dataLoader.pageSize(...arguments);
  }
  load() {
    return this._dataLoader.load(...arguments);
  }
  loadIfNeed() {
    return this._dataLoader.loadIfNeed(...arguments);
  }
  handleDataChanged() {
    return this._dataLoader.handleDataChanged(...arguments);
  }
  getDelayDeferred() {
    return this._dataLoader.getDelayDeferred();
  }
}
var c2 = "bottom-load-panel", EOe = "group-space", R8 = "dx-freespace-row", bOe = "dx-column-lines", ww = "dx-virtual-row", wOe = "dx-row-inserted", TOe = "infinite", IOe = "virtual", L8 = 300, Zt = "scrolling.legacyMode", WM = "paging.pageIndex", DOe = ["beginPageIndex", "endPageIndex", "pageIndex"], $a = function(t) {
  return t.option("scrolling.mode") === IOe;
}, Ru = function(t) {
  return t.option("scrolling.mode") === TOe;
}, Al = function(t) {
  return $a(t) || Ru(t);
}, h2 = function(t, e, i, r) {
  for (var n = 0; n < e + 1; n++) {
    var a = t[i ? t.length - 1 - n : n];
    a && !r(a, n === e, i) && e++;
  }
  return e;
}, iT = function(t, e) {
  return t.rowType === "data" && !t.isNewRow || t.rowType === "group" && e.isGroupItemCountable(t.data);
}, AOe = function(t) {
  return t.forEach((e, i) => {
    e.rowIndex = i;
  }), t;
}, UM = function(t) {
  var e = t._virtualScrollController.beginPageIndex(-1);
  $a(t) && (e < 0 || t.viewportSize() >= 0 && t.getViewportItemIndex() >= 0 && (e * t.pageSize() > t.getViewportItemIndex() || e * t.pageSize() + t.itemsCount() < t.getViewportItemIndex() + t.viewportSize()) && t._dataSource.isLoading() ? t._isLoading || (t._isLoading = !0, t.loadingChanged.fire(!0)) : t._isLoading && (t._isLoading = !1, t.loadingChanged.fire(!1)));
}, Fa = function(t, e, i) {
  if (t.option(Zt) === !1 && DOe.includes(e)) {
    var r = t._dataSource;
    return r.pageIndex.apply(r, i);
  }
  var n = t._virtualScrollController;
  return n[e].apply(n, i);
}, f2 = function(t, e) {
  var i = t.toArray().map((a) => E(a).parent(".".concat(e)).get(0)).filter((a) => a);
  i.length && (t = E(i));
  for (var r = e === R8 ? t.length - 1 : t.length, n = 0; n < r; n++)
    t.eq(n).remove();
}, OOe = (t) => class extends t {
  init() {
    super.init.apply(this, arguments), this._items = [], this._totalCount = -1, this._isLoaded = !0, this._loadPageCount = 1, this._virtualScrollController = new O8(this.component, this._getVirtualScrollDataOptions());
  }
  dispose() {
    this._virtualScrollController.dispose(), super.dispose.apply(this, arguments);
  }
  _getVirtualScrollDataOptions() {
    var e = this;
    return {
      pageSize: () => e.pageSize(),
      totalItemsCount: () => e.totalItemsCount(),
      hasKnownLastPage: () => e.hasKnownLastPage(),
      pageIndex: (i) => e._dataSource.pageIndex(i),
      isLoading: () => e._dataSource.isLoading() && !e.isCustomLoading(),
      pageCount: () => e.pageCount(),
      load: () => e._dataSource.load(),
      updateLoading() {
        UM(e);
      },
      itemsCount: () => e.itemsCount(!0),
      items: () => e._dataSource.items(),
      viewportItems(i) {
        return i && (e._items = i), e._items;
      },
      onChanged(i) {
        e.changed.fire(i);
      },
      changingDuration() {
        return e.isLoading() ? L8 : e._renderTime || 0;
      }
    };
  }
  _handleLoadingChanged(e) {
    if (this.option(Zt) === !1) {
      super._handleLoadingChanged.apply(this, arguments);
      return;
    }
    (!$a(this) || this._isLoadingAll) && (this._isLoading = e, super._handleLoadingChanged.apply(this, arguments)), e ? this._startLoadTime = /* @__PURE__ */ new Date() : this._startLoadTime = void 0;
  }
  _handleLoadError() {
    this.option(Zt) !== !1 && (this._isLoading = !1, this.loadingChanged.fire(!1)), super._handleLoadError.apply(this, arguments);
  }
  _handleDataChanged(e) {
    if (this.option(Zt) === !1) {
      this._items = this._dataSource.items().slice(), this._totalCount = this._dataSourceTotalCount(!0), super._handleDataChanged.apply(this, arguments);
      return;
    }
    var i = super._handleDataChanged.bind(this);
    this._virtualScrollController.handleDataChanged(i, e);
  }
  _customizeRemoteOperations(e, i) {
    var r = this.option(Zt) === !1, n = this.option("scrolling.renderAsync");
    R(n) || (n = this._renderTime >= this.option("scrolling.renderingThreshold")), ($a(this) || Ru(this) && r) && !i.reload && (i.skip || r) && !n && (e.delay = void 0), super._customizeRemoteOperations.apply(this, arguments);
  }
  items() {
    return this._items;
  }
  _dataSourceTotalCount(e) {
    return this.option(Zt) === !1 && $a(this) && !e ? this._totalCount : super._dataSourceTotalCount();
  }
  itemsCount(e) {
    return e || this.option(Zt) === !1 ? super.itemsCount() : this._virtualScrollController.itemsCount();
  }
  load(e) {
    return this.option(Zt) === !1 || e ? super.load(e) : this._virtualScrollController.load();
  }
  isLoading() {
    return this.option(Zt) === !1 ? this._dataSource.isLoading() : this._isLoading;
  }
  isLoaded() {
    return this._dataSource.isLoaded() && this._isLoaded;
  }
  resetPagesCache(e) {
    e || this._virtualScrollController.reset(!0), super.resetPagesCache.apply(this, arguments);
  }
  _changeRowExpandCore() {
    var e = super._changeRowExpandCore.apply(this, arguments);
    return this.option(Zt) === !1 || (this.resetPagesCache(), UM(this)), e;
  }
  reload() {
    this._dataSource.pageIndex(this.pageIndex());
    var e = this._virtualScrollController;
    if (this.option(Zt) !== !1 && e) {
      var i = new q();
      return super.reload.apply(this, arguments).done((r) => {
        var n = e.getDelayDeferred();
        n ? n.done(i.resolve).fail(i.reject) : i.resolve(r);
      }).fail(i.reject), i;
    }
    return super.reload.apply(this, arguments);
  }
  refresh(e, i) {
    if (this.option(Zt) !== !1) {
      var {
        storeLoadOptions: r
      } = e, n = this._dataSource;
      i.reload ? (this._virtualScrollController.reset(), n.items().length = 0, this._isLoaded = !1, UM(this), this._isLoaded = !0, Ru(this) ? (this.pageIndex(0), n.pageIndex(0), r.pageIndex = 0, e.pageIndex = 0, r.skip = 0) : (n.pageIndex(this.pageIndex()), n.paginate() && (e.pageIndex = this.pageIndex(), r.skip = this.pageIndex() * this.pageSize()))) : Ru(this) && r.skip && this._totalCountCorrection < 0 && (r.skip += this._totalCountCorrection);
    }
    return super.refresh.apply(this, arguments);
  }
  loadPageCount(e) {
    if (!R(e))
      return this._loadPageCount;
    this._loadPageCount = e;
  }
  _handleDataLoading(e) {
    var i = this.loadPageCount(), r = this.pageSize(), n = this.option(Zt) === !1, {
      storeLoadOptions: a
    } = e, o = R(a.take);
    e.loadPageCount = i, !e.isCustomLoading && n && o && i > 1 && r > 0 && (a.take = i * r), super._handleDataLoading.apply(this, arguments);
  }
  _loadPageSize() {
    return super._loadPageSize.apply(this, arguments) * this.loadPageCount();
  }
  beginPageIndex() {
    return Fa(this, "beginPageIndex", [...arguments]);
  }
  endPageIndex() {
    return Fa(this, "endPageIndex", [...arguments]);
  }
  pageIndex(e) {
    return Fa(this, "pageIndex", [...arguments]);
  }
  virtualItemsCount() {
    return Fa(this, "virtualItemsCount", [...arguments]);
  }
  getContentOffset() {
    return Fa(this, "getContentOffset", [...arguments]);
  }
  getVirtualContentSize() {
    return Fa(this, "getVirtualContentSize", [...arguments]);
  }
  setContentItemSizes() {
    return Fa(this, "setContentItemSizes", [...arguments]);
  }
  setViewportPosition() {
    return Fa(this, "setViewportPosition", [...arguments]);
  }
  getViewportItemIndex() {
    return Fa(this, "getViewportItemIndex", [...arguments]);
  }
  setViewportItemIndex(e) {
    return Fa(this, "setViewportItemIndex", [...arguments]);
  }
  getItemIndexByPosition() {
    return Fa(this, "getItemIndexByPosition", [...arguments]);
  }
  viewportSize() {
    return Fa(this, "viewportSize", [...arguments]);
  }
  viewportItemSize() {
    return Fa(this, "viewportItemSize", [...arguments]);
  }
  getItemSize() {
    return Fa(this, "getItemSize", [...arguments]);
  }
  getItemSizes() {
    return Fa(this, "getItemSizes", [...arguments]);
  }
  loadIfNeed() {
    return Fa(this, "loadIfNeed", [...arguments]);
  }
}, ROe = (t) => class extends t {
  dispose() {
    var e = this._rowsScrollController;
    e && e.dispose(), super.dispose.apply(this, arguments);
  }
  _refreshDataSource() {
    var e = super._refreshDataSource.apply(this, arguments) || new q().resolve().promise();
    return e.done(this.initVirtualRows.bind(this)), e;
  }
  _loadDataSource() {
    var e;
    if (this._rowsScrollController && Al(this)) {
      var {
        loadPageCount: i
      } = R(this._loadViewportParams) ? this.getLoadPageParams() : {
        loadPageCount: 0
      };
      i >= 1 && ((e = this._dataSource) === null || e === void 0 || e.loadPageCount(i));
    }
    return super._loadDataSource.apply(this, arguments);
  }
  getRowPageSize() {
    var e = this.option("scrolling.rowPageSize"), i = this.pageSize();
    return i && i < e ? i : e;
  }
  reload() {
    var e = this._rowsScrollController || this._dataSource, i = e && e.getItemIndexByPosition(), r = super.reload.apply(this, arguments);
    return r && r.done(() => {
      var n, a;
      if ($a(this) || xe.isVirtualRowRendering(this)) {
        var o = this.getRowIndexOffset(), u = Math.floor(i) - o, {
          component: c
        } = this, p = c.getScrollable && c.getScrollable(), v = this.dataSource().operationTypes().sorting;
        if (p && !v && u >= 0) {
          var _ = c.getRowElement(u), y = _ && _[0] && E(_[0]), b = y && ((n = y.position()) === null || n === void 0 ? void 0 : n.top), I = $i.chrome && Number((a = $i.version) !== null && a !== void 0 ? a : 0) >= 91, A = $i.mozilla || I ? 1 : 0;
          b && b > A && (b = Math.round(b + jt(y) * (i % 1)), p.scrollTo({
            y: b
          }));
        }
      }
    });
  }
  initVirtualRows() {
    var e = xe.isVirtualRowRendering(this);
    if (this._allItems = null, this._loadViewportParams = null, this.option("scrolling.mode") !== "virtual" && !e || !e || this.option(Zt) !== !1 && !this.option("scrolling.rowPageSize")) {
      this._visibleItems = null, this._rowsScrollController = null;
      return;
    }
    var i = !$a(this) && this.pageIndex() >= this.pageCount() ? this.pageCount() - 1 : this.pageIndex();
    this._rowPageIndex = Math.ceil(i * this.pageSize() / this.getRowPageSize()), this._visibleItems = this.option(Zt) === !1 ? null : [], this._viewportChanging = !1, this._needUpdateViewportAfterLoading = !1, this._rowsScrollController || (this._rowsScrollController = new O8(this.component, this._getRowsScrollDataOptions(), !0), this._rowsScrollController.positionChanged.add(() => {
      var r;
      if (this.option(Zt) === !1) {
        this._viewportChanging = !0, this.loadViewport(), this._viewportChanging = !1;
        return;
      }
      (r = this._dataSource) === null || r === void 0 || r.setViewportItemIndex(this._rowsScrollController.getViewportItemIndex());
    })), this.option(Zt) === !1 && this._updateLoadViewportParams(), this.isLoaded() && this.option(Zt) !== !1 && this._rowsScrollController.load();
  }
  isViewportChanging() {
    return this._viewportChanging;
  }
  _getRowsScrollDataOptions() {
    var e = this, i = function(r) {
      return iT(r, e._dataSource);
    };
    return {
      pageSize: () => e.getRowPageSize(),
      loadedOffset() {
        var r;
        return $a(e) && ((r = e._dataSource) === null || r === void 0 ? void 0 : r.lastLoadOptions().skip) || 0;
      },
      loadedItemCount: () => e._itemCount,
      totalItemsCount() {
        return Al(e) ? e.totalItemsCount() : e.option(Zt) === !1 ? e._itemCount : e._items.filter(i).length;
      },
      hasKnownLastPage: () => e.option(Zt) === !1 ? e.hasKnownLastPage() : !0,
      pageIndex(r) {
        return r !== void 0 && (e._rowPageIndex = r), e._rowPageIndex;
      },
      isLoading: () => e.isLoading(),
      pageCount() {
        var r = Math.ceil(this.totalItemsCount() / this.pageSize());
        return r || 1;
      },
      load() {
        e._rowsScrollController.pageIndex() >= this.pageCount() && (e._rowPageIndex = this.pageCount() - 1, e._rowsScrollController.pageIndex(e._rowPageIndex)), !(!this.items().length && this.totalItemsCount()) && e._rowsScrollController.handleDataChanged((r) => {
          r = r || {}, r.changeType = r.changeType || "refresh", r.items = r.items || e._visibleItems, e._visibleItems.forEach((n, a) => {
            n.rowIndex = a;
          }), e._fireChanged(r);
        });
      },
      updateLoading() {
      },
      itemsCount() {
        return this.items(!0).length;
      },
      correctCount: (r, n, a) => h2(r, n, a, (o, u, c) => o.isNewRow ? u && !c : u && c ? !o.isNewRow : i(o)),
      items(r) {
        var n = e._items;
        if (e.option(Zt)) {
          var a = e.dataSource(), o = a == null ? void 0 : a.virtualItemsCount(), u = o ? o.begin : 0, c = e.getRowPageSize(), p = e._rowPageIndex * c - u, v = c;
          if (p < 0)
            return [];
          p && (p = this.correctCount(n, p), n = n.slice(p)), v && (v = this.correctCount(n, v), n = n.slice(0, v));
        }
        return r ? n.filter(i) : n;
      },
      viewportItems(r) {
        return r && e.option(Zt) !== !1 && (e._visibleItems = r), e._visibleItems;
      },
      onChanged() {
      },
      changingDuration() {
        var r = e.dataSource();
        return r != null && r.isLoading() && e.option(Zt) !== !1 ? L8 : (r == null ? void 0 : r._renderTime) || 0;
      }
    };
  }
  _updateItemsCore(e) {
    var i = this.getRowIndexDelta();
    if (super._updateItemsCore.apply(this, arguments), this.option(Zt) === !1 && xe.isVirtualRowRendering(this)) {
      e.changeType === "update" && e.rowIndices.length === 0 && e.cancelEmptyChanges && (e.cancel = !0);
      return;
    }
    var r = this._rowsScrollController;
    if (r) {
      var n = this._visibleItems, a = e.changeType === "refresh" || e.isLiveUpdate;
      if (e.changeType === "append" && e.items && !e.items.length)
        return;
      a || e.changeType === "append" || e.changeType === "prepend" ? (e.cancel = !0, a && r.reset(!0), r.load()) : (e.changeType === "update" ? e.rowIndices.forEach((o, u) => {
        var c = e.changeTypes[u], p = e.items[u];
        c === "update" ? n[o] = p : c === "insert" ? n.splice(o, 0, p) : c === "remove" && n.splice(o, 1);
      }) : (n.forEach((o, u) => {
        n[u] = this._items[u + i] || n[u];
      }), e.items = n), AOe(n));
    }
  }
  _updateLoadViewportParams() {
    var e = this._rowsScrollController.getViewportParams(), i = this.pageSize();
    if (e && !Al(this) && i > 0) {
      var r = this.pageIndex() * i;
      e.skip += r;
    }
    this._loadViewportParams = e;
  }
  _processItems() {
    var e, i = super._processItems.apply(this, arguments);
    if (this.option(Zt) === !1) {
      var r = this._dataSource, n = (e = r == null ? void 0 : r.lastLoadOptions().skip) !== null && e !== void 0 ? e : 0, a, o, u, c = !1, p = [];
      i.forEach((v) => {
        var {
          rowType: _
        } = v, y = iT(v, r), b = _ === "group" && (a || y || o !== "group" && n > 0), I = _ === "data" && y && (a || o !== "group");
        if (!v.isNewRow && R(a)) {
          var A = u && !c;
          (b || I) && !A && n++;
        }
        (b || I) && (c = !0), v.isNewRow ? p.push(v) : (p.forEach((L) => {
          L.loadIndex = n;
        }), p = []), v.loadIndex = n, a = y, o = _, u = v.isNewRow;
      }), p.forEach((v) => {
        v.loadIndex = n;
      });
    }
    return i;
  }
  _afterProcessItems(e) {
    if (this._itemCount = e.filter((o) => iT(o, this._dataSource)).length, R(this._loadViewportParams)) {
      this._updateLoadViewportParams();
      var i = e;
      if (this._allItems = e, e.length) {
        var {
          skipForCurrentPage: r
        } = this.getLoadPageParams(!0), n = e[0].loadIndex + r, {
          take: a
        } = this._loadViewportParams;
        i = e.filter((o) => {
          var u = o.isNewRow && o.loadIndex === n && a === 0, c = o.loadIndex >= n, p = o.loadIndex < n + a || u;
          return c && p;
        });
      }
      return i;
    }
    return super._afterProcessItems.apply(this, arguments);
  }
  _applyChange(e) {
    var i = this, {
      items: r
    } = e, {
      changeType: n
    } = e, {
      removeCount: a
    } = e;
    if (a) {
      var o = n === "prepend";
      a = h2(i._items, a, o, (u, c) => u.rowType === "data" && !u.isNewRow || u.rowType === "group" && (i._dataSource.isGroupItemCountable(u.data) || c)), e.removeCount = a;
    }
    switch (n) {
      case "prepend":
        i._items.unshift.apply(i._items, r), a && i._items.splice(-a);
        break;
      case "append":
        i._items.push.apply(i._items, r), a && i._items.splice(0, a);
        break;
      default:
        super._applyChange(e);
    }
  }
  items(e) {
    return e ? this._allItems || this._items : this._visibleItems || this._items;
  }
  getRowIndexDelta() {
    var e = 0;
    if (this.option(Zt)) {
      var i = this._visibleItems;
      i && i[0] && (e = this._items.indexOf(i[0]));
    }
    return e < 0 ? 0 : e;
  }
  getRowIndexOffset(e, i) {
    var r, n, a = 0, o = this.dataSource(), u = this._rowsScrollController, c = this.option(Zt) === !1, p = Al(this);
    if (u && !e)
      if (c && R(this._loadViewportParams)) {
        var {
          skipForCurrentPage: v,
          pageIndex: _
        } = this.getLoadPageParams(!0), y = this.items(!0);
        if (a = p ? _ * this.pageSize() : 0, y.length) {
          var b = y[0].loadIndex;
          a += y.filter((A) => A.loadIndex < b + v).length;
        }
      } else
        a = u.beginPageIndex() * u.pageSize();
    else if (p && c && o) {
      var I = o.lastLoadOptions();
      i && (!((r = I.skips) === null || r === void 0) && r.length) ? a = I.skips.reduce((A, L) => A + L, 0) : a = (n = I.skip) !== null && n !== void 0 ? n : 0;
    } else
      $a(this) && o && (a = o.beginPageIndex() * o.pageSize());
    return a;
  }
  getDataIndex() {
    return this.option(Zt) === !1 ? this.getRowIndexOffset(!0, !0) : super.getDataIndex.apply(this, arguments);
  }
  viewportSize() {
    var e = this._rowsScrollController, i = this._dataSource, r = e == null ? void 0 : e.viewportSize.apply(e, arguments);
    return this.option(Zt) === !1 ? r : i == null ? void 0 : i.viewportSize.apply(i, arguments);
  }
  viewportHeight(e, i) {
    var r;
    (r = this._rowsScrollController) === null || r === void 0 || r.viewportHeight(e, i);
  }
  viewportItemSize() {
    var e = this._rowsScrollController, i = this._dataSource, r = e == null ? void 0 : e.viewportItemSize.apply(e, arguments);
    return this.option(Zt) === !1 ? r : i == null ? void 0 : i.viewportItemSize.apply(i, arguments);
  }
  setViewportPosition() {
    var e = this._rowsScrollController, i = this._dataSource;
    this._isPaging = !1, e ? e.setViewportPosition.apply(e, arguments) : i == null || i.setViewportPosition.apply(i, arguments);
  }
  setContentItemSizes(e) {
    var i = this._rowsScrollController, r = this._dataSource, n = i == null ? void 0 : i.setContentItemSizes(e);
    return this.option(Zt) === !1 ? n : r == null ? void 0 : r.setContentItemSizes(e);
  }
  getPreloadedRowCount() {
    var e = this.option("scrolling.preloadedRowCount"), i = this.option("scrolling.preloadEnabled");
    if (R(e))
      return e;
    var r = this.viewportSize();
    return i ? 2 * r : r;
  }
  getLoadPageParams(e) {
    var i, r, n = this.pageSize(), a = this._loadViewportParams, o = (i = this._dataSource) === null || i === void 0 ? void 0 : i.lastLoadOptions(), u = (o == null ? void 0 : o.pageIndex) || 0, c = (o == null ? void 0 : o.take) || 0, p = this._rowsScrollController.isScrollingBack(), v = p ? this.getPreloadedRowCount() : 0, _ = p ? 0 : this.getPreloadedRowCount(), y = ((r = this._dataSource) === null || r === void 0 ? void 0 : r.totalCountCorrection()) || 0, b = Math.max(0, a.skip - v), I = e ? u : Math.floor(n ? b / n : 0), A = I * n, L = a.skip - A, B = a.take + L + _ - y, $ = e ? c : B, K = Math.ceil(n ? $ / n : 0);
    return {
      pageIndex: I,
      loadPageCount: Math.max(1, K),
      skipForCurrentPage: Math.max(0, L)
    };
  }
  _updateVisiblePageIndex(e) {
    if (this._rowsScrollController) {
      if (R(e)) {
        this._silentOption(WM, e), this.pageChanged.fire();
        return;
      }
      var i = this._rowsScrollController.getViewportItemIndex(), r = Math.floor(i / this.pageSize());
      this.pageIndex() !== r && (this._silentOption(WM, r), this.updateItems({
        changeType: "pageIndex"
      }));
    }
  }
  _getChangedLoadParams() {
    var e = this.getLoadPageParams(!0), {
      pageIndex: i,
      loadPageCount: r
    } = this.getLoadPageParams(), n = this._pageIndexIsValid(i), a = null;
    return !this._isLoading && n && (i !== e.pageIndex || r !== e.loadPageCount) && (a = {
      pageIndex: i,
      loadPageCount: r
    }), a;
  }
  _pageIndexIsValid(e) {
    var i = !0;
    return (Ru(this) && this.hasKnownLastPage() || $a(this)) && (i = e * this.pageSize() < this.totalItemsCount()), i;
  }
  _loadItems(e, i) {
    var r, n, a = Al(this), o = this._dataSource, u = this._getChangedLoadParams(), c = (r = o == null ? void 0 : o.loadPageCount()) !== null && r !== void 0 ? r : 0, p = this.pageSize() * c, v = (n = o == null ? void 0 : o.pageIndex()) !== null && n !== void 0 ? n : 0, _ = (u == null ? void 0 : u.pageIndex) === v, y = Ru(this) && this.totalItemsCount() < p, b = this.option("editing.refreshMode") === "repaint", I = (u == null ? void 0 : u.pageIndex) > v, A = !1;
    if (!o || a && e && (b && i || I || _ && y))
      return A;
    if (a && this._isLoading && (this._needUpdateViewportAfterLoading = !0), a && u) {
      A = !0, o.pageIndex(u.pageIndex), o.loadPageCount(u.loadPageCount), this._repaintChangesOnly = !0, this._needUpdateDimensions = !0;
      var L = this._viewportChanging;
      this.load().always(() => {
        this._repaintChangesOnly = void 0, this._needUpdateDimensions = void 0;
      }).done(() => {
        var B = this.pageCount() > 0 && this.pageIndex() === this.pageCount() - 1;
        (L || B) && this._updateVisiblePageIndex(), this._needUpdateViewportAfterLoading && (this._needUpdateViewportAfterLoading = !1, this.loadViewport({
          checkLoadedParamsOnly: !0
        }));
      });
    }
    return A;
  }
  loadViewport(e) {
    var i, r, n, {
      checkLoadedParamsOnly: a,
      checkLoading: o,
      viewportIsNotFilled: u
    } = e ?? {}, c = Al(this);
    if (c || xe.isVirtualRowRendering(this)) {
      this._updateLoadViewportParams();
      var p = this._loadItems(o, !u), v = (i = this._dataSource) === null || i === void 0 ? void 0 : i.isCustomLoading(), _ = o && !v && this._isLoading, y = !(p || _ || a);
      if (y) {
        var b = !(!((n = (r = this._editingController) === null || r === void 0 ? void 0 : r.getChanges()) === null || n === void 0) && n.length);
        this.updateItems({
          repaintChangesOnly: !0,
          needUpdateDimensions: !0,
          useProcessedItemsCache: b,
          cancelEmptyChanges: !0
        });
      }
    }
  }
  updateViewport() {
    var e, i, r = this.viewportSize(), n = this.items().length, a = r > n, o = (i = (e = this._loadViewportParams) === null || e === void 0 ? void 0 : e.take) !== null && i !== void 0 ? i : 0, u = this._rowsScrollController, c = u == null ? void 0 : u.getViewportParams().take;
    (a || o < c) && !this._isPaging && n && this.loadViewport({
      checkLoading: !0,
      viewportIsNotFilled: a
    });
  }
  loadIfNeed() {
    if (this.option(Zt) !== !1) {
      var e = this._rowsScrollController;
      e && e.loadIfNeed();
      var i = this._dataSource;
      return i && i.loadIfNeed();
    }
  }
  getItemSize() {
    var e = this._rowsScrollController;
    if (e)
      return e.getItemSize.apply(e, arguments);
    var i = this._dataSource;
    return i && i.getItemSize.apply(i, arguments);
  }
  getItemSizes() {
    var e = this._rowsScrollController;
    if (e)
      return e.getItemSizes.apply(e, arguments);
    var i = this._dataSource;
    return i && i.getItemSizes.apply(i, arguments);
  }
  getContentOffset() {
    var e = this._rowsScrollController;
    if (e)
      return e.getContentOffset.apply(e, arguments);
    var i = this._dataSource;
    return i && i.getContentOffset.apply(i, arguments);
  }
  refresh(e) {
    var i = this._dataSource;
    return i && e && e.load && Ru(this) && i.resetCurrentTotalCount(), super.refresh.apply(this, arguments);
  }
  topItemIndex() {
    var e;
    return (e = this._loadViewportParams) === null || e === void 0 ? void 0 : e.skip;
  }
  bottomItemIndex() {
    var e = this._loadViewportParams;
    return e && e.skip + e.take;
  }
  virtualItemsCount() {
    var e = this._rowsScrollController;
    if (e)
      return e.virtualItemsCount.apply(e, arguments);
    var i = this._dataSource;
    return i == null ? void 0 : i.virtualItemsCount.apply(i, arguments);
  }
  pageIndex(e) {
    var i, r = Al(this), n = this._rowsScrollController;
    return this.option(Zt) === !1 && r && n && e === void 0 ? (i = this.option(WM)) !== null && i !== void 0 ? i : 0 : super.pageIndex.apply(this, arguments);
  }
  _fireChanged(e) {
    super._fireChanged.apply(this, arguments);
    var {
      operationTypes: i
    } = e;
    if (this.option(Zt) === !1 && Al(this) && i) {
      var {
        fullReload: r,
        pageIndex: n
      } = i;
      e.isDataChanged && !r && n && this._updateVisiblePageIndex(this._dataSource.pageIndex());
    }
  }
  _getPagingOptionValue(e) {
    var i = super._getPagingOptionValue.apply(this, arguments);
    return this.option(Zt) === !1 && Al(this) && (i = this[e]()), i;
  }
  isEmpty() {
    return this.option(Zt) === !1 ? !this.items(!0).length : super.isEmpty.apply(this, arguments);
  }
  isLastPageLoaded() {
    var e = !1;
    if (this.option(Zt) === !1 && Al(this)) {
      var {
        pageIndex: i,
        loadPageCount: r
      } = this.getLoadPageParams(!0), n = this.pageCount();
      e = i + r >= n;
    } else
      e = super.isLastPageLoaded.apply(this, arguments);
    return e;
  }
  reset() {
    this._itemCount = 0, this._allItems = null, super.reset.apply(this, arguments);
  }
  _applyFilter() {
    var e;
    return (e = this._dataSource) === null || e === void 0 || e.loadPageCount(1), super._applyFilter.apply(this, arguments);
  }
  getVirtualContentSize() {
    var e;
    return (e = this._dataSource) === null || e === void 0 ? void 0 : e.getVirtualContentSize.apply(this._dataSource, arguments);
  }
  setViewportItemIndex() {
    var e;
    return (e = this._dataSource) === null || e === void 0 ? void 0 : e.setViewportItemIndex.apply(this._dataSource, arguments);
  }
}, LOe = (t) => class extends t {
  dispose() {
    super.dispose.apply(this, arguments), clearTimeout(this._resizeTimeout);
  }
  _updateMasterDataGridCore(e) {
    return $e(super._updateMasterDataGridCore.apply(this, arguments)).done((i) => {
      var r = $a(e) && e.option(Zt) === !1;
      if (!i && r) {
        var n = e.getScrollable();
        n && e.updateDimensions();
      }
    });
  }
  hasResizeTimeout() {
    return !!this._resizeTimeout;
  }
  resize() {
    var e;
    if ($a(this) || xe.isVirtualRowRendering(this)) {
      clearTimeout(this._resizeTimeout), this._resizeTimeout = null;
      var i = /* @__PURE__ */ new Date() - this._lastTime, r = this.option("scrolling.updateTimeout");
      this._lastTime && i < r ? (e = new q(), this._resizeTimeout = setTimeout(() => {
        this._resizeTimeout = null, super.resize.apply(this).done(e.resolve).fail(e.reject), this._lastTime = /* @__PURE__ */ new Date();
      }, r), this._lastTime = /* @__PURE__ */ new Date()) : (e = super.resize.apply(this), this._dataController.isLoaded() && (this._lastTime = /* @__PURE__ */ new Date()));
    } else
      e = super.resize.apply(this);
    return e;
  }
}, MOe = (t) => class extends t {
  init() {
    var e;
    super.init(), this._dataController.pageChanged.add((i) => {
      var r = this._scrollTop;
      this.scrollToPage(i ?? this._dataController.pageIndex()), this.option(Zt) === !1 && this._scrollTop === r && this._dataController.updateViewport();
    }), this._dataController.dataSourceChanged.add(() => {
      !this._scrollTop && this._scrollToCurrentPageOnResize();
    }), (e = this._dataController.stateLoaded) === null || e === void 0 || e.add(() => {
      this._scrollToCurrentPageOnResize();
    }), this._scrollToCurrentPageOnResize();
  }
  dispose() {
    clearTimeout(this._scrollTimeoutID), super.dispose();
  }
  _scrollToCurrentPageOnResize() {
    if (this._dataController.pageIndex() > 0) {
      var e = () => {
        this.resizeCompleted.remove(e), this.scrollToPage(this._dataController.pageIndex());
      };
      this.resizeCompleted.add(e);
    }
  }
  scrollToPage(e) {
    var i = this._dataController ? this._dataController.pageSize() : 0, r;
    if ($a(this) || Ru(this)) {
      var n = this._dataController.getItemSize(), a = this._dataController.getItemSizes(), o = e * i;
      r = o * n;
      for (var u in a)
        parseInt(u) < o && (r += a[u] - n);
    } else
      r = 0;
    this.scrollTo({
      y: r,
      x: this._scrollLeft
    });
  }
  renderDelayedTemplates() {
    this.waitAsyncTemplates().done(() => {
      this._updateContentPosition(!0);
    }), super.renderDelayedTemplates.apply(this, arguments);
  }
  _renderCore(e) {
    var i = /* @__PURE__ */ new Date(), r = super._renderCore.apply(this, arguments), n = this._dataController._dataSource;
    if (n && e) {
      var a = e.items ? e.items.length : 20, o = this._dataController.viewportSize() || 20;
      xe.isVirtualRowRendering(this) && a > 0 && this.option(Zt) !== !1 ? n._renderTime = (/* @__PURE__ */ new Date() - i) * o / a : n._renderTime = /* @__PURE__ */ new Date() - i;
    }
    return r;
  }
  _getRowElements(e) {
    var i = super._getRowElements(e);
    return i && i.not(".".concat(ww));
  }
  _removeRowsElements(e, i, r) {
    var n = this._getRowElements(e).toArray();
    r === "append" ? n = n.slice(0, i) : n = n.slice(-i), n.map((a) => {
      var o = E(a);
      this._errorHandlingController && this._errorHandlingController.removeErrorRow(o.next()), o.remove();
    });
  }
  _updateContent(e, i) {
    var r, n = this._findContentElement(), a = i && i.changeType, o = q(), u = n.children().first();
    return a === "append" || a === "prepend" ? this.waitAsyncTemplates().done(() => {
      var c = this._getBodies(e);
      c.length === 1 ? this._getBodies(u)[a === "append" ? "append" : "prepend"](c.children()) : c[a === "append" ? "appendTo" : "prependTo"](u), e.remove(), r = this._getFreeSpaceRowElements(u), f2(r, R8), i.removeCount && this._removeRowsElements(u, i.removeCount, a), this._restoreErrorRow(u), o.resolve();
    }).fail(o.reject) : super._updateContent.apply(this, arguments).done(() => {
      a === "update" && this._restoreErrorRow(u), o.resolve();
    }).fail(o.reject), o.promise().done(() => {
      this._updateBottomLoading();
    });
  }
  _addVirtualRow(e, i, r, n) {
    if (n) {
      var a = this._createEmptyRow(ww, i, n);
      a = this._wrapRowIfNeed(e, a), this._appendEmptyRow(e, a, r);
    }
  }
  _updateContentItemSizes() {
    var e = this._getRowHeights(), i = this._correctRowHeights(e);
    this._dataController.setContentItemSizes(i);
  }
  _updateViewportSize(e, i) {
    R(e) || (e = this._hasHeight ? jt(this.element()) : jt(Ot())), this._dataController.viewportHeight(e, i);
  }
  _getRowHeights() {
    var e, i, r = (i = (e = this._editingController) === null || e === void 0 ? void 0 : e.isPopupEditMode) === null || i === void 0 ? void 0 : i.call(e), n = this._getRowElements(this._tableElement).toArray();
    return r && (n = n.filter((a) => !E(a).hasClass(wOe))), n.map((a) => zr(a).height);
  }
  _correctRowHeights(e) {
    for (var i = this._dataController, r = i._dataSource, n = [], a = i.getVisibleRows(), o = 0, u = !0, c = -1, p = 0; p < e.length; p++) {
      var v = a[p];
      R(v) && (this.option(Zt) === !1 ? (c >= 0 && c !== v.loadIndex && (n.push(o), o = 0), c = v.loadIndex) : iT(v, r) && (u ? u = !1 : (n.push(o), o = 0)), o += e[p]);
    }
    return o > 0 && n.push(o), n;
  }
  _updateContentPosition(e) {
    var i = this._rowHeight || 20;
    if (this._dataController.viewportItemSize(i), $a(this) || xe.isVirtualRowRendering(this)) {
      e || this._updateContentItemSizes();
      var r = this._dataController.getContentOffset("begin"), n = this._dataController.getContentOffset("end"), a = this.getTableElements(), o = a.children("tbody").children(".".concat(ww));
      f2(o, ww), a.each((u, c) => {
        var p = u > 0, v = this._isFixedTableRendering;
        this._isFixedTableRendering = p, this._addVirtualRow(E(c), p, "top", r), this._addVirtualRow(E(c), p, "bottom", n), this._isFixedTableRendering = v;
      });
    }
  }
  _isTableLinesDisplaysCorrect(e) {
    var i = e.find(".".concat(bOe)).length > 0;
    return i === this.option("showColumnLines");
  }
  _isColumnElementsEqual(e, i) {
    var r = e.length === i.length;
    return r && N(e, (n, a) => {
      if (a.style.width !== i[n].style.width)
        return r = !1, r;
    }), r;
  }
  _getCellClasses(e) {
    var i = [], {
      cssClass: r
    } = e, n = e.command === "expand";
    return r && i.push(r), n && i.push(this.addWidgetPrefix(EOe)), i;
  }
  _findBottomLoadPanel(e) {
    var i = e || this.element(), r = i && i.find(".".concat(this.addWidgetPrefix(c2)));
    if (r && r.length)
      return r;
  }
  _updateBottomLoading() {
    var e = $a(this), i = Ru(this), r = !this._dataController.hasKnownLastPage() && this._dataController.isLoaded() && (e || i), n = this._findContentElement(), a = this._findBottomLoadPanel(n);
    r ? a || E("<div>").addClass(this.addWidgetPrefix(c2)).append(this._createComponent(E("<div>"), us).$element()).appendTo(n) : a && a.remove();
  }
  _handleScroll(e) {
    var i = this.option(Zt) === !0, r = e.scrollOffset.top === 0, n = this._scrollTop !== e.scrollOffset.top, a = n || e.forceUpdateScrollPosition, o = this._hasHeight || !i && r;
    if (a && o && this._rowHeight) {
      this._scrollTop = e.scrollOffset.top;
      var u = $a(this) || this.option("scrolling.rowRenderingMode") !== "standard";
      u && this.option(Zt) === !1 && (this._updateContentItemSizes(), this._updateViewportSize(null, this._scrollTop)), this._dataController.setViewportPosition(e.scrollOffset.top);
    }
    super._handleScroll.apply(this, arguments);
  }
  _needUpdateRowHeight(e) {
    return super._needUpdateRowHeight.apply(this, arguments) || e > 0 && Ru(this) && !xe.isVirtualRowRendering(this);
  }
  _updateRowHeight() {
    if (super._updateRowHeight.apply(this, arguments), this._rowHeight) {
      this._updateContentPosition();
      var e = this._hasHeight ? jt(this.element()) : jt(Ot());
      this.option(Zt) === !1 ? (this._updateViewportSize(e), this._dataController.updateViewport()) : this._dataController.viewportSize(Math.ceil(e / this._rowHeight));
    }
  }
  updateFreeSpaceRowHeight() {
    var e = super.updateFreeSpaceRowHeight.apply(this, arguments);
    return e && this._updateContentPosition(), e;
  }
  setLoading(e, i) {
    var r = this._dataController, n = r.pageIndex() > 0 && r.isLoaded() && !!this._findBottomLoadPanel();
    this.option(Zt) === !1 && e && r.isViewportChanging() || (n && (e = !1), super.setLoading.call(this, e, i));
  }
  throwHeightWarningIfNeed() {
    if (this._hasHeight !== void 0) {
      var e = !this._hasHeight && Al(this);
      e && !this._heightWarningIsThrown && (this._heightWarningIsThrown = !0, Yt.log("W1025"));
    }
  }
  _resizeCore() {
    var e = this, i = e.element();
    super._resizeCore(), this.throwHeightWarningIfNeed(), e.component.$element() && !e._windowScroll && dI(i) && (e._windowScroll = A8(i, (r) => {
      !e._hasHeight && e._rowHeight && e._dataController.setViewportPosition(r);
    }, e.component.$element()), e.on("disposing", () => {
      e._windowScroll.dispose();
    })), this.option(Zt) !== !1 && e.loadIfNeed();
  }
  loadIfNeed() {
    var e, i;
    (i = (e = this._dataController) === null || e === void 0 ? void 0 : e.loadIfNeed) === null || i === void 0 || i.call(e);
  }
  _restoreErrorRow(e) {
    var i;
    this.option(Zt) === !1 && ((i = this._errorHandlingController) === null || i === void 0 || i.removeErrorRow()), super._restoreErrorRow.apply(this, arguments);
  }
}, kOe = {
  defaultOptions: () => ({
    scrolling: {
      timeout: 300,
      updateTimeout: 300,
      minTimeout: 0,
      renderingThreshold: 100,
      removeInvisiblePages: !0,
      rowPageSize: 5,
      prerenderedRowChunkSize: 1,
      mode: "standard",
      preloadEnabled: !1,
      rowRenderingMode: "standard",
      loadTwoPagesOnStart: !1,
      legacyMode: !1,
      prerenderedRowCount: 1
    }
  }),
  extenders: {
    controllers: {
      data: ROe,
      resizing: LOe
    },
    views: {
      rowsView: MOe
    }
  }
};
et.registerModule("virtualScrolling", kOe);
DI.extend(OOe);
var POe = 0.9, M8 = (t, e) => {
  var i = E(Ot()), {
    top: r
  } = t.offset(), n;
  if (Di(e)) {
    if (e < r)
      return r - e;
    n = vT(i) - e + i.scrollTop();
  } else {
    var a = r - i.scrollTop(), o = vT(i) - a - jt(t);
    n = Math.max(a, o);
  }
  return n * POe;
}, FOe = "dx-context-menu-content-delimiter", BOe = "dx-submenu";
class GM extends RB {
  _getDefaultOptions() {
    return P(super._getDefaultOptions(), {
      orientation: "horizontal",
      tabIndex: null,
      onHoverStart: ee
    });
  }
  _initDataAdapter() {
    this._dataAdapter = this.option("_dataAdapter"), this._dataAdapter || super._initDataAdapter();
  }
  _renderContentImpl() {
    this._renderContextMenuOverlay(), super._renderContentImpl();
    var e = this._dataAdapter.getNodeByKey(this.option("_parentKey"));
    e && this._renderItems(this._getChildNodes(e)), this._renderDelimiter();
  }
  _renderDelimiter() {
    this.$contentDelimiter = E("<div>").appendTo(this._itemContainer()).addClass(FOe);
  }
  _getOverlayOptions() {
    return P(!0, super._getOverlayOptions(), {
      onPositioned: this._overlayPositionedActionHandler.bind(this),
      position: {
        precise: !0
      }
    });
  }
  _overlayPositionedActionHandler(e) {
    this._showDelimiter(e);
  }
  _hoverEndHandler(e) {
    super._hoverEndHandler(e), this._toggleFocusClass(!1, e.currentTarget);
  }
  _isMenuHorizontal() {
    return this.option("orientation") === "horizontal";
  }
  _hoverStartHandler(e) {
    var i = this.option("onHoverStart");
    i(e), super._hoverStartHandler(e), this._toggleFocusClass(!0, e.currentTarget);
  }
  _drawSubmenu(e) {
    this._actions.onShowing({
      rootItem: ot(e),
      submenu: this
    }), super._drawSubmenu(e), this._actions.onShown({
      rootItem: ot(e),
      submenu: this
    });
  }
  _hideSubmenu(e) {
    this._actions.onHiding({
      cancel: !0,
      rootItem: ot(e),
      submenu: this
    }), super._hideSubmenu(e), this._actions.onHidden({
      rootItem: ot(e),
      submenu: this
    });
  }
  _showDelimiter(e) {
    if (this.$contentDelimiter) {
      var i = this._itemContainer().children(".".concat(BOe)).eq(0), r = this.option("position").of.find(".dx-context-menu-container-border"), n = {
        of: i,
        precise: !0
      }, a = e.position, o = a.v.location, u = a.h.location, c = r.offset(), p = Math.round(c.left), v = Math.round(c.top), _ = mt(r), y = Pt(r), b = mt(i), I = Pt(i);
      this.$contentDelimiter.css("display", "block"), gF(this.$contentDelimiter, this._isMenuHorizontal() ? _ < b ? _ : b : 3), Dh(this.$contentDelimiter, this._isMenuHorizontal() ? 3 : y < I ? y : I), this._isMenuHorizontal() ? o > v ? Math.round(u) === p ? (n.offset = "0 -2.5", n.at = n.my = "left top") : (n.offset = "0 -2.5", n.at = n.my = "right top") : (Dh(this.$contentDelimiter, 5), Math.round(u) === p ? (n.offset = "0 5", n.at = n.my = "left bottom") : (n.offset = "0 5", n.at = n.my = "right bottom")) : u > p ? Math.round(o) === v ? (n.offset = "-2.5 0", n.at = n.my = "left top") : (n.offset = "-2.5 0", n.at = n.my = "left bottom") : Math.round(o) === v ? (n.offset = "2.5 0", n.at = n.my = "right top") : (n.offset = "2.5 0", n.at = n.my = "right bottom"), kl.setup(this.$contentDelimiter, n);
    }
  }
  _getContextMenuPosition() {
    return this.option("position");
  }
  isOverlayVisible() {
    return this._overlay.option("visible");
  }
  getOverlayContent() {
    return this._overlay.$content();
  }
}
var Xp = "dx-menu", VOe = Xp + "-vertical", p2 = Xp + "-horizontal", VP = Xp + "-item", v2 = Xp + "-items-container", KM = VP + "-expanded", rT = "dx-context-menu", jM = rT + "-container-border", NOe = "dx-context-menu-content-delimiter", HOe = "dx-submenu", $Oe = "dx-state-disabled", g2 = "dx-state-hover", zOe = "dx-state-active", nT = Xp + "-adaptive-mode", m2 = Xp + "-hamburger-button", WOe = nT + "-overlay-wrapper", UOe = "up", GOe = "down", KOe = "left", jOe = "right", Uy = "showSubmenu", om = "nextItem", fh = "prevItem", YOe = {
  show: 50,
  hide: 300
}, _2 = ["onSubmenuShowing", "onSubmenuShown", "onSubmenuHiding", "onSubmenuHidden", "onItemContextMenu", "onItemClick", "onSelectionChanged", "onItemRendered"];
class NP extends OB {
  _getDefaultOptions() {
    return P(super._getDefaultOptions(), {
      orientation: "horizontal",
      submenuDirection: "auto",
      showFirstSubmenuMode: {
        name: "onClick",
        delay: {
          show: 50,
          hide: 300
        }
      },
      hideSubmenuOnMouseLeave: !1,
      onSubmenuShowing: null,
      onSubmenuShown: null,
      onSubmenuHiding: null,
      onSubmenuHidden: null,
      adaptivityEnabled: !1
    });
  }
  _setOptionsByReference() {
    super._setOptionsByReference(), P(this._optionsByReference, {
      animation: !0,
      selectedItem: !0
    });
  }
  _itemElements() {
    var e = super._itemElements(), i = this._submenuItemElements();
    return e.add(i);
  }
  _submenuItemElements() {
    var e = [], i = ".".concat(VP), r = this._submenus.length && this._submenus[0];
    return r && r.itemsContainer() && (e = r.itemsContainer().find(i)), e;
  }
  _focusTarget() {
    return this.$element();
  }
  _isMenuHorizontal() {
    return this.option("orientation") === "horizontal";
  }
  _moveFocus(e) {
    var i = this._getAvailableItems(), r = this._isMenuHorizontal(), n = this._getActiveItem(!0), a, o, u, c;
    switch (e) {
      case UOe:
        o = r ? Uy : this._getItemsNavigationOperation(fh), a = r ? n : i, u = this._getKeyboardNavigationAction(o, a), c = u();
        break;
      case GOe:
        o = r ? Uy : this._getItemsNavigationOperation(om), a = r ? n : i, u = this._getKeyboardNavigationAction(o, a), c = u();
        break;
      case jOe:
        o = r ? this._getItemsNavigationOperation(om) : Uy, a = r ? i : n, u = this._getKeyboardNavigationAction(o, a), c = u();
        break;
      case KOe:
        o = r ? this._getItemsNavigationOperation(fh) : Uy, a = r ? i : n, u = this._getKeyboardNavigationAction(o, a), c = u();
        break;
      default:
        return super._moveFocus(e);
    }
    c && c.length !== 0 && this.option("focusedElement", ot(c));
  }
  _getItemsNavigationOperation(e) {
    var i = e;
    return this.option("rtlEnabled") && (i = e === fh ? om : fh), i;
  }
  _getKeyboardNavigationAction(e, i) {
    var r = ee;
    switch (e) {
      case Uy:
        i.hasClass($Oe) || (r = this._showSubmenu.bind(this, i));
        break;
      case om:
        r = this._nextItem.bind(this, i);
        break;
      case fh:
        r = this._prevItem.bind(this, i);
    }
    return r;
  }
  _clean() {
    super._clean(), this.option("templatesRenderAsynchronously") && clearTimeout(this._resizeEventTimer);
  }
  _visibilityChanged(e) {
    e && (this._menuItemsWidth || this._updateItemsWidthCache(), this._dimensionChanged());
  }
  _isAdaptivityEnabled() {
    return this.option("adaptivityEnabled") && this.option("orientation") === "horizontal";
  }
  _updateItemsWidthCache() {
    var e = this.$element().find("ul").first().children("li").children(".".concat(VP));
    this._menuItemsWidth = this._getSummaryItemsSize("width", e, !0);
  }
  _dimensionChanged() {
    if (this._isAdaptivityEnabled()) {
      var e = oi(this.$element());
      this._toggleAdaptiveMode(this._menuItemsWidth > e);
    }
  }
  _init() {
    super._init(), this._submenus = [];
  }
  _initActions() {
    this._actions = {}, N(_2, (e, i) => {
      this._actions[i] = this._createActionByOption(i);
    });
  }
  _initMarkup() {
    this._visibleSubmenu = null, this.$element().addClass(Xp), super._initMarkup(), this._addCustomCssClass(this.$element()), this.setAria("role", "menubar");
  }
  _render() {
    super._render(), this._initAdaptivity();
  }
  _renderHamburgerButton() {
    return this._hamburger = new yn(E("<div>").addClass(m2), {
      icon: "menu",
      activeStateEnabled: !1,
      onClick: this._toggleTreeView.bind(this)
    }), this._hamburger.$element();
  }
  _toggleTreeView(e) {
    $t(e) && (e = !this._overlay.option("visible")), this._overlay.option("visible", e), e && this._treeView.focus(), this._toggleHamburgerActiveState(e);
  }
  _toggleHamburgerActiveState(e) {
    this._hamburger && this._hamburger.$element().toggleClass(zOe, e);
  }
  _toggleAdaptiveMode(e) {
    var i = this.$element().find(".".concat(p2)), r = this.$element().find(".".concat(nT));
    e ? this._hideVisibleSubmenu() : (this._treeView && this._treeView.collapseAll(), this._overlay && this._toggleTreeView(e)), i.toggle(!e), r.toggle(e);
  }
  _removeAdaptivity() {
    this._$adaptiveContainer && (this._toggleAdaptiveMode(!1), this._$adaptiveContainer.remove(), this._$adaptiveContainer = null, this._treeView = null, this._hamburger = null, this._overlay = null);
  }
  _treeviewItemClickHandler(e) {
    this._actions.onItemClick(e), e.node.children.length || this._toggleTreeView(!1);
  }
  _getAdaptiveOverlayOptions() {
    var e = this.option("rtlEnabled"), i = e ? "right" : "left";
    return {
      _ignoreFunctionValueDeprecation: !0,
      maxHeight: () => M8(this.$element()),
      deferRendering: !1,
      shading: !1,
      animation: !1,
      hideOnParentScroll: !0,
      onHidden: () => {
        this._toggleHamburgerActiveState(!1);
      },
      height: "auto",
      hideOnOutsideClick: (r) => !E(r.target).closest(".".concat(m2)).length,
      position: {
        collision: "flipfit",
        at: "bottom " + i,
        my: "top " + i,
        of: this._hamburger.$element()
      }
    };
  }
  _getTreeViewOptions() {
    var e = {};
    return N(["rtlEnabled", "width", "accessKey", "activeStateEnabled", "animation", "dataSource", "disabled", "displayExpr", "displayExpr", "focusStateEnabled", "hint", "hoverStateEnabled", "itemsExpr", "items", "itemTemplate", "selectedExpr", "selectionMode", "tabIndex", "visible"], (i, r) => {
      e[r] = this.option(r);
    }), N(["onItemContextMenu", "onSelectionChanged", "onItemRendered"], (i, r) => {
      e[r] = (n) => {
        this._actions[r](n);
      };
    }), P(e, {
      dataSource: this.getDataSource(),
      animationEnabled: !!this.option("animation"),
      onItemClick: this._treeviewItemClickHandler.bind(this),
      onItemExpanded: (i) => {
        this._overlay.repaint(), this._actions.onSubmenuShown(i);
      },
      onItemCollapsed: (i) => {
        this._overlay.repaint(), this._actions.onSubmenuHidden(i);
      },
      selectNodesRecursive: !1,
      selectByClick: this.option("selectByClick"),
      expandEvent: "click"
    });
  }
  _initAdaptivity() {
    if (this._isAdaptivityEnabled()) {
      this._$adaptiveContainer = E("<div>").addClass(nT);
      var e = this._renderHamburgerButton();
      this._treeView = this._createComponent(E("<div>"), TS, this._getTreeViewOptions()), this._overlay = this._createComponent(E("<div>"), Pl, this._getAdaptiveOverlayOptions()), this._overlay.$content().append(this._treeView.$element()).addClass(nT).addClass(this.option("cssClass")), this._overlay.$wrapper().addClass(WOe), this._$adaptiveContainer.append(e), this._$adaptiveContainer.append(this._overlay.$element()), this.$element().append(this._$adaptiveContainer), this._updateItemsWidthCache(), this._dimensionChanged();
    }
  }
  _getDelay(e) {
    var i = this.option("showFirstSubmenuMode").delay;
    return R(i) ? ct(i) ? i[e] : i : YOe[e];
  }
  _keyboardHandler(e) {
    return super._keyboardHandler(e, !!this._visibleSubmenu);
  }
  _renderContainer() {
    var e = E("<div>");
    return e.appendTo(this.$element()).addClass(this._isMenuHorizontal() ? p2 : VOe), super._renderContainer(e);
  }
  _renderSubmenuItems(e, i) {
    var r = this._createSubmenu(e, i);
    return this._submenus.push(r), this._renderBorderElement(i), r;
  }
  _getKeyboardListeners() {
    return super._getKeyboardListeners().concat(this._visibleSubmenu);
  }
  _createSubmenu(e, i) {
    var r = E("<div>").addClass(rT).appendTo(i), n = this._getChildNodes(e), a = this._createComponent(r, GM, P(this._getSubmenuOptions(), {
      _dataAdapter: this._dataAdapter,
      _parentKey: e.internalFields.key,
      items: n,
      onHoverStart: this._clearTimeouts.bind(this),
      position: this.getSubmenuPosition(i)
    }));
    return this._attachSubmenuHandlers(i, a), a;
  }
  _getSubmenuOptions() {
    var e = E("<div>"), i = this._isMenuHorizontal();
    return {
      itemTemplate: this.option("itemTemplate"),
      target: e,
      orientation: this.option("orientation"),
      selectionMode: this.option("selectionMode"),
      cssClass: this.option("cssClass"),
      selectByClick: this.option("selectByClick"),
      hoverStateEnabled: this.option("hoverStateEnabled"),
      activeStateEnabled: this.option("activeStateEnabled"),
      focusStateEnabled: this.option("focusStateEnabled"),
      animation: this.option("animation"),
      showSubmenuMode: this.option("showSubmenuMode"),
      displayExpr: this.option("displayExpr"),
      disabledExpr: this.option("disabledExpr"),
      selectedExpr: this.option("selectedExpr"),
      itemsExpr: this.option("itemsExpr"),
      onFocusedItemChanged: (r) => {
        r.component.option("visible") && this.option("focusedElement", r.component.option("focusedElement"));
      },
      onSelectionChanged: this._nestedItemOnSelectionChangedHandler.bind(this),
      onItemClick: this._nestedItemOnItemClickHandler.bind(this),
      onItemRendered: this._nestedItemOnItemRenderedHandler.bind(this),
      onLeftFirstItem: i ? null : this._moveMainMenuFocus.bind(this, fh),
      onLeftLastItem: i ? null : this._moveMainMenuFocus.bind(this, om),
      onCloseRootSubmenu: this._moveMainMenuFocus.bind(this, i ? fh : null),
      onExpandLastSubmenu: i ? this._moveMainMenuFocus.bind(this, om) : null
    };
  }
  _getShowFirstSubmenuMode() {
    if (!this._isDesktopDevice())
      return "onClick";
    var e = this.option("showFirstSubmenuMode");
    return ct(e) ? e.name : e;
  }
  _moveMainMenuFocus(e) {
    var i = this._getAvailableItems(), r = i.length, n = i.filter(".".concat(KM)).eq(0), a = i.index(n);
    this._hideSubmenu(this._visibleSubmenu), a += e === fh ? -1 : 1, a >= r ? a = 0 : a < 0 && (a = r - 1);
    var o = i.eq(a);
    this.option("focusedElement", ot(o));
  }
  _nestedItemOnSelectionChangedHandler(e) {
    var i = e.addedItems.length && e.addedItems[0], r = GM.getInstance(e.element), n = this._actions.onSelectionChanged;
    n(e), i && this._clearSelectionInSubmenus(i[0], r), this._clearRootSelection(), this._setOptionWithoutOptionChange("selectedItem", i);
  }
  _clearSelectionInSubmenus(e, i) {
    var r = !arguments.length;
    N(this._submenus, (n, a) => {
      var o = a._itemContainer(), u = !o.is(i && i._itemContainer()), c = o.find(".".concat(this._selectedItemClass()));
      if (u && c.length || r) {
        c.removeClass(this._selectedItemClass());
        var p = this._getItemData(c);
        p && (p.selected = !1), a._clearSelectedItems();
      }
    });
  }
  _clearRootSelection() {
    var e = this.$element().find(".".concat(v2)).first().children().children().filter(".".concat(this._selectedItemClass()));
    if (e.length) {
      var i = this._getItemData(e);
      i.selected = !1, e.removeClass(this._selectedItemClass());
    }
  }
  _nestedItemOnItemClickHandler(e) {
    this._actions.onItemClick(e);
  }
  _nestedItemOnItemRenderedHandler(e) {
    this._actions.onItemRendered(e);
  }
  _attachSubmenuHandlers(e, i) {
    var r = i.getOverlayContent(), n = r.find(".".concat(HOe)), a = ve(dS, this.NAME + "_submenu");
    i.option({
      onShowing: this._submenuOnShowingHandler.bind(this, e, i),
      onShown: this._submenuOnShownHandler.bind(this, e, i),
      onHiding: this._submenuOnHidingHandler.bind(this, e, i),
      onHidden: this._submenuOnHiddenHandler.bind(this, e, i)
    }), N(n, (o, u) => {
      k.off(u, a), k.on(u, a, null, this._submenuMouseLeaveHandler.bind(this, e));
    });
  }
  _submenuOnShowingHandler(e, i) {
    var r = e.children(".".concat(jM));
    this._actions.onSubmenuShowing({
      rootItem: ot(e),
      submenu: i
    }), r.show(), e.addClass(KM);
  }
  _submenuOnShownHandler(e, i) {
    this._actions.onSubmenuShown({
      rootItem: ot(e),
      submenu: i
    });
  }
  _submenuOnHidingHandler(e, i, r) {
    var n = e.children(".".concat(jM)), a = r;
    a.rootItem = ot(e), a.submenu = i, this._actions.onSubmenuHiding(a), r = a, r.cancel || (this._visibleSubmenu === i && (this._visibleSubmenu = null), n.hide(), e.removeClass(KM));
  }
  _submenuOnHiddenHandler(e, i) {
    this._actions.onSubmenuHidden({
      rootItem: ot(e),
      submenu: i
    });
  }
  _submenuMouseLeaveHandler(e, i) {
    var r = E(i.relatedTarget).parents(".".concat(rT))[0], n = this._getSubmenuByRootElement(e).getOverlayContent()[0];
    this.option("hideSubmenuOnMouseLeave") && r !== n && (this._clearTimeouts(), setTimeout(this._hideSubmenuAfterTimeout.bind(this), this._getDelay("hide")));
  }
  _hideSubmenuAfterTimeout() {
    if (this._visibleSubmenu) {
      var e = E(this._visibleSubmenu.$element().context).hasClass(g2), i = this._visibleSubmenu.getOverlayContent().find(".".concat(g2)).length, r = this._visibleSubmenu.getOverlayContent().get(0).querySelector(":hover");
      !r && !i && !e && this._visibleSubmenu.hide();
    }
  }
  _getSubmenuByRootElement(e) {
    if (!e)
      return !1;
    var i = e.children(".".concat(rT));
    return i.length && GM.getInstance(i);
  }
  getSubmenuPosition(e) {
    var i = this._isMenuHorizontal(), r = this.option("submenuDirection").toLowerCase(), n = this.option("rtlEnabled"), a = {
      collision: "flip",
      of: e,
      precise: !0
    };
    switch (r) {
      case "leftortop":
        a.at = "left top", a.my = i ? "left bottom" : "right top";
        break;
      case "rightorbottom":
        a.at = i ? "left bottom" : "right top", a.my = "left top";
        break;
      default:
        i ? (a.at = n ? "right bottom" : "left bottom", a.my = n ? "right top" : "left top") : (a.at = n ? "left top" : "right top", a.my = n ? "right top" : "left top");
    }
    return a;
  }
  _renderBorderElement(e) {
    E("<div>").appendTo(e).addClass(jM).hide();
  }
  _itemPointerDownHandler(e) {
    var i = E(e.target), r = i.closest(this._itemElements());
    if (r.hasClass("dx-menu-item-has-submenu")) {
      this.option("focusedElement", null);
      return;
    }
    super._itemPointerDownHandler(e);
  }
  _hoverStartHandler(e) {
    var i = ve(Xt.move, this.NAME), r = this._getItemElementByEventArgs(e), n = this._dataAdapter.getNodeByItem(this._getItemData(r)), a = R(e.buttons) && e.buttons === 1 || !R(e.buttons) && e.which === 1;
    if (!this._isItemDisabled(r)) {
      if (k.off(r, i), !this._hasChildren(n)) {
        this._showSubmenuTimer = setTimeout(this._hideSubmenuAfterTimeout.bind(this), this._getDelay("hide"));
        return;
      }
      if (this._getShowFirstSubmenuMode() === "onHover" && !a) {
        var o = this._getSubmenuByElement(r);
        this._clearTimeouts(), o.isOverlayVisible() || (k.on(r, i, this._itemMouseMoveHandler.bind(this)), this._showSubmenuTimer = this._getDelay("hide"));
      }
    }
  }
  _hoverEndHandler(e) {
    var i = this._getItemElementByEventArgs(e), r = E(e.relatedTarget);
    super._hoverEndHandler(e), this._clearTimeouts(), !this._isItemDisabled(i) && (r.hasClass(NOe) || this.option("hideSubmenuOnMouseLeave") && !r.hasClass(v2) && (this._hideSubmenuTimer = setTimeout(() => {
      this._hideSubmenuAfterTimeout();
    }, this._getDelay("hide"))));
  }
  _hideVisibleSubmenu() {
    return this._visibleSubmenu ? (this._hideSubmenu(this._visibleSubmenu), !0) : !1;
  }
  _showSubmenu(e) {
    var i = this._getSubmenuByElement(e);
    this._visibleSubmenu !== i && this._hideVisibleSubmenu(), i && (this._clearTimeouts(), this.focus(), i.show(), this.option("focusedElement", i.option("focusedElement"))), this._visibleSubmenu = i, this._hoveredRootItem = e;
  }
  _hideSubmenu(e) {
    e && e.hide(), this._visibleSubmenu === e && (this._visibleSubmenu = null), this._hoveredRootItem = null;
  }
  _itemMouseMoveHandler(e) {
    if (!(e.pointers && e.pointers.length)) {
      var i = E(e.currentTarget);
      R(this._showSubmenuTimer) && (this._clearTimeouts(), this._showSubmenuTimer = setTimeout(() => {
        var r = this._getSubmenuByElement(i);
        r && !r.isOverlayVisible() && this._showSubmenu(i);
      }, this._getDelay("show")));
    }
  }
  _clearTimeouts() {
    clearTimeout(this._hideSubmenuTimer), clearTimeout(this._showSubmenuTimer);
  }
  _getSubmenuByElement(e, i) {
    var r = this._getSubmenuByRootElement(e);
    if (r)
      return r;
    i = i || this._getItemData(e);
    var n = this._dataAdapter.getNodeByItem(i);
    return this._hasChildren(n) && this._renderSubmenuItems(n, e);
  }
  _updateSubmenuVisibilityOnClick(e) {
    var i = e.args.length && e.args[0];
    if (!(!i || this._disabledGetter(i.itemData))) {
      var r = E(i.itemElement), n = this._getSubmenuByElement(r, i.itemData);
      if (this._updateSelectedItemOnClick(e), this._visibleSubmenu)
        if (this._visibleSubmenu === n) {
          this.option("showFirstSubmenuMode") === "onClick" && this._hideSubmenu(this._visibleSubmenu);
          return;
        } else
          this._hideSubmenu(this._visibleSubmenu);
      if (n && !n.isOverlayVisible()) {
        this._showSubmenu(r);
        return;
      }
    }
  }
  _optionChanged(e) {
    if (_2.indexOf(e.name) >= 0) {
      this._initActions();
      return;
    }
    switch (e.name) {
      case "orientation":
      case "submenuDirection":
        this._invalidate();
        break;
      case "showFirstSubmenuMode":
      case "hideSubmenuOnMouseLeave":
        break;
      case "showSubmenuMode":
        this._changeSubmenusOption(e.name, e.value);
        break;
      case "adaptivityEnabled":
        e.value ? this._initAdaptivity() : this._removeAdaptivity();
        break;
      case "width":
        this._isAdaptivityEnabled() && (this._treeView.option(e.name, e.value), this._overlay.option(e.name, e.value)), super._optionChanged(e), this._dimensionChanged();
        break;
      case "animation":
        this._isAdaptivityEnabled() && this._treeView.option("animationEnabled", !!e.value), super._optionChanged(e);
        break;
      default:
        this._isAdaptivityEnabled() && (e.name === e.fullName || e.name === "items") && this._treeView.option(e.fullName, e.value), super._optionChanged(e);
    }
  }
  _changeSubmenusOption(e, i) {
    N(this._submenus, (r, n) => {
      n.option(e, i);
    });
  }
  selectItem(e) {
    this._hideSubmenu(this._visibleSubmenu), super.selectItem(e);
  }
  unselectItem(e) {
    this._hideSubmenu(this._visibleSubmenu), super.selectItem(e);
  }
}
ti("dxMenu", NP);
var YM = {
  "=": "filter-operation-equals",
  "<>": "filter-operation-not-equals",
  "<": "filter-operation-less",
  "<=": "filter-operation-less-equal",
  ">": "filter-operation-greater",
  ">=": "filter-operation-greater-equal",
  default: "filter-operation-default",
  notcontains: "filter-operation-not-contains",
  contains: "filter-operation-contains",
  startswith: "filter-operation-starts-with",
  endswith: "filter-operation-ends-with",
  between: "filter-operation-between"
}, C2 = {
  "=": "equal",
  "<>": "notEqual",
  "<": "lessThan",
  "<=": "lessThanOrEqual",
  ">": "greaterThan",
  ">=": "greaterThanOrEqual",
  startswith: "startsWith",
  contains: "contains",
  notcontains: "notContains",
  endswith: "endsWith",
  between: "between"
}, qOe = 700, k8 = 1, Cx = "filter-row", aT = "filter-range-overlay", YT = "filter-range-start", XOe = "filter-range-end", y2 = "dx-menu", x2 = "dx-editor-with-menu", ip = "dx-editor-container", HP = "dx-editor-cell", QOe = "dx-filter-menu", ZOe = "dx-apply-button", qM = "dx-highlight-outline", S2 = "dx-focused", JOe = "dx-cell-focus-disabled", XM = "dx-filter-range-content", QM = "dx-filter-modified", Gy = "input:not([type='hidden'])", eRe = ["date", "datetime", "number"], tRe = X.format("dxDataGrid-ariaSearchBox");
function Pm(t) {
  return t.option("filterRow.applyFilter") === "onClick";
}
var ZM = function(t) {
  var e = t && t.children(), i = e && e.data("dxComponents"), r = i && i.length && e.data(i[0]);
  return r instanceof Fl ? r : null;
}, JM = function(t, e) {
  var i = "", r = "", n = tV(t, e), a = xe.getFormatOptionsByColumn(e, "filterRow");
  return Array.isArray(n) ? (i = xe.formatValue(n[0], a), r = xe.formatValue(n[1], a), r !== "" && (i += " - ".concat(r))) : R(n) && (i = xe.formatValue(n, a)), i;
};
function tV(t, e) {
  if (e)
    return Pm(t) && e.bufferedFilterValue !== void 0 ? e.bufferedFilterValue : e.filterValue;
}
var wu = function(t, e) {
  if (e)
    return Pm(t) && e.bufferedSelectedFilterOperation !== void 0 ? e.bufferedSelectedFilterOperation : e.selectedFilterOperation;
}, iRe = function(t, e) {
  return e && eRe.includes(e.dataType) && Array.isArray(t) ? !1 : t !== void 0;
}, $P = function(t, e, i) {
  var r = t._columnsController.columnOption(e), n = tV(t, r), a = i.closest(".".concat(t.addWidgetPrefix(aT))).length, o = i.hasClass(t.addWidgetPrefix(YT));
  return n && Array.isArray(n) && wu(t, r) === "between" ? o ? n[0] : n[1] : !a && iRe(n, r) ? n : null;
}, rRe = function(t, e, i, r) {
  if (wu(t, i) === "between") {
    var n = tV(t, i);
    return r.hasClass(t.addWidgetPrefix(YT)) ? [e, Array.isArray(n) ? n[1] : void 0] : [Array.isArray(n) ? n[0] : n, e];
  }
  return e;
}, nRe = function(t, e) {
  var i = e.value === "" ? null : e.value, r = e.container, n = t._columnsController.columnOption(e.column.index), a = $P(t, n.index, r);
  if (!(!R(a) && !R(i))) {
    t._applyFilterViewController.setHighLight(r, a !== i);
    var o = Pm(t) ? "bufferedFilterValue" : "filterValue", u = rRe(t, i, n, r), c = wu(t, n) === "between", p = e.notFireEvent || c && Array.isArray(u) && u.includes(void 0);
    t._columnsController.columnOption(n.index, o, u, p);
  }
}, aRe = (t) => class extends t {
  init() {
    super.init(), this._applyFilterViewController = this.getController("applyFilter");
  }
  optionChanged(e) {
    switch (e.name) {
      case "filterRow":
      case "showColumnLines":
        this._invalidate(!0, !0), e.handled = !0;
        break;
      case "syncLookupFilterValues":
        e.value ? this.updateLookupDataSource() : this.render(), e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
  _updateEditorValue(e, i) {
    var r = ZM(i);
    r && r.option("value", $P(this, e.index, i));
  }
  _columnOptionChanged(e) {
    var i, {
      optionNames: r
    } = e, n, a, o, u;
    if (xe.checkChanges(r, ["filterValue", "bufferedFilterValue", "selectedFilterOperation", "bufferedSelectedFilterOperation", "filterValues", "filterType"]) && e.columnIndex !== void 0) {
      var c = this._columnsController.getVisibleIndex(e.columnIndex), p = this._columnsController.columnOption(e.columnIndex);
      if (n = (i = this._getCellElement(this.element().find(".".concat(this.addWidgetPrefix(Cx))).index(), c)) !== null && i !== void 0 ? i : E(), a = n.find(".".concat(ip)).first(), r.filterValue || r.bufferedFilterValue) {
        this._updateEditorValue(p, a);
        var v = n.find(".".concat(this.addWidgetPrefix(aT))).data("dxOverlay");
        v && (o = v.$content().find(".".concat(ip)), this._updateEditorValue(p, o.first()), this._updateEditorValue(p, o.last())), (!v || !v.option("visible")) && this._updateFilterRangeContent(n, JM(this, p));
      }
      (r.selectedFilterOperation || r.bufferedSelectedFilterOperation) && c >= 0 && p && (u = n.find(".".concat(y2)), u.length && (this._updateFilterOperationChooser(u, p, a), wu(this, p) === "between" ? this._renderFilterRangeContent(n, p) : a.find(".".concat(XM)).length && (this._renderEditor(a, this._getEditorOptions(a, p)), this._hideFilterRange())));
      return;
    }
    super._columnOptionChanged(e);
  }
  _renderCore() {
    return this._filterRangeOverlayInstance = null, super._renderCore.apply(this, arguments);
  }
  _resizeCore() {
    var e;
    super._resizeCore.apply(this, arguments), (e = this._filterRangeOverlayInstance) === null || e === void 0 || e.repaint();
  }
  isFilterRowVisible() {
    return this._isElementVisible(this.option("filterRow"));
  }
  isVisible() {
    return super.isVisible() || this.isFilterRowVisible();
  }
  _initFilterRangeOverlay(e, i) {
    var r = this, n = {}, a = e.find(".dx-editor-container"), o = r.addWidgetPrefix(aT), u = E("<div>").addClass(o).appendTo(e);
    return r._createComponent(u, Pl, {
      height: "auto",
      shading: !1,
      showTitle: !1,
      focusStateEnabled: !1,
      hideOnOutsideClick: !0,
      wrapperAttr: {
        class: o
      },
      animation: !1,
      position: {
        my: "top",
        at: "top",
        of: a.length && a || e,
        offset: "0 -1"
      },
      contentTemplate(c) {
        var p, v = E("<div>").addClass("".concat(ip, " ").concat(r.addWidgetPrefix(YT))).appendTo(c);
        return i = r._columnsController.columnOption(i.index), p = r._getEditorOptions(v, i), p.sharedData = n, r._renderEditor(v, p), k.on(v.find(Gy), "keydown", (_) => {
          var y = e.find("[tabindex]").not(_.target).first();
          or(_) === "tab" && _.shiftKey && (_.preventDefault(), r._hideFilterRange(), y.length || (y = e.prev().find("[tabindex]").last()), k.trigger(y, "focus"));
        }), v = E("<div>").addClass("".concat(ip, " ").concat(r.addWidgetPrefix(XOe))).appendTo(c), p = r._getEditorOptions(v, i), p.sharedData = n, r._renderEditor(v, p), k.on(v.find(Gy), "keydown", (_) => {
          or(_) === "tab" && !_.shiftKey && (_.preventDefault(), r._hideFilterRange(), k.trigger(e.next().find("[tabindex]").first(), "focus"));
        }), E(c).addClass(r.getWidgetContainerClass());
      },
      onShown(c) {
        var p = c.component.$content().find(".".concat(ip)).first();
        k.trigger(p.find(Gy), "focus");
      },
      onHidden() {
        i = r._columnsController.columnOption(i.index), e.find(".".concat(y2)).parent().addClass(x2), wu(r, i) === "between" && (r._updateFilterRangeContent(e, JM(r, i)), r.component.updateDimensions());
      }
    });
  }
  _updateFilterRangeOverlay(e) {
    var i = this._filterRangeOverlayInstance;
    i && i.option(e);
  }
  _showFilterRange(e, i) {
    var r = e.children(".".concat(this.addWidgetPrefix(aT))), n = r.length && r.data("dxOverlay");
    !n && i && (n = this._initFilterRangeOverlay(e, i)), n.option("visible") || (this._filterRangeOverlayInstance && this._filterRangeOverlayInstance.hide(), this._filterRangeOverlayInstance = n, this._updateFilterRangeOverlay({
      width: oi(e, !0) + k8
    }), this._filterRangeOverlayInstance && this._filterRangeOverlayInstance.show());
  }
  _hideFilterRange() {
    var e = this._filterRangeOverlayInstance;
    e && e.hide();
  }
  getFilterRangeOverlayInstance() {
    return this._filterRangeOverlayInstance;
  }
  _createRow(e) {
    var i = super._createRow(e);
    return e.rowType === "filter" && (i.addClass(this.addWidgetPrefix(Cx)), this.option("useLegacyKeyboardNavigation") || k.on(i, "keydown", (r) => eB("filterRow", this, r))), i;
  }
  _getRows() {
    var e = super._getRows();
    return this.isFilterRowVisible() && e.push({
      rowType: "filter"
    }), e;
  }
  _renderFilterCell(e, i) {
    var {
      column: r
    } = i, n = E(e);
    this.component.option("showColumnHeaders") && this.setAria("describedby", r.headerId, n), this.setAria("label", X.format("dxDataGrid-ariaFilterCell"), n), n.addClass(HP);
    var a = E("<div>").appendTo(n), o = E("<div>").addClass(ip).appendTo(a);
    if (wu(this, r) === "between")
      this._renderFilterRangeContent(n, r);
    else {
      var u = this._getEditorOptions(o, r);
      this._renderEditor(o, u);
    }
    var {
      alignment: c
    } = r;
    c && c !== "center" && n.find(Gy).first().css("textAlign", r.alignment), r.filterOperations && r.filterOperations.length && this._renderFilterOperationChooser(a, r, o);
  }
  _renderCellContent(e, i) {
    var r = this, {
      column: n
    } = i;
    if (i.rowType === "filter") {
      if (n.command)
        e.html("&nbsp;");
      else if (n.allowFiltering) {
        r.renderTemplate(e, r._renderFilterCell.bind(r), i).done(() => {
          r._updateCell(e, i);
        });
        return;
      }
    }
    super._renderCellContent.apply(this, arguments);
  }
  _getEditorOptions(e, i) {
    var r = this, n = {
      editorOptions: {
        inputAttr: r._getFilterInputAccessibilityAttributes(i)
      }
    }, a = P(n, i, {
      value: $P(r, i.index, e),
      parentType: "filterRow",
      showAllText: r.option("filterRow.showAllText"),
      updateValueTimeout: r.option("filterRow.applyFilter") === "onClick" ? 0 : qOe,
      width: null,
      setValue(o, u) {
        nRe(r, {
          column: i,
          value: o,
          container: e,
          notFireEvent: u
        });
      }
    });
    return wu(r, i) === "between" && (e.hasClass(r.addWidgetPrefix(YT)) ? a.placeholder = r.option("filterRow.betweenStartText") : a.placeholder = r.option("filterRow.betweenEndText")), a;
  }
  _getFilterInputAccessibilityAttributes(e) {
    var i = X.format("dxDataGrid-ariaFilterCell");
    return this.component.option("showColumnHeaders") ? {
      "aria-label": i,
      "aria-describedby": e.headerId
    } : {
      "aria-label": i
    };
  }
  _renderEditor(e, i) {
    e.empty();
    var r = E("<div>").appendTo(e), n = this._dataController.dataSource();
    if (i.lookup && this.option("syncLookupFilterValues")) {
      this._applyFilterViewController.setCurrentColumnForFiltering(i);
      var a = this._dataController.getCombinedFilter();
      this._applyFilterViewController.setCurrentColumnForFiltering(null);
      var o = xe.getWrappedLookupDataSource(i, n, a), u = ae(ae({}, i), {
        lookup: ae(ae({}, i.lookup), {
          dataSource: o
        })
      });
      return this._editorFactoryController.createEditor(r, u);
    }
    return this._editorFactoryController.createEditor(r, i);
  }
  _renderFilterRangeContent(e, i) {
    var r = this, n = e.find(".".concat(ip)).first();
    n.empty();
    var a = E("<div>").addClass(XM).attr("tabindex", this.option("tabIndex"));
    k.on(a, "focusin", () => {
      r._showFilterRange(e, i);
    }), a.appendTo(n), r._updateFilterRangeContent(e, JM(r, i));
  }
  _updateFilterRangeContent(e, i) {
    var r = e.find(".".concat(XM));
    r.length && (i === "" ? r.html("&nbsp;") : r.text(i));
  }
  _updateFilterOperationChooser(e, i, r) {
    var n = this, a, o = function() {
      var c = NP.getInstance(e);
      c && c.option("focusedElement", null), a && n._focusEditor(r);
    }, u = this._editorFactoryController;
    n._createComponent(e, NP, {
      integrationOptions: {},
      activeStateEnabled: !1,
      selectionMode: "single",
      cssClass: "".concat(n.getWidgetContainerClass(), " ").concat(JOe, " ").concat(QOe),
      showFirstSubmenuMode: "onHover",
      hideSubmenuOnMouseLeave: !0,
      items: [{
        disabled: !(i.filterOperations && i.filterOperations.length),
        icon: YM[wu(n, i) || "default"],
        selectable: !1,
        items: n._getFilterOperationMenuItems(i)
      }],
      onItemRendered: (c) => {
        var {
          itemElement: p
        } = c;
        this.setAria("label", tRe, E(p));
      },
      onItemClick(c) {
        var p = c.itemData.name, v = wu(n, i), _ = !1, y = Pm(n), b = {};
        if (!(c.itemData.items || p && p === v)) {
          if (p ? (b[y ? "bufferedSelectedFilterOperation" : "selectedFilterOperation"] = p, (p === "between" || v === "between") && (_ = p === "between", b[y ? "bufferedFilterValue" : "filterValue"] = null)) : (b[y ? "bufferedFilterValue" : "filterValue"] = null, b[y ? "bufferedSelectedFilterOperation" : "selectedFilterOperation"] = i.defaultSelectedFilterOperation || null), n._columnsController.columnOption(i.index, b), n._applyFilterViewController.setHighLight(r, !0), !p) {
            var I = ZM(r);
            I && I.NAME === "dxDateBox" && !I.option("isValid") && (I.clear(), I.option("isValid", !0));
          }
          _ ? n._showFilterRange(r.closest(".".concat(HP)), i) : n._focusEditor(r);
        }
      },
      onSubmenuShowing() {
        a = n._isEditorFocused(r), u.loseFocus();
      },
      onSubmenuHiding() {
        k.trigger(e, "blur"), o();
      },
      onContentReady(c) {
        k.on(e, "blur", () => {
          var p = c.component;
          p._hideSubmenuAfterTimeout(), o();
        });
      },
      rtlEnabled: n.option("rtlEnabled")
    });
  }
  _isEditorFocused(e) {
    return e.hasClass(S2) || e.parents(".".concat(S2)).length;
  }
  _focusEditor(e) {
    this._editorFactoryController.focus(e), k.trigger(e.find(Gy), "focus");
  }
  _renderFilterOperationChooser(e, i, r) {
    var n;
    this.option("filterRow.showOperationChooser") && (e.addClass(x2), n = E("<div>").prependTo(e), this._updateFilterOperationChooser(n, i, r));
  }
  _getFilterOperationMenuItems(e) {
    var i = this, r = [{}], n = i.option("filterRow"), a = n && n.operationDescriptions || {};
    if (e.filterOperations && e.filterOperations.length) {
      var o = e.filterOperations.filter((u) => R(C2[u]));
      r = Jr(o, (u) => {
        var c = C2[u];
        return {
          name: u,
          selected: (wu(i, e) || e.defaultFilterOperation) === u,
          text: a[c],
          icon: YM[u]
        };
      }), r.push({
        name: null,
        text: n && n.resetOperationText,
        icon: YM.default
      });
    }
    return r;
  }
  _handleDataChanged(e) {
    var i, r, n, a, o, u, c = (r = (i = this._dataController) === null || i === void 0 ? void 0 : i.dataSource) === null || r === void 0 ? void 0 : r.call(i), p = (n = c == null ? void 0 : c.lastLoadOptions) === null || n === void 0 ? void 0 : n.call(c);
    super._handleDataChanged.apply(this, arguments), (!((a = e.operationTypes) === null || a === void 0) && a.filtering || !((o = e.operationTypes) === null || o === void 0) && o.fullReload) && this.updateLookupDataSource(((u = e.operationTypes) === null || u === void 0 ? void 0 : u.filtering) || (p == null ? void 0 : p.filter));
  }
  updateLookupDataSource(e) {
    if (this.option("syncLookupFilterValues") && this.element()) {
      var i = this._columnsController.getVisibleColumns(), r = this._dataController.dataSource(), n = this._applyFilterViewController, a = this.element().find(".".concat(this.addWidgetPrefix(Cx))).index();
      a !== -1 && i.forEach((o, u) => {
        if (!(!o.lookup || o.calculateCellValue !== o.defaultCalculateCellValue)) {
          var c = this._getCellElement(a, u), p = ZM(c == null ? void 0 : c.find(".dx-editor-container"));
          if (p) {
            n.setCurrentColumnForFiltering(o);
            var v = this._dataController.getCombinedFilter() || null;
            n.setCurrentColumnForFiltering(null);
            var _ = p.option("dataSource"), y = !e || !Mi(_.__dataGridSourceFilter || null, v);
            if (y) {
              var b = xe.getWrappedLookupDataSource(o, r, v);
              p.option("dataSource", b);
            }
          }
        }
      });
    }
  }
}, oRe = (t) => class extends t {
  skipCalculateColumnFilters() {
    return !1;
  }
  _calculateAdditionalFilter() {
    if (this.skipCalculateColumnFilters())
      return super._calculateAdditionalFilter();
    var e = [super._calculateAdditionalFilter()], i = this._columnsController.getVisibleColumns(null, !0), r = this._applyFilterController;
    return N(i, function() {
      var n, a = ((n = r.getCurrentColumnForFiltering()) === null || n === void 0 ? void 0 : n.index) === this.index;
      if (this.allowFiltering && this.calculateFilterExpression && R(this.filterValue) && !a) {
        var o = this.createFilterExpression(this.filterValue, this.selectedFilterOperation || this.defaultFilterOperation, "filterRow");
        e.push(o);
      }
    }), xe.combineFilters(e);
  }
};
class sRe extends Bi.ViewController {
  init() {
    this._columnsController = this.getController("columns");
  }
  _getHeaderPanel() {
    return this._headerPanel || (this._headerPanel = this.getView("headerPanel")), this._headerPanel;
  }
  setHighLight(e, i) {
    Pm(this) && (e && e.toggleClass(qM, i) && e.closest(".".concat(HP)).toggleClass(QM, i), this._getHeaderPanel().enableApplyButton(i));
  }
  applyFilter() {
    var e = this._columnsController.getColumns();
    this._columnsController.beginUpdate();
    for (var i = 0; i < e.length; i++) {
      var r = e[i];
      r.bufferedFilterValue !== void 0 && (this._columnsController.columnOption(i, "filterValue", r.bufferedFilterValue), r.bufferedFilterValue = void 0), r.bufferedSelectedFilterOperation !== void 0 && (this._columnsController.columnOption(i, "selectedFilterOperation", r.bufferedSelectedFilterOperation), r.bufferedSelectedFilterOperation = void 0);
    }
    this._columnsController.endUpdate(), this.removeHighLights();
  }
  removeHighLights() {
    if (Pm(this)) {
      var e = this.getView("columnHeadersView").element();
      e.find(".".concat(this.addWidgetPrefix(Cx), " .").concat(qM)).removeClass(qM), e.find(".".concat(this.addWidgetPrefix(Cx), " .").concat(QM)).removeClass(QM), this._getHeaderPanel().enableApplyButton(!1);
    }
  }
  setCurrentColumnForFiltering(e) {
    this._currentColumn = e;
  }
  getCurrentColumnForFiltering() {
    return this._currentColumn;
  }
}
var lRe = (t) => class extends t {
  _startResizing() {
    if (super._startResizing.apply(this, arguments), this.isResizing()) {
      var e = this._columnHeadersView.getFilterRangeOverlayInstance();
      if (e) {
        var i = e.$element().closest("td").index();
        (i === this._targetPoint.columnIndex || i === this._targetPoint.columnIndex + 1) && e.$content().hide();
      }
    }
  }
  _endResizing() {
    var e;
    if (this.isResizing()) {
      var i = this._columnHeadersView.getFilterRangeOverlayInstance();
      i && (e = i.$element().closest("td"), this._columnHeadersView._updateFilterRangeOverlay({
        width: oi(e, !0) + k8
      }), i.$content().show());
    }
    super._endResizing.apply(this, arguments);
  }
}, uRe = (t) => class extends t {
  updateFieldValue(e) {
    return e.column.lookup && (this._needUpdateLookupDataSource = !0), super.updateFieldValue.apply(this, arguments);
  }
  _afterSaveEditData(e) {
    var i;
    return this._needUpdateLookupDataSource && !e && ((i = this.getView("columnHeadersView")) === null || i === void 0 || i.updateLookupDataSource()), this._needUpdateLookupDataSource = !1, super._afterSaveEditData.apply(this, arguments);
  }
  _afterCancelEditData() {
    return this._needUpdateLookupDataSource = !1, super._afterCancelEditData.apply(this, arguments);
  }
}, dRe = (t) => class extends t {
  init() {
    super.init(), this._dataController = this.getController("data"), this._applyFilterViewController = this.getController("applyFilter");
  }
  optionChanged(e) {
    e.name === "filterRow" ? (this._invalidate(), e.handled = !0) : super.optionChanged(e);
  }
  _getToolbarItems() {
    var e = super._getToolbarItems(), i = this._prepareFilterItem();
    return i.concat(e);
  }
  _prepareFilterItem() {
    var e = this, i = [];
    if (e._isShowApplyFilterButton()) {
      var r = e.option("filterRow.applyFilterText"), n = e._columnsController.getColumns(), a = !n.filter((u) => u.bufferedFilterValue !== void 0).length, o = {
        widget: "dxButton",
        options: {
          icon: "apply-filter",
          disabled: a,
          onClick: function() {
            e._applyFilterViewController.applyFilter();
          },
          hint: r,
          text: r,
          onInitialized: function(u) {
            E(u.element).addClass(e._getToolbarButtonClass(ZOe));
          }
        },
        showText: "inMenu",
        name: "applyFilterButton",
        location: "after",
        locateInMenu: "auto",
        sortIndex: 10
      };
      i.push(o);
    }
    return i;
  }
  _isShowApplyFilterButton() {
    var e = this.option("filterRow");
    return !!(e != null && e.visible) && e.applyFilter === "onClick";
  }
  enableApplyButton(e) {
    this.setToolbarItemDisabled("applyFilterButton", !e);
  }
  isVisible() {
    return super.isVisible() || this._isShowApplyFilterButton();
  }
}, cRe = {
  defaultOptions: () => ({
    syncLookupFilterValues: !0,
    filterRow: {
      visible: !1,
      showOperationChooser: !0,
      showAllText: X.format("dxDataGrid-filterRowShowAllText"),
      resetOperationText: X.format("dxDataGrid-filterRowResetOperationText"),
      applyFilter: "auto",
      applyFilterText: X.format("dxDataGrid-applyFilterText"),
      operationDescriptions: {
        equal: X.format("dxDataGrid-filterRowOperationEquals"),
        notEqual: X.format("dxDataGrid-filterRowOperationNotEquals"),
        lessThan: X.format("dxDataGrid-filterRowOperationLess"),
        lessThanOrEqual: X.format("dxDataGrid-filterRowOperationLessOrEquals"),
        greaterThan: X.format("dxDataGrid-filterRowOperationGreater"),
        greaterThanOrEqual: X.format("dxDataGrid-filterRowOperationGreaterOrEquals"),
        startsWith: X.format("dxDataGrid-filterRowOperationStartsWith"),
        contains: X.format("dxDataGrid-filterRowOperationContains"),
        notContains: X.format("dxDataGrid-filterRowOperationNotContains"),
        endsWith: X.format("dxDataGrid-filterRowOperationEndsWith"),
        between: X.format("dxDataGrid-filterRowOperationBetween"),
        isBlank: X.format("dxFilterBuilder-filterOperationIsBlank"),
        isNotBlank: X.format("dxFilterBuilder-filterOperationIsNotBlank")
      },
      betweenStartText: X.format("dxDataGrid-filterRowOperationBetweenStartText"),
      betweenEndText: X.format("dxDataGrid-filterRowOperationBetweenEndText")
    }
  }),
  controllers: {
    applyFilter: sRe
  },
  extenders: {
    controllers: {
      data: oRe,
      columnsResizer: lRe,
      editing: uRe
    },
    views: {
      columnHeadersView: aRe,
      headerPanel: dRe
    }
  }
};
et.registerModule("filterRow", cRe);
Mp.setEditorClass(ES);
var E2 = "dx-header-filter", b2 = "dx-header-filter-menu", hRe = "text";
function P8(t) {
  t = t || [];
  for (var e = 0; e < t.length; e++)
    t[e].selected = !1, P8(t[e].items);
}
function F8(t) {
  var e = t.NAME === "dxTreeView" ? ".dx-treeview-select-all-item" : ".dx-list-select-all-checkbox";
  return t.$element().find(e).dxCheckBox("instance");
}
function w2(t, e) {
  if (!t.component.option("searchValue")) {
    var i = F8(t.component);
    i && e && e.length && i.option("value", void 0);
  }
}
function fRe(t, e, i) {
  if (e ^ i) {
    if (t.selected = !0, i && t.items) {
      for (var r = 0; r < t.items.length; r++)
        if (!t.items[r].selected) {
          t.selected = void 0;
          break;
        }
    }
  } else
    (i || t.selected) && (t.selected = !1, P8(t.items));
}
class pRe extends Bi.View {
  getPopupContainer() {
    return this._popupContainer;
  }
  getListComponent() {
    return this._listComponent;
  }
  applyHeaderFilter(e) {
    var i = this.getListComponent(), r = i.option("searchValue"), n = F8(i), a = !r && !e.isFilterBuilder && (n == null ? void 0 : n.option("value")), o = [];
    a ? (e.type === "tree" && (e.filterType = "exclude"), Array.isArray(e.filterValues) && (e.filterValues = [])) : e.type === "tree" && (e.filterType && (e.filterType = "include"), function u(c, p, v) {
      N(p, (_, y) => {
        if (y.selected !== void 0 && !!y.selected ^ v) {
          var b = i._getNode(y), I = i._hasChildren(b), A = I && y.items && y.items.some((L) => L.selected);
          if (!r || !A) {
            c.push(y.value);
            return;
          }
        }
        y.items && y.items.length && u(c, y.items, v);
      });
    }(o, i.option("items"), !1), e.filterValues = o), e.filterValues && !e.filterValues.length && (e.filterValues = null), e.apply(), this.hideHeaderFilterMenu();
  }
  showHeaderFilterMenu(e, i) {
    if (i) {
      this._initializePopupContainer(i);
      var r = this.getPopupContainer();
      this.hideHeaderFilterMenu(), this.updatePopup(e, i), r.show();
    }
  }
  hideHeaderFilterMenu() {
    var e = this.getPopupContainer();
    e && e.hide();
  }
  updatePopup(e, i) {
    var r = this.option("showColumnLines"), n = i.alignment === "right" ^ !r ? "left" : "right";
    this._popupContainer.setAria({
      role: "dialog",
      label: X.format("dxDataGrid-headerFilterLabel")
    }), this._popupContainer && (this._cleanPopupContent(), this._popupContainer.option("position", {
      my: "".concat(n, " top"),
      at: "".concat(n, " bottom"),
      of: e,
      collision: "fit fit"
    }));
  }
  _getSearchExpr(e, i) {
    var {
      lookup: r
    } = e, {
      useDefaultSearchExpr: n
    } = e, a = i.dataSource, o = i.search.searchExpr;
    if (o)
      return o;
    if (n || R(a) && !Le(a))
      return hRe;
    if (r)
      return r.displayExpr || "this";
    if (e.dataSource) {
      var {
        group: u
      } = e.dataSource;
      if (Array.isArray(u) && u.length > 0)
        return u[0].selector;
      if (Le(u) && !e.remoteFiltering)
        return u;
    }
    return e.dataField || e.selector;
  }
  _cleanPopupContent() {
    this._popupContainer && this._popupContainer.$content().empty();
  }
  _initializePopupContainer(e) {
    var i = this, r = i.element(), n = this._normalizeHeaderFilterOptions(e), {
      height: a,
      width: o
    } = n, u = {
      width: o,
      height: a,
      visible: !1,
      shading: !1,
      showTitle: !1,
      showCloseButton: !1,
      hideOnParentScroll: !1,
      dragEnabled: !1,
      hideOnOutsideClick: !0,
      wrapperAttr: {
        class: b2
      },
      focusStateEnabled: !1,
      toolbarItems: [{
        toolbar: "bottom",
        location: "after",
        widget: "dxButton",
        options: {
          text: n.texts.ok,
          onClick() {
            i.applyHeaderFilter(e);
          }
        }
      }, {
        toolbar: "bottom",
        location: "after",
        widget: "dxButton",
        options: {
          text: n.texts.cancel,
          onClick() {
            i.hideHeaderFilterMenu();
          }
        }
      }],
      resizeEnabled: !0,
      onShowing(c) {
        c.component.$content().parent().addClass("dx-dropdowneditor-overlay"), i._initializeListContainer(e, n), e.onShowing && e.onShowing(c);
      },
      onShown() {
        i.getListComponent().focus();
      },
      onHidden: e.onHidden,
      onInitialized(c) {
        var {
          component: p
        } = c;
        p.option("animation", p._getDefaultOptions().animation);
      }
    };
    R(i._popupContainer) ? i._popupContainer.option(u) : i._popupContainer = i._createComponent(r, Hu, u);
  }
  _initializeListContainer(e, i) {
    var r = this, n = r._popupContainer.$content(), a = !e.isFilterBuilder && i.allowSelectAll, o = {
      searchEnabled: i.search.enabled,
      searchTimeout: i.search.timeout,
      searchEditorOptions: i.search.editorOptions,
      searchMode: i.search.mode || "",
      dataSource: e.dataSource,
      onContentReady() {
        r.renderCompleted.fire();
      },
      itemTemplate(c, p, v) {
        var _ = E(v);
        return e.encodeHtml ? _.text(c.text) : _.html(c.text);
      }
    };
    function u(c) {
      c.fullName === "searchValue" && a && r.option("headerFilter.hideSelectAllOnSearch") !== !1 && (e.type === "tree" ? c.component.option("showCheckBoxesMode", c.value ? "normal" : "selectAll") : c.component.option("selectionMode", c.value ? "multiple" : "all"));
    }
    e.type === "tree" ? r._listComponent = r._createComponent(E("<div>").appendTo(n), TS, P(o, {
      showCheckBoxesMode: a ? "selectAll" : "normal",
      onOptionChanged: u,
      keyExpr: "id"
    })) : r._listComponent = r._createComponent(E("<div>").appendTo(n), Gm, P(o, {
      searchExpr: r._getSearchExpr(e, i),
      pageLoadMode: "scrollBottom",
      showSelectionControls: !0,
      selectionMode: a ? "all" : "multiple",
      onOptionChanged: u,
      onSelectionChanged(c) {
        var p = c.component.option("items"), v = c.component.option("selectedItems");
        if (!c.component._selectedItemsUpdating && !c.component.option("searchValue") && !e.isFilterBuilder) {
          var _ = e.filterValues || [], y = e.filterType === "exclude";
          v.length === 0 && p.length && (_.length <= 1 || y && _.length === p.length - 1) ? (e.filterType = "include", e.filterValues = []) : v.length === p.length && (e.filterType = "exclude", e.filterValues = []);
        }
        N(p, (b, I) => {
          var A = xe.getIndexByKey(I, v, null) >= 0, L = !!I.selected;
          if (L !== A) {
            I.selected = A, e.filterValues = e.filterValues || [];
            var B = xe.getIndexByKey(I.value, e.filterValues, null);
            B >= 0 && e.filterValues.splice(B, 1);
            var $ = e.filterType === "exclude";
            A ^ $ && e.filterValues.push(I.value);
          }
        }), w2(c, e.filterValues);
      },
      onContentReady(c) {
        var {
          component: p
        } = c, v = p.option("items"), _ = [];
        N(v, function() {
          this.selected && _.push(this);
        }), p._selectedItemsUpdating = !0, p.option("selectedItems", _), p._selectedItemsUpdating = !1, w2(c, e.filterValues);
      }
    }));
  }
  _normalizeHeaderFilterOptions(e) {
    var i = this.option("headerFilter") || {}, r = e.headerFilter || {}, n = {
      search: {
        enabled: i.allowSearch,
        timeout: i.searchTimeout
      }
    }, a = {
      search: {
        enabled: r.allowSearch,
        mode: r.searchMode,
        timeout: r.searchTimeout
      }
    };
    return P(!0, {}, i, n, r, a);
  }
  _renderCore() {
    this.element().addClass(b2);
  }
}
var VI = function(t) {
  return R(t.allowHeaderFiltering) ? t.allowHeaderFiltering : t.allowFiltering;
}, B8 = (t) => class extends t {
  optionChanged(e) {
    if (e.name === "headerFilter") {
      var i = this.name === "columnHeadersView";
      this._invalidate(i, i), e.handled = !0;
    } else
      super.optionChanged(e);
  }
  _applyColumnState(e) {
    var i, {
      rootElement: r
    } = e, {
      column: n
    } = e;
    if (e.name === "headerFilter") {
      if (r.find(".".concat(E2)).remove(), VI(n)) {
        i = super._applyColumnState(e).toggleClass("dx-header-filter-empty", this._isHeaderFilterEmpty(n)), this.option("useLegacyKeyboardNavigation") || i.attr("tabindex", this.option("tabindex") || 0);
        var a = X.format("dxDataGrid-headerFilterIndicatorLabel", n.caption);
        i.attr("aria-label", a), i.attr("aria-haspopup", "dialog"), i.attr("role", "button");
      }
      return i;
    }
    return super._applyColumnState(e);
  }
  _isHeaderFilterEmpty(e) {
    return !e.filterValues || !e.filterValues.length;
  }
  _getIndicatorClassName(e) {
    return e === "headerFilter" ? E2 : super._getIndicatorClassName(e);
  }
  _renderIndicator(e) {
    var i = e.container, r = e.indicator;
    if (e.name === "headerFilter") {
      var n = this.option("rtlEnabled");
      if (i.children().length && (!n && e.columnAlignment === "right" || n && e.columnAlignment === "left")) {
        i.prepend(r);
        return;
      }
    }
    super._renderIndicator(e);
  }
}, vRe = {
  month: (t) => Bt.getMonthNames()[t - 1],
  quarter: (t) => Bt.format(new Date(2e3, 3 * t - 1), "quarter")
};
function V8(t, e, i) {
  return e = e || [], i = i || [], t.forEach((r) => {
    if (R(r.key)) {
      var n = e.length === 1;
      if (e.push(n ? r.key - 1 : r.key), r.items)
        V8(r.items, e, i);
      else {
        var a = new Date(Date.UTC.apply(Date, e));
        i.push(a);
      }
      e.pop();
    } else
      i.push(null);
  }), i;
}
function gRe(t, e) {
  var i = V8(t), r = lo(i), n = xe.getHeaderFilterGroupParameters(ae(ae({}, e), {
    calculateCellValue: (a) => a
  }));
  return rc.queryByOptions(r, {
    group: n
  }).toArray();
}
function mRe(t) {
  return (t == null ? void 0 : t.slice(-1)) === "Z" || (t == null ? void 0 : t.slice(-3)) === "'Z'";
}
var _Re = function(t, e, i) {
  var r = Wp.getGroupInterval(e), n = xe.getFormatOptionsByColumn(e, "headerFilter");
  return r && (n.groupInterval = r[i], xe.isDateType(e.dataType) ? n.format = vRe[r[i]] : e.dataType === "number" && (n.getDisplayFormat = function() {
    var a = {
      format: e.format,
      target: "headerFilter"
    }, o = xe.formatValue(t, a), u = t + r[i], c = xe.formatValue(u, a);
    return o && c ? "".concat(o, " - ").concat(c) : "";
  })), n;
};
class CRe extends Bi.ViewController {
  init() {
    this._columnsController = this.getController("columns"), this._dataController = this.getController("data"), this._headerFilterView = this.getView("headerFilterView");
  }
  _updateSelectedState(e, i) {
    for (var r = e.length, n = i.filterType === "exclude"; r--; ) {
      var a = e[r];
      "items" in e[r] && this._updateSelectedState(e[r].items, i), fRe(a, xe.getIndexByKey(e[r].value, i.filterValues, null) > -1, n);
    }
  }
  _normalizeGroupItem(e, i, r) {
    var n, a, {
      path: o
    } = r, {
      valueSelector: u
    } = r, {
      displaySelector: c
    } = r, {
      column: p
    } = r;
    return u && c ? (n = u(e), a = c(e)) : (n = e.key, a = n), ct(e) ? e = P({}, e) : e = {}, o.push(n), o.length === 1 ? e.value = o[0] : e.value = o.join("/"), e.text = this.getHeaderItemText(a, p, i, r.headerFilterOptions), e;
  }
  getHeaderItemText(e, i, r, n) {
    var a = xe.formatValue(e, _Re(e, i, r));
    return a || (a = n.texts.emptyValue), a;
  }
  _processGroupItems(e, i, r, n) {
    var a, o, {
      column: u
    } = n, {
      lookup: c
    } = u, {
      level: p
    } = n;
    r = r || [], i = i || 0, c && (a = Ii(c.displayExpr), o = Ii(c.valueExpr));
    for (var v = 0; v < e.length; v++)
      e[v] = this._normalizeGroupItem(e[v], i, {
        column: n.column,
        headerFilterOptions: n.headerFilterOptions,
        displaySelector: a,
        valueSelector: o,
        path: r
      }), "items" in e[v] && (i === p || !R(e[v].value) ? delete e[v].items : this._processGroupItems(e[v].items, i + 1, r, n)), r.pop();
  }
  getDataSource(e) {
    var i, r = this._dataController.dataSource(), n = r == null ? void 0 : r.remoteOperations().grouping, a = xe.getHeaderFilterGroupParameters(e, n), o = (i = e.headerFilter) === null || i === void 0 ? void 0 : i.dataSource, u = this.option("headerFilter"), c = !1, p = {
      component: this.component
    };
    if (r) {
      if (R(o) && !Le(o))
        p.dataSource = zp(o);
      else if (e.lookup)
        if (c = !0, this.option("syncLookupFilterValues")) {
          this._currentColumn = e;
          var v = this._dataController.getCombinedFilter();
          this._currentColumn = null, p.dataSource = xe.getWrappedLookupDataSource(e, r, v);
        } else
          p.dataSource = xe.normalizeLookupDataSource(e.lookup);
      else {
        var _ = Array.isArray(a) ? a.length - 1 : 0;
        this._currentColumn = e;
        var y = this._dataController.getCombinedFilter();
        this._currentColumn = null, p.dataSource = {
          filter: y,
          group: a,
          useDefaultSearch: !0,
          load: (A) => {
            var L = new q();
            return A.dataField = e.dataField || e.name, r.load(A).done((B) => {
              var $ = n && mRe(e.serializationFormat) && _ > 3;
              $ && (B = gRe(B, e)), I._processGroupItems(B, null, null, {
                level: _,
                column: e,
                headerFilterOptions: u
              }), L.resolve(B);
            }).fail(L.reject), L;
          }
        };
      }
      Le(o) && o.call(e, p);
      var b = p.dataSource.postProcess, I = this;
      return p.dataSource.postProcess = function(A) {
        var L = A;
        return c && (L = L.filter((B) => B[e.lookup.valueExpr] !== null), this.pageIndex() === 0 && !this.searchValue() && (L = L.slice(0), L.unshift(null)), I._processGroupItems(L, null, null, {
          level: 0,
          column: e,
          headerFilterOptions: u
        })), L = b && b.call(this, L) || L, I._updateSelectedState(L, e), L;
      }, p.dataSource;
    }
  }
  getCurrentColumn() {
    return this._currentColumn;
  }
  showHeaderFilterMenu(e, i) {
    var r = this._columnsController, n = P(!0, {}, this._columnsController.getColumns()[e]);
    if (n) {
      var a = r.getVisibleIndex(e), o = i ? this.getView("headerPanel") : this.getView("columnHeadersView"), u = o.getColumnElements().eq(i ? n.groupIndex : a);
      this.showHeaderFilterMenuBase({
        columnElement: u,
        column: n,
        applyFilter: !0,
        apply() {
          r.columnOption(e, {
            filterValues: this.filterValues,
            filterType: this.filterType
          });
        }
      });
    }
  }
  showHeaderFilterMenuBase(e) {
    var {
      column: i
    } = e;
    if (i) {
      var r = Wp.getGroupInterval(i), n = this._dataController.dataSource(), a = n && n.remoteOperations().filtering, o = e.onHidden;
      P(e, i, {
        type: r && r.length > 1 ? "tree" : "list",
        remoteFiltering: a,
        onShowing: (u) => {
          var c = u.component.$overlayContent().dxResizable("instance");
          c && c.option("onResizeEnd", (p) => {
            var v = this._columnsController.columnOption(e.dataField, "headerFilter");
            v = v || {}, v.width = p.width, v.height = p.height, this._columnsController.columnOption(e.dataField, "headerFilter", v, !0);
          });
        },
        onHidden: () => {
          o == null || o(), JF(this);
        }
      }), e.dataSource = this.getDataSource(e), e.isFilterBuilder && (e.dataSource.filter = null, e.alignment = "right"), this._headerFilterView.showHeaderFilterMenu(e.columnElement, e);
    }
  }
  hideHeaderFilterMenu() {
    this._headerFilterView.hideHeaderFilterMenu();
  }
}
var yRe = (t) => class extends B8(t) {
  _renderCellContent(e, i) {
    var r, {
      column: n
    } = i;
    !n.command && VI(n) && this.option("headerFilter.visible") && i.rowType === "header" && (r = this._applyColumnState({
      name: "headerFilter",
      rootElement: e,
      column: n,
      showColumnLines: this.option("showColumnLines")
    }), r && this._subscribeToIndicatorEvent(r, n, "headerFilter")), super._renderCellContent.apply(this, arguments);
  }
  _subscribeToIndicatorEvent(e, i, r) {
    r === "headerFilter" && k.on(e, di, this.createAction((n) => {
      n.event.stopPropagation(), Kq(e, this), this._headerFilterController.showHeaderFilterMenu(i.index, !1);
    }));
  }
  _updateIndicator(e, i, r) {
    var n = super._updateIndicator(e, i, r);
    n && this._subscribeToIndicatorEvent(n, i, r);
  }
  _updateHeaderFilterIndicators() {
    this.option("headerFilter.visible") && this._updateIndicators("headerFilter");
  }
  _needUpdateFilterIndicators() {
    return !0;
  }
  _columnOptionChanged(e) {
    var {
      optionNames: i
    } = e, r = xe.checkChanges(i, ["filterValues", "filterValue"]), n = xe.checkChanges(i, ["filterValues", "filterType"]), a = (r || n) && this._needUpdateFilterIndicators();
    a && this._updateHeaderFilterIndicators(), n || super._columnOptionChanged(e);
  }
}, xRe = (t) => class extends B8(t) {
  _createGroupPanelItem(e, i) {
    var r = super._createGroupPanelItem.apply(this, arguments), n;
    return !i.command && VI(i) && this.option("headerFilter.visible") && (n = this._applyColumnState({
      name: "headerFilter",
      rootElement: r,
      column: {
        alignment: Nh(this.option("rtlEnabled")),
        filterValues: i.filterValues,
        allowHeaderFiltering: !0,
        caption: i.caption
      },
      showColumnLines: !0
    }), n && k.on(n, di, this.createAction((a) => {
      var {
        event: o
      } = a;
      o.stopPropagation(), this._headerFilterController.showHeaderFilterMenu(i.index, !0);
    }))), r;
  }
};
var SRe = (t) => class extends t {
  skipCalculateColumnFilters() {
    return !1;
  }
  _calculateAdditionalFilter() {
    if (this.skipCalculateColumnFilters())
      return super._calculateAdditionalFilter();
    var e = [super._calculateAdditionalFilter()], i = this._columnsController.getVisibleColumns(null, !0), r = this._headerFilterController, n = r.getCurrentColumn();
    return N(i, (a, o) => {
      var u;
      if (!(n && n.index === o.index) && VI(o) && o.calculateFilterExpression && Array.isArray(o.filterValues) && o.filterValues.length) {
        var c = [];
        N(o.filterValues, (p, v) => {
          Array.isArray(v) ? u = v : (o.deserializeValue && !xe.isDateType(o.dataType) && o.dataType !== "number" && (v = o.deserializeValue(v)), u = o.createFilterExpression(v, "=", "headerFilter")), u && (u.columnIndex = o.index), c.push(u);
        }), c = xe.combineFilters(c, "or"), e.push(o.filterType === "exclude" ? ["!", c] : c);
      }
    }), xe.combineFilters(e);
  }
}, ERe = {
  defaultOptions: () => ({
    syncLookupFilterValues: !0,
    headerFilter: {
      visible: !1,
      width: 252,
      height: 325,
      allowSelectAll: !0,
      search: {
        enabled: !1,
        timeout: 500,
        mode: "contains",
        editorOptions: {}
      },
      texts: {
        emptyValue: X.format("dxDataGrid-headerFilterEmptyValue"),
        ok: X.format("dxDataGrid-headerFilterOK"),
        cancel: X.format("dxDataGrid-headerFilterCancel")
      }
    }
  }),
  controllers: {
    headerFilter: CRe
  },
  views: {
    headerFilterView: pRe
  },
  extenders: {
    controllers: {
      data: SRe
    },
    views: {
      columnHeadersView: yRe,
      headerPanel: xRe
    }
  }
};
et.registerModule("headerFilter", ERe);
var NI = "dx-filterbuilder-range", bRe = "".concat(NI, "-start"), wRe = "".concat(NI, "-end"), TRe = "".concat(NI, "-separator"), N8 = "–";
function IRe(t, e) {
  var i = E("<div>").addClass(bRe), r = E("<div>").addClass(wRe), n = t.value || [], a = function(u) {
    return u && u.length > 0 ? u[0] : null;
  }, o = function(u) {
    return u && u.length === 2 ? u[1] : null;
  };
  e.append(i), e.append(E("<span>").addClass(TRe).text(N8)), e.append(r), e.addClass(NI), this._editorFactory.createEditor.call(this, i, P({}, t.field, t, {
    value: a(n),
    parentType: "filterBuilder",
    setValue(u) {
      n = [u, o(n)], t.setValue(n);
    }
  })), this._editorFactory.createEditor.call(this, r, P({}, t.field, t, {
    value: o(n),
    parentType: "filterBuilder",
    setValue(u) {
      n = [a(n), u], t.setValue(n);
    }
  }));
}
function T2(t, e) {
  return {
    name: "between",
    caption: t,
    icon: "range",
    valueSeparator: N8,
    dataTypes: ["number", "date", "datetime"],
    editorTemplate: IRe.bind(e),
    notForLookup: !0
  };
}
var DRe = {
  "=": "equal",
  "<>": "notequal",
  "<": "less",
  "<=": "lessorequal",
  ">": "greater",
  ">=": "greaterorequal",
  notcontains: "doesnotcontain",
  contains: "contains",
  startswith: "startswith",
  endswith: "endswith",
  isblank: "isblank",
  isnotblank: "isnotblank"
}, ARe = {
  "=": "equal",
  "<>": "notEqual",
  "<": "lessThan",
  "<=": "lessThanOrEqual",
  ">": "greaterThan",
  ">=": "greaterThanOrEqual",
  startswith: "startsWith",
  contains: "contains",
  notcontains: "notContains",
  endswith: "endsWith",
  isblank: "isBlank",
  isnotblank: "isNotBlank",
  between: "between"
};
const H8 = {
  getIconByFilterOperation: (t) => DRe[t],
  getNameByFilterOperation: (t) => ARe[t]
};
var iV = "string", I2 = "icon-none", kh = "and", rV = "=", ORe = "<>", RRe = {
  number: ["=", "<>", "<", ">", "<=", ">=", "isblank", "isnotblank"],
  string: ["contains", "notcontains", "startswith", "endswith", "=", "<>", "isblank", "isnotblank"],
  date: ["=", "<>", "<", ">", "<=", ">=", "isblank", "isnotblank"],
  datetime: ["=", "<>", "<", ">", "<=", ">=", "isblank", "isnotblank"],
  boolean: ["=", "<>", "isblank", "isnotblank"],
  object: ["isblank", "isnotblank"]
}, LRe = {
  date: "shortDate",
  datetime: "shortDateShortTime"
}, MRe = ["=", "<>", "isblank", "isnotblank"], kRe = ["caption", "customizeText", "dataField", "dataType", "editorTemplate", "falseText", "editorOptions", "filterOperations", "format", "lookup", "trueText", "calculateFilterExpression", "name"], PRe = "dx-filterbuilder", $8 = "".concat(PRe, "-text"), FRe = "".concat($8, "-part"), z8 = "".concat($8, "-separator"), BRe = "".concat(z8, "-empty");
function VRe(t, e) {
  var i = t.format || LRe[t.dataType];
  return F6.format(e, i);
}
function Bp(t) {
  return t && t.length > 1 && t[0] === "!" && !$n(t);
}
function Hh(t) {
  return Bp(t) ? t[1] : t;
}
function NRe(t, e) {
  return Bp(t) ? t[1] = e : t = e, t;
}
function HRe(t, e) {
  (function(i) {
    return i.indexOf("!") !== -1;
  })(e) ? Bp(t) || function(i) {
    var r = i.slice(0);
    i.length = 0, i.push("!", r);
  }(t) : Bp(t) && function(i) {
    var r = Hh(i);
    i.length = 0, [].push.apply(i, r);
  }(t);
}
function $Re(t, e) {
  HRe(t, e);
  var i = Hh(t), r;
  return e = function(n) {
    return n.indexOf("!") === -1 ? n : n.substring(1);
  }(e), function(n, a) {
    for (r = 0; r < n.length; r++)
      Array.isArray(n[r]) || (n[r] = a);
  }(i, e), t;
}
function zRe(t, e) {
  var i = Qp(t);
  return e.filter((r) => r.value === i)[0];
}
function W8(t) {
  if ($n(t))
    return kh;
  for (var e = "", i = 0; i < t.length; i++) {
    var r = t[i];
    if (!Array.isArray(r)) {
      if (e && e !== r)
        throw new Zr.Error("E4019");
      r !== "!" && (e = r);
    }
  }
  return e;
}
function Qp(t) {
  var e = Hh(t), i = W8(e);
  return i || (i = kh), e !== t && (i = "!".concat(i)), i;
}
function WRe(t) {
  return t.lookup && MRe || RRe[t.dataType || iV];
}
function URe(t) {
  return Array.isArray(t) && t.length;
}
function U8(t) {
  var e = URe(t.filterOperations) ? t.filterOperations : WRe(t);
  return P([], e);
}
function zP(t, e) {
  var i = H8.getNameByFilterOperation(t);
  return e && e[i] ? e[i] : i;
}
function GRe(t, e) {
  for (var i = 0; i < e.length; i++)
    if (e[i].value === t)
      return e[i];
  throw new Yt.Error("E1048", t);
}
function Qd(t, e) {
  var i = t.filter((r) => r.name === e);
  return i.length ? i[0] : null;
}
function KRe(t, e, i) {
  var r = U8(t), n = !!t.lookup;
  return i.forEach((a) => {
    if (!t.filterOperations && r.indexOf(a.name) === -1) {
      var o = a && a.dataTypes, u = n ? !!a.notForLookup : !1;
      !u && o && o.indexOf(t.dataType || iV) >= 0 && r.push(a.name);
    }
  }), r.map((a) => {
    var o = Qd(i, a);
    return o ? {
      icon: o.icon || I2,
      text: o.caption || bp(o.name),
      value: o.name,
      isCustom: !0
    } : {
      icon: H8.getIconByFilterOperation(a) || I2,
      text: zP(a, e),
      value: a
    };
  });
}
function nV(t) {
  return t.defaultFilterOperation || U8(t)[0];
}
function jRe(t, e) {
  var i = [t.dataField, "", ""], r = nV(t);
  return UP(i, r, e), i;
}
function WP(t, e) {
  var i = Hh(t), r = i.indexOf(e);
  return i.splice(r, 1), i.length !== 1 && i.splice(r, 1), t;
}
function G8(t) {
  var e = aV(t), i = e ? oV(t) : t;
  return e ? ["!", [i]] : [i];
}
function qT(t, e) {
  var i = Hh(e), r = Qp(i);
  return i.length === 1 ? i.unshift(t) : i.push(t, r), e;
}
function XT(t, e) {
  for (var i = 0; i < e.length; i++)
    if (e[i].name === t || e[i].dataField.toLowerCase() === t.toLowerCase())
      return e[i];
  var r = Q8(e, !0).filter((n) => n.dataField.toLowerCase() === t.toLowerCase());
  if (r.length > 0)
    return r[0];
  throw new Yt.Error("E1047", t);
}
function $h(t) {
  return Array.isArray(t) ? t.length < 2 || Array.isArray(t[0]) || Array.isArray(t[1]) : !1;
}
function $n(t) {
  return Array.isArray(t) ? t.length > 1 && !Array.isArray(t[0]) && !Array.isArray(t[1]) : !1;
}
function D2(t, e, i) {
  i = i || kh;
  for (var r = W8(t).toLowerCase() || i, n = [], a = 0; a < t.length; a++)
    $h(t[a]) ? (n.push(sV(t[a], e, i)), n = tk(n, r)) : $n(t[a]) && (n.push(QT(t[a], e)), n = tk(n, r));
  return n.length === 0 && (n = tk(n, r)), n;
}
function YRe(t, e) {
  var i = Qd(e, t[1]);
  return i && i.name === t[1];
}
function QT(t, e) {
  return YRe(t, e) || t.length < 3 && (t[2] = t[1], t[1] = rV), t;
}
function aV(t) {
  return t.indexOf("not") !== -1;
}
function oV(t) {
  return t.substring(3).toLowerCase();
}
function ek(t, e) {
  var i = aV(e);
  return e = i ? oV(e) : e, i ? ["!", t, e] : [t, e];
}
function tk(t, e) {
  var i = aV(e);
  e = i ? oV(e) : e, t.push(e);
  var r = t;
  return i && (r = ["!", r]), r;
}
function sV(t, e, i) {
  return i = i || kh, t ? (t = P(!0, [], t), $n(t) ? ek(QT(t, e), i) : Bp(t) ? ["!", $n(t[1]) ? ek(QT(t[1], e), i) : Bp(t[1]) ? ek(sV(t[1], e), i) : D2(t[1], e, i)] : D2(t, e, i)) : G8(i);
}
function qRe(t) {
  return t.reduce((e, i) => {
    if (R(i.dataField)) {
      var r = {};
      for (var n in i)
        i[n] && kRe.includes(n) && (r[n] = i[n]);
      r.defaultCalculateFilterExpression = Wp.defaultCalculateFilterExpression, R(r.dataType) || (r.dataType = iV), R(r.trueText) || (r.trueText = X.format("dxDataGrid-trueText")), R(r.falseText) || (r.falseText = X.format("dxDataGrid-falseText")), e.push(r);
    }
    return e;
  }, []);
}
function A2(t, e, i, r) {
  var n = XT(t[0], e), a = QT(t, i), o = i.length && Qd(i, a[1]);
  return o && o.calculateFilterExpression ? o.calculateFilterExpression.apply(o, [a[2], n, e]) : n.createFilterExpression ? n.createFilterExpression.apply(n, [a[2], a[1], r]) : n.calculateFilterExpression ? n.calculateFilterExpression.apply(n, [a[2], a[1], r]) : n.defaultCalculateFilterExpression.apply(n, [a[2], a[1], r]);
}
function Fm(t, e, i, r) {
  if (!R(t))
    return null;
  if (Bp(t)) {
    var n = Fm(t[1], e, i, r);
    return ["!", n];
  }
  var a = Hh(t);
  if ($n(a))
    return A2(a, e, i, r) || null;
  for (var o = [], u, c = Qp(a), p = 0; p < a.length; p++)
    $h(a[p]) ? (u = Fm(a[p], e, i, r), u && (p && o.push(c), o.push(u))) : $n(a[p]) && (u = A2(a[p], e, i, r), u && (o.length && o.push(c), o.push(u)));
  return o.length === 1 && (o = o[0]), o.length ? o : null;
}
function yx(t) {
  var e = Hh(t), i;
  if (e.length === 0)
    return null;
  var r = [];
  for (i = 0; i < e.length; i++)
    if ($h(e[i])) {
      var n = yx(e[i]);
      n ? e[i] = n : r.push(e[i]);
    } else
      $n(e[i]) && (QRe(e[i]) || r.push(e[i]));
  for (i = 0; i < r.length; i++)
    WP(e, r[i]);
  return e.length === 1 || (e.splice(e.length - 1, 1), e.length === 1 && (t = NRe(t, e[0])), t.length === 0) ? null : t;
}
function K8(t, e, i) {
  if (e === "") {
    i("");
    return;
  }
  var {
    lookup: r
  } = t;
  if (r.items)
    i(r.calculateCellValue(e) || "");
  else {
    var n = Le(r.dataSource) ? r.dataSource({}) : r.dataSource, a = new Ks(n);
    a.loadSingle(r.valueExpr, e).done((o) => {
      var u = "";
      o && (u = r.displayExpr ? Ii(r.displayExpr)(o) : o), t.customizeText && (u = t.customizeText({
        value: e,
        valueText: u
      })), i(u);
    }).fail(() => {
      i("");
    });
  }
}
function j8(t, e, i, r, n) {
  var a;
  return e === !0 ? a = t.trueText || X.format("dxDataGrid-trueText") : e === !1 ? a = t.falseText || X.format("dxDataGrid-falseText") : a = VRe(t, e), t.customizeText && (a = t.customizeText.call(t, {
    value: e,
    valueText: a,
    target: r
  })), i && i.customizeText && (a = i.customizeText.call(i, {
    value: e,
    valueText: a,
    field: t,
    target: r
  }, n)), a;
}
function XRe(t, e, i, r) {
  var n = {
    values: e
  };
  return e.map((a) => j8(t, a, i, r, n));
}
function ik(t) {
  return t === "" || t === null;
}
function Y8(t, e, i) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "filterBuilder";
  if (ik(e))
    return "";
  if (Array.isArray(e)) {
    var n = new q();
    return $e.apply(this, XRe(t, e, i, r)).done(function() {
      for (var a = arguments.length, o = new Array(a), u = 0; u < a; u++)
        o[u] = arguments[u];
      var c = o.some((p) => !ik(p)) ? o.map((p) => ik(p) ? "?" : p) : "";
      n.resolve(c);
    }), n;
  }
  return j8(t, e, i, r);
}
function O2(t, e) {
  return t.some((i) => i.dataField === e);
}
function q8(t, e, i) {
  var {
    dataField: r
  } = i;
  lV(r) && (i.parentId = Z8(r), !O2(e, i.parentId) && !O2(t, i.parentId) && q8(t, e, {
    id: i.parentId,
    dataType: "object",
    dataField: i.parentId,
    caption: X8(i.parentId, !0),
    filterOperations: ["isblank", "isnotblank"],
    defaultCalculateFilterExpression: Wp.defaultCalculateFilterExpression
  })), e.push(i);
}
function X8(t, e) {
  var i = "";
  if (e)
    t = t.substring(t.lastIndexOf(".") + 1);
  else if (lV(t))
    return t.split(".").forEach((r, n, a) => {
      i += bp(r), n !== a.length - 1 && (i += ".");
    }), i;
  return bp(t);
}
function Q8(t, e) {
  for (var i = [], r = 0; r < t.length; r++) {
    var n = P(!0, {
      caption: X8(t[r].dataField, e)
    }, t[r]);
    n.id = n.name || n.dataField, e ? q8(t, i, n) : i.push(n);
  }
  return i;
}
function lV(t) {
  return t.lastIndexOf(".") !== -1;
}
function Z8(t) {
  return t.substring(0, t.lastIndexOf("."));
}
function J8(t, e) {
  if (lV(t.dataField)) {
    for (var i = Z8(t.dataField), r = 0; r < e.length; r++)
      if (e[r].dataField === i)
        return "".concat(J8(e[r], e), ".").concat(t.caption);
  }
  return t.caption;
}
function UP(t, e, i) {
  var r = Qd(i, e);
  return r ? (r.hasValue === !1 ? (t[1] = e, t.length = 2) : (t[1] = e, t[2] = ""), t) : (e === "isblank" ? (t[1] = rV, t[2] = null) : e === "isnotblank" ? (t[1] = ORe, t[2] = null) : (r = Qd(i, t[1]), (r || t.length === 2 || t[2] === null) && (t[2] = ""), t[1] = e), t);
}
function R2(t) {
  var e;
  return t[2] === null ? t[1] === rV ? e = "isblank" : e = "isnotblank" : e = t[1], e;
}
function QRe(t) {
  return t[2] !== "";
}
function ZRe(t, e, i) {
  var r = P(!0, [], t), n = -1;
  return r.some((a, o) => {
    if (a.name === "between")
      return n = o, !0;
  }), n !== -1 ? r[n] = P(T2(e, i), r[n]) : r.unshift(T2(e, i)), r;
}
function Ux(t, e) {
  return t[0] === e;
}
function GP(t, e) {
  if (!t || t.length === 0)
    return null;
  if ($n(t)) {
    var i = Ux(t, e);
    return i ? null : t;
  }
  return e9(t, [e], !1);
}
function e9(t, e, i) {
  var r = [];
  return t.forEach((n) => {
    $n(n) ? Ux(n, e[0]) ? i ? (r.push(e), i = !1) : r.splice(r.length - 1, 1) : r.push(n) : (r.length || $h(n)) && r.push(n);
  }), r.length === 0 ? null : (i && (r.push(kh), r.push(e)), r.length === 1 ? r[0] : r);
}
function L2(t, e) {
  if (t === null || t.length === 0)
    return e;
  if ($n(t))
    return Ux(t, e[0]) ? e : [t, kh, e];
  var i = Qp(t);
  return i !== kh ? [e, "and", t] : e9(t, e, !0);
}
function JRe(t, e) {
  if (t === null || t.length === 0)
    return [];
  if ($n(t))
    return Ux(t, e) ? [t] : [];
  var i = Qp(t);
  if (i !== kh)
    return [];
  var r = t.filter((n) => $n(n) && Ux(n, e));
  return r;
}
function t9(t, e) {
  return t === null || t.length === 0 ? !1 : $n(t) ? t[0] === e : t.some((i) => ($n(i) || $h(i)) && t9(i, e));
}
var KP = function(t, e, i) {
  if (Array.isArray(e)) {
    var r = e.length - 1;
    t.empty(), e.forEach((n, a) => {
      E("<span>").addClass(FRe).text(n).appendTo(t), a !== r && E("<span>").addClass(z8).text(i && i.valueSeparator ? i.valueSeparator : "|").addClass(BRe).appendTo(t);
    });
  } else
    e ? t.text(e) : t.text(X.format("dxFilterBuilder-enterValueText"));
};
function i9(t) {
  var e = function(r, n) {
    return n ? "".concat(n, "/").concat(r) : r;
  }, i = t && t.getController("headerFilter");
  return {
    dataTypes: ["string", "date", "datetime", "number", "boolean", "object"],
    calculateFilterExpression: function(r, n, a) {
      var o = [], u = r.length - 1;
      return r && r.forEach((c, p) => {
        if ($n(c) || $h(c)) {
          var v = Fm(c, a, [], "headerFilter");
          o.push(v);
        } else {
          var _ = Fm([n.dataField, "=", c], a, [], "headerFilter");
          o.push(_);
        }
        p !== u && o.push("or");
      }), o.length === 1 ? o[0] : o;
    },
    editorTemplate(r, n) {
      var a = E("<div>").addClass("dx-filterbuilder-item-value-text").appendTo(n), o = P(!0, {}, t.columnOption(r.field.dataField));
      return KP(a, r.text && r.text.split("|")), o.filterType = "include", o.filterValues = r.value ? r.value.slice() : [], i.showHeaderFilterMenuBase({
        columnElement: a,
        column: o,
        apply() {
          u = this.filterValues, r.setValue(u);
          var u;
          i.hideHeaderFilterMenu(), r.closeEditor();
        },
        onHidden() {
          r.closeEditor();
        },
        isFilterBuilder: !0
      }), n;
    },
    customizeText: function(r, n) {
      n = n || {};
      var {
        value: a
      } = r, o = t.columnOption(r.field.dataField), u = o && o.headerFilter, c = o && o.lookup, p = n.values || [a];
      if (u && u.dataSource || c && c.dataSource) {
        var v = new q(), _ = n.items || new q();
        if (!n.items) {
          o = P({}, o, {
            filterType: "include",
            filterValues: p
          });
          var y = i.getDataSource(o);
          y.paginate = !1;
          var b = new Ks(y), I = b.store().key();
          if (I) {
            var {
              values: A
            } = n;
            if (A && A.length > 1) {
              var L = A.reduce(($, K) => ($.length && $.push("or"), $.push([I, "=", K]), $), []);
              b.filter(L);
            } else
              b.filter([I, "=", r.value]);
          } else
            r.field.calculateDisplayValue && Yt.log("W1017");
          n.items = _, b.load().done(_.resolve);
        }
        return _.done(($) => {
          var K = p.indexOf(r.value);
          v.resolve(function te(z, ie) {
            var pe = [];
            return z.forEach((_e) => {
              if (_e.items) {
                var be = te(_e.items, e(_e.text, ie));
                pe = pe.concat(be);
              }
              _e.selected && pe.push(e(_e.text, ie));
            }), pe;
          }($, null)[K]);
        }), v;
      }
      var B = i.getHeaderItemText(a, o, 0, t.option("headerFilter"));
      return B;
    }
  };
}
function eLe(t) {
  return P(i9(t), {
    name: "anyof",
    icon: "selectall",
    caption: X.format("dxFilterBuilder-filterOperationAnyOf")
  });
}
function tLe(t) {
  var e = i9(t);
  return P({}, e, {
    calculateFilterExpression(i, r, n) {
      var a = e.calculateFilterExpression(i, r, n);
      return !a || a.length === 0 ? null : a[0] === "!" ? a : ["!", a];
    },
    name: "noneof",
    icon: "unselectall",
    caption: X.format("dxFilterBuilder-filterOperationNoneOf")
  });
}
var iLe = ["=", "<>", "<", "<=", ">", ">=", "notcontains", "contains", "startswith", "endswith", "between"], r9 = "include", Gx = "exclude";
function Lu(t) {
  return t.name || t.dataField;
}
function rLe(t) {
  t.forEach((e) => {
    var i = Lu(e);
    if (!R(i) && e.allowFiltering)
      throw new Yt.Error("E1049", e.caption);
  });
}
var rk = function() {
  return {
    filterType: r9,
    filterValues: void 0
  };
}, n9 = function(t) {
  var e = t.filterValues || [];
  return !Wp.getGroupInterval(t) && !(t.headerFilter && t.headerFilter.dataSource) || e.length === 1 && e[0] === null;
}, nLe = function(t, e) {
  if (!t)
    return rk();
  var i, r = t[1], n = t[2], a = Array.isArray(n);
  if (!a && !n9(e))
    return rk();
  switch (r) {
    case "anyof":
    case "=":
      i = r9;
      break;
    case "noneof":
    case "<>":
      i = Gx;
      break;
    default:
      return rk();
  }
  return {
    filterType: i,
    filterValues: a ? n : [n]
  };
}, M2 = function(t) {
  var e = t.filterValue;
  if (R(e)) {
    var i = t.selectedFilterOperation || t.defaultFilterOperation || nV(t), r = [Lu(t), i, t.filterValue];
    return r;
  }
  return null;
}, k2 = function(t) {
  var e, i, {
    filterValues: r
  } = t;
  return r ? (r.length === 1 && n9(t) && !Array.isArray(r[0]) ? (t.filterType === Gx ? e = "<>" : e = "=", i = r[0]) : (t.filterType === Gx ? e = "noneof" : e = "anyof", i = r), [Lu(t), e, i]) : null;
}, P2 = function(t, e, i) {
  var r = nLe(i, e);
  t.columnOption(Lu(e), r);
}, F2 = function(t, e, i) {
  var r, n = i == null ? void 0 : i[1], a = i == null ? void 0 : i[2], o = e.filterOperations || e.defaultFilterOperations;
  (!o || o.indexOf(n) >= 0 || n === e.defaultFilterOperation) && iLe.includes(n) && a !== null ? (n === e.defaultFilterOperation && !R(e.selectedFilterOperation) && (n = e.selectedFilterOperation), r = {
    filterValue: a,
    selectedFilterOperation: n
  }) : r = {
    filterValue: void 0,
    selectedFilterOperation: void 0
  }, t.columnOption(Lu(e), r);
};
class aLe extends Bi.Controller {
  init() {
    this._dataController = this.getController("data"), this._columnsController = this.getController("columns"), this._dataController.isFilterSyncActive() && (this._columnsController.isAllDataTypesDefined() ? this._initSync() : this._dataController.dataSourceChanged.add(() => this._initSync()));
  }
  publicMethods() {
    return ["getCustomFilterOperations"];
  }
  syncFilterValue() {
    var e = this, i = this._columnsController.getFilteringColumns();
    this._skipSyncColumnOptions = !0, i.forEach((r) => {
      var n = JRe(e.option("filterValue"), Lu(r));
      if (n.length === 1) {
        var a = n[0];
        P2(this._columnsController, r, a), F2(this._columnsController, r, a);
      } else
        R(r.filterValues) && P2(this._columnsController, r, null), R(r.filterValue) && F2(this._columnsController, r, null);
    }), this._skipSyncColumnOptions = !1;
  }
  _initSync() {
    var e = this._columnsController.getColumns(), i = this._dataController.pageIndex();
    if (rLe(e), !this.option("filterValue")) {
      var r = this._columnsController.getFilteringColumns(), n = this.getFilterValueFromColumns(r);
      this._silentOption("filterValue", n);
    }
    this.syncFilterValue(), this._dataController.pageIndex(i);
  }
  _getSyncFilterRow(e, i) {
    var r = M2(i);
    return R(r) ? L2(e, r) : GP(e, Lu(i));
  }
  _getSyncHeaderFilter(e, i) {
    var r = k2(i);
    return r ? L2(e, r) : GP(e, Lu(i));
  }
  getFilterValueFromColumns(e) {
    if (!this._dataController.isFilterSyncActive())
      return null;
    var i = ["and"];
    return e && e.forEach((r) => {
      var n = k2(r), a = M2(r);
      n && qT(n, i), a && qT(a, i);
    }), yx(i);
  }
  syncFilterRow(e, i) {
    this.option("filterValue", this._getSyncFilterRow(this.option("filterValue"), e));
  }
  syncHeaderFilter(e) {
    this.option("filterValue", this._getSyncHeaderFilter(this.option("filterValue"), e));
  }
  getCustomFilterOperations() {
    var e, i = (e = this.option("filterBuilder.customOperations")) !== null && e !== void 0 ? e : [];
    return [eLe(this.component), tLe(this.component)].concat(i);
  }
}
var oLe = (t) => class extends t {
  optionChanged(e) {
    switch (e.name) {
      case "filterValue":
        this._applyFilter(), this.isFilterSyncActive() && this._filterSyncController.syncFilterValue(), e.handled = !0;
        break;
      case "filterSyncEnabled":
        e.handled = !0;
        break;
      case "columns":
        if (this.isFilterSyncActive()) {
          var i = this._columnsController.getColumnByPath(e.fullName);
          if (i && !this._filterSyncController._skipSyncColumnOptions) {
            var r = this._parseColumnPropertyName(e.fullName);
            this._filterSyncController._skipSyncColumnOptions = !0, r === "filterType" ? (Gx === e.value || Gx === e.previousValue) && this._filterSyncController.syncHeaderFilter(i) : r === "filterValues" ? this._filterSyncController.syncHeaderFilter(i) : ["filterValue", "selectedFilterOperation"].includes(r) && this._filterSyncController.syncFilterRow(i, i.filterValue), this._filterSyncController._skipSyncColumnOptions = !1;
          }
        }
        super.optionChanged(e);
        break;
      default:
        super.optionChanged(e);
    }
  }
  isFilterSyncActive() {
    var e = this.option("filterSyncEnabled");
    return e === "auto" ? this.option("filterPanel.visible") : e;
  }
  skipCalculateColumnFilters() {
    return (R(this.option("filterValue")) || this._filterSyncController._skipSyncColumnOptions) && this.isFilterSyncActive();
  }
  _calculateAdditionalFilter() {
    if (this.option("filterPanel.filterEnabled") === !1)
      return super._calculateAdditionalFilter();
    var e = [super._calculateAdditionalFilter()], i = this._columnsController.getFilteringColumns(), r = this.option("filterValue");
    if (this.isFilterSyncActive()) {
      var n = this._headerFilterController.getCurrentColumn(), a = this._applyFilterController.getCurrentColumnForFiltering(), o = n || a, u = n || R(a == null ? void 0 : a.filterValue);
      u && r && (r = GP(r, Lu(o)));
    }
    var c = this._filterSyncController.getCustomFilterOperations(), p = Fm(r, i, c, "filterBuilder");
    return p && e.push(p), xe.combineFilters(e);
  }
  _parseColumnPropertyName(e) {
    var i = e.match(/.*\.(.*)/);
    return i ? i[1] : null;
  }
  clearFilter(e) {
    this.component.beginUpdate(), arguments.length > 0 ? (e === "filterValue" && this.option("filterValue", null), super.clearFilter(e)) : (this.option("filterValue", null), super.clearFilter()), this.component.endUpdate();
  }
  _applyFilter() {
    return this._filterSyncController._skipSyncColumnOptions ? new q().resolve() : super._applyFilter.apply(this, arguments);
  }
}, sLe = (t) => class extends t {
  optionChanged(e) {
    e.name === "filterValue" ? this._updateHeaderFilterIndicators() : super.optionChanged(e);
  }
  _isHeaderFilterEmpty(e) {
    return this._dataController.isFilterSyncActive() ? !t9(this.option("filterValue"), Lu(e)) : super._isHeaderFilterEmpty(e);
  }
  _needUpdateFilterIndicators() {
    return !this._dataController.isFilterSyncActive();
  }
}, lLe = {
  defaultOptions: () => ({
    filterValue: null,
    filterSyncEnabled: "auto"
  }),
  controllers: {
    filterSync: aLe
  },
  extenders: {
    controllers: {
      data: oLe
    },
    views: {
      columnHeadersView: sLe
    }
  }
};
et.registerModule("filterSync", lLe);
var vs = "dx-filterbuilder", Bm = "".concat(vs, "-group"), B2 = "".concat(Bm, "-item"), V2 = "".concat(Bm, "-content"), uLe = "".concat(Bm, "-operations"), dLe = "".concat(Bm, "-operation"), jP = "".concat(vs, "-action"), N2 = "".concat(jP, "-icon"), cLe = "dx-icon-plus", hLe = "dx-icon-remove", Ky = "".concat(vs, "-text"), fLe = "".concat(vs, "-item-field"), pLe = "".concat(vs, "-item-operation"), H2 = "".concat(vs, "-item-value"), vLe = "".concat(vs, "-item-value-text"), gLe = "".concat(vs, "-overlay"), mLe = "".concat(vs, "-operations"), _Le = "".concat(vs, "-fields"), CLe = "".concat(vs, "-add-condition"), Tw = "dx-state-active", yLe = "".concat(vs, "-menu-custom-operation"), $2 = "filterBuilder", xLe = "dx-state-disabled", z2 = "tab", nk = "enter", W2 = "escape", SLe = [{
  name: "onEditorPreparing",
  config: {
    excludeValidators: ["disabled", "readOnly"],
    category: "rendering"
  }
}, {
  name: "onEditorPrepared",
  config: {
    excludeValidators: ["disabled", "readOnly"],
    category: "rendering"
  }
}, {
  name: "onValueChanged",
  config: {
    excludeValidators: ["disabled", "readOnly"]
  }
}], U2 = {
  and: "and",
  or: "or",
  notAnd: "!and",
  notOr: "!or"
}, ELe = XX(class {
});
let a9 = class extends xn {
  _getDefaultOptions() {
    return P(super._getDefaultOptions(), {
      onEditorPreparing: null,
      onEditorPrepared: null,
      onValueChanged: null,
      fields: [],
      groupOperations: ["and", "or", "notAnd", "notOr"],
      maxGroupLevel: void 0,
      value: null,
      allowHierarchicalFields: !1,
      groupOperationDescriptions: {
        and: X.format("dxFilterBuilder-and"),
        or: X.format("dxFilterBuilder-or"),
        notAnd: X.format("dxFilterBuilder-notAnd"),
        notOr: X.format("dxFilterBuilder-notOr")
      },
      customOperations: [],
      closePopupOnTargetScroll: !0,
      filterOperationDescriptions: {
        between: X.format("dxFilterBuilder-filterOperationBetween"),
        equal: X.format("dxFilterBuilder-filterOperationEquals"),
        notEqual: X.format("dxFilterBuilder-filterOperationNotEquals"),
        lessThan: X.format("dxFilterBuilder-filterOperationLess"),
        lessThanOrEqual: X.format("dxFilterBuilder-filterOperationLessOrEquals"),
        greaterThan: X.format("dxFilterBuilder-filterOperationGreater"),
        greaterThanOrEqual: X.format("dxFilterBuilder-filterOperationGreaterOrEquals"),
        startsWith: X.format("dxFilterBuilder-filterOperationStartsWith"),
        contains: X.format("dxFilterBuilder-filterOperationContains"),
        notContains: X.format("dxFilterBuilder-filterOperationNotContains"),
        endsWith: X.format("dxFilterBuilder-filterOperationEndsWith"),
        isBlank: X.format("dxFilterBuilder-filterOperationIsBlank"),
        isNotBlank: X.format("dxFilterBuilder-filterOperationIsNotBlank")
      }
    });
  }
  _optionChanged(e) {
    switch (e.name) {
      case "closePopupOnTargetScroll":
        break;
      case "onEditorPreparing":
      case "onEditorPrepared":
      case "onValueChanged":
        this._initActions();
        break;
      case "customOperations":
        this._initCustomOperations(), this._invalidate();
        break;
      case "fields":
      case "maxGroupLevel":
      case "groupOperations":
      case "allowHierarchicalFields":
      case "groupOperationDescriptions":
      case "filterOperationDescriptions":
        this._invalidate();
        break;
      case "value":
        if (e.value !== e.previousValue) {
          var i = this._disableInvalidateForValue;
          i || (this._initModel(), this._invalidate()), this._disableInvalidateForValue = !1, this.executeAction("onValueChanged", {
            value: e.value,
            previousValue: e.previousValue
          }), this._disableInvalidateForValue = i;
        }
        break;
      default:
        super._optionChanged(e);
    }
  }
  getFilterExpression() {
    var e = this._getNormalizedFields(), i = P(!0, [], this._model);
    return Fm(yx(i), e, this._customOperations, $2);
  }
  _getNormalizedFields() {
    return qRe(this.option("fields"));
  }
  _updateFilter() {
    this._disableInvalidateForValue = !0;
    var e = P(!0, [], this._model), i = yx(e), r = yx(this._getModel(this.option("value")));
    JSON.stringify(r) !== JSON.stringify(i) && this.option("value", i), this._disableInvalidateForValue = !1, this._fireContentReadyAction();
  }
  _init() {
    this._initCustomOperations(), this._initModel(), this._initEditorFactory(), this._initActions(), super._init();
  }
  _initEditorFactory() {
    this._editorFactory = new ELe();
  }
  _initCustomOperations() {
    this._customOperations = ZRe(this.option("customOperations"), this.option("filterOperationDescriptions.between"), this);
  }
  _getDefaultGroupOperation() {
    var e, i;
    return (i = (e = this.option("groupOperations")) === null || e === void 0 ? void 0 : e[0]) !== null && i !== void 0 ? i : U2.and;
  }
  _getModel(e) {
    return sV(e, this._customOperations, this._getDefaultGroupOperation());
  }
  _initModel() {
    this._model = this._getModel(this.option("value"));
  }
  _initActions() {
    var e = this;
    e._actions = {}, SLe.forEach((i) => {
      var r = P({}, i.config);
      e._actions[i.name] = e._createActionByOption(i.name, r);
    });
  }
  executeAction(e, i) {
    var r = this._actions[e];
    return r && r(i);
  }
  _initMarkup() {
    this.$element().addClass(vs), super._initMarkup(), this._createGroupElementByCriteria(this._model).appendTo(this.$element());
  }
  _createConditionElement(e, i) {
    return E("<div>").addClass(Bm).append(this._createConditionItem(e, i));
  }
  _createGroupElementByCriteria(e, i) {
    for (var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, n = this._createGroupElement(e, i, r), a = n.find(".".concat(V2)), o = Hh(e), u = 0; u < o.length; u++) {
      var c = o[u];
      $h(c) ? this._createGroupElementByCriteria(c, e, r + 1).appendTo(a) : $n(c) && this._createConditionElement(c, e).appendTo(a);
    }
    return n;
  }
  _createGroupElement(e, i, r) {
    var n = E("<div>").addClass(B2), a = E("<div>").addClass(V2), o = E("<div>").addClass(Bm).append(n).append(a);
    return i != null && this._createRemoveButton(() => {
      WP(i, e), o.remove(), this._updateFilter();
    }).appendTo(n), this._createGroupOperationButton(e).appendTo(n), this._createAddButton(() => {
      var u = G8(this._getDefaultGroupOperation());
      qT(u, e), this._createGroupElement(u, e, r + 1).appendTo(a), this._updateFilter();
    }, () => {
      var u = this.option("fields")[0], c = jRe(u, this._customOperations);
      qT(c, e), this._createConditionElement(c, e).appendTo(a), this._updateFilter();
    }, r).appendTo(n), o;
  }
  _createButton(e) {
    return E("<div>").text(e);
  }
  _createGroupOperationButton(e) {
    var i = this._getGroupOperations(e), r = zRe(e, i), n = r.text, a = i && i.length < 2 ? this._createButton(n).addClass(xLe) : this._createButtonWithMenu({
      caption: n,
      menu: {
        items: i,
        displayExpr: "text",
        keyExpr: "value",
        onItemClick: (o) => {
          r !== o.itemData && ($Re(e, o.itemData.value), a.text(o.itemData.text), r = o.itemData, this._updateFilter());
        },
        onContentReady(o) {
          o.component.selectItem(r);
        },
        cssClass: uLe
      }
    });
    return a.addClass(Ky).addClass(dLe).attr("tabindex", 0);
  }
  _createButtonWithMenu(e) {
    var i = this, r = function() {
      i.$element().find(".".concat(Tw)).removeClass(Tw), i.$element().find(".dx-overlay .dx-treeview").remove(), i.$element().find(".dx-overlay").remove();
    }, n = this.option("rtlEnabled"), a = n ? "right" : "left", o = this._createButton(e.caption);
    P(e.menu, {
      focusStateEnabled: !0,
      selectionMode: "single",
      onItemClick: (u = e.menu.onItemClick, function(c) {
        u(c), c.event.type === "dxclick" && r();
      }),
      onHiding() {
        o.removeClass(Tw);
      },
      position: {
        my: "".concat(a, " top"),
        at: "".concat(a, " bottom"),
        offset: "0 1",
        of: o,
        collision: "flip"
      },
      animation: null,
      onHidden() {
        r();
      },
      cssClass: "".concat(gLe, " ").concat(e.menu.cssClass),
      rtlEnabled: n
    });
    var u;
    return e.popup = {
      onShown(c) {
        var p = E(c.component.content()).find(".dx-treeview"), v = p.dxTreeView("instance");
        k.on(p, "keyup keydown", (_) => {
          var y = or(_);
          (_.type === "keydown" && y === z2 || _.type === "keyup" && (y === W2 || y === nk)) && (c.component.hide(), k.trigger(e.menu.position.of, "focus"));
        }), v.focus(), v.option("focusedElement", null);
      }
    }, this._subscribeOnClickAndEnterKey(o, () => {
      r(), i._createPopupWithTreeView(e, i.$element()), o.addClass(Tw);
    }), o;
  }
  _hasValueButton(e) {
    var i = Qd(this._customOperations, e[1]);
    return i ? i.hasValue !== !1 : e[2] !== null;
  }
  _createOperationButtonWithMenu(e, i) {
    var r = this, n = KRe(i, this.option("filterOperationDescriptions"), this._customOperations), a = GRe(R2(e), n), o = this._createButtonWithMenu({
      caption: a.text,
      menu: {
        items: n,
        displayExpr: "text",
        onItemRendered(u) {
          u.itemData.isCustom && E(u.itemElement).addClass(yLe);
        },
        onContentReady(u) {
          u.component.selectItem(a);
        },
        onItemClick: (u) => {
          if (a !== u.itemData) {
            a = u.itemData, UP(e, a.value, r._customOperations);
            var c = o.siblings().filter(".".concat(H2));
            r._hasValueButton(e) ? (c.length !== 0 && c.remove(), r._createValueButton(e, i).appendTo(o.parent())) : c.remove(), o.text(a.text), this._updateFilter();
          }
        },
        cssClass: mLe
      }
    }).addClass(Ky).addClass(pLe).attr("tabindex", 0);
    return o;
  }
  _createOperationAndValueButtons(e, i, r) {
    this._createOperationButtonWithMenu(e, i).appendTo(r), this._hasValueButton(e) && this._createValueButton(e, i).appendTo(r);
  }
  _createFieldButtonWithMenu(e, i, r) {
    var n = this, a = this.option("allowHierarchicalFields"), o = Q8(e, a), u = XT(r.name || r.dataField, o), c = function(v, _) {
      return a ? J8(v, _) : v.caption;
    }, p = this._createButtonWithMenu({
      caption: c(u, o),
      menu: {
        items: o,
        dataStructure: "plain",
        keyExpr: "id",
        parentId: "parentId",
        displayExpr: "caption",
        onItemClick: (v) => {
          if (u !== v.itemData) {
            u = v.itemData, i[0] = u.name || u.dataField, i[2] = u.dataType === "object" ? null : "", UP(i, nV(u), n._customOperations), p.siblings().filter(".".concat(Ky)).remove(), n._createOperationAndValueButtons(i, u, p.parent());
            var _ = c(u, v.component.option("items"));
            p.text(_), this._updateFilter();
          }
        },
        onContentReady(v) {
          v.component.selectItem(u);
        },
        cssClass: _Le
      }
    }).addClass(Ky).addClass(fLe).attr("tabindex", 0);
    return p;
  }
  _createConditionItem(e, i) {
    var r = E("<div>").addClass(B2), n = this._getNormalizedFields(), a = XT(e[0], n);
    return this._createRemoveButton(() => {
      WP(i, e);
      var o = r.parent().children().length === 1;
      o ? r.parent().remove() : r.remove(), this._updateFilter();
    }).appendTo(r), this._createFieldButtonWithMenu(n, e, a).appendTo(r), this._createOperationAndValueButtons(e, a, r), r;
  }
  _getGroupOperations(e) {
    var i = this.option("groupOperations"), r = this.option("groupOperationDescriptions");
    return (!i || !i.length) && (i = [Qp(e).replace("!", "not")]), i.map((n) => ({
      text: r[n],
      value: U2[n]
    }));
  }
  _createRemoveButton(e) {
    var i = E("<div>").addClass(N2).addClass(hLe).addClass(jP).attr("tabindex", 0);
    return this._subscribeOnClickAndEnterKey(i, e), i;
  }
  _createAddButton(e, i, r) {
    var n, a = this.option("maxGroupLevel");
    return R(a) && r >= a ? (n = this._createButton(), this._subscribeOnClickAndEnterKey(n, i)) : n = this._createButtonWithMenu({
      menu: {
        items: [{
          caption: X.format("dxFilterBuilder-addCondition"),
          click: i
        }, {
          caption: X.format("dxFilterBuilder-addGroup"),
          click: e
        }],
        displayExpr: "caption",
        onItemClick(o) {
          o.itemData.click();
        },
        cssClass: CLe
      }
    }), n.addClass(N2).addClass(cLe).addClass(jP).attr("tabindex", 0);
  }
  _createValueText(e, i, r) {
    var n = this, a = E("<div>").html("&nbsp;").addClass(vLe).attr("tabindex", 0).appendTo(r), o = e[2], u = Qd(n._customOperations, e[1]);
    return !u && i.lookup ? K8(i, o, (c) => {
      KP(a, c);
    }) : $e(Y8(i, o, u)).done((c) => {
      KP(a, c, u);
    }), n._subscribeOnClickAndEnterKey(a, (c) => {
      c.type === "keyup" && c.stopPropagation(), n._createValueEditorWithEvents(e, i, r);
    }), a;
  }
  _updateConditionValue(e, i, r) {
    var n = e[2] !== i;
    n && (e[2] = i), r(), this._updateFilter();
  }
  _addDocumentKeyUp(e, i) {
    var r = !1, n = !1, a = de.getDocument(), o = (c) => {
      if (r || n) {
        n = !1;
        return;
      }
      i(c);
    };
    k.on(a, "keyup", o);
    var u = e.find("input");
    k.on(u, "compositionstart", () => {
      r = !0;
    }), k.on(u, "compositionend", () => {
      r = !1, n = !0;
    }), k.on(u, "keydown", (c) => {
      c.which !== 229 && (n = !1);
    }), this._documentKeyUpHandler = o;
  }
  _addDocumentClick(e, i) {
    var r = de.getDocument(), n = (a) => {
      this._isFocusOnEditorParts(e, a.target) || (k.trigger(e.find("input"), "change"), i());
    };
    k.on(r, "dxpointerdown", n), this._documentClickHandler = n;
  }
  _isFocusOnEditorParts(e, i) {
    var r = i || de.getActiveElement();
    return E(r).closest(e.children()).length || E(r).closest(".dx-dropdowneditor-overlay").length;
  }
  _removeEvents() {
    var e = de.getDocument();
    R(this._documentKeyUpHandler) && k.off(e, "keyup", this._documentKeyUpHandler), R(this._documentClickHandler) && k.off(e, "dxpointerdown", this._documentClickHandler);
  }
  _dispose() {
    this._removeEvents(), super._dispose();
  }
  _createValueEditorWithEvents(e, i, r) {
    var n = e[2], a = () => (r.empty(), this._removeEvents(), this._createValueText(e, i, r)), o = () => {
      this._updateConditionValue(e, n, () => {
        a();
      });
    }, u = {
      value: n === "" ? null : n,
      filterOperation: R2(e),
      setValue(p) {
        n = p === null ? "" : p;
      },
      closeEditor: o,
      text: r.text()
    };
    r.empty();
    var c = this._createValueEditor(r, i, u);
    k.trigger(c.find("input").not(":hidden").eq(0), "focus"), this._removeEvents(), this._addDocumentClick(c, o), this._addDocumentKeyUp(c, (p) => {
      var v = or(p);
      if (v === z2) {
        if (this._isFocusOnEditorParts(c))
          return;
        this._updateConditionValue(e, n, () => {
          a(), p.shiftKey && k.trigger(r.prev(), "focus");
        });
      }
      v === W2 && k.trigger(a(), "focus"), v === nk && this._updateConditionValue(e, n, () => {
        k.trigger(a(), "focus");
      });
    }), this._fireContentReadyAction();
  }
  _createValueButton(e, i) {
    var r = E("<div>").addClass(Ky).addClass(H2);
    return this._createValueText(e, i, r), r;
  }
  _createValueEditor(e, i, r) {
    var n = E("<div>").attr("tabindex", 0).appendTo(e), a = Qd(this._customOperations, r.filterOperation), o = a && a.editorTemplate ? a.editorTemplate : i.editorTemplate;
    if (o) {
      var u = this._getTemplate(o);
      u.render({
        model: P({
          field: i
        }, r),
        container: n
      });
    } else
      this._editorFactory.createEditor.call(this, n, P({}, i, r, {
        parentType: $2
      }));
    return n;
  }
  _createPopupWithTreeView(e, i) {
    var r = this, n = E("<div>").addClass(e.menu.cssClass).appendTo(i);
    this._createComponent(n, BB, {
      onHiding: e.menu.onHiding,
      onHidden: e.menu.onHidden,
      rtlEnabled: e.menu.rtlEnabled,
      position: e.menu.position,
      animation: e.menu.animation,
      contentTemplate(a) {
        var o = E("<div>").appendTo(a);
        r._createComponent(o, TS, e.menu), this.repaint();
      },
      _ignoreFunctionValueDeprecation: !0,
      maxHeight: () => M8(e.menu.position.of),
      visible: !0,
      focusStateEnabled: !1,
      hideOnParentScroll: this.option("closePopupOnTargetScroll"),
      hideOnOutsideClick: !0,
      onShown: e.popup.onShown,
      shading: !1,
      width: "auto",
      height: "auto",
      showTitle: !1,
      _wrapperClassExternal: e.menu.cssClass
    });
  }
  _subscribeOnClickAndEnterKey(e, i) {
    k.on(e, "dxclick", i), k.on(e, "keyup", (r) => {
      or(r) === nk && i(r);
    });
  }
};
ti("dxFilterBuilder", a9);
class bLe extends Bi.View {
  init() {
    super.init(), this._columnsController = this.getController("columns"), this._filterSyncController = this.getController("filterSync");
  }
  optionChanged(e) {
    switch (e.name) {
      case "filterBuilder":
      case "filterBuilderPopup":
        this._invalidate(), e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
  _renderCore() {
    this._updatePopupOptions();
  }
  _updatePopupOptions() {
    this.option("filterBuilderPopup.visible") ? this._initPopup() : this._filterBuilderPopup && this._filterBuilderPopup.hide();
  }
  _disposePopup() {
    this._filterBuilderPopup && (this._filterBuilderPopup.dispose(), this._filterBuilderPopup = void 0), this._filterBuilder && (this._filterBuilder.dispose(), this._filterBuilder = void 0);
  }
  _initPopup() {
    var e = this;
    e._disposePopup(), e._filterBuilderPopup = e._createComponent(e.element(), Hu, P({
      title: X.format("dxDataGrid-filterBuilderPopupTitle"),
      contentTemplate: (i) => e._getPopupContentTemplate(i),
      onOptionChanged(i) {
        i.name === "visible" && e.option("filterBuilderPopup.visible", i.value);
      },
      toolbarItems: e._getPopupToolbarItems()
    }, e.option("filterBuilderPopup"), {
      onHidden() {
        JF(e), e._disposePopup();
      }
    }));
  }
  _getPopupContentTemplate(e) {
    var i = E(e), r = E("<div>").appendTo(E(e));
    this._filterBuilder = this._createComponent(r, a9, P({
      value: this.option("filterValue"),
      fields: this._columnsController.getFilteringColumns()
    }, this.option("filterBuilder"), {
      customOperations: this._filterSyncController.getCustomFilterOperations()
    })), this._createComponent(i, kB, {
      direction: "both"
    });
  }
  _getPopupToolbarItems() {
    var e = this;
    return [{
      toolbar: "bottom",
      location: "after",
      widget: "dxButton",
      options: {
        text: X.format("OK"),
        onClick() {
          var i = e._filterBuilder.option("value");
          e.option("filterValue", i), e._filterBuilderPopup.hide();
        }
      }
    }, {
      toolbar: "bottom",
      location: "after",
      widget: "dxButton",
      options: {
        text: X.format("Cancel"),
        onClick() {
          e._filterBuilderPopup.hide();
        }
      }
    }];
  }
}
var wLe = {
  defaultOptions: () => ({
    filterBuilder: {
      groupOperationDescriptions: {
        and: X.format("dxFilterBuilder-and"),
        or: X.format("dxFilterBuilder-or"),
        notAnd: X.format("dxFilterBuilder-notAnd"),
        notOr: X.format("dxFilterBuilder-notOr")
      },
      filterOperationDescriptions: {
        between: X.format("dxFilterBuilder-filterOperationBetween"),
        equal: X.format("dxFilterBuilder-filterOperationEquals"),
        notEqual: X.format("dxFilterBuilder-filterOperationNotEquals"),
        lessThan: X.format("dxFilterBuilder-filterOperationLess"),
        lessThanOrEqual: X.format("dxFilterBuilder-filterOperationLessOrEquals"),
        greaterThan: X.format("dxFilterBuilder-filterOperationGreater"),
        greaterThanOrEqual: X.format("dxFilterBuilder-filterOperationGreaterOrEquals"),
        startsWith: X.format("dxFilterBuilder-filterOperationStartsWith"),
        contains: X.format("dxFilterBuilder-filterOperationContains"),
        notContains: X.format("dxFilterBuilder-filterOperationNotContains"),
        endsWith: X.format("dxFilterBuilder-filterOperationEndsWith"),
        isBlank: X.format("dxFilterBuilder-filterOperationIsBlank"),
        isNotBlank: X.format("dxFilterBuilder-filterOperationIsNotBlank")
      }
    },
    filterBuilderPopup: {}
  }),
  views: {
    filterBuilderView: bLe
  }
};
et.registerModule("filterBuilder", wLe);
var DS = "filter-panel", TLe = "".concat(DS, "-text"), ILe = "".concat(DS, "-checkbox"), DLe = "".concat(DS, "-clear-filter"), ALe = "".concat(DS, "-left"), OLe = "filterPanel";
class RLe extends Bi.View {
  init() {
    this._dataController = this.getController("data"), this._columnsController = this.getController("columns"), this._filterSyncController = this.getController("filterSync"), this._dataController.dataSourceChanged.add(() => this.render());
  }
  isVisible() {
    return this.option("filterPanel.visible") && this._dataController.dataSource();
  }
  _renderCore() {
    var e = this.element();
    e.empty();
    var i = !!this._columnsController.getColumns().length;
    if (i) {
      e.addClass(this.addWidgetPrefix(DS));
      var r = E("<div>").addClass(this.addWidgetPrefix(ALe)).appendTo(e);
      this._renderFilterBuilderText(e, r);
    }
  }
  _renderFilterBuilderText(e, i) {
    var r = this._getFilterElement(), n = this._getTextElement();
    if (this.option("filterValue") || this._filterValueBuffer) {
      var a = this._getCheckElement(), o = this._getRemoveButtonElement();
      i.append(a).append(r).append(n), e.append(o);
      return;
    }
    i.append(r).append(n);
  }
  _getCheckElement() {
    var e = this, i = E("<div>").addClass(this.addWidgetPrefix(ILe));
    return e._createComponent(i, kp, {
      value: e.option("filterPanel.filterEnabled"),
      onValueChanged(r) {
        e.option("filterPanel.filterEnabled", r.value);
      }
    }), i.attr("title", this.option("filterPanel.texts.filterEnabledHint")), i;
  }
  _getFilterElement() {
    var e = this, i = E("<div>").addClass("dx-icon-filter");
    return k.on(i, "click", () => e._showFilterBuilder()), fx("filterPanel", e, i, void 0, () => e._showFilterBuilder()), e._addTabIndexToElement(i), i;
  }
  _getTextElement() {
    var e = this, i = E("<div>").addClass(e.addWidgetPrefix(TLe)), r, n = e.option("filterValue");
    return n ? $e(e.getFilterText(n, this._filterSyncController.getCustomFilterOperations())).done((a) => {
      var o = e.option("filterPanel.customizeText");
      if (o) {
        var u = o({
          component: e.component,
          filterValue: n,
          text: a
        });
        typeof u == "string" && (a = u);
      }
      i.text(a);
    }) : (r = e.option("filterPanel.texts.createFilter"), i.text(r)), k.on(i, "click", () => e._showFilterBuilder()), fx("filterPanel", e, i, void 0, () => e._showFilterBuilder()), e._addTabIndexToElement(i), i;
  }
  _showFilterBuilder() {
    this.option("filterBuilderPopup.visible", !0);
  }
  _getRemoveButtonElement() {
    var e = this, i = () => e.option("filterValue", null), r = E("<div>").addClass(e.addWidgetPrefix(DLe)).text(e.option("filterPanel.texts.clearFilter"));
    return k.on(r, "click", i), fx("filterPanel", this, r, void 0, i), e._addTabIndexToElement(r), r;
  }
  _addTabIndexToElement(e) {
    if (!this.option("useLegacyKeyboardNavigation")) {
      var i = this.option("tabindex") || 0;
      e.attr("tabindex", i);
    }
  }
  optionChanged(e) {
    switch (e.name) {
      case "filterValue":
        this._invalidate(), this.option("filterPanel.filterEnabled", !0), e.handled = !0;
        break;
      case "filterPanel":
        this._invalidate(), e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
  _getConditionText(e, i, r) {
    var n = "[".concat(e, "] ").concat(i);
    return R(r) && (n += r), n;
  }
  _getValueMaskedText(e) {
    return Array.isArray(e) ? "('".concat(e.join("', '"), "')") : " '".concat(e, "'");
  }
  _getValueText(e, i, r) {
    var n = new q(), a = i && i.customizeText;
    if (R(r) || a)
      if (!a && e.lookup)
        K8(e, r, (u) => {
          n.resolve(this._getValueMaskedText(u));
        });
      else {
        var o = Array.isArray(r) ? r : xe.getDisplayValue(e, r, null);
        $e(Y8(e, o, i, OLe)).done((u) => {
          n.resolve(this._getValueMaskedText(u));
        });
      }
    else
      n.resolve("");
    return n.promise();
  }
  getConditionText(e, i) {
    var r = this, n = e[1], a = new q(), o = Qd(i.customOperations, n), u, c = XT(e[0], i.columns), p = c.caption || "", v = e[2];
    return o ? u = o.caption || bp(o.name) : v === null ? u = zP(n === "=" ? "isblank" : "isnotblank", i.filterOperationDescriptions) : u = zP(n, i.filterOperationDescriptions), this._getValueText(c, o, v).done((_) => {
      a.resolve(r._getConditionText(p, u, _));
    }), a;
  }
  getGroupText(e, i, r) {
    var n = this, a = new q(), o = [], u = Qp(e);
    return e.forEach((c) => {
      $n(c) ? o.push(n.getConditionText(c, i)) : $h(c) && o.push(n.getGroupText(c, i, !0));
    }), $e.apply(this, o).done(function() {
      for (var c, p = arguments.length, v = new Array(p), _ = 0; _ < p; _++)
        v[_] = arguments[_];
      if (u.startsWith("!")) {
        var y = i.groupOperationDescriptions["not".concat(u.substring(1, 2).toUpperCase()).concat(u.substring(2))].split(" ");
        c = "".concat(y[0], " ").concat(v[0]);
      } else
        c = v.join(" ".concat(i.groupOperationDescriptions[u], " "));
      r && (c = "(".concat(c, ")")), a.resolve(c);
    }), a;
  }
  getFilterText(e, i) {
    var r = {
      customOperations: i,
      columns: this._columnsController.getFilteringColumns(),
      filterOperationDescriptions: this.option("filterBuilder.filterOperationDescriptions"),
      groupOperationDescriptions: this.option("filterBuilder.groupOperationDescriptions")
    };
    return $n(e) ? this.getConditionText(e, r) : this.getGroupText(e, r);
  }
}
var LLe = (t) => class extends t {
  optionChanged(e) {
    switch (e.name) {
      case "filterPanel":
        this._applyFilter(), e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
}, MLe = {
  defaultOptions: () => ({
    filterPanel: {
      visible: !1,
      filterEnabled: !0,
      texts: {
        createFilter: X.format("dxDataGrid-filterPanelCreateFilter"),
        clearFilter: X.format("dxDataGrid-filterPanelClearFilter"),
        filterEnabledHint: X.format("dxDataGrid-filterPanelFilterEnabledHint")
      }
    }
  }),
  views: {
    filterPanelView: RLe
  },
  extenders: {
    controllers: {
      data: LLe
    }
  }
};
et.registerModule("filterPanel", MLe);
var G2 = "search-panel", K2 = "search-text", kLe = "header-panel", PLe = 700;
function o9(t) {
  var e;
  return !!((e = t.allowSearch) !== null && e !== void 0 ? e : t.allowFiltering);
}
function s9(t, e) {
  var {
    lookup: i
  } = t;
  return t.parseValue ? i ? t.parseValue.call(i, e) : t.parseValue(e) : e;
}
var FLe = (t) => class extends t {
  optionChanged(e) {
    switch (e.fullName) {
      case "searchPanel.text":
      case "searchPanel":
        this._applyFilter(), e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
  publicMethods() {
    return super.publicMethods().concat(["searchByText"]);
  }
  _calculateAdditionalFilter() {
    var e = super._calculateAdditionalFilter(), i = this.calculateSearchFilter(this.option("searchPanel.text"));
    return xe.combineFilters([e, i]);
  }
  searchByText(e) {
    this.option("searchPanel.text", e);
  }
  calculateSearchFilter(e) {
    var i, r, n = this._columnsController.getColumns(), a = this.option("searchPanel.searchVisibleColumnsOnly"), o, u = [];
    if (!e)
      return null;
    function c(v) {
      for (var _ = Ii(o.valueExpr), y = 0; y < v.length; y++) {
        var b = _(v[y]);
        u.push(r.createFilterExpression(b, null, "search"));
      }
    }
    for (i = 0; i < n.length; i++)
      if (r = n[i], !(a && !r.visible) && o9(r) && r.calculateFilterExpression) {
        o = r.lookup;
        var p = s9(r, e);
        o && o.items ? lo(o.items).filter(r.createFilterExpression.call({
          dataField: o.displayExpr,
          dataType: o.dataType,
          calculateFilterExpression: r.calculateFilterExpression
        }, p, null, "search")).enumerate().done(c) : p !== void 0 && u.push(r.createFilterExpression(p, null, "search"));
      }
    return u.length === 0 ? ["!"] : xe.combineFilters(u, "or");
  }
}, BLe = (t) => class extends t {
  optionChanged(e) {
    if (e.name === "searchPanel") {
      if (e.fullName === "searchPanel.text") {
        var i = this.getSearchTextEditor();
        i && i.option("value", e.value);
      } else
        this._invalidate();
      e.handled = !0;
    } else
      super.optionChanged(e);
  }
  _getToolbarItems() {
    var e = super._getToolbarItems();
    return this._prepareSearchItem(e);
  }
  _prepareSearchItem(e) {
    var i = this, r = this._dataController, n = this.option("searchPanel");
    if (n && n.visible) {
      var a = {
        template(o, u, c) {
          var p = E("<div>").addClass(i.addWidgetPrefix(G2)).appendTo(c);
          i._editorFactoryController.createEditor(p, {
            width: n.width,
            placeholder: n.placeholder,
            parentType: "searchPanel",
            value: i.option("searchPanel.text"),
            updateValueTimeout: PLe,
            setValue(v) {
              r.searchByText(v);
            },
            editorOptions: {
              inputAttr: {
                "aria-label": X.format("".concat(i.component.NAME, "-ariaSearchInGrid"))
              }
            }
          }), i.resize();
        },
        name: "searchPanel",
        location: "after",
        locateInMenu: "never",
        sortIndex: 40
      };
      e.push(a);
    }
    return e;
  }
  getSearchTextEditor() {
    var e = this, i = e.element(), r = i.find(".".concat(e.addWidgetPrefix(G2))).filter(function() {
      return E(this).closest(".".concat(e.addWidgetPrefix(kLe))).is(i);
    });
    return r.length ? r.dxTextBox("instance") : null;
  }
  isVisible() {
    var e = this.option("searchPanel");
    return super.isVisible() || !!(e != null && e.visible);
  }
}, VLe = (t) => class extends t {
  init() {
    super.init.apply(this, arguments), this._searchParams = [], this._dataController = this.getController("data");
  }
  dispose() {
    clearTimeout(this._highlightTimer), super.dispose();
  }
  _getFormattedSearchText(e, i) {
    var r = s9(e, i), n = xe.getFormatOptionsByColumn(e, "search");
    return xe.formatValue(r, n);
  }
  _getStringNormalizer() {
    var e, i, r, n, a = this.option("searchPanel.highlightCaseSensitive"), o = (i = (e = this._dataController) === null || e === void 0 ? void 0 : e.getDataSource) === null || i === void 0 ? void 0 : i.call(e), u = (n = (r = o == null ? void 0 : o.loadOptions) === null || r === void 0 ? void 0 : r.call(o)) === null || n === void 0 ? void 0 : n.langParams;
    return (c) => ta(c, a, u);
  }
  _findHighlightingTextNodes(e, i, r) {
    var n = i.parent(), a, o = this._getStringNormalizer(), u = o(r), c = [];
    if (!n.length)
      n = E("<div>").append(i);
    else if (e)
      if (e.groupIndex >= 0 && !e.showWhenGrouped)
        a = i;
      else {
        var p = this._columnsController.getVisibleIndex(e.index);
        a = n.children("td").eq(p).find("*");
      }
    return a = a != null && a.length ? a : n.find("*"), a.each((v, _) => {
      for (var y, b, I = E(_).contents(), A = 0; A < I.length; A++) {
        var L = I.get(A);
        if (L.nodeType === 3) {
          var B = o((b = (y = L.textContent) !== null && y !== void 0 ? y : L.nodeValue) !== null && b !== void 0 ? b : "");
          B.includes(u) && c.push(L);
        }
      }
    }), c;
  }
  _highlightSearchTextCore(e, i) {
    var r = E("<span>").addClass(this.addWidgetPrefix(K2)), n = e.text(), a = e[0], o = this._getStringNormalizer(), u = o(n).indexOf(o(i));
    if (u >= 0)
      return a.textContent ? a.textContent = n.substr(0, u) : a.nodeValue = n.substr(0, u), e.after(r.text(n.substr(u, i.length))), e = E(de.createTextNode(n.substr(u + i.length))).insertAfter(r), this._highlightSearchTextCore(e, i);
  }
  _highlightSearchText(e, i, r) {
    var n = this, a = this._getStringNormalizer(), o = n.option("searchPanel.text");
    if (i && r && (o = o && n._getFormattedSearchText(r, o)), o && n.option("searchPanel.highlightSearchText")) {
      var u = n._findHighlightingTextNodes(r, e, o);
      u.forEach((c) => {
        i ? a(E(c).text()) === a(o ?? "") && E(c).replaceWith(E("<span>").addClass(n.addWidgetPrefix(K2)).text(E(c).text())) : n._highlightSearchTextCore(E(c), o);
      });
    }
  }
  _renderCore() {
    var e = super._renderCore.apply(this, arguments);
    return (this.option().rowTemplate || this.option("dataRowTemplate")) && (this.option("templatesRenderAsynchronously") ? (clearTimeout(this._highlightTimer), this._highlightTimer = setTimeout(() => {
      this._highlightSearchText(this.getTableElement());
    })) : this._highlightSearchText(this.getTableElement())), e;
  }
  _updateCell(e, i) {
    var {
      column: r
    } = i, n = r.lookup && r.lookup.dataType || r.dataType, a = n !== "string";
    o9(r) && !i.isOnForm && (this.option("templatesRenderAsynchronously") ? (this._searchParams.length || (clearTimeout(this._highlightTimer), this._highlightTimer = setTimeout(() => {
      this._searchParams.forEach((o) => {
        this._highlightSearchText.apply(this, o);
      }), this._searchParams = [];
    })), this._searchParams.push([e, a, r])) : this._highlightSearchText(e, a, r)), super._updateCell(e, i);
  }
}, NLe = {
  defaultOptions: () => ({
    searchPanel: {
      visible: !1,
      width: 160,
      placeholder: X.format("dxDataGrid-searchPanelPlaceholder"),
      highlightSearchText: !0,
      highlightCaseSensitive: !1,
      text: "",
      searchVisibleColumnsOnly: !1
    }
  }),
  extenders: {
    controllers: {
      data: FLe
    },
    views: {
      headerPanel: BLe,
      rowsView: VLe
    }
  }
};
et.registerModule("search", NLe);
class HLe extends cS {
  _optionChanged(e) {
    switch (e.name) {
      case "pageIndex":
        var i = this.option("pageIndexChanged");
        i && i(e.value);
        break;
      case "pageSize":
        var r = this.option("pageSizeChanged");
        r && r(e.value);
    }
    super._optionChanged(e);
  }
}
function Zd(t, e) {
  var i, r = (i = vX(e)) !== null && i !== void 0 ? i : {};
  return iX(r[t]);
}
function $Le(t) {
  var e = Zd("paddingLeft", t) + Zd("paddingRight", t), i = Zd("width", t);
  return i - e;
}
function oT(t) {
  var e = Zd("marginLeft", t) + Zd("marginRight", t), i = Zd("width", t);
  return e + i;
}
function l9(t) {
  return Zd("minWidth", t);
}
var zLe = ["contentTemplate", "pagerProps"], WLe = (t) => {
  var {
    contentAttributes: e,
    infoTextRef: i,
    infoTextVisible: r,
    isLargeDisplayMode: n,
    pageSizesRef: a,
    pagesRef: o,
    parentRef: u,
    props: {
      contentTemplate: c
    }
  } = t;
  return c(ae({
    rootElementRef: u,
    pageSizesRef: a,
    infoTextRef: i,
    pagesRef: o,
    infoTextVisible: r,
    isLargeDisplayMode: n
  }, e));
};
function ULe(t) {
  var {
    pageSizes: e,
    pages: i,
    parent: r
  } = t;
  return r - (e + i) > 0;
}
function GLe(t) {
  var {
    info: e,
    pageSizes: i,
    pages: r,
    parent: n
  } = t, a = i + r + e;
  return n - a > 0;
}
function KLe(t) {
  var {
    info: e,
    pageSizes: i,
    pages: r,
    parent: n
  } = t, a = $Le(n), o = oT(i), u = oT(e), c = oT(r);
  return {
    parent: a,
    pageSizes: o,
    info: u + Zd("marginLeft", e) + Zd("marginRight", e),
    pages: c
  };
}
var jLe = {}, YLe = (t) => t && (t.defaultProps ? (e) => Uo(zi(2, t, ae({}, e))) : t);
class u9 extends Bu {
  constructor(e) {
    super(e), this.parentRef = Vn(), this.pageSizesRef = Vn(), this.infoTextRef = Vn(), this.pagesRef = Vn(), this.actualIsLargeDisplayMode = !0, this.actualInfoTextVisible = !0, this.state = {
      infoTextVisible: !0,
      isLargeDisplayMode: !0
    }, this.subscribeToResize = this.subscribeToResize.bind(this), this.effectUpdateChildProps = this.effectUpdateChildProps.bind(this), this.updateAdaptivityProps = this.updateAdaptivityProps.bind(this);
  }
  createEffects() {
    return [new ar(this.subscribeToResize, [this.state.infoTextVisible, this.state.isLargeDisplayMode]), new ar(this.effectUpdateChildProps, [this.props, this.state.infoTextVisible, this.state.isLargeDisplayMode, this.props.pagerProps, this.props.contentTemplate])];
  }
  updateEffects() {
    var e, i;
    (e = this._effects[0]) === null || e === void 0 || e.update([this.state.infoTextVisible, this.state.isLargeDisplayMode]), (i = this._effects[1]) === null || i === void 0 || i.update([this.props, this.state.infoTextVisible, this.state.isLargeDisplayMode, this.props.pagerProps, this.props.contentTemplate]);
  }
  subscribeToResize() {
    var e = () => {
      this.parentWidth > 0 && this.updateAdaptivityProps();
    };
    return Tp.add(e), () => {
      Tp.remove(e);
    };
  }
  effectUpdateChildProps() {
    this.parentWidth > 0 && this.updateAdaptivityProps();
  }
  get contentAttributes() {
    var {
      className: e,
      displayMode: i,
      gridCompatibility: r,
      hasKnownLastPage: n,
      infoText: a,
      label: o,
      lightModeEnabled: u,
      maxPagesCount: c,
      onKeyDown: p,
      pageCount: v,
      pageIndex: _,
      pageIndexChange: y,
      pageSize: b,
      pageSizeChange: I,
      pageSizes: A,
      pagesCountText: L,
      pagesNavigatorVisible: B,
      rtlEnabled: $,
      showInfo: K,
      showNavigationButtons: te,
      showPageSizes: z,
      totalCount: ie,
      visible: pe
    } = this.props.pagerProps;
    return ae({}, this.restAttributes, {
      pageSize: b,
      pageIndex: _,
      pageIndexChange: y,
      pageSizeChange: I,
      gridCompatibility: r,
      className: e,
      showInfo: K,
      infoText: a,
      lightModeEnabled: u,
      displayMode: i,
      maxPagesCount: c,
      pageCount: v,
      pagesCountText: L,
      visible: pe,
      hasKnownLastPage: n,
      pagesNavigatorVisible: B,
      showPageSizes: z,
      pageSizes: A,
      rtlEnabled: $,
      showNavigationButtons: te,
      totalCount: ie,
      onKeyDown: p,
      label: o
    });
  }
  get parentWidth() {
    return this.parentRef.current ? oT(this.parentRef.current) : 0;
  }
  updateAdaptivityProps() {
    var e = KLe({
      parent: this.parentRef.current,
      pageSizes: this.pageSizesRef.current,
      info: this.infoTextRef.current,
      pages: this.pagesRef.current
    });
    if (!(this.actualInfoTextVisible !== this.state.infoTextVisible || this.actualIsLargeDisplayMode !== this.state.isLargeDisplayMode)) {
      var i = !R(this.elementsWidth);
      i && (this.elementsWidth = {}), (i || this.state.isLargeDisplayMode) && (this.elementsWidth.pageSizes = e.pageSizes, this.elementsWidth.pages = e.pages), (i || this.state.infoTextVisible) && (this.elementsWidth.info = e.info), this.actualIsLargeDisplayMode = ULe(ae({
        parent: e.parent
      }, {
        pageSizes: this.elementsWidth.pageSizes,
        pages: this.elementsWidth.pages
      })), this.actualInfoTextVisible = GLe(ae({}, e, {
        info: this.elementsWidth.info
      })), this.setState((r) => ({
        infoTextVisible: this.actualInfoTextVisible
      })), this.setState((r) => ({
        isLargeDisplayMode: this.actualIsLargeDisplayMode
      }));
    }
  }
  get restAttributes() {
    var e = this.props, i = sr(e, zLe);
    return i;
  }
  render() {
    var e = this.props;
    return WLe({
      props: ae({}, e, {
        contentTemplate: YLe(e.contentTemplate)
      }),
      infoTextVisible: this.state.infoTextVisible,
      isLargeDisplayMode: this.state.isLargeDisplayMode,
      parentRef: this.parentRef,
      pageSizesRef: this.pageSizesRef,
      infoTextRef: this.infoTextRef,
      pagesRef: this.pagesRef,
      contentAttributes: this.contentAttributes,
      parentWidth: this.parentWidth,
      updateAdaptivityProps: this.updateAdaptivityProps,
      restAttributes: this.restAttributes
    });
  }
}
u9.defaultProps = jLe;
var d9 = {
  gridCompatibility: !0,
  showInfo: !1,
  displayMode: "adaptive",
  maxPagesCount: 10,
  pageCount: 10,
  visible: !0,
  hasKnownLastPage: !0,
  pagesNavigatorVisible: "auto",
  showPageSizes: !0,
  pageSizes: Object.freeze([5, 10]),
  showNavigationButtons: !1,
  totalCount: 0,
  get label() {
    return X.format("dxPager-ariaLabel");
  }
}, qLe = Object.create(Object.prototype, ae(Object.getOwnPropertyDescriptors(d9), Object.getOwnPropertyDescriptors({
  defaultPageSize: 5,
  pageSizeChange: () => {
  },
  defaultPageIndex: 1,
  pageIndexChange: () => {
  }
}))), kn = Object.create(Object.prototype, ae(Object.getOwnPropertyDescriptors(d9), Object.getOwnPropertyDescriptors({
  pageSize: 5,
  pageIndex: 1
}))), XLe = ["infoText", "pageCount", "pageIndex", "rootElementRef", "totalCount"], c9 = "dx-info", QLe = (t) => {
  var {
    props: {
      rootElementRef: e
    },
    text: i
  } = t;
  return Fr(1, "div", c9, i, 0, null, null, e);
};
var ZLe = {
  get pageIndex() {
    return kn.pageIndex;
  },
  get pageCount() {
    return kn.pageCount;
  },
  get totalCount() {
    return kn.totalCount;
  }
};
class h9 extends qs {
  constructor(e) {
    super(e), this.state = {};
  }
  get infoText() {
    var e;
    return ((e = this.props.infoText) !== null && e !== void 0 ? e : "") || X.getFormatter("dxPager-infoText")();
  }
  get text() {
    var {
      pageCount: e,
      pageIndex: i,
      totalCount: r
    } = this.props;
    return Mu(this.infoText, (i + 1).toString(), e.toString(), r.toString());
  }
  get restAttributes() {
    var e = this.props, i = sr(e, XLe);
    return i;
  }
  render() {
    var e = this.props;
    return QLe({
      props: ae({}, e),
      infoText: this.infoText,
      text: this.text,
      restAttributes: this.restAttributes
    });
  }
}
h9.defaultProps = ZLe;
var xx = cY(void 0), JLe = ["children", "className", "label", "onClick", "selected", "tabIndex"], eMe = (t) => {
  var {
    props: {
      children: e,
      className: i,
      label: r,
      selected: n,
      tabIndex: a
    },
    widgetRef: o
  } = t;
  return Fr(1, "div", i, e, 0, {
    tabIndex: a,
    role: "button",
    "aria-label": r,
    "aria-current": n ? "page" : void 0
  }, null, o);
}, tMe = {
  className: "",
  label: "",
  tabIndex: 0,
  selected: !1
};
class Kx extends Bu {
  constructor(e) {
    super(e), this.state = {}, this.widgetRef = Vn(), this.keyboardEffect = this.keyboardEffect.bind(this), this.subscribeToClick = this.subscribeToClick.bind(this);
  }
  get keyboardContext() {
    return this.context[xx.id] ? this.context[xx.id] : xx.defaultValue;
  }
  createEffects() {
    return [new ar(this.keyboardEffect, [this.keyboardContext, this.props.onClick]), new ar(this.subscribeToClick, [this.props.onClick])];
  }
  updateEffects() {
    var e, i;
    (e = this._effects[0]) === null || e === void 0 || e.update([this.keyboardContext, this.props.onClick]), (i = this._effects[1]) === null || i === void 0 || i.update([this.props.onClick]);
  }
  keyboardEffect() {
    return this.keyboardContext.registerKeyboardAction(this.widgetRef.current, this.props.onClick);
  }
  subscribeToClick() {
    return Sle(this.widgetRef.current, this.props.onClick);
  }
  get restAttributes() {
    var e = this.props, i = sr(e, JLe);
    return i;
  }
  render() {
    var e = this.props;
    return eMe({
      props: ae({}, e),
      widgetRef: this.widgetRef,
      keyboardContext: this.keyboardContext,
      restAttributes: this.restAttributes
    });
  }
}
Kx.defaultProps = tMe;
var iMe = "dx-pager", rMe = "dx-light-mode", nMe = "dx-pages", aMe = "dx-page-indexes", oMe = "dx-page", f9 = "dx-selection", p9 = "dx-page-size", sMe = "dx-page-sizes", lMe = "".concat(p9, " ").concat(f9), uMe = "dx-first-child", dMe = ["className", "index", "onClick", "selected"], cMe = (t) => {
  var {
    className: e,
    label: i,
    props: {
      onClick: r,
      selected: n
    },
    value: a
  } = t;
  return zi(2, Kx, {
    className: e,
    label: i,
    onClick: r,
    selected: n,
    children: a
  });
}, hMe = {
  index: 0,
  selected: !1,
  className: oMe
};
class uV extends qs {
  constructor(e) {
    super(e), this.state = {};
  }
  get label() {
    return Mu(X.getFormatter("dxPager-page"), this.value);
  }
  get value() {
    return this.props.index + 1;
  }
  get className() {
    var {
      selected: e
    } = this.props;
    return $s({
      ["".concat(this.props.className)]: !!this.props.className,
      [f9]: !!e
    });
  }
  get restAttributes() {
    var e = this.props, i = sr(e, dMe);
    return i;
  }
  render() {
    var e = this.props;
    return cMe({
      props: ae({}, e),
      label: this.label,
      value: this.value,
      className: this.className,
      restAttributes: this.restAttributes
    });
  }
}
uV.defaultProps = hMe;
var fMe = ["pageIndexes"], pMe = ["maxPagesCount", "pageCount", "pageIndex", "pageIndexChange"], vMe = "dx-separator", gMe = (t) => {
  var {
    pages: e
  } = t, i = e.map((r) => {
    var {
      key: n,
      pageProps: a
    } = r;
    return a ? zi(2, uV, {
      index: a.index,
      selected: a.selected,
      onClick: a.onClick
    }, n) : Fr(1, "div", vMe, ". . .", 16, null, n);
  });
  return sc(i, 0);
}, rp = 4;
function j2(t, e, i) {
  return t === 1 ? "high" : t + e === i - 1 ? "low" : "both";
}
function v9(t, e, i) {
  var r = [], n = [];
  switch (i) {
    case "none":
      r = [...t];
      break;
    case "both":
      r = [0, "low", ...t, "high", e - 1], n = t.slice(1, -1);
      break;
    case "high":
      r = [0, ...t, "high", e - 1], n = t.slice(0, -1);
      break;
    case "low":
      r = [0, "low", ...t, e - 1], n = t.slice(1);
  }
  return {
    slidingWindowIndexes: t,
    indexesForReuse: n,
    pageIndexes: r
  };
}
function Y2(t, e, i, r) {
  for (var n = [], a = 0; a < e; a += 1)
    n.push(a + t);
  return v9(n, i, r);
}
var mMe = {
  get pageIndex() {
    return kn.pageIndex;
  },
  get maxPagesCount() {
    return kn.maxPagesCount;
  },
  get pageCount() {
    return kn.pageCount;
  }
};
class g9 extends qs {
  constructor(e) {
    super(e), this.state = {}, this.canReuseSlidingWindow = this.canReuseSlidingWindow.bind(this), this.generatePageIndexes = this.generatePageIndexes.bind(this), this.isSlidingWindowMode = this.isSlidingWindowMode.bind(this), this.onPageClick = this.onPageClick.bind(this);
  }
  get config() {
    return this.context[ea.id] ? this.context[ea.id] : ea.defaultValue;
  }
  get slidingWindowState() {
    var e = this.slidingWindowStateHolder;
    return e || {
      indexesForReuse: [],
      slidingWindowIndexes: []
    };
  }
  canReuseSlidingWindow(e, i) {
    var {
      indexesForReuse: r
    } = this.slidingWindowState, n = r.slice(-1)[0] < e - 1, a = r.includes(i);
    return n && a;
  }
  generatePageIndexes() {
    var {
      pageCount: e,
      pageIndex: i
    } = this.props, r = 0, {
      slidingWindowIndexes: n
    } = this.slidingWindowState;
    i === n[0] ? r = i - 1 : i === n[n.length - 1] ? r = i + 2 - rp : i < rp ? r = 1 : i >= e - rp ? r = e - rp - 1 : r = i - 1;
    var a = rp, o = j2(r, a, e), u = Y2(r, a, e, o), {
      pageIndexes: c
    } = u, p = sr(u, fMe);
    return this.slidingWindowStateHolder = p, c;
  }
  isSlidingWindowMode() {
    var {
      maxPagesCount: e,
      pageCount: i
    } = this.props;
    return i <= rp || i <= e;
  }
  onPageClick(e) {
    this.props.pageIndexChange(e);
  }
  get pageIndexes() {
    var {
      pageCount: e
    } = this.props;
    if (this.isSlidingWindowMode())
      return Y2(0, e, e, "none").pageIndexes;
    if (this.canReuseSlidingWindow(e, this.props.pageIndex)) {
      var {
        slidingWindowIndexes: i
      } = this.slidingWindowState, r = j2(i[0], rp, e);
      return v9(i, e, r).pageIndexes;
    }
    return this.generatePageIndexes();
  }
  get pages() {
    var e, {
      pageIndex: i
    } = this.props, r = (a) => {
      var o = a === "low" || a === "high" ? null : {
        index: a,
        onClick: () => this.onPageClick(a),
        selected: i === a
      };
      return {
        key: a.toString(),
        pageProps: o
      };
    }, n = (e = this.config) !== null && e !== void 0 && e.rtlEnabled ? [...this.pageIndexes].reverse() : this.pageIndexes;
    return n.map((a) => r(a));
  }
  get restAttributes() {
    var e = this.props, i = sr(e, pMe);
    return i;
  }
  render() {
    var e = this.props;
    return gMe({
      props: ae({}, e),
      config: this.config,
      pageIndexes: this.pageIndexes,
      pages: this.pages,
      restAttributes: this.restAttributes
    });
  }
}
g9.defaultProps = mMe;
var Tm = {
  hoverStateEnabled: !0,
  activeStateEnabled: !0,
  get focusStateEnabled() {
    return Ye.real().deviceType === "desktop" && !Ye.isSimulator();
  }
}, ZT = {
  label: "",
  get labelMode() {
    return _a(ho()) ? "floating" : "static";
  }
}, _Me = ["accessKey", "activeStateEnabled", "className", "defaultValue", "disabled", "focusStateEnabled", "height", "hint", "hoverStateEnabled", "inputAttr", "invalidValueMessage", "isDirty", "isValid", "label", "labelMode", "max", "min", "mode", "name", "onClick", "onFocusIn", "onKeyDown", "readOnly", "rtlEnabled", "showSpinButtons", "step", "tabIndex", "useLargeSpinButtons", "validationError", "validationErrors", "validationMessageMode", "validationMessagePosition", "validationStatus", "value", "valueChange", "visible", "width"], CMe = 0, yMe = (t) => {
  var {
    componentProps: e,
    restAttributes: i
  } = t;
  return Uo(zi(2, MI, ae({
    componentType: WT,
    componentProps: e,
    templateNames: []
  }, i)));
}, ro = Object.create(Object.prototype, ae(Object.getOwnPropertyDescriptors(qr), Object.getOwnPropertyDescriptors({
  defaultValue: CMe,
  isReactComponentWrapper: !0
}))), xMe = {
  get defaultValue() {
    return ro.defaultValue;
  },
  get readOnly() {
    return ro.readOnly;
  },
  get name() {
    return ro.name;
  },
  get validationError() {
    return ro.validationError;
  },
  get validationErrors() {
    return ro.validationErrors;
  },
  get validationMessageMode() {
    return ro.validationMessageMode;
  },
  get validationMessagePosition() {
    return ro.validationMessagePosition;
  },
  get validationStatus() {
    return ro.validationStatus;
  },
  get isValid() {
    return ro.isValid;
  },
  get isDirty() {
    return ro.isDirty;
  },
  get inputAttr() {
    return ro.inputAttr;
  },
  get className() {
    return ro.className;
  },
  get activeStateEnabled() {
    return Tm.activeStateEnabled;
  },
  get disabled() {
    return ro.disabled;
  },
  get focusStateEnabled() {
    return Tm.focusStateEnabled;
  },
  get hoverStateEnabled() {
    return Tm.hoverStateEnabled;
  },
  get tabIndex() {
    return ro.tabIndex;
  },
  get visible() {
    return ro.visible;
  },
  get label() {
    return ZT.label;
  },
  get labelMode() {
    return ZT.labelMode;
  },
  isReactComponentWrapper: !0
};
class m9 extends qs {
  constructor(e) {
    super(e), this.state = {
      value: this.props.value !== void 0 ? this.props.value : this.props.defaultValue
    };
  }
  get componentProps() {
    return ae({}, this.props, {
      value: this.props.value !== void 0 ? this.props.value : this.state.value
    });
  }
  get restAttributes() {
    var e = ae({}, this.props, {
      value: this.props.value !== void 0 ? this.props.value : this.state.value
    }), i = sr(e, _Me);
    return i;
  }
  render() {
    var e = this.props;
    return yMe({
      props: ae({}, e, {
        value: this.props.value !== void 0 ? this.props.value : this.state.value
      }),
      componentProps: this.componentProps,
      restAttributes: this.restAttributes
    });
  }
}
m9.defaultProps = xMe;
var SMe = 10;
function _9(t, e) {
  return t + SMe * Math.max(...e).toString().length;
}
var EMe = ["inputAttr", "pageCount", "pageIndex", "pageIndexChange", "pagesCountText"], bMe = "".concat(c9, "  dx-info-text"), C9 = "dx-page-index", wMe = "dx-light-pages", TMe = "dx-pages-count", IMe = (t) => {
  var {
    pageIndexRef: e,
    pagesCountText: i,
    props: {
      inputAttr: r,
      pageCount: n
    },
    selectLastPageIndex: a,
    value: o,
    valueChange: u,
    width: c
  } = t;
  return Fr(1, "div", wMe, [zi(2, m9, {
    className: C9,
    min: 1,
    max: Math.max(n, o),
    width: c,
    value: o,
    valueChange: u,
    inputAttr: r
  }), Fr(1, "span", bMe, i, 0), zi(2, uV, {
    className: TMe,
    selected: !1,
    index: n - 1,
    onClick: a
  })], 4, null, null, e);
}, DMe = {
  inputAttr: Object.freeze({
    "aria-label": X.format("dxPager-ariaPageNumber")
  })
}, AMe = {
  get pageIndex() {
    return kn.pageIndex;
  },
  get pageCount() {
    return kn.pageCount;
  },
  get inputAttr() {
    return DMe.inputAttr;
  }
};
class y9 extends Bu {
  constructor(e) {
    super(e), this.pageIndexRef = Vn(), this.state = {
      minWidth: 10
    }, this.updateWidth = this.updateWidth.bind(this), this.selectLastPageIndex = this.selectLastPageIndex.bind(this), this.valueChange = this.valueChange.bind(this);
  }
  createEffects() {
    return [new ar(this.updateWidth, [this.state.minWidth])];
  }
  updateEffects() {
    var e;
    (e = this._effects[0]) === null || e === void 0 || e.update([this.state.minWidth]);
  }
  updateWidth() {
    var e, i = (e = this.pageIndexRef.current) === null || e === void 0 ? void 0 : e.querySelector(".".concat(C9));
    this.setState((r) => ({
      minWidth: i && l9(i) || r.minWidth
    }));
  }
  get value() {
    return this.props.pageIndex + 1;
  }
  get width() {
    var {
      pageCount: e
    } = this.props;
    return _9(this.state.minWidth, [e]);
  }
  get pagesCountText() {
    var e;
    return ((e = this.props.pagesCountText) !== null && e !== void 0 ? e : "") || X.getFormatter("dxPager-pagesCountText")();
  }
  selectLastPageIndex() {
    this.props.pageIndexChange(this.props.pageCount - 1);
  }
  valueChange(e) {
    this.props.pageIndexChange(e - 1);
  }
  get restAttributes() {
    var e = this.props, i = sr(e, EMe);
    return i;
  }
  render() {
    var e = this.props;
    return IMe({
      props: ae({}, e),
      pageIndexRef: this.pageIndexRef,
      value: this.value,
      width: this.width,
      pagesCountText: this.pagesCountText,
      selectLastPageIndex: this.selectLastPageIndex,
      valueChange: this.valueChange,
      restAttributes: this.restAttributes
    });
  }
}
y9.defaultProps = AMe;
var OMe = ["hasKnownLastPage", "isLargeDisplayMode", "maxPagesCount", "pageCount", "pageIndex", "pageIndexChange", "pagesCountText", "showNavigationButtons", "totalCount"], Iw = "dx-navigate-button", q2 = "dx-prev-button", X2 = "dx-next-button", Q2 = "dx-button-disable", RMe = () => X.getFormatter("dxPager-nextPage")(), LMe = () => X.getFormatter("dxPager-prevPage")(), MMe = {
  nextEnabledClass: "".concat(Iw, " ").concat(X2),
  prevEnabledClass: "".concat(Iw, " ").concat(q2),
  nextDisabledClass: "".concat(Q2, " ").concat(Iw, " ").concat(X2),
  prevDisabledClass: "".concat(Q2, " ").concat(Iw, " ").concat(q2)
}, kMe = {
  next: "prev",
  prev: "next"
}, PMe = (t) => {
  var {
    nextButtonProps: e,
    pageIndexChange: i,
    prevButtonProps: r,
    props: {
      isLargeDisplayMode: n,
      maxPagesCount: a,
      pageCount: o,
      pageIndex: u,
      pagesCountText: c
    },
    renderNextButton: p,
    renderPrevButton: v
  } = t;
  return sc([v && zi(2, Kx, {
    label: LMe(),
    className: r.className,
    tabIndex: r.tabIndex,
    onClick: r.navigate
  }), n && zi(2, g9, {
    maxPagesCount: a,
    pageCount: o,
    pageIndex: u,
    pageIndexChange: i
  }), !n && zi(2, y9, {
    pageCount: o,
    pageIndex: u,
    pageIndexChange: i,
    pagesCountText: c
  }), p && zi(2, Kx, {
    label: RMe(),
    className: e.className,
    tabIndex: e.tabIndex,
    onClick: e.navigate
  })], 0);
};
function FMe(t) {
  return t === "next" ? 1 : -1;
}
var BMe = {
  isLargeDisplayMode: !0
}, VMe = {
  get pageIndex() {
    return kn.pageIndex;
  },
  get maxPagesCount() {
    return kn.maxPagesCount;
  },
  get pageCount() {
    return kn.pageCount;
  },
  get hasKnownLastPage() {
    return kn.hasKnownLastPage;
  },
  get showNavigationButtons() {
    return kn.showNavigationButtons;
  },
  get totalCount() {
    return kn.totalCount;
  },
  get isLargeDisplayMode() {
    return BMe.isLargeDisplayMode;
  }
};
class x9 extends qs {
  constructor(e) {
    super(e), this.state = {}, this.__getterCache = {}, this.pageIndexChange = this.pageIndexChange.bind(this), this.getButtonProps = this.getButtonProps.bind(this), this.canNavigateToPage = this.canNavigateToPage.bind(this), this.getNextPageIndex = this.getNextPageIndex.bind(this), this.canNavigateTo = this.canNavigateTo.bind(this), this.navigateToPage = this.navigateToPage.bind(this);
  }
  get config() {
    return this.context[ea.id] ? this.context[ea.id] : ea.defaultValue;
  }
  pageIndexChange(e) {
    this.canNavigateToPage(e) && this.props.pageIndexChange(e);
  }
  getButtonProps(e) {
    var i, r = (i = this.config) !== null && i !== void 0 && i.rtlEnabled ? kMe[e] : e, n = this.canNavigateTo(r), a = MMe["".concat(e).concat(n ? "Enabled" : "Disabled", "Class")];
    return {
      className: a,
      tabIndex: n ? 0 : -1,
      navigate: () => this.navigateToPage(r)
    };
  }
  canNavigateToPage(e) {
    return this.props.hasKnownLastPage ? e >= 0 && e <= this.props.pageCount - 1 : e >= 0;
  }
  getNextPageIndex(e) {
    return this.props.pageIndex + FMe(e);
  }
  canNavigateTo(e) {
    return this.canNavigateToPage(this.getNextPageIndex(e));
  }
  navigateToPage(e) {
    this.pageIndexChange(this.getNextPageIndex(e));
  }
  get renderPrevButton() {
    var {
      isLargeDisplayMode: e,
      showNavigationButtons: i
    } = this.props;
    return !e || i;
  }
  get renderNextButton() {
    return this.renderPrevButton || !this.props.hasKnownLastPage;
  }
  get prevButtonProps() {
    return this.__getterCache.prevButtonProps !== void 0 ? this.__getterCache.prevButtonProps : this.__getterCache.prevButtonProps = this.getButtonProps("prev");
  }
  get nextButtonProps() {
    return this.__getterCache.nextButtonProps !== void 0 ? this.__getterCache.nextButtonProps : this.__getterCache.nextButtonProps = this.getButtonProps("next");
  }
  get restAttributes() {
    var e = this.props, i = sr(e, OMe);
    return i;
  }
  componentWillUpdate(e, i, r) {
    (this.context[ea.id] !== r[ea.id] || this.props.hasKnownLastPage !== e.hasKnownLastPage || this.props.pageCount !== e.pageCount || this.props.pageIndex !== e.pageIndex || this.props.pageIndexChange !== e.pageIndexChange) && (this.__getterCache.prevButtonProps = void 0), (this.context[ea.id] !== r[ea.id] || this.props.hasKnownLastPage !== e.hasKnownLastPage || this.props.pageCount !== e.pageCount || this.props.pageIndex !== e.pageIndex || this.props.pageIndexChange !== e.pageIndexChange) && (this.__getterCache.nextButtonProps = void 0);
  }
  render() {
    var e = this.props;
    return PMe({
      props: ae({}, e),
      config: this.config,
      pageIndexChange: this.pageIndexChange,
      renderPrevButton: this.renderPrevButton,
      renderNextButton: this.renderNextButton,
      prevButtonProps: this.prevButtonProps,
      nextButtonProps: this.nextButtonProps,
      restAttributes: this.restAttributes
    });
  }
}
x9.defaultProps = VMe;
var NMe = ["accessKey", "activeStateEnabled", "className", "dataSource", "defaultValue", "disabled", "displayExpr", "focusStateEnabled", "height", "hint", "hoverStateEnabled", "inputAttr", "isDirty", "isValid", "label", "labelMode", "name", "onClick", "onFocusIn", "onKeyDown", "placeholder", "readOnly", "rtlEnabled", "searchEnabled", "tabIndex", "validationError", "validationErrors", "validationMessageMode", "validationMessagePosition", "validationStatus", "value", "valueChange", "valueExpr", "visible", "width"], HMe = (t) => {
  var {
    componentProps: e,
    restAttributes: i
  } = t;
  return Uo(zi(2, MI, ae({
    componentType: KB,
    componentProps: e,
    templateNames: ["dropDownButtonTemplate", "groupTemplate", "itemTemplate"]
  }, i)));
}, pa = Object.create(Object.prototype, ae(Object.getOwnPropertyDescriptors(qr), Object.getOwnPropertyDescriptors({
  placeholder: "",
  hoverStateEnabled: !0,
  searchEnabled: !1,
  defaultValue: null,
  isReactComponentWrapper: !0
}))), $Me = {
  get placeholder() {
    return pa.placeholder;
  },
  get hoverStateEnabled() {
    return Tm.hoverStateEnabled;
  },
  get searchEnabled() {
    return pa.searchEnabled;
  },
  get defaultValue() {
    return pa.defaultValue;
  },
  get readOnly() {
    return pa.readOnly;
  },
  get name() {
    return pa.name;
  },
  get validationError() {
    return pa.validationError;
  },
  get validationErrors() {
    return pa.validationErrors;
  },
  get validationMessageMode() {
    return pa.validationMessageMode;
  },
  get validationMessagePosition() {
    return pa.validationMessagePosition;
  },
  get validationStatus() {
    return pa.validationStatus;
  },
  get isValid() {
    return pa.isValid;
  },
  get isDirty() {
    return pa.isDirty;
  },
  get inputAttr() {
    return pa.inputAttr;
  },
  get className() {
    return pa.className;
  },
  get activeStateEnabled() {
    return Tm.activeStateEnabled;
  },
  get disabled() {
    return pa.disabled;
  },
  get focusStateEnabled() {
    return Tm.focusStateEnabled;
  },
  get tabIndex() {
    return pa.tabIndex;
  },
  get visible() {
    return pa.visible;
  },
  get label() {
    return ZT.label;
  },
  get labelMode() {
    return ZT.labelMode;
  },
  isReactComponentWrapper: !0
};
class S9 extends qs {
  constructor(e) {
    super(e), this.state = {
      value: this.props.value !== void 0 ? this.props.value : this.props.defaultValue
    };
  }
  get componentProps() {
    return ae({}, this.props, {
      value: this.props.value !== void 0 ? this.props.value : this.state.value
    });
  }
  get restAttributes() {
    var e = ae({}, this.props, {
      value: this.props.value !== void 0 ? this.props.value : this.state.value
    }), i = sr(e, NMe);
    return i;
  }
  render() {
    var e = this.props;
    return HMe({
      props: ae({}, e, {
        value: this.props.value !== void 0 ? this.props.value : this.state.value
      }),
      componentProps: this.componentProps,
      restAttributes: this.restAttributes
    });
  }
}
S9.defaultProps = $Me;
var zMe = ["inputAttr", "pageSize", "pageSizeChange", "pageSizes", "parentRef"], WMe = (t) => {
  var {
    props: {
      inputAttr: e,
      pageSize: i,
      pageSizeChange: r,
      pageSizes: n
    },
    width: a
  } = t;
  return zi(2, S9, {
    displayExpr: "text",
    valueExpr: "value",
    dataSource: n,
    value: i,
    valueChange: r,
    width: a,
    inputAttr: e
  });
}, UMe = {
  inputAttr: Object.freeze({
    "aria-label": X.format("dxPager-ariaPageSize")
  })
}, GMe = {
  get pageSize() {
    return kn.pageSize;
  },
  get inputAttr() {
    return UMe.inputAttr;
  }
};
class E9 extends Bu {
  constructor(e) {
    super(e), this.state = {
      minWidth: 10
    }, this.updateWidth = this.updateWidth.bind(this);
  }
  createEffects() {
    return [new ar(this.updateWidth, [this.props, this.state.minWidth, this.props.pageSize, this.props.pageSizeChange, this.props.pageSizes, this.props.inputAttr])];
  }
  updateEffects() {
    var e;
    (e = this._effects[0]) === null || e === void 0 || e.update([this.props, this.state.minWidth, this.props.pageSize, this.props.pageSizeChange, this.props.pageSizes, this.props.inputAttr]);
  }
  updateWidth() {
    this.setState((e) => ({
      minWidth: l9(this.props.parentRef.current) || e.minWidth
    }));
  }
  get width() {
    return _9(this.state.minWidth, this.props.pageSizes.map((e) => e.value));
  }
  get restAttributes() {
    var e = this.props, i = sr(e, zMe);
    return i;
  }
  render() {
    var e = this.props;
    return WMe({
      props: ae({}, e),
      width: this.width,
      restAttributes: this.restAttributes
    });
  }
}
E9.defaultProps = GMe;
var KMe = ["pageSize", "pageSizeChange", "pageSizes"], jMe = (t) => {
  var {
    pageSizesText: e
  } = t;
  return sc(e.map((i) => {
    var {
      className: r,
      click: n,
      label: a,
      text: o
    } = i;
    return zi(2, Kx, {
      className: r,
      label: a,
      onClick: n,
      children: o
    }, o);
  }), 0);
};
var YMe = {
  get pageSize() {
    return kn.pageSize;
  }
};
class b9 extends qs {
  constructor(e) {
    super(e), this.state = {}, this.__getterCache = {}, this.onPageSizeChange = this.onPageSizeChange.bind(this);
  }
  get pageSizesText() {
    return this.__getterCache.pageSizesText !== void 0 ? this.__getterCache.pageSizesText : this.__getterCache.pageSizesText = (() => {
      var {
        pageSize: e,
        pageSizes: i
      } = this.props;
      return i.map((r, n) => {
        var {
          text: a,
          value: o
        } = r, u = o === e, c = $s({
          [u ? lMe : p9]: !0,
          [uMe]: n === 0
        });
        return {
          className: c,
          click: this.onPageSizeChange(o),
          label: Mu(X.getFormatter("dxPager-pageSize"), o || X.getFormatter("dxPager-pageSizesAllText")),
          text: a
        };
      });
    })();
  }
  onPageSizeChange(e) {
    return () => (this.props.pageSizeChange(e), this.props.pageSize);
  }
  get restAttributes() {
    var e = this.props, i = sr(e, KMe);
    return i;
  }
  componentWillUpdate(e, i, r) {
    (this.props.pageSize !== e.pageSize || this.props.pageSizes !== e.pageSizes || this.props.pageSizeChange !== e.pageSizeChange) && (this.__getterCache.pageSizesText = void 0);
  }
  render() {
    var e = this.props;
    return jMe({
      props: ae({}, e),
      pageSizesText: this.pageSizesText,
      restAttributes: this.restAttributes
    });
  }
}
b9.defaultProps = YMe;
var qMe = ["isLargeDisplayMode", "pageSize", "pageSizeChange", "pageSizes", "rootElementRef"], XMe = (t) => {
  var {
    htmlRef: e,
    normalizedPageSizes: i,
    props: {
      isLargeDisplayMode: r,
      pageSize: n,
      pageSizeChange: a
    }
  } = t;
  return Fr(1, "div", sMe, [r && zi(2, b9, {
    pageSizes: i,
    pageSize: n,
    pageSizeChange: a
  }), !r && zi(2, E9, {
    parentRef: e,
    pageSizes: i,
    pageSize: n,
    pageSizeChange: a
  })], 0, null, null, e);
};
function QMe() {
  return X.getFormatter("dxPager-pageSizesAllText")();
}
var ZMe = {
  isLargeDisplayMode: !0
}, JMe = {
  get pageSize() {
    return kn.pageSize;
  },
  get pageSizes() {
    return kn.pageSizes;
  },
  get isLargeDisplayMode() {
    return ZMe.isLargeDisplayMode;
  }
};
class w9 extends Bu {
  constructor(e) {
    super(e), this.state = {}, this.htmlRef = Vn(), this.__getterCache = {}, this.setRootElementRef = this.setRootElementRef.bind(this);
  }
  createEffects() {
    return [new ar(this.setRootElementRef, [])];
  }
  setRootElementRef() {
    var {
      rootElementRef: e
    } = this.props;
    e && (e.current = this.htmlRef.current);
  }
  get normalizedPageSizes() {
    return this.__getterCache.normalizedPageSizes !== void 0 ? this.__getterCache.normalizedPageSizes : this.__getterCache.normalizedPageSizes = (() => {
      var {
        pageSizes: e
      } = this.props;
      return e.map((i) => i === "all" || i === 0 ? {
        text: QMe(),
        value: 0
      } : {
        text: String(i),
        value: i
      });
    })();
  }
  get restAttributes() {
    var e = this.props, i = sr(e, qMe);
    return i;
  }
  componentWillUpdate(e, i, r) {
    super.componentWillUpdate(), this.props.pageSizes !== e.pageSizes && (this.__getterCache.normalizedPageSizes = void 0);
  }
  render() {
    var e = this.props;
    return XMe({
      props: ae({}, e),
      htmlRef: this.htmlRef,
      normalizedPageSizes: this.normalizedPageSizes,
      restAttributes: this.restAttributes
    });
  }
}
w9.defaultProps = JMe;
var eke = ["className", "displayMode", "gridCompatibility", "hasKnownLastPage", "infoText", "infoTextRef", "infoTextVisible", "isLargeDisplayMode", "label", "lightModeEnabled", "maxPagesCount", "onKeyDown", "pageCount", "pageIndex", "pageIndexChange", "pageSize", "pageSizeChange", "pageSizes", "pageSizesRef", "pagesCountText", "pagesNavigatorVisible", "pagesRef", "rootElementRef", "rtlEnabled", "showInfo", "showNavigationButtons", "showPageSizes", "totalCount", "visible"], tke = (t) => {
  var {
    aria: e,
    classes: i,
    infoVisible: r,
    isLargeDisplayMode: n,
    pageIndexSelectorVisible: a,
    pagesContainerVisibility: o,
    pagesContainerVisible: u,
    props: {
      hasKnownLastPage: c,
      infoText: p,
      infoTextRef: v,
      maxPagesCount: _,
      pageCount: y,
      pageIndex: b,
      pageIndexChange: I,
      pageSize: A,
      pageSizeChange: L,
      pageSizes: B,
      pageSizesRef: $,
      pagesCountText: K,
      pagesRef: te,
      rtlEnabled: z,
      showNavigationButtons: ie,
      showPageSizes: pe,
      totalCount: _e,
      visible: be
    },
    restAttributes: De,
    widgetRootElementRef: Ce
  } = t;
  return Uo(zi(2, gI, ae({
    rootElementRef: Ce,
    rtlEnabled: z,
    classes: i,
    visible: be,
    aria: e
  }, De, {
    children: [pe && zi(2, w9, {
      rootElementRef: $,
      isLargeDisplayMode: n,
      pageSize: A,
      pageSizeChange: L,
      pageSizes: B
    }), u && Fr(1, "div", nMe, [r && zi(2, h9, {
      rootElementRef: v,
      infoText: p,
      pageCount: y,
      pageIndex: b,
      totalCount: _e
    }), a && Fr(1, "div", aMe, zi(2, x9, {
      hasKnownLastPage: c,
      isLargeDisplayMode: n,
      maxPagesCount: _,
      pageCount: y,
      pageIndex: b,
      pageIndexChange: I,
      pagesCountText: K,
      showNavigationButtons: ie,
      totalCount: _e
    }), 2, null, null, te)], 0, {
      style: AF({
        visibility: o
      })
    })]
  })));
}, ike = Object.create(Object.prototype, ae(Object.getOwnPropertyDescriptors(kn), Object.getOwnPropertyDescriptors({
  infoTextVisible: !0,
  isLargeDisplayMode: !0
})));
class T9 extends Bu {
  constructor(e) {
    super(e), this.state = {}, this.widgetRootElementRef = Vn(), this.__getterCache = {}, this.setRootElementRef = this.setRootElementRef.bind(this), this.createFakeInstance = this.createFakeInstance.bind(this);
  }
  createEffects() {
    return [new ar(this.setRootElementRef, [])];
  }
  getChildContext() {
    return ae({}, this.context, {
      [xx.id]: this.keyboardAction || xx.defaultValue
    });
  }
  setRootElementRef() {
    var {
      rootElementRef: e
    } = this.props;
    e && (e.current = this.widgetRootElementRef.current);
  }
  createFakeInstance() {
    return {
      option: () => !1,
      element: () => this.widgetRootElementRef.current,
      _createActionByOption: () => (e) => {
        var i, r;
        (i = (r = this.props).onKeyDown) === null || i === void 0 || i.call(r, e);
      }
    };
  }
  get keyboardAction() {
    return this.__getterCache.keyboardAction !== void 0 ? this.__getterCache.keyboardAction : this.__getterCache.keyboardAction = {
      registerKeyboardAction: (e, i) => {
        var r = this.createFakeInstance();
        return qq("pager", r, e, void 0, i);
      }
    };
  }
  get infoVisible() {
    var {
      infoTextVisible: e,
      showInfo: i
    } = this.props;
    return i && e;
  }
  get pageIndexSelectorVisible() {
    return this.props.pageSize !== 0;
  }
  get normalizedDisplayMode() {
    var {
      displayMode: e,
      lightModeEnabled: i
    } = this.props;
    return e === "adaptive" && i !== void 0 ? i ? "compact" : "full" : e;
  }
  get pagesContainerVisible() {
    return !!this.props.pagesNavigatorVisible && this.props.pageCount > 0;
  }
  get pagesContainerVisibility() {
    if (this.props.pagesNavigatorVisible === "auto" && this.props.pageCount === 1 && this.props.hasKnownLastPage)
      return "hidden";
  }
  get isLargeDisplayMode() {
    var e = this.normalizedDisplayMode, i = !1;
    return e === "adaptive" ? i = this.props.isLargeDisplayMode : i = e === "full", i;
  }
  get classes() {
    var e = {
      ["".concat(this.props.className)]: !!this.props.className,
      [iMe]: !0,
      [rMe]: !this.isLargeDisplayMode
    };
    return $s(e);
  }
  get aria() {
    return {
      role: "navigation",
      label: this.props.label
    };
  }
  get restAttributes() {
    var e = this.props, i = sr(e, eke);
    return i;
  }
  componentWillUpdate(e, i, r) {
    super.componentWillUpdate(), this.props.onKeyDown !== e.onKeyDown && (this.__getterCache.keyboardAction = void 0);
  }
  render() {
    var e = this.props;
    return tke({
      props: ae({}, e),
      widgetRootElementRef: this.widgetRootElementRef,
      keyboardAction: this.keyboardAction,
      infoVisible: this.infoVisible,
      pageIndexSelectorVisible: this.pageIndexSelectorVisible,
      pagesContainerVisible: this.pagesContainerVisible,
      pagesContainerVisibility: this.pagesContainerVisibility,
      isLargeDisplayMode: this.isLargeDisplayMode,
      classes: this.classes,
      aria: this.aria,
      restAttributes: this.restAttributes
    });
  }
}
T9.defaultProps = ike;
var rke = ["className", "defaultPageIndex", "defaultPageSize", "displayMode", "gridCompatibility", "hasKnownLastPage", "infoText", "label", "lightModeEnabled", "maxPagesCount", "onKeyDown", "pageCount", "pageIndex", "pageIndexChange", "pageSize", "pageSizeChange", "pageSizes", "pagesCountText", "pagesNavigatorVisible", "rtlEnabled", "showInfo", "showNavigationButtons", "showPageSizes", "totalCount", "visible"], nke = (t) => {
  var {
    pagerProps: e,
    restAttributes: i
  } = t;
  return Uo(zi(2, u9, ae({
    contentTemplate: T9,
    pagerProps: e
  }, i)));
};
let I9 = class extends aS {
  constructor(e) {
    super(e), this.__getterCache = {}, this.state = {
      pageSize: this.props.pageSize !== void 0 ? this.props.pageSize : this.props.defaultPageSize,
      pageIndex: this.props.pageIndex !== void 0 ? this.props.pageIndex : this.props.defaultPageIndex
    }, this.pageIndexChange = this.pageIndexChange.bind(this), this.pageSizeChange = this.pageSizeChange.bind(this);
  }
  createEffects() {
    return [oS()];
  }
  pageIndexChange(e) {
    if (this.props.gridCompatibility) {
      var i;
      this.setState((n) => (i = e + 1, {
        pageIndex: i
      })), this.props.pageIndexChange(i);
    } else {
      var r;
      this.setState((n) => (r = e, {
        pageIndex: r
      })), this.props.pageIndexChange(r);
    }
  }
  get pageIndex() {
    return this.props.gridCompatibility ? (this.props.pageIndex !== void 0 ? this.props.pageIndex : this.state.pageIndex) - 1 : this.props.pageIndex !== void 0 ? this.props.pageIndex : this.state.pageIndex;
  }
  pageSizeChange(e) {
    var i;
    this.setState((r) => (i = e, {
      pageSize: i
    })), this.props.pageSizeChange(i);
  }
  get className() {
    return this.props.gridCompatibility ? $s({
      "dx-datagrid-pager": !0,
      ["".concat(this.props.className)]: !!this.props.className
    }) : this.props.className;
  }
  get pagerProps() {
    return this.__getterCache.pagerProps !== void 0 ? this.__getterCache.pagerProps : this.__getterCache.pagerProps = ae({}, ae({}, this.props, {
      pageSize: this.props.pageSize !== void 0 ? this.props.pageSize : this.state.pageSize,
      pageIndex: this.props.pageIndex !== void 0 ? this.props.pageIndex : this.state.pageIndex
    }), {
      className: this.className,
      pageIndex: this.pageIndex,
      pageIndexChange: (e) => this.pageIndexChange(e),
      pageSizeChange: (e) => this.pageSizeChange(e)
    });
  }
  get restAttributes() {
    var e = ae({}, this.props, {
      pageSize: this.props.pageSize !== void 0 ? this.props.pageSize : this.state.pageSize,
      pageIndex: this.props.pageIndex !== void 0 ? this.props.pageIndex : this.state.pageIndex
    }), i = sr(e, rke);
    return i;
  }
  componentWillUpdate(e, i, r) {
    super.componentWillUpdate(), (this.props !== e || this.props.gridCompatibility !== e.gridCompatibility || this.props.className !== e.className || this.state.pageIndex !== i.pageIndex || this.props.pageIndex !== e.pageIndex || this.props.pageIndexChange !== e.pageIndexChange || this.props.pageSizeChange !== e.pageSizeChange) && (this.__getterCache.pagerProps = void 0);
  }
  render() {
    var e = this.props;
    return nke({
      props: ae({}, e, {
        pageSize: this.props.pageSize !== void 0 ? this.props.pageSize : this.state.pageSize,
        pageIndex: this.props.pageIndex !== void 0 ? this.props.pageIndex : this.state.pageIndex
      }),
      pageIndexChange: this.pageIndexChange,
      pageIndex: this.pageIndex,
      pageSizeChange: this.pageSizeChange,
      className: this.className,
      pagerProps: this.pagerProps,
      restAttributes: this.restAttributes
    });
  }
};
I9.defaultProps = qLe;
let D9 = class extends HLe {
  getProps() {
    var e = super.getProps();
    return e.onKeyDown = this._wrapKeyDownHandler(e.onKeyDown), e;
  }
  get _propsInfo() {
    return {
      twoWay: [
        ["pageSize", "defaultPageSize", "pageSizeChange"],
        ["pageIndex", "defaultPageIndex", "pageIndexChange"]
      ],
      allowNull: [],
      elements: [],
      templates: [],
      props: ["defaultPageSize", "pageSizeChange", "defaultPageIndex", "pageIndexChange", "gridCompatibility", "className", "showInfo", "infoText", "lightModeEnabled", "displayMode", "maxPagesCount", "pageCount", "pagesCountText", "visible", "hasKnownLastPage", "pagesNavigatorVisible", "showPageSizes", "pageSizes", "rtlEnabled", "showNavigationButtons", "totalCount", "label", "onKeyDown", "pageSize", "pageIndex"]
    };
  }
  get _viewComponent() {
    return I9;
  }
};
ti("dxPager", D9);
var ake = "pager", oke = 10, Z2 = function(t) {
  return 1 + (parseInt(t.pageIndex()) || 0);
};
class ske extends Bi.View {
  init() {
    var e = this.getController("data");
    e.changed.add((i) => {
      if (i && i.repaintChangesOnly) {
        var r = this._pager;
        r ? r.option({
          pageIndex: Z2(e),
          pageSize: e.pageSize(),
          pageCount: e.pageCount(),
          totalCount: e.totalCount(),
          hasKnownLastPage: e.hasKnownLastPage()
        }) : this.render();
      } else
        (!i || i.changeType !== "update" && i.changeType !== "updateSelection" && i.changeType !== "updateFocusedRow") && (this._pager = null, this.render());
    });
  }
  dispose() {
    this._pager = null;
  }
  optionChanged(e) {
    var {
      name: i
    } = e, r = i === "pager", n = i === "paging", a = i === "dataSource", o = i === "scrolling", u = this.getController("data");
    if (r || n || o || a) {
      if (e.handled = !0, u.skipProcessingPagingChange(e.fullName))
        return;
      (r || n) && (this._pageSizes = null), a || (this._pager = null, this._invalidate(), wt() && r && this.component && this.component.resize());
    }
  }
  _renderCore() {
    var e, i = this.element().addClass(this.addWidgetPrefix(ake)), r = (e = this.option("pager")) !== null && e !== void 0 ? e : {}, n = this.getController("data"), a = this.getController("keyboardNavigation"), o = {
      maxPagesCount: oke,
      pageIndex: Z2(n),
      pageCount: n.pageCount(),
      pageSize: n.pageSize(),
      showPageSizes: r.showPageSizeSelector,
      showInfo: r.showInfo,
      displayMode: r.displayMode,
      pagesNavigatorVisible: r.visible,
      showNavigationButtons: r.showNavigationButtons,
      label: r.label,
      pageSizes: this.getPageSizes(),
      totalCount: n.totalCount(),
      hasKnownLastPage: n.hasKnownLastPage(),
      pageIndexChanged(u) {
        n.pageIndex() !== u - 1 && n.pageIndex(u - 1);
      },
      pageSizeChanged(u) {
        n.pageSize(u);
      },
      onKeyDown: (u) => a && a.executeAction("onKeyDown", u),
      useLegacyKeyboardNavigation: this.option("useLegacyKeyboardNavigation"),
      useKeyboard: this.option("keyboardNavigation.enabled")
    };
    if (R(r.infoText) && (o.infoText = r.infoText), this._pager) {
      this._pager.repaint();
      return;
    }
    wt() ? this._pager = this._createComponent(i, D9, o) : i.addClass("dx-pager").html('<div class="dx-pages"><div class="dx-page"></div></div>');
  }
  getPager() {
    return this._pager;
  }
  getPageSizes() {
    var e = this.getController("data"), i = this.option("pager"), r = i && i.allowedPageSizes, n = e.pageSize();
    return (!R(this._pageSizes) || !this._pageSizes.includes(n)) && (this._pageSizes = [], i && (Array.isArray(r) ? this._pageSizes = r : r && n > 1 && (this._pageSizes = [Math.floor(n / 2), n, 2 * n]))), this._pageSizes;
  }
  isVisible() {
    var e = this.getController("data"), i = this.option("pager"), r = i && i.visible, n = this.option("scrolling");
    return r === "auto" && (n && (n.mode === "virtual" || n.mode === "infinite") ? r = !1 : r = e.pageCount() > 1 || e.isLoaded() && !e.hasKnownLastPage()), !!r;
  }
  getHeight() {
    return this.getElementHeight();
  }
}
var lke = {
  defaultOptions: () => ({
    pager: {
      visible: "auto",
      showPageSizeSelector: !1,
      allowedPageSizes: "auto",
      label: X.format("dxPager-ariaLabel")
    }
  }),
  views: {
    pagerView: ske
  }
};
et.registerModule("pager", lke);
var uke = "columns-separator", J2 = "columns-separator-transparent", e3 = "drag-header", dke = "text-content", YP = "drag-action", t3 = "tracker", i3 = "drop-highlight", r3 = "dx-block-separator", n3 = "dx-header-row", cke = "dx-widget", hke = "dx-drag-command-cell", Ho = "dxDataGridResizingReordering", fke = 10, a3 = 5, ak = 0.5, Sx = function(t) {
  return t.option("allowColumnResizing") || t.getController("columns").isColumnOptionUsed("allowResizing");
}, A9 = function(t) {
  return t.option("allowColumnReordering") || t.getController("columns").isColumnOptionUsed("allowReordering");
};
let pke = class extends Bi.View {
  init() {
    super.init(), this._tablePositionController = this.getController("tablePosition"), this._subscribeToCallback();
  }
  dispose() {
    this._unsubscribeFromCallback(), super.dispose();
  }
  optionChanged(e) {
    e.name === "allowColumnResizing" && (this._unsubscribeFromCallback(), e.value && (this._subscribeToCallback(), this._invalidate())), super.optionChanged(e);
  }
  _renderCore() {
    var e = super._renderCore();
    return this.element().addClass(this.addWidgetPrefix(t3)), this.hide(), e;
  }
  _unsubscribeFromCallback() {
    this._positionChanged && this._tablePositionController.positionChanged.remove(this._positionChanged);
  }
  _subscribeToCallback() {
    var e = this;
    e._positionChanged = function(i) {
      var r = e.element();
      r && r.hasClass(e.addWidgetPrefix(t3)) && (r.css({
        top: i.top
      }), Dh(r, i.height));
    }, this._tablePositionController.positionChanged.add(e._positionChanged);
  }
  isVisible() {
    return Sx(this);
  }
  show() {
    this.element().show();
  }
  hide() {
    this.element() && this.element().hide();
  }
  setHeight(e) {
    Dh(this.element(), e);
  }
};
class O9 extends Bi.View {
  _renderSeparator() {
  }
  _renderCore(e) {
    var i = super._renderCore(e);
    return this._isShown = !0, this._renderSeparator(), this.hide(), i;
  }
  show() {
    this._isShown = !0;
  }
  hide() {
    this._isShown = !1;
  }
  height(e) {
    var i = this.element();
    if (i)
      if (R(e))
        Dh(i, e);
      else
        return Pt(i);
  }
  width(e) {
    var i = this.element();
    if (i)
      if (R(e))
        gF(i, e);
      else
        return mt(i);
  }
}
let vke = class extends O9 {
  init() {
    super.init(), this._tablePositionController = this.getController("tablePosition"), this._init();
  }
  dispose() {
    this._unsubscribeFromCallback(), super.dispose();
  }
  optionChanged(e) {
    e.name === "allowColumnResizing" && (e.value ? (this._init(), this._invalidate(), this.hide(!0)) : (this._unsubscribeFromCallback(), this._isTransparent = Sx(this), this.hide(!0))), super.optionChanged(e);
  }
  _renderSeparator() {
    super._renderSeparator();
    var e = this.element();
    e.addClass(this.addWidgetPrefix(uke));
  }
  _subscribeToCallback() {
    var e = this, i;
    e._positionChanged = function(r) {
      i = e.element(), i && (i.css({
        top: r.top
      }), Dh(i, r.height));
    }, e._tablePositionController.positionChanged.add(e._positionChanged);
  }
  _unsubscribeFromCallback() {
    this._positionChanged && this._tablePositionController.positionChanged.remove(this._positionChanged);
  }
  _init() {
    this._isTransparent = Sx(this), this.isVisible() && this._subscribeToCallback();
  }
  isVisible() {
    return this.option("showColumnHeaders") && (A9(this) || Sx(this));
  }
  show() {
    var e = this.element();
    e && !this._isShown && (this._isTransparent ? e.removeClass(this.addWidgetPrefix(J2)) : e.show()), super.show();
  }
  hide(e) {
    var i = this.element(), r = this.addWidgetPrefix(J2);
    i && (this._isShown || e) && (this._isTransparent ? (i.addClass(r), i.css("left", ""), i.show()) : (i.hasClass(r) && i.removeClass(r), i.hide())), super.hide();
  }
  moveByX(e) {
    var i = this.element();
    i && i.css("left", e === null ? 0 : e - this._parentElement().offset().left);
  }
  changeCursor(e) {
    e = R(e) ? e : "";
    var i = this.element();
    i && i.css("cursor", e);
  }
};
class gke extends O9 {
  init() {
    super.init();
    var e = this.getController("data");
    e.loadingChanged.add((i) => {
      i || this.hide();
    });
  }
  _renderSeparator() {
    super._renderSeparator(), this.element().addClass(r3).html("&nbsp;");
  }
  hide() {
    var e = this._parentElement(), i = this.element();
    i && this._isShown && i.css("display", "none"), e && !e.children(".".concat(r3)).length && e.prepend(this.element()), super.hide();
  }
  isVisible() {
    var e = this.option("groupPanel"), i = this.option("columnChooser");
    return e && e.visible || i && i.enabled;
  }
  show(e) {
    var i = this.element();
    if (i && !this._isShown)
      switch (e) {
        case "group":
          this.element().css("display", "block");
          break;
        case "columnChooser":
          (function(r) {
            ji.stop(i, !0), ji.animate(i, {
              type: "slide",
              from: {
                width: 0,
                display: r.display
              },
              to: r,
              duration: 300,
              easing: "swing"
            });
          })({
            width: "100%",
            display: "block"
          });
          break;
        default:
          i.css("display", "");
      }
    super.show();
  }
}
let mke = class extends Bi.View {
  init() {
    super.init();
    var e = this.getController("data");
    this._controller = this.getController("draggingHeader"), this._columnsResizerViewController = this.getController("columnsResizer"), this._columnsController = this.getController("columns"), this._isDragging = !1, e.loadingChanged.add((i) => {
      var r = this.element();
      !i && r && r.hide();
    });
  }
  isDragging() {
    return this._isDragging;
  }
  _getDraggingPanelByPos(e) {
    var i;
    return N(this._dragOptions.draggingPanels, (r, n) => {
      if (n) {
        var a = n.getBoundingRect();
        if (a && (a.bottom === void 0 || e.y < a.bottom) && (a.top === void 0 || e.y > a.top) && (a.left === void 0 || e.x > a.left) && (a.right === void 0 || e.x < a.right))
          return i = n, !1;
      }
    }), i;
  }
  _renderCore() {
    this.element().addClass("".concat(this.addWidgetPrefix(e3), " ").concat(this.addWidgetPrefix(dke), " ").concat(cke)).hide();
  }
  _resetTargetColumnOptions() {
    var e = this._dropOptions;
    e.targetColumnIndex = -1, delete e.targetColumnElement, delete e.isLast, delete e.posX, delete e.posY;
  }
  _getVisibleIndexObject(e, i) {
    return R(e) ? {
      columnIndex: i,
      rowIndex: e
    } : i;
  }
  dispose() {
    var e = this.element();
    this._dragOptions = null, e && e.parent().find(".".concat(this.addWidgetPrefix(e3))).remove();
  }
  isVisible() {
    var e = this._columnsController.getCommonSettings();
    return this.option("showColumnHeaders") && (A9(this) || e.allowGrouping || e.allowHiding);
  }
  dragHeader(e) {
    var {
      columnElement: i
    } = e, r = !!e.sourceColumn.type;
    this._isDragging = !0, this._dragOptions = e, this._dropOptions = {
      sourceIndex: e.index,
      sourceColumnIndex: this._getVisibleIndexObject(e.rowIndex, e.columnIndex),
      sourceColumnElement: e.columnElement,
      sourceLocation: e.sourceLocation
    };
    var n = de.getDocument();
    this._onSelectStart = n.onselectstart, n.onselectstart = function() {
      return !1;
    }, this._controller.drag(this._dropOptions), this.element().css({
      textAlign: i && i.css("textAlign"),
      height: i && (r && i.get(0).clientHeight || Pt(i)),
      width: i && (r && i.get(0).clientWidth || mt(i)),
      whiteSpace: i && i.css("whiteSpace")
    }).addClass(this.addWidgetPrefix(YP)).toggleClass(hke, r).text(r ? "" : e.sourceColumn.caption), this.element().appendTo(X6.getSwatchContainer(i));
  }
  moveHeader(e) {
    var i = e.event, {
      that: r
    } = i.data, n = br(i), a = r._columnsResizerViewController ? r._columnsResizerViewController.isResizing() : !1, o = r._dragOptions;
    if (r._isDragging && !a) {
      var u = r.element(), c = Math.abs(n.x - o.columnElement.offset().left - o.deltaX), p = Math.abs(n.y - o.columnElement.offset().top - o.deltaY);
      if (u.is(":visible") || c > a3 || p > a3) {
        u.show();
        var v = n.x - o.deltaX, _ = n.y - o.deltaY;
        u.css({
          left: v,
          top: _
        }), r.dockHeader(n);
      }
      i.preventDefault();
    }
  }
  dockHeader(e) {
    var i = this._getDraggingPanelByPos(e), r = this._controller, n = this._dropOptions, a = this._dragOptions;
    if (i) {
      var o = this.option("rtlEnabled"), u = i.getName() === "columnChooser", c = u ? "y" : "x", p = i.getName(), v = p === "headers" ? a.rowIndex : void 0, {
        sourceColumn: _
      } = a, y = i.getColumnElements(v, _ == null ? void 0 : _.ownerBand) || [], b = a.pointsByTarget = a.pointsByTarget || {}, I = p === "columnChooser" ? [] : b[p] || r._generatePointsByColumns(P({}, a, {
        targetDraggingPanel: i,
        columns: i.getColumns(v),
        columnElements: y,
        isVerticalOrientation: u,
        startColumnIndex: p === "headers" && E(y[0]).index()
      }));
      if (b[p] = I, n.targetLocation = p, I.length > 0)
        for (var A = 0; A < I.length; A++) {
          var L = I[A + 1] && (I[A][c] + I[A + 1][c]) / 2;
          if (L === void 0 || (o && c === "x" ? e[c] > L : e[c] < L)) {
            n.targetColumnIndex = this._getVisibleIndexObject(v, I[A].columnIndex), y[A] ? (n.targetColumnElement = y.eq(A), n.isLast = !1) : (n.targetColumnElement = y.last(), n.isLast = !0), n.posX = I[A].x, n.posY = I[A].y, r.dock(n);
            break;
          }
        }
      else
        this._resetTargetColumnOptions(), r.dock(n);
    }
  }
  dropHeader(e) {
    var i = e.event, {
      that: r
    } = i.data, n = r._controller;
    r.element().hide(), n && r._isDragging && n.drop(r._dropOptions), r.element().appendTo(r._parentElement()), r._dragOptions = null, r._dropOptions = null, r._isDragging = !1, de.getDocument().onselectstart = r._onSelectStart || null;
  }
};
var ok = function(t) {
  return t.option("columnResizingMode") !== "widget";
};
let _ke = class extends Bi.ViewController {
  init() {
    this._subscribesToCallbacks = [], Sx(this) && this._init();
  }
  dispose() {
    this._unsubscribes(), super.dispose();
  }
  optionChanged(e) {
    super.optionChanged(e), e.name === "allowColumnResizing" && (e.value ? (this._init(), this._subscribeToEvents()) : this._unsubscribes());
  }
  _isHeadersRowArea(e) {
    if (this._columnHeadersView) {
      var i = this._columnHeadersView.element();
      if (i) {
        var r = i.offset().top, n = this._columnHeadersView.getHeadersRowHeight();
        return e >= r && e <= r + n;
      }
    }
    return !1;
  }
  _isRtlParentStyle() {
    var e;
    return this.option("rtlEnabled") && ((e = this._$parentContainer) === null || e === void 0 ? void 0 : e.parent().css("direction")) === "rtl";
  }
  _pointCreated(e, i, r) {
    var n = ok(this), a = this.option("rtlEnabled"), o = this._isRtlParentStyle(), u = !n && a && !o ? 0 : 1;
    if (e.index >= u && e.index < i + (!n && (!a || o) ? 1 : 0)) {
      e.columnIndex -= u;
      var c = r[e.columnIndex] || {}, p = r[e.columnIndex + 1] || {};
      return !(n ? c.allowResizing && p.allowResizing : c.allowResizing);
    }
    return !0;
  }
  _getTargetPoint(e, i, r) {
    if (e) {
      for (var n = 0; n < e.length; n++)
        if (!(e[n].x === e[0].x && e[n + 1] && e[n].x === e[n + 1].x) && e[n].x - r <= i && i <= e[n].x + r)
          return e[n];
    }
    return null;
  }
  _moveSeparator(e) {
    var i, r = e.event, n = r.data, a = n._columnsSeparatorView.width(), o = ok(n), u = a / 2, c = n._$parentContainer.offset(), p = c.left, v = br(r), _ = n.option("rtlEnabled"), y = this._isRtlParentStyle(), b = (i = n._draggingHeaderView) === null || i === void 0 ? void 0 : i.isDragging();
    if (n._isResizing && n._resizingInfo) {
      if ((p <= v.x || !o && y) && (!o || v.x <= p + mt(n._$parentContainer)) && n._updateColumnsWidthIfNeeded(v.x)) {
        var I = n._columnHeadersView.getColumnElements().eq(n._resizingInfo.currentColumnIndex), A = I[0];
        if (A) {
          var L = A.getBoundingClientRect().width;
          n._columnsSeparatorView.moveByX(I.offset().left + ((o || y) && _ ? 0 : L)), n._tablePositionController.update(n._targetPoint.y), r.preventDefault();
        }
      }
    } else
      b || (n._isHeadersRowArea(v.y) ? (n._previousParentOffset && (n._previousParentOffset.left !== c.left || n._previousParentOffset.top !== c.top) && n.pointsByColumns(null), n._targetPoint = n._getTargetPoint(n.pointsByColumns(), v.x, a), n._previousParentOffset = c, n._isReadyResizing = !1, n._targetPoint ? (n._columnsSeparatorView.changeCursor("col-resize"), n._columnsSeparatorView.moveByX(n._targetPoint.x - u), n._tablePositionController.update(n._targetPoint.y), n._isReadyResizing = !0, r.preventDefault()) : (n._columnsSeparatorView.changeCursor(), n._columnsSeparatorView.moveByX(null))) : (n.pointsByColumns(null), n._isReadyResizing = !1, n._columnsSeparatorView.changeCursor(), n._columnsSeparatorView.moveByX(null)));
  }
  _endResizing(e) {
    var i = e.event, r = i.data;
    r._isResizing && (r.pointsByColumns(null), r._resizingInfo = null, r._columnsSeparatorView.hide(), r._columnsSeparatorView.changeCursor(), r._trackerView.hide(), r._isReadyResizing = !1, r._isResizing = !1);
  }
  _getNextColumnIndex(e) {
    return e + 1;
  }
  _setupResizingInfo(e) {
    var i = this._targetPoint.columnIndex, r = this._getNextColumnIndex(i), n = this._columnHeadersView.getHeaderElement(i), a = this._columnHeadersView.getHeaderElement(r);
    this._resizingInfo = {
      startPosX: e,
      currentColumnIndex: i,
      currentColumnWidth: n && n.length > 0 ? zr(n[0]).width : 0,
      nextColumnIndex: r,
      nextColumnWidth: a && a.length > 0 ? zr(a[0]).width : 0
    };
  }
  _startResizing(e) {
    var i = e.event, r = i.data, n = br(i);
    if (nS(i) && (r._isHeadersRowArea(n.y) ? (r._targetPoint = r._getTargetPoint(r.pointsByColumns(), n.x, fke), r._targetPoint && (r._columnsSeparatorView.moveByX(r._targetPoint.x - r._columnsSeparatorView.width() / 2), r._isReadyResizing = !0)) : r._isReadyResizing = !1), r._isReadyResizing) {
      r._setupResizingInfo(n.x), r._isResizing = !0, r._tablePositionController.update(r._targetPoint.y), r._columnsSeparatorView.show(), r._trackerView.show();
      var a = r.component.getScrollable();
      a && r._isRtlParentStyle() && (r._scrollRight = mt(a.$content()) - mt(a.container()) - a.scrollLeft()), i.preventDefault(), i.stopPropagation();
    }
    this.isResizing() && this._editorFactoryController.loseFocus();
  }
  _generatePointsByColumns() {
    var e = this, i = e._columnsController ? e._columnsController.getVisibleColumns() : [], r = e._columnHeadersView.getColumnElements(), n = [];
    r && r.length > 0 && (n = xe.getPointsByColumns(r, (a) => e._pointCreated(a, r.length, i))), e._pointsByColumns = n;
  }
  _unsubscribeFromEvents() {
    this._moveSeparatorHandler && k.off(de.getDocument(), ve(Xt.move, Ho), this._moveSeparatorHandler), this._startResizingHandler && k.off(this._$parentContainer, ve(Xt.down, Ho), this._startResizingHandler), this._endResizingHandler && (k.off(this._columnsSeparatorView.element(), ve(Xt.up, Ho), this._endResizingHandler), k.off(de.getDocument(), ve(Xt.up, Ho), this._endResizingHandler));
  }
  _subscribeToEvents() {
    this._moveSeparatorHandler = this.createAction(this._moveSeparator), this._startResizingHandler = this.createAction(this._startResizing), this._endResizingHandler = this.createAction(this._endResizing), k.on(de.getDocument(), ve(Xt.move, Ho), this, this._moveSeparatorHandler), k.on(this._$parentContainer, ve(Xt.down, Ho), this, this._startResizingHandler), k.on(this._columnsSeparatorView.element(), ve(Xt.up, Ho), this, this._endResizingHandler), k.on(de.getDocument(), ve(Xt.up, Ho), this, this._endResizingHandler);
  }
  _updateColumnsWidthIfNeeded(e) {
    var i, r, n = this._rowsView.contentWidth(), a = this._resizingInfo, o = this._columnsController, u = o.getVisibleColumns(), c = this._columnsSeparatorView.width(), p = ok(this), v = p && this.option("adaptColumnWidthByRatio") && !this.option("columnAutoWidth"), _ = this.option("rtlEnabled"), y = this._isRtlParentStyle(), b = u[a.currentColumnIndex], I = u[a.nextColumnIndex];
    function A(be) {
      return ht(be) && be.endsWith("%");
    }
    function L(be, De, Ce, ft) {
      if (be) {
        var Ve = be.width;
        Ve && (ft = A(Ve)), ft ? (o.columnOption(be.index, "visibleWidth", De), o.columnOption(be.index, "width", "".concat((De / Ce * 100).toFixed(3), "%"))) : (o.columnOption(be.index, "visibleWidth", null), o.columnOption(be.index, "width", De));
      }
    }
    i = e - a.startPosX, (p || y) && _ && (i = -i);
    var {
      cellWidth: B,
      nextCellWidth: $
    } = function(be) {
      var De, Ce, ft, Ve = a.currentColumnWidth + be, Ee = b && b.minWidth || c, Re = {};
      return Ve >= Ee ? Re.cellWidth = Ve : (Re.cellWidth = Ee, ft = !0), p && (Ce = a.nextColumnWidth - be, De = I && I.minWidth || c, Ce >= De ? ft ? Re.nextCellWidth = a.nextColumnWidth - (be + Ee - Ve) : Re.nextCellWidth = Ce : (Re.nextCellWidth = De, Re.cellWidth = a.currentColumnWidth + (be - De + Ce))), Re;
    }(i);
    if (r = b.width !== B, r) {
      if (o.beginUpdate(), B = Math.floor(B), n = function(be, De) {
        var Ce = De.every((Ve) => Ve.width);
        if (Ce) {
          var ft = De.reduce((Ve, Ee) => (A(Ee.width) && (Ve += parseFloat(Ee.width)), Ve), 0);
          ft > 100 && (be = be / ft * 100);
        }
        return be;
      }(n, u), L(b, B, n, v), p)
        $ = Math.floor($), L(I, $, n, v);
      else {
        var K = this._columnHeadersView.getColumnWidths();
        K[a.currentColumnIndex] = B;
        var te = K.reduce((be, De) => be + De, 0) > this._rowsView.contentWidth();
        if (!te) {
          var z = xe.getLastResizableColumnIndex(u);
          z >= 0 && o.columnOption(u[z].index, "visibleWidth", "auto");
        }
        for (var ie = 0; ie < K.length; ie++)
          u[ie] && u[ie] !== b && u[ie].width === void 0 && o.columnOption(u[ie].index, "width", K[ie]);
      }
      if (o.endUpdate(), !p) {
        this.component.updateDimensions();
        var pe = this.component.getScrollable();
        if (pe && y) {
          var _e = mt(pe.$content()) - mt(pe.container()) - this._scrollRight;
          pe.scrollTo({
            left: _e
          });
        }
      }
    }
    return r;
  }
  _subscribeToCallback(e, i) {
    e.add(i), this._subscribesToCallbacks.push({
      callback: e,
      handler: i
    });
  }
  _unsubscribeFromCallbacks() {
    for (var e = 0; e < this._subscribesToCallbacks.length; e++) {
      var i = this._subscribesToCallbacks[e];
      i.callback.remove(i.handler);
    }
    this._subscribesToCallbacks = [];
  }
  _unsubscribes() {
    this._unsubscribeFromEvents(), this._unsubscribeFromCallbacks();
  }
  _init() {
    var e = () => {
      this._isResizing || this.pointsByColumns(null);
    }, i = (a) => {
      this._scrollLeft !== a.left && (this._scrollLeft = a.left, this.pointsByColumns(null));
    };
    this._columnsSeparatorView = this.getView("columnsSeparatorView"), this._columnHeadersView = this.getView("columnHeadersView"), this._trackerView = this.getView("trackerView"), this._rowsView = this.getView("rowsView"), this._columnsController = this.getController("columns"), this._tablePositionController = this.getController("tablePosition"), this._editorFactoryController = this.getController("editorFactory"), this._draggingHeaderView = this.component.getView("draggingHeaderView"), this._$parentContainer = this.component.$element(), this._subscribeToCallback(this._columnHeadersView.renderCompleted, e), this._subscribeToCallback(this._columnHeadersView.resizeCompleted, e), this._subscribeToCallback(this._columnsSeparatorView.renderCompleted, () => {
      this._unsubscribeFromEvents(), this._subscribeToEvents();
    }), this._subscribeToCallback(this._rowsView.renderCompleted, () => {
      this._rowsView.scrollChanged.remove(i), this._rowsView.scrollChanged.add(i);
    });
    var r = this._rowsView.getScrollbarWidth() !== 0, n = 0;
    this._subscribeToCallback(this._tablePositionController.positionChanged, (a) => {
      if (this._isResizing && !this._rowsView.isResizing) {
        var o = this._rowsView.getScrollbarWidth() !== 0;
        r !== o || n && n !== a.height ? (r = o, n = a.height, this.component.updateDimensions()) : this._rowsView.updateFreeSpaceRowHeight();
      }
      n = a.height;
    });
  }
  isResizing() {
    return this._isResizing;
  }
  pointsByColumns(e) {
    if (e !== void 0)
      this._pointsByColumns = e;
    else
      return this._pointsByColumns || this._generatePointsByColumns(), this._pointsByColumns;
  }
}, Cke = class extends Bi.ViewController {
  constructor(e) {
    super(e), this.positionChanged = ui();
  }
  init() {
    super.init(), this._columnsResizerController = this.getController("columnsResizer"), this._columnHeadersView = this.getView("columnHeadersView"), this._rowsView = this.getView("rowsView"), this._pagerView = this.getView("pagerView"), this._rowsView.resizeCompleted.add(() => {
      if (this.option("allowColumnResizing")) {
        var e = this._columnsResizerController._targetPoint;
        this.update(e ? e.y : null);
      }
    });
  }
  update(e) {
    var i = {}, r = this._columnHeadersView.element(), n = r && r.offset(), a = n && n.top || 0, o = R(e) ? Math.abs(e - a) : 0, u = this._columnHeadersView ? this._columnHeadersView.getHeight() : 0, c = this._rowsView.getScrollbarWidth(!0), p = this._rowsView ? this._rowsView.height() - c : 0, v = this.component.getView("draggingHeaderView");
    i.height = u;
    var _ = this._columnsResizerController.isResizing() || v.isDragging();
    _ && (i.height += p - o), e !== null && r && r.length && (i.top = r[0].offsetTop + o), this.positionChanged.fire(i);
  }
}, yke = class extends Bi.ViewController {
  init() {
    super.init(), this._columnsController = this.getController("columns"), this._tablePositionController = this.getController("tablePosition"), this._columnHeadersView = this.getView("columnHeadersView"), this._columnsSeparatorView = this.getView("columnsSeparatorView"), this._draggingHeaderView = this.getView("draggingHeaderView"), this._rowsView = this.getView("rowsView"), this._blockSeparatorView = this.getView("blockSeparatorView"), this._headerPanelView = this.getView("headerPanel"), this._columnChooserView = this.getView("columnChooserView");
    var e = () => {
      if (this._draggingHeaderView) {
        var i = [this._columnChooserView, this._columnHeadersView, this._headerPanelView];
        this._unsubscribeFromEvents(this._draggingHeaderView, i), this._subscribeToEvents(this._draggingHeaderView, i);
      }
    };
    this._columnHeadersView.renderCompleted.add(e), this._headerPanelView && this._headerPanelView.renderCompleted.add(e), this._columnChooserView && this._columnChooserView.renderCompleted.add(e);
  }
  dispose() {
    this._draggingHeaderView && this._unsubscribeFromEvents(this._draggingHeaderView, [this._columnChooserView, this._columnHeadersView, this._headerPanelView]);
  }
  _generatePointsByColumns(e) {
    var i = this;
    this.isCustomGroupColumnPosition = this.checkIsCustomGroupColumnPosition(e);
    var r = xe.getPointsByColumns(e.columnElements, (n) => i._pointCreated(n, e.columns, e.targetDraggingPanel.getName(), e.sourceColumn), e.isVerticalOrientation, e.startColumnIndex);
    return r;
  }
  checkIsCustomGroupColumnPosition(e) {
    for (var i = !0, r = 0; r < e.columns.length; r += 1) {
      var n = e.columns[r];
      if (n.command === "expand" && !i)
        return !0;
      n.command || (i = !1);
    }
    return !1;
  }
  _pointCreated(e, i, r, n) {
    var a, o = i[e.columnIndex], u = i[e.columnIndex - 1], c = (u == null ? void 0 : u.command) === "expand", p = (o == null ? void 0 : o.command) === "expand" && (u == null ? void 0 : u.command) !== "expand", v = n && !n.allowReordering, _ = !(o != null && o.allowReordering) && !(u != null && u.allowReordering);
    switch (r) {
      case "columnChooser":
        return !0;
      case "headers":
        if (v)
          return !0;
        if (!p)
          return c || _;
        if (this.isCustomGroupColumnPosition)
          return !1;
        for (; ((a = i[e.columnIndex]) === null || a === void 0 ? void 0 : a.command) === "expand"; )
          e.columnIndex += 1;
        return !1;
      default:
        return i.length === 0;
    }
  }
  _subscribeToEvents(e, i) {
    var r = this;
    N(i, (n, a) => {
      if (a)
        for (var o, u = a.getRowCount ? a.getRowCount() : 1, c = a.getName(), p = function(y, b) {
          if (b) {
            var I = E(b), A = o[y];
            A && a.allowDragging(A) && (I.addClass(r.addWidgetPrefix(YP)), k.on(I, ve(Rp, Ho), r.createAction((L) => {
              var B = L.event, $ = br(B);
              e.dragHeader({
                deltaX: $.x - E(B.currentTarget).offset().left,
                deltaY: $.y - E(B.currentTarget).offset().top,
                sourceColumn: A,
                index: A.index,
                columnIndex: y,
                columnElement: I,
                sourceLocation: c,
                draggingPanels: i,
                rowIndex: r._columnsController.getRowIndex(A.index, !0)
              });
            })), k.on(I, ve(Rh, Ho), {
              that: e
            }, r.createAction(e.moveHeader)), k.on(I, ve(Lp, Ho), {
              that: e
            }, r.createAction(e.dropHeader)));
          }
        }, v = 0; v < u; v++) {
          var _ = a.getColumnElements(v) || [];
          _.length && (o = a.getColumns(v) || [], N(_, p));
        }
    });
  }
  _unsubscribeFromEvents(e, i) {
    var r = this;
    N(i, (n, a) => {
      if (a) {
        var o = a.getColumnElements() || [];
        N(o, (u, c) => {
          var p = E(c);
          k.off(p, ve(Rp, Ho)), k.off(p, ve(Rh, Ho)), k.off(p, ve(Lp, Ho)), p.removeClass(r.addWidgetPrefix(YP));
        });
      }
    });
  }
  _getSeparator(e) {
    return e === "headers" ? this._columnsSeparatorView : this._blockSeparatorView;
  }
  hideSeparators(e) {
    var i = this._blockSeparatorView, r = this._columnsSeparatorView;
    this._animationColumnIndex = void 0, i && i.hide(), e !== "block" && r && r.hide();
  }
  allowDrop(e) {
    return this._columnsController.allowMoveColumn(e.sourceColumnIndex, e.targetColumnIndex, e.sourceLocation, e.targetLocation);
  }
  drag(e) {
    var {
      sourceIndex: i
    } = e, {
      sourceLocation: r
    } = e, {
      sourceColumnElement: n
    } = e, a = this._columnHeadersView, o = this._rowsView;
    n && (n.css({
      opacity: ak
    }), r === "headers" && (a && a.setRowsOpacity(i, ak), o && o.setRowsOpacity(i, ak)));
  }
  dock(e) {
    var i = this, r = ct(e.targetColumnIndex) ? e.targetColumnIndex.columnIndex : e.targetColumnIndex, {
      sourceLocation: n
    } = e, {
      targetLocation: a
    } = e, o = i._getSeparator(a), u = r >= 0;
    i._columnHeadersView.element().find(".".concat(n3)).toggleClass(i.addWidgetPrefix(i3), n !== "headers" && a === "headers" && !u), o && (i.allowDrop(e) && u ? a === "group" || a === "columnChooser" ? function() {
      i._animationColumnIndex !== r && (i.hideSeparators(), o.element()[e.isLast ? "insertAfter" : "insertBefore"](e.targetColumnElement), i._animationColumnIndex = r, o.show(a));
    }() : (i.hideSeparators("block"), i._tablePositionController.update(e.posY), o.moveByX(e.posX - o.width()), o.show()) : i.hideSeparators());
  }
  drop(e) {
    var {
      sourceColumnElement: i
    } = e;
    if (i && (i.css({
      opacity: ""
    }), this._columnHeadersView.setRowsOpacity(e.sourceIndex, ""), this._rowsView.setRowsOpacity(e.sourceIndex, ""), this._columnHeadersView.element().find(".".concat(n3)).removeClass(this.addWidgetPrefix(i3))), this.allowDrop(e)) {
      var r = this._getSeparator(e.targetLocation);
      r && r.hide(), this._columnsController.moveColumn(e.sourceColumnIndex, e.targetColumnIndex, e.sourceLocation, e.targetLocation);
    }
  }
};
var xke = (t) => class extends t {
  _needUpdateRowHeight(e) {
    var i = this.option("wordWrapEnabled"), r = this._columnsResizerController.isResizing();
    return super._needUpdateRowHeight.apply(this, arguments) || e > 0 && i && r;
  }
}, Ske = (t) => class extends t {
  renderFocusOverlay() {
    if (!this._columnsResizerController.isResizing())
      return super.renderFocusOverlay.apply(this, arguments);
  }
}, Zp = {
  views: {
    columnsSeparatorView: vke,
    blockSeparatorView: gke,
    draggingHeaderView: mke,
    trackerView: pke
  },
  controllers: {
    draggingHeader: yke,
    tablePosition: Cke,
    columnsResizer: _ke
  },
  extenders: {
    views: {
      rowsView: xke
    },
    controllers: {
      editorFactory: Ske
    }
  }
}, s1e = Zp.views.draggingHeaderView, l1e = Zp.controllers.draggingHeader, u1e = Zp.views.columnsSeparatorView, d1e = Zp.controllers.tablePosition, c1e = Zp.controllers.columnsResizer, h1e = Zp.views.trackerView;
et.registerModule("columnsResizingReordering", Zp);
var Eke = (t, e) => t.length === e.length && !Object.keys(t).some((i) => t[i] !== e[i]), bke = (t, e) => Mi(t, e, {
  maxDepth: 4
}), wke = (t, e, i, r) => {
  var n = t, a = e;
  return function() {
    for (var o = arguments.length, u = new Array(o), c = 0; c < o; c++)
      u[c] = arguments[c];
    var p = r(u, n);
    return p || (n = u, a = i(...n)), a;
  };
}, Tke = {
  compareType: "reference"
}, o3 = function(t) {
  var {
    compareType: e
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Tke, i = null;
  return function() {
    for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
      n[a] = arguments[a];
    if (!i) {
      var o = t(...n);
      return i = wke(n, o, t, e === "reference" ? Eke : bke), o;
    }
    return i(...n);
  };
}, qP = {
  ariaColIndex: "aria-colindex",
  dragCell: "dx-drag-cell"
}, sk = "rowsview";
var R9 = "dx-data-row", Ike = "dx-group-row", Dke = "dx-header-row", Ake = "edit-form-item", Oke = "dx-master-detail-row", L9 = "dx-freespace-row", Rke = "dx-virtual-row", s3 = "dx-master-detail-cell";
var Lke = "dx-dropdowneditor-overlay", Dw = "dx-command-expand", Mke = "dx-command-adaptive", M9 = "dx-command-select", k9 = "dx-command-edit", l3 = "[class^=dx-command]", Aw = "dx-cell-focus-disabled", kke = "dxDateBox", u3 = "dx-state-focused", Pke = "dx-widget", Fke = "dx-revert-button", d3 = "dx-focused", lk = "delete", sT = `
  input:not([type="hidden"]):not([disabled]),
  textarea:not([disabled]),
  a:not([disabled]),
  select:not([disabled]),
  button:not([disabled]),
  [tabindex]:not([disabled]),
  .dx-checkbox:not([disabled],.dx-state-readonly)
`, c3 = "".concat(sT, ", .dx-dropdowneditor-icon");
var h3 = "row", f3 = "cell", p3 = "columnHeadersView", Bke = ["shift", "control", "alt"], Vke = (t) => t.attr(qP.dragCell) !== void 0, Nke = (t, e) => t.filter("[".concat(qP.ariaColIndex, '="').concat(e + 1, '"]:not([').concat(qP.dragCell, "])")).first(), P9 = {
  isDragCell: Vke,
  getCellToFocus: Nke
}, Hke = "dx-datagrid-group-footer";
function ox(t) {
  return t && t.hasClass(Ike);
}
function $ke(t) {
  return t && t.hasClass(Hke);
}
function uk(t) {
  return t && t.hasClass(Oke);
}
function jy(t) {
  return t && t.hasClass(R9);
}
function zke(t) {
  return !t || t.hasClass(L9) || t.hasClass(Rke);
}
function v3(t, e) {
  return !t._isRowEditMode() && e && !e.hasClass(M9) && e.hasClass(FI);
}
function Vs(t) {
  return R(t) && t.length > 0;
}
function XP() {
  return Ye.current().deviceType !== "desktop";
}
function g3(t) {
  return !!t.parent(".".concat(Dke)).length;
}
function Wke(t, e) {
  var i = t.option("rtlEnabled");
  return i ? !(e.fixedPosition === "right" || R(e.command) && !R(e.fixedPosition)) : !(!R(e.fixedPosition) || e.fixedPosition === "left");
}
function Uke(t) {
  var e = t.getController("keyboardNavigation");
  return e._isVirtualScrolling() ? t.option("focusedRowIndex") === e.getRowIndex() : !1;
}
var Gke = (t) => class extends t {
  init() {
    var e;
    super.init(), this.rowsViewFocusOutHandlerContext = (e = this.rowsViewFocusOutHandlerContext) !== null && e !== void 0 ? e : this.rowsViewFocusOutHandler.bind(this);
  }
  subscribeToRowsViewFocusEvent() {
    var e;
    super.subscribeToRowsViewFocusEvent();
    var i = (e = this._rowsView) === null || e === void 0 ? void 0 : e.element();
    k.on(i, "focusout", this.rowsViewFocusOutHandlerContext);
  }
  unsubscribeFromRowsViewFocusEvent() {
    var e;
    super.unsubscribeFromRowsViewFocusEvent();
    var i = (e = this._rowsView) === null || e === void 0 ? void 0 : e.element();
    k.off(i, "focusout", this.rowsViewFocusOutHandlerContext);
  }
  rowsViewFocusHandler(e) {
    var i = E(e.target);
    this.translateFocusIfNeed(e, i), super.rowsViewFocusHandler(e);
  }
  rowsViewFocusOutHandler() {
    this.makeScrollableFocusableIfNeed();
  }
  translateFocusIfNeed(e, i) {
    var r = this.isScrollableNeedFocusable(), n = this._isFixedColumn(0);
    if (!(!r || !n)) {
      var a = this._rowsView.getCell({
        rowIndex: 0,
        columnIndex: 0
      }), o = !!a.attr("tabindex"), u = i.is(this._$firstNotFixedCell);
      o && u && (e.preventDefault(), this._focus(a));
    }
  }
  renderCompleted(e) {
    this._$firstNotFixedCell = this.getFirstNotFixedCell(), this.makeScrollableFocusableIfNeed(), super.renderCompleted(e);
  }
  _focus(e, i, r) {
    super._focus(e, i, r), this.makeScrollableFocusableIfNeed();
  }
  _tabKeyHandler(e, i) {
    var r, n = R(this._focusedCellPosition) && !uo(this._focusedCellPosition), a = !n || !e.shift && this._isLastValidCell(this._focusedCellPosition) || e.shift && this._isFirstValidCell(this._focusedCellPosition), o = this.isScrollableNeedFocusable();
    a && o && ((r = this._$firstNotFixedCell) === null || r === void 0 || r.removeAttr("tabIndex")), super._tabKeyHandler(e, i);
  }
  getFirstNotFixedCell() {
    var e = this._columnsController.getVisibleColumns(), i = e.findIndex((r) => {
      var {
        fixed: n
      } = r;
      return !n;
    });
    return i === -1 ? void 0 : this._rowsView._getCellElement(0, i);
  }
  isScrollableNeedFocusable() {
    var e, i, r = !!this._rowsView.getScrollable(), n = !!(!((e = this._rowsView._fixedTableElement) === null || e === void 0) && e.length), a = !!(!((i = this._rowsView.getCellElements(0)) === null || i === void 0) && i.length);
    return r && n && a;
  }
  makeScrollableFocusableIfNeed() {
    var e = this.isScrollableNeedFocusable();
    !e || !this._$firstNotFixedCell || this._applyTabIndexToElement(this._$firstNotFixedCell);
  }
};
class Kke extends Bi.ViewController {
  init() {
    var e, i;
    this._dataController = this.getController("data"), this._selectionController = this.getController("selection"), this._editingController = this.getController("editing"), this._headerPanel = this.getView("headerPanel"), this._rowsView = this.getView("rowsView"), this._columnsController = this.getController("columns"), this._editorFactory = this.getController("editorFactory"), this._focusController = this.getController("focus"), this._adaptiveColumnsController = this.getController("adaptiveColumns"), this._columnResizerController = this.getController("columnsResizer"), this._memoFireFocusedCellChanged = o3(this._memoFireFocusedCellChanged.bind(this), {
      compareType: "value"
    }), this._memoFireFocusedRowChanged = o3(this._memoFireFocusedRowChanged.bind(this), {
      compareType: "value"
    }), this.focusedHandlerWithContext = this.focusedHandlerWithContext || this.focusedHandler.bind(this), this.renderCompletedWithContext = this.renderCompletedWithContext || this.renderCompleted.bind(this), this.rowsViewFocusHandlerContext = this.rowsViewFocusHandlerContext || this.rowsViewFocusHandler.bind(this), this._updateFocusTimeout = null, this._fastEditingStarted = !1, this._focusedCellPosition = {}, this._canceledCellPosition = null, this.isKeyboardEnabled() ? (Zde(), (e = this._editorFactory) === null || e === void 0 || e.focused.add(this.focusedHandlerWithContext), this.createAction("onKeyDown")) : (rW(), (i = this._editorFactory) === null || i === void 0 || i.focused.remove(this.focusedHandlerWithContext)), this.initViewHandlers(), this.initDocumentHandlers();
  }
  dispose() {
    super.dispose(), this._resetFocusedView(), bh.off(this._keyDownListener), k.off(de.getDocument(), ve(Xt.down, "dxDataGridKeyboardNavigation"), this._documentClickHandler), clearTimeout(this._updateFocusTimeout), rW();
  }
  focusedHandler(e) {
    this.setupFocusedView(), this._isNeedScroll && e.is(":visible") && this._focusedView && this._focusedView.getScrollable() && (this._focusedView._scrollToElement(e), this._isNeedScroll = !1);
  }
  rowsViewFocusHandler(e) {
    var i, r = E(e.target), n = E(e.relatedTarget).closest(this._rowsView.element()).length, a = r.is("a");
    if (e.relatedTarget && a && !n && this._isEventInCurrentGrid(e)) {
      var o = this._getFocusedCell();
      o = Vs(o) ? o : this._rowsView.getCellElements(0).filter("[tabindex]").eq(0), r.closest(o).length || (e.preventDefault(), k.trigger(o, "focus"));
    }
    var u = r.is("td"), c = ((i = this.option("focusedRowIndex")) !== null && i !== void 0 ? i : -1) < 0;
    u && c && this._updateFocusedCellPosition(r);
  }
  subscribeToRowsViewFocusEvent() {
    var e, i = (e = this._rowsView) === null || e === void 0 ? void 0 : e.element();
    k.on(i, "focusin", this.rowsViewFocusHandlerContext);
  }
  unsubscribeFromRowsViewFocusEvent() {
    var e, i = (e = this._rowsView) === null || e === void 0 ? void 0 : e.element();
    k.off(i, "focusin", this.rowsViewFocusHandlerContext);
  }
  renderCompleted(e) {
    var i = this._rowsView.element(), r = !e || e.changeType === "refresh", n = this._focusedView && this._focusedView.name === this._rowsView.name, a = !1, o = e && (e.changeType === "append" || e.changeType === "prepend"), u = E(de.getRootNode(i.get && i.get(0))), c = u.find(":focus"), p = !c.length || c.closest(i).length;
    this.unsubscribeFromRowsViewFocusEvent(), this.subscribeToRowsViewFocusEvent(), this.initPointerEventHandler(), this.initKeyDownHandler(), this._setRowsViewAttributes(), n && p && (a = this._isNeedFocus ? !o : this._isHiddenFocus && r && !(e != null && e.virtualColumnsScrolling), a && this._updateFocus(!0));
  }
  initViewHandlers() {
    var e, i;
    this.unsubscribeFromRowsViewFocusEvent(), this.unsubscribeFromPointerEvent(), this.unsubscribeFromKeyDownEvent(), (i = (e = this._rowsView) === null || e === void 0 ? void 0 : e.renderCompleted) === null || i === void 0 || i.remove(this.renderCompletedWithContext), this.isKeyboardEnabled() && this._rowsView.renderCompleted.add(this.renderCompletedWithContext);
  }
  initDocumentHandlers() {
    var e = de.getDocument();
    this._documentClickHandler = this._documentClickHandler || this.createAction((i) => {
      var r = E(i.event.target), n = this._isEventInCurrentGrid(i.event) && r.closest(".".concat(this.addWidgetPrefix(sk))).length, a = r.closest(".".concat(Lke)).length, o = !!this._columnResizerController && this._columnResizerController.isResizing();
      if (!n && !a && !o) {
        var u = this._focusedView ? r.parents().filter(this._focusedView.element()).length > 0 : !1;
        !u && this._resetFocusedCell(!0), this._resetFocusedView();
      }
    }), k.off(e, ve(Xt.down, "dxDataGridKeyboardNavigation"), this._documentClickHandler), this.isKeyboardEnabled() && k.on(e, ve(Xt.down, "dxDataGridKeyboardNavigation"), this._documentClickHandler);
  }
  _setRowsViewAttributes() {
    var e = this._getRowsViewElement(), i = !this._dataController.getVisibleRows().length;
    i && this._applyTabIndexToElement(e);
  }
  unsubscribeFromPointerEvent() {
    var e = XP() ? di : Xt.down, i = this._getRowsViewElement();
    this._pointerEventAction && k.off(i, ve(e, "dxDataGridKeyboardNavigation"), this._pointerEventAction);
  }
  subscribeToPointerEvent() {
    var e = XP() ? di : Xt.down, i = this._getRowsViewElement(), r = ".".concat(vh, " > td, .").concat(vh);
    k.on(i, ve(e, "dxDataGridKeyboardNavigation"), r, this._pointerEventAction);
  }
  initPointerEventHandler() {
    this._pointerEventAction = this._pointerEventAction || this.createAction(this._pointerEventHandler), this.unsubscribeFromPointerEvent(), this.subscribeToPointerEvent();
  }
  unsubscribeFromKeyDownEvent() {
    bh.off(this._keyDownListener);
  }
  subscribeToKeyDownEvent() {
    var e = this._getRowsViewElement();
    this._keyDownListener = bh.on(e, null, (i) => this._keyDownHandler(i));
  }
  initKeyDownHandler() {
    this._keyDownListener && this.unsubscribeFromKeyDownEvent(), this.subscribeToKeyDownEvent();
  }
  optionChanged(e) {
    switch (e.name) {
      case "keyboardNavigation":
        e.fullName === "keyboardNavigation.enabled" && this.init(), e.handled = !0;
        break;
      case "useLegacyKeyboardNavigation":
        this.init(), e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
  isRowFocusType() {
    return this.focusType === h3;
  }
  isCellFocusType() {
    return this.focusType === f3;
  }
  setRowFocusType() {
    this.option("focusedRowEnabled") && (this.focusType = h3);
  }
  setCellFocusType() {
    this.focusType = f3;
  }
  _keyDownHandler(e) {
    var i, r = !0;
    this._isNeedFocus = !0, this._isNeedScroll = !0;
    var n = this._processOnKeyDown(e), a = (i = this._editingController) === null || i === void 0 ? void 0 : i.isEditing(), {
      originalEvent: o
    } = e;
    if (o.isDefaultPrevented()) {
      this._isNeedFocus = !1, this._isNeedScroll = !1;
      return;
    }
    if (!Bke.includes(e.keyName) && this._updateFocusedCellPositionByTarget(o.target), !n) {
      switch (e.keyName) {
        case "leftArrow":
        case "rightArrow":
          this._leftRightKeysHandler(e, a), n = !0;
          break;
        case "upArrow":
        case "downArrow":
          e.ctrl ? eB("rowsView", this, o) : this._upDownKeysHandler(e, a), n = !0;
          break;
        case "pageUp":
        case "pageDown":
          this._pageUpDownKeyHandler(e), n = !0;
          break;
        case "space":
          n = this._spaceKeyHandler(e, a);
          break;
        case "A":
          Cn(e.originalEvent) ? (this._ctrlAKeyHandler(e, a), n = !0) : n = this._beginFastEditing(e.originalEvent);
          break;
        case "tab":
          this._tabKeyHandler(e, a), n = !0;
          break;
        case "enter":
          this._enterKeyHandler(e, a), n = !0;
          break;
        case "escape":
          n = this._escapeKeyHandler(e, a);
          break;
        case "F":
          Cn(e.originalEvent) ? (this._ctrlFKeyHandler(e), n = !0) : n = this._beginFastEditing(e.originalEvent);
          break;
        case "F2":
          this._f2KeyHandler(), n = !0;
          break;
        case "del":
        case "backspace":
          this._isFastEditingAllowed() && !this._isFastEditingStarted() && (n = this._beginFastEditing(o, !0));
      }
      !n && !this._beginFastEditing(o) && (this._isNeedFocus = !1, this._isNeedScroll = !1, r = !1), r && o.stopPropagation();
    }
  }
  _processOnKeyDown(e) {
    var {
      originalEvent: i
    } = e, r = {
      handled: !1,
      event: i
    };
    return this.executeAction("onKeyDown", r), e.ctrl = i.ctrlKey, e.alt = i.altKey, e.shift = i.shiftKey, !!r.handled;
  }
  _closeEditCell() {
    setTimeout(() => {
      this._editingController.closeEditCell();
    });
  }
  _leftRightKeysHandler(e, i) {
    var r = this.getVisibleRowIndex(), n = e.originalEvent, a = this._focusedView && this._focusedView.getRow(r), o = this._getDirectionCodeByKey(e.keyName), u = this._isFastEditingStarted(), c = (!i || u) && jy(a);
    if (c) {
      this.setCellFocusType(), u && this._closeEditCell(), this._isVirtualColumnRender() && this._processVirtualHorizontalPosition(o);
      var p = this._getNextCell(o);
      Vs(p) && this._arrowKeysHandlerFocusCell(n, p, o), n && n.preventDefault();
    }
  }
  _upDownKeysHandler(e, i) {
    var r, n, a = this.getVisibleRowIndex(), o = this._focusedView && this._focusedView.getRow(a), u = e.originalEvent, c = e.keyName === "upArrow", p = this._dataController.dataSource(), v = (n = (r = this._editingController) === null || r === void 0 ? void 0 : r.isEditRowByIndex) === null || n === void 0 ? void 0 : n.call(r, a), _ = this._isFastEditingStarted(), y = (!v || !i || _) && o && !uk(o);
    if (y) {
      if (_ && this._closeEditCell(), !this._navigateNextCell(u, e.keyName) && this._isVirtualRowRender() && c && p && !p.isLoading()) {
        var b = jt(o), I = this._focusedCellPosition.rowIndex - 1;
        this._scrollBy(0, -b, I, u);
      }
      u && u.preventDefault();
    }
  }
  _pageUpDownKeyHandler(e) {
    var i = this._dataController.pageIndex(), r = this._dataController.pageCount(), n = this.option("paging.enabled"), a = e.keyName === "pageUp", o = a ? -1 : 1, u = this._rowsView.getScrollable();
    n && !this._isVirtualScrolling() ? (a ? i > 0 : i < r - 1) && !this._isVirtualScrolling() && (this._dataController.pageIndex(i + o), e.originalEvent.preventDefault()) : u && Pt(u.container()) < Pt(u.$content()) && (this._scrollBy(0, Pt(u.container()) * o), e.originalEvent.preventDefault());
  }
  _spaceKeyHandler(e, i) {
    var r = this.getVisibleRowIndex(), n = E(e.originalEvent && e.originalEvent.target);
    if (this.option("selection") && this.option("selection").mode !== "none" && !i) {
      var a = this._getElementType(n) === "row" && this.isRowFocusType() && jy(n), o = n.hasClass(M9);
      return o && this.option("selection.showCheckBoxesMode") === "onClick" && this._selectionController.startSelectionWithCheckboxes(), a || n.parent().hasClass(R9) || n.hasClass(this.addWidgetPrefix(sk)) ? (this._selectionController.changeItemSelection(r, {
        shift: e.shift,
        control: e.ctrl
      }), e.originalEvent.preventDefault(), !0) : !1;
    }
    return this._beginFastEditing(e.originalEvent);
  }
  _ctrlAKeyHandler(e, i) {
    !i && !e.alt && this.option("selection.mode") === "multiple" && this.option("selection.allowSelectAll") && (this._selectionController.selectAll(), e.originalEvent.preventDefault());
  }
  _tabKeyHandler(e, i) {
    var r = this.option("editing"), n = e.shift ? "previous" : "next", a = R(this._focusedCellPosition) && !uo(this._focusedCellPosition), o = !a || !e.shift && this._isLastValidCell(this._focusedCellPosition) || e.shift && this._isFirstValidCell(this._focusedCellPosition), u = e.originalEvent.target, c = this._focusedView && this._focusedView.element();
    if (!this._handleTabKeyOnMasterDetailCell(u, n)) {
      if (E(c).addClass(u3), r && u && !o)
        if (E(u).hasClass(this.addWidgetPrefix(sk)) && this._resetFocusedCell(), this._isVirtualColumnRender() && this._processVirtualHorizontalPosition(n), i) {
          if (!this._editingCellTabHandler(e, n))
            return;
        } else
          this._targetCellTabHandler(e, n) && (o = !0);
      o ? (this._editorFactory.loseFocus(), this._editingController.isEditing() && !this._isRowEditMode() && (this._resetFocusedCell(!0), this._resetFocusedView(), this._closeEditCell())) : e.originalEvent.preventDefault();
    }
  }
  _getMaxHorizontalOffset() {
    var e = this.component.getScrollable();
    return e ? e.scrollWidth() - mt(this._rowsView.element()) : 0;
  }
  _isColumnRendered(e) {
    var i = this._columnsController.getVisibleColumns(null, !0), r = this._columnsController.getVisibleColumns(), n = i[e], a = !1;
    return n && (a = r.indexOf(n) >= 0), a;
  }
  _isFixedColumn(e) {
    var i = this._columnsController.getVisibleColumns(null, !0), r = i[e];
    return !!r && !!r.fixed;
  }
  _isColumnVirtual(e) {
    var i = e - this._columnsController.getColumnIndexOffset(), r = this._columnsController.getVisibleColumns(), n = r[i];
    return !!n && n.command === "virtual";
  }
  _processVirtualHorizontalPosition(e) {
    var i = this.component.getScrollable(), r = this.getColumnIndex(), n, a = 0, o = !1;
    switch (e) {
      case "next":
      case "nextInRow":
        var u = this._getVisibleColumnCount();
        n = r + 1, a = this.option("rtlEnabled") ? this._getMaxHorizontalOffset() : 0, e === "next" ? o = u === n || this._isFixedColumn(r) && !this._isColumnRendered(n) : o = u > n && this._isFixedColumn(r) && !this._isColumnRendered(n);
        break;
      case "previous":
      case "previousInRow":
        if (n = r - 1, a = this.option("rtlEnabled") ? 0 : this._getMaxHorizontalOffset(), e === "previous") {
          var c = this._columnsController.getColumnIndexOffset(), p = n < 0 && c === 0;
          o = p || this._isFixedColumn(r) && !this._isColumnRendered(n);
        } else
          o = n >= 0 && this._isFixedColumn(r) && !this._isColumnRendered(n);
    }
    o ? i.scrollTo({
      left: a
    }) : R(n) && R(e) && this._isColumnVirtual(n) && (a = this._getHorizontalScrollPositionOffset(e), a !== 0 && i.scrollBy({
      left: a,
      top: 0
    }));
  }
  _getHorizontalScrollPositionOffset(e) {
    var i = 0, r = this._getCell(this._focusedCellPosition), n = r && oi(r);
    if (n > 0) {
      var a = this.option("rtlEnabled") ? -1 : 1;
      i = e === "nextInRow" || e === "next" ? n * a : n * a * -1;
    }
    return i;
  }
  _editingCellTabHandler(e, i) {
    var r = e.originalEvent.target, n = this._getCellElementFromTarget(r), a, o = e.originalEvent, u = this._getElementType(r);
    if (n.is(l3))
      return !this._targetCellTabHandler(e, i);
    this._updateFocusedCellPosition(n);
    var c = this._getNextCellByTabKey(o, i, u);
    if (n = c.$cell, !n || this._handleTabKeyOnMasterDetailCell(n, i))
      return !1;
    var p = this._getColumnByCellElement(n), v = n.parent(), _ = this._getRowIndex(v), y = this._dataController.items()[_], b = this._editingController;
    if (p && p.allowEditing) {
      var I = !y || y.rowType === "data";
      a = b.allowUpdating({
        row: y
      }) ? I : y && y.isNewRow;
    }
    return a || this._closeEditCell(), this._focusCell(n, !c.isHighlighted) && (!this._isRowEditMode() && a ? this._editFocusedCell() : this._focusInteractiveElement(n, e.shift)), !0;
  }
  _targetCellTabHandler(e, i) {
    var r = e.originalEvent, n = r.target, a = this._getElementType(n), o = this._getCellElementFromTarget(n), u = a === "cell" && this._getInteractiveElement(o, !e.shift), c = !1;
    if (!v3(this, o) && (u != null && u.length) && n !== u.get(0))
      c = !0;
    else {
      this._focusedCellPosition.rowIndex === void 0 && E(n).hasClass(vh) && this._updateFocusedCellPosition(o), a = this._getElementType(n), this.isRowFocusType() && (this.setCellFocusType(), a === "row" && jy(E(n)) && (n = this.getFirstValidCellInRow(E(n)), a = this._getElementType(n)));
      var p = this._getNextCellByTabKey(r, i, a);
      if (o = p.$cell, !o || (o = this._checkNewLineTransition(r, o), !o))
        return !1;
      this._focusCell(o, !p.isHighlighted), v3(this, o) || this._focusInteractiveElement(o, e.shift);
    }
    return c;
  }
  _getNextCellByTabKey(e, i, r) {
    var n = this._getNextCell(i, r), a = n && this._fireFocusedCellChanging(e, n, !0);
    return !a || a.cancel ? {} : (a.$newCellElement && (n = a.$newCellElement), {
      $cell: n,
      isHighlighted: a.isHighlighted
    });
  }
  _checkNewLineTransition(e, i) {
    var r = this.getVisibleRowIndex(), n = i.parent();
    if (r !== this._getRowIndex(n)) {
      var a = this._getCellPosition(i), o = this._fireFocusedRowChanging(e, n);
      if (o.cancel)
        return;
      o.rowIndexChanged && a && (this.setFocusedColumnIndex(a.columnIndex), i = this._getFocusedCell());
    }
    return i;
  }
  _enterKeyHandler(e, i) {
    var r, n = this.getVisibleRowIndex(), a = this._dataController.getKeyByRowIndex(n), o = (r = this._focusedView) === null || r === void 0 ? void 0 : r.getRow(n), u = this._getFocusedCell(), c = this.option("grouping.allowCollapsing") && ox(o), p = this.option("masterDetail.enabled") && (u == null ? void 0 : u.hasClass(Dw)), v = u == null ? void 0 : u.hasClass(Mke);
    if (c || p) {
      var _ = this._dataController.items()[n], y = (_ == null ? void 0 : _.data) && !_.data.isContinuation;
      R(a) && y && this._dataController.changeRowExpand(a);
    } else
      v ? (this._adaptiveColumnsController.toggleExpandAdaptiveDetailRow(a), this._updateFocusedCellPosition(u)) : u != null && u.hasClass(k9) || this._processEnterKeyForDataCell(e, i);
  }
  _processEnterKeyForDataCell(e, i) {
    var r = this._getEnterKeyDirection(e), n = this._allowEditingOnEnterKey();
    i || !n && r ? (this._handleEnterKeyEditingCell(e.originalEvent), r === "next" || r === "previous" ? this._targetCellTabHandler(e, r) : (r === "upArrow" || r === "downArrow") && this._navigateNextCell(e.originalEvent, r)) : n && this._startEditing(e);
  }
  _getEnterKeyDirection(e) {
    var i = this.option("keyboardNavigation.enterKeyDirection"), r = e.shift;
    if (i === "column")
      return r ? "upArrow" : "downArrow";
    if (i === "row")
      return r ? "previous" : "next";
  }
  _handleEnterKeyEditingCell(e) {
    var {
      target: i
    } = e, r = this._getCellElementFromTarget(i), n = this._isRowEditMode();
    this._updateFocusedCellPosition(r), n ? (this._focusEditFormCell(r), setTimeout(this._editingController.saveEditData.bind(this._editingController))) : (k.trigger(E(i), "change"), this._closeEditCell(), e.preventDefault());
  }
  _escapeKeyHandler(e, i) {
    var r = this._getCellElementFromTarget(e.originalEvent.target);
    return i ? (this._updateFocusedCellPosition(r), this._isRowEditMode() ? (this._focusEditFormCell(r), this._editingController.cancelEditData(), this._dataController.items().length === 0 && (this._resetFocusedCell(), this._editorFactory.loseFocus())) : this._editingController.getEditMode() === "cell" ? this._editingController.cancelEditData() : this._closeEditCell(), e.originalEvent.preventDefault(), !0) : !1;
  }
  _ctrlFKeyHandler(e) {
    if (this.option("searchPanel.visible")) {
      var i = this._headerPanel.getSearchTextEditor();
      i && (i.focus(), e.originalEvent.preventDefault());
    }
  }
  _f2KeyHandler() {
    var e = this._editingController.isEditing(), i = this.getVisibleRowIndex(), r = this._focusedView && this._focusedView.getRow(i);
    !e && jy(r) && this._startEditing();
  }
  _navigateNextCell(e, i) {
    var r = this._getNextCell(i), n = this._getDirectionCodeByKey(i), a = r && this._isCellValid(r), o = a ? this._arrowKeysHandlerFocusCell(e, r, n) : !1;
    return o;
  }
  _arrowKeysHandlerFocusCell(e, i, r) {
    var n = r === "prevRow" || r === "nextRow", a = this._fireFocusChangingEvents(e, i, n, !0);
    return i = a.$newCellElement, !a.cancel && this._isCellValid(i) ? (this._focus(i, !a.isHighlighted), !0) : !1;
  }
  _beginFastEditing(e, i) {
    if (!this._isFastEditingAllowed() || e.altKey || e.ctrlKey || this._editingController.isEditing())
      return !1;
    if (i)
      this._startEditing(e, lk);
    else {
      var {
        key: r
      } = e, n = e.keyCode || e.which, a = r || n && String.fromCharCode(n);
      a && (a.length === 1 || a === lk) && this._startEditing(e, a);
    }
    return !0;
  }
  _pointerEventHandler(e) {
    var i, r = e.event || e, n = E(r.currentTarget), a = (i = this._rowsView) === null || i === void 0 ? void 0 : i.element(), o = n.parent(), u = E(r.target).is(sT), c = !!E(r.target).closest(".".concat(Fke)).length, p = n.hasClass(Dw);
    this._isEventInCurrentGrid(r) && (!c && (this._isCellValid(n, !u) || p) ? (n = this._isInsideEditForm(n) ? E(r.target) : n, this._focusView(), E(a).removeClass(u3), o.hasClass(L9) ? (this._updateFocusedCellPosition(n), this._applyTabIndexToElement(this._focusedView.element()), this._focusedView.focus(!0)) : this._isMasterDetailCell(n) ? this._updateFocusedCellPosition(n) : this._clickTargetCellHandler(r, n)) : n.is("td") && this._resetFocusedCell());
  }
  _clickTargetCellHandler(e, i) {
    var r = this._getColumnByCellElement(i), n = this._isCellEditMode();
    this.setCellFocusType();
    var a = this._fireFocusChangingEvents(e, i, !0);
    if (i = a.$newCellElement, a.cancel)
      this.setRowFocusType(), this.setFocusedRowIndex(a.prevRowIndex), this._editingController.isEditing() && n && this._closeEditCell();
    else {
      if (a.resetFocusedRow) {
        this._focusController._resetFocusedRow();
        return;
      }
      if (a.rowIndexChanged && (i = this._getFocusedCell()), !a.isHighlighted && !n && this.setRowFocusType(), this._updateFocusedCellPosition(i), this._allowRowUpdating() && n && r && r.allowEditing)
        this._isNeedFocus = !1, this._isHiddenFocus = !1;
      else {
        i = this._getFocusedCell();
        var o = e && E(e.target).closest("".concat(c3, ", td")), u = o && o.not(i).is(c3), c = !!r && !r.command && i.hasClass(FI), p = !c && (!a.isHighlighted || u);
        this._focus(i, p, u);
      }
    }
  }
  _allowRowUpdating() {
    var e = this.getVisibleRowIndex(), i = this._dataController.items()[e];
    return this._editingController.allowUpdating({
      row: i
    }, "click");
  }
  focus(e) {
    var i, r = this.option("focusedRowEnabled"), n = this._isCellElement(E(e));
    e || (i = ".dx-datagrid-rowsview .dx-row[tabindex]", r || (i += ", .dx-datagrid-rowsview .dx-row > td[tabindex]"), e = this.component.$element().find(i).first()), e && this._focusElement(E(e), n);
  }
  getFocusedView() {
    return this._focusedView;
  }
  setupFocusedView() {
    this.isKeyboardEnabled() && !R(this._focusedView) && this._focusView();
  }
  _focusElement(e, i) {
    var r = E(this._getRowsViewElement()), n = e.closest(r), a = this.isRowFocusType(), o = {};
    !n.length || this._isCellElement(e) && !this._isCellValid(e) || (this._focusView(), this._isNeedFocus = !0, this._isNeedScroll = !0, (this._isCellElement(e) || ox(e)) && (this.setCellFocusType(), o = this._fireFocusChangingEvents(null, e, !0, i), e = o.$newCellElement, a && !o.isHighlighted && this.setRowFocusType()), o.cancel || (this._focus(e, !o.isHighlighted), this._focusInteractiveElement(e)));
  }
  _getFocusedViewByElement(e) {
    var i = this.getFocusedView(), r = i && E(i.element());
    return e && e.closest(r).length !== 0;
  }
  _focusView() {
    this._focusedView = this._rowsView;
  }
  _resetFocusedView() {
    this.setRowFocusType(), this._focusedView = null;
  }
  _focusInteractiveElement(e, i) {
    if (e) {
      var r = this._getInteractiveElement(e, i);
      xe.focusAndSelectElement(this, r);
    }
  }
  _focus(e, i, r) {
    var n = e && !e.hasClass(vh) ? e.closest(".".concat(vh)) : e;
    if (!(n && zke(n))) {
      var a = this._focusedView, o = a && a.element(), u;
      this._isHiddenFocus = i;
      var c = ox(n) || $ke(n) || this.isRowFocusType();
      c ? (u = n, a && this.setFocusedRowIndex(this._getRowIndex(n))) : this._isCellElement(e) && (u = e, this._updateFocusedCellPosition(e)), u && (o && o.find(".dx-row[tabindex], .dx-row > td[tabindex]").not(u).removeClass(Aw).removeClass(d3).removeAttr("tabindex"), k.one(u, "blur", (p) => {
        p.relatedTarget && u.removeClass(Aw).removeClass(d3);
      }), r || (this._applyTabIndexToElement(u), k.trigger(u, "focus")), i ? (u.addClass(Aw), c && e.addClass(Aw)) : this._editorFactory.focus(u));
    }
  }
  _updateFocus(e) {
    this._updateFocusTimeout = setTimeout(() => {
      if (this._needFocusEditingCell()) {
        this._editingController._focusEditingCell();
        return;
      }
      var i = this._getFocusedCell(), r = this._editingController.isEditing();
      if (!this._isMasterDetailCell(i) || this._isRowEditMode()) {
        if (this._hasSkipRow(i.parent())) {
          var n = this._focusedCellPosition && this._focusedCellPosition.rowIndex > 0 ? "upArrow" : "downArrow";
          i = this._getNextCell(n);
        }
        if (Vs(i))
          if (i.is("td") || i.hasClass(this.addWidgetPrefix(Ake))) {
            var a = i.is(l3), o = i.find(":focus"), u = Vs(o), c = this._getColumnByCellElement(i);
            if ((e || !a) && this._editorFactory.focus()) {
              if (a && u) {
                xe.focusAndSelectElement(this, o);
                return;
              }
              !u && this._focus(i);
            } else
              !u && (this._isNeedFocus || this._isHiddenFocus) && this._focus(i, this._isHiddenFocus);
            r && !(c != null && c.showEditorAlways) && this._focusInteractiveElement.bind(this)(i);
          } else
            k.trigger(i, "focus");
      }
    });
  }
  _getColumnByCellElement(e) {
    var i = this._rowsView.getCellIndex(e), r = i + this._columnsController.getColumnIndexOffset();
    return this._columnsController.getVisibleColumns(null, !0)[r];
  }
  _needFocusEditingCell() {
    var e = this._editingController.getEditMode() === km, i = this._editingController.getEditMode() === Fp, r = e && this._editingController.hasChanges(), n = i && this._editingController.isNewRowInEditMode(), a = this._getFocusedCell();
    return (a.children().length === 0 || a.find(qB).length > 0) && (r || n);
  }
  _getFocusedCell() {
    return E(this._getCell(this._focusedCellPosition));
  }
  _updateFocusedCellPositionByTarget(e) {
    var i, r = this._getElementType(e);
    if (r === "row" && R((i = this._focusedCellPosition) === null || i === void 0 ? void 0 : i.columnIndex)) {
      var n = E(e);
      this._focusedView && ox(n) && this.setFocusedRowIndex(this._getRowIndex(n));
    } else
      this._updateFocusedCellPosition(this._getCellElementFromTarget(e));
  }
  _updateFocusedCellPosition(e, i) {
    var r = this._getCellPosition(e, i);
    return r && (!e.length || r.rowIndex >= 0 && r.columnIndex >= 0) && this.setFocusedCellPosition(r.rowIndex, r.columnIndex), r;
  }
  _getFocusedColumnIndexOffset(e) {
    var i = 0, r = this._columnsController.getVisibleColumns()[e];
    return r && r.fixed ? i = this._getFixedColumnIndexOffset(r) : e >= 0 && (i = this._columnsController.getColumnIndexOffset()), i;
  }
  _getFixedColumnIndexOffset(e) {
    var i = Wke(this, e) ? this._getVisibleColumnCount() - this._columnsController.getVisibleColumns().length : 0;
    return i;
  }
  _getCellPosition(e, i) {
    var r, n = Vs(e) && e.closest("tr");
    if (Vs(n)) {
      var a = this._getRowIndex(n);
      return r = this._rowsView.getCellIndex(e, a), r += this._getFocusedColumnIndexOffset(r), i && (r = i === "previous" ? r - 1 : r + 1, r = this._applyColumnIndexBoundaries(r)), {
        rowIndex: a,
        columnIndex: r
      };
    }
  }
  _focusCell(e, i) {
    if (this._isCellValid(e))
      return this._focus(e, i), !0;
  }
  _focusEditFormCell(e) {
    e.hasClass(s3) && this._editorFactory.focus(e, !0);
  }
  _resetFocusedCell(e) {
    var i, r = this._getFocusedCell();
    Vs(r) && r.removeAttr("tabindex"), this._isNeedFocus = !1, this._isNeedScroll = !1, this._focusedCellPosition = {}, clearTimeout(this._updateFocusTimeout), (i = this._focusedView) === null || i === void 0 || i.renderFocusState({
      preventScroll: e
    });
  }
  restoreFocusableElement(e, i) {
    var r, n, a = R(e), o = this._rowsView.element(), {
      columnIndex: u
    } = this._focusedCellPosition, c = this._dataController.getRowIndexOffset();
    e = a ? e : this._rowsView.getTopVisibleItemIndex() + c, a ? (n = this._rowsView.getRow(e - c), r = this._fireFocusedRowChanging(i, n), !r.cancel && r.rowIndexChanged && (e = r.newRowIndex)) : (this._editorFactory.loseFocus(), this._applyTabIndexToElement(o), k.trigger(o, "focus")), (!a || !r.cancel) && this.setFocusedCellPosition(e, u), a && this._updateFocus();
  }
  _getNewPositionByCode(e, i, r) {
    var {
      columnIndex: n
    } = e, {
      rowIndex: a
    } = e, o;
    if (e.rowIndex === void 0 && r === "next")
      return {
        columnIndex: 0,
        rowIndex: 0
      };
    switch (r) {
      case "nextInRow":
      case "next":
        o = this._getVisibleColumnCount(), n < o - 1 && i !== "row" && this._hasValidCellAfterPosition({
          columnIndex: n,
          rowIndex: a
        }) ? n++ : !this._isLastRow(a) && r === "next" && (n = 0, a++);
        break;
      case "previousInRow":
      case "previous":
        n > 0 && i !== "row" && this._hasValidCellBeforePosition({
          columnIndex: n,
          rowIndex: a
        }) ? n-- : a > 0 && r === "previous" && (a--, o = this._getVisibleColumnCount(), n = o - 1);
        break;
      case "upArrow":
        a = a > 0 ? a - 1 : a;
        break;
      case "downArrow":
        a = this._isLastRow(a) ? a : a + 1;
    }
    return {
      columnIndex: n,
      rowIndex: a
    };
  }
  setFocusedCellPosition(e, i) {
    this.setFocusedRowIndex(e), this.setFocusedColumnIndex(i);
  }
  setFocusedRowIndex(e) {
    this._focusedCellPosition || (this._focusedCellPosition = {}), this._focusedCellPosition.rowIndex = e;
  }
  setFocusedColumnIndex(e) {
    this._focusedCellPosition || (this._focusedCellPosition = {}), this._focusedCellPosition.columnIndex = e;
  }
  getRowIndex() {
    return this._focusedCellPosition ? this._focusedCellPosition.rowIndex : -1;
  }
  getColumnIndex() {
    return this._focusedCellPosition ? this._focusedCellPosition.columnIndex : -1;
  }
  getVisibleRowIndex() {
    var e, i = (e = this._focusedCellPosition) === null || e === void 0 ? void 0 : e.rowIndex;
    return !R(i) || i < 0 ? -1 : i - this._dataController.getRowIndexOffset();
  }
  getVisibleColumnIndex() {
    var e, i = (e = this._focusedCellPosition) === null || e === void 0 ? void 0 : e.columnIndex;
    return R(i) ? i - this._columnsController.getColumnIndexOffset() : -1;
  }
  _applyColumnIndexBoundaries(e) {
    var i = this._getVisibleColumnCount();
    return e < 0 ? e = 0 : e >= i && (e = i - 1), e;
  }
  _isCellByPositionValid(e) {
    var i = E(this._getCell(e));
    return this._isCellValid(i);
  }
  _isLastRow(e) {
    var i = this._dataController;
    if (this._isVirtualRowRender())
      return e >= i.getMaxRowIndex();
    var r = Math.max(...i.items().map((n, a) => n.visible !== !1 ? a : -1));
    return e === r;
  }
  _isFirstValidCell(e) {
    var i = !1;
    return e.rowIndex === 0 && e.columnIndex >= 0 && (i = i || !this._hasValidCellBeforePosition(e)), i;
  }
  _hasValidCellBeforePosition(e) {
    for (var {
      columnIndex: i
    } = e, r = !1; i > 0 && !r; ) {
      var n = {
        columnIndex: --i,
        rowIndex: e.rowIndex
      };
      r = this._isCellByPositionValid(n);
    }
    return r;
  }
  _hasValidCellAfterPosition(e) {
    for (var {
      columnIndex: i
    } = e, r = !1, n = this._getVisibleColumnCount(); i < n - 1 && !r; ) {
      var a = {
        columnIndex: ++i,
        rowIndex: e.rowIndex
      };
      r = this._isCellByPositionValid(a);
    }
    return r;
  }
  _isLastValidCell(e) {
    var i = e.columnIndex >= 0 ? e.columnIndex + 1 : 0, {
      rowIndex: r
    } = e, n = {
      columnIndex: i,
      rowIndex: r
    }, a = this._dataController.getVisibleRows(), o = a && a[r], u = this._isLastRow(r);
    if (!u)
      return !1;
    var c = (o == null ? void 0 : o.rowType) === "group" || (o == null ? void 0 : o.rowType) === "groupFooter";
    return c && e.columnIndex > 0 || e.columnIndex === this._getVisibleColumnCount() - 1 ? !0 : this._isCellByPositionValid(n) ? !1 : this._isLastValidCell(n);
  }
  _isCellValid(e, i) {
    if (Vs(e)) {
      var r = e.parent(), n = this._rowsView.getCellIndex(e) + this._columnsController.getColumnIndexOffset(), a = this._getColumnByCellElement(e), o = this._getVisibleColumnCount(), u = this._editingController, c = uk(r), p = a && a.showWhenGrouped, v = a && !e.hasClass(Dw) && jy(r), _ = P9.isDragCell(e);
      if (_)
        return !1;
      if (this._isMasterDetailCell(e))
        return !0;
      if (o > n && (!c && a && (!R(a.groupIndex) || p && v) || parseInt(e.attr("colspan"), 10) > 1)) {
        var y = this._dataController.items(), b = this._rowsView.getRowIndex(r), I = y[b], A = u && this._isCellEditMode() && u.isEditing(), L = u && u.isEditRow(b), B = L || A;
        return a.command ? this._isLegacyNavigation() ? !B && a.command === "expand" : A ? !1 : L ? a.command !== "select" : !B : A && I && I.rowType !== "data" ? !1 : !B || a.allowEditing || i;
      }
    }
  }
  getFirstValidCellInRow(e, i) {
    var r = e.find("> td"), n, a;
    i = i || 0;
    for (var o = i; o < r.length; ++o)
      if (n = r.eq(o), this._isCellValid(n)) {
        a = n;
        break;
      }
    return a;
  }
  _getNextCell(e, i, r) {
    var n = r || this._focusedCellPosition, a = this.isRowFocusType(), o = a || ["next", "previous"].includes(e), u, c;
    if (this._focusedView && n) {
      var p = this._getNewPositionByCode(n, i, e);
      u = E(this._getCell(p));
      var v = e === "previous" ? this._isFirstValidCell(p) : this._isLastValidCell(p);
      if (Vs(u) && !this._isCellValid(u) && this._isCellInRow(p, o) && !v && (a ? u = this.getFirstValidCellInRow(u.parent(), p.columnIndex) : u = this._getNextCell(e, "cell", p)), c = Vs(u) && u.parent(), this._hasSkipRow(c)) {
        var _ = this._getRowIndex(c);
        if (!this._isLastRow(_))
          u = this._getNextCell(e, "row", {
            columnIndex: n.columnIndex,
            rowIndex: _
          });
        else
          return null;
      }
      return Vs(u) ? u : null;
    }
    return null;
  }
  _startEditing(e, i) {
    var r = this._focusedCellPosition, n = this.getVisibleRowIndex(), a = this.getVisibleColumnIndex(), o = this._dataController.items()[n], u = this._columnsController.getVisibleColumns()[a];
    this._isAllowEditing(o, u) && (this._isRowEditMode() ? this._editingController.editRow(n) : r && this._startEditCell(e, i));
  }
  _isAllowEditing(e, i) {
    return this._editingController.allowUpdating({
      row: e
    }) && i && i.allowEditing;
  }
  _editFocusedCell() {
    var e = this.getVisibleRowIndex(), i = this.getVisibleColumnIndex();
    return this._editingController.editCell(e, i);
  }
  _startEditCell(e, i) {
    this._fastEditingStarted = R(i);
    var r = this._editFocusedCell(), n = JT(r), a = this._isFastEditingStarted();
    if (!(!a || !n && !r)) {
      var o = n && i === lk ? "" : i, u = n ? r : q().resolve(), c = this._rowsView.waitAsyncTemplates(!0);
      $e(u, c).done(() => {
        this._editingCellHandler(e, o);
      });
    }
  }
  _editingCellHandler(e, i) {
    var r, n, a = this._getFocusedCell().find(sT).eq(0), o = a.get(0);
    if (o) {
      var u = Ch(e, {
        type: "keydown",
        target: o
      }), c = Ch(e, {
        type: "keypress",
        target: o
      }), p = Ch(e, {
        type: "input",
        target: o
      });
      if (p.originalEvent && (p.originalEvent = Ch(p.originalEvent, {
        data: i
      })), (n = (r = o).select) === null || n === void 0 || n.call(r), k.trigger(a, u), !u.isDefaultPrevented() && (k.trigger(a, c), !c.isDefaultPrevented())) {
        var v = $i.mozilla ? 25 : 0;
        setTimeout(() => {
          var _ = this._getKeyPressInputValue(a, i);
          a.val(_);
          var y = a.closest(".".concat(Pke));
          k.off(y, "focusout"), k.one(y, "focusout", () => {
            k.trigger(a, "change");
          }), k.trigger(a, p);
        }, v);
      }
    }
  }
  _getKeyPressInputValue(e, i) {
    var r = e.val();
    return i === "-" && r === "-0" ? "-0" : i;
  }
  _fireFocusChangingEvents(e, i, r, n) {
    var a, o = {}, u = (a = this._getCellPosition(i)) !== null && a !== void 0 ? a : {};
    return this.isCellFocusType() && (o = this._fireFocusedCellChanging(e, i, n), o.cancel || (u.columnIndex = o.newColumnIndex, u.rowIndex = o.newRowIndex, n = o.isHighlighted, i = E(this._getCell(u)))), !o.cancel && r && i && (o = this._fireFocusedRowChanging(e, i.parent()), o.cancel || (u.rowIndex = o.newRowIndex, o.isHighlighted = n)), o.$newCellElement = E(this._getCell(u)), o.$newCellElement.length || (o.$newCellElement = i), o;
  }
  _fireFocusedCellChanging(e, i, r) {
    var n = this.option("focusedColumnIndex"), a = this.option("focusedRowIndex"), o = this._getCellPosition(i), u = o ? o.columnIndex : -1, c = o ? o.rowIndex : -1, p = this._dataController.getVisibleRows(), v = this._columnsController.getVisibleColumns(), _ = {
      cellElement: i,
      prevColumnIndex: n,
      prevRowIndex: a,
      newColumnIndex: u,
      newRowIndex: c,
      rows: p,
      columns: v,
      event: e,
      isHighlighted: r || !1,
      cancel: !1
    };
    return this._canceledCellPosition = null, this.executeAction("onFocusedCellChanging", _), (_.newColumnIndex !== u || _.newRowIndex !== c) && (_.$newCellElement = E(this._getCell({
      columnIndex: _.newColumnIndex,
      rowIndex: _.newRowIndex
    }))), _.cancel && (this._canceledCellPosition = {
      rowIndex: c,
      columnIndex: u
    }), _;
  }
  _fireFocusedCellChanged(e) {
    var i = this._rowsView.getCellIndex(e), r = e == null ? void 0 : e.parent().data("options"), n = r == null ? void 0 : r.key;
    this._memoFireFocusedCellChanged(n, i);
  }
  _memoFireFocusedCellChanged(e, i) {
    var r = this._getFocusedCell(), n = this._getRowIndex(r == null ? void 0 : r.parent()), a = Math.min(n - this._dataController.getRowIndexOffset(), this._dataController.items().length - 1), o = this._editingController.isEditCell(a, i);
    if (!o) {
      var u = this._dataController.items()[a], c = this._columnsController.getVisibleColumns()[i];
      this.executeAction("onFocusedCellChanged", {
        cellElement: r ? ot(r) : void 0,
        columnIndex: i,
        rowIndex: n,
        row: u,
        column: c
      });
    }
  }
  _fireFocusedRowChanging(e, i) {
    var r = this._getRowIndex(i), n = this.option("focusedRowIndex"), a = this._dataController.loadingOperationTypes(), o = {
      rowElement: i,
      prevRowIndex: n,
      newRowIndex: r,
      event: e,
      rows: this._dataController.getVisibleRows(),
      cancel: !1
    }, u = a.sorting || a.grouping || a.filtering || a.paging;
    return !this._dataController || this._dataController.isLoading() && u ? (o.cancel = !0, o) : (this.option("focusedRowEnabled") && (this.executeAction("onFocusedRowChanging", o), !o.cancel && o.newRowIndex !== r && (o.resetFocusedRow = o.newRowIndex < 0, o.resetFocusedRow || this.setFocusedRowIndex(o.newRowIndex), o.rowIndexChanged = !0)), o);
  }
  _fireFocusedRowChanged() {
    var e, i = this.option("focusedRowEnabled"), r = this.option("focusedRowKey"), n = (e = this._focusController) === null || e === void 0 ? void 0 : e.getFocusedRowIndexByKey(r);
    !i || R(r) && n < 0 || this._memoFireFocusedRowChanged(r, n);
  }
  _memoFireFocusedRowChanged(e, i) {
    var r = i - this._dataController.getRowIndexOffset();
    this.executeAction("onFocusedRowChanged", {
      rowElement: i < 0 ? void 0 : this._rowsView.getRowElement(r),
      rowIndex: i,
      row: i < 0 ? void 0 : this._dataController.getVisibleRows()[r]
    });
  }
  _isEventInCurrentGrid(e) {
    return xe.isElementInCurrentGrid(this, E(e.target));
  }
  _isRowEditMode() {
    var e = this._editingController.getEditMode();
    return e === Xd || e === Km;
  }
  _isCellEditMode() {
    var e = this._editingController.getEditMode();
    return e === km || e === Fp;
  }
  _isFastEditingAllowed() {
    return this._isCellEditMode() && this.option("keyboardNavigation.editOnKeyPress");
  }
  _getInteractiveElement(e, i) {
    var r = e.find(sT).filter(":visible");
    return i ? r.last() : r.first();
  }
  _applyTabIndexToElement(e) {
    var i, r = (i = this.option("tabIndex")) !== null && i !== void 0 ? i : 0;
    e.attr("tabindex", r);
  }
  _getCell(e) {
    if (this._focusedView && e) {
      var i = this._dataController.getRowIndexOffset(), r = this._columnsController.getVisibleColumns(null, !0)[e.columnIndex], n = r && r.fixed ? this._getFixedColumnIndexOffset(r) : this._columnsController.getColumnIndexOffset(), a = e.rowIndex >= 0 ? e.rowIndex - i : -1, o = e.columnIndex >= 0 ? e.columnIndex - n : -1;
      return this._focusedView.getCell({
        rowIndex: a,
        columnIndex: o
      });
    }
  }
  _getRowIndex(e) {
    var i = this._rowsView.getRowIndex(e);
    return i >= 0 && (i += this._dataController.getRowIndexOffset()), i;
  }
  _hasSkipRow(e) {
    var i = e && e.get(0);
    return i && (i.style.display === "none" || uk(e) && !e.hasClass(this.addWidgetPrefix(KT)));
  }
  _allowEditingOnEnterKey() {
    return this.option("keyboardNavigation.enterKeyAction") === "startEdit";
  }
  _isLegacyNavigation() {
    return this.option("useLegacyKeyboardNavigation");
  }
  _getDirectionCodeByKey(e) {
    var i;
    switch (e) {
      case "upArrow":
        i = "prevRow";
        break;
      case "downArrow":
        i = "nextRow";
        break;
      case "leftArrow":
        i = this.option("rtlEnabled") ? "nextInRow" : "previousInRow";
        break;
      case "rightArrow":
        i = this.option("rtlEnabled") ? "previousInRow" : "nextInRow";
    }
    return i;
  }
  _isVirtualScrolling() {
    var e = this.option("scrolling.mode");
    return e === "virtual" || e === "infinite";
  }
  _isVirtualRowRender() {
    return this._isVirtualScrolling() || xe.isVirtualRowRendering(this);
  }
  _isVirtualColumnRender() {
    return this.option("scrolling.columnRenderingMode") === "virtual";
  }
  _scrollBy(e, i, r, n) {
    var a = this, o = this._rowsView.getScrollable();
    return a._focusedCellPosition && o.on("scroll", function u() {
      o.off("scroll", u), setTimeout(a.restoreFocusableElement.bind(a, r, n));
    }), o.scrollBy({
      left: e,
      top: i
    });
  }
  _isInsideEditForm(e) {
    var i = E(e).closest(".".concat(this.addWidgetPrefix(KT)));
    return i.length && this.elementIsInsideGrid(i);
  }
  _isMasterDetailCell(e) {
    var i = E(e).closest(".".concat(s3));
    return i.length && this.elementIsInsideGrid(i);
  }
  _processNextCellInMasterDetail(e, i) {
    !this._isInsideEditForm(e) && e && this._applyTabIndexToElement(e);
  }
  _handleTabKeyOnMasterDetailCell(e, i) {
    if (this._isMasterDetailCell(e)) {
      this._updateFocusedCellPosition(E(e), i);
      var r = this._getNextCell(i, "row");
      return this._processNextCellInMasterDetail(r, E(e)), !0;
    }
    return !1;
  }
  _getElementType(e) {
    return E(e).is("tr") ? "row" : "cell";
  }
  _isFastEditingStarted() {
    return this._isFastEditingAllowed() && this._fastEditingStarted;
  }
  _getVisibleColumnCount() {
    return this._columnsController.getVisibleColumns(null, !0).length;
  }
  _isCellInRow(e, i) {
    var {
      columnIndex: r
    } = e, n = this._getVisibleColumnCount();
    return i ? r >= 0 && r <= n - 1 : r > 0 && r < n - 1;
  }
  _isCellElement(e) {
    return e.length && e[0].tagName === "TD";
  }
  _getCellElementFromTarget(e) {
    var i = this._getElementType(e), r = E(e), n;
    return i === "cell" ? n = r.closest(".".concat(vh, " > td")) : n = r.children().not(".".concat(Dw)).first(), n;
  }
  _getRowsViewElement() {
    var e;
    return (e = this._rowsView) === null || e === void 0 ? void 0 : e.element();
  }
  isKeyboardEnabled() {
    return this.option("keyboardNavigation.enabled");
  }
  _processCanceledEditCellPosition(e, i) {
    if (this._canceledCellPosition) {
      var r = this._canceledCellPosition.rowIndex === e && this._canceledCellPosition.columnIndex === i;
      return this._canceledCellPosition = null, r;
    }
  }
  updateFocusedRowIndex() {
    var e = this._dataController, i = this.getVisibleRowIndex(), r = e.items(), n = r.length ? r.length - 1 : -1, a = e.getRowIndexOffset();
    n >= 0 && i > n && this.setFocusedRowIndex(n + a);
  }
}
var jke = (t) => class extends t {
  _rowClick(e) {
    var i = this._editingController.getEditRowIndex(), r = this._keyboardNavigationController.isKeyboardEnabled();
    i === e.rowIndex && this._keyboardNavigationController.setCellFocusType();
    var n = (XP() || !r) && this.option("focusedRowEnabled");
    n && this._triggerPointerDownEventHandler(e, !r), super._rowClick.apply(this, arguments);
  }
  _triggerPointerDownEventHandler(e, i) {
    var {
      originalEvent: r
    } = e.event;
    if (r) {
      var n = E(r.target), a = this.getCellIndex(n), o = this._columnsController.getVisibleColumns()[a], u = this._dataController.items()[e.rowIndex];
      if (this._keyboardNavigationController._isAllowEditing(u, o) || i) {
        var c = Ch(r, {
          currentTarget: r.target
        });
        this._keyboardNavigationController._pointerEventHandler(c);
      }
    }
  }
  renderFocusState(e) {
    var {
      preventScroll: i,
      pageSizeChanged: r
    } = e ?? {}, n = this.element();
    n && !Ah(n) && n.attr("tabindex", null), r && this._keyboardNavigationController.updateFocusedRowIndex();
    var a = this._keyboardNavigationController.getVisibleRowIndex();
    (!R(a) || a < 0) && (a = 0);
    var o = this.getCellElements(a);
    this._keyboardNavigationController.isKeyboardEnabled() && (o != null && o.length) && this.updateFocusElementTabIndex(o, i);
  }
  updateFocusElementTabIndex(e, i) {
    var r = e.eq(0).parent();
    if (ox(r))
      this._keyboardNavigationController._applyTabIndexToElement(r);
    else {
      var n = this._keyboardNavigationController.getColumnIndex();
      (!R(n) || n < 0) && (n = 0), this._updateFocusedCellTabIndex(e, n);
    }
  }
  _updateFocusedCellTabIndex(e, i) {
    var r = this._keyboardNavigationController, n = e ? e.length : -1, a = function(c) {
      var p = r._isMasterDetailCell(c), v = r._isCellValid(c);
      if (!p && v && r._isCellElement(c))
        return r._applyTabIndexToElement(c), r.setCellFocusType(), !0;
    }, o = P9.getCellToFocus(e, i);
    if (o.length)
      a(o);
    else {
      n <= i && (i = n - 1);
      for (var u = i; u < n && !a(E(e[u])); ++u)
        ;
    }
  }
  renderDelayedTemplates(e) {
    super.renderDelayedTemplates.apply(this, arguments), this.waitAsyncTemplates().done(() => {
      this._renderFocusByChange(e);
    });
  }
  _renderFocusByChange(e) {
    var i, {
      operationTypes: r,
      repaintChangesOnly: n
    } = e ?? {}, {
      fullReload: a,
      pageSize: o
    } = r ?? {}, u = !!(!((i = e == null ? void 0 : e.changeTypes) === null || i === void 0) && i.find((p) => p === "insert" || p === "remove"));
    if (!e || !n || a || o || u) {
      var c = Uke(this);
      this.renderFocusState({
        preventScroll: c,
        pageSizeChanged: o
      });
    }
  }
  _renderCore(e) {
    var i = super._renderCore.apply(this, arguments);
    return this._renderFocusByChange(e), i;
  }
  _editCellPrepared(e) {
    var i, r = this._getEditorInstance(e), n = (i = this._keyboardNavigationController) === null || i === void 0 ? void 0 : i._isFastEditingStarted();
    r && n && this._handleEditingNavigationMode(r), super._editCellPrepared.apply(this, arguments);
  }
  _handleEditingNavigationMode(e) {
    ["downArrow", "upArrow"].forEach((r) => {
      var n = e._supportedKeys()[r];
      e.registerKeyHandler(r, (a) => {
        var o = e._input().attr("aria-expanded") === "true";
        if (o)
          return n && n.call(e, a);
      });
    }), e.registerKeyHandler("leftArrow", ee), e.registerKeyHandler("rightArrow", ee);
    var i = e.NAME === kke && e.option("useMaskBehavior");
    i && e.registerKeyHandler("enter", ee);
  }
  _getEditorInstance(e) {
    var i = e.find(".dx-texteditor").eq(0);
    return xe.getWidgetInstance(i);
  }
}, Yke = (t) => class extends t {
  editCell(e, i) {
    if (this._keyboardNavigationController._processCanceledEditCellPosition(e, i))
      return !1;
    var r = super.editCell(e, i);
    return r && this._keyboardNavigationController.setupFocusedView(), r;
  }
  editRow(e) {
    var i = this._keyboardNavigationController.getVisibleColumnIndex(), r = this._columnsController.getVisibleColumns()[i];
    (r && r.type || this.option("editing.mode") === Km) && this._keyboardNavigationController._resetFocusedCell(), super.editRow(e);
  }
  addRow(e) {
    return this._keyboardNavigationController.setupFocusedView(), this._keyboardNavigationController.setCellFocusType(), super.addRow.apply(this, arguments);
  }
  getFocusedCellInRow(e) {
    var i = super.getFocusedCellInRow(e), r = this._dataController.getRowIndexOffset(), n = this._keyboardNavigationController._focusedCellPosition.rowIndex - r;
    if (this._keyboardNavigationController.isKeyboardEnabled() && n === e) {
      var a = this._keyboardNavigationController._getFocusedCell();
      Vs(a) && !a.hasClass(k9) && (i = a);
    }
    return i;
  }
  _processCanceledEditingCell() {
    this.closeEditCell().done(() => {
      this._keyboardNavigationController._updateFocus();
    });
  }
  closeEditCell() {
    var e = this._keyboardNavigationController;
    e._fastEditingStarted = !1;
    var i = super.closeEditCell.apply(this, arguments);
    return e._updateFocus(), i;
  }
  _delayedInputFocus() {
    this._keyboardNavigationController._isNeedScroll = !0, super._delayedInputFocus.apply(this, arguments);
  }
  _isEditingStart() {
    var e = super._isEditingStart.apply(this, arguments);
    if (e && !this._keyboardNavigationController._isNeedFocus) {
      var i = this._keyboardNavigationController._getFocusedCell();
      this._keyboardNavigationController._focus(i, !0);
    }
    return e;
  }
}, qke = (t) => class extends t {
  _correctRowIndices(e) {
    var i = this._keyboardNavigationController._focusedCellPosition;
    if (super._correctRowIndices.apply(this, arguments), i && i.rowIndex >= 0) {
      var r = e(i.rowIndex);
      r && (i.rowIndex += r, this._editorFactoryController.refocus());
    }
  }
  getMaxRowIndex() {
    var e = this.items().length - 1, i = this.virtualItemsCount();
    if (i) {
      var r = this.getRowIndexOffset();
      e += r + i.end;
    }
    return e;
  }
}, Xke = (t) => class extends t {
  _showHiddenCellsInView(e) {
    var {
      viewName: i,
      $cells: r,
      isCommandColumn: n
    } = e;
    super._showHiddenCellsInView.apply(this, arguments), i === p3 && !n && r.each((a, o) => {
      var u = E(o);
      g3(u) && u.attr("tabindex", 0);
    });
  }
  _hideVisibleCellInView(e) {
    var {
      viewName: i,
      $cell: r,
      isCommandColumn: n
    } = e;
    super._hideVisibleCellInView.apply(this, arguments), i === p3 && !n && g3(r) && r.removeAttr("tabindex");
  }
}, Qke = {
  defaultOptions: () => ({
    useLegacyKeyboardNavigation: !1,
    keyboardNavigation: {
      enabled: !0,
      enterKeyAction: "startEdit",
      enterKeyDirection: "none",
      editOnKeyPress: !1
    }
  }),
  controllers: {
    keyboardNavigation: Kke
  },
  extenders: {
    views: {
      rowsView: jke
    },
    controllers: {
      editing: Yke,
      data: qke,
      adaptiveColumns: Xke,
      keyboardNavigation: Gke
    }
  }
};
et.registerModule("keyboardNavigation", Qke);
function QP(t, e, i, r) {
  var n = 0;
  if (t < e)
    for (; n < i.items.length; n++)
      QP(t + 1, e, i.items[n], r);
  t === e && r(i);
}
function Ow(t, e) {
  var i;
  if ("map" in t)
    return t.map(e);
  var r = new Array(t.length);
  for (i in t)
    r[i] = e(t[i], i);
  return r;
}
function Zke(t) {
  return t !== t || t === "" || t === null || t === void 0;
}
function Jke(t) {
  return t === iB.count;
}
function m3(t) {
  var e = Ii(t.selector), i = "skipEmptyValues" in t ? t.skipEmptyValues : !0, {
    aggregator: r
  } = t;
  if (typeof r == "string" && (r = iB[r], !r))
    throw Zr.Error("E4001", t.aggregator);
  return {
    selector: e,
    aggregator: r,
    skipEmptyValues: i
  };
}
class ePe {
  constructor(e) {
    this._data = e.data, this._groupLevel = e.groupLevel || 0, this._totalAggregates = Ow(e.totalAggregates || [], m3), this._groupAggregates = Ow(e.groupAggregates || [], m3), this._totals = [];
  }
  calculate() {
    this._totalAggregates.length && this._calculateTotals(0, {
      items: this._data
    }), this._groupAggregates.length && this._groupLevel > 0 && this._calculateGroups({
      items: this._data
    });
  }
  totalAggregates() {
    return this._totals;
  }
  _aggregate(e, i, r) {
    for (var n = i.items ? i.items.length : 0, a = 0; a < e.length; a++) {
      if (Jke(e[a].aggregator)) {
        r[a] = (r[a] || 0) + n;
        continue;
      }
      for (var o = 0; o < n; o++)
        this._accumulate(a, e[a], r, i.items[o]);
    }
  }
  _calculateTotals(e, i) {
    if (e === 0 && (this._totals = this._seed(this._totalAggregates)), e === this._groupLevel)
      this._aggregate(this._totalAggregates, i, this._totals);
    else
      for (var r = 0; r < i.items.length; r++)
        this._calculateTotals(e + 1, i.items[r]);
    e === 0 && (this._totals = this._finalize(this._totalAggregates, this._totals));
  }
  _calculateGroups(e) {
    var i = this._groupLevel, r = i + 1, n = this._seed.bind(this, this._groupAggregates), a = this._aggregate.bind(this, this._groupAggregates), o = this._finalize.bind(this, this._groupAggregates);
    function u(c) {
      c.aggregates = n(r - 1), r === i ? a(c, c.aggregates) : QP(r, i, c, (p) => {
        a(p, c.aggregates);
      }), c.aggregates = o(c.aggregates);
    }
    for (; --r > 0; )
      QP(0, r, e, u);
  }
  _seed(e, i) {
    return Ow(e, (r) => {
      var {
        aggregator: n
      } = r, a = "seed" in n ? Le(n.seed) ? n.seed(i) : n.seed : NaN;
      return a;
    });
  }
  _accumulate(e, i, r, n) {
    var a = i.selector(n), {
      aggregator: o
    } = i, {
      skipEmptyValues: u
    } = i;
    u && Zke(a) || (r[e] !== r[e] ? r[e] = a : r[e] = o.step(r[e], a));
  }
  _finalize(e, i) {
    return Ow(e, (r, n) => {
      var a = r.aggregator.finalize;
      return a ? a(i[n]) : i[n];
    });
  }
}
var tPe = "dx-datagrid-total-footer", iPe = "dx-datagrid-summary-item", rPe = "dx-datagrid-text-content", nPe = "dx-datagrid-group-footer", aPe = "dx-datagrid-group-text-content", oPe = "dx-datagrid-nowrap", sPe = "dx-footer-row", lPe = "dx-cell-focus-disabled", ZP = "groupFooter", F9 = "totalFooter", B9 = function(t, e) {
  var i = E(t), {
    column: r
  } = e, {
    summaryItems: n
  } = e, a = [];
  if (!r.command && n) {
    for (var o = 0; o < n.length; o++) {
      var u = n[o], c = et.getSummaryText(u, e.summaryTexts);
      a.push(E("<div>").css("textAlign", u.alignment || r.alignment).addClass(iPe).addClass(rPe).addClass(u.cssClass).toggleClass(aPe, e.rowType === "group").text(c).attr("aria-label", "".concat(r.caption, " ").concat(c)));
    }
    i.append(a);
  }
}, V9 = function(t, e) {
  var i = t.option("summary.texts") || {};
  return {
    totalItem: e.row,
    summaryItems: e.row.summaryCells[e.columnIndex],
    summaryTexts: i
  };
}, dk = function(t) {
  return t.summary || t.aggregates || [];
}, dV = function(t) {
  return t.option("summary.recalculateWhileEditing");
}, uPe = function t(e, i, r, n) {
  n = n || [];
  for (var a = 0; a < e.length; a++)
    n.push(e[a].key), i === 1 ? r(n, e[a].items) : t(e[a].items, i - 1, r, n), n.pop();
}, dPe = function t(e, i, r) {
  return r ? t(e, i.map((n) => ({
    items: [n]
  }), r - 1)) : e.concat(i);
}, cPe = function t(e, i, r) {
  return r ? e.map((n) => {
    var a = {}, o = t(n.items || [], i, r - 1);
    return Object.defineProperty(a, "aggregates", {
      get: () => n.aggregates,
      set: (u) => {
        n.aggregates = u;
      }
    }), P(a, n, {
      items: o
    });
  }) : e.filter((n) => i.indexOf(n) < 0);
}, hPe = function t(e, i, r) {
  if (!e || !i.length)
    return e;
  var n = i[0], a = r[0], o;
  return n && a && a.length && (o = lo(e), N(a, function(u) {
    u === 0 ? o = o.sortBy(this.selector, this.desc) : o = o.thenBy(this.selector, this.desc);
  }), o.enumerate().done((u) => {
    e = u;
  })), i = i.slice(1), r = r.slice(1), i.length && r.length && N(e, function() {
    this.items = t(this.items, i, r);
  }), e;
}, _3 = function(t, e, i) {
  var r = i && i.sortByGroups && i.sortByGroups();
  return r && r.length ? hPe(t, e, r) : t;
}, C3 = function(t, e, i, r) {
  var n;
  if (dV(t)) {
    var a = t.getController("editing");
    if (a) {
      var o = a.getInsertedData();
      o.length && (i = dPe(i, o, r));
      var u = a.getRemovedData();
      u.length && (i = cPe(i, u, r));
    }
  }
  return e && (n = new ePe({
    totalAggregates: e.totalAggregates,
    groupAggregates: e.groupAggregates,
    data: i,
    groupLevel: r
  }), n.calculate()), n ? n.totalAggregates() : [];
};
class fPe extends SS {
  _getRows() {
    return this._dataController.footerItems();
  }
  _getCellOptions(e) {
    return P(super._getCellOptions(e), V9(this, e));
  }
  _renderCellContent(e, i) {
    B9(e, i), super._renderCellContent.apply(this, arguments);
  }
  _renderCore(e) {
    var i = !1, r = this._dataController.footerItems()[0];
    (!e || !e.columnIndices) && (this.element().empty().addClass(tPe).toggleClass(oPe, !this.option("wordWrapEnabled")), i = !0), r && r.summaryCells && r.summaryCells.length && (this._updateContent(this._renderTable({
      change: e
    }), e), i && this._updateScrollLeftPosition());
  }
  _updateContent(e, i) {
    return i && i.changeType === "update" && i.columnIndices ? this.waitAsyncTemplates().done(() => {
      var r = this.getTableElement().find(".dx-row"), n = e.find(".dx-row");
      this._updateCells(r, n, i.columnIndices[0]);
    }) : super._updateContent.apply(this, arguments);
  }
  _rowClick(e) {
    var i = this._dataController.footerItems()[e.rowIndex] || {};
    this.executeAction("onRowClick", P({}, e, i));
  }
  _columnOptionChanged(e) {
    var {
      optionNames: i
    } = e;
    e.changeTypes.grouping || (i.width || i.visibleWidth) && super._columnOptionChanged(e);
  }
  _handleDataChanged(e) {
    var {
      changeType: i
    } = e;
    e.changeType === "update" && e.repaintChangesOnly ? e.totalColumnIndices ? e.totalColumnIndices.length && this.render(null, {
      changeType: "update",
      columnIndices: [e.totalColumnIndices]
    }) : this.render() : (i === "refresh" || i === "append" || i === "prepend") && this.render();
  }
  _createRow(e) {
    var i = super._createRow.apply(this, arguments);
    return e.rowType === F9 && (i.addClass(sPe), i.addClass(lPe), i.attr("tabindex", 0)), i;
  }
  getHeight() {
    return this.getElementHeight();
  }
  isVisible() {
    return !!this._dataController.footerItems().length;
  }
}
var pPe = (t) => class extends t {
  init() {
    super.init.apply(this, arguments), this._totalAggregates = [], this._summaryGetter = ee;
  }
  summaryGetter(e) {
    if (!arguments.length)
      return this._summaryGetter;
    Le(e) && (this._summaryGetter = e);
  }
  summary(e) {
    if (!arguments.length)
      return this._summaryGetter();
    this._summaryGetter = function() {
      return e;
    };
  }
  totalAggregates() {
    return this._totalAggregates;
  }
  isLastLevelGroupItemsPagingLocal() {
    var e = this.summary(), i = e == null ? void 0 : e.sortByGroups();
    return i == null ? void 0 : i.length;
  }
  sortLastLevelGroupItems(e, i, r) {
    var n = rc.multiLevelGroup(lo(e), i).toArray(), a = [];
    return r.forEach((o) => {
      uPe(n, i.length, (u, c) => {
        o.toString() === u.toString() && (a = a.concat(c));
      });
    }), a;
  }
  _customizeRemoteOperations(e) {
    var i = this.summary();
    i && (e.remoteOperations.summary ? (!e.isCustomLoading || e.storeLoadOptions.isLoadingAll) && (e.storeLoadOptions.group && (e.remoteOperations.grouping ? e.storeLoadOptions.groupSummary = i.groupAggregates : i.groupAggregates.length && (e.remoteOperations.paging = !1)), e.storeLoadOptions.totalSummary = i.totalAggregates) : (i.totalAggregates.length || i.groupAggregates.length && e.storeLoadOptions.group) && (e.remoteOperations.paging = !1)), super._customizeRemoteOperations.apply(this, arguments);
    var r = e.cachedData.extra;
    r != null && r.summary && !e.isCustomLoading && (e.storeLoadOptions.totalSummary = void 0);
  }
  _handleDataLoadedCore(e) {
    var i, r, n = ic(e.storeLoadOptions.group || e.loadOptions.group || []), a = e.remoteOperations || {}, o = this.summaryGetter()(a);
    if (!e.isCustomLoading || e.storeLoadOptions.isLoadingAll) {
      if (a.summary)
        !a.paging && n.length && o && (a.grouping || C3(this, {
          groupAggregates: o.groupAggregates
        }, e.data, n.length), e.data = _3(e.data, n, o));
      else if (!a.paging && o) {
        var u = e.operationTypes || {}, c = Object.keys(u).some((v) => u[v]);
        if (!c || !(!((r = (i = e.cachedData) === null || i === void 0 ? void 0 : i.extra) === null || r === void 0) && r.summary) || n.length && o.groupAggregates.length) {
          var p = C3(this, o, e.data, n.length);
          e.extra = $t(e.extra) ? e.extra : {}, e.extra.summary = p, e.cachedData && (e.cachedData.extra = e.extra);
        }
        e.data = _3(e.data, n, o);
      }
    }
    e.isCustomLoading || (this._totalAggregates = e.extra && e.extra.summary || this._totalAggregates), super._handleDataLoadedCore(e);
  }
};
DI.extend(pPe);
var vPe = (t) => class extends t {
  _isDataColumn(e) {
    return e && (!R(e.groupIndex) || e.showWhenGrouped);
  }
  _isGroupFooterVisible() {
    for (var e = this.option("summary.groupItems") || [], i = 0; i < e.length; i++) {
      var r = e[i], n = this._columnsController.columnOption(r.showInColumn || r.column);
      if (r.showInGroupFooter && this._isDataColumn(n))
        return !0;
    }
    return !1;
  }
  _processGroupItems(e, i, r) {
    var n = r && r.data, a = super._processGroupItems.apply(this, arguments);
    return r && (r.isGroupFooterVisible === void 0 && (r.isGroupFooterVisible = this._isGroupFooterVisible()), n && n.items && r.isGroupFooterVisible && (r.collectContinuationItems || !n.isContinuationOnNextPage) && a.push({
      rowType: ZP,
      key: r.path.slice(),
      data: n,
      groupIndex: r.path.length - 1,
      values: []
    })), a;
  }
  _processGroupItem(e, i) {
    var r = this;
    if (i.summaryGroupItems || (i.summaryGroupItems = r.option("summary.groupItems") || []), e.rowType === "group") {
      var n = -1, a = -1;
      N(i.visibleColumns, function(o) {
        var u = i.visibleColumns[o - 1];
        e.groupIndex === this.groupIndex && (n = this.index), o > 0 && u.command === "expand" && this.command !== "expand" && (a = this.index);
      }), e.summaryCells = this._calculateSummaryCells(i.summaryGroupItems, dk(e.data), i.visibleColumns, (o, u) => o.showInGroupFooter ? -1 : o.alignByColumn && u && !R(u.groupIndex) && u.index !== a ? u.index : n, !0);
    }
    return e.rowType === ZP && (e.summaryCells = this._calculateSummaryCells(i.summaryGroupItems, dk(e.data), i.visibleColumns, (o, u) => o.showInGroupFooter && r._isDataColumn(u) ? u.index : -1)), e;
  }
  _calculateSummaryCells(e, i, r, n, a) {
    var o = this, u = [], c = {};
    return N(e, (p, v) => {
      var _ = o._columnsController.columnOption(v.column), y = v.showInColumn && o._columnsController.columnOption(v.showInColumn) || _, b = n(v, y);
      if (b >= 0) {
        c[b] || (c[b] = []);
        var I = i[p];
        if (I === I) {
          var A;
          R(v.valueFormat) ? A = v.valueFormat : v.summaryType !== "count" && (A = et.getFormatByDataType(_ && _.dataType)), c[b].push(P({}, v, {
            value: ht(I) && _ && _.deserializeValue ? _.deserializeValue(I) : I,
            valueFormat: A,
            columnCaption: _ && _.index !== b ? _.caption : void 0
          }));
        }
      }
    }), uo(c) || r.forEach((p, v) => {
      var _ = r[v - 1], y = a && ((_ == null ? void 0 : _.command) === "expand" || p.command === "expand") ? _ == null ? void 0 : _.index : p.index;
      u.push(c[y] || []);
    }), u;
  }
  _getSummaryCells(e, i) {
    var r = this, n = r._columnsController;
    return r._calculateSummaryCells(e, i, n.getVisibleColumns(), (a, o) => r._isDataColumn(o) ? o.index : -1);
  }
  _updateItemsCore(e) {
    var i, r = this._dataSource, n = this._footerItems, a = n && n[0] && n[0].summaryCells, o = this.option("summary.totalItems");
    if (this._footerItems = [], r && o && o.length) {
      var u = r.totalAggregates();
      i = this._getSummaryCells(o, u), e && e.repaintChangesOnly && a && (e.totalColumnIndices = i.map((c, p) => JSON.stringify(c) !== JSON.stringify(a[p]) ? p : -1).filter((c) => c >= 0)), i.length && this._footerItems.push({
        rowType: F9,
        summaryCells: i
      });
    }
    super._updateItemsCore(e);
  }
  _prepareUnsavedDataSelector(e) {
    if (dV(this)) {
      var i = this.getController("editing");
      if (i)
        return function(r) {
          return r = i.getUpdatedData(r), e(r);
        };
    }
    return e;
  }
  _prepareAggregateSelector(e, i) {
    return e = this._prepareUnsavedDataSelector(e), i === "avg" || i === "sum" ? function(r) {
      var n = e(r);
      return R(n) ? Number(n) : n;
    } : e;
  }
  _getAggregates(e, i) {
    var r = this, n = r.getController("columns"), a = r.option("summary.calculateCustomSummary"), o = r.option("summary.skipEmptyValues");
    return Jr(e || [], (u) => {
      var c = n.columnOption(u.column), p = c && c.calculateCellValue ? c.calculateCellValue.bind(c) : Ii(c ? c.dataField : u.column), v = u.summaryType || "count", _ = R(u.skipEmptyValues) ? u.skipEmptyValues : o;
      if (i)
        return {
          selector: u.column,
          summaryType: v
        };
      var y = r._prepareAggregateSelector(p, v);
      if (v === "custom") {
        a || (Yt.log("E1026"), a = function() {
        });
        var b = {
          component: r.component,
          name: u.name
        };
        a(b), b.summaryProcess = "calculate", v = {
          seed(I) {
            return b.summaryProcess = "start", b.totalValue = void 0, b.groupIndex = I, delete b.value, a(b), b.totalValue;
          },
          step(I, A) {
            return b.summaryProcess = "calculate", b.totalValue = I, b.value = A, a(b), b.totalValue;
          },
          finalize(I) {
            return b.summaryProcess = "finalize", b.totalValue = I, delete b.value, a(b), b.totalValue;
          }
        };
      }
      return {
        selector: y,
        aggregator: v,
        skipEmptyValues: _
      };
    });
  }
  _addSortInfo(e, i, r, n) {
    if (i) {
      var {
        groupIndex: a
      } = i;
      n = n || i.sortOrder, R(a) && (e[a] = e[a] || [], e[a].push({
        selector: r,
        desc: n === "desc"
      }));
    }
  }
  _findSummaryItem(e, i) {
    var r = -1;
    return R(i) && N(e || [], function(n) {
      if (this.name === i || n === i || this.summaryType === i || this.column === i || function(a) {
        var {
          summaryType: o
        } = a, {
          column: u
        } = a;
        return o && u && "".concat(o, "_").concat(u);
      }(this) === i)
        return r = n, !1;
    }), r;
  }
  _getSummarySortByGroups(e, i) {
    var r = this, n = r._columnsController, a = n.getGroupColumns(), o = [];
    if (!(!i || !i.length))
      return N(e || [], function() {
        var {
          sortOrder: u
        } = this, {
          groupColumn: c
        } = this, p = r._findSummaryItem(i, this.summaryItem);
        if (!(p < 0)) {
          var v = function(_) {
            return dk(_)[p];
          };
          R(c) ? (c = n.columnOption(c), r._addSortInfo(o, c, v, u)) : N(a, (_, y) => {
            r._addSortInfo(o, y, v, u);
          });
        }
      }), o;
  }
  _createDataSourceAdapterCore(e, i) {
    var r = this, n = super._createDataSourceAdapterCore(e, i);
    return n.summaryGetter((a) => r._getSummaryOptions(a || i)), n;
  }
  _getSummaryOptions(e) {
    var i = this, r = i.option("summary.groupItems"), n = i.option("summary.totalItems"), a = i.option("sortByGroupSummaryInfo"), o = i._getAggregates(r, e && e.grouping && e.summary), u = i._getAggregates(n, e && e.summary);
    if (o.length || u.length)
      return {
        groupAggregates: o,
        totalAggregates: u,
        sortByGroups: function() {
          return i._getSummarySortByGroups(a, r);
        }
      };
  }
  publicMethods() {
    var e = super.publicMethods();
    return e.push("getTotalSummaryValue"), e;
  }
  getTotalSummaryValue(e) {
    var i = this._findSummaryItem(this.option("summary.totalItems"), e), r = this._dataSource.totalAggregates();
    if (r.length && i > -1)
      return r[i];
  }
  optionChanged(e) {
    (e.name === "summary" || e.name === "sortByGroupSummaryInfo") && (e.name = "dataSource"), super.optionChanged(e);
  }
  init() {
    this._footerItems = [], super.init();
  }
  footerItems() {
    return this._footerItems;
  }
}, gPe = (t) => class extends t {
  _refreshSummary() {
    dV(this) && !this.isSaving() && this._dataController.refresh({
      load: !0,
      changesOnly: !0
    });
  }
  _addChange(e) {
    var i = super._addChange.apply(this, arguments);
    return e.type && this._refreshSummary(), i;
  }
  _removeChange() {
    var e = super._removeChange.apply(this, arguments);
    return this._refreshSummary(), e;
  }
  cancelEditData() {
    var e = super.cancelEditData.apply(this, arguments);
    return this._refreshSummary(), e;
  }
}, mPe = (t) => class extends t {
  _createRow(e) {
    var i = super._createRow.apply(this, arguments);
    return e && i.addClass(e.rowType === ZP ? nPe : ""), i;
  }
  _renderCells(e, i) {
    super._renderCells.apply(this, arguments), i.row.rowType === "group" && i.row.summaryCells && i.row.summaryCells.length && this._renderGroupSummaryCells(e, i);
  }
  _hasAlignByColumnSummaryItems(e, i) {
    return !R(i.columns[e].groupIndex) && i.row.summaryCells[e].length;
  }
  _getAlignByColumnCellCount(e, i) {
    for (var r = 0, n = 1; n < e; n++) {
      var a = i.row.summaryCells.length - n;
      r = this._hasAlignByColumnSummaryItems(a, i) ? n : r;
    }
    return r;
  }
  _renderGroupSummaryCells(e, i) {
    var r = e.children().last(), n = Number(r.attr("colSpan")) || 1, a = this._getAlignByColumnCellCount(n, i);
    this._renderGroupSummaryCellsCore(r, i, n, a);
  }
  _renderGroupSummaryCellsCore(e, i, r, n) {
    if (n > 0) {
      e.attr("colSpan", r - n);
      for (var a = 0; a < n; a++) {
        var o = i.columns.length - n + a;
        this._renderCell(e.parent(), P({
          column: i.columns[o],
          columnIndex: this._getSummaryCellIndex(o, i.columns)
        }, i));
      }
    }
  }
  _getSummaryCellIndex(e, i) {
    return e;
  }
  _getCellTemplate(e) {
    return !e.column.command && !R(e.column.groupIndex) && e.summaryItems && e.summaryItems.length ? B9 : super._getCellTemplate(e);
  }
  _getCellOptions(e) {
    var i = super._getCellOptions(e);
    return e.row.summaryCells ? P(i, V9(this, e)) : i;
  }
};
et.registerModule("summary", {
  defaultOptions: () => ({
    summary: {
      groupItems: void 0,
      totalItems: void 0,
      calculateCustomSummary: void 0,
      skipEmptyValues: !0,
      recalculateWhileEditing: !1,
      texts: {
        sum: X.format("dxDataGrid-summarySum"),
        sumOtherColumn: X.format("dxDataGrid-summarySumOtherColumn"),
        min: X.format("dxDataGrid-summaryMin"),
        minOtherColumn: X.format("dxDataGrid-summaryMinOtherColumn"),
        max: X.format("dxDataGrid-summaryMax"),
        maxOtherColumn: X.format("dxDataGrid-summaryMaxOtherColumn"),
        avg: X.format("dxDataGrid-summaryAvg"),
        avgOtherColumn: X.format("dxDataGrid-summaryAvgOtherColumn"),
        count: X.format("dxDataGrid-summaryCount")
      }
    },
    sortByGroupSummaryInfo: void 0
  }),
  views: {
    footerView: fPe
  },
  extenders: {
    controllers: {
      data: vPe,
      editing: gPe
    },
    views: {
      rowsView: mPe
    }
  }
});
var y3 = "content", Ex = "content-fixed", _Pe = "dx-master-detail-cell", x3 = "dx-first-cell", CPe = "dx-last-cell", S3 = "dx-state-hover", E3 = "dx-col-fixed", yPe = "dx-fixed-columns", ck = "dx-pointer-events-none", lp = "transparent", b3 = "dx-group-row", xPe = "dx-master-detail-row", zd = function(t) {
  var e = -1;
  return N(t, (i, r) => {
    if (r.command === lp)
      return e = i, !1;
  }), e;
}, N9 = function(t, e, i) {
  var r = 0;
  if (t && e && i)
    for (var n = 0; n < t.length; n++)
      t[n].command === lp ? r += t[n].colspan : (e[r] < i[n] && (e[r] = i[n]), r++);
  return e;
}, cV = (t) => class extends t {
  init() {
    super.init(), this._isFixedTableRendering = !1, this._isFixedColumns = !1;
  }
  _createCol(e) {
    return super._createCol(e).toggleClass(E3, !!(this._isFixedTableRendering && (e.fixed || e.command && e.command !== lp)));
  }
  _correctColumnIndicesForFixedColumns(e, i) {
    var r = zd(e), n = e[r].colspan, a = i && i.columnIndices;
    a && (i.columnIndices = a.map((o) => {
      if (o)
        return o.map((u) => u < r ? u : u >= r + n ? u - n + 1 : -1).filter((u) => u >= 0);
    }));
  }
  _partialUpdateFixedTable(e) {
    var i = this._fixedTableElement, r = this._getRowElementsCore(i), n = i.children("colgroup");
    n.replaceWith(this._createColGroup(e));
    for (var a = 0; a < r.length; a++)
      this._partialUpdateFixedRow(E(r[a]), e);
  }
  _partialUpdateFixedRow(e, i) {
    var r, n = e.get(0).childNodes, a = zd(i), o = i[a], u = this._columnsController.getColumnIndexOffset(), c, p = u + 1, {
      colspan: v
    } = o;
    if (e.hasClass(xPe)) {
      n[0].setAttribute("colspan", (r = this._columnsController.getVisibleColumns()) === null || r === void 0 ? void 0 : r.length);
      return;
    }
    e.hasClass(b3) && (c = this._getGroupCellOptions({
      row: e.data("options"),
      columns: this._columnsController.getVisibleColumns()
    }), v = c.colspan - Math.max(0, n.length - (c.columnIndex + 2)));
    for (var _ = 0; _ < n.length; _++) {
      var y = c ? _ === c.columnIndex + 1 : _ === a;
      n[_].setAttribute("aria-colindex", p), y ? (n[_].setAttribute("colspan", v), p += v) : p++;
    }
  }
  _renderTable(e) {
    var i, r, n = this.getFixedColumns();
    this._isFixedColumns = !!n.length;
    var a = super._renderTable(e);
    if (this._isFixedColumns) {
      var o = e == null ? void 0 : e.change, u = this._getRowElements(this._fixedTableElement), c = (o == null ? void 0 : o.virtualColumnsScrolling) && u.length === ((i = o == null ? void 0 : o.items) === null || i === void 0 ? void 0 : i.length);
      if (this._isFixedTableRendering = !0, c && this.option("scrolling.legacyMode") !== !0)
        this._partialUpdateFixedTable(n), this._isFixedTableRendering = !1;
      else {
        var p = o == null ? void 0 : o.columnIndices;
        this._correctColumnIndicesForFixedColumns(n, o), r = this._createTable(n), this._renderRows(r, P({}, e, {
          columns: n
        })), this._updateContent(r, o, !0), p && (o.columnIndices = p), this._isFixedTableRendering = !1;
      }
    } else
      this._fixedTableElement && this._fixedTableElement.parent().remove(), this._fixedTableElement = null;
    return a;
  }
  _renderRow(e, i) {
    var r, {
      cells: n
    } = i.row;
    if (super._renderRow.apply(this, arguments), this._isFixedTableRendering && n && n.length) {
      r = 0;
      var a = i.row.cells || [];
      n = n.slice(), i.row.cells = n;
      for (var o = 0; o < a.length; o++) {
        if (a[o].column && a[o].column.command === lp) {
          r = (a[o].column.colspan || 1) - 1;
          continue;
        }
        n[o + r] = a[o];
      }
    }
  }
  _createCell(e) {
    var {
      column: i
    } = e, r = i && i.command, {
      rowType: n
    } = e, a = super._createCell.apply(this, arguments), o, u, c;
    (this._isFixedTableRendering || n === "filter") && (o = this.getFixedColumns(), c = zd(o), u = o[c - 1]), this._isFixedTableRendering ? r === lp && (a.addClass(ck).toggleClass(x3, c === 0 || u && u.command === "expand").toggleClass(CPe, o.length && c === o.length - 1), n !== "freeSpace" && xe.setEmptyText(a)) : n === "filter" && a.toggleClass(x3, e.columnIndex === c);
    var p = this.option("rowAlternationEnabled") && e.isAltRow, v = this.option("selection.mode") === "multiple" && e.columnIndex === 0 && e.rowType === "header";
    return $i.mozilla && e.column.fixed && e.rowType !== "group" && !p && !v && a.addClass(E3), a;
  }
  _getContent(e) {
    var i;
    return e ? (i = this._fixedTableElement) === null || i === void 0 ? void 0 : i.parent() : super._getContent.apply(this, arguments);
  }
  _wrapTableInScrollContainer(e, i) {
    var r = super._wrapTableInScrollContainer.apply(this, arguments);
    return (this._isFixedTableRendering || i) && r.addClass(this.addWidgetPrefix(Ex)), r;
  }
  _renderCellContent(e, i) {
    var r, {
      column: n
    } = i, a = this._isFixedTableRendering, o = i.rowType === "group" && R(n.groupIndex);
    if (a && o && !n.command && !n.groupCellTemplate && e.css("pointerEvents", "none"), !a && this._isFixedColumns) {
      if (r = n.fixed || n.command && n.fixed !== !1, o && (r = !1, i.row.summaryCells && i.row.summaryCells.length)) {
        var u = this._columnsController.getVisibleColumns(), c = this._getAlignByColumnCellCount ? this._getAlignByColumnCellCount(n.colspan, {
          columns: u,
          row: i.row,
          isFixed: !0
        }) : 0;
        if (c > 0) {
          var p = zd(this._columnsController.getFixedColumns());
          r = u.length - c < p;
        }
      }
      if (r) {
        if (n.command && n.type !== "buttons" || i.rowType === "group") {
          e.html("&nbsp;").addClass(n.cssClass);
          return;
        }
        e.addClass("dx-hidden-cell");
      }
    }
    n.command !== lp && super._renderCellContent.apply(this, arguments);
  }
  _getCellElementsCore(e) {
    var i = super._getCellElementsCore.apply(this, arguments), r = i == null ? void 0 : i.parent().hasClass(b3), n = this.name === "columnHeadersView" ? e : void 0;
    if (this._fixedTableElement && i) {
      var a = this.getFixedColumns(n), o = this._getRowElements(this._fixedTableElement).eq(e).children("td");
      N(o, (u, c) => {
        if (r)
          i[u] && c.style.visibility !== "hidden" && (i[u] = c);
        else {
          var p = a[u];
          if (p)
            if (p.command === lp)
              o.eq(u).hasClass(_Pe) && (i[u] = c || i[u]);
            else {
              var v = this._columnsController.getVisibleIndexByColumn(p, n);
              i[v] = c || i[v];
            }
        }
      });
    }
    return i;
  }
  getColumnWidths(e) {
    var i = super.getColumnWidths(), r = this.getFixedColumns(), n = this._fixedTableElement && i.length ? super.getColumnWidths(this._fixedTableElement) : void 0;
    return N9(r, i, n);
  }
  getTableElement(e) {
    e = this._isFixedTableRendering || e;
    var i = e ? this._fixedTableElement : super.getTableElement();
    return i;
  }
  setTableElement(e, i) {
    this._isFixedTableRendering || i ? this._fixedTableElement = e.addClass(ck) : super.setTableElement(e);
  }
  getColumns(e) {
    var i = this.getTableElement();
    return this._isFixedTableRendering ? this.getFixedColumns(e) : super.getColumns(e, i);
  }
  getRowIndex(e) {
    var i = this._fixedTableElement;
    return i && i.find(e).length ? this._getRowElements(i).index(e) : super.getRowIndex(e);
  }
  getTableElements() {
    var e = super.getTableElements.apply(this, arguments);
    return this._fixedTableElement && (e = E([e.get(0), this._fixedTableElement.get(0)])), e;
  }
  getFixedColumns(e) {
    return this._columnsController.getFixedColumns(e);
  }
  getFixedColumnsOffset() {
    var e = {
      left: 0,
      right: 0
    }, i;
    if (this._fixedTableElement) {
      i = this.getTransparentColumnElement();
      var r = i.position();
      e = {
        left: r.left,
        right: oi(this.element(), !0) - (oi(i, !0) + r.left)
      };
    }
    return e;
  }
  getTransparentColumnElement() {
    return this._fixedTableElement && this._fixedTableElement.find(".".concat(ck)).first();
  }
  getFixedTableElement() {
    return this._fixedTableElement;
  }
  isFixedColumns() {
    return this._isFixedColumns;
  }
  _resizeCore() {
    super._resizeCore(), this.synchronizeRows();
  }
  setColumnWidths(e) {
    var i, {
      widths: r
    } = e, n = this._columnsController.getVisibleColumns(), a = (r == null ? void 0 : r.length) && n.some((y) => R(y.visibleWidth)), o = (i = e.optionNames) === null || i === void 0 ? void 0 : i.width;
    if (super.setColumnWidths(e), this._fixedTableElement) {
      var u = r == null ? void 0 : r.some((y) => y === "auto" || !R(y)), c = u && (!a || !this.isScrollbarVisible(!0)), p = c ? n : this.getFixedColumns();
      this.setFixedTableColumnWidths(p, r);
    }
    var v = this.option("wordWrapEnabled"), _ = a || o && v;
    _ && this.synchronizeRows();
  }
  setFixedTableColumnWidths(e, i) {
    if (!(!this._fixedTableElement || !i)) {
      var r = this._fixedTableElement.children("colgroup").children("col");
      r.toArray().forEach((a) => a.removeAttribute("style"));
      var n = 0;
      e.forEach((a) => {
        if (a.colspan) {
          n += a.colspan;
          return;
        }
        var o = i5(i[n]);
        R(o) && yk(r.eq(n), o), n += 1;
      });
    }
  }
  _getClientHeight(e) {
    var i = e.getBoundingClientRect && zr(e);
    return i && i.height ? i.height : e.clientHeight;
  }
  synchronizeRows() {
    var e = [], i = [], r, n, a, o;
    this.waitAsyncTemplates(!0).done(() => {
      if (this._isFixedColumns && this._tableElement && this._fixedTableElement) {
        var u = this._getClientHeight(this._tableElement.get(0)), c = this._getClientHeight(this._fixedTableElement.get(0));
        if (n = this._getRowElements(this._tableElement), a = this._getRowElements(this._fixedTableElement), o = this._findContentElement(), u !== c) {
          for (o && o.css("height", u), n.css("height", ""), a.css("height", ""), r = 0; r < n.length; r++)
            e.push(this._getClientHeight(n.get(r))), i.push(this._getClientHeight(a.get(r)));
          for (r = 0; r < n.length; r++) {
            var p = e[r], v = i[r];
            p > v ? a.eq(r).css("height", p) : p < v && n.eq(r).css("height", v);
          }
          o && o.css("height", "");
        }
      }
    });
  }
  setScrollerSpacing(e, i) {
    var r = this.option("rtlEnabled");
    super.setScrollerSpacing(e), this.element().children(".".concat(this.addWidgetPrefix(Ex))).css({
      paddingLeft: r ? e : "",
      paddingRight: r ? "" : e
    });
  }
}, SPe = (t) => class extends cV(t) {
  _getRowVisibleColumns(e) {
    return this._isFixedTableRendering ? this.getFixedColumns(e) : super._getRowVisibleColumns(e);
  }
  getContextMenuItems(e) {
    var {
      column: i
    } = e, r = this.option("columnFixing"), n = super.getContextMenuItems(e);
    if (e.row && e.row.rowType === "header" && r.enabled === !0 && i && i.allowFixing) {
      var a = (o) => {
        switch (o.itemData.value) {
          case "none":
            this._columnsController.columnOption(i.index, "fixed", !1);
            break;
          case "left":
            this._columnsController.columnOption(i.index, {
              fixed: !0,
              fixedPosition: "left"
            });
            break;
          case "right":
            this._columnsController.columnOption(i.index, {
              fixed: !0,
              fixedPosition: "right"
            });
        }
      };
      n = n || [], n.push({
        text: r.texts.fix,
        beginGroup: !0,
        items: [{
          text: r.texts.leftPosition,
          value: "left",
          disabled: i.fixed && (!i.fixedPosition || i.fixedPosition === "left"),
          onItemClick: a
        }, {
          text: r.texts.rightPosition,
          value: "right",
          disabled: i.fixed && i.fixedPosition === "right",
          onItemClick: a
        }]
      }, {
        text: r.texts.unfix,
        value: "none",
        disabled: !i.fixed,
        onItemClick: a
      });
    }
    return n;
  }
  getFixedColumnElements(e) {
    if (R(e))
      return this._fixedTableElement && this._getRowElements(this._fixedTableElement).eq(e).children();
    var i = this.getColumnElements(), r = this.getTransparentColumnElement();
    if (i && r && r.length) {
      var n = zd(this.getFixedColumns());
      i.splice(n, r.get(0).colSpan, r.get(0));
    }
    return i;
  }
  getColumnWidths() {
    var e, i = super.getColumnWidths(), r = this.getFixedColumnElements(), n = this.getFixedColumns();
    return this._fixedTableElement && (r && r.length ? e = this._getWidths(r) : e = super.getColumnWidths(this._fixedTableElement)), N9(n, i, e);
  }
}, EPe = (t) => class extends cV(t) {
  dispose() {
    super.dispose.apply(this, arguments), clearTimeout(this._fixedScrollTimeout);
  }
  optionChanged(e) {
    super.optionChanged(e), e.name === "hoverStateEnabled" && this._isFixedColumns && (e.value ? this._attachHoverEvents() : this._detachHoverEvents());
  }
  _detachHoverEvents() {
    var e = this.element();
    this._fixedTableElement && this._tableElement && k.off(e, "mouseover mouseout", ".dx-data-row");
  }
  _attachHoverEvents() {
    this._fixedTableElement && this._tableElement && k.on(this.element(), "mouseover mouseout", ".dx-data-row", this.createAction((e) => {
      var {
        event: i
      } = e, r = this.getRowIndex(E(i.target).closest(".dx-row")), n = i.type === "mouseover";
      r >= 0 && (this._tableElement && this._getRowElements(this._tableElement).eq(r).toggleClass(S3, n), this._fixedTableElement && this._getRowElements(this._fixedTableElement).eq(r).toggleClass(S3, n));
    }));
  }
  _getScrollDelay() {
    var e, i = (e = this._resizingController) === null || e === void 0 ? void 0 : e.hasResizeTimeout();
    return i ? this.option("scrolling.updateTimeout") : $i.mozilla ? 60 : 0;
  }
  _findContentElement(e) {
    var i, r, n = this.addWidgetPrefix(y3), a = this.element();
    if (e = this._isFixedTableRendering || e, a && e) {
      i = a.children(".".concat(n));
      var o = this.getScrollable();
      return !i.length && o && (i = E("<div>").addClass(n), k.on(i, "scroll", (u) => {
        var {
          target: c
        } = u, p = this._getScrollDelay();
        clearTimeout(this._fixedScrollTimeout), this._fixedScrollTimeout = setTimeout(() => {
          r = E(c).scrollTop(), o.scrollTo({
            y: r
          });
        }, p);
      }), k.on(i, lS, (u) => {
        var c = E(u.target).closest(".dx-scrollable"), p = !1;
        if (o && o.$element().is(c))
          p = !0;
        else {
          var v = c.length && ds.getInstance(c.get(0)), _ = v && v.scrollHeight() - v.clientHeight() > 0;
          p = v && !_;
        }
        if (p) {
          r = o.scrollTop(), o.scrollTo({
            y: r - u.delta
          });
          var y = o.scrollTop() + o.clientHeight(), b = o.scrollHeight() + this.getScrollbarWidth(), I = o.scrollTop() > 0 && y < b;
          if (I)
            return !1;
        }
      }), i.appendTo(a)), i;
    }
    return super._findContentElement();
  }
  _updateScrollable() {
    super._updateScrollable();
    var e = this.getScrollable();
    if (!(e != null && e._disposed)) {
      var i = e && e.scrollOffset().top;
      this._updateFixedTablePosition(i);
    }
  }
  _renderContent(e, i, r) {
    return this._isFixedTableRendering || r ? e.empty().addClass("".concat(this.addWidgetPrefix(y3), " ").concat(this.addWidgetPrefix(Ex))).append(i) : super._renderContent(e, i);
  }
  _getGroupCellOptions(e) {
    return this._isFixedTableRendering ? super._getGroupCellOptions(P({}, e, {
      columns: this._columnsController.getVisibleColumns()
    })) : super._getGroupCellOptions(e);
  }
  _renderGroupedCells(e, i) {
    return super._renderGroupedCells(e, P({}, i, {
      columns: this._columnsController.getVisibleColumns()
    }));
  }
  _renderGroupSummaryCells(e, i) {
    this._isFixedTableRendering ? super._renderGroupSummaryCells(e, P({}, i, {
      columns: this._columnsController.getVisibleColumns()
    })) : super._renderGroupSummaryCells(e, i);
  }
  _hasAlignByColumnSummaryItems(e, i) {
    var r = super._hasAlignByColumnSummaryItems.apply(this, arguments), n = i.columns[e];
    return i.isFixed ? n.fixed && (r || n.fixedPosition === "right") : r && (!this._isFixedColumns || !n.fixed);
  }
  _renderGroupSummaryCellsCore(e, i, r, n) {
    var a;
    if (this._isFixedTableRendering) {
      i.isFixed = !0, a = this._getAlignByColumnCellCount(r, i), i.isFixed = !1;
      var o = i.columns.length - a;
      i = P({}, i, {
        columns: this.getFixedColumns()
      });
      var u = zd(i.columns);
      o < u ? (a -= i.columns[u].colspan - 1 || 0, r -= i.columns[u].colspan - 1 || 0) : n > 0 && e.css("visibility", "hidden"), n = a;
    }
    super._renderGroupSummaryCellsCore(e, i, r, n);
  }
  _getSummaryCellIndex(e, i) {
    if (this._isFixedTableRendering) {
      var r = zd(i);
      return e > r && (e += i[r].colspan - 1), e;
    }
    return super._getSummaryCellIndex.apply(this, arguments);
  }
  _renderCore(e) {
    this._detachHoverEvents();
    var i = super._renderCore(e), r = this._isFixedColumns;
    return this.element().toggleClass(yPe, r), this.option("hoverStateEnabled") && r && this._attachHoverEvents(), i;
  }
  setAriaOwns(e, i, r) {
    var n, a;
    if (r) {
      var o = this.addWidgetPrefix(Ex), u = (n = this.element()) === null || n === void 0 ? void 0 : n.children(".".concat(o)), c = this.getFixedTableElement();
      u.length && (c != null && c.length) && this.setAria("owns", "".concat(e ?? "", " ").concat((a = c.attr("id")) !== null && a !== void 0 ? a : "", " ").concat(i ?? "").trim(), u);
    } else
      super.setAriaOwns.apply(this, arguments);
  }
  setRowsOpacity(e, i) {
    super.setRowsOpacity(e, i);
    var r = this._getRowElements(this._fixedTableElement);
    this._setRowsOpacityCore(r, this.getFixedColumns(), e, i);
  }
  getCellIndex(e) {
    var i = this._fixedTableElement, r = 0;
    if (i && e.is("td") && e.closest(i).length) {
      var n = this.getFixedColumns();
      return N(n, (a, o) => {
        if (a === e[0].cellIndex)
          return !1;
        if (o.colspan) {
          r += o.colspan;
          return;
        }
        r++;
      }), r;
    }
    return super.getCellIndex.apply(this, arguments);
  }
  _updateFixedTablePosition(e, i) {
    if (this._fixedTableElement && this._tableElement) {
      var r;
      this._fixedTableElement.parent().scrollTop(e), i && this._editorFactoryController && (r = this._editorFactoryController.focus(), r && this._editorFactoryController.focus(r));
    }
  }
  setScrollerSpacing(e, i) {
    var r = {
      marginBottom: 0
    }, n = this.element().children(".".concat(this.addWidgetPrefix(Ex)));
    if (n.length && this._fixedTableElement) {
      n.css(r), this._fixedTableElement.css(r), r[this.option("rtlEnabled") ? "marginLeft" : "marginRight"] = e, r.marginBottom = i;
      var a = this._scrollable && this._scrollable.option("useNative");
      (a ? n : this._fixedTableElement).css(r);
    }
  }
  _getElasticScrollTop(e) {
    var i = 0;
    if (e.scrollOffset.top < 0)
      i = -e.scrollOffset.top;
    else if (e.reachedBottom) {
      var r = E(e.component.content()), n = E(e.component.container()), a = Math.max(r.get(0).clientHeight - n.get(0).clientHeight, 0);
      i = Math.min(a - e.scrollOffset.top, 0);
    }
    return Math.floor(i);
  }
  _applyElasticScrolling(e) {
    if (this._fixedTableElement) {
      var i = this._getElasticScrollTop(e);
      Math.ceil(i) !== 0 ? Nn(this._fixedTableElement, {
        top: i
      }) : this._fixedTableElement.css("transform", "");
    }
  }
  _handleScroll(e) {
    this._updateFixedTablePosition(e.scrollOffset.top, !0), this._applyElasticScrolling(e), super._handleScroll(e);
  }
  _updateContentPosition(e) {
    super._updateContentPosition.apply(this, arguments), e || this._updateFixedTablePosition(this._scrollTop);
  }
  _afterRowPrepared(e) {
    this._isFixedTableRendering || super._afterRowPrepared(e);
  }
  _scrollToElement(e) {
    super._scrollToElement(e, this.getFixedColumnsOffset());
  }
}, bPe = (t) => class extends cV(t) {
}, wPe = function(t, e, i) {
  var r = zd(e), n = t.length - e.length;
  return N(i, (a, o) => {
    o.index > r && (o.columnIndex += n, o.index += n);
  }), i;
}, TPe = (t) => class extends t {
  _generatePointsByColumns(e) {
    var i = e.columns, {
      targetDraggingPanel: r
    } = e;
    if (r && r.getName() === "headers" && r.isFixedColumns() && e.sourceColumn.fixed) {
      e.rowIndex || (e.columnElements = r.getFixedColumnElements(0)), e.columns = r.getFixedColumns(e.rowIndex);
      var n = super._generatePointsByColumns(e);
      return wPe(i, e.columns, n), n;
    }
    return super._generatePointsByColumns(e);
  }
  _pointCreated(e, i, r, n) {
    var a = super._pointCreated.apply(this, arguments), o = i[e.columnIndex], u = this._columnHeadersView.getTransparentColumnElement();
    if (!a && r === "headers" && u && u.length) {
      var c = zr(u.get(0));
      return n && n.fixed ? n.fixedPosition === "right" ? e.x < c.right : e.x > c.left : o && o.fixed && o.fixedPosition !== "right" ? !0 : e.x < c.left || e.x > c.right;
    }
    return a;
  }
}, IPe = (t) => class extends t {
  _generatePointsByColumns() {
    var e = this, i = e._columnsController, r = i && e._columnsController.getVisibleColumns(), n = i && e._columnsController.getFixedColumns(), a = zd(n), o = r.length - n.length, u = e._columnHeadersView.getFixedColumnElements();
    super._generatePointsByColumns(), u && u.length > 0 && (e._pointsByFixedColumns = xe.getPointsByColumns(u, (c) => (c.index > a && (c.columnIndex += o, c.index += o), e._pointCreated(c, r.length, r))));
  }
  _getTargetPoint(e, i, r) {
    var n = this._columnHeadersView.getTransparentColumnElement();
    if (n && n.length) {
      var a = zr(n.get(0));
      if (i <= a.left || i >= a.right)
        return super._getTargetPoint(this._pointsByFixedColumns, i, r);
    }
    return super._getTargetPoint(e, i, r);
  }
}, DPe = (t) => class extends t {
  _setAriaOwns() {
    var e, i, r;
    super._setAriaOwns.apply(this, arguments);
    var n = (e = this._columnHeadersView) === null || e === void 0 ? void 0 : e.getFixedTableElement(), a = (i = this._footerView) === null || i === void 0 ? void 0 : i.getFixedTableElement();
    (r = this._rowsView) === null || r === void 0 || r.setAriaOwns(n == null ? void 0 : n.attr("id"), a == null ? void 0 : a.attr("id"), !0);
  }
}, APe = {
  defaultOptions: () => ({
    columnFixing: {
      enabled: !1,
      texts: {
        fix: X.format("dxDataGrid-columnFixingFix"),
        unfix: X.format("dxDataGrid-columnFixingUnfix"),
        leftPosition: X.format("dxDataGrid-columnFixingLeftPosition"),
        rightPosition: X.format("dxDataGrid-columnFixingRightPosition")
      }
    }
  }),
  extenders: {
    views: {
      columnHeadersView: SPe,
      rowsView: EPe,
      footerView: bPe
    },
    controllers: {
      draggingHeader: TPe,
      columnsResizer: IPe,
      resizing: DPe
    }
  }
};
et.registerModule("columnFixing", APe);
var H9 = "columnHeadersView", $9 = "rowsView", OPe = "footerView", hk = [H9, $9, OPe], RPe = "dxDataGridAdaptivity", Wd = "adaptiveHidden", up = "detailAdaptive", hV = "dx-field-item-content", LPe = "dx-item-modified", bx = "hidden-column", MPe = "adaptive-more", z9 = "dx-command-adaptive", lT = "dx-command-adaptive-hidden", kPe = "dx-adaptive-detail-row", JP = "dx-adaptive-item-text", PPe = "dx-master-detail-cell", FPe = "dx-last-data-cell", Rw = "adaptive", BPe = "batch", eF = "row", VPe = "form", NPe = "popup", HPe = "revert-tooltip", w3 = "dx-group-cell", $Pe = "dx-group-row", W9 = "dxDataGrid-ariaAdaptiveExpand", zPe = "dxDataGrid-ariaAdaptiveCollapse", WPe = "scrolling.legacyMode";
function Lw(t, e) {
  return t._columnsController.getColumnId(e);
}
function UPe(t) {
  return t.find("td:not(.dx-datagrid-hidden-column):not([class*='dx-command-'])");
}
function GPe(t, e) {
  var i, r = E(t), n = e.component.getController("adaptiveColumns");
  e.rowType === "data" ? (i = E("<span>").addClass(n.addWidgetPrefix(MPe)), k.on(i, ve(di, RPe), n.createAction(() => {
    n.toggleExpandAdaptiveDetailRow(e.key);
  })), i.appendTo(r)) : xe.setEmptyText(r);
}
function tF(t) {
  var e, i = (e = t.data) === null || e === void 0 ? void 0 : e.$nextCell;
  k.off(i, "focus", tF), k.trigger(i, "dxclick");
}
class KPe extends Bi.ViewController {
  init() {
    this._columnsController = this.getController("columns"), this._dataController = this.getController("data"), this._editingController = this.getController("editing"), this._keyboardNavigationController = this.getController("keyboardNavigation"), this._rowsView = this.getView("rowsView"), this._columnsController.addCommandColumn({
      type: Rw,
      command: Rw,
      visible: !0,
      adaptiveHidden: !0,
      cssClass: z9,
      alignment: "center",
      width: "auto",
      cellTemplate: GPe,
      fixedPosition: "right"
    }), this._columnsController.columnsChanged.add(() => {
      var e = !!this.updateHidingQueue(this._columnsController.getColumns()).length;
      this._columnsController.columnOption("command:adaptive", "adaptiveHidden", !e, !0);
    }), this._hidingColumnsQueue = [], this._hiddenColumns = [], this.createAction("onAdaptiveDetailRowPreparing"), super.init();
  }
  optionChanged(e) {
    e.name === "columnHidingEnabled" && this._columnsController.columnOption("command:adaptive", "adaptiveHidden", !e.value), super.optionChanged(e);
  }
  publicMethods() {
    return ["isAdaptiveDetailRowExpanded", "expandAdaptiveDetailRow", "collapseAdaptiveDetailRow"];
  }
  _isRowEditMode() {
    var e = this._getEditMode();
    return e === eF;
  }
  _isItemModified(e, i) {
    var r = this._columnsController.getVisibleIndex(e.column.index), n = this._dataController.getRowIndexByKey(i.key), a = this._dataController.items()[n + 1];
    return a && a.modifiedValues && R(a.modifiedValues[r]);
  }
  _renderFormViewTemplate(e, i, r) {
    var n = this, {
      column: a
    } = e, o = n.createAction(() => {
      n._editingController.isEditing() && k.trigger(r, di);
    }), u = i.row.data, c = a.calculateCellValue(u), p = xe.getDisplayValue(a, c, u, i.rowType), v = xe.formatValue(p, a), _ = this._editingController.isCellOrBatchEditMode(), y = n._rowsView;
    if (a.allowEditing && this._keyboardNavigationController.isKeyboardEnabled() && (r.attr("tabIndex", n.option("tabIndex")), _ && (k.off(r, "focus", o), k.on(r, "focus", o))), a.cellTemplate) {
      var b = P({}, i, {
        value: c,
        displayValue: p,
        text: v,
        column: a
      });
      y.renderTemplate(r, a.cellTemplate, b, dI(r)).done(() => {
        y._cellPrepared(r, i);
      });
    } else {
      var I = r.get(0);
      a.encodeHtml ? I.textContent = v : I.innerHTML = v, r.addClass(JP), (!R(v) || v === "") && r.html("&nbsp;"), n._isRowEditMode() || n._isItemModified(e, i) && r.addClass(LPe), y._cellPrepared(r, i);
    }
  }
  _getTemplate(e, i, r) {
    var n = this, {
      column: a
    } = e, o = this._editingController;
    return function(u, c) {
      var p = E(c), v = n._columnsController.getVisibleIndex(a.index), _ = P({}, i), y = function() {
        var I = n._isItemEdited(e);
        _.value = i.row.values[v], I || a.showEditorAlways ? o.renderFormEditorTemplate(_, e, u, p, !I) : (_.column = a, _.columnIndex = v, n._renderFormViewTemplate(e, _, p));
      };
      if (y(), _.watch) {
        var b = _.watch(() => ({
          isItemEdited: n._isItemEdited(e),
          value: i.row.values[v]
        }), () => {
          p.contents().remove(), p.removeClass(JP), y();
        });
        k.on(p, fo, b);
      }
    };
  }
  _isVisibleColumnsValid(e) {
    return !(e < 2 || e.length - function() {
      for (var i = 0, r = 0; r < e.length; r++) {
        var n = e[r];
        n.command && i++;
      }
      return i;
    }() <= 1);
  }
  _calculatePercentWidths(e, i) {
    var r = this, n = 0;
    return i.forEach((a, o) => {
      e[o] !== Wd && (n += r._getItemPercentWidth(a));
    }), n;
  }
  _isPercentWidth(e) {
    return ht(e) && e.endsWith("%");
  }
  _isColumnHidden(e) {
    return this._hiddenColumns.filter((i) => i.index === e.index).length > 0;
  }
  _getAverageColumnsWidth(e, i, r) {
    var n = this, a = 0, o = 0;
    return i.forEach((u) => {
      if (!n._isColumnHidden(u)) {
        var {
          width: c
        } = u;
        R(c) && !isNaN(parseFloat(c)) ? a += n._isPercentWidth(c) ? n._calculatePercentWidth({
          visibleIndex: u.visibleIndex,
          columnsCount: i.length,
          columnsCanFit: r,
          bestFitWidth: u.bestFitWidth,
          columnWidth: c,
          containerWidth: e
        }) : parseFloat(c) : o++;
      }
    }), (e - a) / o;
  }
  _calculateColumnWidth(e, i, r, n) {
    var a = Lw(this, e), o = this._columnsController.columnOption(a, "width"), u = this._columnsController.columnOption(a, "bestFitWidth"), c = r.length, p;
    if (o && o !== "auto")
      if (this._isPercentWidth(o))
        p = this._calculatePercentWidth({
          visibleIndex: e.visibleIndex,
          columnsCount: c,
          columnsCanFit: n,
          bestFitWidth: u,
          columnWidth: o,
          containerWidth: i
        });
      else
        return parseFloat(o);
    else {
      var v = this.option("columnAutoWidth");
      p = v || e.command ? u : this._getAverageColumnsWidth(i, r, n);
    }
    return p;
  }
  _calculatePercentWidth(e) {
    var i = e.visibleIndex < e.columnsCount - 1 && e.columnsCanFit, r = e.containerWidth * parseFloat(e.columnWidth) / 100, n = e.columnsCanFit && r < e.bestFitWidth ? e.bestFitWidth : r;
    return i ? e.containerWidth * parseFloat(e.columnWidth) / 100 : n;
  }
  _getNotTruncatedColumnWidth(e, i, r, n) {
    var a = Lw(this, e), o = this._columnsController.columnOption(a, "width"), u = this._columnsController.columnOption(a, "bestFitWidth");
    if (o && o !== "auto" && !this._isPercentWidth(o))
      return parseFloat(o);
    var c = this._calculateColumnWidth(e, i, r, n);
    return c < u ? null : c;
  }
  _getItemPercentWidth(e) {
    var i = 0;
    return e.width && this._isPercentWidth(e.width) && (i = parseFloat(e.width)), i;
  }
  _getCommandColumnsWidth() {
    var e = this, i = e._columnsController.getVisibleColumns(), r = 0;
    return N(i, (n, a) => {
      (a.index < 0 || a.command) && (r += e._columnsController.columnOption(Lw(e, a), "bestFitWidth") || 0);
    }), r;
  }
  _isItemEdited(e) {
    if (this.isFormOrPopupEditMode())
      return !1;
    if (this._isRowEditMode()) {
      var i = this.option("editing.editRowKey");
      if (Mi(i, this._dataController.adaptiveExpandedKey()))
        return !0;
    } else {
      var r = this._dataController.getRowIndexByKey(this._dataController.adaptiveExpandedKey()) + 1, n = this._columnsController.getVisibleIndex(e.column.index);
      return this._editingController.isEditCell(r, n);
    }
  }
  _getFormItemsByHiddenColumns(e) {
    var i = [];
    return N(e, (r, n) => {
      i.push({
        column: n,
        name: n.name,
        dataField: n.dataField,
        visibleIndex: n.visibleIndex
      });
    }), i;
  }
  _getAdaptiveColumnVisibleIndex(e) {
    for (var i = 0; i < e.length; i++) {
      var r = e[i];
      if (r.command === Rw)
        return i;
    }
  }
  _hideAdaptiveColumn(e, i) {
    var r = this._getAdaptiveColumnVisibleIndex(i);
    R(r) && (e[r] = Wd, this._hideVisibleColumn({
      isCommandColumn: !0,
      visibleIndex: r
    }));
  }
  _showHiddenCellsInView(e) {
    var {
      $cells: i,
      isCommandColumn: r
    } = e, n = this.addWidgetPrefix(bx);
    r ? (n = lT, i.attr({
      tabIndex: 0,
      "aria-hidden": null
    }).removeClass(n)) : i.removeClass(n);
  }
  _showHiddenColumns() {
    for (var e = 0; e < hk.length; e++) {
      var i = this.getView(hk[e]);
      if (i && i.isVisible() && i.element()) {
        var r = i.name, n = i.element().find(".".concat(lT));
        this._showHiddenCellsInView({
          viewName: r,
          $cells: n,
          isCommandColumn: !0
        });
        var a = i.element().find(".".concat(this.addWidgetPrefix(bx)));
        this._showHiddenCellsInView({
          viewName: r,
          $cells: a
        });
      }
    }
  }
  _isCellValid(e) {
    return e && e.length && !e.hasClass(PPe) && !e.hasClass(w3);
  }
  _hideVisibleColumn(e) {
    var {
      isCommandColumn: i,
      visibleIndex: r
    } = e, n = this;
    hk.forEach((a) => {
      var o = n.getView(a);
      o && n._hideVisibleColumnInView({
        view: o,
        isCommandColumn: i,
        visibleIndex: r
      });
    });
  }
  _hideVisibleColumnInView(e) {
    var {
      view: i,
      isCommandColumn: r,
      visibleIndex: n
    } = e, a = i.name, o, u = this._columnsController.getVisibleColumns()[n], c = this._editingController && this._editingController.getEditFormRowIndex();
    if (i && i.isVisible() && u)
      for (var p = i.getRowsCount(), v = i._getRowElements(), _ = 0; _ < p; _++) {
        var y = _ === c && a === $9 && this.option("editing.mode") !== "popup";
        if (!y) {
          var b = a === H9 ? this._columnsController.getVisibleIndex(u.index, _) : n;
          if (b >= 0) {
            var I = v.eq(_);
            o = this._findCellElementInRow(I, b), this._isCellValid(o) && this._hideVisibleCellInView({
              viewName: a,
              isCommandColumn: r,
              $cell: o
            });
          }
        }
      }
  }
  _findCellElementInRow(e, i) {
    var r = e.children(), n = i, a = !1;
    if (e.hasClass($Pe)) {
      var o = e.find(".".concat(w3)), u = o.attr("colspan");
      if (o.length && R(u)) {
        var c = parseInt(u), p = o.index() + c - 1;
        i > p ? n = i - c + 1 : a = !0;
      }
    }
    var v = a ? void 0 : r.eq(n);
    return v;
  }
  _hideVisibleCellInView(e) {
    var {
      $cell: i,
      isCommandColumn: r
    } = e, n = r ? lT : this.addWidgetPrefix(bx);
    i.attr({
      tabIndex: -1,
      "aria-hidden": !0
    }).addClass(n);
  }
  _getEditMode() {
    return this._editingController.getEditMode();
  }
  isFormOrPopupEditMode() {
    var e = this._getEditMode();
    return e === VPe || e === NPe;
  }
  hideRedundantColumns(e, i, r) {
    if (this._hiddenColumns = [], this._isVisibleColumnsValid(i) && r.length) {
      var n = 0, a = this.component.$element(), o = mt(a) - this._getCommandColumnsWidth(), u = (function() {
        return i.filter((pe) => !pe.command && this._hiddenColumns.filter((_e) => _e.index === pe.index).length === 0);
      }).bind(this), c = u(), p = c.length, v, _, y;
      do {
        y = !1, n = 0;
        var b = this._calculatePercentWidths(e, i), I = b < 100 && b !== 0;
        for (v = 0; v < i.length; v++) {
          var A = i[v], L = this._getNotTruncatedColumnWidth(A, o, c, I), B = Lw(this, A), $ = this._columnsController.columnOption(B, "width"), K = this._columnsController.columnOption(B, "minWidth"), te = this._columnsController.columnOption(B, "bestFitWidth");
          if (e[v] === Wd) {
            _ = !0;
            continue;
          }
          if (!L && !A.command && !A.fixed) {
            y = !0;
            break;
          }
          (!$ || $ === "auto") && (L = Math.max(te || 0, K || 0)), (A.command !== Rw || _) && (n += L);
        }
        if (y = y || n > mt(a), y) {
          var z = r.pop(), ie = this._columnsController.getVisibleIndex(z.index);
          o += this._calculateColumnWidth(z, o, c, I), this._hideVisibleColumn({
            visibleIndex: ie
          }), e[ie] = Wd, this._hiddenColumns.push(z), c = u();
        }
      } while (y && c.length > 1 && r.length);
      p === c.length && this._hideAdaptiveColumn(e, i);
    } else
      this._hideAdaptiveColumn(e, i);
  }
  getAdaptiveDetailItems() {
    return this._$itemContents;
  }
  getItemContentByColumnIndex(e) {
    for (var i, r = 0; r < this._$itemContents.length; r++) {
      i = this._$itemContents.eq(r);
      var n = i.data("dx-form-item");
      if (n && n.column && this._columnsController.getVisibleIndex(n.column.index) === e)
        return i;
    }
  }
  toggleExpandAdaptiveDetailRow(e, i) {
    this.isFormOrPopupEditMode() && this._editingController.isEditing() || this._dataController.toggleExpandAdaptiveDetailRow(e, i);
  }
  createFormByHiddenColumns(e, i) {
    var r = this, n = E(e), a = {
      items: r._getFormItemsByHiddenColumns(r._hiddenColumns),
      formID: "dx-".concat(new yr())
    }, o = _a() ? {
      colCount: 2
    } : {};
    this.executeAction("onAdaptiveDetailRowPreparing", {
      formOptions: a
    }), r._$itemContents = null, r._form = r._createComponent(E("<div>").appendTo(n), eV, P(o, a, {
      customizeItem(u) {
        var c = u.column || r._columnsController.columnOption(u.name || u.dataField);
        c && (u.label = u.label || {}, u.label.text = u.label.text || c.caption, u.column = c, u.template = r._getTemplate(u, i, r.updateForm.bind(r))), a.customizeItem && a.customizeItem.call(this, u);
      },
      onContentReady(u) {
        a.onContentReady && a.onContentReady.call(this, u), r._$itemContents = n.find(".".concat(hV));
      }
    }));
  }
  hasAdaptiveDetailRowExpanded() {
    return R(this._dataController.adaptiveExpandedKey());
  }
  updateForm(e) {
    this.hasAdaptiveDetailRowExpanded() && this._form && R(this._form._contentReadyAction) && (e && e.length ? this._form.option("items", this._getFormItemsByHiddenColumns(e)) : this._form.repaint());
  }
  updateHidingQueue(e) {
    var i = e.filter((o) => o.visible && !o.type && !o.fixed && !(R(o.groupIndex) && o.groupIndex >= 0)), r, n;
    if (this._hidingColumnsQueue = [], this.option("allowColumnResizing") && this.option("columnResizingMode") === "widget")
      return this._hidingColumnsQueue;
    for (n = 0; n < i.length; n++)
      R(i[n].hidingPriority) && i[n].hidingPriority >= 0 && (r = !0, this._hidingColumnsQueue[i[n].hidingPriority] = i[n]);
    if (r)
      this._hidingColumnsQueue.reverse();
    else if (this.option("columnHidingEnabled"))
      for (n = 0; n < i.length; n++) {
        var a = this._columnsController.getVisibleIndex(i[n].index);
        this._hidingColumnsQueue[a] = i[n];
      }
    return this._hidingColumnsQueue = this._hidingColumnsQueue.filter(Object), this._hidingColumnsQueue;
  }
  getHiddenColumns() {
    return this._hiddenColumns;
  }
  hasHiddenColumns() {
    return this._hiddenColumns.length > 0;
  }
  getHidingColumnsQueue() {
    return this._hidingColumnsQueue;
  }
  isAdaptiveDetailRowExpanded(e) {
    var i = this._dataController;
    return i.adaptiveExpandedKey() && Mi(i.adaptiveExpandedKey(), e);
  }
  expandAdaptiveDetailRow(e) {
    this.hasAdaptiveDetailRowExpanded() || this.toggleExpandAdaptiveDetailRow(e);
  }
  collapseAdaptiveDetailRow() {
    this.hasAdaptiveDetailRowExpanded() && this.toggleExpandAdaptiveDetailRow();
  }
  updateCommandAdaptiveAriaLabel(e, i) {
    var r = this._dataController.getRowIndexByKey(e);
    if (r !== -1) {
      var n = E(this.component.getRowElement(r));
      this.setCommandAdaptiveAriaLabel(n, i);
    }
  }
  setCommandAdaptiveAriaLabel(e, i) {
    var r = e.find(".dx-command-adaptive");
    r.attr("aria-label", X.format(i));
  }
}
var jPe = (t) => class extends t {
  _isCellValid(e, i) {
    return super._isCellValid(e, i) && !e.hasClass(this.addWidgetPrefix(bx)) && !e.hasClass(lT);
  }
  _processNextCellInMasterDetail(e, i) {
    super._processNextCellInMasterDetail(e, i);
    var r = this._editingController.isCellOrBatchEditMode(), n = this._editingController.isEditing();
    n && e && r && !this._isInsideEditForm(e) && (k.off(e, "focus", tF), k.on(e, "focus", {
      $nextCell: e
    }, tF), k.trigger(i, "focus"));
  }
  _isCellElement(e) {
    return super._isCellElement(e) || e.hasClass(JP);
  }
}, YPe = (t) => class extends t {
  _getCellTemplate(e) {
    var i = this, {
      column: r
    } = e;
    return e.rowType === up && r.command === "detail" ? function(n, a) {
      i._adaptiveColumnsController.createFormByHiddenColumns(E(n), a);
    } : super._getCellTemplate(e);
  }
  _createRow(e) {
    var i = super._createRow.apply(this, arguments);
    return e && e.rowType === up && e.key === this._dataController.adaptiveExpandedKey() && i.addClass(kPe), i;
  }
  _renderCells(e, i) {
    super._renderCells(e, i);
    var r = this._adaptiveColumnsController, n = r.getHidingColumnsQueue().length, a = r.getHiddenColumns().length;
    n && !a && UPe(e).last().addClass(FPe), i.row.rowType === "data" && r.setCommandAdaptiveAriaLabel(e, W9);
  }
  _getColumnIndexByElementCore(e) {
    var i = e.closest(".".concat(hV));
    if (i.length && i.closest(this.component.$element()).length) {
      var r = i.length ? i.first().data("dx-form-item") : null;
      return r && r.column && this._columnsController.getVisibleIndex(r.column.index);
    }
    return super._getColumnIndexByElementCore(e);
  }
  _cellPrepared(e, i) {
    super._cellPrepared.apply(this, arguments), i.row.rowType !== up && i.column.visibleWidth === Wd && e.addClass(this.addWidgetPrefix(bx));
  }
  getCell(e, i) {
    var r = this._dataController.items()[e == null ? void 0 : e.rowIndex];
    if ((r == null ? void 0 : r.rowType) === up) {
      var n = this._adaptiveColumnsController.getAdaptiveDetailItems();
      return super.getCell(e, i, n);
    }
    return super.getCell.apply(this, arguments);
  }
  _getCellElement(e, i) {
    var r = this._dataController.items()[e];
    return r && r.rowType === up ? this._adaptiveColumnsController.getItemContentByColumnIndex(i) : super._getCellElement.apply(this, arguments);
  }
  getContextMenuItems(e) {
    var i;
    if (e.row && e.row.rowType === "detailAdaptive") {
      var r = this._columnHeadersView, n = E(e.targetElement).closest(".dx-field-item-label").next().data("dx-form-item");
      return e.column = n ? n.column : e.column, r.getContextMenuItems && r.getContextMenuItems(e);
    }
    return (i = super.getContextMenuItems) === null || i === void 0 ? void 0 : i.call(this, e);
  }
  isClickableElement(e) {
    var i, r, n = (r = (i = super.isClickableElement) === null || i === void 0 ? void 0 : i.call(this, e)) !== null && r !== void 0 ? r : !1;
    return n || !!e.closest(".".concat(z9)).length;
  }
}, qPe = (t) => class extends t {
  _updateColumnWidth(e, i) {
    super._updateColumnWidth(e, e.visibleWidth === Wd ? e.bestFitWidth : i);
  }
}, XPe = (t) => class extends t {
  _pointCreated(e, i, r) {
    var n = super._pointCreated(e, i, r), a = r[e.columnIndex] || {}, o = this._getNextColumnIndex(e.columnIndex), u = r[o] || {}, c = o !== e.columnIndex + 1 && u.command, p = a.visibleWidth === Wd || c;
    return n || p;
  }
  _getNextColumnIndex(e) {
    for (var i = this._columnsController.getVisibleColumns(), r = super._getNextColumnIndex(e); i[r] && i[r].visibleWidth === Wd; )
      r++;
    return r;
  }
}, QPe = (t) => class extends t {
  _pointCreated(e, i, r, n) {
    var a = super._pointCreated(e, i, r, n), o = i[e.columnIndex - 1] || {}, u = o.visibleWidth === Wd;
    return a || u;
  }
}, ZPe = (t) => class extends t {
  _isRowEditMode() {
    return this.getEditMode() === eF;
  }
  _getFormEditItemTemplate(e, i) {
    return this.getEditMode() !== eF && e.rowType === "detailAdaptive" ? (e.columnIndex = this._columnsController.getVisibleIndex(i.index), this.getColumnTemplate(e)) : super._getFormEditItemTemplate(e, i);
  }
  _closeEditItem(e) {
    var i = e.closest(".".concat(hV)), r = this._dataController.getRowIndexByKey(this._dataController.adaptiveExpandedKey()) + 1, n = i.length ? i.first().data("dx-form-item") : null, a = n && n.column && this._columnsController.getVisibleIndex(n.column.index);
    this.isEditCell(r, a) || super._closeEditItem(e);
  }
  _beforeUpdateItems(e, i) {
    if (!this._adaptiveColumnsController.isFormOrPopupEditMode() && this._adaptiveColumnsController.hasHiddenColumns()) {
      var r = this._dataController.items(), n = r[i], a = xe.getIndexByKey(this._dataController.adaptiveExpandedKey(), r);
      this._isForceRowAdaptiveExpand = !this._adaptiveColumnsController.hasAdaptiveDetailRowExpanded(), a >= 0 && e.push(a + 1), e.push(i + 1), this._dataController.adaptiveExpandedKey(n.key);
    }
  }
  _afterInsertRow(e) {
    super._afterInsertRow.apply(this, arguments), this._adaptiveColumnsController.hasHiddenColumns() && (this._adaptiveColumnsController.toggleExpandAdaptiveDetailRow(e, this.isRowEditMode()), this._isForceRowAdaptiveExpand = !0);
  }
  _collapseAdaptiveDetailRow() {
    this._isRowEditMode() && this._isForceRowAdaptiveExpand && (this._adaptiveColumnsController.collapseAdaptiveDetailRow(), this._isForceRowAdaptiveExpand = !1);
  }
  _cancelEditAdaptiveDetailRow() {
    this._adaptiveColumnsController.hasHiddenColumns() && this._collapseAdaptiveDetailRow();
  }
  _afterSaveEditData() {
    super._afterSaveEditData.apply(this, arguments);
    var e = new q();
    return this._isRowEditMode() && this._adaptiveColumnsController.hasHiddenColumns() ? $e(this._validatingController.validate(!0)).done((i) => {
      i && this._cancelEditAdaptiveDetailRow(), e.resolve();
    }) : e.resolve(), e.promise();
  }
  _beforeCancelEditData() {
    super._beforeCancelEditData(), this._cancelEditAdaptiveDetailRow();
  }
  _getRowIndicesForCascadeUpdating(e) {
    var i = super._getRowIndicesForCascadeUpdating.apply(this, arguments);
    return this._adaptiveColumnsController.isAdaptiveDetailRowExpanded(e.key) && i.push(e.rowType === up ? e.rowIndex - 1 : e.rowIndex + 1), i;
  }
  _beforeCloseEditCellInBatchMode(e) {
    var i = this._dataController._adaptiveExpandedKey;
    if (i) {
      var r = xe.getIndexByKey(i, this._dataController.items());
      r > -1 && e.unshift(r);
    }
  }
  editRow(e) {
    return this._adaptiveColumnsController.isFormOrPopupEditMode() && this._adaptiveColumnsController.collapseAdaptiveDetailRow(), super.editRow(e);
  }
  deleteRow(e) {
    var i = this._dataController.getKeyByRowIndex(e);
    this.getEditMode() === BPe && this._adaptiveColumnsController.isAdaptiveDetailRowExpanded(i) && this._adaptiveColumnsController.collapseAdaptiveDetailRow(), super.deleteRow(e);
  }
}, JPe = (t) => class extends t {
  _processItems(e, i) {
    var {
      changeType: r
    } = i;
    if (e = super._processItems.apply(this, arguments), r === "loadingAll" || !R(this._adaptiveExpandedKey))
      return e;
    var n = xe.getIndexByKey(this._adaptiveExpandedKey, e), a = this.option(WPe) === !1;
    if (n >= 0) {
      var o = e[n];
      e.splice(n + 1, 0, {
        visible: !0,
        rowType: up,
        key: o.key,
        data: o.data,
        node: o.node,
        modifiedValues: o.modifiedValues,
        isNewRow: o.isNewRow,
        values: o.values
      });
    } else
      r === "refresh" && !(a && i.repaintChangesOnly) && (this._adaptiveExpandedKey = void 0);
    return e;
  }
  _getRowIndicesForExpand(e) {
    var i = super._getRowIndicesForExpand.apply(this, arguments);
    if (this._adaptiveColumnsController.isAdaptiveDetailRowExpanded(e)) {
      var r = i[i.length - 1];
      i.push(r + 1);
    }
    return i;
  }
  adaptiveExpandedKey(e) {
    if (R(e))
      this._adaptiveExpandedKey = e;
    else
      return this._adaptiveExpandedKey;
  }
  toggleExpandAdaptiveDetailRow(e, i) {
    var r = xe.getIndexByKey(this._adaptiveExpandedKey, this._items), n = xe.getIndexByKey(e, this._items);
    r >= 0 && r === n && !i && (e = void 0, n = -1);
    var a = this._adaptiveExpandedKey;
    this._adaptiveExpandedKey = e, r >= 0 && r++, n >= 0 && n++;
    var o = this.getRowIndexDelta();
    this.updateItems({
      allowInvisibleRowIndices: !0,
      changeType: "update",
      rowIndices: [r - o, n - o]
    }), this._adaptiveColumnsController.updateCommandAdaptiveAriaLabel(e, zPe), this._adaptiveColumnsController.updateCommandAdaptiveAriaLabel(a, W9);
  }
}, eFe = (t) => class extends t {
  _needHideBorder(e) {
    return super._needHideBorder(e) || (e == null ? void 0 : e.hasClass("dx-field-item-content")) && (e == null ? void 0 : e.find(".dx-checkbox").length);
  }
  _getFocusCellSelector() {
    return "".concat(super._getFocusCellSelector(), ", .dx-adaptive-detail-row .dx-field-item > .dx-field-item-content");
  }
  _getRevertTooltipsSelector() {
    return "".concat(super._getRevertTooltipsSelector(), ", .dx-field-item-content .").concat(this.addWidgetPrefix(HPe));
  }
}, tFe = (t) => class extends t {
  _isColumnVisible(e) {
    return super._isColumnVisible(e) && !e.adaptiveHidden;
  }
}, iFe = (t) => class extends t {
  dispose() {
    super.dispose.apply(this, arguments), clearTimeout(this._updateScrollableTimeoutID);
  }
  _needBestFit() {
    return super._needBestFit() || !!this._adaptiveColumnsController.getHidingColumnsQueue().length;
  }
  _correctColumnWidths(e, i) {
    var r = this._adaptiveColumnsController, n = r.getHiddenColumns(), a = r.updateHidingQueue(this._columnsController.getColumns());
    r.hideRedundantColumns(e, i, a);
    var o = r.getHiddenColumns();
    return r.hasAdaptiveDetailRowExpanded() && n.length !== o.length && r.updateForm(o), !o.length && r.collapseAdaptiveDetailRow(), super._correctColumnWidths.apply(this, arguments);
  }
  _toggleBestFitMode(e) {
    e && this._adaptiveColumnsController._showHiddenColumns(), super._toggleBestFitMode(e);
  }
  _needStretch() {
    var e = this._adaptiveColumnsController;
    return super._needStretch.apply(this, arguments) || e.getHidingColumnsQueue().length || e.hasHiddenColumns();
  }
}, rFe = {
  defaultOptions: () => ({
    columnHidingEnabled: !1,
    onAdaptiveDetailRowPreparing: null
  }),
  controllers: {
    adaptiveColumns: KPe
  },
  extenders: {
    views: {
      rowsView: YPe
    },
    controllers: {
      export: qPe,
      columnsResizer: XPe,
      draggingHeader: QPe,
      editing: ZPe,
      resizing: iFe,
      data: JPe,
      editorFactory: eFe,
      columns: tFe,
      keyboardNavigation: jPe
    }
  }
};
et.registerModule("adaptivity", rFe);
function U9(t, e, i, r, n, a) {
  i = i || 0, r = r || [], a = a || [], r[i] = r[i] || 0;
  var o = t[i], u = a[i] + 1 || 0, c = 0, p;
  if (o) {
    for (p = u; p < o.length; p++) {
      var v = o[p], _ = p + r[i], y = v.colspan || 1;
      if (U9(t, e, i + (v.rowspan || 1), r, y, a), r[i] += y - 1, c += y, v.rowspan)
        for (var b = i + 1; b < i + v.rowspan; b++)
          r[b] = r[b] || 0, r[b] += v.colspan || 1;
      if (e(v, _, i, p) === !1 || n !== void 0 && c >= n)
        break;
    }
    a[i] = p;
  }
}
function fk(t, e, i) {
  var r = [];
  U9(t, (a, o, u) => {
    var c = a, p, v = c.colspan || 1, _ = o + v - 1 >= e && o < i;
    if (r[u] = r[u] || [], _)
      o < e ? (p = v - (e - o), o = e) : p = v, o + p > i && (p = i - o), p !== v && (c = P({}, c, {
        colspan: p
      })), r[u].push(c);
    else if (o > i)
      return !1;
  });
  for (var n = 0; n < r.length; n++)
    r[n] = r[n] || [];
  return r;
}
var nFe = 50, aFe = (t) => class extends t {
  _resizeCore() {
    super._resizeCore.apply(this, arguments), this._columnsController.resize();
  }
  _handleScroll(e) {
    var i = this.getScrollable(), {
      left: r
    } = e.scrollOffset;
    super._handleScroll.apply(this, arguments), this.option("rtlEnabled") && i && (r = mt(i.$content()) - mt(i.$element()) - r), this._columnsController.setScrollPosition(r);
  }
  _renderCore(e) {
    var i, r;
    if (e != null && e.virtualColumnsScrolling) {
      var n = this._findContentElement(), a = (i = this._columnsController) === null || i === void 0 ? void 0 : i.getFixedColumns(), o = (r = this._scrollable) === null || r === void 0 ? void 0 : r.option("useNative");
      if (a != null && a.length) {
        n.css({
          minHeight: o ? Pt(n) : xe.getContentHeightLimit($i)
        });
        var u = () => {
          this.resizeCompleted.remove(u), n.css({
            minHeight: ""
          });
        };
        this.resizeCompleted.add(u);
      }
    }
    return super._renderCore.apply(this, arguments);
  }
}, oFe = (t) => class extends t {
  _renderCore() {
    var e = super._renderCore.apply(this, arguments);
    return this._columnsController.isVirtualMode() && this._updateScrollLeftPosition(), e;
  }
}, Mw = function(t) {
  return t.map((e) => e.visibleWidth || parseFloat(e.width) || nFe);
}, sFe = (t) => class extends t {
  init() {
    super.init.apply(this, arguments), this._resizingController = this.getController("resizing"), this._beginPageIndex = null, this._endPageIndex = null, this._position = 0, this._virtualVisibleColumns = {};
  }
  dispose() {
    clearTimeout(this._changedTimeout), super.dispose.apply(this, arguments);
  }
  resetColumnsCache() {
    super.resetColumnsCache(), this._virtualVisibleColumns = {};
  }
  getBeginPageIndex(e) {
    for (var i = this.getVisibleColumns(void 0, !0), r = Mw(i), n = 0, a = 0; a < r.length; a++) {
      if (n >= e)
        return Math.floor(a / this.getColumnPageSize());
      n += r[a];
    }
    return 0;
  }
  getTotalWidth() {
    var e = this.option("width");
    return typeof e == "number" ? e : this._resizingController._lastWidth || oi(this.component.$element());
  }
  getEndPageIndex(e) {
    var i = this.getVisibleColumns(void 0, !0), r = Mw(i), n = 0;
    e += this.getTotalWidth();
    for (var a = 0; a < r.length; a++) {
      if (n >= e)
        return Math.ceil(a / this.getColumnPageSize());
      n += r[a];
    }
    return Math.ceil(r.length / this.getColumnPageSize());
  }
  getColumnPageSize() {
    return this.option("scrolling.columnPageSize");
  }
  _fireColumnsChanged() {
    var e = /* @__PURE__ */ new Date();
    this.columnsChanged.fire({
      optionNames: {
        all: !0,
        length: 1
      },
      changeTypes: {
        columns: !0,
        virtualColumnsScrolling: !0,
        length: 2
      }
    }), this._renderTime = /* @__PURE__ */ new Date() - e;
  }
  getScrollingTimeout() {
    var e = this.option("scrolling.columnRenderingThreshold"), i = this.option("scrolling.renderAsync"), r = 0;
    return (!R(i) && this._renderTime > e || i) && (r = this.option("scrolling.timeout")), r;
  }
  setScrollPosition(e) {
    var i = this.getScrollingTimeout();
    i > 0 ? (clearTimeout(this._changedTimeout), this._changedTimeout = setTimeout(() => {
      this._setScrollPositionCore(e);
    }, i)) : this._setScrollPositionCore(e);
  }
  isVirtualMode() {
    return wt() && this.option("scrolling.columnRenderingMode") === "virtual";
  }
  resize() {
    this._setScrollPositionCore(this._position);
  }
  _setScrollPositionCore(e) {
    if (this.isVirtualMode()) {
      var i = this.getBeginPageIndex(e), r = this.getEndPageIndex(e), n = e < this._position ? this._beginPageIndex > i : this._endPageIndex < r;
      this._position = e, n && (this._beginPageIndex = i, this._endPageIndex = r, this._fireColumnsChanged());
    }
  }
  getFixedColumns(e, i) {
    var r = super.getFixedColumns(e);
    if (this.isVirtualMode() && !i && r.length) {
      var n = r.map((a) => a.command).indexOf("transparent");
      return r[n].colspan = this.getVisibleColumns().length - super.getFixedColumns().length + 1, r;
    }
    return r;
  }
  _compileVisibleColumns(e, i) {
    var r;
    if (i || !this.isVirtualMode() || !this._shouldReturnVisibleColumns())
      return super._compileVisibleColumns(e);
    !((r = this._columns) === null || r === void 0) && r.length && !R(this._beginPageIndex) && !R(this._endPageIndex) && (this._beginPageIndex = this.getBeginPageIndex(this._position), this._endPageIndex = this.getEndPageIndex(this._position));
    var n = this._beginPageIndex, a = this._endPageIndex, o = "".concat(e, "-").concat(n, "-").concat(a);
    if (this._virtualVisibleColumns[o])
      return this._virtualVisibleColumns[o];
    var u = super._compileVisibleColumns(), c = this.getRowCount(), p = this.getColumnPageSize(), v = n * p, _ = a * p, y = this.getFixedColumns(void 0, !0), b = y.map((_e) => _e.command).indexOf("transparent"), I = y.length ? b : 0, A = u.slice(0, I), L = u.slice(I, v), B = Mw(L).reduce((_e, be) => _e + be, 0);
    B || (v = 0);
    var $ = y.length ? y.length - b - 1 : 0, K = u.slice(u.length - $), te = u.slice(_, u.length - $), z = Mw(te).reduce((_e, be) => _e + be, 0);
    if (z || (_ = u.length), c > 1 && typeof e == "number") {
      for (var ie = [], pe = 0; pe <= c; pe++)
        ie.push(super._compileVisibleColumns(pe));
      A = fk(ie, 0, A.length)[e] || [], K = fk(ie, u.length - K.length, u.length)[e] || [], u = fk(ie, v, _)[e] || [];
    } else
      u = u.slice(v, _);
    return B && (u.unshift({
      command: "virtual",
      width: B
    }), u = A.concat(u)), z && (u.push({
      command: "virtual",
      width: z
    }), u = u.concat(K)), this._virtualVisibleColumns[o] = u, u;
  }
  getColumnIndexOffset() {
    var e = 0;
    if (this._beginPageIndex > 0) {
      var i = this.getFixedColumns(), r = i.map((a) => a.command).indexOf("transparent"), n = r >= 0 ? r : 0;
      e = this._beginPageIndex * this.getColumnPageSize() - n - 1;
    }
    return e > 0 ? e : 0;
  }
}, lFe = {
  defaultOptions: () => ({
    scrolling: {
      columnRenderingMode: "standard",
      columnPageSize: 5,
      columnRenderingThreshold: 300
    }
  }),
  extenders: {
    controllers: {
      columns: sFe
    },
    views: {
      columnHeadersView: oFe,
      rowsView: aFe
    }
  }
};
et.registerModule("virtualColumns", lFe);
var AS = "dx-buttongroup", uFe = "".concat(AS, "-wrapper"), G9 = "".concat(AS, "-item"), dFe = "".concat(AS, "-first-item"), cFe = "".concat(AS, "-last-item"), T3 = "".concat(G9, "-has-width"), hFe = "dx-shape-standard", kw = {
  contained: "dx-buttongroup-mode-contained",
  outlined: "dx-buttongroup-mode-outlined",
  text: "dx-buttongroup-mode-text"
}, fFe = Kp.inherit({
  _initTemplates() {
    this.callBase(), this._templateManager.addDefaultTemplates({
      item: new Gp((t, e, i) => {
        this._prepareItemStyles(t);
        var r = this.option("buttonTemplate");
        this._createComponent(t, yn, P({}, i, e, this._getBasicButtonOptions(), {
          _templateData: this._hasCustomTemplate(r) ? i : {},
          template: i.template || r
        }));
      }, ["text", "type", "icon", "disabled", "visible", "hint"], this.option("integrationOptions.watchMethod"))
    });
  },
  _getBasicButtonOptions() {
    return {
      focusStateEnabled: !1,
      onClick: null,
      hoverStateEnabled: this.option("hoverStateEnabled"),
      activeStateEnabled: this.option("activeStateEnabled"),
      stylingMode: this.option("stylingMode")
    };
  },
  _getDefaultOptions() {
    return P(this.callBase(), {
      itemTemplateProperty: null
    });
  },
  _hasCustomTemplate(t) {
    return Le(t) || this.option("integrationOptions.templates")[t];
  },
  _selectedItemClass: () => "dx-item-selected dx-state-selected",
  _prepareItemStyles(t) {
    var e = t.data("dxItemIndex");
    e === 0 && t.addClass(dFe);
    var i = this.option("items");
    i && e === i.length - 1 && t.addClass(cFe), t.addClass(hFe);
  },
  _renderItemContent(t) {
    return t.container = E(t.container).parent(), this.callBase(t);
  },
  _setAriaSelectionAttribute(t, e) {
    this.setAria("pressed", e, t);
  },
  _renderItemContentByNode(t, e) {
    return t.container = E(t.container.children().first()), this.callBase(t, e);
  },
  _focusTarget() {
    return this.$element().parent();
  },
  _keyboardEventBindingTarget() {
    return this._focusTarget();
  },
  _refreshContent() {
    this._prepareContent(), this._renderContent();
  },
  _itemClass: () => G9,
  _itemSelectHandler(t) {
    this.option("selectionMode") === "single" && this.isItemSelected(t.currentTarget) || this.callBase(t);
  }
}), K9 = xn.inherit({
  _getDefaultOptions() {
    return P(this.callBase(), {
      hoverStateEnabled: !0,
      focusStateEnabled: !0,
      selectionMode: "single",
      selectedItems: [],
      selectedItemKeys: [],
      stylingMode: "contained",
      keyExpr: "text",
      items: [],
      buttonTemplate: "content",
      onSelectionChanged: null,
      onItemClick: null
    });
  },
  _init() {
    this.callBase(), this._createItemClickAction();
  },
  _createItemClickAction() {
    this._itemClickAction = this._createActionByOption("onItemClick");
  },
  _initMarkup() {
    this.setAria("role", "group"), this.$element().addClass(AS), this._renderStylingMode(), this._renderButtons(), this._syncSelectionOptions(), this.callBase();
  },
  _renderStylingMode() {
    var t, {
      stylingMode: e
    } = this.option();
    for (var i in kw)
      this.$element().removeClass(kw[i]);
    this.$element().addClass((t = kw[e]) !== null && t !== void 0 ? t : kw.contained);
  },
  _fireSelectionChangeEvent(t, e) {
    this._createActionByOption("onSelectionChanged", {
      excludeValidators: ["disabled", "readOnly"]
    })({
      addedItems: t,
      removedItems: e
    });
  },
  _renderButtons() {
    var t = E("<div>").addClass(uFe).appendTo(this.$element()), e = this.option("selectedItems"), i = {
      selectionMode: this.option("selectionMode"),
      items: this.option("items"),
      keyExpr: this.option("keyExpr"),
      buttonTemplate: this.option("buttonTemplate"),
      scrollingEnabled: !1,
      selectedItemKeys: this.option("selectedItemKeys"),
      focusStateEnabled: this.option("focusStateEnabled"),
      hoverStateEnabled: this.option("hoverStateEnabled"),
      activeStateEnabled: this.option("activeStateEnabled"),
      stylingMode: this.option("stylingMode"),
      accessKey: this.option("accessKey"),
      tabIndex: this.option("tabIndex"),
      noDataText: "",
      selectionRequired: !1,
      onItemRendered: (r) => {
        var n = this.option("width");
        R(n) && E(r.itemElement).addClass(T3);
      },
      onSelectionChanged: (r) => {
        this._syncSelectionOptions(), this._fireSelectionChangeEvent(r.addedItems, r.removedItems);
      },
      onItemClick: (r) => {
        this._itemClickAction(r);
      }
    };
    R(e) && e.length && (i.selectedItems = e), this._buttonsCollection = this._createComponent(t, fFe, i);
  },
  _syncSelectionOptions() {
    this._setOptionWithoutOptionChange("selectedItems", this._buttonsCollection.option("selectedItems")), this._setOptionWithoutOptionChange("selectedItemKeys", this._buttonsCollection.option("selectedItemKeys"));
  },
  _optionChanged(t) {
    switch (t.name) {
      case "stylingMode":
      case "selectionMode":
      case "keyExpr":
      case "buttonTemplate":
      case "items":
      case "activeStateEnabled":
      case "focusStateEnabled":
      case "hoverStateEnabled":
      case "tabIndex":
        this._invalidate();
        break;
      case "selectedItemKeys":
      case "selectedItems":
        this._buttonsCollection.option(t.name, t.value);
        break;
      case "onItemClick":
        this._createItemClickAction();
        break;
      case "onSelectionChanged":
        break;
      case "width":
        this.callBase(t), this._buttonsCollection.itemElements().toggleClass(T3, !!t.value);
        break;
      default:
        this.callBase(t);
    }
  }
});
ti("dxButtonGroup", K9);
var I3 = "dx-dropdownbutton", pFe = "dx-dropdownbutton-content", D3 = "dx-dropdownbutton-action", A3 = "dx-dropdownbutton-toggle", vFe = "dx-dropdownbutton-has-arrow", gFe = "dx-dropdownbutton-popup-wrapper", mFe = "dx-dropdowneditor-overlay", _Fe = "dx-button", CFe = "dx-button-text", yFe = "dx-icon-right", xFe = xn.inherit({
  _getDefaultOptions() {
    return P(this.callBase(), {
      itemTemplate: "item",
      keyExpr: "this",
      displayExpr: void 0,
      selectedItem: null,
      selectedItemKey: null,
      stylingMode: "outlined",
      deferRendering: !0,
      noDataText: X.format("dxCollectionWidget-noDataText"),
      useSelectMode: !1,
      splitButton: !1,
      showArrowIcon: !0,
      text: "",
      type: "normal",
      icon: void 0,
      onButtonClick: null,
      onSelectionChanged: null,
      onItemClick: null,
      opened: !1,
      items: null,
      dataSource: null,
      focusStateEnabled: !0,
      hoverStateEnabled: !0,
      dropDownOptions: {},
      dropDownContentTemplate: "content",
      wrapItemText: !1,
      useItemTextAsTitle: !0,
      grouped: !1,
      groupTemplate: "group",
      buttonGroupOptions: {}
    });
  },
  _setOptionsByReference() {
    this.callBase(), P(this._optionsByReference, {
      selectedItem: !0
    });
  },
  _init() {
    this.callBase(), this._createItemClickAction(), this._createActionClickAction(), this._createSelectionChangedAction(), this._initDataSource(), this._compileKeyGetter(), this._compileDisplayGetter(), this._itemsToDataSource(this.option("items")), this._options.cache("buttonGroupOptions", this.option("buttonGroupOptions")), this._options.cache("dropDownOptions", this.option("dropDownOptions"));
  },
  _initTemplates() {
    this._templateManager.addDefaultTemplates({
      content: new Lm((t) => {
        var e = E(t.container), i = E("<div>").appendTo(e);
        this._list = this._createComponent(i, Gm, this._listOptions()), this._list.registerKeyHandler("escape", this._escHandler.bind(this)), this._list.registerKeyHandler("tab", this._escHandler.bind(this)), this._list.registerKeyHandler("leftArrow", this._escHandler.bind(this)), this._list.registerKeyHandler("rightArrow", this._escHandler.bind(this));
      })
    }), this.callBase();
  },
  _itemsToDataSource: function(t) {
    this._dataSource || (this._dataSource = new Ks({
      store: new mS({
        key: this._getKey(),
        data: t
      }),
      pageSize: 0
    }));
  },
  _getKey: function() {
    var t, e = this.option("keyExpr"), i = (t = this._dataSource) === null || t === void 0 ? void 0 : t.key();
    return R(i) && (!R(e) || e === "this") ? i : e;
  },
  _compileKeyGetter() {
    this._keyGetter = Ii(this._getKey());
  },
  _compileDisplayGetter() {
    this._displayGetter = Ii(this.option("displayExpr"));
  },
  _initMarkup() {
    this.callBase(), this.$element().addClass(I3), this._renderButtonGroup(), this._updateArrowClass(), R(this.option("selectedItemKey")) && this._loadSelectedItem().done(this._updateActionButton.bind(this));
  },
  _renderFocusTarget: ee,
  _render() {
    (!this.option("deferRendering") || this.option("opened")) && this._renderPopup(), this.callBase();
  },
  _renderContentImpl() {
    return this._popup && this._renderPopupContent(), this.callBase();
  },
  _loadSelectedItem() {
    var t;
    (t = this._loadSingleDeferred) === null || t === void 0 || t.reject();
    var e = new q();
    if (this._list && this._lastSelectedItemData !== void 0) {
      var i = this.option("useSelectMode") ? this._list.option("selectedItem") : this._lastSelectedItemData;
      return e.resolve(i);
    }
    this._lastSelectedItemData = void 0;
    var r = this.option("selectedItemKey");
    return this._loadSingle(this._getKey(), r).done(e.resolve).fail(() => {
      e.resolve(null);
    }), this._loadSingleDeferred = e, e.promise();
  },
  _createActionClickAction() {
    this._actionClickAction = this._createActionByOption("onButtonClick");
  },
  _createSelectionChangedAction() {
    this._selectionChangedAction = this._createActionByOption("onSelectionChanged");
  },
  _createItemClickAction() {
    this._itemClickAction = this._createActionByOption("onItemClick");
  },
  _fireSelectionChangedAction(t) {
    var {
      previousValue: e,
      value: i
    } = t;
    this._selectionChangedAction({
      item: i,
      previousItem: e
    });
  },
  _fireItemClickAction(t) {
    var {
      event: e,
      itemElement: i,
      itemData: r
    } = t;
    return this._itemClickAction({
      event: e,
      itemElement: i,
      itemData: this._actionItem || r
    });
  },
  _actionButtonConfig() {
    var {
      icon: t,
      text: e,
      type: i
    } = this.option();
    return {
      text: e,
      icon: t,
      type: i,
      elementAttr: {
        class: D3
      }
    };
  },
  _getButtonGroupItems() {
    var {
      splitButton: t,
      type: e
    } = this.option(), i = [];
    return i.push(this._actionButtonConfig()), t && i.push({
      icon: "spindown",
      type: e,
      elementAttr: {
        class: A3
      }
    }), i;
  },
  _buttonGroupItemClick(t) {
    var {
      event: e,
      itemData: i
    } = t, r = i.elementAttr.class === D3, n = i.elementAttr.class === A3;
    n ? this.toggle() : r && (this._actionClickAction({
      event: e,
      selectedItem: this.option("selectedItem")
    }), this.option("splitButton") || this.toggle());
  },
  _buttonGroupOptions() {
    var {
      splitButton: t,
      showArrowIcon: e,
      focusStateEnabled: i,
      hoverStateEnabled: r,
      stylingMode: n,
      accessKey: a,
      tabIndex: o
    } = this.option(), u = t || !e ? "content" : (c, p) => {
      var {
        text: v,
        icon: _
      } = c, y = ec(_), b = v ? E("<span>").text(v).addClass(CFe) : void 0, I = ec("spindown").addClass(yFe);
      E(p).append(y, b, I);
    };
    return P({
      items: this._getButtonGroupItems(),
      onItemClick: this._buttonGroupItemClick.bind(this),
      width: "100%",
      height: "100%",
      selectionMode: "none",
      onKeyboardHandled: (c) => this._keyboardHandler(c),
      buttonTemplate: u,
      focusStateEnabled: i,
      hoverStateEnabled: r,
      stylingMode: n,
      accessKey: a,
      tabIndex: o
    }, this._options.cache("buttonGroupOptions"));
  },
  _renderPopupContent() {
    var t = this._popup.$content(), e = this._getTemplateByOption("dropDownContentTemplate");
    return t.empty(), this._popupContentId = "dx-" + new yr(), this.setAria("id", this._popupContentId, t), e.render({
      container: ot(t),
      model: this.option("items") || this._dataSource
    });
  },
  _popupOptions() {
    var t = this.option("rtlEnabled") ? "right" : "left";
    return P({
      dragEnabled: !1,
      focusStateEnabled: !1,
      deferRendering: this.option("deferRendering"),
      hideOnOutsideClick: (e) => {
        var i = this.$element(), r = E(e.target).closest(".".concat(I3));
        return !r.is(i);
      },
      showTitle: !1,
      animation: {
        show: {
          type: "fade",
          duration: 0,
          from: 0,
          to: 1
        },
        hide: {
          type: "fade",
          duration: 400,
          from: 1,
          to: 0
        }
      },
      _ignoreFunctionValueDeprecation: !0,
      width: () => UT(this.$element()),
      height: "auto",
      shading: !1,
      position: {
        of: this.$element(),
        collision: "flipfit",
        my: t + " top",
        at: t + " bottom"
      },
      _wrapperClassExternal: mFe
    }, this._options.cache("dropDownOptions"), {
      visible: this.option("opened")
    });
  },
  _listOptions() {
    var t = this.option("selectedItemKey"), e = this.option("useSelectMode");
    return {
      selectionMode: e ? "single" : "none",
      wrapItemText: this.option("wrapItemText"),
      focusStateEnabled: this.option("focusStateEnabled"),
      hoverStateEnabled: this.option("hoverStateEnabled"),
      useItemTextAsTitle: this.option("useItemTextAsTitle"),
      onContentReady: () => this._fireContentReadyAction(),
      selectedItemKeys: R(t) && e ? [t] : [],
      grouped: this.option("grouped"),
      groupTemplate: this.option("groupTemplate"),
      keyExpr: this._getKey(),
      noDataText: this.option("noDataText"),
      displayExpr: this.option("displayExpr"),
      itemTemplate: this.option("itemTemplate"),
      items: this.option("items"),
      dataSource: this._dataSource,
      onItemClick: (i) => {
        this.option("useSelectMode") || (this._lastSelectedItemData = i.itemData), this.option("selectedItemKey", this._keyGetter(i.itemData));
        var r = this._fireItemClickAction(i);
        r !== !1 && (this.toggle(!1), this._buttonGroup.focus());
      }
    };
  },
  _upDownKeyHandler() {
    return this._popup && this._popup.option("visible") && this._list ? this._list.focus() : this.open(), !0;
  },
  _escHandler() {
    return this.close(), this._buttonGroup.focus(), !0;
  },
  _tabHandler() {
    return this.close(), !0;
  },
  _renderPopup() {
    var t = E("<div>");
    this.$element().append(t), this._popup = this._createComponent(t, Hu, this._popupOptions()), this._popup.$content().addClass(pFe), this._popup.$wrapper().addClass(gFe), this._popup.on("hiding", this._popupHidingHandler.bind(this)), this._popup.on("showing", this._popupShowingHandler.bind(this)), this._bindInnerWidgetOptions(this._popup, "dropDownOptions");
  },
  _popupHidingHandler() {
    this.option("opened", !1), this._updateAriaAttributes(!1);
  },
  _popupOptionChanged: function(t) {
    var e = xn.getOptionsFromContainer(t);
    this._setPopupOption(e);
    var i = Object.keys(e);
    (i.indexOf("width") !== -1 || i.indexOf("height") !== -1) && this._dimensionChanged();
  },
  _dimensionChanged: function() {
    var t = WB(this.option("dropDownOptions.width"));
    t === void 0 && this._setPopupOption("width", () => UT(this.$element()));
  },
  _setPopupOption: function(t, e) {
    this._setWidgetOption("_popup", arguments);
  },
  _popupShowingHandler() {
    this.option("opened", !0), this._updateAriaAttributes(!0);
  },
  _setElementAria(t) {
    var e = {
      owns: t ? this._popupContentId : void 0
    };
    this.setAria(e, this.$element());
  },
  _setButtonsAria(t) {
    var e = {
      expanded: t,
      haspopup: "listbox"
    }, i = {};
    this.option("text") || (i.label = "dropdownbutton"), this._getButtons().each((r, n) => {
      r === 0 ? this.setAria(ae({}, i, e), E(n)) : this.setAria(e, E(n));
    });
  },
  _updateAriaAttributes(t) {
    this._setElementAria(t), this._setButtonsAria(t);
  },
  _getButtons() {
    return this._buttonGroup.$element().find(".".concat(_Fe));
  },
  _renderButtonGroup() {
    var t = this._buttonGroup && this._buttonGroup.$element() || E("<div>");
    this._buttonGroup || this.$element().append(t), this._buttonGroup = this._createComponent(t, K9, this._buttonGroupOptions()), this._buttonGroup.registerKeyHandler("downArrow", this._upDownKeyHandler.bind(this)), this._buttonGroup.registerKeyHandler("tab", this._tabHandler.bind(this)), this._buttonGroup.registerKeyHandler("upArrow", this._upDownKeyHandler.bind(this)), this._buttonGroup.registerKeyHandler("escape", this._escHandler.bind(this)), this._bindInnerWidgetOptions(this._buttonGroup, "buttonGroupOptions"), this._updateAriaAttributes(this.option("opened"));
  },
  _updateArrowClass() {
    var t = this.option("splitButton") || this.option("showArrowIcon");
    this.$element().toggleClass(vFe, t);
  },
  toggle(t) {
    return this._popup || (this._renderPopup(), this._renderContent()), this._popup.toggle(t);
  },
  open() {
    return this.toggle(!0);
  },
  close() {
    return this.toggle(!1);
  },
  _setListOption(t, e) {
    this._list && this._list.option(t, e);
  },
  _getDisplayValue(t) {
    var e = !$t(t), i = e ? t : this._displayGetter(t);
    return $t(i) ? "" : String(cr(i, ""));
  },
  _updateActionButton(t) {
    this.option("useSelectMode") && this.option({
      text: this._getDisplayValue(t),
      icon: $t(t) ? t.icon : void 0
    }), this._setOptionWithoutOptionChange("selectedItem", t), this._setOptionWithoutOptionChange("selectedItemKey", this._keyGetter(t));
  },
  _clean() {
    this._list && this._list.$element().remove(), this._popup && this._popup.$element().remove();
  },
  _selectedItemKeyChanged(t) {
    this._setListOption("selectedItemKeys", this.option("useSelectMode") && R(t) ? [t] : []);
    var e = this.option("selectedItem");
    this._loadSelectedItem().done((i) => {
      this._updateActionButton(i), this._displayGetter(e) !== this._displayGetter(i) && this._fireSelectionChangedAction({
        previousValue: e,
        value: i
      });
    });
  },
  _updateButtonGroup(t, e) {
    this._buttonGroup.option(t, e), this._updateAriaAttributes(this.option("opened"));
  },
  _actionButtonOptionChanged(t) {
    var {
      name: e,
      value: i
    } = t, r = {};
    r[e] = i, this._updateButtonGroup("items[0]", P({}, this._actionButtonConfig(), r)), this._popup && this._popup.repaint();
  },
  _selectModeChanged(t) {
    if (t) {
      this._setListOption("selectionMode", "single");
      var e = this.option("selectedItemKey");
      this._setListOption("selectedItemKeys", R(e) ? [e] : []), this._selectedItemKeyChanged(this.option("selectedItemKey"));
    } else
      this._setListOption("selectionMode", "none"), this.option({
        selectedItemKey: void 0,
        selectedItem: void 0
      }), this._actionButtonOptionChanged({
        text: this.option("text")
      });
  },
  _updateItemCollection(t) {
    var e = this.option("selectedItemKey");
    this._setListOption("selectedItem", null), this._setWidgetOption("_list", [t]), R(e) && this._loadSelectedItem().done((i) => {
      this._setListOption("selectedItemKeys", [e]), this._setListOption("selectedItem", i);
    }).fail((i) => {
      this._setListOption("selectedItemKeys", []);
    }).always(this._updateActionButton.bind(this));
  },
  _updateDataSource: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._dataSource.items();
    this._dataSource = void 0, this._itemsToDataSource(t), this._updateKeyExpr();
  },
  _updateKeyExpr: function() {
    this._compileKeyGetter(), this._setListOption("keyExpr", this._getKey());
  },
  focus: function() {
    this._buttonGroup.focus();
  },
  _optionChanged(t) {
    var e, {
      name: i,
      value: r
    } = t;
    switch (i) {
      case "useSelectMode":
        this._selectModeChanged(r);
        break;
      case "splitButton":
        this._updateArrowClass(), this._renderButtonGroup();
        break;
      case "displayExpr":
        this._compileDisplayGetter(), this._setListOption(i, r), this._updateActionButton(this.option("selectedItem"));
        break;
      case "keyExpr":
        this._updateDataSource();
        break;
      case "buttonGroupOptions":
        this._innerWidgetOptionChanged(this._buttonGroup, t);
        break;
      case "dropDownOptions":
        if (t.fullName === "dropDownOptions.visible")
          break;
        t.value.visible !== void 0 && delete t.value.visible, this._popupOptionChanged(t), this._innerWidgetOptionChanged(this._popup, t);
        break;
      case "opened":
        this.toggle(r);
        break;
      case "focusStateEnabled":
      case "hoverStateEnabled":
        this._setListOption(i, r), this._updateButtonGroup(i, r), this.callBase(t);
        break;
      case "items":
        this._updateDataSource(this.option("items")), this._updateItemCollection(i);
        break;
      case "dataSource":
        Array.isArray(r) ? this._updateDataSource(this.option("dataSource")) : (this._initDataSource(), this._updateKeyExpr()), this._updateItemCollection(i);
        break;
      case "icon":
      case "text":
        this._actionButtonOptionChanged(t);
        break;
      case "showArrowIcon":
        this._updateArrowClass(), this._renderButtonGroup(), this._popup && this._popup.repaint();
        break;
      case "width":
      case "height":
        this.callBase(t), (e = this._popup) === null || e === void 0 || e.repaint();
        break;
      case "stylingMode":
        this._updateButtonGroup(i, r);
        break;
      case "type":
        this._updateButtonGroup("items", this._getButtonGroupItems());
        break;
      case "itemTemplate":
      case "grouped":
      case "noDataText":
      case "groupTemplate":
      case "wrapItemText":
      case "useItemTextAsTitle":
        this._setListOption(i, r);
        break;
      case "dropDownContentTemplate":
        this._renderContent();
        break;
      case "selectedItemKey":
        this._selectedItemKeyChanged(r);
        break;
      case "selectedItem":
        break;
      case "onItemClick":
        this._createItemClickAction();
        break;
      case "onButtonClick":
        this._createActionClickAction();
        break;
      case "onSelectionChanged":
        this._createSelectionChangedAction();
        break;
      case "deferRendering":
        this.toggle(this.option("opened"));
        break;
      case "tabIndex":
        this._updateButtonGroup(i, r);
        break;
      default:
        this.callBase(t);
    }
  }
}).include(wB);
ti("dxDropDownButton", xFe);
function SFe(t, e) {
  for (var i = (v) => v || 1, r = [], n = (t[0] || []).reduce((v, _) => v + i(_.colspan), 0), a = /* @__PURE__ */ ((v) => {
    var _ = 0, y = 0;
    return () => {
      var b = v[_] || [], I = b[y++];
      return y >= b.length && (_++, y = 0), I && (I.colspan = i(I.colspan), I.rowspan = i(I.rowspan)), I;
    };
  })(t), o = (v, _, y) => {
    var b = r[v] = r[v] || [];
    if (b[_] = y, y.colspan > 1 || y.rowspan > 1) {
      for (var I = (($) => P({}, $, e))(y), A = 1; A < y.colspan; A++)
        o(v, _ + A, I);
      for (var L = 1; L < y.rowspan; L++)
        for (var B = 0; B < y.colspan; B++)
          o(v + L, _ + B, I);
    }
  }, u = a(), c = 0; u; ) {
    for (var p = 0; p < n && u; p++)
      r[c] && r[c][p] || (o(c, p, u), p += u.colspan - 1, u = a());
    c++;
  }
  return r;
}
var EFe = "dx-datagrid-export-menu", O3 = "dx-datagrid-export-button", bFe = "exportButton", R3 = "export", wFe = "xlsxfile", TFe = "exportselected", IFe = "pdffile";
class DFe {
  constructor(e, i, r) {
    this._exportController = e, this._initialColumnWidthsByColumnIndex = i, this._selectedRowsOnly = r;
  }
  _getGroupValue(e) {
    var {
      key: i,
      data: r,
      rowType: n,
      groupIndex: a,
      summaryCells: o
    } = e, u = this._options.groupColumns[a], c = et.getDisplayValue(u, u.deserializeValue ? u.deserializeValue(i[a]) : i[a], r, n), p = "".concat(u.caption, ": ").concat(et.formatValue(c, u));
    return o && o[0] && o[0].length && (p += " ".concat(et.getGroupRowSummaryText(o[0], this._options.summaryTexts))), p;
  }
  _correctCellIndex(e) {
    return e;
  }
  _initOptions() {
    var e = this._exportController, i = e._columnsController.getGroupColumns();
    this._options = {
      columns: e._getColumns(this._initialColumnWidthsByColumnIndex),
      groupColumns: i,
      items: this._selectedRowsOnly || e._selectionOnly ? e._getSelectedItems() : e._getAllItems(),
      isHeadersVisible: e.option("showColumnHeaders"),
      summaryTexts: e.option("summary.texts"),
      rtlEnabled: e.option("rtlEnabled")
    };
  }
  getHeaderStyles() {
    return [{
      bold: !0,
      alignment: "center"
    }, {
      bold: !0,
      alignment: "left"
    }, {
      bold: !0,
      alignment: "right"
    }];
  }
  getGroupRowStyle() {
    return {
      bold: !0,
      alignment: Nh(this._options.rtlEnabled)
    };
  }
  getColumnStyles() {
    var e = [];
    return this.getColumns().forEach((i) => {
      e.push({
        alignment: i.alignment || "left",
        format: i.format,
        dataType: i.dataType
      });
    }), e;
  }
  getStyles() {
    return [...this.getHeaderStyles(), ...this.getColumnStyles(), this.getGroupRowStyle()];
  }
  _getTotalCellStyleId(e) {
    var i, r = ((i = this.getColumns()[e]) === null || i === void 0 ? void 0 : i.alignment) || "right";
    return this.getHeaderStyles().map((n) => n.alignment).indexOf(r);
  }
  getStyleId(e, i) {
    return e < this.getHeaderRowCount() ? 0 : this.isTotalCell(e - this.getHeaderRowCount(), i) ? this._getTotalCellStyleId(i) : this.isGroupRow(e - this.getHeaderRowCount()) ? this.getHeaderStyles().length + this.getColumns().length : i + this.getHeaderStyles().length;
  }
  getColumns(e) {
    var {
      columns: i
    } = this._options;
    return e ? i : i[i.length - 1];
  }
  getColumnsWidths() {
    var e = this.getColumns();
    return R(e) ? e.map((i) => i.width) : void 0;
  }
  getRowsCount() {
    return this._options.items.length + this.getHeaderRowCount();
  }
  getHeaderRowCount() {
    return this.isHeadersVisible() ? this._options.columns.length - 1 : 0;
  }
  isGroupRow(e) {
    return e < this._options.items.length && this._options.items[e].rowType === "group";
  }
  getGroupLevel(e) {
    var i = this._options.items[e - this.getHeaderRowCount()], r = i && i.groupIndex;
    return i && i.rowType === "totalFooter" ? 0 : R(r) ? r : this._options.groupColumns.length;
  }
  getCellType(e, i) {
    var r = this.getColumns();
    if (e < this.getHeaderRowCount())
      return "string";
    if (e -= this.getHeaderRowCount(), i < r.length) {
      var n = this._options.items.length && this._options.items[e], a = r[i];
      return n && n.rowType === "data" && isFinite(n.values[this._correctCellIndex(i)]) && !R(a.customizeText) ? R(a.lookup) ? a.lookup.dataType : a.dataType : "string";
    }
  }
  ready() {
    this._initOptions();
    var e = this._options;
    return $e(e.items).done((i) => {
      e.items = i;
    }).fail(() => {
      e.items = [];
    });
  }
  _convertFromGridGroupSummaryItems(e) {
    if (R(e) && e.length > 0)
      return e.map((i) => ({
        value: i.value,
        name: i.name
      }));
  }
  getCellData(e, i, r) {
    var n, a, o = {
      cellSourceData: {},
      value: n
    }, u = this.getColumns(), c = this._correctCellIndex(i);
    if (e < this.getHeaderRowCount()) {
      var p = this.getColumns(!0)[e];
      a = p[i], o.cellSourceData.rowType = "header", o.cellSourceData.column = a && a.gridColumn, o.value = a && a.caption;
    } else {
      e -= this.getHeaderRowCount();
      var v = this._options.items.length && this._options.items[e];
      if (v) {
        var _ = v.values;
        switch (o.cellSourceData.rowType = v.rowType, o.cellSourceData.column = u[i] && u[i].gridColumn, v.rowType) {
          case "groupFooter":
          case "totalFooter":
            c < _.length && (n = _[c], R(n) ? (o.cellSourceData.value = n.value, o.cellSourceData.totalSummaryItemName = n.name, o.value = et.getSummaryText(n, this._options.summaryTexts)) : o.cellSourceData.value = void 0);
            break;
          case "group":
            if (o.cellSourceData.groupIndex = v.groupIndex, i < 1)
              o.cellSourceData.column = this._options.groupColumns[v.groupIndex], o.cellSourceData.value = v.key[v.groupIndex], o.cellSourceData.groupSummaryItems = this._convertFromGridGroupSummaryItems(v.summaryCells[0]), o.value = this._getGroupValue(v);
            else {
              var y = v.values[c];
              if (Array.isArray(y)) {
                o.cellSourceData.groupSummaryItems = this._convertFromGridGroupSummaryItems(y), n = "";
                for (var b = 0; b < y.length; b++)
                  n += (b > 0 ? r ? `
` : ` 
 ` : "") + et.getSummaryText(y[b], this._options.summaryTexts);
                o.value = n;
              } else
                o.cellSourceData.value = void 0;
            }
            break;
          default:
            if (a = u[i], a) {
              var I = _[c], A = et.getDisplayValue(a, I, v.data, v.rowType);
              !isFinite(A) || R(a.customizeText) ? r && R(a.customizeText) && a.customizeText === this._exportController._columnsController.getCustomizeTextByDataType("boolean") ? o.value = A : o.value = et.formatValue(A, a) : o.value = A, o.cellSourceData.value = I;
            }
            o.cellSourceData.data = v.data;
        }
      }
    }
    return o;
  }
  isHeadersVisible() {
    return this._options.isHeadersVisible;
  }
  isTotalCell(e, i) {
    var {
      items: r
    } = this._options, n = r[e], a = this._correctCellIndex(i), o = n.summaryCells && n.summaryCells[a] && n.summaryCells[a].length > 0 && n.summaryCells[a][0].alignByColumn;
    return n && n.rowType === "groupFooter" || n.rowType === "totalFooter" || o;
  }
  getCellMerging(e, i) {
    var {
      columns: r
    } = this._options, n = r[e] && r[e][i];
    return n ? {
      colspan: (n.exportColspan || 1) - 1,
      rowspan: (n.rowspan || 1) - 1
    } : {
      colspan: 0,
      rowspan: 0
    };
  }
  getFrozenArea() {
    return {
      x: 0,
      y: this.getHeaderRowCount()
    };
  }
}
class AFe extends et.ViewController {
  _getEmptyCell() {
    return {
      caption: "",
      colspan: 1,
      rowspan: 1
    };
  }
  _updateColumnWidth(e, i) {
    e.width = i;
  }
  _getColumns(e) {
    var i = [], r, n, a = this._columnsController, o = a.getRowCount();
    for (r = 0; r <= o; r++) {
      var u = [];
      n = a.getVisibleColumns(r, !0);
      var c = void 0;
      if (r === o)
        if (this._updateLockCount)
          c = e;
        else {
          var p = this._getColumnWidths(this._headersView, this._rowsView);
          if (p && p.length) {
            c = {};
            for (var v = 0; v < n.length; v++)
              c[n[v].index] = p[v];
          }
        }
      for (var _ = 0; _ < n.length; _++) {
        var y = P({}, n[_], {
          dataType: n[_].dataType === "datetime" ? "date" : n[_].dataType,
          gridColumn: n[_]
        });
        if (this._needColumnExporting(y)) {
          var b = this._calculateExportColspan(y);
          R(b) && (y.exportColspan = b), c && this._updateColumnWidth(y, c[y.index]), u.push(y);
        }
      }
      i.push(u);
    }
    return n = i[o], i = SFe(i.slice(0, -1), this._getEmptyCell()), i.push(n), i;
  }
  _calculateExportColspan(e) {
    if (e.isBand) {
      var i = this._columnsController.getChildrenByBandColumn(e.index, !0);
      if (R(i))
        return i.reduce((r, n) => this._needColumnExporting(n) ? r + (this._calculateExportColspan(n) || 1) : r, 0);
    }
  }
  _needColumnExporting(e) {
    return !e.command && (e.allowExporting || e.allowExporting === void 0);
  }
  _getFooterSummaryItems(e, i) {
    var r = [], n = 1, a = 0;
    do {
      for (var o = [], u = 0; u < e.length; u++) {
        var c = e[u], p = c.length;
        n < p && (n = p), o.push(c[a]);
      }
      r.push({
        values: o,
        rowType: i ? "totalFooter" : "groupFooter"
      });
    } while (a++ < n - 1);
    return r;
  }
  _hasSummaryGroupFooters() {
    var e = this.option("summary.groupItems");
    if (R(e)) {
      for (var i = 0; i < e.length; i++)
        if (e[i].showInGroupFooter)
          return !0;
    }
    return !1;
  }
  _getItemsWithSummaryGroupFooters(e) {
    for (var i = [], r = [], n = [], a = 0; a < e.length; a++) {
      var o = e[a];
      o.rowType === "groupFooter" ? (n = this._getFooterSummaryItems(o.summaryCells), i = i.concat(r, n), r = []) : r.push(o);
    }
    return i.length ? i : r;
  }
  _updateGroupValuesWithSummaryByColumn(e) {
    for (var i = [], r = 0; r < e.length; r++) {
      var n = e[r], {
        summaryCells: a
      } = n;
      if (n.rowType === "group" && a && a.length > 1) {
        for (var o = n.values.length, u = 1; u < a.length; u++)
          for (var c = 0; c < a[u].length; c++) {
            var p = a[u][c];
            p && p.alignByColumn && (Array.isArray(i[u - o]) || (i[u - o] = []), i[u - o].push(p));
          }
        i.length > 0 && (n.values.push(...i), i = []);
      }
    }
  }
  _processUnExportedItems(e) {
    for (var i = this._columnsController.getVisibleColumns(null, !0), r = this._columnsController.getGroupColumns(), n, a, o = 0; o < e.length; o++) {
      var u = e[o], c = !1;
      n = [], a = [];
      for (var p = 0; p < i.length; p++) {
        var v = i[p];
        if (c || (c = ["detailExpand", "buttons"].includes(v.type)), this._needColumnExporting(v) && (u.values && (u.rowType === "group" && !n.length ? n.push(u.key[u.groupIndex]) : n.push(u.values[p])), u.summaryCells))
          if (u.rowType === "group" && !a.length) {
            var _ = p - r.length + u.groupIndex;
            a.push(u.summaryCells[c ? _ : _ + 1]);
          } else
            a.push(u.summaryCells[p]);
      }
      n.length && (u.values = n), a.length && (u.summaryCells = a);
    }
  }
  _getAllItems(e) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = this, n = new q(), a = this.getController("data"), o = a.footerItems(), u = o.length && o[0], c = r.option("summary.totalItems"), p;
    return $e(e).done((v) => {
      a.loadAll(v, i).done((_, y) => {
        r._updateGroupValuesWithSummaryByColumn(_), r._hasSummaryGroupFooters() && (_ = r._getItemsWithSummaryGroupFooters(_)), p = u && u.summaryCells, R(y) && c && (p = r._getSummaryCells(c, y));
        var b = u && r._getFooterSummaryItems(p, !0);
        b && (_ = _.concat(b)), r._processUnExportedItems(_), n.resolve(_);
      }).fail(n.reject);
    }).fail(n.reject), n;
  }
  _getSummaryCells(e, i) {
    var r = this.getController("data"), n = r._columnsController;
    return r._calculateSummaryCells(e, i, n.getVisibleColumns(null, !0), (a, o) => r._isDataColumn(o) ? o.index : -1);
  }
  _getSelectedItems() {
    var e = this.getController("selection");
    return this.needLoadItemsOnExportingSelectedItems() ? this._getAllItems(e.loadSelectedItemsWithFilter(), !0) : this._getAllItems(e.getSelectedRowsData());
  }
  _getColumnWidths(e, i) {
    return e && e.isVisible() ? e.getColumnWidths() : i.getColumnWidths();
  }
  throwWarningIfNoOnExportingEvent() {
    var e, i, r = (i = (e = this.component).hasActionSubscription) === null || i === void 0 ? void 0 : i.call(e, "onExporting");
    this.option("export.enabled") && !r && Yt.log("W1024");
  }
  init() {
    this.throwWarningIfNoOnExportingEvent(), this._columnsController = this.getController("columns"), this._rowsView = this.getView("rowsView"), this._headersView = this.getView("columnHeadersView"), this.createAction("onExporting", {
      excludeValidators: ["disabled", "readOnly"]
    });
  }
  callbackNames() {
    return ["selectionOnlyChanged"];
  }
  getDataProvider(e) {
    var i = this._getColumnWidths(this._headersView, this._rowsView), r;
    if (i && i.length) {
      r = {};
      for (var n = this._columnsController.getVisibleColumns(this._columnsController.getRowCount(), !0), a = 0; a < n.length; a++)
        r[n[a].index] = i[a];
    }
    return new DFe(this, r, e);
  }
  exportTo(e, i) {
    this._selectionOnly = e;
    var r = this.getAction("onExporting"), n = {
      rtlEnabled: this.option("rtlEnabled"),
      selectedRowsOnly: !!e,
      format: i,
      fileName: "DataGrid",
      cancel: !1
    };
    Le(r) && r(n);
  }
  publicMethods() {
    return ["getDataProvider"];
  }
  selectionOnly(e) {
    if (R(e))
      this._isSelectedRows = e, this.selectionOnlyChanged.fire();
    else
      return this._isSelectedRows;
  }
  optionChanged(e) {
    super.optionChanged(e), e.name === "export" && this.throwWarningIfNoOnExportingEvent();
  }
  needLoadItemsOnExportingSelectedItems() {
    var e;
    return (e = this.option("loadItemsOnExportingSelectedItems")) !== null && e !== void 0 ? e : this.getController("data")._dataSource.remoteOperations().filtering;
  }
}
var OFe = (t) => class extends t {
  callbackNames() {
    var e = super.callbackNames();
    return R(e) ? e.push("editingButtonsUpdated") : ["editingButtonsUpdated"];
  }
  _updateEditButtons() {
    super._updateEditButtons(), this.editingButtonsUpdated.fire();
  }
}, RFe = (t) => class extends t {
  _getToolbarItems() {
    var e = super._getToolbarItems(), i = this._getExportToolbarButton();
    return i && (e.push(i), this._correctItemsPosition(e)), e;
  }
  _getExportToolbarButton() {
    var e = this._getExportToolbarItems();
    if (e.length === 0)
      return null;
    var i = this._needDisableExportButton(), r = {
      name: bFe,
      location: "after",
      locateInMenu: "auto",
      sortIndex: 30,
      options: {
        items: e
      },
      disabled: i
    };
    if (e.length === 1) {
      var n = ae(ae({}, e[0]), {
        hint: e[0].text,
        elementAttr: {
          class: O3
        }
      });
      r.widget = "dxButton", r.showText = "inMenu", r.options = n;
    } else {
      var a = {
        icon: R3,
        displayExpr: "text",
        items: e,
        hint: this.option("export.texts.exportTo"),
        elementAttr: {
          class: O3
        },
        dropDownOptions: {
          width: "auto",
          _wrapperClassExternal: EFe
        }
      };
      r.options = a, r.widget = "dxDropDownButton", r.menuItemTemplate = (o, u, c) => {
        this._createComponent(E(c), Gm, {
          items: e
        });
      };
    }
    return r;
  }
  _getExportToolbarItems() {
    var e, i = this.option("export"), r = this.option("export.texts"), n = (e = this.option("export.formats")) !== null && e !== void 0 ? e : [];
    if (!i.enabled)
      return [];
    var a = [];
    return n.forEach((o) => {
      var u = o.toUpperCase(), c = R3, p = TFe;
      o === "xlsx" && (u = "Excel", c = wFe), o === "pdf" && (c = IFe), a.push({
        text: Mu(r.exportAll, u),
        icon: c,
        onClick: () => {
          this._exportController.exportTo(!1, o);
        }
      }), i.allowExportSelectedData && a.push({
        text: Mu(r.exportSelectedRows, u),
        icon: p,
        onClick: () => {
          this._exportController.exportTo(!0, o);
        }
      });
    }), a;
  }
  _correctItemsPosition(e) {
    e.sort((i, r) => i.sortIndex - r.sortIndex);
  }
  _isExportButtonVisible() {
    return this.option("export.enabled");
  }
  optionChanged(e) {
    super.optionChanged(e), e.name === "export" && (e.handled = !0, this._invalidate());
  }
  _needDisableExportButton() {
    var e = !this._columnsController.hasVisibleDataColumns(), i = this._editingController.hasChanges();
    return e || i;
  }
  _columnOptionChanged(e) {
    super._columnOptionChanged(e);
    var i = et.checkChanges(e.optionNames, ["groupIndex", "visible", "all"]);
    if (i) {
      var r = this._needDisableExportButton();
      this.setToolbarItemDisabled("exportButton", r);
    }
  }
  init() {
    super.init(), this._exportController = this.getController("export"), this._editingController = this.getController("editing"), this._editingController.editingButtonsUpdated.add(() => {
      var e = this._needDisableExportButton();
      this.setToolbarItemDisabled("exportButton", e);
    });
  }
  isVisible() {
    return super.isVisible() || this._isExportButtonVisible();
  }
};
et.registerModule("export", {
  defaultOptions: () => ({
    export: {
      enabled: !1,
      fileName: "DataGrid",
      formats: ["xlsx"],
      allowExportSelectedData: !1,
      texts: {
        exportTo: X.format("dxDataGrid-exportTo"),
        exportAll: X.format("dxDataGrid-exportAll"),
        exportSelectedRows: X.format("dxDataGrid-exportSelectedRows")
      }
    }
  }),
  controllers: {
    export: AFe
  },
  extenders: {
    controllers: {
      editing: OFe
    },
    views: {
      headerPanel: RFe
    }
  }
});
var LFe = (t, e, i) => {
  var {
    isRemoteFiltering: r,
    dateSerializationFormat: n,
    getSelector: a
  } = i, {
    selector: o
  } = t, u = Le(o) ? o : a(o), c = u ? u(e) : e[o], p = r && zo(c) ? $r.serializeDate(c, n) : c;
  return {
    getter: u,
    rawValue: c,
    safeValue: p
  };
}, MFe = {
  getSortFilterValue: LFe
}, jx = "dx-row-focused", kFe = ".dx-row.".concat(jx), PFe = "table", L3 = "dx-cell-focus-disabled";
class FFe extends Bi.ViewController {
  get _keyboardController() {
    return this.getController("keyboardNavigation");
  }
  get _dataController() {
    return this.getController("data");
  }
  init() {
    this.component._optionsByReference.focusedRowKey = !0;
  }
  optionChanged(e) {
    var {
      name: i,
      value: r,
      previousValue: n
    } = e;
    switch (i) {
      case "focusedRowIndex":
        this._focusRowByIndex(r), this._keyboardController._fireFocusedRowChanged(), e.handled = !0;
        break;
      case "focusedRowKey":
        if (Array.isArray(r) && JSON.stringify(r) === JSON.stringify(n))
          return;
        this._focusRowByKey(r), this._keyboardController._fireFocusedRowChanged(), e.handled = !0;
        break;
      case "focusedColumnIndex":
      case "focusedRowEnabled":
      case "autoNavigateToFocusedRow":
        e.handled = !0;
        break;
      default:
        super.optionChanged(e);
    }
  }
  publicMethods() {
    return ["navigateToRow", "isRowFocused"];
  }
  isAutoNavigateToFocusedRow() {
    return this.option("scrolling.mode") !== "infinite" && this.option("autoNavigateToFocusedRow");
  }
  _focusRowByIndex(e, i) {
    this.option("focusedRowEnabled") && (e = e !== void 0 ? e : this.option("focusedRowIndex"), e < 0 ? this.isAutoNavigateToFocusedRow() && this._resetFocusedRow() : this._focusRowByIndexCore(e, i));
  }
  _focusRowByIndexCore(e, i) {
    var r = this._dataController.pageSize(), n = () => {
      if (this._isValidFocusedRowIndex(e)) {
        var o = e - this._dataController.getRowIndexOffset(!0);
        if (!i || i.paging && !i.filtering) {
          var u = this._dataController._getLastItemIndex();
          o = Math.min(o, u);
        }
        var c = this._dataController.getKeyByRowIndex(o, !0);
        R(c) && !this.isRowFocused(c) && this.option("focusedRowKey", c);
      }
    };
    if (r >= 0)
      if (this._isLocalRowIndex(e))
        n();
      else {
        var a = Math.floor(e / this._dataController.pageSize());
        $e(this._dataController.pageIndex(a), this._dataController.waitReady()).done(() => {
          n();
        });
      }
  }
  _isLocalRowIndex(e) {
    var i = this._keyboardController._isVirtualScrolling();
    if (i) {
      var r = Math.floor(e / this._dataController.pageSize()), n = this._dataController.virtualItemsCount(), a = n ? n.begin : -1, o = this._dataController.getVisibleRows().length + this._dataController.getRowIndexOffset(), u = Math.ceil(o / this._dataController.pageSize());
      return a <= e && u > r;
    }
    return !0;
  }
  _setFocusedRowKeyByIndex(e) {
    if (this._isValidFocusedRowIndex(e)) {
      var i = Math.min(e - this._dataController.getRowIndexOffset(), this._dataController.items().length - 1), r = this._dataController.getKeyByRowIndex(i);
      R(r) && !this.isRowFocused(r) && this.option("focusedRowKey", r);
    }
  }
  _focusRowByKey(e) {
    R(e) ? this._navigateToRow(e, !0) : this._resetFocusedRow();
  }
  _resetFocusedRow() {
    var e = this.option("focusedRowKey"), i = R(e);
    !i && this.option("focusedRowIndex") < 0 || (i && this.option("focusedRowKey", null), this._keyboardController.setFocusedRowIndex(-1), this.option("focusedRowIndex", -1), this._dataController.updateItems({
      changeType: "updateFocusedRow",
      focusedRowKey: null
    }), this._keyboardController._fireFocusedRowChanged());
  }
  _isValidFocusedRowIndex(e) {
    var i = this._dataController.getVisibleRows()[e];
    return !i || i.rowType === "data" || i.rowType === "group";
  }
  navigateToRow(e) {
    return this.isAutoNavigateToFocusedRow() || this.option("focusedRowIndex", -1), this._navigateToRow(e);
  }
  _navigateToRow(e, i) {
    var r = this, n = r.isAutoNavigateToFocusedRow(), a = new q();
    if (e === void 0 || !this._dataController.dataSource())
      return a.reject().promise();
    var o = r.getFocusedRowIndexByKey(e);
    return !n && i || o >= 0 ? r._navigateTo(e, a, i) : this._dataController.getPageIndexByKey(e).done((u) => {
      if (u < 0) {
        a.resolve(-1);
        return;
      }
      u === this._dataController.pageIndex() ? this._dataController.reload().done(() => {
        r.isRowFocused(e) && this._dataController.getRowIndexByKey(e) >= 0 ? a.resolve(r.getFocusedRowIndexByKey(e)) : r._navigateTo(e, a, i);
      }).fail(a.reject) : this._dataController.pageIndex(u).done(() => {
        r._navigateTo(e, a, i);
      }).fail(a.reject);
    }).fail(a.reject), a.promise();
  }
  _navigateTo(e, i, r) {
    var n = this._dataController.getRowIndexByKey(e), a = xe.isVirtualRowRendering(this), o = this.isAutoNavigateToFocusedRow();
    o && a && n < 0 ? this._navigateToVirtualRow(e, i, r) : this._navigateToVisibleRow(e, i, r);
  }
  _navigateToVisibleRow(e, i, r) {
    if (r)
      this._triggerUpdateFocusedRow(e, i);
    else {
      var n = this.getFocusedRowIndexByKey(e);
      this.getView("rowsView").scrollToRowElement(e, i).done(() => {
        i.resolve(n);
      });
    }
  }
  _navigateToVirtualRow(e, i, r) {
    var n = this._dataController._rowsScrollController, a = xe.getIndexByKey(e, this._dataController.items(!0)), o = this.getView("rowsView").getScrollable();
    if (n && o && a >= 0) {
      var u = a + this._dataController.getRowIndexOffset(!0), c = n.getItemOffset(u), p = () => {
        this._dataController.totalCount() && !this._dataController.items().length || (this.component.off("contentReady", p), r ? this._triggerUpdateFocusedRow(e, i) : i.resolve(u));
      };
      this.component.on("contentReady", p), this.getView("rowsView").scrollTopPosition(c);
    } else
      i.resolve(-1);
  }
  _triggerUpdateFocusedRow(e, i) {
    var r = this.getFocusedRowIndexByKey(e);
    if (this._isValidFocusedRowIndex(r)) {
      var n;
      this.option("focusedRowEnabled") ? this._dataController.updateItems({
        changeType: "updateFocusedRow",
        focusedRowKey: e
      }) : n = this.getView("rowsView").scrollToRowElement(e), $e(n).done(() => {
        this._keyboardController.setFocusedRowIndex(r), i && i.resolve(r);
      });
    } else
      i && i.resolve(-1);
  }
  getFocusedRowIndexByKey(e) {
    var i = this._dataController.getRowIndexByKey(e, !0);
    return i >= 0 ? i + this._dataController.getRowIndexOffset(!0) : -1;
  }
  _focusRowByKeyOrIndex() {
    var e = this.option("focusedRowKey"), i = this.option("focusedRowIndex");
    if (R(e)) {
      var r = this._dataController.getRowIndexByKey(e);
      r >= 0 ? (this._keyboardController._isVirtualScrolling() && (i = r + this._dataController.getRowIndexOffset()), this._keyboardController.setFocusedRowIndex(i), this._triggerUpdateFocusedRow(e)) : this._navigateToRow(e, !0).done((n) => {
        i >= 0 && n < 0 ? this._focusRowByIndex() : i < 0 && n >= 0 && this._keyboardController.setFocusedRowIndex(n);
      });
    } else
      i >= 0 && this._focusRowByIndex(i);
  }
  isRowFocused(e) {
    var i = this.option("focusedRowKey");
    if (R(i))
      return Mi(e, this.option("focusedRowKey"));
  }
  updateFocusedRow(e) {
    var {
      focusedRowKey: i
    } = e, r = this, n = r._dataController.getRowIndexByKey(i), a = r.getView("rowsView"), o, u;
    N(a.getTableElements(), (c, p) => {
      var v = c === 0;
      o = E(p), r._clearPreviousFocusedRow(o, n);
      var _ = r._prepareFocusedRow({
        changedItem: r._dataController.getVisibleRows()[n],
        $tableElement: o,
        focusedRowIndex: n
      });
      v && (u = _);
    }), u && a.scrollToElementVertically(u);
  }
  _clearPreviousFocusedRow(e, i) {
    var r = e.find(kFe).filter((a, o) => {
      var u = E(o).closest(".".concat(this.addWidgetPrefix(PFe)));
      return e.is(u);
    });
    if (r.removeClass(jx).removeClass(L3).removeAttr("tabindex"), r.children("td").removeAttr("tabindex"), i !== 0) {
      var n = E(this.getView("rowsView").getRowElement(0));
      n.removeClass(L3).removeAttr("tabIndex");
    }
  }
  _prepareFocusedRow(e) {
    var i, {
      changedItem: r
    } = e;
    if (r && (r.rowType === "data" || r.rowType === "group")) {
      var {
        focusedRowIndex: n
      } = e, {
        $tableElement: a
      } = e, o = this.option("tabindex") || 0, u = this.getView("rowsView");
      i = E(u._getRowElements(a).eq(n)), i.addClass(jx).attr("tabindex", o);
    }
    return i;
  }
}
var BFe = (t) => class extends t {
  init() {
    var e = this.option("focusedRowIndex"), i = this.option("focusedColumnIndex");
    this.createAction("onFocusedRowChanging", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onFocusedRowChanged", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onFocusedCellChanging", {
      excludeValidators: ["disabled", "readOnly"]
    }), this.createAction("onFocusedCellChanged", {
      excludeValidators: ["disabled", "readOnly"]
    }), super.init(), this.setRowFocusType(), this._focusedCellPosition = {}, R(e) && e >= 0 && (this._focusedCellPosition.rowIndex = e), R(i) && i >= 0 && (this._focusedCellPosition.columnIndex = i);
  }
  setFocusedRowIndex(e) {
    super.setFocusedRowIndex(e), this.option("focusedRowIndex", e);
  }
  setFocusedColumnIndex(e) {
    super.setFocusedColumnIndex(e), this.option("focusedColumnIndex", e);
  }
  _escapeKeyHandler(e, i) {
    return i || !this.option("focusedRowEnabled") ? super._escapeKeyHandler(e, i) : this.isCellFocusType() ? (this.setRowFocusType(), this._focus(this._getCellElementFromTarget(e.originalEvent.target), !0), !0) : !1;
  }
  _updateFocusedCellPosition(e, i) {
    var r = super._updateFocusedCellPosition(e, i);
    return r && r.columnIndex >= 0 && this._fireFocusedCellChanged(e), r;
  }
}, VFe = (t) => class extends t {
  renderFocusOverlay(e, i) {
    var r, n = this.option("focusedRowEnabled"), a;
    if (!n || !(!((r = this._keyboardNavigationController) === null || r === void 0) && r.isRowFocusType()) || this._editingController.isEditing())
      super.renderFocusOverlay(e, i);
    else if (n) {
      var o = this._keyboardNavigationController._getElementType(e) === "row";
      o && !e.hasClass(jx) && (a = this._keyboardNavigationController.getFirstValidCellInRow(e), this._keyboardNavigationController.focus(a));
    }
  }
}, NFe = (t) => class extends t {
  getSortDataSourceParameters(e, i) {
    var r = super.getSortDataSourceParameters.apply(this, arguments), n = this._dataController._dataSource, a = this._dataController.store(), o = a && a.key(), u = n && n.remoteOperations() || {}, c = Object.keys(u).every((v) => !u[v]);
    if (o && (this.option("focusedRowEnabled") && this._focusController.isAutoNavigateToFocusedRow() !== !1 || i)) {
      o = Array.isArray(o) ? o : [o];
      var p = o.filter((v) => !this.columnOption(v, "sortOrder"));
      p.length && (r = r || [], c ? r.push({
        selector: n.getDataIndexGetter(),
        desc: !1
      }) : p.forEach((v) => r.push({
        selector: v,
        desc: !1
      })));
    }
    return r;
  }
}, HFe = (t) => class extends t {
  _applyChange(e) {
    if (!(e && e.changeType === "updateFocusedRow"))
      return super._applyChange.apply(this, arguments);
  }
  _fireChanged(e) {
    if (super._fireChanged(e), this.option("focusedRowEnabled") && this._dataSource) {
      var i = e.changeType === "update" && e.repaintChangesOnly, r = i && e.changeTypes && e.changeTypes.indexOf("remove") >= 0;
      e.changeType === "refresh" && e.items.length || r ? (this._updatePageIndexes(), this._updateFocusedRow(e)) : e.changeType === "append" || e.changeType === "prepend" ? this._updatePageIndexes() : e.changeType === "update" && e.repaintChangesOnly && this._updateFocusedRow(e);
    }
  }
  _updatePageIndexes() {
    var e = this._lastRenderingPageIndex || 0, i = this._rowsScrollController ? this._rowsScrollController.pageIndex() : 0;
    this._lastRenderingPageIndex = i, this._isPagingByRendering = i !== e;
  }
  isPagingByRendering() {
    return this._isPagingByRendering;
  }
  _updateFocusedRow(e) {
    var i = e.operationTypes || {}, {
      reload: r,
      fullReload: n,
      pageIndex: a,
      paging: o
    } = i, u = this._keyboardNavigationController._isVirtualScrolling(), c = o && !u, p = this.option("focusedRowKey"), v = this._focusController.isAutoNavigateToFocusedRow(), _ = r && a === !1;
    if (_ && !n && R(p))
      this._focusController._navigateToRow(p, !0).done((B) => {
        B < 0 && this._focusController._focusRowByIndex(void 0, i);
      });
    else if (c && v) {
      var y = this.getRowIndexByKey(p), b = this.option("focusedRowIndex"), I = y >= 0, A = b >= 0, L = b === y;
      A && (L || !I) && this._focusController._focusRowByIndex(b, i);
    } else
      c && !v && this.getRowIndexByKey(p) < 0 ? this.option("focusedRowIndex", -1) : i.fullReload && this._focusController._focusRowByKeyOrIndex();
  }
  getPageIndexByKey(e) {
    var i = this, r = new q();
    return i.getGlobalRowIndexByKey(e).done((n) => {
      r.resolve(n >= 0 ? Math.floor(n / i.pageSize()) : -1);
    }).fail(r.reject), r.promise();
  }
  getGlobalRowIndexByKey(e) {
    return this._dataSource.group() ? this._calculateGlobalRowIndexByGroupedData(e) : this._calculateGlobalRowIndexByFlatData(e);
  }
  _calculateGlobalRowIndexByFlatData(e, i, r) {
    var n = this, a = new q(), o = n._dataSource;
    if (Array.isArray(e) || VIe(e))
      return a.resolve(-1).promise();
    var u = n._generateFilterByKey(e);
    return o.load({
      filter: n._concatWithCombinedFilter(u),
      skip: 0,
      take: 1
    }).done((c) => {
      c.length > 0 ? (u = n._generateOperationFilterByKey(e, c[0], r), o.load({
        filter: n._concatWithCombinedFilter(u, i),
        skip: 0,
        take: 1,
        requireTotalCount: !0
      }).done((p, v) => {
        a.resolve(v.totalCount);
      })) : a.resolve(-1);
    }), a.promise();
  }
  _concatWithCombinedFilter(e, i) {
    var r = this.getCombinedFilter();
    return xe.combineFilters([e, r, i]);
  }
  _generateBooleanFilter(e, i, r) {
    var {
      desc: n
    } = r;
    switch (!0) {
      case (i === !1 && n):
        return [e, "=", !0];
      case (i === !1 && !n):
        return [e, "=", null];
      case (i === !0 && !n):
      case (!wx(i) && n):
        return [e, "<>", i];
      default:
        return;
    }
  }
  _generateOperationFilterByKey(e, i, r) {
    var n = this, a = n.option("dateSerializationFormat"), o = n._dataSource.remoteOperations().filtering, u = n._dataSource.remoteOperations().sorting, c = n._generateFilterByKey(e, "<"), p = n._columnsController.getSortDataSourceParameters(!o, !0);
    if (r) {
      var v = n._columnsController.getGroupDataSourceParameters(!o);
      v && (p = p ? v.concat(p) : v);
    }
    return p && p.slice().reverse().forEach((_) => {
      var {
        selector: y,
        desc: b,
        compare: I
      } = _, {
        getter: A,
        rawValue: L,
        safeValue: B
      } = MFe.getSortFilterValue(_, i, {
        isRemoteFiltering: o,
        dateSerializationFormat: a,
        getSelector: (z) => n._columnsController.columnOption(z, "selector")
      });
      if (c = [
        [y, "=", B],
        "and",
        c
      ], L === null || wx(L)) {
        var $ = n._generateBooleanFilter(y, B, b);
        $ && (c = [$, "or", c]);
      } else {
        var K = b ? ">" : "<", te;
        I && !u ? te = (z) => K === "<" ? I(L, A(z)) >= 1 : I(L, A(z)) <= -1 : (te = [y, K, B], b || (te = [te, "or", [y, "=", null]])), c = [te, "or", c];
      }
    }), c;
  }
  _generateFilterByKey(e, i) {
    var r = this._dataSource.key(), n = [];
    if (i || (i = "="), Array.isArray(r))
      for (var a = 0; a < r.length; ++a) {
        var o = e[r[a]];
        o && (n.length > 0 && n.push("and"), n.push([r[a], i, o]));
      }
    else
      n = [r, i, e];
    return n;
  }
  _getLastItemIndex() {
    return this.items(!0).length - 1;
  }
}, $Fe = (t) => class extends t {
  _deleteRowCore(e) {
    var i = super._deleteRowCore.apply(this, arguments), r = this._dataController.getKeyByRowIndex(e);
    i.done(() => {
      var n = this._dataController.getRowIndexByKey(r), a = this._dataController.getVisibleRows();
      n === -1 && !a.length && this._focusController._resetFocusedRow();
    });
  }
}, zFe = (t) => class extends t {
  _createRow(e) {
    var i = super._createRow.apply(this, arguments);
    return this.option("focusedRowEnabled") && e && this._focusController.isRowFocused(e.key) && i.addClass(jx), i;
  }
  _checkRowKeys(e) {
    if (super._checkRowKeys.apply(this, arguments), this.option("focusedRowEnabled") && this.option("dataSource")) {
      var i = this._dataController.store();
      i && !i.key() && this._dataController.fireError("E1042", "Row focusing");
    }
  }
  _update(e) {
    e.changeType === "updateFocusedRow" ? this.option("focusedRowEnabled") && this._focusController.updateFocusedRow(e) : super._update(e);
  }
  updateFocusElementTabIndex(e, i) {
    this.option("focusedRowEnabled") ? this._setFocusedRowElementTabIndex(i) : super.updateFocusElementTabIndex(e);
  }
  _setFocusedRowElementTabIndex(e) {
    var i, r = this.option("focusedRowKey"), n = (i = this.option("tabIndex")) !== null && i !== void 0 ? i : 0, a = this._columnsController, o = this._dataController.getRowIndexByKey(r), u = this.option("focusedColumnIndex"), c = this._findRowElementForTabIndex();
    if (R(this._scrollToFocusOnResize) || (this._scrollToFocusOnResize = () => {
      this.scrollToElementVertically(this._findRowElementForTabIndex()), this.resizeCompleted.remove(this._scrollToFocusOnResize);
    }), c.attr("tabIndex", n), o >= 0 && !e && (u < 0 && (u = 0), o += this._dataController.getRowIndexOffset(), u += a.getColumnIndexOffset(), this._keyboardNavigationController.setFocusedCellPosition(o, u), this._focusController.isAutoNavigateToFocusedRow())) {
      var p = this._dataController.dataSource(), v = p && p.operationTypes();
      v && !v.paging && !this._dataController.isPagingByRendering() && (this.resizeCompleted.remove(this._scrollToFocusOnResize), this.resizeCompleted.add(this._scrollToFocusOnResize));
    }
  }
  _findRowElementForTabIndex() {
    var e = this.option("focusedRowKey"), i = this._dataController.getRowIndexByKey(e);
    return E(this.getRowElement(i >= 0 ? i : 0));
  }
  scrollToRowElement(e) {
    var i = this._dataController.getRowIndexByKey(e), r = E(this.getRow(i));
    return this.scrollToElementVertically(r);
  }
  scrollToElementVertically(e) {
    var i = this.getScrollable();
    if (i && e.length) {
      var r = i.getScrollElementPosition(e, "vertical");
      return this.scrollTopPosition(r);
    }
    return new q().resolve();
  }
  scrollTopPosition(e) {
    var i = new q(), r = this.getScrollable();
    if (r) {
      var n = r.scrollTop(), a = () => {
        r.off("scroll", a), i.resolve();
      };
      if (e !== n)
        return r.on("scroll", a), this._dataController.resetFilterApplying(), r.scrollTo({
          top: e
        }), i.promise();
    }
    return i.resolve();
  }
}, uT = {
  defaultOptions: () => ({
    focusedRowEnabled: !1,
    autoNavigateToFocusedRow: !0,
    focusedRowKey: null,
    focusedRowIndex: -1,
    focusedColumnIndex: -1
  }),
  controllers: {
    focus: FFe
  },
  extenders: {
    controllers: {
      keyboardNavigation: BFe,
      editorFactory: VFe,
      columns: NFe,
      data: HFe,
      editing: $Fe
    },
    views: {
      rowsView: zFe
    }
  }
}, WFe = Number.MAX_SAFE_INTEGER || 9007199254740991, UFe = (t) => class extends uT.extenders.controllers.data(t) {
  changeRowExpand(e, i) {
    if (this.option("focusedRowEnabled") && Array.isArray(e) && this.isRowExpanded(e)) {
      var r = this.getController("keyboardNavigation");
      (!i || !r.isKeyboardEnabled()) && this._isFocusedRowInsideGroup(e) && this.option("focusedRowKey", e);
    }
    return super.changeRowExpand(e, i);
  }
  _isFocusedRowInsideGroup(e) {
    var i = this.getController("columns"), r = this.option("focusedRowKey"), n = this.getRowIndexByKey(r), a = n >= 0 && this.getVisibleRows()[n], o = i.getGroupDataSourceParameters(!0);
    if (a)
      for (var u = 0; u < e.length; ++u) {
        var c = Ii(o[u] && o[u].selector);
        if (c(a.data) !== e[u])
          return !1;
      }
    return !0;
  }
  _getGroupPath(e, i) {
    for (var r = [], n = [e]; n && n[0] && i; ) {
      var a = n[0];
      a.key !== void 0 && r.push(a.key), n = a.items, i--;
    }
    return r;
  }
  _expandGroupByPath(e, i, r) {
    var n = new q();
    return r++, e.expandRow(i.slice(0, r)).done(() => {
      r === i.length ? n.resolve() : e._expandGroupByPath(e, i, r).done(n.resolve).fail(n.reject);
    }).fail(n.reject), n.promise();
  }
  _calculateGlobalRowIndexByGroupedData(e) {
    var i = this, r = i._dataSource, n = i._generateFilterByKey(e), a = new q(), o = Array.isArray(e), u = r.group();
    return o ? a.resolve(-1).promise() : r._grouping._updatePagingOptions ? (r.load({
      filter: i._concatWithCombinedFilter(n),
      group: u
    }).done((c) => {
      if (!c || c.length === 0 || !R(c[0].key) || c[0].key === -1)
        return a.resolve(-1).promise();
      var p = i._getGroupPath(c[0], u.length);
      i._expandGroupByPath(i, p, 0).done(() => {
        i._calculateExpandedRowGlobalIndex(a, e, p, u);
      }).fail(a.reject);
    }).fail(a.reject), a.promise()) : (i._calculateGlobalRowIndexByFlatData(e, null, !0).done(a.resolve).fail(a.reject), a);
  }
  _calculateExpandedRowGlobalIndex(e, i, r, n) {
    var a = Pp(r, {
      group: n
    }), o = this._dataSource, u = this.option("scrolling.mode"), c = u === "virtual" || u === "infinite", p = o.pageSize(), v;
    o._grouping._updatePagingOptions({
      skip: 0,
      take: WFe
    }, (_, y) => {
      Mi(_.path, r) && (v = y);
    }), this._calculateGlobalRowIndexByFlatData(i, a).done((_) => {
      var y, b;
      if (_ < 0) {
        e.resolve(-1);
        return;
      }
      var I = v % p || p;
      y = I + _ - r.length, c ? b = 0 : b = Math.floor(y / (p - r.length)) * r.length, y = v + _ + b, e.resolve(y);
    }).fail(e.reject);
  }
};
et.registerModule("focus", ae(ae({}, uT), {
  extenders: ae(ae({}, uT.extenders), {
    controllers: ae(ae({}, uT.extenders.controllers), {
      data: UFe
    })
  })
}));
var M3 = Ot(), GFe = "keydown", Pu = "dxDraggable", KFe = ve(Rp, Pu), jFe = ve(Rh, Pu), YFe = ve(Lp, Pu), qFe = ve(bI, Pu), XFe = ve(wI, Pu), QFe = ve(Xt.down, Pu), ZFe = ve(GFe, Pu), k3 = "clone", pk, sm, JFe = "content", iF = (t) => ({
  x: t.pageX - E(M3).scrollLeft(),
  y: t.pageY - E(M3).scrollTop()
}), eBe = "dx-gesture-cover", tBe = "dx-overlay-wrapper", iBe = "dx-overlay-content";
class P3 {
  constructor(e, i) {
    this._$scrollableAtPointer = null, this._preventScroll = !0, this._component = i, e === "vertical" ? (this._scrollValue = "scrollTop", this._overFlowAttr = "overflowY", this._sizeAttr = "height", this._scrollSizeProp = "scrollHeight", this._clientSizeProp = "clientHeight", this._limitProps = {
      start: "top",
      end: "bottom"
    }) : (this._scrollValue = "scrollLeft", this._overFlowAttr = "overflowX", this._sizeAttr = "width", this._scrollSizeProp = "scrollWidth", this._clientSizeProp = "clientWidth", this._limitProps = {
      start: "left",
      end: "right"
    });
  }
  updateScrollable(e, i) {
    var r = !1;
    e.some((n) => {
      var a = E(n), o = a.hasClass(tBe), u = a.hasClass(iBe);
      return o || u ? !0 : (r = this._trySetScrollable(n, i), r);
    }), r || (this._$scrollableAtPointer = null, this._scrollSpeed = 0);
  }
  isScrolling() {
    return !!this._scrollSpeed;
  }
  isScrollable(e) {
    return (e.css(this._overFlowAttr) === "auto" || e.hasClass("dx-scrollable-container")) && e.prop(this._scrollSizeProp) > Math.ceil(this._sizeAttr === "width" ? mt(e) : Pt(e));
  }
  _trySetScrollable(e, i) {
    var r = E(e), n, a = this._component.option("scrollSensitivity"), o = this.isScrollable(r);
    return o && (n = this._calculateDistanceToBorders(r, i), a > n[this._limitProps.start] ? this._preventScroll || (this._scrollSpeed = -this._calculateScrollSpeed(n[this._limitProps.start]), this._$scrollableAtPointer = r) : a > n[this._limitProps.end] ? this._preventScroll || (this._scrollSpeed = this._calculateScrollSpeed(n[this._limitProps.end]), this._$scrollableAtPointer = r) : (o = !1, this._preventScroll = !1)), o;
  }
  _calculateDistanceToBorders(e, i) {
    var r = e.get(0), n;
    return r ? (n = zr(r), {
      left: i.x - n.left,
      top: i.y - n.top,
      right: n.right - i.x,
      bottom: n.bottom - i.y
    }) : {};
  }
  _calculateScrollSpeed(e) {
    var i = this._component, r = i.option("scrollSensitivity"), n = i.option("scrollSpeed");
    return Math.ceil(((r - e) / r) ** 2 * n);
  }
  scrollByStep() {
    if (this._$scrollableAtPointer && this._scrollSpeed) {
      if (this._$scrollableAtPointer.hasClass("dx-scrollable-container")) {
        var e = this._$scrollableAtPointer.closest(".dx-scrollable"), i = e.data("dxScrollable") || e.data("dxScrollView");
        if (i) {
          var r = i.scrollOffset()[this._limitProps.start] + this._scrollSpeed;
          i.scrollTo({
            [this._limitProps.start]: r
          });
        }
      } else {
        var n = this._$scrollableAtPointer[this._scrollValue]() + this._scrollSpeed;
        this._$scrollableAtPointer[this._scrollValue](n);
      }
      var a = this._component._dragMoveArgs;
      a && this._component._dragMoveHandler(a);
    }
  }
  reset() {
    this._$scrollableAtPointer = null, this._scrollSpeed = 0, this._preventScroll = !0;
  }
  isOutsideScrollable(e, i) {
    if (!e)
      return !1;
    var r = zr(e.get(0)), n = r[this._limitProps.start], a = r[this._sizeAttr], o = iF(i), u = this._sizeAttr === "width" ? o.x : o.y;
    return u < n || u > n + a;
  }
}
var rBe = x5.inherit({
  ctor(t) {
    this.callBase(), this._strategy = t;
  },
  _step() {
    var t = this._strategy._horizontalScrollHelper, e = this._strategy._verticalScrollHelper;
    t && t.scrollByStep(), e && e.scrollByStep();
  }
}), j9 = Nu.inherit({
  reset: ee,
  dragMove: ee,
  dragEnter: ee,
  dragLeave: ee,
  dragEnd(t) {
    var e = this._getSourceDraggable();
    return e._fireRemoveEvent(t), q().resolve();
  },
  _fireRemoveEvent: ee,
  _getDefaultOptions() {
    return P(this.callBase(), {
      onDragStart: null,
      onDragMove: null,
      onDragEnd: null,
      onDragEnter: null,
      onDragLeave: null,
      onDragCancel: null,
      onCancelByEsc: !1,
      onDrop: null,
      immediate: !0,
      dragDirection: "both",
      boundary: void 0,
      boundOffset: 0,
      allowMoveByClick: !1,
      itemData: null,
      container: void 0,
      dragTemplate: void 0,
      contentTemplate: "content",
      handle: "",
      filter: "",
      clone: !1,
      autoScroll: !0,
      scrollSpeed: 30,
      scrollSensitivity: 60,
      group: void 0,
      data: void 0
    });
  },
  _setOptionsByReference() {
    this.callBase.apply(this, arguments), P(this._optionsByReference, {
      component: !0,
      group: !0,
      itemData: !0,
      data: !0
    });
  },
  _init() {
    this.callBase(), this._attachEventHandlers(), this._scrollAnimator = new rBe(this), this._horizontalScrollHelper = new P3("horizontal", this), this._verticalScrollHelper = new P3("vertical", this), this._initScrollTop = 0, this._initScrollLeft = 0;
  },
  _normalizeCursorOffset(t) {
    return ct(t) && (t = {
      h: t.x,
      v: t.y
    }), t = Nm(t).map((e) => parseFloat(e)), {
      left: t[0],
      top: t.length === 1 ? t[0] : t[1]
    };
  },
  _getNormalizedCursorOffset(t, e) {
    return Le(t) && (t = t.call(this, e)), this._normalizeCursorOffset(t);
  },
  _calculateElementOffset(t) {
    var e, i, {
      event: r
    } = t, n = E(t.itemElement), a = E(t.dragElement), o = this._dragElementIsCloned(), u = this.option("cursorOffset"), c = {
      left: 0,
      top: 0
    }, p = this._initialLocate = zs(a);
    return (o || t.initialOffset || u) && (e = t.initialOffset || n.offset(), u && (c = this._getNormalizedCursorOffset(u, t), isFinite(c.left) && (e.left = r.pageX), isFinite(c.top) && (e.top = r.pageY)), i = a.offset(), e.top -= i.top + (c.top || 0) - p.top, e.left -= i.left + (c.left || 0) - p.left), e;
  },
  _initPosition(t) {
    var e = E(t.dragElement), i = this._calculateElementOffset(t);
    i && this._move(i, e), this._startPosition = zs(e);
  },
  _startAnimator() {
    this._scrollAnimator.inProgress() || this._scrollAnimator.start();
  },
  _stopAnimator() {
    this._scrollAnimator.stop();
  },
  _addWidgetPrefix(t) {
    var e = this.NAME;
    return vF(e) + (t ? "-".concat(t) : "");
  },
  _getItemsSelector() {
    return this.option("filter") || "";
  },
  _$content() {
    var t = this.$element(), e = t.children(".dx-template-wrapper");
    return e.length ? e : t;
  },
  _attachEventHandlers() {
    if (!this.option("disabled")) {
      var t = this._$content(), e = this._getItemsSelector(), i = this.option("allowMoveByClick"), r = {
        direction: this.option("dragDirection"),
        immediate: this.option("immediate"),
        checkDropTarget: (n, a) => {
          var o = this.option("group"), u = this._getSourceDraggable().option("group"), c = this._getScrollable(n);
          return this._verticalScrollHelper.isOutsideScrollable(c, a) || this._horizontalScrollHelper.isOutsideScrollable(c, a) ? !1 : u && u === o;
        }
      };
      i && (t = this._getArea(), k.on(t, QFe, r, this._pointerDownHandler.bind(this))), e[0] === ">" && (e = e.slice(1)), k.on(t, KFe, e, r, this._dragStartHandler.bind(this)), k.on(t, jFe, r, this._dragMoveHandler.bind(this)), k.on(t, YFe, r, this._dragEndHandler.bind(this)), k.on(t, qFe, r, this._dragEnterHandler.bind(this)), k.on(t, XFe, r, this._dragLeaveHandler.bind(this)), this.option("onCancelByEsc") && k.on(t, ZFe, this._keydownHandler.bind(this));
    }
  },
  _dragElementIsCloned() {
    return this._$dragElement && this._$dragElement.hasClass(this._addWidgetPrefix(k3));
  },
  _getDragTemplateArgs(t, e) {
    return {
      container: ot(e),
      model: {
        itemData: this.option("itemData"),
        itemElement: ot(t)
      }
    };
  },
  _createDragElement(t) {
    var e = t, i = this.option("clone"), r = this._getContainer(), n = this.option("dragTemplate");
    return n ? (n = this._getTemplate(n), e = E("<div>").appendTo(r), n.render(this._getDragTemplateArgs(t, e))) : i && (e = E("<div>").appendTo(r), t.clone().css({
      width: t.css("width"),
      height: t.css("height")
    }).appendTo(e)), e.toggleClass(this._addWidgetPrefix(k3), e.get(0) !== t.get(0)).toggleClass("dx-rtl", this.option("rtlEnabled"));
  },
  _resetDragElement() {
    this._dragElementIsCloned() ? this._$dragElement.remove() : this._toggleDraggingClass(!1), this._$dragElement = null;
  },
  _resetSourceElement() {
    this._toggleDragSourceClass(!1), this._$sourceElement = null;
  },
  _detachEventHandlers() {
    k.off(this._$content(), ".".concat(Pu)), k.off(this._getArea(), ".".concat(Pu));
  },
  _move(t, e) {
    Nn(e || this._$dragElement, t);
  },
  _getDraggableElement(t) {
    var e = this._getSourceElement();
    if (e)
      return e;
    var i = this.option("allowMoveByClick");
    if (i)
      return this.$element();
    var r = E(t && t.target), n = this._getItemsSelector();
    if (n[0] === ">") {
      var a = this._$content().find(n);
      a.is(r) || (r = r.closest(a));
    }
    return r;
  },
  _getSourceElement() {
    var t = this._getSourceDraggable();
    return t._$sourceElement;
  },
  _pointerDownHandler(t) {
    if (!uY(t)) {
      var e = {}, i = this.$element(), r = this.option("dragDirection");
      (r === "horizontal" || r === "both") && (e.left = t.pageX - i.offset().left + zs(i).left - mt(i) / 2), (r === "vertical" || r === "both") && (e.top = t.pageY - i.offset().top + zs(i).top - Pt(i) / 2), this._move(e, i), this._getAction("onDragMove")(this._getEventArgs(t));
    }
  },
  _isValidElement(t, e) {
    var i = this.option("handle"), r = E(t.originalEvent && t.originalEvent.target);
    return i && !r.closest(i).length || !e.length ? !1 : !e.is(".dx-state-disabled, .dx-state-disabled *");
  },
  _dragStartHandler(t) {
    var e = this._getDraggableElement(t);
    if (this.dragInProgress = !0, !this._isValidElement(t, e)) {
      t.cancel = !0;
      return;
    }
    if (!this._$sourceElement) {
      var i = this._getDragStartArgs(t, e);
      if (this._getAction("onDragStart")(i), i.cancel) {
        t.cancel = !0;
        return;
      }
      this.option("itemData", i.itemData), this._setSourceDraggable(), this._$sourceElement = e;
      var r = e.offset();
      !this._hasClonedDraggable() && this.option("autoScroll") && (this._initScrollTop = this._getScrollableScrollTop(), this._initScrollLeft = this._getScrollableScrollLeft(), r = this._getDraggableElementOffset(r.left, r.top));
      var n = this._$dragElement = this._createDragElement(e);
      this._toggleDraggingClass(!0), this._toggleDragSourceClass(!0), this._setGestureCoverCursor(n.children());
      var a = n.css("position") === "fixed";
      this._initPosition(P({}, i, {
        dragElement: n.get(0),
        initialOffset: a && r
      })), this._getAction("onDraggableElementShown")(ae(ae({}, i), {
        dragElement: n
      }));
      var o = this._getArea(), u = this._getAreaOffset(o), c = this._getBoundOffset(), p = oi(o), v = jt(o), _ = mt(n), y = Pt(n), b = n.offset().left - u.left, I = n.offset().top - u.top;
      o.length && (t.maxLeftOffset = b - c.left, t.maxRightOffset = p - b - _ - c.right, t.maxTopOffset = I - c.top, t.maxBottomOffset = v - I - y - c.bottom), this.option("autoScroll") && this._startAnimator();
    }
  },
  _getAreaOffset(t) {
    var e = t && kl.offset(t);
    return e || {
      left: 0,
      top: 0
    };
  },
  _toggleDraggingClass(t) {
    this._$dragElement && this._$dragElement.toggleClass(this._addWidgetPrefix("dragging"), t);
  },
  _toggleDragSourceClass(t, e) {
    var i = e || this._$sourceElement;
    i && i.toggleClass(this._addWidgetPrefix("source"), t);
  },
  _setGestureCoverCursor(t) {
    E(".".concat(eBe)).css("cursor", t.css("cursor"));
  },
  _getBoundOffset() {
    var t = this.option("boundOffset");
    return Le(t) && (t = t.call(this)), iie(t);
  },
  _getArea() {
    var t = this.option("boundary");
    return Le(t) && (t = t.call(this)), E(t);
  },
  _getContainer() {
    var t = this.option("container");
    return t === void 0 && (t = Oh()), E(t);
  },
  _getDraggableElementOffset(t, e) {
    var i, r, n, a, o = this._initScrollTop, u = this._initScrollLeft, c = this._getScrollableScrollTop(), p = this._getScrollableScrollLeft(), v = E(this.element()).css("position"), _ = v === "fixed", y = {
      left: ((r = (i = this._startPosition) === null || i === void 0 ? void 0 : i.left) !== null && r !== void 0 ? r : 0) + t,
      top: ((a = (n = this._startPosition) === null || n === void 0 ? void 0 : n.top) !== null && a !== void 0 ? a : 0) + e
    };
    return _ || this._hasClonedDraggable() ? y : {
      left: Di(p) ? y.left + p - u : y.left,
      top: Di(c) ? y.top + c - o : y.top
    };
  },
  _hasClonedDraggable() {
    return this.option("clone") || this.option("dragTemplate");
  },
  _dragMoveHandler(t) {
    if (this._dragMoveArgs = t, !this._$dragElement) {
      t.cancel = !0;
      return;
    }
    var e = this._getDraggableElementOffset(t.offset.x, t.offset.y);
    this._move(e), this._updateScrollable(t);
    var i = this._getEventArgs(t);
    if (this._getAction("onDragMove")(i), i.cancel !== !0) {
      var r = this._getTargetDraggable();
      r.dragMove(t, scrollBy);
    }
  },
  _updateScrollable(t) {
    if (this.option("autoScroll")) {
      var e = iF(t), i = de.elementsFromPoint(e.x, e.y, this.$element().get(0));
      this._verticalScrollHelper.updateScrollable(i, e), this._horizontalScrollHelper.updateScrollable(i, e);
    }
  },
  _getScrollable(t) {
    var e;
    return t.parents().toArray().some((i) => {
      var r = E(i);
      return this._horizontalScrollHelper.isScrollable(r) || this._verticalScrollHelper.isScrollable(r) ? (e = r, !0) : !1;
    }), e;
  },
  _getScrollableScrollTop() {
    var t, e;
    return (e = (t = this._getScrollable(E(this.element()))) === null || t === void 0 ? void 0 : t.scrollTop()) !== null && e !== void 0 ? e : 0;
  },
  _getScrollableScrollLeft() {
    var t, e;
    return (e = (t = this._getScrollable(E(this.element()))) === null || t === void 0 ? void 0 : t.scrollLeft()) !== null && e !== void 0 ? e : 0;
  },
  _defaultActionArgs() {
    var t = this.callBase.apply(this, arguments), e = this.option("component");
    return e && (t.component = e, t.element = e.element()), t;
  },
  _getEventArgs(t) {
    var e = this._getSourceDraggable(), i = this._getTargetDraggable();
    return {
      event: t,
      itemData: e.option("itemData"),
      itemElement: ot(e._$sourceElement),
      fromComponent: e.option("component") || e,
      toComponent: i.option("component") || i,
      fromData: e.option("data"),
      toData: i.option("data")
    };
  },
  _getDragStartArgs(t, e) {
    var i = this._getEventArgs(t);
    return {
      event: i.event,
      itemData: i.itemData,
      itemElement: e,
      fromData: i.fromData
    };
  },
  _revertItemToInitialPosition() {
    !this._dragElementIsCloned() && this._move(this._initialLocate, this._$sourceElement);
  },
  _dragEndHandler(t) {
    var e = q(), i = this._getEventArgs(t), r = this._getEventArgs(t), n = this._getTargetDraggable(), a = !0;
    this.dragInProgress = !1;
    try {
      this._getAction("onDragEnd")(i);
    } finally {
      $e(Pn(i.cancel)).done((o) => {
        if (!o && (n !== this && n._getAction("onDrop")(r), !r.cancel)) {
          a = !1, $e(Pn(n.dragEnd(i))).always(e.resolve);
          return;
        }
        e.resolve();
      }).fail(e.resolve), e.done(() => {
        a && this._revertItemToInitialPosition(), this._resetDragOptions(n);
      });
    }
  },
  _isTargetOverAnotherDraggable(t) {
    var e = this._getSourceDraggable();
    if (this === e)
      return !1;
    var i = e._$dragElement, r = e.$element(), n = this.$element(), a = iF(t), o = de.elementsFromPoint(a.x, a.y, this.element()), u = o.filter((_) => {
      var y = E(_);
      return y.hasClass(this._addWidgetPrefix()) ? !y.closest(i).length : !1;
    })[0], c = this._getSourceElement(), p = u === r.get(0), v = E(u).closest(c).length;
    return !u || u === n.get(0) && !p && !v;
  },
  _dragEnterHandler(t) {
    this._fireDragEnterEvent(t), this._isTargetOverAnotherDraggable(t) && this._setTargetDraggable();
    var e = this._getSourceDraggable();
    e.dragEnter(t);
  },
  _dragLeaveHandler(t) {
    this._fireDragLeaveEvent(t), this._resetTargetDraggable(), this !== this._getSourceDraggable() && this.reset();
    var e = this._getSourceDraggable();
    e.dragLeave(t);
  },
  _keydownHandler(t) {
    this.dragInProgress && t.key === "Escape" && this._keydownEscapeHandler(t);
  },
  _keydownEscapeHandler(t) {
    var e = this._getSourceElement();
    if (e) {
      var i = this._getEventArgs(t);
      if (this._getAction("onDragCancel")(i), !i.cancel) {
        this.dragInProgress = !1, sm == null || sm._toggleDraggingClass(!1), this._detachEventHandlers(), this._revertItemToInitialPosition();
        var r = this._getTargetDraggable();
        this._resetDragOptions(r), this._attachEventHandlers();
      }
    }
  },
  _getAction(t) {
    return this["_".concat(t, "Action")] || this._createActionByOption(t);
  },
  _getAnonymousTemplateName: () => JFe,
  _initTemplates() {
    this.option("contentTemplate") && (this._templateManager.addDefaultTemplates({
      content: new yp()
    }), this.callBase.apply(this, arguments));
  },
  _render() {
    this.callBase(), this.$element().addClass(this._addWidgetPrefix());
    var t = this._templateManager.anonymousTemplateName === this.option("contentTemplate"), e = this._getTemplateByOption("contentTemplate");
    e && E(e.render({
      container: this.element(),
      transclude: t
    }));
  },
  _optionChanged(t) {
    var {
      name: e
    } = t;
    switch (e) {
      case "onDragStart":
      case "onDragMove":
      case "onDragEnd":
      case "onDrop":
      case "onDragEnter":
      case "onDragLeave":
      case "onDragCancel":
      case "onDraggableElementShown":
        this["_".concat(e, "Action")] = this._createActionByOption(e);
        break;
      case "dragTemplate":
      case "contentTemplate":
      case "container":
      case "clone":
        break;
      case "allowMoveByClick":
      case "dragDirection":
      case "disabled":
      case "boundary":
      case "filter":
      case "immediate":
        this._resetDragElement(), this._detachEventHandlers(), this._attachEventHandlers();
        break;
      case "onCancelByEsc":
        this._keydownHandler();
        break;
      case "autoScroll":
        this._verticalScrollHelper.reset(), this._horizontalScrollHelper.reset();
        break;
      case "scrollSensitivity":
      case "scrollSpeed":
      case "boundOffset":
      case "handle":
      case "group":
      case "data":
      case "itemData":
        break;
      default:
        this.callBase(t);
    }
  },
  _getTargetDraggable() {
    return pk || this;
  },
  _getSourceDraggable() {
    return sm || this;
  },
  _setTargetDraggable() {
    var t = this.option("group"), e = this._getSourceDraggable();
    t && t === e.option("group") && (pk = this);
  },
  _setSourceDraggable() {
    sm = this;
  },
  _resetSourceDraggable() {
    sm = null;
  },
  _resetTargetDraggable() {
    pk = null;
  },
  _resetDragOptions(t) {
    this.reset(), t.reset(), this._stopAnimator(), this._horizontalScrollHelper.reset(), this._verticalScrollHelper.reset(), this._resetDragElement(), this._resetSourceElement(), this._resetTargetDraggable(), this._resetSourceDraggable();
  },
  _dispose() {
    this.callBase(), this._detachEventHandlers(), this._resetDragElement(), this._resetTargetDraggable(), this._resetSourceDraggable(), this._$sourceElement = null, this._stopAnimator();
  },
  _fireDragEnterEvent(t) {
    var e = this._getEventArgs(t);
    this._getAction("onDragEnter")(e);
  },
  _fireDragLeaveEvent(t) {
    var e = this._getEventArgs(t);
    this._getAction("onDragLeave")(e);
  }
});
ti(Pu, j9);
var F3 = Ot(), nBe = "dxSortable", B3 = "placeholder", aBe = "clone", V3 = (t) => E(t).is(":visible"), oBe = (t, e) => {
  var i, r;
  if (t) {
    var n = ((i = e.to) === null || i === void 0 ? void 0 : i.left) || 0, a = ((r = e.to) === null || r === void 0 ? void 0 : r.top) || 0;
    t.style.transform = "translate(".concat(n, "px,").concat(a, "px)"), t.style.transition = ji.off ? "" : "transform ".concat(e.duration, "ms ").concat(e.easing);
  }
}, sBe = (t) => {
  t && (t.style.transform = "", t.style.transition = "");
};
function lBe(t) {
  var e = t.offset(), {
    style: i
  } = t[0], r = parseFloat(i.paddingLeft) || 0, n = parseFloat(i.paddingRight) || 0, a = parseFloat(i.paddingTop) || 0, o = t[0].clientWidth - (r + n), u = Pt(t), c = e.left + r, p = e.top + a;
  return {
    left: c,
    right: c + o,
    top: p,
    bottom: p + u
  };
}
var Y9 = j9.inherit({
  _init() {
    this.callBase(), this._sourceScrollHandler = this._handleSourceScroll.bind(this), this._sourceScrollableInfo = null;
  },
  _getDefaultOptions() {
    return P(this.callBase(), {
      clone: !0,
      filter: "> *",
      itemOrientation: "vertical",
      dropFeedbackMode: "push",
      allowDropInsideItem: !1,
      allowReordering: !0,
      moveItemOnDrop: !1,
      onDragChange: null,
      onAdd: null,
      onRemove: null,
      onReorder: null,
      onPlaceholderPrepared: null,
      animation: {
        type: "slide",
        duration: 300,
        easing: "ease"
      },
      fromIndex: null,
      toIndex: null,
      dropInsideItem: !1,
      itemPoints: null,
      fromIndexOffset: 0,
      offset: 0,
      autoUpdate: !1,
      draggableElementSize: 0
    });
  },
  reset() {
    this.option({
      dropInsideItem: !1,
      toIndex: null,
      fromIndex: null,
      itemPoints: null,
      fromIndexOffset: 0,
      draggableElementSize: 0
    }), this._$placeholderElement && this._$placeholderElement.remove(), this._$placeholderElement = null, !this._isIndicateMode() && this._$modifiedItem && (this._$modifiedItem.css("marginBottom", this._modifiedItemMargin), this._$modifiedItem = null);
  },
  _getPrevVisibleItem: (t, e) => t.slice(0, e).reverse().filter(V3)[0],
  _dragStartHandler(t) {
    if (this.callBase.apply(this, arguments), t.cancel !== !0) {
      var e = this._getSourceElement();
      this._updateItemPoints(), this._subscribeToSourceScroll(t), this.option("fromIndex", this._getElementIndex(e)), this.option("fromIndexOffset", this.option("offset"));
    }
  },
  _subscribeToSourceScroll(t) {
    var e = this._getScrollable(E(t.target));
    e && (this._sourceScrollableInfo = {
      element: e,
      scrollLeft: e.scrollLeft(),
      scrollTop: e.scrollTop()
    }, k.off(e, "scroll", this._sourceScrollHandler), k.on(e, "scroll", this._sourceScrollHandler));
  },
  _unsubscribeFromSourceScroll() {
    this._sourceScrollableInfo && (k.off(this._sourceScrollableInfo.element, "scroll", this._sourceScrollHandler), this._sourceScrollableInfo = null);
  },
  _handleSourceScroll(t) {
    var e = this._sourceScrollableInfo;
    e && ["scrollLeft", "scrollTop"].forEach((i) => {
      if (t.target[i] !== e[i]) {
        var r = t.target[i] - e[i];
        this._correctItemPoints(r), this._movePlaceholder(), e[i] = t.target[i];
      }
    });
  },
  _dragEnterHandler(t) {
    if (this.callBase.apply(this, arguments), this !== this._getSourceDraggable() && (this._subscribeToSourceScroll(t), this._updateItemPoints(), this.option("fromIndex", -1), !this._isIndicateMode())) {
      var e = this.option("itemPoints"), i = e[e.length - 1];
      if (i) {
        var r = this.$element(), n = this._getSourceElement(), a = this._isVerticalOrientation(), o = a ? jt(n, !0) : oi(n, !0), u = r.get(0)[a ? "scrollHeight" : "scrollWidth"], c = r.get(0)[a ? "scrollTop" : "scrollLeft"], p = a ? "top" : "left", v = i[p], _ = r.offset()[p], y = _ + u - c - v;
        if (y < o && a) {
          var b = this._getItems(), I = E(this._getPrevVisibleItem(b));
          this._$modifiedItem = I, this._modifiedItemMargin = I.get(0).style.marginBottom, I.css("marginBottom", o - y);
          var A = I.closest(".dx-sortable"), L = A.data("dxScrollable") || A.data("dxScrollView");
          L && L.update();
        }
      }
    }
  },
  _dragLeaveHandler() {
    this.callBase.apply(this, arguments), this !== this._getSourceDraggable() && this._unsubscribeFromSourceScroll();
  },
  dragEnter() {
    this !== this._getTargetDraggable() && this.option("toIndex", -1);
  },
  dragLeave() {
    this !== this._getTargetDraggable() && this.option("toIndex", this.option("fromIndex"));
  },
  _allowDrop(t) {
    var e = this._getTargetDraggable(), i = e.$element(), r = this._getScrollable(i);
    if (r) {
      var {
        left: n,
        right: a,
        top: o,
        bottom: u
      } = lBe(r), c = this.option("toIndex"), p = this.option("itemPoints"), v = p == null ? void 0 : p.filter((y) => y.index === c)[0];
      if (v && v.top !== void 0) {
        var _ = this._isVerticalOrientation();
        return _ ? o <= Math.ceil(v.top) && Math.floor(v.top) <= u : n <= Math.ceil(v.left) && Math.floor(v.left) <= a;
      }
    }
    return !0;
  },
  dragEnd(t) {
    this._unsubscribeFromSourceScroll();
    var e = this._getSourceElement(), i = this._getSourceDraggable(), r = i.NAME !== this.NAME, n = this.option("toIndex"), {
      event: a
    } = t, o = this._allowDrop(a);
    if (n !== null && n >= 0 && o) {
      var u, c;
      if (i !== this && (u = this._fireAddEvent(a), u || (c = this._fireRemoveEvent(a))), r && xS(e), this.option("moveItemOnDrop") && !u && this._moveItem(e, n, c), i === this)
        return this._fireReorderEvent(a);
    }
    return q().resolve();
  },
  dragMove(t) {
    var e = this.option("itemPoints");
    if (e) {
      for (var i = this._isVerticalOrientation(), r = i ? "top" : "left", n = i ? t.pageY : t.pageX, a = this.option("rtlEnabled"), o, u = e.length - 1; u >= 0; u--) {
        var c = e[u + 1] && (e[u][r] + e[u + 1][r]) / 2;
        if ((!i && a ? n > c : c > n) || c === void 0)
          o = e[u];
        else
          break;
      }
      o && (this._updatePlaceholderPosition(t, o), this._verticalScrollHelper.isScrolling() && this._isIndicateMode() && this._movePlaceholder());
    }
  },
  _isIndicateMode() {
    return this.option("dropFeedbackMode") === "indicate" || this.option("allowDropInsideItem");
  },
  _createPlaceholder() {
    var t;
    return this._isIndicateMode() && (t = E("<div>").addClass(this._addWidgetPrefix(B3)).insertBefore(this._getSourceDraggable()._$dragElement)), this._$placeholderElement = t, t;
  },
  _getItems() {
    var t = this._getItemsSelector();
    return this._$content().find(t).not(".".concat(this._addWidgetPrefix(B3))).not(".".concat(this._addWidgetPrefix(aBe))).toArray();
  },
  _allowReordering() {
    var t = this._getSourceDraggable(), e = this._getTargetDraggable();
    return t !== e || this.option("allowReordering");
  },
  _isValidPoint(t, e, i) {
    var r = this.option("allowDropInsideItem"), n = i || this._allowReordering();
    return !n && (t !== 0 || !r) ? !1 : this._isIndicateMode() ? e === -1 || t !== e && (i || t !== e + 1) : !0;
  },
  _getItemPoints() {
    var t = [], e, i, r, n = this.option("rtlEnabled"), a = this._isVerticalOrientation(), o = this._getItems(), u = o.filter(V3), c = u.length, p = this._getDraggableElement(), v = u.indexOf(p.get(0));
    if (c) {
      for (var _ = 0; _ <= c; _++) {
        var y = !a && n ^ _ === c, b = a && _ === c;
        _ < c && (e = E(u[_]), i = e.offset(), r = oi(e)), t.push({
          dropInsideItem: !1,
          left: i.left + (y ? r : 0),
          top: i.top + (b ? t[_ - 1].height : 0),
          index: _ === c ? o.length : o.indexOf(e.get(0)),
          $item: e,
          width: oi(e),
          height: jt(e),
          isValid: this._isValidPoint(_, v)
        });
      }
      if (this.option("allowDropInsideItem")) {
        var I = t;
        t = [];
        for (var A = 0; A < I.length; A++)
          t.push(I[A]), I[A + 1] && t.push(P({}, I[A], {
            dropInsideItem: !0,
            top: Math.floor((I[A].top + I[A + 1].top) / 2),
            left: Math.floor((I[A].left + I[A + 1].left) / 2),
            isValid: this._isValidPoint(A, v, !0)
          }));
      }
    } else
      t.push({
        dropInsideItem: !1,
        index: 0,
        isValid: !0
      });
    return t;
  },
  _updateItemPoints(t) {
    (t || this.option("autoUpdate") || !this.option("itemPoints")) && this.option("itemPoints", this._getItemPoints());
  },
  _correctItemPoints(t) {
    var e = this.option("itemPoints");
    if (t && e && !this.option("autoUpdate")) {
      var i = this._isVerticalOrientation(), r = i ? "top" : "left";
      e.forEach((n) => {
        n[r] -= t;
      });
    }
  },
  _getElementIndex(t) {
    return this._getItems().indexOf(t.get(0));
  },
  _getDragTemplateArgs(t) {
    var e = this.callBase.apply(this, arguments);
    return e.model.fromIndex = this._getElementIndex(t), e;
  },
  _togglePlaceholder(t) {
    this._$placeholderElement && this._$placeholderElement.toggle(t);
  },
  _isVerticalOrientation() {
    return this.option("itemOrientation") === "vertical";
  },
  _normalizeToIndex(t, e) {
    var i = this._getSourceDraggable() !== this._getTargetDraggable(), r = this._getActualFromIndex();
    return t === null ? r : Math.max(i || r >= t || e ? t : t - 1, 0);
  },
  _updatePlaceholderPosition(t, e) {
    var i = this._getSourceDraggable(), r = this._normalizeToIndex(e.index, e.dropInsideItem), n = P(this._getEventArgs(t), {
      toIndex: r,
      dropInsideItem: e.dropInsideItem
    });
    if (e.isValid && this._getAction("onDragChange")(n), n.cancel || !e.isValid) {
      e.isValid || this.option({
        dropInsideItem: !1,
        toIndex: null
      });
      return;
    }
    this.option({
      dropInsideItem: e.dropInsideItem,
      toIndex: e.index
    }), this._getAction("onPlaceholderPrepared")(P(this._getEventArgs(t), {
      placeholderElement: ot(this._$placeholderElement),
      dragElement: ot(i._$dragElement)
    })), this._updateItemPoints();
  },
  _makeWidthCorrection(t, e) {
    if (this._$scrollable = this._getScrollable(t), this._$scrollable) {
      var i = mt(this._$scrollable), r = this._$scrollable.offset().left - t.offset().left, n = oi(t) - r - i;
      r > 0 && (e -= r), n > 0 && (e -= n);
    }
    return e;
  },
  _updatePlaceholderSizes(t, e) {
    var i = this.option("dropInsideItem"), r = E(e), n = this._isVerticalOrientation(), a = "", o = "";
    t.toggleClass(this._addWidgetPrefix("placeholder-inside"), i), (n || i) && (a = oi(r)), (!n || i) && (o = jt(r)), a = this._makeWidthCorrection(r, a), t.css({
      width: a,
      height: o
    });
  },
  _moveItem(t, e, i) {
    var r, n = this._getItems(), a = n[e], o = this._getSourceDraggable();
    i && (t = t.clone(), o._toggleDragSourceClass(!1, t)), a || (r = n[e - 1]), this._moveItemCore(t, a, r);
  },
  _moveItemCore(t, e, i) {
    !e && !i ? t.appendTo(this.$element()) : i ? t.insertAfter(E(i)) : t.insertBefore(E(e));
  },
  _getDragStartArgs(t, e) {
    return P(this.callBase.apply(this, arguments), {
      fromIndex: this._getElementIndex(e)
    });
  },
  _getEventArgs(t) {
    var e = this._getSourceDraggable(), i = this._getTargetDraggable(), r = i.option("dropInsideItem");
    return P(this.callBase.apply(this, arguments), {
      fromIndex: e.option("fromIndex"),
      toIndex: this._normalizeToIndex(i.option("toIndex"), r),
      dropInsideItem: r
    });
  },
  _optionChanged(t) {
    var {
      name: e
    } = t;
    switch (e) {
      case "onDragChange":
      case "onPlaceholderPrepared":
      case "onAdd":
      case "onRemove":
      case "onReorder":
        this["_".concat(e, "Action")] = this._createActionByOption(e);
        break;
      case "itemOrientation":
      case "allowDropInsideItem":
      case "moveItemOnDrop":
      case "dropFeedbackMode":
      case "itemPoints":
      case "animation":
      case "allowReordering":
      case "fromIndexOffset":
      case "offset":
      case "draggableElementSize":
      case "autoUpdate":
        break;
      case "fromIndex":
        [!1, !0].forEach((i) => {
          var r = i ? t.value : t.previousValue;
          if (r !== null) {
            var n = E(this._getItems()[r]);
            this._toggleDragSourceClass(i, n);
          }
        });
        break;
      case "dropInsideItem":
        this._optionChangedDropInsideItem(t);
        break;
      case "toIndex":
        this._optionChangedToIndex(t);
        break;
      default:
        this.callBase(t);
    }
  },
  _optionChangedDropInsideItem() {
    this._isIndicateMode() && this._$placeholderElement && this._movePlaceholder();
  },
  _isPositionVisible(t) {
    var e = this.$element(), i;
    if (e.css("overflow") !== "hidden" ? i = e.get(0) : e.parents().each(function() {
      if (E(this).css("overflow") !== "visible")
        return i = this, !1;
    }), i) {
      var r = zr(i), n = this._isVerticalOrientation(), a = n ? "top" : "left", o = n ? "bottom" : "right", u = n ? F3.pageYOffset : F3.pageXOffset;
      if (t[a] < r[a] + u || t[a] > r[o] + u)
        return !1;
    }
    return !0;
  },
  _optionChangedToIndex(t) {
    var e = t.value;
    if (this._isIndicateMode()) {
      var i = e !== null && e >= 0;
      this._togglePlaceholder(i), i && this._movePlaceholder();
    } else
      this._moveItems(t.previousValue, t.value, t.fullUpdate);
  },
  update() {
    if (!(this.option("fromIndex") === null && this.option("toIndex") === null)) {
      this._updateItemPoints(!0), this._updateDragSourceClass();
      var t = this.option("toIndex");
      this._optionChangedToIndex({
        value: t,
        fullUpdate: !0
      });
    }
  },
  _updateDragSourceClass() {
    var t = this._getActualFromIndex(), e = E(this._getItems()[t]);
    e.length && (this._$sourceElement = e, this._toggleDragSourceClass(!0, e));
  },
  _makeLeftCorrection(t) {
    var e = this._$scrollable;
    if (e && this._isVerticalOrientation()) {
      var i = e.offset().left - t;
      i > 0 && (t += i);
    }
    return t;
  },
  _movePlaceholder() {
    var t = this._$placeholderElement || this._createPlaceholder();
    if (t) {
      var e = this._getItems(), i = this.option("toIndex"), r = this._isVerticalOrientation(), n = this.option("rtlEnabled"), a = this.option("dropInsideItem"), o = null, u = e[i];
      if (u) {
        var c = E(u);
        o = c.offset(), !r && n && !a && (o.left += oi(c, !0));
      } else {
        var p = u = this._getPrevVisibleItem(e, i);
        p && (o = E(p).offset(), r ? o.top += jt(p, !0) : n || (o.left += oi(p, !0)));
      }
      if (this._updatePlaceholderSizes(t, u), o && !this._isPositionVisible(o) && (o = null), o) {
        var v = r && i === e.length, _ = jt(t);
        o.left = this._makeLeftCorrection(o.left), o.top = v && o.top >= _ ? o.top - _ : o.top, this._move(o, t);
      }
      t.toggle(!!o);
    }
  },
  _getPositions(t, e, i, r) {
    for (var n = [], a = 0; a < t.length; a++) {
      var o = 0;
      if (r === null || i === null) {
        n.push(o);
        continue;
      }
      i === -1 ? a >= r && (o = e) : r === -1 ? a > i && (o = -e) : i < r ? a > i && a < r && (o = -e) : i > r && a >= r && a < i && (o = e), n.push(o);
    }
    return n;
  },
  _getDraggableElementSize(t) {
    var e = this._getDraggableElement(), i = this.option("draggableElementSize");
    return i || (i = t ? (jt(e) + jt(e, !0)) / 2 : (oi(e) + oi(e, !0)) / 2, this.option("autoUpdate") || this.option("draggableElementSize", i)), i;
  },
  _getActualFromIndex() {
    var {
      fromIndex: t,
      fromIndexOffset: e,
      offset: i
    } = this.option();
    return t == null ? null : t + e - i;
  },
  _moveItems(t, e, i) {
    for (var r = this._getActualFromIndex(), n = this._isVerticalOrientation(), a = n ? "top" : "left", o = this._getDraggableElementSize(n), u = this._getItems(), c = this._getPositions(u, o, r, t), p = this._getPositions(u, o, r, e), v = this.option("animation"), _ = this.option("rtlEnabled"), y = 0; y < u.length; y++) {
      var b = u[y], I = c[y], A = p[y];
      e === null || r === null ? sBe(b) : (I !== A || i && A) && oBe(b, P({}, v, {
        to: {
          [a]: !n && _ ? -A : A
        }
      }));
    }
  },
  _toggleDragSourceClass(t, e) {
    var i = e || this._$sourceElement;
    this.callBase.apply(this, arguments), this._isIndicateMode() || i && i.toggleClass(this._addWidgetPrefix("source-hidden"), t);
  },
  _dispose() {
    this.reset(), this.callBase();
  },
  _fireAddEvent(t) {
    var e = this._getEventArgs(t);
    return this._getAction("onAdd")(e), e.cancel;
  },
  _fireRemoveEvent(t) {
    var e = this._getSourceDraggable(), i = this._getEventArgs(t);
    return e._getAction("onRemove")(i), i.cancel;
  },
  _fireReorderEvent(t) {
    var e = this._getEventArgs(t);
    return this._getAction("onReorder")(e), e.promise || q().resolve();
  }
});
ti(nBe, Y9);
var uBe = {
  dragCell: "dx-drag-cell"
}, dp = {
  cellFocusDisabled: "dx-cell-focus-disabled",
  handleIcon: "drag-icon",
  commandDrag: "dx-command-drag",
  sortableWithoutHandle: "dx-sortable-without-handle",
  rowsView: "rowsview",
  dragView: "dragview"
}, dBe = (t) => (e, i) => {
  var r = E(e);
  if (i.rowType === "data")
    return r.addClass(dp.cellFocusDisabled), E("<span>").addClass(t(dp.handleIcon));
  xe.setEmptyText(r);
}, cBe = {
  createHandleTemplateFunc: dBe
}, hBe = (t) => class extends t {
  init() {
    super.init.apply(this, arguments), this._updateHandleColumn();
  }
  optionChanged(e) {
    e.name === "rowDragging" && (this._updateHandleColumn(), this._invalidate(!0, !0), e.handled = !0), super.optionChanged.apply(this, arguments);
  }
  _allowReordering() {
    var e = this.option("rowDragging");
    return !!(e && (e.allowReordering || e.allowDropInsideItem || e.group));
  }
  _updateHandleColumn() {
    var e = this.option("rowDragging"), i = this._allowReordering(), r = this._columnsController, n = i && e.showDragIcons;
    r == null || r.addCommandColumn({
      type: "drag",
      command: "drag",
      visibleIndex: -2,
      alignment: "center",
      elementAttr: [{
        name: uBe.dragCell,
        value: ""
      }],
      cssClass: dp.commandDrag,
      width: "auto",
      cellTemplate: this._getHandleTemplate(),
      visible: n
    }), r == null || r.columnOption("type:drag", "visible", n);
  }
  _renderContent() {
    var e = this.option("rowDragging"), i = this._allowReordering(), r = super._renderContent.apply(this, arguments), n = this._isFixedTableRendering, a = n ? "_sortableFixed" : "_sortable", o = n ? "_sortable" : "_sortableFixed", u = (v) => {
      var _;
      (_ = this._sortableFixed) === null || _ === void 0 || _.$element().css("pointerEvents", v ? "auto" : "");
    }, c = ".dx-row:not(.dx-freespace-row):not(.dx-virtual-row):not(.dx-header-row):not(.dx-footer-row)", p = this.option("dataRowTemplate") ? "> table > tbody".concat(c) : "> table > tbody > ".concat(c);
    return (i || this[a]) && r.length && (this[a] = this._createComponent(r, Y9, P({
      component: this.component,
      contentTemplate: null,
      filter: p,
      cursorOffset: (v) => {
        var {
          event: _
        } = v, y = E(this.element()).offset();
        return {
          x: _.pageX - y.left
        };
      },
      onDraggableElementShown: (v) => {
        if (!e.dragTemplate) {
          var _ = E(v.dragElement), y = _.children(".dx-widget").data(this.component.NAME);
          this._synchronizeScrollLeftPosition(y);
        }
      },
      dragTemplate: this._getDraggableRowTemplate(),
      handle: e.showDragIcons && ".".concat(dp.commandDrag),
      dropFeedbackMode: "indicate"
    }, e, {
      onDragStart: (v) => {
        var _, y;
        (_ = this.getController("keyboardNavigation")) === null || _ === void 0 || _._resetFocusedCell();
        var b = v.component.getVisibleRows()[v.fromIndex];
        v.itemData = b && b.data;
        var I = b && b.rowType === "data";
        v.cancel = !i || !I, (y = e.onDragStart) === null || y === void 0 || y.call(e, v);
      },
      onDragEnter: () => {
        u(!0);
      },
      onDragLeave: () => {
        u(!1);
      },
      onDragEnd: (v) => {
        var _;
        u(!1), (_ = e.onDragEnd) === null || _ === void 0 || _.call(e, v);
      },
      onAdd: (v) => {
        var _;
        u(!1), (_ = e.onAdd) === null || _ === void 0 || _.call(e, v);
      },
      dropFeedbackMode: e.dropFeedbackMode,
      onOptionChanged: (v) => {
        var _ = this._sortableFixed;
        _ && (v.name === "fromIndex" || v.name === "toIndex") && this[o].option(v.name, v.value);
      }
    })), r.toggleClass("dx-scrollable-container", n), r.toggleClass(dp.sortableWithoutHandle, i && !e.showDragIcons)), r;
  }
  _renderCore(e) {
    super._renderCore.apply(this, arguments), e && e.changeType === "update" && e.repaintChangesOnly && xe.isVirtualRowRendering(this) && Na(() => {
      this._updateSortable();
    });
  }
  _updateSortable() {
    var e = this._dataController.getRowIndexOffset(), i = e - this._previousOffset;
    [this._sortable, this._sortableFixed].forEach((r) => {
      var n = r == null ? void 0 : r.option("toIndex");
      R(n) && R(this._previousOffset) && (r == null || r.option("toIndex", n - i)), r == null || r.option("offset", e), r == null || r.update();
    }), this._previousOffset = e;
  }
  _resizeCore() {
    super._resizeCore.apply(this, arguments), this._updateSortable();
  }
  _getDraggableGridOptions(e) {
    var i = this.option(), r = this.getColumns(), n = E(this.getRowElement(e.rowIndex));
    return {
      dataSource: [{
        id: 1,
        parentId: 0
      }],
      showBorders: !0,
      showColumnHeaders: !1,
      scrolling: {
        useNative: !1,
        showScrollbar: "never"
      },
      pager: {
        visible: !1
      },
      loadingTimeout: null,
      columnFixing: i.columnFixing,
      columnAutoWidth: i.columnAutoWidth,
      showColumnLines: i.showColumnLines,
      columns: r.map((a) => ({
        width: a.width || a.visibleWidth,
        fixed: a.fixed,
        fixedPosition: a.fixedPosition
      })),
      onRowPrepared: (a) => {
        var o = a.component.getView("rowsView");
        E(a.rowElement).replaceWith(n.eq(o._isFixedTableRendering ? 1 : 0).clone());
      }
    };
  }
  _synchronizeScrollLeftPosition(e) {
    var i = e == null ? void 0 : e.getScrollable();
    i == null || i.scrollTo({
      x: this._scrollLeft
    });
  }
  _getDraggableRowTemplate() {
    return (e) => {
      var i = this.component.$element(), r = E("<div>");
      gF(r, mt(i));
      var n = this._dataController.items(), a = n && n[e.fromIndex], o = this._getDraggableGridOptions(a);
      return this._createComponent(r, this.component.NAME, o), r.find(".dx-gridbase-container").children(":not(.".concat(this.addWidgetPrefix(dp.rowsView), ")")).hide(), r.addClass(this.addWidgetPrefix(dp.dragView)), r;
    };
  }
  _getHandleTemplate() {
    return cBe.createHandleTemplateFunc((e) => this.addWidgetPrefix(e));
  }
}, fBe = {
  defaultOptions: () => ({
    rowDragging: {
      showDragIcons: !0,
      dropFeedbackMode: "indicate",
      allowReordering: !1,
      allowDropInsideItem: !1
    }
  }),
  extenders: {
    views: {
      rowsView: hBe
    }
  }
};
et.registerModule("rowDragging", fBe);
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var pBe = /* @__PURE__ */ function() {
  var t = function(e, i) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
    }, t(e, i);
  };
  return function(e, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    t(e, i);
    function r() {
      this.constructor = e;
    }
    e.prototype = i === null ? Object.create(i) : (r.prototype = i.prototype, new r());
  };
}(), Qe = (
  /** @class */
  function(t) {
    pBe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.render = function() {
      var i = this.props.children, r = Er.Children.map(i, function(n) {
        var a = Sq(n);
        return a.type === Au.Option ? n : null;
      });
      return Er.createElement(Er.Fragment, {}, r);
    }, e;
  }(Er.PureComponent)
);
/*!
 * devextreme-react
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var qe = /* @__PURE__ */ function() {
  var t = function(e, i) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
    }, t(e, i);
  };
  return function(e, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    t(e, i);
    function r() {
      this.constructor = e;
    }
    e.prototype = i === null ? Object.create(i) : (r.prototype = i.prototype, new r());
  };
}(), fV = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      var i = t !== null && t.apply(this, arguments) || this;
      return i._WidgetClass = VB, i.useRequestAnimationFrameFlag = !0, i.subscribableOptions = ["columns", "editing", "editing.changes", "editing.editColumnName", "editing.editRowKey", "filterPanel", "filterPanel.filterEnabled", "filterValue", "focusedColumnIndex", "focusedRowIndex", "focusedRowKey", "groupPanel", "groupPanel.visible", "paging", "paging.pageIndex", "paging.pageSize", "searchPanel", "searchPanel.text", "selectedRowKeys", "selectionFilter"], i.independentEvents = ["onAdaptiveDetailRowPreparing", "onCellClick", "onCellDblClick", "onCellPrepared", "onContentReady", "onContextMenuPreparing", "onDataErrorOccurred", "onDisposing", "onEditCanceled", "onEditCanceling", "onEditingStart", "onEditorPrepared", "onEditorPreparing", "onExporting", "onFocusedCellChanging", "onFocusedRowChanging", "onInitialized", "onInitNewRow", "onKeyDown", "onRowClick", "onRowCollapsed", "onRowCollapsing", "onRowDblClick", "onRowExpanded", "onRowExpanding", "onRowInserted", "onRowInserting", "onRowPrepared", "onRowRemoved", "onRowRemoving", "onRowUpdated", "onRowUpdating", "onRowValidating", "onSaved", "onSaving", "onToolbarPreparing"], i._defaults = {
        defaultColumns: "columns",
        defaultEditing: "editing",
        defaultFilterPanel: "filterPanel",
        defaultFilterValue: "filterValue",
        defaultFocusedColumnIndex: "focusedColumnIndex",
        defaultFocusedRowIndex: "focusedRowIndex",
        defaultFocusedRowKey: "focusedRowKey",
        defaultGroupPanel: "groupPanel",
        defaultPaging: "paging",
        defaultSearchPanel: "searchPanel",
        defaultSelectedRowKeys: "selectedRowKeys",
        defaultSelectionFilter: "selectionFilter"
      }, i._expectedChildren = {
        column: { optionName: "columns", isCollectionItem: !0 },
        columnChooser: { optionName: "columnChooser", isCollectionItem: !1 },
        columnFixing: { optionName: "columnFixing", isCollectionItem: !1 },
        dataGridHeaderFilter: { optionName: "headerFilter", isCollectionItem: !1 },
        dataGridSelection: { optionName: "selection", isCollectionItem: !1 },
        editing: { optionName: "editing", isCollectionItem: !1 },
        export: { optionName: "export", isCollectionItem: !1 },
        filterBuilder: { optionName: "filterBuilder", isCollectionItem: !1 },
        filterBuilderPopup: { optionName: "filterBuilderPopup", isCollectionItem: !1 },
        filterPanel: { optionName: "filterPanel", isCollectionItem: !1 },
        filterRow: { optionName: "filterRow", isCollectionItem: !1 },
        grouping: { optionName: "grouping", isCollectionItem: !1 },
        groupPanel: { optionName: "groupPanel", isCollectionItem: !1 },
        headerFilter: { optionName: "headerFilter", isCollectionItem: !1 },
        keyboardNavigation: { optionName: "keyboardNavigation", isCollectionItem: !1 },
        loadPanel: { optionName: "loadPanel", isCollectionItem: !1 },
        masterDetail: { optionName: "masterDetail", isCollectionItem: !1 },
        pager: { optionName: "pager", isCollectionItem: !1 },
        paging: { optionName: "paging", isCollectionItem: !1 },
        remoteOperations: { optionName: "remoteOperations", isCollectionItem: !1 },
        rowDragging: { optionName: "rowDragging", isCollectionItem: !1 },
        scrolling: { optionName: "scrolling", isCollectionItem: !1 },
        searchPanel: { optionName: "searchPanel", isCollectionItem: !1 },
        selection: { optionName: "selection", isCollectionItem: !1 },
        sortByGroupSummaryInfo: { optionName: "sortByGroupSummaryInfo", isCollectionItem: !0 },
        sorting: { optionName: "sorting", isCollectionItem: !1 },
        stateStoring: { optionName: "stateStoring", isCollectionItem: !1 },
        summary: { optionName: "summary", isCollectionItem: !1 },
        toolbar: { optionName: "toolbar", isCollectionItem: !1 }
      }, i._templateProps = [{
        tmplOption: "dataRowTemplate",
        render: "dataRowRender",
        component: "dataRowComponent",
        keyFn: "dataRowKeyFn"
      }, {
        tmplOption: "rowTemplate",
        render: "rowRender",
        component: "rowComponent",
        keyFn: "rowKeyFn"
      }], i;
    }
    return Object.defineProperty(e.prototype, "instance", {
      get: function() {
        return this._instance;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(bq)
);
fV.propTypes = {
  accessKey: re.string,
  activeStateEnabled: re.bool,
  allowColumnReordering: re.bool,
  allowColumnResizing: re.bool,
  autoNavigateToFocusedRow: re.bool,
  cacheEnabled: re.bool,
  cellHintEnabled: re.bool,
  columnAutoWidth: re.bool,
  columnChooser: re.object,
  columnFixing: re.object,
  columnHidingEnabled: re.bool,
  columnMinWidth: re.number,
  columnResizingMode: re.oneOfType([
    re.string,
    re.oneOf([
      "nextColumn",
      "widget"
    ])
  ]),
  columns: re.array,
  columnWidth: re.oneOfType([
    re.number,
    re.oneOfType([
      re.string,
      re.oneOf([
        "auto"
      ])
    ])
  ]),
  customizeColumns: re.func,
  dateSerializationFormat: re.string,
  disabled: re.bool,
  editing: re.object,
  elementAttr: re.object,
  errorRowEnabled: re.bool,
  export: re.object,
  filterBuilder: re.object,
  filterBuilderPopup: re.object,
  filterPanel: re.object,
  filterRow: re.object,
  filterSyncEnabled: re.oneOfType([
    re.bool,
    re.oneOfType([
      re.string,
      re.oneOf([
        "auto"
      ])
    ])
  ]),
  filterValue: re.oneOfType([
    re.array,
    re.func,
    re.string
  ]),
  focusedColumnIndex: re.number,
  focusedRowEnabled: re.bool,
  focusedRowIndex: re.number,
  grouping: re.object,
  groupPanel: re.object,
  headerFilter: re.object,
  height: re.oneOfType([
    re.func,
    re.number,
    re.string
  ]),
  highlightChanges: re.bool,
  hint: re.string,
  hoverStateEnabled: re.bool,
  keyboardNavigation: re.object,
  keyExpr: re.oneOfType([
    re.array,
    re.string
  ]),
  loadPanel: re.object,
  masterDetail: re.object,
  noDataText: re.string,
  onAdaptiveDetailRowPreparing: re.func,
  onCellClick: re.func,
  onCellDblClick: re.func,
  onCellHoverChanged: re.func,
  onCellPrepared: re.func,
  onContentReady: re.func,
  onContextMenuPreparing: re.func,
  onDataErrorOccurred: re.func,
  onDisposing: re.func,
  onEditCanceled: re.func,
  onEditCanceling: re.func,
  onEditingStart: re.func,
  onEditorPrepared: re.func,
  onEditorPreparing: re.func,
  onExporting: re.func,
  onFocusedCellChanged: re.func,
  onFocusedCellChanging: re.func,
  onFocusedRowChanged: re.func,
  onFocusedRowChanging: re.func,
  onInitialized: re.func,
  onInitNewRow: re.func,
  onKeyDown: re.func,
  onOptionChanged: re.func,
  onRowClick: re.func,
  onRowCollapsed: re.func,
  onRowCollapsing: re.func,
  onRowDblClick: re.func,
  onRowExpanded: re.func,
  onRowExpanding: re.func,
  onRowInserted: re.func,
  onRowInserting: re.func,
  onRowPrepared: re.func,
  onRowRemoved: re.func,
  onRowRemoving: re.func,
  onRowUpdated: re.func,
  onRowUpdating: re.func,
  onRowValidating: re.func,
  onSaved: re.func,
  onSaving: re.func,
  onSelectionChanged: re.func,
  onToolbarPreparing: re.func,
  pager: re.object,
  paging: re.object,
  remoteOperations: re.oneOfType([
    re.bool,
    re.object,
    re.oneOfType([
      re.string,
      re.oneOf([
        "auto"
      ])
    ])
  ]),
  renderAsync: re.bool,
  repaintChangesOnly: re.bool,
  rowAlternationEnabled: re.bool,
  rowDragging: re.object,
  rtlEnabled: re.bool,
  scrolling: re.object,
  searchPanel: re.object,
  selectedRowKeys: re.array,
  selection: re.object,
  selectionFilter: re.oneOfType([
    re.array,
    re.func,
    re.string
  ]),
  showBorders: re.bool,
  showColumnHeaders: re.bool,
  showColumnLines: re.bool,
  showRowLines: re.bool,
  sortByGroupSummaryInfo: re.array,
  sorting: re.object,
  stateStoring: re.object,
  summary: re.object,
  syncLookupFilterValues: re.bool,
  tabIndex: re.number,
  toolbar: re.object,
  twoWayBindingEnabled: re.bool,
  visible: re.bool,
  width: re.oneOfType([
    re.func,
    re.number,
    re.string
  ]),
  wordWrapEnabled: re.bool
};
var f1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "animation", e.ExpectedChildren = {
      hide: { optionName: "hide", isCollectionItem: !1 },
      show: { optionName: "show", isCollectionItem: !1 }
    }, e;
  }(Qe)
), p1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "validationRules", e.IsCollectionItem = !0, e.PredefinedProps = {
      type: "async"
    }, e;
  }(Qe)
), v1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "at", e;
  }(Qe)
), g1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "boundaryOffset", e;
  }(Qe)
), vk = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "buttons", e.IsCollectionItem = !0, e.TemplateProps = [{
      tmplOption: "template",
      render: "render",
      component: "component",
      keyFn: "keyFn"
    }], e;
  }(Qe)
), m1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "changes", e.IsCollectionItem = !0, e;
  }(Qe)
), _1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "colCountByScreen", e;
  }(Qe)
), C1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "collision", e;
  }(Qe)
), dT = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "columns", e.IsCollectionItem = !0, e.DefaultsProps = {
      defaultFilterValue: "filterValue",
      defaultFilterValues: "filterValues",
      defaultGroupIndex: "groupIndex",
      defaultSelectedFilterOperation: "selectedFilterOperation",
      defaultSortIndex: "sortIndex",
      defaultSortOrder: "sortOrder",
      defaultVisible: "visible",
      defaultVisibleIndex: "visibleIndex"
    }, e.ExpectedChildren = {
      AsyncRule: { optionName: "validationRules", isCollectionItem: !0 },
      button: { optionName: "buttons", isCollectionItem: !0 },
      columnHeaderFilter: { optionName: "headerFilter", isCollectionItem: !1 },
      columnLookup: { optionName: "lookup", isCollectionItem: !1 },
      CompareRule: { optionName: "validationRules", isCollectionItem: !0 },
      CustomRule: { optionName: "validationRules", isCollectionItem: !0 },
      EmailRule: { optionName: "validationRules", isCollectionItem: !0 },
      format: { optionName: "format", isCollectionItem: !1 },
      formItem: { optionName: "formItem", isCollectionItem: !1 },
      headerFilter: { optionName: "headerFilter", isCollectionItem: !1 },
      lookup: { optionName: "lookup", isCollectionItem: !1 },
      NumericRule: { optionName: "validationRules", isCollectionItem: !0 },
      PatternRule: { optionName: "validationRules", isCollectionItem: !0 },
      RangeRule: { optionName: "validationRules", isCollectionItem: !0 },
      RequiredRule: { optionName: "validationRules", isCollectionItem: !0 },
      StringLengthRule: { optionName: "validationRules", isCollectionItem: !0 },
      validationRule: { optionName: "validationRules", isCollectionItem: !0 }
    }, e.TemplateProps = [{
      tmplOption: "cellTemplate",
      render: "cellRender",
      component: "cellComponent",
      keyFn: "cellKeyFn"
    }, {
      tmplOption: "editCellTemplate",
      render: "editCellRender",
      component: "editCellComponent",
      keyFn: "editCellKeyFn"
    }, {
      tmplOption: "groupCellTemplate",
      render: "groupCellRender",
      component: "groupCellComponent",
      keyFn: "groupCellKeyFn"
    }, {
      tmplOption: "headerCellTemplate",
      render: "headerCellRender",
      component: "headerCellComponent",
      keyFn: "headerCellKeyFn"
    }], e;
  }(Qe)
), vBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "columnChooser", e.ExpectedChildren = {
      columnChooserSearch: { optionName: "search", isCollectionItem: !1 },
      columnChooserSelection: { optionName: "selection", isCollectionItem: !1 },
      position: { optionName: "position", isCollectionItem: !1 },
      search: { optionName: "search", isCollectionItem: !1 },
      selection: { optionName: "selection", isCollectionItem: !1 }
    }, e;
  }(Qe)
), gBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "search", e;
  }(Qe)
), mBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "selection", e;
  }(Qe)
), y1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "columnFixing", e.ExpectedChildren = {
      columnFixingTexts: { optionName: "texts", isCollectionItem: !1 },
      texts: { optionName: "texts", isCollectionItem: !1 }
    }, e;
  }(Qe)
), x1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "texts", e;
  }(Qe)
), S1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "headerFilter", e.ExpectedChildren = {
      columnHeaderFilterSearch: { optionName: "search", isCollectionItem: !1 },
      search: { optionName: "search", isCollectionItem: !1 }
    }, e;
  }(Qe)
), E1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "search", e;
  }(Qe)
), b1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "lookup", e;
  }(Qe)
), w1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "validationRules", e.IsCollectionItem = !0, e.PredefinedProps = {
      type: "compare"
    }, e;
  }(Qe)
), T1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "cursorOffset", e;
  }(Qe)
), I1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "customOperations", e.IsCollectionItem = !0, e.TemplateProps = [{
      tmplOption: "editorTemplate",
      render: "editorRender",
      component: "editorComponent",
      keyFn: "editorKeyFn"
    }], e;
  }(Qe)
), D1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "validationRules", e.IsCollectionItem = !0, e.PredefinedProps = {
      type: "custom"
    }, e;
  }(Qe)
), A1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "headerFilter", e.ExpectedChildren = {
      dataGridHeaderFilterSearch: { optionName: "search", isCollectionItem: !1 },
      dataGridHeaderFilterTexts: { optionName: "texts", isCollectionItem: !1 },
      search: { optionName: "search", isCollectionItem: !1 },
      texts: { optionName: "texts", isCollectionItem: !1 }
    }, e;
  }(Qe)
), O1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "search", e;
  }(Qe)
), R1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "texts", e;
  }(Qe)
), L1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "selection", e;
  }(Qe)
), _Be = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "editing", e.DefaultsProps = {
      defaultChanges: "changes",
      defaultEditColumnName: "editColumnName",
      defaultEditRowKey: "editRowKey"
    }, e.ExpectedChildren = {
      change: { optionName: "changes", isCollectionItem: !0 },
      editingTexts: { optionName: "texts", isCollectionItem: !1 },
      form: { optionName: "form", isCollectionItem: !1 },
      popup: { optionName: "popup", isCollectionItem: !1 },
      texts: { optionName: "texts", isCollectionItem: !1 }
    }, e;
  }(Qe)
), M1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "texts", e;
  }(Qe)
), CBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "validationRules", e.IsCollectionItem = !0, e.PredefinedProps = {
      type: "email"
    }, e;
  }(Qe)
), yBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "export", e.ExpectedChildren = {
      exportTexts: { optionName: "texts", isCollectionItem: !1 },
      texts: { optionName: "texts", isCollectionItem: !1 }
    }, e;
  }(Qe)
), k1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "texts", e;
  }(Qe)
), P1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "fields", e.IsCollectionItem = !0, e.ExpectedChildren = {
      fieldLookup: { optionName: "lookup", isCollectionItem: !1 },
      format: { optionName: "format", isCollectionItem: !1 },
      lookup: { optionName: "lookup", isCollectionItem: !1 }
    }, e.TemplateProps = [{
      tmplOption: "editorTemplate",
      render: "editorRender",
      component: "editorComponent",
      keyFn: "editorKeyFn"
    }], e;
  }(Qe)
), F1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "lookup", e;
  }(Qe)
), B1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "filterBuilder", e.DefaultsProps = {
      defaultValue: "value"
    }, e.ExpectedChildren = {
      customOperation: { optionName: "customOperations", isCollectionItem: !0 },
      field: { optionName: "fields", isCollectionItem: !0 },
      filterOperationDescriptions: { optionName: "filterOperationDescriptions", isCollectionItem: !1 },
      groupOperationDescriptions: { optionName: "groupOperationDescriptions", isCollectionItem: !1 }
    }, e;
  }(Qe)
), V1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "filterBuilderPopup", e.DefaultsProps = {
      defaultHeight: "height",
      defaultPosition: "position",
      defaultVisible: "visible",
      defaultWidth: "width"
    }, e.TemplateProps = [{
      tmplOption: "contentTemplate",
      render: "contentRender",
      component: "contentComponent",
      keyFn: "contentKeyFn"
    }, {
      tmplOption: "titleTemplate",
      render: "titleRender",
      component: "titleComponent",
      keyFn: "titleKeyFn"
    }], e;
  }(Qe)
), N1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "filterOperationDescriptions", e;
  }(Qe)
), H1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "filterPanel", e.DefaultsProps = {
      defaultFilterEnabled: "filterEnabled"
    }, e.ExpectedChildren = {
      filterPanelTexts: { optionName: "texts", isCollectionItem: !1 },
      texts: { optionName: "texts", isCollectionItem: !1 }
    }, e;
  }(Qe)
), $1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "texts", e;
  }(Qe)
), q9 = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "filterRow", e.ExpectedChildren = {
      operationDescriptions: { optionName: "operationDescriptions", isCollectionItem: !1 }
    }, e;
  }(Qe)
), z1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "form", e.DefaultsProps = {
      defaultFormData: "formData"
    }, e.ExpectedChildren = {
      colCountByScreen: { optionName: "colCountByScreen", isCollectionItem: !1 }
    }, e;
  }(Qe)
), W1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "format", e;
  }(Qe)
), U1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "formItem", e.ExpectedChildren = {
      AsyncRule: { optionName: "validationRules", isCollectionItem: !0 },
      CompareRule: { optionName: "validationRules", isCollectionItem: !0 },
      CustomRule: { optionName: "validationRules", isCollectionItem: !0 },
      EmailRule: { optionName: "validationRules", isCollectionItem: !0 },
      label: { optionName: "label", isCollectionItem: !1 },
      NumericRule: { optionName: "validationRules", isCollectionItem: !0 },
      PatternRule: { optionName: "validationRules", isCollectionItem: !0 },
      RangeRule: { optionName: "validationRules", isCollectionItem: !0 },
      RequiredRule: { optionName: "validationRules", isCollectionItem: !0 },
      StringLengthRule: { optionName: "validationRules", isCollectionItem: !0 },
      validationRule: { optionName: "validationRules", isCollectionItem: !0 }
    }, e.TemplateProps = [{
      tmplOption: "template",
      render: "render",
      component: "component",
      keyFn: "keyFn"
    }], e;
  }(Qe)
), G1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "from", e.ExpectedChildren = {
      position: { optionName: "position", isCollectionItem: !1 }
    }, e;
  }(Qe)
), K1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "grouping", e.ExpectedChildren = {
      groupingTexts: { optionName: "texts", isCollectionItem: !1 },
      texts: { optionName: "texts", isCollectionItem: !1 }
    }, e;
  }(Qe)
), j1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "texts", e;
  }(Qe)
), Y1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "groupItems", e.IsCollectionItem = !0, e.ExpectedChildren = {
      valueFormat: { optionName: "valueFormat", isCollectionItem: !1 }
    }, e;
  }(Qe)
), q1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "groupOperationDescriptions", e;
  }(Qe)
), xBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "groupPanel", e.DefaultsProps = {
      defaultVisible: "visible"
    }, e;
  }(Qe)
), SBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "headerFilter", e;
  }(Qe)
), X1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "hide", e.ExpectedChildren = {
      from: { optionName: "from", isCollectionItem: !1 },
      to: { optionName: "to", isCollectionItem: !1 }
    }, e;
  }(Qe)
), Yy = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "items", e.IsCollectionItem = !0, e.TemplateProps = [{
      tmplOption: "menuItemTemplate",
      render: "menuItemRender",
      component: "menuItemComponent",
      keyFn: "menuItemKeyFn"
    }, {
      tmplOption: "template",
      render: "render",
      component: "component",
      keyFn: "keyFn"
    }], e;
  }(Qe)
), Q1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "keyboardNavigation", e;
  }(Qe)
), Z1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "label", e.TemplateProps = [{
      tmplOption: "template",
      render: "render",
      component: "component",
      keyFn: "keyFn"
    }], e;
  }(Qe)
), X9 = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "loadPanel", e;
  }(Qe)
), EBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "lookup", e;
  }(Qe)
), bBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "masterDetail", e.TemplateProps = [{
      tmplOption: "template",
      render: "render",
      component: "component",
      keyFn: "keyFn"
    }], e;
  }(Qe)
), J1e = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "my", e;
  }(Qe)
), eNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "validationRules", e.IsCollectionItem = !0, e.PredefinedProps = {
      type: "numeric"
    }, e;
  }(Qe)
), tNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "offset", e;
  }(Qe)
), iNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "operationDescriptions", e;
  }(Qe)
), wBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "pager", e;
  }(Qe)
), TBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "paging", e.DefaultsProps = {
      defaultPageIndex: "pageIndex",
      defaultPageSize: "pageSize"
    }, e;
  }(Qe)
), rNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "validationRules", e.IsCollectionItem = !0, e.PredefinedProps = {
      type: "pattern"
    }, e;
  }(Qe)
), nNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "popup", e.DefaultsProps = {
      defaultHeight: "height",
      defaultPosition: "position",
      defaultVisible: "visible",
      defaultWidth: "width"
    }, e.ExpectedChildren = {
      animation: { optionName: "animation", isCollectionItem: !1 },
      position: { optionName: "position", isCollectionItem: !1 },
      toolbarItem: { optionName: "toolbarItems", isCollectionItem: !0 }
    }, e.TemplateProps = [{
      tmplOption: "contentTemplate",
      render: "contentRender",
      component: "contentComponent",
      keyFn: "contentKeyFn"
    }, {
      tmplOption: "titleTemplate",
      render: "titleRender",
      component: "titleComponent",
      keyFn: "titleKeyFn"
    }], e;
  }(Qe)
), aNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "position", e;
  }(Qe)
), oNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "validationRules", e.IsCollectionItem = !0, e.PredefinedProps = {
      type: "range"
    }, e;
  }(Qe)
), sNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "remoteOperations", e;
  }(Qe)
), IBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "validationRules", e.IsCollectionItem = !0, e.PredefinedProps = {
      type: "required"
    }, e;
  }(Qe)
), DBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "rowDragging", e.ExpectedChildren = {
      cursorOffset: { optionName: "cursorOffset", isCollectionItem: !1 }
    }, e.TemplateProps = [{
      tmplOption: "dragTemplate",
      render: "dragRender",
      component: "dragComponent",
      keyFn: "dragKeyFn"
    }], e;
  }(Qe)
), ABe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "scrolling", e;
  }(Qe)
), lNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "search", e;
  }(Qe)
), OBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "searchPanel", e.DefaultsProps = {
      defaultText: "text"
    }, e;
  }(Qe)
), Q9 = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "selection", e;
  }(Qe)
), uNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "show", e;
  }(Qe)
), dNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "sortByGroupSummaryInfo", e.IsCollectionItem = !0, e;
  }(Qe)
), RBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "sorting", e;
  }(Qe)
), LBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "stateStoring", e;
  }(Qe)
), cNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "validationRules", e.IsCollectionItem = !0, e.PredefinedProps = {
      type: "stringLength"
    }, e;
  }(Qe)
), MBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "summary", e.ExpectedChildren = {
      groupItem: { optionName: "groupItems", isCollectionItem: !0 },
      summaryTexts: { optionName: "texts", isCollectionItem: !1 },
      texts: { optionName: "texts", isCollectionItem: !1 },
      totalItem: { optionName: "totalItems", isCollectionItem: !0 }
    }, e;
  }(Qe)
), hNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "texts", e;
  }(Qe)
), fNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "texts", e;
  }(Qe)
), pNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "to", e;
  }(Qe)
), kBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "toolbar", e.ExpectedChildren = {
      item: { optionName: "items", isCollectionItem: !0 }
    }, e;
  }(Qe)
), vNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "toolbarItems", e.IsCollectionItem = !0, e.TemplateProps = [{
      tmplOption: "menuItemTemplate",
      render: "menuItemRender",
      component: "menuItemComponent",
      keyFn: "menuItemKeyFn"
    }, {
      tmplOption: "template",
      render: "render",
      component: "component",
      keyFn: "keyFn"
    }], e;
  }(Qe)
), PBe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "totalItems", e.IsCollectionItem = !0, e.ExpectedChildren = {
      valueFormat: { optionName: "valueFormat", isCollectionItem: !1 }
    }, e;
  }(Qe)
), gNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "validationRules", e.IsCollectionItem = !0, e.PredefinedProps = {
      type: "required"
    }, e;
  }(Qe)
), mNe = (
  /** @class */
  function(t) {
    qe(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.OptionName = "valueFormat", e;
  }(Qe)
);
const FBe = YF("kanela:datagrid:detail");
function BBe(t) {
  const {
    allowFiltering: e = !1,
    columns: i = [],
    dataSource: r = [],
    selection: n = "none"
  } = t, a = !Array.isArray(r) && typeof r != "string" && !qF.isUndefined(r.url) ? {
    url: r.url,
    args: {
      body: r.parameter,
      headers: r.headers,
      method: r.method,
      namespace: r.namespace
    }
  } : null, { data: o } = Wq(a, Mq, {}), u = Array.isArray(r) ? r : o;
  return FBe("render detail"), /* @__PURE__ */ ni.jsxs(
    fV,
    {
      allowColumnReordering: !0,
      allowColumnResizing: !0,
      cacheEnabled: !0,
      columnAutoWidth: !0,
      dataSource: u,
      onSelectionChanged: t.onClick,
      showBorders: !0,
      width: "100%",
      children: [
        /* @__PURE__ */ ni.jsx(X9, { enabled: !0 }),
        /* @__PURE__ */ ni.jsx(q9, { visible: e }),
        /* @__PURE__ */ ni.jsx(Q9, { mode: n, showCheckBoxesMode: "always" }),
        i.map((c) => /* @__PURE__ */ ni.jsx(
          dT,
          {
            caption: c.label,
            dataField: c.name,
            dataType: c.type !== "select" && c.type !== "email" && c.type !== "link" ? c.type : "string",
            visible: c.visible
          },
          c.name
        ))
      ]
    }
  );
}
const VBe = {
  Yes: "Sí",
  No: "No",
  Cancel: "Cancelar",
  Close: "Cerca",
  Clear: "Limpiar",
  Done: "Hecho",
  Loading: "Cargando...",
  Select: "Seleccionar...",
  Search: "Buscar",
  Back: "Volver",
  OK: "Aceptar",
  "dxCollectionWidget-noDataText": "Sin datos para mostrar",
  "dxDropDownEditor-selectLabel": "Seleccionar",
  "validation-required": "Obligatorio",
  "validation-required-formatted": "{0} es obligatorio",
  "validation-numeric": "Valor debe ser un número",
  "validation-numeric-formatted": "{0} debe ser un número",
  "validation-range": "Valor fuera de rango",
  "validation-range-formatted": "{0} fuera de rango",
  "validation-stringLength": "El tamaño del valor es incorrecto",
  "validation-stringLength-formatted": "El tamaño de {0} es incorrecto",
  "validation-custom": "Valor inválido",
  "validation-custom-formatted": "{0} inválido",
  "validation-async": "Valor inválido",
  "validation-async-formatted": "{0} inválido",
  "validation-compare": "Valores no coinciden",
  "validation-compare-formatted": "{0} no coinciden",
  "validation-pattern": "Valor no coincide con el patrón",
  "validation-pattern-formatted": "{0} no coincide con el patrón",
  "validation-email": "Email inválido",
  "validation-email-formatted": "{0} inválido",
  "validation-mask": "Valor inválido",
  "dxLookup-searchPlaceholder": "Cantidad mínima de caracteres: {0}",
  "dxList-pullingDownText": "Desliza hacia abajo para actualizar...",
  "dxList-pulledDownText": "Suelta para actualizar...",
  "dxList-refreshingText": "Actualizando...",
  "dxList-pageLoadingText": "Cargando...",
  "dxList-nextButtonText": "Más",
  "dxList-selectAll": "Seleccionar Todo",
  "dxListEditDecorator-delete": "Eliminar",
  "dxListEditDecorator-more": "Más",
  "dxScrollView-pullingDownText": "Desliza hacia abajo para actualizar...",
  "dxScrollView-pulledDownText": "Suelta para actualizar...",
  "dxScrollView-refreshingText": "Actualizando...",
  "dxScrollView-reachBottomText": "Cargando...",
  "dxDateBox-simulatedDataPickerTitleTime": "Seleccione hora",
  "dxDateBox-simulatedDataPickerTitleDate": "Seleccione fecha",
  "dxDateBox-simulatedDataPickerTitleDateTime": "Seleccione fecha y hora",
  "dxDateBox-validation-datetime": "Valor debe ser una fecha u hora",
  "dxDateRangeBox-invalidStartDateMessage": "Start value must be a date",
  "dxDateRangeBox-invalidEndDateMessage": "End value must be a date",
  "dxDateRangeBox-startDateOutOfRangeMessage": "Start date is out of range",
  "dxDateRangeBox-endDateOutOfRangeMessage": "End date is out of range",
  "dxDateRangeBox-startDateLabel": "Fecha inicial",
  "dxDateRangeBox-endDateLabel": "Fecha final",
  "dxFileUploader-selectFile": "Seleccionar archivo",
  "dxFileUploader-dropFile": "o arrastre un archivo aquí",
  "dxFileUploader-bytes": "bytes",
  "dxFileUploader-kb": "KB",
  "dxFileUploader-Mb": "MB",
  "dxFileUploader-Gb": "GB",
  "dxFileUploader-upload": "Subir",
  "dxFileUploader-uploaded": "Subido",
  "dxFileUploader-readyToUpload": "Listo para subir",
  "dxFileUploader-uploadAbortedMessage": "Upload cancelled",
  "dxFileUploader-uploadFailedMessage": "Falla ao subir",
  "dxFileUploader-invalidFileExtension": "Tipo de archivo no está permitido",
  "dxFileUploader-invalidMaxFileSize": "Archivo es muy grande",
  "dxFileUploader-invalidMinFileSize": "Archivo es muy pequeño",
  "dxRangeSlider-ariaFrom": "Desde",
  "dxRangeSlider-ariaTill": "Hasta",
  "dxSwitch-switchedOnText": "ENCENDIDO",
  "dxSwitch-switchedOffText": "APAGADO",
  "dxForm-optionalMark": "opcional",
  "dxForm-requiredMessage": "{0} es obligatorio",
  "dxNumberBox-invalidValueMessage": "Valor debe ser un número",
  "dxNumberBox-noDataText": "Sin datos",
  "dxDataGrid-emptyHeaderWithColumnChooserText": "Use {0} to display columns",
  "dxDataGrid-emptyHeaderWithGroupPanelText": "Drag a column from the group panel here",
  "dxDataGrid-emptyHeaderWithColumnChooserAndGroupPanelText": "Use {0} or drag a column from the group panel",
  "dxDataGrid-emptyHeaderColumnChooserText": "column chooser",
  "dxDataGrid-columnChooserTitle": "Selector de Columnas",
  "dxDataGrid-columnChooserEmptyText": "Arrastra una columna aquí para ocultarla",
  "dxDataGrid-groupContinuesMessage": "Continúa en la página siguiente",
  "dxDataGrid-groupContinuedMessage": "Continuación de la página anterior",
  "dxDataGrid-groupHeaderText": "Agrupar por esta columna",
  "dxDataGrid-ungroupHeaderText": "Desagrupar",
  "dxDataGrid-ungroupAllText": "Desagrupar Todo",
  "dxDataGrid-editingEditRow": "Modificar",
  "dxDataGrid-editingSaveRowChanges": "Guardar",
  "dxDataGrid-editingCancelRowChanges": "Cancelar",
  "dxDataGrid-editingDeleteRow": "Eliminar",
  "dxDataGrid-editingUndeleteRow": "Recuperar",
  "dxDataGrid-editingConfirmDeleteMessage": "¿Está seguro que desea eliminar este registro?",
  "dxDataGrid-validationCancelChanges": "Cancelar cambios",
  "dxDataGrid-groupPanelEmptyText": "Arrastra una columna aquí para agrupar por ella",
  "dxDataGrid-noDataText": "Sin datos",
  "dxDataGrid-searchPanelPlaceholder": "Buscar...",
  "dxDataGrid-filterRowShowAllText": "(Todos)",
  "dxDataGrid-filterRowResetOperationText": "Reestablecer",
  "dxDataGrid-filterRowOperationEquals": "Igual",
  "dxDataGrid-filterRowOperationNotEquals": "No es igual",
  "dxDataGrid-filterRowOperationLess": "Menor que",
  "dxDataGrid-filterRowOperationLessOrEquals": "Menor o igual a",
  "dxDataGrid-filterRowOperationGreater": "Mayor que",
  "dxDataGrid-filterRowOperationGreaterOrEquals": "Mayor o igual a",
  "dxDataGrid-filterRowOperationStartsWith": "Empieza con",
  "dxDataGrid-filterRowOperationContains": "Contiene",
  "dxDataGrid-filterRowOperationNotContains": "No contiene",
  "dxDataGrid-filterRowOperationEndsWith": "Termina con",
  "dxDataGrid-filterRowOperationBetween": "Entre",
  "dxDataGrid-filterRowOperationBetweenStartText": "Inicio",
  "dxDataGrid-filterRowOperationBetweenEndText": "Fin",
  "dxDataGrid-ariaSearchBox": "Search box",
  "dxDataGrid-applyFilterText": "Filtrar",
  "dxDataGrid-trueText": "verdadero",
  "dxDataGrid-falseText": "falso",
  "dxDataGrid-sortingAscendingText": "Orden Ascendente",
  "dxDataGrid-sortingDescendingText": "Orden Descendente",
  "dxDataGrid-sortingClearText": "Limpiar Ordenamiento",
  "dxDataGrid-ariaNotSortedColumn": "Not sorted column",
  "dxDataGrid-ariaSortedAscendingColumn": "Column sorted in ascending order",
  "dxDataGrid-ariaSortedDescendingColumn": "Column sorted in descending order",
  "dxDataGrid-ariaSortIndex": "Sort index {0}",
  "dxDataGrid-editingSaveAllChanges": "Guardar cambios",
  "dxDataGrid-editingCancelAllChanges": "Descartar cambios",
  "dxDataGrid-editingAddRow": "Agregar una fila",
  "dxDataGrid-summaryMin": "Mín: {0}",
  "dxDataGrid-summaryMinOtherColumn": "Mín de {1} es {0}",
  "dxDataGrid-summaryMax": "Máx: {0}",
  "dxDataGrid-summaryMaxOtherColumn": "Máx de {1} es {0}",
  "dxDataGrid-summaryAvg": "Prom: {0}",
  "dxDataGrid-summaryAvgOtherColumn": "Prom de {1} es {0}",
  "dxDataGrid-summarySum": "Suma: {0}",
  "dxDataGrid-summarySumOtherColumn": "Suma de {1} es {0}",
  "dxDataGrid-summaryCount": "Cantidad: {0}",
  "dxDataGrid-columnFixingFix": "Anclar",
  "dxDataGrid-columnFixingUnfix": "Desanclar",
  "dxDataGrid-columnFixingLeftPosition": "A la izquierda",
  "dxDataGrid-columnFixingRightPosition": "A la derecha",
  "dxDataGrid-exportTo": "Exportar",
  "dxDataGrid-exportToExcel": "Exportar a archivo Excel",
  "dxDataGrid-exporting": "Exportar...",
  "dxDataGrid-excelFormat": "Archivo Excel",
  "dxDataGrid-selectedRows": "Filas seleccionadas",
  "dxDataGrid-exportSelectedRows": "Exportar filas seleccionadas a {0}",
  "dxDataGrid-exportAll": "Exportar todo a {0}",
  "dxDataGrid-headerFilterLabel": "Filter options",
  "dxDataGrid-headerFilterIndicatorLabel": "Show filter options for column '{0}'",
  "dxDataGrid-headerFilterEmptyValue": "(Vacio)",
  "dxDataGrid-headerFilterOK": "Aceptar",
  "dxDataGrid-headerFilterCancel": "Cancelar",
  "dxDataGrid-ariaAdaptiveCollapse": "Hide additional data",
  "dxDataGrid-ariaAdaptiveExpand": "Display additional data",
  "dxDataGrid-ariaColumn": "Columna",
  "dxDataGrid-ariaColumnHeader": "Column header",
  "dxDataGrid-ariaValue": "Valor",
  "dxDataGrid-ariaError": "Error",
  "dxDataGrid-ariaRevertButton": "Press Escape to discard the changes",
  "dxDataGrid-ariaFilterCell": "Celda de filtro",
  "dxDataGrid-ariaCollapse": "Colapsar",
  "dxDataGrid-ariaModifiedCell": "Modified",
  "dxDataGrid-ariaDeletedCell": "Deleted",
  "dxDataGrid-ariaEditableCell": "Editable",
  "dxDataGrid-ariaExpand": "Expandir",
  "dxDataGrid-ariaCollapsedRow": "Collapsed row",
  "dxDataGrid-ariaExpandedRow": "Expanded row",
  "dxDataGrid-ariaDataGrid": "Tabla de datos",
  "dxDataGrid-ariaSearchInGrid": "Buscar en la tabla de datos",
  "dxDataGrid-ariaSelectAll": "Seleccionar todo",
  "dxDataGrid-ariaSelectRow": "Seleccionar fila",
  "dxDataGrid-ariaToolbar": "Data grid toolbar",
  "dxDataGrid-ariaEditForm": "Edit form",
  "dxDataGrid-filterBuilderPopupTitle": "Constructor de filtro",
  "dxDataGrid-filterPanelCreateFilter": "Crear filtro",
  "dxDataGrid-filterPanelClearFilter": "Limpiar filtro",
  "dxDataGrid-filterPanelFilterEnabledHint": "Habilitar filtro",
  "dxTreeList-ariaTreeList": "Tree list with {0} rows and {1} columns",
  "dxTreeList-ariaSearchInGrid": "Search in the tree list",
  "dxTreeList-ariaToolbar": "Tree list toolbar",
  "dxTreeList-editingAddRowToNode": "Añadir",
  "dxPager-infoText": "Página {0} de {1} ({2} ítems)",
  "dxPager-pagesCountText": "de",
  "dxPager-pageSize": "Items per page: {0}",
  "dxPager-pageSizesAllText": "Todos",
  "dxPager-page": "Page {0}",
  "dxPager-prevPage": "Previous Page",
  "dxPager-nextPage": "Next Page",
  "dxPager-ariaLabel": "Page Navigation",
  "dxPager-ariaPageSize": "Page size",
  "dxPager-ariaPageNumber": "Page number",
  "dxPivotGrid-grandTotal": "Gran Total",
  "dxPivotGrid-total": "{0} Total",
  "dxPivotGrid-fieldChooserTitle": "Selector de Campos",
  "dxPivotGrid-showFieldChooser": "Mostrar Selector de Campos",
  "dxPivotGrid-expandAll": "Expandir Todo",
  "dxPivotGrid-collapseAll": "Colapsar Todo",
  "dxPivotGrid-sortColumnBySummary": 'Ordenar "{0}" por esta columna',
  "dxPivotGrid-sortRowBySummary": 'Ordenar "{0}" por esta fila',
  "dxPivotGrid-removeAllSorting": "Remover ordenamiento",
  "dxPivotGrid-dataNotAvailable": "N/A",
  "dxPivotGrid-rowFields": "Campos de fila",
  "dxPivotGrid-columnFields": "Campos de columna",
  "dxPivotGrid-dataFields": "Campos de dato",
  "dxPivotGrid-filterFields": "Campos de filtro",
  "dxPivotGrid-allFields": "Todos los campos",
  "dxPivotGrid-columnFieldArea": "Arrastra campos de columna aquí",
  "dxPivotGrid-dataFieldArea": "Arrastra campos de dato aquí",
  "dxPivotGrid-rowFieldArea": "Arrastra campos de fila aquí",
  "dxPivotGrid-filterFieldArea": "Arrastra campos de filtro aquí",
  "dxScheduler-editorLabelTitle": "Asunto",
  "dxScheduler-editorLabelStartDate": "Fecha inicial",
  "dxScheduler-editorLabelEndDate": "Fecha final",
  "dxScheduler-editorLabelDescription": "Descripción",
  "dxScheduler-editorLabelRecurrence": "Repetir",
  "dxScheduler-openAppointment": "Abrir cita",
  "dxScheduler-recurrenceNever": "Nunca",
  "dxScheduler-recurrenceMinutely": "Minutely",
  "dxScheduler-recurrenceHourly": "Hourly",
  "dxScheduler-recurrenceDaily": "Diario",
  "dxScheduler-recurrenceWeekly": "Semanal",
  "dxScheduler-recurrenceMonthly": "Mensual",
  "dxScheduler-recurrenceYearly": "Anual",
  "dxScheduler-recurrenceRepeatEvery": "Cada",
  "dxScheduler-recurrenceRepeatOn": "Repeat On",
  "dxScheduler-recurrenceEnd": "Terminar repetición",
  "dxScheduler-recurrenceAfter": "Después",
  "dxScheduler-recurrenceOn": "En",
  "dxScheduler-recurrenceRepeatMinutely": "minute(s)",
  "dxScheduler-recurrenceRepeatHourly": "hour(s)",
  "dxScheduler-recurrenceRepeatDaily": "día(s)",
  "dxScheduler-recurrenceRepeatWeekly": "semana(s)",
  "dxScheduler-recurrenceRepeatMonthly": "mes(es)",
  "dxScheduler-recurrenceRepeatYearly": "año(s)",
  "dxScheduler-switcherDay": "Día",
  "dxScheduler-switcherWeek": "Semana",
  "dxScheduler-switcherWorkWeek": "Semana Laboral",
  "dxScheduler-switcherMonth": "Mes",
  "dxScheduler-switcherAgenda": "Agenda",
  "dxScheduler-switcherTimelineDay": "Línea de tiempo Día",
  "dxScheduler-switcherTimelineWeek": "Línea de tiempo Semana",
  "dxScheduler-switcherTimelineWorkWeek": "Línea de tiempo Semana Laboral",
  "dxScheduler-switcherTimelineMonth": "Línea de tiempo Mes",
  "dxScheduler-recurrenceRepeatOnDate": "en la fecha",
  "dxScheduler-recurrenceRepeatCount": "ocurrencia(s)",
  "dxScheduler-allDay": "Todo el día",
  "dxScheduler-confirmRecurrenceEditTitle": "Edit Recurring Appointment",
  "dxScheduler-confirmRecurrenceDeleteTitle": "Delete Recurring Appointment",
  "dxScheduler-confirmRecurrenceEditMessage": "¿Quiere modificar solo esta cita o toda la serie?",
  "dxScheduler-confirmRecurrenceDeleteMessage": "¿Quiere eliminar solo esta cita o toda la serie?",
  "dxScheduler-confirmRecurrenceEditSeries": "Modificar serie",
  "dxScheduler-confirmRecurrenceDeleteSeries": "Eliminar serie",
  "dxScheduler-confirmRecurrenceEditOccurrence": "Modificar cita",
  "dxScheduler-confirmRecurrenceDeleteOccurrence": "Eliminar cita",
  "dxScheduler-noTimezoneTitle": "Sin zona horaria",
  "dxScheduler-moreAppointments": "{0} más",
  "dxCalendar-todayButtonText": "Hoy",
  "dxCalendar-ariaWidgetName": "Calendario",
  "dxCalendar-previousMonthButtonLabel": "Previous month",
  "dxCalendar-previousYearButtonLabel": "Previous year",
  "dxCalendar-previousDecadeButtonLabel": "Previous decade",
  "dxCalendar-previousCenturyButtonLabel": "Previous century",
  "dxCalendar-nextMonthButtonLabel": "Next month",
  "dxCalendar-nextYearButtonLabel": "Next year",
  "dxCalendar-nextDecadeButtonLabel": "Next decade",
  "dxCalendar-nextCenturyButtonLabel": "Next century",
  "dxCalendar-captionMonthLabel": "Month selection",
  "dxCalendar-captionYearLabel": "Year selection",
  "dxCalendar-captionDecadeLabel": "Decade selection",
  "dxCalendar-captionCenturyLabel": "Century selection",
  "dxColorView-ariaRed": "Rojo",
  "dxColorView-ariaGreen": "Verde",
  "dxColorView-ariaBlue": "Azul",
  "dxColorView-ariaAlpha": "Transparencia",
  "dxColorView-ariaHex": "Código del color",
  "dxTagBox-selected": "{0} seleccionado",
  "dxTagBox-allSelected": "Todos seleccionados ({0})",
  "dxTagBox-moreSelected": "{0} más",
  "vizExport-printingButtonText": "Imprimir",
  "vizExport-titleMenuText": "Exportar/Imprimir",
  "vizExport-exportButtonText": "Archivo {0}",
  "dxFilterBuilder-and": "Y",
  "dxFilterBuilder-or": "O",
  "dxFilterBuilder-notAnd": "NO Y",
  "dxFilterBuilder-notOr": "NO O",
  "dxFilterBuilder-addCondition": "Añadir condición",
  "dxFilterBuilder-addGroup": "Añadir Grupo",
  "dxFilterBuilder-enterValueText": "<rellene con un valor>",
  "dxFilterBuilder-filterOperationEquals": "Igual",
  "dxFilterBuilder-filterOperationNotEquals": "Diferente",
  "dxFilterBuilder-filterOperationLess": "Menos que",
  "dxFilterBuilder-filterOperationLessOrEquals": "Menor o igual que",
  "dxFilterBuilder-filterOperationGreater": "Más grande que",
  "dxFilterBuilder-filterOperationGreaterOrEquals": "Mayor o igual que",
  "dxFilterBuilder-filterOperationStartsWith": "Comienza con",
  "dxFilterBuilder-filterOperationContains": "Contiene",
  "dxFilterBuilder-filterOperationNotContains": "No contiene",
  "dxFilterBuilder-filterOperationEndsWith": "Termina con",
  "dxFilterBuilder-filterOperationIsBlank": "Vacío",
  "dxFilterBuilder-filterOperationIsNotBlank": "No vacío",
  "dxFilterBuilder-filterOperationBetween": "Entre",
  "dxFilterBuilder-filterOperationAnyOf": "Alguno de",
  "dxFilterBuilder-filterOperationNoneOf": "Ningún de",
  "dxHtmlEditor-dialogColorCaption": "Cambiar el color de la fuente",
  "dxHtmlEditor-dialogBackgroundCaption": "Cambiar el color de fondo",
  "dxHtmlEditor-dialogLinkCaption": "Añadir enlace",
  "dxHtmlEditor-dialogLinkUrlField": "URL",
  "dxHtmlEditor-dialogLinkTextField": "Texto",
  "dxHtmlEditor-dialogLinkTargetField": "Abrir enlace en nueva ventana",
  "dxHtmlEditor-dialogImageCaption": "Añadir imagen",
  "dxHtmlEditor-dialogImageUrlField": "URL",
  "dxHtmlEditor-dialogImageAltField": "Texto alternativo",
  "dxHtmlEditor-dialogImageWidthField": "Anchura (px)",
  "dxHtmlEditor-dialogImageHeightField": "Altura (px)",
  "dxHtmlEditor-dialogInsertTableRowsField": "Rows",
  "dxHtmlEditor-dialogInsertTableColumnsField": "Columns",
  "dxHtmlEditor-dialogInsertTableCaption": "Insert Table",
  "dxHtmlEditor-dialogUpdateImageCaption": "Update Image",
  "dxHtmlEditor-dialogImageUpdateButton": "Update",
  "dxHtmlEditor-dialogImageAddButton": "Add",
  "dxHtmlEditor-dialogImageSpecifyUrl": "From the Web",
  "dxHtmlEditor-dialogImageSelectFile": "From This Device",
  "dxHtmlEditor-dialogImageKeepAspectRatio": "Keep Aspect Ratio",
  "dxHtmlEditor-dialogImageEncodeToBase64": "Encode to Base64",
  "dxHtmlEditor-heading": "Encabezamiento",
  "dxHtmlEditor-normalText": "Texto normal",
  "dxHtmlEditor-background": "Background Color",
  "dxHtmlEditor-bold": "Bold",
  "dxHtmlEditor-color": "Font Color",
  "dxHtmlEditor-font": "Font",
  "dxHtmlEditor-italic": "Italic",
  "dxHtmlEditor-link": "Add Link",
  "dxHtmlEditor-image": "Add Image",
  "dxHtmlEditor-size": "Size",
  "dxHtmlEditor-strike": "Strikethrough",
  "dxHtmlEditor-subscript": "Subscript",
  "dxHtmlEditor-superscript": "Superscript",
  "dxHtmlEditor-underline": "Underline",
  "dxHtmlEditor-blockquote": "Blockquote",
  "dxHtmlEditor-header": "Header",
  "dxHtmlEditor-increaseIndent": "Increase Indent",
  "dxHtmlEditor-decreaseIndent": "Decrease Indent",
  "dxHtmlEditor-orderedList": "Ordered List",
  "dxHtmlEditor-bulletList": "Bullet List",
  "dxHtmlEditor-alignLeft": "Align Left",
  "dxHtmlEditor-alignCenter": "Align Center",
  "dxHtmlEditor-alignRight": "Align Right",
  "dxHtmlEditor-alignJustify": "Align Justify",
  "dxHtmlEditor-codeBlock": "Code Block",
  "dxHtmlEditor-variable": "Add Variable",
  "dxHtmlEditor-undo": "Undo",
  "dxHtmlEditor-redo": "Redo",
  "dxHtmlEditor-clear": "Clear Formatting",
  "dxHtmlEditor-insertTable": "Insert Table",
  "dxHtmlEditor-insertHeaderRow": "Insert Header Row",
  "dxHtmlEditor-insertRowAbove": "Insert Row Above",
  "dxHtmlEditor-insertRowBelow": "Insert Row Below",
  "dxHtmlEditor-insertColumnLeft": "Insert Column Left",
  "dxHtmlEditor-insertColumnRight": "Insert Column Right",
  "dxHtmlEditor-deleteColumn": "Delete Column",
  "dxHtmlEditor-deleteRow": "Delete Row",
  "dxHtmlEditor-deleteTable": "Delete Table",
  "dxHtmlEditor-cellProperties": "Cell Properties",
  "dxHtmlEditor-tableProperties": "Table Properties",
  "dxHtmlEditor-insert": "Insert",
  "dxHtmlEditor-delete": "Delete",
  "dxHtmlEditor-border": "Border",
  "dxHtmlEditor-style": "Style",
  "dxHtmlEditor-width": "Width",
  "dxHtmlEditor-height": "Height",
  "dxHtmlEditor-borderColor": "Color",
  "dxHtmlEditor-tableBackground": "Background",
  "dxHtmlEditor-dimensions": "Dimensions",
  "dxHtmlEditor-alignment": "Alignment",
  "dxHtmlEditor-horizontal": "Horizontal",
  "dxHtmlEditor-vertical": "Vertical",
  "dxHtmlEditor-paddingVertical": "Vertical Padding",
  "dxHtmlEditor-paddingHorizontal": "Horizontal Padding",
  "dxHtmlEditor-pixels": "Pixels",
  "dxHtmlEditor-list": "List",
  "dxHtmlEditor-ordered": "Ordered",
  "dxHtmlEditor-bullet": "Bullet",
  "dxHtmlEditor-align": "Align",
  "dxHtmlEditor-center": "Center",
  "dxHtmlEditor-left": "Left",
  "dxHtmlEditor-right": "Right",
  "dxHtmlEditor-indent": "Indent",
  "dxHtmlEditor-justify": "Justify",
  "dxHtmlEditor-borderStyleNone": "none",
  "dxHtmlEditor-borderStyleHidden": "hidden",
  "dxHtmlEditor-borderStyleDotted": "dotted",
  "dxHtmlEditor-borderStyleDashed": "dashed",
  "dxHtmlEditor-borderStyleSolid": "solid",
  "dxHtmlEditor-borderStyleDouble": "double",
  "dxHtmlEditor-borderStyleGroove": "groove",
  "dxHtmlEditor-borderStyleRidge": "ridge",
  "dxHtmlEditor-borderStyleInset": "inset",
  "dxHtmlEditor-borderStyleOutset": "outset",
  "dxFileManager-newDirectoryName": "Sin título",
  "dxFileManager-rootDirectoryName": "Archivos",
  "dxFileManager-errorNoAccess": "Acceso denegado. La operación no se puede completar.",
  "dxFileManager-errorDirectoryExistsFormat": "Carpeta {0} ya existe.",
  "dxFileManager-errorFileExistsFormat": "Archivo {0} ya existe.",
  "dxFileManager-errorFileNotFoundFormat": "Archivo {0} no encontrado.",
  "dxFileManager-errorDirectoryNotFoundFormat": "Directory '{0}' not found.",
  "dxFileManager-errorWrongFileExtension": "File extension is not allowed.",
  "dxFileManager-errorMaxFileSizeExceeded": "File size exceeds the maximum allowed size.",
  "dxFileManager-errorInvalidSymbols": "This name contains invalid characters.",
  "dxFileManager-errorDefault": "Error no especificado",
  "dxFileManager-errorDirectoryOpenFailed": "The directory cannot be opened",
  "dxFileManager-commandCreate": "New directory",
  "dxFileManager-commandRename": "Rename",
  "dxFileManager-commandMove": "Move to",
  "dxFileManager-commandCopy": "Copy to",
  "dxFileManager-commandDelete": "Delete",
  "dxFileManager-commandDownload": "Download",
  "dxFileManager-commandUpload": "Upload files",
  "dxFileManager-commandRefresh": "Refresh",
  "dxFileManager-commandThumbnails": "Thumbnails View",
  "dxFileManager-commandDetails": "Details View",
  "dxFileManager-commandClearSelection": "Clear selection",
  "dxFileManager-commandShowNavPane": "Toggle navigation pane",
  "dxFileManager-dialogDirectoryChooserMoveTitle": "Move to",
  "dxFileManager-dialogDirectoryChooserMoveButtonText": "Move",
  "dxFileManager-dialogDirectoryChooserCopyTitle": "Copy to",
  "dxFileManager-dialogDirectoryChooserCopyButtonText": "Copy",
  "dxFileManager-dialogRenameItemTitle": "Rename",
  "dxFileManager-dialogRenameItemButtonText": "Save",
  "dxFileManager-dialogCreateDirectoryTitle": "New directory",
  "dxFileManager-dialogCreateDirectoryButtonText": "Create",
  "dxFileManager-dialogDeleteItemTitle": "Delete",
  "dxFileManager-dialogDeleteItemButtonText": "Delete",
  "dxFileManager-dialogDeleteItemSingleItemConfirmation": "Are you sure you want to delete {0}?",
  "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "Are you sure you want to delete {0} items?",
  "dxFileManager-dialogButtonCancel": "Cancel",
  "dxFileManager-editingCreateSingleItemProcessingMessage": "Creating a directory inside {0}",
  "dxFileManager-editingCreateSingleItemSuccessMessage": "Created a directory inside {0}",
  "dxFileManager-editingCreateSingleItemErrorMessage": "Directory was not created",
  "dxFileManager-editingCreateCommonErrorMessage": "Directory was not created",
  "dxFileManager-editingRenameSingleItemProcessingMessage": "Renaming an item inside {0}",
  "dxFileManager-editingRenameSingleItemSuccessMessage": "Renamed an item inside {0}",
  "dxFileManager-editingRenameSingleItemErrorMessage": "Item was not renamed",
  "dxFileManager-editingRenameCommonErrorMessage": "Item was not renamed",
  "dxFileManager-editingDeleteSingleItemProcessingMessage": "Deleting an item from {0}",
  "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "Deleting {0} items from {1}",
  "dxFileManager-editingDeleteSingleItemSuccessMessage": "Deleted an item from {0}",
  "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "Deleted {0} items from {1}",
  "dxFileManager-editingDeleteSingleItemErrorMessage": "Item was not deleted",
  "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} items were not deleted",
  "dxFileManager-editingDeleteCommonErrorMessage": "Some items were not deleted",
  "dxFileManager-editingMoveSingleItemProcessingMessage": "Moving an item to {0}",
  "dxFileManager-editingMoveMultipleItemsProcessingMessage": "Moving {0} items to {1}",
  "dxFileManager-editingMoveSingleItemSuccessMessage": "Moved an item to {0}",
  "dxFileManager-editingMoveMultipleItemsSuccessMessage": "Moved {0} items to {1}",
  "dxFileManager-editingMoveSingleItemErrorMessage": "Item was not moved",
  "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} items were not moved",
  "dxFileManager-editingMoveCommonErrorMessage": "Some items were not moved",
  "dxFileManager-editingCopySingleItemProcessingMessage": "Copying an item to {0}",
  "dxFileManager-editingCopyMultipleItemsProcessingMessage": "Copying {0} items to {1}",
  "dxFileManager-editingCopySingleItemSuccessMessage": "Copied an item to {0}",
  "dxFileManager-editingCopyMultipleItemsSuccessMessage": "Copied {0} items to {1}",
  "dxFileManager-editingCopySingleItemErrorMessage": "Item was not copied",
  "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} items were not copied",
  "dxFileManager-editingCopyCommonErrorMessage": "Some items were not copied",
  "dxFileManager-editingUploadSingleItemProcessingMessage": "Uploading an item to {0}",
  "dxFileManager-editingUploadMultipleItemsProcessingMessage": "Uploading {0} items to {1}",
  "dxFileManager-editingUploadSingleItemSuccessMessage": "Uploaded an item to {0}",
  "dxFileManager-editingUploadMultipleItemsSuccessMessage": "Uploaded {0} items to {1}",
  "dxFileManager-editingUploadSingleItemErrorMessage": "Item was not uploaded",
  "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} items were not uploaded",
  "dxFileManager-editingUploadCanceledMessage": "Canceled",
  "dxFileManager-editingDownloadSingleItemErrorMessage": "Item was not downloaded",
  "dxFileManager-editingDownloadMultipleItemsErrorMessage": "{0} items were not downloaded",
  "dxFileManager-listDetailsColumnCaptionName": "Name",
  "dxFileManager-listDetailsColumnCaptionDateModified": "Date Modified",
  "dxFileManager-listDetailsColumnCaptionFileSize": "File Size",
  "dxFileManager-listThumbnailsTooltipTextSize": "Size",
  "dxFileManager-listThumbnailsTooltipTextDateModified": "Date Modified",
  "dxFileManager-notificationProgressPanelTitle": "Progress",
  "dxFileManager-notificationProgressPanelEmptyListText": "No operations",
  "dxFileManager-notificationProgressPanelOperationCanceled": "Canceled",
  "dxDiagram-categoryGeneral": "General",
  "dxDiagram-categoryFlowchart": "Diagrama de flujo",
  "dxDiagram-categoryOrgChart": "Organigrama",
  "dxDiagram-categoryContainers": "Contenedores",
  "dxDiagram-categoryCustom": "Personalizado",
  "dxDiagram-commandExportToSvg": "Exportar a SVG",
  "dxDiagram-commandExportToPng": "Exportar a PNG",
  "dxDiagram-commandExportToJpg": "Exportar a JPG",
  "dxDiagram-commandUndo": "Deshacer",
  "dxDiagram-commandRedo": "Rehacer",
  "dxDiagram-commandFontName": "Nombre de fuente",
  "dxDiagram-commandFontSize": "Tamaño de fuente",
  "dxDiagram-commandBold": "Negrita",
  "dxDiagram-commandItalic": "Cursiva",
  "dxDiagram-commandUnderline": "Subrayado",
  "dxDiagram-commandTextColor": "Color de fuente",
  "dxDiagram-commandLineColor": "Color de línea",
  "dxDiagram-commandLineWidth": "Ancho de línea",
  "dxDiagram-commandLineStyle": "Estilo de línea",
  "dxDiagram-commandLineStyleSolid": "Sólido",
  "dxDiagram-commandLineStyleDotted": "De puntos",
  "dxDiagram-commandLineStyleDashed": "De guiones",
  "dxDiagram-commandFillColor": "Color de relleno",
  "dxDiagram-commandAlignLeft": "Alinear a la izquierda",
  "dxDiagram-commandAlignCenter": "Alinear al centro",
  "dxDiagram-commandAlignRight": "Alinear a la derecha",
  "dxDiagram-commandConnectorLineType": "Tipo de línea de conector",
  "dxDiagram-commandConnectorLineStraight": "Recto",
  "dxDiagram-commandConnectorLineOrthogonal": "Ortogonal",
  "dxDiagram-commandConnectorLineStart": "Conector de inicio de línea",
  "dxDiagram-commandConnectorLineEnd": "Conector de final de línea",
  "dxDiagram-commandConnectorLineNone": "Ninguno",
  "dxDiagram-commandConnectorLineArrow": "Flecha",
  "dxDiagram-commandFullscreen": "Pantalla completa",
  "dxDiagram-commandUnits": "Unidades",
  "dxDiagram-commandPageSize": "Tamaño de página",
  "dxDiagram-commandPageOrientation": "Orientación de página",
  "dxDiagram-commandPageOrientationLandscape": "Horizontal",
  "dxDiagram-commandPageOrientationPortrait": "Vertical",
  "dxDiagram-commandPageColor": "Color de página",
  "dxDiagram-commandShowGrid": "Mostrar cuadrícula",
  "dxDiagram-commandSnapToGrid": "Ajustar a la cuadrícula",
  "dxDiagram-commandGridSize": "Tamaño de cuadrícula",
  "dxDiagram-commandZoomLevel": "Nivel de zoom",
  "dxDiagram-commandAutoZoom": "Zoom automático",
  "dxDiagram-commandFitToContent": "Ajustar al contenido",
  "dxDiagram-commandFitToWidth": "Ajustar al ancho",
  "dxDiagram-commandAutoZoomByContent": "Zoom automático por contenido",
  "dxDiagram-commandAutoZoomByWidth": "Zoom automático por ancho",
  "dxDiagram-commandSimpleView": "Vista Simple",
  "dxDiagram-commandCut": "Cortar",
  "dxDiagram-commandCopy": "Copiar",
  "dxDiagram-commandPaste": "Pegar",
  "dxDiagram-commandSelectAll": "Seleccionar todo",
  "dxDiagram-commandDelete": "Eliminar",
  "dxDiagram-commandBringToFront": "Traer al frente",
  "dxDiagram-commandSendToBack": "Enviar al fondo",
  "dxDiagram-commandLock": "Bloquear",
  "dxDiagram-commandUnlock": "Desbloquear",
  "dxDiagram-commandInsertShapeImage": "Insertar imagen...",
  "dxDiagram-commandEditShapeImage": "Cambiar imagen...",
  "dxDiagram-commandDeleteShapeImage": "Eliminar imagen",
  "dxDiagram-commandLayoutLeftToRight": "De izquierda a derecha",
  "dxDiagram-commandLayoutRightToLeft": "De derecha a izquierda",
  "dxDiagram-commandLayoutTopToBottom": "De arriba a abajo",
  "dxDiagram-commandLayoutBottomToTop": "De abajo a arriba",
  "dxDiagram-unitIn": "pulg.",
  "dxDiagram-unitCm": "cm",
  "dxDiagram-unitPx": "px",
  "dxDiagram-dialogButtonOK": "Aceptar",
  "dxDiagram-dialogButtonCancel": "Cancelar",
  "dxDiagram-dialogInsertShapeImageTitle": "Insertar Imagen",
  "dxDiagram-dialogEditShapeImageTitle": "Cambiar Imagen",
  "dxDiagram-dialogEditShapeImageSelectButton": "Seleccionar imagen",
  "dxDiagram-dialogEditShapeImageLabelText": "o colocar el archivo aquí",
  "dxDiagram-uiExport": "Exportar",
  "dxDiagram-uiProperties": "Propiedades",
  "dxDiagram-uiSettings": "Configuración",
  "dxDiagram-uiShowToolbox": "Cuadro de herramientas",
  "dxDiagram-uiSearch": "Buscar",
  "dxDiagram-uiStyle": "Estilo",
  "dxDiagram-uiLayout": "Diseño",
  "dxDiagram-uiLayoutTree": "Árbol",
  "dxDiagram-uiLayoutLayered": "Capas",
  "dxDiagram-uiDiagram": "Diagrama",
  "dxDiagram-uiText": "Texto",
  "dxDiagram-uiObject": "Objeto",
  "dxDiagram-uiConnector": "Conector",
  "dxDiagram-uiPage": "Página",
  "dxDiagram-shapeText": "Texto",
  "dxDiagram-shapeRectangle": "Rectángulo",
  "dxDiagram-shapeEllipse": "Elipse",
  "dxDiagram-shapeCross": "Cruz",
  "dxDiagram-shapeTriangle": "Triángulo",
  "dxDiagram-shapeDiamond": "Rombo",
  "dxDiagram-shapeHeart": "Corazón",
  "dxDiagram-shapePentagon": "Pentágono",
  "dxDiagram-shapeHexagon": "Hexágono",
  "dxDiagram-shapeOctagon": "Octágono",
  "dxDiagram-shapeStar": "Estrella",
  "dxDiagram-shapeArrowLeft": "Flecha izquierda",
  "dxDiagram-shapeArrowUp": "Flecha arriba",
  "dxDiagram-shapeArrowRight": "Flecha derecha",
  "dxDiagram-shapeArrowDown": "Flecha abajo",
  "dxDiagram-shapeArrowUpDown": "Flecha arriba/abajo",
  "dxDiagram-shapeArrowLeftRight": "Flecha izquierda/derecha",
  "dxDiagram-shapeProcess": "Proceso",
  "dxDiagram-shapeDecision": "Decisión",
  "dxDiagram-shapeTerminator": "Terminador",
  "dxDiagram-shapePredefinedProcess": "Proceso predefinido",
  "dxDiagram-shapeDocument": "Documento",
  "dxDiagram-shapeMultipleDocuments": "Varios documentos",
  "dxDiagram-shapeManualInput": "Entrada manual",
  "dxDiagram-shapePreparation": "Preparación",
  "dxDiagram-shapeData": "Datos",
  "dxDiagram-shapeDatabase": "Base de datos",
  "dxDiagram-shapeHardDisk": "Disco duro",
  "dxDiagram-shapeInternalStorage": "Almacenamiento interno",
  "dxDiagram-shapePaperTape": "Cinta de papel",
  "dxDiagram-shapeManualOperation": "Operación manual",
  "dxDiagram-shapeDelay": "Retraso",
  "dxDiagram-shapeStoredData": "Datos almacenados",
  "dxDiagram-shapeDisplay": "Pantalla",
  "dxDiagram-shapeMerge": "Combinar",
  "dxDiagram-shapeConnector": "Conector",
  "dxDiagram-shapeOr": "O",
  "dxDiagram-shapeSummingJunction": "Unión en Y",
  "dxDiagram-shapeContainerDefaultText": "Contenedor",
  "dxDiagram-shapeVerticalContainer": "Contenedor vertical",
  "dxDiagram-shapeHorizontalContainer": "Contenedor horizontal",
  "dxDiagram-shapeCardDefaultText": "Nombre de persona",
  "dxDiagram-shapeCardWithImageOnLeft": "Tarjeta con imagen a la izquierda",
  "dxDiagram-shapeCardWithImageOnTop": "Tarjeta con imagen en la parte superior",
  "dxDiagram-shapeCardWithImageOnRight": "Tarjeta con imagen a la derecha",
  "dxGantt-dialogTitle": "Title",
  "dxGantt-dialogStartTitle": "Start",
  "dxGantt-dialogEndTitle": "End",
  "dxGantt-dialogProgressTitle": "Progress",
  "dxGantt-dialogResourcesTitle": "Resources",
  "dxGantt-dialogResourceManagerTitle": "Resource Manager",
  "dxGantt-dialogTaskDetailsTitle": "Task Details",
  "dxGantt-dialogEditResourceListHint": "Edit Resource List",
  "dxGantt-dialogEditNoResources": "No resources",
  "dxGantt-dialogButtonAdd": "Add",
  "dxGantt-contextMenuNewTask": "New Task",
  "dxGantt-contextMenuNewSubtask": "New Subtask",
  "dxGantt-contextMenuDeleteTask": "Delete Task",
  "dxGantt-contextMenuDeleteDependency": "Delete Dependency",
  "dxGantt-dialogTaskDeleteConfirmation": "Deleting a task also deletes all its dependencies and subtasks. Are you sure you want to delete this task?",
  "dxGantt-dialogDependencyDeleteConfirmation": "Are you sure you want to delete the dependency from the task?",
  "dxGantt-dialogResourcesDeleteConfirmation": "Deleting a resource also deletes it from tasks to which this resource is assigned. Are you sure you want to delete these resources? Resources: {0}",
  "dxGantt-dialogConstraintCriticalViolationMessage": "The task you are attempting to move is linked to a second task by a dependency relation. This change would conflict with dependency rules. How would you like to proceed?",
  "dxGantt-dialogConstraintViolationMessage": "The task you are attempting to move is linked to a second task by a dependency relation. How would you like to proceed?",
  "dxGantt-dialogCancelOperationMessage": "Cancel the operation",
  "dxGantt-dialogDeleteDependencyMessage": "Delete the dependency",
  "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "Move the task and keep the dependency",
  "dxGantt-dialogConstraintCriticalViolationSeveralTasksMessage": "The task you are attempting to move is linked to another tasks by dependency relations. This change would conflict with dependency rules. How would you like to proceed?",
  "dxGantt-dialogConstraintViolationSeveralTasksMessage": "The task you are attempting to move is linked to another tasks by dependency relations. How would you like to proceed?",
  "dxGantt-dialogDeleteDependenciesMessage": "Delete the dependency relations",
  "dxGantt-dialogMoveTaskAndKeepDependenciesMessage": "Move the task and keep the dependencies",
  "dxGantt-undo": "Undo",
  "dxGantt-redo": "Redo",
  "dxGantt-expandAll": "Expand All",
  "dxGantt-collapseAll": "Collapse All",
  "dxGantt-addNewTask": "Add New Task",
  "dxGantt-deleteSelectedTask": "Delete Selected Task",
  "dxGantt-zoomIn": "Zoom In",
  "dxGantt-zoomOut": "Zoom Out",
  "dxGantt-fullScreen": "Full Screen",
  "dxGantt-quarter": "Q{0}",
  "dxGantt-sortingAscendingText": "Orden Ascendente",
  "dxGantt-sortingDescendingText": "Orden Descendente",
  "dxGantt-sortingClearText": "Limpiar Ordenamiento",
  "dxGantt-showResources": "Mostrar Recursos",
  "dxGantt-showDependencies": "Mostrar Dependencias",
  "dxGantt-dialogStartDateValidation": "La fecha de inicio debe ser anterior {0}",
  "dxGantt-dialogEndDateValidation": "La fecha de finalización debe ser posterior {0}",
  "dxGallery-itemName": "Gallery item",
  "dxMultiView-elementAriaRoleDescription": "MultiView",
  "dxMultiView-elementAriaLabel": "Use the arrow keys or swipe to navigate between views",
  "dxMultiView-itemAriaRoleDescription": "View",
  "dxMultiView-itemAriaLabel": "{0} of {1}"
}, NBe = {
  es: VBe
};
var HBe = Wo.locale.bind(Wo), $Be = X.load.bind(X), _Ne = X.format.bind(X), CNe = _i.format.bind(_i), yNe = _i.parse.bind(_i), xNe = Bt.format.bind(Bt), SNe = Bt.parse.bind(Bt);
const zBe = "cancel", WBe = "complete", UBe = "content", GBe = "cursor", N3 = "data", qy = "dataSource", H3 = "selectedRowsData", KBe = "selectedRowKeys", $3 = "selectedRowsDataMasterDetail", jBe = "email", YBe = "select";
const z3 = "alert", qBe = /\{([^}]+)\}/g;
Oi({
  licenseKey: "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjJhYTQ1YWUzLTk1YjUtMTFlMy1hZTM3LTAwMjE5YjhiMmNhNyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjMyCn0=.BWxPoCpEdVEvZifc1llI4HZgqr9aws3Vvw6YTu2WnB5JVjprLlcBTZvXaGMIqglhvSeBBtKs3C6ZpfHwNOG+VFZOBM0+s72jpq4jcAPyEtvq50ZbUCEii9rIgR2au5eWuhR2qg=="
});
const Ba = YF("kanela:datagrid"), ENe = Kte(function(e, i) {
  var ms, Xs, _s, Qs, Ua, Ko, Wn, ya, jo, G, ke;
  const {
    actions: r = [],
    advanced: n = {},
    columns: a = [],
    dataSource: o = [],
    detail: u = {},
    menu: c = [],
    name: p,
    onChange: v,
    onClick: _,
    onRightClick: y,
    onOrdered: b,
    onRowAction: I,
    onRowRemoved: A,
    onRowRemoving: L,
    readonly: B = !1,
    summaries: $ = []
  } = e, {
    alert: K = "red",
    allowColumnChooser: te = !0,
    allowColumnHidingEnabled: z = !1,
    allowCustomize: ie = !1,
    allowFiltering: pe = !0,
    allowRefresh: _e = !0,
    allowReordering: be = !1,
    allowSearch: De = !0,
    entity: Ce,
    height: ft = "340px",
    hideDelete: Ve = [],
    mode: Ee = "standard",
    namespace: Re = "",
    refresh: we = void 0,
    rememberSelection: We = !0,
    revalidate: ne = !0,
    selection: Ae = "single",
    storing: j = !0,
    textColor: ge = "white",
    defaultNoDataText: Me = void 0
  } = n, ze = Ee === "infinite", je = {
    refreshInterval: we,
    revalidateOnFocus: ne
  }, {
    enabled: vt = !1
  } = u, Je = Jn(v), _t = Jn(b), at = Jn(null), yt = Jn({
    next: null,
    previous: null
  }), tt = Sh(() => !Array.isArray(o) && !qF.isUndefined(o.url) ? {
    url: o.url,
    args: {
      body: o.parameter,
      headers: o.headers,
      method: o.method,
      namespace: o.namespace,
      pagination: o.pagination
    }
  } : null, [o]), { data: zt, mutate: Ie } = Wq(
    () => ze ? null : tt,
    Mq,
    je
  ), gt = Ki(() => {
    Ba("refresh"), Ie();
  }, [Ie]), si = Sh(() => new Ks({
    key: Ce,
    load: () => new Promise((U, ye) => {
      if (!tt) {
        U([]);
        return;
      }
      if (yt.current.next === null && yt.current.previous !== null) {
        U([]);
        return;
      }
      const Fe = yt.current.next ? pde.query(GBe, yt.current.next) : null, Ue = tt.args.body || {};
      Fe && (Ue.cursor = Fe);
      const Ze = qk.fetch(tt.url, {
        method: tt.args.method,
        body: Ue,
        headers: tt.args.headers
      });
      Ze.then((Xe) => {
        U(np.extract(Xe, tt.args.namespace)), yt.current = np.extract(
          Xe,
          tt.args.pagination
        ), Ba("navigation %o", yt.current);
      }), Ze.catch((Xe) => {
        ye(Xe);
      });
    })
  }), [Ce, tt]);
  xm(() => {
    Je.current = v;
  }, [v]), xm(() => {
    _t.current = b;
  }, [b]), xm(() => {
    $Be(NBe), typeof window < "u" && window.navigator && window.navigator.language && HBe(window.navigator.language);
  }, []), jte(
    i,
    () => ({
      name: p,
      clear() {
        const U = at.current;
        U == null || U.option(qy, []);
      },
      clearSelection() {
        const U = at.current;
        U == null || U.clearSelection();
      },
      validate() {
        const U = at.current, ye = U == null ? void 0 : U.option(qy);
        return !(Array.isArray(ye) && ye.length === 0);
      },
      refresh() {
        gt();
      },
      value() {
        const U = at.current, ye = U == null ? void 0 : U.option(qy);
        return Array.isArray(ye) ? ye : [];
      },
      getSelection() {
        const U = at.current, ye = [], Fe = U == null ? void 0 : U.option(KBe);
        Array.isArray(Fe) && Fe.length && ye.push(...Fe);
        const Ue = U == null ? void 0 : U.option(
          $3
        );
        return Array.isArray(Ue) && Ue.length && ye.push(...Ue), ye;
      }
    }),
    [p, gt]
  );
  const Wt = Ki((U) => (Ba("lookup data source"), new Promise((ye, Fe) => {
    const Ue = qk.fetch(U.url, {
      body: U.parameter,
      headers: U.headers,
      method: U.method
    });
    Ue.then((Ze) => {
      const Xe = np.extract(Ze, U.namespace);
      if (Array.isArray(Xe)) {
        ye(Xe);
        return;
      }
      ye([]);
    }), Ue.catch((Ze) => {
      Fe(Ze);
    });
  })), []), ki = Ki(
    (U, ye) => (Ba("column data source"), Array.isArray(ye) ? ye : {
      store: new gS({
        key: U || "id",
        loadMode: "raw",
        load() {
          return Wt(ye);
        }
      })
    }),
    [Wt]
  ), lr = Ki(
    (U) => {
      var Fe, Ue;
      let ye = {};
      return $.forEach((Ze) => {
        const Xe = Ze.name;
        Xe && (ye[Xe] = U.component.getTotalSummaryValue(Xe));
      }), ((Ue = (Fe = e.advanced) == null ? void 0 : Fe.summary) == null ? void 0 : Ue.result) === WBe && (ye = {
        summary: ye
      }), ye;
    },
    [$, (Xs = (ms = e.advanced) == null ? void 0 : ms.summary) == null ? void 0 : Xs.result]
  ), mi = Ki(
    (U) => {
      var ye, Fe, Ue;
      (Ue = (Fe = (ye = U.component) == null ? void 0 : ye.getDataSource()) == null ? void 0 : Fe.store()) == null || Ue.load().then((Ze) => {
        if (Je.current) {
          Je.current(p, Ze);
          const Xe = lr(U);
          Object.keys(Xe).forEach((Nt) => {
            Je.current && Je.current(Nt, Xe[Nt]);
          });
        }
      });
    },
    [p, lr]
  ), Wi = Ki(
    (U) => {
      if (Ba("row removed"), mi(U), A) {
        const ye = N3 in U ? U == null ? void 0 : U[N3] : void 0;
        A(ye);
      }
    },
    [mi, A]
  ), Rr = Ki(
    (U) => {
      L && zBe in U && (Ba("row removing"), U.cancel = L());
    },
    [L]
  ), ia = Ki(
    (U) => {
      if (H3 in U) {
        const Fe = U.selectedRowsData;
        if (!Array.isArray(Fe) || Fe.length === 0) {
          _ && _([]);
          return;
        }
        We || setTimeout(() => {
          const Ue = at.current;
          Ue == null || Ue.clearSelection();
        }, 500), Ba("selection changed"), _ && _(Fe);
      }
    },
    [_, We]
  ), ra = Ki(
    (U) => {
      if (H3 in U) {
        const Fe = U.selectedRowsData;
        if (!Array.isArray(Fe) || Fe.length === 0)
          return;
        const Ue = at.current;
        Ue == null || Ue.option($3, Fe);
      }
    },
    []
  ), zn = Ki(
    (U) => {
      if (at.current = U.component, at.current) {
        Ba("content ready");
        const ye = at.current;
        if (Je.current && !ze) {
          const Fe = ye.option(qy);
          Je.current(p, Fe);
        }
      }
    },
    [p, ze]
  ), Yi = Ki(
    (U) => {
      U.target === UBe && (U.items || (U.items = []), c.forEach((ye) => {
        var Ze;
        const [Fe, Ue] = ye;
        (Ze = U.items) == null || Ze.push({
          text: Ue,
          onItemClick: () => {
            var Xe;
            y && y(Fe, (Xe = U.row) == null ? void 0 : Xe.data);
          }
        });
      }));
    },
    [c, y]
  ), tr = Ki(
    (U, ye) => {
      const {
        data: Fe,
        value: Ue
      } = U, Ze = ye.match(qBe);
      if ((Ze == null ? void 0 : Ze.length) !== 0)
        return Ze == null || Ze.forEach((Xe) => {
          const Nt = Xe.replaceAll("{", "").replaceAll("}", ""), kt = np.extract(Fe, Nt);
          kt != null && (ye = ye.replaceAll(Xe, `${kt}`));
        }), /* @__PURE__ */ ni.jsx(
          "a",
          {
            className: "hover:underline",
            href: ye,
            rel: "noreferrer",
            target: "_blank",
            children: Ue
          }
        );
    },
    []
  ), cn = Ki(
    (U) => {
      var ye, Fe, Ue, Ze, Xe, Nt;
      return /* @__PURE__ */ ni.jsxs(
        dT,
        {
          sortOrder: U.sort,
          allowEditing: !(B || (U.readonly ?? !1)),
          allowHiding: U.allowHiding,
          caption: U.label,
          dataField: U.name,
          allowSorting: U.allowSorting,
          editorOptions: U.type === "number" ? U.advanced : void 0,
          dataType: U.type !== "select" && U.type !== "email" && U.type !== "link" ? U.type : "string",
          format: U.format,
          groupIndex: U.group,
          visible: U.visible,
          cellRender: U.type === "link" && U.link ? (kt) => tr(kt, U.link) : void 0,
          children: [
            !U.optional && /* @__PURE__ */ ni.jsx(IBe, { message: (ye = U.validation) == null ? void 0 : ye.message }),
            U.type === jBe && ((Ue = (Fe = U.validation) == null ? void 0 : Fe.email) == null ? void 0 : Ue.enabled) && /* @__PURE__ */ ni.jsx(CBe, { message: (Ze = U.validation) == null ? void 0 : Ze.email.message }),
            U.type === YBe && /* @__PURE__ */ ni.jsx(
              EBe,
              {
                dataSource: ki(
                  U.entity,
                  U.dataSource
                ),
                displayExpr: ((Xe = U.options) == null ? void 0 : Xe.label) || "label",
                valueExpr: ((Nt = U.options) == null ? void 0 : Nt.value) || "value"
              }
            )
          ]
        },
        U.name
      );
    },
    [B, ki, tr]
  ), hr = Ki(
    (U) => {
      var ye;
      return /* @__PURE__ */ ni.jsx(dT, { caption: U.label, alignment: "center", children: (ye = U.children) == null ? void 0 : ye.map((Fe) => cn(Fe)) }, U.name);
    },
    [cn]
  ), Wr = Sh(() => (Ba("prepare list rows"), a.sort(jz.asc).filter((U) => !U.hidden).map(
    (U) => U.children ? hr(U) : cn(U)
  )), [a, hr, cn]), Go = Ki(
    (U) => {
      const {
        data: ye = {}
      } = U, Fe = ye && typeof ye == "object" ? ye : null;
      let Ue = u.dataSource;
      if (Ue) {
        if (typeof Ue == "string") {
          const Ze = np.extract(Fe, Ue);
          Array.isArray(Ze) && (Ue = Ze);
        } else if (typeof Ue == "object" && !Array.isArray(Ue) && Fe && "url" in Ue) {
          Ue = {
            ...u.dataSource
          };
          let Ze = Ue.url;
          Object.keys(Fe).forEach((Xe) => {
            Ze = Ze.replace(
              `{${Xe}}`,
              Fe[Xe]
            );
          }), Ue.url = Ze;
        }
      }
      return Ba("prepare detail"), /* @__PURE__ */ ni.jsx(
        BBe,
        {
          allowFiltering: u.allowFiltering,
          columns: u.columns,
          dataSource: Ue,
          onClick: ra,
          selected: U,
          selection: u.selection
        }
      );
    },
    [
      u.columns,
      u.dataSource,
      u.allowFiltering,
      u.selection,
      ra
    ]
  ), Wa = (U) => {
    const ye = U.format;
    Ba("export file %s", ye), ye === "xlsx" ? import("./xlsx-hwdiZaRZ.mjs").then((Fe) => {
      const Ue = Fe.default, Ze = new Ue(), Xe = Ze.addWorksheet("Main sheet");
      import("./xlsx-exporter-B3CuTZRl.mjs").then((Nt) => Nt.default({
        component: U.component,
        worksheet: Xe,
        autoFilterEnabled: !0,
        customizeCell: ({ gridCell: kt, excelCell: ci }) => {
          var pr;
          if ((kt == null ? void 0 : kt.rowType) === "data") {
            const xa = a.find(
              (Cs) => {
                var hi;
                return Cs.name === ((hi = kt == null ? void 0 : kt.column) == null ? void 0 : hi.dataField);
              }
            );
            if (xa && xa.type === "link") {
              const Cs = xa.link, hi = Cs == null ? void 0 : Cs.replace(
                `{${(pr = kt == null ? void 0 : kt.column) == null ? void 0 : pr.dataField}}`,
                kt.value
              );
              ci.value = {
                text: kt.value,
                hyperlink: hi
              }, ci.font = {
                color: { argb: "ef6636" },
                underline: !0
              }, ci.alignment = {
                horizontal: "left"
              };
            }
          }
        }
      })).then(() => {
        import("./file-system-x0nkVouZ.mjs").then((Nt) => {
          const kt = Nt.default;
          Ze.xlsx.writeBuffer().then((ci) => {
            kt(
              new Blob([ci], {
                type: "application/octet-stream"
              }),
              "DataGrid.xlsx"
            );
          });
        });
      }), U.cancel = !0;
    }) : import("./pdf-DOHeHzrp.mjs").then((Fe) => Fe.p).then((Fe) => {
      const Ue = new Fe.default();
      import("./pdf-exporter-CvDOFuac.mjs").then((Ze) => Ze.default({
        jsPDFDocument: Ue,
        component: U.component,
        indent: 5
      })).then(() => {
        Ue.save("DataGrid.pdf");
      }), U.cancel = !0;
    });
  }, Ca = Ki(
    (U) => {
      if (p && typeof U == "object" && window.localStorage) {
        const ye = {
          ...U,
          selectedRowKeys: []
        }, Fe = Re ? `${Re}/${p}` : p;
        Ba("save (%s) state storing %o", Fe, ye), window.localStorage.setItem(Fe, JSON.stringify(ye));
      }
    },
    [p, Re]
  ), nt = Ki(() => {
    try {
      if (p && window.localStorage) {
        const U = Re ? `${Re}/${p}` : p, ye = window.localStorage.getItem(U);
        if (ye) {
          const Fe = JSON.parse(ye);
          return Ba("load (%s) state storing %o", U, Fe), Fe;
        }
      }
      return null;
    } catch {
      return null;
    }
  }, [p, Re]), Rt = Ki(
    (U) => {
      if (!Ce) {
        Ba("the key is undefined");
        return;
      }
      const ye = U, Fe = ye.component.getVisibleRows();
      if (Fe.length === 0) {
        Ba("the visible rows is empty");
        return;
      }
      const Ue = Array.isArray(o) ? o : zt;
      if (!Ue || Ue.length === 0) {
        Ba("the data is empty");
        return;
      }
      const Ze = Ue.findIndex((Nt) => {
        const kt = Nt && typeof Nt == "object" && Ce in Nt ? Nt == null ? void 0 : Nt[Ce] : null, ci = Fe[ye.toIndex], pr = ci && typeof ci == "object" && "data" in ci ? ci.data : null, xa = pr && typeof pr == "object" && "id" in pr ? pr == null ? void 0 : pr[Ce] : null;
        return kt === xa;
      }), Xe = Ue.findIndex((Nt) => {
        const kt = Nt && typeof Nt == "object" && Ce in Nt ? Nt == null ? void 0 : Nt[Ce] : null;
        return Ce in ye.itemData && kt === ye.itemData[Ce];
      });
      if (_t.current) {
        const Nt = ye.itemData;
        if (Nt) {
          let kt = Ze;
          Xe > Ze && (kt = Ze - 1, kt < 0 && (kt = null));
          const ci = kt !== null ? Ue[kt] : null;
          _t.current(Nt, ci);
        }
      }
      if (Ue.splice(Xe, 1), Ue.splice(Ze, 0, ye.itemData), Array.isArray(o)) {
        if (at.current) {
          const Nt = at.current;
          Nt == null || Nt.option(qy, Ue);
        }
      } else
        Ie(Ue, !1);
      Je.current && Je.current(p, Ue);
    },
    [Ce, o, zt, Ie, p]
  ), ii = Ki(
    (U) => {
      if (Ve.length === 0)
        return;
      const ye = "command" in U.column && U.column.command === "edit";
      U.rowType === "data" && ye && Ve.includes(np.extract(U.data, Ce)) && "children" in U.cellElement && Array.from(U.cellElement.children).forEach((Fe) => {
        Fe.classList.contains("dx-link-delete") && U.cellElement.removeChild(Fe);
      });
    },
    [Ve, Ce]
  ), Pi = Ki(
    (U) => {
      ii(U);
    },
    [ii]
  ), Ui = Ki(
    (U, ye) => {
      var Fe;
      I && I(ye.name, (Fe = U.row) == null ? void 0 : Fe.data);
    },
    [I]
  ), Br = (_s = e.advanced) != null && _s.allowUpdating && !((Qs = e.advanced) != null && Qs.allowAdding) && !((Ua = e.advanced) != null && Ua.allowDeleting) ? "cell" : "row", fr = !e.readonly && ((Ko = e.advanced) == null ? void 0 : Ko.allowAdding), Lr = !e.readonly && ((Wn = e.advanced) == null ? void 0 : Wn.allowDeleting), ur = !e.readonly && ((ya = e.advanced) == null ? void 0 : ya.allowUpdating), Ti = Array.isArray(o) ? o : zt, qi = ze ? si : Ti, Bl = ze ? "none" : "single", gs = te && !fr && !Lr, Vl = ie ? `color: ${ge}; background-color: ${K}` : "", $u = (U) => {
    var ye;
    U.rowType === "data" && z3 in U.data && (ye = U.data) != null && ye[z3] && (U.rowElement.style.cssText = Vl);
  }, uc = () => {
    const U = {};
    return Me && (U.noDataText = Me), U;
  };
  return /* @__PURE__ */ ni.jsx("div", { className: "w-full", "data-testid": e.testid, children: /* @__PURE__ */ ni.jsxs(
    fV,
    {
      elementAttr: {
        "data-ready": at.current !== null
      },
      allowColumnReordering: !0,
      allowColumnResizing: !0,
      cacheEnabled: !0,
      columnAutoWidth: !0,
      columnHidingEnabled: z,
      dataSource: qi,
      errorRowEnabled: !1,
      height: ft,
      keyExpr: ze ? "" : Ce,
      onCellPrepared: Pi,
      onContentReady: zn,
      onContextMenuPreparing: Yi,
      onExporting: Wa,
      onRowInserted: mi,
      onRowPrepared: $u,
      onRowRemoved: Wi,
      onRowRemoving: Rr,
      onRowUpdated: mi,
      onSelectionChanged: ia,
      remoteOperations: ze,
      showBorders: !0,
      width: "100%",
      wordWrapEnabled: !0,
      ...uc(),
      children: [
        /* @__PURE__ */ ni.jsx(
          ABe,
          {
            columnRenderingMode: "standard",
            mode: Ee,
            rowRenderingMode: "standard"
          }
        ),
        /* @__PURE__ */ ni.jsx(RBe, { mode: Bl }),
        /* @__PURE__ */ ni.jsx(xBe, { visible: !ze }),
        /* @__PURE__ */ ni.jsx(
          OBe,
          {
            visible: ze ? !1 : De
          }
        ),
        /* @__PURE__ */ ni.jsx(
          TBe,
          {
            defaultPageSize: 50,
            enabled: (jo = e.advanced) == null ? void 0 : jo.allowPaging
          }
        ),
        /* @__PURE__ */ ni.jsx(
          wBe,
          {
            visible: !ze && ((G = e.advanced) == null ? void 0 : G.allowPaging),
            allowedPageSizes: [10, 25, 50],
            displayMode: "full",
            showPageSizeSelector: !0,
            showInfo: !1,
            showNavigationButtons: !1
          }
        ),
        /* @__PURE__ */ ni.jsxs(vBe, { enabled: gs, mode: "select", children: [
          /* @__PURE__ */ ni.jsx(gBe, { enabled: !0 }),
          /* @__PURE__ */ ni.jsx(
            mBe,
            {
              allowSelectAll: !0,
              selectByClick: !0,
              recursive: !0
            }
          )
        ] }),
        /* @__PURE__ */ ni.jsx(
          DBe,
          {
            allowReordering: be,
            onReorder: Rt,
            showDragIcons: !0
          }
        ),
        /* @__PURE__ */ ni.jsx(
          SBe,
          {
            search: { enabled: !0 },
            visible: pe
          }
        ),
        /* @__PURE__ */ ni.jsx(q9, { visible: pe }),
        /* @__PURE__ */ ni.jsx(X9, { enabled: !0 }),
        /* @__PURE__ */ ni.jsx(Q9, { mode: Ae, showCheckBoxesMode: "always" }),
        /* @__PURE__ */ ni.jsx(
          yBe,
          {
            allowExportSelectedData: Ae === "multiple",
            enabled: (ke = e.advanced) == null ? void 0 : ke.allowExporting,
            formats: ["pdf", "xlsx"]
          }
        ),
        /* @__PURE__ */ ni.jsxs(kBe, { children: [
          /* @__PURE__ */ ni.jsx(Yy, { name: "addRowButton" }),
          _e && !ze && /* @__PURE__ */ ni.jsx(Yy, { location: "after", children: /* @__PURE__ */ ni.jsx(wq, { icon: "refresh", onClick: gt }) }),
          /* @__PURE__ */ ni.jsx(Yy, { name: "exportButton" }),
          gs && /* @__PURE__ */ ni.jsx(Yy, { name: "columnChooserButton" }),
          !ze && De && /* @__PURE__ */ ni.jsx(Yy, { name: "searchPanel" })
        ] }),
        /* @__PURE__ */ ni.jsx(
          LBe,
          {
            customLoad: nt,
            customSave: Ca,
            enabled: j,
            type: "custom"
          }
        ),
        $.length > 0 && /* @__PURE__ */ ni.jsx(MBe, { children: $.map((U) => /* @__PURE__ */ ni.jsx(
          PBe,
          {
            column: U.column,
            displayFormat: U.format,
            name: U.name,
            summaryType: U.type,
            valueFormat: U.formatValue
          },
          U.column
        )) }),
        /* @__PURE__ */ ni.jsx(
          _Be,
          {
            mode: Br,
            allowAdding: fr,
            allowDeleting: Lr,
            allowUpdating: ur
          }
        ),
        Wr,
        (Br === "row" && ur || Lr || r.length > 0) && /* @__PURE__ */ ni.jsxs(
          dT,
          {
            allowHiding: !1,
            showInColumnChooser: !1,
            type: "buttons",
            children: [
              /* @__PURE__ */ ni.jsx(vk, { name: "edit" }),
              /* @__PURE__ */ ni.jsx(vk, { name: "delete" }),
              r.sort(jz.asc).map((U) => /* @__PURE__ */ ni.jsx(
                vk,
                {
                  disabled: U.readonly,
                  hint: U.label,
                  onClick: (ye) => Ui(ye, U),
                  text: U.label
                },
                U.name
              ))
            ]
          }
        ),
        /* @__PURE__ */ ni.jsx(bBe, { enabled: vt, render: Go })
      ]
    }
  ) });
});
export {
  E as $,
  ENe as D,
  CB as L,
  ae as _,
  M6 as a,
  ct as b,
  eVe as c,
  Bt as d,
  P as e,
  Mu as f,
  Yte as g,
  R as h,
  Di as i,
  ht as j,
  wt as k,
  Wo as l,
  zo as m,
  _i as n,
  Le as o,
  Nh as p,
  Ix as q,
  sr as r,
  X as s,
  bi as t,
  xe as u
};
//# sourceMappingURL=main-zRUwk2ge.mjs.map
